
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire785f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire785f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2nzLi", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $1bb9784afa87e369$export$ffb0004e005737fa; }, function (v) { return $1bb9784afa87e369$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $1bb9784afa87e369$export$34b9dba7ce09269b; }, function (v) { return $1bb9784afa87e369$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $1bb9784afa87e369$export$25062201e9e25d76; }, function (v) { return $1bb9784afa87e369$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bb9784afa87e369$export$ffb0004e005737fa;
var $1bb9784afa87e369$export$34b9dba7ce09269b;
var $1bb9784afa87e369$export$25062201e9e25d76;
'use strict';

var $7fPBF = parcelRequire("7fPBF");
var $1bb9784afa87e369$var$k = Symbol.for("react.element"), $1bb9784afa87e369$var$l = Symbol.for("react.fragment"), $1bb9784afa87e369$var$m = Object.prototype.hasOwnProperty, $1bb9784afa87e369$var$n = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $1bb9784afa87e369$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1bb9784afa87e369$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$1bb9784afa87e369$var$m.call(a, b) && !$1bb9784afa87e369$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $1bb9784afa87e369$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $1bb9784afa87e369$var$n.current
    };
}
$1bb9784afa87e369$export$ffb0004e005737fa = $1bb9784afa87e369$var$l;
$1bb9784afa87e369$export$34b9dba7ce09269b = $1bb9784afa87e369$var$q;
$1bb9784afa87e369$export$25062201e9e25d76 = $1bb9784afa87e369$var$q;

});
parcelRegister("7fPBF", function(module, exports) {
'use strict';

module.exports = (parcelRequire("fSPLm"));

});
parcelRegister("fSPLm", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $b9040d2deeb360f4$export$dca3b0875bd9a954; }, function (v) { return $b9040d2deeb360f4$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $b9040d2deeb360f4$export$16fa2f45be04daa8; }, function (v) { return $b9040d2deeb360f4$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $b9040d2deeb360f4$export$ffb0004e005737fa; }, function (v) { return $b9040d2deeb360f4$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $b9040d2deeb360f4$export$e2c29f18771995cb; }, function (v) { return $b9040d2deeb360f4$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $b9040d2deeb360f4$export$221d75b3f55bb0bd; }, function (v) { return $b9040d2deeb360f4$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $b9040d2deeb360f4$export$5f8d39834fd61797; }, function (v) { return $b9040d2deeb360f4$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $b9040d2deeb360f4$export$74bf444e3cd11ea5; }, function (v) { return $b9040d2deeb360f4$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $b9040d2deeb360f4$export$ae55be85d98224ed; }, function (v) { return $b9040d2deeb360f4$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $b9040d2deeb360f4$export$3ba232387fd5d6dd; }, function (v) { return $b9040d2deeb360f4$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $b9040d2deeb360f4$export$e530037191fcd5d7; }, function (v) { return $b9040d2deeb360f4$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $b9040d2deeb360f4$export$fd42f52fd3ae1109; }, function (v) { return $b9040d2deeb360f4$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $b9040d2deeb360f4$export$c8a8987d4410bf2d; }, function (v) { return $b9040d2deeb360f4$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $b9040d2deeb360f4$export$d38cd72104c1f0e9; }, function (v) { return $b9040d2deeb360f4$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43; }, function (v) { return $b9040d2deeb360f4$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $b9040d2deeb360f4$export$257a8862b851cb5b; }, function (v) { return $b9040d2deeb360f4$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $b9040d2deeb360f4$export$a8257692ac88316c; }, function (v) { return $b9040d2deeb360f4$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $b9040d2deeb360f4$export$488013bae63b21da; }, function (v) { return $b9040d2deeb360f4$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $b9040d2deeb360f4$export$7c73462e0d25e514; }, function (v) { return $b9040d2deeb360f4$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $b9040d2deeb360f4$export$7568632d0d33d16d; }, function (v) { return $b9040d2deeb360f4$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $b9040d2deeb360f4$export$88948ce120ea2619; }, function (v) { return $b9040d2deeb360f4$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $b9040d2deeb360f4$export$35808ee640e87ca7; }, function (v) { return $b9040d2deeb360f4$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $b9040d2deeb360f4$export$fae74005e78b1a27; }, function (v) { return $b9040d2deeb360f4$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e; }, function (v) { return $b9040d2deeb360f4$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf; }, function (v) { return $b9040d2deeb360f4$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $b9040d2deeb360f4$export$6d9c69b0de29b591; }, function (v) { return $b9040d2deeb360f4$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $b9040d2deeb360f4$export$f680877a34711e37; }, function (v) { return $b9040d2deeb360f4$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $b9040d2deeb360f4$export$d5a552a76deda3c2; }, function (v) { return $b9040d2deeb360f4$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $b9040d2deeb360f4$export$aaabe4eda9ed9969; }, function (v) { return $b9040d2deeb360f4$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $b9040d2deeb360f4$export$e5c5a5f917a5871c; }, function (v) { return $b9040d2deeb360f4$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $b9040d2deeb360f4$export$1538c33de8887b59; }, function (v) { return $b9040d2deeb360f4$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $b9040d2deeb360f4$export$13e3392192263954; }, function (v) { return $b9040d2deeb360f4$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $b9040d2deeb360f4$export$b8f5890fc79d6aca; }, function (v) { return $b9040d2deeb360f4$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $b9040d2deeb360f4$export$60241385465d0a34; }, function (v) { return $b9040d2deeb360f4$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $b9040d2deeb360f4$export$306c0aa65ff9ec16; }, function (v) { return $b9040d2deeb360f4$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $b9040d2deeb360f4$export$7b286972b8d8ccbf; }, function (v) { return $b9040d2deeb360f4$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $b9040d2deeb360f4$export$83d89fbfd8236492; }, function (v) { return $b9040d2deeb360f4$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $b9040d2deeb360f4$export$dca3b0875bd9a954;
var $b9040d2deeb360f4$export$16fa2f45be04daa8;
var $b9040d2deeb360f4$export$ffb0004e005737fa;
var $b9040d2deeb360f4$export$e2c29f18771995cb;
var $b9040d2deeb360f4$export$221d75b3f55bb0bd;
var $b9040d2deeb360f4$export$5f8d39834fd61797;
var $b9040d2deeb360f4$export$74bf444e3cd11ea5;
var $b9040d2deeb360f4$export$ae55be85d98224ed;
var $b9040d2deeb360f4$export$3ba232387fd5d6dd;
var $b9040d2deeb360f4$export$e530037191fcd5d7;
var $b9040d2deeb360f4$export$fd42f52fd3ae1109;
var $b9040d2deeb360f4$export$c8a8987d4410bf2d;
var $b9040d2deeb360f4$export$d38cd72104c1f0e9;
var $b9040d2deeb360f4$export$7d1e3a5e95ceca43;
var $b9040d2deeb360f4$export$257a8862b851cb5b;
var $b9040d2deeb360f4$export$a8257692ac88316c;
var $b9040d2deeb360f4$export$488013bae63b21da;
var $b9040d2deeb360f4$export$7c73462e0d25e514;
var $b9040d2deeb360f4$export$7568632d0d33d16d;
var $b9040d2deeb360f4$export$88948ce120ea2619;
var $b9040d2deeb360f4$export$35808ee640e87ca7;
var $b9040d2deeb360f4$export$fae74005e78b1a27;
var $b9040d2deeb360f4$export$dc8fbce3eb94dc1e;
var $b9040d2deeb360f4$export$6a7bc4e911dc01cf;
var $b9040d2deeb360f4$export$6d9c69b0de29b591;
var $b9040d2deeb360f4$export$f680877a34711e37;
var $b9040d2deeb360f4$export$d5a552a76deda3c2;
var $b9040d2deeb360f4$export$aaabe4eda9ed9969;
var $b9040d2deeb360f4$export$e5c5a5f917a5871c;
var $b9040d2deeb360f4$export$1538c33de8887b59;
var $b9040d2deeb360f4$export$13e3392192263954;
var $b9040d2deeb360f4$export$b8f5890fc79d6aca;
var $b9040d2deeb360f4$export$60241385465d0a34;
var $b9040d2deeb360f4$export$306c0aa65ff9ec16;
var $b9040d2deeb360f4$export$7b286972b8d8ccbf;
var $b9040d2deeb360f4$export$83d89fbfd8236492;
'use strict';
var $b9040d2deeb360f4$var$l = Symbol.for("react.element"), $b9040d2deeb360f4$var$n = Symbol.for("react.portal"), $b9040d2deeb360f4$var$p = Symbol.for("react.fragment"), $b9040d2deeb360f4$var$q = Symbol.for("react.strict_mode"), $b9040d2deeb360f4$var$r = Symbol.for("react.profiler"), $b9040d2deeb360f4$var$t = Symbol.for("react.provider"), $b9040d2deeb360f4$var$u = Symbol.for("react.context"), $b9040d2deeb360f4$var$v = Symbol.for("react.forward_ref"), $b9040d2deeb360f4$var$w = Symbol.for("react.suspense"), $b9040d2deeb360f4$var$x = Symbol.for("react.memo"), $b9040d2deeb360f4$var$y = Symbol.for("react.lazy"), $b9040d2deeb360f4$var$z = Symbol.iterator;
function $b9040d2deeb360f4$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $b9040d2deeb360f4$var$z && a[$b9040d2deeb360f4$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $b9040d2deeb360f4$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $b9040d2deeb360f4$var$C = Object.assign, $b9040d2deeb360f4$var$D = {};
function $b9040d2deeb360f4$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
$b9040d2deeb360f4$var$E.prototype.isReactComponent = {};
$b9040d2deeb360f4$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$b9040d2deeb360f4$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $b9040d2deeb360f4$var$F() {}
$b9040d2deeb360f4$var$F.prototype = $b9040d2deeb360f4$var$E.prototype;
function $b9040d2deeb360f4$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $b9040d2deeb360f4$var$D;
    this.updater = e || $b9040d2deeb360f4$var$B;
}
var $b9040d2deeb360f4$var$H = $b9040d2deeb360f4$var$G.prototype = new $b9040d2deeb360f4$var$F;
$b9040d2deeb360f4$var$H.constructor = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$var$C($b9040d2deeb360f4$var$H, $b9040d2deeb360f4$var$E.prototype);
$b9040d2deeb360f4$var$H.isPureReactComponent = !0;
var $b9040d2deeb360f4$var$I = Array.isArray, $b9040d2deeb360f4$var$J = Object.prototype.hasOwnProperty, $b9040d2deeb360f4$var$K = {
    current: null
}, $b9040d2deeb360f4$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $b9040d2deeb360f4$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$b9040d2deeb360f4$var$J.call(b, d) && !$b9040d2deeb360f4$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $b9040d2deeb360f4$var$K.current
    };
}
function $b9040d2deeb360f4$var$N(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $b9040d2deeb360f4$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $b9040d2deeb360f4$var$l;
}
function $b9040d2deeb360f4$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $b9040d2deeb360f4$var$P = /\/+/g;
function $b9040d2deeb360f4$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $b9040d2deeb360f4$var$escape("" + a.key) : b.toString(36);
}
function $b9040d2deeb360f4$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $b9040d2deeb360f4$var$l:
                case $b9040d2deeb360f4$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $b9040d2deeb360f4$var$Q(h, 0) : d, $b9040d2deeb360f4$var$I(c) ? (e = "", null != a && (e = a.replace($b9040d2deeb360f4$var$P, "$&/") + "/"), $b9040d2deeb360f4$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($b9040d2deeb360f4$var$O(c) && (c = $b9040d2deeb360f4$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($b9040d2deeb360f4$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($b9040d2deeb360f4$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $b9040d2deeb360f4$var$Q(k, g);
        h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    }
    else if (f = $b9040d2deeb360f4$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $b9040d2deeb360f4$var$Q(k, g++), h += $b9040d2deeb360f4$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $b9040d2deeb360f4$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $b9040d2deeb360f4$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $b9040d2deeb360f4$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $b9040d2deeb360f4$var$U = {
    current: null
}, $b9040d2deeb360f4$var$V = {
    transition: null
}, $b9040d2deeb360f4$var$W = {
    ReactCurrentDispatcher: $b9040d2deeb360f4$var$U,
    ReactCurrentBatchConfig: $b9040d2deeb360f4$var$V,
    ReactCurrentOwner: $b9040d2deeb360f4$var$K
};
function $b9040d2deeb360f4$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$b9040d2deeb360f4$export$dca3b0875bd9a954 = {
    map: $b9040d2deeb360f4$var$S,
    forEach: function(a, b, e) {
        $b9040d2deeb360f4$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $b9040d2deeb360f4$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $b9040d2deeb360f4$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$b9040d2deeb360f4$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$b9040d2deeb360f4$export$16fa2f45be04daa8 = $b9040d2deeb360f4$var$E;
$b9040d2deeb360f4$export$ffb0004e005737fa = $b9040d2deeb360f4$var$p;
$b9040d2deeb360f4$export$e2c29f18771995cb = $b9040d2deeb360f4$var$r;
$b9040d2deeb360f4$export$221d75b3f55bb0bd = $b9040d2deeb360f4$var$G;
$b9040d2deeb360f4$export$5f8d39834fd61797 = $b9040d2deeb360f4$var$q;
$b9040d2deeb360f4$export$74bf444e3cd11ea5 = $b9040d2deeb360f4$var$w;
$b9040d2deeb360f4$export$ae55be85d98224ed = $b9040d2deeb360f4$var$W;
$b9040d2deeb360f4$export$3ba232387fd5d6dd = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $b9040d2deeb360f4$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $b9040d2deeb360f4$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$b9040d2deeb360f4$var$J.call(b, f) && !$b9040d2deeb360f4$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $b9040d2deeb360f4$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$b9040d2deeb360f4$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $b9040d2deeb360f4$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $b9040d2deeb360f4$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$b9040d2deeb360f4$export$c8a8987d4410bf2d = $b9040d2deeb360f4$var$M;
$b9040d2deeb360f4$export$d38cd72104c1f0e9 = function(a) {
    var b = $b9040d2deeb360f4$var$M.bind(null, a);
    b.type = a;
    return b;
};
$b9040d2deeb360f4$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$b9040d2deeb360f4$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$v,
        render: a
    };
};
$b9040d2deeb360f4$export$a8257692ac88316c = $b9040d2deeb360f4$var$O;
$b9040d2deeb360f4$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $b9040d2deeb360f4$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $b9040d2deeb360f4$var$T
    };
};
$b9040d2deeb360f4$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $b9040d2deeb360f4$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$b9040d2deeb360f4$export$7568632d0d33d16d = function(a) {
    var b = $b9040d2deeb360f4$var$V.transition;
    $b9040d2deeb360f4$var$V.transition = {};
    try {
        a();
    } finally{
        $b9040d2deeb360f4$var$V.transition = b;
    }
};
$b9040d2deeb360f4$export$88948ce120ea2619 = $b9040d2deeb360f4$var$X;
$b9040d2deeb360f4$export$35808ee640e87ca7 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useCallback(a, b);
};
$b9040d2deeb360f4$export$fae74005e78b1a27 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useContext(a);
};
$b9040d2deeb360f4$export$dc8fbce3eb94dc1e = function() {};
$b9040d2deeb360f4$export$6a7bc4e911dc01cf = function(a) {
    return $b9040d2deeb360f4$var$U.current.useDeferredValue(a);
};
$b9040d2deeb360f4$export$6d9c69b0de29b591 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useEffect(a, b);
};
$b9040d2deeb360f4$export$f680877a34711e37 = function() {
    return $b9040d2deeb360f4$var$U.current.useId();
};
$b9040d2deeb360f4$export$d5a552a76deda3c2 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useImperativeHandle(a, b, e);
};
$b9040d2deeb360f4$export$aaabe4eda9ed9969 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useInsertionEffect(a, b);
};
$b9040d2deeb360f4$export$e5c5a5f917a5871c = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useLayoutEffect(a, b);
};
$b9040d2deeb360f4$export$1538c33de8887b59 = function(a, b) {
    return $b9040d2deeb360f4$var$U.current.useMemo(a, b);
};
$b9040d2deeb360f4$export$13e3392192263954 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useReducer(a, b, e);
};
$b9040d2deeb360f4$export$b8f5890fc79d6aca = function(a) {
    return $b9040d2deeb360f4$var$U.current.useRef(a);
};
$b9040d2deeb360f4$export$60241385465d0a34 = function(a) {
    return $b9040d2deeb360f4$var$U.current.useState(a);
};
$b9040d2deeb360f4$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $b9040d2deeb360f4$var$U.current.useSyncExternalStore(a, b, e);
};
$b9040d2deeb360f4$export$7b286972b8d8ccbf = function() {
    return $b9040d2deeb360f4$var$U.current.useTransition();
};
$b9040d2deeb360f4$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("6EA3T", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $4d82739dd229d539$export$ae55be85d98224ed; }, function (v) { return $4d82739dd229d539$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $4d82739dd229d539$export$d39a5bbd09211389; }, function (v) { return $4d82739dd229d539$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $4d82739dd229d539$export$882461b6382ed46c; }, function (v) { return $4d82739dd229d539$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $4d82739dd229d539$export$466bfc07425424d5; }, function (v) { return $4d82739dd229d539$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $4d82739dd229d539$export$cd75ccfd720a3cd4; }, function (v) { return $4d82739dd229d539$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $4d82739dd229d539$export$fa8d919ba61d84db; }, function (v) { return $4d82739dd229d539$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $4d82739dd229d539$export$757ceba2d55c277e; }, function (v) { return $4d82739dd229d539$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $4d82739dd229d539$export$b3890eb0ae9dca99; }, function (v) { return $4d82739dd229d539$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $4d82739dd229d539$export$502457920280e6be; }, function (v) { return $4d82739dd229d539$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $4d82739dd229d539$export$c78a37762a8d58e1; }, function (v) { return $4d82739dd229d539$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $4d82739dd229d539$export$dc54d992c10e8a18; }, function (v) { return $4d82739dd229d539$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $4d82739dd229d539$export$83d89fbfd8236492; }, function (v) { return $4d82739dd229d539$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $4d82739dd229d539$export$ae55be85d98224ed;
var $4d82739dd229d539$export$d39a5bbd09211389;
var $4d82739dd229d539$export$882461b6382ed46c;
var $4d82739dd229d539$export$466bfc07425424d5;
var $4d82739dd229d539$export$cd75ccfd720a3cd4;
var $4d82739dd229d539$export$fa8d919ba61d84db;
var $4d82739dd229d539$export$757ceba2d55c277e;
var $4d82739dd229d539$export$b3890eb0ae9dca99;
var $4d82739dd229d539$export$502457920280e6be;
var $4d82739dd229d539$export$c78a37762a8d58e1;
var $4d82739dd229d539$export$dc54d992c10e8a18;
var $4d82739dd229d539$export$83d89fbfd8236492;
'use strict';

var $7fPBF = parcelRequire("7fPBF");

var $33s19 = parcelRequire("33s19");
function $4d82739dd229d539$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $4d82739dd229d539$var$da = new Set, $4d82739dd229d539$var$ea = {};
function $4d82739dd229d539$var$fa(a, b) {
    $4d82739dd229d539$var$ha(a, b);
    $4d82739dd229d539$var$ha(a + "Capture", b);
}
function $4d82739dd229d539$var$ha(a, b) {
    $4d82739dd229d539$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$4d82739dd229d539$var$da.add(b[a]);
}
var $4d82739dd229d539$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $4d82739dd229d539$var$ja = Object.prototype.hasOwnProperty, $4d82739dd229d539$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $4d82739dd229d539$var$la = {}, $4d82739dd229d539$var$ma = {};
function $4d82739dd229d539$var$oa(a) {
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$ma, a)) return !0;
    if ($4d82739dd229d539$var$ja.call($4d82739dd229d539$var$la, a)) return !1;
    if ($4d82739dd229d539$var$ka.test(a)) return $4d82739dd229d539$var$ma[a] = !0;
    $4d82739dd229d539$var$la[a] = !0;
    return !1;
}
function $4d82739dd229d539$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $4d82739dd229d539$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $4d82739dd229d539$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $4d82739dd229d539$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $4d82739dd229d539$var$ra = /[\-:]([a-z])/g;
function $4d82739dd229d539$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($4d82739dd229d539$var$ra, $4d82739dd229d539$var$sa);
    $4d82739dd229d539$var$z[b] = new $4d82739dd229d539$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$4d82739dd229d539$var$z.xlinkHref = new $4d82739dd229d539$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $4d82739dd229d539$var$z[a] = new $4d82739dd229d539$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $4d82739dd229d539$var$ta(a, b, c, d) {
    var e = $4d82739dd229d539$var$z.hasOwnProperty(b) ? $4d82739dd229d539$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $4d82739dd229d539$var$qa(b, c, e, d) && (c = null), d || null === e ? $4d82739dd229d539$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $4d82739dd229d539$var$ua = $7fPBF.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $4d82739dd229d539$var$va = Symbol.for("react.element"), $4d82739dd229d539$var$wa = Symbol.for("react.portal"), $4d82739dd229d539$var$ya = Symbol.for("react.fragment"), $4d82739dd229d539$var$za = Symbol.for("react.strict_mode"), $4d82739dd229d539$var$Aa = Symbol.for("react.profiler"), $4d82739dd229d539$var$Ba = Symbol.for("react.provider"), $4d82739dd229d539$var$Ca = Symbol.for("react.context"), $4d82739dd229d539$var$Da = Symbol.for("react.forward_ref"), $4d82739dd229d539$var$Ea = Symbol.for("react.suspense"), $4d82739dd229d539$var$Fa = Symbol.for("react.suspense_list"), $4d82739dd229d539$var$Ga = Symbol.for("react.memo"), $4d82739dd229d539$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $4d82739dd229d539$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $4d82739dd229d539$var$Ja = Symbol.iterator;
function $4d82739dd229d539$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $4d82739dd229d539$var$Ja && a[$4d82739dd229d539$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $4d82739dd229d539$var$A = Object.assign, $4d82739dd229d539$var$La;
function $4d82739dd229d539$var$Ma(a) {
    if (void 0 === $4d82739dd229d539$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $4d82739dd229d539$var$La = b && b[1] || "";
    }
    return "\n" + $4d82739dd229d539$var$La + a;
}
var $4d82739dd229d539$var$Na = !1;
function $4d82739dd229d539$var$Oa(a, b) {
    if (!a || $4d82739dd229d539$var$Na) return "";
    $4d82739dd229d539$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $4d82739dd229d539$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $4d82739dd229d539$var$Ma(a) : "";
}
function $4d82739dd229d539$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $4d82739dd229d539$var$Ma(a.type);
        case 16:
            return $4d82739dd229d539$var$Ma("Lazy");
        case 13:
            return $4d82739dd229d539$var$Ma("Suspense");
        case 19:
            return $4d82739dd229d539$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $4d82739dd229d539$var$Oa(a.type, !1), a;
        case 11:
            return a = $4d82739dd229d539$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $4d82739dd229d539$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $4d82739dd229d539$var$ya:
            return "Fragment";
        case $4d82739dd229d539$var$wa:
            return "Portal";
        case $4d82739dd229d539$var$Aa:
            return "Profiler";
        case $4d82739dd229d539$var$za:
            return "StrictMode";
        case $4d82739dd229d539$var$Ea:
            return "Suspense";
        case $4d82739dd229d539$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $4d82739dd229d539$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $4d82739dd229d539$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $4d82739dd229d539$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $4d82739dd229d539$var$Ga:
            return b = a.displayName || null, null !== b ? b : $4d82739dd229d539$var$Qa(a.type) || "Memo";
        case $4d82739dd229d539$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $4d82739dd229d539$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $4d82739dd229d539$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $4d82739dd229d539$var$Qa(b);
        case 8:
            return b === $4d82739dd229d539$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $4d82739dd229d539$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $4d82739dd229d539$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $4d82739dd229d539$var$Ua(a) {
    var b = $4d82739dd229d539$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $4d82739dd229d539$var$Va(a) {
    a._valueTracker || (a._valueTracker = $4d82739dd229d539$var$Ua(a));
}
function $4d82739dd229d539$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $4d82739dd229d539$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $4d82739dd229d539$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $4d82739dd229d539$var$Ya(a, b) {
    var c = b.checked;
    return $4d82739dd229d539$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $4d82739dd229d539$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $4d82739dd229d539$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $4d82739dd229d539$var$ab(a, b) {
    b = b.checked;
    null != b && $4d82739dd229d539$var$ta(a, "checked", b, !1);
}
function $4d82739dd229d539$var$bb(a, b) {
    $4d82739dd229d539$var$ab(a, b);
    var c = $4d82739dd229d539$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $4d82739dd229d539$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $4d82739dd229d539$var$cb(a, b.type, $4d82739dd229d539$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $4d82739dd229d539$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $4d82739dd229d539$var$cb(a, b, c) {
    if ("number" !== b || $4d82739dd229d539$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $4d82739dd229d539$var$eb = Array.isArray;
function $4d82739dd229d539$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $4d82739dd229d539$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $4d82739dd229d539$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($4d82739dd229d539$var$p(91));
    return $4d82739dd229d539$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $4d82739dd229d539$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($4d82739dd229d539$var$p(92));
            if ($4d82739dd229d539$var$eb(c)) {
                if (1 < c.length) throw Error($4d82739dd229d539$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $4d82739dd229d539$var$Sa(c)
    };
}
function $4d82739dd229d539$var$ib(a, b) {
    var c = $4d82739dd229d539$var$Sa(b.value), d = $4d82739dd229d539$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $4d82739dd229d539$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $4d82739dd229d539$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $4d82739dd229d539$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $4d82739dd229d539$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $4d82739dd229d539$var$mb, $4d82739dd229d539$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $4d82739dd229d539$var$mb = $4d82739dd229d539$var$mb || document.createElement("div");
        $4d82739dd229d539$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $4d82739dd229d539$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $4d82739dd229d539$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $4d82739dd229d539$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $4d82739dd229d539$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($4d82739dd229d539$var$pb).forEach(function(a) {
    $4d82739dd229d539$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $4d82739dd229d539$var$pb[b] = $4d82739dd229d539$var$pb[a];
    });
});
function $4d82739dd229d539$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $4d82739dd229d539$var$pb.hasOwnProperty(a) && $4d82739dd229d539$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $4d82739dd229d539$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $4d82739dd229d539$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $4d82739dd229d539$var$tb = $4d82739dd229d539$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $4d82739dd229d539$var$ub(a, b) {
    if (b) {
        if ($4d82739dd229d539$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($4d82739dd229d539$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($4d82739dd229d539$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($4d82739dd229d539$var$p(62));
    }
}
function $4d82739dd229d539$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $4d82739dd229d539$var$wb = null;
function $4d82739dd229d539$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $4d82739dd229d539$var$yb = null, $4d82739dd229d539$var$zb = null, $4d82739dd229d539$var$Ab = null;
function $4d82739dd229d539$var$Bb(a) {
    if (a = $4d82739dd229d539$var$Cb(a)) {
        if ("function" !== typeof $4d82739dd229d539$var$yb) throw Error($4d82739dd229d539$var$p(280));
        var b = a.stateNode;
        b && (b = $4d82739dd229d539$var$Db(b), $4d82739dd229d539$var$yb(a.stateNode, a.type, b));
    }
}
function $4d82739dd229d539$var$Eb(a) {
    $4d82739dd229d539$var$zb ? $4d82739dd229d539$var$Ab ? $4d82739dd229d539$var$Ab.push(a) : $4d82739dd229d539$var$Ab = [
        a
    ] : $4d82739dd229d539$var$zb = a;
}
function $4d82739dd229d539$var$Fb() {
    if ($4d82739dd229d539$var$zb) {
        var a = $4d82739dd229d539$var$zb, b = $4d82739dd229d539$var$Ab;
        $4d82739dd229d539$var$Ab = $4d82739dd229d539$var$zb = null;
        $4d82739dd229d539$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$4d82739dd229d539$var$Bb(b[a]);
    }
}
function $4d82739dd229d539$var$Gb(a, b) {
    return a(b);
}
function $4d82739dd229d539$var$Hb() {}
var $4d82739dd229d539$var$Ib = !1;
function $4d82739dd229d539$var$Jb(a, b, c) {
    if ($4d82739dd229d539$var$Ib) return a(b, c);
    $4d82739dd229d539$var$Ib = !0;
    try {
        return $4d82739dd229d539$var$Gb(a, b, c);
    } finally{
        if ($4d82739dd229d539$var$Ib = !1, null !== $4d82739dd229d539$var$zb || null !== $4d82739dd229d539$var$Ab) $4d82739dd229d539$var$Hb(), $4d82739dd229d539$var$Fb();
    }
}
function $4d82739dd229d539$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $4d82739dd229d539$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($4d82739dd229d539$var$p(231, b, typeof c));
    return c;
}
var $4d82739dd229d539$var$Lb = !1;
if ($4d82739dd229d539$var$ia) try {
    var $4d82739dd229d539$var$Mb = {};
    Object.defineProperty($4d82739dd229d539$var$Mb, "passive", {
        get: function() {
            $4d82739dd229d539$var$Lb = !0;
        }
    });
    window.addEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
    window.removeEventListener("test", $4d82739dd229d539$var$Mb, $4d82739dd229d539$var$Mb);
} catch (a) {
    $4d82739dd229d539$var$Lb = !1;
}
function $4d82739dd229d539$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $4d82739dd229d539$var$Ob = !1, $4d82739dd229d539$var$Pb = null, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, $4d82739dd229d539$var$Sb = {
    onError: function(a) {
        $4d82739dd229d539$var$Ob = !0;
        $4d82739dd229d539$var$Pb = a;
    }
};
function $4d82739dd229d539$var$Tb(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Ob = !1;
    $4d82739dd229d539$var$Pb = null;
    $4d82739dd229d539$var$Nb.apply($4d82739dd229d539$var$Sb, arguments);
}
function $4d82739dd229d539$var$Ub(a, b, c, d, e, f, g, h, k) {
    $4d82739dd229d539$var$Tb.apply(this, arguments);
    if ($4d82739dd229d539$var$Ob) {
        if ($4d82739dd229d539$var$Ob) {
            var l = $4d82739dd229d539$var$Pb;
            $4d82739dd229d539$var$Ob = !1;
            $4d82739dd229d539$var$Pb = null;
        } else throw Error($4d82739dd229d539$var$p(198));
        $4d82739dd229d539$var$Qb || ($4d82739dd229d539$var$Qb = !0, $4d82739dd229d539$var$Rb = l);
    }
}
function $4d82739dd229d539$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $4d82739dd229d539$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $4d82739dd229d539$var$Xb(a) {
    if ($4d82739dd229d539$var$Vb(a) !== a) throw Error($4d82739dd229d539$var$p(188));
}
function $4d82739dd229d539$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $4d82739dd229d539$var$Vb(a);
        if (null === b) throw Error($4d82739dd229d539$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $4d82739dd229d539$var$Xb(e), a;
                if (f === d) return $4d82739dd229d539$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($4d82739dd229d539$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($4d82739dd229d539$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($4d82739dd229d539$var$p(190));
    }
    if (3 !== c.tag) throw Error($4d82739dd229d539$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $4d82739dd229d539$var$Zb(a) {
    a = $4d82739dd229d539$var$Yb(a);
    return null !== a ? $4d82739dd229d539$var$$b(a) : null;
}
function $4d82739dd229d539$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $4d82739dd229d539$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$ac = $33s19.unstable_scheduleCallback, $4d82739dd229d539$var$bc = $33s19.unstable_cancelCallback, $4d82739dd229d539$var$cc = $33s19.unstable_shouldYield, $4d82739dd229d539$var$dc = $33s19.unstable_requestPaint, $4d82739dd229d539$var$B = $33s19.unstable_now, $4d82739dd229d539$var$ec = $33s19.unstable_getCurrentPriorityLevel, $4d82739dd229d539$var$fc = $33s19.unstable_ImmediatePriority, $4d82739dd229d539$var$gc = $33s19.unstable_UserBlockingPriority, $4d82739dd229d539$var$hc = $33s19.unstable_NormalPriority, $4d82739dd229d539$var$ic = $33s19.unstable_LowPriority, $4d82739dd229d539$var$jc = $33s19.unstable_IdlePriority, $4d82739dd229d539$var$kc = null, $4d82739dd229d539$var$lc = null;
function $4d82739dd229d539$var$mc(a) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberRoot) try {
        $4d82739dd229d539$var$lc.onCommitFiberRoot($4d82739dd229d539$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $4d82739dd229d539$var$oc = Math.clz32 ? Math.clz32 : $4d82739dd229d539$var$nc, $4d82739dd229d539$var$pc = Math.log, $4d82739dd229d539$var$qc = Math.LN2;
function $4d82739dd229d539$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($4d82739dd229d539$var$pc(a) / $4d82739dd229d539$var$qc | 0) | 0;
}
var $4d82739dd229d539$var$rc = 64, $4d82739dd229d539$var$sc = 4194304;
function $4d82739dd229d539$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $4d82739dd229d539$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $4d82739dd229d539$var$tc(h) : (f &= g, 0 !== f && (d = $4d82739dd229d539$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $4d82739dd229d539$var$tc(g) : 0 !== f && (d = $4d82739dd229d539$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $4d82739dd229d539$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $4d82739dd229d539$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $4d82739dd229d539$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $4d82739dd229d539$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $4d82739dd229d539$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $4d82739dd229d539$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $4d82739dd229d539$var$yc() {
    var a = $4d82739dd229d539$var$rc;
    $4d82739dd229d539$var$rc <<= 1;
    0 === ($4d82739dd229d539$var$rc & 4194240) && ($4d82739dd229d539$var$rc = 64);
    return a;
}
function $4d82739dd229d539$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $4d82739dd229d539$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $4d82739dd229d539$var$oc(b);
    a[b] = c;
}
function $4d82739dd229d539$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $4d82739dd229d539$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $4d82739dd229d539$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $4d82739dd229d539$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $4d82739dd229d539$var$C = 0;
function $4d82739dd229d539$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $4d82739dd229d539$var$Ec, $4d82739dd229d539$var$Fc, $4d82739dd229d539$var$Gc, $4d82739dd229d539$var$Hc, $4d82739dd229d539$var$Ic, $4d82739dd229d539$var$Jc = !1, $4d82739dd229d539$var$Kc = [], $4d82739dd229d539$var$Lc = null, $4d82739dd229d539$var$Mc = null, $4d82739dd229d539$var$Nc = null, $4d82739dd229d539$var$Oc = new Map, $4d82739dd229d539$var$Pc = new Map, $4d82739dd229d539$var$Qc = [], $4d82739dd229d539$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $4d82739dd229d539$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $4d82739dd229d539$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $4d82739dd229d539$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $4d82739dd229d539$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $4d82739dd229d539$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $4d82739dd229d539$var$Pc.delete(b.pointerId);
    }
}
function $4d82739dd229d539$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $4d82739dd229d539$var$Cb(b), null !== b && $4d82739dd229d539$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $4d82739dd229d539$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $4d82739dd229d539$var$Lc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $4d82739dd229d539$var$Mc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $4d82739dd229d539$var$Nc = $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $4d82739dd229d539$var$Oc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $4d82739dd229d539$var$Pc.set(f, $4d82739dd229d539$var$Tc($4d82739dd229d539$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $4d82739dd229d539$var$Vc(a) {
    var b = $4d82739dd229d539$var$Wc(a.target);
    if (null !== b) {
        var c = $4d82739dd229d539$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $4d82739dd229d539$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $4d82739dd229d539$var$Ic(a.priority, function() {
                        $4d82739dd229d539$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $4d82739dd229d539$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $4d82739dd229d539$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $4d82739dd229d539$var$wb = d;
            c.target.dispatchEvent(d);
            $4d82739dd229d539$var$wb = null;
        } else return b = $4d82739dd229d539$var$Cb(c), null !== b && $4d82739dd229d539$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $4d82739dd229d539$var$Zc(a, b, c) {
    $4d82739dd229d539$var$Xc(a) && c.delete(b);
}
function $4d82739dd229d539$var$$c() {
    $4d82739dd229d539$var$Jc = !1;
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Lc) && ($4d82739dd229d539$var$Lc = null);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Mc) && ($4d82739dd229d539$var$Mc = null);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$Xc($4d82739dd229d539$var$Nc) && ($4d82739dd229d539$var$Nc = null);
    $4d82739dd229d539$var$Oc.forEach($4d82739dd229d539$var$Zc);
    $4d82739dd229d539$var$Pc.forEach($4d82739dd229d539$var$Zc);
}
function $4d82739dd229d539$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $4d82739dd229d539$var$Jc || ($4d82739dd229d539$var$Jc = !0, $33s19.unstable_scheduleCallback($33s19.unstable_NormalPriority, $4d82739dd229d539$var$$c)));
}
function $4d82739dd229d539$var$bd(a) {
    function b(b) {
        return $4d82739dd229d539$var$ad(b, a);
    }
    if (0 < $4d82739dd229d539$var$Kc.length) {
        $4d82739dd229d539$var$ad($4d82739dd229d539$var$Kc[0], a);
        for(var c = 1; c < $4d82739dd229d539$var$Kc.length; c++){
            var d = $4d82739dd229d539$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $4d82739dd229d539$var$Lc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Lc, a);
    null !== $4d82739dd229d539$var$Mc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Mc, a);
    null !== $4d82739dd229d539$var$Nc && $4d82739dd229d539$var$ad($4d82739dd229d539$var$Nc, a);
    $4d82739dd229d539$var$Oc.forEach(b);
    $4d82739dd229d539$var$Pc.forEach(b);
    for(c = 0; c < $4d82739dd229d539$var$Qc.length; c++)d = $4d82739dd229d539$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $4d82739dd229d539$var$Qc.length && (c = $4d82739dd229d539$var$Qc[0], null === c.blockedOn);)$4d82739dd229d539$var$Vc(c), null === c.blockedOn && $4d82739dd229d539$var$Qc.shift();
}
var $4d82739dd229d539$var$cd = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$dd = !0;
function $4d82739dd229d539$var$ed(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$gd(a, b, c, d) {
    var e = $4d82739dd229d539$var$C, f = $4d82739dd229d539$var$cd.transition;
    $4d82739dd229d539$var$cd.transition = null;
    try {
        $4d82739dd229d539$var$C = 4, $4d82739dd229d539$var$fd(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$C = e, $4d82739dd229d539$var$cd.transition = f;
    }
}
function $4d82739dd229d539$var$fd(a, b, c, d) {
    if ($4d82739dd229d539$var$dd) {
        var e = $4d82739dd229d539$var$Yc(a, b, c, d);
        if (null === e) $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c), $4d82739dd229d539$var$Sc(a, d);
        else if ($4d82739dd229d539$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($4d82739dd229d539$var$Sc(a, d), b & 4 && -1 < $4d82739dd229d539$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $4d82739dd229d539$var$Cb(e);
                null !== f && $4d82739dd229d539$var$Ec(f);
                f = $4d82739dd229d539$var$Yc(a, b, c, d);
                null === f && $4d82739dd229d539$var$hd(a, b, d, $4d82739dd229d539$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $4d82739dd229d539$var$hd(a, b, d, null, c);
    }
}
var $4d82739dd229d539$var$id = null;
function $4d82739dd229d539$var$Yc(a, b, c, d) {
    $4d82739dd229d539$var$id = null;
    a = $4d82739dd229d539$var$xb(d);
    a = $4d82739dd229d539$var$Wc(a);
    if (null !== a) {
        if (b = $4d82739dd229d539$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $4d82739dd229d539$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $4d82739dd229d539$var$id = a;
    return null;
}
function $4d82739dd229d539$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($4d82739dd229d539$var$ec()){
                case $4d82739dd229d539$var$fc:
                    return 1;
                case $4d82739dd229d539$var$gc:
                    return 4;
                case $4d82739dd229d539$var$hc:
                case $4d82739dd229d539$var$ic:
                    return 16;
                case $4d82739dd229d539$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ld = null, $4d82739dd229d539$var$md = null;
function $4d82739dd229d539$var$nd() {
    if ($4d82739dd229d539$var$md) return $4d82739dd229d539$var$md;
    var a, b = $4d82739dd229d539$var$ld, c = b.length, d, e = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $4d82739dd229d539$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $4d82739dd229d539$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $4d82739dd229d539$var$pd() {
    return !0;
}
function $4d82739dd229d539$var$qd() {
    return !1;
}
function $4d82739dd229d539$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $4d82739dd229d539$var$pd : $4d82739dd229d539$var$qd;
        this.isPropagationStopped = $4d82739dd229d539$var$qd;
        return this;
    }
    $4d82739dd229d539$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $4d82739dd229d539$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $4d82739dd229d539$var$pd);
        },
        persist: function() {},
        isPersistent: $4d82739dd229d539$var$pd
    });
    return b;
}
var $4d82739dd229d539$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $4d82739dd229d539$var$td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$sd), $4d82739dd229d539$var$ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    view: 0,
    detail: 0
}), $4d82739dd229d539$var$vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$ud), $4d82739dd229d539$var$wd, $4d82739dd229d539$var$xd, $4d82739dd229d539$var$yd, $4d82739dd229d539$var$Ad = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $4d82739dd229d539$var$yd && ($4d82739dd229d539$var$yd && "mousemove" === a.type ? ($4d82739dd229d539$var$wd = a.screenX - $4d82739dd229d539$var$yd.screenX, $4d82739dd229d539$var$xd = a.screenY - $4d82739dd229d539$var$yd.screenY) : $4d82739dd229d539$var$xd = $4d82739dd229d539$var$wd = 0, $4d82739dd229d539$var$yd = a);
        return $4d82739dd229d539$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $4d82739dd229d539$var$xd;
    }
}), $4d82739dd229d539$var$Bd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ad), $4d82739dd229d539$var$Cd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    dataTransfer: 0
}), $4d82739dd229d539$var$Dd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Cd), $4d82739dd229d539$var$Ed = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    relatedTarget: 0
}), $4d82739dd229d539$var$Fd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ed), $4d82739dd229d539$var$Gd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Hd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Gd), $4d82739dd229d539$var$Id = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $4d82739dd229d539$var$Jd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Id), $4d82739dd229d539$var$Kd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    data: 0
}), $4d82739dd229d539$var$Ld = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Kd), $4d82739dd229d539$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $4d82739dd229d539$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $4d82739dd229d539$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $4d82739dd229d539$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $4d82739dd229d539$var$Od[a]) ? !!b[a] : !1;
}
function $4d82739dd229d539$var$zd() {
    return $4d82739dd229d539$var$Pd;
}
var $4d82739dd229d539$var$Qd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $4d82739dd229d539$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $4d82739dd229d539$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $4d82739dd229d539$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $4d82739dd229d539$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $4d82739dd229d539$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $4d82739dd229d539$var$Rd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Qd), $4d82739dd229d539$var$Sd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $4d82739dd229d539$var$Td = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Sd), $4d82739dd229d539$var$Ud = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $4d82739dd229d539$var$zd
}), $4d82739dd229d539$var$Vd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Ud), $4d82739dd229d539$var$Wd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $4d82739dd229d539$var$Xd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Wd), $4d82739dd229d539$var$Yd = $4d82739dd229d539$var$A({}, $4d82739dd229d539$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $4d82739dd229d539$var$Zd = $4d82739dd229d539$var$rd($4d82739dd229d539$var$Yd), $4d82739dd229d539$var$$d = [
    9,
    13,
    27,
    32
], $4d82739dd229d539$var$ae = $4d82739dd229d539$var$ia && "CompositionEvent" in window, $4d82739dd229d539$var$be = null;
$4d82739dd229d539$var$ia && "documentMode" in document && ($4d82739dd229d539$var$be = document.documentMode);
var $4d82739dd229d539$var$ce = $4d82739dd229d539$var$ia && "TextEvent" in window && !$4d82739dd229d539$var$be, $4d82739dd229d539$var$de = $4d82739dd229d539$var$ia && (!$4d82739dd229d539$var$ae || $4d82739dd229d539$var$be && 8 < $4d82739dd229d539$var$be && 11 >= $4d82739dd229d539$var$be), $4d82739dd229d539$var$ee = String.fromCharCode(32), $4d82739dd229d539$var$fe = !1;
function $4d82739dd229d539$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $4d82739dd229d539$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $4d82739dd229d539$var$ie = !1;
function $4d82739dd229d539$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $4d82739dd229d539$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $4d82739dd229d539$var$fe = !0;
            return $4d82739dd229d539$var$ee;
        case "textInput":
            return a = b.data, a === $4d82739dd229d539$var$ee && $4d82739dd229d539$var$fe ? null : a;
        default:
            return null;
    }
}
function $4d82739dd229d539$var$ke(a, b) {
    if ($4d82739dd229d539$var$ie) return "compositionend" === a || !$4d82739dd229d539$var$ae && $4d82739dd229d539$var$ge(a, b) ? (a = $4d82739dd229d539$var$nd(), $4d82739dd229d539$var$md = $4d82739dd229d539$var$ld = $4d82739dd229d539$var$kd = null, $4d82739dd229d539$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $4d82739dd229d539$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $4d82739dd229d539$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$4d82739dd229d539$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $4d82739dd229d539$var$ne(a, b, c, d) {
    $4d82739dd229d539$var$Eb(d);
    b = $4d82739dd229d539$var$oe(b, "onChange");
    0 < b.length && (c = new $4d82739dd229d539$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $4d82739dd229d539$var$pe = null, $4d82739dd229d539$var$qe = null;
function $4d82739dd229d539$var$re(a) {
    $4d82739dd229d539$var$se(a, 0);
}
function $4d82739dd229d539$var$te(a) {
    var b = $4d82739dd229d539$var$ue(a);
    if ($4d82739dd229d539$var$Wa(b)) return a;
}
function $4d82739dd229d539$var$ve(a, b) {
    if ("change" === a) return b;
}
var $4d82739dd229d539$var$we = !1;
if ($4d82739dd229d539$var$ia) {
    var $4d82739dd229d539$var$xe;
    if ($4d82739dd229d539$var$ia) {
        var $4d82739dd229d539$var$ye = "oninput" in document;
        if (!$4d82739dd229d539$var$ye) {
            var $4d82739dd229d539$var$ze = document.createElement("div");
            $4d82739dd229d539$var$ze.setAttribute("oninput", "return;");
            $4d82739dd229d539$var$ye = "function" === typeof $4d82739dd229d539$var$ze.oninput;
        }
        $4d82739dd229d539$var$xe = $4d82739dd229d539$var$ye;
    } else $4d82739dd229d539$var$xe = !1;
    $4d82739dd229d539$var$we = $4d82739dd229d539$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $4d82739dd229d539$var$Ae() {
    $4d82739dd229d539$var$pe && ($4d82739dd229d539$var$pe.detachEvent("onpropertychange", $4d82739dd229d539$var$Be), $4d82739dd229d539$var$qe = $4d82739dd229d539$var$pe = null);
}
function $4d82739dd229d539$var$Be(a) {
    if ("value" === a.propertyName && $4d82739dd229d539$var$te($4d82739dd229d539$var$qe)) {
        var b = [];
        $4d82739dd229d539$var$ne(b, $4d82739dd229d539$var$qe, a, $4d82739dd229d539$var$xb(a));
        $4d82739dd229d539$var$Jb($4d82739dd229d539$var$re, b);
    }
}
function $4d82739dd229d539$var$Ce(a, b, c) {
    "focusin" === a ? ($4d82739dd229d539$var$Ae(), $4d82739dd229d539$var$pe = b, $4d82739dd229d539$var$qe = c, $4d82739dd229d539$var$pe.attachEvent("onpropertychange", $4d82739dd229d539$var$Be)) : "focusout" === a && $4d82739dd229d539$var$Ae();
}
function $4d82739dd229d539$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $4d82739dd229d539$var$te($4d82739dd229d539$var$qe);
}
function $4d82739dd229d539$var$Ee(a, b) {
    if ("click" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $4d82739dd229d539$var$te(b);
}
function $4d82739dd229d539$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $4d82739dd229d539$var$He = "function" === typeof Object.is ? Object.is : $4d82739dd229d539$var$Ge;
function $4d82739dd229d539$var$Ie(a, b) {
    if ($4d82739dd229d539$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$4d82739dd229d539$var$ja.call(b, e) || !$4d82739dd229d539$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $4d82739dd229d539$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $4d82739dd229d539$var$Ke(a, b) {
    var c = $4d82739dd229d539$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $4d82739dd229d539$var$Je(c);
    }
}
function $4d82739dd229d539$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $4d82739dd229d539$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $4d82739dd229d539$var$Me() {
    for(var a = window, b = $4d82739dd229d539$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $4d82739dd229d539$var$Xa(a.document);
    }
    return b;
}
function $4d82739dd229d539$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $4d82739dd229d539$var$Oe(a) {
    var b = $4d82739dd229d539$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $4d82739dd229d539$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $4d82739dd229d539$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $4d82739dd229d539$var$Ke(c, f);
                var g = $4d82739dd229d539$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $4d82739dd229d539$var$Pe = $4d82739dd229d539$var$ia && "documentMode" in document && 11 >= document.documentMode, $4d82739dd229d539$var$Qe = null, $4d82739dd229d539$var$Re = null, $4d82739dd229d539$var$Se = null, $4d82739dd229d539$var$Te = !1;
function $4d82739dd229d539$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $4d82739dd229d539$var$Te || null == $4d82739dd229d539$var$Qe || $4d82739dd229d539$var$Qe !== $4d82739dd229d539$var$Xa(d) || (d = $4d82739dd229d539$var$Qe, "selectionStart" in d && $4d82739dd229d539$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $4d82739dd229d539$var$Se && $4d82739dd229d539$var$Ie($4d82739dd229d539$var$Se, d) || ($4d82739dd229d539$var$Se = d, d = $4d82739dd229d539$var$oe($4d82739dd229d539$var$Re, "onSelect"), 0 < d.length && (b = new $4d82739dd229d539$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $4d82739dd229d539$var$Qe)));
}
function $4d82739dd229d539$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $4d82739dd229d539$var$We = {
    animationend: $4d82739dd229d539$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $4d82739dd229d539$var$Ve("Animation", "AnimationIteration"),
    animationstart: $4d82739dd229d539$var$Ve("Animation", "AnimationStart"),
    transitionend: $4d82739dd229d539$var$Ve("Transition", "TransitionEnd")
}, $4d82739dd229d539$var$Xe = {}, $4d82739dd229d539$var$Ye = {};
$4d82739dd229d539$var$ia && ($4d82739dd229d539$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $4d82739dd229d539$var$We.animationend.animation, delete $4d82739dd229d539$var$We.animationiteration.animation, delete $4d82739dd229d539$var$We.animationstart.animation), "TransitionEvent" in window || delete $4d82739dd229d539$var$We.transitionend.transition);
function $4d82739dd229d539$var$Ze(a) {
    if ($4d82739dd229d539$var$Xe[a]) return $4d82739dd229d539$var$Xe[a];
    if (!$4d82739dd229d539$var$We[a]) return a;
    var b = $4d82739dd229d539$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $4d82739dd229d539$var$Ye) return $4d82739dd229d539$var$Xe[a] = b[c];
    return a;
}
var $4d82739dd229d539$var$$e = $4d82739dd229d539$var$Ze("animationend"), $4d82739dd229d539$var$af = $4d82739dd229d539$var$Ze("animationiteration"), $4d82739dd229d539$var$bf = $4d82739dd229d539$var$Ze("animationstart"), $4d82739dd229d539$var$cf = $4d82739dd229d539$var$Ze("transitionend"), $4d82739dd229d539$var$df = new Map, $4d82739dd229d539$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $4d82739dd229d539$var$ff(a, b) {
    $4d82739dd229d539$var$df.set(a, b);
    $4d82739dd229d539$var$fa(b, [
        a
    ]);
}
for(var $4d82739dd229d539$var$gf = 0; $4d82739dd229d539$var$gf < $4d82739dd229d539$var$ef.length; $4d82739dd229d539$var$gf++){
    var $4d82739dd229d539$var$hf = $4d82739dd229d539$var$ef[$4d82739dd229d539$var$gf], $4d82739dd229d539$var$jf = $4d82739dd229d539$var$hf.toLowerCase(), $4d82739dd229d539$var$kf = $4d82739dd229d539$var$hf[0].toUpperCase() + $4d82739dd229d539$var$hf.slice(1);
    $4d82739dd229d539$var$ff($4d82739dd229d539$var$jf, "on" + $4d82739dd229d539$var$kf);
}
$4d82739dd229d539$var$ff($4d82739dd229d539$var$$e, "onAnimationEnd");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$af, "onAnimationIteration");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$bf, "onAnimationStart");
$4d82739dd229d539$var$ff("dblclick", "onDoubleClick");
$4d82739dd229d539$var$ff("focusin", "onFocus");
$4d82739dd229d539$var$ff("focusout", "onBlur");
$4d82739dd229d539$var$ff($4d82739dd229d539$var$cf, "onTransitionEnd");
$4d82739dd229d539$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$4d82739dd229d539$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$4d82739dd229d539$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$4d82739dd229d539$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$4d82739dd229d539$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$4d82739dd229d539$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $4d82739dd229d539$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $4d82739dd229d539$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($4d82739dd229d539$var$lf));
function $4d82739dd229d539$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $4d82739dd229d539$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $4d82739dd229d539$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $4d82739dd229d539$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($4d82739dd229d539$var$Qb) throw a = $4d82739dd229d539$var$Rb, $4d82739dd229d539$var$Qb = !1, $4d82739dd229d539$var$Rb = null, a;
}
function $4d82739dd229d539$var$D(a, b) {
    var c = b[$4d82739dd229d539$var$of];
    void 0 === c && (c = b[$4d82739dd229d539$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($4d82739dd229d539$var$pf(b, a, 2, !1), c.add(d));
}
function $4d82739dd229d539$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $4d82739dd229d539$var$pf(c, a, d, b);
}
var $4d82739dd229d539$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $4d82739dd229d539$var$sf(a) {
    if (!a[$4d82739dd229d539$var$rf]) {
        a[$4d82739dd229d539$var$rf] = !0;
        $4d82739dd229d539$var$da.forEach(function(b) {
            "selectionchange" !== b && ($4d82739dd229d539$var$mf.has(b) || $4d82739dd229d539$var$qf(b, !1, a), $4d82739dd229d539$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$4d82739dd229d539$var$rf] || (b[$4d82739dd229d539$var$rf] = !0, $4d82739dd229d539$var$qf("selectionchange", !1, b));
    }
}
function $4d82739dd229d539$var$pf(a, b, c, d) {
    switch($4d82739dd229d539$var$jd(b)){
        case 1:
            var e = $4d82739dd229d539$var$ed;
            break;
        case 4:
            e = $4d82739dd229d539$var$gd;
            break;
        default:
            e = $4d82739dd229d539$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$4d82739dd229d539$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $4d82739dd229d539$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $4d82739dd229d539$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $4d82739dd229d539$var$Jb(function() {
        var d = f, e = $4d82739dd229d539$var$xb(c), g = [];
        a: {
            var h = $4d82739dd229d539$var$df.get(a);
            if (void 0 !== h) {
                var k = $4d82739dd229d539$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $4d82739dd229d539$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $4d82739dd229d539$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $4d82739dd229d539$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $4d82739dd229d539$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $4d82739dd229d539$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $4d82739dd229d539$var$Vd;
                        break;
                    case $4d82739dd229d539$var$$e:
                    case $4d82739dd229d539$var$af:
                    case $4d82739dd229d539$var$bf:
                        k = $4d82739dd229d539$var$Hd;
                        break;
                    case $4d82739dd229d539$var$cf:
                        k = $4d82739dd229d539$var$Xd;
                        break;
                    case "scroll":
                        k = $4d82739dd229d539$var$vd;
                        break;
                    case "wheel":
                        k = $4d82739dd229d539$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $4d82739dd229d539$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $4d82739dd229d539$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $4d82739dd229d539$var$Kb(w, x), null != F && t.push($4d82739dd229d539$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $4d82739dd229d539$var$wb && (n = c.relatedTarget || c.fromElement) && ($4d82739dd229d539$var$Wc(n) || n[$4d82739dd229d539$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $4d82739dd229d539$var$Wc(n) : null, null !== n && (J = $4d82739dd229d539$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $4d82739dd229d539$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $4d82739dd229d539$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $4d82739dd229d539$var$ue(k);
                        u = null == n ? h : $4d82739dd229d539$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $4d82739dd229d539$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $4d82739dd229d539$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $4d82739dd229d539$var$vf(F))u++;
                            for(; 0 < w - u;)t = $4d82739dd229d539$var$vf(t), w--;
                            for(; 0 < u - w;)x = $4d82739dd229d539$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $4d82739dd229d539$var$vf(t);
                                x = $4d82739dd229d539$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $4d82739dd229d539$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $4d82739dd229d539$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $4d82739dd229d539$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $4d82739dd229d539$var$ve;
                else if ($4d82739dd229d539$var$me(h)) {
                    if ($4d82739dd229d539$var$we) na = $4d82739dd229d539$var$Fe;
                    else {
                        na = $4d82739dd229d539$var$De;
                        var xa = $4d82739dd229d539$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $4d82739dd229d539$var$Ee);
                if (na && (na = na(a, d))) {
                    $4d82739dd229d539$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $4d82739dd229d539$var$cb(h, "number", h.value);
            }
            xa = d ? $4d82739dd229d539$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($4d82739dd229d539$var$me(xa) || "true" === xa.contentEditable) $4d82739dd229d539$var$Qe = xa, $4d82739dd229d539$var$Re = d, $4d82739dd229d539$var$Se = null;
                    break;
                case "focusout":
                    $4d82739dd229d539$var$Se = $4d82739dd229d539$var$Re = $4d82739dd229d539$var$Qe = null;
                    break;
                case "mousedown":
                    $4d82739dd229d539$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $4d82739dd229d539$var$Te = !1;
                    $4d82739dd229d539$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($4d82739dd229d539$var$Pe) break;
                case "keydown":
                case "keyup":
                    $4d82739dd229d539$var$Ue(g, c, e);
            }
            var $a;
            if ($4d82739dd229d539$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $4d82739dd229d539$var$ie ? $4d82739dd229d539$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($4d82739dd229d539$var$de && "ko" !== c.locale && ($4d82739dd229d539$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $4d82739dd229d539$var$ie && ($a = $4d82739dd229d539$var$nd()) : ($4d82739dd229d539$var$kd = e, $4d82739dd229d539$var$ld = "value" in $4d82739dd229d539$var$kd ? $4d82739dd229d539$var$kd.value : $4d82739dd229d539$var$kd.textContent, $4d82739dd229d539$var$ie = !0)), xa = $4d82739dd229d539$var$oe(d, ba), 0 < xa.length && (ba = new $4d82739dd229d539$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $4d82739dd229d539$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $4d82739dd229d539$var$ce ? $4d82739dd229d539$var$je(a, c) : $4d82739dd229d539$var$ke(a, c)) d = $4d82739dd229d539$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $4d82739dd229d539$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $4d82739dd229d539$var$se(g, b);
    });
}
function $4d82739dd229d539$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $4d82739dd229d539$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $4d82739dd229d539$var$Kb(a, c), null != f && d.unshift($4d82739dd229d539$var$tf(a, f, e)), f = $4d82739dd229d539$var$Kb(a, b), null != f && d.push($4d82739dd229d539$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $4d82739dd229d539$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $4d82739dd229d539$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.unshift($4d82739dd229d539$var$tf(c, k, h))) : e || (k = $4d82739dd229d539$var$Kb(c, f), null != k && g.push($4d82739dd229d539$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $4d82739dd229d539$var$xf = /\r\n?/g, $4d82739dd229d539$var$yf = /\u0000|\uFFFD/g;
function $4d82739dd229d539$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($4d82739dd229d539$var$xf, "\n").replace($4d82739dd229d539$var$yf, "");
}
function $4d82739dd229d539$var$Af(a, b, c) {
    b = $4d82739dd229d539$var$zf(b);
    if ($4d82739dd229d539$var$zf(a) !== b && c) throw Error($4d82739dd229d539$var$p(425));
}
function $4d82739dd229d539$var$Bf() {}
var $4d82739dd229d539$var$Cf = null, $4d82739dd229d539$var$Df = null;
function $4d82739dd229d539$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $4d82739dd229d539$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $4d82739dd229d539$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $4d82739dd229d539$var$Hf = "function" === typeof Promise ? Promise : void 0, $4d82739dd229d539$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $4d82739dd229d539$var$Hf ? function(a) {
    return $4d82739dd229d539$var$Hf.resolve(null).then(a).catch($4d82739dd229d539$var$If);
} : $4d82739dd229d539$var$Ff;
function $4d82739dd229d539$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $4d82739dd229d539$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $4d82739dd229d539$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $4d82739dd229d539$var$bd(b);
}
function $4d82739dd229d539$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $4d82739dd229d539$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $4d82739dd229d539$var$Nf = Math.random().toString(36).slice(2), $4d82739dd229d539$var$Of = "__reactFiber$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Pf = "__reactProps$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$uf = "__reactContainer$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$of = "__reactEvents$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Qf = "__reactListeners$" + $4d82739dd229d539$var$Nf, $4d82739dd229d539$var$Rf = "__reactHandles$" + $4d82739dd229d539$var$Nf;
function $4d82739dd229d539$var$Wc(a) {
    var b = a[$4d82739dd229d539$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$4d82739dd229d539$var$uf] || c[$4d82739dd229d539$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $4d82739dd229d539$var$Mf(a); null !== a;){
                if (c = a[$4d82739dd229d539$var$Of]) return c;
                a = $4d82739dd229d539$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $4d82739dd229d539$var$Cb(a) {
    a = a[$4d82739dd229d539$var$Of] || a[$4d82739dd229d539$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $4d82739dd229d539$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($4d82739dd229d539$var$p(33));
}
function $4d82739dd229d539$var$Db(a) {
    return a[$4d82739dd229d539$var$Pf] || null;
}
var $4d82739dd229d539$var$Sf = [], $4d82739dd229d539$var$Tf = -1;
function $4d82739dd229d539$var$Uf(a) {
    return {
        current: a
    };
}
function $4d82739dd229d539$var$E(a) {
    0 > $4d82739dd229d539$var$Tf || (a.current = $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf], $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = null, $4d82739dd229d539$var$Tf--);
}
function $4d82739dd229d539$var$G(a, b) {
    $4d82739dd229d539$var$Tf++;
    $4d82739dd229d539$var$Sf[$4d82739dd229d539$var$Tf] = a.current;
    a.current = b;
}
var $4d82739dd229d539$var$Vf = {}, $4d82739dd229d539$var$H = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$Vf), $4d82739dd229d539$var$Wf = $4d82739dd229d539$var$Uf(!1), $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$Vf;
function $4d82739dd229d539$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $4d82739dd229d539$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $4d82739dd229d539$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $4d82739dd229d539$var$$f() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
}
function $4d82739dd229d539$var$ag(a, b, c) {
    if ($4d82739dd229d539$var$H.current !== $4d82739dd229d539$var$Vf) throw Error($4d82739dd229d539$var$p(168));
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
function $4d82739dd229d539$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($4d82739dd229d539$var$p(108, $4d82739dd229d539$var$Ra(a) || "Unknown", e));
    return $4d82739dd229d539$var$A({}, c, d);
}
function $4d82739dd229d539$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $4d82739dd229d539$var$Vf;
    $4d82739dd229d539$var$Xf = $4d82739dd229d539$var$H.current;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, $4d82739dd229d539$var$Wf.current);
    return !0;
}
function $4d82739dd229d539$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($4d82739dd229d539$var$p(169));
    c ? (a = $4d82739dd229d539$var$bg(a, b, $4d82739dd229d539$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$G($4d82739dd229d539$var$H, a)) : $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$Wf, c);
}
var $4d82739dd229d539$var$eg = null, $4d82739dd229d539$var$fg = !1, $4d82739dd229d539$var$gg = !1;
function $4d82739dd229d539$var$hg(a) {
    null === $4d82739dd229d539$var$eg ? $4d82739dd229d539$var$eg = [
        a
    ] : $4d82739dd229d539$var$eg.push(a);
}
function $4d82739dd229d539$var$ig(a) {
    $4d82739dd229d539$var$fg = !0;
    $4d82739dd229d539$var$hg(a);
}
function $4d82739dd229d539$var$jg() {
    if (!$4d82739dd229d539$var$gg && null !== $4d82739dd229d539$var$eg) {
        $4d82739dd229d539$var$gg = !0;
        var a = 0, b = $4d82739dd229d539$var$C;
        try {
            var c = $4d82739dd229d539$var$eg;
            for($4d82739dd229d539$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $4d82739dd229d539$var$eg = null;
            $4d82739dd229d539$var$fg = !1;
        } catch (e) {
            throw null !== $4d82739dd229d539$var$eg && ($4d82739dd229d539$var$eg = $4d82739dd229d539$var$eg.slice(a + 1)), $4d82739dd229d539$var$ac($4d82739dd229d539$var$fc, $4d82739dd229d539$var$jg), e;
        } finally{
            $4d82739dd229d539$var$C = b, $4d82739dd229d539$var$gg = !1;
        }
    }
    return null;
}
var $4d82739dd229d539$var$kg = [], $4d82739dd229d539$var$lg = 0, $4d82739dd229d539$var$mg = null, $4d82739dd229d539$var$ng = 0, $4d82739dd229d539$var$og = [], $4d82739dd229d539$var$pg = 0, $4d82739dd229d539$var$qg = null, $4d82739dd229d539$var$rg = 1, $4d82739dd229d539$var$sg = "";
function $4d82739dd229d539$var$tg(a, b) {
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$ng;
    $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg++] = $4d82739dd229d539$var$mg;
    $4d82739dd229d539$var$mg = a;
    $4d82739dd229d539$var$ng = b;
}
function $4d82739dd229d539$var$ug(a, b, c) {
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg;
    $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg;
    $4d82739dd229d539$var$qg = a;
    var d = $4d82739dd229d539$var$rg;
    a = $4d82739dd229d539$var$sg;
    var e = 32 - $4d82739dd229d539$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $4d82739dd229d539$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $4d82739dd229d539$var$rg = 1 << 32 - $4d82739dd229d539$var$oc(b) + e | c << e | d;
        $4d82739dd229d539$var$sg = f + a;
    } else $4d82739dd229d539$var$rg = 1 << f | c << e | d, $4d82739dd229d539$var$sg = a;
}
function $4d82739dd229d539$var$vg(a) {
    null !== a.return && ($4d82739dd229d539$var$tg(a, 1), $4d82739dd229d539$var$ug(a, 1, 0));
}
function $4d82739dd229d539$var$wg(a) {
    for(; a === $4d82739dd229d539$var$mg;)$4d82739dd229d539$var$mg = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null, $4d82739dd229d539$var$ng = $4d82739dd229d539$var$kg[--$4d82739dd229d539$var$lg], $4d82739dd229d539$var$kg[$4d82739dd229d539$var$lg] = null;
    for(; a === $4d82739dd229d539$var$qg;)$4d82739dd229d539$var$qg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$sg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null, $4d82739dd229d539$var$rg = $4d82739dd229d539$var$og[--$4d82739dd229d539$var$pg], $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg] = null;
}
var $4d82739dd229d539$var$xg = null, $4d82739dd229d539$var$yg = null, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$zg = null;
function $4d82739dd229d539$var$Ag(a, b) {
    var c = $4d82739dd229d539$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $4d82739dd229d539$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $4d82739dd229d539$var$qg ? {
                id: $4d82739dd229d539$var$rg,
                overflow: $4d82739dd229d539$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $4d82739dd229d539$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $4d82739dd229d539$var$xg = a, $4d82739dd229d539$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $4d82739dd229d539$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $4d82739dd229d539$var$Eg(a) {
    if ($4d82739dd229d539$var$I) {
        var b = $4d82739dd229d539$var$yg;
        if (b) {
            var c = b;
            if (!$4d82739dd229d539$var$Cg(a, b)) {
                if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
                b = $4d82739dd229d539$var$Lf(c.nextSibling);
                var d = $4d82739dd229d539$var$xg;
                b && $4d82739dd229d539$var$Cg(a, b) ? $4d82739dd229d539$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $4d82739dd229d539$var$I = !1, $4d82739dd229d539$var$xg = a);
            }
        } else {
            if ($4d82739dd229d539$var$Dg(a)) throw Error($4d82739dd229d539$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $4d82739dd229d539$var$I = !1;
            $4d82739dd229d539$var$xg = a;
        }
    }
}
function $4d82739dd229d539$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $4d82739dd229d539$var$xg = a;
}
function $4d82739dd229d539$var$Gg(a) {
    if (a !== $4d82739dd229d539$var$xg) return !1;
    if (!$4d82739dd229d539$var$I) return $4d82739dd229d539$var$Fg(a), $4d82739dd229d539$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$4d82739dd229d539$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $4d82739dd229d539$var$yg)) {
        if ($4d82739dd229d539$var$Dg(a)) throw $4d82739dd229d539$var$Hg(), Error($4d82739dd229d539$var$p(418));
        for(; b;)$4d82739dd229d539$var$Ag(a, b), b = $4d82739dd229d539$var$Lf(b.nextSibling);
    }
    $4d82739dd229d539$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($4d82739dd229d539$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $4d82739dd229d539$var$yg = null;
        }
    } else $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg ? $4d82739dd229d539$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $4d82739dd229d539$var$Hg() {
    for(var a = $4d82739dd229d539$var$yg; a;)a = $4d82739dd229d539$var$Lf(a.nextSibling);
}
function $4d82739dd229d539$var$Ig() {
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$xg = null;
    $4d82739dd229d539$var$I = !1;
}
function $4d82739dd229d539$var$Jg(a) {
    null === $4d82739dd229d539$var$zg ? $4d82739dd229d539$var$zg = [
        a
    ] : $4d82739dd229d539$var$zg.push(a);
}
var $4d82739dd229d539$var$Kg = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig;
function $4d82739dd229d539$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($4d82739dd229d539$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($4d82739dd229d539$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($4d82739dd229d539$var$p(284));
        if (!c._owner) throw Error($4d82739dd229d539$var$p(290, a));
    }
    return a;
}
function $4d82739dd229d539$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($4d82739dd229d539$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $4d82739dd229d539$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $4d82739dd229d539$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $4d82739dd229d539$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $4d82739dd229d539$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $4d82739dd229d539$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $4d82739dd229d539$var$Lg(a, b, c), d.return = a, d;
        d = $4d82739dd229d539$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $4d82739dd229d539$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $4d82739dd229d539$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $4d82739dd229d539$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $4d82739dd229d539$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c = $4d82739dd229d539$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $4d82739dd229d539$var$Lg(a, null, b), c.return = a, c;
                case $4d82739dd229d539$var$wa:
                    return b = $4d82739dd229d539$var$Sg(b, a.mode, c), b.return = a, b;
                case $4d82739dd229d539$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($4d82739dd229d539$var$eb(b) || $4d82739dd229d539$var$Ka(b)) return b = $4d82739dd229d539$var$Tg(b, a.mode, c, null), b.return = a, b;
            $4d82739dd229d539$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $4d82739dd229d539$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $4d82739dd229d539$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $4d82739dd229d539$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($4d82739dd229d539$var$eb(c) || $4d82739dd229d539$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $4d82739dd229d539$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $4d82739dd229d539$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $4d82739dd229d539$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $4d82739dd229d539$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($4d82739dd229d539$var$eb(d) || $4d82739dd229d539$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $4d82739dd229d539$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $4d82739dd229d539$var$Ka(h);
        if ("function" !== typeof l) throw Error($4d82739dd229d539$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($4d82739dd229d539$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $4d82739dd229d539$var$I && $4d82739dd229d539$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $4d82739dd229d539$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $4d82739dd229d539$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $4d82739dd229d539$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $4d82739dd229d539$var$Ha && $4d82739dd229d539$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $4d82739dd229d539$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $4d82739dd229d539$var$ya ? (d = $4d82739dd229d539$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $4d82739dd229d539$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $4d82739dd229d539$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $4d82739dd229d539$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $4d82739dd229d539$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $4d82739dd229d539$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($4d82739dd229d539$var$eb(f)) return n(a, d, f, h);
            if ($4d82739dd229d539$var$Ka(f)) return t(a, d, f, h);
            $4d82739dd229d539$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $4d82739dd229d539$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $4d82739dd229d539$var$Ug = $4d82739dd229d539$var$Og(!0), $4d82739dd229d539$var$Vg = $4d82739dd229d539$var$Og(!1), $4d82739dd229d539$var$Wg = $4d82739dd229d539$var$Uf(null), $4d82739dd229d539$var$Xg = null, $4d82739dd229d539$var$Yg = null, $4d82739dd229d539$var$Zg = null;
function $4d82739dd229d539$var$$g() {
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Xg = null;
}
function $4d82739dd229d539$var$ah(a) {
    var b = $4d82739dd229d539$var$Wg.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$Wg);
    a._currentValue = b;
}
function $4d82739dd229d539$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $4d82739dd229d539$var$ch(a, b) {
    $4d82739dd229d539$var$Xg = a;
    $4d82739dd229d539$var$Zg = $4d82739dd229d539$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($4d82739dd229d539$var$dh = !0), a.firstContext = null);
}
function $4d82739dd229d539$var$eh(a) {
    var b = a._currentValue;
    if ($4d82739dd229d539$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $4d82739dd229d539$var$Yg) {
            if (null === $4d82739dd229d539$var$Xg) throw Error($4d82739dd229d539$var$p(308));
            $4d82739dd229d539$var$Yg = a;
            $4d82739dd229d539$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $4d82739dd229d539$var$Yg = $4d82739dd229d539$var$Yg.next = a;
    }
    return b;
}
var $4d82739dd229d539$var$fh = null;
function $4d82739dd229d539$var$gh(a) {
    null === $4d82739dd229d539$var$fh ? $4d82739dd229d539$var$fh = [
        a
    ] : $4d82739dd229d539$var$fh.push(a);
}
function $4d82739dd229d539$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $4d82739dd229d539$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $4d82739dd229d539$var$ih(a, d);
}
function $4d82739dd229d539$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $4d82739dd229d539$var$jh = !1;
function $4d82739dd229d539$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $4d82739dd229d539$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $4d82739dd229d539$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $4d82739dd229d539$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($4d82739dd229d539$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $4d82739dd229d539$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $4d82739dd229d539$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $4d82739dd229d539$var$ih(a, c);
}
function $4d82739dd229d539$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
function $4d82739dd229d539$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $4d82739dd229d539$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $4d82739dd229d539$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $4d82739dd229d539$var$A({}, q, r);
                            break a;
                        case 2:
                            $4d82739dd229d539$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $4d82739dd229d539$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $4d82739dd229d539$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($4d82739dd229d539$var$p(191, e));
            e.call(d);
        }
    }
}
var $4d82739dd229d539$var$th = {}, $4d82739dd229d539$var$uh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$vh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th), $4d82739dd229d539$var$wh = $4d82739dd229d539$var$Uf($4d82739dd229d539$var$th);
function $4d82739dd229d539$var$xh(a) {
    if (a === $4d82739dd229d539$var$th) throw Error($4d82739dd229d539$var$p(174));
    return a;
}
function $4d82739dd229d539$var$yh(a, b) {
    $4d82739dd229d539$var$G($4d82739dd229d539$var$wh, b);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, $4d82739dd229d539$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $4d82739dd229d539$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $4d82739dd229d539$var$lb(b, a);
    }
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, b);
}
function $4d82739dd229d539$var$zh() {
    $4d82739dd229d539$var$E($4d82739dd229d539$var$uh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$vh);
    $4d82739dd229d539$var$E($4d82739dd229d539$var$wh);
}
function $4d82739dd229d539$var$Ah(a) {
    $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
    var b = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
    var c = $4d82739dd229d539$var$lb(b, a.type);
    b !== c && ($4d82739dd229d539$var$G($4d82739dd229d539$var$vh, a), $4d82739dd229d539$var$G($4d82739dd229d539$var$uh, c));
}
function $4d82739dd229d539$var$Bh(a) {
    $4d82739dd229d539$var$vh.current === a && ($4d82739dd229d539$var$E($4d82739dd229d539$var$uh), $4d82739dd229d539$var$E($4d82739dd229d539$var$vh));
}
var $4d82739dd229d539$var$L = $4d82739dd229d539$var$Uf(0);
function $4d82739dd229d539$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $4d82739dd229d539$var$Dh = [];
function $4d82739dd229d539$var$Eh() {
    for(var a = 0; a < $4d82739dd229d539$var$Dh.length; a++)$4d82739dd229d539$var$Dh[a]._workInProgressVersionPrimary = null;
    $4d82739dd229d539$var$Dh.length = 0;
}
var $4d82739dd229d539$var$Fh = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$Gh = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$Hh = 0, $4d82739dd229d539$var$M = null, $4d82739dd229d539$var$N = null, $4d82739dd229d539$var$O = null, $4d82739dd229d539$var$Ih = !1, $4d82739dd229d539$var$Jh = !1, $4d82739dd229d539$var$Kh = 0, $4d82739dd229d539$var$Lh = 0;
function $4d82739dd229d539$var$P() {
    throw Error($4d82739dd229d539$var$p(321));
}
function $4d82739dd229d539$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$4d82739dd229d539$var$He(a[c], b[c])) return !1;
    return !0;
}
function $4d82739dd229d539$var$Nh(a, b, c, d, e, f) {
    $4d82739dd229d539$var$Hh = f;
    $4d82739dd229d539$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $4d82739dd229d539$var$Fh.current = null === a || null === a.memoizedState ? $4d82739dd229d539$var$Oh : $4d82739dd229d539$var$Ph;
    a = c(d, e);
    if ($4d82739dd229d539$var$Jh) {
        f = 0;
        do {
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            if (25 <= f) throw Error($4d82739dd229d539$var$p(301));
            f += 1;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = null;
            b.updateQueue = null;
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Qh;
            a = c(d, e);
        }while ($4d82739dd229d539$var$Jh);
    }
    $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
    b = null !== $4d82739dd229d539$var$N && null !== $4d82739dd229d539$var$N.next;
    $4d82739dd229d539$var$Hh = 0;
    $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
    $4d82739dd229d539$var$Ih = !1;
    if (b) throw Error($4d82739dd229d539$var$p(300));
    return a;
}
function $4d82739dd229d539$var$Sh() {
    var a = 0 !== $4d82739dd229d539$var$Kh;
    $4d82739dd229d539$var$Kh = 0;
    return a;
}
function $4d82739dd229d539$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Uh() {
    if (null === $4d82739dd229d539$var$N) {
        var a = $4d82739dd229d539$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $4d82739dd229d539$var$N.next;
    var b = null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState : $4d82739dd229d539$var$O.next;
    if (null !== b) $4d82739dd229d539$var$O = b, $4d82739dd229d539$var$N = a;
    else {
        if (null === a) throw Error($4d82739dd229d539$var$p(310));
        $4d82739dd229d539$var$N = a;
        a = {
            memoizedState: $4d82739dd229d539$var$N.memoizedState,
            baseState: $4d82739dd229d539$var$N.baseState,
            baseQueue: $4d82739dd229d539$var$N.baseQueue,
            queue: $4d82739dd229d539$var$N.queue,
            next: null
        };
        null === $4d82739dd229d539$var$O ? $4d82739dd229d539$var$M.memoizedState = $4d82739dd229d539$var$O = a : $4d82739dd229d539$var$O = $4d82739dd229d539$var$O.next = a;
    }
    return $4d82739dd229d539$var$O;
}
function $4d82739dd229d539$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $4d82739dd229d539$var$Wh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = $4d82739dd229d539$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($4d82739dd229d539$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $4d82739dd229d539$var$M.lanes |= m;
                $4d82739dd229d539$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $4d82739dd229d539$var$He(d, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $4d82739dd229d539$var$M.lanes |= f, $4d82739dd229d539$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $4d82739dd229d539$var$Xh(a) {
    var b = $4d82739dd229d539$var$Uh(), c = b.queue;
    if (null === c) throw Error($4d82739dd229d539$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $4d82739dd229d539$var$He(f, b.memoizedState) || ($4d82739dd229d539$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $4d82739dd229d539$var$Yh() {}
function $4d82739dd229d539$var$Zh(a, b) {
    var c = $4d82739dd229d539$var$M, d = $4d82739dd229d539$var$Uh(), e = b(), f = !$4d82739dd229d539$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $4d82739dd229d539$var$dh = !0);
    d = d.queue;
    $4d82739dd229d539$var$$h($4d82739dd229d539$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $4d82739dd229d539$var$O && $4d82739dd229d539$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
        0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(c, b, e);
    }
    return e;
}
function $4d82739dd229d539$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $4d82739dd229d539$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
}
function $4d82739dd229d539$var$ai(a, b, c) {
    return c(function() {
        $4d82739dd229d539$var$ei(b) && $4d82739dd229d539$var$fi(a);
    });
}
function $4d82739dd229d539$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$4d82739dd229d539$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $4d82739dd229d539$var$fi(a) {
    var b = $4d82739dd229d539$var$ih(a, 1);
    null !== b && $4d82739dd229d539$var$gi(b, a, 1, -1);
}
function $4d82739dd229d539$var$hi(a) {
    var b = $4d82739dd229d539$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $4d82739dd229d539$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $4d82739dd229d539$var$ii.bind(null, $4d82739dd229d539$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $4d82739dd229d539$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $4d82739dd229d539$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $4d82739dd229d539$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $4d82739dd229d539$var$ji() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$ki(a, b, c, d) {
    var e = $4d82739dd229d539$var$Th();
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $4d82739dd229d539$var$li(a, b, c, d) {
    var e = $4d82739dd229d539$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $4d82739dd229d539$var$N) {
        var g = $4d82739dd229d539$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $4d82739dd229d539$var$Mh(d, g.deps)) {
            e.memoizedState = $4d82739dd229d539$var$bi(b, c, f, d);
            return;
        }
    }
    $4d82739dd229d539$var$M.flags |= a;
    e.memoizedState = $4d82739dd229d539$var$bi(1 | b, c, f, d);
}
function $4d82739dd229d539$var$mi(a, b) {
    return $4d82739dd229d539$var$ki(8390656, 8, a, b);
}
function $4d82739dd229d539$var$$h(a, b) {
    return $4d82739dd229d539$var$li(2048, 8, a, b);
}
function $4d82739dd229d539$var$ni(a, b) {
    return $4d82739dd229d539$var$li(4, 2, a, b);
}
function $4d82739dd229d539$var$oi(a, b) {
    return $4d82739dd229d539$var$li(4, 4, a, b);
}
function $4d82739dd229d539$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $4d82739dd229d539$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $4d82739dd229d539$var$li(4, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
}
function $4d82739dd229d539$var$ri() {}
function $4d82739dd229d539$var$si(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ti(a, b) {
    var c = $4d82739dd229d539$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $4d82739dd229d539$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $4d82739dd229d539$var$ui(a, b, c) {
    if (0 === ($4d82739dd229d539$var$Hh & 21)) return a.baseState && (a.baseState = !1, $4d82739dd229d539$var$dh = !0), a.memoizedState = c;
    $4d82739dd229d539$var$He(c, b) || (c = $4d82739dd229d539$var$yc(), $4d82739dd229d539$var$M.lanes |= c, $4d82739dd229d539$var$rh |= c, a.baseState = !0);
    return b;
}
function $4d82739dd229d539$var$vi(a, b) {
    var c = $4d82739dd229d539$var$C;
    $4d82739dd229d539$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $4d82739dd229d539$var$Gh.transition;
    $4d82739dd229d539$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$Gh.transition = d;
    }
}
function $4d82739dd229d539$var$wi() {
    return $4d82739dd229d539$var$Uh().memoizedState;
}
function $4d82739dd229d539$var$xi(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, c);
    else if (c = $4d82739dd229d539$var$hh(a, b, c, d), null !== c) {
        var e = $4d82739dd229d539$var$R();
        $4d82739dd229d539$var$gi(c, a, d, e);
        $4d82739dd229d539$var$Bi(c, b, d);
    }
}
function $4d82739dd229d539$var$ii(a, b, c) {
    var d = $4d82739dd229d539$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($4d82739dd229d539$var$zi(a)) $4d82739dd229d539$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($4d82739dd229d539$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $4d82739dd229d539$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $4d82739dd229d539$var$hh(a, b, e, d);
        null !== c && (e = $4d82739dd229d539$var$R(), $4d82739dd229d539$var$gi(c, a, d, e), $4d82739dd229d539$var$Bi(c, b, d));
    }
}
function $4d82739dd229d539$var$zi(a) {
    var b = a.alternate;
    return a === $4d82739dd229d539$var$M || null !== b && b === $4d82739dd229d539$var$M;
}
function $4d82739dd229d539$var$Ai(a, b) {
    $4d82739dd229d539$var$Jh = $4d82739dd229d539$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $4d82739dd229d539$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $4d82739dd229d539$var$Cc(a, c);
    }
}
var $4d82739dd229d539$var$Rh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$P,
    useContext: $4d82739dd229d539$var$P,
    useEffect: $4d82739dd229d539$var$P,
    useImperativeHandle: $4d82739dd229d539$var$P,
    useInsertionEffect: $4d82739dd229d539$var$P,
    useLayoutEffect: $4d82739dd229d539$var$P,
    useMemo: $4d82739dd229d539$var$P,
    useReducer: $4d82739dd229d539$var$P,
    useRef: $4d82739dd229d539$var$P,
    useState: $4d82739dd229d539$var$P,
    useDebugValue: $4d82739dd229d539$var$P,
    useDeferredValue: $4d82739dd229d539$var$P,
    useTransition: $4d82739dd229d539$var$P,
    useMutableSource: $4d82739dd229d539$var$P,
    useSyncExternalStore: $4d82739dd229d539$var$P,
    useId: $4d82739dd229d539$var$P,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Oh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: function(a, b) {
        $4d82739dd229d539$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $4d82739dd229d539$var$ki(4194308, 4, $4d82739dd229d539$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $4d82739dd229d539$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $4d82739dd229d539$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $4d82739dd229d539$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $4d82739dd229d539$var$xi.bind(null, $4d82739dd229d539$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $4d82739dd229d539$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $4d82739dd229d539$var$hi,
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        return $4d82739dd229d539$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$hi(!1), b = a[0];
        a = $4d82739dd229d539$var$vi.bind(null, a[1]);
        $4d82739dd229d539$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $4d82739dd229d539$var$M, e = $4d82739dd229d539$var$Th();
        if ($4d82739dd229d539$var$I) {
            if (void 0 === c) throw Error($4d82739dd229d539$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $4d82739dd229d539$var$Q) throw Error($4d82739dd229d539$var$p(349));
            0 !== ($4d82739dd229d539$var$Hh & 30) || $4d82739dd229d539$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $4d82739dd229d539$var$mi($4d82739dd229d539$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $4d82739dd229d539$var$bi(9, $4d82739dd229d539$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $4d82739dd229d539$var$Th(), b = $4d82739dd229d539$var$Q.identifierPrefix;
        if ($4d82739dd229d539$var$I) {
            var c = $4d82739dd229d539$var$sg;
            var d = $4d82739dd229d539$var$rg;
            c = (d & ~(1 << 32 - $4d82739dd229d539$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $4d82739dd229d539$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $4d82739dd229d539$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Ph = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Wh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Wh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
}, $4d82739dd229d539$var$Qh = {
    readContext: $4d82739dd229d539$var$eh,
    useCallback: $4d82739dd229d539$var$si,
    useContext: $4d82739dd229d539$var$eh,
    useEffect: $4d82739dd229d539$var$$h,
    useImperativeHandle: $4d82739dd229d539$var$qi,
    useInsertionEffect: $4d82739dd229d539$var$ni,
    useLayoutEffect: $4d82739dd229d539$var$oi,
    useMemo: $4d82739dd229d539$var$ti,
    useReducer: $4d82739dd229d539$var$Xh,
    useRef: $4d82739dd229d539$var$ji,
    useState: function() {
        return $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh);
    },
    useDebugValue: $4d82739dd229d539$var$ri,
    useDeferredValue: function(a) {
        var b = $4d82739dd229d539$var$Uh();
        return null === $4d82739dd229d539$var$N ? b.memoizedState = a : $4d82739dd229d539$var$ui(b, $4d82739dd229d539$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $4d82739dd229d539$var$Xh($4d82739dd229d539$var$Vh)[0], b = $4d82739dd229d539$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $4d82739dd229d539$var$Yh,
    useSyncExternalStore: $4d82739dd229d539$var$Zh,
    useId: $4d82739dd229d539$var$wi,
    unstable_isNewReconciler: !1
};
function $4d82739dd229d539$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $4d82739dd229d539$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $4d82739dd229d539$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $4d82739dd229d539$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $4d82739dd229d539$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $4d82739dd229d539$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $4d82739dd229d539$var$R(), e = $4d82739dd229d539$var$yi(a), f = $4d82739dd229d539$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $4d82739dd229d539$var$nh(a, f, e);
        null !== b && ($4d82739dd229d539$var$gi(b, a, e, d), $4d82739dd229d539$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $4d82739dd229d539$var$R(), d = $4d82739dd229d539$var$yi(a), e = $4d82739dd229d539$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $4d82739dd229d539$var$nh(a, e, d);
        null !== b && ($4d82739dd229d539$var$gi(b, a, d, c), $4d82739dd229d539$var$oh(b, a, d));
    }
};
function $4d82739dd229d539$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$4d82739dd229d539$var$Ie(c, d) || !$4d82739dd229d539$var$Ie(e, f) : !0;
}
function $4d82739dd229d539$var$Gi(a, b, c) {
    var d = !1, e = $4d82739dd229d539$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $4d82739dd229d539$var$eh(f) : (e = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $4d82739dd229d539$var$Yf(a, e) : $4d82739dd229d539$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $4d82739dd229d539$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $4d82739dd229d539$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $4d82739dd229d539$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $4d82739dd229d539$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $4d82739dd229d539$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $4d82739dd229d539$var$eh(f) : (f = $4d82739dd229d539$var$Zf(b) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, e.context = $4d82739dd229d539$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($4d82739dd229d539$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $4d82739dd229d539$var$Ei.enqueueReplaceState(e, e.state, null), $4d82739dd229d539$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $4d82739dd229d539$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $4d82739dd229d539$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $4d82739dd229d539$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $4d82739dd229d539$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $4d82739dd229d539$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $4d82739dd229d539$var$Ni(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $4d82739dd229d539$var$Oi || ($4d82739dd229d539$var$Oi = !0, $4d82739dd229d539$var$Pi = d);
        $4d82739dd229d539$var$Li(a, b);
    };
    return c;
}
function $4d82739dd229d539$var$Qi(a, b, c) {
    c = $4d82739dd229d539$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $4d82739dd229d539$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $4d82739dd229d539$var$Li(a, b);
        "function" !== typeof d && (null === $4d82739dd229d539$var$Ri ? $4d82739dd229d539$var$Ri = new Set([
            this
        ]) : $4d82739dd229d539$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $4d82739dd229d539$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $4d82739dd229d539$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $4d82739dd229d539$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $4d82739dd229d539$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $4d82739dd229d539$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $4d82739dd229d539$var$mh(-1, 1), b.tag = 2, $4d82739dd229d539$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $4d82739dd229d539$var$Wi = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$dh = !1;
function $4d82739dd229d539$var$Xi(a, b, c, d) {
    b.child = null === a ? $4d82739dd229d539$var$Vg(b, null, c, d) : $4d82739dd229d539$var$Ug(b, a.child, c, d);
}
function $4d82739dd229d539$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $4d82739dd229d539$var$ch(b, e);
    d = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    c = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && c && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, d, e);
    return b.child;
}
function $4d82739dd229d539$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$4d82739dd229d539$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $4d82739dd229d539$var$bj(a, b, f, d, e);
        a = $4d82739dd229d539$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $4d82739dd229d539$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $4d82739dd229d539$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $4d82739dd229d539$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $4d82739dd229d539$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($4d82739dd229d539$var$Ie(f, d) && a.ref === b.ref) {
            if ($4d82739dd229d539$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($4d82739dd229d539$var$dh = !0);
            else return b.lanes = a.lanes, $4d82739dd229d539$var$Zi(a, b, e);
        }
    }
    return $4d82739dd229d539$var$cj(a, b, c, d, e);
}
function $4d82739dd229d539$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj);
            $4d82739dd229d539$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $4d82739dd229d539$var$G($4d82739dd229d539$var$ej, $4d82739dd229d539$var$fj), $4d82739dd229d539$var$fj |= d;
    $4d82739dd229d539$var$Xi(a, b, e, c);
    return b.child;
}
function $4d82739dd229d539$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $4d82739dd229d539$var$cj(a, b, c, d, e) {
    var f = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current;
    f = $4d82739dd229d539$var$Yf(b, f);
    $4d82739dd229d539$var$ch(b, e);
    c = $4d82739dd229d539$var$Nh(a, b, c, d, f, e);
    d = $4d82739dd229d539$var$Sh();
    if (null !== a && !$4d82739dd229d539$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $4d82739dd229d539$var$Zi(a, b, e);
    $4d82739dd229d539$var$I && d && $4d82739dd229d539$var$vg(b);
    b.flags |= 1;
    $4d82739dd229d539$var$Xi(a, b, c, e);
    return b.child;
}
function $4d82739dd229d539$var$hj(a, b, c, d, e) {
    if ($4d82739dd229d539$var$Zf(c)) {
        var f = !0;
        $4d82739dd229d539$var$cg(b);
    } else f = !1;
    $4d82739dd229d539$var$ch(b, e);
    if (null === b.stateNode) $4d82739dd229d539$var$ij(a, b), $4d82739dd229d539$var$Gi(b, c, d), $4d82739dd229d539$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $4d82739dd229d539$var$eh(l) : (l = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, l = $4d82739dd229d539$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $4d82739dd229d539$var$Hi(b, g, d, l);
        $4d82739dd229d539$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof m && ($4d82739dd229d539$var$Di(b, c, m, d), k = b.memoizedState), (h = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $4d82739dd229d539$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $4d82739dd229d539$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $4d82739dd229d539$var$eh(k) : (k = $4d82739dd229d539$var$Zf(c) ? $4d82739dd229d539$var$Xf : $4d82739dd229d539$var$H.current, k = $4d82739dd229d539$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $4d82739dd229d539$var$Hi(b, g, d, k);
        $4d82739dd229d539$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $4d82739dd229d539$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $4d82739dd229d539$var$Wf.current || $4d82739dd229d539$var$jh ? ("function" === typeof y && ($4d82739dd229d539$var$Di(b, c, y, d), n = b.memoizedState), (l = $4d82739dd229d539$var$jh || $4d82739dd229d539$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $4d82739dd229d539$var$jj(a, b, c, d, f, e);
}
function $4d82739dd229d539$var$jj(a, b, c, d, e, f) {
    $4d82739dd229d539$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $4d82739dd229d539$var$dg(b, c, !1), $4d82739dd229d539$var$Zi(a, b, f);
    d = b.stateNode;
    $4d82739dd229d539$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $4d82739dd229d539$var$Ug(b, a.child, null, f), b.child = $4d82739dd229d539$var$Ug(b, null, h, f)) : $4d82739dd229d539$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $4d82739dd229d539$var$dg(b, c, !0);
    return b.child;
}
function $4d82739dd229d539$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $4d82739dd229d539$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $4d82739dd229d539$var$ag(a, b.context, !1);
    $4d82739dd229d539$var$yh(a, b.containerInfo);
}
function $4d82739dd229d539$var$lj(a, b, c, d, e) {
    $4d82739dd229d539$var$Ig();
    $4d82739dd229d539$var$Jg(e);
    b.flags |= 256;
    $4d82739dd229d539$var$Xi(a, b, c, d);
    return b.child;
}
var $4d82739dd229d539$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $4d82739dd229d539$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $4d82739dd229d539$var$oj(a, b, c) {
    var d = b.pendingProps, e = $4d82739dd229d539$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, e & 1);
    if (null === a) {
        $4d82739dd229d539$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $4d82739dd229d539$var$pj(g, d, 0, null), a = $4d82739dd229d539$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $4d82739dd229d539$var$nj(c), b.memoizedState = $4d82739dd229d539$var$mj, a) : $4d82739dd229d539$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $4d82739dd229d539$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $4d82739dd229d539$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $4d82739dd229d539$var$Pg(h, f) : (f = $4d82739dd229d539$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $4d82739dd229d539$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $4d82739dd229d539$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $4d82739dd229d539$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $4d82739dd229d539$var$qj(a, b) {
    b = $4d82739dd229d539$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $4d82739dd229d539$var$sj(a, b, c, d) {
    null !== d && $4d82739dd229d539$var$Jg(d);
    $4d82739dd229d539$var$Ug(b, a.child, null, c);
    a = $4d82739dd229d539$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $4d82739dd229d539$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(422))), $4d82739dd229d539$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $4d82739dd229d539$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $4d82739dd229d539$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $4d82739dd229d539$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $4d82739dd229d539$var$nj(g);
        b.memoizedState = $4d82739dd229d539$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $4d82739dd229d539$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($4d82739dd229d539$var$p(419));
        d = $4d82739dd229d539$var$Ki(f, d, void 0);
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($4d82739dd229d539$var$dh || h) {
        d = $4d82739dd229d539$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $4d82739dd229d539$var$ih(a, e), $4d82739dd229d539$var$gi(d, a, e, -1));
        }
        $4d82739dd229d539$var$tj();
        d = $4d82739dd229d539$var$Ki(Error($4d82739dd229d539$var$p(421)));
        return $4d82739dd229d539$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $4d82739dd229d539$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(e.nextSibling);
    $4d82739dd229d539$var$xg = b;
    $4d82739dd229d539$var$I = !0;
    $4d82739dd229d539$var$zg = null;
    null !== a && ($4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$rg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$sg, $4d82739dd229d539$var$og[$4d82739dd229d539$var$pg++] = $4d82739dd229d539$var$qg, $4d82739dd229d539$var$rg = a.id, $4d82739dd229d539$var$sg = a.overflow, $4d82739dd229d539$var$qg = b);
    b = $4d82739dd229d539$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $4d82739dd229d539$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $4d82739dd229d539$var$bh(a.return, b, c);
}
function $4d82739dd229d539$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $4d82739dd229d539$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $4d82739dd229d539$var$Xi(a, b, d.children, c);
    d = $4d82739dd229d539$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $4d82739dd229d539$var$vj(a, c, b);
            else if (19 === a.tag) $4d82739dd229d539$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $4d82739dd229d539$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $4d82739dd229d539$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $4d82739dd229d539$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $4d82739dd229d539$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $4d82739dd229d539$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $4d82739dd229d539$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $4d82739dd229d539$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($4d82739dd229d539$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $4d82739dd229d539$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $4d82739dd229d539$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $4d82739dd229d539$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $4d82739dd229d539$var$kj(b);
            $4d82739dd229d539$var$Ig();
            break;
        case 5:
            $4d82739dd229d539$var$Ah(b);
            break;
        case 1:
            $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$cg(b);
            break;
        case 4:
            $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $4d82739dd229d539$var$oj(a, b, c);
                $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
                a = $4d82739dd229d539$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $4d82739dd229d539$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $4d82739dd229d539$var$dj(a, b, c);
    }
    return $4d82739dd229d539$var$Zi(a, b, c);
}
var $4d82739dd229d539$var$zj, $4d82739dd229d539$var$Aj, $4d82739dd229d539$var$Bj, $4d82739dd229d539$var$Cj;
$4d82739dd229d539$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$4d82739dd229d539$var$Aj = function() {};
$4d82739dd229d539$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $4d82739dd229d539$var$Ya(a, e);
                d = $4d82739dd229d539$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $4d82739dd229d539$var$A({}, e, {
                    value: void 0
                });
                d = $4d82739dd229d539$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $4d82739dd229d539$var$gb(a, e);
                d = $4d82739dd229d539$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
        }
        $4d82739dd229d539$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($4d82739dd229d539$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $4d82739dd229d539$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$4d82739dd229d539$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $4d82739dd229d539$var$Dj(a, b) {
    if (!$4d82739dd229d539$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $4d82739dd229d539$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $4d82739dd229d539$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $4d82739dd229d539$var$S(b), null;
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 3:
            d = b.stateNode;
            $4d82739dd229d539$var$zh();
            $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
            $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
            $4d82739dd229d539$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $4d82739dd229d539$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null));
            $4d82739dd229d539$var$Aj(a, b);
            $4d82739dd229d539$var$S(b);
            return null;
        case 5:
            $4d82739dd229d539$var$Bh(b);
            var e = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $4d82739dd229d539$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                    $4d82739dd229d539$var$S(b);
                    return null;
                }
                a = $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    d[$4d82739dd229d539$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $4d82739dd229d539$var$D("cancel", d);
                            $4d82739dd229d539$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], d);
                            break;
                        case "source":
                            $4d82739dd229d539$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $4d82739dd229d539$var$D("error", d);
                            $4d82739dd229d539$var$D("load", d);
                            break;
                        case "details":
                            $4d82739dd229d539$var$D("toggle", d);
                            break;
                        case "input":
                            $4d82739dd229d539$var$Za(d, f);
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $4d82739dd229d539$var$D("invalid", d);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$hb(d, f), $4d82739dd229d539$var$D("invalid", d);
                    }
                    $4d82739dd229d539$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $4d82739dd229d539$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $4d82739dd229d539$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$Va(d);
                            $4d82739dd229d539$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $4d82739dd229d539$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $4d82739dd229d539$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$4d82739dd229d539$var$Of] = b;
                    a[$4d82739dd229d539$var$Pf] = d;
                    $4d82739dd229d539$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $4d82739dd229d539$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $4d82739dd229d539$var$D("cancel", a);
                                $4d82739dd229d539$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $4d82739dd229d539$var$lf.length; e++)$4d82739dd229d539$var$D($4d82739dd229d539$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $4d82739dd229d539$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $4d82739dd229d539$var$D("error", a);
                                $4d82739dd229d539$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $4d82739dd229d539$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $4d82739dd229d539$var$Za(a, d);
                                e = $4d82739dd229d539$var$Ya(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $4d82739dd229d539$var$A({}, d, {
                                    value: void 0
                                });
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$hb(a, d);
                                e = $4d82739dd229d539$var$gb(a, d);
                                $4d82739dd229d539$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $4d82739dd229d539$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $4d82739dd229d539$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $4d82739dd229d539$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $4d82739dd229d539$var$ob(a, k) : "number" === typeof k && $4d82739dd229d539$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($4d82739dd229d539$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $4d82739dd229d539$var$D("scroll", a) : null != k && $4d82739dd229d539$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $4d82739dd229d539$var$Va(a);
                                $4d82739dd229d539$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $4d82739dd229d539$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $4d82739dd229d539$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $4d82739dd229d539$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $4d82739dd229d539$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $4d82739dd229d539$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($4d82739dd229d539$var$p(166));
                c = $4d82739dd229d539$var$xh($4d82739dd229d539$var$wh.current);
                $4d82739dd229d539$var$xh($4d82739dd229d539$var$uh.current);
                if ($4d82739dd229d539$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$4d82739dd229d539$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $4d82739dd229d539$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $4d82739dd229d539$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$4d82739dd229d539$var$Of] = b, b.stateNode = d;
            }
            $4d82739dd229d539$var$S(b);
            return null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($4d82739dd229d539$var$I && null !== $4d82739dd229d539$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $4d82739dd229d539$var$Hg(), $4d82739dd229d539$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $4d82739dd229d539$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($4d82739dd229d539$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($4d82739dd229d539$var$p(317));
                        f[$4d82739dd229d539$var$Of] = b;
                    } else $4d82739dd229d539$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $4d82739dd229d539$var$S(b);
                    f = !1;
                } else null !== $4d82739dd229d539$var$zg && ($4d82739dd229d539$var$Fj($4d82739dd229d539$var$zg), $4d82739dd229d539$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($4d82739dd229d539$var$L.current & 1) ? 0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 3) : $4d82739dd229d539$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $4d82739dd229d539$var$S(b);
            return null;
        case 4:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$Aj(a, b), null === a && $4d82739dd229d539$var$sf(b.stateNode.containerInfo), $4d82739dd229d539$var$S(b), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), $4d82739dd229d539$var$S(b), null;
        case 17:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), $4d82739dd229d539$var$S(b), null;
        case 19:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            f = b.memoizedState;
            if (null === f) return $4d82739dd229d539$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $4d82739dd229d539$var$Dj(f, !1);
                else {
                    if (0 !== $4d82739dd229d539$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $4d82739dd229d539$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $4d82739dd229d539$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $4d82739dd229d539$var$G($4d82739dd229d539$var$L, $4d82739dd229d539$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $4d82739dd229d539$var$B() > $4d82739dd229d539$var$Gj && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $4d82739dd229d539$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $4d82739dd229d539$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$4d82739dd229d539$var$I) return $4d82739dd229d539$var$S(b), null;
                    } else 2 * $4d82739dd229d539$var$B() - f.renderingStartTime > $4d82739dd229d539$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $4d82739dd229d539$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $4d82739dd229d539$var$B(), b.sibling = null, c = $4d82739dd229d539$var$L.current, $4d82739dd229d539$var$G($4d82739dd229d539$var$L, d ? c & 1 | 2 : c & 1), b;
            $4d82739dd229d539$var$S(b);
            return null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($4d82739dd229d539$var$fj & 1073741824) && ($4d82739dd229d539$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $4d82739dd229d539$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
}
function $4d82739dd229d539$var$Ij(a, b) {
    $4d82739dd229d539$var$wg(b);
    switch(b.tag){
        case 1:
            return $4d82739dd229d539$var$Zf(b.type) && $4d82739dd229d539$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $4d82739dd229d539$var$zh(), $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf), $4d82739dd229d539$var$E($4d82739dd229d539$var$H), $4d82739dd229d539$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $4d82739dd229d539$var$Bh(b), null;
        case 13:
            $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($4d82739dd229d539$var$p(340));
                $4d82739dd229d539$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $4d82739dd229d539$var$E($4d82739dd229d539$var$L), null;
        case 4:
            return $4d82739dd229d539$var$zh(), null;
        case 10:
            return $4d82739dd229d539$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $4d82739dd229d539$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $4d82739dd229d539$var$Jj = !1, $4d82739dd229d539$var$U = !1, $4d82739dd229d539$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $4d82739dd229d539$var$V = null;
function $4d82739dd229d539$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $4d82739dd229d539$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $4d82739dd229d539$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $4d82739dd229d539$var$W(a, b, d);
    }
}
var $4d82739dd229d539$var$Nj = !1;
function $4d82739dd229d539$var$Oj(a, b) {
    $4d82739dd229d539$var$Cf = $4d82739dd229d539$var$dd;
    a = $4d82739dd229d539$var$Me();
    if ($4d82739dd229d539$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $4d82739dd229d539$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $4d82739dd229d539$var$dd = !1;
    for($4d82739dd229d539$var$V = b; null !== $4d82739dd229d539$var$V;)if (b = $4d82739dd229d539$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $4d82739dd229d539$var$V = a;
    else for(; null !== $4d82739dd229d539$var$V;){
        b = $4d82739dd229d539$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $4d82739dd229d539$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(163));
            }
        } catch (F) {
            $4d82739dd229d539$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $4d82739dd229d539$var$V = a;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
    n = $4d82739dd229d539$var$Nj;
    $4d82739dd229d539$var$Nj = !1;
    return n;
}
function $4d82739dd229d539$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $4d82739dd229d539$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $4d82739dd229d539$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $4d82739dd229d539$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $4d82739dd229d539$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $4d82739dd229d539$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$4d82739dd229d539$var$Of], delete b[$4d82739dd229d539$var$Pf], delete b[$4d82739dd229d539$var$of], delete b[$4d82739dd229d539$var$Qf], delete b[$4d82739dd229d539$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $4d82739dd229d539$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $4d82739dd229d539$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $4d82739dd229d539$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $4d82739dd229d539$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $4d82739dd229d539$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Vj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Vj(a, b, c), a = a.sibling;
}
function $4d82739dd229d539$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($4d82739dd229d539$var$Wj(a, b, c), a = a.sibling; null !== a;)$4d82739dd229d539$var$Wj(a, b, c), a = a.sibling;
}
var $4d82739dd229d539$var$X = null, $4d82739dd229d539$var$Xj = !1;
function $4d82739dd229d539$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$4d82739dd229d539$var$Zj(a, b, c), c = c.sibling;
}
function $4d82739dd229d539$var$Zj(a, b, c) {
    if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onCommitFiberUnmount) try {
        $4d82739dd229d539$var$lc.onCommitFiberUnmount($4d82739dd229d539$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $4d82739dd229d539$var$U || $4d82739dd229d539$var$Lj(c, b);
        case 6:
            var d = $4d82739dd229d539$var$X, e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $4d82739dd229d539$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $4d82739dd229d539$var$X && ($4d82739dd229d539$var$Xj ? (a = $4d82739dd229d539$var$X, c = c.stateNode, 8 === a.nodeType ? $4d82739dd229d539$var$Kf(a.parentNode, c) : 1 === a.nodeType && $4d82739dd229d539$var$Kf(a, c), $4d82739dd229d539$var$bd(a)) : $4d82739dd229d539$var$Kf($4d82739dd229d539$var$X, c.stateNode));
            break;
        case 4:
            d = $4d82739dd229d539$var$X;
            e = $4d82739dd229d539$var$Xj;
            $4d82739dd229d539$var$X = c.stateNode.containerInfo;
            $4d82739dd229d539$var$Xj = !0;
            $4d82739dd229d539$var$Yj(a, b, c);
            $4d82739dd229d539$var$X = d;
            $4d82739dd229d539$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$4d82739dd229d539$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $4d82739dd229d539$var$Mj(c, b, g) : 0 !== (f & 4) && $4d82739dd229d539$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 1:
            if (!$4d82739dd229d539$var$U && ($4d82739dd229d539$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $4d82739dd229d539$var$W(c, b, h);
            }
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 21:
            $4d82739dd229d539$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($4d82739dd229d539$var$U = (d = $4d82739dd229d539$var$U) || null !== c.memoizedState, $4d82739dd229d539$var$Yj(a, b, c), $4d82739dd229d539$var$U = d) : $4d82739dd229d539$var$Yj(a, b, c);
            break;
        default:
            $4d82739dd229d539$var$Yj(a, b, c);
    }
}
function $4d82739dd229d539$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $4d82739dd229d539$var$Kj);
        b.forEach(function(b) {
            var d = $4d82739dd229d539$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $4d82739dd229d539$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $4d82739dd229d539$var$X = h.stateNode;
                        $4d82739dd229d539$var$Xj = !1;
                        break a;
                    case 3:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                    case 4:
                        $4d82739dd229d539$var$X = h.stateNode.containerInfo;
                        $4d82739dd229d539$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $4d82739dd229d539$var$X) throw Error($4d82739dd229d539$var$p(160));
            $4d82739dd229d539$var$Zj(f, g, e);
            $4d82739dd229d539$var$X = null;
            $4d82739dd229d539$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $4d82739dd229d539$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$4d82739dd229d539$var$dk(b, a), b = b.sibling;
}
function $4d82739dd229d539$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                try {
                    $4d82739dd229d539$var$Pj(3, a, a.return), $4d82739dd229d539$var$Qj(3, a);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
                try {
                    $4d82739dd229d539$var$Pj(5, a, a.return);
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            break;
        case 5:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 512 && null !== c && $4d82739dd229d539$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $4d82739dd229d539$var$ob(e, "");
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $4d82739dd229d539$var$ab(e, f);
                    $4d82739dd229d539$var$vb(h, g);
                    var l = $4d82739dd229d539$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $4d82739dd229d539$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $4d82739dd229d539$var$nb(e, q) : "children" === m ? $4d82739dd229d539$var$ob(e, q) : $4d82739dd229d539$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $4d82739dd229d539$var$bb(e, f);
                            break;
                        case "textarea":
                            $4d82739dd229d539$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $4d82739dd229d539$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $4d82739dd229d539$var$fb(e, !!f.multiple, f.defaultValue, !0) : $4d82739dd229d539$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$4d82739dd229d539$var$Pf] = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($4d82739dd229d539$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $4d82739dd229d539$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $4d82739dd229d539$var$bd(b.containerInfo);
            } catch (t) {
                $4d82739dd229d539$var$W(a, a.return, t);
            }
            break;
        case 4:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            break;
        case 13:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($4d82739dd229d539$var$fk = $4d82739dd229d539$var$B()));
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($4d82739dd229d539$var$U = (l = $4d82739dd229d539$var$U) || m, $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$U = l) : $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($4d82739dd229d539$var$V = a, m = a.child; null !== m;){
                    for(q = $4d82739dd229d539$var$V = m; null !== $4d82739dd229d539$var$V;){
                        r = $4d82739dd229d539$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $4d82739dd229d539$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $4d82739dd229d539$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $4d82739dd229d539$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $4d82739dd229d539$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $4d82739dd229d539$var$V = y) : $4d82739dd229d539$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $4d82739dd229d539$var$rb("display", g));
                            } catch (t) {
                                $4d82739dd229d539$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $4d82739dd229d539$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $4d82739dd229d539$var$ck(b, a);
            $4d82739dd229d539$var$ek(a);
            d & 4 && $4d82739dd229d539$var$ak(a);
            break;
        case 21:
            break;
        default:
            $4d82739dd229d539$var$ck(b, a), $4d82739dd229d539$var$ek(a);
    }
}
function $4d82739dd229d539$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($4d82739dd229d539$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($4d82739dd229d539$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($4d82739dd229d539$var$ob(e, ""), d.flags &= -33);
                    var f = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $4d82739dd229d539$var$Uj(a);
                    $4d82739dd229d539$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(161));
            }
        } catch (k) {
            $4d82739dd229d539$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $4d82739dd229d539$var$hk(a, b, c) {
    $4d82739dd229d539$var$V = a;
    $4d82739dd229d539$var$ik(a, b, c);
}
function $4d82739dd229d539$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $4d82739dd229d539$var$V;){
        var e = $4d82739dd229d539$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $4d82739dd229d539$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $4d82739dd229d539$var$U;
                h = $4d82739dd229d539$var$Jj;
                var l = $4d82739dd229d539$var$U;
                $4d82739dd229d539$var$Jj = g;
                if (($4d82739dd229d539$var$U = k) && !l) for($4d82739dd229d539$var$V = e; null !== $4d82739dd229d539$var$V;)g = $4d82739dd229d539$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $4d82739dd229d539$var$jk(e) : null !== k ? (k.return = g, $4d82739dd229d539$var$V = k) : $4d82739dd229d539$var$jk(e);
                for(; null !== f;)$4d82739dd229d539$var$V = f, $4d82739dd229d539$var$ik(f, b, c), f = f.sibling;
                $4d82739dd229d539$var$V = e;
                $4d82739dd229d539$var$Jj = h;
                $4d82739dd229d539$var$U = l;
            }
            $4d82739dd229d539$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $4d82739dd229d539$var$V = f) : $4d82739dd229d539$var$kk(a, b, c);
    }
}
function $4d82739dd229d539$var$kk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $4d82739dd229d539$var$U || $4d82739dd229d539$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$4d82739dd229d539$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $4d82739dd229d539$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $4d82739dd229d539$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $4d82739dd229d539$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $4d82739dd229d539$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($4d82739dd229d539$var$p(163));
                }
                $4d82739dd229d539$var$U || b.flags & 512 && $4d82739dd229d539$var$Rj(b);
            } catch (r) {
                $4d82739dd229d539$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$gk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $4d82739dd229d539$var$V = c;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
function $4d82739dd229d539$var$jk(a) {
    for(; null !== $4d82739dd229d539$var$V;){
        var b = $4d82739dd229d539$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $4d82739dd229d539$var$Qj(4, b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $4d82739dd229d539$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $4d82739dd229d539$var$Rj(b);
                    } catch (k) {
                        $4d82739dd229d539$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $4d82739dd229d539$var$W(b, b.return, k);
        }
        if (b === a) {
            $4d82739dd229d539$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $4d82739dd229d539$var$V = h;
            break;
        }
        $4d82739dd229d539$var$V = b.return;
    }
}
var $4d82739dd229d539$var$lk = Math.ceil, $4d82739dd229d539$var$mk = $4d82739dd229d539$var$ua.ReactCurrentDispatcher, $4d82739dd229d539$var$nk = $4d82739dd229d539$var$ua.ReactCurrentOwner, $4d82739dd229d539$var$ok = $4d82739dd229d539$var$ua.ReactCurrentBatchConfig, $4d82739dd229d539$var$K = 0, $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Y = null, $4d82739dd229d539$var$Z = 0, $4d82739dd229d539$var$fj = 0, $4d82739dd229d539$var$ej = $4d82739dd229d539$var$Uf(0), $4d82739dd229d539$var$T = 0, $4d82739dd229d539$var$pk = null, $4d82739dd229d539$var$rh = 0, $4d82739dd229d539$var$qk = 0, $4d82739dd229d539$var$rk = 0, $4d82739dd229d539$var$sk = null, $4d82739dd229d539$var$tk = null, $4d82739dd229d539$var$fk = 0, $4d82739dd229d539$var$Gj = Infinity, $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Oi = !1, $4d82739dd229d539$var$Pi = null, $4d82739dd229d539$var$Ri = null, $4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = null, $4d82739dd229d539$var$xk = 0, $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, $4d82739dd229d539$var$Ak = -1, $4d82739dd229d539$var$Bk = 0;
function $4d82739dd229d539$var$R() {
    return 0 !== ($4d82739dd229d539$var$K & 6) ? $4d82739dd229d539$var$B() : -1 !== $4d82739dd229d539$var$Ak ? $4d82739dd229d539$var$Ak : $4d82739dd229d539$var$Ak = $4d82739dd229d539$var$B();
}
function $4d82739dd229d539$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($4d82739dd229d539$var$K & 2) && 0 !== $4d82739dd229d539$var$Z) return $4d82739dd229d539$var$Z & -$4d82739dd229d539$var$Z;
    if (null !== $4d82739dd229d539$var$Kg.transition) return 0 === $4d82739dd229d539$var$Bk && ($4d82739dd229d539$var$Bk = $4d82739dd229d539$var$yc()), $4d82739dd229d539$var$Bk;
    a = $4d82739dd229d539$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $4d82739dd229d539$var$jd(a.type);
    return a;
}
function $4d82739dd229d539$var$gi(a, b, c, d) {
    if (50 < $4d82739dd229d539$var$yk) throw $4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = null, Error($4d82739dd229d539$var$p(185));
    $4d82739dd229d539$var$Ac(a, c, d);
    if (0 === ($4d82739dd229d539$var$K & 2) || a !== $4d82739dd229d539$var$Q) a === $4d82739dd229d539$var$Q && (0 === ($4d82739dd229d539$var$K & 2) && ($4d82739dd229d539$var$qk |= c), 4 === $4d82739dd229d539$var$T && $4d82739dd229d539$var$Ck(a, $4d82739dd229d539$var$Z)), $4d82739dd229d539$var$Dk(a, d), 1 === c && 0 === $4d82739dd229d539$var$K && 0 === (b.mode & 1) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
}
function $4d82739dd229d539$var$Dk(a, b) {
    var c = a.callbackNode;
    $4d82739dd229d539$var$wc(a, b);
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) null !== c && $4d82739dd229d539$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $4d82739dd229d539$var$bc(c);
        if (1 === b) 0 === a.tag ? $4d82739dd229d539$var$ig($4d82739dd229d539$var$Ek.bind(null, a)) : $4d82739dd229d539$var$hg($4d82739dd229d539$var$Ek.bind(null, a)), $4d82739dd229d539$var$Jf(function() {
            0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
        }), c = null;
        else {
            switch($4d82739dd229d539$var$Dc(d)){
                case 1:
                    c = $4d82739dd229d539$var$fc;
                    break;
                case 4:
                    c = $4d82739dd229d539$var$gc;
                    break;
                case 16:
                    c = $4d82739dd229d539$var$hc;
                    break;
                case 536870912:
                    c = $4d82739dd229d539$var$jc;
                    break;
                default:
                    c = $4d82739dd229d539$var$hc;
            }
            c = $4d82739dd229d539$var$Fk(c, $4d82739dd229d539$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $4d82739dd229d539$var$Gk(a, b) {
    $4d82739dd229d539$var$Ak = -1;
    $4d82739dd229d539$var$Bk = 0;
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    var c = a.callbackNode;
    if ($4d82739dd229d539$var$Hk() && a.callbackNode !== c) return null;
    var d = $4d82739dd229d539$var$uc(a, a === $4d82739dd229d539$var$Q ? $4d82739dd229d539$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $4d82739dd229d539$var$Ik(a, d);
    else {
        b = d;
        var e = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 2;
        var f = $4d82739dd229d539$var$Jk();
        if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$Kk(a, b);
        for(;;)try {
            $4d82739dd229d539$var$Lk();
            break;
        } catch (h) {
            $4d82739dd229d539$var$Mk(a, h);
        }
        $4d82739dd229d539$var$$g();
        $4d82739dd229d539$var$mk.current = f;
        $4d82739dd229d539$var$K = e;
        null !== $4d82739dd229d539$var$Y ? b = 0 : ($4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0, b = $4d82739dd229d539$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $4d82739dd229d539$var$xc(a), 0 !== e && (d = e, b = $4d82739dd229d539$var$Nk(a, e)));
        if (1 === b) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
        if (6 === b) $4d82739dd229d539$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$4d82739dd229d539$var$Ok(e) && (b = $4d82739dd229d539$var$Ik(a, d), 2 === b && (f = $4d82739dd229d539$var$xc(a), 0 !== f && (d = f, b = $4d82739dd229d539$var$Nk(a, f))), 1 === b)) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, d), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($4d82739dd229d539$var$p(345));
                case 2:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 3:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $4d82739dd229d539$var$fk + 500 - $4d82739dd229d539$var$B(), 10 < b)) {
                        if (0 !== $4d82739dd229d539$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $4d82739dd229d539$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), b);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 4:
                    $4d82739dd229d539$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $4d82739dd229d539$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $4d82739dd229d539$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $4d82739dd229d539$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $4d82739dd229d539$var$Ff($4d82739dd229d539$var$Pk.bind(null, a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk), d);
                        break;
                    }
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                case 5:
                    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
                    break;
                default:
                    throw Error($4d82739dd229d539$var$p(329));
            }
        }
    }
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return a.callbackNode === c ? $4d82739dd229d539$var$Gk.bind(null, a) : null;
}
function $4d82739dd229d539$var$Nk(a, b) {
    var c = $4d82739dd229d539$var$sk;
    a.current.memoizedState.isDehydrated && ($4d82739dd229d539$var$Kk(a, b).flags |= 256);
    a = $4d82739dd229d539$var$Ik(a, b);
    2 !== a && (b = $4d82739dd229d539$var$tk, $4d82739dd229d539$var$tk = c, null !== b && $4d82739dd229d539$var$Fj(b));
    return a;
}
function $4d82739dd229d539$var$Fj(a) {
    null === $4d82739dd229d539$var$tk ? $4d82739dd229d539$var$tk = a : $4d82739dd229d539$var$tk.push.apply($4d82739dd229d539$var$tk, a);
}
function $4d82739dd229d539$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$4d82739dd229d539$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $4d82739dd229d539$var$Ck(a, b) {
    b &= ~$4d82739dd229d539$var$rk;
    b &= ~$4d82739dd229d539$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $4d82739dd229d539$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $4d82739dd229d539$var$Ek(a) {
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$uc(a, 0);
    if (0 === (b & 1)) return $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), null;
    var c = $4d82739dd229d539$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $4d82739dd229d539$var$xc(a);
        0 !== d && (b = d, c = $4d82739dd229d539$var$Nk(a, d));
    }
    if (1 === c) throw c = $4d82739dd229d539$var$pk, $4d82739dd229d539$var$Kk(a, 0), $4d82739dd229d539$var$Ck(a, b), $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B()), c;
    if (6 === c) throw Error($4d82739dd229d539$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $4d82739dd229d539$var$Pk(a, $4d82739dd229d539$var$tk, $4d82739dd229d539$var$uk);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    return null;
}
function $4d82739dd229d539$var$Qk(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    try {
        return a(b);
    } finally{
        $4d82739dd229d539$var$K = c, 0 === $4d82739dd229d539$var$K && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$fg && $4d82739dd229d539$var$jg());
    }
}
function $4d82739dd229d539$var$Rk(a) {
    null !== $4d82739dd229d539$var$wk && 0 === $4d82739dd229d539$var$wk.tag && 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$Hk();
    var b = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 1;
    var c = $4d82739dd229d539$var$ok.transition, d = $4d82739dd229d539$var$C;
    try {
        if ($4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, a) return a();
    } finally{
        $4d82739dd229d539$var$C = d, $4d82739dd229d539$var$ok.transition = c, $4d82739dd229d539$var$K = b, 0 === ($4d82739dd229d539$var$K & 6) && $4d82739dd229d539$var$jg();
    }
}
function $4d82739dd229d539$var$Hj() {
    $4d82739dd229d539$var$fj = $4d82739dd229d539$var$ej.current;
    $4d82739dd229d539$var$E($4d82739dd229d539$var$ej);
}
function $4d82739dd229d539$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $4d82739dd229d539$var$Gf(c));
    if (null !== $4d82739dd229d539$var$Y) for(c = $4d82739dd229d539$var$Y.return; null !== c;){
        var d = c;
        $4d82739dd229d539$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $4d82739dd229d539$var$$f();
                break;
            case 3:
                $4d82739dd229d539$var$zh();
                $4d82739dd229d539$var$E($4d82739dd229d539$var$Wf);
                $4d82739dd229d539$var$E($4d82739dd229d539$var$H);
                $4d82739dd229d539$var$Eh();
                break;
            case 5:
                $4d82739dd229d539$var$Bh(d);
                break;
            case 4:
                $4d82739dd229d539$var$zh();
                break;
            case 13:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 19:
                $4d82739dd229d539$var$E($4d82739dd229d539$var$L);
                break;
            case 10:
                $4d82739dd229d539$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $4d82739dd229d539$var$Hj();
        }
        c = c.return;
    }
    $4d82739dd229d539$var$Q = a;
    $4d82739dd229d539$var$Y = a = $4d82739dd229d539$var$Pg(a.current, null);
    $4d82739dd229d539$var$Z = $4d82739dd229d539$var$fj = b;
    $4d82739dd229d539$var$T = 0;
    $4d82739dd229d539$var$pk = null;
    $4d82739dd229d539$var$rk = $4d82739dd229d539$var$qk = $4d82739dd229d539$var$rh = 0;
    $4d82739dd229d539$var$tk = $4d82739dd229d539$var$sk = null;
    if (null !== $4d82739dd229d539$var$fh) {
        for(b = 0; b < $4d82739dd229d539$var$fh.length; b++)if (c = $4d82739dd229d539$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $4d82739dd229d539$var$fh = null;
    }
    return a;
}
function $4d82739dd229d539$var$Mk(a, b) {
    do {
        var c = $4d82739dd229d539$var$Y;
        try {
            $4d82739dd229d539$var$$g();
            $4d82739dd229d539$var$Fh.current = $4d82739dd229d539$var$Rh;
            if ($4d82739dd229d539$var$Ih) {
                for(var d = $4d82739dd229d539$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $4d82739dd229d539$var$Ih = !1;
            }
            $4d82739dd229d539$var$Hh = 0;
            $4d82739dd229d539$var$O = $4d82739dd229d539$var$N = $4d82739dd229d539$var$M = null;
            $4d82739dd229d539$var$Jh = !1;
            $4d82739dd229d539$var$Kh = 0;
            $4d82739dd229d539$var$nk.current = null;
            if (null === c || null === c.return) {
                $4d82739dd229d539$var$T = 1;
                $4d82739dd229d539$var$pk = b;
                $4d82739dd229d539$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $4d82739dd229d539$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $4d82739dd229d539$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $4d82739dd229d539$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $4d82739dd229d539$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $4d82739dd229d539$var$Si(f, l, b);
                            $4d82739dd229d539$var$tj();
                            break a;
                        }
                        k = Error($4d82739dd229d539$var$p(426));
                    }
                } else if ($4d82739dd229d539$var$I && h.mode & 1) {
                    var J = $4d82739dd229d539$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $4d82739dd229d539$var$Vi(J, g, h, f, b);
                        $4d82739dd229d539$var$Jg($4d82739dd229d539$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $4d82739dd229d539$var$Ji(k, h);
                4 !== $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 2);
                null === $4d82739dd229d539$var$sk ? $4d82739dd229d539$var$sk = [
                    f
                ] : $4d82739dd229d539$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $4d82739dd229d539$var$Ni(f, k, b);
                            $4d82739dd229d539$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $4d82739dd229d539$var$Qi(f, h, b);
                                $4d82739dd229d539$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $4d82739dd229d539$var$Sk(c);
        } catch (na) {
            b = na;
            $4d82739dd229d539$var$Y === c && null !== c && ($4d82739dd229d539$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $4d82739dd229d539$var$Jk() {
    var a = $4d82739dd229d539$var$mk.current;
    $4d82739dd229d539$var$mk.current = $4d82739dd229d539$var$Rh;
    return null === a ? $4d82739dd229d539$var$Rh : a;
}
function $4d82739dd229d539$var$tj() {
    if (0 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T || 2 === $4d82739dd229d539$var$T) $4d82739dd229d539$var$T = 4;
    null === $4d82739dd229d539$var$Q || 0 === ($4d82739dd229d539$var$rh & 268435455) && 0 === ($4d82739dd229d539$var$qk & 268435455) || $4d82739dd229d539$var$Ck($4d82739dd229d539$var$Q, $4d82739dd229d539$var$Z);
}
function $4d82739dd229d539$var$Ik(a, b) {
    var c = $4d82739dd229d539$var$K;
    $4d82739dd229d539$var$K |= 2;
    var d = $4d82739dd229d539$var$Jk();
    if ($4d82739dd229d539$var$Q !== a || $4d82739dd229d539$var$Z !== b) $4d82739dd229d539$var$uk = null, $4d82739dd229d539$var$Kk(a, b);
    for(;;)try {
        $4d82739dd229d539$var$Tk();
        break;
    } catch (e) {
        $4d82739dd229d539$var$Mk(a, e);
    }
    $4d82739dd229d539$var$$g();
    $4d82739dd229d539$var$K = c;
    $4d82739dd229d539$var$mk.current = d;
    if (null !== $4d82739dd229d539$var$Y) throw Error($4d82739dd229d539$var$p(261));
    $4d82739dd229d539$var$Q = null;
    $4d82739dd229d539$var$Z = 0;
    return $4d82739dd229d539$var$T;
}
function $4d82739dd229d539$var$Tk() {
    for(; null !== $4d82739dd229d539$var$Y;)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Lk() {
    for(; null !== $4d82739dd229d539$var$Y && !$4d82739dd229d539$var$cc();)$4d82739dd229d539$var$Uk($4d82739dd229d539$var$Y);
}
function $4d82739dd229d539$var$Uk(a) {
    var b = $4d82739dd229d539$var$Vk(a.alternate, a, $4d82739dd229d539$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $4d82739dd229d539$var$Sk(a) : $4d82739dd229d539$var$Y = b;
    $4d82739dd229d539$var$nk.current = null;
}
function $4d82739dd229d539$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $4d82739dd229d539$var$Ej(c, b, $4d82739dd229d539$var$fj), null !== c) {
                $4d82739dd229d539$var$Y = c;
                return;
            }
        } else {
            c = $4d82739dd229d539$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $4d82739dd229d539$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $4d82739dd229d539$var$T = 6;
                $4d82739dd229d539$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $4d82739dd229d539$var$Y = b;
            return;
        }
        $4d82739dd229d539$var$Y = b = a;
    }while (null !== b);
    0 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$T = 5);
}
function $4d82739dd229d539$var$Pk(a, b, c) {
    var d = $4d82739dd229d539$var$C, e = $4d82739dd229d539$var$ok.transition;
    try {
        $4d82739dd229d539$var$ok.transition = null, $4d82739dd229d539$var$C = 1, $4d82739dd229d539$var$Wk(a, b, c, d);
    } finally{
        $4d82739dd229d539$var$ok.transition = e, $4d82739dd229d539$var$C = d;
    }
    return null;
}
function $4d82739dd229d539$var$Wk(a, b, c, d) {
    do $4d82739dd229d539$var$Hk();
    while (null !== $4d82739dd229d539$var$wk);
    if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($4d82739dd229d539$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $4d82739dd229d539$var$Bc(a, f);
    a === $4d82739dd229d539$var$Q && ($4d82739dd229d539$var$Y = $4d82739dd229d539$var$Q = null, $4d82739dd229d539$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $4d82739dd229d539$var$vk || ($4d82739dd229d539$var$vk = !0, $4d82739dd229d539$var$Fk($4d82739dd229d539$var$hc, function() {
        $4d82739dd229d539$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $4d82739dd229d539$var$ok.transition;
        $4d82739dd229d539$var$ok.transition = null;
        var g = $4d82739dd229d539$var$C;
        $4d82739dd229d539$var$C = 1;
        var h = $4d82739dd229d539$var$K;
        $4d82739dd229d539$var$K |= 4;
        $4d82739dd229d539$var$nk.current = null;
        $4d82739dd229d539$var$Oj(a, c);
        $4d82739dd229d539$var$dk(c, a);
        $4d82739dd229d539$var$Oe($4d82739dd229d539$var$Df);
        $4d82739dd229d539$var$dd = !!$4d82739dd229d539$var$Cf;
        $4d82739dd229d539$var$Df = $4d82739dd229d539$var$Cf = null;
        a.current = c;
        $4d82739dd229d539$var$hk(c, a, e);
        $4d82739dd229d539$var$dc();
        $4d82739dd229d539$var$K = h;
        $4d82739dd229d539$var$C = g;
        $4d82739dd229d539$var$ok.transition = f;
    } else a.current = c;
    $4d82739dd229d539$var$vk && ($4d82739dd229d539$var$vk = !1, $4d82739dd229d539$var$wk = a, $4d82739dd229d539$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($4d82739dd229d539$var$Ri = null);
    $4d82739dd229d539$var$mc(c.stateNode, d);
    $4d82739dd229d539$var$Dk(a, $4d82739dd229d539$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($4d82739dd229d539$var$Oi) throw $4d82739dd229d539$var$Oi = !1, a = $4d82739dd229d539$var$Pi, $4d82739dd229d539$var$Pi = null, a;
    0 !== ($4d82739dd229d539$var$xk & 1) && 0 !== a.tag && $4d82739dd229d539$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $4d82739dd229d539$var$zk ? $4d82739dd229d539$var$yk++ : ($4d82739dd229d539$var$yk = 0, $4d82739dd229d539$var$zk = a) : $4d82739dd229d539$var$yk = 0;
    $4d82739dd229d539$var$jg();
    return null;
}
function $4d82739dd229d539$var$Hk() {
    if (null !== $4d82739dd229d539$var$wk) {
        var a = $4d82739dd229d539$var$Dc($4d82739dd229d539$var$xk), b = $4d82739dd229d539$var$ok.transition, c = $4d82739dd229d539$var$C;
        try {
            $4d82739dd229d539$var$ok.transition = null;
            $4d82739dd229d539$var$C = 16 > a ? 16 : a;
            if (null === $4d82739dd229d539$var$wk) var d = !1;
            else {
                a = $4d82739dd229d539$var$wk;
                $4d82739dd229d539$var$wk = null;
                $4d82739dd229d539$var$xk = 0;
                if (0 !== ($4d82739dd229d539$var$K & 6)) throw Error($4d82739dd229d539$var$p(331));
                var e = $4d82739dd229d539$var$K;
                $4d82739dd229d539$var$K |= 4;
                for($4d82739dd229d539$var$V = a.current; null !== $4d82739dd229d539$var$V;){
                    var f = $4d82739dd229d539$var$V, g = f.child;
                    if (0 !== ($4d82739dd229d539$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($4d82739dd229d539$var$V = l; null !== $4d82739dd229d539$var$V;){
                                    var m = $4d82739dd229d539$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $4d82739dd229d539$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $4d82739dd229d539$var$V = q;
                                    else for(; null !== $4d82739dd229d539$var$V;){
                                        m = $4d82739dd229d539$var$V;
                                        var r = m.sibling, y = m.return;
                                        $4d82739dd229d539$var$Sj(m);
                                        if (m === l) {
                                            $4d82739dd229d539$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $4d82739dd229d539$var$V = r;
                                            break;
                                        }
                                        $4d82739dd229d539$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $4d82739dd229d539$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $4d82739dd229d539$var$V = g;
                    else b: for(; null !== $4d82739dd229d539$var$V;){
                        f = $4d82739dd229d539$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $4d82739dd229d539$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $4d82739dd229d539$var$V = x;
                            break b;
                        }
                        $4d82739dd229d539$var$V = f.return;
                    }
                }
                var w = a.current;
                for($4d82739dd229d539$var$V = w; null !== $4d82739dd229d539$var$V;){
                    g = $4d82739dd229d539$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $4d82739dd229d539$var$V = u;
                    else b: for(g = w; null !== $4d82739dd229d539$var$V;){
                        h = $4d82739dd229d539$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $4d82739dd229d539$var$Qj(9, h);
                            }
                        } catch (na) {
                            $4d82739dd229d539$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $4d82739dd229d539$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $4d82739dd229d539$var$V = F;
                            break b;
                        }
                        $4d82739dd229d539$var$V = h.return;
                    }
                }
                $4d82739dd229d539$var$K = e;
                $4d82739dd229d539$var$jg();
                if ($4d82739dd229d539$var$lc && "function" === typeof $4d82739dd229d539$var$lc.onPostCommitFiberRoot) try {
                    $4d82739dd229d539$var$lc.onPostCommitFiberRoot($4d82739dd229d539$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $4d82739dd229d539$var$C = c, $4d82739dd229d539$var$ok.transition = b;
        }
    }
    return !1;
}
function $4d82739dd229d539$var$Xk(a, b, c) {
    b = $4d82739dd229d539$var$Ji(c, b);
    b = $4d82739dd229d539$var$Ni(a, b, 1);
    a = $4d82739dd229d539$var$nh(a, b, 1);
    b = $4d82739dd229d539$var$R();
    null !== a && ($4d82739dd229d539$var$Ac(a, 1, b), $4d82739dd229d539$var$Dk(a, b));
}
function $4d82739dd229d539$var$W(a, b, c) {
    if (3 === a.tag) $4d82739dd229d539$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $4d82739dd229d539$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $4d82739dd229d539$var$Ri || !$4d82739dd229d539$var$Ri.has(d))) {
                a = $4d82739dd229d539$var$Ji(c, a);
                a = $4d82739dd229d539$var$Qi(b, a, 1);
                b = $4d82739dd229d539$var$nh(b, a, 1);
                a = $4d82739dd229d539$var$R();
                null !== b && ($4d82739dd229d539$var$Ac(b, 1, a), $4d82739dd229d539$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $4d82739dd229d539$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $4d82739dd229d539$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $4d82739dd229d539$var$Q === a && ($4d82739dd229d539$var$Z & c) === c && (4 === $4d82739dd229d539$var$T || 3 === $4d82739dd229d539$var$T && ($4d82739dd229d539$var$Z & 130023424) === $4d82739dd229d539$var$Z && 500 > $4d82739dd229d539$var$B() - $4d82739dd229d539$var$fk ? $4d82739dd229d539$var$Kk(a, 0) : $4d82739dd229d539$var$rk |= c);
    $4d82739dd229d539$var$Dk(a, b);
}
function $4d82739dd229d539$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $4d82739dd229d539$var$sc, $4d82739dd229d539$var$sc <<= 1, 0 === ($4d82739dd229d539$var$sc & 130023424) && ($4d82739dd229d539$var$sc = 4194304)));
    var c = $4d82739dd229d539$var$R();
    a = $4d82739dd229d539$var$ih(a, b);
    null !== a && ($4d82739dd229d539$var$Ac(a, b, c), $4d82739dd229d539$var$Dk(a, c));
}
function $4d82739dd229d539$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $4d82739dd229d539$var$Yk(a, c);
}
function $4d82739dd229d539$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($4d82739dd229d539$var$p(314));
    }
    null !== d && d.delete(b);
    $4d82739dd229d539$var$Yk(a, c);
}
var $4d82739dd229d539$var$Vk;
$4d82739dd229d539$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $4d82739dd229d539$var$Wf.current) $4d82739dd229d539$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$yj(a, b, c);
            $4d82739dd229d539$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $4d82739dd229d539$var$dh = !1, $4d82739dd229d539$var$I && 0 !== (b.flags & 1048576) && $4d82739dd229d539$var$ug(b, $4d82739dd229d539$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $4d82739dd229d539$var$ij(a, b);
            a = b.pendingProps;
            var e = $4d82739dd229d539$var$Yf(b, $4d82739dd229d539$var$H.current);
            $4d82739dd229d539$var$ch(b, c);
            e = $4d82739dd229d539$var$Nh(null, b, d, a, e, c);
            var f = $4d82739dd229d539$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $4d82739dd229d539$var$Zf(d) ? (f = !0, $4d82739dd229d539$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $4d82739dd229d539$var$kh(b), e.updater = $4d82739dd229d539$var$Ei, b.stateNode = e, e._reactInternals = b, $4d82739dd229d539$var$Ii(b, d, a, c), b = $4d82739dd229d539$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $4d82739dd229d539$var$I && f && $4d82739dd229d539$var$vg(b), $4d82739dd229d539$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $4d82739dd229d539$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $4d82739dd229d539$var$Zk(d);
                a = $4d82739dd229d539$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $4d82739dd229d539$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $4d82739dd229d539$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $4d82739dd229d539$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $4d82739dd229d539$var$$i(null, b, d, $4d82739dd229d539$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($4d82739dd229d539$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $4d82739dd229d539$var$kj(b);
                if (null === a) throw Error($4d82739dd229d539$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $4d82739dd229d539$var$lh(a, b);
                $4d82739dd229d539$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(423)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $4d82739dd229d539$var$Ji(Error($4d82739dd229d539$var$p(424)), b);
                        b = $4d82739dd229d539$var$lj(a, b, d, c, e);
                        break a;
                    } else for($4d82739dd229d539$var$yg = $4d82739dd229d539$var$Lf(b.stateNode.containerInfo.firstChild), $4d82739dd229d539$var$xg = b, $4d82739dd229d539$var$I = !0, $4d82739dd229d539$var$zg = null, c = $4d82739dd229d539$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $4d82739dd229d539$var$Ig();
                    if (d === e) {
                        b = $4d82739dd229d539$var$Zi(a, b, c);
                        break a;
                    }
                    $4d82739dd229d539$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $4d82739dd229d539$var$Ah(b), null === a && $4d82739dd229d539$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $4d82739dd229d539$var$Ef(d, e) ? g = null : null !== f && $4d82739dd229d539$var$Ef(d, f) && (b.flags |= 32), $4d82739dd229d539$var$gj(a, b), $4d82739dd229d539$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $4d82739dd229d539$var$Eg(b), null;
        case 13:
            return $4d82739dd229d539$var$oj(a, b, c);
        case 4:
            return $4d82739dd229d539$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $4d82739dd229d539$var$Ug(b, null, d, c) : $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$Yi(a, b, d, e, c);
        case 7:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $4d82739dd229d539$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $4d82739dd229d539$var$G($4d82739dd229d539$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($4d82739dd229d539$var$He(f.value, g)) {
                        if (f.children === e.children && !$4d82739dd229d539$var$Wf.current) {
                            b = $4d82739dd229d539$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $4d82739dd229d539$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $4d82739dd229d539$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($4d82739dd229d539$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $4d82739dd229d539$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $4d82739dd229d539$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $4d82739dd229d539$var$ch(b, c), e = $4d82739dd229d539$var$eh(e), d = d(e), b.flags |= 1, $4d82739dd229d539$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $4d82739dd229d539$var$Ci(d, b.pendingProps), e = $4d82739dd229d539$var$Ci(d.type, e), $4d82739dd229d539$var$$i(a, b, d, e, c);
        case 15:
            return $4d82739dd229d539$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $4d82739dd229d539$var$Ci(d, e), $4d82739dd229d539$var$ij(a, b), b.tag = 1, $4d82739dd229d539$var$Zf(d) ? (a = !0, $4d82739dd229d539$var$cg(b)) : a = !1, $4d82739dd229d539$var$ch(b, c), $4d82739dd229d539$var$Gi(b, d, e), $4d82739dd229d539$var$Ii(b, d, e, c), $4d82739dd229d539$var$jj(null, b, d, !0, a, c);
        case 19:
            return $4d82739dd229d539$var$xj(a, b, c);
        case 22:
            return $4d82739dd229d539$var$dj(a, b, c);
    }
    throw Error($4d82739dd229d539$var$p(156, b.tag));
};
function $4d82739dd229d539$var$Fk(a, b) {
    return $4d82739dd229d539$var$ac(a, b);
}
function $4d82739dd229d539$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $4d82739dd229d539$var$Bg(a, b, c, d) {
    return new $4d82739dd229d539$var$$k(a, b, c, d);
}
function $4d82739dd229d539$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $4d82739dd229d539$var$Zk(a) {
    if ("function" === typeof a) return $4d82739dd229d539$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $4d82739dd229d539$var$Da) return 11;
        if (a === $4d82739dd229d539$var$Ga) return 14;
    }
    return 2;
}
function $4d82739dd229d539$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $4d82739dd229d539$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $4d82739dd229d539$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $4d82739dd229d539$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $4d82739dd229d539$var$ya:
            return $4d82739dd229d539$var$Tg(c.children, e, f, b);
        case $4d82739dd229d539$var$za:
            g = 8;
            e |= 8;
            break;
        case $4d82739dd229d539$var$Aa:
            return a = $4d82739dd229d539$var$Bg(12, c, b, e | 2), a.elementType = $4d82739dd229d539$var$Aa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ea:
            return a = $4d82739dd229d539$var$Bg(13, c, b, e), a.elementType = $4d82739dd229d539$var$Ea, a.lanes = f, a;
        case $4d82739dd229d539$var$Fa:
            return a = $4d82739dd229d539$var$Bg(19, c, b, e), a.elementType = $4d82739dd229d539$var$Fa, a.lanes = f, a;
        case $4d82739dd229d539$var$Ia:
            return $4d82739dd229d539$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $4d82739dd229d539$var$Ba:
                    g = 10;
                    break a;
                case $4d82739dd229d539$var$Ca:
                    g = 9;
                    break a;
                case $4d82739dd229d539$var$Da:
                    g = 11;
                    break a;
                case $4d82739dd229d539$var$Ga:
                    g = 14;
                    break a;
                case $4d82739dd229d539$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($4d82739dd229d539$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $4d82739dd229d539$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $4d82739dd229d539$var$Tg(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$pj(a, b, c, d) {
    a = $4d82739dd229d539$var$Bg(22, a, d, b);
    a.elementType = $4d82739dd229d539$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $4d82739dd229d539$var$Qg(a, b, c) {
    a = $4d82739dd229d539$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $4d82739dd229d539$var$Sg(a, b, c) {
    b = $4d82739dd229d539$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $4d82739dd229d539$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $4d82739dd229d539$var$zc(0);
    this.expirationTimes = $4d82739dd229d539$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $4d82739dd229d539$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $4d82739dd229d539$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $4d82739dd229d539$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $4d82739dd229d539$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $4d82739dd229d539$var$kh(f);
    return a;
}
function $4d82739dd229d539$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4d82739dd229d539$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $4d82739dd229d539$var$dl(a) {
    if (!a) return $4d82739dd229d539$var$Vf;
    a = a._reactInternals;
    a: {
        if ($4d82739dd229d539$var$Vb(a) !== a || 1 !== a.tag) throw Error($4d82739dd229d539$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($4d82739dd229d539$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($4d82739dd229d539$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($4d82739dd229d539$var$Zf(c)) return $4d82739dd229d539$var$bg(a, c, b);
    }
    return b;
}
function $4d82739dd229d539$var$el(a, b, c, d, e, f, g, h, k) {
    a = $4d82739dd229d539$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $4d82739dd229d539$var$dl(null);
    c = a.current;
    d = $4d82739dd229d539$var$R();
    e = $4d82739dd229d539$var$yi(c);
    f = $4d82739dd229d539$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $4d82739dd229d539$var$nh(c, f, e);
    a.current.lanes = e;
    $4d82739dd229d539$var$Ac(a, e, d);
    $4d82739dd229d539$var$Dk(a, d);
    return a;
}
function $4d82739dd229d539$var$fl(a, b, c, d) {
    var e = b.current, f = $4d82739dd229d539$var$R(), g = $4d82739dd229d539$var$yi(e);
    c = $4d82739dd229d539$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $4d82739dd229d539$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $4d82739dd229d539$var$nh(e, b, g);
    null !== a && ($4d82739dd229d539$var$gi(a, e, g, f), $4d82739dd229d539$var$oh(a, e, g));
    return g;
}
function $4d82739dd229d539$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $4d82739dd229d539$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $4d82739dd229d539$var$il(a, b) {
    $4d82739dd229d539$var$hl(a, b);
    (a = a.alternate) && $4d82739dd229d539$var$hl(a, b);
}
function $4d82739dd229d539$var$jl() {
    return null;
}
var $4d82739dd229d539$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $4d82739dd229d539$var$ll(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.render = $4d82739dd229d539$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($4d82739dd229d539$var$p(409));
    $4d82739dd229d539$var$fl(a, b, null, null);
};
$4d82739dd229d539$var$ml.prototype.unmount = $4d82739dd229d539$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $4d82739dd229d539$var$Rk(function() {
            $4d82739dd229d539$var$fl(null, a, null, null);
        });
        b[$4d82739dd229d539$var$uf] = null;
    }
};
function $4d82739dd229d539$var$ml(a) {
    this._internalRoot = a;
}
$4d82739dd229d539$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $4d82739dd229d539$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $4d82739dd229d539$var$Qc.length && 0 !== b && b < $4d82739dd229d539$var$Qc[c].priority; c++);
        $4d82739dd229d539$var$Qc.splice(c, 0, a);
        0 === c && $4d82739dd229d539$var$Vc(a);
    }
};
function $4d82739dd229d539$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $4d82739dd229d539$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $4d82739dd229d539$var$pl() {}
function $4d82739dd229d539$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $4d82739dd229d539$var$gl(g);
                f.call(a);
            };
        }
        var g = $4d82739dd229d539$var$el(b, d, a, 0, null, !1, !1, "", $4d82739dd229d539$var$pl);
        a._reactRootContainer = g;
        a[$4d82739dd229d539$var$uf] = g.current;
        $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
        $4d82739dd229d539$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $4d82739dd229d539$var$gl(k);
            h.call(a);
        };
    }
    var k = $4d82739dd229d539$var$bl(a, 0, !1, null, null, !1, !1, "", $4d82739dd229d539$var$pl);
    a._reactRootContainer = k;
    a[$4d82739dd229d539$var$uf] = k.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    $4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$fl(b, k, c, d);
    });
    return k;
}
function $4d82739dd229d539$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $4d82739dd229d539$var$gl(g);
                h.call(a);
            };
        }
        $4d82739dd229d539$var$fl(b, g, a, e);
    } else g = $4d82739dd229d539$var$ql(c, b, a, e, d);
    return $4d82739dd229d539$var$gl(g);
}
$4d82739dd229d539$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $4d82739dd229d539$var$tc(b.pendingLanes);
                0 !== c && ($4d82739dd229d539$var$Cc(b, c | 1), $4d82739dd229d539$var$Dk(b, $4d82739dd229d539$var$B()), 0 === ($4d82739dd229d539$var$K & 6) && ($4d82739dd229d539$var$Gj = $4d82739dd229d539$var$B() + 500, $4d82739dd229d539$var$jg()));
            }
            break;
        case 13:
            $4d82739dd229d539$var$Rk(function() {
                var b = $4d82739dd229d539$var$ih(a, 1);
                if (null !== b) {
                    var c = $4d82739dd229d539$var$R();
                    $4d82739dd229d539$var$gi(b, a, 1, c);
                }
            }), $4d82739dd229d539$var$il(a, 1);
    }
};
$4d82739dd229d539$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$ih(a, 134217728);
        if (null !== b) {
            var c = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(b, a, 134217728, c);
        }
        $4d82739dd229d539$var$il(a, 134217728);
    }
};
$4d82739dd229d539$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $4d82739dd229d539$var$yi(a), c = $4d82739dd229d539$var$ih(a, b);
        if (null !== c) {
            var d = $4d82739dd229d539$var$R();
            $4d82739dd229d539$var$gi(c, a, b, d);
        }
        $4d82739dd229d539$var$il(a, b);
    }
};
$4d82739dd229d539$var$Hc = function() {
    return $4d82739dd229d539$var$C;
};
$4d82739dd229d539$var$Ic = function(a, b) {
    var c = $4d82739dd229d539$var$C;
    try {
        return $4d82739dd229d539$var$C = a, b();
    } finally{
        $4d82739dd229d539$var$C = c;
    }
};
$4d82739dd229d539$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $4d82739dd229d539$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $4d82739dd229d539$var$Db(d);
                        if (!e) throw Error($4d82739dd229d539$var$p(90));
                        $4d82739dd229d539$var$Wa(d);
                        $4d82739dd229d539$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $4d82739dd229d539$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $4d82739dd229d539$var$fb(a, !!c.multiple, b, !1);
    }
};
$4d82739dd229d539$var$Gb = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$var$Hb = $4d82739dd229d539$var$Rk;
var $4d82739dd229d539$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $4d82739dd229d539$var$Cb,
        $4d82739dd229d539$var$ue,
        $4d82739dd229d539$var$Db,
        $4d82739dd229d539$var$Eb,
        $4d82739dd229d539$var$Fb,
        $4d82739dd229d539$var$Qk
    ]
}, $4d82739dd229d539$var$tl = {
    findFiberByHostInstance: $4d82739dd229d539$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $4d82739dd229d539$var$ul = {
    bundleType: $4d82739dd229d539$var$tl.bundleType,
    version: $4d82739dd229d539$var$tl.version,
    rendererPackageName: $4d82739dd229d539$var$tl.rendererPackageName,
    rendererConfig: $4d82739dd229d539$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $4d82739dd229d539$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $4d82739dd229d539$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $4d82739dd229d539$var$tl.findFiberByHostInstance || $4d82739dd229d539$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $4d82739dd229d539$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$4d82739dd229d539$var$vl.isDisabled && $4d82739dd229d539$var$vl.supportsFiber) try {
        $4d82739dd229d539$var$kc = $4d82739dd229d539$var$vl.inject($4d82739dd229d539$var$ul), $4d82739dd229d539$var$lc = $4d82739dd229d539$var$vl;
    } catch (a) {}
}
$4d82739dd229d539$export$ae55be85d98224ed = $4d82739dd229d539$var$sl;
$4d82739dd229d539$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$4d82739dd229d539$var$nl(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$cl(a, b, null, c);
};
$4d82739dd229d539$export$882461b6382ed46c = function(a, b) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(299));
    var c = !1, d = "", e = $4d82739dd229d539$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $4d82739dd229d539$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $4d82739dd229d539$var$ll(b);
};
$4d82739dd229d539$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($4d82739dd229d539$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($4d82739dd229d539$var$p(268, a));
    }
    a = $4d82739dd229d539$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$4d82739dd229d539$export$cd75ccfd720a3cd4 = function(a) {
    return $4d82739dd229d539$var$Rk(a);
};
$4d82739dd229d539$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !0, c);
};
$4d82739dd229d539$export$757ceba2d55c277e = function(a, b, c) {
    if (!$4d82739dd229d539$var$nl(a)) throw Error($4d82739dd229d539$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $4d82739dd229d539$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $4d82739dd229d539$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$4d82739dd229d539$var$uf] = b.current;
    $4d82739dd229d539$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $4d82739dd229d539$var$ml(b);
};
$4d82739dd229d539$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$4d82739dd229d539$var$ol(b)) throw Error($4d82739dd229d539$var$p(200));
    return $4d82739dd229d539$var$rl(null, a, b, !1, c);
};
$4d82739dd229d539$export$502457920280e6be = function(a) {
    if (!$4d82739dd229d539$var$ol(a)) throw Error($4d82739dd229d539$var$p(40));
    return a._reactRootContainer ? ($4d82739dd229d539$var$Rk(function() {
        $4d82739dd229d539$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$4d82739dd229d539$var$uf] = null;
        });
    }), !0) : !1;
};
$4d82739dd229d539$export$c78a37762a8d58e1 = $4d82739dd229d539$var$Qk;
$4d82739dd229d539$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$4d82739dd229d539$var$ol(c)) throw Error($4d82739dd229d539$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($4d82739dd229d539$var$p(38));
    return $4d82739dd229d539$var$rl(a, b, c, !1, d);
};
$4d82739dd229d539$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("33s19", function(module, exports) {
'use strict';

module.exports = (parcelRequire("a0C75"));

});
parcelRegister("a0C75", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $749777fefd570b40$export$c4744153514ff05d; }, function (v) { return $749777fefd570b40$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $749777fefd570b40$export$3e506c1ccc9cc1a7; }, function (v) { return $749777fefd570b40$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $749777fefd570b40$export$e26fe2ed2fa76875; }, function (v) { return $749777fefd570b40$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $749777fefd570b40$export$502329bbf4b505b1; }, function (v) { return $749777fefd570b40$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $749777fefd570b40$export$6e3807111c4874c4; }, function (v) { return $749777fefd570b40$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $749777fefd570b40$export$c27134553091fb3a; }, function (v) { return $749777fefd570b40$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $749777fefd570b40$export$33ee1acdc04fd2a2; }, function (v) { return $749777fefd570b40$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $749777fefd570b40$export$b00a404bbd5edef2; }, function (v) { return $749777fefd570b40$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $749777fefd570b40$export$8352ce38b91d0c62; }, function (v) { return $749777fefd570b40$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $749777fefd570b40$export$d66a1c1c77bd778b; }, function (v) { return $749777fefd570b40$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $749777fefd570b40$export$d3dfb8e4810cb555; }, function (v) { return $749777fefd570b40$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $749777fefd570b40$export$839f9183b0465a69; }, function (v) { return $749777fefd570b40$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $749777fefd570b40$export$72fdf0e06517287b; }, function (v) { return $749777fefd570b40$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $749777fefd570b40$export$4b844e58a3e414b4; }, function (v) { return $749777fefd570b40$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $749777fefd570b40$export$816d2913ae6b83b1; }, function (v) { return $749777fefd570b40$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $749777fefd570b40$export$61bcfe829111a1d0; }, function (v) { return $749777fefd570b40$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $749777fefd570b40$export$7ee8c9beb337bc3f; }, function (v) { return $749777fefd570b40$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $749777fefd570b40$export$b5836b71941fa3ed; }, function (v) { return $749777fefd570b40$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $749777fefd570b40$export$cf845f2c119da08a; }, function (v) { return $749777fefd570b40$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $749777fefd570b40$export$c4744153514ff05d;
var $749777fefd570b40$export$3e506c1ccc9cc1a7;
var $749777fefd570b40$export$e26fe2ed2fa76875;
var $749777fefd570b40$export$502329bbf4b505b1;
var $749777fefd570b40$export$6e3807111c4874c4;
var $749777fefd570b40$export$c27134553091fb3a;
var $749777fefd570b40$export$33ee1acdc04fd2a2;
var $749777fefd570b40$export$b00a404bbd5edef2;
var $749777fefd570b40$export$8352ce38b91d0c62;
var $749777fefd570b40$export$d66a1c1c77bd778b;
var $749777fefd570b40$export$d3dfb8e4810cb555;
var $749777fefd570b40$export$839f9183b0465a69;
var $749777fefd570b40$export$72fdf0e06517287b;
var $749777fefd570b40$export$4b844e58a3e414b4;
var $749777fefd570b40$export$816d2913ae6b83b1;
var $749777fefd570b40$export$61bcfe829111a1d0;
var $749777fefd570b40$export$7ee8c9beb337bc3f;
var $749777fefd570b40$export$b5836b71941fa3ed;
var $749777fefd570b40$export$cf845f2c119da08a;
'use strict';
function $749777fefd570b40$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $749777fefd570b40$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $749777fefd570b40$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $749777fefd570b40$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $749777fefd570b40$var$g(C, c)) n < e && 0 > $749777fefd570b40$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $749777fefd570b40$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $749777fefd570b40$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $749777fefd570b40$var$l = performance;
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$l.now();
    };
} else {
    var $749777fefd570b40$var$p = Date, $749777fefd570b40$var$q = $749777fefd570b40$var$p.now();
    $749777fefd570b40$export$c4744153514ff05d = function() {
        return $749777fefd570b40$var$p.now() - $749777fefd570b40$var$q;
    };
}
var $749777fefd570b40$var$r = [], $749777fefd570b40$var$t = [], $749777fefd570b40$var$u = 1, $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = 3, $749777fefd570b40$var$z = !1, $749777fefd570b40$var$A = !1, $749777fefd570b40$var$B = !1, $749777fefd570b40$var$D = "function" === typeof setTimeout ? setTimeout : null, $749777fefd570b40$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $749777fefd570b40$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $749777fefd570b40$var$G(a) {
    for(var b = $749777fefd570b40$var$h($749777fefd570b40$var$t); null !== b;){
        if (null === b.callback) $749777fefd570b40$var$k($749777fefd570b40$var$t);
        else if (b.startTime <= a) $749777fefd570b40$var$k($749777fefd570b40$var$t), b.sortIndex = b.expirationTime, $749777fefd570b40$var$f($749777fefd570b40$var$r, b);
        else break;
        b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
    }
}
function $749777fefd570b40$var$H(a) {
    $749777fefd570b40$var$B = !1;
    $749777fefd570b40$var$G(a);
    if (!$749777fefd570b40$var$A) {
        if (null !== $749777fefd570b40$var$h($749777fefd570b40$var$r)) $749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J);
        else {
            var b = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== b && $749777fefd570b40$var$K($749777fefd570b40$var$H, b.startTime - a);
        }
    }
}
function $749777fefd570b40$var$J(a, b) {
    $749777fefd570b40$var$A = !1;
    $749777fefd570b40$var$B && ($749777fefd570b40$var$B = !1, $749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1);
    $749777fefd570b40$var$z = !0;
    var c = $749777fefd570b40$var$y;
    try {
        $749777fefd570b40$var$G(b);
        for($749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r); null !== $749777fefd570b40$var$v && (!($749777fefd570b40$var$v.expirationTime > b) || a && !$749777fefd570b40$var$M());){
            var d = $749777fefd570b40$var$v.callback;
            if ("function" === typeof d) {
                $749777fefd570b40$var$v.callback = null;
                $749777fefd570b40$var$y = $749777fefd570b40$var$v.priorityLevel;
                var e = d($749777fefd570b40$var$v.expirationTime <= b);
                b = $749777fefd570b40$export$c4744153514ff05d();
                "function" === typeof e ? $749777fefd570b40$var$v.callback = e : $749777fefd570b40$var$v === $749777fefd570b40$var$h($749777fefd570b40$var$r) && $749777fefd570b40$var$k($749777fefd570b40$var$r);
                $749777fefd570b40$var$G(b);
            } else $749777fefd570b40$var$k($749777fefd570b40$var$r);
            $749777fefd570b40$var$v = $749777fefd570b40$var$h($749777fefd570b40$var$r);
        }
        if (null !== $749777fefd570b40$var$v) var w = !0;
        else {
            var m = $749777fefd570b40$var$h($749777fefd570b40$var$t);
            null !== m && $749777fefd570b40$var$K($749777fefd570b40$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $749777fefd570b40$var$v = null, $749777fefd570b40$var$y = c, $749777fefd570b40$var$z = !1;
    }
}
var $749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null, $749777fefd570b40$var$L = -1, $749777fefd570b40$var$P = 5, $749777fefd570b40$var$Q = -1;
function $749777fefd570b40$var$M() {
    return $749777fefd570b40$export$c4744153514ff05d() - $749777fefd570b40$var$Q < $749777fefd570b40$var$P ? !1 : !0;
}
function $749777fefd570b40$var$R() {
    if (null !== $749777fefd570b40$var$O) {
        var a = $749777fefd570b40$export$c4744153514ff05d();
        $749777fefd570b40$var$Q = a;
        var b = !0;
        try {
            b = $749777fefd570b40$var$O(!0, a);
        } finally{
            b ? $749777fefd570b40$var$S() : ($749777fefd570b40$var$N = !1, $749777fefd570b40$var$O = null);
        }
    } else $749777fefd570b40$var$N = !1;
}
var $749777fefd570b40$var$S;
if ("function" === typeof $749777fefd570b40$var$F) $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$F($749777fefd570b40$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $749777fefd570b40$var$T = new MessageChannel, $749777fefd570b40$var$U = $749777fefd570b40$var$T.port2;
    $749777fefd570b40$var$T.port1.onmessage = $749777fefd570b40$var$R;
    $749777fefd570b40$var$S = function() {
        $749777fefd570b40$var$U.postMessage(null);
    };
} else $749777fefd570b40$var$S = function() {
    $749777fefd570b40$var$D($749777fefd570b40$var$R, 0);
};
function $749777fefd570b40$var$I(a) {
    $749777fefd570b40$var$O = a;
    $749777fefd570b40$var$N || ($749777fefd570b40$var$N = !0, $749777fefd570b40$var$S());
}
function $749777fefd570b40$var$K(a, b) {
    $749777fefd570b40$var$L = $749777fefd570b40$var$D(function() {
        a($749777fefd570b40$export$c4744153514ff05d());
    }, b);
}
$749777fefd570b40$export$3e506c1ccc9cc1a7 = 5;
$749777fefd570b40$export$e26fe2ed2fa76875 = 1;
$749777fefd570b40$export$502329bbf4b505b1 = 4;
$749777fefd570b40$export$6e3807111c4874c4 = 3;
$749777fefd570b40$export$c27134553091fb3a = null;
$749777fefd570b40$export$33ee1acdc04fd2a2 = 2;
$749777fefd570b40$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$749777fefd570b40$export$8352ce38b91d0c62 = function() {
    $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J));
};
$749777fefd570b40$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $749777fefd570b40$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$749777fefd570b40$export$d3dfb8e4810cb555 = function() {
    return $749777fefd570b40$var$y;
};
$749777fefd570b40$export$839f9183b0465a69 = function() {
    return $749777fefd570b40$var$h($749777fefd570b40$var$r);
};
$749777fefd570b40$export$72fdf0e06517287b = function(a) {
    switch($749777fefd570b40$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $749777fefd570b40$var$y;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = b;
    try {
        return a();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$4b844e58a3e414b4 = function() {};
$749777fefd570b40$export$816d2913ae6b83b1 = function() {};
$749777fefd570b40$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $749777fefd570b40$var$y;
    $749777fefd570b40$var$y = a;
    try {
        return b();
    } finally{
        $749777fefd570b40$var$y = c;
    }
};
$749777fefd570b40$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $749777fefd570b40$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $749777fefd570b40$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $749777fefd570b40$var$f($749777fefd570b40$var$t, a), null === $749777fefd570b40$var$h($749777fefd570b40$var$r) && a === $749777fefd570b40$var$h($749777fefd570b40$var$t) && ($749777fefd570b40$var$B ? ($749777fefd570b40$var$E($749777fefd570b40$var$L), $749777fefd570b40$var$L = -1) : $749777fefd570b40$var$B = !0, $749777fefd570b40$var$K($749777fefd570b40$var$H, c - d))) : (a.sortIndex = e, $749777fefd570b40$var$f($749777fefd570b40$var$r, a), $749777fefd570b40$var$A || $749777fefd570b40$var$z || ($749777fefd570b40$var$A = !0, $749777fefd570b40$var$I($749777fefd570b40$var$J)));
    return a;
};
$749777fefd570b40$export$b5836b71941fa3ed = $749777fefd570b40$var$M;
$749777fefd570b40$export$cf845f2c119da08a = function(a) {
    var b = $749777fefd570b40$var$y;
    return function() {
        var c = $749777fefd570b40$var$y;
        $749777fefd570b40$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $749777fefd570b40$var$y = c;
        }
    };
};

});



parcelRegister("lzq3r", function(module, exports) {

module.exports = (parcelRequire("1iyJ7"))($parcel$resolve("kPsoI")).then(()=>parcelRequire('3GJ3v'));

});
parcelRegister("1iyJ7", function(module, exports) {
"use strict";

var $e0V30 = parcelRequire("e0V30");
module.exports = $e0V30(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Add a global function to handle when the script loads.
        var globalName = "i".concat(('' + Math.random()).slice(2));
        $parcel$global[globalName] = function(m) {
            resolve(m);
            cleanup();
        };
        // Remove script on load or error
        var cleanup = function() {
            delete $parcel$global[globalName];
            script.onerror = null;
            script.remove();
        };
        // Append an inline script tag into the document head
        var script = document.createElement('script');
        script.async = true;
        script.type = 'module';
        script.charset = 'utf-8';
        script.textContent = "import * as m from '".concat(bundle, "'; ").concat(globalName, "(m);");
        script.onerror = function(e) {
            reject(e);
            cleanup();
        };
        document.head.appendChild(script);
    });
});

});
parcelRegister("e0V30", function(module, exports) {
"use strict";
var $a33d51355b1da95d$var$cachedBundles = {};
var $a33d51355b1da95d$var$cachedPreloads = {};
var $a33d51355b1da95d$var$cachedPrefetches = {};
function $a33d51355b1da95d$var$getCache(type) {
    switch(type){
        case 'preload':
            return $a33d51355b1da95d$var$cachedPreloads;
        case 'prefetch':
            return $a33d51355b1da95d$var$cachedPrefetches;
        default:
            return $a33d51355b1da95d$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $a33d51355b1da95d$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("2Bwgd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return instance; });
$parcel$export(module.exports, "createInstance", function () { return createInstance; });
$parcel$export(module.exports, "dir", function () { return dir; });
$parcel$export(module.exports, "init", function () { return init; });
$parcel$export(module.exports, "loadResources", function () { return loadResources; });
$parcel$export(module.exports, "reloadResources", function () { return reloadResources; });
$parcel$export(module.exports, "use", function () { return use; });
$parcel$export(module.exports, "changeLanguage", function () { return changeLanguage; });
$parcel$export(module.exports, "getFixedT", function () { return getFixedT; });
$parcel$export(module.exports, "t", function () { return t; });
$parcel$export(module.exports, "exists", function () { return exists; });
$parcel$export(module.exports, "setDefaultNamespace", function () { return setDefaultNamespace; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return hasLoadedNamespace; });
$parcel$export(module.exports, "loadNamespaces", function () { return loadNamespaces; });
$parcel$export(module.exports, "loadLanguages", function () { return loadLanguages; });

var $6TO5S = parcelRequire("6TO5S");

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $3zeAJ = parcelRequire("3zeAJ");

var $73CuG = parcelRequire("73CuG");

var $91d37 = parcelRequire("91d37");

var $fv7Xh = parcelRequire("fv7Xh");

var $dQMrF = parcelRequire("dQMrF");

var $4LIBW = parcelRequire("4LIBW");
function ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var consoleLogger = {
    type: 'logger',
    log: function log(args) {
        this.output('log', args);
    },
    warn: function warn(args) {
        this.output('warn', args);
    },
    error: function error(args) {
        this.output('error', args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $03dWn.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $4OFm0.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || 'i18next:';
                this.logger = concreteLogger || consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, 'log', '', true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, 'warn', '', true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, 'error', '');
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, _objectSpread$6(_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var baseLogger = new Logger();
var EventEmitter = function() {
    function EventEmitter() {
        (0, $03dWn.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $4OFm0.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(' ').forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers['*']) {
                    var _cloned = [].concat(this.observers['*']);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function makeString(object) {
    if (object == null) return '';
    return '' + object;
}
function copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === 'string';
    }
    var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function setPath(object, path, newValue) {
    var _getLastOfPath = getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
    var _getLastOfPath3 = getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
    var value = getPath(data, key);
    if (value !== undefined) return value;
    return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== '__proto__' && prop !== 'constructor') {
        if (prop in target) {
            if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;',
    '/': '&#x2F;'
};
function escape(data) {
    if (typeof data === 'string') return data.replace(/[&<>"'\/]/g, function(s) {
        return _entityMap[s];
    });
    return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && typeof window.navigator.userAgentData === 'undefined' && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;
var chars = [
    ' ',
    ',',
    '?',
    '!',
    ';'
];
function looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || '';
    keySeparator = keySeparator || '';
    var possibleChars = chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === '?' ? '\\?' : c;
    }).join('|'), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === 'string' && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === 'string') return mix;
                if (p && typeof mix[p] === 'string') return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$3(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $fv7Xh.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $fv7Xh.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $91d37.default)(this, result);
    };
}
function _isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var ResourceStore = function(_EventEmitter) {
    (0, $73CuG.default)(ResourceStore, _EventEmitter);
    var _super = _createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                'translation'
            ],
            defaultNS: 'translation'
        };
        (0, $03dWn.default)(this, ResourceStore);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3zeAJ.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $4OFm0.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== 'string') path = path.concat(key);
                if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) path = lng.split('.');
                var result = getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== 'string') return result;
                return deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                setPath(this.data, path, value);
                if (!options.silent) this.emit('added', lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf('.') > -1) {
                    path = lng.split('.');
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = getPath(this.data, path) || {};
                if (deep) deepExtend(pack, resources, overwrite);
                else pack = _objectSpread$5(_objectSpread$5({}, pack), resources);
                setPath(this.data, path, pack);
                if (!options.silent) this.emit('added', lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit('removed', lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === 'v1') return _objectSpread$5(_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}(EventEmitter);
var postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$2(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $fv7Xh.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $fv7Xh.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $91d37.default)(this, result);
    };
}
function _isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var checkedLoadedFor = {};
var Translator = function(_EventEmitter) {
    (0, $73CuG.default)(Translator, _EventEmitter);
    var _super = _createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $03dWn.default)(this, Translator);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3zeAJ.default)(_this));
        copy([
            'resourceStore',
            'languageUtils',
            'pluralResolver',
            'interpolator',
            'backendConnector',
            'i18nFormat',
            'utils'
        ], services, (0, $3zeAJ.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = '.';
        _this.logger = baseLogger.create('translator');
        return _this;
    }
    (0, $4OFm0.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ':';
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $6TO5S.default)(options) !== 'object' && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if ((0, $6TO5S.default)(options) === 'object') options = _objectSpread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return '';
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === 'cimode') {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace
                    };
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    '[object Number]',
                    '[object Function]',
                    '[object RegExp]'
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn('accessing an object - but returnObjects options is not enabled!');
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, _objectSpread$4(_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === '[object Array]';
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, _objectSpread$4(_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : '';
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, _objectSpread$4(_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === 'all') lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit('missingKey', l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== 'v1') res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init(_objectSpread$4(_objectSpread$4({}, options), {
                        interpolation: _objectSpread$4(_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === 'string' && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = _objectSpread$4(_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && this.options.compatibilityAPI !== 'v1' && resolved && resolved.res) options.lng = resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === 'string' ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === 'string') keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === 'string' || typeof options.context === 'number') && options.context !== '';
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = 'defaultValue';
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}(EventEmitter);
function capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $03dWn.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = baseLogger.create('languageUtils');
    }
    (0, $4OFm0.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return null;
                var p = code.split('-');
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === 'x') return null;
                return this.formatLanguageCode(p.join('-'));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf('-') < 0) return code;
                var p = code.split('-');
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    var specialCases = [
                        'hans',
                        'hant',
                        'latn',
                        'cyrl',
                        'cans',
                        'mong',
                        'arab'
                    ];
                    var p = code.split('-');
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
                    }
                    return p.join('-');
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return supportedLng;
                        if (supportedLng.indexOf('-') < 0 && lngOnly.indexOf('-') < 0) return;
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
                if (typeof fallbacks === 'string') fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === 'string' && code.indexOf('-') > -1) {
                    if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
                    if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === 'string') addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var sets = [
    {
        lngs: [
            'ach',
            'ak',
            'am',
            'arn',
            'br',
            'fil',
            'gun',
            'ln',
            'mfe',
            'mg',
            'mi',
            'oc',
            'pt',
            'pt-BR',
            'tg',
            'tl',
            'ti',
            'tr',
            'uz',
            'wa'
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            'af',
            'an',
            'ast',
            'az',
            'bg',
            'bn',
            'ca',
            'da',
            'de',
            'dev',
            'el',
            'en',
            'eo',
            'es',
            'et',
            'eu',
            'fi',
            'fo',
            'fur',
            'fy',
            'gl',
            'gu',
            'ha',
            'hi',
            'hu',
            'hy',
            'ia',
            'it',
            'kk',
            'kn',
            'ku',
            'lb',
            'mai',
            'ml',
            'mn',
            'mr',
            'nah',
            'nap',
            'nb',
            'ne',
            'nl',
            'nn',
            'no',
            'nso',
            'pa',
            'pap',
            'pms',
            'ps',
            'pt-PT',
            'rm',
            'sco',
            'se',
            'si',
            'so',
            'son',
            'sq',
            'sv',
            'sw',
            'ta',
            'te',
            'tk',
            'ur',
            'yo'
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            'ay',
            'bo',
            'cgg',
            'fa',
            'ht',
            'id',
            'ja',
            'jbo',
            'ka',
            'km',
            'ko',
            'ky',
            'lo',
            'ms',
            'sah',
            'su',
            'th',
            'tt',
            'ug',
            'vi',
            'wo',
            'zh'
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            'be',
            'bs',
            'cnr',
            'dz',
            'hr',
            'ru',
            'sr',
            'uk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            'ar'
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            'cs',
            'sk'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            'csb',
            'pl'
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            'cy'
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            'fr'
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            'ga'
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            'gd'
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            'is'
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            'jv'
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            'kw'
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            'lt'
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            'lv'
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            'mk'
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            'mnk'
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            'mt'
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            'or'
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            'ro'
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            'sl'
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            'he',
            'iw'
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var _rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var deprecatedJsonVersions = [
    'v1',
    'v2',
    'v3'
];
var suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function createRules() {
    var rules = {};
    sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: _rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $03dWn.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = baseLogger.create('pluralResolver');
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === 'v4') && (typeof Intl === 'undefined' || !Intl.PluralRules)) {
            this.options.compatibilityJSON = 'v3';
            this.logger.error('Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.');
        }
        this.rules = createRules();
    }
    (0, $4OFm0.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? 'ordinal' : 'cardinal'
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return suffixesOrder[pluralCategory1] - suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return '';
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = 'plural';
                    else if (suffix === 1) suffix = '';
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === 'v1') {
                    if (suffix === 1) return '';
                    if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === 'v2') return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '.';
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === 'string') {
        path = deepFind(data, key, keySeparator);
        if (path === undefined) path = deepFind(defaultData, key, keySeparator);
    }
    return path;
}
var Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $03dWn.default)(this, Interpolator);
        this.logger = baseLogger.create('interpolator');
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $4OFm0.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
                this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
                this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
                this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
                this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
                this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, 'g');
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, '$$$$');
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format(deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, _objectSpread$3(_objectSpread$3(_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === 'function') {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === 'string' ? temp : '';
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = '';
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = '';
                            }
                        } else if (typeof value !== 'string' && !_this.useRawValueToEscape) value = makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = _objectSpread$3(_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = _objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== 'string' ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== 'string') return value;
                    if (typeof value !== 'string') value = makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = '';
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, _objectSpread$3(_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf('(') > -1) {
        var p = formatStr.split('(');
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === 'currency' && optStr.indexOf(':') < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === 'relativetime' && optStr.indexOf(':') < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(';');
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(':'), _opt$split2 = (0, $4LIBW.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(':').trim().replace(/^'+|'+$/g, '');
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === 'false') formatOptions[key.trim()] = false;
                if (val === 'true') formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $03dWn.default)(this, Formatter);
        this.logger = baseLogger.create('formatter');
        this.options = options;
        this.formats = {
            number: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, _objectSpread$2(_objectSpread$2({}, opt), {}, {
                    style: 'currency'
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || 'day');
                };
            }),
            list: createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, _objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $4OFm0.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, _objectSpread$2(_objectSpread$2(_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper$1(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $fv7Xh.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $fv7Xh.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $91d37.default)(this, result);
    };
}
function _isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var Connector = function(_EventEmitter) {
    (0, $73CuG.default)(Connector, _EventEmitter);
    var _super = _createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $03dWn.default)(this, Connector);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3zeAJ.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = baseLogger.create('backendConnector');
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $4OFm0.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit('failedLoading', lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    pushPath(q.loaded, [
                        lng
                    ], ns);
                    removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit('loaded', loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === 'function') r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn('No backend was added via i18next.use. Will not load resources.');
                    return callback && callback();
                }
                if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === 'string') namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
                var s = name.split('|');
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, 'read', undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
                    return;
                }
                if (key === undefined || key === null || key === '') return;
                if (this.backend && this.backend.create) {
                    var opts = _objectSpread$1(_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === 'function') r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}(EventEmitter);
function get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            'translation'
        ],
        defaultNS: [
            'translation'
        ],
        fallbackLng: [
            'dev'
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: 'all',
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: '.',
        nsSeparator: ':',
        pluralSeparator: '_',
        contextSeparator: '_',
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: 'fallback',
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $6TO5S.default)(args[1]) === 'object') ret = args[1];
            if (typeof args[1] === 'string') ret.defaultValue = args[1];
            if (typeof args[2] === 'string') ret.tDescription = args[2];
            if ((0, $6TO5S.default)(args[2]) === 'object' || (0, $6TO5S.default)(args[3]) === 'object') {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: '{{',
            suffix: '}}',
            formatSeparator: ',',
            unescapePrefix: '-',
            nestingPrefix: '$t(',
            nestingSuffix: ')',
            nestingOptionsSeparator: ',',
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function transformOptions(options) {
    if (typeof options.ns === 'string') options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === 'string') options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === 'string') options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) options.supportedLngs = options.supportedLngs.concat([
        'cimode'
    ]);
    return options;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), !0).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $fv7Xh.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $fv7Xh.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $91d37.default)(this, result);
    };
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function noop() {}
function bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === 'function') inst[mem] = inst[mem].bind(inst);
    });
}
var I18n = function(_EventEmitter) {
    (0, $73CuG.default)(I18n, _EventEmitter);
    var _super = _createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $03dWn.default)(this, I18n);
        _this = _super.call(this);
        if (isIE10) EventEmitter.call((0, $3zeAJ.default)(_this));
        _this.options = transformOptions(options);
        _this.services = {};
        _this.logger = baseLogger;
        _this.modules = {
            external: []
        };
        bindMemberFunctions((0, $3zeAJ.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $91d37.default)(_this, (0, $3zeAJ.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $4OFm0.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === 'string') options.defaultNS = options.ns;
                    else if (options.ns.indexOf('translation') < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = get();
                this.options = _objectSpread(_objectSpread(_objectSpread({}, defOpts), this.options), transformOptions(options));
                if (this.options.compatibilityAPI !== 'v1') this.options.interpolation = _objectSpread(_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === 'function') return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== 'undefined') formatter = Formatter;
                    var lu = new LanguageUtil(this.options);
                    this.store = new ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on('*', function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new Translator(this.services, this.options);
                    this.translator.on('*', function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn('init: no languageDetector is used and no lng is defined');
                var storeApi = [
                    'getResource',
                    'hasResourceBundle',
                    'getResourceBundle',
                    'getDataByLanguage'
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    'addResource',
                    'addResources',
                    'addResourceBundle',
                    'removeResourceBundle'
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);
                        _this2.emit('initialized', _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var usedCallback = callback;
                var usedLng = typeof language === 'string' ? language : this.language;
                if (typeof language === 'function') usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
                if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');
                if (module.type === 'backend') this.modules.backend = module;
                if (module.type === 'logger' || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === 'languageDetector') this.modules.languageDetector = module;
                if (module.type === 'i18nFormat') this.modules.i18nFormat = module;
                if (module.type === 'postProcessor') postProcessor.addPostProcessor(module);
                if (module.type === 'formatter') this.modules.formatter = module;
                if (module.type === '3rdParty') this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    'cimode',
                    'dev'
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        'cimode',
                        'dev'
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = defer();
                this.emit('languageChanging', lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit('languageChanged', l);
                        _this4.logger.log('languageChanged', l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $6TO5S.default)(opts) !== 'object') {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = _objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || '.';
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === 'string') fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
                    return false;
                }
                var lng = options.lng || this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === 'cimode') return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (typeof ns === 'string') ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = defer();
                if (typeof lngs === 'string') lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return 'rtl';
                var rtlLngs = [
                    'ar',
                    'shu',
                    'sqr',
                    'ssh',
                    'xaa',
                    'yhd',
                    'yud',
                    'aao',
                    'abh',
                    'abv',
                    'acm',
                    'acq',
                    'acw',
                    'acx',
                    'acy',
                    'adf',
                    'ads',
                    'aeb',
                    'aec',
                    'afb',
                    'ajp',
                    'apc',
                    'apd',
                    'arb',
                    'arq',
                    'ars',
                    'ary',
                    'arz',
                    'auz',
                    'avl',
                    'ayh',
                    'ayl',
                    'ayn',
                    'ayp',
                    'bbz',
                    'pga',
                    'he',
                    'iw',
                    'ps',
                    'pbt',
                    'pbu',
                    'pst',
                    'prp',
                    'prd',
                    'ug',
                    'ur',
                    'ydd',
                    'yds',
                    'yih',
                    'ji',
                    'yi',
                    'hbo',
                    'men',
                    'xmn',
                    'fa',
                    'jpr',
                    'peo',
                    'pes',
                    'prs',
                    'dv',
                    'sam',
                    'ckb'
                ];
                var languageUtils = this.services && this.services.languageUtils || new LanguageUtil(get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf('-arab') > 1 ? 'rtl' : 'ltr';
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;
                var mergedOptions = _objectSpread(_objectSpread(_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    'store',
                    'services',
                    'language'
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = _objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new Translator(clone.services, clone.options);
                clone.translator.on('*', function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}(EventEmitter);
(0, $dQMrF.default)(I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new I18n(options, callback);
});
var instance = I18n.createInstance();
instance.createInstance = I18n.createInstance;
var createInstance = instance.createInstance;
var dir = instance.dir;
var init = instance.init;
var loadResources = instance.loadResources;
var reloadResources = instance.reloadResources;
var use = instance.use;
var changeLanguage = instance.changeLanguage;
var getFixedT = instance.getFixedT;
var t = instance.t;
var exists = instance.exists;
var setDefaultNamespace = instance.setDefaultNamespace;
var hasLoadedNamespace = instance.hasLoadedNamespace;
var loadNamespaces = instance.loadNamespaces;
var loadLanguages = instance.loadLanguages;

});
parcelRegister("6TO5S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $505ebcb184373782$export$2e2bcd8739ae039; });
function $505ebcb184373782$export$2e2bcd8739ae039(o) {
    "@babel/helpers - typeof";
    return $505ebcb184373782$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $505ebcb184373782$export$2e2bcd8739ae039(o);
}

});

parcelRegister("03dWn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $009b183922525d46$export$2e2bcd8739ae039; });
function $009b183922525d46$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("4OFm0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $381be8fad7784fe9$export$2e2bcd8739ae039; });

var $aYCSV = parcelRequire("aYCSV");
function $381be8fad7784fe9$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aYCSV.default)(o.key), o);
    }
}
function $381be8fad7784fe9$export$2e2bcd8739ae039(e, r, t) {
    return r && $381be8fad7784fe9$var$_defineProperties(e.prototype, r), t && $381be8fad7784fe9$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});
parcelRegister("aYCSV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7fddabb4b045308c$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");

var $3qCmf = parcelRequire("3qCmf");
function $7fddabb4b045308c$export$2e2bcd8739ae039(t) {
    var i = (0, $3qCmf.default)(t, "string");
    return "symbol" == (0, $6TO5S.default)(i) ? i : i + "";
}

});
parcelRegister("3qCmf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27f18dd8fc16da3b$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");
function $27f18dd8fc16da3b$export$2e2bcd8739ae039(t, r) {
    if ("object" != (0, $6TO5S.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, $6TO5S.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

});



parcelRegister("3zeAJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $298ff58efa174465$export$2e2bcd8739ae039; });
function $298ff58efa174465$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

});

parcelRegister("73CuG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5236ac5195402c05$export$2e2bcd8739ae039; });

var $iJeDO = parcelRequire("iJeDO");
function $5236ac5195402c05$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $iJeDO.default)(t, e);
}

});
parcelRegister("iJeDO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da27c96857818bcc$export$2e2bcd8739ae039; });
function $da27c96857818bcc$export$2e2bcd8739ae039(t, e) {
    return $da27c96857818bcc$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $da27c96857818bcc$export$2e2bcd8739ae039(t, e);
}

});


parcelRegister("91d37", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $690e545d5a200a90$export$2e2bcd8739ae039; });

var $6TO5S = parcelRequire("6TO5S");

var $3zeAJ = parcelRequire("3zeAJ");
function $690e545d5a200a90$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $6TO5S.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3zeAJ.default)(t);
}

});

parcelRegister("fv7Xh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b48febf76cf3d138$export$2e2bcd8739ae039; });
function $b48febf76cf3d138$export$2e2bcd8739ae039(t) {
    return $b48febf76cf3d138$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $b48febf76cf3d138$export$2e2bcd8739ae039(t);
}

});

parcelRegister("dQMrF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a155b5e75cfe9a4d$export$2e2bcd8739ae039; });

var $aYCSV = parcelRequire("aYCSV");
function $a155b5e75cfe9a4d$export$2e2bcd8739ae039(e, r, t) {
    return (r = (0, $aYCSV.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

});

parcelRegister("4LIBW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $378e28034d64ade8$export$2e2bcd8739ae039; });

var $a2azi = parcelRequire("a2azi");

var $1DcFf = parcelRequire("1DcFf");

var $6A22e = parcelRequire("6A22e");

var $bM4Gu = parcelRequire("bM4Gu");
function $378e28034d64ade8$export$2e2bcd8739ae039(r) {
    return (0, $a2azi.default)(r) || (0, $1DcFf.default)(r) || (0, $6A22e.default)(r) || (0, $bM4Gu.default)();
}

});
parcelRegister("a2azi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74e249f0a1430824$export$2e2bcd8739ae039; });
function $74e249f0a1430824$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("1DcFf", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $130341d5473c4bb5$export$2e2bcd8739ae039; });
function $130341d5473c4bb5$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("6A22e", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4ca7aef5b7b26ccf$export$2e2bcd8739ae039; });

var $9A91F = parcelRequire("9A91F");
function $4ca7aef5b7b26ccf$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $9A91F.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $9A91F.default)(r, a) : void 0;
    }
}

});
parcelRegister("9A91F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6f9e7a38a1550ef5$export$2e2bcd8739ae039; });
function $6f9e7a38a1550ef5$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("bM4Gu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8927cf96e9e7e6b4$export$2e2bcd8739ae039; });
function $8927cf96e9e7e6b4$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("a04va", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6zjya = parcelRequire("6zjya");

var $8PZpp = parcelRequire("8PZpp");

var $5f6d7 = parcelRequire("5f6d7");

var $9X39E = parcelRequire("9X39E");
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */ function $747d656b899e6115$var$createInstance(defaultConfig) {
    var context = new $8PZpp(defaultConfig);
    var instance = $6zjya($8PZpp.prototype.request, context);
    // Copy axios.prototype to instance
    $adReO.extend(instance, $8PZpp.prototype, context);
    // Copy context to instance
    $adReO.extend(instance, context);
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $747d656b899e6115$var$createInstance($5f6d7(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
var $747d656b899e6115$var$axios = $747d656b899e6115$var$createInstance($9X39E);
// Expose Axios class to allow class inheritance
$747d656b899e6115$var$axios.Axios = $8PZpp;

// Expose Cancel & CancelToken
$747d656b899e6115$var$axios.Cancel = (parcelRequire("2W85d"));

$747d656b899e6115$var$axios.CancelToken = (parcelRequire("kZZD0"));

$747d656b899e6115$var$axios.isCancel = (parcelRequire("4IsRW"));

$747d656b899e6115$var$axios.VERSION = (parcelRequire("cR4ZD")).version;
// Expose all/spread
$747d656b899e6115$var$axios.all = function all(promises) {
    return Promise.all(promises);
};

$747d656b899e6115$var$axios.spread = (parcelRequire("b676K"));

// Expose isAxiosError
$747d656b899e6115$var$axios.isAxiosError = (parcelRequire("kgiwQ"));
module.exports = $747d656b899e6115$var$axios;
// Allow use of default import syntax in TypeScript
module.exports.default = $747d656b899e6115$var$axios;

});
parcelRegister("adReO", function(module, exports) {
'use strict';

var $6zjya = parcelRequire("6zjya");
// utils is a library of generic helper functions non-specific to axios
var $77146a31cb578292$var$toString = Object.prototype.toString;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */ function $77146a31cb578292$var$isArray(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Array]';
}
/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */ function $77146a31cb578292$var$isUndefined(val) {
    return typeof val === 'undefined';
}
/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $77146a31cb578292$var$isBuffer(val) {
    return val !== null && !$77146a31cb578292$var$isUndefined(val) && val.constructor !== null && !$77146a31cb578292$var$isUndefined(val.constructor) && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBuffer(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object ArrayBuffer]';
}
/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */ function $77146a31cb578292$var$isFormData(val) {
    return typeof FormData !== 'undefined' && val instanceof FormData;
}
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $77146a31cb578292$var$isArrayBufferView(val) {
    var result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && val.buffer instanceof ArrayBuffer;
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */ function $77146a31cb578292$var$isString(val) {
    return typeof val === 'string';
}
/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */ function $77146a31cb578292$var$isNumber(val) {
    return typeof val === 'number';
}
/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */ function $77146a31cb578292$var$isObject(val) {
    return val !== null && typeof val === 'object';
}
/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */ function $77146a31cb578292$var$isPlainObject(val) {
    if ($77146a31cb578292$var$toString.call(val) !== '[object Object]') return false;
    var prototype = Object.getPrototypeOf(val);
    return prototype === null || prototype === Object.prototype;
}
/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */ function $77146a31cb578292$var$isDate(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Date]';
}
/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */ function $77146a31cb578292$var$isFile(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object File]';
}
/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */ function $77146a31cb578292$var$isBlob(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Blob]';
}
/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ function $77146a31cb578292$var$isFunction(val) {
    return $77146a31cb578292$var$toString.call(val) === '[object Function]';
}
/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */ function $77146a31cb578292$var$isStream(val) {
    return $77146a31cb578292$var$isObject(val) && $77146a31cb578292$var$isFunction(val.pipe);
}
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ function $77146a31cb578292$var$isURLSearchParams(val) {
    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */ function $77146a31cb578292$var$trim(str) {
    return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */ function $77146a31cb578292$var$isStandardBrowserEnv() {
    if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' || navigator.product === 'NativeScript' || navigator.product === 'NS')) return false;
    return typeof window !== 'undefined' && typeof document !== 'undefined';
}
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */ function $77146a31cb578292$var$forEach(obj, fn) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($77146a31cb578292$var$isArray(obj)) // Iterate over array values
    for(var i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) fn.call(null, obj[key], key, obj);
    }
}
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */ function $77146a31cb578292$var$merge() {
    var result = {};
    function assignValue(val, key) {
        if ($77146a31cb578292$var$isPlainObject(result[key]) && $77146a31cb578292$var$isPlainObject(val)) result[key] = $77146a31cb578292$var$merge(result[key], val);
        else if ($77146a31cb578292$var$isPlainObject(val)) result[key] = $77146a31cb578292$var$merge({}, val);
        else if ($77146a31cb578292$var$isArray(val)) result[key] = val.slice();
        else result[key] = val;
    }
    for(var i = 0, l = arguments.length; i < l; i++)$77146a31cb578292$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */ function $77146a31cb578292$var$extend(a, b, thisArg) {
    $77146a31cb578292$var$forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === 'function') a[key] = $6zjya(val, thisArg);
        else a[key] = val;
    });
    return a;
}
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */ function $77146a31cb578292$var$stripBOM(content) {
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
}
module.exports = {
    isArray: $77146a31cb578292$var$isArray,
    isArrayBuffer: $77146a31cb578292$var$isArrayBuffer,
    isBuffer: $77146a31cb578292$var$isBuffer,
    isFormData: $77146a31cb578292$var$isFormData,
    isArrayBufferView: $77146a31cb578292$var$isArrayBufferView,
    isString: $77146a31cb578292$var$isString,
    isNumber: $77146a31cb578292$var$isNumber,
    isObject: $77146a31cb578292$var$isObject,
    isPlainObject: $77146a31cb578292$var$isPlainObject,
    isUndefined: $77146a31cb578292$var$isUndefined,
    isDate: $77146a31cb578292$var$isDate,
    isFile: $77146a31cb578292$var$isFile,
    isBlob: $77146a31cb578292$var$isBlob,
    isFunction: $77146a31cb578292$var$isFunction,
    isStream: $77146a31cb578292$var$isStream,
    isURLSearchParams: $77146a31cb578292$var$isURLSearchParams,
    isStandardBrowserEnv: $77146a31cb578292$var$isStandardBrowserEnv,
    forEach: $77146a31cb578292$var$forEach,
    merge: $77146a31cb578292$var$merge,
    extend: $77146a31cb578292$var$extend,
    trim: $77146a31cb578292$var$trim,
    stripBOM: $77146a31cb578292$var$stripBOM
};

});
parcelRegister("6zjya", function(module, exports) {
'use strict';
module.exports = function bind(fn, thisArg) {
    return function wrap() {
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        return fn.apply(thisArg, args);
    };
};

});


parcelRegister("8PZpp", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $6nvAH = parcelRequire("6nvAH");

var $khPLX = parcelRequire("khPLX");

var $eystn = parcelRequire("eystn");

var $5f6d7 = parcelRequire("5f6d7");

var $2iR5D = parcelRequire("2iR5D");
var $66f2b8a41463d1e8$var$validators = $2iR5D.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */ function $66f2b8a41463d1e8$var$Axios(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
        request: new $khPLX(),
        response: new $khPLX()
    };
}
/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */ $66f2b8a41463d1e8$var$Axios.prototype.request = function request(config) {
    /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
    if (typeof config === 'string') {
        config = arguments[1] || {};
        config.url = arguments[0];
    } else config = config || {};
    config = $5f6d7(this.defaults, config);
    // Set config.method
    if (config.method) config.method = config.method.toLowerCase();
    else if (this.defaults.method) config.method = this.defaults.method.toLowerCase();
    else config.method = 'get';
    var transitional = config.transitional;
    if (transitional !== undefined) $2iR5D.assertOptions(transitional, {
        silentJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
        forcedJSONParsing: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean),
        clarifyTimeoutError: $66f2b8a41463d1e8$var$validators.transitional($66f2b8a41463d1e8$var$validators.boolean)
    }, false);
    // filter out skipped interceptors
    var requestInterceptorChain = [];
    var synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    var responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    var promise;
    if (!synchronousRequestInterceptors) {
        var chain = [
            $eystn,
            undefined
        ];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while(chain.length)promise = promise.then(chain.shift(), chain.shift());
        return promise;
    }
    var newConfig = config;
    while(requestInterceptorChain.length){
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
            newConfig = onFulfilled(newConfig);
        } catch (error) {
            onRejected(error);
            break;
        }
    }
    try {
        promise = $eystn(newConfig);
    } catch (error) {
        return Promise.reject(error);
    }
    while(responseInterceptorChain.length)promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
    return promise;
};
$66f2b8a41463d1e8$var$Axios.prototype.getUri = function getUri(config) {
    config = $5f6d7(this.defaults, config);
    return $6nvAH(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};
// Provide aliases for supported request methods
$adReO.forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, config) {
        return this.request($5f6d7(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ $66f2b8a41463d1e8$var$Axios.prototype[method] = function(url, data, config) {
        return this.request($5f6d7(config || {}, {
            method: method,
            url: url,
            data: data
        }));
    };
});
module.exports = $66f2b8a41463d1e8$var$Axios;

});
parcelRegister("6nvAH", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $4a4d655613ae826e$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
}
/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */ module.exports = function buildURL(url, params, paramsSerializer) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    var serializedParams;
    if (paramsSerializer) serializedParams = paramsSerializer(params);
    else if ($adReO.isURLSearchParams(params)) serializedParams = params.toString();
    else {
        var parts = [];
        $adReO.forEach(params, function serialize(val, key) {
            if (val === null || typeof val === 'undefined') return;
            if ($adReO.isArray(val)) key = key + '[]';
            else val = [
                val
            ];
            $adReO.forEach(val, function parseValue(v) {
                if ($adReO.isDate(v)) v = v.toISOString();
                else if ($adReO.isObject(v)) v = JSON.stringify(v);
                parts.push($4a4d655613ae826e$var$encode(key) + '=' + $4a4d655613ae826e$var$encode(v));
            });
        });
        serializedParams = parts.join('&');
    }
    if (serializedParams) {
        var hashmarkIndex = url.indexOf('#');
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
};

});

parcelRegister("khPLX", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
function $ec4d8e24b0699790$var$InterceptorManager() {
    this.handlers = [];
}
/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
    this.handlers.push({
        fulfilled: fulfilled,
        rejected: rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
};
/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.eject = function eject(id) {
    if (this.handlers[id]) this.handlers[id] = null;
};
/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */ $ec4d8e24b0699790$var$InterceptorManager.prototype.forEach = function forEach(fn) {
    $adReO.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) fn(h);
    });
};
module.exports = $ec4d8e24b0699790$var$InterceptorManager;

});

parcelRegister("eystn", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $15ANS = parcelRequire("15ANS");

var $4IsRW = parcelRequire("4IsRW");

var $9X39E = parcelRequire("9X39E");

var $2W85d = parcelRequire("2W85d");
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ function $a98a53c8a75f9db0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new $2W85d('canceled');
}
/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */ module.exports = function dispatchRequest(config) {
    $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
    // Ensure headers exist
    config.headers = config.headers || {};
    // Transform request data
    config.data = $15ANS.call(config, config.data, config.headers, config.transformRequest);
    // Flatten headers
    config.headers = $adReO.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers);
    $adReO.forEach([
        'delete',
        'get',
        'head',
        'post',
        'put',
        'patch',
        'common'
    ], function cleanHeaderConfig(method) {
        delete config.headers[method];
    });
    var adapter = config.adapter || $9X39E.adapter;
    return adapter(config).then(function onAdapterResolution(response) {
        $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = $15ANS.call(config, response.data, response.headers, config.transformResponse);
        return response;
    }, function onAdapterRejection(reason) {
        if (!$4IsRW(reason)) {
            $a98a53c8a75f9db0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) reason.response.data = $15ANS.call(config, reason.response.data, reason.response.headers, config.transformResponse);
        }
        return Promise.reject(reason);
    });
};

});
parcelRegister("15ANS", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $9X39E = parcelRequire("9X39E");
/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */ module.exports = function transformData(data, headers, fns) {
    var context = this || $9X39E;
    /*eslint no-param-reassign:0*/ $adReO.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
    });
    return data;
};

});
parcelRegister("9X39E", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $9y7wC = parcelRequire("9y7wC");

var $3leq5 = parcelRequire("3leq5");
var $73ec122cfcba4842$var$DEFAULT_CONTENT_TYPE = {
    'Content-Type': 'application/x-www-form-urlencoded'
};
function $73ec122cfcba4842$var$setContentTypeIfUnset(headers, value) {
    if (!$adReO.isUndefined(headers) && $adReO.isUndefined(headers['Content-Type'])) headers['Content-Type'] = value;
}

function $73ec122cfcba4842$var$getDefaultAdapter() {
    var adapter;
    if (typeof XMLHttpRequest !== 'undefined') // For browsers use XHR adapter
    adapter = (parcelRequire("3PMHb"));
    return adapter;
}
function $73ec122cfcba4842$var$stringifySafely(rawValue, parser, encoder) {
    if ($adReO.isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return $adReO.trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
var $73ec122cfcba4842$var$defaults = {
    transitional: {
        silentJSONParsing: true,
        forcedJSONParsing: true,
        clarifyTimeoutError: false
    },
    adapter: $73ec122cfcba4842$var$getDefaultAdapter(),
    transformRequest: [
        function transformRequest(data, headers) {
            $9y7wC(headers, 'Accept');
            $9y7wC(headers, 'Content-Type');
            if ($adReO.isFormData(data) || $adReO.isArrayBuffer(data) || $adReO.isBuffer(data) || $adReO.isStream(data) || $adReO.isFile(data) || $adReO.isBlob(data)) return data;
            if ($adReO.isArrayBufferView(data)) return data.buffer;
            if ($adReO.isURLSearchParams(data)) {
                $73ec122cfcba4842$var$setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
                return data.toString();
            }
            if ($adReO.isObject(data) || headers && headers['Content-Type'] === 'application/json') {
                $73ec122cfcba4842$var$setContentTypeIfUnset(headers, 'application/json');
                return $73ec122cfcba4842$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            var transitional = this.transitional || $73ec122cfcba4842$var$defaults.transitional;
            var silentJSONParsing = transitional && transitional.silentJSONParsing;
            var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';
            if (strictJSONParsing || forcedJSONParsing && $adReO.isString(data) && data.length) try {
                return JSON.parse(data);
            } catch (e) {
                if (strictJSONParsing) {
                    if (e.name === 'SyntaxError') throw $3leq5(e, this, 'E_JSON_PARSE');
                    throw e;
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*'
        }
    }
};
$adReO.forEach([
    'delete',
    'get',
    'head'
], function forEachMethodNoData(method) {
    $73ec122cfcba4842$var$defaults.headers[method] = {};
});
$adReO.forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    $73ec122cfcba4842$var$defaults.headers[method] = $adReO.merge($73ec122cfcba4842$var$DEFAULT_CONTENT_TYPE);
});
module.exports = $73ec122cfcba4842$var$defaults;

});
parcelRegister("9y7wC", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = function normalizeHeaderName(headers, normalizedName) {
    $adReO.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
            headers[normalizedName] = value;
            delete headers[name];
        }
    });
};

});

parcelRegister("3leq5", function(module, exports) {
'use strict';
/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */ module.exports = function enhanceError(error, config, code, request, response) {
    error.config = config;
    if (code) error.code = code;
    error.request = request;
    error.response = response;
    error.isAxiosError = true;
    error.toJSON = function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: this.config,
            code: this.code,
            status: this.response && this.response.status ? this.response.status : null
        };
    };
    return error;
};

});

parcelRegister("3PMHb", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");

var $3PfpF = parcelRequire("3PfpF");

var $79n0f = parcelRequire("79n0f");

var $6nvAH = parcelRequire("6nvAH");

var $40T1q = parcelRequire("40T1q");

var $hMzvi = parcelRequire("hMzvi");

var $besJL = parcelRequire("besJL");

var $hHo9F = parcelRequire("hHo9F");

var $9X39E = parcelRequire("9X39E");

var $2W85d = parcelRequire("2W85d");
module.exports = function xhrAdapter(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
            if (config.cancelToken) config.cancelToken.unsubscribe(onCanceled);
            if (config.signal) config.signal.removeEventListener('abort', onCanceled);
        }
        if ($adReO.isFormData(requestData)) delete requestHeaders['Content-Type']; // Let the browser set it
        var request = new XMLHttpRequest();
        // HTTP basic authentication
        if (config.auth) {
            var username = config.auth.username || '';
            var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
            requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
        }
        var fullPath = $40T1q(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), $6nvAH(fullPath, config.params, config.paramsSerializer), true);
        // Set the request timeout in MS
        request.timeout = config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            var responseHeaders = 'getAllResponseHeaders' in request ? $hMzvi(request.getAllResponseHeaders()) : null;
            var responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            var response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            $3PfpF(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject($hHo9F('Request aborted', config, 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject($hHo9F('Network Error', config, null, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
            var transitional = config.transitional || $9X39E.transitional;
            if (config.timeoutErrorMessage) timeoutErrorMessage = config.timeoutErrorMessage;
            reject($hHo9F(timeoutErrorMessage, config, transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED', request));
            // Clean up request
            request = null;
        };
        // Add xsrf header
        // This is only done if running in a standard browser environment.
        // Specifically not if we're in a web worker, or react-native.
        if ($adReO.isStandardBrowserEnv()) {
            // Add xsrf header
            var xsrfValue = (config.withCredentials || $besJL(fullPath)) && config.xsrfCookieName ? $79n0f.read(config.xsrfCookieName) : undefined;
            if (xsrfValue) requestHeaders[config.xsrfHeaderName] = xsrfValue;
        }
        // Add headers to the request
        if ('setRequestHeader' in request) $adReO.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') // Remove Content-Type if data is undefined
            delete requestHeaders[key];
            else // Otherwise add header to the request
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!$adReO.isUndefined(config.withCredentials)) request.withCredentials = !!config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = config.responseType;
        // Handle progress if needed
        if (typeof config.onDownloadProgress === 'function') request.addEventListener('progress', config.onDownloadProgress);
        // Not all browsers support upload events
        if (typeof config.onUploadProgress === 'function' && request.upload) request.upload.addEventListener('progress', config.onUploadProgress);
        if (config.cancelToken || config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = function(cancel) {
                if (!request) return;
                reject(!cancel || cancel && cancel.type ? new $2W85d('canceled') : cancel);
                request.abort();
                request = null;
            };
            config.cancelToken && config.cancelToken.subscribe(onCanceled);
            if (config.signal) config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
        }
        if (!requestData) requestData = null;
        // Send the request
        request.send(requestData);
    });
};

});
parcelRegister("3PfpF", function(module, exports) {
'use strict';

var $hHo9F = parcelRequire("hHo9F");
/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */ module.exports = function settle(resolve, reject, response) {
    var validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject($hHo9F('Request failed with status code ' + response.status, response.config, null, response.request, response));
};

});
parcelRegister("hHo9F", function(module, exports) {
'use strict';

var $3leq5 = parcelRequire("3leq5");
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */ module.exports = function createError(message, config, code, request, response) {
    var error = new Error(message);
    return $3leq5(error, config, code, request, response);
};

});


parcelRegister("79n0f", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs support document.cookie
function standardBrowserEnv() {
    return {
        write: function write(name, value, expires, path, domain, secure) {
            var cookie = [];
            cookie.push(name + '=' + encodeURIComponent(value));
            if ($adReO.isNumber(expires)) cookie.push('expires=' + new Date(expires).toGMTString());
            if ($adReO.isString(path)) cookie.push('path=' + path);
            if ($adReO.isString(domain)) cookie.push('domain=' + domain);
            if (secure === true) cookie.push('secure');
            document.cookie = cookie.join('; ');
        },
        read: function read(name) {
            var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
            return match ? decodeURIComponent(match[3]) : null;
        },
        remove: function remove(name) {
            this.write(name, '', Date.now() - 86400000);
        }
    };
}() : // Non standard browser env (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return {
        write: function write() {},
        read: function read() {
            return null;
        },
        remove: function remove() {}
    };
}();

});

parcelRegister("40T1q", function(module, exports) {
'use strict';

var $1yk63 = parcelRequire("1yk63");

var $l45Ly = parcelRequire("l45Ly");
/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */ module.exports = function buildFullPath(baseURL, requestedURL) {
    if (baseURL && !$1yk63(requestedURL)) return $l45Ly(baseURL, requestedURL);
    return requestedURL;
};

});
parcelRegister("1yk63", function(module, exports) {
'use strict';
/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */ module.exports = function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};

});

parcelRegister("l45Ly", function(module, exports) {
'use strict';
/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */ module.exports = function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
};

});


parcelRegister("hMzvi", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var $cf2275aca40d6d88$var$ignoreDuplicateOf = [
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
];
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */ module.exports = function parseHeaders(headers) {
    var parsed = {};
    var key;
    var val;
    var i;
    if (!headers) return parsed;
    $adReO.forEach(headers.split('\n'), function parser(line) {
        i = line.indexOf(':');
        key = $adReO.trim(line.substr(0, i)).toLowerCase();
        val = $adReO.trim(line.substr(i + 1));
        if (key) {
            if (parsed[key] && $cf2275aca40d6d88$var$ignoreDuplicateOf.indexOf(key) >= 0) return;
            if (key === 'set-cookie') parsed[key] = (parsed[key] ? parsed[key] : []).concat([
                val
            ]);
            else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
        }
    });
    return parsed;
};

});

parcelRegister("besJL", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
module.exports = $adReO.isStandardBrowserEnv() ? // Standard browser envs have full support of the APIs needed to test
// whether the request URL is of the same origin as current location.
function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;
    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */ function resolveURL(url) {
        var href = url;
        if (msie) {
            // IE needs attribute set twice to normalize properties
            urlParsingNode.setAttribute('href', href);
            href = urlParsingNode.href;
        }
        urlParsingNode.setAttribute('href', href);
        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
        };
    }
    originURL = resolveURL(window.location.href);
    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */ return function isURLSameOrigin(requestURL) {
        var parsed = $adReO.isString(requestURL) ? resolveURL(requestURL) : requestURL;
        return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
    };
}() : // Non standard browser envs (web workers, react-native) lack needed support.
function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
        return true;
    };
}();

});

parcelRegister("2W85d", function(module, exports) {
'use strict';
/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */ function $223744b24e5d0b4c$var$Cancel(message) {
    this.message = message;
}
$223744b24e5d0b4c$var$Cancel.prototype.toString = function toString() {
    return 'Cancel' + (this.message ? ': ' + this.message : '');
};
$223744b24e5d0b4c$var$Cancel.prototype.__CANCEL__ = true;
module.exports = $223744b24e5d0b4c$var$Cancel;

});




parcelRegister("4IsRW", function(module, exports) {
'use strict';
module.exports = function isCancel(value) {
    return !!(value && value.__CANCEL__);
};

});


parcelRegister("5f6d7", function(module, exports) {
'use strict';

var $adReO = parcelRequire("adReO");
/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */ module.exports = function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    var config = {};
    function getMergedValue(target, source) {
        if ($adReO.isPlainObject(target) && $adReO.isPlainObject(source)) return $adReO.merge(target, source);
        else if ($adReO.isPlainObject(source)) return $adReO.merge({}, source);
        else if ($adReO.isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(config1[prop], config2[prop]);
        else if (!$adReO.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(prop) {
        if (!$adReO.isUndefined(config2[prop])) return getMergedValue(undefined, config2[prop]);
        else if (!$adReO.isUndefined(config1[prop])) return getMergedValue(undefined, config1[prop]);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(prop) {
        if (prop in config2) return getMergedValue(config1[prop], config2[prop]);
        else if (prop in config1) return getMergedValue(undefined, config1[prop]);
    }
    var mergeMap = {
        'url': valueFromConfig2,
        'method': valueFromConfig2,
        'data': valueFromConfig2,
        'baseURL': defaultToConfig2,
        'transformRequest': defaultToConfig2,
        'transformResponse': defaultToConfig2,
        'paramsSerializer': defaultToConfig2,
        'timeout': defaultToConfig2,
        'timeoutMessage': defaultToConfig2,
        'withCredentials': defaultToConfig2,
        'adapter': defaultToConfig2,
        'responseType': defaultToConfig2,
        'xsrfCookieName': defaultToConfig2,
        'xsrfHeaderName': defaultToConfig2,
        'onUploadProgress': defaultToConfig2,
        'onDownloadProgress': defaultToConfig2,
        'decompress': defaultToConfig2,
        'maxContentLength': defaultToConfig2,
        'maxBodyLength': defaultToConfig2,
        'transport': defaultToConfig2,
        'httpAgent': defaultToConfig2,
        'httpsAgent': defaultToConfig2,
        'cancelToken': defaultToConfig2,
        'socketPath': defaultToConfig2,
        'responseEncoding': defaultToConfig2,
        'validateStatus': mergeDirectKeys
    };
    $adReO.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge(prop);
        $adReO.isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
};

});

parcelRegister("2iR5D", function(module, exports) {
'use strict';

var $cR4ZD = parcelRequire("cR4ZD");
var $1ad671c27810423e$require$VERSION = $cR4ZD.version;
var $1ad671c27810423e$var$validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach(function(type, i) {
    $1ad671c27810423e$var$validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
var $1ad671c27810423e$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */ $1ad671c27810423e$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + $1ad671c27810423e$require$VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return function(value, opt, opts) {
        if (validator === false) throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
        if (version && !$1ad671c27810423e$var$deprecatedWarnings[opt]) {
            $1ad671c27810423e$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */ function $1ad671c27810423e$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new TypeError('options must be an object');
    var keys = Object.keys(options);
    var i = keys.length;
    while(i-- > 0){
        var opt = keys[i];
        var validator = schema[opt];
        if (validator) {
            var value = options[opt];
            var result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new TypeError('option ' + opt + ' must be ' + result);
            continue;
        }
        if (allowUnknown !== true) throw Error('Unknown option ' + opt);
    }
}
module.exports = {
    assertOptions: $1ad671c27810423e$var$assertOptions,
    validators: $1ad671c27810423e$var$validators
};

});
parcelRegister("cR4ZD", function(module, exports) {
module.exports = {
    "version": "0.24.0"
};

});



parcelRegister("kZZD0", function(module, exports) {
'use strict';

var $2W85d = parcelRequire("2W85d");
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */ function $f4994f37c883aea2$var$CancelToken(executor) {
    if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
    var resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
    });
    var token = this;
    // eslint-disable-next-line func-names
    this.promise.then(function(cancel) {
        if (!token._listeners) return;
        var i;
        var l = token._listeners.length;
        for(i = 0; i < l; i++)token._listeners[i](cancel);
        token._listeners = null;
    });
    // eslint-disable-next-line func-names
    this.promise.then = function(onfulfilled) {
        var _resolve;
        // eslint-disable-next-line func-names
        var promise = new Promise(function(resolve) {
            token.subscribe(resolve);
            _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
            token.unsubscribe(_resolve);
        };
        return promise;
    };
    executor(function cancel(message) {
        if (token.reason) // Cancellation has already been requested
        return;
        token.reason = new $2W85d(message);
        resolvePromise(token.reason);
    });
}
/**
 * Throws a `Cancel` if cancellation has been requested.
 */ $f4994f37c883aea2$var$CancelToken.prototype.throwIfRequested = function throwIfRequested() {
    if (this.reason) throw this.reason;
};
/**
 * Subscribe to the cancel signal
 */ $f4994f37c883aea2$var$CancelToken.prototype.subscribe = function subscribe(listener) {
    if (this.reason) {
        listener(this.reason);
        return;
    }
    if (this._listeners) this._listeners.push(listener);
    else this._listeners = [
        listener
    ];
};
/**
 * Unsubscribe from the cancel signal
 */ $f4994f37c883aea2$var$CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
    if (!this._listeners) return;
    var index = this._listeners.indexOf(listener);
    if (index !== -1) this._listeners.splice(index, 1);
};
/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */ $f4994f37c883aea2$var$CancelToken.source = function source() {
    var cancel;
    var token = new $f4994f37c883aea2$var$CancelToken(function executor(c) {
        cancel = c;
    });
    return {
        token: token,
        cancel: cancel
    };
};
module.exports = $f4994f37c883aea2$var$CancelToken;

});

parcelRegister("b676K", function(module, exports) {
'use strict';
/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */ module.exports = function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
};

});

parcelRegister("kgiwQ", function(module, exports) {
'use strict';
/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */ module.exports = function isAxiosError(payload) {
    return typeof payload === 'object' && payload.isAxiosError === true;
};

});


parcelRegister("asDSe", function(module, exports) {

var $ihqFb = parcelRequire("ihqFb");
module.exports = function(jwt, options) {
    options = options || {};
    var decoded = $ihqFb.decode(jwt, options);
    if (!decoded) return null;
    var payload = decoded.payload;
    //try parse the payload
    if (typeof payload === 'string') try {
        var obj = JSON.parse(payload);
        if (obj !== null && typeof obj === 'object') payload = obj;
    } catch (e) {}
    //return header if `complete` option is enabled.  header includes claims
    //such as `kid` and `alg` used to select the key within a JWKS needed to
    //verify the signature
    if (options.complete === true) return {
        header: decoded.header,
        payload: payload,
        signature: decoded.signature
    };
    return payload;
};

});
parcelRegister("ihqFb", function(module, exports) {

$parcel$export(module.exports, "sign", function () { return $d4ee7f4800ec4eba$export$c5552dfdbc7cec71; }, function (v) { return $d4ee7f4800ec4eba$export$c5552dfdbc7cec71 = v; });
$parcel$export(module.exports, "verify", function () { return $d4ee7f4800ec4eba$export$532244b5b8b0b4b6; }, function (v) { return $d4ee7f4800ec4eba$export$532244b5b8b0b4b6 = v; });
$parcel$export(module.exports, "decode", function () { return $d4ee7f4800ec4eba$export$2f872c0f2117be69; }, function (v) { return $d4ee7f4800ec4eba$export$2f872c0f2117be69 = v; });
$parcel$export(module.exports, "createSign", function () { return $d4ee7f4800ec4eba$export$45df7cae684751af; }, function (v) { return $d4ee7f4800ec4eba$export$45df7cae684751af = v; });
/*global exports*/ var $d4ee7f4800ec4eba$export$6f6fa4628974a579;
var $d4ee7f4800ec4eba$export$c5552dfdbc7cec71;
var $d4ee7f4800ec4eba$export$532244b5b8b0b4b6;
var $d4ee7f4800ec4eba$export$2f872c0f2117be69;
var $d4ee7f4800ec4eba$export$1ea939691cdc45b8;
var $d4ee7f4800ec4eba$export$45df7cae684751af;
var $d4ee7f4800ec4eba$export$6f65485f87568e37;

var $9Z1dG = parcelRequire("9Z1dG");

var $cFKIK = parcelRequire("cFKIK");
var $d4ee7f4800ec4eba$var$ALGORITHMS = [
    'HS256',
    'HS384',
    'HS512',
    'RS256',
    'RS384',
    'RS512',
    'PS256',
    'PS384',
    'PS512',
    'ES256',
    'ES384',
    'ES512'
];
$d4ee7f4800ec4eba$export$6f6fa4628974a579 = $d4ee7f4800ec4eba$var$ALGORITHMS;
$d4ee7f4800ec4eba$export$c5552dfdbc7cec71 = $9Z1dG.sign;
$d4ee7f4800ec4eba$export$532244b5b8b0b4b6 = $cFKIK.verify;
$d4ee7f4800ec4eba$export$2f872c0f2117be69 = $cFKIK.decode;
$d4ee7f4800ec4eba$export$1ea939691cdc45b8 = $cFKIK.isValid;
$d4ee7f4800ec4eba$export$45df7cae684751af = function createSign(opts) {
    return new $9Z1dG(opts);
};
$d4ee7f4800ec4eba$export$6f65485f87568e37 = function createVerify(opts) {
    return new $cFKIK(opts);
};

});
parcelRegister("9Z1dG", function(module, exports) {
/*global module*/ 
var $838j1 = parcelRequire("838j1");
var $744ac1c582c082a8$require$Buffer = $838j1.Buffer;

var $2lgVM = parcelRequire("2lgVM");

var $gUhMZ = parcelRequire("gUhMZ");

var $3DkjE = parcelRequire("3DkjE");

var $q8HNf = parcelRequire("q8HNf");

var $5LV4O = parcelRequire("5LV4O");
function $744ac1c582c082a8$var$base64url(string, encoding) {
    return $744ac1c582c082a8$require$Buffer.from(string, encoding).toString('base64').replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $744ac1c582c082a8$var$jwsSecuredInput(header, payload, encoding) {
    encoding = encoding || 'utf8';
    var encodedHeader = $744ac1c582c082a8$var$base64url($q8HNf(header), 'binary');
    var encodedPayload = $744ac1c582c082a8$var$base64url($q8HNf(payload), encoding);
    return $5LV4O.format('%s.%s', encodedHeader, encodedPayload);
}
function $744ac1c582c082a8$var$jwsSign(opts) {
    var header = opts.header;
    var payload = opts.payload;
    var secretOrKey = opts.secret || opts.privateKey;
    var encoding = opts.encoding;
    var algo = $gUhMZ(header.alg);
    var securedInput = $744ac1c582c082a8$var$jwsSecuredInput(header, payload, encoding);
    var signature = algo.sign(securedInput, secretOrKey);
    return $5LV4O.format('%s.%s', securedInput, signature);
}
function $744ac1c582c082a8$var$SignStream(opts) {
    var secret = opts.secret;
    secret = secret == null ? opts.privateKey : secret;
    secret = secret == null ? opts.key : secret;
    if (/^hs/i.test(opts.header.alg) === true && secret == null) throw new TypeError('secret must be a string or buffer or a KeyObject');
    var secretStream = new $2lgVM(secret);
    this.readable = true;
    this.header = opts.header;
    this.encoding = opts.encoding;
    this.secret = this.privateKey = this.key = secretStream;
    this.payload = new $2lgVM(opts.payload);
    this.secret.once('close', (function() {
        if (!this.payload.writable && this.readable) this.sign();
    }).bind(this));
    this.payload.once('close', (function() {
        if (!this.secret.writable && this.readable) this.sign();
    }).bind(this));
}
$5LV4O.inherits($744ac1c582c082a8$var$SignStream, $3DkjE);
$744ac1c582c082a8$var$SignStream.prototype.sign = function sign() {
    try {
        var signature = $744ac1c582c082a8$var$jwsSign({
            header: this.header,
            payload: this.payload.buffer,
            secret: this.secret.buffer,
            encoding: this.encoding
        });
        this.emit('done', signature);
        this.emit('data', signature);
        this.emit('end');
        this.readable = false;
        return signature;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$744ac1c582c082a8$var$SignStream.sign = $744ac1c582c082a8$var$jwsSign;
module.exports = $744ac1c582c082a8$var$SignStream;

});
parcelRegister("838j1", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $5dc50be4850cea7a$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $5dc50be4850cea7a$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($5dc50be4850cea7a$var$Buffer.from && $5dc50be4850cea7a$var$Buffer.alloc && $5dc50be4850cea7a$var$Buffer.allocUnsafe && $5dc50be4850cea7a$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $5dc50be4850cea7a$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $5dc50be4850cea7a$var$SafeBuffer;
}
function $5dc50be4850cea7a$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $5dc50be4850cea7a$var$Buffer(arg, encodingOrOffset, length);
}
$5dc50be4850cea7a$var$SafeBuffer.prototype = Object.create($5dc50be4850cea7a$var$Buffer.prototype);
// Copy static methods from Buffer
$5dc50be4850cea7a$var$copyProps($5dc50be4850cea7a$var$Buffer, $5dc50be4850cea7a$var$SafeBuffer);
$5dc50be4850cea7a$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $5dc50be4850cea7a$var$Buffer(arg, encodingOrOffset, length);
};
$5dc50be4850cea7a$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $5dc50be4850cea7a$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$5dc50be4850cea7a$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $5dc50be4850cea7a$var$Buffer(size);
};
$5dc50be4850cea7a$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});
parcelRegister("bdjQ6", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $82a04c4ec6982288$export$a143d493d941bafc; }, function (v) { return $82a04c4ec6982288$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $82a04c4ec6982288$export$e4cf37d7f6fb9e0a; }, function (v) { return $82a04c4ec6982288$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $82a04c4ec6982288$export$f99ded8fe4b79145; }, function (v) { return $82a04c4ec6982288$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $82a04c4ec6982288$export$599f31c3813fae4d; }, function (v) { return $82a04c4ec6982288$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $82a04c4ec6982288$export$a143d493d941bafc;
var $82a04c4ec6982288$export$e4cf37d7f6fb9e0a;
var $82a04c4ec6982288$export$f99ded8fe4b79145;
var $82a04c4ec6982288$export$599f31c3813fae4d;
'use strict';

var $3nocJ = parcelRequire("3nocJ");

var $gU9iR = parcelRequire("gU9iR");
const $82a04c4ec6982288$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$82a04c4ec6982288$export$a143d493d941bafc = $82a04c4ec6982288$var$Buffer;
$82a04c4ec6982288$export$e4cf37d7f6fb9e0a = $82a04c4ec6982288$var$SlowBuffer;
$82a04c4ec6982288$export$f99ded8fe4b79145 = 50;
const $82a04c4ec6982288$var$K_MAX_LENGTH = 0x7fffffff;
$82a04c4ec6982288$export$599f31c3813fae4d = $82a04c4ec6982288$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT = $82a04c4ec6982288$var$typedArraySupport();
if (!$82a04c4ec6982288$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $82a04c4ec6982288$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($82a04c4ec6982288$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$82a04c4ec6982288$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $82a04c4ec6982288$var$createBuffer(length) {
    if (length > $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $82a04c4ec6982288$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $82a04c4ec6982288$var$allocUnsafe(arg);
    }
    return $82a04c4ec6982288$var$from(arg, encodingOrOffset, length);
}
$82a04c4ec6982288$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $82a04c4ec6982288$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $82a04c4ec6982288$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $82a04c4ec6982288$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($82a04c4ec6982288$var$isInstance(value, ArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, ArrayBuffer)) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($82a04c4ec6982288$var$isInstance(value, SharedArrayBuffer) || value && $82a04c4ec6982288$var$isInstance(value.buffer, SharedArrayBuffer))) return $82a04c4ec6982288$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $82a04c4ec6982288$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $82a04c4ec6982288$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $82a04c4ec6982288$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $82a04c4ec6982288$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $82a04c4ec6982288$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($82a04c4ec6982288$var$Buffer, Uint8Array);
function $82a04c4ec6982288$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $82a04c4ec6982288$var$alloc(size, fill, encoding) {
    $82a04c4ec6982288$var$assertSize(size);
    if (size <= 0) return $82a04c4ec6982288$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $82a04c4ec6982288$var$createBuffer(size).fill(fill, encoding) : $82a04c4ec6982288$var$createBuffer(size).fill(fill);
    return $82a04c4ec6982288$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $82a04c4ec6982288$var$Buffer.alloc = function(size, fill, encoding) {
    return $82a04c4ec6982288$var$alloc(size, fill, encoding);
};
function $82a04c4ec6982288$var$allocUnsafe(size) {
    $82a04c4ec6982288$var$assertSize(size);
    return $82a04c4ec6982288$var$createBuffer(size < 0 ? 0 : $82a04c4ec6982288$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $82a04c4ec6982288$var$Buffer.allocUnsafe = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $82a04c4ec6982288$var$Buffer.allocUnsafeSlow = function(size) {
    return $82a04c4ec6982288$var$allocUnsafe(size);
};
function $82a04c4ec6982288$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $82a04c4ec6982288$var$byteLength(string, encoding) | 0;
    let buf = $82a04c4ec6982288$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $82a04c4ec6982288$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $82a04c4ec6982288$var$checked(array.length) | 0;
    const buf = $82a04c4ec6982288$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $82a04c4ec6982288$var$fromArrayView(arrayView) {
    if ($82a04c4ec6982288$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $82a04c4ec6982288$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $82a04c4ec6982288$var$fromArrayLike(arrayView);
}
function $82a04c4ec6982288$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $82a04c4ec6982288$var$Buffer.prototype);
    return buf;
}
function $82a04c4ec6982288$var$fromObject(obj) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(obj)) {
        const len = $82a04c4ec6982288$var$checked(obj.length) | 0;
        const buf = $82a04c4ec6982288$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $82a04c4ec6982288$var$numberIsNaN(obj.length)) return $82a04c4ec6982288$var$createBuffer(0);
        return $82a04c4ec6982288$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $82a04c4ec6982288$var$fromArrayLike(obj.data);
}
function $82a04c4ec6982288$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $82a04c4ec6982288$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $82a04c4ec6982288$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $82a04c4ec6982288$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $82a04c4ec6982288$var$Buffer.alloc(+length);
}
$82a04c4ec6982288$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $82a04c4ec6982288$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$82a04c4ec6982288$var$Buffer.compare = function compare(a, b) {
    if ($82a04c4ec6982288$var$isInstance(a, Uint8Array)) a = $82a04c4ec6982288$var$Buffer.from(a, a.offset, a.byteLength);
    if ($82a04c4ec6982288$var$isInstance(b, Uint8Array)) b = $82a04c4ec6982288$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(a) || !$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$82a04c4ec6982288$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$82a04c4ec6982288$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $82a04c4ec6982288$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $82a04c4ec6982288$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($82a04c4ec6982288$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) buf = $82a04c4ec6982288$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $82a04c4ec6982288$var$byteLength(string, encoding) {
    if ($82a04c4ec6982288$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $82a04c4ec6982288$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $82a04c4ec6982288$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $82a04c4ec6982288$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$82a04c4ec6982288$var$Buffer.byteLength = $82a04c4ec6982288$var$byteLength;
function $82a04c4ec6982288$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Slice(this, start, end);
        case 'ascii':
            return $82a04c4ec6982288$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$latin1Slice(this, start, end);
        case 'base64':
            return $82a04c4ec6982288$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$82a04c4ec6982288$var$Buffer.prototype._isBuffer = true;
function $82a04c4ec6982288$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$82a04c4ec6982288$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$82a04c4ec6982288$var$swap(this, i, i + 1);
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $82a04c4ec6982288$var$swap(this, i, i + 3);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $82a04c4ec6982288$var$swap(this, i, i + 7);
        $82a04c4ec6982288$var$swap(this, i + 1, i + 6);
        $82a04c4ec6982288$var$swap(this, i + 2, i + 5);
        $82a04c4ec6982288$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$82a04c4ec6982288$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $82a04c4ec6982288$var$utf8Slice(this, 0, length);
    return $82a04c4ec6982288$var$slowToString.apply(this, arguments);
};
$82a04c4ec6982288$var$Buffer.prototype.toLocaleString = $82a04c4ec6982288$var$Buffer.prototype.toString;
$82a04c4ec6982288$var$Buffer.prototype.equals = function equals(b) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $82a04c4ec6982288$var$Buffer.compare(this, b) === 0;
};
$82a04c4ec6982288$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $82a04c4ec6982288$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($82a04c4ec6982288$var$customInspectSymbol) $82a04c4ec6982288$var$Buffer.prototype[$82a04c4ec6982288$var$customInspectSymbol] = $82a04c4ec6982288$var$Buffer.prototype.inspect;
$82a04c4ec6982288$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($82a04c4ec6982288$var$isInstance(target, Uint8Array)) target = $82a04c4ec6982288$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $82a04c4ec6982288$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($82a04c4ec6982288$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $82a04c4ec6982288$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($82a04c4ec6982288$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $82a04c4ec6982288$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $82a04c4ec6982288$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$82a04c4ec6982288$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$82a04c4ec6982288$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$82a04c4ec6982288$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $82a04c4ec6982288$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $82a04c4ec6982288$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($82a04c4ec6982288$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $82a04c4ec6982288$var$utf8Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $82a04c4ec6982288$var$asciiWrite(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$asciiToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$base64Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$base64ToBytes(string), buf, offset, length);
}
function $82a04c4ec6982288$var$ucs2Write(buf, string, offset, length) {
    return $82a04c4ec6982288$var$blitBuffer($82a04c4ec6982288$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$82a04c4ec6982288$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $82a04c4ec6982288$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $82a04c4ec6982288$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $82a04c4ec6982288$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $82a04c4ec6982288$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $82a04c4ec6982288$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$82a04c4ec6982288$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $82a04c4ec6982288$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $3nocJ.fromByteArray(buf);
    else return $3nocJ.fromByteArray(buf.slice(start, end));
}
function $82a04c4ec6982288$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $82a04c4ec6982288$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $82a04c4ec6982288$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $82a04c4ec6982288$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $82a04c4ec6982288$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $82a04c4ec6982288$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $82a04c4ec6982288$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $82a04c4ec6982288$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $82a04c4ec6982288$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$82a04c4ec6982288$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $82a04c4ec6982288$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $82a04c4ec6982288$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$82a04c4ec6982288$var$Buffer.prototype.readUintLE = $82a04c4ec6982288$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUintBE = $82a04c4ec6982288$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint8 = $82a04c4ec6982288$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint16BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32LE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$82a04c4ec6982288$var$Buffer.prototype.readUint32BE = $82a04c4ec6982288$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$82a04c4ec6982288$var$Buffer.prototype.readBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$82a04c4ec6982288$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$82a04c4ec6982288$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$82a04c4ec6982288$var$Buffer.prototype.readBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $82a04c4ec6982288$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$82a04c4ec6982288$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, true, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 4, this.length);
    return $gU9iR.read(this, offset, false, 23, 4);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, true, 52, 8);
};
$82a04c4ec6982288$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkOffset(offset, 8, this.length);
    return $gU9iR.read(this, offset, false, 52, 8);
};
function $82a04c4ec6982288$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$82a04c4ec6982288$var$Buffer.prototype.writeUintLE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUintBE = $82a04c4ec6982288$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint8 = $82a04c4ec6982288$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint16BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32LE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeUint32BE = $82a04c4ec6982288$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $82a04c4ec6982288$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $82a04c4ec6982288$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigUInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $82a04c4ec6982288$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64LE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$82a04c4ec6982288$var$Buffer.prototype.writeBigInt64BE = $82a04c4ec6982288$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $82a04c4ec6982288$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $82a04c4ec6982288$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$82a04c4ec6982288$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeFloat(this, value, offset, false, noAssert);
};
function $82a04c4ec6982288$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $82a04c4ec6982288$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $gU9iR.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, true, noAssert);
};
$82a04c4ec6982288$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $82a04c4ec6982288$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$82a04c4ec6982288$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$82a04c4ec6982288$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$82a04c4ec6982288$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$82a04c4ec6982288$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $82a04c4ec6982288$var$Buffer.isBuffer(val) ? val : $82a04c4ec6982288$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $82a04c4ec6982288$var$errors = {};
function $82a04c4ec6982288$var$E(sym, getMessage, Base) {
    $82a04c4ec6982288$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$82a04c4ec6982288$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$82a04c4ec6982288$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$82a04c4ec6982288$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $82a04c4ec6982288$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $82a04c4ec6982288$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $82a04c4ec6982288$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength) {
    $82a04c4ec6982288$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $82a04c4ec6982288$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $82a04c4ec6982288$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $82a04c4ec6982288$var$checkBounds(buf, offset, byteLength);
}
function $82a04c4ec6982288$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $82a04c4ec6982288$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $82a04c4ec6982288$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $82a04c4ec6982288$var$validateNumber(value, type);
        throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $82a04c4ec6982288$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $82a04c4ec6982288$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $82a04c4ec6982288$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $82a04c4ec6982288$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($82a04c4ec6982288$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $82a04c4ec6982288$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $82a04c4ec6982288$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $82a04c4ec6982288$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $82a04c4ec6982288$var$base64ToBytes(str) {
    return $3nocJ.toByteArray($82a04c4ec6982288$var$base64clean(str));
}
function $82a04c4ec6982288$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $82a04c4ec6982288$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $82a04c4ec6982288$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $82a04c4ec6982288$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $82a04c4ec6982288$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $82a04c4ec6982288$var$BufferBigIntNotDefined : fn;
}
function $82a04c4ec6982288$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("3nocJ", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $27564b8a0078aa3d$export$d622b2ad8d90c771; }, function (v) { return $27564b8a0078aa3d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $27564b8a0078aa3d$export$6100ba28696e12de; }, function (v) { return $27564b8a0078aa3d$export$6100ba28696e12de = v; });
var $27564b8a0078aa3d$export$a48f0734ac7c2329;
var $27564b8a0078aa3d$export$d622b2ad8d90c771;
var $27564b8a0078aa3d$export$6100ba28696e12de;
'use strict';
$27564b8a0078aa3d$export$a48f0734ac7c2329 = $27564b8a0078aa3d$var$byteLength;
$27564b8a0078aa3d$export$d622b2ad8d90c771 = $27564b8a0078aa3d$var$toByteArray;
$27564b8a0078aa3d$export$6100ba28696e12de = $27564b8a0078aa3d$var$fromByteArray;
var $27564b8a0078aa3d$var$lookup = [];
var $27564b8a0078aa3d$var$revLookup = [];
var $27564b8a0078aa3d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $27564b8a0078aa3d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $27564b8a0078aa3d$var$i = 0, $27564b8a0078aa3d$var$len = $27564b8a0078aa3d$var$code.length; $27564b8a0078aa3d$var$i < $27564b8a0078aa3d$var$len; ++$27564b8a0078aa3d$var$i){
    $27564b8a0078aa3d$var$lookup[$27564b8a0078aa3d$var$i] = $27564b8a0078aa3d$var$code[$27564b8a0078aa3d$var$i];
    $27564b8a0078aa3d$var$revLookup[$27564b8a0078aa3d$var$code.charCodeAt($27564b8a0078aa3d$var$i)] = $27564b8a0078aa3d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$27564b8a0078aa3d$var$revLookup['-'.charCodeAt(0)] = 62;
$27564b8a0078aa3d$var$revLookup['_'.charCodeAt(0)] = 63;
function $27564b8a0078aa3d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $27564b8a0078aa3d$var$byteLength(b64) {
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $27564b8a0078aa3d$var$toByteArray(b64) {
    var tmp;
    var lens = $27564b8a0078aa3d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $27564b8a0078aa3d$var$Arr($27564b8a0078aa3d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 18 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 2 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i)] << 10 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $27564b8a0078aa3d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $27564b8a0078aa3d$var$tripletToBase64(num) {
    return $27564b8a0078aa3d$var$lookup[num >> 18 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 12 & 0x3F] + $27564b8a0078aa3d$var$lookup[num >> 6 & 0x3F] + $27564b8a0078aa3d$var$lookup[num & 0x3F];
}
function $27564b8a0078aa3d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($27564b8a0078aa3d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $27564b8a0078aa3d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($27564b8a0078aa3d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 2] + $27564b8a0078aa3d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($27564b8a0078aa3d$var$lookup[tmp >> 10] + $27564b8a0078aa3d$var$lookup[tmp >> 4 & 0x3F] + $27564b8a0078aa3d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("gU9iR", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $c4e917b4c37bfab7$export$aafa59e2e03f2942; }, function (v) { return $c4e917b4c37bfab7$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $c4e917b4c37bfab7$export$68d8715fc104d294; }, function (v) { return $c4e917b4c37bfab7$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $c4e917b4c37bfab7$export$aafa59e2e03f2942;
var $c4e917b4c37bfab7$export$68d8715fc104d294;
$c4e917b4c37bfab7$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$c4e917b4c37bfab7$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRegister("2lgVM", function(module, exports) {
/*global module, process*/ 
var $4ZL0H = parcelRequire("4ZL0H");

var $838j1 = parcelRequire("838j1");
var $1b4aad135d3f35c1$require$Buffer = $838j1.Buffer;

var $3DkjE = parcelRequire("3DkjE");

var $5LV4O = parcelRequire("5LV4O");
function $1b4aad135d3f35c1$var$DataStream(data) {
    this.buffer = null;
    this.writable = true;
    this.readable = true;
    // No input
    if (!data) {
        this.buffer = $1b4aad135d3f35c1$require$Buffer.alloc(0);
        return this;
    }
    // Stream
    if (typeof data.pipe === 'function') {
        this.buffer = $1b4aad135d3f35c1$require$Buffer.alloc(0);
        data.pipe(this);
        return this;
    }
    // Buffer or String
    // or Object (assumedly a passworded key)
    if (data.length || typeof data === 'object') {
        this.buffer = data;
        this.writable = false;
        $4ZL0H.nextTick((function() {
            this.emit('end', data);
            this.readable = false;
            this.emit('close');
        }).bind(this));
        return this;
    }
    throw new TypeError('Unexpected data type (' + typeof data + ')');
}
$5LV4O.inherits($1b4aad135d3f35c1$var$DataStream, $3DkjE);
$1b4aad135d3f35c1$var$DataStream.prototype.write = function write(data) {
    this.buffer = $1b4aad135d3f35c1$require$Buffer.concat([
        this.buffer,
        $1b4aad135d3f35c1$require$Buffer.from(data)
    ]);
    this.emit('data', data);
};
$1b4aad135d3f35c1$var$DataStream.prototype.end = function end(data) {
    if (data) this.write(data);
    this.emit('end', data);
    this.emit('close');
    this.writable = false;
    this.readable = false;
};
module.exports = $1b4aad135d3f35c1$var$DataStream;

});
parcelRegister("4ZL0H", function(module, exports) {
// shim for using process in browser
var $3a3153321729209f$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $3a3153321729209f$var$cachedSetTimeout;
var $3a3153321729209f$var$cachedClearTimeout;
function $3a3153321729209f$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $3a3153321729209f$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        else $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    } catch (e) {
        $3a3153321729209f$var$cachedSetTimeout = $3a3153321729209f$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        else $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    } catch (e) {
        $3a3153321729209f$var$cachedClearTimeout = $3a3153321729209f$var$defaultClearTimeout;
    }
})();
function $3a3153321729209f$var$runTimeout(fun) {
    if ($3a3153321729209f$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedSetTimeout === $3a3153321729209f$var$defaultSetTimout || !$3a3153321729209f$var$cachedSetTimeout) && setTimeout) {
        $3a3153321729209f$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $3a3153321729209f$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $3a3153321729209f$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $3a3153321729209f$var$runClearTimeout(marker) {
    if ($3a3153321729209f$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($3a3153321729209f$var$cachedClearTimeout === $3a3153321729209f$var$defaultClearTimeout || !$3a3153321729209f$var$cachedClearTimeout) && clearTimeout) {
        $3a3153321729209f$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $3a3153321729209f$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $3a3153321729209f$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $3a3153321729209f$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $3a3153321729209f$var$queue = [];
var $3a3153321729209f$var$draining = false;
var $3a3153321729209f$var$currentQueue;
var $3a3153321729209f$var$queueIndex = -1;
function $3a3153321729209f$var$cleanUpNextTick() {
    if (!$3a3153321729209f$var$draining || !$3a3153321729209f$var$currentQueue) return;
    $3a3153321729209f$var$draining = false;
    if ($3a3153321729209f$var$currentQueue.length) $3a3153321729209f$var$queue = $3a3153321729209f$var$currentQueue.concat($3a3153321729209f$var$queue);
    else $3a3153321729209f$var$queueIndex = -1;
    if ($3a3153321729209f$var$queue.length) $3a3153321729209f$var$drainQueue();
}
function $3a3153321729209f$var$drainQueue() {
    if ($3a3153321729209f$var$draining) return;
    var timeout = $3a3153321729209f$var$runTimeout($3a3153321729209f$var$cleanUpNextTick);
    $3a3153321729209f$var$draining = true;
    var len = $3a3153321729209f$var$queue.length;
    while(len){
        $3a3153321729209f$var$currentQueue = $3a3153321729209f$var$queue;
        $3a3153321729209f$var$queue = [];
        while(++$3a3153321729209f$var$queueIndex < len)if ($3a3153321729209f$var$currentQueue) $3a3153321729209f$var$currentQueue[$3a3153321729209f$var$queueIndex].run();
        $3a3153321729209f$var$queueIndex = -1;
        len = $3a3153321729209f$var$queue.length;
    }
    $3a3153321729209f$var$currentQueue = null;
    $3a3153321729209f$var$draining = false;
    $3a3153321729209f$var$runClearTimeout(timeout);
}
$3a3153321729209f$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $3a3153321729209f$var$queue.push(new $3a3153321729209f$var$Item(fun, args));
    if ($3a3153321729209f$var$queue.length === 1 && !$3a3153321729209f$var$draining) $3a3153321729209f$var$runTimeout($3a3153321729209f$var$drainQueue);
};
// v8 likes predictible objects
function $3a3153321729209f$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$3a3153321729209f$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$3a3153321729209f$var$process.title = 'browser';
$3a3153321729209f$var$process.browser = true;
$3a3153321729209f$var$process.env = {};
$3a3153321729209f$var$process.argv = [];
$3a3153321729209f$var$process.version = ''; // empty string to avoid regexp issues
$3a3153321729209f$var$process.versions = {};
function $3a3153321729209f$var$noop() {}
$3a3153321729209f$var$process.on = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.addListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.once = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.off = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.removeAllListeners = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.emit = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.prependOnceListener = $3a3153321729209f$var$noop;
$3a3153321729209f$var$process.listeners = function(name) {
    return [];
};
$3a3153321729209f$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$3a3153321729209f$var$process.cwd = function() {
    return '/';
};
$3a3153321729209f$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$3a3153321729209f$var$process.umask = function() {
    return 0;
};

});

parcelRegister("3DkjE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $2a54c5edd7835136$var$Stream;

var $fzCxw = parcelRequire("fzCxw");
var $2a54c5edd7835136$require$EE = $fzCxw.EventEmitter;

var $dhT4G = parcelRequire("dhT4G");
$dhT4G($2a54c5edd7835136$var$Stream, $2a54c5edd7835136$require$EE);

$2a54c5edd7835136$var$Stream.Readable = (parcelRequire("52Vgn"));

$2a54c5edd7835136$var$Stream.Writable = (parcelRequire("1uEw0"));

$2a54c5edd7835136$var$Stream.Duplex = (parcelRequire("6APwg"));

$2a54c5edd7835136$var$Stream.Transform = (parcelRequire("6H0L1"));

$2a54c5edd7835136$var$Stream.PassThrough = (parcelRequire("e2OS0"));

$2a54c5edd7835136$var$Stream.finished = (parcelRequire("faWKl"));

$2a54c5edd7835136$var$Stream.pipeline = (parcelRequire("9Mw7i"));
// Backwards-compat with node 0.4.x
$2a54c5edd7835136$var$Stream.Stream = $2a54c5edd7835136$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $2a54c5edd7835136$var$Stream() {
    $2a54c5edd7835136$require$EE.call(this);
}
$2a54c5edd7835136$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($2a54c5edd7835136$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("fzCxw", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $b5680518dd48c196$var$R = typeof Reflect === 'object' ? Reflect : null;
var $b5680518dd48c196$var$ReflectApply = $b5680518dd48c196$var$R && typeof $b5680518dd48c196$var$R.apply === 'function' ? $b5680518dd48c196$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $b5680518dd48c196$var$ReflectOwnKeys;
if ($b5680518dd48c196$var$R && typeof $b5680518dd48c196$var$R.ownKeys === 'function') $b5680518dd48c196$var$ReflectOwnKeys = $b5680518dd48c196$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $b5680518dd48c196$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $b5680518dd48c196$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $b5680518dd48c196$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $b5680518dd48c196$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $b5680518dd48c196$var$EventEmitter() {
    $b5680518dd48c196$var$EventEmitter.init.call(this);
}
module.exports = $b5680518dd48c196$var$EventEmitter;
module.exports.once = $b5680518dd48c196$var$once;
// Backwards-compat with node 0.10.x
$b5680518dd48c196$var$EventEmitter.EventEmitter = $b5680518dd48c196$var$EventEmitter;
$b5680518dd48c196$var$EventEmitter.prototype._events = undefined;
$b5680518dd48c196$var$EventEmitter.prototype._eventsCount = 0;
$b5680518dd48c196$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $b5680518dd48c196$var$defaultMaxListeners = 10;
function $b5680518dd48c196$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($b5680518dd48c196$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $b5680518dd48c196$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $b5680518dd48c196$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $b5680518dd48c196$var$defaultMaxListeners = arg;
    }
});
$b5680518dd48c196$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$b5680518dd48c196$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $b5680518dd48c196$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $b5680518dd48c196$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $b5680518dd48c196$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$b5680518dd48c196$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $b5680518dd48c196$var$_getMaxListeners(this);
};
$b5680518dd48c196$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $b5680518dd48c196$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $b5680518dd48c196$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$b5680518dd48c196$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $b5680518dd48c196$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $b5680518dd48c196$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $b5680518dd48c196$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $b5680518dd48c196$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$b5680518dd48c196$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $b5680518dd48c196$var$_addListener(this, type, listener, false);
};
$b5680518dd48c196$var$EventEmitter.prototype.on = $b5680518dd48c196$var$EventEmitter.prototype.addListener;
$b5680518dd48c196$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $b5680518dd48c196$var$_addListener(this, type, listener, true);
};
function $b5680518dd48c196$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $b5680518dd48c196$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $b5680518dd48c196$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$b5680518dd48c196$var$EventEmitter.prototype.once = function once(type, listener) {
    $b5680518dd48c196$var$checkListener(listener);
    this.on(type, $b5680518dd48c196$var$_onceWrap(this, type, listener));
    return this;
};
$b5680518dd48c196$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $b5680518dd48c196$var$checkListener(listener);
    this.prependListener(type, $b5680518dd48c196$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$b5680518dd48c196$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $b5680518dd48c196$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $b5680518dd48c196$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$b5680518dd48c196$var$EventEmitter.prototype.off = $b5680518dd48c196$var$EventEmitter.prototype.removeListener;
$b5680518dd48c196$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $b5680518dd48c196$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $b5680518dd48c196$var$unwrapListeners(evlistener) : $b5680518dd48c196$var$arrayClone(evlistener, evlistener.length);
}
$b5680518dd48c196$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $b5680518dd48c196$var$_listeners(this, type, true);
};
$b5680518dd48c196$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $b5680518dd48c196$var$_listeners(this, type, false);
};
$b5680518dd48c196$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $b5680518dd48c196$var$listenerCount.call(emitter, type);
};
$b5680518dd48c196$var$EventEmitter.prototype.listenerCount = $b5680518dd48c196$var$listenerCount;
function $b5680518dd48c196$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$b5680518dd48c196$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $b5680518dd48c196$var$ReflectOwnKeys(this._events) : [];
};
function $b5680518dd48c196$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $b5680518dd48c196$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $b5680518dd48c196$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $b5680518dd48c196$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $b5680518dd48c196$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $b5680518dd48c196$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $b5680518dd48c196$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("dhT4G", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("52Vgn", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
module.exports = $3ac98eed33a0cf82$var$Readable;
/*<replacement>*/ var $3ac98eed33a0cf82$var$Duplex;
/*</replacement>*/ $3ac98eed33a0cf82$var$Readable.ReadableState = $3ac98eed33a0cf82$var$ReadableState;

var $fzCxw = parcelRequire("fzCxw");
var $3ac98eed33a0cf82$require$EE = $fzCxw.EventEmitter;
var $3ac98eed33a0cf82$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $kKRZw = parcelRequire("kKRZw");

var $bdjQ6 = parcelRequire("bdjQ6");
var $3ac98eed33a0cf82$require$Buffer = $bdjQ6.Buffer;
var $3ac98eed33a0cf82$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $3ac98eed33a0cf82$var$_uint8ArrayToBuffer(chunk) {
    return $3ac98eed33a0cf82$require$Buffer.from(chunk);
}
function $3ac98eed33a0cf82$var$_isUint8Array(obj) {
    return $3ac98eed33a0cf82$require$Buffer.isBuffer(obj) || obj instanceof $3ac98eed33a0cf82$var$OurUint8Array;
}

var $ifbub = parcelRequire("ifbub");
var $3ac98eed33a0cf82$var$debug;
if ($ifbub && $ifbub.debuglog) $3ac98eed33a0cf82$var$debug = $ifbub.debuglog('stream');
else $3ac98eed33a0cf82$var$debug = function debug() {};

var $aJGWJ = parcelRequire("aJGWJ");

var $cIBKQ = parcelRequire("cIBKQ");

var $9LKRZ = parcelRequire("9LKRZ");
var $3ac98eed33a0cf82$var$getHighWaterMark = $9LKRZ.getHighWaterMark;

var $akNAa = parcelRequire("akNAa");
var $3ac98eed33a0cf82$require$_require$codes = $akNAa.codes;
var $3ac98eed33a0cf82$var$ERR_INVALID_ARG_TYPE = $3ac98eed33a0cf82$require$_require$codes.ERR_INVALID_ARG_TYPE, $3ac98eed33a0cf82$var$ERR_STREAM_PUSH_AFTER_EOF = $3ac98eed33a0cf82$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $3ac98eed33a0cf82$var$ERR_METHOD_NOT_IMPLEMENTED = $3ac98eed33a0cf82$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $3ac98eed33a0cf82$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $3ac98eed33a0cf82$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $3ac98eed33a0cf82$var$StringDecoder;
var $3ac98eed33a0cf82$var$createReadableStreamAsyncIterator;
var $3ac98eed33a0cf82$var$from;

(parcelRequire("dhT4G"))($3ac98eed33a0cf82$var$Readable, $kKRZw);
var $3ac98eed33a0cf82$var$errorOrDestroy = $cIBKQ.errorOrDestroy;
var $3ac98eed33a0cf82$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $3ac98eed33a0cf82$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $3ac98eed33a0cf82$var$ReadableState(options, stream, isDuplex) {
    $3ac98eed33a0cf82$var$Duplex = $3ac98eed33a0cf82$var$Duplex || (parcelRequire("6APwg"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $3ac98eed33a0cf82$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $3ac98eed33a0cf82$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $aJGWJ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$3ac98eed33a0cf82$var$StringDecoder) $3ac98eed33a0cf82$var$StringDecoder = (parcelRequire("iGJyf")).StringDecoder;
        this.decoder = new $3ac98eed33a0cf82$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $3ac98eed33a0cf82$var$Readable(options) {
    $3ac98eed33a0cf82$var$Duplex = $3ac98eed33a0cf82$var$Duplex || (parcelRequire("6APwg"));
    if (!(this instanceof $3ac98eed33a0cf82$var$Readable)) return new $3ac98eed33a0cf82$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $3ac98eed33a0cf82$var$Duplex;
    this._readableState = new $3ac98eed33a0cf82$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $kKRZw.call(this);
}
Object.defineProperty($3ac98eed33a0cf82$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$3ac98eed33a0cf82$var$Readable.prototype.destroy = $cIBKQ.destroy;
$3ac98eed33a0cf82$var$Readable.prototype._undestroy = $cIBKQ.undestroy;
$3ac98eed33a0cf82$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$3ac98eed33a0cf82$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $3ac98eed33a0cf82$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $3ac98eed33a0cf82$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$3ac98eed33a0cf82$var$Readable.prototype.unshift = function(chunk) {
    return $3ac98eed33a0cf82$var$readableAddChunk(this, chunk, null, true, false);
};
function $3ac98eed33a0cf82$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $3ac98eed33a0cf82$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $3ac98eed33a0cf82$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $3ac98eed33a0cf82$var$chunkInvalid(state, chunk);
        if (er) $3ac98eed33a0cf82$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $3ac98eed33a0cf82$require$Buffer.prototype) chunk = $3ac98eed33a0cf82$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $3ac98eed33a0cf82$var$errorOrDestroy(stream, new $3ac98eed33a0cf82$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $3ac98eed33a0cf82$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $3ac98eed33a0cf82$var$errorOrDestroy(stream, new $3ac98eed33a0cf82$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $3ac98eed33a0cf82$var$addChunk(stream, state, chunk, false);
                    else $3ac98eed33a0cf82$var$maybeReadMore(stream, state);
                } else $3ac98eed33a0cf82$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $3ac98eed33a0cf82$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $3ac98eed33a0cf82$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $3ac98eed33a0cf82$var$emitReadable(stream);
    }
    $3ac98eed33a0cf82$var$maybeReadMore(stream, state);
}
function $3ac98eed33a0cf82$var$chunkInvalid(state, chunk) {
    var er;
    if (!$3ac98eed33a0cf82$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $3ac98eed33a0cf82$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$3ac98eed33a0cf82$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$3ac98eed33a0cf82$var$Readable.prototype.setEncoding = function(enc) {
    if (!$3ac98eed33a0cf82$var$StringDecoder) $3ac98eed33a0cf82$var$StringDecoder = (parcelRequire("iGJyf")).StringDecoder;
    var decoder = new $3ac98eed33a0cf82$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $3ac98eed33a0cf82$var$MAX_HWM = 0x40000000;
function $3ac98eed33a0cf82$var$computeNewHighWaterMark(n) {
    if (n >= $3ac98eed33a0cf82$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $3ac98eed33a0cf82$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3ac98eed33a0cf82$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $3ac98eed33a0cf82$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$3ac98eed33a0cf82$var$Readable.prototype.read = function(n) {
    $3ac98eed33a0cf82$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $3ac98eed33a0cf82$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $3ac98eed33a0cf82$var$endReadable(this);
        else $3ac98eed33a0cf82$var$emitReadable(this);
        return null;
    }
    n = $3ac98eed33a0cf82$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $3ac98eed33a0cf82$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $3ac98eed33a0cf82$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $3ac98eed33a0cf82$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $3ac98eed33a0cf82$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $3ac98eed33a0cf82$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $3ac98eed33a0cf82$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $3ac98eed33a0cf82$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $3ac98eed33a0cf82$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $3ac98eed33a0cf82$var$onEofChunk(stream, state) {
    $3ac98eed33a0cf82$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $3ac98eed33a0cf82$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $3ac98eed33a0cf82$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $3ac98eed33a0cf82$var$emitReadable(stream) {
    var state = stream._readableState;
    $3ac98eed33a0cf82$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $3ac98eed33a0cf82$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $4ZL0H.nextTick($3ac98eed33a0cf82$var$emitReadable_, stream);
    }
}
function $3ac98eed33a0cf82$var$emitReadable_(stream) {
    var state = stream._readableState;
    $3ac98eed33a0cf82$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $3ac98eed33a0cf82$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $3ac98eed33a0cf82$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $4ZL0H.nextTick($3ac98eed33a0cf82$var$maybeReadMore_, stream, state);
    }
}
function $3ac98eed33a0cf82$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $3ac98eed33a0cf82$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$3ac98eed33a0cf82$var$Readable.prototype._read = function(n) {
    $3ac98eed33a0cf82$var$errorOrDestroy(this, new $3ac98eed33a0cf82$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$3ac98eed33a0cf82$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $3ac98eed33a0cf82$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4ZL0H.stdout && dest !== $4ZL0H.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $4ZL0H.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $3ac98eed33a0cf82$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $3ac98eed33a0cf82$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $3ac98eed33a0cf82$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $3ac98eed33a0cf82$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $3ac98eed33a0cf82$var$debug('ondata');
        var ret = dest.write(chunk);
        $3ac98eed33a0cf82$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $3ac98eed33a0cf82$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $3ac98eed33a0cf82$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $3ac98eed33a0cf82$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($3ac98eed33a0cf82$var$EElistenerCount(dest, 'error') === 0) $3ac98eed33a0cf82$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $3ac98eed33a0cf82$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $3ac98eed33a0cf82$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $3ac98eed33a0cf82$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $3ac98eed33a0cf82$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $3ac98eed33a0cf82$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $3ac98eed33a0cf82$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $3ac98eed33a0cf82$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $3ac98eed33a0cf82$var$flow(src);
        }
    };
}
$3ac98eed33a0cf82$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $3ac98eed33a0cf82$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$3ac98eed33a0cf82$var$Readable.prototype.on = function(ev, fn) {
    var res = $kKRZw.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $3ac98eed33a0cf82$var$debug('on readable', state.length, state.reading);
            if (state.length) $3ac98eed33a0cf82$var$emitReadable(this);
            else if (!state.reading) $4ZL0H.nextTick($3ac98eed33a0cf82$var$nReadingNextTick, this);
        }
    }
    return res;
};
$3ac98eed33a0cf82$var$Readable.prototype.addListener = $3ac98eed33a0cf82$var$Readable.prototype.on;
$3ac98eed33a0cf82$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $kKRZw.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4ZL0H.nextTick($3ac98eed33a0cf82$var$updateReadableListening, this);
    return res;
};
$3ac98eed33a0cf82$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $kKRZw.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $4ZL0H.nextTick($3ac98eed33a0cf82$var$updateReadableListening, this);
    return res;
};
function $3ac98eed33a0cf82$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $3ac98eed33a0cf82$var$nReadingNextTick(self1) {
    $3ac98eed33a0cf82$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$3ac98eed33a0cf82$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $3ac98eed33a0cf82$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $3ac98eed33a0cf82$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $3ac98eed33a0cf82$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $4ZL0H.nextTick($3ac98eed33a0cf82$var$resume_, stream, state);
    }
}
function $3ac98eed33a0cf82$var$resume_(stream, state) {
    $3ac98eed33a0cf82$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $3ac98eed33a0cf82$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$3ac98eed33a0cf82$var$Readable.prototype.pause = function() {
    $3ac98eed33a0cf82$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $3ac98eed33a0cf82$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $3ac98eed33a0cf82$var$flow(stream) {
    var state = stream._readableState;
    $3ac98eed33a0cf82$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$3ac98eed33a0cf82$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $3ac98eed33a0cf82$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $3ac98eed33a0cf82$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $3ac98eed33a0cf82$var$kProxyEvents.length; n++)stream.on($3ac98eed33a0cf82$var$kProxyEvents[n], this.emit.bind(this, $3ac98eed33a0cf82$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $3ac98eed33a0cf82$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $3ac98eed33a0cf82$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($3ac98eed33a0cf82$var$createReadableStreamAsyncIterator === undefined) $3ac98eed33a0cf82$var$createReadableStreamAsyncIterator = (parcelRequire("84GJs"));
    return $3ac98eed33a0cf82$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($3ac98eed33a0cf82$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($3ac98eed33a0cf82$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($3ac98eed33a0cf82$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$3ac98eed33a0cf82$var$Readable._fromList = $3ac98eed33a0cf82$var$fromList;
Object.defineProperty($3ac98eed33a0cf82$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $3ac98eed33a0cf82$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $3ac98eed33a0cf82$var$endReadable(stream) {
    var state = stream._readableState;
    $3ac98eed33a0cf82$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $4ZL0H.nextTick($3ac98eed33a0cf82$var$endReadableNT, state, stream);
    }
}
function $3ac98eed33a0cf82$var$endReadableNT(state, stream) {
    $3ac98eed33a0cf82$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $3ac98eed33a0cf82$var$Readable.from = function(iterable, opts) {
    if ($3ac98eed33a0cf82$var$from === undefined) $3ac98eed33a0cf82$var$from = (parcelRequire("dp7AE"));
    return $3ac98eed33a0cf82$var$from($3ac98eed33a0cf82$var$Readable, iterable, opts);
};
function $3ac98eed33a0cf82$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("kKRZw", function(module, exports) {

module.exports = (parcelRequire("fzCxw")).EventEmitter;

});

parcelRegister("ifbub", function(module, exports) {
"use strict";

});

parcelRegister("aJGWJ", function(module, exports) {
'use strict';
function $7d0f6b91e6ceef9e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7d0f6b91e6ceef9e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7d0f6b91e6ceef9e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7d0f6b91e6ceef9e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7d0f6b91e6ceef9e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7d0f6b91e6ceef9e$var$_defineProperty(obj, key, value) {
    key = $7d0f6b91e6ceef9e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7d0f6b91e6ceef9e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7d0f6b91e6ceef9e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $7d0f6b91e6ceef9e$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $7d0f6b91e6ceef9e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $7d0f6b91e6ceef9e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $7d0f6b91e6ceef9e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $7d0f6b91e6ceef9e$var$_toPropertyKey(arg) {
    var key = $7d0f6b91e6ceef9e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $7d0f6b91e6ceef9e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $bdjQ6 = parcelRequire("bdjQ6");
var $7d0f6b91e6ceef9e$var$Buffer = $bdjQ6.Buffer;

var $ifbub = parcelRequire("ifbub");
var $7d0f6b91e6ceef9e$var$inspect = $ifbub.inspect;
var $7d0f6b91e6ceef9e$var$custom = $7d0f6b91e6ceef9e$var$inspect && $7d0f6b91e6ceef9e$var$inspect.custom || 'inspect';
function $7d0f6b91e6ceef9e$var$copyBuffer(src, target, offset) {
    $7d0f6b91e6ceef9e$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $7d0f6b91e6ceef9e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $7d0f6b91e6ceef9e$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $7d0f6b91e6ceef9e$var$Buffer.alloc(0);
                var ret = $7d0f6b91e6ceef9e$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $7d0f6b91e6ceef9e$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $7d0f6b91e6ceef9e$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $7d0f6b91e6ceef9e$var$custom,
            value: function value(_, options) {
                return $7d0f6b91e6ceef9e$var$inspect(this, $7d0f6b91e6ceef9e$var$_objectSpread($7d0f6b91e6ceef9e$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("cIBKQ", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $9426e159af77fd1c$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $4ZL0H.nextTick($9426e159af77fd1c$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $4ZL0H.nextTick($9426e159af77fd1c$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $4ZL0H.nextTick($9426e159af77fd1c$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $4ZL0H.nextTick($9426e159af77fd1c$var$emitErrorAndCloseNT, _this, err);
            } else $4ZL0H.nextTick($9426e159af77fd1c$var$emitCloseNT, _this);
        } else if (cb) {
            $4ZL0H.nextTick($9426e159af77fd1c$var$emitCloseNT, _this);
            cb(err);
        } else $4ZL0H.nextTick($9426e159af77fd1c$var$emitCloseNT, _this);
    });
    return this;
}
function $9426e159af77fd1c$var$emitErrorAndCloseNT(self, err) {
    $9426e159af77fd1c$var$emitErrorNT(self, err);
    $9426e159af77fd1c$var$emitCloseNT(self);
}
function $9426e159af77fd1c$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $9426e159af77fd1c$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $9426e159af77fd1c$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $9426e159af77fd1c$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $9426e159af77fd1c$var$destroy,
    undestroy: $9426e159af77fd1c$var$undestroy,
    errorOrDestroy: $9426e159af77fd1c$var$errorOrDestroy
};

});

parcelRegister("9LKRZ", function(module, exports) {
'use strict';

var $71ccdc346f30658a$var$ERR_INVALID_OPT_VALUE = (parcelRequire("akNAa")).codes.ERR_INVALID_OPT_VALUE;
function $71ccdc346f30658a$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $71ccdc346f30658a$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $71ccdc346f30658a$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $71ccdc346f30658a$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $71ccdc346f30658a$var$getHighWaterMark
};

});
parcelRegister("akNAa", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $78623ba8b47f0d8a$export$e45cb6485273080e; }, function (v) { return $78623ba8b47f0d8a$export$e45cb6485273080e = v; });
var $78623ba8b47f0d8a$export$e45cb6485273080e;
'use strict';
function $78623ba8b47f0d8a$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $78623ba8b47f0d8a$var$codes = {};
function $78623ba8b47f0d8a$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $78623ba8b47f0d8a$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $78623ba8b47f0d8a$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $78623ba8b47f0d8a$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $78623ba8b47f0d8a$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $78623ba8b47f0d8a$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $78623ba8b47f0d8a$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$78623ba8b47f0d8a$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$78623ba8b47f0d8a$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $78623ba8b47f0d8a$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($78623ba8b47f0d8a$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($78623ba8b47f0d8a$var$oneOf(expected, 'type'));
    else {
        var type = $78623ba8b47f0d8a$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($78623ba8b47f0d8a$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$78623ba8b47f0d8a$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$78623ba8b47f0d8a$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$78623ba8b47f0d8a$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$78623ba8b47f0d8a$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$78623ba8b47f0d8a$export$e45cb6485273080e = $78623ba8b47f0d8a$var$codes;

});


parcelRegister("6APwg", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
/*<replacement>*/ var $4cce118ae2f1e391$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $4cce118ae2f1e391$var$Duplex;

var $52Vgn = parcelRequire("52Vgn");

var $1uEw0 = parcelRequire("1uEw0");

(parcelRequire("dhT4G"))($4cce118ae2f1e391$var$Duplex, $52Vgn);
// Allow the keys array to be GC'ed.
var $4cce118ae2f1e391$var$keys = $4cce118ae2f1e391$var$objectKeys($1uEw0.prototype);
for(var $4cce118ae2f1e391$var$v = 0; $4cce118ae2f1e391$var$v < $4cce118ae2f1e391$var$keys.length; $4cce118ae2f1e391$var$v++){
    var $4cce118ae2f1e391$var$method = $4cce118ae2f1e391$var$keys[$4cce118ae2f1e391$var$v];
    if (!$4cce118ae2f1e391$var$Duplex.prototype[$4cce118ae2f1e391$var$method]) $4cce118ae2f1e391$var$Duplex.prototype[$4cce118ae2f1e391$var$method] = $1uEw0.prototype[$4cce118ae2f1e391$var$method];
}
function $4cce118ae2f1e391$var$Duplex(options) {
    if (!(this instanceof $4cce118ae2f1e391$var$Duplex)) return new $4cce118ae2f1e391$var$Duplex(options);
    $52Vgn.call(this, options);
    $1uEw0.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $4cce118ae2f1e391$var$onend);
        }
    }
}
Object.defineProperty($4cce118ae2f1e391$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($4cce118ae2f1e391$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($4cce118ae2f1e391$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $4cce118ae2f1e391$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $4ZL0H.nextTick($4cce118ae2f1e391$var$onEndNT, this);
}
function $4cce118ae2f1e391$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($4cce118ae2f1e391$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("1uEw0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
module.exports = $1168054a9de158f4$var$Writable;
/* <replacement> */ function $1168054a9de158f4$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $1168054a9de158f4$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $1168054a9de158f4$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $1168054a9de158f4$var$Duplex;
/*</replacement>*/ $1168054a9de158f4$var$Writable.WritableState = $1168054a9de158f4$var$WritableState;

/*<replacement>*/ var $1168054a9de158f4$var$internalUtil = {
    deprecate: (parcelRequire("4SymK"))
};

var $kKRZw = parcelRequire("kKRZw");

var $bdjQ6 = parcelRequire("bdjQ6");
var $1168054a9de158f4$require$Buffer = $bdjQ6.Buffer;
var $1168054a9de158f4$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $1168054a9de158f4$var$_uint8ArrayToBuffer(chunk) {
    return $1168054a9de158f4$require$Buffer.from(chunk);
}
function $1168054a9de158f4$var$_isUint8Array(obj) {
    return $1168054a9de158f4$require$Buffer.isBuffer(obj) || obj instanceof $1168054a9de158f4$var$OurUint8Array;
}

var $cIBKQ = parcelRequire("cIBKQ");

var $9LKRZ = parcelRequire("9LKRZ");
var $1168054a9de158f4$var$getHighWaterMark = $9LKRZ.getHighWaterMark;

var $akNAa = parcelRequire("akNAa");
var $1168054a9de158f4$require$_require$codes = $akNAa.codes;
var $1168054a9de158f4$var$ERR_INVALID_ARG_TYPE = $1168054a9de158f4$require$_require$codes.ERR_INVALID_ARG_TYPE, $1168054a9de158f4$var$ERR_METHOD_NOT_IMPLEMENTED = $1168054a9de158f4$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $1168054a9de158f4$var$ERR_MULTIPLE_CALLBACK = $1168054a9de158f4$require$_require$codes.ERR_MULTIPLE_CALLBACK, $1168054a9de158f4$var$ERR_STREAM_CANNOT_PIPE = $1168054a9de158f4$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $1168054a9de158f4$var$ERR_STREAM_DESTROYED = $1168054a9de158f4$require$_require$codes.ERR_STREAM_DESTROYED, $1168054a9de158f4$var$ERR_STREAM_NULL_VALUES = $1168054a9de158f4$require$_require$codes.ERR_STREAM_NULL_VALUES, $1168054a9de158f4$var$ERR_STREAM_WRITE_AFTER_END = $1168054a9de158f4$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $1168054a9de158f4$var$ERR_UNKNOWN_ENCODING = $1168054a9de158f4$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $1168054a9de158f4$var$errorOrDestroy = $cIBKQ.errorOrDestroy;

(parcelRequire("dhT4G"))($1168054a9de158f4$var$Writable, $kKRZw);
function $1168054a9de158f4$var$nop() {}

function $1168054a9de158f4$var$WritableState(options, stream, isDuplex) {
    $1168054a9de158f4$var$Duplex = $1168054a9de158f4$var$Duplex || (parcelRequire("6APwg"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $1168054a9de158f4$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $1168054a9de158f4$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $1168054a9de158f4$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $1168054a9de158f4$var$CorkedRequest(this);
}
$1168054a9de158f4$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($1168054a9de158f4$var$WritableState.prototype, 'buffer', {
            get: $1168054a9de158f4$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $1168054a9de158f4$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $1168054a9de158f4$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($1168054a9de158f4$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($1168054a9de158f4$var$realHasInstance.call(this, object)) return true;
            if (this !== $1168054a9de158f4$var$Writable) return false;
            return object && object._writableState instanceof $1168054a9de158f4$var$WritableState;
        }
    });
} else $1168054a9de158f4$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $1168054a9de158f4$var$Writable(options) {
    $1168054a9de158f4$var$Duplex = $1168054a9de158f4$var$Duplex || (parcelRequire("6APwg"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $1168054a9de158f4$var$Duplex;
    if (!isDuplex && !$1168054a9de158f4$var$realHasInstance.call($1168054a9de158f4$var$Writable, this)) return new $1168054a9de158f4$var$Writable(options);
    this._writableState = new $1168054a9de158f4$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $kKRZw.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$1168054a9de158f4$var$Writable.prototype.pipe = function() {
    $1168054a9de158f4$var$errorOrDestroy(this, new $1168054a9de158f4$var$ERR_STREAM_CANNOT_PIPE());
};
function $1168054a9de158f4$var$writeAfterEnd(stream, cb) {
    var er = new $1168054a9de158f4$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $1168054a9de158f4$var$errorOrDestroy(stream, er);
    $4ZL0H.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $1168054a9de158f4$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $1168054a9de158f4$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $1168054a9de158f4$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $1168054a9de158f4$var$errorOrDestroy(stream, er);
        $4ZL0H.nextTick(cb, er);
        return false;
    }
    return true;
}
$1168054a9de158f4$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $1168054a9de158f4$var$_isUint8Array(chunk);
    if (isBuf && !$1168054a9de158f4$require$Buffer.isBuffer(chunk)) chunk = $1168054a9de158f4$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $1168054a9de158f4$var$nop;
    if (state.ending) $1168054a9de158f4$var$writeAfterEnd(this, cb);
    else if (isBuf || $1168054a9de158f4$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $1168054a9de158f4$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$1168054a9de158f4$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$1168054a9de158f4$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $1168054a9de158f4$var$clearBuffer(this, state);
    }
};
$1168054a9de158f4$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $1168054a9de158f4$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($1168054a9de158f4$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $1168054a9de158f4$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $1168054a9de158f4$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($1168054a9de158f4$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $1168054a9de158f4$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $1168054a9de158f4$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $1168054a9de158f4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $1168054a9de158f4$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $1168054a9de158f4$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $1168054a9de158f4$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $4ZL0H.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $4ZL0H.nextTick($1168054a9de158f4$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $1168054a9de158f4$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $1168054a9de158f4$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $1168054a9de158f4$var$finishMaybe(stream, state);
    }
}
function $1168054a9de158f4$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $1168054a9de158f4$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $1168054a9de158f4$var$ERR_MULTIPLE_CALLBACK();
    $1168054a9de158f4$var$onwriteStateUpdate(state);
    if (er) $1168054a9de158f4$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $1168054a9de158f4$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $1168054a9de158f4$var$clearBuffer(stream, state);
        if (sync) $4ZL0H.nextTick($1168054a9de158f4$var$afterWrite, stream, state, finished, cb);
        else $1168054a9de158f4$var$afterWrite(stream, state, finished, cb);
    }
}
function $1168054a9de158f4$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $1168054a9de158f4$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $1168054a9de158f4$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $1168054a9de158f4$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $1168054a9de158f4$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $1168054a9de158f4$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $1168054a9de158f4$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $1168054a9de158f4$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$1168054a9de158f4$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $1168054a9de158f4$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$1168054a9de158f4$var$Writable.prototype._writev = null;
$1168054a9de158f4$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $1168054a9de158f4$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($1168054a9de158f4$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $1168054a9de158f4$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $1168054a9de158f4$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $1168054a9de158f4$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $1168054a9de158f4$var$finishMaybe(stream, state);
    });
}
function $1168054a9de158f4$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $4ZL0H.nextTick($1168054a9de158f4$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $1168054a9de158f4$var$finishMaybe(stream, state) {
    var need = $1168054a9de158f4$var$needFinish(state);
    if (need) {
        $1168054a9de158f4$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $1168054a9de158f4$var$endWritable(stream, state, cb) {
    state.ending = true;
    $1168054a9de158f4$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $4ZL0H.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $1168054a9de158f4$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($1168054a9de158f4$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$1168054a9de158f4$var$Writable.prototype.destroy = $cIBKQ.destroy;
$1168054a9de158f4$var$Writable.prototype._undestroy = $cIBKQ.undestroy;
$1168054a9de158f4$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("4SymK", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $38d6dce7fbf76fcf$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $38d6dce7fbf76fcf$var$deprecate(fn, msg) {
    if ($38d6dce7fbf76fcf$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($38d6dce7fbf76fcf$var$config('throwDeprecation')) throw new Error(msg);
            else if ($38d6dce7fbf76fcf$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $38d6dce7fbf76fcf$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("iGJyf", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $d9af7bc5baf161c1$export$63a7aa211a91ed69; }, function (v) { return $d9af7bc5baf161c1$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d9af7bc5baf161c1$export$63a7aa211a91ed69;
'use strict';

var $838j1 = parcelRequire("838j1");
var $d9af7bc5baf161c1$require$Buffer = $838j1.Buffer;
/*</replacement>*/ var $d9af7bc5baf161c1$var$isEncoding = $d9af7bc5baf161c1$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $d9af7bc5baf161c1$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d9af7bc5baf161c1$var$normalizeEncoding(enc) {
    var nenc = $d9af7bc5baf161c1$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($d9af7bc5baf161c1$require$Buffer.isEncoding === $d9af7bc5baf161c1$var$isEncoding || !$d9af7bc5baf161c1$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$d9af7bc5baf161c1$export$63a7aa211a91ed69 = $d9af7bc5baf161c1$var$StringDecoder;
function $d9af7bc5baf161c1$var$StringDecoder(encoding) {
    this.encoding = $d9af7bc5baf161c1$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $d9af7bc5baf161c1$var$utf16Text;
            this.end = $d9af7bc5baf161c1$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $d9af7bc5baf161c1$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $d9af7bc5baf161c1$var$base64Text;
            this.end = $d9af7bc5baf161c1$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d9af7bc5baf161c1$var$simpleWrite;
            this.end = $d9af7bc5baf161c1$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d9af7bc5baf161c1$require$Buffer.allocUnsafe(nb);
}
$d9af7bc5baf161c1$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$d9af7bc5baf161c1$var$StringDecoder.prototype.end = $d9af7bc5baf161c1$var$utf8End;
// Returns only complete characters in a Buffer
$d9af7bc5baf161c1$var$StringDecoder.prototype.text = $d9af7bc5baf161c1$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d9af7bc5baf161c1$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d9af7bc5baf161c1$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d9af7bc5baf161c1$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d9af7bc5baf161c1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d9af7bc5baf161c1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d9af7bc5baf161c1$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d9af7bc5baf161c1$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d9af7bc5baf161c1$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d9af7bc5baf161c1$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d9af7bc5baf161c1$var$utf8Text(buf, i) {
    var total = $d9af7bc5baf161c1$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d9af7bc5baf161c1$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d9af7bc5baf161c1$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d9af7bc5baf161c1$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $d9af7bc5baf161c1$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $d9af7bc5baf161c1$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d9af7bc5baf161c1$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d9af7bc5baf161c1$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});

parcelRegister("84GJs", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
var $5e0fd82fa820676f$var$_Object$setPrototypeO;
function $5e0fd82fa820676f$var$_defineProperty(obj, key, value) {
    key = $5e0fd82fa820676f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5e0fd82fa820676f$var$_toPropertyKey(arg) {
    var key = $5e0fd82fa820676f$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5e0fd82fa820676f$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $faWKl = parcelRequire("faWKl");
var $5e0fd82fa820676f$var$kLastResolve = Symbol('lastResolve');
var $5e0fd82fa820676f$var$kLastReject = Symbol('lastReject');
var $5e0fd82fa820676f$var$kError = Symbol('error');
var $5e0fd82fa820676f$var$kEnded = Symbol('ended');
var $5e0fd82fa820676f$var$kLastPromise = Symbol('lastPromise');
var $5e0fd82fa820676f$var$kHandlePromise = Symbol('handlePromise');
var $5e0fd82fa820676f$var$kStream = Symbol('stream');
function $5e0fd82fa820676f$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $5e0fd82fa820676f$var$readAndResolve(iter) {
    var resolve = iter[$5e0fd82fa820676f$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$5e0fd82fa820676f$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$5e0fd82fa820676f$var$kLastPromise] = null;
            iter[$5e0fd82fa820676f$var$kLastResolve] = null;
            iter[$5e0fd82fa820676f$var$kLastReject] = null;
            resolve($5e0fd82fa820676f$var$createIterResult(data, false));
        }
    }
}
function $5e0fd82fa820676f$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $4ZL0H.nextTick($5e0fd82fa820676f$var$readAndResolve, iter);
}
function $5e0fd82fa820676f$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$5e0fd82fa820676f$var$kEnded]) {
                resolve($5e0fd82fa820676f$var$createIterResult(undefined, true));
                return;
            }
            iter[$5e0fd82fa820676f$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $5e0fd82fa820676f$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $5e0fd82fa820676f$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($5e0fd82fa820676f$var$_Object$setPrototypeO = {
    get stream () {
        return this[$5e0fd82fa820676f$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$5e0fd82fa820676f$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$5e0fd82fa820676f$var$kEnded]) return Promise.resolve($5e0fd82fa820676f$var$createIterResult(undefined, true));
        if (this[$5e0fd82fa820676f$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $4ZL0H.nextTick(function() {
                if (_this[$5e0fd82fa820676f$var$kError]) reject(_this[$5e0fd82fa820676f$var$kError]);
                else resolve($5e0fd82fa820676f$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$5e0fd82fa820676f$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($5e0fd82fa820676f$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$5e0fd82fa820676f$var$kStream].read();
            if (data !== null) return Promise.resolve($5e0fd82fa820676f$var$createIterResult(data, false));
            promise = new Promise(this[$5e0fd82fa820676f$var$kHandlePromise]);
        }
        this[$5e0fd82fa820676f$var$kLastPromise] = promise;
        return promise;
    }
}, $5e0fd82fa820676f$var$_defineProperty($5e0fd82fa820676f$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $5e0fd82fa820676f$var$_defineProperty($5e0fd82fa820676f$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$5e0fd82fa820676f$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($5e0fd82fa820676f$var$createIterResult(undefined, true));
        });
    });
}), $5e0fd82fa820676f$var$_Object$setPrototypeO), $5e0fd82fa820676f$var$AsyncIteratorPrototype);
var $5e0fd82fa820676f$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($5e0fd82fa820676f$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kStream, {
        value: stream,
        writable: true
    }), $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kLastResolve, {
        value: null,
        writable: true
    }), $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kLastReject, {
        value: null,
        writable: true
    }), $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kError, {
        value: null,
        writable: true
    }), $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $5e0fd82fa820676f$var$_defineProperty(_Object$create, $5e0fd82fa820676f$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$5e0fd82fa820676f$var$kStream].read();
            if (data) {
                iterator[$5e0fd82fa820676f$var$kLastPromise] = null;
                iterator[$5e0fd82fa820676f$var$kLastResolve] = null;
                iterator[$5e0fd82fa820676f$var$kLastReject] = null;
                resolve($5e0fd82fa820676f$var$createIterResult(data, false));
            } else {
                iterator[$5e0fd82fa820676f$var$kLastResolve] = resolve;
                iterator[$5e0fd82fa820676f$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$5e0fd82fa820676f$var$kLastPromise] = null;
    $faWKl(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$5e0fd82fa820676f$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$5e0fd82fa820676f$var$kLastPromise] = null;
                iterator[$5e0fd82fa820676f$var$kLastResolve] = null;
                iterator[$5e0fd82fa820676f$var$kLastReject] = null;
                reject(err);
            }
            iterator[$5e0fd82fa820676f$var$kError] = err;
            return;
        }
        var resolve = iterator[$5e0fd82fa820676f$var$kLastResolve];
        if (resolve !== null) {
            iterator[$5e0fd82fa820676f$var$kLastPromise] = null;
            iterator[$5e0fd82fa820676f$var$kLastResolve] = null;
            iterator[$5e0fd82fa820676f$var$kLastReject] = null;
            resolve($5e0fd82fa820676f$var$createIterResult(undefined, true));
        }
        iterator[$5e0fd82fa820676f$var$kEnded] = true;
    });
    stream.on('readable', $5e0fd82fa820676f$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $5e0fd82fa820676f$var$createReadableStreamAsyncIterator;

});
parcelRegister("faWKl", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $b0c55c009ac329cf$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("akNAa")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $b0c55c009ac329cf$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $b0c55c009ac329cf$var$noop() {}
function $b0c55c009ac329cf$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $b0c55c009ac329cf$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $b0c55c009ac329cf$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $b0c55c009ac329cf$var$once(callback || $b0c55c009ac329cf$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $b0c55c009ac329cf$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $b0c55c009ac329cf$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($b0c55c009ac329cf$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $b0c55c009ac329cf$var$eos;

});


parcelRegister("dp7AE", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("6H0L1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $4df758a4af864665$var$Transform;

var $akNAa = parcelRequire("akNAa");
var $4df758a4af864665$require$_require$codes = $akNAa.codes;
var $4df758a4af864665$var$ERR_METHOD_NOT_IMPLEMENTED = $4df758a4af864665$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $4df758a4af864665$var$ERR_MULTIPLE_CALLBACK = $4df758a4af864665$require$_require$codes.ERR_MULTIPLE_CALLBACK, $4df758a4af864665$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $4df758a4af864665$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $4df758a4af864665$var$ERR_TRANSFORM_WITH_LENGTH_0 = $4df758a4af864665$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $6APwg = parcelRequire("6APwg");

(parcelRequire("dhT4G"))($4df758a4af864665$var$Transform, $6APwg);
function $4df758a4af864665$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $4df758a4af864665$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $4df758a4af864665$var$Transform(options) {
    if (!(this instanceof $4df758a4af864665$var$Transform)) return new $4df758a4af864665$var$Transform(options);
    $6APwg.call(this, options);
    this._transformState = {
        afterTransform: $4df758a4af864665$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $4df758a4af864665$var$prefinish);
}
function $4df758a4af864665$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $4df758a4af864665$var$done(_this, er, data);
    });
    else $4df758a4af864665$var$done(this, null, null);
}
$4df758a4af864665$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $6APwg.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$4df758a4af864665$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $4df758a4af864665$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$4df758a4af864665$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$4df758a4af864665$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$4df758a4af864665$var$Transform.prototype._destroy = function(err, cb) {
    $6APwg.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $4df758a4af864665$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $4df758a4af864665$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $4df758a4af864665$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("e2OS0", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $a398b6599795cfb9$var$PassThrough;

var $6H0L1 = parcelRequire("6H0L1");

(parcelRequire("dhT4G"))($a398b6599795cfb9$var$PassThrough, $6H0L1);
function $a398b6599795cfb9$var$PassThrough(options) {
    if (!(this instanceof $a398b6599795cfb9$var$PassThrough)) return new $a398b6599795cfb9$var$PassThrough(options);
    $6H0L1.call(this, options);
}
$a398b6599795cfb9$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("9Mw7i", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $71f18271492cbec4$var$eos;
function $71f18271492cbec4$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $akNAa = parcelRequire("akNAa");
var $71f18271492cbec4$require$_require$codes = $akNAa.codes;
var $71f18271492cbec4$var$ERR_MISSING_ARGS = $71f18271492cbec4$require$_require$codes.ERR_MISSING_ARGS, $71f18271492cbec4$var$ERR_STREAM_DESTROYED = $71f18271492cbec4$require$_require$codes.ERR_STREAM_DESTROYED;
function $71f18271492cbec4$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $71f18271492cbec4$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $71f18271492cbec4$var$destroyer(stream, reading, writing, callback) {
    callback = $71f18271492cbec4$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($71f18271492cbec4$var$eos === undefined) $71f18271492cbec4$var$eos = (parcelRequire("faWKl"));
    $71f18271492cbec4$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($71f18271492cbec4$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $71f18271492cbec4$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $71f18271492cbec4$var$call(fn) {
    fn();
}
function $71f18271492cbec4$var$pipe(from, to) {
    return from.pipe(to);
}
function $71f18271492cbec4$var$popCallback(streams) {
    if (!streams.length) return $71f18271492cbec4$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $71f18271492cbec4$var$noop;
    return streams.pop();
}
function $71f18271492cbec4$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $71f18271492cbec4$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $71f18271492cbec4$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $71f18271492cbec4$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($71f18271492cbec4$var$call);
            if (reading) return;
            destroys.forEach($71f18271492cbec4$var$call);
            callback(error);
        });
    });
    return streams.reduce($71f18271492cbec4$var$pipe);
}
module.exports = $71f18271492cbec4$var$pipeline;

});


parcelRegister("5LV4O", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
var $433d9dc7b7117565$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $433d9dc7b7117565$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$433d9dc7b7117565$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($433d9dc7b7117565$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($433d9dc7b7117565$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($433d9dc7b7117565$var$isNull(x) || !$433d9dc7b7117565$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $433d9dc7b7117565$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($4ZL0H.throwDeprecation) throw new Error(msg);
            else if ($4ZL0H.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $433d9dc7b7117565$var$debugs = {};
var $433d9dc7b7117565$var$debugEnvRegex = /^$/;
var $433d9dc7b7117565$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$433d9dc7b7117565$var$debugs[set]) {
        if ($433d9dc7b7117565$var$debugEnvRegex.test(set)) {
            var pid = $4ZL0H.pid;
            $433d9dc7b7117565$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $433d9dc7b7117565$var$debugs[set] = function() {};
    }
    return $433d9dc7b7117565$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $433d9dc7b7117565$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $433d9dc7b7117565$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($433d9dc7b7117565$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($433d9dc7b7117565$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($433d9dc7b7117565$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($433d9dc7b7117565$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($433d9dc7b7117565$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $433d9dc7b7117565$var$stylizeWithColor;
    return $433d9dc7b7117565$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $433d9dc7b7117565$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$433d9dc7b7117565$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$433d9dc7b7117565$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $433d9dc7b7117565$var$stylizeWithColor(str, styleType) {
    var style = $433d9dc7b7117565$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $433d9dc7b7117565$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $433d9dc7b7117565$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $433d9dc7b7117565$var$stylizeNoColor(str, styleType) {
    return str;
}
function $433d9dc7b7117565$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $433d9dc7b7117565$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $433d9dc7b7117565$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$433d9dc7b7117565$var$isString(ret)) ret = $433d9dc7b7117565$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $433d9dc7b7117565$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $433d9dc7b7117565$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($433d9dc7b7117565$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $433d9dc7b7117565$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($433d9dc7b7117565$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($433d9dc7b7117565$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($433d9dc7b7117565$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($433d9dc7b7117565$var$isError(value)) return $433d9dc7b7117565$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($433d9dc7b7117565$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($433d9dc7b7117565$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($433d9dc7b7117565$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($433d9dc7b7117565$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($433d9dc7b7117565$var$isError(value)) base = ' ' + $433d9dc7b7117565$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($433d9dc7b7117565$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $433d9dc7b7117565$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $433d9dc7b7117565$var$reduceToSingleString(output, base, braces);
}
function $433d9dc7b7117565$var$formatPrimitive(ctx, value) {
    if ($433d9dc7b7117565$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($433d9dc7b7117565$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($433d9dc7b7117565$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($433d9dc7b7117565$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($433d9dc7b7117565$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $433d9dc7b7117565$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $433d9dc7b7117565$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($433d9dc7b7117565$var$hasOwnProperty(value, String(i))) output.push($433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $433d9dc7b7117565$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$433d9dc7b7117565$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($433d9dc7b7117565$var$isNull(recurseTimes)) str = $433d9dc7b7117565$var$formatValue(ctx, desc.value, null);
            else str = $433d9dc7b7117565$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($433d9dc7b7117565$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $433d9dc7b7117565$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("84NGl"));
function $433d9dc7b7117565$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $433d9dc7b7117565$var$isArray;
function $433d9dc7b7117565$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $433d9dc7b7117565$var$isBoolean;
function $433d9dc7b7117565$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $433d9dc7b7117565$var$isNull;
function $433d9dc7b7117565$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $433d9dc7b7117565$var$isNullOrUndefined;
function $433d9dc7b7117565$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $433d9dc7b7117565$var$isNumber;
function $433d9dc7b7117565$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $433d9dc7b7117565$var$isString;
function $433d9dc7b7117565$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $433d9dc7b7117565$var$isSymbol;
function $433d9dc7b7117565$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $433d9dc7b7117565$var$isUndefined;
function $433d9dc7b7117565$var$isRegExp(re) {
    return $433d9dc7b7117565$var$isObject(re) && $433d9dc7b7117565$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $433d9dc7b7117565$var$isRegExp;
module.exports.types.isRegExp = $433d9dc7b7117565$var$isRegExp;
function $433d9dc7b7117565$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $433d9dc7b7117565$var$isObject;
function $433d9dc7b7117565$var$isDate(d) {
    return $433d9dc7b7117565$var$isObject(d) && $433d9dc7b7117565$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $433d9dc7b7117565$var$isDate;
module.exports.types.isDate = $433d9dc7b7117565$var$isDate;
function $433d9dc7b7117565$var$isError(e) {
    return $433d9dc7b7117565$var$isObject(e) && ($433d9dc7b7117565$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $433d9dc7b7117565$var$isError;
module.exports.types.isNativeError = $433d9dc7b7117565$var$isError;
function $433d9dc7b7117565$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $433d9dc7b7117565$var$isFunction;
function $433d9dc7b7117565$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $433d9dc7b7117565$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("15hNQ"));
function $433d9dc7b7117565$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $433d9dc7b7117565$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $433d9dc7b7117565$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $433d9dc7b7117565$var$timestamp() {
    var d = new Date();
    var time = [
        $433d9dc7b7117565$var$pad(d.getHours()),
        $433d9dc7b7117565$var$pad(d.getMinutes()),
        $433d9dc7b7117565$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $433d9dc7b7117565$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $433d9dc7b7117565$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("dhT4G"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$433d9dc7b7117565$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $433d9dc7b7117565$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $433d9dc7b7117565$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($433d9dc7b7117565$var$kCustomPromisifiedSymbol && original[$433d9dc7b7117565$var$kCustomPromisifiedSymbol]) {
        var fn = original[$433d9dc7b7117565$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $433d9dc7b7117565$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($433d9dc7b7117565$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $433d9dc7b7117565$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $433d9dc7b7117565$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $433d9dc7b7117565$var$kCustomPromisifiedSymbol;
function $433d9dc7b7117565$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $433d9dc7b7117565$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $4ZL0H.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $4ZL0H.nextTick($433d9dc7b7117565$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $433d9dc7b7117565$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $433d9dc7b7117565$var$callbackify;

});
parcelRegister("84NGl", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $1CYP9 = parcelRequire("1CYP9");

var $hPT6u = parcelRequire("hPT6u");

var $3y8Uz = parcelRequire("3y8Uz");

var $3v1VX = parcelRequire("3v1VX");
function $5e153c455be43079$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $5e153c455be43079$var$BigIntSupported = typeof BigInt !== 'undefined';
var $5e153c455be43079$var$SymbolSupported = typeof Symbol !== 'undefined';
var $5e153c455be43079$var$ObjectToString = $5e153c455be43079$var$uncurryThis(Object.prototype.toString);
var $5e153c455be43079$var$numberValue = $5e153c455be43079$var$uncurryThis(Number.prototype.valueOf);
var $5e153c455be43079$var$stringValue = $5e153c455be43079$var$uncurryThis(String.prototype.valueOf);
var $5e153c455be43079$var$booleanValue = $5e153c455be43079$var$uncurryThis(Boolean.prototype.valueOf);
if ($5e153c455be43079$var$BigIntSupported) var $5e153c455be43079$var$bigIntValue = $5e153c455be43079$var$uncurryThis(BigInt.prototype.valueOf);
if ($5e153c455be43079$var$SymbolSupported) var $5e153c455be43079$var$symbolValue = $5e153c455be43079$var$uncurryThis(Symbol.prototype.valueOf);
function $5e153c455be43079$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $1CYP9;
module.exports.isGeneratorFunction = $hPT6u;
module.exports.isTypedArray = $3v1VX;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $5e153c455be43079$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $5e153c455be43079$var$isPromise;
function $5e153c455be43079$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $3v1VX(value) || $5e153c455be43079$var$isDataView(value);
}
module.exports.isArrayBufferView = $5e153c455be43079$var$isArrayBufferView;
function $5e153c455be43079$var$isUint8Array(value) {
    return $3y8Uz(value) === 'Uint8Array';
}
module.exports.isUint8Array = $5e153c455be43079$var$isUint8Array;
function $5e153c455be43079$var$isUint8ClampedArray(value) {
    return $3y8Uz(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $5e153c455be43079$var$isUint8ClampedArray;
function $5e153c455be43079$var$isUint16Array(value) {
    return $3y8Uz(value) === 'Uint16Array';
}
module.exports.isUint16Array = $5e153c455be43079$var$isUint16Array;
function $5e153c455be43079$var$isUint32Array(value) {
    return $3y8Uz(value) === 'Uint32Array';
}
module.exports.isUint32Array = $5e153c455be43079$var$isUint32Array;
function $5e153c455be43079$var$isInt8Array(value) {
    return $3y8Uz(value) === 'Int8Array';
}
module.exports.isInt8Array = $5e153c455be43079$var$isInt8Array;
function $5e153c455be43079$var$isInt16Array(value) {
    return $3y8Uz(value) === 'Int16Array';
}
module.exports.isInt16Array = $5e153c455be43079$var$isInt16Array;
function $5e153c455be43079$var$isInt32Array(value) {
    return $3y8Uz(value) === 'Int32Array';
}
module.exports.isInt32Array = $5e153c455be43079$var$isInt32Array;
function $5e153c455be43079$var$isFloat32Array(value) {
    return $3y8Uz(value) === 'Float32Array';
}
module.exports.isFloat32Array = $5e153c455be43079$var$isFloat32Array;
function $5e153c455be43079$var$isFloat64Array(value) {
    return $3y8Uz(value) === 'Float64Array';
}
module.exports.isFloat64Array = $5e153c455be43079$var$isFloat64Array;
function $5e153c455be43079$var$isBigInt64Array(value) {
    return $3y8Uz(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $5e153c455be43079$var$isBigInt64Array;
function $5e153c455be43079$var$isBigUint64Array(value) {
    return $3y8Uz(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $5e153c455be43079$var$isBigUint64Array;
function $5e153c455be43079$var$isMapToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object Map]';
}
$5e153c455be43079$var$isMapToString.working = typeof Map !== 'undefined' && $5e153c455be43079$var$isMapToString(new Map());
function $5e153c455be43079$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $5e153c455be43079$var$isMapToString.working ? $5e153c455be43079$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $5e153c455be43079$var$isMap;
function $5e153c455be43079$var$isSetToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object Set]';
}
$5e153c455be43079$var$isSetToString.working = typeof Set !== 'undefined' && $5e153c455be43079$var$isSetToString(new Set());
function $5e153c455be43079$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $5e153c455be43079$var$isSetToString.working ? $5e153c455be43079$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $5e153c455be43079$var$isSet;
function $5e153c455be43079$var$isWeakMapToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object WeakMap]';
}
$5e153c455be43079$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $5e153c455be43079$var$isWeakMapToString(new WeakMap());
function $5e153c455be43079$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $5e153c455be43079$var$isWeakMapToString.working ? $5e153c455be43079$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $5e153c455be43079$var$isWeakMap;
function $5e153c455be43079$var$isWeakSetToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object WeakSet]';
}
$5e153c455be43079$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $5e153c455be43079$var$isWeakSetToString(new WeakSet());
function $5e153c455be43079$var$isWeakSet(value) {
    return $5e153c455be43079$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $5e153c455be43079$var$isWeakSet;
function $5e153c455be43079$var$isArrayBufferToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$5e153c455be43079$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $5e153c455be43079$var$isArrayBufferToString(new ArrayBuffer());
function $5e153c455be43079$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $5e153c455be43079$var$isArrayBufferToString.working ? $5e153c455be43079$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $5e153c455be43079$var$isArrayBuffer;
function $5e153c455be43079$var$isDataViewToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object DataView]';
}
$5e153c455be43079$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $5e153c455be43079$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $5e153c455be43079$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $5e153c455be43079$var$isDataViewToString.working ? $5e153c455be43079$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $5e153c455be43079$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $5e153c455be43079$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $5e153c455be43079$var$isSharedArrayBufferToString(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $5e153c455be43079$var$isSharedArrayBuffer(value) {
    if (typeof $5e153c455be43079$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $5e153c455be43079$var$isSharedArrayBufferToString.working === 'undefined') $5e153c455be43079$var$isSharedArrayBufferToString.working = $5e153c455be43079$var$isSharedArrayBufferToString(new $5e153c455be43079$var$SharedArrayBufferCopy());
    return $5e153c455be43079$var$isSharedArrayBufferToString.working ? $5e153c455be43079$var$isSharedArrayBufferToString(value) : value instanceof $5e153c455be43079$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $5e153c455be43079$var$isSharedArrayBuffer;
function $5e153c455be43079$var$isAsyncFunction(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $5e153c455be43079$var$isAsyncFunction;
function $5e153c455be43079$var$isMapIterator(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $5e153c455be43079$var$isMapIterator;
function $5e153c455be43079$var$isSetIterator(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $5e153c455be43079$var$isSetIterator;
function $5e153c455be43079$var$isGeneratorObject(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $5e153c455be43079$var$isGeneratorObject;
function $5e153c455be43079$var$isWebAssemblyCompiledModule(value) {
    return $5e153c455be43079$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $5e153c455be43079$var$isWebAssemblyCompiledModule;
function $5e153c455be43079$var$isNumberObject(value) {
    return $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$numberValue);
}
module.exports.isNumberObject = $5e153c455be43079$var$isNumberObject;
function $5e153c455be43079$var$isStringObject(value) {
    return $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$stringValue);
}
module.exports.isStringObject = $5e153c455be43079$var$isStringObject;
function $5e153c455be43079$var$isBooleanObject(value) {
    return $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$booleanValue);
}
module.exports.isBooleanObject = $5e153c455be43079$var$isBooleanObject;
function $5e153c455be43079$var$isBigIntObject(value) {
    return $5e153c455be43079$var$BigIntSupported && $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$bigIntValue);
}
module.exports.isBigIntObject = $5e153c455be43079$var$isBigIntObject;
function $5e153c455be43079$var$isSymbolObject(value) {
    return $5e153c455be43079$var$SymbolSupported && $5e153c455be43079$var$checkBoxedPrimitive(value, $5e153c455be43079$var$symbolValue);
}
module.exports.isSymbolObject = $5e153c455be43079$var$isSymbolObject;
function $5e153c455be43079$var$isBoxedPrimitive(value) {
    return $5e153c455be43079$var$isNumberObject(value) || $5e153c455be43079$var$isStringObject(value) || $5e153c455be43079$var$isBooleanObject(value) || $5e153c455be43079$var$isBigIntObject(value) || $5e153c455be43079$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $5e153c455be43079$var$isBoxedPrimitive;
function $5e153c455be43079$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($5e153c455be43079$var$isArrayBuffer(value) || $5e153c455be43079$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $5e153c455be43079$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("1CYP9", function(module, exports) {
'use strict';

var $12f8857680b8d243$var$hasToStringTag = (parcelRequire("1Zhkx"))();

var $eC3A3 = parcelRequire("eC3A3");
var $12f8857680b8d243$var$$toString = $eC3A3('Object.prototype.toString');
/** @type {import('.')} */ var $12f8857680b8d243$var$isStandardArguments = function isArguments(value) {
    if ($12f8857680b8d243$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $12f8857680b8d243$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $12f8857680b8d243$var$isLegacyArguments = function isArguments(value) {
    if ($12f8857680b8d243$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $12f8857680b8d243$var$$toString(value) !== '[object Array]' && 'callee' in value && $12f8857680b8d243$var$$toString(value.callee) === '[object Function]';
};
var $12f8857680b8d243$var$supportsStandardArguments = function() {
    return $12f8857680b8d243$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$12f8857680b8d243$var$isStandardArguments.isLegacyArguments = $12f8857680b8d243$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $12f8857680b8d243$var$supportsStandardArguments ? $12f8857680b8d243$var$isStandardArguments : $12f8857680b8d243$var$isLegacyArguments;

});
parcelRegister("1Zhkx", function(module, exports) {
'use strict';

var $f2BFz = parcelRequire("f2BFz");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $f2BFz() && !!Symbol.toStringTag;
};

});
parcelRegister("f2BFz", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("eC3A3", function(module, exports) {
'use strict';

var $hkNzn = parcelRequire("hkNzn");

var $593ev = parcelRequire("593ev");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $aa3764525413497a$var$$indexOf = $593ev([
    $hkNzn('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $hkNzn(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $aa3764525413497a$var$$indexOf(name, '.prototype.') > -1) return $593ev(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("hkNzn", function(module, exports) {
'use strict';
var $c9eac16840c8f75d$var$undefined1;

var $aEzGq = parcelRequire("aEzGq");

var $6xoeI = parcelRequire("6xoeI");

var $SKRnU = parcelRequire("SKRnU");

var $6iFy7 = parcelRequire("6iFy7");

var $j0Ert = parcelRequire("j0Ert");

var $bw8YX = parcelRequire("bw8YX");

var $5Xz8R = parcelRequire("5Xz8R");

var $62IVw = parcelRequire("62IVw");

var $iuXCA = parcelRequire("iuXCA");

var $57uf1 = parcelRequire("57uf1");

var $8KJjU = parcelRequire("8KJjU");

var $cmoNf = parcelRequire("cmoNf");

var $eaKh2 = parcelRequire("eaKh2");

var $13WPP = parcelRequire("13WPP");

var $g26DA = parcelRequire("g26DA");
var $c9eac16840c8f75d$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $c9eac16840c8f75d$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $c9eac16840c8f75d$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $gNKV7 = parcelRequire("gNKV7");

var $bKXTU = parcelRequire("bKXTU");
var $c9eac16840c8f75d$var$throwTypeError = function() {
    throw new $5Xz8R();
};
var $c9eac16840c8f75d$var$ThrowTypeError = $gNKV7 ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $c9eac16840c8f75d$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $gNKV7(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $c9eac16840c8f75d$var$throwTypeError;
        }
    }
}() : $c9eac16840c8f75d$var$throwTypeError;

var $c9eac16840c8f75d$var$hasSymbols = (parcelRequire("4qQ7b"))();

var $b7uaR = parcelRequire("b7uaR");

var $4kTCn = parcelRequire("4kTCn");

var $1Gomj = parcelRequire("1Gomj");

var $aYzei = parcelRequire("aYzei");

var $bSEx1 = parcelRequire("bSEx1");
var $c9eac16840c8f75d$var$needsEval = {};
var $c9eac16840c8f75d$var$TypedArray = typeof Uint8Array === 'undefined' || !$b7uaR ? undefined : $b7uaR(Uint8Array);
var $c9eac16840c8f75d$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGenerator%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncGeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%AsyncIteratorPrototype%': $c9eac16840c8f75d$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $6xoeI,
    '%eval%': eval,
    '%EvalError%': $SKRnU,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $c9eac16840c8f75d$var$$Function,
    '%GeneratorFunction%': $c9eac16840c8f75d$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR($b7uaR([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$b7uaR ? undefined : $b7uaR(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $aEzGq,
    '%Object.getOwnPropertyDescriptor%': $gNKV7,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $6iFy7,
    '%ReferenceError%': $j0Ert,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$c9eac16840c8f75d$var$hasSymbols || !$b7uaR ? undefined : $b7uaR(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $c9eac16840c8f75d$var$hasSymbols && $b7uaR ? $b7uaR(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $c9eac16840c8f75d$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $bw8YX,
    '%ThrowTypeError%': $c9eac16840c8f75d$var$ThrowTypeError,
    '%TypedArray%': $c9eac16840c8f75d$var$TypedArray,
    '%TypeError%': $5Xz8R,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $62IVw,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $bSEx1,
    '%Function.prototype.apply%': $aYzei,
    '%Object.defineProperty%': $bKXTU,
    '%Object.getPrototypeOf%': $4kTCn,
    '%Math.abs%': $iuXCA,
    '%Math.floor%': $57uf1,
    '%Math.max%': $8KJjU,
    '%Math.min%': $cmoNf,
    '%Math.pow%': $eaKh2,
    '%Math.round%': $13WPP,
    '%Math.sign%': $g26DA,
    '%Reflect.getPrototypeOf%': $1Gomj
};
if ($b7uaR) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $c9eac16840c8f75d$var$errorProto = $b7uaR($b7uaR(e));
    $c9eac16840c8f75d$var$INTRINSICS['%Error.prototype%'] = $c9eac16840c8f75d$var$errorProto;
}
var $c9eac16840c8f75d$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $c9eac16840c8f75d$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $b7uaR) value = $b7uaR(gen.prototype);
    }
    $c9eac16840c8f75d$var$INTRINSICS[name] = value;
    return value;
};
var $c9eac16840c8f75d$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $eQ7C3 = parcelRequire("eQ7C3");

var $8byr2 = parcelRequire("8byr2");
var $c9eac16840c8f75d$var$$concat = $eQ7C3.call($bSEx1, Array.prototype.concat);
var $c9eac16840c8f75d$var$$spliceApply = $eQ7C3.call($aYzei, Array.prototype.splice);
var $c9eac16840c8f75d$var$$replace = $eQ7C3.call($bSEx1, String.prototype.replace);
var $c9eac16840c8f75d$var$$strSlice = $eQ7C3.call($bSEx1, String.prototype.slice);
var $c9eac16840c8f75d$var$$exec = $eQ7C3.call($bSEx1, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $c9eac16840c8f75d$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $c9eac16840c8f75d$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $c9eac16840c8f75d$var$stringToPath = function stringToPath(string) {
    var first = $c9eac16840c8f75d$var$$strSlice(string, 0, 1);
    var last = $c9eac16840c8f75d$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $bw8YX('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $bw8YX('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $c9eac16840c8f75d$var$$replace(string, $c9eac16840c8f75d$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $c9eac16840c8f75d$var$$replace(subString, $c9eac16840c8f75d$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $c9eac16840c8f75d$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($8byr2($c9eac16840c8f75d$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $c9eac16840c8f75d$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($8byr2($c9eac16840c8f75d$var$INTRINSICS, intrinsicName)) {
        var value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicName];
        if (value === $c9eac16840c8f75d$var$needsEval) value = $c9eac16840c8f75d$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $5Xz8R('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $bw8YX('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $5Xz8R('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $5Xz8R('"allowMissing" argument must be a boolean');
    if ($c9eac16840c8f75d$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $bw8YX('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $c9eac16840c8f75d$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $c9eac16840c8f75d$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $c9eac16840c8f75d$var$$spliceApply(parts, $c9eac16840c8f75d$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $c9eac16840c8f75d$var$$strSlice(part, 0, 1);
        var last = $c9eac16840c8f75d$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $bw8YX('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($8byr2($c9eac16840c8f75d$var$INTRINSICS, intrinsicRealName)) value = $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $5Xz8R('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($gNKV7 && i + 1 >= parts.length) {
                var desc = $gNKV7(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $8byr2(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $c9eac16840c8f75d$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("aEzGq", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("6xoeI", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("SKRnU", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("6iFy7", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("j0Ert", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("bw8YX", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("5Xz8R", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("62IVw", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("iuXCA", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("57uf1", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("8KJjU", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("cmoNf", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("eaKh2", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("13WPP", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("g26DA", function(module, exports) {
'use strict';

var $8hbPu = parcelRequire("8hbPu");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($8hbPu(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("8hbPu", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("gNKV7", function(module, exports) {
'use strict';

var $87tme = parcelRequire("87tme");
var $c3b59e512f612c17$require$$gOPD = $87tme;
if ($c3b59e512f612c17$require$$gOPD) try {
    $c3b59e512f612c17$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $c3b59e512f612c17$require$$gOPD = null;
}
module.exports = $c3b59e512f612c17$require$$gOPD;

});
parcelRegister("87tme", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("bKXTU", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $88f2749ea03868eb$var$$defineProperty = Object.defineProperty || false;
if ($88f2749ea03868eb$var$$defineProperty) try {
    $88f2749ea03868eb$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $88f2749ea03868eb$var$$defineProperty = false;
}
module.exports = $88f2749ea03868eb$var$$defineProperty;

});

parcelRegister("4qQ7b", function(module, exports) {
'use strict';
var $33a204135f6b8445$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $f2BFz = parcelRequire("f2BFz");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $33a204135f6b8445$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $33a204135f6b8445$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $f2BFz();
};

});

parcelRegister("b7uaR", function(module, exports) {
'use strict';

var $1Gomj = parcelRequire("1Gomj");

var $4kTCn = parcelRequire("4kTCn");

var $2mxVo = parcelRequire("2mxVo");
/** @type {import('.')} */ module.exports = $1Gomj ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $1Gomj(O);
} : $4kTCn ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $4kTCn(O);
} : $2mxVo ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $2mxVo(O);
} : null;

});
parcelRegister("1Gomj", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("4kTCn", function(module, exports) {
'use strict';

var $aEzGq = parcelRequire("aEzGq");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $aEzGq.getPrototypeOf || null;

});

parcelRegister("2mxVo", function(module, exports) {
'use strict';

var $593ev = parcelRequire("593ev");

var $gNKV7 = parcelRequire("gNKV7");
var $1b87f3939656d8ea$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $1b87f3939656d8ea$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $1b87f3939656d8ea$var$desc = !!$1b87f3939656d8ea$var$hasProtoAccessor && $gNKV7 && $gNKV7(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $1b87f3939656d8ea$var$$Object = Object;
var $1b87f3939656d8ea$var$$getPrototypeOf = $1b87f3939656d8ea$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $1b87f3939656d8ea$var$desc && typeof $1b87f3939656d8ea$var$desc.get === 'function' ? $593ev([
    $1b87f3939656d8ea$var$desc.get
]) : typeof $1b87f3939656d8ea$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $1b87f3939656d8ea$var$$getPrototypeOf(value == null ? value : $1b87f3939656d8ea$var$$Object(value));
} : false;

});
parcelRegister("593ev", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $5Xz8R = parcelRequire("5Xz8R");

var $bSEx1 = parcelRequire("bSEx1");

var $04tsO = parcelRequire("04tsO");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $5Xz8R('a function is required');
    return $04tsO($eQ7C3, $bSEx1, args);
};

});
parcelRegister("eQ7C3", function(module, exports) {
'use strict';

var $gfKZG = parcelRequire("gfKZG");
module.exports = Function.prototype.bind || $gfKZG;

});
parcelRegister("gfKZG", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $bd52800b6fae4c57$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $bd52800b6fae4c57$var$toStr = Object.prototype.toString;
var $bd52800b6fae4c57$var$max = Math.max;
var $bd52800b6fae4c57$var$funcType = '[object Function]';
var $bd52800b6fae4c57$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $bd52800b6fae4c57$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $bd52800b6fae4c57$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $bd52800b6fae4c57$var$toStr.apply(target) !== $bd52800b6fae4c57$var$funcType) throw new TypeError($bd52800b6fae4c57$var$ERROR_MESSAGE + target);
    var args = $bd52800b6fae4c57$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $bd52800b6fae4c57$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $bd52800b6fae4c57$var$concatty(args, arguments));
    };
    var boundLength = $bd52800b6fae4c57$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $bd52800b6fae4c57$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("bSEx1", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("04tsO", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $aYzei = parcelRequire("aYzei");

var $bSEx1 = parcelRequire("bSEx1");

var $fYjQh = parcelRequire("fYjQh");
/** @type {import('./actualApply')} */ module.exports = $fYjQh || $eQ7C3.call($bSEx1, $aYzei);

});
parcelRegister("aYzei", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("fYjQh", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("8byr2", function(module, exports) {
'use strict';
var $5f5a0fe320c1ef2a$var$call = Function.prototype.call;
var $5f5a0fe320c1ef2a$var$$hasOwn = Object.prototype.hasOwnProperty;

var $eQ7C3 = parcelRequire("eQ7C3");
/** @type {import('.')} */ module.exports = $eQ7C3.call($5f5a0fe320c1ef2a$var$call, $5f5a0fe320c1ef2a$var$$hasOwn);

});




parcelRegister("hPT6u", function(module, exports) {
'use strict';

var $eC3A3 = parcelRequire("eC3A3");

var $8IoOS = parcelRequire("8IoOS");
var $cfc1f18425c87f72$var$isFnRegex = $8IoOS(/^\s*(?:function)?\*/);

var $cfc1f18425c87f72$var$hasToStringTag = (parcelRequire("1Zhkx"))();

var $b7uaR = parcelRequire("b7uaR");
var $cfc1f18425c87f72$var$toStr = $eC3A3('Object.prototype.toString');
var $cfc1f18425c87f72$var$fnToStr = $eC3A3('Function.prototype.toString');

var $44bcj = parcelRequire("44bcj");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($cfc1f18425c87f72$var$isFnRegex($cfc1f18425c87f72$var$fnToStr(fn))) return true;
    if (!$cfc1f18425c87f72$var$hasToStringTag) {
        var str = $cfc1f18425c87f72$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$b7uaR) return false;
    var GeneratorFunction = $44bcj();
    return GeneratorFunction && $b7uaR(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("8IoOS", function(module, exports) {
'use strict';

var $eC3A3 = parcelRequire("eC3A3");

var $2kOHf = parcelRequire("2kOHf");
var $6585af70518b6cbc$var$$exec = $eC3A3('RegExp.prototype.exec');

var $5Xz8R = parcelRequire("5Xz8R");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$2kOHf(regex)) throw new $5Xz8R('`regex` must be a RegExp');
    return function test(s) {
        return $6585af70518b6cbc$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("2kOHf", function(module, exports) {
'use strict';

var $eC3A3 = parcelRequire("eC3A3");

var $1b34c64db5454254$var$hasToStringTag = (parcelRequire("1Zhkx"))();

var $8byr2 = parcelRequire("8byr2");

var $gNKV7 = parcelRequire("gNKV7");
/** @type {import('.')} */ var $1b34c64db5454254$var$fn;
if ($1b34c64db5454254$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $1b34c64db5454254$var$$exec = $eC3A3('RegExp.prototype.exec');
    /** @type {object} */ var $1b34c64db5454254$var$isRegexMarker = {};
    var $1b34c64db5454254$var$throwRegexMarker = function() {
        throw $1b34c64db5454254$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $1b34c64db5454254$var$badStringifier = {
        toString: $1b34c64db5454254$var$throwRegexMarker,
        valueOf: $1b34c64db5454254$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $1b34c64db5454254$var$badStringifier[Symbol.toPrimitive] = $1b34c64db5454254$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $1b34c64db5454254$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $gNKV7(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $8byr2(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $1b34c64db5454254$var$$exec(value, /** @type {unknown} */ $1b34c64db5454254$var$badStringifier);
        } catch (e) {
            return e === $1b34c64db5454254$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $1b34c64db5454254$var$$toString = $eC3A3('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $1b34c64db5454254$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $1b34c64db5454254$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $1b34c64db5454254$var$$toString(value) === $1b34c64db5454254$var$regexClass;
    };
}
module.exports = $1b34c64db5454254$var$fn;

});


parcelRegister("44bcj", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $2f6038bd01dc2b99$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$2f6038bd01dc2b99$var$cached;

});


parcelRegister("3y8Uz", function(module, exports) {
'use strict';

var $4t3RV = parcelRequire("4t3RV");

var $gxzn4 = parcelRequire("gxzn4");

var $e6nwk = parcelRequire("e6nwk");

var $eC3A3 = parcelRequire("eC3A3");

var $gNKV7 = parcelRequire("gNKV7");

var $b7uaR = parcelRequire("b7uaR");
var $295b75af42290f89$var$$toString = $eC3A3('Object.prototype.toString');

var $295b75af42290f89$var$hasToStringTag = (parcelRequire("1Zhkx"))();
var $295b75af42290f89$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $295b75af42290f89$var$typedArrays = $gxzn4();
var $295b75af42290f89$var$$slice = $eC3A3('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $295b75af42290f89$var$$indexOf = $eC3A3('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $295b75af42290f89$var$cache = {
    __proto__: null
};
if ($295b75af42290f89$var$hasToStringTag && $gNKV7 && $b7uaR) $4t3RV($295b75af42290f89$var$typedArrays, function(typedArray) {
    var arr = new $295b75af42290f89$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $b7uaR) {
        var proto = $b7uaR(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $gNKV7(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $b7uaR(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $gNKV7(superProto, Symbol.toStringTag);
        }
        if (descriptor && descriptor.get) {
            var bound = $e6nwk(descriptor.get);
            $295b75af42290f89$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
        }
    }
});
else $4t3RV($295b75af42290f89$var$typedArrays, function(typedArray) {
    var arr = new $295b75af42290f89$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) {
        var bound = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
        $e6nwk(fn);
        $295b75af42290f89$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = bound;
    }
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $295b75af42290f89$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $4t3RV(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $295b75af42290f89$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $295b75af42290f89$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $295b75af42290f89$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $4t3RV(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $295b75af42290f89$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $295b75af42290f89$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$295b75af42290f89$var$hasToStringTag) {
        /** @type {string} */ var tag = $295b75af42290f89$var$$slice($295b75af42290f89$var$$toString(value), 8, -1);
        if ($295b75af42290f89$var$$indexOf($295b75af42290f89$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $295b75af42290f89$var$trySlices(value);
    }
    if (!$gNKV7) return null;
     // unknown engine
    return $295b75af42290f89$var$tryTypedArrays(value);
};

});
parcelRegister("4t3RV", function(module, exports) {
'use strict';

var $jUn8P = parcelRequire("jUn8P");
var $340cdf18336e158b$var$toStr = Object.prototype.toString;
var $340cdf18336e158b$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $340cdf18336e158b$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($340cdf18336e158b$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $340cdf18336e158b$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $340cdf18336e158b$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($340cdf18336e158b$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $340cdf18336e158b$var$isArray(x) {
    return $340cdf18336e158b$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$jUn8P(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($340cdf18336e158b$var$isArray(list)) $340cdf18336e158b$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $340cdf18336e158b$var$forEachString(list, iterator, receiver);
    else $340cdf18336e158b$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("jUn8P", function(module, exports) {
'use strict';
var $e7e532a9f9e12dda$var$fnToStr = Function.prototype.toString;
var $e7e532a9f9e12dda$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $e7e532a9f9e12dda$var$badArrayLike;
var $e7e532a9f9e12dda$var$isCallableMarker;
if (typeof $e7e532a9f9e12dda$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $e7e532a9f9e12dda$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $e7e532a9f9e12dda$var$isCallableMarker;
        }
    });
    $e7e532a9f9e12dda$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $e7e532a9f9e12dda$var$reflectApply(function() {
        throw 42;
    }, null, $e7e532a9f9e12dda$var$badArrayLike);
} catch (_) {
    if (_ !== $e7e532a9f9e12dda$var$isCallableMarker) $e7e532a9f9e12dda$var$reflectApply = null;
}
else $e7e532a9f9e12dda$var$reflectApply = null;
var $e7e532a9f9e12dda$var$constructorRegex = /^\s*class\b/;
var $e7e532a9f9e12dda$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $e7e532a9f9e12dda$var$fnToStr.call(value);
        return $e7e532a9f9e12dda$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $e7e532a9f9e12dda$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($e7e532a9f9e12dda$var$isES6ClassFn(value)) return false;
        $e7e532a9f9e12dda$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $e7e532a9f9e12dda$var$toStr = Object.prototype.toString;
var $e7e532a9f9e12dda$var$objectClass = '[object Object]';
var $e7e532a9f9e12dda$var$fnClass = '[object Function]';
var $e7e532a9f9e12dda$var$genClass = '[object GeneratorFunction]';
var $e7e532a9f9e12dda$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $e7e532a9f9e12dda$var$ddaClass2 = '[object HTML document.all class]';
var $e7e532a9f9e12dda$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $e7e532a9f9e12dda$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $e7e532a9f9e12dda$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $e7e532a9f9e12dda$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $e7e532a9f9e12dda$var$all = document.all;
    if ($e7e532a9f9e12dda$var$toStr.call($e7e532a9f9e12dda$var$all) === $e7e532a9f9e12dda$var$toStr.call(document.all)) $e7e532a9f9e12dda$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($e7e532a9f9e12dda$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $e7e532a9f9e12dda$var$toStr.call(value);
            return (str === $e7e532a9f9e12dda$var$ddaClass || str === $e7e532a9f9e12dda$var$ddaClass2 || str === $e7e532a9f9e12dda$var$ddaClass3 // opera 12.16
             || str === $e7e532a9f9e12dda$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $e7e532a9f9e12dda$var$reflectApply ? function isCallable(value) {
    if ($e7e532a9f9e12dda$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $e7e532a9f9e12dda$var$reflectApply(value, null, $e7e532a9f9e12dda$var$badArrayLike);
    } catch (e) {
        if (e !== $e7e532a9f9e12dda$var$isCallableMarker) return false;
    }
    return !$e7e532a9f9e12dda$var$isES6ClassFn(value) && $e7e532a9f9e12dda$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($e7e532a9f9e12dda$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($e7e532a9f9e12dda$var$hasToStringTag) return $e7e532a9f9e12dda$var$tryFunctionObject(value);
    if ($e7e532a9f9e12dda$var$isES6ClassFn(value)) return false;
    var strClass = $e7e532a9f9e12dda$var$toStr.call(value);
    if (strClass !== $e7e532a9f9e12dda$var$fnClass && strClass !== $e7e532a9f9e12dda$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $e7e532a9f9e12dda$var$tryFunctionObject(value);
};

});


parcelRegister("gxzn4", function(module, exports) {
'use strict';

var $9nxil = parcelRequire("9nxil");
var $c0ab2a592dd1c9f4$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $9nxil.length; i++)if (typeof $c0ab2a592dd1c9f4$var$g[$9nxil[i]] === 'function') // @ts-expect-error
    out[out.length] = $9nxil[i];
    return out;
};

});
parcelRegister("9nxil", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("e6nwk", function(module, exports) {
'use strict';

var $5i5al = parcelRequire("5i5al");

var $bKXTU = parcelRequire("bKXTU");

var $593ev = parcelRequire("593ev");

var $02PIM = parcelRequire("02PIM");
module.exports = function callBind(originalFunction) {
    var func = $593ev(arguments);
    var adjustedLength = 1 + originalFunction.length - (arguments.length - 1);
    return $5i5al(func, adjustedLength > 0 ? adjustedLength : 0, true);
};
if ($bKXTU) $bKXTU(module.exports, 'apply', {
    value: $02PIM
});
else module.exports.apply = $02PIM;

});
parcelRegister("5i5al", function(module, exports) {
'use strict';

var $hkNzn = parcelRequire("hkNzn");

var $g8VEL = parcelRequire("g8VEL");

var $3da2a40616138e3d$var$hasDescriptors = (parcelRequire("iSORN"))();

var $gNKV7 = parcelRequire("gNKV7");

var $5Xz8R = parcelRequire("5Xz8R");
var $3da2a40616138e3d$var$$floor = $hkNzn('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $5Xz8R('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $3da2a40616138e3d$var$$floor(length) !== length) throw new $5Xz8R('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $gNKV7) {
        var desc = $gNKV7(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($3da2a40616138e3d$var$hasDescriptors) $g8VEL(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $g8VEL(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("g8VEL", function(module, exports) {
'use strict';

var $bKXTU = parcelRequire("bKXTU");

var $bw8YX = parcelRequire("bw8YX");

var $5Xz8R = parcelRequire("5Xz8R");

var $gNKV7 = parcelRequire("gNKV7");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $5Xz8R('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $5Xz8R('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $5Xz8R('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $5Xz8R('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $5Xz8R('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $5Xz8R('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$gNKV7 && $gNKV7(obj, property);
    if ($bKXTU) $bKXTU(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $bw8YX('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("iSORN", function(module, exports) {
'use strict';

var $bKXTU = parcelRequire("bKXTU");
var $dbf4ba30baa712f1$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$bKXTU;
};
$dbf4ba30baa712f1$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$bKXTU) return null;
    try {
        return $bKXTU([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $dbf4ba30baa712f1$var$hasPropertyDescriptors;

});


parcelRegister("02PIM", function(module, exports) {
'use strict';

var $eQ7C3 = parcelRequire("eQ7C3");

var $aYzei = parcelRequire("aYzei");

var $04tsO = parcelRequire("04tsO");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $04tsO($eQ7C3, $aYzei, arguments);
};

});



parcelRegister("3v1VX", function(module, exports) {
'use strict';

var $3y8Uz = parcelRequire("3y8Uz");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$3y8Uz(value);
};

});


parcelRegister("15hNQ", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});



parcelRegister("gUhMZ", function(module, exports) {

var $838j1 = parcelRequire("838j1");
var $c4efacd6ddafd7d8$require$Buffer = $838j1.Buffer;

var $6AcGf = parcelRequire("6AcGf");

var $9YAY5 = parcelRequire("9YAY5");

var $5LV4O = parcelRequire("5LV4O");
var $c4efacd6ddafd7d8$var$MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".';
var $c4efacd6ddafd7d8$var$MSG_INVALID_SECRET = 'secret must be a string or buffer';
var $c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
var $c4efacd6ddafd7d8$var$MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';
var $c4efacd6ddafd7d8$var$supportsKeyObjects = typeof $6AcGf.createPublicKey === 'function';
if ($c4efacd6ddafd7d8$var$supportsKeyObjects) {
    $c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
    $c4efacd6ddafd7d8$var$MSG_INVALID_SECRET += 'or a KeyObject';
}
function $c4efacd6ddafd7d8$var$checkIsPublicKey(key) {
    if ($c4efacd6ddafd7d8$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (!$c4efacd6ddafd7d8$var$supportsKeyObjects) throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key !== 'object') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.type !== 'string') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.asymmetricKeyType !== 'string') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY);
    if (typeof key.export !== 'function') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_VERIFIER_KEY);
}
function $c4efacd6ddafd7d8$var$checkIsPrivateKey(key) {
    if ($c4efacd6ddafd7d8$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return;
    if (typeof key === 'object') return;
    throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_SIGNER_KEY);
}
function $c4efacd6ddafd7d8$var$checkIsSecretKey(key) {
    if ($c4efacd6ddafd7d8$require$Buffer.isBuffer(key)) return;
    if (typeof key === 'string') return key;
    if (!$c4efacd6ddafd7d8$var$supportsKeyObjects) throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_SECRET);
    if (typeof key !== 'object') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_SECRET);
    if (key.type !== 'secret') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_SECRET);
    if (typeof key.export !== 'function') throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_SECRET);
}
function $c4efacd6ddafd7d8$var$fromBase64(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $c4efacd6ddafd7d8$var$toBase64(base64url) {
    base64url = base64url.toString();
    var padding = 4 - base64url.length % 4;
    if (padding !== 4) for(var i = 0; i < padding; ++i)base64url += '=';
    return base64url.replace(/\-/g, '+').replace(/_/g, '/');
}
function $c4efacd6ddafd7d8$var$typeError(template) {
    var args = [].slice.call(arguments, 1);
    var errMsg = $5LV4O.format.bind($5LV4O, template).apply(null, args);
    return new TypeError(errMsg);
}
function $c4efacd6ddafd7d8$var$bufferOrString(obj) {
    return $c4efacd6ddafd7d8$require$Buffer.isBuffer(obj) || typeof obj === 'string';
}
function $c4efacd6ddafd7d8$var$normalizeInput(thing) {
    if (!$c4efacd6ddafd7d8$var$bufferOrString(thing)) thing = JSON.stringify(thing);
    return thing;
}
function $c4efacd6ddafd7d8$var$createHmacSigner(bits) {
    return function sign(thing, secret) {
        $c4efacd6ddafd7d8$var$checkIsSecretKey(secret);
        thing = $c4efacd6ddafd7d8$var$normalizeInput(thing);
        var hmac = $6AcGf.createHmac('sha' + bits, secret);
        var sig = (hmac.update(thing), hmac.digest('base64'));
        return $c4efacd6ddafd7d8$var$fromBase64(sig);
    };
}
var $c4efacd6ddafd7d8$var$bufferEqual;

var $c4efacd6ddafd7d8$var$timingSafeEqual = 'timingSafeEqual' in $6AcGf ? function timingSafeEqual(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $6AcGf.timingSafeEqual(a, b);
} : function timingSafeEqual(a, b) {
    if (!$c4efacd6ddafd7d8$var$bufferEqual) $c4efacd6ddafd7d8$var$bufferEqual = (parcelRequire("2ounp"));
    return $c4efacd6ddafd7d8$var$bufferEqual(a, b);
};
function $c4efacd6ddafd7d8$var$createHmacVerifier(bits) {
    return function verify(thing, signature, secret) {
        var computedSig = $c4efacd6ddafd7d8$var$createHmacSigner(bits)(thing, secret);
        return $c4efacd6ddafd7d8$var$timingSafeEqual($c4efacd6ddafd7d8$require$Buffer.from(signature), $c4efacd6ddafd7d8$require$Buffer.from(computedSig));
    };
}
function $c4efacd6ddafd7d8$var$createKeySigner(bits) {
    return function sign(thing, privateKey) {
        $c4efacd6ddafd7d8$var$checkIsPrivateKey(privateKey);
        thing = $c4efacd6ddafd7d8$var$normalizeInput(thing);
        // Even though we are specifying "RSA" here, this works with ECDSA
        // keys as well.
        var signer = $6AcGf.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
        return $c4efacd6ddafd7d8$var$fromBase64(sig);
    };
}
function $c4efacd6ddafd7d8$var$createKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $c4efacd6ddafd7d8$var$checkIsPublicKey(publicKey);
        thing = $c4efacd6ddafd7d8$var$normalizeInput(thing);
        signature = $c4efacd6ddafd7d8$var$toBase64(signature);
        var verifier = $6AcGf.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify(publicKey, signature, 'base64');
    };
}
function $c4efacd6ddafd7d8$var$createPSSKeySigner(bits) {
    return function sign(thing, privateKey) {
        $c4efacd6ddafd7d8$var$checkIsPrivateKey(privateKey);
        thing = $c4efacd6ddafd7d8$var$normalizeInput(thing);
        var signer = $6AcGf.createSign('RSA-SHA' + bits);
        var sig = (signer.update(thing), signer.sign({
            key: privateKey,
            padding: $6AcGf.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $6AcGf.constants.RSA_PSS_SALTLEN_DIGEST
        }, 'base64'));
        return $c4efacd6ddafd7d8$var$fromBase64(sig);
    };
}
function $c4efacd6ddafd7d8$var$createPSSKeyVerifier(bits) {
    return function verify(thing, signature, publicKey) {
        $c4efacd6ddafd7d8$var$checkIsPublicKey(publicKey);
        thing = $c4efacd6ddafd7d8$var$normalizeInput(thing);
        signature = $c4efacd6ddafd7d8$var$toBase64(signature);
        var verifier = $6AcGf.createVerify('RSA-SHA' + bits);
        verifier.update(thing);
        return verifier.verify({
            key: publicKey,
            padding: $6AcGf.constants.RSA_PKCS1_PSS_PADDING,
            saltLength: $6AcGf.constants.RSA_PSS_SALTLEN_DIGEST
        }, signature, 'base64');
    };
}
function $c4efacd6ddafd7d8$var$createECDSASigner(bits) {
    var inner = $c4efacd6ddafd7d8$var$createKeySigner(bits);
    return function sign() {
        var signature = inner.apply(null, arguments);
        signature = $9YAY5.derToJose(signature, 'ES' + bits);
        return signature;
    };
}
function $c4efacd6ddafd7d8$var$createECDSAVerifer(bits) {
    var inner = $c4efacd6ddafd7d8$var$createKeyVerifier(bits);
    return function verify(thing, signature, publicKey) {
        signature = $9YAY5.joseToDer(signature, 'ES' + bits).toString('base64');
        var result = inner(thing, signature, publicKey);
        return result;
    };
}
function $c4efacd6ddafd7d8$var$createNoneSigner() {
    return function sign() {
        return '';
    };
}
function $c4efacd6ddafd7d8$var$createNoneVerifier() {
    return function verify(thing, signature) {
        return signature === '';
    };
}
module.exports = function jwa(algorithm) {
    var signerFactories = {
        hs: $c4efacd6ddafd7d8$var$createHmacSigner,
        rs: $c4efacd6ddafd7d8$var$createKeySigner,
        ps: $c4efacd6ddafd7d8$var$createPSSKeySigner,
        es: $c4efacd6ddafd7d8$var$createECDSASigner,
        none: $c4efacd6ddafd7d8$var$createNoneSigner
    };
    var verifierFactories = {
        hs: $c4efacd6ddafd7d8$var$createHmacVerifier,
        rs: $c4efacd6ddafd7d8$var$createKeyVerifier,
        ps: $c4efacd6ddafd7d8$var$createPSSKeyVerifier,
        es: $c4efacd6ddafd7d8$var$createECDSAVerifer,
        none: $c4efacd6ddafd7d8$var$createNoneVerifier
    };
    var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
    if (!match) throw $c4efacd6ddafd7d8$var$typeError($c4efacd6ddafd7d8$var$MSG_INVALID_ALGORITHM, algorithm);
    var algo = (match[1] || match[3]).toLowerCase();
    var bits = match[2];
    return {
        sign: signerFactories[algo](bits),
        verify: verifierFactories[algo](bits)
    };
};

});
parcelRegister("6AcGf", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $4caff0eaeff97cc6$export$5f828d93ff035aa8; }, function (v) { return $4caff0eaeff97cc6$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $4caff0eaeff97cc6$export$cd94982b18c6332c; }, function (v) { return $4caff0eaeff97cc6$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $4caff0eaeff97cc6$export$1d518568e4f529b0; }, function (v) { return $4caff0eaeff97cc6$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $4caff0eaeff97cc6$export$5285b6d41c912b41; }, function (v) { return $4caff0eaeff97cc6$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $4caff0eaeff97cc6$export$2fb37efbf6ae0c0e; }, function (v) { return $4caff0eaeff97cc6$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $4caff0eaeff97cc6$export$ab85ecd77ce6a5cd; }, function (v) { return $4caff0eaeff97cc6$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $4caff0eaeff97cc6$export$da39cf97e1eb7c91; }, function (v) { return $4caff0eaeff97cc6$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $4caff0eaeff97cc6$export$52a9039d7177394f; }, function (v) { return $4caff0eaeff97cc6$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $4caff0eaeff97cc6$export$f7201db400317331; }, function (v) { return $4caff0eaeff97cc6$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $4caff0eaeff97cc6$export$448fa22aedc9dbca; }, function (v) { return $4caff0eaeff97cc6$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $4caff0eaeff97cc6$export$b80c7ba289c8fa56; }, function (v) { return $4caff0eaeff97cc6$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $4caff0eaeff97cc6$export$26e5786e8ac8e530; }, function (v) { return $4caff0eaeff97cc6$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $4caff0eaeff97cc6$export$bdd223f16383713e; }, function (v) { return $4caff0eaeff97cc6$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $4caff0eaeff97cc6$export$20533d26f07f1ee0; }, function (v) { return $4caff0eaeff97cc6$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $4caff0eaeff97cc6$export$2f64596b8cbf08b4; }, function (v) { return $4caff0eaeff97cc6$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $4caff0eaeff97cc6$export$2ce6d8d0e8b04e1a; }, function (v) { return $4caff0eaeff97cc6$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $4caff0eaeff97cc6$export$12ada9414fbc594c; }, function (v) { return $4caff0eaeff97cc6$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $4caff0eaeff97cc6$export$f5e7e39d57cd9700; }, function (v) { return $4caff0eaeff97cc6$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $4caff0eaeff97cc6$export$36b6d6ef312eab39; }, function (v) { return $4caff0eaeff97cc6$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $4caff0eaeff97cc6$export$58a258485f1e49f6; }, function (v) { return $4caff0eaeff97cc6$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $4caff0eaeff97cc6$export$dedd8dc3dc62b370; }, function (v) { return $4caff0eaeff97cc6$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $4caff0eaeff97cc6$export$971862a2fcb1bb40; }, function (v) { return $4caff0eaeff97cc6$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $4caff0eaeff97cc6$export$c6ff6a88acbeaf40; }, function (v) { return $4caff0eaeff97cc6$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $4caff0eaeff97cc6$export$fdc27893e98845cc; }, function (v) { return $4caff0eaeff97cc6$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $4caff0eaeff97cc6$export$6671fb9a1323bed; }, function (v) { return $4caff0eaeff97cc6$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $4caff0eaeff97cc6$export$d74daf141a551db; }, function (v) { return $4caff0eaeff97cc6$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $4caff0eaeff97cc6$export$45df7cae684751af; }, function (v) { return $4caff0eaeff97cc6$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $4caff0eaeff97cc6$export$1db683ad541682f6; }, function (v) { return $4caff0eaeff97cc6$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $4caff0eaeff97cc6$export$6f65485f87568e37; }, function (v) { return $4caff0eaeff97cc6$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $4caff0eaeff97cc6$export$91a8e56769aeb334; }, function (v) { return $4caff0eaeff97cc6$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $4caff0eaeff97cc6$export$2d4117e99c2179e4; }, function (v) { return $4caff0eaeff97cc6$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $4caff0eaeff97cc6$export$512823e338ddb1b7; }, function (v) { return $4caff0eaeff97cc6$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $4caff0eaeff97cc6$export$9d0e0c0c4a8d30f3; }, function (v) { return $4caff0eaeff97cc6$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $4caff0eaeff97cc6$export$b9d55ff329113abd; }, function (v) { return $4caff0eaeff97cc6$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $4caff0eaeff97cc6$export$7efb24e2fddf99b9; }, function (v) { return $4caff0eaeff97cc6$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $4caff0eaeff97cc6$export$bb1abf2ce84fc7e8; }, function (v) { return $4caff0eaeff97cc6$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $4caff0eaeff97cc6$export$2f7171e78e524d5e; }, function (v) { return $4caff0eaeff97cc6$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $4caff0eaeff97cc6$export$e1d879b482f37d98; }, function (v) { return $4caff0eaeff97cc6$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $4caff0eaeff97cc6$export$1a988e7317c65621; }, function (v) { return $4caff0eaeff97cc6$export$1a988e7317c65621 = v; });
// eslint-disable-next-line no-multi-assign
var $4caff0eaeff97cc6$export$5f828d93ff035aa8;
var $4caff0eaeff97cc6$export$cd94982b18c6332c;
var $4caff0eaeff97cc6$export$1d518568e4f529b0;
var $4caff0eaeff97cc6$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $4caff0eaeff97cc6$export$2fb37efbf6ae0c0e;
var $4caff0eaeff97cc6$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $4caff0eaeff97cc6$export$da39cf97e1eb7c91;
var $4caff0eaeff97cc6$export$52a9039d7177394f;
var $4caff0eaeff97cc6$export$f7201db400317331;
var $4caff0eaeff97cc6$export$448fa22aedc9dbca;
var $4caff0eaeff97cc6$export$b80c7ba289c8fa56;
var $4caff0eaeff97cc6$export$26e5786e8ac8e530;
var $4caff0eaeff97cc6$export$bdd223f16383713e;
var $4caff0eaeff97cc6$export$20533d26f07f1ee0;
var $4caff0eaeff97cc6$export$2f64596b8cbf08b4;
var $4caff0eaeff97cc6$export$2ce6d8d0e8b04e1a;
var $4caff0eaeff97cc6$export$12ada9414fbc594c;
var $4caff0eaeff97cc6$export$f5e7e39d57cd9700;
var $4caff0eaeff97cc6$export$36b6d6ef312eab39;
var $4caff0eaeff97cc6$export$58a258485f1e49f6;
var $4caff0eaeff97cc6$export$dedd8dc3dc62b370;
var $4caff0eaeff97cc6$export$971862a2fcb1bb40;
var $4caff0eaeff97cc6$export$c6ff6a88acbeaf40;
var $4caff0eaeff97cc6$export$fdc27893e98845cc;
var $4caff0eaeff97cc6$export$6671fb9a1323bed;
var $4caff0eaeff97cc6$export$d74daf141a551db;
var $4caff0eaeff97cc6$export$45df7cae684751af;
var $4caff0eaeff97cc6$export$1db683ad541682f6;
var $4caff0eaeff97cc6$export$6f65485f87568e37;
var $4caff0eaeff97cc6$export$91a8e56769aeb334;
var $4caff0eaeff97cc6$export$2d4117e99c2179e4;
var $4caff0eaeff97cc6$export$512823e338ddb1b7;
var $4caff0eaeff97cc6$export$9d0e0c0c4a8d30f3;
var $4caff0eaeff97cc6$export$b9d55ff329113abd;
var $4caff0eaeff97cc6$export$7efb24e2fddf99b9;
var $4caff0eaeff97cc6$export$bb1abf2ce84fc7e8;
var $4caff0eaeff97cc6$export$2f7171e78e524d5e;
var $4caff0eaeff97cc6$export$e1d879b482f37d98;
var $4caff0eaeff97cc6$export$1a988e7317c65621;
'use strict';

$4caff0eaeff97cc6$export$5f828d93ff035aa8 = $4caff0eaeff97cc6$export$cd94982b18c6332c = $4caff0eaeff97cc6$export$1d518568e4f529b0 = $4caff0eaeff97cc6$export$5285b6d41c912b41 = (parcelRequire("f08he"));

$4caff0eaeff97cc6$export$2fb37efbf6ae0c0e = $4caff0eaeff97cc6$export$ab85ecd77ce6a5cd = (parcelRequire("eNPUV"));

$4caff0eaeff97cc6$export$da39cf97e1eb7c91 = $4caff0eaeff97cc6$export$52a9039d7177394f = (parcelRequire("cL3Ff"));

var $bci9C = parcelRequire("bci9C");
var $4caff0eaeff97cc6$var$algoKeys = Object.keys($bci9C);
var $4caff0eaeff97cc6$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($4caff0eaeff97cc6$var$algoKeys);
$4caff0eaeff97cc6$export$f7201db400317331 = function() {
    return $4caff0eaeff97cc6$var$hashes;
};

var $d0xYH = parcelRequire("d0xYH");
$4caff0eaeff97cc6$export$448fa22aedc9dbca = $d0xYH.pbkdf2;
$4caff0eaeff97cc6$export$b80c7ba289c8fa56 = $d0xYH.pbkdf2Sync;

var $jGT0o = parcelRequire("jGT0o");
$4caff0eaeff97cc6$export$26e5786e8ac8e530 = $jGT0o.Cipher;
$4caff0eaeff97cc6$export$bdd223f16383713e = $jGT0o.createCipher;
$4caff0eaeff97cc6$export$20533d26f07f1ee0 = $jGT0o.Cipheriv;
$4caff0eaeff97cc6$export$2f64596b8cbf08b4 = $jGT0o.createCipheriv;
$4caff0eaeff97cc6$export$2ce6d8d0e8b04e1a = $jGT0o.Decipher;
$4caff0eaeff97cc6$export$12ada9414fbc594c = $jGT0o.createDecipher;
$4caff0eaeff97cc6$export$f5e7e39d57cd9700 = $jGT0o.Decipheriv;
$4caff0eaeff97cc6$export$36b6d6ef312eab39 = $jGT0o.createDecipheriv;
$4caff0eaeff97cc6$export$58a258485f1e49f6 = $jGT0o.getCiphers;
$4caff0eaeff97cc6$export$dedd8dc3dc62b370 = $jGT0o.listCiphers;

var $8wQsp = parcelRequire("8wQsp");
$4caff0eaeff97cc6$export$971862a2fcb1bb40 = $8wQsp.DiffieHellmanGroup;
$4caff0eaeff97cc6$export$c6ff6a88acbeaf40 = $8wQsp.createDiffieHellmanGroup;
$4caff0eaeff97cc6$export$fdc27893e98845cc = $8wQsp.getDiffieHellman;
$4caff0eaeff97cc6$export$6671fb9a1323bed = $8wQsp.createDiffieHellman;
$4caff0eaeff97cc6$export$d74daf141a551db = $8wQsp.DiffieHellman;

var $bASYu = parcelRequire("bASYu");
$4caff0eaeff97cc6$export$45df7cae684751af = $bASYu.createSign;
$4caff0eaeff97cc6$export$1db683ad541682f6 = $bASYu.Sign;
$4caff0eaeff97cc6$export$6f65485f87568e37 = $bASYu.createVerify;
$4caff0eaeff97cc6$export$91a8e56769aeb334 = $bASYu.Verify;

$4caff0eaeff97cc6$export$2d4117e99c2179e4 = (parcelRequire("iT16E"));

var $estFo = parcelRequire("estFo");
$4caff0eaeff97cc6$export$512823e338ddb1b7 = $estFo.publicEncrypt;
$4caff0eaeff97cc6$export$9d0e0c0c4a8d30f3 = $estFo.privateEncrypt;
$4caff0eaeff97cc6$export$b9d55ff329113abd = $estFo.publicDecrypt;
$4caff0eaeff97cc6$export$7efb24e2fddf99b9 = $estFo.privateDecrypt;

var $3yLuA = parcelRequire("3yLuA");
$4caff0eaeff97cc6$export$bb1abf2ce84fc7e8 = $3yLuA.randomFill;
$4caff0eaeff97cc6$export$2f7171e78e524d5e = $3yLuA.randomFillSync;
$4caff0eaeff97cc6$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$4caff0eaeff97cc6$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("f08he", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $aebd46b710a95c96$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $aebd46b710a95c96$var$MAX_UINT32 = 4294967295;
function $aebd46b710a95c96$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $838j1 = parcelRequire("838j1");
var $aebd46b710a95c96$require$Buffer = $838j1.Buffer;
var $aebd46b710a95c96$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($aebd46b710a95c96$var$crypto && $aebd46b710a95c96$var$crypto.getRandomValues) module.exports = $aebd46b710a95c96$var$randomBytes;
else module.exports = $aebd46b710a95c96$var$oldBrowser;
function $aebd46b710a95c96$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $aebd46b710a95c96$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $aebd46b710a95c96$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $aebd46b710a95c96$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $aebd46b710a95c96$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $aebd46b710a95c96$var$crypto.getRandomValues(bytes.slice(generated, generated + $aebd46b710a95c96$var$MAX_BYTES));
        else $aebd46b710a95c96$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $4ZL0H.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("eNPUV", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $2GAk4 = parcelRequire("2GAk4");

var $1Jsb3 = parcelRequire("1Jsb3");

var $15EwC = parcelRequire("15EwC");

var $6GOuC = parcelRequire("6GOuC");
function $ac6de9f97af53a66$var$Hash(hash) {
    $6GOuC.call(this, 'digest');
    this._hash = hash;
}
$dhT4G($ac6de9f97af53a66$var$Hash, $6GOuC);
$ac6de9f97af53a66$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$ac6de9f97af53a66$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $2GAk4();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $1Jsb3();
    return new $ac6de9f97af53a66$var$Hash($15EwC(alg));
};

});
parcelRegister("2GAk4", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $fMFLx = parcelRequire("fMFLx");

var $838j1 = parcelRequire("838j1");
var $1f4badf6a671bb38$require$Buffer = $838j1.Buffer;
var $1f4badf6a671bb38$var$ARRAY16 = new Array(16);
function $1f4badf6a671bb38$var$MD5() {
    $fMFLx.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dhT4G($1f4badf6a671bb38$var$MD5, $fMFLx);
$1f4badf6a671bb38$var$MD5.prototype._update = function() {
    var M = $1f4badf6a671bb38$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $1f4badf6a671bb38$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $1f4badf6a671bb38$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $1f4badf6a671bb38$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $1f4badf6a671bb38$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $1f4badf6a671bb38$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $1f4badf6a671bb38$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $1f4badf6a671bb38$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $1f4badf6a671bb38$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $1f4badf6a671bb38$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $1f4badf6a671bb38$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $1f4badf6a671bb38$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $1f4badf6a671bb38$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $1f4badf6a671bb38$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $1f4badf6a671bb38$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $1f4badf6a671bb38$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $1f4badf6a671bb38$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$1f4badf6a671bb38$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $1f4badf6a671bb38$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $1f4badf6a671bb38$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $1f4badf6a671bb38$var$fnF(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $1f4badf6a671bb38$var$fnG(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $1f4badf6a671bb38$var$fnH(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $1f4badf6a671bb38$var$fnI(a, b, c, d, m, k, s) {
    return $1f4badf6a671bb38$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $1f4badf6a671bb38$var$MD5;

});
parcelRegister("fMFLx", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $b7dbbc848410cd66$require$Buffer = $838j1.Buffer;

var $3DkjE = parcelRequire("3DkjE");
var $b7dbbc848410cd66$require$Transform = $3DkjE.Transform;

var $dhT4G = parcelRequire("dhT4G");
function $b7dbbc848410cd66$var$HashBase(blockSize) {
    $b7dbbc848410cd66$require$Transform.call(this);
    this._block = $b7dbbc848410cd66$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dhT4G($b7dbbc848410cd66$var$HashBase, $b7dbbc848410cd66$require$Transform);
$b7dbbc848410cd66$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$b7dbbc848410cd66$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $b7dbbc848410cd66$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $b7dbbc848410cd66$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($b7dbbc848410cd66$require$Buffer.prototype instanceof Uint8Array || $b7dbbc848410cd66$require$Buffer.TYPED_ARRAY_SUPPORT);
function $b7dbbc848410cd66$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $b7dbbc848410cd66$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $b7dbbc848410cd66$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($b7dbbc848410cd66$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $b7dbbc848410cd66$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $b7dbbc848410cd66$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($b7dbbc848410cd66$var$useUint8Array && data instanceof Uint8Array) return $b7dbbc848410cd66$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($b7dbbc848410cd66$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $b7dbbc848410cd66$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$b7dbbc848410cd66$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $b7dbbc848410cd66$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$b7dbbc848410cd66$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$b7dbbc848410cd66$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$b7dbbc848410cd66$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $b7dbbc848410cd66$var$HashBase;

});


parcelRegister("1Jsb3", function(module, exports) {
'use strict';

var $bdjQ6 = parcelRequire("bdjQ6");
var $142fd9dc489aa108$require$Buffer = $bdjQ6.Buffer;

var $dhT4G = parcelRequire("dhT4G");

var $lV0fd = parcelRequire("lV0fd");
var $142fd9dc489aa108$var$ARRAY16 = new Array(16);
var $142fd9dc489aa108$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $142fd9dc489aa108$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $142fd9dc489aa108$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $142fd9dc489aa108$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $142fd9dc489aa108$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $142fd9dc489aa108$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $142fd9dc489aa108$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $142fd9dc489aa108$var$fn1(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn2(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn3(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn4(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$fn5(a, b, c, d, e, m, k, s) {
    return $142fd9dc489aa108$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $142fd9dc489aa108$var$RIPEMD160() {
    $lV0fd.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dhT4G($142fd9dc489aa108$var$RIPEMD160, $lV0fd);
$142fd9dc489aa108$var$RIPEMD160.prototype._update = function() {
    var words = $142fd9dc489aa108$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $142fd9dc489aa108$var$fn1(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[0], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn5(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[0], $142fd9dc489aa108$var$sr[i]);
        } else if (i < 32) {
            tl = $142fd9dc489aa108$var$fn2(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[1], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn4(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[1], $142fd9dc489aa108$var$sr[i]);
        } else if (i < 48) {
            tl = $142fd9dc489aa108$var$fn3(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[2], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn3(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[2], $142fd9dc489aa108$var$sr[i]);
        } else if (i < 64) {
            tl = $142fd9dc489aa108$var$fn4(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[3], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn2(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[3], $142fd9dc489aa108$var$sr[i]);
        } else {
            tl = $142fd9dc489aa108$var$fn5(al, bl, cl, dl, el, words[$142fd9dc489aa108$var$zl[i]], $142fd9dc489aa108$var$hl[4], $142fd9dc489aa108$var$sl[i]);
            tr = $142fd9dc489aa108$var$fn1(ar, br, cr, dr, er, words[$142fd9dc489aa108$var$zr[i]], $142fd9dc489aa108$var$hr[4], $142fd9dc489aa108$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $142fd9dc489aa108$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $142fd9dc489aa108$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$142fd9dc489aa108$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $142fd9dc489aa108$require$Buffer.alloc ? $142fd9dc489aa108$require$Buffer.alloc(20) : new $142fd9dc489aa108$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $142fd9dc489aa108$var$RIPEMD160;

});
parcelRegister("lV0fd", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $ff4f1c6668d95823$require$Buffer = $838j1.Buffer;

var $a9qQG = parcelRequire("a9qQG");

var $dFZZW = parcelRequire("dFZZW");
var $ff4f1c6668d95823$require$Transform = $dFZZW.Transform;

var $dhT4G = parcelRequire("dhT4G");
function $ff4f1c6668d95823$var$HashBase(blockSize) {
    $ff4f1c6668d95823$require$Transform.call(this);
    this._block = $ff4f1c6668d95823$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dhT4G($ff4f1c6668d95823$var$HashBase, $ff4f1c6668d95823$require$Transform);
$ff4f1c6668d95823$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$ff4f1c6668d95823$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$ff4f1c6668d95823$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $a9qQG(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$ff4f1c6668d95823$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$ff4f1c6668d95823$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$ff4f1c6668d95823$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $ff4f1c6668d95823$var$HashBase;

});
parcelRegister("a9qQG", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $763f923ff3649c26$require$Buffer = $838j1.Buffer;

var $iDFZs = parcelRequire("iDFZs");
var $763f923ff3649c26$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $763f923ff3649c26$var$useArrayBuffer = $763f923ff3649c26$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $763f923ff3649c26$var$isView = $763f923ff3649c26$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $763f923ff3649c26$require$Buffer.isBuffer(thing) || $763f923ff3649c26$var$useUint8Array && thing instanceof Uint8Array || $763f923ff3649c26$var$isView && $763f923ff3649c26$var$isView(thing)) return $iDFZs(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("iDFZs", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $d91c70e90d0fdaa9$require$Buffer = $838j1.Buffer;

var $58ZcN = parcelRequire("58ZcN");

var $awmI8 = parcelRequire("awmI8");
var $d91c70e90d0fdaa9$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $awmI8(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $d91c70e90d0fdaa9$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $d91c70e90d0fdaa9$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $d91c70e90d0fdaa9$var$useFromArrayBuffer = $d91c70e90d0fdaa9$var$useArrayBuffer && ($d91c70e90d0fdaa9$require$Buffer.prototype instanceof Uint8Array || $d91c70e90d0fdaa9$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($d91c70e90d0fdaa9$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $d91c70e90d0fdaa9$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $d91c70e90d0fdaa9$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($d91c70e90d0fdaa9$var$useArrayBuffer && $d91c70e90d0fdaa9$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $d91c70e90d0fdaa9$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($d91c70e90d0fdaa9$var$useFromArrayBuffer) {
            var res = $d91c70e90d0fdaa9$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $d91c70e90d0fdaa9$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($d91c70e90d0fdaa9$var$useUint8Array && data instanceof Uint8Array) return $d91c70e90d0fdaa9$require$Buffer.from(data);
    var isArr = $58ZcN(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $d91c70e90d0fdaa9$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $d91c70e90d0fdaa9$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("58ZcN", function(module, exports) {
var $3bed2d3a94d62fc0$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $3bed2d3a94d62fc0$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("awmI8", function(module, exports) {
'use strict';

var $5Xz8R = parcelRequire("5Xz8R");

var $eC3A3 = parcelRequire("eC3A3");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $7a8e8270e20ed7b6$var$$typedArrayBuffer = $eC3A3('TypedArray.prototype.buffer', true);

var $3v1VX = parcelRequire("3v1VX");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $7a8e8270e20ed7b6$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$3v1VX(x)) throw new $5Xz8R('Not a Typed Array');
    return x.buffer;
};

});



parcelRegister("dFZZW", function(module, exports) {

exports = module.exports = (parcelRequire("g4ZW2"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("g6cJS"));

exports.Duplex = (parcelRequire("hxbeF"));

exports.Transform = (parcelRequire("k0KBi"));

exports.PassThrough = (parcelRequire("jYFEV"));

});
parcelRegister("g4ZW2", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ module.exports = $bb4d100ed8009141$var$Readable;

var $gzvFb = parcelRequire("gzvFb");
/*</replacement>*/ /*<replacement>*/ var $bb4d100ed8009141$var$Duplex;
/*</replacement>*/ $bb4d100ed8009141$var$Readable.ReadableState = $bb4d100ed8009141$var$ReadableState;

var $fzCxw = parcelRequire("fzCxw");
var $bb4d100ed8009141$require$EE = $fzCxw.EventEmitter;
var $bb4d100ed8009141$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $bSqQK = parcelRequire("bSqQK");

var $jfWxI = parcelRequire("jfWxI");
var $bb4d100ed8009141$require$Buffer = $jfWxI.Buffer;
var $bb4d100ed8009141$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $bb4d100ed8009141$var$_uint8ArrayToBuffer(chunk) {
    return $bb4d100ed8009141$require$Buffer.from(chunk);
}
function $bb4d100ed8009141$var$_isUint8Array(obj) {
    return $bb4d100ed8009141$require$Buffer.isBuffer(obj) || obj instanceof $bb4d100ed8009141$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $bb4d100ed8009141$var$util = Object.create((parcelRequire("6PLnu")));

$bb4d100ed8009141$var$util.inherits = (parcelRequire("dhT4G"));

var $ifbub = parcelRequire("ifbub");
var $bb4d100ed8009141$var$debug = void 0;
if ($ifbub && $ifbub.debuglog) $bb4d100ed8009141$var$debug = $ifbub.debuglog('stream');
else $bb4d100ed8009141$var$debug = function() {};

var $jAhDc = parcelRequire("jAhDc");

var $ktkM5 = parcelRequire("ktkM5");
var $bb4d100ed8009141$var$StringDecoder;
$bb4d100ed8009141$var$util.inherits($bb4d100ed8009141$var$Readable, $bSqQK);
var $bb4d100ed8009141$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $bb4d100ed8009141$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($gzvFb(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $bb4d100ed8009141$var$ReadableState(options, stream) {
    $bb4d100ed8009141$var$Duplex = $bb4d100ed8009141$var$Duplex || (parcelRequire("hxbeF"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $bb4d100ed8009141$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $jAhDc();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$bb4d100ed8009141$var$StringDecoder) $bb4d100ed8009141$var$StringDecoder = (parcelRequire("bAIDW")).StringDecoder;
        this.decoder = new $bb4d100ed8009141$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $bb4d100ed8009141$var$Readable(options) {
    $bb4d100ed8009141$var$Duplex = $bb4d100ed8009141$var$Duplex || (parcelRequire("hxbeF"));
    if (!(this instanceof $bb4d100ed8009141$var$Readable)) return new $bb4d100ed8009141$var$Readable(options);
    this._readableState = new $bb4d100ed8009141$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $bSqQK.call(this);
}
Object.defineProperty($bb4d100ed8009141$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$bb4d100ed8009141$var$Readable.prototype.destroy = $ktkM5.destroy;
$bb4d100ed8009141$var$Readable.prototype._undestroy = $ktkM5.undestroy;
$bb4d100ed8009141$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$bb4d100ed8009141$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $bb4d100ed8009141$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $bb4d100ed8009141$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$bb4d100ed8009141$var$Readable.prototype.unshift = function(chunk) {
    return $bb4d100ed8009141$var$readableAddChunk(this, chunk, null, true, false);
};
function $bb4d100ed8009141$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $bb4d100ed8009141$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $bb4d100ed8009141$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $bb4d100ed8009141$require$Buffer.prototype) chunk = $bb4d100ed8009141$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $bb4d100ed8009141$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $bb4d100ed8009141$var$addChunk(stream, state, chunk, false);
                    else $bb4d100ed8009141$var$maybeReadMore(stream, state);
                } else $bb4d100ed8009141$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $bb4d100ed8009141$var$needMoreData(state);
}
function $bb4d100ed8009141$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $bb4d100ed8009141$var$emitReadable(stream);
    }
    $bb4d100ed8009141$var$maybeReadMore(stream, state);
}
function $bb4d100ed8009141$var$chunkInvalid(state, chunk) {
    var er;
    if (!$bb4d100ed8009141$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $bb4d100ed8009141$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$bb4d100ed8009141$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$bb4d100ed8009141$var$Readable.prototype.setEncoding = function(enc) {
    if (!$bb4d100ed8009141$var$StringDecoder) $bb4d100ed8009141$var$StringDecoder = (parcelRequire("bAIDW")).StringDecoder;
    this._readableState.decoder = new $bb4d100ed8009141$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $bb4d100ed8009141$var$MAX_HWM = 0x800000;
function $bb4d100ed8009141$var$computeNewHighWaterMark(n) {
    if (n >= $bb4d100ed8009141$var$MAX_HWM) n = $bb4d100ed8009141$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $bb4d100ed8009141$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$bb4d100ed8009141$var$Readable.prototype.read = function(n) {
    $bb4d100ed8009141$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $bb4d100ed8009141$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $bb4d100ed8009141$var$endReadable(this);
        else $bb4d100ed8009141$var$emitReadable(this);
        return null;
    }
    n = $bb4d100ed8009141$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $bb4d100ed8009141$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $bb4d100ed8009141$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $bb4d100ed8009141$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $bb4d100ed8009141$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $bb4d100ed8009141$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $bb4d100ed8009141$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $bb4d100ed8009141$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $bb4d100ed8009141$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $bb4d100ed8009141$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $bb4d100ed8009141$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $bb4d100ed8009141$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $bb4d100ed8009141$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $e5LkN.nextTick($bb4d100ed8009141$var$emitReadable_, stream);
        else $bb4d100ed8009141$var$emitReadable_(stream);
    }
}
function $bb4d100ed8009141$var$emitReadable_(stream) {
    $bb4d100ed8009141$var$debug('emit readable');
    stream.emit('readable');
    $bb4d100ed8009141$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $bb4d100ed8009141$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $e5LkN.nextTick($bb4d100ed8009141$var$maybeReadMore_, stream, state);
    }
}
function $bb4d100ed8009141$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $bb4d100ed8009141$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$bb4d100ed8009141$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$bb4d100ed8009141$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $bb4d100ed8009141$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $4ZL0H.stdout && dest !== $4ZL0H.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $e5LkN.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $bb4d100ed8009141$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $bb4d100ed8009141$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $bb4d100ed8009141$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $bb4d100ed8009141$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $bb4d100ed8009141$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $bb4d100ed8009141$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $bb4d100ed8009141$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $bb4d100ed8009141$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($bb4d100ed8009141$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $bb4d100ed8009141$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $bb4d100ed8009141$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $bb4d100ed8009141$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $bb4d100ed8009141$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $bb4d100ed8009141$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $bb4d100ed8009141$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $bb4d100ed8009141$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $bb4d100ed8009141$var$flow(src);
        }
    };
}
$bb4d100ed8009141$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $bb4d100ed8009141$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$bb4d100ed8009141$var$Readable.prototype.on = function(ev, fn) {
    var res = $bSqQK.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $e5LkN.nextTick($bb4d100ed8009141$var$nReadingNextTick, this);
            else if (state.length) $bb4d100ed8009141$var$emitReadable(this);
        }
    }
    return res;
};
$bb4d100ed8009141$var$Readable.prototype.addListener = $bb4d100ed8009141$var$Readable.prototype.on;
function $bb4d100ed8009141$var$nReadingNextTick(self1) {
    $bb4d100ed8009141$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$bb4d100ed8009141$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $bb4d100ed8009141$var$debug('resume');
        state.flowing = true;
        $bb4d100ed8009141$var$resume(this, state);
    }
    return this;
};
function $bb4d100ed8009141$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $e5LkN.nextTick($bb4d100ed8009141$var$resume_, stream, state);
    }
}
function $bb4d100ed8009141$var$resume_(stream, state) {
    if (!state.reading) {
        $bb4d100ed8009141$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $bb4d100ed8009141$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$bb4d100ed8009141$var$Readable.prototype.pause = function() {
    $bb4d100ed8009141$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $bb4d100ed8009141$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $bb4d100ed8009141$var$flow(stream) {
    var state = stream._readableState;
    $bb4d100ed8009141$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$bb4d100ed8009141$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $bb4d100ed8009141$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $bb4d100ed8009141$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $bb4d100ed8009141$var$kProxyEvents.length; n++)stream.on($bb4d100ed8009141$var$kProxyEvents[n], this.emit.bind(this, $bb4d100ed8009141$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $bb4d100ed8009141$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($bb4d100ed8009141$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$bb4d100ed8009141$var$Readable._fromList = $bb4d100ed8009141$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $bb4d100ed8009141$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $bb4d100ed8009141$var$copyFromBufferString(n, list) : $bb4d100ed8009141$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $bb4d100ed8009141$var$copyFromBuffer(n, list) {
    var ret = $bb4d100ed8009141$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $bb4d100ed8009141$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $e5LkN.nextTick($bb4d100ed8009141$var$endReadableNT, state, stream);
    }
}
function $bb4d100ed8009141$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $bb4d100ed8009141$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("e5LkN", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
module.exports = {
    nextTick: $a4263fec5066d64f$var$nextTick
};
function $a4263fec5066d64f$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $4ZL0H.nextTick(fn);
        case 2:
            return $4ZL0H.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $4ZL0H.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $4ZL0H.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $4ZL0H.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("gzvFb", function(module, exports) {
var $c10879e6d2766179$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $c10879e6d2766179$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("bSqQK", function(module, exports) {

module.exports = (parcelRequire("fzCxw")).EventEmitter;

});

parcelRegister("jfWxI", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $e04cd46ce8cf6bde$var$Buffer = $bdjQ6.Buffer;
// alternative to using Object.keys for old browsers
function $e04cd46ce8cf6bde$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($e04cd46ce8cf6bde$var$Buffer.from && $e04cd46ce8cf6bde$var$Buffer.alloc && $e04cd46ce8cf6bde$var$Buffer.allocUnsafe && $e04cd46ce8cf6bde$var$Buffer.allocUnsafeSlow) module.exports = $bdjQ6;
else {
    // Copy properties from require('buffer')
    $e04cd46ce8cf6bde$var$copyProps($bdjQ6, module.exports);
    module.exports.Buffer = $e04cd46ce8cf6bde$var$SafeBuffer;
}
function $e04cd46ce8cf6bde$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $e04cd46ce8cf6bde$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$e04cd46ce8cf6bde$var$copyProps($e04cd46ce8cf6bde$var$Buffer, $e04cd46ce8cf6bde$var$SafeBuffer);
$e04cd46ce8cf6bde$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $e04cd46ce8cf6bde$var$Buffer(arg, encodingOrOffset, length);
};
$e04cd46ce8cf6bde$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $e04cd46ce8cf6bde$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$e04cd46ce8cf6bde$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $e04cd46ce8cf6bde$var$Buffer(size);
};
$e04cd46ce8cf6bde$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $bdjQ6.SlowBuffer(size);
};

});

parcelRegister("6PLnu", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $4f9c41bc251cd7a3$export$43bee75e5e14138e; }, function (v) { return $4f9c41bc251cd7a3$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $4f9c41bc251cd7a3$export$f9ce7b637dfbe238; }, function (v) { return $4f9c41bc251cd7a3$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $4f9c41bc251cd7a3$export$630801d484da15df; }, function (v) { return $4f9c41bc251cd7a3$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $4f9c41bc251cd7a3$export$bedb7023a7733221; }, function (v) { return $4f9c41bc251cd7a3$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $4f9c41bc251cd7a3$export$7e4aa119212bc614; }, function (v) { return $4f9c41bc251cd7a3$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $4f9c41bc251cd7a3$export$844ec244b1367d54; }, function (v) { return $4f9c41bc251cd7a3$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $4f9c41bc251cd7a3$export$a244864fd9645c7f; }, function (v) { return $4f9c41bc251cd7a3$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $4f9c41bc251cd7a3$export$fce6876652108ab; }, function (v) { return $4f9c41bc251cd7a3$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $4f9c41bc251cd7a3$export$49841c62b9eff15; }, function (v) { return $4f9c41bc251cd7a3$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $4f9c41bc251cd7a3$export$a6cdc56e425d0d0a; }, function (v) { return $4f9c41bc251cd7a3$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $4f9c41bc251cd7a3$export$871608497c498473; }, function (v) { return $4f9c41bc251cd7a3$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $4f9c41bc251cd7a3$export$e6127cc7fe7395c3; }, function (v) { return $4f9c41bc251cd7a3$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $4f9c41bc251cd7a3$export$f6e2535fb5126e54; }, function (v) { return $4f9c41bc251cd7a3$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $4f9c41bc251cd7a3$export$c3825b437cbdea5c; }, function (v) { return $4f9c41bc251cd7a3$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $4f9c41bc251cd7a3$export$a7884ebc965f8f54; }, function (v) { return $4f9c41bc251cd7a3$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $4f9c41bc251cd7a3$export$43bee75e5e14138e;
var $4f9c41bc251cd7a3$export$f9ce7b637dfbe238;
var $4f9c41bc251cd7a3$export$630801d484da15df;
var $4f9c41bc251cd7a3$export$bedb7023a7733221;
var $4f9c41bc251cd7a3$export$7e4aa119212bc614;
var $4f9c41bc251cd7a3$export$844ec244b1367d54;
var $4f9c41bc251cd7a3$export$a244864fd9645c7f;
var $4f9c41bc251cd7a3$export$fce6876652108ab;
var $4f9c41bc251cd7a3$export$49841c62b9eff15;
var $4f9c41bc251cd7a3$export$a6cdc56e425d0d0a;
var $4f9c41bc251cd7a3$export$871608497c498473;
var $4f9c41bc251cd7a3$export$e6127cc7fe7395c3;
var $4f9c41bc251cd7a3$export$f6e2535fb5126e54;
var $4f9c41bc251cd7a3$export$c3825b437cbdea5c;
var $4f9c41bc251cd7a3$export$a7884ebc965f8f54;
function $4f9c41bc251cd7a3$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $4f9c41bc251cd7a3$var$objectToString(arg) === '[object Array]';
}
$4f9c41bc251cd7a3$export$43bee75e5e14138e = $4f9c41bc251cd7a3$var$isArray;
function $4f9c41bc251cd7a3$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$4f9c41bc251cd7a3$export$f9ce7b637dfbe238 = $4f9c41bc251cd7a3$var$isBoolean;
function $4f9c41bc251cd7a3$var$isNull(arg) {
    return arg === null;
}
$4f9c41bc251cd7a3$export$630801d484da15df = $4f9c41bc251cd7a3$var$isNull;
function $4f9c41bc251cd7a3$var$isNullOrUndefined(arg) {
    return arg == null;
}
$4f9c41bc251cd7a3$export$bedb7023a7733221 = $4f9c41bc251cd7a3$var$isNullOrUndefined;
function $4f9c41bc251cd7a3$var$isNumber(arg) {
    return typeof arg === 'number';
}
$4f9c41bc251cd7a3$export$7e4aa119212bc614 = $4f9c41bc251cd7a3$var$isNumber;
function $4f9c41bc251cd7a3$var$isString(arg) {
    return typeof arg === 'string';
}
$4f9c41bc251cd7a3$export$844ec244b1367d54 = $4f9c41bc251cd7a3$var$isString;
function $4f9c41bc251cd7a3$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$4f9c41bc251cd7a3$export$a244864fd9645c7f = $4f9c41bc251cd7a3$var$isSymbol;
function $4f9c41bc251cd7a3$var$isUndefined(arg) {
    return arg === void 0;
}
$4f9c41bc251cd7a3$export$fce6876652108ab = $4f9c41bc251cd7a3$var$isUndefined;
function $4f9c41bc251cd7a3$var$isRegExp(re) {
    return $4f9c41bc251cd7a3$var$objectToString(re) === '[object RegExp]';
}
$4f9c41bc251cd7a3$export$49841c62b9eff15 = $4f9c41bc251cd7a3$var$isRegExp;
function $4f9c41bc251cd7a3$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$4f9c41bc251cd7a3$export$a6cdc56e425d0d0a = $4f9c41bc251cd7a3$var$isObject;
function $4f9c41bc251cd7a3$var$isDate(d) {
    return $4f9c41bc251cd7a3$var$objectToString(d) === '[object Date]';
}
$4f9c41bc251cd7a3$export$871608497c498473 = $4f9c41bc251cd7a3$var$isDate;
function $4f9c41bc251cd7a3$var$isError(e) {
    return $4f9c41bc251cd7a3$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$4f9c41bc251cd7a3$export$e6127cc7fe7395c3 = $4f9c41bc251cd7a3$var$isError;
function $4f9c41bc251cd7a3$var$isFunction(arg) {
    return typeof arg === 'function';
}
$4f9c41bc251cd7a3$export$f6e2535fb5126e54 = $4f9c41bc251cd7a3$var$isFunction;
function $4f9c41bc251cd7a3$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$4f9c41bc251cd7a3$export$c3825b437cbdea5c = $4f9c41bc251cd7a3$var$isPrimitive;

$4f9c41bc251cd7a3$export$a7884ebc965f8f54 = (parcelRequire("bdjQ6")).Buffer.isBuffer;
function $4f9c41bc251cd7a3$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("jAhDc", function(module, exports) {
'use strict';
function $e41f0e4be4b6884d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $jfWxI = parcelRequire("jfWxI");
var $e41f0e4be4b6884d$require$Buffer = $jfWxI.Buffer;

var $ifbub = parcelRequire("ifbub");
function $e41f0e4be4b6884d$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $e41f0e4be4b6884d$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $e41f0e4be4b6884d$require$Buffer.alloc(0);
        var ret = $e41f0e4be4b6884d$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $e41f0e4be4b6884d$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($ifbub && $ifbub.inspect && $ifbub.inspect.custom) module.exports.prototype[$ifbub.inspect.custom] = function() {
    var obj = $ifbub.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("ktkM5", function(module, exports) {
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $ee76a179a649e840$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $e5LkN.nextTick($ee76a179a649e840$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $e5LkN.nextTick($ee76a179a649e840$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $e5LkN.nextTick($ee76a179a649e840$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $e5LkN.nextTick($ee76a179a649e840$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $ee76a179a649e840$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $ee76a179a649e840$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $ee76a179a649e840$var$destroy,
    undestroy: $ee76a179a649e840$var$undestroy
};

});

parcelRegister("hxbeF", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ /*<replacement>*/ var $cc3e3be8c0373de4$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $cc3e3be8c0373de4$var$Duplex;

/*<replacement>*/ var $cc3e3be8c0373de4$var$util = Object.create((parcelRequire("6PLnu")));

$cc3e3be8c0373de4$var$util.inherits = (parcelRequire("dhT4G"));

var $g4ZW2 = parcelRequire("g4ZW2");

var $g6cJS = parcelRequire("g6cJS");
$cc3e3be8c0373de4$var$util.inherits($cc3e3be8c0373de4$var$Duplex, $g4ZW2);
// avoid scope creep, the keys array can then be collected
var $cc3e3be8c0373de4$var$keys = $cc3e3be8c0373de4$var$objectKeys($g6cJS.prototype);
for(var $cc3e3be8c0373de4$var$v = 0; $cc3e3be8c0373de4$var$v < $cc3e3be8c0373de4$var$keys.length; $cc3e3be8c0373de4$var$v++){
    var $cc3e3be8c0373de4$var$method = $cc3e3be8c0373de4$var$keys[$cc3e3be8c0373de4$var$v];
    if (!$cc3e3be8c0373de4$var$Duplex.prototype[$cc3e3be8c0373de4$var$method]) $cc3e3be8c0373de4$var$Duplex.prototype[$cc3e3be8c0373de4$var$method] = $g6cJS.prototype[$cc3e3be8c0373de4$var$method];
}
function $cc3e3be8c0373de4$var$Duplex(options) {
    if (!(this instanceof $cc3e3be8c0373de4$var$Duplex)) return new $cc3e3be8c0373de4$var$Duplex(options);
    $g4ZW2.call(this, options);
    $g6cJS.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $cc3e3be8c0373de4$var$onend);
}
Object.defineProperty($cc3e3be8c0373de4$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $cc3e3be8c0373de4$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $e5LkN.nextTick($cc3e3be8c0373de4$var$onEndNT, this);
}
function $cc3e3be8c0373de4$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($cc3e3be8c0373de4$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$cc3e3be8c0373de4$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $e5LkN.nextTick(cb, err);
};

});
parcelRegister("g6cJS", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $e5LkN = parcelRequire("e5LkN");
/*</replacement>*/ module.exports = $bb8716969b605b7d$var$Writable;
/* <replacement> */ function $bb8716969b605b7d$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $bb8716969b605b7d$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $bb8716969b605b7d$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $bb8716969b605b7d$var$asyncWrite = (0, $e5LkN.nextTick);
/*</replacement>*/ /*<replacement>*/ var $bb8716969b605b7d$var$Duplex;
/*</replacement>*/ $bb8716969b605b7d$var$Writable.WritableState = $bb8716969b605b7d$var$WritableState;

/*<replacement>*/ var $bb8716969b605b7d$var$util = Object.create((parcelRequire("6PLnu")));

$bb8716969b605b7d$var$util.inherits = (parcelRequire("dhT4G"));

/*</replacement>*/ /*<replacement>*/ var $bb8716969b605b7d$var$internalUtil = {
    deprecate: (parcelRequire("4SymK"))
};

var $bSqQK = parcelRequire("bSqQK");

var $jfWxI = parcelRequire("jfWxI");
var $bb8716969b605b7d$require$Buffer = $jfWxI.Buffer;
var $bb8716969b605b7d$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $bb8716969b605b7d$var$_uint8ArrayToBuffer(chunk) {
    return $bb8716969b605b7d$require$Buffer.from(chunk);
}
function $bb8716969b605b7d$var$_isUint8Array(obj) {
    return $bb8716969b605b7d$require$Buffer.isBuffer(obj) || obj instanceof $bb8716969b605b7d$var$OurUint8Array;
}

var $ktkM5 = parcelRequire("ktkM5");
$bb8716969b605b7d$var$util.inherits($bb8716969b605b7d$var$Writable, $bSqQK);
function $bb8716969b605b7d$var$nop() {}

function $bb8716969b605b7d$var$WritableState(options, stream) {
    $bb8716969b605b7d$var$Duplex = $bb8716969b605b7d$var$Duplex || (parcelRequire("hxbeF"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $bb8716969b605b7d$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $bb8716969b605b7d$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $bb8716969b605b7d$var$CorkedRequest(this);
}
$bb8716969b605b7d$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($bb8716969b605b7d$var$WritableState.prototype, 'buffer', {
            get: $bb8716969b605b7d$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $bb8716969b605b7d$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $bb8716969b605b7d$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($bb8716969b605b7d$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($bb8716969b605b7d$var$realHasInstance.call(this, object)) return true;
            if (this !== $bb8716969b605b7d$var$Writable) return false;
            return object && object._writableState instanceof $bb8716969b605b7d$var$WritableState;
        }
    });
} else $bb8716969b605b7d$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $bb8716969b605b7d$var$Writable(options) {
    $bb8716969b605b7d$var$Duplex = $bb8716969b605b7d$var$Duplex || (parcelRequire("hxbeF"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$bb8716969b605b7d$var$realHasInstance.call($bb8716969b605b7d$var$Writable, this) && !(this instanceof $bb8716969b605b7d$var$Duplex)) return new $bb8716969b605b7d$var$Writable(options);
    this._writableState = new $bb8716969b605b7d$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $bSqQK.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$bb8716969b605b7d$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $bb8716969b605b7d$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $e5LkN.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $bb8716969b605b7d$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $e5LkN.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$bb8716969b605b7d$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $bb8716969b605b7d$var$_isUint8Array(chunk);
    if (isBuf && !$bb8716969b605b7d$require$Buffer.isBuffer(chunk)) chunk = $bb8716969b605b7d$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $bb8716969b605b7d$var$nop;
    if (state.ended) $bb8716969b605b7d$var$writeAfterEnd(this, cb);
    else if (isBuf || $bb8716969b605b7d$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $bb8716969b605b7d$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$bb8716969b605b7d$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$bb8716969b605b7d$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bb8716969b605b7d$var$clearBuffer(this, state);
    }
};
$bb8716969b605b7d$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $bb8716969b605b7d$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $bb8716969b605b7d$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($bb8716969b605b7d$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $bb8716969b605b7d$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $bb8716969b605b7d$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $bb8716969b605b7d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $bb8716969b605b7d$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $bb8716969b605b7d$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $e5LkN.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $e5LkN.nextTick($bb8716969b605b7d$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $bb8716969b605b7d$var$finishMaybe(stream, state);
    }
}
function $bb8716969b605b7d$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $bb8716969b605b7d$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $bb8716969b605b7d$var$onwriteStateUpdate(state);
    if (er) $bb8716969b605b7d$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $bb8716969b605b7d$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $bb8716969b605b7d$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $bb8716969b605b7d$var$asyncWrite($bb8716969b605b7d$var$afterWrite, stream, state, finished, cb);
        else $bb8716969b605b7d$var$afterWrite(stream, state, finished, cb);
    }
}
function $bb8716969b605b7d$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $bb8716969b605b7d$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $bb8716969b605b7d$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $bb8716969b605b7d$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $bb8716969b605b7d$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $bb8716969b605b7d$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $bb8716969b605b7d$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $bb8716969b605b7d$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$bb8716969b605b7d$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$bb8716969b605b7d$var$Writable.prototype._writev = null;
$bb8716969b605b7d$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $bb8716969b605b7d$var$endWritable(this, state, cb);
};
function $bb8716969b605b7d$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $bb8716969b605b7d$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $bb8716969b605b7d$var$finishMaybe(stream, state);
    });
}
function $bb8716969b605b7d$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $e5LkN.nextTick($bb8716969b605b7d$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $bb8716969b605b7d$var$finishMaybe(stream, state) {
    var need = $bb8716969b605b7d$var$needFinish(state);
    if (need) {
        $bb8716969b605b7d$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $bb8716969b605b7d$var$endWritable(stream, state, cb) {
    state.ending = true;
    $bb8716969b605b7d$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $e5LkN.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $bb8716969b605b7d$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($bb8716969b605b7d$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$bb8716969b605b7d$var$Writable.prototype.destroy = $ktkM5.destroy;
$bb8716969b605b7d$var$Writable.prototype._undestroy = $ktkM5.undestroy;
$bb8716969b605b7d$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("bAIDW", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $8705afbb181f916e$export$63a7aa211a91ed69; }, function (v) { return $8705afbb181f916e$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $8705afbb181f916e$export$63a7aa211a91ed69;
'use strict';

var $jfWxI = parcelRequire("jfWxI");
var $8705afbb181f916e$require$Buffer = $jfWxI.Buffer;
/*</replacement>*/ var $8705afbb181f916e$var$isEncoding = $8705afbb181f916e$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $8705afbb181f916e$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $8705afbb181f916e$var$normalizeEncoding(enc) {
    var nenc = $8705afbb181f916e$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($8705afbb181f916e$require$Buffer.isEncoding === $8705afbb181f916e$var$isEncoding || !$8705afbb181f916e$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$8705afbb181f916e$export$63a7aa211a91ed69 = $8705afbb181f916e$var$StringDecoder;
function $8705afbb181f916e$var$StringDecoder(encoding) {
    this.encoding = $8705afbb181f916e$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $8705afbb181f916e$var$utf16Text;
            this.end = $8705afbb181f916e$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $8705afbb181f916e$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $8705afbb181f916e$var$base64Text;
            this.end = $8705afbb181f916e$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $8705afbb181f916e$var$simpleWrite;
            this.end = $8705afbb181f916e$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $8705afbb181f916e$require$Buffer.allocUnsafe(nb);
}
$8705afbb181f916e$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$8705afbb181f916e$var$StringDecoder.prototype.end = $8705afbb181f916e$var$utf8End;
// Returns only complete characters in a Buffer
$8705afbb181f916e$var$StringDecoder.prototype.text = $8705afbb181f916e$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$8705afbb181f916e$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $8705afbb181f916e$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $8705afbb181f916e$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $8705afbb181f916e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8705afbb181f916e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $8705afbb181f916e$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $8705afbb181f916e$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $8705afbb181f916e$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $8705afbb181f916e$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $8705afbb181f916e$var$utf8Text(buf, i) {
    var total = $8705afbb181f916e$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $8705afbb181f916e$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $8705afbb181f916e$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $8705afbb181f916e$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $8705afbb181f916e$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $8705afbb181f916e$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $8705afbb181f916e$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $8705afbb181f916e$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("k0KBi", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $e917f49caec6d43d$var$Transform;

var $hxbeF = parcelRequire("hxbeF");

/*<replacement>*/ var $e917f49caec6d43d$var$util = Object.create((parcelRequire("6PLnu")));

$e917f49caec6d43d$var$util.inherits = (parcelRequire("dhT4G"));
/*</replacement>*/ $e917f49caec6d43d$var$util.inherits($e917f49caec6d43d$var$Transform, $hxbeF);
function $e917f49caec6d43d$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e917f49caec6d43d$var$Transform(options) {
    if (!(this instanceof $e917f49caec6d43d$var$Transform)) return new $e917f49caec6d43d$var$Transform(options);
    $hxbeF.call(this, options);
    this._transformState = {
        afterTransform: $e917f49caec6d43d$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $e917f49caec6d43d$var$prefinish);
}
function $e917f49caec6d43d$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $e917f49caec6d43d$var$done(_this, er, data);
    });
    else $e917f49caec6d43d$var$done(this, null, null);
}
$e917f49caec6d43d$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $hxbeF.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e917f49caec6d43d$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$e917f49caec6d43d$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e917f49caec6d43d$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e917f49caec6d43d$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $hxbeF.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $e917f49caec6d43d$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("jYFEV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $e8b3ef8ac56f630d$var$PassThrough;

var $k0KBi = parcelRequire("k0KBi");

/*<replacement>*/ var $e8b3ef8ac56f630d$var$util = Object.create((parcelRequire("6PLnu")));

$e8b3ef8ac56f630d$var$util.inherits = (parcelRequire("dhT4G"));
/*</replacement>*/ $e8b3ef8ac56f630d$var$util.inherits($e8b3ef8ac56f630d$var$PassThrough, $k0KBi);
function $e8b3ef8ac56f630d$var$PassThrough(options) {
    if (!(this instanceof $e8b3ef8ac56f630d$var$PassThrough)) return new $e8b3ef8ac56f630d$var$PassThrough(options);
    $k0KBi.call(this, options);
}
$e8b3ef8ac56f630d$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("15EwC", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("k2Afl"));

module.exports.sha1 = (parcelRequire("hlzHi"));

module.exports.sha224 = (parcelRequire("lzTLZ"));

module.exports.sha256 = (parcelRequire("kC2XM"));

module.exports.sha384 = (parcelRequire("jDuRY"));

module.exports.sha512 = (parcelRequire("c4ppm"));

});
parcelRegister("k2Afl", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $e9701c5afa941cb3$require$Buffer = $838j1.Buffer;
var $e9701c5afa941cb3$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $e9701c5afa941cb3$var$W = new Array(80);
function $e9701c5afa941cb3$var$Sha() {
    this.init();
    this._w = $e9701c5afa941cb3$var$W;
    $klEcH.call(this, 64, 56);
}
$dhT4G($e9701c5afa941cb3$var$Sha, $klEcH);
$e9701c5afa941cb3$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $e9701c5afa941cb3$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $e9701c5afa941cb3$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $e9701c5afa941cb3$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$e9701c5afa941cb3$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $e9701c5afa941cb3$var$rotl5(a) + $e9701c5afa941cb3$var$ft(s, b, c, d) + e + w[j] + $e9701c5afa941cb3$var$K[s] | 0;
        e = d;
        d = c;
        c = $e9701c5afa941cb3$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$e9701c5afa941cb3$var$Sha.prototype._hash = function() {
    var H = $e9701c5afa941cb3$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $e9701c5afa941cb3$var$Sha;

});
parcelRegister("klEcH", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $ed04f4701195f7c9$require$Buffer = $838j1.Buffer;

var $iDFZs = parcelRequire("iDFZs");
// prototype class for hash functions
function $ed04f4701195f7c9$var$Hash(blockSize, finalSize) {
    this._block = $ed04f4701195f7c9$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$ed04f4701195f7c9$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $iDFZs(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$ed04f4701195f7c9$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$ed04f4701195f7c9$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $ed04f4701195f7c9$var$Hash;

});


parcelRegister("hlzHi", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $ca10169aa7393b0d$require$Buffer = $838j1.Buffer;
var $ca10169aa7393b0d$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $ca10169aa7393b0d$var$W = new Array(80);
function $ca10169aa7393b0d$var$Sha1() {
    this.init();
    this._w = $ca10169aa7393b0d$var$W;
    $klEcH.call(this, 64, 56);
}
$dhT4G($ca10169aa7393b0d$var$Sha1, $klEcH);
$ca10169aa7393b0d$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $ca10169aa7393b0d$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $ca10169aa7393b0d$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $ca10169aa7393b0d$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $ca10169aa7393b0d$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$ca10169aa7393b0d$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $ca10169aa7393b0d$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $ca10169aa7393b0d$var$rotl5(a) + $ca10169aa7393b0d$var$ft(s, b, c, d) + e + w[j] + $ca10169aa7393b0d$var$K[s] | 0;
        e = d;
        d = c;
        c = $ca10169aa7393b0d$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$ca10169aa7393b0d$var$Sha1.prototype._hash = function() {
    var H = $ca10169aa7393b0d$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $ca10169aa7393b0d$var$Sha1;

});

parcelRegister("lzTLZ", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $kC2XM = parcelRequire("kC2XM");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $fb5821351ada7f8b$require$Buffer = $838j1.Buffer;
var $fb5821351ada7f8b$var$W = new Array(64);
function $fb5821351ada7f8b$var$Sha224() {
    this.init();
    this._w = $fb5821351ada7f8b$var$W; // new Array(64)
    $klEcH.call(this, 64, 56);
}
$dhT4G($fb5821351ada7f8b$var$Sha224, $kC2XM);
$fb5821351ada7f8b$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$fb5821351ada7f8b$var$Sha224.prototype._hash = function() {
    var H = $fb5821351ada7f8b$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $fb5821351ada7f8b$var$Sha224;

});
parcelRegister("kC2XM", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $f019a7adf5bdf392$require$Buffer = $838j1.Buffer;
var $f019a7adf5bdf392$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $f019a7adf5bdf392$var$W = new Array(64);
function $f019a7adf5bdf392$var$Sha256() {
    this.init();
    this._w = $f019a7adf5bdf392$var$W; // new Array(64)
    $klEcH.call(this, 64, 56);
}
$dhT4G($f019a7adf5bdf392$var$Sha256, $klEcH);
$f019a7adf5bdf392$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $f019a7adf5bdf392$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $f019a7adf5bdf392$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $f019a7adf5bdf392$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $f019a7adf5bdf392$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $f019a7adf5bdf392$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $f019a7adf5bdf392$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$f019a7adf5bdf392$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $f019a7adf5bdf392$var$gamma1(w[i - 2]) + w[i - 7] + $f019a7adf5bdf392$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $f019a7adf5bdf392$var$sigma1(e) + $f019a7adf5bdf392$var$ch(e, f, g) + $f019a7adf5bdf392$var$K[j] + w[j] | 0;
        var T2 = $f019a7adf5bdf392$var$sigma0(a) + $f019a7adf5bdf392$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$f019a7adf5bdf392$var$Sha256.prototype._hash = function() {
    var H = $f019a7adf5bdf392$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $f019a7adf5bdf392$var$Sha256;

});


parcelRegister("jDuRY", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $c4ppm = parcelRequire("c4ppm");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $e4b99ae2d3c6980e$require$Buffer = $838j1.Buffer;
var $e4b99ae2d3c6980e$var$W = new Array(160);
function $e4b99ae2d3c6980e$var$Sha384() {
    this.init();
    this._w = $e4b99ae2d3c6980e$var$W;
    $klEcH.call(this, 128, 112);
}
$dhT4G($e4b99ae2d3c6980e$var$Sha384, $c4ppm);
$e4b99ae2d3c6980e$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$e4b99ae2d3c6980e$var$Sha384.prototype._hash = function() {
    var H = $e4b99ae2d3c6980e$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $e4b99ae2d3c6980e$var$Sha384;

});
parcelRegister("c4ppm", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $klEcH = parcelRequire("klEcH");

var $838j1 = parcelRequire("838j1");
var $8c99914a22a7c866$require$Buffer = $838j1.Buffer;
var $8c99914a22a7c866$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8c99914a22a7c866$var$W = new Array(160);
function $8c99914a22a7c866$var$Sha512() {
    this.init();
    this._w = $8c99914a22a7c866$var$W;
    $klEcH.call(this, 128, 112);
}
$dhT4G($8c99914a22a7c866$var$Sha512, $klEcH);
$8c99914a22a7c866$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8c99914a22a7c866$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8c99914a22a7c866$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8c99914a22a7c866$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8c99914a22a7c866$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8c99914a22a7c866$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8c99914a22a7c866$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8c99914a22a7c866$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8c99914a22a7c866$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8c99914a22a7c866$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8c99914a22a7c866$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $8c99914a22a7c866$var$Gamma0(xh, xl);
        var gamma0l = $8c99914a22a7c866$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $8c99914a22a7c866$var$Gamma1(xh, xl);
        var gamma1l = $8c99914a22a7c866$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8c99914a22a7c866$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8c99914a22a7c866$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8c99914a22a7c866$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $8c99914a22a7c866$var$maj(ah, bh, ch);
        var majl = $8c99914a22a7c866$var$maj(al, bl, cl);
        var sigma0h = $8c99914a22a7c866$var$sigma0(ah, al);
        var sigma0l = $8c99914a22a7c866$var$sigma0(al, ah);
        var sigma1h = $8c99914a22a7c866$var$sigma1(eh, el);
        var sigma1l = $8c99914a22a7c866$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $8c99914a22a7c866$var$K[j];
        var Kil = $8c99914a22a7c866$var$K[j + 1];
        var chh = $8c99914a22a7c866$var$Ch(eh, fh, gh);
        var chl = $8c99914a22a7c866$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8c99914a22a7c866$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8c99914a22a7c866$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8c99914a22a7c866$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8c99914a22a7c866$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8c99914a22a7c866$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8c99914a22a7c866$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8c99914a22a7c866$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8c99914a22a7c866$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8c99914a22a7c866$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8c99914a22a7c866$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8c99914a22a7c866$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8c99914a22a7c866$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8c99914a22a7c866$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8c99914a22a7c866$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8c99914a22a7c866$var$getCarry(this._hl, hl) | 0;
};
$8c99914a22a7c866$var$Sha512.prototype._hash = function() {
    var H = $8c99914a22a7c866$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8c99914a22a7c866$var$Sha512;

});



parcelRegister("6GOuC", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $4dedd5233519b29a$require$Buffer = $838j1.Buffer;

var $3DkjE = parcelRequire("3DkjE");
var $4dedd5233519b29a$require$Transform = $3DkjE.Transform;

var $iGJyf = parcelRequire("iGJyf");
var $4dedd5233519b29a$require$StringDecoder = $iGJyf.StringDecoder;

var $dhT4G = parcelRequire("dhT4G");

var $iDFZs = parcelRequire("iDFZs");
function $4dedd5233519b29a$var$CipherBase(hashMode) {
    $4dedd5233519b29a$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dhT4G($4dedd5233519b29a$var$CipherBase, $4dedd5233519b29a$require$Transform);
$4dedd5233519b29a$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $iDFZs(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$4dedd5233519b29a$var$CipherBase.prototype.setAutoPadding = function() {};
$4dedd5233519b29a$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$4dedd5233519b29a$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$4dedd5233519b29a$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$4dedd5233519b29a$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$4dedd5233519b29a$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$4dedd5233519b29a$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $4dedd5233519b29a$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$4dedd5233519b29a$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $4dedd5233519b29a$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $4dedd5233519b29a$var$CipherBase;

});


parcelRegister("cL3Ff", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $9gEy8 = parcelRequire("9gEy8");

var $6GOuC = parcelRequire("6GOuC");

var $838j1 = parcelRequire("838j1");
var $949cb77e369e305c$require$Buffer = $838j1.Buffer;

var $7S8oP = parcelRequire("7S8oP");

var $1Jsb3 = parcelRequire("1Jsb3");

var $15EwC = parcelRequire("15EwC");
var $949cb77e369e305c$var$ZEROS = $949cb77e369e305c$require$Buffer.alloc(128);
function $949cb77e369e305c$var$Hmac(alg, key) {
    $6GOuC.call(this, 'digest');
    if (typeof key === 'string') key = $949cb77e369e305c$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $1Jsb3() : $15EwC(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $949cb77e369e305c$require$Buffer.concat([
        key,
        $949cb77e369e305c$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $949cb77e369e305c$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $949cb77e369e305c$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $1Jsb3() : $15EwC(alg);
    this._hash.update(ipad);
}
$dhT4G($949cb77e369e305c$var$Hmac, $6GOuC);
$949cb77e369e305c$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$949cb77e369e305c$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $1Jsb3() : $15EwC(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $949cb77e369e305c$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $9gEy8($7S8oP, key);
    return new $949cb77e369e305c$var$Hmac(alg, key);
};

});
parcelRegister("9gEy8", function(module, exports) {
'use strict';

var $dhT4G = parcelRequire("dhT4G");

var $838j1 = parcelRequire("838j1");
var $6bf50ffe31847a3e$require$Buffer = $838j1.Buffer;

var $6GOuC = parcelRequire("6GOuC");
var $6bf50ffe31847a3e$var$ZEROS = $6bf50ffe31847a3e$require$Buffer.alloc(128);
var $6bf50ffe31847a3e$var$blocksize = 64;
function $6bf50ffe31847a3e$var$Hmac(alg, key) {
    $6GOuC.call(this, 'digest');
    if (typeof key === 'string') key = $6bf50ffe31847a3e$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $6bf50ffe31847a3e$var$blocksize) key = alg(key);
    else if (key.length < $6bf50ffe31847a3e$var$blocksize) key = $6bf50ffe31847a3e$require$Buffer.concat([
        key,
        $6bf50ffe31847a3e$var$ZEROS
    ], $6bf50ffe31847a3e$var$blocksize);
    var ipad = this._ipad = $6bf50ffe31847a3e$require$Buffer.allocUnsafe($6bf50ffe31847a3e$var$blocksize);
    var opad = this._opad = $6bf50ffe31847a3e$require$Buffer.allocUnsafe($6bf50ffe31847a3e$var$blocksize);
    for(var i = 0; i < $6bf50ffe31847a3e$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dhT4G($6bf50ffe31847a3e$var$Hmac, $6GOuC);
$6bf50ffe31847a3e$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$6bf50ffe31847a3e$var$Hmac.prototype._final = function() {
    var h = this._alg($6bf50ffe31847a3e$require$Buffer.concat(this._hash));
    return this._alg($6bf50ffe31847a3e$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $6bf50ffe31847a3e$var$Hmac;

});

parcelRegister("7S8oP", function(module, exports) {

var $2GAk4 = parcelRequire("2GAk4");
module.exports = function(buffer) {
    return new $2GAk4().update(buffer).digest();
};

});


parcelRegister("bci9C", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gm4QM"));

});
parcelRegister("gm4QM", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("d0xYH", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $9785a1c88b34149b$export$448fa22aedc9dbca; }, function (v) { return $9785a1c88b34149b$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $9785a1c88b34149b$export$b80c7ba289c8fa56; }, function (v) { return $9785a1c88b34149b$export$b80c7ba289c8fa56 = v; });
var $9785a1c88b34149b$export$448fa22aedc9dbca;
var $9785a1c88b34149b$export$b80c7ba289c8fa56;
'use strict';

$9785a1c88b34149b$export$448fa22aedc9dbca = (parcelRequire("jZEYv"));

$9785a1c88b34149b$export$b80c7ba289c8fa56 = (parcelRequire("9Tp97"));

});
parcelRegister("jZEYv", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $e8e37f9705f45c6f$require$Buffer = $838j1.Buffer;

var $cGyf5 = parcelRequire("cGyf5");

var $i7B8N = parcelRequire("i7B8N");

var $9Tp97 = parcelRequire("9Tp97");

var $8NXst = parcelRequire("8NXst");
var $e8e37f9705f45c6f$var$ZERO_BUF;
var $e8e37f9705f45c6f$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $e8e37f9705f45c6f$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $e8e37f9705f45c6f$var$checks = [];
var $e8e37f9705f45c6f$var$nextTick;
function $e8e37f9705f45c6f$var$getNextTick() {
    if ($e8e37f9705f45c6f$var$nextTick) return $e8e37f9705f45c6f$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $e8e37f9705f45c6f$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $e8e37f9705f45c6f$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $e8e37f9705f45c6f$var$nextTick = $parcel$global.setImmediate;
    else $e8e37f9705f45c6f$var$nextTick = $parcel$global.setTimeout;
    return $e8e37f9705f45c6f$var$nextTick;
}
function $e8e37f9705f45c6f$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $e8e37f9705f45c6f$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $e8e37f9705f45c6f$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $e8e37f9705f45c6f$require$Buffer.from(res);
    });
}
function $e8e37f9705f45c6f$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$e8e37f9705f45c6f$var$subtle || !$e8e37f9705f45c6f$var$subtle.importKey || !$e8e37f9705f45c6f$var$subtle.deriveBits) return Promise.resolve(false);
    if ($e8e37f9705f45c6f$var$checks[algo] !== undefined) return $e8e37f9705f45c6f$var$checks[algo];
    $e8e37f9705f45c6f$var$ZERO_BUF = $e8e37f9705f45c6f$var$ZERO_BUF || $e8e37f9705f45c6f$require$Buffer.alloc(8);
    var prom = $e8e37f9705f45c6f$var$browserPbkdf2($e8e37f9705f45c6f$var$ZERO_BUF, $e8e37f9705f45c6f$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $e8e37f9705f45c6f$var$checks[algo] = prom;
    return prom;
}
function $e8e37f9705f45c6f$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $e8e37f9705f45c6f$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $e8e37f9705f45c6f$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    $cGyf5(iterations, keylen);
    password = $8NXst(password, $i7B8N, 'Password');
    salt = $8NXst(salt, $i7B8N, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $e8e37f9705f45c6f$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $e8e37f9705f45c6f$var$getNextTick()(function() {
            var out;
            try {
                out = $9Tp97(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $e8e37f9705f45c6f$var$resolvePromise($e8e37f9705f45c6f$var$checkNative(algo).then(function(resp) {
        if (resp) return $e8e37f9705f45c6f$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $9Tp97(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("cGyf5", function(module, exports) {
'use strict';
var $93c3f812afbfc00a$var$$isFinite = isFinite;
var $93c3f812afbfc00a$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$93c3f812afbfc00a$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $93c3f812afbfc00a$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("i7B8N", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
var $d315b0d2c7e0b4e5$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $d315b0d2c7e0b4e5$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $d315b0d2c7e0b4e5$var$pVersionMajor = parseInt($4ZL0H.version.split('.')[0].slice(1), 10);
    $d315b0d2c7e0b4e5$var$defaultEncoding = $d315b0d2c7e0b4e5$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $d315b0d2c7e0b4e5$var$defaultEncoding = 'utf-8';
module.exports = $d315b0d2c7e0b4e5$var$defaultEncoding;

});

parcelRegister("9Tp97", function(module, exports) {
'use strict';

var $7S8oP = parcelRequire("7S8oP");

var $1Jsb3 = parcelRequire("1Jsb3");

var $15EwC = parcelRequire("15EwC");

var $838j1 = parcelRequire("838j1");
var $01dbd19307582e29$require$Buffer = $838j1.Buffer;

var $cGyf5 = parcelRequire("cGyf5");

var $i7B8N = parcelRequire("i7B8N");

var $8NXst = parcelRequire("8NXst");
var $01dbd19307582e29$var$ZEROS = $01dbd19307582e29$require$Buffer.alloc(128);
var $01dbd19307582e29$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $01dbd19307582e29$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $01dbd19307582e29$var$rmd160Func(data) {
    return new $1Jsb3().update(data).digest();
}
function $01dbd19307582e29$var$getDigest(alg) {
    function shaFunc(data) {
        return $15EwC(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $01dbd19307582e29$var$rmd160Func;
    if (alg === 'md5') return $7S8oP;
    return shaFunc;
}
function $01dbd19307582e29$var$Hmac(alg, key, saltLen) {
    var hash = $01dbd19307582e29$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $01dbd19307582e29$require$Buffer.concat([
        key,
        $01dbd19307582e29$var$ZEROS
    ], blocksize);
    var ipad = $01dbd19307582e29$require$Buffer.allocUnsafe(blocksize + $01dbd19307582e29$var$sizes[alg]);
    var opad = $01dbd19307582e29$require$Buffer.allocUnsafe(blocksize + $01dbd19307582e29$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $01dbd19307582e29$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $01dbd19307582e29$var$sizes[alg];
}
$01dbd19307582e29$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $01dbd19307582e29$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $cGyf5(iterations, keylen);
    password = $8NXst(password, $i7B8N, 'Password');
    salt = $8NXst(salt, $i7B8N, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $01dbd19307582e29$var$mapping[lowerDigest] || lowerDigest;
    var size = $01dbd19307582e29$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $01dbd19307582e29$var$Hmac(mappedDigest, password, salt.length);
    var DK = $01dbd19307582e29$require$Buffer.allocUnsafe(keylen);
    var block1 = $01dbd19307582e29$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $01dbd19307582e29$var$pbkdf2;

});
parcelRegister("8NXst", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $66910584d1dc48dd$require$Buffer = $838j1.Buffer;

var $iDFZs = parcelRequire("iDFZs");
var $66910584d1dc48dd$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $66910584d1dc48dd$var$useArrayBuffer = $66910584d1dc48dd$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $66910584d1dc48dd$var$isView = $66910584d1dc48dd$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $66910584d1dc48dd$require$Buffer.isBuffer(thing) || $66910584d1dc48dd$var$useUint8Array && thing instanceof Uint8Array || $66910584d1dc48dd$var$isView && $66910584d1dc48dd$var$isView(thing)) return $iDFZs(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("jGT0o", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $e55c9b7f3ad34522$export$bdd223f16383713e; }, function (v) { return $e55c9b7f3ad34522$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $e55c9b7f3ad34522$export$26e5786e8ac8e530; }, function (v) { return $e55c9b7f3ad34522$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $e55c9b7f3ad34522$export$2f64596b8cbf08b4; }, function (v) { return $e55c9b7f3ad34522$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $e55c9b7f3ad34522$export$20533d26f07f1ee0; }, function (v) { return $e55c9b7f3ad34522$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $e55c9b7f3ad34522$export$12ada9414fbc594c; }, function (v) { return $e55c9b7f3ad34522$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a; }, function (v) { return $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e55c9b7f3ad34522$export$36b6d6ef312eab39; }, function (v) { return $e55c9b7f3ad34522$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $e55c9b7f3ad34522$export$f5e7e39d57cd9700; }, function (v) { return $e55c9b7f3ad34522$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $e55c9b7f3ad34522$export$dedd8dc3dc62b370; }, function (v) { return $e55c9b7f3ad34522$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $e55c9b7f3ad34522$export$58a258485f1e49f6; }, function (v) { return $e55c9b7f3ad34522$export$58a258485f1e49f6 = v; });
var $e55c9b7f3ad34522$export$bdd223f16383713e;
var $e55c9b7f3ad34522$export$26e5786e8ac8e530;
var $e55c9b7f3ad34522$export$2f64596b8cbf08b4;
var $e55c9b7f3ad34522$export$20533d26f07f1ee0;
var $e55c9b7f3ad34522$export$12ada9414fbc594c;
var $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a;
var $e55c9b7f3ad34522$export$36b6d6ef312eab39;
var $e55c9b7f3ad34522$export$f5e7e39d57cd9700;
var $e55c9b7f3ad34522$export$dedd8dc3dc62b370;
var $e55c9b7f3ad34522$export$58a258485f1e49f6;

var $cRnXs = parcelRequire("cRnXs");

var $jGDtA = parcelRequire("jGDtA");

var $gaNIZ = parcelRequire("gaNIZ");

var $baPH8 = parcelRequire("baPH8");

var $iWvja = parcelRequire("iWvja");
function $e55c9b7f3ad34522$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($gaNIZ[suite]) {
        keyLen = $gaNIZ[suite].key;
        ivLen = $gaNIZ[suite].iv;
    } else if ($baPH8[suite]) {
        keyLen = $baPH8[suite].key * 8;
        ivLen = $baPH8[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, keyLen, ivLen);
    return $e55c9b7f3ad34522$var$createCipheriv(suite, keys.key, keys.iv);
}
function $e55c9b7f3ad34522$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($gaNIZ[suite]) {
        keyLen = $gaNIZ[suite].key;
        ivLen = $gaNIZ[suite].iv;
    } else if ($baPH8[suite]) {
        keyLen = $baPH8[suite].key * 8;
        ivLen = $baPH8[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, keyLen, ivLen);
    return $e55c9b7f3ad34522$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $e55c9b7f3ad34522$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($gaNIZ[suite]) return $jGDtA.createCipheriv(suite, key, iv);
    if ($baPH8[suite]) return new $cRnXs({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $e55c9b7f3ad34522$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($gaNIZ[suite]) return $jGDtA.createDecipheriv(suite, key, iv);
    if ($baPH8[suite]) return new $cRnXs({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $e55c9b7f3ad34522$var$getCiphers() {
    return Object.keys($baPH8).concat($jGDtA.getCiphers());
}
$e55c9b7f3ad34522$export$bdd223f16383713e = $e55c9b7f3ad34522$export$26e5786e8ac8e530 = $e55c9b7f3ad34522$var$createCipher;
$e55c9b7f3ad34522$export$2f64596b8cbf08b4 = $e55c9b7f3ad34522$export$20533d26f07f1ee0 = $e55c9b7f3ad34522$var$createCipheriv;
$e55c9b7f3ad34522$export$12ada9414fbc594c = $e55c9b7f3ad34522$export$2ce6d8d0e8b04e1a = $e55c9b7f3ad34522$var$createDecipher;
$e55c9b7f3ad34522$export$36b6d6ef312eab39 = $e55c9b7f3ad34522$export$f5e7e39d57cd9700 = $e55c9b7f3ad34522$var$createDecipheriv;
$e55c9b7f3ad34522$export$dedd8dc3dc62b370 = $e55c9b7f3ad34522$export$58a258485f1e49f6 = $e55c9b7f3ad34522$var$getCiphers;

});
parcelRegister("cRnXs", function(module, exports) {

var $6GOuC = parcelRequire("6GOuC");

var $gXgD6 = parcelRequire("gXgD6");

var $dhT4G = parcelRequire("dhT4G");

var $838j1 = parcelRequire("838j1");
var $95cd04dabc1eb7c8$require$Buffer = $838j1.Buffer;
var $95cd04dabc1eb7c8$var$modes = {
    'des-ede3-cbc': $gXgD6.CBC.instantiate($gXgD6.EDE),
    'des-ede3': $gXgD6.EDE,
    'des-ede-cbc': $gXgD6.CBC.instantiate($gXgD6.EDE),
    'des-ede': $gXgD6.EDE,
    'des-cbc': $gXgD6.CBC.instantiate($gXgD6.DES),
    'des-ecb': $gXgD6.DES
};
$95cd04dabc1eb7c8$var$modes.des = $95cd04dabc1eb7c8$var$modes['des-cbc'];
$95cd04dabc1eb7c8$var$modes.des3 = $95cd04dabc1eb7c8$var$modes['des-ede3-cbc'];
module.exports = $95cd04dabc1eb7c8$var$DES;
$dhT4G($95cd04dabc1eb7c8$var$DES, $6GOuC);
function $95cd04dabc1eb7c8$var$DES(opts) {
    $6GOuC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $95cd04dabc1eb7c8$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$95cd04dabc1eb7c8$require$Buffer.isBuffer(key)) key = $95cd04dabc1eb7c8$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $95cd04dabc1eb7c8$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$95cd04dabc1eb7c8$require$Buffer.isBuffer(iv)) iv = $95cd04dabc1eb7c8$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$95cd04dabc1eb7c8$var$DES.prototype._update = function(data) {
    return $95cd04dabc1eb7c8$require$Buffer.from(this._des.update(data));
};
$95cd04dabc1eb7c8$var$DES.prototype._final = function() {
    return $95cd04dabc1eb7c8$require$Buffer.from(this._des.final());
};

});
parcelRegister("gXgD6", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $c57f0e5ad20890a2$export$cc8859615686b300; }, function (v) { return $c57f0e5ad20890a2$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $c57f0e5ad20890a2$export$8ad3f227af08fcc5; }, function (v) { return $c57f0e5ad20890a2$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $c57f0e5ad20890a2$export$947646e34766044f; }, function (v) { return $c57f0e5ad20890a2$export$947646e34766044f = v; });
var $c57f0e5ad20890a2$export$eab97d15b1788b8d;
var $c57f0e5ad20890a2$export$26e5786e8ac8e530;
var $c57f0e5ad20890a2$export$cc8859615686b300;
var $c57f0e5ad20890a2$export$8ad3f227af08fcc5;
var $c57f0e5ad20890a2$export$947646e34766044f;
'use strict';

$c57f0e5ad20890a2$export$eab97d15b1788b8d = (parcelRequire("aSiVb"));

$c57f0e5ad20890a2$export$26e5786e8ac8e530 = (parcelRequire("en1ji"));

$c57f0e5ad20890a2$export$cc8859615686b300 = (parcelRequire("gv6xd"));

$c57f0e5ad20890a2$export$8ad3f227af08fcc5 = (parcelRequire("f8Mbw"));

$c57f0e5ad20890a2$export$947646e34766044f = (parcelRequire("f5Nr9"));

});
parcelRegister("aSiVb", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $7ead9fe90fb60003$export$cfaef8ed399428b0; }, function (v) { return $7ead9fe90fb60003$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $7ead9fe90fb60003$export$a80c7deaea7cbd80; }, function (v) { return $7ead9fe90fb60003$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $7ead9fe90fb60003$export$ed7577ae6e1cd0ef; }, function (v) { return $7ead9fe90fb60003$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $7ead9fe90fb60003$export$5dcbef3aa594f567; }, function (v) { return $7ead9fe90fb60003$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $7ead9fe90fb60003$export$5bc8001ca71ed9c5; }, function (v) { return $7ead9fe90fb60003$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $7ead9fe90fb60003$export$3e714e2c5d5d8cb2; }, function (v) { return $7ead9fe90fb60003$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $7ead9fe90fb60003$export$94c3e544fd062b7f; }, function (v) { return $7ead9fe90fb60003$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $7ead9fe90fb60003$export$9f77e0932fb78f72; }, function (v) { return $7ead9fe90fb60003$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $7ead9fe90fb60003$export$d865ce2836f5927f; }, function (v) { return $7ead9fe90fb60003$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $7ead9fe90fb60003$export$95e62ad65da8b7d2; }, function (v) { return $7ead9fe90fb60003$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $7ead9fe90fb60003$export$209139ff098c441a; }, function (v) { return $7ead9fe90fb60003$export$209139ff098c441a = v; });
var $7ead9fe90fb60003$export$cfaef8ed399428b0;
var $7ead9fe90fb60003$export$a80c7deaea7cbd80;
var $7ead9fe90fb60003$export$ed7577ae6e1cd0ef;
var $7ead9fe90fb60003$export$5dcbef3aa594f567;
var $7ead9fe90fb60003$export$5bc8001ca71ed9c5;
var $7ead9fe90fb60003$export$3e714e2c5d5d8cb2;
var $7ead9fe90fb60003$export$94c3e544fd062b7f;
var $7ead9fe90fb60003$export$9f77e0932fb78f72;
var $7ead9fe90fb60003$export$d865ce2836f5927f;
var $7ead9fe90fb60003$export$95e62ad65da8b7d2;
var $7ead9fe90fb60003$export$209139ff098c441a;
'use strict';
$7ead9fe90fb60003$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$7ead9fe90fb60003$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$7ead9fe90fb60003$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $7ead9fe90fb60003$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$7ead9fe90fb60003$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $7ead9fe90fb60003$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $7ead9fe90fb60003$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $7ead9fe90fb60003$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $7ead9fe90fb60003$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$7ead9fe90fb60003$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $7ead9fe90fb60003$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$7ead9fe90fb60003$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $7ead9fe90fb60003$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $7ead9fe90fb60003$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $7ead9fe90fb60003$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$7ead9fe90fb60003$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $7ead9fe90fb60003$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $7ead9fe90fb60003$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$7ead9fe90fb60003$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("en1ji", function(module, exports) {
'use strict';

var $jLTFB = parcelRequire("jLTFB");
function $a7643ad938c9a927$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a7643ad938c9a927$var$Cipher;
$a7643ad938c9a927$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a7643ad938c9a927$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a7643ad938c9a927$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a7643ad938c9a927$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a7643ad938c9a927$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a7643ad938c9a927$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a7643ad938c9a927$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a7643ad938c9a927$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a7643ad938c9a927$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a7643ad938c9a927$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a7643ad938c9a927$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $jLTFB.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("jLTFB", function(module, exports) {
module.exports = $e64d96feb50adf1f$var$assert;
function $e64d96feb50adf1f$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$e64d96feb50adf1f$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("gv6xd", function(module, exports) {
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");

var $aSiVb = parcelRequire("aSiVb");

var $en1ji = parcelRequire("en1ji");
function $c0349c4390f1b908$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $c0349c4390f1b908$var$DES(options) {
    $en1ji.call(this, options);
    var state = new $c0349c4390f1b908$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dhT4G($c0349c4390f1b908$var$DES, $en1ji);
module.exports = $c0349c4390f1b908$var$DES;
$c0349c4390f1b908$var$DES.create = function create(options) {
    return new $c0349c4390f1b908$var$DES(options);
};
var $c0349c4390f1b908$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$c0349c4390f1b908$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $jLTFB.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $aSiVb.readUInt32BE(key, 0);
    var kR = $aSiVb.readUInt32BE(key, 4);
    $aSiVb.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $c0349c4390f1b908$var$shiftTable[i >>> 1];
        kL = $aSiVb.r28shl(kL, shift);
        kR = $aSiVb.r28shl(kR, shift);
        $aSiVb.pc2(kL, kR, state.keys, i);
    }
};
$c0349c4390f1b908$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $aSiVb.readUInt32BE(inp, inOff);
    var r = $aSiVb.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $aSiVb.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $aSiVb.writeUInt32BE(out, l, outOff);
    $aSiVb.writeUInt32BE(out, r, outOff + 4);
};
$c0349c4390f1b908$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$c0349c4390f1b908$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$jLTFB.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$c0349c4390f1b908$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aSiVb.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aSiVb.substitute(keyL, keyR);
        var f = $aSiVb.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $aSiVb.rip(r, l, out, off);
};
$c0349c4390f1b908$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $aSiVb.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $aSiVb.substitute(keyL, keyR);
        var f = $aSiVb.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $aSiVb.rip(l, r, out, off);
};

});

parcelRegister("f8Mbw", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $b05cfadcd775606f$export$f9bb8d20ccc7477a; }, function (v) { return $b05cfadcd775606f$export$f9bb8d20ccc7477a = v; });
var $b05cfadcd775606f$export$f9bb8d20ccc7477a;
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");
var $b05cfadcd775606f$var$proto = {};
function $b05cfadcd775606f$var$CBCState(iv) {
    $jLTFB.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $b05cfadcd775606f$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dhT4G(CBC, Base);
    var keys = Object.keys($b05cfadcd775606f$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $b05cfadcd775606f$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$b05cfadcd775606f$export$f9bb8d20ccc7477a = $b05cfadcd775606f$var$instantiate;
$b05cfadcd775606f$var$proto._cbcInit = function _cbcInit() {
    var state = new $b05cfadcd775606f$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$b05cfadcd775606f$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("f5Nr9", function(module, exports) {
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");

var $en1ji = parcelRequire("en1ji");

var $gv6xd = parcelRequire("gv6xd");
function $afcdabc931806f45$var$EDEState(type, key) {
    $jLTFB.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $gv6xd.create({
            type: 'encrypt',
            key: k1
        }),
        $gv6xd.create({
            type: 'decrypt',
            key: k2
        }),
        $gv6xd.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $gv6xd.create({
            type: 'decrypt',
            key: k3
        }),
        $gv6xd.create({
            type: 'encrypt',
            key: k2
        }),
        $gv6xd.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $afcdabc931806f45$var$EDE(options) {
    $en1ji.call(this, options);
    var state = new $afcdabc931806f45$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dhT4G($afcdabc931806f45$var$EDE, $en1ji);
module.exports = $afcdabc931806f45$var$EDE;
$afcdabc931806f45$var$EDE.create = function create(options) {
    return new $afcdabc931806f45$var$EDE(options);
};
$afcdabc931806f45$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$afcdabc931806f45$var$EDE.prototype._pad = $gv6xd.prototype._pad;
$afcdabc931806f45$var$EDE.prototype._unpad = $gv6xd.prototype._unpad;

});



parcelRegister("jGDtA", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $e5508fb2c65b1709$export$2f64596b8cbf08b4; }, function (v) { return $e5508fb2c65b1709$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $e5508fb2c65b1709$export$36b6d6ef312eab39; }, function (v) { return $e5508fb2c65b1709$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $e5508fb2c65b1709$export$58a258485f1e49f6; }, function (v) { return $e5508fb2c65b1709$export$58a258485f1e49f6 = v; });
var $e5508fb2c65b1709$export$bdd223f16383713e;
var $e5508fb2c65b1709$export$26e5786e8ac8e530;
var $e5508fb2c65b1709$export$2f64596b8cbf08b4;
var $e5508fb2c65b1709$export$20533d26f07f1ee0;
var $e5508fb2c65b1709$export$12ada9414fbc594c;
var $e5508fb2c65b1709$export$2ce6d8d0e8b04e1a;
var $e5508fb2c65b1709$export$36b6d6ef312eab39;
var $e5508fb2c65b1709$export$f5e7e39d57cd9700;
var $e5508fb2c65b1709$export$dedd8dc3dc62b370;
var $e5508fb2c65b1709$export$58a258485f1e49f6;

var $2wD6K = parcelRequire("2wD6K");

var $3eloO = parcelRequire("3eloO");

var $fmEa8 = parcelRequire("fmEa8");
function $e5508fb2c65b1709$var$getCiphers() {
    return Object.keys($fmEa8);
}
$e5508fb2c65b1709$export$bdd223f16383713e = $e5508fb2c65b1709$export$26e5786e8ac8e530 = $2wD6K.createCipher;
$e5508fb2c65b1709$export$2f64596b8cbf08b4 = $e5508fb2c65b1709$export$20533d26f07f1ee0 = $2wD6K.createCipheriv;
$e5508fb2c65b1709$export$12ada9414fbc594c = $e5508fb2c65b1709$export$2ce6d8d0e8b04e1a = $3eloO.createDecipher;
$e5508fb2c65b1709$export$36b6d6ef312eab39 = $e5508fb2c65b1709$export$f5e7e39d57cd9700 = $3eloO.createDecipheriv;
$e5508fb2c65b1709$export$dedd8dc3dc62b370 = $e5508fb2c65b1709$export$58a258485f1e49f6 = $e5508fb2c65b1709$var$getCiphers;

});
parcelRegister("2wD6K", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $1d6ce7ec05afe9d6$export$2f64596b8cbf08b4; }, function (v) { return $1d6ce7ec05afe9d6$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $1d6ce7ec05afe9d6$export$bdd223f16383713e; }, function (v) { return $1d6ce7ec05afe9d6$export$bdd223f16383713e = v; });
var $1d6ce7ec05afe9d6$export$2f64596b8cbf08b4;
var $1d6ce7ec05afe9d6$export$bdd223f16383713e;

var $gaNIZ = parcelRequire("gaNIZ");

var $kvo4q = parcelRequire("kvo4q");

var $838j1 = parcelRequire("838j1");
var $1d6ce7ec05afe9d6$require$Buffer = $838j1.Buffer;

var $2mx7M = parcelRequire("2mx7M");

var $6GOuC = parcelRequire("6GOuC");

var $caH4w = parcelRequire("caH4w");

var $iWvja = parcelRequire("iWvja");

var $dhT4G = parcelRequire("dhT4G");
function $1d6ce7ec05afe9d6$var$Cipher(mode, key, iv) {
    $6GOuC.call(this);
    this._cache = new $1d6ce7ec05afe9d6$var$Splitter();
    this._cipher = new $caH4w.AES(key);
    this._prev = $1d6ce7ec05afe9d6$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dhT4G($1d6ce7ec05afe9d6$var$Cipher, $6GOuC);
$1d6ce7ec05afe9d6$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $1d6ce7ec05afe9d6$require$Buffer.concat(out);
};
var $1d6ce7ec05afe9d6$var$PADDING = $1d6ce7ec05afe9d6$require$Buffer.alloc(16, 0x10);
$1d6ce7ec05afe9d6$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($1d6ce7ec05afe9d6$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$1d6ce7ec05afe9d6$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $1d6ce7ec05afe9d6$var$Splitter() {
    this.cache = $1d6ce7ec05afe9d6$require$Buffer.allocUnsafe(0);
}
$1d6ce7ec05afe9d6$var$Splitter.prototype.add = function(data) {
    this.cache = $1d6ce7ec05afe9d6$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$1d6ce7ec05afe9d6$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$1d6ce7ec05afe9d6$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $1d6ce7ec05afe9d6$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $1d6ce7ec05afe9d6$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $1d6ce7ec05afe9d6$var$createCipheriv(suite, password, iv) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $1d6ce7ec05afe9d6$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $1d6ce7ec05afe9d6$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $2mx7M(config.module, password, iv);
    else if (config.type === 'auth') return new $kvo4q(config.module, password, iv);
    return new $1d6ce7ec05afe9d6$var$Cipher(config.module, password, iv);
}
function $1d6ce7ec05afe9d6$var$createCipher(suite, password) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, config.key, config.iv);
    return $1d6ce7ec05afe9d6$var$createCipheriv(suite, keys.key, keys.iv);
}
$1d6ce7ec05afe9d6$export$2f64596b8cbf08b4 = $1d6ce7ec05afe9d6$var$createCipheriv;
$1d6ce7ec05afe9d6$export$bdd223f16383713e = $1d6ce7ec05afe9d6$var$createCipher;

});
parcelRegister("gaNIZ", function(module, exports) {








var $bc6426c4a0e99f84$var$modeModules = {
    ECB: (parcelRequire("4VNRd")),
    CBC: (parcelRequire("dSvNa")),
    CFB: (parcelRequire("hBCvG")),
    CFB8: (parcelRequire("4EjJt")),
    CFB1: (parcelRequire("deF8T")),
    OFB: (parcelRequire("bxTz8")),
    CTR: (parcelRequire("5DIgH")),
    GCM: (parcelRequire("5DIgH"))
};

var $fmEa8 = parcelRequire("fmEa8");
for(var $bc6426c4a0e99f84$var$key in $fmEa8)$fmEa8[$bc6426c4a0e99f84$var$key].module = $bc6426c4a0e99f84$var$modeModules[$fmEa8[$bc6426c4a0e99f84$var$key].mode];
module.exports = $fmEa8;

});
parcelRegister("4VNRd", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $397328e55f3c5ce5$export$5b0f6292f11d1d18; }, function (v) { return $397328e55f3c5ce5$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $397328e55f3c5ce5$export$e85a0c9a1067c5d3; }, function (v) { return $397328e55f3c5ce5$export$e85a0c9a1067c5d3 = v; });
var $397328e55f3c5ce5$export$5b0f6292f11d1d18;
var $397328e55f3c5ce5$export$e85a0c9a1067c5d3;
$397328e55f3c5ce5$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$397328e55f3c5ce5$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("dSvNa", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $a1a8faba74f8f15b$export$5b0f6292f11d1d18; }, function (v) { return $a1a8faba74f8f15b$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $a1a8faba74f8f15b$export$e85a0c9a1067c5d3; }, function (v) { return $a1a8faba74f8f15b$export$e85a0c9a1067c5d3 = v; });
var $a1a8faba74f8f15b$export$5b0f6292f11d1d18;
var $a1a8faba74f8f15b$export$e85a0c9a1067c5d3;

var $lG93x = parcelRequire("lG93x");
$a1a8faba74f8f15b$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $lG93x(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$a1a8faba74f8f15b$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $lG93x(out, pad);
};

});
parcelRegister("lG93x", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $fc848b8cbe231ed8$require$Buffer = $bdjQ6.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $fc848b8cbe231ed8$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("hBCvG", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $cd13c3a99dff038d$export$5b0f6292f11d1d18; }, function (v) { return $cd13c3a99dff038d$export$5b0f6292f11d1d18 = v; });
var $cd13c3a99dff038d$export$5b0f6292f11d1d18;

var $838j1 = parcelRequire("838j1");
var $cd13c3a99dff038d$require$Buffer = $838j1.Buffer;

var $lG93x = parcelRequire("lG93x");
function $cd13c3a99dff038d$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $lG93x(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $cd13c3a99dff038d$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$cd13c3a99dff038d$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $cd13c3a99dff038d$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $cd13c3a99dff038d$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $cd13c3a99dff038d$require$Buffer.concat([
                out,
                $cd13c3a99dff038d$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $cd13c3a99dff038d$require$Buffer.concat([
                out,
                $cd13c3a99dff038d$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("4EjJt", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $362a34512b2cb660$export$5b0f6292f11d1d18; }, function (v) { return $362a34512b2cb660$export$5b0f6292f11d1d18 = v; });
var $362a34512b2cb660$export$5b0f6292f11d1d18;

var $838j1 = parcelRequire("838j1");
var $362a34512b2cb660$require$Buffer = $838j1.Buffer;
function $362a34512b2cb660$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $362a34512b2cb660$require$Buffer.concat([
        self._prev.slice(1),
        $362a34512b2cb660$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$362a34512b2cb660$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $362a34512b2cb660$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $362a34512b2cb660$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("deF8T", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18; }, function (v) { return $9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18 = v; });
var $9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18;

var $838j1 = parcelRequire("838j1");
var $9a2c7f2fbbd3a86b$require$Buffer = $838j1.Buffer;
function $9a2c7f2fbbd3a86b$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $9a2c7f2fbbd3a86b$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $9a2c7f2fbbd3a86b$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $9a2c7f2fbbd3a86b$require$Buffer.allocUnsafe(buffer.length);
    buffer = $9a2c7f2fbbd3a86b$require$Buffer.concat([
        buffer,
        $9a2c7f2fbbd3a86b$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$9a2c7f2fbbd3a86b$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $9a2c7f2fbbd3a86b$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $9a2c7f2fbbd3a86b$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("bxTz8", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $867de0f3149c6687$export$5b0f6292f11d1d18; }, function (v) { return $867de0f3149c6687$export$5b0f6292f11d1d18 = v; });
var $867de0f3149c6687$export$5b0f6292f11d1d18;

var $bdjQ6 = parcelRequire("bdjQ6");
var $867de0f3149c6687$require$Buffer = $bdjQ6.Buffer;

var $lG93x = parcelRequire("lG93x");
function $867de0f3149c6687$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$867de0f3149c6687$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $867de0f3149c6687$require$Buffer.concat([
        self._cache,
        $867de0f3149c6687$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $lG93x(chunk, pad);
};

});

parcelRegister("5DIgH", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $41b2ef081a6e05a6$export$5b0f6292f11d1d18; }, function (v) { return $41b2ef081a6e05a6$export$5b0f6292f11d1d18 = v; });
var $41b2ef081a6e05a6$export$5b0f6292f11d1d18;

var $lG93x = parcelRequire("lG93x");

var $838j1 = parcelRequire("838j1");
var $41b2ef081a6e05a6$require$Buffer = $838j1.Buffer;

var $h75HQ = parcelRequire("h75HQ");
function $41b2ef081a6e05a6$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $h75HQ(self._prev);
    return out;
}
var $41b2ef081a6e05a6$var$blockSize = 16;
$41b2ef081a6e05a6$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $41b2ef081a6e05a6$var$blockSize);
    var start = self._cache.length;
    self._cache = $41b2ef081a6e05a6$require$Buffer.concat([
        self._cache,
        $41b2ef081a6e05a6$require$Buffer.allocUnsafe(chunkNum * $41b2ef081a6e05a6$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $41b2ef081a6e05a6$var$getBlock(self);
        var offset = start + i * $41b2ef081a6e05a6$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $lG93x(chunk, pad);
};

});
parcelRegister("h75HQ", function(module, exports) {
function $c7578441bba1d8c9$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $c7578441bba1d8c9$var$incr32;

});


parcelRegister("fmEa8", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("kvo4q", function(module, exports) {

var $caH4w = parcelRequire("caH4w");

var $838j1 = parcelRequire("838j1");
var $eed95fc46cf3d7a4$require$Buffer = $838j1.Buffer;

var $6GOuC = parcelRequire("6GOuC");

var $dhT4G = parcelRequire("dhT4G");

var $9hgQS = parcelRequire("9hgQS");

var $lG93x = parcelRequire("lG93x");

var $h75HQ = parcelRequire("h75HQ");
function $eed95fc46cf3d7a4$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $eed95fc46cf3d7a4$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $eed95fc46cf3d7a4$require$Buffer.concat([
            iv,
            $eed95fc46cf3d7a4$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $eed95fc46cf3d7a4$require$Buffer.concat([
            iv,
            $eed95fc46cf3d7a4$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $9hgQS(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($eed95fc46cf3d7a4$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($eed95fc46cf3d7a4$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $eed95fc46cf3d7a4$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $eed95fc46cf3d7a4$require$Buffer.from(self._finID);
    $h75HQ(out);
    return out;
}
function $eed95fc46cf3d7a4$var$StreamCipher(mode, key, iv, decrypt) {
    $6GOuC.call(this);
    var h = $eed95fc46cf3d7a4$require$Buffer.alloc(4, 0);
    this._cipher = new $caH4w.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $9hgQS(ck);
    iv = $eed95fc46cf3d7a4$var$calcIv(this, iv, ck);
    this._prev = $eed95fc46cf3d7a4$require$Buffer.from(iv);
    this._cache = $eed95fc46cf3d7a4$require$Buffer.allocUnsafe(0);
    this._secCache = $eed95fc46cf3d7a4$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dhT4G($eed95fc46cf3d7a4$var$StreamCipher, $6GOuC);
$eed95fc46cf3d7a4$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $eed95fc46cf3d7a4$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $lG93x(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $eed95fc46cf3d7a4$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$eed95fc46cf3d7a4$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$eed95fc46cf3d7a4$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $eed95fc46cf3d7a4$var$StreamCipher;

});
parcelRegister("caH4w", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $8dc7d467606a8980$export$b80fbe1c3a2b92b5; }, function (v) { return $8dc7d467606a8980$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $8dc7d467606a8980$export$b80fbe1c3a2b92b5;

var $838j1 = parcelRequire("838j1");
var $8dc7d467606a8980$require$Buffer = $838j1.Buffer;
function $8dc7d467606a8980$var$asUInt32Array(buf) {
    if (!$8dc7d467606a8980$require$Buffer.isBuffer(buf)) buf = $8dc7d467606a8980$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $8dc7d467606a8980$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $8dc7d467606a8980$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $8dc7d467606a8980$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $8dc7d467606a8980$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $8dc7d467606a8980$var$AES(key) {
    this._key = $8dc7d467606a8980$var$asUInt32Array(key);
    this._reset();
}
$8dc7d467606a8980$var$AES.blockSize = 16;
$8dc7d467606a8980$var$AES.keySize = 32;
$8dc7d467606a8980$var$AES.prototype.blockSize = $8dc7d467606a8980$var$AES.blockSize;
$8dc7d467606a8980$var$AES.prototype.keySize = $8dc7d467606a8980$var$AES.keySize;
$8dc7d467606a8980$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $8dc7d467606a8980$var$G.SBOX[t >>> 24] << 24 | $8dc7d467606a8980$var$G.SBOX[t >>> 16 & 0xff] << 16 | $8dc7d467606a8980$var$G.SBOX[t >>> 8 & 0xff] << 8 | $8dc7d467606a8980$var$G.SBOX[t & 0xff];
            t ^= $8dc7d467606a8980$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $8dc7d467606a8980$var$G.SBOX[t >>> 24] << 24 | $8dc7d467606a8980$var$G.SBOX[t >>> 16 & 0xff] << 16 | $8dc7d467606a8980$var$G.SBOX[t >>> 8 & 0xff] << 8 | $8dc7d467606a8980$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $8dc7d467606a8980$var$G.INV_SUB_MIX[0][$8dc7d467606a8980$var$G.SBOX[tt >>> 24]] ^ $8dc7d467606a8980$var$G.INV_SUB_MIX[1][$8dc7d467606a8980$var$G.SBOX[tt >>> 16 & 0xff]] ^ $8dc7d467606a8980$var$G.INV_SUB_MIX[2][$8dc7d467606a8980$var$G.SBOX[tt >>> 8 & 0xff]] ^ $8dc7d467606a8980$var$G.INV_SUB_MIX[3][$8dc7d467606a8980$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$8dc7d467606a8980$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $8dc7d467606a8980$var$asUInt32Array(M);
    return $8dc7d467606a8980$var$cryptBlock(M, this._keySchedule, $8dc7d467606a8980$var$G.SUB_MIX, $8dc7d467606a8980$var$G.SBOX, this._nRounds);
};
$8dc7d467606a8980$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $8dc7d467606a8980$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$8dc7d467606a8980$var$AES.prototype.decryptBlock = function(M) {
    M = $8dc7d467606a8980$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $8dc7d467606a8980$var$cryptBlock(M, this._invKeySchedule, $8dc7d467606a8980$var$G.INV_SUB_MIX, $8dc7d467606a8980$var$G.INV_SBOX, this._nRounds);
    var buf = $8dc7d467606a8980$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$8dc7d467606a8980$var$AES.prototype.scrub = function() {
    $8dc7d467606a8980$var$scrubVec(this._keySchedule);
    $8dc7d467606a8980$var$scrubVec(this._invKeySchedule);
    $8dc7d467606a8980$var$scrubVec(this._key);
};
$8dc7d467606a8980$export$b80fbe1c3a2b92b5 = $8dc7d467606a8980$var$AES;

});

parcelRegister("9hgQS", function(module, exports) {

var $838j1 = parcelRequire("838j1");
var $6c12c604584aeb07$require$Buffer = $838j1.Buffer;
var $6c12c604584aeb07$var$ZEROES = $6c12c604584aeb07$require$Buffer.alloc(16, 0);
function $6c12c604584aeb07$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $6c12c604584aeb07$var$fromArray(out) {
    var buf = $6c12c604584aeb07$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $6c12c604584aeb07$var$GHASH(key) {
    this.h = key;
    this.state = $6c12c604584aeb07$require$Buffer.alloc(16, 0);
    this.cache = $6c12c604584aeb07$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$6c12c604584aeb07$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$6c12c604584aeb07$var$GHASH.prototype._multiply = function() {
    var Vi = $6c12c604584aeb07$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $6c12c604584aeb07$var$fromArray(Zi);
};
$6c12c604584aeb07$var$GHASH.prototype.update = function(buf) {
    this.cache = $6c12c604584aeb07$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$6c12c604584aeb07$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($6c12c604584aeb07$require$Buffer.concat([
        this.cache,
        $6c12c604584aeb07$var$ZEROES
    ], 16));
    this.ghash($6c12c604584aeb07$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $6c12c604584aeb07$var$GHASH;

});


parcelRegister("2mx7M", function(module, exports) {

var $caH4w = parcelRequire("caH4w");

var $838j1 = parcelRequire("838j1");
var $1b8754b29224ac43$require$Buffer = $838j1.Buffer;

var $6GOuC = parcelRequire("6GOuC");

var $dhT4G = parcelRequire("dhT4G");
function $1b8754b29224ac43$var$StreamCipher(mode, key, iv, decrypt) {
    $6GOuC.call(this);
    this._cipher = new $caH4w.AES(key);
    this._prev = $1b8754b29224ac43$require$Buffer.from(iv);
    this._cache = $1b8754b29224ac43$require$Buffer.allocUnsafe(0);
    this._secCache = $1b8754b29224ac43$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dhT4G($1b8754b29224ac43$var$StreamCipher, $6GOuC);
$1b8754b29224ac43$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$1b8754b29224ac43$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $1b8754b29224ac43$var$StreamCipher;

});

parcelRegister("iWvja", function(module, exports) {

var $838j1 = parcelRequire("838j1");
var $dca5eded79f2f8af$require$Buffer = $838j1.Buffer;

var $2GAk4 = parcelRequire("2GAk4");
/* eslint-disable camelcase */ function $dca5eded79f2f8af$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$dca5eded79f2f8af$require$Buffer.isBuffer(password)) password = $dca5eded79f2f8af$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$dca5eded79f2f8af$require$Buffer.isBuffer(salt)) salt = $dca5eded79f2f8af$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $dca5eded79f2f8af$require$Buffer.alloc(keyLen);
    var iv = $dca5eded79f2f8af$require$Buffer.alloc(ivLen || 0);
    var tmp = $dca5eded79f2f8af$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $2GAk4();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $dca5eded79f2f8af$var$EVP_BytesToKey;

});


parcelRegister("3eloO", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $25a34751f31406fd$export$12ada9414fbc594c; }, function (v) { return $25a34751f31406fd$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $25a34751f31406fd$export$36b6d6ef312eab39; }, function (v) { return $25a34751f31406fd$export$36b6d6ef312eab39 = v; });
var $25a34751f31406fd$export$12ada9414fbc594c;
var $25a34751f31406fd$export$36b6d6ef312eab39;

var $kvo4q = parcelRequire("kvo4q");

var $838j1 = parcelRequire("838j1");
var $25a34751f31406fd$require$Buffer = $838j1.Buffer;

var $gaNIZ = parcelRequire("gaNIZ");

var $2mx7M = parcelRequire("2mx7M");

var $6GOuC = parcelRequire("6GOuC");

var $caH4w = parcelRequire("caH4w");

var $iWvja = parcelRequire("iWvja");

var $dhT4G = parcelRequire("dhT4G");
function $25a34751f31406fd$var$Decipher(mode, key, iv) {
    $6GOuC.call(this);
    this._cache = new $25a34751f31406fd$var$Splitter();
    this._last = void 0;
    this._cipher = new $caH4w.AES(key);
    this._prev = $25a34751f31406fd$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dhT4G($25a34751f31406fd$var$Decipher, $6GOuC);
$25a34751f31406fd$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $25a34751f31406fd$require$Buffer.concat(out);
};
$25a34751f31406fd$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $25a34751f31406fd$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$25a34751f31406fd$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $25a34751f31406fd$var$Splitter() {
    this.cache = $25a34751f31406fd$require$Buffer.allocUnsafe(0);
}
$25a34751f31406fd$var$Splitter.prototype.add = function(data) {
    this.cache = $25a34751f31406fd$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$25a34751f31406fd$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$25a34751f31406fd$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $25a34751f31406fd$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $25a34751f31406fd$var$createDecipheriv(suite, password, iv) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $25a34751f31406fd$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $25a34751f31406fd$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $2mx7M(config.module, password, iv, true);
    else if (config.type === 'auth') return new $kvo4q(config.module, password, iv, true);
    return new $25a34751f31406fd$var$Decipher(config.module, password, iv);
}
function $25a34751f31406fd$var$createDecipher(suite, password) {
    var config = $gaNIZ[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $iWvja(password, false, config.key, config.iv);
    return $25a34751f31406fd$var$createDecipheriv(suite, keys.key, keys.iv);
}
$25a34751f31406fd$export$12ada9414fbc594c = $25a34751f31406fd$var$createDecipher;
$25a34751f31406fd$export$36b6d6ef312eab39 = $25a34751f31406fd$var$createDecipheriv;

});


parcelRegister("baPH8", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $8228ba5d20e426a7$export$116f8a5cee447347; }, function (v) { return $8228ba5d20e426a7$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $8228ba5d20e426a7$export$7483c4066bfb7ae9; }, function (v) { return $8228ba5d20e426a7$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $8228ba5d20e426a7$export$e7a565d2e588bb06; }, function (v) { return $8228ba5d20e426a7$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $8228ba5d20e426a7$export$aaa2f54a426f3eb8; }, function (v) { return $8228ba5d20e426a7$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $8228ba5d20e426a7$export$eba20568dde4ada; }, function (v) { return $8228ba5d20e426a7$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $8228ba5d20e426a7$export$d3b5e5996938f5ae; }, function (v) { return $8228ba5d20e426a7$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $8228ba5d20e426a7$export$57c08356130bc99b; }, function (v) { return $8228ba5d20e426a7$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $8228ba5d20e426a7$export$c7169791d5c1e65d; }, function (v) { return $8228ba5d20e426a7$export$c7169791d5c1e65d = v; });
var $8228ba5d20e426a7$export$116f8a5cee447347;
var $8228ba5d20e426a7$export$7483c4066bfb7ae9;
var $8228ba5d20e426a7$export$e7a565d2e588bb06;
var $8228ba5d20e426a7$export$aaa2f54a426f3eb8;
var $8228ba5d20e426a7$export$eba20568dde4ada;
var $8228ba5d20e426a7$export$d3b5e5996938f5ae;
var $8228ba5d20e426a7$export$57c08356130bc99b;
var $8228ba5d20e426a7$export$c7169791d5c1e65d;
$8228ba5d20e426a7$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$8228ba5d20e426a7$export$7483c4066bfb7ae9 = $8228ba5d20e426a7$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$8228ba5d20e426a7$export$aaa2f54a426f3eb8 = $8228ba5d20e426a7$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$8228ba5d20e426a7$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$8228ba5d20e426a7$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$8228ba5d20e426a7$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("8wQsp", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $635a00d17aeeed5c$export$971862a2fcb1bb40; }, function (v) { return $635a00d17aeeed5c$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $635a00d17aeeed5c$export$c6ff6a88acbeaf40; }, function (v) { return $635a00d17aeeed5c$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $635a00d17aeeed5c$export$fdc27893e98845cc; }, function (v) { return $635a00d17aeeed5c$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $635a00d17aeeed5c$export$6671fb9a1323bed; }, function (v) { return $635a00d17aeeed5c$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $635a00d17aeeed5c$export$d74daf141a551db; }, function (v) { return $635a00d17aeeed5c$export$d74daf141a551db = v; });
var $635a00d17aeeed5c$export$971862a2fcb1bb40;
var $635a00d17aeeed5c$export$c6ff6a88acbeaf40;
var $635a00d17aeeed5c$export$fdc27893e98845cc;
var $635a00d17aeeed5c$export$6671fb9a1323bed;
var $635a00d17aeeed5c$export$d74daf141a551db;

var $bdjQ6 = parcelRequire("bdjQ6");
var $635a00d17aeeed5c$require$Buffer = $bdjQ6.Buffer;

var $9quzp = parcelRequire("9quzp");

var $lNdHe = parcelRequire("lNdHe");

var $8Xury = parcelRequire("8Xury");
function $635a00d17aeeed5c$var$getDiffieHellman(mod) {
    var prime = new $635a00d17aeeed5c$require$Buffer($lNdHe[mod].prime, 'hex');
    var gen = new $635a00d17aeeed5c$require$Buffer($lNdHe[mod].gen, 'hex');
    return new $8Xury(prime, gen);
}
var $635a00d17aeeed5c$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $635a00d17aeeed5c$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($635a00d17aeeed5c$require$Buffer.isBuffer(enc) || $635a00d17aeeed5c$var$ENCODINGS[enc] === undefined) return $635a00d17aeeed5c$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $635a00d17aeeed5c$require$Buffer([
        2
    ]);
    if (!$635a00d17aeeed5c$require$Buffer.isBuffer(generator)) generator = new $635a00d17aeeed5c$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $8Xury($9quzp(prime, generator), generator, true);
    if (!$635a00d17aeeed5c$require$Buffer.isBuffer(prime)) prime = new $635a00d17aeeed5c$require$Buffer(prime, enc);
    return new $8Xury(prime, generator, true);
}
$635a00d17aeeed5c$export$971862a2fcb1bb40 = $635a00d17aeeed5c$export$c6ff6a88acbeaf40 = $635a00d17aeeed5c$export$fdc27893e98845cc = $635a00d17aeeed5c$var$getDiffieHellman;
$635a00d17aeeed5c$export$6671fb9a1323bed = $635a00d17aeeed5c$export$d74daf141a551db = $635a00d17aeeed5c$var$createDiffieHellman;

});
parcelRegister("9quzp", function(module, exports) {

var $f08he = parcelRequire("f08he");
module.exports = $6dce41594cded7d5$var$findPrime;
$6dce41594cded7d5$var$findPrime.simpleSieve = $6dce41594cded7d5$var$simpleSieve;
$6dce41594cded7d5$var$findPrime.fermatTest = $6dce41594cded7d5$var$fermatTest;

var $8pG42 = parcelRequire("8pG42");
var $6dce41594cded7d5$var$TWENTYFOUR = new $8pG42(24);

var $gVwT3 = parcelRequire("gVwT3");
var $6dce41594cded7d5$var$millerRabin = new $gVwT3();
var $6dce41594cded7d5$var$ONE = new $8pG42(1);
var $6dce41594cded7d5$var$TWO = new $8pG42(2);
var $6dce41594cded7d5$var$FIVE = new $8pG42(5);
var $6dce41594cded7d5$var$SIXTEEN = new $8pG42(16);
var $6dce41594cded7d5$var$EIGHT = new $8pG42(8);
var $6dce41594cded7d5$var$TEN = new $8pG42(10);
var $6dce41594cded7d5$var$THREE = new $8pG42(3);
var $6dce41594cded7d5$var$SEVEN = new $8pG42(7);
var $6dce41594cded7d5$var$ELEVEN = new $8pG42(11);
var $6dce41594cded7d5$var$FOUR = new $8pG42(4);
var $6dce41594cded7d5$var$TWELVE = new $8pG42(12);
var $6dce41594cded7d5$var$primes = null;
function $6dce41594cded7d5$var$_getPrimes() {
    if ($6dce41594cded7d5$var$primes !== null) return $6dce41594cded7d5$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $6dce41594cded7d5$var$primes = res;
    return res;
}
function $6dce41594cded7d5$var$simpleSieve(p) {
    var primes = $6dce41594cded7d5$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $6dce41594cded7d5$var$fermatTest(p) {
    var red = $8pG42.mont(p);
    return $6dce41594cded7d5$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $6dce41594cded7d5$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $8pG42([
            0x8c,
            0x7b
        ]);
        else return new $8pG42([
            0x8c,
            0x27
        ]);
    }
    gen = new $8pG42(gen);
    var num, n2;
    while(true){
        num = new $8pG42($f08he(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($6dce41594cded7d5$var$ONE);
        if (!num.testn(1)) num.iadd($6dce41594cded7d5$var$TWO);
        if (!gen.cmp($6dce41594cded7d5$var$TWO)) while(num.mod($6dce41594cded7d5$var$TWENTYFOUR).cmp($6dce41594cded7d5$var$ELEVEN))num.iadd($6dce41594cded7d5$var$FOUR);
        else if (!gen.cmp($6dce41594cded7d5$var$FIVE)) while(num.mod($6dce41594cded7d5$var$TEN).cmp($6dce41594cded7d5$var$THREE))num.iadd($6dce41594cded7d5$var$FOUR);
        n2 = num.shrn(1);
        if ($6dce41594cded7d5$var$simpleSieve(n2) && $6dce41594cded7d5$var$simpleSieve(num) && $6dce41594cded7d5$var$fermatTest(n2) && $6dce41594cded7d5$var$fermatTest(num) && $6dce41594cded7d5$var$millerRabin.test(n2) && $6dce41594cded7d5$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("8pG42", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("gVwT3", function(module, exports) {

var $8OaS6 = parcelRequire("8OaS6");

var $gWiKw = parcelRequire("gWiKw");
function $c52b7ae23bf69e77$var$MillerRabin(rand) {
    this.rand = rand || new $gWiKw.Rand();
}
module.exports = $c52b7ae23bf69e77$var$MillerRabin;
$c52b7ae23bf69e77$var$MillerRabin.create = function create(rand) {
    return new $c52b7ae23bf69e77$var$MillerRabin(rand);
};
$c52b7ae23bf69e77$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $8OaS6(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$c52b7ae23bf69e77$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$c52b7ae23bf69e77$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $8OaS6.mont(n);
    var rone = new $8OaS6(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $8OaS6(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$c52b7ae23bf69e77$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $8OaS6.mont(n);
    var rone = new $8OaS6(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $8OaS6(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("8OaS6", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("gWiKw", function(module, exports) {
var $c5509b5bd465f083$var$r;
module.exports = function rand(len) {
    if (!$c5509b5bd465f083$var$r) $c5509b5bd465f083$var$r = new $c5509b5bd465f083$var$Rand(null);
    return $c5509b5bd465f083$var$r.generate(len);
};
function $c5509b5bd465f083$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $c5509b5bd465f083$var$Rand;
$c5509b5bd465f083$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $c5509b5bd465f083$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $c5509b5bd465f083$var$crypto = (parcelRequire("ifbub"));
    if (typeof $c5509b5bd465f083$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $c5509b5bd465f083$var$Rand.prototype._rand = function _rand(n) {
        return $c5509b5bd465f083$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("lNdHe", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("8Xury", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $685b72df33913130$require$Buffer = $bdjQ6.Buffer;

var $8pG42 = parcelRequire("8pG42");

var $gVwT3 = parcelRequire("gVwT3");
var $685b72df33913130$var$millerRabin = new $gVwT3();
var $685b72df33913130$var$TWENTYFOUR = new $8pG42(24);
var $685b72df33913130$var$ELEVEN = new $8pG42(11);
var $685b72df33913130$var$TEN = new $8pG42(10);
var $685b72df33913130$var$THREE = new $8pG42(3);
var $685b72df33913130$var$SEVEN = new $8pG42(7);

var $9quzp = parcelRequire("9quzp");

var $f08he = parcelRequire("f08he");
module.exports = $685b72df33913130$var$DH;
function $685b72df33913130$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$685b72df33913130$require$Buffer.isBuffer(pub)) pub = new $685b72df33913130$require$Buffer(pub, enc);
    this._pub = new $8pG42(pub);
    return this;
}
function $685b72df33913130$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$685b72df33913130$require$Buffer.isBuffer(priv)) priv = new $685b72df33913130$require$Buffer(priv, enc);
    this._priv = new $8pG42(priv);
    return this;
}
var $685b72df33913130$var$primeCache = {};
function $685b72df33913130$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $685b72df33913130$var$primeCache) return $685b72df33913130$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$9quzp.simpleSieve || !$9quzp.fermatTest(prime) || !$685b72df33913130$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $685b72df33913130$var$primeCache[hex] = error;
        return error;
    }
    if (!$685b72df33913130$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($685b72df33913130$var$TWENTYFOUR).cmp($685b72df33913130$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($685b72df33913130$var$TEN);
            if (rem.cmp($685b72df33913130$var$THREE) && rem.cmp($685b72df33913130$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $685b72df33913130$var$primeCache[hex] = error;
    return error;
}
function $685b72df33913130$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $8pG42(prime);
    this._prime = $8pG42.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $685b72df33913130$var$setPublicKey;
        this.setPrivateKey = $685b72df33913130$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($685b72df33913130$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $685b72df33913130$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$685b72df33913130$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $8pG42($f08he(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$685b72df33913130$var$DH.prototype.computeSecret = function(other) {
    other = new $8pG42(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $685b72df33913130$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $685b72df33913130$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $685b72df33913130$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$685b72df33913130$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $685b72df33913130$var$formatReturnValue(this._pub, enc);
};
$685b72df33913130$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $685b72df33913130$var$formatReturnValue(this._priv, enc);
};
$685b72df33913130$var$DH.prototype.getPrime = function(enc) {
    return $685b72df33913130$var$formatReturnValue(this.__prime, enc);
};
$685b72df33913130$var$DH.prototype.getGenerator = function(enc) {
    return $685b72df33913130$var$formatReturnValue(this._gen, enc);
};
$685b72df33913130$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$685b72df33913130$require$Buffer.isBuffer(gen)) gen = new $685b72df33913130$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $8pG42(gen);
    return this;
};
function $685b72df33913130$var$formatReturnValue(bn, enc) {
    var buf = new $685b72df33913130$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("bASYu", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $870db353fba87e6d$require$Buffer = $838j1.Buffer;

var $eNPUV = parcelRequire("eNPUV");

var $dFZZW = parcelRequire("dFZZW");

var $dhT4G = parcelRequire("dhT4G");

var $61Mau = parcelRequire("61Mau");

var $7LwOP = parcelRequire("7LwOP");

var $gm4QM = parcelRequire("gm4QM");
Object.keys($gm4QM).forEach(function(key) {
    $gm4QM[key].id = $870db353fba87e6d$require$Buffer.from($gm4QM[key].id, 'hex');
    $gm4QM[key.toLowerCase()] = $gm4QM[key];
});
function $870db353fba87e6d$var$Sign(algorithm) {
    $dFZZW.Writable.call(this);
    var data = $gm4QM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $eNPUV(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dhT4G($870db353fba87e6d$var$Sign, $dFZZW.Writable);
$870db353fba87e6d$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$870db353fba87e6d$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $870db353fba87e6d$require$Buffer.from(data, enc) : data);
    return this;
};
$870db353fba87e6d$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $61Mau(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $870db353fba87e6d$var$Verify(algorithm) {
    $dFZZW.Writable.call(this);
    var data = $gm4QM[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $eNPUV(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dhT4G($870db353fba87e6d$var$Verify, $dFZZW.Writable);
$870db353fba87e6d$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$870db353fba87e6d$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $870db353fba87e6d$require$Buffer.from(data, enc) : data);
    return this;
};
$870db353fba87e6d$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $870db353fba87e6d$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $7LwOP(sigBuffer, hash, key, this._signType, this._tag);
};
function $870db353fba87e6d$var$createSign(algorithm) {
    return new $870db353fba87e6d$var$Sign(algorithm);
}
function $870db353fba87e6d$var$createVerify(algorithm) {
    return new $870db353fba87e6d$var$Verify(algorithm);
}
module.exports = {
    Sign: $870db353fba87e6d$var$createSign,
    Verify: $870db353fba87e6d$var$createVerify,
    createSign: $870db353fba87e6d$var$createSign,
    createVerify: $870db353fba87e6d$var$createVerify
};

});
parcelRegister("61Mau", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $463833414b7fa82a$require$Buffer = $838j1.Buffer;

var $cL3Ff = parcelRequire("cL3Ff");

var $2jcIV = parcelRequire("2jcIV");

var $a2sGY = parcelRequire("a2sGY");
var $463833414b7fa82a$require$EC = $a2sGY.ec;

var $aVh2m = parcelRequire("aVh2m");

var $hdVtR = parcelRequire("hdVtR");

var $6cUou = parcelRequire("6cUou");
var $463833414b7fa82a$var$RSA_PKCS1_PADDING = 1;
function $463833414b7fa82a$var$sign(hash, key, hashType, signType, tag) {
    var priv = $hdVtR(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $463833414b7fa82a$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $463833414b7fa82a$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $463833414b7fa82a$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $463833414b7fa82a$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $2jcIV(pad, priv);
    return out;
}
function $463833414b7fa82a$var$ecSign(hash, priv) {
    var curveId = $6cUou[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $463833414b7fa82a$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $463833414b7fa82a$require$Buffer.from(out.toDER());
}
function $463833414b7fa82a$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $aVh2m(0);
    var k;
    var H = $463833414b7fa82a$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $463833414b7fa82a$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $463833414b7fa82a$var$makeKey(q, kv, algo);
        r = $463833414b7fa82a$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $aVh2m(0);
        }
    }
    return $463833414b7fa82a$var$toDER(r, s);
}
function $463833414b7fa82a$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $463833414b7fa82a$require$Buffer.from(res);
}
function $463833414b7fa82a$var$getKey(x, q, hash, algo) {
    x = $463833414b7fa82a$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $463833414b7fa82a$require$Buffer.alloc(q.byteLength() - x.length);
        x = $463833414b7fa82a$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $463833414b7fa82a$var$bits2octets(hash, q);
    var v = $463833414b7fa82a$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $463833414b7fa82a$require$Buffer.alloc(hlen);
    k = $cL3Ff(algo, k).update(v).update($463833414b7fa82a$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $cL3Ff(algo, k).update(v).digest();
    k = $cL3Ff(algo, k).update(v).update($463833414b7fa82a$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $cL3Ff(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $463833414b7fa82a$var$bits2int(obits, q) {
    var bits = new $aVh2m(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $463833414b7fa82a$var$bits2octets(bits, q) {
    bits = $463833414b7fa82a$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $463833414b7fa82a$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $463833414b7fa82a$require$Buffer.alloc(q.byteLength() - out.length);
        out = $463833414b7fa82a$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $463833414b7fa82a$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $463833414b7fa82a$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $cL3Ff(algo, kv.k).update(kv.v).digest();
            t = $463833414b7fa82a$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $463833414b7fa82a$var$bits2int(t, q);
        kv.k = $cL3Ff(algo, kv.k).update(kv.v).update($463833414b7fa82a$require$Buffer.from([
            0
        ])).digest();
        kv.v = $cL3Ff(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $463833414b7fa82a$var$makeR(g, k, p, q) {
    return g.toRed($aVh2m.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $463833414b7fa82a$var$sign;
module.exports.getKey = $463833414b7fa82a$var$getKey;
module.exports.makeKey = $463833414b7fa82a$var$makeKey;

});
parcelRegister("2jcIV", function(module, exports) {
'use strict';

var $aVh2m = parcelRequire("aVh2m");

var $f08he = parcelRequire("f08he");

var $838j1 = parcelRequire("838j1");
var $1ae739bfcb63454f$require$Buffer = $838j1.Buffer;
function $1ae739bfcb63454f$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $aVh2m($f08he(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $1ae739bfcb63454f$var$blind(priv) {
    var r = $1ae739bfcb63454f$var$getr(priv);
    var blinder = r.toRed($aVh2m.mont(priv.modulus)).redPow(new $aVh2m(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $1ae739bfcb63454f$var$crt(msg, priv) {
    var blinds = $1ae739bfcb63454f$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $aVh2m(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($aVh2m.mont(priv.prime1));
    var c2 = blinded.toRed($aVh2m.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($1ae739bfcb63454f$require$Buffer, 'be', len);
}
$1ae739bfcb63454f$var$crt.getr = $1ae739bfcb63454f$var$getr;
module.exports = $1ae739bfcb63454f$var$crt;

});
parcelRegister("aVh2m", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("a2sGY", function(module, exports) {
'use strict';
var $74f058f4ed5df70c$var$elliptic = module.exports;

$74f058f4ed5df70c$var$elliptic.version = (parcelRequire("5yWHA")).version;

$74f058f4ed5df70c$var$elliptic.utils = (parcelRequire("2KPxf"));

$74f058f4ed5df70c$var$elliptic.rand = (parcelRequire("gWiKw"));

$74f058f4ed5df70c$var$elliptic.curve = (parcelRequire("5Hkfi"));

$74f058f4ed5df70c$var$elliptic.curves = (parcelRequire("hKjoi"));

// Protocols
$74f058f4ed5df70c$var$elliptic.ec = (parcelRequire("ijEQd"));

$74f058f4ed5df70c$var$elliptic.eddsa = (parcelRequire("9fmHx"));

});
parcelRegister("5yWHA", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("2KPxf", function(module, exports) {
'use strict';
var $2017da7f3b92fe8f$var$utils = module.exports;

var $7iECc = parcelRequire("7iECc");

var $jLTFB = parcelRequire("jLTFB");

var $bA0W1 = parcelRequire("bA0W1");
$2017da7f3b92fe8f$var$utils.assert = $jLTFB;
$2017da7f3b92fe8f$var$utils.toArray = $bA0W1.toArray;
$2017da7f3b92fe8f$var$utils.zero2 = $bA0W1.zero2;
$2017da7f3b92fe8f$var$utils.toHex = $bA0W1.toHex;
$2017da7f3b92fe8f$var$utils.encode = $bA0W1.encode;
// Represent num in a w-NAF form
function $2017da7f3b92fe8f$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$2017da7f3b92fe8f$var$utils.getNAF = $2017da7f3b92fe8f$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $2017da7f3b92fe8f$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$2017da7f3b92fe8f$var$utils.getJSF = $2017da7f3b92fe8f$var$getJSF;
function $2017da7f3b92fe8f$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$2017da7f3b92fe8f$var$utils.cachedProperty = $2017da7f3b92fe8f$var$cachedProperty;
function $2017da7f3b92fe8f$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $2017da7f3b92fe8f$var$utils.toArray(bytes, 'hex') : bytes;
}
$2017da7f3b92fe8f$var$utils.parseBytes = $2017da7f3b92fe8f$var$parseBytes;
function $2017da7f3b92fe8f$var$intFromLE(bytes) {
    return new $7iECc(bytes, 'hex', 'le');
}
$2017da7f3b92fe8f$var$utils.intFromLE = $2017da7f3b92fe8f$var$intFromLE;

});
parcelRegister("7iECc", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("bA0W1", function(module, exports) {
'use strict';
var $86e3c8252f82bd4d$var$utils = module.exports;
function $86e3c8252f82bd4d$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$86e3c8252f82bd4d$var$utils.toArray = $86e3c8252f82bd4d$var$toArray;
function $86e3c8252f82bd4d$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$86e3c8252f82bd4d$var$utils.zero2 = $86e3c8252f82bd4d$var$zero2;
function $86e3c8252f82bd4d$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $86e3c8252f82bd4d$var$zero2(msg[i].toString(16));
    return res;
}
$86e3c8252f82bd4d$var$utils.toHex = $86e3c8252f82bd4d$var$toHex;
$86e3c8252f82bd4d$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $86e3c8252f82bd4d$var$toHex(arr);
    else return arr;
};

});


parcelRegister("5Hkfi", function(module, exports) {
'use strict';
var $4260ac48d49db708$var$curve = module.exports;

$4260ac48d49db708$var$curve.base = (parcelRequire("8dytk"));

$4260ac48d49db708$var$curve.short = (parcelRequire("6gfS3"));

$4260ac48d49db708$var$curve.mont = (parcelRequire("cpeEK"));

$4260ac48d49db708$var$curve.edwards = (parcelRequire("1tM9R"));

});
parcelRegister("8dytk", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $5fba47135c9f13e6$var$getNAF = $2KPxf.getNAF;
var $5fba47135c9f13e6$var$getJSF = $2KPxf.getJSF;
var $5fba47135c9f13e6$var$assert = $2KPxf.assert;
function $5fba47135c9f13e6$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $7iECc(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $7iECc.red(conf.prime) : $7iECc.mont(this.p);
    // Useful for many curves
    this.zero = new $7iECc(0).toRed(this.red);
    this.one = new $7iECc(1).toRed(this.red);
    this.two = new $7iECc(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $7iECc(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $5fba47135c9f13e6$var$BaseCurve;
$5fba47135c9f13e6$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$5fba47135c9f13e6$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$5fba47135c9f13e6$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $5fba47135c9f13e6$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $5fba47135c9f13e6$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$5fba47135c9f13e6$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $5fba47135c9f13e6$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $5fba47135c9f13e6$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$5fba47135c9f13e6$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $5fba47135c9f13e6$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $5fba47135c9f13e6$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $5fba47135c9f13e6$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $5fba47135c9f13e6$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$5fba47135c9f13e6$var$BaseCurve.BasePoint = $5fba47135c9f13e6$var$BasePoint;
$5fba47135c9f13e6$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$5fba47135c9f13e6$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$5fba47135c9f13e6$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $2KPxf.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $5fba47135c9f13e6$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $5fba47135c9f13e6$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$5fba47135c9f13e6$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$5fba47135c9f13e6$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$5fba47135c9f13e6$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $2KPxf.encode(this._encode(compact), enc);
};
$5fba47135c9f13e6$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$5fba47135c9f13e6$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$5fba47135c9f13e6$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$5fba47135c9f13e6$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$5fba47135c9f13e6$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$5fba47135c9f13e6$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("6gfS3", function(module, exports) {
'use strict';

var $2KPxf = parcelRequire("2KPxf");

var $7iECc = parcelRequire("7iECc");

var $dhT4G = parcelRequire("dhT4G");

var $8dytk = parcelRequire("8dytk");
var $48f08c4e491a3d05$var$assert = $2KPxf.assert;
function $48f08c4e491a3d05$var$ShortCurve(conf) {
    $8dytk.call(this, 'short', conf);
    this.a = new $7iECc(conf.a, 16).toRed(this.red);
    this.b = new $7iECc(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dhT4G($48f08c4e491a3d05$var$ShortCurve, $8dytk);
module.exports = $48f08c4e491a3d05$var$ShortCurve;
$48f08c4e491a3d05$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $7iECc(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $7iECc(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $48f08c4e491a3d05$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $7iECc(vec.a, 16),
            b: new $7iECc(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$48f08c4e491a3d05$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $7iECc.mont(num);
    var tinv = new $7iECc(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $7iECc(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$48f08c4e491a3d05$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $7iECc(1);
    var y1 = new $7iECc(0);
    var x2 = new $7iECc(0);
    var y2 = new $7iECc(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$48f08c4e491a3d05$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$48f08c4e491a3d05$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7iECc(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$48f08c4e491a3d05$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$48f08c4e491a3d05$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $48f08c4e491a3d05$var$Point(curve, x, y, isRed) {
    $8dytk.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $7iECc(x, 16);
        this.y = new $7iECc(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dhT4G($48f08c4e491a3d05$var$Point, $8dytk.BasePoint);
$48f08c4e491a3d05$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $48f08c4e491a3d05$var$Point(this, x, y, isRed);
};
$48f08c4e491a3d05$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $48f08c4e491a3d05$var$Point.fromJSON(this, obj, red);
};
$48f08c4e491a3d05$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$48f08c4e491a3d05$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$48f08c4e491a3d05$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$48f08c4e491a3d05$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$48f08c4e491a3d05$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$48f08c4e491a3d05$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$48f08c4e491a3d05$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$48f08c4e491a3d05$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$48f08c4e491a3d05$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$48f08c4e491a3d05$var$Point.prototype.mul = function mul(k) {
    k = new $7iECc(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$48f08c4e491a3d05$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$48f08c4e491a3d05$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$48f08c4e491a3d05$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$48f08c4e491a3d05$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$48f08c4e491a3d05$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $48f08c4e491a3d05$var$JPoint(curve, x, y, z) {
    $8dytk.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $7iECc(0);
    } else {
        this.x = new $7iECc(x, 16);
        this.y = new $7iECc(y, 16);
        this.z = new $7iECc(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dhT4G($48f08c4e491a3d05$var$JPoint, $8dytk.BasePoint);
$48f08c4e491a3d05$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $48f08c4e491a3d05$var$JPoint(this, x, y, z);
};
$48f08c4e491a3d05$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$48f08c4e491a3d05$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$48f08c4e491a3d05$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$48f08c4e491a3d05$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$48f08c4e491a3d05$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$48f08c4e491a3d05$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $7iECc(k, kbase);
    return this.curve._wnafMul(this, k);
};
$48f08c4e491a3d05$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$48f08c4e491a3d05$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$48f08c4e491a3d05$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$48f08c4e491a3d05$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("cpeEK", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $dhT4G = parcelRequire("dhT4G");

var $8dytk = parcelRequire("8dytk");

var $2KPxf = parcelRequire("2KPxf");
function $90833044cafb30f7$var$MontCurve(conf) {
    $8dytk.call(this, 'mont', conf);
    this.a = new $7iECc(conf.a, 16).toRed(this.red);
    this.b = new $7iECc(conf.b, 16).toRed(this.red);
    this.i4 = new $7iECc(4).toRed(this.red).redInvm();
    this.two = new $7iECc(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dhT4G($90833044cafb30f7$var$MontCurve, $8dytk);
module.exports = $90833044cafb30f7$var$MontCurve;
$90833044cafb30f7$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $90833044cafb30f7$var$Point(curve, x, z) {
    $8dytk.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $7iECc(x, 16);
        this.z = new $7iECc(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dhT4G($90833044cafb30f7$var$Point, $8dytk.BasePoint);
$90833044cafb30f7$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($2KPxf.toArray(bytes, enc), 1);
};
$90833044cafb30f7$var$MontCurve.prototype.point = function point(x, z) {
    return new $90833044cafb30f7$var$Point(this, x, z);
};
$90833044cafb30f7$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $90833044cafb30f7$var$Point.fromJSON(this, obj);
};
$90833044cafb30f7$var$Point.prototype.precompute = function precompute() {
// No-op
};
$90833044cafb30f7$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$90833044cafb30f7$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $90833044cafb30f7$var$Point(curve, obj[0], obj[1] || curve.one);
};
$90833044cafb30f7$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$90833044cafb30f7$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$90833044cafb30f7$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$90833044cafb30f7$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$90833044cafb30f7$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$90833044cafb30f7$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$90833044cafb30f7$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$90833044cafb30f7$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$90833044cafb30f7$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$90833044cafb30f7$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$90833044cafb30f7$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("1tM9R", function(module, exports) {
'use strict';

var $2KPxf = parcelRequire("2KPxf");

var $7iECc = parcelRequire("7iECc");

var $dhT4G = parcelRequire("dhT4G");

var $8dytk = parcelRequire("8dytk");
var $113ddb0a953c55e8$var$assert = $2KPxf.assert;
function $113ddb0a953c55e8$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $8dytk.call(this, 'edwards', conf);
    this.a = new $7iECc(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $7iECc(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $7iECc(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $113ddb0a953c55e8$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dhT4G($113ddb0a953c55e8$var$EdwardsCurve, $8dytk);
module.exports = $113ddb0a953c55e8$var$EdwardsCurve;
$113ddb0a953c55e8$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$113ddb0a953c55e8$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $7iECc(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $7iECc(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $113ddb0a953c55e8$var$Point(curve, x, y, z, t) {
    $8dytk.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $7iECc(x, 16);
        this.y = new $7iECc(y, 16);
        this.z = z ? new $7iECc(z, 16) : this.curve.one;
        this.t = t && new $7iECc(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dhT4G($113ddb0a953c55e8$var$Point, $8dytk.BasePoint);
$113ddb0a953c55e8$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $113ddb0a953c55e8$var$Point.fromJSON(this, obj);
};
$113ddb0a953c55e8$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $113ddb0a953c55e8$var$Point(this, x, y, z, t);
};
$113ddb0a953c55e8$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $113ddb0a953c55e8$var$Point(curve, obj[0], obj[1], obj[2]);
};
$113ddb0a953c55e8$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$113ddb0a953c55e8$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$113ddb0a953c55e8$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$113ddb0a953c55e8$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$113ddb0a953c55e8$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$113ddb0a953c55e8$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$113ddb0a953c55e8$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$113ddb0a953c55e8$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$113ddb0a953c55e8$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$113ddb0a953c55e8$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$113ddb0a953c55e8$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$113ddb0a953c55e8$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$113ddb0a953c55e8$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$113ddb0a953c55e8$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$113ddb0a953c55e8$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$113ddb0a953c55e8$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$113ddb0a953c55e8$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$113ddb0a953c55e8$var$Point.prototype.toP = $113ddb0a953c55e8$var$Point.prototype.normalize;
$113ddb0a953c55e8$var$Point.prototype.mixedAdd = $113ddb0a953c55e8$var$Point.prototype.add;

});


parcelRegister("hKjoi", function(module, exports) {
'use strict';
var $ceb5c625f77262d6$var$curves = module.exports;

var $gVjbv = parcelRequire("gVjbv");

var $5Hkfi = parcelRequire("5Hkfi");

var $2KPxf = parcelRequire("2KPxf");
var $ceb5c625f77262d6$var$assert = $2KPxf.assert;
function $ceb5c625f77262d6$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $5Hkfi.short(options);
    else if (options.type === 'edwards') this.curve = new $5Hkfi.edwards(options);
    else this.curve = new $5Hkfi.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $ceb5c625f77262d6$var$assert(this.g.validate(), 'Invalid curve');
    $ceb5c625f77262d6$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$ceb5c625f77262d6$var$curves.PresetCurve = $ceb5c625f77262d6$var$PresetCurve;
function $ceb5c625f77262d6$var$defineCurve(name, options) {
    Object.defineProperty($ceb5c625f77262d6$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $ceb5c625f77262d6$var$PresetCurve(options);
            Object.defineProperty($ceb5c625f77262d6$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$ceb5c625f77262d6$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$ceb5c625f77262d6$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$ceb5c625f77262d6$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$ceb5c625f77262d6$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $gVjbv.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$ceb5c625f77262d6$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $gVjbv.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$ceb5c625f77262d6$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$ceb5c625f77262d6$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $gVjbv.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $ceb5c625f77262d6$var$pre;

try {
    $ceb5c625f77262d6$var$pre = (parcelRequire("8M60a"));
} catch (e) {
    $ceb5c625f77262d6$var$pre = undefined;
}
$ceb5c625f77262d6$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $gVjbv.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $ceb5c625f77262d6$var$pre
    ]
});

});
parcelRegister("gVjbv", function(module, exports) {
var $c520d9d9fb7ed821$var$hash = module.exports;

$c520d9d9fb7ed821$var$hash.utils = (parcelRequire("1JocC"));

$c520d9d9fb7ed821$var$hash.common = (parcelRequire("cx4L0"));

$c520d9d9fb7ed821$var$hash.sha = (parcelRequire("czP09"));

$c520d9d9fb7ed821$var$hash.ripemd = (parcelRequire("1KcMM"));

$c520d9d9fb7ed821$var$hash.hmac = (parcelRequire("iBkDX"));
// Proxy hash functions to the main object
$c520d9d9fb7ed821$var$hash.sha1 = $c520d9d9fb7ed821$var$hash.sha.sha1;
$c520d9d9fb7ed821$var$hash.sha256 = $c520d9d9fb7ed821$var$hash.sha.sha256;
$c520d9d9fb7ed821$var$hash.sha224 = $c520d9d9fb7ed821$var$hash.sha.sha224;
$c520d9d9fb7ed821$var$hash.sha384 = $c520d9d9fb7ed821$var$hash.sha.sha384;
$c520d9d9fb7ed821$var$hash.sha512 = $c520d9d9fb7ed821$var$hash.sha.sha512;
$c520d9d9fb7ed821$var$hash.ripemd160 = $c520d9d9fb7ed821$var$hash.ripemd.ripemd160;

});
parcelRegister("1JocC", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $142cc48ad6105c40$export$69f1b2dcda23c5f8; }, function (v) { return $142cc48ad6105c40$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $142cc48ad6105c40$export$45b10814cc054894; }, function (v) { return $142cc48ad6105c40$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $142cc48ad6105c40$export$7ea66e3774a60b67; }, function (v) { return $142cc48ad6105c40$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $142cc48ad6105c40$export$34a52f00f601f6f1; }, function (v) { return $142cc48ad6105c40$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $142cc48ad6105c40$export$812b0cbd5e8a72ab; }, function (v) { return $142cc48ad6105c40$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $142cc48ad6105c40$export$f24f9e11d63bb314; }, function (v) { return $142cc48ad6105c40$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $142cc48ad6105c40$export$b71357c7e07ca1f1; }, function (v) { return $142cc48ad6105c40$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $142cc48ad6105c40$export$2e58a4b541fdcbe8; }, function (v) { return $142cc48ad6105c40$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $142cc48ad6105c40$export$183b950bde9faab8; }, function (v) { return $142cc48ad6105c40$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $142cc48ad6105c40$export$4785c77169fea59e; }, function (v) { return $142cc48ad6105c40$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $142cc48ad6105c40$export$242a185dfcffac5b; }, function (v) { return $142cc48ad6105c40$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $142cc48ad6105c40$export$58c04ae0ae31877d; }, function (v) { return $142cc48ad6105c40$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $142cc48ad6105c40$export$d058ca695f8c6f11; }, function (v) { return $142cc48ad6105c40$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $142cc48ad6105c40$export$a1efd7fc3e986367; }, function (v) { return $142cc48ad6105c40$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $142cc48ad6105c40$export$bbfea4a2b5abaab4; }, function (v) { return $142cc48ad6105c40$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $142cc48ad6105c40$export$97ad4afc7de86152; }, function (v) { return $142cc48ad6105c40$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $142cc48ad6105c40$export$ce4673d9a79f6a4b; }, function (v) { return $142cc48ad6105c40$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $142cc48ad6105c40$export$786cc99fc6eedc0b; }, function (v) { return $142cc48ad6105c40$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $142cc48ad6105c40$export$45c59b9a1848dd0; }, function (v) { return $142cc48ad6105c40$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $142cc48ad6105c40$export$50d8f613e76d3034; }, function (v) { return $142cc48ad6105c40$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $142cc48ad6105c40$export$b8e83683c60ee162; }, function (v) { return $142cc48ad6105c40$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $142cc48ad6105c40$export$aeeb51790d1bcc4a; }, function (v) { return $142cc48ad6105c40$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $142cc48ad6105c40$export$bb7c616f719ad9c; }, function (v) { return $142cc48ad6105c40$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $142cc48ad6105c40$export$4d63290824f9d7df; }, function (v) { return $142cc48ad6105c40$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $142cc48ad6105c40$export$2f64ceb90ef28ea1; }, function (v) { return $142cc48ad6105c40$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $142cc48ad6105c40$export$8d2089d465f6d10d; }, function (v) { return $142cc48ad6105c40$export$8d2089d465f6d10d = v; });
var $142cc48ad6105c40$export$69f1b2dcda23c5f8;
var $142cc48ad6105c40$export$45b10814cc054894;
var $142cc48ad6105c40$export$7ea66e3774a60b67;
var $142cc48ad6105c40$export$34a52f00f601f6f1;
var $142cc48ad6105c40$export$812b0cbd5e8a72ab;
var $142cc48ad6105c40$export$f24f9e11d63bb314;
var $142cc48ad6105c40$export$b71357c7e07ca1f1;
var $142cc48ad6105c40$export$2e58a4b541fdcbe8;
var $142cc48ad6105c40$export$183b950bde9faab8;
var $142cc48ad6105c40$export$4785c77169fea59e;
var $142cc48ad6105c40$export$242a185dfcffac5b;
var $142cc48ad6105c40$export$58c04ae0ae31877d;
var $142cc48ad6105c40$export$d058ca695f8c6f11;
var $142cc48ad6105c40$export$a1efd7fc3e986367;
var $142cc48ad6105c40$export$bbfea4a2b5abaab4;
var $142cc48ad6105c40$export$97ad4afc7de86152;
var $142cc48ad6105c40$export$ce4673d9a79f6a4b;
var $142cc48ad6105c40$export$786cc99fc6eedc0b;
var $142cc48ad6105c40$export$45c59b9a1848dd0;
var $142cc48ad6105c40$export$50d8f613e76d3034;
var $142cc48ad6105c40$export$b8e83683c60ee162;
var $142cc48ad6105c40$export$aeeb51790d1bcc4a;
var $142cc48ad6105c40$export$bb7c616f719ad9c;
var $142cc48ad6105c40$export$4d63290824f9d7df;
var $142cc48ad6105c40$export$2f64ceb90ef28ea1;
var $142cc48ad6105c40$export$8d2089d465f6d10d;
'use strict';

var $jLTFB = parcelRequire("jLTFB");

var $dhT4G = parcelRequire("dhT4G");
$142cc48ad6105c40$export$69f1b2dcda23c5f8 = $dhT4G;
function $142cc48ad6105c40$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $142cc48ad6105c40$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($142cc48ad6105c40$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$142cc48ad6105c40$export$45b10814cc054894 = $142cc48ad6105c40$var$toArray;
function $142cc48ad6105c40$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $142cc48ad6105c40$var$zero2(msg[i].toString(16));
    return res;
}
$142cc48ad6105c40$export$7ea66e3774a60b67 = $142cc48ad6105c40$var$toHex;
function $142cc48ad6105c40$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$142cc48ad6105c40$export$34a52f00f601f6f1 = $142cc48ad6105c40$var$htonl;
function $142cc48ad6105c40$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $142cc48ad6105c40$var$htonl(w);
        res += $142cc48ad6105c40$var$zero8(w.toString(16));
    }
    return res;
}
$142cc48ad6105c40$export$812b0cbd5e8a72ab = $142cc48ad6105c40$var$toHex32;
function $142cc48ad6105c40$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$142cc48ad6105c40$export$f24f9e11d63bb314 = $142cc48ad6105c40$var$zero2;
function $142cc48ad6105c40$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$142cc48ad6105c40$export$b71357c7e07ca1f1 = $142cc48ad6105c40$var$zero8;
function $142cc48ad6105c40$var$join32(msg, start, end, endian) {
    var len = end - start;
    $jLTFB(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$142cc48ad6105c40$export$2e58a4b541fdcbe8 = $142cc48ad6105c40$var$join32;
function $142cc48ad6105c40$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$142cc48ad6105c40$export$183b950bde9faab8 = $142cc48ad6105c40$var$split32;
function $142cc48ad6105c40$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$142cc48ad6105c40$export$4785c77169fea59e = $142cc48ad6105c40$var$rotr32;
function $142cc48ad6105c40$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$142cc48ad6105c40$export$242a185dfcffac5b = $142cc48ad6105c40$var$rotl32;
function $142cc48ad6105c40$var$sum32(a, b) {
    return a + b >>> 0;
}
$142cc48ad6105c40$export$58c04ae0ae31877d = $142cc48ad6105c40$var$sum32;
function $142cc48ad6105c40$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$142cc48ad6105c40$export$d058ca695f8c6f11 = $142cc48ad6105c40$var$sum32_3;
function $142cc48ad6105c40$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$142cc48ad6105c40$export$a1efd7fc3e986367 = $142cc48ad6105c40$var$sum32_4;
function $142cc48ad6105c40$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$142cc48ad6105c40$export$bbfea4a2b5abaab4 = $142cc48ad6105c40$var$sum32_5;
function $142cc48ad6105c40$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$142cc48ad6105c40$export$97ad4afc7de86152 = $142cc48ad6105c40$var$sum64;
function $142cc48ad6105c40$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$142cc48ad6105c40$export$ce4673d9a79f6a4b = $142cc48ad6105c40$var$sum64_hi;
function $142cc48ad6105c40$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$142cc48ad6105c40$export$786cc99fc6eedc0b = $142cc48ad6105c40$var$sum64_lo;
function $142cc48ad6105c40$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$142cc48ad6105c40$export$45c59b9a1848dd0 = $142cc48ad6105c40$var$sum64_4_hi;
function $142cc48ad6105c40$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$142cc48ad6105c40$export$50d8f613e76d3034 = $142cc48ad6105c40$var$sum64_4_lo;
function $142cc48ad6105c40$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$142cc48ad6105c40$export$b8e83683c60ee162 = $142cc48ad6105c40$var$sum64_5_hi;
function $142cc48ad6105c40$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$142cc48ad6105c40$export$aeeb51790d1bcc4a = $142cc48ad6105c40$var$sum64_5_lo;
function $142cc48ad6105c40$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$142cc48ad6105c40$export$bb7c616f719ad9c = $142cc48ad6105c40$var$rotr64_hi;
function $142cc48ad6105c40$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$142cc48ad6105c40$export$4d63290824f9d7df = $142cc48ad6105c40$var$rotr64_lo;
function $142cc48ad6105c40$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$142cc48ad6105c40$export$2f64ceb90ef28ea1 = $142cc48ad6105c40$var$shr64_hi;
function $142cc48ad6105c40$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$142cc48ad6105c40$export$8d2089d465f6d10d = $142cc48ad6105c40$var$shr64_lo;

});

parcelRegister("cx4L0", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $91fc41c6f399bfd6$export$8687658379b577e6; }, function (v) { return $91fc41c6f399bfd6$export$8687658379b577e6 = v; });
var $91fc41c6f399bfd6$export$8687658379b577e6;
'use strict';

var $1JocC = parcelRequire("1JocC");

var $jLTFB = parcelRequire("jLTFB");
function $91fc41c6f399bfd6$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$91fc41c6f399bfd6$export$8687658379b577e6 = $91fc41c6f399bfd6$var$BlockHash;
$91fc41c6f399bfd6$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $1JocC.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $1JocC.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$91fc41c6f399bfd6$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $jLTFB(this.pending === null);
    return this._digest(enc);
};
$91fc41c6f399bfd6$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("czP09", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $928050bd9f998c99$export$5091bdda49ba90f5; }, function (v) { return $928050bd9f998c99$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $928050bd9f998c99$export$97b70509d4e397ea; }, function (v) { return $928050bd9f998c99$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $928050bd9f998c99$export$bced8d2aada2d1c9; }, function (v) { return $928050bd9f998c99$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $928050bd9f998c99$export$612d47d55dedde45; }, function (v) { return $928050bd9f998c99$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $928050bd9f998c99$export$a888d2532e6dc7bb; }, function (v) { return $928050bd9f998c99$export$a888d2532e6dc7bb = v; });
var $928050bd9f998c99$export$5091bdda49ba90f5;
var $928050bd9f998c99$export$97b70509d4e397ea;
var $928050bd9f998c99$export$bced8d2aada2d1c9;
var $928050bd9f998c99$export$612d47d55dedde45;
var $928050bd9f998c99$export$a888d2532e6dc7bb;
'use strict';

$928050bd9f998c99$export$5091bdda49ba90f5 = (parcelRequire("7jFEf"));

$928050bd9f998c99$export$97b70509d4e397ea = (parcelRequire("aE1Pb"));

$928050bd9f998c99$export$bced8d2aada2d1c9 = (parcelRequire("6lk1c"));

$928050bd9f998c99$export$612d47d55dedde45 = (parcelRequire("tUPWi"));

$928050bd9f998c99$export$a888d2532e6dc7bb = (parcelRequire("joihk"));

});
parcelRegister("7jFEf", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");

var $aoikt = parcelRequire("aoikt");
var $553a9d345907d8a6$var$rotl32 = $1JocC.rotl32;
var $553a9d345907d8a6$var$sum32 = $1JocC.sum32;
var $553a9d345907d8a6$var$sum32_5 = $1JocC.sum32_5;
var $553a9d345907d8a6$var$ft_1 = $aoikt.ft_1;
var $553a9d345907d8a6$var$BlockHash = $cx4L0.BlockHash;
var $553a9d345907d8a6$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $553a9d345907d8a6$var$SHA1() {
    if (!(this instanceof $553a9d345907d8a6$var$SHA1)) return new $553a9d345907d8a6$var$SHA1();
    $553a9d345907d8a6$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$1JocC.inherits($553a9d345907d8a6$var$SHA1, $553a9d345907d8a6$var$BlockHash);
module.exports = $553a9d345907d8a6$var$SHA1;
$553a9d345907d8a6$var$SHA1.blockSize = 512;
$553a9d345907d8a6$var$SHA1.outSize = 160;
$553a9d345907d8a6$var$SHA1.hmacStrength = 80;
$553a9d345907d8a6$var$SHA1.padLength = 64;
$553a9d345907d8a6$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $553a9d345907d8a6$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $553a9d345907d8a6$var$sum32_5($553a9d345907d8a6$var$rotl32(a, 5), $553a9d345907d8a6$var$ft_1(s, b, c, d), e, W[i], $553a9d345907d8a6$var$sha1_K[s]);
        e = d;
        d = c;
        c = $553a9d345907d8a6$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $553a9d345907d8a6$var$sum32(this.h[0], a);
    this.h[1] = $553a9d345907d8a6$var$sum32(this.h[1], b);
    this.h[2] = $553a9d345907d8a6$var$sum32(this.h[2], c);
    this.h[3] = $553a9d345907d8a6$var$sum32(this.h[3], d);
    this.h[4] = $553a9d345907d8a6$var$sum32(this.h[4], e);
};
$553a9d345907d8a6$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'big');
    else return $1JocC.split32(this.h, 'big');
};

});
parcelRegister("aoikt", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $790a5d18b6572c07$export$5a92649d7ddb9f63; }, function (v) { return $790a5d18b6572c07$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $790a5d18b6572c07$export$c6d0d020c3a6269; }, function (v) { return $790a5d18b6572c07$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $790a5d18b6572c07$export$eb90c27fca05f956; }, function (v) { return $790a5d18b6572c07$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $790a5d18b6572c07$export$14a4a98e063b1999; }, function (v) { return $790a5d18b6572c07$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $790a5d18b6572c07$export$d20cecfa1564c686; }, function (v) { return $790a5d18b6572c07$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $790a5d18b6572c07$export$44fd472a12fc6db; }, function (v) { return $790a5d18b6572c07$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $790a5d18b6572c07$export$1ed238bb6ea1dd47; }, function (v) { return $790a5d18b6572c07$export$1ed238bb6ea1dd47 = v; });
var $790a5d18b6572c07$export$5a92649d7ddb9f63;
var $790a5d18b6572c07$export$c6d0d020c3a6269;
var $790a5d18b6572c07$export$eb90c27fca05f956;
var $790a5d18b6572c07$export$cc992891a14496a1;
var $790a5d18b6572c07$export$14a4a98e063b1999;
var $790a5d18b6572c07$export$d20cecfa1564c686;
var $790a5d18b6572c07$export$44fd472a12fc6db;
var $790a5d18b6572c07$export$1ed238bb6ea1dd47;
'use strict';

var $1JocC = parcelRequire("1JocC");
var $790a5d18b6572c07$var$rotr32 = $1JocC.rotr32;
function $790a5d18b6572c07$var$ft_1(s, x, y, z) {
    if (s === 0) return $790a5d18b6572c07$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $790a5d18b6572c07$var$p32(x, y, z);
    if (s === 2) return $790a5d18b6572c07$var$maj32(x, y, z);
}
$790a5d18b6572c07$export$5a92649d7ddb9f63 = $790a5d18b6572c07$var$ft_1;
function $790a5d18b6572c07$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$790a5d18b6572c07$export$c6d0d020c3a6269 = $790a5d18b6572c07$var$ch32;
function $790a5d18b6572c07$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$790a5d18b6572c07$export$eb90c27fca05f956 = $790a5d18b6572c07$var$maj32;
function $790a5d18b6572c07$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$790a5d18b6572c07$export$cc992891a14496a1 = $790a5d18b6572c07$var$p32;
function $790a5d18b6572c07$var$s0_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 2) ^ $790a5d18b6572c07$var$rotr32(x, 13) ^ $790a5d18b6572c07$var$rotr32(x, 22);
}
$790a5d18b6572c07$export$14a4a98e063b1999 = $790a5d18b6572c07$var$s0_256;
function $790a5d18b6572c07$var$s1_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 6) ^ $790a5d18b6572c07$var$rotr32(x, 11) ^ $790a5d18b6572c07$var$rotr32(x, 25);
}
$790a5d18b6572c07$export$d20cecfa1564c686 = $790a5d18b6572c07$var$s1_256;
function $790a5d18b6572c07$var$g0_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 7) ^ $790a5d18b6572c07$var$rotr32(x, 18) ^ x >>> 3;
}
$790a5d18b6572c07$export$44fd472a12fc6db = $790a5d18b6572c07$var$g0_256;
function $790a5d18b6572c07$var$g1_256(x) {
    return $790a5d18b6572c07$var$rotr32(x, 17) ^ $790a5d18b6572c07$var$rotr32(x, 19) ^ x >>> 10;
}
$790a5d18b6572c07$export$1ed238bb6ea1dd47 = $790a5d18b6572c07$var$g1_256;

});


parcelRegister("aE1Pb", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $6lk1c = parcelRequire("6lk1c");
function $7bff0e1ea26927f0$var$SHA224() {
    if (!(this instanceof $7bff0e1ea26927f0$var$SHA224)) return new $7bff0e1ea26927f0$var$SHA224();
    $6lk1c.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$1JocC.inherits($7bff0e1ea26927f0$var$SHA224, $6lk1c);
module.exports = $7bff0e1ea26927f0$var$SHA224;
$7bff0e1ea26927f0$var$SHA224.blockSize = 512;
$7bff0e1ea26927f0$var$SHA224.outSize = 224;
$7bff0e1ea26927f0$var$SHA224.hmacStrength = 192;
$7bff0e1ea26927f0$var$SHA224.padLength = 64;
$7bff0e1ea26927f0$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $1JocC.toHex32(this.h.slice(0, 7), 'big');
    else return $1JocC.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("6lk1c", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");

var $aoikt = parcelRequire("aoikt");

var $jLTFB = parcelRequire("jLTFB");
var $49e43b734242bc05$var$sum32 = $1JocC.sum32;
var $49e43b734242bc05$var$sum32_4 = $1JocC.sum32_4;
var $49e43b734242bc05$var$sum32_5 = $1JocC.sum32_5;
var $49e43b734242bc05$var$ch32 = $aoikt.ch32;
var $49e43b734242bc05$var$maj32 = $aoikt.maj32;
var $49e43b734242bc05$var$s0_256 = $aoikt.s0_256;
var $49e43b734242bc05$var$s1_256 = $aoikt.s1_256;
var $49e43b734242bc05$var$g0_256 = $aoikt.g0_256;
var $49e43b734242bc05$var$g1_256 = $aoikt.g1_256;
var $49e43b734242bc05$var$BlockHash = $cx4L0.BlockHash;
var $49e43b734242bc05$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $49e43b734242bc05$var$SHA256() {
    if (!(this instanceof $49e43b734242bc05$var$SHA256)) return new $49e43b734242bc05$var$SHA256();
    $49e43b734242bc05$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $49e43b734242bc05$var$sha256_K;
    this.W = new Array(64);
}
$1JocC.inherits($49e43b734242bc05$var$SHA256, $49e43b734242bc05$var$BlockHash);
module.exports = $49e43b734242bc05$var$SHA256;
$49e43b734242bc05$var$SHA256.blockSize = 512;
$49e43b734242bc05$var$SHA256.outSize = 256;
$49e43b734242bc05$var$SHA256.hmacStrength = 192;
$49e43b734242bc05$var$SHA256.padLength = 64;
$49e43b734242bc05$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $49e43b734242bc05$var$sum32_4($49e43b734242bc05$var$g1_256(W[i - 2]), W[i - 7], $49e43b734242bc05$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $jLTFB(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $49e43b734242bc05$var$sum32_5(h, $49e43b734242bc05$var$s1_256(e), $49e43b734242bc05$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $49e43b734242bc05$var$sum32($49e43b734242bc05$var$s0_256(a), $49e43b734242bc05$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $49e43b734242bc05$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $49e43b734242bc05$var$sum32(T1, T2);
    }
    this.h[0] = $49e43b734242bc05$var$sum32(this.h[0], a);
    this.h[1] = $49e43b734242bc05$var$sum32(this.h[1], b);
    this.h[2] = $49e43b734242bc05$var$sum32(this.h[2], c);
    this.h[3] = $49e43b734242bc05$var$sum32(this.h[3], d);
    this.h[4] = $49e43b734242bc05$var$sum32(this.h[4], e);
    this.h[5] = $49e43b734242bc05$var$sum32(this.h[5], f);
    this.h[6] = $49e43b734242bc05$var$sum32(this.h[6], g);
    this.h[7] = $49e43b734242bc05$var$sum32(this.h[7], h);
};
$49e43b734242bc05$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'big');
    else return $1JocC.split32(this.h, 'big');
};

});


parcelRegister("tUPWi", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $joihk = parcelRequire("joihk");
function $059ecc239a13035c$var$SHA384() {
    if (!(this instanceof $059ecc239a13035c$var$SHA384)) return new $059ecc239a13035c$var$SHA384();
    $joihk.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$1JocC.inherits($059ecc239a13035c$var$SHA384, $joihk);
module.exports = $059ecc239a13035c$var$SHA384;
$059ecc239a13035c$var$SHA384.blockSize = 1024;
$059ecc239a13035c$var$SHA384.outSize = 384;
$059ecc239a13035c$var$SHA384.hmacStrength = 192;
$059ecc239a13035c$var$SHA384.padLength = 128;
$059ecc239a13035c$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h.slice(0, 12), 'big');
    else return $1JocC.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("joihk", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");

var $jLTFB = parcelRequire("jLTFB");
var $e1de6ff53e4a4c3f$var$rotr64_hi = $1JocC.rotr64_hi;
var $e1de6ff53e4a4c3f$var$rotr64_lo = $1JocC.rotr64_lo;
var $e1de6ff53e4a4c3f$var$shr64_hi = $1JocC.shr64_hi;
var $e1de6ff53e4a4c3f$var$shr64_lo = $1JocC.shr64_lo;
var $e1de6ff53e4a4c3f$var$sum64 = $1JocC.sum64;
var $e1de6ff53e4a4c3f$var$sum64_hi = $1JocC.sum64_hi;
var $e1de6ff53e4a4c3f$var$sum64_lo = $1JocC.sum64_lo;
var $e1de6ff53e4a4c3f$var$sum64_4_hi = $1JocC.sum64_4_hi;
var $e1de6ff53e4a4c3f$var$sum64_4_lo = $1JocC.sum64_4_lo;
var $e1de6ff53e4a4c3f$var$sum64_5_hi = $1JocC.sum64_5_hi;
var $e1de6ff53e4a4c3f$var$sum64_5_lo = $1JocC.sum64_5_lo;
var $e1de6ff53e4a4c3f$var$BlockHash = $cx4L0.BlockHash;
var $e1de6ff53e4a4c3f$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $e1de6ff53e4a4c3f$var$SHA512() {
    if (!(this instanceof $e1de6ff53e4a4c3f$var$SHA512)) return new $e1de6ff53e4a4c3f$var$SHA512();
    $e1de6ff53e4a4c3f$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $e1de6ff53e4a4c3f$var$sha512_K;
    this.W = new Array(160);
}
$1JocC.inherits($e1de6ff53e4a4c3f$var$SHA512, $e1de6ff53e4a4c3f$var$BlockHash);
module.exports = $e1de6ff53e4a4c3f$var$SHA512;
$e1de6ff53e4a4c3f$var$SHA512.blockSize = 1024;
$e1de6ff53e4a4c3f$var$SHA512.outSize = 512;
$e1de6ff53e4a4c3f$var$SHA512.hmacStrength = 192;
$e1de6ff53e4a4c3f$var$SHA512.padLength = 128;
$e1de6ff53e4a4c3f$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $e1de6ff53e4a4c3f$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $e1de6ff53e4a4c3f$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $e1de6ff53e4a4c3f$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $e1de6ff53e4a4c3f$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $e1de6ff53e4a4c3f$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $e1de6ff53e4a4c3f$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$e1de6ff53e4a4c3f$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $jLTFB(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $e1de6ff53e4a4c3f$var$s1_512_hi(eh, el);
        var c1_lo = $e1de6ff53e4a4c3f$var$s1_512_lo(eh, el);
        var c2_hi = $e1de6ff53e4a4c3f$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $e1de6ff53e4a4c3f$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $e1de6ff53e4a4c3f$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $e1de6ff53e4a4c3f$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $e1de6ff53e4a4c3f$var$s0_512_hi(ah, al);
        c0_lo = $e1de6ff53e4a4c3f$var$s0_512_lo(ah, al);
        c1_hi = $e1de6ff53e4a4c3f$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $e1de6ff53e4a4c3f$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $e1de6ff53e4a4c3f$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $e1de6ff53e4a4c3f$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $e1de6ff53e4a4c3f$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $e1de6ff53e4a4c3f$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $e1de6ff53e4a4c3f$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $e1de6ff53e4a4c3f$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $e1de6ff53e4a4c3f$var$sum64(this.h, 0, ah, al);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 2, bh, bl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 4, ch, cl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 6, dh, dl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 8, eh, el);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 10, fh, fl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 12, gh, gl);
    $e1de6ff53e4a4c3f$var$sum64(this.h, 14, hh, hl);
};
$e1de6ff53e4a4c3f$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'big');
    else return $1JocC.split32(this.h, 'big');
};
function $e1de6ff53e4a4c3f$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s0_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s0_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s1_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$s1_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g0_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $e1de6ff53e4a4c3f$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g0_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $e1de6ff53e4a4c3f$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g1_512_hi(xh, xl) {
    var c0_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $e1de6ff53e4a4c3f$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $e1de6ff53e4a4c3f$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $e1de6ff53e4a4c3f$var$g1_512_lo(xh, xl) {
    var c0_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $e1de6ff53e4a4c3f$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $e1de6ff53e4a4c3f$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("1KcMM", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $14540152db666e38$export$d1cea0ee4e3f0d3e; }, function (v) { return $14540152db666e38$export$d1cea0ee4e3f0d3e = v; });
var $14540152db666e38$export$d1cea0ee4e3f0d3e;
'use strict';

var $1JocC = parcelRequire("1JocC");

var $cx4L0 = parcelRequire("cx4L0");
var $14540152db666e38$var$rotl32 = $1JocC.rotl32;
var $14540152db666e38$var$sum32 = $1JocC.sum32;
var $14540152db666e38$var$sum32_3 = $1JocC.sum32_3;
var $14540152db666e38$var$sum32_4 = $1JocC.sum32_4;
var $14540152db666e38$var$BlockHash = $cx4L0.BlockHash;
function $14540152db666e38$var$RIPEMD160() {
    if (!(this instanceof $14540152db666e38$var$RIPEMD160)) return new $14540152db666e38$var$RIPEMD160();
    $14540152db666e38$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$1JocC.inherits($14540152db666e38$var$RIPEMD160, $14540152db666e38$var$BlockHash);
$14540152db666e38$export$d1cea0ee4e3f0d3e = $14540152db666e38$var$RIPEMD160;
$14540152db666e38$var$RIPEMD160.blockSize = 512;
$14540152db666e38$var$RIPEMD160.outSize = 160;
$14540152db666e38$var$RIPEMD160.hmacStrength = 192;
$14540152db666e38$var$RIPEMD160.padLength = 64;
$14540152db666e38$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $14540152db666e38$var$sum32($14540152db666e38$var$rotl32($14540152db666e38$var$sum32_4(A, $14540152db666e38$var$f(j, B, C, D), msg[$14540152db666e38$var$r[j] + start], $14540152db666e38$var$K(j)), $14540152db666e38$var$s[j]), E);
        A = E;
        E = D;
        D = $14540152db666e38$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $14540152db666e38$var$sum32($14540152db666e38$var$rotl32($14540152db666e38$var$sum32_4(Ah, $14540152db666e38$var$f(79 - j, Bh, Ch, Dh), msg[$14540152db666e38$var$rh[j] + start], $14540152db666e38$var$Kh(j)), $14540152db666e38$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $14540152db666e38$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $14540152db666e38$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $14540152db666e38$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $14540152db666e38$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $14540152db666e38$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $14540152db666e38$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$14540152db666e38$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $1JocC.toHex32(this.h, 'little');
    else return $1JocC.split32(this.h, 'little');
};
function $14540152db666e38$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $14540152db666e38$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $14540152db666e38$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $14540152db666e38$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $14540152db666e38$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $14540152db666e38$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $14540152db666e38$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("iBkDX", function(module, exports) {
'use strict';

var $1JocC = parcelRequire("1JocC");

var $jLTFB = parcelRequire("jLTFB");
function $d8abb2129232a5b9$var$Hmac(hash, key, enc) {
    if (!(this instanceof $d8abb2129232a5b9$var$Hmac)) return new $d8abb2129232a5b9$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($1JocC.toArray(key, enc));
}
module.exports = $d8abb2129232a5b9$var$Hmac;
$d8abb2129232a5b9$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $jLTFB(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$d8abb2129232a5b9$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$d8abb2129232a5b9$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("8M60a", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("ijEQd", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $aZYpB = parcelRequire("aZYpB");

var $2KPxf = parcelRequire("2KPxf");

var $hKjoi = parcelRequire("hKjoi");

var $gWiKw = parcelRequire("gWiKw");
var $d559ae8cfe0978b7$var$assert = $2KPxf.assert;

var $6PbNu = parcelRequire("6PbNu");

var $3Q3Ml = parcelRequire("3Q3Ml");
function $d559ae8cfe0978b7$var$EC(options) {
    if (!(this instanceof $d559ae8cfe0978b7$var$EC)) return new $d559ae8cfe0978b7$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $d559ae8cfe0978b7$var$assert(Object.prototype.hasOwnProperty.call($hKjoi, options), 'Unknown curve ' + options);
        options = $hKjoi[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $hKjoi.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $d559ae8cfe0978b7$var$EC;
$d559ae8cfe0978b7$var$EC.prototype.keyPair = function keyPair(options) {
    return new $6PbNu(this, options);
};
$d559ae8cfe0978b7$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $6PbNu.fromPrivate(this, priv, enc);
};
$d559ae8cfe0978b7$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $6PbNu.fromPublic(this, pub, enc);
};
$d559ae8cfe0978b7$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $aZYpB({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $gWiKw(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $7iECc(2));
    for(;;){
        var priv = new $7iECc(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$d559ae8cfe0978b7$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($7iECc.isBN(msg) || typeof msg === 'number') {
        msg = new $7iECc(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $7iECc(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $7iECc(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$d559ae8cfe0978b7$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$7iECc.isBN(msg)) {
        $d559ae8cfe0978b7$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $d559ae8cfe0978b7$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$d559ae8cfe0978b7$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $d559ae8cfe0978b7$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $d559ae8cfe0978b7$var$assert(new $7iECc(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $aZYpB({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $7iECc(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $7iECc(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $3Q3Ml({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$d559ae8cfe0978b7$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $3Q3Ml(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$d559ae8cfe0978b7$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $d559ae8cfe0978b7$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $3Q3Ml(signature, enc);
    var n = this.n;
    var e = new $7iECc(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$d559ae8cfe0978b7$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $3Q3Ml(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("aZYpB", function(module, exports) {
'use strict';

var $gVjbv = parcelRequire("gVjbv");

var $bA0W1 = parcelRequire("bA0W1");

var $jLTFB = parcelRequire("jLTFB");
function $801e766dffc0af0b$var$HmacDRBG(options) {
    if (!(this instanceof $801e766dffc0af0b$var$HmacDRBG)) return new $801e766dffc0af0b$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $bA0W1.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $bA0W1.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $bA0W1.toArray(options.pers, options.persEnc || 'hex');
    $jLTFB(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $801e766dffc0af0b$var$HmacDRBG;
$801e766dffc0af0b$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$801e766dffc0af0b$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $gVjbv.hmac(this.hash, this.K);
};
$801e766dffc0af0b$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$801e766dffc0af0b$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $bA0W1.toArray(entropy, entropyEnc);
    add = $bA0W1.toArray(add, addEnc);
    $jLTFB(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$801e766dffc0af0b$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $bA0W1.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $bA0W1.encode(res, enc);
};

});

parcelRegister("6PbNu", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $4f80a828047f5860$var$assert = $2KPxf.assert;
function $4f80a828047f5860$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $4f80a828047f5860$var$KeyPair;
$4f80a828047f5860$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $4f80a828047f5860$var$KeyPair) return pub;
    return new $4f80a828047f5860$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$4f80a828047f5860$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $4f80a828047f5860$var$KeyPair) return priv;
    return new $4f80a828047f5860$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$4f80a828047f5860$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$4f80a828047f5860$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$4f80a828047f5860$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$4f80a828047f5860$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $7iECc(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$4f80a828047f5860$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $4f80a828047f5860$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $4f80a828047f5860$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$4f80a828047f5860$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $4f80a828047f5860$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$4f80a828047f5860$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$4f80a828047f5860$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$4f80a828047f5860$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("3Q3Ml", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $2cb928d2a10fb271$var$assert = $2KPxf.assert;
function $2cb928d2a10fb271$var$Signature(options, enc) {
    if (options instanceof $2cb928d2a10fb271$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $2cb928d2a10fb271$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $7iECc(options.r, 16);
    this.s = new $7iECc(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $2cb928d2a10fb271$var$Signature;
function $2cb928d2a10fb271$var$Position() {
    this.place = 0;
}
function $2cb928d2a10fb271$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $2cb928d2a10fb271$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$2cb928d2a10fb271$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $2KPxf.toArray(data, enc);
    var p = new $2cb928d2a10fb271$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $2cb928d2a10fb271$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $2cb928d2a10fb271$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $2cb928d2a10fb271$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $7iECc(r);
    this.s = new $7iECc(s);
    this.recoveryParam = null;
    return true;
};
function $2cb928d2a10fb271$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$2cb928d2a10fb271$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $2cb928d2a10fb271$var$rmPadding(r);
    s = $2cb928d2a10fb271$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $2cb928d2a10fb271$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $2cb928d2a10fb271$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $2cb928d2a10fb271$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $2KPxf.encode(res, enc);
};

});


parcelRegister("9fmHx", function(module, exports) {
'use strict';

var $gVjbv = parcelRequire("gVjbv");

var $hKjoi = parcelRequire("hKjoi");

var $2KPxf = parcelRequire("2KPxf");
var $6bb71fc30329a406$var$assert = $2KPxf.assert;
var $6bb71fc30329a406$var$parseBytes = $2KPxf.parseBytes;

var $FCwLh = parcelRequire("FCwLh");

var $gKHZ3 = parcelRequire("gKHZ3");
function $6bb71fc30329a406$var$EDDSA(curve) {
    $6bb71fc30329a406$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $6bb71fc30329a406$var$EDDSA)) return new $6bb71fc30329a406$var$EDDSA(curve);
    curve = $hKjoi[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $gVjbv.sha512;
}
module.exports = $6bb71fc30329a406$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $6bb71fc30329a406$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $6bb71fc30329a406$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $6bb71fc30329a406$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $6bb71fc30329a406$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$6bb71fc30329a406$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $2KPxf.intFromLE(hash.digest()).umod(this.curve.n);
};
$6bb71fc30329a406$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $FCwLh.fromPublic(this, pub);
};
$6bb71fc30329a406$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $FCwLh.fromSecret(this, secret);
};
$6bb71fc30329a406$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $gKHZ3) return sig;
    return new $gKHZ3(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $6bb71fc30329a406$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$6bb71fc30329a406$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $2KPxf.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $2KPxf.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$6bb71fc30329a406$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$6bb71fc30329a406$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $2KPxf.intFromLE(bytes);
};
$6bb71fc30329a406$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("FCwLh", function(module, exports) {
'use strict';

var $2KPxf = parcelRequire("2KPxf");
var $07d1b731153c430e$var$assert = $2KPxf.assert;
var $07d1b731153c430e$var$parseBytes = $2KPxf.parseBytes;
var $07d1b731153c430e$var$cachedProperty = $2KPxf.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $07d1b731153c430e$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $07d1b731153c430e$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $07d1b731153c430e$var$parseBytes(params.pub);
}
$07d1b731153c430e$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $07d1b731153c430e$var$KeyPair) return pub;
    return new $07d1b731153c430e$var$KeyPair(eddsa, {
        pub: pub
    });
};
$07d1b731153c430e$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $07d1b731153c430e$var$KeyPair) return secret;
    return new $07d1b731153c430e$var$KeyPair(eddsa, {
        secret: secret
    });
};
$07d1b731153c430e$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$07d1b731153c430e$var$cachedProperty($07d1b731153c430e$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$07d1b731153c430e$var$KeyPair.prototype.sign = function sign(message) {
    $07d1b731153c430e$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$07d1b731153c430e$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$07d1b731153c430e$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $07d1b731153c430e$var$assert(this._secret, 'KeyPair is public only');
    return $2KPxf.encode(this.secret(), enc);
};
$07d1b731153c430e$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $2KPxf.encode(this.pubBytes(), enc);
};
module.exports = $07d1b731153c430e$var$KeyPair;

});

parcelRegister("gKHZ3", function(module, exports) {
'use strict';

var $7iECc = parcelRequire("7iECc");

var $2KPxf = parcelRequire("2KPxf");
var $c3230f7d16d20b95$var$assert = $2KPxf.assert;
var $c3230f7d16d20b95$var$cachedProperty = $2KPxf.cachedProperty;
var $c3230f7d16d20b95$var$parseBytes = $2KPxf.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $c3230f7d16d20b95$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $c3230f7d16d20b95$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $c3230f7d16d20b95$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $c3230f7d16d20b95$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $7iECc) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$c3230f7d16d20b95$var$cachedProperty($c3230f7d16d20b95$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$c3230f7d16d20b95$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$c3230f7d16d20b95$var$Signature.prototype.toHex = function toHex() {
    return $2KPxf.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $c3230f7d16d20b95$var$Signature;

});



parcelRegister("hdVtR", function(module, exports) {
'use strict';

var $1mcce = parcelRequire("1mcce");

var $7sB41 = parcelRequire("7sB41");

var $afsnk = parcelRequire("afsnk");

var $jGDtA = parcelRequire("jGDtA");

var $d0xYH = parcelRequire("d0xYH");
var $c8a03d08adb7e240$require$pbkdf2Sync = $d0xYH.pbkdf2Sync;

var $838j1 = parcelRequire("838j1");
var $c8a03d08adb7e240$require$Buffer = $838j1.Buffer;
function $c8a03d08adb7e240$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $7sB41[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $c8a03d08adb7e240$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $jGDtA.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $c8a03d08adb7e240$require$Buffer.concat(out);
}
function $c8a03d08adb7e240$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$c8a03d08adb7e240$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $c8a03d08adb7e240$require$Buffer.from(buffer);
    var stripped = $afsnk(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $1mcce.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $1mcce.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $1mcce.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $1mcce.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $1mcce.EncryptedPrivateKey.decode(data, 'der');
            data = $c8a03d08adb7e240$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $1mcce.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $1mcce.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $1mcce.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $1mcce.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $1mcce.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $1mcce.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $1mcce.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $1mcce.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$c8a03d08adb7e240$var$parseKeys.signature = $1mcce.signature;
module.exports = $c8a03d08adb7e240$var$parseKeys;

});
parcelRegister("1mcce", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $0fd14e73698eb927$export$c98397a6eb8d0678; }, function (v) { return $0fd14e73698eb927$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $0fd14e73698eb927$export$f4aab6816f64fa6b; }, function (v) { return $0fd14e73698eb927$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $0fd14e73698eb927$export$4471f5c65d097c11; }, function (v) { return $0fd14e73698eb927$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $0fd14e73698eb927$export$ca8b6604d6ce14de; }, function (v) { return $0fd14e73698eb927$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $0fd14e73698eb927$export$8f54525b330fd87b; }, function (v) { return $0fd14e73698eb927$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $0fd14e73698eb927$export$23cd2842b44ca3e7; }, function (v) { return $0fd14e73698eb927$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $0fd14e73698eb927$export$245c9aaa9f5ce4ce; }, function (v) { return $0fd14e73698eb927$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $0fd14e73698eb927$export$8ad762e3e6399afe; }, function (v) { return $0fd14e73698eb927$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $0fd14e73698eb927$export$32ef6f92e22c6ab0; }, function (v) { return $0fd14e73698eb927$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $0fd14e73698eb927$export$c9cd164b539ebb63; }, function (v) { return $0fd14e73698eb927$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $0fd14e73698eb927$export$c98397a6eb8d0678;
var $0fd14e73698eb927$export$f4aab6816f64fa6b;
var $0fd14e73698eb927$export$4471f5c65d097c11;
var $0fd14e73698eb927$export$ca8b6604d6ce14de;
var $0fd14e73698eb927$export$8f54525b330fd87b;
var $0fd14e73698eb927$export$23cd2842b44ca3e7;
var $0fd14e73698eb927$export$245c9aaa9f5ce4ce;
var $0fd14e73698eb927$export$8ad762e3e6399afe;
var $0fd14e73698eb927$export$32ef6f92e22c6ab0;
var $0fd14e73698eb927$export$c9cd164b539ebb63;
'use strict';

var $hl0ih = parcelRequire("hl0ih");

$0fd14e73698eb927$export$c98397a6eb8d0678 = (parcelRequire("8PYd1"));
var $0fd14e73698eb927$var$RSAPrivateKey = $hl0ih.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$0fd14e73698eb927$export$f4aab6816f64fa6b = $0fd14e73698eb927$var$RSAPrivateKey;
var $0fd14e73698eb927$var$RSAPublicKey = $hl0ih.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$0fd14e73698eb927$export$4471f5c65d097c11 = $0fd14e73698eb927$var$RSAPublicKey;
var $0fd14e73698eb927$var$AlgorithmIdentifier = $hl0ih.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $0fd14e73698eb927$var$PublicKey = $hl0ih.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($0fd14e73698eb927$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$0fd14e73698eb927$export$ca8b6604d6ce14de = $0fd14e73698eb927$var$PublicKey;
var $0fd14e73698eb927$var$PrivateKeyInfo = $hl0ih.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($0fd14e73698eb927$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$0fd14e73698eb927$export$8f54525b330fd87b = $0fd14e73698eb927$var$PrivateKeyInfo;
var $0fd14e73698eb927$var$EncryptedPrivateKeyInfo = $hl0ih.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$0fd14e73698eb927$export$23cd2842b44ca3e7 = $0fd14e73698eb927$var$EncryptedPrivateKeyInfo;
var $0fd14e73698eb927$var$DSAPrivateKey = $hl0ih.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$0fd14e73698eb927$export$245c9aaa9f5ce4ce = $0fd14e73698eb927$var$DSAPrivateKey;
$0fd14e73698eb927$export$8ad762e3e6399afe = $hl0ih.define('DSAparam', function() {
    this['int']();
});
var $0fd14e73698eb927$var$ECParameters = $hl0ih.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $0fd14e73698eb927$var$ECPrivateKey = $hl0ih.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($0fd14e73698eb927$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$0fd14e73698eb927$export$32ef6f92e22c6ab0 = $0fd14e73698eb927$var$ECPrivateKey;
$0fd14e73698eb927$export$c9cd164b539ebb63 = $hl0ih.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("hl0ih", function(module, exports) {
var $c9f4a02d1f59d6a6$var$asn1 = module.exports;

$c9f4a02d1f59d6a6$var$asn1.bignum = (parcelRequire("hlAHM"));

$c9f4a02d1f59d6a6$var$asn1.define = (parcelRequire("7C5CY")).define;

$c9f4a02d1f59d6a6$var$asn1.base = (parcelRequire("iWwea"));

$c9f4a02d1f59d6a6$var$asn1.constants = (parcelRequire("1fb9t"));

$c9f4a02d1f59d6a6$var$asn1.decoders = (parcelRequire("4hyYb"));

$c9f4a02d1f59d6a6$var$asn1.encoders = (parcelRequire("lDvlV"));

});
parcelRegister("hlAHM", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7C5CY", function(module, exports) {

var $hl0ih = parcelRequire("hl0ih");

var $dhT4G = parcelRequire("dhT4G");
var $58b0728c3ed07e03$var$api = module.exports;
$58b0728c3ed07e03$var$api.define = function define(name, body) {
    return new $58b0728c3ed07e03$var$Entity(name, body);
};
function $58b0728c3ed07e03$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$58b0728c3ed07e03$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("eqQT5")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dhT4G(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$58b0728c3ed07e03$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($hl0ih.decoders[enc]);
    return this.decoders[enc];
};
$58b0728c3ed07e03$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$58b0728c3ed07e03$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($hl0ih.encoders[enc]);
    return this.encoders[enc];
};
$58b0728c3ed07e03$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("eqQT5", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("iWwea", function(module, exports) {
var $dca6a4813cf30630$var$base = module.exports;

$dca6a4813cf30630$var$base.Reporter = (parcelRequire("5bsbC")).Reporter;

$dca6a4813cf30630$var$base.DecoderBuffer = (parcelRequire("jH2v3")).DecoderBuffer;

$dca6a4813cf30630$var$base.EncoderBuffer = (parcelRequire("jH2v3")).EncoderBuffer;

$dca6a4813cf30630$var$base.Node = (parcelRequire("3kihE"));

});
parcelRegister("5bsbC", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $3c63d8098c4065a1$export$957313a2f485e5ed; }, function (v) { return $3c63d8098c4065a1$export$957313a2f485e5ed = v; });
var $3c63d8098c4065a1$export$957313a2f485e5ed;

var $dhT4G = parcelRequire("dhT4G");
function $3c63d8098c4065a1$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$3c63d8098c4065a1$export$957313a2f485e5ed = $3c63d8098c4065a1$var$Reporter;
$3c63d8098c4065a1$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $3c63d8098c4065a1$var$ReporterError;
};
$3c63d8098c4065a1$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$3c63d8098c4065a1$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$3c63d8098c4065a1$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$3c63d8098c4065a1$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$3c63d8098c4065a1$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$3c63d8098c4065a1$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$3c63d8098c4065a1$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$3c63d8098c4065a1$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$3c63d8098c4065a1$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $3c63d8098c4065a1$var$ReporterError;
    if (inherited) err = msg;
    else err = new $3c63d8098c4065a1$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$3c63d8098c4065a1$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $3c63d8098c4065a1$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dhT4G($3c63d8098c4065a1$var$ReporterError, Error);
$3c63d8098c4065a1$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $3c63d8098c4065a1$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("jH2v3", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $e563f8e7c404a610$export$bf9f79cdc4a49163; }, function (v) { return $e563f8e7c404a610$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $e563f8e7c404a610$export$8ff24f7760c7a78e; }, function (v) { return $e563f8e7c404a610$export$8ff24f7760c7a78e = v; });
var $e563f8e7c404a610$export$bf9f79cdc4a49163;
var $e563f8e7c404a610$export$8ff24f7760c7a78e;

var $dhT4G = parcelRequire("dhT4G");

var $iWwea = parcelRequire("iWwea");
var $e563f8e7c404a610$require$Reporter = $iWwea.Reporter;

var $bdjQ6 = parcelRequire("bdjQ6");
var $e563f8e7c404a610$require$Buffer = $bdjQ6.Buffer;
function $e563f8e7c404a610$var$DecoderBuffer(base, options) {
    $e563f8e7c404a610$require$Reporter.call(this, options);
    if (!$e563f8e7c404a610$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dhT4G($e563f8e7c404a610$var$DecoderBuffer, $e563f8e7c404a610$require$Reporter);
$e563f8e7c404a610$export$bf9f79cdc4a49163 = $e563f8e7c404a610$var$DecoderBuffer;
$e563f8e7c404a610$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $e563f8e7c404a610$require$Reporter.prototype.save.call(this)
    };
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $e563f8e7c404a610$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $e563f8e7c404a610$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $e563f8e7c404a610$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$e563f8e7c404a610$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $e563f8e7c404a610$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $e563f8e7c404a610$var$EncoderBuffer)) item = new $e563f8e7c404a610$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $e563f8e7c404a610$require$Buffer.byteLength(value);
    } else if ($e563f8e7c404a610$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$e563f8e7c404a610$export$8ff24f7760c7a78e = $e563f8e7c404a610$var$EncoderBuffer;
$e563f8e7c404a610$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $e563f8e7c404a610$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($e563f8e7c404a610$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("3kihE", function(module, exports) {

var $iWwea = parcelRequire("iWwea");
var $26c16c1a02aab51e$require$Reporter = $iWwea.Reporter;

var $iWwea = parcelRequire("iWwea");
var $26c16c1a02aab51e$require$EncoderBuffer = $iWwea.EncoderBuffer;

var $iWwea = parcelRequire("iWwea");
var $26c16c1a02aab51e$require$DecoderBuffer = $iWwea.DecoderBuffer;

var $jLTFB = parcelRequire("jLTFB");
// Supported tags
var $26c16c1a02aab51e$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $26c16c1a02aab51e$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($26c16c1a02aab51e$var$tags);
// Overrided methods list
var $26c16c1a02aab51e$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $26c16c1a02aab51e$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $26c16c1a02aab51e$var$Node;
var $26c16c1a02aab51e$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$26c16c1a02aab51e$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $26c16c1a02aab51e$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$26c16c1a02aab51e$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $26c16c1a02aab51e$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$26c16c1a02aab51e$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $jLTFB(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $jLTFB.equal(state.children.length, 1, 'Root node can have only one child');
};
$26c16c1a02aab51e$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $jLTFB(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $jLTFB(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$26c16c1a02aab51e$var$overrided.forEach(function(method) {
    $26c16c1a02aab51e$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$26c16c1a02aab51e$var$tags.forEach(function(tag) {
    $26c16c1a02aab51e$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $jLTFB(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$26c16c1a02aab51e$var$Node.prototype.use = function use(item) {
    $jLTFB(item);
    var state = this._baseState;
    $jLTFB(state.use === null);
    state.use = item;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $jLTFB(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $jLTFB(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $jLTFB(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $jLTFB(state.key === null);
    state.key = newKey;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $jLTFB(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$26c16c1a02aab51e$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $jLTFB(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$26c16c1a02aab51e$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $26c16c1a02aab51e$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$26c16c1a02aab51e$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$26c16c1a02aab51e$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $jLTFB(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$26c16c1a02aab51e$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$26c16c1a02aab51e$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $26c16c1a02aab51e$require$EncoderBuffer(data, this.reporter);
};
$26c16c1a02aab51e$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$26c16c1a02aab51e$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $26c16c1a02aab51e$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$26c16c1a02aab51e$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $jLTFB(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$26c16c1a02aab51e$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$26c16c1a02aab51e$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$26c16c1a02aab51e$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("1fb9t", function(module, exports) {
var $0e7fd7b3172df5b4$var$constants = module.exports;
// Helper
$0e7fd7b3172df5b4$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$0e7fd7b3172df5b4$var$constants.der = (parcelRequire("1k4L4"));

});
parcelRegister("1k4L4", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $0f6b5998036e2e79$export$3584c46ed60baee8; }, function (v) { return $0f6b5998036e2e79$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $0f6b5998036e2e79$export$f18596ef8d632e49; }, function (v) { return $0f6b5998036e2e79$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $0f6b5998036e2e79$export$2b067c6666111485; }, function (v) { return $0f6b5998036e2e79$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $0f6b5998036e2e79$export$f17df38a421ab9e3; }, function (v) { return $0f6b5998036e2e79$export$f17df38a421ab9e3 = v; });
var $0f6b5998036e2e79$export$3584c46ed60baee8;
var $0f6b5998036e2e79$export$f18596ef8d632e49;
var $0f6b5998036e2e79$export$2b067c6666111485;
var $0f6b5998036e2e79$export$f17df38a421ab9e3;

var $1fb9t = parcelRequire("1fb9t");
$0f6b5998036e2e79$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$0f6b5998036e2e79$export$f18596ef8d632e49 = $1fb9t._reverse($0f6b5998036e2e79$export$3584c46ed60baee8);
$0f6b5998036e2e79$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$0f6b5998036e2e79$export$f17df38a421ab9e3 = $1fb9t._reverse($0f6b5998036e2e79$export$2b067c6666111485);

});


parcelRegister("4hyYb", function(module, exports) {
var $31e3e03616588660$var$decoders = module.exports;

$31e3e03616588660$var$decoders.der = (parcelRequire("lOUAW"));

$31e3e03616588660$var$decoders.pem = (parcelRequire("hXQvW"));

});
parcelRegister("lOUAW", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $hl0ih = parcelRequire("hl0ih");
var $fe2a2b049a9573f9$var$base = $hl0ih.base;
var $fe2a2b049a9573f9$var$bignum = $hl0ih.bignum;
// Import DER constants
var $fe2a2b049a9573f9$var$der = $hl0ih.constants.der;
function $fe2a2b049a9573f9$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $fe2a2b049a9573f9$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $fe2a2b049a9573f9$var$DERDecoder;
$fe2a2b049a9573f9$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $fe2a2b049a9573f9$var$base.DecoderBuffer)) data = new $fe2a2b049a9573f9$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $fe2a2b049a9573f9$var$DERNode(parent) {
    $fe2a2b049a9573f9$var$base.Node.call(this, 'der', parent);
}
$dhT4G($fe2a2b049a9573f9$var$DERNode, $fe2a2b049a9573f9$var$base.Node);
$fe2a2b049a9573f9$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $fe2a2b049a9573f9$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $fe2a2b049a9573f9$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $fe2a2b049a9573f9$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$fe2a2b049a9573f9$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $fe2a2b049a9573f9$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $fe2a2b049a9573f9$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$fe2a2b049a9573f9$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $fe2a2b049a9573f9$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$fe2a2b049a9573f9$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $fe2a2b049a9573f9$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $fe2a2b049a9573f9$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $fe2a2b049a9573f9$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $fe2a2b049a9573f9$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("hXQvW", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $bdjQ6 = parcelRequire("bdjQ6");
var $d140ae98da07bebb$require$Buffer = $bdjQ6.Buffer;

var $lOUAW = parcelRequire("lOUAW");
function $d140ae98da07bebb$var$PEMDecoder(entity) {
    $lOUAW.call(this, entity);
    this.enc = 'pem';
}
$dhT4G($d140ae98da07bebb$var$PEMDecoder, $lOUAW);
module.exports = $d140ae98da07bebb$var$PEMDecoder;
$d140ae98da07bebb$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $d140ae98da07bebb$require$Buffer(base64, 'base64');
    return $lOUAW.prototype.decode.call(this, input, options);
};

});


parcelRegister("lDvlV", function(module, exports) {
var $fc058f72de806c01$var$encoders = module.exports;

$fc058f72de806c01$var$encoders.der = (parcelRequire("aowvn"));

$fc058f72de806c01$var$encoders.pem = (parcelRequire("lJ9hm"));

});
parcelRegister("aowvn", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $bdjQ6 = parcelRequire("bdjQ6");
var $79155c1e61c68e60$require$Buffer = $bdjQ6.Buffer;

var $hl0ih = parcelRequire("hl0ih");
var $79155c1e61c68e60$var$base = $hl0ih.base;
// Import DER constants
var $79155c1e61c68e60$var$der = $hl0ih.constants.der;
function $79155c1e61c68e60$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $79155c1e61c68e60$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $79155c1e61c68e60$var$DEREncoder;
$79155c1e61c68e60$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $79155c1e61c68e60$var$DERNode(parent) {
    $79155c1e61c68e60$var$base.Node.call(this, 'der', parent);
}
$dhT4G($79155c1e61c68e60$var$DERNode, $79155c1e61c68e60$var$base.Node);
$79155c1e61c68e60$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $79155c1e61c68e60$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $79155c1e61c68e60$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $79155c1e61c68e60$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$79155c1e61c68e60$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $79155c1e61c68e60$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$79155c1e61c68e60$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $79155c1e61c68e60$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $79155c1e61c68e60$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$79155c1e61c68e60$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $79155c1e61c68e60$var$two(date.getFullYear()),
        $79155c1e61c68e60$var$two(date.getUTCMonth() + 1),
        $79155c1e61c68e60$var$two(date.getUTCDate()),
        $79155c1e61c68e60$var$two(date.getUTCHours()),
        $79155c1e61c68e60$var$two(date.getUTCMinutes()),
        $79155c1e61c68e60$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $79155c1e61c68e60$var$two(date.getFullYear() % 100),
        $79155c1e61c68e60$var$two(date.getUTCMonth() + 1),
        $79155c1e61c68e60$var$two(date.getUTCDate()),
        $79155c1e61c68e60$var$two(date.getUTCHours()),
        $79155c1e61c68e60$var$two(date.getUTCMinutes()),
        $79155c1e61c68e60$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$79155c1e61c68e60$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$79155c1e61c68e60$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$79155c1e61c68e60$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $79155c1e61c68e60$require$Buffer(numArray);
    }
    if ($79155c1e61c68e60$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $79155c1e61c68e60$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $79155c1e61c68e60$require$Buffer(out));
};
$79155c1e61c68e60$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$79155c1e61c68e60$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$79155c1e61c68e60$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $79155c1e61c68e60$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($79155c1e61c68e60$var$der.tagByName.hasOwnProperty(tag)) res = $79155c1e61c68e60$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $79155c1e61c68e60$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("lJ9hm", function(module, exports) {

var $dhT4G = parcelRequire("dhT4G");

var $aowvn = parcelRequire("aowvn");
function $fd14ff90396c39a5$var$PEMEncoder(entity) {
    $aowvn.call(this, entity);
    this.enc = 'pem';
}
$dhT4G($fd14ff90396c39a5$var$PEMEncoder, $aowvn);
module.exports = $fd14ff90396c39a5$var$PEMEncoder;
$fd14ff90396c39a5$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $aowvn.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("8PYd1", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $hl0ih = parcelRequire("hl0ih");
var $66f1ca64d4f026a4$var$Time = $hl0ih.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $66f1ca64d4f026a4$var$AttributeTypeValue = $hl0ih.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $66f1ca64d4f026a4$var$AlgorithmIdentifier = $hl0ih.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $66f1ca64d4f026a4$var$SubjectPublicKeyInfo = $hl0ih.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($66f1ca64d4f026a4$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $66f1ca64d4f026a4$var$RelativeDistinguishedName = $hl0ih.define('RelativeDistinguishedName', function() {
    this.setof($66f1ca64d4f026a4$var$AttributeTypeValue);
});
var $66f1ca64d4f026a4$var$RDNSequence = $hl0ih.define('RDNSequence', function() {
    this.seqof($66f1ca64d4f026a4$var$RelativeDistinguishedName);
});
var $66f1ca64d4f026a4$var$Name = $hl0ih.define('Name', function() {
    this.choice({
        rdnSequence: this.use($66f1ca64d4f026a4$var$RDNSequence)
    });
});
var $66f1ca64d4f026a4$var$Validity = $hl0ih.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($66f1ca64d4f026a4$var$Time), this.key('notAfter').use($66f1ca64d4f026a4$var$Time));
});
var $66f1ca64d4f026a4$var$Extension = $hl0ih.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $66f1ca64d4f026a4$var$TBSCertificate = $hl0ih.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($66f1ca64d4f026a4$var$AlgorithmIdentifier), this.key('issuer').use($66f1ca64d4f026a4$var$Name), this.key('validity').use($66f1ca64d4f026a4$var$Validity), this.key('subject').use($66f1ca64d4f026a4$var$Name), this.key('subjectPublicKeyInfo').use($66f1ca64d4f026a4$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($66f1ca64d4f026a4$var$Extension).optional());
});
var $66f1ca64d4f026a4$var$X509Certificate = $hl0ih.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($66f1ca64d4f026a4$var$TBSCertificate), this.key('signatureAlgorithm').use($66f1ca64d4f026a4$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $66f1ca64d4f026a4$var$X509Certificate;

});


parcelRegister("7sB41", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("afsnk", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $776150cf36ad152d$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $776150cf36ad152d$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $776150cf36ad152d$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $iWvja = parcelRequire("iWvja");

var $jGDtA = parcelRequire("jGDtA");

var $838j1 = parcelRequire("838j1");
var $776150cf36ad152d$require$Buffer = $838j1.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($776150cf36ad152d$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($776150cf36ad152d$var$fullRegex);
        decrypted = $776150cf36ad152d$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $776150cf36ad152d$require$Buffer.from(match[2], 'hex');
        var cipherText = $776150cf36ad152d$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $iWvja(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $jGDtA.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $776150cf36ad152d$require$Buffer.concat(out);
    }
    var tag = key.match($776150cf36ad152d$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("6cUou", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("7LwOP", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $5a766155c8ab551b$require$Buffer = $838j1.Buffer;

var $aVh2m = parcelRequire("aVh2m");

var $a2sGY = parcelRequire("a2sGY");
var $5a766155c8ab551b$require$EC = $a2sGY.ec;

var $hdVtR = parcelRequire("hdVtR");

var $6cUou = parcelRequire("6cUou");
function $5a766155c8ab551b$var$verify(sig, hash, key, signType, tag) {
    var pub = $hdVtR(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $5a766155c8ab551b$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $5a766155c8ab551b$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $5a766155c8ab551b$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $5a766155c8ab551b$require$Buffer.from(pad);
    var red = $aVh2m.mont(pub.modulus);
    sig = new $aVh2m(sig).toRed(red);
    sig = sig.redPow(new $aVh2m(pub.publicExponent));
    sig = $5a766155c8ab551b$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $5a766155c8ab551b$var$ecVerify(sig, hash, pub) {
    var curveId = $6cUou[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $5a766155c8ab551b$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $5a766155c8ab551b$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $hdVtR.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $5a766155c8ab551b$var$checkValue(s, q);
    $5a766155c8ab551b$var$checkValue(r, q);
    var montp = $aVh2m.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $aVh2m(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $5a766155c8ab551b$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $5a766155c8ab551b$var$verify;

});


parcelRegister("iT16E", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $dbfe38b5b3f041f5$require$Buffer = $bdjQ6.Buffer;

var $a2sGY = parcelRequire("a2sGY");

var $f8x3B = parcelRequire("f8x3B");
module.exports = function createECDH(curve) {
    return new $dbfe38b5b3f041f5$var$ECDH(curve);
};
var $dbfe38b5b3f041f5$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$dbfe38b5b3f041f5$var$aliases.p224 = $dbfe38b5b3f041f5$var$aliases.secp224r1;
$dbfe38b5b3f041f5$var$aliases.p256 = $dbfe38b5b3f041f5$var$aliases.secp256r1 = $dbfe38b5b3f041f5$var$aliases.prime256v1;
$dbfe38b5b3f041f5$var$aliases.p192 = $dbfe38b5b3f041f5$var$aliases.secp192r1 = $dbfe38b5b3f041f5$var$aliases.prime192v1;
$dbfe38b5b3f041f5$var$aliases.p384 = $dbfe38b5b3f041f5$var$aliases.secp384r1;
$dbfe38b5b3f041f5$var$aliases.p521 = $dbfe38b5b3f041f5$var$aliases.secp521r1;
function $dbfe38b5b3f041f5$var$ECDH(curve) {
    this.curveType = $dbfe38b5b3f041f5$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $a2sGY.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$dbfe38b5b3f041f5$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$dbfe38b5b3f041f5$require$Buffer.isBuffer(other)) other = new $dbfe38b5b3f041f5$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $dbfe38b5b3f041f5$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $dbfe38b5b3f041f5$var$formatReturnValue(key, enc);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $dbfe38b5b3f041f5$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$dbfe38b5b3f041f5$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$dbfe38b5b3f041f5$require$Buffer.isBuffer(pub)) pub = new $dbfe38b5b3f041f5$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$dbfe38b5b3f041f5$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$dbfe38b5b3f041f5$require$Buffer.isBuffer(priv)) priv = new $dbfe38b5b3f041f5$require$Buffer(priv, enc);
    var _priv = new $f8x3B(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $dbfe38b5b3f041f5$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $dbfe38b5b3f041f5$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $dbfe38b5b3f041f5$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $dbfe38b5b3f041f5$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("f8x3B", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("estFo", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $a86ab166e2d75ba5$export$512823e338ddb1b7; }, function (v) { return $a86ab166e2d75ba5$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $a86ab166e2d75ba5$export$7efb24e2fddf99b9; }, function (v) { return $a86ab166e2d75ba5$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3; }, function (v) { return $a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $a86ab166e2d75ba5$export$b9d55ff329113abd; }, function (v) { return $a86ab166e2d75ba5$export$b9d55ff329113abd = v; });
var $a86ab166e2d75ba5$export$512823e338ddb1b7;
var $a86ab166e2d75ba5$export$7efb24e2fddf99b9;
var $a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3;
var $a86ab166e2d75ba5$export$b9d55ff329113abd;

$a86ab166e2d75ba5$export$512823e338ddb1b7 = (parcelRequire("eWI2k"));

$a86ab166e2d75ba5$export$7efb24e2fddf99b9 = (parcelRequire("fUUOC"));
$a86ab166e2d75ba5$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $a86ab166e2d75ba5$export$512823e338ddb1b7(key, buf, true);
};
$a86ab166e2d75ba5$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $a86ab166e2d75ba5$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("eWI2k", function(module, exports) {

var $hdVtR = parcelRequire("hdVtR");

var $f08he = parcelRequire("f08he");

var $eNPUV = parcelRequire("eNPUV");

var $k9jil = parcelRequire("k9jil");

var $kkDNX = parcelRequire("kkDNX");

var $jKpja = parcelRequire("jKpja");

var $argyJ = parcelRequire("argyJ");

var $2jcIV = parcelRequire("2jcIV");

var $838j1 = parcelRequire("838j1");
var $ae18a42fc88e982d$require$Buffer = $838j1.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $hdVtR(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $ae18a42fc88e982d$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $ae18a42fc88e982d$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $jKpja(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $2jcIV(paddedMsg, key);
    else return $argyJ(paddedMsg, key);
};
function $ae18a42fc88e982d$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $eNPUV('sha1').update($ae18a42fc88e982d$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $ae18a42fc88e982d$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $f08he(hLen);
    var maskedDb = $kkDNX($ae18a42fc88e982d$require$Buffer.concat([
        iHash,
        ps,
        $ae18a42fc88e982d$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $k9jil(seed, dblen));
    var maskedSeed = $kkDNX(seed, $k9jil(maskedDb, hLen));
    return new $jKpja($ae18a42fc88e982d$require$Buffer.concat([
        $ae18a42fc88e982d$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $ae18a42fc88e982d$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $ae18a42fc88e982d$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $ae18a42fc88e982d$var$nonZero(k - mLen - 3);
    return new $jKpja($ae18a42fc88e982d$require$Buffer.concat([
        $ae18a42fc88e982d$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $ae18a42fc88e982d$require$Buffer.alloc(1),
        msg
    ], k));
}
function $ae18a42fc88e982d$var$nonZero(len) {
    var out = $ae18a42fc88e982d$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $f08he(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $f08he(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("k9jil", function(module, exports) {

var $eNPUV = parcelRequire("eNPUV");

var $838j1 = parcelRequire("838j1");
var $eab39d77b6a56d48$require$Buffer = $838j1.Buffer;
module.exports = function(seed, len) {
    var t = $eab39d77b6a56d48$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $eab39d77b6a56d48$var$i2ops(i++);
        t = $eab39d77b6a56d48$require$Buffer.concat([
            t,
            $eNPUV('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $eab39d77b6a56d48$var$i2ops(c) {
    var out = $eab39d77b6a56d48$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("kkDNX", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("jKpja", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("ifbub")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("argyJ", function(module, exports) {

var $jKpja = parcelRequire("jKpja");

var $838j1 = parcelRequire("838j1");
var $799945527bd57bd7$require$Buffer = $838j1.Buffer;
function $799945527bd57bd7$var$withPublic(paddedMsg, key) {
    return $799945527bd57bd7$require$Buffer.from(paddedMsg.toRed($jKpja.mont(key.modulus)).redPow(new $jKpja(key.publicExponent)).fromRed().toArray());
}
module.exports = $799945527bd57bd7$var$withPublic;

});


parcelRegister("fUUOC", function(module, exports) {

var $hdVtR = parcelRequire("hdVtR");

var $k9jil = parcelRequire("k9jil");

var $kkDNX = parcelRequire("kkDNX");

var $jKpja = parcelRequire("jKpja");

var $2jcIV = parcelRequire("2jcIV");

var $eNPUV = parcelRequire("eNPUV");

var $argyJ = parcelRequire("argyJ");

var $838j1 = parcelRequire("838j1");
var $b9682859c179c6a2$require$Buffer = $838j1.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $hdVtR(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $jKpja(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $argyJ(new $jKpja(enc), key);
    else msg = $2jcIV(enc, key);
    var zBuffer = $b9682859c179c6a2$require$Buffer.alloc(k - msg.length);
    msg = $b9682859c179c6a2$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $b9682859c179c6a2$var$oaep(key, msg);
    else if (padding === 1) return $b9682859c179c6a2$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $b9682859c179c6a2$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $eNPUV('sha1').update($b9682859c179c6a2$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $kkDNX(maskedSeed, $k9jil(maskedDb, hLen));
    var db = $kkDNX(maskedDb, $k9jil(seed, k - hLen - 1));
    if ($b9682859c179c6a2$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $b9682859c179c6a2$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $b9682859c179c6a2$var$compare(a, b) {
    a = $b9682859c179c6a2$require$Buffer.from(a);
    b = $b9682859c179c6a2$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("3yLuA", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $29796313a5dc60f7$export$bb1abf2ce84fc7e8; }, function (v) { return $29796313a5dc60f7$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $29796313a5dc60f7$export$2f7171e78e524d5e; }, function (v) { return $29796313a5dc60f7$export$2f7171e78e524d5e = v; });
var $29796313a5dc60f7$export$bb1abf2ce84fc7e8;
var $29796313a5dc60f7$export$2f7171e78e524d5e;

var $4ZL0H = parcelRequire("4ZL0H");
'use strict';
function $29796313a5dc60f7$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $838j1 = parcelRequire("838j1");

var $f08he = parcelRequire("f08he");
var $29796313a5dc60f7$var$Buffer = $838j1.Buffer;
var $29796313a5dc60f7$var$kBufferMaxLength = $838j1.kMaxLength;
var $29796313a5dc60f7$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $29796313a5dc60f7$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $29796313a5dc60f7$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $29796313a5dc60f7$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $29796313a5dc60f7$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $29796313a5dc60f7$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $29796313a5dc60f7$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $29796313a5dc60f7$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($29796313a5dc60f7$var$crypto && $29796313a5dc60f7$var$crypto.getRandomValues || false) {
    $29796313a5dc60f7$export$bb1abf2ce84fc7e8 = $29796313a5dc60f7$var$randomFill;
    $29796313a5dc60f7$export$2f7171e78e524d5e = $29796313a5dc60f7$var$randomFillSync;
} else {
    $29796313a5dc60f7$export$bb1abf2ce84fc7e8 = $29796313a5dc60f7$var$oldBrowser;
    $29796313a5dc60f7$export$2f7171e78e524d5e = $29796313a5dc60f7$var$oldBrowser;
}
function $29796313a5dc60f7$var$randomFill(buf, offset, size, cb) {
    if (!$29796313a5dc60f7$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $29796313a5dc60f7$var$assertOffset(offset, buf.length);
    $29796313a5dc60f7$var$assertSize(size, offset, buf.length);
    return $29796313a5dc60f7$var$actualFill(buf, offset, size, cb);
}
function $29796313a5dc60f7$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $29796313a5dc60f7$var$crypto.getRandomValues(uint);
    if (cb) {
        $4ZL0H.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $f08he(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $f08he(size);
    bytes.copy(buf, offset);
    return buf;
}
function $29796313a5dc60f7$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$29796313a5dc60f7$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $29796313a5dc60f7$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $29796313a5dc60f7$var$assertSize(size, offset, buf.length);
    return $29796313a5dc60f7$var$actualFill(buf, offset, size);
}

});


parcelRegister("9YAY5", function(module, exports) {
'use strict';

var $838j1 = parcelRequire("838j1");
var $743664c4b8fd32ff$require$Buffer = $838j1.Buffer;

var $gmRjM = parcelRequire("gmRjM");
var $743664c4b8fd32ff$var$MAX_OCTET = 0x80, $743664c4b8fd32ff$var$CLASS_UNIVERSAL = 0, $743664c4b8fd32ff$var$PRIMITIVE_BIT = 0x20, $743664c4b8fd32ff$var$TAG_SEQ = 0x10, $743664c4b8fd32ff$var$TAG_INT = 0x02, $743664c4b8fd32ff$var$ENCODED_TAG_SEQ = $743664c4b8fd32ff$var$TAG_SEQ | $743664c4b8fd32ff$var$PRIMITIVE_BIT | $743664c4b8fd32ff$var$CLASS_UNIVERSAL << 6, $743664c4b8fd32ff$var$ENCODED_TAG_INT = $743664c4b8fd32ff$var$TAG_INT | $743664c4b8fd32ff$var$CLASS_UNIVERSAL << 6;
function $743664c4b8fd32ff$var$base64Url(base64) {
    return base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function $743664c4b8fd32ff$var$signatureAsBuffer(signature) {
    if ($743664c4b8fd32ff$require$Buffer.isBuffer(signature)) return signature;
    else if ('string' === typeof signature) return $743664c4b8fd32ff$require$Buffer.from(signature, 'base64');
    throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
}
function $743664c4b8fd32ff$var$derToJose(signature, alg) {
    signature = $743664c4b8fd32ff$var$signatureAsBuffer(signature);
    var paramBytes = $gmRjM(alg);
    // the DER encoded param should at most be the param size, plus a padding
    // zero, since due to being a signed integer
    var maxEncodedParamLength = paramBytes + 1;
    var inputLength = signature.length;
    var offset = 0;
    if (signature[offset++] !== $743664c4b8fd32ff$var$ENCODED_TAG_SEQ) throw new Error('Could not find expected "seq"');
    var seqLength = signature[offset++];
    if (seqLength === ($743664c4b8fd32ff$var$MAX_OCTET | 1)) seqLength = signature[offset++];
    if (inputLength - offset < seqLength) throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
    if (signature[offset++] !== $743664c4b8fd32ff$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "r"');
    var rLength = signature[offset++];
    if (inputLength - offset - 2 < rLength) throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
    if (maxEncodedParamLength < rLength) throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var rOffset = offset;
    offset += rLength;
    if (signature[offset++] !== $743664c4b8fd32ff$var$ENCODED_TAG_INT) throw new Error('Could not find expected "int" for "s"');
    var sLength = signature[offset++];
    if (inputLength - offset !== sLength) throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
    if (maxEncodedParamLength < sLength) throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
    var sOffset = offset;
    offset += sLength;
    if (offset !== inputLength) throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
    var rPadding = paramBytes - rLength, sPadding = paramBytes - sLength;
    var dst = $743664c4b8fd32ff$require$Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);
    for(offset = 0; offset < rPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);
    offset = paramBytes;
    for(var o = offset; offset < o + sPadding; ++offset)dst[offset] = 0;
    signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);
    dst = dst.toString('base64');
    dst = $743664c4b8fd32ff$var$base64Url(dst);
    return dst;
}
function $743664c4b8fd32ff$var$countPadding(buf, start, stop) {
    var padding = 0;
    while(start + padding < stop && buf[start + padding] === 0)++padding;
    var needsSign = buf[start + padding] >= $743664c4b8fd32ff$var$MAX_OCTET;
    if (needsSign) --padding;
    return padding;
}
function $743664c4b8fd32ff$var$joseToDer(signature, alg) {
    signature = $743664c4b8fd32ff$var$signatureAsBuffer(signature);
    var paramBytes = $gmRjM(alg);
    var signatureBytes = signature.length;
    if (signatureBytes !== paramBytes * 2) throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
    var rPadding = $743664c4b8fd32ff$var$countPadding(signature, 0, paramBytes);
    var sPadding = $743664c4b8fd32ff$var$countPadding(signature, paramBytes, signature.length);
    var rLength = paramBytes - rPadding;
    var sLength = paramBytes - sPadding;
    var rsBytes = 2 + rLength + 1 + 1 + sLength;
    var shortLength = rsBytes < $743664c4b8fd32ff$var$MAX_OCTET;
    var dst = $743664c4b8fd32ff$require$Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);
    var offset = 0;
    dst[offset++] = $743664c4b8fd32ff$var$ENCODED_TAG_SEQ;
    if (shortLength) // Bit 8 has value "0"
    // bits 7-1 give the length.
    dst[offset++] = rsBytes;
    else {
        // Bit 8 of first octet has value "1"
        // bits 7-1 give the number of additional length octets.
        dst[offset++] = $743664c4b8fd32ff$var$MAX_OCTET | 1;
        // length, base 256
        dst[offset++] = rsBytes & 0xff;
    }
    dst[offset++] = $743664c4b8fd32ff$var$ENCODED_TAG_INT;
    dst[offset++] = rLength;
    if (rPadding < 0) {
        dst[offset++] = 0;
        offset += signature.copy(dst, offset, 0, paramBytes);
    } else offset += signature.copy(dst, offset, rPadding, paramBytes);
    dst[offset++] = $743664c4b8fd32ff$var$ENCODED_TAG_INT;
    dst[offset++] = sLength;
    if (sPadding < 0) {
        dst[offset++] = 0;
        signature.copy(dst, offset, paramBytes);
    } else signature.copy(dst, offset, paramBytes + sPadding);
    return dst;
}
module.exports = {
    derToJose: $743664c4b8fd32ff$var$derToJose,
    joseToDer: $743664c4b8fd32ff$var$joseToDer
};

});
parcelRegister("gmRjM", function(module, exports) {
'use strict';
function $bea80f403d43bf62$var$getParamSize(keySize) {
    var result = (keySize / 8 | 0) + (keySize % 8 === 0 ? 0 : 1);
    return result;
}
var $bea80f403d43bf62$var$paramBytesForAlg = {
    ES256: $bea80f403d43bf62$var$getParamSize(256),
    ES384: $bea80f403d43bf62$var$getParamSize(384),
    ES512: $bea80f403d43bf62$var$getParamSize(521)
};
function $bea80f403d43bf62$var$getParamBytesForAlg(alg) {
    var paramBytes = $bea80f403d43bf62$var$paramBytesForAlg[alg];
    if (paramBytes) return paramBytes;
    throw new Error('Unknown algorithm "' + alg + '"');
}
module.exports = $bea80f403d43bf62$var$getParamBytesForAlg;

});


parcelRegister("2ounp", function(module, exports) {
/*jshint node:true */ 'use strict';

var $bdjQ6 = parcelRequire("bdjQ6");
var $1be562d14bdb385f$require$Buffer = $bdjQ6.Buffer;

var $bdjQ6 = parcelRequire("bdjQ6");
var $1be562d14bdb385f$require$SlowBuffer = $bdjQ6.SlowBuffer;
module.exports = $1be562d14bdb385f$var$bufferEq;
function $1be562d14bdb385f$var$bufferEq(a, b) {
    // shortcutting on type is necessary for correctness
    if (!$1be562d14bdb385f$require$Buffer.isBuffer(a) || !$1be562d14bdb385f$require$Buffer.isBuffer(b)) return false;
    // buffer sizes should be well-known information, so despite this
    // shortcutting, it doesn't leak any information about the *contents* of the
    // buffers.
    if (a.length !== b.length) return false;
    var c = 0;
    for(var i = 0; i < a.length; i++)/*jshint bitwise:false */ c |= a[i] ^ b[i]; // XOR
    return c === 0;
}
$1be562d14bdb385f$var$bufferEq.install = function() {
    $1be562d14bdb385f$require$Buffer.prototype.equal = $1be562d14bdb385f$require$SlowBuffer.prototype.equal = function equal(that) {
        return $1be562d14bdb385f$var$bufferEq(this, that);
    };
};
var $1be562d14bdb385f$var$origBufEqual = $1be562d14bdb385f$require$Buffer.prototype.equal;
var $1be562d14bdb385f$var$origSlowBufEqual = $1be562d14bdb385f$require$SlowBuffer.prototype.equal;
$1be562d14bdb385f$var$bufferEq.restore = function() {
    $1be562d14bdb385f$require$Buffer.prototype.equal = $1be562d14bdb385f$var$origBufEqual;
    $1be562d14bdb385f$require$SlowBuffer.prototype.equal = $1be562d14bdb385f$var$origSlowBufEqual;
};

});


parcelRegister("q8HNf", function(module, exports) {
/*global module*/ 
var $bdjQ6 = parcelRequire("bdjQ6");
var $04e92e85da0db810$require$Buffer = $bdjQ6.Buffer;
module.exports = function toString(obj) {
    if (typeof obj === 'string') return obj;
    if (typeof obj === 'number' || $04e92e85da0db810$require$Buffer.isBuffer(obj)) return obj.toString();
    return JSON.stringify(obj);
};

});


parcelRegister("cFKIK", function(module, exports) {
/*global module*/ 
var $838j1 = parcelRequire("838j1");
var $0261824ac7f3e46a$require$Buffer = $838j1.Buffer;

var $2lgVM = parcelRequire("2lgVM");

var $gUhMZ = parcelRequire("gUhMZ");

var $3DkjE = parcelRequire("3DkjE");

var $q8HNf = parcelRequire("q8HNf");

var $5LV4O = parcelRequire("5LV4O");
var $0261824ac7f3e46a$var$JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;
function $0261824ac7f3e46a$var$isObject(thing) {
    return Object.prototype.toString.call(thing) === '[object Object]';
}
function $0261824ac7f3e46a$var$safeJsonParse(thing) {
    if ($0261824ac7f3e46a$var$isObject(thing)) return thing;
    try {
        return JSON.parse(thing);
    } catch (e) {
        return undefined;
    }
}
function $0261824ac7f3e46a$var$headerFromJWS(jwsSig) {
    var encodedHeader = jwsSig.split('.', 1)[0];
    return $0261824ac7f3e46a$var$safeJsonParse($0261824ac7f3e46a$require$Buffer.from(encodedHeader, 'base64').toString('binary'));
}
function $0261824ac7f3e46a$var$securedInputFromJWS(jwsSig) {
    return jwsSig.split('.', 2).join('.');
}
function $0261824ac7f3e46a$var$signatureFromJWS(jwsSig) {
    return jwsSig.split('.')[2];
}
function $0261824ac7f3e46a$var$payloadFromJWS(jwsSig, encoding) {
    encoding = encoding || 'utf8';
    var payload = jwsSig.split('.')[1];
    return $0261824ac7f3e46a$require$Buffer.from(payload, 'base64').toString(encoding);
}
function $0261824ac7f3e46a$var$isValidJws(string) {
    return $0261824ac7f3e46a$var$JWS_REGEX.test(string) && !!$0261824ac7f3e46a$var$headerFromJWS(string);
}
function $0261824ac7f3e46a$var$jwsVerify(jwsSig, algorithm, secretOrKey) {
    if (!algorithm) {
        var err = new Error("Missing algorithm parameter for jws.verify");
        err.code = "MISSING_ALGORITHM";
        throw err;
    }
    jwsSig = $q8HNf(jwsSig);
    var signature = $0261824ac7f3e46a$var$signatureFromJWS(jwsSig);
    var securedInput = $0261824ac7f3e46a$var$securedInputFromJWS(jwsSig);
    var algo = $gUhMZ(algorithm);
    return algo.verify(securedInput, signature, secretOrKey);
}
function $0261824ac7f3e46a$var$jwsDecode(jwsSig, opts) {
    opts = opts || {};
    jwsSig = $q8HNf(jwsSig);
    if (!$0261824ac7f3e46a$var$isValidJws(jwsSig)) return null;
    var header = $0261824ac7f3e46a$var$headerFromJWS(jwsSig);
    if (!header) return null;
    var payload = $0261824ac7f3e46a$var$payloadFromJWS(jwsSig);
    if (header.typ === 'JWT' || opts.json) payload = JSON.parse(payload, opts.encoding);
    return {
        header: header,
        payload: payload,
        signature: $0261824ac7f3e46a$var$signatureFromJWS(jwsSig)
    };
}
function $0261824ac7f3e46a$var$VerifyStream(opts) {
    opts = opts || {};
    var secretOrKey = opts.secret;
    secretOrKey = secretOrKey == null ? opts.publicKey : secretOrKey;
    secretOrKey = secretOrKey == null ? opts.key : secretOrKey;
    if (/^hs/i.test(opts.algorithm) === true && secretOrKey == null) throw new TypeError('secret must be a string or buffer or a KeyObject');
    var secretStream = new $2lgVM(secretOrKey);
    this.readable = true;
    this.algorithm = opts.algorithm;
    this.encoding = opts.encoding;
    this.secret = this.publicKey = this.key = secretStream;
    this.signature = new $2lgVM(opts.signature);
    this.secret.once('close', (function() {
        if (!this.signature.writable && this.readable) this.verify();
    }).bind(this));
    this.signature.once('close', (function() {
        if (!this.secret.writable && this.readable) this.verify();
    }).bind(this));
}
$5LV4O.inherits($0261824ac7f3e46a$var$VerifyStream, $3DkjE);
$0261824ac7f3e46a$var$VerifyStream.prototype.verify = function verify() {
    try {
        var valid = $0261824ac7f3e46a$var$jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
        var obj = $0261824ac7f3e46a$var$jwsDecode(this.signature.buffer, this.encoding);
        this.emit('done', valid, obj);
        this.emit('data', valid);
        this.emit('end');
        this.readable = false;
        return valid;
    } catch (e) {
        this.readable = false;
        this.emit('error', e);
        this.emit('close');
    }
};
$0261824ac7f3e46a$var$VerifyStream.decode = $0261824ac7f3e46a$var$jwsDecode;
$0261824ac7f3e46a$var$VerifyStream.isValid = $0261824ac7f3e46a$var$isValidJws;
$0261824ac7f3e46a$var$VerifyStream.verify = $0261824ac7f3e46a$var$jwsVerify;
module.exports = $0261824ac7f3e46a$var$VerifyStream;

});



parcelRegister("7RGJO", function(module, exports) {

var $ifPfG = parcelRequire("ifPfG");

var $63AiW = parcelRequire("63AiW");

var $bB7TK = parcelRequire("bB7TK");

var $asDSe = parcelRequire("asDSe");

var $1shls = parcelRequire("1shls");

var $eOSWc = parcelRequire("eOSWc");

var $ihqFb = parcelRequire("ihqFb");
var $5b9ea2864b0b5d7a$var$PUB_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512',
    'ES256',
    'ES384',
    'ES512'
];
var $5b9ea2864b0b5d7a$var$RSA_KEY_ALGS = [
    'RS256',
    'RS384',
    'RS512'
];
var $5b9ea2864b0b5d7a$var$HS_ALGS = [
    'HS256',
    'HS384',
    'HS512'
];
if ($eOSWc) {
    $5b9ea2864b0b5d7a$var$PUB_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
    $5b9ea2864b0b5d7a$var$RSA_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
}
module.exports = function(jwtString, secretOrPublicKey, options, callback) {
    if (typeof options === 'function' && !callback) {
        callback = options;
        options = {};
    }
    if (!options) options = {};
    //clone this object since we are going to mutate it.
    options = Object.assign({}, options);
    var done;
    if (callback) done = callback;
    else done = function(err, data) {
        if (err) throw err;
        return data;
    };
    if (options.clockTimestamp && typeof options.clockTimestamp !== 'number') return done(new $ifPfG('clockTimestamp must be a number'));
    if (options.nonce !== undefined && (typeof options.nonce !== 'string' || options.nonce.trim() === '')) return done(new $ifPfG('nonce must be a non-empty string'));
    var clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);
    if (!jwtString) return done(new $ifPfG('jwt must be provided'));
    if (typeof jwtString !== 'string') return done(new $ifPfG('jwt must be a string'));
    var parts = jwtString.split('.');
    if (parts.length !== 3) return done(new $ifPfG('jwt malformed'));
    var decodedToken;
    try {
        decodedToken = $asDSe(jwtString, {
            complete: true
        });
    } catch (err) {
        return done(err);
    }
    if (!decodedToken) return done(new $ifPfG('invalid token'));
    var header = decodedToken.header;
    var getSecret;
    if (typeof secretOrPublicKey === 'function') {
        if (!callback) return done(new $ifPfG('verify must be called asynchronous if secret or public key is provided as a callback'));
        getSecret = secretOrPublicKey;
    } else getSecret = function(header, secretCallback) {
        return secretCallback(null, secretOrPublicKey);
    };
    return getSecret(header, function(err, secretOrPublicKey) {
        if (err) return done(new $ifPfG('error in secret or public key callback: ' + err.message));
        var hasSignature = parts[2].trim() !== '';
        if (!hasSignature && secretOrPublicKey) return done(new $ifPfG('jwt signature is required'));
        if (hasSignature && !secretOrPublicKey) return done(new $ifPfG('secret or public key must be provided'));
        if (!hasSignature && !options.algorithms) options.algorithms = [
            'none'
        ];
        if (!options.algorithms) options.algorithms = ~secretOrPublicKey.toString().indexOf('BEGIN CERTIFICATE') || ~secretOrPublicKey.toString().indexOf('BEGIN PUBLIC KEY') ? $5b9ea2864b0b5d7a$var$PUB_KEY_ALGS : ~secretOrPublicKey.toString().indexOf('BEGIN RSA PUBLIC KEY') ? $5b9ea2864b0b5d7a$var$RSA_KEY_ALGS : $5b9ea2864b0b5d7a$var$HS_ALGS;
        if (!~options.algorithms.indexOf(decodedToken.header.alg)) return done(new $ifPfG('invalid algorithm'));
        var valid;
        try {
            valid = $ihqFb.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
        } catch (e) {
            return done(e);
        }
        if (!valid) return done(new $ifPfG('invalid signature'));
        var payload = decodedToken.payload;
        if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
            if (typeof payload.nbf !== 'number') return done(new $ifPfG('invalid nbf value'));
            if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) return done(new $63AiW('jwt not active', new Date(payload.nbf * 1000)));
        }
        if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
            if (typeof payload.exp !== 'number') return done(new $ifPfG('invalid exp value'));
            if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) return done(new $bB7TK('jwt expired', new Date(payload.exp * 1000)));
        }
        if (options.audience) {
            var audiences = Array.isArray(options.audience) ? options.audience : [
                options.audience
            ];
            var target = Array.isArray(payload.aud) ? payload.aud : [
                payload.aud
            ];
            var match = target.some(function(targetAudience) {
                return audiences.some(function(audience) {
                    return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
                });
            });
            if (!match) return done(new $ifPfG('jwt audience invalid. expected: ' + audiences.join(' or ')));
        }
        if (options.issuer) {
            var invalid_issuer = typeof options.issuer === 'string' && payload.iss !== options.issuer || Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1;
            if (invalid_issuer) return done(new $ifPfG('jwt issuer invalid. expected: ' + options.issuer));
        }
        if (options.subject) {
            if (payload.sub !== options.subject) return done(new $ifPfG('jwt subject invalid. expected: ' + options.subject));
        }
        if (options.jwtid) {
            if (payload.jti !== options.jwtid) return done(new $ifPfG('jwt jwtid invalid. expected: ' + options.jwtid));
        }
        if (options.nonce) {
            if (payload.nonce !== options.nonce) return done(new $ifPfG('jwt nonce invalid. expected: ' + options.nonce));
        }
        if (options.maxAge) {
            if (typeof payload.iat !== 'number') return done(new $ifPfG('iat required when maxAge is specified'));
            var maxAgeTimestamp = $1shls(options.maxAge, payload.iat);
            if (typeof maxAgeTimestamp === 'undefined') return done(new $ifPfG('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
            if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) return done(new $bB7TK('maxAge exceeded', new Date(maxAgeTimestamp * 1000)));
        }
        if (options.complete === true) {
            var signature = decodedToken.signature;
            return done(null, {
                header: header,
                payload: payload,
                signature: signature
            });
        }
        return done(null, payload);
    });
};

});
parcelRegister("ifPfG", function(module, exports) {
var $036df532c7faedba$var$JsonWebTokenError = function(message, error) {
    Error.call(this, message);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    this.name = 'JsonWebTokenError';
    this.message = message;
    if (error) this.inner = error;
};
$036df532c7faedba$var$JsonWebTokenError.prototype = Object.create(Error.prototype);
$036df532c7faedba$var$JsonWebTokenError.prototype.constructor = $036df532c7faedba$var$JsonWebTokenError;
module.exports = $036df532c7faedba$var$JsonWebTokenError;

});

parcelRegister("63AiW", function(module, exports) {

var $ifPfG = parcelRequire("ifPfG");
var $468f2f34c3d3bd1b$var$NotBeforeError = function(message, date) {
    $ifPfG.call(this, message);
    this.name = 'NotBeforeError';
    this.date = date;
};
$468f2f34c3d3bd1b$var$NotBeforeError.prototype = Object.create($ifPfG.prototype);
$468f2f34c3d3bd1b$var$NotBeforeError.prototype.constructor = $468f2f34c3d3bd1b$var$NotBeforeError;
module.exports = $468f2f34c3d3bd1b$var$NotBeforeError;

});

parcelRegister("bB7TK", function(module, exports) {

var $ifPfG = parcelRequire("ifPfG");
var $871946d0e8877ebe$var$TokenExpiredError = function(message, expiredAt) {
    $ifPfG.call(this, message);
    this.name = 'TokenExpiredError';
    this.expiredAt = expiredAt;
};
$871946d0e8877ebe$var$TokenExpiredError.prototype = Object.create($ifPfG.prototype);
$871946d0e8877ebe$var$TokenExpiredError.prototype.constructor = $871946d0e8877ebe$var$TokenExpiredError;
module.exports = $871946d0e8877ebe$var$TokenExpiredError;

});

parcelRegister("1shls", function(module, exports) {

var $ji0pn = parcelRequire("ji0pn");
module.exports = function(time, iat) {
    var timestamp = iat || Math.floor(Date.now() / 1000);
    if (typeof time === 'string') {
        var milliseconds = $ji0pn(time);
        if (typeof milliseconds === 'undefined') return;
        return Math.floor(timestamp + milliseconds / 1000);
    } else if (typeof time === 'number') return timestamp + time;
    else return;
};

});
parcelRegister("ji0pn", function(module, exports) {
/**
 * Helpers.
 */ var $e0b003d12845a58e$var$s = 1000;
var $e0b003d12845a58e$var$m = $e0b003d12845a58e$var$s * 60;
var $e0b003d12845a58e$var$h = $e0b003d12845a58e$var$m * 60;
var $e0b003d12845a58e$var$d = $e0b003d12845a58e$var$h * 24;
var $e0b003d12845a58e$var$w = $e0b003d12845a58e$var$d * 7;
var $e0b003d12845a58e$var$y = $e0b003d12845a58e$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $e0b003d12845a58e$var$parse(val);
    else if (type === 'number' && isFinite(val)) return options.long ? $e0b003d12845a58e$var$fmtLong(val) : $e0b003d12845a58e$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $e0b003d12845a58e$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $e0b003d12845a58e$var$y;
        case 'weeks':
        case 'week':
        case 'w':
            return n * $e0b003d12845a58e$var$w;
        case 'days':
        case 'day':
        case 'd':
            return n * $e0b003d12845a58e$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $e0b003d12845a58e$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $e0b003d12845a58e$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $e0b003d12845a58e$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $e0b003d12845a58e$var$fmtShort(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $e0b003d12845a58e$var$d) return Math.round(ms / $e0b003d12845a58e$var$d) + 'd';
    if (msAbs >= $e0b003d12845a58e$var$h) return Math.round(ms / $e0b003d12845a58e$var$h) + 'h';
    if (msAbs >= $e0b003d12845a58e$var$m) return Math.round(ms / $e0b003d12845a58e$var$m) + 'm';
    if (msAbs >= $e0b003d12845a58e$var$s) return Math.round(ms / $e0b003d12845a58e$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $e0b003d12845a58e$var$fmtLong(ms) {
    var msAbs = Math.abs(ms);
    if (msAbs >= $e0b003d12845a58e$var$d) return $e0b003d12845a58e$var$plural(ms, msAbs, $e0b003d12845a58e$var$d, 'day');
    if (msAbs >= $e0b003d12845a58e$var$h) return $e0b003d12845a58e$var$plural(ms, msAbs, $e0b003d12845a58e$var$h, 'hour');
    if (msAbs >= $e0b003d12845a58e$var$m) return $e0b003d12845a58e$var$plural(ms, msAbs, $e0b003d12845a58e$var$m, 'minute');
    if (msAbs >= $e0b003d12845a58e$var$s) return $e0b003d12845a58e$var$plural(ms, msAbs, $e0b003d12845a58e$var$s, 'second');
    return ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $e0b003d12845a58e$var$plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}

});


parcelRegister("eOSWc", function(module, exports) {

var $4ZL0H = parcelRequire("4ZL0H");

var $dm5kc = parcelRequire("dm5kc");
module.exports = $dm5kc.satisfies($4ZL0H.version, '^6.12.0 || >=8.0.0');

});
parcelRegister("dm5kc", function(module, exports) {
exports = module.exports = SemVer;
var debug;
debug = function() {};
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';
var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16;
var MAX_SAFE_BUILD_LENGTH = MAX_LENGTH - 6;
// The actual regexps go on exports.re
var re = exports.re = [];
var safeRe = exports.safeRe = [];
var src = exports.src = [];
var R = 0;
var LETTERDASHNUMBER = '[a-zA-Z0-9-]';
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
var safeRegexReplacements = [
    [
        '\\s',
        1
    ],
    [
        '\\d',
        MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        MAX_SAFE_BUILD_LENGTH
    ]
];
function makeSafeRe(value) {
    for(var i = 0; i < safeRegexReplacements.length; i++){
        var token = safeRegexReplacements[i][0];
        var max = safeRegexReplacements[i][1];
        value = value.split(token + '*').join(token + '{0,' + max + '}').split(token + '+').join(token + '{1,' + max + '}');
    }
    return value;
}
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '\\d+';
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-]' + LETTERDASHNUMBER + '*';
// ## Main Version
// Three dot-separated numeric identifiers.
var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' + '(' + src[NUMERICIDENTIFIER] + ')\\.' + '(' + src[NUMERICIDENTIFIER] + ')';
var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' + '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' + '(' + src[NUMERICIDENTIFIERLOOSE] + ')';
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] + '|' + src[NONNUMERICIDENTIFIER] + ')';
var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] + '|' + src[NONNUMERICIDENTIFIER] + ')';
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] + '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';
var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] + '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = LETTERDASHNUMBER + '+';
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] + '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] + src[PRERELEASE] + '?' + src[BUILD] + '?';
src[FULL] = '^' + FULLPLAIN + '$';
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] + src[PRERELEASELOOSE] + '?' + src[BUILD] + '?';
var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';
var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';
var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' + '(?:' + src[PRERELEASE] + ')?' + src[BUILD] + '?' + ')?)?';
var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' + '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' + '(?:' + src[PRERELEASELOOSE] + ')?' + src[BUILD] + '?' + ')?)?';
var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
var COERCE = R++;
src[COERCE] = "(?:^|[^\\d])(\\d{1," + MAX_SAFE_COMPONENT_LENGTH + '})' + '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' + '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' + '(?:$|[^\\d])';
// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';
var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
safeRe[TILDETRIM] = new RegExp(makeSafeRe(src[TILDETRIM]), 'g');
var tildeTrimReplace = '$1~';
var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';
// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';
var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
safeRe[CARETTRIM] = new RegExp(makeSafeRe(src[CARETTRIM]), 'g');
var caretTrimReplace = '$1^';
var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';
// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] + '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';
// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
safeRe[COMPARATORTRIM] = new RegExp(makeSafeRe(src[COMPARATORTRIM]), 'g');
var comparatorTrimReplace = '$1$2$3';
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' + '\\s+-\\s+' + '(' + src[XRANGEPLAIN] + ')' + '\\s*$';
var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' + '\\s+-\\s+' + '(' + src[XRANGEPLAINLOOSE] + ')' + '\\s*$';
// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';
// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for(var i = 0; i < R; i++){
    debug(i, src[i]);
    if (!re[i]) {
        re[i] = new RegExp(src[i]);
        // Replace all greedy whitespace to prevent regex dos issues. These regex are
        // used internally via the safeRe object since all inputs in this library get
        // normalized first to trim and collapse all extra whitespace. The original
        // regexes are exported for userland consumption and lower level usage. A
        // future breaking change could export the safer regex only with a note that
        // all input should have extra whitespace removed.
        safeRe[i] = new RegExp(makeSafeRe(src[i]));
    }
}
exports.parse = parse;
function parse(version, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) return version;
    if (typeof version !== 'string') return null;
    if (version.length > MAX_LENGTH) return null;
    var r = options.loose ? safeRe[LOOSE] : safeRe[FULL];
    if (!r.test(version)) return null;
    try {
        return new SemVer(version, options);
    } catch (er) {
        return null;
    }
}
exports.valid = valid;
function valid(version, options) {
    var v = parse(version, options);
    return v ? v.version : null;
}
exports.clean = clean;
function clean(version, options) {
    var s = parse(version.trim().replace(/^[=v]+/, ''), options);
    return s ? s.version : null;
}
exports.SemVer = SemVer;
function SemVer(version, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (version instanceof SemVer) {
        if (version.loose === options.loose) return version;
        else version = version.version;
    } else if (typeof version !== 'string') throw new TypeError('Invalid Version: ' + version);
    if (version.length > MAX_LENGTH) throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters');
    if (!(this instanceof SemVer)) return new SemVer(version, options);
    debug('SemVer', version, options);
    this.options = options;
    this.loose = !!options.loose;
    var m = version.trim().match(options.loose ? safeRe[LOOSE] : safeRe[FULL]);
    if (!m) throw new TypeError('Invalid Version: ' + version);
    this.raw = version;
    // these are actually numbers
    this.major = +m[1];
    this.minor = +m[2];
    this.patch = +m[3];
    if (this.major > MAX_SAFE_INTEGER || this.major < 0) throw new TypeError('Invalid major version');
    if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError('Invalid minor version');
    if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError('Invalid patch version');
    // numberify any prerelease numeric ids
    if (!m[4]) this.prerelease = [];
    else this.prerelease = m[4].split('.').map(function(id) {
        if (/^[0-9]+$/.test(id)) {
            var num = +id;
            if (num >= 0 && num < MAX_SAFE_INTEGER) return num;
        }
        return id;
    });
    this.build = m[5] ? m[5].split('.') : [];
    this.format();
}
SemVer.prototype.format = function() {
    this.version = this.major + '.' + this.minor + '.' + this.patch;
    if (this.prerelease.length) this.version += '-' + this.prerelease.join('.');
    return this.version;
};
SemVer.prototype.toString = function() {
    return this.version;
};
SemVer.prototype.compare = function(other) {
    debug('SemVer.compare', this.version, this.options, other);
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return this.compareMain(other) || this.comparePre(other);
};
SemVer.prototype.compareMain = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    return compareIdentifiers(this.major, other.major) || compareIdentifiers(this.minor, other.minor) || compareIdentifiers(this.patch, other.patch);
};
SemVer.prototype.comparePre = function(other) {
    if (!(other instanceof SemVer)) other = new SemVer(other, this.options);
    // NOT having a prerelease is > having one
    if (this.prerelease.length && !other.prerelease.length) return -1;
    else if (!this.prerelease.length && other.prerelease.length) return 1;
    else if (!this.prerelease.length && !other.prerelease.length) return 0;
    var i = 0;
    do {
        var a = this.prerelease[i];
        var b = other.prerelease[i];
        debug('prerelease compare', i, a, b);
        if (a === undefined && b === undefined) return 0;
        else if (b === undefined) return 1;
        else if (a === undefined) return -1;
        else if (a === b) continue;
        else return compareIdentifiers(a, b);
    }while (++i);
};
// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
    switch(release){
        case 'premajor':
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor = 0;
            this.major++;
            this.inc('pre', identifier);
            break;
        case 'preminor':
            this.prerelease.length = 0;
            this.patch = 0;
            this.minor++;
            this.inc('pre', identifier);
            break;
        case 'prepatch':
            // If this is already a prerelease, it will bump to the next version
            // drop any prereleases that might already exist, since they are not
            // relevant at this point.
            this.prerelease.length = 0;
            this.inc('patch', identifier);
            this.inc('pre', identifier);
            break;
        // If the input is a non-prerelease version, this acts the same as
        // prepatch.
        case 'prerelease':
            if (this.prerelease.length === 0) this.inc('patch', identifier);
            this.inc('pre', identifier);
            break;
        case 'major':
            // If this is a pre-major version, bump up to the same major version.
            // Otherwise increment major.
            // 1.0.0-5 bumps to 1.0.0
            // 1.1.0 bumps to 2.0.0
            if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
            this.minor = 0;
            this.patch = 0;
            this.prerelease = [];
            break;
        case 'minor':
            // If this is a pre-minor version, bump up to the same minor version.
            // Otherwise increment minor.
            // 1.2.0-5 bumps to 1.2.0
            // 1.2.1 bumps to 1.3.0
            if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
            this.patch = 0;
            this.prerelease = [];
            break;
        case 'patch':
            // If this is not a pre-release version, it will increment the patch.
            // If it is a pre-release it will bump up to the same patch version.
            // 1.2.0-5 patches to 1.2.0
            // 1.2.0 patches to 1.2.1
            if (this.prerelease.length === 0) this.patch++;
            this.prerelease = [];
            break;
        // This probably shouldn't be used publicly.
        // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
        case 'pre':
            if (this.prerelease.length === 0) this.prerelease = [
                0
            ];
            else {
                var i = this.prerelease.length;
                while(--i >= 0)if (typeof this.prerelease[i] === 'number') {
                    this.prerelease[i]++;
                    i = -2;
                }
                if (i === -1) // didn't increment anything
                this.prerelease.push(0);
            }
            if (identifier) {
                // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                if (this.prerelease[0] === identifier) {
                    if (isNaN(this.prerelease[1])) this.prerelease = [
                        identifier,
                        0
                    ];
                } else this.prerelease = [
                    identifier,
                    0
                ];
            }
            break;
        default:
            throw new Error('invalid increment argument: ' + release);
    }
    this.format();
    this.raw = this.version;
    return this;
};
exports.inc = inc;
function inc(version, release, loose, identifier) {
    if (typeof loose === 'string') {
        identifier = loose;
        loose = undefined;
    }
    try {
        return new SemVer(version, loose).inc(release, identifier).version;
    } catch (er) {
        return null;
    }
}
exports.diff = diff;
function diff(version1, version2) {
    if (eq(version1, version2)) return null;
    else {
        var v1 = parse(version1);
        var v2 = parse(version2);
        var prefix = '';
        if (v1.prerelease.length || v2.prerelease.length) {
            prefix = 'pre';
            var defaultResult = 'prerelease';
        }
        for(var key in v1)if (key === 'major' || key === 'minor' || key === 'patch') {
            if (v1[key] !== v2[key]) return prefix + key;
        }
        return defaultResult // may be undefined
        ;
    }
}
exports.compareIdentifiers = compareIdentifiers;
var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
    var anum = numeric.test(a);
    var bnum = numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
}
exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
    return compareIdentifiers(b, a);
}
exports.major = major;
function major(a, loose) {
    return new SemVer(a, loose).major;
}
exports.minor = minor;
function minor(a, loose) {
    return new SemVer(a, loose).minor;
}
exports.patch = patch;
function patch(a, loose) {
    return new SemVer(a, loose).patch;
}
exports.compare = compare;
function compare(a, b, loose) {
    return new SemVer(a, loose).compare(new SemVer(b, loose));
}
exports.compareLoose = compareLoose;
function compareLoose(a, b) {
    return compare(a, b, true);
}
exports.rcompare = rcompare;
function rcompare(a, b, loose) {
    return compare(b, a, loose);
}
exports.sort = sort;
function sort(list, loose) {
    return list.sort(function(a, b) {
        return exports.compare(a, b, loose);
    });
}
exports.rsort = rsort;
function rsort(list, loose) {
    return list.sort(function(a, b) {
        return exports.rcompare(a, b, loose);
    });
}
exports.gt = gt;
function gt(a, b, loose) {
    return compare(a, b, loose) > 0;
}
exports.lt = lt;
function lt(a, b, loose) {
    return compare(a, b, loose) < 0;
}
exports.eq = eq;
function eq(a, b, loose) {
    return compare(a, b, loose) === 0;
}
exports.neq = neq;
function neq(a, b, loose) {
    return compare(a, b, loose) !== 0;
}
exports.gte = gte;
function gte(a, b, loose) {
    return compare(a, b, loose) >= 0;
}
exports.lte = lte;
function lte(a, b, loose) {
    return compare(a, b, loose) <= 0;
}
exports.cmp = cmp;
function cmp(a, op, b, loose) {
    switch(op){
        case '===':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a === b;
        case '!==':
            if (typeof a === 'object') a = a.version;
            if (typeof b === 'object') b = b.version;
            return a !== b;
        case '':
        case '=':
        case '==':
            return eq(a, b, loose);
        case '!=':
            return neq(a, b, loose);
        case '>':
            return gt(a, b, loose);
        case '>=':
            return gte(a, b, loose);
        case '<':
            return lt(a, b, loose);
        case '<=':
            return lte(a, b, loose);
        default:
            throw new TypeError('Invalid operator: ' + op);
    }
}
exports.Comparator = Comparator;
function Comparator(comp, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (comp instanceof Comparator) {
        if (comp.loose === !!options.loose) return comp;
        else comp = comp.value;
    }
    if (!(this instanceof Comparator)) return new Comparator(comp, options);
    comp = comp.trim().split(/\s+/).join(' ');
    debug('comparator', comp, options);
    this.options = options;
    this.loose = !!options.loose;
    this.parse(comp);
    if (this.semver === ANY) this.value = '';
    else this.value = this.operator + this.semver.version;
    debug('comp', this);
}
var ANY = {};
Comparator.prototype.parse = function(comp) {
    var r = this.options.loose ? safeRe[COMPARATORLOOSE] : safeRe[COMPARATOR];
    var m = comp.match(r);
    if (!m) throw new TypeError('Invalid comparator: ' + comp);
    this.operator = m[1];
    if (this.operator === '=') this.operator = '';
    // if it literally is just '>' or '' then allow anything.
    if (!m[2]) this.semver = ANY;
    else this.semver = new SemVer(m[2], this.options.loose);
};
Comparator.prototype.toString = function() {
    return this.value;
};
Comparator.prototype.test = function(version) {
    debug('Comparator.test', version, this.options.loose);
    if (this.semver === ANY) return true;
    if (typeof version === 'string') version = new SemVer(version, this.options);
    return cmp(version, this.operator, this.semver, this.options);
};
Comparator.prototype.intersects = function(comp, options) {
    if (!(comp instanceof Comparator)) throw new TypeError('a Comparator is required');
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    var rangeTmp;
    if (this.operator === '') {
        rangeTmp = new Range(comp.value, options);
        return satisfies(this.value, rangeTmp, options);
    } else if (comp.operator === '') {
        rangeTmp = new Range(this.value, options);
        return satisfies(comp.semver, rangeTmp, options);
    }
    var sameDirectionIncreasing = (this.operator === '>=' || this.operator === '>') && (comp.operator === '>=' || comp.operator === '>');
    var sameDirectionDecreasing = (this.operator === '<=' || this.operator === '<') && (comp.operator === '<=' || comp.operator === '<');
    var sameSemVer = this.semver.version === comp.semver.version;
    var differentDirectionsInclusive = (this.operator === '>=' || this.operator === '<=') && (comp.operator === '>=' || comp.operator === '<=');
    var oppositeDirectionsLessThan = cmp(this.semver, '<', comp.semver, options) && (this.operator === '>=' || this.operator === '>') && (comp.operator === '<=' || comp.operator === '<');
    var oppositeDirectionsGreaterThan = cmp(this.semver, '>', comp.semver, options) && (this.operator === '<=' || this.operator === '<') && (comp.operator === '>=' || comp.operator === '>');
    return sameDirectionIncreasing || sameDirectionDecreasing || sameSemVer && differentDirectionsInclusive || oppositeDirectionsLessThan || oppositeDirectionsGreaterThan;
};
exports.Range = Range;
function Range(range, options) {
    if (!options || typeof options !== 'object') options = {
        loose: !!options,
        includePrerelease: false
    };
    if (range instanceof Range) {
        if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
        else return new Range(range.raw, options);
    }
    if (range instanceof Comparator) return new Range(range.value, options);
    if (!(this instanceof Range)) return new Range(range, options);
    this.options = options;
    this.loose = !!options.loose;
    this.includePrerelease = !!options.includePrerelease;
    // First reduce all whitespace as much as possible so we do not have to rely
    // on potentially slow regexes like \s*. This is then stored and used for
    // future error messages as well.
    this.raw = range.trim().split(/\s+/).join(' ');
    // First, split based on boolean or ||
    this.set = this.raw.split('||').map(function(range) {
        return this.parseRange(range.trim());
    }, this).filter(function(c) {
        // throw out any that are not relevant for whatever reason
        return c.length;
    });
    if (!this.set.length) throw new TypeError('Invalid SemVer Range: ' + this.raw);
    this.format();
}
Range.prototype.format = function() {
    this.range = this.set.map(function(comps) {
        return comps.join(' ').trim();
    }).join('||').trim();
    return this.range;
};
Range.prototype.toString = function() {
    return this.range;
};
Range.prototype.parseRange = function(range) {
    var loose = this.options.loose;
    // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
    var hr = loose ? safeRe[HYPHENRANGELOOSE] : safeRe[HYPHENRANGE];
    range = range.replace(hr, hyphenReplace);
    debug('hyphen replace', range);
    // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
    range = range.replace(safeRe[COMPARATORTRIM], comparatorTrimReplace);
    debug('comparator trim', range, safeRe[COMPARATORTRIM]);
    // `~ 1.2.3` => `~1.2.3`
    range = range.replace(safeRe[TILDETRIM], tildeTrimReplace);
    // `^ 1.2.3` => `^1.2.3`
    range = range.replace(safeRe[CARETTRIM], caretTrimReplace);
    // At this point, the range is completely trimmed and
    // ready to be split into comparators.
    var compRe = loose ? safeRe[COMPARATORLOOSE] : safeRe[COMPARATOR];
    var set = range.split(' ').map(function(comp) {
        return parseComparator(comp, this.options);
    }, this).join(' ').split(/\s+/);
    if (this.options.loose) // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
        return !!comp.match(compRe);
    });
    set = set.map(function(comp) {
        return new Comparator(comp, this.options);
    }, this);
    return set;
};
Range.prototype.intersects = function(range, options) {
    if (!(range instanceof Range)) throw new TypeError('a Range is required');
    return this.set.some(function(thisComparators) {
        return thisComparators.every(function(thisComparator) {
            return range.set.some(function(rangeComparators) {
                return rangeComparators.every(function(rangeComparator) {
                    return thisComparator.intersects(rangeComparator, options);
                });
            });
        });
    });
};
// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, options) {
    return new Range(range, options).set.map(function(comp) {
        return comp.map(function(c) {
            return c.value;
        }).join(' ').trim().split(' ');
    });
}
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, options) {
    debug('comp', comp, options);
    comp = replaceCarets(comp, options);
    debug('caret', comp);
    comp = replaceTildes(comp, options);
    debug('tildes', comp);
    comp = replaceXRanges(comp, options);
    debug('xrange', comp);
    comp = replaceStars(comp, options);
    debug('stars', comp);
    return comp;
}
function isX(id) {
    return !id || id.toLowerCase() === 'x' || id === '*';
}
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceTilde(comp, options);
    }).join(' ');
}
function replaceTilde(comp, options) {
    var r = options.loose ? safeRe[TILDELOOSE] : safeRe[TILDE];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug('tilde', comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
        else if (isX(p)) // ~1.2 == >=1.2.0 <1.3.0
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
        else if (pr) {
            debug('replaceTilde pr', pr);
            ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + M + '.' + (+m + 1) + '.0';
        } else // ~1.2.3 == >=1.2.3 <1.3.0
        ret = '>=' + M + '.' + m + '.' + p + ' <' + M + '.' + (+m + 1) + '.0';
        debug('tilde return', ret);
        return ret;
    });
}
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, options) {
    return comp.trim().split(/\s+/).map(function(comp) {
        return replaceCaret(comp, options);
    }).join(' ');
}
function replaceCaret(comp, options) {
    debug('caret', comp, options);
    var r = options.loose ? safeRe[CARETLOOSE] : safeRe[CARET];
    return comp.replace(r, function(_, M, m, p, pr) {
        debug('caret', comp, _, M, m, p, pr);
        var ret;
        if (isX(M)) ret = '';
        else if (isX(m)) ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
        else if (isX(p)) {
            if (M === '0') ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
            else ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
        } else if (pr) {
            debug('replaceCaret pr', pr);
            if (M === '0') {
                if (m === '0') ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + M + '.' + m + '.' + (+p + 1);
                else ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + M + '.' + (+m + 1) + '.0';
            } else ret = '>=' + M + '.' + m + '.' + p + '-' + pr + ' <' + (+M + 1) + '.0.0';
        } else {
            debug('no pr');
            if (M === '0') {
                if (m === '0') ret = '>=' + M + '.' + m + '.' + p + ' <' + M + '.' + m + '.' + (+p + 1);
                else ret = '>=' + M + '.' + m + '.' + p + ' <' + M + '.' + (+m + 1) + '.0';
            } else ret = '>=' + M + '.' + m + '.' + p + ' <' + (+M + 1) + '.0.0';
        }
        debug('caret return', ret);
        return ret;
    });
}
function replaceXRanges(comp, options) {
    debug('replaceXRanges', comp, options);
    return comp.split(/\s+/).map(function(comp) {
        return replaceXRange(comp, options);
    }).join(' ');
}
function replaceXRange(comp, options) {
    comp = comp.trim();
    var r = options.loose ? safeRe[XRANGELOOSE] : safeRe[XRANGE];
    return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
        debug('xRange', comp, ret, gtlt, M, m, p, pr);
        var xM = isX(M);
        var xm = xM || isX(m);
        var xp = xm || isX(p);
        var anyX = xp;
        if (gtlt === '=' && anyX) gtlt = '';
        if (xM) {
            if (gtlt === '>' || gtlt === '<') // nothing is allowed
            ret = '<0.0.0';
            else // nothing is forbidden
            ret = '*';
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === '>') {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                // >1.2.3 => >= 1.2.4
                gtlt = '>=';
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === '<=') {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = '<';
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            ret = gtlt + M + '.' + m + '.' + p;
        } else if (xm) ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
        else if (xp) ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
        debug('xRange return', ret);
        return ret;
    });
}
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, options) {
    debug('replaceStars', comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace(safeRe[STAR], '');
}
// This function is passed to string.replace(safeRe[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr, tb) {
    if (isX(fM)) from = '';
    else if (isX(fm)) from = '>=' + fM + '.0.0';
    else if (isX(fp)) from = '>=' + fM + '.' + fm + '.0';
    else from = '>=' + from;
    if (isX(tM)) to = '';
    else if (isX(tm)) to = '<' + (+tM + 1) + '.0.0';
    else if (isX(tp)) to = '<' + tM + '.' + (+tm + 1) + '.0';
    else if (tpr) to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
    else to = '<=' + to;
    return (from + ' ' + to).trim();
}
// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
    if (!version) return false;
    if (typeof version === 'string') version = new SemVer(version, this.options);
    for(var i = 0; i < this.set.length; i++){
        if (testSet(this.set[i], version, this.options)) return true;
    }
    return false;
};
function testSet(set, version, options) {
    for(var i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(i = 0; i < set.length; i++){
            debug(set[i].semver);
            if (set[i].semver === ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                var allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
}
exports.satisfies = satisfies;
function satisfies(version, range, options) {
    try {
        range = new Range(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
}
exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, options) {
    var max = null;
    var maxSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new SemVer(max, options);
            }
        }
    });
    return max;
}
exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, options) {
    var min = null;
    var minSV = null;
    try {
        var rangeObj = new Range(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach(function(v) {
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new SemVer(min, options);
            }
        }
    });
    return min;
}
exports.minVersion = minVersion;
function minVersion(range, loose) {
    range = new Range(range, loose);
    var minver = new SemVer('0.0.0');
    if (range.test(minver)) return minver;
    minver = new SemVer('0.0.0-0');
    if (range.test(minver)) return minver;
    minver = null;
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        comparators.forEach(function(comparator) {
            // Clone to avoid manipulating the comparator's semver object.
            var compver = new SemVer(comparator.semver.version);
            switch(comparator.operator){
                case '>':
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case '':
                case '>=':
                    if (!minver || gt(minver, compver)) minver = compver;
                    break;
                case '<':
                case '<=':
                    break;
                /* istanbul ignore next */ default:
                    throw new Error('Unexpected operation: ' + comparator.operator);
            }
        });
    }
    if (minver && range.test(minver)) return minver;
    return null;
}
exports.validRange = validRange;
function validRange(range, options) {
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new Range(range, options).range || '*';
    } catch (er) {
        return null;
    }
}
// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, options) {
    return outside(version, range, '<', options);
}
// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, options) {
    return outside(version, range, '>', options);
}
exports.outside = outside;
function outside(version, range, hilo, options) {
    version = new SemVer(version, options);
    range = new Range(range, options);
    var gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case '>':
            gtfn = gt;
            ltefn = lte;
            ltfn = lt;
            comp = '>';
            ecomp = '>=';
            break;
        case '<':
            gtfn = lt;
            ltefn = gte;
            ltfn = gt;
            comp = '<';
            ecomp = '<=';
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisifes the range it is not outside
    if (satisfies(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(var i = 0; i < range.set.length; ++i){
        var comparators = range.set[i];
        var high = null;
        var low = null;
        comparators.forEach(function(comparator) {
            if (comparator.semver === ANY) comparator = new Comparator('>=0.0.0');
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
}
exports.prerelease = prerelease;
function prerelease(version, options) {
    var parsed = parse(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
}
exports.intersects = intersects;
function intersects(r1, r2, options) {
    r1 = new Range(r1, options);
    r2 = new Range(r2, options);
    return r1.intersects(r2);
}
exports.coerce = coerce;
function coerce(version) {
    if (version instanceof SemVer) return version;
    if (typeof version !== 'string') return null;
    var match = version.match(safeRe[COERCE]);
    if (match == null) return null;
    return parse(match[1] + '.' + (match[2] || '0') + '.' + (match[3] || '0'));
}

});



parcelRegister("6Grea", function(module, exports) {

var $bdjQ6 = parcelRequire("bdjQ6");
var $4ddbc922f182ce54$require$Buffer = $bdjQ6.Buffer;

var $1shls = parcelRequire("1shls");

var $eOSWc = parcelRequire("eOSWc");

var $ihqFb = parcelRequire("ihqFb");

var $5EnhC = parcelRequire("5EnhC");

var $fPqc4 = parcelRequire("fPqc4");

var $3hU0A = parcelRequire("3hU0A");

var $iXTVJ = parcelRequire("iXTVJ");

var $jt7gQ = parcelRequire("jt7gQ");

var $gSPry = parcelRequire("gSPry");

var $kOJaT = parcelRequire("kOJaT");
var $4ddbc922f182ce54$var$SUPPORTED_ALGS = [
    'RS256',
    'RS384',
    'RS512',
    'ES256',
    'ES384',
    'ES512',
    'HS256',
    'HS384',
    'HS512',
    'none'
];
if ($eOSWc) $4ddbc922f182ce54$var$SUPPORTED_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
var $4ddbc922f182ce54$var$sign_options_schema = {
    expiresIn: {
        isValid: function(value) {
            return $3hU0A(value) || $gSPry(value) && value;
        },
        message: '"expiresIn" should be a number of seconds or string representing a timespan'
    },
    notBefore: {
        isValid: function(value) {
            return $3hU0A(value) || $gSPry(value) && value;
        },
        message: '"notBefore" should be a number of seconds or string representing a timespan'
    },
    audience: {
        isValid: function(value) {
            return $gSPry(value) || Array.isArray(value);
        },
        message: '"audience" must be a string or array'
    },
    algorithm: {
        isValid: $5EnhC.bind(null, $4ddbc922f182ce54$var$SUPPORTED_ALGS),
        message: '"algorithm" must be a valid string enum value'
    },
    header: {
        isValid: $jt7gQ,
        message: '"header" must be an object'
    },
    encoding: {
        isValid: $gSPry,
        message: '"encoding" must be a string'
    },
    issuer: {
        isValid: $gSPry,
        message: '"issuer" must be a string'
    },
    subject: {
        isValid: $gSPry,
        message: '"subject" must be a string'
    },
    jwtid: {
        isValid: $gSPry,
        message: '"jwtid" must be a string'
    },
    noTimestamp: {
        isValid: $fPqc4,
        message: '"noTimestamp" must be a boolean'
    },
    keyid: {
        isValid: $gSPry,
        message: '"keyid" must be a string'
    },
    mutatePayload: {
        isValid: $fPqc4,
        message: '"mutatePayload" must be a boolean'
    }
};
var $4ddbc922f182ce54$var$registered_claims_schema = {
    iat: {
        isValid: $iXTVJ,
        message: '"iat" should be a number of seconds'
    },
    exp: {
        isValid: $iXTVJ,
        message: '"exp" should be a number of seconds'
    },
    nbf: {
        isValid: $iXTVJ,
        message: '"nbf" should be a number of seconds'
    }
};
function $4ddbc922f182ce54$var$validate(schema, allowUnknown, object, parameterName) {
    if (!$jt7gQ(object)) throw new Error('Expected "' + parameterName + '" to be a plain object.');
    Object.keys(object).forEach(function(key) {
        var validator = schema[key];
        if (!validator) {
            if (!allowUnknown) throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
            return;
        }
        if (!validator.isValid(object[key])) throw new Error(validator.message);
    });
}
function $4ddbc922f182ce54$var$validateOptions(options) {
    return $4ddbc922f182ce54$var$validate($4ddbc922f182ce54$var$sign_options_schema, false, options, 'options');
}
function $4ddbc922f182ce54$var$validatePayload(payload) {
    return $4ddbc922f182ce54$var$validate($4ddbc922f182ce54$var$registered_claims_schema, true, payload, 'payload');
}
var $4ddbc922f182ce54$var$options_to_payload = {
    'audience': 'aud',
    'issuer': 'iss',
    'subject': 'sub',
    'jwtid': 'jti'
};
var $4ddbc922f182ce54$var$options_for_objects = [
    'expiresIn',
    'notBefore',
    'noTimestamp',
    'audience',
    'issuer',
    'subject',
    'jwtid'
];
module.exports = function(payload, secretOrPrivateKey, options, callback) {
    if (typeof options === 'function') {
        callback = options;
        options = {};
    } else options = options || {};
    var isObjectPayload = typeof payload === 'object' && !$4ddbc922f182ce54$require$Buffer.isBuffer(payload);
    var header = Object.assign({
        alg: options.algorithm || 'HS256',
        typ: isObjectPayload ? 'JWT' : undefined,
        kid: options.keyid
    }, options.header);
    function failure(err) {
        if (callback) return callback(err);
        throw err;
    }
    if (!secretOrPrivateKey && options.algorithm !== 'none') return failure(new Error('secretOrPrivateKey must have a value'));
    if (typeof payload === 'undefined') return failure(new Error('payload is required'));
    else if (isObjectPayload) {
        try {
            $4ddbc922f182ce54$var$validatePayload(payload);
        } catch (error) {
            return failure(error);
        }
        if (!options.mutatePayload) payload = Object.assign({}, payload);
    } else {
        var invalid_options = $4ddbc922f182ce54$var$options_for_objects.filter(function(opt) {
            return typeof options[opt] !== 'undefined';
        });
        if (invalid_options.length > 0) return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + typeof payload + ' payload'));
    }
    if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
    if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
    try {
        $4ddbc922f182ce54$var$validateOptions(options);
    } catch (error) {
        return failure(error);
    }
    var timestamp = payload.iat || Math.floor(Date.now() / 1000);
    if (options.noTimestamp) delete payload.iat;
    else if (isObjectPayload) payload.iat = timestamp;
    if (typeof options.notBefore !== 'undefined') {
        try {
            payload.nbf = $1shls(options.notBefore, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.nbf === 'undefined') return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
        try {
            payload.exp = $1shls(options.expiresIn, timestamp);
        } catch (err) {
            return failure(err);
        }
        if (typeof payload.exp === 'undefined') return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
    Object.keys($4ddbc922f182ce54$var$options_to_payload).forEach(function(key) {
        var claim = $4ddbc922f182ce54$var$options_to_payload[key];
        if (typeof options[key] !== 'undefined') {
            if (typeof payload[claim] !== 'undefined') return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
            payload[claim] = options[key];
        }
    });
    var encoding = options.encoding || 'utf8';
    if (typeof callback === 'function') {
        callback = callback && $kOJaT(callback);
        $ihqFb.createSign({
            header: header,
            privateKey: secretOrPrivateKey,
            payload: payload,
            encoding: encoding
        }).once('error', callback).once('done', function(signature) {
            callback(null, signature);
        });
    } else return $ihqFb.sign({
        header: header,
        payload: payload,
        secret: secretOrPrivateKey,
        encoding: encoding
    });
};

});
parcelRegister("5EnhC", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $41d2bfbf13644492$var$INFINITY = 1 / 0, $41d2bfbf13644492$var$MAX_SAFE_INTEGER = 9007199254740991, $41d2bfbf13644492$var$MAX_INTEGER = 1.7976931348623157e+308, $41d2bfbf13644492$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $41d2bfbf13644492$var$argsTag = '[object Arguments]', $41d2bfbf13644492$var$funcTag = '[object Function]', $41d2bfbf13644492$var$genTag = '[object GeneratorFunction]', $41d2bfbf13644492$var$stringTag = '[object String]', $41d2bfbf13644492$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $41d2bfbf13644492$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $41d2bfbf13644492$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $41d2bfbf13644492$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $41d2bfbf13644492$var$reIsOctal = /^0o[0-7]+$/i;
/** Used to detect unsigned integer values. */ var $41d2bfbf13644492$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/** Built-in method references without a dependency on `root`. */ var $41d2bfbf13644492$var$freeParseInt = parseInt;
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $41d2bfbf13644492$var$arrayMap(array, iteratee) {
    var index = -1, length = array ? array.length : 0, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $41d2bfbf13644492$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $41d2bfbf13644492$var$baseIndexOf(array, value, fromIndex) {
    if (value !== value) return $41d2bfbf13644492$var$baseFindIndex(array, $41d2bfbf13644492$var$baseIsNaN, fromIndex);
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $41d2bfbf13644492$var$baseIsNaN(value) {
    return value !== value;
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $41d2bfbf13644492$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */ function $41d2bfbf13644492$var$baseValues(object, props) {
    return $41d2bfbf13644492$var$arrayMap(props, function(key) {
        return object[key];
    });
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $41d2bfbf13644492$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $41d2bfbf13644492$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $41d2bfbf13644492$var$hasOwnProperty = $41d2bfbf13644492$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $41d2bfbf13644492$var$objectToString = $41d2bfbf13644492$var$objectProto.toString;
/** Built-in value references. */ var $41d2bfbf13644492$var$propertyIsEnumerable = $41d2bfbf13644492$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $41d2bfbf13644492$var$nativeKeys = $41d2bfbf13644492$var$overArg(Object.keys, Object), $41d2bfbf13644492$var$nativeMax = Math.max;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $41d2bfbf13644492$var$arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = $41d2bfbf13644492$var$isArray(value) || $41d2bfbf13644492$var$isArguments(value) ? $41d2bfbf13644492$var$baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || $41d2bfbf13644492$var$hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || $41d2bfbf13644492$var$isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $41d2bfbf13644492$var$baseKeys(object) {
    if (!$41d2bfbf13644492$var$isPrototype(object)) return $41d2bfbf13644492$var$nativeKeys(object);
    var result = [];
    for(var key in Object(object))if ($41d2bfbf13644492$var$hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $41d2bfbf13644492$var$isIndex(value, length) {
    length = length == null ? $41d2bfbf13644492$var$MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == 'number' || $41d2bfbf13644492$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $41d2bfbf13644492$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || $41d2bfbf13644492$var$objectProto;
    return value === proto;
}
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $41d2bfbf13644492$var$includes(collection, value, fromIndex, guard) {
    collection = $41d2bfbf13644492$var$isArrayLike(collection) ? collection : $41d2bfbf13644492$var$values(collection);
    fromIndex = fromIndex && !guard ? $41d2bfbf13644492$var$toInteger(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $41d2bfbf13644492$var$nativeMax(length + fromIndex, 0);
    return $41d2bfbf13644492$var$isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $41d2bfbf13644492$var$baseIndexOf(collection, value, fromIndex) > -1;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function $41d2bfbf13644492$var$isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return $41d2bfbf13644492$var$isArrayLikeObject(value) && $41d2bfbf13644492$var$hasOwnProperty.call(value, 'callee') && (!$41d2bfbf13644492$var$propertyIsEnumerable.call(value, 'callee') || $41d2bfbf13644492$var$objectToString.call(value) == $41d2bfbf13644492$var$argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $41d2bfbf13644492$var$isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $41d2bfbf13644492$var$isArrayLike(value) {
    return value != null && $41d2bfbf13644492$var$isLength(value.length) && !$41d2bfbf13644492$var$isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $41d2bfbf13644492$var$isArrayLikeObject(value) {
    return $41d2bfbf13644492$var$isObjectLike(value) && $41d2bfbf13644492$var$isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $41d2bfbf13644492$var$isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = $41d2bfbf13644492$var$isObject(value) ? $41d2bfbf13644492$var$objectToString.call(value) : '';
    return tag == $41d2bfbf13644492$var$funcTag || tag == $41d2bfbf13644492$var$genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $41d2bfbf13644492$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $41d2bfbf13644492$var$MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $41d2bfbf13644492$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $41d2bfbf13644492$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $41d2bfbf13644492$var$isString(value) {
    return typeof value == 'string' || !$41d2bfbf13644492$var$isArray(value) && $41d2bfbf13644492$var$isObjectLike(value) && $41d2bfbf13644492$var$objectToString.call(value) == $41d2bfbf13644492$var$stringTag;
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $41d2bfbf13644492$var$isSymbol(value) {
    return typeof value == 'symbol' || $41d2bfbf13644492$var$isObjectLike(value) && $41d2bfbf13644492$var$objectToString.call(value) == $41d2bfbf13644492$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $41d2bfbf13644492$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $41d2bfbf13644492$var$toNumber(value);
    if (value === $41d2bfbf13644492$var$INFINITY || value === -$41d2bfbf13644492$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $41d2bfbf13644492$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $41d2bfbf13644492$var$toInteger(value) {
    var result = $41d2bfbf13644492$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $41d2bfbf13644492$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($41d2bfbf13644492$var$isSymbol(value)) return $41d2bfbf13644492$var$NAN;
    if ($41d2bfbf13644492$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $41d2bfbf13644492$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($41d2bfbf13644492$var$reTrim, '');
    var isBinary = $41d2bfbf13644492$var$reIsBinary.test(value);
    return isBinary || $41d2bfbf13644492$var$reIsOctal.test(value) ? $41d2bfbf13644492$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $41d2bfbf13644492$var$reIsBadHex.test(value) ? $41d2bfbf13644492$var$NAN : +value;
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $41d2bfbf13644492$var$keys(object) {
    return $41d2bfbf13644492$var$isArrayLike(object) ? $41d2bfbf13644492$var$arrayLikeKeys(object) : $41d2bfbf13644492$var$baseKeys(object);
}
/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */ function $41d2bfbf13644492$var$values(object) {
    return object ? $41d2bfbf13644492$var$baseValues(object, $41d2bfbf13644492$var$keys(object)) : [];
}
module.exports = $41d2bfbf13644492$var$includes;

});

parcelRegister("fPqc4", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $b85feff69e3fdd99$var$boolTag = '[object Boolean]';
/** Used for built-in method references. */ var $b85feff69e3fdd99$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b85feff69e3fdd99$var$objectToString = $b85feff69e3fdd99$var$objectProto.toString;
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $b85feff69e3fdd99$var$isBoolean(value) {
    return value === true || value === false || $b85feff69e3fdd99$var$isObjectLike(value) && $b85feff69e3fdd99$var$objectToString.call(value) == $b85feff69e3fdd99$var$boolTag;
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $b85feff69e3fdd99$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
module.exports = $b85feff69e3fdd99$var$isBoolean;

});

parcelRegister("3hU0A", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var $264e67be8f3841d1$var$INFINITY = 1 / 0, $264e67be8f3841d1$var$MAX_INTEGER = 1.7976931348623157e+308, $264e67be8f3841d1$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $264e67be8f3841d1$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $264e67be8f3841d1$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $264e67be8f3841d1$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $264e67be8f3841d1$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $264e67be8f3841d1$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $264e67be8f3841d1$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $264e67be8f3841d1$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $264e67be8f3841d1$var$objectToString = $264e67be8f3841d1$var$objectProto.toString;
/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */ function $264e67be8f3841d1$var$isInteger(value) {
    return typeof value == 'number' && value == $264e67be8f3841d1$var$toInteger(value);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $264e67be8f3841d1$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $264e67be8f3841d1$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $264e67be8f3841d1$var$isSymbol(value) {
    return typeof value == 'symbol' || $264e67be8f3841d1$var$isObjectLike(value) && $264e67be8f3841d1$var$objectToString.call(value) == $264e67be8f3841d1$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $264e67be8f3841d1$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $264e67be8f3841d1$var$toNumber(value);
    if (value === $264e67be8f3841d1$var$INFINITY || value === -$264e67be8f3841d1$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $264e67be8f3841d1$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $264e67be8f3841d1$var$toInteger(value) {
    var result = $264e67be8f3841d1$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $264e67be8f3841d1$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($264e67be8f3841d1$var$isSymbol(value)) return $264e67be8f3841d1$var$NAN;
    if ($264e67be8f3841d1$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $264e67be8f3841d1$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($264e67be8f3841d1$var$reTrim, '');
    var isBinary = $264e67be8f3841d1$var$reIsBinary.test(value);
    return isBinary || $264e67be8f3841d1$var$reIsOctal.test(value) ? $264e67be8f3841d1$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $264e67be8f3841d1$var$reIsBadHex.test(value) ? $264e67be8f3841d1$var$NAN : +value;
}
module.exports = $264e67be8f3841d1$var$isInteger;

});

parcelRegister("iXTVJ", function(module, exports) {
/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $dce91f3cbf3cc0bf$var$numberTag = '[object Number]';
/** Used for built-in method references. */ var $dce91f3cbf3cc0bf$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $dce91f3cbf3cc0bf$var$objectToString = $dce91f3cbf3cc0bf$var$objectProto.toString;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $dce91f3cbf3cc0bf$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $dce91f3cbf3cc0bf$var$isNumber(value) {
    return typeof value == 'number' || $dce91f3cbf3cc0bf$var$isObjectLike(value) && $dce91f3cbf3cc0bf$var$objectToString.call(value) == $dce91f3cbf3cc0bf$var$numberTag;
}
module.exports = $dce91f3cbf3cc0bf$var$isNumber;

});

parcelRegister("jt7gQ", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $03a85c59201b119a$var$objectTag = '[object Object]';
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $03a85c59201b119a$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != 'function') try {
        result = !!(value + '');
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $03a85c59201b119a$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $03a85c59201b119a$var$funcProto = Function.prototype, $03a85c59201b119a$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $03a85c59201b119a$var$funcToString = $03a85c59201b119a$var$funcProto.toString;
/** Used to check objects for own properties. */ var $03a85c59201b119a$var$hasOwnProperty = $03a85c59201b119a$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $03a85c59201b119a$var$objectCtorString = $03a85c59201b119a$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $03a85c59201b119a$var$objectToString = $03a85c59201b119a$var$objectProto.toString;
/** Built-in value references. */ var $03a85c59201b119a$var$getPrototype = $03a85c59201b119a$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $03a85c59201b119a$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $03a85c59201b119a$var$isPlainObject(value) {
    if (!$03a85c59201b119a$var$isObjectLike(value) || $03a85c59201b119a$var$objectToString.call(value) != $03a85c59201b119a$var$objectTag || $03a85c59201b119a$var$isHostObject(value)) return false;
    var proto = $03a85c59201b119a$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $03a85c59201b119a$var$hasOwnProperty.call(proto, 'constructor') && proto.constructor;
    return typeof Ctor == 'function' && Ctor instanceof Ctor && $03a85c59201b119a$var$funcToString.call(Ctor) == $03a85c59201b119a$var$objectCtorString;
}
module.exports = $03a85c59201b119a$var$isPlainObject;

});

parcelRegister("gSPry", function(module, exports) {
/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /** `Object#toString` result references. */ var $c4a998130330480e$var$stringTag = '[object String]';
/** Used for built-in method references. */ var $c4a998130330480e$var$objectProto = Object.prototype;
/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */ var $c4a998130330480e$var$objectToString = $c4a998130330480e$var$objectProto.toString;
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $c4a998130330480e$var$isArray = Array.isArray;
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $c4a998130330480e$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $c4a998130330480e$var$isString(value) {
    return typeof value == 'string' || !$c4a998130330480e$var$isArray(value) && $c4a998130330480e$var$isObjectLike(value) && $c4a998130330480e$var$objectToString.call(value) == $c4a998130330480e$var$stringTag;
}
module.exports = $c4a998130330480e$var$isString;

});

parcelRegister("kOJaT", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $f27b84ee56edb271$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $f27b84ee56edb271$var$INFINITY = 1 / 0, $f27b84ee56edb271$var$MAX_INTEGER = 1.7976931348623157e+308, $f27b84ee56edb271$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $f27b84ee56edb271$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $f27b84ee56edb271$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $f27b84ee56edb271$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $f27b84ee56edb271$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $f27b84ee56edb271$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $f27b84ee56edb271$var$freeParseInt = parseInt;
/** Used for built-in method references. */ var $f27b84ee56edb271$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $f27b84ee56edb271$var$objectToString = $f27b84ee56edb271$var$objectProto.toString;
/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */ function $f27b84ee56edb271$var$before(n, func) {
    var result;
    if (typeof func != 'function') throw new TypeError($f27b84ee56edb271$var$FUNC_ERROR_TEXT);
    n = $f27b84ee56edb271$var$toInteger(n);
    return function() {
        if (--n > 0) result = func.apply(this, arguments);
        if (n <= 1) func = undefined;
        return result;
    };
}
/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */ function $f27b84ee56edb271$var$once(func) {
    return $f27b84ee56edb271$var$before(2, func);
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $f27b84ee56edb271$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $f27b84ee56edb271$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $f27b84ee56edb271$var$isSymbol(value) {
    return typeof value == 'symbol' || $f27b84ee56edb271$var$isObjectLike(value) && $f27b84ee56edb271$var$objectToString.call(value) == $f27b84ee56edb271$var$symbolTag;
}
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $f27b84ee56edb271$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $f27b84ee56edb271$var$toNumber(value);
    if (value === $f27b84ee56edb271$var$INFINITY || value === -$f27b84ee56edb271$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $f27b84ee56edb271$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $f27b84ee56edb271$var$toInteger(value) {
    var result = $f27b84ee56edb271$var$toFinite(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $f27b84ee56edb271$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($f27b84ee56edb271$var$isSymbol(value)) return $f27b84ee56edb271$var$NAN;
    if ($f27b84ee56edb271$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $f27b84ee56edb271$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($f27b84ee56edb271$var$reTrim, '');
    var isBinary = $f27b84ee56edb271$var$reIsBinary.test(value);
    return isBinary || $f27b84ee56edb271$var$reIsOctal.test(value) ? $f27b84ee56edb271$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $f27b84ee56edb271$var$reIsBadHex.test(value) ? $f27b84ee56edb271$var$NAN : +value;
}
module.exports = $f27b84ee56edb271$var$once;

});


parcelRegister("iDep4", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7KQqJ = parcelRequire("7KQqJ");
function $d9070abd96403449$var$emptyFunction() {}
function $d9070abd96403449$var$emptyFunctionWithReset() {}
$d9070abd96403449$var$emptyFunctionWithReset.resetWarningCache = $d9070abd96403449$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7KQqJ) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $d9070abd96403449$var$emptyFunctionWithReset,
        resetWarningCache: $d9070abd96403449$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7KQqJ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5a557fcd99e4c0a9$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5a557fcd99e4c0a9$var$ReactPropTypesSecret;

});


parcelRegister("45MkT", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", function () { return $2fad1f91101d4119$export$a7c73072b1a182ae; }, function (v) { return $2fad1f91101d4119$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $2fad1f91101d4119$export$9f27bc3417b4524d; }, function (v) { return $2fad1f91101d4119$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $2fad1f91101d4119$export$db77ccec0bb4ccac; }, function (v) { return $2fad1f91101d4119$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $2fad1f91101d4119$export$8392c0c9d3dcbd35; }, function (v) { return $2fad1f91101d4119$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $2fad1f91101d4119$export$ffb0004e005737fa; }, function (v) { return $2fad1f91101d4119$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $2fad1f91101d4119$export$b624eff549462981; }, function (v) { return $2fad1f91101d4119$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $2fad1f91101d4119$export$7897aa7841a5380c; }, function (v) { return $2fad1f91101d4119$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $2fad1f91101d4119$export$602eac185826482c; }, function (v) { return $2fad1f91101d4119$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $2fad1f91101d4119$export$e2c29f18771995cb; }, function (v) { return $2fad1f91101d4119$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $2fad1f91101d4119$export$5f8d39834fd61797; }, function (v) { return $2fad1f91101d4119$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $2fad1f91101d4119$export$74bf444e3cd11ea5; }, function (v) { return $2fad1f91101d4119$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $2fad1f91101d4119$export$92387174baf9b227; }, function (v) { return $2fad1f91101d4119$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $2fad1f91101d4119$export$ec112efeb987d9c6; }, function (v) { return $2fad1f91101d4119$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $2fad1f91101d4119$export$b706b080d889d2c9; }, function (v) { return $2fad1f91101d4119$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $2fad1f91101d4119$export$5be5a87408f70ddc; }, function (v) { return $2fad1f91101d4119$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $2fad1f91101d4119$export$45a5e7f76e0caa8d; }, function (v) { return $2fad1f91101d4119$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $2fad1f91101d4119$export$455c2e768291efa6; }, function (v) { return $2fad1f91101d4119$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $2fad1f91101d4119$export$9522e17588c12572; }, function (v) { return $2fad1f91101d4119$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $2fad1f91101d4119$export$2110ac352bb060b9; }, function (v) { return $2fad1f91101d4119$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $2fad1f91101d4119$export$56885ab8b9c456ab; }, function (v) { return $2fad1f91101d4119$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $2fad1f91101d4119$export$d927fcb6adf8f9de; }, function (v) { return $2fad1f91101d4119$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $2fad1f91101d4119$export$b82d16f27459e05a; }, function (v) { return $2fad1f91101d4119$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $2fad1f91101d4119$export$522c17b4f5e123e8; }, function (v) { return $2fad1f91101d4119$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $2fad1f91101d4119$export$1aabd8a0274ecfd6; }, function (v) { return $2fad1f91101d4119$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $2fad1f91101d4119$export$9b621391a187a31a; }, function (v) { return $2fad1f91101d4119$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $2fad1f91101d4119$export$f5bbd400c2f4426f; }, function (v) { return $2fad1f91101d4119$export$f5bbd400c2f4426f = v; });
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2fad1f91101d4119$export$a7c73072b1a182ae;
var $2fad1f91101d4119$export$9f27bc3417b4524d;
var $2fad1f91101d4119$export$db77ccec0bb4ccac;
var $2fad1f91101d4119$export$8392c0c9d3dcbd35;
var $2fad1f91101d4119$export$ffb0004e005737fa;
var $2fad1f91101d4119$export$b624eff549462981;
var $2fad1f91101d4119$export$7897aa7841a5380c;
var $2fad1f91101d4119$export$602eac185826482c;
var $2fad1f91101d4119$export$e2c29f18771995cb;
var $2fad1f91101d4119$export$5f8d39834fd61797;
var $2fad1f91101d4119$export$74bf444e3cd11ea5;
var $2fad1f91101d4119$export$92387174baf9b227;
var $2fad1f91101d4119$export$ec112efeb987d9c6;
var $2fad1f91101d4119$export$b706b080d889d2c9;
var $2fad1f91101d4119$export$5be5a87408f70ddc;
var $2fad1f91101d4119$export$45a5e7f76e0caa8d;
var $2fad1f91101d4119$export$455c2e768291efa6;
var $2fad1f91101d4119$export$9522e17588c12572;
var $2fad1f91101d4119$export$2110ac352bb060b9;
var $2fad1f91101d4119$export$56885ab8b9c456ab;
var $2fad1f91101d4119$export$d927fcb6adf8f9de;
var $2fad1f91101d4119$export$b82d16f27459e05a;
var $2fad1f91101d4119$export$522c17b4f5e123e8;
var $2fad1f91101d4119$export$1aabd8a0274ecfd6;
var $2fad1f91101d4119$export$9b621391a187a31a;
var $2fad1f91101d4119$export$f5bbd400c2f4426f;
'use strict';
var $2fad1f91101d4119$var$b = 60103, $2fad1f91101d4119$var$c = 60106, $2fad1f91101d4119$var$d = 60107, $2fad1f91101d4119$var$e = 60108, $2fad1f91101d4119$var$f = 60114, $2fad1f91101d4119$var$g = 60109, $2fad1f91101d4119$var$h = 60110, $2fad1f91101d4119$var$k = 60112, $2fad1f91101d4119$var$l = 60113, $2fad1f91101d4119$var$m = 60120, $2fad1f91101d4119$var$n = 60115, $2fad1f91101d4119$var$p = 60116, $2fad1f91101d4119$var$q = 60121, $2fad1f91101d4119$var$r = 60122, $2fad1f91101d4119$var$u = 60117, $2fad1f91101d4119$var$v = 60129, $2fad1f91101d4119$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $2fad1f91101d4119$var$x = Symbol.for;
    $2fad1f91101d4119$var$b = $2fad1f91101d4119$var$x("react.element");
    $2fad1f91101d4119$var$c = $2fad1f91101d4119$var$x("react.portal");
    $2fad1f91101d4119$var$d = $2fad1f91101d4119$var$x("react.fragment");
    $2fad1f91101d4119$var$e = $2fad1f91101d4119$var$x("react.strict_mode");
    $2fad1f91101d4119$var$f = $2fad1f91101d4119$var$x("react.profiler");
    $2fad1f91101d4119$var$g = $2fad1f91101d4119$var$x("react.provider");
    $2fad1f91101d4119$var$h = $2fad1f91101d4119$var$x("react.context");
    $2fad1f91101d4119$var$k = $2fad1f91101d4119$var$x("react.forward_ref");
    $2fad1f91101d4119$var$l = $2fad1f91101d4119$var$x("react.suspense");
    $2fad1f91101d4119$var$m = $2fad1f91101d4119$var$x("react.suspense_list");
    $2fad1f91101d4119$var$n = $2fad1f91101d4119$var$x("react.memo");
    $2fad1f91101d4119$var$p = $2fad1f91101d4119$var$x("react.lazy");
    $2fad1f91101d4119$var$q = $2fad1f91101d4119$var$x("react.block");
    $2fad1f91101d4119$var$r = $2fad1f91101d4119$var$x("react.server.block");
    $2fad1f91101d4119$var$u = $2fad1f91101d4119$var$x("react.fundamental");
    $2fad1f91101d4119$var$v = $2fad1f91101d4119$var$x("react.debug_trace_mode");
    $2fad1f91101d4119$var$w = $2fad1f91101d4119$var$x("react.legacy_hidden");
}
function $2fad1f91101d4119$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $2fad1f91101d4119$var$b:
                switch(a = a.type, a){
                    case $2fad1f91101d4119$var$d:
                    case $2fad1f91101d4119$var$f:
                    case $2fad1f91101d4119$var$e:
                    case $2fad1f91101d4119$var$l:
                    case $2fad1f91101d4119$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2fad1f91101d4119$var$h:
                            case $2fad1f91101d4119$var$k:
                            case $2fad1f91101d4119$var$p:
                            case $2fad1f91101d4119$var$n:
                            case $2fad1f91101d4119$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $2fad1f91101d4119$var$c:
                return t;
        }
    }
}
var $2fad1f91101d4119$var$z = $2fad1f91101d4119$var$g, $2fad1f91101d4119$var$A = $2fad1f91101d4119$var$b, $2fad1f91101d4119$var$B = $2fad1f91101d4119$var$k, $2fad1f91101d4119$var$C = $2fad1f91101d4119$var$d, $2fad1f91101d4119$var$D = $2fad1f91101d4119$var$p, $2fad1f91101d4119$var$E = $2fad1f91101d4119$var$n, $2fad1f91101d4119$var$F = $2fad1f91101d4119$var$c, $2fad1f91101d4119$var$G = $2fad1f91101d4119$var$f, $2fad1f91101d4119$var$H = $2fad1f91101d4119$var$e, $2fad1f91101d4119$var$I = $2fad1f91101d4119$var$l;
$2fad1f91101d4119$export$a7c73072b1a182ae = $2fad1f91101d4119$var$h;
$2fad1f91101d4119$export$9f27bc3417b4524d = $2fad1f91101d4119$var$z;
$2fad1f91101d4119$export$db77ccec0bb4ccac = $2fad1f91101d4119$var$A;
$2fad1f91101d4119$export$8392c0c9d3dcbd35 = $2fad1f91101d4119$var$B;
$2fad1f91101d4119$export$ffb0004e005737fa = $2fad1f91101d4119$var$C;
$2fad1f91101d4119$export$b624eff549462981 = $2fad1f91101d4119$var$D;
$2fad1f91101d4119$export$7897aa7841a5380c = $2fad1f91101d4119$var$E;
$2fad1f91101d4119$export$602eac185826482c = $2fad1f91101d4119$var$F;
$2fad1f91101d4119$export$e2c29f18771995cb = $2fad1f91101d4119$var$G;
$2fad1f91101d4119$export$5f8d39834fd61797 = $2fad1f91101d4119$var$H;
$2fad1f91101d4119$export$74bf444e3cd11ea5 = $2fad1f91101d4119$var$I;
$2fad1f91101d4119$export$92387174baf9b227 = function() {
    return !1;
};
$2fad1f91101d4119$export$ec112efeb987d9c6 = function() {
    return !1;
};
$2fad1f91101d4119$export$b706b080d889d2c9 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$h;
};
$2fad1f91101d4119$export$5be5a87408f70ddc = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$g;
};
$2fad1f91101d4119$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2fad1f91101d4119$var$b;
};
$2fad1f91101d4119$export$455c2e768291efa6 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$k;
};
$2fad1f91101d4119$export$9522e17588c12572 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$d;
};
$2fad1f91101d4119$export$2110ac352bb060b9 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$p;
};
$2fad1f91101d4119$export$56885ab8b9c456ab = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$n;
};
$2fad1f91101d4119$export$d927fcb6adf8f9de = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$c;
};
$2fad1f91101d4119$export$b82d16f27459e05a = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$f;
};
$2fad1f91101d4119$export$522c17b4f5e123e8 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$e;
};
$2fad1f91101d4119$export$1aabd8a0274ecfd6 = function(a) {
    return $2fad1f91101d4119$var$y(a) === $2fad1f91101d4119$var$l;
};
$2fad1f91101d4119$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2fad1f91101d4119$var$d || a === $2fad1f91101d4119$var$f || a === $2fad1f91101d4119$var$v || a === $2fad1f91101d4119$var$e || a === $2fad1f91101d4119$var$l || a === $2fad1f91101d4119$var$m || a === $2fad1f91101d4119$var$w || "object" === typeof a && null !== a && (a.$$typeof === $2fad1f91101d4119$var$p || a.$$typeof === $2fad1f91101d4119$var$n || a.$$typeof === $2fad1f91101d4119$var$g || a.$$typeof === $2fad1f91101d4119$var$h || a.$$typeof === $2fad1f91101d4119$var$k || a.$$typeof === $2fad1f91101d4119$var$u || a.$$typeof === $2fad1f91101d4119$var$q || a[0] === $2fad1f91101d4119$var$r) ? !0 : !1;
};
$2fad1f91101d4119$export$f5bbd400c2f4426f = $2fad1f91101d4119$var$y;

});

parcelRegister("as5xI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $79c0d19c7e2c68ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $79c0d19c7e2c68ac$var$_menuFactory2 = $79c0d19c7e2c68ac$var$_interopRequireDefault($6muFC);
var $79c0d19c7e2c68ac$var$styles = {};
module.exports['default'] = (0, $79c0d19c7e2c68ac$var$_menuFactory2['default'])($79c0d19c7e2c68ac$var$styles);
module.exports = module.exports['default'];

});
parcelRegister("6muFC", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
var $4a1c969d0a878047$var$_slicedToArray = function() {
    function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;
        try {
            for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
                _arr.push(_s.value);
                if (i && _arr.length === i) break;
            }
        } catch (err) {
            _d = true;
            _e = err;
        } finally{
            try {
                if (!_n && _i['return']) _i['return']();
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
    return function(arr, i) {
        if (Array.isArray(arr)) return arr;
        else if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
        else throw new TypeError('Invalid attempt to destructure non-iterable instance');
    };
}();
var $4a1c969d0a878047$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $4a1c969d0a878047$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $7fPBF = parcelRequire("7fPBF");
var $4a1c969d0a878047$var$_react2 = $4a1c969d0a878047$var$_interopRequireDefault($7fPBF);

var $fw0lo = parcelRequire("fw0lo");
var $4a1c969d0a878047$var$_reactDom2 = $4a1c969d0a878047$var$_interopRequireDefault($fw0lo);

var $2oXYc = parcelRequire("2oXYc");
var $4a1c969d0a878047$var$_propTypes2 = $4a1c969d0a878047$var$_interopRequireDefault($2oXYc);

var $iQrFS = parcelRequire("iQrFS");
var $4a1c969d0a878047$var$_helpersBaseStyles2 = $4a1c969d0a878047$var$_interopRequireDefault($iQrFS);

var $dW40D = parcelRequire("dW40D");

var $hzVO1 = parcelRequire("hzVO1");
var $4a1c969d0a878047$var$_componentsBurgerIcon2 = $4a1c969d0a878047$var$_interopRequireDefault($hzVO1);

var $1Uy6W = parcelRequire("1Uy6W");
var $4a1c969d0a878047$var$_componentsCrossIcon2 = $4a1c969d0a878047$var$_interopRequireDefault($1Uy6W);
module.exports['default'] = function(styles) {
    if (!styles) throw new Error('No styles supplied');
    var ARROW_DOWN = 'ArrowDown';
    var ARROW_UP = 'ArrowUp';
    var ESCAPE = 'Escape';
    var SPACE = ' ';
    var HOME = 'Home';
    var END = 'End';
    function usePrevious(value) {
        var ref = $4a1c969d0a878047$var$_react2['default'].useRef(value);
        $4a1c969d0a878047$var$_react2['default'].useEffect(function() {
            ref.current = value;
        });
        return ref.current;
    }
    var Menu = function Menu(props) {
        var defaultProps = {
            bodyClassName: '',
            burgerBarClassName: '',
            burgerButtonClassName: '',
            className: '',
            crossButtonClassName: '',
            crossClassName: '',
            disableAutoFocus: false,
            disableCloseOnEsc: false,
            htmlClassName: '',
            id: '',
            itemClassName: '',
            itemListClassName: '',
            menuClassName: '',
            morphShapeClassName: '',
            noOverlay: false,
            noTransition: false,
            onStateChange: function onStateChange() {},
            outerContainerId: '',
            overlayClassName: '',
            pageWrapId: '',
            styles: {},
            width: 300,
            onIconHoverChange: function onIconHoverChange() {},
            itemListElement: 'nav'
        };
        props = $4a1c969d0a878047$var$_extends({}, defaultProps, props);
        var _React$useState = $4a1c969d0a878047$var$_react2['default'].useState(false);
        var _React$useState2 = $4a1c969d0a878047$var$_slicedToArray(_React$useState, 2);
        var isOpen = _React$useState2[0];
        var setIsOpen = _React$useState2[1];
        var timeoutId = $4a1c969d0a878047$var$_react2['default'].useRef();
        var toggleOptions = $4a1c969d0a878047$var$_react2['default'].useRef({});
        var prevIsOpenProp = usePrevious(props.isOpen);
        $4a1c969d0a878047$var$_react2['default'].useEffect(function() {
            if (props.isOpen) toggleMenu({
                isOpen: true,
                noStateChange: true
            });
            return function cleanup() {
                applyWrapperStyles(false);
                clearCurrentTimeout();
            };
        }, []);
        $4a1c969d0a878047$var$_react2['default'].useEffect(function() {
            var wasToggled = typeof props.isOpen !== 'undefined' && props.isOpen !== isOpen && props.isOpen !== prevIsOpenProp;
            if (wasToggled) {
                toggleMenu();
                // Toggling changes SVG animation requirements, so defer these until next update
                return;
            }
            if (styles.svg) (function() {
                var morphShape = document.getElementById('bm-morph-shape');
                var path = styles.svg.lib(morphShape).select('path');
                if (isOpen) // Animate SVG path
                styles.svg.animate(path);
                else // Reset path (timeout ensures animation happens off screen)
                setTimeout(function() {
                    path.attr('d', styles.svg.pathInitial);
                }, 300);
            })();
        });
        $4a1c969d0a878047$var$_react2['default'].useEffect(function() {
            var _toggleOptions$current = toggleOptions.current;
            var noStateChange = _toggleOptions$current.noStateChange;
            var focusOnLastItem = _toggleOptions$current.focusOnLastItem;
            if (!noStateChange) props.onStateChange({
                isOpen: isOpen
            });
            if (!props.disableAutoFocus) {
                // For accessibility reasons, ensures that when we toggle open,
                // we focus the first or last menu item according to given parameter
                if (isOpen) focusOnLastItem ? (0, $dW40D.focusOnLastMenuItem)() : (0, $dW40D.focusOnFirstMenuItem)();
                else if (document.activeElement) document.activeElement.blur();
                else document.body.blur(); // Needed for IE
            }
            // Timeout ensures wrappers are cleared after animation finishes
            clearCurrentTimeout();
            timeoutId.current = setTimeout(function() {
                timeoutId.current = null;
                if (!isOpen) applyWrapperStyles(false);
            }, 500);
            // Bind keydown handlers (or custom function if supplied)
            var defaultOnKeyDown = isOpen ? onKeyDownOpen : onKeyDownClosed;
            var onKeyDown = props.customOnKeyDown || defaultOnKeyDown;
            window.addEventListener('keydown', onKeyDown);
            return function cleanup() {
                window.removeEventListener('keydown', onKeyDown);
            };
        }, [
            isOpen
        ]);
        function toggleMenu() {
            var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
            toggleOptions.current = options;
            applyWrapperStyles();
            // Ensures wrapper styles are applied before the menu is toggled
            setTimeout(function() {
                setIsOpen(function(open) {
                    return typeof options.isOpen !== 'undefined' ? options.isOpen : !open;
                });
            });
        }
        function open() {
            if (typeof props.onOpen === 'function') props.onOpen();
            else toggleMenu();
        }
        function close() {
            if (typeof props.onClose === 'function') props.onClose();
            else toggleMenu();
        }
        function getStyle(style, index) {
            var _props = props;
            var width = _props.width;
            var right = _props.right;
            var formattedWidth = typeof width !== 'string' ? width + 'px' : width;
            return style(isOpen, formattedWidth, right, index);
        }
        // Builds styles incrementally for a given element
        function getStyles(el, index, inline) {
            var propName = 'bm' + el.replace(el.charAt(0), el.charAt(0).toUpperCase());
            // Set base styles
            var output = $4a1c969d0a878047$var$_helpersBaseStyles2['default'][el] ? getStyle($4a1c969d0a878047$var$_helpersBaseStyles2['default'][el]) : {};
            // Add animation-specific styles
            if (styles[el]) output = $4a1c969d0a878047$var$_extends({}, output, getStyle(styles[el], index + 1));
            // Add custom styles
            if (props.styles[propName]) output = $4a1c969d0a878047$var$_extends({}, output, props.styles[propName]);
            // Add element inline styles
            if (inline) output = $4a1c969d0a878047$var$_extends({}, output, inline);
            // Remove transition if required
            // (useful if rendering open initially)
            if (props.noTransition) delete output.transition;
            return output;
        }
        // Sets or unsets styles on DOM elements outside the menu component
        // This is necessary for correct page interaction with some of the menus
        // Throws and returns if the required external elements don't exist,
        // which means any external page animations won't be applied
        function handleExternalWrapper(id, wrapperStyles, set) {
            var wrapper = document.getElementById(id);
            if (!wrapper) {
                console.error("Element with ID '" + id + "' not found");
                return;
            }
            var builtStyles = getStyle(wrapperStyles);
            for(var prop in builtStyles)if (builtStyles.hasOwnProperty(prop)) wrapper.style[prop] = set ? builtStyles[prop] : '';
            // Prevent any horizontal scroll
            // Only set overflow-x as an inline style if htmlClassName or
            // bodyClassName is not passed in. Otherwise, it is up to the caller to
            // decide if they want to set the overflow style in CSS using the custom
            // class names
            var applyOverflow = function applyOverflow(el) {
                return el.style['overflow-x'] = set ? 'hidden' : '';
            };
            if (!props.htmlClassName) applyOverflow(document.querySelector('html'));
            if (!props.bodyClassName) applyOverflow(document.querySelector('body'));
        }
        // Applies component-specific styles to external wrapper elements
        function applyWrapperStyles() {
            var set = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
            var applyClass = function applyClass(el, className) {
                return el.classList[set ? 'add' : 'remove'](className);
            };
            if (props.htmlClassName) applyClass(document.querySelector('html'), props.htmlClassName);
            if (props.bodyClassName) applyClass(document.querySelector('body'), props.bodyClassName);
            if (styles.pageWrap && props.pageWrapId) handleExternalWrapper(props.pageWrapId, styles.pageWrap, set);
            if (styles.outerContainer && props.outerContainerId) handleExternalWrapper(props.outerContainerId, styles.outerContainer, set);
            var menuWrap = document.querySelector('.bm-menu-wrap');
            if (menuWrap) {
                if (set) menuWrap.removeAttribute('hidden');
                else menuWrap.setAttribute('hidden', true);
            }
        }
        // Avoids potentially attempting to update an unmounted component
        function clearCurrentTimeout() {
            if (timeoutId.current) clearTimeout(timeoutId.current);
        }
        function onKeyDownOpen(e) {
            e = e || window.event;
            switch(e.key){
                case ESCAPE:
                    // Close on ESC, unless disabled
                    if (!props.disableCloseOnEsc) {
                        close();
                        (0, $dW40D.focusOnMenuButton)();
                    }
                    break;
                case ARROW_DOWN:
                    (0, $dW40D.focusOnNextMenuItem)();
                    break;
                case ARROW_UP:
                    (0, $dW40D.focusOnPreviousMenuItem)();
                    break;
                case HOME:
                    (0, $dW40D.focusOnFirstMenuItem)();
                    break;
                case END:
                    (0, $dW40D.focusOnLastMenuItem)();
                    break;
            }
        }
        function onKeyDownClosed(e) {
            e = e || window.event;
            // Key downs came from menu button
            if (e.target === document.getElementById('react-burger-menu-btn')) switch(e.key){
                case ARROW_DOWN:
                case SPACE:
                    // If down arrow, space or enter, open menu and focus on first menuitem
                    toggleMenu();
                    break;
                case ARROW_UP:
                    // If arrow up, open menu and focus on last menuitem
                    toggleMenu({
                        focusOnLastItem: true
                    });
                    break;
            }
        }
        function handleOverlayClick() {
            if (props.disableOverlayClick === true || typeof props.disableOverlayClick === 'function' && props.disableOverlayClick()) return;
            else close();
        }
        return $4a1c969d0a878047$var$_react2['default'].createElement('div', null, !props.noOverlay && $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            className: ('bm-overlay ' + props.overlayClassName).trim(),
            onClick: handleOverlayClick,
            style: getStyles('overlay')
        }), props.customBurgerIcon !== false && $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            style: getStyles('burgerIcon')
        }, $4a1c969d0a878047$var$_react2['default'].createElement($4a1c969d0a878047$var$_componentsBurgerIcon2['default'], {
            onClick: open,
            styles: props.styles,
            customIcon: props.customBurgerIcon,
            className: props.burgerButtonClassName,
            barClassName: props.burgerBarClassName,
            onIconStateChange: props.onIconStateChange
        })), $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            id: props.id,
            className: ('bm-menu-wrap ' + props.className).trim(),
            style: getStyles('menuWrap'),
            'aria-hidden': !isOpen
        }, styles.svg && $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            id: 'bm-morph-shape',
            className: ('bm-morph-shape ' + props.morphShapeClassName).trim(),
            style: getStyles('morphShape')
        }, $4a1c969d0a878047$var$_react2['default'].createElement('svg', {
            width: '100%',
            height: '100%',
            viewBox: '0 0 100 800',
            preserveAspectRatio: 'none'
        }, $4a1c969d0a878047$var$_react2['default'].createElement('path', {
            d: styles.svg.pathInitial
        }))), $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            className: ('bm-menu ' + props.menuClassName).trim(),
            style: getStyles('menu')
        }, $4a1c969d0a878047$var$_react2['default'].createElement(props.itemListElement, {
            className: ('bm-item-list ' + props.itemListClassName).trim(),
            style: getStyles('itemList')
        }, $4a1c969d0a878047$var$_react2['default'].Children.map(props.children, function(item, index) {
            if (item) {
                var classList = [
                    'bm-item',
                    props.itemClassName,
                    item.props.className
                ].filter(function(className) {
                    return !!className;
                }).join(' ');
                var extraProps = $4a1c969d0a878047$var$_extends({
                    key: index,
                    className: classList,
                    style: getStyles('item', index, item.props.style)
                }, !isOpen && {
                    tabIndex: -1
                });
                return $4a1c969d0a878047$var$_react2['default'].cloneElement(item, extraProps);
            }
        }))), props.customCrossIcon !== false && $4a1c969d0a878047$var$_react2['default'].createElement('div', {
            style: getStyles('closeButton')
        }, $4a1c969d0a878047$var$_react2['default'].createElement($4a1c969d0a878047$var$_componentsCrossIcon2['default'], {
            onClick: close,
            styles: props.styles,
            customIcon: props.customCrossIcon,
            className: props.crossButtonClassName,
            crossClassName: props.crossClassName,
            isOpen: isOpen
        }))));
    };
    Menu.propTypes = {
        bodyClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        burgerBarClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        burgerButtonClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        className: $4a1c969d0a878047$var$_propTypes2['default'].string,
        crossButtonClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        crossClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        customBurgerIcon: $4a1c969d0a878047$var$_propTypes2['default'].oneOfType([
            $4a1c969d0a878047$var$_propTypes2['default'].element,
            $4a1c969d0a878047$var$_propTypes2['default'].oneOf([
                false
            ])
        ]),
        customCrossIcon: $4a1c969d0a878047$var$_propTypes2['default'].oneOfType([
            $4a1c969d0a878047$var$_propTypes2['default'].element,
            $4a1c969d0a878047$var$_propTypes2['default'].oneOf([
                false
            ])
        ]),
        customOnKeyDown: $4a1c969d0a878047$var$_propTypes2['default'].func,
        disableAutoFocus: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        disableCloseOnEsc: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        disableOverlayClick: $4a1c969d0a878047$var$_propTypes2['default'].oneOfType([
            $4a1c969d0a878047$var$_propTypes2['default'].bool,
            $4a1c969d0a878047$var$_propTypes2['default'].func
        ]),
        htmlClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        id: $4a1c969d0a878047$var$_propTypes2['default'].string,
        isOpen: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        itemClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        itemListClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        itemListElement: $4a1c969d0a878047$var$_propTypes2['default'].oneOf([
            'div',
            'nav'
        ]),
        menuClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        morphShapeClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        noOverlay: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        noTransition: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        onClose: $4a1c969d0a878047$var$_propTypes2['default'].func,
        onIconHoverChange: $4a1c969d0a878047$var$_propTypes2['default'].func,
        onOpen: $4a1c969d0a878047$var$_propTypes2['default'].func,
        onStateChange: $4a1c969d0a878047$var$_propTypes2['default'].func,
        outerContainerId: styles && styles.outerContainer ? $4a1c969d0a878047$var$_propTypes2['default'].string.isRequired : $4a1c969d0a878047$var$_propTypes2['default'].string,
        overlayClassName: $4a1c969d0a878047$var$_propTypes2['default'].string,
        pageWrapId: styles && styles.pageWrap ? $4a1c969d0a878047$var$_propTypes2['default'].string.isRequired : $4a1c969d0a878047$var$_propTypes2['default'].string,
        right: $4a1c969d0a878047$var$_propTypes2['default'].bool,
        styles: $4a1c969d0a878047$var$_propTypes2['default'].object,
        width: $4a1c969d0a878047$var$_propTypes2['default'].oneOfType([
            $4a1c969d0a878047$var$_propTypes2['default'].number,
            $4a1c969d0a878047$var$_propTypes2['default'].string
        ])
    };
    return Menu;
};
module.exports = module.exports['default'];

});
parcelRegister("fw0lo", function(module, exports) {
'use strict';
function $b4ba1c853f6e1116$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($b4ba1c853f6e1116$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$b4ba1c853f6e1116$var$checkDCE();

module.exports = (parcelRequire("6EA3T"));

});

parcelRegister("2oXYc", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1bfc5778dcd4841a$var$ReactIs, $1bfc5778dcd4841a$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("iDep4"))();

});

parcelRegister("iQrFS", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
var $db828ce58ee26ca8$var$styles = {
    overlay: function overlay(isOpen) {
        return {
            position: 'fixed',
            zIndex: 1000,
            width: '100%',
            height: '100%',
            background: 'rgba(0, 0, 0, 0.3)',
            opacity: isOpen ? 1 : 0,
            MozTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
            MsTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
            OTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
            WebkitTransform: isOpen ? '' : 'translate3d(100%, 0, 0)',
            transform: isOpen ? '' : 'translate3d(100%, 0, 0)',
            transition: isOpen ? 'opacity 0.3s' : 'opacity 0.3s, transform 0s 0.3s'
        };
    },
    menuWrap: function menuWrap(isOpen, width, right) {
        return {
            position: 'fixed',
            right: right ? 0 : 'inherit',
            zIndex: 1100,
            width: width,
            height: '100%',
            MozTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transition: 'all 0.5s'
        };
    },
    menu: function menu() {
        return {
            height: '100%',
            boxSizing: 'border-box',
            overflow: 'auto'
        };
    },
    itemList: function itemList() {
        return {
            height: '100%'
        };
    },
    item: function item() {
        return {
            display: 'block'
        };
    }
};
module.exports['default'] = $db828ce58ee26ca8$var$styles;
module.exports = module.exports['default'];

});

parcelRegister("dW40D", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.focusOnFirstMenuItem = $a253cd4a17c3e40c$var$focusOnFirstMenuItem;
module.exports.focusOnLastMenuItem = $a253cd4a17c3e40c$var$focusOnLastMenuItem;
module.exports.focusOnCrossButton = $a253cd4a17c3e40c$var$focusOnCrossButton;
module.exports.focusOnMenuButton = $a253cd4a17c3e40c$var$focusOnMenuButton;
module.exports.focusOnMenuItem = $a253cd4a17c3e40c$var$focusOnMenuItem;
module.exports.focusOnNextMenuItem = $a253cd4a17c3e40c$var$focusOnNextMenuItem;
module.exports.focusOnPreviousMenuItem = $a253cd4a17c3e40c$var$focusOnPreviousMenuItem;
function $a253cd4a17c3e40c$var$focusOnFirstMenuItem() {
    var firstItem = Array.from(document.getElementsByClassName('bm-item')).shift();
    if (firstItem) firstItem.focus();
}
function $a253cd4a17c3e40c$var$focusOnLastMenuItem() {
    var lastItem = Array.from(document.getElementsByClassName('bm-item')).pop();
    if (lastItem) lastItem.focus();
}
function $a253cd4a17c3e40c$var$focusOnCrossButton() {
    var crossButton = document.getElementById('react-burger-cross-btn');
    if (crossButton) crossButton.focus();
}
function $a253cd4a17c3e40c$var$focusOnMenuButton() {
    var menuButton = document.getElementById('react-burger-menu-btn');
    if (menuButton) menuButton.focus();
}
function $a253cd4a17c3e40c$var$focusOnMenuItem(siblingType) {
    if (document.activeElement.className.includes('bm-item')) {
        var sibling = document.activeElement[siblingType];
        if (sibling) sibling.focus();
        else $a253cd4a17c3e40c$var$focusOnCrossButton();
    } else if (siblingType === 'previousElementSibling') $a253cd4a17c3e40c$var$focusOnLastMenuItem();
    else $a253cd4a17c3e40c$var$focusOnFirstMenuItem();
}
function $a253cd4a17c3e40c$var$focusOnNextMenuItem() {
    $a253cd4a17c3e40c$var$focusOnMenuItem('nextElementSibling');
}
function $a253cd4a17c3e40c$var$focusOnPreviousMenuItem() {
    $a253cd4a17c3e40c$var$focusOnMenuItem('previousElementSibling');
}

});

parcelRegister("hzVO1", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
var $ccc28b9b2253a78e$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ccc28b9b2253a78e$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $ccc28b9b2253a78e$var$_get = function get(_x, _x2, _x3) {
    var _again = true;
    _function: while(_again){
        var object = _x, property = _x2, receiver = _x3;
        _again = false;
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);
        if (desc === undefined) {
            var parent = Object.getPrototypeOf(object);
            if (parent === null) return undefined;
            else {
                _x = parent;
                _x2 = property;
                _x3 = receiver;
                _again = true;
                desc = parent = undefined;
                continue _function;
            }
        } else if ('value' in desc) return desc.value;
        else {
            var getter = desc.get;
            if (getter === undefined) return undefined;
            return getter.call(receiver);
        }
    }
};
function $ccc28b9b2253a78e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $ccc28b9b2253a78e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
function $ccc28b9b2253a78e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $7fPBF = parcelRequire("7fPBF");
var $ccc28b9b2253a78e$var$_react2 = $ccc28b9b2253a78e$var$_interopRequireDefault($7fPBF);

var $2oXYc = parcelRequire("2oXYc");
var $ccc28b9b2253a78e$var$_propTypes2 = $ccc28b9b2253a78e$var$_interopRequireDefault($2oXYc);
var $ccc28b9b2253a78e$var$BurgerIcon = function(_Component) {
    $ccc28b9b2253a78e$var$_inherits(BurgerIcon, _Component);
    function BurgerIcon(props) {
        $ccc28b9b2253a78e$var$_classCallCheck(this, BurgerIcon);
        $ccc28b9b2253a78e$var$_get(Object.getPrototypeOf(BurgerIcon.prototype), 'constructor', this).call(this, props);
        this.state = {
            hover: false
        };
    }
    $ccc28b9b2253a78e$var$_createClass(BurgerIcon, [
        {
            key: 'getLineStyle',
            value: function getLineStyle(index) {
                return $ccc28b9b2253a78e$var$_extends({
                    position: 'absolute',
                    height: '20%',
                    left: 0,
                    right: 0,
                    top: 20 * (index * 2) + '%',
                    opacity: this.state.hover ? 0.6 : 1
                }, this.state.hover && this.props.styles.bmBurgerBarsHover);
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this = this;
                var icon = undefined;
                var buttonStyle = {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    height: '100%',
                    margin: 0,
                    padding: 0,
                    border: 'none',
                    fontSize: 0,
                    background: 'transparent',
                    cursor: 'pointer'
                };
                if (this.props.customIcon) {
                    var extraProps = {
                        className: ('bm-icon ' + (this.props.customIcon.props.className || '')).trim(),
                        style: $ccc28b9b2253a78e$var$_extends({
                            width: '100%',
                            height: '100%'
                        }, this.props.styles.bmIcon)
                    };
                    icon = $ccc28b9b2253a78e$var$_react2['default'].cloneElement(this.props.customIcon, extraProps);
                } else icon = $ccc28b9b2253a78e$var$_react2['default'].createElement('span', null, [
                    0,
                    1,
                    2
                ].map(function(bar) {
                    return $ccc28b9b2253a78e$var$_react2['default'].createElement('span', {
                        key: bar,
                        className: ('bm-burger-bars ' + _this.props.barClassName + ' ' + (_this.state.hover ? 'bm-burger-bars-hover' : '')).trim(),
                        style: $ccc28b9b2253a78e$var$_extends({}, _this.getLineStyle(bar), _this.props.styles.bmBurgerBars)
                    });
                }));
                return $ccc28b9b2253a78e$var$_react2['default'].createElement('div', {
                    className: ('bm-burger-button ' + this.props.className).trim(),
                    style: $ccc28b9b2253a78e$var$_extends({
                        zIndex: 1000
                    }, this.props.styles.bmBurgerButton)
                }, $ccc28b9b2253a78e$var$_react2['default'].createElement('button', {
                    type: 'button',
                    id: 'react-burger-menu-btn',
                    onClick: this.props.onClick,
                    onMouseOver: function() {
                        _this.setState({
                            hover: true
                        });
                        if (_this.props.onIconHoverChange) _this.props.onIconHoverChange({
                            isMouseIn: true
                        });
                    },
                    onMouseOut: function() {
                        _this.setState({
                            hover: false
                        });
                        if (_this.props.onIconHoverChange) _this.props.onIconHoverChange({
                            isMouseIn: false
                        });
                    },
                    style: buttonStyle
                }, 'Open Menu'), icon);
            }
        }
    ]);
    return BurgerIcon;
}($7fPBF.Component);
module.exports['default'] = $ccc28b9b2253a78e$var$BurgerIcon;
$ccc28b9b2253a78e$var$BurgerIcon.propTypes = {
    barClassName: $ccc28b9b2253a78e$var$_propTypes2['default'].string,
    customIcon: $ccc28b9b2253a78e$var$_propTypes2['default'].element,
    styles: $ccc28b9b2253a78e$var$_propTypes2['default'].object
};
$ccc28b9b2253a78e$var$BurgerIcon.defaultProps = {
    barClassName: '',
    className: '',
    styles: {}
};
module.exports = module.exports['default'];

});

parcelRegister("1Uy6W", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
var $16457b278626c6a3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $16457b278626c6a3$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $16457b278626c6a3$var$_get = function get(_x, _x2, _x3) {
    var _again = true;
    _function: while(_again){
        var object = _x, property = _x2, receiver = _x3;
        _again = false;
        if (object === null) object = Function.prototype;
        var desc = Object.getOwnPropertyDescriptor(object, property);
        if (desc === undefined) {
            var parent = Object.getPrototypeOf(object);
            if (parent === null) return undefined;
            else {
                _x = parent;
                _x2 = property;
                _x3 = receiver;
                _again = true;
                desc = parent = undefined;
                continue _function;
            }
        } else if ('value' in desc) return desc.value;
        else {
            var getter = desc.get;
            if (getter === undefined) return undefined;
            return getter.call(receiver);
        }
    }
};
function $16457b278626c6a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $16457b278626c6a3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
function $16457b278626c6a3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $7fPBF = parcelRequire("7fPBF");
var $16457b278626c6a3$var$_react2 = $16457b278626c6a3$var$_interopRequireDefault($7fPBF);

var $2oXYc = parcelRequire("2oXYc");
var $16457b278626c6a3$var$_propTypes2 = $16457b278626c6a3$var$_interopRequireDefault($2oXYc);
var $16457b278626c6a3$var$CrossIcon = function(_Component) {
    $16457b278626c6a3$var$_inherits(CrossIcon, _Component);
    function CrossIcon() {
        $16457b278626c6a3$var$_classCallCheck(this, CrossIcon);
        $16457b278626c6a3$var$_get(Object.getPrototypeOf(CrossIcon.prototype), 'constructor', this).apply(this, arguments);
    }
    $16457b278626c6a3$var$_createClass(CrossIcon, [
        {
            key: 'getCrossStyle',
            value: function getCrossStyle(type) {
                return {
                    position: 'absolute',
                    width: 3,
                    height: 14,
                    transform: type === 'before' ? 'rotate(45deg)' : 'rotate(-45deg)'
                };
            }
        },
        {
            key: 'render',
            value: function render() {
                var _this = this;
                var icon;
                var buttonWrapperStyle = {
                    position: 'absolute',
                    width: 24,
                    height: 24,
                    right: 8,
                    top: 8
                };
                var buttonStyle = {
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    zIndex: 1,
                    width: '100%',
                    height: '100%',
                    margin: 0,
                    padding: 0,
                    border: 'none',
                    fontSize: 0,
                    background: 'transparent',
                    cursor: 'pointer'
                };
                if (this.props.customIcon) {
                    var extraProps = {
                        className: ('bm-cross ' + (this.props.customIcon.props.className || '')).trim(),
                        style: $16457b278626c6a3$var$_extends({
                            width: '100%',
                            height: '100%'
                        }, this.props.styles.bmCross)
                    };
                    icon = $16457b278626c6a3$var$_react2['default'].cloneElement(this.props.customIcon, extraProps);
                } else icon = $16457b278626c6a3$var$_react2['default'].createElement('span', {
                    style: {
                        position: 'absolute',
                        top: '6px',
                        right: '14px'
                    }
                }, [
                    'before',
                    'after'
                ].map(function(type, i) {
                    return $16457b278626c6a3$var$_react2['default'].createElement('span', {
                        key: i,
                        className: ('bm-cross ' + _this.props.crossClassName).trim(),
                        style: $16457b278626c6a3$var$_extends({}, _this.getCrossStyle(type), _this.props.styles.bmCross)
                    });
                }));
                return $16457b278626c6a3$var$_react2['default'].createElement('div', {
                    className: ('bm-cross-button ' + this.props.className).trim(),
                    style: $16457b278626c6a3$var$_extends({}, buttonWrapperStyle, this.props.styles.bmCrossButton)
                }, $16457b278626c6a3$var$_react2['default'].createElement('button', $16457b278626c6a3$var$_extends({
                    type: 'button',
                    id: 'react-burger-cross-btn',
                    onClick: this.props.onClick,
                    style: buttonStyle
                }, !this.props.isOpen && {
                    tabIndex: -1
                }), 'Close Menu'), icon);
            }
        }
    ]);
    return CrossIcon;
}($7fPBF.Component);
module.exports['default'] = $16457b278626c6a3$var$CrossIcon;
$16457b278626c6a3$var$CrossIcon.propTypes = {
    crossClassName: $16457b278626c6a3$var$_propTypes2['default'].string,
    customIcon: $16457b278626c6a3$var$_propTypes2['default'].element,
    isOpen: $16457b278626c6a3$var$_propTypes2['default'].bool,
    styles: $16457b278626c6a3$var$_propTypes2['default'].object
};
$16457b278626c6a3$var$CrossIcon.defaultProps = {
    crossClassName: '',
    className: '',
    styles: {},
    isOpen: false
};
module.exports = module.exports['default'];

});



parcelRegister("8LDbR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $66211ce7119cf1f3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $66211ce7119cf1f3$var$_menuFactory2 = $66211ce7119cf1f3$var$_interopRequireDefault($6muFC);
var $66211ce7119cf1f3$var$styles = {
    menuWrap: function menuWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)',
            transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0.4s cubic-bezier(0.7, 0, 0.3, 1)'
        };
    },
    item: function item(isOpen, width, right, nthChild) {
        return {
            MozTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
            MsTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
            OTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
            WebkitTransform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
            transform: isOpen ? '' : 'translate3d(0, ' + nthChild * 500 + 'px, 0)',
            transition: isOpen ? 'transform 0.8s cubic-bezier(0.7, 0, 0.3, 1)' : 'transform 0s 0.2s cubic-bezier(0.7, 0, 0.3, 1)'
        };
    }
};
module.exports['default'] = (0, $66211ce7119cf1f3$var$_menuFactory2['default'])($66211ce7119cf1f3$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("5Z3UW", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $45b5b027790b8fed$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $c3Chv = parcelRequire("c3Chv");
var $45b5b027790b8fed$var$_helpersSnapsvgImporter2 = $45b5b027790b8fed$var$_interopRequireDefault($c3Chv);

var $6muFC = parcelRequire("6muFC");
var $45b5b027790b8fed$var$_menuFactory2 = $45b5b027790b8fed$var$_interopRequireDefault($6muFC);

var $e1he6 = parcelRequire("e1he6");
var $45b5b027790b8fed$var$MORPH_SHAPE_WIDTH = 120;
var $45b5b027790b8fed$var$styles = {
    svg: {
        lib: $45b5b027790b8fed$var$_helpersSnapsvgImporter2['default'],
        pathInitial: 'M-1,0h101c0,0-97.833,153.603-97.833,396.167C2.167,627.579,100,800,100,800H-1V0z',
        pathOpen: 'M-1,0h101c0,0,0-1,0,395c0,404,0,405,0,405H-1V0z',
        animate: function animate(path) {
            path.animate({
                path: this.pathOpen
            }, 400, window.mina.easeinout);
        }
    },
    morphShape: function morphShape(isOpen, width, right) {
        return {
            position: 'absolute',
            width: $45b5b027790b8fed$var$MORPH_SHAPE_WIDTH,
            height: '100%',
            right: right ? 'inherit' : 0,
            left: right ? 0 : 'inherit',
            MozTransform: right ? 'rotateY(180deg)' : '',
            MsTransform: right ? 'rotateY(180deg)' : '',
            OTransform: right ? 'rotateY(180deg)' : '',
            WebkitTransform: right ? 'rotateY(180deg)' : '',
            transform: right ? 'rotateY(180deg)' : ''
        };
    },
    menuWrap: function menuWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transition: 'all 0.3s'
        };
    },
    menu: function menu(isOpen, width, right) {
        return {
            position: 'fixed',
            right: right ? 0 : 'inherit',
            width: (0, $e1he6.pxToNum)(width) - $45b5b027790b8fed$var$MORPH_SHAPE_WIDTH,
            whiteSpace: 'nowrap',
            boxSizing: 'border-box',
            overflow: 'visible'
        };
    },
    itemList: function itemList(isOpen, width, right) {
        if (right) return {
            position: 'relative',
            left: '-110px',
            width: '170%',
            overflow: 'auto'
        };
    },
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(-100px, 0, 0)' : 'translate3d(100px, 0, 0)',
            transition: isOpen ? 'all 0.3s' : 'all 0.3s 0.1s'
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $45b5b027790b8fed$var$_menuFactory2['default'])($45b5b027790b8fed$var$styles);
module.exports = module.exports['default'];

});
parcelRegister("c3Chv", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});

module.exports['default'] = function() {
    var Snap = undefined;
    try {
        Snap = (parcelRequire("kEG1j"));
    } finally{
        return Snap;
    }
};
module.exports = module.exports['default'];

});
parcelRegister("kEG1j", function(module, exports) {

window.eve = (parcelRequire("fXTr3"));
// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var $f098236b7e761f68$var$mina = function(eve1) {
    var animations = {}, requestAnimFrame = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function(callback) {
        setTimeout(callback, 16, new Date().getTime());
        return true;
    }, requestID, isArray = Array.isArray || function(a) {
        return a instanceof Array || Object.prototype.toString.call(a) == "[object Array]";
    }, idgen = 0, idprefix = "M" + (+new Date).toString(36), ID = function() {
        return idprefix + (idgen++).toString(36);
    }, diff = function(a, b, A, B) {
        if (isArray(a)) {
            res = [];
            for(var i = 0, ii = a.length; i < ii; i++)res[i] = diff(a[i], b, A[i], B);
            return res;
        }
        var dif = (A - a) / (B - b);
        return function(bb) {
            return a + dif * (bb - b);
        };
    }, timer = Date.now || function() {
        return +new Date;
    }, sta = function(val) {
        var a = this;
        if (val == null) return a.s;
        var ds = a.s - val;
        a.b += a.dur * ds;
        a.B += a.dur * ds;
        a.s = val;
    }, speed = function(val) {
        var a = this;
        if (val == null) return a.spd;
        a.spd = val;
    }, duration = function(val) {
        var a = this;
        if (val == null) return a.dur;
        a.s = a.s * val / a.dur;
        a.dur = val;
    }, stopit = function() {
        var a = this;
        delete animations[a.id];
        a.update();
        eve1("mina.stop." + a.id, a);
    }, pause = function() {
        var a = this;
        if (a.pdif) return;
        delete animations[a.id];
        a.update();
        a.pdif = a.get() - a.b;
    }, resume = function() {
        var a = this;
        if (!a.pdif) return;
        a.b = a.get() - a.pdif;
        delete a.pdif;
        animations[a.id] = a;
        frame();
    }, update = function() {
        var a = this, res1;
        if (isArray(a.start)) {
            res1 = [];
            for(var j = 0, jj = a.start.length; j < jj; j++)res1[j] = +a.start[j] + (a.end[j] - a.start[j]) * a.easing(a.s);
        } else res1 = +a.start + (a.end - a.start) * a.easing(a.s);
        a.set(res1);
    }, frame = function(timeStamp) {
        // Manual invokation?
        if (!timeStamp) {
            // Frame loop stopped?
            if (!requestID) // Start frame loop...
            requestID = requestAnimFrame(frame);
            return;
        }
        var len = 0;
        for(var i in animations)if (animations.hasOwnProperty(i)) {
            var a = animations[i], b = a.get(), res1;
            len++;
            a.s = (b - a.b) / (a.dur / a.spd);
            if (a.s >= 1) {
                delete animations[i];
                a.s = 1;
                len--;
                (function(a) {
                    setTimeout(function() {
                        eve1("mina.finish." + a.id, a);
                    });
                })(a);
            }
            a.update();
        }
        requestID = len ? requestAnimFrame(frame) : false;
    }, /*\
     * mina
     [ method ]
     **
     * Generic animation of numbers
     **
     - a (number) start _slave_ number
     - A (number) end _slave_ number
     - b (number) start _master_ number (start time in general case)
     - B (number) end _master_ number (end time in general case)
     - get (function) getter of _master_ number (see @mina.time)
     - set (function) setter of _slave_ number
     - easing (function) #optional easing function, default is @mina.linear
     = (object) animation descriptor
     o {
     o         id (string) animation id,
     o         start (number) start _slave_ number,
     o         end (number) end _slave_ number,
     o         b (number) start _master_ number,
     o         s (number) animation status (0..1),
     o         dur (number) animation duration,
     o         spd (number) animation speed,
     o         get (function) getter of _master_ number (see @mina.time),
     o         set (function) setter of _slave_ number,
     o         easing (function) easing function, default is @mina.linear,
     o         status (function) status getter/setter,
     o         speed (function) speed getter/setter,
     o         duration (function) duration getter/setter,
     o         stop (function) animation stopper
     o         pause (function) pauses the animation
     o         resume (function) resumes the animation
     o         update (function) calles setter with the right value of the animation
     o }
    \*/ mina = function(a, A, b, B, get, set, easing) {
        var anim = {
            id: ID(),
            start: a,
            end: A,
            b: b,
            s: 0,
            dur: B - b,
            spd: 1,
            get: get,
            set: set,
            easing: easing || mina.linear,
            status: sta,
            speed: speed,
            duration: duration,
            stop: stopit,
            pause: pause,
            resume: resume,
            update: update
        };
        animations[anim.id] = anim;
        var len = 0, i;
        for(i in animations)if (animations.hasOwnProperty(i)) {
            len++;
            if (len == 2) break;
        }
        len == 1 && frame();
        return anim;
    };
    /*\
     * mina.time
     [ method ]
     **
     * Returns the current time. Equivalent to:
     | function () {
     |     return (new Date).getTime();
     | }
    \*/ mina.time = timer;
    /*\
     * mina.getById
     [ method ]
     **
     * Returns an animation by its id
     - id (string) animation's id
     = (object) See @mina
    \*/ mina.getById = function(id) {
        return animations[id] || null;
    };
    /*\
     * mina.linear
     [ method ]
     **
     * Default linear easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.linear = function(n) {
        return n;
    };
    /*\
     * mina.easeout
     [ method ]
     **
     * Easeout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.easeout = function(n) {
        return Math.pow(n, 1.7);
    };
    /*\
     * mina.easein
     [ method ]
     **
     * Easein easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.easein = function(n) {
        return Math.pow(n, .48);
    };
    /*\
     * mina.easeinout
     [ method ]
     **
     * Easeinout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.easeinout = function(n) {
        if (n == 1) return 1;
        if (n == 0) return 0;
        var q = .48 - n / 1.04, Q = Math.sqrt(.1734 + q * q), x = Q - q, X = Math.pow(Math.abs(x), 1 / 3) * (x < 0 ? -1 : 1), y = -Q - q, Y = Math.pow(Math.abs(y), 1 / 3) * (y < 0 ? -1 : 1), t = X + Y + .5;
        return (1 - t) * 3 * t * t + t * t * t;
    };
    /*\
     * mina.backin
     [ method ]
     **
     * Backin easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.backin = function(n) {
        if (n == 1) return 1;
        var s = 1.70158;
        return n * n * ((s + 1) * n - s);
    };
    /*\
     * mina.backout
     [ method ]
     **
     * Backout easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.backout = function(n) {
        if (n == 0) return 0;
        n = n - 1;
        var s = 1.70158;
        return n * n * ((s + 1) * n + s) + 1;
    };
    /*\
     * mina.elastic
     [ method ]
     **
     * Elastic easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.elastic = function(n) {
        if (n == !!n) return n;
        return Math.pow(2, -10 * n) * Math.sin((n - .075) * (2 * Math.PI) / .3) + 1;
    };
    /*\
     * mina.bounce
     [ method ]
     **
     * Bounce easing
     - n (number) input 0..1
     = (number) output 0..1
    \*/ mina.bounce = function(n) {
        var s = 7.5625, p = 2.75, l;
        if (n < 1 / p) l = s * n * n;
        else {
            if (n < 2 / p) {
                n -= 1.5 / p;
                l = s * n * n + .75;
            } else if (n < 2.5 / p) {
                n -= 2.25 / p;
                l = s * n * n + .9375;
            } else {
                n -= 2.625 / p;
                l = s * n * n + .984375;
            }
        }
        return l;
    };
    window.mina = mina;
    return mina;
}(typeof eve == "undefined" ? function() {} : eve);
// Copyright (c) 2013 - 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
var $f098236b7e761f68$var$Snap = function(root) {
    Snap.version = "0.5.1";
    /*\
 * Snap
 [ method ]
 **
 * Creates a drawing surface or wraps existing SVG element.
 **
 - width (number|string) width of surface
 - height (number|string) height of surface
 * or
 - DOM (SVGElement) element to be wrapped into Snap structure
 * or
 - array (array) array of elements (will return set of elements)
 * or
 - query (string) CSS query selector
 = (object) @Element
\*/ function Snap(w, h) {
        if (w) {
            if (w.nodeType) return wrap(w);
            if (is(w, "array") && Snap.set) return Snap.set.apply(Snap, w);
            if (w instanceof Element) return w;
            if (h == null) try {
                w = glob.doc.querySelector(String(w));
                return wrap(w);
            } catch (e) {
                return null;
            }
        }
        w = w == null ? "100%" : w;
        h = h == null ? "100%" : h;
        return new Paper(w, h);
    }
    Snap.toString = function() {
        return "Snap v" + this.version;
    };
    Snap._ = {};
    var glob = {
        win: root.window,
        doc: root.window.document
    };
    Snap._.glob = glob;
    var has = "hasOwnProperty", Str = String, toFloat = parseFloat, toInt = parseInt, math1 = Math, mmax = math1.max, mmin = math1.min, abs = math1.abs, pow = math1.pow, PI = math1.PI, round = math1.round, E = "", S = " ", objectToString = Object.prototype.toString, ISURL = /^url\(['"]?([^\)]+?)['"]?\)$/i, colourRegExp = /^\s*((#[a-f\d]{6})|(#[a-f\d]{3})|rgba?\(\s*([\d\.]+%?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+%?(?:\s*,\s*[\d\.]+%?)?)\s*\)|hsba?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\)|hsla?\(\s*([\d\.]+(?:deg|\xb0|%)?\s*,\s*[\d\.]+%?\s*,\s*[\d\.]+(?:%?\s*,\s*[\d\.]+)?%?)\s*\))\s*$/i, bezierrg = /^(?:cubic-)?bezier\(([^,]+),([^,]+),([^,]+),([^\)]+)\)/, separator = Snap._.separator = /[,\s]+/, whitespace = /[\s]/g, commaSpaces = /[\s]*,[\s]*/, hsrg = {
        hs: 1,
        rg: 1
    }, pathCommand = /([a-z])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig, tCommand = /([rstm])[\s,]*((-?\d*\.?\d*(?:e[\-+]?\d+)?[\s]*,?[\s]*)+)/ig, pathValues = /(-?\d*\.?\d*(?:e[\-+]?\d+)?)[\s]*,?[\s]*/ig, idgen = 0, idprefix = "S" + (+new Date).toString(36), ID = function(el) {
        return (el && el.type ? el.type : E) + idprefix + (idgen++).toString(36);
    }, xlink = "http://www.w3.org/1999/xlink", xmlns = "http://www.w3.org/2000/svg", hub = {}, /*\
     * Snap.url
     [ method ]
     **
     * Wraps path into `"url('<path>')"`.
     - value (string) path
     = (string) wrapped path
    \*/ URL = Snap.url = function(url) {
        return "url('#" + url + "')";
    };
    function $(el, attr) {
        if (attr) {
            if (el == "#text") el = glob.doc.createTextNode(attr.text || attr["#text"] || "");
            if (el == "#comment") el = glob.doc.createComment(attr.text || attr["#text"] || "");
            if (typeof el == "string") el = $(el);
            if (typeof attr == "string") {
                if (el.nodeType == 1) {
                    if (attr.substring(0, 6) == "xlink:") return el.getAttributeNS(xlink, attr.substring(6));
                    if (attr.substring(0, 4) == "xml:") return el.getAttributeNS(xmlns, attr.substring(4));
                    return el.getAttribute(attr);
                } else if (attr == "text") return el.nodeValue;
                else return null;
            }
            if (el.nodeType == 1) {
                for(var key in attr)if (attr[has](key)) {
                    var val = Str(attr[key]);
                    if (val) {
                        if (key.substring(0, 6) == "xlink:") el.setAttributeNS(xlink, key.substring(6), val);
                        else if (key.substring(0, 4) == "xml:") el.setAttributeNS(xmlns, key.substring(4), val);
                        else el.setAttribute(key, val);
                    } else el.removeAttribute(key);
                }
            } else if ("text" in attr) el.nodeValue = attr.text;
        } else el = glob.doc.createElementNS(xmlns, el);
        return el;
    }
    Snap._.$ = $;
    Snap._.id = ID;
    function getAttrs(el) {
        var attrs = el.attributes, name, out = {};
        for(var i = 0; i < attrs.length; i++){
            if (attrs[i].namespaceURI == xlink) name = "xlink:";
            else name = "";
            name += attrs[i].name;
            out[name] = attrs[i].textContent;
        }
        return out;
    }
    function is(o, type) {
        type = Str.prototype.toLowerCase.call(type);
        if (type == "finite") return isFinite(o);
        if (type == "array" && (o instanceof Array || Array.isArray && Array.isArray(o))) return true;
        return type == "null" && o === null || type == typeof o && o !== null || type == "object" && o === Object(o) || objectToString.call(o).slice(8, -1).toLowerCase() == type;
    }
    /*\
 * Snap.format
 [ method ]
 **
 * Replaces construction of type `{<name>}` to the corresponding argument
 **
 - token (string) string to format
 - json (object) object which properties are used as a replacement
 = (string) formatted string
 > Usage
 | // this draws a rectangular shape equivalent to "M10,20h40v50h-40z"
 | paper.path(Snap.format("M{x},{y}h{dim.width}v{dim.height}h{dim['negative width']}z", {
 |     x: 10,
 |     y: 20,
 |     dim: {
 |         width: 40,
 |         height: 50,
 |         "negative width": -40
 |     }
 | }));
\*/ Snap.format = function() {
        var tokenRegex = /\{([^\}]+)\}/g, objNotationRegex = /(?:(?:^|\.)(.+?)(?=\[|\.|$|\()|\[('|")(.+?)\2\])(\(\))?/g, replacer = function(all, key, obj) {
            var res1 = obj;
            key.replace(objNotationRegex, function(all, name, quote, quotedName, isFunc) {
                name = name || quotedName;
                if (res1) {
                    if (name in res1) res1 = res1[name];
                    typeof res1 == "function" && isFunc && (res1 = res1());
                }
            });
            res1 = (res1 == null || res1 == obj ? all : res1) + "";
            return res1;
        };
        return function(str, obj) {
            return Str(str).replace(tokenRegex, function(all, key) {
                return replacer(all, key, obj);
            });
        };
    }();
    function clone(obj) {
        if (typeof obj == "function" || Object(obj) !== obj) return obj;
        var res1 = new obj.constructor;
        for(var key in obj)if (obj[has](key)) res1[key] = clone(obj[key]);
        return res1;
    }
    Snap._.clone = clone;
    function repush(array, item) {
        for(var i = 0, ii = array.length; i < ii; i++)if (array[i] === item) return array.push(array.splice(i, 1)[0]);
    }
    function cacher(f, scope, postprocessor) {
        function newf() {
            var arg = Array.prototype.slice.call(arguments, 0), args = arg.join("\u2400"), cache = newf.cache = newf.cache || {}, count = newf.count = newf.count || [];
            if (cache[has](args)) {
                repush(count, args);
                return postprocessor ? postprocessor(cache[args]) : cache[args];
            }
            count.length >= 1e3 && delete cache[count.shift()];
            count.push(args);
            cache[args] = f.apply(scope, arg);
            return postprocessor ? postprocessor(cache[args]) : cache[args];
        }
        return newf;
    }
    Snap._.cacher = cacher;
    function angle(x1, y1, x2, y2, x3, y3) {
        if (x3 == null) {
            var x = x1 - x2, y = y1 - y2;
            if (!x && !y) return 0;
            return (180 + math1.atan2(-y, -x) * 180 / PI + 360) % 360;
        } else return angle(x1, y1, x3, y3) - angle(x2, y2, x3, y3);
    }
    function rad(deg) {
        return deg % 360 * PI / 180;
    }
    function deg(rad) {
        return rad * 180 / PI % 360;
    }
    function x_y() {
        return this.x + S + this.y;
    }
    function x_y_w_h() {
        return this.x + S + this.y + S + this.width + " \xd7 " + this.height;
    }
    /*\
 * Snap.rad
 [ method ]
 **
 * Transform angle to radians
 - deg (number) angle in degrees
 = (number) angle in radians
\*/ Snap.rad = rad;
    /*\
 * Snap.deg
 [ method ]
 **
 * Transform angle to degrees
 - rad (number) angle in radians
 = (number) angle in degrees
\*/ Snap.deg = deg;
    /*\
 * Snap.sin
 [ method ]
 **
 * Equivalent to `Math.sin()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) sin
\*/ Snap.sin = function(angle) {
        return math1.sin(Snap.rad(angle));
    };
    /*\
 * Snap.tan
 [ method ]
 **
 * Equivalent to `Math.tan()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) tan
\*/ Snap.tan = function(angle) {
        return math1.tan(Snap.rad(angle));
    };
    /*\
 * Snap.cos
 [ method ]
 **
 * Equivalent to `Math.cos()` only works with degrees, not radians.
 - angle (number) angle in degrees
 = (number) cos
\*/ Snap.cos = function(angle) {
        return math1.cos(Snap.rad(angle));
    };
    /*\
 * Snap.asin
 [ method ]
 **
 * Equivalent to `Math.asin()` only works with degrees, not radians.
 - num (number) value
 = (number) asin in degrees
\*/ Snap.asin = function(num) {
        return Snap.deg(math1.asin(num));
    };
    /*\
 * Snap.acos
 [ method ]
 **
 * Equivalent to `Math.acos()` only works with degrees, not radians.
 - num (number) value
 = (number) acos in degrees
\*/ Snap.acos = function(num) {
        return Snap.deg(math1.acos(num));
    };
    /*\
 * Snap.atan
 [ method ]
 **
 * Equivalent to `Math.atan()` only works with degrees, not radians.
 - num (number) value
 = (number) atan in degrees
\*/ Snap.atan = function(num) {
        return Snap.deg(math1.atan(num));
    };
    /*\
 * Snap.atan2
 [ method ]
 **
 * Equivalent to `Math.atan2()` only works with degrees, not radians.
 - num (number) value
 = (number) atan2 in degrees
\*/ Snap.atan2 = function(num) {
        return Snap.deg(math1.atan2(num));
    };
    /*\
 * Snap.angle
 [ method ]
 **
 * Returns an angle between two or three points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 - x3 (number) #optional x coord of third point
 - y3 (number) #optional y coord of third point
 = (number) angle in degrees
\*/ Snap.angle = angle;
    /*\
 * Snap.len
 [ method ]
 **
 * Returns distance between two points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/ Snap.len = function(x1, y1, x2, y2) {
        return Math.sqrt(Snap.len2(x1, y1, x2, y2));
    };
    /*\
 * Snap.len2
 [ method ]
 **
 * Returns squared distance between two points
 - x1 (number) x coord of first point
 - y1 (number) y coord of first point
 - x2 (number) x coord of second point
 - y2 (number) y coord of second point
 = (number) distance
\*/ Snap.len2 = function(x1, y1, x2, y2) {
        return (x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2);
    };
    /*\
 * Snap.closestPoint
 [ method ]
 **
 * Returns closest point to a given one on a given path.
 - path (Element) path element
 - x (number) x coord of a point
 - y (number) y coord of a point
 = (object) in format
 {
    x (number) x coord of the point on the path
    y (number) y coord of the point on the path
    length (number) length of the path to the point
    distance (number) distance from the given point to the path
 }
\*/ // Copied from http://bl.ocks.org/mbostock/8027637
    Snap.closestPoint = function(path, x, y) {
        function distance2(p) {
            var dx = p.x - x, dy = p.y - y;
            return dx * dx + dy * dy;
        }
        var pathNode = path.node, pathLength = pathNode.getTotalLength(), precision = pathLength / pathNode.pathSegList.numberOfItems * .125, best, bestLength, bestDistance = Infinity;
        // linear scan for coarse approximation
        for(var scan, scanLength = 0, scanDistance; scanLength <= pathLength; scanLength += precision)if ((scanDistance = distance2(scan = pathNode.getPointAtLength(scanLength))) < bestDistance) {
            best = scan;
            bestLength = scanLength;
            bestDistance = scanDistance;
        }
        // binary search for precise estimate
        precision *= .5;
        while(precision > .5){
            var before, after, beforeLength, afterLength, beforeDistance, afterDistance;
            if ((beforeLength = bestLength - precision) >= 0 && (beforeDistance = distance2(before = pathNode.getPointAtLength(beforeLength))) < bestDistance) {
                best = before;
                bestLength = beforeLength;
                bestDistance = beforeDistance;
            } else if ((afterLength = bestLength + precision) <= pathLength && (afterDistance = distance2(after = pathNode.getPointAtLength(afterLength))) < bestDistance) {
                best = after;
                bestLength = afterLength;
                bestDistance = afterDistance;
            } else precision *= .5;
        }
        best = {
            x: best.x,
            y: best.y,
            length: bestLength,
            distance: Math.sqrt(bestDistance)
        };
        return best;
    };
    /*\
 * Snap.is
 [ method ]
 **
 * Handy replacement for the `typeof` operator
 - o (…) any object or primitive
 - type (string) name of the type, e.g., `string`, `function`, `number`, etc.
 = (boolean) `true` if given value is of given type
\*/ Snap.is = is;
    /*\
 * Snap.snapTo
 [ method ]
 **
 * Snaps given value to given grid
 - values (array|number) given array of values or step of the grid
 - value (number) value to adjust
 - tolerance (number) #optional maximum distance to the target value that would trigger the snap. Default is `10`.
 = (number) adjusted value
\*/ Snap.snapTo = function(values, value, tolerance) {
        tolerance = is(tolerance, "finite") ? tolerance : 10;
        if (is(values, "array")) {
            var i = values.length;
            while(i--)if (abs(values[i] - value) <= tolerance) return values[i];
        } else {
            values = +values;
            var rem = value % values;
            if (rem < tolerance) return value - rem;
            if (rem > values - tolerance) return value - rem + values;
        }
        return value;
    };
    // Colour
    /*\
 * Snap.getRGB
 [ method ]
 **
 * Parses color string as RGB object
 - color (string) color string in one of the following formats:
 # <ul>
 #     <li>Color name (<code>red</code>, <code>green</code>, <code>cornflowerblue</code>, etc)</li>
 #     <li>#••• — shortened HTML color: (<code>#000</code>, <code>#fc0</code>, etc.)</li>
 #     <li>#•••••• — full length HTML color: (<code>#000000</code>, <code>#bd2300</code>)</li>
 #     <li>rgb(•••, •••, •••) — red, green and blue channels values: (<code>rgb(200,&nbsp;100,&nbsp;0)</code>)</li>
 #     <li>rgba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>rgb(•••%, •••%, •••%) — same as above, but in %: (<code>rgb(100%,&nbsp;175%,&nbsp;0%)</code>)</li>
 #     <li>rgba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsb(•••, •••, •••) — hue, saturation and brightness values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;1)</code>)</li>
 #     <li>hsba(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsb(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsba(•••%, •••%, •••%, •••%) — also with opacity</li>
 #     <li>hsl(•••, •••, •••) — hue, saturation and luminosity values: (<code>hsb(0.5,&nbsp;0.25,&nbsp;0.5)</code>)</li>
 #     <li>hsla(•••, •••, •••, •••) — also with opacity</li>
 #     <li>hsl(•••%, •••%, •••%) — same as above, but in %</li>
 #     <li>hsla(•••%, •••%, •••%, •••%) — also with opacity</li>
 # </ul>
 * Note that `%` can be used any time: `rgb(20%, 255, 50%)`.
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) true if string can't be parsed
 o }
\*/ Snap.getRGB = cacher(function(colour) {
        if (!colour || !!((colour = Str(colour)).indexOf("-") + 1)) return {
            r: -1,
            g: -1,
            b: -1,
            hex: "none",
            error: 1,
            toString: rgbtoString
        };
        if (colour == "none") return {
            r: -1,
            g: -1,
            b: -1,
            hex: "none",
            toString: rgbtoString
        };
        !(hsrg[has](colour.toLowerCase().substring(0, 2)) || colour.charAt() == "#") && (colour = toHex(colour));
        if (!colour) return {
            r: -1,
            g: -1,
            b: -1,
            hex: "none",
            error: 1,
            toString: rgbtoString
        };
        var res1, red, green, blue, opacity, t, values, rgb = colour.match(colourRegExp);
        if (rgb) {
            if (rgb[2]) {
                blue = toInt(rgb[2].substring(5), 16);
                green = toInt(rgb[2].substring(3, 5), 16);
                red = toInt(rgb[2].substring(1, 3), 16);
            }
            if (rgb[3]) {
                blue = toInt((t = rgb[3].charAt(3)) + t, 16);
                green = toInt((t = rgb[3].charAt(2)) + t, 16);
                red = toInt((t = rgb[3].charAt(1)) + t, 16);
            }
            if (rgb[4]) {
                values = rgb[4].split(commaSpaces);
                red = toFloat(values[0]);
                values[0].slice(-1) == "%" && (red *= 2.55);
                green = toFloat(values[1]);
                values[1].slice(-1) == "%" && (green *= 2.55);
                blue = toFloat(values[2]);
                values[2].slice(-1) == "%" && (blue *= 2.55);
                rgb[1].toLowerCase().slice(0, 4) == "rgba" && (opacity = toFloat(values[3]));
                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
            }
            if (rgb[5]) {
                values = rgb[5].split(commaSpaces);
                red = toFloat(values[0]);
                values[0].slice(-1) == "%" && (red /= 100);
                green = toFloat(values[1]);
                values[1].slice(-1) == "%" && (green /= 100);
                blue = toFloat(values[2]);
                values[2].slice(-1) == "%" && (blue /= 100);
                (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
                rgb[1].toLowerCase().slice(0, 4) == "hsba" && (opacity = toFloat(values[3]));
                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
                return Snap.hsb2rgb(red, green, blue, opacity);
            }
            if (rgb[6]) {
                values = rgb[6].split(commaSpaces);
                red = toFloat(values[0]);
                values[0].slice(-1) == "%" && (red /= 100);
                green = toFloat(values[1]);
                values[1].slice(-1) == "%" && (green /= 100);
                blue = toFloat(values[2]);
                values[2].slice(-1) == "%" && (blue /= 100);
                (values[0].slice(-3) == "deg" || values[0].slice(-1) == "\xb0") && (red /= 360);
                rgb[1].toLowerCase().slice(0, 4) == "hsla" && (opacity = toFloat(values[3]));
                values[3] && values[3].slice(-1) == "%" && (opacity /= 100);
                return Snap.hsl2rgb(red, green, blue, opacity);
            }
            red = mmin(math1.round(red), 255);
            green = mmin(math1.round(green), 255);
            blue = mmin(math1.round(blue), 255);
            opacity = mmin(mmax(opacity, 0), 1);
            rgb = {
                r: red,
                g: green,
                b: blue,
                toString: rgbtoString
            };
            rgb.hex = "#" + (16777216 | blue | green << 8 | red << 16).toString(16).slice(1);
            rgb.opacity = is(opacity, "finite") ? opacity : 1;
            return rgb;
        }
        return {
            r: -1,
            g: -1,
            b: -1,
            hex: "none",
            error: 1,
            toString: rgbtoString
        };
    }, Snap);
    /*\
 * Snap.hsb
 [ method ]
 **
 * Converts HSB values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - b (number) value or brightness
 = (string) hex representation of the color
\*/ Snap.hsb = cacher(function(h, s, b) {
        return Snap.hsb2rgb(h, s, b).hex;
    });
    /*\
 * Snap.hsl
 [ method ]
 **
 * Converts HSL values to a hex representation of the color
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (string) hex representation of the color
\*/ Snap.hsl = cacher(function(h, s, l) {
        return Snap.hsl2rgb(h, s, l).hex;
    });
    /*\
 * Snap.rgb
 [ method ]
 **
 * Converts RGB values to a hex representation of the color
 - r (number) red
 - g (number) green
 - b (number) blue
 = (string) hex representation of the color
\*/ Snap.rgb = cacher(function(r, g1, b, o) {
        if (is(o, "finite")) {
            var round = math1.round;
            return "rgba(" + [
                round(r),
                round(g1),
                round(b),
                +o.toFixed(2)
            ] + ")";
        }
        return "#" + (16777216 | b | g1 << 8 | r << 16).toString(16).slice(1);
    });
    var toHex = function(color) {
        var i = glob.doc.getElementsByTagName("head")[0] || glob.doc.getElementsByTagName("svg")[0], red = "rgb(255, 0, 0)";
        toHex = cacher(function(color) {
            if (color.toLowerCase() == "red") return red;
            i.style.color = red;
            i.style.color = color;
            var out = glob.doc.defaultView.getComputedStyle(i, E).getPropertyValue("color");
            return out == red ? null : out;
        });
        return toHex(color);
    }, hsbtoString = function() {
        return "hsb(" + [
            this.h,
            this.s,
            this.b
        ] + ")";
    }, hsltoString = function() {
        return "hsl(" + [
            this.h,
            this.s,
            this.l
        ] + ")";
    }, rgbtoString = function() {
        return this.opacity == 1 || this.opacity == null ? this.hex : "rgba(" + [
            this.r,
            this.g,
            this.b,
            this.opacity
        ] + ")";
    }, prepareRGB = function(r, g1, b) {
        if (g1 == null && is(r, "object") && "r" in r && "g" in r && "b" in r) {
            b = r.b;
            g1 = r.g;
            r = r.r;
        }
        if (g1 == null && is(r, string)) {
            var clr = Snap.getRGB(r);
            r = clr.r;
            g1 = clr.g;
            b = clr.b;
        }
        if (r > 1 || g1 > 1 || b > 1) {
            r /= 255;
            g1 /= 255;
            b /= 255;
        }
        return [
            r,
            g1,
            b
        ];
    }, packageRGB = function(r, g1, b, o) {
        r = math1.round(r * 255);
        g1 = math1.round(g1 * 255);
        b = math1.round(b * 255);
        var rgb = {
            r: r,
            g: g1,
            b: b,
            opacity: is(o, "finite") ? o : 1,
            hex: Snap.rgb(r, g1, b),
            toString: rgbtoString
        };
        is(o, "finite") && (rgb.opacity = o);
        return rgb;
    };
    /*\
 * Snap.color
 [ method ]
 **
 * Parses the color string and returns an object featuring the color's component values
 - clr (string) color string in one of the supported formats (see @Snap.getRGB)
 = (object) Combined RGB/HSB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••,
 o     error (boolean) `true` if string can't be parsed,
 o     h (number) hue,
 o     s (number) saturation,
 o     v (number) value (brightness),
 o     l (number) lightness
 o }
\*/ Snap.color = function(clr) {
        var rgb;
        if (is(clr, "object") && "h" in clr && "s" in clr && "b" in clr) {
            rgb = Snap.hsb2rgb(clr);
            clr.r = rgb.r;
            clr.g = rgb.g;
            clr.b = rgb.b;
            clr.opacity = 1;
            clr.hex = rgb.hex;
        } else if (is(clr, "object") && "h" in clr && "s" in clr && "l" in clr) {
            rgb = Snap.hsl2rgb(clr);
            clr.r = rgb.r;
            clr.g = rgb.g;
            clr.b = rgb.b;
            clr.opacity = 1;
            clr.hex = rgb.hex;
        } else {
            if (is(clr, "string")) clr = Snap.getRGB(clr);
            if (is(clr, "object") && "r" in clr && "g" in clr && "b" in clr && !("error" in clr)) {
                rgb = Snap.rgb2hsl(clr);
                clr.h = rgb.h;
                clr.s = rgb.s;
                clr.l = rgb.l;
                rgb = Snap.rgb2hsb(clr);
                clr.v = rgb.b;
            } else {
                clr = {
                    hex: "none"
                };
                clr.r = clr.g = clr.b = clr.h = clr.s = clr.v = clr.l = -1;
                clr.error = 1;
            }
        }
        clr.toString = rgbtoString;
        return clr;
    };
    /*\
 * Snap.hsb2rgb
 [ method ]
 **
 * Converts HSB values to an RGB object
 - h (number) hue
 - s (number) saturation
 - v (number) value or brightness
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/ Snap.hsb2rgb = function(h, s, v, o) {
        if (is(h, "object") && "h" in h && "s" in h && "b" in h) {
            v = h.b;
            s = h.s;
            o = h.o;
            h = h.h;
        }
        h *= 360;
        var R, G, B, X, C;
        h = h % 360 / 60;
        C = v * s;
        X = C * (1 - abs(h % 2 - 1));
        R = G = B = v - C;
        h = ~~h;
        R += [
            C,
            X,
            0,
            0,
            X,
            C
        ][h];
        G += [
            X,
            C,
            C,
            X,
            0,
            0
        ][h];
        B += [
            0,
            0,
            X,
            C,
            C,
            X
        ][h];
        return packageRGB(R, G, B, o);
    };
    /*\
 * Snap.hsl2rgb
 [ method ]
 **
 * Converts HSL values to an RGB object
 - h (number) hue
 - s (number) saturation
 - l (number) luminosity
 = (object) RGB object in the following format:
 o {
 o     r (number) red,
 o     g (number) green,
 o     b (number) blue,
 o     hex (string) color in HTML/CSS format: #••••••
 o }
\*/ Snap.hsl2rgb = function(h, s, l, o) {
        if (is(h, "object") && "h" in h && "s" in h && "l" in h) {
            l = h.l;
            s = h.s;
            h = h.h;
        }
        if (h > 1 || s > 1 || l > 1) {
            h /= 360;
            s /= 100;
            l /= 100;
        }
        h *= 360;
        var R, G, B, X, C;
        h = h % 360 / 60;
        C = 2 * s * (l < .5 ? l : 1 - l);
        X = C * (1 - abs(h % 2 - 1));
        R = G = B = l - C / 2;
        h = ~~h;
        R += [
            C,
            X,
            0,
            0,
            X,
            C
        ][h];
        G += [
            X,
            C,
            C,
            X,
            0,
            0
        ][h];
        B += [
            0,
            0,
            X,
            C,
            C,
            X
        ][h];
        return packageRGB(R, G, B, o);
    };
    /*\
 * Snap.rgb2hsb
 [ method ]
 **
 * Converts RGB values to an HSB object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSB object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     b (number) brightness
 o }
\*/ Snap.rgb2hsb = function(r, g1, b) {
        b = prepareRGB(r, g1, b);
        r = b[0];
        g1 = b[1];
        b = b[2];
        var H, S, V, C;
        V = mmax(r, g1, b);
        C = V - mmin(r, g1, b);
        H = C == 0 ? null : V == r ? (g1 - b) / C : V == g1 ? (b - r) / C + 2 : (r - g1) / C + 4;
        H = (H + 360) % 6 * 60 / 360;
        S = C == 0 ? 0 : C / V;
        return {
            h: H,
            s: S,
            b: V,
            toString: hsbtoString
        };
    };
    /*\
 * Snap.rgb2hsl
 [ method ]
 **
 * Converts RGB values to an HSL object
 - r (number) red
 - g (number) green
 - b (number) blue
 = (object) HSL object in the following format:
 o {
 o     h (number) hue,
 o     s (number) saturation,
 o     l (number) luminosity
 o }
\*/ Snap.rgb2hsl = function(r, g1, b) {
        b = prepareRGB(r, g1, b);
        r = b[0];
        g1 = b[1];
        b = b[2];
        var H, S, L, M, m, C;
        M = mmax(r, g1, b);
        m = mmin(r, g1, b);
        C = M - m;
        H = C == 0 ? null : M == r ? (g1 - b) / C : M == g1 ? (b - r) / C + 2 : (r - g1) / C + 4;
        H = (H + 360) % 6 * 60 / 360;
        L = (M + m) / 2;
        S = C == 0 ? 0 : L < .5 ? C / (2 * L) : C / (2 - 2 * L);
        return {
            h: H,
            s: S,
            l: L,
            toString: hsltoString
        };
    };
    // Transformations
    /*\
 * Snap.parsePathString
 [ method ]
 **
 * Utility method
 **
 * Parses given path string into an array of arrays of path segments
 - pathString (string|array) path string or array of segments (in the last case it is returned straight away)
 = (array) array of segments
\*/ Snap.parsePathString = function(pathString) {
        if (!pathString) return null;
        var pth = Snap.path(pathString);
        if (pth.arr) return Snap.path.clone(pth.arr);
        var paramCounts = {
            a: 7,
            c: 6,
            o: 2,
            h: 1,
            l: 2,
            m: 2,
            r: 4,
            q: 4,
            s: 4,
            t: 2,
            v: 1,
            u: 3,
            z: 0
        }, data = [];
        if (is(pathString, "array") && is(pathString[0], "array")) data = Snap.path.clone(pathString);
        if (!data.length) Str(pathString).replace(pathCommand, function(a, b, c) {
            var params = [], name = b.toLowerCase();
            c.replace(pathValues, function(a, b) {
                b && params.push(+b);
            });
            if (name == "m" && params.length > 2) {
                data.push([
                    b
                ].concat(params.splice(0, 2)));
                name = "l";
                b = b == "m" ? "l" : "L";
            }
            if (name == "o" && params.length == 1) data.push([
                b,
                params[0]
            ]);
            if (name == "r") data.push([
                b
            ].concat(params));
            else while(params.length >= paramCounts[name]){
                data.push([
                    b
                ].concat(params.splice(0, paramCounts[name])));
                if (!paramCounts[name]) break;
            }
        });
        data.toString = Snap.path.toString;
        pth.arr = Snap.path.clone(data);
        return data;
    };
    /*\
 * Snap.parseTransformString
 [ method ]
 **
 * Utility method
 **
 * Parses given transform string into an array of transformations
 - TString (string|array) transform string or array of transformations (in the last case it is returned straight away)
 = (array) array of transformations
\*/ var parseTransformString = Snap.parseTransformString = function(TString) {
        if (!TString) return null;
        var paramCounts = {
            r: 3,
            s: 4,
            t: 2,
            m: 6
        }, data = [];
        if (is(TString, "array") && is(TString[0], "array")) data = Snap.path.clone(TString);
        if (!data.length) Str(TString).replace(tCommand, function(a, b, c) {
            var params = [], name = b.toLowerCase();
            c.replace(pathValues, function(a, b) {
                b && params.push(+b);
            });
            data.push([
                b
            ].concat(params));
        });
        data.toString = Snap.path.toString;
        return data;
    };
    function svgTransform2string(tstr) {
        var res1 = [];
        tstr = tstr.replace(/(?:^|\s)(\w+)\(([^)]+)\)/g, function(all, name, params) {
            params = params.split(/\s*,\s*|\s+/);
            if (name == "rotate" && params.length == 1) params.push(0, 0);
            if (name == "scale") {
                if (params.length > 2) params = params.slice(0, 2);
                else if (params.length == 2) params.push(0, 0);
                if (params.length == 1) params.push(params[0], 0, 0);
            }
            if (name == "skewX") res1.push([
                "m",
                1,
                0,
                math1.tan(rad(params[0])),
                1,
                0,
                0
            ]);
            else if (name == "skewY") res1.push([
                "m",
                1,
                math1.tan(rad(params[0])),
                0,
                1,
                0,
                0
            ]);
            else res1.push([
                name.charAt(0)
            ].concat(params));
            return all;
        });
        return res1;
    }
    Snap._.svgTransform2string = svgTransform2string;
    Snap._.rgTransform = /^[a-z][\s]*-?\.?\d/i;
    function transform2matrix(tstr, bbox) {
        var tdata = parseTransformString(tstr), m = new Snap.Matrix;
        if (tdata) for(var i = 0, ii = tdata.length; i < ii; i++){
            var t = tdata[i], tlen = t.length, command = Str(t[0]).toLowerCase(), absolute = t[0] != command, inver = absolute ? m.invert() : 0, x1, y1, x2, y2, bb;
            if (command == "t" && tlen == 2) m.translate(t[1], 0);
            else if (command == "t" && tlen == 3) {
                if (absolute) {
                    x1 = inver.x(0, 0);
                    y1 = inver.y(0, 0);
                    x2 = inver.x(t[1], t[2]);
                    y2 = inver.y(t[1], t[2]);
                    m.translate(x2 - x1, y2 - y1);
                } else m.translate(t[1], t[2]);
            } else if (command == "r") {
                if (tlen == 2) {
                    bb = bb || bbox;
                    m.rotate(t[1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.rotate(t[1], x2, y2);
                    } else m.rotate(t[1], t[2], t[3]);
                }
            } else if (command == "s") {
                if (tlen == 2 || tlen == 3) {
                    bb = bb || bbox;
                    m.scale(t[1], t[tlen - 1], bb.x + bb.width / 2, bb.y + bb.height / 2);
                } else if (tlen == 4) {
                    if (absolute) {
                        x2 = inver.x(t[2], t[3]);
                        y2 = inver.y(t[2], t[3]);
                        m.scale(t[1], t[1], x2, y2);
                    } else m.scale(t[1], t[1], t[2], t[3]);
                } else if (tlen == 5) {
                    if (absolute) {
                        x2 = inver.x(t[3], t[4]);
                        y2 = inver.y(t[3], t[4]);
                        m.scale(t[1], t[2], x2, y2);
                    } else m.scale(t[1], t[2], t[3], t[4]);
                }
            } else if (command == "m" && tlen == 7) m.add(t[1], t[2], t[3], t[4], t[5], t[6]);
        }
        return m;
    }
    Snap._.transform2matrix = transform2matrix;
    Snap._unit2px = unit2px;
    var contains = glob.doc.contains || glob.doc.compareDocumentPosition ? function(a, b) {
        var adown = a.nodeType == 9 ? a.documentElement : a, bup = b && b.parentNode;
        return a == bup || !!(bup && bup.nodeType == 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    } : function(a, b) {
        if (b) while(b){
            b = b.parentNode;
            if (b == a) return true;
        }
        return false;
    };
    function getSomeDefs(el) {
        var p = el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || el.node.parentNode && wrap(el.node.parentNode) || Snap.select("svg") || Snap(0, 0), pdefs = p.select("defs"), defs = pdefs == null ? false : pdefs.node;
        if (!defs) defs = make("defs", p.node).node;
        return defs;
    }
    function getSomeSVG(el) {
        return el.node.ownerSVGElement && wrap(el.node.ownerSVGElement) || Snap.select("svg");
    }
    Snap._.getSomeDefs = getSomeDefs;
    Snap._.getSomeSVG = getSomeSVG;
    function unit2px(el, name, value) {
        var svg = getSomeSVG(el).node, out = {}, mgr = svg.querySelector(".svg---mgr");
        if (!mgr) {
            mgr = $("rect");
            $(mgr, {
                x: -9000000000,
                y: -9000000000,
                width: 10,
                height: 10,
                "class": "svg---mgr",
                fill: "none"
            });
            svg.appendChild(mgr);
        }
        function getW(val) {
            if (val == null) return E;
            if (val == +val) return val;
            $(mgr, {
                width: val
            });
            try {
                return mgr.getBBox().width;
            } catch (e) {
                return 0;
            }
        }
        function getH(val) {
            if (val == null) return E;
            if (val == +val) return val;
            $(mgr, {
                height: val
            });
            try {
                return mgr.getBBox().height;
            } catch (e) {
                return 0;
            }
        }
        function set(nam, f) {
            if (name == null) out[nam] = f(el.attr(nam) || 0);
            else if (nam == name) out = f(value == null ? el.attr(nam) || 0 : value);
        }
        switch(el.type){
            case "rect":
                set("rx", getW);
                set("ry", getH);
            case "image":
                set("width", getW);
                set("height", getH);
            case "text":
                set("x", getW);
                set("y", getH);
                break;
            case "circle":
                set("cx", getW);
                set("cy", getH);
                set("r", getW);
                break;
            case "ellipse":
                set("cx", getW);
                set("cy", getH);
                set("rx", getW);
                set("ry", getH);
                break;
            case "line":
                set("x1", getW);
                set("x2", getW);
                set("y1", getH);
                set("y2", getH);
                break;
            case "marker":
                set("refX", getW);
                set("markerWidth", getW);
                set("refY", getH);
                set("markerHeight", getH);
                break;
            case "radialGradient":
                set("fx", getW);
                set("fy", getH);
                break;
            case "tspan":
                set("dx", getW);
                set("dy", getH);
                break;
            default:
                set(name, getW);
        }
        svg.removeChild(mgr);
        return out;
    }
    /*\
 * Snap.select
 [ method ]
 **
 * Wraps a DOM element specified by CSS selector as @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/ Snap.select = function(query) {
        query = Str(query).replace(/([^\\]):/g, "$1\\:");
        return wrap(glob.doc.querySelector(query));
    };
    /*\
 * Snap.selectAll
 [ method ]
 **
 * Wraps DOM elements specified by CSS selector as set or array of @Element
 - query (string) CSS selector of the element
 = (Element) the current element
\*/ Snap.selectAll = function(query) {
        var nodelist = glob.doc.querySelectorAll(query), set = (Snap.set || Array)();
        for(var i = 0; i < nodelist.length; i++)set.push(wrap(nodelist[i]));
        return set;
    };
    function add2group(list) {
        if (!is(list, "array")) list = Array.prototype.slice.call(arguments, 0);
        var i = 0, j = 0, node = this.node;
        while(this[i])delete this[i++];
        for(i = 0; i < list.length; i++)if (list[i].type == "set") list[i].forEach(function(el) {
            node.appendChild(el.node);
        });
        else node.appendChild(list[i].node);
        var children = node.childNodes;
        for(i = 0; i < children.length; i++)this[j++] = wrap(children[i]);
        return this;
    }
    // Hub garbage collector every 10s
    setInterval(function() {
        for(var key in hub)if (hub[has](key)) {
            var el = hub[key], node = el.node;
            if (el.type != "svg" && !node.ownerSVGElement || el.type == "svg" && (!node.parentNode || "ownerSVGElement" in node.parentNode && !node.ownerSVGElement)) delete hub[key];
        }
    }, 1e4);
    function Element(el) {
        if (el.snap in hub) return hub[el.snap];
        var svg;
        try {
            svg = el.ownerSVGElement;
        } catch (e) {}
        /*\
     * Element.node
     [ property (object) ]
     **
     * Gives you a reference to the DOM object, so you can assign event handlers or just mess around.
     > Usage
     | // draw a circle at coordinate 10,10 with radius of 10
     | var c = paper.circle(10, 10, 10);
     | c.node.onclick = function () {
     |     c.attr("fill", "red");
     | };
    \*/ this.node = el;
        if (svg) this.paper = new Paper(svg);
        /*\
     * Element.type
     [ property (string) ]
     **
     * SVG tag name of the given element.
    \*/ this.type = el.tagName || el.nodeName;
        var id = this.id = ID(this);
        this.anims = {};
        this._ = {
            transform: []
        };
        el.snap = id;
        hub[id] = this;
        if (this.type == "g") this.add = add2group;
        if (this.type in {
            g: 1,
            mask: 1,
            pattern: 1,
            symbol: 1
        }) {
            for(var method in Paper.prototype)if (Paper.prototype[has](method)) this[method] = Paper.prototype[method];
        }
    }
    /*\
     * Element.attr
     [ method ]
     **
     * Gets or sets given attributes of the element.
     **
     - params (object) contains key-value pairs of attributes you want to set
     * or
     - param (string) name of the attribute
     = (Element) the current element
     * or
     = (string) value of attribute
     > Usage
     | el.attr({
     |     fill: "#fc0",
     |     stroke: "#000",
     |     strokeWidth: 2, // CamelCase...
     |     "fill-opacity": 0.5, // or dash-separated names
     |     width: "*=2" // prefixed values
     | });
     | console.log(el.attr("fill")); // #fc0
     * Prefixed values in format `"+=10"` supported. All four operations
     * (`+`, `-`, `*` and `/`) could be used. Optionally you can use units for `+`
     * and `-`: `"+=2em"`.
    \*/ Element.prototype.attr = function(params, value) {
        var el = this, node = el.node;
        if (!params) {
            if (node.nodeType != 1) return {
                text: node.nodeValue
            };
            var attr = node.attributes, out = {};
            for(var i = 0, ii = attr.length; i < ii; i++)out[attr[i].nodeName] = attr[i].nodeValue;
            return out;
        }
        if (is(params, "string")) {
            if (arguments.length > 1) {
                var json = {};
                json[params] = value;
                params = json;
            } else return eve("snap.util.getattr." + params, el).firstDefined();
        }
        for(var att in params)if (params[has](att)) eve("snap.util.attr." + att, el, params[att]);
        return el;
    };
    /*\
 * Snap.parse
 [ method ]
 **
 * Parses SVG fragment and converts it into a @Fragment
 **
 - svg (string) SVG string
 = (Fragment) the @Fragment
\*/ Snap.parse = function(svg) {
        var f = glob.doc.createDocumentFragment(), full = true, div = glob.doc.createElement("div");
        svg = Str(svg);
        if (!svg.match(/^\s*<\s*svg(?:\s|>)/)) {
            svg = "<svg>" + svg + "</svg>";
            full = false;
        }
        div.innerHTML = svg;
        svg = div.getElementsByTagName("svg")[0];
        if (svg) {
            if (full) f = svg;
            else while(svg.firstChild)f.appendChild(svg.firstChild);
        }
        return new Fragment(f);
    };
    function Fragment(frag) {
        this.node = frag;
    }
    /*\
 * Snap.fragment
 [ method ]
 **
 * Creates a DOM fragment from a given list of elements or strings
 **
 - varargs (…) SVG string
 = (Fragment) the @Fragment
\*/ Snap.fragment = function() {
        var args = Array.prototype.slice.call(arguments, 0), f = glob.doc.createDocumentFragment();
        for(var i = 0, ii = args.length; i < ii; i++){
            var item = args[i];
            if (item.node && item.node.nodeType) f.appendChild(item.node);
            if (item.nodeType) f.appendChild(item);
            if (typeof item == "string") f.appendChild(Snap.parse(item).node);
        }
        return new Fragment(f);
    };
    function make(name, parent) {
        var res1 = $(name);
        parent.appendChild(res1);
        var el = wrap(res1);
        return el;
    }
    function Paper(w, h) {
        var res1, desc, defs, proto = Paper.prototype;
        if (w && w.tagName && w.tagName.toLowerCase() == "svg") {
            if (w.snap in hub) return hub[w.snap];
            var doc = w.ownerDocument;
            res1 = new Element(w);
            desc = w.getElementsByTagName("desc")[0];
            defs = w.getElementsByTagName("defs")[0];
            if (!desc) {
                desc = $("desc");
                desc.appendChild(doc.createTextNode("Created with Snap"));
                res1.node.appendChild(desc);
            }
            if (!defs) {
                defs = $("defs");
                res1.node.appendChild(defs);
            }
            res1.defs = defs;
            for(var key in proto)if (proto[has](key)) res1[key] = proto[key];
            res1.paper = res1.root = res1;
        } else {
            res1 = make("svg", glob.doc.body);
            $(res1.node, {
                height: h,
                version: 1.1,
                width: w,
                xmlns: xmlns
            });
        }
        return res1;
    }
    function wrap(dom) {
        if (!dom) return dom;
        if (dom instanceof Element || dom instanceof Fragment) return dom;
        if (dom.tagName && dom.tagName.toLowerCase() == "svg") return new Paper(dom);
        if (dom.tagName && dom.tagName.toLowerCase() == "object" && dom.type == "image/svg+xml") return new Paper(dom.contentDocument.getElementsByTagName("svg")[0]);
        return new Element(dom);
    }
    Snap._.make = make;
    Snap._.wrap = wrap;
    /*\
 * Paper.el
 [ method ]
 **
 * Creates an element on paper with a given name and no attributes
 **
 - name (string) tag name
 - attr (object) attributes
 = (Element) the current element
 > Usage
 | var c = paper.circle(10, 10, 10); // is the same as...
 | var c = paper.el("circle").attr({
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
 | // and the same as
 | var c = paper.el("circle", {
 |     cx: 10,
 |     cy: 10,
 |     r: 10
 | });
\*/ Paper.prototype.el = function(name, attr) {
        var el = make(name, this.node);
        attr && el.attr(attr);
        return el;
    };
    /*\
 * Element.children
 [ method ]
 **
 * Returns array of all the children of the element.
 = (array) array of Elements
\*/ Element.prototype.children = function() {
        var out = [], ch = this.node.childNodes;
        for(var i = 0, ii = ch.length; i < ii; i++)out[i] = Snap(ch[i]);
        return out;
    };
    function jsonFiller(root, o) {
        for(var i = 0, ii = root.length; i < ii; i++){
            var item = {
                type: root[i].type,
                attr: root[i].attr()
            }, children = root[i].children();
            o.push(item);
            if (children.length) jsonFiller(children, item.childNodes = []);
        }
    }
    /*\
 * Element.toJSON
 [ method ]
 **
 * Returns object representation of the given element and all its children.
 = (object) in format
 o {
 o     type (string) this.type,
 o     attr (object) attributes map,
 o     childNodes (array) optional array of children in the same format
 o }
\*/ Element.prototype.toJSON = function() {
        var out = [];
        jsonFiller([
            this
        ], out);
        return out[0];
    };
    // default
    eve.on("snap.util.getattr", function() {
        var att = eve.nt();
        att = att.substring(att.lastIndexOf(".") + 1);
        var css = att.replace(/[A-Z]/g, function(letter) {
            return "-" + letter.toLowerCase();
        });
        if (cssAttr[has](css)) return this.node.ownerDocument.defaultView.getComputedStyle(this.node, null).getPropertyValue(css);
        else return $(this.node, att);
    });
    var cssAttr = {
        "alignment-baseline": 0,
        "baseline-shift": 0,
        "clip": 0,
        "clip-path": 0,
        "clip-rule": 0,
        "color": 0,
        "color-interpolation": 0,
        "color-interpolation-filters": 0,
        "color-profile": 0,
        "color-rendering": 0,
        "cursor": 0,
        "direction": 0,
        "display": 0,
        "dominant-baseline": 0,
        "enable-background": 0,
        "fill": 0,
        "fill-opacity": 0,
        "fill-rule": 0,
        "filter": 0,
        "flood-color": 0,
        "flood-opacity": 0,
        "font": 0,
        "font-family": 0,
        "font-size": 0,
        "font-size-adjust": 0,
        "font-stretch": 0,
        "font-style": 0,
        "font-variant": 0,
        "font-weight": 0,
        "glyph-orientation-horizontal": 0,
        "glyph-orientation-vertical": 0,
        "image-rendering": 0,
        "kerning": 0,
        "letter-spacing": 0,
        "lighting-color": 0,
        "marker": 0,
        "marker-end": 0,
        "marker-mid": 0,
        "marker-start": 0,
        "mask": 0,
        "opacity": 0,
        "overflow": 0,
        "pointer-events": 0,
        "shape-rendering": 0,
        "stop-color": 0,
        "stop-opacity": 0,
        "stroke": 0,
        "stroke-dasharray": 0,
        "stroke-dashoffset": 0,
        "stroke-linecap": 0,
        "stroke-linejoin": 0,
        "stroke-miterlimit": 0,
        "stroke-opacity": 0,
        "stroke-width": 0,
        "text-anchor": 0,
        "text-decoration": 0,
        "text-rendering": 0,
        "unicode-bidi": 0,
        "visibility": 0,
        "word-spacing": 0,
        "writing-mode": 0
    };
    eve.on("snap.util.attr", function(value) {
        var att = eve.nt(), attr = {};
        att = att.substring(att.lastIndexOf(".") + 1);
        attr[att] = value;
        var style = att.replace(/-(\w)/gi, function(all, letter) {
            return letter.toUpperCase();
        }), css = att.replace(/[A-Z]/g, function(letter) {
            return "-" + letter.toLowerCase();
        });
        if (cssAttr[has](css)) this.node.style[style] = value == null ? E : value;
        else $(this.node, attr);
    });
    Paper.prototype;
    // simple ajax
    /*\
 * Snap.ajax
 [ method ]
 **
 * Simple implementation of Ajax
 **
 - url (string) URL
 - postData (object|string) data for post request
 - callback (function) callback
 - scope (object) #optional scope of callback
 * or
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
 = (XMLHttpRequest) the XMLHttpRequest object, just in case
\*/ Snap.ajax = function(url, postData, callback, scope) {
        var req = new XMLHttpRequest, id = ID();
        if (req) {
            if (is(postData, "function")) {
                scope = callback;
                callback = postData;
                postData = null;
            } else if (is(postData, "object")) {
                var pd = [];
                for(var key in postData)if (postData.hasOwnProperty(key)) pd.push(encodeURIComponent(key) + "=" + encodeURIComponent(postData[key]));
                postData = pd.join("&");
            }
            req.open(postData ? "POST" : "GET", url, true);
            if (postData) {
                req.setRequestHeader("X-Requested-With", "XMLHttpRequest");
                req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
            }
            if (callback) {
                eve.once("snap.ajax." + id + ".0", callback);
                eve.once("snap.ajax." + id + ".200", callback);
                eve.once("snap.ajax." + id + ".304", callback);
            }
            req.onreadystatechange = function() {
                if (req.readyState != 4) return;
                eve("snap.ajax." + id + "." + req.status, scope, req);
            };
            if (req.readyState == 4) return req;
            req.send(postData);
            return req;
        }
    };
    /*\
 * Snap.load
 [ method ]
 **
 * Loads external SVG file as a @Fragment (see @Snap.ajax for more advanced AJAX)
 **
 - url (string) URL
 - callback (function) callback
 - scope (object) #optional scope of callback
\*/ Snap.load = function(url, callback, scope) {
        Snap.ajax(url, function(req) {
            var f = Snap.parse(req.responseText);
            scope ? callback.call(scope, f) : callback(f);
        });
    };
    var getOffset = function(elem) {
        var box = elem.getBoundingClientRect(), doc = elem.ownerDocument, body = doc.body, docElem = doc.documentElement, clientTop = docElem.clientTop || body.clientTop || 0, clientLeft = docElem.clientLeft || body.clientLeft || 0, top = box.top + (g.win.pageYOffset || docElem.scrollTop || body.scrollTop) - clientTop, left = box.left + (g.win.pageXOffset || docElem.scrollLeft || body.scrollLeft) - clientLeft;
        return {
            y: top,
            x: left
        };
    };
    /*\
 * Snap.getElementByPoint
 [ method ]
 **
 * Returns you topmost element under given point.
 **
 = (object) Snap element object
 - x (number) x coordinate from the top left corner of the window
 - y (number) y coordinate from the top left corner of the window
 > Usage
 | Snap.getElementByPoint(mouseX, mouseY).attr({stroke: "#f00"});
\*/ Snap.getElementByPoint = function(x, y) {
        var paper = this, svg = paper.canvas, target = glob.doc.elementFromPoint(x, y);
        if (glob.win.opera && target.tagName == "svg") {
            var so = getOffset(target), sr = target.createSVGRect();
            sr.x = x - so.x;
            sr.y = y - so.y;
            sr.width = sr.height = 1;
            var hits = target.getIntersectionList(sr, null);
            if (hits.length) target = hits[hits.length - 1];
        }
        if (!target) return null;
        return wrap(target);
    };
    /*\
 * Snap.plugin
 [ method ]
 **
 * Let you write plugins. You pass in a function with five arguments, like this:
 | Snap.plugin(function (Snap, Element, Paper, global, Fragment) {
 |     Snap.newmethod = function () {};
 |     Element.prototype.newmethod = function () {};
 |     Paper.prototype.newmethod = function () {};
 | });
 * Inside the function you have access to all main objects (and their
 * prototypes). This allow you to extend anything you want.
 **
 - f (function) your plugin body
\*/ Snap.plugin = function(f) {
        f(Snap, Element, Paper, glob, Fragment);
    };
    glob.win.Snap = Snap;
    return Snap;
}(window || module.exports);
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype, is = Snap.is, Str = String, unit2px = Snap._unit2px, $ = Snap._.$, make = Snap._.make, getSomeDefs = Snap._.getSomeDefs, has = "hasOwnProperty", wrap = Snap._.wrap;
    /*\
     * Element.getBBox
     [ method ]
     **
     * Returns the bounding box descriptor for the given element
     **
     = (object) bounding box descriptor:
     o {
     o     cx: (number) x of the center,
     o     cy: (number) x of the center,
     o     h: (number) height,
     o     height: (number) height,
     o     path: (string) path command for the box,
     o     r0: (number) radius of a circle that fully encloses the box,
     o     r1: (number) radius of the smallest circle that can be enclosed,
     o     r2: (number) radius of the largest circle that can be enclosed,
     o     vb: (string) box as a viewbox command,
     o     w: (number) width,
     o     width: (number) width,
     o     x2: (number) x of the right side,
     o     x: (number) x of the left side,
     o     y2: (number) y of the bottom edge,
     o     y: (number) y of the top edge
     o }
    \*/ elproto.getBBox = function(isWithoutTransform) {
        if (this.type == "tspan") return Snap._.box(this.node.getClientRects().item(0));
        if (!Snap.Matrix || !Snap.path) return this.node.getBBox();
        var el = this, m = new Snap.Matrix;
        if (el.removed) return Snap._.box();
        while(el.type == "use"){
            if (!isWithoutTransform) m = m.add(el.transform().localMatrix.translate(el.attr("x") || 0, el.attr("y") || 0));
            if (el.original) el = el.original;
            else {
                var href = el.attr("xlink:href");
                el = el.original = el.node.ownerDocument.getElementById(href.substring(href.indexOf("#") + 1));
            }
        }
        var _ = el._, pathfinder = Snap.path.get[el.type] || Snap.path.get.deflt;
        try {
            if (isWithoutTransform) {
                _.bboxwt = pathfinder ? Snap.path.getBBox(el.realPath = pathfinder(el)) : Snap._.box(el.node.getBBox());
                return Snap._.box(_.bboxwt);
            } else {
                el.realPath = pathfinder(el);
                el.matrix = el.transform().localMatrix;
                _.bbox = Snap.path.getBBox(Snap.path.map(el.realPath, m.add(el.matrix)));
                return Snap._.box(_.bbox);
            }
        } catch (e) {
            // Firefox doesn’t give you bbox of hidden element
            return Snap._.box();
        }
    };
    var propString = function() {
        return this.string;
    };
    function extractTransform(el, tstr) {
        if (tstr == null) {
            var doReturn = true;
            if (el.type == "linearGradient" || el.type == "radialGradient") tstr = el.node.getAttribute("gradientTransform");
            else if (el.type == "pattern") tstr = el.node.getAttribute("patternTransform");
            else tstr = el.node.getAttribute("transform");
            if (!tstr) return new Snap.Matrix;
            tstr = Snap._.svgTransform2string(tstr);
        } else {
            if (!Snap._.rgTransform.test(tstr)) tstr = Snap._.svgTransform2string(tstr);
            else tstr = Str(tstr).replace(/\.{3}|\u2026/g, el._.transform || "");
            if (is(tstr, "array")) tstr = Snap.path ? Snap.path.toString.call(tstr) : Str(tstr);
            el._.transform = tstr;
        }
        var m = Snap._.transform2matrix(tstr, el.getBBox(1));
        if (doReturn) return m;
        else el.matrix = m;
    }
    /*\
     * Element.transform
     [ method ]
     **
     * Gets or sets transformation of the element
     **
     - tstr (string) transform string in Snap or SVG format
     = (Element) the current element
     * or
     = (object) transformation descriptor:
     o {
     o     string (string) transform string,
     o     globalMatrix (Matrix) matrix of all transformations applied to element or its parents,
     o     localMatrix (Matrix) matrix of transformations applied only to the element,
     o     diffMatrix (Matrix) matrix of difference between global and local transformations,
     o     global (string) global transformation as string,
     o     local (string) local transformation as string,
     o     toString (function) returns `string` property
     o }
    \*/ elproto.transform = function(tstr) {
        var _ = this._;
        if (tstr == null) {
            var papa = this, global = new Snap.Matrix(this.node.getCTM()), local = extractTransform(this), ms = [
                local
            ], m = new Snap.Matrix, i, localString = local.toTransformString(), string1 = Str(local) == Str(this.matrix) ? Str(_.transform) : localString;
            while(papa.type != "svg" && (papa = papa.parent()))ms.push(extractTransform(papa));
            i = ms.length;
            while(i--)m.add(ms[i]);
            return {
                string: string1,
                globalMatrix: global,
                totalMatrix: m,
                localMatrix: local,
                diffMatrix: global.clone().add(local.invert()),
                global: global.toTransformString(),
                total: m.toTransformString(),
                local: localString,
                toString: propString
            };
        }
        if (tstr instanceof Snap.Matrix) {
            this.matrix = tstr;
            this._.transform = tstr.toTransformString();
        } else extractTransform(this, tstr);
        if (this.node) {
            if (this.type == "linearGradient" || this.type == "radialGradient") $(this.node, {
                gradientTransform: this.matrix
            });
            else if (this.type == "pattern") $(this.node, {
                patternTransform: this.matrix
            });
            else $(this.node, {
                transform: this.matrix
            });
        }
        return this;
    };
    /*\
     * Element.parent
     [ method ]
     **
     * Returns the element's parent
     **
     = (Element) the parent element
    \*/ elproto.parent = function() {
        return wrap(this.node.parentNode);
    };
    /*\
     * Element.append
     [ method ]
     **
     * Appends the given element to current one
     **
     - el (Element|Set) element to append
     = (Element) the parent element
    \*/ /*\
     * Element.add
     [ method ]
     **
     * See @Element.append
    \*/ elproto.append = elproto.add = function(el) {
        if (el) {
            if (el.type == "set") {
                var it = this;
                el.forEach(function(el) {
                    it.add(el);
                });
                return this;
            }
            el = wrap(el);
            this.node.appendChild(el.node);
            el.paper = this.paper;
        }
        return this;
    };
    /*\
     * Element.appendTo
     [ method ]
     **
     * Appends the current element to the given one
     **
     - el (Element) parent element to append to
     = (Element) the child element
    \*/ elproto.appendTo = function(el) {
        if (el) {
            el = wrap(el);
            el.append(this);
        }
        return this;
    };
    /*\
     * Element.prepend
     [ method ]
     **
     * Prepends the given element to the current one
     **
     - el (Element) element to prepend
     = (Element) the parent element
    \*/ elproto.prepend = function(el) {
        if (el) {
            if (el.type == "set") {
                var it = this, first;
                el.forEach(function(el) {
                    if (first) first.after(el);
                    else it.prepend(el);
                    first = el;
                });
                return this;
            }
            el = wrap(el);
            var parent = el.parent();
            this.node.insertBefore(el.node, this.node.firstChild);
            this.add && this.add();
            el.paper = this.paper;
            this.parent() && this.parent().add();
            parent && parent.add();
        }
        return this;
    };
    /*\
     * Element.prependTo
     [ method ]
     **
     * Prepends the current element to the given one
     **
     - el (Element) parent element to prepend to
     = (Element) the child element
    \*/ elproto.prependTo = function(el) {
        el = wrap(el);
        el.prepend(this);
        return this;
    };
    /*\
     * Element.before
     [ method ]
     **
     * Inserts given element before the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/ elproto.before = function(el) {
        if (el.type == "set") {
            var it = this;
            el.forEach(function(el) {
                var parent = el.parent();
                it.node.parentNode.insertBefore(el.node, it.node);
                parent && parent.add();
            });
            this.parent().add();
            return this;
        }
        el = wrap(el);
        var parent = el.parent();
        this.node.parentNode.insertBefore(el.node, this.node);
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.after
     [ method ]
     **
     * Inserts given element after the current one
     **
     - el (Element) element to insert
     = (Element) the parent element
    \*/ elproto.after = function(el) {
        el = wrap(el);
        var parent = el.parent();
        if (this.node.nextSibling) this.node.parentNode.insertBefore(el.node, this.node.nextSibling);
        else this.node.parentNode.appendChild(el.node);
        this.parent() && this.parent().add();
        parent && parent.add();
        el.paper = this.paper;
        return this;
    };
    /*\
     * Element.insertBefore
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/ elproto.insertBefore = function(el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.insertAfter
     [ method ]
     **
     * Inserts the element after the given one
     **
     - el (Element) element next to whom insert to
     = (Element) the parent element
    \*/ elproto.insertAfter = function(el) {
        el = wrap(el);
        var parent = this.parent();
        el.node.parentNode.insertBefore(this.node, el.node.nextSibling);
        this.paper = el.paper;
        parent && parent.add();
        el.parent() && el.parent().add();
        return this;
    };
    /*\
     * Element.remove
     [ method ]
     **
     * Removes element from the DOM
     = (Element) the detached element
    \*/ elproto.remove = function() {
        var parent = this.parent();
        this.node.parentNode && this.node.parentNode.removeChild(this.node);
        delete this.paper;
        this.removed = true;
        parent && parent.add();
        return this;
    };
    /*\
     * Element.select
     [ method ]
     **
     * Gathers the nested @Element matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Element) result of query selection
    \*/ elproto.select = function(query) {
        return wrap(this.node.querySelector(query));
    };
    /*\
     * Element.selectAll
     [ method ]
     **
     * Gathers nested @Element objects matching the given set of CSS selectors
     **
     - query (string) CSS selector
     = (Set|array) result of query selection
    \*/ elproto.selectAll = function(query) {
        var nodelist = this.node.querySelectorAll(query), set = (Snap.set || Array)();
        for(var i = 0; i < nodelist.length; i++)set.push(wrap(nodelist[i]));
        return set;
    };
    /*\
     * Element.asPX
     [ method ]
     **
     * Returns given attribute of the element as a `px` value (not %, em, etc.)
     **
     - attr (string) attribute name
     - value (string) #optional attribute value
     = (Element) result of query selection
    \*/ elproto.asPX = function(attr, value) {
        if (value == null) value = this.attr(attr);
        return +unit2px(this, attr, value);
    };
    // SIERRA Element.use(): I suggest adding a note about how to access the original element the returned <use> instantiates. It's a part of SVG with which ordinary web developers may be least familiar.
    /*\
     * Element.use
     [ method ]
     **
     * Creates a `<use>` element linked to the current element
     **
     = (Element) the `<use>` element
    \*/ elproto.use = function() {
        var use, id = this.node.id;
        if (!id) {
            id = this.id;
            $(this.node, {
                id: id
            });
        }
        if (this.type == "linearGradient" || this.type == "radialGradient" || this.type == "pattern") use = make(this.type, this.node.parentNode);
        else use = make("use", this.node.parentNode);
        $(use.node, {
            "xlink:href": "#" + id
        });
        use.original = this;
        return use;
    };
    function fixids(el) {
        var els = el.selectAll("*"), it, url = /^\s*url\(("|'|)(.*)\1\)\s*$/, ids = [], uses = {};
        function urltest(it, name) {
            var val = $(it.node, name);
            val = val && val.match(url);
            val = val && val[2];
            if (val && val.charAt() == "#") val = val.substring(1);
            else return;
            if (val) uses[val] = (uses[val] || []).concat(function(id) {
                var attr = {};
                attr[name] = Snap.url(id);
                $(it.node, attr);
            });
        }
        function linktest(it) {
            var val = $(it.node, "xlink:href");
            if (val && val.charAt() == "#") val = val.substring(1);
            else return;
            if (val) uses[val] = (uses[val] || []).concat(function(id) {
                it.attr("xlink:href", "#" + id);
            });
        }
        for(var i = 0, ii = els.length; i < ii; i++){
            it = els[i];
            urltest(it, "fill");
            urltest(it, "stroke");
            urltest(it, "filter");
            urltest(it, "mask");
            urltest(it, "clip-path");
            linktest(it);
            var oldid = $(it.node, "id");
            if (oldid) {
                $(it.node, {
                    id: it.id
                });
                ids.push({
                    old: oldid,
                    id: it.id
                });
            }
        }
        for(i = 0, ii = ids.length; i < ii; i++){
            var fs = uses[ids[i].old];
            if (fs) for(var j = 0, jj = fs.length; j < jj; j++)fs[j](ids[i].id);
        }
    }
    /*\
     * Element.clone
     [ method ]
     **
     * Creates a clone of the element and inserts it after the element
     **
     = (Element) the clone
    \*/ elproto.clone = function() {
        var clone = wrap(this.node.cloneNode(true));
        if ($(clone.node, "id")) $(clone.node, {
            id: clone.id
        });
        fixids(clone);
        clone.insertAfter(this);
        return clone;
    };
    /*\
     * Element.toDefs
     [ method ]
     **
     * Moves element to the shared `<defs>` area
     **
     = (Element) the element
    \*/ elproto.toDefs = function() {
        var defs = getSomeDefs(this);
        defs.appendChild(this.node);
        return this;
    };
    /*\
     * Element.toPattern
     [ method ]
     **
     * Creates a `<pattern>` element from the current element
     **
     * To create a pattern you have to specify the pattern rect:
     - x (string|number)
     - y (string|number)
     - width (string|number)
     - height (string|number)
     = (Element) the `<pattern>` element
     * You can use pattern later on as an argument for `fill` attribute:
     | var p = paper.path("M10-5-10,15M15,0,0,15M0-5-20,15").attr({
     |         fill: "none",
     |         stroke: "#bada55",
     |         strokeWidth: 5
     |     }).pattern(0, 0, 10, 10),
     |     c = paper.circle(200, 200, 100);
     | c.attr({
     |     fill: p
     | });
    \*/ elproto.pattern = elproto.toPattern = function(x, y, width, height) {
        var p = make("pattern", getSomeDefs(this));
        if (x == null) x = this.getBBox();
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        $(p.node, {
            x: x,
            y: y,
            width: width,
            height: height,
            patternUnits: "userSpaceOnUse",
            id: p.id,
            viewBox: [
                x,
                y,
                width,
                height
            ].join(" ")
        });
        p.node.appendChild(this.node);
        return p;
    };
    // SIERRA Element.marker(): clarify what a reference point is. E.g., helps you offset the object from its edge such as when centering it over a path.
    // SIERRA Element.marker(): I suggest the method should accept default reference point values.  Perhaps centered with (refX = width/2) and (refY = height/2)? Also, couldn't it assume the element's current _width_ and _height_? And please specify what _x_ and _y_ mean: offsets? If so, from where?  Couldn't they also be assigned default values?
    /*\
     * Element.marker
     [ method ]
     **
     * Creates a `<marker>` element from the current element
     **
     * To create a marker you have to specify the bounding rect and reference point:
     - x (number)
     - y (number)
     - width (number)
     - height (number)
     - refX (number)
     - refY (number)
     = (Element) the `<marker>` element
     * You can specify the marker later as an argument for `marker-start`, `marker-end`, `marker-mid`, and `marker` attributes. The `marker` attribute places the marker at every point along the path, and `marker-mid` places them at every point except the start and end.
    \*/ // TODO add usage for markers
    elproto.marker = function(x, y, width, height, refX, refY) {
        var p = make("marker", getSomeDefs(this));
        if (x == null) x = this.getBBox();
        if (is(x, "object") && "x" in x) {
            y = x.y;
            width = x.width;
            height = x.height;
            refX = x.refX || x.cx;
            refY = x.refY || x.cy;
            x = x.x;
        }
        $(p.node, {
            viewBox: [
                x,
                y,
                width,
                height
            ].join(" "),
            markerWidth: width,
            markerHeight: height,
            orient: "auto",
            refX: refX || 0,
            refY: refY || 0,
            id: p.id
        });
        p.node.appendChild(this.node);
        return p;
    };
    var eldata = {};
    /*\
     * Element.data
     [ method ]
     **
     * Adds or retrieves given value associated with given key. (Don’t confuse
     * with `data-` attributes)
     *
     * See also @Element.removeData
     - key (string) key to store data
     - value (any) #optional value to store
     = (object) @Element
     * or, if value is not specified:
     = (any) value
     > Usage
     | for (var i = 0, i < 5, i++) {
     |     paper.circle(10 + 15 * i, 10, 10)
     |          .attr({fill: "#000"})
     |          .data("i", i)
     |          .click(function () {
     |             alert(this.data("i"));
     |          });
     | }
    \*/ elproto.data = function(key, value) {
        var data = eldata[this.id] = eldata[this.id] || {};
        if (arguments.length == 0) {
            eve("snap.data.get." + this.id, this, data, null);
            return data;
        }
        if (arguments.length == 1) {
            if (Snap.is(key, "object")) {
                for(var i in key)if (key[has](i)) this.data(i, key[i]);
                return this;
            }
            eve("snap.data.get." + this.id, this, data[key], key);
            return data[key];
        }
        data[key] = value;
        eve("snap.data.set." + this.id, this, value, key);
        return this;
    };
    /*\
     * Element.removeData
     [ method ]
     **
     * Removes value associated with an element by given key.
     * If key is not provided, removes all the data of the element.
     - key (string) #optional key
     = (object) @Element
    \*/ elproto.removeData = function(key) {
        if (key == null) eldata[this.id] = {};
        else eldata[this.id] && delete eldata[this.id][key];
        return this;
    };
    /*\
     * Element.outerSVG
     [ method ]
     **
     * Returns SVG code for the element, equivalent to HTML's `outerHTML`.
     *
     * See also @Element.innerSVG
     = (string) SVG code for the element
    \*/ /*\
     * Element.toString
     [ method ]
     **
     * See @Element.outerSVG
    \*/ elproto.outerSVG = elproto.toString = toString(1);
    /*\
     * Element.innerSVG
     [ method ]
     **
     * Returns SVG code for the element's contents, equivalent to HTML's `innerHTML`
     = (string) SVG code for the element
    \*/ elproto.innerSVG = toString();
    function toString(type) {
        return function() {
            var res1 = type ? "<" + this.type : "", attr = this.node.attributes, chld = this.node.childNodes;
            if (type) for(var i = 0, ii = attr.length; i < ii; i++)res1 += " " + attr[i].name + '="' + attr[i].value.replace(/"/g, '\\"') + '"';
            if (chld.length) {
                type && (res1 += ">");
                for(i = 0, ii = chld.length; i < ii; i++){
                    if (chld[i].nodeType == 3) res1 += chld[i].nodeValue;
                    else if (chld[i].nodeType == 1) res1 += wrap(chld[i]).toString();
                }
                type && (res1 += "</" + this.type + ">");
            } else type && (res1 += "/>");
            return res1;
        };
    }
    elproto.toDataURL = function() {
        if (window && window.btoa) {
            var bb = this.getBBox(), svg = Snap.format('<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="{width}" height="{height}" viewBox="{x} {y} {width} {height}">{contents}</svg>', {
                x: +bb.x.toFixed(3),
                y: +bb.y.toFixed(3),
                width: +bb.width.toFixed(3),
                height: +bb.height.toFixed(3),
                contents: this.outerSVG()
            });
            return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svg)));
        }
    };
    /*\
     * Fragment.select
     [ method ]
     **
     * See @Element.select
    \*/ Fragment.prototype.select = elproto.select;
    /*\
     * Fragment.selectAll
     [ method ]
     **
     * See @Element.selectAll
    \*/ Fragment.prototype.selectAll = elproto.selectAll;
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var objectToString = Object.prototype.toString, Str = String, math1 = Math, E = "";
    function Matrix(a, b, c, d, e, f) {
        if (b == null && objectToString.call(a) == "[object SVGMatrix]") {
            this.a = a.a;
            this.b = a.b;
            this.c = a.c;
            this.d = a.d;
            this.e = a.e;
            this.f = a.f;
            return;
        }
        if (a != null) {
            this.a = +a;
            this.b = +b;
            this.c = +c;
            this.d = +d;
            this.e = +e;
            this.f = +f;
        } else {
            this.a = 1;
            this.b = 0;
            this.c = 0;
            this.d = 1;
            this.e = 0;
            this.f = 0;
        }
    }
    (function(matrixproto) {
        /*\
         * Matrix.add
         [ method ]
         **
         * Adds the given matrix to existing one
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/ matrixproto.add = function(a, b, c, d, e, f) {
            if (a && a instanceof Matrix) return this.add(a.a, a.b, a.c, a.d, a.e, a.f);
            var aNew = a * this.a + b * this.c, bNew = a * this.b + b * this.d;
            this.e += e * this.a + f * this.c;
            this.f += e * this.b + f * this.d;
            this.c = c * this.a + d * this.c;
            this.d = c * this.b + d * this.d;
            this.a = aNew;
            this.b = bNew;
            return this;
        };
        /*\
         * Matrix.multLeft
         [ method ]
         **
         * Multiplies a passed affine transform to the left: M * this.
         - a (number)
         - b (number)
         - c (number)
         - d (number)
         - e (number)
         - f (number)
         * or
         - matrix (object) @Matrix
        \*/ Matrix.prototype.multLeft = function(a, b, c, d, e, f) {
            if (a && a instanceof Matrix) return this.multLeft(a.a, a.b, a.c, a.d, a.e, a.f);
            var aNew = a * this.a + c * this.b, cNew = a * this.c + c * this.d, eNew = a * this.e + c * this.f + e;
            this.b = b * this.a + d * this.b;
            this.d = b * this.c + d * this.d;
            this.f = b * this.e + d * this.f + f;
            this.a = aNew;
            this.c = cNew;
            this.e = eNew;
            return this;
        };
        /*\
         * Matrix.invert
         [ method ]
         **
         * Returns an inverted version of the matrix
         = (object) @Matrix
        \*/ matrixproto.invert = function() {
            var me = this, x = me.a * me.d - me.b * me.c;
            return new Matrix(me.d / x, -me.b / x, -me.c / x, me.a / x, (me.c * me.f - me.d * me.e) / x, (me.b * me.e - me.a * me.f) / x);
        };
        /*\
         * Matrix.clone
         [ method ]
         **
         * Returns a copy of the matrix
         = (object) @Matrix
        \*/ matrixproto.clone = function() {
            return new Matrix(this.a, this.b, this.c, this.d, this.e, this.f);
        };
        /*\
         * Matrix.translate
         [ method ]
         **
         * Translate the matrix
         - x (number) horizontal offset distance
         - y (number) vertical offset distance
        \*/ matrixproto.translate = function(x, y) {
            this.e += x * this.a + y * this.c;
            this.f += x * this.b + y * this.d;
            return this;
        };
        /*\
         * Matrix.scale
         [ method ]
         **
         * Scales the matrix
         - x (number) amount to be scaled, with `1` resulting in no change
         - y (number) #optional amount to scale along the vertical axis. (Otherwise `x` applies to both axes.)
         - cx (number) #optional horizontal origin point from which to scale
         - cy (number) #optional vertical origin point from which to scale
         * Default cx, cy is the middle point of the element.
        \*/ matrixproto.scale = function(x, y, cx, cy) {
            y == null && (y = x);
            (cx || cy) && this.translate(cx, cy);
            this.a *= x;
            this.b *= x;
            this.c *= y;
            this.d *= y;
            (cx || cy) && this.translate(-cx, -cy);
            return this;
        };
        /*\
         * Matrix.rotate
         [ method ]
         **
         * Rotates the matrix
         - a (number) angle of rotation, in degrees
         - x (number) horizontal origin point from which to rotate
         - y (number) vertical origin point from which to rotate
        \*/ matrixproto.rotate = function(a, x, y) {
            a = Snap.rad(a);
            x = x || 0;
            y = y || 0;
            var cos = +math1.cos(a).toFixed(9), sin = +math1.sin(a).toFixed(9);
            this.add(cos, sin, -sin, cos, x, y);
            return this.add(1, 0, 0, 1, -x, -y);
        };
        /*\
         * Matrix.skewX
         [ method ]
         **
         * Skews the matrix along the x-axis
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/ matrixproto.skewX = function(x) {
            return this.skew(x, 0);
        };
        /*\
         * Matrix.skewY
         [ method ]
         **
         * Skews the matrix along the y-axis
         - y (number) Angle to skew along the y-axis (in degrees).
        \*/ matrixproto.skewY = function(y) {
            return this.skew(0, y);
        };
        /*\
         * Matrix.skew
         [ method ]
         **
         * Skews the matrix
         - y (number) Angle to skew along the y-axis (in degrees).
         - x (number) Angle to skew along the x-axis (in degrees).
        \*/ matrixproto.skew = function(x, y) {
            x = x || 0;
            y = y || 0;
            x = Snap.rad(x);
            y = Snap.rad(y);
            var c = math1.tan(x).toFixed(9);
            var b = math1.tan(y).toFixed(9);
            return this.add(1, b, c, 1, 0, 0);
        };
        /*\
         * Matrix.x
         [ method ]
         **
         * Returns x coordinate for given point after transformation described by the matrix. See also @Matrix.y
         - x (number)
         - y (number)
         = (number) x
        \*/ matrixproto.x = function(x, y) {
            return x * this.a + y * this.c + this.e;
        };
        /*\
         * Matrix.y
         [ method ]
         **
         * Returns y coordinate for given point after transformation described by the matrix. See also @Matrix.x
         - x (number)
         - y (number)
         = (number) y
        \*/ matrixproto.y = function(x, y) {
            return x * this.b + y * this.d + this.f;
        };
        matrixproto.get = function(i) {
            return +this[Str.fromCharCode(97 + i)].toFixed(4);
        };
        matrixproto.toString = function() {
            return "matrix(" + [
                this.get(0),
                this.get(1),
                this.get(2),
                this.get(3),
                this.get(4),
                this.get(5)
            ].join() + ")";
        };
        matrixproto.offset = function() {
            return [
                this.e.toFixed(4),
                this.f.toFixed(4)
            ];
        };
        function norm(a) {
            return a[0] * a[0] + a[1] * a[1];
        }
        function normalize(a) {
            var mag = math1.sqrt(norm(a));
            a[0] && (a[0] /= mag);
            a[1] && (a[1] /= mag);
        }
        /*\
         * Matrix.determinant
         [ method ]
         **
         * Finds determinant of the given matrix.
         = (number) determinant
        \*/ matrixproto.determinant = function() {
            return this.a * this.d - this.b * this.c;
        };
        /*\
         * Matrix.split
         [ method ]
         **
         * Splits matrix into primitive transformations
         = (object) in format:
         o dx (number) translation by x
         o dy (number) translation by y
         o scalex (number) scale by x
         o scaley (number) scale by y
         o shear (number) shear
         o rotate (number) rotation in deg
         o isSimple (boolean) could it be represented via simple transformations
        \*/ matrixproto.split = function() {
            var out = {};
            // translation
            out.dx = this.e;
            out.dy = this.f;
            // scale and shear
            var row = [
                [
                    this.a,
                    this.b
                ],
                [
                    this.c,
                    this.d
                ]
            ];
            out.scalex = math1.sqrt(norm(row[0]));
            normalize(row[0]);
            out.shear = row[0][0] * row[1][0] + row[0][1] * row[1][1];
            row[1] = [
                row[1][0] - row[0][0] * out.shear,
                row[1][1] - row[0][1] * out.shear
            ];
            out.scaley = math1.sqrt(norm(row[1]));
            normalize(row[1]);
            out.shear /= out.scaley;
            if (this.determinant() < 0) out.scalex = -out.scalex;
            // rotation
            var sin = row[0][1], cos = row[1][1];
            if (cos < 0) {
                out.rotate = Snap.deg(math1.acos(cos));
                if (sin < 0) out.rotate = 360 - out.rotate;
            } else out.rotate = Snap.deg(math1.asin(sin));
            out.isSimple = !+out.shear.toFixed(9) && (out.scalex.toFixed(9) == out.scaley.toFixed(9) || !out.rotate);
            out.isSuperSimple = !+out.shear.toFixed(9) && out.scalex.toFixed(9) == out.scaley.toFixed(9) && !out.rotate;
            out.noRotation = !+out.shear.toFixed(9) && !out.rotate;
            return out;
        };
        /*\
         * Matrix.toTransformString
         [ method ]
         **
         * Returns transform string that represents given matrix
         = (string) transform string
        \*/ matrixproto.toTransformString = function(shorter) {
            var s = shorter || this.split();
            if (!+s.shear.toFixed(9)) {
                s.scalex = +s.scalex.toFixed(4);
                s.scaley = +s.scaley.toFixed(4);
                s.rotate = +s.rotate.toFixed(4);
                return (s.dx || s.dy ? "t" + [
                    +s.dx.toFixed(4),
                    +s.dy.toFixed(4)
                ] : E) + (s.rotate ? "r" + [
                    +s.rotate.toFixed(4),
                    0,
                    0
                ] : E) + (s.scalex != 1 || s.scaley != 1 ? "s" + [
                    s.scalex,
                    s.scaley,
                    0,
                    0
                ] : E);
            } else return "m" + [
                this.get(0),
                this.get(1),
                this.get(2),
                this.get(3),
                this.get(4),
                this.get(5)
            ];
        };
    })(Matrix.prototype);
    /*\
     * Snap.Matrix
     [ method ]
     **
     * Matrix constructor, extend on your own risk.
     * To create matrices use @Snap.matrix.
    \*/ Snap.Matrix = Matrix;
    /*\
     * Snap.matrix
     [ method ]
     **
     * Utility method
     **
     * Returns a matrix based on the given parameters
     - a (number)
     - b (number)
     - c (number)
     - d (number)
     - e (number)
     - f (number)
     * or
     - svgMatrix (SVGMatrix)
     = (object) @Matrix
    \*/ Snap.matrix = function(a, b, c, d, e, f) {
        return new Matrix(a, b, c, d, e, f);
    };
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var has = "hasOwnProperty", make = Snap._.make, wrap = Snap._.wrap, is = Snap.is, getSomeDefs = Snap._.getSomeDefs, reURLValue = /^url\((['"]?)([^)]+)\1\)$/, $ = Snap._.$, URL = Snap.url, Str = String, separator = Snap._.separator, E = "";
    /*\
     * Snap.deurl
     [ method ]
     **
     * Unwraps path from `"url(<path>)"`.
     - value (string) url path
     = (string) unwrapped path
    \*/ Snap.deurl = function(value) {
        var res1 = String(value).match(reURLValue);
        return res1 ? res1[2] : value;
    };
    // Attributes event handlers
    eve.on("snap.util.attr.mask", function(value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value.type == "mask") var mask = value;
            else {
                mask = make("mask", getSomeDefs(this));
                mask.node.appendChild(value.node);
            }
            !mask.node.id && $(mask.node, {
                id: mask.id
            });
            $(this.node, {
                mask: URL(mask.id)
            });
        }
    });
    (function(clipIt) {
        eve.on("snap.util.attr.clip", clipIt);
        eve.on("snap.util.attr.clip-path", clipIt);
        eve.on("snap.util.attr.clipPath", clipIt);
    })(function(value) {
        if (value instanceof Element || value instanceof Fragment) {
            eve.stop();
            var clip, node = value.node;
            while(node){
                if (node.nodeName === "clipPath") {
                    clip = new Element(node);
                    break;
                }
                if (node.nodeName === "svg") {
                    clip = undefined;
                    break;
                }
                node = node.parentNode;
            }
            if (!clip) {
                clip = make("clipPath", getSomeDefs(this));
                clip.node.appendChild(value.node);
                !clip.node.id && $(clip.node, {
                    id: clip.id
                });
            }
            $(this.node, {
                "clip-path": URL(clip.node.id || clip.id)
            });
        }
    });
    function fillStroke(name) {
        return function(value) {
            eve.stop();
            if (value instanceof Fragment && value.node.childNodes.length == 1 && (value.node.firstChild.tagName == "radialGradient" || value.node.firstChild.tagName == "linearGradient" || value.node.firstChild.tagName == "pattern")) {
                value = value.node.firstChild;
                getSomeDefs(this).appendChild(value);
                value = wrap(value);
            }
            if (value instanceof Element) {
                if (value.type == "radialGradient" || value.type == "linearGradient" || value.type == "pattern") {
                    if (!value.node.id) $(value.node, {
                        id: value.id
                    });
                    var fill = URL(value.node.id);
                } else fill = value.attr(name);
            } else {
                fill = Snap.color(value);
                if (fill.error) {
                    var grad = Snap(getSomeDefs(this).ownerSVGElement).gradient(value);
                    if (grad) {
                        if (!grad.node.id) $(grad.node, {
                            id: grad.id
                        });
                        fill = URL(grad.node.id);
                    } else fill = value;
                } else fill = Str(fill);
            }
            var attrs = {};
            attrs[name] = fill;
            $(this.node, attrs);
            this.node.style[name] = E;
        };
    }
    eve.on("snap.util.attr.fill", fillStroke("fill"));
    eve.on("snap.util.attr.stroke", fillStroke("stroke"));
    var gradrg = /^([lr])(?:\(([^)]*)\))?(.*)$/i;
    eve.on("snap.util.grad.parse", function parseGrad(string1) {
        string1 = Str(string1);
        var tokens = string1.match(gradrg);
        if (!tokens) return null;
        var type = tokens[1], params = tokens[2], stops = tokens[3];
        params = params.split(/\s*,\s*/).map(function(el) {
            return +el == el ? +el : el;
        });
        if (params.length == 1 && params[0] == 0) params = [];
        stops = stops.split("-");
        stops = stops.map(function(el) {
            el = el.split(":");
            var out = {
                color: el[0]
            };
            if (el[1]) out.offset = parseFloat(el[1]);
            return out;
        });
        var len = stops.length, start = 0, j = 0;
        function seed(i, end) {
            var step = (end - start) / (i - j);
            for(var k = j; k < i; k++)stops[k].offset = +(+start + step * (k - j)).toFixed(2);
            j = i;
            start = end;
        }
        len--;
        for(var i = 0; i < len; i++)if ("offset" in stops[i]) seed(i, stops[i].offset);
        stops[len].offset = stops[len].offset || 100;
        seed(len, stops[len].offset);
        return {
            type: type,
            params: params,
            stops: stops
        };
    });
    eve.on("snap.util.attr.d", function(value) {
        eve.stop();
        if (is(value, "array") && is(value[0], "array")) value = Snap.path.toString.call(value);
        value = Str(value);
        if (value.match(/[ruo]/i)) value = Snap.path.toAbsolute(value);
        $(this.node, {
            d: value
        });
    })(-1);
    eve.on("snap.util.attr.#text", function(value) {
        eve.stop();
        value = Str(value);
        var txt = glob.doc.createTextNode(value);
        while(this.node.firstChild)this.node.removeChild(this.node.firstChild);
        this.node.appendChild(txt);
    })(-1);
    eve.on("snap.util.attr.path", function(value) {
        eve.stop();
        this.attr({
            d: value
        });
    })(-1);
    eve.on("snap.util.attr.class", function(value) {
        eve.stop();
        this.node.className.baseVal = value;
    })(-1);
    eve.on("snap.util.attr.viewBox", function(value) {
        var vb;
        if (is(value, "object") && "x" in value) vb = [
            value.x,
            value.y,
            value.width,
            value.height
        ].join(" ");
        else if (is(value, "array")) vb = value.join(" ");
        else vb = value;
        $(this.node, {
            viewBox: vb
        });
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.transform", function(value) {
        this.transform(value);
        eve.stop();
    })(-1);
    eve.on("snap.util.attr.r", function(value) {
        if (this.type == "rect") {
            eve.stop();
            $(this.node, {
                rx: value,
                ry: value
            });
        }
    })(-1);
    eve.on("snap.util.attr.textpath", function(value) {
        eve.stop();
        if (this.type == "text") {
            var id, tp, node;
            if (!value && this.textPath) {
                tp = this.textPath;
                while(tp.node.firstChild)this.node.appendChild(tp.node.firstChild);
                tp.remove();
                delete this.textPath;
                return;
            }
            if (is(value, "string")) {
                var defs = getSomeDefs(this), path = wrap(defs.parentNode).path(value);
                defs.appendChild(path.node);
                id = path.id;
                path.attr({
                    id: id
                });
            } else {
                value = wrap(value);
                if (value instanceof Element) {
                    id = value.attr("id");
                    if (!id) {
                        id = value.id;
                        value.attr({
                            id: id
                        });
                    }
                }
            }
            if (id) {
                tp = this.textPath;
                node = this.node;
                if (tp) tp.attr({
                    "xlink:href": "#" + id
                });
                else {
                    tp = $("textPath", {
                        "xlink:href": "#" + id
                    });
                    while(node.firstChild)tp.appendChild(node.firstChild);
                    node.appendChild(tp);
                    this.textPath = wrap(tp);
                }
            }
        }
    })(-1);
    eve.on("snap.util.attr.text", function(value) {
        if (this.type == "text") {
            var i = 0, node = this.node, tuner = function(chunk) {
                var out = $("tspan");
                if (is(chunk, "array")) for(var i = 0; i < chunk.length; i++)out.appendChild(tuner(chunk[i]));
                else out.appendChild(glob.doc.createTextNode(chunk));
                out.normalize && out.normalize();
                return out;
            };
            while(node.firstChild)node.removeChild(node.firstChild);
            var tuned = tuner(value);
            while(tuned.firstChild)node.appendChild(tuned.firstChild);
        }
        eve.stop();
    })(-1);
    function setFontSize(value) {
        eve.stop();
        if (value == +value) value += "px";
        this.node.style.fontSize = value;
    }
    eve.on("snap.util.attr.fontSize", setFontSize)(-1);
    eve.on("snap.util.attr.font-size", setFontSize)(-1);
    eve.on("snap.util.getattr.transform", function() {
        eve.stop();
        return this.transform();
    })(-1);
    eve.on("snap.util.getattr.textpath", function() {
        eve.stop();
        return this.textPath;
    })(-1);
    // Markers
    (function() {
        function getter(end) {
            return function() {
                eve.stop();
                var style = glob.doc.defaultView.getComputedStyle(this.node, null).getPropertyValue("marker-" + end);
                if (style == "none") return style;
                else return Snap(glob.doc.getElementById(style.match(reURLValue)[1]));
            };
        }
        function setter(end) {
            return function(value) {
                eve.stop();
                var name = "marker" + end.charAt(0).toUpperCase() + end.substring(1);
                if (value == "" || !value) {
                    this.node.style[name] = "none";
                    return;
                }
                if (value.type == "marker") {
                    var id = value.node.id;
                    if (!id) $(value.node, {
                        id: value.id
                    });
                    this.node.style[name] = URL(id);
                    return;
                }
            };
        }
        eve.on("snap.util.getattr.marker-end", getter("end"))(-1);
        eve.on("snap.util.getattr.markerEnd", getter("end"))(-1);
        eve.on("snap.util.getattr.marker-start", getter("start"))(-1);
        eve.on("snap.util.getattr.markerStart", getter("start"))(-1);
        eve.on("snap.util.getattr.marker-mid", getter("mid"))(-1);
        eve.on("snap.util.getattr.markerMid", getter("mid"))(-1);
        eve.on("snap.util.attr.marker-end", setter("end"))(-1);
        eve.on("snap.util.attr.markerEnd", setter("end"))(-1);
        eve.on("snap.util.attr.marker-start", setter("start"))(-1);
        eve.on("snap.util.attr.markerStart", setter("start"))(-1);
        eve.on("snap.util.attr.marker-mid", setter("mid"))(-1);
        eve.on("snap.util.attr.markerMid", setter("mid"))(-1);
    })();
    eve.on("snap.util.getattr.r", function() {
        if (this.type == "rect" && $(this.node, "rx") == $(this.node, "ry")) {
            eve.stop();
            return $(this.node, "rx");
        }
    })(-1);
    function textExtract(node) {
        var out = [];
        var children = node.childNodes;
        for(var i = 0, ii = children.length; i < ii; i++){
            var chi = children[i];
            if (chi.nodeType == 3) out.push(chi.nodeValue);
            if (chi.tagName == "tspan") {
                if (chi.childNodes.length == 1 && chi.firstChild.nodeType == 3) out.push(chi.firstChild.nodeValue);
                else out.push(textExtract(chi));
            }
        }
        return out;
    }
    eve.on("snap.util.getattr.text", function() {
        if (this.type == "text" || this.type == "tspan") {
            eve.stop();
            var out = textExtract(this.node);
            return out.length == 1 ? out[0] : out;
        }
    })(-1);
    eve.on("snap.util.getattr.#text", function() {
        return this.node.textContent;
    })(-1);
    eve.on("snap.util.getattr.fill", function(internal) {
        if (internal) return;
        eve.stop();
        var value = eve("snap.util.getattr.fill", this, true).firstDefined();
        return Snap(Snap.deurl(value)) || value;
    })(-1);
    eve.on("snap.util.getattr.stroke", function(internal) {
        if (internal) return;
        eve.stop();
        var value = eve("snap.util.getattr.stroke", this, true).firstDefined();
        return Snap(Snap.deurl(value)) || value;
    })(-1);
    eve.on("snap.util.getattr.viewBox", function() {
        eve.stop();
        var vb = $(this.node, "viewBox");
        if (vb) {
            vb = vb.split(separator);
            return Snap._.box(+vb[0], +vb[1], +vb[2], +vb[3]);
        } else return;
    })(-1);
    eve.on("snap.util.getattr.points", function() {
        var p = $(this.node, "points");
        eve.stop();
        if (p) return p.split(separator);
        else return;
    })(-1);
    eve.on("snap.util.getattr.path", function() {
        var p = $(this.node, "d");
        eve.stop();
        return p;
    })(-1);
    eve.on("snap.util.getattr.class", function() {
        return this.node.className.baseVal;
    })(-1);
    function getFontSize() {
        eve.stop();
        return this.node.style.fontSize;
    }
    eve.on("snap.util.getattr.fontSize", getFontSize)(-1);
    eve.on("snap.util.getattr.font-size", getFontSize)(-1);
});
// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var rgNotSpace = /\S+/g, rgBadSpace = /[\t\r\n\f]/g, rgTrim = /(^\s+|\s+$)/g, Str = String, elproto = Element.prototype;
    /*\
     * Element.addClass
     [ method ]
     **
     * Adds given class name or list of class names to the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/ elproto.addClass = function(value) {
        var classes = Str(value || "").match(rgNotSpace) || [], elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [], j, pos, clazz, finalValue;
        if (classes.length) {
            j = 0;
            while(clazz = classes[j++]){
                pos = curClasses.indexOf(clazz);
                if (!~pos) curClasses.push(clazz);
            }
            finalValue = curClasses.join(" ");
            if (className != finalValue) elem.className.baseVal = finalValue;
        }
        return this;
    };
    /*\
     * Element.removeClass
     [ method ]
     **
     * Removes given class name or list of class names from the element.
     - value (string) class name or space separated list of class names
     **
     = (Element) original element.
    \*/ elproto.removeClass = function(value) {
        var classes = Str(value || "").match(rgNotSpace) || [], elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [], j, pos, clazz, finalValue;
        if (curClasses.length) {
            j = 0;
            while(clazz = classes[j++]){
                pos = curClasses.indexOf(clazz);
                if (~pos) curClasses.splice(pos, 1);
            }
            finalValue = curClasses.join(" ");
            if (className != finalValue) elem.className.baseVal = finalValue;
        }
        return this;
    };
    /*\
     * Element.hasClass
     [ method ]
     **
     * Checks if the element has a given class name in the list of class names applied to it.
     - value (string) class name
     **
     = (boolean) `true` if the element has given class
    \*/ elproto.hasClass = function(value) {
        var elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [];
        return !!~curClasses.indexOf(value);
    };
    /*\
     * Element.toggleClass
     [ method ]
     **
     * Add or remove one or more classes from the element, depending on either
     * the class’s presence or the value of the `flag` argument.
     - value (string) class name or space separated list of class names
     - flag (boolean) value to determine whether the class should be added or removed
     **
     = (Element) original element.
    \*/ elproto.toggleClass = function(value, flag) {
        if (flag != null) {
            if (flag) return this.addClass(value);
            else return this.removeClass(value);
        }
        var classes = (value || "").match(rgNotSpace) || [], elem = this.node, className = elem.className.baseVal, curClasses = className.match(rgNotSpace) || [], j, pos, clazz, finalValue;
        j = 0;
        while(clazz = classes[j++]){
            pos = curClasses.indexOf(clazz);
            if (~pos) curClasses.splice(pos, 1);
            else curClasses.push(clazz);
        }
        finalValue = curClasses.join(" ");
        if (className != finalValue) elem.className.baseVal = finalValue;
        return this;
    };
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var operators = {
        "+": function(x, y) {
            return x + y;
        },
        "-": function(x, y) {
            return x - y;
        },
        "/": function(x, y) {
            return x / y;
        },
        "*": function(x, y) {
            return x * y;
        }
    }, Str = String, reUnit = /[a-z]+$/i, reAddon = /^\s*([+\-\/*])\s*=\s*([\d.eE+\-]+)\s*([^\d\s]+)?\s*$/;
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function(val) {
            return +val.toFixed(3) + unit;
        };
    }
    eve.on("snap.util.attr", function(val) {
        var plus = Str(val).match(reAddon);
        if (plus) {
            var evnt = eve.nt(), name = evnt.substring(evnt.lastIndexOf(".") + 1), a = this.attr(name), atr = {};
            eve.stop();
            var unit = plus[3] || "", aUnit = a.match(reUnit), op = operators[plus[1]];
            if (aUnit && aUnit == unit) val = op(parseFloat(a), +plus[2]);
            else {
                a = this.asPX(name);
                val = op(this.asPX(name), this.asPX(name, plus[2] + unit));
            }
            if (isNaN(a) || isNaN(val)) return;
            atr[name] = val;
            this.attr(atr);
        }
    })(-10);
    eve.on("snap.util.equal", function(name, b) {
        var A, B, a = Str(this.attr(name) || ""), el = this, bplus = Str(b).match(reAddon);
        if (bplus) {
            eve.stop();
            var unit = bplus[3] || "", aUnit = a.match(reUnit), op = operators[bplus[1]];
            if (aUnit && aUnit == unit) return {
                from: parseFloat(a),
                to: op(parseFloat(a), +bplus[2]),
                f: getUnit(aUnit)
            };
            else {
                a = this.asPX(name);
                return {
                    from: a,
                    to: op(a, this.asPX(name, bplus[2] + unit)),
                    f: getNumber
                };
            }
        }
    })(-10);
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var proto = Paper.prototype, is = Snap.is;
    /*\
     * Paper.rect
     [ method ]
     *
     * Draws a rectangle
     **
     - x (number) x coordinate of the top left corner
     - y (number) y coordinate of the top left corner
     - width (number) width
     - height (number) height
     - rx (number) #optional horizontal radius for rounded corners, default is 0
     - ry (number) #optional vertical radius for rounded corners, default is rx or 0
     = (object) the `rect` element
     **
     > Usage
     | // regular rectangle
     | var c = paper.rect(10, 10, 50, 50);
     | // rectangle with rounded corners
     | var c = paper.rect(40, 40, 50, 50, 10);
    \*/ proto.rect = function(x, y, w, h, rx, ry) {
        var attr;
        if (ry == null) ry = rx;
        if (is(x, "object") && x == "[object Object]") attr = x;
        else if (x != null) {
            attr = {
                x: x,
                y: y,
                width: w,
                height: h
            };
            if (rx != null) {
                attr.rx = rx;
                attr.ry = ry;
            }
        }
        return this.el("rect", attr);
    };
    /*\
     * Paper.circle
     [ method ]
     **
     * Draws a circle
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - r (number) radius
     = (object) the `circle` element
     **
     > Usage
     | var c = paper.circle(50, 50, 40);
    \*/ proto.circle = function(cx, cy, r) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") attr = cx;
        else if (cx != null) attr = {
            cx: cx,
            cy: cy,
            r: r
        };
        return this.el("circle", attr);
    };
    var preload = function() {
        function onerror() {
            this.parentNode.removeChild(this);
        }
        return function(src, f) {
            var img = glob.doc.createElement("img"), body = glob.doc.body;
            img.style.cssText = "position:absolute;left:-9999em;top:-9999em";
            img.onload = function() {
                f.call(img);
                img.onload = img.onerror = null;
                body.removeChild(img);
            };
            img.onerror = onerror;
            body.appendChild(img);
            img.src = src;
        };
    }();
    /*\
     * Paper.image
     [ method ]
     **
     * Places an image on the surface
     **
     - src (string) URI of the source image
     - x (number) x offset position
     - y (number) y offset position
     - width (number) width of the image
     - height (number) height of the image
     = (object) the `image` element
     * or
     = (object) Snap element object with type `image`
     **
     > Usage
     | var c = paper.image("apple.png", 10, 10, 80, 80);
    \*/ proto.image = function(src, x, y, width, height) {
        var el = this.el("image");
        if (is(src, "object") && "src" in src) el.attr(src);
        else if (src != null) {
            var set = {
                "xlink:href": src,
                preserveAspectRatio: "none"
            };
            if (x != null && y != null) {
                set.x = x;
                set.y = y;
            }
            if (width != null && height != null) {
                set.width = width;
                set.height = height;
            } else preload(src, function() {
                Snap._.$(el.node, {
                    width: this.offsetWidth,
                    height: this.offsetHeight
                });
            });
            Snap._.$(el.node, set);
        }
        return el;
    };
    /*\
     * Paper.ellipse
     [ method ]
     **
     * Draws an ellipse
     **
     - x (number) x coordinate of the centre
     - y (number) y coordinate of the centre
     - rx (number) horizontal radius
     - ry (number) vertical radius
     = (object) the `ellipse` element
     **
     > Usage
     | var c = paper.ellipse(50, 50, 40, 20);
    \*/ proto.ellipse = function(cx, cy, rx, ry) {
        var attr;
        if (is(cx, "object") && cx == "[object Object]") attr = cx;
        else if (cx != null) attr = {
            cx: cx,
            cy: cy,
            rx: rx,
            ry: ry
        };
        return this.el("ellipse", attr);
    };
    // SIERRA Paper.path(): Unclear from the link what a Catmull-Rom curveto is, and why it would make life any easier.
    /*\
     * Paper.path
     [ method ]
     **
     * Creates a `<path>` element using the given string as the path's definition
     - pathString (string) #optional path string in SVG format
     * Path string consists of one-letter commands, followed by comma seprarated arguments in numerical form. Example:
     | "M10,20L30,40"
     * This example features two commands: `M`, with arguments `(10, 20)` and `L` with arguments `(30, 40)`. Uppercase letter commands express coordinates in absolute terms, while lowercase commands express them in relative terms from the most recently declared coordinates.
     *
     # <p>Here is short list of commands available, for more details see <a href="http://www.w3.org/TR/SVG/paths.html#PathData" title="Details of a path's data attribute's format are described in the SVG specification.">SVG path string format</a> or <a href="https://developer.mozilla.org/en/SVG/Tutorial/Paths">article about path strings at MDN</a>.</p>
     # <table><thead><tr><th>Command</th><th>Name</th><th>Parameters</th></tr></thead><tbody>
     # <tr><td>M</td><td>moveto</td><td>(x y)+</td></tr>
     # <tr><td>Z</td><td>closepath</td><td>(none)</td></tr>
     # <tr><td>L</td><td>lineto</td><td>(x y)+</td></tr>
     # <tr><td>H</td><td>horizontal lineto</td><td>x+</td></tr>
     # <tr><td>V</td><td>vertical lineto</td><td>y+</td></tr>
     # <tr><td>C</td><td>curveto</td><td>(x1 y1 x2 y2 x y)+</td></tr>
     # <tr><td>S</td><td>smooth curveto</td><td>(x2 y2 x y)+</td></tr>
     # <tr><td>Q</td><td>quadratic Bézier curveto</td><td>(x1 y1 x y)+</td></tr>
     # <tr><td>T</td><td>smooth quadratic Bézier curveto</td><td>(x y)+</td></tr>
     # <tr><td>A</td><td>elliptical arc</td><td>(rx ry x-axis-rotation large-arc-flag sweep-flag x y)+</td></tr>
     # <tr><td>R</td><td><a href="http://en.wikipedia.org/wiki/Catmull–Rom_spline#Catmull.E2.80.93Rom_spline">Catmull-Rom curveto</a>*</td><td>x1 y1 (x y)+</td></tr></tbody></table>
     * * _Catmull-Rom curveto_ is a not standard SVG command and added to make life easier.
     * Note: there is a special case when a path consists of only three commands: `M10,10R…z`. In this case the path connects back to its starting point.
     > Usage
     | var c = paper.path("M10 10L90 90");
     | // draw a diagonal line:
     | // move to 10,10, line to 90,90
    \*/ proto.path = function(d) {
        var attr;
        if (is(d, "object") && !is(d, "array")) attr = d;
        else if (d) attr = {
            d: d
        };
        return this.el("path", attr);
    };
    /*\
     * Paper.g
     [ method ]
     **
     * Creates a group element
     **
     - varargs (…) #optional elements to nest within the group
     = (object) the `g` element
     **
     > Usage
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g(c2, c1); // note that the order of elements is different
     * or
     | var c1 = paper.circle(),
     |     c2 = paper.rect(),
     |     g = paper.g();
     | g.add(c2, c1);
    \*/ /*\
     * Paper.group
     [ method ]
     **
     * See @Paper.g
    \*/ proto.group = proto.g = function(first) {
        var attr, el = this.el("g");
        if (arguments.length == 1 && first && !first.type) el.attr(first);
        else if (arguments.length) el.add(Array.prototype.slice.call(arguments, 0));
        return el;
    };
    /*\
     * Paper.svg
     [ method ]
     **
     * Creates a nested SVG element.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `svg` element
     **
    \*/ proto.svg = function(x, y, width, height, vbx, vby, vbw, vbh) {
        var attrs = {};
        if (is(x, "object") && y == null) attrs = x;
        else {
            if (x != null) attrs.x = x;
            if (y != null) attrs.y = y;
            if (width != null) attrs.width = width;
            if (height != null) attrs.height = height;
            if (vbx != null && vby != null && vbw != null && vbh != null) attrs.viewBox = [
                vbx,
                vby,
                vbw,
                vbh
            ];
        }
        return this.el("svg", attrs);
    };
    /*\
     * Paper.mask
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a mask.
     **
     = (object) the `mask` element
     **
    \*/ proto.mask = function(first) {
        var attr, el = this.el("mask");
        if (arguments.length == 1 && first && !first.type) el.attr(first);
        else if (arguments.length) el.add(Array.prototype.slice.call(arguments, 0));
        return el;
    };
    /*\
     * Paper.ptrn
     [ method ]
     **
     * Equivalent in behaviour to @Paper.g, except it’s a pattern.
     - x (number) @optional X of the element
     - y (number) @optional Y of the element
     - width (number) @optional width of the element
     - height (number) @optional height of the element
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     **
     = (object) the `pattern` element
     **
    \*/ proto.ptrn = function(x, y, width, height, vx, vy, vw, vh) {
        if (is(x, "object")) var attr = x;
        else {
            attr = {
                patternUnits: "userSpaceOnUse"
            };
            if (x) attr.x = x;
            if (y) attr.y = y;
            if (width != null) attr.width = width;
            if (height != null) attr.height = height;
            if (vx != null && vy != null && vw != null && vh != null) attr.viewBox = [
                vx,
                vy,
                vw,
                vh
            ];
            else attr.viewBox = [
                x || 0,
                y || 0,
                width || 0,
                height || 0
            ];
        }
        return this.el("pattern", attr);
    };
    /*\
     * Paper.use
     [ method ]
     **
     * Creates a <use> element.
     - id (string) @optional id of element to link
     * or
     - id (Element) @optional element to link
     **
     = (object) the `use` element
     **
    \*/ proto.use = function(id) {
        if (id != null) {
            if (id instanceof Element) {
                if (!id.attr("id")) id.attr({
                    id: Snap._.id(id)
                });
                id = id.attr("id");
            }
            if (String(id).charAt() == "#") id = id.substring(1);
            return this.el("use", {
                "xlink:href": "#" + id
            });
        } else return Element.prototype.use.call(this);
    };
    /*\
     * Paper.symbol
     [ method ]
     **
     * Creates a <symbol> element.
     - vbx (number) @optional viewbox X
     - vby (number) @optional viewbox Y
     - vbw (number) @optional viewbox width
     - vbh (number) @optional viewbox height
     = (object) the `symbol` element
     **
    \*/ proto.symbol = function(vx, vy, vw, vh) {
        var attr = {};
        if (vx != null && vy != null && vw != null && vh != null) attr.viewBox = [
            vx,
            vy,
            vw,
            vh
        ];
        return this.el("symbol", attr);
    };
    /*\
     * Paper.text
     [ method ]
     **
     * Draws a text string
     **
     - x (number) x coordinate position
     - y (number) y coordinate position
     - text (string|array) The text string to draw or array of strings to nest within separate `<tspan>` elements
     = (object) the `text` element
     **
     > Usage
     | var t1 = paper.text(50, 50, "Snap");
     | var t2 = paper.text(50, 50, ["S","n","a","p"]);
     | // Text path usage
     | t1.attr({textpath: "M10,10L100,100"});
     | // or
     | var pth = paper.path("M10,10L100,100");
     | t1.attr({textpath: pth});
    \*/ proto.text = function(x, y, text) {
        var attr = {};
        if (is(x, "object")) attr = x;
        else if (x != null) attr = {
            x: x,
            y: y,
            text: text || ""
        };
        return this.el("text", attr);
    };
    /*\
     * Paper.line
     [ method ]
     **
     * Draws a line
     **
     - x1 (number) x coordinate position of the start
     - y1 (number) y coordinate position of the start
     - x2 (number) x coordinate position of the end
     - y2 (number) y coordinate position of the end
     = (object) the `line` element
     **
     > Usage
     | var t1 = paper.line(50, 50, 100, 100);
    \*/ proto.line = function(x1, y1, x2, y2) {
        var attr = {};
        if (is(x1, "object")) attr = x1;
        else if (x1 != null) attr = {
            x1: x1,
            x2: x2,
            y1: y1,
            y2: y2
        };
        return this.el("line", attr);
    };
    /*\
     * Paper.polyline
     [ method ]
     **
     * Draws a polyline
     **
     - points (array) array of points
     * or
     - varargs (…) points
     = (object) the `polyline` element
     **
     > Usage
     | var p1 = paper.polyline([10, 10, 100, 100]);
     | var p2 = paper.polyline(10, 10, 100, 100);
    \*/ proto.polyline = function(points) {
        if (arguments.length > 1) points = Array.prototype.slice.call(arguments, 0);
        var attr = {};
        if (is(points, "object") && !is(points, "array")) attr = points;
        else if (points != null) attr = {
            points: points
        };
        return this.el("polyline", attr);
    };
    /*\
     * Paper.polygon
     [ method ]
     **
     * Draws a polygon. See @Paper.polyline
    \*/ proto.polygon = function(points) {
        if (arguments.length > 1) points = Array.prototype.slice.call(arguments, 0);
        var attr = {};
        if (is(points, "object") && !is(points, "array")) attr = points;
        else if (points != null) attr = {
            points: points
        };
        return this.el("polygon", attr);
    };
    // gradients
    (function() {
        var $ = Snap._.$;
        // gradients' helpers
        /*\
         * Element.stops
         [ method ]
         **
         * Only for gradients!
         * Returns array of gradient stops elements.
         = (array) the stops array.
        \*/ function Gstops() {
            return this.selectAll("stop");
        }
        /*\
         * Element.addStop
         [ method ]
         **
         * Only for gradients!
         * Adds another stop to the gradient.
         - color (string) stops color
         - offset (number) stops offset 0..100
         = (object) gradient element
        \*/ function GaddStop(color, offset) {
            var stop = $("stop"), attr = {
                offset: +offset + "%"
            };
            color = Snap.color(color);
            attr["stop-color"] = color.hex;
            if (color.opacity < 1) attr["stop-opacity"] = color.opacity;
            $(stop, attr);
            var stops = this.stops(), inserted;
            for(var i = 0; i < stops.length; i++){
                var stopOffset = parseFloat(stops[i].attr("offset"));
                if (stopOffset > offset) {
                    this.node.insertBefore(stop, stops[i].node);
                    inserted = true;
                    break;
                }
            }
            if (!inserted) this.node.appendChild(stop);
            return this;
        }
        function GgetBBox() {
            if (this.type == "linearGradient") {
                var x1 = $(this.node, "x1") || 0, x2 = $(this.node, "x2") || 1, y1 = $(this.node, "y1") || 0, y2 = $(this.node, "y2") || 0;
                return Snap._.box(x1, y1, math.abs(x2 - x1), math.abs(y2 - y1));
            } else {
                var cx = this.node.cx || .5, cy = this.node.cy || .5, r = this.node.r || 0;
                return Snap._.box(cx - r, cy - r, r * 2, r * 2);
            }
        }
        /*\
         * Element.setStops
         [ method ]
         **
         * Only for gradients!
         * Updates stops of the gradient based on passed gradient descriptor. See @Ppaer.gradient
         - str (string) gradient descriptor part after `()`.
         = (object) gradient element
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         | g.setStops("#fff-#000-#f00-#fc0");
        \*/ function GsetStops(str) {
            var grad = str, stops = this.stops();
            if (typeof str == "string") grad = eve("snap.util.grad.parse", null, "l(0,0,0,1)" + str).firstDefined().stops;
            if (!Snap.is(grad, "array")) return;
            for(var i = 0; i < stops.length; i++)if (grad[i]) {
                var color = Snap.color(grad[i].color), attr = {
                    "offset": grad[i].offset + "%"
                };
                attr["stop-color"] = color.hex;
                if (color.opacity < 1) attr["stop-opacity"] = color.opacity;
                stops[i].attr(attr);
            } else stops[i].remove();
            for(i = stops.length; i < grad.length; i++)this.addStop(grad[i].color, grad[i].offset);
            return this;
        }
        function gradient(defs, str) {
            var grad = eve("snap.util.grad.parse", null, str).firstDefined(), el;
            if (!grad) return null;
            grad.params.unshift(defs);
            if (grad.type.toLowerCase() == "l") el = gradientLinear.apply(0, grad.params);
            else el = gradientRadial.apply(0, grad.params);
            if (grad.type != grad.type.toLowerCase()) $(el.node, {
                gradientUnits: "userSpaceOnUse"
            });
            var stops = grad.stops, len = stops.length;
            for(var i = 0; i < len; i++){
                var stop = stops[i];
                el.addStop(stop.color, stop.offset);
            }
            return el;
        }
        function gradientLinear(defs, x1, y1, x2, y2) {
            var el = Snap._.make("linearGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            el.setStops = GsetStops;
            if (x1 != null) $(el.node, {
                x1: x1,
                y1: y1,
                x2: x2,
                y2: y2
            });
            return el;
        }
        function gradientRadial(defs, cx, cy, r, fx, fy) {
            var el = Snap._.make("radialGradient", defs);
            el.stops = Gstops;
            el.addStop = GaddStop;
            el.getBBox = GgetBBox;
            if (cx != null) $(el.node, {
                cx: cx,
                cy: cy,
                r: r
            });
            if (fx != null && fy != null) $(el.node, {
                fx: fx,
                fy: fy
            });
            return el;
        }
        /*\
         * Paper.gradient
         [ method ]
         **
         * Creates a gradient element
         **
         - gradient (string) gradient descriptor
         > Gradient Descriptor
         * The gradient descriptor is an expression formatted as
         * follows: `<type>(<coords>)<colors>`.  The `<type>` can be
         * either linear or radial.  The uppercase `L` or `R` letters
         * indicate absolute coordinates offset from the SVG surface.
         * Lowercase `l` or `r` letters indicate coordinates
         * calculated relative to the element to which the gradient is
         * applied.  Coordinates specify a linear gradient vector as
         * `x1`, `y1`, `x2`, `y2`, or a radial gradient as `cx`, `cy`,
         * `r` and optional `fx`, `fy` specifying a focal point away
         * from the center of the circle. Specify `<colors>` as a list
         * of dash-separated CSS color values.  Each color may be
         * followed by a custom offset value, separated with a colon
         * character.
         > Examples
         * Linear gradient, relative from top-left corner to bottom-right
         * corner, from black through red to white:
         | var g = paper.gradient("l(0, 0, 1, 1)#000-#f00-#fff");
         * Linear gradient, absolute from (0, 0) to (100, 100), from black
         * through red at 25% to white:
         | var g = paper.gradient("L(0, 0, 100, 100)#000-#f00:25-#fff");
         * Radial gradient, relative from the center of the element with radius
         * half the width, from black to white:
         | var g = paper.gradient("r(0.5, 0.5, 0.5)#000-#fff");
         * To apply the gradient:
         | paper.circle(50, 50, 40).attr({
         |     fill: g
         | });
         = (object) the `gradient` element
        \*/ proto.gradient = function(str) {
            return gradient(this.defs, str);
        };
        proto.gradientLinear = function(x1, y1, x2, y2) {
            return gradientLinear(this.defs, x1, y1, x2, y2);
        };
        proto.gradientRadial = function(cx, cy, r, fx, fy) {
            return gradientRadial(this.defs, cx, cy, r, fx, fy);
        };
        /*\
         * Paper.toString
         [ method ]
         **
         * Returns SVG code for the @Paper
         = (string) SVG code for the @Paper
        \*/ proto.toString = function() {
            var doc = this.node.ownerDocument, f = doc.createDocumentFragment(), d = doc.createElement("div"), svg = this.node.cloneNode(true), res1;
            f.appendChild(d);
            d.appendChild(svg);
            Snap._.$(svg, {
                xmlns: "http://www.w3.org/2000/svg"
            });
            res1 = d.innerHTML;
            f.removeChild(f.firstChild);
            return res1;
        };
        /*\
         * Paper.toDataURL
         [ method ]
         **
         * Returns SVG code for the @Paper as Data URI string.
         = (string) Data URI string
        \*/ proto.toDataURL = function() {
            if (window && window.btoa) return "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(this)));
        };
        /*\
         * Paper.clear
         [ method ]
         **
         * Removes all child nodes of the paper, except <defs>.
        \*/ proto.clear = function() {
            var node = this.node.firstChild, next;
            while(node){
                next = node.nextSibling;
                if (node.tagName != "defs") node.parentNode.removeChild(node);
                else proto.clear.call({
                    node: node
                });
                node = next;
            }
        };
    })();
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    var elproto = Element.prototype, is = Snap.is, clone = Snap._.clone, has = "hasOwnProperty", p2s = /,?([a-z]),?/gi, toFloat = parseFloat, math1 = Math, PI = math1.PI, mmin = math1.min, mmax = math1.max, pow = math1.pow, abs = math1.abs;
    function paths(ps) {
        var p = paths.ps = paths.ps || {};
        if (p[ps]) p[ps].sleep = 100;
        else p[ps] = {
            sleep: 100
        };
        setTimeout(function() {
            for(var key in p)if (p[has](key) && key != ps) {
                p[key].sleep--;
                !p[key].sleep && delete p[key];
            }
        });
        return p[ps];
    }
    function box(x, y, width, height) {
        if (x == null) x = y = width = height = 0;
        if (y == null) {
            y = x.y;
            width = x.width;
            height = x.height;
            x = x.x;
        }
        return {
            x: x,
            y: y,
            width: width,
            w: width,
            height: height,
            h: height,
            x2: x + width,
            y2: y + height,
            cx: x + width / 2,
            cy: y + height / 2,
            r1: math1.min(width, height) / 2,
            r2: math1.max(width, height) / 2,
            r0: math1.sqrt(width * width + height * height) / 2,
            path: rectPath(x, y, width, height),
            vb: [
                x,
                y,
                width,
                height
            ].join(" ")
        };
    }
    function toString() {
        return this.join(",").replace(p2s, "$1");
    }
    function pathClone(pathArray) {
        var res1 = clone(pathArray);
        res1.toString = toString;
        return res1;
    }
    function getPointAtSegmentLength(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length) {
        if (length == null) return bezlen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y);
        else return findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, getTotLen(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, length));
    }
    function getLengthFactory(istotal, subpath) {
        function O(val) {
            return +(+val).toFixed(3);
        }
        return Snap._.cacher(function(path, length, onlystart) {
            if (path instanceof Element) path = path.attr("d");
            path = path2curve(path);
            var x, y, p, l, sp = "", subpaths = {}, point, len = 0;
            for(var i = 0, ii = path.length; i < ii; i++){
                p = path[i];
                if (p[0] == "M") {
                    x = +p[1];
                    y = +p[2];
                } else {
                    l = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                    if (len + l > length) {
                        if (subpath && !subpaths.start) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            sp += [
                                "C" + O(point.start.x),
                                O(point.start.y),
                                O(point.m.x),
                                O(point.m.y),
                                O(point.x),
                                O(point.y)
                            ];
                            if (onlystart) return sp;
                            subpaths.start = sp;
                            sp = [
                                "M" + O(point.x),
                                O(point.y) + "C" + O(point.n.x),
                                O(point.n.y),
                                O(point.end.x),
                                O(point.end.y),
                                O(p[5]),
                                O(p[6])
                            ].join();
                            len += l;
                            x = +p[5];
                            y = +p[6];
                            continue;
                        }
                        if (!istotal && !subpath) {
                            point = getPointAtSegmentLength(x, y, p[1], p[2], p[3], p[4], p[5], p[6], length - len);
                            return point;
                        }
                    }
                    len += l;
                    x = +p[5];
                    y = +p[6];
                }
                sp += p.shift() + p;
            }
            subpaths.end = sp;
            point = istotal ? len : subpath ? subpaths : findDotsAtSegment(x, y, p[0], p[1], p[2], p[3], p[4], p[5], 1);
            return point;
        }, null, Snap._.clone);
    }
    var getTotalLength = getLengthFactory(1), getPointAtLength = getLengthFactory(), getSubpathsAtLength = getLengthFactory(0, 1);
    function findDotsAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t, t13 = pow(t1, 3), t12 = pow(t1, 2), t2 = t * t, t3 = t2 * t, x = t13 * p1x + t12 * 3 * t * c1x + t1 * 3 * t * t * c2x + t3 * p2x, y = t13 * p1y + t12 * 3 * t * c1y + t1 * 3 * t * t * c2y + t3 * p2y, mx = p1x + 2 * t * (c1x - p1x) + t2 * (c2x - 2 * c1x + p1x), my = p1y + 2 * t * (c1y - p1y) + t2 * (c2y - 2 * c1y + p1y), nx = c1x + 2 * t * (c2x - c1x) + t2 * (p2x - 2 * c2x + c1x), ny = c1y + 2 * t * (c2y - c1y) + t2 * (p2y - 2 * c2y + c1y), ax = t1 * p1x + t * c1x, ay = t1 * p1y + t * c1y, cx = t1 * c2x + t * p2x, cy = t1 * c2y + t * p2y, alpha = 90 - math1.atan2(mx - nx, my - ny) * 180 / PI;
        // (mx > nx || my < ny) && (alpha += 180);
        return {
            x: x,
            y: y,
            m: {
                x: mx,
                y: my
            },
            n: {
                x: nx,
                y: ny
            },
            start: {
                x: ax,
                y: ay
            },
            end: {
                x: cx,
                y: cy
            },
            alpha: alpha
        };
    }
    function bezierBBox(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y) {
        if (!Snap.is(p1x, "array")) p1x = [
            p1x,
            p1y,
            c1x,
            c1y,
            c2x,
            c2y,
            p2x,
            p2y
        ];
        var bbox = curveDim.apply(null, p1x);
        return box(bbox.min.x, bbox.min.y, bbox.max.x - bbox.min.x, bbox.max.y - bbox.min.y);
    }
    function isPointInsideBBox(bbox, x, y) {
        return x >= bbox.x && x <= bbox.x + bbox.width && y >= bbox.y && y <= bbox.y + bbox.height;
    }
    function isBBoxIntersect(bbox1, bbox2) {
        bbox1 = box(bbox1);
        bbox2 = box(bbox2);
        return isPointInsideBBox(bbox2, bbox1.x, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y) || isPointInsideBBox(bbox2, bbox1.x, bbox1.y2) || isPointInsideBBox(bbox2, bbox1.x2, bbox1.y2) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y) || isPointInsideBBox(bbox1, bbox2.x, bbox2.y2) || isPointInsideBBox(bbox1, bbox2.x2, bbox2.y2) || (bbox1.x < bbox2.x2 && bbox1.x > bbox2.x || bbox2.x < bbox1.x2 && bbox2.x > bbox1.x) && (bbox1.y < bbox2.y2 && bbox1.y > bbox2.y || bbox2.y < bbox1.y2 && bbox2.y > bbox1.y);
    }
    function base3(t, p1, p2, p3, p4) {
        var t1 = -3 * p1 + 9 * p2 - 9 * p3 + 3 * p4, t2 = t * t1 + 6 * p1 - 12 * p2 + 6 * p3;
        return t * t2 - 3 * p1 + 3 * p2;
    }
    function bezlen(x1, y1, x2, y2, x3, y3, x4, y4, z) {
        if (z == null) z = 1;
        z = z > 1 ? 1 : z < 0 ? 0 : z;
        var z2 = z / 2, n = 12, Tvalues = [
            -0.1252,
            .1252,
            -0.3678,
            .3678,
            -0.5873,
            .5873,
            -0.7699,
            .7699,
            -0.9041,
            .9041,
            -0.9816,
            .9816
        ], Cvalues = [
            0.2491,
            0.2491,
            0.2335,
            0.2335,
            0.2032,
            0.2032,
            0.1601,
            0.1601,
            0.1069,
            0.1069,
            0.0472,
            0.0472
        ], sum = 0;
        for(var i = 0; i < n; i++){
            var ct = z2 * Tvalues[i] + z2, xbase = base3(ct, x1, x2, x3, x4), ybase = base3(ct, y1, y2, y3, y4), comb = xbase * xbase + ybase * ybase;
            sum += Cvalues[i] * math1.sqrt(comb);
        }
        return z2 * sum;
    }
    function getTotLen(x1, y1, x2, y2, x3, y3, x4, y4, ll) {
        if (ll < 0 || bezlen(x1, y1, x2, y2, x3, y3, x4, y4) < ll) return;
        var t = 1, step = t / 2, t2 = t - step, l, e = .01;
        l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        while(abs(l - ll) > e){
            step /= 2;
            t2 += (l < ll ? 1 : -1) * step;
            l = bezlen(x1, y1, x2, y2, x3, y3, x4, y4, t2);
        }
        return t2;
    }
    function intersect(x1, y1, x2, y2, x3, y3, x4, y4) {
        if (mmax(x1, x2) < mmin(x3, x4) || mmin(x1, x2) > mmax(x3, x4) || mmax(y1, y2) < mmin(y3, y4) || mmin(y1, y2) > mmax(y3, y4)) return;
        var nx = (x1 * y2 - y1 * x2) * (x3 - x4) - (x1 - x2) * (x3 * y4 - y3 * x4), ny = (x1 * y2 - y1 * x2) * (y3 - y4) - (y1 - y2) * (x3 * y4 - y3 * x4), denominator = (x1 - x2) * (y3 - y4) - (y1 - y2) * (x3 - x4);
        if (!denominator) return;
        var px = nx / denominator, py = ny / denominator, px2 = +px.toFixed(2), py2 = +py.toFixed(2);
        if (px2 < +mmin(x1, x2).toFixed(2) || px2 > +mmax(x1, x2).toFixed(2) || px2 < +mmin(x3, x4).toFixed(2) || px2 > +mmax(x3, x4).toFixed(2) || py2 < +mmin(y1, y2).toFixed(2) || py2 > +mmax(y1, y2).toFixed(2) || py2 < +mmin(y3, y4).toFixed(2) || py2 > +mmax(y3, y4).toFixed(2)) return;
        return {
            x: px,
            y: py
        };
    }
    function inter(bez1, bez2) {
        return interHelper(bez1, bez2);
    }
    function interCount(bez1, bez2) {
        return interHelper(bez1, bez2, 1);
    }
    function interHelper(bez1, bez2, justCount) {
        var bbox1 = bezierBBox(bez1), bbox2 = bezierBBox(bez2);
        if (!isBBoxIntersect(bbox1, bbox2)) return justCount ? 0 : [];
        var l1 = bezlen.apply(0, bez1), l2 = bezlen.apply(0, bez2), n1 = ~~(l1 / 8), n2 = ~~(l2 / 8), dots1 = [], dots2 = [], xy = {}, res1 = justCount ? 0 : [];
        for(var i = 0; i < n1 + 1; i++){
            var p = findDotsAtSegment.apply(0, bez1.concat(i / n1));
            dots1.push({
                x: p.x,
                y: p.y,
                t: i / n1
            });
        }
        for(i = 0; i < n2 + 1; i++){
            p = findDotsAtSegment.apply(0, bez2.concat(i / n2));
            dots2.push({
                x: p.x,
                y: p.y,
                t: i / n2
            });
        }
        for(i = 0; i < n1; i++)for(var j = 0; j < n2; j++){
            var di = dots1[i], di1 = dots1[i + 1], dj = dots2[j], dj1 = dots2[j + 1], ci = abs(di1.x - di.x) < .001 ? "y" : "x", cj = abs(dj1.x - dj.x) < .001 ? "y" : "x", is = intersect(di.x, di.y, di1.x, di1.y, dj.x, dj.y, dj1.x, dj1.y);
            if (is) {
                if (xy[is.x.toFixed(4)] == is.y.toFixed(4)) continue;
                xy[is.x.toFixed(4)] = is.y.toFixed(4);
                var t1 = di.t + abs((is[ci] - di[ci]) / (di1[ci] - di[ci])) * (di1.t - di.t), t2 = dj.t + abs((is[cj] - dj[cj]) / (dj1[cj] - dj[cj])) * (dj1.t - dj.t);
                if (t1 >= 0 && t1 <= 1 && t2 >= 0 && t2 <= 1) {
                    if (justCount) res1++;
                    else res1.push({
                        x: is.x,
                        y: is.y,
                        t1: t1,
                        t2: t2
                    });
                }
            }
        }
        return res1;
    }
    function pathIntersection(path1, path2) {
        return interPathHelper(path1, path2);
    }
    function pathIntersectionNumber(path1, path2) {
        return interPathHelper(path1, path2, 1);
    }
    function interPathHelper(path1, path2, justCount) {
        path1 = path2curve(path1);
        path2 = path2curve(path2);
        var x1, y1, x2, y2, x1m, y1m, x2m, y2m, bez1, bez2, res1 = justCount ? 0 : [];
        for(var i = 0, ii = path1.length; i < ii; i++){
            var pi = path1[i];
            if (pi[0] == "M") {
                x1 = x1m = pi[1];
                y1 = y1m = pi[2];
            } else {
                if (pi[0] == "C") {
                    bez1 = [
                        x1,
                        y1
                    ].concat(pi.slice(1));
                    x1 = bez1[6];
                    y1 = bez1[7];
                } else {
                    bez1 = [
                        x1,
                        y1,
                        x1,
                        y1,
                        x1m,
                        y1m,
                        x1m,
                        y1m
                    ];
                    x1 = x1m;
                    y1 = y1m;
                }
                for(var j = 0, jj = path2.length; j < jj; j++){
                    var pj = path2[j];
                    if (pj[0] == "M") {
                        x2 = x2m = pj[1];
                        y2 = y2m = pj[2];
                    } else {
                        if (pj[0] == "C") {
                            bez2 = [
                                x2,
                                y2
                            ].concat(pj.slice(1));
                            x2 = bez2[6];
                            y2 = bez2[7];
                        } else {
                            bez2 = [
                                x2,
                                y2,
                                x2,
                                y2,
                                x2m,
                                y2m,
                                x2m,
                                y2m
                            ];
                            x2 = x2m;
                            y2 = y2m;
                        }
                        var intr = interHelper(bez1, bez2, justCount);
                        if (justCount) res1 += intr;
                        else {
                            for(var k = 0, kk = intr.length; k < kk; k++){
                                intr[k].segment1 = i;
                                intr[k].segment2 = j;
                                intr[k].bez1 = bez1;
                                intr[k].bez2 = bez2;
                            }
                            res1 = res1.concat(intr);
                        }
                    }
                }
            }
        }
        return res1;
    }
    function isPointInsidePath(path, x, y) {
        var bbox = pathBBox(path);
        return isPointInsideBBox(bbox, x, y) && interPathHelper(path, [
            [
                "M",
                x,
                y
            ],
            [
                "H",
                bbox.x2 + 10
            ]
        ], 1) % 2 == 1;
    }
    function pathBBox(path) {
        var pth = paths(path);
        if (pth.bbox) return clone(pth.bbox);
        if (!path) return box();
        path = path2curve(path);
        var x = 0, y = 0, X = [], Y = [], p;
        for(var i = 0, ii = path.length; i < ii; i++){
            p = path[i];
            if (p[0] == "M") {
                x = p[1];
                y = p[2];
                X.push(x);
                Y.push(y);
            } else {
                var dim = curveDim(x, y, p[1], p[2], p[3], p[4], p[5], p[6]);
                X = X.concat(dim.min.x, dim.max.x);
                Y = Y.concat(dim.min.y, dim.max.y);
                x = p[5];
                y = p[6];
            }
        }
        var xmin = mmin.apply(0, X), ymin = mmin.apply(0, Y), xmax = mmax.apply(0, X), ymax = mmax.apply(0, Y), bb = box(xmin, ymin, xmax - xmin, ymax - ymin);
        pth.bbox = clone(bb);
        return bb;
    }
    function rectPath(x, y, w, h, r) {
        if (r) return [
            [
                "M",
                +x + +r,
                y
            ],
            [
                "l",
                w - r * 2,
                0
            ],
            [
                "a",
                r,
                r,
                0,
                0,
                1,
                r,
                r
            ],
            [
                "l",
                0,
                h - r * 2
            ],
            [
                "a",
                r,
                r,
                0,
                0,
                1,
                -r,
                r
            ],
            [
                "l",
                r * 2 - w,
                0
            ],
            [
                "a",
                r,
                r,
                0,
                0,
                1,
                -r,
                -r
            ],
            [
                "l",
                0,
                r * 2 - h
            ],
            [
                "a",
                r,
                r,
                0,
                0,
                1,
                r,
                -r
            ],
            [
                "z"
            ]
        ];
        var res1 = [
            [
                "M",
                x,
                y
            ],
            [
                "l",
                w,
                0
            ],
            [
                "l",
                0,
                h
            ],
            [
                "l",
                -w,
                0
            ],
            [
                "z"
            ]
        ];
        res1.toString = toString;
        return res1;
    }
    function ellipsePath(x, y, rx, ry, a) {
        if (a == null && ry == null) ry = rx;
        x = +x;
        y = +y;
        rx = +rx;
        ry = +ry;
        if (a != null) var rad = Math.PI / 180, x1 = x + rx * Math.cos(-ry * rad), x2 = x + rx * Math.cos(-a * rad), y1 = y + rx * Math.sin(-ry * rad), y2 = y + rx * Math.sin(-a * rad), res1 = [
            [
                "M",
                x1,
                y1
            ],
            [
                "A",
                rx,
                rx,
                0,
                +(a - ry > 180),
                0,
                x2,
                y2
            ]
        ];
        else res1 = [
            [
                "M",
                x,
                y
            ],
            [
                "m",
                0,
                -ry
            ],
            [
                "a",
                rx,
                ry,
                0,
                1,
                1,
                0,
                2 * ry
            ],
            [
                "a",
                rx,
                ry,
                0,
                1,
                1,
                0,
                -2 * ry
            ],
            [
                "z"
            ]
        ];
        res1.toString = toString;
        return res1;
    }
    var unit2px = Snap._unit2px, getPath = {
        path: function(el) {
            return el.attr("path");
        },
        circle: function(el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx, attr.cy, attr.r);
        },
        ellipse: function(el) {
            var attr = unit2px(el);
            return ellipsePath(attr.cx || 0, attr.cy || 0, attr.rx, attr.ry);
        },
        rect: function(el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height, attr.rx, attr.ry);
        },
        image: function(el) {
            var attr = unit2px(el);
            return rectPath(attr.x || 0, attr.y || 0, attr.width, attr.height);
        },
        line: function(el) {
            return "M" + [
                el.attr("x1") || 0,
                el.attr("y1") || 0,
                el.attr("x2"),
                el.attr("y2")
            ];
        },
        polyline: function(el) {
            return "M" + el.attr("points");
        },
        polygon: function(el) {
            return "M" + el.attr("points") + "z";
        },
        deflt: function(el) {
            var bbox = el.node.getBBox();
            return rectPath(bbox.x, bbox.y, bbox.width, bbox.height);
        }
    };
    function pathToRelative(pathArray) {
        var pth = paths(pathArray), lowerCase = String.prototype.toLowerCase;
        if (pth.rel) return pathClone(pth.rel);
        if (!Snap.is(pathArray, "array") || !Snap.is(pathArray && pathArray[0], "array")) pathArray = Snap.parsePathString(pathArray);
        var res1 = [], x = 0, y = 0, mx = 0, my = 0, start = 0;
        if (pathArray[0][0] == "M") {
            x = pathArray[0][1];
            y = pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res1.push([
                "M",
                x,
                y
            ]);
        }
        for(var i = start, ii = pathArray.length; i < ii; i++){
            var r = res1[i] = [], pa = pathArray[i];
            if (pa[0] != lowerCase.call(pa[0])) {
                r[0] = lowerCase.call(pa[0]);
                switch(r[0]){
                    case "a":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +(pa[6] - x).toFixed(3);
                        r[7] = +(pa[7] - y).toFixed(3);
                        break;
                    case "v":
                        r[1] = +(pa[1] - y).toFixed(3);
                        break;
                    case "m":
                        mx = pa[1];
                        my = pa[2];
                    default:
                        for(var j = 1, jj = pa.length; j < jj; j++)r[j] = +(pa[j] - (j % 2 ? x : y)).toFixed(3);
                }
            } else {
                r = res1[i] = [];
                if (pa[0] == "m") {
                    mx = pa[1] + x;
                    my = pa[2] + y;
                }
                for(var k = 0, kk = pa.length; k < kk; k++)res1[i][k] = pa[k];
            }
            var len = res1[i].length;
            switch(res1[i][0]){
                case "z":
                    x = mx;
                    y = my;
                    break;
                case "h":
                    x += +res1[i][len - 1];
                    break;
                case "v":
                    y += +res1[i][len - 1];
                    break;
                default:
                    x += +res1[i][len - 2];
                    y += +res1[i][len - 1];
            }
        }
        res1.toString = toString;
        pth.rel = pathClone(res1);
        return res1;
    }
    function pathToAbsolute(pathArray) {
        var pth = paths(pathArray);
        if (pth.abs) return pathClone(pth.abs);
        if (!is(pathArray, "array") || !is(pathArray && pathArray[0], "array")) pathArray = Snap.parsePathString(pathArray);
        if (!pathArray || !pathArray.length) return [
            [
                "M",
                0,
                0
            ]
        ];
        var res1 = [], x = 0, y = 0, mx = 0, my = 0, start = 0, pa0;
        if (pathArray[0][0] == "M") {
            x = +pathArray[0][1];
            y = +pathArray[0][2];
            mx = x;
            my = y;
            start++;
            res1[0] = [
                "M",
                x,
                y
            ];
        }
        var crz = pathArray.length == 3 && pathArray[0][0] == "M" && pathArray[1][0].toUpperCase() == "R" && pathArray[2][0].toUpperCase() == "Z";
        for(var r, pa, i = start, ii = pathArray.length; i < ii; i++){
            res1.push(r = []);
            pa = pathArray[i];
            pa0 = pa[0];
            if (pa0 != pa0.toUpperCase()) {
                r[0] = pa0.toUpperCase();
                switch(r[0]){
                    case "A":
                        r[1] = pa[1];
                        r[2] = pa[2];
                        r[3] = pa[3];
                        r[4] = pa[4];
                        r[5] = pa[5];
                        r[6] = +pa[6] + x;
                        r[7] = +pa[7] + y;
                        break;
                    case "V":
                        r[1] = +pa[1] + y;
                        break;
                    case "H":
                        r[1] = +pa[1] + x;
                        break;
                    case "R":
                        var dots = [
                            x,
                            y
                        ].concat(pa.slice(1));
                        for(var j = 2, jj = dots.length; j < jj; j++){
                            dots[j] = +dots[j] + x;
                            dots[++j] = +dots[j] + y;
                        }
                        res1.pop();
                        res1 = res1.concat(catmullRom2bezier(dots, crz));
                        break;
                    case "O":
                        res1.pop();
                        dots = ellipsePath(x, y, pa[1], pa[2]);
                        dots.push(dots[0]);
                        res1 = res1.concat(dots);
                        break;
                    case "U":
                        res1.pop();
                        res1 = res1.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                        r = [
                            "U"
                        ].concat(res1[res1.length - 1].slice(-2));
                        break;
                    case "M":
                        mx = +pa[1] + x;
                        my = +pa[2] + y;
                    default:
                        for(j = 1, jj = pa.length; j < jj; j++)r[j] = +pa[j] + (j % 2 ? x : y);
                }
            } else if (pa0 == "R") {
                dots = [
                    x,
                    y
                ].concat(pa.slice(1));
                res1.pop();
                res1 = res1.concat(catmullRom2bezier(dots, crz));
                r = [
                    "R"
                ].concat(pa.slice(-2));
            } else if (pa0 == "O") {
                res1.pop();
                dots = ellipsePath(x, y, pa[1], pa[2]);
                dots.push(dots[0]);
                res1 = res1.concat(dots);
            } else if (pa0 == "U") {
                res1.pop();
                res1 = res1.concat(ellipsePath(x, y, pa[1], pa[2], pa[3]));
                r = [
                    "U"
                ].concat(res1[res1.length - 1].slice(-2));
            } else for(var k = 0, kk = pa.length; k < kk; k++)r[k] = pa[k];
            pa0 = pa0.toUpperCase();
            if (pa0 != "O") switch(r[0]){
                case "Z":
                    x = +mx;
                    y = +my;
                    break;
                case "H":
                    x = r[1];
                    break;
                case "V":
                    y = r[1];
                    break;
                case "M":
                    mx = r[r.length - 2];
                    my = r[r.length - 1];
                default:
                    x = r[r.length - 2];
                    y = r[r.length - 1];
            }
        }
        res1.toString = toString;
        pth.abs = pathClone(res1);
        return res1;
    }
    function l2c(x1, y1, x2, y2) {
        return [
            x1,
            y1,
            x2,
            y2,
            x2,
            y2
        ];
    }
    function q2c(x1, y1, ax, ay, x2, y2) {
        var _13 = 1 / 3, _23 = 2 / 3;
        return [
            _13 * x1 + _23 * ax,
            _13 * y1 + _23 * ay,
            _13 * x2 + _23 * ax,
            _13 * y2 + _23 * ay,
            x2,
            y2
        ];
    }
    function a2c(x1, y1, rx, ry, angle, large_arc_flag, sweep_flag, x2, y2, recursive) {
        // for more information of where this math came from visit:
        // http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
        var _120 = PI * 120 / 180, rad = PI / 180 * (+angle || 0), res1 = [], xy, rotate = Snap._.cacher(function(x, y, rad) {
            var X = x * math1.cos(rad) - y * math1.sin(rad), Y = x * math1.sin(rad) + y * math1.cos(rad);
            return {
                x: X,
                y: Y
            };
        });
        if (!rx || !ry) return [
            x1,
            y1,
            x2,
            y2,
            x2,
            y2
        ];
        if (!recursive) {
            xy = rotate(x1, y1, -rad);
            x1 = xy.x;
            y1 = xy.y;
            xy = rotate(x2, y2, -rad);
            x2 = xy.x;
            y2 = xy.y;
            var cos = math1.cos(PI / 180 * angle), sin = math1.sin(PI / 180 * angle), x = (x1 - x2) / 2, y = (y1 - y2) / 2;
            var h = x * x / (rx * rx) + y * y / (ry * ry);
            if (h > 1) {
                h = math1.sqrt(h);
                rx = h * rx;
                ry = h * ry;
            }
            var rx2 = rx * rx, ry2 = ry * ry, k = (large_arc_flag == sweep_flag ? -1 : 1) * math1.sqrt(abs((rx2 * ry2 - rx2 * y * y - ry2 * x * x) / (rx2 * y * y + ry2 * x * x))), cx = k * rx * y / ry + (x1 + x2) / 2, cy = k * -ry * x / rx + (y1 + y2) / 2, f1 = math1.asin(((y1 - cy) / ry).toFixed(9)), f2 = math1.asin(((y2 - cy) / ry).toFixed(9));
            f1 = x1 < cx ? PI - f1 : f1;
            f2 = x2 < cx ? PI - f2 : f2;
            f1 < 0 && (f1 = PI * 2 + f1);
            f2 < 0 && (f2 = PI * 2 + f2);
            if (sweep_flag && f1 > f2) f1 = f1 - PI * 2;
            if (!sweep_flag && f2 > f1) f2 = f2 - PI * 2;
        } else {
            f1 = recursive[0];
            f2 = recursive[1];
            cx = recursive[2];
            cy = recursive[3];
        }
        var df = f2 - f1;
        if (abs(df) > _120) {
            var f2old = f2, x2old = x2, y2old = y2;
            f2 = f1 + _120 * (sweep_flag && f2 > f1 ? 1 : -1);
            x2 = cx + rx * math1.cos(f2);
            y2 = cy + ry * math1.sin(f2);
            res1 = a2c(x2, y2, rx, ry, angle, 0, sweep_flag, x2old, y2old, [
                f2,
                f2old,
                cx,
                cy
            ]);
        }
        df = f2 - f1;
        var c1 = math1.cos(f1), s1 = math1.sin(f1), c2 = math1.cos(f2), s2 = math1.sin(f2), t = math1.tan(df / 4), hx = 4 / 3 * rx * t, hy = 4 / 3 * ry * t, m1 = [
            x1,
            y1
        ], m2 = [
            x1 + hx * s1,
            y1 - hy * c1
        ], m3 = [
            x2 + hx * s2,
            y2 - hy * c2
        ], m4 = [
            x2,
            y2
        ];
        m2[0] = 2 * m1[0] - m2[0];
        m2[1] = 2 * m1[1] - m2[1];
        if (recursive) return [
            m2,
            m3,
            m4
        ].concat(res1);
        else {
            res1 = [
                m2,
                m3,
                m4
            ].concat(res1).join().split(",");
            var newres = [];
            for(var i = 0, ii = res1.length; i < ii; i++)newres[i] = i % 2 ? rotate(res1[i - 1], res1[i], rad).y : rotate(res1[i], res1[i + 1], rad).x;
            return newres;
        }
    }
    function findDotAtSegment(p1x, p1y, c1x, c1y, c2x, c2y, p2x, p2y, t) {
        var t1 = 1 - t;
        return {
            x: pow(t1, 3) * p1x + pow(t1, 2) * 3 * t * c1x + t1 * 3 * t * t * c2x + pow(t, 3) * p2x,
            y: pow(t1, 3) * p1y + pow(t1, 2) * 3 * t * c1y + t1 * 3 * t * t * c2y + pow(t, 3) * p2y
        };
    }
    // Returns bounding box of cubic bezier curve.
    // Source: http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    // Original version: NISHIO Hirokazu
    // Modifications: https://github.com/timo22345
    function curveDim(x0, y0, x1, y1, x2, y2, x3, y3) {
        var tvalues = [], bounds = [
            [],
            []
        ], a, b, c, t, t1, t2, b2ac, sqrtb2ac;
        for(var i = 0; i < 2; ++i){
            if (i == 0) {
                b = 6 * x0 - 12 * x1 + 6 * x2;
                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                c = 3 * x1 - 3 * x0;
            } else {
                b = 6 * y0 - 12 * y1 + 6 * y2;
                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                c = 3 * y1 - 3 * y0;
            }
            if (abs(a) < 1e-12) {
                if (abs(b) < 1e-12) continue;
                t = -c / b;
                if (0 < t && t < 1) tvalues.push(t);
                continue;
            }
            b2ac = b * b - 4 * c * a;
            sqrtb2ac = math1.sqrt(b2ac);
            if (b2ac < 0) continue;
            t1 = (-b + sqrtb2ac) / (2 * a);
            if (0 < t1 && t1 < 1) tvalues.push(t1);
            t2 = (-b - sqrtb2ac) / (2 * a);
            if (0 < t2 && t2 < 1) tvalues.push(t2);
        }
        var x, y, j = tvalues.length, jlen = j, mt;
        while(j--){
            t = tvalues[j];
            mt = 1 - t;
            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
        }
        bounds[0][jlen] = x0;
        bounds[1][jlen] = y0;
        bounds[0][jlen + 1] = x3;
        bounds[1][jlen + 1] = y3;
        bounds[0].length = bounds[1].length = jlen + 2;
        return {
            min: {
                x: mmin.apply(0, bounds[0]),
                y: mmin.apply(0, bounds[1])
            },
            max: {
                x: mmax.apply(0, bounds[0]),
                y: mmax.apply(0, bounds[1])
            }
        };
    }
    function path2curve(path, path2) {
        var pth = !path2 && paths(path);
        if (!path2 && pth.curve) return pathClone(pth.curve);
        var p = pathToAbsolute(path), p2 = path2 && pathToAbsolute(path2), attrs = {
            x: 0,
            y: 0,
            bx: 0,
            by: 0,
            X: 0,
            Y: 0,
            qx: null,
            qy: null
        }, attrs2 = {
            x: 0,
            y: 0,
            bx: 0,
            by: 0,
            X: 0,
            Y: 0,
            qx: null,
            qy: null
        }, processPath = function(path, d, pcom) {
            var nx, ny;
            if (!path) return [
                "C",
                d.x,
                d.y,
                d.x,
                d.y,
                d.x,
                d.y
            ];
            !(path[0] in {
                T: 1,
                Q: 1
            }) && (d.qx = d.qy = null);
            switch(path[0]){
                case "M":
                    d.X = path[1];
                    d.Y = path[2];
                    break;
                case "A":
                    path = [
                        "C"
                    ].concat(a2c.apply(0, [
                        d.x,
                        d.y
                    ].concat(path.slice(1))));
                    break;
                case "S":
                    if (pcom == "C" || pcom == "S") {
                        nx = d.x * 2 - d.bx; // And reflect the previous
                        ny = d.y * 2 - d.by; // command's control point relative to the current point.
                    } else {
                        nx = d.x;
                        ny = d.y;
                    }
                    path = [
                        "C",
                        nx,
                        ny
                    ].concat(path.slice(1));
                    break;
                case "T":
                    if (pcom == "Q" || pcom == "T") {
                        d.qx = d.x * 2 - d.qx; // And make a reflection similar
                        d.qy = d.y * 2 - d.qy; // to case "S".
                    } else {
                        d.qx = d.x;
                        d.qy = d.y;
                    }
                    path = [
                        "C"
                    ].concat(q2c(d.x, d.y, d.qx, d.qy, path[1], path[2]));
                    break;
                case "Q":
                    d.qx = path[1];
                    d.qy = path[2];
                    path = [
                        "C"
                    ].concat(q2c(d.x, d.y, path[1], path[2], path[3], path[4]));
                    break;
                case "L":
                    path = [
                        "C"
                    ].concat(l2c(d.x, d.y, path[1], path[2]));
                    break;
                case "H":
                    path = [
                        "C"
                    ].concat(l2c(d.x, d.y, path[1], d.y));
                    break;
                case "V":
                    path = [
                        "C"
                    ].concat(l2c(d.x, d.y, d.x, path[1]));
                    break;
                case "Z":
                    path = [
                        "C"
                    ].concat(l2c(d.x, d.y, d.X, d.Y));
                    break;
            }
            return path;
        }, fixArc = function(pp, i) {
            if (pp[i].length > 7) {
                pp[i].shift();
                var pi = pp[i];
                while(pi.length){
                    pcoms1[i] = "A"; // if created multiple C:s, their original seg is saved
                    p2 && (pcoms2[i] = "A"); // the same as above
                    pp.splice(i++, 0, [
                        "C"
                    ].concat(pi.splice(0, 6)));
                }
                pp.splice(i, 1);
                ii = mmax(p.length, p2 && p2.length || 0);
            }
        }, fixM = function(path1, path2, a1, a2, i) {
            if (path1 && path2 && path1[i][0] == "M" && path2[i][0] != "M") {
                path2.splice(i, 0, [
                    "M",
                    a2.x,
                    a2.y
                ]);
                a1.bx = 0;
                a1.by = 0;
                a1.x = path1[i][1];
                a1.y = path1[i][2];
                ii = mmax(p.length, p2 && p2.length || 0);
            }
        }, pcoms1 = [], pcoms2 = [], pfirst = "", pcom = ""; // holder for previous path command of original path
        for(var i = 0, ii = mmax(p.length, p2 && p2.length || 0); i < ii; i++){
            p[i] && (pfirst = p[i][0]); // save current path command
            if (pfirst != "C") {
                pcoms1[i] = pfirst; // Save current path command
                i && (pcom = pcoms1[i - 1]); // Get previous path command pcom
            }
            p[i] = processPath(p[i], attrs, pcom); // Previous path command is inputted to processPath
            if (pcoms1[i] != "A" && pfirst == "C") pcoms1[i] = "C"; // A is the only command
            // which may produce multiple C:s
            // so we have to make sure that C is also C in original path
            fixArc(p, i); // fixArc adds also the right amount of A:s to pcoms1
            if (p2) {
                p2[i] && (pfirst = p2[i][0]);
                if (pfirst != "C") {
                    pcoms2[i] = pfirst;
                    i && (pcom = pcoms2[i - 1]);
                }
                p2[i] = processPath(p2[i], attrs2, pcom);
                if (pcoms2[i] != "A" && pfirst == "C") pcoms2[i] = "C";
                fixArc(p2, i);
            }
            fixM(p, p2, attrs, attrs2, i);
            fixM(p2, p, attrs2, attrs, i);
            var seg = p[i], seg2 = p2 && p2[i], seglen = seg.length, seg2len = p2 && seg2.length;
            attrs.x = seg[seglen - 2];
            attrs.y = seg[seglen - 1];
            attrs.bx = toFloat(seg[seglen - 4]) || attrs.x;
            attrs.by = toFloat(seg[seglen - 3]) || attrs.y;
            attrs2.bx = p2 && (toFloat(seg2[seg2len - 4]) || attrs2.x);
            attrs2.by = p2 && (toFloat(seg2[seg2len - 3]) || attrs2.y);
            attrs2.x = p2 && seg2[seg2len - 2];
            attrs2.y = p2 && seg2[seg2len - 1];
        }
        if (!p2) pth.curve = pathClone(p);
        return p2 ? [
            p,
            p2
        ] : p;
    }
    function mapPath(path, matrix) {
        if (!matrix) return path;
        var x, y, i, j, ii, jj, pathi;
        path = path2curve(path);
        for(i = 0, ii = path.length; i < ii; i++){
            pathi = path[i];
            for(j = 1, jj = pathi.length; j < jj; j += 2){
                x = matrix.x(pathi[j], pathi[j + 1]);
                y = matrix.y(pathi[j], pathi[j + 1]);
                pathi[j] = x;
                pathi[j + 1] = y;
            }
        }
        return path;
    }
    // http://schepers.cc/getting-to-the-point
    function catmullRom2bezier(crp, z) {
        var d = [];
        for(var i = 0, iLen = crp.length; iLen - 2 * !z > i; i += 2){
            var p = [
                {
                    x: +crp[i - 2],
                    y: +crp[i - 1]
                },
                {
                    x: +crp[i],
                    y: +crp[i + 1]
                },
                {
                    x: +crp[i + 2],
                    y: +crp[i + 3]
                },
                {
                    x: +crp[i + 4],
                    y: +crp[i + 5]
                }
            ];
            if (z) {
                if (!i) p[0] = {
                    x: +crp[iLen - 2],
                    y: +crp[iLen - 1]
                };
                else if (iLen - 4 == i) p[3] = {
                    x: +crp[0],
                    y: +crp[1]
                };
                else if (iLen - 2 == i) {
                    p[2] = {
                        x: +crp[0],
                        y: +crp[1]
                    };
                    p[3] = {
                        x: +crp[2],
                        y: +crp[3]
                    };
                }
            } else {
                if (iLen - 4 == i) p[3] = p[2];
                else if (!i) p[0] = {
                    x: +crp[i],
                    y: +crp[i + 1]
                };
            }
            d.push([
                "C",
                (-p[0].x + 6 * p[1].x + p[2].x) / 6,
                (-p[0].y + 6 * p[1].y + p[2].y) / 6,
                (p[1].x + 6 * p[2].x - p[3].x) / 6,
                (p[1].y + 6 * p[2].y - p[3].y) / 6,
                p[2].x,
                p[2].y
            ]);
        }
        return d;
    }
    // export
    Snap.path = paths;
    /*\
     * Snap.path.getTotalLength
     [ method ]
     **
     * Returns the length of the given path in pixels
     **
     - path (string) SVG path string
     **
     = (number) length
    \*/ Snap.path.getTotalLength = getTotalLength;
    /*\
     * Snap.path.getPointAtLength
     [ method ]
     **
     * Returns the coordinates of the point located at the given length along the given path
     **
     - path (string) SVG path string
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/ Snap.path.getPointAtLength = getPointAtLength;
    /*\
     * Snap.path.getSubpath
     [ method ]
     **
     * Returns the subpath of a given path between given start and end lengths
     **
     - path (string) SVG path string
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/ Snap.path.getSubpath = function(path, from, to) {
        if (this.getTotalLength(path) - to < 1e-6) return getSubpathsAtLength(path, from).end;
        var a = getSubpathsAtLength(path, to, 1);
        return from ? getSubpathsAtLength(a, from).end : a;
    };
    /*\
     * Element.getTotalLength
     [ method ]
     **
     * Returns the length of the path in pixels (only works for `path` elements)
     = (number) length
    \*/ elproto.getTotalLength = function() {
        if (this.node.getTotalLength) return this.node.getTotalLength();
    };
    // SIERRA Element.getPointAtLength()/Element.getTotalLength(): If a <path> is broken into different segments, is the jump distance to the new coordinates set by the _M_ or _m_ commands calculated as part of the path's total length?
    /*\
     * Element.getPointAtLength
     [ method ]
     **
     * Returns coordinates of the point located at the given length on the given path (only works for `path` elements)
     **
     - length (number) length, in pixels, from the start of the path, excluding non-rendering jumps
     **
     = (object) representation of the point:
     o {
     o     x: (number) x coordinate,
     o     y: (number) y coordinate,
     o     alpha: (number) angle of derivative
     o }
    \*/ elproto.getPointAtLength = function(length) {
        return getPointAtLength(this.attr("d"), length);
    };
    // SIERRA Element.getSubpath(): Similar to the problem for Element.getPointAtLength(). Unclear how this would work for a segmented path. Overall, the concept of _subpath_ and what I'm calling a _segment_ (series of non-_M_ or _Z_ commands) is unclear.
    /*\
     * Element.getSubpath
     [ method ]
     **
     * Returns subpath of a given element from given start and end lengths (only works for `path` elements)
     **
     - from (number) length, in pixels, from the start of the path to the start of the segment
     - to (number) length, in pixels, from the start of the path to the end of the segment
     **
     = (string) path string definition for the segment
    \*/ elproto.getSubpath = function(from, to) {
        return Snap.path.getSubpath(this.attr("d"), from, to);
    };
    Snap._.box = box;
    /*\
     * Snap.path.findDotsAtSegment
     [ method ]
     **
     * Utility method
     **
     * Finds dot coordinates on the given cubic beziér curve at the given t
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     - t (number) position on the curve (0..1)
     = (object) point information in format:
     o {
     o     x: (number) x coordinate of the point,
     o     y: (number) y coordinate of the point,
     o     m: {
     o         x: (number) x coordinate of the left anchor,
     o         y: (number) y coordinate of the left anchor
     o     },
     o     n: {
     o         x: (number) x coordinate of the right anchor,
     o         y: (number) y coordinate of the right anchor
     o     },
     o     start: {
     o         x: (number) x coordinate of the start of the curve,
     o         y: (number) y coordinate of the start of the curve
     o     },
     o     end: {
     o         x: (number) x coordinate of the end of the curve,
     o         y: (number) y coordinate of the end of the curve
     o     },
     o     alpha: (number) angle of the curve derivative at the point
     o }
    \*/ Snap.path.findDotsAtSegment = findDotsAtSegment;
    /*\
     * Snap.path.bezierBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given cubic beziér curve
     - p1x (number) x of the first point of the curve
     - p1y (number) y of the first point of the curve
     - c1x (number) x of the first anchor of the curve
     - c1y (number) y of the first anchor of the curve
     - c2x (number) x of the second anchor of the curve
     - c2y (number) y of the second anchor of the curve
     - p2x (number) x of the second point of the curve
     - p2y (number) y of the second point of the curve
     * or
     - bez (array) array of six points for beziér curve
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/ Snap.path.bezierBBox = bezierBBox;
    /*\
     * Snap.path.isPointInsideBBox
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside bounding box
     - bbox (string) bounding box
     - x (string) x coordinate of the point
     - y (string) y coordinate of the point
     = (boolean) `true` if point is inside
    \*/ Snap.path.isPointInsideBBox = isPointInsideBBox;
    Snap.closest = function(x, y, X, Y) {
        var r = 100, b = box(x - r / 2, y - r / 2, r, r), inside = [], getter = X[0].hasOwnProperty("x") ? function(i) {
            return {
                x: X[i].x,
                y: X[i].y
            };
        } : function(i) {
            return {
                x: X[i],
                y: Y[i]
            };
        }, found = 0;
        while(r <= 1e6 && !found){
            for(var i = 0, ii = X.length; i < ii; i++){
                var xy = getter(i);
                if (isPointInsideBBox(b, xy.x, xy.y)) {
                    found++;
                    inside.push(xy);
                    break;
                }
            }
            if (!found) {
                r *= 2;
                b = box(x - r / 2, y - r / 2, r, r);
            }
        }
        if (r == 1e6) return;
        var len = Infinity, res1;
        for(i = 0, ii = inside.length; i < ii; i++){
            var l = Snap.len(x, y, inside[i].x, inside[i].y);
            if (len > l) {
                len = l;
                inside[i].len = l;
                res1 = inside[i];
            }
        }
        return res1;
    };
    /*\
     * Snap.path.isBBoxIntersect
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if two bounding boxes intersect
     - bbox1 (string) first bounding box
     - bbox2 (string) second bounding box
     = (boolean) `true` if bounding boxes intersect
    \*/ Snap.path.isBBoxIntersect = isBBoxIntersect;
    /*\
     * Snap.path.intersection
     [ method ]
     **
     * Utility method
     **
     * Finds intersections of two paths
     - path1 (string) path string
     - path2 (string) path string
     = (array) dots of intersection
     o [
     o     {
     o         x: (number) x coordinate of the point,
     o         y: (number) y coordinate of the point,
     o         t1: (number) t value for segment of path1,
     o         t2: (number) t value for segment of path2,
     o         segment1: (number) order number for segment of path1,
     o         segment2: (number) order number for segment of path2,
     o         bez1: (array) eight coordinates representing beziér curve for the segment of path1,
     o         bez2: (array) eight coordinates representing beziér curve for the segment of path2
     o     }
     o ]
    \*/ Snap.path.intersection = pathIntersection;
    Snap.path.intersectionNumber = pathIntersectionNumber;
    /*\
     * Snap.path.isPointInside
     [ method ]
     **
     * Utility method
     **
     * Returns `true` if given point is inside a given closed path.
     *
     * Note: fill mode doesn’t affect the result of this method.
     - path (string) path string
     - x (number) x of the point
     - y (number) y of the point
     = (boolean) `true` if point is inside the path
    \*/ Snap.path.isPointInside = isPointInsidePath;
    /*\
     * Snap.path.getBBox
     [ method ]
     **
     * Utility method
     **
     * Returns the bounding box of a given path
     - path (string) path string
     = (object) bounding box
     o {
     o     x: (number) x coordinate of the left top point of the box,
     o     y: (number) y coordinate of the left top point of the box,
     o     x2: (number) x coordinate of the right bottom point of the box,
     o     y2: (number) y coordinate of the right bottom point of the box,
     o     width: (number) width of the box,
     o     height: (number) height of the box
     o }
    \*/ Snap.path.getBBox = pathBBox;
    Snap.path.get = getPath;
    /*\
     * Snap.path.toRelative
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into relative values
     - path (string) path string
     = (array) path string
    \*/ Snap.path.toRelative = pathToRelative;
    /*\
     * Snap.path.toAbsolute
     [ method ]
     **
     * Utility method
     **
     * Converts path coordinates into absolute values
     - path (string) path string
     = (array) path string
    \*/ Snap.path.toAbsolute = pathToAbsolute;
    /*\
     * Snap.path.toCubic
     [ method ]
     **
     * Utility method
     **
     * Converts path to a new path where all segments are cubic beziér curves
     - pathString (string|array) path string or array of segments
     = (array) array of segments
    \*/ Snap.path.toCubic = path2curve;
    /*\
     * Snap.path.map
     [ method ]
     **
     * Transform the path string with the given matrix
     - path (string) path string
     - matrix (object) see @Matrix
     = (string) transformed path string
    \*/ Snap.path.map = mapPath;
    Snap.path.toString = toString;
    Snap.path.clone = pathClone;
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    var mmax = Math.max, mmin = Math.min;
    // Set
    var Set = function(items) {
        this.items = [];
        this.bindings = {};
        this.length = 0;
        this.type = "set";
        if (items) {
            for(var i = 0, ii = items.length; i < ii; i++)if (items[i]) {
                this[this.items.length] = this.items[this.items.length] = items[i];
                this.length++;
            }
        }
    }, setproto = Set.prototype;
    /*\
     * Set.push
     [ method ]
     **
     * Adds each argument to the current set
     = (object) original element
    \*/ setproto.push = function() {
        var item, len;
        for(var i = 0, ii = arguments.length; i < ii; i++){
            item = arguments[i];
            if (item) {
                len = this.items.length;
                this[len] = this.items[len] = item;
                this.length++;
            }
        }
        return this;
    };
    /*\
     * Set.pop
     [ method ]
     **
     * Removes last element and returns it
     = (object) element
    \*/ setproto.pop = function() {
        this.length && delete this[this.length--];
        return this.items.pop();
    };
    /*\
     * Set.forEach
     [ method ]
     **
     * Executes given function for each element in the set
     *
     * If the function returns `false`, the loop stops running.
     **
     - callback (function) function to run
     - thisArg (object) context object for the callback
     = (object) Set object
    \*/ setproto.forEach = function(callback, thisArg) {
        for(var i = 0, ii = this.items.length; i < ii; i++){
            if (callback.call(thisArg, this.items[i], i) === false) return this;
        }
        return this;
    };
    /*\
     * Set.animate
     [ method ]
     **
     * Animates each element in set in sync.
     *
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     * or
     - animation (array) array of animation parameter for each element in set in format `[attrs, duration, easing, callback]`
     > Usage
     | // animate all elements in set to radius 10
     | set.animate({r: 10}, 500, mina.easein);
     | // or
     | // animate first element to radius 10, but second to radius 20 and in different time
     | set.animate([{r: 10}, 500, mina.easein], [{r: 20}, 1500, mina.easein]);
     = (Element) the current element
    \*/ setproto.animate = function(attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = $f098236b7e761f68$var$mina.linear;
        }
        if (attrs instanceof Snap._.Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = easing.dur;
            attrs = attrs.attr;
        }
        var args = arguments;
        if (Snap.is(attrs, "array") && Snap.is(args[args.length - 1], "array")) var each = true;
        var begin, handler = function() {
            if (begin) this.b = begin;
            else begin = this.b;
        }, cb = 0, set = this, callbacker = callback && function() {
            if (++cb == set.length) callback.call(this);
        };
        return this.forEach(function(el, i) {
            eve.once("snap.animcreated." + el.id, handler);
            if (each) args[i] && el.animate.apply(el, args[i]);
            else el.animate(attrs, ms, easing, callbacker);
        });
    };
    /*\
     * Set.remove
     [ method ]
     **
     * Removes all children of the set.
     *
     = (object) Set object
    \*/ setproto.remove = function() {
        while(this.length)this.pop().remove();
        return this;
    };
    /*\
     * Set.bind
     [ method ]
     **
     * Specifies how to handle a specific attribute when applied
     * to a set.
     *
     **
     - attr (string) attribute name
     - callback (function) function to run
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     * or
     - attr (string) attribute name
     - element (Element) specific element in the set to apply the attribute to
     - eattr (string) attribute on the element to bind the attribute to
     = (object) Set object
    \*/ setproto.bind = function(attr, a, b) {
        var data = {};
        if (typeof a == "function") this.bindings[attr] = a;
        else {
            var aname = b || attr;
            this.bindings[attr] = function(v) {
                data[aname] = v;
                a.attr(data);
            };
        }
        return this;
    };
    /*\
     * Set.attr
     [ method ]
     **
     * Equivalent of @Element.attr.
     = (object) Set object
    \*/ setproto.attr = function(value) {
        var unbound = {};
        for(var k in value)if (this.bindings[k]) this.bindings[k](value[k]);
        else unbound[k] = value[k];
        for(var i = 0, ii = this.items.length; i < ii; i++)this.items[i].attr(unbound);
        return this;
    };
    /*\
     * Set.clear
     [ method ]
     **
     * Removes all elements from the set
    \*/ setproto.clear = function() {
        while(this.length)this.pop();
    };
    /*\
     * Set.splice
     [ method ]
     **
     * Removes range of elements from the set
     **
     - index (number) position of the deletion
     - count (number) number of element to remove
     - insertion… (object) #optional elements to insert
     = (object) set elements that were deleted
    \*/ setproto.splice = function(index, count, insertion) {
        index = index < 0 ? mmax(this.length + index, 0) : index;
        count = mmax(0, mmin(this.length - index, count));
        var tail = [], todel = [], args = [], i;
        for(i = 2; i < arguments.length; i++)args.push(arguments[i]);
        for(i = 0; i < count; i++)todel.push(this[index + i]);
        for(; i < this.length - index; i++)tail.push(this[index + i]);
        var arglen = args.length;
        for(i = 0; i < arglen + tail.length; i++)this.items[index + i] = this[index + i] = i < arglen ? args[i] : tail[i - arglen];
        i = this.items.length = this.length -= count - arglen;
        while(this[i])delete this[i++];
        return new Set(todel);
    };
    /*\
     * Set.exclude
     [ method ]
     **
     * Removes given element from the set
     **
     - element (object) element to remove
     = (boolean) `true` if object was found and removed from the set
    \*/ setproto.exclude = function(el) {
        for(var i = 0, ii = this.length; i < ii; i++)if (this[i] == el) {
            this.splice(i, 1);
            return true;
        }
        return false;
    };
    /*\
     * Set.insertAfter
     [ method ]
     **
     * Inserts set elements after given element.
     **
     - element (object) set will be inserted after this element
     = (object) Set object
    \*/ setproto.insertAfter = function(el) {
        var i = this.items.length;
        while(i--)this.items[i].insertAfter(el);
        return this;
    };
    /*\
     * Set.getBBox
     [ method ]
     **
     * Union of all bboxes of the set. See @Element.getBBox.
     = (object) bounding box descriptor. See @Element.getBBox.
    \*/ setproto.getBBox = function() {
        var x = [], y = [], x2 = [], y2 = [];
        for(var i = this.items.length; i--;)if (!this.items[i].removed) {
            var box = this.items[i].getBBox();
            x.push(box.x);
            y.push(box.y);
            x2.push(box.x + box.width);
            y2.push(box.y + box.height);
        }
        x = mmin.apply(0, x);
        y = mmin.apply(0, y);
        x2 = mmax.apply(0, x2);
        y2 = mmax.apply(0, y2);
        return {
            x: x,
            y: y,
            x2: x2,
            y2: y2,
            width: x2 - x,
            height: y2 - y,
            cx: x + (x2 - x) / 2,
            cy: y + (y2 - y) / 2
        };
    };
    /*\
     * Set.insertAfter
     [ method ]
     **
     * Creates a clone of the set.
     **
     = (object) New Set object
    \*/ setproto.clone = function(s) {
        s = new Set;
        for(var i = 0, ii = this.items.length; i < ii; i++)s.push(this.items[i].clone());
        return s;
    };
    setproto.toString = function() {
        return "Snap\u2018s set";
    };
    setproto.type = "set";
    // export
    /*\
     * Snap.Set
     [ property ]
     **
     * Set constructor.
    \*/ Snap.Set = Set;
    /*\
     * Snap.set
     [ method ]
     **
     * Creates a set and fills it with list of arguments.
     **
     = (object) New Set object
     | var r = paper.rect(0, 0, 10, 10),
     |     s1 = Snap.set(), // empty set
     |     s2 = Snap.set(r, paper.circle(100, 100, 20)); // prefilled set
    \*/ Snap.set = function() {
        var set = new Set;
        if (arguments.length) set.push.apply(set, Array.prototype.slice.call(arguments, 0));
        return set;
    };
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    var names = {}, reUnit = /[%a-z]+$/i, Str = String;
    names.stroke = names.fill = "colour";
    function getEmpty(item) {
        var l = item[0];
        switch(l.toLowerCase()){
            case "t":
                return [
                    l,
                    0,
                    0
                ];
            case "m":
                return [
                    l,
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
            case "r":
                if (item.length == 4) return [
                    l,
                    0,
                    item[2],
                    item[3]
                ];
                else return [
                    l,
                    0
                ];
            case "s":
                if (item.length == 5) return [
                    l,
                    1,
                    1,
                    item[3],
                    item[4]
                ];
                else if (item.length == 3) return [
                    l,
                    1,
                    1
                ];
                else return [
                    l,
                    1
                ];
        }
    }
    function equaliseTransform(t1, t2, getBBox) {
        t1 = t1 || new Snap.Matrix;
        t2 = t2 || new Snap.Matrix;
        t1 = Snap.parseTransformString(t1.toTransformString()) || [];
        t2 = Snap.parseTransformString(t2.toTransformString()) || [];
        var maxlength = Math.max(t1.length, t2.length), from = [], to = [], i = 0, j, jj, tt1, tt2;
        for(; i < maxlength; i++){
            tt1 = t1[i] || getEmpty(t2[i]);
            tt2 = t2[i] || getEmpty(tt1);
            if (tt1[0] != tt2[0] || tt1[0].toLowerCase() == "r" && (tt1[2] != tt2[2] || tt1[3] != tt2[3]) || tt1[0].toLowerCase() == "s" && (tt1[3] != tt2[3] || tt1[4] != tt2[4])) {
                t1 = Snap._.transform2matrix(t1, getBBox());
                t2 = Snap._.transform2matrix(t2, getBBox());
                from = [
                    [
                        "m",
                        t1.a,
                        t1.b,
                        t1.c,
                        t1.d,
                        t1.e,
                        t1.f
                    ]
                ];
                to = [
                    [
                        "m",
                        t2.a,
                        t2.b,
                        t2.c,
                        t2.d,
                        t2.e,
                        t2.f
                    ]
                ];
                break;
            }
            from[i] = [];
            to[i] = [];
            for(j = 0, jj = Math.max(tt1.length, tt2.length); j < jj; j++){
                j in tt1 && (from[i][j] = tt1[j]);
                j in tt2 && (to[i][j] = tt2[j]);
            }
        }
        return {
            from: path2array(from),
            to: path2array(to),
            f: getPath(from)
        };
    }
    function getNumber(val) {
        return val;
    }
    function getUnit(unit) {
        return function(val) {
            return +val.toFixed(3) + unit;
        };
    }
    function getViewBox(val) {
        return val.join(" ");
    }
    function getColour(clr) {
        return Snap.rgb(clr[0], clr[1], clr[2], clr[3]);
    }
    function getPath(path) {
        var k = 0, i, ii, j, jj, out, a, b = [];
        for(i = 0, ii = path.length; i < ii; i++){
            out = "[";
            a = [
                '"' + path[i][0] + '"'
            ];
            for(j = 1, jj = path[i].length; j < jj; j++)a[j] = "val[" + k++ + "]";
            out += a + "]";
            b[i] = out;
        }
        return Function("val", "return Snap.path.toString.call([" + b + "])");
    }
    function path2array(path) {
        var out = [];
        for(var i = 0, ii = path.length; i < ii; i++)for(var j = 1, jj = path[i].length; j < jj; j++)out.push(path[i][j]);
        return out;
    }
    function isNumeric(obj) {
        return isFinite(obj);
    }
    function arrayEqual(arr1, arr2) {
        if (!Snap.is(arr1, "array") || !Snap.is(arr2, "array")) return false;
        return arr1.toString() == arr2.toString();
    }
    Element.prototype.equal = function(name, b) {
        return eve("snap.util.equal", this, name, b).firstDefined();
    };
    eve.on("snap.util.equal", function(name, b) {
        var A, B, a = Str(this.attr(name) || ""), el = this;
        if (names[name] == "colour") {
            A = Snap.color(a);
            B = Snap.color(b);
            return {
                from: [
                    A.r,
                    A.g,
                    A.b,
                    A.opacity
                ],
                to: [
                    B.r,
                    B.g,
                    B.b,
                    B.opacity
                ],
                f: getColour
            };
        }
        if (name == "viewBox") {
            A = this.attr(name).vb.split(" ").map(Number);
            B = b.split(" ").map(Number);
            return {
                from: A,
                to: B,
                f: getViewBox
            };
        }
        if (name == "transform" || name == "gradientTransform" || name == "patternTransform") {
            if (typeof b == "string") b = Str(b).replace(/\.{3}|\u2026/g, a);
            a = this.matrix;
            if (!Snap._.rgTransform.test(b)) b = Snap._.transform2matrix(Snap._.svgTransform2string(b), this.getBBox());
            else b = Snap._.transform2matrix(b, this.getBBox());
            return equaliseTransform(a, b, function() {
                return el.getBBox(1);
            });
        }
        if (name == "d" || name == "path") {
            A = Snap.path.toCubic(a, b);
            return {
                from: path2array(A[0]),
                to: path2array(A[1]),
                f: getPath(A[0])
            };
        }
        if (name == "points") {
            A = Str(a).split(Snap._.separator);
            B = Str(b).split(Snap._.separator);
            return {
                from: A,
                to: B,
                f: function(val) {
                    return val;
                }
            };
        }
        if (isNumeric(a) && isNumeric(b)) return {
            from: parseFloat(a),
            to: parseFloat(b),
            f: getNumber
        };
        var aUnit = a.match(reUnit), bUnit = Str(b).match(reUnit);
        if (aUnit && arrayEqual(aUnit, bUnit)) return {
            from: parseFloat(a),
            to: parseFloat(b),
            f: getUnit(aUnit)
        };
        else return {
            from: this.asPX(name),
            to: this.asPX(name, b),
            f: getNumber
        };
    });
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
// 
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
// 
// http://www.apache.org/licenses/LICENSE-2.0
// 
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    var elproto = Element.prototype, has = "hasOwnProperty", supportsTouch = "createTouch" in glob.doc, events = [
        "click",
        "dblclick",
        "mousedown",
        "mousemove",
        "mouseout",
        "mouseover",
        "mouseup",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel"
    ], touchMap = {
        mousedown: "touchstart",
        mousemove: "touchmove",
        mouseup: "touchend"
    }, getScroll = function(xy, el) {
        var name = xy == "y" ? "scrollTop" : "scrollLeft", doc = el && el.node ? el.node.ownerDocument : glob.doc;
        return doc[name in doc.documentElement ? "documentElement" : "body"][name];
    }, preventDefault = function() {
        this.returnValue = false;
    }, preventTouch = function() {
        return this.originalEvent.preventDefault();
    }, stopPropagation = function() {
        this.cancelBubble = true;
    }, stopTouch = function() {
        return this.originalEvent.stopPropagation();
    }, addEvent = function(obj, type, fn, element) {
        var realName = supportsTouch && touchMap[type] ? touchMap[type] : type, f = function(e) {
            var scrollY = getScroll("y", element), scrollX = getScroll("x", element);
            if (supportsTouch && touchMap[has](type)) {
                for(var i = 0, ii = e.targetTouches && e.targetTouches.length; i < ii; i++)if (e.targetTouches[i].target == obj || obj.contains(e.targetTouches[i].target)) {
                    var olde = e;
                    e = e.targetTouches[i];
                    e.originalEvent = olde;
                    e.preventDefault = preventTouch;
                    e.stopPropagation = stopTouch;
                    break;
                }
            }
            var x = e.clientX + scrollX, y = e.clientY + scrollY;
            return fn.call(element, e, x, y);
        };
        if (type !== realName) obj.addEventListener(type, f, false);
        obj.addEventListener(realName, f, false);
        return function() {
            if (type !== realName) obj.removeEventListener(type, f, false);
            obj.removeEventListener(realName, f, false);
            return true;
        };
    }, drag = [], dragMove = function(e) {
        var x = e.clientX, y = e.clientY, scrollY = getScroll("y"), scrollX = getScroll("x"), dragi, j = drag.length;
        while(j--){
            dragi = drag[j];
            if (supportsTouch) {
                var i = e.touches && e.touches.length, touch;
                while(i--){
                    touch = e.touches[i];
                    if (touch.identifier == dragi.el._drag.id || dragi.el.node.contains(touch.target)) {
                        x = touch.clientX;
                        y = touch.clientY;
                        (e.originalEvent ? e.originalEvent : e).preventDefault();
                        break;
                    }
                }
            } else e.preventDefault();
            var node = dragi.el.node, o, next = node.nextSibling, parent = node.parentNode, display = node.style.display;
            // glob.win.opera && parent.removeChild(node);
            // node.style.display = "none";
            // o = dragi.el.paper.getElementByPoint(x, y);
            // node.style.display = display;
            // glob.win.opera && (next ? parent.insertBefore(node, next) : parent.appendChild(node));
            // o && eve("snap.drag.over." + dragi.el.id, dragi.el, o);
            x += scrollX;
            y += scrollY;
            eve("snap.drag.move." + dragi.el.id, dragi.move_scope || dragi.el, x - dragi.el._drag.x, y - dragi.el._drag.y, x, y, e);
        }
    }, dragUp = function(e) {
        Snap.unmousemove(dragMove).unmouseup(dragUp);
        var i = drag.length, dragi;
        while(i--){
            dragi = drag[i];
            dragi.el._drag = {};
            eve("snap.drag.end." + dragi.el.id, dragi.end_scope || dragi.start_scope || dragi.move_scope || dragi.el, e);
            eve.off("snap.drag.*." + dragi.el.id);
        }
        drag = [];
    };
    /*\
     * Element.click
     [ method ]
     **
     * Adds a click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unclick
     [ method ]
     **
     * Removes a click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.dblclick
     [ method ]
     **
     * Adds a double click event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.undblclick
     [ method ]
     **
     * Removes a double click event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.mousedown
     [ method ]
     **
     * Adds a mousedown event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unmousedown
     [ method ]
     **
     * Removes a mousedown event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.mousemove
     [ method ]
     **
     * Adds a mousemove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unmousemove
     [ method ]
     **
     * Removes a mousemove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.mouseout
     [ method ]
     **
     * Adds a mouseout event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unmouseout
     [ method ]
     **
     * Removes a mouseout event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.mouseover
     [ method ]
     **
     * Adds a mouseover event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unmouseover
     [ method ]
     **
     * Removes a mouseover event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.mouseup
     [ method ]
     **
     * Adds a mouseup event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.unmouseup
     [ method ]
     **
     * Removes a mouseup event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.touchstart
     [ method ]
     **
     * Adds a touchstart event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.untouchstart
     [ method ]
     **
     * Removes a touchstart event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.touchmove
     [ method ]
     **
     * Adds a touchmove event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.untouchmove
     [ method ]
     **
     * Removes a touchmove event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.touchend
     [ method ]
     **
     * Adds a touchend event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.untouchend
     [ method ]
     **
     * Removes a touchend event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.touchcancel
     [ method ]
     **
     * Adds a touchcancel event handler to the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ /*\
     * Element.untouchcancel
     [ method ]
     **
     * Removes a touchcancel event handler from the element
     - handler (function) handler for the event
     = (object) @Element
    \*/ for(var i = events.length; i--;)(function(eventName) {
        Snap[eventName] = elproto[eventName] = function(fn, scope) {
            if (Snap.is(fn, "function")) {
                this.events = this.events || [];
                this.events.push({
                    name: eventName,
                    f: fn,
                    unbind: addEvent(this.node || document, eventName, fn, scope || this)
                });
            } else {
                for(var i = 0, ii = this.events.length; i < ii; i++)if (this.events[i].name == eventName) try {
                    this.events[i].f.call(this);
                } catch (e) {}
            }
            return this;
        };
        Snap["un" + eventName] = elproto["un" + eventName] = function(fn) {
            var events = this.events || [], l = events.length;
            while(l--)if (events[l].name == eventName && (events[l].f == fn || !fn)) {
                events[l].unbind();
                events.splice(l, 1);
                !events.length && delete this.events;
                return this;
            }
            return this;
        };
    })(events[i]);
    /*\
     * Element.hover
     [ method ]
     **
     * Adds hover event handlers to the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     - icontext (object) #optional context for hover in handler
     - ocontext (object) #optional context for hover out handler
     = (object) @Element
    \*/ elproto.hover = function(f_in, f_out, scope_in, scope_out) {
        return this.mouseover(f_in, scope_in).mouseout(f_out, scope_out || scope_in);
    };
    /*\
     * Element.unhover
     [ method ]
     **
     * Removes hover event handlers from the element
     - f_in (function) handler for hover in
     - f_out (function) handler for hover out
     = (object) @Element
    \*/ elproto.unhover = function(f_in, f_out) {
        return this.unmouseover(f_in).unmouseout(f_out);
    };
    var draggable = [];
    // SIERRA unclear what _context_ refers to for starting, ending, moving the drag gesture.
    // SIERRA Element.drag(): _x position of the mouse_: Where are the x/y values offset from?
    // SIERRA Element.drag(): much of this member's doc appears to be duplicated for some reason.
    // SIERRA Unclear about this sentence: _Additionally following drag events will be triggered: drag.start.<id> on start, drag.end.<id> on end and drag.move.<id> on every move._ Is there a global _drag_ object to which you can assign handlers keyed by an element's ID?
    /*\
     * Element.drag
     [ method ]
     **
     * Adds event handlers for an element's drag gesture
     **
     - onmove (function) handler for moving
     - onstart (function) handler for drag start
     - onend (function) handler for drag end
     - mcontext (object) #optional context for moving handler
     - scontext (object) #optional context for drag start handler
     - econtext (object) #optional context for drag end handler
     * Additionaly following `drag` events are triggered: `drag.start.<id>` on start, 
     * `drag.end.<id>` on end and `drag.move.<id>` on every move. When element is dragged over another element 
     * `drag.over.<id>` fires as well.
     *
     * Start event and start handler are called in specified context or in context of the element with following parameters:
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * Move event and move handler are called in specified context or in context of the element with following parameters:
     o dx (number) shift by x from the start point
     o dy (number) shift by y from the start point
     o x (number) x position of the mouse
     o y (number) y position of the mouse
     o event (object) DOM event object
     * End event and end handler are called in specified context or in context of the element with following parameters:
     o event (object) DOM event object
     = (object) @Element
    \*/ elproto.drag = function(onmove, onstart, onend, move_scope, start_scope, end_scope) {
        var el = this;
        if (!arguments.length) {
            var origTransform;
            return el.drag(function(dx, dy) {
                this.attr({
                    transform: origTransform + (origTransform ? "T" : "t") + [
                        dx,
                        dy
                    ]
                });
            }, function() {
                origTransform = this.transform().local;
            });
        }
        function start(e, x, y) {
            (e.originalEvent || e).preventDefault();
            el._drag.x = x;
            el._drag.y = y;
            el._drag.id = e.identifier;
            !drag.length && Snap.mousemove(dragMove).mouseup(dragUp);
            drag.push({
                el: el,
                move_scope: move_scope,
                start_scope: start_scope,
                end_scope: end_scope
            });
            onstart && eve.on("snap.drag.start." + el.id, onstart);
            onmove && eve.on("snap.drag.move." + el.id, onmove);
            onend && eve.on("snap.drag.end." + el.id, onend);
            eve("snap.drag.start." + el.id, start_scope || move_scope || el, x, y, e);
        }
        function init(e, x, y) {
            eve("snap.draginit." + el.id, el, e, x, y);
        }
        eve.on("snap.draginit." + el.id, start);
        el._drag = {};
        draggable.push({
            el: el,
            start: start,
            init: init
        });
        el.mousedown(init);
        return el;
    };
    /*
     * Element.onDragOver
     [ method ]
     **
     * Shortcut to assign event handler for `drag.over.<id>` event, where `id` is the element's `id` (see @Element.id)
     - f (function) handler for event, first argument would be the element you are dragging over
    \*/ // elproto.onDragOver = function (f) {
    //     f ? eve.on("snap.drag.over." + this.id, f) : eve.unbind("snap.drag.over." + this.id);
    // };
    /*\
     * Element.undrag
     [ method ]
     **
     * Removes all drag event handlers from the given element
    \*/ elproto.undrag = function() {
        var i = draggable.length;
        while(i--)if (draggable[i].el == this) {
            this.unmousedown(draggable[i].init);
            draggable.splice(i, 1);
            eve.unbind("snap.drag.*." + this.id);
            eve.unbind("snap.draginit." + this.id);
        }
        !draggable.length && Snap.unmousemove(dragMove).unmouseup(dragUp);
        return this;
    };
});
// Copyright (c) 2013 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    var elproto = Element.prototype, pproto = Paper.prototype, rgurl = /^\s*url\((.+)\)/, Str = String, $ = Snap._.$;
    Snap.filter = {};
    /*\
     * Paper.filter
     [ method ]
     **
     * Creates a `<filter>` element
     **
     - filstr (string) SVG fragment of filter provided as a string
     = (object) @Element
     * Note: It is recommended to use filters embedded into the page inside an empty SVG element.
     > Usage
     | var f = paper.filter('<feGaussianBlur stdDeviation="2"/>'),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/ pproto.filter = function(filstr) {
        var paper = this;
        if (paper.type != "svg") paper = paper.paper;
        var f = Snap.parse(Str(filstr)), id = Snap._.id(), width = paper.node.offsetWidth, height = paper.node.offsetHeight, filter = $("filter");
        $(filter, {
            id: id,
            filterUnits: "userSpaceOnUse"
        });
        filter.appendChild(f.node);
        paper.defs.appendChild(filter);
        return new Element(filter);
    };
    eve.on("snap.util.getattr.filter", function() {
        eve.stop();
        var p = $(this.node, "filter");
        if (p) {
            var match = Str(p).match(rgurl);
            return match && Snap.select(match[1]);
        }
    });
    eve.on("snap.util.attr.filter", function(value) {
        if (value instanceof Element && value.type == "filter") {
            eve.stop();
            var id = value.node.id;
            if (!id) {
                $(value.node, {
                    id: value.id
                });
                id = value.id;
            }
            $(this.node, {
                filter: Snap.url(id)
            });
        }
        if (!value || value == "none") {
            eve.stop();
            this.node.removeAttribute("filter");
        }
    });
    /*\
     * Snap.filter.blur
     [ method ]
     **
     * Returns an SVG markup string for the blur filter
     **
     - x (number) amount of horizontal blur, in pixels
     - y (number) #optional amount of vertical blur, in pixels
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.blur(5, 10)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/ Snap.filter.blur = function(x, y) {
        if (x == null) x = 2;
        var def = y == null ? x : [
            x,
            y
        ];
        return Snap.format('\<feGaussianBlur stdDeviation="{def}"/>', {
            def: def
        });
    };
    Snap.filter.blur.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.shadow
     [ method ]
     **
     * Returns an SVG markup string for the shadow filter
     **
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - blur (number) #optional amount of blur
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - color (string) #optional color of the shadow
     - opacity (number) #optional `0..1` opacity of the shadow
     * which makes blur default to `4`. Or
     - dx (number) #optional horizontal shift of the shadow, in pixels
     - dy (number) #optional vertical shift of the shadow, in pixels
     - opacity (number) #optional `0..1` opacity of the shadow
     = (string) filter representation
     > Usage
     | var f = paper.filter(Snap.filter.shadow(0, 2, .3)),
     |     c = paper.circle(10, 10, 10).attr({
     |         filter: f
     |     });
    \*/ Snap.filter.shadow = function(dx, dy, blur, color, opacity) {
        if (opacity == null) {
            if (color == null) {
                opacity = blur;
                blur = 4;
                color = "#000";
            } else {
                opacity = color;
                color = blur;
                blur = 4;
            }
        }
        if (blur == null) blur = 4;
        if (opacity == null) opacity = 1;
        if (dx == null) {
            dx = 0;
            dy = 2;
        }
        if (dy == null) dy = dx;
        color = Snap.color(color);
        return Snap.format('<feGaussianBlur in="SourceAlpha" stdDeviation="{blur}"/><feOffset dx="{dx}" dy="{dy}" result="offsetblur"/><feFlood flood-color="{color}"/><feComposite in2="offsetblur" operator="in"/><feComponentTransfer><feFuncA type="linear" slope="{opacity}"/></feComponentTransfer><feMerge><feMergeNode/><feMergeNode in="SourceGraphic"/></feMerge>', {
            color: color,
            dx: dx,
            dy: dy,
            blur: blur,
            opacity: opacity
        });
    };
    Snap.filter.shadow.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.grayscale
     [ method ]
     **
     * Returns an SVG markup string for the grayscale filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.grayscale = function(amount) {
        if (amount == null) amount = 1;
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {b} {h} 0 0 0 0 0 1 0"/>', {
            a: 0.2126 + 0.7874 * (1 - amount),
            b: 0.7152 - 0.7152 * (1 - amount),
            c: 0.0722 - 0.0722 * (1 - amount),
            d: 0.2126 - 0.2126 * (1 - amount),
            e: 0.7152 + 0.2848 * (1 - amount),
            f: 0.0722 - 0.0722 * (1 - amount),
            g: 0.2126 - 0.2126 * (1 - amount),
            h: 0.0722 + 0.9278 * (1 - amount)
        });
    };
    Snap.filter.grayscale.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.sepia
     [ method ]
     **
     * Returns an SVG markup string for the sepia filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.sepia = function(amount) {
        if (amount == null) amount = 1;
        return Snap.format('<feColorMatrix type="matrix" values="{a} {b} {c} 0 0 {d} {e} {f} 0 0 {g} {h} {i} 0 0 0 0 0 1 0"/>', {
            a: 0.393 + 0.607 * (1 - amount),
            b: 0.769 - 0.769 * (1 - amount),
            c: 0.189 - 0.189 * (1 - amount),
            d: 0.349 - 0.349 * (1 - amount),
            e: 0.686 + 0.314 * (1 - amount),
            f: 0.168 - 0.168 * (1 - amount),
            g: 0.272 - 0.272 * (1 - amount),
            h: 0.534 - 0.534 * (1 - amount),
            i: 0.131 + 0.869 * (1 - amount)
        });
    };
    Snap.filter.sepia.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.saturate
     [ method ]
     **
     * Returns an SVG markup string for the saturate filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.saturate = function(amount) {
        if (amount == null) amount = 1;
        return Snap.format('<feColorMatrix type="saturate" values="{amount}"/>', {
            amount: 1 - amount
        });
    };
    Snap.filter.saturate.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.hueRotate
     [ method ]
     **
     * Returns an SVG markup string for the hue-rotate filter
     **
     - angle (number) angle of rotation
     = (string) filter representation
    \*/ Snap.filter.hueRotate = function(angle) {
        angle = angle || 0;
        return Snap.format('<feColorMatrix type="hueRotate" values="{angle}"/>', {
            angle: angle
        });
    };
    Snap.filter.hueRotate.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.invert
     [ method ]
     **
     * Returns an SVG markup string for the invert filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.invert = function(amount) {
        if (amount == null) amount = 1;
        //        <feColorMatrix type="matrix" values="-1 0 0 0 1  0 -1 0 0 1  0 0 -1 0 1  0 0 0 1 0" color-interpolation-filters="sRGB"/>
        return Snap.format('<feComponentTransfer><feFuncR type="table" tableValues="{amount} {amount2}"/><feFuncG type="table" tableValues="{amount} {amount2}"/><feFuncB type="table" tableValues="{amount} {amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: 1 - amount
        });
    };
    Snap.filter.invert.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.brightness
     [ method ]
     **
     * Returns an SVG markup string for the brightness filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.brightness = function(amount) {
        if (amount == null) amount = 1;
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}"/><feFuncG type="linear" slope="{amount}"/><feFuncB type="linear" slope="{amount}"/></feComponentTransfer>', {
            amount: amount
        });
    };
    Snap.filter.brightness.toString = function() {
        return this();
    };
    /*\
     * Snap.filter.contrast
     [ method ]
     **
     * Returns an SVG markup string for the contrast filter
     **
     - amount (number) amount of filter (`0..1`)
     = (string) filter representation
    \*/ Snap.filter.contrast = function(amount) {
        if (amount == null) amount = 1;
        return Snap.format('<feComponentTransfer><feFuncR type="linear" slope="{amount}" intercept="{amount2}"/><feFuncG type="linear" slope="{amount}" intercept="{amount2}"/><feFuncB type="linear" slope="{amount}" intercept="{amount2}"/></feComponentTransfer>', {
            amount: amount,
            amount2: .5 - amount / 2
        });
    };
    Snap.filter.contrast.toString = function() {
        return this();
    };
});
// Copyright (c) 2014 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var box = Snap._.box, is = Snap.is, firstLetter = /^[^a-z]*([tbmlrc])/i, toString = function() {
        return "T" + this.dx + "," + this.dy;
    };
    /*\
     * Element.getAlign
     [ method ]
     **
     * Returns shift needed to align the element relatively to given element.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object|string) Object in format `{dx: , dy: }` also has a string representation as a transformation string
     > Usage
     | el.transform(el.getAlign(el2, "top"));
     * or
     | var dy = el.getAlign(el2, "top").dy;
    \*/ Element.prototype.getAlign = function(el, way) {
        if (way == null && is(el, "string")) {
            way = el;
            el = null;
        }
        el = el || this.paper;
        var bx = el.getBBox ? el.getBBox() : box(el), bb = this.getBBox(), out = {};
        way = way && way.match(firstLetter);
        way = way ? way[1].toLowerCase() : "c";
        switch(way){
            case "t":
                out.dx = 0;
                out.dy = bx.y - bb.y;
                break;
            case "b":
                out.dx = 0;
                out.dy = bx.y2 - bb.y2;
                break;
            case "m":
                out.dx = 0;
                out.dy = bx.cy - bb.cy;
                break;
            case "l":
                out.dx = bx.x - bb.x;
                out.dy = 0;
                break;
            case "r":
                out.dx = bx.x2 - bb.x2;
                out.dy = 0;
                break;
            default:
                out.dx = bx.cx - bb.cx;
                out.dy = 0;
                break;
        }
        out.toString = toString;
        return out;
    };
    /*\
     * Element.align
     [ method ]
     **
     * Aligns the element relatively to given one via transformation.
     * If no elements specified, parent `<svg>` container will be used.
     - el (object) @optional alignment element
     - way (string) one of six values: `"top"`, `"middle"`, `"bottom"`, `"left"`, `"center"`, `"right"`
     = (object) this element
     > Usage
     | el.align(el2, "top");
     * or
     | el.align("middle");
    \*/ Element.prototype.align = function(el, way) {
        return this.transform("..." + this.getAlign(el, way));
    };
});
// Copyright (c) 2016 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob, Fragment) {
    var elproto = Element.prototype, is = Snap.is, Str = String, has = "hasOwnProperty";
    function slice(from, to, f) {
        return function(arr) {
            var res1 = arr.slice(from, to);
            if (res1.length == 1) res1 = res1[0];
            return f ? f(res1) : res1;
        };
    }
    var Animation = function(attr, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = $f098236b7e761f68$var$mina.linear;
        }
        this.attr = attr;
        this.dur = ms;
        easing && (this.easing = easing);
        callback && (this.callback = callback);
    };
    Snap._.Animation = Animation;
    /*\
     * Snap.animation
     [ method ]
     **
     * Creates an animation object
     **
     - attr (object) attributes of final destination
     - duration (number) duration of the animation, in milliseconds
     - easing (function) #optional one of easing functions of @mina or custom one
     - callback (function) #optional callback function that fires when animation ends
     = (object) animation object
    \*/ Snap.animation = function(attr, ms, easing, callback) {
        return new Animation(attr, ms, easing, callback);
    };
    /*\
     * Element.inAnim
     [ method ]
     **
     * Returns a set of animations that may be able to manipulate the current element
     **
     = (object) in format:
     o {
     o     anim (object) animation object,
     o     mina (object) @mina object,
     o     curStatus (number) 0..1 — status of the animation: 0 — just started, 1 — just finished,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
    \*/ elproto.inAnim = function() {
        var el = this, res1 = [];
        for(var id in el.anims)if (el.anims[has](id)) (function(a) {
            res1.push({
                anim: new Animation(a._attrs, a.dur, a.easing, a._callback),
                mina: a,
                curStatus: a.status(),
                status: function(val) {
                    return a.status(val);
                },
                stop: function() {
                    a.stop();
                }
            });
        })(el.anims[id]);
        return res1;
    };
    /*\
     * Snap.animate
     [ method ]
     **
     * Runs generic animation of one number into another with a caring function
     **
     - from (number|array) number or array of numbers
     - to (number|array) number or array of numbers
     - setter (function) caring function that accepts one number argument
     - duration (number) duration, in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function to execute when animation ends
     = (object) animation object in @mina format
     o {
     o     id (string) animation id, consider it read-only,
     o     duration (function) gets or sets the duration of the animation,
     o     easing (function) easing,
     o     speed (function) gets or sets the speed of the animation,
     o     status (function) gets or sets the status of the animation,
     o     stop (function) stops the animation
     o }
     | var rect = Snap().rect(0, 0, 10, 10);
     | Snap.animate(0, 10, function (val) {
     |     rect.attr({
     |         x: val
     |     });
     | }, 1000);
     | // in given context is equivalent to
     | rect.animate({x: 10}, 1000);
    \*/ Snap.animate = function(from, to, setter, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = $f098236b7e761f68$var$mina.linear;
        }
        var now = $f098236b7e761f68$var$mina.time(), anim = $f098236b7e761f68$var$mina(from, to, now, now + ms, $f098236b7e761f68$var$mina.time, setter, easing);
        callback && eve.once("mina.finish." + anim.id, callback);
        return anim;
    };
    /*\
     * Element.stop
     [ method ]
     **
     * Stops all the animations for the current element
     **
     = (Element) the current element
    \*/ elproto.stop = function() {
        var anims = this.inAnim();
        for(var i = 0, ii = anims.length; i < ii; i++)anims[i].stop();
        return this;
    };
    /*\
     * Element.animate
     [ method ]
     **
     * Animates the given attributes of the element
     **
     - attrs (object) key-value pairs of destination attributes
     - duration (number) duration of the animation in milliseconds
     - easing (function) #optional easing function from @mina or custom
     - callback (function) #optional callback function that executes when the animation ends
     = (Element) the current element
    \*/ elproto.animate = function(attrs, ms, easing, callback) {
        if (typeof easing == "function" && !easing.length) {
            callback = easing;
            easing = $f098236b7e761f68$var$mina.linear;
        }
        if (attrs instanceof Animation) {
            callback = attrs.callback;
            easing = attrs.easing;
            ms = attrs.dur;
            attrs = attrs.attr;
        }
        var fkeys = [], tkeys = [], keys = {}, from, to, f, eq, el = this;
        for(var key in attrs)if (attrs[has](key)) {
            if (el.equal) {
                eq = el.equal(key, Str(attrs[key]));
                from = eq.from;
                to = eq.to;
                f = eq.f;
            } else {
                from = +el.attr(key);
                to = +attrs[key];
            }
            var len = is(from, "array") ? from.length : 1;
            keys[key] = slice(fkeys.length, fkeys.length + len, f);
            fkeys = fkeys.concat(from);
            tkeys = tkeys.concat(to);
        }
        var now = $f098236b7e761f68$var$mina.time(), anim = $f098236b7e761f68$var$mina(fkeys, tkeys, now, now + ms, $f098236b7e761f68$var$mina.time, function(val) {
            var attr = {};
            for(var key in keys)if (keys[has](key)) attr[key] = keys[key](val);
            el.attr(attr);
        }, easing);
        el.anims[anim.id] = anim;
        anim._attrs = attrs;
        anim._callback = callback;
        eve("snap.animcreated." + el.id, anim);
        eve.once("mina.finish." + anim.id, function() {
            eve.off("mina.*." + anim.id);
            delete el.anims[anim.id];
            callback && callback.call(el);
        });
        eve.once("mina.stop." + anim.id, function() {
            eve.off("mina.*." + anim.id);
            delete el.anims[anim.id];
        });
        return el;
    };
});
// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
$f098236b7e761f68$var$Snap.plugin(function(Snap, Element, Paper, glob) {
    // Colours are from https://www.materialui.co
    var red = "#ffebee#ffcdd2#ef9a9a#e57373#ef5350#f44336#e53935#d32f2f#c62828#b71c1c#ff8a80#ff5252#ff1744#d50000", pink = "#FCE4EC#F8BBD0#F48FB1#F06292#EC407A#E91E63#D81B60#C2185B#AD1457#880E4F#FF80AB#FF4081#F50057#C51162", purple = "#F3E5F5#E1BEE7#CE93D8#BA68C8#AB47BC#9C27B0#8E24AA#7B1FA2#6A1B9A#4A148C#EA80FC#E040FB#D500F9#AA00FF", deeppurple = "#EDE7F6#D1C4E9#B39DDB#9575CD#7E57C2#673AB7#5E35B1#512DA8#4527A0#311B92#B388FF#7C4DFF#651FFF#6200EA", indigo = "#E8EAF6#C5CAE9#9FA8DA#7986CB#5C6BC0#3F51B5#3949AB#303F9F#283593#1A237E#8C9EFF#536DFE#3D5AFE#304FFE", blue = "#E3F2FD#BBDEFB#90CAF9#64B5F6#64B5F6#2196F3#1E88E5#1976D2#1565C0#0D47A1#82B1FF#448AFF#2979FF#2962FF", lightblue = "#E1F5FE#B3E5FC#81D4FA#4FC3F7#29B6F6#03A9F4#039BE5#0288D1#0277BD#01579B#80D8FF#40C4FF#00B0FF#0091EA", cyan = "#E0F7FA#B2EBF2#80DEEA#4DD0E1#26C6DA#00BCD4#00ACC1#0097A7#00838F#006064#84FFFF#18FFFF#00E5FF#00B8D4", teal = "#E0F2F1#B2DFDB#80CBC4#4DB6AC#26A69A#009688#00897B#00796B#00695C#004D40#A7FFEB#64FFDA#1DE9B6#00BFA5", green = "#E8F5E9#C8E6C9#A5D6A7#81C784#66BB6A#4CAF50#43A047#388E3C#2E7D32#1B5E20#B9F6CA#69F0AE#00E676#00C853", lightgreen = "#F1F8E9#DCEDC8#C5E1A5#AED581#9CCC65#8BC34A#7CB342#689F38#558B2F#33691E#CCFF90#B2FF59#76FF03#64DD17", lime = "#F9FBE7#F0F4C3#E6EE9C#DCE775#D4E157#CDDC39#C0CA33#AFB42B#9E9D24#827717#F4FF81#EEFF41#C6FF00#AEEA00", yellow = "#FFFDE7#FFF9C4#FFF59D#FFF176#FFEE58#FFEB3B#FDD835#FBC02D#F9A825#F57F17#FFFF8D#FFFF00#FFEA00#FFD600", amber = "#FFF8E1#FFECB3#FFE082#FFD54F#FFCA28#FFC107#FFB300#FFA000#FF8F00#FF6F00#FFE57F#FFD740#FFC400#FFAB00", orange = "#FFF3E0#FFE0B2#FFCC80#FFB74D#FFA726#FF9800#FB8C00#F57C00#EF6C00#E65100#FFD180#FFAB40#FF9100#FF6D00", deeporange = "#FBE9E7#FFCCBC#FFAB91#FF8A65#FF7043#FF5722#F4511E#E64A19#D84315#BF360C#FF9E80#FF6E40#FF3D00#DD2C00", brown = "#EFEBE9#D7CCC8#BCAAA4#A1887F#8D6E63#795548#6D4C41#5D4037#4E342E#3E2723", grey = "#FAFAFA#F5F5F5#EEEEEE#E0E0E0#BDBDBD#9E9E9E#757575#616161#424242#212121", bluegrey = "#ECEFF1#CFD8DC#B0BEC5#90A4AE#78909C#607D8B#546E7A#455A64#37474F#263238";
    /*\
     * Snap.mui
     [ property ]
     **
     * Contain Material UI colours.
     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.mui.deeppurple, stroke: Snap.mui.amber[600]});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/ Snap.mui = {};
    /*\
     * Snap.flat
     [ property ]
     **
     * Contain Flat UI colours.
     | Snap().rect(0, 0, 10, 10).attr({fill: Snap.flat.carrot, stroke: Snap.flat.wetasphalt});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/ Snap.flat = {};
    function saveColor(colors) {
        colors = colors.split(/(?=#)/);
        var color = new String(colors[5]);
        color[50] = colors[0];
        color[100] = colors[1];
        color[200] = colors[2];
        color[300] = colors[3];
        color[400] = colors[4];
        color[500] = colors[5];
        color[600] = colors[6];
        color[700] = colors[7];
        color[800] = colors[8];
        color[900] = colors[9];
        if (colors[10]) {
            color.A100 = colors[10];
            color.A200 = colors[11];
            color.A400 = colors[12];
            color.A700 = colors[13];
        }
        return color;
    }
    Snap.mui.red = saveColor(red);
    Snap.mui.pink = saveColor(pink);
    Snap.mui.purple = saveColor(purple);
    Snap.mui.deeppurple = saveColor(deeppurple);
    Snap.mui.indigo = saveColor(indigo);
    Snap.mui.blue = saveColor(blue);
    Snap.mui.lightblue = saveColor(lightblue);
    Snap.mui.cyan = saveColor(cyan);
    Snap.mui.teal = saveColor(teal);
    Snap.mui.green = saveColor(green);
    Snap.mui.lightgreen = saveColor(lightgreen);
    Snap.mui.lime = saveColor(lime);
    Snap.mui.yellow = saveColor(yellow);
    Snap.mui.amber = saveColor(amber);
    Snap.mui.orange = saveColor(orange);
    Snap.mui.deeporange = saveColor(deeporange);
    Snap.mui.brown = saveColor(brown);
    Snap.mui.grey = saveColor(grey);
    Snap.mui.bluegrey = saveColor(bluegrey);
    Snap.flat.turquoise = "#1abc9c";
    Snap.flat.greensea = "#16a085";
    Snap.flat.sunflower = "#f1c40f";
    Snap.flat.orange = "#f39c12";
    Snap.flat.emerland = "#2ecc71";
    Snap.flat.nephritis = "#27ae60";
    Snap.flat.carrot = "#e67e22";
    Snap.flat.pumpkin = "#d35400";
    Snap.flat.peterriver = "#3498db";
    Snap.flat.belizehole = "#2980b9";
    Snap.flat.alizarin = "#e74c3c";
    Snap.flat.pomegranate = "#c0392b";
    Snap.flat.amethyst = "#9b59b6";
    Snap.flat.wisteria = "#8e44ad";
    Snap.flat.clouds = "#ecf0f1";
    Snap.flat.silver = "#bdc3c7";
    Snap.flat.wetasphalt = "#34495e";
    Snap.flat.midnightblue = "#2c3e50";
    Snap.flat.concrete = "#95a5a6";
    Snap.flat.asbestos = "#7f8c8d";
    /*\
     * Snap.importMUIColors
     [ method ]
     **
     * Imports Material UI colours into global object.
     | Snap.importMUIColors();
     | Snap().rect(0, 0, 10, 10).attr({fill: deeppurple, stroke: amber[600]});
     # For colour reference: <a href="https://www.materialui.co">https://www.materialui.co</a>.
    \*/ Snap.importMUIColors = function() {
        for(var color in Snap.mui)if (Snap.mui.hasOwnProperty(color)) window[color] = Snap.mui[color];
    };
});
module.exports = $f098236b7e761f68$var$Snap;

});
parcelRegister("fXTr3", function(module, exports) {
// Copyright (c) 2017 Adobe Systems Incorporated. All rights reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
// ┌────────────────────────────────────────────────────────────┐ \\
// │ Eve 0.5.4 - JavaScript Events Library                      │ \\
// ├────────────────────────────────────────────────────────────┤ \\
// │ Author Dmitry Baranovskiy (http://dmitry.baranovskiy.com/) │ \\
// └────────────────────────────────────────────────────────────┘ \\
(function(glob) {
    var version = "0.5.4", has = "hasOwnProperty", separator = /[\.\/]/, comaseparator = /\s*,\s*/, wildcard = "*", numsort = function(a, b) {
        return a - b;
    }, current_event, stop, events = {
        n: {}
    }, firstDefined = function() {
        for(var i = 0, ii = this.length; i < ii; i++){
            if (typeof this[i] != "undefined") return this[i];
        }
    }, lastDefined = function() {
        var i = this.length;
        while(--i){
            if (typeof this[i] != "undefined") return this[i];
        }
    }, objtos = Object.prototype.toString, Str = String, isArray = Array.isArray || function(ar) {
        return ar instanceof Array || objtos.call(ar) == "[object Array]";
    }, /*\
     * eve
     [ method ]

     * Fires event with given `name`, given scope and other parameters.

     - name (string) name of the *event*, dot (`.`) or slash (`/`) separated
     - scope (object) context for the event handlers
     - varargs (...) the rest of arguments will be sent to event handlers

     = (object) array of returned values from the listeners. Array has two methods `.firstDefined()` and `.lastDefined()` to get first or last not `undefined` value.
    \*/ eve = function(name, scope) {
        var oldstop = stop, args = Array.prototype.slice.call(arguments, 2), listeners = eve.listeners(name), z = 0, l, indexed = [], queue = {}, out = [], ce = current_event;
        out.firstDefined = firstDefined;
        out.lastDefined = lastDefined;
        current_event = name;
        stop = 0;
        for(var i = 0, ii = listeners.length; i < ii; i++)if ("zIndex" in listeners[i]) {
            indexed.push(listeners[i].zIndex);
            if (listeners[i].zIndex < 0) queue[listeners[i].zIndex] = listeners[i];
        }
        indexed.sort(numsort);
        while(indexed[z] < 0){
            l = queue[indexed[z++]];
            out.push(l.apply(scope, args));
            if (stop) {
                stop = oldstop;
                return out;
            }
        }
        for(i = 0; i < ii; i++){
            l = listeners[i];
            if ("zIndex" in l) {
                if (l.zIndex == indexed[z]) {
                    out.push(l.apply(scope, args));
                    if (stop) break;
                    do {
                        z++;
                        l = queue[indexed[z]];
                        l && out.push(l.apply(scope, args));
                        if (stop) break;
                    }while (l);
                } else queue[l.zIndex] = l;
            } else {
                out.push(l.apply(scope, args));
                if (stop) break;
            }
        }
        stop = oldstop;
        current_event = ce;
        return out;
    };
    // Undocumented. Debug only.
    eve._events = events;
    /*\
     * eve.listeners
     [ method ]

     * Internal method which gives you array of all event handlers that will be triggered by the given `name`.

     - name (string) name of the event, dot (`.`) or slash (`/`) separated

     = (array) array of event handlers
    \*/ eve.listeners = function(name) {
        var names = isArray(name) ? name : name.split(separator), e = events, item, items, k, i, ii, j, jj, nes, es = [
            e
        ], out = [];
        for(i = 0, ii = names.length; i < ii; i++){
            nes = [];
            for(j = 0, jj = es.length; j < jj; j++){
                e = es[j].n;
                items = [
                    e[names[i]],
                    e[wildcard]
                ];
                k = 2;
                while(k--){
                    item = items[k];
                    if (item) {
                        nes.push(item);
                        out = out.concat(item.f || []);
                    }
                }
            }
            es = nes;
        }
        return out;
    };
    /*\
     * eve.separator
     [ method ]

     * If for some reasons you don’t like default separators (`.` or `/`) you can specify yours
     * here. Be aware that if you pass a string longer than one character it will be treated as
     * a list of characters.

     - separator (string) new separator. Empty string resets to default: `.` or `/`.
    \*/ eve.separator = function(sep) {
        if (sep) {
            sep = Str(sep).replace(/(?=[\.\^\]\[\-])/g, "\\");
            sep = "[" + sep + "]";
            separator = new RegExp(sep);
        } else separator = /[\.\/]/;
    };
    /*\
     * eve.on
     [ method ]
     **
     * Binds given event handler with a given name. You can use wildcards “`*`” for the names:
     | eve.on("*.under.*", f);
     | eve("mouse.under.floor"); // triggers f
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     - name (array) if you don’t want to use separators, you can use array of strings
     - f (function) event handler function
     **
     = (function) returned function accepts a single numeric parameter that represents z-index of the handler. It is an optional feature and only used when you need to ensure that some subset of handlers will be invoked in a given order, despite of the order of assignment.
     > Example:
     | eve.on("mouse", eatIt)(2);
     | eve.on("mouse", scream);
     | eve.on("mouse", catchIt)(1);
     * This will ensure that `catchIt` function will be called before `eatIt`.
     *
     * If you want to put your handler before non-indexed handlers, specify a negative value.
     * Note: I assume most of the time you don’t need to worry about z-index, but it’s nice to have this feature “just in case”.
    \*/ eve.on = function(name, f) {
        if (typeof f != "function") return function() {};
        var names = isArray(name) ? isArray(name[0]) ? name : [
            name
        ] : Str(name).split(comaseparator);
        for(var i = 0, ii = names.length; i < ii; i++)(function(name) {
            var names = isArray(name) ? name : Str(name).split(separator), e = events, exist;
            for(var i = 0, ii = names.length; i < ii; i++){
                e = e.n;
                e = e.hasOwnProperty(names[i]) && e[names[i]] || (e[names[i]] = {
                    n: {}
                });
            }
            e.f = e.f || [];
            for(i = 0, ii = e.f.length; i < ii; i++)if (e.f[i] == f) {
                exist = true;
                break;
            }
            !exist && e.f.push(f);
        })(names[i]);
        return function(zIndex) {
            if (+zIndex == +zIndex) f.zIndex = +zIndex;
        };
    };
    /*\
     * eve.f
     [ method ]
     **
     * Returns function that will fire given event with optional arguments.
     * Arguments that will be passed to the result function will be also
     * concated to the list of final arguments.
     | el.onclick = eve.f("click", 1, 2);
     | eve.on("click", function (a, b, c) {
     |     console.log(a, b, c); // 1, 2, [event object]
     | });
     - event (string) event name
     - varargs (…) and any other arguments
     = (function) possible event handler function
    \*/ eve.f = function(event) {
        var attrs = [].slice.call(arguments, 1);
        return function() {
            eve.apply(null, [
                event,
                null
            ].concat(attrs).concat([].slice.call(arguments, 0)));
        };
    };
    /*\
     * eve.stop
     [ method ]
     **
     * Is used inside an event handler to stop the event, preventing any subsequent listeners from firing.
    \*/ eve.stop = function() {
        stop = 1;
    };
    /*\
     * eve.nt
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     - subname (string) #optional subname of the event
     **
     = (string) name of the event, if `subname` is not specified
     * or
     = (boolean) `true`, if current event’s name contains `subname`
    \*/ eve.nt = function(subname) {
        var cur = isArray(current_event) ? current_event.join(".") : current_event;
        if (subname) return new RegExp("(?:\\.|\\/|^)" + subname + "(?:\\.|\\/|$)").test(cur);
        return cur;
    };
    /*\
     * eve.nts
     [ method ]
     **
     * Could be used inside event handler to figure out actual name of the event.
     **
     **
     = (array) names of the event
    \*/ eve.nts = function() {
        return isArray(current_event) ? current_event : current_event.split(separator);
    };
    /*\
     * eve.off
     [ method ]
     **
     * Removes given function from the list of event listeners assigned to given name.
     * If no arguments specified all the events will be cleared.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
    \*/ /*\
     * eve.unbind
     [ method ]
     **
     * See @eve.off
    \*/ eve.off = eve.unbind = function(name, f) {
        if (!name) {
            eve._events = events = {
                n: {}
            };
            return;
        }
        var names = isArray(name) ? isArray(name[0]) ? name : [
            name
        ] : Str(name).split(comaseparator);
        if (names.length > 1) {
            for(var i = 0, ii = names.length; i < ii; i++)eve.off(names[i], f);
            return;
        }
        names = isArray(name) ? name : Str(name).split(separator);
        var e, key, splice, i, ii, j, jj, cur = [
            events
        ], inodes = [];
        for(i = 0, ii = names.length; i < ii; i++)for(j = 0; j < cur.length; j += splice.length - 2){
            splice = [
                j,
                1
            ];
            e = cur[j].n;
            if (names[i] != wildcard) {
                if (e[names[i]]) {
                    splice.push(e[names[i]]);
                    inodes.unshift({
                        n: e,
                        name: names[i]
                    });
                }
            } else {
                for(key in e)if (e[has](key)) {
                    splice.push(e[key]);
                    inodes.unshift({
                        n: e,
                        name: key
                    });
                }
            }
            cur.splice.apply(cur, splice);
        }
        for(i = 0, ii = cur.length; i < ii; i++){
            e = cur[i];
            while(e.n){
                if (f) {
                    if (e.f) {
                        for(j = 0, jj = e.f.length; j < jj; j++)if (e.f[j] == f) {
                            e.f.splice(j, 1);
                            break;
                        }
                        !e.f.length && delete e.f;
                    }
                    for(key in e.n)if (e.n[has](key) && e.n[key].f) {
                        var funcs = e.n[key].f;
                        for(j = 0, jj = funcs.length; j < jj; j++)if (funcs[j] == f) {
                            funcs.splice(j, 1);
                            break;
                        }
                        !funcs.length && delete e.n[key].f;
                    }
                } else {
                    delete e.f;
                    for(key in e.n)if (e.n[has](key) && e.n[key].f) delete e.n[key].f;
                }
                e = e.n;
            }
        }
        // prune inner nodes in path
        prune: for(i = 0, ii = inodes.length; i < ii; i++){
            e = inodes[i];
            for(key in e.n[e.name].f)continue prune;
            for(key in e.n[e.name].n)continue prune;
            // is empty
            delete e.n[e.name];
        }
    };
    /*\
     * eve.once
     [ method ]
     **
     * Binds given event handler with a given name to only run once then unbind itself.
     | eve.once("login", f);
     | eve("login"); // triggers f
     | eve("login"); // no listeners
     * Use @eve to trigger the listener.
     **
     - name (string) name of the event, dot (`.`) or slash (`/`) separated, with optional wildcards
     - f (function) event handler function
     **
     = (function) same return function as @eve.on
    \*/ eve.once = function(name, f) {
        var f2 = function() {
            eve.off(name, f2);
            return f.apply(this, arguments);
        };
        return eve.on(name, f2);
    };
    /*\
     * eve.version
     [ property (string) ]
     **
     * Current version of the library.
    \*/ eve.version = version;
    eve.toString = function() {
        return "You are running Eve " + version;
    };
    glob.eve = eve;
    module.exports ? module.exports = eve : typeof define === "function" && define.amd ? define("eve", [], function() {
        return eve;
    }) : glob.eve = eve;
})(typeof window != "undefined" ? window : module.exports);

});



parcelRegister("e1he6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a34e857d010d1d35$var$pxToNum = function pxToNum(val) {
    return parseInt(val.slice(0, -2), 10);
};
module.exports.pxToNum = $a34e857d010d1d35$var$pxToNum;

});


parcelRegister("63d8t", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $467d365c461d701b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $c3Chv = parcelRequire("c3Chv");
var $467d365c461d701b$var$_helpersSnapsvgImporter2 = $467d365c461d701b$var$_interopRequireDefault($c3Chv);

var $6muFC = parcelRequire("6muFC");
var $467d365c461d701b$var$_menuFactory2 = $467d365c461d701b$var$_interopRequireDefault($6muFC);

var $e1he6 = parcelRequire("e1he6");
var $467d365c461d701b$var$BUBBLE_WIDTH = 140;
var $467d365c461d701b$var$styles = {
    svg: {
        lib: $467d365c461d701b$var$_helpersSnapsvgImporter2['default'],
        pathInitial: 'M-7.312,0H0c0,0,0,113.839,0,400c0,264.506,0,400,0,400h-7.312V0z',
        pathOpen: 'M-7.312,0H15c0,0,66,113.339,66,399.5C81,664.006,15,800,15,800H-7.312V0z;M-7.312,0H100c0,0,0,113.839,0,400c0,264.506,0,400,0,400H-7.312V0z',
        animate: function animate(path) {
            var pos = 0;
            var steps = this.pathOpen.split(';');
            var stepsTotal = steps.length;
            var mina = window.mina;
            var nextStep = function nextStep() {
                if (pos > stepsTotal - 1) return;
                path.animate({
                    path: steps[pos]
                }, pos === 0 ? 400 : 500, pos === 0 ? mina.easein : mina.elastic, function() {
                    nextStep();
                });
                pos++;
            };
            nextStep();
        }
    },
    morphShape: function morphShape(isOpen, width, right) {
        return {
            position: 'absolute',
            width: '100%',
            height: '100%',
            right: right ? 'inherit' : 0,
            left: right ? 0 : 'inherit',
            MozTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
            MsTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
            OTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
            WebkitTransform: right ? 'rotateY(180deg)' : 'rotateY(0deg)',
            transform: right ? 'rotateY(180deg)' : 'rotateY(0deg)'
        };
    },
    menuWrap: function menuWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(100%, 0, 0)' : 'translate3d(-100%, 0, 0)',
            transition: isOpen ? 'transform 0.4s 0s' : 'transform 0.4s'
        };
    },
    menu: function menu(isOpen, width, right) {
        var finalWidth = (0, $e1he6.pxToNum)(width) - $467d365c461d701b$var$BUBBLE_WIDTH;
        return {
            position: 'fixed',
            MozTransform: isOpen ? '' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transition: isOpen ? 'opacity 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.1s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
            opacity: isOpen ? 1 : 0
        };
    },
    item: function item(isOpen, width, right, nthChild) {
        var finalWidth = (0, $e1he6.pxToNum)(width) - $467d365c461d701b$var$BUBBLE_WIDTH;
        return {
            MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transition: isOpen ? 'opacity 0.3s 0.4s, transform 0.3s 0.4s' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
            opacity: isOpen ? 1 : 0
        };
    },
    closeButton: function closeButton(isOpen, width, right) {
        var finalWidth = (0, $e1he6.pxToNum)(width) - $467d365c461d701b$var$BUBBLE_WIDTH;
        return {
            MozTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            MsTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            OTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            WebkitTransform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transform: isOpen ? 'translate3d(0, 0, 0)' : right ? 'translate3d(' + finalWidth + ', 0, 0)' : 'translate3d(-' + finalWidth + ', 0, 0)',
            transition: isOpen ? 'opacity 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27), transform 0.3s 0.4s cubic-bezier(.17, .67, .1, 1.27)' : 'opacity 0s 0.3s cubic-bezier(.17, .67, .1, 1.27), transform 0s 0.3s cubic-bezier(.17, .67, .1, 1.27)',
            opacity: isOpen ? 1 : 0
        };
    }
};
module.exports['default'] = (0, $467d365c461d701b$var$_menuFactory2['default'])($467d365c461d701b$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("d9Mhz", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $99419183d31f2cf3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $99419183d31f2cf3$var$_menuFactory2 = $99419183d31f2cf3$var$_interopRequireDefault($6muFC);
var $99419183d31f2cf3$var$styles = {
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transition: 'all 0.5s'
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $99419183d31f2cf3$var$_menuFactory2['default'])($99419183d31f2cf3$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("cJH6C", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $945b1fef15f87dd8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $945b1fef15f87dd8$var$_menuFactory2 = $945b1fef15f87dd8$var$_interopRequireDefault($6muFC);
var $945b1fef15f87dd8$var$styles = {
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
            OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
            transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0) rotateY(15deg)' : 'translate3d(' + width + ', 0, 0) rotateY(-15deg)',
            transformOrigin: right ? '100% 50%' : '0% 50%',
            transformStyle: 'preserve-3d',
            transition: 'all 0.5s'
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            perspective: '1500px',
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $945b1fef15f87dd8$var$_menuFactory2['default'])($945b1fef15f87dd8$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("1v5Sr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $117d3ec0376391d4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $117d3ec0376391d4$var$_menuFactory2 = $117d3ec0376391d4$var$_interopRequireDefault($6muFC);
var $117d3ec0376391d4$var$styles = {
    pageWrap: function pageWrap(isOpen, width) {
        return {
            MozTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
            MsTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
            OTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
            WebkitTransform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
            transform: isOpen ? '' : 'translate3d(0, 0, -' + width + ')',
            transformOrigin: '100%',
            transformStyle: 'preserve-3d',
            transition: 'all 0.5s'
        };
    },
    outerContainer: function outerContainer() {
        return {
            perspective: '1500px'
        };
    }
};
module.exports['default'] = (0, $117d3ec0376391d4$var$_menuFactory2['default'])($117d3ec0376391d4$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("i1zqH", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $d1f3cd9079abce5f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $d1f3cd9079abce5f$var$_menuFactory2 = $d1f3cd9079abce5f$var$_interopRequireDefault($6muFC);
var $d1f3cd9079abce5f$var$styles = {
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
            OTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
            transform: isOpen ? '' : right ? 'translate3d(-100px, 0, -600px) rotateY(20deg)' : 'translate3d(100px, 0, -600px) rotateY(-20deg)',
            transformStyle: 'preserve-3d',
            transition: 'all 0.5s',
            overflow: isOpen ? '' : 'hidden'
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            perspective: '1500px',
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $d1f3cd9079abce5f$var$_menuFactory2['default'])($d1f3cd9079abce5f$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("k9vVI", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $eabd6a816097098a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $eabd6a816097098a$var$_menuFactory2 = $eabd6a816097098a$var$_interopRequireDefault($6muFC);
var $eabd6a816097098a$var$styles = {
    menuWrap: function menuWrap(isOpen) {
        return {
            MozTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
            MsTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
            OTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
            WebkitTransform: isOpen ? '' : 'translate3d(0, -100%, 0)',
            transform: isOpen ? '' : 'translate3d(0, -100%, 0)',
            transition: 'all 0.5s ease-in-out'
        };
    },
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transition: 'all 0.5s'
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            perspective: '1500px',
            perspectiveOrigin: '0% 50%',
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $eabd6a816097098a$var$_menuFactory2['default'])($eabd6a816097098a$var$styles);
module.exports = module.exports['default'];

});

parcelRegister("6UWsR", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
function $509552e2c96be21e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $6muFC = parcelRequire("6muFC");
var $509552e2c96be21e$var$_menuFactory2 = $509552e2c96be21e$var$_interopRequireDefault($6muFC);
var $509552e2c96be21e$var$styles = {
    menuWrap: function menuWrap(isOpen, width, right) {
        return {
            MozTransform: 'translate3d(0, 0, 0)',
            MsTransform: 'translate3d(0, 0, 0)',
            OTransform: 'translate3d(0, 0, 0)',
            WebkitTransform: 'translate3d(0, 0, 0)',
            transform: 'translate3d(0, 0, 0)',
            zIndex: isOpen ? 1000 : -1
        };
    },
    overlay: function overlay(isOpen, width, right) {
        return {
            zIndex: 1400,
            MozTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            MsTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            OTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            WebkitTransform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            transform: isOpen ? right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            transition: 'all 0.5s',
            visibility: isOpen ? 'visible' : 'hidden'
        };
    },
    pageWrap: function pageWrap(isOpen, width, right) {
        return {
            MozTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            MsTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            OTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            WebkitTransform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transform: isOpen ? '' : right ? 'translate3d(-' + width + ', 0, 0)' : 'translate3d(' + width + ', 0, 0)',
            transition: 'all 0.5s',
            zIndex: 1200,
            position: 'relative'
        };
    },
    burgerIcon: function burgerIcon(isOpen, width, right) {
        return {
            MozTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            MsTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            OTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            WebkitTransform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            transform: isOpen ? right ? 'translate3d(' + width + ', 0, 0)' : 'translate3d(-' + width + ', 0, 0)' : 'translate3d(0, 0, 0)',
            transition: 'all 0.1s',
            position: 'relative',
            zIndex: 1300
        };
    },
    outerContainer: function outerContainer(isOpen) {
        return {
            overflow: isOpen ? '' : 'hidden'
        };
    }
};
module.exports['default'] = (0, $509552e2c96be21e$var$_menuFactory2['default'])($509552e2c96be21e$var$styles);
module.exports = module.exports['default'];

});

var $c58b4bd715a2993b$exports = {};
$parcel$extendImportMap({
    "kPsoI": "web-vitals.b0f69557.js",
    "4vxZ7": "plus.plain.9ac6e54f.svg",
    "f5wK0": "info.plain.686f6c0c.svg",
    "iq4SA": "chevron.right.plain.6d034a94.svg",
    "7RiSE": "apple-music.99a209d9.png",
    "9gzWm": "spotify.29406c19.png",
    "afN0H": "youtube-music.07eee2c3.jpg",
    "bdSHX": "tidal.6285109a.jpg",
    "5eOiC": "pencil.b8c5706e.svg",
    "jCnJv": "close.e79222ed.svg",
    "kroiJ": "error-icon.3ca358df.svg",
    "bkeVr": "checkmark.45800772.svg",
    "2cdBw": "SongPlaceholder.925266e9.png",
    "kEDyG": "chevron.left.b742c9f8.svg",
    "6pPtb": "options-icon.6e5b49d2.svg",
    "1BhH4": "share.a0dee636.svg",
    "f7jIs": "trash.bb9c5ac1.svg",
    "pzApr": "chevron.left.plain.d4f26cb4.svg",
    "1MmLB": "linkArrow.9cdcce79.svg",
    "g0W8j": "checkmark-circle.c728f695.svg",
    "1Ascd": "plusNoCircle.3d024fdc.svg",
    "khbCc": "newspaper.92d23923.svg",
    "7TP2d": "rocket.0fa28e81.svg",
    "gZZwP": "iphone17_frame_portrait.a7afc0e2.png",
    "1E0fq": "heart.fill.f9f6b055.svg",
    "34dY3": "people-icon.91331cd1.png",
    "LuWrb": "salt-icon.95e97c75.png",
    "hECYG": "person.plus.plain.190e96b6.svg",
    "4my32": "arrow.right.plain.2554b46d.svg",
    "71O5d": "infocircle.df7a29e4.svg",
    "fvXcC": "book.5cd6142f.svg",
    "hRLDk": "NotesPlaceholder.d06ea620.png",
    "96vVz": "churchhub-logo.fac3d1bd.png",
    "hXw2B": "planning-center-white.b0494edd.svg",
    "8nLu6": "planning-center-full-color.7a78942d.svg",
    "aJ728": "smartwaiver-logo.ab86e67f.svg",
    "l9fer": "event-placeholder.70832a6b.png",
    "fYzlm": "registrations-icon.a17a8982.png",
    "abwkZ": "events-icon.0cf12a90.svg",
    "5pgWl": "HeaderLogo.bc96b6f1.png",
    "ltOob": "HeaderLogo-dark.fbbb76a3.png",
    "bBooK": "house.1fc3ab23.svg",
    "es6ZK": "connections.23b99b17.svg",
    "aKLVB": "music.list.4cfa019c.svg",
    "kGQfz": "arrow.right.d98dd07b.svg",
    "ha6AV": "person.a0669ef7.svg",
    "5AGgz": "gear.f193ac05.svg",
    "gmrzU": "people.06ba44bc.svg",
    "7Tmfa": "sidebar.7204249a.svg",
    "ahs3Z": "volunteer-icon.ce1c9201.svg",
    "9YVV8": "waivers-icon.f81ee61a.svg",
    "ktzxf": "smartwaiver-icon.fc1416b1.svg"
});

var $824c049f32d4395d$exports = {};
'use strict';

$824c049f32d4395d$exports = (parcelRequire("2nzLi"));


var $f11ec298ebcca059$exports = {};

$parcel$export($f11ec298ebcca059$exports, "createRoot", function () { return $f11ec298ebcca059$export$882461b6382ed46c; }, function (v) { return $f11ec298ebcca059$export$882461b6382ed46c = v; });
$parcel$export($f11ec298ebcca059$exports, "hydrateRoot", function () { return $f11ec298ebcca059$export$757ceba2d55c277e; }, function (v) { return $f11ec298ebcca059$export$757ceba2d55c277e = v; });
var $f11ec298ebcca059$export$882461b6382ed46c;
var $f11ec298ebcca059$export$757ceba2d55c277e;
'use strict';

var $fw0lo = parcelRequire("fw0lo");
var $f11ec298ebcca059$var$i;
$f11ec298ebcca059$export$882461b6382ed46c = $fw0lo.createRoot;
$f11ec298ebcca059$export$757ceba2d55c277e = $fw0lo.hydrateRoot;



const $5a0342ebaab9f2d7$var$reportWebVitals = (onPerfEntry)=>{
    if (onPerfEntry && onPerfEntry instanceof Function) (parcelRequire("lzq3r")).then(({ getCLS: getCLS, getFID: getFID, getFCP: getFCP, getLCP: getLCP, getTTFB: getTTFB })=>{
        getCLS(onPerfEntry);
        getFID(onPerfEntry);
        getFCP(onPerfEntry);
        getLCP(onPerfEntry);
        getTTFB(onPerfEntry);
    });
};
var $5a0342ebaab9f2d7$export$2e2bcd8739ae039 = $5a0342ebaab9f2d7$var$reportWebVitals;



var $2Bwgd = parcelRequire("2Bwgd");

var $dQMrF = parcelRequire("dQMrF");
function $939dffaddf93a85b$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $f779b8b0ef990dda$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}



var $7fPBF = parcelRequire("7fPBF");


var $6TO5S = parcelRequire("6TO5S");

var $dQMrF = parcelRequire("dQMrF");

var $7fPBF = parcelRequire("7fPBF");
var $f1ee620f0561c02a$exports = {};
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ $f1ee620f0561c02a$exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};


var $3be60b4f29d3a6e3$var$e = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?("[^"]*"|'[^']*')/g;
function $3be60b4f29d3a6e3$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($f1ee620f0561c02a$exports)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("--\x3e");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($3be60b4f29d3a6e3$var$e), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var l = c[1].trim(), o = [
                l,
                ""
            ];
            l.indexOf("=") > -1 && (o = l.split("=")), r.attrs[o[0]] = o[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $3be60b4f29d3a6e3$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $3be60b4f29d3a6e3$var$i = /^\s*$/, $3be60b4f29d3a6e3$var$s = Object.create(null);
function $3be60b4f29d3a6e3$var$a(t, e) {
    switch(e.type){
        case "text":
            return t + e.content;
        case "tag":
            return t += "<" + e.name + (e.attrs ? function(t) {
                var e = [];
                for(var n in t)e.push(n + '="' + t[n] + '"');
                return e.length ? " " + e.join(" ") : "";
            }(e.attrs) : "") + (e.voidElement ? "/>" : ">"), e.voidElement ? t : t + e.children.reduce($3be60b4f29d3a6e3$var$a, "") + "</" + e.name + ">";
        case "comment":
            return t + "\x3c!--" + e.comment + "--\x3e";
    }
}
var $3be60b4f29d3a6e3$var$c = {
    parse: function(t, e) {
        e || (e = {}), e.components || (e.components = $3be60b4f29d3a6e3$var$s);
        var a, c = [], l = [], o = -1, u = !1;
        if (0 !== t.indexOf("<")) {
            var h = t.indexOf("<");
            c.push({
                type: "text",
                content: -1 === h ? t : t.substring(0, h)
            });
        }
        for(var v, f = []; v = $3be60b4f29d3a6e3$var$r.exec(t);)f.push(v);
        return f.forEach(function(t, e) {
            var n = t[0];
            if (n && !n.startsWith("\x3c!--")) {
                for(var r = 0, i = 0, s = -1, a = null, c = 0; c < n.length; c++){
                    var l = n.charAt(c);
                    a ? l === a && (a = null) : '"' === l || "'" === l ? a = l : "<" === l ? 2 == ++r && (s = c) : ">" === l && i++;
                }
                var o = s > -1 && /[a-zA-Z0-9\-!/]/.test(n.charAt(s + 1));
                if (r > i && o) {
                    var u = n.substring(0, s), h = n.substring(u.length);
                    f[e][0] = h, f[e].index += u.length;
                }
            }
        }), f.forEach(function(r, s) {
            var h = r[0];
            if (h) {
                var v = r.index;
                if (u) {
                    if (h !== "</" + a.name + ">") return;
                    u = !1;
                }
                var m, d, p = "/" !== h.charAt(1), x = h.startsWith("\x3c!--"), g = v + h.length, y = t.charAt(g), E = f[s + 1];
                if ("<" === y && E) {
                    var A = t.substring(g, E.index);
                    m = A.split("<").length > A.split(">").length;
                }
                if (x) {
                    var b = $3be60b4f29d3a6e3$var$n(h);
                    if (o < 0) return c.push(b), c;
                    (d = l[o]).children.push(b);
                    var O = t.slice(g, E ? E.index : void 0);
                    return O.length > 0 && d.children.push({
                        type: "text",
                        content: O
                    }), c;
                }
                if (p && (o++, "tag" === (a = $3be60b4f29d3a6e3$var$n(h)).type && e.components[a.name] && (a.type = "component", u = !0), a.voidElement || u || !y || "<" === y || a.children.push({
                    type: "text",
                    content: t.slice(g, E ? E.index : void 0)
                }), 0 === o && c.push(a), (d = l[o - 1]) && d.children.push(a), l[o] = a), (!p || a.voidElement) && (o > -1 && (a.voidElement || a.name === h.slice(2, -1)) && (o--, a = -1 === o ? c : l[o]), !u && ("<" !== y || m) && y)) {
                    d = -1 === o ? c : l[o].children;
                    var W = E ? E.index : -1, j = t.slice(g, -1 === W ? void 0 : W);
                    $3be60b4f29d3a6e3$var$i.test(j) && (j = " "), (W > -1 && o + d.length >= 0 || " " !== j) && d.push({
                        type: "text",
                        content: j
                    });
                }
            }
        }), c;
    },
    stringify: function(t) {
        return t.reduce(function(t, e) {
            return t + $3be60b4f29d3a6e3$var$a("", e);
        }, "");
    }
};
var $3be60b4f29d3a6e3$export$2e2bcd8739ae039 = $3be60b4f29d3a6e3$var$c;


function $445d14444882807b$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $445d14444882807b$var$alreadyWarned = {};
function $445d14444882807b$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === 'string' && $445d14444882807b$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === 'string') $445d14444882807b$var$alreadyWarned[args[0]] = new Date();
    $445d14444882807b$export$c106dd0671a0fc2d.apply(void 0, args);
}
var $445d14444882807b$var$loadedClb = function loadedClb(i18n, cb) {
    return function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off('initialized', initialized);
                }, 0);
                cb();
            };
            i18n.on('initialized', initialized);
        }
    };
};
function $445d14444882807b$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $445d14444882807b$var$loadedClb(i18n, cb));
}
function $445d14444882807b$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === 'string') ns = [
        ns
    ];
    ns.forEach(function(n) {
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $445d14444882807b$var$loadedClb(i18n, cb));
}
function $445d14444882807b$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === 'cimode') return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $445d14444882807b$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $445d14444882807b$export$5b28268982f175ba('i18n.languages were undefined or empty', i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $445d14444882807b$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $445d14444882807b$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}



var $dQMrF = parcelRequire("dQMrF");
var $dbc236e0ae4b1bc0$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $dbc236e0ae4b1bc0$var$htmlEntities = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"',
    '&nbsp;': ' ',
    '&#160;': ' ',
    '&copy;': "\xa9",
    '&#169;': "\xa9",
    '&reg;': "\xae",
    '&#174;': "\xae",
    '&hellip;': "\u2026",
    '&#8230;': "\u2026",
    '&#x2F;': '/',
    '&#47;': '/'
};
var $dbc236e0ae4b1bc0$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $dbc236e0ae4b1bc0$var$htmlEntities[m];
};
var $dbc236e0ae4b1bc0$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($dbc236e0ae4b1bc0$var$matchHtmlEntity, $dbc236e0ae4b1bc0$var$unescapeHtmlEntity);
};


function $ba1062cc0d1f4b93$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ba1062cc0d1f4b93$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ba1062cc0d1f4b93$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ba1062cc0d1f4b93$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $ba1062cc0d1f4b93$var$defaultOptions = {
    bindI18n: 'languageChanged',
    bindI18nStore: '',
    transEmptyNodeValue: '',
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: '',
    transKeepBasicHtmlNodesFor: [
        'br',
        'strong',
        'i',
        'p'
    ],
    useSuspense: true,
    unescape: (0, $dbc236e0ae4b1bc0$export$e8bacd2802a88316)
};
function $ba1062cc0d1f4b93$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $ba1062cc0d1f4b93$var$defaultOptions = $ba1062cc0d1f4b93$var$_objectSpread($ba1062cc0d1f4b93$var$_objectSpread({}, $ba1062cc0d1f4b93$var$defaultOptions), options);
}
function $ba1062cc0d1f4b93$export$212bb2fc580a90a8() {
    return $ba1062cc0d1f4b93$var$defaultOptions;
}


var $91a4dd25d142fe34$var$i18nInstance;
function $91a4dd25d142fe34$export$a039134f2fc7e0(instance) {
    $91a4dd25d142fe34$var$i18nInstance = instance;
}
function $91a4dd25d142fe34$export$64af334f494c2f47() {
    return $91a4dd25d142fe34$var$i18nInstance;
}


var $1bd7e790a57f14c4$var$_excluded = [
    "format"
], $1bd7e790a57f14c4$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $1bd7e790a57f14c4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1bd7e790a57f14c4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1bd7e790a57f14c4$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1bd7e790a57f14c4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1bd7e790a57f14c4$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $1bd7e790a57f14c4$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $1bd7e790a57f14c4$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== '[object Array]') return false;
    return children.every(function(child) {
        return (0, $7fPBF.isValidElement)(child);
    });
}
function $1bd7e790a57f14c4$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $1bd7e790a57f14c4$var$mergeProps(source, target) {
    var newTarget = $1bd7e790a57f14c4$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $1bd7e790a57f14c4$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return '';
    var stringNode = '';
    var childrenArray = $1bd7e790a57f14c4$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === 'string') stringNode += "".concat(child);
        else if ((0, $7fPBF.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $1bd7e790a57f14c4$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $445d14444882807b$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, $6TO5S.default)(child) === 'object') {
            var format = child.format, clone = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(child, $1bd7e790a57f14c4$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $445d14444882807b$export$c106dd0671a0fc2d)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $445d14444882807b$export$c106dd0671a0fc2d)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $1bd7e790a57f14c4$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === '') return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $1bd7e790a57f14c4$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === 'string') return;
            if ($1bd7e790a57f14c4$var$hasChildren(child)) getData($1bd7e790a57f14c4$var$getChildren(child));
            else if ((0, $6TO5S.default)(child) === 'object' && !(0, $7fPBF.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $3be60b4f29d3a6e3$export$2e2bcd8739ae039).parse("<0>".concat(targetString, "</0>"));
    var opts = $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $1bd7e790a57f14c4$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $1bd7e790a57f14c4$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $7fPBF.cloneElement)(child, $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $1bd7e790a57f14c4$var$getAsArray(reactNode);
        var astNodes = $1bd7e790a57f14c4$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === 'tag') {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $1bd7e790a57f14c4$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $7fPBF.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $1bd7e790a57f14c4$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $6TO5S.default)(child) === 'object' && child.dummy && !isElement;
                var isKnownComponent = (0, $6TO5S.default)(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === 'string') {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($1bd7e790a57f14c4$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $7fPBF.cloneElement)(child, $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $7fPBF.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $7fPBF.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, $6TO5S.default)(child) === 'object' && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $7fPBF.cloneElement)(child, $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $7fPBF.cloneElement)(child, $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === 'text') {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $7fPBF.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $1bd7e790a57f14c4$var$getAsArray(children || []));
    return $1bd7e790a57f14c4$var$getChildren(result[0]);
}
function $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref, $1bd7e790a57f14c4$var$_excluded2);
    var i18n = i18nFromProps || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (!i18n) {
        (0, $445d14444882807b$export$5b28268982f175ba)('You will need to pass in an i18next instance by using i18nextReactModule');
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, (0, $ba1062cc0d1f4b93$export$212bb2fc580a90a8)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    var defaultValue = defaults || $1bd7e790a57f14c4$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: '#$?',
            suffix: '?$#'
        })
    };
    var combinedTOpts = $1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread($1bd7e790a57f14c4$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $1bd7e790a57f14c4$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $7fPBF.createElement)(useAsParent, additionalProps, content) : content;
}



var $dQMrF = parcelRequire("dQMrF");

var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");

var $7fPBF = parcelRequire("7fPBF");




var $09536692873e4879$export$ae7e14d40d89f296 = {
    type: '3rdParty',
    init: function init(instance) {
        (0, $ba1062cc0d1f4b93$export$2e2366488d12e20d)(instance.options.react);
        (0, $91a4dd25d142fe34$export$a039134f2fc7e0)(instance);
    }
};


function $021c8539c0651064$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $021c8539c0651064$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $021c8539c0651064$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $021c8539c0651064$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $021c8539c0651064$export$5603ab5ced17ce64 = (0, $7fPBF.createContext)();
var $021c8539c0651064$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, $03dWn.default)(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, $4OFm0.default)(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $021c8539c0651064$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $021c8539c0651064$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($021c8539c0651064$var$_objectSpread($021c8539c0651064$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $021c8539c0651064$export$704200e5d0b9e8f() {
    var i18n = (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}


var $69274dd39b5dbdf8$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $69274dd39b5dbdf8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $69274dd39b5dbdf8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $69274dd39b5dbdf8$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $69274dd39b5dbdf8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref, $69274dd39b5dbdf8$var$_excluded);
    var _ref2 = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $1bd7e790a57f14c4$export$8d6a9236f2e3f2ce)($69274dd39b5dbdf8$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}




var $a2azi = parcelRequire("a2azi");
function $e9005c7c032e54f6$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}



var $6A22e = parcelRequire("6A22e");

var $bM4Gu = parcelRequire("bM4Gu");
function $1a6fc27d69850fe4$export$2e2bcd8739ae039(r, e) {
    return (0, $a2azi.default)(r) || (0, $e9005c7c032e54f6$export$2e2bcd8739ae039)(r, e) || (0, $6A22e.default)(r, e) || (0, $bM4Gu.default)();
}



var $dQMrF = parcelRequire("dQMrF");

var $6TO5S = parcelRequire("6TO5S");

var $7fPBF = parcelRequire("7fPBF");


function $9c081519ec78392c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9c081519ec78392c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $9c081519ec78392c$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $9c081519ec78392c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $9c081519ec78392c$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $7fPBF.useRef)();
    (0, $7fPBF.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $9c081519ec78392c$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $021c8539c0651064$export$ea171b67e3820290)();
    if (!i18n) {
        (0, $445d14444882807b$export$5b28268982f175ba)('You will need to pass in an i18next instance by using initReactI18next');
        var notReadyT = function notReadyT(k, optsOrDefaultValue) {
            if (typeof optsOrDefaultValue === 'string') return optsOrDefaultValue;
            if (optsOrDefaultValue && (0, $6TO5S.default)(optsOrDefaultValue) === 'object' && typeof optsOrDefaultValue.defaultValue === 'string') return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $445d14444882807b$export$5b28268982f175ba)('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');
    var i18nOptions = $9c081519ec78392c$var$_objectSpread($9c081519ec78392c$var$_objectSpread($9c081519ec78392c$var$_objectSpread({}, (0, $ba1062cc0d1f4b93$export$212bb2fc580a90a8)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === 'string' ? [
        namespaces
    ] : namespaces || [
        'translation'
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $445d14444882807b$export$93d9ee97c1ad3f31)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $7fPBF.useState)(getT), _useState2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
    var previousJoinedNS = $9c081519ec78392c$var$usePrevious(joinedNS);
    var isMounted = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $445d14444882807b$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
            else (0, $445d14444882807b$export$83be934b53fff43b)(i18n, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(' ').forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $7fPBF.useRef)(true);
    (0, $7fPBF.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        if (props.lng) (0, $445d14444882807b$export$8cd7e7a54fa865bc)(i18n, props.lng, namespaces, function() {
            return resolve();
        });
        else (0, $445d14444882807b$export$83be934b53fff43b)(i18n, namespaces, function() {
            return resolve();
        });
    });
}



var $dQMrF = parcelRequire("dQMrF");



var $7fPBF = parcelRequire("7fPBF");


var $1b9d18dce12af9e0$var$_excluded = [
    "forwardedRef"
];
function $1b9d18dce12af9e0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1b9d18dce12af9e0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1b9d18dce12af9e0$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1b9d18dce12af9e0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1b9d18dce12af9e0$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref, $1b9d18dce12af9e0$var$_excluded);
            var _useTranslation = (0, $9c081519ec78392c$export$9fc83ad70ead8663)(ns, $1b9d18dce12af9e0$var$_objectSpread($1b9d18dce12af9e0$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $1b9d18dce12af9e0$var$_objectSpread($1b9d18dce12af9e0$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $7fPBF.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $445d14444882807b$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $7fPBF.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $7fPBF.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}





var $1123dfab2acde046$var$_excluded = [
    "ns",
    "children"
];
function $1123dfab2acde046$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(props, $1123dfab2acde046$var$_excluded);
    var _useTranslation = (0, $9c081519ec78392c$export$9fc83ad70ead8663)(ns, options), _useTranslation2 = (0, $1a6fc27d69850fe4$export$2e2bcd8739ae039)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}



var $7fPBF = parcelRequire("7fPBF");

function $f40df753886fac13$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $7fPBF.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $7fPBF.createElement)((0, $021c8539c0651064$export$5603ab5ced17ce64).Provider, {
        value: value
    }, children);
}



var $dQMrF = parcelRequire("dQMrF");


var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

function $6dc6e4594d06aae3$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $7fPBF.useContext)((0, $021c8539c0651064$export$5603ab5ced17ce64)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $91a4dd25d142fe34$export$64af334f494c2f47)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}




var $25e3a7ece768866e$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $25e3a7ece768866e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $25e3a7ece768866e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $25e3a7ece768866e$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $dQMrF.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $25e3a7ece768866e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $25e3a7ece768866e$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, $f779b8b0ef990dda$export$2e2bcd8739ae039)(_ref, $25e3a7ece768866e$var$_excluded);
            (0, $6dc6e4594d06aae3$export$3526fb65ade8d8b7)(initialI18nStore, initialLanguage);
            return (0, $7fPBF.createElement)(WrappedComponent, $25e3a7ece768866e$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $021c8539c0651064$export$30ff0342ccf735a)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $445d14444882807b$export$be63e0664592e141)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}







var $2af286126fb112dc$export$324d90190a8b822a = function date() {
    return '';
};
var $2af286126fb112dc$export$2da9be4cfdb689b1 = function time() {
    return '';
};
var $2af286126fb112dc$export$98e628dec113755e = function number() {
    return '';
};
var $2af286126fb112dc$export$2e6c959c16ff56b8 = function select() {
    return '';
};
var $2af286126fb112dc$export$4e35d5c922a95490 = function plural() {
    return '';
};
var $2af286126fb112dc$export$720a3b9db04b7a0f = function selectOrdinal() {
    return '';
};



var $03dWn = parcelRequire("03dWn");

var $4OFm0 = parcelRequire("4OFm0");
var $f73f86de2138df56$var$arr = [];
var $f73f86de2138df56$var$each = $f73f86de2138df56$var$arr.forEach;
var $f73f86de2138df56$var$slice = $f73f86de2138df56$var$arr.slice;
function $f73f86de2138df56$var$defaults(obj) {
    $f73f86de2138df56$var$each.call($f73f86de2138df56$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $f73f86de2138df56$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $f73f86de2138df56$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || '/';
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.domain)) throw new TypeError('option domain is invalid');
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$f73f86de2138df56$var$fieldContentRegExp.test(opt.path)) throw new TypeError('option path is invalid');
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== 'function') throw new TypeError('option expires is invalid');
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += '; HttpOnly';
    if (opt.secure) str += '; Secure';
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += '; SameSite=Strict';
                break;
            case 'lax':
                str += '; SameSite=Lax';
                break;
            case 'strict':
                str += '; SameSite=Strict';
                break;
            case 'none':
                str += '; SameSite=None';
                break;
            default:
                throw new TypeError('option sameSite is invalid');
        }
    }
    return str;
};
var $f73f86de2138df56$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: '/',
            sameSite: 'strict'
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $f73f86de2138df56$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === ' ')c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, '', -1);
    }
};
var $f73f86de2138df56$var$cookie$1 = {
    name: 'cookie',
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== 'undefined') {
            var c = $f73f86de2138df56$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== 'undefined') $f73f86de2138df56$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $f73f86de2138df56$var$querystring = {
    name: 'querystring',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf('?') > -1) search = window.location.hash.substring(window.location.hash.indexOf('?'));
            var query = search.substring(1);
            var params = query.split('&');
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf('=');
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$hasLocalStorageSupport = null;
var $f73f86de2138df56$var$localStorageAvailable = function localStorageAvailable() {
    if ($f73f86de2138df56$var$hasLocalStorageSupport !== null) return $f73f86de2138df56$var$hasLocalStorageSupport;
    try {
        $f73f86de2138df56$var$hasLocalStorageSupport = window !== 'undefined' && window.localStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.localStorage.setItem(testKey, 'foo');
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasLocalStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasLocalStorageSupport;
};
var $f73f86de2138df56$var$localStorage = {
    name: 'localStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $f73f86de2138df56$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $f73f86de2138df56$var$hasSessionStorageSupport = null;
var $f73f86de2138df56$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($f73f86de2138df56$var$hasSessionStorageSupport !== null) return $f73f86de2138df56$var$hasSessionStorageSupport;
    try {
        $f73f86de2138df56$var$hasSessionStorageSupport = window !== 'undefined' && window.sessionStorage !== null;
        var testKey = 'i18next.translate.boo';
        window.sessionStorage.setItem(testKey, 'foo');
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $f73f86de2138df56$var$hasSessionStorageSupport = false;
    }
    return $f73f86de2138df56$var$hasSessionStorageSupport;
};
var $f73f86de2138df56$var$sessionStorage = {
    name: 'sessionStorage',
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $f73f86de2138df56$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $f73f86de2138df56$var$navigator$1 = {
    name: 'navigator',
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== 'undefined') {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $f73f86de2138df56$var$htmlTag = {
    name: 'htmlTag',
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === 'function') found = htmlTag.getAttribute('lang');
        return found;
    }
};
var $f73f86de2138df56$var$path = {
    name: 'path',
    lookup: function lookup(options) {
        var found;
        if (typeof window !== 'undefined') {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === 'number') {
                    if (typeof language[options.lookupFromPathIndex] !== 'string') return undefined;
                    found = language[options.lookupFromPathIndex].replace('/', '');
                } else found = language[0].replace('/', '');
            }
        }
        return found;
    }
};
var $f73f86de2138df56$var$subdomain = {
    name: 'subdomain',
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === 'number' ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== 'undefined' && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
// some environments, throws when accessing document.cookie
var $f73f86de2138df56$var$canCookies = false;
try {
    // eslint-disable-next-line no-unused-expressions
    document.cookie;
    $f73f86de2138df56$var$canCookies = true;
// eslint-disable-next-line no-empty
} catch (e) {}
var $f73f86de2138df56$var$order = [
    'querystring',
    'cookie',
    'localStorage',
    'sessionStorage',
    'navigator',
    'htmlTag'
];
if (!$f73f86de2138df56$var$canCookies) $f73f86de2138df56$var$order.splice(1, 1);
function $f73f86de2138df56$var$getDefaults() {
    return {
        order: $f73f86de2138df56$var$order,
        lookupQuerystring: 'lng',
        lookupCookie: 'i18next',
        lookupLocalStorage: 'i18nextLng',
        lookupSessionStorage: 'i18nextLng',
        // cache user language
        caches: [
            'localStorage'
        ],
        excludeCacheFor: [
            'cimode'
        ],
        // cookieMinutes: 10,
        // cookieDomain: 'myDomain'
        convertDetectedLanguage: function convertDetectedLanguage(l) {
            return l;
        }
    };
}
var $f73f86de2138df56$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $03dWn.default)(this, Browser);
        this.type = 'languageDetector';
        this.detectors = {};
        this.init(services, options);
    }
    return (0, $4OFm0.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services || {
                    languageUtils: {}
                }; // this way the language detector can be used without i18next
                this.options = $f73f86de2138df56$var$defaults(options, this.options || {}, $f73f86de2138df56$var$getDefaults());
                if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) this.options.convertDetectedLanguage = function(l) {
                    return l.replace('-', '_');
                };
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($f73f86de2138df56$var$cookie$1);
                this.addDetector($f73f86de2138df56$var$querystring);
                this.addDetector($f73f86de2138df56$var$localStorage);
                this.addDetector($f73f86de2138df56$var$sessionStorage);
                this.addDetector($f73f86de2138df56$var$navigator$1);
                this.addDetector($f73f86de2138df56$var$htmlTag);
                this.addDetector($f73f86de2138df56$var$path);
                this.addDetector($f73f86de2138df56$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
                return this;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === 'string') lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                detected = detected.map(function(d) {
                    return _this.options.convertDetectedLanguage(d);
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
}();
$f73f86de2138df56$export$2e2bcd8739ae039.type = 'languageDetector';


var $2436233380b6882f$exports = {};
$2436233380b6882f$exports = JSON.parse("{\"moduleTitle\":\"Select a Module\",\"detailsTitle\":\"Assignment Details\",\"continue\":\"Continue\",\"assign\":\"Assign module\",\"assigning\":\"Assigning\",\"missingContext\":\"Missing the context needed to assign this Module. Please refresh and try again.\",\"retry\":\"Retry\",\"emptyTitle\":\"No Modules Yet\",\"emptyMessage\":\"Create a Training Module before assigning one.\",\"alreadyAssigned\":\"Already assigned\",\"reassignWarning\":\"Assigning this Module again will remove {{person}}'s existing progress.\",\"dueDate\":\"Due Date\",\"notify\":\"Notify me when {{person}} finishes this Module\"}");


var $c002470d02ce3cd4$exports = {};
$c002470d02ce3cd4$exports = JSON.parse('{"sourceTitle":"New Volunteering Team","sourceDescription":"Group volunteers into teams to organize their roles, invites, and training.","volunteeringIcon":"Volunteering","unavailable":"Unavailable creation methods may require you to connect an external provider in <link>Connections</link>","createInSalt":"Create in Salt","createInSaltDescription":"Create a new team from scratch.","saltLogo":"Salt","importTitle":"Import from Planning Center","importDescription":"Import an existing Planning Center team to quickly get started. Volunteers added after import will not be synced.","planningCenterLogo":"Planning Center","detailsTitle":"New Team","namePlaceholder":"Team Name","nameLabel":"Team name","detailsFootnote":"You can add roles and invite volunteers once the team is created.","create":"Create Team","creating":"Creating...","createFailed":"Unable to create this team right now.","loadTeamsFailed":"Unable to load your Planning Center teams right now.","alreadyImported":"That team has already been imported.","importFailed":"Unable to import this team right now.","importedTitle":"{{team}} was imported","importedVolunteers_one":"{{count}} volunteer","importedVolunteers_other":"{{count}} volunteers","importedRoles_one":"{{count}} role","importedRoles_other":"{{count}} roles","importedSummary":"{{volunteers}} and {{roles}} were added from Planning Center.","unmatched_one":"{{count}} person on this team wasn\'t added because they aren\'t in Salt yet. Import your people from Planning Center on the <link>People</link> tab, then invite them to this team.","unmatched_other":"{{count}} people on this team weren\'t added because they aren\'t in Salt yet. Import your people from Planning Center on the <link>People</link> tab, then invite them to this team.","goToTeam":"Go to Team","loadingTeams":"Loading your teams from Planning Center\u2026","noTeams":"There are no active teams in your Planning Center account.","createInSaltInstead":"Create a Team in Salt Instead","chooseTeam":"Choose a team to copy into Salt. Its positions become roles, and its people are matched to people already in Salt.","filterPlaceholder":"Filter teams","noFilterMatches":"No teams match that filter.","otherTeams":"Other Teams","imported":"Imported","importFootnote":"A one-time copy: the team won\'t stay in sync with Planning Center, and no new people are created.","import":"Import Team","importNamed":"Import {{team}}","importing":"Importing\u2026"}');


var $d29049e066501c72$exports = {};
$d29049e066501c72$exports = JSON.parse("{\"title\":\"Edit Roles\",\"savedTitle\":\"Roles Saved\",\"saveLabel\":\"Save roles\",\"savingLabel\":\"Saving\",\"assigned_one\":\"{{person}} was assigned this training for their new role:\",\"assigned_other\":\"{{person}} was assigned this training for their new roles:\",\"fallbackPerson\":\"This volunteer\",\"fallbackModule\":\"Training Module\",\"due\":\"Due {{date}}\",\"caption\":\"{{person}} on the {{team}} team\",\"noRoles\":\"This team hasn't defined any roles yet.\",\"createRoles\":\"Create Roles\"}");


var $643840e186bf6773$exports = {};
$643840e186bf6773$exports = JSON.parse("{\"title\":\"Edit Team\",\"nameLabel\":\"Team name\",\"save\":\"Save\",\"saving\":\"Saving...\"}");


var $eaaca7f238397659$exports = {};
$eaaca7f238397659$exports = JSON.parse("{\"title\":\"Invite Volunteer to {{team}} Team\",\"titleUnnamed\":\"Invite Volunteer\",\"rolesTitle\":\"Select Roles\",\"continue\":\"Continue\",\"invite\":\"Send invite\",\"inviting\":\"Inviting\",\"roles\":\"Roles\",\"rolesHint\":\"Optional. Roles can be changed later from the volunteer's menu.\",\"searchPlaceholder\":\"Search by first name or email\",\"searchLabel\":\"Search people\",\"noMatches\":\"No one matched that search.\",\"createInstead\":\"Can't find who you're looking for? Create New Person\",\"searchInstead\":\"Search for Existing Person Instead\",\"nameLabel\":\"Name\",\"namePlaceholder\":\"Full name\",\"emailLabel\":\"Email\",\"emailPlaceholder\":\"name@example.com\"}");


var $cb96ede08269c00c$exports = {};
$cb96ede08269c00c$exports = JSON.parse('{"newTitle":"New Lesson","editTitle":"Edit Lesson","uploadingTitle":"Uploading Video","uploadedTitle":"Video Uploaded","saveLabel":"Save lesson","savingLabel":"Saving","titleLabel":"Title","titlePlaceholder":"Lesson Title","descriptionLabel":"Description","descriptionPlaceholder":"A one-line summary of this lesson","videoLabel":"Video","textLabel":"Text","fallbackFileName":"Video","previewFailed":"Unable to get a playable URL for this video.","uploadStartFailed":"The video upload could not be started.","uploadFailed":"The video upload failed.","thumbnailTargetFailed":"Unable to create an upload target for the thumbnail.","thumbnailUploadFailed":"The thumbnail upload failed. Please try again.","saveFailed":"Unable to save this Lesson right now.","uploadSavedCaption":"The Lesson was saved. You can retry the upload, or close and add the video later.","retryUpload":"Retry Upload","close":"Close","uploadComplete":"Upload Complete. Video will be available once processing completes","uploading":"Uploading... {{percent}}%","keepCurrentVideo":"Keep current video","keepCurrentImage":"Keep current image","clear":"Clear","uploadsAfterCreate":"Uploads after the Lesson is created.","preparingPreview":"Preparing preview\u2026","previewVideo":"Preview video","noVideo":"No video on this lesson.","thumbnailTitle":"Thumbnail","thumbnailCaption":"Shown in the lesson list before the video plays.","videoProcessing":"Processing","videoUploaded":"Uploaded","videoHosted":"Hosted","videoUploadFailed":"Upload failed","videoProcessingDetail":"Video processing.","editor":{"contentArea":{"editableMarkdown":"editable markdown"},"toolbar":{"undo":"Undo {{shortcut}}","redo":"Redo {{shortcut}}","bold":"Bold","removeBold":"Remove bold","italic":"Italic","removeItalic":"Remove italic","blockTypeSelect":{"placeholder":"Block type","selectBlockTypeTooltip":"Select block type"},"blockTypes":{"paragraph":"Paragraph","heading":"Heading {{level}}","quote":"Quote"},"bulletedList":"Bulleted list","numberedList":"Numbered list","link":"Create link","table":"Insert Table","toggleGroup":"toggle group"},"createLink":{"url":"URL","urlPlaceholder":"Select or paste a URL","text":"Anchor text","textTooltip":"The text to be displayed for the link","title":"Link title","titleTooltip":"The link\'s title attribute, shown on hover","saveTooltip":"Set URL","cancelTooltip":"Cancel change"},"linkPreview":{"edit":"Edit link URL","copyToClipboard":"Copy to clipboard","copied":"Copied!","remove":"Remove link"},"dialogControls":{"save":"Save","cancel":"Cancel"},"table":{"columnMenu":"Column menu","rowMenu":"Row menu","textAlignment":"Text alignment","alignLeft":"Align left","alignCenter":"Align center","alignRight":"Align right","insertColumnLeft":"Insert a column to the left of this one","insertColumnRight":"Insert a column to the right of this one","deleteColumn":"Delete this column","insertRowAbove":"Insert a row above this one","insertRowBelow":"Insert a row below this one","deleteRow":"Delete this row","deleteTable":"Delete table"}}}');


var $88755a45f9c709c9$exports = {};
$88755a45f9c709c9$exports = JSON.parse('{"title":"{{team}} Roles","titleUnnamed":"Roles","caption":"Roles group the people on this team, like \\"Camera Operator\\" or \\"Greeter\\". A volunteer can hold several.","newRolePlaceholder":"New role name","addRole":"Add Role","adding":"Adding...","duplicateName":"This team already has a role with that name.","duplicateNamed":"This team already has a role named \\"{{name}}\\".","createFailed":"Unable to create this role right now.","empty":"No roles yet. Add one above to start grouping this team.","volunteers_one":"{{count}} volunteer","volunteers_other":"{{count}} volunteers","trainingTitle":"Training for {{role}}","trainingEmpty":"No training yet. People given this role aren\'t assigned anything.","dueInBefore":"Due in","dueInAfter":"days","dueInLabel":"Days to complete {{module}}","stopAssigning":"Stop assigning {{module}}","invalidWindow":"Each due window must be a whole number of days, from {{min}} to {{max}}.","addModule":"Add a training module","addModuleOption":"Add a training module\u2026","noModules":"This church has no Training Modules yet.","trainingCaptionHolders_one":"Updating a role\'s assigned training will automatically assign the added module to the volunteer who holds this role now.","trainingCaptionHolders_other":"Updating a role\'s assigned training will automatically assign the added module to the {{count}} volunteers who hold this role now.","trainingCaptionNoHolders":"Updating a role\'s assigned training will automatically assign the added module to anyone who is given this role later.","renameLabel":"Rename {{role}}","deleteLabel":"Delete {{role}}","deleteConfirm":"Delete {{role}}?","deleteHolders_one":"It will be removed from {{count}} volunteer.","deleteHolders_other":"It will be removed from {{count}} volunteers.","deleteNoHolders":"No one holds this role.","delete":"Delete","deleting":"Deleting...","summaryCount_one":"Assigns {{count}} training module","summaryCount_other":"Assigns {{count}} training modules","summaryList":"Assigns {{list}}","summaryItem_one":"{{module}} ({{count}} day)","summaryItem_other":"{{module}} ({{count}} days)","listSeparator":", ","unknownModule":"Unknown module","assignedPart_one":"{{module}} to {{count}} volunteer","assignedPart_other":"{{module}} to {{count}} volunteers","assignedNotice":"Assigned {{parts}}.","assignedJoiner":", and "}');


var $02db604409e3f38e$exports = {};
$02db604409e3f38e$exports = JSON.parse("{\"newTitle\":\"New Module\",\"editTitle\":\"Edit Module\",\"saveLabel\":\"Save module\",\"savingLabel\":\"Saving\",\"titleLabel\":\"Title\",\"titlePlaceholder\":\"Module Title\",\"descriptionLabel\":\"Description\",\"descriptionPlaceholder\":\"What this module covers\",\"thumbnailLabel\":\"Thumbnail\",\"keepCurrentImage\":\"Keep current image\",\"clearImage\":\"Clear\",\"campusLabel\":\"Campus\",\"campusPlaceholder\":\"Select a campus\",\"categoryLabel\":\"Category\",\"categoryPlaceholder\":\"Select a category\",\"uploadTargetFailed\":\"Unable to create an upload target for the thumbnail.\",\"uploadFailed\":\"The thumbnail upload failed. Please try again.\"}");


var $d9d34482b0518e71$exports = {};
$d9d34482b0518e71$exports = JSON.parse("{\"title\":\"Remove Volunteer\",\"confirm\":\"Remove {{person}} from the {{team}} team?\",\"confirmUnnamed\":\"Remove this volunteer from this team?\",\"caption\":\"This doesn't delete them from your church's People. You can invite them back to this team at any time.\",\"remove\":\"Remove from Team\",\"removing\":\"Removing...\"}");


var $4ceee968c3e3d346$exports = {};
$4ceee968c3e3d346$exports = JSON.parse("{\"heading\":\"Modules\",\"newModule\":\"New Module\",\"emptyTitle\":\"No Modules Yet\",\"emptyMessage\":\"Create a Training Module to get started.\",\"retry\":\"Retry\",\"unknownCampus\":\"Unknown Campus\",\"unknownCategory\":\"Unknown Category\"}");


var $bdfa45a60b7acd50$exports = {};
$bdfa45a60b7acd50$exports = JSON.parse("{\"retry\":\"Retry\",\"notFound\":\"Training Module not found.\",\"backToTraining\":\"Back to Training\",\"edit\":\"Edit\",\"lessonsHeading\":\"Lessons\",\"newLesson\":\"New Lesson\",\"emptyTitle\":\"No Lessons\",\"emptyMessage\":\"Add a Lesson to this Module to get started.\",\"videoProcessing\":\"Processing\",\"videoFailed\":\"Video failed\",\"video\":\"Video\"}");


var $ff480a0c679a69fc$exports = {};
$ff480a0c679a69fc$exports = JSON.parse("{\"fallbackName\":\"Volunteer\",\"details\":\"Details\",\"retry\":\"Retry\",\"assignedHeading\":\"Assigned Training\",\"assignTraining\":\"Assign Training\",\"emptyTitle\":\"No Assigned Training\",\"emptyMessage\":\"{{person}} hasn't been assigned any Training Modules yet.\",\"anotherTeam\":\"Another team\",\"unavailableModule\":\"Unavailable Module\",\"moduleUnavailable\":\"This Training Module is no longer available.\",\"completed\":\"Completed\",\"lessonsComplete_one\":\"{{count}} Lesson complete\",\"lessonsComplete_other\":\"{{count}} Lessons complete\",\"notStarted\":\"Not started\",\"due\":\"Due {{date}}\",\"overdue\":\"Overdue {{date}}\",\"via\":\"via {{team}}\"}");


var $8195002cbf826711$exports = {};
$8195002cbf826711$exports = JSON.parse('{"tabs":{"title":"Volunteering","teams":"Teams","trainingModules":"Training Modules"},"teams":{"heading":"Teams","newTeam":"New Team","emptyTitle":"No Teams Yet","emptyMessage":"Create a volunteer team to get started."},"team":{"loadFailedTitle":"Unable to Load Team","loadFailedMessage":"This team may have been deleted.","backToTeams":"Back to Teams","noMembers":"No volunteers on this team. Invite a volunteer to get started.","viewAll_one":"View all {{count}} volunteer","viewAll_other":"View all {{count}} volunteers","roles":"Roles","editTeam":"Edit Team","inviteVolunteer":"Invite Volunteer","unknownPerson":"Unknown"},"menu":{"details":"Details","editRoles":"Edit Roles","assignedTraining":"Assigned Training","removeFromTeam":"Remove from Team"},"rolePicker":{"label":"Roles"},"errors":{"loadTeams":"Failed to load teams.","loadTeam":"Failed to load this team.","loadTrainingModules":"Failed to load Training Modules.","loadTrainingModule":"Failed to load this Training Module.","loadAssignedTraining":"Failed to load assigned training.","missingChurch":"Missing church context. Please refresh and try again."},"common":{"close":"Close","save":"Save","saving":"Saving\u2026","done":"Done","cancel":"Cancel","tryAgain":"Try Again","back":"Back","loading":"Loading\u2026"}}');


var $98fe2de48f0912bd$exports = {};
$98fe2de48f0912bd$exports = JSON.parse('{"moduleTitle":"Choisir un module","detailsTitle":"D\xe9tails de l\'assignation","continue":"Continuer","assign":"Assigner le module","assigning":"Assignation","missingContext":"Des informations n\xe9cessaires pour assigner ce module sont manquantes. Veuillez actualiser la page et r\xe9essayer.","retry":"R\xe9essayer","emptyTitle":"Aucun module pour l\'instant","emptyMessage":"Cr\xe9ez un module de formation avant d\'en assigner un.","alreadyAssigned":"D\xe9j\xe0 assign\xe9","reassignWarning":"Assigner ce module \xe0 nouveau effacera la progression actuelle de {{person}}.","dueDate":"Date d\'\xe9ch\xe9ance","notify":"M\'avertir quand {{person}} termine ce module"}');


var $db4f007afb1ecb03$exports = {};
$db4f007afb1ecb03$exports = JSON.parse('{"sourceTitle":"Nouvelle \xe9quipe de b\xe9n\xe9voles","sourceDescription":"Regroupez les b\xe9n\xe9voles en \xe9quipes pour organiser leurs r\xf4les, leurs invitations et leurs formations.","volunteeringIcon":"B\xe9n\xe9volat","unavailable":"Les m\xe9thodes de cr\xe9ation indisponibles peuvent n\xe9cessiter de connecter un fournisseur externe dans <link>Connexions</link>","createInSalt":"Cr\xe9er dans Salt","createInSaltDescription":"Cr\xe9er une nouvelle \xe9quipe \xe0 partir de z\xe9ro.","saltLogo":"Salt","importTitle":"Importer depuis Planning Center","importDescription":"Importez une \xe9quipe Planning Center existante pour commencer rapidement. Les b\xe9n\xe9voles ajout\xe9s apr\xe8s l\'importation ne seront pas synchronis\xe9s.","planningCenterLogo":"Planning Center","detailsTitle":"Nouvelle \xe9quipe","namePlaceholder":"Nom de l\'\xe9quipe","nameLabel":"Nom de l\'\xe9quipe","detailsFootnote":"Vous pourrez ajouter des r\xf4les et inviter des b\xe9n\xe9voles une fois l\'\xe9quipe cr\xe9\xe9e.","create":"Cr\xe9er l\'\xe9quipe","creating":"Cr\xe9ation\u2026","createFailed":"Impossible de cr\xe9er cette \xe9quipe pour le moment.","loadTeamsFailed":"Impossible de charger vos \xe9quipes Planning Center pour le moment.","alreadyImported":"Cette \xe9quipe a d\xe9j\xe0 \xe9t\xe9 import\xe9e.","importFailed":"Impossible d\'importer cette \xe9quipe pour le moment.","importedTitle":"{{team}} a \xe9t\xe9 import\xe9e","importedVolunteers_one":"{{count}} b\xe9n\xe9vole","importedVolunteers_other":"{{count}} b\xe9n\xe9voles","importedRoles_one":"{{count}} r\xf4le","importedRoles_other":"{{count}} r\xf4les","importedSummary":"{{volunteers}} et {{roles}} ont \xe9t\xe9 ajout\xe9s depuis Planning Center.","unmatched_one":"{{count}} personne de cette \xe9quipe n\'a pas \xe9t\xe9 ajout\xe9e, car elle n\'est pas encore dans Salt. Importez vos personnes depuis Planning Center dans l\'onglet <link>Personnes</link>, puis invitez-les dans cette \xe9quipe.","unmatched_other":"{{count}} personnes de cette \xe9quipe n\'ont pas \xe9t\xe9 ajout\xe9es, car elles ne sont pas encore dans Salt. Importez vos personnes depuis Planning Center dans l\'onglet <link>Personnes</link>, puis invitez-les dans cette \xe9quipe.","goToTeam":"Aller \xe0 l\'\xe9quipe","loadingTeams":"Chargement de vos \xe9quipes Planning Center\u2026","noTeams":"Votre compte Planning Center ne contient aucune \xe9quipe active.","createInSaltInstead":"Cr\xe9er plut\xf4t une \xe9quipe dans Salt","chooseTeam":"Choisissez une \xe9quipe \xe0 copier dans Salt. Ses postes deviennent des r\xf4les, et ses membres sont associ\xe9s aux personnes d\xe9j\xe0 pr\xe9sentes dans Salt.","filterPlaceholder":"Filtrer les \xe9quipes","noFilterMatches":"Aucune \xe9quipe ne correspond \xe0 ce filtre.","otherTeams":"Autres \xe9quipes","imported":"Import\xe9e","importFootnote":"Une copie unique : l\'\xe9quipe ne restera pas synchronis\xe9e avec Planning Center, et aucune nouvelle personne n\'est cr\xe9\xe9e.","import":"Importer l\'\xe9quipe","importNamed":"Importer {{team}}","importing":"Importation\u2026"}');


var $fe25728064163779$exports = {};
$fe25728064163779$exports = JSON.parse('{"title":"Modifier les r\xf4les","savedTitle":"R\xf4les enregistr\xe9s","saveLabel":"Enregistrer les r\xf4les","savingLabel":"Enregistrement","assigned_one":"{{person}} s\'est vu assigner cette formation pour son nouveau r\xf4le :","assigned_other":"{{person}} s\'est vu assigner cette formation pour ses nouveaux r\xf4les :","fallbackPerson":"Ce b\xe9n\xe9vole","fallbackModule":"Module de formation","due":"\xc0 faire d\'ici le {{date}}","caption":"{{person}} dans l\'\xe9quipe {{team}}","noRoles":"Cette \xe9quipe n\'a encore d\xe9fini aucun r\xf4le.","createRoles":"Cr\xe9er des r\xf4les"}');


var $f52f7cd013f24acc$exports = {};
$f52f7cd013f24acc$exports = JSON.parse('{"title":"Modifier l\'\xe9quipe","nameLabel":"Nom de l\'\xe9quipe","save":"Enregistrer","saving":"Enregistrement\u2026"}');


var $49553acc9a509a26$exports = {};
$49553acc9a509a26$exports = JSON.parse('{"title":"Inviter un b\xe9n\xe9vole dans l\'\xe9quipe {{team}}","titleUnnamed":"Inviter un b\xe9n\xe9vole","rolesTitle":"Choisir les r\xf4les","continue":"Continuer","invite":"Envoyer l\'invitation","inviting":"Envoi de l\'invitation","roles":"R\xf4les","rolesHint":"Facultatif. Les r\xf4les pourront \xeatre modifi\xe9s plus tard depuis le menu du b\xe9n\xe9vole.","searchPlaceholder":"Rechercher par pr\xe9nom ou adresse e-mail","searchLabel":"Rechercher des personnes","noMatches":"Aucune personne ne correspond \xe0 cette recherche.","createInstead":"Vous ne trouvez pas la personne que vous cherchez ? Cr\xe9er une nouvelle personne","searchInstead":"Rechercher plut\xf4t une personne existante","nameLabel":"Nom","namePlaceholder":"Nom complet","emailLabel":"Adresse e-mail","emailPlaceholder":"nom@exemple.com"}');


var $53bb430a43a21e3b$exports = {};
$53bb430a43a21e3b$exports = JSON.parse('{"newTitle":"Nouvelle le\xe7on","editTitle":"Modifier la le\xe7on","uploadingTitle":"T\xe9l\xe9versement de la vid\xe9o","uploadedTitle":"Vid\xe9o t\xe9l\xe9vers\xe9e","saveLabel":"Enregistrer la le\xe7on","savingLabel":"Enregistrement","titleLabel":"Titre","titlePlaceholder":"Titre de la le\xe7on","descriptionLabel":"Description","descriptionPlaceholder":"Un r\xe9sum\xe9 de cette le\xe7on en une ligne","videoLabel":"Vid\xe9o","textLabel":"Texte","fallbackFileName":"Vid\xe9o","previewFailed":"Impossible d\'obtenir une URL de lecture pour cette vid\xe9o.","uploadStartFailed":"Le t\xe9l\xe9versement de la vid\xe9o n\'a pas pu d\xe9marrer.","uploadFailed":"Le t\xe9l\xe9versement de la vid\xe9o a \xe9chou\xe9.","thumbnailTargetFailed":"Impossible de pr\xe9parer le t\xe9l\xe9versement de la miniature.","thumbnailUploadFailed":"Le t\xe9l\xe9versement de la miniature a \xe9chou\xe9. Veuillez r\xe9essayer.","saveFailed":"Impossible d\'enregistrer cette le\xe7on pour le moment.","uploadSavedCaption":"La le\xe7on a \xe9t\xe9 enregistr\xe9e. Vous pouvez relancer le t\xe9l\xe9versement, ou fermer et ajouter la vid\xe9o plus tard.","retryUpload":"Relancer le t\xe9l\xe9versement","close":"Fermer","uploadComplete":"T\xe9l\xe9versement termin\xe9. La vid\xe9o sera disponible une fois le traitement termin\xe9","uploading":"T\xe9l\xe9versement\u2026 {{percent}} %","keepCurrentVideo":"Conserver la vid\xe9o actuelle","keepCurrentImage":"Conserver l\'image actuelle","clear":"Effacer","uploadsAfterCreate":"T\xe9l\xe9vers\xe9e une fois la le\xe7on cr\xe9\xe9e.","preparingPreview":"Pr\xe9paration de l\'aper\xe7u\u2026","previewVideo":"Aper\xe7u de la vid\xe9o","noVideo":"Aucune vid\xe9o dans cette le\xe7on.","thumbnailTitle":"Miniature","thumbnailCaption":"Affich\xe9e dans la liste des le\xe7ons avant la lecture de la vid\xe9o.","videoProcessing":"En traitement","videoUploaded":"T\xe9l\xe9vers\xe9e","videoHosted":"H\xe9berg\xe9e","videoUploadFailed":"\xc9chec du t\xe9l\xe9versement","videoProcessingDetail":"Vid\xe9o en cours de traitement.","editor":{"contentArea":{"editableMarkdown":"markdown modifiable"},"toolbar":{"undo":"Annuler {{shortcut}}","redo":"R\xe9tablir {{shortcut}}","bold":"Gras","removeBold":"Retirer le gras","italic":"Italique","removeItalic":"Retirer l\'italique","blockTypeSelect":{"placeholder":"Type de bloc","selectBlockTypeTooltip":"Choisir le type de bloc"},"blockTypes":{"paragraph":"Paragraphe","heading":"Titre {{level}}","quote":"Citation"},"bulletedList":"Liste \xe0 puces","numberedList":"Liste num\xe9rot\xe9e","link":"Cr\xe9er un lien","table":"Ins\xe9rer un tableau","toggleGroup":"groupe de boutons"},"createLink":{"url":"URL","urlPlaceholder":"Choisir ou coller une URL","text":"Texte du lien","textTooltip":"Le texte affich\xe9 pour le lien","title":"Titre du lien","titleTooltip":"L\'attribut title du lien, affich\xe9 au survol","saveTooltip":"D\xe9finir l\'URL","cancelTooltip":"Annuler la modification"},"linkPreview":{"edit":"Modifier l\'URL du lien","copyToClipboard":"Copier dans le presse-papiers","copied":"Copi\xe9 !","remove":"Retirer le lien"},"dialogControls":{"save":"Enregistrer","cancel":"Annuler"},"table":{"columnMenu":"Menu de la colonne","rowMenu":"Menu de la ligne","textAlignment":"Alignement du texte","alignLeft":"Aligner \xe0 gauche","alignCenter":"Centrer","alignRight":"Aligner \xe0 droite","insertColumnLeft":"Ins\xe9rer une colonne \xe0 gauche de celle-ci","insertColumnRight":"Ins\xe9rer une colonne \xe0 droite de celle-ci","deleteColumn":"Supprimer cette colonne","insertRowAbove":"Ins\xe9rer une ligne au-dessus de celle-ci","insertRowBelow":"Ins\xe9rer une ligne au-dessous de celle-ci","deleteRow":"Supprimer cette ligne","deleteTable":"Supprimer le tableau"}}}');


var $9574c61a4d59ba31$exports = {};
$9574c61a4d59ba31$exports = JSON.parse('{"title":"R\xf4les de l\'\xe9quipe {{team}}","titleUnnamed":"R\xf4les","caption":"Les r\xf4les regroupent les membres de cette \xe9quipe, comme \xab Cam\xe9raman \xbb ou \xab Accueil \xbb. Un b\xe9n\xe9vole peut en avoir plusieurs.","newRolePlaceholder":"Nom du nouveau r\xf4le","addRole":"Ajouter un r\xf4le","adding":"Ajout...","duplicateName":"Cette \xe9quipe a d\xe9j\xe0 un r\xf4le portant ce nom.","duplicateNamed":"Cette \xe9quipe a d\xe9j\xe0 un r\xf4le nomm\xe9 \xab {{name}} \xbb.","createFailed":"Impossible de cr\xe9er ce r\xf4le pour le moment.","empty":"Aucun r\xf4le pour l\'instant. Ajoutez-en un ci-dessus pour commencer \xe0 organiser cette \xe9quipe.","volunteers_one":"{{count}} b\xe9n\xe9vole","volunteers_other":"{{count}} b\xe9n\xe9voles","trainingTitle":"Formation pour {{role}}","trainingEmpty":"Aucune formation pour l\'instant. Rien n\'est assign\xe9 aux personnes qui re\xe7oivent ce r\xf4le.","dueInBefore":"\xc0 faire dans","dueInAfter":"jours","dueInLabel":"Jours pour terminer {{module}}","stopAssigning":"Ne plus assigner {{module}}","invalidWindow":"Chaque d\xe9lai doit \xeatre un nombre entier de jours, de {{min}} \xe0 {{max}}.","addModule":"Ajouter un module de formation","addModuleOption":"Ajouter un module de formation\u2026","noModules":"Cette \xe9glise n\'a encore aucun module de formation.","trainingCaptionHolders_one":"Modifier les formations assign\xe9es \xe0 un r\xf4le assignera automatiquement le module ajout\xe9 au b\xe9n\xe9vole qui a ce r\xf4le actuellement.","trainingCaptionHolders_other":"Modifier les formations assign\xe9es \xe0 un r\xf4le assignera automatiquement le module ajout\xe9 aux {{count}} b\xe9n\xe9voles qui ont ce r\xf4le actuellement.","trainingCaptionNoHolders":"Modifier les formations assign\xe9es \xe0 un r\xf4le assignera automatiquement le module ajout\xe9 \xe0 toute personne qui recevra ce r\xf4le plus tard.","renameLabel":"Renommer {{role}}","deleteLabel":"Supprimer {{role}}","deleteConfirm":"Supprimer {{role}} ?","deleteHolders_one":"Il sera retir\xe9 \xe0 {{count}} b\xe9n\xe9vole.","deleteHolders_other":"Il sera retir\xe9 \xe0 {{count}} b\xe9n\xe9voles.","deleteNoHolders":"Personne n\'a ce r\xf4le.","delete":"Supprimer","deleting":"Suppression...","summaryCount_one":"Assigne {{count}} module de formation","summaryCount_other":"Assigne {{count}} modules de formation","summaryList":"Assigne {{list}}","summaryItem_one":"{{module}} ({{count}} jour)","summaryItem_other":"{{module}} ({{count}} jours)","listSeparator":", ","unknownModule":"Module inconnu","assignedPart_one":"{{module}} \xe0 {{count}} b\xe9n\xe9vole","assignedPart_other":"{{module}} \xe0 {{count}} b\xe9n\xe9voles","assignedNotice":"Assign\xe9 : {{parts}}.","assignedJoiner":" et "}');


var $8ad3e72e12620613$exports = {};
$8ad3e72e12620613$exports = JSON.parse('{"newTitle":"Nouveau module","editTitle":"Modifier le module","saveLabel":"Enregistrer le module","savingLabel":"Enregistrement","titleLabel":"Titre","titlePlaceholder":"Titre du module","descriptionLabel":"Description","descriptionPlaceholder":"Ce que couvre ce module","thumbnailLabel":"Miniature","keepCurrentImage":"Conserver l\'image actuelle","clearImage":"Effacer","campusLabel":"Campus","campusPlaceholder":"Choisir un campus","categoryLabel":"Cat\xe9gorie","categoryPlaceholder":"Choisir une cat\xe9gorie","uploadTargetFailed":"Impossible de pr\xe9parer le t\xe9l\xe9versement de la miniature.","uploadFailed":"Le t\xe9l\xe9versement de la miniature a \xe9chou\xe9. Veuillez r\xe9essayer."}');


var $ca1de925b1d692b7$exports = {};
$ca1de925b1d692b7$exports = JSON.parse('{"title":"Retirer le b\xe9n\xe9vole","confirm":"Retirer {{person}} de l\'\xe9quipe {{team}} ?","confirmUnnamed":"Retirer ce b\xe9n\xe9vole de cette \xe9quipe ?","caption":"Cette personne ne sera pas supprim\xe9e de la liste des personnes de votre \xe9glise. Vous pourrez l\'inviter \xe0 nouveau dans cette \xe9quipe \xe0 tout moment.","remove":"Retirer de l\'\xe9quipe","removing":"Retrait\u2026"}');


var $43acd798940ea6a8$exports = {};
$43acd798940ea6a8$exports = JSON.parse('{"heading":"Modules","newModule":"Nouveau module","emptyTitle":"Aucun module pour l\'instant","emptyMessage":"Cr\xe9ez un module de formation pour commencer.","retry":"R\xe9essayer","unknownCampus":"Campus inconnu","unknownCategory":"Cat\xe9gorie inconnue"}');


var $57b748c4c6561e8b$exports = {};
$57b748c4c6561e8b$exports = JSON.parse('{"retry":"R\xe9essayer","notFound":"Module de formation introuvable.","backToTraining":"Retour \xe0 la formation","edit":"Modifier","lessonsHeading":"Le\xe7ons","newLesson":"Nouvelle le\xe7on","emptyTitle":"Aucune le\xe7on","emptyMessage":"Ajoutez une le\xe7on \xe0 ce module pour commencer.","videoProcessing":"En traitement","videoFailed":"\xc9chec de la vid\xe9o","video":"Vid\xe9o"}');


var $0d86076a13e5c251$exports = {};
$0d86076a13e5c251$exports = JSON.parse('{"fallbackName":"B\xe9n\xe9vole","details":"D\xe9tails","retry":"R\xe9essayer","assignedHeading":"Formations assign\xe9es","assignTraining":"Assigner une formation","emptyTitle":"Aucune formation assign\xe9e","emptyMessage":"Aucun module de formation n\'a encore \xe9t\xe9 assign\xe9 \xe0 {{person}}.","anotherTeam":"Une autre \xe9quipe","unavailableModule":"Module indisponible","moduleUnavailable":"Ce module de formation n\'est plus disponible.","completed":"Termin\xe9","lessonsComplete_one":"{{count}} le\xe7on termin\xe9e","lessonsComplete_other":"{{count}} le\xe7ons termin\xe9es","notStarted":"Pas commenc\xe9","due":"\xc0 faire d\'ici le {{date}}","overdue":"En retard depuis le {{date}}","via":"via {{team}}"}');


var $380a9ad6b3128756$exports = {};
$380a9ad6b3128756$exports = JSON.parse('{"tabs":{"title":"B\xe9n\xe9volat","teams":"\xc9quipes","trainingModules":"Modules de formation"},"teams":{"heading":"\xc9quipes","newTeam":"Nouvelle \xe9quipe","emptyTitle":"Aucune \xe9quipe pour l\'instant","emptyMessage":"Cr\xe9ez une \xe9quipe de b\xe9n\xe9voles pour commencer."},"team":{"loadFailedTitle":"Impossible de charger l\'\xe9quipe","loadFailedMessage":"Cette \xe9quipe a peut-\xeatre \xe9t\xe9 supprim\xe9e.","backToTeams":"Retour aux \xe9quipes","noMembers":"Aucun b\xe9n\xe9vole dans cette \xe9quipe. Invitez un b\xe9n\xe9vole pour commencer.","viewAll_one":"Voir {{count}} b\xe9n\xe9vole","viewAll_other":"Voir les {{count}} b\xe9n\xe9voles","roles":"R\xf4les","editTeam":"Modifier l\'\xe9quipe","inviteVolunteer":"Inviter un b\xe9n\xe9vole","unknownPerson":"Inconnu"},"menu":{"details":"D\xe9tails","editRoles":"Modifier les r\xf4les","assignedTraining":"Formations assign\xe9es","removeFromTeam":"Retirer de l\'\xe9quipe"},"rolePicker":{"label":"R\xf4les"},"errors":{"loadTeams":"Impossible de charger les \xe9quipes.","loadTeam":"Impossible de charger cette \xe9quipe.","loadTrainingModules":"Impossible de charger les modules de formation.","loadTrainingModule":"Impossible de charger ce module de formation.","loadAssignedTraining":"Impossible de charger les formations assign\xe9es.","missingChurch":"Contexte d\'\xe9glise manquant. Veuillez actualiser la page et r\xe9essayer."},"common":{"close":"Fermer","save":"Enregistrer","saving":"Enregistrement\u2026","done":"Termin\xe9","cancel":"Annuler","tryAgain":"R\xe9essayer","back":"Retour","loading":"Chargement\u2026"}}');


var $f817a976a4250acf$exports = {};
$f817a976a4250acf$exports = JSON.parse('{"searchPlaceholder":"Rechercher par pr\xe9nom ou courriel","emailLabel":"Courriel","emailPlaceholder":"nom@exemple.com"}');


const $a23744eec8a25876$export$bc99aaabaf7b70a7 = {
    en: {
        assignTraining: (0, (/*@__PURE__*/$parcel$interopDefault($2436233380b6882f$exports))),
        createTeam: (0, (/*@__PURE__*/$parcel$interopDefault($c002470d02ce3cd4$exports))),
        editMemberRoles: (0, (/*@__PURE__*/$parcel$interopDefault($d29049e066501c72$exports))),
        editTeam: (0, (/*@__PURE__*/$parcel$interopDefault($643840e186bf6773$exports))),
        inviteVolunteer: (0, (/*@__PURE__*/$parcel$interopDefault($eaaca7f238397659$exports))),
        lessonEditor: (0, (/*@__PURE__*/$parcel$interopDefault($cb96ede08269c00c$exports))),
        manageRoles: (0, (/*@__PURE__*/$parcel$interopDefault($88755a45f9c709c9$exports))),
        moduleEditor: (0, (/*@__PURE__*/$parcel$interopDefault($02db604409e3f38e$exports))),
        removeVolunteer: (0, (/*@__PURE__*/$parcel$interopDefault($d9d34482b0518e71$exports))),
        training: (0, (/*@__PURE__*/$parcel$interopDefault($4ceee968c3e3d346$exports))),
        trainingModule: (0, (/*@__PURE__*/$parcel$interopDefault($bdfa45a60b7acd50$exports))),
        volunteer: (0, (/*@__PURE__*/$parcel$interopDefault($ff480a0c679a69fc$exports))),
        volunteering: (0, (/*@__PURE__*/$parcel$interopDefault($8195002cbf826711$exports)))
    },
    fr: {
        assignTraining: (0, (/*@__PURE__*/$parcel$interopDefault($98fe2de48f0912bd$exports))),
        createTeam: (0, (/*@__PURE__*/$parcel$interopDefault($db4f007afb1ecb03$exports))),
        editMemberRoles: (0, (/*@__PURE__*/$parcel$interopDefault($fe25728064163779$exports))),
        editTeam: (0, (/*@__PURE__*/$parcel$interopDefault($f52f7cd013f24acc$exports))),
        inviteVolunteer: (0, (/*@__PURE__*/$parcel$interopDefault($49553acc9a509a26$exports))),
        lessonEditor: (0, (/*@__PURE__*/$parcel$interopDefault($53bb430a43a21e3b$exports))),
        manageRoles: (0, (/*@__PURE__*/$parcel$interopDefault($9574c61a4d59ba31$exports))),
        moduleEditor: (0, (/*@__PURE__*/$parcel$interopDefault($8ad3e72e12620613$exports))),
        removeVolunteer: (0, (/*@__PURE__*/$parcel$interopDefault($ca1de925b1d692b7$exports))),
        training: (0, (/*@__PURE__*/$parcel$interopDefault($43acd798940ea6a8$exports))),
        trainingModule: (0, (/*@__PURE__*/$parcel$interopDefault($57b748c4c6561e8b$exports))),
        volunteer: (0, (/*@__PURE__*/$parcel$interopDefault($0d86076a13e5c251$exports))),
        volunteering: (0, (/*@__PURE__*/$parcel$interopDefault($380a9ad6b3128756$exports)))
    },
    'fr-CA': {
        inviteVolunteer: (0, (/*@__PURE__*/$parcel$interopDefault($f817a976a4250acf$exports)))
    }
};
const $a23744eec8a25876$export$7c77c3a9bb93870d = [
    'en',
    'fr',
    'fr-CA'
];
const $a23744eec8a25876$export$4d2fb7344096e022 = [
    'assignTraining',
    'createTeam',
    'editMemberRoles',
    'editTeam',
    'inviteVolunteer',
    'lessonEditor',
    'manageRoles',
    'moduleEditor',
    'removeVolunteer',
    'training',
    'trainingModule',
    'volunteer',
    'volunteering'
];
(0, $2Bwgd.default).use((0, $f73f86de2138df56$export$2e2bcd8739ae039)).use((0, $09536692873e4879$export$ae7e14d40d89f296)).init({
    resources: $a23744eec8a25876$export$bc99aaabaf7b70a7,
    ns: $a23744eec8a25876$export$4d2fb7344096e022,
    defaultNS: 'volunteering',
    supportedLngs: $a23744eec8a25876$export$7c77c3a9bb93870d,
    nonExplicitSupportedLngs: true,
    fallbackLng: {
        'fr-CA': [
            'fr',
            'en'
        ],
        default: [
            'en'
        ]
    },
    // fr-CA ships only the namespaces it overrides, so a missing key must fall
    // through to fr rather than resolving to an empty string.
    fallbackNS: false,
    returnEmptyString: false,
    // See i18next.d.ts.
    returnNull: false,
    interpolation: {
        // React already escapes rendered values.
        escapeValue: false
    },
    detection: {
        // ?lang=fr is handy for QA and for reviewing a translation.
        order: [
            'querystring',
            'localStorage',
            'navigator'
        ],
        lookupQuerystring: 'lang',
        lookupLocalStorage: 'lang',
        caches: [
            'localStorage'
        ]
    }
});
// Keep <html lang> in step with the active language for screen readers,
// browser translation prompts, and correct hyphenation.
function $a23744eec8a25876$var$syncDocumentLang(lng) {
    document.documentElement.lang = lng;
}
var $a23744eec8a25876$var$_i18n_resolvedLanguage;
$a23744eec8a25876$var$syncDocumentLang(($a23744eec8a25876$var$_i18n_resolvedLanguage = (0, $2Bwgd.default).resolvedLanguage) !== null && $a23744eec8a25876$var$_i18n_resolvedLanguage !== void 0 ? $a23744eec8a25876$var$_i18n_resolvedLanguage : 'en');
(0, $2Bwgd.default).on('languageChanged', $a23744eec8a25876$var$syncDocumentLang);
var $a23744eec8a25876$export$2e2bcd8739ae039 = (0, $2Bwgd.default);


/**
 * React Router v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");
/**
 * @remix-run/router v1.23.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $55100129ab36ed65$var$_extends() {
    $55100129ab36ed65$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55100129ab36ed65$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $55100129ab36ed65$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($55100129ab36ed65$export$e19cd5f9376f8cee || ($55100129ab36ed65$export$e19cd5f9376f8cee = {}));
const $55100129ab36ed65$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $55100129ab36ed65$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $55100129ab36ed65$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $55100129ab36ed65$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $55100129ab36ed65$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $55100129ab36ed65$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $55100129ab36ed65$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $55100129ab36ed65$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $55100129ab36ed65$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $55100129ab36ed65$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $55100129ab36ed65$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $55100129ab36ed65$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $55100129ab36ed65$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $55100129ab36ed65$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $55100129ab36ed65$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $55100129ab36ed65$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $55100129ab36ed65$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $55100129ab36ed65$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $55100129ab36ed65$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($55100129ab36ed65$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let location = $55100129ab36ed65$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $55100129ab36ed65$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $55100129ab36ed65$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $55100129ab36ed65$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($55100129ab36ed65$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $55100129ab36ed65$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($55100129ab36ed65$var$ResultType || ($55100129ab36ed65$var$ResultType = {}));
const $55100129ab36ed65$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $55100129ab36ed65$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $55100129ab36ed65$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $55100129ab36ed65$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($55100129ab36ed65$var$isIndexRoute(route)) {
            let indexRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $55100129ab36ed65$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $55100129ab36ed65$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $55100129ab36ed65$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $55100129ab36ed65$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $55100129ab36ed65$var$flattenRoutes(routes);
    $55100129ab36ed65$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $55100129ab36ed65$export$30d21fd6d7295f52(pathname);
        matches = $55100129ab36ed65$var$matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function $55100129ab36ed65$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $55100129ab36ed65$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $55100129ab36ed65$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $55100129ab36ed65$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $55100129ab36ed65$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $55100129ab36ed65$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $55100129ab36ed65$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $55100129ab36ed65$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $55100129ab36ed65$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $55100129ab36ed65$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $55100129ab36ed65$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $55100129ab36ed65$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $55100129ab36ed65$var$paramRe = /^:[\w-]+$/;
const $55100129ab36ed65$var$dynamicSegmentValue = 3;
const $55100129ab36ed65$var$indexRouteValue = 2;
const $55100129ab36ed65$var$emptySegmentValue = 1;
const $55100129ab36ed65$var$staticSegmentValue = 10;
const $55100129ab36ed65$var$splatPenalty = -2;
const $55100129ab36ed65$var$isSplat = (s)=>s === "*";
function $55100129ab36ed65$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($55100129ab36ed65$var$isSplat)) initialScore += $55100129ab36ed65$var$splatPenalty;
    if (index) initialScore += $55100129ab36ed65$var$indexRouteValue;
    return segments.filter((s)=>!$55100129ab36ed65$var$isSplat(s)).reduce((score, segment)=>score + ($55100129ab36ed65$var$paramRe.test(segment) ? $55100129ab36ed65$var$dynamicSegmentValue : segment === "" ? $55100129ab36ed65$var$emptySegmentValue : $55100129ab36ed65$var$staticSegmentValue), initialScore);
}
function $55100129ab36ed65$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $55100129ab36ed65$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $55100129ab36ed65$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $55100129ab36ed65$export$a5c6d149b50c1d86($55100129ab36ed65$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $55100129ab36ed65$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $55100129ab36ed65$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $55100129ab36ed65$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $55100129ab36ed65$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $55100129ab36ed65$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $55100129ab36ed65$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $55100129ab36ed65$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $55100129ab36ed65$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $55100129ab36ed65$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $55100129ab36ed65$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$isAbsoluteUrl = (url)=>$55100129ab36ed65$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($55100129ab36ed65$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                $55100129ab36ed65$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $55100129ab36ed65$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $55100129ab36ed65$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $55100129ab36ed65$var$normalizeSearch(search),
        hash: $55100129ab36ed65$var$normalizeHash(hash)
    };
}
function $55100129ab36ed65$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $55100129ab36ed65$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $55100129ab36ed65$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $55100129ab36ed65$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $55100129ab36ed65$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $55100129ab36ed65$export$8ccf933b0513f8d0(toArg);
    else {
        to = $55100129ab36ed65$var$_extends({}, toArg);
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $55100129ab36ed65$var$getInvalidPathError("?", "pathname", "search", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "pathname", "hash", to));
        $55100129ab36ed65$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $55100129ab36ed65$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $55100129ab36ed65$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $55100129ab36ed65$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $55100129ab36ed65$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $55100129ab36ed65$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $55100129ab36ed65$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $55100129ab36ed65$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $55100129ab36ed65$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $55100129ab36ed65$export$4051a07651545597(data, init) {
    return new $55100129ab36ed65$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $55100129ab36ed65$export$42a99a7a4bc0e76a extends Error {
}
class $55100129ab36ed65$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $55100129ab36ed65$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $55100129ab36ed65$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $55100129ab36ed65$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $55100129ab36ed65$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $55100129ab36ed65$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $55100129ab36ed65$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $55100129ab36ed65$var$unwrapTrackedPromise(value) {
    if (!$55100129ab36ed65$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $55100129ab36ed65$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $55100129ab36ed65$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $55100129ab36ed65$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $55100129ab36ed65$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $55100129ab36ed65$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $55100129ab36ed65$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $55100129ab36ed65$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $55100129ab36ed65$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $55100129ab36ed65$var$validMutationMethods = new Set($55100129ab36ed65$var$validMutationMethodsArr);
const $55100129ab36ed65$var$validRequestMethodsArr = [
    "get",
    ...$55100129ab36ed65$var$validMutationMethodsArr
];
const $55100129ab36ed65$var$validRequestMethods = new Set($55100129ab36ed65$var$validRequestMethodsArr);
const $55100129ab36ed65$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $55100129ab36ed65$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $55100129ab36ed65$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $55100129ab36ed65$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $55100129ab36ed65$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $55100129ab36ed65$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $55100129ab36ed65$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $55100129ab36ed65$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $55100129ab36ed65$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$55100129ab36ed65$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $55100129ab36ed65$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $55100129ab36ed65$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$55100129ab36ed65$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($55100129ab36ed65$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $55100129ab36ed65$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $55100129ab36ed65$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $55100129ab36ed65$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $55100129ab36ed65$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $55100129ab36ed65$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($55100129ab36ed65$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $55100129ab36ed65$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $55100129ab36ed65$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $55100129ab36ed65$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $55100129ab36ed65$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $55100129ab36ed65$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $55100129ab36ed65$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $55100129ab36ed65$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $55100129ab36ed65$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $55100129ab36ed65$var$findNearestBoundary(matches).route.id,
            {
                type: $55100129ab36ed65$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $55100129ab36ed65$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($55100129ab36ed65$var$isErrorResult(result) && $55100129ab36ed65$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $55100129ab36ed65$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $55100129ab36ed65$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $55100129ab36ed65$var$_extends({
            matches: updatedMatches || matches
        }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $55100129ab36ed65$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $55100129ab36ed65$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $55100129ab36ed65$var$ResultType.error,
            error: $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $55100129ab36ed65$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($55100129ab36ed65$var$isDeferredResult(result)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $55100129ab36ed65$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $55100129ab36ed65$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($55100129ab36ed65$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $55100129ab36ed65$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $55100129ab36ed65$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $55100129ab36ed65$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $55100129ab36ed65$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $55100129ab36ed65$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $55100129ab36ed65$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $55100129ab36ed65$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult) || $55100129ab36ed65$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($55100129ab36ed65$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($55100129ab36ed65$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($55100129ab36ed65$var$isDeferredResult(actionResult)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $55100129ab36ed65$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $55100129ab36ed65$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $55100129ab36ed65$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $55100129ab36ed65$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $55100129ab36ed65$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $55100129ab36ed65$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $55100129ab36ed65$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $55100129ab36ed65$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $55100129ab36ed65$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $55100129ab36ed65$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $55100129ab36ed65$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $55100129ab36ed65$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $55100129ab36ed65$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($55100129ab36ed65$var$isDeferredResult(result)) result = await $55100129ab36ed65$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($55100129ab36ed65$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $55100129ab36ed65$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $55100129ab36ed65$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $55100129ab36ed65$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $55100129ab36ed65$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $55100129ab36ed65$export$e19cd5f9376f8cee.Replace : $55100129ab36ed65$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $55100129ab36ed65$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($55100129ab36ed65$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $55100129ab36ed65$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $55100129ab36ed65$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $55100129ab36ed65$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $55100129ab36ed65$var$ResultType.redirect,
                response: $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $55100129ab36ed65$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: $55100129ab36ed65$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $55100129ab36ed65$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $55100129ab36ed65$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $55100129ab36ed65$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $55100129ab36ed65$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $55100129ab36ed65$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $55100129ab36ed65$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$55100129ab36ed65$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $55100129ab36ed65$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $55100129ab36ed65$export$4d0306f8f6a4585b = Symbol("deferred");
function $55100129ab36ed65$export$3336b097a6fbc59a(routes, opts) {
    $55100129ab36ed65$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $55100129ab36ed65$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $55100129ab36ed65$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD") {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $55100129ab36ed65$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $55100129ab36ed65$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $55100129ab36ed65$var$createLocation("", $55100129ab36ed65$export$fe53371bee54353d(url), null, "default");
        let matches = $55100129ab36ed65$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$55100129ab36ed65$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $55100129ab36ed65$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $55100129ab36ed65$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $55100129ab36ed65$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $55100129ab36ed65$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($55100129ab36ed65$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$55100129ab36ed65$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $55100129ab36ed65$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($55100129ab36ed65$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $55100129ab36ed65$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $55100129ab36ed65$var$isResponse(result) ? result : $55100129ab36ed65$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($55100129ab36ed65$var$isDataStrategyResult(e) && $55100129ab36ed65$var$isResponse(e.result)) {
                if (e.type === $55100129ab36ed65$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($55100129ab36ed65$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $55100129ab36ed65$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($55100129ab36ed65$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            let error = $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $55100129ab36ed65$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($55100129ab36ed65$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $55100129ab36ed65$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $55100129ab36ed65$var$_extends({}, context, {
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $55100129ab36ed65$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $55100129ab36ed65$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $55100129ab36ed65$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $55100129ab36ed65$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $55100129ab36ed65$var$callDataStrategyImpl(dataStrategy || $55100129ab36ed65$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($55100129ab36ed65$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($55100129ab36ed65$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $55100129ab36ed65$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $55100129ab36ed65$export$fec11da027c70692(routes, context, error) {
    let newContext = $55100129ab36ed65$var$_extends({}, context, {
        statusCode: $55100129ab36ed65$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $55100129ab36ed65$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $55100129ab36ed65$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $55100129ab36ed65$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $55100129ab36ed65$export$cae722b0cc860f13(to ? to : ".", $55100129ab36ed65$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $55100129ab36ed65$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $55100129ab36ed65$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $55100129ab36ed65$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $55100129ab36ed65$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $55100129ab36ed65$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$55100129ab36ed65$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$55100129ab36ed65$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $55100129ab36ed65$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $55100129ab36ed65$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $55100129ab36ed65$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$55100129ab36ed65$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $55100129ab36ed65$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $55100129ab36ed65$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($55100129ab36ed65$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $55100129ab36ed65$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $55100129ab36ed65$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $55100129ab36ed65$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $55100129ab36ed65$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $55100129ab36ed65$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($55100129ab36ed65$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $55100129ab36ed65$var$shouldRevalidateLoader(match, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $55100129ab36ed65$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $55100129ab36ed65$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $55100129ab36ed65$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $55100129ab36ed65$var$shouldRevalidateLoader(fetcherMatch, $55100129ab36ed65$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $55100129ab36ed65$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $55100129ab36ed65$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $55100129ab36ed65$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $55100129ab36ed65$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $55100129ab36ed65$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$55100129ab36ed65$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $55100129ab36ed65$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $55100129ab36ed65$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$55100129ab36ed65$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $55100129ab36ed65$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $55100129ab36ed65$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $55100129ab36ed65$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$55100129ab36ed65$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $55100129ab36ed65$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $55100129ab36ed65$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $55100129ab36ed65$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $55100129ab36ed65$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $55100129ab36ed65$var$ResultType.data,
                result: undefined
            });
        };
        return $55100129ab36ed65$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $55100129ab36ed65$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $55100129ab36ed65$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $55100129ab36ed65$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $55100129ab36ed65$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $55100129ab36ed65$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $55100129ab36ed65$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($55100129ab36ed65$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: e
            };
        }
        if (type === $55100129ab36ed65$var$ResultType.error) return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: new $55100129ab36ed65$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $55100129ab36ed65$var$ResultType.error) {
        if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $55100129ab36ed65$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $55100129ab36ed65$var$ResultType.error,
                error: new $55100129ab36ed65$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: result,
            statusCode: $55100129ab36ed65$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($55100129ab36ed65$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $55100129ab36ed65$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($55100129ab36ed65$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $55100129ab36ed65$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $55100129ab36ed65$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $55100129ab36ed65$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $55100129ab36ed65$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($55100129ab36ed65$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $55100129ab36ed65$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $55100129ab36ed65$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($55100129ab36ed65$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $55100129ab36ed65$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $55100129ab36ed65$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $55100129ab36ed65$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $55100129ab36ed65$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $55100129ab36ed65$export$3e9cee6b33872309(!$55100129ab36ed65$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($55100129ab36ed65$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $55100129ab36ed65$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($55100129ab36ed65$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $55100129ab36ed65$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $55100129ab36ed65$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $55100129ab36ed65$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($55100129ab36ed65$var$isErrorResult(result)) {
            let boundaryMatch = $55100129ab36ed65$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $55100129ab36ed65$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($55100129ab36ed65$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($55100129ab36ed65$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $55100129ab36ed65$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $55100129ab36ed65$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $55100129ab36ed65$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $55100129ab36ed65$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $55100129ab36ed65$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $55100129ab36ed65$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $55100129ab36ed65$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $55100129ab36ed65$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $55100129ab36ed65$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $55100129ab36ed65$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $55100129ab36ed65$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($55100129ab36ed65$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $55100129ab36ed65$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(path) : path;
    return $55100129ab36ed65$export$fe53371bee54353d($55100129ab36ed65$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $55100129ab36ed65$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $55100129ab36ed65$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $55100129ab36ed65$var$ResultType.data || result.type === $55100129ab36ed65$var$ResultType.error);
}
function $55100129ab36ed65$var$isRedirectDataStrategyResultResult(result) {
    return $55100129ab36ed65$var$isResponse(result.result) && $55100129ab36ed65$var$redirectStatusCodes.has(result.result.status);
}
function $55100129ab36ed65$var$isDeferredResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.deferred;
}
function $55100129ab36ed65$var$isErrorResult(result) {
    return result.type === $55100129ab36ed65$var$ResultType.error;
}
function $55100129ab36ed65$var$isRedirectResult(result) {
    return (result && result.type) === $55100129ab36ed65$var$ResultType.redirect;
}
function $55100129ab36ed65$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $55100129ab36ed65$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $55100129ab36ed65$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $55100129ab36ed65$var$isRedirectResponse(result) {
    if (!$55100129ab36ed65$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $55100129ab36ed65$var$isValidMethod(method) {
    return $55100129ab36ed65$var$validRequestMethods.has(method.toLowerCase());
}
function $55100129ab36ed65$var$isMutationMethod(method) {
    return $55100129ab36ed65$var$validMutationMethods.has(method.toLowerCase());
}
async function $55100129ab36ed65$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$55100129ab36ed65$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($55100129ab36ed65$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $55100129ab36ed65$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $55100129ab36ed65$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($55100129ab36ed65$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $55100129ab36ed65$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $55100129ab36ed65$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $55100129ab36ed65$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $55100129ab36ed65$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $55100129ab36ed65$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $55100129ab36ed65$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $55100129ab36ed65$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $55100129ab36ed65$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $55100129ab36ed65$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $55100129ab36ed65$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $55100129ab36ed65$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $55100129ab36ed65$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $55100129ab36ed65$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $55100129ab36ed65$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $55100129ab36ed65$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $55100129ab36ed65$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $55100129ab36ed65$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $55100129ab36ed65$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $55100129ab36ed65$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($55100129ab36ed65$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $55100129ab36ed65$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}


function $d9fd026bfea79ab9$var$_extends() {
    $d9fd026bfea79ab9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d9fd026bfea79ab9$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $d9fd026bfea79ab9$export$3add0d5dce533e2e = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$145dfa71566a64dc = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$var$AwaitContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $d9fd026bfea79ab9$export$26749e8557646306 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$c7914228fb69b0f5 = /*#__PURE__*/ $7fPBF.createContext(null);
const $d9fd026bfea79ab9$export$9072aa6dd1f93057 = /*#__PURE__*/ $7fPBF.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $d9fd026bfea79ab9$var$RouteErrorContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $d9fd026bfea79ab9$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $d9fd026bfea79ab9$export$9c954a9d03d32f4a() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $d9fd026bfea79ab9$export$45d76561a5302f2b() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $d9fd026bfea79ab9$export$1b3f31771c5d07c() {
    return $7fPBF.useContext($d9fd026bfea79ab9$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $d9fd026bfea79ab9$export$6c330e8992e8a295(pattern) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$81336c211d5ff295)(pattern, (0, $55100129ab36ed65$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $d9fd026bfea79ab9$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $7fPBF.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $d9fd026bfea79ab9$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $d9fd026bfea79ab9$var$useNavigateStable() : $d9fd026bfea79ab9$var$useNavigateUnstable();
}
function $d9fd026bfea79ab9$var$useNavigateUnstable() {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$OutletContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $d9fd026bfea79ab9$export$4138103a3ae699cc() {
    return $7fPBF.useContext($d9fd026bfea79ab9$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $d9fd026bfea79ab9$export$a3be3530d8e40d0b(context) {
    let outlet = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $d9fd026bfea79ab9$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $d9fd026bfea79ab9$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $7fPBF.useMemo(()=>(0, $55100129ab36ed65$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $d9fd026bfea79ab9$export$5d3fca4a98652595(routes, locationArg) {
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: parentMatches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $55100129ab36ed65$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $d9fd026bfea79ab9$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $d9fd026bfea79ab9$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $d9fd026bfea79ab9$var$DefaultErrorComponent() {
    let error = $d9fd026bfea79ab9$export$ed527bf60f6e05f2();
    let message = (0, $55100129ab36ed65$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $7fPBF.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $7fPBF.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $d9fd026bfea79ab9$var$defaultErrorElement = /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DefaultErrorComponent, null);
class $d9fd026bfea79ab9$var$RenderErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $d9fd026bfea79ab9$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $d9fd026bfea79ab9$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $d9fd026bfea79ab9$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $d9fd026bfea79ab9$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $7fPBF.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $d9fd026bfea79ab9$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($d9fd026bfea79ab9$var$DataRouterHook || {});
var $d9fd026bfea79ab9$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($d9fd026bfea79ab9$var$DataRouterStateHook || {});
function $d9fd026bfea79ab9$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $d9fd026bfea79ab9$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext($d9fd026bfea79ab9$export$3add0d5dce533e2e);
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $d9fd026bfea79ab9$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext($d9fd026bfea79ab9$export$145dfa71566a64dc);
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
function $d9fd026bfea79ab9$var$useRouteContext(hookName) {
    let route = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $d9fd026bfea79ab9$var$useCurrentRouteId(hookName) {
    let route = $d9fd026bfea79ab9$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $d9fd026bfea79ab9$export$5fc8298006ad9e58() {
    return $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $d9fd026bfea79ab9$export$d0fd4b7106de2769() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $d9fd026bfea79ab9$export$600dc272ed516c15() {
    let dataRouterContext = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseRevalidator);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRevalidator);
    return $7fPBF.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $d9fd026bfea79ab9$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseMatches);
    return $7fPBF.useMemo(()=>matches.map((m)=>(0, $55100129ab36ed65$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $d9fd026bfea79ab9$export$1448a5050d252c4d() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $d9fd026bfea79ab9$export$fd5d37484eab868d(routeId) {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $d9fd026bfea79ab9$export$fdc00f3f26066d5e() {
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseActionData);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $d9fd026bfea79ab9$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $7fPBF.useContext($d9fd026bfea79ab9$var$RouteErrorContext);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    let routeId = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$78a72ddb39bdd145() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $d9fd026bfea79ab9$export$17f53340677d5831() {
    let value = $7fPBF.useContext($d9fd026bfea79ab9$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $d9fd026bfea79ab9$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $d9fd026bfea79ab9$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseBlocker);
    let state = $d9fd026bfea79ab9$var$useDataRouterState($d9fd026bfea79ab9$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $7fPBF.useState("");
    let blockerFunction = $7fPBF.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $d9fd026bfea79ab9$var$_extends({}, currentLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $d9fd026bfea79ab9$var$_extends({}, nextLocation, {
                pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $7fPBF.useEffect(()=>{
        let key = String(++$d9fd026bfea79ab9$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $7fPBF.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $55100129ab36ed65$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $d9fd026bfea79ab9$var$useNavigateStable() {
    let { router: router } = $d9fd026bfea79ab9$var$useDataRouterContext($d9fd026bfea79ab9$var$DataRouterHook.UseNavigateStable);
    let id = $d9fd026bfea79ab9$var$useCurrentRouteId($d9fd026bfea79ab9$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $7fPBF.useRef(false);
    $d9fd026bfea79ab9$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $7fPBF.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $d9fd026bfea79ab9$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $d9fd026bfea79ab9$var$alreadyWarned$1 = {};
function $d9fd026bfea79ab9$var$warningOnce(key, cond, message) {
    if (!cond && !$d9fd026bfea79ab9$var$alreadyWarned$1[key]) $d9fd026bfea79ab9$var$alreadyWarned$1[key] = true;
}
const $d9fd026bfea79ab9$var$alreadyWarned = {};
function $d9fd026bfea79ab9$var$warnOnce(key, message) {}
const $d9fd026bfea79ab9$var$logDeprecation = (flag, msg, link)=>$d9fd026bfea79ab9$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $d9fd026bfea79ab9$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $d9fd026bfea79ab9$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $d9fd026bfea79ab9$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $d9fd026bfea79ab9$var$START_TRANSITION = "startTransition";
const $d9fd026bfea79ab9$var$startTransitionImpl = $7fPBF[$d9fd026bfea79ab9$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $d9fd026bfea79ab9$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        if (v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl) $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $d9fd026bfea79ab9$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $d9fd026bfea79ab9$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $d9fd026bfea79ab9$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $d9fd026bfea79ab9$var$startTransitionImpl ? $d9fd026bfea79ab9$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>$d9fd026bfea79ab9$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $d9fd026bfea79ab9$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $7fPBF.useContext($d9fd026bfea79ab9$export$26749e8557646306);
    let { matches: matches } = $7fPBF.useContext($d9fd026bfea79ab9$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $d9fd026bfea79ab9$export$45d76561a5302f2b();
    let navigate = $d9fd026bfea79ab9$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $55100129ab36ed65$export$cae722b0cc860f13)(to, (0, $55100129ab36ed65$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $7fPBF.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $d9fd026bfea79ab9$export$910ae8079b2c2852(props) {
    return $d9fd026bfea79ab9$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $d9fd026bfea79ab9$export$e7b0ac011bb776c6(_props) {
    (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $d9fd026bfea79ab9$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $55100129ab36ed65$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$d9fd026bfea79ab9$export$9c954a9d03d32f4a() && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $7fPBF.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $d9fd026bfea79ab9$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $55100129ab36ed65$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $7fPBF.useMemo(()=>{
        let trailingPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $d9fd026bfea79ab9$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $d9fd026bfea79ab9$export$5d3fca4a98652595($d9fd026bfea79ab9$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $d9fd026bfea79ab9$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$ResolveAwait, null, children));
}
var $d9fd026bfea79ab9$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($d9fd026bfea79ab9$var$AwaitRenderStatus || {});
const $d9fd026bfea79ab9$var$neverSettledPromise = new Promise(()=>{});
class $d9fd026bfea79ab9$var$AwaitErrorBoundary extends $7fPBF.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.error : "_data" in promise ? $d9fd026bfea79ab9$var$AwaitRenderStatus.success : $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $d9fd026bfea79ab9$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && promise._error instanceof (0, $55100129ab36ed65$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $d9fd026bfea79ab9$var$neverSettledPromise;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $d9fd026bfea79ab9$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $7fPBF.createElement($d9fd026bfea79ab9$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $d9fd026bfea79ab9$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $d9fd026bfea79ab9$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $d9fd026bfea79ab9$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $7fPBF.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $7fPBF.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $7fPBF.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $d9fd026bfea79ab9$export$e7b0ac011bb776c6) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $d9fd026bfea79ab9$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $d9fd026bfea79ab9$export$daf73786167a7f72(matches) {
    return $d9fd026bfea79ab9$var$_renderMatches(matches);
}
function $d9fd026bfea79ab9$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $7fPBF.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $7fPBF.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $7fPBF.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $d9fd026bfea79ab9$export$f30f7e456d254e83(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $d9fd026bfea79ab9$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $d9fd026bfea79ab9$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}


/**
 * React Router DOM v6.30.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");


function $a0cf24fd73ae067c$var$_extends() {
    $a0cf24fd73ae067c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a0cf24fd73ae067c$var$_extends.apply(this, arguments);
}
function $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a0cf24fd73ae067c$var$defaultMethod = "get";
const $a0cf24fd73ae067c$var$defaultEncType = "application/x-www-form-urlencoded";
function $a0cf24fd73ae067c$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $a0cf24fd73ae067c$var$isButtonElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $a0cf24fd73ae067c$var$isFormElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $a0cf24fd73ae067c$var$isInputElement(object) {
    return $a0cf24fd73ae067c$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $a0cf24fd73ae067c$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$a0cf24fd73ae067c$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $a0cf24fd73ae067c$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = null;
function $a0cf24fd73ae067c$var$isFormDataSubmitterSupported() {
    if ($a0cf24fd73ae067c$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $a0cf24fd73ae067c$var$_formDataSupportsSubmitter = true;
    }
    return $a0cf24fd73ae067c$var$_formDataSupportsSubmitter;
}
const $a0cf24fd73ae067c$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $a0cf24fd73ae067c$var$getFormEncType(encType) {
    if (encType != null && !$a0cf24fd73ae067c$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($a0cf24fd73ae067c$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        formData = new FormData(target);
    } else if ($a0cf24fd73ae067c$var$isButtonElement(target) || $a0cf24fd73ae067c$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $55100129ab36ed65$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $a0cf24fd73ae067c$var$defaultMethod;
        encType = $a0cf24fd73ae067c$var$getFormEncType(target.getAttribute("formenctype")) || $a0cf24fd73ae067c$var$getFormEncType(form.getAttribute("enctype")) || $a0cf24fd73ae067c$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$a0cf24fd73ae067c$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($a0cf24fd73ae067c$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $a0cf24fd73ae067c$var$defaultMethod;
        action = null;
        encType = $a0cf24fd73ae067c$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $a0cf24fd73ae067c$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $a0cf24fd73ae067c$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $a0cf24fd73ae067c$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $a0cf24fd73ae067c$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $a0cf24fd73ae067c$export$1f3f55432a00e06d(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $55100129ab36ed65$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $a0cf24fd73ae067c$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $55100129ab36ed65$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $a0cf24fd73ae067c$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $d9fd026bfea79ab9$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $a0cf24fd73ae067c$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $a0cf24fd73ae067c$var$_extends({}, state, {
        errors: $a0cf24fd73ae067c$var$deserializeErrors(state.errors)
    });
    return state;
}
function $a0cf24fd73ae067c$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $55100129ab36ed65$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $a0cf24fd73ae067c$export$7ad602f0e94e62d1 = /*#__PURE__*/ $7fPBF.createContext({
    isTransitioning: false
});
const $a0cf24fd73ae067c$export$148fd98d095596d4 = /*#__PURE__*/ $7fPBF.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $a0cf24fd73ae067c$var$START_TRANSITION = "startTransition";
const $a0cf24fd73ae067c$var$startTransitionImpl = $7fPBF[$a0cf24fd73ae067c$var$START_TRANSITION];
const $a0cf24fd73ae067c$var$FLUSH_SYNC = "flushSync";
const $a0cf24fd73ae067c$var$flushSyncImpl = $fw0lo[$a0cf24fd73ae067c$var$FLUSH_SYNC];
const $a0cf24fd73ae067c$var$USE_ID = "useId";
const $a0cf24fd73ae067c$var$useIdImpl = $7fPBF[$a0cf24fd73ae067c$var$USE_ID];
function $a0cf24fd73ae067c$var$startTransitionSafe(cb) {
    if ($a0cf24fd73ae067c$var$startTransitionImpl) $a0cf24fd73ae067c$var$startTransitionImpl(cb);
    else cb();
}
function $a0cf24fd73ae067c$var$flushSyncSafe(cb) {
    if ($a0cf24fd73ae067c$var$flushSyncImpl) $a0cf24fd73ae067c$var$flushSyncImpl(cb);
    else cb();
}
class $a0cf24fd73ae067c$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $a0cf24fd73ae067c$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $7fPBF.useState(router.state);
    let [pendingState, setPendingState] = $7fPBF.useState();
    let [vtContext, setVtContext] = $7fPBF.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $7fPBF.useState();
    let [transition, setTransition] = $7fPBF.useState();
    let [interruption, setInterruption] = $7fPBF.useState();
    let fetcherData = $7fPBF.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $7fPBF.useCallback((cb)=>{
        if (v7_startTransition) $a0cf24fd73ae067c$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $7fPBF.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $a0cf24fd73ae067c$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $a0cf24fd73ae067c$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $7fPBF.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $7fPBF.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $a0cf24fd73ae067c$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $7fPBF.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $7fPBF.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $7fPBF.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $7fPBF.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $7fPBF.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $7fPBF.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $7fPBF.createElement($7fPBF.Fragment, null, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $a0cf24fd73ae067c$var$MemoizedDataRoutes = /*#__PURE__*/ $7fPBF.memo($a0cf24fd73ae067c$var$DataRoutes);
function $a0cf24fd73ae067c$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $d9fd026bfea79ab9$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $a0cf24fd73ae067c$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $7fPBF.useRef();
    if (historyRef.current == null) historyRef.current = (0, $55100129ab36ed65$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $a0cf24fd73ae067c$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $7fPBF.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $7fPBF.useCallback((newState)=>{
        v7_startTransition && $a0cf24fd73ae067c$var$startTransitionImpl ? $a0cf24fd73ae067c$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $7fPBF.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $7fPBF.useEffect(()=>(0, $d9fd026bfea79ab9$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $7fPBF.createElement((0, $d9fd026bfea79ab9$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $a0cf24fd73ae067c$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $a0cf24fd73ae067c$export$a6c7ac8248d6e38a = /*#__PURE__*/ $7fPBF.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref7, $a0cf24fd73ae067c$var$_excluded);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $a0cf24fd73ae067c$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($a0cf24fd73ae067c$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $d9fd026bfea79ab9$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $a0cf24fd73ae067c$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $7fPBF.createElement("a", $a0cf24fd73ae067c$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $a0cf24fd73ae067c$export$b0d92dbee9b5b60d = /*#__PURE__*/ $7fPBF.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref8, $a0cf24fd73ae067c$var$_excluded2);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let routerState = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $a0cf24fd73ae067c$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a6c7ac8248d6e38a, $a0cf24fd73ae067c$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $a0cf24fd73ae067c$export$a7fed597f4b8afd8 = /*#__PURE__*/ $7fPBF.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $a0cf24fd73ae067c$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $a0cf24fd73ae067c$var$_objectWithoutPropertiesLoose(_ref9, $a0cf24fd73ae067c$var$_excluded3);
    let submit = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let formAction = $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $7fPBF.createElement("form", $a0cf24fd73ae067c$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $a0cf24fd73ae067c$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $a0cf24fd73ae067c$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $a0cf24fd73ae067c$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($a0cf24fd73ae067c$var$DataRouterHook || ($a0cf24fd73ae067c$var$DataRouterHook = {}));
var $a0cf24fd73ae067c$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($a0cf24fd73ae067c$var$DataRouterStateHook || ($a0cf24fd73ae067c$var$DataRouterStateHook = {}));
// Internal hooks
function $a0cf24fd73ae067c$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $a0cf24fd73ae067c$var$useDataRouterContext(hookName) {
    let ctx = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$3add0d5dce533e2e));
    !ctx && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return ctx;
}
function $a0cf24fd73ae067c$var$useDataRouterState(hookName) {
    let state = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$145dfa71566a64dc));
    !state && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $a0cf24fd73ae067c$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $7fPBF.useCallback((event)=>{
        if ($a0cf24fd73ae067c$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $55100129ab36ed65$export$fe53371bee54353d)(location) === (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $a0cf24fd73ae067c$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $7fPBF.useRef($a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $7fPBF.useRef(false);
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let searchParams = $7fPBF.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $a0cf24fd73ae067c$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let setSearchParams = $7fPBF.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $a0cf24fd73ae067c$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $a0cf24fd73ae067c$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $a0cf24fd73ae067c$var$fetcherId = 0;
let $a0cf24fd73ae067c$var$getUniqueFetcherId = ()=>"__" + String(++$a0cf24fd73ae067c$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $a0cf24fd73ae067c$export$47c85c6e3a081d3() {
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let currentRouteId = (0, $d9fd026bfea79ab9$export$5fc8298006ad9e58)();
    return $7fPBF.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $a0cf24fd73ae067c$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $a0cf24fd73ae067c$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $a0cf24fd73ae067c$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $a0cf24fd73ae067c$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let routeContext = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    !routeContext && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $a0cf24fd73ae067c$var$_extends({}, (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $55100129ab36ed65$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $55100129ab36ed65$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $a0cf24fd73ae067c$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseFetcher);
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $7fPBF.useContext($a0cf24fd73ae067c$export$148fd98d095596d4);
    let route = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !route && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $a0cf24fd73ae067c$var$useIdImpl ? $a0cf24fd73ae067c$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $7fPBF.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($a0cf24fd73ae067c$var$getUniqueFetcherId());
    // Registration/cleanup
    $7fPBF.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $7fPBF.useCallback((href, opts)=>{
        !routeId && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $a0cf24fd73ae067c$export$47c85c6e3a081d3();
    let submit = $7fPBF.useCallback((target, opts)=>{
        submitImpl(target, $a0cf24fd73ae067c$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $7fPBF.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $7fPBF.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $7fPBF.createElement($a0cf24fd73ae067c$export$a7fed597f4b8afd8, $a0cf24fd73ae067c$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $55100129ab36ed65$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $7fPBF.useMemo(()=>$a0cf24fd73ae067c$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $a0cf24fd73ae067c$export$fa996778a3a31087() {
    let state = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $a0cf24fd73ae067c$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $a0cf24fd73ae067c$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $a0cf24fd73ae067c$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $a0cf24fd73ae067c$var$useDataRouterState($a0cf24fd73ae067c$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $7fPBF.useContext((0, $d9fd026bfea79ab9$export$26749e8557646306));
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let matches = (0, $d9fd026bfea79ab9$export$2378eb7f5ff86053)();
    let navigation = (0, $d9fd026bfea79ab9$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $7fPBF.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $a0cf24fd73ae067c$var$usePageHide($7fPBF.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $a0cf24fd73ae067c$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($a0cf24fd73ae067c$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $a0cf24fd73ae067c$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $a0cf24fd73ae067c$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($a0cf24fd73ae067c$var$_extends({}, location, {
                    pathname: (0, $55100129ab36ed65$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($a0cf24fd73ae067c$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $7fPBF.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $a0cf24fd73ae067c$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $7fPBF.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $a0cf24fd73ae067c$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $d9fd026bfea79ab9$export$b273b3273281a049)(when);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $7fPBF.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $a0cf24fd73ae067c$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $7fPBF.useContext($a0cf24fd73ae067c$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $55100129ab36ed65$export$3e9cee6b33872309)(false);
    let { basename: basename } = $a0cf24fd73ae067c$var$useDataRouterContext($a0cf24fd73ae067c$var$DataRouterHook.useViewTransitionState);
    let path = (0, $d9fd026bfea79ab9$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $55100129ab36ed65$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $55100129ab36ed65$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $c6ba0193c6fadd6f$exports = {};

$c6ba0193c6fadd6f$exports = (parcelRequire("a04va"));


var $7f6f67fb8f6e889a$exports = {};






$7f6f67fb8f6e889a$exports = {
    decode: (parcelRequire("asDSe")),
    verify: (parcelRequire("7RGJO")),
    sign: (parcelRequire("6Grea")),
    JsonWebTokenError: (parcelRequire("ifPfG")),
    NotBeforeError: (parcelRequire("63AiW")),
    TokenExpiredError: (parcelRequire("bB7TK"))
};


class $b299c3de35dcaad6$export$2e2bcd8739ae039 {
    static getInstance() {
        if (!this.instance) this.instance = new $b299c3de35dcaad6$export$2e2bcd8739ae039();
        return this.instance;
    }
    // Methods
    getRefreshToken() {
        return localStorage.getItem("refreshToken");
    }
    hasRefreshToken() {
        return this.getRefreshToken() != null;
    }
    setRefreshToken(newToken) {
        if (newToken === null) return localStorage.removeItem("refreshToken");
        localStorage.setItem("refreshToken", newToken);
    }
    getAccessToken() {
        return this.accessToken || null;
    }
    setAccessToken(newToken) {
        this.accessToken = newToken === null ? undefined : newToken;
    }
    isTokenExpired(token) {
        if (token === null) return true;
        const payload = (0, (/*@__PURE__*/$parcel$interopDefault($7f6f67fb8f6e889a$exports))).decode(token);
        var _payload_exp;
        return typeof payload !== 'object' || ((_payload_exp = payload === null || payload === void 0 ? void 0 : payload.exp) !== null && _payload_exp !== void 0 ? _payload_exp : 0) < Date.now() / 1000;
    }
    constructor(){}
}


var $45c7c1b07e176ae0$export$43de73c489c61e6b = /*#__PURE__*/ function(NetworkEndpoint) {
    NetworkEndpoint["STAFF_LOGIN"] = "/auth/staff/email/sign-in";
    NetworkEndpoint["STAFF_USE_REFRESH_TOKEN"] = "/auth/staff/refresh-token";
    NetworkEndpoint["STAFF_RESET_PASSWORD"] = "/auth/staff/email/reset-password";
    NetworkEndpoint["STAFF_REQUEST_RESET_PASSWORD"] = "/auth/staff/email/request-reset-password";
    return NetworkEndpoint;
}({});
class $45c7c1b07e176ae0$export$2e2bcd8739ae039 {
    static async performRequest(request, consumeRefreshToken, useRefreshTokenIfNeeded = true) {
        return this.performRequestAt("https://api.saltplatform.com", request, consumeRefreshToken, useRefreshTokenIfNeeded);
    }
    static async performRequestAt(baseURL, request, consumeRefreshToken, useRefreshTokenIfNeeded = true) {
        try {
            if (request.endpoint !== "/auth/staff/refresh-token" && request.endpoint !== "/auth/staff/email/sign-in" && request.endpoint !== "/auth/staff/email/reset-password" && request.endpoint !== "/auth/staff/email/request-reset-password") {
                const tokenProvider = (0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance();
                let accessToken = tokenProvider.getAccessToken();
                if (accessToken !== null) {
                    if (tokenProvider.isTokenExpired(accessToken)) {
                        const success = useRefreshTokenIfNeeded ? await consumeRefreshToken() : false;
                        if (!success) throw new Error("Invalid session. Please login again.");
                        accessToken = tokenProvider.getAccessToken();
                    }
                    request.headers["Authorization"] = `Bearer ${accessToken}`;
                }
            }
            const result = await (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports)))({
                method: request.method,
                url: baseURL + request.endpoint,
                data: request.body || {},
                headers: request.headers
            });
            return {
                body: result.data
            };
        } catch (error) {
            var _error_response, _error_response_data, _error_response1, _error_response2, _error_response_data1, _error_response3;
            if (request.endpoint !== "/auth/staff/email/sign-in" && request.endpoint !== "/auth/staff/refresh-token" && useRefreshTokenIfNeeded && ((_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.status) === 403) {
                const success = await consumeRefreshToken();
                if (success) // Re-run request now
                return await this.performRequest(request, consumeRefreshToken, false);
            }
            let errorMessage = "Something went wrong. Please try again later.";
            if (error.hasOwnProperty('response') && error.response !== undefined && error.response.hasOwnProperty('data')) {
                const { data: data } = error.response;
                if (data.hasOwnProperty('error')) errorMessage = data.error;
                else if (data.hasOwnProperty('errorMessage')) errorMessage = data.errorMessage;
                else if (typeof (data === null || data === void 0 ? void 0 : data.message) === 'string' && data.message.length > 0) // Sanctuary sends its HTTPError as the body: { status, message }.
                errorMessage = data.message;
            }
            const code = error === null || error === void 0 ? void 0 : (_error_response1 = error.response) === null || _error_response1 === void 0 ? void 0 : (_error_response_data = _error_response1.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.code;
            const status = error === null || error === void 0 ? void 0 : (_error_response2 = error.response) === null || _error_response2 === void 0 ? void 0 : _error_response2.status;
            return {
                error: errorMessage,
                status: typeof status === 'number' ? status : undefined,
                code: typeof code === 'string' ? code : undefined,
                extra: error === null || error === void 0 ? void 0 : (_error_response3 = error.response) === null || _error_response3 === void 0 ? void 0 : (_error_response_data1 = _error_response3.data) === null || _error_response_data1 === void 0 ? void 0 : _error_response_data1.extra
            };
        }
    }
    // Mux hands back a single authenticated URL to PUT the file to, rather than
    // the signed form POST the S3 image flow uses.
    static async performSignedPut(url, data, mimeType, onProgress) {
        try {
            const result = await (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).put(url, data, {
                headers: {
                    'Content-Type': mimeType || 'application/octet-stream'
                },
                onUploadProgress: onProgress ? (event)=>{
                    var _event_total;
                    // Falls back to the file's own size when the browser doesn't report
                    // a total for the request.
                    const total = (_event_total = event.total) !== null && _event_total !== void 0 ? _event_total : data instanceof Blob ? data.size : 0;
                    if (total > 0) onProgress(Math.min(event.loaded / total, 1));
                } : undefined
            });
            return result.status >= 200 && result.status <= 299;
        } catch (error) {
            console.log(error.response);
            return false;
        }
    }
    static async performSignedPost(instructions, data, mimeType) {
        const formData = new FormData();
        for(const field in instructions.fields)formData.append(field, instructions.fields[field]);
        // This must be last! Thanks AWS D:
        formData.append("file", data);
        try {
            const result = await (0, (/*@__PURE__*/$parcel$interopDefault($c6ba0193c6fadd6f$exports))).post(instructions.url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            return result.status >= 200 && result.status <= 299;
        } catch (error) {
            console.log(error.response);
            return false;
        }
    }
}
class $45c7c1b07e176ae0$export$3df08bb5d0f8b499 {
    constructor(method, endpoint, body, headers){
        this.headers = headers || {};
        this.method = method;
        this.endpoint = endpoint;
        this.body = body;
    }
}
var $45c7c1b07e176ae0$export$f03a741ee867f39c = /*#__PURE__*/ function(HTTPMethod) {
    HTTPMethod["GET"] = "get";
    HTTPMethod["POST"] = "post";
    HTTPMethod["PATCH"] = "patch";
    HTTPMethod["PUT"] = "put";
    HTTPMethod["DELETE"] = "delete";
    return HTTPMethod;
}({});


var $490c7b02975ed1ea$export$d636315ee2b4886d = /*#__PURE__*/ function(SupportedChurchVideoService) {
    SupportedChurchVideoService["YOUTUBE"] = "YOUTUBE";
    SupportedChurchVideoService["FACEBOOK"] = "FACEBOOK";
    return SupportedChurchVideoService;
}({});
var $490c7b02975ed1ea$export$3e2a2388f3561d5 = /*#__PURE__*/ function(StaffRole) {
    StaffRole["ADMIN"] = "Admin";
    StaffRole["VOLUNTEER_MANAGER"] = "Volunteer Manager";
    StaffRole["EVENT_MANAGER"] = "Event Manager";
    StaffRole["PLAYLIST_MANAGER"] = "Playlist Manager";
    StaffRole["SERVICE_MANAGER"] = "Service Manager";
    StaffRole["LAUNCHPAD_MANAGER"] = "Launchpad Manager";
    StaffRole["PEOPLE_MANAGER"] = "People Manager";
    return StaffRole;
}({});
const $490c7b02975ed1ea$export$613954afd987de13 = [
    "Admin",
    "Volunteer Manager",
    "Event Manager",
    "Playlist Manager",
    "Service Manager",
    "Launchpad Manager",
    "People Manager"
];
var $490c7b02975ed1ea$export$dd9f17662886326 = /*#__PURE__*/ function(StaffAction) {
    StaffAction[StaffAction["DELETE_STAFF_USER"] = 0] = "DELETE_STAFF_USER";
    StaffAction[StaffAction["CREATE_STAFF_USER"] = 1] = "CREATE_STAFF_USER";
    StaffAction[StaffAction["EDIT_STAFF_USER"] = 2] = "EDIT_STAFF_USER";
    StaffAction[StaffAction["EDIT_CHURCH_METADATA"] = 3] = "EDIT_CHURCH_METADATA";
    StaffAction[StaffAction["CREATE_DAILY_DEVOTIONAL"] = 4] = "CREATE_DAILY_DEVOTIONAL";
    StaffAction[StaffAction["CREATE_PLAYLIST"] = 5] = "CREATE_PLAYLIST";
    StaffAction[StaffAction["EDIT_PLAYLIST"] = 6] = "EDIT_PLAYLIST";
    StaffAction[StaffAction["DELETE_PLAYLIST"] = 7] = "DELETE_PLAYLIST";
    // Access to each area of Church Hub, which decides what the sidebar shows.
    StaffAction[StaffAction["MANAGE_LAUNCHPAD"] = 8] = "MANAGE_LAUNCHPAD";
    StaffAction[StaffAction["MANAGE_PLAYLISTS"] = 9] = "MANAGE_PLAYLISTS";
    StaffAction[StaffAction["MANAGE_SERVICES"] = 10] = "MANAGE_SERVICES";
    StaffAction[StaffAction["MANAGE_EVENTS"] = 11] = "MANAGE_EVENTS";
    StaffAction[StaffAction["MANAGE_VOLUNTEERING"] = 12] = "MANAGE_VOLUNTEERING";
    StaffAction[StaffAction["MANAGE_PEOPLE"] = 13] = "MANAGE_PEOPLE";
    StaffAction[StaffAction["MANAGE_STAFF"] = 14] = "MANAGE_STAFF";
    StaffAction[StaffAction["MANAGE_CONNECTIONS"] = 15] = "MANAGE_CONNECTIONS";
    StaffAction[StaffAction["MANAGE_SETTINGS"] = 16] = "MANAGE_SETTINGS";
    return StaffAction;
}({});
const $490c7b02975ed1ea$export$f43caee112d022e1 = {
    [0]: [
        "Admin"
    ],
    [2]: [
        "Admin"
    ],
    [1]: [
        "Admin"
    ],
    [3]: [
        "Admin"
    ],
    [4]: [
        "Admin"
    ],
    [5]: [
        "Admin",
        "Playlist Manager"
    ],
    [6]: [
        "Admin",
        "Playlist Manager"
    ],
    [7]: [
        "Admin",
        "Playlist Manager"
    ],
    // Each manager role opens its own area; the legacy roles keep the areas
    // they already had.
    [8]: [
        "Admin",
        "Launchpad Manager"
    ],
    [9]: [
        "Admin",
        "Playlist Manager"
    ],
    [10]: [
        "Admin",
        "Service Manager"
    ],
    [11]: [
        "Admin",
        "Event Manager"
    ],
    [12]: [
        "Admin",
        "Volunteer Manager"
    ],
    [13]: [
        "Admin",
        "People Manager"
    ],
    [14]: [
        "Admin"
    ],
    [15]: [
        "Admin"
    ],
    [16]: [
        "Admin"
    ]
};



var $7fPBF = parcelRequire("7fPBF");


let $12342e602c448a3c$var$AuthContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
// A refresh returns an equivalent staff record as a brand new object. Comparing
// by value keeps the context identity stable across a refresh, so consumers
// don't treat "same user, new token" as a change worth reacting to.
function $12342e602c448a3c$var$isSameStaff(a, b) {
    if (a === b) return true;
    if (!a || !b) return false;
    return a.id === b.id && a.email === b.email && a.name === b.name && a.roles.length === b.roles.length && a.roles.every((role, index)=>role === b.roles[index]);
}
function $12342e602c448a3c$export$2e2bcd8739ae039({ children: children }) {
    // Read once on mount rather than re-parsing localStorage on every render.
    let [user, setUser] = (0, $7fPBF.useState)(()=>{
        const cached = localStorage.getItem("user");
        return cached === null ? undefined : JSON.parse(cached);
    });
    let [churchId, setChurchId] = (0, $7fPBF.useState)(undefined);
    const applyUser = (0, $7fPBF.useCallback)((nextUser)=>{
        setUser((currentUser)=>$12342e602c448a3c$var$isSameStaff(currentUser, nextUser) ? currentUser : nextUser);
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (user === undefined) return;
        localStorage.setItem("user", JSON.stringify(user));
    }, [
        user,
        churchId
    ]);
    // Held in a ref so the callbacks below stay stable even though react-router
    // hands back a new navigate function as the route changes.
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const navigateRef = (0, $7fPBF.useRef)(navigate);
    navigateRef.current = navigate;
    const signOut = (0, $7fPBF.useCallback)((callback)=>{
        const authTokenProvider = (0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance();
        authTokenProvider.setAccessToken(null);
        authTokenProvider.setRefreshToken(null);
        setUser(undefined);
        setChurchId(undefined);
        localStorage.removeItem("user");
        callback();
    }, []);
    const consumeRefreshToken = (0, $7fPBF.useCallback)(async ()=>{
        const authTokenProvider = (0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance();
        const existingRefreshToken = authTokenProvider.getRefreshToken();
        if (existingRefreshToken === null || authTokenProvider.isTokenExpired(existingRefreshToken)) {
            signOut(()=>{
                navigateRef.current("/");
            });
            return false;
        }
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, (0, $45c7c1b07e176ae0$export$43de73c489c61e6b).STAFF_USE_REFRESH_TOKEN, {
            refreshToken: existingRefreshToken
        }), async ()=>{
            return false;
        }, false);
        if (response.error || !response.body) {
            signOut(()=>{
                navigateRef.current("/");
            });
            return false;
        }
        const { user: user, churchId: churchId, accessToken: accessToken, refreshToken: refreshToken } = response.body;
        authTokenProvider.setAccessToken(accessToken);
        authTokenProvider.setRefreshToken(refreshToken);
        applyUser(user);
        setChurchId(churchId);
        return true;
    }, [
        signOut,
        applyUser
    ]);
    const signIn = (0, $7fPBF.useCallback)(async (email, password)=>{
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, (0, $45c7c1b07e176ae0$export$43de73c489c61e6b).STAFF_LOGIN, {
            email: email,
            password: password
        }), consumeRefreshToken);
        if (response.error !== undefined || response.body === undefined) throw new Error(response.error || "Something went wrong while communicating with Salt systems.");
        const { accessToken: accessToken, refreshToken: refreshToken, staff: staff, churchId: churchId } = response.body;
        const authTokenProvider = (0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance();
        authTokenProvider.setAccessToken(accessToken);
        authTokenProvider.setRefreshToken(refreshToken);
        applyUser(staff);
        setChurchId(churchId);
        return staff;
    }, [
        consumeRefreshToken,
        applyUser
    ]);
    const resetPassword = (0, $7fPBF.useCallback)(async (token, password)=>{
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, (0, $45c7c1b07e176ae0$export$43de73c489c61e6b).STAFF_RESET_PASSWORD, {
            token: token,
            password: password
        }), consumeRefreshToken);
        if (response.error !== undefined || response.body === undefined) throw new Error(response.error || "Something went wrong while communicating with Salt systems.");
        return response.body.success;
    }, [
        consumeRefreshToken
    ]);
    const requestPasswordReset = (0, $7fPBF.useCallback)(async (email)=>{
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequest(new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, (0, $45c7c1b07e176ae0$export$43de73c489c61e6b).STAFF_REQUEST_RESET_PASSWORD, {
            email: email
        }), consumeRefreshToken);
        if (response.error !== undefined || response.body === undefined) throw new Error(response.error || "Something went wrong while communicating with Salt systems.");
        return response.body.message;
    }, [
        consumeRefreshToken
    ]);
    const hasPermission = (0, $7fPBF.useCallback)((permission)=>{
        if (user === undefined) return false;
        const validRoles = (0, $490c7b02975ed1ea$export$f43caee112d022e1)[permission];
        return validRoles.filter((validRole)=>{
            return user === null || user === void 0 ? void 0 : user.roles.includes(validRole);
        }).length > 0;
    }, [
        user
    ]);
    // Identity changes only when the user or church actually changes, so a token
    // refresh no longer invalidates every consumer of this context.
    const value = (0, $7fPBF.useMemo)(()=>({
            user: user,
            churchId: churchId,
            hasPermission: hasPermission,
            signIn: signIn,
            signOut: signOut,
            resetPassword: resetPassword,
            requestPasswordReset: requestPasswordReset,
            consumeRefreshToken: consumeRefreshToken
        }), [
        user,
        churchId,
        hasPermission,
        signIn,
        signOut,
        resetPassword,
        requestPasswordReset,
        consumeRefreshToken
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($12342e602c448a3c$var$AuthContext.Provider, {
        value: value,
        children: children
    });
}
function $12342e602c448a3c$export$1d39dc5b47e56ff0() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($12342e602c448a3c$var$AuthContext);
}






function $f1b5de3ad0a0b51c$export$2e2bcd8739ae039() {
    let auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    if ((0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance().getAccessToken() == null && (0, $b299c3de35dcaad6$export$2e2bcd8739ae039).getInstance().getRefreshToken() != null) {
        auth.consumeRefreshToken();
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$910ae8079b2c2852), {});
    }
    if (!auth.user) // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/login",
        state: {
            from: location
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$910ae8079b2c2852), {});
}





var $7fPBF = parcelRequire("7fPBF");

class $d6ceddc0f5c6ead5$export$2e2bcd8739ae039 {
    static async fetchIntegrations(churchID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/integrations`), auth.consumeRefreshToken);
    }
    // Only for providers connected through a redirect: the API answers an
    // API-key provider with a 400 rather than a URL.
    static async fetchAuthorizationURL(churchID, provider, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/integrations/${provider}/authorization-url`), auth.consumeRefreshToken);
    }
    // Re-submitting is how a church rotates a key, so this overwrites an
    // existing connection rather than failing.
    static async saveAPIKey(churchID, provider, apiKey, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PUT, `/v1/church/${churchID}/integrations/${provider}/api-key`, {
            apiKey: apiKey
        }), auth.consumeRefreshToken);
    }
    // Returns straight away with the queued job; the work happens off a queue,
    // and progress comes from fetchPeopleImport. The API defaults an empty body
    // to a preview, so the mode is always sent explicitly.
    static async startPeopleImport(churchID, provider, mode, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/integrations/${provider}/imports`, {
            mode: mode
        }), auth.consumeRefreshToken);
    }
    // Newest first. Job records expire after six months, so an empty list
    // doesn't prove a church never imported -- starting again will say so.
    static async fetchPeopleImports(churchID, provider, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/integrations/${provider}/imports`), auth.consumeRefreshToken);
    }
    static async fetchPeopleImport(churchID, provider, jobID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/integrations/${provider}/imports/${jobID}`), auth.consumeRefreshToken);
    }
    // Read live from the provider on every call, so it can take a moment.
    static async fetchImportableTeams(churchID, provider, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/integrations/${provider}/teams`), auth.consumeRefreshToken);
    }
    // A one-time copy into a new Salt team. Refused with TEAM_ALREADY_IMPORTED
    // for a team imported before.
    static async importTeam(churchID, provider, externalTeamID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/integrations/${provider}/teams/${encodeURIComponent(externalTeamID)}/import`), auth.consumeRefreshToken);
    }
    static async disconnect(churchID, provider, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/integrations/${provider}`), auth.consumeRefreshToken);
    }
}
$d6ceddc0f5c6ead5$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";


var $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72 = /*#__PURE__*/ function(ExternalVendor) {
    ExternalVendor["PLANNING_CENTER"] = "PLANNING_CENTER";
    ExternalVendor["SMART_WAIVER"] = "SMART_WAIVER";
    return ExternalVendor;
}({});


var $5586e2638b6c1db4$export$22609f4d35043983 = /*#__PURE__*/ function(IntegrationAuthorizationStyle) {
    IntegrationAuthorizationStyle["OAUTH"] = "OAUTH";
    IntegrationAuthorizationStyle["API_KEY"] = "API_KEY";
    return IntegrationAuthorizationStyle;
}({});
var $5586e2638b6c1db4$export$140fd4ecf5a82cf0 = /*#__PURE__*/ function(IntegrationStatus) {
    IntegrationStatus["ACTIVE"] = "ACTIVE";
    /// The provider rejected our refresh token. Only the church can fix this, by
    /// reconnecting.
    IntegrationStatus["NEEDS_REAUTHORIZATION"] = "NEEDS_REAUTHORIZATION";
    IntegrationStatus["REVOKED"] = "REVOKED";
    return IntegrationStatus;
}({});
var $5586e2638b6c1db4$export$1b64b3d59d6fc61f = /*#__PURE__*/ function(IntegrationWebhookStatus) {
    IntegrationWebhookStatus["NOT_REGISTERED"] = "NOT_REGISTERED";
    IntegrationWebhookStatus["ACTIVE"] = "ACTIVE";
    IntegrationWebhookStatus["FAILED"] = "FAILED";
    return IntegrationWebhookStatus;
}({});
function $5586e2638b6c1db4$export$26b3dc1777d13b5f(body) {
    if (!body || typeof body !== 'object') return [];
    const payload = body;
    var _payload_result, _ref;
    const candidate = (_ref = (_payload_result = payload.result) !== null && _payload_result !== void 0 ? _payload_result : payload.results) !== null && _ref !== void 0 ? _ref : payload;
    if (!Array.isArray(candidate)) return [];
    return candidate.filter((connection)=>Boolean(connection === null || connection === void 0 ? void 0 : connection.provider));
}
function $5586e2638b6c1db4$export$432e3e4ebac25704(connection) {
    return (connection === null || connection === void 0 ? void 0 : connection.status) === "ACTIVE";
}
var $5586e2638b6c1db4$export$464939c50b7e9aa5 = /*#__PURE__*/ function(PeopleImportMode) {
    PeopleImportMode["PREVIEW"] = "PREVIEW";
    PeopleImportMode["APPLY"] = "APPLY";
    return PeopleImportMode;
}({});
var $5586e2638b6c1db4$export$16d185230a192260 = /*#__PURE__*/ function(PeopleImportStatus) {
    PeopleImportStatus["QUEUED"] = "QUEUED";
    PeopleImportStatus["RUNNING"] = "RUNNING";
    PeopleImportStatus["SUCCEEDED"] = "SUCCEEDED";
    PeopleImportStatus["FAILED"] = "FAILED";
    PeopleImportStatus["CANCELED"] = "CANCELED";
    /// Stopped cleanly partway -- usually a chunk reaching its deadline -- and
    /// picks up again from where it left off.
    PeopleImportStatus["INTERRUPTED"] = "INTERRUPTED";
    return PeopleImportStatus;
}({});
function $5586e2638b6c1db4$export$2711b377650411ef(status) {
    return status === "SUCCEEDED" || status === "FAILED" || status === "CANCELED";
}
function $5586e2638b6c1db4$export$1fb54e0e25b02151(counters) {
    return counters.created + counters.claimed + counters.updated + counters.unchanged + counters.skipped + counters.failed;
}




let $516c6e0c0adbc42f$var$ChurchDataContext = /*#__PURE__*/ (0, $7fPBF.createContext)(null);
function $516c6e0c0adbc42f$export$2e2bcd8739ae039({ children: children }) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let [church, setChurch] = (0, $7fPBF.useState)(undefined);
    let [campuses, setCampuses] = (0, $7fPBF.useState)([]);
    let [categories, setCategories] = (0, $7fPBF.useState)([]);
    let [staff, setStaff] = (0, $7fPBF.useState)([]);
    let [integrations, setIntegrations] = (0, $7fPBF.useState)(null);
    // Derived so the Events pages can keep asking "is Planning Center on?"
    // without knowing about connection records. Only an ACTIVE connection counts
    // as connected: one needing reauthorization can't make a request.
    const connectionStatus = (0, $7fPBF.useMemo)(()=>{
        // Captured in a const so the null check narrows inside the callback below;
        // `integrations` is a `let` from useState, which TypeScript won't narrow
        // across a closure.
        const currentIntegrations = integrations;
        if (!currentIntegrations) return null;
        return Object.values((0, $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72)).reduce((statuses, vendor)=>{
            statuses[vendor] = currentIntegrations.some((connection)=>connection.provider === vendor && (0, $5586e2638b6c1db4$export$432e3e4ebac25704)(connection));
            return statuses;
        }, {});
    }, [
        integrations
    ]);
    const reloadChurch = (0, $7fPBF.useCallback)(async (churchId)=>{
        if (!auth.user) return;
        const response = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt("https://sanctuary-api.saltplatform.com", new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchId}?includeStaff=true&includeConnectionMetadata=true`), auth.consumeRefreshToken);
        if (response.error || !response.body) return auth.signOut(()=>{
            navigate("/");
        });
        const { church: church, staff: staff, campuses: campuses, categories: categories } = response.body;
        setChurch(church);
        setStaff(staff === undefined ? [] : staff);
        setCampuses(campuses === undefined ? [] : campuses);
        setCategories(categories === undefined ? [] : categories);
        // also refresh connection status
        try {
            const resp = await (0, $d6ceddc0f5c6ead5$export$2e2bcd8739ae039).fetchIntegrations(churchId, auth);
            if (!resp.error && resp.body) setIntegrations((0, $5586e2638b6c1db4$export$26b3dc1777d13b5f)(resp.body));
        } catch (err) {
            console.error('Failed to load connection status', err);
        }
    // reloadCurrentWeekCheckInData(churchId);
    }, [
        auth,
        navigate
    ]);
    const reloadConnectionStatus = (0, $7fPBF.useCallback)(async ()=>{
        if (!auth.churchId) return;
        try {
            const resp = await (0, $d6ceddc0f5c6ead5$export$2e2bcd8739ae039).fetchIntegrations(auth.churchId, auth);
            if (!resp.error && resp.body) setIntegrations((0, $5586e2638b6c1db4$export$26b3dc1777d13b5f)(resp.body));
        } catch (err) {
            console.error('Failed to load connection status', err);
        }
    }, [
        auth
    ]);
    const clear = ()=>{
        setChurch(undefined);
        setStaff([]);
        setCampuses([]);
        setCategories([]);
        setIntegrations(null);
    };
    // Modify data when user changes
    (0, $7fPBF.useEffect)(()=>{
        if (auth.user !== undefined && auth.churchId !== undefined) reloadChurch(auth.churchId);
        else clear();
    }, [
        auth.user,
        reloadChurch,
        auth.churchId
    ]);
    let value = {
        church: church,
        staff: staff,
        campuses: campuses,
        categories: categories,
        connectionStatus: connectionStatus,
        integrations: integrations,
        reloadConnectionStatus: reloadConnectionStatus,
        reloadChurch: ()=>{
            if (!auth.user || !auth.churchId) return;
            reloadChurch(auth.churchId);
        },
        clear: clear
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($516c6e0c0adbc42f$var$ChurchDataContext.Provider, {
        value: value,
        children: children
    });
}
function $516c6e0c0adbc42f$export$2f841eb01d18b05e() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($516c6e0c0adbc42f$var$ChurchDataContext);
}





var $7fPBF = parcelRequire("7fPBF");




var $19d0cd1776c9b37d$exports = {};
$19d0cd1776c9b37d$exports = $parcel$resolve("4vxZ7");


var $b398b821fc98725b$exports = {};
$b398b821fc98725b$exports = $parcel$resolve("f5wK0");


function $6ae515035e6d7062$export$2e2bcd8739ae039(props) {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const selectedPath = $6ae515035e6d7062$var$selectedTabPath(props.tabs, location.pathname);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "page-tabs",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                className: "header",
                children: props.title
            }),
            props.tabs.map((tab)=>{
                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    className: tab.path === selectedPath ? 'page-tab selected' : 'page-tab',
                    onClick: ()=>navigate(tab.path),
                    children: tab.label
                }, tab.path);
            }),
            props.buttons && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "spacer"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "page-tab-buttons",
                        children: props.buttons.map((button)=>{
                            let icon;
                            switch(button.icon){
                                case 'add':
                                    icon = (0, (/*@__PURE__*/$parcel$interopDefault($19d0cd1776c9b37d$exports)));
                                    break;
                                case 'info':
                                    icon = (0, (/*@__PURE__*/$parcel$interopDefault($b398b821fc98725b$exports)));
                                    break;
                            }
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                className: "page-tab-button",
                                onClick: button.onClick,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: icon,
                                    alt: button.label,
                                    "aria-hidden": "true"
                                })
                            }, button.label);
                        })
                    })
                ]
            })
        ]
    });
}
// A tab owns its path and everything nested under it, so the most specific
// match wins: /launchpad/tags belongs to Tags, /launchpad/{id} to Views.
function $6ae515035e6d7062$var$selectedTabPath(tabs, pathname) {
    const matches = tabs.filter((tab)=>{
        return pathname === tab.path || pathname.startsWith(`${tab.path}/`);
    });
    if (matches.length === 0) return null;
    return matches.reduce((longest, tab)=>tab.path.length > longest.path.length ? tab : longest).path;
}




parcelRequire("7fPBF");


function $a316458081a8d65b$export$2e2bcd8739ae039(props) {
    var _props_size;
    const size = (_props_size = props.size) !== null && _props_size !== void 0 ? _props_size : 'medium';
    const className = `monogram monogram-${size} monogram-${$a316458081a8d65b$export$c96af8212224499f(props.name)}`;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: className,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            children: $a316458081a8d65b$var$monogramForName(props.name)
        })
    });
}
function $a316458081a8d65b$var$monogramForName(name) {
    const initials = name.split(' ').map((word)=>word[0]).join('');
    return initials.length > 2 ? initials.substring(0, 2) : initials;
}
// Matches the class names in index.scss, in the same order as the iOS palette.
const $a316458081a8d65b$var$MONOGRAM_COLORS = [
    'red',
    'orange',
    'green',
    'blue',
    'purple',
    'pink',
    'cyan',
    'indigo',
    'mint',
    'teal'
];
function $a316458081a8d65b$export$c96af8212224499f(name) {
    let hash = 0;
    for(let index = 0; index < name.length; index++)hash = hash * 31 + name.charCodeAt(index) | 0;
    return $a316458081a8d65b$var$MONOGRAM_COLORS[Math.abs(hash) % $a316458081a8d65b$var$MONOGRAM_COLORS.length];
}


var $e5c73394f0bf85aa$exports = {};
$e5c73394f0bf85aa$exports = $parcel$resolve("iq4SA");


function $2baa135e072363db$export$2e2bcd8739ae039(props) {
    const content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a316458081a8d65b$export$2e2bcd8739ae039), {
                name: props.name
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "text",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "name",
                        children: props.name
                    }),
                    props.email && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "email",
                        children: props.email
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: "chevron",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($e5c73394f0bf85aa$exports))),
                alt: ">"
            })
        ]
    });
    if (!props.onClick) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "person-card card",
        children: content
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        className: "person-card card is-interactive",
        onClick: props.onClick,
        children: content
    });
}


// Shares the volunteer menu's look, so both people lists feel the same.





var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
const $9108a7a2191b8648$var$VIEWPORT_MARGIN = 12;
function $9108a7a2191b8648$export$2e2bcd8739ae039(props) {
    const menuRef = (0, $7fPBF.useRef)(null);
    const [position, setPosition] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useLayoutEffect)(()=>{
        if (props.isClosing) return;
        const updatePosition = ()=>{
            if (!menuRef.current) return;
            const isMobile = window.innerWidth <= 650;
            const horizontalOffset = isMobile ? -12 : -20;
            const verticalOffset = isMobile ? 10 : 12;
            const rect = menuRef.current.getBoundingClientRect();
            const viewportLeft = window.scrollX;
            const viewportRight = viewportLeft + window.innerWidth;
            const viewportTop = window.scrollY;
            const viewportBottom = viewportTop + window.innerHeight;
            const appRoot = document.getElementById('root');
            const appRootRect = appRoot === null || appRoot === void 0 ? void 0 : appRoot.getBoundingClientRect();
            const pageBottom = appRootRect ? appRootRect.bottom + window.scrollY : document.documentElement.scrollHeight;
            const availableBottom = Math.min(viewportBottom, pageBottom);
            let left = props.x + horizontalOffset;
            const minLeft = viewportLeft + $9108a7a2191b8648$var$VIEWPORT_MARGIN;
            const maxLeft = viewportRight - rect.width - $9108a7a2191b8648$var$VIEWPORT_MARGIN;
            const minTop = viewportTop + $9108a7a2191b8648$var$VIEWPORT_MARGIN;
            const maxTop = viewportBottom - rect.height - $9108a7a2191b8648$var$VIEWPORT_MARGIN;
            let top = props.y + verticalOffset;
            left = Math.min(Math.max(minLeft, left), Math.max(minLeft, maxLeft));
            if (top + rect.height > availableBottom - $9108a7a2191b8648$var$VIEWPORT_MARGIN) top = props.y - rect.height - verticalOffset;
            top = Math.min(Math.max(minTop, top), Math.max(minTop, maxTop));
            setPosition({
                left: left,
                top: top
            });
        };
        updatePosition();
        window.addEventListener('resize', updatePosition);
        return ()=>{
            window.removeEventListener('resize', updatePosition);
        };
    }, [
        props.isClosing,
        props.x,
        props.y
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!props.onRequestClose) return;
        // Dismissing on click rather than mousedown, in the capture phase, so the
        // click that closes the menu can be stopped before it reaches whatever it
        // landed on. On mousedown the browser still delivers the click afterwards,
        // which re-triggers the control that opened the menu in the first place.
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                var _props_onRequestClose;
                event.stopPropagation();
                (_props_onRequestClose = props.onRequestClose) === null || _props_onRequestClose === void 0 ? void 0 : _props_onRequestClose.call(props);
            }
        };
        const handleEscape = (event)=>{
            var _props_onRequestClose;
            if (event.key === 'Escape') (_props_onRequestClose = props.onRequestClose) === null || _props_onRequestClose === void 0 ? void 0 : _props_onRequestClose.call(props);
        };
        document.addEventListener('click', handleClickOutside, true);
        document.addEventListener('keydown', handleEscape);
        return ()=>{
            document.removeEventListener('click', handleClickOutside, true);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [
        props.onRequestClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).createPortal(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: menuRef,
        className: `context-menu ${props.className || ''} ${props.isClosing ? 'closing' : 'opening'}`,
        style: {
            left: position ? `${position.left}px` : `${props.x}px`,
            top: position ? `${position.top}px` : `${props.y}px`,
            visibility: position ? 'visible' : 'hidden'
        },
        onClick: (event)=>{
            event.stopPropagation();
        },
        children: props.sections.map((section, sectionIndex)=>{
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
                children: [
                    sectionIndex !== 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "context-menu-divider"
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: section.className,
                        children: section.items.map((item)=>{
                            if (!item) return null;
                            if (item.href && !item.disabled) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                className: item.className,
                                href: item.href,
                                target: item.target || '_blank',
                                rel: item.rel || 'noreferrer',
                                onClick: ()=>{
                                    var _item_onClick;
                                    (_item_onClick = item.onClick) === null || _item_onClick === void 0 ? void 0 : _item_onClick.call(item);
                                },
                                children: item.content
                            }, item.key);
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                className: item.className,
                                disabled: item.disabled,
                                onClick: ()=>{
                                    var _item_onClick;
                                    if (!item.disabled) (_item_onClick = item.onClick) === null || _item_onClick === void 0 ? void 0 : _item_onClick.call(item);
                                },
                                children: item.content
                            }, item.key);
                        })
                    })
                ]
            }, `section-${sectionIndex}`);
        })
    }), document.body);
}




parcelRequire("7fPBF");

var $af0bfc2991cf1d62$exports = {};
$af0bfc2991cf1d62$exports = $parcel$resolve("7RiSE");


var $32dba739a0e17da8$exports = {};
$32dba739a0e17da8$exports = $parcel$resolve("9gzWm");


var $b9f73db21efadc5d$exports = {};
$b9f73db21efadc5d$exports = $parcel$resolve("afN0H");


var $81839c9282ade394$exports = {};
$81839c9282ade394$exports = $parcel$resolve("bdSHX");


function $cb1d7f76a966659b$export$c8cea87c262cf9fb() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
        width: "12",
        height: "14",
        viewBox: "0 0 12 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M3.1582 13.3594C2.20898 13.3594 1.61719 12.8086 1.57617 11.8652L1.18359 3.48047H0.580078C0.257812 3.48047 0 3.23438 0 2.90625C0 2.58398 0.257812 2.33789 0.580078 2.33789H3.12891V1.47656C3.12891 0.544922 3.71484 0 4.73438 0H6.9668C7.98633 0 8.57812 0.544922 8.57812 1.47656V2.33789H11.1328C11.4609 2.33789 11.7129 2.58398 11.7129 2.90625C11.7129 3.23438 11.4609 3.48047 11.1328 3.48047H10.5293L10.1367 11.8594C10.0957 12.8086 9.49805 13.3594 8.55469 13.3594H3.1582ZM4.32422 1.52344V2.33789H7.38281V1.52344C7.38281 1.24219 7.18945 1.06641 6.87891 1.06641H4.82227C4.51758 1.06641 4.32422 1.24219 4.32422 1.52344ZM4.04883 11.5137C4.33008 11.5137 4.51172 11.3379 4.5 11.0742L4.31836 4.76367C4.3125 4.49414 4.125 4.33008 3.86133 4.33008C3.58008 4.33008 3.4043 4.5 3.41602 4.76953L3.5918 11.0801C3.60352 11.3438 3.78516 11.5137 4.04883 11.5137ZM5.85938 11.5137C6.12891 11.5137 6.31641 11.3438 6.31641 11.0801V4.76367C6.31641 4.5 6.12891 4.33008 5.85938 4.33008C5.58398 4.33008 5.39648 4.5 5.39648 4.76367V11.0801C5.39648 11.3438 5.58398 11.5137 5.85938 11.5137ZM7.66406 11.5137C7.92773 11.5137 8.10938 11.3438 8.12109 11.0801L8.29688 4.76953C8.30859 4.5 8.13281 4.33008 7.85156 4.33008C7.58789 4.33008 7.40039 4.5 7.39453 4.76367L7.21289 11.0742C7.20117 11.3379 7.38281 11.5137 7.66406 11.5137Z",
            fill: "#F64D4D"
        })
    });
}
function $cb1d7f76a966659b$export$2e2bcd8739ae039(props) {
    const platformRows = $cb1d7f76a966659b$var$buildPlatformRows(props.song);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9108a7a2191b8648$export$2e2bcd8739ae039), {
        className: "song-context-menu",
        x: props.x,
        y: props.y,
        isClosing: props.isClosing,
        onRequestClose: props.onRequestClose,
        sections: [
            {
                className: 'song-context-menu-links',
                items: platformRows.map((row, index)=>({
                        key: `${row.platform}-${index}`,
                        className: `song-context-menu-link plain ${row.url ? '' : 'disabled'}`,
                        href: row.url || undefined,
                        disabled: !row.url,
                        content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: `platform-icon platform-${$cb1d7f76a966659b$var$toPlatformSlug(row.platform)}`,
                                    children: $cb1d7f76a966659b$var$renderPlatformIcon(row.platform)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "platform-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "platform-name",
                                            children: row.platform
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                            className: "platform-status",
                                            children: [
                                                row.status === 'matched' ? 'Matched' : null,
                                                row.status === 'linked' ? 'Linked to Search' : null,
                                                row.status === 'unavailable' ? 'Unavailable' : null
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }))
            },
            {
                className: 'song-context-menu-actions',
                items: [
                    {
                        key: 'remove',
                        className: 'song-context-action remove',
                        onClick: ()=>{
                            var _props_onRemove;
                            (_props_onRemove = props.onRemove) === null || _props_onRemove === void 0 ? void 0 : _props_onRemove.call(props, props.song);
                        },
                        content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cb1d7f76a966659b$export$c8cea87c262cf9fb, {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: "Remove"
                                })
                            ]
                        })
                    }
                ]
            }
        ]
    });
}
function $cb1d7f76a966659b$var$buildPlatformRows(song) {
    const platforms = [
        'Apple Music',
        'Spotify',
        'YouTube Music',
        'Tidal'
    ];
    return platforms.map((platform)=>{
        const directLink = song.attributes.streamingLinks.find((link)=>link.platform === platform);
        const externalID = song.attributes.externalIDs.find((id)=>id.platform === platform);
        let status = 'unavailable';
        if (externalID) status = 'matched';
        else if (directLink) status = 'linked';
        return {
            platform: platform,
            status: status,
            url: (directLink === null || directLink === void 0 ? void 0 : directLink.url) || null
        };
    });
}
function $cb1d7f76a966659b$var$toPlatformSlug(platform) {
    return platform.toLowerCase().replace(/\s+/g, '-');
}
function $cb1d7f76a966659b$var$renderPlatformIcon(platform) {
    if (platform === 'YouTube Music') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($b9f73db21efadc5d$exports))),
        alt: "",
        "aria-hidden": "true"
    });
    if (platform === 'Apple Music') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($af0bfc2991cf1d62$exports))),
        alt: "",
        "aria-hidden": "true"
    });
    if (platform === 'Spotify') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($32dba739a0e17da8$exports))),
        alt: "",
        "aria-hidden": "true"
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($81839c9282ade394$exports))),
        alt: "",
        "aria-hidden": "true"
    });
}


var $a9cdc003ba228dda$exports = {};
$a9cdc003ba228dda$exports = $parcel$resolve("5eOiC");


function $20c32c73e36fc0b5$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9108a7a2191b8648$export$2e2bcd8739ae039), {
        className: "volunteer-context-menu",
        x: props.x,
        y: props.y,
        isClosing: props.isClosing,
        onRequestClose: props.onRequestClose,
        sections: [
            {
                className: 'volunteer-context-menu-actions',
                items: [
                    {
                        key: 'edit',
                        className: 'volunteer-context-action',
                        onClick: props.onEdit,
                        content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a9cdc003ba228dda$exports))),
                                    alt: "",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: "Edit"
                                })
                            ]
                        })
                    }
                ]
            },
            {
                className: 'volunteer-context-menu-actions',
                items: [
                    {
                        key: 'delete',
                        className: 'volunteer-context-action destructive',
                        disabled: props.canDelete === false,
                        onClick: props.onDelete,
                        content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb1d7f76a966659b$export$c8cea87c262cf9fb), {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: "Delete"
                                })
                            ]
                        })
                    }
                ]
            }
        ]
    });
}







var $7fPBF = parcelRequire("7fPBF");



var $7857575a213426db$exports = {};
"use strict";
Object.defineProperty($7857575a213426db$exports, "__esModule", {
    value: true
});
var $01d836b69da8407b$exports = {};
"use strict";
Object.defineProperty($01d836b69da8407b$exports, "__esModule", {
    value: true
});
$01d836b69da8407b$exports.bodyOpenClassName = $01d836b69da8407b$exports.portalClassName = undefined;
var $01d836b69da8407b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $01d836b69da8407b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");
var $01d836b69da8407b$var$_react2 = $01d836b69da8407b$var$_interopRequireDefault($7fPBF);

var $fw0lo = parcelRequire("fw0lo");
var $01d836b69da8407b$var$_reactDom2 = $01d836b69da8407b$var$_interopRequireDefault($fw0lo);

var $2oXYc = parcelRequire("2oXYc");
var $01d836b69da8407b$var$_propTypes2 = $01d836b69da8407b$var$_interopRequireDefault($2oXYc);
var $b5b678a3df90cd43$exports = {};
"use strict";
Object.defineProperty($b5b678a3df90cd43$exports, "__esModule", {
    value: true
});
var $b5b678a3df90cd43$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $b5b678a3df90cd43$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $b5b678a3df90cd43$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $7fPBF = parcelRequire("7fPBF");

var $2oXYc = parcelRequire("2oXYc");
var $b5b678a3df90cd43$var$_propTypes2 = $b5b678a3df90cd43$var$_interopRequireDefault($2oXYc);
var $bdd76cd1d420fe67$exports = {};
"use strict";
Object.defineProperty($bdd76cd1d420fe67$exports, "__esModule", {
    value: true
});
$bdd76cd1d420fe67$exports.resetState = $bdd76cd1d420fe67$var$resetState;
$bdd76cd1d420fe67$exports.log = $bdd76cd1d420fe67$var$log;
$bdd76cd1d420fe67$exports.handleBlur = $bdd76cd1d420fe67$var$handleBlur;
$bdd76cd1d420fe67$exports.handleFocus = $bdd76cd1d420fe67$var$handleFocus;
$bdd76cd1d420fe67$exports.markForFocusLater = $bdd76cd1d420fe67$var$markForFocusLater;
$bdd76cd1d420fe67$exports.returnFocus = $bdd76cd1d420fe67$var$returnFocus;
$bdd76cd1d420fe67$exports.popWithoutFocus = $bdd76cd1d420fe67$var$popWithoutFocus;
$bdd76cd1d420fe67$exports.setupScopedFocus = $bdd76cd1d420fe67$var$setupScopedFocus;
$bdd76cd1d420fe67$exports.teardownScopedFocus = $bdd76cd1d420fe67$var$teardownScopedFocus;
var $7db76db89ad06fec$exports = {};
"use strict";
Object.defineProperty($7db76db89ad06fec$exports, "__esModule", {
    value: true
});
$7db76db89ad06fec$exports.default = $7db76db89ad06fec$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $7db76db89ad06fec$var$DISPLAY_NONE = "none";
var $7db76db89ad06fec$var$DISPLAY_CONTENTS = "contents";
// match the whole word to prevent fuzzy searching
var $7db76db89ad06fec$var$tabbableNode = /^(input|select|textarea|button|object|iframe)$/;
function $7db76db89ad06fec$var$isNotOverflowing(element, style) {
    return style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
    element.scrollWidth <= 0 && element.scrollHeight <= 0;
}
function $7db76db89ad06fec$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        var displayValue = style.getPropertyValue("display");
        return zeroSize ? displayValue !== $7db76db89ad06fec$var$DISPLAY_CONTENTS && $7db76db89ad06fec$var$isNotOverflowing(element, style) : displayValue === $7db76db89ad06fec$var$DISPLAY_NONE;
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $7db76db89ad06fec$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($7db76db89ad06fec$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $7db76db89ad06fec$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $7db76db89ad06fec$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $7db76db89ad06fec$var$visible(element);
}
function $7db76db89ad06fec$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $7db76db89ad06fec$var$focusable(element, !isTabIndexNaN);
}
function $7db76db89ad06fec$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $7db76db89ad06fec$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($7db76db89ad06fec$var$tabbable);
}
$7db76db89ad06fec$exports = $7db76db89ad06fec$exports["default"];


var $bdd76cd1d420fe67$var$_tabbable2 = $bdd76cd1d420fe67$var$_interopRequireDefault($7db76db89ad06fec$exports);
function $bdd76cd1d420fe67$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $bdd76cd1d420fe67$var$focusLaterElements = [];
var $bdd76cd1d420fe67$var$modalElement = null;
var $bdd76cd1d420fe67$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $bdd76cd1d420fe67$var$resetState() {
    $bdd76cd1d420fe67$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $bdd76cd1d420fe67$var$log() {}
/* eslint-enable no-console */ function $bdd76cd1d420fe67$var$handleBlur() {
    $bdd76cd1d420fe67$var$needToFocus = true;
}
function $bdd76cd1d420fe67$var$handleFocus() {
    if ($bdd76cd1d420fe67$var$needToFocus) {
        $bdd76cd1d420fe67$var$needToFocus = false;
        if (!$bdd76cd1d420fe67$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($bdd76cd1d420fe67$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $bdd76cd1d420fe67$var$_tabbable2.default)($bdd76cd1d420fe67$var$modalElement)[0] || $bdd76cd1d420fe67$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $bdd76cd1d420fe67$var$markForFocusLater() {
    $bdd76cd1d420fe67$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $bdd76cd1d420fe67$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($bdd76cd1d420fe67$var$focusLaterElements.length !== 0) {
            toFocus = $bdd76cd1d420fe67$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $bdd76cd1d420fe67$var$popWithoutFocus() {
    $bdd76cd1d420fe67$var$focusLaterElements.length > 0 && $bdd76cd1d420fe67$var$focusLaterElements.pop();
}
function $bdd76cd1d420fe67$var$setupScopedFocus(element) {
    $bdd76cd1d420fe67$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $bdd76cd1d420fe67$var$handleBlur, false);
        document.addEventListener("focus", $bdd76cd1d420fe67$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $bdd76cd1d420fe67$var$handleBlur);
        document.attachEvent("onFocus", $bdd76cd1d420fe67$var$handleFocus);
    }
}
function $bdd76cd1d420fe67$var$teardownScopedFocus() {
    $bdd76cd1d420fe67$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $bdd76cd1d420fe67$var$handleBlur);
        document.removeEventListener("focus", $bdd76cd1d420fe67$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $bdd76cd1d420fe67$var$handleBlur);
        document.detachEvent("onFocus", $bdd76cd1d420fe67$var$handleFocus);
    }
}


var $b5b678a3df90cd43$var$focusManager = $b5b678a3df90cd43$var$_interopRequireWildcard($bdd76cd1d420fe67$exports);
var $6af62020494a2c19$exports = {};
"use strict";
Object.defineProperty($6af62020494a2c19$exports, "__esModule", {
    value: true
});
$6af62020494a2c19$exports.default = $6af62020494a2c19$var$scopeTab;

var $6af62020494a2c19$var$_tabbable2 = $6af62020494a2c19$var$_interopRequireDefault($7db76db89ad06fec$exports);
function $6af62020494a2c19$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6af62020494a2c19$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $6af62020494a2c19$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $6af62020494a2c19$var$scopeTab(node, event) {
    var tabbable = (0, $6af62020494a2c19$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $6af62020494a2c19$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
$6af62020494a2c19$exports = $6af62020494a2c19$exports["default"];


var $b5b678a3df90cd43$var$_scopeTab2 = $b5b678a3df90cd43$var$_interopRequireDefault($6af62020494a2c19$exports);
var $037a42a7720a4af2$exports = {};
"use strict";
Object.defineProperty($037a42a7720a4af2$exports, "__esModule", {
    value: true
});
$037a42a7720a4af2$exports.resetState = $037a42a7720a4af2$var$resetState;
$037a42a7720a4af2$exports.log = $037a42a7720a4af2$var$log;
$037a42a7720a4af2$exports.assertNodeList = $037a42a7720a4af2$var$assertNodeList;
$037a42a7720a4af2$exports.setElement = $037a42a7720a4af2$var$setElement;
$037a42a7720a4af2$exports.validateElement = $037a42a7720a4af2$var$validateElement;
$037a42a7720a4af2$exports.hide = $037a42a7720a4af2$var$hide;
$037a42a7720a4af2$exports.show = $037a42a7720a4af2$var$show;
$037a42a7720a4af2$exports.documentNotReadyOrSSRTesting = $037a42a7720a4af2$var$documentNotReadyOrSSRTesting;
var $4ceddc5ee7e9d694$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $4ceddc5ee7e9d694$var$__DEV__ = false;
var $4ceddc5ee7e9d694$var$warning = function() {};
if ($4ceddc5ee7e9d694$var$__DEV__) {
    var $4ceddc5ee7e9d694$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $4ceddc5ee7e9d694$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $4ceddc5ee7e9d694$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$4ceddc5ee7e9d694$exports = $4ceddc5ee7e9d694$var$warning;


var $037a42a7720a4af2$var$_warning2 = $037a42a7720a4af2$var$_interopRequireDefault($4ceddc5ee7e9d694$exports);
var $af300acd1d5fd7ac$exports = {};
"use strict";
Object.defineProperty($af300acd1d5fd7ac$exports, "__esModule", {
    value: true
});
$af300acd1d5fd7ac$exports.canUseDOM = $af300acd1d5fd7ac$exports.SafeNodeList = $af300acd1d5fd7ac$exports.SafeHTMLCollection = undefined;
var $913ab7e52a911d58$exports = {};
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    'use strict';
    var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== 'undefined',
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if ($913ab7e52a911d58$exports) $913ab7e52a911d58$exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();


var $af300acd1d5fd7ac$var$_exenv2 = $af300acd1d5fd7ac$var$_interopRequireDefault($913ab7e52a911d58$exports);
function $af300acd1d5fd7ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $af300acd1d5fd7ac$var$EE = $af300acd1d5fd7ac$var$_exenv2.default;
var $af300acd1d5fd7ac$var$SafeHTMLElement = $af300acd1d5fd7ac$var$EE.canUseDOM ? window.HTMLElement : {};
var $af300acd1d5fd7ac$var$SafeHTMLCollection = $af300acd1d5fd7ac$exports.SafeHTMLCollection = $af300acd1d5fd7ac$var$EE.canUseDOM ? window.HTMLCollection : {};
var $af300acd1d5fd7ac$var$SafeNodeList = $af300acd1d5fd7ac$exports.SafeNodeList = $af300acd1d5fd7ac$var$EE.canUseDOM ? window.NodeList : {};
var $af300acd1d5fd7ac$var$canUseDOM = $af300acd1d5fd7ac$exports.canUseDOM = $af300acd1d5fd7ac$var$EE.canUseDOM;
$af300acd1d5fd7ac$exports.default = $af300acd1d5fd7ac$var$SafeHTMLElement;


function $037a42a7720a4af2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $037a42a7720a4af2$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $037a42a7720a4af2$var$resetState() {
    if ($037a42a7720a4af2$var$globalElement) {
        if ($037a42a7720a4af2$var$globalElement.removeAttribute) $037a42a7720a4af2$var$globalElement.removeAttribute("aria-hidden");
        else if ($037a42a7720a4af2$var$globalElement.length != null) $037a42a7720a4af2$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($037a42a7720a4af2$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $037a42a7720a4af2$var$globalElement = null;
}
/* istanbul ignore next */ function $037a42a7720a4af2$var$log() {
    var check;
}
/* eslint-enable no-console */ function $037a42a7720a4af2$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $037a42a7720a4af2$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $af300acd1d5fd7ac$exports.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $037a42a7720a4af2$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $037a42a7720a4af2$var$globalElement = useElement || $037a42a7720a4af2$var$globalElement;
    return $037a42a7720a4af2$var$globalElement;
}
function $037a42a7720a4af2$var$validateElement(appElement) {
    var el = appElement || $037a42a7720a4af2$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $037a42a7720a4af2$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $037a42a7720a4af2$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $037a42a7720a4af2$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $037a42a7720a4af2$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $037a42a7720a4af2$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $037a42a7720a4af2$var$documentNotReadyOrSSRTesting() {
    $037a42a7720a4af2$var$globalElement = null;
}


var $b5b678a3df90cd43$var$ariaAppHider = $b5b678a3df90cd43$var$_interopRequireWildcard($037a42a7720a4af2$exports);
var $52182e4d88153cf9$exports = {};
"use strict";
Object.defineProperty($52182e4d88153cf9$exports, "__esModule", {
    value: true
});
$52182e4d88153cf9$exports.resetState = $52182e4d88153cf9$var$resetState;
$52182e4d88153cf9$exports.log = $52182e4d88153cf9$var$log;
var $52182e4d88153cf9$var$htmlClassList = {};
var $52182e4d88153cf9$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $52182e4d88153cf9$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $52182e4d88153cf9$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $52182e4d88153cf9$var$htmlClassList)$52182e4d88153cf9$var$removeClass(htmlElement, $52182e4d88153cf9$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $52182e4d88153cf9$var$docBodyClassList)$52182e4d88153cf9$var$removeClass(body, $52182e4d88153cf9$var$docBodyClassList[_cls]);
    $52182e4d88153cf9$var$htmlClassList = {};
    $52182e4d88153cf9$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $52182e4d88153cf9$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $52182e4d88153cf9$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $52182e4d88153cf9$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $52182e4d88153cf9$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $52182e4d88153cf9$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $52182e4d88153cf9$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $52182e4d88153cf9$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $52182e4d88153cf9$var$add = $52182e4d88153cf9$exports.add = function add(element, classString) {
    return $52182e4d88153cf9$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $52182e4d88153cf9$var$htmlClassList : $52182e4d88153cf9$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $52182e4d88153cf9$var$remove = $52182e4d88153cf9$exports.remove = function remove(element, classString) {
    return $52182e4d88153cf9$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $52182e4d88153cf9$var$htmlClassList : $52182e4d88153cf9$var$docBodyClassList, classString.split(" "));
};


var $b5b678a3df90cd43$var$classList = $b5b678a3df90cd43$var$_interopRequireWildcard($52182e4d88153cf9$exports);

var $b5b678a3df90cd43$var$_safeHTMLElement2 = $b5b678a3df90cd43$var$_interopRequireDefault($af300acd1d5fd7ac$exports);
var $6e0d329bb9e22275$exports = {};
"use strict";
Object.defineProperty($6e0d329bb9e22275$exports, "__esModule", {
    value: true
});
$6e0d329bb9e22275$exports.log = $6e0d329bb9e22275$var$log;
$6e0d329bb9e22275$exports.resetState = $6e0d329bb9e22275$var$resetState;
function $6e0d329bb9e22275$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $6e0d329bb9e22275$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $6e0d329bb9e22275$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $6e0d329bb9e22275$var$portalOpenInstances = new $6e0d329bb9e22275$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $6e0d329bb9e22275$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($6e0d329bb9e22275$var$portalOpenInstances.openInstances.length);
    $6e0d329bb9e22275$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $6e0d329bb9e22275$var$resetState() {
    $6e0d329bb9e22275$var$portalOpenInstances = new $6e0d329bb9e22275$var$PortalOpenInstances();
}
/* eslint-enable no-console */ $6e0d329bb9e22275$exports.default = $6e0d329bb9e22275$var$portalOpenInstances;


var $b5b678a3df90cd43$var$_portalOpenInstances2 = $b5b678a3df90cd43$var$_interopRequireDefault($6e0d329bb9e22275$exports);
var $f3e26d1d9b6811c1$exports = {};
"use strict";
Object.defineProperty($f3e26d1d9b6811c1$exports, "__esModule", {
    value: true
});
$f3e26d1d9b6811c1$exports.resetState = $f3e26d1d9b6811c1$var$resetState;
$f3e26d1d9b6811c1$exports.log = $f3e26d1d9b6811c1$var$log;

var $f3e26d1d9b6811c1$var$_portalOpenInstances2 = $f3e26d1d9b6811c1$var$_interopRequireDefault($6e0d329bb9e22275$exports);
function $f3e26d1d9b6811c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $f3e26d1d9b6811c1$var$before = void 0, $f3e26d1d9b6811c1$var$after = void 0, $f3e26d1d9b6811c1$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $f3e26d1d9b6811c1$var$resetState() {
    var _arr = [
        $f3e26d1d9b6811c1$var$before,
        $f3e26d1d9b6811c1$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $f3e26d1d9b6811c1$var$before = $f3e26d1d9b6811c1$var$after = null;
    $f3e26d1d9b6811c1$var$instances = [];
}
/* istanbul ignore next */ function $f3e26d1d9b6811c1$var$log() {
    console.log("bodyTrap ----------");
    console.log($f3e26d1d9b6811c1$var$instances.length);
    var _arr2 = [
        $f3e26d1d9b6811c1$var$before,
        $f3e26d1d9b6811c1$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $f3e26d1d9b6811c1$var$focusContent() {
    if ($f3e26d1d9b6811c1$var$instances.length === 0) return;
    $f3e26d1d9b6811c1$var$instances[$f3e26d1d9b6811c1$var$instances.length - 1].focusContent();
}
function $f3e26d1d9b6811c1$var$bodyTrap(eventType, openInstances) {
    if (!$f3e26d1d9b6811c1$var$before && !$f3e26d1d9b6811c1$var$after) {
        $f3e26d1d9b6811c1$var$before = document.createElement("div");
        $f3e26d1d9b6811c1$var$before.setAttribute("data-react-modal-body-trap", "");
        $f3e26d1d9b6811c1$var$before.style.position = "absolute";
        $f3e26d1d9b6811c1$var$before.style.opacity = "0";
        $f3e26d1d9b6811c1$var$before.setAttribute("tabindex", "0");
        $f3e26d1d9b6811c1$var$before.addEventListener("focus", $f3e26d1d9b6811c1$var$focusContent);
        $f3e26d1d9b6811c1$var$after = $f3e26d1d9b6811c1$var$before.cloneNode();
        $f3e26d1d9b6811c1$var$after.addEventListener("focus", $f3e26d1d9b6811c1$var$focusContent);
    }
    $f3e26d1d9b6811c1$var$instances = openInstances;
    if ($f3e26d1d9b6811c1$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $f3e26d1d9b6811c1$var$before) document.body.insertBefore($f3e26d1d9b6811c1$var$before, document.body.firstChild);
        if (document.body.lastChild !== $f3e26d1d9b6811c1$var$after) document.body.appendChild($f3e26d1d9b6811c1$var$after);
    } else {
        // Remove focus trap
        if ($f3e26d1d9b6811c1$var$before.parentElement) $f3e26d1d9b6811c1$var$before.parentElement.removeChild($f3e26d1d9b6811c1$var$before);
        if ($f3e26d1d9b6811c1$var$after.parentElement) $f3e26d1d9b6811c1$var$after.parentElement.removeChild($f3e26d1d9b6811c1$var$after);
    }
}
$f3e26d1d9b6811c1$var$_portalOpenInstances2.default.subscribe($f3e26d1d9b6811c1$var$bodyTrap);


function $b5b678a3df90cd43$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $b5b678a3df90cd43$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b5b678a3df90cd43$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b5b678a3df90cd43$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b5b678a3df90cd43$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $b5b678a3df90cd43$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
/**
 * We need to support the deprecated `KeyboardEvent.keyCode` in addition to
 * `KeyboardEvent.code` for apps that still support IE11. Can be removed when
 * `react-modal` only supports React >18 (which dropped IE support).
 */ var $b5b678a3df90cd43$var$isTabKey = function isTabKey(event) {
    return event.code === "Tab" || event.keyCode === 9;
};
var $b5b678a3df90cd43$var$isEscKey = function isEscKey(event) {
    return event.code === "Escape" || event.keyCode === 27;
};
var $b5b678a3df90cd43$var$ariaHiddenInstances = 0;
var $b5b678a3df90cd43$var$ModalPortal = function(_Component) {
    $b5b678a3df90cd43$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $b5b678a3df90cd43$var$_classCallCheck(this, ModalPortal);
        var _this = $b5b678a3df90cd43$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName, parentSelector = _this$props.parentSelector;
            var parentDocument = parentSelector && parentSelector().ownerDocument || document;
            // Remove classes.
            bodyOpenClassName && $b5b678a3df90cd43$var$classList.remove(parentDocument.body, bodyOpenClassName);
            htmlOpenClassName && $b5b678a3df90cd43$var$classList.remove(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $b5b678a3df90cd43$var$ariaHiddenInstances > 0) {
                $b5b678a3df90cd43$var$ariaHiddenInstances -= 1;
                if ($b5b678a3df90cd43$var$ariaHiddenInstances === 0) $b5b678a3df90cd43$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $b5b678a3df90cd43$var$focusManager.returnFocus(_this.props.preventScroll);
                    $b5b678a3df90cd43$var$focusManager.teardownScopedFocus();
                } else $b5b678a3df90cd43$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $b5b678a3df90cd43$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $b5b678a3df90cd43$var$focusManager.setupScopedFocus(_this.node);
                    $b5b678a3df90cd43$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if ($b5b678a3df90cd43$var$isTabKey(event)) (0, $b5b678a3df90cd43$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && $b5b678a3df90cd43$var$isEscKey(event)) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $b5b678a3df90cd43$var$_typeof(additional)) === "object" ? additional : {
                base: $b5b678a3df90cd43$var$CLASS_NAMES[which],
                afterOpen: $b5b678a3df90cd43$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $b5b678a3df90cd43$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $b5b678a3df90cd43$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName, parentSelector = _props.parentSelector;
                var parentDocument = parentSelector && parentSelector().ownerDocument || document;
                // Add classes.
                bodyOpenClassName && $b5b678a3df90cd43$var$classList.add(parentDocument.body, bodyOpenClassName);
                htmlOpenClassName && $b5b678a3df90cd43$var$classList.add(parentDocument.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $b5b678a3df90cd43$var$ariaHiddenInstances += 1;
                    $b5b678a3df90cd43$var$ariaAppHider.hide(appElement);
                }
                $b5b678a3df90cd43$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $b5b678a3df90cd43$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $b5b678a3df90cd43$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $b5b678a3df90cd43$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $b5b678a3df90cd43$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($7fPBF.Component);
$b5b678a3df90cd43$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$b5b678a3df90cd43$var$ModalPortal.propTypes = {
    isOpen: $b5b678a3df90cd43$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $b5b678a3df90cd43$var$_propTypes2.default.shape({
        content: $b5b678a3df90cd43$var$_propTypes2.default.object,
        overlay: $b5b678a3df90cd43$var$_propTypes2.default.object
    }),
    style: $b5b678a3df90cd43$var$_propTypes2.default.shape({
        content: $b5b678a3df90cd43$var$_propTypes2.default.object,
        overlay: $b5b678a3df90cd43$var$_propTypes2.default.object
    }),
    className: $b5b678a3df90cd43$var$_propTypes2.default.oneOfType([
        $b5b678a3df90cd43$var$_propTypes2.default.string,
        $b5b678a3df90cd43$var$_propTypes2.default.object
    ]),
    overlayClassName: $b5b678a3df90cd43$var$_propTypes2.default.oneOfType([
        $b5b678a3df90cd43$var$_propTypes2.default.string,
        $b5b678a3df90cd43$var$_propTypes2.default.object
    ]),
    parentSelector: $b5b678a3df90cd43$var$_propTypes2.default.func,
    bodyOpenClassName: $b5b678a3df90cd43$var$_propTypes2.default.string,
    htmlOpenClassName: $b5b678a3df90cd43$var$_propTypes2.default.string,
    ariaHideApp: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    appElement: $b5b678a3df90cd43$var$_propTypes2.default.oneOfType([
        $b5b678a3df90cd43$var$_propTypes2.default.instanceOf($b5b678a3df90cd43$var$_safeHTMLElement2.default),
        $b5b678a3df90cd43$var$_propTypes2.default.instanceOf($af300acd1d5fd7ac$exports.SafeHTMLCollection),
        $b5b678a3df90cd43$var$_propTypes2.default.instanceOf($af300acd1d5fd7ac$exports.SafeNodeList),
        $b5b678a3df90cd43$var$_propTypes2.default.arrayOf($b5b678a3df90cd43$var$_propTypes2.default.instanceOf($b5b678a3df90cd43$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $b5b678a3df90cd43$var$_propTypes2.default.func,
    onAfterClose: $b5b678a3df90cd43$var$_propTypes2.default.func,
    onRequestClose: $b5b678a3df90cd43$var$_propTypes2.default.func,
    closeTimeoutMS: $b5b678a3df90cd43$var$_propTypes2.default.number,
    shouldFocusAfterRender: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    preventScroll: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    role: $b5b678a3df90cd43$var$_propTypes2.default.string,
    contentLabel: $b5b678a3df90cd43$var$_propTypes2.default.string,
    aria: $b5b678a3df90cd43$var$_propTypes2.default.object,
    data: $b5b678a3df90cd43$var$_propTypes2.default.object,
    children: $b5b678a3df90cd43$var$_propTypes2.default.node,
    shouldCloseOnEsc: $b5b678a3df90cd43$var$_propTypes2.default.bool,
    overlayRef: $b5b678a3df90cd43$var$_propTypes2.default.func,
    contentRef: $b5b678a3df90cd43$var$_propTypes2.default.func,
    id: $b5b678a3df90cd43$var$_propTypes2.default.string,
    overlayElement: $b5b678a3df90cd43$var$_propTypes2.default.func,
    contentElement: $b5b678a3df90cd43$var$_propTypes2.default.func,
    testId: $b5b678a3df90cd43$var$_propTypes2.default.string
};
$b5b678a3df90cd43$exports.default = $b5b678a3df90cd43$var$ModalPortal;
$b5b678a3df90cd43$exports = $b5b678a3df90cd43$exports["default"];


var $01d836b69da8407b$var$_ModalPortal2 = $01d836b69da8407b$var$_interopRequireDefault($b5b678a3df90cd43$exports);

var $01d836b69da8407b$var$ariaAppHider = $01d836b69da8407b$var$_interopRequireWildcard($037a42a7720a4af2$exports);

var $01d836b69da8407b$var$_safeHTMLElement2 = $01d836b69da8407b$var$_interopRequireDefault($af300acd1d5fd7ac$exports);
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $bd136de90080c1b8$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $bd136de90080c1b8$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $bd136de90080c1b8$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$bd136de90080c1b8$var$componentWillMount.__suppressDeprecationWarning = true;
$bd136de90080c1b8$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$bd136de90080c1b8$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $bd136de90080c1b8$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $bd136de90080c1b8$var$componentWillMount;
        prototype.componentWillReceiveProps = $bd136de90080c1b8$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $bd136de90080c1b8$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}


function $01d836b69da8407b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $01d836b69da8407b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $01d836b69da8407b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $01d836b69da8407b$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $01d836b69da8407b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $01d836b69da8407b$var$portalClassName = $01d836b69da8407b$exports.portalClassName = "ReactModalPortal";
var $01d836b69da8407b$var$bodyOpenClassName = $01d836b69da8407b$exports.bodyOpenClassName = "ReactModal__Body--open";
var $01d836b69da8407b$var$isReact16 = $af300acd1d5fd7ac$exports.canUseDOM && $01d836b69da8407b$var$_reactDom2.default.createPortal !== undefined;
var $01d836b69da8407b$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $01d836b69da8407b$var$getCreatePortal = function getCreatePortal() {
    return $01d836b69da8407b$var$isReact16 ? $01d836b69da8407b$var$_reactDom2.default.createPortal : $01d836b69da8407b$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $01d836b69da8407b$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $01d836b69da8407b$var$Modal = function(_Component) {
    $01d836b69da8407b$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $01d836b69da8407b$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $01d836b69da8407b$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$01d836b69da8407b$var$isReact16 && $01d836b69da8407b$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $01d836b69da8407b$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $01d836b69da8407b$var$getCreatePortal();
            var portal = createPortal(_this, $01d836b69da8407b$var$_react2.default.createElement($01d836b69da8407b$var$_ModalPortal2.default, $01d836b69da8407b$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $01d836b69da8407b$var$_possibleConstructorReturn(_this, _ret);
    }
    $01d836b69da8407b$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$af300acd1d5fd7ac$exports.canUseDOM) return;
                if (!$01d836b69da8407b$var$isReact16) this.node = $01d836b69da8407b$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $01d836b69da8407b$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$01d836b69da8407b$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $01d836b69da8407b$var$getParentElement(prevProps.parentSelector);
                var nextParent = $01d836b69da8407b$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$af300acd1d5fd7ac$exports.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$01d836b69da8407b$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$af300acd1d5fd7ac$exports.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$af300acd1d5fd7ac$exports.canUseDOM || !$01d836b69da8407b$var$isReact16) return null;
                if (!this.node && $01d836b69da8407b$var$isReact16) this.node = $01d836b69da8407b$var$createHTMLElement("div");
                var createPortal = $01d836b69da8407b$var$getCreatePortal();
                return createPortal($01d836b69da8407b$var$_react2.default.createElement($01d836b69da8407b$var$_ModalPortal2.default, $01d836b69da8407b$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $01d836b69da8407b$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($7fPBF.Component);
$01d836b69da8407b$var$Modal.propTypes = {
    isOpen: $01d836b69da8407b$var$_propTypes2.default.bool.isRequired,
    style: $01d836b69da8407b$var$_propTypes2.default.shape({
        content: $01d836b69da8407b$var$_propTypes2.default.object,
        overlay: $01d836b69da8407b$var$_propTypes2.default.object
    }),
    portalClassName: $01d836b69da8407b$var$_propTypes2.default.string,
    bodyOpenClassName: $01d836b69da8407b$var$_propTypes2.default.string,
    htmlOpenClassName: $01d836b69da8407b$var$_propTypes2.default.string,
    className: $01d836b69da8407b$var$_propTypes2.default.oneOfType([
        $01d836b69da8407b$var$_propTypes2.default.string,
        $01d836b69da8407b$var$_propTypes2.default.shape({
            base: $01d836b69da8407b$var$_propTypes2.default.string.isRequired,
            afterOpen: $01d836b69da8407b$var$_propTypes2.default.string.isRequired,
            beforeClose: $01d836b69da8407b$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $01d836b69da8407b$var$_propTypes2.default.oneOfType([
        $01d836b69da8407b$var$_propTypes2.default.string,
        $01d836b69da8407b$var$_propTypes2.default.shape({
            base: $01d836b69da8407b$var$_propTypes2.default.string.isRequired,
            afterOpen: $01d836b69da8407b$var$_propTypes2.default.string.isRequired,
            beforeClose: $01d836b69da8407b$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $01d836b69da8407b$var$_propTypes2.default.oneOfType([
        $01d836b69da8407b$var$_propTypes2.default.instanceOf($01d836b69da8407b$var$_safeHTMLElement2.default),
        $01d836b69da8407b$var$_propTypes2.default.instanceOf($af300acd1d5fd7ac$exports.SafeHTMLCollection),
        $01d836b69da8407b$var$_propTypes2.default.instanceOf($af300acd1d5fd7ac$exports.SafeNodeList),
        $01d836b69da8407b$var$_propTypes2.default.arrayOf($01d836b69da8407b$var$_propTypes2.default.instanceOf($01d836b69da8407b$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $01d836b69da8407b$var$_propTypes2.default.func,
    onRequestClose: $01d836b69da8407b$var$_propTypes2.default.func,
    closeTimeoutMS: $01d836b69da8407b$var$_propTypes2.default.number,
    ariaHideApp: $01d836b69da8407b$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $01d836b69da8407b$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $01d836b69da8407b$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $01d836b69da8407b$var$_propTypes2.default.bool,
    preventScroll: $01d836b69da8407b$var$_propTypes2.default.bool,
    parentSelector: $01d836b69da8407b$var$_propTypes2.default.func,
    aria: $01d836b69da8407b$var$_propTypes2.default.object,
    data: $01d836b69da8407b$var$_propTypes2.default.object,
    role: $01d836b69da8407b$var$_propTypes2.default.string,
    contentLabel: $01d836b69da8407b$var$_propTypes2.default.string,
    shouldCloseOnEsc: $01d836b69da8407b$var$_propTypes2.default.bool,
    overlayRef: $01d836b69da8407b$var$_propTypes2.default.func,
    contentRef: $01d836b69da8407b$var$_propTypes2.default.func,
    id: $01d836b69da8407b$var$_propTypes2.default.string,
    overlayElement: $01d836b69da8407b$var$_propTypes2.default.func,
    contentElement: $01d836b69da8407b$var$_propTypes2.default.func
};
$01d836b69da8407b$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $01d836b69da8407b$var$portalClassName,
    bodyOpenClassName: $01d836b69da8407b$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $01d836b69da8407b$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $01d836b69da8407b$var$_react2.default.createElement("div", props, children);
    }
};
$01d836b69da8407b$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $bd136de90080c1b8$export$cea1c58a6db52bca)($01d836b69da8407b$var$Modal);
$01d836b69da8407b$exports.default = $01d836b69da8407b$var$Modal;


var $7857575a213426db$var$_Modal2 = $7857575a213426db$var$_interopRequireDefault($01d836b69da8407b$exports);
function $7857575a213426db$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$7857575a213426db$exports.default = $7857575a213426db$var$_Modal2.default;
$7857575a213426db$exports = $7857575a213426db$exports["default"];


var $63d64463cd01676b$export$46c1ead11549edea = /*#__PURE__*/ function(ModalButtonStyle) {
    ModalButtonStyle["FILLED"] = "filled";
    ModalButtonStyle["OUTLINE"] = "outline";
    return ModalButtonStyle;
}({});
function $63d64463cd01676b$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7857575a213426db$exports))), {
        isOpen: props.isOpen,
        id: props.id,
        closeTimeoutMS: 200,
        className: "modal",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "content-holder",
            children: [
                props.headerTitle !== undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "header",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: props.headerTitle
                    })
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "modal-content",
                    children: props.children
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("footer", {
                    style: props.footerButtons.length === 1 ? {
                        gridTemplateColumns: '1fr'
                    } : {},
                    children: props.footerButtons.map((button)=>{
                        var _button_enabled;
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            className: `button-${button.style} ${!((_button_enabled = button.enabled) !== null && _button_enabled !== void 0 ? _button_enabled : true) ? 'disabled' : ''}`,
                            onClick: (e)=>{
                                e.preventDefault();
                                if (button.enabled !== undefined && !button.enabled) return;
                                button.onClick();
                            },
                            children: button.title
                        }, button.title);
                    })
                })
            ]
        })
    });
}



class $2feff408b41eeb4d$export$2e2bcd8739ae039 {
    // Creating the account emails them to set up a password. The API rejects an
    // email another staff account, at any church, already uses.
    static async inviteStaffMember(churchID, name, email, roles, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/staff`, {
            name: name,
            email: email,
            roles: roles
        }), auth.consumeRefreshToken);
    }
    // The API only takes a new name and roles; the email is their sign in and
    // can't change. It refuses to take away the requester's own Admin role.
    static async editStaffMember(churchID, staffID, name, roles, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/staff/${staffID}`, {
            name: name,
            roles: roles
        }), auth.consumeRefreshToken);
    }
    // The API refuses to delete an admin, or the requester themselves.
    static async deleteStaffMember(churchID, staffID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/staff/${staffID}`), auth.consumeRefreshToken);
    }
}
$2feff408b41eeb4d$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";



var $3254a4d5e28fabfa$exports = {};
$3254a4d5e28fabfa$exports = $parcel$resolve("jCnJv");


function $ebcc3926585f46a0$export$2e2bcd8739ae039(props) {
    var _props_staff, _props_staff1, _props_staff2;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const isEditing = Boolean(props.staff);
    var _props_staff_name;
    const [name, setName] = (0, $7fPBF.useState)((_props_staff_name = (_props_staff = props.staff) === null || _props_staff === void 0 ? void 0 : _props_staff.name) !== null && _props_staff_name !== void 0 ? _props_staff_name : '');
    var _props_staff_email;
    const [email, setEmail] = (0, $7fPBF.useState)((_props_staff_email = (_props_staff1 = props.staff) === null || _props_staff1 === void 0 ? void 0 : _props_staff1.email) !== null && _props_staff_email !== void 0 ? _props_staff_email : '');
    var _props_staff_roles;
    const [roles, setRoles] = (0, $7fPBF.useState)((_props_staff_roles = (_props_staff2 = props.staff) === null || _props_staff2 === void 0 ? void 0 : _props_staff2.roles) !== null && _props_staff_roles !== void 0 ? _props_staff_roles : []);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const nameInputRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        var _nameInputRef_current;
        if (props.isOpen) (_nameInputRef_current = nameInputRef.current) === null || _nameInputRef_current === void 0 ? void 0 : _nameInputRef_current.focus({
            preventScroll: true
        });
    }, [
        props.isOpen
    ]);
    // Legacy roles a member still holds are shown alongside the current ones, so
    // they can be seen and taken away.
    const legacyRoles = roles.filter((role)=>!(0, $490c7b02975ed1ea$export$613954afd987de13).includes(role));
    const pickableRoles = [
        ...(0, $490c7b02975ed1ea$export$613954afd987de13),
        ...legacyRoles
    ];
    const trimmedName = name.trim();
    const trimmedEmail = email.trim();
    const hasChanges = !props.staff || trimmedName !== props.staff.name || roles.length !== props.staff.roles.length || roles.some((role)=>!props.staff.roles.includes(role));
    const canSave = trimmedName.length > 0 && (isEditing || trimmedEmail.includes('@')) && roles.length > 0 && hasChanges && !isSaving;
    const toggleRole = (role)=>{
        setRoles((currentRoles)=>currentRoles.includes(role) ? currentRoles.filter((heldRole)=>heldRole !== role) : [
                ...currentRoles,
                role
            ]);
    };
    const save = async ()=>{
        if (!auth.churchId) {
            setError('Missing church context. Please refresh and try again.');
            return;
        }
        if (!canSave) return;
        setIsSaving(true);
        setError(null);
        try {
            const response = props.staff ? await (0, $2feff408b41eeb4d$export$2e2bcd8739ae039).editStaffMember(auth.churchId, props.staff.id, trimmedName, roles, auth) : await (0, $2feff408b41eeb4d$export$2e2bcd8739ae039).inviteStaffMember(auth.churchId, trimmedName, trimmedEmail, roles, auth);
            if (response.error) {
                setError(response.error);
                return;
            }
            props.onSaved();
        } finally{
            setIsSaving(false);
        }
    };
    let submitTitle = isEditing ? 'Save Changes' : 'Send Invite';
    if (isSaving) submitTitle = isEditing ? 'Saving...' : 'Sending...';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "staff-member-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "staff-member-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            disabled: isSaving,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: isEditing ? 'Edit Staff Member' : 'Invite Staff Member'
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "header-control-spacer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                    className: "staff-form",
                    onSubmit: (e)=>{
                        e.preventDefault();
                        save();
                    },
                    children: [
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "section",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "input",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "text",
                                        name: "name",
                                        placeholder: "Name",
                                        "aria-label": "Name",
                                        autoComplete: "off",
                                        value: name,
                                        ref: nameInputRef,
                                        disabled: isSaving,
                                        onChange: (e)=>setName(e.target.value)
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "separator"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "input",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "email",
                                        name: "email",
                                        placeholder: "Email",
                                        "aria-label": "Email",
                                        autoComplete: "off",
                                        value: email,
                                        // The account is tied to its email, so it can't be changed here.
                                        disabled: isSaving || isEditing,
                                        onChange: (e)=>setEmail(e.target.value)
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                            className: "section-title",
                            children: "Roles"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "section",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "role-picker",
                                role: "group",
                                "aria-label": "Roles",
                                children: pickableRoles.map((role)=>{
                                    const isSelected = roles.includes(role);
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "button",
                                        className: isSelected ? 'role-chip is-selected' : 'role-chip',
                                        "aria-pressed": isSelected,
                                        disabled: isSaving,
                                        onClick: ()=>toggleRole(role),
                                        children: role
                                    }, role);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "footnote",
                            children: isEditing ? 'Roles decide which parts of Church Hub this person can see and change.' : 'Roles determine what this staff member has access to within Church Hub. You can always add or remove them later.'
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "submit",
                            className: "submit",
                            disabled: !canSave,
                            children: submitTitle
                        })
                    ]
                })
            ]
        })
    });
}





var $7fPBF = parcelRequire("7fPBF");




function $cf60f4bc1b64387d$export$2e2bcd8739ae039(props) {
    var _props_staff;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [isDeleting, setIsDeleting] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const deleteStaffMember = async ()=>{
        if (!auth.churchId || !props.staff) {
            setError('Missing church context. Please refresh and try again.');
            return;
        }
        setIsDeleting(true);
        setError(null);
        try {
            const response = await (0, $2feff408b41eeb4d$export$2e2bcd8739ae039).deleteStaffMember(auth.churchId, props.staff.id, auth);
            if (response.error) {
                setError(response.error);
                return;
            }
            props.onDeleted();
        } finally{
            setIsDeleting(false);
        }
    };
    var _props_staff_name;
    const name = (_props_staff_name = (_props_staff = props.staff) === null || _props_staff === void 0 ? void 0 : _props_staff.name) !== null && _props_staff_name !== void 0 ? _props_staff_name : 'this staff member';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "delete-staff-member-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "delete-staff-member-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            disabled: isDeleting,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: "Delete Staff Member"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "header-control-spacer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "delete-copy",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("strong", {
                                children: [
                                    "Delete ",
                                    name,
                                    "'s Church Hub account?"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "caption",
                            children: "They'll no longer be able to sign in to Church Hub. You can invite them again at any time."
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "delete-button",
                            disabled: isDeleting,
                            onClick: ()=>{
                                deleteStaffMember();
                            },
                            children: isDeleting ? 'Deleting...' : 'Delete Staff Member'
                        })
                    ]
                })
            ]
        })
    });
}


// Matches the context menu's exit animation.
const $0df0f1e0da66b712$var$MENU_EXIT_DURATION_MS = 140;
function $0df0f1e0da66b712$export$2e2bcd8739ae039() {
    var _auth_user;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { staff: staff, reloadChurch: reloadChurch } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    (0, $7fPBF.useEffect)(()=>{
        reloadChurch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Keyed per open, so each open starts from the member as they are now. A
    // null member means inviting someone new.
    const [memberForEdit, setMemberForEdit] = (0, $7fPBF.useState)(null);
    const [isMemberModalOpen, setIsMemberModalOpen] = (0, $7fPBF.useState)(false);
    const [memberModalKey, setMemberModalKey] = (0, $7fPBF.useState)(0);
    const openMemberModal = (member)=>{
        setMemberForEdit(member);
        setMemberModalKey((currentKey)=>currentKey + 1);
        setIsMemberModalOpen(true);
    };
    const [memberForDelete, setMemberForDelete] = (0, $7fPBF.useState)(null);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $7fPBF.useState)(false);
    const closeDeleteModal = ()=>{
        setIsDeleteModalOpen(false);
        window.setTimeout(()=>{
            setMemberForDelete(null);
        }, 200);
    };
    // The menu stays mounted through its exit animation, so the selected and
    // displayed states are tracked separately.
    const [selectedMenu, setSelectedMenu] = (0, $7fPBF.useState)(null);
    const [displayedMenu, setDisplayedMenu] = (0, $7fPBF.useState)(null);
    const [isClosingMenu, setIsClosingMenu] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (selectedMenu) {
            setDisplayedMenu(selectedMenu);
            setIsClosingMenu(false);
            return;
        }
        if (!displayedMenu) {
            setIsClosingMenu(false);
            return;
        }
        setIsClosingMenu(true);
        const timeout = window.setTimeout(()=>{
            setDisplayedMenu(null);
            setIsClosingMenu(false);
        }, $0df0f1e0da66b712$var$MENU_EXIT_DURATION_MS);
        return ()=>window.clearTimeout(timeout);
    }, [
        selectedMenu,
        displayedMenu
    ]);
    const sortedStaff = [
        ...staff
    ].sort((one, two)=>one.name.localeCompare(two.name));
    var _memberForDelete_id;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "staff-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ae515035e6d7062$export$2e2bcd8739ae039), {
                title: "Staff Members",
                tabs: [],
                buttons: [
                    {
                        icon: 'add',
                        label: 'Invite Staff Member',
                        onClick: ()=>openMemberModal(null)
                    }
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebcc3926585f46a0$export$2e2bcd8739ae039), {
                isOpen: isMemberModalOpen,
                staff: memberForEdit,
                close: ()=>setIsMemberModalOpen(false),
                onSaved: ()=>{
                    setIsMemberModalOpen(false);
                    reloadChurch();
                }
            }, `staff-member-${memberModalKey}`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cf60f4bc1b64387d$export$2e2bcd8739ae039), {
                isOpen: isDeleteModalOpen,
                staff: memberForDelete,
                close: closeDeleteModal,
                onDeleted: ()=>{
                    closeDeleteModal();
                    reloadChurch();
                }
            }, (_memberForDelete_id = memberForDelete === null || memberForDelete === void 0 ? void 0 : memberForDelete.id) !== null && _memberForDelete_id !== void 0 ? _memberForDelete_id : 'delete-staff-member'),
            displayedMenu ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $20c32c73e36fc0b5$export$2e2bcd8739ae039), {
                x: displayedMenu.x,
                y: displayedMenu.y,
                isClosing: isClosingMenu,
                onRequestClose: ()=>setSelectedMenu(null),
                canDelete: displayedMenu.staff.id !== ((_auth_user = auth.user) === null || _auth_user === void 0 ? void 0 : _auth_user.id),
                onEdit: ()=>{
                    setSelectedMenu(null);
                    openMemberModal(displayedMenu.staff);
                },
                onDelete: ()=>{
                    setSelectedMenu(null);
                    setMemberForDelete(displayedMenu.staff);
                    setIsDeleteModalOpen(true);
                }
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "staff",
                children: sortedStaff.map((member)=>{
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2baa135e072363db$export$2e2bcd8739ae039), {
                        name: member.name,
                        email: [
                            ...member.roles
                        ].sort().join(', '),
                        onClick: (event)=>{
                            setSelectedMenu({
                                staff: member,
                                x: event.clientX + window.scrollX,
                                y: event.clientY + window.scrollY
                            });
                        }
                    }, member.id);
                })
            })
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");


class $aadf679b6bdf08ee$export$2e2bcd8739ae039 {
    static async fetchPlaylists(churchID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/library/playlist`), auth.consumeRefreshToken);
    }
    static async fetchPlaylist(churchID, playlistID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/library/playlist/${playlistID}`), auth.consumeRefreshToken);
    }
    static async createPlaylist(churchID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/library/playlist`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    // Replaces the playlist's name, campus and category; its songs are left as
    // they are. Needs the Playlist Manager role.
    static async updatePlaylist(churchID, playlistID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/library/playlist/${playlistID}`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    // Permanently removes a playlist and its songs. Needs the Playlist Manager
    // role.
    static async deletePlaylist(churchID, playlistID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/library/playlist/${playlistID}`), auth.consumeRefreshToken);
    }
    static async addSongToPlaylist(churchID, playlistID, songAttributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/library/playlist/${playlistID}/songs`, songAttributes), auth.consumeRefreshToken);
    }
    static async removeSongFromPlaylist(churchID, playlistID, songID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/library/playlist/${playlistID}/songs/${songID}`), auth.consumeRefreshToken);
    }
}
$aadf679b6bdf08ee$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";


function $32995cb92df30107$export$2e2bcd8739ae039(providedChurchId) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchId = providedChurchId || auth.churchId;
    const [playlists, setPlaylists] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchId) return;
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $aadf679b6bdf08ee$export$2e2bcd8739ae039).fetchPlaylists(churchId, auth);
            if (response.error) {
                setError(response.error);
                setPlaylists(null);
            } else if (response.body) setPlaylists(response.body);
            else setPlaylists(null);
        } catch (err) {
            setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to load playlists');
            setPlaylists(null);
        } finally{
            setLoading(false);
        }
    }, [
        churchId,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!churchId) return;
        fetch();
    }, [
        churchId,
        fetch
    ]);
    const createPlaylist = (0, $7fPBF.useCallback)(async (attributes)=>{
        if (!churchId) return {
            error: 'Missing church ID.'
        };
        const response = await (0, $aadf679b6bdf08ee$export$2e2bcd8739ae039).createPlaylist(churchId, attributes, auth);
        if (response.error) return {
            error: response.error
        };
        if (response.body) setPlaylists((currentPlaylists)=>{
            if (currentPlaylists === null) return [
                response.body
            ];
            return [
                response.body,
                ...currentPlaylists
            ];
        });
        var _response_body;
        return {
            playlist: (_response_body = response.body) !== null && _response_body !== void 0 ? _response_body : null
        };
    }, [
        churchId,
        auth
    ]);
    return {
        playlists: playlists,
        loading: loading,
        error: error,
        refetch: fetch,
        createPlaylist: createPlaylist
    };
}






var $7fPBF = parcelRequire("7fPBF");
function $ebf906ca24cd582c$export$2e2bcd8739ae039(props = {
    fullScreen: true
}) {
    var _props_delayMs;
    const delayMs = (_props_delayMs = props.delayMs) !== null && _props_delayMs !== void 0 ? _props_delayMs : 0;
    const [isVisible, setIsVisible] = (0, $7fPBF.useState)(delayMs === 0);
    (0, $7fPBF.useEffect)(()=>{
        if (delayMs === 0) return;
        const timeout = window.setTimeout(()=>setIsVisible(true), delayMs);
        return ()=>window.clearTimeout(timeout);
    }, [
        delayMs
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: props.fullScreen === undefined || props.fullScreen === true ? "loading-indicator full-screen" : 'loading-indicator',
        children: isVisible ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "loading-spinner"
        }) : null
    });
}




var $5407115776bd457c$exports = {};
$5407115776bd457c$exports = $parcel$resolve("kroiJ");



function $1bcae8edd2c9b338$export$2e2bcd8739ae039(props) {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const icon = props.icon === undefined ? (0, (/*@__PURE__*/$parcel$interopDefault($5407115776bd457c$exports))) : props.icon;
    var _props_title, _props_buttonAction, _props_buttonText;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: props.fullHeight ? 'error-view full-height' : 'error-view',
        children: [
            icon ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: icon,
                alt: "",
                "aria-hidden": "true"
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: (_props_title = props.title) !== null && _props_title !== void 0 ? _props_title : 'Error'
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: props.error
            }),
            props.showButton !== false ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                href: "#",
                onClick: (_props_buttonAction = props.buttonAction) !== null && _props_buttonAction !== void 0 ? _props_buttonAction : ()=>navigate(-1),
                children: (_props_buttonText = props.buttonText) !== null && _props_buttonText !== void 0 ? _props_buttonText : "Go Back"
            }) : null
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");




var $d5bdfc11cea11cc4$exports = {};
$d5bdfc11cea11cc4$exports = $parcel$resolve("bkeVr");



function $a39d0220e0abc509$export$2e2bcd8739ae039(props) {
    const isEditing = Boolean(props.playlist);
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const [name, setName] = (0, $7fPBF.useState)('');
    const [campusID, setCampusID] = (0, $7fPBF.useState)('');
    const [categoryID, setCategoryID] = (0, $7fPBF.useState)('');
    const [error, setError] = (0, $7fPBF.useState)(null);
    // Each open starts from the playlist being edited, or blank for a new one.
    (0, $7fPBF.useEffect)(()=>{
        if (props.isOpen) {
            var _props_playlist, _props_playlist1, _props_playlist2;
            var _props_playlist_attributes_name;
            setName((_props_playlist_attributes_name = (_props_playlist = props.playlist) === null || _props_playlist === void 0 ? void 0 : _props_playlist.attributes.name) !== null && _props_playlist_attributes_name !== void 0 ? _props_playlist_attributes_name : '');
            var _props_playlist_attributes_campusID;
            setCampusID((_props_playlist_attributes_campusID = (_props_playlist1 = props.playlist) === null || _props_playlist1 === void 0 ? void 0 : _props_playlist1.attributes.campusID) !== null && _props_playlist_attributes_campusID !== void 0 ? _props_playlist_attributes_campusID : '');
            var _props_playlist_attributes_categoryID;
            setCategoryID((_props_playlist_attributes_categoryID = (_props_playlist2 = props.playlist) === null || _props_playlist2 === void 0 ? void 0 : _props_playlist2.attributes.categoryID) !== null && _props_playlist_attributes_categoryID !== void 0 ? _props_playlist_attributes_categoryID : '');
            setError(null);
            setSaving(false);
        }
    }, [
        props.isOpen,
        props.playlist
    ]);
    const submit = async ()=>{
        if (saving || name.trim().length === 0) return;
        setSaving(true);
        setError(null);
        const response = await props.onSave({
            name: name.trim(),
            campusID: campusID || null,
            categoryID: categoryID || null
        });
        if (response.error) {
            setError(response.error);
            setSaving(false);
            return;
        }
        props.setIsOpen(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7857575a213426db$exports))), {
        isOpen: props.isOpen,
        id: "add-playlist-modal",
        closeTimeoutMS: 200,
        className: "modal add-playlist-modal-shell",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "add-playlist-modal",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "add-playlist-modal-header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "add-playlist-modal-header-control close",
                            disabled: saving,
                            onClick: ()=>{
                                props.setIsOpen(false);
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            children: isEditing ? 'Edit Playlist' : 'New Playlist'
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "add-playlist-modal-header-control confirm",
                            disabled: saving || name.trim().length === 0,
                            onClick: ()=>{
                                submit();
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d5bdfc11cea11cc4$exports))),
                                alt: "Confirm icon"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "add-playlist-modal-body",
                    children: saving ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "add-playlist-modal-loading-state",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                            fullScreen: false
                        })
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "add-playlist-modal-error",
                                children: error
                            }) : null,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "field-container",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "playlist-name",
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        id: "playlist-name",
                                        type: "text",
                                        value: name,
                                        placeholder: "Popular Worship Songs",
                                        onChange: (e)=>setName(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "field-container",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "playlist-campus",
                                        children: "Campus"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                        id: "playlist-campus",
                                        value: campusID,
                                        onChange: (e)=>setCampusID(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: "",
                                                children: "No campus"
                                            }),
                                            churchData.campuses.map((campus)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: campus.id,
                                                    children: campus.attributes.name
                                                }, campus.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "field-container",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "playlist-category",
                                        children: "Category"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                        id: "playlist-category",
                                        value: categoryID,
                                        onChange: (e)=>setCategoryID(e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: "",
                                                children: "No category"
                                            }),
                                            churchData.categories.map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: category.id,
                                                    children: category.name
                                                }, category.id))
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}



var $7fPBF = parcelRequire("7fPBF");

var $f4ad1f40df3d002c$exports = {};
$f4ad1f40df3d002c$exports = $parcel$resolve("2cdBw");



function $642e727260322576$export$2e2bcd8739ae039() {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const { playlists: playlists, loading: loading, error: error, refetch: refetch, createPlaylist: createPlaylist } = (0, $32995cb92df30107$export$2e2bcd8739ae039)();
    const [isAddPlaylistModalOpen, setIsAddPlaylistModalOpen] = (0, $7fPBF.useState)(false);
    const groupedPlaylists = $642e727260322576$var$groupPlaylists(playlists || [], churchData.campuses, churchData.categories);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "playlists",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a39d0220e0abc509$export$2e2bcd8739ae039), {
                isOpen: isAddPlaylistModalOpen,
                setIsOpen: setIsAddPlaylistModalOpen,
                onSave: createPlaylist
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ae515035e6d7062$export$2e2bcd8739ae039), {
                title: "Playlists",
                tabs: [],
                buttons: [
                    {
                        icon: 'add',
                        label: 'Create Playlist',
                        onClick: ()=>{
                            setIsAddPlaylistModalOpen(true);
                        }
                    }
                ]
            }),
            loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                fullScreen: true
            }) : null,
            error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                error: error,
                buttonText: "Retry",
                buttonAction: ()=>refetch()
            }) : null,
            groupedPlaylists.map((campusGroup)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                    className: "playlist-campus-group",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "playlist-group-heading",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: campusGroup.title
                            })
                        }),
                        campusGroup.categories.map((categoryGroup)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "playlist-category-group",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "playlist-group-subheading",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            children: categoryGroup.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "playlists-list",
                                        children: categoryGroup.playlists.map((playlist)=>{
                                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                                type: "button",
                                                className: "playlist",
                                                onClick: ()=>{
                                                    navigate(`/playlists/${playlist.id}`, {
                                                        state: {
                                                            playlist: playlist
                                                        }
                                                    });
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($642e727260322576$var$PlaylistDetail, {
                                                        playlist: playlist
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                        className: "playlist-info",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                                className: "title",
                                                                children: playlist.attributes.name
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                                                className: "subtitle",
                                                                children: [
                                                                    playlist.songs.length,
                                                                    " song",
                                                                    playlist.songs.length !== 1 ? 's' : ''
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, playlist.id);
                                        })
                                    })
                                ]
                            }, categoryGroup.id))
                    ]
                }, campusGroup.id))
        ]
    });
}
function $642e727260322576$var$groupPlaylists(playlists, campuses, categories) {
    const campusNameByID = new Map(campuses.map((campus)=>[
            campus.id,
            campus.attributes.name
        ]));
    const categoryNameByID = new Map(categories.map((category)=>[
            category.id,
            category.name
        ]));
    const sortedPlaylists = [
        ...playlists
    ].sort((a, b)=>{
        const campusA = $642e727260322576$var$getCampusLabel(a, campusNameByID);
        const campusB = $642e727260322576$var$getCampusLabel(b, campusNameByID);
        if (campusA !== campusB) return campusA.localeCompare(campusB);
        const categoryA = $642e727260322576$var$getCategoryLabel(a, categoryNameByID);
        const categoryB = $642e727260322576$var$getCategoryLabel(b, categoryNameByID);
        if (categoryA !== categoryB) return categoryA.localeCompare(categoryB);
        return a.attributes.name.localeCompare(b.attributes.name);
    });
    const campusGroups = new Map();
    sortedPlaylists.forEach((playlist)=>{
        const campusID = playlist.attributes.campusID || 'no-campus';
        const campusTitle = $642e727260322576$var$getCampusLabel(playlist, campusNameByID);
        const categoryID = playlist.attributes.categoryID || 'no-category';
        const categoryTitle = $642e727260322576$var$getCategoryLabel(playlist, categoryNameByID);
        if (!campusGroups.has(campusID)) campusGroups.set(campusID, {
            id: campusID,
            title: campusTitle,
            categories: new Map()
        });
        const campusGroup = campusGroups.get(campusID);
        if (!campusGroup.categories.has(categoryID)) campusGroup.categories.set(categoryID, {
            id: categoryID,
            title: categoryTitle,
            playlists: []
        });
        campusGroup.categories.get(categoryID).playlists.push(playlist);
    });
    return Array.from(campusGroups.values()).map((campusGroup)=>({
            id: campusGroup.id,
            title: campusGroup.title,
            categories: Array.from(campusGroup.categories.values())
        }));
}
function $642e727260322576$var$getCampusLabel(playlist, campusNameByID) {
    if (!playlist.attributes.campusID) return 'No Campus';
    return campusNameByID.get(playlist.attributes.campusID) || 'Unknown Campus';
}
function $642e727260322576$var$getCategoryLabel(playlist, categoryNameByID) {
    if (!playlist.attributes.categoryID) return 'No Category';
    return categoryNameByID.get(playlist.attributes.categoryID) || 'Unknown Category';
}
const $642e727260322576$var$PlaylistDetail = (props)=>{
    const thumbnails = props.playlist.songs.slice(0, 4);
    const collageItems = thumbnails.length > 0 ? thumbnails.map((song, index)=>({
            id: `${song.id}-${index}`,
            src: song.attributes.artworkURL || (0, (/*@__PURE__*/$parcel$interopDefault($f4ad1f40df3d002c$exports)))
        })) : [
        {
            id: 'placeholder',
            src: (0, (/*@__PURE__*/$parcel$interopDefault($f4ad1f40df3d002c$exports)))
        }
    ];
    const collageCount = Math.min(Math.max(collageItems.length, 1), 4);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "playlist-detail",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: `playlist-collage count-${collageCount} ${thumbnails.length === 0 ? 'is-placeholder' : ''}`,
            "aria-hidden": "true",
            children: collageItems.map((item, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: item.src,
                    alt: "",
                    className: `cover-art tile-${index + 1}`
                }, item.id))
        })
    });
};


function $919ebf39980bf8f3$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $6e5b65c9cbae0db9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $919ebf39980bf8f3$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $1c481e73824c6361$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c481e73824c6361$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $1c481e73824c6361$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}






var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");


function $b8698b2ff68d207b$export$2e2bcd8739ae039(playlistID, providedChurchId, initialPlaylist) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchId = providedChurchId || auth.churchId;
    const [playlist, setPlaylist] = (0, $7fPBF.useState)(initialPlaylist || null);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [hasLoaded, setHasLoaded] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        setPlaylist(initialPlaylist || null);
    }, [
        initialPlaylist
    ]);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchId || !playlistID) return;
        setLoading(true);
        setError(null);
        setHasLoaded(false);
        try {
            const response = await (0, $aadf679b6bdf08ee$export$2e2bcd8739ae039).fetchPlaylist(churchId, playlistID, auth);
            if (response.error) {
                setError(response.error);
                setPlaylist(null);
            } else if (response.body) setPlaylist(response.body);
            else setPlaylist(null);
        } catch (err) {
            setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to load playlist');
            setPlaylist(null);
        } finally{
            setLoading(false);
            setHasLoaded(true);
        }
    }, [
        churchId,
        playlistID,
        auth
    ]);
    const addSong = (0, $7fPBF.useCallback)(async (songAttributes)=>{
        if (!churchId || !playlistID) return {
            success: false,
            title: '',
            message: 'Failed to load playlist for update.'
        };
        const response = await (0, $aadf679b6bdf08ee$export$2e2bcd8739ae039).addSongToPlaylist(churchId, playlistID, songAttributes, auth);
        if (!response || response.error || !response.body) return {
            success: false,
            title: '',
            message: (response === null || response === void 0 ? void 0 : response.error) || 'An unknown error occurred while adding the song to the playlist.'
        };
        const updatedPlaylist = response.body.result;
        setPlaylist(updatedPlaylist);
        return {
            success: true,
            title: 'Added to Playlist',
            message: `${songAttributes.title} was added to ${updatedPlaylist.attributes.name}.`
        };
    }, [
        churchId,
        playlistID,
        auth
    ]);
    const removeSong = (0, $7fPBF.useCallback)(async (songID)=>{
        if (!churchId || !playlistID) return {
            success: false,
            title: '',
            message: 'Failed to load playlist for update.'
        };
        const response = await (0, $aadf679b6bdf08ee$export$2e2bcd8739ae039).removeSongFromPlaylist(churchId, playlistID, songID, auth);
        if (!response || response.error) return {
            success: false,
            title: '',
            message: (response === null || response === void 0 ? void 0 : response.error) || 'An unknown error occurred while removing the song from the playlist.'
        };
        setPlaylist((currentPlaylist)=>{
            if (!currentPlaylist) return currentPlaylist;
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, currentPlaylist), {
                songs: currentPlaylist.songs.filter((song)=>song.id !== songID)
            });
        });
        return {
            success: true,
            title: 'Removed from Playlist',
            message: 'The song was removed from the playlist.'
        };
    }, [
        churchId,
        playlistID,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!churchId || !playlistID) return;
        fetch();
    }, [
        churchId,
        playlistID,
        fetch
    ]);
    // Takes a playlist the caller already has, such as the one an edit returns,
    // instead of fetching it again.
    const applyPlaylist = (0, $7fPBF.useCallback)((updated)=>{
        setPlaylist(updated);
    }, []);
    return {
        playlist: playlist,
        loading: loading,
        error: error,
        hasLoaded: hasLoaded,
        refetch: fetch,
        addSong: addSong,
        removeSong: removeSong,
        applyPlaylist: applyPlaylist
    };
}






var $48a08cc73bd1bdd6$exports = {};
$48a08cc73bd1bdd6$exports = $parcel$resolve("kEDyG");





var $7fPBF = parcelRequire("7fPBF");
var $f4914239429a8982$exports = {};
$f4914239429a8982$exports = $parcel$resolve("6pPtb");


var $0298034ab94cd70d$export$3ed8400b82efd319 = /*#__PURE__*/ function(DropdownItemIcon) {
    DropdownItemIcon[DropdownItemIcon["DOCUMENT"] = 0] = "DOCUMENT";
    DropdownItemIcon[DropdownItemIcon["SHARE"] = 1] = "SHARE";
    DropdownItemIcon[DropdownItemIcon["MAIL"] = 2] = "MAIL";
    return DropdownItemIcon;
}({});
const $0298034ab94cd70d$var$iconComponent = (icon)=>{
    const fill = "#F58B8B";
    switch(icon){
        case 0:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                width: "66",
                height: "83",
                viewBox: "0 0 66 83",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M17.7246 52.6367C16.0156 52.6367 14.7949 51.416 14.7949 49.8535C14.7949 48.2422 16.0156 47.0215 17.7246 47.0215H47.3633C49.0235 47.0215 50.293 48.2422 50.293 49.8535C50.293 51.416 49.0235 52.6367 47.3633 52.6367H17.7246ZM17.7246 67.334C16.0156 67.334 14.7949 66.1133 14.7949 64.5019C14.7949 62.9394 16.0156 61.6699 17.7246 61.6699H47.3633C49.0235 61.6699 50.293 62.9394 50.293 64.5019C50.293 66.1133 49.0235 67.334 47.3633 67.334H17.7246ZM12.2559 82.3242H52.7344C60.9375 82.3242 65.0391 78.1738 65.0391 69.873V35.9863H37.1094C31.9336 35.9863 29.4922 33.5449 29.4922 28.3691V0H12.2559C4.05278 0 0 4.1504 0 12.4512V69.873C0 78.2226 4.05278 82.3242 12.2559 82.3242ZM37.1094 30.2734H64.5996C64.3555 28.4668 63.1348 26.7578 61.084 24.6582L40.8203 3.9551C38.8184 1.9043 37.0117 0.634797 35.2051 0.341797V28.3691C35.2051 29.6387 35.8887 30.2734 37.1094 30.2734Z",
                    fill: fill
                })
            });
        case 2:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                width: "94",
                height: "67",
                viewBox: "0 0 94 67",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M46.5332 37.207C47.7539 37.207 48.9746 36.7188 50.0977 35.6934L88.5742 1.9531C86.377 0.585902 83.9844 0 80.6641 0H12.4512C9.13088 0 6.73828 0.585902 4.49218 1.9531L43.0176 35.6934C44.1406 36.7188 45.3614 37.207 46.5332 37.207ZM0.83008 59.9121L28.9551 31.7871L0.73238 7.0801C0.43948 7.7149 0 9.5703 0 12.2559V54.4434C0 56.8359 0.34178 58.5449 0.83008 59.9121ZM11.084 66.6992H82.0313C84.7656 66.6992 86.9629 66.0645 88.4278 65.0879L59.2774 35.9863L53.8574 40.8203C51.5625 42.8223 49.0235 43.8477 46.5332 43.8477C44.0918 43.8477 41.5528 42.8223 39.2578 40.8203L33.7891 35.9863L4.63868 65.0879C6.10348 66.0645 8.34958 66.6992 11.084 66.6992ZM92.2854 59.9121C92.7244 58.5449 93.1154 56.8359 93.1154 54.4434V12.2559C93.1154 9.5703 92.6754 7.7149 92.3824 7.0801L64.1602 31.7871L92.2854 59.9121Z",
                    fill: fill
                })
            });
        case 1:
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                width: "88",
                height: "111",
                viewBox: "0 0 88 111",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                    d: "M15.839 110.248H71.8423C82.0744 110.248 87.1603 105.141 87.1603 95.085V46.4341C87.1603 36.3679 82.0744 31.2714 71.8423 31.2714H58.2569V39.1661H71.7177C76.5001 39.1661 79.3068 41.7859 79.3068 46.8175V94.7016C79.3068 99.7849 76.5001 102.342 71.7177 102.342H15.9636C11.0873 102.342 8.3745 99.7849 8.3745 94.7016V46.8175C8.3745 41.7859 11.0873 39.1661 15.9636 39.1661H29.4455V31.2714H15.839C5.6587 31.2714 0.520996 36.3468 0.520996 46.4341V95.085C0.520996 105.162 5.6587 110.248 15.839 110.248ZM43.8148 72.0197C45.9387 72.0197 47.7415 70.2686 47.7415 68.1965V18.1006L47.4204 10.7612L50.6914 14.2497L58.0936 22.1177C58.8086 22.8844 59.8034 23.2783 60.736 23.2783C62.7871 23.2783 64.3311 21.8378 64.3311 19.8797C64.3311 18.7919 63.896 18.0357 63.1292 17.3207L46.6431 1.3933C45.6694 0.419495 44.8509 0.0878906 43.8148 0.0878906C42.8305 0.0878906 42.0014 0.419495 40.9864 1.3933L24.4898 17.3207C23.7748 18.0357 23.3396 18.7919 23.3396 19.8797C23.3396 21.8378 24.8214 23.2783 26.883 23.2783C27.8156 23.2783 28.8622 22.8844 29.5666 22.1177L36.9794 14.2497L40.2609 10.7506L39.9398 18.1006V68.1965C39.9398 70.2686 41.7426 72.0197 43.8148 72.0197Z",
                    fill: fill
                })
            });
    }
};
function $0298034ab94cd70d$export$2e2bcd8739ae039(props) {
    const menuRef = (0, $7fPBF.useRef)(null);
    const [isDropdownVisible, setDropdownVisible] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (menuRef.current && !menuRef.current.contains(event.target)) setDropdownVisible(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "menu",
        ref: menuRef,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: (e)=>{
                    e.stopPropagation();
                    setDropdownVisible(!isDropdownVisible);
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f4914239429a8982$exports))),
                    alt: "Menu"
                })
            }),
            isDropdownVisible && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "dropdown-menu",
                children: [
                    props.title && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "title",
                        children: props.title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                        children: props.items.map((item, idx)=>{
                            const icon = $0298034ab94cd70d$var$iconComponent(item.icon);
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, {
                                children: [
                                    idx !== 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "divider"
                                    }) : null,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            item.onClick();
                                            setDropdownVisible(false);
                                        },
                                        children: [
                                            icon,
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: item.title
                                            })
                                        ]
                                    })
                                ]
                            }, item.title);
                        })
                    })
                ]
            })
        ]
    });
}


function $7f236beed1e911ce$export$2e2bcd8739ae039(props) {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "page-header",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "content",
                children: [
                    props.showBackButton === undefined || props.showBackButton === true ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                        className: "back",
                        href: "#back",
                        onClick: ()=>{
                            var _props_backLocation;
                            return navigate((_props_backLocation = props.backLocation) !== null && _props_backLocation !== void 0 ? _props_backLocation : "/");
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($48a08cc73bd1bdd6$exports))),
                                alt: "Left arrow icon"
                            }),
                            " Back"
                        ]
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        className: "header-title",
                        children: props.title
                    }),
                    props.subtitle !== undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        className: "header-subtitle",
                        children: props.subtitle
                    }) : null,
                    props.links !== undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "header-links",
                        children: props.links.map((link)=>{
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                                href: link.title,
                                onClick: (e)=>{
                                    e.preventDefault();
                                    link.onClick();
                                },
                                children: [
                                    link.icon !== undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        src: link.icon,
                                        alt: `${link.title} icon`
                                    }) : null,
                                    link.title
                                ]
                            }, link.title);
                        })
                    }) : null
                ]
            }),
            props.dropdown && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0298034ab94cd70d$export$2e2bcd8739ae039), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.dropdown))
        ]
    });
}






var $4492b6a3f2f323df$var$_httpssanctuaryapisaltplatformcom;
const $4492b6a3f2f323df$export$90400aecdf75d9f6 = (($4492b6a3f2f323df$var$_httpssanctuaryapisaltplatformcom = "https://sanctuary-api.saltplatform.com") === null || $4492b6a3f2f323df$var$_httpssanctuaryapisaltplatformcom === void 0 ? void 0 : $4492b6a3f2f323df$var$_httpssanctuaryapisaltplatformcom.includes('staging')) ? 'https://staging.launchpad.church' : 'https://launchpad.church';
const $4492b6a3f2f323df$export$3ffb8289671fe93c = {
    min: 3,
    max: 32
};
function $4492b6a3f2f323df$export$8634d0e3ad628eed(tag) {
    return tag.trim().toLowerCase();
}
function $4492b6a3f2f323df$export$3e16a84b016b16b8(tag) {
    if (tag.length < $4492b6a3f2f323df$export$3ffb8289671fe93c.min || tag.length > $4492b6a3f2f323df$export$3ffb8289671fe93c.max) return `A tag must be between ${$4492b6a3f2f323df$export$3ffb8289671fe93c.min} and ${$4492b6a3f2f323df$export$3ffb8289671fe93c.max} characters.`;
    if (!/^[a-z0-9-]+$/.test(tag) || tag.startsWith('-') || tag.endsWith('-')) return "A tag may only contain letters, numbers and hyphens, and can't start or end with a hyphen.";
    return null;
}
function $4492b6a3f2f323df$export$1d692e3ae13428f6(playlist) {
    return `${$4492b6a3f2f323df$export$90400aecdf75d9f6}/church/${encodeURIComponent(playlist.churchID)}/playlist/${encodeURIComponent(playlist.id)}`;
}
function $4492b6a3f2f323df$export$b82fb1b632b9b982(launchpad) {
    const path = launchpad.tag ? `/t/${encodeURIComponent(launchpad.tag)}` : `/church/${encodeURIComponent(launchpad.churchID)}/launchpad/${encodeURIComponent(launchpad.launchpadID)}`;
    return `${$4492b6a3f2f323df$export$90400aecdf75d9f6}${path}`;
}
function $4492b6a3f2f323df$var$normalizeLinks(links) {
    return [
        ...links !== null && links !== void 0 ? links : []
    ].sort((one, two)=>one.sortIndex - two.sortIndex);
}
function $4492b6a3f2f323df$export$89c9e789b0451492(attributes) {
    var _attributes_logoURL, _attributes_campusID, _attributes_categoryID;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, attributes), {
        logoURL: (_attributes_logoURL = attributes.logoURL) !== null && _attributes_logoURL !== void 0 ? _attributes_logoURL : null,
        campusID: (_attributes_campusID = attributes.campusID) !== null && _attributes_campusID !== void 0 ? _attributes_campusID : null,
        categoryID: (_attributes_categoryID = attributes.categoryID) !== null && _attributes_categoryID !== void 0 ? _attributes_categoryID : null,
        links: $4492b6a3f2f323df$var$normalizeLinks(attributes.links)
    });
}
function $4492b6a3f2f323df$export$fa95b638304b17de(launchpad) {
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, launchpad), {
        metadata: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, launchpad.metadata), {
            attributes: $4492b6a3f2f323df$export$89c9e789b0451492(launchpad.metadata.attributes)
        })
    });
}
function $4492b6a3f2f323df$export$3b902ee20af0594e(metadata) {
    return $4492b6a3f2f323df$export$fa95b638304b17de({
        churchID: metadata.churchID,
        launchpadID: metadata.launchpadID,
        metadata: metadata
    });
}
function $4492b6a3f2f323df$export$8d56d0b92b79b4fa(body) {
    var _candidate_metadata;
    if (!body || typeof body !== 'object') return null;
    const payload = body;
    var _payload_result, _ref;
    const candidate = (_ref = (_payload_result = payload.result) !== null && _payload_result !== void 0 ? _payload_result : payload.launchpad) !== null && _ref !== void 0 ? _ref : payload;
    if (!candidate || typeof candidate !== 'object') return null;
    if ((_candidate_metadata = candidate.metadata) === null || _candidate_metadata === void 0 ? void 0 : _candidate_metadata.attributes) return $4492b6a3f2f323df$export$fa95b638304b17de(candidate);
    if (candidate.attributes) return $4492b6a3f2f323df$export$3b902ee20af0594e(candidate);
    return null;
}



function $dc203b94917c8ff8$export$74edb9599ed878c7(shown, translations, edited) {
    if ((shown || null) === edited) return translations !== null && translations !== void 0 ? translations : shown;
    const shownLocale = translations ? Object.keys(translations).find((locale)=>translations[locale] === shown) : undefined;
    // Nothing to preserve: the field held one untranslated value, or nothing.
    if (!translations || !shownLocale) return edited;
    const updated = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, translations);
    if (edited) updated[shownLocale] = edited;
    else delete updated[shownLocale];
    return Object.keys(updated).length > 0 ? updated : null;
}






var $7fPBF = parcelRequire("7fPBF");





const $dcf26dbd3025efae$var$HTTP_NOT_FOUND = 404;
function $dcf26dbd3025efae$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [isDeleting, setIsDeleting] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const name = props.playlist.attributes.name || 'this playlist';
    const deletePlaylist = async ()=>{
        if (!auth.churchId) {
            setError('Missing church context. Please refresh and try again.');
            return;
        }
        setIsDeleting(true);
        setError(null);
        try {
            const response = await (0, $aadf679b6bdf08ee$export$2e2bcd8739ae039).deletePlaylist(auth.churchId, props.playlist.id, auth);
            // Already gone, most likely deleted elsewhere: the outcome asked for.
            if (response.error && response.status !== $dcf26dbd3025efae$var$HTTP_NOT_FOUND) {
                setError(response.error);
                return;
            }
            props.onDeleted();
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "delete-playlist-modal",
        isOpen: props.isOpen,
        footerButtons: [
            {
                title: isDeleting ? 'Deleting...' : 'Delete Playlist',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !isDeleting,
                onClick: ()=>{
                    deletePlaylist();
                }
            },
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !isDeleting,
                onClick: props.close
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "delete-playlist-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "close",
                            disabled: isDeleting,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: "Delete Playlist"
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "save-error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5407115776bd457c$exports))),
                            alt: "",
                            "aria-hidden": "true",
                            className: "warning-icon"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "warning-copy",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("strong", {
                                children: [
                                    "Are you sure you want to delete ",
                                    name,
                                    "?"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "warning-copy",
                            children: "It will be removed from Launchpad and the Salt app, along with its songs. Anyone with a link to it will no longer be able to open it. This action cannot be undone."
                        })
                    ]
                })
            ]
        })
    });
}


var $34a899f6d421b489$exports = {};
$34a899f6d421b489$exports = $parcel$resolve("1BhH4");



var $f382a5c80f18c5e3$exports = {};
$f382a5c80f18c5e3$exports = $parcel$resolve("f7jIs");










var $7fPBF = parcelRequire("7fPBF");





class $182439f299d594a2$export$2e2bcd8739ae039 {
    static async searchSongs(query, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/search/songs/streaming?query=${encodeURIComponent(query)}`), auth.consumeRefreshToken);
    }
    static async fetchMatchResults(isrc, skipPlatform, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/search/songs/streaming/match?isrc=${encodeURIComponent(isrc)}&skipPlatforms=${encodeURIComponent(skipPlatform)}`), auth.consumeRefreshToken);
    }
}
$182439f299d594a2$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";







var $501046bd6ca447c4$exports = {};
$501046bd6ca447c4$exports = $parcel$resolve("pzApr");




var $2f86ea90ef359998$exports = {};
$2f86ea90ef359998$exports = $parcel$resolve("1MmLB");





var $6fbd1f95f867c609$exports = {};
$6fbd1f95f867c609$exports = $parcel$resolve("g0W8j");


function $9f2c42b26582cc85$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "success-view-header",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($6fbd1f95f867c609$exports))),
                className: "icon",
                alt: "Success"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: props.title
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: props.description
            })
        ]
    });
}



const $eefdeb9546a46be2$var$STREAMING_PLATFORMS = [
    'Apple Music',
    'Spotify',
    'YouTube Music',
    'Tidal'
];
function $eefdeb9546a46be2$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [step, setStep] = (0, $7fPBF.useState)('search');
    const [query, setQuery] = (0, $7fPBF.useState)(props.initialQuery || '');
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [isSearching, setIsSearching] = (0, $7fPBF.useState)(false);
    const [isMatching, setIsMatching] = (0, $7fPBF.useState)(false);
    const [results, setResults] = (0, $7fPBF.useState)(null);
    const [selectedSong, setSelectedSong] = (0, $7fPBF.useState)(null);
    const [matchRows, setMatchRows] = (0, $7fPBF.useState)([]);
    const [confirmationResult, setConfirmationResult] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (!props.isOpen) return;
        setStep('search');
        setQuery(props.initialQuery || '');
        setError(null);
        setIsSearching(false);
        setIsMatching(false);
        setResults(null);
        setSelectedSong(null);
        setMatchRows([]);
        setConfirmationResult(null);
    }, [
        props.initialQuery,
        props.isOpen
    ]);
    const submitSearch = async (event)=>{
        event.preventDefault();
        const trimmedQuery = query.trim();
        if (!trimmedQuery) {
            setError('Enter a song title or artist to start searching.');
            return;
        }
        setError(null);
        setResults(null);
        setStep('results');
        setIsSearching(true);
        const response = await (0, $182439f299d594a2$export$2e2bcd8739ae039).searchSongs(trimmedQuery, auth);
        setIsSearching(false);
        if (response.error) {
            setError(response.error);
            return;
        }
        if (response.body) {
            const body = response.body;
            if (body.results.length === 0) {
                setError('No songs matched that search. Try a different title, artist, or spelling.');
                return;
            }
            setResults(body);
        } else {
            setError('An unexpected error occurred. Please try again.');
            return;
        }
    };
    const selectSong = async (song, platform)=>{
        setSelectedSong(song);
        setError(null);
        setMatchRows([]);
        setStep('matching');
        setIsMatching(true);
        const response = await (0, $182439f299d594a2$export$2e2bcd8739ae039).fetchMatchResults(song.isrc || '', platform, auth);
        setIsMatching(false);
        if (response.error) {
            setError(response.error);
            setStep('results');
            return;
        }
        const rows = $eefdeb9546a46be2$var$buildMatchRows(response.body, song, platform);
        setMatchRows(rows);
        setStep('matches');
        if (rows.length === 0) setError('No streaming match results were found.');
    };
    const confirmMatches = ()=>{
        if (!selectedSong || !props.onConfirm || matchRows.length === 0) return;
        let merged = selectedSong;
        matchRows.forEach((row)=>{
            if (merged.streamingLinks.find((link)=>link.platform === row.service)) return;
            if (row.matchedURL && row.externalPlatformID) {
                merged.streamingLinks.push({
                    platform: row.service,
                    url: row.matchedURL
                });
                merged.externalIDs.push({
                    platform: row.service,
                    id: row.externalPlatformID
                });
                return;
            }
            const searchURL = $eefdeb9546a46be2$var$getSearchURLForService(selectedSong, row.service) || undefined;
            if (searchURL) merged.streamingLinks.push({
                platform: row.service,
                url: searchURL
            });
        });
        const result = props.onConfirm({
            selectedSong: merged
        });
        if (result instanceof Promise) {
            setStep('confirmation');
            result.then((confirmationResult)=>{
                setConfirmationResult(confirmationResult);
            });
        } else props.close();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7857575a213426db$exports))), {
        isOpen: props.isOpen,
        id: props.id,
        closeTimeoutMS: 200,
        className: "modal song-search-modal-shell",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "song-search-modal",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "song-search-modal-viewport",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "song-search-modal-step",
                    children: [
                        step === 'search' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$SearchStep, {
                            query: query,
                            disabled: isSearching,
                            onClose: props.close,
                            onQueryChange: (value)=>{
                                setQuery(value);
                                setError(null);
                            },
                            onSubmit: (e)=>{
                                submitSearch(e);
                            }
                        }) : null,
                        step === 'results' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$ResultsStep, {
                            query: query,
                            loading: isSearching,
                            response: results,
                            onBack: ()=>{
                                setStep('search');
                                setError(null);
                            },
                            onSelectSong: (song, platform)=>{
                                selectSong(song, platform);
                            }
                        }) : null,
                        step === 'matching' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$MatchingStep, {
                            song: selectedSong,
                            loading: isMatching,
                            onBack: ()=>{
                                if (isMatching) return;
                                setStep('results');
                                setError(null);
                            }
                        }) : null,
                        step === 'matches' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$MatchesStep, {
                            song: selectedSong,
                            rows: matchRows,
                            disableBack: isMatching,
                            removeMatchForService: (service)=>{
                                setMatchRows((matchRows)=>matchRows.map((row)=>{
                                        if (row.service === service) return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, row), {
                                            title: 'Marked as Incorrect',
                                            artist: 'Search link used for this platform instead.',
                                            artworkURL: null,
                                            matchedURL: null
                                        });
                                        return row;
                                    }));
                            },
                            onBack: ()=>{
                                setStep('results');
                                setError(null);
                            },
                            onConfirm: confirmMatches
                        }) : null,
                        step === 'confirmation' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$ConfirmationStep, {
                            result: confirmationResult,
                            close: props.close
                        }) : null
                    ]
                })
            })
        })
    });
}
function $eefdeb9546a46be2$var$SearchStep(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$StepHeader, {
                title: "Song Search",
                action: "close",
                disabled: props.disabled,
                onAction: props.onClose
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                className: "song-search-modal-search-bar",
                onSubmit: props.onSubmit,
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                        id: "query",
                        type: "text",
                        value: props.query,
                        disabled: props.disabled,
                        placeholder: "Search by song title or artist",
                        onChange: (event)=>{
                            props.onQueryChange(event.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "submit",
                        disabled: props.disabled,
                        children: "Search"
                    })
                ]
            })
        ]
    });
}
function $eefdeb9546a46be2$var$ResultsStep(props) {
    const response = props.response;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$StepHeader, {
                title: "Search Results",
                action: "back",
                disabled: props.loading,
                onAction: props.onBack
            }),
            !props.loading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "song-search-modal-query-label",
                children: [
                    'Showing results for "',
                    props.query,
                    '"'
                ]
            }),
            props.loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "song-search-modal-loading-state",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                    fullScreen: false
                })
            }) : null,
            !props.loading && response && response.results.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "song-search-modal-list",
                children: response.results.map((song, index)=>{
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        type: "button",
                        className: "song-search-modal-card song-search-modal-result-card card",
                        onClick: ()=>{
                            props.onSelectSong(song, response.platform);
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "song-search-modal-artwork",
                                src: song.artworkURL || '',
                                alt: song.title
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "song-search-modal-copy",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h5", {
                                        children: song.title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: song.artist.name
                                    })
                                ]
                            })
                        ]
                    }, `${song.isrc}-${index}`);
                })
            }) : null,
            !props.loading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$EmptyState, {
                message: "No results."
            })
        ]
    });
}
function $eefdeb9546a46be2$var$MatchingStep(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$StepHeader, {
                title: "Match Results",
                action: "back",
                disabled: props.loading,
                onAction: props.onBack
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "song-search-modal-loading-state",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                    fullScreen: false
                })
            })
        ]
    });
}
function $eefdeb9546a46be2$var$MatchesStep(props) {
    const canConfirm = props.rows.length > 0;
    const [activeMenu, setActiveMenu] = (0, $7fPBF.useState)(null);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$StepHeader, {
                title: "Match Results",
                action: "back",
                disabled: props.disableBack,
                onAction: props.onBack,
                confirmAction: props.onConfirm
            }),
            props.rows.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "song-search-modal-list",
                children: props.rows.map((row)=>{
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "song-search-modal-match-group",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "song-search-modal-service-header",
                                children: [
                                    $eefdeb9546a46be2$var$getServiceIcon(row.service) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        className: "song-search-modal-service-icon",
                                        src: $eefdeb9546a46be2$var$getServiceIcon(row.service) || '',
                                        alt: "",
                                        "aria-hidden": "true"
                                    }) : null,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h5", {
                                        children: $eefdeb9546a46be2$var$formatServiceLabel(row.service)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "song-search-modal-card song-search-modal-match-card card",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        className: "song-search-modal-artwork",
                                        src: row.artworkURL || (0, (/*@__PURE__*/$parcel$interopDefault($f4ad1f40df3d002c$exports))),
                                        alt: row.title
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                        className: "song-search-modal-copy",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h5", {
                                                children: row.title
                                            }),
                                            row.artist ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: row.artist
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "song-search-modal-match-actions",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            className: "song-search-modal-options-button",
                                            onClick: (event)=>{
                                                const rect = event.currentTarget.getBoundingClientRect();
                                                setActiveMenu({
                                                    service: row.service,
                                                    x: rect.left + rect.width + window.scrollX,
                                                    y: rect.top + window.scrollY
                                                });
                                            },
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f4914239429a8982$exports))),
                                                alt: "Match actions"
                                            })
                                        })
                                    }),
                                    (activeMenu === null || activeMenu === void 0 ? void 0 : activeMenu.service) === row.service ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9108a7a2191b8648$export$2e2bcd8739ae039), {
                                        className: "song-search-match-menu",
                                        x: activeMenu.x,
                                        y: activeMenu.y,
                                        onRequestClose: ()=>{
                                            setActiveMenu(null);
                                        },
                                        sections: [
                                            {
                                                className: 'song-search-match-menu-actions',
                                                items: [
                                                    {
                                                        key: 'open-link',
                                                        className: 'song-search-match-menu-action',
                                                        href: row.matchedURL || $eefdeb9546a46be2$var$getSearchURLForService(props.song, row.service) || undefined,
                                                        disabled: false,
                                                        onClick: ()=>{
                                                            setActiveMenu(null);
                                                        },
                                                        content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2f86ea90ef359998$exports))),
                                                                    alt: "",
                                                                    "aria-hidden": "true"
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                    children: "Open Link"
                                                                })
                                                            ]
                                                        })
                                                    },
                                                    row.matchedURL ? {
                                                        key: 'incorrect-match',
                                                        className: 'song-search-match-menu-action danger',
                                                        disabled: false,
                                                        onClick: ()=>{
                                                            setActiveMenu(null);
                                                            props.removeMatchForService(row.service);
                                                        },
                                                        content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                children: "Incorrect Match"
                                                            })
                                                        })
                                                    } : null
                                                ]
                                            }
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    }, row.service);
                })
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$EmptyState, {
                message: "No match results were returned for this song."
            })
        ]
    });
}
function $eefdeb9546a46be2$var$ConfirmationStep(props) {
    const loading = props.result === null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($eefdeb9546a46be2$var$StepHeader, {
                title: "",
                action: "close",
                disabled: loading === true,
                onAction: ()=>{
                    props.close();
                }
            }),
            loading === true ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "song-search-modal-loading-state",
                style: {
                    marginBottom: '2rem'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                    fullScreen: false
                })
            }) : null,
            props.result && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "song-search-modal-confirmation",
                children: props.result.success ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9f2c42b26582cc85$export$2e2bcd8739ae039), {
                    title: props.result.title,
                    description: props.result.message
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                    showButton: false,
                    error: props.result.message
                })
            })
        ]
    });
}
function $eefdeb9546a46be2$var$EmptyState(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "song-search-modal-empty",
        children: props.message
    });
}
function $eefdeb9546a46be2$var$StepHeader(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "song-search-modal-header",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: `song-search-modal-header-control ${props.action}`,
                disabled: props.disabled,
                onClick: props.onAction,
                children: props.action === 'close' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                    alt: "Close icon"
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($501046bd6ca447c4$exports))),
                    alt: "Back icon"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                children: props.title
            }),
            props.confirmAction ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: "song-search-modal-header-control confirm",
                disabled: props.disabled,
                onClick: ()=>{
                    var _props_confirmAction;
                    (_props_confirmAction = props.confirmAction) === null || _props_confirmAction === void 0 ? void 0 : _props_confirmAction.call(props);
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($d5bdfc11cea11cc4$exports))),
                    alt: "Confirm icon"
                })
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "song-search-modal-header-spacer"
            })
        ]
    });
}
function $eefdeb9546a46be2$var$buildMatchRows(response, selectedSong, selectedSongPlatform) {
    return $eefdeb9546a46be2$var$STREAMING_PLATFORMS.map((service)=>{
        var _matchedSong_streamingLinks_find, _matchedSong_externalIDs_find;
        let matchedSong = response === null || response === void 0 ? void 0 : response.matchResults[service];
        if (service === selectedSongPlatform) matchedSong = selectedSong;
        if (!matchedSong) return {
            service: service,
            title: 'No Match Found',
            artist: 'Search link used for this platform instead.',
            artworkURL: null,
            matchedURL: null,
            externalPlatformID: null
        };
        return {
            service: service,
            title: matchedSong.title,
            artist: matchedSong.artist.name,
            artworkURL: matchedSong.artworkURL,
            matchedURL: ((_matchedSong_streamingLinks_find = matchedSong.streamingLinks.find((link)=>link.platform === service)) === null || _matchedSong_streamingLinks_find === void 0 ? void 0 : _matchedSong_streamingLinks_find.url) || null,
            externalPlatformID: ((_matchedSong_externalIDs_find = matchedSong.externalIDs.find((id)=>id.platform === service)) === null || _matchedSong_externalIDs_find === void 0 ? void 0 : _matchedSong_externalIDs_find.id) || null
        };
    });
}
function $eefdeb9546a46be2$var$formatServiceLabel(service) {
    return service;
}
function $eefdeb9546a46be2$var$getServiceIcon(service) {
    if (service === 'Apple Music') return 0, (/*@__PURE__*/$parcel$interopDefault($af0bfc2991cf1d62$exports));
    if (service === 'Spotify') return 0, (/*@__PURE__*/$parcel$interopDefault($32dba739a0e17da8$exports));
    if (service === 'YouTube Music') return 0, (/*@__PURE__*/$parcel$interopDefault($b9f73db21efadc5d$exports));
    if (service === 'Tidal') return 0, (/*@__PURE__*/$parcel$interopDefault($81839c9282ade394$exports));
    return null;
}
function $eefdeb9546a46be2$var$getSearchURLForService(song, service) {
    if (service === 'Apple Music') return `https://music.apple.com/search?term=${encodeURIComponent(song.title + ' ' + song.artist.name)}&entity=song`;
    if (service === 'Spotify') return `https://open.spotify.com/search/${encodeURIComponent(song.title + ' ' + song.artist.name)}`;
    if (service === 'YouTube Music') return `https://music.youtube.com/search?q=${encodeURIComponent(song.title + ' ' + song.artist.name)}`;
    if (service === 'Tidal') return `https://tidal.com/search?q=${encodeURIComponent(song.title + ' ' + song.artist.name)}`;
    return null;
}




var $7fPBF = parcelRequire("7fPBF");




function $7e216cc907f56c05$export$2e2bcd8739ae039(props) {
    const [isRemoving, setIsRemoving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [renderedSong, setRenderedSong] = (0, $7fPBF.useState)(props.song);
    (0, $7fPBF.useEffect)(()=>{
        if (props.isOpen && props.song) setRenderedSong(props.song);
    }, [
        props.isOpen,
        props.song
    ]);
    if (!renderedSong) return null;
    const removeSong = async ()=>{
        setIsRemoving(true);
        setError(null);
        try {
            const result = await props.onConfirm(renderedSong);
            if (!result.success) {
                setError(result.message);
                setIsRemoving(false);
                return;
            }
            props.close();
        } finally{
            setIsRemoving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7857575a213426db$exports))), {
        id: "remove-song-modal",
        isOpen: props.isOpen,
        closeTimeoutMS: 200,
        className: "modal remove-song-modal-shell",
        onAfterClose: ()=>{
            var _props_onAfterClose;
            setError(null);
            setIsRemoving(false);
            setRenderedSong(null);
            (_props_onAfterClose = props.onAfterClose) === null || _props_onAfterClose === void 0 ? void 0 : _props_onAfterClose.call(props);
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "remove-song-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            "aria-disabled": isRemoving,
                            className: isRemoving ? 'close disabled' : 'close',
                            href: "#",
                            onClick: (e)=>{
                                e.preventDefault();
                                if (isRemoving) return;
                                props.close();
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: "Remove Song"
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "body",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                        error: error,
                        showButton: false
                    })
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                            children: [
                                "Remove ",
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                    children: renderedSong.attributes.title
                                }),
                                " from this playlist?"
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "spacer"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "remove-song-button",
                            disabled: isRemoving,
                            onClick: ()=>{
                                removeSong();
                            },
                            children: "Remove Song"
                        })
                    ]
                })
            ]
        })
    });
}


var $ed5c0a9c99fa42f0$exports = {};
$ed5c0a9c99fa42f0$exports = $parcel$resolve("1Ascd");


const $de2e140928c5997e$var$SONG_MENU_EXIT_DURATION_MS = 140;
function $de2e140928c5997e$export$2e2bcd8739ae039() {
    var _location_state;
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const pathParams = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const playlistID = pathParams.playlistID;
    const initialPlaylist = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.playlist;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { playlist: playlist, loading: loading, error: error, hasLoaded: hasLoaded, refetch: refetch, addSong: addSong, removeSong: removeSong, applyPlaylist: applyPlaylist } = (0, $b8698b2ff68d207b$export$2e2bcd8739ae039)(playlistID, undefined, initialPlaylist);
    const [isEditModalOpen, setIsEditModalOpen] = (0, $7fPBF.useState)(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $7fPBF.useState)(false);
    const [selectedSongMenu, setSelectedSongMenu] = (0, $7fPBF.useState)(null);
    const [displayedSongMenu, setDisplayedSongMenu] = (0, $7fPBF.useState)(null);
    const [isClosingSongMenu, setIsClosingSongMenu] = (0, $7fPBF.useState)(false);
    const menuRef = (0, $7fPBF.useRef)(null);
    const [showAddSongModal, setShowAddSongModal] = (0, $7fPBF.useState)(false);
    const [songPendingRemoval, setSongPendingRemoval] = (0, $7fPBF.useState)(null);
    const [isRemoveSongModalOpen, setIsRemoveSongModalOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (selectedSongMenu) {
            setDisplayedSongMenu(selectedSongMenu);
            setIsClosingSongMenu(false);
            return;
        }
        if (!displayedSongMenu) {
            setIsClosingSongMenu(false);
            return;
        }
        setIsClosingSongMenu(true);
        const timeout = window.setTimeout(()=>{
            setDisplayedSongMenu(null);
            setIsClosingSongMenu(false);
        }, $de2e140928c5997e$var$SONG_MENU_EXIT_DURATION_MS);
        return ()=>{
            window.clearTimeout(timeout);
        };
    }, [
        selectedSongMenu,
        displayedSongMenu
    ]);
    if (!playlistID) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/playlists",
        replace: true
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "playlist-details-page",
        children: [
            loading && !playlist ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}) : null,
            error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                error: error,
                buttonText: "Retry",
                buttonAction: ()=>refetch()
            }) : null,
            hasLoaded && !loading && !error && !playlist ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                error: "Playlist not found.",
                buttonText: "Back to Playlists",
                buttonAction: ()=>{
                    navigate('/playlists');
                }
            }) : null,
            playlist ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                        title: playlist.attributes.name,
                        backLocation: "/playlists",
                        links: [
                            {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($34a899f6d421b489$exports))),
                                title: 'Share',
                                // The playlist's public page, on Launchpad's short domain.
                                onClick: ()=>window.open((0, $4492b6a3f2f323df$export$1d692e3ae13428f6)(playlist), '_blank', 'noopener,noreferrer')
                            },
                            {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($a9cdc003ba228dda$exports))),
                                title: 'Edit',
                                onClick: ()=>setIsEditModalOpen(true)
                            },
                            {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($f382a5c80f18c5e3$exports))),
                                title: 'Delete',
                                onClick: ()=>setIsDeleteModalOpen(true)
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a39d0220e0abc509$export$2e2bcd8739ae039), {
                        isOpen: isEditModalOpen,
                        setIsOpen: setIsEditModalOpen,
                        playlist: playlist,
                        onSave: async (attributes)=>{
                            if (!auth.churchId) return {
                                error: 'Missing church context. Please refresh and try again.'
                            };
                            var _localizedValue;
                            const response = await (0, $aadf679b6bdf08ee$export$2e2bcd8739ae039).updatePlaylist(auth.churchId, playlist.id, {
                                // An edit replaces only the translation shown, keeping the others.
                                name: (_localizedValue = (0, $dc203b94917c8ff8$export$74edb9599ed878c7)(playlist.attributes.name, playlist.attributes.nameLocalizations, attributes.name)) !== null && _localizedValue !== void 0 ? _localizedValue : attributes.name,
                                campusID: attributes.campusID,
                                categoryID: attributes.categoryID
                            }, auth);
                            if (response.error || !response.body) return {
                                error: response.error || 'Unable to save this playlist right now.'
                            };
                            var _response_body_songs;
                            // The update only touches the playlist's details, so its songs are
                            // kept if the response leaves them out.
                            applyPlaylist((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, response.body), {
                                songs: (_response_body_songs = response.body.songs) !== null && _response_body_songs !== void 0 ? _response_body_songs : playlist.songs
                            }));
                            return {
                                playlist: response.body
                            };
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $dcf26dbd3025efae$export$2e2bcd8739ae039), {
                        isOpen: isDeleteModalOpen,
                        playlist: playlist,
                        close: ()=>setIsDeleteModalOpen(false),
                        // Replaced, so Back doesn't return to a playlist that's gone.
                        onDeleted: ()=>navigate('/playlists', {
                                replace: true
                            })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eefdeb9546a46be2$export$2e2bcd8739ae039), {
                        id: "add-song-to-playlist-modal",
                        isOpen: showAddSongModal,
                        close: ()=>{
                            setShowAddSongModal(false);
                        },
                        onConfirm: async (selection)=>{
                            return await addSong(selection.selectedSong);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7e216cc907f56c05$export$2e2bcd8739ae039), {
                        isOpen: isRemoveSongModalOpen,
                        song: songPendingRemoval,
                        close: ()=>{
                            setIsRemoveSongModalOpen(false);
                        },
                        onAfterClose: ()=>{
                            setSongPendingRemoval(null);
                        },
                        onConfirm: async (song)=>{
                            return await removeSong(song.id);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "songs",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: "playlist-song-card add-song-card",
                                onClick: ()=>{
                                    setShowAddSongModal(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "add-song-artwork",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5c0a9c99fa42f0$exports))),
                                            alt: "",
                                            "aria-hidden": "true"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "song-info",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                            children: "Add Song"
                                        })
                                    })
                                ]
                            }),
                            playlist.songs.map((song)=>{
                                const activeMenu = (displayedSongMenu === null || displayedSongMenu === void 0 ? void 0 : displayedSongMenu.songID) === song.id ? displayedSongMenu : null;
                                const isMenuOpen = (activeMenu === null || activeMenu === void 0 ? void 0 : activeMenu.songID) === song.id;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: `playlist-song-card ${isMenuOpen ? 'active' : ''}`,
                                    onClick: (event)=>{
                                        if ((displayedSongMenu === null || displayedSongMenu === void 0 ? void 0 : displayedSongMenu.songID) === song.id) {
                                            setSelectedSongMenu(null);
                                            return;
                                        }
                                        setSelectedSongMenu({
                                            songID: song.id,
                                            x: event.clientX + window.scrollX,
                                            y: event.clientY + window.scrollY
                                        });
                                    },
                                    role: "button",
                                    tabIndex: 0,
                                    onKeyDown: (event)=>{
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            event.preventDefault();
                                            if ((displayedSongMenu === null || displayedSongMenu === void 0 ? void 0 : displayedSongMenu.songID) === song.id) {
                                                setSelectedSongMenu(null);
                                                return;
                                            }
                                            const rect = event.currentTarget.getBoundingClientRect();
                                            setSelectedSongMenu({
                                                songID: song.id,
                                                x: rect.left + rect.width - 40 + window.scrollX,
                                                y: rect.top + 28 + window.scrollY
                                            });
                                        }
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            src: song.attributes.artworkURL || '',
                                            alt: song.attributes.title,
                                            className: "cover-art"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "song-info",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                                    children: song.attributes.title
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    children: song.attributes.artist.name
                                                })
                                            ]
                                        }),
                                        activeMenu ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb1d7f76a966659b$export$2e2bcd8739ae039), {
                                            song: song,
                                            menuRef: menuRef,
                                            x: activeMenu.x,
                                            y: activeMenu.y,
                                            isClosing: isClosingSongMenu,
                                            onRemove: (selectedSong)=>{
                                                setSelectedSongMenu(null);
                                                setSongPendingRemoval(selectedSong);
                                                setIsRemoveSongModalOpen(true);
                                            },
                                            onRequestClose: ()=>{
                                                setSelectedSongMenu(null);
                                            }
                                        }) : null
                                    ]
                                }, song.id);
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");

/*!
  react-datepicker v8.10.0
  https://github.com/Hacker0x01/react-datepicker
  Released under the MIT License.
*/ function $07a883fe7c352c85$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $07a883fe7c352c85$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $07a883fe7c352c85$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $07a883fe7c352c85$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $07a883fe7c352c85$export$2e2bcd8739ae039 = $07a883fe7c352c85$export$4f5d2d50c9deca37;



var $7fPBF = parcelRequire("7fPBF");
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ const $8fcd7006f7e32aa4$export$dfd9b671c89acc8e = 7;
const $8fcd7006f7e32aa4$export$3913210603d8e9ae = 365.2425;
const $8fcd7006f7e32aa4$export$81caae6e1cc7a622 = Math.pow(10, 8) * 86400000;
const $8fcd7006f7e32aa4$export$4dec998e48f9c246 = -$8fcd7006f7e32aa4$export$81caae6e1cc7a622;
const $8fcd7006f7e32aa4$export$4fad13613e88edc8 = 604800000;
const $8fcd7006f7e32aa4$export$b76b1809a2898f9a = 86400000;
const $8fcd7006f7e32aa4$export$91246f0b9bd9beff = 60000;
const $8fcd7006f7e32aa4$export$7f72910d6dfd237a = 3600000;
const $8fcd7006f7e32aa4$export$397c2d5776aa9055 = 1000;
const $8fcd7006f7e32aa4$export$3633035e63cee86a = 525600;
const $8fcd7006f7e32aa4$export$ab7da2ccd1075c38 = 43200;
const $8fcd7006f7e32aa4$export$2423174df8cd3cd2 = 1440;
const $8fcd7006f7e32aa4$export$f2f5ae5a8e2d8f9f = 60;
const $8fcd7006f7e32aa4$export$3c58128db900d44e = 3;
const $8fcd7006f7e32aa4$export$80d7e435f744f319 = 12;
const $8fcd7006f7e32aa4$export$4db7641526e3241f = 4;
const $8fcd7006f7e32aa4$export$698aec755e92c695 = 3600;
const $8fcd7006f7e32aa4$export$a77c1a7ebebe2a5a = 60;
const $8fcd7006f7e32aa4$export$815a9362476d2fe3 = $8fcd7006f7e32aa4$export$698aec755e92c695 * 24;
const $8fcd7006f7e32aa4$export$34804a017b31e2fe = $8fcd7006f7e32aa4$export$815a9362476d2fe3 * 7;
const $8fcd7006f7e32aa4$export$7271e9e3478110d1 = $8fcd7006f7e32aa4$export$815a9362476d2fe3 * $8fcd7006f7e32aa4$export$3913210603d8e9ae;
const $8fcd7006f7e32aa4$export$8e6600bbdee7dabb = $8fcd7006f7e32aa4$export$7271e9e3478110d1 / 12;
const $8fcd7006f7e32aa4$export$be1dccf2de902d31 = $8fcd7006f7e32aa4$export$8e6600bbdee7dabb * 3;
const $8fcd7006f7e32aa4$export$2a7b97929c48d47d = Symbol.for("constructDateFrom");


function $93cc854f09c80b6b$export$ead8a1812b171991(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, $8fcd7006f7e32aa4$export$2a7b97929c48d47d) in date) return date[0, $8fcd7006f7e32aa4$export$2a7b97929c48d47d](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
var // Fallback for modularized imports:
$93cc854f09c80b6b$export$2e2bcd8739ae039 = $93cc854f09c80b6b$export$ead8a1812b171991;



function $0e4c03a3b8c45094$export$e67a095c620b86fe(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, $93cc854f09c80b6b$export$ead8a1812b171991)(context || argument, argument);
}
var // Fallback for modularized imports:
$0e4c03a3b8c45094$export$2e2bcd8739ae039 = $0e4c03a3b8c45094$export$e67a095c620b86fe;


function $f858e1fd107a3fca$export$dd412b56f1e4d8aa(date, amount, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (isNaN(amount)) return (0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
var // Fallback for modularized imports:
$f858e1fd107a3fca$export$2e2bcd8739ae039 = $f858e1fd107a3fca$export$dd412b56f1e4d8aa;



function $e2323b7421c7660a$export$baf757aaf0c95c94(date, amount, options) {
    return (0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date) + amount);
}
var // Fallback for modularized imports:
$e2323b7421c7660a$export$2e2bcd8739ae039 = $e2323b7421c7660a$export$baf757aaf0c95c94;



function $12502beeb4ed2ed3$export$4a4306ad4fa0e5e6(date, amount, options) {
    return (0, $e2323b7421c7660a$export$baf757aaf0c95c94)(date, amount * (0, $8fcd7006f7e32aa4$export$7f72910d6dfd237a), options);
}
var // Fallback for modularized imports:
$12502beeb4ed2ed3$export$2e2bcd8739ae039 = $12502beeb4ed2ed3$export$4a4306ad4fa0e5e6;



function $879ad858cbf859fa$export$2287e3d29250119e(date, amount, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setTime(_date.getTime() + amount * (0, $8fcd7006f7e32aa4$export$91246f0b9bd9beff));
    return _date;
}
var // Fallback for modularized imports:
$879ad858cbf859fa$export$2e2bcd8739ae039 = $879ad858cbf859fa$export$2287e3d29250119e;



function $1e6165891d3337ed$export$17c93e242b2d3a22(date, amount, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (isNaN(amount)) return (0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    if (!amount) // If 0 months, no-op to avoid changing times in the hour before end of DST
    return _date;
    const dayOfMonth = _date.getDate();
    // The JS Date object supports date math by accepting out-of-bounds values for
    // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
    // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
    // want except that dates will wrap around the end of a month, meaning that
    // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
    // we'll default to the end of the desired month by adding 1 to the desired
    // month and using a date of 0 to back up one day to the end of the desired
    // month.
    const endOfDesiredMonth = (0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, _date.getTime());
    endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
    const daysInMonth = endOfDesiredMonth.getDate();
    if (dayOfMonth >= daysInMonth) // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
    else {
        // Otherwise, we now know that setting the original day-of-month value won't
        // cause an overflow, so set the desired day-of-month. Note that we can't
        // just set the date of `endOfDesiredMonth` because that object may have had
        // its time changed in the unusual case where where a DST transition was on
        // the last day of the month and its local time was in the hour skipped or
        // repeated next to a DST transition.  So we use `date` instead which is
        // guaranteed to still have the original time.
        _date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
        return _date;
    }
}
var // Fallback for modularized imports:
$1e6165891d3337ed$export$2e2bcd8739ae039 = $1e6165891d3337ed$export$17c93e242b2d3a22;


function $4e9bcc6ff9d39f34$export$c252a41d0fbed2ce(date, amount, options) {
    return (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(date, amount * 3, options);
}
var // Fallback for modularized imports:
$4e9bcc6ff9d39f34$export$2e2bcd8739ae039 = $4e9bcc6ff9d39f34$export$c252a41d0fbed2ce;


function $a57a5a7d87e86174$export$3cb31b0df13be68(date, amount, options) {
    return (0, $e2323b7421c7660a$export$baf757aaf0c95c94)(date, amount * 1000, options);
}
var // Fallback for modularized imports:
$a57a5a7d87e86174$export$2e2bcd8739ae039 = $a57a5a7d87e86174$export$3cb31b0df13be68;


function $65f6621a4d881172$export$ef501a2bb4f3ee6b(date, amount, options) {
    return (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(date, amount * 7, options);
}
var // Fallback for modularized imports:
$65f6621a4d881172$export$2e2bcd8739ae039 = $65f6621a4d881172$export$ef501a2bb4f3ee6b;


function $b4358f02f9e27928$export$3d83eec43f4ea476(date, amount, options) {
    return (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(date, amount * 12, options);
}
var // Fallback for modularized imports:
$b4358f02f9e27928$export$2e2bcd8739ae039 = $b4358f02f9e27928$export$3d83eec43f4ea476;


function $798ff302a3eae88e$export$113002b5eff6e430(date) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}



function $f1eab3353eda9458$export$9f53b88e82f64d8d(context, ...dates) {
    const normalize = (0, $93cc854f09c80b6b$export$ead8a1812b171991).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}




function $6adcf5e4df55379b$export$63fa379ae8a9ba2(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$6adcf5e4df55379b$export$2e2bcd8739ae039 = $6adcf5e4df55379b$export$63fa379ae8a9ba2;


function $f83a873b157b4661$export$4a02e9c37dab4871(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f1eab3353eda9458$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    const laterStartOfDay = (0, $6adcf5e4df55379b$export$63fa379ae8a9ba2)(laterDate_);
    const earlierStartOfDay = (0, $6adcf5e4df55379b$export$63fa379ae8a9ba2)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, $798ff302a3eae88e$export$113002b5eff6e430)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, $798ff302a3eae88e$export$113002b5eff6e430)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, $8fcd7006f7e32aa4$export$b76b1809a2898f9a));
}
var // Fallback for modularized imports:
$f83a873b157b4661$export$2e2bcd8739ae039 = $f83a873b157b4661$export$4a02e9c37dab4871;


function $e580dca22e1bfd4c$export$489984ac7c996389(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f1eab3353eda9458$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const monthsDiff = laterDate_.getMonth() - earlierDate_.getMonth();
    return yearsDiff * 12 + monthsDiff;
}
var // Fallback for modularized imports:
$e580dca22e1bfd4c$export$2e2bcd8739ae039 = $e580dca22e1bfd4c$export$489984ac7c996389;



function $5b98fcfb96403ba3$export$de90a4bb31c25221(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const quarter = Math.trunc(_date.getMonth() / 3) + 1;
    return quarter;
}
var // Fallback for modularized imports:
$5b98fcfb96403ba3$export$2e2bcd8739ae039 = $5b98fcfb96403ba3$export$de90a4bb31c25221;


function $7b147184d0363e71$export$f62ae9fb13958c7a(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f1eab3353eda9458$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    const yearsDiff = laterDate_.getFullYear() - earlierDate_.getFullYear();
    const quartersDiff = (0, $5b98fcfb96403ba3$export$de90a4bb31c25221)(laterDate_) - (0, $5b98fcfb96403ba3$export$de90a4bb31c25221)(earlierDate_);
    return yearsDiff * 4 + quartersDiff;
}
var // Fallback for modularized imports:
$7b147184d0363e71$export$2e2bcd8739ae039 = $7b147184d0363e71$export$f62ae9fb13958c7a;


function $44a3d8022c34241b$export$c06dce8b38891685(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f1eab3353eda9458$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    return laterDate_.getFullYear() - earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$44a3d8022c34241b$export$2e2bcd8739ae039 = $44a3d8022c34241b$export$c06dce8b38891685;



function $917d28031341f08a$export$86415ebf4eb36b8c(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f1eab3353eda9458$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    const sign = $917d28031341f08a$var$compareLocalAsc(laterDate_, earlierDate_);
    const difference = Math.abs((0, $f83a873b157b4661$export$4a02e9c37dab4871)(laterDate_, earlierDate_));
    laterDate_.setDate(laterDate_.getDate() - sign * difference);
    // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
    // If so, result must be decreased by 1 in absolute value
    const isLastDayNotFull = Number($917d28031341f08a$var$compareLocalAsc(laterDate_, earlierDate_) === -sign);
    const result = sign * (difference - isLastDayNotFull);
    // Prevent negative zero
    return result === 0 ? 0 : result;
}
// Like `compareAsc` but uses local time not UTC, which is needed
// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.
function $917d28031341f08a$var$compareLocalAsc(laterDate, earlierDate) {
    const diff = laterDate.getFullYear() - earlierDate.getFullYear() || laterDate.getMonth() - earlierDate.getMonth() || laterDate.getDate() - earlierDate.getDate() || laterDate.getHours() - earlierDate.getHours() || laterDate.getMinutes() - earlierDate.getMinutes() || laterDate.getSeconds() - earlierDate.getSeconds() || laterDate.getMilliseconds() - earlierDate.getMilliseconds();
    if (diff < 0) return -1;
    if (diff > 0) return 1;
    // Return 0 if diff is 0; return NaN if diff is NaN
    return diff;
}
var // Fallback for modularized imports:
$917d28031341f08a$export$2e2bcd8739ae039 = $917d28031341f08a$export$86415ebf4eb36b8c;


function $da86bf3c3f1468b8$export$eb9a03f0e9aa6cea(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$da86bf3c3f1468b8$export$2e2bcd8739ae039 = $da86bf3c3f1468b8$export$eb9a03f0e9aa6cea;


function $81a173c055afbc0d$export$a2258d9c4118825c(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const month = _date.getMonth();
    _date.setFullYear(_date.getFullYear(), month + 1, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$81a173c055afbc0d$export$2e2bcd8739ae039 = $81a173c055afbc0d$export$a2258d9c4118825c;

let $61ad82fddc530085$var$defaultOptions = {};
function $61ad82fddc530085$export$430a3269e24b912e() {
    return $61ad82fddc530085$var$defaultOptions;
}
function $61ad82fddc530085$export$95365be1b0704abc(newOptions) {
    $61ad82fddc530085$var$defaultOptions = newOptions;
}



function $0af5ab6305acda41$export$ef8b6d9133084f4e(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $61ad82fddc530085$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    const weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
    _date.setDate(_date.getDate() + diff);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$0af5ab6305acda41$export$2e2bcd8739ae039 = $0af5ab6305acda41$export$ef8b6d9133084f4e;


function $aa26a860d0852c6f$export$8b7aa55c66d5569e(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    _date.setFullYear(year + 1, 0, 0);
    _date.setHours(23, 59, 59, 999);
    return _date;
}
var // Fallback for modularized imports:
$aa26a860d0852c6f$export$2e2bcd8739ae039 = $aa26a860d0852c6f$export$8b7aa55c66d5569e;

const $2bef53d697293f8a$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const $2bef53d697293f8a$export$2c14ff85d6318973 = (token, count, options)=>{
    let result;
    const tokenValue = $2bef53d697293f8a$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options === null || options === void 0 ? void 0 : options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};


function $ddb4e0a4dea96816$export$38e44e97ce4dbb7d(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


const $d2059f186e508fad$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const $d2059f186e508fad$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const $d2059f186e508fad$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const $d2059f186e508fad$export$cbf60ecb96cbb82f = {
    date: (0, $ddb4e0a4dea96816$export$38e44e97ce4dbb7d)({
        formats: $d2059f186e508fad$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $ddb4e0a4dea96816$export$38e44e97ce4dbb7d)({
        formats: $d2059f186e508fad$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $ddb4e0a4dea96816$export$38e44e97ce4dbb7d)({
        formats: $d2059f186e508fad$var$dateTimeFormats,
        defaultWidth: "full"
    })
};


const $bdbb91465ef11bff$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const $bdbb91465ef11bff$export$8fbbfd65594f46a0 = (token, _date, _baseDate, _options)=>$bdbb91465ef11bff$var$formatRelativeLocale[token];


/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ function $df5dc22c628ff836$export$63596d6ee8878b25(args) {
    return (value, options)=>{
        const context = (options === null || options === void 0 ? void 0 : options.context) ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = (options === null || options === void 0 ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


const $e58aa4722f8883d3$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const $e58aa4722f8883d3$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const $e58aa4722f8883d3$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const $e58aa4722f8883d3$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const $e58aa4722f8883d3$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const $e58aa4722f8883d3$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const $e58aa4722f8883d3$var$ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const $e58aa4722f8883d3$export$b3bd0bc58e36cd63 = {
    ordinalNumber: $e58aa4722f8883d3$var$ordinalNumber,
    era: (0, $df5dc22c628ff836$export$63596d6ee8878b25)({
        values: $e58aa4722f8883d3$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $df5dc22c628ff836$export$63596d6ee8878b25)({
        values: $e58aa4722f8883d3$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, $df5dc22c628ff836$export$63596d6ee8878b25)({
        values: $e58aa4722f8883d3$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $df5dc22c628ff836$export$63596d6ee8878b25)({
        values: $e58aa4722f8883d3$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $df5dc22c628ff836$export$63596d6ee8878b25)({
        values: $e58aa4722f8883d3$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $e58aa4722f8883d3$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};


function $541ab6f7aedd86b9$export$1430a0f35710914d(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? $541ab6f7aedd86b9$var$findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : $541ab6f7aedd86b9$var$findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $541ab6f7aedd86b9$var$findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $541ab6f7aedd86b9$var$findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $89e78c12a38ae27f$export$fdaf2fd6d7edde95(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


const $41da9fa24175fe2f$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const $41da9fa24175fe2f$var$parseOrdinalNumberPattern = /\d+/i;
const $41da9fa24175fe2f$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const $41da9fa24175fe2f$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const $41da9fa24175fe2f$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const $41da9fa24175fe2f$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const $41da9fa24175fe2f$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const $41da9fa24175fe2f$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const $41da9fa24175fe2f$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const $41da9fa24175fe2f$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const $41da9fa24175fe2f$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const $41da9fa24175fe2f$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const $41da9fa24175fe2f$export$4659b591c19bdf3d = {
    ordinalNumber: (0, $89e78c12a38ae27f$export$fdaf2fd6d7edde95)({
        matchPattern: $41da9fa24175fe2f$var$matchOrdinalNumberPattern,
        parsePattern: $41da9fa24175fe2f$var$parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, $541ab6f7aedd86b9$export$1430a0f35710914d)({
        matchPatterns: $41da9fa24175fe2f$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $41da9fa24175fe2f$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $541ab6f7aedd86b9$export$1430a0f35710914d)({
        matchPatterns: $41da9fa24175fe2f$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $41da9fa24175fe2f$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, $541ab6f7aedd86b9$export$1430a0f35710914d)({
        matchPatterns: $41da9fa24175fe2f$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $41da9fa24175fe2f$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $541ab6f7aedd86b9$export$1430a0f35710914d)({
        matchPatterns: $41da9fa24175fe2f$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $41da9fa24175fe2f$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $541ab6f7aedd86b9$export$1430a0f35710914d)({
        matchPatterns: $41da9fa24175fe2f$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $41da9fa24175fe2f$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};


const $44bd8aa6859b09cb$export$137380d9ce54f7f = {
    code: "en-US",
    formatDistance: (0, $2bef53d697293f8a$export$2c14ff85d6318973),
    formatLong: (0, $d2059f186e508fad$export$cbf60ecb96cbb82f),
    formatRelative: (0, $bdbb91465ef11bff$export$8fbbfd65594f46a0),
    localize: (0, $e58aa4722f8883d3$export$b3bd0bc58e36cd63),
    match: (0, $41da9fa24175fe2f$export$4659b591c19bdf3d),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
var // Fallback for modularized imports:
$44bd8aa6859b09cb$export$2e2bcd8739ae039 = $44bd8aa6859b09cb$export$137380d9ce54f7f;





function $78040c6eb7d2e9d1$export$f91e89d3d0406102(date, options) {
    const date_ = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
var // Fallback for modularized imports:
$78040c6eb7d2e9d1$export$2e2bcd8739ae039 = $78040c6eb7d2e9d1$export$f91e89d3d0406102;



function $7224ae8634f5fd26$export$d3b42cd8452deec(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = (0, $f83a873b157b4661$export$4a02e9c37dab4871)(_date, (0, $78040c6eb7d2e9d1$export$f91e89d3d0406102)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
var // Fallback for modularized imports:
$7224ae8634f5fd26$export$2e2bcd8739ae039 = $7224ae8634f5fd26$export$d3b42cd8452deec;







function $f9d909ef454eaaa1$export$42c81a444fbfb5d4(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $61ad82fddc530085$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    const weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$f9d909ef454eaaa1$export$2e2bcd8739ae039 = $f9d909ef454eaaa1$export$42c81a444fbfb5d4;


function $c5f18ffcee1d4da1$export$6173213f95a4431e(date, options) {
    return (0, $f9d909ef454eaaa1$export$42c81a444fbfb5d4)(date, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
        weekStartsOn: 1
    }));
}
var // Fallback for modularized imports:
$c5f18ffcee1d4da1$export$2e2bcd8739ae039 = $c5f18ffcee1d4da1$export$6173213f95a4431e;






function $56d1e400076174df$export$3dbc52535f6f8fcc(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, $93cc854f09c80b6b$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $c5f18ffcee1d4da1$export$6173213f95a4431e)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, $93cc854f09c80b6b$export$ead8a1812b171991)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $c5f18ffcee1d4da1$export$6173213f95a4431e)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$56d1e400076174df$export$2e2bcd8739ae039 = $56d1e400076174df$export$3dbc52535f6f8fcc;



function $65555d1a0f736fc8$export$236bdfa374eb69a9(date, options) {
    const year = (0, $56d1e400076174df$export$3dbc52535f6f8fcc)(date, options);
    const fourthOfJanuary = (0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, $c5f18ffcee1d4da1$export$6173213f95a4431e)(fourthOfJanuary);
}
var // Fallback for modularized imports:
$65555d1a0f736fc8$export$2e2bcd8739ae039 = $65555d1a0f736fc8$export$236bdfa374eb69a9;



function $21702feccb8583bb$export$7cabdc5698b63e2f(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = +(0, $c5f18ffcee1d4da1$export$6173213f95a4431e)(_date) - +(0, $65555d1a0f736fc8$export$236bdfa374eb69a9)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $8fcd7006f7e32aa4$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$21702feccb8583bb$export$2e2bcd8739ae039 = $21702feccb8583bb$export$7cabdc5698b63e2f;











function $92c4069fd1d5a4d1$export$12d572480ceb6e58(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, $61ad82fddc530085$export$430a3269e24b912e)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    const firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    const firstWeekOfNextYear = (0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, $f9d909ef454eaaa1$export$42c81a444fbfb5d4)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, $f9d909ef454eaaa1$export$42c81a444fbfb5d4)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
var // Fallback for modularized imports:
$92c4069fd1d5a4d1$export$2e2bcd8739ae039 = $92c4069fd1d5a4d1$export$12d572480ceb6e58;



function $3408687fb4bed137$export$bb7b45bb8e74da0f(date, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $61ad82fddc530085$export$430a3269e24b912e)();
    var _options_firstWeekContainsDate, _ref, _ref1, _ref2;
    const firstWeekContainsDate = (_ref2 = (_ref1 = (_ref = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : defaultOptions.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1;
    const year = (0, $92c4069fd1d5a4d1$export$12d572480ceb6e58)(date, options);
    const firstWeek = (0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, $f9d909ef454eaaa1$export$42c81a444fbfb5d4)(firstWeek, options);
    return _date;
}
var // Fallback for modularized imports:
$3408687fb4bed137$export$2e2bcd8739ae039 = $3408687fb4bed137$export$bb7b45bb8e74da0f;



function $640501682e0224a1$export$efe19b760242b2fc(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = +(0, $f9d909ef454eaaa1$export$42c81a444fbfb5d4)(_date, options) - +(0, $3408687fb4bed137$export$bb7b45bb8e74da0f)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, $8fcd7006f7e32aa4$export$4fad13613e88edc8)) + 1;
}
var // Fallback for modularized imports:
$640501682e0224a1$export$2e2bcd8739ae039 = $640501682e0224a1$export$efe19b760242b2fc;



function $86dce5c07c855d8c$export$c8306e720e213c0f(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}



const $4c9a9466ab823617$export$b0d4b338e1516f13 = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(fractionalSeconds, token.length);
    }
};


const $49dc66ceb10ea843$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const $49dc66ceb10ea843$export$fe98a034cfb96d55 = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $4c9a9466ab823617$export$b0d4b338e1516f13).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, $92c4069fd1d5a4d1$export$12d572480ceb6e58)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, $56d1e400076174df$export$3dbc52535f6f8fcc)(date);
        // Padding
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $4c9a9466ab823617$export$b0d4b338e1516f13).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, $640501682e0224a1$export$efe19b760242b2fc)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, $21702feccb8583bb$export$7cabdc5698b63e2f)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, $4c9a9466ab823617$export$b0d4b338e1516f13).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, $7224ae8634f5fd26$export$d3b42cd8452deec)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $49dc66ceb10ea843$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $49dc66ceb10ea843$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $49dc66ceb10ea843$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $49dc66ceb10ea843$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $49dc66ceb10ea843$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $49dc66ceb10ea843$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $4c9a9466ab823617$export$b0d4b338e1516f13).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, $4c9a9466ab823617$export$b0d4b338e1516f13).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, $4c9a9466ab823617$export$b0d4b338e1516f13).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, $4c9a9466ab823617$export$b0d4b338e1516f13).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, $4c9a9466ab823617$export$b0d4b338e1516f13).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $49dc66ceb10ea843$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return $49dc66ceb10ea843$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $49dc66ceb10ea843$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $49dc66ceb10ea843$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return $49dc66ceb10ea843$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $49dc66ceb10ea843$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $49dc66ceb10ea843$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $49dc66ceb10ea843$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $49dc66ceb10ea843$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $49dc66ceb10ea843$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(+date, token.length);
    }
};
function $49dc66ceb10ea843$var$formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(minutes, 2);
}
function $49dc66ceb10ea843$var$formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(Math.abs(offset) / 60, 2);
    }
    return $49dc66ceb10ea843$var$formatTimezone(offset, delimiter);
}
function $49dc66ceb10ea843$var$formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, $86dce5c07c855d8c$export$c8306e720e213c0f)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}


const $5c87db339038f1b5$var$dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const $5c87db339038f1b5$var$timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const $5c87db339038f1b5$var$dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return $5c87db339038f1b5$var$dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $5c87db339038f1b5$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $5c87db339038f1b5$var$timeLongFormatter(timePattern, formatLong));
};
const $5c87db339038f1b5$export$70cc8fd02856fd58 = {
    p: $5c87db339038f1b5$var$timeLongFormatter,
    P: $5c87db339038f1b5$var$dateTimeLongFormatter
};


const $c71749bb64d8b2c7$var$dayOfYearTokenRE = /^D+$/;
const $c71749bb64d8b2c7$var$weekYearTokenRE = /^Y+$/;
const $c71749bb64d8b2c7$var$throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function $c71749bb64d8b2c7$export$c6cc36aa33304772(token) {
    return $c71749bb64d8b2c7$var$dayOfYearTokenRE.test(token);
}
function $c71749bb64d8b2c7$export$c6b49d6dceb604a1(token) {
    return $c71749bb64d8b2c7$var$weekYearTokenRE.test(token);
}
function $c71749bb64d8b2c7$export$f5f38f90ecaaf879(token, format, input) {
    const _message = $c71749bb64d8b2c7$var$message(token, format, input);
    console.warn(_message);
    if ($c71749bb64d8b2c7$var$throwTokens.includes(token)) throw new RangeError(_message);
}
function $c71749bb64d8b2c7$var$message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}


/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ function $5e4a1e7833f0eaed$export$871608497c498473(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
var // Fallback for modularized imports:
$5e4a1e7833f0eaed$export$2e2bcd8739ae039 = $5e4a1e7833f0eaed$export$871608497c498473;



function $070b8e24dc8d9a3e$export$1ea939691cdc45b8(date) {
    return !(!(0, $5e4a1e7833f0eaed$export$871608497c498473)(date) && typeof date !== "number" || isNaN(+(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date)));
}
var // Fallback for modularized imports:
$070b8e24dc8d9a3e$export$2e2bcd8739ae039 = $070b8e24dc8d9a3e$export$1ea939691cdc45b8;



// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $38b981d0856c132a$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $38b981d0856c132a$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $38b981d0856c132a$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $38b981d0856c132a$var$doubleQuoteRegExp = /''/g;
const $38b981d0856c132a$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $38b981d0856c132a$export$d9468344d3651243(date, formatStr, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    const defaultOptions = (0, $61ad82fddc530085$export$430a3269e24b912e)();
    var _options_locale2, _ref;
    const locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $44bd8aa6859b09cb$export$137380d9ce54f7f);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    const firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    const weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    const originalDate = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    if (!(0, $070b8e24dc8d9a3e$export$1ea939691cdc45b8)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match($38b981d0856c132a$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, $5c87db339038f1b5$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($38b981d0856c132a$var$formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: $38b981d0856c132a$var$cleanEscapedString(substring)
        };
        if ((0, $49dc66ceb10ea843$export$fe98a034cfb96d55)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match($38b981d0856c132a$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $c71749bb64d8b2c7$export$c6b49d6dceb604a1)(token) || !(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $c71749bb64d8b2c7$export$c6cc36aa33304772)(token)) (0, $c71749bb64d8b2c7$export$f5f38f90ecaaf879)(token, formatStr, String(date));
        const formatter = (0, $49dc66ceb10ea843$export$fe98a034cfb96d55)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function $38b981d0856c132a$var$cleanEscapedString(input) {
    const matched = input.match($38b981d0856c132a$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($38b981d0856c132a$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$38b981d0856c132a$export$2e2bcd8739ae039 = $38b981d0856c132a$export$d9468344d3651243;


function $64bf8e94c854677c$export$aa350b96d91cd94(date, options) {
    return (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getDate();
}
var // Fallback for modularized imports:
$64bf8e94c854677c$export$2e2bcd8739ae039 = $64bf8e94c854677c$export$aa350b96d91cd94;


function $d63cd9e792b2e7f8$export$1b64bc9c5306ed54(date, options) {
    return (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getDay();
}
var // Fallback for modularized imports:
$d63cd9e792b2e7f8$export$2e2bcd8739ae039 = $d63cd9e792b2e7f8$export$1b64bc9c5306ed54;


function $1768b25c11e35b0a$export$257b40f71c07d58f(date, options) {
    return (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getHours();
}
var // Fallback for modularized imports:
$1768b25c11e35b0a$export$2e2bcd8739ae039 = $1768b25c11e35b0a$export$257b40f71c07d58f;


function $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145(date, options) {
    return (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getMinutes();
}
var // Fallback for modularized imports:
$2a7e90ce6707ba01$export$2e2bcd8739ae039 = $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145;


function $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b(date, options) {
    return (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getMonth();
}
var // Fallback for modularized imports:
$7dc7d1cfe79653ed$export$2e2bcd8739ae039 = $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b;


function $ad405ba8e35fff1c$export$5e9417507ff28427(date) {
    return (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date).getSeconds();
}
var // Fallback for modularized imports:
$ad405ba8e35fff1c$export$2e2bcd8739ae039 = $ad405ba8e35fff1c$export$5e9417507ff28427;


function $8ab40eacd8053634$export$1428f42a7de81803(date) {
    return +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date);
}
var // Fallback for modularized imports:
$8ab40eacd8053634$export$2e2bcd8739ae039 = $8ab40eacd8053634$export$1428f42a7de81803;


function $18282d9928d9137b$export$5846dc2d57a5c860(date, options) {
    return (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getFullYear();
}
var // Fallback for modularized imports:
$18282d9928d9137b$export$2e2bcd8739ae039 = $18282d9928d9137b$export$5846dc2d57a5c860;


function $04f0c9d20b09837b$export$e4de839670987035(date, dateToCompare) {
    return +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date) > +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$04f0c9d20b09837b$export$2e2bcd8739ae039 = $04f0c9d20b09837b$export$e4de839670987035;


function $eb21892051383660$export$5c007e10c6929c95(date, dateToCompare) {
    return +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date) < +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(dateToCompare);
}
var // Fallback for modularized imports:
$eb21892051383660$export$2e2bcd8739ae039 = $eb21892051383660$export$5c007e10c6929c95;


function $5c4f7b6ec3edce7a$export$248d38f6296296c5(leftDate, rightDate) {
    return +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(leftDate) === +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(rightDate);
}
var // Fallback for modularized imports:
$5c4f7b6ec3edce7a$export$2e2bcd8739ae039 = $5c4f7b6ec3edce7a$export$248d38f6296296c5;



function $0614127f134da85e$export$ea39ec197993aef0(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $f1eab3353eda9458$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    return +(0, $6adcf5e4df55379b$export$63fa379ae8a9ba2)(dateLeft_) === +(0, $6adcf5e4df55379b$export$63fa379ae8a9ba2)(dateRight_);
}
var // Fallback for modularized imports:
$0614127f134da85e$export$2e2bcd8739ae039 = $0614127f134da85e$export$ea39ec197993aef0;


function $5d9f887231a923ce$export$a18c89cbd24170ff(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f1eab3353eda9458$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear() && laterDate_.getMonth() === earlierDate_.getMonth();
}
var // Fallback for modularized imports:
$5d9f887231a923ce$export$2e2bcd8739ae039 = $5d9f887231a923ce$export$a18c89cbd24170ff;



function $2f5f22891d29251a$export$69be7267a042ecb3(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const currentMonth = _date.getMonth();
    const month = currentMonth - currentMonth % 3;
    _date.setMonth(month, 1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$2f5f22891d29251a$export$2e2bcd8739ae039 = $2f5f22891d29251a$export$69be7267a042ecb3;


function $af8cf12eef3460bb$export$5c60e4190867161c(laterDate, earlierDate, options) {
    const [dateLeft_, dateRight_] = (0, $f1eab3353eda9458$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    return +(0, $2f5f22891d29251a$export$69be7267a042ecb3)(dateLeft_) === +(0, $2f5f22891d29251a$export$69be7267a042ecb3)(dateRight_);
}
var // Fallback for modularized imports:
$af8cf12eef3460bb$export$2e2bcd8739ae039 = $af8cf12eef3460bb$export$5c60e4190867161c;


function $42e8c0c34f57b6cb$export$5841f9eb9773f25f(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, $f1eab3353eda9458$export$9f53b88e82f64d8d)(options === null || options === void 0 ? void 0 : options.in, laterDate, earlierDate);
    return laterDate_.getFullYear() === earlierDate_.getFullYear();
}
var // Fallback for modularized imports:
$42e8c0c34f57b6cb$export$2e2bcd8739ae039 = $42e8c0c34f57b6cb$export$5841f9eb9773f25f;


function $76a0813dbe6750d3$export$d7deef7a3738e19d(date, interval, options) {
    const time = +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const [startTime, endTime] = [
        +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(interval.start, options === null || options === void 0 ? void 0 : options.in),
        +(0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(interval.end, options === null || options === void 0 ? void 0 : options.in)
    ].sort((a, b)=>a - b);
    return time >= startTime && time <= endTime;
}
var // Fallback for modularized imports:
$76a0813dbe6750d3$export$2e2bcd8739ae039 = $76a0813dbe6750d3$export$d7deef7a3738e19d;



function $fc0a57bff9d7d350$export$8960430cfd85939f(dates, options) {
    let result;
    let context = options === null || options === void 0 ? void 0 : options.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, $93cc854f09c80b6b$export$ead8a1812b171991).bind(null, date);
        const date_ = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, context);
        if (!result || result < date_ || isNaN(+date_)) result = date_;
    });
    return (0, $93cc854f09c80b6b$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$fc0a57bff9d7d350$export$2e2bcd8739ae039 = $fc0a57bff9d7d350$export$8960430cfd85939f;



function $7c04ad025186dca2$export$96ec731ed4dcb222(dates, options) {
    let result;
    let context = options === null || options === void 0 ? void 0 : options.in;
    dates.forEach((date)=>{
        // Use the first date object as the context function
        if (!context && typeof date === "object") context = (0, $93cc854f09c80b6b$export$ead8a1812b171991).bind(null, date);
        const date_ = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, context);
        if (!result || result > date_ || isNaN(+date_)) result = date_;
    });
    return (0, $93cc854f09c80b6b$export$ead8a1812b171991)(context, result || NaN);
}
var // Fallback for modularized imports:
$7c04ad025186dca2$export$2e2bcd8739ae039 = $7c04ad025186dca2$export$96ec731ed4dcb222;






function $32d3fc12ea0f5ff7$export$430a3269e24b912e() {
    return Object.assign({}, (0, $61ad82fddc530085$export$430a3269e24b912e)());
}
var // Fallback for modularized imports:
$32d3fc12ea0f5ff7$export$2e2bcd8739ae039 = $32d3fc12ea0f5ff7$export$430a3269e24b912e;






function $6fcc5e0b0b945545$export$9cb09a71b7d66923(date, constructor) {
    const date_ = $6fcc5e0b0b945545$var$isConstructor(constructor) ? new constructor(0) : (0, $93cc854f09c80b6b$export$ead8a1812b171991)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function $6fcc5e0b0b945545$var$isConstructor(constructor) {
    var _constructor_prototype;
    return typeof constructor === "function" && ((_constructor_prototype = constructor.prototype) === null || _constructor_prototype === void 0 ? void 0 : _constructor_prototype.constructor) === constructor;
}
var // Fallback for modularized imports:
$6fcc5e0b0b945545$export$2e2bcd8739ae039 = $6fcc5e0b0b945545$export$9cb09a71b7d66923;


const $35d314da2f2e1f0d$var$TIMEZONE_UNIT_PRIORITY = 10;
class $35d314da2f2e1f0d$export$81d53e3678089a6 {
    validate(_utcDate, _options) {
        return true;
    }
    constructor(){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "subPriority", 0);
    }
}
class $35d314da2f2e1f0d$export$9a09e32dd4990fd5 extends $35d314da2f2e1f0d$export$81d53e3678089a6 {
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
}
class $35d314da2f2e1f0d$export$8be15fe85ad72f86 extends $35d314da2f2e1f0d$export$81d53e3678089a6 {
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, $93cc854f09c80b6b$export$ead8a1812b171991)(date, (0, $6fcc5e0b0b945545$export$9cb09a71b7d66923)(date, this.context));
    }
    constructor(context, reference){
        super(), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", $35d314da2f2e1f0d$var$TIMEZONE_UNIT_PRIORITY), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "subPriority", -1);
        this.context = context || ((date)=>(0, $93cc854f09c80b6b$export$ead8a1812b171991)(reference, date));
    }
}




class $70e2ae5a386a81a1$export$7acfa6ed01010e37 {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, $35d314da2f2e1f0d$export$9a09e32dd4990fd5)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}


class $cc8a5c742ca5ced8$export$8e5a1d3f85a9688 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 140), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "R",
            "u",
            "t",
            "T"
        ]);
    }
}





const $350f5a4d90cce133$export$c123ee06d9da8480 = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const $350f5a4d90cce133$export$a7ee192b982af9c1 = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};


function $7c207269bcf55e57$export$4f84e3a82c7b538(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function $7c207269bcf55e57$export$cc7cc9e2a3ff9388(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7c207269bcf55e57$export$6497f4c0ecdfba8e(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, $8fcd7006f7e32aa4$export$7f72910d6dfd237a) + minutes * (0, $8fcd7006f7e32aa4$export$91246f0b9bd9beff) + seconds * (0, $8fcd7006f7e32aa4$export$397c2d5776aa9055)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function $7c207269bcf55e57$export$d931c43c4608a164(dateString) {
    return $7c207269bcf55e57$export$cc7cc9e2a3ff9388((0, $350f5a4d90cce133$export$c123ee06d9da8480).anyDigitsSigned, dateString);
}
function $7c207269bcf55e57$export$513bb01536146ab6(n, dateString) {
    switch(n){
        case 1:
            return $7c207269bcf55e57$export$cc7cc9e2a3ff9388((0, $350f5a4d90cce133$export$c123ee06d9da8480).singleDigit, dateString);
        case 2:
            return $7c207269bcf55e57$export$cc7cc9e2a3ff9388((0, $350f5a4d90cce133$export$c123ee06d9da8480).twoDigits, dateString);
        case 3:
            return $7c207269bcf55e57$export$cc7cc9e2a3ff9388((0, $350f5a4d90cce133$export$c123ee06d9da8480).threeDigits, dateString);
        case 4:
            return $7c207269bcf55e57$export$cc7cc9e2a3ff9388((0, $350f5a4d90cce133$export$c123ee06d9da8480).fourDigits, dateString);
        default:
            return $7c207269bcf55e57$export$cc7cc9e2a3ff9388(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function $7c207269bcf55e57$export$2c9307b2e29c533c(n, dateString) {
    switch(n){
        case 1:
            return $7c207269bcf55e57$export$cc7cc9e2a3ff9388((0, $350f5a4d90cce133$export$c123ee06d9da8480).singleDigitSigned, dateString);
        case 2:
            return $7c207269bcf55e57$export$cc7cc9e2a3ff9388((0, $350f5a4d90cce133$export$c123ee06d9da8480).twoDigitsSigned, dateString);
        case 3:
            return $7c207269bcf55e57$export$cc7cc9e2a3ff9388((0, $350f5a4d90cce133$export$c123ee06d9da8480).threeDigitsSigned, dateString);
        case 4:
            return $7c207269bcf55e57$export$cc7cc9e2a3ff9388((0, $350f5a4d90cce133$export$c123ee06d9da8480).fourDigitsSigned, dateString);
        default:
            return $7c207269bcf55e57$export$cc7cc9e2a3ff9388(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function $7c207269bcf55e57$export$fb506d2676e7f207(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function $7c207269bcf55e57$export$29126f735cbf69f7(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function $7c207269bcf55e57$export$3d50627710b84d75(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}


class $b498bfc2b2115875$export$48d352de7cd4a988 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "yo":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7c207269bcf55e57$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 130), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "u",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}







class $76545862509f4f3d$export$b8ef38dfcf05d5db extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year: year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$513bb01536146ab6)(4, dateString), valueCallback);
            case "Yo":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, $92c4069fd1d5a4d1$export$12d572480ceb6e58)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, $7c207269bcf55e57$export$29126f735cbf69f7)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, $f9d909ef454eaaa1$export$42c81a444fbfb5d4)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, $f9d909ef454eaaa1$export$42c81a444fbfb5d4)(date, options);
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 130), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
    }
}







class $c9a02e7ec3cba1f4$export$951d1df011fde06f extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token) {
        if (token === "R") return (0, $7c207269bcf55e57$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7c207269bcf55e57$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, $93cc854f09c80b6b$export$ead8a1812b171991)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, $c5f18ffcee1d4da1$export$6173213f95a4431e)(firstWeekOfYear);
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 130), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "u",
            "Q",
            "q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}





class $02d6a005b3a1f38e$export$bad9d2ea38e8f1a extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token) {
        if (token === "u") return (0, $7c207269bcf55e57$export$2c9307b2e29c533c)(4, dateString);
        return (0, $7c207269bcf55e57$export$2c9307b2e29c533c)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 130), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "G",
            "y",
            "Y",
            "R",
            "w",
            "I",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}





class $cae67e6b48e15bf9$export$5cb0f701186dde1d extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 120), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}





class $b920b37ddf01f383$export$300c0c2990e20e6d extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 120), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}






class $e7f21d9a6a272810$export$400dd8b40ef138a3 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "L",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 110);
    }
}






class $e0965663fde5a833$export$1d7eaa53eaa5deba extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$513bb01536146ab6)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 110), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}





function $31d22ad730463668$export$4b3066ce4afafd88(date, week, options) {
    const date_ = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = (0, $640501682e0224a1$export$efe19b760242b2fc)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date_, options === null || options === void 0 ? void 0 : options.in);
}
var // Fallback for modularized imports:
$31d22ad730463668$export$2e2bcd8739ae039 = $31d22ad730463668$export$4b3066ce4afafd88;






class $6d58f96f11c2f6c3$export$c4005ffc174e07c0 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, $f9d909ef454eaaa1$export$42c81a444fbfb5d4)((0, $31d22ad730463668$export$4b3066ce4afafd88)(date, value, options), options);
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 100), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "i",
            "t",
            "T"
        ]);
    }
}





function $d170c96133dac301$export$6542bebf6be94082(date, week, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const diff = (0, $21702feccb8583bb$export$7cabdc5698b63e2f)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
var // Fallback for modularized imports:
$d170c96133dac301$export$2e2bcd8739ae039 = $d170c96133dac301$export$6542bebf6be94082;






class $8bce3992bd5b15a8$export$6fc8dbedd560a6af extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, $c5f18ffcee1d4da1$export$6173213f95a4431e)((0, $d170c96133dac301$export$6542bebf6be94082)(date, value));
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 100), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}






const $97d0e412072edbd6$var$DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const $97d0e412072edbd6$var$DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class $97d0e412072edbd6$export$e8d4b28a20981dd2 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7c207269bcf55e57$export$3d50627710b84d75)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= $97d0e412072edbd6$var$DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= $97d0e412072edbd6$var$DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 90), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "subPriority", 1), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "w",
            "I",
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}






class $2072db8cb02c42b6$export$6cfe0d613455f615 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, $7c207269bcf55e57$export$3d50627710b84d75)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 90), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "subpriority", 1), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "Y",
            "R",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "I",
            "d",
            "E",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}






function $0a7bce4b04ee58db$export$b04fdcda82decc6c(date, day, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale;
    const defaultOptions = (0, $61ad82fddc530085$export$430a3269e24b912e)();
    var _options_weekStartsOn, _ref, _ref1, _ref2;
    const weekStartsOn = (_ref2 = (_ref1 = (_ref = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.weekStartsOn) !== null && _ref !== void 0 ? _ref : defaultOptions.weekStartsOn) !== null && _ref1 !== void 0 ? _ref1 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : 0;
    const date_ = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$0a7bce4b04ee58db$export$2e2bcd8739ae039 = $0a7bce4b04ee58db$export$b04fdcda82decc6c;



class $2907bb188a157020$export$1b03c8b76262f7bd extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $0a7bce4b04ee58db$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 90), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "D",
            "i",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}






class $d55e2cb8fdc2bdc3$export$44d1c127ab42c480 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $0a7bce4b04ee58db$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 90), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "c",
            "t",
            "T"
        ]);
    }
}






class $d731dc7a7f897dec$export$e447a647caaaec1d extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, $0a7bce4b04ee58db$export$b04fdcda82decc6c)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 90), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "R",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "I",
            "d",
            "D",
            "E",
            "i",
            "e",
            "t",
            "T"
        ]);
    }
}





function $8428174e934300ac$export$c514f4c1a8ed5e9e(date, options) {
    const day = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in).getDay();
    return day === 0 ? 7 : day;
}
var // Fallback for modularized imports:
$8428174e934300ac$export$2e2bcd8739ae039 = $8428174e934300ac$export$c514f4c1a8ed5e9e;



function $94e19d5b027736a7$export$1fd9df65adb0d1aa(date, day, options) {
    const date_ = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const currentDay = (0, $8428174e934300ac$export$c514f4c1a8ed5e9e)(date_, options);
    const diff = day - currentDay;
    return (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(date_, diff, options);
}
var // Fallback for modularized imports:
$94e19d5b027736a7$export$2e2bcd8739ae039 = $94e19d5b027736a7$export$1fd9df65adb0d1aa;




class $dd49f25b49c9a21f$export$693fb1e525095b2a extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, $94e19d5b027736a7$export$1fd9df65adb0d1aa)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 90), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "y",
            "Y",
            "u",
            "q",
            "Q",
            "M",
            "L",
            "w",
            "d",
            "D",
            "E",
            "e",
            "c",
            "t",
            "T"
        ]);
    }
}





class $9a5719b1f7fe2a44$export$8d1e08492351df91 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7c207269bcf55e57$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 80), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "b",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
    }
}





class $15d64a235495c3eb$export$73ca2bd0a17d273 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7c207269bcf55e57$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 80), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "a",
            "B",
            "H",
            "k",
            "t",
            "T"
        ]);
    }
}





class $08fa6e1f2a83c128$export$bb9212adf05373db extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, $7c207269bcf55e57$export$fb506d2676e7f207)(value), 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 80), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "a",
            "b",
            "t",
            "T"
        ]);
    }
}






class $eb33d9952289bffa$export$8a04050a727a1756 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 70), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "H",
            "K",
            "k",
            "t",
            "T"
        ]);
    }
}






class $300f3f9163bba0a4$export$e56f4dea2c3e56dd extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 70), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "a",
            "b",
            "h",
            "K",
            "k",
            "t",
            "T"
        ]);
    }
}






class $8e93476cbb109601$export$cbbe855312f87d77 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 70), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "h",
            "H",
            "k",
            "t",
            "T"
        ]);
    }
}






class $47b10dbdd93619ad$export$6008046d2b34b6a5 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 70), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "a",
            "b",
            "h",
            "H",
            "K",
            "t",
            "T"
        ]);
    }
}






class $0c2fd22310af8a9a$export$2b52670d9e2be53 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 60), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "t",
            "T"
        ]);
    }
}






class $65398c6fc9f5a2a6$export$94d46d540cf1366a extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, $7c207269bcf55e57$export$cc7cc9e2a3ff9388)((0, $350f5a4d90cce133$export$c123ee06d9da8480).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 50), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "t",
            "T"
        ]);
    }
}





class $f5fb75e0a70c71d3$export$b8e6f8b2d70893b1 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, $7c207269bcf55e57$export$4f84e3a82c7b538)((0, $7c207269bcf55e57$export$513bb01536146ab6)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 30), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "t",
            "T"
        ]);
    }
}








class $749346b3fdb9849d$export$104d901d49fea29b extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, $7c207269bcf55e57$export$6497f4c0ecdfba8e)((0, $350f5a4d90cce133$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "XX":
                return (0, $7c207269bcf55e57$export$6497f4c0ecdfba8e)((0, $350f5a4d90cce133$export$a7ee192b982af9c1).basic, dateString);
            case "XXXX":
                return (0, $7c207269bcf55e57$export$6497f4c0ecdfba8e)((0, $350f5a4d90cce133$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, $7c207269bcf55e57$export$6497f4c0ecdfba8e)((0, $350f5a4d90cce133$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, $7c207269bcf55e57$export$6497f4c0ecdfba8e)((0, $350f5a4d90cce133$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $93cc854f09c80b6b$export$ead8a1812b171991)(date, date.getTime() - (0, $798ff302a3eae88e$export$113002b5eff6e430)(date) - value);
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 10), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "t",
            "T",
            "x"
        ]);
    }
}








class $57ad395dcf00e0eb$export$12910e5204b52b9 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, $7c207269bcf55e57$export$6497f4c0ecdfba8e)((0, $350f5a4d90cce133$export$a7ee192b982af9c1).basicOptionalMinutes, dateString);
            case "xx":
                return (0, $7c207269bcf55e57$export$6497f4c0ecdfba8e)((0, $350f5a4d90cce133$export$a7ee192b982af9c1).basic, dateString);
            case "xxxx":
                return (0, $7c207269bcf55e57$export$6497f4c0ecdfba8e)((0, $350f5a4d90cce133$export$a7ee192b982af9c1).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, $7c207269bcf55e57$export$6497f4c0ecdfba8e)((0, $350f5a4d90cce133$export$a7ee192b982af9c1).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, $7c207269bcf55e57$export$6497f4c0ecdfba8e)((0, $350f5a4d90cce133$export$a7ee192b982af9c1).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, $93cc854f09c80b6b$export$ead8a1812b171991)(date, date.getTime() - (0, $798ff302a3eae88e$export$113002b5eff6e430)(date) - value);
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 10), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", [
            "t",
            "T",
            "X"
        ]);
    }
}






class $af6d5e8dd16cbfad$export$2cd8bf877a05e96 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString) {
        return (0, $7c207269bcf55e57$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $93cc854f09c80b6b$export$ead8a1812b171991)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 40), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", "*");
    }
}






class $99e5417b80ebaef9$export$6d8f69c6906d6368 extends (0, $70e2ae5a386a81a1$export$7acfa6ed01010e37) {
    parse(dateString) {
        return (0, $7c207269bcf55e57$export$d931c43c4608a164)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, $93cc854f09c80b6b$export$ead8a1812b171991)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "priority", 20), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incompatibleTokens", "*");
    }
}


const $2c8121a1e5daaaef$export$19131010e7fd8373 = {
    G: new (0, $cc8a5c742ca5ced8$export$8e5a1d3f85a9688)(),
    y: new (0, $b498bfc2b2115875$export$48d352de7cd4a988)(),
    Y: new (0, $76545862509f4f3d$export$b8ef38dfcf05d5db)(),
    R: new (0, $c9a02e7ec3cba1f4$export$951d1df011fde06f)(),
    u: new (0, $02d6a005b3a1f38e$export$bad9d2ea38e8f1a)(),
    Q: new (0, $cae67e6b48e15bf9$export$5cb0f701186dde1d)(),
    q: new (0, $b920b37ddf01f383$export$300c0c2990e20e6d)(),
    M: new (0, $e7f21d9a6a272810$export$400dd8b40ef138a3)(),
    L: new (0, $e0965663fde5a833$export$1d7eaa53eaa5deba)(),
    w: new (0, $6d58f96f11c2f6c3$export$c4005ffc174e07c0)(),
    I: new (0, $8bce3992bd5b15a8$export$6fc8dbedd560a6af)(),
    d: new (0, $97d0e412072edbd6$export$e8d4b28a20981dd2)(),
    D: new (0, $2072db8cb02c42b6$export$6cfe0d613455f615)(),
    E: new (0, $2907bb188a157020$export$1b03c8b76262f7bd)(),
    e: new (0, $d55e2cb8fdc2bdc3$export$44d1c127ab42c480)(),
    c: new (0, $d731dc7a7f897dec$export$e447a647caaaec1d)(),
    i: new (0, $dd49f25b49c9a21f$export$693fb1e525095b2a)(),
    a: new (0, $9a5719b1f7fe2a44$export$8d1e08492351df91)(),
    b: new (0, $15d64a235495c3eb$export$73ca2bd0a17d273)(),
    B: new (0, $08fa6e1f2a83c128$export$bb9212adf05373db)(),
    h: new (0, $eb33d9952289bffa$export$8a04050a727a1756)(),
    H: new (0, $300f3f9163bba0a4$export$e56f4dea2c3e56dd)(),
    K: new (0, $8e93476cbb109601$export$cbbe855312f87d77)(),
    k: new (0, $47b10dbdd93619ad$export$6008046d2b34b6a5)(),
    m: new (0, $0c2fd22310af8a9a$export$2b52670d9e2be53)(),
    s: new (0, $65398c6fc9f5a2a6$export$94d46d540cf1366a)(),
    S: new (0, $f5fb75e0a70c71d3$export$b8e6f8b2d70893b1)(),
    X: new (0, $749346b3fdb9849d$export$104d901d49fea29b)(),
    x: new (0, $57ad395dcf00e0eb$export$12910e5204b52b9)(),
    t: new (0, $af6d5e8dd16cbfad$export$2cd8bf877a05e96)(),
    T: new (0, $99e5417b80ebaef9$export$6d8f69c6906d6368)()
};


/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const $007c7f8b5e724128$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const $007c7f8b5e724128$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const $007c7f8b5e724128$var$escapedStringRegExp = /^'([^]*?)'?$/;
const $007c7f8b5e724128$var$doubleQuoteRegExp = /''/g;
const $007c7f8b5e724128$var$notWhitespaceRegExp = /\S/;
const $007c7f8b5e724128$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $007c7f8b5e724128$export$98e6a39c04603d36(dateStr, formatStr, referenceDate, options) {
    var _options_locale_options, _options_locale, _defaultOptions_locale_options, _defaultOptions_locale, _options_locale_options1, _options_locale1, _defaultOptions_locale_options1, _defaultOptions_locale1;
    const invalidDate = ()=>(0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || referenceDate, NaN);
    const defaultOptions = (0, $32d3fc12ea0f5ff7$export$430a3269e24b912e)();
    var _options_locale2, _ref;
    const locale = (_ref = (_options_locale2 = options === null || options === void 0 ? void 0 : options.locale) !== null && _options_locale2 !== void 0 ? _options_locale2 : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $44bd8aa6859b09cb$export$137380d9ce54f7f);
    var _options_firstWeekContainsDate, _ref1, _ref2, _ref3;
    const firstWeekContainsDate = (_ref3 = (_ref2 = (_ref1 = (_options_firstWeekContainsDate = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options_firstWeekContainsDate !== void 0 ? _options_firstWeekContainsDate : options === null || options === void 0 ? void 0 : (_options_locale = options.locale) === null || _options_locale === void 0 ? void 0 : (_options_locale_options = _options_locale.options) === null || _options_locale_options === void 0 ? void 0 : _options_locale_options.firstWeekContainsDate) !== null && _ref1 !== void 0 ? _ref1 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions_locale = defaultOptions.locale) === null || _defaultOptions_locale === void 0 ? void 0 : (_defaultOptions_locale_options = _defaultOptions_locale.options) === null || _defaultOptions_locale_options === void 0 ? void 0 : _defaultOptions_locale_options.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : 1;
    var _options_weekStartsOn, _ref4, _ref5, _ref6;
    const weekStartsOn = (_ref6 = (_ref5 = (_ref4 = (_options_weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options_weekStartsOn !== void 0 ? _options_weekStartsOn : options === null || options === void 0 ? void 0 : (_options_locale1 = options.locale) === null || _options_locale1 === void 0 ? void 0 : (_options_locale_options1 = _options_locale1.options) === null || _options_locale_options1 === void 0 ? void 0 : _options_locale_options1.weekStartsOn) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : (_defaultOptions_locale1 = defaultOptions.locale) === null || _defaultOptions_locale1 === void 0 ? void 0 : (_defaultOptions_locale_options1 = _defaultOptions_locale1.options) === null || _defaultOptions_locale_options1 === void 0 ? void 0 : _defaultOptions_locale_options1.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(referenceDate, options === null || options === void 0 ? void 0 : options.in);
    const subFnOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, $35d314da2f2e1f0d$export$8be15fe85ad72f86)(options === null || options === void 0 ? void 0 : options.in, referenceDate)
    ];
    const tokens = formatStr.match($007c7f8b5e724128$var$longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, $5c87db339038f1b5$export$70cc8fd02856fd58)) {
            const longFormatter = (0, $5c87db339038f1b5$export$70cc8fd02856fd58)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($007c7f8b5e724128$var$formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalWeekYearTokens) && (0, $c71749bb64d8b2c7$export$c6b49d6dceb604a1)(token)) (0, $c71749bb64d8b2c7$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        if (!(options === null || options === void 0 ? void 0 : options.useAdditionalDayOfYearTokens) && (0, $c71749bb64d8b2c7$export$c6cc36aa33304772)(token)) (0, $c71749bb64d8b2c7$export$f5f38f90ecaaf879)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, $2c8121a1e5daaaef$export$19131010e7fd8373)[firstCharacter];
        if (parser) {
            const { incompatibleTokens: incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match($007c7f8b5e724128$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = $007c7f8b5e724128$var$cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && $007c7f8b5e724128$var$notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(referenceDate, options === null || options === void 0 ? void 0 : options.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function $007c7f8b5e724128$var$cleanEscapedString(input) {
    return input.match($007c7f8b5e724128$var$escapedStringRegExp)[1].replace($007c7f8b5e724128$var$doubleQuoteRegExp, "'");
}
var // Fallback for modularized imports:
$007c7f8b5e724128$export$2e2bcd8739ae039 = $007c7f8b5e724128$export$98e6a39c04603d36;




function $0de707870e87904f$export$4393d2ccbbedb219(argument, options) {
    const invalidDate = ()=>(0, $93cc854f09c80b6b$export$ead8a1812b171991)(options === null || options === void 0 ? void 0 : options.in, NaN);
    var _options_additionalDigits;
    const additionalDigits = (_options_additionalDigits = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options_additionalDigits !== void 0 ? _options_additionalDigits : 2;
    const dateStrings = $0de707870e87904f$var$splitDateString(argument);
    let date;
    if (dateStrings.date) {
        const parseYearResult = $0de707870e87904f$var$parseYear(dateStrings.date, additionalDigits);
        date = $0de707870e87904f$var$parseDate(parseYearResult.restDateString, parseYearResult.year);
    }
    if (!date || isNaN(+date)) return invalidDate();
    const timestamp = +date;
    let time = 0;
    let offset;
    if (dateStrings.time) {
        time = $0de707870e87904f$var$parseTime(dateStrings.time);
        if (isNaN(time)) return invalidDate();
    }
    if (dateStrings.timezone) {
        offset = $0de707870e87904f$var$parseTimezone(dateStrings.timezone);
        if (isNaN(offset)) return invalidDate();
    } else {
        const tmpDate = new Date(timestamp + time);
        const result = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(0, options === null || options === void 0 ? void 0 : options.in);
        result.setFullYear(tmpDate.getUTCFullYear(), tmpDate.getUTCMonth(), tmpDate.getUTCDate());
        result.setHours(tmpDate.getUTCHours(), tmpDate.getUTCMinutes(), tmpDate.getUTCSeconds(), tmpDate.getUTCMilliseconds());
        return result;
    }
    return (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(timestamp + time + offset, options === null || options === void 0 ? void 0 : options.in);
}
const $0de707870e87904f$var$patterns = {
    dateTimeDelimiter: /[T ]/,
    timeZoneDelimiter: /[Z ]/i,
    timezone: /([Z+-].*)$/
};
const $0de707870e87904f$var$dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
const $0de707870e87904f$var$timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
const $0de707870e87904f$var$timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $0de707870e87904f$var$splitDateString(dateString) {
    const dateStrings = {};
    const array = dateString.split($0de707870e87904f$var$patterns.dateTimeDelimiter);
    let timeString;
    // The regex match should only return at maximum two array elements.
    // [date], [time], or [date, time].
    if (array.length > 2) return dateStrings;
    if (/:/.test(array[0])) timeString = array[0];
    else {
        dateStrings.date = array[0];
        timeString = array[1];
        if ($0de707870e87904f$var$patterns.timeZoneDelimiter.test(dateStrings.date)) {
            dateStrings.date = dateString.split($0de707870e87904f$var$patterns.timeZoneDelimiter)[0];
            timeString = dateString.substr(dateStrings.date.length, dateString.length);
        }
    }
    if (timeString) {
        const token = $0de707870e87904f$var$patterns.timezone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], "");
            dateStrings.timezone = token[1];
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function $0de707870e87904f$var$parseYear(dateString, additionalDigits) {
    const regex = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + additionalDigits) + "})|(\\d{2}|[+-]\\d{" + (2 + additionalDigits) + "})$)");
    const captures = dateString.match(regex);
    // Invalid ISO-formatted year
    if (!captures) return {
        year: NaN,
        restDateString: ""
    };
    const year = captures[1] ? parseInt(captures[1]) : null;
    const century = captures[2] ? parseInt(captures[2]) : null;
    // either year or century is null, not both
    return {
        year: century === null ? year : century * 100,
        restDateString: dateString.slice((captures[1] || captures[2]).length)
    };
}
function $0de707870e87904f$var$parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return new Date(NaN);
    const captures = dateString.match($0de707870e87904f$var$dateRegex);
    // Invalid ISO-formatted string
    if (!captures) return new Date(NaN);
    const isWeekDate = !!captures[4];
    const dayOfYear = $0de707870e87904f$var$parseDateUnit(captures[1]);
    const month = $0de707870e87904f$var$parseDateUnit(captures[2]) - 1;
    const day = $0de707870e87904f$var$parseDateUnit(captures[3]);
    const week = $0de707870e87904f$var$parseDateUnit(captures[4]);
    const dayOfWeek = $0de707870e87904f$var$parseDateUnit(captures[5]) - 1;
    if (isWeekDate) {
        if (!$0de707870e87904f$var$validateWeekDate(year, week, dayOfWeek)) return new Date(NaN);
        return $0de707870e87904f$var$dayOfISOWeekYear(year, week, dayOfWeek);
    } else {
        const date = new Date(0);
        if (!$0de707870e87904f$var$validateDate(year, month, day) || !$0de707870e87904f$var$validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
        return date;
    }
}
function $0de707870e87904f$var$parseDateUnit(value) {
    return value ? parseInt(value) : 1;
}
function $0de707870e87904f$var$parseTime(timeString) {
    const captures = timeString.match($0de707870e87904f$var$timeRegex);
    if (!captures) return NaN; // Invalid ISO-formatted time
    const hours = $0de707870e87904f$var$parseTimeUnit(captures[1]);
    const minutes = $0de707870e87904f$var$parseTimeUnit(captures[2]);
    const seconds = $0de707870e87904f$var$parseTimeUnit(captures[3]);
    if (!$0de707870e87904f$var$validateTime(hours, minutes, seconds)) return NaN;
    return hours * (0, $8fcd7006f7e32aa4$export$7f72910d6dfd237a) + minutes * (0, $8fcd7006f7e32aa4$export$91246f0b9bd9beff) + seconds * 1000;
}
function $0de707870e87904f$var$parseTimeUnit(value) {
    return value && parseFloat(value.replace(",", ".")) || 0;
}
function $0de707870e87904f$var$parseTimezone(timezoneString) {
    if (timezoneString === "Z") return 0;
    const captures = timezoneString.match($0de707870e87904f$var$timezoneRegex);
    if (!captures) return 0;
    const sign = captures[1] === "+" ? -1 : 1;
    const hours = parseInt(captures[2]);
    const minutes = captures[3] && parseInt(captures[3]) || 0;
    if (!$0de707870e87904f$var$validateTimezone(hours, minutes)) return NaN;
    return sign * (hours * (0, $8fcd7006f7e32aa4$export$7f72910d6dfd237a) + minutes * (0, $8fcd7006f7e32aa4$export$91246f0b9bd9beff));
}
function $0de707870e87904f$var$dayOfISOWeekYear(isoWeekYear, week, day) {
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
// February is null to handle the leap year (using ||)
const $0de707870e87904f$var$daysInMonths = [
    31,
    null,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function $0de707870e87904f$var$isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function $0de707870e87904f$var$validateDate(year, month, date) {
    return month >= 0 && month <= 11 && date >= 1 && date <= ($0de707870e87904f$var$daysInMonths[month] || ($0de707870e87904f$var$isLeapYearIndex(year) ? 29 : 28));
}
function $0de707870e87904f$var$validateDayOfYearDate(year, dayOfYear) {
    return dayOfYear >= 1 && dayOfYear <= ($0de707870e87904f$var$isLeapYearIndex(year) ? 366 : 365);
}
function $0de707870e87904f$var$validateWeekDate(_year, week, day) {
    return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function $0de707870e87904f$var$validateTime(hours, minutes, seconds) {
    if (hours === 24) return minutes === 0 && seconds === 0;
    return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function $0de707870e87904f$var$validateTimezone(_hours, minutes) {
    return minutes >= 0 && minutes <= 59;
}
var // Fallback for modularized imports:
$0de707870e87904f$export$2e2bcd8739ae039 = $0de707870e87904f$export$4393d2ccbbedb219;


function $879723943f4caa59$export$f86b797a4659b781(date, hours, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setHours(hours);
    return _date;
}
var // Fallback for modularized imports:
$879723943f4caa59$export$2e2bcd8739ae039 = $879723943f4caa59$export$f86b797a4659b781;


function $dd3d355dc6207ba3$export$ad569bf1c79ea89d(date, minutes, options) {
    const date_ = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    date_.setMinutes(minutes);
    return date_;
}
var // Fallback for modularized imports:
$dd3d355dc6207ba3$export$2e2bcd8739ae039 = $dd3d355dc6207ba3$export$ad569bf1c79ea89d;




function $dd82b381be7c7cae$export$f645ddd439eb259d(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const monthIndex = _date.getMonth();
    const lastDayOfMonth = (0, $93cc854f09c80b6b$export$ead8a1812b171991)(_date, 0);
    lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
    lastDayOfMonth.setHours(0, 0, 0, 0);
    return lastDayOfMonth.getDate();
}
var // Fallback for modularized imports:
$dd82b381be7c7cae$export$2e2bcd8739ae039 = $dd82b381be7c7cae$export$f645ddd439eb259d;



function $a04ce585cc1453dc$export$63264690f8e36790(date, month, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const year = _date.getFullYear();
    const day = _date.getDate();
    const midMonth = (0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, 0);
    midMonth.setFullYear(year, month, 15);
    midMonth.setHours(0, 0, 0, 0);
    const daysInMonth = (0, $dd82b381be7c7cae$export$f645ddd439eb259d)(midMonth);
    // Set the earlier date, allows to wrap Jan 31 to Feb 28
    _date.setMonth(month, Math.min(day, daysInMonth));
    return _date;
}
var // Fallback for modularized imports:
$a04ce585cc1453dc$export$2e2bcd8739ae039 = $a04ce585cc1453dc$export$63264690f8e36790;



function $e9d24921719c0925$export$8924d1de7efe1755(date, quarter, options) {
    const date_ = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    const oldQuarter = Math.trunc(date_.getMonth() / 3) + 1;
    const diff = quarter - oldQuarter;
    return (0, $a04ce585cc1453dc$export$63264690f8e36790)(date_, date_.getMonth() + diff * 3);
}
var // Fallback for modularized imports:
$e9d24921719c0925$export$2e2bcd8739ae039 = $e9d24921719c0925$export$8924d1de7efe1755;


function $d9b52d32db130922$export$aec44746644cbf43(date, seconds, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setSeconds(seconds);
    return _date;
}
var // Fallback for modularized imports:
$d9b52d32db130922$export$2e2bcd8739ae039 = $d9b52d32db130922$export$aec44746644cbf43;



function $abb5c8cf41ac4337$export$a8408b6c5639cab7(date, year, options) {
    const date_ = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
    if (isNaN(+date_)) return (0, $93cc854f09c80b6b$export$ead8a1812b171991)((options === null || options === void 0 ? void 0 : options.in) || date, NaN);
    date_.setFullYear(year);
    return date_;
}
var // Fallback for modularized imports:
$abb5c8cf41ac4337$export$2e2bcd8739ae039 = $abb5c8cf41ac4337$export$a8408b6c5639cab7;


function $51ef0e18718a1681$export$a5a3b454ada2268e(date, options) {
    const _date = (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(date, options === null || options === void 0 ? void 0 : options.in);
    _date.setDate(1);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
var // Fallback for modularized imports:
$51ef0e18718a1681$export$2e2bcd8739ae039 = $51ef0e18718a1681$export$a5a3b454ada2268e;


function $b790179d217fe42b$export$70823084e2deb1ea(date, amount, options) {
    return (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(date, -amount, options);
}
var // Fallback for modularized imports:
$b790179d217fe42b$export$2e2bcd8739ae039 = $b790179d217fe42b$export$70823084e2deb1ea;


function $9ccdf5b091b4766d$export$73d1c15a21f9fae5(date, amount, options) {
    return (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(date, -amount, options);
}
var // Fallback for modularized imports:
$9ccdf5b091b4766d$export$2e2bcd8739ae039 = $9ccdf5b091b4766d$export$73d1c15a21f9fae5;


function $3b7a595f94262fab$export$a31bfeeeee80cce6(date, amount, options) {
    return (0, $4e9bcc6ff9d39f34$export$c252a41d0fbed2ce)(date, -amount, options);
}
var // Fallback for modularized imports:
$3b7a595f94262fab$export$2e2bcd8739ae039 = $3b7a595f94262fab$export$a31bfeeeee80cce6;


function $e5008eb0a28e1fd7$export$b4d8ae6376193efb(date, amount, options) {
    return (0, $65f6621a4d881172$export$ef501a2bb4f3ee6b)(date, -amount, options);
}
var // Fallback for modularized imports:
$e5008eb0a28e1fd7$export$2e2bcd8739ae039 = $e5008eb0a28e1fd7$export$b4d8ae6376193efb;


function $9e4f2bf0d6114176$export$14867687ff6c92e2(date, amount, options) {
    return (0, $b4358f02f9e27928$export$3d83eec43f4ea476)(date, -amount, options);
}
var // Fallback for modularized imports:
$9e4f2bf0d6114176$export$2e2bcd8739ae039 = $9e4f2bf0d6114176$export$14867687ff6c92e2;








function $75dbb8f78ee65245$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $8901fc92b5563702$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $75dbb8f78ee65245$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}


/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */ 
const $91f1cb25f4ca20c6$export$832b6fa47fa053d2 = [
    'top',
    'right',
    'bottom',
    'left'
];
const $91f1cb25f4ca20c6$export$27b07d8a310ed8b5 = [
    'start',
    'end'
];
const $91f1cb25f4ca20c6$export$803cd8101b6c182b = /*#__PURE__*/ $91f1cb25f4ca20c6$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $91f1cb25f4ca20c6$export$27b07d8a310ed8b5[0], side + "-" + $91f1cb25f4ca20c6$export$27b07d8a310ed8b5[1]), []);
const $91f1cb25f4ca20c6$export$96ec731ed4dcb222 = Math.min;
const $91f1cb25f4ca20c6$export$8960430cfd85939f = Math.max;
const $91f1cb25f4ca20c6$export$2077e0241d6afd3c = Math.round;
const $91f1cb25f4ca20c6$export$a3fe094919f356fd = Math.floor;
const $91f1cb25f4ca20c6$export$a397704b5e280835 = (v)=>({
        x: v,
        y: v
    });
const $91f1cb25f4ca20c6$var$oppositeSideMap = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $91f1cb25f4ca20c6$export$7d15b64cf5a3a4c4(start, value, end) {
    return $91f1cb25f4ca20c6$export$8960430cfd85939f(start, $91f1cb25f4ca20c6$export$96ec731ed4dcb222(value, end));
}
function $91f1cb25f4ca20c6$export$fef61f332f2c0afc(value, param) {
    return typeof value === 'function' ? value(param) : value;
}
function $91f1cb25f4ca20c6$export$3c915306cb7fc97a(placement) {
    return placement.split('-')[0];
}
function $91f1cb25f4ca20c6$export$f0989780f32bfcda(placement) {
    return placement.split('-')[1];
}
function $91f1cb25f4ca20c6$export$8a000a963141ac32(axis) {
    return axis === 'x' ? 'y' : 'x';
}
function $91f1cb25f4ca20c6$export$320bd9d53520c68a(axis) {
    return axis === 'y' ? 'height' : 'width';
}
function $91f1cb25f4ca20c6$export$f28e8f882010718a(placement) {
    const firstChar = placement[0];
    return firstChar === 't' || firstChar === 'b' ? 'y' : 'x';
}
function $91f1cb25f4ca20c6$export$2b57e0052a6d6d4c(placement) {
    return $91f1cb25f4ca20c6$export$8a000a963141ac32($91f1cb25f4ca20c6$export$f28e8f882010718a(placement));
}
function $91f1cb25f4ca20c6$export$be42861551f17911(placement, rects, rtl) {
    if (rtl === void 0) rtl = false;
    const alignment = $91f1cb25f4ca20c6$export$f0989780f32bfcda(placement);
    const alignmentAxis = $91f1cb25f4ca20c6$export$2b57e0052a6d6d4c(placement);
    const length = $91f1cb25f4ca20c6$export$320bd9d53520c68a(alignmentAxis);
    let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
    if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $91f1cb25f4ca20c6$export$9c5e28bad23365fa(mainAlignmentSide);
    return [
        mainAlignmentSide,
        $91f1cb25f4ca20c6$export$9c5e28bad23365fa(mainAlignmentSide)
    ];
}
function $91f1cb25f4ca20c6$export$496432a3699e50b1(placement) {
    const oppositePlacement = $91f1cb25f4ca20c6$export$9c5e28bad23365fa(placement);
    return [
        $91f1cb25f4ca20c6$export$2b182c584985588b(placement),
        oppositePlacement,
        $91f1cb25f4ca20c6$export$2b182c584985588b(oppositePlacement)
    ];
}
function $91f1cb25f4ca20c6$export$2b182c584985588b(placement) {
    return placement.includes('start') ? placement.replace('start', 'end') : placement.replace('end', 'start');
}
const $91f1cb25f4ca20c6$var$lrPlacement = [
    'left',
    'right'
];
const $91f1cb25f4ca20c6$var$rlPlacement = [
    'right',
    'left'
];
const $91f1cb25f4ca20c6$var$tbPlacement = [
    'top',
    'bottom'
];
const $91f1cb25f4ca20c6$var$btPlacement = [
    'bottom',
    'top'
];
function $91f1cb25f4ca20c6$var$getSideList(side, isStart, rtl) {
    switch(side){
        case 'top':
        case 'bottom':
            if (rtl) return isStart ? $91f1cb25f4ca20c6$var$rlPlacement : $91f1cb25f4ca20c6$var$lrPlacement;
            return isStart ? $91f1cb25f4ca20c6$var$lrPlacement : $91f1cb25f4ca20c6$var$rlPlacement;
        case 'left':
        case 'right':
            return isStart ? $91f1cb25f4ca20c6$var$tbPlacement : $91f1cb25f4ca20c6$var$btPlacement;
        default:
            return [];
    }
}
function $91f1cb25f4ca20c6$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
    const alignment = $91f1cb25f4ca20c6$export$f0989780f32bfcda(placement);
    let list = $91f1cb25f4ca20c6$var$getSideList($91f1cb25f4ca20c6$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
    if (alignment) {
        list = list.map((side)=>side + "-" + alignment);
        if (flipAlignment) list = list.concat(list.map($91f1cb25f4ca20c6$export$2b182c584985588b));
    }
    return list;
}
function $91f1cb25f4ca20c6$export$9c5e28bad23365fa(placement) {
    const side = $91f1cb25f4ca20c6$export$3c915306cb7fc97a(placement);
    return $91f1cb25f4ca20c6$var$oppositeSideMap[side] + placement.slice(side.length);
}
function $91f1cb25f4ca20c6$export$1c66dbf1a9e34223(padding) {
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, padding);
}
function $91f1cb25f4ca20c6$export$598c291c29bc2e71(padding) {
    return typeof padding !== 'number' ? $91f1cb25f4ca20c6$export$1c66dbf1a9e34223(padding) : {
        top: padding,
        right: padding,
        bottom: padding,
        left: padding
    };
}
function $91f1cb25f4ca20c6$export$ee05aea0aeecbad4(rect) {
    const { x: x, y: y, width: width, height: height } = rect;
    return {
        width: width,
        height: height,
        top: y,
        left: x,
        right: x + width,
        bottom: y + height,
        x: x,
        y: y
    };
}


function $fe4da4642c9ddd37$var$computeCoordsFromPlacement(_ref, placement, rtl) {
    let { reference: reference, floating: floating } = _ref;
    const sideAxis = (0, $91f1cb25f4ca20c6$export$f28e8f882010718a)(placement);
    const alignmentAxis = (0, $91f1cb25f4ca20c6$export$2b57e0052a6d6d4c)(placement);
    const alignLength = (0, $91f1cb25f4ca20c6$export$320bd9d53520c68a)(alignmentAxis);
    const side = (0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(placement);
    const isVertical = sideAxis === 'y';
    const commonX = reference.x + reference.width / 2 - floating.width / 2;
    const commonY = reference.y + reference.height / 2 - floating.height / 2;
    const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
    let coords;
    switch(side){
        case 'top':
            coords = {
                x: commonX,
                y: reference.y - floating.height
            };
            break;
        case 'bottom':
            coords = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 'right':
            coords = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 'left':
            coords = {
                x: reference.x - floating.width,
                y: commonY
            };
            break;
        default:
            coords = {
                x: reference.x,
                y: reference.y
            };
    }
    switch((0, $91f1cb25f4ca20c6$export$f0989780f32bfcda)(placement)){
        case 'start':
            coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
            break;
        case 'end':
            coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
            break;
    }
    return coords;
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ async function $fe4da4642c9ddd37$export$37b6bde19b108ecc(state, options) {
    var _await$platform$isEle;
    if (options === void 0) options = {};
    const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
    const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(options, state);
    const paddingObject = (0, $91f1cb25f4ca20c6$export$598c291c29bc2e71)(padding);
    const altContext = elementContext === 'floating' ? 'reference' : 'floating';
    const element = elements[altBoundary ? altContext : elementContext];
    const clippingClientRect = (0, $91f1cb25f4ca20c6$export$ee05aea0aeecbad4)(await platform.getClippingRect({
        element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
        boundary: boundary,
        rootBoundary: rootBoundary,
        strategy: strategy
    }));
    const rect = elementContext === 'floating' ? {
        x: x,
        y: y,
        width: rects.floating.width,
        height: rects.floating.height
    } : rects.reference;
    const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
    const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
        x: 1,
        y: 1
    } : {
        x: 1,
        y: 1
    };
    const elementClientRect = (0, $91f1cb25f4ca20c6$export$ee05aea0aeecbad4)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
        elements: elements,
        rect: rect,
        offsetParent: offsetParent,
        strategy: strategy
    }) : rect);
    return {
        top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
        bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
        left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
        right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
    };
}
// Maximum number of resets that can occur before bailing to avoid infinite reset loops.
const $fe4da4642c9ddd37$var$MAX_RESET_COUNT = 50;
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */ const $fe4da4642c9ddd37$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
    const platformWithDetectOverflow = platform.detectOverflow ? platform : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, platform), {
        detectOverflow: $fe4da4642c9ddd37$export$37b6bde19b108ecc
    });
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
    let rects = await platform.getElementRects({
        reference: reference,
        floating: floating,
        strategy: strategy
    });
    let { x: x, y: y } = $fe4da4642c9ddd37$var$computeCoordsFromPlacement(rects, placement, rtl);
    let statefulPlacement = placement;
    let resetCount = 0;
    const middlewareData = {};
    for(let i = 0; i < middleware.length; i++){
        const currentMiddleware = middleware[i];
        if (!currentMiddleware) continue;
        const { name: name, fn: fn } = currentMiddleware;
        const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
            x: x,
            y: y,
            initialPlacement: placement,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData,
            rects: rects,
            platform: platformWithDetectOverflow,
            elements: {
                reference: reference,
                floating: floating
            }
        });
        x = nextX != null ? nextX : x;
        y = nextY != null ? nextY : y;
        middlewareData[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, middlewareData[name], data);
        if (reset && resetCount < $fe4da4642c9ddd37$var$MAX_RESET_COUNT) {
            resetCount++;
            if (typeof reset === 'object') {
                if (reset.placement) statefulPlacement = reset.placement;
                if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                    reference: reference,
                    floating: floating,
                    strategy: strategy
                }) : reset.rects;
                ({ x: x, y: y } = $fe4da4642c9ddd37$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
            }
            i = -1;
        }
    }
    return {
        x: x,
        y: y,
        placement: statefulPlacement,
        strategy: strategy,
        middlewareData: middlewareData
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $fe4da4642c9ddd37$export$f2120bbfa5450bd2 = (options)=>({
        name: 'arrow',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
            // Since `element` is required, we don't Partial<> the type.
            const { element: element, padding: padding = 0 } = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(options, state) || {};
            if (element == null) return {};
            const paddingObject = (0, $91f1cb25f4ca20c6$export$598c291c29bc2e71)(padding);
            const coords = {
                x: x,
                y: y
            };
            const axis = (0, $91f1cb25f4ca20c6$export$2b57e0052a6d6d4c)(placement);
            const length = (0, $91f1cb25f4ca20c6$export$320bd9d53520c68a)(axis);
            const arrowDimensions = await platform.getDimensions(element);
            const isYAxis = axis === 'y';
            const minProp = isYAxis ? 'top' : 'left';
            const maxProp = isYAxis ? 'bottom' : 'right';
            const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
            const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
            const startDiff = coords[axis] - rects.reference[axis];
            const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
            let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
            // DOM platform can return `window` as the `offsetParent`.
            if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
            const centerToReference = endDiff / 2 - startDiff / 2;
            // If the padding is large enough that it causes the arrow to no longer be
            // centered, modify the padding so that it is centered.
            const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
            const minPadding = (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(paddingObject[minProp], largestPossiblePadding);
            const maxPadding = (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(paddingObject[maxProp], largestPossiblePadding);
            // Make sure the arrow doesn't overflow the floating element if the center
            // point is outside the floating element's bounds.
            const min$1 = minPadding;
            const max = clientSize - arrowDimensions[length] - maxPadding;
            const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
            const offset = (0, $91f1cb25f4ca20c6$export$7d15b64cf5a3a4c4)(min$1, center, max);
            // If the reference is small enough that the arrow's padding causes it to
            // to point to nothing for an aligned placement, adjust the offset of the
            // floating element itself. To ensure `shift()` continues to take action,
            // a single reset is performed when this is true.
            const shouldAddOffset = !middlewareData.arrow && (0, $91f1cb25f4ca20c6$export$f0989780f32bfcda)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
            const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
            return {
                [axis]: coords[axis] + alignmentOffset,
                data: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    [axis]: offset,
                    centerOffset: center - offset - alignmentOffset
                }, shouldAddOffset && {
                    alignmentOffset: alignmentOffset
                }),
                reset: shouldAddOffset
            };
        }
    });
function $fe4da4642c9ddd37$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
    const allowedPlacementsSortedByAlignment = alignment ? [
        ...allowedPlacements.filter((placement)=>(0, $91f1cb25f4ca20c6$export$f0989780f32bfcda)(placement) === alignment),
        ...allowedPlacements.filter((placement)=>(0, $91f1cb25f4ca20c6$export$f0989780f32bfcda)(placement) !== alignment)
    ] : allowedPlacements.filter((placement)=>(0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(placement) === placement);
    return allowedPlacementsSortedByAlignment.filter((placement)=>{
        if (alignment) return (0, $91f1cb25f4ca20c6$export$f0989780f32bfcda)(placement) === alignment || (autoAlignment ? (0, $91f1cb25f4ca20c6$export$2b182c584985588b)(placement) !== placement : false);
        return true;
    });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $fe4da4642c9ddd37$export$91fb6ecbd551914 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'autoPlacement',
        options: options,
        async fn (state) {
            var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
            const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(options, state), { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, $91f1cb25f4ca20c6$export$803cd8101b6c182b), autoAlignment: autoAlignment = true } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "crossAxis",
                "alignment",
                "allowedPlacements",
                "autoAlignment"
            ]);
            const placements$1 = alignment !== undefined || allowedPlacements === (0, $91f1cb25f4ca20c6$export$803cd8101b6c182b) ? $fe4da4642c9ddd37$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
            const currentPlacement = placements$1[currentIndex];
            if (currentPlacement == null) return {};
            const alignmentSides = (0, $91f1cb25f4ca20c6$export$be42861551f17911)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
            // Make `computeCoords` start from the right place.
            if (placement !== currentPlacement) return {
                reset: {
                    placement: placements$1[0]
                }
            };
            const currentOverflows = [
                overflow[(0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(currentPlacement)],
                overflow[alignmentSides[0]],
                overflow[alignmentSides[1]]
            ];
            const allOverflows = [
                ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                {
                    placement: currentPlacement,
                    overflows: currentOverflows
                }
            ];
            const nextPlacement = placements$1[currentIndex + 1];
            // There are more placements to check.
            if (nextPlacement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: nextPlacement
                }
            };
            const placementsSortedByMostSpace = allOverflows.map((d)=>{
                const alignment = (0, $91f1cb25f4ca20c6$export$f0989780f32bfcda)(d.placement);
                return [
                    d.placement,
                    alignment && crossAxis ? // Check along the mainAxis and main crossAxis side.
                    d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : // Check only the mainAxis.
                    d.overflows[0],
                    d.overflows
                ];
            }).sort((a, b)=>a[1] - b[1]);
            const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, // Aligned placements should not check their opposite crossAxis
                // side.
                (0, $91f1cb25f4ca20c6$export$f0989780f32bfcda)(d[0]) ? 2 : 3).every((v)=>v <= 0));
            const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
            if (resetPlacement !== placement) return {
                data: {
                    index: currentIndex + 1,
                    overflows: allOverflows
                },
                reset: {
                    placement: resetPlacement
                }
            };
            return {};
        }
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $fe4da4642c9ddd37$export$8a83211c878a3f1f = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'flip',
        options: options,
        async fn (state) {
            var _middlewareData$arrow, _middlewareData$flip;
            const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
            const _evaluate = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "fallbackPlacements",
                "fallbackStrategy",
                "fallbackAxisSideDirection",
                "flipAlignment"
            ]);
            // If a reset by the arrow was caused due to an alignment offset being
            // added, we should skip any logic now since `flip()` has already done its
            // work.
            // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
            if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            const side = (0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(placement);
            const initialSideAxis = (0, $91f1cb25f4ca20c6$export$f28e8f882010718a)(initialPlacement);
            const isBasePlacement = (0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(initialPlacement) === initialPlacement;
            const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
            const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                (0, $91f1cb25f4ca20c6$export$9c5e28bad23365fa)(initialPlacement)
            ] : (0, $91f1cb25f4ca20c6$export$496432a3699e50b1)(initialPlacement));
            const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
            if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, $91f1cb25f4ca20c6$export$a9b6fb18fd92c3ec)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
            const placements = [
                initialPlacement,
                ...fallbackPlacements
            ];
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const overflows = [];
            let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
            if (checkMainAxis) overflows.push(overflow[side]);
            if (checkCrossAxis) {
                const sides = (0, $91f1cb25f4ca20c6$export$be42861551f17911)(placement, rects, rtl);
                overflows.push(overflow[sides[0]], overflow[sides[1]]);
            }
            overflowsData = [
                ...overflowsData,
                {
                    placement: placement,
                    overflows: overflows
                }
            ];
            // One or more sides is overflowing.
            if (!overflows.every((side)=>side <= 0)) {
                var _middlewareData$flip2, _overflowsData$filter;
                const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                const nextPlacement = placements[nextIndex];
                if (nextPlacement) {
                    const ignoreCrossAxisOverflow = checkCrossAxis === 'alignment' ? initialSideAxis !== (0, $91f1cb25f4ca20c6$export$f28e8f882010718a)(nextPlacement) : false;
                    if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
                    // overflows the main axis.
                    overflowsData.every((d)=>(0, $91f1cb25f4ca20c6$export$f28e8f882010718a)(d.placement) === initialSideAxis ? d.overflows[0] > 0 : true)) // Try next placement and re-run the lifecycle.
                    return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                }
                // First, find the candidates that fit on the mainAxis side of overflow,
                // then find the placement that fits the best on the main crossAxis side.
                let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                // Otherwise fallback.
                if (!resetPlacement) switch(fallbackStrategy){
                    case 'bestFit':
                        {
                            var _overflowsData$filter2;
                            const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                if (hasFallbackAxisSideDirection) {
                                    const currentSideAxis = (0, $91f1cb25f4ca20c6$export$f28e8f882010718a)(d.placement);
                                    return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                                    // reading directions favoring greater width.
                                    currentSideAxis === 'y';
                                }
                                return true;
                            }).map((d)=>[
                                    d.placement,
                                    d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                            if (placement) resetPlacement = placement;
                            break;
                        }
                    case 'initialPlacement':
                        resetPlacement = initialPlacement;
                        break;
                }
                if (placement !== resetPlacement) return {
                    reset: {
                        placement: resetPlacement
                    }
                };
            }
            return {};
        }
    };
};
function $fe4da4642c9ddd37$var$getSideOffsets(overflow, rect) {
    return {
        top: overflow.top - rect.height,
        right: overflow.right - rect.width,
        bottom: overflow.bottom - rect.height,
        left: overflow.left - rect.width
    };
}
function $fe4da4642c9ddd37$var$isAnySideFullyClipped(overflow) {
    return (0, $91f1cb25f4ca20c6$export$832b6fa47fa053d2).some((side)=>overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $fe4da4642c9ddd37$export$fe8985bb6374093c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'hide',
        options: options,
        async fn (state) {
            const { rects: rects, platform: platform } = state;
            const _evaluate = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(options, state), { strategy: strategy = 'referenceHidden' } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "strategy"
            ]);
            switch(strategy){
                case 'referenceHidden':
                    {
                        const overflow = await platform.detectOverflow(state, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, detectOverflowOptions), {
                            elementContext: 'reference'
                        }));
                        const offsets = $fe4da4642c9ddd37$var$getSideOffsets(overflow, rects.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: offsets,
                                referenceHidden: $fe4da4642c9ddd37$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                case 'escaped':
                    {
                        const overflow = await platform.detectOverflow(state, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, detectOverflowOptions), {
                            altBoundary: true
                        }));
                        const offsets = $fe4da4642c9ddd37$var$getSideOffsets(overflow, rects.floating);
                        return {
                            data: {
                                escapedOffsets: offsets,
                                escaped: $fe4da4642c9ddd37$var$isAnySideFullyClipped(offsets)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $fe4da4642c9ddd37$var$getBoundingRect(rects) {
    const minX = (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.left));
    const minY = (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(...rects.map((rect)=>rect.top));
    const maxX = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(...rects.map((rect)=>rect.right));
    const maxY = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(...rects.map((rect)=>rect.bottom));
    return {
        x: minX,
        y: minY,
        width: maxX - minX,
        height: maxY - minY
    };
}
function $fe4da4642c9ddd37$var$getRectsByLine(rects) {
    const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
    const groups = [];
    let prevRect = null;
    for(let i = 0; i < sortedRects.length; i++){
        const rect = sortedRects[i];
        if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
            rect
        ]);
        else groups[groups.length - 1].push(rect);
        prevRect = rect;
    }
    return groups.map((rect)=>(0, $91f1cb25f4ca20c6$export$ee05aea0aeecbad4)($fe4da4642c9ddd37$var$getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $fe4da4642c9ddd37$export$18c8ad048e32c7d5 = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'inline',
        options: options,
        async fn (state) {
            const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
            // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
            // ClientRect's bounds, despite the event listener being triggered. A
            // padding of 2 seems to handle this issue.
            const { padding: padding = 2, x: x, y: y } = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(options, state);
            const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
            const clientRects = $fe4da4642c9ddd37$var$getRectsByLine(nativeClientRects);
            const fallback = (0, $91f1cb25f4ca20c6$export$ee05aea0aeecbad4)($fe4da4642c9ddd37$var$getBoundingRect(nativeClientRects));
            const paddingObject = (0, $91f1cb25f4ca20c6$export$598c291c29bc2e71)(padding);
            function getBoundingClientRect() {
                // There are two rects and they are disjoined.
                if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) // Find the first rect in which the point is fully inside.
                return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                // There are 2 or more connected rects.
                if (clientRects.length >= 2) {
                    if ((0, $91f1cb25f4ca20c6$export$f28e8f882010718a)(placement) === 'y') {
                        const firstRect = clientRects[0];
                        const lastRect = clientRects[clientRects.length - 1];
                        const isTop = (0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(placement) === 'top';
                        const top = firstRect.top;
                        const bottom = lastRect.bottom;
                        const left = isTop ? firstRect.left : lastRect.left;
                        const right = isTop ? firstRect.right : lastRect.right;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    const isLeftSide = (0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(placement) === 'left';
                    const maxRight = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(...clientRects.map((rect)=>rect.right));
                    const minLeft = (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(...clientRects.map((rect)=>rect.left));
                    const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                    const top = measureRects[0].top;
                    const bottom = measureRects[measureRects.length - 1].bottom;
                    const left = minLeft;
                    const right = maxRight;
                    const width = right - left;
                    const height = bottom - top;
                    return {
                        top: top,
                        bottom: bottom,
                        left: left,
                        right: right,
                        width: width,
                        height: height,
                        x: left,
                        y: top
                    };
                }
                return fallback;
            }
            const resetRects = await platform.getElementRects({
                reference: {
                    getBoundingClientRect: getBoundingClientRect
                },
                floating: elements.floating,
                strategy: strategy
            });
            if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                reset: {
                    rects: resetRects
                }
            };
            return {};
        }
    };
};
const $fe4da4642c9ddd37$var$originSides = /*#__PURE__*/ new Set([
    'left',
    'top'
]);
// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.
async function $fe4da4642c9ddd37$var$convertValueToCoords(state, options) {
    const { placement: placement, platform: platform, elements: elements } = state;
    const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
    const side = (0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(placement);
    const alignment = (0, $91f1cb25f4ca20c6$export$f0989780f32bfcda)(placement);
    const isVertical = (0, $91f1cb25f4ca20c6$export$f28e8f882010718a)(placement) === 'y';
    const mainAxisMulti = $fe4da4642c9ddd37$var$originSides.has(side) ? -1 : 1;
    const crossAxisMulti = rtl && isVertical ? -1 : 1;
    const rawValue = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(options, state);
    // eslint-disable-next-line prefer-const
    let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
        mainAxis: rawValue,
        crossAxis: 0,
        alignmentAxis: null
    } : {
        mainAxis: rawValue.mainAxis || 0,
        crossAxis: rawValue.crossAxis || 0,
        alignmentAxis: rawValue.alignmentAxis
    };
    if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
    return isVertical ? {
        x: crossAxis * crossAxisMulti,
        y: mainAxis * mainAxisMulti
    } : {
        x: mainAxis * mainAxisMulti,
        y: crossAxis * crossAxisMulti
    };
}
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $fe4da4642c9ddd37$export$cc800923e997bb8 = function(options) {
    if (options === void 0) options = 0;
    return {
        name: 'offset',
        options: options,
        async fn (state) {
            var _middlewareData$offse, _middlewareData$arrow;
            const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
            const diffCoords = await $fe4da4642c9ddd37$var$convertValueToCoords(state, options);
            // If the placement is the same and the arrow caused an alignment offset
            // then we don't need to change the positioning coordinates.
            if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
            return {
                x: x + diffCoords.x,
                y: y + diffCoords.y,
                data: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, diffCoords), {
                    placement: placement
                })
            };
        }
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $fe4da4642c9ddd37$export$fba63a578e423eb = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'shift',
        options: options,
        async fn (state) {
            const { x: x, y: y, placement: placement, platform: platform } = state;
            const _evaluate = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(options, state), { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                fn: (_ref)=>{
                    let { x: x, y: y } = _ref;
                    return {
                        x: x,
                        y: y
                    };
                }
            } } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "mainAxis",
                "crossAxis",
                "limiter"
            ]);
            const coords = {
                x: x,
                y: y
            };
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const crossAxis = (0, $91f1cb25f4ca20c6$export$f28e8f882010718a)((0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(placement));
            const mainAxis = (0, $91f1cb25f4ca20c6$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            if (checkMainAxis) {
                const minSide = mainAxis === 'y' ? 'top' : 'left';
                const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                const min = mainAxisCoord + overflow[minSide];
                const max = mainAxisCoord - overflow[maxSide];
                mainAxisCoord = (0, $91f1cb25f4ca20c6$export$7d15b64cf5a3a4c4)(min, mainAxisCoord, max);
            }
            if (checkCrossAxis) {
                const minSide = crossAxis === 'y' ? 'top' : 'left';
                const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                const min = crossAxisCoord + overflow[minSide];
                const max = crossAxisCoord - overflow[maxSide];
                crossAxisCoord = (0, $91f1cb25f4ca20c6$export$7d15b64cf5a3a4c4)(min, crossAxisCoord, max);
            }
            const limitedCoords = limiter.fn((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            }));
            return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, limitedCoords), {
                data: {
                    x: limitedCoords.x - x,
                    y: limitedCoords.y - y,
                    enabled: {
                        [mainAxis]: checkMainAxis,
                        [crossAxis]: checkCrossAxis
                    }
                }
            });
        }
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $fe4da4642c9ddd37$export$7bf07e38f3dc4b69 = function(options) {
    if (options === void 0) options = {};
    return {
        options: options,
        fn (state) {
            const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
            const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(options, state);
            const coords = {
                x: x,
                y: y
            };
            const crossAxis = (0, $91f1cb25f4ca20c6$export$f28e8f882010718a)(placement);
            const mainAxis = (0, $91f1cb25f4ca20c6$export$8a000a963141ac32)(crossAxis);
            let mainAxisCoord = coords[mainAxis];
            let crossAxisCoord = coords[crossAxis];
            const rawOffset = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(offset, state);
            const computedOffset = typeof rawOffset === 'number' ? {
                mainAxis: rawOffset,
                crossAxis: 0
            } : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                mainAxis: 0,
                crossAxis: 0
            }, rawOffset);
            if (checkMainAxis) {
                const len = mainAxis === 'y' ? 'height' : 'width';
                const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
            }
            if (checkCrossAxis) {
                var _middlewareData$offse, _middlewareData$offse2;
                const len = mainAxis === 'y' ? 'width' : 'height';
                const isOriginSide = $fe4da4642c9ddd37$var$originSides.has((0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(placement));
                const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
            }
            return {
                [mainAxis]: mainAxisCoord,
                [crossAxis]: crossAxisCoord
            };
        }
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $fe4da4642c9ddd37$export$346677f925de839c = function(options) {
    if (options === void 0) options = {};
    return {
        name: 'size',
        options: options,
        async fn (state) {
            var _state$middlewareData, _state$middlewareData2;
            const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
            const _evaluate = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(options, state), { apply: apply = ()=>{} } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "apply"
            ]);
            const overflow = await platform.detectOverflow(state, detectOverflowOptions);
            const side = (0, $91f1cb25f4ca20c6$export$3c915306cb7fc97a)(placement);
            const alignment = (0, $91f1cb25f4ca20c6$export$f0989780f32bfcda)(placement);
            const isYAxis = (0, $91f1cb25f4ca20c6$export$f28e8f882010718a)(placement) === 'y';
            const { width: width, height: height } = rects.floating;
            let heightSide;
            let widthSide;
            if (side === 'top' || side === 'bottom') {
                heightSide = side;
                widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
            } else {
                widthSide = side;
                heightSide = alignment === 'end' ? 'top' : 'bottom';
            }
            const maximumClippingHeight = height - overflow.top - overflow.bottom;
            const maximumClippingWidth = width - overflow.left - overflow.right;
            const overflowAvailableHeight = (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(height - overflow[heightSide], maximumClippingHeight);
            const overflowAvailableWidth = (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(width - overflow[widthSide], maximumClippingWidth);
            const noShift = !state.middlewareData.shift;
            let availableHeight = overflowAvailableHeight;
            let availableWidth = overflowAvailableWidth;
            if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
            if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
            if (noShift && !alignment) {
                const xMin = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(overflow.left, 0);
                const xMax = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(overflow.right, 0);
                const yMin = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(overflow.top, 0);
                const yMax = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(overflow.bottom, 0);
                if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(overflow.left, overflow.right));
                else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(overflow.top, overflow.bottom));
            }
            await apply((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                availableWidth: availableWidth,
                availableHeight: availableHeight
            }));
            const nextDimensions = await platform.getDimensions(elements.floating);
            if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                reset: {
                    rects: true
                }
            };
            return {};
        }
    };
};



function $d2553f707975908a$var$hasWindow() {
    return typeof window !== 'undefined';
}
function $d2553f707975908a$export$651544f548703224(node) {
    if ($d2553f707975908a$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
    // Mocked nodes in testing environments may not be instances of Node. By
    // returning `#document` an infinite loop won't occur.
    // https://github.com/floating-ui/floating-ui/issues/2317
    return '#document';
}
function $d2553f707975908a$export$38b2d434cce3ea22(node) {
    var _node$ownerDocument;
    return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function $d2553f707975908a$export$e495491855dc5418(node) {
    var _ref;
    return (_ref = ($d2553f707975908a$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function $d2553f707975908a$export$8ee0fc9ee280b4ee(value) {
    if (!$d2553f707975908a$var$hasWindow()) return false;
    return value instanceof Node || value instanceof $d2553f707975908a$export$38b2d434cce3ea22(value).Node;
}
function $d2553f707975908a$export$45a5e7f76e0caa8d(value) {
    if (!$d2553f707975908a$var$hasWindow()) return false;
    return value instanceof Element || value instanceof $d2553f707975908a$export$38b2d434cce3ea22(value).Element;
}
function $d2553f707975908a$export$1b3bfaa9684536aa(value) {
    if (!$d2553f707975908a$var$hasWindow()) return false;
    return value instanceof HTMLElement || value instanceof $d2553f707975908a$export$38b2d434cce3ea22(value).HTMLElement;
}
function $d2553f707975908a$export$af51f0f06c0f328a(value) {
    if (!$d2553f707975908a$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
    return value instanceof ShadowRoot || value instanceof $d2553f707975908a$export$38b2d434cce3ea22(value).ShadowRoot;
}
function $d2553f707975908a$export$989e911fa9af580a(element) {
    const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $d2553f707975908a$export$3735103072e4a80(element);
    return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && display !== 'inline' && display !== 'contents';
}
function $d2553f707975908a$export$71535ffaa902797f(element) {
    return /^(table|td|th)$/.test($d2553f707975908a$export$651544f548703224(element));
}
function $d2553f707975908a$export$89e651af02346cd4(element) {
    try {
        if (element.matches(':popover-open')) return true;
    } catch (_e) {
    // no-op
    }
    try {
        return element.matches(':modal');
    } catch (_e) {
        return false;
    }
}
const $d2553f707975908a$var$willChangeRe = /transform|translate|scale|rotate|perspective|filter/;
const $d2553f707975908a$var$containRe = /paint|layout|strict|content/;
const $d2553f707975908a$var$isNotNone = (value)=>!!value && value !== 'none';
let $d2553f707975908a$var$isWebKitValue;
function $d2553f707975908a$export$d6c4e8150c35fed1(elementOrCss) {
    const css = $d2553f707975908a$export$45a5e7f76e0caa8d(elementOrCss) ? $d2553f707975908a$export$3735103072e4a80(elementOrCss) : elementOrCss;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    // https://drafts.csswg.org/css-transforms-2/#individual-transforms
    return $d2553f707975908a$var$isNotNone(css.transform) || $d2553f707975908a$var$isNotNone(css.translate) || $d2553f707975908a$var$isNotNone(css.scale) || $d2553f707975908a$var$isNotNone(css.rotate) || $d2553f707975908a$var$isNotNone(css.perspective) || !$d2553f707975908a$export$78551043582a6a98() && ($d2553f707975908a$var$isNotNone(css.backdropFilter) || $d2553f707975908a$var$isNotNone(css.filter)) || $d2553f707975908a$var$willChangeRe.test(css.willChange || '') || $d2553f707975908a$var$containRe.test(css.contain || '');
}
function $d2553f707975908a$export$940d8225183e1404(element) {
    let currentNode = $d2553f707975908a$export$4e12058fc4d51d56(element);
    while($d2553f707975908a$export$1b3bfaa9684536aa(currentNode) && !$d2553f707975908a$export$d1162fb0b6d4cd51(currentNode)){
        if ($d2553f707975908a$export$d6c4e8150c35fed1(currentNode)) return currentNode;
        else if ($d2553f707975908a$export$89e651af02346cd4(currentNode)) return null;
        currentNode = $d2553f707975908a$export$4e12058fc4d51d56(currentNode);
    }
    return null;
}
function $d2553f707975908a$export$78551043582a6a98() {
    if ($d2553f707975908a$var$isWebKitValue == null) $d2553f707975908a$var$isWebKitValue = typeof CSS !== 'undefined' && CSS.supports && CSS.supports('-webkit-backdrop-filter', 'none');
    return $d2553f707975908a$var$isWebKitValue;
}
function $d2553f707975908a$export$d1162fb0b6d4cd51(node) {
    return /^(html|body|#document)$/.test($d2553f707975908a$export$651544f548703224(node));
}
function $d2553f707975908a$export$3735103072e4a80(element) {
    return $d2553f707975908a$export$38b2d434cce3ea22(element).getComputedStyle(element);
}
function $d2553f707975908a$export$dc8fc79fa2800137(element) {
    if ($d2553f707975908a$export$45a5e7f76e0caa8d(element)) return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
    return {
        scrollLeft: element.scrollX,
        scrollTop: element.scrollY
    };
}
function $d2553f707975908a$export$4e12058fc4d51d56(node) {
    if ($d2553f707975908a$export$651544f548703224(node) === 'html') return node;
    const result = // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    $d2553f707975908a$export$af51f0f06c0f328a(node) && node.host || // Fallback.
    $d2553f707975908a$export$e495491855dc5418(node);
    return $d2553f707975908a$export$af51f0f06c0f328a(result) ? result.host : result;
}
function $d2553f707975908a$export$7cd01a57c8ca906c(node) {
    const parentNode = $d2553f707975908a$export$4e12058fc4d51d56(node);
    if ($d2553f707975908a$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
    if ($d2553f707975908a$export$1b3bfaa9684536aa(parentNode) && $d2553f707975908a$export$989e911fa9af580a(parentNode)) return parentNode;
    return $d2553f707975908a$export$7cd01a57c8ca906c(parentNode);
}
function $d2553f707975908a$export$3b57c1601291186b(node, list, traverseIframes) {
    var _node$ownerDocument2;
    if (list === void 0) list = [];
    if (traverseIframes === void 0) traverseIframes = true;
    const scrollableAncestor = $d2553f707975908a$export$7cd01a57c8ca906c(node);
    const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
    const win = $d2553f707975908a$export$38b2d434cce3ea22(scrollableAncestor);
    if (isBody) {
        const frameElement = $d2553f707975908a$export$7bf1f8740e3e34af(win);
        return list.concat(win, win.visualViewport || [], $d2553f707975908a$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $d2553f707975908a$export$3b57c1601291186b(frameElement) : []);
    } else return list.concat(scrollableAncestor, $d2553f707975908a$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
}
function $d2553f707975908a$export$7bf1f8740e3e34af(win) {
    return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}


function $b62109a283c86f13$var$getCssDimensions(element) {
    const css = (0, $d2553f707975908a$export$3735103072e4a80)(element);
    // In testing environments, the `width` and `height` properties are empty
    // strings for SVG elements, returning NaN. Fallback to `0` in this case.
    let width = parseFloat(css.width) || 0;
    let height = parseFloat(css.height) || 0;
    const hasOffset = (0, $d2553f707975908a$export$1b3bfaa9684536aa)(element);
    const offsetWidth = hasOffset ? element.offsetWidth : width;
    const offsetHeight = hasOffset ? element.offsetHeight : height;
    const shouldFallback = (0, $91f1cb25f4ca20c6$export$2077e0241d6afd3c)(width) !== offsetWidth || (0, $91f1cb25f4ca20c6$export$2077e0241d6afd3c)(height) !== offsetHeight;
    if (shouldFallback) {
        width = offsetWidth;
        height = offsetHeight;
    }
    return {
        width: width,
        height: height,
        $: shouldFallback
    };
}
function $b62109a283c86f13$var$unwrapElement(element) {
    return !(0, $d2553f707975908a$export$45a5e7f76e0caa8d)(element) ? element.contextElement : element;
}
function $b62109a283c86f13$var$getScale(element) {
    const domElement = $b62109a283c86f13$var$unwrapElement(element);
    if (!(0, $d2553f707975908a$export$1b3bfaa9684536aa)(domElement)) return (0, $91f1cb25f4ca20c6$export$a397704b5e280835)(1);
    const rect = domElement.getBoundingClientRect();
    const { width: width, height: height, $: $ } = $b62109a283c86f13$var$getCssDimensions(domElement);
    let x = ($ ? (0, $91f1cb25f4ca20c6$export$2077e0241d6afd3c)(rect.width) : rect.width) / width;
    let y = ($ ? (0, $91f1cb25f4ca20c6$export$2077e0241d6afd3c)(rect.height) : rect.height) / height;
    // 0, NaN, or Infinity should always fallback to 1.
    if (!x || !Number.isFinite(x)) x = 1;
    if (!y || !Number.isFinite(y)) y = 1;
    return {
        x: x,
        y: y
    };
}
const $b62109a283c86f13$var$noOffsets = /*#__PURE__*/ (0, $91f1cb25f4ca20c6$export$a397704b5e280835)(0);
function $b62109a283c86f13$var$getVisualOffsets(element) {
    const win = (0, $d2553f707975908a$export$38b2d434cce3ea22)(element);
    if (!(0, $d2553f707975908a$export$78551043582a6a98)() || !win.visualViewport) return $b62109a283c86f13$var$noOffsets;
    return {
        x: win.visualViewport.offsetLeft,
        y: win.visualViewport.offsetTop
    };
}
function $b62109a283c86f13$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
    if (isFixed === void 0) isFixed = false;
    if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, $d2553f707975908a$export$38b2d434cce3ea22)(element)) return false;
    return isFixed;
}
function $b62109a283c86f13$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    const clientRect = element.getBoundingClientRect();
    const domElement = $b62109a283c86f13$var$unwrapElement(element);
    let scale = (0, $91f1cb25f4ca20c6$export$a397704b5e280835)(1);
    if (includeScale) {
        if (offsetParent) {
            if ((0, $d2553f707975908a$export$45a5e7f76e0caa8d)(offsetParent)) scale = $b62109a283c86f13$var$getScale(offsetParent);
        } else scale = $b62109a283c86f13$var$getScale(element);
    }
    const visualOffsets = $b62109a283c86f13$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $b62109a283c86f13$var$getVisualOffsets(domElement) : (0, $91f1cb25f4ca20c6$export$a397704b5e280835)(0);
    let x = (clientRect.left + visualOffsets.x) / scale.x;
    let y = (clientRect.top + visualOffsets.y) / scale.y;
    let width = clientRect.width / scale.x;
    let height = clientRect.height / scale.y;
    if (domElement) {
        const win = (0, $d2553f707975908a$export$38b2d434cce3ea22)(domElement);
        const offsetWin = offsetParent && (0, $d2553f707975908a$export$45a5e7f76e0caa8d)(offsetParent) ? (0, $d2553f707975908a$export$38b2d434cce3ea22)(offsetParent) : offsetParent;
        let currentWin = win;
        let currentIFrame = (0, $d2553f707975908a$export$7bf1f8740e3e34af)(currentWin);
        while(currentIFrame && offsetParent && offsetWin !== currentWin){
            const iframeScale = $b62109a283c86f13$var$getScale(currentIFrame);
            const iframeRect = currentIFrame.getBoundingClientRect();
            const css = (0, $d2553f707975908a$export$3735103072e4a80)(currentIFrame);
            const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
            const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
            x *= iframeScale.x;
            y *= iframeScale.y;
            width *= iframeScale.x;
            height *= iframeScale.y;
            x += left;
            y += top;
            currentWin = (0, $d2553f707975908a$export$38b2d434cce3ea22)(currentIFrame);
            currentIFrame = (0, $d2553f707975908a$export$7bf1f8740e3e34af)(currentWin);
        }
    }
    return (0, $91f1cb25f4ca20c6$export$ee05aea0aeecbad4)({
        width: width,
        height: height,
        x: x,
        y: y
    });
}
// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function $b62109a283c86f13$var$getWindowScrollBarX(element, rect) {
    const leftScroll = (0, $d2553f707975908a$export$dc8fc79fa2800137)(element).scrollLeft;
    if (!rect) return $b62109a283c86f13$var$getBoundingClientRect((0, $d2553f707975908a$export$e495491855dc5418)(element)).left + leftScroll;
    return rect.left + leftScroll;
}
function $b62109a283c86f13$var$getHTMLOffset(documentElement, scroll) {
    const htmlRect = documentElement.getBoundingClientRect();
    const x = htmlRect.left + scroll.scrollLeft - $b62109a283c86f13$var$getWindowScrollBarX(documentElement, htmlRect);
    const y = htmlRect.top + scroll.scrollTop;
    return {
        x: x,
        y: y
    };
}
function $b62109a283c86f13$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
    let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
    const isFixed = strategy === 'fixed';
    const documentElement = (0, $d2553f707975908a$export$e495491855dc5418)(offsetParent);
    const topLayer = elements ? (0, $d2553f707975908a$export$89e651af02346cd4)(elements.floating) : false;
    if (offsetParent === documentElement || topLayer && isFixed) return rect;
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    let scale = (0, $91f1cb25f4ca20c6$export$a397704b5e280835)(1);
    const offsets = (0, $91f1cb25f4ca20c6$export$a397704b5e280835)(0);
    const isOffsetParentAnElement = (0, $d2553f707975908a$export$1b3bfaa9684536aa)(offsetParent);
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d2553f707975908a$export$651544f548703224)(offsetParent) !== 'body' || (0, $d2553f707975908a$export$989e911fa9af580a)(documentElement)) scroll = (0, $d2553f707975908a$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $b62109a283c86f13$var$getBoundingClientRect(offsetParent);
            scale = $b62109a283c86f13$var$getScale(offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        }
    }
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $b62109a283c86f13$var$getHTMLOffset(documentElement, scroll) : (0, $91f1cb25f4ca20c6$export$a397704b5e280835)(0);
    return {
        width: rect.width * scale.x,
        height: rect.height * scale.y,
        x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
        y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
    };
}
function $b62109a283c86f13$var$getClientRects(element) {
    return Array.from(element.getClientRects());
}
// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function $b62109a283c86f13$var$getDocumentRect(element) {
    const html = (0, $d2553f707975908a$export$e495491855dc5418)(element);
    const scroll = (0, $d2553f707975908a$export$dc8fc79fa2800137)(element);
    const body = element.ownerDocument.body;
    const width = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
    const height = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
    let x = -scroll.scrollLeft + $b62109a283c86f13$var$getWindowScrollBarX(element);
    const y = -scroll.scrollTop;
    if ((0, $d2553f707975908a$export$3735103072e4a80)(body).direction === 'rtl') x += (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(html.clientWidth, body.clientWidth) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Safety check: ensure the scrollbar space is reasonable in case this
// calculation is affected by unusual styles.
// Most scrollbars leave 15-18px of space.
const $b62109a283c86f13$var$SCROLLBAR_MAX = 25;
function $b62109a283c86f13$var$getViewportRect(element, strategy) {
    const win = (0, $d2553f707975908a$export$38b2d434cce3ea22)(element);
    const html = (0, $d2553f707975908a$export$e495491855dc5418)(element);
    const visualViewport = win.visualViewport;
    let width = html.clientWidth;
    let height = html.clientHeight;
    let x = 0;
    let y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        const visualViewportBased = (0, $d2553f707975908a$export$78551043582a6a98)();
        if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    const windowScrollbarX = $b62109a283c86f13$var$getWindowScrollBarX(html);
    // <html> `overflow: hidden` + `scrollbar-gutter: stable` reduces the
    // visual width of the <html> but this is not considered in the size
    // of `html.clientWidth`.
    if (windowScrollbarX <= 0) {
        const doc = html.ownerDocument;
        const body = doc.body;
        const bodyStyles = getComputedStyle(body);
        const bodyMarginInline = doc.compatMode === 'CSS1Compat' ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
        const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
        if (clippingStableScrollbarWidth <= $b62109a283c86f13$var$SCROLLBAR_MAX) width -= clippingStableScrollbarWidth;
    } else if (windowScrollbarX <= $b62109a283c86f13$var$SCROLLBAR_MAX) // If the <body> scrollbar is on the left, the width needs to be extended
    // by the scrollbar amount so there isn't extra space on the right.
    width += windowScrollbarX;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
// Returns the inner client rect, subtracting scrollbars if present.
function $b62109a283c86f13$var$getInnerBoundingClientRect(element, strategy) {
    const clientRect = $b62109a283c86f13$var$getBoundingClientRect(element, true, strategy === 'fixed');
    const top = clientRect.top + element.clientTop;
    const left = clientRect.left + element.clientLeft;
    const scale = (0, $d2553f707975908a$export$1b3bfaa9684536aa)(element) ? $b62109a283c86f13$var$getScale(element) : (0, $91f1cb25f4ca20c6$export$a397704b5e280835)(1);
    const width = element.clientWidth * scale.x;
    const height = element.clientHeight * scale.y;
    const x = left * scale.x;
    const y = top * scale.y;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}
function $b62109a283c86f13$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
    let rect;
    if (clippingAncestor === 'viewport') rect = $b62109a283c86f13$var$getViewportRect(element, strategy);
    else if (clippingAncestor === 'document') rect = $b62109a283c86f13$var$getDocumentRect((0, $d2553f707975908a$export$e495491855dc5418)(element));
    else if ((0, $d2553f707975908a$export$45a5e7f76e0caa8d)(clippingAncestor)) rect = $b62109a283c86f13$var$getInnerBoundingClientRect(clippingAncestor, strategy);
    else {
        const visualOffsets = $b62109a283c86f13$var$getVisualOffsets(element);
        rect = {
            x: clippingAncestor.x - visualOffsets.x,
            y: clippingAncestor.y - visualOffsets.y,
            width: clippingAncestor.width,
            height: clippingAncestor.height
        };
    }
    return (0, $91f1cb25f4ca20c6$export$ee05aea0aeecbad4)(rect);
}
function $b62109a283c86f13$var$hasFixedPositionAncestor(element, stopNode) {
    const parentNode = (0, $d2553f707975908a$export$4e12058fc4d51d56)(element);
    if (parentNode === stopNode || !(0, $d2553f707975908a$export$45a5e7f76e0caa8d)(parentNode) || (0, $d2553f707975908a$export$d1162fb0b6d4cd51)(parentNode)) return false;
    return (0, $d2553f707975908a$export$3735103072e4a80)(parentNode).position === 'fixed' || $b62109a283c86f13$var$hasFixedPositionAncestor(parentNode, stopNode);
}
// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function $b62109a283c86f13$var$getClippingElementAncestors(element, cache) {
    const cachedResult = cache.get(element);
    if (cachedResult) return cachedResult;
    let result = (0, $d2553f707975908a$export$3b57c1601291186b)(element, [], false).filter((el)=>(0, $d2553f707975908a$export$45a5e7f76e0caa8d)(el) && (0, $d2553f707975908a$export$651544f548703224)(el) !== 'body');
    let currentContainingBlockComputedStyle = null;
    const elementIsFixed = (0, $d2553f707975908a$export$3735103072e4a80)(element).position === 'fixed';
    let currentNode = elementIsFixed ? (0, $d2553f707975908a$export$4e12058fc4d51d56)(element) : element;
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
    while((0, $d2553f707975908a$export$45a5e7f76e0caa8d)(currentNode) && !(0, $d2553f707975908a$export$d1162fb0b6d4cd51)(currentNode)){
        const computedStyle = (0, $d2553f707975908a$export$3735103072e4a80)(currentNode);
        const currentNodeIsContaining = (0, $d2553f707975908a$export$d6c4e8150c35fed1)(currentNode);
        if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
        const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && (currentContainingBlockComputedStyle.position === 'absolute' || currentContainingBlockComputedStyle.position === 'fixed') || (0, $d2553f707975908a$export$989e911fa9af580a)(currentNode) && !currentNodeIsContaining && $b62109a283c86f13$var$hasFixedPositionAncestor(element, currentNode);
        if (shouldDropCurrentNode) // Drop non-containing blocks.
        result = result.filter((ancestor)=>ancestor !== currentNode);
        else // Record last containing block for next iteration.
        currentContainingBlockComputedStyle = computedStyle;
        currentNode = (0, $d2553f707975908a$export$4e12058fc4d51d56)(currentNode);
    }
    cache.set(element, result);
    return result;
}
// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function $b62109a283c86f13$var$getClippingRect(_ref) {
    let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
    const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, $d2553f707975908a$export$89e651af02346cd4)(element) ? [] : $b62109a283c86f13$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
    const clippingAncestors = [
        ...elementClippingAncestors,
        rootBoundary
    ];
    const firstRect = $b62109a283c86f13$var$getClientRectFromClippingAncestor(element, clippingAncestors[0], strategy);
    let top = firstRect.top;
    let right = firstRect.right;
    let bottom = firstRect.bottom;
    let left = firstRect.left;
    for(let i = 1; i < clippingAncestors.length; i++){
        const rect = $b62109a283c86f13$var$getClientRectFromClippingAncestor(element, clippingAncestors[i], strategy);
        top = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(rect.top, top);
        right = (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(rect.right, right);
        bottom = (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(rect.bottom, bottom);
        left = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(rect.left, left);
    }
    return {
        width: right - left,
        height: bottom - top,
        x: left,
        y: top
    };
}
function $b62109a283c86f13$var$getDimensions(element) {
    const { width: width, height: height } = $b62109a283c86f13$var$getCssDimensions(element);
    return {
        width: width,
        height: height
    };
}
function $b62109a283c86f13$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
    const isOffsetParentAnElement = (0, $d2553f707975908a$export$1b3bfaa9684536aa)(offsetParent);
    const documentElement = (0, $d2553f707975908a$export$e495491855dc5418)(offsetParent);
    const isFixed = strategy === 'fixed';
    const rect = $b62109a283c86f13$var$getBoundingClientRect(element, true, isFixed, offsetParent);
    let scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const offsets = (0, $91f1cb25f4ca20c6$export$a397704b5e280835)(0);
    // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
    // Firefox with layout.scrollbar.side = 3 in about:config to test this.
    function setLeftRTLScrollbarOffset() {
        offsets.x = $b62109a283c86f13$var$getWindowScrollBarX(documentElement);
    }
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $d2553f707975908a$export$651544f548703224)(offsetParent) !== 'body' || (0, $d2553f707975908a$export$989e911fa9af580a)(documentElement)) scroll = (0, $d2553f707975908a$export$dc8fc79fa2800137)(offsetParent);
        if (isOffsetParentAnElement) {
            const offsetRect = $b62109a283c86f13$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
            offsets.x = offsetRect.x + offsetParent.clientLeft;
            offsets.y = offsetRect.y + offsetParent.clientTop;
        } else if (documentElement) setLeftRTLScrollbarOffset();
    }
    if (isFixed && !isOffsetParentAnElement && documentElement) setLeftRTLScrollbarOffset();
    const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $b62109a283c86f13$var$getHTMLOffset(documentElement, scroll) : (0, $91f1cb25f4ca20c6$export$a397704b5e280835)(0);
    const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
    const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
    return {
        x: x,
        y: y,
        width: rect.width,
        height: rect.height
    };
}
function $b62109a283c86f13$var$isStaticPositioned(element) {
    return (0, $d2553f707975908a$export$3735103072e4a80)(element).position === 'static';
}
function $b62109a283c86f13$var$getTrueOffsetParent(element, polyfill) {
    if (!(0, $d2553f707975908a$export$1b3bfaa9684536aa)(element) || (0, $d2553f707975908a$export$3735103072e4a80)(element).position === 'fixed') return null;
    if (polyfill) return polyfill(element);
    let rawOffsetParent = element.offsetParent;
    // Firefox returns the <html> element as the offsetParent if it's non-static,
    // while Chrome and Safari return the <body> element. The <body> element must
    // be used to perform the correct calculations even if the <html> element is
    // non-static.
    if ((0, $d2553f707975908a$export$e495491855dc5418)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
    return rawOffsetParent;
}
// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function $b62109a283c86f13$var$getOffsetParent(element, polyfill) {
    const win = (0, $d2553f707975908a$export$38b2d434cce3ea22)(element);
    if ((0, $d2553f707975908a$export$89e651af02346cd4)(element)) return win;
    if (!(0, $d2553f707975908a$export$1b3bfaa9684536aa)(element)) {
        let svgOffsetParent = (0, $d2553f707975908a$export$4e12058fc4d51d56)(element);
        while(svgOffsetParent && !(0, $d2553f707975908a$export$d1162fb0b6d4cd51)(svgOffsetParent)){
            if ((0, $d2553f707975908a$export$45a5e7f76e0caa8d)(svgOffsetParent) && !$b62109a283c86f13$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
            svgOffsetParent = (0, $d2553f707975908a$export$4e12058fc4d51d56)(svgOffsetParent);
        }
        return win;
    }
    let offsetParent = $b62109a283c86f13$var$getTrueOffsetParent(element, polyfill);
    while(offsetParent && (0, $d2553f707975908a$export$71535ffaa902797f)(offsetParent) && $b62109a283c86f13$var$isStaticPositioned(offsetParent))offsetParent = $b62109a283c86f13$var$getTrueOffsetParent(offsetParent, polyfill);
    if (offsetParent && (0, $d2553f707975908a$export$d1162fb0b6d4cd51)(offsetParent) && $b62109a283c86f13$var$isStaticPositioned(offsetParent) && !(0, $d2553f707975908a$export$d6c4e8150c35fed1)(offsetParent)) return win;
    return offsetParent || (0, $d2553f707975908a$export$940d8225183e1404)(element) || win;
}
const $b62109a283c86f13$var$getElementRects = async function(data) {
    const getOffsetParentFn = this.getOffsetParent || $b62109a283c86f13$var$getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    const floatingDimensions = await getDimensionsFn(data.floating);
    return {
        reference: $b62109a283c86f13$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
        floating: {
            x: 0,
            y: 0,
            width: floatingDimensions.width,
            height: floatingDimensions.height
        }
    };
};
function $b62109a283c86f13$var$isRTL(element) {
    return (0, $d2553f707975908a$export$3735103072e4a80)(element).direction === 'rtl';
}
const $b62109a283c86f13$export$722a64dea1b767dc = {
    convertOffsetParentRelativeRectToViewportRelativeRect: $b62109a283c86f13$var$convertOffsetParentRelativeRectToViewportRelativeRect,
    getDocumentElement: $d2553f707975908a$export$e495491855dc5418,
    getClippingRect: $b62109a283c86f13$var$getClippingRect,
    getOffsetParent: $b62109a283c86f13$var$getOffsetParent,
    getElementRects: $b62109a283c86f13$var$getElementRects,
    getClientRects: $b62109a283c86f13$var$getClientRects,
    getDimensions: $b62109a283c86f13$var$getDimensions,
    getScale: $b62109a283c86f13$var$getScale,
    isElement: $d2553f707975908a$export$45a5e7f76e0caa8d,
    isRTL: $b62109a283c86f13$var$isRTL
};
function $b62109a283c86f13$var$rectsAreEqual(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}
// https://samthor.au/2021/observing-dom/
function $b62109a283c86f13$var$observeMove(element, onMove) {
    let io = null;
    let timeoutId;
    const root = (0, $d2553f707975908a$export$e495491855dc5418)(element);
    function cleanup() {
        var _io;
        clearTimeout(timeoutId);
        (_io = io) == null || _io.disconnect();
        io = null;
    }
    function refresh(skip, threshold) {
        if (skip === void 0) skip = false;
        if (threshold === void 0) threshold = 1;
        cleanup();
        const elementRectForRootMargin = element.getBoundingClientRect();
        const { left: left, top: top, width: width, height: height } = elementRectForRootMargin;
        if (!skip) onMove();
        if (!width || !height) return;
        const insetTop = (0, $91f1cb25f4ca20c6$export$a3fe094919f356fd)(top);
        const insetRight = (0, $91f1cb25f4ca20c6$export$a3fe094919f356fd)(root.clientWidth - (left + width));
        const insetBottom = (0, $91f1cb25f4ca20c6$export$a3fe094919f356fd)(root.clientHeight - (top + height));
        const insetLeft = (0, $91f1cb25f4ca20c6$export$a3fe094919f356fd)(left);
        const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
        const options = {
            rootMargin: rootMargin,
            threshold: (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(0, (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(1, threshold)) || 1
        };
        let isFirstUpdate = true;
        function handleObserve(entries) {
            const ratio = entries[0].intersectionRatio;
            if (ratio !== threshold) {
                if (!isFirstUpdate) return refresh();
                if (!ratio) // If the reference is clipped, the ratio is 0. Throttle the refresh
                // to prevent an infinite loop of updates.
                timeoutId = setTimeout(()=>{
                    refresh(false, 1e-7);
                }, 1000);
                else refresh(false, ratio);
            }
            if (ratio === 1 && !$b62109a283c86f13$var$rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) // It's possible that even though the ratio is reported as 1, the
            // element is not actually fully within the IntersectionObserver's root
            // area anymore. This can happen under performance constraints. This may
            // be a bug in the browser's IntersectionObserver implementation. To
            // work around this, we compare the element's bounding rect now with
            // what it was at the time we created the IntersectionObserver. If they
            // are not equal then the element moved, so we refresh.
            refresh();
            isFirstUpdate = false;
        }
        // Older browsers don't support a `document` as the root and will throw an
        // error.
        try {
            io = new IntersectionObserver(handleObserve, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
                // Handle <iframe>s
                root: root.ownerDocument
            }));
        } catch (_e) {
            io = new IntersectionObserver(handleObserve, options);
        }
        io.observe(element);
    }
    refresh(true);
    return cleanup;
}
/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */ function $b62109a283c86f13$export$deee3a793edee05f(reference, floating, update, options) {
    if (options === void 0) options = {};
    const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
    const referenceEl = $b62109a283c86f13$var$unwrapElement(reference);
    const ancestors = ancestorScroll || ancestorResize ? [
        ...referenceEl ? (0, $d2553f707975908a$export$3b57c1601291186b)(referenceEl) : [],
        ...floating ? (0, $d2553f707975908a$export$3b57c1601291186b)(floating) : []
    ] : [];
    ancestors.forEach((ancestor)=>{
        ancestorScroll && ancestor.addEventListener('scroll', update, {
            passive: true
        });
        ancestorResize && ancestor.addEventListener('resize', update);
    });
    const cleanupIo = referenceEl && layoutShift ? $b62109a283c86f13$var$observeMove(referenceEl, update) : null;
    let reobserveFrame = -1;
    let resizeObserver = null;
    if (elementResize) {
        resizeObserver = new ResizeObserver((_ref)=>{
            let [firstEntry] = _ref;
            if (firstEntry && firstEntry.target === referenceEl && resizeObserver && floating) {
                // Prevent update loops when using the `size` middleware.
                // https://github.com/floating-ui/floating-ui/issues/1740
                resizeObserver.unobserve(floating);
                cancelAnimationFrame(reobserveFrame);
                reobserveFrame = requestAnimationFrame(()=>{
                    var _resizeObserver;
                    (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                });
            }
            update();
        });
        if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
        if (floating) resizeObserver.observe(floating);
    }
    let frameId;
    let prevRefRect = animationFrame ? $b62109a283c86f13$var$getBoundingClientRect(reference) : null;
    if (animationFrame) frameLoop();
    function frameLoop() {
        const nextRefRect = $b62109a283c86f13$var$getBoundingClientRect(reference);
        if (prevRefRect && !$b62109a283c86f13$var$rectsAreEqual(prevRefRect, nextRefRect)) update();
        prevRefRect = nextRefRect;
        frameId = requestAnimationFrame(frameLoop);
    }
    update();
    return ()=>{
        var _resizeObserver2;
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.removeEventListener('scroll', update);
            ancestorResize && ancestor.removeEventListener('resize', update);
        });
        cleanupIo == null || cleanupIo();
        (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
        resizeObserver = null;
        if (animationFrame) cancelAnimationFrame(frameId);
    };
}
/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */ const $b62109a283c86f13$export$37b6bde19b108ecc = (0, $fe4da4642c9ddd37$export$37b6bde19b108ecc);
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $b62109a283c86f13$export$cc800923e997bb8 = (0, $fe4da4642c9ddd37$export$cc800923e997bb8);
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $b62109a283c86f13$export$91fb6ecbd551914 = (0, $fe4da4642c9ddd37$export$91fb6ecbd551914);
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $b62109a283c86f13$export$fba63a578e423eb = (0, $fe4da4642c9ddd37$export$fba63a578e423eb);
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $b62109a283c86f13$export$8a83211c878a3f1f = (0, $fe4da4642c9ddd37$export$8a83211c878a3f1f);
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $b62109a283c86f13$export$346677f925de839c = (0, $fe4da4642c9ddd37$export$346677f925de839c);
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $b62109a283c86f13$export$fe8985bb6374093c = (0, $fe4da4642c9ddd37$export$fe8985bb6374093c);
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */ const $b62109a283c86f13$export$f2120bbfa5450bd2 = (0, $fe4da4642c9ddd37$export$f2120bbfa5450bd2);
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $b62109a283c86f13$export$18c8ad048e32c7d5 = (0, $fe4da4642c9ddd37$export$18c8ad048e32c7d5);
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $b62109a283c86f13$export$7bf07e38f3dc4b69 = (0, $fe4da4642c9ddd37$export$7bf07e38f3dc4b69);
/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */ const $b62109a283c86f13$export$48a53dcb22e581d0 = (reference, floating, options)=>{
    // This caches the expensive `getClippingElementAncestors` function so that
    // multiple lifecycle resets re-use the same result. It only lives for a
    // single call. If other functions become expensive, we can add them as well.
    const cache = new Map();
    const mergedOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        platform: $b62109a283c86f13$export$722a64dea1b767dc
    }, options);
    const platformWithCache = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mergedOptions.platform), {
        _c: cache
    });
    return (0, $fe4da4642c9ddd37$export$48a53dcb22e581d0)(reference, floating, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mergedOptions), {
        platform: platformWithCache
    }));
};



var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
var $2a1639b232695612$var$isClient = typeof document !== 'undefined';
var $2a1639b232695612$var$noop = function noop() {};
var $2a1639b232695612$var$index = $2a1639b232695612$var$isClient ? (0, $7fPBF.useLayoutEffect) : $2a1639b232695612$var$noop;
// Fork of `fast-deep-equal` that only does the comparisons we need and compares
// functions
function $2a1639b232695612$var$deepEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (typeof a === 'function' && a.toString() === b.toString()) return true;
    let length;
    let i;
    let keys;
    if (a && b && typeof a === 'object') {
        if (Array.isArray(a)) {
            length = a.length;
            if (length !== b.length) return false;
            for(i = length; i-- !== 0;){
                if (!$2a1639b232695612$var$deepEqual(a[i], b[i])) return false;
            }
            return true;
        }
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;){
            if (!({}).hasOwnProperty.call(b, keys[i])) return false;
        }
        for(i = length; i-- !== 0;){
            const key = keys[i];
            if (key === '_owner' && a.$$typeof) continue;
            if (!$2a1639b232695612$var$deepEqual(a[key], b[key])) return false;
        }
        return true;
    }
    return a !== a && b !== b;
}
function $2a1639b232695612$var$getDPR(element) {
    if (typeof window === 'undefined') return 1;
    const win = element.ownerDocument.defaultView || window;
    return win.devicePixelRatio || 1;
}
function $2a1639b232695612$var$roundByDPR(element, value) {
    const dpr = $2a1639b232695612$var$getDPR(element);
    return Math.round(value * dpr) / dpr;
}
function $2a1639b232695612$var$useLatestRef(value) {
    const ref = $7fPBF.useRef(value);
    $2a1639b232695612$var$index(()=>{
        ref.current = value;
    });
    return ref;
}
/**
 * Provides data to position a floating element.
 * @see https://floating-ui.com/docs/useFloating
 */ function $2a1639b232695612$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform, elements: { reference: externalReference, floating: externalFloating } = {}, transform: transform = true, whileElementsMounted: whileElementsMounted, open: open } = options;
    const [data, setData] = $7fPBF.useState({
        x: 0,
        y: 0,
        strategy: strategy,
        placement: placement,
        middlewareData: {},
        isPositioned: false
    });
    const [latestMiddleware, setLatestMiddleware] = $7fPBF.useState(middleware);
    if (!$2a1639b232695612$var$deepEqual(latestMiddleware, middleware)) setLatestMiddleware(middleware);
    const [_reference, _setReference] = $7fPBF.useState(null);
    const [_floating, _setFloating] = $7fPBF.useState(null);
    const setReference = $7fPBF.useCallback((node)=>{
        if (node !== referenceRef.current) {
            referenceRef.current = node;
            _setReference(node);
        }
    }, []);
    const setFloating = $7fPBF.useCallback((node)=>{
        if (node !== floatingRef.current) {
            floatingRef.current = node;
            _setFloating(node);
        }
    }, []);
    const referenceEl = externalReference || _reference;
    const floatingEl = externalFloating || _floating;
    const referenceRef = $7fPBF.useRef(null);
    const floatingRef = $7fPBF.useRef(null);
    const dataRef = $7fPBF.useRef(data);
    const hasWhileElementsMounted = whileElementsMounted != null;
    const whileElementsMountedRef = $2a1639b232695612$var$useLatestRef(whileElementsMounted);
    const platformRef = $2a1639b232695612$var$useLatestRef(platform);
    const openRef = $2a1639b232695612$var$useLatestRef(open);
    const update = $7fPBF.useCallback(()=>{
        if (!referenceRef.current || !floatingRef.current) return;
        const config = {
            placement: placement,
            strategy: strategy,
            middleware: latestMiddleware
        };
        if (platformRef.current) config.platform = platformRef.current;
        (0, $b62109a283c86f13$export$48a53dcb22e581d0)(referenceRef.current, floatingRef.current, config).then((data)=>{
            const fullData = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data), {
                // The floating element's position may be recomputed while it's closed
                // but still mounted (such as when transitioning out). To ensure
                // `isPositioned` will be `false` initially on the next open, avoid
                // setting it to `true` when `open === false` (must be specified).
                isPositioned: openRef.current !== false
            });
            if (isMountedRef.current && !$2a1639b232695612$var$deepEqual(dataRef.current, fullData)) {
                dataRef.current = fullData;
                $fw0lo.flushSync(()=>{
                    setData(fullData);
                });
            }
        });
    }, [
        latestMiddleware,
        placement,
        strategy,
        platformRef,
        openRef
    ]);
    $2a1639b232695612$var$index(()=>{
        if (open === false && dataRef.current.isPositioned) {
            dataRef.current.isPositioned = false;
            setData((data)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data), {
                    isPositioned: false
                }));
        }
    }, [
        open
    ]);
    const isMountedRef = $7fPBF.useRef(false);
    $2a1639b232695612$var$index(()=>{
        isMountedRef.current = true;
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    $2a1639b232695612$var$index(()=>{
        if (referenceEl) referenceRef.current = referenceEl;
        if (floatingEl) floatingRef.current = floatingEl;
        if (referenceEl && floatingEl) {
            if (whileElementsMountedRef.current) return whileElementsMountedRef.current(referenceEl, floatingEl, update);
            update();
        }
    }, [
        referenceEl,
        floatingEl,
        update,
        whileElementsMountedRef,
        hasWhileElementsMounted
    ]);
    const refs = $7fPBF.useMemo(()=>({
            reference: referenceRef,
            floating: floatingRef,
            setReference: setReference,
            setFloating: setFloating
        }), [
        setReference,
        setFloating
    ]);
    const elements = $7fPBF.useMemo(()=>({
            reference: referenceEl,
            floating: floatingEl
        }), [
        referenceEl,
        floatingEl
    ]);
    const floatingStyles = $7fPBF.useMemo(()=>{
        const initialStyles = {
            position: strategy,
            left: 0,
            top: 0
        };
        if (!elements.floating) return initialStyles;
        const x = $2a1639b232695612$var$roundByDPR(elements.floating, data.x);
        const y = $2a1639b232695612$var$roundByDPR(elements.floating, data.y);
        if (transform) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, initialStyles), {
            transform: "translate(" + x + "px, " + y + "px)"
        }), $2a1639b232695612$var$getDPR(elements.floating) >= 1.5 && {
            willChange: 'transform'
        });
        return {
            position: strategy,
            left: x,
            top: y
        };
    }, [
        strategy,
        transform,
        elements.floating,
        data.x,
        data.y
    ]);
    return $7fPBF.useMemo(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data), {
            update: update,
            refs: refs,
            elements: elements,
            floatingStyles: floatingStyles
        }), [
        data,
        update,
        refs,
        elements,
        floatingStyles
    ]);
}
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $2a1639b232695612$var$arrow$1 = (options)=>{
    function isRef(value) {
        return ({}).hasOwnProperty.call(value, 'current');
    }
    return {
        name: 'arrow',
        options: options,
        fn (state) {
            const { element: element, padding: padding } = typeof options === 'function' ? options(state) : options;
            if (element && isRef(element)) {
                if (element.current != null) return (0, $b62109a283c86f13$export$f2120bbfa5450bd2)({
                    element: element.current,
                    padding: padding
                }).fn(state);
                return {};
            }
            if (element) return (0, $b62109a283c86f13$export$f2120bbfa5450bd2)({
                element: element,
                padding: padding
            }).fn(state);
            return {};
        }
    };
};
/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */ const $2a1639b232695612$export$cc800923e997bb8 = (options, deps)=>{
    const result = (0, $b62109a283c86f13$export$cc800923e997bb8)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */ const $2a1639b232695612$export$fba63a578e423eb = (options, deps)=>{
    const result = (0, $b62109a283c86f13$export$fba63a578e423eb)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */ const $2a1639b232695612$export$7bf07e38f3dc4b69 = (options, deps)=>{
    const result = (0, $b62109a283c86f13$export$7bf07e38f3dc4b69)(options);
    return {
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */ const $2a1639b232695612$export$8a83211c878a3f1f = (options, deps)=>{
    const result = (0, $b62109a283c86f13$export$8a83211c878a3f1f)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */ const $2a1639b232695612$export$346677f925de839c = (options, deps)=>{
    const result = (0, $b62109a283c86f13$export$346677f925de839c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */ const $2a1639b232695612$export$91fb6ecbd551914 = (options, deps)=>{
    const result = (0, $b62109a283c86f13$export$91fb6ecbd551914)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */ const $2a1639b232695612$export$fe8985bb6374093c = (options, deps)=>{
    const result = (0, $b62109a283c86f13$export$fe8985bb6374093c)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */ const $2a1639b232695612$export$18c8ad048e32c7d5 = (options, deps)=>{
    const result = (0, $b62109a283c86f13$export$18c8ad048e32c7d5)(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};
/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * This wraps the core `arrow` middleware to allow React refs as the element.
 * @see https://floating-ui.com/docs/arrow
 */ const $2a1639b232695612$export$f2120bbfa5450bd2 = (options, deps)=>{
    const result = $2a1639b232695612$var$arrow$1(options);
    return {
        name: result.name,
        fn: result.fn,
        options: [
            options,
            deps
        ]
    };
};




function $82893a1ac286eedc$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}


function $3b9a765e165f5e2c$export$71511d61b312f219(input, hint) {
    if ((0, $82893a1ac286eedc$export$71511d61b312f219)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $82893a1ac286eedc$export$71511d61b312f219)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}



function $48eb3f76e7383a7f$export$71511d61b312f219(arg) {
    var key = (0, $3b9a765e165f5e2c$export$71511d61b312f219)(arg, "string");
    return (0, $82893a1ac286eedc$export$71511d61b312f219)(key) === "symbol" ? key : String(key);
}



var $7fPBF = parcelRequire("7fPBF");



var $7fPBF = parcelRequire("7fPBF");

/*!
* tabbable 6.4.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $fef840927e49d4b7$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $fef840927e49d4b7$var$candidateSelector = /* #__PURE__ */ $fef840927e49d4b7$var$candidateSelectors.join(',');
var $fef840927e49d4b7$var$NoElement = typeof Element === 'undefined';
var $fef840927e49d4b7$var$matches = $fef840927e49d4b7$var$NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $fef840927e49d4b7$var$getRootNode = !$fef840927e49d4b7$var$NoElement && Element.prototype.getRootNode ? function(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $fef840927e49d4b7$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $fef840927e49d4b7$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $fef840927e49d4b7$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $fef840927e49d4b7$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($fef840927e49d4b7$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($fef840927e49d4b7$var$candidateSelector));
    if (includeContainer && $fef840927e49d4b7$var$matches.call(el, $fef840927e49d4b7$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $fef840927e49d4b7$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($fef840927e49d4b7$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $fef840927e49d4b7$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $fef840927e49d4b7$var$matches.call(element, $fef840927e49d4b7$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$fef840927e49d4b7$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $fef840927e49d4b7$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $fef840927e49d4b7$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $fef840927e49d4b7$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $fef840927e49d4b7$var$isContentEditable(node)) && !$fef840927e49d4b7$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $fef840927e49d4b7$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $fef840927e49d4b7$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$fef840927e49d4b7$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $fef840927e49d4b7$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $fef840927e49d4b7$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $fef840927e49d4b7$var$isHiddenInput = function isHiddenInput(node) {
    return $fef840927e49d4b7$var$isInput(node) && node.type === 'hidden';
};
var $fef840927e49d4b7$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $fef840927e49d4b7$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $fef840927e49d4b7$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $fef840927e49d4b7$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $fef840927e49d4b7$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $fef840927e49d4b7$var$isRadio = function isRadio(node) {
    return $fef840927e49d4b7$var$isInput(node) && node.type === 'radio';
};
var $fef840927e49d4b7$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $fef840927e49d4b7$var$isRadio(node) && !$fef840927e49d4b7$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $fef840927e49d4b7$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $fef840927e49d4b7$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $fef840927e49d4b7$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $fef840927e49d4b7$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $fef840927e49d4b7$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    if (getComputedStyle(node).visibility === 'hidden') return true;
    var isDirectSummary = $fef840927e49d4b7$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($fef840927e49d4b7$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $fef840927e49d4b7$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $fef840927e49d4b7$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($fef840927e49d4b7$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $fef840927e49d4b7$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $fef840927e49d4b7$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $fef840927e49d4b7$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $fef840927e49d4b7$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $fef840927e49d4b7$var$isHiddenInput(node) || $fef840927e49d4b7$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $fef840927e49d4b7$var$isDetailsWithSummary(node) || $fef840927e49d4b7$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $fef840927e49d4b7$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($fef840927e49d4b7$var$isNonTabbableRadio(node) || $fef840927e49d4b7$export$a4672efddb4181b8(node) < 0 || !$fef840927e49d4b7$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $fef840927e49d4b7$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $fef840927e49d4b7$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $fef840927e49d4b7$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $fef840927e49d4b7$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($fef840927e49d4b7$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $fef840927e49d4b7$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $fef840927e49d4b7$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $fef840927e49d4b7$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $fef840927e49d4b7$var$isShadowRootTabbable
    });
    else candidates = $fef840927e49d4b7$var$getCandidates(container, options.includeContainer, $fef840927e49d4b7$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $fef840927e49d4b7$var$_sortByOrder(candidates);
};
var $fef840927e49d4b7$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $fef840927e49d4b7$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $fef840927e49d4b7$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $fef840927e49d4b7$var$getCandidates(container, options.includeContainer, $fef840927e49d4b7$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $fef840927e49d4b7$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($fef840927e49d4b7$var$matches.call(node, $fef840927e49d4b7$var$candidateSelector) === false) return false;
    return $fef840927e49d4b7$var$isNodeMatchingSelectorTabbable(options, node);
};
var $fef840927e49d4b7$var$focusableCandidateSelector = /* #__PURE__ */ $fef840927e49d4b7$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $fef840927e49d4b7$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($fef840927e49d4b7$var$matches.call(node, $fef840927e49d4b7$var$focusableCandidateSelector) === false) return false;
    return $fef840927e49d4b7$var$isNodeMatchingSelectorFocusable(options, node);
};


// Avoid Chrome DevTools blue warning.
function $9f8118feb50d8e8d$export$867a782338812cb4() {
    const uaData = navigator.userAgentData;
    if (uaData != null && uaData.platform) return uaData.platform;
    return navigator.platform;
}
function $9f8118feb50d8e8d$export$7935961ef7719cb0() {
    const uaData = navigator.userAgentData;
    if (uaData && Array.isArray(uaData.brands)) return uaData.brands.map((_ref)=>{
        let { brand: brand, version: version } = _ref;
        return brand + "/" + version;
    }).join(' ');
    return navigator.userAgent;
}
function $9f8118feb50d8e8d$export$95df08bae54cb4df() {
    // Chrome DevTools does not complain about navigator.vendor
    return /apple/i.test(navigator.vendor);
}
function $9f8118feb50d8e8d$export$a11b0059900ceec8() {
    const re = /android/i;
    return re.test($9f8118feb50d8e8d$export$867a782338812cb4()) || re.test($9f8118feb50d8e8d$export$7935961ef7719cb0());
}
function $9f8118feb50d8e8d$export$9ac100e40613ea10() {
    return $9f8118feb50d8e8d$export$867a782338812cb4().toLowerCase().startsWith('mac') && !navigator.maxTouchPoints;
}
function $9f8118feb50d8e8d$export$c8f880a2d81914c4() {
    return $9f8118feb50d8e8d$export$7935961ef7719cb0().includes('jsdom/');
}
const $9f8118feb50d8e8d$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $9f8118feb50d8e8d$var$TYPEABLE_SELECTOR = "input:not([type='hidden']):not([disabled]),[contenteditable]:not([contenteditable='false']),textarea:not([disabled])";
const $9f8118feb50d8e8d$var$ARROW_LEFT = 'ArrowLeft';
const $9f8118feb50d8e8d$var$ARROW_RIGHT = 'ArrowRight';
const $9f8118feb50d8e8d$var$ARROW_UP = 'ArrowUp';
const $9f8118feb50d8e8d$var$ARROW_DOWN = 'ArrowDown';
function $9f8118feb50d8e8d$export$da980962bd2147a4(doc) {
    let activeElement = doc.activeElement;
    while(((_activeElement = activeElement) == null || (_activeElement = _activeElement.shadowRoot) == null ? void 0 : _activeElement.activeElement) != null){
        var _activeElement;
        activeElement = activeElement.shadowRoot.activeElement;
    }
    return activeElement;
}
function $9f8118feb50d8e8d$export$2344b14b097df817(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $d2553f707975908a$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $9f8118feb50d8e8d$export$c22522a4dfa48e9c(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $9f8118feb50d8e8d$export$43c3154d5bf2c6c2(event, node) {
    if (node == null) return false;
    if ('composedPath' in event) return event.composedPath().includes(node);
    // TS thinks `event` is of type never as it assumes all browsers support composedPath, but browsers without shadow dom don't
    const e = event;
    return e.target != null && node.contains(e.target);
}
function $9f8118feb50d8e8d$export$7b296c28e0fa3aed(element) {
    return element.matches('html,body');
}
function $9f8118feb50d8e8d$export$f65ca476c09acec0(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
function $9f8118feb50d8e8d$export$42ad131c32f0fb8d(element) {
    return (0, $d2553f707975908a$export$1b3bfaa9684536aa)(element) && element.matches($9f8118feb50d8e8d$var$TYPEABLE_SELECTOR);
}
function $9f8118feb50d8e8d$export$259ba5ae38188551(element) {
    if (!element) return false;
    return element.getAttribute('role') === 'combobox' && $9f8118feb50d8e8d$export$42ad131c32f0fb8d(element);
}
function $9f8118feb50d8e8d$export$65750043c2fb2f40(element) {
    // We don't want to block focus from working with `visibleOnly`
    // (JSDOM doesn't match `:focus-visible` when the element has `:focus`)
    if (!element || $9f8118feb50d8e8d$export$c8f880a2d81914c4()) return true;
    try {
        return element.matches(':focus-visible');
    } catch (_e) {
        return true;
    }
}
function $9f8118feb50d8e8d$export$9b0901b5e9b45fc7(floatingElement) {
    if (!floatingElement) return null;
    // Try to find the element that has `{...getFloatingProps()}` spread on it.
    // This indicates the floating element is acting as a positioning wrapper, and
    // so focus should be managed on the child element with the event handlers and
    // aria props.
    return floatingElement.hasAttribute($9f8118feb50d8e8d$var$FOCUSABLE_ATTRIBUTE) ? floatingElement : floatingElement.querySelector("[" + $9f8118feb50d8e8d$var$FOCUSABLE_ATTRIBUTE + "]") || floatingElement;
}
function $9f8118feb50d8e8d$export$1f1998cc3c6b56fb(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$9f8118feb50d8e8d$export$1f1998cc3c6b56fb(nodes, child.id, onlyOpenChildren)
        ]);
}
function $9f8118feb50d8e8d$export$e7e88d43cb97db79(nodes, id) {
    let deepestNodeId;
    let maxDepth = -1;
    function findDeepest(nodeId, depth) {
        if (depth > maxDepth) {
            deepestNodeId = nodeId;
            maxDepth = depth;
        }
        const children = $9f8118feb50d8e8d$export$1f1998cc3c6b56fb(nodes, nodeId);
        children.forEach((child)=>{
            findDeepest(child.id, depth + 1);
        });
    }
    findDeepest(id, 0);
    return nodes.find((node)=>node.id === deepestNodeId);
}
function $9f8118feb50d8e8d$export$5d8eb345316b65c0(nodes, id) {
    var _nodes$find;
    let allAncestors = [];
    let currentParentId = (_nodes$find = nodes.find((node)=>node.id === id)) == null ? void 0 : _nodes$find.parentId;
    while(currentParentId){
        const currentNode = nodes.find((node)=>node.id === currentParentId);
        currentParentId = currentNode == null ? void 0 : currentNode.parentId;
        if (currentNode) allAncestors = allAncestors.concat(currentNode);
    }
    return allAncestors;
}
function $9f8118feb50d8e8d$export$7ae4cd3a66c1e050(event) {
    event.preventDefault();
    event.stopPropagation();
}
function $9f8118feb50d8e8d$export$94781ce41a161222(event) {
    return 'nativeEvent' in event;
}
// License: https://github.com/adobe/react-spectrum/blob/b35d5c02fe900badccd0cf1a8f23bb593419f238/packages/@react-aria/utils/src/isVirtualEvent.ts
function $9f8118feb50d8e8d$export$60278871457622de(event) {
    // FIXME: Firefox is now emitting a deprecation warning for `mozInputSource`.
    // Try to find a workaround for this. `react-aria` source still has the check.
    if (event.mozInputSource === 0 && event.isTrusted) return true;
    if ($9f8118feb50d8e8d$export$a11b0059900ceec8() && event.pointerType) return event.type === 'click' && event.buttons === 1;
    return event.detail === 0 && !event.pointerType;
}
function $9f8118feb50d8e8d$export$29bf1b5f2c56cf63(event) {
    if ($9f8118feb50d8e8d$export$c8f880a2d81914c4()) return false;
    return !$9f8118feb50d8e8d$export$a11b0059900ceec8() && event.width === 0 && event.height === 0 || $9f8118feb50d8e8d$export$a11b0059900ceec8() && event.width === 1 && event.height === 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'mouse' || // iOS VoiceOver returns 0.333• for width/height.
    event.width < 1 && event.height < 1 && event.pressure === 0 && event.detail === 0 && event.pointerType === 'touch';
}
function $9f8118feb50d8e8d$export$81cf264172d31e51(pointerType, strict) {
    // On some Linux machines with Chromium, mouse inputs return a `pointerType`
    // of "pen": https://github.com/floating-ui/floating-ui/issues/2015
    const values = [
        'mouse',
        'pen'
    ];
    if (!strict) values.push('', undefined);
    return values.includes(pointerType);
}
var $9f8118feb50d8e8d$var$isClient = typeof document !== 'undefined';
var $9f8118feb50d8e8d$var$noop = function noop() {};
var $9f8118feb50d8e8d$export$bb3b3b3acfd7447f = $9f8118feb50d8e8d$var$isClient ? (0, $7fPBF.useLayoutEffect) : $9f8118feb50d8e8d$var$noop;
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $9f8118feb50d8e8d$var$SafeReact = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $7fPBF);
function $9f8118feb50d8e8d$export$bcd07ba85a740103(value) {
    const ref = $7fPBF.useRef(value);
    $9f8118feb50d8e8d$export$bb3b3b3acfd7447f(()=>{
        ref.current = value;
    });
    return ref;
}
const $9f8118feb50d8e8d$var$useInsertionEffect = $9f8118feb50d8e8d$var$SafeReact.useInsertionEffect;
const $9f8118feb50d8e8d$var$useSafeInsertionEffect = $9f8118feb50d8e8d$var$useInsertionEffect || ((fn)=>fn());
function $9f8118feb50d8e8d$export$7f54fc3180508a52(callback) {
    const ref = $7fPBF.useRef(()=>{});
    $9f8118feb50d8e8d$var$useSafeInsertionEffect(()=>{
        ref.current = callback;
    });
    return $7fPBF.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return ref.current == null ? void 0 : ref.current(...args);
    }, []);
}
function $9f8118feb50d8e8d$export$709046525cac3019(index, cols, prevRow) {
    return Math.floor(index / cols) !== prevRow;
}
function $9f8118feb50d8e8d$export$75effb89758ec596(listRef, index) {
    return index < 0 || index >= listRef.current.length;
}
function $9f8118feb50d8e8d$export$53f691ee0acc6058(listRef, disabledIndices) {
    return $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
        disabledIndices: disabledIndices
    });
}
function $9f8118feb50d8e8d$export$b585558af466e926(listRef, disabledIndices) {
    return $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
        decrement: true,
        startingIndex: listRef.current.length,
        disabledIndices: disabledIndices
    });
}
function $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, _temp) {
    let { startingIndex: startingIndex = -1, decrement: decrement = false, disabledIndices: disabledIndices, amount: amount = 1 } = _temp === void 0 ? {} : _temp;
    let index = startingIndex;
    do index += decrement ? -amount : amount;
    while (index >= 0 && index <= listRef.current.length - 1 && $9f8118feb50d8e8d$export$446656ed0410fd9(listRef, index, disabledIndices));
    return index;
}
function $9f8118feb50d8e8d$export$342fcce33a2688bc(listRef, _ref) {
    let { event: event, orientation: orientation, loop: loop, rtl: rtl, cols: cols, disabledIndices: disabledIndices, minIndex: minIndex, maxIndex: maxIndex, prevIndex: prevIndex, stopEvent: stop = false } = _ref;
    let nextIndex = prevIndex;
    if (event.key === $9f8118feb50d8e8d$var$ARROW_UP) {
        stop && $9f8118feb50d8e8d$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = maxIndex;
        else {
            nextIndex = $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: nextIndex,
                amount: cols,
                decrement: true,
                disabledIndices: disabledIndices
            });
            if (loop && (prevIndex - cols < minIndex || nextIndex < 0)) {
                const col = prevIndex % cols;
                const maxCol = maxIndex % cols;
                const offset = maxIndex - (maxCol - col);
                if (maxCol === col) nextIndex = maxIndex;
                else nextIndex = maxCol > col ? offset : offset - cols;
            }
        }
        if ($9f8118feb50d8e8d$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    if (event.key === $9f8118feb50d8e8d$var$ARROW_DOWN) {
        stop && $9f8118feb50d8e8d$export$7ae4cd3a66c1e050(event);
        if (prevIndex === -1) nextIndex = minIndex;
        else {
            nextIndex = $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex,
                amount: cols,
                disabledIndices: disabledIndices
            });
            if (loop && prevIndex + cols > maxIndex) nextIndex = $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex % cols - cols,
                amount: cols,
                disabledIndices: disabledIndices
            });
        }
        if ($9f8118feb50d8e8d$export$75effb89758ec596(listRef, nextIndex)) nextIndex = prevIndex;
    }
    // Remains on the same row/column.
    if (orientation === 'both') {
        const prevRow = (0, $91f1cb25f4ca20c6$export$a3fe094919f356fd)(prevIndex / cols);
        if (event.key === (rtl ? $9f8118feb50d8e8d$var$ARROW_LEFT : $9f8118feb50d8e8d$var$ARROW_RIGHT)) {
            stop && $9f8118feb50d8e8d$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== cols - 1) {
                nextIndex = $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    disabledIndices: disabledIndices
                });
                if (loop && $9f8118feb50d8e8d$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex - prevIndex % cols - 1,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            if ($9f8118feb50d8e8d$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        if (event.key === (rtl ? $9f8118feb50d8e8d$var$ARROW_RIGHT : $9f8118feb50d8e8d$var$ARROW_LEFT)) {
            stop && $9f8118feb50d8e8d$export$7ae4cd3a66c1e050(event);
            if (prevIndex % cols !== 0) {
                nextIndex = $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex,
                    decrement: true,
                    disabledIndices: disabledIndices
                });
                if (loop && $9f8118feb50d8e8d$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
                    startingIndex: prevIndex + (cols - prevIndex % cols),
                    decrement: true,
                    disabledIndices: disabledIndices
                });
            } else if (loop) nextIndex = $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex + (cols - prevIndex % cols),
                decrement: true,
                disabledIndices: disabledIndices
            });
            if ($9f8118feb50d8e8d$export$709046525cac3019(nextIndex, cols, prevRow)) nextIndex = prevIndex;
        }
        const lastRow = (0, $91f1cb25f4ca20c6$export$a3fe094919f356fd)(maxIndex / cols) === prevRow;
        if ($9f8118feb50d8e8d$export$75effb89758ec596(listRef, nextIndex)) {
            if (loop && lastRow) nextIndex = event.key === (rtl ? $9f8118feb50d8e8d$var$ARROW_RIGHT : $9f8118feb50d8e8d$var$ARROW_LEFT) ? maxIndex : $9f8118feb50d8e8d$export$3fc3ea4a67cf714(listRef, {
                startingIndex: prevIndex - prevIndex % cols - 1,
                disabledIndices: disabledIndices
            });
            else nextIndex = prevIndex;
        }
    }
    return nextIndex;
}
/** For each cell index, gets the item index that occupies that cell */ function $9f8118feb50d8e8d$export$5334c96856356f08(sizes, cols, dense) {
    const cellMap = [];
    let startIndex = 0;
    sizes.forEach((_ref2, index)=>{
        let { width: width, height: height } = _ref2;
        let itemPlaced = false;
        if (dense) startIndex = 0;
        while(!itemPlaced){
            const targetCells = [];
            for(let i = 0; i < width; i++)for(let j = 0; j < height; j++)targetCells.push(startIndex + i + j * cols);
            if (startIndex % cols + width <= cols && targetCells.every((cell)=>cellMap[cell] == null)) {
                targetCells.forEach((cell)=>{
                    cellMap[cell] = index;
                });
                itemPlaced = true;
            } else startIndex++;
        }
    });
    // convert into a non-sparse array
    return [
        ...cellMap
    ];
}
/** Gets cell index of an item's corner or -1 when index is -1. */ function $9f8118feb50d8e8d$export$dab2b2ce7761f8e4(index, sizes, cellMap, cols, corner) {
    if (index === -1) return -1;
    const firstCellIndex = cellMap.indexOf(index);
    const sizeItem = sizes[index];
    switch(corner){
        case 'tl':
            return firstCellIndex;
        case 'tr':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + sizeItem.width - 1;
        case 'bl':
            if (!sizeItem) return firstCellIndex;
            return firstCellIndex + (sizeItem.height - 1) * cols;
        case 'br':
            return cellMap.lastIndexOf(index);
    }
}
/** Gets all cell indices that correspond to the specified indices */ function $9f8118feb50d8e8d$export$50d8709b2ccc23f9(indices, cellMap) {
    return cellMap.flatMap((index, cellIndex)=>indices.includes(index) ? [
            cellIndex
        ] : []);
}
function $9f8118feb50d8e8d$export$446656ed0410fd9(listRef, index, disabledIndices) {
    if (typeof disabledIndices === 'function') return disabledIndices(index);
    else if (disabledIndices) return disabledIndices.includes(index);
    const element = listRef.current[index];
    return element == null || element.hasAttribute('disabled') || element.getAttribute('aria-disabled') === 'true';
}
const $9f8118feb50d8e8d$export$6324a2bbae6a332f = ()=>({
        getShadowRoot: true,
        displayCheck: // JSDOM does not support the `tabbable` library. To solve this we can
        // check if `ResizeObserver` is a real function (not polyfilled), which
        // determines if the current environment is JSDOM-like.
        typeof ResizeObserver === 'function' && ResizeObserver.toString().includes('[native code]') ? 'full' : 'none'
    });
function $9f8118feb50d8e8d$var$getTabbableIn(container, dir) {
    const list = (0, $fef840927e49d4b7$export$17100aea90429aa7)(container, $9f8118feb50d8e8d$export$6324a2bbae6a332f());
    const len = list.length;
    if (len === 0) return;
    const active = $9f8118feb50d8e8d$export$da980962bd2147a4($9f8118feb50d8e8d$export$f65ca476c09acec0(container));
    const index = list.indexOf(active);
    const nextIndex = index === -1 ? dir === 1 ? 0 : len - 1 : index + dir;
    return list[nextIndex];
}
function $9f8118feb50d8e8d$export$28f33206776129a7(referenceElement) {
    return $9f8118feb50d8e8d$var$getTabbableIn($9f8118feb50d8e8d$export$f65ca476c09acec0(referenceElement).body, 1) || referenceElement;
}
function $9f8118feb50d8e8d$export$2e5518c3303f364a(referenceElement) {
    return $9f8118feb50d8e8d$var$getTabbableIn($9f8118feb50d8e8d$export$f65ca476c09acec0(referenceElement).body, -1) || referenceElement;
}
function $9f8118feb50d8e8d$export$6e0c4e272f3faa2(event, container) {
    const containerElement = container || event.currentTarget;
    const relatedTarget = event.relatedTarget;
    return !relatedTarget || !$9f8118feb50d8e8d$export$2344b14b097df817(containerElement, relatedTarget);
}
function $9f8118feb50d8e8d$export$3995dd353b80da11(container) {
    const tabbableElements = (0, $fef840927e49d4b7$export$17100aea90429aa7)(container, $9f8118feb50d8e8d$export$6324a2bbae6a332f());
    tabbableElements.forEach((element)=>{
        element.dataset.tabindex = element.getAttribute('tabindex') || '';
        element.setAttribute('tabindex', '-1');
    });
}
function $9f8118feb50d8e8d$export$a65f4028abb17f36(container) {
    const elements = container.querySelectorAll('[data-tabindex]');
    elements.forEach((element)=>{
        const tabindex = element.dataset.tabindex;
        delete element.dataset.tabindex;
        if (tabindex) element.setAttribute('tabindex', tabindex);
        else element.removeAttribute('tabindex');
    });
}






var $fw0lo = parcelRequire("fw0lo");


/**
 * Merges an array of refs into a single memoized callback ref or `null`.
 * @see https://floating-ui.com/docs/react-utils#usemergerefs
 */ function $8762903b8fe68977$export$74665b213cb5c4cf(refs) {
    const cleanupRef = $7fPBF.useRef(undefined);
    const refEffect = $7fPBF.useCallback((instance)=>{
        const cleanups = refs.map((ref)=>{
            if (ref == null) return;
            if (typeof ref === 'function') {
                const refCallback = ref;
                const refCleanup = refCallback(instance);
                return typeof refCleanup === 'function' ? refCleanup : ()=>{
                    refCallback(null);
                };
            }
            ref.current = instance;
            return ()=>{
                ref.current = null;
            };
        });
        return ()=>{
            cleanups.forEach((refCleanup)=>refCleanup == null ? void 0 : refCleanup());
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
    return $7fPBF.useMemo(()=>{
        if (refs.every((ref)=>ref == null)) return null;
        return (value)=>{
            if (cleanupRef.current) {
                cleanupRef.current();
                cleanupRef.current = undefined;
            }
            if (value != null) cleanupRef.current = refEffect(value);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
function $8762903b8fe68977$var$sortByDocumentPosition(a, b) {
    const position = a.compareDocumentPosition(b);
    if (position & Node.DOCUMENT_POSITION_FOLLOWING || position & Node.DOCUMENT_POSITION_CONTAINED_BY) return -1;
    if (position & Node.DOCUMENT_POSITION_PRECEDING || position & Node.DOCUMENT_POSITION_CONTAINS) return 1;
    return 0;
}
const $8762903b8fe68977$var$FloatingListContext = /*#__PURE__*/ $7fPBF.createContext({
    register: ()=>{},
    unregister: ()=>{},
    map: /*#__PURE__*/ new Map(),
    elementsRef: {
        current: []
    }
});
/**
 * Provides context for a list of items within the floating element.
 * @see https://floating-ui.com/docs/FloatingList
 */ function $8762903b8fe68977$export$ffe15b0e64951704(props) {
    const { children: children, elementsRef: elementsRef, labelsRef: labelsRef } = props;
    const [nodes, setNodes] = $7fPBF.useState(()=>new Set());
    const register = $7fPBF.useCallback((node)=>{
        setNodes((prevSet)=>new Set(prevSet).add(node));
    }, []);
    const unregister = $7fPBF.useCallback((node)=>{
        setNodes((prevSet)=>{
            const set = new Set(prevSet);
            set.delete(node);
            return set;
        });
    }, []);
    const map = $7fPBF.useMemo(()=>{
        const newMap = new Map();
        const sortedNodes = Array.from(nodes.keys()).sort($8762903b8fe68977$var$sortByDocumentPosition);
        sortedNodes.forEach((node, index)=>{
            newMap.set(node, index);
        });
        return newMap;
    }, [
        nodes
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$FloatingListContext.Provider, {
        value: $7fPBF.useMemo(()=>({
                register: register,
                unregister: unregister,
                map: map,
                elementsRef: elementsRef,
                labelsRef: labelsRef
            }), [
            register,
            unregister,
            map,
            elementsRef,
            labelsRef
        ]),
        children: children
    });
}
/**
 * Used to register a list item and its index (DOM position) in the
 * `FloatingList`.
 * @see https://floating-ui.com/docs/FloatingList#uselistitem
 */ function $8762903b8fe68977$export$dcdc7ff5149f7d1a(props) {
    if (props === void 0) props = {};
    const { label: label } = props;
    const { register: register, unregister: unregister, map: map, elementsRef: elementsRef, labelsRef: labelsRef } = $7fPBF.useContext($8762903b8fe68977$var$FloatingListContext);
    const [index, setIndex] = $7fPBF.useState(null);
    const componentRef = $7fPBF.useRef(null);
    const ref = $7fPBF.useCallback((node)=>{
        componentRef.current = node;
        if (index !== null) {
            elementsRef.current[index] = node;
            if (labelsRef) {
                var _node$textContent;
                const isLabelDefined = label !== undefined;
                labelsRef.current[index] = isLabelDefined ? label : (_node$textContent = node == null ? void 0 : node.textContent) != null ? _node$textContent : null;
            }
        }
    }, [
        index,
        elementsRef,
        labelsRef,
        label
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        const node = componentRef.current;
        if (node) {
            register(node);
            return ()=>{
                unregister(node);
            };
        }
    }, [
        register,
        unregister
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        const index = componentRef.current ? map.get(componentRef.current) : null;
        if (index != null) setIndex(index);
    }, [
        map
    ]);
    return $7fPBF.useMemo(()=>({
            ref: ref,
            index: index == null ? -1 : index
        }), [
        index,
        ref
    ]);
}
const $8762903b8fe68977$var$FOCUSABLE_ATTRIBUTE = 'data-floating-ui-focusable';
const $8762903b8fe68977$var$ACTIVE_KEY = 'active';
const $8762903b8fe68977$var$SELECTED_KEY = 'selected';
const $8762903b8fe68977$var$ARROW_LEFT = 'ArrowLeft';
const $8762903b8fe68977$var$ARROW_RIGHT = 'ArrowRight';
const $8762903b8fe68977$var$ARROW_UP = 'ArrowUp';
const $8762903b8fe68977$var$ARROW_DOWN = 'ArrowDown';
function $8762903b8fe68977$var$renderJsx(render, computedProps) {
    if (typeof render === 'function') return render(computedProps);
    if (render) return /*#__PURE__*/ $7fPBF.cloneElement(render, computedProps);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, computedProps));
}
const $8762903b8fe68977$var$CompositeContext = /*#__PURE__*/ $7fPBF.createContext({
    activeIndex: 0,
    onNavigate: ()=>{}
});
const $8762903b8fe68977$var$horizontalKeys = [
    $8762903b8fe68977$var$ARROW_LEFT,
    $8762903b8fe68977$var$ARROW_RIGHT
];
const $8762903b8fe68977$var$verticalKeys = [
    $8762903b8fe68977$var$ARROW_UP,
    $8762903b8fe68977$var$ARROW_DOWN
];
const $8762903b8fe68977$var$allKeys = [
    ...$8762903b8fe68977$var$horizontalKeys,
    ...$8762903b8fe68977$var$verticalKeys
];
/**
 * Creates a single tab stop whose items are navigated by arrow keys, which
 * provides list navigation outside of floating element contexts.
 *
 * This is useful to enable navigation of a list of items that aren’t part of a
 * floating element. A menubar is an example of a composite, with each reference
 * element being an item.
 * @see https://floating-ui.com/docs/Composite
 */ const $8762903b8fe68977$export$43586241d9db0c6d = /*#__PURE__*/ $7fPBF.forwardRef(function Composite(props, forwardedRef) {
    const { render: render, orientation: orientation = 'both', loop: loop = true, rtl: rtl = false, cols: cols = 1, disabledIndices: disabledIndices, activeIndex: externalActiveIndex, onNavigate: externalSetActiveIndex, itemSizes: itemSizes, dense: dense = false } = props, domProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "render",
        "orientation",
        "loop",
        "rtl",
        "cols",
        "disabledIndices",
        "activeIndex",
        "onNavigate",
        "itemSizes",
        "dense"
    ]);
    const [internalActiveIndex, internalSetActiveIndex] = $7fPBF.useState(0);
    const activeIndex = externalActiveIndex != null ? externalActiveIndex : internalActiveIndex;
    const onNavigate = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(externalSetActiveIndex != null ? externalSetActiveIndex : internalSetActiveIndex);
    const elementsRef = $7fPBF.useRef([]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const contextValue = $7fPBF.useMemo(()=>({
            activeIndex: activeIndex,
            onNavigate: onNavigate
        }), [
        activeIndex,
        onNavigate
    ]);
    const isGrid = cols > 1;
    function handleKeyDown(event) {
        if (!$8762903b8fe68977$var$allKeys.includes(event.key)) return;
        let nextIndex = activeIndex;
        const minIndex = (0, $9f8118feb50d8e8d$export$53f691ee0acc6058)(elementsRef, disabledIndices);
        const maxIndex = (0, $9f8118feb50d8e8d$export$b585558af466e926)(elementsRef, disabledIndices);
        const horizontalEndKey = rtl ? $8762903b8fe68977$var$ARROW_LEFT : $8762903b8fe68977$var$ARROW_RIGHT;
        const horizontalStartKey = rtl ? $8762903b8fe68977$var$ARROW_RIGHT : $8762903b8fe68977$var$ARROW_LEFT;
        if (isGrid) {
            const sizes = itemSizes || Array.from({
                length: elementsRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $9f8118feb50d8e8d$export$5334c96856356f08)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $9f8118feb50d8e8d$export$446656ed0410fd9)(elementsRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $9f8118feb50d8e8d$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const maybeNextIndex = cellMap[(0, $9f8118feb50d8e8d$export$342fcce33a2688bc)({
                current: cellMap.map((itemIndex)=>itemIndex ? elementsRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $9f8118feb50d8e8d$export$50d8709b2ccc23f9)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || elementsRef.current.map((_, index)=>(0, $9f8118feb50d8e8d$export$446656ed0410fd9)(elementsRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $9f8118feb50d8e8d$export$dab2b2ce7761f8e4)(activeIndex > maxIndex ? minIndex : activeIndex, sizes, cellMap, cols, // use a corner matching the edge closest to the direction we're
                // moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $8762903b8fe68977$var$ARROW_DOWN ? 'bl' : event.key === horizontalEndKey ? 'tr' : 'tl')
            })];
            if (maybeNextIndex != null) nextIndex = maybeNextIndex;
        }
        const toEndKeys = {
            horizontal: [
                horizontalEndKey
            ],
            vertical: [
                $8762903b8fe68977$var$ARROW_DOWN
            ],
            both: [
                horizontalEndKey,
                $8762903b8fe68977$var$ARROW_DOWN
            ]
        }[orientation];
        const toStartKeys = {
            horizontal: [
                horizontalStartKey
            ],
            vertical: [
                $8762903b8fe68977$var$ARROW_UP
            ],
            both: [
                horizontalStartKey,
                $8762903b8fe68977$var$ARROW_UP
            ]
        }[orientation];
        const preventedKeys = isGrid ? $8762903b8fe68977$var$allKeys : ({
            horizontal: $8762903b8fe68977$var$horizontalKeys,
            vertical: $8762903b8fe68977$var$verticalKeys,
            both: $8762903b8fe68977$var$allKeys
        })[orientation];
        if (nextIndex === activeIndex && [
            ...toEndKeys,
            ...toStartKeys
        ].includes(event.key)) {
            if (loop && nextIndex === maxIndex && toEndKeys.includes(event.key)) nextIndex = minIndex;
            else if (loop && nextIndex === minIndex && toStartKeys.includes(event.key)) nextIndex = maxIndex;
            else nextIndex = (0, $9f8118feb50d8e8d$export$3fc3ea4a67cf714)(elementsRef, {
                startingIndex: nextIndex,
                decrement: toStartKeys.includes(event.key),
                disabledIndices: disabledIndices
            });
        }
        if (nextIndex !== activeIndex && !(0, $9f8118feb50d8e8d$export$75effb89758ec596)(elementsRef, nextIndex)) {
            var _elementsRef$current$;
            event.stopPropagation();
            if (preventedKeys.includes(event.key)) event.preventDefault();
            onNavigate(nextIndex);
            (_elementsRef$current$ = elementsRef.current[nextIndex]) == null || _elementsRef$current$.focus();
        }
    }
    const computedProps = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, domProps, renderElementProps), {
        ref: forwardedRef,
        'aria-orientation': orientation === 'both' ? undefined : orientation,
        onKeyDown (e) {
            domProps.onKeyDown == null || domProps.onKeyDown(e);
            renderElementProps.onKeyDown == null || renderElementProps.onKeyDown(e);
            handleKeyDown(e);
        }
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$CompositeContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$export$ffe15b0e64951704, {
            elementsRef: elementsRef,
            children: $8762903b8fe68977$var$renderJsx(render, computedProps)
        })
    });
});
/**
 * @see https://floating-ui.com/docs/Composite
 */ const $8762903b8fe68977$export$ef1ef7a3a43ace8e = /*#__PURE__*/ $7fPBF.forwardRef(function CompositeItem(props, forwardedRef) {
    const { render: render } = props, domProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "render"
    ]);
    const renderElementProps = render && typeof render !== 'function' ? render.props : {};
    const { activeIndex: activeIndex, onNavigate: onNavigate } = $7fPBF.useContext($8762903b8fe68977$var$CompositeContext);
    const { ref: ref, index: index } = $8762903b8fe68977$export$dcdc7ff5149f7d1a();
    const mergedRef = $8762903b8fe68977$export$74665b213cb5c4cf([
        ref,
        forwardedRef,
        renderElementProps.ref
    ]);
    const isActive = activeIndex === index;
    const computedProps = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, domProps, renderElementProps), {
        ref: mergedRef,
        tabIndex: isActive ? 0 : -1,
        'data-active': isActive ? '' : undefined,
        onFocus (e) {
            domProps.onFocus == null || domProps.onFocus(e);
            renderElementProps.onFocus == null || renderElementProps.onFocus(e);
            onNavigate(index);
        }
    });
    return $8762903b8fe68977$var$renderJsx(render, computedProps);
});
// https://github.com/mui/material-ui/issues/41190#issuecomment-2040873379
const $8762903b8fe68977$var$SafeReact = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $7fPBF);
let $8762903b8fe68977$var$serverHandoffComplete = false;
let $8762903b8fe68977$var$count = 0;
const $8762903b8fe68977$var$genId = ()=>// on <React 18
    "floating-ui-" + Math.random().toString(36).slice(2, 6) + $8762903b8fe68977$var$count++;
function $8762903b8fe68977$var$useFloatingId() {
    const [id, setId] = $7fPBF.useState(()=>$8762903b8fe68977$var$serverHandoffComplete ? $8762903b8fe68977$var$genId() : undefined);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (id == null) setId($8762903b8fe68977$var$genId());
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    $7fPBF.useEffect(()=>{
        $8762903b8fe68977$var$serverHandoffComplete = true;
    }, []);
    return id;
}
const $8762903b8fe68977$var$useReactId = $8762903b8fe68977$var$SafeReact.useId;
/**
 * Uses React 18's built-in `useId()` when available, or falls back to a
 * slightly less performant (requiring a double render) implementation for
 * earlier React versions.
 * @see https://floating-ui.com/docs/react-utils#useid
 */ const $8762903b8fe68977$export$f680877a34711e37 = $8762903b8fe68977$var$useReactId || $8762903b8fe68977$var$useFloatingId;
let $8762903b8fe68977$var$devMessageSet;
function $8762903b8fe68977$var$warn() {
    var _devMessageSet;
    for(var _len = arguments.length, messages = new Array(_len), _key = 0; _key < _len; _key++)messages[_key] = arguments[_key];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet = $8762903b8fe68977$var$devMessageSet) != null && _devMessageSet.has(message))) {
        var _devMessageSet2;
        (_devMessageSet2 = $8762903b8fe68977$var$devMessageSet) == null || _devMessageSet2.add(message);
        console.warn(message);
    }
}
function $8762903b8fe68977$var$error() {
    var _devMessageSet3;
    for(var _len2 = arguments.length, messages = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)messages[_key2] = arguments[_key2];
    const message = "Floating UI: " + messages.join(' ');
    if (!((_devMessageSet3 = $8762903b8fe68977$var$devMessageSet) != null && _devMessageSet3.has(message))) {
        var _devMessageSet4;
        (_devMessageSet4 = $8762903b8fe68977$var$devMessageSet) == null || _devMessageSet4.add(message);
        console.error(message);
    }
}
/**
 * Renders a pointing arrow triangle.
 * @see https://floating-ui.com/docs/FloatingArrow
 */ const $8762903b8fe68977$export$33511391554732bc = /*#__PURE__*/ $7fPBF.forwardRef(function FloatingArrow(props, ref) {
    const { context: { placement: placement, elements: { floating: floating }, middlewareData: { arrow: arrow, shift: shift } }, width: width = 14, height: height = 7, tipRadius: tipRadius = 0, strokeWidth: strokeWidth = 0, staticOffset: staticOffset, stroke: stroke, d: d, style: { transform: transform } = {} } = props, restStyle = (0, $8901fc92b5563702$export$71511d61b312f219)(props.style, [
        "transform"
    ]), rest = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "context",
        "width",
        "height",
        "tipRadius",
        "strokeWidth",
        "staticOffset",
        "stroke",
        "d",
        "style"
    ]);
    const clipPathId = $8762903b8fe68977$export$f680877a34711e37();
    const [isRTL, setIsRTL] = $7fPBF.useState(false);
    // https://github.com/floating-ui/floating-ui/issues/2932
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!floating) return;
        const isRTL = (0, $d2553f707975908a$export$3735103072e4a80)(floating).direction === 'rtl';
        if (isRTL) setIsRTL(true);
    }, [
        floating
    ]);
    if (!floating) return null;
    const [side, alignment] = placement.split('-');
    const isVerticalSide = side === 'top' || side === 'bottom';
    let computedStaticOffset = staticOffset;
    if (isVerticalSide && shift != null && shift.x || !isVerticalSide && shift != null && shift.y) computedStaticOffset = null;
    // Strokes must be double the border width, this ensures the stroke's width
    // works as you'd expect.
    const computedStrokeWidth = strokeWidth * 2;
    const halfStrokeWidth = computedStrokeWidth / 2;
    const svgX = width / 2 * (tipRadius / -8 + 1);
    const svgY = height / 2 * tipRadius / 4;
    const isCustomShape = !!d;
    const yOffsetProp = computedStaticOffset && alignment === 'end' ? 'bottom' : 'top';
    let xOffsetProp = computedStaticOffset && alignment === 'end' ? 'right' : 'left';
    if (computedStaticOffset && isRTL) xOffsetProp = alignment === 'end' ? 'left' : 'right';
    const arrowX = (arrow == null ? void 0 : arrow.x) != null ? computedStaticOffset || arrow.x : '';
    const arrowY = (arrow == null ? void 0 : arrow.y) != null ? computedStaticOffset || arrow.y : '';
    const dValue = d || 'M0,0' + (" H" + width) + (" L" + (width - svgX) + "," + (height - svgY)) + (" Q" + width / 2 + "," + height + " " + svgX + "," + (height - svgY)) + ' Z';
    const rotation = {
        top: isCustomShape ? 'rotate(180deg)' : '',
        left: isCustomShape ? 'rotate(90deg)' : 'rotate(-90deg)',
        bottom: isCustomShape ? '' : 'rotate(180deg)',
        right: isCustomShape ? 'rotate(-90deg)' : 'rotate(90deg)'
    }[side];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest), {
        "aria-hidden": true,
        ref: ref,
        width: isCustomShape ? width : width + computedStrokeWidth,
        height: width,
        viewBox: "0 0 " + width + " " + (height > width ? height : width),
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            position: 'absolute',
            pointerEvents: 'none',
            [xOffsetProp]: arrowX,
            [yOffsetProp]: arrowY,
            [side]: isVerticalSide || isCustomShape ? '100%' : "calc(100% - " + computedStrokeWidth / 2 + "px)",
            transform: [
                rotation,
                transform
            ].filter((t)=>!!t).join(' ')
        }, restStyle),
        children: [
            computedStrokeWidth > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                clipPath: "url(#" + clipPathId + ")",
                fill: "none",
                stroke: stroke,
                strokeWidth: computedStrokeWidth + (d ? 0 : 1),
                d: dValue
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                stroke: computedStrokeWidth && !d ? rest.fill : 'none',
                d: dValue
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("clipPath", {
                id: clipPathId,
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("rect", {
                    x: -halfStrokeWidth,
                    y: halfStrokeWidth * (isCustomShape ? -1 : 1),
                    width: width + computedStrokeWidth,
                    height: width
                })
            })
        ]
    }));
});
function $8762903b8fe68977$var$createEventEmitter() {
    const map = new Map();
    return {
        emit (event, data) {
            var _map$get;
            (_map$get = map.get(event)) == null || _map$get.forEach((listener)=>listener(data));
        },
        on (event, listener) {
            if (!map.has(event)) map.set(event, new Set());
            map.get(event).add(listener);
        },
        off (event, listener) {
            var _map$get2;
            (_map$get2 = map.get(event)) == null || _map$get2.delete(listener);
        }
    };
}
const $8762903b8fe68977$var$FloatingNodeContext = /*#__PURE__*/ $7fPBF.createContext(null);
const $8762903b8fe68977$var$FloatingTreeContext = /*#__PURE__*/ $7fPBF.createContext(null);
/**
 * Returns the parent node id for nested floating elements, if available.
 * Returns `null` for top-level floating elements.
 */ const $8762903b8fe68977$export$165209eae06d3488 = ()=>{
    var _React$useContext;
    return ((_React$useContext = $7fPBF.useContext($8762903b8fe68977$var$FloatingNodeContext)) == null ? void 0 : _React$useContext.id) || null;
};
/**
 * Returns the nearest floating tree context, if available.
 */ const $8762903b8fe68977$export$db0c2a7c7a2a4f69 = ()=>$7fPBF.useContext($8762903b8fe68977$var$FloatingTreeContext);
/**
 * Registers a node into the `FloatingTree`, returning its id.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $8762903b8fe68977$export$9b136e0e758a42f4(customParentId) {
    const id = $8762903b8fe68977$export$f680877a34711e37();
    const tree = $8762903b8fe68977$export$db0c2a7c7a2a4f69();
    const reactParentId = $8762903b8fe68977$export$165209eae06d3488();
    const parentId = customParentId || reactParentId;
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!id) return;
        const node = {
            id: id,
            parentId: parentId
        };
        tree == null || tree.addNode(node);
        return ()=>{
            tree == null || tree.removeNode(node);
        };
    }, [
        tree,
        id,
        parentId
    ]);
    return id;
}
/**
 * Provides parent node context for nested floating elements.
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $8762903b8fe68977$export$ca00a83b5b253862(props) {
    const { children: children, id: id } = props;
    const parentId = $8762903b8fe68977$export$165209eae06d3488();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$FloatingNodeContext.Provider, {
        value: $7fPBF.useMemo(()=>({
                id: id,
                parentId: parentId
            }), [
            id,
            parentId
        ]),
        children: children
    });
}
/**
 * Provides context for nested floating elements when they are not children of
 * each other on the DOM.
 * This is not necessary in all cases, except when there must be explicit communication between parent and child floating elements. It is necessary for:
 * - The `bubbles` option in the `useDismiss()` Hook
 * - Nested virtual list navigation
 * - Nested floating elements that each open on hover
 * - Custom communication between parent and child floating elements
 * @see https://floating-ui.com/docs/FloatingTree
 */ function $8762903b8fe68977$export$587b60129641c4c8(props) {
    const { children: children } = props;
    const nodesRef = $7fPBF.useRef([]);
    const addNode = $7fPBF.useCallback((node)=>{
        nodesRef.current = [
            ...nodesRef.current,
            node
        ];
    }, []);
    const removeNode = $7fPBF.useCallback((node)=>{
        nodesRef.current = nodesRef.current.filter((n)=>n !== node);
    }, []);
    const [events] = $7fPBF.useState(()=>$8762903b8fe68977$var$createEventEmitter());
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$FloatingTreeContext.Provider, {
        value: $7fPBF.useMemo(()=>({
                nodesRef: nodesRef,
                addNode: addNode,
                removeNode: removeNode,
                events: events
            }), [
            addNode,
            removeNode,
            events
        ]),
        children: children
    });
}
function $8762903b8fe68977$var$createAttribute(name) {
    return "data-floating-ui-" + name;
}
function $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef) {
    if (timeoutRef.current !== -1) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = -1;
    }
}
const $8762903b8fe68977$var$safePolygonIdentifier = /*#__PURE__*/ $8762903b8fe68977$var$createAttribute('safe-polygon');
function $8762903b8fe68977$var$getDelay(value, prop, pointerType) {
    if (pointerType && !(0, $9f8118feb50d8e8d$export$81cf264172d31e51)(pointerType)) return 0;
    if (typeof value === 'number') return value;
    if (typeof value === 'function') {
        const result = value();
        if (typeof result === 'number') return result;
        return result == null ? void 0 : result[prop];
    }
    return value == null ? void 0 : value[prop];
}
function $8762903b8fe68977$var$getRestMs(value) {
    if (typeof value === 'function') return value();
    return value;
}
/**
 * Opens the floating element while hovering over the reference element, like
 * CSS `:hover`.
 * @see https://floating-ui.com/docs/useHover
 */ function $8762903b8fe68977$export$ae780daf29e6d456(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, events: events, elements: elements } = context;
    const { enabled: enabled = true, delay: delay = 0, handleClose: handleClose = null, mouseOnly: mouseOnly = false, restMs: restMs = 0, move: move = true } = props;
    const tree = $8762903b8fe68977$export$db0c2a7c7a2a4f69();
    const parentId = $8762903b8fe68977$export$165209eae06d3488();
    const handleCloseRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(handleClose);
    const delayRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(delay);
    const openRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(open);
    const restMsRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(restMs);
    const pointerTypeRef = $7fPBF.useRef();
    const timeoutRef = $7fPBF.useRef(-1);
    const handlerRef = $7fPBF.useRef();
    const restTimeoutRef = $7fPBF.useRef(-1);
    const blockMouseMoveRef = $7fPBF.useRef(true);
    const performedPointerEventsMutationRef = $7fPBF.useRef(false);
    const unbindMouseMoveRef = $7fPBF.useRef(()=>{});
    const restTimeoutPendingRef = $7fPBF.useRef(false);
    const isHoverOpen = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(()=>{
        var _dataRef$current$open;
        const type = (_dataRef$current$open = dataRef.current.openEvent) == null ? void 0 : _dataRef$current$open.type;
        return (type == null ? void 0 : type.includes('mouse')) && type !== 'mousedown';
    });
    // When closing before opening, clear the delay timeouts to cancel it
    // from showing.
    $7fPBF.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { open: open } = _ref;
            if (!open) {
                $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef);
                $8762903b8fe68977$var$clearTimeoutIfSet(restTimeoutRef);
                blockMouseMoveRef.current = true;
                restTimeoutPendingRef.current = false;
            }
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        enabled,
        events
    ]);
    $7fPBF.useEffect(()=>{
        if (!enabled) return;
        if (!handleCloseRef.current) return;
        if (!open) return;
        function onLeave(event) {
            if (isHoverOpen()) onOpenChange(false, event, 'hover');
        }
        const html = (0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(elements.floating).documentElement;
        html.addEventListener('mouseleave', onLeave);
        return ()=>{
            html.removeEventListener('mouseleave', onLeave);
        };
    }, [
        elements.floating,
        open,
        onOpenChange,
        enabled,
        handleCloseRef,
        isHoverOpen
    ]);
    const closeWithDelay = $7fPBF.useCallback(function(event, runElseBranch, reason) {
        if (runElseBranch === void 0) runElseBranch = true;
        if (reason === void 0) reason = 'hover';
        const closeDelay = $8762903b8fe68977$var$getDelay(delayRef.current, 'close', pointerTypeRef.current);
        if (closeDelay && !handlerRef.current) {
            $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef);
            timeoutRef.current = window.setTimeout(()=>onOpenChange(false, event, reason), closeDelay);
        } else if (runElseBranch) {
            $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef);
            onOpenChange(false, event, reason);
        }
    }, [
        delayRef,
        onOpenChange
    ]);
    const cleanupMouseMoveHandler = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(()=>{
        unbindMouseMoveRef.current();
        handlerRef.current = undefined;
    });
    const clearPointerEvents = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(()=>{
        if (performedPointerEventsMutationRef.current) {
            const body = (0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(elements.floating).body;
            body.style.pointerEvents = '';
            body.removeAttribute($8762903b8fe68977$var$safePolygonIdentifier);
            performedPointerEventsMutationRef.current = false;
        }
    });
    const isClickLikeOpenEvent = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(()=>{
        return dataRef.current.openEvent ? [
            'click',
            'mousedown'
        ].includes(dataRef.current.openEvent.type) : false;
    });
    // Registering the mouse events on the reference directly to bypass React's
    // delegation system. If the cursor was on a disabled element and then entered
    // the reference (no gap), `mouseenter` doesn't fire in the delegation system.
    $7fPBF.useEffect(()=>{
        if (!enabled) return;
        function onReferenceMouseEnter(event) {
            $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef);
            blockMouseMoveRef.current = false;
            if (mouseOnly && !(0, $9f8118feb50d8e8d$export$81cf264172d31e51)(pointerTypeRef.current) || $8762903b8fe68977$var$getRestMs(restMsRef.current) > 0 && !$8762903b8fe68977$var$getDelay(delayRef.current, 'open')) return;
            const openDelay = $8762903b8fe68977$var$getDelay(delayRef.current, 'open', pointerTypeRef.current);
            if (openDelay) timeoutRef.current = window.setTimeout(()=>{
                if (!openRef.current) onOpenChange(true, event, 'hover');
            }, openDelay);
            else if (!open) onOpenChange(true, event, 'hover');
        }
        function onReferenceMouseLeave(event) {
            if (isClickLikeOpenEvent()) {
                clearPointerEvents();
                return;
            }
            unbindMouseMoveRef.current();
            const doc = (0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(elements.floating);
            $8762903b8fe68977$var$clearTimeoutIfSet(restTimeoutRef);
            restTimeoutPendingRef.current = false;
            if (handleCloseRef.current && dataRef.current.floatingContext) {
                // Prevent clearing `onScrollMouseLeave` timeout.
                if (!open) $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef);
                handlerRef.current = handleCloseRef.current((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, dataRef.current.floatingContext), {
                    tree: tree,
                    x: event.clientX,
                    y: event.clientY,
                    onClose () {
                        clearPointerEvents();
                        cleanupMouseMoveHandler();
                        if (!isClickLikeOpenEvent()) closeWithDelay(event, true, 'safe-polygon');
                    }
                }));
                const handler = handlerRef.current;
                doc.addEventListener('mousemove', handler);
                unbindMouseMoveRef.current = ()=>{
                    doc.removeEventListener('mousemove', handler);
                };
                return;
            }
            // Allow interactivity without `safePolygon` on touch devices. With a
            // pointer, a short close delay is an alternative, so it should work
            // consistently.
            const shouldClose = pointerTypeRef.current === 'touch' ? !(0, $9f8118feb50d8e8d$export$2344b14b097df817)(elements.floating, event.relatedTarget) : true;
            if (shouldClose) closeWithDelay(event);
        }
        // Ensure the floating element closes after scrolling even if the pointer
        // did not move.
        // https://github.com/floating-ui/floating-ui/discussions/1692
        function onScrollMouseLeave(event) {
            if (isClickLikeOpenEvent()) return;
            if (!dataRef.current.floatingContext) return;
            handleCloseRef.current == null || handleCloseRef.current((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, dataRef.current.floatingContext), {
                tree: tree,
                x: event.clientX,
                y: event.clientY,
                onClose () {
                    clearPointerEvents();
                    cleanupMouseMoveHandler();
                    if (!isClickLikeOpenEvent()) closeWithDelay(event);
                }
            }))(event);
        }
        function onFloatingMouseEnter() {
            $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef);
        }
        function onFloatingMouseLeave(event) {
            if (!isClickLikeOpenEvent()) closeWithDelay(event, false);
        }
        if ((0, $d2553f707975908a$export$45a5e7f76e0caa8d)(elements.domReference)) {
            const reference = elements.domReference;
            const floating = elements.floating;
            if (open) reference.addEventListener('mouseleave', onScrollMouseLeave);
            if (move) reference.addEventListener('mousemove', onReferenceMouseEnter, {
                once: true
            });
            reference.addEventListener('mouseenter', onReferenceMouseEnter);
            reference.addEventListener('mouseleave', onReferenceMouseLeave);
            if (floating) {
                floating.addEventListener('mouseleave', onScrollMouseLeave);
                floating.addEventListener('mouseenter', onFloatingMouseEnter);
                floating.addEventListener('mouseleave', onFloatingMouseLeave);
            }
            return ()=>{
                if (open) reference.removeEventListener('mouseleave', onScrollMouseLeave);
                if (move) reference.removeEventListener('mousemove', onReferenceMouseEnter);
                reference.removeEventListener('mouseenter', onReferenceMouseEnter);
                reference.removeEventListener('mouseleave', onReferenceMouseLeave);
                if (floating) {
                    floating.removeEventListener('mouseleave', onScrollMouseLeave);
                    floating.removeEventListener('mouseenter', onFloatingMouseEnter);
                    floating.removeEventListener('mouseleave', onFloatingMouseLeave);
                }
            };
        }
    }, [
        elements,
        enabled,
        context,
        mouseOnly,
        move,
        closeWithDelay,
        cleanupMouseMoveHandler,
        clearPointerEvents,
        onOpenChange,
        open,
        openRef,
        tree,
        delayRef,
        handleCloseRef,
        dataRef,
        isClickLikeOpenEvent,
        restMsRef
    ]);
    // Block pointer-events of every element other than the reference and floating
    // while the floating element is open and has a `handleClose` handler. Also
    // handles nested floating elements.
    // https://github.com/floating-ui/floating-ui/issues/1722
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        var _handleCloseRef$curre;
        if (!enabled) return;
        if (open && (_handleCloseRef$curre = handleCloseRef.current) != null && (_handleCloseRef$curre = _handleCloseRef$curre.__options) != null && _handleCloseRef$curre.blockPointerEvents && isHoverOpen()) {
            performedPointerEventsMutationRef.current = true;
            const floatingEl = elements.floating;
            if ((0, $d2553f707975908a$export$45a5e7f76e0caa8d)(elements.domReference) && floatingEl) {
                var _tree$nodesRef$curren;
                const body = (0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(elements.floating).body;
                body.setAttribute($8762903b8fe68977$var$safePolygonIdentifier, '');
                const ref = elements.domReference;
                const parentFloating = tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null ? void 0 : _tree$nodesRef$curren.elements.floating;
                if (parentFloating) parentFloating.style.pointerEvents = '';
                body.style.pointerEvents = 'none';
                ref.style.pointerEvents = 'auto';
                floatingEl.style.pointerEvents = 'auto';
                return ()=>{
                    body.style.pointerEvents = '';
                    ref.style.pointerEvents = '';
                    floatingEl.style.pointerEvents = '';
                };
            }
        }
    }, [
        enabled,
        open,
        parentId,
        elements,
        tree,
        handleCloseRef,
        isHoverOpen
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!open) {
            pointerTypeRef.current = undefined;
            restTimeoutPendingRef.current = false;
            cleanupMouseMoveHandler();
            clearPointerEvents();
        }
    }, [
        open,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            cleanupMouseMoveHandler();
            $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef);
            $8762903b8fe68977$var$clearTimeoutIfSet(restTimeoutRef);
            clearPointerEvents();
        };
    }, [
        enabled,
        elements.domReference,
        cleanupMouseMoveHandler,
        clearPointerEvents
    ]);
    const reference = $7fPBF.useMemo(()=>{
        function setPointerRef(event) {
            pointerTypeRef.current = event.pointerType;
        }
        return {
            onPointerDown: setPointerRef,
            onPointerEnter: setPointerRef,
            onMouseMove (event) {
                const { nativeEvent: nativeEvent } = event;
                function handleMouseMove() {
                    if (!blockMouseMoveRef.current && !openRef.current) onOpenChange(true, nativeEvent, 'hover');
                }
                if (mouseOnly && !(0, $9f8118feb50d8e8d$export$81cf264172d31e51)(pointerTypeRef.current)) return;
                if (open || $8762903b8fe68977$var$getRestMs(restMsRef.current) === 0) return;
                // Ignore insignificant movements to account for tremors.
                if (restTimeoutPendingRef.current && event.movementX ** 2 + event.movementY ** 2 < 2) return;
                $8762903b8fe68977$var$clearTimeoutIfSet(restTimeoutRef);
                if (pointerTypeRef.current === 'touch') handleMouseMove();
                else {
                    restTimeoutPendingRef.current = true;
                    restTimeoutRef.current = window.setTimeout(handleMouseMove, $8762903b8fe68977$var$getRestMs(restMsRef.current));
                }
            }
        };
    }, [
        mouseOnly,
        onOpenChange,
        open,
        openRef,
        restMsRef
    ]);
    return $7fPBF.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $8762903b8fe68977$var$NOOP = ()=>{};
const $8762903b8fe68977$var$FloatingDelayGroupContext = /*#__PURE__*/ $7fPBF.createContext({
    delay: 0,
    initialDelay: 0,
    timeoutMs: 0,
    currentId: null,
    setCurrentId: $8762903b8fe68977$var$NOOP,
    setState: $8762903b8fe68977$var$NOOP,
    isInstantPhase: false
});
/**
 * @deprecated
 * Use the return value of `useDelayGroup()` instead.
 */ const $8762903b8fe68977$export$e2411914b150383d = ()=>$7fPBF.useContext($8762903b8fe68977$var$FloatingDelayGroupContext);
/**
 * Provides context for a group of floating elements that should share a
 * `delay`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $8762903b8fe68977$export$718279509ff1e241(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const [state, setState] = $7fPBF.useReducer((prev, next)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prev, next), {
        delay: delay,
        timeoutMs: timeoutMs,
        initialDelay: delay,
        currentId: null,
        isInstantPhase: false
    });
    const initialCurrentIdRef = $7fPBF.useRef(null);
    const setCurrentId = $7fPBF.useCallback((currentId)=>{
        setState({
            currentId: currentId
        });
    }, []);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (state.currentId) {
            if (initialCurrentIdRef.current === null) initialCurrentIdRef.current = state.currentId;
            else if (!state.isInstantPhase) setState({
                isInstantPhase: true
            });
        } else {
            if (state.isInstantPhase) setState({
                isInstantPhase: false
            });
            initialCurrentIdRef.current = null;
        }
    }, [
        state.currentId,
        state.isInstantPhase
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$FloatingDelayGroupContext.Provider, {
        value: $7fPBF.useMemo(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                setState: setState,
                setCurrentId: setCurrentId
            }), [
            state,
            setCurrentId
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `FloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $8762903b8fe68977$export$560fc8be89c8b4a8(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { id: optionId, enabled: enabled = true } = options;
    const id = optionId != null ? optionId : floatingId;
    const groupContext = $8762903b8fe68977$export$e2411914b150383d();
    const { currentId: currentId, setCurrentId: setCurrentId, initialDelay: initialDelay, setState: setState, timeoutMs: timeoutMs } = groupContext;
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!currentId) return;
        setState({
            delay: {
                open: 1,
                close: $8762903b8fe68977$var$getDelay(initialDelay, 'close')
            }
        });
        if (currentId !== id) onOpenChange(false);
    }, [
        enabled,
        id,
        onOpenChange,
        setState,
        currentId,
        initialDelay
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        function unset() {
            onOpenChange(false);
            setState({
                delay: initialDelay,
                currentId: null
            });
        }
        if (!enabled) return;
        if (!currentId) return;
        if (!open && currentId === id) {
            if (timeoutMs) {
                const timeout = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeout);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        setState,
        currentId,
        id,
        onOpenChange,
        initialDelay,
        timeoutMs
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (setCurrentId === $8762903b8fe68977$var$NOOP || !open) return;
        setCurrentId(id);
    }, [
        enabled,
        open,
        setCurrentId,
        id
    ]);
    return groupContext;
}
const $8762903b8fe68977$var$NextFloatingDelayGroupContext = /*#__PURE__*/ $7fPBF.createContext({
    hasProvider: false,
    timeoutMs: 0,
    delayRef: {
        current: 0
    },
    initialDelayRef: {
        current: 0
    },
    timeoutIdRef: {
        current: -1
    },
    currentIdRef: {
        current: null
    },
    currentContextRef: {
        current: null
    }
});
/**
 * Experimental next version of `FloatingDelayGroup` to become the default
 * in the future. This component is not yet stable.
 * Provides context for a group of floating elements that should share a
 * `delay`. Unlike `FloatingDelayGroup`, `useNextDelayGroup` with this
 * component does not cause a re-render of unrelated consumers of the
 * context when the delay changes.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $8762903b8fe68977$export$e766ee16075bdf6b(props) {
    const { children: children, delay: delay, timeoutMs: timeoutMs = 0 } = props;
    const delayRef = $7fPBF.useRef(delay);
    const initialDelayRef = $7fPBF.useRef(delay);
    const currentIdRef = $7fPBF.useRef(null);
    const currentContextRef = $7fPBF.useRef(null);
    const timeoutIdRef = $7fPBF.useRef(-1);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$NextFloatingDelayGroupContext.Provider, {
        value: $7fPBF.useMemo(()=>({
                hasProvider: true,
                delayRef: delayRef,
                initialDelayRef: initialDelayRef,
                currentIdRef: currentIdRef,
                timeoutMs: timeoutMs,
                currentContextRef: currentContextRef,
                timeoutIdRef: timeoutIdRef
            }), [
            timeoutMs
        ]),
        children: children
    });
}
/**
 * Enables grouping when called inside a component that's a child of a
 * `NextFloatingDelayGroup`.
 * @see https://floating-ui.com/docs/FloatingDelayGroup
 */ function $8762903b8fe68977$export$f86f270cee1e809c(context, options) {
    if (options === void 0) options = {};
    const { open: open, onOpenChange: onOpenChange, floatingId: floatingId } = context;
    const { enabled: enabled = true } = options;
    const groupContext = $7fPBF.useContext($8762903b8fe68977$var$NextFloatingDelayGroupContext);
    const { currentIdRef: currentIdRef, delayRef: delayRef, timeoutMs: timeoutMs, initialDelayRef: initialDelayRef, currentContextRef: currentContextRef, hasProvider: hasProvider, timeoutIdRef: timeoutIdRef } = groupContext;
    const [isInstantPhase, setIsInstantPhase] = $7fPBF.useState(false);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        function unset() {
            var _currentContextRef$cu;
            setIsInstantPhase(false);
            (_currentContextRef$cu = currentContextRef.current) == null || _currentContextRef$cu.setIsInstantPhase(false);
            currentIdRef.current = null;
            currentContextRef.current = null;
            delayRef.current = initialDelayRef.current;
        }
        if (!enabled) return;
        if (!currentIdRef.current) return;
        if (!open && currentIdRef.current === floatingId) {
            setIsInstantPhase(false);
            if (timeoutMs) {
                timeoutIdRef.current = window.setTimeout(unset, timeoutMs);
                return ()=>{
                    clearTimeout(timeoutIdRef.current);
                };
            }
            unset();
        }
    }, [
        enabled,
        open,
        floatingId,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!open) return;
        const prevContext = currentContextRef.current;
        const prevId = currentIdRef.current;
        currentContextRef.current = {
            onOpenChange: onOpenChange,
            setIsInstantPhase: setIsInstantPhase
        };
        currentIdRef.current = floatingId;
        delayRef.current = {
            open: 0,
            close: $8762903b8fe68977$var$getDelay(initialDelayRef.current, 'close')
        };
        if (prevId !== null && prevId !== floatingId) {
            $8762903b8fe68977$var$clearTimeoutIfSet(timeoutIdRef);
            setIsInstantPhase(true);
            prevContext == null || prevContext.setIsInstantPhase(true);
            prevContext == null || prevContext.onOpenChange(false);
        } else {
            setIsInstantPhase(false);
            prevContext == null || prevContext.setIsInstantPhase(false);
        }
    }, [
        enabled,
        open,
        floatingId,
        onOpenChange,
        currentIdRef,
        delayRef,
        timeoutMs,
        initialDelayRef,
        currentContextRef,
        timeoutIdRef
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        return ()=>{
            currentContextRef.current = null;
        };
    }, [
        currentContextRef
    ]);
    return $7fPBF.useMemo(()=>({
            hasProvider: hasProvider,
            delayRef: delayRef,
            isInstantPhase: isInstantPhase
        }), [
        hasProvider,
        delayRef,
        isInstantPhase
    ]);
}
let $8762903b8fe68977$var$rafId = 0;
function $8762903b8fe68977$var$enqueueFocus(el, options) {
    if (options === void 0) options = {};
    const { preventScroll: preventScroll = false, cancelPrevious: cancelPrevious = true, sync: sync = false } = options;
    cancelPrevious && cancelAnimationFrame($8762903b8fe68977$var$rafId);
    const exec = ()=>el == null ? void 0 : el.focus({
            preventScroll: preventScroll
        });
    if (sync) exec();
    else $8762903b8fe68977$var$rafId = requestAnimationFrame(exec);
}
function $8762903b8fe68977$var$contains(parent, child) {
    if (!parent || !child) return false;
    const rootNode = child.getRootNode == null ? void 0 : child.getRootNode();
    // First, attempt with faster native method
    if (parent.contains(child)) return true;
    // then fallback to custom implementation with Shadow DOM support
    if (rootNode && (0, $d2553f707975908a$export$af51f0f06c0f328a)(rootNode)) {
        let next = child;
        while(next){
            if (parent === next) return true;
            // @ts-ignore
            next = next.parentNode || next.host;
        }
    }
    // Give up, the result is false
    return false;
}
function $8762903b8fe68977$var$getTarget(event) {
    if ('composedPath' in event) return event.composedPath()[0];
    // TS thinks `event` is of type never as it assumes all browsers support
    // `composedPath()`, but browsers without shadow DOM don't.
    return event.target;
}
function $8762903b8fe68977$var$getDocument(node) {
    return (node == null ? void 0 : node.ownerDocument) || document;
}
// Modified to add conditional `aria-hidden` support:
// https://github.com/theKashey/aria-hidden/blob/9220c8f4a4fd35f63bee5510a9f41a37264382d4/src/index.ts
const $8762903b8fe68977$var$counters = {
    inert: /*#__PURE__*/ new WeakMap(),
    'aria-hidden': /*#__PURE__*/ new WeakMap(),
    none: /*#__PURE__*/ new WeakMap()
};
function $8762903b8fe68977$var$getCounterMap(control) {
    if (control === 'inert') return $8762903b8fe68977$var$counters.inert;
    if (control === 'aria-hidden') return $8762903b8fe68977$var$counters['aria-hidden'];
    return $8762903b8fe68977$var$counters.none;
}
let $8762903b8fe68977$var$uncontrolledElementsSet = /*#__PURE__*/ new WeakSet();
let $8762903b8fe68977$var$markerMap = {};
let $8762903b8fe68977$var$lockCount$1 = 0;
const $8762903b8fe68977$var$supportsInert = ()=>typeof HTMLElement !== 'undefined' && 'inert' in HTMLElement.prototype;
function $8762903b8fe68977$var$unwrapHost(node) {
    if (!node) return null;
    return (0, $d2553f707975908a$export$af51f0f06c0f328a)(node) ? node.host : $8762903b8fe68977$var$unwrapHost(node.parentNode);
}
const $8762903b8fe68977$var$correctElements = (parent, targets)=>targets.map((target)=>{
        if (parent.contains(target)) return target;
        const correctedTarget = $8762903b8fe68977$var$unwrapHost(target);
        if (parent.contains(correctedTarget)) return correctedTarget;
        return null;
    }).filter((x)=>x != null);
function $8762903b8fe68977$var$applyAttributeToOthers(uncorrectedAvoidElements, body, ariaHidden, inert) {
    const markerName = 'data-floating-ui-inert';
    const controlAttribute = inert ? 'inert' : ariaHidden ? 'aria-hidden' : null;
    const avoidElements = $8762903b8fe68977$var$correctElements(body, uncorrectedAvoidElements);
    const elementsToKeep = new Set();
    const elementsToStop = new Set(avoidElements);
    const hiddenElements = [];
    if (!$8762903b8fe68977$var$markerMap[markerName]) $8762903b8fe68977$var$markerMap[markerName] = new WeakMap();
    const markerCounter = $8762903b8fe68977$var$markerMap[markerName];
    avoidElements.forEach(keep);
    deep(body);
    elementsToKeep.clear();
    function keep(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        el.parentNode && keep(el.parentNode);
    }
    function deep(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        [].forEach.call(parent.children, (node)=>{
            if ((0, $d2553f707975908a$export$651544f548703224)(node) === 'script') return;
            if (elementsToKeep.has(node)) deep(node);
            else {
                const attr = controlAttribute ? node.getAttribute(controlAttribute) : null;
                const alreadyHidden = attr !== null && attr !== 'false';
                const counterMap = $8762903b8fe68977$var$getCounterMap(controlAttribute);
                const counterValue = (counterMap.get(node) || 0) + 1;
                const markerValue = (markerCounter.get(node) || 0) + 1;
                counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenElements.push(node);
                if (counterValue === 1 && alreadyHidden) $8762903b8fe68977$var$uncontrolledElementsSet.add(node);
                if (markerValue === 1) node.setAttribute(markerName, '');
                if (!alreadyHidden && controlAttribute) node.setAttribute(controlAttribute, controlAttribute === 'inert' ? '' : 'true');
            }
        });
    }
    $8762903b8fe68977$var$lockCount$1++;
    return ()=>{
        hiddenElements.forEach((element)=>{
            const counterMap = $8762903b8fe68977$var$getCounterMap(controlAttribute);
            const currentCounterValue = counterMap.get(element) || 0;
            const counterValue = currentCounterValue - 1;
            const markerValue = (markerCounter.get(element) || 0) - 1;
            counterMap.set(element, counterValue);
            markerCounter.set(element, markerValue);
            if (!counterValue) {
                if (!$8762903b8fe68977$var$uncontrolledElementsSet.has(element) && controlAttribute) element.removeAttribute(controlAttribute);
                $8762903b8fe68977$var$uncontrolledElementsSet.delete(element);
            }
            if (!markerValue) element.removeAttribute(markerName);
        });
        $8762903b8fe68977$var$lockCount$1--;
        if (!$8762903b8fe68977$var$lockCount$1) {
            $8762903b8fe68977$var$counters.inert = new WeakMap();
            $8762903b8fe68977$var$counters['aria-hidden'] = new WeakMap();
            $8762903b8fe68977$var$counters.none = new WeakMap();
            $8762903b8fe68977$var$uncontrolledElementsSet = new WeakSet();
            $8762903b8fe68977$var$markerMap = {};
        }
    };
}
function $8762903b8fe68977$var$markOthers(avoidElements, ariaHidden, inert) {
    if (ariaHidden === void 0) ariaHidden = false;
    if (inert === void 0) inert = false;
    const body = $8762903b8fe68977$var$getDocument(avoidElements[0]).body;
    return $8762903b8fe68977$var$applyAttributeToOthers(avoidElements.concat(Array.from(body.querySelectorAll('[aria-live],[role="status"],output'))), body, ariaHidden, inert);
}
const $8762903b8fe68977$var$HIDDEN_STYLES = {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: '1px',
    margin: '-1px',
    overflow: 'hidden',
    padding: 0,
    position: 'fixed',
    whiteSpace: 'nowrap',
    width: '1px',
    top: 0,
    left: 0
};
const $8762903b8fe68977$var$FocusGuard = /*#__PURE__*/ $7fPBF.forwardRef(function FocusGuard(props, ref) {
    const [role, setRole] = $7fPBF.useState();
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if ((0, $9f8118feb50d8e8d$export$95df08bae54cb4df)()) // Unlike other screen readers such as NVDA and JAWS, the virtual cursor
        // on VoiceOver does trigger the onFocus event, so we can use the focus
        // trap element. On Safari, only buttons trigger the onFocus event.
        // NB: "group" role in the Sandbox no longer appears to work, must be a
        // button role.
        setRole('button');
    }, []);
    const restProps = {
        ref: ref,
        tabIndex: 0,
        role: // Role is only for VoiceOver
        role,
        'aria-hidden': role ? undefined : true,
        [$8762903b8fe68977$var$createAttribute('focus-guard')]: '',
        style: $8762903b8fe68977$var$HIDDEN_STYLES
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props, restProps));
});
const $8762903b8fe68977$var$HIDDEN_OWNER_STYLES = {
    clipPath: 'inset(50%)',
    position: 'fixed',
    top: 0,
    left: 0
};
const $8762903b8fe68977$var$PortalContext = /*#__PURE__*/ $7fPBF.createContext(null);
const $8762903b8fe68977$var$attr = /*#__PURE__*/ $8762903b8fe68977$var$createAttribute('portal');
/**
 * @see https://floating-ui.com/docs/FloatingPortal#usefloatingportalnode
 */ function $8762903b8fe68977$export$ac107512f3c5cca6(props) {
    if (props === void 0) props = {};
    const { id: id, root: root } = props;
    const uniqueId = $8762903b8fe68977$export$f680877a34711e37();
    const portalContext = $8762903b8fe68977$var$usePortalContext();
    const [portalNode, setPortalNode] = $7fPBF.useState(null);
    const portalNodeRef = $7fPBF.useRef(null);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        return ()=>{
            portalNode == null || portalNode.remove();
            // Allow the subsequent layout effects to create a new node on updates.
            // The portal node will still be cleaned up on unmount.
            // https://github.com/floating-ui/floating-ui/issues/2454
            queueMicrotask(()=>{
                portalNodeRef.current = null;
            });
        };
    }, [
        portalNode
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        // Wait for the uniqueId to be generated before creating the portal node in
        // React <18 (using `useFloatingId` instead of the native `useId`).
        // https://github.com/floating-ui/floating-ui/issues/2778
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        const existingIdRoot = id ? document.getElementById(id) : null;
        if (!existingIdRoot) return;
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($8762903b8fe68977$var$attr, '');
        existingIdRoot.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        uniqueId
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        // Wait for the root to exist before creating the portal node. The root must
        // be stored in state, not a ref, for this to work reactively.
        if (root === null) return;
        if (!uniqueId) return;
        if (portalNodeRef.current) return;
        let container = root || (portalContext == null ? void 0 : portalContext.portalNode);
        if (container && !(0, $d2553f707975908a$export$8ee0fc9ee280b4ee)(container)) container = container.current;
        container = container || document.body;
        let idWrapper = null;
        if (id) {
            idWrapper = document.createElement('div');
            idWrapper.id = id;
            container.appendChild(idWrapper);
        }
        const subRoot = document.createElement('div');
        subRoot.id = uniqueId;
        subRoot.setAttribute($8762903b8fe68977$var$attr, '');
        container = idWrapper || container;
        container.appendChild(subRoot);
        portalNodeRef.current = subRoot;
        setPortalNode(subRoot);
    }, [
        id,
        root,
        uniqueId,
        portalContext
    ]);
    return portalNode;
}
/**
 * Portals the floating element into a given container element — by default,
 * outside of the app root and into the body.
 * This is necessary to ensure the floating element can appear outside any
 * potential parent containers that cause clipping (such as `overflow: hidden`),
 * while retaining its location in the React tree.
 * @see https://floating-ui.com/docs/FloatingPortal
 */ function $8762903b8fe68977$export$31fa5d718fa2ac09(props) {
    const { children: children, id: id, root: root, preserveTabOrder: preserveTabOrder = true } = props;
    const portalNode = $8762903b8fe68977$export$ac107512f3c5cca6({
        id: id,
        root: root
    });
    const [focusManagerState, setFocusManagerState] = $7fPBF.useState(null);
    const beforeOutsideRef = $7fPBF.useRef(null);
    const afterOutsideRef = $7fPBF.useRef(null);
    const beforeInsideRef = $7fPBF.useRef(null);
    const afterInsideRef = $7fPBF.useRef(null);
    const modal = focusManagerState == null ? void 0 : focusManagerState.modal;
    const open = focusManagerState == null ? void 0 : focusManagerState.open;
    const shouldRenderGuards = // The FocusManager and therefore floating element are currently open/
    // rendered.
    !!focusManagerState && // Guards are only for non-modal focus management.
    !focusManagerState.modal && // Don't render if unmount is transitioning.
    focusManagerState.open && preserveTabOrder && !!(root || portalNode);
    // https://codesandbox.io/s/tabbable-portal-f4tng?file=/src/TabbablePortal.tsx
    $7fPBF.useEffect(()=>{
        if (!portalNode || !preserveTabOrder || modal) return;
        // Make sure elements inside the portal element are tabbable only when the
        // portal has already been focused, either by tabbing into a focus trap
        // element outside or using the mouse.
        function onFocus(event) {
            if (portalNode && (0, $9f8118feb50d8e8d$export$6e0c4e272f3faa2)(event)) {
                const focusing = event.type === 'focusin';
                const manageFocus = focusing ? (0, $9f8118feb50d8e8d$export$a65f4028abb17f36) : (0, $9f8118feb50d8e8d$export$3995dd353b80da11);
                manageFocus(portalNode);
            }
        }
        // Listen to the event on the capture phase so they run before the focus
        // trap elements onFocus prop is called.
        portalNode.addEventListener('focusin', onFocus, true);
        portalNode.addEventListener('focusout', onFocus, true);
        return ()=>{
            portalNode.removeEventListener('focusin', onFocus, true);
            portalNode.removeEventListener('focusout', onFocus, true);
        };
    }, [
        portalNode,
        preserveTabOrder,
        modal
    ]);
    $7fPBF.useEffect(()=>{
        if (!portalNode) return;
        if (open) return;
        (0, $9f8118feb50d8e8d$export$a65f4028abb17f36)(portalNode);
    }, [
        open,
        portalNode
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)($8762903b8fe68977$var$PortalContext.Provider, {
        value: $7fPBF.useMemo(()=>({
                preserveTabOrder: preserveTabOrder,
                beforeOutsideRef: beforeOutsideRef,
                afterOutsideRef: afterOutsideRef,
                beforeInsideRef: beforeInsideRef,
                afterInsideRef: afterInsideRef,
                portalNode: portalNode,
                setFocusManagerState: setFocusManagerState
            }), [
            preserveTabOrder,
            portalNode
        ]),
        children: [
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$FocusGuard, {
                "data-type": "outside",
                ref: beforeOutsideRef,
                onFocus: (event)=>{
                    if ((0, $9f8118feb50d8e8d$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _beforeInsideRef$curr;
                        (_beforeInsideRef$curr = beforeInsideRef.current) == null || _beforeInsideRef$curr.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const prevTabbable = (0, $9f8118feb50d8e8d$export$2e5518c3303f364a)(domReference);
                        prevTabbable == null || prevTabbable.focus();
                    }
                }
            }),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                "aria-owns": portalNode.id,
                style: $8762903b8fe68977$var$HIDDEN_OWNER_STYLES
            }),
            portalNode && /*#__PURE__*/ $fw0lo.createPortal(children, portalNode),
            shouldRenderGuards && portalNode && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$FocusGuard, {
                "data-type": "outside",
                ref: afterOutsideRef,
                onFocus: (event)=>{
                    if ((0, $9f8118feb50d8e8d$export$6e0c4e272f3faa2)(event, portalNode)) {
                        var _afterInsideRef$curre;
                        (_afterInsideRef$curre = afterInsideRef.current) == null || _afterInsideRef$curre.focus();
                    } else {
                        const domReference = focusManagerState ? focusManagerState.domReference : null;
                        const nextTabbable = (0, $9f8118feb50d8e8d$export$28f33206776129a7)(domReference);
                        nextTabbable == null || nextTabbable.focus();
                        (focusManagerState == null ? void 0 : focusManagerState.closeOnFocusOut) && (focusManagerState == null || focusManagerState.onOpenChange(false, event.nativeEvent, 'focus-out'));
                    }
                }
            })
        ]
    });
}
const $8762903b8fe68977$var$usePortalContext = ()=>$7fPBF.useContext($8762903b8fe68977$var$PortalContext);
function $8762903b8fe68977$var$useLiteMergeRefs(refs) {
    return $7fPBF.useMemo(()=>{
        return (value)=>{
            refs.forEach((ref)=>{
                if (ref) ref.current = value;
            });
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
}
const $8762903b8fe68977$var$LIST_LIMIT = 20;
let $8762903b8fe68977$var$previouslyFocusedElements = [];
function $8762903b8fe68977$var$clearDisconnectedPreviouslyFocusedElements() {
    $8762903b8fe68977$var$previouslyFocusedElements = $8762903b8fe68977$var$previouslyFocusedElements.filter((elementRef)=>{
        var _elementRef$deref;
        return (_elementRef$deref = elementRef.deref()) == null ? void 0 : _elementRef$deref.isConnected;
    });
}
function $8762903b8fe68977$var$addPreviouslyFocusedElement(element) {
    $8762903b8fe68977$var$clearDisconnectedPreviouslyFocusedElements();
    if (element && (0, $d2553f707975908a$export$651544f548703224)(element) !== 'body') {
        $8762903b8fe68977$var$previouslyFocusedElements.push(new WeakRef(element));
        if ($8762903b8fe68977$var$previouslyFocusedElements.length > $8762903b8fe68977$var$LIST_LIMIT) $8762903b8fe68977$var$previouslyFocusedElements = $8762903b8fe68977$var$previouslyFocusedElements.slice(-$8762903b8fe68977$var$LIST_LIMIT);
    }
}
function $8762903b8fe68977$var$getPreviouslyFocusedElement() {
    $8762903b8fe68977$var$clearDisconnectedPreviouslyFocusedElements();
    const elementRef = $8762903b8fe68977$var$previouslyFocusedElements[$8762903b8fe68977$var$previouslyFocusedElements.length - 1];
    return elementRef == null ? void 0 : elementRef.deref();
}
function $8762903b8fe68977$var$getFirstTabbableElement(container) {
    const tabbableOptions = (0, $9f8118feb50d8e8d$export$6324a2bbae6a332f)();
    if ((0, $fef840927e49d4b7$export$bebd5a1431fec25d)(container, tabbableOptions)) return container;
    return (0, $fef840927e49d4b7$export$17100aea90429aa7)(container, tabbableOptions)[0] || container;
}
function $8762903b8fe68977$var$handleTabIndex(floatingFocusElement, orderRef) {
    var _floatingFocusElement;
    if (!orderRef.current.includes('floating') && !((_floatingFocusElement = floatingFocusElement.getAttribute('role')) != null && _floatingFocusElement.includes('dialog'))) return;
    const options = (0, $9f8118feb50d8e8d$export$6324a2bbae6a332f)();
    const focusableElements = (0, $fef840927e49d4b7$export$ecc6d1fcdff4f700)(floatingFocusElement, options);
    const tabbableContent = focusableElements.filter((element)=>{
        const dataTabIndex = element.getAttribute('data-tabindex') || '';
        return (0, $fef840927e49d4b7$export$bebd5a1431fec25d)(element, options) || element.hasAttribute('data-tabindex') && !dataTabIndex.startsWith('-');
    });
    const tabIndex = floatingFocusElement.getAttribute('tabindex');
    if (orderRef.current.includes('floating') || tabbableContent.length === 0) {
        if (tabIndex !== '0') floatingFocusElement.setAttribute('tabindex', '0');
    } else if (tabIndex !== '-1' || floatingFocusElement.hasAttribute('data-tabindex') && floatingFocusElement.getAttribute('data-tabindex') !== '-1') {
        floatingFocusElement.setAttribute('tabindex', '-1');
        floatingFocusElement.setAttribute('data-tabindex', '-1');
    }
}
const $8762903b8fe68977$var$VisuallyHiddenDismiss = /*#__PURE__*/ $7fPBF.forwardRef(function VisuallyHiddenDismiss(props, ref) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        type: "button",
        ref: ref,
        tabIndex: -1,
        style: $8762903b8fe68977$var$HIDDEN_STYLES
    }));
});
/**
 * Provides focus management for the floating element.
 * @see https://floating-ui.com/docs/FloatingFocusManager
 */ function $8762903b8fe68977$export$8aeee49171ded61a(props) {
    const { context: context, children: children, disabled: disabled = false, order: order = [
        'content'
    ], guards: _guards = true, initialFocus: initialFocus = 0, returnFocus: returnFocus = true, restoreFocus: restoreFocus = false, modal: modal = true, visuallyHiddenDismiss: visuallyHiddenDismiss = false, closeOnFocusOut: closeOnFocusOut = true, outsideElementsInert: outsideElementsInert = false, getInsideElements: _getInsideElements = ()=>[] } = props;
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: { domReference: domReference, floating: floating } } = context;
    const getNodeId = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(()=>{
        var _dataRef$current$floa;
        return (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
    });
    const getInsideElements = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(_getInsideElements);
    const ignoreInitialFocus = typeof initialFocus === 'number' && initialFocus < 0;
    // If the reference is a combobox and is typeable (e.g. input/textarea),
    // there are different focus semantics. The guards should not be rendered, but
    // aria-hidden should be applied to all nodes still. Further, the visually
    // hidden dismiss button should only appear at the end of the list, not the
    // start.
    const isUntrappedTypeableCombobox = (0, $9f8118feb50d8e8d$export$259ba5ae38188551)(domReference) && ignoreInitialFocus;
    // Force the guards to be rendered if the `inert` attribute is not supported.
    const inertSupported = $8762903b8fe68977$var$supportsInert();
    const guards = inertSupported ? _guards : true;
    const useInert = !guards || inertSupported && outsideElementsInert;
    const orderRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(order);
    const initialFocusRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(initialFocus);
    const returnFocusRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(returnFocus);
    const tree = $8762903b8fe68977$export$db0c2a7c7a2a4f69();
    const portalContext = $8762903b8fe68977$var$usePortalContext();
    const startDismissButtonRef = $7fPBF.useRef(null);
    const endDismissButtonRef = $7fPBF.useRef(null);
    const preventReturnFocusRef = $7fPBF.useRef(false);
    const isPointerDownRef = $7fPBF.useRef(false);
    const tabbableIndexRef = $7fPBF.useRef(-1);
    const blurTimeoutRef = $7fPBF.useRef(-1);
    const isInsidePortal = portalContext != null;
    const floatingFocusElement = (0, $9f8118feb50d8e8d$export$9b0901b5e9b45fc7)(floating);
    const getTabbableContent = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(function(container) {
        if (container === void 0) container = floatingFocusElement;
        return container ? (0, $fef840927e49d4b7$export$17100aea90429aa7)(container, (0, $9f8118feb50d8e8d$export$6324a2bbae6a332f)()) : [];
    });
    const getTabbableElements = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((container)=>{
        const content = getTabbableContent(container);
        return orderRef.current.map((type)=>{
            if (domReference && type === 'reference') return domReference;
            if (floatingFocusElement && type === 'floating') return floatingFocusElement;
            return content;
        }).filter(Boolean).flat();
    });
    $7fPBF.useEffect(()=>{
        if (disabled) return;
        if (!modal) return;
        function onKeyDown(event) {
            if (event.key === 'Tab') {
                // The focus guards have nothing to focus, so we need to stop the event.
                if ((0, $9f8118feb50d8e8d$export$2344b14b097df817)(floatingFocusElement, (0, $9f8118feb50d8e8d$export$da980962bd2147a4)((0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(floatingFocusElement))) && getTabbableContent().length === 0 && !isUntrappedTypeableCombobox) (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
                const els = getTabbableElements();
                const target = (0, $9f8118feb50d8e8d$export$c22522a4dfa48e9c)(event);
                if (orderRef.current[0] === 'reference' && target === domReference) {
                    (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
                    if (event.shiftKey) $8762903b8fe68977$var$enqueueFocus(els[els.length - 1]);
                    else $8762903b8fe68977$var$enqueueFocus(els[1]);
                }
                if (orderRef.current[1] === 'floating' && target === floatingFocusElement && event.shiftKey) {
                    (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
                    $8762903b8fe68977$var$enqueueFocus(els[0]);
                }
            }
        }
        const doc = (0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(floatingFocusElement);
        doc.addEventListener('keydown', onKeyDown);
        return ()=>{
            doc.removeEventListener('keydown', onKeyDown);
        };
    }, [
        disabled,
        domReference,
        floatingFocusElement,
        modal,
        orderRef,
        isUntrappedTypeableCombobox,
        getTabbableContent,
        getTabbableElements
    ]);
    $7fPBF.useEffect(()=>{
        if (disabled) return;
        if (!floating) return;
        function handleFocusIn(event) {
            const target = (0, $9f8118feb50d8e8d$export$c22522a4dfa48e9c)(event);
            const tabbableContent = getTabbableContent();
            const tabbableIndex = tabbableContent.indexOf(target);
            if (tabbableIndex !== -1) tabbableIndexRef.current = tabbableIndex;
        }
        floating.addEventListener('focusin', handleFocusIn);
        return ()=>{
            floating.removeEventListener('focusin', handleFocusIn);
        };
    }, [
        disabled,
        floating,
        getTabbableContent
    ]);
    $7fPBF.useEffect(()=>{
        if (disabled) return;
        if (!closeOnFocusOut) return;
        // In Safari, buttons lose focus when pressing them.
        function handlePointerDown() {
            isPointerDownRef.current = true;
            setTimeout(()=>{
                isPointerDownRef.current = false;
            });
        }
        function handleFocusOutside(event) {
            const relatedTarget = event.relatedTarget;
            const currentTarget = event.currentTarget;
            const target = (0, $9f8118feb50d8e8d$export$c22522a4dfa48e9c)(event);
            queueMicrotask(()=>{
                const nodeId = getNodeId();
                const movedToUnrelatedNode = !((0, $9f8118feb50d8e8d$export$2344b14b097df817)(domReference, relatedTarget) || (0, $9f8118feb50d8e8d$export$2344b14b097df817)(floating, relatedTarget) || (0, $9f8118feb50d8e8d$export$2344b14b097df817)(relatedTarget, floating) || (0, $9f8118feb50d8e8d$export$2344b14b097df817)(portalContext == null ? void 0 : portalContext.portalNode, relatedTarget) || relatedTarget != null && relatedTarget.hasAttribute($8762903b8fe68977$var$createAttribute('focus-guard')) || tree && ((0, $9f8118feb50d8e8d$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context, _node$context2;
                    return (0, $9f8118feb50d8e8d$export$2344b14b097df817)((_node$context = node.context) == null ? void 0 : _node$context.elements.floating, relatedTarget) || (0, $9f8118feb50d8e8d$export$2344b14b097df817)((_node$context2 = node.context) == null ? void 0 : _node$context2.elements.domReference, relatedTarget);
                }) || (0, $9f8118feb50d8e8d$export$5d8eb345316b65c0)(tree.nodesRef.current, nodeId).find((node)=>{
                    var _node$context3, _node$context4, _node$context5;
                    return [
                        (_node$context3 = node.context) == null ? void 0 : _node$context3.elements.floating,
                        (0, $9f8118feb50d8e8d$export$9b0901b5e9b45fc7)((_node$context4 = node.context) == null ? void 0 : _node$context4.elements.floating)
                    ].includes(relatedTarget) || ((_node$context5 = node.context) == null ? void 0 : _node$context5.elements.domReference) === relatedTarget;
                })));
                if (currentTarget === domReference && floatingFocusElement) $8762903b8fe68977$var$handleTabIndex(floatingFocusElement, orderRef);
                // Restore focus to the previous tabbable element index to prevent
                // focus from being lost outside the floating tree.
                if (restoreFocus && currentTarget !== domReference && !(target != null && target.isConnected) && (0, $9f8118feb50d8e8d$export$da980962bd2147a4)((0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(floatingFocusElement)) === (0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(floatingFocusElement).body) {
                    // Let `FloatingPortal` effect knows that focus is still inside the
                    // floating tree.
                    if ((0, $d2553f707975908a$export$1b3bfaa9684536aa)(floatingFocusElement)) floatingFocusElement.focus();
                    const prevTabbableIndex = tabbableIndexRef.current;
                    const tabbableContent = getTabbableContent();
                    const nodeToFocus = tabbableContent[prevTabbableIndex] || tabbableContent[tabbableContent.length - 1] || floatingFocusElement;
                    if ((0, $d2553f707975908a$export$1b3bfaa9684536aa)(nodeToFocus)) nodeToFocus.focus();
                }
                // https://github.com/floating-ui/floating-ui/issues/3060
                if (dataRef.current.insideReactTree) {
                    dataRef.current.insideReactTree = false;
                    return;
                }
                // Focus did not move inside the floating tree, and there are no tabbable
                // portal guards to handle closing.
                if ((isUntrappedTypeableCombobox ? true : !modal) && relatedTarget && movedToUnrelatedNode && !isPointerDownRef.current && // Fix React 18 Strict Mode returnFocus due to double rendering.
                relatedTarget !== $8762903b8fe68977$var$getPreviouslyFocusedElement()) {
                    preventReturnFocusRef.current = true;
                    onOpenChange(false, event, 'focus-out');
                }
            });
        }
        const shouldHandleBlurCapture = Boolean(!tree && portalContext);
        function markInsideReactTree() {
            $8762903b8fe68977$var$clearTimeoutIfSet(blurTimeoutRef);
            dataRef.current.insideReactTree = true;
            blurTimeoutRef.current = window.setTimeout(()=>{
                dataRef.current.insideReactTree = false;
            });
        }
        if (floating && (0, $d2553f707975908a$export$1b3bfaa9684536aa)(domReference)) {
            domReference.addEventListener('focusout', handleFocusOutside);
            domReference.addEventListener('pointerdown', handlePointerDown);
            floating.addEventListener('focusout', handleFocusOutside);
            if (shouldHandleBlurCapture) floating.addEventListener('focusout', markInsideReactTree, true);
            return ()=>{
                domReference.removeEventListener('focusout', handleFocusOutside);
                domReference.removeEventListener('pointerdown', handlePointerDown);
                floating.removeEventListener('focusout', handleFocusOutside);
                if (shouldHandleBlurCapture) floating.removeEventListener('focusout', markInsideReactTree, true);
            };
        }
    }, [
        disabled,
        domReference,
        floating,
        floatingFocusElement,
        modal,
        tree,
        portalContext,
        onOpenChange,
        closeOnFocusOut,
        restoreFocus,
        getTabbableContent,
        isUntrappedTypeableCombobox,
        getNodeId,
        orderRef,
        dataRef
    ]);
    const beforeGuardRef = $7fPBF.useRef(null);
    const afterGuardRef = $7fPBF.useRef(null);
    const mergedBeforeGuardRef = $8762903b8fe68977$var$useLiteMergeRefs([
        beforeGuardRef,
        portalContext == null ? void 0 : portalContext.beforeInsideRef
    ]);
    const mergedAfterGuardRef = $8762903b8fe68977$var$useLiteMergeRefs([
        afterGuardRef,
        portalContext == null ? void 0 : portalContext.afterInsideRef
    ]);
    $7fPBF.useEffect(()=>{
        var _portalContext$portal, _ancestors$find;
        if (disabled) return;
        if (!floating) return;
        // Don't hide portals nested within the parent portal.
        const portalNodes = Array.from((portalContext == null || (_portalContext$portal = portalContext.portalNode) == null ? void 0 : _portalContext$portal.querySelectorAll("[" + $8762903b8fe68977$var$createAttribute('portal') + "]")) || []);
        const ancestors = tree ? (0, $9f8118feb50d8e8d$export$5d8eb345316b65c0)(tree.nodesRef.current, getNodeId()) : [];
        const rootAncestorComboboxDomReference = (_ancestors$find = ancestors.find((node)=>{
            var _node$context6;
            return (0, $9f8118feb50d8e8d$export$259ba5ae38188551)(((_node$context6 = node.context) == null ? void 0 : _node$context6.elements.domReference) || null);
        })) == null || (_ancestors$find = _ancestors$find.context) == null ? void 0 : _ancestors$find.elements.domReference;
        const insideElements = [
            floating,
            rootAncestorComboboxDomReference,
            ...portalNodes,
            ...getInsideElements(),
            startDismissButtonRef.current,
            endDismissButtonRef.current,
            beforeGuardRef.current,
            afterGuardRef.current,
            portalContext == null ? void 0 : portalContext.beforeOutsideRef.current,
            portalContext == null ? void 0 : portalContext.afterOutsideRef.current,
            orderRef.current.includes('reference') || isUntrappedTypeableCombobox ? domReference : null
        ].filter((x)=>x != null);
        const cleanup = modal || isUntrappedTypeableCombobox ? $8762903b8fe68977$var$markOthers(insideElements, !useInert, useInert) : $8762903b8fe68977$var$markOthers(insideElements);
        return ()=>{
            cleanup();
        };
    }, [
        disabled,
        domReference,
        floating,
        modal,
        orderRef,
        portalContext,
        isUntrappedTypeableCombobox,
        guards,
        useInert,
        tree,
        getNodeId,
        getInsideElements
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (disabled || !(0, $d2553f707975908a$export$1b3bfaa9684536aa)(floatingFocusElement)) return;
        const doc = (0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $9f8118feb50d8e8d$export$da980962bd2147a4)(doc);
        // Wait for any layout effect state setters to execute to set `tabIndex`.
        queueMicrotask(()=>{
            const focusableElements = getTabbableElements(floatingFocusElement);
            const initialFocusValue = initialFocusRef.current;
            const elToFocus = (typeof initialFocusValue === 'number' ? focusableElements[initialFocusValue] : initialFocusValue.current) || floatingFocusElement;
            const focusAlreadyInsideFloatingEl = (0, $9f8118feb50d8e8d$export$2344b14b097df817)(floatingFocusElement, previouslyFocusedElement);
            if (!ignoreInitialFocus && !focusAlreadyInsideFloatingEl && open) $8762903b8fe68977$var$enqueueFocus(elToFocus, {
                preventScroll: elToFocus === floatingFocusElement
            });
        });
    }, [
        disabled,
        open,
        floatingFocusElement,
        ignoreInitialFocus,
        getTabbableElements,
        initialFocusRef
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (disabled || !floatingFocusElement) return;
        const doc = (0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(floatingFocusElement);
        const previouslyFocusedElement = (0, $9f8118feb50d8e8d$export$da980962bd2147a4)(doc);
        $8762903b8fe68977$var$addPreviouslyFocusedElement(previouslyFocusedElement);
        // Dismissing via outside press should always ignore `returnFocus` to
        // prevent unwanted scrolling.
        function onOpenChange(_ref) {
            let { reason: reason, event: event, nested: nested } = _ref;
            if ([
                'hover',
                'safe-polygon'
            ].includes(reason) && event.type === 'mouseleave') preventReturnFocusRef.current = true;
            if (reason !== 'outside-press') return;
            if (nested) preventReturnFocusRef.current = false;
            else if ((0, $9f8118feb50d8e8d$export$60278871457622de)(event) || (0, $9f8118feb50d8e8d$export$29bf1b5f2c56cf63)(event)) preventReturnFocusRef.current = false;
            else {
                let isPreventScrollSupported = false;
                document.createElement('div').focus({
                    get preventScroll () {
                        isPreventScrollSupported = true;
                        return false;
                    }
                });
                if (isPreventScrollSupported) preventReturnFocusRef.current = false;
                else preventReturnFocusRef.current = true;
            }
        }
        events.on('openchange', onOpenChange);
        const fallbackEl = doc.createElement('span');
        fallbackEl.setAttribute('tabindex', '-1');
        fallbackEl.setAttribute('aria-hidden', 'true');
        Object.assign(fallbackEl.style, $8762903b8fe68977$var$HIDDEN_STYLES);
        if (isInsidePortal && domReference) domReference.insertAdjacentElement('afterend', fallbackEl);
        function getReturnElement() {
            if (typeof returnFocusRef.current === 'boolean') {
                const el = domReference || $8762903b8fe68977$var$getPreviouslyFocusedElement();
                return el && el.isConnected ? el : fallbackEl;
            }
            return returnFocusRef.current.current || fallbackEl;
        }
        return ()=>{
            events.off('openchange', onOpenChange);
            const activeEl = (0, $9f8118feb50d8e8d$export$da980962bd2147a4)(doc);
            const isFocusInsideFloatingTree = (0, $9f8118feb50d8e8d$export$2344b14b097df817)(floating, activeEl) || tree && (0, $9f8118feb50d8e8d$export$1f1998cc3c6b56fb)(tree.nodesRef.current, getNodeId(), false).some((node)=>{
                var _node$context7;
                return (0, $9f8118feb50d8e8d$export$2344b14b097df817)((_node$context7 = node.context) == null ? void 0 : _node$context7.elements.floating, activeEl);
            });
            const returnElement = getReturnElement();
            queueMicrotask(()=>{
                // This is `returnElement`, if it's tabbable, or its first tabbable child.
                const tabbableReturnElement = $8762903b8fe68977$var$getFirstTabbableElement(returnElement);
                if (// eslint-disable-next-line react-hooks/exhaustive-deps
                returnFocusRef.current && !preventReturnFocusRef.current && (0, $d2553f707975908a$export$1b3bfaa9684536aa)(tabbableReturnElement) && // If the focus moved somewhere else after mount, avoid returning focus
                // since it likely entered a different element which should be
                // respected: https://github.com/floating-ui/floating-ui/issues/2607
                (tabbableReturnElement !== activeEl && activeEl !== doc.body ? isFocusInsideFloatingTree : true)) tabbableReturnElement.focus({
                    preventScroll: true
                });
                fallbackEl.remove();
            });
        };
    }, [
        disabled,
        floating,
        floatingFocusElement,
        returnFocusRef,
        dataRef,
        events,
        tree,
        isInsidePortal,
        domReference,
        getNodeId
    ]);
    $7fPBF.useEffect(()=>{
        // The `returnFocus` cleanup behavior is inside a microtask; ensure we
        // wait for it to complete before resetting the flag.
        queueMicrotask(()=>{
            preventReturnFocusRef.current = false;
        });
        return ()=>{
            queueMicrotask($8762903b8fe68977$var$clearDisconnectedPreviouslyFocusedElements);
        };
    }, [
        disabled
    ]);
    // Synchronize the `context` & `modal` value to the FloatingPortal context.
    // It will decide whether or not it needs to render its own guards.
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (disabled) return;
        if (!portalContext) return;
        portalContext.setFocusManagerState({
            modal: modal,
            closeOnFocusOut: closeOnFocusOut,
            open: open,
            onOpenChange: onOpenChange,
            domReference: domReference
        });
        return ()=>{
            portalContext.setFocusManagerState(null);
        };
    }, [
        disabled,
        portalContext,
        modal,
        open,
        onOpenChange,
        closeOnFocusOut,
        domReference
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (disabled) return;
        if (!floatingFocusElement) return;
        $8762903b8fe68977$var$handleTabIndex(floatingFocusElement, orderRef);
    }, [
        disabled,
        floatingFocusElement,
        orderRef
    ]);
    function renderDismissButton(location) {
        if (disabled || !visuallyHiddenDismiss || !modal) return null;
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$VisuallyHiddenDismiss, {
            ref: location === 'start' ? startDismissButtonRef : endDismissButtonRef,
            onClick: (event)=>onOpenChange(false, event.nativeEvent),
            children: typeof visuallyHiddenDismiss === 'string' ? visuallyHiddenDismiss : 'Dismiss'
        });
    }
    const shouldRenderGuards = !disabled && guards && (modal ? !isUntrappedTypeableCombobox : true) && (isInsidePortal || modal);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            shouldRenderGuards && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedBeforeGuardRef,
                onFocus: (event)=>{
                    if (modal) {
                        const els = getTabbableElements();
                        $8762903b8fe68977$var$enqueueFocus(order[0] === 'reference' ? els[0] : els[els.length - 1]);
                    } else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        preventReturnFocusRef.current = false;
                        if ((0, $9f8118feb50d8e8d$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            const nextTabbable = (0, $9f8118feb50d8e8d$export$28f33206776129a7)(domReference);
                            nextTabbable == null || nextTabbable.focus();
                        } else {
                            var _portalContext$before;
                            (_portalContext$before = portalContext.beforeOutsideRef.current) == null || _portalContext$before.focus();
                        }
                    }
                }
            }),
            !isUntrappedTypeableCombobox && renderDismissButton('start'),
            children,
            renderDismissButton('end'),
            shouldRenderGuards && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8762903b8fe68977$var$FocusGuard, {
                "data-type": "inside",
                ref: mergedAfterGuardRef,
                onFocus: (event)=>{
                    if (modal) $8762903b8fe68977$var$enqueueFocus(getTabbableElements()[0]);
                    else if (portalContext != null && portalContext.preserveTabOrder && portalContext.portalNode) {
                        if (closeOnFocusOut) preventReturnFocusRef.current = true;
                        if ((0, $9f8118feb50d8e8d$export$6e0c4e272f3faa2)(event, portalContext.portalNode)) {
                            const prevTabbable = (0, $9f8118feb50d8e8d$export$2e5518c3303f364a)(domReference);
                            prevTabbable == null || prevTabbable.focus();
                        } else {
                            var _portalContext$afterO;
                            (_portalContext$afterO = portalContext.afterOutsideRef.current) == null || _portalContext$afterO.focus();
                        }
                    }
                }
            })
        ]
    });
}
let $8762903b8fe68977$var$lockCount = 0;
const $8762903b8fe68977$var$scrollbarProperty = '--floating-ui-scrollbar-width';
function $8762903b8fe68977$var$enableScrollLock() {
    const platform = (0, $9f8118feb50d8e8d$export$867a782338812cb4)();
    const isIOS = /iP(hone|ad|od)|iOS/.test(platform) || // iPads can claim to be MacIntel
    platform === 'MacIntel' && navigator.maxTouchPoints > 1;
    const bodyStyle = document.body.style;
    // RTL <body> scrollbar
    const scrollbarX = Math.round(document.documentElement.getBoundingClientRect().left) + document.documentElement.scrollLeft;
    const paddingProp = scrollbarX ? 'paddingLeft' : 'paddingRight';
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const scrollX = bodyStyle.left ? parseFloat(bodyStyle.left) : window.scrollX;
    const scrollY = bodyStyle.top ? parseFloat(bodyStyle.top) : window.scrollY;
    bodyStyle.overflow = 'hidden';
    bodyStyle.setProperty($8762903b8fe68977$var$scrollbarProperty, scrollbarWidth + "px");
    if (scrollbarWidth) bodyStyle[paddingProp] = scrollbarWidth + "px";
    // Only iOS doesn't respect `overflow: hidden` on document.body, and this
    // technique has fewer side effects.
    if (isIOS) {
        var _window$visualViewpor, _window$visualViewpor2;
        // iOS 12 does not support `visualViewport`.
        const offsetLeft = ((_window$visualViewpor = window.visualViewport) == null ? void 0 : _window$visualViewpor.offsetLeft) || 0;
        const offsetTop = ((_window$visualViewpor2 = window.visualViewport) == null ? void 0 : _window$visualViewpor2.offsetTop) || 0;
        Object.assign(bodyStyle, {
            position: 'fixed',
            top: -(scrollY - Math.floor(offsetTop)) + "px",
            left: -(scrollX - Math.floor(offsetLeft)) + "px",
            right: '0'
        });
    }
    return ()=>{
        Object.assign(bodyStyle, {
            overflow: '',
            [paddingProp]: ''
        });
        bodyStyle.removeProperty($8762903b8fe68977$var$scrollbarProperty);
        if (isIOS) {
            Object.assign(bodyStyle, {
                position: '',
                top: '',
                left: '',
                right: ''
            });
            window.scrollTo(scrollX, scrollY);
        }
    };
}
let $8762903b8fe68977$var$cleanup = ()=>{};
/**
 * Provides base styling for a fixed overlay element to dim content or block
 * pointer events behind a floating element.
 * It's a regular `<div>`, so it can be styled via any CSS solution you prefer.
 * @see https://floating-ui.com/docs/FloatingOverlay
 */ const $8762903b8fe68977$export$a35954495955337b = /*#__PURE__*/ $7fPBF.forwardRef(function FloatingOverlay(props, ref) {
    const { lockScroll: lockScroll = false } = props, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "lockScroll"
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!lockScroll) return;
        $8762903b8fe68977$var$lockCount++;
        if ($8762903b8fe68977$var$lockCount === 1) $8762903b8fe68977$var$cleanup = $8762903b8fe68977$var$enableScrollLock();
        return ()=>{
            $8762903b8fe68977$var$lockCount--;
            if ($8762903b8fe68977$var$lockCount === 0) $8762903b8fe68977$var$cleanup();
        };
    }, [
        lockScroll
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        ref: ref
    }, rest), {
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            position: 'fixed',
            overflow: 'auto',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        }, rest.style)
    }));
});
function $8762903b8fe68977$var$isButtonTarget(event) {
    return (0, $d2553f707975908a$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'BUTTON';
}
function $8762903b8fe68977$var$isAnchorTarget(event) {
    return (0, $d2553f707975908a$export$1b3bfaa9684536aa)(event.target) && event.target.tagName === 'A';
}
function $8762903b8fe68977$var$isSpaceIgnored(element) {
    return (0, $9f8118feb50d8e8d$export$42ad131c32f0fb8d)(element);
}
/**
 * Opens or closes the floating element when clicking the reference element.
 * @see https://floating-ui.com/docs/useClick
 */ function $8762903b8fe68977$export$98524f11226063fc(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, dataRef: dataRef, elements: { domReference: domReference } } = context;
    const { enabled: enabled = true, event: eventOption = 'click', toggle: toggle = true, ignoreMouse: ignoreMouse = false, keyboardHandlers: keyboardHandlers = true, stickIfOpen: stickIfOpen = true } = props;
    const pointerTypeRef = $7fPBF.useRef();
    const didKeyDownRef = $7fPBF.useRef(false);
    const reference = $7fPBF.useMemo(()=>({
            onPointerDown (event) {
                pointerTypeRef.current = event.pointerType;
            },
            onMouseDown (event) {
                const pointerType = pointerTypeRef.current;
                // Ignore all buttons except for the "main" button.
                // https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/button
                if (event.button !== 0) return;
                if (eventOption === 'click') return;
                if ((0, $9f8118feb50d8e8d$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'mousedown' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else {
                    // Prevent stealing focus from the floating element
                    event.preventDefault();
                    onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onClick (event) {
                const pointerType = pointerTypeRef.current;
                if (eventOption === 'mousedown' && pointerTypeRef.current) {
                    pointerTypeRef.current = undefined;
                    return;
                }
                if ((0, $9f8118feb50d8e8d$export$81cf264172d31e51)(pointerType, true) && ignoreMouse) return;
                if (open && toggle && (dataRef.current.openEvent && stickIfOpen ? dataRef.current.openEvent.type === 'click' : true)) onOpenChange(false, event.nativeEvent, 'click');
                else onOpenChange(true, event.nativeEvent, 'click');
            },
            onKeyDown (event) {
                pointerTypeRef.current = undefined;
                if (event.defaultPrevented || !keyboardHandlers || $8762903b8fe68977$var$isButtonTarget(event)) return;
                if (event.key === ' ' && !$8762903b8fe68977$var$isSpaceIgnored(domReference)) {
                    // Prevent scrolling
                    event.preventDefault();
                    didKeyDownRef.current = true;
                }
                if ($8762903b8fe68977$var$isAnchorTarget(event)) return;
                if (event.key === 'Enter') {
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            },
            onKeyUp (event) {
                if (event.defaultPrevented || !keyboardHandlers || $8762903b8fe68977$var$isButtonTarget(event) || $8762903b8fe68977$var$isSpaceIgnored(domReference)) return;
                if (event.key === ' ' && didKeyDownRef.current) {
                    didKeyDownRef.current = false;
                    if (open && toggle) onOpenChange(false, event.nativeEvent, 'click');
                    else onOpenChange(true, event.nativeEvent, 'click');
                }
            }
        }), [
        dataRef,
        domReference,
        eventOption,
        ignoreMouse,
        keyboardHandlers,
        onOpenChange,
        open,
        stickIfOpen,
        toggle
    ]);
    return $7fPBF.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $8762903b8fe68977$var$createVirtualElement(domElement, data) {
    let offsetX = null;
    let offsetY = null;
    let isAutoUpdateEvent = false;
    return {
        contextElement: domElement || undefined,
        getBoundingClientRect () {
            var _data$dataRef$current;
            const domRect = (domElement == null ? void 0 : domElement.getBoundingClientRect()) || {
                width: 0,
                height: 0,
                x: 0,
                y: 0
            };
            const isXAxis = data.axis === 'x' || data.axis === 'both';
            const isYAxis = data.axis === 'y' || data.axis === 'both';
            const canTrackCursorOnAutoUpdate = [
                'mouseenter',
                'mousemove'
            ].includes(((_data$dataRef$current = data.dataRef.current.openEvent) == null ? void 0 : _data$dataRef$current.type) || '') && data.pointerType !== 'touch';
            let width = domRect.width;
            let height = domRect.height;
            let x = domRect.x;
            let y = domRect.y;
            if (offsetX == null && data.x && isXAxis) offsetX = domRect.x - data.x;
            if (offsetY == null && data.y && isYAxis) offsetY = domRect.y - data.y;
            x -= offsetX || 0;
            y -= offsetY || 0;
            width = 0;
            height = 0;
            if (!isAutoUpdateEvent || canTrackCursorOnAutoUpdate) {
                width = data.axis === 'y' ? domRect.width : 0;
                height = data.axis === 'x' ? domRect.height : 0;
                x = isXAxis && data.x != null ? data.x : x;
                y = isYAxis && data.y != null ? data.y : y;
            } else if (isAutoUpdateEvent && !canTrackCursorOnAutoUpdate) {
                height = data.axis === 'x' ? domRect.height : height;
                width = data.axis === 'y' ? domRect.width : width;
            }
            isAutoUpdateEvent = true;
            return {
                width: width,
                height: height,
                x: x,
                y: y,
                top: y,
                right: x + width,
                bottom: y + height,
                left: x
            };
        }
    };
}
function $8762903b8fe68977$var$isMouseBasedEvent(event) {
    return event != null && event.clientX != null;
}
/**
 * Positions the floating element relative to a client point (in the viewport),
 * such as the mouse position. By default, it follows the mouse cursor.
 * @see https://floating-ui.com/docs/useClientPoint
 */ function $8762903b8fe68977$export$7fe170a73a621816(context, props) {
    if (props === void 0) props = {};
    const { open: open, dataRef: dataRef, elements: { floating: floating, domReference: domReference }, refs: refs } = context;
    const { enabled: enabled = true, axis: axis = 'both', x: x = null, y: y = null } = props;
    const initialRef = $7fPBF.useRef(false);
    const cleanupListenerRef = $7fPBF.useRef(null);
    const [pointerType, setPointerType] = $7fPBF.useState();
    const [reactive, setReactive] = $7fPBF.useState([]);
    const setReference = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((x, y)=>{
        if (initialRef.current) return;
        // Prevent setting if the open event was not a mouse-like one
        // (e.g. focus to open, then hover over the reference element).
        // Only apply if the event exists.
        if (dataRef.current.openEvent && !$8762903b8fe68977$var$isMouseBasedEvent(dataRef.current.openEvent)) return;
        refs.setPositionReference($8762903b8fe68977$var$createVirtualElement(domReference, {
            x: x,
            y: y,
            axis: axis,
            dataRef: dataRef,
            pointerType: pointerType
        }));
    });
    const handleReferenceEnterOrMove = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((event)=>{
        if (x != null || y != null) return;
        if (!open) setReference(event.clientX, event.clientY);
        else if (!cleanupListenerRef.current) // If there's no cleanup, there's no listener, but we want to ensure
        // we add the listener if the cursor landed on the floating element and
        // then back on the reference (i.e. it's interactive).
        setReactive([]);
    });
    // If the pointer is a mouse-like pointer, we want to continue following the
    // mouse even if the floating element is transitioning out. On touch
    // devices, this is undesirable because the floating element will move to
    // the dismissal touch point.
    const openCheck = (0, $9f8118feb50d8e8d$export$81cf264172d31e51)(pointerType) ? floating : open;
    const addListener = $7fPBF.useCallback(()=>{
        // Explicitly specified `x`/`y` coordinates shouldn't add a listener.
        if (!openCheck || !enabled || x != null || y != null) return;
        const win = (0, $d2553f707975908a$export$38b2d434cce3ea22)(floating);
        function handleMouseMove(event) {
            const target = (0, $9f8118feb50d8e8d$export$c22522a4dfa48e9c)(event);
            if (!(0, $9f8118feb50d8e8d$export$2344b14b097df817)(floating, target)) setReference(event.clientX, event.clientY);
            else {
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            }
        }
        if (!dataRef.current.openEvent || $8762903b8fe68977$var$isMouseBasedEvent(dataRef.current.openEvent)) {
            win.addEventListener('mousemove', handleMouseMove);
            const cleanup = ()=>{
                win.removeEventListener('mousemove', handleMouseMove);
                cleanupListenerRef.current = null;
            };
            cleanupListenerRef.current = cleanup;
            return cleanup;
        }
        refs.setPositionReference(domReference);
    }, [
        openCheck,
        enabled,
        x,
        y,
        floating,
        dataRef,
        refs,
        domReference,
        setReference
    ]);
    $7fPBF.useEffect(()=>{
        return addListener();
    }, [
        addListener,
        reactive
    ]);
    $7fPBF.useEffect(()=>{
        if (enabled && !floating) initialRef.current = false;
    }, [
        enabled,
        floating
    ]);
    $7fPBF.useEffect(()=>{
        if (!enabled && open) initialRef.current = true;
    }, [
        enabled,
        open
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (enabled && (x != null || y != null)) {
            initialRef.current = false;
            setReference(x, y);
        }
    }, [
        enabled,
        x,
        y,
        setReference
    ]);
    const reference = $7fPBF.useMemo(()=>{
        function setPointerTypeRef(_ref) {
            let { pointerType: pointerType } = _ref;
            setPointerType(pointerType);
        }
        return {
            onPointerDown: setPointerTypeRef,
            onPointerEnter: setPointerTypeRef,
            onMouseMove: handleReferenceEnterOrMove,
            onMouseEnter: handleReferenceEnterOrMove
        };
    }, [
        handleReferenceEnterOrMove
    ]);
    return $7fPBF.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
const $8762903b8fe68977$var$bubbleHandlerKeys = {
    pointerdown: 'onPointerDown',
    mousedown: 'onMouseDown',
    click: 'onClick'
};
const $8762903b8fe68977$var$captureHandlerKeys = {
    pointerdown: 'onPointerDownCapture',
    mousedown: 'onMouseDownCapture',
    click: 'onClickCapture'
};
const $8762903b8fe68977$var$normalizeProp = (normalizable)=>{
    var _normalizable$escapeK, _normalizable$outside;
    return {
        escapeKey: typeof normalizable === 'boolean' ? normalizable : (_normalizable$escapeK = normalizable == null ? void 0 : normalizable.escapeKey) != null ? _normalizable$escapeK : false,
        outsidePress: typeof normalizable === 'boolean' ? normalizable : (_normalizable$outside = normalizable == null ? void 0 : normalizable.outsidePress) != null ? _normalizable$outside : true
    };
};
/**
 * Closes the floating element when a dismissal is requested — by default, when
 * the user presses the `escape` key or outside of the floating element.
 * @see https://floating-ui.com/docs/useDismiss
 */ function $8762903b8fe68977$export$fcdf1ba5fafc089b(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, elements: elements, dataRef: dataRef } = context;
    const { enabled: enabled = true, escapeKey: escapeKey = true, outsidePress: unstable_outsidePress = true, outsidePressEvent: outsidePressEvent = 'pointerdown', referencePress: referencePress = false, referencePressEvent: referencePressEvent = 'pointerdown', ancestorScroll: ancestorScroll = false, bubbles: bubbles, capture: capture } = props;
    const tree = $8762903b8fe68977$export$db0c2a7c7a2a4f69();
    const outsidePressFn = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(typeof unstable_outsidePress === 'function' ? unstable_outsidePress : ()=>false);
    const outsidePress = typeof unstable_outsidePress === 'function' ? outsidePressFn : unstable_outsidePress;
    const endedOrStartedInsideRef = $7fPBF.useRef(false);
    const { escapeKey: escapeKeyBubbles, outsidePress: outsidePressBubbles } = $8762903b8fe68977$var$normalizeProp(bubbles);
    const { escapeKey: escapeKeyCapture, outsidePress: outsidePressCapture } = $8762903b8fe68977$var$normalizeProp(capture);
    const isComposingRef = $7fPBF.useRef(false);
    const closeOnEscapeKeyDown = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((event)=>{
        var _dataRef$current$floa;
        if (!open || !enabled || !escapeKey || event.key !== 'Escape') return;
        // Wait until IME is settled. Pressing `Escape` while composing should
        // close the compose menu, but not the floating element.
        if (isComposingRef.current) return;
        const nodeId = (_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.nodeId;
        const children = tree ? (0, $9f8118feb50d8e8d$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (!escapeKeyBubbles) {
            event.stopPropagation();
            if (children.length > 0) {
                let shouldDismiss = true;
                children.forEach((child)=>{
                    var _child$context;
                    if ((_child$context = child.context) != null && _child$context.open && !child.context.dataRef.current.__escapeKeyBubbles) {
                        shouldDismiss = false;
                        return;
                    }
                });
                if (!shouldDismiss) return;
            }
        }
        onOpenChange(false, (0, $9f8118feb50d8e8d$export$94781ce41a161222)(event) ? event.nativeEvent : event, 'escape-key');
    });
    const closeOnEscapeKeyDownCapture = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((event)=>{
        var _getTarget2;
        const callback = ()=>{
            var _getTarget;
            closeOnEscapeKeyDown(event);
            (_getTarget = (0, $9f8118feb50d8e8d$export$c22522a4dfa48e9c)(event)) == null || _getTarget.removeEventListener('keydown', callback);
        };
        (_getTarget2 = (0, $9f8118feb50d8e8d$export$c22522a4dfa48e9c)(event)) == null || _getTarget2.addEventListener('keydown', callback);
    });
    const closeOnPressOutside = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((event)=>{
        var _dataRef$current$floa2;
        // Given developers can stop the propagation of the synthetic event,
        // we can only be confident with a positive value.
        const insideReactTree = dataRef.current.insideReactTree;
        dataRef.current.insideReactTree = false;
        // When click outside is lazy (`click` event), handle dragging.
        // Don't close if:
        // - The click started inside the floating element.
        // - The click ended inside the floating element.
        const endedOrStartedInside = endedOrStartedInsideRef.current;
        endedOrStartedInsideRef.current = false;
        if (outsidePressEvent === 'click' && endedOrStartedInside) return;
        if (insideReactTree) return;
        if (typeof outsidePress === 'function' && !outsidePress(event)) return;
        const target = (0, $9f8118feb50d8e8d$export$c22522a4dfa48e9c)(event);
        const inertSelector = "[" + $8762903b8fe68977$var$createAttribute('inert') + "]";
        const markers = (0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(elements.floating).querySelectorAll(inertSelector);
        let targetRootAncestor = (0, $d2553f707975908a$export$45a5e7f76e0caa8d)(target) ? target : null;
        while(targetRootAncestor && !(0, $d2553f707975908a$export$d1162fb0b6d4cd51)(targetRootAncestor)){
            const nextParent = (0, $d2553f707975908a$export$4e12058fc4d51d56)(targetRootAncestor);
            if ((0, $d2553f707975908a$export$d1162fb0b6d4cd51)(nextParent) || !(0, $d2553f707975908a$export$45a5e7f76e0caa8d)(nextParent)) break;
            targetRootAncestor = nextParent;
        }
        // Check if the click occurred on a third-party element injected after the
        // floating element rendered.
        if (markers.length && (0, $d2553f707975908a$export$45a5e7f76e0caa8d)(target) && !(0, $9f8118feb50d8e8d$export$7b296c28e0fa3aed)(target) && // Clicked on a direct ancestor (e.g. FloatingOverlay).
        !(0, $9f8118feb50d8e8d$export$2344b14b097df817)(target, elements.floating) && // If the target root element contains none of the markers, then the
        // element was injected after the floating element rendered.
        Array.from(markers).every((marker)=>!(0, $9f8118feb50d8e8d$export$2344b14b097df817)(targetRootAncestor, marker))) return;
        // Check if the click occurred on the scrollbar
        if ((0, $d2553f707975908a$export$1b3bfaa9684536aa)(target) && floating) {
            const lastTraversableNode = (0, $d2553f707975908a$export$d1162fb0b6d4cd51)(target);
            const style = (0, $d2553f707975908a$export$3735103072e4a80)(target);
            const scrollRe = /auto|scroll/;
            const isScrollableX = lastTraversableNode || scrollRe.test(style.overflowX);
            const isScrollableY = lastTraversableNode || scrollRe.test(style.overflowY);
            const canScrollX = isScrollableX && target.clientWidth > 0 && target.scrollWidth > target.clientWidth;
            const canScrollY = isScrollableY && target.clientHeight > 0 && target.scrollHeight > target.clientHeight;
            const isRTL = style.direction === 'rtl';
            // Check click position relative to scrollbar.
            // In some browsers it is possible to change the <body> (or window)
            // scrollbar to the left side, but is very rare and is difficult to
            // check for. Plus, for modal dialogs with backdrops, it is more
            // important that the backdrop is checked but not so much the window.
            const pressedVerticalScrollbar = canScrollY && (isRTL ? event.offsetX <= target.offsetWidth - target.clientWidth : event.offsetX > target.clientWidth);
            const pressedHorizontalScrollbar = canScrollX && event.offsetY > target.clientHeight;
            if (pressedVerticalScrollbar || pressedHorizontalScrollbar) return;
        }
        const nodeId = (_dataRef$current$floa2 = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa2.nodeId;
        const targetIsInsideChildren = tree && (0, $9f8118feb50d8e8d$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId).some((node)=>{
            var _node$context;
            return (0, $9f8118feb50d8e8d$export$43c3154d5bf2c6c2)(event, (_node$context = node.context) == null ? void 0 : _node$context.elements.floating);
        });
        if ((0, $9f8118feb50d8e8d$export$43c3154d5bf2c6c2)(event, elements.floating) || (0, $9f8118feb50d8e8d$export$43c3154d5bf2c6c2)(event, elements.domReference) || targetIsInsideChildren) return;
        const children = tree ? (0, $9f8118feb50d8e8d$export$1f1998cc3c6b56fb)(tree.nodesRef.current, nodeId) : [];
        if (children.length > 0) {
            let shouldDismiss = true;
            children.forEach((child)=>{
                var _child$context2;
                if ((_child$context2 = child.context) != null && _child$context2.open && !child.context.dataRef.current.__outsidePressBubbles) {
                    shouldDismiss = false;
                    return;
                }
            });
            if (!shouldDismiss) return;
        }
        onOpenChange(false, event, 'outside-press');
    });
    const closeOnPressOutsideCapture = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((event)=>{
        var _getTarget4;
        const callback = ()=>{
            var _getTarget3;
            closeOnPressOutside(event);
            (_getTarget3 = (0, $9f8118feb50d8e8d$export$c22522a4dfa48e9c)(event)) == null || _getTarget3.removeEventListener(outsidePressEvent, callback);
        };
        (_getTarget4 = (0, $9f8118feb50d8e8d$export$c22522a4dfa48e9c)(event)) == null || _getTarget4.addEventListener(outsidePressEvent, callback);
    });
    $7fPBF.useEffect(()=>{
        if (!open || !enabled) return;
        dataRef.current.__escapeKeyBubbles = escapeKeyBubbles;
        dataRef.current.__outsidePressBubbles = outsidePressBubbles;
        let compositionTimeout = -1;
        function onScroll(event) {
            onOpenChange(false, event, 'ancestor-scroll');
        }
        function handleCompositionStart() {
            window.clearTimeout(compositionTimeout);
            isComposingRef.current = true;
        }
        function handleCompositionEnd() {
            // Safari fires `compositionend` before `keydown`, so we need to wait
            // until the next tick to set `isComposing` to `false`.
            // https://bugs.webkit.org/show_bug.cgi?id=165004
            compositionTimeout = window.setTimeout(()=>{
                isComposingRef.current = false;
            }, // 0ms or 1ms don't work in Safari. 5ms appears to consistently work.
            // Only apply to WebKit for the test to remain 0ms.
            (0, $d2553f707975908a$export$78551043582a6a98)() ? 5 : 0);
        }
        const doc = (0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(elements.floating);
        if (escapeKey) {
            doc.addEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
            doc.addEventListener('compositionstart', handleCompositionStart);
            doc.addEventListener('compositionend', handleCompositionEnd);
        }
        outsidePress && doc.addEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
        let ancestors = [];
        if (ancestorScroll) {
            if ((0, $d2553f707975908a$export$45a5e7f76e0caa8d)(elements.domReference)) ancestors = (0, $d2553f707975908a$export$3b57c1601291186b)(elements.domReference);
            if ((0, $d2553f707975908a$export$45a5e7f76e0caa8d)(elements.floating)) ancestors = ancestors.concat((0, $d2553f707975908a$export$3b57c1601291186b)(elements.floating));
            if (!(0, $d2553f707975908a$export$45a5e7f76e0caa8d)(elements.reference) && elements.reference && elements.reference.contextElement) ancestors = ancestors.concat((0, $d2553f707975908a$export$3b57c1601291186b)(elements.reference.contextElement));
        }
        // Ignore the visual viewport for scrolling dismissal (allow pinch-zoom)
        ancestors = ancestors.filter((ancestor)=>{
            var _doc$defaultView;
            return ancestor !== ((_doc$defaultView = doc.defaultView) == null ? void 0 : _doc$defaultView.visualViewport);
        });
        ancestors.forEach((ancestor)=>{
            ancestor.addEventListener('scroll', onScroll, {
                passive: true
            });
        });
        return ()=>{
            if (escapeKey) {
                doc.removeEventListener('keydown', escapeKeyCapture ? closeOnEscapeKeyDownCapture : closeOnEscapeKeyDown, escapeKeyCapture);
                doc.removeEventListener('compositionstart', handleCompositionStart);
                doc.removeEventListener('compositionend', handleCompositionEnd);
            }
            outsidePress && doc.removeEventListener(outsidePressEvent, outsidePressCapture ? closeOnPressOutsideCapture : closeOnPressOutside, outsidePressCapture);
            ancestors.forEach((ancestor)=>{
                ancestor.removeEventListener('scroll', onScroll);
            });
            window.clearTimeout(compositionTimeout);
        };
    }, [
        dataRef,
        elements,
        escapeKey,
        outsidePress,
        outsidePressEvent,
        open,
        onOpenChange,
        ancestorScroll,
        enabled,
        escapeKeyBubbles,
        outsidePressBubbles,
        closeOnEscapeKeyDown,
        escapeKeyCapture,
        closeOnEscapeKeyDownCapture,
        closeOnPressOutside,
        outsidePressCapture,
        closeOnPressOutsideCapture
    ]);
    $7fPBF.useEffect(()=>{
        dataRef.current.insideReactTree = false;
    }, [
        dataRef,
        outsidePress,
        outsidePressEvent
    ]);
    const reference = $7fPBF.useMemo(()=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            onKeyDown: closeOnEscapeKeyDown
        }, referencePress && (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            [$8762903b8fe68977$var$bubbleHandlerKeys[referencePressEvent]]: (event)=>{
                onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        }, referencePressEvent !== 'click' && {
            onClick (event) {
                onOpenChange(false, event.nativeEvent, 'reference-press');
            }
        })), [
        closeOnEscapeKeyDown,
        onOpenChange,
        referencePress,
        referencePressEvent
    ]);
    const floating = $7fPBF.useMemo(()=>{
        function setMouseDownOrUpInside(event) {
            if (event.button !== 0) return;
            endedOrStartedInsideRef.current = true;
        }
        return {
            onKeyDown: closeOnEscapeKeyDown,
            onMouseDown: setMouseDownOrUpInside,
            onMouseUp: setMouseDownOrUpInside,
            [$8762903b8fe68977$var$captureHandlerKeys[outsidePressEvent]]: ()=>{
                dataRef.current.insideReactTree = true;
            }
        };
    }, [
        closeOnEscapeKeyDown,
        outsidePressEvent,
        dataRef
    ]);
    return $7fPBF.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $8762903b8fe68977$export$1df81146f8ad8e4c(options) {
    const { open: open = false, onOpenChange: onOpenChangeProp, elements: elementsProp } = options;
    const floatingId = $8762903b8fe68977$export$f680877a34711e37();
    const dataRef = $7fPBF.useRef({});
    const [events] = $7fPBF.useState(()=>$8762903b8fe68977$var$createEventEmitter());
    const nested = $8762903b8fe68977$export$165209eae06d3488() != null;
    const [positionReference, setPositionReference] = $7fPBF.useState(elementsProp.reference);
    const onOpenChange = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((open, event, reason)=>{
        dataRef.current.openEvent = open ? event : undefined;
        events.emit('openchange', {
            open: open,
            event: event,
            reason: reason,
            nested: nested
        });
        onOpenChangeProp == null || onOpenChangeProp(open, event, reason);
    });
    const refs = $7fPBF.useMemo(()=>({
            setPositionReference: setPositionReference
        }), []);
    const elements = $7fPBF.useMemo(()=>({
            reference: positionReference || elementsProp.reference || null,
            floating: elementsProp.floating || null,
            domReference: elementsProp.reference
        }), [
        positionReference,
        elementsProp.reference,
        elementsProp.floating
    ]);
    return $7fPBF.useMemo(()=>({
            dataRef: dataRef,
            open: open,
            onOpenChange: onOpenChange,
            elements: elements,
            events: events,
            floatingId: floatingId,
            refs: refs
        }), [
        open,
        onOpenChange,
        elements,
        events,
        floatingId,
        refs
    ]);
}
/**
 * Provides data to position a floating element and context to add interactions.
 * @see https://floating-ui.com/docs/useFloating
 */ function $8762903b8fe68977$export$4e02a5c1d08bac65(options) {
    if (options === void 0) options = {};
    const { nodeId: nodeId } = options;
    const internalRootContext = $8762903b8fe68977$export$1df81146f8ad8e4c((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
        elements: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            reference: null,
            floating: null
        }, options.elements)
    }));
    const rootContext = options.rootContext || internalRootContext;
    const computedElements = rootContext.elements;
    const [_domReference, setDomReference] = $7fPBF.useState(null);
    const [positionReference, _setPositionReference] = $7fPBF.useState(null);
    const optionDomReference = computedElements == null ? void 0 : computedElements.domReference;
    const domReference = optionDomReference || _domReference;
    const domReferenceRef = $7fPBF.useRef(null);
    const tree = $8762903b8fe68977$export$db0c2a7c7a2a4f69();
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (domReference) domReferenceRef.current = domReference;
    }, [
        domReference
    ]);
    const position = (0, $2a1639b232695612$export$4e02a5c1d08bac65)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
        elements: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, computedElements, positionReference && {
            reference: positionReference
        })
    }));
    const setPositionReference = $7fPBF.useCallback((node)=>{
        const computedPositionReference = (0, $d2553f707975908a$export$45a5e7f76e0caa8d)(node) ? {
            getBoundingClientRect: ()=>node.getBoundingClientRect(),
            getClientRects: ()=>node.getClientRects(),
            contextElement: node
        } : node;
        // Store the positionReference in state if the DOM reference is specified externally via the
        // `elements.reference` option. This ensures that it won't be overridden on future renders.
        _setPositionReference(computedPositionReference);
        position.refs.setReference(computedPositionReference);
    }, [
        position.refs
    ]);
    const setReference = $7fPBF.useCallback((node)=>{
        if ((0, $d2553f707975908a$export$45a5e7f76e0caa8d)(node) || node === null) {
            domReferenceRef.current = node;
            setDomReference(node);
        }
        // Backwards-compatibility for passing a virtual element to `reference`
        // after it has set the DOM reference.
        if ((0, $d2553f707975908a$export$45a5e7f76e0caa8d)(position.refs.reference.current) || position.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
        // `null` to support `positionReference` + an unstable `reference`
        // callback ref.
        node !== null && !(0, $d2553f707975908a$export$45a5e7f76e0caa8d)(node)) position.refs.setReference(node);
    }, [
        position.refs
    ]);
    const refs = $7fPBF.useMemo(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, position.refs), {
            setReference: setReference,
            setPositionReference: setPositionReference,
            domReference: domReferenceRef
        }), [
        position.refs,
        setReference,
        setPositionReference
    ]);
    const elements = $7fPBF.useMemo(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, position.elements), {
            domReference: domReference
        }), [
        position.elements,
        domReference
    ]);
    const context = $7fPBF.useMemo(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, position, rootContext), {
            refs: refs,
            elements: elements,
            nodeId: nodeId
        }), [
        position,
        refs,
        elements,
        nodeId,
        rootContext
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        rootContext.dataRef.current.floatingContext = context;
        const node = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.id === nodeId);
        if (node) node.context = context;
    });
    return $7fPBF.useMemo(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, position), {
            context: context,
            refs: refs,
            elements: elements
        }), [
        position,
        refs,
        elements,
        context
    ]);
}
function $8762903b8fe68977$var$isMacSafari() {
    return (0, $9f8118feb50d8e8d$export$9ac100e40613ea10)() && (0, $9f8118feb50d8e8d$export$95df08bae54cb4df)();
}
/**
 * Opens the floating element while the reference element has focus, like CSS
 * `:focus`.
 * @see https://floating-ui.com/docs/useFocus
 */ function $8762903b8fe68977$export$f8168d8dd8fd66e6(context, props) {
    if (props === void 0) props = {};
    const { open: open, onOpenChange: onOpenChange, events: events, dataRef: dataRef, elements: elements } = context;
    const { enabled: enabled = true, visibleOnly: visibleOnly = true } = props;
    const blockFocusRef = $7fPBF.useRef(false);
    const timeoutRef = $7fPBF.useRef(-1);
    const keyboardModalityRef = $7fPBF.useRef(true);
    $7fPBF.useEffect(()=>{
        if (!enabled) return;
        const win = (0, $d2553f707975908a$export$38b2d434cce3ea22)(elements.domReference);
        // If the reference was focused and the user left the tab/window, and the
        // floating element was not open, the focus should be blocked when they
        // return to the tab/window.
        function onBlur() {
            if (!open && (0, $d2553f707975908a$export$1b3bfaa9684536aa)(elements.domReference) && elements.domReference === (0, $9f8118feb50d8e8d$export$da980962bd2147a4)((0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(elements.domReference))) blockFocusRef.current = true;
        }
        function onKeyDown() {
            keyboardModalityRef.current = true;
        }
        function onPointerDown() {
            keyboardModalityRef.current = false;
        }
        win.addEventListener('blur', onBlur);
        if ($8762903b8fe68977$var$isMacSafari()) {
            win.addEventListener('keydown', onKeyDown, true);
            win.addEventListener('pointerdown', onPointerDown, true);
        }
        return ()=>{
            win.removeEventListener('blur', onBlur);
            if ($8762903b8fe68977$var$isMacSafari()) {
                win.removeEventListener('keydown', onKeyDown, true);
                win.removeEventListener('pointerdown', onPointerDown, true);
            }
        };
    }, [
        elements.domReference,
        open,
        enabled
    ]);
    $7fPBF.useEffect(()=>{
        if (!enabled) return;
        function onOpenChange(_ref) {
            let { reason: reason } = _ref;
            if (reason === 'reference-press' || reason === 'escape-key') blockFocusRef.current = true;
        }
        events.on('openchange', onOpenChange);
        return ()=>{
            events.off('openchange', onOpenChange);
        };
    }, [
        events,
        enabled
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef);
        };
    }, []);
    const reference = $7fPBF.useMemo(()=>({
            onMouseLeave () {
                blockFocusRef.current = false;
            },
            onFocus (event) {
                if (blockFocusRef.current) return;
                const target = (0, $9f8118feb50d8e8d$export$c22522a4dfa48e9c)(event.nativeEvent);
                if (visibleOnly && (0, $d2553f707975908a$export$45a5e7f76e0caa8d)(target)) {
                    // Safari fails to match `:focus-visible` if focus was initially
                    // outside the document.
                    if ($8762903b8fe68977$var$isMacSafari() && !event.relatedTarget) {
                        if (!keyboardModalityRef.current && !(0, $9f8118feb50d8e8d$export$42ad131c32f0fb8d)(target)) return;
                    } else if (!(0, $9f8118feb50d8e8d$export$65750043c2fb2f40)(target)) return;
                }
                onOpenChange(true, event.nativeEvent, 'focus');
            },
            onBlur (event) {
                blockFocusRef.current = false;
                const relatedTarget = event.relatedTarget;
                const nativeEvent = event.nativeEvent;
                // Hit the non-modal focus management portal guard. Focus will be
                // moved into the floating element immediately after.
                const movedToFocusGuard = (0, $d2553f707975908a$export$45a5e7f76e0caa8d)(relatedTarget) && relatedTarget.hasAttribute($8762903b8fe68977$var$createAttribute('focus-guard')) && relatedTarget.getAttribute('data-type') === 'outside';
                // Wait for the window blur listener to fire.
                timeoutRef.current = window.setTimeout(()=>{
                    var _dataRef$current$floa;
                    const activeEl = (0, $9f8118feb50d8e8d$export$da980962bd2147a4)(elements.domReference ? elements.domReference.ownerDocument : document);
                    // Focus left the page, keep it open.
                    if (!relatedTarget && activeEl === elements.domReference) return;
                    // When focusing the reference element (e.g. regular click), then
                    // clicking into the floating element, prevent it from hiding.
                    // Note: it must be focusable, e.g. `tabindex="-1"`.
                    // We can not rely on relatedTarget to point to the correct element
                    // as it will only point to the shadow host of the newly focused element
                    // and not the element that actually has received focus if it is located
                    // inside a shadow root.
                    if ((0, $9f8118feb50d8e8d$export$2344b14b097df817)((_dataRef$current$floa = dataRef.current.floatingContext) == null ? void 0 : _dataRef$current$floa.refs.floating.current, activeEl) || (0, $9f8118feb50d8e8d$export$2344b14b097df817)(elements.domReference, activeEl) || movedToFocusGuard) return;
                    onOpenChange(false, nativeEvent, 'focus');
                });
            }
        }), [
        dataRef,
        elements.domReference,
        onOpenChange,
        visibleOnly
    ]);
    return $7fPBF.useMemo(()=>enabled ? {
            reference: reference
        } : {}, [
        enabled,
        reference
    ]);
}
function $8762903b8fe68977$var$mergeProps(userProps, propsList, elementKey) {
    const map = new Map();
    const isItem = elementKey === 'item';
    let domUserProps = userProps;
    if (isItem && userProps) {
        const { [$8762903b8fe68977$var$ACTIVE_KEY]: _, [$8762903b8fe68977$var$SELECTED_KEY]: __ } = userProps, validProps = (0, $8901fc92b5563702$export$71511d61b312f219)(userProps, [
            $8762903b8fe68977$var$ACTIVE_KEY,
            $8762903b8fe68977$var$SELECTED_KEY
        ].map((0, $48eb3f76e7383a7f$export$71511d61b312f219)));
        domUserProps = validProps;
    }
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, elementKey === 'floating' && {
        tabIndex: -1,
        [$8762903b8fe68977$var$FOCUSABLE_ATTRIBUTE]: ''
    }, domUserProps, propsList.map((value)=>{
        const propsOrGetProps = value ? value[elementKey] : null;
        if (typeof propsOrGetProps === 'function') return userProps ? propsOrGetProps(userProps) : null;
        return propsOrGetProps;
    }).concat(userProps).reduce((acc, props)=>{
        if (!props) return acc;
        Object.entries(props).forEach((_ref)=>{
            let [key, value] = _ref;
            if (isItem && [
                $8762903b8fe68977$var$ACTIVE_KEY,
                $8762903b8fe68977$var$SELECTED_KEY
            ].includes(key)) return;
            if (key.indexOf('on') === 0) {
                if (!map.has(key)) map.set(key, []);
                if (typeof value === 'function') {
                    var _map$get;
                    (_map$get = map.get(key)) == null || _map$get.push(value);
                    acc[key] = function() {
                        var _map$get2;
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        return (_map$get2 = map.get(key)) == null ? void 0 : _map$get2.map((fn)=>fn(...args)).find((val)=>val !== undefined);
                    };
                }
            } else acc[key] = value;
        });
        return acc;
    }, {}));
}
/**
 * Merges an array of interaction hooks' props into prop getters, allowing
 * event handler functions to be composed together without overwriting one
 * another.
 * @see https://floating-ui.com/docs/useInteractions
 */ function $8762903b8fe68977$export$a519f7794e446ddd(propsList) {
    if (propsList === void 0) propsList = [];
    const referenceDeps = propsList.map((key)=>key == null ? void 0 : key.reference);
    const floatingDeps = propsList.map((key)=>key == null ? void 0 : key.floating);
    const itemDeps = propsList.map((key)=>key == null ? void 0 : key.item);
    const getReferenceProps = $7fPBF.useCallback((userProps)=>$8762903b8fe68977$var$mergeProps(userProps, propsList, 'reference'), // eslint-disable-next-line react-hooks/exhaustive-deps
    referenceDeps);
    const getFloatingProps = $7fPBF.useCallback((userProps)=>$8762903b8fe68977$var$mergeProps(userProps, propsList, 'floating'), // eslint-disable-next-line react-hooks/exhaustive-deps
    floatingDeps);
    const getItemProps = $7fPBF.useCallback((userProps)=>$8762903b8fe68977$var$mergeProps(userProps, propsList, 'item'), // eslint-disable-next-line react-hooks/exhaustive-deps
    itemDeps);
    return $7fPBF.useMemo(()=>({
            getReferenceProps: getReferenceProps,
            getFloatingProps: getFloatingProps,
            getItemProps: getItemProps
        }), [
        getReferenceProps,
        getFloatingProps,
        getItemProps
    ]);
}
const $8762903b8fe68977$var$ESCAPE = 'Escape';
function $8762903b8fe68977$var$doSwitch(orientation, vertical, horizontal) {
    switch(orientation){
        case 'vertical':
            return vertical;
        case 'horizontal':
            return horizontal;
        default:
            return vertical || horizontal;
    }
}
function $8762903b8fe68977$var$isMainOrientationKey(key, orientation) {
    const vertical = key === $8762903b8fe68977$var$ARROW_UP || key === $8762903b8fe68977$var$ARROW_DOWN;
    const horizontal = key === $8762903b8fe68977$var$ARROW_LEFT || key === $8762903b8fe68977$var$ARROW_RIGHT;
    return $8762903b8fe68977$var$doSwitch(orientation, vertical, horizontal);
}
function $8762903b8fe68977$var$isMainOrientationToEndKey(key, orientation, rtl) {
    const vertical = key === $8762903b8fe68977$var$ARROW_DOWN;
    const horizontal = rtl ? key === $8762903b8fe68977$var$ARROW_LEFT : key === $8762903b8fe68977$var$ARROW_RIGHT;
    return $8762903b8fe68977$var$doSwitch(orientation, vertical, horizontal) || key === 'Enter' || key === ' ' || key === '';
}
function $8762903b8fe68977$var$isCrossOrientationOpenKey(key, orientation, rtl) {
    const vertical = rtl ? key === $8762903b8fe68977$var$ARROW_LEFT : key === $8762903b8fe68977$var$ARROW_RIGHT;
    const horizontal = key === $8762903b8fe68977$var$ARROW_DOWN;
    return $8762903b8fe68977$var$doSwitch(orientation, vertical, horizontal);
}
function $8762903b8fe68977$var$isCrossOrientationCloseKey(key, orientation, rtl, cols) {
    const vertical = rtl ? key === $8762903b8fe68977$var$ARROW_RIGHT : key === $8762903b8fe68977$var$ARROW_LEFT;
    const horizontal = key === $8762903b8fe68977$var$ARROW_UP;
    if (orientation === 'both' || orientation === 'horizontal' && cols && cols > 1) return key === $8762903b8fe68977$var$ESCAPE;
    return $8762903b8fe68977$var$doSwitch(orientation, vertical, horizontal);
}
/**
 * Adds arrow key-based navigation of a list of items, either using real DOM
 * focus or virtual focus.
 * @see https://floating-ui.com/docs/useListNavigation
 */ function $8762903b8fe68977$export$b5d22cac4ad33f40(context, props) {
    const { open: open, onOpenChange: onOpenChange, elements: elements, floatingId: floatingId } = context;
    const { listRef: listRef, activeIndex: activeIndex, onNavigate: unstable_onNavigate = ()=>{}, enabled: enabled = true, selectedIndex: selectedIndex = null, allowEscape: allowEscape = false, loop: loop = false, nested: nested = false, rtl: rtl = false, virtual: virtual = false, focusItemOnOpen: focusItemOnOpen = 'auto', focusItemOnHover: focusItemOnHover = true, openOnArrowKeyDown: openOnArrowKeyDown = true, disabledIndices: disabledIndices, orientation: orientation = 'vertical', parentOrientation: parentOrientation, cols: cols = 1, scrollItemIntoView: scrollItemIntoView = true, virtualItemRef: virtualItemRef, itemSizes: itemSizes, dense: dense = false } = props;
    const floatingFocusElement = (0, $9f8118feb50d8e8d$export$9b0901b5e9b45fc7)(elements.floating);
    const floatingFocusElementRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(floatingFocusElement);
    const parentId = $8762903b8fe68977$export$165209eae06d3488();
    const tree = $8762903b8fe68977$export$db0c2a7c7a2a4f69();
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        context.dataRef.current.orientation = orientation;
    }, [
        context,
        orientation
    ]);
    const onNavigate = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(()=>{
        unstable_onNavigate(indexRef.current === -1 ? null : indexRef.current);
    });
    const typeableComboboxReference = (0, $9f8118feb50d8e8d$export$259ba5ae38188551)(elements.domReference);
    const focusItemOnOpenRef = $7fPBF.useRef(focusItemOnOpen);
    const indexRef = $7fPBF.useRef(selectedIndex != null ? selectedIndex : -1);
    const keyRef = $7fPBF.useRef(null);
    const isPointerModalityRef = $7fPBF.useRef(true);
    const previousOnNavigateRef = $7fPBF.useRef(onNavigate);
    const previousMountedRef = $7fPBF.useRef(!!elements.floating);
    const previousOpenRef = $7fPBF.useRef(open);
    const forceSyncFocusRef = $7fPBF.useRef(false);
    const forceScrollIntoViewRef = $7fPBF.useRef(false);
    const disabledIndicesRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(disabledIndices);
    const latestOpenRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(open);
    const scrollItemIntoViewRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(scrollItemIntoView);
    const selectedIndexRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(selectedIndex);
    const [activeId, setActiveId] = $7fPBF.useState();
    const [virtualId, setVirtualId] = $7fPBF.useState();
    const focusItem = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(()=>{
        function runFocus(item) {
            if (virtual) {
                var _item$id;
                if ((_item$id = item.id) != null && _item$id.endsWith('-fui-option')) item.id = floatingId + "-" + Math.random().toString(16).slice(2, 10);
                setActiveId(item.id);
                tree == null || tree.events.emit('virtualfocus', item);
                if (virtualItemRef) virtualItemRef.current = item;
            } else $8762903b8fe68977$var$enqueueFocus(item, {
                sync: forceSyncFocusRef.current,
                preventScroll: true
            });
        }
        const initialItem = listRef.current[indexRef.current];
        const forceScrollIntoView = forceScrollIntoViewRef.current;
        if (initialItem) runFocus(initialItem);
        const scheduler = forceSyncFocusRef.current ? (v)=>v() : requestAnimationFrame;
        scheduler(()=>{
            const waitedItem = listRef.current[indexRef.current] || initialItem;
            if (!waitedItem) return;
            if (!initialItem) runFocus(waitedItem);
            const scrollIntoViewOptions = scrollItemIntoViewRef.current;
            const shouldScrollIntoView = scrollIntoViewOptions && item && (forceScrollIntoView || !isPointerModalityRef.current);
            if (shouldScrollIntoView) // JSDOM doesn't support `.scrollIntoView()` but it's widely supported
            // by all browsers.
            waitedItem.scrollIntoView == null || waitedItem.scrollIntoView(typeof scrollIntoViewOptions === 'boolean' ? {
                block: 'nearest',
                inline: 'nearest'
            } : scrollIntoViewOptions);
        });
    });
    // Sync `selectedIndex` to be the `activeIndex` upon opening the floating
    // element. Also, reset `activeIndex` upon closing the floating element.
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (open && elements.floating) {
            if (focusItemOnOpenRef.current && selectedIndex != null) {
                // Regardless of the pointer modality, we want to ensure the selected
                // item comes into view when the floating element is opened.
                forceScrollIntoViewRef.current = true;
                indexRef.current = selectedIndex;
                onNavigate();
            }
        } else if (previousMountedRef.current) {
            // Since the user can specify `onNavigate` conditionally
            // (onNavigate: open ? setActiveIndex : setSelectedIndex),
            // we store and call the previous function.
            indexRef.current = -1;
            previousOnNavigateRef.current();
        }
    }, [
        enabled,
        open,
        elements.floating,
        selectedIndex,
        onNavigate
    ]);
    // Sync `activeIndex` to be the focused item while the floating element is
    // open.
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!open) return;
        if (!elements.floating) return;
        if (activeIndex == null) {
            forceSyncFocusRef.current = false;
            if (selectedIndexRef.current != null) return;
            // Reset while the floating element was open (e.g. the list changed).
            if (previousMountedRef.current) {
                indexRef.current = -1;
                focusItem();
            }
            // Initial sync.
            if ((!previousOpenRef.current || !previousMountedRef.current) && focusItemOnOpenRef.current && (keyRef.current != null || focusItemOnOpenRef.current === true && keyRef.current == null)) {
                let runs = 0;
                const waitForListPopulated = ()=>{
                    if (listRef.current[0] == null) {
                        // Avoid letting the browser paint if possible on the first try,
                        // otherwise use rAF. Don't try more than twice, since something
                        // is wrong otherwise.
                        if (runs < 2) {
                            const scheduler = runs ? requestAnimationFrame : queueMicrotask;
                            scheduler(waitForListPopulated);
                        }
                        runs++;
                    } else {
                        indexRef.current = keyRef.current == null || $8762903b8fe68977$var$isMainOrientationToEndKey(keyRef.current, orientation, rtl) || nested ? (0, $9f8118feb50d8e8d$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current) : (0, $9f8118feb50d8e8d$export$b585558af466e926)(listRef, disabledIndicesRef.current);
                        keyRef.current = null;
                        onNavigate();
                    }
                };
                waitForListPopulated();
            }
        } else if (!(0, $9f8118feb50d8e8d$export$75effb89758ec596)(listRef, activeIndex)) {
            indexRef.current = activeIndex;
            focusItem();
            forceScrollIntoViewRef.current = false;
        }
    }, [
        enabled,
        open,
        elements.floating,
        activeIndex,
        selectedIndexRef,
        nested,
        listRef,
        orientation,
        rtl,
        onNavigate,
        focusItem,
        disabledIndicesRef
    ]);
    // Ensure the parent floating element has focus when a nested child closes
    // to allow arrow key navigation to work after the pointer leaves the child.
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        var _nodes$find;
        if (!enabled || elements.floating || !tree || virtual || !previousMountedRef.current) return;
        const nodes = tree.nodesRef.current;
        const parent = (_nodes$find = nodes.find((node)=>node.id === parentId)) == null || (_nodes$find = _nodes$find.context) == null ? void 0 : _nodes$find.elements.floating;
        const activeEl = (0, $9f8118feb50d8e8d$export$da980962bd2147a4)((0, $9f8118feb50d8e8d$export$f65ca476c09acec0)(elements.floating));
        const treeContainsActiveEl = nodes.some((node)=>node.context && (0, $9f8118feb50d8e8d$export$2344b14b097df817)(node.context.elements.floating, activeEl));
        if (parent && !treeContainsActiveEl && isPointerModalityRef.current) parent.focus({
            preventScroll: true
        });
    }, [
        enabled,
        elements.floating,
        tree,
        parentId,
        virtual
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!enabled) return;
        if (!tree) return;
        if (!virtual) return;
        if (parentId) return;
        function handleVirtualFocus(item) {
            setVirtualId(item.id);
            if (virtualItemRef) virtualItemRef.current = item;
        }
        tree.events.on('virtualfocus', handleVirtualFocus);
        return ()=>{
            tree.events.off('virtualfocus', handleVirtualFocus);
        };
    }, [
        enabled,
        tree,
        virtual,
        parentId,
        virtualItemRef
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        previousOnNavigateRef.current = onNavigate;
        previousOpenRef.current = open;
        previousMountedRef.current = !!elements.floating;
    });
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!open) {
            keyRef.current = null;
            focusItemOnOpenRef.current = focusItemOnOpen;
        }
    }, [
        open,
        focusItemOnOpen
    ]);
    const hasActiveIndex = activeIndex != null;
    const item = $7fPBF.useMemo(()=>{
        function syncCurrentTarget(currentTarget) {
            if (!latestOpenRef.current) return;
            const index = listRef.current.indexOf(currentTarget);
            if (index !== -1 && indexRef.current !== index) {
                indexRef.current = index;
                onNavigate();
            }
        }
        const props = {
            onFocus (_ref) {
                let { currentTarget: currentTarget } = _ref;
                forceSyncFocusRef.current = true;
                syncCurrentTarget(currentTarget);
            },
            onClick: (_ref2)=>{
                let { currentTarget: currentTarget } = _ref2;
                return currentTarget.focus({
                    preventScroll: true
                });
            },
            // Safari
            onMouseMove (_ref3) {
                let { currentTarget: currentTarget } = _ref3;
                forceSyncFocusRef.current = true;
                forceScrollIntoViewRef.current = false;
                if (focusItemOnHover) syncCurrentTarget(currentTarget);
            },
            onPointerLeave (_ref4) {
                let { pointerType: pointerType } = _ref4;
                if (!isPointerModalityRef.current || pointerType === 'touch') return;
                forceSyncFocusRef.current = true;
                if (!focusItemOnHover) return;
                indexRef.current = -1;
                onNavigate();
                if (!virtual) {
                    var _floatingFocusElement;
                    (_floatingFocusElement = floatingFocusElementRef.current) == null || _floatingFocusElement.focus({
                        preventScroll: true
                    });
                }
            }
        };
        return props;
    }, [
        latestOpenRef,
        floatingFocusElementRef,
        focusItemOnHover,
        listRef,
        onNavigate,
        virtual
    ]);
    const getParentOrientation = $7fPBF.useCallback(()=>{
        var _tree$nodesRef$curren;
        return parentOrientation != null ? parentOrientation : tree == null || (_tree$nodesRef$curren = tree.nodesRef.current.find((node)=>node.id === parentId)) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.context) == null || (_tree$nodesRef$curren = _tree$nodesRef$curren.dataRef) == null ? void 0 : _tree$nodesRef$curren.current.orientation;
    }, [
        parentId,
        tree,
        parentOrientation
    ]);
    const commonOnKeyDown = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((event)=>{
        isPointerModalityRef.current = false;
        forceSyncFocusRef.current = true;
        // When composing a character, Chrome fires ArrowDown twice. Firefox/Safari
        // don't appear to suffer from this. `event.isComposing` is avoided due to
        // Safari not supporting it properly (although it's not needed in the first
        // place for Safari, just avoiding any possible issues).
        if (event.which === 229) return;
        // If the floating element is animating out, ignore navigation. Otherwise,
        // the `activeIndex` gets set to 0 despite not being open so the next time
        // the user ArrowDowns, the first item won't be focused.
        if (!latestOpenRef.current && event.currentTarget === floatingFocusElementRef.current) return;
        if (nested && $8762903b8fe68977$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols)) {
            // If the nested list's close key is also the parent navigation key,
            // let the parent navigate. Otherwise, stop propagating the event.
            if (!$8762903b8fe68977$var$isMainOrientationKey(event.key, getParentOrientation())) (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
            onOpenChange(false, event.nativeEvent, 'list-navigation');
            if ((0, $d2553f707975908a$export$1b3bfaa9684536aa)(elements.domReference)) {
                if (virtual) tree == null || tree.events.emit('virtualfocus', elements.domReference);
                else elements.domReference.focus();
            }
            return;
        }
        const currentIndex = indexRef.current;
        const minIndex = (0, $9f8118feb50d8e8d$export$53f691ee0acc6058)(listRef, disabledIndices);
        const maxIndex = (0, $9f8118feb50d8e8d$export$b585558af466e926)(listRef, disabledIndices);
        if (!typeableComboboxReference) {
            if (event.key === 'Home') {
                (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
                indexRef.current = minIndex;
                onNavigate();
            }
            if (event.key === 'End') {
                (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
                indexRef.current = maxIndex;
                onNavigate();
            }
        }
        // Grid navigation.
        if (cols > 1) {
            const sizes = itemSizes || Array.from({
                length: listRef.current.length
            }, ()=>({
                    width: 1,
                    height: 1
                }));
            // To calculate movements on the grid, we use hypothetical cell indices
            // as if every item was 1x1, then convert back to real indices.
            const cellMap = (0, $9f8118feb50d8e8d$export$5334c96856356f08)(sizes, cols, dense);
            const minGridIndex = cellMap.findIndex((index)=>index != null && !(0, $9f8118feb50d8e8d$export$446656ed0410fd9)(listRef, index, disabledIndices));
            // last enabled index
            const maxGridIndex = cellMap.reduce((foundIndex, index, cellIndex)=>index != null && !(0, $9f8118feb50d8e8d$export$446656ed0410fd9)(listRef, index, disabledIndices) ? cellIndex : foundIndex, -1);
            const index = cellMap[(0, $9f8118feb50d8e8d$export$342fcce33a2688bc)({
                current: cellMap.map((itemIndex)=>itemIndex != null ? listRef.current[itemIndex] : null)
            }, {
                event: event,
                orientation: orientation,
                loop: loop,
                rtl: rtl,
                cols: cols,
                // treat undefined (empty grid spaces) as disabled indices so we
                // don't end up in them
                disabledIndices: (0, $9f8118feb50d8e8d$export$50d8709b2ccc23f9)([
                    ...(typeof disabledIndices !== 'function' ? disabledIndices : null) || listRef.current.map((_, index)=>(0, $9f8118feb50d8e8d$export$446656ed0410fd9)(listRef, index, disabledIndices) ? index : undefined),
                    undefined
                ], cellMap),
                minIndex: minGridIndex,
                maxIndex: maxGridIndex,
                prevIndex: (0, $9f8118feb50d8e8d$export$dab2b2ce7761f8e4)(indexRef.current > maxIndex ? minIndex : indexRef.current, sizes, cellMap, cols, // use a corner matching the edge closest to the direction
                // we're moving in so we don't end up in the same item. Prefer
                // top/left over bottom/right.
                event.key === $8762903b8fe68977$var$ARROW_DOWN ? 'bl' : event.key === (rtl ? $8762903b8fe68977$var$ARROW_LEFT : $8762903b8fe68977$var$ARROW_RIGHT) ? 'tr' : 'tl'),
                stopEvent: true
            })];
            if (index != null) {
                indexRef.current = index;
                onNavigate();
            }
            if (orientation === 'both') return;
        }
        if ($8762903b8fe68977$var$isMainOrientationKey(event.key, orientation)) {
            (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
            // Reset the index if no item is focused.
            if (open && !virtual && (0, $9f8118feb50d8e8d$export$da980962bd2147a4)(event.currentTarget.ownerDocument) === event.currentTarget) {
                indexRef.current = $8762903b8fe68977$var$isMainOrientationToEndKey(event.key, orientation, rtl) ? minIndex : maxIndex;
                onNavigate();
                return;
            }
            if ($8762903b8fe68977$var$isMainOrientationToEndKey(event.key, orientation, rtl)) {
                if (loop) indexRef.current = currentIndex >= maxIndex ? allowEscape && currentIndex !== listRef.current.length ? -1 : minIndex : (0, $9f8118feb50d8e8d$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                });
                else indexRef.current = Math.min(maxIndex, (0, $9f8118feb50d8e8d$export$3fc3ea4a67cf714)(listRef, {
                    startingIndex: currentIndex,
                    disabledIndices: disabledIndices
                }));
            } else if (loop) indexRef.current = currentIndex <= minIndex ? allowEscape && currentIndex !== -1 ? listRef.current.length : maxIndex : (0, $9f8118feb50d8e8d$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            });
            else indexRef.current = Math.max(minIndex, (0, $9f8118feb50d8e8d$export$3fc3ea4a67cf714)(listRef, {
                startingIndex: currentIndex,
                decrement: true,
                disabledIndices: disabledIndices
            }));
            if ((0, $9f8118feb50d8e8d$export$75effb89758ec596)(listRef, indexRef.current)) indexRef.current = -1;
            onNavigate();
        }
    });
    const ariaActiveDescendantProp = $7fPBF.useMemo(()=>{
        return virtual && open && hasActiveIndex && {
            'aria-activedescendant': virtualId || activeId
        };
    }, [
        virtual,
        open,
        hasActiveIndex,
        virtualId,
        activeId
    ]);
    const floating = $7fPBF.useMemo(()=>{
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            'aria-orientation': orientation === 'both' ? undefined : orientation
        }, !typeableComboboxReference ? ariaActiveDescendantProp : {}), {
            onKeyDown: commonOnKeyDown,
            onPointerMove () {
                isPointerModalityRef.current = true;
            }
        });
    }, [
        ariaActiveDescendantProp,
        commonOnKeyDown,
        orientation,
        typeableComboboxReference
    ]);
    const reference = $7fPBF.useMemo(()=>{
        function checkVirtualMouse(event) {
            if (focusItemOnOpen === 'auto' && (0, $9f8118feb50d8e8d$export$60278871457622de)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        function checkVirtualPointer(event) {
            // `pointerdown` fires first, reset the state then perform the checks.
            focusItemOnOpenRef.current = focusItemOnOpen;
            if (focusItemOnOpen === 'auto' && (0, $9f8118feb50d8e8d$export$29bf1b5f2c56cf63)(event.nativeEvent)) focusItemOnOpenRef.current = true;
        }
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, ariaActiveDescendantProp), {
            onKeyDown (event) {
                isPointerModalityRef.current = false;
                const isArrowKey = event.key.startsWith('Arrow');
                const isHomeOrEndKey = [
                    'Home',
                    'End'
                ].includes(event.key);
                const isMoveKey = isArrowKey || isHomeOrEndKey;
                const isCrossOpenKey = $8762903b8fe68977$var$isCrossOrientationOpenKey(event.key, orientation, rtl);
                const isCrossCloseKey = $8762903b8fe68977$var$isCrossOrientationCloseKey(event.key, orientation, rtl, cols);
                const isParentCrossOpenKey = $8762903b8fe68977$var$isCrossOrientationOpenKey(event.key, getParentOrientation(), rtl);
                const isMainKey = $8762903b8fe68977$var$isMainOrientationKey(event.key, orientation);
                const isNavigationKey = (nested ? isParentCrossOpenKey : isMainKey) || event.key === 'Enter' || event.key.trim() === '';
                if (virtual && open) {
                    const rootNode = tree == null ? void 0 : tree.nodesRef.current.find((node)=>node.parentId == null);
                    const deepestNode = tree && rootNode ? (0, $9f8118feb50d8e8d$export$e7e88d43cb97db79)(tree.nodesRef.current, rootNode.id) : null;
                    if (isMoveKey && deepestNode && virtualItemRef) {
                        const eventObject = new KeyboardEvent('keydown', {
                            key: event.key,
                            bubbles: true
                        });
                        if (isCrossOpenKey || isCrossCloseKey) {
                            var _deepestNode$context, _deepestNode$context2;
                            const isCurrentTarget = ((_deepestNode$context = deepestNode.context) == null ? void 0 : _deepestNode$context.elements.domReference) === event.currentTarget;
                            const dispatchItem = isCrossCloseKey && !isCurrentTarget ? (_deepestNode$context2 = deepestNode.context) == null ? void 0 : _deepestNode$context2.elements.domReference : isCrossOpenKey ? listRef.current.find((item)=>(item == null ? void 0 : item.id) === activeId) : null;
                            if (dispatchItem) {
                                (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
                                dispatchItem.dispatchEvent(eventObject);
                                setVirtualId(undefined);
                            }
                        }
                        if ((isMainKey || isHomeOrEndKey) && deepestNode.context) {
                            if (deepestNode.context.open && deepestNode.parentId && event.currentTarget !== deepestNode.context.elements.domReference) {
                                var _deepestNode$context$;
                                (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
                                (_deepestNode$context$ = deepestNode.context.elements.domReference) == null || _deepestNode$context$.dispatchEvent(eventObject);
                                return;
                            }
                        }
                    }
                    return commonOnKeyDown(event);
                }
                // If a floating element should not open on arrow key down, avoid
                // setting `activeIndex` while it's closed.
                if (!open && !openOnArrowKeyDown && isArrowKey) return;
                if (isNavigationKey) {
                    const isParentMainKey = $8762903b8fe68977$var$isMainOrientationKey(event.key, getParentOrientation());
                    keyRef.current = nested && isParentMainKey ? null : event.key;
                }
                if (nested) {
                    if (isParentCrossOpenKey) {
                        (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
                        if (open) {
                            indexRef.current = (0, $9f8118feb50d8e8d$export$53f691ee0acc6058)(listRef, disabledIndicesRef.current);
                            onNavigate();
                        } else onOpenChange(true, event.nativeEvent, 'list-navigation');
                    }
                    return;
                }
                if (isMainKey) {
                    if (selectedIndex != null) indexRef.current = selectedIndex;
                    (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
                    if (!open && openOnArrowKeyDown) onOpenChange(true, event.nativeEvent, 'list-navigation');
                    else commonOnKeyDown(event);
                    if (open) onNavigate();
                }
            },
            onFocus () {
                if (open && !virtual) {
                    indexRef.current = -1;
                    onNavigate();
                }
            },
            onPointerDown: checkVirtualPointer,
            onPointerEnter: checkVirtualPointer,
            onMouseDown: checkVirtualMouse,
            onClick: checkVirtualMouse
        });
    }, [
        activeId,
        ariaActiveDescendantProp,
        cols,
        commonOnKeyDown,
        disabledIndicesRef,
        focusItemOnOpen,
        listRef,
        nested,
        onNavigate,
        onOpenChange,
        open,
        openOnArrowKeyDown,
        orientation,
        getParentOrientation,
        rtl,
        selectedIndex,
        tree,
        virtual,
        virtualItemRef
    ]);
    return $7fPBF.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
const $8762903b8fe68977$var$componentRoleToAriaRoleMap = /*#__PURE__*/ new Map([
    [
        'select',
        'listbox'
    ],
    [
        'combobox',
        'listbox'
    ],
    [
        'label',
        false
    ]
]);
/**
 * Adds base screen reader props to the reference and floating elements for a
 * given floating element `role`.
 * @see https://floating-ui.com/docs/useRole
 */ function $8762903b8fe68977$export$f66572793fa256a1(context, props) {
    var _elements$domReferenc, _componentRoleToAriaR;
    if (props === void 0) props = {};
    const { open: open, elements: elements, floatingId: defaultFloatingId } = context;
    const { enabled: enabled = true, role: role = 'dialog' } = props;
    const defaultReferenceId = $8762903b8fe68977$export$f680877a34711e37();
    const referenceId = ((_elements$domReferenc = elements.domReference) == null ? void 0 : _elements$domReferenc.id) || defaultReferenceId;
    const floatingId = $7fPBF.useMemo(()=>{
        var _getFloatingFocusElem;
        return ((_getFloatingFocusElem = (0, $9f8118feb50d8e8d$export$9b0901b5e9b45fc7)(elements.floating)) == null ? void 0 : _getFloatingFocusElem.id) || defaultFloatingId;
    }, [
        elements.floating,
        defaultFloatingId
    ]);
    const ariaRole = (_componentRoleToAriaR = $8762903b8fe68977$var$componentRoleToAriaRoleMap.get(role)) != null ? _componentRoleToAriaR : role;
    const parentId = $8762903b8fe68977$export$165209eae06d3488();
    const isNested = parentId != null;
    const reference = $7fPBF.useMemo(()=>{
        if (ariaRole === 'tooltip' || role === 'label') return {
            ["aria-" + (role === 'label' ? 'labelledby' : 'describedby')]: open ? floatingId : undefined
        };
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            'aria-expanded': open ? 'true' : 'false',
            'aria-haspopup': ariaRole === 'alertdialog' ? 'dialog' : ariaRole,
            'aria-controls': open ? floatingId : undefined
        }, ariaRole === 'listbox' && {
            role: 'combobox'
        }, ariaRole === 'menu' && {
            id: referenceId
        }, ariaRole === 'menu' && isNested && {
            role: 'menuitem'
        }, role === 'select' && {
            'aria-autocomplete': 'none'
        }, role === 'combobox' && {
            'aria-autocomplete': 'list'
        });
    }, [
        ariaRole,
        floatingId,
        isNested,
        open,
        referenceId,
        role
    ]);
    const floating = $7fPBF.useMemo(()=>{
        const floatingProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            id: floatingId
        }, ariaRole && {
            role: ariaRole
        });
        if (ariaRole === 'tooltip' || role === 'label') return floatingProps;
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, floatingProps, ariaRole === 'menu' && {
            'aria-labelledby': referenceId
        });
    }, [
        ariaRole,
        floatingId,
        referenceId,
        role
    ]);
    const item = $7fPBF.useCallback((_ref)=>{
        let { active: active, selected: selected } = _ref;
        const commonProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            role: 'option'
        }, active && {
            id: floatingId + "-fui-option"
        });
        // For `menu`, we are unable to tell if the item is a `menuitemradio`
        // or `menuitemcheckbox`. For backwards-compatibility reasons, also
        // avoid defaulting to `menuitem` as it may overwrite custom role props.
        switch(role){
            case 'select':
            case 'combobox':
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, commonProps), {
                    'aria-selected': selected
                });
        }
        return {};
    }, [
        floatingId,
        role
    ]);
    return $7fPBF.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating,
            item: item
        } : {}, [
        enabled,
        reference,
        floating,
        item
    ]);
}
// Converts a JS style key like `backgroundColor` to a CSS transition-property
// like `background-color`.
const $8762903b8fe68977$var$camelCaseToKebabCase = (str)=>str.replace(/[A-Z]+(?![a-z])|[A-Z]/g, ($, ofs)=>(ofs ? '-' : '') + $.toLowerCase());
function $8762903b8fe68977$var$execWithArgsOrReturn(valueOrFn, args) {
    return typeof valueOrFn === 'function' ? valueOrFn(args) : valueOrFn;
}
function $8762903b8fe68977$var$useDelayUnmount(open, durationMs) {
    const [isMounted, setIsMounted] = $7fPBF.useState(open);
    if (open && !isMounted) setIsMounted(true);
    $7fPBF.useEffect(()=>{
        if (!open && isMounted) {
            const timeout = setTimeout(()=>setIsMounted(false), durationMs);
            return ()=>clearTimeout(timeout);
        }
    }, [
        open,
        isMounted,
        durationMs
    ]);
    return isMounted;
}
/**
 * Provides a status string to apply CSS transitions to a floating element,
 * correctly handling placement-aware transitions.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstatus
 */ function $8762903b8fe68977$export$b2ef21706733f7e5(context, props) {
    if (props === void 0) props = {};
    const { open: open, elements: { floating: floating } } = context;
    const { duration: duration = 250 } = props;
    const isNumberDuration = typeof duration === 'number';
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [status, setStatus] = $7fPBF.useState('unmounted');
    const isMounted = $8762903b8fe68977$var$useDelayUnmount(open, closeDuration);
    if (!isMounted && status === 'close') setStatus('unmounted');
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (!floating) return;
        if (open) {
            setStatus('initial');
            const frame = requestAnimationFrame(()=>{
                // Ensure it opens before paint. With `FloatingDelayGroup`,
                // this avoids a flicker when moving between floating elements
                // to ensure one is always open with no missing frames.
                $fw0lo.flushSync(()=>{
                    setStatus('open');
                });
            });
            return ()=>{
                cancelAnimationFrame(frame);
            };
        }
        setStatus('close');
    }, [
        open,
        floating
    ]);
    return {
        isMounted: isMounted,
        status: status
    };
}
/**
 * Provides styles to apply CSS transitions to a floating element, correctly
 * handling placement-aware transitions. Wrapper around `useTransitionStatus`.
 * @see https://floating-ui.com/docs/useTransition#usetransitionstyles
 */ function $8762903b8fe68977$export$769fba13884bc2f4(context, props) {
    if (props === void 0) props = {};
    const { initial: unstable_initial = {
        opacity: 0
    }, open: unstable_open, close: unstable_close, common: unstable_common, duration: duration = 250 } = props;
    const placement = context.placement;
    const side = placement.split('-')[0];
    const fnArgs = $7fPBF.useMemo(()=>({
            side: side,
            placement: placement
        }), [
        side,
        placement
    ]);
    const isNumberDuration = typeof duration === 'number';
    const openDuration = (isNumberDuration ? duration : duration.open) || 0;
    const closeDuration = (isNumberDuration ? duration : duration.close) || 0;
    const [styles, setStyles] = $7fPBF.useState(()=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $8762903b8fe68977$var$execWithArgsOrReturn(unstable_common, fnArgs), $8762903b8fe68977$var$execWithArgsOrReturn(unstable_initial, fnArgs)));
    const { isMounted: isMounted, status: status } = $8762903b8fe68977$export$b2ef21706733f7e5(context, {
        duration: duration
    });
    const initialRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(unstable_initial);
    const openRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(unstable_open);
    const closeRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(unstable_close);
    const commonRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(unstable_common);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        const initialStyles = $8762903b8fe68977$var$execWithArgsOrReturn(initialRef.current, fnArgs);
        const closeStyles = $8762903b8fe68977$var$execWithArgsOrReturn(closeRef.current, fnArgs);
        const commonStyles = $8762903b8fe68977$var$execWithArgsOrReturn(commonRef.current, fnArgs);
        const openStyles = $8762903b8fe68977$var$execWithArgsOrReturn(openRef.current, fnArgs) || Object.keys(initialStyles).reduce((acc, key)=>{
            acc[key] = '';
            return acc;
        }, {});
        if (status === 'initial') setStyles((styles)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                transitionProperty: styles.transitionProperty
            }, commonStyles, initialStyles));
        if (status === 'open') setStyles((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            transitionProperty: Object.keys(openStyles).map($8762903b8fe68977$var$camelCaseToKebabCase).join(','),
            transitionDuration: openDuration + "ms"
        }, commonStyles, openStyles));
        if (status === 'close') {
            const styles = closeStyles || initialStyles;
            setStyles((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                transitionProperty: Object.keys(styles).map($8762903b8fe68977$var$camelCaseToKebabCase).join(','),
                transitionDuration: closeDuration + "ms"
            }, commonStyles, styles));
        }
    }, [
        closeDuration,
        closeRef,
        initialRef,
        openRef,
        commonRef,
        openDuration,
        status,
        fnArgs
    ]);
    return {
        isMounted: isMounted,
        styles: styles
    };
}
/**
 * Provides a matching callback that can be used to focus an item as the user
 * types, often used in tandem with `useListNavigation()`.
 * @see https://floating-ui.com/docs/useTypeahead
 */ function $8762903b8fe68977$export$d8d674d50b73ba93(context, props) {
    var _ref;
    const { open: open, dataRef: dataRef } = context;
    const { listRef: listRef, activeIndex: activeIndex, onMatch: unstable_onMatch, onTypingChange: unstable_onTypingChange, enabled: enabled = true, findMatch: findMatch = null, resetMs: resetMs = 750, ignoreKeys: ignoreKeys = [], selectedIndex: selectedIndex = null } = props;
    const timeoutIdRef = $7fPBF.useRef(-1);
    const stringRef = $7fPBF.useRef('');
    const prevIndexRef = $7fPBF.useRef((_ref = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref : -1);
    const matchIndexRef = $7fPBF.useRef(null);
    const onMatch = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(unstable_onMatch);
    const onTypingChange = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(unstable_onTypingChange);
    const findMatchRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(findMatch);
    const ignoreKeysRef = (0, $9f8118feb50d8e8d$export$bcd07ba85a740103)(ignoreKeys);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        if (open) {
            $8762903b8fe68977$var$clearTimeoutIfSet(timeoutIdRef);
            matchIndexRef.current = null;
            stringRef.current = '';
        }
    }, [
        open
    ]);
    (0, $9f8118feb50d8e8d$export$bb3b3b3acfd7447f)(()=>{
        // Sync arrow key navigation but not typeahead navigation.
        if (open && stringRef.current === '') {
            var _ref2;
            prevIndexRef.current = (_ref2 = selectedIndex != null ? selectedIndex : activeIndex) != null ? _ref2 : -1;
        }
    }, [
        open,
        selectedIndex,
        activeIndex
    ]);
    const setTypingChange = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((value)=>{
        if (value) {
            if (!dataRef.current.typing) {
                dataRef.current.typing = value;
                onTypingChange(value);
            }
        } else if (dataRef.current.typing) {
            dataRef.current.typing = value;
            onTypingChange(value);
        }
    });
    const onKeyDown = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)((event)=>{
        function getMatchingIndex(list, orderedList, string) {
            const str = findMatchRef.current ? findMatchRef.current(orderedList, string) : orderedList.find((text)=>(text == null ? void 0 : text.toLocaleLowerCase().indexOf(string.toLocaleLowerCase())) === 0);
            return str ? list.indexOf(str) : -1;
        }
        const listContent = listRef.current;
        if (stringRef.current.length > 0 && stringRef.current[0] !== ' ') {
            if (getMatchingIndex(listContent, listContent, stringRef.current) === -1) setTypingChange(false);
            else if (event.key === ' ') (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
        }
        if (listContent == null || ignoreKeysRef.current.includes(event.key) || // Character key.
        event.key.length !== 1 || // Modifier key.
        event.ctrlKey || event.metaKey || event.altKey) return;
        if (open && event.key !== ' ') {
            (0, $9f8118feb50d8e8d$export$7ae4cd3a66c1e050)(event);
            setTypingChange(true);
        }
        // Bail out if the list contains a word like "llama" or "aaron". TODO:
        // allow it in this case, too.
        const allowRapidSuccessionOfFirstLetter = listContent.every((text)=>{
            var _text$, _text$2;
            return text ? ((_text$ = text[0]) == null ? void 0 : _text$.toLocaleLowerCase()) !== ((_text$2 = text[1]) == null ? void 0 : _text$2.toLocaleLowerCase()) : true;
        });
        // Allows the user to cycle through items that start with the same letter
        // in rapid succession.
        if (allowRapidSuccessionOfFirstLetter && stringRef.current === event.key) {
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
        }
        stringRef.current += event.key;
        $8762903b8fe68977$var$clearTimeoutIfSet(timeoutIdRef);
        timeoutIdRef.current = window.setTimeout(()=>{
            stringRef.current = '';
            prevIndexRef.current = matchIndexRef.current;
            setTypingChange(false);
        }, resetMs);
        const prevIndex = prevIndexRef.current;
        const index = getMatchingIndex(listContent, [
            ...listContent.slice((prevIndex || 0) + 1),
            ...listContent.slice(0, (prevIndex || 0) + 1)
        ], stringRef.current);
        if (index !== -1) {
            onMatch(index);
            matchIndexRef.current = index;
        } else if (event.key !== ' ') {
            stringRef.current = '';
            setTypingChange(false);
        }
    });
    const reference = $7fPBF.useMemo(()=>({
            onKeyDown: onKeyDown
        }), [
        onKeyDown
    ]);
    const floating = $7fPBF.useMemo(()=>{
        return {
            onKeyDown: onKeyDown,
            onKeyUp (event) {
                if (event.key === ' ') setTypingChange(false);
            }
        };
    }, [
        onKeyDown,
        setTypingChange
    ]);
    return $7fPBF.useMemo(()=>enabled ? {
            reference: reference,
            floating: floating
        } : {}, [
        enabled,
        reference,
        floating
    ]);
}
function $8762903b8fe68977$var$getArgsWithCustomFloatingHeight(state, height) {
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
        rects: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.rects), {
            floating: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.rects.floating), {
                height: height
            })
        })
    });
}
/**
 * Positions the floating element such that an inner element inside of it is
 * anchored to the reference element.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ const $8762903b8fe68977$export$4ae363f1d88fb658 = (props)=>({
        name: 'inner',
        options: props,
        async fn (state) {
            const _evaluate = (0, $91f1cb25f4ca20c6$export$fef61f332f2c0afc)(props, state), { listRef: listRef, overflowRef: overflowRef, onFallbackChange: onFallbackChange, offset: innerOffset = 0, index: index = 0, minItemsVisible: minItemsVisible = 4, referenceOverflowThreshold: referenceOverflowThreshold = 0, scrollRef: scrollRef } = _evaluate, detectOverflowOptions = (0, $8901fc92b5563702$export$71511d61b312f219)(_evaluate, [
                "listRef",
                "overflowRef",
                "onFallbackChange",
                "offset",
                "index",
                "minItemsVisible",
                "referenceOverflowThreshold",
                "scrollRef"
            ]);
            const { rects: rects, platform: platform, elements: { floating: floating } } = state;
            const item = listRef.current[index];
            const scrollEl = (scrollRef == null ? void 0 : scrollRef.current) || floating;
            // Valid combinations:
            // 1. Floating element is the scrollRef and has a border (default)
            // 2. Floating element is not the scrollRef, floating element has a border
            // 3. Floating element is not the scrollRef, scrollRef has a border
            // Floating > {...getFloatingProps()} wrapper > scrollRef > items is not
            // allowed as VoiceOver doesn't work.
            const clientTop = floating.clientTop || scrollEl.clientTop;
            const floatingIsBordered = floating.clientTop !== 0;
            const scrollElIsBordered = scrollEl.clientTop !== 0;
            const floatingIsScrollEl = floating === scrollEl;
            if (!item) return {};
            const nextArgs = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state, await (0, $2a1639b232695612$export$cc800923e997bb8)(-item.offsetTop - floating.clientTop - rects.reference.height / 2 - item.offsetHeight / 2 - innerOffset).fn(state));
            const overflow = await platform.detectOverflow($8762903b8fe68977$var$getArgsWithCustomFloatingHeight(nextArgs, scrollEl.scrollHeight + clientTop + floating.clientTop), detectOverflowOptions);
            const refOverflow = await platform.detectOverflow(nextArgs, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, detectOverflowOptions), {
                elementContext: 'reference'
            }));
            const diffY = (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(0, overflow.top);
            const nextY = nextArgs.y + diffY;
            const isScrollable = scrollEl.scrollHeight > scrollEl.clientHeight;
            const rounder = isScrollable ? (v)=>v : (0, $91f1cb25f4ca20c6$export$2077e0241d6afd3c);
            const maxHeight = rounder((0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(0, scrollEl.scrollHeight + (floatingIsBordered && floatingIsScrollEl || scrollElIsBordered ? clientTop * 2 : 0) - diffY - (0, $91f1cb25f4ca20c6$export$8960430cfd85939f)(0, overflow.bottom)));
            scrollEl.style.maxHeight = maxHeight + "px";
            scrollEl.scrollTop = diffY;
            // There is not enough space, fallback to standard anchored positioning
            if (onFallbackChange) {
                const shouldFallback = scrollEl.offsetHeight < item.offsetHeight * (0, $91f1cb25f4ca20c6$export$96ec731ed4dcb222)(minItemsVisible, listRef.current.length) - 1 || refOverflow.top >= -referenceOverflowThreshold || refOverflow.bottom >= -referenceOverflowThreshold;
                $fw0lo.flushSync(()=>onFallbackChange(shouldFallback));
            }
            if (overflowRef) overflowRef.current = await platform.detectOverflow($8762903b8fe68977$var$getArgsWithCustomFloatingHeight((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, nextArgs), {
                y: nextY
            }), scrollEl.offsetHeight + clientTop + floating.clientTop), detectOverflowOptions);
            return {
                y: nextY
            };
        }
    });
/**
 * Changes the `inner` middleware's `offset` upon a `wheel` event to
 * expand the floating element's height, revealing more list items.
 * @see https://floating-ui.com/docs/inner
 * @deprecated
 */ function $8762903b8fe68977$export$3d74b0dda7cc82ff(context, props) {
    const { open: open, elements: elements } = context;
    const { enabled: enabled = true, overflowRef: overflowRef, scrollRef: scrollRef, onChange: unstable_onChange } = props;
    const onChange = (0, $9f8118feb50d8e8d$export$7f54fc3180508a52)(unstable_onChange);
    const controlledScrollingRef = $7fPBF.useRef(false);
    const prevScrollTopRef = $7fPBF.useRef(null);
    const initialOverflowRef = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (!enabled) return;
        function onWheel(e) {
            if (e.ctrlKey || !el || overflowRef.current == null) return;
            const dY = e.deltaY;
            const isAtTop = overflowRef.current.top >= -0.5;
            const isAtBottom = overflowRef.current.bottom >= -0.5;
            const remainingScroll = el.scrollHeight - el.clientHeight;
            const sign = dY < 0 ? -1 : 1;
            const method = dY < 0 ? 'max' : 'min';
            if (el.scrollHeight <= el.clientHeight) return;
            if (!isAtTop && dY > 0 || !isAtBottom && dY < 0) {
                e.preventDefault();
                $fw0lo.flushSync(()=>{
                    onChange((d)=>d + Math[method](dY, remainingScroll * sign));
                });
            } else if (/firefox/i.test((0, $9f8118feb50d8e8d$export$7935961ef7719cb0)())) // Needed to propagate scrolling during momentum scrolling phase once
            // it gets limited by the boundary. UX improvement, not critical.
            el.scrollTop += dY;
        }
        const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
        if (open && el) {
            el.addEventListener('wheel', onWheel);
            // Wait for the position to be ready.
            requestAnimationFrame(()=>{
                prevScrollTopRef.current = el.scrollTop;
                if (overflowRef.current != null) initialOverflowRef.current = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, overflowRef.current);
            });
            return ()=>{
                prevScrollTopRef.current = null;
                initialOverflowRef.current = null;
                el.removeEventListener('wheel', onWheel);
            };
        }
    }, [
        enabled,
        open,
        elements.floating,
        overflowRef,
        scrollRef,
        onChange
    ]);
    const floating = $7fPBF.useMemo(()=>({
            onKeyDown () {
                controlledScrollingRef.current = true;
            },
            onWheel () {
                controlledScrollingRef.current = false;
            },
            onPointerMove () {
                controlledScrollingRef.current = false;
            },
            onScroll () {
                const el = (scrollRef == null ? void 0 : scrollRef.current) || elements.floating;
                if (!overflowRef.current || !el || !controlledScrollingRef.current) return;
                if (prevScrollTopRef.current !== null) {
                    const scrollDiff = el.scrollTop - prevScrollTopRef.current;
                    if (overflowRef.current.bottom < -0.5 && scrollDiff < -1 || overflowRef.current.top < -0.5 && scrollDiff > 1) $fw0lo.flushSync(()=>onChange((d)=>d + scrollDiff));
                }
                // [Firefox] Wait for the height change to have been applied.
                requestAnimationFrame(()=>{
                    prevScrollTopRef.current = el.scrollTop;
                });
            }
        }), [
        elements.floating,
        onChange,
        overflowRef,
        scrollRef
    ]);
    return $7fPBF.useMemo(()=>enabled ? {
            floating: floating
        } : {}, [
        enabled,
        floating
    ]);
}
function $8762903b8fe68977$var$getNodeChildren(nodes, id, onlyOpenChildren) {
    if (onlyOpenChildren === void 0) onlyOpenChildren = true;
    const directChildren = nodes.filter((node)=>{
        var _node$context;
        return node.parentId === id && (!onlyOpenChildren || ((_node$context = node.context) == null ? void 0 : _node$context.open));
    });
    return directChildren.flatMap((child)=>[
            child,
            ...$8762903b8fe68977$var$getNodeChildren(nodes, child.id, onlyOpenChildren)
        ]);
}
function $8762903b8fe68977$var$isPointInPolygon(point, polygon) {
    const [x, y] = point;
    let isInside = false;
    const length = polygon.length;
    for(let i = 0, j = length - 1; i < length; j = i++){
        const [xi, yi] = polygon[i] || [
            0,
            0
        ];
        const [xj, yj] = polygon[j] || [
            0,
            0
        ];
        const intersect = yi >= y !== yj >= y && x <= (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) isInside = !isInside;
    }
    return isInside;
}
function $8762903b8fe68977$var$isInside(point, rect) {
    return point[0] >= rect.x && point[0] <= rect.x + rect.width && point[1] >= rect.y && point[1] <= rect.y + rect.height;
}
/**
 * Generates a safe polygon area that the user can traverse without closing the
 * floating element once leaving the reference element.
 * @see https://floating-ui.com/docs/useHover#safepolygon
 */ function $8762903b8fe68977$export$7484214ab62358d2(options) {
    if (options === void 0) options = {};
    const { buffer: buffer = 0.5, blockPointerEvents: blockPointerEvents = false, requireIntent: requireIntent = true } = options;
    const timeoutRef = {
        current: -1
    };
    let hasLanded = false;
    let lastX = null;
    let lastY = null;
    let lastCursorTime = typeof performance !== 'undefined' ? performance.now() : 0;
    function getCursorSpeed(x, y) {
        const currentTime = performance.now();
        const elapsedTime = currentTime - lastCursorTime;
        if (lastX === null || lastY === null || elapsedTime === 0) {
            lastX = x;
            lastY = y;
            lastCursorTime = currentTime;
            return null;
        }
        const deltaX = x - lastX;
        const deltaY = y - lastY;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        const speed = distance / elapsedTime; // px / ms
        lastX = x;
        lastY = y;
        lastCursorTime = currentTime;
        return speed;
    }
    const fn = (_ref)=>{
        let { x: x, y: y, placement: placement, elements: elements, onClose: onClose, nodeId: nodeId, tree: tree } = _ref;
        return function onMouseMove(event) {
            function close() {
                $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef);
                onClose();
            }
            $8762903b8fe68977$var$clearTimeoutIfSet(timeoutRef);
            if (!elements.domReference || !elements.floating || placement == null || x == null || y == null) return;
            const { clientX: clientX, clientY: clientY } = event;
            const clientPoint = [
                clientX,
                clientY
            ];
            const target = $8762903b8fe68977$var$getTarget(event);
            const isLeave = event.type === 'mouseleave';
            const isOverFloatingEl = $8762903b8fe68977$var$contains(elements.floating, target);
            const isOverReferenceEl = $8762903b8fe68977$var$contains(elements.domReference, target);
            const refRect = elements.domReference.getBoundingClientRect();
            const rect = elements.floating.getBoundingClientRect();
            const side = placement.split('-')[0];
            const cursorLeaveFromRight = x > rect.right - rect.width / 2;
            const cursorLeaveFromBottom = y > rect.bottom - rect.height / 2;
            const isOverReferenceRect = $8762903b8fe68977$var$isInside(clientPoint, refRect);
            const isFloatingWider = rect.width > refRect.width;
            const isFloatingTaller = rect.height > refRect.height;
            const left = (isFloatingWider ? refRect : rect).left;
            const right = (isFloatingWider ? refRect : rect).right;
            const top = (isFloatingTaller ? refRect : rect).top;
            const bottom = (isFloatingTaller ? refRect : rect).bottom;
            if (isOverFloatingEl) {
                hasLanded = true;
                if (!isLeave) return;
            }
            if (isOverReferenceEl) hasLanded = false;
            if (isOverReferenceEl && !isLeave) {
                hasLanded = true;
                return;
            }
            // Prevent overlapping floating element from being stuck in an open-close
            // loop: https://github.com/floating-ui/floating-ui/issues/1910
            if (isLeave && (0, $d2553f707975908a$export$45a5e7f76e0caa8d)(event.relatedTarget) && $8762903b8fe68977$var$contains(elements.floating, event.relatedTarget)) return;
            // If any nested child is open, abort.
            if (tree && $8762903b8fe68977$var$getNodeChildren(tree.nodesRef.current, nodeId).length) return;
            // If the pointer is leaving from the opposite side, the "buffer" logic
            // creates a point where the floating element remains open, but should be
            // ignored.
            // A constant of 1 handles floating point rounding errors.
            if (side === 'top' && y >= refRect.bottom - 1 || side === 'bottom' && y <= refRect.top + 1 || side === 'left' && x >= refRect.right - 1 || side === 'right' && x <= refRect.left + 1) return close();
            // Ignore when the cursor is within the rectangular trough between the
            // two elements. Since the triangle is created from the cursor point,
            // which can start beyond the ref element's edge, traversing back and
            // forth from the ref to the floating element can cause it to close. This
            // ensures it always remains open in that case.
            let rectPoly = [];
            switch(side){
                case 'top':
                    rectPoly = [
                        [
                            left,
                            refRect.top + 1
                        ],
                        [
                            left,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            rect.bottom - 1
                        ],
                        [
                            right,
                            refRect.top + 1
                        ]
                    ];
                    break;
                case 'bottom':
                    rectPoly = [
                        [
                            left,
                            rect.top + 1
                        ],
                        [
                            left,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            refRect.bottom - 1
                        ],
                        [
                            right,
                            rect.top + 1
                        ]
                    ];
                    break;
                case 'left':
                    rectPoly = [
                        [
                            rect.right - 1,
                            bottom
                        ],
                        [
                            rect.right - 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            top
                        ],
                        [
                            refRect.left + 1,
                            bottom
                        ]
                    ];
                    break;
                case 'right':
                    rectPoly = [
                        [
                            refRect.right - 1,
                            bottom
                        ],
                        [
                            refRect.right - 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            top
                        ],
                        [
                            rect.left + 1,
                            bottom
                        ]
                    ];
                    break;
            }
            function getPolygon(_ref2) {
                let [x, y] = _ref2;
                switch(side){
                    case 'top':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y + buffer + 1
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.bottom - buffer : isFloatingWider ? rect.bottom - buffer : rect.top
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.bottom - buffer : rect.top : rect.bottom - buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'bottom':
                        {
                            const cursorPointOne = [
                                isFloatingWider ? x + buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const cursorPointTwo = [
                                isFloatingWider ? x - buffer / 2 : cursorLeaveFromRight ? x + buffer * 4 : x - buffer * 4,
                                y - buffer
                            ];
                            const commonPoints = [
                                [
                                    rect.left,
                                    cursorLeaveFromRight ? rect.top + buffer : isFloatingWider ? rect.top + buffer : rect.bottom
                                ],
                                [
                                    rect.right,
                                    cursorLeaveFromRight ? isFloatingWider ? rect.top + buffer : rect.bottom : rect.top + buffer
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                    case 'left':
                        {
                            const cursorPointOne = [
                                x + buffer + 1,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x + buffer + 1,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.right - buffer : isFloatingTaller ? rect.right - buffer : rect.left,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.right - buffer : rect.left : rect.right - buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                ...commonPoints,
                                cursorPointOne,
                                cursorPointTwo
                            ];
                        }
                    case 'right':
                        {
                            const cursorPointOne = [
                                x - buffer,
                                isFloatingTaller ? y + buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const cursorPointTwo = [
                                x - buffer,
                                isFloatingTaller ? y - buffer / 2 : cursorLeaveFromBottom ? y + buffer * 4 : y - buffer * 4
                            ];
                            const commonPoints = [
                                [
                                    cursorLeaveFromBottom ? rect.left + buffer : isFloatingTaller ? rect.left + buffer : rect.right,
                                    rect.top
                                ],
                                [
                                    cursorLeaveFromBottom ? isFloatingTaller ? rect.left + buffer : rect.right : rect.left + buffer,
                                    rect.bottom
                                ]
                            ];
                            return [
                                cursorPointOne,
                                cursorPointTwo,
                                ...commonPoints
                            ];
                        }
                }
            }
            if ($8762903b8fe68977$var$isPointInPolygon([
                clientX,
                clientY
            ], rectPoly)) return;
            if (hasLanded && !isOverReferenceRect) return close();
            if (!isLeave && requireIntent) {
                const cursorSpeed = getCursorSpeed(event.clientX, event.clientY);
                const cursorSpeedThreshold = 0.1;
                if (cursorSpeed !== null && cursorSpeed < cursorSpeedThreshold) return close();
            }
            if (!$8762903b8fe68977$var$isPointInPolygon([
                clientX,
                clientY
            ], getPolygon([
                x,
                y
            ]))) close();
            else if (!hasLanded && requireIntent) timeoutRef.current = window.setTimeout(close, 40);
        };
    };
    fn.__options = {
        blockPointerEvents: blockPointerEvents
    };
    return fn;
}



var $fw0lo = parcelRequire("fw0lo");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $7c7b1a6f859720e7$var$_extendStatics = function extendStatics(d, b) {
    $7c7b1a6f859720e7$var$_extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $7c7b1a6f859720e7$var$_extendStatics(d, b);
};
function $7c7b1a6f859720e7$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $7c7b1a6f859720e7$var$_extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7c7b1a6f859720e7$var$_assign = function __assign() {
    $7c7b1a6f859720e7$var$_assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7c7b1a6f859720e7$var$_assign.apply(this, arguments);
};
function $7c7b1a6f859720e7$var$__spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
typeof SuppressedError === "function" && SuppressedError;
var $7c7b1a6f859720e7$export$946daa762919616e = function(_a) {
    var _b = _a.showTimeSelectOnly, showTimeSelectOnly = _b === void 0 ? false : _b, _c = _a.showTime, showTime = _c === void 0 ? false : _c, className = _a.className, children = _a.children, inline = _a.inline;
    var ariaLabel = showTimeSelectOnly ? "Choose Time" : "Choose Date".concat(showTime ? " and Time" : "");
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: className,
        "aria-label": ariaLabel,
        role: inline ? undefined : "dialog",
        "aria-modal": inline ? undefined : "true"
    }, children);
};
var $7c7b1a6f859720e7$var$useDetectClickOutside = function(onClickOutside, ignoreClass) {
    var ref = (0, $7fPBF.useRef)(null);
    var onClickOutsideRef = (0, $7fPBF.useRef)(onClickOutside);
    (0, $7fPBF.useEffect)(function() {
        onClickOutsideRef.current = onClickOutside;
    }, [
        onClickOutside
    ]);
    var handleClickOutside = (0, $7fPBF.useCallback)(function(event) {
        var _a;
        var target = event.composed && event.composedPath && event.composedPath().find(function(eventTarget) {
            return eventTarget instanceof Node;
        }) || event.target;
        if (ref.current && !ref.current.contains(target)) {
            if (!(ignoreClass && target instanceof HTMLElement && target.classList.contains(ignoreClass))) (_a = onClickOutsideRef.current) === null || _a === void 0 || _a.call(onClickOutsideRef, event);
        }
    }, [
        ignoreClass
    ]);
    (0, $7fPBF.useEffect)(function() {
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        handleClickOutside
    ]);
    return ref;
};
var $7c7b1a6f859720e7$var$ClickOutsideWrapper = function(_a) {
    var children = _a.children, onClickOutside = _a.onClickOutside, className = _a.className, containerRef = _a.containerRef, style = _a.style, ignoreClass = _a.ignoreClass;
    var detectRef = $7c7b1a6f859720e7$var$useDetectClickOutside(onClickOutside, ignoreClass);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: className,
        style: style,
        ref: function(node) {
            detectRef.current = node;
            if (containerRef) containerRef.current = node;
        }
    }, children);
};
var $7c7b1a6f859720e7$var$KeyType;
(function(KeyType) {
    KeyType["ArrowUp"] = "ArrowUp";
    KeyType["ArrowDown"] = "ArrowDown";
    KeyType["ArrowLeft"] = "ArrowLeft";
    KeyType["ArrowRight"] = "ArrowRight";
    KeyType["PageUp"] = "PageUp";
    KeyType["PageDown"] = "PageDown";
    KeyType["Home"] = "Home";
    KeyType["End"] = "End";
    KeyType["Enter"] = "Enter";
    KeyType["Space"] = " ";
    KeyType["Tab"] = "Tab";
    KeyType["Escape"] = "Escape";
    KeyType["Backspace"] = "Backspace";
    KeyType["X"] = "x";
})($7c7b1a6f859720e7$var$KeyType || ($7c7b1a6f859720e7$var$KeyType = {}));
function $7c7b1a6f859720e7$var$getLocaleScope() {
    // Use this cast to avoid messing with users globalThis (like window) and the rest of keys in the globalThis object we don't care about
    var scope = typeof window !== "undefined" ? window : globalThis;
    return scope;
}
var $7c7b1a6f859720e7$var$DEFAULT_YEAR_ITEM_NUMBER = 12;
// ** Date Constructors **
function $7c7b1a6f859720e7$var$newDate(value) {
    if (value == null) return new Date();
    var d = typeof value === "string" ? (0, $0de707870e87904f$export$4393d2ccbbedb219)(value) : (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(value);
    return $7c7b1a6f859720e7$var$isValid(d) ? d : new Date();
}
/**
 * Parses a date.
 *
 * @param value - The string representing the Date in a parsable form, e.g., ISO 1861
 * @param dateFormat - The date format.
 * @param locale - The locale.
 * @param strictParsing - The strict parsing flag.
 * @param refDate - The base date to be passed to date-fns parse() function.
 * @returns - The parsed date or null.
 */ function $7c7b1a6f859720e7$var$parseDate(value, dateFormat, locale, strictParsing, refDate) {
    if (refDate === void 0) refDate = $7c7b1a6f859720e7$var$newDate();
    var localeObject = $7c7b1a6f859720e7$var$getLocaleObject(locale) || $7c7b1a6f859720e7$var$getLocaleObject($7c7b1a6f859720e7$export$f09106e7c6677ec5());
    var formats = Array.isArray(dateFormat) ? dateFormat : [
        dateFormat
    ];
    for(var _i = 0, formats_1 = formats; _i < formats_1.length; _i++){
        var format_1 = formats_1[_i];
        var parsedDate = (0, $007c7f8b5e724128$export$98e6a39c04603d36)(value, format_1, refDate, {
            locale: localeObject,
            useAdditionalWeekYearTokens: true,
            useAdditionalDayOfYearTokens: true
        });
        if ($7c7b1a6f859720e7$var$isValid(parsedDate) && (!strictParsing || value === $7c7b1a6f859720e7$var$formatDate(parsedDate, format_1, locale))) return parsedDate;
    }
    return null;
}
/**
 * Checks if a given date is valid and not before the minimum date.
 * @param date - The date to be checked.
 * @param minDate - The minimum date allowed. If not provided, defaults to "1/1/1800".
 * @returns A boolean value indicating whether the date is valid and not before the minimum date.
 */ function $7c7b1a6f859720e7$var$isValid(date, minDate) {
    /* the fallback date is essential to not break test case
     * `should auto update calendar when the updated date text is after props.minDate`
     * and backward compatibility respectfully
     */ return (0, $070b8e24dc8d9a3e$export$1ea939691cdc45b8)(date) && !(0, $eb21892051383660$export$5c007e10c6929c95)(date, new Date("1/1/1800"));
}
// ** Date Formatting **
/**
 * Formats a date.
 *
 * @param date - The date.
 * @param formatStr - The format string.
 * @param locale - The locale.
 * @returns - The formatted date.
 */ function $7c7b1a6f859720e7$var$formatDate(date, formatStr, locale) {
    if (locale === "en") return (0, $38b981d0856c132a$export$d9468344d3651243)(date, formatStr, {
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
    var localeObj = locale ? $7c7b1a6f859720e7$var$getLocaleObject(locale) : undefined;
    if (locale && !localeObj) console.warn("A locale object was not found for the provided string [\"".concat(locale, "\"]."));
    localeObj = localeObj || $7c7b1a6f859720e7$var$getLocaleObject($7c7b1a6f859720e7$export$f09106e7c6677ec5());
    return (0, $38b981d0856c132a$export$d9468344d3651243)(date, formatStr, {
        locale: localeObj,
        useAdditionalWeekYearTokens: true,
        useAdditionalDayOfYearTokens: true
    });
}
/**
 * Safely formats a date.
 *
 * @param date - The date.
 * @param options - An object containing the dateFormat and locale.
 * @returns - The formatted date or an empty string.
 */ function $7c7b1a6f859720e7$var$safeDateFormat(date, _a) {
    var dateFormat = _a.dateFormat, locale = _a.locale;
    var formatStr = Array.isArray(dateFormat) && dateFormat.length > 0 ? dateFormat[0] : dateFormat; // Cast to string because it's impossible to get `string | string[] | undefined` here and typescript doesn't know that
    return date && $7c7b1a6f859720e7$var$formatDate(date, formatStr, locale) || "";
}
/**
 * Used as a delimiter to separate two dates when formatting a date range
 */ var $7c7b1a6f859720e7$var$DATE_RANGE_SEPARATOR = " - ";
/**
 * Safely formats a date range.
 *
 * @param startDate - The start date.
 * @param endDate - The end date.
 * @param props - The props.
 * @returns - The formatted date range or an empty string.
 */ function $7c7b1a6f859720e7$var$safeDateRangeFormat(startDate, endDate, props) {
    if (!startDate && !endDate) return "";
    var formattedStartDate = startDate ? $7c7b1a6f859720e7$var$safeDateFormat(startDate, props) : "";
    var formattedEndDate = endDate ? $7c7b1a6f859720e7$var$safeDateFormat(endDate, props) : "";
    var dateRangeSeparator = props.rangeSeparator || $7c7b1a6f859720e7$var$DATE_RANGE_SEPARATOR;
    return "".concat(formattedStartDate).concat(dateRangeSeparator).concat(formattedEndDate);
}
/**
 * Safely formats multiple dates.
 *
 * @param dates - The dates.
 * @param props - The props.
 * @returns - The formatted dates or an empty string.
 */ function $7c7b1a6f859720e7$var$safeMultipleDatesFormat(dates, props) {
    if (!(dates === null || dates === void 0 ? void 0 : dates.length)) return "";
    var formattedFirstDate = dates[0] ? $7c7b1a6f859720e7$var$safeDateFormat(dates[0], props) : "";
    if (dates.length === 1) return formattedFirstDate;
    if (dates.length === 2 && dates[1]) {
        var formattedSecondDate = $7c7b1a6f859720e7$var$safeDateFormat(dates[1], props);
        return "".concat(formattedFirstDate, ", ").concat(formattedSecondDate);
    }
    var extraDatesCount = dates.length - 1;
    return "".concat(formattedFirstDate, " (+").concat(extraDatesCount, ")");
}
// ** Date Setters **
/**
 * Sets the time for a given date.
 *
 * @param date - The date.
 * @param time - An object containing the hour, minute, and second.
 * @returns - The date with the time set.
 */ function $7c7b1a6f859720e7$var$setTime(date, _a) {
    var _b = _a.hour, hour = _b === void 0 ? 0 : _b, _c = _a.minute, minute = _c === void 0 ? 0 : _c, _d = _a.second, second = _d === void 0 ? 0 : _d;
    return (0, $879723943f4caa59$export$f86b797a4659b781)((0, $dd3d355dc6207ba3$export$ad569bf1c79ea89d)((0, $d9b52d32db130922$export$aec44746644cbf43)(date, second), minute), hour);
}
/**
 * Gets the week of the year for a given date.
 *
 * @param date - The date.
 * @returns - The week of the year.
 */ function $7c7b1a6f859720e7$var$getWeek(date) {
    return (0, $21702feccb8583bb$export$7cabdc5698b63e2f)(date);
}
/**
 * Gets the day of the week code for a given day.
 *
 * @param day - The day.
 * @param locale - The locale.
 * @returns - The day of the week code.
 */ function $7c7b1a6f859720e7$var$getDayOfWeekCode(day, locale) {
    return $7c7b1a6f859720e7$var$formatDate(day, "ddd", locale);
}
// *** Start of ***
/**
 * Gets the start of the day for a given date.
 *
 * @param date - The date.
 * @returns - The start of the day.
 */ function $7c7b1a6f859720e7$var$getStartOfDay(date) {
    return (0, $6adcf5e4df55379b$export$63fa379ae8a9ba2)(date);
}
/**
 * Gets the start of the week for a given date.
 *
 * @param date - The date.
 * @param locale - The locale.
 * @param calendarStartDay - The day the calendar starts on.
 * @returns - The start of the week.
 */ function $7c7b1a6f859720e7$var$getStartOfWeek(date, locale, calendarStartDay) {
    var localeObj = locale ? $7c7b1a6f859720e7$var$getLocaleObject(locale) : $7c7b1a6f859720e7$var$getLocaleObject($7c7b1a6f859720e7$export$f09106e7c6677ec5());
    return (0, $f9d909ef454eaaa1$export$42c81a444fbfb5d4)(date, {
        locale: localeObj,
        weekStartsOn: calendarStartDay
    });
}
/**
 * Gets the start of the month for a given date.
 *
 * @param date - The date.
 * @returns - The start of the month.
 */ function $7c7b1a6f859720e7$var$getStartOfMonth(date) {
    return (0, $51ef0e18718a1681$export$a5a3b454ada2268e)(date);
}
/**
 * Gets the start of the year for a given date.
 *
 * @param date - The date.
 * @returns - The start of the year.
 */ function $7c7b1a6f859720e7$var$getStartOfYear(date) {
    return (0, $78040c6eb7d2e9d1$export$f91e89d3d0406102)(date);
}
/**
 * Gets the start of the quarter for a given date.
 *
 * @param date - The date.
 * @returns - The start of the quarter.
 */ function $7c7b1a6f859720e7$var$getStartOfQuarter(date) {
    return (0, $2f5f22891d29251a$export$69be7267a042ecb3)(date);
}
/**
 * Gets the start of today.
 *
 * @returns - The start of today.
 */ function $7c7b1a6f859720e7$var$getStartOfToday() {
    return (0, $6adcf5e4df55379b$export$63fa379ae8a9ba2)($7c7b1a6f859720e7$var$newDate());
}
// *** End of ***
/**
 * Gets the end of the day for a given date.
 *
 * @param date - The date.
 * @returns - The end of the day.
 */ function $7c7b1a6f859720e7$var$getEndOfDay(date) {
    return (0, $da86bf3c3f1468b8$export$eb9a03f0e9aa6cea)(date);
}
/**
 * Gets the end of the week for a given date.
 *
 * @param date - The date.
 * @returns - The end of the week.
 */ function $7c7b1a6f859720e7$var$getEndOfWeek(date) {
    return (0, $0af5ab6305acda41$export$ef8b6d9133084f4e)(date);
}
/**
 * Gets the end of the month for a given date.
 *
 * @param date - The date.
 * @returns - The end of the month.
 */ function $7c7b1a6f859720e7$var$getEndOfMonth(date) {
    return (0, $81a173c055afbc0d$export$a2258d9c4118825c)(date);
}
/**
 * Checks if two dates are in the same year.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same year, false otherwise.
 */ function $7c7b1a6f859720e7$var$isSameYear(date1, date2) {
    if (date1 && date2) return (0, $42e8c0c34f57b6cb$export$5841f9eb9773f25f)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same month.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same month, false otherwise.
 */ function $7c7b1a6f859720e7$var$isSameMonth(date1, date2) {
    if (date1 && date2) return (0, $5d9f887231a923ce$export$a18c89cbd24170ff)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are in the same quarter.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are in the same quarter, false otherwise.
 */ function $7c7b1a6f859720e7$var$isSameQuarter(date1, date2) {
    if (date1 && date2) return (0, $af8cf12eef3460bb$export$5c60e4190867161c)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are on the same day.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are on the same day, false otherwise.
 */ function $7c7b1a6f859720e7$var$isSameDay(date1, date2) {
    if (date1 && date2) return (0, $0614127f134da85e$export$ea39ec197993aef0)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if two dates are equal.
 *
 * @param date1 - The first date.
 * @param date2 - The second date.
 * @returns - True if the dates are equal, false otherwise.
 */ function $7c7b1a6f859720e7$var$isEqual(date1, date2) {
    if (date1 && date2) return (0, $5c4f7b6ec3edce7a$export$248d38f6296296c5)(date1, date2);
    else return !date1 && !date2;
}
/**
 * Checks if a day is within a date range.
 *
 * @param day - The day to check.
 * @param startDate - The start date of the range.
 * @param endDate - The end date of the range.
 * @returns - True if the day is within the range, false otherwise.
 */ function $7c7b1a6f859720e7$var$isDayInRange(day, startDate, endDate) {
    var valid;
    var start = (0, $6adcf5e4df55379b$export$63fa379ae8a9ba2)(startDate);
    var end = (0, $da86bf3c3f1468b8$export$eb9a03f0e9aa6cea)(endDate);
    try {
        valid = (0, $76a0813dbe6750d3$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    } catch (err) {
        valid = false;
    }
    return valid;
}
// ** Date Localization **
/**
 * Registers a locale.
 *
 * @param localeName - The name of the locale.
 * @param localeData - The data of the locale.
 */ function $7c7b1a6f859720e7$export$bab6a7822cc1e2cd(localeName, localeData) {
    var scope = $7c7b1a6f859720e7$var$getLocaleScope();
    if (!scope.__localeData__) scope.__localeData__ = {};
    scope.__localeData__[localeName] = localeData;
}
/**
 * Sets the default locale.
 *
 * @param localeName - The name of the locale.
 */ function $7c7b1a6f859720e7$export$a1a5025df4e9ba34(localeName) {
    var scope = $7c7b1a6f859720e7$var$getLocaleScope();
    scope.__localeId__ = localeName;
}
/**
 * Gets the default locale.
 *
 * @returns - The default locale.
 */ function $7c7b1a6f859720e7$export$f09106e7c6677ec5() {
    var scope = $7c7b1a6f859720e7$var$getLocaleScope();
    return scope.__localeId__;
}
/**
 * Gets the locale object.
 *
 * @param localeSpec - The locale specification.
 * @returns - The locale object.
 */ function $7c7b1a6f859720e7$var$getLocaleObject(localeSpec) {
    if (typeof localeSpec === "string") {
        // Treat it as a locale name registered by registerLocale
        var scope = $7c7b1a6f859720e7$var$getLocaleScope();
        // Null was replaced with undefined to avoid type coercion
        return scope.__localeData__ ? scope.__localeData__[localeSpec] : undefined;
    } else // Treat it as a raw date-fns locale object
    return localeSpec;
}
/**
 * Formats the weekday in a given locale.
 *
 * @param date - The date to format.
 * @param formatFunc - The formatting function.
 * @param locale - The locale to use for formatting.
 * @returns - The formatted weekday.
 */ function $7c7b1a6f859720e7$var$getFormattedWeekdayInLocale(date, formatFunc, locale) {
    return formatFunc($7c7b1a6f859720e7$var$formatDate(date, "EEEE", locale));
}
/**
 * Gets the minimum weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The minimum weekday.
 */ function $7c7b1a6f859720e7$var$getWeekdayMinInLocale(date, locale) {
    return $7c7b1a6f859720e7$var$formatDate(date, "EEEEEE", locale);
}
/**
 * Gets the short weekday in a given locale.
 *
 * @param date - The date to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short weekday.
 */ function $7c7b1a6f859720e7$var$getWeekdayShortInLocale(date, locale) {
    return $7c7b1a6f859720e7$var$formatDate(date, "EEE", locale);
}
/**
 * Gets the month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The month.
 */ function $7c7b1a6f859720e7$var$getMonthInLocale(month, locale) {
    return $7c7b1a6f859720e7$var$formatDate((0, $a04ce585cc1453dc$export$63264690f8e36790)($7c7b1a6f859720e7$var$newDate(), month), "LLLL", locale);
}
/**
 * Gets the short month in a given locale.
 *
 * @param month - The month to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short month.
 */ function $7c7b1a6f859720e7$var$getMonthShortInLocale(month, locale) {
    return $7c7b1a6f859720e7$var$formatDate((0, $a04ce585cc1453dc$export$63264690f8e36790)($7c7b1a6f859720e7$var$newDate(), month), "LLL", locale);
}
/**
 * Gets the short quarter in a given locale.
 *
 * @param quarter - The quarter to format.
 * @param locale - The locale to use for formatting.
 * @returns - The short quarter.
 */ function $7c7b1a6f859720e7$var$getQuarterShortInLocale(quarter, locale) {
    return $7c7b1a6f859720e7$var$formatDate((0, $e9d24921719c0925$export$8924d1de7efe1755)($7c7b1a6f859720e7$var$newDate(), quarter), "QQQ", locale);
}
/**
 * Checks if a day is disabled.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is disabled, false otherwise.
 */ function $7c7b1a6f859720e7$var$isDayDisabled(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals, includeDates = _b.includeDates, includeDateIntervals = _b.includeDateIntervals, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    return $7c7b1a6f859720e7$var$isOutOfBounds(day, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludeDate) {
        if (excludeDate instanceof Date) return $7c7b1a6f859720e7$var$isSameDay(day, excludeDate);
        else return $7c7b1a6f859720e7$var$isSameDay(day, excludeDate.date);
    }) || excludeDateIntervals && excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $76a0813dbe6750d3$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    }) || includeDates && !includeDates.some(function(includeDate) {
        return $7c7b1a6f859720e7$var$isSameDay(day, includeDate);
    }) || includeDateIntervals && !includeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $76a0813dbe6750d3$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    }) || filterDate && !filterDate($7c7b1a6f859720e7$var$newDate(day)) || false;
}
/**
 * Checks if a day is excluded.
 *
 * @param day - The day to check.
 * @param options - The options to consider when checking.
 * @returns - Returns true if the day is excluded, false otherwise.
 */ function $7c7b1a6f859720e7$var$isDayExcluded(day, _a) {
    var _b = _a === void 0 ? {} : _a, excludeDates = _b.excludeDates, excludeDateIntervals = _b.excludeDateIntervals;
    if (excludeDateIntervals && excludeDateIntervals.length > 0) return excludeDateIntervals.some(function(_a) {
        var start = _a.start, end = _a.end;
        return (0, $76a0813dbe6750d3$export$d7deef7a3738e19d)(day, {
            start: start,
            end: end
        });
    });
    return excludeDates && excludeDates.some(function(excludeDate) {
        var _a;
        if (excludeDate instanceof Date) return $7c7b1a6f859720e7$var$isSameDay(day, excludeDate);
        else return $7c7b1a6f859720e7$var$isSameDay(day, (_a = excludeDate.date) !== null && _a !== void 0 ? _a : new Date());
    }) || false;
}
function $7c7b1a6f859720e7$var$isMonthDisabled(month, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate;
    return $7c7b1a6f859720e7$var$isOutOfBounds(month, {
        minDate: minDate ? (0, $51ef0e18718a1681$export$a5a3b454ada2268e)(minDate) : undefined,
        maxDate: maxDate ? (0, $81a173c055afbc0d$export$a2258d9c4118825c)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $7c7b1a6f859720e7$var$isSameMonth(month, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $7c7b1a6f859720e7$var$isSameMonth(month, includeDate);
    }) || filterDate && !filterDate($7c7b1a6f859720e7$var$newDate(month)) || false;
}
function $7c7b1a6f859720e7$var$isMonthInRange(startDate, endDate, m, day) {
    var startDateYear = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(startDate);
    var startDateMonth = (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(startDate);
    var endDateYear = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(endDate);
    var endDateMonth = (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(endDate);
    var dayYear = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateMonth <= m && m <= endDateMonth;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateMonth <= m || dayYear === endDateYear && endDateMonth >= m || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
/**
 * To check if a date's month and year are disabled/excluded
 * @param date Date to check
 * @returns {boolean} true if month and year are disabled/excluded, false otherwise
 */ function $7c7b1a6f859720e7$var$isMonthYearDisabled(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
    return $7c7b1a6f859720e7$var$isOutOfBounds(date, {
        minDate: minDate,
        maxDate: maxDate
    }) || excludeDates && excludeDates.some(function(excludedDate) {
        return $7c7b1a6f859720e7$var$isSameMonth(excludedDate instanceof Date ? excludedDate : excludedDate.date, date);
    }) || includeDates && !includeDates.some(function(includedDate) {
        return $7c7b1a6f859720e7$var$isSameMonth(includedDate, date);
    }) || false;
}
function $7c7b1a6f859720e7$var$isQuarterDisabled(quarter, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    return $7c7b1a6f859720e7$var$isOutOfBounds(quarter, {
        minDate: minDate,
        maxDate: maxDate
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $7c7b1a6f859720e7$var$isSameQuarter(quarter, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $7c7b1a6f859720e7$var$isSameQuarter(quarter, includeDate);
    }) || filterDate && !filterDate($7c7b1a6f859720e7$var$newDate(quarter)) || false;
}
function $7c7b1a6f859720e7$var$isYearInRange(year, start, end) {
    if (!start || !end) return false;
    if (!(0, $070b8e24dc8d9a3e$export$1ea939691cdc45b8)(start) || !(0, $070b8e24dc8d9a3e$export$1ea939691cdc45b8)(end)) return false;
    var startYear = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(start);
    var endYear = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(end);
    return startYear <= year && endYear >= year;
}
function $7c7b1a6f859720e7$var$isYearDisabled(year, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates, filterDate = _b.filterDate, disabled = _b.disabled;
    if (disabled) return true;
    var date = new Date(year, 0, 1);
    return $7c7b1a6f859720e7$var$isOutOfBounds(date, {
        minDate: minDate ? (0, $78040c6eb7d2e9d1$export$f91e89d3d0406102)(minDate) : undefined,
        maxDate: maxDate ? (0, $aa26a860d0852c6f$export$8b7aa55c66d5569e)(maxDate) : undefined
    }) || (excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.some(function(excludeDate) {
        return $7c7b1a6f859720e7$var$isSameYear(date, excludeDate instanceof Date ? excludeDate : excludeDate.date);
    })) || includeDates && !includeDates.some(function(includeDate) {
        return $7c7b1a6f859720e7$var$isSameYear(date, includeDate);
    }) || filterDate && !filterDate($7c7b1a6f859720e7$var$newDate(date)) || false;
}
function $7c7b1a6f859720e7$var$isQuarterInRange(startDate, endDate, q, day) {
    var startDateYear = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(startDate);
    var startDateQuarter = (0, $5b98fcfb96403ba3$export$de90a4bb31c25221)(startDate);
    var endDateYear = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(endDate);
    var endDateQuarter = (0, $5b98fcfb96403ba3$export$de90a4bb31c25221)(endDate);
    var dayYear = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(day);
    if (startDateYear === endDateYear && startDateYear === dayYear) return startDateQuarter <= q && q <= endDateQuarter;
    else if (startDateYear < endDateYear) return dayYear === startDateYear && startDateQuarter <= q || dayYear === endDateYear && endDateQuarter >= q || dayYear < endDateYear && dayYear > startDateYear;
    return false;
}
function $7c7b1a6f859720e7$var$isOutOfBounds(day, _a) {
    var _b;
    var _c = _a === void 0 ? {} : _a, minDate = _c.minDate, maxDate = _c.maxDate;
    return (_b = minDate && (0, $f83a873b157b4661$export$4a02e9c37dab4871)(day, minDate) < 0 || maxDate && (0, $f83a873b157b4661$export$4a02e9c37dab4871)(day, maxDate) > 0) !== null && _b !== void 0 ? _b : false;
}
function $7c7b1a6f859720e7$var$isTimeInList(time, times) {
    return times.some(function(listTime) {
        return (0, $1768b25c11e35b0a$export$257b40f71c07d58f)(listTime) === (0, $1768b25c11e35b0a$export$257b40f71c07d58f)(time) && (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(listTime) === (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(time) && (0, $ad405ba8e35fff1c$export$5e9417507ff28427)(listTime) === (0, $ad405ba8e35fff1c$export$5e9417507ff28427)(time);
    });
}
function $7c7b1a6f859720e7$var$isTimeDisabled(time, _a) {
    var _b = _a === void 0 ? {} : _a, excludeTimes = _b.excludeTimes, includeTimes = _b.includeTimes, filterTime = _b.filterTime;
    return excludeTimes && $7c7b1a6f859720e7$var$isTimeInList(time, excludeTimes) || includeTimes && !$7c7b1a6f859720e7$var$isTimeInList(time, includeTimes) || filterTime && !filterTime(time) || false;
}
function $7c7b1a6f859720e7$var$isTimeInDisabledRange(time, _a) {
    var minTime = _a.minTime, maxTime = _a.maxTime;
    if (!minTime || !maxTime) throw new Error("Both minTime and maxTime props required");
    var baseTime = $7c7b1a6f859720e7$var$newDate();
    baseTime = (0, $879723943f4caa59$export$f86b797a4659b781)(baseTime, (0, $1768b25c11e35b0a$export$257b40f71c07d58f)(time));
    baseTime = (0, $dd3d355dc6207ba3$export$ad569bf1c79ea89d)(baseTime, (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(time));
    baseTime = (0, $d9b52d32db130922$export$aec44746644cbf43)(baseTime, (0, $ad405ba8e35fff1c$export$5e9417507ff28427)(time));
    var min = $7c7b1a6f859720e7$var$newDate();
    min = (0, $879723943f4caa59$export$f86b797a4659b781)(min, (0, $1768b25c11e35b0a$export$257b40f71c07d58f)(minTime));
    min = (0, $dd3d355dc6207ba3$export$ad569bf1c79ea89d)(min, (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(minTime));
    min = (0, $d9b52d32db130922$export$aec44746644cbf43)(min, (0, $ad405ba8e35fff1c$export$5e9417507ff28427)(minTime));
    var max = $7c7b1a6f859720e7$var$newDate();
    max = (0, $879723943f4caa59$export$f86b797a4659b781)(max, (0, $1768b25c11e35b0a$export$257b40f71c07d58f)(maxTime));
    max = (0, $dd3d355dc6207ba3$export$ad569bf1c79ea89d)(max, (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(maxTime));
    max = (0, $d9b52d32db130922$export$aec44746644cbf43)(max, (0, $ad405ba8e35fff1c$export$5e9417507ff28427)(maxTime));
    var valid;
    try {
        valid = !(0, $76a0813dbe6750d3$export$d7deef7a3738e19d)(baseTime, {
            start: min,
            end: max
        });
    } catch (err) {
        /* istanbul ignore next - date-fns historically threw on invalid intervals */ valid = false;
    }
    return valid;
}
function $7c7b1a6f859720e7$var$monthDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousMonth = (0, $9ccdf5b091b4766d$export$73d1c15a21f9fae5)(day, 1);
    return minDate && (0, $e580dca22e1bfd4c$export$489984ac7c996389)(minDate, previousMonth) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $e580dca22e1bfd4c$export$489984ac7c996389)(includeDate, previousMonth) > 0;
    }) || false;
}
function $7c7b1a6f859720e7$var$monthDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextMonth = (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(day, 1);
    return maxDate && (0, $e580dca22e1bfd4c$export$489984ac7c996389)(nextMonth, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $e580dca22e1bfd4c$export$489984ac7c996389)(nextMonth, includeDate) > 0;
    }) || false;
}
function $7c7b1a6f859720e7$var$quarterDisabledBefore(date, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var firstDateOfYear = (0, $78040c6eb7d2e9d1$export$f91e89d3d0406102)(date);
    var previousQuarter = (0, $3b7a595f94262fab$export$a31bfeeeee80cce6)(firstDateOfYear, 1);
    return minDate && (0, $7b147184d0363e71$export$f62ae9fb13958c7a)(minDate, previousQuarter) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $7b147184d0363e71$export$f62ae9fb13958c7a)(includeDate, previousQuarter) > 0;
    }) || false;
}
function $7c7b1a6f859720e7$var$quarterDisabledAfter(date, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var lastDateOfYear = (0, $aa26a860d0852c6f$export$8b7aa55c66d5569e)(date);
    var nextQuarter = (0, $4e9bcc6ff9d39f34$export$c252a41d0fbed2ce)(lastDateOfYear, 1);
    return maxDate && (0, $7b147184d0363e71$export$f62ae9fb13958c7a)(nextQuarter, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $7b147184d0363e71$export$f62ae9fb13958c7a)(nextQuarter, includeDate) > 0;
    }) || false;
}
function $7c7b1a6f859720e7$var$yearDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, includeDates = _b.includeDates;
    var previousYear = (0, $9e4f2bf0d6114176$export$14867687ff6c92e2)(day, 1);
    return minDate && (0, $44a3d8022c34241b$export$c06dce8b38891685)(minDate, previousYear) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $44a3d8022c34241b$export$c06dce8b38891685)(includeDate, previousYear) > 0;
    }) || false;
}
function $7c7b1a6f859720e7$var$yearsDisabledBefore(day, _a) {
    var _b = _a === void 0 ? {} : _a, minDate = _b.minDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $7c7b1a6f859720e7$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var previousYear = $7c7b1a6f859720e7$var$getStartOfYear((0, $9e4f2bf0d6114176$export$14867687ff6c92e2)(day, yearItemNumber));
    var endPeriod = $7c7b1a6f859720e7$var$getYearsPeriod(previousYear, yearItemNumber).endPeriod;
    var minDateYear = minDate && (0, $18282d9928d9137b$export$5846dc2d57a5c860)(minDate);
    return minDateYear && minDateYear > endPeriod || false;
}
function $7c7b1a6f859720e7$var$yearDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, includeDates = _b.includeDates;
    var nextYear = (0, $b4358f02f9e27928$export$3d83eec43f4ea476)(day, 1);
    return maxDate && (0, $44a3d8022c34241b$export$c06dce8b38891685)(nextYear, maxDate) > 0 || includeDates && includeDates.every(function(includeDate) {
        return (0, $44a3d8022c34241b$export$c06dce8b38891685)(nextYear, includeDate) > 0;
    }) || false;
}
function $7c7b1a6f859720e7$var$yearsDisabledAfter(day, _a) {
    var _b = _a === void 0 ? {} : _a, maxDate = _b.maxDate, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? $7c7b1a6f859720e7$var$DEFAULT_YEAR_ITEM_NUMBER : _c;
    var nextYear = (0, $b4358f02f9e27928$export$3d83eec43f4ea476)(day, yearItemNumber);
    var startPeriod = $7c7b1a6f859720e7$var$getYearsPeriod(nextYear, yearItemNumber).startPeriod;
    var maxDateYear = maxDate && (0, $18282d9928d9137b$export$5846dc2d57a5c860)(maxDate);
    return maxDateYear && maxDateYear < startPeriod || false;
}
function $7c7b1a6f859720e7$var$getEffectiveMinDate(_a) {
    var minDate = _a.minDate, includeDates = _a.includeDates;
    if (includeDates && minDate) {
        var minDates = includeDates.filter(function(includeDate) {
            return (0, $f83a873b157b4661$export$4a02e9c37dab4871)(includeDate, minDate) >= 0;
        });
        return (0, $7c04ad025186dca2$export$96ec731ed4dcb222)(minDates);
    } else if (includeDates) return (0, $7c04ad025186dca2$export$96ec731ed4dcb222)(includeDates);
    else return minDate;
}
function $7c7b1a6f859720e7$var$getEffectiveMaxDate(_a) {
    var maxDate = _a.maxDate, includeDates = _a.includeDates;
    if (includeDates && maxDate) {
        var maxDates = includeDates.filter(function(includeDate) {
            return (0, $f83a873b157b4661$export$4a02e9c37dab4871)(includeDate, maxDate) <= 0;
        });
        return (0, $fc0a57bff9d7d350$export$8960430cfd85939f)(maxDates);
    } else if (includeDates) return (0, $fc0a57bff9d7d350$export$8960430cfd85939f)(includeDates);
    else return maxDate;
}
/**
 * Get a map of highlighted dates with their corresponding classes.
 * @param highlightDates The dates to highlight.
 * @param defaultClassName The default class to use for highlighting.
 * @returns A map with dates as keys and arrays of class names as values.
 */ function $7c7b1a6f859720e7$var$getHighLightDaysMap(highlightDates, defaultClassName) {
    var _a;
    if (highlightDates === void 0) highlightDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--highlighted";
    var dateClasses = new Map();
    for(var i = 0, len = highlightDates.length; i < len; i++){
        var obj = highlightDates[i];
        if ((0, $5e4a1e7833f0eaed$export$871608497c498473)(obj)) {
            var key = $7c7b1a6f859720e7$var$formatDate(obj, "MM.dd.yyyy");
            var classNamesArr = dateClasses.get(key) || [];
            if (!classNamesArr.includes(defaultClassName)) {
                classNamesArr.push(defaultClassName);
                dateClasses.set(key, classNamesArr);
            }
        } else if (typeof obj === "object") {
            var keys = Object.keys(obj);
            var className = (_a = keys[0]) !== null && _a !== void 0 ? _a : "";
            var arrOfDates = obj[className];
            if (typeof className === "string" && Array.isArray(arrOfDates)) for(var k = 0, len_1 = arrOfDates.length; k < len_1; k++){
                var dateK = arrOfDates[k];
                if (dateK) {
                    var key = $7c7b1a6f859720e7$var$formatDate(dateK, "MM.dd.yyyy");
                    var classNamesArr = dateClasses.get(key) || [];
                    if (!classNamesArr.includes(className)) {
                        classNamesArr.push(className);
                        dateClasses.set(key, classNamesArr);
                    }
                }
            }
        }
    }
    return dateClasses;
}
/**
 * Compare the two arrays
 * @param array1 The first array to compare.
 * @param array2 The second array to compare.
 * @returns true, if the passed arrays are equal, false otherwise.
 */ function $7c7b1a6f859720e7$var$arraysAreEqual(array1, array2) {
    if (array1.length !== array2.length) return false;
    return array1.every(function(value, index) {
        return value === array2[index];
    });
}
/**
 * Assign the custom class to each date
 * @param holidayDates array of object containing date and name of the holiday
 * @param defaultClassName className to be added.
 * @returns Map containing date as key and array of className and holiday name as value
 */ function $7c7b1a6f859720e7$var$getHolidaysMap(holidayDates, defaultClassName) {
    if (holidayDates === void 0) holidayDates = [];
    if (defaultClassName === void 0) defaultClassName = "react-datepicker__day--holidays";
    var dateClasses = new Map();
    holidayDates.forEach(function(holiday) {
        var dateObj = holiday.date, holidayName = holiday.holidayName;
        if (!(0, $5e4a1e7833f0eaed$export$871608497c498473)(dateObj)) return;
        var key = $7c7b1a6f859720e7$var$formatDate(dateObj, "MM.dd.yyyy");
        var classNamesObj = dateClasses.get(key) || {
            className: "",
            holidayNames: []
        };
        if ("className" in classNamesObj && classNamesObj["className"] === defaultClassName && $7c7b1a6f859720e7$var$arraysAreEqual(classNamesObj["holidayNames"], [
            holidayName
        ])) return;
        classNamesObj["className"] = defaultClassName;
        var holidayNameArr = classNamesObj["holidayNames"];
        classNamesObj["holidayNames"] = holidayNameArr ? $7c7b1a6f859720e7$var$__spreadArray($7c7b1a6f859720e7$var$__spreadArray([], holidayNameArr, true), [
            holidayName
        ], false) : [
            holidayName
        ];
        dateClasses.set(key, classNamesObj);
    });
    return dateClasses;
}
/**
 * Determines the times to inject after a given start of day, current time, and multiplier.
 * @param startOfDay The start of the day.
 * @param currentTime The current time.
 * @param currentMultiplier The current multiplier.
 * @param intervals The intervals.
 * @param injectedTimes The times to potentially inject.
 * @returns An array of times to inject.
 */ function $7c7b1a6f859720e7$var$timesToInjectAfter(startOfDay, currentTime, currentMultiplier, intervals, injectedTimes) {
    var l = injectedTimes.length;
    var times = [];
    for(var i = 0; i < l; i++){
        var injectedTime = startOfDay;
        var injectedTimeValue = injectedTimes[i];
        if (injectedTimeValue) {
            injectedTime = (0, $12502beeb4ed2ed3$export$4a4306ad4fa0e5e6)(injectedTime, (0, $1768b25c11e35b0a$export$257b40f71c07d58f)(injectedTimeValue));
            injectedTime = (0, $879ad858cbf859fa$export$2287e3d29250119e)(injectedTime, (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(injectedTimeValue));
            injectedTime = (0, $a57a5a7d87e86174$export$3cb31b0df13be68)(injectedTime, (0, $ad405ba8e35fff1c$export$5e9417507ff28427)(injectedTimeValue));
        }
        var nextTime = (0, $879ad858cbf859fa$export$2287e3d29250119e)(startOfDay, (currentMultiplier + 1) * intervals);
        if ((0, $04f0c9d20b09837b$export$e4de839670987035)(injectedTime, currentTime) && (0, $eb21892051383660$export$5c007e10c6929c95)(injectedTime, nextTime) && injectedTimeValue != undefined) times.push(injectedTimeValue);
    }
    return times;
}
/**
 * Adds a leading zero to a number if it's less than 10.
 * @param i The number to add a leading zero to.
 * @returns The number as a string, with a leading zero if it was less than 10.
 */ function $7c7b1a6f859720e7$var$addZero(i) {
    return i < 10 ? "0".concat(i) : "".concat(i);
}
/**
 * Gets the start and end years for a period.
 * @param date The date to get the period for.
 * @param yearItemNumber The number of years in the period. Defaults to DEFAULT_YEAR_ITEM_NUMBER.
 * @returns An object with the start and end years for the period.
 */ function $7c7b1a6f859720e7$var$getYearsPeriod(date, yearItemNumber) {
    if (yearItemNumber === void 0) yearItemNumber = $7c7b1a6f859720e7$var$DEFAULT_YEAR_ITEM_NUMBER;
    var endPeriod = Math.ceil((0, $18282d9928d9137b$export$5846dc2d57a5c860)(date) / yearItemNumber) * yearItemNumber;
    var startPeriod = endPeriod - (yearItemNumber - 1);
    return {
        startPeriod: startPeriod,
        endPeriod: endPeriod
    };
}
/**
 * Gets the number of hours in a day.
 * @param d The date to get the number of hours for.
 * @returns The number of hours in the day.
 */ function $7c7b1a6f859720e7$var$getHoursInDay(d) {
    var startOfDay = new Date(d.getFullYear(), d.getMonth(), d.getDate());
    var startOfTheNextDay = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 24);
    return Math.round((+startOfTheNextDay - +startOfDay) / 3600000);
}
/**
 * Returns the start of the minute for the given date
 *
 * NOTE: this function is a DST and timezone-safe analog of `date-fns/startOfMinute`
 * do not make changes unless you know what you're doing
 *
 * See comments on https://github.com/Hacker0x01/react-datepicker/pull/4244
 * for more details
 *
 * @param d date
 * @returns start of the minute
 */ function $7c7b1a6f859720e7$var$startOfMinute(d) {
    var seconds = d.getSeconds();
    var milliseconds = d.getMilliseconds();
    return (0, $0e4c03a3b8c45094$export$e67a095c620b86fe)(d.getTime() - seconds * 1000 - milliseconds);
}
/**
 * Returns whether the given dates are in the same minute
 *
 * This function is a DST and timezone-safe analog of `date-fns/isSameMinute`
 *
 * @param d1
 * @param d2
 * @returns
 */ function $7c7b1a6f859720e7$var$isSameMinute(d1, d2) {
    return $7c7b1a6f859720e7$var$startOfMinute(d1).getTime() === $7c7b1a6f859720e7$var$startOfMinute(d2).getTime();
}
/**
 * Returns a new datetime object representing the input date with midnight time
 * @param date The date to get the midnight time for
 * @returns A new datetime object representing the input date with midnight time
 */ function $7c7b1a6f859720e7$var$getMidnightDate(date) {
    if (!(0, $5e4a1e7833f0eaed$export$871608497c498473)(date)) throw new Error("Invalid date");
    var dateWithoutTime = new Date(date);
    dateWithoutTime.setHours(0, 0, 0, 0);
    return dateWithoutTime;
}
/**
 * Is the first date before the second one?
 * @param date The date that should be before the other one to return true
 * @param dateToCompare The date to compare with
 * @returns The first date is before the second date
 *
 * Note:
 *  This function considers the mid-night of the given dates for comparison.
 *  It evaluates whether date is before dateToCompare based on their mid-night timestamps.
 */ function $7c7b1a6f859720e7$var$isDateBefore(date, dateToCompare) {
    if (!(0, $5e4a1e7833f0eaed$export$871608497c498473)(date) || !(0, $5e4a1e7833f0eaed$export$871608497c498473)(dateToCompare)) throw new Error("Invalid date received");
    var midnightDate = $7c7b1a6f859720e7$var$getMidnightDate(date);
    var midnightDateToCompare = $7c7b1a6f859720e7$var$getMidnightDate(dateToCompare);
    return (0, $eb21892051383660$export$5c007e10c6929c95)(midnightDate, midnightDateToCompare);
}
/**
 * Checks if the space key was pressed down.
 *
 * @param event - The keyboard event.
 * @returns - Returns true if the space key was pressed down, false otherwise.
 */ function $7c7b1a6f859720e7$var$isSpaceKeyDown(event) {
    return event.key === $7c7b1a6f859720e7$var$KeyType.Space;
}
/**
 * `InputTime` is a React component that manages time input.
 *
 * @component
 * @example
 * <InputTime timeString="12:00" />
 *
 * @param props - The properties that define the `InputTime` component.
 * @param props.onChange - Function that is called when the date changes.
 * @param props.date - The initial date value.
 * @param props.timeString - The initial time string value.
 * @param props.timeInputLabel - The label for the time input.
 * @param props.customTimeInput - An optional custom time input element.
 *
 * @returns The `InputTime` component.
 */ var $7c7b1a6f859720e7$var$InputTime = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(InputTime, _super);
    function InputTime(props) {
        var _this = _super.call(this, props) || this;
        _this.inputRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createRef();
        _this.onTimeChange = function(time) {
            var _a, _b;
            _this.setState({
                time: time
            });
            var propDate = _this.props.date;
            var isPropDateValid = propDate instanceof Date && !isNaN(+propDate);
            var date = isPropDateValid ? propDate : new Date();
            if (time === null || time === void 0 ? void 0 : time.includes(":")) {
                var _c = time.split(":"), hours = _c[0], minutes = _c[1];
                date.setHours(Number(hours));
                date.setMinutes(Number(minutes));
            }
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, date);
        };
        _this.renderTimeInput = function() {
            var time = _this.state.time;
            var _a = _this.props, date = _a.date, timeString = _a.timeString, customTimeInput = _a.customTimeInput;
            if (customTimeInput) return (0, $7fPBF.cloneElement)(customTimeInput, {
                date: date,
                value: time,
                onChange: _this.onTimeChange
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
                type: "time",
                className: "react-datepicker-time__input",
                placeholder: "Time",
                name: "time-input",
                ref: _this.inputRef,
                onClick: function() {
                    var _a;
                    (_a = _this.inputRef.current) === null || _a === void 0 || _a.focus();
                },
                required: true,
                value: time,
                onChange: function(event) {
                    _this.onTimeChange(event.target.value || timeString);
                }
            });
        };
        _this.state = {
            time: _this.props.timeString
        };
        return _this;
    }
    InputTime.getDerivedStateFromProps = function(props, state) {
        if (props.timeString !== state.time) return {
            time: props.timeString
        };
        // Return null to indicate no change to state.
        return null;
    };
    InputTime.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__input-time-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker-time__caption"
        }, this.props.timeInputLabel), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker-time__input-container"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker-time__input"
        }, this.renderTimeInput())));
    };
    return InputTime;
}((0, $7fPBF.Component));
/**
 * `Day` is a React component that represents a single day in a date picker.
 * It handles the rendering and interaction of a day.
 *
 * @prop ariaLabelPrefixWhenEnabled - Aria label prefix when the day is enabled.
 * @prop ariaLabelPrefixWhenDisabled - Aria label prefix when the day is disabled.
 * @prop disabledKeyboardNavigation - Whether keyboard navigation is disabled.
 * @prop day - The day to be displayed.
 * @prop dayClassName - Function to customize the CSS class of the day.
 * @prop endDate - The end date in a range.
 * @prop highlightDates - Map of dates to be highlighted.
 * @prop holidays - Map of holiday dates.
 * @prop inline - Whether the date picker is inline.
 * @prop shouldFocusDayInline - Whether the day should be focused when date picker is inline.
 * @prop month - The month the day belongs to.
 * @prop onClick - Click event handler.
 * @prop onMouseEnter - Mouse enter event handler.
 * @prop handleOnKeyDown - Key down event handler.
 * @prop usePointerEvent - Whether to use pointer events.
 * @prop preSelection - The date that is currently selected.
 * @prop selected - The selected date.
 * @prop selectingDate - The date currently being selected.
 * @prop selectsEnd - Whether the day can be the end date in a range.
 * @prop selectsStart - Whether the day can be the start date in a range.
 * @prop selectsRange - Whether the day can be in a range.
 * @prop showWeekPicker - Whether to show week picker.
 * @prop showWeekNumber - Whether to show week numbers.
 * @prop selectsDisabledDaysInRange - Whether to select disabled days in a range.
 * @prop selectsMultiple - Whether to allow multiple date selection.
 * @prop selectedDates - Array of selected dates.
 * @prop startDate - The start date in a range.
 * @prop renderDayContents - Function to customize the rendering of the day's contents.
 * @prop containerRef - Ref for the container.
 * @prop excludeDates - Array of dates to be excluded.
 * @prop calendarStartDay - The start day of the week.
 * @prop locale - The locale object.
 * @prop monthShowsDuplicateDaysEnd - Whether to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Whether to show duplicate days at the start of the month.
 * @prop includeDates - Array of dates to be included.
 * @prop includeDateIntervals - Array of date intervals to be included.
 * @prop minDate - The minimum date that can be selected.
 * @prop maxDate - The maximum date that can be selected.
 *
 * @example
 * ```tsx
 * import React from 'react';
 * import Day from './day';
 *
 * function MyComponent() {
 *   const handleDayClick = (event) => {
 *     console.log('Day clicked', event);
 *   };
 *
 *   const handleDayMouseEnter = (event) => {
 *     console.log('Mouse entered day', event);
 *   };
 *
 *   const renderDayContents = (date) => {
 *     return <div>{date.getDate()}</div>;
 *   };
 *
 *   return (
 *     <Day
 *       day={new Date()}
 *       onClick={handleDayClick}
 *       onMouseEnter={handleDayMouseEnter}
 *       renderDayContents={renderDayContents}
 *     />
 *   );
 * }
 *
 * export default MyComponent;
 * ```
 */ var $7c7b1a6f859720e7$var$Day = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(Day, _super);
    function Day() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dayEl = (0, $7fPBF.createRef)();
        _this.handleClick = function(event) {
            if (!_this.isDisabled() && _this.props.onClick) _this.props.onClick(event);
        };
        _this.handleMouseEnter = function(event) {
            if (!_this.isDisabled() && _this.props.onMouseEnter) _this.props.onMouseEnter(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $7c7b1a6f859720e7$var$KeyType.Space) {
                event.preventDefault();
                event.key = $7c7b1a6f859720e7$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isSameDay = function(other) {
            return $7c7b1a6f859720e7$var$isSameDay(_this.props.day, other);
        };
        _this.isKeyboardSelected = function() {
            var _a;
            if (_this.props.disabledKeyboardNavigation) return false;
            var isSelectedDate = _this.props.selectsMultiple ? (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            }) : _this.isSameDayOrWeek(_this.props.selected);
            var isDisabled = _this.props.preSelection && _this.isDisabled(_this.props.preSelection);
            return !isSelectedDate && _this.isSameDayOrWeek(_this.props.preSelection) && !isDisabled;
        };
        _this.isDisabled = function(day) {
            if (day === void 0) day = _this.props.day;
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $7c7b1a6f859720e7$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate,
                disabled: _this.props.disabled
            });
        };
        _this.isExcluded = function() {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $7c7b1a6f859720e7$var$isDayExcluded(_this.props.day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.isStartOfWeek = function() {
            return $7c7b1a6f859720e7$var$isSameDay(_this.props.day, $7c7b1a6f859720e7$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameWeek = function(other) {
            return _this.props.showWeekPicker && $7c7b1a6f859720e7$var$isSameDay(other, $7c7b1a6f859720e7$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay));
        };
        _this.isSameDayOrWeek = function(other) {
            return _this.isSameDay(other) || _this.isSameWeek(other);
        };
        _this.getHighLightedClass = function() {
            var _a = _this.props, day = _a.day, highlightDates = _a.highlightDates;
            if (!highlightDates) return false;
            // Looking for className in the Map of {'day string, 'className'}
            var dayStr = $7c7b1a6f859720e7$var$formatDate(day, "MM.dd.yyyy");
            return highlightDates.get(dayStr);
        };
        // Function to return the array containing className associated to the date
        _this.getHolidaysClass = function() {
            var _a;
            var _b = _this.props, day = _b.day, holidays = _b.holidays;
            if (!holidays) // For type consistency no other reasons
            return [
                undefined
            ];
            var dayStr = $7c7b1a6f859720e7$var$formatDate(day, "MM.dd.yyyy");
            // Looking for className in the Map of {day string: {className, holidayName}}
            if (holidays.has(dayStr)) return [
                (_a = holidays.get(dayStr)) === null || _a === void 0 ? void 0 : _a.className
            ];
            // For type consistency no other reasons
            return [
                undefined
            ];
        };
        _this.isInRange = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $7c7b1a6f859720e7$var$isDayInRange(day, startDate, endDate);
        };
        _this.isInSelectingRange = function() {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, selectsDisabledDaysInRange = _b.selectsDisabledDaysInRange, startDate = _b.startDate, swapRange = _b.swapRange, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate || !selectsDisabledDaysInRange && _this.isDisabled()) return false;
            if (selectsStart && endDate && ((0, $eb21892051383660$export$5c007e10c6929c95)(selectingDate, endDate) || $7c7b1a6f859720e7$var$isEqual(selectingDate, endDate))) return $7c7b1a6f859720e7$var$isDayInRange(day, selectingDate, endDate);
            if (selectsEnd && startDate && ((0, $04f0c9d20b09837b$export$e4de839670987035)(selectingDate, startDate) || $7c7b1a6f859720e7$var$isEqual(selectingDate, startDate))) return $7c7b1a6f859720e7$var$isDayInRange(day, startDate, selectingDate);
            if (selectsRange && startDate && !endDate) {
                if ($7c7b1a6f859720e7$var$isEqual(selectingDate, startDate)) return $7c7b1a6f859720e7$var$isDayInRange(day, startDate, selectingDate);
                if ((0, $04f0c9d20b09837b$export$e4de839670987035)(selectingDate, startDate)) return $7c7b1a6f859720e7$var$isDayInRange(day, startDate, selectingDate);
                if (swapRange && (0, $eb21892051383660$export$5c007e10c6929c95)(selectingDate, startDate)) return $7c7b1a6f859720e7$var$isDayInRange(day, selectingDate, startDate);
            }
            return false;
        };
        _this.isSelectingRangeStart = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart, swapRange = _b.swapRange, selectsRange = _b.selectsRange;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $7c7b1a6f859720e7$var$isSameDay(day, selectingDate);
            if (selectsRange && swapRange && startDate && selectingDate) return $7c7b1a6f859720e7$var$isSameDay(day, (0, $eb21892051383660$export$5c007e10c6929c95)(selectingDate, startDate) ? selectingDate : startDate);
            return $7c7b1a6f859720e7$var$isSameDay(day, startDate);
        };
        _this.isSelectingRangeEnd = function() {
            var _a;
            if (!_this.isInSelectingRange()) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, swapRange = _b.swapRange, startDate = _b.startDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd) return $7c7b1a6f859720e7$var$isSameDay(day, selectingDate);
            if (selectsRange && swapRange && startDate && selectingDate) return $7c7b1a6f859720e7$var$isSameDay(day, (0, $eb21892051383660$export$5c007e10c6929c95)(selectingDate, startDate) ? startDate : selectingDate);
            if (selectsRange) return $7c7b1a6f859720e7$var$isSameDay(day, selectingDate);
            return $7c7b1a6f859720e7$var$isSameDay(day, endDate);
        };
        _this.isRangeStart = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $7c7b1a6f859720e7$var$isSameDay(startDate, day);
        };
        _this.isRangeEnd = function() {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $7c7b1a6f859720e7$var$isSameDay(endDate, day);
        };
        _this.isWeekend = function() {
            var weekday = (0, $d63cd9e792b2e7f8$export$1b64bc9c5306ed54)(_this.props.day);
            return weekday === 0 || weekday === 6;
        };
        _this.isAfterMonth = function() {
            return _this.props.month !== undefined && (_this.props.month + 1) % 12 === (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(_this.props.day);
        };
        _this.isBeforeMonth = function() {
            return _this.props.month !== undefined && ((0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(_this.props.day) + 1) % 12 === _this.props.month;
        };
        _this.isCurrentDay = function() {
            return _this.isSameDay($7c7b1a6f859720e7$var$newDate());
        };
        _this.isSelected = function() {
            var _a;
            if (_this.props.selectsMultiple) return (_a = _this.props.selectedDates) === null || _a === void 0 ? void 0 : _a.some(function(date) {
                return _this.isSameDayOrWeek(date);
            });
            return _this.isSameDayOrWeek(_this.props.selected);
        };
        _this.getClassNames = function(date) {
            var dayClassName = _this.props.dayClassName ? _this.props.dayClassName(date) : undefined;
            return (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("react-datepicker__day", dayClassName, "react-datepicker__day--" + $7c7b1a6f859720e7$var$getDayOfWeekCode(_this.props.day), {
                "react-datepicker__day--disabled": _this.isDisabled(),
                "react-datepicker__day--excluded": _this.isExcluded(),
                "react-datepicker__day--selected": _this.isSelected(),
                "react-datepicker__day--keyboard-selected": _this.isKeyboardSelected(),
                "react-datepicker__day--range-start": _this.isRangeStart(),
                "react-datepicker__day--range-end": _this.isRangeEnd(),
                "react-datepicker__day--in-range": _this.isInRange(),
                "react-datepicker__day--in-selecting-range": _this.isInSelectingRange(),
                "react-datepicker__day--selecting-range-start": _this.isSelectingRangeStart(),
                "react-datepicker__day--selecting-range-end": _this.isSelectingRangeEnd(),
                "react-datepicker__day--today": _this.isCurrentDay(),
                "react-datepicker__day--weekend": _this.isWeekend(),
                "react-datepicker__day--outside-month": _this.isAfterMonth() || _this.isBeforeMonth()
            }, _this.getHighLightedClass(), _this.getHolidaysClass());
        };
        _this.getAriaLabel = function() {
            var _a = _this.props, day = _a.day, _b = _a.ariaLabelPrefixWhenEnabled, ariaLabelPrefixWhenEnabled = _b === void 0 ? "Choose" : _b, _c = _a.ariaLabelPrefixWhenDisabled, ariaLabelPrefixWhenDisabled = _c === void 0 ? "Not available" : _c;
            var prefix = _this.isDisabled() || _this.isExcluded() ? ariaLabelPrefixWhenDisabled : ariaLabelPrefixWhenEnabled;
            return "".concat(prefix, " ").concat($7c7b1a6f859720e7$var$formatDate(day, "PPPP", _this.props.locale));
        };
        // A function to return the holiday's name as title's content
        _this.getTitle = function() {
            var _a = _this.props, day = _a.day, _b = _a.holidays, holidays = _b === void 0 ? new Map() : _b, excludeDates = _a.excludeDates;
            var compareDt = $7c7b1a6f859720e7$var$formatDate(day, "MM.dd.yyyy");
            var titles = [];
            if (holidays.has(compareDt)) titles.push.apply(titles, holidays.get(compareDt).holidayNames);
            if (_this.isExcluded()) titles.push(excludeDates === null || excludeDates === void 0 ? void 0 : excludeDates.filter(function(excludeDate) {
                if (excludeDate instanceof Date) return $7c7b1a6f859720e7$var$isSameDay(excludeDate, day);
                return $7c7b1a6f859720e7$var$isSameDay(excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.date, day);
            }).map(function(excludeDate) {
                if (excludeDate instanceof Date) return undefined;
                return excludeDate === null || excludeDate === void 0 ? void 0 : excludeDate.message;
            }));
            // I'm not sure that this is a right output, but all tests are green
            return titles.join(", ");
        };
        _this.getTabIndex = function() {
            var selectedDay = _this.props.selected;
            var preSelectionDay = _this.props.preSelection;
            var tabIndex = !(_this.props.showWeekPicker && (_this.props.showWeekNumber || !_this.isStartOfWeek())) && (_this.isKeyboardSelected() || _this.isSameDay(selectedDay) && $7c7b1a6f859720e7$var$isSameDay(preSelectionDay, selectedDay)) ? 0 : -1;
            return tabIndex;
        };
        // various cases when we need to apply focus to the preselected day
        // focus the day on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusDay = function() {
            var _a;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            _this.shouldFocusDay() && ((_a = _this.dayEl.current) === null || _a === void 0 || _a.focus({
                preventScroll: true
            }));
        };
        _this.renderDayContents = function() {
            if (_this.props.monthShowsDuplicateDaysEnd && _this.isAfterMonth()) return null;
            if (_this.props.monthShowsDuplicateDaysStart && _this.isBeforeMonth()) return null;
            return _this.props.renderDayContents ? _this.props.renderDayContents((0, $64bf8e94c854677c$export$aa350b96d91cd94)(_this.props.day), _this.props.day) : (0, $64bf8e94c854677c$export$aa350b96d91cd94)(_this.props.day);
        };
        _this.render = function() {
            return(// TODO: Use <option> instead of the "option" role to ensure accessibility across all devices.
            (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                ref: _this.dayEl,
                className: _this.getClassNames(_this.props.day),
                onKeyDown: _this.handleOnKeyDown,
                onClick: _this.handleClick,
                onMouseEnter: !_this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                onPointerEnter: _this.props.usePointerEvent ? _this.handleMouseEnter : undefined,
                tabIndex: _this.getTabIndex(),
                "aria-label": _this.getAriaLabel(),
                role: "gridcell",
                title: _this.getTitle(),
                "aria-disabled": _this.isDisabled(),
                "aria-current": _this.isCurrentDay() ? "date" : undefined,
                "aria-selected": _this.isSelected() || _this.isInRange()
            }, _this.renderDayContents(), _this.getTitle() !== "" && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                className: "overlay"
            }, _this.getTitle())));
        };
        return _this;
    }
    Day.prototype.componentDidMount = function() {
        this.handleFocusDay();
    };
    Day.prototype.componentDidUpdate = function() {
        this.handleFocusDay();
    };
    Day.prototype.shouldFocusDay = function() {
        var shouldFocusDay = false;
        if (this.getTabIndex() === 0 && this.isSameDay(this.props.preSelection)) {
            // there is currently no activeElement and not inline
            if (!document.activeElement || document.activeElement === document.body) shouldFocusDay = true;
            // inline version:
            // do not focus on initial render to prevent autoFocus issue
            // focus after month has changed via keyboard
            if (this.props.inline && !this.props.shouldFocusDayInline) shouldFocusDay = false;
            if (this.isDayActiveElement()) shouldFocusDay = true;
            if (this.isDuplicateDay()) shouldFocusDay = false;
        }
        return shouldFocusDay;
    };
    // the activeElement is in the container, and it is another instance of Day
    Day.prototype.isDayActiveElement = function() {
        var _a, _b, _c;
        return ((_b = (_a = this.props.containerRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.contains(document.activeElement)) && ((_c = document.activeElement) === null || _c === void 0 ? void 0 : _c.classList.contains("react-datepicker__day"));
    };
    Day.prototype.isDuplicateDay = function() {
        return(//day is one of the non rendered duplicate days
        this.props.monthShowsDuplicateDaysEnd && this.isAfterMonth() || this.props.monthShowsDuplicateDaysStart && this.isBeforeMonth());
    };
    return Day;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$WeekNumber = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(WeekNumber, _super);
    function WeekNumber() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.weekNumberEl = (0, $7fPBF.createRef)();
        _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
        };
        _this.handleOnKeyDown = function(event) {
            var _a, _b;
            var eventKey = event.key;
            if (eventKey === $7c7b1a6f859720e7$var$KeyType.Space) {
                event.preventDefault();
                event.key = $7c7b1a6f859720e7$var$KeyType.Enter;
            }
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$7c7b1a6f859720e7$var$isSameDay(_this.props.date, _this.props.selected) && $7c7b1a6f859720e7$var$isSameDay(_this.props.date, _this.props.preSelection);
        };
        _this.getTabIndex = function() {
            return _this.props.showWeekPicker && _this.props.showWeekNumber && (_this.isKeyboardSelected() || $7c7b1a6f859720e7$var$isSameDay(_this.props.date, _this.props.selected) && $7c7b1a6f859720e7$var$isSameDay(_this.props.preSelection, _this.props.selected)) ? 0 : -1;
        };
        // various cases when we need to apply focus to the preselected week-number
        // focus the week-number on mount/update so that keyboard navigation works while cycling through months with up or down keys (not for prev and next month buttons)
        // prevent focus for these activeElement cases so we don't pull focus from the input as the calendar opens
        _this.handleFocusWeekNumber = function(prevProps) {
            var shouldFocusWeekNumber = false;
            // only do this while the input isn't focused
            // otherwise, typing/backspacing the date manually may steal focus away from the input
            if (_this.getTabIndex() === 0 && !(prevProps === null || prevProps === void 0 ? void 0 : prevProps.isInputFocused) && $7c7b1a6f859720e7$var$isSameDay(_this.props.date, _this.props.preSelection)) {
                // there is currently no activeElement and not inline
                if (!document.activeElement || document.activeElement === document.body) shouldFocusWeekNumber = true;
                // inline version:
                // do not focus on initial render to prevent autoFocus issue
                // focus after month has changed via keyboard
                if (_this.props.inline && !_this.props.shouldFocusDayInline) shouldFocusWeekNumber = false;
                // the activeElement is in the container, and it is another instance of WeekNumber
                if (_this.props.containerRef && _this.props.containerRef.current && _this.props.containerRef.current.contains(document.activeElement) && document.activeElement && document.activeElement.classList.contains("react-datepicker__week-number")) shouldFocusWeekNumber = true;
            }
            shouldFocusWeekNumber && _this.weekNumberEl.current && _this.weekNumberEl.current.focus({
                preventScroll: true
            });
        };
        return _this;
    }
    Object.defineProperty(WeekNumber, "defaultProps", {
        get: function() {
            return {
                ariaLabelPrefix: "week "
            };
        },
        enumerable: false,
        configurable: true
    });
    WeekNumber.prototype.componentDidMount = function() {
        this.handleFocusWeekNumber();
    };
    WeekNumber.prototype.componentDidUpdate = function(prevProps) {
        this.handleFocusWeekNumber(prevProps);
    };
    WeekNumber.prototype.render = function() {
        var _a = this.props, weekNumber = _a.weekNumber, isWeekDisabled = _a.isWeekDisabled, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? WeekNumber.defaultProps.ariaLabelPrefix : _b, onClick = _a.onClick;
        var weekNumberClasses = {
            "react-datepicker__week-number": true,
            "react-datepicker__week-number--clickable": !!onClick && !isWeekDisabled,
            "react-datepicker__week-number--selected": !!onClick && $7c7b1a6f859720e7$var$isSameDay(this.props.date, this.props.selected)
        };
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            ref: this.weekNumberEl,
            className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(weekNumberClasses),
            "aria-label": "".concat(ariaLabelPrefix, " ").concat(this.props.weekNumber),
            onClick: this.handleClick,
            onKeyDown: this.handleOnKeyDown,
            tabIndex: this.getTabIndex(),
            role: "gridcell"
        }, weekNumber);
    };
    return WeekNumber;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$Week = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(Week, _super);
    function Week() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDisabled = function(day) {
            return $7c7b1a6f859720e7$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.handleDayClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleDayMouseEnter = function(day) {
            if (_this.props.onDayMouseEnter) _this.props.onDayMouseEnter(day);
        };
        _this.handleWeekClick = function(day, weekNumber, event) {
            var _a, _b, _c;
            var enabledWeekDay = new Date(day);
            for(var i = 0; i < 7; i++){
                var processingDay = new Date(day);
                processingDay.setDate(processingDay.getDate() + i);
                var isEnabled = !_this.isDisabled(processingDay);
                if (isEnabled) {
                    enabledWeekDay = processingDay;
                    break;
                }
            }
            if (typeof _this.props.onWeekSelect === "function") _this.props.onWeekSelect(enabledWeekDay, weekNumber, event);
            if (_this.props.showWeekPicker) _this.handleDayClick(enabledWeekDay, event);
            if ((_a = _this.props.shouldCloseOnSelect) !== null && _a !== void 0 ? _a : Week.defaultProps.shouldCloseOnSelect) (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, false);
        };
        _this.formatWeekNumber = function(date) {
            if (_this.props.formatWeekNumber) return _this.props.formatWeekNumber(date);
            return $7c7b1a6f859720e7$var$getWeek(date);
        };
        _this.isWeekDisabled = function() {
            var startOfWeek = _this.startOfWeek();
            var endOfWeek = (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(startOfWeek, 6);
            var processingDate = new Date(startOfWeek);
            while(processingDate <= endOfWeek){
                if (!_this.isDisabled(processingDate)) return false;
                processingDate = (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(processingDate, 1);
            }
            return true;
        };
        _this.renderDays = function() {
            var startOfWeek = _this.startOfWeek();
            var days = [];
            var weekNumber = _this.formatWeekNumber(startOfWeek);
            if (_this.props.showWeekNumber) {
                var onClickAction = _this.props.onWeekSelect || _this.props.showWeekPicker ? _this.handleWeekClick.bind(_this, startOfWeek, weekNumber) : undefined;
                days.push((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$WeekNumber, $7c7b1a6f859720e7$var$_assign({
                    key: "W"
                }, Week.defaultProps, _this.props, {
                    weekNumber: weekNumber,
                    isWeekDisabled: _this.isWeekDisabled(),
                    date: startOfWeek,
                    onClick: onClickAction
                })));
            }
            return days.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(startOfWeek, offset);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$Day, $7c7b1a6f859720e7$var$_assign({}, Week.defaultProps, _this.props, {
                    ariaLabelPrefixWhenEnabled: _this.props.chooseDayAriaLabelPrefix,
                    ariaLabelPrefixWhenDisabled: _this.props.disabledDayAriaLabelPrefix,
                    key: day.valueOf(),
                    day: day,
                    onClick: _this.handleDayClick.bind(_this, day),
                    onMouseEnter: _this.handleDayMouseEnter.bind(_this, day)
                }));
            }));
        };
        _this.startOfWeek = function() {
            return $7c7b1a6f859720e7$var$getStartOfWeek(_this.props.day, _this.props.locale, _this.props.calendarStartDay);
        };
        _this.isKeyboardSelected = function() {
            return !_this.props.disabledKeyboardNavigation && !$7c7b1a6f859720e7$var$isSameDay(_this.startOfWeek(), _this.props.selected) && $7c7b1a6f859720e7$var$isSameDay(_this.startOfWeek(), _this.props.preSelection);
        };
        return _this;
    }
    Object.defineProperty(Week, "defaultProps", {
        get: function() {
            return {
                shouldCloseOnSelect: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Week.prototype.render = function() {
        var weekNumberClasses = {
            "react-datepicker__week": true,
            "react-datepicker__week--selected": $7c7b1a6f859720e7$var$isSameDay(this.startOfWeek(), this.props.selected),
            "react-datepicker__week--keyboard-selected": this.isKeyboardSelected()
        };
        var customWeekClassName = this.props.weekClassName ? this.props.weekClassName(this.startOfWeek()) : undefined;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(weekNumberClasses, customWeekClassName),
            role: "row"
        }, this.renderDays());
    };
    return Week;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$_a;
var $7c7b1a6f859720e7$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT = 6;
var $7c7b1a6f859720e7$var$MONTH_COLUMNS_LAYOUT = {
    TWO_COLUMNS: "two_columns",
    THREE_COLUMNS: "three_columns",
    FOUR_COLUMNS: "four_columns"
};
var $7c7b1a6f859720e7$var$MONTH_COLUMNS = ($7c7b1a6f859720e7$var$_a = {}, $7c7b1a6f859720e7$var$_a[$7c7b1a6f859720e7$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS] = {
    grid: [
        [
            0,
            1
        ],
        [
            2,
            3
        ],
        [
            4,
            5
        ],
        [
            6,
            7
        ],
        [
            8,
            9
        ],
        [
            10,
            11
        ]
    ],
    verticalNavigationOffset: 2
}, $7c7b1a6f859720e7$var$_a[$7c7b1a6f859720e7$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2
        ],
        [
            3,
            4,
            5
        ],
        [
            6,
            7,
            8
        ],
        [
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 3
}, $7c7b1a6f859720e7$var$_a[$7c7b1a6f859720e7$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS] = {
    grid: [
        [
            0,
            1,
            2,
            3
        ],
        [
            4,
            5,
            6,
            7
        ],
        [
            8,
            9,
            10,
            11
        ]
    ],
    verticalNavigationOffset: 4
}, $7c7b1a6f859720e7$var$_a);
var $7c7b1a6f859720e7$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET = 1;
function $7c7b1a6f859720e7$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker) {
    if (showFourColumnMonthYearPicker) return $7c7b1a6f859720e7$var$MONTH_COLUMNS_LAYOUT.FOUR_COLUMNS;
    if (showTwoColumnMonthYearPicker) return $7c7b1a6f859720e7$var$MONTH_COLUMNS_LAYOUT.TWO_COLUMNS;
    return $7c7b1a6f859720e7$var$MONTH_COLUMNS_LAYOUT.THREE_COLUMNS;
}
/**
 * `Month` is a React component that represents a month in a calendar.
 * It accepts a `MonthProps` object as props which provides various configurations and event handlers.
 *
 * @prop dayClassName - Function to determine the class name for a day.
 * @prop monthClassName - Function to determine the class name for a month.
 * @prop filterDate - Function to filter dates.
 * @prop formatWeekNumber - Function to format the week number.
 * @prop onDayClick - Function to handle day click events.
 * @prop onDayMouseEnter - Function to handle mouse enter events on a day.
 * @prop onMouseLeave - Function to handle mouse leave events.
 * @prop onWeekSelect - Function to handle week selection.
 * @prop setPreSelection - Function to set pre-selection.
 * @prop setOpen - Function to set open state.
 * @prop renderDayContents - Function to render day contents.
 * @prop renderMonthContent - Function to render month content.
 * @prop renderQuarterContent - Function to render quarter content.
 * @prop handleOnKeyDown - Function to handle key down events.
 * @prop handleOnMonthKeyDown - Function to handle key down events on a month.
 * @prop ariaLabelPrefix - Aria label prefix.
 * @prop chooseDayAriaLabelPrefix - Aria label prefix for choosing a day.
 * @prop disabledDayAriaLabelPrefix - Aria label prefix for disabled day.
 * @prop disabledKeyboardNavigation - Flag to disable keyboard navigation.
 * @prop day - The day.
 * @prop endDate - The end date.
 * @prop orderInDisplay - The order in display.
 * @prop excludeDates - Dates to exclude.
 * @prop excludeDateIntervals - Date intervals to exclude.
 * @prop fixedHeight - Flag to set fixed height.
 * @prop highlightDates - Dates to highlight.
 * @prop holidays - Holidays.
 * @prop includeDates - Dates to include.
 * @prop includeDateIntervals - Date intervals to include.
 * @prop inline - Flag to set inline.
 * @prop shouldFocusDayInline - Flag to set focus on day inline.
 * @prop locale - The locale.
 * @prop maxDate - The maximum date.
 * @prop minDate - The minimum date.
 * @prop usePointerEvent - Flag to use pointer event.
 * @prop peekNextMonth - Flag to peek next month.
 * @prop preSelection - The pre-selection.
 * @prop selected - The selected date.
 * @prop selectingDate - The selecting date.
 * @prop calendarStartDay - The calendar start day.
 * @prop selectsEnd - Flag to select end.
 * @prop selectsStart - Flag to select start.
 * @prop selectsRange - Flag to select range.
 * @prop selectsDisabledDaysInRange - Flag to select disabled days in range.
 * @prop selectsMultiple - Flag to select multiple.
 * @prop selectedDates - The selected dates.
 * @prop showWeekNumbers - Flag to show week numbers.
 * @prop startDate - The start date.
 * @prop shouldCloseOnSelect - Flag to close on select.
 * @prop showMonthYearPicker - Flag to show month year picker.
 * @prop showFullMonthYearPicker - Flag to show full month year picker.
 * @prop showTwoColumnMonthYearPicker - Flag to show two column month year picker.
 * @prop showFourColumnMonthYearPicker - Flag to show four column month year picker.
 * @prop showQuarterYearPicker - Flag to show quarter year picker.
 * @prop showWeekPicker - Flag to show week picker.
 * @prop isInputFocused - Flag to set input focus.
 * @prop weekAriaLabelPrefix - Aria label prefix for week.
 * @prop containerRef - The container reference.
 * @prop monthShowsDuplicateDaysEnd - Flag to show duplicate days at the end of the month.
 * @prop monthShowsDuplicateDaysStart - Flag to show duplicate days at the start of the month.
 *
 * @example
 * ```tsx
 * function App() {
 *  const handleDayClick = (date) => {
 *     console.log('Day clicked: ', date);
 *   };
 *
 *   const handleDayMouseEnter = (date) => {
 *     console.log('Mouse entered on day: ', date);
 *   };
 *
 *   return (
 *     <div>
 *       <Month
 *         day={new Date()}
 *         endDate={new Date()}
 *         onDayClick={handleDayClick}
 *         onDayMouseEnter={handleDayMouseEnter}
 *         disabledKeyboardNavigation={false}
 *         showWeekNumbers={true}
 *         showMonthYearPicker={false}
 *       />
 *     </div>
 *   );
 * }
 * ```
 */ var $7c7b1a6f859720e7$var$Month = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(Month, _super);
    function Month() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.MONTH_REFS = $7c7b1a6f859720e7$var$__spreadArray([], Array(12), true).map(function() {
            return (0, $7fPBF.createRef)();
        });
        _this.QUARTER_REFS = $7c7b1a6f859720e7$var$__spreadArray([], Array(4), true).map(function() {
            return (0, $7fPBF.createRef)();
        });
        _this.isDisabled = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $7c7b1a6f859720e7$var$isDayDisabled(day, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals,
                includeDateIntervals: _this.props.includeDateIntervals,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate,
                disabled: _this.props.disabled
            });
        };
        _this.isExcluded = function(day) {
            // Almost all props previously were passed as this.props w/o proper typing with prop-types
            // after the migration to TS i made it explicit
            return $7c7b1a6f859720e7$var$isDayExcluded(day, {
                excludeDates: _this.props.excludeDates,
                excludeDateIntervals: _this.props.excludeDateIntervals
            });
        };
        _this.handleDayClick = function(day, event) {
            var _a, _b;
            (_b = (_a = _this.props).onDayClick) === null || _b === void 0 || _b.call(_a, day, event, _this.props.orderInDisplay);
        };
        _this.handleDayMouseEnter = function(day) {
            var _a, _b;
            (_b = (_a = _this.props).onDayMouseEnter) === null || _b === void 0 || _b.call(_a, day);
        };
        _this.handleMouseLeave = function() {
            var _a, _b;
            (_b = (_a = _this.props).onMouseLeave) === null || _b === void 0 || _b.call(_a);
        };
        _this.isRangeStartMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $7c7b1a6f859720e7$var$isSameMonth((0, $a04ce585cc1453dc$export$63264690f8e36790)(day, m), startDate);
        };
        _this.isRangeStartQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $7c7b1a6f859720e7$var$isSameQuarter((0, $e9d24921719c0925$export$8924d1de7efe1755)(day, q), startDate);
        };
        _this.isRangeEndMonth = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $7c7b1a6f859720e7$var$isSameMonth((0, $a04ce585cc1453dc$export$63264690f8e36790)(day, m), endDate);
        };
        _this.isRangeEndQuarter = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate;
            if (!startDate || !endDate) return false;
            return $7c7b1a6f859720e7$var$isSameQuarter((0, $e9d24921719c0925$export$8924d1de7efe1755)(day, q), endDate);
        };
        _this.isInSelectingRangeMonth = function(m) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $7c7b1a6f859720e7$var$isMonthInRange(selectingDate, endDate, m, day);
            if (selectsEnd && startDate) return $7c7b1a6f859720e7$var$isMonthInRange(startDate, selectingDate, m, day);
            if (selectsRange && startDate && !endDate) return $7c7b1a6f859720e7$var$isMonthInRange(startDate, selectingDate, m, day);
            return false;
        };
        _this.isSelectingMonthRangeStart = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _month = (0, $a04ce585cc1453dc$export$63264690f8e36790)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsStart) return $7c7b1a6f859720e7$var$isSameMonth(_month, selectingDate);
            else return $7c7b1a6f859720e7$var$isSameMonth(_month, startDate);
        };
        _this.isSelectingMonthRangeEnd = function(m) {
            var _a;
            if (!_this.isInSelectingRangeMonth(m)) return false;
            var _b = _this.props, day = _b.day, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _month = (0, $a04ce585cc1453dc$export$63264690f8e36790)(day, m);
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (selectsEnd || selectsRange) return $7c7b1a6f859720e7$var$isSameMonth(_month, selectingDate);
            else return $7c7b1a6f859720e7$var$isSameMonth(_month, endDate);
        };
        _this.isInSelectingRangeQuarter = function(q) {
            var _a;
            var _b = _this.props, day = _b.day, selectsStart = _b.selectsStart, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate;
            var selectingDate = (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
            if (!(selectsStart || selectsEnd || selectsRange) || !selectingDate) return false;
            if (selectsStart && endDate) return $7c7b1a6f859720e7$var$isQuarterInRange(selectingDate, endDate, q, day);
            if (selectsEnd && startDate) return $7c7b1a6f859720e7$var$isQuarterInRange(startDate, selectingDate, q, day);
            if (selectsRange && startDate && !endDate) return $7c7b1a6f859720e7$var$isQuarterInRange(startDate, selectingDate, q, day);
            return false;
        };
        _this.isWeekInMonth = function(startOfWeek) {
            var day = _this.props.day;
            var endOfWeek = (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(startOfWeek, 6);
            return $7c7b1a6f859720e7$var$isSameMonth(startOfWeek, day) || $7c7b1a6f859720e7$var$isSameMonth(endOfWeek, day);
        };
        _this.isCurrentMonth = function(day, m) {
            return (0, $18282d9928d9137b$export$5846dc2d57a5c860)(day) === (0, $18282d9928d9137b$export$5846dc2d57a5c860)($7c7b1a6f859720e7$var$newDate()) && m === (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)($7c7b1a6f859720e7$var$newDate());
        };
        _this.isCurrentQuarter = function(day, q) {
            return (0, $18282d9928d9137b$export$5846dc2d57a5c860)(day) === (0, $18282d9928d9137b$export$5846dc2d57a5c860)($7c7b1a6f859720e7$var$newDate()) && q === (0, $5b98fcfb96403ba3$export$de90a4bb31c25221)($7c7b1a6f859720e7$var$newDate());
        };
        _this.isSelectedMonth = function(day, m, selected) {
            return (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(selected) === m && (0, $18282d9928d9137b$export$5846dc2d57a5c860)(day) === (0, $18282d9928d9137b$export$5846dc2d57a5c860)(selected);
        };
        _this.isSelectMonthInList = function(day, m, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedMonth(day, m, selectedDate);
            });
        };
        _this.isSelectedQuarter = function(day, q, selected) {
            return (0, $5b98fcfb96403ba3$export$de90a4bb31c25221)(selected) === q && (0, $18282d9928d9137b$export$5846dc2d57a5c860)(day) === (0, $18282d9928d9137b$export$5846dc2d57a5c860)(selected);
        };
        _this.isSelectQuarterInList = function(day, q, selectedDates) {
            return selectedDates.some(function(selectedDate) {
                return _this.isSelectedQuarter(day, q, selectedDate);
            });
        };
        _this.isMonthSelected = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
            var monthIdx = (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(day);
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return _this.isSelectedMonth(day, monthIdx, date);
            });
            return !!selected && _this.isSelectedMonth(day, monthIdx, selected);
        };
        _this.isQuarterSelected = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
            var quarterIdx = (0, $5b98fcfb96403ba3$export$de90a4bb31c25221)(day);
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(selectedDate) {
                return _this.isSelectedQuarter(day, quarterIdx, selectedDate);
            });
            return !!selected && _this.isSelectedQuarter(day, quarterIdx, selected);
        };
        _this.renderWeeks = function() {
            // Return empty array if day is invalid
            if (!$7c7b1a6f859720e7$var$isValid(_this.props.day)) return [];
            var weeks = [];
            var isFixedHeight = _this.props.fixedHeight;
            var i = 0;
            var breakAfterNextPush = false;
            var currentWeekStart = $7c7b1a6f859720e7$var$getStartOfWeek($7c7b1a6f859720e7$var$getStartOfMonth(_this.props.day), _this.props.locale, _this.props.calendarStartDay);
            var isPreSelected = function(preSelection) {
                return _this.props.showWeekPicker ? $7c7b1a6f859720e7$var$getStartOfWeek(preSelection, _this.props.locale, _this.props.calendarStartDay) : _this.props.preSelection;
            };
            var isSelected = function(selected) {
                return _this.props.showWeekPicker ? $7c7b1a6f859720e7$var$getStartOfWeek(selected, _this.props.locale, _this.props.calendarStartDay) : _this.props.selected;
            };
            var selected = _this.props.selected ? isSelected(_this.props.selected) : undefined;
            var preSelection = _this.props.preSelection ? isPreSelected(_this.props.preSelection) : undefined;
            while(true){
                weeks.push((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$Week, $7c7b1a6f859720e7$var$_assign({}, _this.props, {
                    ariaLabelPrefix: _this.props.weekAriaLabelPrefix,
                    key: i,
                    day: currentWeekStart,
                    month: (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(_this.props.day),
                    onDayClick: _this.handleDayClick,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    selected: selected,
                    preSelection: preSelection,
                    showWeekNumber: _this.props.showWeekNumbers
                })));
                if (breakAfterNextPush) break;
                i++;
                currentWeekStart = (0, $65f6621a4d881172$export$ef501a2bb4f3ee6b)(currentWeekStart, 1);
                // If one of these conditions is true, we will either break on this week
                // or break on the next week
                var isFixedAndFinalWeek = isFixedHeight && i >= $7c7b1a6f859720e7$var$FIXED_HEIGHT_STANDARD_WEEK_COUNT;
                var isNonFixedAndOutOfMonth = !isFixedHeight && !_this.isWeekInMonth(currentWeekStart);
                if (isFixedAndFinalWeek || isNonFixedAndOutOfMonth) {
                    if (_this.props.peekNextMonth) breakAfterNextPush = true;
                    else break;
                }
            }
            return weeks;
        };
        _this.onMonthClick = function(event, m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayClick($7c7b1a6f859720e7$var$getStartOfMonth(labelDate), event);
        };
        _this.onMonthMouseEnter = function(m) {
            var _a = _this.isMonthDisabledForLabelDate(m), isDisabled = _a.isDisabled, labelDate = _a.labelDate;
            if (isDisabled) return;
            _this.handleDayMouseEnter($7c7b1a6f859720e7$var$getStartOfMonth(labelDate));
        };
        _this.handleMonthNavigation = function(newMonth, newDate) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.MONTH_REFS[newMonth]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.handleKeyboardNavigation = function(event, eventKey, month) {
            var _a;
            var _b = _this.props, selected = _b.selected, preSelection = _b.preSelection, setPreSelection = _b.setPreSelection, minDate = _b.minDate, maxDate = _b.maxDate, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker;
            if (!preSelection) return;
            var monthColumnsLayout = $7c7b1a6f859720e7$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker);
            var verticalOffset = _this.getVerticalOffset(monthColumnsLayout);
            var monthsGrid = (_a = $7c7b1a6f859720e7$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.grid;
            var calculateNewDateAndMonth = function(eventKey, date, month) {
                var _a, _b;
                var newCalculatedDate = date;
                var newCalculatedMonth = month;
                switch(eventKey){
                    case $7c7b1a6f859720e7$var$KeyType.ArrowRight:
                        newCalculatedDate = (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(date, $7c7b1a6f859720e7$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 11 ? 0 : month + $7c7b1a6f859720e7$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $7c7b1a6f859720e7$var$KeyType.ArrowLeft:
                        newCalculatedDate = (0, $9ccdf5b091b4766d$export$73d1c15a21f9fae5)(date, $7c7b1a6f859720e7$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET);
                        newCalculatedMonth = month === 0 ? 11 : month - $7c7b1a6f859720e7$var$MONTH_NAVIGATION_HORIZONTAL_OFFSET;
                        break;
                    case $7c7b1a6f859720e7$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $9ccdf5b091b4766d$export$73d1c15a21f9fae5)(date, verticalOffset);
                        newCalculatedMonth = ((_a = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[0]) === null || _a === void 0 ? void 0 : _a.includes(month)) ? month + 12 - verticalOffset : month - verticalOffset;
                        break;
                    case $7c7b1a6f859720e7$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(date, verticalOffset);
                        newCalculatedMonth = ((_b = monthsGrid === null || monthsGrid === void 0 ? void 0 : monthsGrid[monthsGrid.length - 1]) === null || _b === void 0 ? void 0 : _b.includes(month)) ? month - 12 + verticalOffset : month + verticalOffset;
                        break;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            var getNewDateAndMonth = function(eventKey, selectedDate, month) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var _a = calculateNewDateAndMonth(eventKeyCopy, selectedDate, month), newCalculatedDate = _a.newCalculatedDate, newCalculatedMonth = _a.newCalculatedMonth;
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newCalculatedDate = selectedDate;
                        newCalculatedMonth = month;
                        break;
                    }
                    // if minDate exists and the new month is before the minimum month, it will try to find the next available month after
                    if (minDate && newCalculatedDate < minDate) {
                        eventKeyCopy = $7c7b1a6f859720e7$var$KeyType.ArrowRight;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    // if maxDate exists and the new month is after the maximum month, it will try to find the next available month before
                    if (maxDate && newCalculatedDate > maxDate) {
                        eventKeyCopy = $7c7b1a6f859720e7$var$KeyType.ArrowLeft;
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    }
                    if ($7c7b1a6f859720e7$var$isMonthYearDisabled(newCalculatedDate, _this.props)) {
                        var obj = calculateNewDateAndMonth(eventKeyCopy, newCalculatedDate, newCalculatedMonth);
                        newCalculatedDate = obj.newCalculatedDate;
                        newCalculatedMonth = obj.newCalculatedMonth;
                    } else validDateFound = true;
                    iterations++;
                }
                return {
                    newCalculatedDate: newCalculatedDate,
                    newCalculatedMonth: newCalculatedMonth
                };
            };
            if (eventKey === $7c7b1a6f859720e7$var$KeyType.Enter) {
                if (!_this.isMonthDisabled(month)) {
                    _this.onMonthClick(event, month);
                    setPreSelection === null || setPreSelection === void 0 || setPreSelection(selected);
                }
                return;
            }
            var _c = getNewDateAndMonth(eventKey, preSelection, month), newCalculatedDate = _c.newCalculatedDate, newCalculatedMonth = _c.newCalculatedMonth;
            switch(eventKey){
                case $7c7b1a6f859720e7$var$KeyType.ArrowRight:
                case $7c7b1a6f859720e7$var$KeyType.ArrowLeft:
                case $7c7b1a6f859720e7$var$KeyType.ArrowUp:
                case $7c7b1a6f859720e7$var$KeyType.ArrowDown:
                    _this.handleMonthNavigation(newCalculatedMonth, newCalculatedDate);
                    break;
            }
        };
        _this.getVerticalOffset = function(monthColumnsLayout) {
            var _a, _b;
            return (_b = (_a = $7c7b1a6f859720e7$var$MONTH_COLUMNS[monthColumnsLayout]) === null || _a === void 0 ? void 0 : _a.verticalNavigationOffset) !== null && _b !== void 0 ? _b : 0;
        };
        _this.onMonthKeyDown = function(event, month) {
            var _a = _this.props, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, handleOnMonthKeyDown = _a.handleOnMonthKeyDown;
            var eventKey = event.key;
            if (eventKey !== $7c7b1a6f859720e7$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!disabledKeyboardNavigation) _this.handleKeyboardNavigation(event, eventKey, month);
            handleOnMonthKeyDown && handleOnMonthKeyDown(event);
        };
        _this.onQuarterClick = function(event, q) {
            var labelDate = (0, $e9d24921719c0925$export$8924d1de7efe1755)(_this.props.day, q);
            if ($7c7b1a6f859720e7$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayClick($7c7b1a6f859720e7$var$getStartOfQuarter(labelDate), event);
        };
        _this.onQuarterMouseEnter = function(q) {
            var labelDate = (0, $e9d24921719c0925$export$8924d1de7efe1755)(_this.props.day, q);
            if ($7c7b1a6f859720e7$var$isQuarterDisabled(labelDate, _this.props)) return;
            _this.handleDayMouseEnter($7c7b1a6f859720e7$var$getStartOfQuarter(labelDate));
        };
        _this.handleQuarterNavigation = function(newQuarter, newDate) {
            var _a, _b, _c, _d;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            (_d = (_c = _this.QUARTER_REFS[newQuarter - 1]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.onQuarterKeyDown = function(event, quarter) {
            var _a, _b;
            var eventKey = event.key;
            if (!_this.props.disabledKeyboardNavigation) switch(eventKey){
                case $7c7b1a6f859720e7$var$KeyType.Enter:
                    _this.onQuarterClick(event, quarter);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $7c7b1a6f859720e7$var$KeyType.ArrowRight:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 4 ? 1 : quarter + 1, (0, $4e9bcc6ff9d39f34$export$c252a41d0fbed2ce)(_this.props.preSelection, 1));
                    break;
                case $7c7b1a6f859720e7$var$KeyType.ArrowLeft:
                    if (!_this.props.preSelection) break;
                    _this.handleQuarterNavigation(quarter === 1 ? 4 : quarter - 1, (0, $3b7a595f94262fab$export$a31bfeeeee80cce6)(_this.props.preSelection, 1));
                    break;
            }
        };
        _this.isMonthDisabledForLabelDate = function(month) {
            var _a;
            var _b = _this.props, day = _b.day, disabled = _b.disabled, minDate = _b.minDate, maxDate = _b.maxDate, excludeDates = _b.excludeDates, includeDates = _b.includeDates;
            var labelDate = (0, $a04ce585cc1453dc$export$63264690f8e36790)(day, month);
            if (disabled) return {
                isDisabled: true,
                labelDate: (0, $a04ce585cc1453dc$export$63264690f8e36790)(day, month)
            };
            return {
                isDisabled: (_a = (minDate || maxDate || excludeDates || includeDates) && $7c7b1a6f859720e7$var$isMonthDisabled(labelDate, _this.props)) !== null && _a !== void 0 ? _a : false,
                labelDate: labelDate
            };
        };
        _this.isMonthDisabled = function(month) {
            var isDisabled = _this.isMonthDisabledForLabelDate(month).isDisabled;
            return isDisabled;
        };
        _this.getMonthClassNames = function(m) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, preSelection = _a.preSelection, monthClassName = _a.monthClassName;
            var _monthClassName = monthClassName ? monthClassName((0, $a04ce585cc1453dc$export$63264690f8e36790)(day, m)) : undefined;
            var selection = _this.getSelection();
            return (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("react-datepicker__month-text", "react-datepicker__month-".concat(m), _monthClassName, {
                "react-datepicker__month-text--disabled": _this.isMonthDisabled(m),
                "react-datepicker__month-text--selected": selection ? _this.isSelectMonthInList(day, m, selection) : undefined,
                "react-datepicker__month-text--keyboard-selected": !_this.props.disabledKeyboardNavigation && preSelection && _this.isSelectedMonth(day, m, preSelection) && !_this.isMonthSelected() && !_this.isMonthDisabled(m),
                "react-datepicker__month-text--in-selecting-range": _this.isInSelectingRangeMonth(m),
                "react-datepicker__month-text--in-range": startDate && endDate ? $7c7b1a6f859720e7$var$isMonthInRange(startDate, endDate, m, day) : undefined,
                "react-datepicker__month-text--range-start": _this.isRangeStartMonth(m),
                "react-datepicker__month-text--range-end": _this.isRangeEndMonth(m),
                "react-datepicker__month-text--selecting-range-start": _this.isSelectingMonthRangeStart(m),
                "react-datepicker__month-text--selecting-range-end": _this.isSelectingMonthRangeEnd(m),
                "react-datepicker__month-text--today": _this.isCurrentMonth(day, m)
            });
        };
        _this.getTabIndex = function(m) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedMonth = (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(_this.props.preSelection);
            var isPreSelectedMonthDisabled = _this.isMonthDisabledForLabelDate(preSelectedMonth).isDisabled;
            var tabIndex = m === preSelectedMonth && !(isPreSelectedMonthDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getQuarterTabIndex = function(q) {
            if (_this.props.preSelection == null) return "-1";
            var preSelectedQuarter = (0, $5b98fcfb96403ba3$export$de90a4bb31c25221)(_this.props.preSelection);
            var isCurrentQuarterDisabled = $7c7b1a6f859720e7$var$isQuarterDisabled(_this.props.day, _this.props);
            var tabIndex = q === preSelectedQuarter && !(isCurrentQuarterDisabled || _this.props.disabledKeyboardNavigation) ? "0" : "-1";
            return tabIndex;
        };
        _this.getAriaLabel = function(month) {
            var _a = _this.props, _b = _a.chooseDayAriaLabelPrefix, chooseDayAriaLabelPrefix = _b === void 0 ? "Choose" : _b, _c = _a.disabledDayAriaLabelPrefix, disabledDayAriaLabelPrefix = _c === void 0 ? "Not available" : _c, day = _a.day, locale = _a.locale;
            var labelDate = (0, $a04ce585cc1453dc$export$63264690f8e36790)(day, month);
            var prefix = _this.isDisabled(labelDate) || _this.isExcluded(labelDate) ? disabledDayAriaLabelPrefix : chooseDayAriaLabelPrefix;
            return "".concat(prefix, " ").concat($7c7b1a6f859720e7$var$formatDate(labelDate, "MMMM yyyy", locale));
        };
        _this.getQuarterClassNames = function(q) {
            var _a = _this.props, day = _a.day, startDate = _a.startDate, endDate = _a.endDate, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, preSelection = _a.preSelection, disabledKeyboardNavigation = _a.disabledKeyboardNavigation, disabled = _a.disabled;
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && $7c7b1a6f859720e7$var$isQuarterDisabled((0, $e9d24921719c0925$export$8924d1de7efe1755)(day, q), _this.props);
            var selection = _this.getSelection();
            return (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("react-datepicker__quarter-text", "react-datepicker__quarter-".concat(q), {
                "react-datepicker__quarter-text--disabled": isDisabled,
                "react-datepicker__quarter-text--selected": selection ? _this.isSelectQuarterInList(day, q, selection) : undefined,
                "react-datepicker__quarter-text--keyboard-selected": !disabledKeyboardNavigation && preSelection && _this.isSelectedQuarter(day, q, preSelection) && !_this.isQuarterSelected() && !isDisabled,
                "react-datepicker__quarter-text--in-selecting-range": _this.isInSelectingRangeQuarter(q),
                "react-datepicker__quarter-text--in-range": startDate && endDate ? $7c7b1a6f859720e7$var$isQuarterInRange(startDate, endDate, q, day) : undefined,
                "react-datepicker__quarter-text--range-start": _this.isRangeStartQuarter(q),
                "react-datepicker__quarter-text--range-end": _this.isRangeEndQuarter(q),
                "react-datepicker__quarter-text--today": _this.isCurrentQuarter(day, q)
            });
        };
        _this.getMonthContent = function(m) {
            var _a = _this.props, showFullMonthYearPicker = _a.showFullMonthYearPicker, renderMonthContent = _a.renderMonthContent, locale = _a.locale, day = _a.day;
            var shortMonthText = $7c7b1a6f859720e7$var$getMonthShortInLocale(m, locale);
            var fullMonthText = $7c7b1a6f859720e7$var$getMonthInLocale(m, locale);
            if (renderMonthContent) return renderMonthContent(m, shortMonthText, fullMonthText, day);
            return showFullMonthYearPicker ? fullMonthText : shortMonthText;
        };
        _this.getQuarterContent = function(q) {
            var _a;
            var _b = _this.props, renderQuarterContent = _b.renderQuarterContent, locale = _b.locale;
            var shortQuarter = $7c7b1a6f859720e7$var$getQuarterShortInLocale(q, locale);
            return (_a = renderQuarterContent === null || renderQuarterContent === void 0 ? void 0 : renderQuarterContent(q, shortQuarter)) !== null && _a !== void 0 ? _a : shortQuarter;
        };
        _this.renderMonths = function() {
            var _a;
            var _b = _this.props, showTwoColumnMonthYearPicker = _b.showTwoColumnMonthYearPicker, showFourColumnMonthYearPicker = _b.showFourColumnMonthYearPicker, day = _b.day, selected = _b.selected;
            var monthColumns = (_a = $7c7b1a6f859720e7$var$MONTH_COLUMNS[$7c7b1a6f859720e7$var$getMonthColumnsLayout(showFourColumnMonthYearPicker, showTwoColumnMonthYearPicker)]) === null || _a === void 0 ? void 0 : _a.grid;
            return monthColumns === null || monthColumns === void 0 ? void 0 : monthColumns.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    className: "react-datepicker__month-wrapper",
                    key: i
                }, month.map(function(m, j) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                        ref: _this.MONTH_REFS[m],
                        key: j,
                        onClick: function(event) {
                            _this.onMonthClick(event, m);
                        },
                        onKeyDown: function(event) {
                            if ($7c7b1a6f859720e7$var$isSpaceKeyDown(event)) {
                                event.preventDefault();
                                event.key = $7c7b1a6f859720e7$var$KeyType.Enter;
                            }
                            _this.onMonthKeyDown(event, m);
                        },
                        onMouseEnter: !_this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        onPointerEnter: _this.props.usePointerEvent ? function() {
                            return _this.onMonthMouseEnter(m);
                        } : undefined,
                        tabIndex: Number(_this.getTabIndex(m)),
                        className: _this.getMonthClassNames(m),
                        "aria-disabled": _this.isMonthDisabled(m),
                        role: "option",
                        "aria-label": _this.getAriaLabel(m),
                        "aria-current": _this.isCurrentMonth(day, m) ? "date" : undefined,
                        "aria-selected": selected ? _this.isSelectedMonth(day, m, selected) : undefined
                    }, _this.getMonthContent(m));
                }));
            });
        };
        _this.renderQuarters = function() {
            var _a = _this.props, day = _a.day, selected = _a.selected;
            var quarters = [
                1,
                2,
                3,
                4
            ];
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__quarter-wrapper"
            }, quarters.map(function(q, j) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    key: j,
                    ref: _this.QUARTER_REFS[j],
                    role: "option",
                    onClick: function(event) {
                        _this.onQuarterClick(event, q);
                    },
                    onKeyDown: function(event) {
                        _this.onQuarterKeyDown(event, q);
                    },
                    onMouseEnter: !_this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    onPointerEnter: _this.props.usePointerEvent ? function() {
                        return _this.onQuarterMouseEnter(q);
                    } : undefined,
                    className: _this.getQuarterClassNames(q),
                    "aria-selected": selected ? _this.isSelectedQuarter(day, q, selected) : undefined,
                    tabIndex: Number(_this.getQuarterTabIndex(q)),
                    "aria-current": _this.isCurrentQuarter(day, q) ? "date" : undefined
                }, _this.getQuarterContent(q));
            }));
        };
        _this.getClassNames = function() {
            var _a = _this.props, selectingDate = _a.selectingDate, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, showWeekPicker = _a.showWeekPicker;
            return (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("react-datepicker__month", {
                "react-datepicker__month--selecting-range": selectingDate && (selectsStart || selectsEnd)
            }, {
                "react-datepicker__monthPicker": showMonthYearPicker
            }, {
                "react-datepicker__quarterPicker": showQuarterYearPicker
            }, {
                "react-datepicker__weekPicker": showWeekPicker
            });
        };
        return _this;
    }
    Month.prototype.getSelection = function() {
        var _a = this.props, selected = _a.selected, selectedDates = _a.selectedDates, selectsMultiple = _a.selectsMultiple;
        if (selectsMultiple) return selectedDates;
        if (selected) return [
            selected
        ];
        return undefined;
    };
    Month.prototype.render = function() {
        var _a = this.props, showMonthYearPicker = _a.showMonthYearPicker, showQuarterYearPicker = _a.showQuarterYearPicker, day = _a.day, _b = _a.ariaLabelPrefix, ariaLabelPrefix = _b === void 0 ? "Month " : _b;
        var formattedAriaLabelPrefix = ariaLabelPrefix ? ariaLabelPrefix.trim() + " " : "";
        // Format aria-label, return empty string if date is invalid
        var formattedAriaLabel = $7c7b1a6f859720e7$var$isValid(day) ? "".concat(formattedAriaLabelPrefix).concat($7c7b1a6f859720e7$var$formatDate(day, "MMMM, yyyy", this.props.locale)) : "";
        var shouldUseListboxRole = showMonthYearPicker || showQuarterYearPicker;
        if (shouldUseListboxRole) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": formattedAriaLabel,
            role: "listbox"
        }, showMonthYearPicker ? this.renderMonths() : this.renderQuarters());
        // For regular calendar view, use table structure
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            role: "table"
        }, this.props.dayNamesHeader && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            role: "rowgroup"
        }, this.props.dayNamesHeader), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: this.getClassNames(),
            onMouseLeave: !this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.handleMouseLeave : undefined,
            "aria-label": formattedAriaLabel,
            role: "rowgroup"
        }, this.renderWeeks()));
    };
    return Month;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$MonthDropdownOptions = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(MonthDropdownOptions, _super);
    function MonthDropdownOptions() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.monthOptionButtonsRef = {};
        _this.isSelectedMonth = function(i) {
            return _this.props.month === i;
        };
        _this.handleOptionKeyDown = function(i, e) {
            var _a;
            switch(e.key){
                case "Enter":
                    e.preventDefault();
                    _this.onChange(i);
                    break;
                case "Escape":
                    e.preventDefault();
                    _this.props.onCancel();
                    break;
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault();
                    var newMonth = (i + (e.key === "ArrowUp" ? -1 : 1) + _this.props.monthNames.length) % _this.props.monthNames.length;
                    (_a = _this.monthOptionButtonsRef[newMonth]) === null || _a === void 0 || _a.focus();
                    break;
            }
        };
        _this.renderOptions = function() {
            // Clear refs to prevent memory leaks on re-render
            _this.monthOptionButtonsRef = {};
            return _this.props.monthNames.map(function(month, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    ref: function(el) {
                        _this.monthOptionButtonsRef[i] = el;
                        if (_this.isSelectedMonth(i)) el === null || el === void 0 || el.focus();
                    },
                    role: "button",
                    tabIndex: 0,
                    className: _this.isSelectedMonth(i) ? "react-datepicker__month-option react-datepicker__month-option--selected_month" : "react-datepicker__month-option",
                    key: month,
                    onClick: _this.onChange.bind(_this, i),
                    onKeyDown: _this.handleOptionKeyDown.bind(_this, i),
                    "aria-selected": _this.isSelectedMonth(i) ? "true" : undefined
                }, _this.isSelectedMonth(i) ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "react-datepicker__month-option--selected"
                }, "\u2713") : "", month);
            });
        };
        _this.onChange = function(month) {
            return _this.props.onChange(month);
        };
        _this.handleClickOutside = function() {
            return _this.props.onCancel();
        };
        return _this;
    }
    MonthDropdownOptions.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$ClickOutsideWrapper, {
            className: "react-datepicker__month-dropdown",
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthDropdownOptions;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$MonthDropdown = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(MonthDropdown, _super);
    function MonthDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function(monthNames) {
            return monthNames.map(function(m, i) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("option", {
                    key: m,
                    value: i
                }, m);
            });
        };
        _this.renderSelectMode = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("select", {
                value: _this.props.month,
                className: "react-datepicker__month-select",
                onChange: function(e) {
                    return _this.onChange(parseInt(e.target.value));
                }
            }, _this.renderSelectOptions(monthNames));
        };
        _this.renderReadView = function(visible, monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
                key: "read",
                type: "button",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                className: "react-datepicker__month-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                className: "react-datepicker__month-read-view--selected-month"
            }, monthNames[_this.props.month]));
        };
        _this.renderDropdown = function(monthNames) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$MonthDropdownOptions, $7c7b1a6f859720e7$var$_assign({
                key: "dropdown"
            }, _this.props, {
                monthNames: monthNames,
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function(monthNames) {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible, monthNames)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown(monthNames));
            return result;
        };
        _this.onChange = function(month) {
            _this.toggleDropdown();
            if (month !== _this.props.month) _this.props.onChange(month);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthDropdown.prototype.render = function() {
        var _this = this;
        var monthNames = [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map(this.props.useShortMonthInDropdown ? function(m) {
            return $7c7b1a6f859720e7$var$getMonthShortInLocale(m, _this.props.locale);
        } : function(m) {
            return $7c7b1a6f859720e7$var$getMonthInLocale(m, _this.props.locale);
        });
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode(monthNames);
                break;
            case "select":
                renderedDropdown = this.renderSelectMode(monthNames);
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthDropdown;
}((0, $7fPBF.Component));
function $7c7b1a6f859720e7$var$generateMonthYears(minDate, maxDate) {
    var list = [];
    var currDate = $7c7b1a6f859720e7$var$getStartOfMonth(minDate);
    var lastDate = $7c7b1a6f859720e7$var$getStartOfMonth(maxDate);
    while(!(0, $04f0c9d20b09837b$export$e4de839670987035)(currDate, lastDate)){
        list.push($7c7b1a6f859720e7$var$newDate(currDate));
        currDate = (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(currDate, 1);
    }
    return list;
}
var $7c7b1a6f859720e7$var$MonthYearDropdownOptions = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(MonthYearDropdownOptions, _super);
    function MonthYearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.renderOptions = function() {
            return _this.state.monthYearsList.map(function(monthYear) {
                var monthYearPoint = (0, $8ab40eacd8053634$export$1428f42a7de81803)(monthYear);
                var isSameMonthYear = $7c7b1a6f859720e7$var$isSameYear(_this.props.date, monthYear) && $7c7b1a6f859720e7$var$isSameMonth(_this.props.date, monthYear);
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    className: isSameMonthYear ? "react-datepicker__month-year-option--selected_month-year" : "react-datepicker__month-year-option",
                    key: monthYearPoint,
                    onClick: _this.onChange.bind(_this, monthYearPoint),
                    "aria-selected": isSameMonthYear ? "true" : undefined
                }, isSameMonthYear ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "react-datepicker__month-year-option--selected"
                }, "\u2713") : "", $7c7b1a6f859720e7$var$formatDate(monthYear, _this.props.dateFormat, _this.props.locale));
            });
        };
        _this.onChange = function(monthYear) {
            return _this.props.onChange(monthYear);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.state = {
            monthYearsList: $7c7b1a6f859720e7$var$generateMonthYears(_this.props.minDate, _this.props.maxDate)
        };
        return _this;
    }
    MonthYearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)({
            "react-datepicker__month-year-dropdown": true,
            "react-datepicker__month-year-dropdown--scrollable": this.props.scrollableMonthYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$ClickOutsideWrapper, {
            className: dropdownClass,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return MonthYearDropdownOptions;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$MonthYearDropdown = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(MonthYearDropdown, _super);
    function MonthYearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var currDate = $7c7b1a6f859720e7$var$getStartOfMonth(_this.props.minDate);
            var lastDate = $7c7b1a6f859720e7$var$getStartOfMonth(_this.props.maxDate);
            var options = [];
            while(!(0, $04f0c9d20b09837b$export$e4de839670987035)(currDate, lastDate)){
                var timePoint = (0, $8ab40eacd8053634$export$1428f42a7de81803)(currDate);
                options.push((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("option", {
                    key: timePoint,
                    value: timePoint
                }, $7c7b1a6f859720e7$var$formatDate(currDate, _this.props.dateFormat, _this.props.locale)));
                currDate = (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(currDate, 1);
            }
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("select", {
                value: (0, $8ab40eacd8053634$export$1428f42a7de81803)($7c7b1a6f859720e7$var$getStartOfMonth(_this.props.date)),
                className: "react-datepicker__month-year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            var yearMonth = $7c7b1a6f859720e7$var$formatDate(_this.props.date, _this.props.dateFormat, _this.props.locale);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                key: "read",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__month-year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                className: "react-datepicker__month-year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                className: "react-datepicker__month-year-read-view--selected-month-year"
            }, yearMonth));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$MonthYearDropdownOptions, $7c7b1a6f859720e7$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(monthYearPoint) {
            _this.toggleDropdown();
            var changedDate = $7c7b1a6f859720e7$var$newDate(monthYearPoint);
            if ($7c7b1a6f859720e7$var$isSameYear(_this.props.date, changedDate) && $7c7b1a6f859720e7$var$isSameMonth(_this.props.date, changedDate)) return;
            _this.props.onChange(changedDate);
        };
        _this.toggleDropdown = function() {
            return _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            });
        };
        return _this;
    }
    MonthYearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return MonthYearDropdown;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$Time = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(Time, _super);
    function Time() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            height: null
        };
        _this.scrollToTheSelectedTime = function() {
            requestAnimationFrame(function() {
                var _a, _b, _c;
                if (!_this.list) return;
                _this.list.scrollTop = (_c = _this.centerLi && Time.calcCenterPosition(_this.props.monthRef ? _this.props.monthRef.clientHeight - ((_b = (_a = _this.header) === null || _a === void 0 ? void 0 : _a.clientHeight) !== null && _b !== void 0 ? _b : 0) : _this.list.clientHeight, _this.centerLi)) !== null && _c !== void 0 ? _c : 0;
            });
        };
        _this.handleClick = function(time) {
            var _a, _b;
            if ((_this.props.minTime || _this.props.maxTime) && $7c7b1a6f859720e7$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $7c7b1a6f859720e7$var$isTimeDisabled(time, _this.props)) return;
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, time);
        };
        _this.isSelectedTime = function(time) {
            return _this.props.selected && $7c7b1a6f859720e7$var$isSameMinute(_this.props.selected, time);
        };
        _this.isDisabledTime = function(time) {
            return (_this.props.minTime || _this.props.maxTime) && $7c7b1a6f859720e7$var$isTimeInDisabledRange(time, _this.props) || (_this.props.excludeTimes || _this.props.includeTimes || _this.props.filterTime) && $7c7b1a6f859720e7$var$isTimeDisabled(time, _this.props);
        };
        _this.liClasses = function(time) {
            var _a;
            var classes = [
                "react-datepicker__time-list-item",
                _this.props.timeClassName ? _this.props.timeClassName(time) : undefined
            ];
            if (_this.isSelectedTime(time)) classes.push("react-datepicker__time-list-item--selected");
            if (_this.isDisabledTime(time)) classes.push("react-datepicker__time-list-item--disabled");
            //convert this.props.intervals and the relevant time to seconds and check if it it's a clean multiple of the interval
            if (_this.props.injectTimes && ((0, $1768b25c11e35b0a$export$257b40f71c07d58f)(time) * 3600 + (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(time) * 60 + (0, $ad405ba8e35fff1c$export$5e9417507ff28427)(time)) % (((_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals) * 60) !== 0) classes.push("react-datepicker__time-list-item--injected");
            return classes.join(" ");
        };
        _this.handleOnKeyDown = function(event, time) {
            var _a, _b;
            if (event.key === $7c7b1a6f859720e7$var$KeyType.Space) {
                event.preventDefault();
                event.key = $7c7b1a6f859720e7$var$KeyType.Enter;
            }
            if ((event.key === $7c7b1a6f859720e7$var$KeyType.ArrowUp || event.key === $7c7b1a6f859720e7$var$KeyType.ArrowLeft) && event.target instanceof HTMLElement && event.target.previousSibling) {
                event.preventDefault();
                event.target.previousSibling instanceof HTMLElement && event.target.previousSibling.focus();
            }
            if ((event.key === $7c7b1a6f859720e7$var$KeyType.ArrowDown || event.key === $7c7b1a6f859720e7$var$KeyType.ArrowRight) && event.target instanceof HTMLElement && event.target.nextSibling) {
                event.preventDefault();
                event.target.nextSibling instanceof HTMLElement && event.target.nextSibling.focus();
            }
            if (event.key === $7c7b1a6f859720e7$var$KeyType.Enter) _this.handleClick(time);
            (_b = (_a = _this.props).handleOnKeyDown) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.renderTimes = function() {
            var _a;
            var times = [];
            var format = typeof _this.props.format === "string" ? _this.props.format : "p";
            var intervals = (_a = _this.props.intervals) !== null && _a !== void 0 ? _a : Time.defaultProps.intervals;
            var activeDate = _this.props.selected || _this.props.openToDate || $7c7b1a6f859720e7$var$newDate();
            var base = $7c7b1a6f859720e7$var$getStartOfDay(activeDate);
            var sortedInjectTimes = _this.props.injectTimes && _this.props.injectTimes.sort(function(a, b) {
                return a.getTime() - b.getTime();
            });
            var minutesInDay = 60 * $7c7b1a6f859720e7$var$getHoursInDay(activeDate);
            var multiplier = minutesInDay / intervals;
            for(var i = 0; i < multiplier; i++){
                var currentTime = (0, $879ad858cbf859fa$export$2287e3d29250119e)(base, i * intervals);
                times.push(currentTime);
                if (sortedInjectTimes) {
                    var timesToInject = $7c7b1a6f859720e7$var$timesToInjectAfter(base, currentTime, i, intervals, sortedInjectTimes);
                    times = times.concat(timesToInject);
                }
            }
            // Determine which time to focus and scroll into view when component mounts
            var timeToFocus = times.reduce(function(prev, time) {
                if (time.getTime() <= activeDate.getTime()) return time;
                return prev;
            }, times[0]);
            return times.map(function(time) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("li", {
                    key: time.valueOf(),
                    onClick: _this.handleClick.bind(_this, time),
                    className: _this.liClasses(time),
                    ref: function(li) {
                        if (time === timeToFocus) _this.centerLi = li;
                    },
                    onKeyDown: function(event) {
                        _this.handleOnKeyDown(event, time);
                    },
                    tabIndex: time === timeToFocus ? 0 : -1,
                    role: "option",
                    "aria-selected": _this.isSelectedTime(time) ? "true" : undefined,
                    "aria-disabled": _this.isDisabledTime(time) ? "true" : undefined
                }, $7c7b1a6f859720e7$var$formatDate(time, format, _this.props.locale));
            });
        };
        _this.renderTimeCaption = function() {
            if (_this.props.showTimeCaption === false) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--time ".concat(_this.props.showTimeSelectOnly ? "react-datepicker__header--time--only" : ""),
                ref: function(header) {
                    _this.header = header;
                }
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker-time__header"
            }, _this.props.timeCaption));
        };
        return _this;
    }
    Object.defineProperty(Time, "defaultProps", {
        get: function() {
            return {
                intervals: 30,
                todayButton: null,
                timeCaption: "Time",
                showTimeCaption: true
            };
        },
        enumerable: false,
        configurable: true
    });
    Time.prototype.componentDidMount = function() {
        // code to ensure selected time will always be in focus within time window when it first appears
        this.scrollToTheSelectedTime();
        this.observeDatePickerHeightChanges();
    };
    Time.prototype.componentWillUnmount = function() {
        var _a;
        (_a = this.resizeObserver) === null || _a === void 0 || _a.disconnect();
    };
    Time.prototype.observeDatePickerHeightChanges = function() {
        var _this = this;
        var monthRef = this.props.monthRef;
        this.updateContainerHeight();
        if (monthRef) {
            this.resizeObserver = new ResizeObserver(function() {
                _this.updateContainerHeight();
            });
            this.resizeObserver.observe(monthRef);
        }
    };
    Time.prototype.updateContainerHeight = function() {
        if (this.props.monthRef && this.header) this.setState({
            height: this.props.monthRef.clientHeight - this.header.clientHeight
        });
    };
    Time.prototype.render = function() {
        var _this = this;
        var _a;
        var height = this.state.height;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__time-container ".concat(((_a = this.props.todayButton) !== null && _a !== void 0 ? _a : Time.defaultProps.todayButton) ? "react-datepicker__time-container--with-today-button" : "")
        }, this.renderTimeCaption(), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__time"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__time-box"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("ul", {
            className: "react-datepicker__time-list",
            ref: function(list) {
                _this.list = list;
            },
            style: height ? {
                height: height
            } : {},
            role: "listbox",
            "aria-label": this.props.timeCaption
        }, this.renderTimes()))));
    };
    Time.calcCenterPosition = function(listHeight, centerLiRef) {
        return centerLiRef.offsetTop - (listHeight / 2 - centerLiRef.clientHeight / 2);
    };
    return Time;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$VERTICAL_NAVIGATION_OFFSET = 3;
/**
 * `Year` is a component that represents a year in a date picker.
 *
 * @class
 * @param {YearProps} props - The properties that define the `Year` component.
 * @property {VoidFunction} [props.clearSelectingDate] - Function to clear the selected date.
 * @property {Date} [props.date] - The currently selected date.
 * @property {boolean} [props.disabledKeyboardNavigation] - If true, keyboard navigation is disabled.
 * @property {Date} [props.endDate] - The end date in a range selection.
 * @property {(date: Date) => void} props.onDayClick - Function to handle day click events.
 * @property {Date} props.preSelection - The date that is currently in focus.
 * @property {(date: Date) => void} props.setPreSelection - Function to set the pre-selected date.
 * @property {{ [key: string]: any }} props.selected - The selected date(s).
 * @property {boolean} props.inline - If true, the date picker is displayed inline.
 * @property {Date} props.maxDate - The maximum selectable date.
 * @property {Date} props.minDate - The minimum selectable date.
 * @property {boolean} props.usePointerEvent - If true, pointer events are used instead of mouse events.
 * @property {(date: Date) => void} props.onYearMouseEnter - Function to handle mouse enter events on a year.
 * @property {(date: Date) => void} props.onYearMouseLeave - Function to handle mouse leave events on a year.
 */ var $7c7b1a6f859720e7$var$Year = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(Year, _super);
    function Year(props) {
        var _this = _super.call(this, props) || this;
        _this.YEAR_REFS = $7c7b1a6f859720e7$var$__spreadArray([], Array(_this.props.yearItemNumber), true).map(function() {
            return (0, $7fPBF.createRef)();
        });
        _this.isDisabled = function(date) {
            return $7c7b1a6f859720e7$var$isDayDisabled(date, {
                minDate: _this.props.minDate,
                maxDate: _this.props.maxDate,
                excludeDates: _this.props.excludeDates,
                includeDates: _this.props.includeDates,
                filterDate: _this.props.filterDate
            });
        };
        _this.isExcluded = function(date) {
            return $7c7b1a6f859720e7$var$isDayExcluded(date, {
                excludeDates: _this.props.excludeDates
            });
        };
        _this.selectingDate = function() {
            var _a;
            return (_a = _this.props.selectingDate) !== null && _a !== void 0 ? _a : _this.props.preSelection;
        };
        _this.updateFocusOnPaginate = function(refIndex) {
            var waitForReRender = function() {
                var _a, _b;
                (_b = (_a = _this.YEAR_REFS[refIndex]) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 || _b.focus();
            };
            window.requestAnimationFrame(waitForReRender);
        };
        _this.handleYearClick = function(day, event) {
            if (_this.props.onDayClick) _this.props.onDayClick(day, event);
        };
        _this.handleYearNavigation = function(newYear, newDate) {
            var _a, _b, _c, _d;
            var _e = _this.props, date = _e.date, yearItemNumber = _e.yearItemNumber;
            if (date === undefined || yearItemNumber === undefined) return;
            var startPeriod = $7c7b1a6f859720e7$var$getYearsPeriod(date, yearItemNumber).startPeriod;
            if (_this.isDisabled(newDate) || _this.isExcluded(newDate)) return;
            (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, newDate);
            if (newYear - startPeriod < 0) _this.updateFocusOnPaginate(yearItemNumber - (startPeriod - newYear));
            else if (newYear - startPeriod >= yearItemNumber) _this.updateFocusOnPaginate(Math.abs(yearItemNumber - (newYear - startPeriod)));
            else (_d = (_c = _this.YEAR_REFS[newYear - startPeriod]) === null || _c === void 0 ? void 0 : _c.current) === null || _d === void 0 || _d.focus();
        };
        _this.isSameDay = function(y, other) {
            return $7c7b1a6f859720e7$var$isSameDay(y, other);
        };
        _this.isCurrentYear = function(y) {
            return y === (0, $18282d9928d9137b$export$5846dc2d57a5c860)($7c7b1a6f859720e7$var$newDate());
        };
        _this.isRangeStart = function(y) {
            return _this.props.startDate && _this.props.endDate && $7c7b1a6f859720e7$var$isSameYear((0, $abb5c8cf41ac4337$export$a8408b6c5639cab7)($7c7b1a6f859720e7$var$newDate(), y), _this.props.startDate);
        };
        _this.isRangeEnd = function(y) {
            return _this.props.startDate && _this.props.endDate && $7c7b1a6f859720e7$var$isSameYear((0, $abb5c8cf41ac4337$export$a8408b6c5639cab7)($7c7b1a6f859720e7$var$newDate(), y), _this.props.endDate);
        };
        _this.isInRange = function(y) {
            return $7c7b1a6f859720e7$var$isYearInRange(y, _this.props.startDate, _this.props.endDate);
        };
        _this.isInSelectingRange = function(y) {
            var _a = _this.props, selectsStart = _a.selectsStart, selectsEnd = _a.selectsEnd, selectsRange = _a.selectsRange, startDate = _a.startDate, endDate = _a.endDate;
            if (!(selectsStart || selectsEnd || selectsRange) || !_this.selectingDate()) return false;
            if (selectsStart && endDate) return $7c7b1a6f859720e7$var$isYearInRange(y, _this.selectingDate(), endDate);
            if (selectsEnd && startDate) return $7c7b1a6f859720e7$var$isYearInRange(y, startDate, _this.selectingDate());
            if (selectsRange && startDate && !endDate) return $7c7b1a6f859720e7$var$isYearInRange(y, startDate, _this.selectingDate());
            return false;
        };
        _this.isSelectingRangeStart = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, startDate = _b.startDate, selectsStart = _b.selectsStart;
            var _year = (0, $abb5c8cf41ac4337$export$a8408b6c5639cab7)($7c7b1a6f859720e7$var$newDate(), y);
            if (selectsStart) return $7c7b1a6f859720e7$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $7c7b1a6f859720e7$var$isSameYear(_year, startDate !== null && startDate !== void 0 ? startDate : null);
        };
        _this.isSelectingRangeEnd = function(y) {
            var _a;
            if (!_this.isInSelectingRange(y)) return false;
            var _b = _this.props, endDate = _b.endDate, selectsEnd = _b.selectsEnd, selectsRange = _b.selectsRange;
            var _year = (0, $abb5c8cf41ac4337$export$a8408b6c5639cab7)($7c7b1a6f859720e7$var$newDate(), y);
            if (selectsEnd || selectsRange) return $7c7b1a6f859720e7$var$isSameYear(_year, (_a = _this.selectingDate()) !== null && _a !== void 0 ? _a : null);
            return $7c7b1a6f859720e7$var$isSameYear(_year, endDate !== null && endDate !== void 0 ? endDate : null);
        };
        _this.isKeyboardSelected = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.date === undefined || _this.props.preSelection == null) return;
            var _a = _this.props, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, selected = _a.selected;
            var date = $7c7b1a6f859720e7$var$getStartOfYear((0, $abb5c8cf41ac4337$export$a8408b6c5639cab7)(_this.props.date, y));
            var isDisabled = (minDate || maxDate || excludeDates || includeDates || filterDate) && $7c7b1a6f859720e7$var$isYearDisabled(y, _this.props);
            var isSelectedDay = !!selected && $7c7b1a6f859720e7$var$isSameDay(date, $7c7b1a6f859720e7$var$getStartOfYear(selected));
            var isKeyboardSelectedDay = $7c7b1a6f859720e7$var$isSameDay(date, $7c7b1a6f859720e7$var$getStartOfYear(_this.props.preSelection));
            return !_this.props.inline && !isSelectedDay && isKeyboardSelectedDay && !isDisabled;
        };
        _this.isSelectedYear = function(year) {
            var _a = _this.props, selectsMultiple = _a.selectsMultiple, selected = _a.selected, selectedDates = _a.selectedDates;
            if (selectsMultiple) return selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.some(function(date) {
                return year === (0, $18282d9928d9137b$export$5846dc2d57a5c860)(date);
            });
            return !!selected && year === (0, $18282d9928d9137b$export$5846dc2d57a5c860)(selected);
        };
        _this.onYearClick = function(event, y) {
            var date = _this.props.date;
            if (date === undefined) return;
            _this.handleYearClick($7c7b1a6f859720e7$var$getStartOfYear((0, $abb5c8cf41ac4337$export$a8408b6c5639cab7)(date, y)), event);
        };
        _this.onYearKeyDown = function(event, y) {
            var _a, _b;
            var key = event.key;
            var _c = _this.props, date = _c.date, yearItemNumber = _c.yearItemNumber, handleOnKeyDown = _c.handleOnKeyDown;
            if (key !== $7c7b1a6f859720e7$var$KeyType.Tab) // preventDefault on tab event blocks focus change
            event.preventDefault();
            if (!_this.props.disabledKeyboardNavigation) switch(key){
                case $7c7b1a6f859720e7$var$KeyType.Enter:
                    if (_this.props.selected == null) break;
                    _this.onYearClick(event, y);
                    (_b = (_a = _this.props).setPreSelection) === null || _b === void 0 || _b.call(_a, _this.props.selected);
                    break;
                case $7c7b1a6f859720e7$var$KeyType.ArrowRight:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y + 1, (0, $b4358f02f9e27928$export$3d83eec43f4ea476)(_this.props.preSelection, 1));
                    break;
                case $7c7b1a6f859720e7$var$KeyType.ArrowLeft:
                    if (_this.props.preSelection == null) break;
                    _this.handleYearNavigation(y - 1, (0, $9e4f2bf0d6114176$export$14867687ff6c92e2)(_this.props.preSelection, 1));
                    break;
                case $7c7b1a6f859720e7$var$KeyType.ArrowUp:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var startPeriod = $7c7b1a6f859720e7$var$getYearsPeriod(date, yearItemNumber).startPeriod;
                    var offset = $7c7b1a6f859720e7$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y - offset;
                    if (newYear < startPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y >= startPeriod && y < startPeriod + leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y - offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $9e4f2bf0d6114176$export$14867687ff6c92e2)(_this.props.preSelection, offset));
                    break;
                case $7c7b1a6f859720e7$var$KeyType.ArrowDown:
                    if (date === undefined || yearItemNumber === undefined || _this.props.preSelection == null) break;
                    var endPeriod = $7c7b1a6f859720e7$var$getYearsPeriod(date, yearItemNumber).endPeriod;
                    var offset = $7c7b1a6f859720e7$var$VERTICAL_NAVIGATION_OFFSET;
                    var newYear = y + offset;
                    if (newYear > endPeriod) {
                        var leftOverOffset = yearItemNumber % offset;
                        if (y <= endPeriod && y > endPeriod - leftOverOffset) offset = leftOverOffset;
                        else offset += leftOverOffset;
                        newYear = y + offset;
                    }
                    _this.handleYearNavigation(newYear, (0, $b4358f02f9e27928$export$3d83eec43f4ea476)(_this.props.preSelection, offset));
                    break;
            }
            handleOnKeyDown && handleOnKeyDown(event);
        };
        _this.getYearClassNames = function(y) {
            var _a = _this.props, date = _a.date, disabled = _a.disabled, minDate = _a.minDate, maxDate = _a.maxDate, excludeDates = _a.excludeDates, includeDates = _a.includeDates, filterDate = _a.filterDate, yearClassName = _a.yearClassName;
            return (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("react-datepicker__year-text", "react-datepicker__year-".concat(y), date ? yearClassName === null || yearClassName === void 0 ? void 0 : yearClassName((0, $abb5c8cf41ac4337$export$a8408b6c5639cab7)(date, y)) : undefined, {
                "react-datepicker__year-text--selected": _this.isSelectedYear(y),
                "react-datepicker__year-text--disabled": (minDate || maxDate || excludeDates || includeDates || filterDate || disabled) && $7c7b1a6f859720e7$var$isYearDisabled(y, _this.props),
                "react-datepicker__year-text--keyboard-selected": _this.isKeyboardSelected(y),
                "react-datepicker__year-text--range-start": _this.isRangeStart(y),
                "react-datepicker__year-text--range-end": _this.isRangeEnd(y),
                "react-datepicker__year-text--in-range": _this.isInRange(y),
                "react-datepicker__year-text--in-selecting-range": _this.isInSelectingRange(y),
                "react-datepicker__year-text--selecting-range-start": _this.isSelectingRangeStart(y),
                "react-datepicker__year-text--selecting-range-end": _this.isSelectingRangeEnd(y),
                "react-datepicker__year-text--today": _this.isCurrentYear(y)
            });
        };
        _this.getYearTabIndex = function(y) {
            if (_this.props.disabledKeyboardNavigation || _this.props.preSelection == null) return "-1";
            var preSelected = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(_this.props.preSelection);
            var isPreSelectedYearDisabled = $7c7b1a6f859720e7$var$isYearDisabled(y, _this.props);
            return y === preSelected && !isPreSelectedYearDisabled ? "0" : "-1";
        };
        _this.getYearContent = function(y) {
            return _this.props.renderYearContent ? _this.props.renderYearContent(y) : y;
        };
        return _this;
    }
    Year.prototype.render = function() {
        var _this = this;
        var yearsList = [];
        var _a = this.props, date = _a.date, yearItemNumber = _a.yearItemNumber, onYearMouseEnter = _a.onYearMouseEnter, onYearMouseLeave = _a.onYearMouseLeave;
        if (date === undefined) return null;
        var _b = $7c7b1a6f859720e7$var$getYearsPeriod(date, yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
        var _loop_1 = function(y) {
            yearsList.push((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                ref: this_1.YEAR_REFS[y - startPeriod],
                onClick: function(event) {
                    _this.onYearClick(event, y);
                },
                onKeyDown: function(event) {
                    if ($7c7b1a6f859720e7$var$isSpaceKeyDown(event)) {
                        event.preventDefault();
                        event.key = $7c7b1a6f859720e7$var$KeyType.Enter;
                    }
                    _this.onYearKeyDown(event, y);
                },
                tabIndex: Number(this_1.getYearTabIndex(y)),
                className: this_1.getYearClassNames(y),
                onMouseEnter: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onPointerEnter: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseEnter(event, y);
                } : undefined,
                onMouseLeave: !this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                onPointerLeave: this_1.props.usePointerEvent ? function(event) {
                    return onYearMouseLeave(event, y);
                } : undefined,
                key: y,
                "aria-current": this_1.isCurrentYear(y) ? "date" : undefined
            }, this_1.getYearContent(y)));
        };
        var this_1 = this;
        for(var y = startPeriod; y <= endPeriod; y++)_loop_1(y);
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__year"
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__year-wrapper",
            onMouseLeave: !this.props.usePointerEvent ? this.props.clearSelectingDate : undefined,
            onPointerLeave: this.props.usePointerEvent ? this.props.clearSelectingDate : undefined
        }, yearsList));
    };
    return Year;
}((0, $7fPBF.Component));
function $7c7b1a6f859720e7$var$generateYears(year, noOfYear, minDate, maxDate) {
    var list = [];
    for(var i = 0; i < 2 * noOfYear + 1; i++){
        var newYear = year + noOfYear - i;
        var isInRange = true;
        if (minDate) isInRange = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(minDate) <= newYear;
        if (maxDate && isInRange) isInRange = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(maxDate) >= newYear;
        if (isInRange) list.push(newYear);
    }
    return list;
}
var $7c7b1a6f859720e7$var$YearDropdownOptions = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(YearDropdownOptions, _super);
    function YearDropdownOptions(props) {
        var _this = _super.call(this, props) || this;
        _this.yearOptionButtonsRef = {};
        _this.handleOptionKeyDown = function(year, e) {
            var _a;
            switch(e.key){
                case "Enter":
                    e.preventDefault();
                    _this.onChange(year);
                    break;
                case "Escape":
                    e.preventDefault();
                    _this.props.onCancel();
                    break;
                case "ArrowUp":
                case "ArrowDown":
                    e.preventDefault();
                    var newYear = year + (e.key === "ArrowUp" ? 1 : -1);
                    // Add bounds checking to ensure the year exists in our refs
                    if (_this.yearOptionButtonsRef[newYear]) (_a = _this.yearOptionButtonsRef[newYear]) === null || _a === void 0 || _a.focus();
                    break;
            }
        };
        _this.renderOptions = function() {
            // Clear refs to prevent memory leaks on re-render
            _this.yearOptionButtonsRef = {};
            var selectedYear = _this.props.year;
            var options = _this.state.yearsList.map(function(year) {
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    ref: function(el) {
                        _this.yearOptionButtonsRef[year] = el;
                        if (year === selectedYear) el === null || el === void 0 || el.focus();
                    },
                    role: "button",
                    tabIndex: 0,
                    className: selectedYear === year ? "react-datepicker__year-option react-datepicker__year-option--selected_year" : "react-datepicker__year-option",
                    key: year,
                    onClick: _this.onChange.bind(_this, year),
                    onKeyDown: _this.handleOptionKeyDown.bind(_this, year),
                    "aria-selected": selectedYear === year ? "true" : undefined
                }, selectedYear === year ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "react-datepicker__year-option--selected"
                }, "\u2713") : "", year);
            });
            var minYear = _this.props.minDate ? (0, $18282d9928d9137b$export$5846dc2d57a5c860)(_this.props.minDate) : null;
            var maxYear = _this.props.maxDate ? (0, $18282d9928d9137b$export$5846dc2d57a5c860)(_this.props.maxDate) : null;
            if (!maxYear || !_this.state.yearsList.find(function(year) {
                return year === maxYear;
            })) options.unshift((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "upcoming",
                onClick: _this.incrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"
            })));
            if (!minYear || !_this.state.yearsList.find(function(year) {
                return year === minYear;
            })) options.push((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__year-option",
                key: "previous",
                onClick: _this.decrementYears
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("a", {
                className: "react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"
            })));
            return options;
        };
        _this.onChange = function(year) {
            _this.props.onChange(year);
        };
        _this.handleClickOutside = function() {
            _this.props.onCancel();
        };
        _this.shiftYears = function(amount) {
            var years = _this.state.yearsList.map(function(year) {
                return year + amount;
            });
            _this.setState({
                yearsList: years
            });
        };
        _this.incrementYears = function() {
            return _this.shiftYears(1);
        };
        _this.decrementYears = function() {
            return _this.shiftYears(-1);
        };
        var yearDropdownItemNumber = props.yearDropdownItemNumber, scrollableYearDropdown = props.scrollableYearDropdown;
        var noOfYear = yearDropdownItemNumber || (scrollableYearDropdown ? 10 : 5);
        _this.state = {
            yearsList: $7c7b1a6f859720e7$var$generateYears(_this.props.year, noOfYear, _this.props.minDate, _this.props.maxDate)
        };
        _this.dropdownRef = (0, $7fPBF.createRef)();
        return _this;
    }
    YearDropdownOptions.prototype.componentDidMount = function() {
        var dropdownCurrent = this.dropdownRef.current;
        if (dropdownCurrent) {
            // Get array from HTMLCollection
            var dropdownCurrentChildren = dropdownCurrent.children ? Array.from(dropdownCurrent.children) : null;
            var selectedYearOptionEl = dropdownCurrentChildren ? dropdownCurrentChildren.find(function(childEl) {
                return childEl.ariaSelected;
            }) : null;
            dropdownCurrent.scrollTop = selectedYearOptionEl && selectedYearOptionEl instanceof HTMLElement ? selectedYearOptionEl.offsetTop + (selectedYearOptionEl.clientHeight - dropdownCurrent.clientHeight) / 2 : (dropdownCurrent.scrollHeight - dropdownCurrent.clientHeight) / 2;
        }
    };
    YearDropdownOptions.prototype.render = function() {
        var dropdownClass = (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)({
            "react-datepicker__year-dropdown": true,
            "react-datepicker__year-dropdown--scrollable": this.props.scrollableYearDropdown
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$ClickOutsideWrapper, {
            className: dropdownClass,
            containerRef: this.dropdownRef,
            onClickOutside: this.handleClickOutside
        }, this.renderOptions());
    };
    return YearDropdownOptions;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$YearDropdown = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(YearDropdown, _super);
    function YearDropdown() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            dropdownVisible: false
        };
        _this.renderSelectOptions = function() {
            var minYear = _this.props.minDate ? (0, $18282d9928d9137b$export$5846dc2d57a5c860)(_this.props.minDate) : 1900;
            var maxYear = _this.props.maxDate ? (0, $18282d9928d9137b$export$5846dc2d57a5c860)(_this.props.maxDate) : 2100;
            var options = [];
            for(var i = minYear; i <= maxYear; i++)options.push((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("option", {
                key: i,
                value: i
            }, i));
            return options;
        };
        _this.onSelectChange = function(event) {
            _this.onChange(parseInt(event.target.value));
        };
        _this.renderSelectMode = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("select", {
                value: _this.props.year,
                className: "react-datepicker__year-select",
                onChange: _this.onSelectChange
            }, _this.renderSelectOptions());
        };
        _this.renderReadView = function(visible) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
                key: "read",
                type: "button",
                style: {
                    visibility: visible ? "visible" : "hidden"
                },
                className: "react-datepicker__year-read-view",
                onClick: _this.toggleDropdown
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                className: "react-datepicker__year-read-view--down-arrow"
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                className: "react-datepicker__year-read-view--selected-year"
            }, _this.props.year));
        };
        _this.renderDropdown = function() {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$YearDropdownOptions, $7c7b1a6f859720e7$var$_assign({
                key: "dropdown"
            }, _this.props, {
                onChange: _this.onChange,
                onCancel: _this.toggleDropdown
            }));
        };
        _this.renderScrollMode = function() {
            var dropdownVisible = _this.state.dropdownVisible;
            var result = [
                _this.renderReadView(!dropdownVisible)
            ];
            if (dropdownVisible) result.unshift(_this.renderDropdown());
            return result;
        };
        _this.onChange = function(year) {
            _this.toggleDropdown();
            if (year === _this.props.year) return;
            _this.props.onChange(year);
        };
        _this.toggleDropdown = function(event) {
            _this.setState({
                dropdownVisible: !_this.state.dropdownVisible
            }, function() {
                if (_this.props.adjustDateOnChange) _this.handleYearChange(_this.props.date, event);
            });
        };
        _this.handleYearChange = function(date, event) {
            var _a;
            (_a = _this.onSelect) === null || _a === void 0 || _a.call(_this, date, event);
            _this.setOpen();
        };
        _this.onSelect = function(date, event) {
            var _a, _b;
            (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, date, event);
        };
        _this.setOpen = function() {
            var _a, _b;
            (_b = (_a = _this.props).setOpen) === null || _b === void 0 || _b.call(_a, true);
        };
        return _this;
    }
    YearDropdown.prototype.render = function() {
        var renderedDropdown;
        switch(this.props.dropdownMode){
            case "scroll":
                renderedDropdown = this.renderScrollMode();
                break;
            case "select":
                renderedDropdown = this.renderSelectMode();
                break;
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)
        }, renderedDropdown);
    };
    return YearDropdown;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$DROPDOWN_FOCUS_CLASSNAMES = [
    "react-datepicker__year-select",
    "react-datepicker__month-select",
    "react-datepicker__month-year-select"
];
var $7c7b1a6f859720e7$var$OUTSIDE_CLICK_IGNORE_CLASS = "react-datepicker-ignore-onclickoutside";
var $7c7b1a6f859720e7$var$isDropdownSelect = function(element) {
    var classNames = (element.className || "").split(/\s+/);
    return $7c7b1a6f859720e7$var$DROPDOWN_FOCUS_CLASSNAMES.some(function(testClassname) {
        return classNames.indexOf(testClassname) >= 0;
    });
};
var $7c7b1a6f859720e7$var$Calendar = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(Calendar, _super);
    function Calendar(props) {
        var _this = _super.call(this, props) || this;
        _this.monthContainer = undefined;
        _this.handleClickOutside = function(event) {
            _this.props.onClickOutside(event);
        };
        _this.setClickOutsideRef = function() {
            return _this.containerRef.current;
        };
        _this.handleDropdownFocus = function(event) {
            var _a, _b;
            if ($7c7b1a6f859720e7$var$isDropdownSelect(event.target)) (_b = (_a = _this.props).onDropdownFocus) === null || _b === void 0 || _b.call(_a, event);
        };
        _this.getDateInView = function() {
            var _a = _this.props, preSelection = _a.preSelection, selected = _a.selected, openToDate = _a.openToDate;
            var minDate = $7c7b1a6f859720e7$var$getEffectiveMinDate(_this.props);
            var maxDate = $7c7b1a6f859720e7$var$getEffectiveMaxDate(_this.props);
            var current = $7c7b1a6f859720e7$var$newDate();
            var initialDate = openToDate || selected || preSelection;
            if (initialDate) return initialDate;
            else {
                if (minDate && (0, $eb21892051383660$export$5c007e10c6929c95)(current, minDate)) return minDate;
                else if (maxDate && (0, $04f0c9d20b09837b$export$e4de839670987035)(current, maxDate)) return maxDate;
            }
            return current;
        };
        _this.increaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.decreaseMonth = function() {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $9ccdf5b091b4766d$export$73d1c15a21f9fae5)(date, 1)
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.handleDayClick = function(day, event, monthSelectedIn) {
            _this.props.onSelect(day, event, monthSelectedIn);
            _this.props.setPreSelection && _this.props.setPreSelection(day);
        };
        _this.handleDayMouseEnter = function(day) {
            _this.setState({
                selectingDate: day
            });
            _this.props.onDayMouseEnter && _this.props.onDayMouseEnter(day);
        };
        _this.handleMonthMouseLeave = function() {
            _this.setState({
                selectingDate: undefined
            });
            _this.props.onMonthMouseLeave && _this.props.onMonthMouseLeave();
        };
        _this.handleYearMouseEnter = function(event, year) {
            _this.setState({
                selectingDate: (0, $abb5c8cf41ac4337$export$a8408b6c5639cab7)($7c7b1a6f859720e7$var$newDate(), year)
            });
            !!_this.props.onYearMouseEnter && _this.props.onYearMouseEnter(event, year);
        };
        _this.handleYearMouseLeave = function(event, year) {
            !!_this.props.onYearMouseLeave && _this.props.onYearMouseLeave(event, year);
        };
        _this.handleYearChange = function(date) {
            var _a, _b, _c, _d;
            (_b = (_a = _this.props).onYearChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(date);
                (_d = (_c = _this.props).setOpen) === null || _d === void 0 || _d.call(_c, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(date);
        };
        _this.getEnabledPreSelectionDateForMonth = function(date) {
            if (!$7c7b1a6f859720e7$var$isDayDisabled(date, _this.props)) return date;
            var startOfMonth = $7c7b1a6f859720e7$var$getStartOfMonth(date);
            var endOfMonth = $7c7b1a6f859720e7$var$getEndOfMonth(date);
            var totalDays = (0, $917d28031341f08a$export$86415ebf4eb36b8c)(endOfMonth, startOfMonth);
            var preSelectedDate = null;
            for(var dayIdx = 0; dayIdx <= totalDays; dayIdx++){
                var processingDate = (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(startOfMonth, dayIdx);
                if (!$7c7b1a6f859720e7$var$isDayDisabled(processingDate, _this.props)) {
                    preSelectedDate = processingDate;
                    break;
                }
            }
            return preSelectedDate;
        };
        _this.handleMonthChange = function(date) {
            var _a, _b, _c;
            var enabledPreSelectionDate = (_a = _this.getEnabledPreSelectionDateForMonth(date)) !== null && _a !== void 0 ? _a : date;
            _this.handleCustomMonthChange(enabledPreSelectionDate);
            if (_this.props.adjustDateOnChange) {
                _this.props.onSelect(enabledPreSelectionDate);
                (_c = (_b = _this.props).setOpen) === null || _c === void 0 || _c.call(_b, true);
            }
            _this.props.setPreSelection && _this.props.setPreSelection(enabledPreSelectionDate);
        };
        _this.handleCustomMonthChange = function(date) {
            var _a, _b;
            (_b = (_a = _this.props).onMonthChange) === null || _b === void 0 || _b.call(_a, date);
            _this.setState({
                isRenderAriaLiveMessage: true
            });
        };
        _this.handleMonthYearChange = function(date) {
            _this.handleYearChange(date);
            _this.handleMonthChange(date);
        };
        _this.changeYear = function(year) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $abb5c8cf41ac4337$export$a8408b6c5639cab7)(date, Number(year))
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.changeMonth = function(month) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $a04ce585cc1453dc$export$63264690f8e36790)(date, Number(month))
                };
            }, function() {
                return _this.handleMonthChange(_this.state.date);
            });
        };
        _this.changeMonthYear = function(monthYear) {
            _this.setState(function(_a) {
                var date = _a.date;
                return {
                    date: (0, $abb5c8cf41ac4337$export$a8408b6c5639cab7)((0, $a04ce585cc1453dc$export$63264690f8e36790)(date, (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(monthYear)), (0, $18282d9928d9137b$export$5846dc2d57a5c860)(monthYear))
                };
            }, function() {
                return _this.handleMonthYearChange(_this.state.date);
            });
        };
        _this.header = function(date) {
            if (date === void 0) date = _this.state.date;
            // Return empty array if date is invalid
            if (!$7c7b1a6f859720e7$var$isValid(date)) return [];
            var disabled = _this.props.disabled;
            var startOfWeek = $7c7b1a6f859720e7$var$getStartOfWeek(date, _this.props.locale, _this.props.calendarStartDay);
            var dayNames = [];
            if (_this.props.showWeekNumbers) dayNames.push((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                key: "W",
                className: "react-datepicker__day-name ".concat(disabled ? "react-datepicker__day-name--disabled" : ""),
                role: "columnheader"
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                className: "react-datepicker__sr-only"
            }, "Week number"), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                "aria-hidden": "true"
            }, _this.props.weekLabel || "#")));
            return dayNames.concat([
                0,
                1,
                2,
                3,
                4,
                5,
                6
            ].map(function(offset) {
                var day = (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(startOfWeek, offset);
                var weekDayName = _this.formatWeekday(day, _this.props.locale);
                var weekDayClassName = _this.props.weekDayClassName ? _this.props.weekDayClassName(day) : undefined;
                return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    key: offset,
                    role: "columnheader",
                    className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("react-datepicker__day-name", weekDayClassName, disabled ? "react-datepicker__day-name--disabled" : "")
                }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    className: "react-datepicker__sr-only"
                }, $7c7b1a6f859720e7$var$formatDate(day, "EEEE", _this.props.locale)), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                    "aria-hidden": "true"
                }, weekDayName));
            }));
        };
        _this.formatWeekday = function(day, locale) {
            if (_this.props.formatWeekDay) return $7c7b1a6f859720e7$var$getFormattedWeekdayInLocale(day, _this.props.formatWeekDay, locale);
            return _this.props.useWeekdaysShort ? $7c7b1a6f859720e7$var$getWeekdayShortInLocale(day, locale) : $7c7b1a6f859720e7$var$getWeekdayMinInLocale(day, locale);
        };
        _this.decreaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $9e4f2bf0d6114176$export$14867687ff6c92e2)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.clearSelectingDate = function() {
            _this.setState({
                selectingDate: undefined
            });
        };
        _this.renderPreviousButton = function() {
            var _a, _b, _c;
            if (_this.props.renderCustomHeader) return;
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            var fromMonthDate = (0, $9ccdf5b091b4766d$export$73d1c15a21f9fae5)(_this.state.date, monthSelectedIn);
            var allPrevDaysDisabled;
            switch(true){
                case _this.props.disabled:
                    allPrevDaysDisabled = true;
                    break;
                case _this.props.showMonthYearPicker:
                    allPrevDaysDisabled = $7c7b1a6f859720e7$var$yearDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allPrevDaysDisabled = $7c7b1a6f859720e7$var$yearsDisabledBefore(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allPrevDaysDisabled = $7c7b1a6f859720e7$var$quarterDisabledBefore(_this.state.date, _this.props);
                    break;
                default:
                    allPrevDaysDisabled = $7c7b1a6f859720e7$var$monthDisabledBefore(fromMonthDate, _this.props);
                    break;
            }
            if (!((_c = _this.props.forceShowMonthNavigation) !== null && _c !== void 0 ? _c : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allPrevDaysDisabled || _this.props.showTimeSelectOnly) return;
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--previous"
            ];
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--previous"
            ];
            var clickHandler = _this.decreaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.decreaseYear;
            if (allPrevDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--previous--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _d = _this.props, _e = _d.previousMonthButtonLabel, previousMonthButtonLabel = _e === void 0 ? Calendar.defaultProps.previousMonthButtonLabel : _e, _f = _d.previousYearButtonLabel, previousYearButtonLabel = _f === void 0 ? Calendar.defaultProps.previousYearButtonLabel : _f;
            var _g = _this.props, _h = _g.previousMonthAriaLabel, previousMonthAriaLabel = _h === void 0 ? typeof previousMonthButtonLabel === "string" ? previousMonthButtonLabel : "Previous Month" : _h, _j = _g.previousYearAriaLabel, previousYearAriaLabel = _j === void 0 ? typeof previousYearButtonLabel === "string" ? previousYearButtonLabel : "Previous Year" : _j;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? previousYearAriaLabel : previousMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? previousYearButtonLabel : previousMonthButtonLabel));
        };
        _this.increaseYear = function() {
            _this.setState(function(_a) {
                var _b;
                var date = _a.date;
                return {
                    date: (0, $b4358f02f9e27928$export$3d83eec43f4ea476)(date, _this.props.showYearPicker ? (_b = _this.props.yearItemNumber) !== null && _b !== void 0 ? _b : Calendar.defaultProps.yearItemNumber : 1)
                };
            }, function() {
                return _this.handleYearChange(_this.state.date);
            });
        };
        _this.renderNextButton = function() {
            var _a;
            if (_this.props.renderCustomHeader) return;
            var allNextDaysDisabled;
            switch(true){
                case _this.props.disabled:
                    allNextDaysDisabled = true;
                    break;
                case _this.props.showMonthYearPicker:
                    allNextDaysDisabled = $7c7b1a6f859720e7$var$yearDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showYearPicker:
                    allNextDaysDisabled = $7c7b1a6f859720e7$var$yearsDisabledAfter(_this.state.date, _this.props);
                    break;
                case _this.props.showQuarterYearPicker:
                    allNextDaysDisabled = $7c7b1a6f859720e7$var$quarterDisabledAfter(_this.state.date, _this.props);
                    break;
                default:
                    allNextDaysDisabled = $7c7b1a6f859720e7$var$monthDisabledAfter(_this.state.date, _this.props);
                    break;
            }
            if (!((_a = _this.props.forceShowMonthNavigation) !== null && _a !== void 0 ? _a : Calendar.defaultProps.forceShowMonthNavigation) && !_this.props.showDisabledMonthNavigation && allNextDaysDisabled || _this.props.showTimeSelectOnly) return;
            var classes = [
                "react-datepicker__navigation",
                "react-datepicker__navigation--next"
            ];
            var iconClasses = [
                "react-datepicker__navigation-icon",
                "react-datepicker__navigation-icon--next"
            ];
            if (_this.props.showTimeSelect) classes.push("react-datepicker__navigation--next--with-time");
            if (_this.props.todayButton) classes.push("react-datepicker__navigation--next--with-today-button");
            var clickHandler = _this.increaseMonth;
            if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker) clickHandler = _this.increaseYear;
            if (allNextDaysDisabled && _this.props.showDisabledMonthNavigation) {
                classes.push("react-datepicker__navigation--next--disabled");
                clickHandler = undefined;
            }
            var isForYear = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker;
            var _b = _this.props, _c = _b.nextMonthButtonLabel, nextMonthButtonLabel = _c === void 0 ? Calendar.defaultProps.nextMonthButtonLabel : _c, _d = _b.nextYearButtonLabel, nextYearButtonLabel = _d === void 0 ? Calendar.defaultProps.nextYearButtonLabel : _d;
            var _e = _this.props, _f = _e.nextMonthAriaLabel, nextMonthAriaLabel = _f === void 0 ? typeof nextMonthButtonLabel === "string" ? nextMonthButtonLabel : "Next Month" : _f, _g = _e.nextYearAriaLabel, nextYearAriaLabel = _g === void 0 ? typeof nextYearButtonLabel === "string" ? nextYearButtonLabel : "Next Year" : _g;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
                type: "button",
                className: classes.join(" "),
                onClick: clickHandler,
                onKeyDown: _this.props.handleOnKeyDown,
                "aria-label": isForYear ? nextYearAriaLabel : nextMonthAriaLabel
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                className: iconClasses.join(" ")
            }, isForYear ? nextYearButtonLabel : nextMonthButtonLabel));
        };
        _this.renderCurrentMonth = function(date) {
            if (date === void 0) date = _this.state.date;
            var classes = [
                "react-datepicker__current-month"
            ];
            if (_this.props.showYearDropdown) classes.push("react-datepicker__current-month--hasYearDropdown");
            if (_this.props.showMonthDropdown) classes.push("react-datepicker__current-month--hasMonthDropdown");
            if (_this.props.showMonthYearDropdown) classes.push("react-datepicker__current-month--hasMonthYearDropdown");
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("h2", {
                className: classes.join(" ")
            }, $7c7b1a6f859720e7$var$isValid(date) ? $7c7b1a6f859720e7$var$formatDate(date, _this.props.dateFormat, _this.props.locale) : "");
        };
        _this.renderYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$YearDropdown, $7c7b1a6f859720e7$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeYear,
                year: (0, $18282d9928d9137b$export$5846dc2d57a5c860)(_this.state.date)
            }));
        };
        _this.renderMonthDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$MonthDropdown, $7c7b1a6f859720e7$var$_assign({}, Calendar.defaultProps, _this.props, {
                month: (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(_this.state.date),
                onChange: _this.changeMonth
            }));
        };
        _this.renderMonthYearDropdown = function(overrideHide) {
            if (overrideHide === void 0) overrideHide = false;
            if (!_this.props.showMonthYearDropdown || overrideHide) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$MonthYearDropdown, $7c7b1a6f859720e7$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: _this.state.date,
                onChange: _this.changeMonthYear
            }));
        };
        _this.handleTodayButtonClick = function(event) {
            _this.props.onSelect($7c7b1a6f859720e7$var$getStartOfToday(), event);
            _this.props.setPreSelection && _this.props.setPreSelection($7c7b1a6f859720e7$var$getStartOfToday());
        };
        _this.renderTodayButton = function() {
            if (!_this.props.todayButton || _this.props.showTimeSelectOnly) return;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__today-button",
                onClick: _this.handleTodayButtonClick
            }, _this.props.todayButton);
        };
        _this.renderDayNamesHeader = function(monthDate) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__day-names",
                role: "row"
            }, _this.header(monthDate));
        };
        _this.renderDefaultHeader = function(_a) {
            var monthDate = _a.monthDate, i = _a.i;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__header ".concat(_this.props.showTimeSelect ? "react-datepicker__header--has-time-select" : "")
            }, _this.renderCurrentMonth(monthDate), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(_this.props.dropdownMode),
                onFocus: _this.handleDropdownFocus
            }, _this.renderMonthDropdown(i !== 0), _this.renderMonthYearDropdown(i !== 0), _this.renderYearDropdown(i !== 0)));
        };
        _this.renderCustomHeader = function(headerArgs) {
            var _a, _b;
            var monthDate = headerArgs.monthDate, i = headerArgs.i;
            if (_this.props.showTimeSelect && !_this.state.monthContainer || _this.props.showTimeSelectOnly) return null;
            var _c = _this.props, showYearPicker = _c.showYearPicker, yearItemNumber = _c.yearItemNumber;
            var visibleYearsRange;
            if (showYearPicker) {
                var _d = $7c7b1a6f859720e7$var$getYearsPeriod(monthDate, yearItemNumber), startYear = _d.startPeriod, endYear = _d.endPeriod;
                visibleYearsRange = {
                    startYear: startYear,
                    endYear: endYear
                };
            }
            var prevMonthButtonDisabled = $7c7b1a6f859720e7$var$monthDisabledBefore(_this.state.date, _this.props);
            var nextMonthButtonDisabled = $7c7b1a6f859720e7$var$monthDisabledAfter(_this.state.date, _this.props);
            var prevYearButtonDisabled = $7c7b1a6f859720e7$var$yearDisabledBefore(_this.state.date, _this.props);
            var nextYearButtonDisabled = $7c7b1a6f859720e7$var$yearDisabledAfter(_this.state.date, _this.props);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__header react-datepicker__header--custom",
                onFocus: _this.props.onDropdownFocus
            }, (_b = (_a = _this.props).renderCustomHeader) === null || _b === void 0 ? void 0 : _b.call(_a, $7c7b1a6f859720e7$var$_assign($7c7b1a6f859720e7$var$_assign($7c7b1a6f859720e7$var$_assign({}, _this.state), showYearPicker && {
                visibleYearsRange: visibleYearsRange
            }), {
                customHeaderCount: i,
                monthDate: monthDate,
                changeMonth: _this.changeMonth,
                changeYear: _this.changeYear,
                decreaseMonth: _this.decreaseMonth,
                increaseMonth: _this.increaseMonth,
                decreaseYear: _this.decreaseYear,
                increaseYear: _this.increaseYear,
                prevMonthButtonDisabled: prevMonthButtonDisabled,
                nextMonthButtonDisabled: nextMonthButtonDisabled,
                prevYearButtonDisabled: prevYearButtonDisabled,
                nextYearButtonDisabled: nextYearButtonDisabled
            })));
        };
        _this.renderYearHeader = function(_a) {
            var monthDate = _a.monthDate;
            var _b = _this.props, showYearPicker = _b.showYearPicker, _c = _b.yearItemNumber, yearItemNumber = _c === void 0 ? Calendar.defaultProps.yearItemNumber : _c;
            var _d = $7c7b1a6f859720e7$var$getYearsPeriod(monthDate, yearItemNumber), startPeriod = _d.startPeriod, endPeriod = _d.endPeriod;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__header react-datepicker-year-header"
            }, showYearPicker ? "".concat(startPeriod, " - ").concat(endPeriod) : (0, $18282d9928d9137b$export$5846dc2d57a5c860)(monthDate));
        };
        _this.renderHeader = function(_a) {
            var monthDate = _a.monthDate, _b = _a.i, i = _b === void 0 ? 0 : _b;
            var headerArgs = {
                monthDate: monthDate,
                i: i
            };
            switch(true){
                case _this.props.renderCustomHeader !== undefined:
                    return _this.renderCustomHeader(headerArgs);
                case _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker || _this.props.showYearPicker:
                    return _this.renderYearHeader(headerArgs);
                default:
                    return _this.renderDefaultHeader(headerArgs);
            }
        };
        _this.renderMonths = function() {
            var _a, _b;
            if (_this.props.showTimeSelectOnly || _this.props.showYearPicker) return;
            var monthList = [];
            var monthsShown = (_a = _this.props.monthsShown) !== null && _a !== void 0 ? _a : Calendar.defaultProps.monthsShown;
            var monthsToSubtract = _this.props.showPreviousMonths ? monthsShown - 1 : 0;
            var fromMonthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $b4358f02f9e27928$export$3d83eec43f4ea476)(_this.state.date, monthsToSubtract) : (0, $9ccdf5b091b4766d$export$73d1c15a21f9fae5)(_this.state.date, monthsToSubtract);
            var monthSelectedIn = (_b = _this.props.monthSelectedIn) !== null && _b !== void 0 ? _b : monthsToSubtract;
            for(var i = 0; i < monthsShown; ++i){
                var monthsToAdd = i - monthSelectedIn + monthsToSubtract;
                var monthDate = _this.props.showMonthYearPicker || _this.props.showQuarterYearPicker ? (0, $b4358f02f9e27928$export$3d83eec43f4ea476)(fromMonthDate, monthsToAdd) : (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(fromMonthDate, monthsToAdd);
                var monthKey = "month-".concat(i);
                var monthShowsDuplicateDaysEnd = i < monthsShown - 1;
                var monthShowsDuplicateDaysStart = i > 0;
                monthList.push((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                    key: monthKey,
                    ref: function(div) {
                        _this.monthContainer = div !== null && div !== void 0 ? div : undefined;
                    },
                    className: "react-datepicker__month-container"
                }, _this.renderHeader({
                    monthDate: monthDate,
                    i: i
                }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$Month, $7c7b1a6f859720e7$var$_assign({}, Calendar.defaultProps, _this.props, {
                    containerRef: _this.containerRef,
                    ariaLabelPrefix: _this.props.monthAriaLabelPrefix,
                    day: monthDate,
                    onDayClick: _this.handleDayClick,
                    handleOnKeyDown: _this.props.handleOnDayKeyDown,
                    handleOnMonthKeyDown: _this.props.handleOnKeyDown,
                    onDayMouseEnter: _this.handleDayMouseEnter,
                    onMouseLeave: _this.handleMonthMouseLeave,
                    orderInDisplay: i,
                    selectingDate: _this.state.selectingDate,
                    monthShowsDuplicateDaysEnd: monthShowsDuplicateDaysEnd,
                    monthShowsDuplicateDaysStart: monthShowsDuplicateDaysStart,
                    dayNamesHeader: _this.renderDayNamesHeader(monthDate)
                }))));
            }
            return monthList;
        };
        _this.renderYears = function() {
            if (_this.props.showTimeSelectOnly) return;
            if (_this.props.showYearPicker) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__year--container"
            }, _this.renderHeader({
                monthDate: _this.state.date
            }), (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$Year, $7c7b1a6f859720e7$var$_assign({}, Calendar.defaultProps, _this.props, {
                selectingDate: _this.state.selectingDate,
                date: _this.state.date,
                onDayClick: _this.handleDayClick,
                clearSelectingDate: _this.clearSelectingDate,
                onYearMouseEnter: _this.handleYearMouseEnter,
                onYearMouseLeave: _this.handleYearMouseLeave
            })));
            return;
        };
        _this.renderTimeSection = function() {
            if (_this.props.showTimeSelect && (_this.state.monthContainer || _this.props.showTimeSelectOnly)) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$Time, $7c7b1a6f859720e7$var$_assign({}, Calendar.defaultProps, _this.props, {
                onChange: _this.props.onTimeChange,
                format: _this.props.timeFormat,
                intervals: _this.props.timeIntervals,
                monthRef: _this.state.monthContainer
            }));
            return;
        };
        _this.renderInputTimeSection = function() {
            var time = _this.props.selected ? new Date(_this.props.selected) : undefined;
            var timeValid = time && $7c7b1a6f859720e7$var$isValid(time) && Boolean(_this.props.selected);
            var timeString = timeValid ? "".concat($7c7b1a6f859720e7$var$addZero(time.getHours()), ":").concat($7c7b1a6f859720e7$var$addZero(time.getMinutes())) : "";
            if (_this.props.showTimeInput) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$InputTime, $7c7b1a6f859720e7$var$_assign({}, Calendar.defaultProps, _this.props, {
                date: time,
                timeString: timeString,
                onChange: _this.props.onTimeChange
            }));
            return;
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            // Don't render aria-live message if date is invalid
            if (!$7c7b1a6f859720e7$var$isValid(_this.state.date)) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            });
            var _b = $7c7b1a6f859720e7$var$getYearsPeriod(_this.state.date, (_a = _this.props.yearItemNumber) !== null && _a !== void 0 ? _a : Calendar.defaultProps.yearItemNumber), startPeriod = _b.startPeriod, endPeriod = _b.endPeriod;
            var ariaLiveMessage;
            if (_this.props.showYearPicker) ariaLiveMessage = "".concat(startPeriod, " - ").concat(endPeriod);
            else if (_this.props.showMonthYearPicker || _this.props.showQuarterYearPicker) ariaLiveMessage = (0, $18282d9928d9137b$export$5846dc2d57a5c860)(_this.state.date);
            else ariaLiveMessage = "".concat($7c7b1a6f859720e7$var$getMonthInLocale((0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(_this.state.date), _this.props.locale), " ").concat((0, $18282d9928d9137b$export$5846dc2d57a5c860)(_this.state.date));
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, _this.state.isRenderAriaLiveMessage && ariaLiveMessage);
        };
        _this.renderChildren = function() {
            if (_this.props.children) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__children-container"
            }, _this.props.children);
            return;
        };
        _this.containerRef = (0, $7fPBF.createRef)();
        _this.state = {
            date: _this.getDateInView(),
            selectingDate: undefined,
            monthContainer: undefined,
            isRenderAriaLiveMessage: false
        };
        return _this;
    }
    Object.defineProperty(Calendar, "defaultProps", {
        get: function() {
            return {
                monthsShown: 1,
                forceShowMonthNavigation: false,
                outsideClickIgnoreClass: $7c7b1a6f859720e7$var$OUTSIDE_CLICK_IGNORE_CLASS,
                timeCaption: "Time",
                previousYearButtonLabel: "Previous Year",
                nextYearButtonLabel: "Next Year",
                previousMonthButtonLabel: "Previous Month",
                nextMonthButtonLabel: "Next Month",
                yearItemNumber: $7c7b1a6f859720e7$var$DEFAULT_YEAR_ITEM_NUMBER
            };
        },
        enumerable: false,
        configurable: true
    });
    Calendar.prototype.componentDidMount = function() {
        var _this = this;
        // monthContainer height is needed in time component
        // to determine the height for the ul in the time component
        // setState here so height is given after final component
        // layout is rendered
        if (this.props.showTimeSelect) this.assignMonthContainer = function() {
            _this.setState({
                monthContainer: _this.monthContainer
            });
        }();
    };
    Calendar.prototype.componentDidUpdate = function(prevProps) {
        var _this = this;
        if (this.props.preSelection && $7c7b1a6f859720e7$var$isValid(this.props.preSelection) && (!$7c7b1a6f859720e7$var$isSameDay(this.props.preSelection, prevProps.preSelection) || this.props.monthSelectedIn !== prevProps.monthSelectedIn)) {
            var hasMonthChanged_1 = !$7c7b1a6f859720e7$var$isSameMonth(this.state.date, this.props.preSelection);
            this.setState({
                date: this.props.preSelection
            }, function() {
                return hasMonthChanged_1 && _this.handleCustomMonthChange(_this.state.date);
            });
        } else if (this.props.openToDate && !$7c7b1a6f859720e7$var$isSameDay(this.props.openToDate, prevProps.openToDate)) this.setState({
            date: this.props.openToDate
        });
    };
    Calendar.prototype.render = function() {
        var Container = this.props.container || $7c7b1a6f859720e7$export$946daa762919616e;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$ClickOutsideWrapper, {
            onClickOutside: this.handleClickOutside,
            style: {
                display: "contents"
            },
            ignoreClass: this.props.outsideClickIgnoreClass
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            style: {
                display: "contents"
            },
            ref: this.containerRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Container, {
            className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("react-datepicker", this.props.className, {
                "react-datepicker--time-only": this.props.showTimeSelectOnly
            }),
            showTime: this.props.showTimeSelect || this.props.showTimeInput,
            showTimeSelectOnly: this.props.showTimeSelectOnly,
            inline: this.props.inline
        }, this.renderAriaLiveRegion(), this.renderPreviousButton(), this.renderNextButton(), this.renderMonths(), this.renderYears(), this.renderTodayButton(), this.renderTimeSection(), this.renderInputTimeSection(), this.renderChildren())));
    };
    return Calendar;
}((0, $7fPBF.Component));
/**
 * `CalendarIcon` is a React component that renders an icon for a calendar.
 * The icon can be a string representing a CSS class, a React node, or a default SVG icon.
 *
 * @component
 * @prop  icon - The icon to be displayed. This can be a string representing a CSS class or a React node.
 * @prop  className - An optional string representing additional CSS classes to be applied to the icon.
 * @prop  onClick - An optional function to be called when the icon is clicked.
 *
 * @example
 * // To use a CSS class as the icon
 * <CalendarIcon icon="my-icon-class" onClick={myClickHandler} />
 *
 * @example
 * // To use a React node as the icon
 * <CalendarIcon icon={<MyIconComponent />} onClick={myClickHandler} />
 *
 * @returns  The `CalendarIcon` component.
 */ var $7c7b1a6f859720e7$var$CalendarIcon = function(_a) {
    var icon = _a.icon, _b = _a.className, className = _b === void 0 ? "" : _b, onClick = _a.onClick;
    var defaultClass = "react-datepicker__calendar-icon";
    if (typeof icon === "string") return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("i", {
        className: "".concat(defaultClass, " ").concat(icon, " ").concat(className),
        "aria-hidden": "true",
        onClick: onClick
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).isValidElement(icon)) {
        // Because we are checking that typeof icon is string first, we can safely cast icon as React.ReactElement on types level and code level
        var iconElement_1 = icon;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).cloneElement(iconElement_1, {
            className: "".concat(iconElement_1.props.className || "", " ").concat(defaultClass, " ").concat(className),
            onClick: function(event) {
                if (typeof iconElement_1.props.onClick === "function") iconElement_1.props.onClick(event);
                if (typeof onClick === "function") onClick(event);
            }
        });
    }
    // Default SVG Icon
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        className: "".concat(defaultClass, " ").concat(className),
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 448 512",
        onClick: onClick
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"
    }));
};
/**
 * `Portal` is a React component that allows you to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 *
 * @class
 * @param {PortalProps} props - The properties that define the `Portal` component.
 * @property {React.ReactNode} props.children - The children to be rendered into the `Portal`.
 * @property {string} props.portalId - The id of the DOM node into which the `Portal` will render.
 * @property {ShadowRoot} [props.portalHost] - The DOM node to host the `Portal`.
 */ var $7c7b1a6f859720e7$var$Portal = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(Portal, _super);
    function Portal(props) {
        var _this = _super.call(this, props) || this;
        _this.portalRoot = null;
        _this.el = document.createElement("div");
        return _this;
    }
    Portal.prototype.componentDidMount = function() {
        this.portalRoot = (this.props.portalHost || document).getElementById(this.props.portalId);
        if (!this.portalRoot) {
            this.portalRoot = document.createElement("div");
            this.portalRoot.setAttribute("id", this.props.portalId);
            (this.props.portalHost || document.body).appendChild(this.portalRoot);
        }
        this.portalRoot.appendChild(this.el);
    };
    Portal.prototype.componentWillUnmount = function() {
        if (this.portalRoot) this.portalRoot.removeChild(this.el);
    };
    Portal.prototype.render = function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($fw0lo))).createPortal(this.props.children, this.el);
    };
    return Portal;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$focusableElementsSelector = "[tabindex], a, button, input, select, textarea";
var $7c7b1a6f859720e7$var$focusableFilter = function(node) {
    if (node instanceof HTMLAnchorElement) return node.tabIndex !== -1;
    return !node.disabled && node.tabIndex !== -1;
};
/**
 * `TabLoop` is a React component that manages tabbing behavior for its children.
 *
 * TabLoop prevents the user from tabbing outside of the popper
 * It creates a tabindex loop so that "Tab" on the last element will focus the first element
 * and "Shift Tab" on the first element will focus the last element
 *
 * @component
 * @example
 * <TabLoop enableTabLoop={true}>
 *   <ChildComponent />
 * </TabLoop>
 *
 * @param props - The properties that define the `TabLoop` component.
 * @param props.children - The child components.
 * @param props.enableTabLoop - Whether to enable the tab loop.
 *
 * @returns The `TabLoop` component.
 */ var $7c7b1a6f859720e7$var$TabLoop = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(TabLoop, _super);
    function TabLoop(props) {
        var _this = _super.call(this, props) || this;
        /**
         * `getTabChildren` is a method of the `TabLoop` class that retrieves all tabbable children of the component.
         *
         * This method uses the `tabbable` library to find all tabbable elements within the `TabLoop` component.
         * It then filters out any elements that are not visible.
         *
         * @returns An array of all tabbable and visible children of the `TabLoop` component.
         */ _this.getTabChildren = function() {
            var _a;
            return Array.prototype.slice.call((_a = _this.tabLoopRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll($7c7b1a6f859720e7$var$focusableElementsSelector), 1, -1).filter($7c7b1a6f859720e7$var$focusableFilter);
        };
        _this.handleFocusStart = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[tabChildren.length - 1].focus();
        };
        _this.handleFocusEnd = function() {
            var tabChildren = _this.getTabChildren();
            tabChildren && tabChildren.length > 1 && tabChildren[0].focus();
        };
        _this.tabLoopRef = (0, $7fPBF.createRef)();
        return _this;
    }
    TabLoop.prototype.render = function() {
        var _a;
        if (!((_a = this.props.enableTabLoop) !== null && _a !== void 0 ? _a : TabLoop.defaultProps.enableTabLoop)) return this.props.children;
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__tab-loop",
            ref: this.tabLoopRef
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__tab-loop__start",
            tabIndex: 0,
            onFocus: this.handleFocusStart
        }), this.props.children, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__tab-loop__end",
            tabIndex: 0,
            onFocus: this.handleFocusEnd
        }));
    };
    TabLoop.defaultProps = {
        enableTabLoop: true
    };
    return TabLoop;
}((0, $7fPBF.Component));
/**
 * `withFloating` is a higher-order component that adds floating behavior to a component.
 *
 * @param Component - The component to enhance.
 *
 * @example
 * const FloatingComponent = withFloating(MyComponent);
 * <FloatingComponent popperModifiers={[]} popperProps={{}} hidePopper={true} />
 *
 * @param popperModifiers - The modifiers to use for the popper.
 * @param popperProps - The props to pass to the popper.
 * @param hidePopper - Whether to hide the popper.
 * @param popperPlacement - The placement of the popper.
 *
 * @returns A new component with floating behavior.
 */ function $7c7b1a6f859720e7$var$withFloating(Component) {
    function WithFloating(props) {
        var _a;
        var hidePopper = typeof props.hidePopper === "boolean" ? props.hidePopper : true;
        var arrowRef = (0, $7fPBF.useRef)(null);
        var floatingProps = (0, $8762903b8fe68977$export$4e02a5c1d08bac65)($7c7b1a6f859720e7$var$_assign({
            open: !hidePopper,
            whileElementsMounted: (0, $b62109a283c86f13$export$deee3a793edee05f),
            placement: props.popperPlacement,
            middleware: $7c7b1a6f859720e7$var$__spreadArray([
                (0, $2a1639b232695612$export$8a83211c878a3f1f)({
                    padding: 15
                }),
                (0, $2a1639b232695612$export$cc800923e997bb8)(10),
                // eslint-disable-next-line react-hooks/refs -- Floating UI requires refs to be passed during render
                (0, $2a1639b232695612$export$f2120bbfa5450bd2)({
                    element: arrowRef
                })
            ], (_a = props.popperModifiers) !== null && _a !== void 0 ? _a : [], true)
        }, props.popperProps));
        var componentProps = $7c7b1a6f859720e7$var$_assign($7c7b1a6f859720e7$var$_assign({}, props), {
            hidePopper: hidePopper,
            popperProps: $7c7b1a6f859720e7$var$_assign($7c7b1a6f859720e7$var$_assign({}, floatingProps), {
                arrowRef: arrowRef
            })
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, $7c7b1a6f859720e7$var$_assign({}, componentProps));
    }
    WithFloating.displayName = "withFloating(".concat(Component.displayName || Component.name || "Component", ")");
    return WithFloating;
}
// Exported for testing purposes
var $7c7b1a6f859720e7$var$PopperComponent$1 = function(props) {
    var className = props.className, wrapperClassName = props.wrapperClassName, _a = props.hidePopper, hidePopper = _a === void 0 ? true : _a, popperComponent = props.popperComponent, targetComponent = props.targetComponent, enableTabLoop = props.enableTabLoop, popperOnKeyDown = props.popperOnKeyDown, portalId = props.portalId, portalHost = props.portalHost, popperProps = props.popperProps, showArrow = props.showArrow;
    var popper = undefined;
    if (!hidePopper) {
        var classes = (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("react-datepicker-popper", className);
        popper = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$TabLoop, {
            enableTabLoop: enableTabLoop
        }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            ref: popperProps.refs.setFloating,
            style: popperProps.floatingStyles,
            className: classes,
            "data-placement": popperProps.placement,
            onKeyDown: popperOnKeyDown
        }, popperComponent, showArrow && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $8762903b8fe68977$export$33511391554732bc), {
            ref: popperProps.arrowRef,
            context: popperProps.context,
            fill: "currentColor",
            strokeWidth: 1,
            height: 8,
            width: 16,
            style: {
                transform: "translateY(-1px)"
            },
            className: "react-datepicker__triangle"
        })));
    }
    if (props.popperContainer) popper = (0, $7fPBF.createElement)(props.popperContainer, {}, popper);
    if (portalId && !hidePopper) popper = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$Portal, {
        portalId: portalId,
        portalHost: portalHost
    }, popper);
    var wrapperClasses = (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("react-datepicker-wrapper", wrapperClassName);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        ref: popperProps.refs.setReference,
        className: wrapperClasses
    }, targetComponent), popper);
};
var $7c7b1a6f859720e7$var$PopperComponent = $7c7b1a6f859720e7$var$withFloating($7c7b1a6f859720e7$var$PopperComponent$1);
// Compares dates year+month combinations
function $7c7b1a6f859720e7$var$hasPreSelectionChanged(date1, date2) {
    if (date1 && date2) return (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(date1) !== (0, $7dc7d1cfe79653ed$export$6ce1b5acc29cb53b)(date2) || (0, $18282d9928d9137b$export$5846dc2d57a5c860)(date1) !== (0, $18282d9928d9137b$export$5846dc2d57a5c860)(date2);
    return date1 !== date2;
}
/**
 * General datepicker component.
 */ var $7c7b1a6f859720e7$var$INPUT_ERR_1 = "Date input not valid.";
var $7c7b1a6f859720e7$export$5109c6dd95d8fb00 = /** @class */ function(_super) {
    $7c7b1a6f859720e7$var$__extends(DatePicker, _super);
    function DatePicker(props) {
        var _this = _super.call(this, props) || this;
        _this.calendar = null;
        _this.input = null;
        _this.getPreSelection = function() {
            return _this.props.openToDate ? _this.props.openToDate : _this.props.selectsEnd && _this.props.startDate ? _this.props.startDate : _this.props.selectsStart && _this.props.endDate ? _this.props.endDate : $7c7b1a6f859720e7$var$newDate();
        };
        // Convert the date from string format to standard Date format
        _this.modifyHolidays = function() {
            var _a;
            return (_a = _this.props.holidays) === null || _a === void 0 ? void 0 : _a.reduce(function(accumulator, holiday) {
                var date = new Date(holiday.date);
                if (!$7c7b1a6f859720e7$var$isValid(date)) return accumulator;
                return $7c7b1a6f859720e7$var$__spreadArray($7c7b1a6f859720e7$var$__spreadArray([], accumulator, true), [
                    $7c7b1a6f859720e7$var$_assign($7c7b1a6f859720e7$var$_assign({}, holiday), {
                        date: date
                    })
                ], false);
            }, []);
        };
        _this.calcInitialState = function() {
            var _a;
            var defaultPreSelection = _this.getPreSelection();
            var minDate = $7c7b1a6f859720e7$var$getEffectiveMinDate(_this.props);
            var maxDate = $7c7b1a6f859720e7$var$getEffectiveMaxDate(_this.props);
            var boundedPreSelection = minDate && (0, $eb21892051383660$export$5c007e10c6929c95)(defaultPreSelection, $7c7b1a6f859720e7$var$getStartOfDay(minDate)) ? minDate : maxDate && (0, $04f0c9d20b09837b$export$e4de839670987035)(defaultPreSelection, $7c7b1a6f859720e7$var$getEndOfDay(maxDate)) ? maxDate : defaultPreSelection;
            return {
                open: _this.props.startOpen || false,
                preventFocus: false,
                inputValue: null,
                preSelection: (_a = _this.props.selectsRange ? _this.props.startDate : _this.props.selected) !== null && _a !== void 0 ? _a : boundedPreSelection,
                // transforming highlighted days (perhaps nested array)
                // to flat Map for faster access in day.jsx
                highlightDates: $7c7b1a6f859720e7$var$getHighLightDaysMap(_this.props.highlightDates),
                focused: false,
                // used to focus day in inline version after month has changed, but not on
                // initial render
                shouldFocusDayInline: false,
                isRenderAriaLiveMessage: false,
                wasHidden: false
            };
        };
        _this.getInputValue = function() {
            var _a;
            var _b = _this.props, locale = _b.locale, startDate = _b.startDate, endDate = _b.endDate, rangeSeparator = _b.rangeSeparator, selected = _b.selected, selectedDates = _b.selectedDates, selectsMultiple = _b.selectsMultiple, selectsRange = _b.selectsRange, value = _b.value;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var inputValue = _this.state.inputValue;
            if (typeof value === "string") return value;
            else if (typeof inputValue === "string") return inputValue;
            else if (selectsRange) return $7c7b1a6f859720e7$var$safeDateRangeFormat(startDate, endDate, {
                dateFormat: dateFormat,
                locale: locale,
                rangeSeparator: rangeSeparator
            });
            else if (selectsMultiple) return $7c7b1a6f859720e7$var$safeMultipleDatesFormat(selectedDates !== null && selectedDates !== void 0 ? selectedDates : [], {
                dateFormat: dateFormat,
                locale: locale
            });
            return $7c7b1a6f859720e7$var$safeDateFormat(selected, {
                dateFormat: dateFormat,
                locale: locale
            });
        };
        _this.resetHiddenStatus = function() {
            _this.setState($7c7b1a6f859720e7$var$_assign($7c7b1a6f859720e7$var$_assign({}, _this.state), {
                wasHidden: false
            }));
        };
        _this.setHiddenStatus = function() {
            _this.setState($7c7b1a6f859720e7$var$_assign($7c7b1a6f859720e7$var$_assign({}, _this.state), {
                wasHidden: true
            }));
        };
        _this.setHiddenStateOnVisibilityHidden = function() {
            if (document.visibilityState !== "hidden") return;
            _this.setHiddenStatus();
        };
        _this.clearPreventFocusTimeout = function() {
            if (_this.preventFocusTimeout) clearTimeout(_this.preventFocusTimeout);
        };
        _this.setFocus = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a, {
                preventScroll: true
            });
        };
        _this.setBlur = function() {
            var _a, _b;
            (_b = (_a = _this.input) === null || _a === void 0 ? void 0 : _a.blur) === null || _b === void 0 || _b.call(_a);
            _this.cancelFocusInput();
        };
        _this.deferBlur = function() {
            requestAnimationFrame(function() {
                _this.setBlur();
            });
        };
        _this.setOpen = function(open, skipSetBlur) {
            if (skipSetBlur === void 0) skipSetBlur = false;
            _this.setState({
                open: open,
                preSelection: open && _this.state.open ? _this.state.preSelection : _this.calcInitialState().preSelection,
                lastPreSelectChange: $7c7b1a6f859720e7$var$PRESELECT_CHANGE_VIA_NAVIGATE
            }, function() {
                if (!open) _this.setState(function(prev) {
                    return {
                        focused: skipSetBlur ? prev.focused : false
                    };
                }, function() {
                    !skipSetBlur && _this.deferBlur();
                    _this.setState({
                        inputValue: null
                    });
                });
            });
        };
        _this.inputOk = function() {
            return (0, $5e4a1e7833f0eaed$export$871608497c498473)(_this.state.preSelection);
        };
        _this.isCalendarOpen = function() {
            return _this.props.open === undefined ? _this.state.open && !_this.props.disabled && !_this.props.readOnly : _this.props.open;
        };
        _this.handleFocus = function(event) {
            var _a, _b;
            var isAutoReFocus = _this.state.wasHidden;
            var isOpenAllowed = isAutoReFocus ? _this.state.open : true;
            if (isAutoReFocus) _this.resetHiddenStatus();
            if (!_this.state.preventFocus) {
                (_b = (_a = _this.props).onFocus) === null || _b === void 0 || _b.call(_a, event);
                if (isOpenAllowed && !_this.props.preventOpenOnFocus && !_this.props.readOnly) _this.setOpen(true);
            }
            _this.setState({
                focused: true
            });
        };
        _this.sendFocusBackToInput = function() {
            // Clear previous timeout if it exists
            if (_this.preventFocusTimeout) _this.clearPreventFocusTimeout();
            // close the popper and refocus the input
            // stop the input from auto opening onFocus
            // setFocus to the input
            _this.setState({
                preventFocus: true
            }, function() {
                _this.preventFocusTimeout = setTimeout(function() {
                    _this.setFocus();
                    _this.setState({
                        preventFocus: false
                    });
                });
            });
        };
        _this.cancelFocusInput = function() {
            clearTimeout(_this.inputFocusTimeout);
            _this.inputFocusTimeout = undefined;
        };
        _this.deferFocusInput = function() {
            _this.cancelFocusInput();
            _this.inputFocusTimeout = setTimeout(function() {
                return _this.setFocus();
            }, 1);
        };
        _this.handleDropdownFocus = function() {
            _this.cancelFocusInput();
        };
        _this.resetInputValue = function() {
            _this.setState($7c7b1a6f859720e7$var$_assign($7c7b1a6f859720e7$var$_assign({}, _this.state), {
                inputValue: null
            }));
        };
        _this.handleBlur = function(event) {
            var _a, _b;
            if (!_this.state.open || _this.props.withPortal || _this.props.showTimeInput) (_b = (_a = _this.props).onBlur) === null || _b === void 0 || _b.call(_a, event);
            _this.resetInputValue();
            if (_this.state.open && _this.props.open === false) _this.setOpen(false);
            _this.setState({
                focused: false
            });
        };
        _this.handleCalendarClickOutside = function(event) {
            var _a, _b;
            if (!_this.props.inline) _this.setOpen(false);
            (_b = (_a = _this.props).onClickOutside) === null || _b === void 0 || _b.call(_a, event);
            if (_this.props.withPortal) event.preventDefault();
        };
        // handleChange is called when user types in the textbox
        _this.handleChange = function() {
            var _a, _b, _c, _d, _e;
            var allArgs = [];
            for(var _i = 0; _i < arguments.length; _i++)allArgs[_i] = arguments[_i];
            var event = allArgs[0];
            if (_this.props.onChangeRaw) {
                _this.props.onChangeRaw.apply(_this, allArgs);
                if (!event || typeof event.isDefaultPrevented !== "function" || event.isDefaultPrevented()) return;
            }
            _this.setState({
                inputValue: (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : null,
                lastPreSelectChange: $7c7b1a6f859720e7$var$PRESELECT_CHANGE_VIA_INPUT
            });
            var _f = _this.props, selectsRange = _f.selectsRange, startDate = _f.startDate, endDate = _f.endDate;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var strictParsing = (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.strictParsing;
            var value = (event === null || event === void 0 ? void 0 : event.target) instanceof HTMLInputElement ? event.target.value : "";
            if (selectsRange) {
                var rangeSeparator = _this.props.rangeSeparator;
                var trimmedRangeSeparator = rangeSeparator.trim();
                var _g = value.split(dateFormat.includes(trimmedRangeSeparator) ? rangeSeparator : trimmedRangeSeparator, 2).map(function(val) {
                    return val.trim();
                }), valueStart = _g[0], valueEnd = _g[1];
                var startDateNew = $7c7b1a6f859720e7$var$parseDate(valueStart !== null && valueStart !== void 0 ? valueStart : "", dateFormat, _this.props.locale, strictParsing);
                var endDateNew = startDateNew ? $7c7b1a6f859720e7$var$parseDate(valueEnd !== null && valueEnd !== void 0 ? valueEnd : "", dateFormat, _this.props.locale, strictParsing) : null;
                var startChanged = (startDate === null || startDate === void 0 ? void 0 : startDate.getTime()) !== (startDateNew === null || startDateNew === void 0 ? void 0 : startDateNew.getTime());
                var endChanged = (endDate === null || endDate === void 0 ? void 0 : endDate.getTime()) !== (endDateNew === null || endDateNew === void 0 ? void 0 : endDateNew.getTime());
                if (!startChanged && !endChanged) return;
                if (startDateNew && $7c7b1a6f859720e7$var$isDayDisabled(startDateNew, _this.props)) return;
                if (endDateNew && $7c7b1a6f859720e7$var$isDayDisabled(endDateNew, _this.props)) return;
                (_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, [
                    startDateNew,
                    endDateNew
                ], event);
            } else {
                // not selectsRange
                var date = $7c7b1a6f859720e7$var$parseDate(value, dateFormat, _this.props.locale, strictParsing, (_e = _this.props.selected) !== null && _e !== void 0 ? _e : undefined);
                // Update selection if either (1) date was successfully parsed, or (2) input field is empty
                if (date || !value) _this.setSelected(date, event, true);
            }
        };
        _this.handleSelect = function(date, event, monthSelectedIn) {
            var _a;
            if (_this.props.readOnly) return;
            var _b = _this.props, selectsRange = _b.selectsRange, startDate = _b.startDate, endDate = _b.endDate, locale = _b.locale, swapRange = _b.swapRange;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var isDateSelectionComplete = !selectsRange || startDate && !endDate && (swapRange || !$7c7b1a6f859720e7$var$isDateBefore(date, startDate));
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeSelect && isDateSelectionComplete) // Preventing onFocus event to fix issue
            // https://github.com/Hacker0x01/react-datepicker/issues/628
            _this.sendFocusBackToInput();
            if (_this.props.onChangeRaw) {
                var formattedDate = $7c7b1a6f859720e7$var$safeDateFormat(date, {
                    dateFormat: dateFormat,
                    locale: locale
                });
                _this.props.onChangeRaw(event, {
                    date: date,
                    formattedDate: formattedDate
                });
            }
            _this.setSelected(date, event, false, monthSelectedIn);
            if (_this.props.showDateSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            if (!_this.props.shouldCloseOnSelect || _this.props.showTimeSelect) _this.setPreSelection(date);
            else if (isDateSelectionComplete) _this.setOpen(false);
        };
        // setSelected is called either from handleChange (user typed date into textbox and it was parsed) or handleSelect (user selected date from calendar using mouse or keyboard)
        _this.setSelected = function(date, event, keepInput, monthSelectedIn) {
            var _a, _b;
            var changedDate = date;
            // Early return if selected year/month/day is disabled
            if (_this.props.showYearPicker) {
                if (changedDate !== null && $7c7b1a6f859720e7$var$isYearDisabled((0, $18282d9928d9137b$export$5846dc2d57a5c860)(changedDate), _this.props)) return;
            } else if (_this.props.showMonthYearPicker) {
                if (changedDate !== null && $7c7b1a6f859720e7$var$isMonthDisabled(changedDate, _this.props)) return;
            } else {
                if (changedDate !== null && $7c7b1a6f859720e7$var$isDayDisabled(changedDate, _this.props)) return;
            }
            var _c = _this.props, onChange = _c.onChange, selectsRange = _c.selectsRange, startDate = _c.startDate, endDate = _c.endDate, selectsMultiple = _c.selectsMultiple, selectedDates = _c.selectedDates, minTime = _c.minTime, swapRange = _c.swapRange;
            if (!$7c7b1a6f859720e7$var$isEqual(_this.props.selected, changedDate) || _this.props.allowSameDay || selectsRange || selectsMultiple) {
                if (changedDate !== null) {
                    // Preserve previously selected time if only date is currently being changed
                    if (_this.props.selected && (!keepInput || !_this.props.showTimeSelect && !_this.props.showTimeSelectOnly && !_this.props.showTimeInput)) changedDate = $7c7b1a6f859720e7$var$setTime(changedDate, {
                        hour: (0, $1768b25c11e35b0a$export$257b40f71c07d58f)(_this.props.selected),
                        minute: (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(_this.props.selected),
                        second: (0, $ad405ba8e35fff1c$export$5e9417507ff28427)(_this.props.selected)
                    });
                    // If minTime is present then set the time to minTime
                    if (!keepInput && (_this.props.showTimeSelect || _this.props.showTimeSelectOnly)) {
                        if (minTime) changedDate = $7c7b1a6f859720e7$var$setTime(changedDate, {
                            hour: minTime.getHours(),
                            minute: minTime.getMinutes(),
                            second: minTime.getSeconds()
                        });
                    }
                    if (!_this.props.inline) _this.setState({
                        preSelection: changedDate
                    });
                    if (!_this.props.focusSelectedMonth) _this.setState({
                        monthSelectedIn: monthSelectedIn
                    });
                }
                if (selectsRange) {
                    var noRanges = !startDate && !endDate;
                    var hasStartRange = startDate && !endDate;
                    var hasOnlyEndRange = !startDate && !!endDate;
                    var isRangeFilled = startDate && endDate;
                    if (noRanges) onChange === null || onChange === void 0 || onChange([
                        changedDate,
                        null
                    ], event);
                    else if (hasStartRange) {
                        if (changedDate === null) onChange === null || onChange === void 0 || onChange([
                            null,
                            null
                        ], event);
                        else if ($7c7b1a6f859720e7$var$isDateBefore(changedDate, startDate)) {
                            if (swapRange) onChange === null || onChange === void 0 || onChange([
                                changedDate,
                                startDate
                            ], event);
                            else onChange === null || onChange === void 0 || onChange([
                                changedDate,
                                null
                            ], event);
                        } else onChange === null || onChange === void 0 || onChange([
                            startDate,
                            changedDate
                        ], event);
                    } else if (hasOnlyEndRange) {
                        if (changedDate && $7c7b1a6f859720e7$var$isDateBefore(changedDate, endDate)) onChange === null || onChange === void 0 || onChange([
                            changedDate,
                            endDate
                        ], event);
                        else onChange === null || onChange === void 0 || onChange([
                            changedDate,
                            null
                        ], event);
                    }
                    if (isRangeFilled) onChange === null || onChange === void 0 || onChange([
                        changedDate,
                        null
                    ], event);
                } else if (selectsMultiple) {
                    if (changedDate !== null) {
                        if (!(selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length)) onChange === null || onChange === void 0 || onChange([
                            changedDate
                        ], event);
                        else {
                            var isChangedDateAlreadySelected = selectedDates.some(function(selectedDate) {
                                return $7c7b1a6f859720e7$var$isSameDay(selectedDate, changedDate);
                            });
                            if (isChangedDateAlreadySelected) {
                                var nextDates = selectedDates.filter(function(selectedDate) {
                                    return !$7c7b1a6f859720e7$var$isSameDay(selectedDate, changedDate);
                                });
                                onChange === null || onChange === void 0 || onChange(nextDates, event);
                            } else onChange === null || onChange === void 0 || onChange($7c7b1a6f859720e7$var$__spreadArray($7c7b1a6f859720e7$var$__spreadArray([], selectedDates, true), [
                                changedDate
                            ], false), event);
                        }
                    }
                } else onChange === null || onChange === void 0 || onChange(changedDate, event);
            }
            if (!keepInput) {
                (_b = (_a = _this.props).onSelect) === null || _b === void 0 || _b.call(_a, changedDate, event);
                _this.setState({
                    inputValue: null
                });
            }
        };
        // When checking preSelection via min/maxDate, times need to be manipulated via getStartOfDay/getEndOfDay
        _this.setPreSelection = function(date) {
            if (_this.props.readOnly) return;
            var hasMinDate = (0, $5e4a1e7833f0eaed$export$871608497c498473)(_this.props.minDate);
            var hasMaxDate = (0, $5e4a1e7833f0eaed$export$871608497c498473)(_this.props.maxDate);
            var isValidDateSelection = true;
            if (date) {
                var dateStartOfDay = $7c7b1a6f859720e7$var$getStartOfDay(date);
                if (hasMinDate && hasMaxDate) // isDayInRange uses getStartOfDay internally, so not necessary to manipulate times here
                isValidDateSelection = $7c7b1a6f859720e7$var$isDayInRange(date, _this.props.minDate, _this.props.maxDate);
                else if (hasMinDate) {
                    var minDateStartOfDay = $7c7b1a6f859720e7$var$getStartOfDay(_this.props.minDate);
                    isValidDateSelection = (0, $04f0c9d20b09837b$export$e4de839670987035)(date, minDateStartOfDay) || $7c7b1a6f859720e7$var$isEqual(dateStartOfDay, minDateStartOfDay);
                } else if (hasMaxDate) {
                    var maxDateEndOfDay = $7c7b1a6f859720e7$var$getEndOfDay(_this.props.maxDate);
                    isValidDateSelection = (0, $eb21892051383660$export$5c007e10c6929c95)(date, maxDateEndOfDay) || $7c7b1a6f859720e7$var$isEqual(dateStartOfDay, maxDateEndOfDay);
                }
            }
            if (isValidDateSelection) _this.setState({
                preSelection: date
            });
        };
        _this.toggleCalendar = function() {
            _this.setOpen(!_this.state.open);
        };
        _this.handleTimeChange = function(time) {
            var _a, _b;
            if (_this.props.selectsRange || _this.props.selectsMultiple) return;
            var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
            var changedDate = _this.props.selected ? time : $7c7b1a6f859720e7$var$setTime(selected, {
                hour: (0, $1768b25c11e35b0a$export$257b40f71c07d58f)(time),
                minute: (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(time)
            });
            _this.setState({
                preSelection: changedDate
            });
            (_b = (_a = _this.props).onChange) === null || _b === void 0 || _b.call(_a, changedDate);
            if (_this.props.shouldCloseOnSelect && !_this.props.showTimeInput) {
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
            if (_this.props.showTimeInput) _this.setOpen(true);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            _this.setState({
                inputValue: null
            });
        };
        _this.onInputClick = function() {
            var _a, _b;
            if (!_this.props.disabled && !_this.props.readOnly) _this.setOpen(true);
            (_b = (_a = _this.props).onInputClick) === null || _b === void 0 || _b.call(_a);
        };
        _this.handleTimeOnlyArrowKey = function(eventKey) {
            var _a, _b, _c, _d;
            var currentTime = _this.props.selected || _this.state.preSelection || $7c7b1a6f859720e7$var$newDate();
            var timeIntervals = (_a = _this.props.timeIntervals) !== null && _a !== void 0 ? _a : 30;
            var dateFormat = (_b = _this.props.dateFormat) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dateFormat;
            var formatStr = Array.isArray(dateFormat) ? dateFormat[0] : dateFormat;
            var baseDate = $7c7b1a6f859720e7$var$getStartOfDay(currentTime);
            var currentMinutes = (0, $1768b25c11e35b0a$export$257b40f71c07d58f)(currentTime) * 60 + (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(currentTime);
            var maxMinutes = 1440 - timeIntervals; // Cap at last valid interval of the day
            var newTime;
            if (eventKey === $7c7b1a6f859720e7$var$KeyType.ArrowUp) {
                var newMinutes = Math.max(0, currentMinutes - timeIntervals);
                newTime = (0, $879ad858cbf859fa$export$2287e3d29250119e)(baseDate, newMinutes);
            } else {
                var newMinutes = Math.min(maxMinutes, currentMinutes + timeIntervals);
                newTime = (0, $879ad858cbf859fa$export$2287e3d29250119e)(baseDate, newMinutes);
            }
            var formattedTime = $7c7b1a6f859720e7$var$formatDate(newTime, formatStr || DatePicker.defaultProps.dateFormat, _this.props.locale);
            _this.setState({
                preSelection: newTime,
                inputValue: formattedTime
            });
            if (_this.props.selectsRange || _this.props.selectsMultiple) return;
            var selected = _this.props.selected ? _this.props.selected : _this.getPreSelection();
            var changedDate = _this.props.selected ? newTime : $7c7b1a6f859720e7$var$setTime(selected, {
                hour: (0, $1768b25c11e35b0a$export$257b40f71c07d58f)(newTime),
                minute: (0, $2a7e90ce6707ba01$export$b7f1bc3ea3ac4145)(newTime)
            });
            (_d = (_c = _this.props).onChange) === null || _d === void 0 || _d.call(_c, changedDate);
            if (_this.props.showTimeSelectOnly || _this.props.showTimeSelect) _this.setState({
                isRenderAriaLiveMessage: true
            });
            requestAnimationFrame(function() {
                _this.scrollToTimeOption(newTime);
            });
        };
        _this.handleTimeOnlyEnterKey = function(event) {
            var _a, _b, _c, _d;
            var inputElement = event.target;
            var inputValue = inputElement.value;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var timeFormat = _this.props.timeFormat || "p";
            var defaultTime = _this.state.preSelection || _this.props.selected || $7c7b1a6f859720e7$var$newDate();
            var parsedDate = $7c7b1a6f859720e7$var$parseDate(inputValue, dateFormat, _this.props.locale, (_b = _this.props.strictParsing) !== null && _b !== void 0 ? _b : false, defaultTime);
            var timeToCommit = defaultTime;
            if (parsedDate && $7c7b1a6f859720e7$var$isValid(parsedDate)) timeToCommit = parsedDate;
            else {
                var highlightedItem = ((_c = _this.calendar) === null || _c === void 0 ? void 0 : _c.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(".react-datepicker__time-list-item[tabindex='0']");
                if (highlightedItem instanceof HTMLElement) {
                    var itemText = (_d = highlightedItem.textContent) === null || _d === void 0 ? void 0 : _d.trim();
                    if (itemText) {
                        var itemTime = $7c7b1a6f859720e7$var$parseDate(itemText, timeFormat, _this.props.locale, false, defaultTime);
                        if (itemTime && $7c7b1a6f859720e7$var$isValid(itemTime)) timeToCommit = itemTime;
                    }
                }
            }
            _this.handleTimeChange(timeToCommit);
            _this.setOpen(false);
            _this.sendFocusBackToInput();
        };
        _this.scrollToTimeOption = function(time) {
            var _a, _b;
            if (!((_a = _this.calendar) === null || _a === void 0 ? void 0 : _a.containerRef.current)) return;
            var container = _this.calendar.containerRef.current;
            var timeListItems = Array.from(container.querySelectorAll(".react-datepicker__time-list-item"));
            var targetItem = null;
            var closestTimeDiff = Infinity;
            var timeFormat = _this.props.timeFormat || "p";
            for(var _i = 0, timeListItems_1 = timeListItems; _i < timeListItems_1.length; _i++){
                var item = timeListItems_1[_i];
                var itemText = (_b = item.textContent) === null || _b === void 0 ? void 0 : _b.trim();
                if (itemText) {
                    var itemTime = $7c7b1a6f859720e7$var$parseDate(itemText, timeFormat, _this.props.locale, false, time);
                    if (itemTime && $7c7b1a6f859720e7$var$isValid(itemTime)) {
                        if ($7c7b1a6f859720e7$var$isSameMinute(itemTime, time)) {
                            targetItem = item;
                            break;
                        }
                        var timeDiff = Math.abs(itemTime.getTime() - time.getTime());
                        if (timeDiff < closestTimeDiff) {
                            closestTimeDiff = timeDiff;
                            targetItem = item;
                        }
                    }
                }
            }
            if (targetItem) {
                timeListItems.forEach(function(item) {
                    item.setAttribute("tabindex", "-1");
                });
                targetItem.setAttribute("tabindex", "0");
                targetItem.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
            }
        };
        _this.onInputKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            var eventKey = event.key;
            if (!_this.state.open && !_this.props.inline && !_this.props.preventOpenOnFocus) {
                if (eventKey === $7c7b1a6f859720e7$var$KeyType.ArrowDown || eventKey === $7c7b1a6f859720e7$var$KeyType.ArrowUp || eventKey === $7c7b1a6f859720e7$var$KeyType.Enter) (_c = _this.onInputClick) === null || _c === void 0 || _c.call(_this);
                return;
            }
            if (_this.state.open && _this.props.showTimeSelectOnly) {
                if (eventKey === $7c7b1a6f859720e7$var$KeyType.ArrowDown || eventKey === $7c7b1a6f859720e7$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    _this.handleTimeOnlyArrowKey(eventKey);
                    return;
                }
                if (eventKey === $7c7b1a6f859720e7$var$KeyType.Enter) {
                    event.preventDefault();
                    _this.handleTimeOnlyEnterKey(event);
                    return;
                }
            }
            // if calendar is open, these keys will focus the selected item
            if (_this.state.open) {
                if (eventKey === $7c7b1a6f859720e7$var$KeyType.ArrowDown || eventKey === $7c7b1a6f859720e7$var$KeyType.ArrowUp) {
                    event.preventDefault();
                    var selectorString = _this.props.showTimeSelectOnly ? ".react-datepicker__time-list-item[tabindex='0']" : _this.props.showWeekPicker && _this.props.showWeekNumbers ? '.react-datepicker__week-number[tabindex="0"]' : _this.props.showFullMonthYearPicker || _this.props.showMonthYearPicker ? '.react-datepicker__month-text[tabindex="0"]' : '.react-datepicker__day[tabindex="0"]';
                    var selectedItem = ((_d = _this.calendar) === null || _d === void 0 ? void 0 : _d.containerRef.current) instanceof Element && _this.calendar.containerRef.current.querySelector(selectorString);
                    selectedItem instanceof HTMLElement && selectedItem.focus({
                        preventScroll: true
                    });
                    return;
                }
                var copy = $7c7b1a6f859720e7$var$newDate(_this.state.preSelection);
                if (eventKey === $7c7b1a6f859720e7$var$KeyType.Enter) {
                    event.preventDefault();
                    event.target.blur();
                    if (_this.inputOk() && _this.state.lastPreSelectChange === $7c7b1a6f859720e7$var$PRESELECT_CHANGE_VIA_NAVIGATE) {
                        _this.handleSelect(copy, event);
                        !_this.props.shouldCloseOnSelect && _this.setPreSelection(copy);
                    } else _this.setOpen(false);
                } else if (eventKey === $7c7b1a6f859720e7$var$KeyType.Escape) {
                    event.preventDefault();
                    event.target.blur();
                    _this.sendFocusBackToInput();
                    _this.setOpen(false);
                } else if (eventKey === $7c7b1a6f859720e7$var$KeyType.Tab) _this.setOpen(false);
                if (!_this.inputOk()) (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $7c7b1a6f859720e7$var$INPUT_ERR_1
                });
            }
        };
        _this.onPortalKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $7c7b1a6f859720e7$var$KeyType.Escape) {
                event.preventDefault();
                _this.setState({
                    preventFocus: true
                }, function() {
                    _this.setOpen(false);
                    setTimeout(function() {
                        _this.setFocus();
                        _this.setState({
                            preventFocus: false
                        });
                    });
                });
            }
        };
        // keyDown events passed down to day.jsx
        _this.onDayKeyDown = function(event) {
            var _a, _b, _c, _d, _e, _f;
            var _g = _this.props, minDate = _g.minDate, maxDate = _g.maxDate, disabledKeyboardNavigation = _g.disabledKeyboardNavigation, showWeekPicker = _g.showWeekPicker, shouldCloseOnSelect = _g.shouldCloseOnSelect, locale = _g.locale, calendarStartDay = _g.calendarStartDay, adjustDateOnChange = _g.adjustDateOnChange, inline = _g.inline;
            (_b = (_a = _this.props).onKeyDown) === null || _b === void 0 || _b.call(_a, event);
            if (disabledKeyboardNavigation) return;
            var eventKey = event.key;
            var isShiftKeyActive = event.shiftKey;
            var copy = $7c7b1a6f859720e7$var$newDate(_this.state.preSelection);
            var calculateNewDate = function(eventKey, date) {
                var newCalculatedDate = date;
                switch(eventKey){
                    case $7c7b1a6f859720e7$var$KeyType.ArrowRight:
                        newCalculatedDate = showWeekPicker ? (0, $65f6621a4d881172$export$ef501a2bb4f3ee6b)(date, 1) : (0, $f858e1fd107a3fca$export$dd412b56f1e4d8aa)(date, 1);
                        break;
                    case $7c7b1a6f859720e7$var$KeyType.ArrowLeft:
                        newCalculatedDate = showWeekPicker ? (0, $e5008eb0a28e1fd7$export$b4d8ae6376193efb)(date, 1) : (0, $b790179d217fe42b$export$70823084e2deb1ea)(date, 1);
                        break;
                    case $7c7b1a6f859720e7$var$KeyType.ArrowUp:
                        newCalculatedDate = (0, $e5008eb0a28e1fd7$export$b4d8ae6376193efb)(date, 1);
                        break;
                    case $7c7b1a6f859720e7$var$KeyType.ArrowDown:
                        newCalculatedDate = (0, $65f6621a4d881172$export$ef501a2bb4f3ee6b)(date, 1);
                        break;
                    case $7c7b1a6f859720e7$var$KeyType.PageUp:
                        newCalculatedDate = isShiftKeyActive ? (0, $9e4f2bf0d6114176$export$14867687ff6c92e2)(date, 1) : (0, $9ccdf5b091b4766d$export$73d1c15a21f9fae5)(date, 1);
                        break;
                    case $7c7b1a6f859720e7$var$KeyType.PageDown:
                        newCalculatedDate = isShiftKeyActive ? (0, $b4358f02f9e27928$export$3d83eec43f4ea476)(date, 1) : (0, $1e6165891d3337ed$export$17c93e242b2d3a22)(date, 1);
                        break;
                    case $7c7b1a6f859720e7$var$KeyType.Home:
                        newCalculatedDate = $7c7b1a6f859720e7$var$getStartOfWeek(date, locale, calendarStartDay);
                        break;
                    case $7c7b1a6f859720e7$var$KeyType.End:
                        newCalculatedDate = $7c7b1a6f859720e7$var$getEndOfWeek(date);
                        break;
                }
                return newCalculatedDate;
            };
            var getNewDate = function(eventKey, date) {
                var MAX_ITERATIONS = 40;
                var eventKeyCopy = eventKey;
                var validDateFound = false;
                var iterations = 0;
                var newSelection = calculateNewDate(eventKey, date);
                while(!validDateFound){
                    if (iterations >= MAX_ITERATIONS) {
                        newSelection = date;
                        break;
                    }
                    // if minDate exists and the new selection is before the min date, get the nearest date that isn't disabled
                    if (minDate && newSelection < minDate) {
                        eventKeyCopy = $7c7b1a6f859720e7$var$KeyType.ArrowRight;
                        newSelection = $7c7b1a6f859720e7$var$isDayDisabled(minDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : minDate;
                    }
                    // if maxDate exists and the new selection is after the max date, get the nearest date that isn't disabled
                    if (maxDate && newSelection > maxDate) {
                        eventKeyCopy = $7c7b1a6f859720e7$var$KeyType.ArrowLeft;
                        newSelection = $7c7b1a6f859720e7$var$isDayDisabled(maxDate, _this.props) ? calculateNewDate(eventKeyCopy, newSelection) : maxDate;
                    }
                    if ($7c7b1a6f859720e7$var$isDayDisabled(newSelection, _this.props)) {
                        // if PageUp and Home is pressed to a disabled date, it will try to find the next available date after
                        if (eventKeyCopy === $7c7b1a6f859720e7$var$KeyType.PageUp || eventKeyCopy === $7c7b1a6f859720e7$var$KeyType.Home) eventKeyCopy = $7c7b1a6f859720e7$var$KeyType.ArrowRight;
                        // if PageDown and End is pressed to a disabled date, it will try to find the next available date before
                        if (eventKeyCopy === $7c7b1a6f859720e7$var$KeyType.PageDown || eventKeyCopy === $7c7b1a6f859720e7$var$KeyType.End) eventKeyCopy = $7c7b1a6f859720e7$var$KeyType.ArrowLeft;
                        newSelection = calculateNewDate(eventKeyCopy, newSelection);
                    } else validDateFound = true;
                    iterations++;
                }
                return newSelection;
            };
            if (eventKey === $7c7b1a6f859720e7$var$KeyType.Enter) {
                event.preventDefault();
                _this.handleSelect(copy, event);
                !shouldCloseOnSelect && _this.setPreSelection(copy);
                return;
            } else if (eventKey === $7c7b1a6f859720e7$var$KeyType.Escape) {
                event.preventDefault();
                _this.setOpen(false);
                if (!_this.inputOk()) (_d = (_c = _this.props).onInputError) === null || _d === void 0 || _d.call(_c, {
                    code: 1,
                    msg: $7c7b1a6f859720e7$var$INPUT_ERR_1
                });
                return;
            }
            var newSelection = null;
            switch(eventKey){
                case $7c7b1a6f859720e7$var$KeyType.ArrowLeft:
                case $7c7b1a6f859720e7$var$KeyType.ArrowRight:
                case $7c7b1a6f859720e7$var$KeyType.ArrowUp:
                case $7c7b1a6f859720e7$var$KeyType.ArrowDown:
                case $7c7b1a6f859720e7$var$KeyType.PageUp:
                case $7c7b1a6f859720e7$var$KeyType.PageDown:
                case $7c7b1a6f859720e7$var$KeyType.Home:
                case $7c7b1a6f859720e7$var$KeyType.End:
                    newSelection = getNewDate(eventKey, copy);
                    break;
            }
            if (!newSelection) {
                (_f = (_e = _this.props).onInputError) === null || _f === void 0 || _f.call(_e, {
                    code: 1,
                    msg: $7c7b1a6f859720e7$var$INPUT_ERR_1
                });
                return;
            }
            event.preventDefault();
            _this.setState({
                lastPreSelectChange: $7c7b1a6f859720e7$var$PRESELECT_CHANGE_VIA_NAVIGATE
            });
            if (adjustDateOnChange) _this.setSelected(newSelection);
            _this.setPreSelection(newSelection);
            // In inline mode, always set shouldFocusDayInline to true when navigating via keyboard.
            // This ensures focus is properly transferred to the new day element regardless of
            // whether the month changed. The user initiated this navigation from a focused day,
            // so we should always focus the destination day.
            if (inline) _this.setState({
                shouldFocusDayInline: true
            });
        };
        // handle generic key down events in the popper that do not adjust or select dates
        // ex: while focusing prev and next month buttons
        _this.onPopperKeyDown = function(event) {
            var eventKey = event.key;
            if (eventKey === $7c7b1a6f859720e7$var$KeyType.Escape) {
                event.preventDefault();
                _this.sendFocusBackToInput();
                _this.setOpen(false);
            }
        };
        _this.onClearClick = function(event) {
            if (event) {
                if (event.preventDefault) event.preventDefault();
            }
            _this.sendFocusBackToInput();
            var _a = _this.props, selectsRange = _a.selectsRange, onChange = _a.onChange;
            if (selectsRange) onChange === null || onChange === void 0 || onChange([
                null,
                null
            ], event);
            else onChange === null || onChange === void 0 || onChange(null, event);
            _this.setState({
                inputValue: null
            });
        };
        _this.clear = function() {
            _this.onClearClick();
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeOnScroll === "boolean" && _this.props.closeOnScroll) {
                if (event.target === document || event.target === document.documentElement || event.target === document.body) _this.setOpen(false);
            } else if (typeof _this.props.closeOnScroll === "function") {
                if (_this.props.closeOnScroll(event)) _this.setOpen(false);
            }
        };
        _this.renderCalendar = function() {
            var _a, _b;
            if (!_this.props.inline && !_this.isCalendarOpen()) return null;
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$Calendar, $7c7b1a6f859720e7$var$_assign({
                showMonthYearDropdown: undefined,
                ref: function(elem) {
                    _this.calendar = elem;
                }
            }, _this.props, _this.state, {
                setOpen: _this.setOpen,
                dateFormat: (_a = _this.props.dateFormatCalendar) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormatCalendar,
                onSelect: _this.handleSelect,
                onClickOutside: _this.handleCalendarClickOutside,
                holidays: $7c7b1a6f859720e7$var$getHolidaysMap(_this.modifyHolidays()),
                outsideClickIgnoreClass: _this.props.outsideClickIgnoreClass,
                onDropdownFocus: _this.handleDropdownFocus,
                onTimeChange: _this.handleTimeChange,
                className: _this.props.calendarClassName,
                container: _this.props.calendarContainer,
                handleOnKeyDown: _this.props.onKeyDown,
                handleOnDayKeyDown: _this.onDayKeyDown,
                setPreSelection: _this.setPreSelection,
                dropdownMode: (_b = _this.props.dropdownMode) !== null && _b !== void 0 ? _b : DatePicker.defaultProps.dropdownMode
            }), _this.props.children);
        };
        _this.renderAriaLiveRegion = function() {
            var _a;
            var locale = _this.props.locale;
            var dateFormat = (_a = _this.props.dateFormat) !== null && _a !== void 0 ? _a : DatePicker.defaultProps.dateFormat;
            var isContainsTime = _this.props.showTimeInput || _this.props.showTimeSelect;
            var longDateFormat = isContainsTime ? "PPPPp" : "PPPP";
            var ariaLiveMessage;
            if (_this.props.selectsRange) ariaLiveMessage = "Selected start date: ".concat($7c7b1a6f859720e7$var$safeDateFormat(_this.props.startDate, {
                dateFormat: longDateFormat,
                locale: locale
            }), ". ").concat(_this.props.endDate ? "End date: " + $7c7b1a6f859720e7$var$safeDateFormat(_this.props.endDate, {
                dateFormat: longDateFormat,
                locale: locale
            }) : "");
            else {
                if (_this.props.showTimeSelectOnly) ariaLiveMessage = "Selected time: ".concat($7c7b1a6f859720e7$var$safeDateFormat(_this.props.selected, {
                    dateFormat: dateFormat,
                    locale: locale
                }));
                else if (_this.props.showYearPicker) ariaLiveMessage = "Selected year: ".concat($7c7b1a6f859720e7$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy",
                    locale: locale
                }));
                else if (_this.props.showMonthYearPicker) ariaLiveMessage = "Selected month: ".concat($7c7b1a6f859720e7$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "MMMM yyyy",
                    locale: locale
                }));
                else if (_this.props.showQuarterYearPicker) ariaLiveMessage = "Selected quarter: ".concat($7c7b1a6f859720e7$var$safeDateFormat(_this.props.selected, {
                    dateFormat: "yyyy, QQQ",
                    locale: locale
                }));
                else ariaLiveMessage = "Selected date: ".concat($7c7b1a6f859720e7$var$safeDateFormat(_this.props.selected, {
                    dateFormat: longDateFormat,
                    locale: locale
                }));
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
                role: "alert",
                "aria-live": "polite",
                className: "react-datepicker__aria-live"
            }, ariaLiveMessage);
        };
        _this.renderDateInput = function() {
            var _a, _b;
            var _c, _d, _e, _f;
            var className = (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(_this.props.className, (_a = {}, _a[_this.props.outsideClickIgnoreClass || DatePicker.defaultProps.outsideClickIgnoreClass] = _this.state.open, _a));
            var customInput = _this.props.customInput || (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", {
                type: "text"
            });
            var customInputRef = _this.props.customInputRef || "ref";
            // Build aria props object, only including defined values to avoid
            // overwriting aria attributes that may be set on the custom input
            var ariaProps = {};
            var ariaDescribedBy = (_c = _this.props["aria-describedby"]) !== null && _c !== void 0 ? _c : _this.props.ariaDescribedBy;
            var ariaInvalid = (_d = _this.props["aria-invalid"]) !== null && _d !== void 0 ? _d : _this.props.ariaInvalid;
            var ariaLabelledBy = (_e = _this.props["aria-labelledby"]) !== null && _e !== void 0 ? _e : _this.props.ariaLabelledBy;
            var ariaRequired = (_f = _this.props["aria-required"]) !== null && _f !== void 0 ? _f : _this.props.ariaRequired;
            if (ariaDescribedBy != null) ariaProps["aria-describedby"] = ariaDescribedBy;
            if (ariaInvalid != null) ariaProps["aria-invalid"] = ariaInvalid;
            if (ariaLabelledBy != null) ariaProps["aria-labelledby"] = ariaLabelledBy;
            if (ariaRequired != null) ariaProps["aria-required"] = ariaRequired;
            return (0, $7fPBF.cloneElement)(customInput, $7c7b1a6f859720e7$var$_assign((_b = {}, _b[customInputRef] = function(input) {
                _this.input = input;
            }, _b.value = _this.getInputValue(), _b.onBlur = _this.handleBlur, _b.onChange = _this.handleChange, _b.onClick = _this.onInputClick, _b.onFocus = _this.handleFocus, _b.onKeyDown = _this.onInputKeyDown, _b.id = _this.props.id, _b.name = _this.props.name, _b.form = _this.props.form, _b.autoFocus = _this.props.autoFocus, _b.placeholder = _this.props.placeholderText, _b.disabled = _this.props.disabled, _b.autoComplete = _this.props.autoComplete, _b.className = (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(customInput.props.className, className), _b.title = _this.props.title, _b.readOnly = _this.props.readOnly, _b.required = _this.props.required, _b.tabIndex = _this.props.tabIndex, _b), ariaProps));
        };
        _this.renderClearButton = function() {
            var _a = _this.props, isClearable = _a.isClearable, disabled = _a.disabled, selected = _a.selected, startDate = _a.startDate, endDate = _a.endDate, clearButtonTitle = _a.clearButtonTitle, _b = _a.clearButtonClassName, clearButtonClassName = _b === void 0 ? "" : _b, _c = _a.ariaLabelClose, ariaLabelClose = _c === void 0 ? "Close" : _c, selectedDates = _a.selectedDates, readOnly = _a.readOnly;
            if (isClearable && !readOnly && (selected != null || startDate != null || endDate != null || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length))) return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
                type: "button",
                className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)("react-datepicker__close-icon", clearButtonClassName, {
                    "react-datepicker__close-icon--disabled": disabled
                }),
                disabled: disabled,
                "aria-label": ariaLabelClose,
                onClick: _this.onClearClick,
                title: clearButtonTitle,
                tabIndex: -1
            });
            else return null;
        };
        _this.state = _this.calcInitialState();
        _this.preventFocusTimeout = undefined;
        return _this;
    }
    Object.defineProperty(DatePicker, "defaultProps", {
        get: function() {
            return {
                allowSameDay: false,
                dateFormat: "MM/dd/yyyy",
                dateFormatCalendar: "LLLL yyyy",
                disabled: false,
                disabledKeyboardNavigation: false,
                dropdownMode: "scroll",
                preventOpenOnFocus: false,
                monthsShown: 1,
                outsideClickIgnoreClass: $7c7b1a6f859720e7$var$OUTSIDE_CLICK_IGNORE_CLASS,
                readOnly: false,
                rangeSeparator: $7c7b1a6f859720e7$var$DATE_RANGE_SEPARATOR,
                withPortal: false,
                selectsDisabledDaysInRange: false,
                shouldCloseOnSelect: true,
                showTimeSelect: false,
                showTimeInput: false,
                showPreviousMonths: false,
                showMonthYearPicker: false,
                showFullMonthYearPicker: false,
                showTwoColumnMonthYearPicker: false,
                showFourColumnMonthYearPicker: false,
                showYearPicker: false,
                showQuarterYearPicker: false,
                showWeekPicker: false,
                strictParsing: false,
                swapRange: false,
                timeIntervals: 30,
                timeCaption: "Time",
                previousMonthAriaLabel: "Previous Month",
                previousMonthButtonLabel: "Previous Month",
                nextMonthAriaLabel: "Next Month",
                nextMonthButtonLabel: "Next Month",
                previousYearAriaLabel: "Previous Year",
                previousYearButtonLabel: "Previous Year",
                nextYearAriaLabel: "Next Year",
                nextYearButtonLabel: "Next Year",
                timeInputLabel: "Time",
                enableTabLoop: true,
                yearItemNumber: $7c7b1a6f859720e7$var$DEFAULT_YEAR_ITEM_NUMBER,
                focusSelectedMonth: false,
                showPopperArrow: true,
                excludeScrollbar: true,
                customTimeInput: null,
                calendarStartDay: undefined,
                toggleCalendarOnIconClick: false,
                usePointerEvent: false
            };
        },
        enumerable: false,
        configurable: true
    });
    DatePicker.prototype.componentDidMount = function() {
        window.addEventListener("scroll", this.onScroll, true);
        document.addEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.componentDidUpdate = function(prevProps, prevState) {
        var _a, _b, _c, _d;
        if (prevProps.inline && $7c7b1a6f859720e7$var$hasPreSelectionChanged(prevProps.selected, this.props.selected)) this.setPreSelection(this.props.selected);
        if (this.state.monthSelectedIn !== undefined && prevProps.monthsShown !== this.props.monthsShown) this.setState({
            monthSelectedIn: 0
        });
        if (this.props.selectsRange && this.state.monthSelectedIn !== 0) this.setState({
            monthSelectedIn: 0
        });
        if (prevProps.highlightDates !== this.props.highlightDates) this.setState({
            highlightDates: $7c7b1a6f859720e7$var$getHighLightDaysMap(this.props.highlightDates)
        });
        if (!prevState.focused && !$7c7b1a6f859720e7$var$isEqual(prevProps.selected, this.props.selected)) this.setState({
            inputValue: null
        });
        if (prevState.open !== this.state.open) {
            if (prevState.open === false && this.state.open === true) (_b = (_a = this.props).onCalendarOpen) === null || _b === void 0 || _b.call(_a);
            if (prevState.open === true && this.state.open === false) (_d = (_c = this.props).onCalendarClose) === null || _d === void 0 || _d.call(_c);
        }
    };
    DatePicker.prototype.componentWillUnmount = function() {
        this.clearPreventFocusTimeout();
        window.removeEventListener("scroll", this.onScroll, true);
        document.removeEventListener("visibilitychange", this.setHiddenStateOnVisibilityHidden);
    };
    DatePicker.prototype.renderInputContainer = function() {
        var _a = this.props, showIcon = _a.showIcon, icon = _a.icon, calendarIconClassname = _a.calendarIconClassname, calendarIconClassName = _a.calendarIconClassName, toggleCalendarOnIconClick = _a.toggleCalendarOnIconClick;
        var open = this.state.open;
        if (calendarIconClassname) console.warn("calendarIconClassname props is deprecated. should use calendarIconClassName props.");
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: "react-datepicker__input-container".concat(showIcon ? " react-datepicker__view-calendar-icon" : "")
        }, showIcon && (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$CalendarIcon, $7c7b1a6f859720e7$var$_assign({
            icon: icon,
            className: (0, $07a883fe7c352c85$export$4f5d2d50c9deca37)(calendarIconClassName, !calendarIconClassName && calendarIconClassname, open && "react-datepicker-ignore-onclickoutside")
        }, toggleCalendarOnIconClick ? {
            onClick: this.toggleCalendar
        } : null)), this.state.isRenderAriaLiveMessage && this.renderAriaLiveRegion(), this.renderDateInput(), this.renderClearButton());
    };
    DatePicker.prototype.render = function() {
        var calendar = this.renderCalendar();
        if (this.props.inline) return calendar;
        if (this.props.withPortal) {
            var portalContainer = this.state.open ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$TabLoop, {
                enableTabLoop: this.props.enableTabLoop
            }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
                className: "react-datepicker__portal",
                tabIndex: -1,
                onKeyDown: this.onPortalKeyDown
            }, calendar)) : null;
            if (this.state.open && this.props.portalId) portalContainer = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$Portal, $7c7b1a6f859720e7$var$_assign({
                portalId: this.props.portalId
            }, this.props), portalContainer);
            return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null, this.renderInputContainer(), portalContainer);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7c7b1a6f859720e7$var$PopperComponent, $7c7b1a6f859720e7$var$_assign({}, this.props, {
            className: this.props.popperClassName,
            hidePopper: !this.isCalendarOpen(),
            targetComponent: this.renderInputContainer(),
            popperComponent: calendar,
            popperOnKeyDown: this.onPopperKeyDown,
            showArrow: this.props.showPopperArrow
        }));
    };
    return DatePicker;
}((0, $7fPBF.Component));
var $7c7b1a6f859720e7$var$PRESELECT_CHANGE_VIA_INPUT = "input";
var $7c7b1a6f859720e7$var$PRESELECT_CHANGE_VIA_NAVIGATE = "navigate";











class $97638f75b6ce75cf$export$2e2bcd8739ae039 {
    // A page of a campus's services in one category, newest first. No
    // `categoryID` means the campus's uncategorized services, not every service
    // at the campus. Pass a page's `nextLastServiceID` as `lastServiceID` for the
    // page after it.
    //
    // Only past services are public; `includeUpcoming` adds scheduled ones and
    // needs the Service Manager role.
    static async fetchServices(churchID, campusID, categoryID, includeUpcoming, lastServiceID, auth) {
        const query = new URLSearchParams();
        if (categoryID) query.set('categoryID', categoryID);
        if (includeUpcoming) query.set('includeUpcoming', 'true');
        if (lastServiceID) query.set('lastServiceID', lastServiceID);
        const queryString = query.toString();
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/campus/${campusID}/library/service${queryString ? `?${queryString}` : ''}`), auth.consumeRefreshToken);
    }
    // One service by ID, wherever it's filed. An upcoming service is only
    // returned to staff who manage services; to anyone else, like a missing one,
    // it's a 404.
    static async fetchService(churchID, serviceID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/library/service/${serviceID}`), auth.consumeRefreshToken);
    }
    // Creates a service at `attributes.campusID`. Needs the Service Manager
    // role, and the same uploaded thumbnail as an update.
    static async createService(churchID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/campus/${attributes.campusID}/library/service`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    // Replaces the service's attributes with `attributes`, which must be
    // complete. Needs the Service Manager role. The thumbnail has to be one
    // uploaded through uploadLibraryThumbnail.
    //
    // The path names the campus the service ends up at, which Sanctuary requires
    // to match `attributes.campusID`; a different one from its current campus
    // moves it.
    static async updateService(churchID, service, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/campus/${attributes.campusID}/library/service/${service.id}`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    // Permanently removes a service. Needs the Service Manager role; a service
    // that's already gone is a 404.
    static async deleteService(churchID, serviceID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/library/service/${serviceID}`), auth.consumeRefreshToken);
    }
}
$97638f75b6ce75cf$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";



var $7fPBF = parcelRequire("7fPBF");


const $2e7a6464932056f2$var$HTTP_NOT_FOUND = 404;
function $2e7a6464932056f2$export$2e2bcd8739ae039(serviceID) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    const [service, setService] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(serviceID !== null);
    const [hasLoaded, setHasLoaded] = (0, $7fPBF.useState)(false);
    const [notFound, setNotFound] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    // Only the latest request's answer is kept, if the ID changes mid-flight.
    const latestRequest = (0, $7fPBF.useRef)(0);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchID || !serviceID) return;
        const request = ++latestRequest.current;
        setLoading(true);
        setError(null);
        setNotFound(false);
        const response = await (0, $97638f75b6ce75cf$export$2e2bcd8739ae039).fetchService(churchID, serviceID, auth);
        if (request !== latestRequest.current) return;
        if (response.status === $2e7a6464932056f2$var$HTTP_NOT_FOUND) {
            setService(null);
            setNotFound(true);
        } else if (response.error || !response.body) {
            setService(null);
            setError(response.error || 'Failed to load this service.');
        } else setService(response.body);
        setLoading(false);
        setHasLoaded(true);
    }, [
        churchID,
        serviceID,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        latestRequest.current++;
        setService(null);
        setHasLoaded(false);
        setNotFound(false);
        setError(null);
        if (!serviceID) {
            setLoading(false);
            return;
        }
        fetch();
    }, [
        serviceID,
        fetch
    ]);
    return {
        service: service,
        loading: loading,
        hasLoaded: hasLoaded,
        notFound: notFound,
        error: error,
        refetch: fetch
    };
}





var $7fPBF = parcelRequire("7fPBF");


class $354a777975e62edf$export$2e2bcd8739ae039 {
    // A page of a campus's series in one category, newest start date first. No
    // `categoryID` means the campus's uncategorized series, as with services.
    // Pass a page's `nextLastSeriesID` as `lastSeriesID` for the one after.
    static async fetchSeriesPage(churchID, campusID, categoryID, lastSeriesID, auth) {
        const query = new URLSearchParams();
        if (categoryID) query.set('categoryID', categoryID);
        if (lastSeriesID) query.set('lastSeriesID', lastSeriesID);
        const queryString = query.toString();
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/campus/${campusID}/library/series${queryString ? `?${queryString}` : ''}`), auth.consumeRefreshToken);
    }
    // A series with one page of its services, newest first. Scoped to the
    // campus: a series filed under another one is a 404, like a missing one.
    // Only past services are public; `includeUpcoming` adds scheduled ones and
    // needs the Service Manager role.
    static async fetchSeries(churchID, campusID, seriesID, includeUpcoming, lastServiceID, auth) {
        const query = new URLSearchParams();
        if (includeUpcoming) query.set('includeUpcoming', 'true');
        if (lastServiceID) query.set('lastServiceID', lastServiceID);
        const queryString = query.toString();
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/campus/${campusID}/library/series/${seriesID}${queryString ? `?${queryString}` : ''}`), auth.consumeRefreshToken);
    }
    // Creates a series at `attributes.campusID`. Needs the Service Manager role;
    // the thumbnail has to be one uploaded through uploadLibraryThumbnail.
    static async createSeries(churchID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/campus/${attributes.campusID}/library/series`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    // Replaces a series' attributes, which must be complete. The path names the
    // campus it ends up at, moving it if that's a different one; its services
    // stay in it.
    static async updateSeries(churchID, seriesID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/campus/${attributes.campusID}/library/series/${seriesID}`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    // Deletes a series. Its services aren't deleted; they're taken out of it.
    static async deleteSeries(churchID, seriesID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/library/series/${seriesID}`), auth.consumeRefreshToken);
    }
}
$354a777975e62edf$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";





var $7fPBF = parcelRequire("7fPBF");
function $46e12f9e434dd2e4$export$2e2bcd8739ae039(key, fetchPage) {
    const [loaded, setLoaded] = (0, $7fPBF.useState)(null);
    const [isLoadingMore, setIsLoadingMore] = (0, $7fPBF.useState)(false);
    // A refetch of the query already shown, which keeps showing it meanwhile.
    const [isRefetching, setIsRefetching] = (0, $7fPBF.useState)(false);
    // Read through a ref so callers can pass an inline function without it
    // counting as a new query every render; `key` is what says that.
    const fetchPageRef = (0, $7fPBF.useRef)(fetchPage);
    fetchPageRef.current = fetchPage;
    const latestRequest = (0, $7fPBF.useRef)(0);
    const load = (0, $7fPBF.useCallback)(async (cursor)=>{
        if (key === null) return;
        const request = ++latestRequest.current;
        const isFirstPage = cursor === null;
        if (isFirstPage) setIsRefetching(true);
        else setIsLoadingMore(true);
        const result = await fetchPageRef.current(cursor);
        // A newer request, or a different query, has taken over.
        if (request !== latestRequest.current) return;
        setLoaded((current)=>{
            const previous = (current === null || current === void 0 ? void 0 : current.key) === key ? current : null;
            var _result_status, _result_status1;
            if ('error' in result) // A failed Load More keeps the pages already shown.
            return isFirstPage || !previous ? {
                key: key,
                items: [],
                extra: null,
                hasMore: false,
                next: null,
                error: result.error,
                errorStatus: (_result_status = result.status) !== null && _result_status !== void 0 ? _result_status : null
            } : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, previous), {
                error: result.error,
                errorStatus: (_result_status1 = result.status) !== null && _result_status1 !== void 0 ? _result_status1 : null
            });
            var _previous_extra;
            return {
                key: key,
                // The first page replaces, so a refetch doesn't duplicate rows.
                items: isFirstPage || !previous ? result.items : [
                    ...previous.items,
                    ...result.items
                ],
                extra: result.extra !== undefined ? result.extra : (_previous_extra = previous === null || previous === void 0 ? void 0 : previous.extra) !== null && _previous_extra !== void 0 ? _previous_extra : null,
                hasMore: result.hasMore && Boolean(result.next),
                next: result.next,
                error: null,
                errorStatus: null
            };
        });
        if (isFirstPage) setIsRefetching(false);
        else setIsLoadingMore(false);
    }, [
        key
    ]);
    (0, $7fPBF.useEffect)(()=>{
        // Anything still in flight belongs to the old query.
        latestRequest.current++;
        setIsLoadingMore(false);
        setIsRefetching(false);
        if (key !== null) load(null);
    }, [
        key,
        load
    ]);
    const current = key !== null && (loaded === null || loaded === void 0 ? void 0 : loaded.key) === key ? loaded : null;
    var _current_hasMore;
    const hasMore = (_current_hasMore = current === null || current === void 0 ? void 0 : current.hasMore) !== null && _current_hasMore !== void 0 ? _current_hasMore : false;
    var _current_next;
    const next = (_current_next = current === null || current === void 0 ? void 0 : current.next) !== null && _current_next !== void 0 ? _current_next : null;
    const loadMore = (0, $7fPBF.useCallback)(()=>{
        if (!hasMore || isLoadingMore || !next) return;
        load(next);
    }, [
        hasMore,
        isLoadingMore,
        next,
        load
    ]);
    const refetch = (0, $7fPBF.useCallback)(()=>load(null), [
        load
    ]);
    var _current_items, _current_extra, _current_error, _current_errorStatus;
    return {
        items: (_current_items = current === null || current === void 0 ? void 0 : current.items) !== null && _current_items !== void 0 ? _current_items : [],
        extra: (_current_extra = current === null || current === void 0 ? void 0 : current.extra) !== null && _current_extra !== void 0 ? _current_extra : null,
        // True from the first render with a new key until its first page is in,
        // and again during a refetch.
        loading: key !== null && current === null || isRefetching,
        hasLoaded: current !== null,
        error: (_current_error = current === null || current === void 0 ? void 0 : current.error) !== null && _current_error !== void 0 ? _current_error : null,
        errorStatus: (_current_errorStatus = current === null || current === void 0 ? void 0 : current.errorStatus) !== null && _current_errorStatus !== void 0 ? _current_errorStatus : null,
        hasMore: hasMore,
        isLoadingMore: isLoadingMore,
        loadMore: loadMore,
        refetch: refetch
    };
}



const $0839360f84148e9b$var$HTTP_NOT_FOUND = 404;
function $0839360f84148e9b$export$5a8ecf1f06a8addb(campusID, categoryID) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    const key = churchID && campusID ? `${campusID}|${categoryID !== null && categoryID !== void 0 ? categoryID : ''}` : null;
    const list = (0, $46e12f9e434dd2e4$export$2e2bcd8739ae039)(key, async (cursor)=>{
        const response = await (0, $354a777975e62edf$export$2e2bcd8739ae039).fetchSeriesPage(churchID, campusID, categoryID, cursor, auth);
        const body = response.body;
        if (response.error || !body) return {
            error: response.error || 'Failed to load series.',
            status: response.status
        };
        var _body_results, _body_nextLastSeriesID;
        return {
            items: (_body_results = body.results) !== null && _body_results !== void 0 ? _body_results : [],
            hasMore: body.hasMore === true,
            next: (_body_nextLastSeriesID = body.nextLastSeriesID) !== null && _body_nextLastSeriesID !== void 0 ? _body_nextLastSeriesID : null
        };
    });
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, list), {
        series: list.items
    });
}
function $0839360f84148e9b$export$5ca726549f7e2446(campusID, seriesID) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    // Staff who manage services also see the series' upcoming services.
    const includeUpcoming = auth.hasPermission((0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_SERVICES);
    const key = churchID && campusID && seriesID ? `${campusID}|${seriesID}|${includeUpcoming}` : null;
    const list = (0, $46e12f9e434dd2e4$export$2e2bcd8739ae039)(key, async (cursor)=>{
        var _body_services, _body_services1, _body_services2;
        const response = await (0, $354a777975e62edf$export$2e2bcd8739ae039).fetchSeries(churchID, campusID, seriesID, includeUpcoming, cursor, auth);
        const body = response.body;
        if (response.error || !body) return {
            error: response.error || 'Failed to load this series.',
            status: response.status
        };
        var _body_services_results, _body_services_nextLastServiceID;
        return {
            items: (_body_services_results = (_body_services = body.services) === null || _body_services === void 0 ? void 0 : _body_services.results) !== null && _body_services_results !== void 0 ? _body_services_results : [],
            hasMore: ((_body_services1 = body.services) === null || _body_services1 === void 0 ? void 0 : _body_services1.hasMore) === true,
            next: (_body_services_nextLastServiceID = (_body_services2 = body.services) === null || _body_services2 === void 0 ? void 0 : _body_services2.nextLastServiceID) !== null && _body_services_nextLastServiceID !== void 0 ? _body_services_nextLastServiceID : null,
            extra: body.series
        };
    });
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, list), {
        series: list.extra,
        services: list.items,
        notFound: list.errorStatus === $0839360f84148e9b$var$HTTP_NOT_FOUND
    });
}
function $0839360f84148e9b$export$4f814464c617a55b(campusID, seriesID) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    const key = churchID && campusID && seriesID ? `${campusID}|${seriesID}` : null;
    const [loaded, setLoaded] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (!key) return;
        let isCancelled = false;
        (0, $354a777975e62edf$export$2e2bcd8739ae039).fetchSeries(churchID, campusID, seriesID, false, null, auth).then((response)=>{
            var _response_body;
            if (isCancelled) return;
            var _response_body_series;
            setLoaded({
                key: key,
                series: (_response_body_series = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.series) !== null && _response_body_series !== void 0 ? _response_body_series : null
            });
        });
        return ()=>{
            isCancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        key,
        auth
    ]);
    const isCurrent = key !== null && (loaded === null || loaded === void 0 ? void 0 : loaded.key) === key;
    return {
        series: isCurrent ? loaded.series : null,
        loading: key !== null && !isCurrent
    };
}





var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");
// A date picker's trigger, for react-datepicker's `customInput`. A button
// rather than the picker's own text input, so it's exactly as wide as the date
// it shows instead of a fixed box with the date pushed to one side. The picker
// hands it the formatted value and its open handler.
const $c40eac2834ad20c3$var$DateButton = /*#__PURE__*/ (0, $7fPBF.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: "date-button",
        disabled: props.disabled,
        onClick: props.onClick,
        children: props.value || 'Choose a date'
    });
});
var $c40eac2834ad20c3$export$2e2bcd8739ae039 = $c40eac2834ad20c3$var$DateButton;


// A date as Sanctuary parses it: ISO 8601 without the fractional seconds that
// toISOString always includes.
function $af166244e46ffe4e$export$2508653e5b52dd4d(date) {
    return date.toISOString().replace(/\.\d{3}Z$/, 'Z');
}



var $95905311ad8ad743$var$q = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "#",
    "$",
    "%",
    "*",
    "+",
    ",",
    "-",
    ".",
    ":",
    ";",
    "=",
    "?",
    "@",
    "[",
    "]",
    "^",
    "_",
    "{",
    "|",
    "}",
    "~"
], $95905311ad8ad743$var$x = (t)=>{
    let e = 0;
    for(let r = 0; r < t.length; r++){
        let n = t[r], l = $95905311ad8ad743$var$q.indexOf(n);
        e = e * 83 + l;
    }
    return e;
}, $95905311ad8ad743$var$p = (t, e)=>{
    var r = "";
    for(let n = 1; n <= e; n++){
        let l = Math.floor(t) / Math.pow(83, e - n) % 83;
        r += $95905311ad8ad743$var$q[Math.floor(l)];
    }
    return r;
};
var $95905311ad8ad743$var$f = (t)=>{
    let e = t / 255;
    return e <= .04045 ? e / 12.92 : Math.pow((e + .055) / 1.055, 2.4);
}, $95905311ad8ad743$var$h = (t)=>{
    let e = Math.max(0, Math.min(1, t));
    return e <= .0031308 ? Math.trunc(e * 3294.6 + .5) : Math.trunc((1.055 * Math.pow(e, .4166666666666667) - .055) * 255 + .5);
}, $95905311ad8ad743$var$F = (t)=>t < 0 ? -1 : 1, $95905311ad8ad743$var$M = (t, e)=>$95905311ad8ad743$var$F(t) * Math.pow(Math.abs(t), e);
var $95905311ad8ad743$export$2191b9da168c6cf0 = class extends Error {
    constructor(e){
        super(e), this.name = "ValidationError", this.message = e;
    }
};
var $95905311ad8ad743$var$C = (t)=>{
    if (!t || t.length < 6) throw new $95905311ad8ad743$export$2191b9da168c6cf0("The blurhash string must be at least 6 characters");
    let e = $95905311ad8ad743$var$x(t[0]), r = Math.floor(e / 9) + 1, n = e % 9 + 1;
    if (t.length !== 4 + 2 * n * r) throw new $95905311ad8ad743$export$2191b9da168c6cf0(`blurhash length mismatch: length is ${t.length} but it should be ${4 + 2 * n * r}`);
}, $95905311ad8ad743$export$dd2c1290f799dc27 = (t)=>{
    try {
        $95905311ad8ad743$var$C(t);
    } catch (e) {
        return {
            result: !1,
            errorReason: e.message
        };
    }
    return {
        result: !0
    };
}, $95905311ad8ad743$var$z = (t)=>{
    let e = t >> 16, r = t >> 8 & 255, n = t & 255;
    return [
        $95905311ad8ad743$var$f(e),
        $95905311ad8ad743$var$f(r),
        $95905311ad8ad743$var$f(n)
    ];
}, $95905311ad8ad743$var$L = (t, e)=>{
    let r = Math.floor(t / 361), n = Math.floor(t / 19) % 19, l = t % 19;
    return [
        $95905311ad8ad743$var$M((r - 9) / 9, 2) * e,
        $95905311ad8ad743$var$M((n - 9) / 9, 2) * e,
        $95905311ad8ad743$var$M((l - 9) / 9, 2) * e
    ];
}, $95905311ad8ad743$var$U = (t, e, r, n)=>{
    $95905311ad8ad743$var$C(t), n = n | 1;
    let l = $95905311ad8ad743$var$x(t[0]), m = Math.floor(l / 9) + 1, b = l % 9 + 1, i = ($95905311ad8ad743$var$x(t[1]) + 1) / 166, u = new Array(b * m);
    for(let o = 0; o < u.length; o++)if (o === 0) {
        let a = $95905311ad8ad743$var$x(t.substring(2, 6));
        u[o] = $95905311ad8ad743$var$z(a);
    } else {
        let a = $95905311ad8ad743$var$x(t.substring(4 + o * 2, 6 + o * 2));
        u[o] = $95905311ad8ad743$var$L(a, i * n);
    }
    let c = e * 4, s = new Uint8ClampedArray(c * r);
    for(let o = 0; o < r; o++)for(let a = 0; a < e; a++){
        let y = 0, B = 0, R = 0;
        for(let w = 0; w < m; w++)for(let P = 0; P < b; P++){
            let G = Math.cos(Math.PI * a * P / e) * Math.cos(Math.PI * o * w / r), T = u[P + w * b];
            y += T[0] * G, B += T[1] * G, R += T[2] * G;
        }
        let V = $95905311ad8ad743$var$h(y), I = $95905311ad8ad743$var$h(B), E = $95905311ad8ad743$var$h(R);
        s[4 * a + 0 + o * c] = V, s[4 * a + 1 + o * c] = I, s[4 * a + 2 + o * c] = E, s[4 * a + 3 + o * c] = 255;
    }
    return s;
}, $95905311ad8ad743$export$2f872c0f2117be69 = $95905311ad8ad743$var$U;
var $95905311ad8ad743$var$A = 4, $95905311ad8ad743$var$D = (t, e, r, n)=>{
    let l = 0, m = 0, b = 0, g = e * $95905311ad8ad743$var$A;
    for(let u = 0; u < e; u++){
        let c = $95905311ad8ad743$var$A * u;
        for(let s = 0; s < r; s++){
            let o = c + s * g, a = n(u, s);
            l += a * $95905311ad8ad743$var$f(t[o]), m += a * $95905311ad8ad743$var$f(t[o + 1]), b += a * $95905311ad8ad743$var$f(t[o + 2]);
        }
    }
    let i = 1 / (e * r);
    return [
        l * i,
        m * i,
        b * i
    ];
}, $95905311ad8ad743$var$$ = (t)=>{
    let e = $95905311ad8ad743$var$h(t[0]), r = $95905311ad8ad743$var$h(t[1]), n = $95905311ad8ad743$var$h(t[2]);
    return (e << 16) + (r << 8) + n;
}, $95905311ad8ad743$var$H = (t, e)=>{
    let r = Math.floor(Math.max(0, Math.min(18, Math.floor($95905311ad8ad743$var$M(t[0] / e, .5) * 9 + 9.5)))), n = Math.floor(Math.max(0, Math.min(18, Math.floor($95905311ad8ad743$var$M(t[1] / e, .5) * 9 + 9.5)))), l = Math.floor(Math.max(0, Math.min(18, Math.floor($95905311ad8ad743$var$M(t[2] / e, .5) * 9 + 9.5))));
    return r * 361 + n * 19 + l;
}, $95905311ad8ad743$var$O = (t, e, r, n, l)=>{
    if (n < 1 || n > 9 || l < 1 || l > 9) throw new $95905311ad8ad743$export$2191b9da168c6cf0("BlurHash must have between 1 and 9 components");
    if (e * r * 4 !== t.length) throw new $95905311ad8ad743$export$2191b9da168c6cf0("Width and height must match the pixels array");
    let m = [];
    for(let s = 0; s < l; s++)for(let o = 0; o < n; o++){
        let a = o == 0 && s == 0 ? 1 : 2, y = $95905311ad8ad743$var$D(t, e, r, (B, R)=>a * Math.cos(Math.PI * o * B / e) * Math.cos(Math.PI * s * R / r));
        m.push(y);
    }
    let b = m[0], g = m.slice(1), i = "", u = n - 1 + (l - 1) * 9;
    i += $95905311ad8ad743$var$p(u, 1);
    let c;
    if (g.length > 0) {
        let s = Math.max(...g.map((a)=>Math.max(...a))), o = Math.floor(Math.max(0, Math.min(82, Math.floor(s * 166 - .5))));
        c = (o + 1) / 166, i += $95905311ad8ad743$var$p(o, 1);
    } else c = 1, i += $95905311ad8ad743$var$p(0, 1);
    return i += $95905311ad8ad743$var$p($95905311ad8ad743$var$$(b), 4), g.forEach((s)=>{
        i += $95905311ad8ad743$var$p($95905311ad8ad743$var$H(s, c), 2);
    }), i;
}, $95905311ad8ad743$export$c564cdbbe6da493 = $95905311ad8ad743$var$O;


// Encoding reads every pixel once per component, so it runs on a small copy:
// 64x36 hashes in a few milliseconds, where a full-size photo takes seconds and
// gives essentially the same result.
const $e151957c6f3bfebc$var$ENCODE_WIDTH = 64;
const $e151957c6f3bfebc$var$ENCODE_HEIGHT = 36;
// 4x3 is BlurHash's suggested balance for landscape images.
const $e151957c6f3bfebc$var$COMPONENTS_X = 4;
const $e151957c6f3bfebc$var$COMPONENTS_Y = 3;
async function $e151957c6f3bfebc$export$164ac2c54c56b877(file) {
    try {
        const bitmap = await createImageBitmap(file);
        const canvas = document.createElement('canvas');
        canvas.width = $e151957c6f3bfebc$var$ENCODE_WIDTH;
        canvas.height = $e151957c6f3bfebc$var$ENCODE_HEIGHT;
        const context = canvas.getContext('2d');
        if (!context) {
            bitmap.close();
            return null;
        }
        // Covers the canvas, overflowing evenly on whichever axis is too long.
        const scale = Math.max($e151957c6f3bfebc$var$ENCODE_WIDTH / bitmap.width, $e151957c6f3bfebc$var$ENCODE_HEIGHT / bitmap.height);
        const drawWidth = bitmap.width * scale;
        const drawHeight = bitmap.height * scale;
        context.drawImage(bitmap, ($e151957c6f3bfebc$var$ENCODE_WIDTH - drawWidth) / 2, ($e151957c6f3bfebc$var$ENCODE_HEIGHT - drawHeight) / 2, drawWidth, drawHeight);
        bitmap.close();
        const { data: data } = context.getImageData(0, 0, $e151957c6f3bfebc$var$ENCODE_WIDTH, $e151957c6f3bfebc$var$ENCODE_HEIGHT);
        return (0, $95905311ad8ad743$export$c564cdbbe6da493)(data, $e151957c6f3bfebc$var$ENCODE_WIDTH, $e151957c6f3bfebc$var$ENCODE_HEIGHT, $e151957c6f3bfebc$var$COMPONENTS_X, $e151957c6f3bfebc$var$COMPONENTS_Y);
    } catch (e) {
        return null;
    }
}


const $107fb90fbf824423$var$UPLOAD_FAILED = "The thumbnail couldn't be uploaded. Please try again.";
async function $107fb90fbf824423$export$2966bceab4a48a87(churchID, file, assetType, auth) {
    const blurHash = (0, $e151957c6f3bfebc$export$164ac2c54c56b877)(file);
    const contentType = file.type || 'application/octet-stream';
    const target = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt("https://sanctuary-api.saltplatform.com", new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/assets/upload-target`, {
        assetType: assetType,
        contentType: contentType,
        fileSizeBytes: file.size
    }), auth.consumeRefreshToken);
    if (!target.body) return {
        error: target.error || $107fb90fbf824423$var$UPLOAD_FAILED
    };
    const uploaded = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performSignedPost({
        url: target.body.url,
        fields: target.body.fields
    }, file, contentType);
    if (!uploaded) return {
        error: $107fb90fbf824423$var$UPLOAD_FAILED
    };
    return {
        thumbnail: {
            url: target.body.assetURL,
            blurHash: await blurHash
        }
    };
}




function $1ebd48de221e02da$export$2e2bcd8739ae039(props) {
    var _props_series;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { campuses: campuses, categories: categories } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const existing = (_props_series = props.series) === null || _props_series === void 0 ? void 0 : _props_series.attributes;
    const isEditing = Boolean(props.series);
    // Only a campus and category that still exist are carried in, so a stale
    // link can't preset one the pickers don't offer.
    const initialCampusID = campuses.some((campus)=>campus.id === props.initialCampusID) ? props.initialCampusID : campuses.length === 1 ? campuses[0].id : null;
    const initialCategoryID = categories.some((category)=>category.id === props.initialCategoryID) ? props.initialCategoryID : null;
    var _existing_name;
    const [name, setName] = (0, $7fPBF.useState)((_existing_name = existing === null || existing === void 0 ? void 0 : existing.name) !== null && _existing_name !== void 0 ? _existing_name : '');
    var _existing_campusID, _ref;
    const [campusID, setCampusID] = (0, $7fPBF.useState)((_ref = (_existing_campusID = existing === null || existing === void 0 ? void 0 : existing.campusID) !== null && _existing_campusID !== void 0 ? _existing_campusID : initialCampusID) !== null && _ref !== void 0 ? _ref : '');
    var _existing_categoryID, _ref1;
    const [categoryID, setCategoryID] = (0, $7fPBF.useState)((_ref1 = (_existing_categoryID = existing === null || existing === void 0 ? void 0 : existing.categoryID) !== null && _existing_categoryID !== void 0 ? _existing_categoryID : initialCategoryID) !== null && _ref1 !== void 0 ? _ref1 : '');
    // Series are listed newest first by this. A new one starts today, the
    // likeliest start for one being set up.
    const [startDate, setStartDate] = (0, $7fPBF.useState)(()=>{
        if (existing === null || existing === void 0 ? void 0 : existing.startDate) {
            const stored = new Date(existing.startDate);
            return Number.isNaN(stored.getTime()) ? null : stored;
        }
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return today;
    });
    // The thumbnail and its hash travel together, so one never describes the
    // other's image.
    const [thumbnail, setThumbnail] = (0, $7fPBF.useState)((existing === null || existing === void 0 ? void 0 : existing.thumbnailURL) ? {
        url: existing.thumbnailURL,
        blurHash: existing.thumbnailBlurHash
    } : null);
    const [isUploading, setIsUploading] = (0, $7fPBF.useState)(false);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fileInputRef = (0, $7fPBF.useRef)(null);
    const sortedCampuses = [
        ...campuses
    ].sort((one, two)=>one.attributes.name.localeCompare(two.attributes.name));
    const sortedCategories = [
        ...categories
    ].sort((one, two)=>one.name.localeCompare(two.name));
    const trimmedName = name.trim();
    const isBusy = isSaving || isUploading;
    const canSave = trimmedName.length > 0 && campusID.length > 0 && startDate !== null && !isBusy;
    const upload = async (file)=>{
        if (!auth.churchId) return;
        setIsUploading(true);
        setError(null);
        try {
            const result = await (0, $107fb90fbf824423$export$2966bceab4a48a87)(auth.churchId, file, 'series', auth);
            if (!result.thumbnail) {
                var _result_error;
                setError((_result_error = result.error) !== null && _result_error !== void 0 ? _result_error : "The thumbnail couldn't be uploaded. Please try again.");
                return;
            }
            setThumbnail(result.thumbnail);
        } finally{
            setIsUploading(false);
        }
    };
    const save = async ()=>{
        if (!auth.churchId) {
            setError('Missing church context. Please refresh and try again.');
            return;
        }
        if (!canSave || !startDate) return;
        setIsSaving(true);
        setError(null);
        var _existing_name, _localizedValue, _thumbnail_url, _thumbnail_blurHash;
        const attributes = {
            campusID: campusID,
            categoryID: categoryID || null,
            startDate: (0, $af166244e46ffe4e$export$2508653e5b52dd4d)(startDate),
            // An edit replaces only the translation shown, keeping the others.
            name: (_localizedValue = (0, $dc203b94917c8ff8$export$74edb9599ed878c7)((_existing_name = existing === null || existing === void 0 ? void 0 : existing.name) !== null && _existing_name !== void 0 ? _existing_name : null, existing === null || existing === void 0 ? void 0 : existing.nameLocalizations, trimmedName)) !== null && _localizedValue !== void 0 ? _localizedValue : trimmedName,
            thumbnailURL: (_thumbnail_url = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.url) !== null && _thumbnail_url !== void 0 ? _thumbnail_url : null,
            thumbnailBlurHash: (_thumbnail_blurHash = thumbnail === null || thumbnail === void 0 ? void 0 : thumbnail.blurHash) !== null && _thumbnail_blurHash !== void 0 ? _thumbnail_blurHash : null
        };
        try {
            const response = props.series ? await (0, $354a777975e62edf$export$2e2bcd8739ae039).updateSeries(auth.churchId, props.series.id, attributes, auth) : await (0, $354a777975e62edf$export$2e2bcd8739ae039).createSeries(auth.churchId, attributes, auth);
            if (response.error || !response.body) {
                setError($1ebd48de221e02da$var$friendlySaveError(response.error || `Unable to ${isEditing ? 'save' : 'create'} this series right now.`));
                return;
            }
            props.onSaved(response.body);
        } finally{
            setIsSaving(false);
        }
    };
    let submitTitle = isEditing ? 'Save Changes' : 'Create Series';
    if (isSaving) submitTitle = isEditing ? 'Saving...' : 'Creating...';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "series-editor-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "series-editor-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            disabled: isBusy,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: isEditing ? 'Edit Series' : 'New Series'
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "header-control-spacer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                    className: "series-form",
                    onSubmit: (e)=>{
                        e.preventDefault();
                        save();
                    },
                    children: [
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "section",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "text",
                                    placeholder: "Series Name",
                                    "aria-label": "Series name",
                                    value: name,
                                    disabled: isSaving,
                                    onChange: (e)=>setName(e.target.value)
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "section",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "input labeled",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "series-campus",
                                            children: "Campus"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                            id: "series-campus",
                                            value: campusID,
                                            disabled: isSaving,
                                            onChange: (e)=>setCampusID(e.target.value),
                                            children: [
                                                campusID === '' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: "",
                                                    disabled: true,
                                                    children: "Choose a campus"
                                                }) : null,
                                                sortedCampuses.map((campus)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                        value: campus.id,
                                                        children: campus.attributes.name
                                                    }, campus.id))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "separator"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "input labeled",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            htmlFor: "series-category",
                                            children: "Category"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                            id: "series-category",
                                            value: categoryID,
                                            disabled: isSaving,
                                            onChange: (e)=>setCategoryID(e.target.value),
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: "",
                                                    children: "No Category"
                                                }),
                                                sortedCategories.map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                        value: category.id,
                                                        children: category.name
                                                    }, category.id))
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "separator"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "input labeled",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            children: "Start Date"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "date-picker-container",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c7b1a6f859720e7$export$5109c6dd95d8fb00), {
                                                customInput: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c40eac2834ad20c3$export$2e2bcd8739ae039), {}),
                                                selected: startDate,
                                                disabled: isSaving,
                                                dateFormat: "PP",
                                                // Rendered at the top of the page, over the modal, rather than
                                                // inside it where it'd be clipped.
                                                withPortal: true,
                                                portalId: "series-start-date-portal",
                                                onChange: (date)=>setStartDate(date)
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                            className: "footnote",
                            children: [
                                "Series are listed newest first by their start date, usually the day of their first service.",
                                isEditing ? ' Moving a series to another campus or category keeps its services in it.' : " Add services to it from each service\u2019s page, under Schedule."
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "section thumbnail-section",
                            children: [
                                thumbnail ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    className: "thumbnail-preview",
                                    src: thumbnail.url,
                                    alt: "Thumbnail preview"
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "thumbnail-preview empty",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "thumbnail-controls",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                            ref: fileInputRef,
                                            type: "file",
                                            accept: "image/*",
                                            hidden: true,
                                            onChange: (e)=>{
                                                var _e_target_files;
                                                const file = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
                                                // Cleared so picking the same file again still fires.
                                                e.target.value = '';
                                                if (file) upload(file);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            className: "secondary-button",
                                            disabled: isBusy,
                                            onClick: ()=>{
                                                var _fileInputRef_current;
                                                return (_fileInputRef_current = fileInputRef.current) === null || _fileInputRef_current === void 0 ? void 0 : _fileInputRef_current.click();
                                            },
                                            children: isUploading ? 'Uploading...' : thumbnail ? 'Upload New Thumbnail' : 'Upload Thumbnail'
                                        }),
                                        thumbnail && !isUploading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            className: "text-button destructive",
                                            disabled: isSaving,
                                            onClick: ()=>setThumbnail(null),
                                            children: "Remove Thumbnail"
                                        }) : null
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "footnote",
                            children: "A 16:9 image works best. It\u2019s shown wherever the series appears in Launchpad and in the Salt app."
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "submit",
                            className: "submit",
                            disabled: !canSave,
                            children: submitTitle
                        })
                    ]
                })
            ]
        })
    });
}
// Sanctuary's refusal for a thumbnail hosted outside Salt, reworded for the
// person who hit it.
function $1ebd48de221e02da$var$friendlySaveError(error) {
    if (error.includes('Assets must be uploaded through the asset upload target')) return "This series' thumbnail is hosted outside Salt, so it can't be saved as is. Upload the thumbnail again, or remove it, then save.";
    return error;
}





function $4bf91bc2ddb7f5fe$export$2e2bcd8739ae039(props) {
    var _campuses_find, _categories_find;
    const { campuses: campuses, categories: categories } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const { series: series, loading: loading, hasLoaded: hasLoaded, error: error, hasMore: hasMore, isLoadingMore: isLoadingMore, loadMore: loadMore, refetch: refetch } = (0, $0839360f84148e9b$export$5a8ecf1f06a8addb)(props.isOpen ? props.campusID : null, props.categoryID);
    // What's been picked but not yet confirmed. `series` is kept alongside the
    // ID so the caller can show its name; it's null for "No Series" and for
    // the service's current series, which the caller already knows.
    const [pending, setPending] = (0, $7fPBF.useState)({
        id: props.selectedSeriesID,
        series: null
    });
    // Each open starts from the service's series as it is now.
    (0, $7fPBF.useEffect)(()=>{
        if (props.isOpen) setPending({
            id: props.selectedSeriesID,
            series: null
        });
    }, [
        props.isOpen,
        props.selectedSeriesID
    ]);
    const hasChanged = pending.id !== props.selectedSeriesID;
    // Keyed per open, so each new series starts blank.
    const [isEditorOpen, setIsEditorOpen] = (0, $7fPBF.useState)(false);
    const [editorKey, setEditorKey] = (0, $7fPBF.useState)(0);
    var _campuses_find_attributes_name;
    const campusName = (_campuses_find_attributes_name = (_campuses_find = campuses.find((campus)=>campus.id === props.campusID)) === null || _campuses_find === void 0 ? void 0 : _campuses_find.attributes.name) !== null && _campuses_find_attributes_name !== void 0 ? _campuses_find_attributes_name : 'This campus';
    var _categories_find_name;
    const categoryName = (_categories_find_name = (_categories_find = categories.find((category)=>category.id === props.categoryID)) === null || _categories_find === void 0 ? void 0 : _categories_find.name) !== null && _categories_find_name !== void 0 ? _categories_find_name : 'No Category';
    let list;
    if (loading && !hasLoaded) list = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "series-picker-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
            fullScreen: false,
            delayMs: 250
        })
    });
    else if (error && series.length === 0) list = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "series-picker-state",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: error
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: "text-button",
                onClick: ()=>void refetch(),
                children: "Try Again"
            })
        ]
    });
    else list = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                className: "series-picker-list",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4bf91bc2ddb7f5fe$var$SeriesOption, {
                        name: "No Series",
                        isSelected: pending.id === null,
                        onClick: ()=>setPending({
                                id: null,
                                series: null
                            })
                    }),
                    series.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4bf91bc2ddb7f5fe$var$SeriesOption, {
                            name: item.attributes.name || 'Untitled Series',
                            thumbnailURL: item.attributes.thumbnailURL,
                            isSelected: item.id === pending.id,
                            onClick: ()=>setPending({
                                    id: item.id,
                                    series: item
                                })
                        }, item.id))
                ]
            }),
            series.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "series-picker-empty",
                children: "There aren't any series here yet. Start one below."
            }) : null,
            error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "series-picker-error",
                children: error
            }) : null,
            hasMore ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: "text-button load-more",
                disabled: isLoadingMore,
                onClick: loadMore,
                children: isLoadingMore ? "Loading\u2026" : 'Load More'
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
                id: "series-picker-modal",
                isOpen: props.isOpen,
                footerButtons: [],
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "series-picker-modal-content",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "header",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    className: "header-control close",
                                    onClick: props.close,
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                        alt: "Close icon"
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    className: "title",
                                    children: "Choose a Series"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    className: "header-control confirm",
                                    disabled: !hasChanged,
                                    onClick: ()=>props.onSelect(pending.series),
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($d5bdfc11cea11cc4$exports))),
                                        alt: "Confirm selection"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                            className: "caption",
                            children: [
                                "Showing Series in ",
                                campusName,
                                " \xb7 ",
                                categoryName
                            ]
                        }),
                        list,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                            type: "button",
                            className: "new-series-button",
                            onClick: ()=>{
                                setEditorKey((current)=>current + 1);
                                setIsEditorOpen(true);
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5c0a9c99fa42f0$exports))),
                                    alt: "",
                                    "aria-hidden": "true"
                                }),
                                "New Series"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ebd48de221e02da$export$2e2bcd8739ae039), {
                isOpen: isEditorOpen,
                initialCampusID: props.campusID,
                initialCategoryID: props.categoryID,
                close: ()=>setIsEditorOpen(false),
                onSaved: (created)=>{
                    setIsEditorOpen(false);
                    props.onSelect(created);
                }
            }, `picker-new-series-${editorKey}`)
        ]
    });
}
function $4bf91bc2ddb7f5fe$var$SeriesOption(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
            type: "button",
            className: props.isSelected ? 'series-option is-selected' : 'series-option',
            "aria-pressed": props.isSelected,
            onClick: props.onClick,
            children: [
                props.thumbnailURL !== undefined ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "series-option-thumbnail",
                    children: props.thumbnailURL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: props.thumbnailURL,
                        alt: "",
                        "aria-hidden": "true"
                    }) : null
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "series-option-name",
                    children: props.name
                }),
                props.isSelected ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                    className: "series-option-check",
                    viewBox: "0 0 16 16",
                    role: "img",
                    "aria-label": "Selected",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                        d: "M3 8.5l3.2 3.2L13 5",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                }) : null
            ]
        })
    });
}





var $7fPBF = parcelRequire("7fPBF");





const $b0602dc681041303$var$HTTP_NOT_FOUND = 404;
function $b0602dc681041303$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [isDeleting, setIsDeleting] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const title = props.service.attributes.title || 'this service';
    const deleteService = async ()=>{
        if (!auth.churchId) {
            setError('Missing church context. Please refresh and try again.');
            return;
        }
        setIsDeleting(true);
        setError(null);
        try {
            const response = await (0, $97638f75b6ce75cf$export$2e2bcd8739ae039).deleteService(auth.churchId, props.service.id, auth);
            // Already gone, most likely deleted elsewhere: the outcome asked for.
            if (response.error && response.status !== $b0602dc681041303$var$HTTP_NOT_FOUND) {
                setError(response.error);
                return;
            }
            props.onDeleted();
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "delete-service-modal",
        isOpen: props.isOpen,
        footerButtons: [
            {
                title: isDeleting ? 'Deleting...' : 'Delete Service',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !isDeleting,
                onClick: ()=>{
                    deleteService();
                }
            },
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !isDeleting,
                onClick: props.close
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "delete-service-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "close",
                            disabled: isDeleting,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: "Delete Service"
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "save-error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5407115776bd457c$exports))),
                            alt: "",
                            "aria-hidden": "true",
                            className: "warning-icon"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "warning-copy",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("strong", {
                                children: [
                                    "Are you sure you want to delete ",
                                    title,
                                    "?"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "warning-copy",
                            children: "It will be removed from Launchpad and the Salt app, along with its songs, scripture, and discussion questions. This action cannot be undone."
                        })
                    ]
                })
            ]
        })
    });
}






const $7987ebb20220fb8b$export$b0d48545634a470f = [
    {
        id: 'video',
        name: 'Video',
        platforms: [
            {
                id: 'youTube',
                name: 'YouTube'
            }
        ]
    },
    {
        id: 'audio',
        name: 'Audio',
        platforms: [
            {
                id: 'applePodcasts',
                name: 'Apple Podcasts'
            },
            {
                id: 'spotify',
                name: 'Spotify'
            },
            {
                id: 'amazonMusic',
                name: 'Amazon Music'
            },
            {
                id: 'iHeartRadio',
                name: 'iHeartRadio'
            },
            // Sanctuary's `youTube` platform as audio, which is YouTube Music.
            {
                id: 'youTube',
                name: 'YouTube Music'
            }
        ]
    }
];
const $7987ebb20220fb8b$export$c2f567cf7e1d96ae = 20;
const $7987ebb20220fb8b$export$ca64e1a0e16de414 = [
    [
        'genesis',
        'Genesis'
    ],
    [
        'exodus',
        'Exodus'
    ],
    [
        'leviticus',
        'Leviticus'
    ],
    [
        'numbers',
        'Numbers'
    ],
    [
        'deuteronomy',
        'Deuteronomy'
    ],
    [
        'joshua',
        'Joshua'
    ],
    [
        'judges',
        'Judges'
    ],
    [
        'ruth',
        'Ruth'
    ],
    [
        'firstSamuel',
        '1 Samuel'
    ],
    [
        'secondSamuel',
        '2 Samuel'
    ],
    [
        'firstKings',
        '1 Kings'
    ],
    [
        'secondKings',
        '2 Kings'
    ],
    [
        'firstChronicles',
        '1 Chronicles'
    ],
    [
        'secondChronicles',
        '2 Chronicles'
    ],
    [
        'ezra',
        'Ezra'
    ],
    [
        'nehemiah',
        'Nehemiah'
    ],
    [
        'esther',
        'Esther'
    ],
    [
        'job',
        'Job'
    ],
    [
        'psalms',
        'Psalms'
    ],
    [
        'proverbs',
        'Proverbs'
    ],
    [
        'ecclesiastes',
        'Ecclesiastes'
    ],
    [
        'songOfSongs',
        'Song of Songs'
    ],
    [
        'isaiah',
        'Isaiah'
    ],
    [
        'jeremiah',
        'Jeremiah'
    ],
    [
        'lamentations',
        'Lamentations'
    ],
    [
        'ezekiel',
        'Ezekiel'
    ],
    [
        'daniel',
        'Daniel'
    ],
    [
        'hosea',
        'Hosea'
    ],
    [
        'joel',
        'Joel'
    ],
    [
        'amos',
        'Amos'
    ],
    [
        'obadiah',
        'Obadiah'
    ],
    [
        'jonah',
        'Jonah'
    ],
    [
        'micah',
        'Micah'
    ],
    [
        'nahum',
        'Nahum'
    ],
    [
        'habakkuk',
        'Habakkuk'
    ],
    [
        'zephaniah',
        'Zephaniah'
    ],
    [
        'haggai',
        'Haggai'
    ],
    [
        'zechariah',
        'Zechariah'
    ],
    [
        'malachi',
        'Malachi'
    ],
    [
        'matthew',
        'Matthew'
    ],
    [
        'mark',
        'Mark'
    ],
    [
        'luke',
        'Luke'
    ],
    [
        'john',
        'John'
    ],
    [
        'acts',
        'Acts'
    ],
    [
        'romans',
        'Romans'
    ],
    [
        'firstCorinthians',
        '1 Corinthians'
    ],
    [
        'secondCorinthians',
        '2 Corinthians'
    ],
    [
        'galatians',
        'Galatians'
    ],
    [
        'ephesians',
        'Ephesians'
    ],
    [
        'philippians',
        'Philippians'
    ],
    [
        'colossians',
        'Colossians'
    ],
    [
        'firstThessalonians',
        '1 Thessalonians'
    ],
    [
        'secondThessalonians',
        '2 Thessalonians'
    ],
    [
        'firstTimothy',
        '1 Timothy'
    ],
    [
        'secondTimothy',
        '2 Timothy'
    ],
    [
        'titus',
        'Titus'
    ],
    [
        'philemon',
        'Philemon'
    ],
    [
        'hebrews',
        'Hebrews'
    ],
    [
        'james',
        'James'
    ],
    [
        'firstPeter',
        '1 Peter'
    ],
    [
        'secondPeter',
        '2 Peter'
    ],
    [
        'firstJohn',
        '1 John'
    ],
    [
        'secondJohn',
        '2 John'
    ],
    [
        'thirdJohn',
        '3 John'
    ],
    [
        'jude',
        'Jude'
    ],
    [
        'revelation',
        'Revelation'
    ]
];
const $7987ebb20220fb8b$var$bibleBookNames = new Map($7987ebb20220fb8b$export$ca64e1a0e16de414);
function $7987ebb20220fb8b$export$33afb27bab152f62(book) {
    var _bibleBookNames_get;
    return (_bibleBookNames_get = $7987ebb20220fb8b$var$bibleBookNames.get(book)) !== null && _bibleBookNames_get !== void 0 ? _bibleBookNames_get : book;
}
function $7987ebb20220fb8b$export$ff4450457e97a410(verse) {
    const reference = `${$7987ebb20220fb8b$export$33afb27bab152f62(verse.book)} ${verse.chapter}:${verse.verse}`;
    return verse.version ? `${reference} (${verse.version})` : reference;
}





// Matches the context menu's exit animation.
const $4a2fec0e077f8fd2$var$MENU_EXIT_DURATION_MS = 140;
// Matches save-bar-out in index.scss.
const $4a2fec0e077f8fd2$var$SAVE_BAR_EXIT_MS = 200;
function $4a2fec0e077f8fd2$export$b4820472e653f2ab(campusID, categoryID) {
    const params = new URLSearchParams();
    if (campusID) params.set('campus', campusID);
    if (categoryID) params.set('category', categoryID);
    const query = params.toString();
    return query ? `/services/new?${query}` : '/services/new';
}
// A blank service for the editor to start a new one from. It has no ID until
// Sanctuary creates it.
function $4a2fec0e077f8fd2$var$emptyService(campusID, categoryID) {
    return {
        id: '',
        churchID: '',
        attributes: {
            campusID: campusID,
            categoryID: categoryID,
            seriesID: null,
            songs: [],
            title: '',
            description: null,
            discussionQuestions: null,
            thumbnailURL: null,
            thumbnailBlurHash: null,
            videoURL: null,
            media: [],
            verses: [],
            timestamp: '',
            additionalTimestamps: []
        }
    };
}
function $4a2fec0e077f8fd2$export$2f557ba72376749f() {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [searchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const { campuses: campuses, categories: categories } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    // Only a campus and category that still exist are carried over.
    const requestedCampusID = searchParams.get('campus');
    const requestedCategoryID = searchParams.get('category');
    // With only one campus, it's the one: the Services tabs use it without
    // putting it in the URL.
    const campusID = campuses.some((campus)=>campus.id === requestedCampusID) ? requestedCampusID : campuses.length === 1 ? campuses[0].id : null;
    const categoryID = categories.some((category)=>category.id === requestedCategoryID) ? requestedCategoryID : null;
    // Made once, so the editor's starting point doesn't shift under it.
    const [template] = (0, $7fPBF.useState)(()=>$4a2fec0e077f8fd2$var$emptyService(campusID !== null && campusID !== void 0 ? campusID : '', categoryID));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4a2fec0e077f8fd2$var$ServiceEditor, {
        isNew: true,
        service: template,
        backLocation: $4a2fec0e077f8fd2$export$e89e893f4600f250(campusID, categoryID),
        onSaved: (created)=>{
            const state = {
                service: created,
                justCreated: true
            };
            navigate($4a2fec0e077f8fd2$export$4a8c15014d47b752(created), {
                replace: true,
                state: state
            });
        }
    });
}
function $4a2fec0e077f8fd2$export$4a8c15014d47b752(service) {
    return `/services/${service.id}`;
}
function $4a2fec0e077f8fd2$export$e89e893f4600f250(campusID, categoryID) {
    const params = new URLSearchParams();
    if (campusID) params.set('campus', campusID);
    if (categoryID) params.set('category', categoryID);
    const query = params.toString();
    return query ? `/services?${query}` : '/services';
}
function $4a2fec0e077f8fd2$export$2e2bcd8739ae039() {
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { serviceID: serviceID } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    var _location_state;
    const routedState = (_location_state = location.state) !== null && _location_state !== void 0 ? _location_state : null;
    var _routedState_service;
    const routedService = (_routedState_service = routedState === null || routedState === void 0 ? void 0 : routedState.service) !== null && _routedState_service !== void 0 ? _routedState_service : null;
    const hasRoutedService = routedService !== null && routedService.id === serviceID;
    // Only needed when the page was reloaded or opened from a link.
    const { service: fetchedService, notFound: notFound, error: error, refetch: refetch } = (0, $2e7a6464932056f2$export$2e2bcd8739ae039)(hasRoutedService ? null : serviceID !== null && serviceID !== void 0 ? serviceID : null);
    // Kept here once saved, so the editor carries on from what the server stored.
    const [savedService, setSavedService] = (0, $7fPBF.useState)(null);
    const service = savedService !== null && savedService !== void 0 ? savedService : hasRoutedService ? routedService : fetchedService;
    if (!serviceID) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/services",
        replace: true
    });
    var _ref;
    if (service) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4a2fec0e077f8fd2$var$ServiceEditor, {
        service: service,
        justCreated: hasRoutedService && (routedState === null || routedState === void 0 ? void 0 : routedState.justCreated) === true,
        // Back returns to wherever the service was opened from, or else the
        // list it's filed in now, which follows it if a save moved it.
        backLocation: (_ref = hasRoutedService ? routedState === null || routedState === void 0 ? void 0 : routedState.backLocation : undefined) !== null && _ref !== void 0 ? _ref : $4a2fec0e077f8fd2$export$e89e893f4600f250(service.attributes.campusID, service.attributes.categoryID),
        onSaved: setSavedService
    }, service.id);
    if (notFound) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "service-details-page",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
            title: "Service Not Found",
            error: "This service doesn't exist, or it's been deleted.",
            buttonText: "Back to Services",
            buttonAction: ()=>navigate('/services'),
            fullHeight: true
        })
    });
    if (error) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "service-details-page",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
            error: error,
            buttonText: "Retry",
            buttonAction: ()=>void refetch(),
            fullHeight: true
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "service-details-page",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "service-state",
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                fullScreen: false,
                delayMs: 250
            })
        })
    });
}
let $4a2fec0e077f8fd2$var$nextVerseKey = 0;
let $4a2fec0e077f8fd2$var$nextSongKey = 0;
let $4a2fec0e077f8fd2$var$nextMediaKey = 0;
// What Sanctuary keeps unique: one entry per kind and platform. Also the
// value of each option in a row's platform dropdown, which picks both at once.
function $4a2fec0e077f8fd2$var$mediaSlot(kind, platform) {
    return `${kind}|${platform}`;
}
function $4a2fec0e077f8fd2$var$parseMediaSlot(slot) {
    const [kind, ...platform] = slot.split('|');
    return {
        kind: kind === 'audio' ? 'audio' : 'video',
        platform: platform.join('|')
    };
}
// Whether the dropdown offers this kind and platform, as opposed to one this
// portal doesn't know, which is then shown on its own so it isn't lost.
function $4a2fec0e077f8fd2$var$isListedMediaSlot(kind, platform) {
    return (0, $7987ebb20220fb8b$export$b0d48545634a470f).some((group)=>group.id === kind && group.platforms.some((option)=>option.id === platform));
}
// A new row on the first kind and platform, in dropdown order, that no row
// has yet, so usually only the link is left to fill in.
function $4a2fec0e077f8fd2$var$newMediaDraft(existing) {
    const taken = new Set(existing.map((entry)=>$4a2fec0e077f8fd2$var$mediaSlot(entry.kind, entry.platform)));
    for (const group of (0, $7987ebb20220fb8b$export$b0d48545634a470f)){
        const platform = group.platforms.find((option)=>!taken.has($4a2fec0e077f8fd2$var$mediaSlot(group.id, option.id)));
        if (platform) return {
            key: $4a2fec0e077f8fd2$var$nextMediaKey++,
            platform: platform.id,
            kind: group.id,
            url: '',
            origin: null
        };
    }
    return {
        key: $4a2fec0e077f8fd2$var$nextMediaKey++,
        platform: '',
        kind: 'video',
        url: '',
        origin: null
    };
}
// Whether a link is to YouTube, the one platform the old single `videoURL`
// maps onto without guessing.
function $4a2fec0e077f8fd2$var$isYouTubeURL(value) {
    try {
        const host = new URL(value).hostname.toLowerCase();
        return host === 'youtu.be' || host === 'youtube.com' || host.endsWith('.youtube.com');
    } catch (e) {
        return false;
    }
}
// A service's media as editor rows. One saved before media existed, with just
// a YouTube `videoURL`, opens with that as its YouTube row, so it carries over
// on the next save. Any other old link is left alone rather than guessed at.
function $4a2fec0e077f8fd2$var$mediaDraftsFrom(service) {
    var _service_attributes_media;
    const media = (_service_attributes_media = service.attributes.media) !== null && _service_attributes_media !== void 0 ? _service_attributes_media : [];
    if (media.length > 0) return media.map((entry)=>{
        var _entry_origin;
        return {
            key: $4a2fec0e077f8fd2$var$nextMediaKey++,
            platform: entry.platform,
            kind: entry.kind,
            url: entry.url,
            origin: (_entry_origin = entry.origin) !== null && _entry_origin !== void 0 ? _entry_origin : null
        };
    });
    const videoURL = service.attributes.videoURL;
    if (videoURL && $4a2fec0e077f8fd2$var$isYouTubeURL(videoURL)) return [
        {
            key: $4a2fec0e077f8fd2$var$nextMediaKey++,
            platform: 'youTube',
            kind: 'video',
            url: videoURL,
            origin: null
        }
    ];
    return [];
}
// Whether the service still has an old `videoURL` that no media row stands
// for, which then has to be kept as it is.
function $4a2fec0e077f8fd2$var$hasUnmigratedVideoURL(service) {
    const videoURL = service.attributes.videoURL;
    var _service_attributes_media;
    return ((_service_attributes_media = service.attributes.media) !== null && _service_attributes_media !== void 0 ? _service_attributes_media : []).length === 0 && Boolean(videoURL) && !$4a2fec0e077f8fd2$var$isYouTubeURL(videoURL);
}
function $4a2fec0e077f8fd2$var$draftFrom(service) {
    const attributes = service.attributes;
    const timestamp = new Date(attributes.timestamp);
    var _attributes_title, _attributes_description, _attributes_discussionQuestions, _attributes_thumbnailURL, _attributes_thumbnailBlurHash, _attributes_categoryID, _attributes_seriesID, _attributes_songs, _attributes_verses;
    return {
        title: (_attributes_title = attributes.title) !== null && _attributes_title !== void 0 ? _attributes_title : '',
        description: (_attributes_description = attributes.description) !== null && _attributes_description !== void 0 ? _attributes_description : '',
        discussionQuestions: (_attributes_discussionQuestions = attributes.discussionQuestions) !== null && _attributes_discussionQuestions !== void 0 ? _attributes_discussionQuestions : '',
        media: $4a2fec0e077f8fd2$var$mediaDraftsFrom(service),
        thumbnailURL: (_attributes_thumbnailURL = attributes.thumbnailURL) !== null && _attributes_thumbnailURL !== void 0 ? _attributes_thumbnailURL : '',
        thumbnailBlurHash: (_attributes_thumbnailBlurHash = attributes.thumbnailBlurHash) !== null && _attributes_thumbnailBlurHash !== void 0 ? _attributes_thumbnailBlurHash : '',
        timestamp: Number.isNaN(timestamp.getTime()) ? null : timestamp,
        campusID: attributes.campusID,
        categoryID: (_attributes_categoryID = attributes.categoryID) !== null && _attributes_categoryID !== void 0 ? _attributes_categoryID : '',
        seriesID: (_attributes_seriesID = attributes.seriesID) !== null && _attributes_seriesID !== void 0 ? _attributes_seriesID : '',
        songs: ((_attributes_songs = attributes.songs) !== null && _attributes_songs !== void 0 ? _attributes_songs : []).map((song)=>({
                key: $4a2fec0e077f8fd2$var$nextSongKey++,
                song: {
                    id: song.id,
                    globalID: song.globalID,
                    attributes: song.attributes
                }
            })),
        verses: ((_attributes_verses = attributes.verses) !== null && _attributes_verses !== void 0 ? _attributes_verses : []).map((verse)=>{
            var _verse_version;
            return {
                key: $4a2fec0e077f8fd2$var$nextVerseKey++,
                book: verse.book,
                chapter: String(verse.chapter),
                verse: String(verse.verse),
                version: (_verse_version = verse.version) !== null && _verse_version !== void 0 ? _verse_version : ''
            };
        })
    };
}
function $4a2fec0e077f8fd2$var$updateFrom(draft) {
    var _draft_media_find;
    const orNull = (value)=>value.trim().length > 0 ? value.trim() : null;
    return {
        title: draft.title.trim(),
        description: orNull(draft.description),
        discussionQuestions: orNull(draft.discussionQuestions),
        media: draft.media.map((entry)=>({
                kind: entry.kind,
                platform: entry.platform,
                url: entry.url.trim(),
                origin: entry.origin
            })),
        // Kept in step with the YouTube row, for app versions that only read the
        // old single link.
        videoURL: ((_draft_media_find = draft.media.find((entry)=>entry.platform === 'youTube' && entry.kind === 'video')) === null || _draft_media_find === void 0 ? void 0 : _draft_media_find.url.trim()) || null,
        thumbnailURL: orNull(draft.thumbnailURL),
        // Only sent with a thumbnail to describe.
        thumbnailBlurHash: draft.thumbnailURL.trim() ? orNull(draft.thumbnailBlurHash) : null,
        timestamp: draft.timestamp ? (0, $af166244e46ffe4e$export$2508653e5b52dd4d)(draft.timestamp) : '',
        campusID: draft.campusID,
        categoryID: orNull(draft.categoryID),
        seriesID: orNull(draft.seriesID),
        songs: draft.songs.map((song)=>song.song),
        verses: draft.verses.map((verse)=>({
                book: verse.book,
                chapter: Number(verse.chapter),
                verse: Number(verse.verse),
                version: orNull(verse.version)
            }))
    };
}
// The complete attributes the update route replaces the stored ones with:
// the editor's fields, and everything it doesn't edit carried over as-is.
function $4a2fec0e077f8fd2$var$requestBodyFor(service, draft) {
    const attributes = service.attributes;
    const update = $4a2fec0e077f8fd2$var$updateFrom(draft);
    var _localizedValue, _update_thumbnailBlurHash, _update_videoURL, _attributes_additionalTimestamps;
    return {
        campusID: update.campusID,
        categoryID: update.categoryID,
        seriesID: update.seriesID,
        songs: update.songs,
        title: (_localizedValue = (0, $dc203b94917c8ff8$export$74edb9599ed878c7)(attributes.title, attributes.titleLocalizations, update.title)) !== null && _localizedValue !== void 0 ? _localizedValue : update.title,
        description: (0, $dc203b94917c8ff8$export$74edb9599ed878c7)(attributes.description, attributes.descriptionLocalizations, update.description),
        discussionQuestions: (0, $dc203b94917c8ff8$export$74edb9599ed878c7)(attributes.discussionQuestions, attributes.discussionQuestionsLocalizations, update.discussionQuestions),
        thumbnailURL: update.thumbnailURL,
        thumbnailBlurHash: (_update_thumbnailBlurHash = update.thumbnailBlurHash) !== null && _update_thumbnailBlurHash !== void 0 ? _update_thumbnailBlurHash : null,
        media: update.media,
        // An old non-YouTube link with nothing standing in for it is kept, so
        // opening and saving a service never loses it.
        videoURL: (_update_videoURL = update.videoURL) !== null && _update_videoURL !== void 0 ? _update_videoURL : $4a2fec0e077f8fd2$var$hasUnmigratedVideoURL(service) ? attributes.videoURL : null,
        verses: update.verses,
        timestamp: update.timestamp,
        additionalTimestamps: (_attributes_additionalTimestamps = attributes.additionalTimestamps) !== null && _attributes_additionalTimestamps !== void 0 ? _attributes_additionalTimestamps : []
    };
}
// Sanctuary's refusal for a thumbnail hosted outside Salt, reworded for the
// person who hit it.
function $4a2fec0e077f8fd2$var$friendlySaveError(error) {
    if (error.includes('Assets must be uploaded through the asset upload target')) return "This service's thumbnail is hosted outside Salt, so it can't be saved as is. Upload the thumbnail again, or remove it, then save.";
    return error;
}
// Songs are stored with the IDs they're sent with, so a new one needs its own.
function $4a2fec0e077f8fd2$var$newSongID() {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') return crypto.randomUUID();
    return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
function $4a2fec0e077f8fd2$var$isWebURL(value) {
    try {
        const url = new URL(value.trim());
        return url.protocol === 'https:' || url.protocol === 'http:';
    } catch (e) {
        return false;
    }
}
function $4a2fec0e077f8fd2$var$isSecureURL(value) {
    try {
        const url = new URL(value.trim());
        return url.protocol === 'https:' && url.hostname.length > 0;
    } catch (e) {
        return false;
    }
}
function $4a2fec0e077f8fd2$var$isPositiveWholeNumber(value) {
    return /^\d+$/.test(value.trim()) && Number(value) > 0;
}
// Everything the draft needs before it can be saved, as messages to show.
function $4a2fec0e077f8fd2$var$problemsWith(draft) {
    const problems = [];
    if (draft.title.trim().length === 0) problems.push('Add a title.');
    if (!draft.timestamp) problems.push('Choose when the service happens.');
    if (!draft.campusID) problems.push('Choose a campus.');
    if (draft.media.some((entry)=>!entry.platform)) problems.push('Choose a platform for each media link.');
    // Sanctuary only accepts HTTPS, since apps open these links directly.
    if (draft.media.some((entry)=>!$4a2fec0e077f8fd2$var$isSecureURL(entry.url))) problems.push('Each media link needs to be a full web address, starting with https://.');
    if (draft.thumbnailURL.trim() && !$4a2fec0e077f8fd2$var$isWebURL(draft.thumbnailURL)) problems.push('The thumbnail link needs to be a full web address, starting with https://.');
    if (draft.verses.some((verse)=>!$4a2fec0e077f8fd2$var$isPositiveWholeNumber(verse.chapter) || !$4a2fec0e077f8fd2$var$isPositiveWholeNumber(verse.verse))) problems.push('Every verse needs a chapter and verse number.');
    return problems;
}
// Grows with its text instead of scrolling or offering a resize handle, so its
// card fits what's written. The CSS min-height sets the starting size.
function $4a2fec0e077f8fd2$var$AutoSizingTextarea(props) {
    const ref = (0, $7fPBF.useRef)(null);
    const fit = ()=>{
        const textarea = ref.current;
        if (!textarea) return;
        // Collapsed first so it can shrink when text is deleted, then sized to fit.
        textarea.style.height = 'auto';
        textarea.style.height = `${textarea.scrollHeight}px`;
    };
    (0, $7fPBF.useLayoutEffect)(fit, [
        props.value
    ]);
    // A narrower card wraps the text onto more lines.
    (0, $7fPBF.useEffect)(()=>{
        window.addEventListener('resize', fit);
        return ()=>window.removeEventListener('resize', fit);
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        ref: ref,
        rows: 1
    }));
}
function $4a2fec0e077f8fd2$var$songForMenu(entry) {
    return {
        id: entry.song.id,
        globalID: entry.song.globalID,
        attributes: entry.song.attributes
    };
}
function $4a2fec0e077f8fd2$var$ServiceEditor(props) {
    var _campuses_find;
    const isNew = props.isNew === true;
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { campuses: campuses, categories: categories } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const initialDraft = (0, $7fPBF.useMemo)(()=>$4a2fec0e077f8fd2$var$draftFrom(props.service), [
        props.service
    ]);
    const [draft, setDraft] = (0, $7fPBF.useState)(initialDraft);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [isSongPickerOpen, setIsSongPickerOpen] = (0, $7fPBF.useState)(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $7fPBF.useState)(false);
    const [isSeriesPickerOpen, setIsSeriesPickerOpen] = (0, $7fPBF.useState)(false);
    // Kept after the error clears, so the message stays readable while it
    // collapses away rather than vanishing first.
    const [lastError, setLastError] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (error) setLastError(error);
    }, [
        error
    ]);
    // A brief confirmation, since the save bar disappearing is easy to miss.
    const [savedNotice, setSavedNotice] = (0, $7fPBF.useState)(props.justCreated ? 'created' : null);
    (0, $7fPBF.useEffect)(()=>{
        if (!savedNotice) return;
        const timeout = window.setTimeout(()=>setSavedNotice(null), 3000);
        return ()=>window.clearTimeout(timeout);
    }, [
        savedNotice
    ]);
    const [isUploadingThumbnail, setIsUploadingThumbnail] = (0, $7fPBF.useState)(false);
    const [thumbnailError, setThumbnailError] = (0, $7fPBF.useState)(null);
    const thumbnailInputRef = (0, $7fPBF.useRef)(null);
    // The menu stays mounted through its exit animation, so the selected and
    // displayed states are tracked separately.
    const [selectedSongMenu, setSelectedSongMenu] = (0, $7fPBF.useState)(null);
    const [displayedSongMenu, setDisplayedSongMenu] = (0, $7fPBF.useState)(null);
    const [isClosingSongMenu, setIsClosingSongMenu] = (0, $7fPBF.useState)(false);
    const songMenuRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (selectedSongMenu) {
            setDisplayedSongMenu(selectedSongMenu);
            setIsClosingSongMenu(false);
            return;
        }
        if (!displayedSongMenu) {
            setIsClosingSongMenu(false);
            return;
        }
        setIsClosingSongMenu(true);
        const timeout = window.setTimeout(()=>{
            setDisplayedSongMenu(null);
            setIsClosingSongMenu(false);
        }, $4a2fec0e077f8fd2$var$MENU_EXIT_DURATION_MS);
        return ()=>window.clearTimeout(timeout);
    }, [
        selectedSongMenu,
        displayedSongMenu
    ]);
    const update = (key, value)=>{
        setDraft((current)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current), {
                [key]: value
            }));
    };
    const updateMedia = (key, changes)=>{
        setDraft((current)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current), {
                media: current.media.map((entry)=>entry.key === key ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, entry, changes) : entry)
            }));
    };
    const updateVerse = (key, changes)=>{
        setDraft((current)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current), {
                verses: current.verses.map((verse)=>verse.key === key ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, verse, changes) : verse)
            }));
    };
    // Compared as they'd be sent, so typing a space and deleting it isn't a change.
    const hasChanges = JSON.stringify($4a2fec0e077f8fd2$var$updateFrom(draft)) !== JSON.stringify($4a2fec0e077f8fd2$var$updateFrom(initialDraft));
    const problems = $4a2fec0e077f8fd2$var$problemsWith(draft);
    const canSave = hasChanges && problems.length === 0 && !isSaving && !isUploadingThumbnail;
    // A new service always offers its Create button, so the way to finish is
    // never hidden, and says what's still needed.
    const showsSaveBar = isNew || hasChanges;
    // Uploaded as soon as it's picked, so the draft only ever holds a URL, and
    // Discard puts the old image back like any other field. Its BlurHash is
    // worked out from the file alongside the upload, so it adds no wait.
    const uploadThumbnail = async (file)=>{
        if (!auth.churchId) return;
        setIsUploadingThumbnail(true);
        setThumbnailError(null);
        try {
            const { thumbnail: thumbnail, error: uploadError } = await (0, $107fb90fbf824423$export$2966bceab4a48a87)(auth.churchId, file, 'service', auth);
            if (!thumbnail) {
                setThumbnailError(uploadError !== null && uploadError !== void 0 ? uploadError : "The thumbnail couldn't be uploaded. Please try again.");
                return;
            }
            // Set in one update, so the draft never pairs the new image with the
            // old image's hash.
            setDraft((current)=>{
                var _thumbnail_blurHash;
                return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current), {
                    thumbnailURL: thumbnail.url,
                    thumbnailBlurHash: (_thumbnail_blurHash = thumbnail.blurHash) !== null && _thumbnail_blurHash !== void 0 ? _thumbnail_blurHash : ''
                });
            });
        } finally{
            setIsUploadingThumbnail(false);
        }
    };
    // The save bar stays mounted through its exit animation, so it leaves
    // instead of vanishing when the changes are discarded or saved.
    const [isSaveBarMounted, setIsSaveBarMounted] = (0, $7fPBF.useState)(showsSaveBar);
    const [isSaveBarLeaving, setIsSaveBarLeaving] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (showsSaveBar) {
            setIsSaveBarMounted(true);
            setIsSaveBarLeaving(false);
            return;
        }
        if (!isSaveBarMounted) return;
        setIsSaveBarLeaving(true);
        const timeout = window.setTimeout(()=>{
            setIsSaveBarMounted(false);
            setIsSaveBarLeaving(false);
        }, $4a2fec0e077f8fd2$var$SAVE_BAR_EXIT_MS);
        return ()=>window.clearTimeout(timeout);
    }, [
        showsSaveBar,
        isSaveBarMounted
    ]);
    // A reload or closed tab would lose the edits without asking.
    (0, $7fPBF.useEffect)(()=>{
        if (!hasChanges) return;
        const warn = (event)=>{
            event.preventDefault();
            event.returnValue = '';
        };
        window.addEventListener('beforeunload', warn);
        return ()=>window.removeEventListener('beforeunload', warn);
    }, [
        hasChanges
    ]);
    const save = async ()=>{
        if (!auth.churchId || !canSave) return;
        setIsSaving(true);
        setError(null);
        try {
            const body = $4a2fec0e077f8fd2$var$requestBodyFor(props.service, draft);
            const response = isNew ? await (0, $97638f75b6ce75cf$export$2e2bcd8739ae039).createService(auth.churchId, body, auth) : await (0, $97638f75b6ce75cf$export$2e2bcd8739ae039).updateService(auth.churchId, props.service, body, auth);
            const saved = response.body;
            if (response.error || !saved) {
                setError($4a2fec0e077f8fd2$var$friendlySaveError(response.error || `Unable to ${isNew ? 'create' : 'save'} this service right now.`));
                return;
            }
            // The new service's own page takes over from here.
            if (isNew) {
                props.onSaved(saved);
                return;
            }
            // Rebuilt from what was stored, so the editor matches the server exactly
            // and the save bar goes away.
            setDraft($4a2fec0e077f8fd2$var$draftFrom(saved));
            setSavedNotice('saved');
            props.onSaved(saved);
        } finally{
            setIsSaving(false);
        }
    };
    // The saved campus, for the header; the picker shows the draft's.
    const campusName = (_campuses_find = campuses.find((campus)=>campus.id === props.service.attributes.campusID)) === null || _campuses_find === void 0 ? void 0 : _campuses_find.attributes.name;
    const sortedCampuses = [
        ...campuses
    ].sort((one, two)=>one.attributes.name.localeCompare(two.attributes.name));
    // A campus deleted since the service was filed isn't in the list, but it's
    // still the service's until another is chosen.
    const isUnknownCampus = draft.campusID !== '' && !campuses.some((campus)=>campus.id === draft.campusID);
    const sortedCategories = [
        ...categories
    ].sort((one, two)=>one.name.localeCompare(two.name));
    var _draft_songs_find;
    const menuSong = (_draft_songs_find = draft.songs.find((entry)=>entry.key === (displayedSongMenu === null || displayedSongMenu === void 0 ? void 0 : displayedSongMenu.key))) !== null && _draft_songs_find !== void 0 ? _draft_songs_find : null;
    // The series row shows a name, so it needs the series itself: the one
    // chosen in the picker, or else the one the service was saved with, looked
    // up on its own rather than by loading a whole list.
    const [chosenSeries, setChosenSeries] = (0, $7fPBF.useState)(null);
    var _props_service_attributes_seriesID;
    const savedSeries = (0, $0839360f84148e9b$export$4f814464c617a55b)(props.service.attributes.campusID || null, (_props_service_attributes_seriesID = props.service.attributes.seriesID) !== null && _props_service_attributes_seriesID !== void 0 ? _props_service_attributes_seriesID : null);
    let seriesLabel = 'No Series';
    if (draft.seriesID) {
        var _savedSeries_series;
        if ((chosenSeries === null || chosenSeries === void 0 ? void 0 : chosenSeries.id) === draft.seriesID) seriesLabel = chosenSeries.attributes.name || 'Untitled Series';
        else if (((_savedSeries_series = savedSeries.series) === null || _savedSeries_series === void 0 ? void 0 : _savedSeries_series.id) === draft.seriesID) seriesLabel = savedSeries.series.attributes.name || 'Untitled Series';
        else // Filed at another campus, where the lookup can't see it.
        seriesLabel = savedSeries.loading ? "Loading\u2026" : 'Current Series';
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "service-details-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: draft.title.trim() || (isNew ? 'New Service' : 'Untitled Service'),
                subtitle: isNew ? undefined : campusName,
                backLocation: props.backLocation,
                // A service that hasn't been created yet has nothing to delete; Cancel
                // leaves it instead.
                links: isNew ? undefined : [
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($f382a5c80f18c5e3$exports))),
                        title: 'Delete',
                        onClick: ()=>setIsDeleteModalOpen(true)
                    }
                ]
            }),
            draft.campusID ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4bf91bc2ddb7f5fe$export$2e2bcd8739ae039), {
                isOpen: isSeriesPickerOpen,
                campusID: draft.campusID,
                categoryID: draft.categoryID || null,
                selectedSeriesID: draft.seriesID || null,
                close: ()=>setIsSeriesPickerOpen(false),
                // Kept in the draft like any other edit; a series created from the
                // picker arrives here too, chosen straight away.
                onSelect: (picked)=>{
                    setChosenSeries(picked);
                    var _picked_id;
                    update('seriesID', (_picked_id = picked === null || picked === void 0 ? void 0 : picked.id) !== null && _picked_id !== void 0 ? _picked_id : '');
                    setIsSeriesPickerOpen(false);
                }
            }) : null,
            isNew ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b0602dc681041303$export$2e2bcd8739ae039), {
                isOpen: isDeleteModalOpen,
                service: props.service,
                close: ()=>setIsDeleteModalOpen(false),
                // Replaced, so Back from the list doesn't return to a service that's gone.
                onDeleted: ()=>navigate(props.backLocation, {
                        replace: true
                    })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $eefdeb9546a46be2$export$2e2bcd8739ae039), {
                id: "add-song-to-service-modal",
                isOpen: isSongPickerOpen,
                close: ()=>setIsSongPickerOpen(false),
                onConfirm: (selection)=>{
                    // Kept in the draft like any other edit; nothing is sent until Save.
                    update('songs', [
                        ...draft.songs,
                        {
                            key: $4a2fec0e077f8fd2$var$nextSongKey++,
                            song: {
                                id: $4a2fec0e077f8fd2$var$newSongID(),
                                attributes: selection.selectedSong
                            }
                        }
                    ]);
                }
            }),
            displayedSongMenu && menuSong ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb1d7f76a966659b$export$2e2bcd8739ae039), {
                song: $4a2fec0e077f8fd2$var$songForMenu(menuSong),
                menuRef: songMenuRef,
                x: displayedSongMenu.x,
                y: displayedSongMenu.y,
                isClosing: isClosingSongMenu,
                onRequestClose: ()=>setSelectedSongMenu(null),
                onRemove: ()=>{
                    setSelectedSongMenu(null);
                    update('songs', draft.songs.filter((entry)=>entry.key !== menuSong.key));
                }
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                className: "service-form",
                onSubmit: (e)=>{
                    e.preventDefault();
                    save();
                },
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Details"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "text",
                                    placeholder: "Title",
                                    "aria-label": "Title",
                                    value: draft.title,
                                    disabled: isSaving,
                                    onChange: (e)=>update('title', e.target.value)
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "separator"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4a2fec0e077f8fd2$var$AutoSizingTextarea, {
                                    placeholder: "Description",
                                    "aria-label": "Description",
                                    value: draft.description,
                                    disabled: isSaving,
                                    onChange: (e)=>update('description', e.target.value)
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Discussion Questions"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "section",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "input",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($4a2fec0e077f8fd2$var$AutoSizingTextarea, {
                                placeholder: "Discussion Questions",
                                "aria-label": "Discussion questions",
                                className: "tall",
                                value: draft.discussionQuestions,
                                disabled: isSaving,
                                onChange: (e)=>update('discussionQuestions', e.target.value)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: "Discussion Questions are shown alongside the service in Launchpad and in the Salt app."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Schedule"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "input labeled",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Date"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "date-picker-container",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c7b1a6f859720e7$export$5109c6dd95d8fb00), {
                                            customInput: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c40eac2834ad20c3$export$2e2bcd8739ae039), {}),
                                            selected: draft.timestamp,
                                            disabled: isSaving,
                                            showTimeInput: true,
                                            timeInputLabel: "Time",
                                            timeFormat: "p",
                                            dateFormat: "Pp",
                                            onChange: (date)=>update('timestamp', date)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "separator"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "input labeled",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "service-campus",
                                        children: "Campus"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                        id: "service-campus",
                                        value: draft.campusID,
                                        disabled: isSaving,
                                        onChange: (e)=>update('campusID', e.target.value),
                                        children: [
                                            draft.campusID === '' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: "",
                                                disabled: true,
                                                children: "Choose a campus"
                                            }) : null,
                                            isUnknownCampus ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: draft.campusID,
                                                disabled: true,
                                                children: "Unknown Campus"
                                            }) : null,
                                            sortedCampuses.map((campus)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: campus.id,
                                                    children: campus.attributes.name
                                                }, campus.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "separator"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "input labeled",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "service-category",
                                        children: "Category"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                        id: "service-category",
                                        value: draft.categoryID,
                                        disabled: isSaving,
                                        onChange: (e)=>update('categoryID', e.target.value),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: "",
                                                children: "No Category"
                                            }),
                                            sortedCategories.map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: category.id,
                                                    children: category.name
                                                }, category.id))
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "separator"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "input labeled",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "service-series",
                                        children: "Series"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        id: "service-series",
                                        type: "button",
                                        className: "row-link",
                                        // The picker lists series from the service's campus.
                                        disabled: isSaving || !draft.campusID,
                                        onClick: ()=>setIsSeriesPickerOpen(true),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: seriesLabel
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", {
                                                className: "row-link-chevron",
                                                viewBox: "0 0 8 14",
                                                "aria-hidden": "true",
                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                                                    d: "M1.5 1.5l5 5.5-5 5.5",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "1.8",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: "A service isn't shown in Launchpad or in the Salt app until its date has passed. Series are chosen from the campus and category above."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Thumbnail"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section thumbnail-section",
                        children: [
                            draft.thumbnailURL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "thumbnail-preview",
                                src: draft.thumbnailURL,
                                alt: "Thumbnail preview"
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "thumbnail-preview empty",
                                "aria-hidden": "true"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "thumbnail-controls",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        ref: thumbnailInputRef,
                                        type: "file",
                                        accept: "image/*",
                                        hidden: true,
                                        onChange: (e)=>{
                                            var _e_target_files;
                                            const file = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0];
                                            // Cleared so picking the same file again still fires.
                                            e.target.value = '';
                                            if (file) uploadThumbnail(file);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "button",
                                        className: "secondary-button",
                                        disabled: isSaving || isUploadingThumbnail,
                                        onClick: ()=>{
                                            var _thumbnailInputRef_current;
                                            return (_thumbnailInputRef_current = thumbnailInputRef.current) === null || _thumbnailInputRef_current === void 0 ? void 0 : _thumbnailInputRef_current.click();
                                        },
                                        children: isUploadingThumbnail ? 'Uploading...' : draft.thumbnailURL ? 'Upload New Thumbnail' : 'Upload Thumbnail'
                                    }),
                                    draft.thumbnailURL && !isUploadingThumbnail ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "button",
                                        className: "text-button destructive",
                                        disabled: isSaving,
                                        onClick: ()=>setDraft((current)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current), {
                                                    thumbnailURL: '',
                                                    thumbnailBlurHash: ''
                                                })),
                                        children: "Remove Thumbnail"
                                    }) : null,
                                    thumbnailError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "thumbnail-error",
                                        children: thumbnailError
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: "A 16:9 image works best. It's shown wherever the service appears in Launchpad and in the Salt app."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Media"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section media",
                        children: [
                            draft.media.map((entry, index)=>{
                                // Sanctuary allows each platform once per kind, so YouTube can carry
                                // both a video and an audio entry but not two of either.
                                const takenElsewhere = new Set(draft.media.filter((other)=>other.key !== entry.key).map((other)=>$4a2fec0e077f8fd2$var$mediaSlot(other.kind, other.platform)));
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        index > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "separator"
                                        }) : null,
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "media-row",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                                    "aria-label": "Platform",
                                                    value: entry.platform ? $4a2fec0e077f8fd2$var$mediaSlot(entry.kind, entry.platform) : '',
                                                    disabled: isSaving,
                                                    onChange: (e)=>updateMedia(entry.key, $4a2fec0e077f8fd2$var$parseMediaSlot(e.target.value)),
                                                    children: [
                                                        entry.platform === '' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                            value: "",
                                                            disabled: true,
                                                            children: "Platform"
                                                        }) : null,
                                                        entry.platform && !$4a2fec0e077f8fd2$var$isListedMediaSlot(entry.kind, entry.platform) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("option", {
                                                            value: $4a2fec0e077f8fd2$var$mediaSlot(entry.kind, entry.platform),
                                                            children: [
                                                                entry.platform,
                                                                " (",
                                                                entry.kind === 'audio' ? 'Audio' : 'Video',
                                                                ")"
                                                            ]
                                                        }) : null,
                                                        (0, $7987ebb20220fb8b$export$b0d48545634a470f).map((group)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("optgroup", {
                                                                label: group.name,
                                                                children: group.platforms.map((platform)=>{
                                                                    const slot = $4a2fec0e077f8fd2$var$mediaSlot(group.id, platform.id);
                                                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                                        value: slot,
                                                                        disabled: takenElsewhere.has(slot),
                                                                        children: platform.name
                                                                    }, slot);
                                                                })
                                                            }, group.id))
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    type: "url",
                                                    className: "media-url",
                                                    "aria-label": "Link",
                                                    placeholder: "https://",
                                                    value: entry.url,
                                                    disabled: isSaving,
                                                    onChange: (e)=>updateMedia(entry.key, {
                                                            url: e.target.value
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "remove-button",
                                                    "aria-label": "Remove media",
                                                    disabled: isSaving,
                                                    onClick: ()=>update('media', draft.media.filter((other)=>other.key !== entry.key)),
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f382a5c80f18c5e3$exports))),
                                                        alt: "",
                                                        "aria-hidden": "true"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, entry.key);
                            }),
                            draft.media.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "separator"
                            }) : null,
                            draft.media.length < (0, $7987ebb20220fb8b$export$c2f567cf7e1d96ae) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: "add-button",
                                disabled: isSaving,
                                onClick: ()=>update('media', [
                                        ...draft.media,
                                        $4a2fec0e077f8fd2$var$newMediaDraft(draft.media)
                                    ]),
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5c0a9c99fa42f0$exports))),
                                        alt: "",
                                        "aria-hidden": "true"
                                    }),
                                    "Add Media"
                                ]
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: "Links to this service's episode or video on each platform, opened in Launchpad and in the Salt app."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Songs"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section songs",
                        children: [
                            draft.songs.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ol", {
                                children: draft.songs.map((entry)=>{
                                    var _entry_song_attributes_artist;
                                    const isMenuOpen = (displayedSongMenu === null || displayedSongMenu === void 0 ? void 0 : displayedSongMenu.key) === entry.key;
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                            type: "button",
                                            className: "song-row",
                                            disabled: isSaving,
                                            onClick: (event)=>{
                                                if (isMenuOpen) {
                                                    setSelectedSongMenu(null);
                                                    return;
                                                }
                                                setSelectedSongMenu({
                                                    key: entry.key,
                                                    x: event.clientX + window.scrollX,
                                                    y: event.clientY + window.scrollY
                                                });
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                    src: entry.song.attributes.artworkURL || (0, (/*@__PURE__*/$parcel$interopDefault($f4ad1f40df3d002c$exports))),
                                                    alt: "",
                                                    "aria-hidden": "true"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                                    className: "song-text",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: "song-title",
                                                            children: entry.song.attributes.title
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                            className: "song-artist",
                                                            children: (_entry_song_attributes_artist = entry.song.attributes.artist) === null || _entry_song_attributes_artist === void 0 ? void 0 : _entry_song_attributes_artist.name
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, entry.key);
                                })
                            }) : null,
                            draft.songs.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "separator"
                            }) : null,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: "add-button",
                                disabled: isSaving,
                                onClick: ()=>setIsSongPickerOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5c0a9c99fa42f0$exports))),
                                        alt: "",
                                        "aria-hidden": "true"
                                    }),
                                    "Add Song"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Scripture"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section verses",
                        children: [
                            draft.verses.map((verse, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        index > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "separator"
                                        }) : null,
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "verse-row",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("select", {
                                                    "aria-label": "Book",
                                                    value: verse.book,
                                                    disabled: isSaving,
                                                    onChange: (e)=>updateVerse(verse.key, {
                                                            book: e.target.value
                                                        }),
                                                    children: (0, $7987ebb20220fb8b$export$ca64e1a0e16de414).map(([book, name])=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                            value: book,
                                                            children: name
                                                        }, book))
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    type: "text",
                                                    inputMode: "numeric",
                                                    "aria-label": "Chapter",
                                                    placeholder: "Ch.",
                                                    className: "number",
                                                    value: verse.chapter,
                                                    disabled: isSaving,
                                                    onChange: (e)=>updateVerse(verse.key, {
                                                            chapter: e.target.value
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "colon",
                                                    "aria-hidden": "true",
                                                    children: ":"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    type: "text",
                                                    inputMode: "numeric",
                                                    "aria-label": "Verse",
                                                    placeholder: "Vs.",
                                                    className: "number",
                                                    value: verse.verse,
                                                    disabled: isSaving,
                                                    onChange: (e)=>updateVerse(verse.key, {
                                                            verse: e.target.value
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    type: "text",
                                                    "aria-label": "Translation",
                                                    placeholder: "Translation (optional)",
                                                    className: "version",
                                                    value: verse.version,
                                                    disabled: isSaving,
                                                    onChange: (e)=>updateVerse(verse.key, {
                                                            version: e.target.value
                                                        })
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "remove-button",
                                                    "aria-label": "Remove verse",
                                                    disabled: isSaving,
                                                    onClick: ()=>update('verses', draft.verses.filter((candidate)=>candidate.key !== verse.key)),
                                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f382a5c80f18c5e3$exports))),
                                                        alt: "",
                                                        "aria-hidden": "true"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }, verse.key)),
                            draft.verses.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "separator"
                            }) : null,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                className: "add-button",
                                disabled: isSaving,
                                onClick: ()=>update('verses', [
                                        ...draft.verses,
                                        {
                                            key: $4a2fec0e077f8fd2$var$nextVerseKey++,
                                            book: 'genesis',
                                            chapter: '',
                                            verse: '',
                                            version: ''
                                        }
                                    ]),
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5c0a9c99fa42f0$exports))),
                                        alt: "",
                                        "aria-hidden": "true"
                                    }),
                                    "Add Verse"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: "Launchpad and the Salt app will automatically generate BibleGateway links for the selected verse and translation."
                    }),
                    !isSaveBarMounted && savedNotice ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "save-bar saved",
                        role: "status",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-bar-status",
                            children: savedNotice === 'created' ? 'Service created.' : 'Changes saved.'
                        })
                    }) : null,
                    isSaveBarMounted ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: [
                            'save-bar',
                            error ? 'has-error' : '',
                            isSaveBarLeaving ? 'is-leaving' : ''
                        ].join(' ').trim(),
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: error ? 'save-bar-error is-open' : 'save-bar-error',
                                "aria-hidden": !error,
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "save-bar-error-clip",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        role: error ? 'alert' : undefined,
                                        children: error !== null && error !== void 0 ? error : lastError
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "save-bar-row",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "save-bar-status",
                                        children: problems.length > 0 ? problems[0] : isNew ? 'Ready to create.' : 'You have unsaved changes.'
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "button",
                                        className: "discard-button",
                                        disabled: isSaving || isSaveBarLeaving,
                                        onClick: ()=>{
                                            // A new service has nothing to go back to, so this leaves it.
                                            if (isNew) {
                                                navigate(props.backLocation);
                                                return;
                                            }
                                            setDraft(initialDraft);
                                            setError(null);
                                        },
                                        children: isNew ? 'Cancel' : 'Discard'
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                        type: "submit",
                                        className: "save-button",
                                        disabled: !canSave || isSaveBarLeaving,
                                        children: isNew ? isSaving ? 'Creating...' : 'Create Service' : isSaving ? 'Saving...' : 'Save Changes'
                                    })
                                ]
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}







var $7fPBF = parcelRequire("7fPBF");







// Sanctuary files a service or series without a category as the campus's
// uncategorized ones, and lists them when no category is asked for.
const $596f8705576f4935$var$NO_CATEGORY = '';
function $596f8705576f4935$export$9b80eb666acf04e4() {
    const { church: church, campuses: campuses, categories: categories } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const isReady = church !== undefined;
    const [searchParams, setSearchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const requestedCampusID = searchParams.get('campus');
    var _searchParams_get;
    const requestedCategoryID = (_searchParams_get = searchParams.get('category')) !== null && _searchParams_get !== void 0 ? _searchParams_get : $596f8705576f4935$var$NO_CATEGORY;
    var _campuses_find;
    // A campus or category that's since been deleted reads as unchosen rather
    // than asking the API for something that isn't there.
    // A lone campus is used straight away, rather than chosen by an effect
    // after the first render, which would flash "Choose a Campus" first.
    const campus = (_campuses_find = campuses.find((candidate)=>candidate.id === requestedCampusID)) !== null && _campuses_find !== void 0 ? _campuses_find : campuses.length === 1 ? campuses[0] : null;
    var _categories_find;
    const category = (_categories_find = categories.find((candidate)=>candidate.id === requestedCategoryID)) !== null && _categories_find !== void 0 ? _categories_find : null;
    const select = (campusID, categoryID)=>{
        const params = new URLSearchParams();
        if (campusID) params.set('campus', campusID);
        if (categoryID) params.set('category', categoryID);
        setSearchParams(params, {
            replace: true
        });
    };
    return {
        campus: campus,
        category: category,
        hasCampuses: campuses.length > 0,
        isReady: isReady,
        select: select
    };
}
function $596f8705576f4935$export$2e2bcd8739ae039(props) {
    var _props_campus, _props_category;
    const { campuses: campuses, categories: categories } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const sortedCampuses = [
        ...campuses
    ].sort((one, two)=>one.attributes.name.localeCompare(two.attributes.name));
    const sortedCategories = [
        ...categories
    ].sort((one, two)=>one.name.localeCompare(two.name));
    var _props_campus_id, _props_category_id;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "services-filters",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                className: "services-filter search",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                    type: "search",
                    "aria-label": "Search",
                    value: props.query,
                    placeholder: props.searchPlaceholder,
                    disabled: !props.campus,
                    onChange: (e)=>props.onQueryChange(e.target.value)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                className: "services-filter",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                    "aria-label": "Campus",
                    value: (_props_campus_id = (_props_campus = props.campus) === null || _props_campus === void 0 ? void 0 : _props_campus.id) !== null && _props_campus_id !== void 0 ? _props_campus_id : '',
                    onChange: (e)=>{
                        var _props_category;
                        var _props_category_id;
                        return props.select(e.target.value, (_props_category_id = (_props_category = props.category) === null || _props_category === void 0 ? void 0 : _props_category.id) !== null && _props_category_id !== void 0 ? _props_category_id : $596f8705576f4935$var$NO_CATEGORY);
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                            value: "",
                            disabled: true,
                            children: "Choose a campus"
                        }),
                        sortedCampuses.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                value: option.id,
                                children: option.attributes.name
                            }, option.id))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                className: "services-filter",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                    "aria-label": "Category",
                    value: (_props_category_id = (_props_category = props.category) === null || _props_category === void 0 ? void 0 : _props_category.id) !== null && _props_category_id !== void 0 ? _props_category_id : $596f8705576f4935$var$NO_CATEGORY,
                    disabled: !props.campus,
                    onChange: (e)=>{
                        var _props_campus;
                        var _props_campus_id;
                        return props.select((_props_campus_id = (_props_campus = props.campus) === null || _props_campus === void 0 ? void 0 : _props_campus.id) !== null && _props_campus_id !== void 0 ? _props_campus_id : '', e.target.value);
                    },
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                            value: $596f8705576f4935$var$NO_CATEGORY,
                            children: "No Category"
                        }),
                        sortedCategories.map((option)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                value: option.id,
                                children: option.name
                            }, option.id))
                    ]
                })
            })
        ]
    });
}


var $55cab1b870ffe3ff$exports = {};
$55cab1b870ffe3ff$exports = $parcel$resolve("khbCc");


// Long enough that a quick load never shows the spinner at all.
const $d91f6cd1037b45b2$var$SPINNER_DELAY_MS = 250;
function $d91f6cd1037b45b2$export$b3a5f6438faf69ff(series) {
    return `/services/series/${series.id}?${new URLSearchParams({
        campus: series.attributes.campusID
    }).toString()}`;
}
function $d91f6cd1037b45b2$export$32d83b3e60948478(campusID, categoryID) {
    const params = new URLSearchParams();
    if (campusID) params.set('campus', campusID);
    if (categoryID) params.set('category', categoryID);
    const query = params.toString();
    return query ? `/services/series?${query}` : '/services/series';
}
function $d91f6cd1037b45b2$export$2e2bcd8739ae039() {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { campus: campus, category: category, hasCampuses: hasCampuses, isReady: isReady, select: select } = (0, $596f8705576f4935$export$9b80eb666acf04e4)();
    const [query, setQuery] = (0, $7fPBF.useState)('');
    var _campus_id, _category_id;
    const { series: series, loading: loading, hasLoaded: hasLoaded, error: error, hasMore: hasMore, isLoadingMore: isLoadingMore, loadMore: loadMore, refetch: refetch } = (0, $0839360f84148e9b$export$5a8ecf1f06a8addb)((_campus_id = campus === null || campus === void 0 ? void 0 : campus.id) !== null && _campus_id !== void 0 ? _campus_id : null, (_category_id = category === null || category === void 0 ? void 0 : category.id) !== null && _category_id !== void 0 ? _category_id : null);
    var _campus_attributes_name, _category_name;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "services-page series-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $596f8705576f4935$export$2e2bcd8739ae039), {
                campus: campus,
                category: category,
                select: select,
                query: query,
                onQueryChange: setQuery,
                searchPlaceholder: "Search by name"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d91f6cd1037b45b2$var$SeriesResults, {
                isReady: isReady,
                hasCampuses: hasCampuses,
                campusName: (_campus_attributes_name = campus === null || campus === void 0 ? void 0 : campus.attributes.name) !== null && _campus_attributes_name !== void 0 ? _campus_attributes_name : null,
                categoryName: (_category_name = category === null || category === void 0 ? void 0 : category.name) !== null && _category_name !== void 0 ? _category_name : null,
                series: series,
                query: query,
                loading: loading,
                hasLoaded: hasLoaded,
                error: error,
                hasMore: hasMore,
                isLoadingMore: isLoadingMore,
                loadMore: loadMore,
                refetch: ()=>void refetch(),
                onOpen: (item)=>{
                    const state = {
                        series: item
                    };
                    navigate($d91f6cd1037b45b2$export$b3a5f6438faf69ff(item), {
                        state: state
                    });
                }
            })
        ]
    });
}
function $d91f6cd1037b45b2$var$SeriesResults(props) {
    // Until the church loads, no campuses means "not yet", not "none".
    if (!props.isReady) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "services-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
            fullScreen: false,
            delayMs: $d91f6cd1037b45b2$var$SPINNER_DELAY_MS
        })
    });
    if (!props.hasCampuses) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55cab1b870ffe3ff$exports))),
        title: "No Campuses Yet",
        error: "Series belong to a campus. Add a campus in Settings to get started.",
        showButton: false,
        fullHeight: true
    });
    if (!props.campusName) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55cab1b870ffe3ff$exports))),
        title: "Choose a Campus",
        error: "Pick a campus above to see its series. You can narrow them to a category too.",
        showButton: false,
        fullHeight: true
    });
    if (props.loading && !props.hasLoaded) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "services-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
            fullScreen: false,
            delayMs: $d91f6cd1037b45b2$var$SPINNER_DELAY_MS
        })
    });
    // A failed Load More keeps what's already shown; only a failed first page
    // takes over.
    if (props.error && props.series.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        error: props.error,
        buttonText: "Retry",
        buttonAction: props.refetch,
        fullHeight: true
    });
    if (props.series.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55cab1b870ffe3ff$exports))),
        title: "No Series Yet",
        error: props.categoryName ? `${props.campusName} doesn't have any series in ${props.categoryName} yet. Series group services that belong together, like a sermon series.` : `${props.campusName} doesn't have any series without a category yet. Series group services that belong together, like a sermon series.`,
        showButton: false,
        fullHeight: true
    });
    const needle = props.query.trim().toLowerCase();
    const matches = needle ? props.series.filter((item)=>{
        var _item_attributes_name;
        return ((_item_attributes_name = item.attributes.name) !== null && _item_attributes_name !== void 0 ? _item_attributes_name : '').toLowerCase().includes(needle);
    }) : props.series;
    // Search covers the pages loaded so far, so while there are more it says so,
    // and offers to look further.
    if (matches.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55cab1b870ffe3ff$exports))),
        title: "No Matches",
        error: props.hasMore ? `None of the ${props.series.length} series loaded so far match "${props.query.trim()}". Older series haven't been searched yet.` : `No series match "${props.query.trim()}".`,
        showButton: props.hasMore,
        buttonText: props.isLoadingMore ? "Loading\u2026" : 'Search Older Series',
        buttonAction: props.loadMore,
        fullHeight: true
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            needle && props.hasMore ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "services-search-note",
                children: [
                    "Showing matches from the ",
                    props.series.length,
                    " most recent series. Load more to search older ones."
                ]
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "series-grid",
                children: matches.map((item)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d91f6cd1037b45b2$var$SeriesCard, {
                        series: item,
                        onClick: ()=>props.onOpen(item)
                    }, item.id))
            }),
            props.error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "services-error",
                children: props.error
            }) : null,
            props.hasMore ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "services-load-more",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    disabled: props.isLoadingMore,
                    onClick: props.loadMore,
                    children: props.isLoadingMore ? "Loading\u2026" : 'Load More'
                })
            }) : null
        ]
    });
}
// A thumbnail and a name, and nothing else.
function $d91f6cd1037b45b2$var$SeriesCard(props) {
    const attributes = props.series.attributes;
    const name = attributes.name || 'Untitled Series';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
        type: "button",
        className: "series-card card",
        onClick: props.onClick,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "series-thumbnail",
                children: attributes.thumbnailURL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: attributes.thumbnailURL,
                    alt: "",
                    "aria-hidden": "true"
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "thumbnail-fallback",
                    "aria-hidden": "true",
                    children: name.slice(0, 1)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                className: "series-name",
                children: name
            })
        ]
    });
}


const $470393d7db593e2c$var$LIBRARY_PATH = '/services';
const $470393d7db593e2c$var$SERIES_PATH = '/services/series';
function $470393d7db593e2c$export$2e2bcd8739ae039() {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const [searchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const isLibrary = location.pathname === $470393d7db593e2c$var$LIBRARY_PATH;
    const isSeriesList = location.pathname === $470393d7db593e2c$var$SERIES_PATH;
    // Keyed per open, so each new series starts blank.
    const [isNewSeriesOpen, setIsNewSeriesOpen] = (0, $7fPBF.useState)(false);
    const [newSeriesKey, setNewSeriesKey] = (0, $7fPBF.useState)(0);
    let buttons;
    if (isLibrary) buttons = [
        {
            label: 'New Service',
            icon: 'add',
            // Starts at the campus and category All Services is showing.
            onClick: ()=>navigate((0, $4a2fec0e077f8fd2$export$b4820472e653f2ab)(searchParams.get('campus'), searchParams.get('category')))
        }
    ];
    else if (isSeriesList) buttons = [
        {
            label: 'New Series',
            icon: 'add',
            onClick: ()=>{
                setNewSeriesKey((current)=>current + 1);
                setIsNewSeriesOpen(true);
            }
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "services-layout",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ae515035e6d7062$export$2e2bcd8739ae039), {
                title: "Services",
                tabs: [
                    {
                        label: 'All Services',
                        path: $470393d7db593e2c$var$LIBRARY_PATH
                    },
                    {
                        label: 'Series',
                        path: $470393d7db593e2c$var$SERIES_PATH
                    }
                ],
                buttons: buttons
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ebd48de221e02da$export$2e2bcd8739ae039), {
                isOpen: isNewSeriesOpen,
                // Starts at the campus and category the Series tab is showing.
                initialCampusID: searchParams.get('campus'),
                initialCategoryID: searchParams.get('category'),
                close: ()=>setIsNewSeriesOpen(false),
                onSaved: (created)=>{
                    setIsNewSeriesOpen(false);
                    const state = {
                        series: created
                    };
                    navigate((0, $d91f6cd1037b45b2$export$b3a5f6438faf69ff)(created), {
                        state: state
                    });
                }
            }, `new-series-${newSeriesKey}`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$910ae8079b2c2852), {})
        ]
    });
}




var $7fPBF = parcelRequire("7fPBF");








function $37edaa0adb9cf942$export$2e2bcd8739ae039(campusID, categoryID) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    // Staff who manage services also see ones that haven't happened yet.
    const includeUpcoming = auth.hasPermission((0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_SERVICES);
    const key = churchID && campusID ? `${campusID}|${categoryID !== null && categoryID !== void 0 ? categoryID : ''}|${includeUpcoming}` : null;
    const list = (0, $46e12f9e434dd2e4$export$2e2bcd8739ae039)(key, async (cursor)=>{
        const response = await (0, $97638f75b6ce75cf$export$2e2bcd8739ae039).fetchServices(churchID, campusID, categoryID, includeUpcoming, cursor, auth);
        const body = response.body;
        if (response.error || !body) return {
            error: response.error || 'Failed to load services.',
            status: response.status
        };
        var _body_results, _body_nextLastServiceID;
        return {
            items: (_body_results = body.results) !== null && _body_results !== void 0 ? _body_results : [],
            hasMore: body.hasMore === true,
            next: (_body_nextLastServiceID = body.nextLastServiceID) !== null && _body_nextLastServiceID !== void 0 ? _body_nextLastServiceID : null
        };
    });
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, list), {
        services: list.items
    });
}







function $734844d741f57652$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ol", {
        className: "services-list",
        children: props.services.map((service)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($734844d741f57652$var$ServiceRow, {
                service: service,
                backLocation: props.backLocation
            }, service.id))
    });
}
function $734844d741f57652$var$ServiceRow(props) {
    var _attributes_songs, _attributes_media;
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const attributes = props.service.attributes;
    const date = $734844d741f57652$var$parseDate(attributes.timestamp);
    const isUpcoming = date !== null && date.getTime() > Date.now();
    var _attributes_songs_length;
    const songCount = (_attributes_songs_length = (_attributes_songs = attributes.songs) === null || _attributes_songs === void 0 ? void 0 : _attributes_songs.length) !== null && _attributes_songs_length !== void 0 ? _attributes_songs_length : 0;
    var _attributes_media_length;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
            type: "button",
            className: "service-row",
            onClick: ()=>{
                const state = {
                    service: props.service,
                    backLocation: props.backLocation
                };
                navigate((0, $4a2fec0e077f8fd2$export$4a8c15014d47b752)(props.service), {
                    state: state
                });
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "service-thumbnail",
                    children: attributes.thumbnailURL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: attributes.thumbnailURL,
                        alt: "",
                        "aria-hidden": "true"
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "thumbnail-fallback",
                        "aria-hidden": "true",
                        children: (attributes.title || '?').slice(0, 1)
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "service-body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            children: attributes.title || 'Untitled Service'
                        }),
                        date ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "service-date",
                            children: $734844d741f57652$var$formatDate(date)
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "service-tags",
                            children: [
                                isUpcoming ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "service-tag upcoming",
                                    children: "Upcoming"
                                }) : null,
                                songCount > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                    className: "service-tag",
                                    children: [
                                        songCount,
                                        " ",
                                        songCount === 1 ? 'song' : 'songs'
                                    ]
                                }) : null,
                                ((_attributes_media_length = (_attributes_media = attributes.media) === null || _attributes_media === void 0 ? void 0 : _attributes_media.length) !== null && _attributes_media_length !== void 0 ? _attributes_media_length : 0) > 0 || attributes.videoURL ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    className: "service-tag muted",
                                    children: "No media"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $734844d741f57652$export$24931f05a0d78759(services, query) {
    const needle = query.trim().toLowerCase();
    if (needle.length === 0) return services;
    return services.filter((service)=>{
        var _service_attributes_title, _service_attributes_description;
        return ((_service_attributes_title = service.attributes.title) !== null && _service_attributes_title !== void 0 ? _service_attributes_title : '').toLowerCase().includes(needle) || ((_service_attributes_description = service.attributes.description) !== null && _service_attributes_description !== void 0 ? _service_attributes_description : '').toLowerCase().includes(needle);
    });
}
// Timestamps arrive as ISO 8601. Anything unparseable is treated as absent
// rather than rendered as "Invalid Date".
function $734844d741f57652$var$parseDate(value) {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
function $734844d741f57652$var$formatDate(date) {
    return date.toLocaleString(undefined, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: date.getFullYear() === new Date().getFullYear() ? undefined : 'numeric',
        hour: 'numeric',
        minute: '2-digit'
    });
}



// Long enough that a quick load never shows the spinner at all.
const $fbeffcef14d41dff$var$SPINNER_DELAY_MS = 250;
function $fbeffcef14d41dff$export$2e2bcd8739ae039() {
    const { campus: campus, category: category, hasCampuses: hasCampuses, isReady: isReady, select: select } = (0, $596f8705576f4935$export$9b80eb666acf04e4)();
    const [query, setQuery] = (0, $7fPBF.useState)('');
    var _campus_id, _category_id;
    const { services: services, loading: loading, hasLoaded: hasLoaded, error: error, hasMore: hasMore, isLoadingMore: isLoadingMore, loadMore: loadMore, refetch: refetch } = (0, $37edaa0adb9cf942$export$2e2bcd8739ae039)((_campus_id = campus === null || campus === void 0 ? void 0 : campus.id) !== null && _campus_id !== void 0 ? _campus_id : null, (_category_id = category === null || category === void 0 ? void 0 : category.id) !== null && _category_id !== void 0 ? _category_id : null);
    var _campus_attributes_name, _category_name;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "services-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $596f8705576f4935$export$2e2bcd8739ae039), {
                campus: campus,
                category: category,
                select: select,
                query: query,
                onQueryChange: setQuery,
                searchPlaceholder: "Search by title or description"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($fbeffcef14d41dff$var$ServicesResults, {
                isReady: isReady,
                hasCampuses: hasCampuses,
                campusName: (_campus_attributes_name = campus === null || campus === void 0 ? void 0 : campus.attributes.name) !== null && _campus_attributes_name !== void 0 ? _campus_attributes_name : null,
                categoryName: (_category_name = category === null || category === void 0 ? void 0 : category.name) !== null && _category_name !== void 0 ? _category_name : null,
                services: services,
                query: query,
                loading: loading,
                hasLoaded: hasLoaded,
                error: error,
                hasMore: hasMore,
                isLoadingMore: isLoadingMore,
                loadMore: loadMore,
                refetch: ()=>{
                    refetch();
                }
            })
        ]
    });
}
function $fbeffcef14d41dff$var$ServicesResults(props) {
    // Until the church loads, no campuses means "not yet", not "none".
    if (!props.isReady) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "services-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
            fullScreen: false,
            delayMs: $fbeffcef14d41dff$var$SPINNER_DELAY_MS
        })
    });
    if (!props.hasCampuses) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55cab1b870ffe3ff$exports))),
        title: "No Campuses Yet",
        error: "Services belong to a campus. Add a campus in Settings to get started.",
        showButton: false,
        fullHeight: true
    });
    if (!props.campusName) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55cab1b870ffe3ff$exports))),
        title: "Choose a Campus",
        error: "Pick a campus above to see its services. You can narrow them to a category too.",
        showButton: false,
        fullHeight: true
    });
    if (props.loading && !props.hasLoaded) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "services-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
            fullScreen: false,
            delayMs: $fbeffcef14d41dff$var$SPINNER_DELAY_MS
        })
    });
    // A failed Load More keeps what's already listed; only a failed first page
    // takes over.
    if (props.error && props.services.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        error: props.error,
        buttonText: "Retry",
        buttonAction: props.refetch,
        fullHeight: true
    });
    if (props.services.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55cab1b870ffe3ff$exports))),
        title: "No Services",
        error: props.categoryName ? `${props.campusName} doesn't have any services in ${props.categoryName} yet.` : `${props.campusName} doesn't have any services without a category yet.`,
        showButton: false,
        fullHeight: true
    });
    const isSearching = props.query.trim().length > 0;
    const matches = (0, $734844d741f57652$export$24931f05a0d78759)(props.services, props.query);
    // Search only covers the pages loaded so far, so while there are more it
    // says so, and offers to look further.
    if (matches.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55cab1b870ffe3ff$exports))),
        title: "No Matches",
        error: props.hasMore ? `None of the ${props.services.length} services loaded so far match "${props.query.trim()}". Older services haven't been searched yet.` : `No services match "${props.query.trim()}".`,
        showButton: props.hasMore,
        buttonText: props.isLoadingMore ? "Loading\u2026" : 'Search Older Services',
        buttonAction: props.loadMore,
        fullHeight: true
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            isSearching && props.hasMore ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "services-search-note",
                children: [
                    "Showing matches from the ",
                    props.services.length,
                    " most recent services. Load more to search older ones."
                ]
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $734844d741f57652$export$2e2bcd8739ae039), {
                services: matches
            }),
            props.error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "services-error",
                children: props.error
            }) : null,
            props.hasMore ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "services-load-more",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    disabled: props.isLoadingMore,
                    onClick: props.loadMore,
                    children: props.isLoadingMore ? "Loading\u2026" : 'Load More'
                })
            }) : null
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");





const $5525fd712e6af2d3$var$HTTP_NOT_FOUND = 404;
function $5525fd712e6af2d3$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [isDeleting, setIsDeleting] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const name = props.series.attributes.name || 'this series';
    const deleteSeries = async ()=>{
        if (!auth.churchId) {
            setError('Missing church context. Please refresh and try again.');
            return;
        }
        setIsDeleting(true);
        setError(null);
        try {
            const response = await (0, $354a777975e62edf$export$2e2bcd8739ae039).deleteSeries(auth.churchId, props.series.id, auth);
            // Already gone, most likely deleted elsewhere: the outcome asked for.
            if (response.error && response.status !== $5525fd712e6af2d3$var$HTTP_NOT_FOUND) {
                setError(response.error);
                return;
            }
            props.onDeleted();
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "delete-series-modal",
        isOpen: props.isOpen,
        footerButtons: [
            {
                title: isDeleting ? 'Deleting...' : 'Delete Series',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !isDeleting,
                onClick: ()=>{
                    deleteSeries();
                }
            },
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !isDeleting,
                onClick: props.close
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "delete-series-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "close",
                            disabled: isDeleting,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: "Delete Series"
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "save-error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5407115776bd457c$exports))),
                            alt: "",
                            "aria-hidden": "true",
                            className: "warning-icon"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "warning-copy",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("strong", {
                                children: [
                                    "Are you sure you want to delete ",
                                    name,
                                    "?"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "warning-copy",
                            children: "It will be removed from Launchpad and the Salt app. Its services aren't deleted: they stay in All Services, just no longer part of a series. This action cannot be undone."
                        })
                    ]
                })
            ]
        })
    });
}









function $2a0c35f4183b1c04$export$2e2bcd8739ae039() {
    var _location_state, _campuses_find, _categories_find;
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { seriesID: seriesID } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const [searchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const { campuses: campuses, categories: categories } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    // Sanctuary finds a series through the campus it's filed in.
    const campusID = searchParams.get('campus');
    const { series: fetchedSeries, services: services, loading: loading, hasLoaded: hasLoaded, notFound: notFound, error: error, hasMore: hasMore, isLoadingMore: isLoadingMore, loadMore: loadMore, refetch: refetch } = (0, $0839360f84148e9b$export$5ca726549f7e2446)(campusID, seriesID !== null && seriesID !== void 0 ? seriesID : null);
    // The card that was clicked, so the heading is right before the request
    // comes back.
    const routedSeries = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.series;
    const series = fetchedSeries !== null && fetchedSeries !== void 0 ? fetchedSeries : (routedSeries === null || routedSeries === void 0 ? void 0 : routedSeries.id) === seriesID ? routedSeries : undefined;
    const [isEditorOpen, setIsEditorOpen] = (0, $7fPBF.useState)(false);
    const [editorKey, setEditorKey] = (0, $7fPBF.useState)(0);
    const [isDeleteOpen, setIsDeleteOpen] = (0, $7fPBF.useState)(false);
    const campusName = (_campuses_find = campuses.find((campus)=>campus.id === (series === null || series === void 0 ? void 0 : series.attributes.campusID))) === null || _campuses_find === void 0 ? void 0 : _campuses_find.attributes.name;
    const categoryName = (_categories_find = categories.find((category)=>category.id === (series === null || series === void 0 ? void 0 : series.attributes.categoryID))) === null || _categories_find === void 0 ? void 0 : _categories_find.name;
    const startDate = series ? new Date(series.attributes.startDate) : null;
    const started = startDate && !Number.isNaN(startDate.getTime()) ? `Started ${startDate.toLocaleDateString(undefined, {
        month: 'long',
        day: 'numeric',
        year: 'numeric'
    })}` : null;
    const place = [
        campusName,
        categoryName,
        started
    ].filter(Boolean).join(" \xb7 ");
    // Back to the list this series is filed in.
    const listPath = series ? (0, $d91f6cd1037b45b2$export$32d83b3e60948478)(series.attributes.campusID, series.attributes.categoryID) : (0, $d91f6cd1037b45b2$export$32d83b3e60948478)(campusID, null);
    const isMissing = notFound || !campusID;
    let results;
    if (isMissing) results = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        title: "Series Not Found",
        error: "This series doesn't exist, or it's been deleted.",
        showButton: false,
        fullHeight: true
    });
    else if (error && services.length === 0) results = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        error: error,
        buttonText: "Retry",
        buttonAction: ()=>void refetch(),
        fullHeight: true
    });
    else if (loading && !hasLoaded) results = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "services-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
            fullScreen: false,
            delayMs: 250
        })
    });
    else if (services.length === 0) results = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55cab1b870ffe3ff$exports))),
        title: "No Services Yet",
        error: "A service joins this series when it\u2019s chosen as its series, under Schedule on the service\u2019s page.",
        showButton: false,
        fullHeight: true
    });
    else results = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $734844d741f57652$export$2e2bcd8739ae039), {
                services: services,
                backLocation: series ? (0, $d91f6cd1037b45b2$export$b3a5f6438faf69ff)(series) : undefined
            }),
            error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "services-error",
                children: error
            }) : null,
            hasMore ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "services-load-more",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    disabled: isLoadingMore,
                    onClick: loadMore,
                    children: isLoadingMore ? "Loading\u2026" : 'Load More'
                })
            }) : null
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "services-page series-services-page",
        children: [
            series ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1ebd48de221e02da$export$2e2bcd8739ae039), {
                        isOpen: isEditorOpen,
                        series: series,
                        close: ()=>setIsEditorOpen(false),
                        onSaved: (saved)=>{
                            setIsEditorOpen(false);
                            // A new campus files it elsewhere, so the URL follows it; either
                            // way the page reloads what's stored now.
                            const state = {
                                series: saved
                            };
                            if (saved.attributes.campusID !== campusID) navigate((0, $d91f6cd1037b45b2$export$b3a5f6438faf69ff)(saved), {
                                replace: true,
                                state: state
                            });
                            else refetch();
                        }
                    }, `series-editor-${editorKey}`),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5525fd712e6af2d3$export$2e2bcd8739ae039), {
                        isOpen: isDeleteOpen,
                        series: series,
                        close: ()=>setIsDeleteOpen(false),
                        // Replaced, so Back doesn't return to a series that's gone.
                        onDeleted: ()=>navigate(listPath, {
                                replace: true
                            })
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $a0cf24fd73ae067c$export$a6c7ac8248d6e38a), {
                to: listPath,
                className: "series-back",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: "icon",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($48a08cc73bd1bdd6$exports))),
                        alt: "",
                        "aria-hidden": "true"
                    }),
                    "Back"
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "series-heading",
                children: [
                    (series === null || series === void 0 ? void 0 : series.attributes.thumbnailURL) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: "series-heading-thumbnail",
                        src: series.attributes.thumbnailURL,
                        alt: "",
                        "aria-hidden": "true"
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "series-heading-text",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: (series === null || series === void 0 ? void 0 : series.attributes.name) || (isMissing ? 'Series' : '')
                            }),
                            series ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                children: [
                                    place,
                                    place && hasLoaded ? " \xb7 " : '',
                                    hasLoaded ? `${services.length}${hasMore ? '+' : ''} ${services.length === 1 && !hasMore ? 'service' : 'services'}` : ''
                                ]
                            }) : null
                        ]
                    }),
                    series ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "series-actions",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>{
                                    setEditorKey((current)=>current + 1);
                                    setIsEditorOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a9cdc003ba228dda$exports))),
                                        alt: "",
                                        "aria-hidden": "true"
                                    }),
                                    "Edit"
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                type: "button",
                                onClick: ()=>setIsDeleteOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f382a5c80f18c5e3$exports))),
                                        alt: "",
                                        "aria-hidden": "true"
                                    }),
                                    "Delete"
                                ]
                            })
                        ]
                    }) : null
                ]
            }),
            results
        ]
    });
}







function $78ffe0c21bc67c21$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "launchpad-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ae515035e6d7062$export$2e2bcd8739ae039), {
                title: "Launchpad",
                tabs: []
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$910ae8079b2c2852), {})
        ]
    });
}







class $6ffd02048d6f1e28$export$2e2bcd8739ae039 {
    static async fetchLaunchpads(churchID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/launchpad`), auth.consumeRefreshToken);
    }
    // Single-Launchpad responses carry more than the Launchpad itself (latest
    // service, playlists, events); we only read the metadata off them.
    static async fetchLaunchpad(churchID, launchpadID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/launchpad/${launchpadID}`), auth.consumeRefreshToken);
    }
    // Replaces the Launchpad's attributes and its tag together. The API treats a
    // missing tag as giving it up, so every update has to say which tag the
    // Launchpad keeps; null releases it.
    static async updateLaunchpad(churchID, launchpadID, tag, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/launchpad/${launchpadID}`, {
            tag: tag,
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    // A tag is optional here; null creates the Launchpad without one.
    static async createLaunchpad(churchID, tag, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/launchpad`, {
            tag: tag,
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    static async createAssetUploadTarget(churchID, contentType, fileSizeBytes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/assets/upload-target`, {
            assetType: 'launchpad',
            contentType: contentType,
            fileSizeBytes: fileSizeBytes
        }), auth.consumeRefreshToken);
    }
    static async deleteLaunchpad(churchID, launchpadID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/launchpad/${launchpadID}`), auth.consumeRefreshToken);
    }
}
$6ffd02048d6f1e28$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";




var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");








function $42e9a645849f7eb0$export$2e2bcd8739ae039(props) {
    var _props_launchpad, _props_launchpad1, _props_launchpad2, _props_launchpad3, _props_launchpad4, _props_launchpad5, _props_launchpad6;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    var _props_launchpad_metadata_attributes_name;
    const modalTitle = (_props_launchpad_metadata_attributes_name = (_props_launchpad = props.launchpad) === null || _props_launchpad === void 0 ? void 0 : _props_launchpad.metadata.attributes.name) !== null && _props_launchpad_metadata_attributes_name !== void 0 ? _props_launchpad_metadata_attributes_name : 'New Launchpad View';
    var _props_launchpad_metadata_attributes_name1;
    const [name, setName] = (0, $7fPBF.useState)((_props_launchpad_metadata_attributes_name1 = (_props_launchpad1 = props.launchpad) === null || _props_launchpad1 === void 0 ? void 0 : _props_launchpad1.metadata.attributes.name) !== null && _props_launchpad_metadata_attributes_name1 !== void 0 ? _props_launchpad_metadata_attributes_name1 : '');
    var _props_launchpad_metadata_attributes_description;
    const [description, setDescription] = (0, $7fPBF.useState)((_props_launchpad_metadata_attributes_description = (_props_launchpad2 = props.launchpad) === null || _props_launchpad2 === void 0 ? void 0 : _props_launchpad2.metadata.attributes.description) !== null && _props_launchpad_metadata_attributes_description !== void 0 ? _props_launchpad_metadata_attributes_description : '');
    var _props_launchpad_metadata_attributes_campusID;
    const [campusID, setCampusID] = (0, $7fPBF.useState)((_props_launchpad_metadata_attributes_campusID = (_props_launchpad3 = props.launchpad) === null || _props_launchpad3 === void 0 ? void 0 : _props_launchpad3.metadata.attributes.campusID) !== null && _props_launchpad_metadata_attributes_campusID !== void 0 ? _props_launchpad_metadata_attributes_campusID : '');
    var _props_launchpad_metadata_attributes_categoryID;
    const [categoryID, setCategoryID] = (0, $7fPBF.useState)((_props_launchpad_metadata_attributes_categoryID = (_props_launchpad4 = props.launchpad) === null || _props_launchpad4 === void 0 ? void 0 : _props_launchpad4.metadata.attributes.categoryID) !== null && _props_launchpad_metadata_attributes_categoryID !== void 0 ? _props_launchpad_metadata_attributes_categoryID : '');
    var _props_launchpad_tag;
    const [tag, setTag] = (0, $7fPBF.useState)((_props_launchpad_tag = (_props_launchpad5 = props.launchpad) === null || _props_launchpad5 === void 0 ? void 0 : _props_launchpad5.tag) !== null && _props_launchpad_tag !== void 0 ? _props_launchpad_tag : '');
    // Optional: an empty tag means none. Checked as typed with Sanctuary's rules;
    // whether it's taken is only known on save.
    const trimmedTag = (0, $4492b6a3f2f323df$export$8634d0e3ad628eed)(tag);
    const tagProblem = trimmedTag.length > 0 ? (0, $4492b6a3f2f323df$export$3e16a84b016b16b8)(trimmedTag) : null;
    // A Launchpad shown from list metadata doesn't know its tag until its own
    // fetch returns, and saving then would release whatever it holds.
    const isTagUnknown = props.launchpad !== null && props.launchpad !== undefined && props.launchpad.tag === undefined;
    const [isCategoryPickerOpen, setIsCategoryPickerOpen] = (0, $7fPBF.useState)(false);
    const [logoFile, setLogoFile] = (0, $7fPBF.useState)(null);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const existingAttributes = (_props_launchpad6 = props.launchpad) === null || _props_launchpad6 === void 0 ? void 0 : _props_launchpad6.metadata.attributes;
    var _existingAttributes_logoURL;
    const existingLogoURL = (_existingAttributes_logoURL = existingAttributes === null || existingAttributes === void 0 ? void 0 : existingAttributes.logoURL) !== null && _existingAttributes_logoURL !== void 0 ? _existingAttributes_logoURL : null;
    const saveLaunchpad = async ()=>{
        if (!auth.churchId) {
            setError('Missing church context. Please refresh and try again.');
            return;
        }
        const trimmedName = name.trim();
        if (trimmedName.length === 0) {
            setError('Please give this Launchpad a title.');
            return;
        }
        const trimmedDescription = description.trim();
        if (trimmedDescription.length === 0) {
            setError('Please give this Launchpad a description.');
            return;
        }
        if (!campusID) {
            setError('Please select a campus for this Launchpad.');
            return;
        }
        if (tagProblem) {
            setError(tagProblem);
            return;
        }
        if (isTagUnknown) {
            setError('This Launchpad is still loading. Please try again in a moment.');
            return;
        }
        const tagToSave = trimmedTag.length > 0 ? trimmedTag : null;
        setIsSaving(true);
        setError(null);
        try {
            let logoURL = existingLogoURL;
            if (logoFile) {
                const uploadTargetResponse = await (0, $6ffd02048d6f1e28$export$2e2bcd8739ae039).createAssetUploadTarget(auth.churchId, logoFile.type || 'application/octet-stream', logoFile.size, auth);
                if (!uploadTargetResponse.body) {
                    setError(uploadTargetResponse.error || 'Unable to create an upload target for the logo image.');
                    setIsSaving(false);
                    return;
                }
                const uploadSucceeded = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performSignedPost({
                    url: uploadTargetResponse.body.url,
                    fields: uploadTargetResponse.body.fields
                }, logoFile, logoFile.type);
                if (!uploadSucceeded) {
                    setError('The logo upload failed. Please try again.');
                    setIsSaving(false);
                    return;
                }
                logoURL = uploadTargetResponse.body.assetURL;
            }
            var _existingAttributes_links;
            const attributes = (0, $4492b6a3f2f323df$export$89c9e789b0451492)({
                name: trimmedName,
                description: trimmedDescription,
                logoURL: logoURL,
                campusID: campusID || null,
                categoryID: categoryID || null,
                links: (_existingAttributes_links = existingAttributes === null || existingAttributes === void 0 ? void 0 : existingAttributes.links) !== null && _existingAttributes_links !== void 0 ? _existingAttributes_links : []
            });
            const response = props.launchpad ? await (0, $6ffd02048d6f1e28$export$2e2bcd8739ae039).updateLaunchpad(auth.churchId, props.launchpad.launchpadID, tagToSave, attributes, auth) : await (0, $6ffd02048d6f1e28$export$2e2bcd8739ae039).createLaunchpad(auth.churchId, tagToSave, attributes, auth);
            if (response.error) {
                setError(response.error);
                setIsSaving(false);
                return;
            }
            var _launchpadFromResponse;
            // The save went through, so fall back to what we sent if the response
            // isn't in a shape we can read.
            const savedLaunchpad = (_launchpadFromResponse = (0, $4492b6a3f2f323df$export$8d56d0b92b79b4fa)(response.body)) !== null && _launchpadFromResponse !== void 0 ? _launchpadFromResponse : props.launchpad ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.launchpad), {
                tag: tagToSave,
                metadata: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.launchpad.metadata), {
                    attributes: attributes
                })
            }) : null;
            if (!savedLaunchpad) {
                setError('This Launchpad was saved, but the response could not be read. Please refresh.');
                setIsSaving(false);
                return;
            }
            props.onSaved(savedLaunchpad);
        } finally{
            setIsSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "launchpad-view-modal",
        isOpen: props.isOpen,
        footerButtons: [
            {
                title: props.launchpad ? 'Save Changes' : 'Create Launchpad View',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !isSaving && description.trim().length > 0 && campusID.length > 0 && !tagProblem,
                onClick: saveLaunchpad
            },
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !isSaving,
                onClick: props.close
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "launchpad-view-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            "aria-disabled": isSaving,
                            className: isSaving ? 'close disabled' : 'close',
                            href: "#",
                            onClick: (e)=>{
                                e.preventDefault();
                                if (isSaving) return;
                                props.close();
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: modalTitle
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "save-error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "launchpad-name",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    id: "launchpad-name",
                                    type: "text",
                                    name: "launchpad-name",
                                    placeholder: "Launchpad Name",
                                    value: name,
                                    onChange: (e)=>setName(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "caption",
                                    children: "Who is this Launchpad for? We recommend including the campus name itself, as well as the category."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "launchpad-description",
                                    children: "Description"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                    id: "launchpad-description",
                                    name: "launchpad-description",
                                    rows: 3,
                                    placeholder: "Description",
                                    value: description,
                                    onChange: (e)=>setDescription(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "caption",
                                    children: "A short summary of what people will find on this Launchpad."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "launchpad-tag",
                                    children: "Tag"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: tagProblem ? 'tag-input has-problem' : 'tag-input',
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                                            className: "tag-prefix",
                                            "aria-hidden": "true",
                                            children: [
                                                (0, $4492b6a3f2f323df$export$90400aecdf75d9f6).replace(/^https?:\/\//, ''),
                                                "/t/"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                            id: "launchpad-tag",
                                            type: "text",
                                            name: "launchpad-tag",
                                            placeholder: "your-church",
                                            autoCapitalize: "none",
                                            autoCorrect: "off",
                                            spellCheck: false,
                                            maxLength: 40,
                                            disabled: isTagUnknown,
                                            value: tag,
                                            // Lower-cased as typed, since that's how Sanctuary stores it.
                                            onChange: (e)=>setTag(e.target.value.toLowerCase())
                                        })
                                    ]
                                }),
                                tagProblem ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "caption tag-problem",
                                    children: tagProblem
                                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "caption",
                                    children: isTagUnknown ? "Loading this Launchpad\u2019s tag\u2026" : 'Optional. A short, memorable address for this Launchpad, like a link in a bulletin or on a slide. Tags are unique across Salt, and removing one frees it for anyone to claim.'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "launchpad-logo",
                                    children: "Logo"
                                }),
                                existingLogoURL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: existingLogoURL,
                                    alt: "Current logo",
                                    className: "logo-preview"
                                }) : null,
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    id: "launchpad-logo",
                                    type: "file",
                                    name: "launchpad-logo",
                                    accept: "image/*",
                                    onChange: (e)=>{
                                        var _e_target_files;
                                        var _e_target_files_;
                                        setLogoFile((_e_target_files_ = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0]) !== null && _e_target_files_ !== void 0 ? _e_target_files_ : null);
                                    }
                                }),
                                logoFile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    className: "caption",
                                    children: [
                                        "Selected: ",
                                        logoFile.name
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "caption",
                                    children: "Your logo image will be displayed in white or black at the top of Launchpad. For the best result, upload a logo with no background, where the logo touches the top and bottom edges of the frame."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "launchpad-campus",
                                    children: "Campus"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                    id: "launchpad-campus",
                                    value: campusID,
                                    onChange: (e)=>setCampusID(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: "",
                                            disabled: true,
                                            children: "Select a campus"
                                        }),
                                        churchData.campuses.map((campus)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: campus.id,
                                                children: campus.attributes.name
                                            }, campus.id))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "caption",
                                    children: "Launchpad will automatically display events, playlists, services, and more from the chosen campus."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "launchpad-categories-trigger",
                                    children: "Category"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                    id: "launchpad-category",
                                    value: categoryID,
                                    onChange: (e)=>setCategoryID(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: "",
                                            children: "No category"
                                        }),
                                        churchData.categories.map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: category.id,
                                                children: category.name
                                            }, category.id))
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "caption",
                                    children: "Selecting a category will filter what content is displayed on this Launchpad."
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $b683f9125e92b609$exports = {};
$b683f9125e92b609$exports = $parcel$resolve("7TP2d");


function $78790fb1db1697a8$export$2e2bcd8739ae039() {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [launchpads, setLaunchpads] = (0, $7fPBF.useState)([]);
    const [isLaunchpadModalOpen, setIsLaunchpadModalOpen] = (0, $7fPBF.useState)(false);
    const [newLaunchpadModalKey, setNewLaunchpadModalKey] = (0, $7fPBF.useState)(0);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        let isCancelled = false;
        const loadLaunchpads = async ()=>{
            var _response_body_results;
            if (!auth.churchId) return;
            setLoading(true);
            setError(null);
            const response = await (0, $6ffd02048d6f1e28$export$2e2bcd8739ae039).fetchLaunchpads(auth.churchId, auth);
            if (isCancelled) return;
            if (!response.body) {
                setError(response.error || 'Failed to load Launchpads.');
                setLoading(false);
                return;
            }
            setLaunchpads((_response_body_results = response.body.results) === null || _response_body_results === void 0 ? void 0 : _response_body_results.map((metadata)=>(0, $4492b6a3f2f323df$export$3b902ee20af0594e)(metadata)));
            setLoading(false);
        };
        loadLaunchpads();
        return ()=>{
            isCancelled = true;
        };
    }, [
        auth.churchId,
        auth.consumeRefreshToken
    ]);
    const openLaunchpad = (launchpad)=>{
        navigate(`/launchpad/${launchpad.launchpadID}`, {
            state: {
                launchpad: launchpad
            }
        });
    };
    if (loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "launchpad-views-page launchpad-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "launchpad-views-page",
        children: [
            error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "banner error",
                children: error
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42e9a645849f7eb0$export$2e2bcd8739ae039), {
                isOpen: isLaunchpadModalOpen,
                launchpad: null,
                close: ()=>setIsLaunchpadModalOpen(false),
                onSaved: (savedLaunchpad)=>{
                    setIsLaunchpadModalOpen(false);
                    openLaunchpad(savedLaunchpad);
                }
            }, `new-launchpad-${newLaunchpadModalKey}`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "launchpad-layout",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "launchpad-list-column",
                    children: [
                        launchpads.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "empty-state card",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    children: "No Launchpad Views yet"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: "A Launchpad View can be made for as many campuses or categories as you want."
                                })
                            ]
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "launchpad-card-grid",
                            children: [
                                launchpads.map((launchpad)=>{
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($78790fb1db1697a8$var$LaunchpadCard, {
                                        launchpad: launchpad,
                                        onClick: ()=>openLaunchpad(launchpad)
                                    }, launchpad.launchpadID);
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                    type: "button",
                                    className: "new-launchpad-card",
                                    onClick: ()=>{
                                        setNewLaunchpadModalKey((currentKey)=>currentKey + 1);
                                        setIsLaunchpadModalOpen(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5c0a9c99fa42f0$exports))),
                                            alt: "",
                                            "aria-hidden": "true"
                                        }),
                                        "New Launchpad View"
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}
function $78790fb1db1697a8$var$LaunchpadCard(props) {
    const attributes = props.launchpad.metadata.attributes;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
        type: "button",
        className: "launchpad-card card",
        onClick: props.onClick,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "launchpad-card-logo",
                children: attributes.logoURL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: attributes.logoURL,
                    alt: `${attributes.name} logo`
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($b683f9125e92b609$exports))),
                    alt: "",
                    "aria-hidden": "true",
                    className: "placeholder"
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "launchpad-card-heading",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: attributes.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($e5c73394f0bf85aa$exports))),
                        alt: "",
                        "aria-hidden": "true",
                        className: "chevron"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "launchpad-card-description",
                children: attributes.description
            })
        ]
    });
}



function $ebc7da599f03f738$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
        className: "launchpad-tags-view card",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "section-header",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                            children: "Launchpad Tags"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "Manage Launchpad tag definitions separately from individual pages."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "empty-state",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Tag management is next up"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "This tab is in place so we can add Launchpad Tag CRUD here without mixing it into the page editor."
                    })
                ]
            })
        ]
    });
}







var $7fPBF = parcelRequire("7fPBF");










var $7fPBF = parcelRequire("7fPBF");


var $839f0801e5bbc116$exports = {};
$839f0801e5bbc116$exports = $parcel$resolve("gZZwP");



// The iPhone 17 the frame is drawn from, in points: its screen is 1206x2622
// pixels at 3x, which is exactly the frame image's transparent screen. The
// page is laid out at this size and then scaled down to fit, so it wraps and
// arranges itself just as it does on the phone rather than at the few hundred
// pixels the preview has to spare.
const $d33450954367416e$var$DEVICE = {
    width: 402,
    height: 874,
    // Kept clear by the Dynamic Island's status bar, and the home indicator.
    safeAreaTop: 62,
    safeAreaBottom: 34
};
function $d33450954367416e$export$2e2bcd8739ae039(props) {
    const url = (0, $4492b6a3f2f323df$export$b82fb1b632b9b982)(props.launchpad);
    // The page is reloaded whenever the Launchpad changes, so an edit made here
    // shows up without a manual refresh.
    const version = JSON.stringify(props.launchpad.metadata.attributes);
    // How far the device-sized page is shrunk to fit the frame's screen. The
    // frame scales with the layout, so this follows its width as it changes.
    const screenRef = (0, $7fPBF.useRef)(null);
    const [scale, setScale] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useLayoutEffect)(()=>{
        const screen = screenRef.current;
        if (!screen) return;
        const measure = ()=>setScale(screen.clientWidth / $d33450954367416e$var$DEVICE.width);
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(screen);
        return ()=>observer.disconnect();
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "launchpad-view-preview",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "phone-shell",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "phone-screen",
                        ref: screenRef,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d33450954367416e$var$LivePage, {
                            url: url,
                            title: `${props.launchpad.metadata.attributes.name} preview`,
                            scale: scale
                        }, `${url}|${version}`)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($839f0801e5bbc116$exports))),
                        alt: "",
                        "aria-hidden": "true",
                        className: "iphone-frame"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                className: "launchpad-url",
                href: url,
                target: "_blank",
                rel: "noopener noreferrer",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        children: url.replace(/^https?:\/\//, '')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2f86ea90ef359998$exports))),
                        alt: "",
                        "aria-hidden": "true"
                    })
                ]
            })
        ]
    });
}
// Keyed by its caller, so each load starts with the spinner showing. The
// spinner sits outside the scaled device, so it isn't shrunk with the page.
function $d33450954367416e$var$LivePage(props) {
    const [hasLoaded, setHasLoaded] = (0, $7fPBF.useState)(false);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            hasLoaded ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "preview-loading",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                    fullScreen: false
                })
            }),
            props.scale !== null ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "device-viewport",
                style: {
                    width: $d33450954367416e$var$DEVICE.width,
                    height: $d33450954367416e$var$DEVICE.height,
                    paddingTop: $d33450954367416e$var$DEVICE.safeAreaTop,
                    paddingBottom: $d33450954367416e$var$DEVICE.safeAreaBottom,
                    transform: `scale(${props.scale})`
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("iframe", {
                    src: props.url,
                    title: props.title,
                    className: hasLoaded ? 'preview-frame is-loaded' : 'preview-frame',
                    onLoad: ()=>setHasLoaded(true)
                })
            }) : null
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");



function $434bab72884901a7$export$2e2bcd8739ae039(launchpad, onSaved) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const savedLinks = launchpad === null || launchpad === void 0 ? void 0 : launchpad.metadata.attributes.links;
    const [links, setLinks] = (0, $7fPBF.useState)(()=>$434bab72884901a7$export$ae83cf003c8ada01(savedLinks));
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    // The launchpad arrives after mount on a refresh, and is replaced again by a
    // save or an edit, so the draft follows whatever the server last confirmed.
    (0, $7fPBF.useEffect)(()=>{
        setLinks($434bab72884901a7$export$ae83cf003c8ada01(savedLinks));
        setError(null);
    }, [
        savedLinks
    ]);
    const hasUnsavedChanges = (0, $7fPBF.useMemo)(()=>{
        return !$434bab72884901a7$var$areLinksEqual(links, savedLinks);
    }, [
        links,
        savedLinks
    ]);
    const addLink = (0, $7fPBF.useCallback)(()=>{
        setLinks((current)=>$434bab72884901a7$var$withSortIndexes([
                ...current,
                {
                    id: $434bab72884901a7$var$createLinkID(),
                    name: '',
                    url: '',
                    sortIndex: current.length
                }
            ]));
    }, []);
    const updateLink = (0, $7fPBF.useCallback)((linkID, changes)=>{
        setLinks((current)=>current.map((link)=>link.id === linkID ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, link, changes) : link));
    }, []);
    const removeLink = (0, $7fPBF.useCallback)((linkID)=>{
        setLinks((current)=>$434bab72884901a7$var$withSortIndexes(current.filter((link)=>link.id !== linkID)));
    }, []);
    const moveLink = (0, $7fPBF.useCallback)((draggedLinkID, targetLinkID)=>{
        setLinks((current)=>$434bab72884901a7$var$reorderLinks(current, draggedLinkID, targetLinkID));
    }, []);
    const reset = (0, $7fPBF.useCallback)(()=>{
        setError(null);
        setLinks($434bab72884901a7$export$ae83cf003c8ada01(savedLinks));
    }, [
        savedLinks
    ]);
    const save = (0, $7fPBF.useCallback)(async ()=>{
        if (!launchpad) return;
        const result = await $434bab72884901a7$var$saveLinks(launchpad, links, auth);
        if (result.error) {
            setError(result.error);
            return;
        }
        setError(null);
        onSaved(result.launchpad);
    }, [
        launchpad,
        links,
        auth,
        onSaved
    ]);
    // The saving flag is set around the call rather than inside it so the async
    // helper stays free of component state.
    const saveWithState = (0, $7fPBF.useCallback)(async ()=>{
        setIsSaving(true);
        try {
            await save();
        } finally{
            setIsSaving(false);
        }
    }, [
        save
    ]);
    return {
        links: links,
        hasUnsavedChanges: hasUnsavedChanges,
        isSaving: isSaving,
        error: error,
        addLink: addLink,
        updateLink: updateLink,
        removeLink: removeLink,
        moveLink: moveLink,
        save: saveWithState,
        reset: reset
    };
}
async function $434bab72884901a7$var$saveLinks(launchpad, links, auth) {
    if (!auth.churchId) return {
        error: 'Missing church context. Please refresh and try again.'
    };
    const trimmedLinks = links.map((link)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, link), {
            name: link.name.trim(),
            url: link.url.trim()
        }));
    if (trimmedLinks.some((link)=>link.name.length === 0 || link.url.length === 0)) return {
        error: 'Every link needs a name and a URL.'
    };
    const attributes = (0, $4492b6a3f2f323df$export$89c9e789b0451492)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, launchpad.metadata.attributes), {
        links: trimmedLinks.map((_param)=>{
            var { id: id } = _param, link = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
                "id"
            ]);
            return link;
        })
    }));
    // Sending no tag would release it, so a save waits until the Launchpad's own
    // fetch has said which tag it holds.
    if (launchpad.tag === undefined) return {
        error: 'This Launchpad is still loading. Please try again in a moment.'
    };
    const response = await (0, $6ffd02048d6f1e28$export$2e2bcd8739ae039).updateLaunchpad(auth.churchId, launchpad.launchpadID, launchpad.tag, attributes, auth);
    if (response.error) return {
        error: response.error
    };
    var _launchpadFromResponse;
    // The save went through, so fall back to what we sent if the response isn't
    // in a shape we can read.
    return {
        launchpad: (_launchpadFromResponse = (0, $4492b6a3f2f323df$export$8d56d0b92b79b4fa)(response.body)) !== null && _launchpadFromResponse !== void 0 ? _launchpadFromResponse : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, launchpad), {
            metadata: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, launchpad.metadata), {
                attributes: attributes
            })
        })
    };
}
function $434bab72884901a7$export$ae83cf003c8ada01(links) {
    return $434bab72884901a7$var$withSortIndexes((links !== null && links !== void 0 ? links : []).map((link)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, link), {
            id: $434bab72884901a7$var$createLinkID()
        })));
}
// Position is what the API stores, so it's rewritten from array order after
// every structural change rather than tracked by hand.
function $434bab72884901a7$var$withSortIndexes(links) {
    return links.map((link, index)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, link), {
            sortIndex: index
        }));
}
function $434bab72884901a7$var$reorderLinks(links, draggedLinkID, targetLinkID) {
    const draggedIndex = links.findIndex((link)=>link.id === draggedLinkID);
    const targetIndex = links.findIndex((link)=>link.id === targetLinkID);
    if (draggedIndex === -1 || targetIndex === -1) return links;
    const reordered = [
        ...links
    ];
    const [dragged] = reordered.splice(draggedIndex, 1);
    reordered.splice(targetIndex, 0, dragged);
    return $434bab72884901a7$var$withSortIndexes(reordered);
}
// Compares name, URL, and order -- reordering alone is a change worth saving.
function $434bab72884901a7$var$areLinksEqual(links, savedLinks) {
    const saved = savedLinks !== null && savedLinks !== void 0 ? savedLinks : [];
    if (saved.length !== links.length) return false;
    return links.every((link, index)=>{
        return link.name.trim() === saved[index].name && link.url.trim() === saved[index].url;
    });
}
let $434bab72884901a7$var$linkIDCounter = 0;
function $434bab72884901a7$var$createLinkID() {
    $434bab72884901a7$var$linkIDCounter += 1;
    return `link-${$434bab72884901a7$var$linkIDCounter}`;
}





var $7fPBF = parcelRequire("7fPBF");






function $09ef1d323105615a$export$2e2bcd8739ae039(props) {
    var _props_launchpad;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [isDeleting, setIsDeleting] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const deleteLaunchpad = async ()=>{
        if (!auth.churchId || !props.launchpad) {
            setError('Missing Launchpad context. Please refresh and try again.');
            return;
        }
        setIsDeleting(true);
        setError(null);
        try {
            const response = await (0, $6ffd02048d6f1e28$export$2e2bcd8739ae039).deleteLaunchpad(auth.churchId, props.launchpad.launchpadID, auth);
            if (response.error) {
                setError(response.error);
                setIsDeleting(false);
                return;
            }
            props.onDeleted();
        } finally{
            setIsDeleting(false);
        }
    };
    var _props_launchpad_metadata_attributes_name;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "delete-launchpad-modal",
        isOpen: props.isOpen,
        footerButtons: [
            {
                title: 'Delete Launchpad',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !isDeleting,
                onClick: deleteLaunchpad
            },
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !isDeleting,
                onClick: props.close
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "delete-launchpad-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            "aria-disabled": isDeleting,
                            className: isDeleting ? 'close disabled' : 'close',
                            href: "#",
                            onClick: (e)=>{
                                e.preventDefault();
                                if (isDeleting) return;
                                props.close();
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                            className: "title",
                            children: [
                                "Delete ",
                                (_props_launchpad_metadata_attributes_name = (_props_launchpad = props.launchpad) === null || _props_launchpad === void 0 ? void 0 : _props_launchpad.metadata.attributes.name) !== null && _props_launchpad_metadata_attributes_name !== void 0 ? _props_launchpad_metadata_attributes_name : 'Launchpad'
                            ]
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "save-error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5407115776bd457c$exports))),
                            alt: "",
                            "aria-hidden": "true",
                            className: "warning-icon"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "warning-copy",
                            children: "Deleting a Launchpad View will permanently remove its configuration and links. This action cannot be undone. Would you like to delete the Launchpad View?"
                        })
                    ]
                })
            ]
        })
    });
}







var $7fPBF = parcelRequire("7fPBF");



function $cc048b1bd1abc5c3$export$2e2bcd8739ae039(props) {
    const { links: links, hasUnsavedChanges: hasUnsavedChanges, isSaving: isSaving, error: error } = props.editor;
    const [draggedLinkID, setDraggedLinkID] = (0, $7fPBF.useState)(null);
    const closeAndDiscard = ()=>{
        props.editor.reset();
        props.close();
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "links-editor-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "links-editor-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            disabled: isSaving,
                            onClick: closeAndDiscard,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: "Edit Links"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: isSaving ? 'header-control confirm saving' : 'header-control confirm',
                            disabled: isSaving || !hasUnsavedChanges,
                            onClick: async ()=>{
                                await props.editor.save();
                                props.close();
                            },
                            children: isSaving ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "header-control-spinner",
                                role: "status",
                                "aria-label": "Saving"
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d5bdfc11cea11cc4$exports))),
                                alt: "Save icon"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "caption",
                            children: "These appear at the top of Launchpad, in the order set below \u2014 drag a link by its handle to move it. On the Salt mobile app they appear at the bottom."
                        }),
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        links.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "empty-links-state caption",
                            children: "No links added."
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "links-list",
                            children: links.map((link, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($cc048b1bd1abc5c3$var$LinkRow, {
                                    link: link,
                                    position: index + 1,
                                    isDragging: draggedLinkID === link.id,
                                    onChange: (changes)=>props.editor.updateLink(link.id, changes),
                                    onRemove: ()=>props.editor.removeLink(link.id),
                                    onDragStart: ()=>setDraggedLinkID(link.id),
                                    onDragEnd: ()=>setDraggedLinkID(null),
                                    onDropOn: ()=>{
                                        if (draggedLinkID && draggedLinkID !== link.id) props.editor.moveLink(draggedLinkID, link.id);
                                        setDraggedLinkID(null);
                                    }
                                }, link.id))
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "add-link-button",
                            disabled: isSaving,
                            onClick: props.editor.addLink,
                            children: "Add Link"
                        })
                    ]
                })
            ]
        })
    });
}
function $cc048b1bd1abc5c3$var$LinkRow(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: props.isDragging ? 'link-card is-dragging' : 'link-card',
        onDragOver: (event)=>event.preventDefault(),
        onDrop: props.onDropOn,
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                className: "drag-handle",
                draggable: true,
                role: "button",
                "aria-label": `Reorder link ${props.position}`,
                onDragStart: props.onDragStart,
                onDragEnd: props.onDragEnd,
                children: "\u283F"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "link-fields",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                        id: `launchpad-link-name-${props.link.id}`,
                        type: "text",
                        className: "link-name",
                        "aria-label": `Link ${props.position} name`,
                        placeholder: "Link Name",
                        value: props.link.name,
                        onChange: (event)=>props.onChange({
                                name: event.target.value
                            })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                        id: `launchpad-link-url-${props.link.id}`,
                        type: "text",
                        className: "link-url",
                        "aria-label": `Link ${props.position} URL`,
                        placeholder: "Link URL",
                        value: props.link.url,
                        onChange: (event)=>props.onChange({
                                url: event.target.value
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: "remove-link-button",
                "aria-label": `Remove link ${props.position}`,
                onClick: props.onRemove,
                children: "Remove"
            })
        ]
    });
}


function $3411554fac1e8fe2$export$2e2bcd8739ae039() {
    var _location_state;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const pathParams = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const launchpadID = pathParams.launchpadID;
    var _location_state_launchpad;
    const initialLaunchpad = (_location_state_launchpad = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.launchpad) !== null && _location_state_launchpad !== void 0 ? _location_state_launchpad : null;
    const [launchpad, setLaunchpad] = (0, $7fPBF.useState)(initialLaunchpad);
    const [loading, setLoading] = (0, $7fPBF.useState)(initialLaunchpad === null);
    const [hasLoaded, setHasLoaded] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [reloadKey, setReloadKey] = (0, $7fPBF.useState)(0);
    const [isEditModalOpen, setIsEditModalOpen] = (0, $7fPBF.useState)(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, $7fPBF.useState)(false);
    const applyLaunchpad = (0, $7fPBF.useCallback)((updatedLaunchpad)=>{
        // Some responses carry only the Launchpad's metadata, without its tag;
        // keeping the one already known stops the preview's address flipping to
        // the ID form after a save.
        setLaunchpad((current)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, updatedLaunchpad), {
                tag: updatedLaunchpad.tag !== undefined ? updatedLaunchpad.tag : current === null || current === void 0 ? void 0 : current.tag
            }));
    }, []);
    const linksEditor = (0, $434bab72884901a7$export$2e2bcd8739ae039)(launchpad, applyLaunchpad);
    const [isLinkEditorOpen, setIsLinkEditorOpen] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        let isCancelled = false;
        const loadLaunchpad = async ()=>{
            if (!auth.churchId || !launchpadID) return;
            setLoading(true);
            setError(null);
            const response = await (0, $6ffd02048d6f1e28$export$2e2bcd8739ae039).fetchLaunchpad(auth.churchId, launchpadID, auth);
            if (isCancelled) return;
            const fetchedLaunchpad = response.error ? null : (0, $4492b6a3f2f323df$export$8d56d0b92b79b4fa)(response.body);
            if (!fetchedLaunchpad) {
                setError(response.error || 'Failed to load this Launchpad.');
                setLaunchpad(null);
            } else applyLaunchpad(fetchedLaunchpad);
            setLoading(false);
            setHasLoaded(true);
        };
        loadLaunchpad();
        return ()=>{
            isCancelled = true;
        };
    }, [
        auth.churchId,
        auth.consumeRefreshToken,
        launchpadID,
        reloadKey
    ]);
    if (!launchpadID) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/launchpad",
        replace: true
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "launchpad-details-page",
        children: [
            loading && !launchpad ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}) : null,
            error && !launchpad ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                error: error,
                buttonText: "Retry",
                buttonAction: ()=>setReloadKey((currentKey)=>currentKey + 1)
            }) : null,
            hasLoaded && !loading && !error && !launchpad ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                error: "Launchpad not found.",
                buttonText: "Back to Launchpad",
                buttonAction: ()=>navigate('/launchpad')
            }) : null,
            launchpad ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                        title: launchpad.metadata.attributes.name,
                        subtitle: launchpad.metadata.attributes.description,
                        backLocation: "/launchpad",
                        links: [
                            {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($a9cdc003ba228dda$exports))),
                                title: 'Edit',
                                onClick: ()=>setIsEditModalOpen(true)
                            },
                            {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($f382a5c80f18c5e3$exports))),
                                title: 'Delete',
                                onClick: ()=>setIsDeleteModalOpen(true)
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $42e9a645849f7eb0$export$2e2bcd8739ae039), {
                        isOpen: isEditModalOpen,
                        launchpad: launchpad,
                        close: ()=>setIsEditModalOpen(false),
                        onSaved: (savedLaunchpad)=>{
                            applyLaunchpad(savedLaunchpad);
                            setIsEditModalOpen(false);
                        }
                    }, `edit-launchpad-${launchpad.launchpadID}`),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $09ef1d323105615a$export$2e2bcd8739ae039), {
                        isOpen: isDeleteModalOpen,
                        launchpad: launchpad,
                        close: ()=>setIsDeleteModalOpen(false),
                        onDeleted: ()=>{
                            setIsDeleteModalOpen(false);
                            navigate('/launchpad');
                        }
                    }, `delete-launchpad-${launchpad.launchpadID}`),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cc048b1bd1abc5c3$export$2e2bcd8739ae039), {
                        isOpen: isLinkEditorOpen,
                        editor: linksEditor,
                        close: ()=>setIsLinkEditorOpen(false)
                    }),
                    launchpad && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: "launchpad-preview-section",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "Preview"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                className: "edit-links-button",
                                onClick: ()=>setIsLinkEditorOpen(true),
                                children: "Edit Links"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d33450954367416e$export$2e2bcd8739ae039), {
                                launchpad: launchpad
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
}







function $35ec7910fa739a74$export$2e2bcd8739ae039() {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('volunteering');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "volunteering-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ae515035e6d7062$export$2e2bcd8739ae039), {
                title: t('tabs.title'),
                tabs: [
                    {
                        label: t('tabs.teams'),
                        path: '/volunteering'
                    },
                    {
                        label: t('tabs.trainingModules'),
                        path: '/volunteering/training'
                    }
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$910ae8079b2c2852), {})
        ]
    });
}





var $30bbe81485bfa1db$exports = {};
$30bbe81485bfa1db$exports = $parcel$resolve("1E0fq");





var $7fPBF = parcelRequire("7fPBF");


class $369e4aa7dc42c97e$export$2e2bcd8739ae039 {
    static async fetchTeamsWithMembers(churchID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/volunteering/teams`), auth.consumeRefreshToken);
    }
    // One team with its members and roles.
    static async fetchTeam(churchID, teamID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/volunteering/teams/${teamID}`), auth.consumeRefreshToken);
    }
    // Creates an empty team. The API rejects an empty name.
    static async createTeam(churchID, name, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/volunteering/teams`, {
            attributes: {
                name: name
            }
        }), auth.consumeRefreshToken);
    }
    // Replaces the team's attributes, which today are only its name.
    static async updateTeam(churchID, teamID, name, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/volunteering/teams/${teamID}`, {
            attributes: {
                name: name
            }
        }), auth.consumeRefreshToken);
    }
    // Adds a person who already exists to a team, optionally starting them off
    // with some of its roles.
    static async addTeamMember(churchID, teamID, personID, auth, roleIDs = []) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PUT, `/v1/church/${churchID}/volunteering/teams/${teamID}/members/${personID}`, {
            roleIDs: roleIDs
        }), auth.consumeRefreshToken);
    }
    static async removeTeamMember(churchID, teamID, personID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/volunteering/teams/${teamID}/members/${personID}`), auth.consumeRefreshToken);
    }
    // Creates the person and adds them to the team in one call.
    static async createTeamMember(churchID, teamID, attributes, auth, roleIDs = []) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/volunteering/teams/${teamID}/members`, {
            attributes: attributes,
            roleIDs: roleIDs
        }), auth.consumeRefreshToken);
    }
    // Replaces the roles a member holds. An empty list clears them.
    static async setMemberRoles(churchID, teamID, personID, roleIDs, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/volunteering/teams/${teamID}/members/${personID}`, {
            roleIDs: roleIDs
        }), auth.consumeRefreshToken);
    }
    static async createTeamRole(churchID, teamID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/volunteering/teams/${teamID}/roles`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    // Replaces every attribute, so a rename has to carry the role's training
    // rules along: the API reads a missing list as none, and would drop them.
    // Modules newly added to the rules are also assigned to the people who hold
    // the role now; the response lists what that handed out.
    static async updateTeamRole(churchID, teamID, roleID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/volunteering/teams/${teamID}/roles/${roleID}`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    // Deleting a role also takes it off everyone who held it.
    static async deleteTeamRole(churchID, teamID, roleID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/volunteering/teams/${teamID}/roles/${roleID}`), auth.consumeRefreshToken);
    }
}
$369e4aa7dc42c97e$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";



var $2Bwgd = parcelRequire("2Bwgd");
function $db113dffb920235a$export$2e2bcd8739ae039() {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchId = auth.churchId;
    const [teams, setTeams] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchId) return;
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).fetchTeamsWithMembers(churchId, auth);
            if (response.error) {
                setError(response.error);
                setTeams(null);
            } else if (response.body) setTeams(response.body);
            else setTeams(null);
        } catch (err) {
            setError((err === null || err === void 0 ? void 0 : err.message) || (0, $2Bwgd.default).t('volunteering:errors.loadTeams'));
            setTeams(null);
        } finally{
            setLoading(false);
        }
    }, [
        churchId,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!churchId) return;
        fetch();
    }, [
        churchId,
        fetch
    ]);
    return {
        teams: teams,
        loading: loading,
        error: error,
        refetch: fetch
    };
}



var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");







function $77186c032b6447f6$export$2e2bcd8739ae039(props) {
    const enabled = props.cards.filter((card)=>card.enabled);
    const disabled = props.cards.filter((card)=>!card.enabled);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "chooser",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "chooser-header",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: props.icon.image,
                        className: "icon",
                        alt: props.icon.alt
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        children: props.title
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: props.description
                    })
                ]
            }),
            enabled.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "card",
                children: enabled.map((card, idx)=>{
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            idx !== 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "divider"
                            }) : null,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($77186c032b6447f6$var$CreateOption, {
                                onClick: card.onClick,
                                logo: card.logo,
                                title: card.title,
                                description: card.description
                            })
                        ]
                    }, card.title);
                })
            }) : null,
            disabled.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        style: {
                            marginBottom: '0'
                        },
                        children: "Unavailable"
                    }),
                    disabled.map((card)=>{
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "card unavailable",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($77186c032b6447f6$var$CreateOption, {
                                onClick: null,
                                logo: card.logo,
                                title: card.title,
                                description: card.description
                            })
                        }, card.title);
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        style: {
                            margin: '0'
                        },
                        children: props.unavailableText
                    })
                ]
            }) : null
        ]
    });
}
function $77186c032b6447f6$var$CreateOption(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: 'option-row',
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "option",
            onClick: ()=>{
                props.onClick && props.onClick();
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: props.logo.image,
                    className: "provider-logo",
                    alt: props.logo.alt
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "option-text",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                            children: props.title
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: props.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e5c73394f0bf85aa$exports))),
                    className: "chevron",
                    alt: ""
                })
            ]
        })
    });
}








var $e80e2f80027daa71$exports = {};
$e80e2f80027daa71$exports = $parcel$resolve("34dY3");


var $9a6c88b634913c19$exports = {};
$9a6c88b634913c19$exports = $parcel$resolve("LuWrb");



// Matches the slide in index.scss.
const $f0bf91c199fcc3cc$var$STAGE_TRANSITION_MS = 240;
// ImportTeamForChurch's refusal for a team imported before.
const $f0bf91c199fcc3cc$var$TEAM_ALREADY_IMPORTED = 'TEAM_ALREADY_IMPORTED';
function $f0bf91c199fcc3cc$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        'createTeam',
        'volunteering'
    ]);
    const { connectionStatus: connectionStatus, reloadConnectionStatus: reloadConnectionStatus } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const [stage, setStage] = (0, $7fPBF.useState)('source');
    const [transition, setTransition] = (0, $7fPBF.useState)(null);
    const [name, setName] = (0, $7fPBF.useState)('');
    const [isCreating, setIsCreating] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    // The import step's data lives here rather than in the step: the step is
    // rendered a second time as it slides out, and a copy that fetched for itself
    // would request the list twice and flash a spinner on its way out.
    const [importableTeams, setImportableTeams] = (0, $7fPBF.useState)(null);
    const [isLoadingTeams, setIsLoadingTeams] = (0, $7fPBF.useState)(false);
    const [teamsError, setTeamsError] = (0, $7fPBF.useState)(null);
    const [teamFilter, setTeamFilter] = (0, $7fPBF.useState)('');
    const [selectedExternalID, setSelectedExternalID] = (0, $7fPBF.useState)(null);
    const [isImporting, setIsImporting] = (0, $7fPBF.useState)(false);
    const [importResult, setImportResult] = (0, $7fPBF.useState)(null);
    const viewportRef = (0, $7fPBF.useRef)(null);
    const outgoingRef = (0, $7fPBF.useRef)(null);
    const incomingRef = (0, $7fPBF.useRef)(null);
    const nameInputRef = (0, $7fPBF.useRef)(null);
    (0, $7fPBF.useEffect)(()=>{
        // Ensure we have the latest connection status whenever the modal opens
        if (props.isOpen) reloadConnectionStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        props.isOpen
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!transition) return;
        const timeout = window.setTimeout(()=>setTransition(null), $f0bf91c199fcc3cc$var$STAGE_TRANSITION_MS);
        return ()=>window.clearTimeout(timeout);
    }, [
        transition
    ]);
    // The steps differ a lot in height -- the source step is far taller than
    // the name form -- so the viewport eases between them. Left to follow the
    // incoming step, it would snap to the new height on the first frame and clip
    // the outgoing step before it could slide away.
    (0, $7fPBF.useLayoutEffect)(()=>{
        var _outgoingRef_current, _incomingRef_current;
        const viewport = viewportRef.current;
        if (!viewport) return;
        if (!transition) {
            viewport.style.height = '';
            return;
        }
        var _outgoingRef_current_offsetHeight;
        const fromHeight = (_outgoingRef_current_offsetHeight = (_outgoingRef_current = outgoingRef.current) === null || _outgoingRef_current === void 0 ? void 0 : _outgoingRef_current.offsetHeight) !== null && _outgoingRef_current_offsetHeight !== void 0 ? _outgoingRef_current_offsetHeight : 0;
        var _incomingRef_current_offsetHeight;
        const toHeight = (_incomingRef_current_offsetHeight = (_incomingRef_current = incomingRef.current) === null || _incomingRef_current === void 0 ? void 0 : _incomingRef_current.offsetHeight) !== null && _incomingRef_current_offsetHeight !== void 0 ? _incomingRef_current_offsetHeight : 0;
        viewport.style.height = `${fromHeight}px`;
        // Commit the starting height so the change below transitions from it.
        viewport.offsetHeight;
        viewport.style.height = `${toHeight}px`;
    }, [
        transition
    ]);
    // Not autoFocus: the field would take focus while it's still parked off to
    // the right, and the browser would scroll the viewport to reveal it --
    // jumping both steps to their end positions instead of sliding them.
    (0, $7fPBF.useEffect)(()=>{
        var _nameInputRef_current;
        if (stage === 'details') (_nameInputRef_current = nameInputRef.current) === null || _nameInputRef_current === void 0 ? void 0 : _nameInputRef_current.focus({
            preventScroll: true
        });
    }, [
        stage
    ]);
    const changeStage = (nextStage)=>{
        if (nextStage === stage) return;
        // The source step is the root; every other step sits forward of it.
        setTransition({
            from: stage,
            direction: nextStage === 'source' ? 'back' : 'forward'
        });
        setStage(nextStage);
        setError(null);
    };
    const isPlanningCenterConnected = (connectionStatus === null || connectionStatus === void 0 ? void 0 : connectionStatus.PLANNING_CENTER) === true;
    const fetchImportableTeams = async ()=>{
        if (!auth.churchId) return;
        setIsLoadingTeams(true);
        setTeamsError(null);
        try {
            const response = await (0, $d6ceddc0f5c6ead5$export$2e2bcd8739ae039).fetchImportableTeams(auth.churchId, (0, $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72).PLANNING_CENTER, auth);
            if (response.error || !response.body) {
                setTeamsError(response.error || t('loadTeamsFailed'));
                return;
            }
            var _response_body_result;
            setImportableTeams((_response_body_result = response.body.result) !== null && _response_body_result !== void 0 ? _response_body_result : []);
        } finally{
            setIsLoadingTeams(false);
        }
    };
    // Read live from Planning Center, so only fetched once the step is reached.
    (0, $7fPBF.useEffect)(()=>{
        if (stage !== 'import' || importableTeams !== null || isLoadingTeams || teamsError) return;
        fetchImportableTeams();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stage,
        importableTeams,
        isLoadingTeams,
        teamsError
    ]);
    const importSelectedTeam = async ()=>{
        if (!auth.churchId || !selectedExternalID || isImporting) return;
        setIsImporting(true);
        setError(null);
        try {
            var _response_body;
            const response = await (0, $d6ceddc0f5c6ead5$export$2e2bcd8739ae039).importTeam(auth.churchId, (0, $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72).PLANNING_CENTER, selectedExternalID, auth);
            const result = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.result;
            if (!response.error && result) {
                setImportResult(result);
                return;
            }
            if (response.code === $f0bf91c199fcc3cc$var$TEAM_ALREADY_IMPORTED) {
                // Someone else got there first, or a double-click did. Reload so the
                // list marks it, rather than leaving an option that can't work.
                setError(t('alreadyImported'));
                setSelectedExternalID(null);
                setImportableTeams(null);
                return;
            }
            setError(response.error || t('importFailed'));
        } finally{
            setIsImporting(false);
        }
    };
    const trimmedName = name.trim();
    // The API rejects an empty name.
    const canCreate = trimmedName.length > 0 && !isCreating;
    const createTeam = async ()=>{
        if (!auth.churchId) {
            setError(t('volunteering:errors.missingChurch'));
            return;
        }
        if (!canCreate) return;
        setIsCreating(true);
        setError(null);
        try {
            var _response_body;
            const response = await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).createTeam(auth.churchId, trimmedName, auth);
            const created = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.result;
            if (response.error || !created) {
                setError(response.error || t('createFailed'));
                return;
            }
            props.onCreated(created, trimmedName);
        } finally{
            setIsCreating(false);
        }
    };
    // The stage sliding out is rendered a second time while it leaves, so only
    // the copy that's arriving gets the input ref.
    const renderStage = (target, isOutgoing)=>{
        if (target === 'source') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77186c032b6447f6$export$2e2bcd8739ae039), {
            title: t('sourceTitle'),
            description: t('sourceDescription'),
            icon: {
                image: (0, (/*@__PURE__*/$parcel$interopDefault($30bbe81485bfa1db$exports))),
                alt: t('volunteeringIcon')
            },
            // Trans fills the link with its text from the catalog.
            // eslint-disable-next-line jsx-a11y/anchor-has-content
            unavailableText: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                t: t,
                i18nKey: "unavailable",
                components: {
                    link: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: "/connections"
                    })
                }
            }),
            cards: [
                {
                    title: t('createInSalt'),
                    description: t('createInSaltDescription'),
                    logo: {
                        image: (0, (/*@__PURE__*/$parcel$interopDefault($9a6c88b634913c19$exports))),
                        alt: t('saltLogo')
                    },
                    enabled: true,
                    onClick: ()=>changeStage('details')
                },
                {
                    title: t('importTitle'),
                    description: t('importDescription'),
                    logo: {
                        image: (0, (/*@__PURE__*/$parcel$interopDefault($e80e2f80027daa71$exports))),
                        alt: t('planningCenterLogo')
                    },
                    enabled: isPlanningCenterConnected,
                    onClick: ()=>changeStage('import')
                }
            ]
        });
        if (target === 'details') // Styled after the Create in Salt event form.
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
            className: "team-form",
            onSubmit: (e)=>{
                e.preventDefault();
                createTeam();
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "section",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "input",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            type: "text",
                            name: "name",
                            placeholder: t('namePlaceholder'),
                            "aria-label": t('nameLabel'),
                            value: name,
                            ref: isOutgoing ? undefined : nameInputRef,
                            disabled: isCreating,
                            onChange: (e)=>setName(e.target.value)
                        })
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "footnote",
                    children: t('detailsFootnote')
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "submit",
                    className: "submit",
                    disabled: !canCreate,
                    children: isCreating ? t('creating') : t('create')
                })
            ]
        });
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($f0bf91c199fcc3cc$var$ImportStage, {
            teams: importableTeams,
            isLoading: isLoadingTeams,
            loadError: teamsError,
            filter: teamFilter,
            onFilterChange: setTeamFilter,
            selectedExternalID: selectedExternalID,
            onSelect: setSelectedExternalID,
            isImporting: isImporting,
            result: importResult,
            onRetry: ()=>{
                fetchImportableTeams();
            },
            onImport: ()=>{
                importSelectedTeam();
            },
            onCreateInSalt: ()=>changeStage('details'),
            onGoToTeam: ()=>{
                if (importResult) props.onCreated(importResult.team, importResult.team.attributes.name);
            }
        });
    };
    const isAtSource = stage === 'source';
    let title = '';
    if (stage === 'details') title = t('detailsTitle');
    else if (stage === 'import') title = t('importTitle');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "create-team-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "create-team-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: isAtSource ? 'header-control close' : 'header-control back',
                            // Going back mid-import would abandon it, and after one the team
                            // already exists: the way on is to it.
                            disabled: isCreating || isImporting || importResult !== null,
                            onClick: ()=>{
                                if (isAtSource) {
                                    props.close();
                                    return;
                                }
                                changeStage('source');
                            },
                            children: isAtSource ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: t('volunteering:common.close')
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($501046bd6ca447c4$exports))),
                                alt: t('volunteering:common.back')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "header-control-spacer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "stage-viewport",
                            ref: viewportRef,
                            children: [
                                transition ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    ref: outgoingRef,
                                    className: `stage is-outgoing ${transition.direction}`,
                                    "aria-hidden": "true",
                                    children: renderStage(transition.from, true)
                                }) : null,
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    ref: incomingRef,
                                    className: transition ? `stage is-incoming ${transition.direction}` : 'stage',
                                    children: renderStage(stage, false)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
// Keeps the API's order -- by service type, then name -- and groups under each
// service type, which is how same-named teams ("Band", "Band") tell apart.
function $f0bf91c199fcc3cc$var$groupTeams(teams, otherTeamsTitle) {
    const groups = [];
    for (const team of teams){
        const title = team.serviceTypeName || otherTeamsTitle;
        const last = groups[groups.length - 1];
        if ((last === null || last === void 0 ? void 0 : last.title) === title) last.teams.push(team);
        else groups.push({
            title: title,
            teams: [
                team
            ]
        });
    }
    return groups;
}
// Worth a filter only once the list is long enough to hunt through.
const $f0bf91c199fcc3cc$var$FILTER_THRESHOLD = 8;
// Lists the church's Planning Center teams, read live, and copies the chosen
// one into a new Salt team with its positions as roles and its people as
// volunteers. A one-time copy: later changes in Planning Center don't follow.
function $f0bf91c199fcc3cc$var$ImportStage(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        'createTeam',
        'volunteering'
    ]);
    if (props.result) {
        const { team: team, members: members, roles: roles, unmatchedPeopleCount: unmatchedPeopleCount } = props.result;
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "import-stage",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                    children: t('importedTitle', {
                        team: team.attributes.name
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    children: t('importedSummary', {
                        volunteers: t('importedVolunteers', {
                            count: members.length
                        }),
                        roles: t('importedRoles', {
                            count: roles.length
                        })
                    })
                }),
                unmatchedPeopleCount > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "import-notice",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $69274dd39b5dbdf8$export$8d6a9236f2e3f2ce), {
                        t: t,
                        i18nKey: "unmatched",
                        count: unmatchedPeopleCount,
                        values: {
                            count: unmatchedPeopleCount
                        },
                        // Trans fills the link with its text from the catalog.
                        // eslint-disable-next-line jsx-a11y/anchor-has-content
                        components: {
                            link: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                href: "/people"
                            })
                        }
                    })
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    className: "submit",
                    onClick: props.onGoToTeam,
                    children: t('goToTeam')
                })
            ]
        });
    }
    if (props.isLoading && !props.teams) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "import-stage import-stage-state",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                fullScreen: false
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "footnote",
                children: t('loadingTeams')
            })
        ]
    });
    if (props.loadError) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "import-stage import-stage-state",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: props.loadError
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: "stage-switch",
                onClick: props.onRetry,
                children: t('volunteering:common.tryAgain')
            })
        ]
    });
    var _props_teams;
    const teams = (_props_teams = props.teams) !== null && _props_teams !== void 0 ? _props_teams : [];
    if (teams.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "import-stage import-stage-state",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: t('noTeams')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: "stage-switch",
                onClick: props.onCreateInSalt,
                children: t('createInSaltInstead')
            })
        ]
    });
    const query = props.filter.trim().toLowerCase();
    const visibleTeams = query.length === 0 ? teams : teams.filter((team)=>{
        var _team_serviceTypeName;
        return team.name.toLowerCase().includes(query) || ((_team_serviceTypeName = team.serviceTypeName) !== null && _team_serviceTypeName !== void 0 ? _team_serviceTypeName : '').toLowerCase().includes(query);
    });
    var _teams_find;
    const selected = (_teams_find = teams.find((team)=>team.externalID === props.selectedExternalID)) !== null && _teams_find !== void 0 ? _teams_find : null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "import-stage",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: t('chooseTeam')
            }),
            teams.length > $f0bf91c199fcc3cc$var$FILTER_THRESHOLD ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                type: "search",
                className: "importable-team-filter",
                value: props.filter,
                placeholder: t('filterPlaceholder'),
                "aria-label": t('filterPlaceholder'),
                disabled: props.isImporting,
                onChange: (e)=>props.onFilterChange(e.target.value)
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "importable-teams",
                children: [
                    visibleTeams.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: t('noFilterMatches')
                    }) : null,
                    $f0bf91c199fcc3cc$var$groupTeams(visibleTeams, t('otherTeams')).map((group)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "importable-team-group",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "importable-team-group-title",
                                    children: group.title
                                }),
                                group.teams.map((team)=>{
                                    const isImported = Boolean(team.importedTeamID);
                                    const isSelected = team.externalID === props.selectedExternalID;
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        type: "button",
                                        className: isSelected ? 'importable-team is-selected' : 'importable-team',
                                        "aria-pressed": isSelected,
                                        disabled: isImported || props.isImporting,
                                        onClick: ()=>props.onSelect(team.externalID),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "importable-team-name",
                                                children: team.name
                                            }),
                                            isImported ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                className: "importable-team-badge",
                                                children: t('imported')
                                            }) : null
                                        ]
                                    }, team.externalID);
                                })
                            ]
                        }, group.title))
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "footnote",
                children: t('importFootnote')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: "submit",
                disabled: !selected || props.isImporting,
                onClick: props.onImport,
                children: props.isImporting ? t('importing') : selected ? t('importNamed', {
                    team: selected.name
                }) : t('import')
            })
        ]
    });
}






var $8e1e7337a3d903e8$exports = {};
$8e1e7337a3d903e8$exports = $parcel$resolve("hECYG");




var $7fPBF = parcelRequire("7fPBF");



var $2Bwgd = parcelRequire("2Bwgd");








var $7fPBF = parcelRequire("7fPBF");


class $08583e4f7cf6a0b5$export$2e2bcd8739ae039 {
    // Pages are cursored: pass the previous page's nextLastPersonID to continue.
    static async fetchPeople(churchID, auth, lastPersonID) {
        const query = lastPersonID ? `?lastPersonID=${encodeURIComponent(lastPersonID)}` : '';
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/people${query}`), auth.consumeRefreshToken);
    }
    // Scaffolding: the single-person endpoint isn't defined yet, so this path is
    // a placeholder and the envelope is read defensively by personFromResponse.
    static async fetchPerson(churchID, personID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/people/${personID}`), auth.consumeRefreshToken);
    }
    static async searchPeople(churchID, auth, field, query, lastPersonID) {
        const cursor = lastPersonID ? `&lastPersonID=${encodeURIComponent(lastPersonID)}` : '';
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/search/church/${churchID}/people/${field}?query=${encodeURIComponent(query)}${cursor}`), auth.consumeRefreshToken);
    }
}
$08583e4f7cf6a0b5$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";


function $e1ff014facf5329b$export$faf075037f0122d5(body) {
    var _candidate_attributes;
    if (!body || typeof body !== 'object') return null;
    const payload = body;
    var _payload_result, _ref;
    const candidate = (_ref = (_payload_result = payload.result) !== null && _payload_result !== void 0 ? _payload_result : payload.person) !== null && _ref !== void 0 ? _ref : payload;
    if (!candidate || typeof candidate !== 'object' || !((_candidate_attributes = candidate.attributes) === null || _candidate_attributes === void 0 ? void 0 : _candidate_attributes.name)) return null;
    return candidate;
}


function $5762e6227721a04d$export$2e2bcd8739ae039(personID, providedPerson) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    const [person, setPerson] = (0, $7fPBF.useState)(providedPerson !== null && providedPerson !== void 0 ? providedPerson : null);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const shouldFetch = !providedPerson && Boolean(churchID) && Boolean(personID);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchID || !personID) return;
        setLoading(true);
        setError(null);
        const response = await (0, $08583e4f7cf6a0b5$export$2e2bcd8739ae039).fetchPerson(churchID, personID, auth);
        const fetchedPerson = response.error ? null : (0, $e1ff014facf5329b$export$faf075037f0122d5)(response.body);
        if (!fetchedPerson) {
            setError(response.error || 'Failed to load this person.');
            setPerson(null);
        } else setPerson(fetchedPerson);
        setLoading(false);
    }, [
        churchID,
        personID,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (providedPerson) {
            setPerson(providedPerson);
            setError(null);
            setLoading(false);
            return;
        }
        if (!shouldFetch) return;
        fetch();
    }, [
        providedPerson,
        shouldFetch,
        fetch
    ]);
    return {
        person: person,
        loading: loading,
        error: error,
        refetch: fetch
    };
}


function $d093efa5d4df2a8b$export$f7fd57ccce645fe2(personID) {
    return `/people/${personID}`;
}
function $d093efa5d4df2a8b$export$2e2bcd8739ae039() {
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const { personID: personID } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    var _location_state;
    const routedPerson = (_location_state = location.state) !== null && _location_state !== void 0 ? _location_state : null;
    const { person: person, loading: loading, error: error, refetch: refetch } = (0, $5762e6227721a04d$export$2e2bcd8739ae039)(personID);
    if (!personID) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/people",
        replace: true
    });
    const name = (person === null || person === void 0 ? void 0 : person.attributes.name) || (routedPerson === null || routedPerson === void 0 ? void 0 : routedPerson.personName) || 'Person';
    var _routedPerson_backLocation;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "person-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: name,
                backLocation: (_routedPerson_backLocation = routedPerson === null || routedPerson === void 0 ? void 0 : routedPerson.backLocation) !== null && _routedPerson_backLocation !== void 0 ? _routedPerson_backLocation : '/people'
            }),
            loading && !person ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "person-detail-state",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                    fullScreen: false
                })
            }) : null,
            error && !person ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                error: error,
                buttonText: "Retry",
                buttonAction: ()=>refetch(),
                fullHeight: true
            }) : null,
            person ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                        className: "person-identity-card",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a316458081a8d65b$export$2e2bcd8739ae039), {
                                name: person.attributes.name,
                                size: "large"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "person-identity-text",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "name",
                                        children: person.attributes.name
                                    }),
                                    person.attributes.email ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        className: "email",
                                        children: person.attributes.email
                                    }) : null
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($d093efa5d4df2a8b$var$PersonDetails, {
                        attributes: person.attributes
                    })
                ]
            }) : null
        ]
    });
}
// Phone numbers are typed by hand elsewhere, so only the shapes that are
// unambiguously North American get reformatted. Anything else -- an
// international number, an extension, a number with letters -- is shown exactly
// as it was entered rather than risking a wrong guess.
function $d093efa5d4df2a8b$var$formatPhoneNumber(phoneNumber) {
    if (!phoneNumber) return phoneNumber;
    const digits = phoneNumber.replace(/\D/g, '');
    const isPlainNANP = /^[\d\s().+-]+$/.test(phoneNumber);
    if (!isPlainNANP) return phoneNumber;
    if (digits.length === 10) return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
    if (digits.length === 11 && digits.startsWith('1')) return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
    return phoneNumber;
}
// Birthdays arrive as ISO 8601. Formatting from the date parts in UTC avoids
// the day-earlier shift a date-only string picks up when parsed as local time
// west of Greenwich.
function $d093efa5d4df2a8b$var$formatBirthday(birthday) {
    if (!birthday) return birthday;
    const parts = /^(\d{4})-(\d{2})-(\d{2})/.exec(birthday);
    if (!parts) return birthday;
    const [, year, month, day] = parts;
    const date = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)));
    if (Number.isNaN(date.getTime())) return birthday;
    return date.toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
    });
}
function $d093efa5d4df2a8b$var$PersonDetails(props) {
    // Every field renders whether or not it's set, so a blank one reads as
    // "nothing on file" rather than as a field that doesn't exist.
    const rows = [
        {
            label: 'Email',
            value: props.attributes.email
        },
        {
            label: 'Phone',
            value: $d093efa5d4df2a8b$var$formatPhoneNumber(props.attributes.phoneNumber)
        },
        {
            label: 'Birthday',
            value: $d093efa5d4df2a8b$var$formatBirthday(props.attributes.birthday)
        },
        {
            label: 'Gender',
            value: props.attributes.gender
        },
        {
            label: 'Medical Notes',
            value: props.attributes.medicalNotes
        }
    ];
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dl", {
        className: "person-detail-rows",
        children: rows.map((row)=>{
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "person-detail-row",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dt", {
                        children: row.label
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("dd", {
                        className: row.value ? undefined : 'is-empty',
                        children: row.value || 'None'
                    })
                ]
            }, row.label);
        })
    });
}





var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");


// The cursor walk both the full list and search results share. Pass null to sit
// idle without issuing requests.
function $7a49e75250975903$var$usePeoplePages(fetchPage) {
    const [people, setPeople] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(fetchPage !== null);
    const [hasLoaded, setHasLoaded] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [hasMore, setHasMore] = (0, $7fPBF.useState)(false);
    const [nextLastPersonID, setNextLastPersonID] = (0, $7fPBF.useState)(null);
    const [isLoadingMore, setIsLoadingMore] = (0, $7fPBF.useState)(false);
    // Which fetcher the results in hand came from. Clearing in the effect leaves
    // one render where a new fetcher is paired with the old results, which is
    // long enough to see.
    const [loadedFor, setLoadedFor] = (0, $7fPBF.useState)(null);
    const load = (0, $7fPBF.useCallback)(async (lastPersonID)=>{
        if (!fetchPage) return;
        const isFirstPage = lastPersonID === null;
        if (isFirstPage) setLoading(true);
        else setIsLoadingMore(true);
        setError(null);
        const response = await fetchPage(lastPersonID);
        const body = response.body;
        if (response.error || !body) {
            setError(response.error || 'Failed to load people.');
            if (isFirstPage) {
                setPeople([]);
                setHasMore(false);
                setNextLastPersonID(null);
            }
        } else {
            var _body_results;
            const page = (_body_results = body.results) !== null && _body_results !== void 0 ? _body_results : [];
            // Appending rather than replacing is what makes this a cursor walk; the
            // first page still replaces so a refetch doesn't duplicate rows.
            setPeople((currentPeople)=>isFirstPage ? page : [
                    ...currentPeople,
                    ...page
                ]);
            setHasMore(body.hasMore === true && Boolean(body.nextLastPersonID));
            var _body_nextLastPersonID;
            setNextLastPersonID((_body_nextLastPersonID = body.nextLastPersonID) !== null && _body_nextLastPersonID !== void 0 ? _body_nextLastPersonID : null);
            setLoadedFor(()=>fetchPage);
        }
        if (isFirstPage) {
            setLoading(false);
            setHasLoaded(true);
        } else setIsLoadingMore(false);
    }, [
        fetchPage
    ]);
    (0, $7fPBF.useEffect)(()=>{
        // Going idle keeps the last results on screen: the view that owns them is
        // still fading out, and blanking them mid-fade reads as a flicker.
        if (!fetchPage) {
            setLoading(false);
            return;
        }
        // A different fetcher means a different query, so previous results are
        // cleared rather than lingering under the new one.
        setPeople([]);
        setHasLoaded(false);
        setHasMore(false);
        setNextLastPersonID(null);
        setError(null);
        load(null);
    }, [
        fetchPage,
        load
    ]);
    const loadMore = (0, $7fPBF.useCallback)(()=>{
        if (!hasMore || isLoadingMore || !nextLastPersonID) return;
        load(nextLastPersonID);
    }, [
        hasMore,
        isLoadingMore,
        nextLastPersonID,
        load
    ]);
    const refetch = (0, $7fPBF.useCallback)(()=>load(null), [
        load
    ]);
    // Idle keeps whatever was last shown so a fading-out view doesn't blank.
    const isShowingCurrent = fetchPage === null || loadedFor === fetchPage;
    return {
        people: isShowingCurrent ? people : [],
        loading: loading || fetchPage !== null && !isShowingCurrent,
        hasLoaded: isShowingCurrent && hasLoaded,
        error: error,
        hasMore: isShowingCurrent && hasMore,
        isLoadingMore: isLoadingMore,
        loadMore: loadMore,
        refetch: refetch
    };
}
function $7a49e75250975903$export$2e2bcd8739ae039() {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    const fetchPage = (0, $7fPBF.useCallback)((lastPersonID)=>{
        return (0, $08583e4f7cf6a0b5$export$2e2bcd8739ae039).fetchPeople(churchID, auth, lastPersonID);
    }, [
        churchID,
        auth
    ]);
    return $7a49e75250975903$var$usePeoplePages(churchID ? fetchPage : null);
}
function $7a49e75250975903$export$1b49a7a7a7c111a2(query) {
    return query.includes('@') ? 'email' : 'name';
}
const $7a49e75250975903$var$SEARCH_DEBOUNCE_MS = 300;
function $7a49e75250975903$export$d443a927de736110(query) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    const trimmedQuery = query.trim();
    // Debounced so typing doesn't fire a request per keystroke.
    const [debouncedQuery, setDebouncedQuery] = (0, $7fPBF.useState)(trimmedQuery);
    (0, $7fPBF.useEffect)(()=>{
        const timeout = window.setTimeout(()=>setDebouncedQuery(trimmedQuery), $7a49e75250975903$var$SEARCH_DEBOUNCE_MS);
        return ()=>window.clearTimeout(timeout);
    }, [
        trimmedQuery
    ]);
    const fetchPage = (0, $7fPBF.useCallback)((lastPersonID)=>{
        return (0, $08583e4f7cf6a0b5$export$2e2bcd8739ae039).searchPeople(churchID, auth, $7a49e75250975903$export$1b49a7a7a7c111a2(debouncedQuery), debouncedQuery, lastPersonID);
    }, [
        churchID,
        auth,
        debouncedQuery
    ]);
    const results = $7a49e75250975903$var$usePeoplePages(churchID && debouncedQuery.length > 0 ? fetchPage : null);
    // True while the user has typed something the debounce hasn't caught up to.
    const isPending = trimmedQuery !== debouncedQuery;
    // Results belong to the previous query while a new one is still settling, so
    // they read as loading rather than as answers. Clearing the field is the one
    // pending state that keeps them: that view is fading out, and blanking it
    // mid-fade is the flicker this avoids.
    const isStale = isPending && trimmedQuery.length > 0;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, results), {
        people: isStale ? [] : results.people,
        hasLoaded: isStale ? false : results.hasLoaded,
        loading: isStale || results.loading,
        hasMore: isStale ? false : results.hasMore,
        field: $7a49e75250975903$export$1b49a7a7a7c111a2(isStale ? trimmedQuery : debouncedQuery),
        isPending: isPending
    });
}





function $f6bd0f2dafc61f4b$export$1976c4a4228eddb2(roleIDs, roleID) {
    return roleIDs.includes(roleID) ? roleIDs.filter((heldRoleID)=>heldRoleID !== roleID) : [
        ...roleIDs,
        roleID
    ];
}
function $f6bd0f2dafc61f4b$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('volunteering');
    const selected = new Set(props.selectedRoleIDs);
    const sortedRoles = [
        ...props.roles
    ].sort((one, two)=>one.attributes.name.localeCompare(two.attributes.name));
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "role-picker",
        role: "group",
        "aria-label": t('rolePicker.label'),
        children: sortedRoles.map((role)=>{
            const isSelected = selected.has(role.id);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: isSelected ? 'role-chip is-selected' : 'role-chip',
                "aria-pressed": isSelected,
                disabled: props.disabled,
                onClick: ()=>props.onToggle(role.id),
                children: role.attributes.name
            }, role.id);
        })
    });
}





var $77aa1e44a1d53977$exports = {};
$77aa1e44a1d53977$exports = $parcel$resolve("4my32");


// Matches the slide in index.scss.
const $e03a092891f51785$var$PHASE_TRANSITION_MS = 240;
function $e03a092891f51785$export$2e2bcd8739ae039(props) {
    var _props_team;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        'inviteVolunteer',
        'volunteering'
    ]);
    const [mode, setMode] = (0, $7fPBF.useState)('search');
    const [phase, setPhase] = (0, $7fPBF.useState)('person');
    const [transition, setTransition] = (0, $7fPBF.useState)(null);
    const [query, setQuery] = (0, $7fPBF.useState)('');
    const [selectedPerson, setSelectedPerson] = (0, $7fPBF.useState)(null);
    const [name, setName] = (0, $7fPBF.useState)('');
    const [email, setEmail] = (0, $7fPBF.useState)('');
    const [roleIDs, setRoleIDs] = (0, $7fPBF.useState)([]);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const searchResults = (0, $7a49e75250975903$export$d443a927de736110)(query);
    const isSearching = query.trim().length > 0;
    var _props_roles;
    const roles = (_props_roles = props.roles) !== null && _props_roles !== void 0 ? _props_roles : [];
    // A team with no roles has nothing for a second phase to offer, so the
    // invite goes straight out from the first.
    const hasRolePhase = roles.length > 0;
    const hasInvitee = mode === 'search' ? selectedPerson !== null : name.trim().length > 0 && email.trim().length > 0;
    (0, $7fPBF.useEffect)(()=>{
        if (!transition) return;
        const timeout = window.setTimeout(()=>setTransition(null), $e03a092891f51785$var$PHASE_TRANSITION_MS);
        return ()=>window.clearTimeout(timeout);
    }, [
        transition
    ]);
    const changePhase = (nextPhase)=>{
        if (nextPhase === phase) return;
        setTransition({
            from: phase,
            direction: nextPhase === 'roles' ? 'forward' : 'back'
        });
        setPhase(nextPhase);
        setError(null);
    };
    const startCreating = ()=>{
        // Whatever they typed is a reasonable starting point for the new person.
        const typed = query.trim();
        if (typed.length > 0) {
            if (typed.includes('@')) setEmail(typed);
            else setName(typed);
        }
        setSelectedPerson(null);
        setError(null);
        setMode('create');
    };
    const backToSearch = ()=>{
        setError(null);
        setMode('search');
    };
    const invite = async ()=>{
        if (!auth.churchId || !props.team) {
            setError(t('volunteering:errors.missingChurch'));
            return;
        }
        setIsSaving(true);
        setError(null);
        try {
            const response = mode === 'search' && selectedPerson ? await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).addTeamMember(auth.churchId, props.team.id, selectedPerson.id, auth, roleIDs) : await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).createTeamMember(auth.churchId, props.team.id, {
                name: name.trim(),
                email: email.trim()
            }, auth, roleIDs);
            if (response.error) {
                setError(response.error);
                setIsSaving(false);
                return;
            }
            props.onInvited();
        } finally{
            setIsSaving(false);
        }
    };
    const isChoosingPerson = phase === 'person';
    const renderPhase = (target)=>{
        var _selectedPerson_attributes_name, _ref;
        if (target === 'roles') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2baa135e072363db$export$2e2bcd8739ae039), {
                    name: mode === 'search' ? (_selectedPerson_attributes_name = selectedPerson === null || selectedPerson === void 0 ? void 0 : selectedPerson.attributes.name) !== null && _selectedPerson_attributes_name !== void 0 ? _selectedPerson_attributes_name : '' : name.trim(),
                    email: (_ref = mode === 'search' ? selectedPerson === null || selectedPerson === void 0 ? void 0 : selectedPerson.attributes.email : email.trim()) !== null && _ref !== void 0 ? _ref : undefined
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "invite-roles",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "invite-roles-label",
                            children: t('roles')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f6bd0f2dafc61f4b$export$2e2bcd8739ae039), {
                            roles: roles,
                            selectedRoleIDs: roleIDs,
                            disabled: isSaving,
                            onToggle: (roleID)=>setRoleIDs((currentRoleIDs)=>(0, $f6bd0f2dafc61f4b$export$1976c4a4228eddb2)(currentRoleIDs, roleID))
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "invite-hint",
                            children: t('rolesHint')
                        })
                    ]
                })
            ]
        });
        if (mode === 'search') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                    id: "query",
                    className: "invite-search",
                    type: "search",
                    value: query,
                    placeholder: t('searchPlaceholder'),
                    "aria-label": t('searchLabel'),
                    disabled: isSaving,
                    onChange: (e)=>{
                        setQuery(e.target.value);
                        setSelectedPerson(null);
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e03a092891f51785$var$SearchResults, {
                    isSearching: isSearching,
                    loading: searchResults.loading,
                    people: searchResults.people,
                    selectedPerson: selectedPerson,
                    onSelect: setSelectedPerson
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    className: "invite-stage-switch",
                    disabled: isSaving,
                    onClick: startCreating,
                    children: t('createInstead')
                })
            ]
        });
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "field-container",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                            htmlFor: "invite-name",
                            children: t('nameLabel')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            id: "invite-name",
                            type: "text",
                            value: name,
                            placeholder: t('namePlaceholder'),
                            disabled: isSaving,
                            onChange: (e)=>setName(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "field-container",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                            htmlFor: "invite-email",
                            children: t('emailLabel')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            id: "invite-email",
                            type: "email",
                            value: email,
                            placeholder: t('emailPlaceholder'),
                            disabled: isSaving,
                            onChange: (e)=>setEmail(e.target.value)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    className: "invite-stage-switch",
                    disabled: isSaving,
                    onClick: backToSearch,
                    children: t('searchInstead')
                })
            ]
        });
    };
    const confirmButton = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        className: isSaving ? 'header-control confirm saving' : 'header-control confirm',
        disabled: !hasInvitee || isSaving,
        onClick: ()=>{
            invite();
        },
        children: isSaving ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
            className: "header-control-spinner",
            role: "status",
            "aria-label": t('inviting')
        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
            src: (0, (/*@__PURE__*/$parcel$interopDefault($d5bdfc11cea11cc4$exports))),
            alt: t('invite')
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "invite-volunteer-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "invite-volunteer-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: isChoosingPerson ? 'header-control close' : 'header-control back',
                            disabled: isSaving,
                            onClick: ()=>{
                                if (isChoosingPerson) {
                                    props.close();
                                    return;
                                }
                                changePhase('person');
                            },
                            children: isChoosingPerson ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: t('volunteering:common.close')
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($501046bd6ca447c4$exports))),
                                alt: t('volunteering:common.back')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: isChoosingPerson ? ((_props_team = props.team) === null || _props_team === void 0 ? void 0 : _props_team.attributes.name) ? t('title', {
                                team: props.team.attributes.name
                            }) : t('titleUnnamed') : t('rolesTitle')
                        }),
                        isChoosingPerson && hasRolePhase ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control forward",
                            disabled: !hasInvitee,
                            onClick: ()=>changePhase('roles'),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($77aa1e44a1d53977$exports))),
                                alt: t('continue')
                            })
                        }) : confirmButton
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "stage-viewport",
                            children: [
                                transition ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: `stage is-outgoing ${transition.direction}`,
                                    "aria-hidden": "true",
                                    children: renderPhase(transition.from)
                                }) : null,
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: transition ? `stage is-incoming ${transition.direction}` : 'stage',
                                    children: renderPhase(phase)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $e03a092891f51785$var$SearchResults(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('inviteVolunteer');
    if (!props.isSearching) return null;
    if (props.loading && props.people.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "invite-results-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
            fullScreen: false
        })
    });
    if (props.people.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
        className: "invite-hint",
        children: t('noMatches')
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "invite-results",
        children: props.people.map((person)=>{
            var _props_selectedPerson;
            const isSelected = ((_props_selectedPerson = props.selectedPerson) === null || _props_selectedPerson === void 0 ? void 0 : _props_selectedPerson.id) === person.id;
            var _person_attributes_email;
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: isSelected ? 'invite-result is-selected' : 'invite-result',
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2baa135e072363db$export$2e2bcd8739ae039), {
                    name: person.attributes.name,
                    email: (_person_attributes_email = person.attributes.email) !== null && _person_attributes_email !== void 0 ? _person_attributes_email : undefined,
                    onClick: ()=>props.onSelect(person)
                })
            }, person.id);
        })
    });
}







var $dc4ccb2f22e15fa3$exports = {};
$dc4ccb2f22e15fa3$exports = $parcel$resolve("71O5d");


var $ced971621fdd495b$exports = {};
$ced971621fdd495b$exports = $parcel$resolve("fvXcC");



function $1000fbd3382c2a62$export$2e2bcd8739ae039(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('volunteering');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9108a7a2191b8648$export$2e2bcd8739ae039), {
        className: "volunteer-context-menu",
        x: props.x,
        y: props.y,
        isClosing: props.isClosing,
        onRequestClose: props.onRequestClose,
        sections: [
            {
                className: 'volunteer-context-menu-actions',
                items: [
                    {
                        key: 'details',
                        className: 'volunteer-context-action',
                        onClick: props.onDetails,
                        content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($dc4ccb2f22e15fa3$exports))),
                                    alt: "",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: t('menu.details')
                                })
                            ]
                        })
                    },
                    {
                        key: 'edit-roles',
                        className: 'volunteer-context-action',
                        onClick: props.onEditRoles,
                        content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($a9cdc003ba228dda$exports))),
                                    alt: "",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: t('menu.editRoles')
                                })
                            ]
                        })
                    },
                    {
                        key: 'assigned-training',
                        className: 'volunteer-context-action',
                        onClick: props.onAssignedTraining,
                        content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($ced971621fdd495b$exports))),
                                    alt: "",
                                    "aria-hidden": "true"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: t('menu.assignedTraining')
                                })
                            ]
                        })
                    }
                ]
            },
            {
                className: 'volunteer-context-menu-actions',
                items: [
                    {
                        key: 'remove',
                        className: 'volunteer-context-action destructive',
                        onClick: props.onRemoveFromTeam,
                        content: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cb1d7f76a966659b$export$c8cea87c262cf9fb), {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                    children: t('menu.removeFromTeam')
                                })
                            ]
                        })
                    }
                ]
            }
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");





function $e4e2a96d7c6c34a4$export$2e2bcd8739ae039(props) {
    var _props_target, _props_target1;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        'removeVolunteer',
        'volunteering'
    ]);
    const [isRemoving, setIsRemoving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const removeVolunteer = async ()=>{
        if (!auth.churchId || !props.target) {
            setError(t('volunteering:errors.missingChurch'));
            return;
        }
        setIsRemoving(true);
        setError(null);
        try {
            const response = await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).removeTeamMember(auth.churchId, props.target.teamID, props.target.personID, auth);
            if (response.error) {
                setError(response.error);
                setIsRemoving(false);
                return;
            }
            props.onRemoved();
        } finally{
            setIsRemoving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "remove-volunteer-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "remove-volunteer-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            disabled: isRemoving,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: t('volunteering:common.close')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: t('title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "header-control-spacer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "remove-copy",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: ((_props_target = props.target) === null || _props_target === void 0 ? void 0 : _props_target.personName) && ((_props_target1 = props.target) === null || _props_target1 === void 0 ? void 0 : _props_target1.teamName) ? t('confirm', {
                                    person: props.target.personName,
                                    team: props.target.teamName
                                }) : t('confirmUnnamed')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "caption",
                            children: t('caption')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "remove-actions",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                className: "remove-button",
                                disabled: isRemoving,
                                onClick: ()=>{
                                    removeVolunteer();
                                },
                                children: isRemoving ? t('removing') : t('remove')
                            })
                        })
                    ]
                })
            ]
        })
    });
}







var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");


// The asset type the upload-target endpoint expects for Volunteering assets,
// alongside Launchpad's 'launchpad'.
const $3b4da10d641ce97c$var$VOLUNTEERING_ASSET_TYPE = 'volunteering';
class $3b4da10d641ce97c$export$2e2bcd8739ae039 {
    static async fetchTrainingModules(churchID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/volunteering/training-modules`), auth.consumeRefreshToken);
    }
    static async fetchTrainingModule(churchID, moduleID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/volunteering/training-modules/${moduleID}`), auth.consumeRefreshToken);
    }
    static async createTrainingModule(churchID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/volunteering/training-modules`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    static async updateTrainingModule(churchID, moduleID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/volunteering/training-modules/${moduleID}`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    static async createTrainingResource(churchID, moduleID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/volunteering/training-modules/${moduleID}/resources`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    static async updateTrainingResource(churchID, moduleID, resourceID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/volunteering/training-modules/${moduleID}/resources/${resourceID}`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    static async createVideoUploadTarget(churchID, moduleID, resourceID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/volunteering/training-modules/${moduleID}/resources/${resourceID}/video-upload-target`), auth.consumeRefreshToken);
    }
    // External videos are only playable through a URL the server hands back.
    static async fetchVideoURL(churchID, moduleID, resourceID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/volunteering/training-modules/${moduleID}/resources/${resourceID}/video-url`), auth.consumeRefreshToken);
    }
    // Assignments hang off the person rather than a team: a volunteer's training
    // can come from any team they're on.
    static async fetchVolunteerTrainingAssignments(churchID, personID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/v1/church/${churchID}/people/${personID}/training-assignments`), auth.consumeRefreshToken);
    }
    static async assignTrainingModule(churchID, teamID, personID, assignment, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/volunteering/teams/${teamID}/members/${personID}/training-assignments`, assignment), auth.consumeRefreshToken);
    }
    static async createThumbnailUploadTarget(churchID, contentType, fileSizeBytes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/assets/upload-target`, {
            assetType: $3b4da10d641ce97c$var$VOLUNTEERING_ASSET_TYPE,
            contentType: contentType,
            fileSizeBytes: fileSizeBytes
        }), auth.consumeRefreshToken);
    }
}
$3b4da10d641ce97c$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";



var $2Bwgd = parcelRequire("2Bwgd");
function $9202b6e1bfa100e3$export$2e2bcd8739ae039(options = {}) {
    var _options_enabled;
    const enabled = (_options_enabled = options.enabled) !== null && _options_enabled !== void 0 ? _options_enabled : true;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    const [modules, setModules] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [hasLoaded, setHasLoaded] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchID) return;
        setLoading(true);
        setError(null);
        const response = await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).fetchTrainingModules(churchID, auth);
        var _response_body_results;
        if (response.error || !response.body) {
            setError(response.error || (0, $2Bwgd.default).t('volunteering:errors.loadTrainingModules'));
            setModules([]);
        } else setModules((_response_body_results = response.body.results) !== null && _response_body_results !== void 0 ? _response_body_results : []);
        setLoading(false);
        setHasLoaded(true);
    }, [
        churchID,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!enabled) return;
        fetch();
    }, [
        fetch,
        enabled
    ]);
    return {
        modules: modules,
        loading: loading,
        hasLoaded: hasLoaded,
        error: error,
        refetch: fetch
    };
}






// The API's allowed window, and the same default as assigning by hand.
const $f95d939cf11254b6$var$DUE_IN_DAYS_MIN = 1;
const $f95d939cf11254b6$var$DUE_IN_DAYS_MAX = 365;
const $f95d939cf11254b6$var$DEFAULT_DUE_IN_DAYS = 14;
function $f95d939cf11254b6$var$parseDueInDays(value) {
    const days = Number(value);
    return Number.isInteger(days) && days >= $f95d939cf11254b6$var$DUE_IN_DAYS_MIN && days <= $f95d939cf11254b6$var$DUE_IN_DAYS_MAX ? days : null;
}
function $f95d939cf11254b6$var$isSameTraining(draft, saved) {
    return draft.length === saved.length && draft.every((rule, index)=>{
        return rule.moduleID === saved[index].moduleID && $f95d939cf11254b6$var$parseDueInDays(rule.dueInDays) === saved[index].dueInDays;
    });
}
function $f95d939cf11254b6$var$isSameName(one, two) {
    return one.trim().toLowerCase() === two.trim().toLowerCase();
}
function $f95d939cf11254b6$export$2e2bcd8739ae039(props) {
    var _props_team;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        'manageRoles',
        'volunteering'
    ]);
    // Seeded once per open. Each response lands here directly, so the list
    // doesn't wait on the page's refetch to catch up.
    const [roles, setRoles] = (0, $7fPBF.useState)(props.roles);
    const [newName, setNewName] = (0, $7fPBF.useState)('');
    const [rowMode, setRowMode] = (0, $7fPBF.useState)(null);
    const [renameValue, setRenameValue] = (0, $7fPBF.useState)('');
    const [trainingDraft, setTrainingDraft] = (0, $7fPBF.useState)([]);
    // Only once the modal is open: it stays mounted while hidden.
    const { modules: modules, loading: modulesLoading, error: modulesError } = (0, $9202b6e1bfa100e3$export$2e2bcd8739ae039)({
        enabled: props.isOpen
    });
    const moduleNameByID = new Map(modules.map((module)=>[
            module.id,
            module.attributes.name
        ]));
    const moduleName = (moduleID)=>{
        var _moduleNameByID_get;
        return (_moduleNameByID_get = moduleNameByID.get(moduleID)) !== null && _moduleNameByID_get !== void 0 ? _moduleNameByID_get : modulesLoading ? t('volunteering:common.loading') : t('unknownModule');
    };
    // What a role hands out, for its row. Counts stand in while names load.
    const trainingSummary = (role)=>{
        var _role_attributes_autoAssignedTraining;
        const rules = (_role_attributes_autoAssignedTraining = role.attributes.autoAssignedTraining) !== null && _role_attributes_autoAssignedTraining !== void 0 ? _role_attributes_autoAssignedTraining : [];
        if (rules.length === 0) return null;
        if (modulesLoading && modules.length === 0) return t('summaryCount', {
            count: rules.length
        });
        const list = rules.map((rule)=>t('summaryItem', {
                module: moduleName(rule.moduleID),
                count: rule.dueInDays
            })).join(t('listSeparator'));
        return t('summaryList', {
            list: list
        });
    };
    // 'add' while creating, or the ID of the role being changed.
    const [busy, setBusy] = (0, $7fPBF.useState)(null);
    const [error, setError] = (0, $7fPBF.useState)(null);
    // What the last training save handed out to people already holding the role.
    const [notice, setNotice] = (0, $7fPBF.useState)(null);
    const isBusy = busy !== null;
    const trimmedNewName = newName.trim();
    const sortedRoles = [
        ...roles
    ].sort((one, two)=>one.attributes.name.localeCompare(two.attributes.name));
    // The API allows duplicate names, but two "Greeter" roles on one team can't
    // be told apart anywhere they're shown.
    const isNameTaken = (name, exceptRoleID)=>{
        return roles.some((role)=>role.id !== exceptRoleID && $f95d939cf11254b6$var$isSameName(role.attributes.name, name));
    };
    const isNewNameTaken = trimmedNewName.length > 0 && isNameTaken(trimmedNewName);
    const holderCount = (roleID)=>{
        return props.members.filter((member)=>{
            var _member_attributes_roleIDs;
            return ((_member_attributes_roleIDs = member.attributes.roleIDs) !== null && _member_attributes_roleIDs !== void 0 ? _member_attributes_roleIDs : []).includes(roleID);
        }).length;
    };
    const addRole = async ()=>{
        if (!auth.churchId || !props.team) {
            setError(t('volunteering:errors.missingChurch'));
            return;
        }
        if (trimmedNewName.length === 0 || isNewNameTaken) return;
        setBusy('add');
        setError(null);
        try {
            var _response_body;
            const response = await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).createTeamRole(auth.churchId, props.team.id, {
                name: trimmedNewName,
                autoAssignedTraining: []
            }, auth);
            const created = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.result;
            if (response.error || !created) {
                setError(response.error || t('createFailed'));
                return;
            }
            setRoles((currentRoles)=>[
                    ...currentRoles,
                    created
                ]);
            setNewName('');
            props.onChanged();
        } finally{
            setBusy(null);
        }
    };
    const renameRole = async (role)=>{
        const name = renameValue.trim();
        if (!auth.churchId || !props.team || name.length === 0) return;
        if (name === role.attributes.name) {
            setRowMode(null);
            return;
        }
        if (isNameTaken(name, role.id)) {
            setError(t('duplicateNamed', {
                name: name
            }));
            return;
        }
        setBusy(role.id);
        setError(null);
        try {
            var _response_body;
            var _role_attributes_autoAssignedTraining;
            // The training rules ride along: the API replaces every attribute, and
            // would read a missing list as none.
            const response = await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).updateTeamRole(auth.churchId, props.team.id, role.id, {
                name: name,
                autoAssignedTraining: (_role_attributes_autoAssignedTraining = role.attributes.autoAssignedTraining) !== null && _role_attributes_autoAssignedTraining !== void 0 ? _role_attributes_autoAssignedTraining : []
            }, auth);
            if (response.error) {
                setError(response.error);
                return;
            }
            var _response_body_result;
            const updated = (_response_body_result = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.result) !== null && _response_body_result !== void 0 ? _response_body_result : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, role), {
                attributes: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, role.attributes), {
                    name: name
                })
            });
            setRoles((currentRoles)=>currentRoles.map((currentRole)=>currentRole.id === role.id ? updated : currentRole));
            setRowMode(null);
            props.onChanged();
        } finally{
            setBusy(null);
        }
    };
    // "Assigned Camera Basics to 3 volunteers." Grouped by module, counting the
    // people each actually went to -- anyone who already had it was skipped.
    const assignedNotice = (assignments)=>{
        if (assignments.length === 0) return null;
        const peopleByModule = new Map();
        for (const assignment of assignments){
            var _peopleByModule_get;
            const people = (_peopleByModule_get = peopleByModule.get(assignment.moduleID)) !== null && _peopleByModule_get !== void 0 ? _peopleByModule_get : new Set();
            people.add(assignment.personID);
            peopleByModule.set(assignment.moduleID, people);
        }
        // Array.from rather than a spread: the ES5 target can't spread a Map.
        const parts = Array.from(peopleByModule.entries()).map(([moduleID, people])=>{
            return t('assignedPart', {
                module: moduleName(moduleID),
                count: people.size
            });
        });
        return t('assignedNotice', {
            parts: parts.join(t('assignedJoiner'))
        });
    };
    const openTraining = (role)=>{
        setNotice(null);
        var _role_attributes_autoAssignedTraining;
        setTrainingDraft(((_role_attributes_autoAssignedTraining = role.attributes.autoAssignedTraining) !== null && _role_attributes_autoAssignedTraining !== void 0 ? _role_attributes_autoAssignedTraining : []).map((rule)=>({
                moduleID: rule.moduleID,
                dueInDays: String(rule.dueInDays)
            })));
        setRowMode({
            roleID: role.id,
            kind: 'training'
        });
        setError(null);
    };
    const saveTraining = async (role)=>{
        if (!auth.churchId || !props.team) return;
        const rules = trainingDraft.map((rule)=>({
                moduleID: rule.moduleID,
                dueInDays: $f95d939cf11254b6$var$parseDueInDays(rule.dueInDays)
            }));
        if (rules.some((rule)=>rule.dueInDays === null)) return;
        setBusy(role.id);
        setError(null);
        setNotice(null);
        try {
            var _response_body, _response_body1;
            const autoAssignedTraining = rules;
            const response = await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).updateTeamRole(auth.churchId, props.team.id, role.id, {
                name: role.attributes.name,
                autoAssignedTraining: autoAssignedTraining
            }, auth);
            if (response.error) {
                setError(response.error);
                return;
            }
            var _response_body_result;
            const updated = (_response_body_result = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.result) !== null && _response_body_result !== void 0 ? _response_body_result : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, role), {
                attributes: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, role.attributes), {
                    autoAssignedTraining: autoAssignedTraining
                })
            });
            setRoles((currentRoles)=>currentRoles.map((currentRole)=>currentRole.id === role.id ? updated : currentRole));
            setRowMode(null);
            var _response_body_autoAssignedTraining;
            setNotice(assignedNotice((_response_body_autoAssignedTraining = (_response_body1 = response.body) === null || _response_body1 === void 0 ? void 0 : _response_body1.autoAssignedTraining) !== null && _response_body_autoAssignedTraining !== void 0 ? _response_body_autoAssignedTraining : []));
            props.onChanged();
        } finally{
            setBusy(null);
        }
    };
    const deleteRole = async (role)=>{
        if (!auth.churchId || !props.team) return;
        setBusy(role.id);
        setError(null);
        try {
            const response = await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).deleteTeamRole(auth.churchId, props.team.id, role.id, auth);
            if (response.error) {
                setError(response.error);
                return;
            }
            setRoles((currentRoles)=>currentRoles.filter((currentRole)=>currentRole.id !== role.id));
            setRowMode(null);
            props.onChanged();
        } finally{
            setBusy(null);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "manage-roles-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "manage-roles-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            disabled: isBusy,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: t('volunteering:common.close')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: ((_props_team = props.team) === null || _props_team === void 0 ? void 0 : _props_team.attributes.name) ? t('title', {
                                team: props.team.attributes.name
                            }) : t('titleUnnamed')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "header-control-spacer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "caption",
                            children: t('caption')
                        }),
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        notice ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-notice",
                            role: "status",
                            children: notice
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                            className: "add-role",
                            onSubmit: (e)=>{
                                e.preventDefault();
                                addRole();
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "text",
                                    value: newName,
                                    placeholder: t('newRolePlaceholder'),
                                    "aria-label": t('newRolePlaceholder'),
                                    disabled: isBusy,
                                    onChange: (e)=>setNewName(e.target.value)
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "submit",
                                    className: "add-role-button",
                                    disabled: isBusy || trimmedNewName.length === 0 || isNewNameTaken,
                                    children: busy === 'add' ? t('adding') : t('addRole')
                                })
                            ]
                        }),
                        isNewNameTaken ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "field-hint",
                            children: t('duplicateName')
                        }) : null,
                        sortedRoles.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "empty-roles",
                            children: t('empty')
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                            className: "role-list",
                            children: sortedRoles.map((role)=>{
                                const mode = (rowMode === null || rowMode === void 0 ? void 0 : rowMode.roleID) === role.id ? rowMode.kind : null;
                                const isRowBusy = busy === role.id;
                                const holders = holderCount(role.id);
                                const holdersLabel = t('volunteers', {
                                    count: holders
                                });
                                if (mode === 'training') {
                                    const chosen = new Set(trainingDraft.map((rule)=>rule.moduleID));
                                    const available = modules.filter((module)=>!chosen.has(module.id)).sort((one, two)=>one.attributes.name.localeCompare(two.attributes.name));
                                    const hasInvalidWindow = trainingDraft.some((rule)=>$f95d939cf11254b6$var$parseDueInDays(rule.dueInDays) === null);
                                    var _role_attributes_autoAssignedTraining;
                                    const isUnchanged = $f95d939cf11254b6$var$isSameTraining(trainingDraft, (_role_attributes_autoAssignedTraining = role.attributes.autoAssignedTraining) !== null && _role_attributes_autoAssignedTraining !== void 0 ? _role_attributes_autoAssignedTraining : []);
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                        className: "role-row is-training",
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "role-training-title",
                                                children: t('trainingTitle', {
                                                    role: role.attributes.name
                                                })
                                            }),
                                            trainingDraft.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "role-training-empty",
                                                children: t('trainingEmpty')
                                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                                                className: "role-training-rules",
                                                children: trainingDraft.map((rule, index)=>{
                                                    const name = moduleName(rule.moduleID);
                                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                                        className: "role-training-rule",
                                                        children: [
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                                className: "role-training-module",
                                                                children: name
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                                                className: "role-training-due",
                                                                children: [
                                                                    t('dueInBefore'),
                                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                                        type: "number",
                                                                        inputMode: "numeric",
                                                                        min: $f95d939cf11254b6$var$DUE_IN_DAYS_MIN,
                                                                        max: $f95d939cf11254b6$var$DUE_IN_DAYS_MAX,
                                                                        step: 1,
                                                                        value: rule.dueInDays,
                                                                        "aria-label": t('dueInLabel', {
                                                                            module: name
                                                                        }),
                                                                        disabled: isRowBusy,
                                                                        onChange: (e)=>{
                                                                            const value = e.target.value;
                                                                            setTrainingDraft((draft)=>draft.map((current, currentIndex)=>{
                                                                                    return currentIndex === index ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current), {
                                                                                        dueInDays: value
                                                                                    }) : current;
                                                                                }));
                                                                        }
                                                                    }),
                                                                    t('dueInAfter')
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                                type: "button",
                                                                className: "icon-action destructive",
                                                                "aria-label": t('stopAssigning', {
                                                                    module: name
                                                                }),
                                                                disabled: isRowBusy,
                                                                onClick: ()=>{
                                                                    setTrainingDraft((draft)=>draft.filter((_, currentIndex)=>currentIndex !== index));
                                                                },
                                                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($f382a5c80f18c5e3$exports))),
                                                                    alt: "",
                                                                    "aria-hidden": "true"
                                                                })
                                                            })
                                                        ]
                                                    }, rule.moduleID);
                                                })
                                            }),
                                            hasInvalidWindow ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "field-hint",
                                                children: t('invalidWindow', {
                                                    min: $f95d939cf11254b6$var$DUE_IN_DAYS_MIN,
                                                    max: $f95d939cf11254b6$var$DUE_IN_DAYS_MAX
                                                })
                                            }) : null,
                                            modulesError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "field-hint",
                                                children: modulesError
                                            }) : null,
                                            available.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                                className: "role-training-add",
                                                value: "",
                                                "aria-label": t('addModule'),
                                                disabled: isRowBusy,
                                                onChange: (e)=>{
                                                    const moduleID = e.target.value;
                                                    if (!moduleID) return;
                                                    setTrainingDraft((draft)=>[
                                                            ...draft,
                                                            {
                                                                moduleID: moduleID,
                                                                dueInDays: String($f95d939cf11254b6$var$DEFAULT_DUE_IN_DAYS)
                                                            }
                                                        ]);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                        value: "",
                                                        children: t('addModuleOption')
                                                    }),
                                                    available.map((module)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                            value: module.id,
                                                            children: module.attributes.name
                                                        }, module.id))
                                                ]
                                            }) : null,
                                            !modulesLoading && !modulesError && modules.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "role-training-empty",
                                                children: t('noModules')
                                            }) : null,
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                className: "role-training-caption",
                                                children: holders > 0 ? t('trainingCaptionHolders', {
                                                    count: holders
                                                }) : t('trainingCaptionNoHolders')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                className: "role-delete-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "row-action primary",
                                                        disabled: isRowBusy || hasInvalidWindow || isUnchanged,
                                                        onClick: ()=>{
                                                            saveTraining(role);
                                                        },
                                                        children: isRowBusy ? t('volunteering:common.saving') : t('volunteering:common.save')
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                        type: "button",
                                                        className: "row-action",
                                                        disabled: isRowBusy,
                                                        onClick: ()=>setRowMode(null),
                                                        children: t('volunteering:common.cancel')
                                                    })
                                                ]
                                            })
                                        ]
                                    }, role.id);
                                }
                                if (mode === 'rename') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                    className: "role-row is-editing",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                                        className: "role-rename",
                                        onSubmit: (e)=>{
                                            e.preventDefault();
                                            renameRole(role);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                type: "text",
                                                value: renameValue,
                                                "aria-label": t('renameLabel', {
                                                    role: role.attributes.name
                                                }),
                                                autoFocus: true,
                                                disabled: isRowBusy,
                                                onChange: (e)=>setRenameValue(e.target.value),
                                                onKeyDown: (e)=>{
                                                    if (e.key === 'Escape') setRowMode(null);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                type: "submit",
                                                className: "row-action primary",
                                                disabled: isRowBusy || renameValue.trim().length === 0,
                                                children: isRowBusy ? t('volunteering:common.saving') : t('volunteering:common.save')
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                type: "button",
                                                className: "row-action",
                                                disabled: isRowBusy,
                                                onClick: ()=>setRowMode(null),
                                                children: t('volunteering:common.cancel')
                                            })
                                        ]
                                    })
                                }, role.id);
                                if (mode === 'delete') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                    className: "role-row is-confirming",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                            className: "role-delete-copy",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                                    children: t('deleteConfirm', {
                                                        role: role.attributes.name
                                                    })
                                                }),
                                                ' ',
                                                holders > 0 ? t('deleteHolders', {
                                                    count: holders
                                                }) : t('deleteNoHolders')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "role-delete-actions",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "row-action destructive",
                                                    disabled: isRowBusy,
                                                    onClick: ()=>{
                                                        deleteRole(role);
                                                    },
                                                    children: isRowBusy ? t('deleting') : t('delete')
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "row-action",
                                                    disabled: isRowBusy,
                                                    onClick: ()=>setRowMode(null),
                                                    children: t('volunteering:common.cancel')
                                                })
                                            ]
                                        })
                                    ]
                                }, role.id);
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                    className: "role-row",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "role-main",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "role-name",
                                                    children: role.attributes.name
                                                }),
                                                trainingSummary(role) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                    className: "role-training-summary",
                                                    children: trainingSummary(role)
                                                }) : null
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "role-holders",
                                            children: holdersLabel
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            className: "icon-action",
                                            "aria-label": t('trainingTitle', {
                                                role: role.attributes.name
                                            }),
                                            disabled: isBusy,
                                            onClick: ()=>openTraining(role),
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ced971621fdd495b$exports))),
                                                alt: "",
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            className: "icon-action",
                                            "aria-label": t('renameLabel', {
                                                role: role.attributes.name
                                            }),
                                            disabled: isBusy,
                                            onClick: ()=>{
                                                setRenameValue(role.attributes.name);
                                                setRowMode({
                                                    roleID: role.id,
                                                    kind: 'rename'
                                                });
                                                setError(null);
                                            },
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($a9cdc003ba228dda$exports))),
                                                alt: "",
                                                "aria-hidden": "true"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                            type: "button",
                                            className: "icon-action destructive",
                                            "aria-label": t('deleteLabel', {
                                                role: role.attributes.name
                                            }),
                                            disabled: isBusy,
                                            onClick: ()=>{
                                                setRowMode({
                                                    roleID: role.id,
                                                    kind: 'delete'
                                                });
                                                setError(null);
                                            },
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($f382a5c80f18c5e3$exports))),
                                                alt: "",
                                                "aria-hidden": "true"
                                            })
                                        })
                                    ]
                                }, role.id);
                            })
                        })
                    ]
                })
            ]
        })
    });
}





var $7fPBF = parcelRequire("7fPBF");








function $9329c7a53fa84a02$export$2e2bcd8739ae039(props) {
    var _props_target, _props_target1, _props_target2;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { t: t, i18n: i18n } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        'editMemberRoles',
        'volunteering'
    ]);
    const personName = ((_props_target = props.target) === null || _props_target === void 0 ? void 0 : _props_target.personName) || t('fallbackPerson');
    // Only roles the team still defines count. One deleted since the page loaded
    // shouldn't read as a change, or be sent back and rejected.
    const knownRoleIDs = new Set(props.roles.map((role)=>role.id));
    var _props_target_roleIDs;
    const initialRoleIDs = ((_props_target_roleIDs = (_props_target1 = props.target) === null || _props_target1 === void 0 ? void 0 : _props_target1.roleIDs) !== null && _props_target_roleIDs !== void 0 ? _props_target_roleIDs : []).filter((roleID)=>knownRoleIDs.has(roleID));
    const [roleIDs, setRoleIDs] = (0, $7fPBF.useState)(initialRoleIDs);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    // Training handed out by the roles just given, shown before closing so it
    // doesn't happen silently.
    const [assigned, setAssigned] = (0, $7fPBF.useState)(null);
    var _assigned_length;
    // Names for that list, fetched only if there's something to name.
    const { modules: modules } = (0, $9202b6e1bfa100e3$export$2e2bcd8739ae039)({
        enabled: ((_assigned_length = assigned === null || assigned === void 0 ? void 0 : assigned.length) !== null && _assigned_length !== void 0 ? _assigned_length : 0) > 0
    });
    const moduleNameByID = new Map(modules.map((module)=>[
            module.id,
            module.attributes.name
        ]));
    // Training is handed out for roles newly gained, so that's what the copy
    // counts -- not the number of modules.
    const gainedRoleCount = roleIDs.filter((roleID)=>!initialRoleIDs.includes(roleID)).length;
    const hasChanges = roleIDs.length !== initialRoleIDs.length || roleIDs.some((roleID)=>!initialRoleIDs.includes(roleID));
    const save = async ()=>{
        if (!auth.churchId || !props.target) {
            setError(t('volunteering:errors.missingChurch'));
            return;
        }
        setIsSaving(true);
        setError(null);
        try {
            var _response_body;
            const response = await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).setMemberRoles(auth.churchId, props.target.teamID, props.target.personID, roleIDs, auth);
            if (response.error) {
                setError(response.error);
                return;
            }
            var _response_body_autoAssignedTraining;
            const assignments = (_response_body_autoAssignedTraining = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.autoAssignedTraining) !== null && _response_body_autoAssignedTraining !== void 0 ? _response_body_autoAssignedTraining : [];
            if (assignments.length > 0) {
                setAssigned(assignments);
                return;
            }
            props.onSaved();
        } finally{
            setIsSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "edit-member-roles-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "edit-member-roles-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            disabled: isSaving,
                            // Once saved, closing is how the page learns the roles changed.
                            onClick: assigned ? props.onSaved : props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: t('volunteering:common.close')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: assigned ? t('savedTitle') : t('title')
                        }),
                        assigned ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "header-control-spacer"
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: isSaving ? 'header-control confirm saving' : 'header-control confirm',
                            disabled: !hasChanges || isSaving,
                            onClick: ()=>{
                                save();
                            },
                            children: isSaving ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "header-control-spinner",
                                role: "status",
                                "aria-label": t('savingLabel')
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d5bdfc11cea11cc4$exports))),
                                alt: t('saveLabel')
                            })
                        })
                    ]
                }),
                assigned ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "assigned-training-copy",
                            children: t('assigned', {
                                person: personName,
                                count: gainedRoleCount
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                            className: "assigned-training",
                            children: assigned.map((assignment)=>{
                                const dueDate = assignment.dueDate ? new Date(assignment.dueDate) : null;
                                var _moduleNameByID_get;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "assigned-training-name",
                                            children: (_moduleNameByID_get = moduleNameByID.get(assignment.moduleID)) !== null && _moduleNameByID_get !== void 0 ? _moduleNameByID_get : t('fallbackModule')
                                        }),
                                        dueDate && !Number.isNaN(dueDate.getTime()) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                            className: "assigned-training-due",
                                            children: t('due', {
                                                date: dueDate.toLocaleDateString(i18n.language, {
                                                    month: 'short',
                                                    day: 'numeric'
                                                })
                                            })
                                        }) : null
                                    ]
                                }, assignment.moduleID);
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "text-button",
                            onClick: props.onSaved,
                            children: t('volunteering:common.done')
                        })
                    ]
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "caption",
                            children: ((_props_target2 = props.target) === null || _props_target2 === void 0 ? void 0 : _props_target2.teamName) ? t('caption', {
                                person: personName,
                                team: props.target.teamName
                            }) : personName
                        }),
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        props.roles.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "no-roles",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: t('noRoles')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                    type: "button",
                                    className: "text-button",
                                    onClick: props.onManageRoles,
                                    children: t('createRoles')
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f6bd0f2dafc61f4b$export$2e2bcd8739ae039), {
                            roles: props.roles,
                            selectedRoleIDs: roleIDs,
                            disabled: isSaving,
                            onToggle: (roleID)=>setRoleIDs((currentRoleIDs)=>(0, $f6bd0f2dafc61f4b$export$1976c4a4228eddb2)(currentRoleIDs, roleID))
                        })
                    ]
                })
            ]
        })
    });
}





var $7fPBF = parcelRequire("7fPBF");





function $ebb6cc86732a7060$export$2e2bcd8739ae039(props) {
    var _props_team;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        'editTeam',
        'volunteering'
    ]);
    var _props_team_attributes_name;
    const currentName = (_props_team_attributes_name = (_props_team = props.team) === null || _props_team === void 0 ? void 0 : _props_team.attributes.name) !== null && _props_team_attributes_name !== void 0 ? _props_team_attributes_name : '';
    const [name, setName] = (0, $7fPBF.useState)(currentName);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const trimmedName = name.trim();
    // The API rejects an empty name, and saving an unchanged one is a no-op.
    const canSave = trimmedName.length > 0 && trimmedName !== currentName.trim() && !isSaving;
    const save = async ()=>{
        if (!auth.churchId || !props.team) {
            setError(t('volunteering:errors.missingChurch'));
            return;
        }
        if (!canSave) return;
        setIsSaving(true);
        setError(null);
        try {
            const response = await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).updateTeam(auth.churchId, props.team.id, trimmedName, auth);
            if (response.error) {
                setError(response.error);
                return;
            }
            // The page refetches for the saved name rather than reading it back from
            // this response, which may carry it in its stored, localized form.
            props.onSaved();
        } finally{
            setIsSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "edit-team-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "edit-team-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            disabled: isSaving,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: t('volunteering:common.close')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: t('title')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "header-control-spacer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                    className: "body",
                    onSubmit: (e)=>{
                        e.preventDefault();
                        save();
                    },
                    children: [
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                            className: "field-label",
                            htmlFor: "edit-team-name",
                            children: t('nameLabel')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                            id: "edit-team-name",
                            type: "text",
                            value: name,
                            autoFocus: true,
                            disabled: isSaving,
                            onChange: (e)=>setName(e.target.value)
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "submit",
                            className: "save-button",
                            disabled: !canSave,
                            children: isSaving ? t('saving') : t('save')
                        })
                    ]
                })
            ]
        })
    });
}


const $23b3202b2105069a$var$MENU_EXIT_DURATION_MS = 140;
const $23b3202b2105069a$export$493bb586d9d56e67 = 6;
function $23b3202b2105069a$export$8f3d9efee1fc4b24(teamID) {
    return `/team/${teamID}`;
}
function $23b3202b2105069a$export$2e2bcd8739ae039(props) {
    var _bundleFor;
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const { bundles: bundles, refetch: refetch } = props;
    // Looked up at render rather than captured when a modal opens, so a modal
    // sees roles added or renamed while it's open.
    const bundleFor = (teamID)=>{
        var _bundles_find;
        return (_bundles_find = bundles.find((bundle)=>bundle.team.id === teamID)) !== null && _bundles_find !== void 0 ? _bundles_find : null;
    };
    const rolesFor = (teamID)=>{
        var _bundleFor;
        var _bundleFor_roles;
        return (_bundleFor_roles = (_bundleFor = bundleFor(teamID)) === null || _bundleFor === void 0 ? void 0 : _bundleFor.roles) !== null && _bundleFor_roles !== void 0 ? _bundleFor_roles : [];
    };
    // Back from the person's page returns to whichever page this is hosted on.
    const openPerson = (personID, personName)=>{
        const state = {
            personName: personName,
            backLocation: location.pathname
        };
        navigate((0, $d093efa5d4df2a8b$export$f7fd57ccce645fe2)(personID), {
            state: state
        });
    };
    const [teamForInvite, setTeamForInvite] = (0, $7fPBF.useState)(null);
    const [isInviteModalOpen, setIsInviteModalOpen] = (0, $7fPBF.useState)(false);
    const closeInviteModal = ()=>{
        setIsInviteModalOpen(false);
        window.setTimeout(()=>{
            setTeamForInvite(null);
        }, 200);
    };
    const openInviteModal = (team)=>{
        setTeamForInvite(team);
        setIsInviteModalOpen(true);
    };
    // Keyed per open, so the modal re-seeds from the team's latest roles.
    const [teamForRoles, setTeamForRoles] = (0, $7fPBF.useState)(null);
    const [isRolesModalOpen, setIsRolesModalOpen] = (0, $7fPBF.useState)(false);
    const [rolesModalKey, setRolesModalKey] = (0, $7fPBF.useState)(0);
    const openRolesModal = (team)=>{
        setTeamForRoles(team);
        setRolesModalKey((currentKey)=>currentKey + 1);
        setIsRolesModalOpen(true);
    };
    // Keyed per open, so the name field starts from the team's current name.
    const [teamForEdit, setTeamForEdit] = (0, $7fPBF.useState)(null);
    const [isEditTeamOpen, setIsEditTeamOpen] = (0, $7fPBF.useState)(false);
    const [editTeamKey, setEditTeamKey] = (0, $7fPBF.useState)(0);
    const openEditTeam = (team)=>{
        setTeamForEdit(team);
        setEditTeamKey((currentKey)=>currentKey + 1);
        setIsEditTeamOpen(true);
    };
    // Also keyed per open: reopening for the same volunteer after a save should
    // start from what they hold now, not what was picked last time.
    const [memberRolesTarget, setMemberRolesTarget] = (0, $7fPBF.useState)(null);
    const [isMemberRolesOpen, setIsMemberRolesOpen] = (0, $7fPBF.useState)(false);
    const [memberRolesKey, setMemberRolesKey] = (0, $7fPBF.useState)(0);
    // The menu stays mounted through its exit animation, so the selected and
    // displayed states are tracked separately.
    const [selectedMenu, setSelectedMenu] = (0, $7fPBF.useState)(null);
    const [displayedMenu, setDisplayedMenu] = (0, $7fPBF.useState)(null);
    const [isClosingMenu, setIsClosingMenu] = (0, $7fPBF.useState)(false);
    (0, $7fPBF.useEffect)(()=>{
        if (selectedMenu) {
            setDisplayedMenu(selectedMenu);
            setIsClosingMenu(false);
            return;
        }
        if (!displayedMenu) {
            setIsClosingMenu(false);
            return;
        }
        setIsClosingMenu(true);
        const timeout = window.setTimeout(()=>{
            setDisplayedMenu(null);
            setIsClosingMenu(false);
        }, $23b3202b2105069a$var$MENU_EXIT_DURATION_MS);
        return ()=>window.clearTimeout(timeout);
    }, [
        selectedMenu,
        displayedMenu
    ]);
    const [removalTarget, setRemovalTarget] = (0, $7fPBF.useState)(null);
    const [isRemoveModalOpen, setIsRemoveModalOpen] = (0, $7fPBF.useState)(false);
    const closeRemoveModal = ()=>{
        setIsRemoveModalOpen(false);
        window.setTimeout(()=>{
            setRemovalTarget(null);
        }, 200);
    };
    var _teamForInvite_id, _bundleFor_members;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e03a092891f51785$export$2e2bcd8739ae039), {
                isOpen: isInviteModalOpen,
                team: teamForInvite,
                roles: rolesFor(teamForInvite === null || teamForInvite === void 0 ? void 0 : teamForInvite.id),
                close: closeInviteModal,
                onInvited: ()=>{
                    closeInviteModal();
                    refetch();
                }
            }, (_teamForInvite_id = teamForInvite === null || teamForInvite === void 0 ? void 0 : teamForInvite.id) !== null && _teamForInvite_id !== void 0 ? _teamForInvite_id : 'invite-volunteer'),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f95d939cf11254b6$export$2e2bcd8739ae039), {
                isOpen: isRolesModalOpen,
                team: teamForRoles,
                roles: rolesFor(teamForRoles === null || teamForRoles === void 0 ? void 0 : teamForRoles.id),
                members: (_bundleFor_members = (_bundleFor = bundleFor(teamForRoles === null || teamForRoles === void 0 ? void 0 : teamForRoles.id)) === null || _bundleFor === void 0 ? void 0 : _bundleFor.members) !== null && _bundleFor_members !== void 0 ? _bundleFor_members : [],
                close: ()=>setIsRolesModalOpen(false),
                onChanged: ()=>{
                    refetch();
                }
            }, `manage-roles-${rolesModalKey}`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebb6cc86732a7060$export$2e2bcd8739ae039), {
                isOpen: isEditTeamOpen,
                team: teamForEdit,
                close: ()=>setIsEditTeamOpen(false),
                onSaved: ()=>{
                    setIsEditTeamOpen(false);
                    refetch();
                }
            }, `edit-team-${editTeamKey}`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9329c7a53fa84a02$export$2e2bcd8739ae039), {
                isOpen: isMemberRolesOpen,
                target: memberRolesTarget,
                roles: rolesFor(memberRolesTarget === null || memberRolesTarget === void 0 ? void 0 : memberRolesTarget.teamID),
                close: ()=>setIsMemberRolesOpen(false),
                onSaved: ()=>{
                    setIsMemberRolesOpen(false);
                    refetch();
                },
                onManageRoles: ()=>{
                    setIsMemberRolesOpen(false);
                    const bundle = bundleFor(memberRolesTarget === null || memberRolesTarget === void 0 ? void 0 : memberRolesTarget.teamID);
                    if (bundle) openRolesModal(bundle.team);
                }
            }, `member-roles-${memberRolesKey}`),
            displayedMenu ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1000fbd3382c2a62$export$2e2bcd8739ae039), {
                personName: displayedMenu.personName,
                x: displayedMenu.x,
                y: displayedMenu.y,
                isClosing: isClosingMenu,
                onRequestClose: ()=>setSelectedMenu(null),
                onDetails: ()=>{
                    setSelectedMenu(null);
                    openPerson(displayedMenu.personID, displayedMenu.personName);
                },
                onEditRoles: ()=>{
                    setSelectedMenu(null);
                    setMemberRolesTarget({
                        personID: displayedMenu.personID,
                        personName: displayedMenu.personName,
                        teamID: displayedMenu.teamID,
                        teamName: displayedMenu.teamName,
                        roleIDs: displayedMenu.roleIDs
                    });
                    setMemberRolesKey((currentKey)=>currentKey + 1);
                    setIsMemberRolesOpen(true);
                },
                onAssignedTraining: ()=>{
                    setSelectedMenu(null);
                    // The names ride along so the detail page's header is right before its
                    // own requests come back.
                    navigate(`/volunteering/teams/${displayedMenu.teamID}/people/${displayedMenu.personID}`, {
                        state: {
                            personName: displayedMenu.personName,
                            teamName: displayedMenu.teamName
                        }
                    });
                },
                onRemoveFromTeam: ()=>{
                    setSelectedMenu(null);
                    setRemovalTarget({
                        personID: displayedMenu.personID,
                        personName: displayedMenu.personName,
                        teamID: displayedMenu.teamID,
                        teamName: displayedMenu.teamName
                    });
                    setIsRemoveModalOpen(true);
                }
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e4e2a96d7c6c34a4$export$2e2bcd8739ae039), {
                isOpen: isRemoveModalOpen,
                target: removalTarget,
                close: closeRemoveModal,
                onRemoved: ()=>{
                    closeRemoveModal();
                    refetch();
                }
            }, removalTarget ? `${removalTarget.teamID}-${removalTarget.personID}` : 'remove-volunteer'),
            bundles.map((team)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($23b3202b2105069a$var$TeamSection, {
                    bundle: team,
                    variant: props.variant,
                    onPersonClick: (member, event)=>{
                        var _member_attributes_roleIDs;
                        setSelectedMenu({
                            personID: member.personID,
                            personName: member.attributes.personName || (0, $2Bwgd.default).t('volunteering:team.unknownPerson'),
                            teamID: team.team.id,
                            teamName: team.team.attributes.name,
                            roleIDs: (_member_attributes_roleIDs = member.attributes.roleIDs) !== null && _member_attributes_roleIDs !== void 0 ? _member_attributes_roleIDs : [],
                            x: event.clientX + window.scrollX,
                            y: event.clientY + window.scrollY
                        });
                    },
                    onRolesClick: openRolesModal,
                    onEditClick: openEditTeam,
                    onInviteClick: openInviteModal
                }, team.team.id))
        ]
    });
}
// The names of the roles a member holds, alphabetised, for their card. An ID
// that no longer resolves -- a role deleted since this load -- is skipped.
function $23b3202b2105069a$var$roleSummary(member, roleNameByID) {
    var _member_attributes_roleIDs;
    return ((_member_attributes_roleIDs = member.attributes.roleIDs) !== null && _member_attributes_roleIDs !== void 0 ? _member_attributes_roleIDs : []).map((roleID)=>roleNameByID.get(roleID)).filter((name)=>Boolean(name)).sort((one, two)=>one.localeCompare(two)).join(', ');
}
function $23b3202b2105069a$var$TeamSection(props) {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('volunteering');
    const team = props.bundle.team;
    const isOverview = props.variant === 'overview';
    const members = props.bundle.members;
    const sorted = (0, $7fPBF.useMemo)(()=>{
        return [
            ...members
        ].sort((a, b)=>{
            const nameA = a.attributes.personName || '';
            const nameB = b.attributes.personName || '';
            return nameA.localeCompare(nameB);
        });
    }, [
        members
    ]);
    const roles = props.bundle.roles;
    const roleNameByID = (0, $7fPBF.useMemo)(()=>{
        return new Map((roles !== null && roles !== void 0 ? roles : []).map((role)=>[
                role.id,
                role.attributes.name
            ]));
    }, [
        roles
    ]);
    const visible = isOverview ? sorted.slice(0, $23b3202b2105069a$export$493bb586d9d56e67) : sorted;
    const hiddenCount = sorted.length - visible.length;
    // The name rides along so the team page's header is right before its own
    // request comes back.
    const openTeamPage = ()=>{
        navigate($23b3202b2105069a$export$8f3d9efee1fc4b24(team.id), {
            state: {
                teamName: team.attributes.name
            }
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "team-section",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($23b3202b2105069a$var$TeamHeader, {
                leading: isOverview ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        className: "team-name-link",
                        onClick: openTeamPage,
                        children: team.attributes.name
                    })
                }) : null,
                onRolesClick: ()=>props.onRolesClick(team),
                onEditClick: ()=>props.onEditClick(team),
                onInviteClick: ()=>props.onInviteClick(team)
            }),
            sorted.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "no-members",
                children: t('team.noMembers')
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "people",
                children: visible.map((member)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2baa135e072363db$export$2e2bcd8739ae039), {
                        name: member.attributes.personName || t('team.unknownPerson'),
                        // The subtitle shows the member's roles rather than an email, which
                        // not every membership carries.
                        email: $23b3202b2105069a$var$roleSummary(member, roleNameByID),
                        onClick: (event)=>{
                            props.onPersonClick(member, event);
                        }
                    }, member.personID))
            }),
            hiddenCount > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                type: "button",
                className: "view-all-button",
                onClick: openTeamPage,
                children: [
                    t('team.viewAll', {
                        count: sorted.length
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($23b3202b2105069a$var$ChevronForwardIcon, {})
                ]
            })
        ]
    });
}
function $23b3202b2105069a$var$TeamHeader(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('volunteering');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "head",
        children: [
            props.leading,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "head-actions",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        className: "icon-action",
                        "aria-label": t('team.roles'),
                        title: t('team.roles'),
                        onClick: props.onRolesClick,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($23b3202b2105069a$var$TagIcon, {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        className: "icon-action",
                        "aria-label": t('team.editTeam'),
                        title: t('team.editTeam'),
                        onClick: props.onEditClick,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($23b3202b2105069a$var$PencilIcon, {})
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        className: "plus-button",
                        "aria-label": t('team.inviteVolunteer'),
                        title: t('team.inviteVolunteer'),
                        onClick: props.onInviteClick,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($8e1e7337a3d903e8$exports))),
                            alt: "",
                            "aria-hidden": "true"
                        })
                    })
                ]
            })
        ]
    });
}
// Drawn inline rather than imported as image assets so they take the button's
// text colour, which keeps them tinted -- and right in dark mode -- without a
// second copy of each icon.
const $23b3202b2105069a$var$ICON_PROPS = {
    viewBox: '0 0 24 24',
    width: 16,
    height: 16,
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2.2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    'aria-hidden': true
};
// lucide: tag
function $23b3202b2105069a$var$TagIcon() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $23b3202b2105069a$var$ICON_PROPS), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
                d: "M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("circle", {
                cx: "7.5",
                cy: "7.5",
                r: "1",
                fill: "currentColor"
            })
        ]
    }));
}
// lucide: pencil
function $23b3202b2105069a$var$PencilIcon() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $23b3202b2105069a$var$ICON_PROPS), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z"
        })
    }));
}
// lucide: chevron-right
function $23b3202b2105069a$var$ChevronForwardIcon() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("svg", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $23b3202b2105069a$var$ICON_PROPS), {
        width: 14,
        height: 14,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("path", {
            d: "m9 18 6-6-6-6"
        })
    }));
}


function $284d277906b46fb8$export$2e2bcd8739ae039() {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('volunteering');
    const { teams: teams, loading: loading, error: error, refetch: refetch } = (0, $db113dffb920235a$export$2e2bcd8739ae039)();
    // Only the very first load blanks the page. A later refetch -- after an
    // invite, a removal, or a token refresh -- leaves what's on screen alone so
    // an open modal keeps its state.
    const isFirstLoad = loading && !teams;
    var _teams_results;
    const bundles = (_teams_results = teams === null || teams === void 0 ? void 0 : teams.results) !== null && _teams_results !== void 0 ? _teams_results : [];
    // Keyed per open, so every open starts back at the source step.
    const [isCreateOpen, setIsCreateOpen] = (0, $7fPBF.useState)(false);
    const [createKey, setCreateKey] = (0, $7fPBF.useState)(0);
    const openCreateTeam = ()=>{
        setCreateKey((currentKey)=>currentKey + 1);
        setIsCreateOpen(true);
    };
    const createTeamModal = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f0bf91c199fcc3cc$export$2e2bcd8739ae039), {
        isOpen: isCreateOpen,
        close: ()=>setIsCreateOpen(false),
        onCreated: (team, name)=>{
            setIsCreateOpen(false);
            // The new team is empty, so its page -- where volunteers get invited --
            // is the next place to be. The name rides along for the header.
            navigate((0, $23b3202b2105069a$export$8f3d9efee1fc4b24)(team.id), {
                state: {
                    teamName: name
                }
            });
        }
    }, `create-team-${createKey}`);
    if (!loading && !error && bundles.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            createTeamModal,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($30bbe81485bfa1db$exports))),
                title: t('teams.emptyTitle'),
                error: t('teams.emptyMessage'),
                buttonText: t('teams.newTeam'),
                buttonAction: openCreateTeam,
                fullHeight: true
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "volunteering-people-page",
        children: [
            createTeamModal,
            isFirstLoad ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                fullScreen: true
            }) : null,
            !isFirstLoad && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "teams-page-header",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: t('teams.heading')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        type: "button",
                        className: "new-team-button",
                        onClick: openCreateTeam,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5c0a9c99fa42f0$exports))),
                                alt: "",
                                "aria-hidden": "true"
                            }),
                            t('teams.newTeam')
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23b3202b2105069a$export$2e2bcd8739ae039), {
                bundles: bundles,
                refetch: refetch,
                variant: "overview"
            }),
            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "error",
                children: error
            })
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");



var $2Bwgd = parcelRequire("2Bwgd");




function $b6bebf3e1b16bb93$export$2e2bcd8739ae039(props) {
    const attributes = props.module.attributes;
    const classNames = [
        'training-module-card',
        'card'
    ];
    if (props.isSelected) classNames.push('is-selected');
    const content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "training-module-thumbnail",
                children: attributes.thumbnailURL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: attributes.thumbnailURL,
                    alt: "",
                    "aria-hidden": "true"
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "thumbnail-fallback",
                    "aria-hidden": "true",
                    children: attributes.name.slice(0, 1)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "training-module-body",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: attributes.name
                    }),
                    attributes.description ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "training-module-description",
                        children: attributes.description
                    }) : null,
                    props.badge ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "training-module-badge",
                        children: props.badge
                    }) : null
                ]
            })
        ]
    });
    if (!props.onClick) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: classNames.join(' '),
        children: content
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        type: "button",
        className: classNames.join(' '),
        "aria-pressed": props.isSelected,
        onClick: props.onClick,
        children: content
    });
}







var $7fPBF = parcelRequire("7fPBF");








function $ef1657690e180529$export$2e2bcd8739ae039(props) {
    var _props_module;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        'moduleEditor',
        'volunteering'
    ]);
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const attributes = (_props_module = props.module) === null || _props_module === void 0 ? void 0 : _props_module.attributes;
    const isEditing = Boolean(props.module);
    var _attributes_name;
    const [name, setName] = (0, $7fPBF.useState)((_attributes_name = attributes === null || attributes === void 0 ? void 0 : attributes.name) !== null && _attributes_name !== void 0 ? _attributes_name : '');
    var _attributes_description;
    const [description, setDescription] = (0, $7fPBF.useState)((_attributes_description = attributes === null || attributes === void 0 ? void 0 : attributes.description) !== null && _attributes_description !== void 0 ? _attributes_description : '');
    var _attributes_campusID;
    const [campusID, setCampusID] = (0, $7fPBF.useState)((_attributes_campusID = attributes === null || attributes === void 0 ? void 0 : attributes.campusID) !== null && _attributes_campusID !== void 0 ? _attributes_campusID : '');
    var _attributes_categoryID;
    const [categoryID, setCategoryID] = (0, $7fPBF.useState)((_attributes_categoryID = attributes === null || attributes === void 0 ? void 0 : attributes.categoryID) !== null && _attributes_categoryID !== void 0 ? _attributes_categoryID : '');
    const [thumbnailFile, setThumbnailFile] = (0, $7fPBF.useState)(null);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    // A picked file previews from a local object URL; an existing module falls
    // back to whatever the API already has.
    const [pickedThumbnailURL, setPickedThumbnailURL] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (!thumbnailFile) {
            setPickedThumbnailURL(null);
            return;
        }
        const objectURL = URL.createObjectURL(thumbnailFile);
        setPickedThumbnailURL(objectURL);
        return ()=>{
            URL.revokeObjectURL(objectURL);
        };
    }, [
        thumbnailFile
    ]);
    var _ref;
    const thumbnailURL = (_ref = pickedThumbnailURL !== null && pickedThumbnailURL !== void 0 ? pickedThumbnailURL : attributes === null || attributes === void 0 ? void 0 : attributes.thumbnailURL) !== null && _ref !== void 0 ? _ref : null;
    // A new Module needs its required fields filled in; an existing one needs an
    // actual change to save.
    const meetsRequirements = name.trim().length > 0 && campusID.length > 0 && categoryID.length > 0;
    var _attributes_name1, _attributes_description1, _attributes_campusID1, _attributes_categoryID1;
    const hasChanges = name !== ((_attributes_name1 = attributes === null || attributes === void 0 ? void 0 : attributes.name) !== null && _attributes_name1 !== void 0 ? _attributes_name1 : '') || description !== ((_attributes_description1 = attributes === null || attributes === void 0 ? void 0 : attributes.description) !== null && _attributes_description1 !== void 0 ? _attributes_description1 : '') || campusID !== ((_attributes_campusID1 = attributes === null || attributes === void 0 ? void 0 : attributes.campusID) !== null && _attributes_campusID1 !== void 0 ? _attributes_campusID1 : '') || categoryID !== ((_attributes_categoryID1 = attributes === null || attributes === void 0 ? void 0 : attributes.categoryID) !== null && _attributes_categoryID1 !== void 0 ? _attributes_categoryID1 : '') || thumbnailFile !== null;
    const canSave = meetsRequirements && (!isEditing || hasChanges) && !isSaving;
    const saveModule = async ()=>{
        if (!auth.churchId) {
            setError(t('volunteering:errors.missingChurch'));
            return;
        }
        setIsSaving(true);
        setError(null);
        try {
            var _attributes_thumbnailURL;
            let uploadedThumbnailURL = (_attributes_thumbnailURL = attributes === null || attributes === void 0 ? void 0 : attributes.thumbnailURL) !== null && _attributes_thumbnailURL !== void 0 ? _attributes_thumbnailURL : null;
            if (thumbnailFile) {
                const uploadTargetResponse = await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).createThumbnailUploadTarget(auth.churchId, thumbnailFile.type || 'application/octet-stream', thumbnailFile.size, auth);
                if (!uploadTargetResponse.body) {
                    setError(uploadTargetResponse.error || t('uploadTargetFailed'));
                    setIsSaving(false);
                    return;
                }
                const uploadSucceeded = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performSignedPost({
                    url: uploadTargetResponse.body.url,
                    fields: uploadTargetResponse.body.fields
                }, thumbnailFile, thumbnailFile.type);
                if (!uploadSucceeded) {
                    setError(t('uploadFailed'));
                    setIsSaving(false);
                    return;
                }
                uploadedThumbnailURL = uploadTargetResponse.body.assetURL;
            }
            const savedAttributes = {
                name: name.trim(),
                description: description.trim() || null,
                thumbnailURL: uploadedThumbnailURL,
                campusID: campusID,
                categoryID: categoryID
            };
            const response = props.module ? await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).updateTrainingModule(auth.churchId, props.module.id, savedAttributes, auth) : await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).createTrainingModule(auth.churchId, savedAttributes, auth);
            if (response.error) {
                setError(response.error);
                setIsSaving(false);
                return;
            }
            props.onSaved();
        } finally{
            setIsSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "module-editor-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "module-editor-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            disabled: isSaving,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: t('volunteering:common.close')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: isEditing ? t('editTitle') : t('newTitle')
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: isSaving ? 'header-control confirm saving' : 'header-control confirm',
                            disabled: !canSave,
                            onClick: ()=>{
                                saveModule();
                            },
                            children: isSaving ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "header-control-spinner",
                                role: "status",
                                "aria-label": t('savingLabel')
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d5bdfc11cea11cc4$exports))),
                                alt: t('saveLabel')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "module-name",
                                    children: t('titleLabel')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    id: "module-name",
                                    type: "text",
                                    value: name,
                                    placeholder: t('titlePlaceholder'),
                                    disabled: isSaving,
                                    onChange: (e)=>setName(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "module-description",
                                    children: t('descriptionLabel')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                    id: "module-description",
                                    rows: 2,
                                    value: description,
                                    placeholder: t('descriptionPlaceholder'),
                                    disabled: isSaving,
                                    onChange: (e)=>setDescription(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "module-thumbnail",
                                    children: t('thumbnailLabel')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "thumbnail-picker",
                                    children: [
                                        thumbnailURL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            className: "thumbnail-preview",
                                            src: thumbnailURL,
                                            alt: "",
                                            "aria-hidden": "true"
                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "thumbnail-preview empty",
                                            "aria-hidden": "true"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "thumbnail-picker-controls",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                    id: "module-thumbnail",
                                                    type: "file",
                                                    accept: "image/*",
                                                    disabled: isSaving,
                                                    onChange: (e)=>{
                                                        var _e_target_files;
                                                        var _e_target_files_;
                                                        return setThumbnailFile((_e_target_files_ = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0]) !== null && _e_target_files_ !== void 0 ? _e_target_files_ : null);
                                                    }
                                                }),
                                                thumbnailFile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "thumbnail-clear",
                                                    disabled: isSaving,
                                                    onClick: ()=>setThumbnailFile(null),
                                                    children: (attributes === null || attributes === void 0 ? void 0 : attributes.thumbnailURL) ? t('keepCurrentImage') : t('clearImage')
                                                }) : null
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "module-campus",
                                    children: t('campusLabel')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                    id: "module-campus",
                                    value: campusID,
                                    disabled: isSaving,
                                    onChange: (e)=>setCampusID(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: "",
                                            disabled: true,
                                            children: t('campusPlaceholder')
                                        }),
                                        churchData.campuses.map((campus)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: campus.id,
                                                children: campus.attributes.name
                                            }, campus.id))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "module-category",
                                    children: t('categoryLabel')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                    id: "module-category",
                                    value: categoryID,
                                    disabled: isSaving,
                                    onChange: (e)=>setCategoryID(e.target.value),
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                            value: "",
                                            disabled: true,
                                            children: t('categoryPlaceholder')
                                        }),
                                        churchData.categories.map((category)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: category.id,
                                                children: category.name
                                            }, category.id))
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




function $7c74839fe1f39bb8$export$2e2bcd8739ae039() {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('training');
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const { modules: modules, loading: loading, hasLoaded: hasLoaded, error: error, refetch: refetch } = (0, $9202b6e1bfa100e3$export$2e2bcd8739ae039)();
    const campusGroups = $7c74839fe1f39bb8$var$groupModules(modules, churchData.campuses, churchData.categories);
    const [isModuleEditorOpen, setIsModuleEditorOpen] = (0, $7fPBF.useState)(false);
    const [newModuleKey, setNewModuleKey] = (0, $7fPBF.useState)(0);
    const openNewModuleEditor = ()=>{
        setNewModuleKey((currentKey)=>currentKey + 1);
        setIsModuleEditorOpen(true);
    };
    const moduleEditor = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef1657690e180529$export$2e2bcd8739ae039), {
        isOpen: isModuleEditorOpen,
        module: null,
        close: ()=>setIsModuleEditorOpen(false),
        onSaved: ()=>{
            setIsModuleEditorOpen(false);
            refetch();
        }
    }, `new-module-${newModuleKey}`);
    if (loading && !hasLoaded) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "training-page training-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {})
    });
    if (error) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        error: error,
        buttonText: t('retry'),
        buttonAction: ()=>refetch(),
        fullHeight: true
    });
    if (modules.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            moduleEditor,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ced971621fdd495b$exports))),
                title: t('emptyTitle'),
                error: t('emptyMessage'),
                buttonText: t('newModule'),
                buttonAction: openNewModuleEditor,
                fullHeight: true
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "training-page",
        children: [
            moduleEditor,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "training-page-header",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: t('heading')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                        type: "button",
                        className: "new-module-button",
                        onClick: openNewModuleEditor,
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5c0a9c99fa42f0$exports))),
                                alt: "",
                                "aria-hidden": "true"
                            }),
                            t('newModule')
                        ]
                    })
                ]
            }),
            campusGroups.map((campusGroup)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
                    className: "training-campus-group",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "training-group-heading",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                children: campusGroup.title
                            })
                        }),
                        campusGroup.categories.map((categoryGroup)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "training-category-group",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "training-group-subheading",
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            children: categoryGroup.title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "training-module-grid",
                                        children: categoryGroup.modules.map((module)=>{
                                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6bebf3e1b16bb93$export$2e2bcd8739ae039), {
                                                module: module,
                                                onClick: ()=>{
                                                    navigate(`/volunteering/training/${module.id}`, {
                                                        state: {
                                                            module: module
                                                        }
                                                    });
                                                }
                                            }, module.id);
                                        })
                                    })
                                ]
                            }, categoryGroup.id))
                    ]
                }, campusGroup.id))
        ]
    });
}
function $7c74839fe1f39bb8$var$groupModules(modules, campuses, categories) {
    const campusNameByID = new Map(campuses.map((campus)=>[
            campus.id,
            campus.attributes.name
        ]));
    const categoryNameByID = new Map(categories.map((category)=>[
            category.id,
            category.name
        ]));
    const sortedModules = [
        ...modules
    ].sort((one, two)=>{
        const campusOne = $7c74839fe1f39bb8$var$getCampusLabel(one, campusNameByID);
        const campusTwo = $7c74839fe1f39bb8$var$getCampusLabel(two, campusNameByID);
        if (campusOne !== campusTwo) return campusOne.localeCompare(campusTwo);
        const categoryOne = $7c74839fe1f39bb8$var$getCategoryLabel(one, categoryNameByID);
        const categoryTwo = $7c74839fe1f39bb8$var$getCategoryLabel(two, categoryNameByID);
        if (categoryOne !== categoryTwo) return categoryOne.localeCompare(categoryTwo);
        return one.attributes.name.localeCompare(two.attributes.name);
    });
    const campusGroups = new Map();
    sortedModules.forEach((module)=>{
        const campusID = module.attributes.campusID;
        const categoryID = module.attributes.categoryID;
        if (!campusGroups.has(campusID)) campusGroups.set(campusID, {
            id: campusID,
            title: $7c74839fe1f39bb8$var$getCampusLabel(module, campusNameByID),
            categories: new Map()
        });
        const campusGroup = campusGroups.get(campusID);
        if (!campusGroup.categories.has(categoryID)) campusGroup.categories.set(categoryID, {
            id: categoryID,
            title: $7c74839fe1f39bb8$var$getCategoryLabel(module, categoryNameByID),
            modules: []
        });
        campusGroup.categories.get(categoryID).modules.push(module);
    });
    return Array.from(campusGroups.values()).map((campusGroup)=>({
            id: campusGroup.id,
            title: campusGroup.title,
            categories: Array.from(campusGroup.categories.values())
        }));
}
function $7c74839fe1f39bb8$var$getCampusLabel(module, campusNameByID) {
    return campusNameByID.get(module.attributes.campusID) || (0, $2Bwgd.default).t('training:unknownCampus');
}
function $7c74839fe1f39bb8$var$getCategoryLabel(module, categoryNameByID) {
    return categoryNameByID.get(module.attributes.categoryID) || (0, $2Bwgd.default).t('training:unknownCategory');
}





var $7fPBF = parcelRequire("7fPBF");



var $2Bwgd = parcelRequire("2Bwgd");




var $7fPBF = parcelRequire("7fPBF");



var $2Bwgd = parcelRequire("2Bwgd");
function $e3a47506f98723a6$export$2e2bcd8739ae039(moduleID, initialModule) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    const [module, setModule] = (0, $7fPBF.useState)(initialModule !== null && initialModule !== void 0 ? initialModule : null);
    const [resources, setResources] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [hasLoaded, setHasLoaded] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        var _response_body;
        if (!churchID || !moduleID) return;
        setLoading(true);
        setError(null);
        const response = await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).fetchTrainingModule(churchID, moduleID, auth);
        const result = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.result;
        if (response.error || !(result === null || result === void 0 ? void 0 : result.module)) {
            setError(response.error || (0, $2Bwgd.default).t('volunteering:errors.loadTrainingModule'));
            setModule(null);
            setResources([]);
        } else {
            setModule(result.module);
            var _result_resources;
            setResources((_result_resources = result.resources) !== null && _result_resources !== void 0 ? _result_resources : []);
        }
        setLoading(false);
        setHasLoaded(true);
    }, [
        churchID,
        moduleID,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    return {
        module: module,
        resources: resources,
        loading: loading,
        hasLoaded: hasLoaded,
        error: error,
        refetch: fetch
    };
}









var $7fPBF = parcelRequire("7fPBF");


var $2Bwgd = parcelRequire("2Bwgd");
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 


function $3e88191b87395c2e$var$t(t1, ...e) {
    const n = new URL("https://lexical.dev/docs/error"), o = new URLSearchParams;
    o.append("code", t1);
    for (const t of e)o.append("v", t);
    throw n.search = o.toString(), Error(`Minified Lexical error #${t1}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function $3e88191b87395c2e$var$e(t, ...e1) {
    const n = new URL("https://lexical.dev/docs/error"), o = new URLSearchParams;
    o.append("code", t);
    for (const t of e1)o.append("v", t);
    n.search = o.toString(), console.warn(`Minified Lexical warning #${t}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
const $3e88191b87395c2e$export$37d2f1e98a187e61 = "undefined" != typeof window && void 0 !== window.document && void 0 !== window.document.createElement, $3e88191b87395c2e$var$o = $3e88191b87395c2e$export$37d2f1e98a187e61 && "documentMode" in document ? document.documentMode : null, $3e88191b87395c2e$export$d093bd80dddd0842 = $3e88191b87395c2e$export$37d2f1e98a187e61 && /Mac|iPod|iPhone|iPad/.test(navigator.platform), $3e88191b87395c2e$export$fa35291248be714f = $3e88191b87395c2e$export$37d2f1e98a187e61 && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent), $3e88191b87395c2e$export$7596791c42a3094d = !(!$3e88191b87395c2e$export$37d2f1e98a187e61 || !("InputEvent" in window) || $3e88191b87395c2e$var$o) && "getTargetRanges" in new window.InputEvent("input"), $3e88191b87395c2e$export$9135b5fce2a2854d = $3e88191b87395c2e$export$37d2f1e98a187e61 && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, $3e88191b87395c2e$export$2760ddee6a71ee7d = $3e88191b87395c2e$export$37d2f1e98a187e61 && /Android/.test(navigator.userAgent), $3e88191b87395c2e$export$af54264dae9065e6 = $3e88191b87395c2e$export$37d2f1e98a187e61 && /Version\/[\d.]+.*Safari/.test(navigator.userAgent) && !$3e88191b87395c2e$export$2760ddee6a71ee7d, $3e88191b87395c2e$export$265e05392e08df49 = $3e88191b87395c2e$export$37d2f1e98a187e61 && /^(?=.*Chrome).*/i.test(navigator.userAgent), $3e88191b87395c2e$export$129f916e5a4d8e94 = $3e88191b87395c2e$export$37d2f1e98a187e61 && $3e88191b87395c2e$export$2760ddee6a71ee7d && $3e88191b87395c2e$export$265e05392e08df49, $3e88191b87395c2e$export$e9250b0198928087 = $3e88191b87395c2e$export$37d2f1e98a187e61 && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && $3e88191b87395c2e$export$d093bd80dddd0842 && !$3e88191b87395c2e$export$265e05392e08df49, $3e88191b87395c2e$var$h = 0, $3e88191b87395c2e$var$g = 1, $3e88191b87395c2e$var$_ = 2, $3e88191b87395c2e$export$d401051135d8c941 = 1, $3e88191b87395c2e$export$6f537bdfcfab164 = 2, $3e88191b87395c2e$export$27809404dee18444 = 4, $3e88191b87395c2e$export$4fefe1576f07e925 = 8, $3e88191b87395c2e$export$bf809f2b03ed57cc = 16, $3e88191b87395c2e$export$22c32c29c50da53a = 32, $3e88191b87395c2e$export$703b9afdf8723203 = 64, $3e88191b87395c2e$export$f1e9b55cdd671814 = 128, $3e88191b87395c2e$export$a0ecbce4c0037b95 = 2047, $3e88191b87395c2e$var$b = 1, $3e88191b87395c2e$var$N = 2, $3e88191b87395c2e$var$w = 3, $3e88191b87395c2e$var$E = 4, $3e88191b87395c2e$var$O = 5, $3e88191b87395c2e$var$M = 6, $3e88191b87395c2e$var$A = $3e88191b87395c2e$export$af54264dae9065e6 || $3e88191b87395c2e$export$9135b5fce2a2854d || $3e88191b87395c2e$export$e9250b0198928087 ? "\xa0" : "\u200b", $3e88191b87395c2e$var$D = "\n\n", $3e88191b87395c2e$var$P = $3e88191b87395c2e$export$fa35291248be714f ? "\xa0" : $3e88191b87395c2e$var$A, $3e88191b87395c2e$var$F = "\u0591-\u07ff\ufb1d-\ufdfd\ufe70-\ufefc", $3e88191b87395c2e$var$I = "A-Za-z\xc0-\xd6\xd8-\xf6\xf8-\u02b8\u0300-\u0590\u0800-\u1fff\u200e\u2c00-\ufb1c\ufe00-\ufe6f\ufefd-\uffff", $3e88191b87395c2e$var$L = new RegExp("^[^" + $3e88191b87395c2e$var$I + "]*[" + $3e88191b87395c2e$var$F + "]"), $3e88191b87395c2e$var$K = new RegExp("^[^" + $3e88191b87395c2e$var$F + "]*[" + $3e88191b87395c2e$var$I + "]"), $3e88191b87395c2e$export$c9e7d6eb65b13430 = {
    bold: 1,
    capitalize: 1024,
    code: 16,
    highlight: $3e88191b87395c2e$export$f1e9b55cdd671814,
    italic: 2,
    lowercase: 256,
    strikethrough: 4,
    subscript: 32,
    superscript: 64,
    underline: 8,
    uppercase: 512
}, $3e88191b87395c2e$var$B = {
    directionless: 1,
    unmergeable: 2
}, $3e88191b87395c2e$var$R = {
    center: 2,
    end: 6,
    justify: 4,
    left: 1,
    right: 3,
    start: 5
}, $3e88191b87395c2e$var$W = {
    [$3e88191b87395c2e$var$N]: "center",
    [$3e88191b87395c2e$var$M]: "end",
    [$3e88191b87395c2e$var$E]: "justify",
    [$3e88191b87395c2e$var$b]: "left",
    [$3e88191b87395c2e$var$w]: "right",
    [$3e88191b87395c2e$var$O]: "start"
}, $3e88191b87395c2e$var$U = {
    normal: 0,
    segmented: 2,
    token: 1
}, $3e88191b87395c2e$var$$ = {
    [$3e88191b87395c2e$var$h]: "normal",
    [$3e88191b87395c2e$var$_]: "segmented",
    [$3e88191b87395c2e$var$g]: "token"
}, $3e88191b87395c2e$export$f5a9c2b177d1c0bb = "$", $3e88191b87395c2e$var$J = "$config";
function $3e88191b87395c2e$var$j() {
    return $3e88191b87395c2e$export$8a7392c46faf1a3f()._blockCursorElement;
}
function $3e88191b87395c2e$var$V(t) {
    return null !== t && 1 === t.nodeType && t.hasAttribute("data-lexical-slot");
}
class $3e88191b87395c2e$var$q {
    withBefore(t) {
        return new $3e88191b87395c2e$var$q(this.element, t, this.after);
    }
    withAfter(t) {
        return new $3e88191b87395c2e$var$q(this.element, this.before, t);
    }
    withElement(t) {
        return this.element === t ? this : new $3e88191b87395c2e$var$q(t, this.before, this.after);
    }
    insertChild(e) {
        const n = this.getInsertionAnchor();
        return null !== n && n.parentElement !== this.element && $3e88191b87395c2e$var$t(357), this.element.insertBefore(e, n), this;
    }
    removeChild(e) {
        return e.parentElement !== this.element && $3e88191b87395c2e$var$t(358), this.element.removeChild(e), this;
    }
    replaceChild(e, n) {
        return n.parentElement !== this.element && $3e88191b87395c2e$var$t(359), this.element.replaceChild(e, n), this;
    }
    getFirstChild() {
        const t = this.getFirstChildAnchor(), e = t ? t.nextSibling : this.element.firstChild;
        return e === this.getInsertionAnchor() ? null : e;
    }
    getFirstChildAnchor() {
        return this.after;
    }
    resolveLeafPosition(t, e, n) {
        if (this.element === t) return e === t && 0 === n ? "before" : "after";
        const o = $3e88191b87395c2e$var$Y(t, this.element);
        if (null === o) return "after";
        const r = Array.prototype.indexOf.call(t.childNodes, o);
        if (r < 0) return "after";
        if (e === t) return n <= r ? "before" : "after";
        const i = $3e88191b87395c2e$var$Y(t, e);
        if (null === i) return "after";
        const s = Array.prototype.indexOf.call(t.childNodes, i);
        return s >= 0 && s <= r ? "before" : "after";
    }
    getInsertionAnchor() {
        return this.before;
    }
    constructor(t, e, n){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "element", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "before", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "after", void 0);
        this.element = t, this.before = e || null, this.after = n || null;
    }
}
function $3e88191b87395c2e$var$Y(t, e) {
    let n = e;
    for(; null !== n && n.parentNode !== t;)n = n.parentNode;
    return n;
}
class $3e88191b87395c2e$var$G extends $3e88191b87395c2e$var$q {
    withBefore(t) {
        return new $3e88191b87395c2e$var$G(this.element, t, this.after);
    }
    withAfter(t) {
        return new $3e88191b87395c2e$var$G(this.element, this.before, t);
    }
    withElement(t) {
        return this.element === t ? this : new $3e88191b87395c2e$var$G(t, this.before, this.after);
    }
    getInsertionAnchor() {
        return super.getInsertionAnchor() || this.getManagedLineBreak();
    }
    getFirstChildAnchor() {
        let t = super.getFirstChildAnchor(), e = t ? t.nextSibling : this.element.firstChild;
        for(; $3e88191b87395c2e$var$V(e);)t = e, e = e.nextSibling;
        const n = t ? t.nextSibling : this.element.firstChild;
        return null !== n && n === $3e88191b87395c2e$var$j() ? n : t;
    }
    getManagedLineBreak() {
        return this.element.__lexicalLineBreak || null;
    }
    setManagedLineBreak(t) {
        if (this.element.__lexicalLastChildKind = t, null === t) this.removeManagedLineBreak();
        else {
            const e = "decorator" === t && ($3e88191b87395c2e$export$e9250b0198928087 || $3e88191b87395c2e$export$9135b5fce2a2854d || $3e88191b87395c2e$export$af54264dae9065e6);
            this.insertManagedLineBreak(e);
        }
    }
    removeManagedLineBreak() {
        const t = this.getManagedLineBreak();
        if (t) {
            const e = this.element, n = "IMG" === t.nodeName ? t.nextSibling : null;
            n && e.removeChild(n), e.removeChild(t), e.__lexicalLineBreak = void 0;
        }
    }
    insertManagedLineBreak(t) {
        const e = this.getManagedLineBreak();
        if (e) {
            if (t === ("IMG" === e.nodeName)) return;
            this.removeManagedLineBreak();
        }
        const n = this.element, o = this.before, r = $3e88191b87395c2e$export$db1ba3824aa1e742().createElement("br");
        if (r.setAttribute("data-lexical-managed-linebreak", "true"), n.insertBefore(r, o), t) {
            const t = $3e88191b87395c2e$export$db1ba3824aa1e742().createElement("img");
            t.setAttribute("data-lexical-managed-linebreak", "true"), t.style.setProperty("display", "inline", "important"), t.style.setProperty("border", "0px", "important"), t.style.setProperty("margin", "0px", "important"), t.alt = "", n.insertBefore(t, r), n.__lexicalLineBreak = t;
        } else n.__lexicalLineBreak = r;
    }
    getFirstChildOffset() {
        const t = this.getFirstChild(), e = this.getInsertionAnchor();
        let n = 0;
        for(let o = this.element.firstChild; null !== o && o !== t && o !== e; o = o.nextSibling)n++;
        return n;
    }
    resolveChildIndex(t, e, n, o) {
        if (n === this.element) {
            const e = this.getFirstChildOffset(), n = $3e88191b87395c2e$var$j(), r = this.element.childNodes, i = Math.min(o, r.length);
            let s = 0;
            for(let t = e; t < i; t++)r[t] !== n && s++;
            return [
                t,
                Math.min(s, t.getChildrenSize())
            ];
        }
        const r = $3e88191b87395c2e$var$X(e, n);
        r.push(o);
        const i = $3e88191b87395c2e$var$X(e, this.element);
        let s = t.getIndexWithinParent();
        for(let t = 0; t < i.length; t++){
            const e = r[t], n = i[t];
            if (void 0 === e || e < n) break;
            if (e > n) {
                s += 1;
                break;
            }
        }
        return [
            t.getParentOrThrow(),
            s
        ];
    }
}
function $3e88191b87395c2e$var$X(e, n) {
    const o = [];
    let r = n;
    for(; r !== e && null !== r; r = r.parentNode){
        let t = 0;
        for(let e = r.previousSibling; null !== e; e = e.previousSibling)t++;
        o.push(t);
    }
    return r !== e && $3e88191b87395c2e$var$t(225), o.reverse();
}
let $3e88191b87395c2e$var$Q;
try {
    $3e88191b87395c2e$var$Q = "0.48.0+prod.esm";
} catch (t) {}
const $3e88191b87395c2e$var$Z = $3e88191b87395c2e$var$Q !== null && $3e88191b87395c2e$var$Q !== void 0 ? $3e88191b87395c2e$var$Q : '"<unknown>+source"';
class $3e88191b87395c2e$var$tt {
    get size() {
        return this._front.size + this._back.size;
    }
    addBack(t) {
        return delete this._cache, this._front.has(t) || this._back.add(t), this;
    }
    addFront(t) {
        return delete this._cache, this._back.has(t) || this._front.add(t), this;
    }
    delete(t) {
        return delete this._cache, this._front.delete(t) || this._back.delete(t);
    }
    toArray() {
        const t = Array.from(this._front).reverse();
        for (const e of this._back)t.push(e);
        return t;
    }
    toReadonlyArray() {
        return this._cache = this._cache || this.toArray(), this._cache;
    }
    [Symbol.iterator]() {
        return this.toReadonlyArray()[Symbol.iterator]();
    }
    constructor(){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_front", new Set);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_back", new Set);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_cache", void 0);
    }
}
const $3e88191b87395c2e$var$et = null;
function $3e88191b87395c2e$var$nt(t, e = 1e3) {
    return t instanceof $3e88191b87395c2e$var$ot ? t.clone() : t.size < e ? new Map(t) : (new $3e88191b87395c2e$var$ot).init(new Map(t), void 0, t.size);
}
class $3e88191b87395c2e$var$ot {
    clone() {
        return this._mutable = !1, (new $3e88191b87395c2e$var$ot).init(this._old, this._nursery, this._size);
    }
    init(t, e, n) {
        return this._old = t, this._nursery = e, this._size = n, this;
    }
    get size() {
        return this._size;
    }
    has(t) {
        return void 0 !== this.get(t);
    }
    getWithTombstone(t) {
        const e = this._nursery && this._nursery.get(t);
        return void 0 !== e ? e : this._old && this._old.get(t);
    }
    get(t) {
        const e = this.getWithTombstone(t);
        return e === $3e88191b87395c2e$var$et ? void 0 : e;
    }
    shouldCompact() {
        return void 0 !== this._nursery && 2 * this._nursery.size > this._size;
    }
    getNursery() {
        return this._mutable && this._nursery || (this.compact(), this._nursery = new Map(this._nursery), this._mutable = !0), this._nursery;
    }
    compact(t = !1) {
        if (this._nursery && this._nursery.size > 0 && (t || this.shouldCompact())) {
            const t = new Map(this._old);
            for (const [e, n] of this._nursery)n !== $3e88191b87395c2e$var$et ? t.set(e, n) : t.delete(e);
            this._old = t, this._nursery = void 0;
        }
        return this._mutable = !1, this;
    }
    set(t, e) {
        const n = this.getWithTombstone(t);
        if (n === e) return this;
        const o = this.getNursery();
        return n !== $3e88191b87395c2e$var$et && void 0 !== n || (this._size++, n === $3e88191b87395c2e$var$et && o.delete(t)), o.set(t, e), this;
    }
    delete(t) {
        const e = this.has(t);
        return e && (this.getNursery().set(t, $3e88191b87395c2e$var$et), this._size--), e;
    }
    getOrInsert(t, e) {
        const n = this.get(t);
        return void 0 !== n ? n : (this.set(t, e), e);
    }
    getOrInsertComputed(t, e) {
        const n = this.get(t);
        if (void 0 !== n) return n;
        const o = e(t);
        return this.set(t, o), o;
    }
    clear() {
        this._mutable = !1, this._old = void 0, this._nursery = void 0, this._size = 0;
    }
    *keys() {
        for (const t of this.entries())yield t[0];
    }
    *values() {
        for (const t of this.entries())yield t[1];
    }
    *entries() {
        const t = this._nursery, e = this._old;
        if (e) for (const n of e){
            const e = n[0], o = t ? t.get(e) : void 0;
            o !== $3e88191b87395c2e$var$et && (void 0 !== o && (n[1] = o), yield n);
        }
        if (t) for (const n of t)n[1] === $3e88191b87395c2e$var$et || e && e.has(n[0]) || (yield n);
    }
    forEach(t, e) {
        void 0 !== e && (t = t.bind(e));
        for (const [e, n] of this.entries())t(n, e, this);
    }
    get [Symbol.toStringTag]() {
        return "GenMap";
    }
    [Symbol.iterator]() {
        return this.entries();
    }
    constructor(){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_mutable", !1);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_old", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_nursery", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_size", 0);
    }
}
function $3e88191b87395c2e$var$rt(t, e, n, o, r, i) {
    if ($3e88191b87395c2e$export$923a058ef54437a4(t)) {
        let s = t.getFirstChild();
        for(; null !== s;){
            const t = s.__key;
            s.__parent === e && (($3e88191b87395c2e$export$923a058ef54437a4(s) || $3e88191b87395c2e$export$e14ad7e55d229066(s) && null !== s.__slots) && $3e88191b87395c2e$var$rt(s, t, n, o, r, i), n.has(t) || i.delete(t), r.push(t)), s = s.getNextSibling();
        }
    }
    for (const s of $3e88191b87395c2e$export$e14ad7e55d229066(t) && null !== t.__slots ? t.__slots.values() : []){
        const t = o.get(s);
        void 0 !== t && $3e88191b87395c2e$export$6b4473cff535c86d(t) && t.__slotHost === e && (($3e88191b87395c2e$export$923a058ef54437a4(t) || $3e88191b87395c2e$export$e14ad7e55d229066(t) && null !== t.__slots) && $3e88191b87395c2e$var$rt(t, s, n, o, r, i), n.has(s) || i.delete(s), r.push(s));
    }
}
let $3e88191b87395c2e$var$it = !1, $3e88191b87395c2e$var$st = 0;
function $3e88191b87395c2e$var$lt(t) {
    $3e88191b87395c2e$var$st = t.timeStamp;
}
function $3e88191b87395c2e$var$ct(t, e, n) {
    const o = "BR" === t.nodeName, r = e.__lexicalLineBreak;
    return r && (t === r || o && t.previousSibling === r) || o && void 0 !== $3e88191b87395c2e$var$Gs(t, n);
}
function $3e88191b87395c2e$var$at(t, e, n) {
    const o = $3e88191b87395c2e$export$74c14770a0819525($3e88191b87395c2e$var$Pl(n)), r = o && $3e88191b87395c2e$export$fca86712f5243a7e(o, n._rootElement);
    let i = null, s = null;
    null !== r && r.anchorNode === t && (i = r.anchorOffset, s = r.focusOffset);
    const l = t.nodeValue;
    null !== l && $3e88191b87395c2e$var$al(e, l, i, s, !1);
}
function $3e88191b87395c2e$var$ut(t, e, n) {
    if ($3e88191b87395c2e$export$181b63acea8a0224(t)) {
        const e = t.anchor.getNode();
        if (e.is(n) && t.format !== e.getFormat()) return !1;
    }
    return $3e88191b87395c2e$export$4295c0f0b9b754c4(e) && n.isAttached();
}
function $3e88191b87395c2e$var$ft(t, e, n) {
    for(let o = t; o && !$3e88191b87395c2e$export$163e1a1a046f2b80(o); o = $3e88191b87395c2e$export$169e5491001d3ed6(o)){
        const t = $3e88191b87395c2e$var$Gs(o, e);
        if (void 0 !== t) {
            const e = $3e88191b87395c2e$export$e725f93d4d48c6d8(t, n);
            if (e) return $3e88191b87395c2e$export$60aa03725ce41b1c(e) || !$3e88191b87395c2e$export$1b3bfaa9684536aa(o) ? void 0 : [
                o,
                e
            ];
        }
    }
}
function $3e88191b87395c2e$var$dt(t, e, n) {
    $3e88191b87395c2e$var$it = !0;
    const o = performance.now() - $3e88191b87395c2e$var$st > 100;
    try {
        $3e88191b87395c2e$var$Mi(t, ()=>{
            const r = $3e88191b87395c2e$export$63a3201b3a5c7d90() || function(t) {
                return t.read("latest", ()=>{
                    const t = $3e88191b87395c2e$export$63a3201b3a5c7d90();
                    return null !== t ? t.clone() : null;
                });
            }(t), s = new Map, l = t._editorState, c = t._blockCursorElement;
            let a = !1, u = "";
            for(let n = 0; n < e.length; n++){
                const f = e[n], d = f.type, h = f.target, g = $3e88191b87395c2e$var$ft(h, t, l);
                if (!g) continue;
                const [_, p] = g;
                if ("characterData" === d) o && $3e88191b87395c2e$export$471953706258be2b(p) && $3e88191b87395c2e$export$4295c0f0b9b754c4(h) && $3e88191b87395c2e$var$ut(r, h, p) && $3e88191b87395c2e$var$at(h, p, t);
                else if ("childList" === d) {
                    a = !0;
                    const e = f.addedNodes;
                    for(let n = 0; n < e.length; n++){
                        const o = e[n], r = $3e88191b87395c2e$export$b1414e7b1cad1d22(o), s = o.parentNode;
                        if (!(null == s || o === c || null !== r || $3e88191b87395c2e$var$ct(o, s, t) || t._slotsUsed && $3e88191b87395c2e$export$1b3bfaa9684536aa(o) && o.hasAttribute("data-lexical-slot") || $3e88191b87395c2e$export$163e1a1a046f2b80(o))) {
                            if ($3e88191b87395c2e$export$fa35291248be714f) {
                                const t = ($3e88191b87395c2e$export$1b3bfaa9684536aa(o) ? o.innerText : null) || o.nodeValue;
                                t && (u += t);
                            }
                            s.removeChild(o);
                        }
                    }
                    const n = f.removedNodes, o = n.length;
                    if (o > 0) {
                        let e = 0;
                        for(let r = 0; r < o; r++){
                            const o = n[r];
                            ($3e88191b87395c2e$var$ct(o, h, t) || c === o) && (h.appendChild(o), e++);
                        }
                        o !== e && s.set(_, p);
                    }
                }
            }
            if (s.size > 0) for (const [e, n] of s)n.reconcileObservedMutation(e, t);
            const f = n.takeRecords();
            if (f.length > 0) {
                for(let e = 0; e < f.length; e++){
                    const n = f[e], o = n.addedNodes, r = n.target;
                    for(let e = 0; e < o.length; e++){
                        const n = o[e], i = n.parentNode;
                        null == i || "BR" !== n.nodeName || $3e88191b87395c2e$var$ct(n, r, t) || i.removeChild(n);
                    }
                }
                n.takeRecords();
            }
            null !== r && (a && $3e88191b87395c2e$export$2aad78c37810bca9(r), $3e88191b87395c2e$export$fa35291248be714f && $3e88191b87395c2e$var$Tl(t) && r.insertRawText(u));
        });
    } finally{
        $3e88191b87395c2e$var$it = !1;
    }
}
function $3e88191b87395c2e$var$ht(t) {
    const e = t._observer;
    if (null !== e) $3e88191b87395c2e$var$dt(t, e.takeRecords(), e);
}
function $3e88191b87395c2e$var$gt(t) {
    !function(t) {
        0 === $3e88191b87395c2e$var$st && $3e88191b87395c2e$var$Pl(t).addEventListener("textInput", $3e88191b87395c2e$var$lt, !0);
    }(t), t._observer = new MutationObserver((e, n)=>{
        $3e88191b87395c2e$var$dt(t, e, n);
    });
}
const $3e88191b87395c2e$export$9572c8e58cd0eb15 = "direct", $3e88191b87395c2e$export$2107b47cb802d8f6 = "latest";
class $3e88191b87395c2e$var$yt {
    constructor(t, e){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "key", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "parse", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "unparse", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "isEqual", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "defaultValue", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "resetOnCopyNode", void 0);
        this.key = t, this.parse = e.parse.bind(e), this.unparse = (e.unparse || $3e88191b87395c2e$var$Et).bind(e), this.isEqual = (e.isEqual || Object.is).bind(e), this.defaultValue = this.parse(void 0), this.resetOnCopyNode = e.resetOnCopyNode || !1;
    }
}
function $3e88191b87395c2e$export$e6a0daad8304de(t, e) {
    return new $3e88191b87395c2e$var$yt(t, e);
}
function $3e88191b87395c2e$export$5f6d848b3f2eebb0(t, e, n = $3e88191b87395c2e$export$2107b47cb802d8f6) {
    const o = (n === $3e88191b87395c2e$export$2107b47cb802d8f6 ? t.getLatest() : t).__state;
    return o ? o.getValue(e) : e.defaultValue;
}
function $3e88191b87395c2e$export$71251be947c2f6fb(t, e, n) {
    const o = $3e88191b87395c2e$export$5f6d848b3f2eebb0(t, n, $3e88191b87395c2e$export$9572c8e58cd0eb15), r = $3e88191b87395c2e$export$5f6d848b3f2eebb0(e, n, $3e88191b87395c2e$export$9572c8e58cd0eb15);
    return n.isEqual(o, r) ? null : [
        o,
        r
    ];
}
function $3e88191b87395c2e$export$401d8a6b50e0699a(t, e, n) {
    let o;
    if ($3e88191b87395c2e$var$ui(), "function" == typeof n) {
        const r = t.getLatest(), i = $3e88191b87395c2e$export$5f6d848b3f2eebb0(r, e);
        if (o = n(i), e.isEqual(i, o)) return r;
    } else o = n;
    const r = t.getWritable();
    return $3e88191b87395c2e$export$4fd6c21cb0624349(r).updateFromKnown(e, o), r;
}
function $3e88191b87395c2e$export$42a31b61c59197f6(t) {
    const e = new Map, n = new Set;
    for (const { ownNodeConfig: o } of $3e88191b87395c2e$export$9f01219fd9911d4c("function" == typeof t ? t : t.replace))if (o && o.stateConfigs) for (const t of o.stateConfigs){
        let o;
        "stateConfig" in t ? (o = t.stateConfig, t.flat && n.add(o.key)) : o = t, e.set(o.key, o);
    }
    return {
        flatKeys: n,
        sharedConfigMap: e
    };
}
const $3e88191b87395c2e$var$Tt = new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
class $3e88191b87395c2e$var$kt {
    getValue(t) {
        const e = this.knownState.get(t);
        if (void 0 !== e) return e;
        this.sharedNodeState.sharedConfigMap.set(t.key, t);
        let n = t.defaultValue;
        if (this.unknownState && t.key in this.unknownState) {
            const e = this.unknownState[t.key];
            void 0 !== e && (n = t.parse(e)), this.updateFromKnown(t, n);
        }
        return n;
    }
    getInternalState() {
        return [
            this.unknownState,
            this.knownState
        ];
    }
    toJSON() {
        const t = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.unknownState), e = {};
        for (const [e, n] of this.knownState)e.isEqual(n, e.defaultValue) ? delete t[e.key] : t[e.key] = e.unparse(n);
        for (const n of this.sharedNodeState.flatKeys)n in t && (e[n] = t[n], delete t[n]);
        return $3e88191b87395c2e$var$wt(t) && (e.$ = t), e;
    }
    getWritable(t) {
        if (this.node === t) return this;
        const { sharedNodeState: e, unknownState: n } = this, o = new Map(this.knownState);
        return new $3e88191b87395c2e$var$kt(t, e, function(t, e, n) {
            let o;
            if (n) for (const [r, i] of Object.entries(n)){
                if ($3e88191b87395c2e$var$Tt.has(r)) continue;
                const n = t.get(r);
                n ? e.has(n) || e.set(n, n.parse(i)) : (o = o || {}, o[r] = i);
            }
            return o;
        }(e.sharedConfigMap, o, n), o, this.size);
    }
    resetOnCopyNode() {
        for (const t of this.knownState.keys())t.resetOnCopyNode && this.knownState.set(t, t.defaultValue);
        return this;
    }
    updateFromKnown(t, e) {
        const n = t.key;
        this.sharedNodeState.sharedConfigMap.set(n, t);
        const { knownState: o, unknownState: r } = this;
        o.has(t) || r && n in r || (r && (delete r[n], this.unknownState = $3e88191b87395c2e$var$wt(r)), this.size++), o.set(t, e);
    }
    updateFromUnknown(t, e) {
        if ($3e88191b87395c2e$var$Tt.has(t)) return;
        const n = this.sharedNodeState.sharedConfigMap.get(t);
        n ? this.updateFromKnown(n, n.parse(e)) : (this.unknownState = this.unknownState || {}, t in this.unknownState || this.size++, this.unknownState[t] = e);
    }
    updateFromJSON(t) {
        const { knownState: e } = this;
        for (const t of e.keys())e.set(t, t.defaultValue);
        if (this.size = e.size, this.unknownState = void 0, t) for (const [e, n] of Object.entries(t))this.updateFromUnknown(e, n);
    }
    constructor(t, e, n, o = new Map, r){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "node", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "knownState", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "unknownState", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "sharedNodeState", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "size", void 0);
        this.node = t, this.sharedNodeState = e, this.unknownState = n, this.knownState = o;
        const { sharedConfigMap: i } = this.sharedNodeState, s = void 0 !== r ? r : function(t, e, n) {
            let o = n.size;
            if (e) for(const r in e){
                const e = t.get(r);
                e && n.has(e) || o++;
            }
            return o;
        }(i, n, o);
        this.size = s;
    }
}
function $3e88191b87395c2e$export$4fd6c21cb0624349(t) {
    const e = t.getWritable(), n = e.__state ? e.__state.getWritable(e) : new $3e88191b87395c2e$var$kt(e, $3e88191b87395c2e$var$Nt(e));
    return e.__state = n, n;
}
function $3e88191b87395c2e$var$Nt(t) {
    return t.__state ? t.__state.sharedNodeState : $3e88191b87395c2e$export$8988849ce1143792($3e88191b87395c2e$export$8a7392c46faf1a3f(), t.getType()).sharedNodeState;
}
function $3e88191b87395c2e$var$wt(t) {
    if (t) for(const e in t)return t;
}
function $3e88191b87395c2e$var$Et(t) {
    return t;
}
function $3e88191b87395c2e$var$Ot(t, e, n) {
    for (const [o, r] of e.knownState){
        if (t.has(o.key)) continue;
        t.add(o.key);
        const e = n ? n.getValue(o) : o.defaultValue;
        if (e !== r && !o.isEqual(e, r)) return !0;
    }
    return !1;
}
function $3e88191b87395c2e$var$Mt(t, e, n) {
    const { unknownState: o } = e, r = n ? n.unknownState : void 0;
    if (o) for (const [e, n] of Object.entries(o)){
        if (t.has(e)) continue;
        t.add(e);
        if (n !== (r ? r[e] : void 0)) return !0;
    }
    return !1;
}
function $3e88191b87395c2e$var$At(t, e) {
    const n = t.__state;
    return n && n.node === t ? n.getWritable(e) : n;
}
function $3e88191b87395c2e$var$Dt(t, e) {
    const n = t.__mode, o = t.__format, r = t.__style, i = e.__mode, s = e.__format, l = e.__style, c = t.__state, a = e.__state;
    return (null === n || n === i) && (null === o || o === s) && (null === r || r === l) && (null === t.__state || c === a || function(t, e) {
        if (t === e) return !0;
        const n = new Set;
        return !(t && $3e88191b87395c2e$var$Ot(n, t, e) || e && $3e88191b87395c2e$var$Ot(n, e, t) || t && $3e88191b87395c2e$var$Mt(n, t, e) || e && $3e88191b87395c2e$var$Mt(n, e, t));
    }(c, a));
}
function $3e88191b87395c2e$var$Pt(t, e) {
    const n = t.mergeWithSibling(e), o = $3e88191b87395c2e$var$gi()._normalizedNodes;
    return o.add(t.__key), o.add(e.__key), n;
}
function $3e88191b87395c2e$var$Ft(t) {
    let e, n, o = t;
    if ("" !== o.__text || !o.isSimpleText() || o.isUnmergeable()) {
        for(; null !== (e = o.getPreviousSibling()) && $3e88191b87395c2e$export$471953706258be2b(e) && e.isSimpleText() && !e.isUnmergeable();){
            if ("" !== e.__text) {
                if ($3e88191b87395c2e$var$Dt(e, o)) {
                    o = $3e88191b87395c2e$var$Pt(e, o);
                    break;
                }
                break;
            }
            e.remove();
        }
        for(; null !== (n = o.getNextSibling()) && $3e88191b87395c2e$export$471953706258be2b(n) && n.isSimpleText() && !n.isUnmergeable();){
            if ("" !== n.__text) {
                if ($3e88191b87395c2e$var$Dt(o, n)) {
                    o = $3e88191b87395c2e$var$Pt(o, n);
                    break;
                }
                break;
            }
            n.remove();
        }
    } else o.remove();
}
function $3e88191b87395c2e$export$db10bc6ba67ffcb5(t) {
    return $3e88191b87395c2e$var$Lt(t.anchor), $3e88191b87395c2e$var$Lt(t.focus), t;
}
function $3e88191b87395c2e$var$Lt(t) {
    for(; "element" === t.type;){
        const e = t.getNode(), n = t.offset;
        let o, r;
        if (n === e.getChildrenSize() ? (o = e.getChildAtIndex(n - 1), r = !0) : (o = e.getChildAtIndex(n), r = !1), $3e88191b87395c2e$export$471953706258be2b(o)) {
            t.set(o.__key, r ? o.getTextContentSize() : 0, "text", !0);
            break;
        }
        if (!$3e88191b87395c2e$export$923a058ef54437a4(o)) break;
        t.set(o.__key, r ? o.getChildrenSize() : 0, "element", !0);
    }
}
const $3e88191b87395c2e$var$Kt = Symbol.for("@lexical/CachedTextSize");
function $3e88191b87395c2e$var$zt(e, n) {
    return $3e88191b87395c2e$var$ee.read(()=>{
        let o = 0, r = e;
        for(let e = 0; e < n && null !== r; e++){
            const i = $3e88191b87395c2e$var$te.get(r);
            if (void 0 === i && $3e88191b87395c2e$var$t(345, r), $3e88191b87395c2e$export$923a058ef54437a4(i)) {
                const s = $3e88191b87395c2e$var$ne.get(r);
                if (void 0 !== s && $3e88191b87395c2e$export$923a058ef54437a4(s) && s.__parent !== i.__parent) o += i.getTextContentSize();
                else {
                    const e = $3e88191b87395c2e$var$oe.get(r), n = e && e.__lexicalTextContent;
                    "string" != typeof n && $3e88191b87395c2e$var$t(346, i.getType()), o += n.length;
                }
                e < n - 1 && !i.isInline() && (o += 2);
            } else {
                const e = i[$3e88191b87395c2e$var$Kt];
                void 0 === e && $3e88191b87395c2e$var$t(347, i.getType(), r), o += e;
            }
            r = i.__next;
        }
        return o;
    }, {
        editor: $3e88191b87395c2e$var$Ut
    });
}
function $3e88191b87395c2e$var$Bt(t) {
    $3e88191b87395c2e$export$923a058ef54437a4(t) || void 0 === t[$3e88191b87395c2e$var$Kt] && (t[$3e88191b87395c2e$var$Kt] = $3e88191b87395c2e$export$471953706258be2b(t) ? t.__text.length : t.getTextContentSize());
}
const $3e88191b87395c2e$var$Rt = 4;
let $3e88191b87395c2e$var$Wt, $3e88191b87395c2e$var$Ut, $3e88191b87395c2e$var$$t, $3e88191b87395c2e$var$Ht = "", $3e88191b87395c2e$var$Jt = null, $3e88191b87395c2e$var$jt = null, $3e88191b87395c2e$var$Vt = null;
function $3e88191b87395c2e$var$qt() {
    return {
        firstTextKey: $3e88191b87395c2e$var$Vt,
        format: $3e88191b87395c2e$var$Jt,
        style: $3e88191b87395c2e$var$jt
    };
}
function $3e88191b87395c2e$var$Yt(t) {
    null !== t.firstTextKey && ($3e88191b87395c2e$var$Jt = t.format, $3e88191b87395c2e$var$jt = t.style, $3e88191b87395c2e$var$Vt = t.firstTextKey);
}
function $3e88191b87395c2e$var$Gt(e) {
    if (null !== $3e88191b87395c2e$var$Vt) return;
    const n = e.__lexicalFirstTextKey;
    if (void 0 === n && $3e88191b87395c2e$var$t(348), null === n) return;
    const o = $3e88191b87395c2e$var$ne.get(n);
    $3e88191b87395c2e$export$471953706258be2b(o) && ($3e88191b87395c2e$var$Jt = o.getFormat(), $3e88191b87395c2e$var$jt = o.getStyle(), $3e88191b87395c2e$var$Vt = n);
}
let $3e88191b87395c2e$var$Xt, $3e88191b87395c2e$var$Qt, $3e88191b87395c2e$var$Zt, $3e88191b87395c2e$var$te, $3e88191b87395c2e$var$ee, $3e88191b87395c2e$var$ne, $3e88191b87395c2e$var$oe, $3e88191b87395c2e$var$re, $3e88191b87395c2e$var$ie, $3e88191b87395c2e$var$se, $3e88191b87395c2e$var$le = !1, $3e88191b87395c2e$var$ce = !1;
function $3e88191b87395c2e$var$ae(t, e) {
    const n = $3e88191b87395c2e$var$te.get(t), o = $3e88191b87395c2e$var$ne.has(t);
    if (null !== e) {
        const n = $3e88191b87395c2e$var$Pe(t);
        n.parentNode === e && e.removeChild(n);
    }
    if (!o) {
        if ($3e88191b87395c2e$var$Ut._keyToDOMMap.delete(t), $3e88191b87395c2e$export$923a058ef54437a4(n)) {
            const t = $3e88191b87395c2e$export$4755c0a85d0b9cd5(n, $3e88191b87395c2e$var$te);
            $3e88191b87395c2e$var$ue(t, 0, t.length - 1, null);
        }
        if (void 0 !== n) {
            for (const t of $3e88191b87395c2e$var$xe(n).values()){
                const e = $3e88191b87395c2e$var$Se(t);
                $3e88191b87395c2e$var$ae(t, null), null !== e && e.remove();
            }
            $3e88191b87395c2e$var$xl($3e88191b87395c2e$var$ie, $3e88191b87395c2e$var$$t, $3e88191b87395c2e$var$Xt, n, "destroyed");
        }
    }
}
function $3e88191b87395c2e$var$ue(t, e, n, o) {
    for(let r = e; r <= n; ++r){
        const e = t[r];
        void 0 !== e && $3e88191b87395c2e$var$ae(e, o);
    }
}
function $3e88191b87395c2e$var$fe(t, e) {
    t.setProperty("text-align", e);
}
const $3e88191b87395c2e$var$de = "40px";
function $3e88191b87395c2e$var$he(t, e) {
    const n = $3e88191b87395c2e$var$Wt.theme.indent;
    if ("string" == typeof n) {
        const o = t.classList.contains(n);
        e > 0 && !o ? t.classList.add(n) : e < 1 && o && t.classList.remove(n);
    }
    t.style.setProperty("padding-inline-start", 0 === e ? "" : `calc(${e} * var(--lexical-indent-base-value, ${$3e88191b87395c2e$var$de}))`);
}
function $3e88191b87395c2e$var$ge(t, e) {
    const n = t.style;
    0 === e ? $3e88191b87395c2e$var$fe(n, "") : 1 === e ? $3e88191b87395c2e$var$fe(n, "left") : 2 === e ? $3e88191b87395c2e$var$fe(n, "center") : 3 === e ? $3e88191b87395c2e$var$fe(n, "right") : 4 === e ? $3e88191b87395c2e$var$fe(n, "justify") : 5 === e ? $3e88191b87395c2e$var$fe(n, "start") : 6 === e && $3e88191b87395c2e$var$fe(n, "end");
}
function $3e88191b87395c2e$var$_e(t, e) {
    const n = function(t) {
        const e = t.__dir;
        if (null !== e) return e;
        if ($3e88191b87395c2e$export$5b29ca560c2fedab(t)) return null;
        const n = t.getParent();
        return null === n || $3e88191b87395c2e$export$6f851a24c61146af(n) && null === n.__dir ? "auto" : null;
    }(e);
    null !== n ? t.dir = n : t.removeAttribute("dir");
}
function $3e88191b87395c2e$var$pe(t) {
    const e = $3e88191b87395c2e$export$db1ba3824aa1e742().createElement("div");
    return e.setAttribute("data-lexical-slot", t), e.style.display = "none", e;
}
function $3e88191b87395c2e$var$ye(t, e, n) {
    e || "false" === t.contentEditable ? $3e88191b87395c2e$export$cdba2bd0b63ec62e(n, $3e88191b87395c2e$var$Ut) : n.removeAttribute("contenteditable");
}
function $3e88191b87395c2e$var$me(t, e, n) {
    const o = $3e88191b87395c2e$var$Ht, r = $3e88191b87395c2e$var$qt();
    $3e88191b87395c2e$var$Ht = "";
    let i = "";
    const s = $3e88191b87395c2e$export$60aa03725ce41b1c(t);
    for (const [o, r] of n){
        const n = $3e88191b87395c2e$var$pe(o);
        $3e88191b87395c2e$var$ye(e, s, n), e.appendChild(n), $3e88191b87395c2e$var$Ht = "";
        const l = $3e88191b87395c2e$var$qt();
        $3e88191b87395c2e$var$Te(r, $3e88191b87395c2e$export$724e988312a5b9ca(t, n, $3e88191b87395c2e$var$Ut)), $3e88191b87395c2e$var$Yt(l), $3e88191b87395c2e$var$Ce(t, o, e, n), i += $3e88191b87395c2e$var$Ht;
    }
    return $3e88191b87395c2e$var$Yt(r), $3e88191b87395c2e$var$Ht = o, i;
}
function $3e88191b87395c2e$var$xe(t) {
    return $3e88191b87395c2e$export$e14ad7e55d229066(t) && null !== t.__slots ? t.__slots : $3e88191b87395c2e$var$qc;
}
function $3e88191b87395c2e$var$Ce(t, e, n, o) {
    const r = $3e88191b87395c2e$var$se.$getSlotTargetElement(t, e, n, $3e88191b87395c2e$var$Ut);
    null !== r && (o.parentElement !== r && r.appendChild(o), o.style.display = "");
}
function $3e88191b87395c2e$var$Se(t) {
    const e = $3e88191b87395c2e$var$oe.get(t);
    return void 0 !== e ? e.parentElement : null;
}
function $3e88191b87395c2e$var$ve(t, e, n) {
    const o = $3e88191b87395c2e$var$xe(t), r = $3e88191b87395c2e$var$xe(e);
    for (const [t, e] of o)if (!r.has(t)) {
        const t = $3e88191b87395c2e$var$Se(e);
        $3e88191b87395c2e$var$ae(e, null), null !== t && t.remove();
    }
    const i = $3e88191b87395c2e$var$Ht, s = $3e88191b87395c2e$var$qt();
    let l = "", c = null;
    const a = $3e88191b87395c2e$export$60aa03725ce41b1c(e);
    for (const [t, i] of r){
        const r = o.get(t);
        let s = void 0 !== r ? $3e88191b87395c2e$var$Se(r) : null;
        $3e88191b87395c2e$var$Ht = "";
        const u = $3e88191b87395c2e$var$qt();
        if (null === s) {
            s = $3e88191b87395c2e$var$pe(t);
            let o = null;
            for (const t of n.children)if (!t.hasAttribute("data-lexical-slot")) {
                o = t;
                break;
            }
            n.insertBefore(s, o), $3e88191b87395c2e$var$Te(i, $3e88191b87395c2e$export$724e988312a5b9ca(e, s, $3e88191b87395c2e$var$Ut));
        } else r === i ? $3e88191b87395c2e$var$Ee(i, s) : (void 0 !== r && $3e88191b87395c2e$var$ae(r, s), $3e88191b87395c2e$var$Te(i, $3e88191b87395c2e$export$724e988312a5b9ca(e, s, $3e88191b87395c2e$var$Ut)));
        if ($3e88191b87395c2e$var$Yt(u), $3e88191b87395c2e$var$ye(n, a, s), $3e88191b87395c2e$var$Ce(e, t, n, s), l += $3e88191b87395c2e$var$Ht, s.parentElement === n) {
            const t = null === c ? n.firstChild : c.nextSibling;
            t !== s && n.insertBefore(s, t), c = s;
        }
    }
    return $3e88191b87395c2e$var$Yt(s), $3e88191b87395c2e$var$Ht = i, l;
}
function $3e88191b87395c2e$var$Te(e, n) {
    const o = $3e88191b87395c2e$var$ne.get(e);
    if (void 0 === o && $3e88191b87395c2e$var$t(60), null !== n) {
        const t = $3e88191b87395c2e$var$te.get(e);
        if (void 0 !== t) {
            const r = $3e88191b87395c2e$var$oe.get(e);
            if (void 0 !== r) {
                const i = $3e88191b87395c2e$export$6b4473cff535c86d(t) ? t.__slotHost : null, s = $3e88191b87395c2e$export$6b4473cff535c86d(o) ? o.__slotHost : null, l = t.__parent !== o.__parent || i !== s, c = null !== s && r.parentElement !== n.element;
                if (l || c) return n.insertChild(r), $3e88191b87395c2e$var$Ee(e, n.element);
            }
        }
    }
    const r = $3e88191b87395c2e$var$se.$createDOM(o, $3e88191b87395c2e$var$Ut);
    if (function(t, e, n) {
        const o = n._keyToDOMMap;
        $3e88191b87395c2e$var$Ys(e, n, t), o.set(t, e);
    }(e, r, $3e88191b87395c2e$var$Ut), $3e88191b87395c2e$export$471953706258be2b(o) ? r.setAttribute("data-lexical-text", "true") : $3e88191b87395c2e$export$60aa03725ce41b1c(o) && (r.setAttribute("data-lexical-decorator", "true"), $3e88191b87395c2e$export$601028e2f53ab464(r, {
        captureSelection: !0
    })), $3e88191b87395c2e$export$923a058ef54437a4(o)) {
        const t = o.__indent, e = o.__size;
        $3e88191b87395c2e$var$_e(r, o), 0 !== t && $3e88191b87395c2e$var$he(r, t);
        const n = $3e88191b87395c2e$var$xe(o), i = n.size > 0 ? $3e88191b87395c2e$var$me(o, r, n) : "";
        if (0 === e) r.__lexicalTextContent = i, r.__lexicalFirstTextKey = null, $3e88191b87395c2e$var$Ht += i, n.size > 0 && (r.__lexicalSlotTextLength = i.length);
        else {
            const t = $3e88191b87395c2e$var$Ht, s = e - 1;
            if ($3e88191b87395c2e$var$ke($3e88191b87395c2e$export$4755c0a85d0b9cd5(o, $3e88191b87395c2e$var$ne), o, 0, s, $3e88191b87395c2e$export$724e988312a5b9ca(o, r, $3e88191b87395c2e$var$Ut)), "" !== i) {
                const e = r.__lexicalTextContent || "";
                r.__lexicalTextContent = i + e, $3e88191b87395c2e$var$Ht = t + i + e;
            }
            n.size > 0 && (r.__lexicalSlotTextLength = i.length);
        }
        const s = o.__format;
        0 !== s && $3e88191b87395c2e$var$ge(r, s), o.isInline() || $3e88191b87395c2e$var$be(null, o, r);
    } else {
        const t = o.getTextContent();
        if ($3e88191b87395c2e$export$60aa03725ce41b1c(o)) {
            const t = o.decorate($3e88191b87395c2e$var$Ut, $3e88191b87395c2e$var$Wt);
            null !== t && $3e88191b87395c2e$var$Oe(e, t), r.contentEditable = "false";
            const n = $3e88191b87395c2e$var$xe(o);
            n.size > 0 && $3e88191b87395c2e$var$me(o, r, n);
        }
        $3e88191b87395c2e$var$Ht += t;
    }
    return null !== n && n.insertChild(r), $3e88191b87395c2e$var$se.$decorateDOM(o, null, r, $3e88191b87395c2e$var$Ut), $3e88191b87395c2e$var$Bt(o), $3e88191b87395c2e$var$xl($3e88191b87395c2e$var$ie, $3e88191b87395c2e$var$$t, $3e88191b87395c2e$var$Xt, o, "created"), r;
}
function $3e88191b87395c2e$var$ke(e, n, o, r, i) {
    const s = $3e88191b87395c2e$var$Ht, l = $3e88191b87395c2e$var$qt();
    $3e88191b87395c2e$var$Ht = "", $3e88191b87395c2e$var$Jt = null, $3e88191b87395c2e$var$jt = null, $3e88191b87395c2e$var$Vt = null;
    let c = o;
    for(; c <= r; ++c){
        const t = $3e88191b87395c2e$var$qt();
        $3e88191b87395c2e$var$Te(e[c], i);
        const n = $3e88191b87395c2e$var$ne.get(e[c]);
        null !== n && $3e88191b87395c2e$export$471953706258be2b(n) ? null === $3e88191b87395c2e$var$Jt && ($3e88191b87395c2e$var$Jt = n.getFormat(), $3e88191b87395c2e$var$jt = n.getStyle(), $3e88191b87395c2e$var$Vt = n.__key) : $3e88191b87395c2e$export$923a058ef54437a4(n) && c < r && !n.isInline() && ($3e88191b87395c2e$var$Ht += $3e88191b87395c2e$var$D), $3e88191b87395c2e$var$Yt(t);
    }
    const a = $3e88191b87395c2e$var$Ut._keyToDOMMap.get(n.__key);
    void 0 === a && $3e88191b87395c2e$var$t(349, n.__key), a.__lexicalTextContent = $3e88191b87395c2e$var$Ht, a.__lexicalFirstTextKey = $3e88191b87395c2e$var$Vt, $3e88191b87395c2e$var$Ht = s + $3e88191b87395c2e$var$Ht, $3e88191b87395c2e$var$Yt(l);
}
function $3e88191b87395c2e$var$be(t, e, n) {
    var _o_element___lexicalLastChildKind;
    const o = $3e88191b87395c2e$export$724e988312a5b9ca(e, n, $3e88191b87395c2e$var$Ut), r = (_o_element___lexicalLastChildKind = o.element.__lexicalLastChildKind) !== null && _o_element___lexicalLastChildKind !== void 0 ? _o_element___lexicalLastChildKind : null, i = function(t, e) {
        if (t) {
            const n = t.__last;
            if (n) {
                const t = e.get(n);
                if (t) return $3e88191b87395c2e$export$b16330e40aa25c4e(t) ? "line-break" : $3e88191b87395c2e$export$60aa03725ce41b1c(t) && t.isInline() ? "decorator" : null;
            }
            return $3e88191b87395c2e$var$xe(t).size > 0 ? null : "empty";
        }
        return null;
    }(e, $3e88191b87395c2e$var$ne);
    r !== i && o.setManagedLineBreak(i);
}
function $3e88191b87395c2e$var$Ne(e, n, o) {
    var r;
    $3e88191b87395c2e$var$Jt = null, $3e88191b87395c2e$var$jt = null, $3e88191b87395c2e$var$Vt = null, function(e, n, o) {
        const r = $3e88191b87395c2e$var$Ht, i = e.__size, s = n.__size;
        $3e88191b87395c2e$var$Ht = "";
        const l = o.element, c = $3e88191b87395c2e$var$Ut._keyToDOMMap.get(n.__key);
        void 0 === c && $3e88191b87395c2e$var$t(351, n.__key);
        const a = s - i;
        if (!$3e88191b87395c2e$var$le && Math.abs(a) <= 1 && i >= $3e88191b87395c2e$var$Rt && e.__first === n.__first && (0 !== a || !$3e88191b87395c2e$var$Ut._cloneNotNeeded.has(e.__key))) {
            const i = c.__lexicalTextContent, u = $3e88191b87395c2e$var$re.get(e.__key);
            if (!$3e88191b87395c2e$var$le && "string" == typeof i && void 0 !== u) {
                const s = function(t, e) {
                    const n = e.size;
                    if (0 === n || n >= t.__size) return null;
                    let o = t.__last, r = null, i = 0;
                    for(; null !== o && i < n;){
                        if (!e.has(o)) return null;
                        r = o;
                        const t = $3e88191b87395c2e$var$ne.get(o);
                        if (void 0 === t) return null;
                        o = t.__prev, i++;
                    }
                    if (i !== n) return null;
                    if (null !== o && e.has(o)) return null;
                    return r;
                }(n, u);
                if (null !== s) {
                    const f = u.size;
                    if (0 === a) {
                        const e = $3e88191b87395c2e$var$zt(s, f);
                        let o = s, a = 0;
                        for(; null !== o && a < f;){
                            const t = $3e88191b87395c2e$var$ne.get(o);
                            if (void 0 === t) break;
                            const e = $3e88191b87395c2e$var$qt();
                            $3e88191b87395c2e$var$Ee(o, l), $3e88191b87395c2e$export$471953706258be2b(t) && null === $3e88191b87395c2e$var$Jt && ($3e88191b87395c2e$var$Jt = t.getFormat(), $3e88191b87395c2e$var$jt = t.getStyle(), $3e88191b87395c2e$var$Vt = t.__key), $3e88191b87395c2e$var$Yt(e), o = t.__next, a++;
                        }
                        let d = "";
                        for(o = s, a = 0; null !== o && a < f;){
                            const e = $3e88191b87395c2e$var$ne.get(o);
                            if (void 0 === e) break;
                            let n;
                            if ($3e88191b87395c2e$export$923a058ef54437a4(e)) {
                                const r = $3e88191b87395c2e$var$Ut._keyToDOMMap.get(o), i = r && r.__lexicalTextContent;
                                "string" != typeof i && $3e88191b87395c2e$var$t(352, e.getType()), n = i;
                            } else n = e.getTextContent();
                            d += n, a < f - 1 && $3e88191b87395c2e$export$923a058ef54437a4(e) && !e.isInline() && (d += $3e88191b87395c2e$var$D), o = e.__next, a++;
                        }
                        const h = c.__lexicalSlotTextLength || 0, g = h > 0 ? i.slice(h) : i, _ = g.slice(0, g.length - e) + d;
                        return c.__lexicalTextContent = _, $3e88191b87395c2e$var$Ht = r + _, void $3e88191b87395c2e$var$we(n, c, u);
                    }
                    if (function(e, n, o, r, i, s, l, c) {
                        if (1 !== c && -1 !== c) return !1;
                        const a = 1 === c ? 2 : 1;
                        if (l !== a) return !1;
                        const u = l - c;
                        let f = e.__last;
                        for(let t = 0; t < u - 1; t++){
                            if (null === f) return !1;
                            const t = $3e88191b87395c2e$var$te.get(f);
                            if (void 0 === t) return !1;
                            f = t.__prev;
                        }
                        if (null === f) return !1;
                        const d = $3e88191b87395c2e$var$ne.get(s), h = $3e88191b87395c2e$var$te.get(f);
                        if (void 0 === d || void 0 === h) return !1;
                        if (d.__prev !== h.__prev) return !1;
                        const g = [];
                        let _ = s;
                        for(let t = 0; t < l; t++){
                            if (null === _) return !1;
                            g.push(_);
                            const t = $3e88191b87395c2e$var$ne.get(_);
                            _ = t ? t.__next : null;
                        }
                        const p = [];
                        _ = f;
                        for(let t = 0; t < u; t++){
                            if (null === _) return !1;
                            p.push(_);
                            const t = $3e88191b87395c2e$var$te.get(_);
                            _ = t ? t.__next : null;
                        }
                        const y = new Set(p), m = new Set(g), x = [];
                        let C = 0, S = 0;
                        for(; C < u && S < l;)if (g[S] === p[C]) x.push({
                            key: g[S],
                            kind: "reconcile"
                        }), C++, S++;
                        else if (m.has(p[C])) {
                            if (y.has(g[S])) return !1;
                            x.push({
                                key: g[S],
                                kind: "create",
                                nextIndex: S
                            }), S++;
                        } else x.push({
                            key: p[C],
                            kind: "destroy"
                        }), C++;
                        for(; C < u;)x.push({
                            key: p[C++],
                            kind: "destroy"
                        });
                        for(; S < l;)x.push({
                            key: g[S],
                            kind: "create",
                            nextIndex: S
                        }), S++;
                        const v = $3e88191b87395c2e$var$zt(f, u);
                        for (const t of x){
                            const e = $3e88191b87395c2e$var$qt();
                            if ("reconcile" === t.kind) $3e88191b87395c2e$var$Ee(t.key, o.element);
                            else if ("destroy" === t.kind) $3e88191b87395c2e$var$ae(t.key, o.element);
                            else {
                                let e = null;
                                for(let n = t.nextIndex + 1; n < l; n++){
                                    const t = $3e88191b87395c2e$var$Ut._keyToDOMMap.get(g[n]);
                                    if (void 0 !== t) {
                                        e = t;
                                        break;
                                    }
                                }
                                $3e88191b87395c2e$var$Te(t.key, o.withBefore(e !== null && e !== void 0 ? e : o.before));
                            }
                            if ("destroy" !== t.kind) {
                                const e = $3e88191b87395c2e$var$ne.get(t.key);
                                e && $3e88191b87395c2e$export$471953706258be2b(e) && null === $3e88191b87395c2e$var$Jt && ($3e88191b87395c2e$var$Jt = e.getFormat(), $3e88191b87395c2e$var$jt = e.getStyle(), $3e88191b87395c2e$var$Vt = e.__key);
                            }
                            $3e88191b87395c2e$var$Yt(e);
                        }
                        let T = "";
                        for(let e = 0; e < l; e++){
                            const n = $3e88191b87395c2e$var$ne.get(g[e]);
                            if (void 0 === n) return !1;
                            let o;
                            if ($3e88191b87395c2e$export$923a058ef54437a4(n)) {
                                const r = $3e88191b87395c2e$var$Ut._keyToDOMMap.get(g[e]), i = r && r.__lexicalTextContent;
                                "string" != typeof i && $3e88191b87395c2e$var$t(350, n.getType()), o = i;
                            } else o = n.getTextContent();
                            T += o, e < l - 1 && $3e88191b87395c2e$export$923a058ef54437a4(n) && !n.isInline() && (T += $3e88191b87395c2e$var$D);
                        }
                        const k = r.__lexicalSlotTextLength || 0, b = k > 0 ? i.slice(k) : i;
                        return r.__lexicalTextContent = b.slice(0, b.length - v) + T, !0;
                    }(e, 0, o, c, i, s, f, a)) {
                        const e = c.__lexicalTextContent;
                        return "string" != typeof e && $3e88191b87395c2e$var$t(353), $3e88191b87395c2e$var$Ht = r + e, void $3e88191b87395c2e$var$we(n, c, u);
                    }
                }
            }
            if (0 === a) {
                let n = e.__first, o = 0;
                for(; null !== n;){
                    const e = $3e88191b87395c2e$var$ne.get(n);
                    if (void 0 === e) break;
                    const r = $3e88191b87395c2e$var$le || $3e88191b87395c2e$var$Zt.has(n) || $3e88191b87395c2e$var$Qt.has(n), i = $3e88191b87395c2e$var$qt();
                    if (r) $3e88191b87395c2e$var$Ee(n, l);
                    else {
                        let o, r;
                        if ($3e88191b87395c2e$export$923a058ef54437a4(e)) {
                            r = $3e88191b87395c2e$var$oe.get(n);
                            const i = r && r.__lexicalTextContent;
                            "string" != typeof i && $3e88191b87395c2e$var$t(354, e.getType()), o = i;
                        } else o = e.getTextContent();
                        $3e88191b87395c2e$var$Ht += o, void 0 !== r && $3e88191b87395c2e$var$Gt(r);
                    }
                    $3e88191b87395c2e$export$471953706258be2b(e) ? null === $3e88191b87395c2e$var$Jt && ($3e88191b87395c2e$var$Jt = e.getFormat(), $3e88191b87395c2e$var$jt = e.getStyle(), $3e88191b87395c2e$var$Vt = e.__key) : $3e88191b87395c2e$export$923a058ef54437a4(e) && o < s - 1 && !e.isInline() && ($3e88191b87395c2e$var$Ht += $3e88191b87395c2e$var$D), $3e88191b87395c2e$var$Yt(i), n = e.__next, o++;
                }
                return c.__lexicalTextContent = $3e88191b87395c2e$var$Ht, c.__lexicalFirstTextKey = $3e88191b87395c2e$var$Vt, void ($3e88191b87395c2e$var$Ht = r + $3e88191b87395c2e$var$Ht);
            }
        }
        if (1 === i && 1 === s) {
            const t = e.__first, r = n.__first;
            if (t === r) $3e88191b87395c2e$var$Ee(t, l);
            else {
                const e = $3e88191b87395c2e$var$Pe(t), n = $3e88191b87395c2e$var$Te(r, null);
                try {
                    e.parentNode === l ? l.replaceChild(n, e) : o.insertChild(n);
                } catch (o) {
                    if ("object" == typeof o && null != o) {
                        const i = `${o.toString()} Parent: ${l.tagName}, new child: {tag: ${n.tagName} key: ${r}}, old child: {tag: ${e.tagName}, key: ${t}}.`;
                        throw new Error(i);
                    }
                    throw o;
                }
                $3e88191b87395c2e$var$ae(t, null);
            }
            const i = $3e88191b87395c2e$var$ne.get(r);
            $3e88191b87395c2e$export$471953706258be2b(i) && null === $3e88191b87395c2e$var$Jt && ($3e88191b87395c2e$var$Jt = i.getFormat(), $3e88191b87395c2e$var$jt = i.getStyle(), $3e88191b87395c2e$var$Vt = i.__key);
        } else {
            const r = $3e88191b87395c2e$export$4755c0a85d0b9cd5(e, $3e88191b87395c2e$var$te), c = $3e88191b87395c2e$export$4755c0a85d0b9cd5(n, $3e88191b87395c2e$var$ne);
            if (r.length !== i && $3e88191b87395c2e$var$t(227), c.length !== s && $3e88191b87395c2e$var$t(228), 0 === i) 0 !== s && $3e88191b87395c2e$var$ke(c, n, 0, s - 1, o);
            else if (0 === s) {
                if (0 !== i) {
                    const t = null == o.after && null == o.before && 0 === $3e88191b87395c2e$var$xe(n).size && null == o.element.__lexicalLineBreak;
                    $3e88191b87395c2e$var$ue(r, 0, i - 1, t ? null : l), t && (l.textContent = "");
                }
            } else !function(t, e, n, o, r, i) {
                const s = o - 1, l = r - 1;
                let c, a, u = i.getFirstChild(), f = 0, d = 0;
                for(; f <= s && d <= l;){
                    const t = e[f], o = n[d], r = $3e88191b87395c2e$var$qt();
                    if (t === o) u = $3e88191b87395c2e$var$Me($3e88191b87395c2e$var$Ee(o, i.element)), f++, d++;
                    else {
                        if (void 0 === a && (a = $3e88191b87395c2e$var$Ae(n, d)), void 0 === c) c = $3e88191b87395c2e$var$Ae(e, f);
                        else if (!c.has(t)) {
                            f++, $3e88191b87395c2e$var$Yt(r);
                            continue;
                        }
                        if (!a.has(t)) {
                            u = $3e88191b87395c2e$var$Me($3e88191b87395c2e$var$Pe(t)), $3e88191b87395c2e$var$ae(t, i.element), f++, c.delete(t), $3e88191b87395c2e$var$Yt(r);
                            continue;
                        }
                        if (c.has(o)) {
                            const t = $3e88191b87395c2e$var$bl($3e88191b87395c2e$var$Ut, o);
                            t !== u && i.withBefore(u !== null && u !== void 0 ? u : i.before).insertChild(t), u = $3e88191b87395c2e$var$Me($3e88191b87395c2e$var$Ee(o, i.element)), f++, d++;
                        } else $3e88191b87395c2e$var$Te(o, i.withBefore(u !== null && u !== void 0 ? u : i.before)), d++;
                    }
                    const s = $3e88191b87395c2e$var$ne.get(o);
                    null !== s && $3e88191b87395c2e$export$471953706258be2b(s) ? null === $3e88191b87395c2e$var$Jt && ($3e88191b87395c2e$var$Jt = s.getFormat(), $3e88191b87395c2e$var$jt = s.getStyle(), $3e88191b87395c2e$var$Vt = s.__key) : $3e88191b87395c2e$export$923a058ef54437a4(s) && d <= l && !s.isInline() && ($3e88191b87395c2e$var$Ht += $3e88191b87395c2e$var$D), $3e88191b87395c2e$var$Yt(r);
                }
                const h = f > s, g = d > l;
                if (h && !g) {
                    const e = n[l + 1], o = void 0 === e ? null : $3e88191b87395c2e$var$Ut.getElementByKey(e);
                    $3e88191b87395c2e$var$ke(n, t, d, l, i.withBefore(o !== null && o !== void 0 ? o : i.before));
                } else g && !h && $3e88191b87395c2e$var$ue(e, f, s, i.element);
            }(n, r, c, i, s, o);
        }
        c.__lexicalTextContent = $3e88191b87395c2e$var$Ht, c.__lexicalFirstTextKey = $3e88191b87395c2e$var$Vt, $3e88191b87395c2e$var$Ht = r + $3e88191b87395c2e$var$Ht;
    }(e, n, $3e88191b87395c2e$export$724e988312a5b9ca(n, o, $3e88191b87395c2e$var$Ut)), $3e88191b87395c2e$export$6f851a24c61146af(n) || (r = n, null == $3e88191b87395c2e$var$Jt || $3e88191b87395c2e$var$Jt === r.__textFormat || $3e88191b87395c2e$var$ce || r.setTextFormat($3e88191b87395c2e$var$Jt), function(t) {
        null == $3e88191b87395c2e$var$jt || $3e88191b87395c2e$var$jt === t.__textStyle || $3e88191b87395c2e$var$ce || t.setTextStyle($3e88191b87395c2e$var$jt);
    }(n));
}
function $3e88191b87395c2e$var$we(t, e, n) {
    const o = e.__lexicalFirstTextKey;
    if (null != o) {
        const e = t.__key;
        let r = o;
        for(; null !== r;){
            const t = $3e88191b87395c2e$var$ne.get(r);
            if (void 0 === t) {
                r = null;
                break;
            }
            if (t.__parent === e) break;
            r = t.__parent;
        }
        if (null !== r && !n.has(r)) {
            const t = $3e88191b87395c2e$var$ne.get(o);
            if ($3e88191b87395c2e$export$471953706258be2b(t)) return $3e88191b87395c2e$var$Jt = t.getFormat(), void ($3e88191b87395c2e$var$jt = t.getStyle());
        }
    }
    e.__lexicalFirstTextKey = $3e88191b87395c2e$var$Vt;
}
function $3e88191b87395c2e$var$Ee(e, n) {
    const o = $3e88191b87395c2e$var$te.get(e);
    let r = $3e88191b87395c2e$var$ne.get(e);
    void 0 !== o && void 0 !== r || $3e88191b87395c2e$var$t(61);
    const i = $3e88191b87395c2e$var$le || $3e88191b87395c2e$var$Zt.has(e) || $3e88191b87395c2e$var$Qt.has(e), s = $3e88191b87395c2e$var$bl($3e88191b87395c2e$var$Ut, e);
    if (o === r && !i) {
        let e;
        if ($3e88191b87395c2e$export$923a058ef54437a4(o)) {
            const n = s.__lexicalTextContent;
            "string" != typeof n && $3e88191b87395c2e$var$t(355, o.getType()), e = n, $3e88191b87395c2e$var$Gt(s);
        } else e = o.getTextContent();
        return $3e88191b87395c2e$var$Ht += e, s;
    }
    if (o !== r && i && $3e88191b87395c2e$var$xl($3e88191b87395c2e$var$ie, $3e88191b87395c2e$var$$t, $3e88191b87395c2e$var$Xt, r, "updated"), $3e88191b87395c2e$var$se.$updateDOM(r, o, s, $3e88191b87395c2e$var$Ut)) {
        const o = $3e88191b87395c2e$var$Te(e, null);
        return null === n && $3e88191b87395c2e$var$t(62), n.replaceChild(o, s), $3e88191b87395c2e$var$ae(e, null), o;
    }
    if ($3e88191b87395c2e$export$923a058ef54437a4(o)) {
        $3e88191b87395c2e$export$923a058ef54437a4(r) || $3e88191b87395c2e$var$t(334, e);
        const n = r.__indent;
        ($3e88191b87395c2e$var$le || n !== o.__indent) && $3e88191b87395c2e$var$he(s, n);
        const l = r.__format;
        ($3e88191b87395c2e$var$le || l !== o.__format) && $3e88191b87395c2e$var$ge(s, l);
        const c = i && ($3e88191b87395c2e$var$xe(r).size > 0 || $3e88191b87395c2e$var$xe(o).size > 0) ? $3e88191b87395c2e$var$ve(o, r, s) : "";
        if (i) {
            const t = $3e88191b87395c2e$var$Ht;
            if ($3e88191b87395c2e$var$Ne(o, r, s), $3e88191b87395c2e$export$5b29ca560c2fedab(r) || r.isInline() || $3e88191b87395c2e$var$be(0, r, s), "" !== c) {
                const e = s.__lexicalTextContent || "";
                s.__lexicalTextContent = c + e, $3e88191b87395c2e$var$Ht = t + c + e, s.__lexicalSlotTextLength = c.length;
            } else ($3e88191b87395c2e$var$xe(r).size > 0 || $3e88191b87395c2e$var$xe(o).size > 0) && (s.__lexicalSlotTextLength = 0);
        } else {
            const e = s.__lexicalTextContent;
            "string" != typeof e && $3e88191b87395c2e$var$t(356, o.getType()), $3e88191b87395c2e$var$Ht += e, $3e88191b87395c2e$var$Gt(s);
        }
        if (($3e88191b87395c2e$var$le || r.__dir !== o.__dir || r.__parent !== o.__parent) && ($3e88191b87395c2e$var$_e(s, r), $3e88191b87395c2e$export$5b29ca560c2fedab(r) && !$3e88191b87395c2e$var$le)) {
            for (const t of r.getChildren())if ($3e88191b87395c2e$export$923a058ef54437a4(t)) $3e88191b87395c2e$var$_e($3e88191b87395c2e$var$bl($3e88191b87395c2e$var$Ut, t.getKey()), t);
        }
    } else {
        const t = r.getTextContent();
        if ($3e88191b87395c2e$export$60aa03725ce41b1c(r)) {
            const t = r.decorate($3e88191b87395c2e$var$Ut, $3e88191b87395c2e$var$Wt);
            null !== t && $3e88191b87395c2e$var$Oe(e, t), i && ($3e88191b87395c2e$var$xe(r).size > 0 || $3e88191b87395c2e$var$xe(o).size > 0) && $3e88191b87395c2e$var$ve(o, r, s);
        }
        $3e88191b87395c2e$var$Ht += t;
    }
    if (!$3e88191b87395c2e$var$ce && $3e88191b87395c2e$export$5b29ca560c2fedab(r)) {
        const t = r.getLatest();
        if (t.__cachedText !== $3e88191b87395c2e$var$Ht) {
            const e = t.getWritable();
            e.__cachedText = $3e88191b87395c2e$var$Ht, r = e;
        }
    }
    return $3e88191b87395c2e$var$se.$decorateDOM(r, o, s, $3e88191b87395c2e$var$Ut), $3e88191b87395c2e$var$Bt(r), s;
}
function $3e88191b87395c2e$var$Oe(t, e) {
    let n = $3e88191b87395c2e$var$Ut._pendingDecorators;
    const o = $3e88191b87395c2e$var$Ut._decorators;
    if (null === n) {
        if (o[t] === e) return;
        n = $3e88191b87395c2e$var$Qs($3e88191b87395c2e$var$Ut);
    }
    n[t] = e;
}
function $3e88191b87395c2e$var$Me(t) {
    let e = t.nextSibling;
    return null !== e && e === $3e88191b87395c2e$var$Ut._blockCursorElement && (e = e.nextSibling), e;
}
function $3e88191b87395c2e$var$Ae(t, e) {
    const n = new Set;
    for(let o = e; o < t.length; o++)n.add(t[o]);
    return n;
}
function $3e88191b87395c2e$var$De(t, e, n, o, r, i) {
    $3e88191b87395c2e$var$Ht = "", $3e88191b87395c2e$var$Jt = null, $3e88191b87395c2e$var$jt = null, $3e88191b87395c2e$var$Vt = null, $3e88191b87395c2e$var$le = 2 === o, $3e88191b87395c2e$var$Ut = n, $3e88191b87395c2e$var$Wt = n._config, $3e88191b87395c2e$var$se = n._config.dom || $3e88191b87395c2e$export$1d0bbaf021f5def1, $3e88191b87395c2e$var$$t = n._nodes, $3e88191b87395c2e$var$Xt = $3e88191b87395c2e$var$Ut._listeners.mutation, $3e88191b87395c2e$var$Qt = r, $3e88191b87395c2e$var$Zt = i, $3e88191b87395c2e$var$te = t._nodeMap, $3e88191b87395c2e$var$ee = t, $3e88191b87395c2e$var$ne = e._nodeMap, $3e88191b87395c2e$var$ce = e._readOnly, $3e88191b87395c2e$var$oe = $3e88191b87395c2e$var$nt(n._keyToDOMMap), $3e88191b87395c2e$var$re = function() {
        const t = new Map, e = (e)=>{
            for (const n of e){
                const e = $3e88191b87395c2e$var$ne.get(n);
                if (void 0 === e) continue;
                const o = e.__parent;
                if (null === o) continue;
                let r = t.get(o);
                void 0 === r && (r = new Set, t.set(o, r)), r.add(n);
            }
        };
        return e($3e88191b87395c2e$var$Qt.keys()), e($3e88191b87395c2e$var$Zt), t;
    }();
    const s = new Map;
    return $3e88191b87395c2e$var$ie = s, $3e88191b87395c2e$var$Ee("root", null), $3e88191b87395c2e$var$Ut = void 0, $3e88191b87395c2e$var$$t = void 0, $3e88191b87395c2e$var$Qt = void 0, $3e88191b87395c2e$var$Zt = void 0, $3e88191b87395c2e$var$te = void 0, $3e88191b87395c2e$var$ee = void 0, $3e88191b87395c2e$var$ne = void 0, $3e88191b87395c2e$var$Wt = void 0, $3e88191b87395c2e$var$oe = void 0, $3e88191b87395c2e$var$re = void 0, $3e88191b87395c2e$var$ie = void 0, $3e88191b87395c2e$var$se = $3e88191b87395c2e$export$1d0bbaf021f5def1, s;
}
function $3e88191b87395c2e$var$Pe(e) {
    const n = $3e88191b87395c2e$var$oe.get(e);
    return void 0 === n && $3e88191b87395c2e$var$t(75, e), n;
}
/*@__INLINE__*/ function $3e88191b87395c2e$export$8d4021544bdece00(t) {
    return {
        type: t
    };
}
const $3e88191b87395c2e$export$e396fef71d2b56e5 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("SELECTION_CHANGE_COMMAND"), $3e88191b87395c2e$export$e47bb493817ec5f6 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("SELECTION_INSERT_CLIPBOARD_NODES_COMMAND"), $3e88191b87395c2e$export$c1a2de6c823e5f82 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("CLICK_COMMAND"), $3e88191b87395c2e$export$5ac84ded9d925fd5 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("BEFORE_INPUT_COMMAND"), $3e88191b87395c2e$export$ee0f3fd82c319b92 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("INPUT_COMMAND"), $3e88191b87395c2e$export$e688de3e16be2231 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("COMPOSITION_START_COMMAND"), $3e88191b87395c2e$export$432579d4ad746c17 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("COMPOSITION_END_COMMAND"), $3e88191b87395c2e$export$35595bf6d7e36fd5 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("DELETE_CHARACTER_COMMAND"), $3e88191b87395c2e$export$64e35ce26e025724 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("INSERT_LINE_BREAK_COMMAND"), $3e88191b87395c2e$export$24f4fea65b096b4 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("INSERT_PARAGRAPH_COMMAND"), $3e88191b87395c2e$export$6f67c758bb657857 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("CONTROLLED_TEXT_INSERTION_COMMAND"), $3e88191b87395c2e$export$7fb70c61b3bcc883 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("PASTE_COMMAND"), $3e88191b87395c2e$export$9cc285f2a3ff220c = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("REMOVE_TEXT_COMMAND"), $3e88191b87395c2e$export$8e315b175631384c = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("DELETE_WORD_COMMAND"), $3e88191b87395c2e$export$d77fad8fb8747fd = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("DELETE_LINE_COMMAND"), $3e88191b87395c2e$export$85443a1a9543f043 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("FORMAT_TEXT_COMMAND"), $3e88191b87395c2e$export$8bd686fd552eaef7 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("SET_TEXT_FORMAT_COMMAND"), $3e88191b87395c2e$export$34722a4946cb641e = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("UNDO_COMMAND"), $3e88191b87395c2e$export$8c4a0748d31d9941 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("REDO_COMMAND"), $3e88191b87395c2e$export$61973214e0e18936 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEYDOWN_COMMAND"), $3e88191b87395c2e$export$217ec2281ac1c53b = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_ARROW_RIGHT_COMMAND"), $3e88191b87395c2e$export$fb3b2d438650aff6 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("MOVE_TO_END"), $3e88191b87395c2e$export$7525f8f8ab44508 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_ARROW_LEFT_COMMAND"), $3e88191b87395c2e$export$dc117ee4d661295a = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("MOVE_TO_START"), $3e88191b87395c2e$export$7833c2a33ae81d3d = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_ARROW_UP_COMMAND"), $3e88191b87395c2e$export$baa60daa2ca402b3 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_ARROW_DOWN_COMMAND"), $3e88191b87395c2e$export$2cdb7cdd6fccb293 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_ENTER_COMMAND"), $3e88191b87395c2e$export$d0bc2bb647ce4c17 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_SPACE_COMMAND"), $3e88191b87395c2e$export$24bbba9bfa830f78 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_BACKSPACE_COMMAND"), $3e88191b87395c2e$export$53589e422a755d59 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_ESCAPE_COMMAND"), $3e88191b87395c2e$export$13a0e72b5c0146bb = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_DELETE_COMMAND"), $3e88191b87395c2e$export$b321bdc226ccdcde = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_TAB_COMMAND"), $3e88191b87395c2e$export$926ce4da2c89d118 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("INSERT_TAB_COMMAND"), $3e88191b87395c2e$export$2f74f6a2d927e6bd = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("INDENT_CONTENT_COMMAND"), $3e88191b87395c2e$export$ecf9caa19e96e40d = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("OUTDENT_CONTENT_COMMAND"), $3e88191b87395c2e$export$eac1e4b16b80d3ea = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("DROP_COMMAND"), $3e88191b87395c2e$export$d394dc6514823b18 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("FORMAT_ELEMENT_COMMAND"), $3e88191b87395c2e$export$2e0fd45fde1da719 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("DRAGSTART_COMMAND"), $3e88191b87395c2e$export$b62c1cce98fa7223 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("DRAGOVER_COMMAND"), $3e88191b87395c2e$export$ffbd838cf75d7d8e = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("DRAGEND_COMMAND"), $3e88191b87395c2e$export$3435fcfb1f59ef96 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("COPY_COMMAND"), $3e88191b87395c2e$export$4dc8a35a083beec4 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("CUT_COMMAND"), $3e88191b87395c2e$export$185c218616045e75 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("SELECT_ALL_COMMAND"), $3e88191b87395c2e$export$4926ce1a5702fdc7 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("CLEAR_EDITOR_COMMAND"), $3e88191b87395c2e$export$d3f69a65bbe7edc = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("CLEAR_HISTORY_COMMAND"), $3e88191b87395c2e$export$e36aacf84f559bb3 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("CAN_REDO_COMMAND"), $3e88191b87395c2e$export$9fd9dd31dd6ebdf5 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("CAN_UNDO_COMMAND"), $3e88191b87395c2e$export$cafe35f35e77bf56 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("FOCUS_COMMAND"), $3e88191b87395c2e$export$4b6d457d076906ac = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("BLUR_COMMAND"), $3e88191b87395c2e$export$452548a3c1874d61 = /* @__PURE__ */ $3e88191b87395c2e$export$8d4021544bdece00("KEY_MODIFIER_COMMAND");
function $3e88191b87395c2e$export$f6b7bc9c26b0bf39(t) {
    const e = new Map;
    return {
        dispose () {
            for (const t of e.values())t.dispose();
            e.clear();
        },
        register (n, o) {
            let r = e.get(n);
            void 0 === r && (r = {
                dispose: t(n, o),
                holders: new Set
            }, e.set(n, r));
            const i = ()=>{
                const t = e.get(n);
                t && t.holders.delete(i) && 0 === t.holders.size && (e.delete(n), t.dispose());
            };
            return r.holders.add(i), i;
        }
    };
}
function $3e88191b87395c2e$export$bea698773a21b4e8(t, e, n, o) {
    return t.addEventListener(e, n, o), t.removeEventListener.bind(t, e, n, o);
}
const $3e88191b87395c2e$var$Fn = Object.freeze({}), $3e88191b87395c2e$var$In = [
    [
        "keydown",
        function(t, e) {
            const n = e._inputState;
            n.lastKeyDownTimeStamp = t.timeStamp, n.lastKeyCode = t.key, "Backspace" !== t.key && $3e88191b87395c2e$var$jn(n);
            if (e.isComposing()) return;
            $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$61973214e0e18936, t);
        }
    ],
    [
        "pointerdown",
        function(t, e) {
            const n = $3e88191b87395c2e$export$da5d2f8c5437c541(t), o = t.pointerType;
            $3e88191b87395c2e$export$b8eb4d3b76e486c2(n) && "touch" !== o && "pen" !== o && 0 === t.button && $3e88191b87395c2e$var$Mi(e, ()=>{
                $3e88191b87395c2e$export$b1dbc8b9f80bab62(n, e) || (e._inputState.isSelectionChangeFromMouseDown = !0);
            });
        }
    ],
    [
        "compositionstart",
        function(t, e) {
            $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$e688de3e16be2231, t);
        }
    ],
    [
        "compositionend",
        function(t, e) {
            const n = e._inputState;
            $3e88191b87395c2e$export$fa35291248be714f ? n.compositionPhase = "ending-firefox" : $3e88191b87395c2e$export$9135b5fce2a2854d || !$3e88191b87395c2e$export$af54264dae9065e6 && !$3e88191b87395c2e$export$e9250b0198928087 ? $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$432579d4ad746c17, t) : (n.compositionPhase = "ending-safari", n.compositionEndData = t.data);
        }
    ],
    [
        "input",
        function(t, e) {
            t.stopPropagation();
            const n = e._inputState;
            $3e88191b87395c2e$var$jn(n), $3e88191b87395c2e$var$Mi(e, ()=>{
                $3e88191b87395c2e$var$qn(t, e) || e.dispatchCommand($3e88191b87395c2e$export$ee0f3fd82c319b92, t);
            }, {
                event: t
            }), n.unprocessedBeforeInputData = null;
        }
    ],
    [
        "click",
        function(t, e) {
            $3e88191b87395c2e$var$Mi(e, ()=>{
                const n = $3e88191b87395c2e$export$63a3201b3a5c7d90(), o = $3e88191b87395c2e$export$74c14770a0819525($3e88191b87395c2e$var$Pl(e)), r = $3e88191b87395c2e$export$846e9407a8b5d98c();
                if (o) {
                    if ($3e88191b87395c2e$export$181b63acea8a0224(n)) {
                        const t = n.anchor, e = t.getNode();
                        "element" === t.type && 0 === t.offset && n.isCollapsed() && !$3e88191b87395c2e$export$5b29ca560c2fedab(e) && 1 === $3e88191b87395c2e$export$8d83ea843c4eea9a().getChildrenSize() && e.getTopLevelElementOrThrow().isEmpty() && null !== r && n.is(r) && (o.removeAllRanges(), n.dirty = !0);
                    } else if ("touch" === t.pointerType || "pen" === t.pointerType) {
                        const n = $3e88191b87395c2e$export$fca86712f5243a7e(o, e._rootElement).anchorNode;
                        if ($3e88191b87395c2e$export$1b3bfaa9684536aa(n) || $3e88191b87395c2e$export$4295c0f0b9b754c4(n)) $3e88191b87395c2e$export$2aad78c37810bca9($3e88191b87395c2e$var$Ir(r, o, e, t));
                    }
                }
                $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$c1a2de6c823e5f82, t);
            });
        }
    ],
    [
        "cut",
        $3e88191b87395c2e$var$Fn
    ],
    [
        "copy",
        $3e88191b87395c2e$var$Fn
    ],
    [
        "dragstart",
        $3e88191b87395c2e$var$Fn
    ],
    [
        "dragover",
        $3e88191b87395c2e$var$Fn
    ],
    [
        "dragend",
        $3e88191b87395c2e$var$Fn
    ],
    [
        "paste",
        $3e88191b87395c2e$var$Fn
    ],
    [
        "focus",
        $3e88191b87395c2e$var$Fn
    ],
    [
        "blur",
        $3e88191b87395c2e$var$Fn
    ],
    [
        "drop",
        $3e88191b87395c2e$var$Fn
    ]
];
$3e88191b87395c2e$export$7596791c42a3094d && $3e88191b87395c2e$var$In.push([
    "beforeinput",
    (t, e)=>(function(t, e) {
            const n = t.inputType;
            if ("deleteCompositionText" === n || $3e88191b87395c2e$export$fa35291248be714f && $3e88191b87395c2e$var$Tl(e)) return;
            if ("insertCompositionText" === n) return;
            $3e88191b87395c2e$var$Mi(e, ()=>{
                $3e88191b87395c2e$var$qn(t, e) || $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$5ac84ded9d925fd5, t);
            }, {
                event: t
            });
        })(t, e)
]);
const $3e88191b87395c2e$var$Ln = new WeakMap, $3e88191b87395c2e$var$Kn = new WeakMap, $3e88191b87395c2e$var$zn = $3e88191b87395c2e$export$f6b7bc9c26b0bf39((t)=>(t.addEventListener("selectionchange", $3e88191b87395c2e$var$ro), ()=>t.removeEventListener("selectionchange", $3e88191b87395c2e$var$ro)));
function $3e88191b87395c2e$var$Bn(t, e, n, o, r, i) {
    const l = t.anchor, c = t.focus, a = l.getNode(), u = $3e88191b87395c2e$var$gi();
    let f;
    if (void 0 !== i) f = i;
    else {
        const t = $3e88191b87395c2e$export$74c14770a0819525($3e88191b87395c2e$var$Pl(u));
        f = null !== t ? $3e88191b87395c2e$export$fca86712f5243a7e(t, u._rootElement) : null;
    }
    const d = null !== f ? f.anchorNode : null, h = l.key, g = u.getElementByKey(h), _ = n.length;
    return h !== c.key || !$3e88191b87395c2e$export$471953706258be2b(a) || (!r && (!$3e88191b87395c2e$export$7596791c42a3094d || u._inputState.lastBeforeInputInsertTextTimeStamp < o + 50) || a.isDirty() && _ < 2 || $3e88191b87395c2e$var$rl(n)) && l.offset !== c.offset && !a.isComposing() || $3e88191b87395c2e$export$8b834332909623ff(a) || a.isDirty() && _ > 1 || (r || !$3e88191b87395c2e$export$7596791c42a3094d) && null !== g && !a.isComposing() && d !== $3e88191b87395c2e$export$118c63c491bd7ec(a, g, u) || null !== f && null !== e && (!e.collapsed || e.startContainer !== f.anchorNode || e.startOffset !== f.anchorOffset) || !a.isComposing() && (a.getFormat() !== t.format || a.getStyle() !== t.style) || function(t, e) {
        if (e.isSegmented()) return !0;
        if (!t.isCollapsed()) return !1;
        const n = t.anchor.offset, o = e.getParentOrThrow(), r = $3e88191b87395c2e$export$c863bf9446d4a347(e);
        return 0 === n ? !e.canInsertTextBefore() || !o.canInsertTextBefore() && !e.isComposing() || r || function(t) {
            const e = t.getPreviousSibling();
            return ($3e88191b87395c2e$export$471953706258be2b(e) || $3e88191b87395c2e$export$923a058ef54437a4(e) && e.isInline()) && !e.canInsertTextAfter();
        }(e) : n === e.getTextContentSize() && (!e.canInsertTextAfter() || !o.canInsertTextAfter() && !e.isComposing() || r);
    }(t, a);
}
function $3e88191b87395c2e$var$Rn(t, e) {
    return $3e88191b87395c2e$export$4295c0f0b9b754c4(t) && null !== t.nodeValue && 0 !== e && e !== t.nodeValue.length;
}
function $3e88191b87395c2e$var$Wn(e, n, o) {
    const { anchorNode: r, anchorOffset: i, focusNode: s, focusOffset: l } = $3e88191b87395c2e$export$fca86712f5243a7e(e, n._rootElement), c = n._inputState;
    c.isSelectionChangeFromDOMUpdate && (c.isSelectionChangeFromDOMUpdate = !1, $3e88191b87395c2e$var$Rn(r, i) && $3e88191b87395c2e$var$Rn(s, l) && !c.postDeleteSelectionToRestore) || $3e88191b87395c2e$var$Mi(n, ()=>{
        if (!o) return void $3e88191b87395c2e$export$2aad78c37810bca9(null);
        if (!$3e88191b87395c2e$export$f1b377b21cd6350b(n, r, s)) return;
        let a = $3e88191b87395c2e$export$63a3201b3a5c7d90();
        if (c.postDeleteSelectionToRestore && $3e88191b87395c2e$export$181b63acea8a0224(a) && a.isCollapsed()) {
            const t = a.anchor, e = c.postDeleteSelectionToRestore.anchor;
            (t.key === e.key && t.offset === e.offset + 1 || 1 === t.offset && e.getNode().is(t.getNode().getPreviousSibling())) && (a = c.postDeleteSelectionToRestore.clone(), $3e88191b87395c2e$export$2aad78c37810bca9(a));
        }
        if (c.postDeleteSelectionToRestore = null, $3e88191b87395c2e$export$181b63acea8a0224(a)) {
            const o = a.anchor, u = o.getNode();
            if (a.isCollapsed()) {
                "Range" === e.type && r === s && (a.dirty = !0);
                const i = $3e88191b87395c2e$var$Pl(n).event, l = i ? i.timeStamp : performance.now(), { format: f, style: d, offset: h, key: g, timeStamp: _ } = c.collapsedSelectionFormat, p = $3e88191b87395c2e$export$8d83ea843c4eea9a(), y = !1 === n.isComposing() && "" === p.getTextContent();
                if (l < _ + 200 && o.offset === h && o.key === g) $3e88191b87395c2e$var$Un(a, f, d);
                else if ("text" === o.type) $3e88191b87395c2e$export$471953706258be2b(u) || $3e88191b87395c2e$var$t(141), $3e88191b87395c2e$var$$n(a, u);
                else if ("element" === o.type && !y) {
                    $3e88191b87395c2e$export$923a058ef54437a4(u) || $3e88191b87395c2e$var$t(259);
                    const e = o.getNode();
                    e.isEmpty() ? function(t, e) {
                        const n = e.getTextFormat(), o = e.getTextStyle();
                        $3e88191b87395c2e$var$Un(t, n, o);
                    }(a, e) : $3e88191b87395c2e$var$Un(a, a.format, "");
                }
            } else {
                const t = o.key, e = a.focus.key, n = a.getNodes(), r = n.length, s = a.isBackward(), c = s ? l : i, u = s ? i : l, f = s ? e : t, d = s ? t : e;
                let h = 2047, g = !1;
                for(let t = 0; t < r; t++){
                    const e = n[t], o = e.getTextContentSize();
                    if ($3e88191b87395c2e$export$471953706258be2b(e) && 0 !== o && !(0 === t && e.__key === f && c === o || t === r - 1 && e.__key === d && 0 === u) && (g = !0, h &= e.getFormat(), 0 === h)) break;
                }
                a.format = g ? h : 0;
            }
        }
        $3e88191b87395c2e$var$kl(n, $3e88191b87395c2e$export$e396fef71d2b56e5, void 0);
    });
}
function $3e88191b87395c2e$var$Un(t, e, n) {
    t.format === e && t.style === n || (t.format = e, t.style = n, t.dirty = !0);
}
function $3e88191b87395c2e$var$$n(t, e) {
    $3e88191b87395c2e$var$Un(t, e.getFormat(), e.getStyle());
}
function $3e88191b87395c2e$var$Hn(t) {
    if (!t.getTargetRanges) return null;
    const e = t.getTargetRanges();
    return 0 === e.length ? null : e[0];
}
function $3e88191b87395c2e$var$Jn(t) {
    const { lastKeyCode: e } = $3e88191b87395c2e$var$gi()._inputState;
    if (null == t || t.length <= 1 || null == e) return;
    const n = 1 === e.length ? e : "Enter" === e ? "\n" : "Tab" === e ? "\t" : null;
    if (!n) return;
    const o = $3e88191b87395c2e$export$63a3201b3a5c7d90();
    if (!$3e88191b87395c2e$export$181b63acea8a0224(o) || !o.isCollapsed()) return;
    const r = o.anchor.getNode();
    if (!$3e88191b87395c2e$export$471953706258be2b(r)) return;
    const { offset: i } = o.anchor;
    if (r.getTextContentSize() === i) {
        const t = r.getNextSibling();
        if ("\n" === n) {
            if ($3e88191b87395c2e$export$b16330e40aa25c4e(t)) t.selectEnd();
            else if (!t) {
                const t = $3e88191b87395c2e$export$57101724ca611500(r, $3e88191b87395c2e$export$de078facd4ee1560), e = t && t.getNextSibling();
                $3e88191b87395c2e$export$923a058ef54437a4(e) && e.selectStart();
            }
        } else "\t" === n ? $3e88191b87395c2e$export$ac9141efa5fb7932(t) && t.selectEnd() : $3e88191b87395c2e$export$471953706258be2b(t) && t.getTextContent()[0] === n && t.select(1, 1);
    } else r.getTextContent()[i] === n && r.select(i + 1, i + 1);
}
function $3e88191b87395c2e$var$jn(t) {
    t.isInsertTextAfterHandledSelectionCommand = !1, null !== t.handledSelectionCommandTimeoutId && (clearTimeout(t.handledSelectionCommandTimeoutId), t.handledSelectionCommandTimeoutId = null);
}
function $3e88191b87395c2e$var$Vn(t) {
    $3e88191b87395c2e$var$jn(t), t.isInsertTextAfterHandledSelectionCommand = !0, t.handledSelectionCommandTimeoutId = setTimeout(()=>$3e88191b87395c2e$var$jn(t), 0);
}
function $3e88191b87395c2e$var$qn(t, e) {
    const n = $3e88191b87395c2e$export$da5d2f8c5437c541(t);
    if ($3e88191b87395c2e$export$1b3bfaa9684536aa(n) && $3e88191b87395c2e$export$b1dbc8b9f80bab62(n, e)) return !0;
    const o = e.getRootElement();
    if (null === o) return !1;
    const r = $3e88191b87395c2e$export$914ab019e7cf55b0(o.ownerDocument);
    return null !== r && o.contains(r) && $3e88191b87395c2e$export$b1dbc8b9f80bab62(r, e);
}
function $3e88191b87395c2e$var$Yn(e) {
    const n = e.inputType, o = $3e88191b87395c2e$var$Hn(e), r = $3e88191b87395c2e$var$gi(), i = r._inputState, s = $3e88191b87395c2e$export$63a3201b3a5c7d90();
    if ("insertText" === n && e.data && i.isInsertTextAfterHandledSelectionCommand) {
        if ($3e88191b87395c2e$var$jn(i), e.preventDefault(), $3e88191b87395c2e$export$181b63acea8a0224(s) && !s.isCollapsed()) {
            const t = s.isBackward() ? s.anchor : s.focus;
            s.anchor.set(t.key, t.offset, t.type), s.focus.set(t.key, t.offset, t.type);
        }
        return !0;
    }
    if ("deleteContentBackward" === n) {
        if (null === s) {
            const t = $3e88191b87395c2e$export$846e9407a8b5d98c();
            if (!$3e88191b87395c2e$export$181b63acea8a0224(t)) return !0;
            $3e88191b87395c2e$export$2aad78c37810bca9(t.clone());
        }
        if ($3e88191b87395c2e$export$181b63acea8a0224(s)) {
            const n = s.anchor.key === s.focus.key;
            if (function(t, e) {
                return "MediaLast" === t.lastKeyCode && e < t.lastKeyDownTimeStamp + 30;
            }(i, e.timeStamp) && r.isComposing() && n) {
                if ($3e88191b87395c2e$export$ea25f5ef71f2d042(null), i.lastKeyDownTimeStamp = 0, setTimeout(()=>{
                    $3e88191b87395c2e$var$Mi(r, ()=>{
                        $3e88191b87395c2e$export$ea25f5ef71f2d042(null);
                    });
                }, 30), $3e88191b87395c2e$export$181b63acea8a0224(s)) {
                    const e = s.anchor.getNode();
                    e.markDirty(), $3e88191b87395c2e$export$471953706258be2b(e) || $3e88191b87395c2e$var$t(142), $3e88191b87395c2e$var$$n(s, e);
                }
            } else {
                if ($3e88191b87395c2e$export$ea25f5ef71f2d042(null), $3e88191b87395c2e$export$9135b5fce2a2854d && null !== o && !o.collapsed && (s.applyDOMRange(o), !s.isCollapsed())) return e.preventDefault(), s.removeText(), !0;
                e.preventDefault();
                const t = s.anchor.getNode(), c = t.getTextContent(), a = t.canInsertTextAfter(), u = 0 === s.anchor.offset && s.focus.offset === c.length;
                let d = $3e88191b87395c2e$export$129f916e5a4d8e94 && n && !u && a;
                if (d && s.isCollapsed() && (d = !$3e88191b87395c2e$export$60aa03725ce41b1c($3e88191b87395c2e$export$c4b907be1879d8c1(s.anchor, !0))), !d) {
                    $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$35595bf6d7e36fd5, !0);
                    const t = $3e88191b87395c2e$export$63a3201b3a5c7d90();
                    $3e88191b87395c2e$export$129f916e5a4d8e94 && $3e88191b87395c2e$export$181b63acea8a0224(t) && t.isCollapsed() && (i.postDeleteSelectionToRestore = t, setTimeout(()=>i.postDeleteSelectionToRestore = null));
                }
            }
            return !0;
        }
    }
    if (!$3e88191b87395c2e$export$181b63acea8a0224(s)) return !0;
    const c = e.data;
    null !== i.unprocessedBeforeInputData && $3e88191b87395c2e$var$cl(!1, r, i.unprocessedBeforeInputData), s.dirty && null === i.unprocessedBeforeInputData || !s.isCollapsed() || $3e88191b87395c2e$export$5b29ca560c2fedab(s.anchor.getNode()) || null === o || s.applyDOMRange(o), i.unprocessedBeforeInputData = null;
    const a = s.anchor, u = s.focus, d = a.getNode(), h = u.getNode();
    if ("insertText" === n || "insertTranspose" === n) {
        if ("\n" === c) e.preventDefault(), $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$64e35ce26e025724, !1);
        else if (c === $3e88191b87395c2e$var$D) e.preventDefault(), $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$24f4fea65b096b4, void 0);
        else if (null == c && e.dataTransfer) {
            const t = e.dataTransfer.getData("text/plain");
            e.preventDefault(), s.insertRawText(t);
        } else null != c && $3e88191b87395c2e$var$Bn(s, o, c, e.timeStamp, !0) ? (e.preventDefault(), $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$6f67c758bb657857, c), $3e88191b87395c2e$var$Jn(c)) : i.unprocessedBeforeInputData = c;
        return i.lastBeforeInputInsertTextTimeStamp = e.timeStamp, !0;
    }
    switch(e.preventDefault(), n){
        case "insertFromYank":
        case "insertFromDrop":
        case "insertReplacementText":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$6f67c758bb657857, e);
            var _ref;
            $3e88191b87395c2e$var$Jn((_ref = e.dataTransfer ? e.dataTransfer.getData("text/plain") : null) !== null && _ref !== void 0 ? _ref : e.data);
            break;
        case "insertFromComposition":
            {
                const t = i.hadOrphanedCompositionEvents;
                i.hadOrphanedCompositionEvents = !1;
                const n = r._compositionKey;
                $3e88191b87395c2e$export$ea25f5ef71f2d042(null), t || $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$6f67c758bb657857, e), $3e88191b87395c2e$var$Zn(n);
                break;
            }
        case "insertLineBreak":
            $3e88191b87395c2e$export$ea25f5ef71f2d042(null), $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$64e35ce26e025724, !1);
            break;
        case "insertParagraph":
            $3e88191b87395c2e$export$ea25f5ef71f2d042(null), i.isInsertLineBreak && !$3e88191b87395c2e$export$9135b5fce2a2854d ? (i.isInsertLineBreak = !1, $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$64e35ce26e025724, !1)) : $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$24f4fea65b096b4, void 0);
            break;
        case "insertFromPaste":
        case "insertFromPasteAsQuotation":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$7fb70c61b3bcc883, e);
            break;
        case "deleteByComposition":
            (function(t, e) {
                return t !== e || $3e88191b87395c2e$export$923a058ef54437a4(t) || $3e88191b87395c2e$export$923a058ef54437a4(e) || !$3e88191b87395c2e$export$c863bf9446d4a347(t) || !$3e88191b87395c2e$export$c863bf9446d4a347(e);
            })(d, h) && $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$9cc285f2a3ff220c, e);
            break;
        case "deleteByDrag":
            $3e88191b87395c2e$export$24cab2f466b76c04($3e88191b87395c2e$export$8a1d07d516311732), $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$9cc285f2a3ff220c, e);
            break;
        case "deleteByCut":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$9cc285f2a3ff220c, e);
            break;
        case "deleteContent":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$35595bf6d7e36fd5, !1);
            break;
        case "deleteWordBackward":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$8e315b175631384c, !0);
            break;
        case "deleteWordForward":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$8e315b175631384c, !1);
            break;
        case "deleteHardLineBackward":
        case "deleteSoftLineBackward":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$d77fad8fb8747fd, !0);
            break;
        case "deleteContentForward":
        case "deleteHardLineForward":
        case "deleteSoftLineForward":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$d77fad8fb8747fd, !1);
            break;
        case "formatStrikeThrough":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$85443a1a9543f043, "strikethrough");
            break;
        case "formatBold":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$85443a1a9543f043, "bold");
            break;
        case "formatItalic":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$85443a1a9543f043, "italic");
            break;
        case "formatUnderline":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$85443a1a9543f043, "underline");
            break;
        case "historyUndo":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$34722a4946cb641e, void 0);
            break;
        case "historyRedo":
            $3e88191b87395c2e$var$kl(r, $3e88191b87395c2e$export$8c4a0748d31d9941, void 0);
    }
    return !0;
}
function $3e88191b87395c2e$var$Gn(t) {
    const e = $3e88191b87395c2e$var$gi(), n = e._inputState, o = $3e88191b87395c2e$export$63a3201b3a5c7d90(), r = t.data, l = $3e88191b87395c2e$var$Hn(t);
    let c = !1;
    if (null != r && $3e88191b87395c2e$export$181b63acea8a0224(o)) {
        const a = $3e88191b87395c2e$export$74c14770a0819525($3e88191b87395c2e$var$Pl(e)), u = null !== a ? $3e88191b87395c2e$export$fca86712f5243a7e(a, e._rootElement) : null, d = "insertCompositionText" === t.inputType && "ending-firefox" !== n.compositionPhase && !e.isComposing();
        d && (n.hadOrphanedCompositionEvents = !0);
        const h = o.anchor.getNode(), g = "insertCompositionText" === t.inputType && "ending-firefox" !== n.compositionPhase && e.isComposing() && $3e88191b87395c2e$export$471953706258be2b(h) && $3e88191b87395c2e$export$8b834332909623ff(h);
        if (!d && !g && $3e88191b87395c2e$var$Bn(o, l, r, t.timeStamp, !1, u)) {
            if (c = !0, "ending-firefox" === n.compositionPhase) {
                const t = $3e88191b87395c2e$var$to(e, r);
                if (n.compositionPhase = "idle", t) return $3e88191b87395c2e$export$24cab2f466b76c04($3e88191b87395c2e$export$ecc13538534b9f74), $3e88191b87395c2e$var$nl(), !0;
            }
            const l = o.anchor.getNode();
            if (null === a || null === u) return !0;
            const d = o.isBackward(), h = d ? o.anchor.offset : o.focus.offset, g = d ? o.focus.offset : o.anchor.offset;
            $3e88191b87395c2e$export$7596791c42a3094d && !o.isCollapsed() && $3e88191b87395c2e$export$471953706258be2b(l) && null !== u.anchorNode && l.getTextContent().slice(0, h) + r + l.getTextContent().slice(h + g) === $3e88191b87395c2e$var$ll(u.anchorNode) || $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$6f67c758bb657857, r);
            const _ = r.length;
            $3e88191b87395c2e$export$fa35291248be714f && _ > 1 && "insertCompositionText" === t.inputType && !e.isComposing() && (o.anchor.offset -= _, o._cachedNodes = null, o._cachedIsBackward = null), $3e88191b87395c2e$export$129f916e5a4d8e94 && e.isComposing() && (n.lastKeyDownTimeStamp = 0, $3e88191b87395c2e$export$ea25f5ef71f2d042(null));
        }
    }
    if (!c) $3e88191b87395c2e$var$cl(!1, e, null !== r ? r : void 0), "ending-firefox" === n.compositionPhase && ($3e88191b87395c2e$var$to(e, r || void 0), $3e88191b87395c2e$export$24cab2f466b76c04($3e88191b87395c2e$export$ecc13538534b9f74), n.compositionPhase = "idle");
    return $3e88191b87395c2e$var$nl(), !0;
}
function $3e88191b87395c2e$var$Xn(t) {
    const e = $3e88191b87395c2e$var$gi(), n = e._inputState, o = $3e88191b87395c2e$export$63a3201b3a5c7d90();
    if ($3e88191b87395c2e$export$181b63acea8a0224(o) && !e.isComposing()) {
        n.compositionPhase = "composing", n.hadOrphanedCompositionEvents = !1;
        const r = o.anchor, i = o.anchor.getNode();
        if ($3e88191b87395c2e$export$ea25f5ef71f2d042(r.key), $3e88191b87395c2e$export$24cab2f466b76c04($3e88191b87395c2e$export$98153f24c6e5ae19), t.timeStamp < n.lastKeyDownTimeStamp + 30 || "element" === r.type || !o.isCollapsed() || !$3e88191b87395c2e$export$129f916e5a4d8e94 && (i.getFormat() !== o.format || $3e88191b87395c2e$export$471953706258be2b(i) && i.getStyle() !== o.style) || $3e88191b87395c2e$export$471953706258be2b(i) && ($3e88191b87395c2e$export$8b834332909623ff(i) || 0 === r.offset && !i.canInsertTextBefore() || r.offset === i.getTextContentSize() && !i.canInsertTextAfter())) {
            $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$6f67c758bb657857, $3e88191b87395c2e$var$P);
            const t = $3e88191b87395c2e$export$63a3201b3a5c7d90();
            $3e88191b87395c2e$export$181b63acea8a0224(t) && $3e88191b87395c2e$export$ea25f5ef71f2d042(t.anchor.key);
        }
    }
    return !0;
}
function $3e88191b87395c2e$var$Qn(t) {
    const e = $3e88191b87395c2e$var$gi();
    return e._inputState.compositionPhase = "idle", $3e88191b87395c2e$var$to(e, t.data), $3e88191b87395c2e$export$24cab2f466b76c04($3e88191b87395c2e$export$ecc13538534b9f74), !0;
}
function $3e88191b87395c2e$var$Zn(t) {
    if (null === t) return;
    const e = $3e88191b87395c2e$export$e725f93d4d48c6d8(t);
    if (!$3e88191b87395c2e$export$471953706258be2b(e) || "text" === e.getType() || $3e88191b87395c2e$export$8b834332909623ff(e) || !e.isAttached()) return;
    const n = $3e88191b87395c2e$export$63a3201b3a5c7d90(), o = $3e88191b87395c2e$export$181b63acea8a0224(n) && n.anchor.key === t ? n.anchor.offset : null, r = $3e88191b87395c2e$export$2785f39dcdec0078(e.getTextContent());
    if (r.setFormat(e.getFormat()), r.setStyle(e.getStyle()), e.replace(r), null !== o) {
        const t = Math.min(o, r.getTextContentSize());
        r.select(t, t);
    }
}
function $3e88191b87395c2e$var$to(t, e) {
    const n = t._compositionKey;
    if ($3e88191b87395c2e$export$ea25f5ef71f2d042(null), null !== n && null != e) {
        if ("" === e) {
            const e = $3e88191b87395c2e$export$e725f93d4d48c6d8(n), o = t.getElementByKey(n), r = null !== o && $3e88191b87395c2e$export$471953706258be2b(e) ? $3e88191b87395c2e$export$118c63c491bd7ec(e, o, t) : null;
            if (null !== r && null !== r.nodeValue && $3e88191b87395c2e$export$471953706258be2b(e)) {
                const n = $3e88191b87395c2e$export$74c14770a0819525($3e88191b87395c2e$var$Pl(t)), o = n && $3e88191b87395c2e$export$fca86712f5243a7e(n, t._rootElement);
                let i = null, s = null;
                null !== o && o.anchorNode === r && (i = o.anchorOffset, s = o.focusOffset), $3e88191b87395c2e$var$al(e, r.nodeValue, i, s, !0);
            }
            return $3e88191b87395c2e$var$Zn(n), !1;
        }
        if ("\n" === e[e.length - 1]) {
            const e = $3e88191b87395c2e$export$63a3201b3a5c7d90();
            if ($3e88191b87395c2e$export$181b63acea8a0224(e) || $3e88191b87395c2e$export$7257e4181651a7c3(e)) {
                if ($3e88191b87395c2e$export$181b63acea8a0224(e)) {
                    const t = e.focus;
                    e.anchor.set(t.key, t.offset, t.type);
                }
                return $3e88191b87395c2e$var$kl(t, $3e88191b87395c2e$export$2cdb7cdd6fccb293, null), $3e88191b87395c2e$var$Zn(n), !1;
            }
        }
        const o = $3e88191b87395c2e$export$e725f93d4d48c6d8(n);
        if (null !== o && $3e88191b87395c2e$export$471953706258be2b(o) && $3e88191b87395c2e$export$8b834332909623ff(o)) {
            o.markDirty();
            const t = $3e88191b87395c2e$export$63a3201b3a5c7d90(), r = o.getTextContentSize(), i = $3e88191b87395c2e$export$181b63acea8a0224(t) && t.anchor.key === n ? t.anchor.offset : r;
            return o.select(i, i).insertText(e), !0;
        }
    }
    return $3e88191b87395c2e$var$cl(!0, t, e), $3e88191b87395c2e$var$Zn(n), !1;
}
function $3e88191b87395c2e$var$eo(t) {
    const e = $3e88191b87395c2e$var$gi(), n = e._inputState;
    if (null == t.key) return !0;
    if ("ending-safari" === n.compositionPhase) {
        const o = $3e88191b87395c2e$var$pl(t);
        if (o && $3e88191b87395c2e$var$Mi(e, ()=>{
            $3e88191b87395c2e$var$to(e, n.compositionEndData);
        }), n.compositionPhase = "idle", n.compositionEndData = "", o) return !0;
    }
    if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "ArrowRight", {
            shiftKey: "any"
        });
    }(t)) $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$217ec2281ac1c53b, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "ArrowRight", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $3e88191b87395c2e$var$gl), {
            shiftKey: "any"
        }));
    }(t)) $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$fb3b2d438650aff6, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "ArrowLeft", {
            shiftKey: "any"
        });
    }(t)) $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$7525f8f8ab44508, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "ArrowLeft", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $3e88191b87395c2e$var$gl), {
            shiftKey: "any"
        }));
    }(t)) $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$dc117ee4d661295a, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "ArrowUp", {
            altKey: "any",
            shiftKey: "any"
        });
    }(t)) $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$7833c2a33ae81d3d, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "ArrowDown", {
            altKey: "any",
            shiftKey: "any"
        });
    }(t)) $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$baa60daa2ca402b3, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "Enter", {
            altKey: "any",
            ctrlKey: "any",
            metaKey: "any",
            shiftKey: !0
        });
    }(t)) n.isInsertLineBreak = !0, $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$2cdb7cdd6fccb293, t);
    else if (function(t) {
        return " " === t.key;
    }(t)) $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$d0bc2bb647ce4c17, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$d093bd80dddd0842 && $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "o", {
            ctrlKey: !0
        });
    }(t)) t.preventDefault(), n.isInsertLineBreak = !0, $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$64e35ce26e025724, !0);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "Enter", {
            altKey: "any",
            ctrlKey: "any",
            metaKey: "any"
        });
    }(t)) n.isInsertLineBreak = !1, $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$2cdb7cdd6fccb293, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "Backspace", {
            shiftKey: "any"
        }) || $3e88191b87395c2e$export$d093bd80dddd0842 && $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "h", {
            ctrlKey: !0
        });
    }(t)) $3e88191b87395c2e$var$pl(t) ? $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$24bbba9bfa830f78, t) && $3e88191b87395c2e$var$Vn(n) : (t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$35595bf6d7e36fd5, !0));
    else if (function(t) {
        return "Escape" === t.key;
    }(t)) $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$53589e422a755d59, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "Delete", {}) || $3e88191b87395c2e$export$d093bd80dddd0842 && $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "d", {
            ctrlKey: !0
        });
    }(t)) !function(t) {
        return "Delete" === t.key;
    }(t) ? (t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$35595bf6d7e36fd5, !1)) : $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$13a0e72b5c0146bb, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "Backspace", $3e88191b87395c2e$var$_l);
    }(t)) t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$8e315b175631384c, !0);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "Delete", $3e88191b87395c2e$var$_l);
    }(t)) t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$8e315b175631384c, !1);
    else if (function(t) {
        return $3e88191b87395c2e$export$d093bd80dddd0842 && $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "Backspace", {
            metaKey: !0
        });
    }(t)) t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$d77fad8fb8747fd, !0);
    else if (function(t) {
        return $3e88191b87395c2e$export$d093bd80dddd0842 && ($3e88191b87395c2e$export$56e059fc8d27aa5f(t, "Delete", {
            metaKey: !0
        }) || $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "k", {
            ctrlKey: !0
        }));
    }(t)) t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$d77fad8fb8747fd, !1);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "b", $3e88191b87395c2e$var$gl);
    }(t)) t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$85443a1a9543f043, "bold");
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "u", $3e88191b87395c2e$var$gl);
    }(t)) t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$85443a1a9543f043, "underline");
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "i", $3e88191b87395c2e$var$gl);
    }(t)) t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$85443a1a9543f043, "italic");
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "Tab", {
            shiftKey: "any"
        });
    }(t)) $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$b321bdc226ccdcde, t);
    else if (function(t) {
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "z", $3e88191b87395c2e$var$gl);
    }(t)) t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$34722a4946cb641e, void 0);
    else if (function(t) {
        if ($3e88191b87395c2e$export$d093bd80dddd0842) return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "z", {
            metaKey: !0,
            shiftKey: !0
        });
        return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "y", {
            ctrlKey: !0
        }) || $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "z", {
            ctrlKey: !0,
            shiftKey: !0
        });
    }(t)) t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$8c4a0748d31d9941, void 0);
    else {
        const o = e._editorState._selection;
        !function(t) {
            return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "a", $3e88191b87395c2e$var$gl);
        }(t) ? null === o || $3e88191b87395c2e$export$181b63acea8a0224(o) || (!function(t) {
            return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "c", $3e88191b87395c2e$var$gl);
        }(t) ? function(t) {
            return $3e88191b87395c2e$export$56e059fc8d27aa5f(t, "x", $3e88191b87395c2e$var$gl);
        }(t) && (t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$4dc8a35a083beec4, t)) : (t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$3435fcfb1f59ef96, t))) : (t.preventDefault(), $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$185c218616045e75, t) && $3e88191b87395c2e$var$Vn(n));
    }
    return function(t) {
        return t.ctrlKey || t.shiftKey || t.altKey || t.metaKey;
    }(t) && e.dispatchCommand($3e88191b87395c2e$export$452548a3c1874d61, t), !0;
}
function $3e88191b87395c2e$var$no(t) {
    let e = t.__lexicalEventHandles;
    return void 0 === e && (e = [], t.__lexicalEventHandles = e), e;
}
const $3e88191b87395c2e$var$oo = new Map;
function $3e88191b87395c2e$var$ro(t) {
    const e = $3e88191b87395c2e$export$c8cecd54bd4bdb44(t.target);
    if (null === e) return;
    const n = $3e88191b87395c2e$export$43a91182e77c9b6d(t.target);
    let o = null, r = null;
    const i = null !== n ? $3e88191b87395c2e$var$Kn.get(n) : void 0;
    if (null !== n) {
        if (void 0 !== i) {
            const t = i.editors;
            let n = i.hasShadowEditor;
            if (void 0 === n) {
                n = !1;
                for (const e of t)if (null !== e._rootElement && $3e88191b87395c2e$export$cbad3bd7ce195561(e._rootElement.getRootNode())) {
                    n = !0;
                    break;
                }
                i.hasShadowEditor = n;
            }
            if (n) {
                let n = null, i = null;
                for (const s of t){
                    const t = s._rootElement;
                    if (null === t) continue;
                    const l = $3e88191b87395c2e$export$fca86712f5243a7e(e, t).anchorNode;
                    if (null !== l && $3e88191b87395c2e$export$30c13854ab4c9903(l) === s) {
                        if ($3e88191b87395c2e$export$cbad3bd7ce195561(t.getRootNode())) {
                            o = s, r = l;
                            break;
                        }
                        null === n && (n = s, i = l);
                    }
                }
                null === o && null !== n && (o = n, r = i);
            } else {
                const t = e.anchorNode;
                null === t || $3e88191b87395c2e$export$1b3bfaa9684536aa(t) && null !== t.shadowRoot || (o = $3e88191b87395c2e$export$30c13854ab4c9903(t), null !== o && (r = t));
            }
        }
        if (null === o) {
            const t = $3e88191b87395c2e$export$914ab019e7cf55b0(n);
            o = null !== t ? $3e88191b87395c2e$export$30c13854ab4c9903(t) : null;
        }
    }
    if (null === o) return;
    if (o._inputState.isSelectionChangeFromMouseDown) {
        if (void 0 !== i) for (const t of i.editors)t._inputState.isSelectionChangeFromMouseDown = !1;
        $3e88191b87395c2e$var$Mi(o, ()=>{
            const n = $3e88191b87395c2e$export$846e9407a8b5d98c(), i = r !== null && r !== void 0 ? r : $3e88191b87395c2e$export$fca86712f5243a7e(e, o._rootElement).anchorNode;
            if ($3e88191b87395c2e$export$1b3bfaa9684536aa(i) || $3e88191b87395c2e$export$4295c0f0b9b754c4(i)) $3e88191b87395c2e$export$2aad78c37810bca9($3e88191b87395c2e$var$Ir(n, e, o, t));
        });
    }
    const s = $3e88191b87395c2e$var$il(o), l = s[s.length - 1], c = l._key, a = $3e88191b87395c2e$var$oo.get(c), u = a || l;
    u !== o && $3e88191b87395c2e$var$Wn(e, u, !1), $3e88191b87395c2e$var$Wn(e, o, !0), o !== l ? $3e88191b87395c2e$var$oo.set(c, o) : a && $3e88191b87395c2e$var$oo.delete(c);
}
function $3e88191b87395c2e$export$e066258f9188a34f(t) {
    t._lexicalHandled = !0;
}
function $3e88191b87395c2e$var$so(t) {
    return !0 === t._lexicalHandled;
}
const $3e88191b87395c2e$var$lo = ()=>{};
function $3e88191b87395c2e$var$co(e) {
    const n = $3e88191b87395c2e$var$Ln.get(e);
    if (void 0 === n) return void $3e88191b87395c2e$var$lo();
    const o = $3e88191b87395c2e$var$Kn.get(n);
    if (void 0 === o) return void $3e88191b87395c2e$var$lo();
    $3e88191b87395c2e$var$Ln.delete(e);
    const r = $3e88191b87395c2e$export$40676f02fb121ce2(e);
    $3e88191b87395c2e$export$811e9996da830291(r) ? (!function(t) {
        if (null !== t._parentEditor) {
            const e = $3e88191b87395c2e$var$il(t), n = e[e.length - 1]._key;
            $3e88191b87395c2e$var$oo.get(n) === t && $3e88191b87395c2e$var$oo.delete(n);
        } else $3e88191b87395c2e$var$oo.delete(t._key);
    }(r), o.editors.delete(r), o.hasShadowEditor = void 0, e.__lexicalEditor = null) : r && $3e88191b87395c2e$var$t(198);
    const i = $3e88191b87395c2e$var$no(e);
    for(let t = 0; t < i.length; t++)i[t]();
    e.__lexicalEventHandles = [];
}
function $3e88191b87395c2e$var$ao(e, n, o) {
    $3e88191b87395c2e$var$ui();
    const r = e.__key, i = e.getParent();
    if (null === i) return void (null !== $3e88191b87395c2e$var$Xc(e) && $3e88191b87395c2e$var$t(367, r, String($3e88191b87395c2e$var$Xc(e))));
    const s = function(t) {
        const e = $3e88191b87395c2e$export$63a3201b3a5c7d90();
        if (!$3e88191b87395c2e$export$181b63acea8a0224(e) || !$3e88191b87395c2e$export$923a058ef54437a4(t)) return e;
        const { anchor: n, focus: o } = e, r = n.getNode(), i = o.getNode();
        $3e88191b87395c2e$export$e3d4b782f65c81f1(r, t) && n.set(t.__key, 0, "element");
        $3e88191b87395c2e$export$e3d4b782f65c81f1(i, t) && o.set(t.__key, 0, "element");
        return e;
    }(e);
    let l = !1;
    if ($3e88191b87395c2e$export$181b63acea8a0224(s) && n) {
        const t = s.anchor, n = s.focus;
        t.key === r && ($3e88191b87395c2e$var$Rr(t, e, i, e.getPreviousSibling(), e.getNextSibling()), l = !0), n.key === r && ($3e88191b87395c2e$var$Rr(n, e, i, e.getPreviousSibling(), e.getNextSibling()), l = !0);
    } else $3e88191b87395c2e$export$7257e4181651a7c3(s) && n && e.isSelected() && e.selectPrevious();
    if ($3e88191b87395c2e$export$181b63acea8a0224(s) && n && !l) {
        const t = e.getIndexWithinParent();
        $3e88191b87395c2e$export$37daa10d18442dd6(e), $3e88191b87395c2e$var$zr(s, i, t, -1);
    } else $3e88191b87395c2e$export$37daa10d18442dd6(e);
    o || $3e88191b87395c2e$export$6f851a24c61146af(i) || i.canBeEmpty() || !i.isEmpty() || $3e88191b87395c2e$var$ao(i, n), n && s && $3e88191b87395c2e$export$5b29ca560c2fedab(i) && i.isEmpty() && i.selectEnd();
}
function $3e88191b87395c2e$export$3bd46c0194b0999e(t) {
    return t;
}
const $3e88191b87395c2e$var$fo = Symbol.for("ephemeral");
function $3e88191b87395c2e$var$ho(t) {
    return t[$3e88191b87395c2e$var$fo] || !1;
}
const $3e88191b87395c2e$var$go = {
    configurable: !0,
    enumerable: !1,
    value: void 0,
    writable: !0
};
let $3e88191b87395c2e$var$_Kt = $3e88191b87395c2e$var$Kt;
class $3e88191b87395c2e$var$_o {
    static getType() {
        const { ownNodeType: e } = $3e88191b87395c2e$export$e89f9d0013499fc6(this);
        return void 0 === e && $3e88191b87395c2e$var$t(64, this.name), e;
    }
    static clone(e) {
        $3e88191b87395c2e$var$t(65, this.name);
    }
    $config() {
        return {};
    }
    config(t, e) {
        const n = e.extends || $3e88191b87395c2e$var$Vc(this.constructor);
        return Object.assign(e, {
            extends: n
        }), "string" == typeof t && Object.assign(e, {
            type: t
        }), {
            [t]: e
        };
    }
    afterCloneFrom(t) {
        this.__key === t.__key ? (this.__parent = t.__parent, this.__next = t.__next, this.__prev = t.__prev, this.__state = t.__state) : t.__state && (this.__state = t.__state.getWritable(this));
    }
    resetOnCopyNodeFrom(t) {
        this.__state && (this.__state = this.__state.getWritable(this).resetOnCopyNode());
    }
    getType() {
        return this.__type;
    }
    isInline() {
        $3e88191b87395c2e$var$t(137, this.constructor.name);
    }
    isAttached() {
        let t = this.__key;
        for(; null !== t;){
            if ("root" === t) return !0;
            const e = $3e88191b87395c2e$export$e725f93d4d48c6d8(t);
            if (null === e) break;
            t = null !== e.__parent ? e.__parent : $3e88191b87395c2e$var$Xc(e);
        }
        return !1;
    }
    isSelected(t) {
        const e = t || $3e88191b87395c2e$export$63a3201b3a5c7d90();
        if (null == e) return !1;
        const n = e.getNodes().some((t)=>t.__key === this.__key);
        if ($3e88191b87395c2e$export$471953706258be2b(this)) return n;
        if ($3e88191b87395c2e$export$181b63acea8a0224(e) && "element" === e.anchor.type && "element" === e.focus.type) {
            if (e.isCollapsed()) return !1;
            const t = this.getParent();
            if ($3e88191b87395c2e$export$60aa03725ce41b1c(this) && this.isInline() && t) {
                const n = e.isBackward() ? e.focus : e.anchor;
                if (t.is(n.getNode()) && n.offset === t.getChildrenSize() && this.is(t.getLastChild())) return !1;
            }
        }
        return n;
    }
    getKey() {
        return this.__key;
    }
    getIndexWithinParent() {
        const t = this.getParent();
        if (null === t) return -1;
        let e = t.getFirstChild(), n = 0;
        for(; null !== e;){
            if (this.is(e)) return n;
            n++, e = e.getNextSibling();
        }
        return -1;
    }
    getParent() {
        const t = this.getLatest().__parent;
        return null === t ? null : $3e88191b87395c2e$export$e725f93d4d48c6d8(t);
    }
    getParentOrThrow() {
        const e = this.getParent();
        return null === e && $3e88191b87395c2e$var$t(66, this.__key), e;
    }
    getTopLevelElement() {
        let e = this;
        for(; null !== e;){
            const n = e.getParent();
            if ($3e88191b87395c2e$export$6f851a24c61146af(n) || null !== $3e88191b87395c2e$var$Xc(e)) return $3e88191b87395c2e$export$923a058ef54437a4(e) || e === this && $3e88191b87395c2e$export$60aa03725ce41b1c(e) || $3e88191b87395c2e$var$t(194), e;
            e = n;
        }
        return null;
    }
    getTopLevelElementOrThrow() {
        const e = this.getTopLevelElement();
        return null === e && $3e88191b87395c2e$var$t(67, this.__key), e;
    }
    getParents() {
        const t = [];
        let e = this.getParent();
        for(; null !== e;)t.push(e), e = e.getParent();
        return t;
    }
    getParentKeys() {
        const t = [];
        let e = this.getParent();
        for(; null !== e;)t.push(e.__key), e = e.getParent();
        return t;
    }
    getPreviousSibling() {
        const t = this.getLatest().__prev;
        return null === t ? null : $3e88191b87395c2e$export$e725f93d4d48c6d8(t);
    }
    getPreviousSiblings() {
        const t = [], e = this.getParent();
        if (null === e) return t;
        let n = e.getFirstChild();
        for(; null !== n && !n.is(this);)t.push(n), n = n.getNextSibling();
        return t;
    }
    getNextSibling() {
        const t = this.getLatest().__next;
        return null === t ? null : $3e88191b87395c2e$export$e725f93d4d48c6d8(t);
    }
    getNextSiblings() {
        const t = [];
        let e = this.getNextSibling();
        for(; null !== e;)t.push(e), e = e.getNextSibling();
        return t;
    }
    getCommonAncestor(t) {
        const e = $3e88191b87395c2e$export$923a058ef54437a4(this) ? this : this.getParent(), n = $3e88191b87395c2e$export$923a058ef54437a4(t) ? t : t.getParent(), o = e && n ? $3e88191b87395c2e$export$8e83ae67c400e272(e, n) : null;
        return o ? o.commonAncestor : null;
    }
    is(t) {
        return null != t && this.__key === t.__key;
    }
    isBefore(e) {
        const n = $3e88191b87395c2e$export$8e83ae67c400e272(this, e);
        return null !== n && ("descendant" === n.type || ("branch" === n.type ? -1 === $3e88191b87395c2e$export$a903b6b3a0477995(n) : ("same" !== n.type && "ancestor" !== n.type && $3e88191b87395c2e$var$t(279), !1)));
    }
    isParentOf(t) {
        return $3e88191b87395c2e$export$e3d4b782f65c81f1(t, this);
    }
    getNodesBetween(e) {
        const n = this.isBefore(e), o = [], r = new Set;
        let i = this;
        for(; null !== i;){
            const s = i.__key;
            if (r.has(s) || (r.add(s), o.push(i)), i === e) break;
            const l = $3e88191b87395c2e$export$923a058ef54437a4(i) ? n ? i.getFirstChild() : i.getLastChild() : null;
            if (null !== l) {
                i = l;
                continue;
            }
            const c = n ? i.getNextSibling() : i.getPreviousSibling();
            if (null !== c) {
                i = c;
                continue;
            }
            const a = i.getParentOrThrow();
            if (r.has(a.__key) || o.push(a), a === e) break;
            let u = null, f = a;
            do {
                if (null === f && $3e88191b87395c2e$var$t(68), u = n ? f.getNextSibling() : f.getPreviousSibling(), f = f.getParent(), null === f) break;
                null !== u || r.has(f.__key) || o.push(f);
            }while (null === u);
            i = u;
        }
        return n || o.reverse(), o;
    }
    isDirty() {
        const t = $3e88191b87395c2e$var$gi()._dirtyLeaves;
        return null !== t && t.has(this.__key);
    }
    getLatest() {
        if ($3e88191b87395c2e$var$ho(this)) return this;
        const e = $3e88191b87395c2e$export$e725f93d4d48c6d8(this.__key);
        return null === e && $3e88191b87395c2e$var$t(113), e;
    }
    getWritable() {
        if ($3e88191b87395c2e$var$ho(this)) return this;
        $3e88191b87395c2e$var$ui();
        const t = $3e88191b87395c2e$var$di(), e = $3e88191b87395c2e$var$gi(), n = t._nodeMap, o = this.__key, r = this.getLatest(), i = e._cloneNotNeeded, s = $3e88191b87395c2e$export$63a3201b3a5c7d90();
        if (null !== s && s.setCachedNodes(null), i.has(o)) return $3e88191b87395c2e$var$Hs(r), r;
        const l = $3e88191b87395c2e$export$10b12fb9e226edf0(r);
        return i.add(o), $3e88191b87395c2e$var$Hs(l), n.set(o, l), l;
    }
    getTextContent() {
        return $3e88191b87395c2e$var$ua(this);
    }
    getTextContentSize() {
        return this.getTextContent().length;
    }
    createDOM(e, n) {
        $3e88191b87395c2e$var$t(70);
    }
    updateDOM(e, n, o) {
        $3e88191b87395c2e$var$t(71);
    }
    getDOMSlot(t) {
        return new $3e88191b87395c2e$var$q(t);
    }
    exportDOM(t) {
        return {
            element: this.createDOM(t._config, t)
        };
    }
    exportJSON() {
        const t = this.__state ? this.__state.toJSON() : void 0;
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: this.__type,
            version: 1
        }, t);
    }
    static importJSON(e) {
        $3e88191b87395c2e$var$t(18, this.name);
    }
    updateFromJSON(t) {
        return function(t, e) {
            const n = t.getWritable(), o = e.$;
            let r = o;
            for (const t of $3e88191b87395c2e$var$Nt(n).flatKeys)t in e && (void 0 !== r && r !== o || (r = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, o)), r[t] = e[t]);
            return (n.__state || r) && $3e88191b87395c2e$export$4fd6c21cb0624349(t).updateFromJSON(r), n;
        }(this, t);
    }
    static transform() {
        return null;
    }
    remove(t) {
        $3e88191b87395c2e$var$ao(this, !0, t);
    }
    replace(e, n) {
        $3e88191b87395c2e$var$ui();
        let o = $3e88191b87395c2e$export$63a3201b3a5c7d90();
        null !== o && (o = o.clone()), $3e88191b87395c2e$var$Rl(this, e);
        const r = this.getLatest(), i = this.__key, s = e.__key, l = e.getWritable(), c = this.getParentOrThrow().getWritable(), a = c.__size, u = l.getParent(), f = null !== u ? l.getIndexWithinParent() : -1;
        $3e88191b87395c2e$export$37daa10d18442dd6(l), null !== u && $3e88191b87395c2e$export$181b63acea8a0224(o) && $3e88191b87395c2e$var$zr(o, u, f, -1);
        const d = r.getPreviousSibling(), h = r.getNextSibling(), g = r.__prev, _ = r.__next, p = r.__parent;
        if ($3e88191b87395c2e$var$ao(r, !1, !0), null === d) c.__first = s;
        else d.getWritable().__next = s;
        if (l.__prev = g, null === h) c.__last = s;
        else h.getWritable().__prev = s;
        l.__next = _, l.__parent = p, c.__size = a;
        let y = 0;
        n && ($3e88191b87395c2e$export$923a058ef54437a4(this) && $3e88191b87395c2e$export$923a058ef54437a4(l) || $3e88191b87395c2e$var$t(139), y = l.getChildrenSize(), l.splice(y, 0, this.getChildren()));
        const m = $3e88191b87395c2e$export$c83fc7fbb76e480a(this);
        if (m.length > 0) {
            $3e88191b87395c2e$export$e14ad7e55d229066(this) && $3e88191b87395c2e$export$e14ad7e55d229066(l) || $3e88191b87395c2e$var$t(368, this.__key, l.__key);
            for (const t of m){
                const e = $3e88191b87395c2e$export$ea4162355720819(this, t);
                null !== e && ($3e88191b87395c2e$export$fd9ec12460745091(this, t), $3e88191b87395c2e$export$74e604a6c813bb6f(l, t, e));
            }
        }
        if ($3e88191b87395c2e$export$181b63acea8a0224(o)) {
            $3e88191b87395c2e$export$2aad78c37810bca9(o);
            const t = o.anchor, e = o.focus;
            t.key === i && (n && "element" === t.type ? t.set(l.__key, y + t.offset, "element") : $3e88191b87395c2e$var$ir(t, l)), e.key === i && (n && "element" === e.type ? e.set(l.__key, y + e.offset, "element") : $3e88191b87395c2e$var$ir(e, l));
        }
        return $3e88191b87395c2e$var$js() === i && $3e88191b87395c2e$export$ea25f5ef71f2d042(s), l;
    }
    insertAfter(t, e = !0) {
        $3e88191b87395c2e$var$ui(), $3e88191b87395c2e$var$Rl(this, t);
        const n = this.getWritable(), o = t.getWritable();
        $3e88191b87395c2e$var$_a(this.getParentOrThrow());
        const r = o.getParent(), i = $3e88191b87395c2e$export$63a3201b3a5c7d90();
        let s = !1, l = !1;
        if (null !== r) {
            const n = t.getIndexWithinParent();
            if ($3e88191b87395c2e$export$181b63acea8a0224(i)) {
                const t = r.__key, e = i.anchor, o = i.focus;
                s = "element" === e.type && e.key === t && e.offset === n + 1, l = "element" === o.type && o.key === t && o.offset === n + 1;
            }
            $3e88191b87395c2e$export$37daa10d18442dd6(o), e && $3e88191b87395c2e$export$181b63acea8a0224(i) && $3e88191b87395c2e$var$zr(i, r, n, -1);
        } else $3e88191b87395c2e$export$37daa10d18442dd6(o);
        const c = this.getNextSibling(), a = this.getParentOrThrow().getWritable(), u = o.__key, f = n.__next;
        if (null === c) a.__last = u;
        else c.getWritable().__prev = u;
        if (a.__size++, n.__next = u, o.__next = f, o.__prev = n.__key, o.__parent = n.__parent, e && $3e88191b87395c2e$export$181b63acea8a0224(i)) {
            const t = this.getIndexWithinParent();
            $3e88191b87395c2e$var$zr(i, a, t + 1);
            const e = a.__key;
            s && i.anchor.set(e, t + 2, "element"), l && i.focus.set(e, t + 2, "element");
        }
        return t;
    }
    insertBefore(t, e = !0) {
        $3e88191b87395c2e$var$ui(), $3e88191b87395c2e$var$Rl(this, t);
        const n = this.getWritable(), o = t.getWritable();
        $3e88191b87395c2e$var$_a(this.getParentOrThrow());
        const r = o.__key, i = $3e88191b87395c2e$export$63a3201b3a5c7d90(), s = o.getParent(), l = null !== s ? o.getIndexWithinParent() : -1;
        $3e88191b87395c2e$export$37daa10d18442dd6(o), null !== s && e && $3e88191b87395c2e$export$181b63acea8a0224(i) && $3e88191b87395c2e$var$zr(i, s, l, -1);
        const c = this.getPreviousSibling(), a = this.getParentOrThrow().getWritable(), u = n.__prev, f = this.getIndexWithinParent();
        if (null === c) a.__first = r;
        else c.getWritable().__next = r;
        if (a.__size++, n.__prev = r, o.__prev = u, o.__next = n.__key, o.__parent = n.__parent, e && $3e88191b87395c2e$export$181b63acea8a0224(i)) $3e88191b87395c2e$var$zr(i, this.getParentOrThrow(), f);
        return t;
    }
    isParentRequired() {
        return !1;
    }
    createParentElementNode() {
        return $3e88191b87395c2e$export$7f0c05ffb7ced90d();
    }
    selectStart() {
        return this.selectPrevious();
    }
    selectEnd() {
        return this.selectNext(0, 0);
    }
    selectPrevious(t, e) {
        $3e88191b87395c2e$var$ui();
        const n = $3e88191b87395c2e$export$fe2a41df16bf88cd(this);
        if (null !== n) return n.selectPrevious(t, e);
        const o = this.getPreviousSibling(), r = this.getParentOrThrow();
        if (null === o) return r.select(0, 0);
        if ($3e88191b87395c2e$export$923a058ef54437a4(o)) return o.select();
        if (!$3e88191b87395c2e$export$471953706258be2b(o)) {
            const t = o.getIndexWithinParent() + 1;
            return r.select(t, t);
        }
        return o.select(t, e);
    }
    selectNext(t, e) {
        $3e88191b87395c2e$var$ui();
        const n = $3e88191b87395c2e$export$fe2a41df16bf88cd(this);
        if (null !== n) return n.selectNext(t, e);
        const o = this.getNextSibling(), r = this.getParentOrThrow();
        if (null === o) return r.select();
        if ($3e88191b87395c2e$export$923a058ef54437a4(o)) return o.select(0, 0);
        if (!$3e88191b87395c2e$export$471953706258be2b(o)) {
            const t = o.getIndexWithinParent();
            return r.select(t, t);
        }
        return o.select(t, e);
    }
    markDirty() {
        this.getWritable();
    }
    reconcileObservedMutation(t, e) {
        this.markDirty();
    }
    constructor(t){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__type", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__key", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__parent", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__prev", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__next", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__state", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, $3e88191b87395c2e$var$_Kt, void 0);
        this.__type = this.constructor.getType(), this.__parent = null, this.__prev = null, this.__next = null, Object.defineProperty(this, "__state", $3e88191b87395c2e$var$go), Object.defineProperty(this, $3e88191b87395c2e$var$Kt, $3e88191b87395c2e$var$go), $3e88191b87395c2e$var$Ws(this, t);
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($3e88191b87395c2e$var$_o, "importDOM", void 0);
function $3e88191b87395c2e$export$51639c096d96bcc8(t) {
    return t instanceof $3e88191b87395c2e$var$_o;
}
const $3e88191b87395c2e$export$7581001a764add86 = "historic", $3e88191b87395c2e$export$6387218b6bdcf960 = "history-push", $3e88191b87395c2e$export$b58a9fabaf2a5573 = "history-merge", $3e88191b87395c2e$export$c9fefd1a0f1b33fa = "paste", $3e88191b87395c2e$export$b4b7091df6750ac5 = "cut", $3e88191b87395c2e$export$39d6d771d40857ac = "collaboration", $3e88191b87395c2e$export$4e3790431a2fb29d = "skip-collab", $3e88191b87395c2e$export$e36816488e788f40 = "skip-scroll-into-view", $3e88191b87395c2e$export$2d54a03edd17ad1f = "skip-dom-selection", $3e88191b87395c2e$export$8a1d07d516311732 = "skip-selection-focus", $3e88191b87395c2e$export$98153f24c6e5ae19 = "composition-start", $3e88191b87395c2e$export$ecc13538534b9f74 = "composition-end", $3e88191b87395c2e$var$Oo = "!important";
function $3e88191b87395c2e$export$2ce8a4767ed9993e(t) {
    const e = {};
    if (!t) return e;
    let n = "", o = "", r = null, i = !1, s = !1, l = !1, c = 0;
    const a = t.length;
    let u = -1;
    for(let f = 0; f < a; f++){
        const a = t[f];
        if (i) "*" === a && "/" === t[f + 1] && (i = !1, f++);
        else if (s) -1 === u && (u = f), s = !1;
        else if (null === r) {
            if ("/" !== a || "*" !== t[f + 1]) {
                if ('"' !== a && "'" !== a) {
                    if ("(" !== a) {
                        if (")" !== a) {
                            if (l || ":" !== a || 0 !== c) {
                                if (";" === a && 0 === c) {
                                    -1 !== u && (l ? o += t.slice(u, f) : n += t.slice(u, f), u = -1);
                                    const r = n.trim(), i = o.trim();
                                    "" !== r && "" !== i && (e[r] = i), n = "", o = "", l = !1;
                                    continue;
                                }
                                -1 === u && (u = f);
                            } else -1 !== u && (n += t.slice(u, f), u = -1), l = !0;
                        } else -1 === u && (u = f), c = Math.max(0, c - 1);
                    } else -1 === u && (u = f), c++;
                } else -1 === u && (u = f), r = a;
            } else -1 !== u && (l ? o += t.slice(u, f) : n += t.slice(u, f), u = -1), i = !0, f++;
        } else -1 === u && (u = f), "\\" === a ? s = !0 : a === r && (r = null);
    }
    -1 !== u && (l ? o += t.slice(u, a) : n += t.slice(u, a));
    const f = n.trim(), d = o.trim();
    return "" !== f && "" !== d && (e[f] = d), e;
}
function $3e88191b87395c2e$var$Ao(t, e, n) {
    const o = n.trimEnd(), r = o.length - 10;
    r >= 0 && o.slice(r).toLowerCase() === $3e88191b87395c2e$var$Oo ? t.setProperty(e, o.slice(0, r).trim(), "important") : t.setProperty(e, n, "");
}
function $3e88191b87395c2e$export$4eb12230f262dbad(t, e) {
    for(const n in e){
        const o = e[n];
        null == o ? t.removeProperty(n) : $3e88191b87395c2e$var$Ao(t, n, o);
    }
}
function $3e88191b87395c2e$export$742e98a31b68d917(t, e, n = "") {
    if (e === n) return;
    const o = $3e88191b87395c2e$export$2ce8a4767ed9993e(n), r = $3e88191b87395c2e$export$2ce8a4767ed9993e(e);
    for(const e in r)delete o[e], $3e88191b87395c2e$var$Ao(t, e, r[e]);
    for(const e in o)t.removeProperty(e);
}
function $3e88191b87395c2e$var$Fo(t, e) {
    return 16 & e ? "code" : e & $3e88191b87395c2e$export$f1e9b55cdd671814 ? "mark" : 32 & e ? "sub" : 64 & e ? "sup" : null;
}
function $3e88191b87395c2e$var$Io(t, e) {
    return 1 & e ? "strong" : 2 & e ? "em" : "span";
}
function $3e88191b87395c2e$var$Lo(t, e, n, o, r) {
    const i = o.classList;
    let s = $3e88191b87395c2e$var$ml(r, "base");
    void 0 !== s && i.add(...s), s = $3e88191b87395c2e$var$ml(r, "underlineStrikethrough");
    let l = !1;
    const c = 8 & e && 4 & e;
    void 0 !== s && (8 & n && 4 & n ? (l = !0, c || i.add(...s)) : c && i.remove(...s));
    for(const t in $3e88191b87395c2e$export$c9e7d6eb65b13430){
        const o = $3e88191b87395c2e$export$c9e7d6eb65b13430[t];
        if (s = $3e88191b87395c2e$var$ml(r, t), void 0 !== s) {
            if (n & o) {
                if (l && ("underline" === t || "strikethrough" === t)) {
                    e & o && i.remove(...s);
                    continue;
                }
                (0 === (e & o) || c && "underline" === t || "strikethrough" === t) && i.add(...s);
            } else e & o && i.remove(...s);
        }
    }
}
function $3e88191b87395c2e$var$Ko(t, e, n) {
    const o = n.isComposing(), r = t + (o ? $3e88191b87395c2e$var$A : ""), s = $3e88191b87395c2e$export$8a7392c46faf1a3f(), l = $3e88191b87395c2e$export$cee5aec8bb4a87d6(s).$getDOMSlot(n, e, s), c = l.getFirstChild();
    if (null === c || c.nodeType !== Node.TEXT_NODE) return void l.insertChild($3e88191b87395c2e$export$db1ba3824aa1e742().createTextNode(r));
    const a = c, u = a.nodeValue;
    if (u !== r) {
        if (o || $3e88191b87395c2e$export$fa35291248be714f) {
            const [t, e, n] = function(t, e) {
                const n = t.length, o = e.length;
                let r = 0, i = 0;
                for(; r < n && r < o && t[r] === e[r];)r++;
                for(; i + r < n && i + r < o && t[n - i - 1] === e[o - i - 1];)i++;
                return [
                    r,
                    n - r - i,
                    e.slice(r, o - i)
                ];
            }(u, r);
            0 !== e && a.deleteData(t, e), a.insertData(t, n);
        } else a.nodeValue = r;
    }
}
function $3e88191b87395c2e$var$zo(t, e, n, o, r, i) {
    $3e88191b87395c2e$var$Ko(r, t, e);
    const s = i.theme.text;
    void 0 !== s && $3e88191b87395c2e$var$Lo(0, 0, o, t, s);
}
function $3e88191b87395c2e$var$Bo(t, e) {
    const n = $3e88191b87395c2e$export$db1ba3824aa1e742().createElement(e);
    return n.appendChild(t), n;
}
function $3e88191b87395c2e$export$9dd2963cec3c9590(t) {
    return null != t && !0 === t.__isInlineFormattable;
}
class $3e88191b87395c2e$export$f0a25ea3087686aa extends $3e88191b87395c2e$var$_o {
    get __isInlineFormattable() {
        return !0;
    }
    static getType() {
        return "text";
    }
    static clone(t) {
        return new $3e88191b87395c2e$export$f0a25ea3087686aa(t.__text, t.__key);
    }
    afterCloneFrom(t) {
        super.afterCloneFrom(t), this.__text = t.__text, this.__format = t.__format, this.__style = t.__style, this.__mode = t.__mode, this.__detail = t.__detail;
    }
    getFormat() {
        return this.getLatest().__format;
    }
    getDetail() {
        return this.getLatest().__detail;
    }
    getMode() {
        const t = this.getLatest();
        return $3e88191b87395c2e$var$$[t.__mode];
    }
    getStyle() {
        return this.getLatest().__style;
    }
    isToken() {
        return 1 === this.getLatest().__mode;
    }
    isComposing() {
        return this.__key === $3e88191b87395c2e$var$js();
    }
    isSegmented() {
        return 2 === this.getLatest().__mode;
    }
    isDirectionless() {
        return !!(1 & this.getLatest().__detail);
    }
    isUnmergeable() {
        return !!(2 & this.getLatest().__detail);
    }
    hasFormat(t) {
        const e = $3e88191b87395c2e$export$c9e7d6eb65b13430[t];
        return 0 !== (this.getFormat() & e);
    }
    isSimpleText() {
        return "text" === this.__type && 0 === this.__mode;
    }
    getTextContent() {
        return this.getLatest().__text;
    }
    getFormatFlags(t, e) {
        return $3e88191b87395c2e$export$bfd35cbfa01f02e5(this.getLatest().__format, t, e);
    }
    canHaveFormat() {
        return !0;
    }
    isInline() {
        return !0;
    }
    createDOM(t, e) {
        const n = this.__format, o = $3e88191b87395c2e$var$Fo(0, n), r = $3e88191b87395c2e$var$Io(0, n), i = null === o ? r : o, s = $3e88191b87395c2e$export$db1ba3824aa1e742().createElement(i);
        let l = s;
        this.hasFormat("code") && s.setAttribute("spellcheck", "false"), null !== o && (l = $3e88191b87395c2e$export$db1ba3824aa1e742().createElement(r), s.appendChild(l));
        $3e88191b87395c2e$var$zo(l, this, 0, n, this.__text, t);
        const c = this.__style;
        return "" !== c && $3e88191b87395c2e$export$742e98a31b68d917(s.style, c), s;
    }
    updateDOM(e, n, o) {
        const r = this.__text, i = e.__format, s = this.__format, l = $3e88191b87395c2e$var$Fo(0, i), c = $3e88191b87395c2e$var$Fo(0, s), a = $3e88191b87395c2e$var$Io(0, i), u = $3e88191b87395c2e$var$Io(0, s);
        if ((null === l ? a : l) !== (null === c ? u : c)) return !0;
        if (l === c && a !== u) {
            const e = n.firstChild;
            null == e && $3e88191b87395c2e$var$t(48);
            const i = $3e88191b87395c2e$export$db1ba3824aa1e742().createElement(u);
            return $3e88191b87395c2e$var$zo(i, this, 0, s, r, o), n.replaceChild(i, e), !1;
        }
        let f = n;
        null !== c && null !== l && (f = n.firstChild, null == f && $3e88191b87395c2e$var$t(49)), $3e88191b87395c2e$var$Ko(r, f, this);
        const d = o.theme.text;
        void 0 !== d && i !== s && $3e88191b87395c2e$var$Lo(0, i, s, f, d);
        const h = e.__style, g = this.__style;
        return h !== g && $3e88191b87395c2e$export$742e98a31b68d917(n.style, g, h), !1;
    }
    static importDOM() {
        return {
            "#text": ()=>({
                    conversion: $3e88191b87395c2e$var$jo,
                    priority: 0
                }),
            b: ()=>({
                    conversion: $3e88191b87395c2e$var$$o,
                    priority: 0
                }),
            code: ()=>({
                    conversion: $3e88191b87395c2e$var$Yo,
                    priority: 0
                }),
            em: ()=>({
                    conversion: $3e88191b87395c2e$var$Yo,
                    priority: 0
                }),
            i: ()=>({
                    conversion: $3e88191b87395c2e$var$Yo,
                    priority: 0
                }),
            mark: ()=>({
                    conversion: $3e88191b87395c2e$var$Yo,
                    priority: 0
                }),
            s: ()=>({
                    conversion: $3e88191b87395c2e$var$Yo,
                    priority: 0
                }),
            span: ()=>({
                    conversion: $3e88191b87395c2e$var$Uo,
                    priority: 0
                }),
            strong: ()=>({
                    conversion: $3e88191b87395c2e$var$Yo,
                    priority: 0
                }),
            sub: ()=>({
                    conversion: $3e88191b87395c2e$var$Yo,
                    priority: 0
                }),
            sup: ()=>({
                    conversion: $3e88191b87395c2e$var$Yo,
                    priority: 0
                }),
            u: ()=>({
                    conversion: $3e88191b87395c2e$var$Yo,
                    priority: 0
                })
        };
    }
    static importJSON(t) {
        return $3e88191b87395c2e$export$2785f39dcdec0078().updateFromJSON(t);
    }
    updateFromJSON(t) {
        return super.updateFromJSON(t).setTextContent(t.text).setFormat(t.format).setDetail(t.detail).setMode(t.mode).setStyle(t.style);
    }
    exportDOM(e) {
        let { element: n } = super.exportDOM(e);
        return $3e88191b87395c2e$export$1b3bfaa9684536aa(n) || $3e88191b87395c2e$var$t(132), n.style.whiteSpace = "pre-wrap", this.hasFormat("lowercase") ? n.style.textTransform = "lowercase" : this.hasFormat("uppercase") ? n.style.textTransform = "uppercase" : this.hasFormat("capitalize") && (n.style.textTransform = "capitalize"), this.hasFormat("bold") && (n = $3e88191b87395c2e$var$Bo(n, "b")), this.hasFormat("italic") && (n = $3e88191b87395c2e$var$Bo(n, "i")), this.hasFormat("strikethrough") && (n = $3e88191b87395c2e$var$Bo(n, "s")), this.hasFormat("underline") && (n = $3e88191b87395c2e$var$Bo(n, "u")), {
            element: n
        };
    }
    exportJSON() {
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            detail: this.getDetail(),
            format: this.getFormat(),
            mode: this.getMode(),
            style: this.getStyle(),
            text: this.getTextContent()
        }, super.exportJSON());
    }
    selectionTransform(t, e) {}
    setFormat(t) {
        const e = this.getWritable();
        return e.__format = "string" == typeof t ? $3e88191b87395c2e$export$c9e7d6eb65b13430[t] : t, e;
    }
    setDetail(t) {
        const e = this.getWritable();
        return e.__detail = "string" == typeof t ? $3e88191b87395c2e$var$B[t] : t, e;
    }
    setStyle(t) {
        const e = this.getWritable();
        return e.__style = t, e;
    }
    toggleFormat(t) {
        const e = $3e88191b87395c2e$export$bfd35cbfa01f02e5(this.getFormat(), t, null);
        return this.setFormat(e);
    }
    toggleDirectionless() {
        const t = this.getWritable();
        return t.__detail ^= 1, t;
    }
    toggleUnmergeable() {
        const t = this.getWritable();
        return t.__detail ^= 2, t;
    }
    setMode(t) {
        const e = $3e88191b87395c2e$var$U[t];
        if (this.__mode === e) return this;
        const n = this.getWritable();
        return n.__mode = e, n;
    }
    setTextContent(t) {
        if (this.__text === t) return this;
        const e = this.getWritable();
        return e.__text = t, e;
    }
    select(t, e) {
        $3e88191b87395c2e$var$ui();
        let n = t, o = e;
        const r = $3e88191b87395c2e$export$63a3201b3a5c7d90(), i = this.getTextContent(), s = this.__key;
        if ("string" == typeof i) {
            const t = i.length;
            void 0 === n && (n = t), void 0 === o && (o = t);
        } else n = 0, o = 0;
        if (!$3e88191b87395c2e$export$181b63acea8a0224(r)) return $3e88191b87395c2e$var$Ar(s, n, s, o, "text", "text");
        {
            const t = $3e88191b87395c2e$var$js();
            t !== r.anchor.key && t !== r.focus.key || $3e88191b87395c2e$export$ea25f5ef71f2d042(s), r.setTextNodeRange(this, n, this, o);
        }
        return r;
    }
    selectStart() {
        return this.select(0, 0);
    }
    selectEnd() {
        const t = this.getTextContentSize();
        return this.select(t, t);
    }
    spliceText(t, e, n, o) {
        const r = this.getWritable(), i = r.__text, s = n.length;
        let l = t;
        l < 0 && (l = s + l, l < 0 && (l = 0));
        const c = $3e88191b87395c2e$export$63a3201b3a5c7d90();
        if (o && $3e88191b87395c2e$export$181b63acea8a0224(c)) {
            const e = t + s;
            c.setTextNodeRange(r, e, r, e);
        }
        const a = i.slice(0, l) + n + i.slice(l + e);
        return r.__text = a, r;
    }
    canInsertTextBefore() {
        return !0;
    }
    canInsertTextAfter() {
        return !0;
    }
    splitText(...t) {
        $3e88191b87395c2e$var$ui();
        const e = this.getLatest(), n = e.getTextContent();
        if ("" === n) return [];
        const o = e.__key, r = $3e88191b87395c2e$var$js(), i = n.length;
        t.sort((t, e)=>t - e), t.push(i);
        const s = [], l = t.length;
        for(let e = 0, o = 0; e < i && o <= l; o++){
            const r = t[o];
            r > e && (s.push(n.slice(e, r)), e = r);
        }
        const c = s.length;
        if (1 === c) return [
            e
        ];
        const a = s[0], u = e.getParent();
        let f;
        const d = e.getFormat(), h = e.getStyle(), g = e.__detail;
        let _ = !1, p = null, y = null;
        const m = $3e88191b87395c2e$export$63a3201b3a5c7d90();
        if ($3e88191b87395c2e$export$181b63acea8a0224(m)) {
            const [t, e] = m.isBackward() ? [
                m.focus,
                m.anchor
            ] : [
                m.anchor,
                m.focus
            ];
            "text" === t.type && t.key === o && (p = t), "text" === e.type && e.key === o && (y = e);
        }
        e.isSegmented() ? (f = $3e88191b87395c2e$export$2785f39dcdec0078(a), f.__format = d, f.__style = h, f.__detail = g, f.__state = $3e88191b87395c2e$var$At(e, f), _ = !0) : f = e.setTextContent(a);
        const x = [
            f
        ];
        for(let t = 1; t < c; t++){
            const n = $3e88191b87395c2e$export$2785f39dcdec0078(s[t]);
            n.__format = d, n.__style = h, n.__detail = g, n.__state = $3e88191b87395c2e$var$At(e, n);
            const i = n.__key;
            r === o && $3e88191b87395c2e$export$ea25f5ef71f2d042(i), x.push(n);
        }
        const C = p ? p.offset : null, S = y ? y.offset : null;
        let v = 0;
        for (const t of x){
            if (!p && !y) break;
            const e = v + t.getTextContentSize();
            if (null !== p && null !== C && C <= e && C >= v && (p.set(t.getKey(), C - v, "text"), C < e && (p = null)), null !== y && null !== S && S <= e && S >= v) {
                y.set(t.getKey(), S - v, "text");
                break;
            }
            v = e;
        }
        if (null !== u) {
            !function(t) {
                const e = t.getPreviousSibling(), n = t.getNextSibling();
                null !== e && $3e88191b87395c2e$var$Hs(e);
                null !== n && $3e88191b87395c2e$var$Hs(n);
            }(this);
            const t = u.getWritable(), e = this.getIndexWithinParent();
            _ ? (t.splice(e, 0, x), this.remove()) : t.splice(e, 1, x), $3e88191b87395c2e$export$181b63acea8a0224(m) && $3e88191b87395c2e$var$zr(m, u, e, c - 1);
        }
        return x;
    }
    mergeWithSibling(e) {
        const n = e === this.getPreviousSibling();
        n || e === this.getNextSibling() || $3e88191b87395c2e$var$t(50);
        const o = this.__key, r = e.__key, i = this.__text, s = i.length;
        $3e88191b87395c2e$var$js() === r && $3e88191b87395c2e$export$ea25f5ef71f2d042(o);
        const l = $3e88191b87395c2e$export$63a3201b3a5c7d90();
        if ($3e88191b87395c2e$export$181b63acea8a0224(l)) {
            const t = l.anchor, i = l.focus;
            null !== t && t.key === r && $3e88191b87395c2e$var$Wr(t, n, o, e, s), null !== i && i.key === r && $3e88191b87395c2e$var$Wr(i, n, o, e, s);
        }
        const c = e.__text, a = n ? c + i : i + c;
        this.setTextContent(a);
        const u = this.getWritable();
        return e.remove(), u;
    }
    isTextEntity() {
        return !1;
    }
    constructor(t = "", e){
        super(e), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__text", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__format", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__style", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__mode", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__detail", void 0), this.__text = t, this.__format = 0, this.__style = "", this.__mode = 0, this.__detail = 0;
    }
}
function $3e88191b87395c2e$var$Uo(t) {
    return {
        forChild: $3e88191b87395c2e$var$Qo(t.style),
        node: null
    };
}
function $3e88191b87395c2e$var$$o(t) {
    const e = t, n = "normal" === e.style.fontWeight;
    return {
        forChild: $3e88191b87395c2e$var$Qo(e.style, n ? void 0 : "bold"),
        node: null
    };
}
const $3e88191b87395c2e$var$Ho = new WeakMap;
function $3e88191b87395c2e$var$Jo(t) {
    if (!$3e88191b87395c2e$export$1b3bfaa9684536aa(t)) return !1;
    if ("PRE" === t.nodeName) return !0;
    const e = t.style.whiteSpace;
    return "string" == typeof e && e.startsWith("pre");
}
function $3e88191b87395c2e$var$jo(e) {
    const n = e;
    null === e.parentElement && $3e88191b87395c2e$var$t(129);
    let o = n.textContent || "";
    if (null !== function(t) {
        let e, n = t.parentNode;
        const o = [
            t
        ];
        for(; null !== n && void 0 === (e = $3e88191b87395c2e$var$Ho.get(n)) && !$3e88191b87395c2e$var$Jo(n);)o.push(n), n = n.parentNode;
        const r = void 0 === e ? n : e;
        for(let t = 0; t < o.length; t++)$3e88191b87395c2e$var$Ho.set(o[t], r);
        return r;
    }(n)) return {
        node: $3e88191b87395c2e$export$34f16fe1ef81eac4(o)
    };
    if (o = o.replace(/\r/g, "").replace(/[ \t\n]+/g, " "), "" === o) return {
        node: null
    };
    if (" " === o[0]) {
        let t = n, e = !0;
        for(; null !== t && null !== (t = $3e88191b87395c2e$var$Vo(t, !1));){
            const n = t.textContent || "";
            if (n.length > 0) {
                /[ \t\n]$/.test(n) && (o = o.slice(1)), e = !1;
                break;
            }
        }
        e && (o = o.slice(1));
    }
    if (" " === o[o.length - 1]) {
        let t = n, e = !0;
        for(; null !== t && null !== (t = $3e88191b87395c2e$var$Vo(t, !0));)if ((t.textContent || "").replace(/^( |\t|\r?\n)+/, "").length > 0) {
            e = !1;
            break;
        }
        e && (o = o.slice(0, o.length - 1));
    }
    return "" === o ? {
        node: null
    } : {
        node: $3e88191b87395c2e$export$2785f39dcdec0078(o)
    };
}
function $3e88191b87395c2e$var$Vo(t, e) {
    let n = t;
    for(;;){
        let t;
        for(; null === (t = e ? n.nextSibling : n.previousSibling);){
            const t = n.parentElement;
            if (null === t) return null;
            n = t;
        }
        if (n = t, $3e88191b87395c2e$export$1b3bfaa9684536aa(n)) {
            const t = n.style.display;
            if ("" === t && !$3e88191b87395c2e$export$456fd4e5e0a7123d(n) || "" !== t && !t.startsWith("inline")) return null;
        }
        let o = n;
        for(; null !== (o = e ? n.firstChild : n.lastChild);)n = o;
        if ($3e88191b87395c2e$export$4295c0f0b9b754c4(n)) return n;
        if ("BR" === n.nodeName) return null;
    }
}
const $3e88191b87395c2e$var$qo = {
    code: "code",
    em: "italic",
    i: "italic",
    mark: "highlight",
    s: "strikethrough",
    strong: "bold",
    sub: "subscript",
    sup: "superscript",
    u: "underline"
};
function $3e88191b87395c2e$var$Yo(t) {
    const e = $3e88191b87395c2e$var$qo[t.nodeName.toLowerCase()];
    return void 0 === e ? {
        node: null
    } : {
        forChild: $3e88191b87395c2e$var$Qo(t.style, e),
        node: null
    };
}
function $3e88191b87395c2e$export$2785f39dcdec0078(t = "") {
    return $3e88191b87395c2e$export$2f5beb31df92ea57(new $3e88191b87395c2e$export$f0a25ea3087686aa(t));
}
function $3e88191b87395c2e$export$471953706258be2b(t) {
    return t instanceof $3e88191b87395c2e$export$f0a25ea3087686aa;
}
function $3e88191b87395c2e$var$Qo(t, e) {
    const n = t.fontWeight, o = t.textDecoration.split(" "), r = "700" === n || "bold" === n, i = o.includes("line-through"), s = "italic" === t.fontStyle, l = o.includes("underline"), c = t.verticalAlign;
    return (t)=>$3e88191b87395c2e$export$471953706258be2b(t) || $3e88191b87395c2e$export$9dd2963cec3c9590(t) ? (r && !t.hasFormat("bold") && t.toggleFormat("bold"), i && !t.hasFormat("strikethrough") && t.toggleFormat("strikethrough"), s && !t.hasFormat("italic") && t.toggleFormat("italic"), l && !t.hasFormat("underline") && t.toggleFormat("underline"), "sub" !== c || t.hasFormat("subscript") || t.toggleFormat("subscript"), "super" !== c || t.hasFormat("superscript") || t.toggleFormat("superscript"), e && !t.hasFormat(e) && t.toggleFormat(e), t) : t;
}
class $3e88191b87395c2e$export$8dbf7edd89edc19c extends $3e88191b87395c2e$export$f0a25ea3087686aa {
    static getType() {
        return "tab";
    }
    static clone(t) {
        return new $3e88191b87395c2e$export$8dbf7edd89edc19c(t.__key);
    }
    static importDOM() {
        return null;
    }
    createDOM(t) {
        const e = super.createDOM(t), n = $3e88191b87395c2e$var$ml(t.theme, "tab");
        if (void 0 !== n) e.classList.add(...n);
        return e;
    }
    static importJSON(t) {
        return $3e88191b87395c2e$export$5bde9d58a1da0796().updateFromJSON(t);
    }
    setTextContent(t) {
        return super.setTextContent("\t");
    }
    spliceText(e, n, o, r) {
        return "" === o && 0 === n || "\t" === o && 1 === n || $3e88191b87395c2e$var$t(286), this;
    }
    setDetail(e) {
        return 2 !== e && $3e88191b87395c2e$var$t(127), this;
    }
    setMode(e) {
        return "normal" !== e && $3e88191b87395c2e$var$t(128), this;
    }
    canInsertTextBefore() {
        return !1;
    }
    canInsertTextAfter() {
        return !1;
    }
    constructor(t){
        super("\t", t), this.__detail = 2;
    }
}
function $3e88191b87395c2e$export$5bde9d58a1da0796() {
    return $3e88191b87395c2e$export$2f5beb31df92ea57(new $3e88191b87395c2e$export$8dbf7edd89edc19c);
}
function $3e88191b87395c2e$export$ac9141efa5fb7932(t) {
    return t instanceof $3e88191b87395c2e$export$8dbf7edd89edc19c;
}
class $3e88191b87395c2e$var$nr {
    is(t) {
        return this.key === t.key && this.offset === t.offset && this.type === t.type;
    }
    isBefore(t) {
        if (this.key === t.key) return this.offset < t.offset;
        return $3e88191b87395c2e$export$cfa5c948dc0495fa($3e88191b87395c2e$export$33e015e8f2ff8536($3e88191b87395c2e$export$e435a0def9eb2000(this, "next")), $3e88191b87395c2e$export$33e015e8f2ff8536($3e88191b87395c2e$export$e435a0def9eb2000(t, "next"))) < 0;
    }
    getNode() {
        const e = $3e88191b87395c2e$export$e725f93d4d48c6d8(this.key);
        return null === e && $3e88191b87395c2e$var$t(20), e;
    }
    set(t, e, n, o) {
        const r = this._selection, i = this.key;
        o && this.key === t && this.offset === e && this.type === n || (this.key = t, this.offset = e, this.type = n, $3e88191b87395c2e$export$761df28585b755e8() || ($3e88191b87395c2e$var$js() === i && $3e88191b87395c2e$export$ea25f5ef71f2d042(t), null !== r && (r.setCachedNodes(null), $3e88191b87395c2e$export$181b63acea8a0224(r) && (r._cachedIsBackward = null), r.dirty = !0)));
    }
    constructor(t, e, n){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "key", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "offset", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "type", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_selection", void 0);
        this._selection = null, this.key = t, this.offset = e, this.type = n;
    }
}
function $3e88191b87395c2e$export$9b3f8d373c057995(t, e, n) {
    return new $3e88191b87395c2e$var$nr(t, e, n);
}
function $3e88191b87395c2e$var$rr(t, e) {
    let n = e.__key, o = t.offset, r = "element";
    if ($3e88191b87395c2e$export$471953706258be2b(e)) {
        r = "text";
        const t = e.getTextContentSize();
        o > t && (o = t);
    } else if (!$3e88191b87395c2e$export$923a058ef54437a4(e)) {
        const t = e.getNextSibling();
        if ($3e88191b87395c2e$export$471953706258be2b(t)) n = t.__key, o = 0, r = "text";
        else {
            const t = e.getParent();
            t && (n = t.__key, o = e.getIndexWithinParent() + 1);
        }
    }
    t.set(n, o, r);
}
function $3e88191b87395c2e$var$ir(t, e) {
    if ($3e88191b87395c2e$export$923a058ef54437a4(e)) {
        const n = e.getLastDescendant();
        $3e88191b87395c2e$export$923a058ef54437a4(n) || $3e88191b87395c2e$export$471953706258be2b(n) ? $3e88191b87395c2e$var$rr(t, n) : $3e88191b87395c2e$var$rr(t, e);
    } else $3e88191b87395c2e$var$rr(t, e);
}
class $3e88191b87395c2e$var$sr {
    getCachedNodes() {
        return this._cachedNodes;
    }
    setCachedNodes(t) {
        this._cachedNodes = t;
    }
    is(t) {
        if (!$3e88191b87395c2e$export$7257e4181651a7c3(t)) return !1;
        const e = this._nodes, n = t._nodes;
        return e.size === n.size && Array.from(e).every((t)=>n.has(t));
    }
    isCollapsed() {
        return !1;
    }
    isBackward() {
        return !1;
    }
    getStartEndPoints() {
        return null;
    }
    add(t) {
        this.dirty = !0, this._nodes.add(t), this._cachedNodes = null;
    }
    delete(t) {
        this.dirty = !0, this._nodes.delete(t), this._cachedNodes = null;
    }
    clear() {
        this.dirty = !0, this._nodes.clear(), this._cachedNodes = null;
    }
    has(t) {
        return this._nodes.has(t);
    }
    clone() {
        return new $3e88191b87395c2e$var$sr(new Set(this._nodes));
    }
    extract() {
        return this.getNodes();
    }
    insertRawText(t) {}
    insertText() {}
    insertNodes(t) {
        const e = this.getNodes().filter((t)=>null === $3e88191b87395c2e$var$Xc(t)), n = e.length;
        if (0 === n) return;
        const o = e[n - 1];
        let r;
        if ($3e88191b87395c2e$export$471953706258be2b(o)) r = o.select();
        else {
            const t = o.getIndexWithinParent() + 1;
            r = o.getParentOrThrow().select(t, t);
        }
        r.insertNodes(t);
        for(let t = 0; t < n; t++)e[t].remove();
    }
    getNodes() {
        const t = this._cachedNodes;
        if (null !== t) return t;
        const e = this._nodes, n = [];
        for (const t of e){
            const e = $3e88191b87395c2e$export$e725f93d4d48c6d8(t);
            null !== e && n.push(e);
        }
        return $3e88191b87395c2e$export$761df28585b755e8() || (this._cachedNodes = n), n;
    }
    getTextContent() {
        const t = this.getNodes();
        let e = "";
        for(let n = 0; n < t.length; n++)e += t[n].getTextContent();
        return e;
    }
    deleteNodes() {
        const t = this.getNodes().filter((t)=>null === $3e88191b87395c2e$var$Xc(t));
        if (($3e88191b87395c2e$export$63a3201b3a5c7d90() || $3e88191b87395c2e$export$846e9407a8b5d98c()) === this && t[0]) {
            const e = $3e88191b87395c2e$export$cdd98497d9dc1de9(t[0], "next");
            $3e88191b87395c2e$export$9fb698110f44889d($3e88191b87395c2e$export$36f672915982afb2(e, e));
        }
        for (const e of t)e.remove();
        $3e88191b87395c2e$var$lr();
    }
    constructor(t){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_nodes", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_cachedNodes", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "dirty", void 0);
        this._cachedNodes = null, this._nodes = t, this.dirty = !1;
    }
}
function $3e88191b87395c2e$var$lr() {
    const t = $3e88191b87395c2e$export$8d83ea843c4eea9a();
    if (t.isEmpty()) {
        const e = $3e88191b87395c2e$export$7f0c05ffb7ced90d();
        t.append(e), e.select();
    }
}
function $3e88191b87395c2e$export$181b63acea8a0224(t) {
    return t instanceof $3e88191b87395c2e$var$ar;
}
class $3e88191b87395c2e$var$ar {
    getCachedNodes() {
        return this._cachedNodes;
    }
    setCachedNodes(t) {
        this._cachedNodes = t;
    }
    is(t) {
        return !!$3e88191b87395c2e$export$181b63acea8a0224(t) && this.anchor.is(t.anchor) && this.focus.is(t.focus) && this.format === t.format && this.style === t.style;
    }
    isCollapsed() {
        return this.anchor.is(this.focus);
    }
    getNodes() {
        const t = this._cachedNodes;
        if (null !== t) return t;
        const e = function(t) {
            const e = [], [n, o] = t.getTextSlices();
            n && e.push(n.caret.origin);
            const r = new Set, i = new Set;
            for (const n of t)if ($3e88191b87395c2e$export$1c3da6f3e60ca260(n)) {
                const { origin: t } = n;
                0 === e.length ? r.add(t) : (i.add(t), e.push(t));
            } else {
                const { origin: t } = n;
                $3e88191b87395c2e$export$923a058ef54437a4(t) && i.has(t) || e.push(t);
            }
            o && e.push(o.caret.origin);
            if ($3e88191b87395c2e$export$3bcd9a2637e8506e(t.focus) && $3e88191b87395c2e$export$923a058ef54437a4(t.focus.origin) && null === t.focus.getNodeAtCaret()) for(let n = $3e88191b87395c2e$export$19f6ef5eb31488f9(t.focus.origin, "previous"); $3e88191b87395c2e$export$1c3da6f3e60ca260(n) && r.has(n.origin) && !n.origin.isEmpty() && n.origin.is(e[e.length - 1]); n = $3e88191b87395c2e$export$17eea20b564ca4ca(n))r.delete(n.origin), e.pop();
            for(; e.length > 1;){
                const t = e[e.length - 1];
                if (!$3e88191b87395c2e$export$923a058ef54437a4(t) || i.has(t) || t.isEmpty() || r.has(t)) break;
                e.pop();
            }
            if (0 === e.length && t.isCollapsed()) {
                const n = $3e88191b87395c2e$export$33e015e8f2ff8536(t.anchor), o = $3e88191b87395c2e$export$33e015e8f2ff8536(t.anchor.getFlipped()), r = (t)=>$3e88191b87395c2e$export$6d8c68034bda7a85(t) ? t.origin : t.getNodeAtCaret(), i = r(n) || r(o) || (t.anchor.getNodeAtCaret() ? n.origin : o.origin);
                e.push(i);
            }
            return e;
        }($3e88191b87395c2e$export$b6aa34707ffda54a($3e88191b87395c2e$export$7bcaa61bc56938bf(this), "next"));
        return $3e88191b87395c2e$export$761df28585b755e8() || (this._cachedNodes = e), e;
    }
    setTextNodeRange(t, e, n, o) {
        return this.anchor.set(t.__key, e, "text"), this.focus.set(n.__key, o, "text"), this;
    }
    getTextContent() {
        const t = this.getNodes();
        if (0 === t.length) return "";
        const e = t[0], n = t[t.length - 1], o = this.anchor, r = this.focus, i = o.isBefore(r), [s, l] = $3e88191b87395c2e$export$5a33b5b9a9d5db8f(this);
        let c = "", a = !0;
        for(let u = 0; u < t.length; u++){
            const f = t[u];
            if ($3e88191b87395c2e$export$923a058ef54437a4(f) && !f.isInline()) {
                a || (c += "\n");
                let t = "";
                for (const e of $3e88191b87395c2e$export$c83fc7fbb76e480a(f)){
                    const n = $3e88191b87395c2e$export$ea4162355720819(f, e);
                    null !== n && (t += n.getTextContent());
                }
                "" !== t ? (c += t, a = !1) : a = !f.isEmpty();
            } else if (a = !1, $3e88191b87395c2e$export$471953706258be2b(f)) {
                let t = f.getTextContent();
                f === e ? f === n ? "element" === o.type && "element" === r.type && r.offset !== o.offset || (t = s < l ? t.slice(s, l) : t.slice(l, s)) : t = i ? t.slice(s) : t.slice(l) : f === n && (t = i ? t.slice(0, l) : t.slice(0, s)), c += t;
            } else !$3e88191b87395c2e$export$60aa03725ce41b1c(f) && !$3e88191b87395c2e$export$b16330e40aa25c4e(f) || f === n && this.isCollapsed() || (c += f.getTextContent());
        }
        return c;
    }
    applyDOMRange(t) {
        const e = $3e88191b87395c2e$var$gi(), n = e.getEditorState()._selection, o = $3e88191b87395c2e$var$Or(t.startContainer, t.startOffset, t.endContainer, t.endOffset, e, n);
        if (null === o) return;
        const [r, i, s] = o;
        this.anchor.set(r.key, r.offset, r.type, !0), this.focus.set(i.key, i.offset, i.type, !0), s && (this.dirty = !0), $3e88191b87395c2e$export$db10bc6ba67ffcb5(this);
    }
    clone() {
        const t = this.anchor, e = this.focus;
        return new $3e88191b87395c2e$var$ar($3e88191b87395c2e$export$9b3f8d373c057995(t.key, t.offset, t.type), $3e88191b87395c2e$export$9b3f8d373c057995(e.key, e.offset, e.type), this.format, this.style);
    }
    toggleFormat(t) {
        this.format = $3e88191b87395c2e$export$bfd35cbfa01f02e5(this.format, t, null), this.dirty = !0;
    }
    setFormat(t) {
        this.format = t, this.dirty = !0;
    }
    setStyle(t) {
        this.style = t, this.dirty = !0;
    }
    hasFormat(t) {
        const e = $3e88191b87395c2e$export$c9e7d6eb65b13430[t];
        return 0 !== (this.format & e);
    }
    insertRawText(t) {
        this.insertNodes($3e88191b87395c2e$export$34f16fe1ef81eac4(t));
    }
    insertText(e) {
        const n = this.anchor, o = this.focus, r = this.format, i = this.style;
        let s = n, l = o;
        !this.isCollapsed() && o.isBefore(n) && (s = o, l = n), "element" === s.type && function(t, e, n, o) {
            const r = t.getNode(), i = r.getChildAtIndex(t.offset), s = $3e88191b87395c2e$export$2785f39dcdec0078();
            if (s.setFormat(n), s.setStyle(o), $3e88191b87395c2e$export$1fdda795300c79c6(i)) i.splice(0, 0, [
                s
            ]);
            else if (null !== i) {
                const t = $3e88191b87395c2e$export$6f851a24c61146af(r) ? $3e88191b87395c2e$export$7f0c05ffb7ced90d().append(s) : s;
                i.insertBefore(t);
            } else if ($3e88191b87395c2e$export$6f851a24c61146af(r)) {
                const t = r.getLastChild();
                $3e88191b87395c2e$export$923a058ef54437a4(t) && !t.isInline() && t.isEmpty() ? t.append(s) : r.append($3e88191b87395c2e$export$7f0c05ffb7ced90d().append(s));
            } else r.append(s);
            t.is(e) && e.set(s.__key, 0, "text"), t.set(s.__key, 0, "text");
        }(s, l, r, i), "element" === l.type && $3e88191b87395c2e$export$dd601b22fa430ce6(l, $3e88191b87395c2e$export$33e015e8f2ff8536($3e88191b87395c2e$export$e435a0def9eb2000(l, "next")));
        const c = s.offset;
        let a = l.offset;
        const u = this.getNodes(), f = u.length;
        let d = u[0];
        $3e88191b87395c2e$export$471953706258be2b(d) || $3e88191b87395c2e$var$t(26);
        const h = d.getTextContent().length, g = d.getParentOrThrow();
        let _ = u[f - 1];
        if (1 === f && "element" === l.type && (a = h, l.set(s.key, a, "text")), this.isCollapsed() && c === h && ($3e88191b87395c2e$export$8b834332909623ff(d) || !d.canInsertTextAfter() || !g.canInsertTextAfter() && null === d.getNextSibling())) {
            const t = d.getNextSibling();
            let n;
            if ($3e88191b87395c2e$export$471953706258be2b(t) && t.canInsertTextBefore() && !$3e88191b87395c2e$export$8b834332909623ff(t) ? n = t : (n = $3e88191b87395c2e$export$2785f39dcdec0078(), n.setFormat(r), n.setStyle(i), g.canInsertTextAfter() ? d.insertAfter(n) : g.insertAfter(n)), n.select(0, 0), d = n, "" !== e) return void this.insertText(e);
        } else if (this.isCollapsed() && 0 === c && ($3e88191b87395c2e$export$8b834332909623ff(d) || !d.canInsertTextBefore() || !g.canInsertTextBefore() && null === d.getPreviousSibling())) {
            const t = d.getPreviousSibling();
            let n;
            if (!$3e88191b87395c2e$export$471953706258be2b(t) || $3e88191b87395c2e$export$8b834332909623ff(t) ? (n = $3e88191b87395c2e$export$2785f39dcdec0078(), n.setFormat(r), g.canInsertTextBefore() ? d.insertBefore(n) : g.insertBefore(n)) : n = t, n.select(), d = n, "" !== e) return void this.insertText(e);
        } else if (d.isSegmented() && c !== h) {
            if (null !== $3e88191b87395c2e$var$js()) d = d.setMode("normal").setFormat(r).setStyle(i);
            else {
                const t = $3e88191b87395c2e$export$2785f39dcdec0078(d.getTextContent());
                t.setFormat(r), d.replace(t), d = t;
            }
        } else if (!this.isCollapsed() && "" !== e) {
            const t = _.getParent();
            if (!g.canInsertTextBefore() || !g.canInsertTextAfter() || $3e88191b87395c2e$export$923a058ef54437a4(t) && (!t.canInsertTextBefore() || !t.canInsertTextAfter())) return this.insertText(""), $3e88191b87395c2e$var$br(this.anchor, this.focus), void this.insertText(e);
        }
        if (1 === f) {
            if ($3e88191b87395c2e$export$c863bf9446d4a347(d)) {
                const t = $3e88191b87395c2e$export$2785f39dcdec0078(e);
                return t.select(), void d.replace(t);
            }
            const t = d.getFormat(), n = d.getStyle();
            if (c !== a || t === r && n === i) {
                if ($3e88191b87395c2e$export$ac9141efa5fb7932(d)) {
                    const t = $3e88191b87395c2e$export$2785f39dcdec0078(e);
                    return t.setFormat(r), t.setStyle(i), t.select(), void d.replace(t);
                }
            } else {
                if ("" !== d.getTextContent()) {
                    const t = $3e88191b87395c2e$export$2785f39dcdec0078(e);
                    if (t.setFormat(r), t.setStyle(i), t.select(), 0 === c) d.insertBefore(t, !1);
                    else {
                        const [e] = d.splitText(c);
                        e.insertAfter(t, !1);
                    }
                    return void (t.isComposing() && "text" === this.anchor.type && (this.anchor.offset -= e.length, this._cachedNodes = null, this._cachedIsBackward = null));
                }
                d.setFormat(r), d.setStyle(i);
            }
            const o = a - c;
            d = d.spliceText(c, o, e, !0), "" === d.getTextContent() ? d.remove() : "text" === this.anchor.type && (this.format = t, this.style = n, d.isComposing() && (this.anchor.offset -= e.length, this._cachedNodes = null, this._cachedIsBackward = null));
        } else {
            const n = new Set([
                ...d.getParentKeys(),
                ..._.getParentKeys()
            ]), o = $3e88191b87395c2e$export$923a058ef54437a4(d) ? d : d.getParentOrThrow();
            let r = $3e88191b87395c2e$export$923a058ef54437a4(_) ? _ : _.getParentOrThrow(), i = _;
            if (!o.is(r) && r.isInline()) do i = r, r = r.getParentOrThrow();
            while (r.isInline());
            if ("text" === l.type && (0 !== a || "" === _.getTextContent()) || "element" === l.type && _.getIndexWithinParent() < a) {
                if ($3e88191b87395c2e$export$471953706258be2b(_) && !$3e88191b87395c2e$export$c863bf9446d4a347(_) && a !== _.getTextContentSize()) {
                    if (_.isSegmented()) {
                        const t = $3e88191b87395c2e$export$2785f39dcdec0078(_.getTextContent());
                        _.replace(t), _ = t;
                    }
                    $3e88191b87395c2e$export$5b29ca560c2fedab(l.getNode()) || "text" !== l.type || ($3e88191b87395c2e$export$471953706258be2b(_) || $3e88191b87395c2e$var$t(395), _ = _.spliceText(0, a, "")), n.add(_.__key);
                } else {
                    const t = _.getParentOrThrow();
                    t.canBeEmpty() || 1 !== t.getChildrenSize() ? _.remove() : t.remove();
                }
            } else n.add(_.__key);
            const s = r.getChildren(), g = new Set(u), p = o.is(r), y = o.isInline() && null === d.getNextSibling() ? o : d;
            for(let t = s.length - 1; t >= 0; t--){
                const e = s[t];
                if (e.is(d) || $3e88191b87395c2e$export$923a058ef54437a4(e) && e.isParentOf(d)) break;
                e.isAttached() && (!g.has(e) || e.is(i) ? p || y.insertAfter(e, !1) : e.remove());
            }
            if (!p) {
                let t = r, e = null;
                for(; null !== t;){
                    const o = t.getChildren(), r = o.length;
                    (0 === r || o[r - 1].is(e)) && (n.delete(t.__key), e = t), t = t.getParent();
                }
            }
            if ($3e88191b87395c2e$export$c863bf9446d4a347(d)) {
                if (c === h) d.select();
                else {
                    const t = $3e88191b87395c2e$export$2785f39dcdec0078(e);
                    t.select(), d.replace(t);
                }
            } else d = d.spliceText(c, h - c, e, !0), "" === d.getTextContent() ? d.remove() : "text" === this.anchor.type && (this.format = d.getFormat(), this.style = d.getStyle(), d.isComposing() && (this.anchor.offset -= e.length, this._cachedNodes = null, this._cachedIsBackward = null));
            for(let t = 1; t < f; t++){
                const e = u[t], o = e.__key;
                n.has(o) || e.remove();
            }
        }
    }
    removeText() {
        const t = $3e88191b87395c2e$export$63a3201b3a5c7d90() === this;
        $3e88191b87395c2e$export$704f368fc2317a88(this, $3e88191b87395c2e$export$9421bed7a385cd41($3e88191b87395c2e$export$7bcaa61bc56938bf(this))), t && $3e88191b87395c2e$export$63a3201b3a5c7d90() !== this && $3e88191b87395c2e$export$2aad78c37810bca9(this);
    }
    formatText(t, e = null) {
        $3e88191b87395c2e$export$91ce7d57f84cadd3(this, t, e);
    }
    insertNodes(e) {
        if (0 === e.length) return;
        this.isCollapsed() || this.removeText();
        const n = this.anchor.getNode();
        if ("element" === this.anchor.type && $3e88191b87395c2e$export$923a058ef54437a4(n) && null !== $3e88191b87395c2e$var$Xc(n)) {
            var _n_getFirstChild;
            let o = n.isShadowRoot() ? (_n_getFirstChild = n.getFirstChild()) !== null && _n_getFirstChild !== void 0 ? _n_getFirstChild : n.append($3e88191b87395c2e$export$7f0c05ffb7ced90d()).getFirstChild() : n.getFirstChild();
            if (n.isShadowRoot() && null !== o && !$3e88191b87395c2e$export$923a058ef54437a4(o)) {
                const t = $3e88191b87395c2e$export$7f0c05ffb7ced90d();
                o.insertBefore(t), o = t;
            }
            if (null !== o) {
                o.selectStart();
                const n = $3e88191b87395c2e$export$63a3201b3a5c7d90();
                return $3e88191b87395c2e$export$181b63acea8a0224(n) || $3e88191b87395c2e$var$t(369), n.insertNodes(e);
            }
        }
        if ("element" === this.anchor.type && $3e88191b87395c2e$export$6f851a24c61146af(n)) {
            const t = $3e88191b87395c2e$var$Zr(e), o = t.getLastDescendant();
            return n.splice(this.anchor.offset, 0, t.getChildren()), void (null !== o && o.selectEnd());
        }
        let o = (this.isBackward() ? this.focus : this.anchor).getNode(), r = $3e88191b87395c2e$export$57101724ca611500(o, $3e88191b87395c2e$export$bd7ca521104e245c);
        const i = e[e.length - 1];
        if ($3e88191b87395c2e$export$923a058ef54437a4(r) && "__language" in r) {
            if ("__language" in e[0]) this.insertText(e[0].getTextContent());
            else {
                const t = $3e88191b87395c2e$var$Gr(this);
                r.splice(t, 0, e), i.selectEnd();
            }
            return;
        }
        if (!e.some((t)=>($3e88191b87395c2e$export$923a058ef54437a4(t) || $3e88191b87395c2e$export$60aa03725ce41b1c(t)) && !t.isInline())) {
            $3e88191b87395c2e$export$923a058ef54437a4(r) || $3e88191b87395c2e$var$t(211, o.constructor.name, o.getType());
            const n = $3e88191b87395c2e$var$Gr(this);
            return r.splice(n, 0, e), void i.selectEnd();
        }
        if ($3e88191b87395c2e$export$923a058ef54437a4(r) && null !== $3e88191b87395c2e$var$Xc(r)) {
            const t = $3e88191b87395c2e$var$Gr(this), n = $3e88191b87395c2e$var$Yr(e);
            r.splice(t, 0, n);
            const o = n[n.length - 1];
            return void (void 0 !== o ? o.selectEnd() : r.select(t, t));
        }
        if (null === r) {
            const t = $3e88191b87395c2e$var$Zr(e), n = t.getLastDescendant();
            let o = $3e88191b87395c2e$export$e435a0def9eb2000(this.anchor, "next");
            for (const e of t.getChildren())o = $3e88191b87395c2e$export$8074a5062ab072d1(e, o);
            return void (null !== n && n.selectEnd());
        }
        if ($3e88191b87395c2e$export$923a058ef54437a4(r) && !r.isParentRequired() && !$3e88191b87395c2e$export$6f851a24c61146af(r.getParentOrThrow())) {
            const t = $3e88191b87395c2e$var$Gr(this), n = $3e88191b87395c2e$var$Yr(e);
            r.splice(t, 0, n);
            const o = n[n.length - 1];
            return void (void 0 !== o ? o.selectEnd() : r.select(t, t));
        }
        const s = $3e88191b87395c2e$var$Zr(e), l = s.getLastDescendant(), c = s.getChildren(), a = !$3e88191b87395c2e$export$923a058ef54437a4(r) || !r.isEmpty() ? this.insertParagraph() : null;
        a && !r.isAttached() && (o = this.anchor.getNode(), r = $3e88191b87395c2e$export$57101724ca611500(o, $3e88191b87395c2e$export$bd7ca521104e245c));
        const u = c[c.length - 1];
        let f = c[0];
        var d;
        $3e88191b87395c2e$export$923a058ef54437a4(d = f) && $3e88191b87395c2e$export$bd7ca521104e245c(d) && !d.isEmpty() && $3e88191b87395c2e$export$923a058ef54437a4(r) && (!r.isEmpty() || r.canMergeWhenEmpty()) && ($3e88191b87395c2e$export$923a058ef54437a4(r) || $3e88191b87395c2e$var$t(211, o.constructor.name, o.getType()), r.append(...f.getChildren()), f = c[1]), f && (null === r && $3e88191b87395c2e$var$t(212, o.constructor.name, o.getType()), function(e, n) {
            const o = n.getParentOrThrow().getLastChild();
            let r = n;
            const i = [
                n
            ];
            for(; r !== o;)r.getNextSibling() || $3e88191b87395c2e$var$t(140), r = r.getNextSibling(), i.push(r);
            let s = e;
            for (const t of i)s = s.insertAfter(t);
        }(r, f));
        const h = $3e88191b87395c2e$export$57101724ca611500(l, $3e88191b87395c2e$export$bd7ca521104e245c);
        a && $3e88191b87395c2e$export$923a058ef54437a4(h) && (a.canMergeWhenEmpty() || $3e88191b87395c2e$export$bd7ca521104e245c(u)) && (h.append(...a.getChildren()), a.remove()), $3e88191b87395c2e$export$923a058ef54437a4(r) && r.isEmpty() && r.remove(), l.selectEnd();
        const g = $3e88191b87395c2e$export$923a058ef54437a4(r) ? r.getLastChild() : null;
        $3e88191b87395c2e$export$b16330e40aa25c4e(g) && h !== r && g.remove();
    }
    insertParagraph() {
        const e = this.anchor.getNode();
        if ("element" === this.anchor.type && $3e88191b87395c2e$export$6f851a24c61146af(e)) {
            const t = $3e88191b87395c2e$export$7f0c05ffb7ced90d();
            return e.splice(this.anchor.offset, 0, [
                t
            ]), t.select(), t;
        }
        const n = $3e88191b87395c2e$var$Gr(this), o = $3e88191b87395c2e$export$57101724ca611500(this.anchor.getNode(), $3e88191b87395c2e$export$bd7ca521104e245c);
        if (null !== o && null !== $3e88191b87395c2e$var$Xc(o)) return null;
        $3e88191b87395c2e$export$923a058ef54437a4(o) || $3e88191b87395c2e$var$t(213);
        const r = o.getChildAtIndex(n), i = r ? [
            r,
            ...r.getNextSiblings()
        ] : [], s = o.insertNewAfter(this, !1);
        return s ? (s.append(...i), s.selectStart(), s) : null;
    }
    insertLineBreak(t) {
        const e = $3e88191b87395c2e$export$4ccaf7d0d16ab4c();
        if (this.insertNodes([
            e
        ]), t) {
            const t = e.getParentOrThrow(), n = e.getIndexWithinParent();
            t.select(n, n);
        }
    }
    extract() {
        const t = [
            ...this.getNodes()
        ], e = t.length;
        let n = t[0], o = t[e - 1];
        const [r, i] = $3e88191b87395c2e$export$5a33b5b9a9d5db8f(this), s = this.isBackward(), [l, c] = s ? [
            this.focus,
            this.anchor
        ] : [
            this.anchor,
            this.focus
        ], [a, u] = s ? [
            i,
            r
        ] : [
            r,
            i
        ];
        if (0 === e) return [];
        if (1 === e) {
            if ($3e88191b87395c2e$export$471953706258be2b(n) && !this.isCollapsed()) {
                const t = n.splitText(a, u), e = 0 === a ? t[0] : t[1];
                return e ? (l.set(e.getKey(), 0, "text"), c.set(e.getKey(), e.getTextContentSize(), "text"), [
                    e
                ]) : [];
            }
            return [
                n
            ];
        }
        if ($3e88191b87395c2e$export$471953706258be2b(n) && (a === n.getTextContentSize() ? t.shift() : 0 !== a && ([, n] = n.splitText(a), t[0] = n, l.set(n.getKey(), 0, "text"))), $3e88191b87395c2e$export$471953706258be2b(o)) {
            const e = o.getTextContent().length;
            0 === u ? t.pop() : u !== e && ([o] = o.splitText(u), t[t.length - 1] = o, c.set(o.getKey(), o.getTextContentSize(), "text"));
        }
        return t;
    }
    modify(t, e, n) {
        if ($3e88191b87395c2e$var$ti(this, t, e, n)) return;
        const o = "move" === t, r = $3e88191b87395c2e$var$gi(), i = $3e88191b87395c2e$export$74c14770a0819525($3e88191b87395c2e$var$Pl(r));
        if (!i) return;
        const s = r._blockCursorElement, l = r._rootElement, c = this.focus.getNode();
        null === l || null === s || !$3e88191b87395c2e$export$923a058ef54437a4(c) || c.isInline() || c.canBeEmpty() || $3e88191b87395c2e$var$$l(s, r, l);
        const a = $3e88191b87395c2e$var$bl(r, this.focus.key);
        let u = a;
        if ("text" === this.focus.type && (u = $3e88191b87395c2e$export$471953706258be2b(c) ? $3e88191b87395c2e$export$118c63c491bd7ec(c, a, r) : null), this.dirty) {
            const t = $3e88191b87395c2e$var$bl(r, this.anchor.key);
            let e = t;
            if ("text" === this.anchor.type) {
                const n = this.anchor.getNode();
                e = $3e88191b87395c2e$export$471953706258be2b(n) ? $3e88191b87395c2e$export$118c63c491bd7ec(n, t, r) : null;
            }
            e && u && $3e88191b87395c2e$var$Ur(i, e, this.anchor.offset, u, this.focus.offset);
        }
        if ("character" === n && $3e88191b87395c2e$export$471953706258be2b(c) && c.isUnmergeable()) {
            if (e ? 0 === this.focus.offset : this.focus.offset === c.getTextContentSize()) {
                const t = $3e88191b87395c2e$export$cdd98497d9dc1de9(c, e ? "previous" : "next").getNodeAtCaret();
                if ($3e88191b87395c2e$export$471953706258be2b(t)) {
                    if (!o) {
                        const n = t.getTextContentSize();
                        return e ? this.focus.set(t.__key, n - 1, "text") : this.focus.set(t.__key, 1, "text"), void (this.dirty = !0);
                    }
                    {
                        const n = r.getElementByKey(t.getKey()), o = n ? $3e88191b87395c2e$export$118c63c491bd7ec(t, n, r) : null;
                        if (o) {
                            const t = e ? o.length : 0;
                            $3e88191b87395c2e$var$Ur(i, o, t, o, t);
                        }
                    }
                }
            }
        }
        if ($3e88191b87395c2e$var$mr(i, t, e ? "backward" : "forward", n), i.rangeCount > 0) {
            const t = $3e88191b87395c2e$export$ad2e2afb4198aa89(i, r._rootElement), n = t || i.getRangeAt(0), s = this.anchor.getNode(), l = $3e88191b87395c2e$export$5b29ca560c2fedab(s) ? s : $3e88191b87395c2e$export$6f13c476561e4734(s);
            if (this.applyDOMRange(n), this.dirty = !0, !o) {
                $3e88191b87395c2e$var$xr(this, e, l);
                (t ? "backward" !== i.direction : i.anchorNode === n.startContainer && i.anchorOffset === n.startOffset) || $3e88191b87395c2e$var$yr(this);
            }
        }
        "lineboundary" === n && $3e88191b87395c2e$var$ti(this, t, e, n, "decorators");
    }
    forwardDeletion(t, e, n) {
        if (!n && ("element" === t.type && $3e88191b87395c2e$export$923a058ef54437a4(e) && t.offset === e.getChildrenSize() || "text" === t.type && t.offset === e.getTextContentSize())) {
            const t = e.getParent(), n = e.getNextSibling() || (null === t ? null : t.getNextSibling());
            if ($3e88191b87395c2e$export$923a058ef54437a4(n) && n.isShadowRoot()) return !0;
        }
        return !1;
    }
    deleteCharacter(t) {
        const e = this.isCollapsed();
        if (this.isCollapsed()) {
            const e = this.anchor;
            let n = e.getNode();
            if (this.forwardDeletion(e, n, t)) return;
            const o = $3e88191b87395c2e$export$7f1827f6551d91c3($3e88191b87395c2e$export$e435a0def9eb2000(e, t ? "previous" : "next"));
            if (o.getTextSlices().every((t)=>null === t || 0 === t.distance)) {
                let t = {
                    type: "initial"
                };
                for (const e of o.iterNodeCarets("shadowRoot"))if ($3e88191b87395c2e$export$1c3da6f3e60ca260(e)) {
                    if (e.origin.isInline()) ;
                    else {
                        if (e.origin.isShadowRoot()) {
                            if ("merge-block" === t.type) break;
                            if ($3e88191b87395c2e$export$923a058ef54437a4(o.anchor.origin) && o.anchor.origin.isEmpty()) {
                                const t = $3e88191b87395c2e$export$33e015e8f2ff8536(e);
                                $3e88191b87395c2e$export$704f368fc2317a88(this, $3e88191b87395c2e$export$36f672915982afb2(t, t)), o.anchor.origin.remove();
                            }
                            return;
                        }
                        "merge-next-block" !== t.type && "merge-block" !== t.type || (t = {
                            block: t.block,
                            caret: e,
                            type: "merge-block"
                        });
                    }
                } else {
                    if ("merge-block" === t.type) break;
                    if ($3e88191b87395c2e$export$3bcd9a2637e8506e(e)) {
                        if ($3e88191b87395c2e$export$923a058ef54437a4(e.origin)) {
                            if (e.origin.isInline()) {
                                if (!e.origin.isParentOf(o.anchor.origin)) break;
                            } else t = {
                                block: e.origin,
                                type: "merge-next-block"
                            };
                            continue;
                        }
                        if ($3e88191b87395c2e$export$60aa03725ce41b1c(e.origin)) {
                            if (e.origin.isIsolated()) ;
                            else if ($3e88191b87395c2e$export$c83fc7fbb76e480a(e.origin).length > 0) {
                                if ($3e88191b87395c2e$export$923a058ef54437a4(o.anchor.origin) && o.anchor.origin.isEmpty()) {
                                    o.anchor.origin.remove();
                                    const t = $3e88191b87395c2e$export$f8cd0c3f35d1a61c();
                                    t.add(e.origin.getKey()), $3e88191b87395c2e$export$2aad78c37810bca9(t);
                                }
                            } else if ("merge-next-block" === t.type && (e.origin.isKeyboardSelectable() || !e.origin.isInline()) && $3e88191b87395c2e$export$923a058ef54437a4(o.anchor.origin) && o.anchor.origin.isEmpty()) {
                                o.anchor.origin.remove();
                                const t = $3e88191b87395c2e$export$f8cd0c3f35d1a61c();
                                t.add(e.origin.getKey()), $3e88191b87395c2e$export$2aad78c37810bca9(t);
                            } else e.origin.remove();
                            return;
                        }
                        break;
                    }
                }
                if ("merge-block" === t.type) {
                    const { caret: e, block: n } = t;
                    if ($3e88191b87395c2e$export$c83fc7fbb76e480a(n).length > 0) return;
                    return e.origin.isEmpty() && !n.isEmpty() && e.origin.getParent() === n.getParent() ? void e.origin.remove(!0) : ($3e88191b87395c2e$export$704f368fc2317a88(this, $3e88191b87395c2e$export$36f672915982afb2(!e.origin.isEmpty() && n.isEmpty() ? $3e88191b87395c2e$export$3d19514618fb28f3($3e88191b87395c2e$export$cdd98497d9dc1de9(n, e.direction)) : o.anchor, e)), this.removeText());
                }
                for(let t = e.getNode(); null !== t;){
                    if (null !== $3e88191b87395c2e$var$Xc(t)) return;
                    if ($3e88191b87395c2e$export$923a058ef54437a4(t) && t.isShadowRoot()) break;
                    t = t.getParent();
                }
            }
            const r = this.focus;
            if ($3e88191b87395c2e$var$Cr(this, t, "character"), this.isCollapsed()) {
                if (t && 0 === e.offset && $3e88191b87395c2e$var$pr(this, e.getNode())) return;
            } else {
                const o = "text" === r.type ? r.getNode() : null;
                if (n = "text" === e.type ? e.getNode() : null, null !== o && o.isSegmented()) {
                    const e = r.offset, i = o.getTextContentSize();
                    if (o.is(n) || t && e !== i || !t && 0 !== e) return void $3e88191b87395c2e$var$vr(o, t, e);
                } else if (null !== n && n.isSegmented()) {
                    const r = e.offset, i = n.getTextContentSize();
                    if (n.is(o) || t && 0 !== r || !t && r !== i) return void $3e88191b87395c2e$var$vr(n, t, r);
                }
                !function(t, e) {
                    const n = t.anchor, o = t.focus, r = n.getNode(), i = o.getNode();
                    if (r === i && "text" === n.type && "text" === o.type) {
                        const t = n.offset, i = o.offset, s = t < i, l = s ? t : i, c = s ? i : t, a = c - 1;
                        if (l !== a) (function(t) {
                            return !($3e88191b87395c2e$var$rl(t) || $3e88191b87395c2e$var$Sr(t));
                        })(r.getTextContent().slice(l, c)) && (e ? o.set(o.key, a, o.type) : n.set(n.key, a, n.type));
                    }
                }(this, t);
            }
        }
        if (this.removeText(), t && !e && this.isCollapsed() && "element" === this.anchor.type && 0 === this.anchor.offset) {
            const t = this.anchor.getNode();
            t.isEmpty() && $3e88191b87395c2e$export$5b29ca560c2fedab(t.getParent()) && null === t.getPreviousSibling() && $3e88191b87395c2e$var$pr(this, t), $3e88191b87395c2e$var$lr();
        }
    }
    deleteLine(t) {
        const e = $3e88191b87395c2e$var$Nr(this.anchor);
        if (null !== e && $3e88191b87395c2e$export$60aa03725ce41b1c($3e88191b87395c2e$export$fe2a41df16bf88cd(e))) return this.isCollapsed() || this.focus.set(this.anchor.key, this.anchor.offset, this.anchor.type), void this.deleteCharacter(t);
        if (this.isCollapsed() && $3e88191b87395c2e$var$Cr(this, t, "lineboundary"), this.isCollapsed()) this.deleteCharacter(t);
        else $3e88191b87395c2e$export$57101724ca611500(this.anchor.getNode(), $3e88191b87395c2e$export$bd7ca521104e245c) !== $3e88191b87395c2e$export$57101724ca611500(this.focus.getNode(), $3e88191b87395c2e$export$bd7ca521104e245c) ? (this.focus.set(this.anchor.key, this.anchor.offset, this.anchor.type), this.deleteCharacter(t)) : this.removeText();
    }
    deleteWord(t) {
        if (this.isCollapsed()) {
            const e = this.anchor, n = e.getNode();
            if (this.forwardDeletion(e, n, t)) return;
            $3e88191b87395c2e$var$Cr(this, t, "word");
        }
        this.isCollapsed() ? this.deleteCharacter(t) : this.removeText();
    }
    isBackward() {
        const t = this._cachedIsBackward;
        if (null !== t) return t;
        const e = this.focus.isBefore(this.anchor);
        return $3e88191b87395c2e$export$761df28585b755e8() || (this._cachedIsBackward = e), e;
    }
    getStartEndPoints() {
        return [
            this.anchor,
            this.focus
        ];
    }
    constructor(t, e, n, o){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "format", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "style", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "anchor", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "focus", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_cachedNodes", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_cachedIsBackward", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "dirty", void 0);
        this.anchor = t, this.focus = e, t._selection = this, e._selection = this, this._cachedNodes = null, this._cachedIsBackward = null, this.format = n, this.style = o, this.dirty = !1;
    }
}
function $3e88191b87395c2e$export$7257e4181651a7c3(t) {
    return t instanceof $3e88191b87395c2e$var$sr;
}
function $3e88191b87395c2e$var$fr(t, e) {
    if ($3e88191b87395c2e$export$7257e4181651a7c3(t)) {
        for (const n of t.getNodes())$3e88191b87395c2e$export$9dd2963cec3c9590(n) && n.setFormat(e(n.getFormat()));
        return;
    }
    if (t.isCollapsed()) return t.setFormat(e(t.format)), void $3e88191b87395c2e$export$ea25f5ef71f2d042(null);
    const n = [];
    for (const o of t.getNodes())$3e88191b87395c2e$export$471953706258be2b(o) ? n.push(o) : $3e88191b87395c2e$export$923a058ef54437a4(o) ? o.setTextFormat(e(o.getTextFormat())) : $3e88191b87395c2e$export$9dd2963cec3c9590(o) && o.setFormat(e(o.getFormat()));
    const o = n.length;
    if (0 === o) return t.setFormat(e(t.format)), void $3e88191b87395c2e$export$ea25f5ef71f2d042(null);
    const r = t.anchor, i = t.focus, s = t.isBackward(), l = s ? i : r, c = s ? r : i;
    let a = 0, u = n[0], f = "element" === l.type ? 0 : l.offset;
    if ("text" === l.type && f === u.getTextContentSize() && (a = 1, u = n[1], f = 0), null == u) return;
    const d = o - 1;
    let h = n[d];
    const g = "text" === c.type ? c.offset : h.getTextContentSize();
    if (u.is(h)) {
        if (f === g) return;
        const n = e(u.getFormat());
        if ($3e88191b87395c2e$export$8b834332909623ff(u) || 0 === f && g === u.getTextContentSize()) u.setFormat(n);
        else {
            const t = u.splitText(f, g), e = 0 === f ? t[0] : t[1];
            e.setFormat(n), "text" === l.type && l.set(e.__key, 0, "text"), "text" === c.type && c.set(e.__key, g - f, "text");
        }
        return void (t.format = n);
    }
    0 === f || $3e88191b87395c2e$export$8b834332909623ff(u) || ([, u] = u.splitText(f), f = 0);
    const _ = e(u.getFormat());
    u.setFormat(_);
    const p = e(h.getFormat());
    g > 0 && (g === h.getTextContentSize() || $3e88191b87395c2e$export$8b834332909623ff(h) || ([h] = h.splitText(g)), h.setFormat(p));
    for(let t = a + 1; t < d; t++){
        const o = n[t];
        o.setFormat(e(o.getFormat()));
    }
    "text" === l.type && l.set(u.__key, f, "text"), "text" === c.type && c.set(h.__key, g, "text"), t.format = _ | p;
}
function $3e88191b87395c2e$export$1f3463ab0266bd6b(t, e) {
    const n = [];
    for (const [t, o] of Object.entries(e))"boolean" == typeof o && n.push([
        t,
        o
    ]);
    0 !== n.length && $3e88191b87395c2e$var$fr(t, (t)=>{
        for (const [e, o] of n)t = $3e88191b87395c2e$export$bfd35cbfa01f02e5(t, e, o ? $3e88191b87395c2e$export$c9e7d6eb65b13430[e] : 0);
        return t;
    });
}
function $3e88191b87395c2e$export$91ce7d57f84cadd3(t, e, n = null) {
    const o = null === n && $3e88191b87395c2e$export$181b63acea8a0224(t) ? $3e88191b87395c2e$export$bfd35cbfa01f02e5(t.format, e, null) : n;
    $3e88191b87395c2e$var$fr(t, (t)=>$3e88191b87395c2e$export$bfd35cbfa01f02e5(t, e, o));
}
function $3e88191b87395c2e$var$gr(t) {
    const e = t.offset;
    if ("text" === t.type) return e;
    const n = t.getNode();
    return e === n.getChildrenSize() ? n.getTextContent().length : 0;
}
function $3e88191b87395c2e$export$5a33b5b9a9d5db8f(t) {
    const e = t.getStartEndPoints();
    if (null === e) return [
        0,
        0
    ];
    const [n, o] = e;
    return "element" === n.type && "element" === o.type && n.key === o.key && n.offset === o.offset ? [
        0,
        0
    ] : [
        $3e88191b87395c2e$var$gr(n),
        $3e88191b87395c2e$var$gr(o)
    ];
}
function $3e88191b87395c2e$var$pr(t, e) {
    for(let n = e; n; n = n.getParent()){
        if ($3e88191b87395c2e$export$923a058ef54437a4(n)) {
            if (n.collapseAtStart(t)) return !0;
            if ($3e88191b87395c2e$export$6f851a24c61146af(n)) break;
        }
        if (n.getPreviousSibling()) break;
    }
    return !1;
}
function $3e88191b87395c2e$var$yr(t) {
    const e = t.focus, n = t.anchor, o = n.key, r = n.offset, i = n.type;
    n.set(e.key, e.offset, e.type, !0), e.set(o, r, i, !0);
}
function $3e88191b87395c2e$var$mr(t, e, n, o) {
    t.modify(e, n, o);
}
function $3e88191b87395c2e$var$xr(t, e, n) {
    const o = t.getNodes(), r = o.filter((t)=>$3e88191b87395c2e$export$e3d4b782f65c81f1(t, n));
    if (0 === r.length || r.length === o.length) return !1;
    const i = e ? r[0] : r[r.length - 1], s = $3e88191b87395c2e$export$923a058ef54437a4(i) ? i : i.getParentOrThrow();
    return e ? s.selectStart() : s.selectEnd(), !0;
}
function $3e88191b87395c2e$var$Cr(t, e, n) {
    if ($3e88191b87395c2e$var$ti(t, "extend", e, n)) return;
    const o = $3e88191b87395c2e$var$gi(), r = $3e88191b87395c2e$export$74c14770a0819525($3e88191b87395c2e$var$Pl(o));
    if (!r || "function" != typeof r.modify) return;
    const i = o._blockCursorElement, s = o._rootElement, l = t.anchor, c = t.focus.getNode();
    null === s || null === i || !$3e88191b87395c2e$export$923a058ef54437a4(c) || c.isInline() || c.canBeEmpty() || $3e88191b87395c2e$var$$l(i, o, s);
    const a = (t)=>{
        const e = t.getNode(), n = o.getElementByKey(t.key);
        return null !== n && "text" === t.type && $3e88191b87395c2e$export$471953706258be2b(e) ? $3e88191b87395c2e$export$118c63c491bd7ec(e, n, o) : n;
    }, u = l.getNode(), f = a(l);
    if (null === f) return;
    const d = l.offset, h = t.isCollapsed(), g = t.focus, _ = h ? f : a(g);
    if (null === _) return;
    const p = g.offset;
    if ($3e88191b87395c2e$var$Ur(r, _, p, _, p), $3e88191b87395c2e$var$mr(r, "move", e ? "backward" : "forward", n), 0 === r.rangeCount) return;
    const y = $3e88191b87395c2e$export$ad2e2afb4198aa89(r, s) || r.getRangeAt(0), m = y.startContainer, x = y.startOffset;
    if (h && "character" === n && "text" === l.type && $3e88191b87395c2e$export$471953706258be2b(u) && u.isUnmergeable()) {
        if (d === (e ? 0 : u.getTextContentSize())) {
            const n = $3e88191b87395c2e$export$cdd98497d9dc1de9(u, e ? "previous" : "next").getNodeAtCaret();
            if ($3e88191b87395c2e$export$471953706258be2b(n)) {
                const o = e ? n.getTextContentSize() - 1 : 1;
                return t.focus.set(n.__key, o, "text"), void (t.dirty = !0);
            }
        }
    }
    if (h && "character" === n && "text" === l.type) {
        const n = e ? 0 : u.getTextContentSize(), o = m === f ? x : d !== n ? n : -1;
        if (o >= 0) return void (o !== d && (t.focus.set(l.key, o, "text"), t.dirty = !0));
    }
    const [C, S, v, T] = e ? [
        m,
        x,
        f,
        d
    ] : [
        f,
        d,
        m,
        x
    ], k = $3e88191b87395c2e$export$5b29ca560c2fedab(u) ? u : $3e88191b87395c2e$export$6f13c476561e4734(u);
    t.applyDOMRange({
        collapsed: !1,
        endContainer: v,
        endOffset: T,
        startContainer: C,
        startOffset: S
    }), t.dirty = !0, !$3e88191b87395c2e$var$xr(t, e, k) && e && $3e88191b87395c2e$var$yr(t), "lineboundary" === n && $3e88191b87395c2e$var$ti(t, "extend", e, n, "decorators");
}
const $3e88191b87395c2e$var$Sr = (()=>{
    try {
        const t = new RegExp("\\p{Emoji}", "u"), e = t.test.bind(t);
        if (e("\u2764\ufe0f") && e("#\ufe0f\u20e3") && e("\uD83D\uDC4D")) return e;
    } catch (t) {}
    return ()=>!1;
})();
function $3e88191b87395c2e$var$vr(t, e, n) {
    const o = t, r = o.getTextContent().split(/(?=\s)/g), i = r.length;
    let s = 0, l = 0;
    for(let t = 0; t < i; t++){
        const o = t === i - 1;
        if (l = s, s += r[t].length, e && s === n || s > n || o) {
            r.splice(t, 1), o && (l = void 0);
            break;
        }
    }
    const c = r.join("").trim();
    "" === c ? o.remove() : (o.setTextContent(c), o.select(l, l));
}
function $3e88191b87395c2e$var$Tr(e, n, o, r) {
    let i, s = n, l = !1;
    if ($3e88191b87395c2e$export$1b3bfaa9684536aa(e)) {
        let c = !1;
        const a = e.childNodes, u = a.length, f = r._blockCursorElement;
        s === u && u > 0 && (c = !0, s = u - 1), void 0 !== $3e88191b87395c2e$var$Gs(e, r) || $3e88191b87395c2e$export$b1dbc8b9f80bab62(e, r) || (l = !0);
        let d = a[s], h = !1;
        if (d === f) d = a[s + 1], h = !0;
        else if (null !== f) {
            const t = f.parentNode;
            if (e === t) n > Array.prototype.indexOf.call(t.children, f) && s--;
        }
        if (i = $3e88191b87395c2e$var$ol(d), $3e88191b87395c2e$export$471953706258be2b(i)) s = $3e88191b87395c2e$export$d83ac801960e4905(i, c ? "next" : "previous");
        else {
            let a = $3e88191b87395c2e$var$ol(e);
            if (null === a) return null;
            if ($3e88191b87395c2e$export$923a058ef54437a4(a)) {
                const l = r.getElementByKey(a.getKey());
                null === l && $3e88191b87395c2e$var$t(214);
                const u = $3e88191b87395c2e$export$724e988312a5b9ca(a, l, r);
                [a, s] = u.resolveChildIndex(a, l, e, n), $3e88191b87395c2e$export$923a058ef54437a4(a) || $3e88191b87395c2e$var$t(215), c && s >= a.getChildrenSize() && (s = Math.max(0, a.getChildrenSize() - 1));
                let f = a.getChildAtIndex(s);
                if ($3e88191b87395c2e$export$923a058ef54437a4(f) && function(t, e, n) {
                    const o = t.getParent();
                    return null === n || null === o || !o.canBeEmpty() || o !== n.getNode();
                }(f, 0, o)) {
                    const t = c ? f.getLastDescendant() : f.getFirstDescendant();
                    null === t ? a = f : (f = t, a = $3e88191b87395c2e$export$923a058ef54437a4(f) ? f : f.getParentOrThrow()), s = 0;
                }
                $3e88191b87395c2e$export$471953706258be2b(f) ? (i = f, a = null, s = $3e88191b87395c2e$export$d83ac801960e4905(f, c ? "next" : "previous")) : f !== a && c && !h && ($3e88191b87395c2e$export$923a058ef54437a4(a) || $3e88191b87395c2e$var$t(216), s = Math.min(a.getChildrenSize(), s + 1));
            } else {
                const t = $3e88191b87395c2e$export$fe2a41df16bf88cd(a), o = null !== t ? t : a, i = o.getIndexWithinParent(), l = r.getElementByKey(a.getKey());
                let c = "after";
                if (null !== l && $3e88191b87395c2e$var$ol(e) === a) {
                    const t = $3e88191b87395c2e$export$724e988312a5b9ca(a, l, r);
                    t.element !== l ? c = t.resolveLeafPosition(l, e, n) : 0 === n && $3e88191b87395c2e$export$60aa03725ce41b1c(a) && (c = "before");
                }
                s = "before" === c ? i : i + 1, a = o.getParentOrThrow();
            }
            if ($3e88191b87395c2e$export$923a058ef54437a4(a)) return [
                $3e88191b87395c2e$export$9b3f8d373c057995(a.__key, s, "element"),
                l
            ];
        }
    } else i = $3e88191b87395c2e$var$ol(e);
    return $3e88191b87395c2e$export$471953706258be2b(i) ? [
        $3e88191b87395c2e$export$9b3f8d373c057995(i.__key, $3e88191b87395c2e$export$d83ac801960e4905(i, s, "clamp"), "text"),
        l
    ] : null;
}
function $3e88191b87395c2e$var$kr(t, e, n) {
    const o = t.offset, r = t.getNode();
    if (0 === o) {
        const o = r.getPreviousSibling(), i = r.getParent();
        if (e) {
            if ((n || !e) && null === o && $3e88191b87395c2e$export$923a058ef54437a4(i) && i.isInline()) {
                const e = i.getPreviousSibling();
                $3e88191b87395c2e$export$471953706258be2b(e) && t.set(e.__key, e.getTextContent().length, "text");
            }
        } else $3e88191b87395c2e$export$923a058ef54437a4(o) && !n && o.isInline() ? t.set(o.__key, o.getChildrenSize(), "element") : $3e88191b87395c2e$export$471953706258be2b(o) && !r.isUnmergeable() && t.set(o.__key, o.getTextContent().length, "text");
    } else if (o === r.getTextContent().length) {
        const o = r.getNextSibling(), i = r.getParent();
        if (e && $3e88191b87395c2e$export$923a058ef54437a4(o) && o.isInline()) t.set(o.__key, 0, "element");
        else if ((n || e) && null === o && $3e88191b87395c2e$export$923a058ef54437a4(i) && i.isInline() && !i.canInsertTextAfter() && i.getTextContentSize() > 1) {
            const e = i.getNextSibling();
            $3e88191b87395c2e$export$471953706258be2b(e) && t.set(e.__key, 0, "text");
        }
    }
}
function $3e88191b87395c2e$var$br(t, e, n) {
    if ("text" === t.type && "text" === e.type) {
        const n = t.isBefore(e), o = t.is(e);
        $3e88191b87395c2e$var$kr(t, n, o), $3e88191b87395c2e$var$kr(e, !n, o), o && e.set(t.key, t.offset, t.type);
    }
}
function $3e88191b87395c2e$var$Nr(t) {
    const e = $3e88191b87395c2e$export$e725f93d4d48c6d8(t.key);
    return null === e ? null : $3e88191b87395c2e$export$fe2dfd0f9ec2306d(e);
}
function $3e88191b87395c2e$var$wr(t, e, n) {
    const o = $3e88191b87395c2e$var$Nr(t), r = $3e88191b87395c2e$var$Nr(e);
    if (o === r || null !== o && null !== r && o.is(r)) return !1;
    const i = n(o, r);
    if (null !== o) return $3e88191b87395c2e$export$923a058ef54437a4(o) ? e.set(o.getKey(), i ? o.getChildrenSize() : 0, "element") : e.set(o.getKey(), i ? o.getTextContentSize() : 0, "text"), !0;
    const s = $3e88191b87395c2e$export$fe2a41df16bf88cd(r);
    if (null === s) return !1;
    const l = s.getParent();
    if (null === l) return !1;
    const c = s.getIndexWithinParent();
    return e.set(l.getKey(), i ? c + 1 : c, "element"), !0;
}
function $3e88191b87395c2e$var$Er(t) {
    const e = $3e88191b87395c2e$var$wr(t.anchor, t.focus, (e, n)=>(function(t, e, n, o) {
            if (null !== n && null !== o) {
                const t = $3e88191b87395c2e$export$fe2a41df16bf88cd(n), e = $3e88191b87395c2e$export$fe2a41df16bf88cd(o);
                if (null !== t && t.is(e)) {
                    for (const e of $3e88191b87395c2e$var$ea(t).values()){
                        if (e === n.getKey()) return !0;
                        if (e === o.getKey()) return !1;
                    }
                    return !0;
                }
                return null === t || null === e || t.isBefore(e);
            }
            if (null !== n) {
                const t = $3e88191b87395c2e$export$fe2a41df16bf88cd(n), o = $3e88191b87395c2e$export$e725f93d4d48c6d8(e.key);
                return null === t || null === o || !(!t.is(o) && !t.isParentOf(o)) || t.isBefore(o);
            }
            const r = $3e88191b87395c2e$export$fe2a41df16bf88cd(o), i = $3e88191b87395c2e$export$e725f93d4d48c6d8(t.key);
            return null !== r && null !== i && !r.is(i) && !r.isParentOf(i) && i.isBefore(r);
        })(t.anchor, t.focus, e, n));
    return e && (t.dirty = !0), e;
}
function $3e88191b87395c2e$var$Or(t, e, n, o, r, i) {
    if (null === t || null === n || !$3e88191b87395c2e$export$f1b377b21cd6350b(r, t, n)) return null;
    const s = $3e88191b87395c2e$var$Tr(t, e, $3e88191b87395c2e$export$181b63acea8a0224(i) ? i.anchor : null, r);
    if (null === s) return null;
    const l = $3e88191b87395c2e$var$Tr(n, o, $3e88191b87395c2e$export$181b63acea8a0224(i) ? i.focus : null, r);
    if (null === l) return null;
    const [c, a] = s, [u, f] = l;
    if ("element" === c.type && "element" === u.type) {
        const e = $3e88191b87395c2e$var$ol(t), o = $3e88191b87395c2e$var$ol(n);
        if ($3e88191b87395c2e$export$60aa03725ce41b1c(e) && $3e88191b87395c2e$export$60aa03725ce41b1c(o)) return null;
    }
    const d = r._slotsUsed && $3e88191b87395c2e$var$wr(c, u, ()=>0 !== (t.compareDocumentPosition(n) & Node.DOCUMENT_POSITION_FOLLOWING));
    return $3e88191b87395c2e$var$br(c, u), [
        c,
        u,
        a || f || d
    ];
}
function $3e88191b87395c2e$export$de078facd4ee1560(t) {
    return $3e88191b87395c2e$export$923a058ef54437a4(t) && !t.isInline();
}
function $3e88191b87395c2e$var$Ar(t, e, n, o, r, i) {
    const s = $3e88191b87395c2e$var$di(), l = new $3e88191b87395c2e$var$ar($3e88191b87395c2e$export$9b3f8d373c057995(t, e, r), $3e88191b87395c2e$export$9b3f8d373c057995(n, o, i), 0, "");
    return l.dirty = !0, s._selection = l, l;
}
function $3e88191b87395c2e$export$1ccc217b9831b072() {
    const t = $3e88191b87395c2e$export$9b3f8d373c057995("root", 0, "element"), e = $3e88191b87395c2e$export$9b3f8d373c057995("root", 0, "element");
    return new $3e88191b87395c2e$var$ar(t, e, 0, "");
}
function $3e88191b87395c2e$export$f8cd0c3f35d1a61c() {
    return new $3e88191b87395c2e$var$sr(new Set);
}
function $3e88191b87395c2e$export$68ac2b736ac647aa(t, e) {
    return $3e88191b87395c2e$var$Ir(null, t, e, null);
}
function $3e88191b87395c2e$var$Ir(t, e, n, o) {
    const r = n._window;
    if (null === r) return null;
    const i = o || r.event, s = i ? i.type : void 0, l = "selectionchange" === s, c = !$3e88191b87395c2e$var$it && (l || "beforeinput" === s || "compositionstart" === s || "compositionend" === s || "click" === s && i && 3 === i.detail || "drop" === s || void 0 === s);
    let a, u, f, d;
    if ($3e88191b87395c2e$export$181b63acea8a0224(t) && !c) return t.clone();
    {
        if (null === e) return null;
        const o = $3e88191b87395c2e$export$fca86712f5243a7e(e, n._rootElement);
        if (a = o.anchorNode, u = o.focusNode, f = o.anchorOffset, d = o.focusOffset, (l || void 0 === s) && $3e88191b87395c2e$export$181b63acea8a0224(t) && !$3e88191b87395c2e$export$f1b377b21cd6350b(n, a, u)) return t.clone();
    }
    const h = $3e88191b87395c2e$var$Or(a, f, u, d, n, t);
    if (null === h) return null;
    const [g, _, p] = h;
    let y = 0, m = "";
    if ($3e88191b87395c2e$export$181b63acea8a0224(t)) {
        const e = t.anchor;
        if (g.key === e.key) y = t.format, m = t.style;
        else {
            const t = g.getNode();
            $3e88191b87395c2e$export$471953706258be2b(t) ? (y = t.getFormat(), m = t.getStyle()) : $3e88191b87395c2e$export$923a058ef54437a4(t) && (y = t.getTextFormat(), m = t.getTextStyle());
        }
    }
    const x = new $3e88191b87395c2e$var$ar(g, _, y, m);
    return p && (x.dirty = !0), x;
}
function $3e88191b87395c2e$export$63a3201b3a5c7d90() {
    return $3e88191b87395c2e$var$di()._selection;
}
function $3e88191b87395c2e$export$846e9407a8b5d98c() {
    return $3e88191b87395c2e$var$gi()._editorState._selection;
}
function $3e88191b87395c2e$var$zr(t, e, n, o = 1) {
    const r = t.anchor, i = t.focus, s = r.getNode(), l = i.getNode();
    if (!e.is(s) && !e.is(l)) return;
    const c = e.__key;
    if (t.isCollapsed()) {
        const e = r.offset;
        if (n <= e && o > 0 || n < e && o < 0) {
            const n = Math.max(0, e + o);
            r.set(c, n, "element"), i.set(c, n, "element"), $3e88191b87395c2e$var$Br(t);
        }
    } else {
        const s = t.isBackward(), l = s ? i : r, a = l.getNode(), u = s ? r : i, f = u.getNode();
        if (e.is(a)) {
            const t = l.offset;
            (n <= t && o > 0 || n < t && o < 0) && l.set(c, Math.max(0, t + o), "element");
        }
        if (e.is(f)) {
            const t = u.offset;
            (n <= t && o > 0 || n < t && o < 0) && u.set(c, Math.max(0, t + o), "element");
        }
    }
    $3e88191b87395c2e$var$Br(t);
}
function $3e88191b87395c2e$var$Br(t) {
    const e = t.anchor, n = e.offset, o = t.focus, r = o.offset, i = e.getNode(), s = o.getNode();
    if (t.isCollapsed()) {
        if (!$3e88191b87395c2e$export$923a058ef54437a4(i)) return;
        const t = i.getChildrenSize(), r = n >= t, s = r ? i.getChildAtIndex(t - 1) : i.getChildAtIndex(n);
        if ($3e88191b87395c2e$export$471953706258be2b(s)) {
            let t = 0;
            r && (t = s.getTextContentSize()), e.set(s.__key, t, "text"), o.set(s.__key, t, "text");
        }
        return;
    }
    if ($3e88191b87395c2e$export$923a058ef54437a4(i)) {
        const t = i.getChildrenSize(), o = n >= t, r = o ? i.getChildAtIndex(t - 1) : i.getChildAtIndex(n);
        if ($3e88191b87395c2e$export$471953706258be2b(r)) {
            let t = 0;
            o && (t = r.getTextContentSize()), e.set(r.__key, t, "text");
        }
    }
    if ($3e88191b87395c2e$export$923a058ef54437a4(s)) {
        const t = s.getChildrenSize(), e = r >= t, n = e ? s.getChildAtIndex(t - 1) : s.getChildAtIndex(r);
        if ($3e88191b87395c2e$export$471953706258be2b(n)) {
            let t = 0;
            e && (t = n.getTextContentSize()), o.set(n.__key, t, "text");
        }
    }
}
function $3e88191b87395c2e$var$Rr(t, e, n, o, r) {
    let i = null, s = 0, l = null;
    null !== o ? (i = o.__key, $3e88191b87395c2e$export$471953706258be2b(o) ? (s = o.getTextContentSize(), l = "text") : $3e88191b87395c2e$export$923a058ef54437a4(o) && (s = o.getChildrenSize(), l = "element")) : null !== r && (i = r.__key, $3e88191b87395c2e$export$471953706258be2b(r) ? l = "text" : $3e88191b87395c2e$export$923a058ef54437a4(r) && (l = "element")), null !== i && null !== l ? t.set(i, s, l) : (s = e.getIndexWithinParent(), -1 === s && (s = n.getChildrenSize()), t.set(n.__key, s, "element"));
}
function $3e88191b87395c2e$var$Wr(t, e, n, o, r) {
    "text" === t.type ? t.set(n, t.offset + (e ? 0 : r), "text") : t.offset > o.getIndexWithinParent() && t.set(t.key, t.offset - 1, "element");
}
function $3e88191b87395c2e$var$Ur(t, e, n, o, r) {
    try {
        t.setBaseAndExtent(e, n, o, r);
    } catch (t) {}
}
function $3e88191b87395c2e$var$$r(t, e, n) {
    const o = $3e88191b87395c2e$var$bl(t, e.getKey());
    if ($3e88191b87395c2e$export$923a058ef54437a4(e)) {
        const r = $3e88191b87395c2e$export$724e988312a5b9ca(e, o, t);
        return [
            r.element,
            n + r.getFirstChildOffset()
        ];
    }
    return [
        o,
        n
    ];
}
function $3e88191b87395c2e$export$1e1970b9083661aa(t, e, n, o, r, s) {
    const l = s.getRootNode(), c = $3e88191b87395c2e$export$47ea8b9bb8a4c4de(l) || $3e88191b87395c2e$export$cbad3bd7ce195561(l) ? $3e88191b87395c2e$export$914ab019e7cf55b0(l) : null;
    if (r.has($3e88191b87395c2e$export$39d6d771d40857ac) && c !== s || null !== c && $3e88191b87395c2e$export$ceaabfa7ddeeb250(c, c)) return;
    const a = $3e88191b87395c2e$export$fca86712f5243a7e(o, s);
    let u;
    if (!$3e88191b87395c2e$export$181b63acea8a0224(e)) return void (null !== t && $3e88191b87395c2e$export$f1b377b21cd6350b(n, a.anchorNode, a.focusNode) && o.removeAllRanges());
    const f = e.anchor, d = e.focus, h = f.getNode(), g = d.getNode(), [_, p] = $3e88191b87395c2e$var$$r(n, h, f.offset), [y, m] = $3e88191b87395c2e$var$$r(n, g, d.offset), x = e.format, C = e.style, S = e.isCollapsed();
    let v = _, T = y, k = !1;
    if ("text" === f.type ? (v = $3e88191b87395c2e$export$471953706258be2b(h) ? $3e88191b87395c2e$export$118c63c491bd7ec(h, _, n) : null, k = h.getFormat() !== x || h.getStyle() !== C) : $3e88191b87395c2e$export$181b63acea8a0224(t) && "text" === t.anchor.type && (k = !0), "text" === d.type && (T = $3e88191b87395c2e$export$471953706258be2b(g) ? $3e88191b87395c2e$export$118c63c491bd7ec(g, y, n) : null), null !== v && null !== T) {
        if (S && (null === t || k || $3e88191b87395c2e$export$181b63acea8a0224(t) && (t.format !== x || t.style !== C)) && function(t, e, n, o, r, i) {
            t._inputState.collapsedSelectionFormat = {
                format: e,
                key: r,
                offset: o,
                style: n,
                timeStamp: i
            };
        }(n, x, C, p, f.key, performance.now()), ("Range" !== o.type || !S) && a.anchorOffset === p && a.focusOffset === m && a.anchorNode === v && a.focusNode === T) {
            if (null === c || !s.contains(c)) {
                const t = null !== c ? $3e88191b87395c2e$export$30c13854ab4c9903(c) : null;
                null !== t && t !== n || r.has($3e88191b87395c2e$export$8a1d07d516311732) || s.focus({
                    preventScroll: !0
                });
            }
            if ("element" !== f.type) return;
        }
        if ($3e88191b87395c2e$var$Ur(o, v, p, T, m), $3e88191b87395c2e$export$fa35291248be714f && e.isCollapsed() && null !== s && !r.has($3e88191b87395c2e$export$8a1d07d516311732)) {
            const t = $3e88191b87395c2e$export$cd4e5573fbe2b576(s);
            if (null === t || !s.contains(t)) {
                const t = $3e88191b87395c2e$export$914ab019e7cf55b0(s.ownerDocument), e = null !== t ? $3e88191b87395c2e$export$30c13854ab4c9903(t) : null;
                null !== e && e !== n || s.focus({
                    preventScroll: !0
                });
            }
        }
        if (!r.has($3e88191b87395c2e$export$e36816488e788f40) && e.isCollapsed() && null !== s && s === $3e88191b87395c2e$export$cd4e5573fbe2b576(s)) {
            const t = $3e88191b87395c2e$export$181b63acea8a0224(e) && "element" === e.anchor.type ? v.childNodes[p] || null : (void 0 === u && (u = $3e88191b87395c2e$export$341e1c1b48347df(o, s)), u);
            if (null !== t) {
                let e;
                if ($3e88191b87395c2e$export$4295c0f0b9b754c4(t)) {
                    const n = t.ownerDocument.createRange();
                    n.selectNode(t), e = n.getBoundingClientRect();
                } else e = t.getBoundingClientRect();
                !function(t, e, n) {
                    const o = $3e88191b87395c2e$export$43a91182e77c9b6d(n), r = $3e88191b87395c2e$var$Dl(o);
                    if (null === o || null === r) return;
                    const i = n.getBoundingClientRect();
                    if (e.bottom < i.top) return;
                    let { top: s, bottom: l } = e, c = 0, a = 0, u = n;
                    for(; null !== u;){
                        const e = u === o.body;
                        if (e) {
                            const e = r.visualViewport;
                            if (e) {
                                const t = e.offsetTop;
                                c = t, a = t + e.height;
                            } else c = 0, a = $3e88191b87395c2e$var$Pl(t).innerHeight;
                            const n = r.getComputedStyle(o.documentElement), i = parseFloat(n.scrollPaddingTop), s = parseFloat(n.scrollPaddingBottom);
                            isFinite(i) && (c += i), isFinite(s) && (a -= s);
                        } else {
                            const t = u === n ? i : u.getBoundingClientRect();
                            c = t.top, a = t.bottom;
                        }
                        let f = 0;
                        if (s < c ? f = -(c - s) : l > a && (f = l - a), 0 !== f) {
                            if (e) r.scrollBy(0, f);
                            else {
                                const t = u.scrollTop;
                                u.scrollTop += f;
                                const e = u.scrollTop - t;
                                s -= e, l -= e;
                            }
                        }
                        if (e) break;
                        u = $3e88191b87395c2e$export$169e5491001d3ed6(u);
                    }
                }(n, e, s);
            }
        }
        !function(t) {
            t._inputState.isSelectionChangeFromDOMUpdate = !0;
        }(n);
    }
}
function $3e88191b87395c2e$export$d773017360b45449(t) {
    let e = $3e88191b87395c2e$export$63a3201b3a5c7d90() || $3e88191b87395c2e$export$846e9407a8b5d98c();
    null === e && (e = $3e88191b87395c2e$export$8d83ea843c4eea9a().selectEnd()), e.insertNodes(t);
}
function $3e88191b87395c2e$export$31e7aa1b3b383742(t, e) {
    for (const n of t.split(/(\r?\n|\t)/))"\n" === n || "\r\n" === n ? e.linebreak() : "\t" === n ? e.tab() : "" !== n && e.text(n);
}
function $3e88191b87395c2e$export$34f16fe1ef81eac4(t) {
    const e = [];
    return $3e88191b87395c2e$export$31e7aa1b3b383742(t, {
        linebreak: ()=>e.push($3e88191b87395c2e$export$4ccaf7d0d16ab4c()),
        tab: ()=>e.push($3e88191b87395c2e$export$5bde9d58a1da0796()),
        text: (t)=>e.push($3e88191b87395c2e$export$2785f39dcdec0078(t))
    }), e;
}
function $3e88191b87395c2e$export$2d96f9a07231d1b9() {
    const t = $3e88191b87395c2e$export$63a3201b3a5c7d90();
    return null === t ? "" : t.getTextContent();
}
function $3e88191b87395c2e$var$Yr(t) {
    const e = [];
    for (const n of t)$3e88191b87395c2e$export$b16330e40aa25c4e(n) || (!$3e88191b87395c2e$export$923a058ef54437a4(n) && !$3e88191b87395c2e$export$60aa03725ce41b1c(n) || n.isInline() ? e.push(n) : $3e88191b87395c2e$export$923a058ef54437a4(n) && e.push(...$3e88191b87395c2e$var$Yr(n.getChildren())));
    return e;
}
function $3e88191b87395c2e$var$Gr(e) {
    let n = e;
    e.isCollapsed() || n.removeText();
    const o = $3e88191b87395c2e$export$63a3201b3a5c7d90();
    $3e88191b87395c2e$export$181b63acea8a0224(o) && (n = o), $3e88191b87395c2e$export$181b63acea8a0224(n) || $3e88191b87395c2e$var$t(161);
    const r = n.anchor;
    let i = r.getNode(), s = r.offset;
    for(; !$3e88191b87395c2e$export$bd7ca521104e245c(i) && null === $3e88191b87395c2e$var$Xc(i);){
        const t = i;
        if ([i, s] = $3e88191b87395c2e$var$Xr(i, s), t.is(i)) break;
    }
    return s;
}
function $3e88191b87395c2e$var$Xr(t, e) {
    const n = t.getParent();
    if (!n) {
        const t = $3e88191b87395c2e$export$7f0c05ffb7ced90d();
        return $3e88191b87395c2e$export$8d83ea843c4eea9a().append(t), t.select(), [
            $3e88191b87395c2e$export$8d83ea843c4eea9a(),
            0
        ];
    }
    if ($3e88191b87395c2e$export$471953706258be2b(t)) {
        const o = t.splitText(e);
        if (0 === o.length) return [
            n,
            t.getIndexWithinParent()
        ];
        const r = 0 === e ? 0 : 1;
        return [
            n,
            o[0].getIndexWithinParent() + r
        ];
    }
    if (!$3e88191b87395c2e$export$923a058ef54437a4(t) || 0 === e) return [
        n,
        t.getIndexWithinParent()
    ];
    const o = t.getChildAtIndex(e);
    if (o) {
        const n = new $3e88191b87395c2e$var$ar($3e88191b87395c2e$export$9b3f8d373c057995(t.__key, e, "element"), $3e88191b87395c2e$export$9b3f8d373c057995(t.__key, e, "element"), 0, ""), r = t.insertNewAfter(n);
        r && r.append(o, ...o.getNextSiblings());
    }
    return [
        n,
        t.getIndexWithinParent() + 1
    ];
}
function $3e88191b87395c2e$var$Qr(t) {
    return $3e88191b87395c2e$export$b16330e40aa25c4e(t) || $3e88191b87395c2e$export$a78813a4e8e8b9dd(t) || $3e88191b87395c2e$export$471953706258be2b(t) || t.isParentRequired();
}
function $3e88191b87395c2e$var$Zr(t) {
    const e = $3e88191b87395c2e$export$7f0c05ffb7ced90d();
    let n = null;
    for(let o = 0; o < t.length; o++){
        const r = t[o];
        if ($3e88191b87395c2e$var$Qr(r)) {
            if (null === n) {
                n = r.createParentElementNode(), e.append(n);
                const i = t[o + 1];
                if ($3e88191b87395c2e$export$b16330e40aa25c4e(r) && (void 0 === i || !$3e88191b87395c2e$var$Qr(i))) continue;
            }
            n.append(r);
        } else e.append(r), n = null;
    }
    return e;
}
function $3e88191b87395c2e$var$ti(t, e, n, o, r = "decorators-and-blocks") {
    if ("move" === e && "character" === o && !t.isCollapsed()) {
        const [e, o] = n === t.isBackward() ? [
            t.focus,
            t.anchor
        ] : [
            t.anchor,
            t.focus
        ];
        return o.set(e.key, e.offset, e.type), !0;
    }
    const i = $3e88191b87395c2e$export$e435a0def9eb2000(t.focus, n ? "previous" : "next"), s = "lineboundary" === o, l = "move" === e;
    let c = i, a = "decorators-and-blocks" === r;
    if (!$3e88191b87395c2e$export$2b09d6371b5f4203(c)) {
        for (const t of c){
            a = !1;
            const { origin: e } = t;
            if (!$3e88191b87395c2e$export$60aa03725ce41b1c(e) || e.isIsolated() || (c = t, !s || !e.isInline())) break;
        }
        if (a) for (const t of $3e88191b87395c2e$export$7f1827f6551d91c3(i).iterNodeCarets("extend" === e ? "shadowRoot" : "root")){
            if ($3e88191b87395c2e$export$1c3da6f3e60ca260(t)) t.origin.isInline() || (c = t);
            else {
                if ($3e88191b87395c2e$export$923a058ef54437a4(t.origin)) continue;
                $3e88191b87395c2e$export$60aa03725ce41b1c(t.origin) && !t.origin.isInline() && (c = t);
            }
            break;
        }
    }
    if (c === i) return !1;
    if (l && !s && $3e88191b87395c2e$export$60aa03725ce41b1c(c.origin) && c.origin.isKeyboardSelectable()) {
        const t = $3e88191b87395c2e$export$f8cd0c3f35d1a61c();
        return t.add(c.origin.getKey()), $3e88191b87395c2e$export$2aad78c37810bca9(t), !0;
    }
    return c = $3e88191b87395c2e$export$33e015e8f2ff8536(c), l && $3e88191b87395c2e$export$dd601b22fa430ce6(t.anchor, c), $3e88191b87395c2e$export$dd601b22fa430ce6(t.focus, c), a || !s;
}
let $3e88191b87395c2e$var$ei = null, $3e88191b87395c2e$var$ni = null, $3e88191b87395c2e$var$oi = !1, $3e88191b87395c2e$var$ri = !1, $3e88191b87395c2e$var$ii = !1;
const $3e88191b87395c2e$var$si = new Set;
let $3e88191b87395c2e$var$li = 0;
const $3e88191b87395c2e$var$ci = {
    characterData: !0,
    childList: !0,
    subtree: !0
};
function $3e88191b87395c2e$export$761df28585b755e8() {
    return $3e88191b87395c2e$var$oi || null !== $3e88191b87395c2e$var$ei && $3e88191b87395c2e$var$ei._readOnly;
}
function $3e88191b87395c2e$var$ui() {
    $3e88191b87395c2e$var$oi && $3e88191b87395c2e$var$t(13);
}
function $3e88191b87395c2e$var$fi() {
    $3e88191b87395c2e$var$li > 99 && $3e88191b87395c2e$var$t(14);
}
function $3e88191b87395c2e$var$di() {
    return null === $3e88191b87395c2e$var$ei && $3e88191b87395c2e$var$t(195, $3e88191b87395c2e$var$pi()), $3e88191b87395c2e$var$ei;
}
function $3e88191b87395c2e$export$d5c083845dcac446(t) {
    null !== $3e88191b87395c2e$var$di() && null === $3e88191b87395c2e$var$ni && ($3e88191b87395c2e$var$ni = t), $3e88191b87395c2e$var$ni !== t && $3e88191b87395c2e$var$e(378);
}
function $3e88191b87395c2e$var$gi() {
    return null === $3e88191b87395c2e$var$ni && $3e88191b87395c2e$var$t(337, $3e88191b87395c2e$var$pi()), $3e88191b87395c2e$var$ni;
}
function $3e88191b87395c2e$export$d05b7cf3bb138003() {
    $3e88191b87395c2e$var$gi()._dirtyType = 2;
}
function $3e88191b87395c2e$var$pi() {
    let t = 0;
    const e = new Set, n = $3e88191b87395c2e$var$xs.version;
    if ("undefined" != typeof window) for (const o of $3e88191b87395c2e$export$5ec8835222827c6b(document)){
        const r = $3e88191b87395c2e$export$40676f02fb121ce2(o);
        if ($3e88191b87395c2e$export$811e9996da830291(r)) t++;
        else if (r) {
            let t = String(r.constructor.version || "<0.17.1");
            t === n && (t += " (separately built, likely a bundler configuration issue)"), e.add(t);
        }
    }
    let o = ` Detected on the page: ${t} compatible editor(s) with version ${n}`;
    return e.size && (o += ` and incompatible editors with versions ${Array.from(e).join(", ")}`), o;
}
function $3e88191b87395c2e$var$yi() {
    return $3e88191b87395c2e$var$ni;
}
function $3e88191b87395c2e$var$mi(t, e, n) {
    const o = e.__type, r = $3e88191b87395c2e$export$8988849ce1143792(t, o);
    let i = n.get(o);
    void 0 === i && (i = Array.from(r.transforms), n.set(o, i));
    const s = i.length;
    for(let t = 0; t < s && (i[t](e), e.isAttached()); t++);
}
function $3e88191b87395c2e$var$xi(t, e) {
    return void 0 !== t && t.__key !== e && t.isAttached();
}
function $3e88191b87395c2e$var$Ci(t, e) {
    if (!e) return;
    const n = t._updateTags;
    let o = e;
    Array.isArray(e) || (o = [
        e
    ]);
    for (const t of o)n.add(t);
}
function $3e88191b87395c2e$export$e1d3a194df5be556(t) {
    return $3e88191b87395c2e$var$vi(t, $3e88191b87395c2e$var$gi()._nodes);
}
function $3e88191b87395c2e$var$vi(e, n) {
    const o = e.type, r = n.get(o);
    void 0 === r && $3e88191b87395c2e$var$t(17, o);
    const i = r.klass;
    e.type !== i.getType() && $3e88191b87395c2e$var$t(18, i.name);
    const s = i.importJSON(e), l = e.children;
    if ($3e88191b87395c2e$export$923a058ef54437a4(s) && Array.isArray(l)) for(let t = 0; t < l.length; t++){
        const e = $3e88191b87395c2e$var$vi(l[t], n);
        s.append(e);
    }
    const c = e.$slots;
    if (c) {
        $3e88191b87395c2e$export$e14ad7e55d229066(s) || $3e88191b87395c2e$var$t(379, i.name);
        for(const t in c)$3e88191b87395c2e$export$74e604a6c813bb6f(s, t, $3e88191b87395c2e$var$vi(c[t], n));
    }
    return s;
}
function $3e88191b87395c2e$var$Ti(t, e, n) {
    const o = $3e88191b87395c2e$var$ei, r = $3e88191b87395c2e$var$oi, i = $3e88191b87395c2e$var$ni;
    $3e88191b87395c2e$var$ei = e, $3e88191b87395c2e$var$oi = !0, $3e88191b87395c2e$var$ni = t;
    try {
        return n();
    } finally{
        $3e88191b87395c2e$var$ei = o, $3e88191b87395c2e$var$oi = r, $3e88191b87395c2e$var$ni = i;
    }
}
function $3e88191b87395c2e$var$ki(t, e) {
    const n = $3e88191b87395c2e$var$ii;
    $3e88191b87395c2e$var$ii = !0;
    try {
        !function(t, e) {
            const n = t._pendingEditorState, o = t._rootElement, r = t._headless || null === o;
            if (null === n) return void (!t._updating && t._deferred.length > 0 && $3e88191b87395c2e$var$wi(t, t._deferred));
            const i = t._editorState, s = i._selection, l = n._selection, c = 0 !== t._dirtyType, a = $3e88191b87395c2e$var$ei, u = $3e88191b87395c2e$var$oi, f = $3e88191b87395c2e$var$ni, d = t._updating, h = t._observer;
            let g = null;
            if (t._pendingEditorState = null, t._editorState = n, !r && c && null !== h) {
                $3e88191b87395c2e$var$ni = t, $3e88191b87395c2e$var$ei = n, $3e88191b87395c2e$var$oi = !1, t._updating = !0;
                try {
                    const e = t._dirtyType, o = t._dirtyElements, r = t._dirtyLeaves;
                    h.disconnect(), g = $3e88191b87395c2e$var$De(i, n, t, e, o, r);
                } catch (e) {
                    if (e instanceof Error && t._onError(e), $3e88191b87395c2e$var$ri) throw e;
                    return $3e88191b87395c2e$var$hs(t, null, o, n), $3e88191b87395c2e$var$gt(t), t._dirtyType = 2, $3e88191b87395c2e$var$ri = !0, $3e88191b87395c2e$var$ki(t, i), void ($3e88191b87395c2e$var$ri = !1);
                } finally{
                    h.observe(o, $3e88191b87395c2e$var$ci), t._updating = d, $3e88191b87395c2e$var$ei = a, $3e88191b87395c2e$var$oi = u, $3e88191b87395c2e$var$ni = f;
                }
            }
            n._readOnly || (n._readOnly = !0);
            const _ = t._dirtyLeaves, p = t._dirtyElements, y = t._normalizedNodes, m = t._updateTags;
            c && (t._dirtyType = 0, t._cloneNotNeeded.clear(), t._dirtyLeaves = new Set, t._dirtyElements = new Map, t._normalizedNodes = new Set);
            t._updateTags = new Set, function(t, e) {
                const n = t._decorators;
                let o = t._pendingDecorators || n;
                const r = e._nodeMap;
                let i;
                for(i in o)r.has(i) || (o === n && (o = $3e88191b87395c2e$var$Qs(t)), delete o[i]);
            }(t, n);
            const x = r ? null : $3e88191b87395c2e$export$74c14770a0819525($3e88191b87395c2e$var$Pl(t));
            if (t._editable && null !== x && (c || null === l || l.dirty || !l.is(s)) && null !== o && !m.has($3e88191b87395c2e$export$2d54a03edd17ad1f)) {
                $3e88191b87395c2e$var$ni = t, $3e88191b87395c2e$var$ei = n;
                try {
                    if (null !== h && h.disconnect(), c || null === l || l.dirty) {
                        const e = t._blockCursorElement;
                        null !== e && $3e88191b87395c2e$var$$l(e, t, o), $3e88191b87395c2e$export$1e1970b9083661aa(s, l, t, x, m, o);
                    }
                    !function(t, e, n) {
                        let o = t._blockCursorElement;
                        if ($3e88191b87395c2e$export$181b63acea8a0224(n) && n.isCollapsed() && "element" === n.anchor.type && e.contains($3e88191b87395c2e$export$cd4e5573fbe2b576(e))) {
                            const r = n.anchor, i = r.getNode(), s = r.offset;
                            let l = !1, c = null;
                            if (s === i.getChildrenSize()) $3e88191b87395c2e$export$7a90539e4eb02726(i.getChildAtIndex(s - 1)) && (l = !0);
                            else {
                                const e = i.getChildAtIndex(s);
                                if (null !== e && $3e88191b87395c2e$export$7a90539e4eb02726(e)) {
                                    const n = e.getPreviousSibling();
                                    (null === n || $3e88191b87395c2e$export$7a90539e4eb02726(n)) && (l = !0, c = t.getElementByKey(e.__key));
                                }
                            }
                            if (l) {
                                const n = $3e88191b87395c2e$export$724e988312a5b9ca(i, t.getElementByKey(i.__key), t).element;
                                return null === o && (t._blockCursorElement = o = function(t) {
                                    const e = t.theme, n = $3e88191b87395c2e$export$db1ba3824aa1e742().createElement("div");
                                    n.contentEditable = "false", n.setAttribute("data-lexical-cursor", "true");
                                    let o = e.blockCursor;
                                    if (void 0 !== o) {
                                        if ("string" == typeof o) {
                                            const t = $3e88191b87395c2e$export$68575042fda37fa9(o);
                                            o = e.blockCursor = t;
                                        }
                                        void 0 !== o && n.classList.add(...o);
                                    }
                                    return n;
                                }(t._config)), e.style.caretColor = "transparent", void (null === c ? n.appendChild(o) : n.insertBefore(o, c));
                            }
                        }
                        null !== o && $3e88191b87395c2e$var$$l(o, t, e);
                    }(t, o, l);
                } finally{
                    null !== h && h.observe(o, $3e88191b87395c2e$var$ci), $3e88191b87395c2e$var$ni = f, $3e88191b87395c2e$var$ei = a;
                }
            }
            null !== g && function(t, e, n, o, r) {
                const i = Array.from(t._listeners.mutation), s = i.length;
                for(let t = 0; t < s; t++){
                    const [s, l] = i[t];
                    for (const t of l){
                        const i = e.get(t);
                        void 0 !== i && s(i, {
                            dirtyLeaves: o,
                            prevEditorState: r,
                            updateTags: n
                        });
                    }
                }
            }(t, g, m, _, i);
            $3e88191b87395c2e$export$181b63acea8a0224(l) || null === l || null !== s && s.is(l) || t.dispatchCommand($3e88191b87395c2e$export$e396fef71d2b56e5, void 0);
            const C = t._pendingDecorators;
            null !== C && (t._decorators = C, t._pendingDecorators = null, $3e88191b87395c2e$var$bi("decorator", t, !0, C));
            if (function(t, e, n) {
                const o = $3e88191b87395c2e$var$Zs(e), r = $3e88191b87395c2e$var$Zs(n);
                o !== r && $3e88191b87395c2e$var$bi("textcontent", t, !0, r);
            }(t, e || i, n), $3e88191b87395c2e$var$bi("update", t, !0, {
                dirtyElements: p,
                dirtyLeaves: _,
                editorState: n,
                mutatedNodes: g,
                normalizedNodes: y,
                prevEditorState: e || i,
                tags: m
            }), !d) $3e88191b87395c2e$var$wi(t, t._deferred);
            !function(t) {
                const e = t._updates;
                if (0 === e.length) return void (t._cascadeCount = 0);
                if (function(t) {
                    if ($3e88191b87395c2e$var$si.has(t)) return;
                    $3e88191b87395c2e$var$si.add(t), setTimeout(()=>{
                        $3e88191b87395c2e$var$si.delete(t), t._cascadeCount = 0;
                    }, 0);
                }(t), t._cascadeCount++ > 99) return t._updates = [], t._cascadeCount = 0, void t._onWarn(new Error(`One or more update listeners are endlessly enqueueing more updates. May have encountered infinite recursion caused by update listeners that trigger additional updates without a stop condition. Editor namespace: ${t._config.namespace}`));
                const n = e.shift();
                if (n) {
                    const [e, o] = n;
                    $3e88191b87395c2e$var$Oi(t, e, o);
                }
            }(t);
        }(t, e);
    } finally{
        $3e88191b87395c2e$var$ii = n;
    }
}
function $3e88191b87395c2e$var$bi(t, e, n, ...o) {
    const r = e._updating;
    e._updating = n;
    try {
        const n = e._listeners[t], r = Array.from(n);
        for (const [t, e] of r){
            e && e();
            const r = t(...o);
            n.has(t) ? n.set(t, r) : r && r();
        }
    } finally{
        e._updating = r;
    }
}
function $3e88191b87395c2e$var$Ni(t, e, n, o) {
    const r = $3e88191b87395c2e$var$il(t);
    let i;
    if (!$3e88191b87395c2e$var$ii) for(let t = 0; t < r.length; t++)r[t]._updating || (r[t]._cascadeCount = 0);
    for(let t = 4; t >= 0; t--)for(let s = 0; s < r.length; s++){
        const l = r[s];
        if (s > 0 && l._updating) {
            i = l;
            break;
        }
        const c = l._commands.get(e);
        if (void 0 !== c) {
            const e = c[t];
            if (e.size > 0) {
                let t = !1;
                if ($3e88191b87395c2e$var$Mi(l, ()=>{
                    for (const r of e)if (r(n, o)) return void (t = !0);
                }), t) return t;
            }
        }
    }
    return i && i.update(()=>{
        $3e88191b87395c2e$var$Ni(i, e, n, o);
    }), !1;
}
function $3e88191b87395c2e$var$wi(t, e) {
    if (t._deferred = [], 0 !== e.length) {
        const n = t._updating;
        t._updating = !0;
        try {
            for(let t = 0; t < e.length; t++)e[t]();
        } finally{
            t._updating = n;
        }
    }
}
function $3e88191b87395c2e$var$Ei(e, n) {
    const o = e._updates;
    let r = n || !1;
    for(; 0 !== o.length;){
        const n = o.shift();
        if (n) {
            const [o, i] = n, s = e._pendingEditorState;
            let l;
            void 0 !== i && (l = i.onUpdate, i.skipTransforms && (r = !0), i.discrete && (null === s && $3e88191b87395c2e$var$t(191), s._flushSync = !0), l && e._deferred.push(l), $3e88191b87395c2e$var$Ci(e, i.tag)), null == s ? $3e88191b87395c2e$var$Oi(e, o, i) : o();
        }
    }
    return r;
}
function $3e88191b87395c2e$var$Oi(e, n, o) {
    const r = e._updateTags;
    let i, s = !1, l = !1;
    void 0 !== o && (i = o.onUpdate, $3e88191b87395c2e$var$Ci(e, o.tag), s = o.skipTransforms || !1, l = o.discrete || !1), i && e._deferred.push(i);
    const c = e._editorState;
    let a = e._pendingEditorState, u = !1;
    (null === a || a._readOnly) && (a = e._pendingEditorState = $3e88191b87395c2e$var$Bi(a || c), u = !0), a._flushSync = l;
    const f = $3e88191b87395c2e$var$ei, d = $3e88191b87395c2e$var$oi, h = $3e88191b87395c2e$var$ni, g = e._updating;
    $3e88191b87395c2e$var$ei = a, $3e88191b87395c2e$var$oi = !1, e._updating = !0, $3e88191b87395c2e$var$ni = e;
    const _ = e._headless || null === e.getRootElement();
    $3e88191b87395c2e$var$Ss(null);
    try {
        u && (_ ? null !== c._selection && (a._selection = c._selection.clone()) : a._selection = function(t, e) {
            const n = t.getEditorState()._selection, o = $3e88191b87395c2e$export$74c14770a0819525($3e88191b87395c2e$var$Pl(t));
            return $3e88191b87395c2e$export$181b63acea8a0224(n) || null == n ? $3e88191b87395c2e$var$Ir(n, o, t, e) : n.clone();
        }(e, o && o.event || null));
        const r = e._compositionKey;
        n(), s = $3e88191b87395c2e$var$Ei(e, s), function(t, e) {
            const n = e.getEditorState()._selection, o = t._selection;
            if ($3e88191b87395c2e$export$181b63acea8a0224(o)) {
                const t = o.anchor, e = o.focus;
                let r;
                if ("text" === t.type && (r = t.getNode(), r.selectionTransform(n, o)), "text" === e.type) {
                    const t = e.getNode();
                    r !== t && t.selectionTransform(n, o);
                }
            }
        }(a, e), 0 !== e._dirtyType && (s ? function(t, e) {
            const n = e._dirtyLeaves, o = t._nodeMap;
            for (const t of n){
                const e = o.get(t);
                $3e88191b87395c2e$export$471953706258be2b(e) && e.isAttached() && e.isSimpleText() && !e.isUnmergeable() && $3e88191b87395c2e$var$Ft(e);
            }
        }(a, e) : function(t, e) {
            const n = e._dirtyLeaves, o = e._dirtyElements, r = t._nodeMap, i = $3e88191b87395c2e$var$js(), s = new Map;
            let l = n, c = l.size, a = o, u = a.size;
            for(; c > 0 || u > 0;){
                if (c > 0) {
                    e._dirtyLeaves = new Set;
                    for (const t of l){
                        const o = r.get(t);
                        $3e88191b87395c2e$export$471953706258be2b(o) && o.isAttached() && o.isSimpleText() && !o.isUnmergeable() && $3e88191b87395c2e$var$Ft(o), void 0 !== o && $3e88191b87395c2e$var$xi(o, i) && $3e88191b87395c2e$var$mi(e, o, s), n.add(t);
                    }
                    if (l = e._dirtyLeaves, c = l.size, c > 0) {
                        $3e88191b87395c2e$var$li++;
                        continue;
                    }
                }
                e._dirtyLeaves = new Set, e._dirtyElements = new Map, a.delete("root") && a.set("root", !0);
                for (const t of a){
                    const n = t[0], l = t[1];
                    if (o.set(n, l), !l) continue;
                    const c = r.get(n);
                    void 0 !== c && $3e88191b87395c2e$var$xi(c, i) && $3e88191b87395c2e$var$mi(e, c, s);
                }
                l = e._dirtyLeaves, c = l.size, a = e._dirtyElements, u = a.size, $3e88191b87395c2e$var$li++;
            }
            e._dirtyLeaves = n, e._dirtyElements = o;
        }(a, e), $3e88191b87395c2e$var$Ei(e), function(t, e, n, o) {
            const r = t._nodeMap, i = e._nodeMap, s = [];
            for (const [t] of o){
                const e = i.get(t);
                void 0 !== e && (e.isAttached() || ($3e88191b87395c2e$export$923a058ef54437a4(e) && $3e88191b87395c2e$var$rt(e, t, r, i, s, o), r.has(t) || o.delete(t), s.push(t)));
            }
            for (const t of n){
                const e = i.get(t);
                void 0 === e || e.isAttached() || ($3e88191b87395c2e$export$e14ad7e55d229066(e) && null !== e.__slots && $3e88191b87395c2e$var$rt(e, t, r, i, s, n), r.has(t) || n.delete(t), s.push(t));
            }
            for (const t of s)i.delete(t);
            const l = $3e88191b87395c2e$var$gi(), c = l._compositionKey;
            null === c || i.has(c) || (l._compositionKey = null);
        }(c, a, e._dirtyLeaves, e._dirtyElements));
        r !== e._compositionKey && (a._flushSync = !0);
        const i = a._selection;
        if ($3e88191b87395c2e$export$181b63acea8a0224(i)) {
            e._slotsUsed && $3e88191b87395c2e$var$Er(i);
            const n = a._nodeMap, o = i.anchor.key, r = i.focus.key;
            void 0 !== n.get(o) && void 0 !== n.get(r) || $3e88191b87395c2e$var$t(19);
        } else $3e88191b87395c2e$export$7257e4181651a7c3(i) && 0 === i._nodes.size && (a._selection = null);
    } catch (t) {
        return t instanceof Error && e._onError(t), e._pendingEditorState = c, e._dirtyType = 2, e._cloneNotNeeded.clear(), e._dirtyLeaves = new Set, e._dirtyElements.clear(), void $3e88191b87395c2e$var$ki(e);
    } finally{
        $3e88191b87395c2e$var$ei = f, $3e88191b87395c2e$var$oi = d, $3e88191b87395c2e$var$ni = h, e._updating = g, $3e88191b87395c2e$var$li = 0;
    }
    const p = 0 !== e._dirtyType || e._deferred.length > 0 || function(t, e) {
        const n = e.getEditorState()._selection, o = t._selection;
        if (null !== o) {
            if (o.dirty || !o.is(n)) return !0;
        } else if (null !== n) return !0;
        return !1;
    }(a, e);
    p ? a._flushSync ? (a._flushSync = !1, $3e88191b87395c2e$var$ki(e)) : u && $3e88191b87395c2e$var$Ns(()=>{
        $3e88191b87395c2e$var$ki(e);
    }) : (a._flushSync = !1, u && (r.clear(), e._deferred = [], e._pendingEditorState = null));
}
function $3e88191b87395c2e$var$Mi(t, e, n) {
    $3e88191b87395c2e$var$ni === t && void 0 === n ? e() : $3e88191b87395c2e$var$Oi(t, e, n);
}
function $3e88191b87395c2e$var$Ai(t) {
    if ($3e88191b87395c2e$export$6f851a24c61146af(t)) {
        let e = null;
        for (const n of t.getChildren())e = n.isInline() ? (e || n.replace(n.createParentElementNode())).append(n) : null;
    }
}
class $3e88191b87395c2e$export$dc064fe9e59310fd extends $3e88191b87395c2e$var$_o {
    $config() {
        return this.config(Symbol.for("ElementNode"), {
            $transform: $3e88191b87395c2e$var$Ai,
            extends: $3e88191b87395c2e$var$_o
        });
    }
    afterCloneFrom(e) {
        super.afterCloneFrom(e), this.__key === e.__key && (this.__first = e.__first, this.__last = e.__last, this.__size = e.__size, this.__slotHost = e.__slotHost, null !== this.__slotHost && null !== this.__parent && $3e88191b87395c2e$var$t(384, this.__key, String(this.__slotHost), String(this.__parent)), this.__slots = e.__slots), this.__indent = e.__indent, this.__format = e.__format, this.__style = e.__style, this.__dir = e.__dir, this.__textFormat = e.__textFormat, this.__textStyle = e.__textStyle;
    }
    getFormat() {
        return this.getLatest().__format;
    }
    getFormatType() {
        const t = this.getFormat();
        return $3e88191b87395c2e$var$W[t] || "";
    }
    getStyle() {
        return this.getLatest().__style;
    }
    getIndent() {
        return this.getLatest().__indent;
    }
    getChildren() {
        const t = [];
        let e = this.getFirstChild();
        for(; null !== e;)t.push(e), e = e.getNextSibling();
        return t;
    }
    getChildrenKeys() {
        const t = [];
        let e = this.getFirstChild();
        for(; null !== e;)t.push(e.__key), e = e.getNextSibling();
        return t;
    }
    getChildrenSize() {
        return this.getLatest().__size;
    }
    isEmpty() {
        return 0 === this.getChildrenSize() && 0 === $3e88191b87395c2e$export$c83fc7fbb76e480a(this).length;
    }
    isDirty() {
        const t = $3e88191b87395c2e$var$gi()._dirtyElements;
        return null !== t && t.has(this.__key);
    }
    isLastChild() {
        const t = this.getLatest(), e = this.getParentOrThrow().getLastChild();
        return null !== e && e.is(t);
    }
    getAllTextNodes() {
        const t = [];
        for (const e of $3e88191b87395c2e$export$c83fc7fbb76e480a(this)){
            const n = $3e88191b87395c2e$export$ea4162355720819(this, e);
            $3e88191b87395c2e$export$923a058ef54437a4(n) && t.push(...n.getAllTextNodes());
        }
        let e = this.getFirstChild();
        for(; null !== e;){
            if ($3e88191b87395c2e$export$471953706258be2b(e) && t.push(e), $3e88191b87395c2e$export$923a058ef54437a4(e)) {
                const n = e.getAllTextNodes();
                t.push(...n);
            }
            e = e.getNextSibling();
        }
        return t;
    }
    getFirstDescendant() {
        let t = this.getFirstChild();
        for(; $3e88191b87395c2e$export$923a058ef54437a4(t);){
            const e = t.getFirstChild();
            if (null === e) break;
            t = e;
        }
        return t;
    }
    getLastDescendant() {
        let t = this.getLastChild();
        for(; $3e88191b87395c2e$export$923a058ef54437a4(t);){
            const e = t.getLastChild();
            if (null === e) break;
            t = e;
        }
        return t;
    }
    getDescendantByIndex(t) {
        const e = this.getChildren(), n = e.length;
        if (t >= n) {
            const t = e[n - 1];
            return $3e88191b87395c2e$export$923a058ef54437a4(t) && t.getLastDescendant() || t || null;
        }
        const o = e[t];
        return $3e88191b87395c2e$export$923a058ef54437a4(o) && o.getFirstDescendant() || o || null;
    }
    getFirstChild() {
        const t = this.getLatest().__first;
        return null === t ? null : $3e88191b87395c2e$export$e725f93d4d48c6d8(t);
    }
    getFirstChildOrThrow() {
        const e = this.getFirstChild();
        return null === e && $3e88191b87395c2e$var$t(45, this.__key), e;
    }
    getLastChild() {
        const t = this.getLatest().__last;
        return null === t ? null : $3e88191b87395c2e$export$e725f93d4d48c6d8(t);
    }
    getLastChildOrThrow() {
        const e = this.getLastChild();
        return null === e && $3e88191b87395c2e$var$t(96, this.__key), e;
    }
    getChildAtIndex(t) {
        const e = this.getChildrenSize();
        let n, o;
        if (t < e / 2) {
            for(n = this.getFirstChild(), o = 0; null !== n && o <= t;){
                if (o === t) return n;
                n = n.getNextSibling(), o++;
            }
            return null;
        }
        for(n = this.getLastChild(), o = e - 1; null !== n && o >= t;){
            if (o === t) return n;
            n = n.getPreviousSibling(), o--;
        }
        return null;
    }
    getTextContent() {
        let t = $3e88191b87395c2e$var$ua(this);
        const e = this.getChildren(), n = e.length;
        for(let o = 0; o < n; o++){
            const r = e[o];
            t += r.getTextContent(), $3e88191b87395c2e$export$923a058ef54437a4(r) && o !== n - 1 && !r.isInline() && (t += $3e88191b87395c2e$var$D);
        }
        return t;
    }
    getTextContentSize() {
        let t = function(t) {
            let e = 0;
            for (const n of $3e88191b87395c2e$export$c83fc7fbb76e480a(t)){
                const o = $3e88191b87395c2e$export$ea4162355720819(t, n);
                null !== o && (e += o.getTextContentSize());
            }
            return e;
        }(this);
        const e = this.getChildren(), n = e.length;
        for(let o = 0; o < n; o++){
            const r = e[o];
            t += r.getTextContentSize(), $3e88191b87395c2e$export$923a058ef54437a4(r) && o !== n - 1 && !r.isInline() && (t += 2);
        }
        return t;
    }
    getDirection() {
        return this.getLatest().__dir;
    }
    getTextFormat() {
        return this.getLatest().__textFormat;
    }
    hasFormat(t) {
        if ("" !== t) {
            const e = $3e88191b87395c2e$var$R[t];
            return 0 !== (this.getFormat() & e);
        }
        return !1;
    }
    hasTextFormat(t) {
        const e = $3e88191b87395c2e$export$c9e7d6eb65b13430[t];
        return 0 !== (this.getTextFormat() & e);
    }
    getFormatFlags(t, e) {
        return $3e88191b87395c2e$export$bfd35cbfa01f02e5(this.getLatest().__textFormat, t, e);
    }
    getTextStyle() {
        return this.getLatest().__textStyle;
    }
    select(t, e) {
        $3e88191b87395c2e$var$ui();
        const n = $3e88191b87395c2e$export$63a3201b3a5c7d90();
        let o = t, r = e;
        const i = this.getChildrenSize();
        if (!this.canBeEmpty()) {
            if (0 === t && 0 === e) {
                const t = this.getFirstChild();
                if ($3e88191b87395c2e$export$471953706258be2b(t) || $3e88191b87395c2e$export$923a058ef54437a4(t)) return t.select(0, 0);
            } else if (!(void 0 !== t && t !== i || void 0 !== e && e !== i)) {
                const t = this.getLastChild();
                if ($3e88191b87395c2e$export$471953706258be2b(t) || $3e88191b87395c2e$export$923a058ef54437a4(t)) return t.select();
            }
        }
        void 0 === o && (o = i), void 0 === r && (r = i);
        const s = this.__key;
        return $3e88191b87395c2e$export$181b63acea8a0224(n) ? (n.anchor.set(s, o, "element"), n.focus.set(s, r, "element"), n.dirty = !0, n) : $3e88191b87395c2e$var$Ar(s, o, s, r, "element", "element");
    }
    selectStart() {
        const t = this.getFirstDescendant();
        return t ? t.selectStart() : this.select();
    }
    selectEnd() {
        const t = this.getLastDescendant();
        return t ? t.selectEnd() : this.select();
    }
    clear() {
        const t = this.getWritable();
        return this.getChildren().forEach((t)=>t.remove()), t;
    }
    append(...t) {
        return this.splice(this.getChildrenSize(), 0, t);
    }
    setDirection(t) {
        const e = this.getWritable();
        return e.__dir = t, e;
    }
    setFormat(t) {
        return this.getWritable().__format = "" !== t && $3e88191b87395c2e$var$R[t] || 0, this;
    }
    setStyle(t) {
        return this.getWritable().__style = t || "", this;
    }
    setTextFormat(t) {
        const e = this.getWritable();
        return e.__textFormat = t, e;
    }
    setTextStyle(t) {
        const e = this.getWritable();
        return e.__textStyle = t, e;
    }
    setIndent(t) {
        return this.getWritable().__indent = t, this;
    }
    splice(e, n, o) {
        $3e88191b87395c2e$var$ho(this) && $3e88191b87395c2e$var$t(324, this.__key, this.__type);
        const r = this.getChildrenSize(), i = this.getWritable();
        e + n <= r || $3e88191b87395c2e$var$t(226, String(e), String(n), String(r));
        for (const t of o);
        const s = i.__key, l = [], c = [], a = this.getChildAtIndex(e + n);
        let u = null, f = r - n + o.length;
        if (0 !== e) {
            if (e === r) u = this.getLastChild();
            else {
                const t = this.getChildAtIndex(e);
                null !== t && (u = t.getPreviousSibling());
            }
        }
        if (n > 0) {
            let e = null === u ? this.getFirstChild() : u.getNextSibling();
            for(let o = 0; o < n; o++){
                null === e && $3e88191b87395c2e$var$t(100);
                const n = e.getNextSibling(), o = e.__key;
                $3e88191b87395c2e$export$37daa10d18442dd6(e.getWritable()), c.push(o), e = n;
            }
        }
        let d = u;
        for (const e of o){
            null !== d && e.is(d) && (u = d = d.getPreviousSibling());
            const n = e.getWritable();
            n.__parent === s && f--, $3e88191b87395c2e$export$37daa10d18442dd6(n);
            const o = e.__key;
            if (null === d) i.__first = o, n.__prev = null;
            else {
                const t = d.getWritable();
                t.__next = o, n.__prev = t.__key;
            }
            e.__key === s && $3e88191b87395c2e$var$t(76), n.__parent = s, l.push(o), d = e;
        }
        if (e + n === r) {
            if (null !== d) d.getWritable().__next = null, i.__last = d.__key;
        } else if (null !== a) {
            const t = a.getWritable();
            if (null !== d) {
                const e = d.getWritable();
                t.__prev = d.__key, e.__next = a.__key;
            } else t.__prev = null;
        }
        if (i.__size = f, c.length) {
            const t = $3e88191b87395c2e$export$63a3201b3a5c7d90();
            if ($3e88191b87395c2e$export$181b63acea8a0224(t)) {
                const e = new Set(c), n = new Set(l), { anchor: o, focus: r } = t;
                $3e88191b87395c2e$var$Fi(o, e, n) && $3e88191b87395c2e$var$Rr(o, o.getNode(), this, u, a), $3e88191b87395c2e$var$Fi(r, e, n) && $3e88191b87395c2e$var$Rr(r, r.getNode(), this, u, a), 0 !== f || this.canBeEmpty() || $3e88191b87395c2e$export$6f851a24c61146af(this) || this.remove();
            }
        }
        return i;
    }
    getDOMSlot(t) {
        return new $3e88191b87395c2e$var$G(t);
    }
    exportDOM(t) {
        const { element: e } = super.exportDOM(t);
        if ($3e88191b87395c2e$export$1b3bfaa9684536aa(e)) {
            const t = this.getIndent();
            t > 0 && (e.style.paddingInlineStart = 40 * t + "px", e.setAttribute("data-lexical-indent", String(t)));
            const n = this.getDirection();
            n && (e.dir = n);
        }
        return {
            element: e
        };
    }
    exportJSON() {
        const t = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            children: [],
            direction: this.getDirection(),
            format: this.getFormatType(),
            indent: this.getIndent()
        }, super.exportJSON()), e = this.getTextFormat(), n = this.getTextStyle();
        return 0 === e && "" === n || $3e88191b87395c2e$export$6f851a24c61146af(this) || this.getChildren().some($3e88191b87395c2e$export$471953706258be2b) || (0 !== e && (t.textFormat = e), "" !== n && (t.textStyle = n)), t;
    }
    updateFromJSON(t) {
        return super.updateFromJSON(t).setFormat(t.format).setIndent(t.indent).setDirection(t.direction).setTextFormat(t.textFormat || 0).setTextStyle(t.textStyle || "");
    }
    insertNewAfter(t, e) {
        return null;
    }
    canIndent() {
        return !0;
    }
    collapseAtStart(t) {
        return !1;
    }
    excludeFromCopy(t) {
        return !1;
    }
    canReplaceWith(t) {
        return !0;
    }
    canInsertAfter(t) {
        return !0;
    }
    canBeEmpty() {
        return !0;
    }
    canInsertTextBefore() {
        return !0;
    }
    canInsertTextAfter() {
        return !0;
    }
    isInline() {
        return !1;
    }
    isShadowRoot() {
        return !1;
    }
    canMergeWith(t) {
        return !1;
    }
    extractWithChild(t, e, n) {
        return !1;
    }
    canMergeWhenEmpty() {
        return !1;
    }
    reconcileObservedMutation(t, e) {
        const n = $3e88191b87395c2e$export$724e988312a5b9ca(this, t, e);
        let o = n.getFirstChild();
        for(let t = this.getFirstChild(); t; t = t.getNextSibling()){
            const r = e.getElementByKey(t.getKey());
            null !== r && (null == o ? (n.insertChild(r), o = r) : o !== r && n.replaceChild(r, o), o = o.nextSibling);
        }
    }
    constructor(t){
        super(t), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__first", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__last", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__size", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__format", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__style", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__indent", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__dir", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__textFormat", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__textStyle", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__slotHost", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__slots", void 0), this.__first = null, this.__last = null, this.__size = 0, this.__format = 0, this.__style = "", this.__indent = 0, this.__dir = null, this.__textFormat = 0, this.__textStyle = "", this.__slotHost = null, this.__slots = null;
    }
}
function $3e88191b87395c2e$export$923a058ef54437a4(t) {
    return t instanceof $3e88191b87395c2e$export$dc064fe9e59310fd;
}
function $3e88191b87395c2e$var$Fi(t, e, n) {
    let o = t.getNode();
    for(; o;){
        const t = o.__key;
        if (e.has(t) && !n.has(t)) return !0;
        o = o.getParent();
    }
    return !1;
}
class $3e88191b87395c2e$export$8244b9efe04488e extends $3e88191b87395c2e$var$_o {
    afterCloneFrom(e) {
        super.afterCloneFrom(e), this.__key === e.__key && (this.__slotHost = e.__slotHost, null !== this.__slotHost && null !== this.__parent && $3e88191b87395c2e$var$t(383, this.__key, String(this.__slotHost), String(this.__parent)), this.__slots = e.__slots);
    }
    decorate(t, e) {
        return null;
    }
    isIsolated() {
        return !1;
    }
    isInline() {
        return !0;
    }
    isKeyboardSelectable() {
        return !0;
    }
    constructor(t){
        super(t), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__slotHost", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__slots", void 0), this.__slotHost = null, this.__slots = null;
    }
}
function $3e88191b87395c2e$export$60aa03725ce41b1c(t) {
    return t instanceof $3e88191b87395c2e$export$8244b9efe04488e;
}
class $3e88191b87395c2e$export$1c180cb67301903c extends $3e88191b87395c2e$export$dc064fe9e59310fd {
    static getType() {
        return "root";
    }
    static clone() {
        return new $3e88191b87395c2e$export$1c180cb67301903c;
    }
    getTopLevelElementOrThrow() {
        $3e88191b87395c2e$var$t(51);
    }
    getTextContent() {
        const t = this.__cachedText;
        return null === t || !$3e88191b87395c2e$export$761df28585b755e8() && 0 !== $3e88191b87395c2e$var$gi()._dirtyType ? super.getTextContent() : t;
    }
    remove() {
        $3e88191b87395c2e$var$t(52);
    }
    replace(e) {
        $3e88191b87395c2e$var$t(53);
    }
    insertBefore(e) {
        $3e88191b87395c2e$var$t(54);
    }
    insertAfter(e) {
        $3e88191b87395c2e$var$t(55);
    }
    updateDOM(t, e) {
        return !1;
    }
    splice(e, n, o) {
        for (const e of o)$3e88191b87395c2e$export$923a058ef54437a4(e) || $3e88191b87395c2e$export$60aa03725ce41b1c(e) || $3e88191b87395c2e$var$t(282);
        return super.splice(e, n, o);
    }
    static importJSON(t) {
        return $3e88191b87395c2e$export$8d83ea843c4eea9a().updateFromJSON(t);
    }
    collapseAtStart() {
        return !0;
    }
    constructor(){
        super("root"), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__cachedText", void 0), this.__cachedText = null;
    }
}
function $3e88191b87395c2e$export$5b29ca560c2fedab(t) {
    return t instanceof $3e88191b87395c2e$export$1c180cb67301903c;
}
function $3e88191b87395c2e$var$Bi(t) {
    return new $3e88191b87395c2e$var$$i($3e88191b87395c2e$var$nt(t._nodeMap), null, t._slotsUsed);
}
function $3e88191b87395c2e$var$Ri() {
    return new $3e88191b87395c2e$var$$i(new Map([
        [
            "root",
            new $3e88191b87395c2e$export$1c180cb67301903c
        ]
    ]), null, !1);
}
function $3e88191b87395c2e$var$Wi(e) {
    const n = e.exportJSON(), o = e.constructor;
    if (n.type !== o.getType() && $3e88191b87395c2e$var$t(130, o.name), $3e88191b87395c2e$export$923a058ef54437a4(e)) {
        const r = n.children;
        Array.isArray(r) || $3e88191b87395c2e$var$t(59, o.name);
        const i = e.getChildren();
        for(let t = 0; t < i.length; t++){
            const e = $3e88191b87395c2e$var$Wi(i[t]);
            r.push(e);
        }
    }
    const r = $3e88191b87395c2e$export$c83fc7fbb76e480a(e);
    if (r.length > 0) {
        const i = {};
        for (const n of r){
            const r = $3e88191b87395c2e$export$ea4162355720819(e, n);
            null === r && $3e88191b87395c2e$var$t(366, o.name, n), i[n] = $3e88191b87395c2e$var$Wi(r);
        }
        n.$slots = i;
    }
    return n;
}
function $3e88191b87395c2e$export$ac0ab291f300d875(t) {
    return t instanceof $3e88191b87395c2e$var$$i;
}
class $3e88191b87395c2e$var$$i {
    isEmpty() {
        return 1 === this._nodeMap.size && null === this._selection;
    }
    read(t, e) {
        return $3e88191b87395c2e$var$Ti(e && e.editor || null, this, t);
    }
    clone(t) {
        const e = new $3e88191b87395c2e$var$$i(this._nodeMap, void 0 === t ? this._selection : t, this._slotsUsed);
        return e._readOnly = !0, e;
    }
    toJSON() {
        return $3e88191b87395c2e$var$Ti(null, this, ()=>({
                root: $3e88191b87395c2e$var$Wi($3e88191b87395c2e$export$8d83ea843c4eea9a())
            }));
    }
    constructor(t, e = null, n = !1){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_nodeMap", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_selection", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_flushSync", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_readOnly", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_parsed", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_slotsUsed", void 0);
        this._nodeMap = t, this._selection = e || null, this._flushSync = !1, this._readOnly = !1, this._parsed = !1, this._slotsUsed = n;
    }
}
class $3e88191b87395c2e$export$82a585c2442a6dd6 extends $3e88191b87395c2e$export$dc064fe9e59310fd {
    static getType() {
        return "artificial";
    }
    createDOM(t) {
        return $3e88191b87395c2e$export$db1ba3824aa1e742().createElement("div");
    }
}
class $3e88191b87395c2e$export$965f56e8043e93ae extends $3e88191b87395c2e$var$_o {
    static getType() {
        return "linebreak";
    }
    static clone(t) {
        return new $3e88191b87395c2e$export$965f56e8043e93ae(t.__key);
    }
    getTextContent() {
        return "\n";
    }
    createDOM() {
        return $3e88191b87395c2e$export$db1ba3824aa1e742().createElement("br");
    }
    updateDOM() {
        return !1;
    }
    isInline() {
        return !0;
    }
    static importDOM() {
        return {
            br: (t)=>$3e88191b87395c2e$export$1f569a676de9fb13(t) || $3e88191b87395c2e$export$a9cc11da6f64f6a1(t) ? null : {
                    conversion: $3e88191b87395c2e$var$ji,
                    priority: 0
                }
        };
    }
    static importJSON(t) {
        return $3e88191b87395c2e$export$4ccaf7d0d16ab4c().updateFromJSON(t);
    }
    constructor(t){
        super(t);
    }
}
function $3e88191b87395c2e$var$ji(t) {
    return {
        node: $3e88191b87395c2e$export$4ccaf7d0d16ab4c()
    };
}
function $3e88191b87395c2e$export$4ccaf7d0d16ab4c() {
    return $3e88191b87395c2e$export$2f5beb31df92ea57(new $3e88191b87395c2e$export$965f56e8043e93ae);
}
function $3e88191b87395c2e$export$b16330e40aa25c4e(t) {
    return t instanceof $3e88191b87395c2e$export$965f56e8043e93ae;
}
function $3e88191b87395c2e$export$1f569a676de9fb13(t) {
    const e = t.parentElement;
    if (null !== e && $3e88191b87395c2e$export$5ef1a5ca687c7168(e)) {
        const n = e.firstChild;
        if (n === t || n.nextSibling === t && $3e88191b87395c2e$var$Xi(n)) {
            const n = e.lastChild;
            if (n === t || n.previousSibling === t && $3e88191b87395c2e$var$Xi(n)) return !0;
        }
    }
    return !1;
}
function $3e88191b87395c2e$export$a9cc11da6f64f6a1(t) {
    const e = t.parentElement;
    if (null !== e && $3e88191b87395c2e$export$5ef1a5ca687c7168(e)) {
        const n = e.firstChild;
        if (n === t || n.nextSibling === t && $3e88191b87395c2e$var$Xi(n)) return !1;
        const o = e.lastChild;
        if (o === t || o.previousSibling === t && $3e88191b87395c2e$var$Xi(o)) return !0;
    }
    return !1;
}
function $3e88191b87395c2e$var$Xi(t) {
    return $3e88191b87395c2e$export$4295c0f0b9b754c4(t) && /^( |\t|\r?\n)+$/.test(t.textContent || "");
}
class $3e88191b87395c2e$export$e94424771493b912 extends $3e88191b87395c2e$export$dc064fe9e59310fd {
    static getType() {
        return "paragraph";
    }
    static clone(t) {
        return new $3e88191b87395c2e$export$e94424771493b912(t.__key);
    }
    createDOM(t) {
        const e = $3e88191b87395c2e$export$db1ba3824aa1e742().createElement("p"), n = $3e88191b87395c2e$var$ml(t.theme, "paragraph");
        if (void 0 !== n) e.classList.add(...n);
        return e;
    }
    updateDOM(t, e, n) {
        return !1;
    }
    static importDOM() {
        return {
            p: (t)=>({
                    conversion: $3e88191b87395c2e$var$Zi,
                    priority: 0
                })
        };
    }
    exportDOM(t) {
        const { element: e } = super.exportDOM(t);
        if ($3e88191b87395c2e$export$1b3bfaa9684536aa(e)) {
            this.isEmpty() && e.append($3e88191b87395c2e$export$db1ba3824aa1e742().createElement("br"));
            const t = this.getFormatType();
            t && (e.style.textAlign = t);
        }
        return {
            element: e
        };
    }
    static importJSON(t) {
        return $3e88191b87395c2e$export$7f0c05ffb7ced90d().updateFromJSON(t);
    }
    exportJSON() {
        const t = super.exportJSON();
        if (void 0 === t.textFormat || void 0 === t.textStyle) {
            const e = this.getChildren().find($3e88191b87395c2e$export$471953706258be2b);
            e ? (t.textFormat = e.getFormat(), t.textStyle = e.getStyle()) : (t.textFormat = this.getTextFormat(), t.textStyle = this.getTextStyle());
        }
        return t;
    }
    insertNewAfter(t, e) {
        const n = $3e88191b87395c2e$export$7f0c05ffb7ced90d();
        n.setTextFormat(t.format), n.setTextStyle(t.style);
        const o = this.getDirection();
        return n.setDirection(o), n.setFormat(this.getFormatType()), n.setStyle(this.getStyle()), this.insertAfter(n, e), n;
    }
    collapseAtStart() {
        const t = this.getChildren();
        if (0 === t.length || $3e88191b87395c2e$export$471953706258be2b(t[0]) && "" === t[0].getTextContent().trim()) {
            if (null !== this.getNextSibling()) return this.selectNext(), this.remove(), !0;
            if (null !== this.getPreviousSibling()) return this.selectPrevious(), this.remove(), !0;
        }
        return !1;
    }
}
function $3e88191b87395c2e$var$Zi(t) {
    const e = $3e88191b87395c2e$export$7f0c05ffb7ced90d();
    if ($3e88191b87395c2e$export$b92488674c2048ea(e, t), $3e88191b87395c2e$export$bf56bccfeec66814(t, e), "" === e.getFormatType()) {
        const n = t.getAttribute("align");
        n && n && n in $3e88191b87395c2e$var$R && e.setFormat(n);
    }
    return $3e88191b87395c2e$export$44a229cf8757fa56(e, t), {
        node: e
    };
}
function $3e88191b87395c2e$export$7f0c05ffb7ced90d() {
    return $3e88191b87395c2e$export$2f5beb31df92ea57(new $3e88191b87395c2e$export$e94424771493b912);
}
function $3e88191b87395c2e$export$1fdda795300c79c6(t) {
    return t instanceof $3e88191b87395c2e$export$e94424771493b912;
}
function $3e88191b87395c2e$var$ns(t) {
    console.warn(t);
}
const $3e88191b87395c2e$export$11c61e12af5e1f41 = 0, $3e88191b87395c2e$export$1d1358fe8b5bfab4 = 1, $3e88191b87395c2e$export$7bb13e375de35064 = 2, $3e88191b87395c2e$export$e8fb7042985cd2e9 = 3, $3e88191b87395c2e$export$6afdf194f304e546 = 4, $3e88191b87395c2e$export$ad4f8f37df5d0905 = -8, $3e88191b87395c2e$export$265a302a8c4420d7 = -7, $3e88191b87395c2e$export$55f62b401e429757 = -6, $3e88191b87395c2e$export$aa9dc11340526a4c = -5, $3e88191b87395c2e$export$3bc56e5f4ab213d = -4;
function $3e88191b87395c2e$var$hs(t, e, n, o, r) {
    const i = t._keyToDOMMap;
    i.clear(), t._editorState = $3e88191b87395c2e$var$Ri(), t._pendingEditorState = o, t._compositionKey = null, t._dirtyType = 0, t._cloneNotNeeded.clear(), t._dirtyLeaves = new Set, t._dirtyElements.clear(), t._normalizedNodes = new Set, r && r.preserveUpdateQueue || (t._updateTags = new Set, t._updates = [], t._cascadeCount = 0), t._blockCursorElement = null, null !== t._inputState.handledSelectionCommandTimeoutId && clearTimeout(t._inputState.handledSelectionCommandTimeoutId), t._inputState = {
        collapsedSelectionFormat: {
            format: 0,
            key: "root",
            offset: 0,
            style: "",
            timeStamp: 0
        },
        compositionEndData: "",
        compositionPhase: "idle",
        hadOrphanedCompositionEvents: !1,
        handledSelectionCommandTimeoutId: null,
        isInsertLineBreak: !1,
        isInsertTextAfterHandledSelectionCommand: !1,
        isSelectionChangeFromDOMUpdate: !1,
        isSelectionChangeFromMouseDown: !1,
        lastBeforeInputInsertTextTimeStamp: 0,
        lastKeyCode: null,
        lastKeyDownTimeStamp: 0,
        postDeleteSelectionToRestore: null,
        unprocessedBeforeInputData: null
    };
    const s = t._observer;
    null !== s && (s.disconnect(), t._observer = null), null !== e && (e.textContent = "", function(t, e) {
        const n = `__lexicalKey_${e._key}`;
        delete t[n];
    }(e, t)), null !== n && (n.textContent = "", i.set("root", n), $3e88191b87395c2e$var$Ys(n, t, "root"));
}
function $3e88191b87395c2e$export$ab0d62aef5036181(t) {
    const e = new Set, n = new Set;
    for (const { klass: o, ownNodeConfig: r } of $3e88191b87395c2e$export$9f01219fd9911d4c(t)){
        const t = o.transform;
        if (!n.has(t)) {
            n.add(t);
            const r = o.transform();
            r && e.add(r);
        }
        if (r) {
            const t = r.$transform;
            t && e.add(t);
        }
    }
    return e;
}
const $3e88191b87395c2e$export$1d0bbaf021f5def1 = {
    $createDOM: (t, e)=>t.createDOM(e._config, e),
    $decorateDOM: (t, e, n, o)=>{},
    $exportDOM: (t, e)=>{
        const n = $3e88191b87395c2e$export$d1089922dfafeaf5(e, t.getType());
        return n && void 0 !== n.exportDOM ? n.exportDOM(e, t) : t.exportDOM(e);
    },
    $extractWithChild: (t, e, n, o, r)=>$3e88191b87395c2e$export$923a058ef54437a4(t) && t.extractWithChild(e, n, o),
    $getDOMSlot: (t, e, n)=>t.getDOMSlot(e),
    $getSlotTargetElement: (t, e, n, o)=>null,
    $shouldExclude: (t, e, n)=>$3e88191b87395c2e$export$923a058ef54437a4(t) && t.excludeFromCopy("html"),
    $shouldInclude: (t, e, n)=>!e || t.isSelected(e),
    $updateDOM: (t, e, n, o)=>t.updateDOM(e, n, o._config)
};
function $3e88191b87395c2e$export$eb02d1ee0d3cac30(e) {
    const n = e || {}, o = $3e88191b87395c2e$var$yi(), r = n.theme || {}, i = void 0 === e ? o : n.parentEditor || null, s = n.disableEvents || !1, l = $3e88191b87395c2e$var$Ri(), c = n.namespace || (null !== i ? i._config.namespace : $3e88191b87395c2e$var$sl()), a = n.editorState, u = [
        $3e88191b87395c2e$export$1c180cb67301903c,
        $3e88191b87395c2e$export$f0a25ea3087686aa,
        $3e88191b87395c2e$export$965f56e8043e93ae,
        $3e88191b87395c2e$export$8dbf7edd89edc19c,
        $3e88191b87395c2e$export$e94424771493b912,
        $3e88191b87395c2e$export$82a585c2442a6dd6,
        ...n.nodes || []
    ], { onError: f, onWarn: d, html: h } = n, g = void 0 === n.editable || n.editable;
    let _;
    if (void 0 === e && null !== o) _ = o._nodes;
    else {
        _ = new Map;
        for(let e = 0; e < u.length; e++){
            let o = u[e], r = null, i = null;
            if (o && "object" == typeof o) {
                const t = o;
                o = t.replace, r = t.with, i = t.withKlass || null;
            }
            if ("function" != typeof o || !o.prototype || !(o === $3e88191b87395c2e$var$_o || o.prototype instanceof $3e88191b87395c2e$var$_o)) {
                let r = "<unknown>";
                try {
                    r = JSON.parse($3e88191b87395c2e$var$Z);
                } catch (t) {}
                $3e88191b87395c2e$var$t(365, String(e - u.length + (n.nodes ? n.nodes.length : 0)), "function" == typeof o ? `${o.name}${"function" == typeof o.getType ? ` (type ${String(o.getType())})` : ""}` : String(o), String(r));
            }
            $3e88191b87395c2e$export$e89f9d0013499fc6(o);
            const s = o.getType(), l = $3e88191b87395c2e$export$ab0d62aef5036181(o);
            _.set(s, {
                exportDOM: h && h.export ? h.export.get(o) : void 0,
                klass: o,
                replace: r,
                replaceWithKlass: i,
                sharedNodeState: $3e88191b87395c2e$export$42a31b61c59197f6(u[e]),
                transforms: l
            });
        }
    }
    const p = new $3e88191b87395c2e$var$xs(l, i, _, {
        disableEvents: s,
        dom: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $3e88191b87395c2e$export$1d0bbaf021f5def1, e && e.dom),
        namespace: c,
        theme: r
    }, f || console.error, d || $3e88191b87395c2e$var$ns, function(t, e) {
        const n = new Map, o = new Set, r = (t)=>{
            Object.keys(t).forEach((e)=>{
                let o = n.get(e);
                void 0 === o && (o = [], n.set(e, o)), o.push(t[e]);
            });
        };
        return t.forEach((t)=>{
            const e = t.klass.importDOM;
            if (null == e || o.has(e)) return;
            o.add(e);
            const n = e.call(t.klass);
            null !== n && r(n);
        }), e && r(e), n;
    }(_, h ? h.import : void 0), g, e);
    return void 0 !== a && (p._pendingEditorState = a, p._dirtyType = 2), function(t) {
        t.registerCommand($3e88191b87395c2e$export$5ac84ded9d925fd5, $3e88191b87395c2e$var$Yn, $3e88191b87395c2e$export$11c61e12af5e1f41), t.registerCommand($3e88191b87395c2e$export$ee0f3fd82c319b92, $3e88191b87395c2e$var$Gn, $3e88191b87395c2e$export$11c61e12af5e1f41), t.registerCommand($3e88191b87395c2e$export$e688de3e16be2231, $3e88191b87395c2e$var$Xn, $3e88191b87395c2e$export$11c61e12af5e1f41), t.registerCommand($3e88191b87395c2e$export$432579d4ad746c17, $3e88191b87395c2e$var$Qn, $3e88191b87395c2e$export$11c61e12af5e1f41), t.registerCommand($3e88191b87395c2e$export$61973214e0e18936, $3e88191b87395c2e$var$eo, $3e88191b87395c2e$export$11c61e12af5e1f41);
    }(p), p;
}
function $3e88191b87395c2e$var$ys(t, e) {
    const n = t.get(e);
    t.delete(e), n && n();
}
function $3e88191b87395c2e$var$ms(t, e, n) {
    return t.set(e, n), $3e88191b87395c2e$var$ys.bind(null, t, e);
}
class $3e88191b87395c2e$var$xs {
    isComposing() {
        return null != this._compositionKey;
    }
    registerUpdateListener(t) {
        return $3e88191b87395c2e$var$ms(this._listeners.update, t);
    }
    registerEditableListener(t) {
        return $3e88191b87395c2e$var$ms(this._listeners.editable, t);
    }
    registerDecoratorListener(t) {
        return $3e88191b87395c2e$var$ms(this._listeners.decorator, t);
    }
    registerTextContentListener(t) {
        return $3e88191b87395c2e$var$ms(this._listeners.textcontent, t);
    }
    registerRootListener(t) {
        const e = this._listeners.root;
        return $3e88191b87395c2e$export$d64d64f541cc1835($3e88191b87395c2e$var$ms(e, t, t(this._rootElement, null) || void 0), ()=>(function(t, e, n) {
                const o = t.get(e);
                o && o(), t.set(e, e(...n) || void 0);
            })(e, t, [
                null,
                this._rootElement
            ]));
    }
    registerCommand(e, n, o) {
        void 0 === o && $3e88191b87395c2e$var$t(35);
        const r = this._commands;
        r.has(e) || r.set(e, [
            new $3e88191b87395c2e$var$tt,
            new $3e88191b87395c2e$var$tt,
            new $3e88191b87395c2e$var$tt,
            new $3e88191b87395c2e$var$tt,
            new $3e88191b87395c2e$var$tt
        ]);
        const i = r.get(e);
        void 0 === i && $3e88191b87395c2e$var$t(36, String(e));
        const s = function(t) {
            return 7 & t;
        }(o), l = i[s];
        return s !== o ? l.addFront(n) : l.addBack(n), ()=>{
            l.delete(n), i.every((t)=>0 === t.size) && r.delete(e);
        };
    }
    registerMutationListener(t, e, n) {
        const o = this.resolveRegisteredNodeAfterReplacements(this.getRegisteredNode(t)).klass, r = this._listeners.mutation;
        let i = r.get(e);
        void 0 === i && (i = new Set, r.set(e, i)), i.add(o);
        const s = n && n.skipInitialization;
        return void 0 !== s && s || this.initializeMutationListener(e, o), ()=>{
            i.delete(o), 0 === i.size && r.delete(e);
        };
    }
    getRegisteredNode(e) {
        const n = this._nodes.get(e.getType());
        return void 0 === n && $3e88191b87395c2e$var$t(37, e.name), n;
    }
    resolveRegisteredNodeAfterReplacements(t) {
        for(; t.replaceWithKlass;)t = this.getRegisteredNode(t.replaceWithKlass);
        return t;
    }
    initializeMutationListener(t, e) {
        const n = this._editorState, o = $3e88191b87395c2e$var$Oc(n).get(e.getType());
        if (!o) return;
        const r = new Map;
        for (const t of o.keys())r.set(t, "created");
        r.size > 0 && t(r, {
            dirtyLeaves: new Set,
            prevEditorState: n,
            updateTags: new Set([
                "registerMutationListener"
            ])
        });
    }
    registerNodeTransformToKlass(t, e) {
        const n = this.getRegisteredNode(t);
        return n.transforms.add(e), n;
    }
    registerNodeTransform(t, e) {
        const n = this.registerNodeTransformToKlass(t, e), o = [
            n
        ], r = n.replaceWithKlass;
        if (null != r) {
            const t = this.registerNodeTransformToKlass(r, e);
            o.push(t);
        }
        return function(t, e) {
            const n = $3e88191b87395c2e$var$Oc(t.getEditorState()), o = [];
            for (const t of e){
                const e = n.get(t);
                e && o.push(e);
            }
            if (0 === o.length) return;
            t.update(()=>{
                for (const t of o)for (const e of t.keys()){
                    const t = $3e88191b87395c2e$export$e725f93d4d48c6d8(e);
                    t && t.markDirty();
                }
            }, null === t._pendingEditorState ? {
                tag: $3e88191b87395c2e$export$b58a9fabaf2a5573
            } : void 0);
        }(this, o.map((t)=>t.klass.getType())), ()=>{
            o.forEach((t)=>t.transforms.delete(e));
        };
    }
    hasNode(t) {
        return this._nodes.has(t.getType());
    }
    hasNodes(t) {
        return t.every(this.hasNode.bind(this));
    }
    dispatchCommand(t, e) {
        return $3e88191b87395c2e$var$kl(this, t, e);
    }
    getDecorators() {
        return this._decorators;
    }
    getRootElement() {
        return this._rootElement;
    }
    getKey() {
        return this._key;
    }
    setRootElement(t) {
        const e = this._rootElement;
        if (t !== e) {
            const n = $3e88191b87395c2e$var$ml(this._config.theme, "root"), o = this._pendingEditorState || this._editorState;
            if (this._rootElement = t, $3e88191b87395c2e$var$hs(this, e, t, o, {
                preserveUpdateQueue: !0
            }), null !== e && (this._config.disableEvents || $3e88191b87395c2e$var$co(e), null != n && e.classList.remove(...n)), null !== t) {
                const e = $3e88191b87395c2e$var$Dl(t), o = t.style;
                o.userSelect = "text", o.whiteSpace = "pre-wrap", o.wordBreak = "break-word", t.setAttribute("data-lexical-editor", "true"), this._window = e, this._dirtyType = 2, $3e88191b87395c2e$var$gt(this), this._updateTags.add($3e88191b87395c2e$export$b58a9fabaf2a5573), $3e88191b87395c2e$var$ki(this), this._config.disableEvents || function(t, e) {
                    const n = t.ownerDocument;
                    $3e88191b87395c2e$var$Ln.set(t, n);
                    let o = $3e88191b87395c2e$var$Kn.get(n);
                    void 0 === o && (o = {
                        editors: new Set,
                        hasShadowEditor: void 0
                    }, $3e88191b87395c2e$var$Kn.set(n, o)), o.editors.add(e), o.hasShadowEditor = void 0, t.__lexicalEditor = e;
                    const r = $3e88191b87395c2e$var$no(t);
                    r.push($3e88191b87395c2e$var$zn.register(n));
                    for(let n = 0; n < $3e88191b87395c2e$var$In.length; n++){
                        const [o, i] = $3e88191b87395c2e$var$In[n], s = "function" == typeof i ? (t)=>{
                            $3e88191b87395c2e$var$so(t) || ($3e88191b87395c2e$export$e066258f9188a34f(t), (e.isEditable() || "click" === o) && i(t, e));
                        } : (t)=>{
                            if ($3e88191b87395c2e$var$so(t)) return;
                            $3e88191b87395c2e$export$e066258f9188a34f(t);
                            const n = e.isEditable();
                            switch(o){
                                case "cut":
                                    return n && $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$4dc8a35a083beec4, t);
                                case "copy":
                                    return $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$3435fcfb1f59ef96, t);
                                case "paste":
                                    return n && $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$7fb70c61b3bcc883, t);
                                case "dragstart":
                                    return n && $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$2e0fd45fde1da719, t);
                                case "dragover":
                                    return n && $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$b62c1cce98fa7223, t);
                                case "dragend":
                                    return n && $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$ffbd838cf75d7d8e, t);
                                case "focus":
                                    return n && $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$cafe35f35e77bf56, t);
                                case "blur":
                                    return n && $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$4b6d457d076906ac, t);
                                case "drop":
                                    return n && $3e88191b87395c2e$var$kl(e, $3e88191b87395c2e$export$eac1e4b16b80d3ea, t);
                            }
                        };
                        r.push($3e88191b87395c2e$export$bea698773a21b4e8(t, o, s));
                    }
                }(t, this), null != n && t.classList.add(...n);
            } else this._window = null, this._updateTags.add($3e88191b87395c2e$export$b58a9fabaf2a5573), $3e88191b87395c2e$var$ki(this);
            $3e88191b87395c2e$var$bi("root", this, !1, t, e);
        }
    }
    getElementByKey(t) {
        return this._keyToDOMMap.get(t) || null;
    }
    getEditorState() {
        return this._editorState;
    }
    setEditorState(e, n) {
        e.isEmpty() && $3e88191b87395c2e$var$t(38);
        let o = e;
        o._readOnly && (o = $3e88191b87395c2e$var$Bi(e), o._selection = e._selection ? e._selection.clone() : null), $3e88191b87395c2e$var$ht(this);
        const r = this._pendingEditorState, i = void 0 !== n ? n.tag : null;
        null === r || r.isEmpty() || (null != i && this._updateTags.add(i), $3e88191b87395c2e$var$ki(this)), this._pendingEditorState = o, this._dirtyType = 2, this._dirtyElements.set("root", !1), this._compositionKey = null, this._slotsUsed = this._slotsUsed || e._slotsUsed, $3e88191b87395c2e$var$Mi(this, ()=>{
            if (i && this._updateTags.add(i), e._parsed) for (const [t, e] of o._nodeMap.entries())$3e88191b87395c2e$export$923a058ef54437a4(e) ? this._dirtyElements.set(t, !0) : this._dirtyLeaves.add(t);
        }, {
            discrete: !this._updating || void 0
        });
    }
    parseEditorState(t, e) {
        return function(t, e, n) {
            const o = $3e88191b87395c2e$var$Ri(), r = $3e88191b87395c2e$var$ei, i = $3e88191b87395c2e$var$oi, s = $3e88191b87395c2e$var$ni, l = e._dirtyElements, c = e._dirtyLeaves, a = e._cloneNotNeeded, u = e._dirtyType;
            e._dirtyElements = new Map, e._dirtyLeaves = new Set, e._cloneNotNeeded = new Set, e._dirtyType = 0, $3e88191b87395c2e$var$ei = o, $3e88191b87395c2e$var$oi = !1, $3e88191b87395c2e$var$ni = e, $3e88191b87395c2e$var$Ss(null);
            try {
                const r = e._nodes;
                $3e88191b87395c2e$var$vi(t.root, r), n && n(), o._readOnly = !0, o._parsed = !0;
            } catch (t) {
                t instanceof Error && e._onError(t);
            } finally{
                e._dirtyElements = l, e._dirtyLeaves = c, e._cloneNotNeeded = a, e._dirtyType = u, $3e88191b87395c2e$var$ei = r, $3e88191b87395c2e$var$oi = i, $3e88191b87395c2e$var$ni = s;
            }
            return o;
        }("string" == typeof t ? JSON.parse(t) : t, this, e);
    }
    read(...t) {
        const [e, n] = 1 === t.length ? [
            "force-commit",
            t[0]
        ] : t;
        "force-commit" === e && $3e88191b87395c2e$var$ki(this);
        return ("pending" === e ? this._pendingEditorState || this._editorState : this.getEditorState()).read(n, {
            editor: this
        });
    }
    update(t, e) {
        !function(t, e, n) {
            t._updating ? t._updates.push([
                e,
                n
            ]) : $3e88191b87395c2e$var$Oi(t, e, n);
        }(this, t, e);
    }
    focus(t, e = {}) {
        const n = this._rootElement;
        null !== n && (n.setAttribute("autocapitalize", "off"), $3e88191b87395c2e$var$Mi(this, ()=>{
            const o = $3e88191b87395c2e$export$63a3201b3a5c7d90(), r = $3e88191b87395c2e$export$8d83ea843c4eea9a();
            null !== o ? o.dirty || $3e88191b87395c2e$export$2aad78c37810bca9(o.clone()) : 0 !== r.getChildrenSize() && ("rootStart" === e.defaultSelection ? r.selectStart() : r.selectEnd()), $3e88191b87395c2e$export$24cab2f466b76c04("focus"), $3e88191b87395c2e$export$61a2e38e1c9f7284(()=>{
                n.removeAttribute("autocapitalize"), t && t();
            });
        }), null === this._pendingEditorState && n.removeAttribute("autocapitalize"));
    }
    blur() {
        const t = this._rootElement;
        null !== t && t.blur();
        const e = $3e88191b87395c2e$export$74c14770a0819525(this._window);
        null !== e && e.removeAllRanges();
    }
    isEditable() {
        return this._editable;
    }
    setEditable(t) {
        this._editable !== t && (this._editable = t, $3e88191b87395c2e$var$bi("editable", this, !0, t), this._slotsUsed && this.update(()=>$3e88191b87395c2e$export$d05b7cf3bb138003()));
    }
    toJSON() {
        return {
            editorState: this._editorState.toJSON()
        };
    }
    constructor(t, e, n, o, r, i, s, l, c){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_headless", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_parentEditor", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_rootElement", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_editorState", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_pendingEditorState", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_compositionKey", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_deferred", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_keyToDOMMap", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_updates", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_updating", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_cascadeCount", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_listeners", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_commands", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_nodes", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_decorators", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_pendingDecorators", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_config", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_dirtyType", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_cloneNotNeeded", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_dirtyLeaves", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_dirtyElements", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_normalizedNodes", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_updateTags", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_observer", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_key", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_onError", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_onWarn", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_htmlConversions", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_window", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_editable", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_blockCursorElement", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_slotsUsed", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_inputState", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_createEditorArgs", void 0);
        this._createEditorArgs = c, this._parentEditor = e, this._rootElement = null, this._editorState = t, this._pendingEditorState = null, this._compositionKey = null, this._deferred = [], this._keyToDOMMap = new $3e88191b87395c2e$var$ot, this._updates = [], this._updating = !1, this._cascadeCount = 0, this._listeners = {
            decorator: new Map,
            editable: new Map,
            mutation: new Map,
            root: new Map,
            textcontent: new Map,
            update: new Map
        }, this._commands = new Map, this._config = o, this._nodes = n, this._decorators = {}, this._pendingDecorators = null, this._dirtyType = 0, this._cloneNotNeeded = new Set, this._dirtyLeaves = new Set, this._dirtyElements = new Map, this._normalizedNodes = new Set, this._updateTags = new Set, this._observer = null, this._key = $3e88191b87395c2e$var$sl(), this._onError = r, this._onWarn = i, this._htmlConversions = s, this._editable = l, this._headless = null !== e && e._headless, this._window = null, this._blockCursorElement = null, this._slotsUsed = !1, this._inputState = {
            collapsedSelectionFormat: {
                format: 0,
                key: "root",
                offset: 0,
                style: "",
                timeStamp: 0
            },
            compositionEndData: "",
            compositionPhase: "idle",
            hadOrphanedCompositionEvents: !1,
            handledSelectionCommandTimeoutId: null,
            isInsertLineBreak: !1,
            isInsertTextAfterHandledSelectionCommand: !1,
            isSelectionChangeFromDOMUpdate: !1,
            isSelectionChangeFromMouseDown: !1,
            lastBeforeInputInsertTextTimeStamp: 0,
            lastKeyCode: null,
            lastKeyDownTimeStamp: 0,
            postDeleteSelectionToRestore: null,
            unprocessedBeforeInputData: null
        };
    }
}
(0, $919ebf39980bf8f3$export$71511d61b312f219)($3e88191b87395c2e$var$xs, "version", void 0);
$3e88191b87395c2e$var$xs.version = $3e88191b87395c2e$var$Z;
let $3e88191b87395c2e$var$Cs = null;
function $3e88191b87395c2e$var$Ss(t) {
    $3e88191b87395c2e$var$Cs = t;
}
let $3e88191b87395c2e$var$vs = 1;
function $3e88191b87395c2e$export$404db5fc87e4045() {
    $3e88191b87395c2e$var$vs = 1;
}
function $3e88191b87395c2e$export$8988849ce1143792(e, n) {
    const o = $3e88191b87395c2e$export$d1089922dfafeaf5(e, n);
    return void 0 === o && $3e88191b87395c2e$var$t(30, n), o;
}
function $3e88191b87395c2e$export$d1089922dfafeaf5(t, e) {
    return t._nodes.get(e);
}
const $3e88191b87395c2e$var$Ns = "function" == typeof queueMicrotask ? queueMicrotask : (t)=>{
    Promise.resolve().then(t);
};
function $3e88191b87395c2e$export$ceaabfa7ddeeb250(t, e) {
    const n = void 0 !== e ? e : (()=>{
        const e = t.getRootNode();
        return $3e88191b87395c2e$export$47ea8b9bb8a4c4de(e) || $3e88191b87395c2e$export$cbad3bd7ce195561(e) ? $3e88191b87395c2e$export$914ab019e7cf55b0(e) : null;
    })();
    if (!$3e88191b87395c2e$export$1b3bfaa9684536aa(n)) return !1;
    if (n.hasAttribute("data-lexical-slot")) return !1;
    const o = $3e88191b87395c2e$export$fef265f0d2fcffdd(n), r = n.nodeName;
    return $3e88191b87395c2e$export$51639c096d96bcc8(o) && ("INPUT" === r || "TEXTAREA" === r || "true" === n.contentEditable && null == $3e88191b87395c2e$export$40676f02fb121ce2(n));
}
const $3e88191b87395c2e$export$340cc5df988bf401 = $3e88191b87395c2e$export$ceaabfa7ddeeb250;
function $3e88191b87395c2e$export$f1b377b21cd6350b(t, e, n) {
    const o = t.getRootElement();
    if (!o) return !1;
    try {
        if (!e || !o.contains(e) || !o.contains(n)) return !1;
    } catch (t) {
        return !1;
    }
    return $3e88191b87395c2e$export$30c13854ab4c9903(e) === t && t.read("latest", ()=>!$3e88191b87395c2e$export$ceaabfa7ddeeb250(e));
}
function $3e88191b87395c2e$export$811e9996da830291(t) {
    return t instanceof $3e88191b87395c2e$var$xs;
}
function $3e88191b87395c2e$export$30c13854ab4c9903(t) {
    let e = t;
    for(; null != e;){
        const t = $3e88191b87395c2e$export$40676f02fb121ce2(e);
        if ($3e88191b87395c2e$export$811e9996da830291(t)) return t;
        e = $3e88191b87395c2e$export$169e5491001d3ed6(e);
    }
    return null;
}
function $3e88191b87395c2e$export$40676f02fb121ce2(t) {
    return t ? t.__lexicalEditor : null;
}
function $3e88191b87395c2e$export$fab72c0039936348(t) {
    return $3e88191b87395c2e$var$L.test(t) ? "rtl" : $3e88191b87395c2e$var$K.test(t) ? "ltr" : null;
}
function $3e88191b87395c2e$export$c863bf9446d4a347(t) {
    return $3e88191b87395c2e$export$ac9141efa5fb7932(t) || t.isToken();
}
function $3e88191b87395c2e$export$8b834332909623ff(t) {
    return $3e88191b87395c2e$export$c863bf9446d4a347(t) || t.isSegmented();
}
function $3e88191b87395c2e$export$4295c0f0b9b754c4(t) {
    return $3e88191b87395c2e$export$b8eb4d3b76e486c2(t) && 3 === t.nodeType;
}
function $3e88191b87395c2e$export$47ea8b9bb8a4c4de(t) {
    return $3e88191b87395c2e$export$b8eb4d3b76e486c2(t) && 9 === t.nodeType;
}
function $3e88191b87395c2e$export$78c4e6c266471ee(t) {
    let e = t;
    for(; null != e;){
        if ($3e88191b87395c2e$export$4295c0f0b9b754c4(e)) return e;
        e = e.firstChild;
    }
    return null;
}
function $3e88191b87395c2e$export$bfd35cbfa01f02e5(t, e, n) {
    const o = $3e88191b87395c2e$export$c9e7d6eb65b13430[e];
    if (null !== n && (t & o) === (n & o)) return t;
    let r = t ^ o;
    return "subscript" === e ? r &= ~$3e88191b87395c2e$export$c9e7d6eb65b13430.superscript : "superscript" === e ? r &= ~$3e88191b87395c2e$export$c9e7d6eb65b13430.subscript : "lowercase" === e ? (r &= ~$3e88191b87395c2e$export$c9e7d6eb65b13430.uppercase, r &= ~$3e88191b87395c2e$export$c9e7d6eb65b13430.capitalize) : "uppercase" === e ? (r &= ~$3e88191b87395c2e$export$c9e7d6eb65b13430.lowercase, r &= ~$3e88191b87395c2e$export$c9e7d6eb65b13430.capitalize) : "capitalize" === e && (r &= ~$3e88191b87395c2e$export$c9e7d6eb65b13430.lowercase, r &= ~$3e88191b87395c2e$export$c9e7d6eb65b13430.uppercase), r;
}
function $3e88191b87395c2e$export$8d016e0592201ace(t) {
    return $3e88191b87395c2e$export$471953706258be2b(t) || $3e88191b87395c2e$export$b16330e40aa25c4e(t) || $3e88191b87395c2e$export$60aa03725ce41b1c(t);
}
function $3e88191b87395c2e$var$Ws(t, e) {
    const n = function() {
        const t = $3e88191b87395c2e$var$Cs;
        return $3e88191b87395c2e$var$Cs = null, t;
    }();
    if (null != (e = e || n && n.__key)) return void (t.__key = e);
    $3e88191b87395c2e$var$ui(), $3e88191b87395c2e$var$fi();
    const o = $3e88191b87395c2e$var$gi(), r = $3e88191b87395c2e$var$di(), i = "" + $3e88191b87395c2e$var$vs++;
    r._nodeMap.set(i, t), $3e88191b87395c2e$export$923a058ef54437a4(t) ? o._dirtyElements.set(i, !0) : o._dirtyLeaves.add(i), o._cloneNotNeeded.add(i), 0 === o._dirtyType && (o._dirtyType = 1), t.__key = i;
}
function $3e88191b87395c2e$export$37daa10d18442dd6(e) {
    null !== $3e88191b87395c2e$var$Xc(e) && $3e88191b87395c2e$var$t(380, e.__key, String($3e88191b87395c2e$var$Xc(e)));
    const n = e.getParent();
    if (null !== n) {
        const t = e.getWritable(), o = n.getWritable(), r = e.getPreviousSibling(), i = e.getNextSibling(), s = null !== i ? i.__key : null, l = null !== r ? r.__key : null, c = null !== r ? r.getWritable() : null, a = null !== i ? i.getWritable() : null;
        null === r && (o.__first = s), null === i && (o.__last = l), null !== c && (c.__next = s), null !== a && (a.__prev = l), t.__prev = null, t.__next = null, t.__parent = null, o.__size--;
    }
}
const $3e88191b87395c2e$export$8f65eac074b5d438 = $3e88191b87395c2e$export$37daa10d18442dd6;
function $3e88191b87395c2e$var$Hs(e) {
    $3e88191b87395c2e$var$fi(), $3e88191b87395c2e$var$ho(e) && $3e88191b87395c2e$var$t(323, e.__key, e.__type);
    const n = e.getLatest(), o = null !== n.__parent ? n.__parent : $3e88191b87395c2e$export$6b4473cff535c86d(n) ? n.__slotHost : null, r = $3e88191b87395c2e$var$di(), i = $3e88191b87395c2e$var$gi(), s = r._nodeMap, l = i._dirtyElements;
    null !== o && function(t, e, n) {
        let o = t;
        for(; null !== o;){
            if (n.has(o)) return;
            const t = e.get(o);
            if (void 0 === t) break;
            n.set(o, !1), o = null !== t.__parent ? t.__parent : $3e88191b87395c2e$export$6b4473cff535c86d(t) ? t.__slotHost : null;
        }
    }(o, s, l);
    const c = n.__key;
    0 === i._dirtyType && (i._dirtyType = 1), $3e88191b87395c2e$export$923a058ef54437a4(e) ? l.set(c, !0) : i._dirtyLeaves.add(c);
}
function $3e88191b87395c2e$export$ea25f5ef71f2d042(t) {
    $3e88191b87395c2e$var$ui();
    const e = $3e88191b87395c2e$var$gi(), n = e._compositionKey;
    if (t !== n) {
        if (e._compositionKey = t, null !== n) {
            const t = $3e88191b87395c2e$export$e725f93d4d48c6d8(n);
            null !== t && t.getWritable();
        }
        if (null !== t) {
            const e = $3e88191b87395c2e$export$e725f93d4d48c6d8(t);
            null !== e && e.getWritable();
        }
    }
}
function $3e88191b87395c2e$var$js() {
    if ($3e88191b87395c2e$export$761df28585b755e8()) return null;
    return $3e88191b87395c2e$var$gi()._compositionKey;
}
function $3e88191b87395c2e$export$e725f93d4d48c6d8(t, e) {
    const n = (e || $3e88191b87395c2e$var$di())._nodeMap.get(t);
    return void 0 === n ? null : n;
}
function $3e88191b87395c2e$export$b1414e7b1cad1d22(t, e) {
    const n = $3e88191b87395c2e$var$Gs(t, $3e88191b87395c2e$var$gi());
    return void 0 !== n ? $3e88191b87395c2e$export$e725f93d4d48c6d8(n, e) : null;
}
function $3e88191b87395c2e$var$Ys(t, e, n) {
    t[`__lexicalKey_${e._key}`] = n;
}
function $3e88191b87395c2e$var$Gs(t, e) {
    return t[`__lexicalKey_${e._key}`];
}
function $3e88191b87395c2e$export$fef265f0d2fcffdd(t, e) {
    let n = t;
    for(; null != n;){
        const t = $3e88191b87395c2e$export$b1414e7b1cad1d22(n, e);
        if (null !== t) return t;
        n = $3e88191b87395c2e$export$169e5491001d3ed6(n);
    }
    return null;
}
function $3e88191b87395c2e$var$Qs(t) {
    const e = t._decorators, n = Object.assign({}, e);
    return t._pendingDecorators = n, n;
}
function $3e88191b87395c2e$var$Zs(t) {
    return t.read(()=>$3e88191b87395c2e$export$8d83ea843c4eea9a().getTextContent());
}
function $3e88191b87395c2e$export$8d83ea843c4eea9a() {
    return $3e88191b87395c2e$var$di()._nodeMap.get("root");
}
function $3e88191b87395c2e$export$2aad78c37810bca9(t) {
    $3e88191b87395c2e$var$ui();
    const e = $3e88191b87395c2e$var$di();
    null !== t && (t.dirty = !0, t.setCachedNodes(null), $3e88191b87395c2e$export$181b63acea8a0224(t) && $3e88191b87395c2e$var$gi()._slotsUsed && $3e88191b87395c2e$var$Er(t)), e._selection = t;
}
function $3e88191b87395c2e$var$nl() {
    $3e88191b87395c2e$var$ui();
    $3e88191b87395c2e$var$ht($3e88191b87395c2e$var$gi());
}
function $3e88191b87395c2e$var$ol(t) {
    const e = function(t, e) {
        let n = t;
        for(; null != n;){
            const t = $3e88191b87395c2e$var$Gs(n, e);
            if (void 0 !== t) return t;
            n = $3e88191b87395c2e$export$169e5491001d3ed6(n);
        }
        return null;
    }(t, $3e88191b87395c2e$var$gi());
    return null === e ? null : $3e88191b87395c2e$export$e725f93d4d48c6d8(e);
}
function $3e88191b87395c2e$var$rl(t) {
    return /[\uD800-\uDBFF][\uDC00-\uDFFF]/g.test(t);
}
function $3e88191b87395c2e$var$il(t) {
    const e = [];
    for(let n = t; null !== n; n = n._parentEditor)e.push(n);
    return e;
}
function $3e88191b87395c2e$var$sl() {
    return Math.random().toString(36).replace(/[^a-z]+/g, "").substring(0, 5);
}
function $3e88191b87395c2e$var$ll(t) {
    return $3e88191b87395c2e$export$4295c0f0b9b754c4(t) ? t.nodeValue : null;
}
function $3e88191b87395c2e$var$cl(t, e, n) {
    const o = $3e88191b87395c2e$export$74c14770a0819525($3e88191b87395c2e$var$Pl(e));
    if (null === o) return;
    const r = $3e88191b87395c2e$export$fca86712f5243a7e(o, e._rootElement), i = r.anchorNode;
    let { anchorOffset: s, focusOffset: l } = r;
    if (null !== i) {
        let e = $3e88191b87395c2e$var$ll(i);
        const o = $3e88191b87395c2e$export$fef265f0d2fcffdd(i);
        if (null !== e && $3e88191b87395c2e$export$471953706258be2b(o)) {
            if ((e === $3e88191b87395c2e$var$A || e === $3e88191b87395c2e$var$P) && n) {
                const t = n.length;
                e = n, s = t, l = t;
            }
            null !== e && $3e88191b87395c2e$var$al(o, e, s, l, t);
        }
    }
}
function $3e88191b87395c2e$var$al(t, e, n, o, r) {
    let i = t;
    if (i.isAttached() && (r || !i.isDirty())) {
        const s = i.isComposing();
        if (i.isToken() && s) return;
        let c = e;
        if ((s || r) && (e.endsWith($3e88191b87395c2e$var$A) && (c = e.slice(0, -$3e88191b87395c2e$var$A.length)), r)) {
            const t = $3e88191b87395c2e$var$P;
            let e;
            for(; -1 !== (e = c.indexOf(t));)c = c.slice(0, e) + c.slice(e + t.length), null !== n && n > e && (n = Math.max(e, n - t.length)), null !== o && o > e && (o = Math.max(e, o - t.length));
        }
        const u = i.getTextContent();
        if (r || c !== u) {
            const e = $3e88191b87395c2e$export$63a3201b3a5c7d90();
            if ("" === c) {
                if ($3e88191b87395c2e$export$ea25f5ef71f2d042(null), $3e88191b87395c2e$export$af54264dae9065e6 || $3e88191b87395c2e$export$9135b5fce2a2854d || $3e88191b87395c2e$export$e9250b0198928087) i.remove();
                else {
                    const t = $3e88191b87395c2e$var$gi();
                    $3e88191b87395c2e$var$ul(i, "", e), setTimeout(()=>{
                        t.update(()=>{
                            i.isAttached() && "" === i.getTextContent() && i.remove();
                        });
                    }, 20);
                }
                return;
            }
            const r = i.getParent(), u = $3e88191b87395c2e$export$846e9407a8b5d98c(), f = i.getTextContentSize(), h = $3e88191b87395c2e$var$js(), g = i.getKey();
            if (i.isToken() && !s || null !== h && g === h && !s || $3e88191b87395c2e$export$181b63acea8a0224(u) && (null !== r && !r.canInsertTextBefore() && 0 === u.anchor.offset || u.anchor.key === t.__key && 0 === u.anchor.offset && !i.canInsertTextBefore() && !s || u.focus.key === t.__key && u.focus.offset === f && !i.canInsertTextAfter() && !s)) return void i.markDirty();
            if (!$3e88191b87395c2e$export$181b63acea8a0224(e) || null === n || null === o) return void $3e88191b87395c2e$var$ul(i, c, e);
            if (e.setTextNodeRange(i, n, i, o), i.isSegmented()) {
                const t = $3e88191b87395c2e$export$2785f39dcdec0078(i.getTextContent());
                i.replace(t), i = t;
            }
            $3e88191b87395c2e$var$ul(i, c, e);
        }
    }
}
function $3e88191b87395c2e$var$ul(t, e, n) {
    if (t.setTextContent(e), $3e88191b87395c2e$export$181b63acea8a0224(n)) {
        const e = t.getKey();
        let o = !1;
        for (const r of [
            "anchor",
            "focus"
        ]){
            const i = n[r];
            "text" === i.type && i.key === e && (i.offset = $3e88191b87395c2e$export$d83ac801960e4905(t, i.offset, "clamp"), o = !0);
        }
        o && (n._cachedNodes = null, n._cachedIsBackward = null);
    }
}
function $3e88191b87395c2e$var$fl(t, e, n) {
    const o = e[n] || !1;
    return "any" === o || o === t[n];
}
function $3e88191b87395c2e$export$cd06557afcd20d1c(t, e) {
    return $3e88191b87395c2e$var$fl(t, e, "altKey") && $3e88191b87395c2e$var$fl(t, e, "ctrlKey") && $3e88191b87395c2e$var$fl(t, e, "shiftKey") && $3e88191b87395c2e$var$fl(t, e, "metaKey");
}
function $3e88191b87395c2e$export$56e059fc8d27aa5f(t, e, n) {
    if (!$3e88191b87395c2e$export$cd06557afcd20d1c(t, n)) return !1;
    if (t.key.toLowerCase() === e.toLowerCase()) return !0;
    if (e.length > 1) return !1;
    if (1 === t.key.length && t.key.charCodeAt(0) <= 127) return !1;
    if (t.code.startsWith("Digit") && /^\d$/.test(e)) return t.code === `Digit${e}`;
    const o = "Key" + e.toUpperCase();
    return t.code === o;
}
const $3e88191b87395c2e$var$gl = {
    ctrlKey: !$3e88191b87395c2e$export$d093bd80dddd0842,
    metaKey: $3e88191b87395c2e$export$d093bd80dddd0842
}, $3e88191b87395c2e$var$_l = {
    altKey: $3e88191b87395c2e$export$d093bd80dddd0842,
    ctrlKey: !$3e88191b87395c2e$export$d093bd80dddd0842
};
function $3e88191b87395c2e$var$pl(t) {
    return "Backspace" === t.key;
}
function $3e88191b87395c2e$export$824f075b28fd7b6c(t) {
    const e = $3e88191b87395c2e$export$8d83ea843c4eea9a();
    if ($3e88191b87395c2e$export$181b63acea8a0224(t)) {
        const e = t.anchor, n = t.focus, o = e.getNode();
        if ($3e88191b87395c2e$export$5b29ca560c2fedab(o)) return e.set(o.getKey(), 0, "element"), n.set(o.getKey(), o.getChildrenSize(), "element"), $3e88191b87395c2e$export$db10bc6ba67ffcb5(t), t;
        const r = o.getTopLevelElementOrThrow(), i = r.getParent();
        if (null === i) return $3e88191b87395c2e$export$923a058ef54437a4(r) && (e.set(r.getKey(), 0, "element"), n.set(r.getKey(), r.getChildrenSize(), "element"), $3e88191b87395c2e$export$db10bc6ba67ffcb5(t)), t;
        const s = i;
        return e.set(s.getKey(), 0, "element"), n.set(s.getKey(), s.getChildrenSize(), "element"), $3e88191b87395c2e$export$db10bc6ba67ffcb5(t), t;
    }
    {
        const t = e.select(0, e.getChildrenSize());
        return $3e88191b87395c2e$export$2aad78c37810bca9($3e88191b87395c2e$export$db10bc6ba67ffcb5(t)), t;
    }
}
function $3e88191b87395c2e$var$ml(t, e) {
    void 0 === t.__lexicalClassNameCache && (t.__lexicalClassNameCache = {});
    const n = t.__lexicalClassNameCache, o = n[e];
    if (void 0 !== o) return o;
    const r = t[e];
    if ("string" == typeof r) {
        const t = $3e88191b87395c2e$export$68575042fda37fa9(r);
        return n[e] = t, t;
    }
    return r;
}
function $3e88191b87395c2e$var$xl(e, n, o, r, i) {
    if (0 === o.size) return;
    const s = r.__type, l = r.__key, c = n.get(s);
    void 0 === c && $3e88191b87395c2e$var$t(33, s);
    const a = c.klass;
    let u = e.get(a);
    void 0 === u && (u = new Map, e.set(a, u));
    const f = u.get(l), d = "destroyed" === f && "created" === i;
    (void 0 === f || d) && u.set(l, d ? "updated" : i);
}
function $3e88191b87395c2e$export$ac6fed8d7d40e66c(t) {
    const e = t.getType(), n = $3e88191b87395c2e$var$di();
    if (n._readOnly) {
        const t = $3e88191b87395c2e$var$Oc(n).get(e);
        return t ? Array.from(t.values()) : [];
    }
    const o = n._nodeMap, r = [];
    for (const [, n] of o)n instanceof t && n.__type === e && n.isAttached() && r.push(n);
    return r;
}
function $3e88191b87395c2e$var$Sl(t, e, n) {
    const o = t.getParent();
    let r = n, i = t;
    return null !== o && (e && 0 === n ? (r = i.getIndexWithinParent(), i = o) : e || n !== i.getChildrenSize() || (r = i.getIndexWithinParent() + 1, i = o)), i.getChildAtIndex(e ? r - 1 : r);
}
function $3e88191b87395c2e$export$c4b907be1879d8c1(t, e) {
    const n = t.offset;
    if ("element" === t.type) return $3e88191b87395c2e$var$Sl(t.getNode(), e, n);
    {
        const o = t.getNode();
        if (e && 0 === n || !e && n === o.getTextContentSize()) {
            const t = e ? o.getPreviousSibling() : o.getNextSibling();
            return null === t ? $3e88191b87395c2e$var$Sl(o.getParentOrThrow(), e, o.getIndexWithinParent() + (e ? 0 : 1)) : t;
        }
    }
    return null;
}
function $3e88191b87395c2e$var$Tl(t) {
    const e = $3e88191b87395c2e$var$Pl(t).event, n = e && e.inputType;
    return "insertFromPaste" === n || "insertFromPasteAsQuotation" === n;
}
function $3e88191b87395c2e$var$kl(t, e, n) {
    return $3e88191b87395c2e$var$Ni(t, e, n, t);
}
function $3e88191b87395c2e$var$bl(e, n) {
    const o = e._keyToDOMMap.get(n);
    return void 0 === o && $3e88191b87395c2e$var$t(75, n), o;
}
function $3e88191b87395c2e$export$169e5491001d3ed6(t) {
    const e = t.assignedSlot || t.parentElement;
    if (null !== e) return e;
    const n = t.parentNode;
    return $3e88191b87395c2e$export$cbad3bd7ce195561(n) ? n.host : null;
}
function $3e88191b87395c2e$export$43a91182e77c9b6d(t) {
    return $3e88191b87395c2e$export$47ea8b9bb8a4c4de(t) ? t : $3e88191b87395c2e$export$1b3bfaa9684536aa(t) ? t.ownerDocument : null;
}
function $3e88191b87395c2e$export$fbcbbb073e480e61(t) {
    return $3e88191b87395c2e$var$gi()._updateTags.has(t);
}
function $3e88191b87395c2e$export$24cab2f466b76c04(t) {
    $3e88191b87395c2e$var$ui();
    $3e88191b87395c2e$var$gi()._updateTags.add(t);
}
function $3e88191b87395c2e$export$61a2e38e1c9f7284(t) {
    $3e88191b87395c2e$var$ui();
    $3e88191b87395c2e$var$gi()._deferred.push(t);
}
function $3e88191b87395c2e$export$e3d4b782f65c81f1(t, e) {
    let n = t.getParent();
    for(; null !== n;){
        if (n.is(e)) return !0;
        n = n.getParent();
    }
    return !1;
}
function $3e88191b87395c2e$var$Dl(t) {
    const e = $3e88191b87395c2e$export$43a91182e77c9b6d(t);
    return e ? e.defaultView : null;
}
function $3e88191b87395c2e$var$Pl(e) {
    const n = e._window;
    return null === n && $3e88191b87395c2e$var$t(78), n;
}
function $3e88191b87395c2e$export$a78813a4e8e8b9dd(t) {
    return $3e88191b87395c2e$export$923a058ef54437a4(t) && t.isInline() || $3e88191b87395c2e$export$60aa03725ce41b1c(t) && t.isInline();
}
function $3e88191b87395c2e$export$6f13c476561e4734(t) {
    let e = t.getLatest();
    for(; null !== e;){
        if (null !== $3e88191b87395c2e$var$Xc(e) && $3e88191b87395c2e$export$923a058ef54437a4(e)) return e;
        const t = e.getParentOrThrow();
        if ($3e88191b87395c2e$export$6f851a24c61146af(t)) return t;
        e = t;
    }
    return e;
}
function $3e88191b87395c2e$export$966170d136a21178(t) {
    return $3e88191b87395c2e$export$923a058ef54437a4(t) && t.isShadowRoot();
}
function $3e88191b87395c2e$export$6f851a24c61146af(t) {
    return $3e88191b87395c2e$export$5b29ca560c2fedab(t) || $3e88191b87395c2e$export$966170d136a21178(t);
}
function $3e88191b87395c2e$export$def73b17b22438e7(t, e = !1) {
    const n = t.constructor.clone(t);
    return $3e88191b87395c2e$var$Ws(n, null), n.afterCloneFrom(t), e || n.resetOnCopyNodeFrom(t), n;
}
function $3e88191b87395c2e$export$2f5beb31df92ea57(e) {
    const n = $3e88191b87395c2e$var$gi(), o = e.getType(), r = $3e88191b87395c2e$export$d1089922dfafeaf5(n, o);
    void 0 === r && $3e88191b87395c2e$var$t(200, e.constructor.name, o);
    const { replace: i, replaceWithKlass: s } = r;
    if (null !== i) {
        const n = i(e), r = n.constructor;
        return null !== s ? n instanceof s || $3e88191b87395c2e$var$t(201, s.name, s.getType(), r.name, r.getType(), e.constructor.name, o) : n instanceof e.constructor && r !== e.constructor || $3e88191b87395c2e$var$t(202, r.name, r.getType(), e.constructor.name, o), n.__key === e.__key && $3e88191b87395c2e$var$t(203, e.constructor.name, o, r.name, r.getType()), n;
    }
    return e;
}
function $3e88191b87395c2e$var$Rl(e, n) {
    !$3e88191b87395c2e$export$5b29ca560c2fedab(e.getParent()) || $3e88191b87395c2e$export$923a058ef54437a4(n) || $3e88191b87395c2e$export$60aa03725ce41b1c(n) || $3e88191b87395c2e$var$t(99);
}
function $3e88191b87395c2e$export$b86173decb513938(e) {
    const n = $3e88191b87395c2e$export$e725f93d4d48c6d8(e);
    return null === n && $3e88191b87395c2e$var$t(63, e), n;
}
function $3e88191b87395c2e$export$7a90539e4eb02726(t) {
    if (!t || t.isInline()) return !1;
    if ($3e88191b87395c2e$export$60aa03725ce41b1c(t)) return !0;
    if ($3e88191b87395c2e$export$923a058ef54437a4(t)) {
        if (t.isShadowRoot()) {
            const e = t.getParent();
            return !($3e88191b87395c2e$export$923a058ef54437a4(e) && e.isShadowRoot());
        }
        return !t.canBeEmpty();
    }
    return !1;
}
function $3e88191b87395c2e$var$$l(t, e, n) {
    n.style.removeProperty("caret-color"), e._blockCursorElement = null;
    const o = t.parentElement;
    null !== o && o.removeChild(t);
}
function $3e88191b87395c2e$export$74c14770a0819525(t) {
    return $3e88191b87395c2e$export$37d2f1e98a187e61 ? (t || window).getSelection() : null;
}
function $3e88191b87395c2e$export$c8cecd54bd4bdb44(t) {
    const e = $3e88191b87395c2e$var$Dl(t);
    return e ? e.getSelection() : null;
}
function $3e88191b87395c2e$export$cbad3bd7ce195561(t) {
    return $3e88191b87395c2e$export$bb9401626c51130a(t) && "host" in t;
}
const $3e88191b87395c2e$var$Vl = [];
function $3e88191b87395c2e$export$3ac46f5934eb607d(t) {
    const e = t.getRootNode();
    if (e === t || !$3e88191b87395c2e$export$cbad3bd7ce195561(e)) return $3e88191b87395c2e$var$Vl;
    const n = [
        e
    ];
    let o = e.host;
    for(;;){
        const t = o.getRootNode();
        if (t === o || !$3e88191b87395c2e$export$cbad3bd7ce195561(t)) break;
        n.push(t), o = t.host;
    }
    return n;
}
function* $3e88191b87395c2e$export$5ec8835222827c6b(t) {
    const e = [
        t
    ];
    let n;
    for(; n = e.pop();){
        yield* n.querySelectorAll('[data-lexical-editor="true"]');
        const t = ($3e88191b87395c2e$export$47ea8b9bb8a4c4de(n) ? n : n.ownerDocument).createTreeWalker(n, NodeFilter.SHOW_ELEMENT);
        let o;
        for(; o = t.nextNode();)o.shadowRoot && e.push(o.shadowRoot);
    }
}
function $3e88191b87395c2e$export$c074c5c00886935b(t) {
    return null !== t ? t.ownerDocument : document;
}
function $3e88191b87395c2e$export$db1ba3824aa1e742() {
    const t = $3e88191b87395c2e$var$yi();
    return $3e88191b87395c2e$export$c074c5c00886935b(null !== t ? t._rootElement : null);
}
function $3e88191b87395c2e$export$ad2e2afb4198aa89(t, e) {
    if (null === e || "function" != typeof t.getComposedRanges) return null;
    const n = $3e88191b87395c2e$export$3ac46f5934eb607d(e);
    if (0 === n.length) return null;
    const o = t.getComposedRanges;
    try {
        const e = o.call(t, {
            shadowRoots: n
        })[0];
        if (void 0 !== e) return e;
    } catch (t) {}
    try {
        const e = o.apply(t, n)[0];
        if (void 0 !== e) return e;
    } catch (t) {}
    return null;
}
function $3e88191b87395c2e$export$341e1c1b48347df(t, e) {
    const n = $3e88191b87395c2e$export$ad2e2afb4198aa89(t, e);
    if (null !== n) {
        const t = $3e88191b87395c2e$var$nc(n);
        if (null !== t) return t;
    }
    return t.rangeCount > 0 ? t.getRangeAt(0) : null;
}
function $3e88191b87395c2e$export$fca86712f5243a7e(t, e) {
    const n = $3e88191b87395c2e$export$ad2e2afb4198aa89(t, e);
    return null === n ? t : $3e88191b87395c2e$var$oc(n, $3e88191b87395c2e$var$rc(t));
}
function $3e88191b87395c2e$export$44add355b9a0437c(t, e) {
    const n = $3e88191b87395c2e$export$ad2e2afb4198aa89(t, e);
    if (null === n) return {
        points: t,
        range: t.rangeCount > 0 ? t.getRangeAt(0) : null
    };
    var _nc;
    const o = (_nc = $3e88191b87395c2e$var$nc(n)) !== null && _nc !== void 0 ? _nc : t.rangeCount > 0 ? t.getRangeAt(0) : null;
    return {
        points: $3e88191b87395c2e$var$oc(n, $3e88191b87395c2e$var$rc(t)),
        range: o
    };
}
function $3e88191b87395c2e$var$nc(t) {
    const e = t.startContainer.ownerDocument;
    if (null === e) return null;
    const n = e.createRange();
    try {
        return n.setStart(t.startContainer, t.startOffset), n.setEnd(t.endContainer, t.endOffset), n;
    } catch (t) {
        return null;
    }
}
function $3e88191b87395c2e$var$oc(t, e) {
    const { startContainer: n, startOffset: o, endContainer: r, endOffset: i } = t;
    return "backward" === e ? {
        anchorNode: r,
        anchorOffset: i,
        direction: e,
        focusNode: n,
        focusOffset: o
    } : {
        anchorNode: n,
        anchorOffset: o,
        direction: e,
        focusNode: r,
        focusOffset: i
    };
}
function $3e88191b87395c2e$var$rc(t) {
    return t.direction;
}
function $3e88191b87395c2e$export$cd4e5573fbe2b576(t) {
    const e = t.getRootNode();
    return $3e88191b87395c2e$export$47ea8b9bb8a4c4de(e) || $3e88191b87395c2e$export$cbad3bd7ce195561(e) ? e.activeElement : null;
}
function $3e88191b87395c2e$export$914ab019e7cf55b0(t) {
    let e = t.activeElement;
    for(; null !== e && null !== e.shadowRoot;){
        const t = e.shadowRoot.activeElement;
        if (null === t) break;
        e = t;
    }
    return e;
}
function $3e88191b87395c2e$export$da5d2f8c5437c541(t) {
    const e = t.target;
    if (null !== e && $3e88191b87395c2e$export$1b3bfaa9684536aa(e) && null !== e.shadowRoot && "function" == typeof t.composedPath) {
        const e = t.composedPath();
        if (e.length > 0) return e[0];
    }
    return e;
}
function $3e88191b87395c2e$export$cc2d53c74c1fb2b2(e, n) {
    let o = e.getChildAtIndex(n);
    null == o && (o = e), $3e88191b87395c2e$export$6f851a24c61146af(e) && $3e88191b87395c2e$var$t(102);
    const r = (e)=>{
        const n = e.getParentOrThrow(), i = $3e88191b87395c2e$export$6f851a24c61146af(n), s = e !== o || i ? $3e88191b87395c2e$export$def73b17b22438e7(e) : e;
        if (i) return $3e88191b87395c2e$export$923a058ef54437a4(e) && $3e88191b87395c2e$export$923a058ef54437a4(s) || $3e88191b87395c2e$var$t(133), e.insertAfter(s), [
            e,
            s,
            s
        ];
        {
            const [t, o, i] = r(n), l = e.getNextSiblings();
            return i.append(s, ...l), [
                t,
                o,
                s
            ];
        }
    }, [i, s] = r(o);
    return [
        i,
        s
    ];
}
function $3e88191b87395c2e$export$f5326d78d8d21e1f(t) {
    return $3e88191b87395c2e$export$1b3bfaa9684536aa(t) && "A" === t.tagName;
}
function $3e88191b87395c2e$export$dc1475f01755a57a(t) {
    return $3e88191b87395c2e$export$1b3bfaa9684536aa(t) && "TR" === t.tagName;
}
function $3e88191b87395c2e$export$fdedcf73d1851f5c(t) {
    return $3e88191b87395c2e$export$1b3bfaa9684536aa(t) && ("TD" === t.tagName || "TH" === t.tagName);
}
function $3e88191b87395c2e$export$1b3bfaa9684536aa(t) {
    return $3e88191b87395c2e$export$b8eb4d3b76e486c2(t) && 1 === t.nodeType;
}
function $3e88191b87395c2e$export$b8eb4d3b76e486c2(t) {
    return "object" == typeof t && null !== t && "nodeType" in t && "number" == typeof t.nodeType;
}
function $3e88191b87395c2e$export$bb9401626c51130a(t) {
    return $3e88191b87395c2e$export$b8eb4d3b76e486c2(t) && 11 === t.nodeType;
}
const $3e88191b87395c2e$var$_c = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|mark|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var|#text)$/i;
function $3e88191b87395c2e$export$456fd4e5e0a7123d(t) {
    return !(!$3e88191b87395c2e$export$1b3bfaa9684536aa(t) || !t.style.display.startsWith("inline")) || $3e88191b87395c2e$var$_c.test(t.nodeName);
}
const $3e88191b87395c2e$var$yc = /^(address|article|aside|blockquote|canvas|dd|div|dl|dt|fieldset|figcaption|figure|footer|form|h1|h2|h3|h4|h5|h6|header|hr|li|main|nav|noscript|ol|p|pre|section|table|td|tfoot|ul|video)$/i;
function $3e88191b87395c2e$export$5ef1a5ca687c7168(t) {
    return (!$3e88191b87395c2e$export$1b3bfaa9684536aa(t) || !t.style.display.startsWith("inline")) && $3e88191b87395c2e$var$yc.test(t.nodeName);
}
function $3e88191b87395c2e$export$bd7ca521104e245c(t) {
    if ($3e88191b87395c2e$export$60aa03725ce41b1c(t) && !t.isInline()) return !0;
    if (!$3e88191b87395c2e$export$923a058ef54437a4(t) || $3e88191b87395c2e$export$6f851a24c61146af(t)) return !1;
    const e = t.getFirstChild(), n = null === e || $3e88191b87395c2e$export$b16330e40aa25c4e(e) || $3e88191b87395c2e$export$471953706258be2b(e) || e.isInline();
    return !t.isInline() && !1 !== t.canBeEmpty() && n;
}
function $3e88191b87395c2e$export$8a7392c46faf1a3f() {
    return $3e88191b87395c2e$var$gi();
}
function $3e88191b87395c2e$export$cee5aec8bb4a87d6(t = $3e88191b87395c2e$export$8a7392c46faf1a3f()) {
    return t._config.dom || $3e88191b87395c2e$export$1d0bbaf021f5def1;
}
function $3e88191b87395c2e$export$724e988312a5b9ca(e, n, o = $3e88191b87395c2e$export$8a7392c46faf1a3f()) {
    const r = $3e88191b87395c2e$export$cee5aec8bb4a87d6(o).$getDOMSlot(e, n, o);
    return $3e88191b87395c2e$export$923a058ef54437a4(e) && ($3e88191b87395c2e$export$73ed146da9c92847(r) || $3e88191b87395c2e$var$t(344, e.getKey(), e.getType())), r;
}
function $3e88191b87395c2e$export$9ef81b35e856c801(t, e, n, o) {
    const r = t.read("latest", ()=>{
        const o = $3e88191b87395c2e$export$e725f93d4d48c6d8(e);
        return null !== o ? function(t, e, n = $3e88191b87395c2e$export$8a7392c46faf1a3f()) {
            const o = $3e88191b87395c2e$export$ea4162355720819(t, e);
            if (null === o) return null;
            const r = n.getElementByKey(o.getKey());
            return null !== r ? r.parentElement : null;
        }(o, n, t) : null;
    });
    return null !== r && (r.parentElement !== o && o.appendChild(r), r.style.display = ""), r;
}
function $3e88191b87395c2e$export$8bff083e61b0d857(t, e, n) {
    n.style.display = "none";
    const o = t.getElementByKey(e);
    null !== o && n.parentElement !== o && o.insertBefore(n, o.firstChild);
}
function $3e88191b87395c2e$export$73ed146da9c92847(t) {
    return t instanceof $3e88191b87395c2e$var$G;
}
function $3e88191b87395c2e$export$118c63c491bd7ec(t, e, n = $3e88191b87395c2e$export$8a7392c46faf1a3f()) {
    return $3e88191b87395c2e$export$78c4e6c266471ee($3e88191b87395c2e$export$724e988312a5b9ca(t, e, n).element);
}
const $3e88191b87395c2e$var$wc = new WeakMap, $3e88191b87395c2e$var$Ec = new Map;
function $3e88191b87395c2e$var$Oc(e) {
    if (!e._readOnly && e.isEmpty()) return $3e88191b87395c2e$var$Ec;
    e._readOnly || $3e88191b87395c2e$var$t(192);
    let n = $3e88191b87395c2e$var$wc.get(e);
    return n || (n = function(t) {
        const e = new Map;
        for (const [n, o] of t._nodeMap){
            const t = o.__type;
            let r = e.get(t);
            r || (r = new Map, e.set(t, r)), r.set(n, o);
        }
        return e;
    }(e), $3e88191b87395c2e$var$wc.set(e, n)), n;
}
function $3e88191b87395c2e$export$10b12fb9e226edf0(t) {
    const e = t.constructor.clone(t);
    return e.afterCloneFrom(t), e;
}
function $3e88191b87395c2e$export$26da83a243ca58b3(t) {
    var e;
    return (e = $3e88191b87395c2e$export$10b12fb9e226edf0(t))[$3e88191b87395c2e$var$fo] = !0, e;
}
function $3e88191b87395c2e$export$bf56bccfeec66814(t, e) {
    const n = t.getAttribute("data-lexical-indent");
    if (null !== n) {
        const t = parseInt(n, 10);
        if (Number.isFinite(t) && t >= 0) return void e.setIndent(t);
    }
    const o = parseInt(t.style.paddingInlineStart, 10) || 0, r = Math.round(o / 40);
    e.setIndent(r);
}
function $3e88191b87395c2e$export$44a229cf8757fa56(t, e) {
    const n = e.getAttribute("dir");
    return "ltr" === n || "rtl" === n ? t.setDirection(n) : t;
}
function $3e88191b87395c2e$export$b92488674c2048ea(t, e) {
    const n = e.style.textAlign;
    return n && n in $3e88191b87395c2e$var$R ? t.setFormat(n) : t;
}
function $3e88191b87395c2e$export$601028e2f53ab464(t, e) {
    t.__lexicalUnmanaged = !0, e && void 0 !== e.captureSelection && (t.__lexicalCapturedSelection = e.captureSelection);
}
function $3e88191b87395c2e$export$163e1a1a046f2b80(t) {
    return !0 === t.__lexicalUnmanaged;
}
function $3e88191b87395c2e$export$cdba2bd0b63ec62e(t, e = $3e88191b87395c2e$export$8a7392c46faf1a3f()) {
    const n = e.isEditable();
    t.contentEditable = n ? "true" : "false", n ? t.__lexicalEditor = e : delete t.__lexicalEditor;
}
function $3e88191b87395c2e$export$b1dbc8b9f80bab62(t, e) {
    let n = t;
    for(; null != n;){
        if (!0 === n.__lexicalCapturedSelection) return !0;
        if ($3e88191b87395c2e$export$1b3bfaa9684536aa(n) && n.hasAttribute("data-lexical-slot")) return !1;
        if (void 0 !== $3e88191b87395c2e$var$Gs(n, e)) return !1;
        n = $3e88191b87395c2e$export$169e5491001d3ed6(n);
    }
    return !1;
}
function $3e88191b87395c2e$var$Bc(t, e) {
    return function(t, e) {
        return Object.prototype.hasOwnProperty.call(t, e);
    }(t, e) && t[e] !== $3e88191b87395c2e$var$_o[e];
}
const $3e88191b87395c2e$var$Rc = new WeakMap;
function $3e88191b87395c2e$export$e89f9d0013499fc6(e) {
    const n = $3e88191b87395c2e$var$Rc.get(e);
    if (n) return n;
    const o = null != e.prototype && $3e88191b87395c2e$var$J in e.prototype ? e.prototype[$3e88191b87395c2e$var$J]() : void 0, r = function(e) {
        if (!(e === $3e88191b87395c2e$var$_o || e.prototype instanceof $3e88191b87395c2e$var$_o)) {
            let n = "<unknown>", o = "<unknown>";
            try {
                n = e.getType();
            } catch (t) {}
            try {
                $3e88191b87395c2e$var$xs.version && (o = JSON.parse($3e88191b87395c2e$var$xs.version));
            } catch (t) {}
            $3e88191b87395c2e$var$t(290, e.name, n, o);
        }
        return e === $3e88191b87395c2e$export$8244b9efe04488e || e === $3e88191b87395c2e$export$dc064fe9e59310fd || e === $3e88191b87395c2e$var$_o;
    }(e), i = !r && $3e88191b87395c2e$var$Bc(e, "getType") ? e.getType() : void 0;
    let s, l = i;
    if (o) {
        if (i) s = o[i];
        else {
            for (const [t, e] of Object.entries(o))l = t, s = e;
            if (!s) for (const t of Object.getOwnPropertySymbols(o)){
                const e = o[t];
                if (e) {
                    s = e;
                    break;
                }
            }
        }
    }
    if (!r && l && ($3e88191b87395c2e$var$Bc(e, "getType") || (e.getType = ()=>l), $3e88191b87395c2e$var$Bc(e, "clone") || (e.clone = (t)=>($3e88191b87395c2e$var$Ss(t), new e)), $3e88191b87395c2e$var$Bc(e, "importJSON") || (e.importJSON = s && s.$importJSON || ((t)=>(new e).updateFromJSON(t))), !$3e88191b87395c2e$var$Bc(e, "importDOM") && s)) {
        const { importDOM: t } = s;
        t && (e.importDOM = ()=>t);
    }
    const c = {
        klass: e,
        ownNodeConfig: s,
        ownNodeType: l
    };
    return $3e88191b87395c2e$var$Rc.set(e, c), c;
}
function* $3e88191b87395c2e$export$9f01219fd9911d4c(t) {
    for(let e = t; e && (e === $3e88191b87395c2e$var$_o || $3e88191b87395c2e$export$51639c096d96bcc8(e.prototype));){
        const t = $3e88191b87395c2e$export$e89f9d0013499fc6(e);
        yield t, e = t.ownNodeConfig && t.ownNodeConfig.extends || $3e88191b87395c2e$var$Vc(e);
    }
}
function $3e88191b87395c2e$export$178ba1ee8bfc8fa1(t) {
    const e = new Map, n = new Map;
    for (const o of t){
        const { ownNodeType: t } = $3e88191b87395c2e$export$e89f9d0013499fc6(o);
        t && (n.set(t, o), e.set(t, new Set));
    }
    for (const [t, o] of n)for (const { ownNodeType: n } of $3e88191b87395c2e$export$9f01219fd9911d4c(o)){
        const o = n && e.get(n);
        o && o.add(t);
    }
    return e;
}
function $3e88191b87395c2e$export$dde9d6ffeb117c5e(t) {
    const e = $3e88191b87395c2e$export$8a7392c46faf1a3f();
    $3e88191b87395c2e$var$ui();
    return new (e.resolveRegisteredNodeAfterReplacements(e.getRegisteredNode(t))).klass;
}
const $3e88191b87395c2e$export$57101724ca611500 = (t, e)=>{
    let n = t;
    for(; null != n && !$3e88191b87395c2e$export$5b29ca560c2fedab(n);){
        if (e(n)) return n;
        n = n.getParent();
    }
    return null;
};
function $3e88191b87395c2e$export$4755c0a85d0b9cd5(e, n) {
    const o = [];
    let r = e.__first;
    for(; null !== r;){
        const e = null === n ? $3e88191b87395c2e$export$e725f93d4d48c6d8(r) : n.get(r);
        null == e && $3e88191b87395c2e$var$t(174), o.push(r), r = e.__next;
    }
    return o;
}
function $3e88191b87395c2e$var$Vc(t) {
    const e = Object.getPrototypeOf(t);
    if ("function" == typeof e && e !== Function.prototype) return e;
    const n = t.prototype && Object.getPrototypeOf(t.prototype);
    return n ? n.constructor : null;
}
const $3e88191b87395c2e$var$qc = new Map;
function $3e88191b87395c2e$export$e14ad7e55d229066(t) {
    return $3e88191b87395c2e$export$923a058ef54437a4(t) || $3e88191b87395c2e$export$60aa03725ce41b1c(t);
}
function $3e88191b87395c2e$export$6b4473cff535c86d(t) {
    return $3e88191b87395c2e$export$923a058ef54437a4(t) || $3e88191b87395c2e$export$60aa03725ce41b1c(t);
}
function $3e88191b87395c2e$var$Xc(t) {
    const e = t.getLatest();
    return $3e88191b87395c2e$export$6b4473cff535c86d(e) ? e.__slotHost : null;
}
function $3e88191b87395c2e$export$fe2a41df16bf88cd(e) {
    const n = $3e88191b87395c2e$var$Xc(e);
    if (null === n) return null;
    const o = $3e88191b87395c2e$export$e725f93d4d48c6d8(n);
    return $3e88191b87395c2e$export$923a058ef54437a4(o) || $3e88191b87395c2e$export$60aa03725ce41b1c(o) || $3e88191b87395c2e$var$t(370), o;
}
function $3e88191b87395c2e$export$ad110a3ea760d531(t) {
    const e = $3e88191b87395c2e$export$fe2a41df16bf88cd(t);
    if (null === e) return null;
    const n = t.getLatest().__key;
    for (const [t, o] of $3e88191b87395c2e$var$ea(e))if (o === n) return t;
    return null;
}
function $3e88191b87395c2e$export$fe2dfd0f9ec2306d(t) {
    let e = t.getLatest();
    for(; null !== e;){
        if (null !== $3e88191b87395c2e$var$Xc(e)) return e;
        e = e.getParent();
    }
    return null;
}
function $3e88191b87395c2e$var$ea(t) {
    const e = t.getLatest();
    return $3e88191b87395c2e$export$e14ad7e55d229066(e) && null !== e.__slots ? e.__slots : $3e88191b87395c2e$var$qc;
}
function $3e88191b87395c2e$export$c83fc7fbb76e480a(t) {
    return Array.from($3e88191b87395c2e$var$ea(t).keys());
}
function $3e88191b87395c2e$export$ea4162355720819(t, e) {
    const n = $3e88191b87395c2e$var$ea(t).get(e);
    return void 0 === n ? null : $3e88191b87395c2e$export$e725f93d4d48c6d8(n);
}
const $3e88191b87395c2e$var$ra = [
    "__proto__",
    "constructor",
    "prototype"
], $3e88191b87395c2e$var$ia = Symbol("slotMapOwner");
function $3e88191b87395c2e$var$sa(t) {
    let e = t.__slots;
    return null !== e && e[$3e88191b87395c2e$var$ia] === t || (e = new Map(e), e[$3e88191b87395c2e$var$ia] = t, t.__slots = e), e;
}
const $3e88191b87395c2e$var$la = new WeakMap, $3e88191b87395c2e$var$ca = [];
function $3e88191b87395c2e$export$5ca0f72a0e5cc5bb(t) {
    for (const { ownNodeConfig: e } of $3e88191b87395c2e$export$9f01219fd9911d4c(t)){
        const t = e && e.slots;
        if (t) return t;
    }
    return $3e88191b87395c2e$var$ca;
}
function $3e88191b87395c2e$var$ua(t) {
    let e = "";
    for (const n of $3e88191b87395c2e$export$c83fc7fbb76e480a(t)){
        const o = $3e88191b87395c2e$export$ea4162355720819(t, n);
        null !== o && (e += o.getTextContent());
    }
    return e;
}
function $3e88191b87395c2e$var$fa(t, e, n) {
    const o = n.get(t), r = n.get(e);
    return void 0 !== o ? void 0 !== r ? o - r : -1 : void 0 !== r ? 1 : t < e ? -1 : t > e ? 1 : 0;
}
function $3e88191b87395c2e$var$da(e) {
    const n = e.__slots;
    if (null === n || n.size < 2) return;
    const o = function(e) {
        let n = $3e88191b87395c2e$var$la.get(e);
        if (void 0 === n) {
            const o = $3e88191b87395c2e$export$5ca0f72a0e5cc5bb(e), r = new Map;
            for (const n of o)$3e88191b87395c2e$var$ra.includes(n) && $3e88191b87395c2e$var$t(371, e.name, n), r.has(n) && $3e88191b87395c2e$var$t(372, e.name, n), r.set(n, r.size);
            n = r, $3e88191b87395c2e$var$la.set(e, n);
        }
        return n;
    }(e.constructor);
    let r = null, i = !0;
    for (const t of n.keys()){
        if (null !== r && $3e88191b87395c2e$var$fa(r, t, o) > 0) {
            i = !1;
            break;
        }
        r = t;
    }
    if (i) return;
    const s = Array.from(n).sort(([t], [e])=>$3e88191b87395c2e$var$fa(t, e, o));
    n.clear();
    for (const [t, e] of s)n.set(t, e);
}
function $3e88191b87395c2e$export$74e604a6c813bb6f(e, n, o) {
    "__proto__" !== n && "constructor" !== n && "prototype" !== n || $3e88191b87395c2e$var$t(373, n);
    const r = e.getLatest();
    if (null !== r.__slots && r.__slots.get(n) === o.getLatest().__key) return r;
    (!$3e88191b87395c2e$export$923a058ef54437a4(o) && !$3e88191b87395c2e$export$60aa03725ce41b1c(o) || o.isInline()) && $3e88191b87395c2e$var$t(374, o.__key);
    const i = e.getWritable(), s = $3e88191b87395c2e$var$sa(i), l = s.get(n);
    void 0 !== l && $3e88191b87395c2e$var$pa(l);
    const c = o.getWritable(), a = $3e88191b87395c2e$export$fe2a41df16bf88cd(c);
    if (null !== a) {
        const t = $3e88191b87395c2e$export$ad110a3ea760d531(c);
        null !== t && $3e88191b87395c2e$var$sa(a.getWritable()).delete(t), c.__slotHost = null;
    }
    return $3e88191b87395c2e$export$37daa10d18442dd6(c), c.__slotHost = i.__key, s.set(n, c.__key), $3e88191b87395c2e$var$da(i), function() {
        const t = $3e88191b87395c2e$export$8a7392c46faf1a3f();
        t._slotsUsed = !0, t._pendingEditorState && (t._pendingEditorState._slotsUsed = !0);
    }(), i;
}
function $3e88191b87395c2e$export$fd9ec12460745091(t, e) {
    const n = t.getWritable();
    if (null === n.__slots) return n;
    const o = n.__slots.get(e);
    return void 0 !== o && ($3e88191b87395c2e$var$pa(o), $3e88191b87395c2e$var$sa(n).delete(e)), n;
}
function $3e88191b87395c2e$var$_a(t, e) {}
function $3e88191b87395c2e$var$pa(e) {
    const n = $3e88191b87395c2e$export$e725f93d4d48c6d8(e);
    if (null === n) return;
    const o = n.getWritable();
    $3e88191b87395c2e$export$6b4473cff535c86d(o) || $3e88191b87395c2e$var$t(377, e), o.__slotHost = null, o.remove();
}
const $3e88191b87395c2e$var$ya = {
    next: "previous",
    previous: "next"
};
class $3e88191b87395c2e$var$ma {
    [Symbol.iterator]() {
        return $3e88191b87395c2e$export$51a344848dcba5b({
            hasNext: $3e88191b87395c2e$export$3bcd9a2637e8506e,
            initial: this.getAdjacentCaret(),
            map: (t)=>t,
            step: (t)=>t.getAdjacentCaret()
        });
    }
    getAdjacentCaret() {
        return $3e88191b87395c2e$export$cdd98497d9dc1de9(this.getNodeAtCaret(), this.direction);
    }
    getSiblingCaret() {
        return $3e88191b87395c2e$export$cdd98497d9dc1de9(this.origin, this.direction);
    }
    remove() {
        const t = this.getNodeAtCaret();
        return t && t.remove(), this;
    }
    replaceOrInsert(t, e) {
        const n = this.getNodeAtCaret();
        return t.is(this.origin) || t.is(n) || (null === n ? this.insert(t) : n.replace(t, e)), this;
    }
    splice(e, n, o = "next") {
        const r = o === this.direction ? n : Array.from(n).reverse();
        let i = this;
        const s = this.getParentAtCaret(), l = new Map;
        for(let t = i.getAdjacentCaret(); null !== t && l.size < e; t = t.getAdjacentCaret()){
            const e = t.origin.getWritable();
            l.set(e.getKey(), e);
        }
        for (const e of r){
            if (l.size > 0) {
                const n = i.getNodeAtCaret();
                if (n) {
                    if (l.delete(n.getKey()), l.delete(e.getKey()), n.is(e) || i.origin.is(e)) ;
                    else {
                        const t = e.getParent();
                        t && t.is(s) && e.remove(), n.replace(e);
                    }
                } else null === n && $3e88191b87395c2e$var$t(263, Array.from(l).join(" "));
            } else i.insert(e);
            i = $3e88191b87395c2e$export$cdd98497d9dc1de9(e, this.direction);
        }
        for (const t of l.values())t.remove();
        return this;
    }
    constructor(t){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "origin", void 0);
        this.origin = t;
    }
}
class $3e88191b87395c2e$var$xa extends $3e88191b87395c2e$var$ma {
    getLatest() {
        const t = this.origin.getLatest();
        return t === this.origin ? this : $3e88191b87395c2e$export$19f6ef5eb31488f9(t, this.direction);
    }
    getParentCaret(t = "root") {
        return $3e88191b87395c2e$export$cdd98497d9dc1de9($3e88191b87395c2e$var$va(this.getParentAtCaret(), t), this.direction);
    }
    getFlipped() {
        const t = $3e88191b87395c2e$export$be9b688c8ff522db(this.direction);
        return $3e88191b87395c2e$export$cdd98497d9dc1de9(this.getNodeAtCaret(), t) || $3e88191b87395c2e$export$19f6ef5eb31488f9(this.origin, t);
    }
    getParentAtCaret() {
        return this.origin;
    }
    getChildCaret() {
        return this;
    }
    isSameNodeCaret(t) {
        return t instanceof $3e88191b87395c2e$var$xa && this.direction === t.direction && this.origin.is(t.origin);
    }
    isSamePointCaret(t) {
        return this.isSameNodeCaret(t);
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "type", "child");
    }
}
const $3e88191b87395c2e$var$Ca = {
    root: $3e88191b87395c2e$export$5b29ca560c2fedab,
    shadowRoot: $3e88191b87395c2e$export$6f851a24c61146af
};
function $3e88191b87395c2e$export$be9b688c8ff522db(t) {
    return $3e88191b87395c2e$var$ya[t];
}
function $3e88191b87395c2e$var$va(t, e = "root") {
    return null === t || $3e88191b87395c2e$var$Ca[e](t) ? null : null === $3e88191b87395c2e$var$Xc(t) ? t : null;
}
class $3e88191b87395c2e$var$Ta extends $3e88191b87395c2e$var$ma {
    getLatest() {
        const t = this.origin.getLatest();
        return t === this.origin ? this : $3e88191b87395c2e$export$cdd98497d9dc1de9(t, this.direction);
    }
    getSiblingCaret() {
        return this;
    }
    getParentAtCaret() {
        return this.origin.getParent();
    }
    getChildCaret() {
        return $3e88191b87395c2e$export$923a058ef54437a4(this.origin) ? $3e88191b87395c2e$export$19f6ef5eb31488f9(this.origin, this.direction) : null;
    }
    getParentCaret(t = "root") {
        return $3e88191b87395c2e$export$cdd98497d9dc1de9($3e88191b87395c2e$var$va(this.getParentAtCaret(), t), this.direction);
    }
    getFlipped() {
        const t = $3e88191b87395c2e$export$be9b688c8ff522db(this.direction);
        return $3e88191b87395c2e$export$cdd98497d9dc1de9(this.getNodeAtCaret(), t) || $3e88191b87395c2e$export$19f6ef5eb31488f9(this.origin.getParentOrThrow(), t);
    }
    isSamePointCaret(t) {
        return t instanceof $3e88191b87395c2e$var$Ta && this.direction === t.direction && this.origin.is(t.origin);
    }
    isSameNodeCaret(t) {
        return (t instanceof $3e88191b87395c2e$var$Ta || t instanceof $3e88191b87395c2e$var$ka) && this.direction === t.direction && this.origin.is(t.origin);
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "type", "sibling");
    }
}
class $3e88191b87395c2e$var$ka extends $3e88191b87395c2e$var$ma {
    getLatest() {
        const t = this.origin.getLatest();
        return t === this.origin ? this : $3e88191b87395c2e$export$be15ddddbeea202c(t, this.direction, this.offset);
    }
    getParentAtCaret() {
        return this.origin.getParent();
    }
    getChildCaret() {
        return null;
    }
    getParentCaret(t = "root") {
        return $3e88191b87395c2e$export$cdd98497d9dc1de9($3e88191b87395c2e$var$va(this.getParentAtCaret(), t), this.direction);
    }
    getFlipped() {
        return $3e88191b87395c2e$export$be15ddddbeea202c(this.origin, $3e88191b87395c2e$export$be9b688c8ff522db(this.direction), this.offset);
    }
    isSamePointCaret(t) {
        return t instanceof $3e88191b87395c2e$var$ka && this.direction === t.direction && this.origin.is(t.origin) && this.offset === t.offset;
    }
    isSameNodeCaret(t) {
        return (t instanceof $3e88191b87395c2e$var$Ta || t instanceof $3e88191b87395c2e$var$ka) && this.direction === t.direction && this.origin.is(t.origin);
    }
    getSiblingCaret() {
        return $3e88191b87395c2e$export$cdd98497d9dc1de9(this.origin, this.direction);
    }
    constructor(t, e){
        super(t), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "type", "text"), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "offset", void 0), this.offset = e;
    }
}
function $3e88191b87395c2e$export$6d8c68034bda7a85(t) {
    return t instanceof $3e88191b87395c2e$var$ka;
}
function $3e88191b87395c2e$export$e63f959533d3239d(t) {
    return t instanceof $3e88191b87395c2e$var$ma;
}
function $3e88191b87395c2e$export$3bcd9a2637e8506e(t) {
    return t instanceof $3e88191b87395c2e$var$Ta;
}
function $3e88191b87395c2e$export$1c3da6f3e60ca260(t) {
    return t instanceof $3e88191b87395c2e$var$xa;
}
const $3e88191b87395c2e$var$Oa = {
    next: class extends $3e88191b87395c2e$var$ka {
        getNodeAtCaret() {
            return this.origin.getNextSibling();
        }
        insert(t) {
            return this.origin.insertAfter(t), this;
        }
        constructor(...args){
            super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "direction", "next");
        }
    },
    previous: class extends $3e88191b87395c2e$var$ka {
        getNodeAtCaret() {
            return this.origin.getPreviousSibling();
        }
        insert(t) {
            return this.origin.insertBefore(t), this;
        }
        constructor(...args){
            super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "direction", "previous");
        }
    }
}, $3e88191b87395c2e$var$Ma = {
    next: class extends $3e88191b87395c2e$var$Ta {
        getNodeAtCaret() {
            return this.origin.getNextSibling();
        }
        insert(t) {
            return this.origin.insertAfter(t), this;
        }
        constructor(...args){
            super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "direction", "next");
        }
    },
    previous: class extends $3e88191b87395c2e$var$Ta {
        getNodeAtCaret() {
            return this.origin.getPreviousSibling();
        }
        insert(t) {
            return this.origin.insertBefore(t), this;
        }
        constructor(...args){
            super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "direction", "previous");
        }
    }
}, $3e88191b87395c2e$var$Aa = {
    next: class extends $3e88191b87395c2e$var$xa {
        getNodeAtCaret() {
            return this.origin.getFirstChild();
        }
        insert(t) {
            return this.origin.splice(0, 0, [
                t
            ]), this;
        }
        constructor(...args){
            super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "direction", "next");
        }
    },
    previous: class extends $3e88191b87395c2e$var$xa {
        getNodeAtCaret() {
            return this.origin.getLastChild();
        }
        insert(t) {
            return this.origin.splice(this.origin.getChildrenSize(), 0, [
                t
            ]), this;
        }
        constructor(...args){
            super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "direction", "previous");
        }
    }
};
function $3e88191b87395c2e$export$cdd98497d9dc1de9(t, e) {
    return t ? new $3e88191b87395c2e$var$Ma[e](t) : null;
}
function $3e88191b87395c2e$export$be15ddddbeea202c(t, e, n) {
    return t ? new $3e88191b87395c2e$var$Oa[e](t, $3e88191b87395c2e$export$d83ac801960e4905(t, n)) : null;
}
function $3e88191b87395c2e$export$d83ac801960e4905(t, n, o = "error") {
    const r = t.getTextContentSize();
    let i = "next" === n ? r : "previous" === n ? 0 : n;
    return (i < 0 || i > r) && ("clamp" !== o && $3e88191b87395c2e$var$e(284, String(n), String(r), t.getKey()), i = i < 0 ? 0 : r), i;
}
function $3e88191b87395c2e$export$6e1166a75f41f67a(t, e) {
    return new $3e88191b87395c2e$var$Ra(t, e);
}
function $3e88191b87395c2e$export$19f6ef5eb31488f9(t, e) {
    return $3e88191b87395c2e$export$923a058ef54437a4(t) ? new $3e88191b87395c2e$var$Aa[e](t) : null;
}
function $3e88191b87395c2e$export$823551f18b301259(t) {
    return t && t.getChildCaret() || t;
}
function $3e88191b87395c2e$export$17eea20b564ca4ca(t) {
    return t && $3e88191b87395c2e$export$823551f18b301259(t.getAdjacentCaret());
}
class $3e88191b87395c2e$var$Ba {
    getLatest() {
        const t = this.anchor.getLatest(), e = this.focus.getLatest();
        return t === this.anchor && e === this.focus ? this : new $3e88191b87395c2e$var$Ba(t, e, this.direction);
    }
    isCollapsed() {
        return this.anchor.isSamePointCaret(this.focus);
    }
    getTextSlices() {
        const t = (t)=>{
            const e = this[t].getLatest();
            return $3e88191b87395c2e$export$6d8c68034bda7a85(e) ? function(t, e) {
                const { direction: n, origin: o } = t, r = $3e88191b87395c2e$export$d83ac801960e4905(o, "focus" === e ? $3e88191b87395c2e$export$be9b688c8ff522db(n) : n);
                return $3e88191b87395c2e$export$6e1166a75f41f67a(t, r - t.offset);
            }(e, t) : null;
        }, e = t("anchor"), n = t("focus");
        if (e && n) {
            const { caret: t } = e, { caret: o } = n;
            if (t.isSameNodeCaret(o)) return [
                $3e88191b87395c2e$export$6e1166a75f41f67a(t, o.offset - t.offset),
                null
            ];
        }
        return [
            e,
            n
        ];
    }
    iterNodeCarets(t = "root") {
        const e = $3e88191b87395c2e$export$6d8c68034bda7a85(this.anchor) ? this.anchor.getSiblingCaret() : this.anchor.getLatest(), n = this.focus.getLatest(), o = $3e88191b87395c2e$export$6d8c68034bda7a85(n), r = (e)=>e.isSameNodeCaret(n) ? null : $3e88191b87395c2e$export$17eea20b564ca4ca(e) || e.getParentCaret(t);
        return $3e88191b87395c2e$export$51a344848dcba5b({
            hasNext: (t)=>null !== t && !(o && n.isSameNodeCaret(t)),
            initial: e.isSameNodeCaret(n) ? null : r(e),
            map: (t)=>t,
            step: r
        });
    }
    [Symbol.iterator]() {
        return this.iterNodeCarets("root");
    }
    constructor(t, e, n){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "type", "node-caret-range");
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "direction", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "anchor", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "focus", void 0);
        this.anchor = t, this.focus = e, this.direction = n;
    }
}
class $3e88191b87395c2e$var$Ra {
    getSliceIndices() {
        const { distance: t, caret: { offset: e } } = this, n = e + t;
        return n < e ? [
            n,
            e
        ] : [
            e,
            n
        ];
    }
    getTextContent() {
        const [t, e] = this.getSliceIndices();
        return this.caret.origin.getTextContent().slice(t, e);
    }
    getTextContentSize() {
        return Math.abs(this.distance);
    }
    removeTextSlice() {
        const { caret: { origin: t, direction: e } } = this, [n, o] = this.getSliceIndices(), r = t.getTextContent();
        return $3e88191b87395c2e$export$be15ddddbeea202c(t.setTextContent(r.slice(0, n) + r.slice(o)), e, n);
    }
    constructor(t, e){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "type", "slice");
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "caret", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "distance", void 0);
        this.caret = t, this.distance = e;
    }
}
function $3e88191b87395c2e$export$9f70dc0a2203160f(t) {
    return t instanceof $3e88191b87395c2e$var$Ra;
}
function $3e88191b87395c2e$export$7f1827f6551d91c3(t) {
    return $3e88191b87395c2e$export$36f672915982afb2(t, $3e88191b87395c2e$export$cdd98497d9dc1de9($3e88191b87395c2e$export$8d83ea843c4eea9a(), t.direction));
}
function $3e88191b87395c2e$export$4a7df333303cecc7(t) {
    return $3e88191b87395c2e$export$36f672915982afb2(t, t);
}
function $3e88191b87395c2e$export$36f672915982afb2(e, n) {
    return e.direction !== n.direction && $3e88191b87395c2e$var$t(265), new $3e88191b87395c2e$var$Ba(e, n, e.direction);
}
function $3e88191b87395c2e$export$51a344848dcba5b(t) {
    const { initial: e, hasNext: n, step: o, map: r } = t;
    let i = e;
    return {
        [Symbol.iterator] () {
            return this;
        },
        next () {
            if (!n(i)) return {
                done: !0,
                value: void 0
            };
            const t = {
                done: !1,
                value: r(i)
            };
            return i = o(i), t;
        }
    };
}
function $3e88191b87395c2e$export$cfa5c948dc0495fa(e, n) {
    const o = $3e88191b87395c2e$export$8e83ae67c400e272(e.origin, n.origin);
    switch(null === o && $3e88191b87395c2e$var$t(275, e.origin.getKey(), n.origin.getKey()), o.type){
        case "same":
            {
                const t = "text" === e.type, o = "text" === n.type;
                return t && o ? function(t, e) {
                    return Math.sign(t - e);
                }(e.offset, n.offset) : e.type === n.type ? 0 : t ? -1 : o ? 1 : "child" === e.type ? -1 : 1;
            }
        case "ancestor":
            return "child" === e.type ? -1 : 1;
        case "descendant":
            return "child" === n.type ? 1 : -1;
        case "branch":
            return $3e88191b87395c2e$export$a903b6b3a0477995(o);
    }
}
function $3e88191b87395c2e$export$a903b6b3a0477995(t) {
    const { a: e, b: n } = t, o = e.__key, r = n.__key;
    let i = e, s = n;
    for(; i && s; i = i.getNextSibling(), s = s.getNextSibling()){
        if (i.__key === r) return -1;
        if (s.__key === o) return 1;
    }
    return null === i ? 1 : -1;
}
function $3e88191b87395c2e$var$qa(t, e) {
    return e.is(t);
}
function $3e88191b87395c2e$var$Ya(t) {
    return $3e88191b87395c2e$export$923a058ef54437a4(t) ? [
        t.getLatest(),
        null
    ] : [
        t.getParent(),
        t.getLatest()
    ];
}
function $3e88191b87395c2e$export$8e83ae67c400e272(e, n) {
    if (e.is(n)) return {
        commonAncestor: e,
        type: "same"
    };
    const o = new Map;
    for(let [t, n] = $3e88191b87395c2e$var$Ya(e); t; n = t, t = t.getParent())o.set(t, n);
    for(let [r, i] = $3e88191b87395c2e$var$Ya(n); r; i = r, r = r.getParent()){
        const s = o.get(r);
        if (void 0 !== s) return null === s ? ($3e88191b87395c2e$var$qa(e, r) || $3e88191b87395c2e$var$t(276), {
            commonAncestor: r,
            type: "ancestor"
        }) : null === i ? ($3e88191b87395c2e$var$qa(n, r) || $3e88191b87395c2e$var$t(277), {
            commonAncestor: r,
            type: "descendant"
        }) : (($3e88191b87395c2e$export$923a058ef54437a4(s) || $3e88191b87395c2e$var$qa(e, s)) && ($3e88191b87395c2e$export$923a058ef54437a4(i) || $3e88191b87395c2e$var$qa(n, i)) && r.is(s.getParent()) && r.is(i.getParent()) || $3e88191b87395c2e$var$t(278), {
            a: s,
            b: i,
            commonAncestor: r,
            type: "branch"
        });
    }
    return null;
}
function $3e88191b87395c2e$export$e435a0def9eb2000(e, n) {
    const { type: o, key: r, offset: i } = e, s = $3e88191b87395c2e$export$b86173decb513938(e.key);
    return "text" === o ? ($3e88191b87395c2e$export$471953706258be2b(s) || $3e88191b87395c2e$var$t(266, s.getType(), r), $3e88191b87395c2e$export$be15ddddbeea202c(s, n, i)) : ($3e88191b87395c2e$export$923a058ef54437a4(s) || $3e88191b87395c2e$var$t(267, s.getType(), r), $3e88191b87395c2e$export$723976e2b4bde43d(s, e.offset, n));
}
function $3e88191b87395c2e$export$dd601b22fa430ce6(e, n) {
    const { origin: o, direction: r } = n, i = "next" === r;
    $3e88191b87395c2e$export$6d8c68034bda7a85(n) ? e.set(o.getKey(), n.offset, "text") : $3e88191b87395c2e$export$3bcd9a2637e8506e(n) ? $3e88191b87395c2e$export$471953706258be2b(o) ? e.set(o.getKey(), $3e88191b87395c2e$export$d83ac801960e4905(o, r), "text") : e.set(o.getParentOrThrow().getKey(), o.getIndexWithinParent() + (i ? 1 : 0), "element") : ($3e88191b87395c2e$export$1c3da6f3e60ca260(n) && $3e88191b87395c2e$export$923a058ef54437a4(o) || $3e88191b87395c2e$var$t(268), e.set(o.getKey(), i ? 0 : o.getChildrenSize(), "element"));
}
function $3e88191b87395c2e$export$9fb698110f44889d(t) {
    const e = $3e88191b87395c2e$export$63a3201b3a5c7d90(), n = $3e88191b87395c2e$export$181b63acea8a0224(e) ? e : $3e88191b87395c2e$export$1ccc217b9831b072();
    return $3e88191b87395c2e$export$704f368fc2317a88(n, t), $3e88191b87395c2e$export$2aad78c37810bca9(n), n;
}
function $3e88191b87395c2e$export$704f368fc2317a88(t, e) {
    $3e88191b87395c2e$export$dd601b22fa430ce6(t.anchor, e.anchor), $3e88191b87395c2e$export$dd601b22fa430ce6(t.focus, e.focus);
}
function $3e88191b87395c2e$export$7bcaa61bc56938bf(t) {
    const { anchor: e, focus: n } = t, o = $3e88191b87395c2e$export$e435a0def9eb2000(e, "next"), r = $3e88191b87395c2e$export$e435a0def9eb2000(n, "next"), i = $3e88191b87395c2e$export$cfa5c948dc0495fa(o, r) <= 0 ? "next" : "previous";
    return $3e88191b87395c2e$export$36f672915982afb2($3e88191b87395c2e$export$6899265904214748(o, i), $3e88191b87395c2e$export$6899265904214748(r, i));
}
function $3e88191b87395c2e$export$3d19514618fb28f3(t) {
    const { direction: e, origin: n } = t, o = $3e88191b87395c2e$export$cdd98497d9dc1de9(n, $3e88191b87395c2e$export$be9b688c8ff522db(e)).getNodeAtCaret();
    return o ? $3e88191b87395c2e$export$cdd98497d9dc1de9(o, e) : $3e88191b87395c2e$export$19f6ef5eb31488f9(n.getParentOrThrow(), e);
}
function $3e88191b87395c2e$var$ou(t, e = "root") {
    const n = [
        t
    ];
    for(let o = $3e88191b87395c2e$export$1c3da6f3e60ca260(t) ? t.getParentCaret(e) : t.getSiblingCaret(); null !== o; o = o.getParentCaret(e))n.push($3e88191b87395c2e$export$3d19514618fb28f3(o));
    return n;
}
function $3e88191b87395c2e$var$ru(t) {
    return !!t && t.origin.isAttached();
}
function $3e88191b87395c2e$export$9421bed7a385cd41(e, n = "removeEmptySlices") {
    if (e.isCollapsed()) return e;
    const o = "root", r = "next";
    let i = n;
    const s = $3e88191b87395c2e$export$b6aa34707ffda54a(e, r), l = $3e88191b87395c2e$var$ou(s.anchor, o), c = $3e88191b87395c2e$var$ou(s.focus.getFlipped(), o), a = new Set, u = [];
    for (const t of s.iterNodeCarets(o))if ($3e88191b87395c2e$export$1c3da6f3e60ca260(t)) a.add(t.origin.getKey());
    else if ($3e88191b87395c2e$export$3bcd9a2637e8506e(t)) {
        const { origin: e } = t;
        $3e88191b87395c2e$export$923a058ef54437a4(e) && !a.has(e.getKey()) || u.push(e);
    }
    for (const t of u)t.remove();
    for (const t of s.getTextSlices()){
        if (!t) continue;
        const { origin: e } = t.caret, n = e.getTextContentSize(), o = $3e88191b87395c2e$export$3d19514618fb28f3($3e88191b87395c2e$export$cdd98497d9dc1de9(e, r)), s = e.getMode();
        if (Math.abs(t.distance) === n && "removeEmptySlices" === i || "token" === s && 0 !== t.distance) o.remove();
        else if (0 !== t.distance) {
            i = "removeEmptySlices";
            let e = t.removeTextSlice();
            const n = t.caret.origin;
            if ("segmented" === s) {
                const t = e.origin, n = $3e88191b87395c2e$export$2785f39dcdec0078(t.getTextContent()).setStyle(t.getStyle()).setFormat(t.getFormat());
                o.replaceOrInsert(n), e = $3e88191b87395c2e$export$be15ddddbeea202c(n, r, e.offset);
            }
            n.is(l[0].origin) && (l[0] = e), n.is(c[0].origin) && (c[0] = e.getFlipped());
        }
    }
    let f, d;
    for (const t of l)if ($3e88191b87395c2e$var$ru(t)) {
        f = $3e88191b87395c2e$export$33e015e8f2ff8536(t);
        break;
    }
    for (const t of c)if ($3e88191b87395c2e$var$ru(t)) {
        d = $3e88191b87395c2e$export$33e015e8f2ff8536(t);
        break;
    }
    const h = function(t, e, n) {
        if (!t || !e) return null;
        const o = t.getParentAtCaret(), r = e.getParentAtCaret();
        if (!o || !r) return null;
        const i = o.getParents().reverse();
        i.push(o);
        const s = r.getParents().reverse();
        s.push(r);
        const l = Math.min(i.length, s.length);
        let c;
        for(c = 0; c < l && i[c] === s[c]; c++);
        const a = (t, e)=>{
            let n;
            for(let o = c; o < t.length; o++){
                const r = t[o];
                if ($3e88191b87395c2e$export$6f851a24c61146af(r)) return;
                !n && e(r) && (n = r);
            }
            return n;
        }, u = a(i, $3e88191b87395c2e$export$bd7ca521104e245c), f = u && a(s, (t)=>n.has(t.getKey()) && $3e88191b87395c2e$export$bd7ca521104e245c(t));
        if (f && $3e88191b87395c2e$export$c83fc7fbb76e480a(f).length > 0) return null;
        return u && f ? [
            u,
            f
        ] : null;
    }(f, d, a);
    if (h) {
        const [t, e] = h;
        $3e88191b87395c2e$export$19f6ef5eb31488f9(t, "previous").splice(0, e.getChildren());
        let n = e.getParent();
        for(e.remove(!0); n && n.isEmpty();){
            const t = n;
            n = n.getParent(), t.remove(!0);
        }
    } else if (d) {
        const t = function(t) {
            if ($3e88191b87395c2e$export$1c3da6f3e60ca260(t)) {
                const e = t.origin;
                if ($3e88191b87395c2e$export$bd7ca521104e245c(e)) return e;
            } else {
                const e = t.getParentAtCaret();
                if (e && $3e88191b87395c2e$export$bd7ca521104e245c(e)) return e;
            }
            return null;
        }(d), e = t && t.getParent(), n = t && t.getParents().findLast($3e88191b87395c2e$export$966170d136a21178);
        if (t && e && !$3e88191b87395c2e$export$5b29ca560c2fedab(e) && t.isEmpty() && a.has(t.getKey()) && 0 === $3e88191b87395c2e$export$c83fc7fbb76e480a(t).length && (!n || a.has(n.getKey()))) {
            t.remove(!0);
            let n = e;
            for(; n && !$3e88191b87395c2e$export$5b29ca560c2fedab(n) && n.isEmpty();){
                const t = n.getParent();
                if (t && $3e88191b87395c2e$export$5b29ca560c2fedab(t) && t.getChildrenSize() <= 1) break;
                const e = n;
                n = t, e.remove(!0);
            }
        }
    }
    const g = [
        f,
        d,
        ...l,
        ...c
    ].find($3e88191b87395c2e$var$ru);
    if (g) return $3e88191b87395c2e$export$4a7df333303cecc7($3e88191b87395c2e$export$6899265904214748($3e88191b87395c2e$export$33e015e8f2ff8536(g), e.direction));
    $3e88191b87395c2e$var$t(269, JSON.stringify(l.map((t)=>t.origin.__key)));
}
function $3e88191b87395c2e$export$33e015e8f2ff8536(t) {
    const e = function(t) {
        let e = t;
        for(; $3e88191b87395c2e$export$1c3da6f3e60ca260(e);){
            const t = $3e88191b87395c2e$export$17eea20b564ca4ca(e);
            if (!$3e88191b87395c2e$export$1c3da6f3e60ca260(t)) break;
            e = t;
        }
        return e;
    }(t.getLatest()), { direction: n } = e;
    if ($3e88191b87395c2e$export$471953706258be2b(e.origin)) return $3e88191b87395c2e$export$6d8c68034bda7a85(e) ? e : $3e88191b87395c2e$export$be15ddddbeea202c(e.origin, n, n);
    const o = e.getAdjacentCaret();
    return $3e88191b87395c2e$export$3bcd9a2637e8506e(o) && $3e88191b87395c2e$export$471953706258be2b(o.origin) ? $3e88191b87395c2e$export$be15ddddbeea202c(o.origin, n, $3e88191b87395c2e$export$be9b688c8ff522db(n)) : e;
}
function $3e88191b87395c2e$export$2b09d6371b5f4203(t) {
    return $3e88191b87395c2e$export$6d8c68034bda7a85(t) && t.offset !== $3e88191b87395c2e$export$d83ac801960e4905(t.origin, t.direction);
}
function $3e88191b87395c2e$export$6899265904214748(t, e) {
    return t.direction === e ? t : t.getFlipped();
}
function $3e88191b87395c2e$export$b6aa34707ffda54a(t, e) {
    return t.direction === e ? t : $3e88191b87395c2e$export$36f672915982afb2($3e88191b87395c2e$export$6899265904214748(t.focus, e), $3e88191b87395c2e$export$6899265904214748(t.anchor, e));
}
function $3e88191b87395c2e$export$723976e2b4bde43d(t, e, n) {
    let o = $3e88191b87395c2e$export$19f6ef5eb31488f9(t, "next");
    for(let t = 0; t < e; t++){
        const t = o.getAdjacentCaret();
        if (null === t) break;
        o = t;
    }
    return $3e88191b87395c2e$export$6899265904214748(o, n);
}
function $3e88191b87395c2e$export$f0135ff654c2200b(t, e = "root") {
    let n = 0, o = t, r = $3e88191b87395c2e$export$17eea20b564ca4ca(o);
    for(; null === r;){
        if (n--, r = o.getParentCaret(e), !r) return null;
        o = r, r = $3e88191b87395c2e$export$17eea20b564ca4ca(o);
    }
    return r && [
        r,
        n
    ];
}
function $3e88191b87395c2e$var$du(e) {
    const { origin: n, offset: o, direction: r } = e;
    if (o === $3e88191b87395c2e$export$d83ac801960e4905(n, r)) return e.getSiblingCaret();
    if (o === $3e88191b87395c2e$export$d83ac801960e4905(n, $3e88191b87395c2e$export$be9b688c8ff522db(r))) return $3e88191b87395c2e$export$3d19514618fb28f3(e.getSiblingCaret());
    const [i] = n.splitText(o);
    return $3e88191b87395c2e$export$471953706258be2b(i) || $3e88191b87395c2e$var$t(281), $3e88191b87395c2e$export$6899265904214748($3e88191b87395c2e$export$cdd98497d9dc1de9(i, "next"), r);
}
function $3e88191b87395c2e$var$hu(t, e) {
    return !0;
}
function $3e88191b87395c2e$export$9138b8478eedbb65(t, { $copyElementNode: e = $3e88191b87395c2e$export$def73b17b22438e7, $splitTextPointCaretNext: n = $3e88191b87395c2e$var$du, rootMode: o = "shadowRoot", $shouldSplit: r = $3e88191b87395c2e$var$hu, removeEmptyDestination: i = !1 } = {}) {
    if ($3e88191b87395c2e$export$6d8c68034bda7a85(t)) return n(t);
    const s = t.getParentCaret(o);
    if (s) {
        const { origin: n } = s;
        if ($3e88191b87395c2e$export$1c3da6f3e60ca260(t)) {
            const t = $3e88191b87395c2e$export$3d19514618fb28f3(s);
            if (i && n.isEmpty()) return n.remove(), t;
            if (!n.canBeEmpty() || !r(n, "first")) return t;
        }
        const o = function(t) {
            const e = [];
            for(let n = t.getAdjacentCaret(); n; n = n.getAdjacentCaret())e.push(n.origin);
            return e;
        }(t);
        (o.length > 0 || !i && n.canBeEmpty() && r(n, "last")) && s.insert(e(n).splice(0, 0, o));
    }
    return s;
}
function $3e88191b87395c2e$export$8074a5062ab072d1(e, n, o) {
    let r = $3e88191b87395c2e$export$6899265904214748(n, "next");
    $3e88191b87395c2e$export$6d8c68034bda7a85(r) && (0 === r.offset ? r = $3e88191b87395c2e$export$cdd98497d9dc1de9(r.origin, "previous").getFlipped() : r.offset === r.origin.getTextContentSize() && (r = $3e88191b87395c2e$export$cdd98497d9dc1de9(r.origin, "next"))), r.origin.is(e) && ($3e88191b87395c2e$export$3bcd9a2637e8506e(r) || $3e88191b87395c2e$var$t(342, e.getKey(), e.getType()), r = $3e88191b87395c2e$export$3d19514618fb28f3(r)), (e.is(r.getNodeAtCaret()) || e.is(r.getFlipped().getNodeAtCaret())) && e.remove(!0);
    for(let t = r; t; t = $3e88191b87395c2e$export$9138b8478eedbb65(t, o))r = t;
    return $3e88191b87395c2e$export$6d8c68034bda7a85(r) && $3e88191b87395c2e$var$t(283), r.insert(e.isInline() ? $3e88191b87395c2e$export$7f0c05ffb7ced90d().append(e) : e), $3e88191b87395c2e$export$6899265904214748($3e88191b87395c2e$export$cdd98497d9dc1de9(e.getLatest(), "next"), n.direction);
}
function $3e88191b87395c2e$export$71a90bfc0b778801(t) {
    return t;
}
function $3e88191b87395c2e$export$7c74af9ea11c2716(...t) {
    return t;
}
function $3e88191b87395c2e$export$27b7a43b7d643f5f(t, e) {
    return [
        t,
        e
    ];
}
function $3e88191b87395c2e$export$a15b7eb5055a4ef6(t) {
    return t;
}
function $3e88191b87395c2e$export$89e5ee996f4118(t, e) {
    if (!e || t === e) return t;
    for(const n in e)if (t[n] !== e[n]) return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, t, e);
    return t;
}
function $3e88191b87395c2e$export$68575042fda37fa9(...t) {
    const e = [];
    for (const n of t)if (n && "string" == typeof n) for (const [t] of n.matchAll(/\S+/g))e.push(t);
    return e;
}
function $3e88191b87395c2e$export$71781797876b07d6(t, ...e) {
    const n = $3e88191b87395c2e$export$68575042fda37fa9(...e);
    n.length > 0 && t.classList.add(...n);
}
function $3e88191b87395c2e$export$b59af601940ff389(t, ...e) {
    const n = $3e88191b87395c2e$export$68575042fda37fa9(...e);
    n.length > 0 && t.classList.remove(...n);
}
function $3e88191b87395c2e$export$d64d64f541cc1835(...t) {
    return ()=>{
        for(let e = t.length - 1; e >= 0; e--)t[e]();
        t.length = 0;
    };
}
function $3e88191b87395c2e$export$4256f76d7567e2ca(t, e, n) {
    return $3e88191b87395c2e$export$d64d64f541cc1835(...Object.entries(e).map(([e, o])=>$3e88191b87395c2e$export$bea698773a21b4e8(t, e, o, n)));
}


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 




/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

function $016075a3cb2a2f02$var$B(e, ...t) {
    const n = new URL("https://lexical.dev/docs/error"), o = new URLSearchParams;
    o.append("code", e);
    for (const e of t)o.append("v", e);
    throw n.search = o.toString(), Error(`Minified Lexical error #${e}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
/*@__INLINE__*/ function $016075a3cb2a2f02$var$k(e) {
    let t = e;
    for(; null != t;){
        if (t.nodeType === Node.TEXT_NODE) return t;
        t = t.firstChild;
    }
    return null;
}
function $016075a3cb2a2f02$var$F(e) {
    const t = e.parentNode;
    if (null == t) throw new Error("Should never happen");
    return [
        t,
        Array.from(t.childNodes).indexOf(e)
    ];
}
function $016075a3cb2a2f02$export$b5835907b026f0bc(n, o, l, r, i) {
    const s = o.getKey(), c = r.getKey(), f = (0, $3e88191b87395c2e$export$c074c5c00886935b)(n.getRootElement()).createRange();
    let u = n.getElementByKey(s), g = n.getElementByKey(c), a = l, d = i;
    if ((0, $3e88191b87395c2e$export$471953706258be2b)(o) && (u = $016075a3cb2a2f02$var$k(u)), (0, $3e88191b87395c2e$export$471953706258be2b)(r) && (g = $016075a3cb2a2f02$var$k(g)), void 0 === o || void 0 === r || null === u || null === g) return null;
    "BR" === u.nodeName && ([u, a] = $016075a3cb2a2f02$var$F(u)), "BR" === g.nodeName && ([g, d] = $016075a3cb2a2f02$var$F(g));
    const p = u.firstChild;
    u === g && null != p && "BR" === p.nodeName && 0 === a && 0 === d && (d = 1);
    try {
        f.setStart(u, a), f.setEnd(g, d);
    } catch (e) {
        return null;
    }
    return !f.collapsed || a === d && s === c || (f.setStart(g, d), f.setEnd(u, a)), f;
}
function $016075a3cb2a2f02$export$3021984b31d6d2e2(e, t) {
    const n = e.getRootElement();
    if (null === n) return [];
    const o = n.getBoundingClientRect(), l = getComputedStyle(n), r = parseFloat(l.paddingLeft) + parseFloat(l.paddingRight), i = Array.from(t.getClientRects());
    let s, c = i.length;
    i.sort((e, t)=>{
        const n = e.top - t.top;
        return Math.abs(n) <= 3 ? e.left - t.left : n;
    });
    for(let e = 0; e < c; e++){
        const t = i[e], n = s && s.top <= t.top && s.top + s.height > t.top && s.left + s.width > t.left, l = t.width + r === o.width;
        n || l ? (i.splice(e--, 1), c--) : s = t;
    }
    return i;
}
function $016075a3cb2a2f02$export$ed350edd4ef5f44d(e) {
    let t = "";
    for(const n in e)n && (t += `${n}: ${e[n]};`);
    return t;
}
function $016075a3cb2a2f02$export$47af7ba34f93d90a(e) {
    const t = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)().getElementByKey(e.getKey());
    if (null === t) return null;
    const o = t.ownerDocument.defaultView;
    return null === o ? null : o.getComputedStyle(t);
}
function $016075a3cb2a2f02$export$a64a14806f0ec48d(e) {
    return $016075a3cb2a2f02$export$47af7ba34f93d90a((0, $3e88191b87395c2e$export$5b29ca560c2fedab)(e) ? e : e.getParentOrThrow());
}
function $016075a3cb2a2f02$export$368701545dbe0002(e) {
    const t = $016075a3cb2a2f02$export$a64a14806f0ec48d(e);
    return null !== t && "rtl" === t.direction;
}
function $016075a3cb2a2f02$export$56763a00ff6960e6(e, t, n = "self") {
    const o = e.getStartEndPoints();
    if (t.isSelected(e) && !(0, $3e88191b87395c2e$export$8b834332909623ff)(t) && null !== o) {
        const [l, r] = o, i = e.isBackward(), s = l.getNode(), c = r.getNode(), g = t.is(s), a = t.is(c);
        if (g || a) {
            const [o, l] = (0, $3e88191b87395c2e$export$5a33b5b9a9d5db8f)(e), r = s.is(c), g = t.is(i ? c : s), a = t.is(i ? s : c);
            let d, p = 0;
            if (r) p = o > l ? l : o, d = o > l ? o : l;
            else if (g) p = i ? l : o, d = void 0;
            else if (a) p = 0, d = i ? o : l;
            const h = t.__text.slice(p, d);
            h !== t.__text && ("clone" === n && (t = (0, $3e88191b87395c2e$export$26da83a243ca58b3)(t)), t.__text = h);
        }
    }
    return t;
}
function $016075a3cb2a2f02$export$899bddb8773a1c9e(e) {
    if ("text" === e.type) return e.offset === e.getNode().getTextContentSize();
    const t = e.getNode();
    return (0, $3e88191b87395c2e$export$923a058ef54437a4)(t) || $016075a3cb2a2f02$var$B(177), e.offset === t.getChildrenSize();
}
function $016075a3cb2a2f02$export$440ba083e0a4348(e, n, l) {
    let i = n.getNode(), s = l;
    if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(i)) {
        const e = i.getDescendantByIndex(n.offset);
        null !== e && (i = e);
    }
    for(; s > 0 && null !== i;){
        if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(i)) {
            const e = i.getLastDescendant();
            null !== e && (i = e);
        }
        let l = i.getPreviousSibling(), f = 0;
        if (null === l) {
            let e = i.getParentOrThrow(), t = e.getPreviousSibling();
            for(; null === t;){
                if (e = e.getParent(), null === e) {
                    l = null;
                    break;
                }
                t = e.getPreviousSibling();
            }
            null !== e && (f = e.isInline() ? 0 : 2, l = t);
        }
        let u = i.getTextContent();
        "" === u && (0, $3e88191b87395c2e$export$923a058ef54437a4)(i) && !i.isInline() && (u = "\n\n");
        const p = u.length;
        if (!(0, $3e88191b87395c2e$export$471953706258be2b)(i) || s >= p) {
            const e = i.getParent();
            i.remove(), null == e || 0 !== e.getChildrenSize() || (0, $3e88191b87395c2e$export$5b29ca560c2fedab)(e) || e.remove(), s -= p + f, i = l;
        } else {
            const o = i.getKey(), l = e.read("latest", ()=>{
                const e = (0, $3e88191b87395c2e$export$e725f93d4d48c6d8)(o);
                return (0, $3e88191b87395c2e$export$471953706258be2b)(e) && e.isSimpleText() ? e.getTextContent() : null;
            }), c = p - s, f = u.slice(0, c);
            if (null !== l && l !== u) {
                const e = (0, $3e88191b87395c2e$export$846e9407a8b5d98c)();
                let t = i;
                if (i.isSimpleText()) i.setTextContent(l);
                else {
                    const e = (0, $3e88191b87395c2e$export$2785f39dcdec0078)(l);
                    i.replace(e), t = e;
                }
                if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && e.isCollapsed()) {
                    const n = e.anchor.offset;
                    t.select(n, n);
                }
            } else if (i.isSimpleText()) {
                const e = n.key === o;
                let t = n.offset;
                t < s && (t = p);
                const l = e ? t - s : 0, r = e ? t : c;
                if (e && 0 === l) {
                    const [e] = i.splitText(l, r);
                    e.remove();
                } else {
                    const [, e] = i.splitText(l, r);
                    e.remove();
                }
            } else {
                const e = (0, $3e88191b87395c2e$export$2785f39dcdec0078)(f);
                i.replace(e);
            }
            s = 0;
        }
    }
}
const $016075a3cb2a2f02$export$2c70ac68e537db45 = ()=>{};
function $016075a3cb2a2f02$var$U(e, n) {
    ((0, $3e88191b87395c2e$export$181b63acea8a0224)(e) ? e.isCollapsed() : (0, $3e88191b87395c2e$export$471953706258be2b)(e) || (0, $3e88191b87395c2e$export$923a058ef54437a4)(e)) || $016075a3cb2a2f02$var$B(280);
    const o = (0, $3e88191b87395c2e$export$2ce8a4767ed9993e)((0, $3e88191b87395c2e$export$181b63acea8a0224)(e) ? e.style : (0, $3e88191b87395c2e$export$471953706258be2b)(e) ? e.getStyle() : e.getTextStyle()), l = $016075a3cb2a2f02$export$ed350edd4ef5f44d(Object.entries(n).reduce((t, [n, l])=>("function" == typeof l ? t[n] = l(o[n], e) : null === l ? delete t[n] : t[n] = l, t), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, o)));
    (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) || (0, $3e88191b87395c2e$export$471953706258be2b)(e) ? e.setStyle(l) : e.setTextStyle(l);
}
function $016075a3cb2a2f02$export$77e498d7a92e253c(e, t) {
    if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && e.isCollapsed()) {
        $016075a3cb2a2f02$var$U(e, t);
        const n = e.anchor.getNode();
        (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) && n.isEmpty() && $016075a3cb2a2f02$var$U(n, t);
    }
    $016075a3cb2a2f02$export$7b72eb271de5a0f9((e)=>{
        $016075a3cb2a2f02$var$U(e, t);
    });
    const n = e.getNodes();
    if (n.length > 0) {
        const e = new Set;
        for (const o of n){
            if (!(0, $3e88191b87395c2e$export$923a058ef54437a4)(o) || !o.canBeEmpty() || 0 !== o.getChildrenSize()) continue;
            const n = o.getKey();
            e.has(n) || (e.add(n), $016075a3cb2a2f02$var$U(o, t));
        }
    }
}
function $016075a3cb2a2f02$export$7b72eb271de5a0f9(e) {
    const n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (!n) return;
    const o = new Map, c = (e)=>o.get(e.getKey()) || [
            0,
            e.getTextContentSize()
        ];
    if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(n)) for (const e of (0, $3e88191b87395c2e$export$7bcaa61bc56938bf)(n).getTextSlices())e && o.set(e.caret.origin.getKey(), e.getSliceIndices());
    const f = n.getNodes();
    for (const n of f){
        if (!(0, $3e88191b87395c2e$export$471953706258be2b)(n) || !n.canHaveFormat()) continue;
        const [o, l] = c(n);
        if (l !== o) {
            if ((0, $3e88191b87395c2e$export$8b834332909623ff)(n) || 0 === o && l === n.getTextContentSize()) e(n);
            else e(n.splitText(o, l)[0 === o ? 0 : 1]);
        }
    }
    (0, $3e88191b87395c2e$export$181b63acea8a0224)(n) && "text" === n.anchor.type && "text" === n.focus.type && n.anchor.key === n.focus.key && $016075a3cb2a2f02$export$b74becdf7d9ace69(n);
}
function $016075a3cb2a2f02$export$b74becdf7d9ace69(e) {
    if (e.isBackward()) {
        const { anchor: t, focus: n } = e, { key: o, offset: l, type: r } = t;
        t.set(n.key, n.offset, n.type), n.set(o, l, r);
    }
}
function $016075a3cb2a2f02$export$172930305298c610(e, t) {
    const n = e.getFormatType(), o = e.getIndent();
    n !== t.getFormatType() && t.setFormat(n), o !== t.getIndent() && t.setIndent(o);
}
function $016075a3cb2a2f02$export$da8915a94c8ebf9f(e, t, n) {
    let o = (0, $3e88191b87395c2e$export$e435a0def9eb2000)(e, n);
    if ((0, $3e88191b87395c2e$export$2b09d6371b5f4203)(o)) return !1;
    for(; o; o = o.getParentCaret()){
        const e = o.getParentAtCaret();
        if (!e || o.getNodeAtCaret()) return !1;
        if (t.is(e)) return !0;
    }
    return !1;
}
function $016075a3cb2a2f02$export$b298cd49550a7619(e, t, n = $016075a3cb2a2f02$export$172930305298c610) {
    if (!e) return;
    const o = e.getStartEndPoints();
    let l = !1, r = null;
    const i = new Map;
    if (o) {
        const [t, n] = o, s = (0, $3e88191b87395c2e$export$57101724ca611500)(t.getNode(), (0, $3e88191b87395c2e$export$bd7ca521104e245c));
        r = (0, $3e88191b87395c2e$export$57101724ca611500)(n.getNode(), (0, $3e88191b87395c2e$export$bd7ca521104e245c));
        const f = e.isBackward() ? "previous" : "next";
        l = (0, $3e88191b87395c2e$export$923a058ef54437a4)(r) && !r.is(s) && function(e, t, n) {
            const o = e.getNode();
            return (!(0, $3e88191b87395c2e$export$923a058ef54437a4)(o) || !o.isEmpty()) && $016075a3cb2a2f02$export$da8915a94c8ebf9f(e, t, n);
        }(n, r, (0, $3e88191b87395c2e$export$be9b688c8ff522db)(f)), (0, $3e88191b87395c2e$export$923a058ef54437a4)(s) && i.set(s.getKey(), s), (0, $3e88191b87395c2e$export$923a058ef54437a4)(r) && !l && i.set(r.getKey(), r);
    }
    for (const t of e.getNodes())if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(t) && (0, $3e88191b87395c2e$export$bd7ca521104e245c)(t)) {
        if (l && t.is(r)) continue;
        i.set(t.getKey(), t);
    } else if (!o) {
        const e = (0, $3e88191b87395c2e$export$57101724ca611500)(t, (0, $3e88191b87395c2e$export$bd7ca521104e245c));
        (0, $3e88191b87395c2e$export$923a058ef54437a4)(e) && i.set(e.getKey(), e);
    }
    for (const e of i.values()){
        const o = t();
        n(e, o), e.replace(o, !0);
    }
}
function $016075a3cb2a2f02$var$G(e) {
    return e.getNode().isAttached();
}
function $016075a3cb2a2f02$var$J(e) {
    let t = e;
    for(; null !== t && !(0, $3e88191b87395c2e$export$6f851a24c61146af)(t);){
        const e = t.getLatest(), n = t.getParent();
        0 === e.getChildrenSize() && t.remove(!0), t = n;
    }
}
function $016075a3cb2a2f02$export$bb69554bb07b9f3d(e, t, n = null) {
    const o = e.getStartEndPoints(), l = o ? o[0] : null, r = e.getNodes(), i = r.length;
    if (null !== l && (0 === i || 1 === i && "element" === l.type && 0 === l.getNode().getChildrenSize())) {
        const e = "text" === l.type ? l.getNode().getParentOrThrow() : l.getNode(), o = e.getChildren();
        let r = t();
        return r.setFormat(e.getFormatType()), r.setIndent(e.getIndent()), o.forEach((e)=>r.append(e)), n && (r = n.append(r)), void e.replace(r);
    }
    let s = null, c = [];
    for(let o = 0; o < i; o++){
        const l = r[o];
        (0, $3e88191b87395c2e$export$6f851a24c61146af)(l) ? ($016075a3cb2a2f02$var$Y(e, c, c.length, t, n), c = [], s = l) : null === s || null !== s && (0, $3e88191b87395c2e$export$e3d4b782f65c81f1)(l, s) ? c.push(l) : ($016075a3cb2a2f02$var$Y(e, c, c.length, t, n), c = [
            l
        ]);
    }
    $016075a3cb2a2f02$var$Y(e, c, c.length, t, n);
}
function $016075a3cb2a2f02$var$Y(e, t, n, o, l = null) {
    if (0 === t.length) return;
    const i = t[0], s = new Map, f = [], u = (0, $3e88191b87395c2e$export$923a058ef54437a4)(i) ? i : i.getParentOrThrow();
    let g = u.isInline() ? u.getParentOrThrow() : u, d = !1;
    for(; null !== g;){
        const e = g.getPreviousSibling();
        if (null !== e) {
            g = e, d = !0;
            break;
        }
        if (g = g.getParentOrThrow(), (0, $3e88191b87395c2e$export$6f851a24c61146af)(g)) break;
    }
    const p = new Set;
    for(let e = 0; e < n; e++){
        const n = t[e];
        (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) && 0 === n.getChildrenSize() && p.add(n.getKey());
    }
    const h = new Set;
    for(let e = 0; e < n; e++){
        const n = t[e];
        let l = n.getParent();
        if (null !== l && l.isInline() && (l = l.getParent()), null !== l && (0, $3e88191b87395c2e$export$8d016e0592201ace)(n) && !h.has(n.getKey())) {
            const e = l.getKey();
            if (void 0 === s.get(e)) {
                const t = o();
                t.setFormat(l.getFormatType()), t.setIndent(l.getIndent()), f.push(t), s.set(e, t);
                const n = l.getChildren();
                t.splice(t.getChildrenSize(), 0, n);
                for (const e of n)if (h.add(e.getKey()), (0, $3e88191b87395c2e$export$923a058ef54437a4)(e)) for (const t of e.getChildrenKeys())h.add(t);
                $016075a3cb2a2f02$var$J(l);
            }
        } else if (p.has(n.getKey())) {
            (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) || $016075a3cb2a2f02$var$B(179);
            const e = o();
            e.setFormat(n.getFormatType()), e.setIndent(n.getIndent()), f.push(e), n.remove(!0);
        }
    }
    if (null !== l) for(let e = 0; e < f.length; e++){
        const t = f[e];
        l.append(t);
    }
    let y = null;
    if ((0, $3e88191b87395c2e$export$6f851a24c61146af)(g)) {
        if (d) {
            if (null !== l) g.insertAfter(l);
            else for(let e = f.length - 1; e >= 0; e--){
                const t = f[e];
                g.insertAfter(t);
            }
        } else {
            const e = g, t = e.getFirstChild();
            if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(t) && (g = t), null === t) {
                if (l) e.append(l);
                else for(let t = 0; t < f.length; t++){
                    const n = f[t];
                    e.append(n), y = n;
                }
            } else if (null !== l) t.insertBefore(l);
            else for(let e = 0; e < f.length; e++){
                const n = f[e];
                t.insertBefore(n), y = n;
            }
        }
    } else if (l) g.insertAfter(l);
    else for(let e = f.length - 1; e >= 0; e--){
        const t = f[e];
        g.insertAfter(t), y = t;
    }
    const m = (0, $3e88191b87395c2e$export$846e9407a8b5d98c)();
    (0, $3e88191b87395c2e$export$181b63acea8a0224)(m) && $016075a3cb2a2f02$var$G(m.anchor) && $016075a3cb2a2f02$var$G(m.focus) ? (0, $3e88191b87395c2e$export$2aad78c37810bca9)(m.clone()) : null !== y ? y.selectEnd() : e.dirty = !0;
}
function $016075a3cb2a2f02$var$Z(e) {
    const t = $016075a3cb2a2f02$var$ee(e);
    return null !== t && "vertical-rl" === t.writingMode;
}
function $016075a3cb2a2f02$var$ee(e) {
    const t = e.anchor.getNode();
    return (0, $3e88191b87395c2e$export$923a058ef54437a4)(t) ? $016075a3cb2a2f02$export$47af7ba34f93d90a(t) : $016075a3cb2a2f02$export$a64a14806f0ec48d(t);
}
function $016075a3cb2a2f02$export$d0018f657aae1e58(e, n) {
    let o = $016075a3cb2a2f02$var$Z(e) ? !n : n;
    $016075a3cb2a2f02$export$4e1eaaa3c34f8a7(e) && (o = !o);
    const l = (0, $3e88191b87395c2e$export$e435a0def9eb2000)(e.focus, o ? "previous" : "next");
    if ((0, $3e88191b87395c2e$export$2b09d6371b5f4203)(l)) return !1;
    if ((0, $3e88191b87395c2e$export$6d8c68034bda7a85)(l) && !(0, $3e88191b87395c2e$export$ac9141efa5fb7932)(l.origin) && l.origin.isUnmergeable()) {
        const e = l.getNodeAtCaret();
        if ((0, $3e88191b87395c2e$export$471953706258be2b)(e) && !(0, $3e88191b87395c2e$export$ac9141efa5fb7932)(e)) return !0;
    }
    for (const e of (0, $3e88191b87395c2e$export$7f1827f6551d91c3)(l)){
        if ((0, $3e88191b87395c2e$export$1c3da6f3e60ca260)(e)) return !e.origin.isInline();
        if (!(0, $3e88191b87395c2e$export$923a058ef54437a4)(e.origin)) {
            if ((0, $3e88191b87395c2e$export$60aa03725ce41b1c)(e.origin)) return !0;
            break;
        }
    }
    return !1;
}
function $016075a3cb2a2f02$export$fe8c741023d35787(e, t, n, o) {
    e.modify(t ? "extend" : "move", n, o);
}
function $016075a3cb2a2f02$export$4e1eaaa3c34f8a7(e) {
    const t = $016075a3cb2a2f02$var$ee(e);
    return null !== t && "rtl" === t.direction;
}
function $016075a3cb2a2f02$export$2ced31adbb83549a(e, t, n) {
    const o = $016075a3cb2a2f02$export$4e1eaaa3c34f8a7(e);
    let l;
    l = $016075a3cb2a2f02$var$Z(e) || o ? !n : n, $016075a3cb2a2f02$export$fe8c741023d35787(e, t, l, "character");
}
function $016075a3cb2a2f02$var$re(e, t, n) {
    const o = e.getStyle(), l = (0, $3e88191b87395c2e$export$2ce8a4767ed9993e)(o);
    return null !== l && l[t] || n;
}
function $016075a3cb2a2f02$export$195af47f5349a5ae(e, n, o = "") {
    let l = null;
    const i = e.getNodes();
    let s, c;
    if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) {
        if (e.isCollapsed() && "" !== e.style) {
            const t = (0, $3e88191b87395c2e$export$2ce8a4767ed9993e)(e.style);
            if (null !== t && n in t) return t[n];
        }
        const { anchor: o, focus: l } = e, r = e.isBackward(), i = r ? l.getNode() : o.getNode(), f = r ? o.getNode() : l.getNode(), u = r ? l.offset : o.offset, g = r ? o.offset : l.offset;
        (0, $3e88191b87395c2e$export$471953706258be2b)(i) && u === i.getTextContentSize() && (s = i), 0 === g && (c = f);
    }
    for(let e = 0; e < i.length; e++){
        const r = i[e];
        if ((0, $3e88191b87395c2e$export$471953706258be2b)(r) && !r.is(0 === e ? s : c)) {
            const e = $016075a3cb2a2f02$var$re(r, n, o);
            if (null === l) l = e;
            else if (l !== e) {
                l = "";
                break;
            }
        }
    }
    return null === l ? o : l;
}
const $016075a3cb2a2f02$export$2ce8a4767ed9993e = (0, $3e88191b87395c2e$export$2ce8a4767ed9993e), $016075a3cb2a2f02$export$fc113f24dcf7dc = $016075a3cb2a2f02$export$440ba083e0a4348;



function $74849711df60ce24$var$Z(t, ...e) {
    const n = new URL("https://lexical.dev/docs/error"), o = new URLSearchParams;
    o.append("code", t);
    for (const t of e)o.append("v", t);
    throw n.search = o.toString(), Error(`Minified Lexical error #${t}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function $74849711df60ce24$export$de4dd8ebeac3028f(t) {
    const e = (t, e)=>e.left >= t.left - 1 && e.top >= t.top - 1 && e.right <= t.right + 1 && e.bottom <= t.bottom + 1, n = [];
    for (const o of Array.from(t))if (!(o.width < .5 || o.height < .5 || n.some((t)=>e(o, t)))) {
        for(let t = n.length - 1; t >= 0; t--)e(n[t], o) && n.splice(t, 1);
        n.push(o);
    }
    return n;
}
function $74849711df60ce24$var$et(t) {
    return `${t}px`;
}
const $74849711df60ce24$var$nt = {
    attributes: !0,
    characterData: !0,
    childList: !0,
    subtree: !0
};
function $74849711df60ce24$export$27d1076112acf609(e, r, i) {
    let l = null, s = null, u = null, c = [];
    const f = (0, $3e88191b87395c2e$export$c074c5c00886935b)(e.getRootElement()).createElement("div");
    function d() {
        null === l && $74849711df60ce24$var$Z(182), null === s && $74849711df60ce24$var$Z(183);
        const { left: o, top: u } = s.getBoundingClientRect(), d = $74849711df60ce24$export$de4dd8ebeac3028f((0, $016075a3cb2a2f02$export$3021984b31d6d2e2)(e, r));
        var a, g;
        f.isConnected || (g = f, (a = s).insertBefore(g, a.firstChild));
        let p = !1;
        for(let t = 0; t < d.length; t++){
            const e = d[t], r = c[t] || (0, $3e88191b87395c2e$export$c074c5c00886935b)(l).createElement("div"), i = r.style;
            "absolute" !== i.position && (i.position = "absolute", p = !0);
            const s = $74849711df60ce24$var$et(e.left - o);
            i.left !== s && (i.left = s, p = !0);
            const a = $74849711df60ce24$var$et(e.top - u);
            i.top !== a && (r.style.top = a, p = !0);
            const g = $74849711df60ce24$var$et(e.width);
            i.width !== g && (r.style.width = g, p = !0);
            const h = $74849711df60ce24$var$et(e.height);
            i.height !== h && (r.style.height = h, p = !0), r.parentNode !== f && (f.append(r), p = !0), c[t] = r;
        }
        for(; c.length > d.length;){
            const t = c.pop();
            null != t && t.remove();
        }
        p && i(c);
    }
    function a() {
        s = null, l = null, null !== u && u.disconnect(), u = null, f.remove();
        for (const t of c)t.remove();
        c = [];
    }
    f.style.position = "relative";
    const g = e.registerRootListener(function t() {
        const n = e.getRootElement();
        if (null === n) return a();
        const r = n.parentElement;
        if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(r)) return a();
        a(), l = n, s = r, u = new MutationObserver((n)=>{
            const o = e.getRootElement(), r = o && o.parentElement;
            if (o !== l || r !== s) return t();
            for (const t of n)if (!f.contains(t.target)) return d();
        }), u.observe(r, $74849711df60ce24$var$nt), d();
    });
    return ()=>{
        g(), a();
    };
}
function $74849711df60ce24$var$rt(t, e, n, o) {
    if ("text" !== e.type && (0, $3e88191b87395c2e$export$923a058ef54437a4)(n)) {
        const r = (0, $3e88191b87395c2e$export$724e988312a5b9ca)(n, o, t);
        return [
            r.element,
            r.getFirstChildOffset() + e.offset
        ];
    }
    return [
        ((0, $3e88191b87395c2e$export$471953706258be2b)(n) ? (0, $3e88191b87395c2e$export$118c63c491bd7ec)(n, o, t) : (0, $3e88191b87395c2e$export$78c4e6c266471ee)(o)) || o,
        e.offset
    ];
}
function $74849711df60ce24$var$it(t) {
    for (const e of t){
        const t = e.style;
        "Highlight" !== t.background && (t.background = "Highlight"), "HighlightText" !== t.color && (t.color = "HighlightText"), t.marginTop !== $74849711df60ce24$var$et(-1.5) && (t.marginTop = $74849711df60ce24$var$et(-1.5)), t.paddingTop !== $74849711df60ce24$var$et(4) && (t.paddingTop = $74849711df60ce24$var$et(4)), t.paddingBottom !== $74849711df60ce24$var$et(0) && (t.paddingBottom = $74849711df60ce24$var$et(0));
    }
}
function $74849711df60ce24$export$3ba48467d3728463(t, e = $74849711df60ce24$var$it) {
    let n = null, o = null, s = null, u = null, c = null, f = null, d = ()=>{};
    function a(r) {
        r.read(()=>{
            const r = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(r)) return n = null, s = null, u = null, f = null, d(), void (d = ()=>{});
            const [a, g] = function(t) {
                const e = t.getStartEndPoints();
                return t.isBackward() ? [
                    e[1],
                    e[0]
                ] : e;
            }(r), p = a.getNode(), h = p.getKey(), m = a.offset, y = g.getNode(), v = y.getKey(), E = g.offset, w = t.getElementByKey(h), C = t.getElementByKey(v), x = null === n || w !== o || m !== s || h !== n.getKey(), S = null === u || C !== c || E !== f || v !== u.getKey();
            if ((x || S) && null !== w && null !== C) {
                const n = function(t, e, n, o, r, i, l) {
                    const s = (t._window ? t._window.document : document).createRange();
                    return s.setStart(...$74849711df60ce24$var$rt(t, e, n, o)), s.setEnd(...$74849711df60ce24$var$rt(t, r, i, l)), s;
                }(t, a, p, w, g, y, C);
                d(), d = $74849711df60ce24$export$27d1076112acf609(t, n, e);
            }
            n = p, o = w, s = m, u = y, c = C, f = E;
        }, {
            editor: t
        });
    }
    return a(t.getEditorState()), (0, $3e88191b87395c2e$export$d64d64f541cc1835)(t.registerUpdateListener(({ editorState: t })=>a(t)), ()=>{
        d();
    });
}
function $74849711df60ce24$export$624fc3ca4be05b70(t, e) {
    let n = null;
    const o = ()=>{
        const o = t.getRootElement(), r = null !== o ? o.ownerDocument.defaultView : null, i = null !== r ? r.getSelection() : null, l = null !== i ? (0, $3e88191b87395c2e$export$fca86712f5243a7e)(i, o).anchorNode : null;
        null !== l && null !== o && o.contains(l) ? null !== n && (n(), n = null) : null === n && (n = $74849711df60ce24$export$3ba48467d3728463(t, e));
    };
    return t.registerRootListener((t)=>{
        if (t) {
            const e = t.ownerDocument, i = (0, $3e88191b87395c2e$export$d64d64f541cc1835)((0, $3e88191b87395c2e$export$bea698773a21b4e8)(e, "selectionchange", o), ()=>{
                null !== n && n();
            });
            return o(), i;
        }
    });
}
function $74849711df60ce24$export$cfa2225e87938781(t, e) {
    const n = t.ownerDocument, o = n.defaultView || window;
    let r = o.getComputedStyle(t);
    const i = "absolute" === r.position, l = e ? /(auto|scroll|hidden)/ : /(auto|scroll)/;
    if ("fixed" === r.position) return n.body;
    for(let e = t; e = (0, $3e88191b87395c2e$export$169e5491001d3ed6)(e);)if (r = o.getComputedStyle(e), (!i || "static" !== r.position) && l.test(r.overflow + r.overflowY + r.overflowX)) return e;
    return n.body;
}
function $74849711df60ce24$export$fdc4ce7158f86e77(t, e) {
    for (const n of e)if (t.type.startsWith(n)) return !0;
    return !1;
}
function $74849711df60ce24$export$d7187ecdab7ff06e(t, e) {
    const n = t[Symbol.iterator]();
    return new Promise((t, o)=>{
        const r = [], i = ()=>{
            const { done: l, value: s } = n.next();
            if (l) return t(r);
            const u = new FileReader;
            u.addEventListener("error", o), u.addEventListener("load", ()=>{
                const t = u.result;
                "string" == typeof t && r.push({
                    file: s,
                    result: t
                }), i();
            }), $74849711df60ce24$export$fdc4ce7158f86e77(s, e) ? u.readAsDataURL(s) : i();
        };
        i();
    });
}
function $74849711df60ce24$export$a96b5f91cc4d807b(t, e) {
    return Array.from($74849711df60ce24$export$42b800a71faa415(t, e));
}
function $74849711df60ce24$export$fe23f27ed2c21434(t) {
    return t ? t.getAdjacentCaret() : null;
}
function $74849711df60ce24$export$8ca66cf8a8298d2c(t, e) {
    return Array.from($74849711df60ce24$export$b7283edb12b95c9d(t, e));
}
function $74849711df60ce24$export$42b800a71faa415(t, e) {
    return $74849711df60ce24$var$Et("next", t, e);
}
function $74849711df60ce24$export$1dc16e545810df74(t, e) {
    return Array.from($74849711df60ce24$export$40da5dc8034feee4(t, e));
}
function* $74849711df60ce24$export$40da5dc8034feee4(t, e) {
    for (const n of $74849711df60ce24$var$Et("next", t, e)){
        yield n;
        const { node: t, depth: o } = n;
        if ((0, $3e88191b87395c2e$export$e14ad7e55d229066)(t) && !t.is(e)) for (const e of (0, $3e88191b87395c2e$export$c83fc7fbb76e480a)(t)){
            const n = (0, $3e88191b87395c2e$export$ea4162355720819)(t, e);
            null !== n && (yield* $74849711df60ce24$var$yt(n, o + 1));
        }
    }
}
function* $74849711df60ce24$var$yt(t, e) {
    yield {
        depth: e,
        node: t
    };
    const n = e + 1;
    if ((0, $3e88191b87395c2e$export$e14ad7e55d229066)(t)) for (const e of (0, $3e88191b87395c2e$export$c83fc7fbb76e480a)(t)){
        const o = (0, $3e88191b87395c2e$export$ea4162355720819)(t, e);
        null !== o && (yield* $74849711df60ce24$var$yt(o, n));
    }
    if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(t)) for (const e of t.getChildren())yield* $74849711df60ce24$var$yt(e, n);
}
function $74849711df60ce24$var$vt(t, e) {
    const n = (0, $3e88191b87395c2e$export$f0135ff654c2200b)((0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(t, e));
    return n && n[0];
}
function $74849711df60ce24$var$Et(t, e, n) {
    const o = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), r = e || o, i = (0, $3e88191b87395c2e$export$923a058ef54437a4)(r) ? (0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(r, t) : (0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(r, t), l = $74849711df60ce24$export$48030bdcb105a06f(r), u = n ? (0, $3e88191b87395c2e$export$17eea20b564ca4ca)((0, $3e88191b87395c2e$export$823551f18b301259)((0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(n, t))) || $74849711df60ce24$var$vt(n, t) : $74849711df60ce24$var$vt(r, t);
    let c = l;
    return (0, $3e88191b87395c2e$export$51a344848dcba5b)({
        hasNext: (t)=>null !== t,
        initial: i,
        map: (t)=>({
                depth: c,
                node: t.origin
            }),
        step: (t)=>{
            if (t.isSameNodeCaret(u)) return null;
            (0, $3e88191b87395c2e$export$1c3da6f3e60ca260)(t) && c++;
            const e = (0, $3e88191b87395c2e$export$f0135ff654c2200b)(t);
            return !e || e[0].isSameNodeCaret(u) ? null : (c += e[1], e[0]);
        }
    });
}
function $74849711df60ce24$export$e101bd0436802f31(t) {
    const e = (0, $3e88191b87395c2e$export$f0135ff654c2200b)((0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(t, "next"));
    return e && [
        e[0].origin,
        e[1]
    ];
}
function $74849711df60ce24$export$48030bdcb105a06f(t) {
    let e = -1;
    var _n_getParent;
    for(let n = t; null !== n; n = (_n_getParent = n.getParent()) !== null && _n_getParent !== void 0 ? _n_getParent : (0, $3e88191b87395c2e$export$fe2a41df16bf88cd)(n))e++;
    return e;
}
function $74849711df60ce24$export$4e6d9091ca9005b4(t) {
    const e = (0, $3e88191b87395c2e$export$823551f18b301259)((0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(t, "previous")), n = (0, $3e88191b87395c2e$export$f0135ff654c2200b)(e, "root");
    return n && n[0].origin;
}
function $74849711df60ce24$export$b7283edb12b95c9d(t, e) {
    return $74849711df60ce24$var$Et("previous", t, e);
}
function $74849711df60ce24$export$1bb6f313e62eb61e(t, e) {
    return Array.from($74849711df60ce24$export$b9ff78de33723e2e(t, e));
}
function* $74849711df60ce24$export$b9ff78de33723e2e(t, e) {
    const n = [];
    for (const o of $74849711df60ce24$var$Et("previous", t, e)){
        for(; n.length > 0 && o.depth <= n[n.length - 1].depth;){
            const t = n.pop();
            yield* $74849711df60ce24$var$bt(t.node, t.depth + 1);
        }
        yield o;
        const { node: t, depth: r } = o;
        (0, $3e88191b87395c2e$export$e14ad7e55d229066)(t) && (0, $3e88191b87395c2e$export$c83fc7fbb76e480a)(t).length > 0 && !t.is(e) && n.push({
            depth: r,
            node: t
        });
    }
    for(; n.length > 0;){
        const t = n.pop();
        yield* $74849711df60ce24$var$bt(t.node, t.depth + 1);
    }
}
function* $74849711df60ce24$var$bt(t, e) {
    const n = (0, $3e88191b87395c2e$export$c83fc7fbb76e480a)(t);
    for(let o = n.length - 1; o >= 0; o--){
        const r = (0, $3e88191b87395c2e$export$ea4162355720819)(t, n[o]);
        null !== r && (yield* $74849711df60ce24$var$Rt(r, e));
    }
}
function* $74849711df60ce24$var$Rt(t, e) {
    yield {
        depth: e,
        node: t
    };
    const n = e + 1;
    if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(t)) {
        const e = t.getChildren();
        for(let t = e.length - 1; t >= 0; t--)yield* $74849711df60ce24$var$Rt(e[t], n);
    }
    (0, $3e88191b87395c2e$export$e14ad7e55d229066)(t) && (yield* $74849711df60ce24$var$bt(t, n));
}
function $74849711df60ce24$export$9f980e09b7e30818(t, e) {
    let n = t;
    for(; null != n;){
        if (n instanceof e) return n;
        n = n.getParent();
    }
    return null;
}
function $74849711df60ce24$export$87243b8185b18f91(t) {
    const e = (0, $3e88191b87395c2e$export$57101724ca611500)(t, (t)=>(0, $3e88191b87395c2e$export$923a058ef54437a4)(t) && !t.isInline());
    return (0, $3e88191b87395c2e$export$923a058ef54437a4)(e) || $74849711df60ce24$var$Z(4, t.__key), e;
}
function $74849711df60ce24$export$970e2195f7f7e928(t, e) {
    const n = (0, $3e88191b87395c2e$export$b6aa34707ffda54a)((0, $3e88191b87395c2e$export$181b63acea8a0224)(e) ? (0, $3e88191b87395c2e$export$7bcaa61bc56938bf)(e) : e, "next"), o = (0, $3e88191b87395c2e$export$fe2dfd0f9ec2306d)(n.anchor.origin), r = (0, $3e88191b87395c2e$export$fe2dfd0f9ec2306d)(t.getLatest());
    if (null === o ? null !== r : !o.is(r)) return !1;
    const i = (0, $3e88191b87395c2e$export$33e015e8f2ff8536)((0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(t, "next")), s = (0, $3e88191b87395c2e$export$6899265904214748)((0, $3e88191b87395c2e$export$33e015e8f2ff8536)((0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(t, "previous")), "next");
    return (0, $3e88191b87395c2e$export$cfa5c948dc0495fa)(n.anchor, i) <= 0 && (0, $3e88191b87395c2e$export$cfa5c948dc0495fa)(n.focus, s) >= 0;
}
function $74849711df60ce24$export$91c210fb70675873(t, e, n, o) {
    const r = (t)=>t instanceof e;
    return t.registerNodeTransform(e, (t)=>{
        const e = ((t)=>{
            const e = t.getChildren();
            for(let t = 0; t < e.length; t++){
                const n = e[t];
                if (r(n)) return null;
            }
            let n = t, o = t;
            for(; null !== n;)if (o = n, n = n.getParent(), r(n)) return {
                child: o,
                parent: n
            };
            return null;
        })(t);
        if (null !== e) {
            const { child: r, parent: i } = e;
            if (r.is(t)) {
                o(i, t);
                const e = r.getNextSiblings(), l = e.length;
                if (i.insertAfter(r), 0 !== l) {
                    const t = n(i);
                    r.insertAfter(t);
                    for(let n = 0; n < l; n++)t.append(e[n]);
                }
                i.canBeEmpty() || 0 !== i.getChildrenSize() || i.remove();
            }
        }
    });
}
function $74849711df60ce24$export$695042680df6d70a(t, e) {
    const n = new Map, o = t._pendingEditorState;
    for (const [t, o] of e._nodeMap)n.set(t, (0, $3e88191b87395c2e$export$10b12fb9e226edf0)(o));
    o && (o._nodeMap = n), (0, $3e88191b87395c2e$export$d05b7cf3bb138003)();
    const r = e._selection;
    (0, $3e88191b87395c2e$export$2aad78c37810bca9)(null === r ? null : r.clone());
}
function $74849711df60ce24$export$4ec669795a8ed6b(t) {
    const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)() || (0, $3e88191b87395c2e$export$846e9407a8b5d98c)();
    let n;
    if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) n = (0, $3e88191b87395c2e$export$e435a0def9eb2000)(e.focus, "next");
    else {
        if (null != e) {
            const t = e.getNodes(), o = t[t.length - 1];
            o && (n = (0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(o, "next"));
        }
        n = n || (0, $3e88191b87395c2e$export$19f6ef5eb31488f9)((0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), "previous").getFlipped().insert((0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)());
    }
    const o = (0, $3e88191b87395c2e$export$8074a5062ab072d1)(t, n), r = (0, $3e88191b87395c2e$export$17eea20b564ca4ca)(o), s = (0, $3e88191b87395c2e$export$1c3da6f3e60ca260)(r) ? (0, $3e88191b87395c2e$export$33e015e8f2ff8536)(r) : o;
    return (0, $3e88191b87395c2e$export$9fb698110f44889d)((0, $3e88191b87395c2e$export$4a7df333303cecc7)(s)), t.getLatest();
}
function $74849711df60ce24$export$38eb54ed06a83722(t) {
    const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) return void (e && e.insertNodes([
        t
    ]));
    const n = (0, $3e88191b87395c2e$export$7bcaa61bc56938bf)(e);
    let o = (0, $3e88191b87395c2e$export$b6aa34707ffda54a)((0, $3e88191b87395c2e$export$9421bed7a385cd41)(n), "next").anchor;
    if ((0, $3e88191b87395c2e$export$6d8c68034bda7a85)(o)) {
        const t = (0, $3e88191b87395c2e$export$9138b8478eedbb65)(o);
        if (!t) return;
        o = t;
    }
    const r = o.getFlipped();
    r.insert(t), (0, $3e88191b87395c2e$export$9fb698110f44889d)((0, $3e88191b87395c2e$export$36f672915982afb2)(r, r));
}
function $74849711df60ce24$export$4de868a07eee3cf0(t, e) {
    const n = e();
    return t.replace(n), n.append(t), n;
}
function $74849711df60ce24$export$266ae88fb619dc2e(t, e) {
    return null !== t && Object.getPrototypeOf(t).constructor.name === e.name;
}
function $74849711df60ce24$export$1faf88b1db1d6bb9(t) {
    let e = null;
    if ($74849711df60ce24$export$266ae88fb619dc2e(t, DragEvent) ? e = t.dataTransfer : $74849711df60ce24$export$266ae88fb619dc2e(t, ClipboardEvent) && (e = t.clipboardData), null === e) return [
        !1,
        [],
        !1
    ];
    const n = e.types, o = n.includes("Files"), r = n.includes("text/html") || n.includes("text/plain");
    return [
        o,
        Array.from(e.files),
        r
    ];
}
function $74849711df60ce24$export$f8463c20f5fd3ddc(t, e) {
    const n = [];
    for(let o = 0; o < t.length; o++){
        const r = e(t[o]);
        null !== r && n.push(r);
    }
    return n;
}
function $74849711df60ce24$export$39768b879b3f6739(t) {
    const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) return !1;
    const n = new Set, o = e.getNodes();
    for(let e = 0; e < o.length; e++){
        const r = o[e], i = r.getKey();
        if (n.has(i)) continue;
        const l = (0, $3e88191b87395c2e$export$57101724ca611500)(r, (t)=>(0, $3e88191b87395c2e$export$923a058ef54437a4)(t) && !t.isInline());
        if (null === l) continue;
        const u = l.getKey();
        l.canIndent() && !n.has(u) && (n.add(u), t(l));
    }
    return n.size > 0;
}
function $74849711df60ce24$export$8cc97bf6a3616a50(t, e) {
    (0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(t, "next").insert(e);
}
let $74849711df60ce24$var$kt = !((0, $3e88191b87395c2e$export$fa35291248be714f) || !(0, $3e88191b87395c2e$export$37d2f1e98a187e61)) && void 0;
function $74849711df60ce24$export$8c73aeb81b5c13e3(t, e = !1) {
    let n = 1;
    if (function() {
        if (void 0 === $74849711df60ce24$var$kt) {
            const t = document.createElement("div");
            t.style.position = "absolute", t.style.opacity = "0", t.style.width = "100px", t.style.left = "-1000px", document.body.appendChild(t);
            const e = t.getBoundingClientRect();
            t.style.setProperty("zoom", "2"), $74849711df60ce24$var$kt = t.getBoundingClientRect().width === e.width, document.body.removeChild(t);
        }
        return $74849711df60ce24$var$kt;
    }() || e) {
        const e = t && t.ownerDocument.defaultView || window;
        for(; t;)n *= Number(e.getComputedStyle(t).getPropertyValue("zoom")), t = (0, $3e88191b87395c2e$export$169e5491001d3ed6)(t);
    }
    return n;
}
function $74849711df60ce24$export$bbe8eaa4f00d1da0(t) {
    return null !== t._parentEditor;
}
function $74849711df60ce24$export$2604295c7bfec614(t, e) {
    return $74849711df60ce24$var$Vt(t, e, null);
}
function $74849711df60ce24$var$Vt(t, e, n) {
    let o = !1;
    for (const r of $74849711df60ce24$export$225ff276ba9a4913(t))e(r) ? null !== n && n(r) : (o = !0, (0, $3e88191b87395c2e$export$923a058ef54437a4)(r) && $74849711df60ce24$var$Vt(r, e, n || ((t)=>r.insertAfter(t))), r.remove());
    return o;
}
function $74849711df60ce24$export$70c046ee94de83c6(t, e) {
    const n = [], o = Array.from(t).reverse();
    for(let t = o.pop(); void 0 !== t; t = o.pop())if (e(t)) n.push(t);
    else if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(t)) for (const e of $74849711df60ce24$export$225ff276ba9a4913(t))o.push(e);
    return n;
}
function $74849711df60ce24$export$e1fb40cb4e3f9663(t) {
    return $74849711df60ce24$var$Yt((0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(t, "next"));
}
function $74849711df60ce24$export$225ff276ba9a4913(t) {
    return $74849711df60ce24$var$Yt((0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(t, "previous"));
}
function $74849711df60ce24$var$Yt(t) {
    return (0, $3e88191b87395c2e$export$51a344848dcba5b)({
        hasNext: (0, $3e88191b87395c2e$export$3bcd9a2637e8506e),
        initial: t.getAdjacentCaret(),
        map: (t)=>t.origin.getLatest(),
        step: (t)=>t.getAdjacentCaret()
    });
}
function $74849711df60ce24$export$4942e7d6646d512a(t) {
    (0, $3e88191b87395c2e$export$3d19514618fb28f3)((0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(t, "next")).splice(1, t.getChildren());
}
function $74849711df60ce24$export$6ab6269e44986006(t) {
    const e = (e)=>(0, $3e88191b87395c2e$export$5f6d848b3f2eebb0)(e, t), n = (e, n)=>(0, $3e88191b87395c2e$export$401d8a6b50e0699a)(e, t, n);
    return {
        $get: e,
        $set: n,
        accessors: [
            e,
            n
        ],
        makeGetterMethod: ()=>function() {
                return e(this);
            },
        makeSetterMethod: ()=>function(t) {
                return n(this, t);
            },
        stateConfig: t
    };
}
function $74849711df60ce24$export$17109e98798bb572(t, e) {
    const n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(n) && n.isCollapsed()) {
        const o = (0, $3e88191b87395c2e$export$57101724ca611500)(n.anchor.getNode(), t);
        if (o) {
            const t = o.getParent();
            if (null !== t && t.getFirstChild() === o && $74849711df60ce24$export$4572c09727e93e24(n.anchor, o)) return o.insertBefore((0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)()).selectEnd(), e && e.preventDefault(), !0;
        }
    }
    return !1;
}
function $74849711df60ce24$export$6e6e076922000e47(t, e) {
    const n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(n) && n.isCollapsed()) {
        const o = (0, $3e88191b87395c2e$export$57101724ca611500)(n.anchor.getNode(), t);
        if (o) {
            const t = o.getParent();
            if (null !== t && t.getLastChild() === o && $74849711df60ce24$export$6b4ffc8d1b716b83(n.anchor, o)) return o.insertAfter((0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)()).selectEnd(), e && e.preventDefault(), !0;
        }
    }
    return !1;
}
function $74849711df60ce24$export$4572c09727e93e24(t, n) {
    return (0, $016075a3cb2a2f02$export$da8915a94c8ebf9f)(t, n, "previous");
}
function $74849711df60ce24$export$6b4ffc8d1b716b83(t, n) {
    return (0, $016075a3cb2a2f02$export$da8915a94c8ebf9f)(t, n, "next");
}


const $8ebc39becbfbdd8f$var$Kt = Symbol.for("preact-signals");
function $8ebc39becbfbdd8f$var$$t() {
    if ($8ebc39becbfbdd8f$var$Bt > 1) return void $8ebc39becbfbdd8f$var$Bt--;
    let t, e = !1;
    for(!function() {
        let t = $8ebc39becbfbdd8f$var$Wt;
        for($8ebc39becbfbdd8f$var$Wt = void 0; void 0 !== t;)t.S.v === t.v && (t.S.i = t.i), t = t.o;
    }(); void 0 !== $8ebc39becbfbdd8f$var$zt;){
        let n = $8ebc39becbfbdd8f$var$zt;
        for($8ebc39becbfbdd8f$var$zt = void 0, $8ebc39becbfbdd8f$var$Vt++; void 0 !== n;){
            const i = n.u;
            if (n.u = void 0, n.f &= -3, !(8 & n.f) && $8ebc39becbfbdd8f$var$qt(n)) try {
                n.c();
            } catch (n) {
                e || (t = n, e = !0);
            }
            n = i;
        }
    }
    if ($8ebc39becbfbdd8f$var$Vt = 0, $8ebc39becbfbdd8f$var$Bt--, e) throw t;
}
function $8ebc39becbfbdd8f$export$712ea50be43a7858(t) {
    if ($8ebc39becbfbdd8f$var$Bt > 0) return t();
    $8ebc39becbfbdd8f$var$Zt = ++$8ebc39becbfbdd8f$var$Gt, $8ebc39becbfbdd8f$var$Bt++;
    try {
        return t();
    } finally{
        $8ebc39becbfbdd8f$var$$t();
    }
}
let $8ebc39becbfbdd8f$var$jt, $8ebc39becbfbdd8f$var$zt;
function $8ebc39becbfbdd8f$export$8c437e4d572e2f99(t) {
    const e = $8ebc39becbfbdd8f$var$jt;
    $8ebc39becbfbdd8f$var$jt = void 0;
    try {
        return t();
    } finally{
        $8ebc39becbfbdd8f$var$jt = e;
    }
}
let $8ebc39becbfbdd8f$var$Wt, $8ebc39becbfbdd8f$var$Bt = 0, $8ebc39becbfbdd8f$var$Vt = 0, $8ebc39becbfbdd8f$var$Gt = 0, $8ebc39becbfbdd8f$var$Zt = 0, $8ebc39becbfbdd8f$var$Jt = 0;
function $8ebc39becbfbdd8f$var$Ht(t) {
    if (void 0 === $8ebc39becbfbdd8f$var$jt) return;
    let e = t.n;
    return void 0 === e || e.t !== $8ebc39becbfbdd8f$var$jt ? (e = {
        i: 0,
        S: t,
        p: $8ebc39becbfbdd8f$var$jt.s,
        n: void 0,
        t: $8ebc39becbfbdd8f$var$jt,
        e: void 0,
        x: void 0,
        r: e
    }, void 0 !== $8ebc39becbfbdd8f$var$jt.s && ($8ebc39becbfbdd8f$var$jt.s.n = e), $8ebc39becbfbdd8f$var$jt.s = e, t.n = e, 32 & $8ebc39becbfbdd8f$var$jt.f && t.S(e), e) : -1 === e.i ? (e.i = 0, void 0 !== e.n && (e.n.p = e.p, void 0 !== e.p && (e.p.n = e.n), e.p = $8ebc39becbfbdd8f$var$jt.s, e.n = void 0, $8ebc39becbfbdd8f$var$jt.s.n = e, $8ebc39becbfbdd8f$var$jt.s = e), e) : void 0;
}
function $8ebc39becbfbdd8f$var$Xt(t, e) {
    this.v = t, this.i = 0, this.n = void 0, this.t = void 0, this.l = 0, this.W = null == e ? void 0 : e.watched, this.Z = null == e ? void 0 : e.unwatched, this.name = null == e ? void 0 : e.name;
}
function $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8(t, e) {
    return new $8ebc39becbfbdd8f$var$Xt(t, e);
}
function $8ebc39becbfbdd8f$var$qt(t) {
    for(let e = t.s; void 0 !== e; e = e.n)if (e.S.i !== e.i || !e.S.h() || e.S.i !== e.i) return !0;
    return !1;
}
function $8ebc39becbfbdd8f$var$Qt(t) {
    for(let e = t.s; void 0 !== e; e = e.n){
        const n = e.S.n;
        if (void 0 !== n && (e.r = n), e.S.n = e, e.i = -1, void 0 === e.n) {
            t.s = e;
            break;
        }
    }
}
function $8ebc39becbfbdd8f$var$te(t) {
    let e, n = t.s;
    for(; void 0 !== n;){
        const t = n.p;
        -1 === n.i ? (n.S.U(n), void 0 !== t && (t.n = n.n), void 0 !== n.n && (n.n.p = t)) : e = n, n.S.n = n.r, void 0 !== n.r && (n.r = void 0), n = t;
    }
    t.s = e;
}
function $8ebc39becbfbdd8f$var$ee(t, e) {
    $8ebc39becbfbdd8f$var$Xt.call(this, void 0), this.x = t, this.s = void 0, this.g = $8ebc39becbfbdd8f$var$Jt - 1, this.f = 4, this.W = null == e ? void 0 : e.watched, this.Z = null == e ? void 0 : e.unwatched, this.name = null == e ? void 0 : e.name;
}
function $8ebc39becbfbdd8f$export$2983e091f1a1e8e2(t, e) {
    return new $8ebc39becbfbdd8f$var$ee(t, e);
}
function $8ebc39becbfbdd8f$var$ie(t) {
    const e = t.m;
    if (t.m = void 0, "function" == typeof e) {
        $8ebc39becbfbdd8f$var$Bt++;
        const n = $8ebc39becbfbdd8f$var$jt;
        $8ebc39becbfbdd8f$var$jt = void 0;
        try {
            e();
        } catch (e) {
            throw t.f &= -2, t.f |= 8, $8ebc39becbfbdd8f$var$oe(t), e;
        } finally{
            $8ebc39becbfbdd8f$var$jt = n, $8ebc39becbfbdd8f$var$$t();
        }
    }
}
function $8ebc39becbfbdd8f$var$oe(t) {
    for(let e = t.s; void 0 !== e; e = e.n)e.S.U(e);
    t.x = void 0, t.s = void 0, $8ebc39becbfbdd8f$var$ie(t);
}
function $8ebc39becbfbdd8f$var$se(t) {
    if ($8ebc39becbfbdd8f$var$jt !== this) throw new Error("Out-of-order effect");
    $8ebc39becbfbdd8f$var$te(this), $8ebc39becbfbdd8f$var$jt = t, this.f &= -2, 8 & this.f && $8ebc39becbfbdd8f$var$oe(this), $8ebc39becbfbdd8f$var$$t();
}
function $8ebc39becbfbdd8f$var$re(t, e) {
    this.x = t, this.m = void 0, this.s = void 0, this.u = void 0, this.f = 32, this.name = null == e ? void 0 : e.name;
}
function $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(t, e) {
    const n = new $8ebc39becbfbdd8f$var$re(t, e);
    try {
        n.c();
    } catch (t) {
        throw n.d(), t;
    }
    const i = n.d.bind(n);
    return i[Symbol.dispose] = i, i;
}
function $8ebc39becbfbdd8f$export$b351c03363e45c4f(t, e = {}) {
    const n = {};
    for(const i in t){
        const o = e[i], s = $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8(void 0 === o ? t[i] : o);
        n[i] = s;
    }
    return n;
}
$8ebc39becbfbdd8f$var$Xt.prototype.brand = $8ebc39becbfbdd8f$var$Kt, $8ebc39becbfbdd8f$var$Xt.prototype.h = function() {
    return !0;
}, $8ebc39becbfbdd8f$var$Xt.prototype.S = function(t) {
    const e = this.t;
    e !== t && void 0 === t.e && (t.x = e, this.t = t, void 0 !== e ? e.e = t : $8ebc39becbfbdd8f$export$8c437e4d572e2f99(()=>{
        var t;
        null == (t = this.W) || t.call(this);
    }));
}, $8ebc39becbfbdd8f$var$Xt.prototype.U = function(t) {
    if (void 0 !== this.t) {
        const e = t.e, n = t.x;
        void 0 !== e && (e.x = n, t.e = void 0), void 0 !== n && (n.e = e, t.x = void 0), t === this.t && (this.t = n, void 0 === n && $8ebc39becbfbdd8f$export$8c437e4d572e2f99(()=>{
            var t;
            null == (t = this.Z) || t.call(this);
        }));
    }
}, $8ebc39becbfbdd8f$var$Xt.prototype.subscribe = function(t) {
    return $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
        const e = this.value, n = $8ebc39becbfbdd8f$var$jt;
        $8ebc39becbfbdd8f$var$jt = void 0;
        try {
            t(e);
        } finally{
            $8ebc39becbfbdd8f$var$jt = n;
        }
    }, {
        name: "sub"
    });
}, $8ebc39becbfbdd8f$var$Xt.prototype.valueOf = function() {
    return this.value;
}, $8ebc39becbfbdd8f$var$Xt.prototype.toString = function() {
    return this.value + "";
}, $8ebc39becbfbdd8f$var$Xt.prototype.toJSON = function() {
    return this.value;
}, $8ebc39becbfbdd8f$var$Xt.prototype.peek = function() {
    const t = $8ebc39becbfbdd8f$var$jt;
    $8ebc39becbfbdd8f$var$jt = void 0;
    try {
        return this.value;
    } finally{
        $8ebc39becbfbdd8f$var$jt = t;
    }
}, Object.defineProperty($8ebc39becbfbdd8f$var$Xt.prototype, "value", {
    get () {
        const t = $8ebc39becbfbdd8f$var$Ht(this);
        return void 0 !== t && (t.i = this.i), this.v;
    },
    set (t) {
        if (t !== this.v) {
            if ($8ebc39becbfbdd8f$var$Vt > 100) throw new Error("Cycle detected");
            !function(t) {
                0 !== $8ebc39becbfbdd8f$var$Bt && 0 === $8ebc39becbfbdd8f$var$Vt && t.l !== $8ebc39becbfbdd8f$var$Zt && (t.l = $8ebc39becbfbdd8f$var$Zt, $8ebc39becbfbdd8f$var$Wt = {
                    S: t,
                    v: t.v,
                    i: t.i,
                    o: $8ebc39becbfbdd8f$var$Wt
                });
            }(this), this.v = t, this.i++, $8ebc39becbfbdd8f$var$Jt++, $8ebc39becbfbdd8f$var$Bt++;
            try {
                for(let t = this.t; void 0 !== t; t = t.x)t.t.N();
            } finally{
                $8ebc39becbfbdd8f$var$$t();
            }
        }
    }
}), $8ebc39becbfbdd8f$var$ee.prototype = new $8ebc39becbfbdd8f$var$Xt, $8ebc39becbfbdd8f$var$ee.prototype.h = function() {
    if (this.f &= -3, 1 & this.f) return !1;
    if (32 == (36 & this.f)) return !0;
    if (this.f &= -5, this.g === $8ebc39becbfbdd8f$var$Jt) return !0;
    if (this.g = $8ebc39becbfbdd8f$var$Jt, this.f |= 1, this.i > 0 && !$8ebc39becbfbdd8f$var$qt(this)) return this.f &= -2, !0;
    const t = $8ebc39becbfbdd8f$var$jt;
    try {
        $8ebc39becbfbdd8f$var$Qt(this), $8ebc39becbfbdd8f$var$jt = this;
        const t = this.x();
        (16 & this.f || this.v !== t || 0 === this.i) && (this.v = t, this.f &= -17, this.i++);
    } catch (t) {
        this.v = t, this.f |= 16, this.i++;
    }
    return $8ebc39becbfbdd8f$var$jt = t, $8ebc39becbfbdd8f$var$te(this), this.f &= -2, !0;
}, $8ebc39becbfbdd8f$var$ee.prototype.S = function(t) {
    if (void 0 === this.t) {
        this.f |= 36;
        for(let t = this.s; void 0 !== t; t = t.n)t.S.S(t);
    }
    $8ebc39becbfbdd8f$var$Xt.prototype.S.call(this, t);
}, $8ebc39becbfbdd8f$var$ee.prototype.U = function(t) {
    if (void 0 !== this.t && ($8ebc39becbfbdd8f$var$Xt.prototype.U.call(this, t), void 0 === this.t)) {
        this.f &= -33;
        for(let t = this.s; void 0 !== t; t = t.n)t.S.U(t);
    }
}, $8ebc39becbfbdd8f$var$ee.prototype.N = function() {
    if (!(2 & this.f)) {
        this.f |= 6;
        for(let t = this.t; void 0 !== t; t = t.x)t.t.N();
    }
}, Object.defineProperty($8ebc39becbfbdd8f$var$ee.prototype, "value", {
    get () {
        if (1 & this.f) throw new Error("Cycle detected");
        const t = $8ebc39becbfbdd8f$var$Ht(this);
        if (this.h(), void 0 !== t && (t.i = this.i), 16 & this.f) throw this.v;
        return this.v;
    }
}), $8ebc39becbfbdd8f$var$re.prototype.c = function() {
    const t = this.S();
    try {
        if (8 & this.f) return;
        if (void 0 === this.x) return;
        const t = this.x();
        "function" == typeof t && (this.m = t);
    } finally{
        t();
    }
}, $8ebc39becbfbdd8f$var$re.prototype.S = function() {
    if (1 & this.f) throw new Error("Cycle detected");
    this.f |= 1, this.f &= -9, $8ebc39becbfbdd8f$var$ie(this), $8ebc39becbfbdd8f$var$Qt(this), $8ebc39becbfbdd8f$var$Bt++;
    const t = $8ebc39becbfbdd8f$var$jt;
    return $8ebc39becbfbdd8f$var$jt = this, $8ebc39becbfbdd8f$var$se.bind(this, t);
}, $8ebc39becbfbdd8f$var$re.prototype.N = function() {
    2 & this.f || (this.f |= 2, this.u = $8ebc39becbfbdd8f$var$zt, $8ebc39becbfbdd8f$var$zt = this);
}, $8ebc39becbfbdd8f$var$re.prototype.d = function() {
    this.f |= 8, 1 & this.f || $8ebc39becbfbdd8f$var$oe(this);
}, $8ebc39becbfbdd8f$var$re.prototype.dispose = function() {
    this.d();
};
const $8ebc39becbfbdd8f$export$e203703de40a3835 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e, n)=>$8ebc39becbfbdd8f$export$b351c03363e45c4f(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        defaultSelection: "rootEnd",
        disabled: !1
    }),
    name: "@lexical/extension/AutoFocus",
    register (t, e, i) {
        const o = i.getOutput();
        return $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>o.disabled.value ? void 0 : t.registerRootListener((e)=>{
                t.focus(()=>{
                    const t = null !== e ? (0, $3e88191b87395c2e$export$cd4e5573fbe2b576)(e) : null;
                    null === e || null !== t && e.contains(t) || e.focus({
                        preventScroll: !0
                    });
                }, {
                    defaultSelection: o.defaultSelection.peek()
                });
            }));
    }
});
function $8ebc39becbfbdd8f$var$le() {
    const t = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)(), n = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
    t.clear(), t.append(n), null !== e && n.select(), (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && (e.format = 0);
}
function $8ebc39becbfbdd8f$export$392152e008acc8f4(t, e = $8ebc39becbfbdd8f$var$le) {
    return t.registerCommand((0, $3e88191b87395c2e$export$4926ce1a5702fdc7), ()=>(e(), !0), (0, $3e88191b87395c2e$export$11c61e12af5e1f41));
}
const $8ebc39becbfbdd8f$export$52e21de9dfe85928 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e, n)=>$8ebc39becbfbdd8f$export$b351c03363e45c4f(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        $onClear: $8ebc39becbfbdd8f$var$le
    }),
    name: "@lexical/extension/ClearEditor",
    register (t, e, n) {
        const { $onClear: i } = n.getOutput();
        return $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>$8ebc39becbfbdd8f$export$392152e008acc8f4(t, i.value));
    }
});
function $8ebc39becbfbdd8f$export$6703438f4b73182a(t) {
    return !!(0, $3e88191b87395c2e$export$60aa03725ce41b1c)(t) || !(!(0, $3e88191b87395c2e$export$923a058ef54437a4)(t) || !t.isShadowRoot());
}
function $8ebc39becbfbdd8f$var$ge(t, e, n, i) {
    return !!t.isEditable() && n.target === e && t.read("latest", ()=>{
        const e = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)().getLastChild();
        if (null === e) return !1;
        const o = t.getElementByKey(e.getKey());
        return null !== o && !(n.clientY <= o.getBoundingClientRect().bottom) && i(e);
    });
}
const $8ebc39becbfbdd8f$export$5b647c0a1ddb6fc3 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e)=>$8ebc39becbfbdd8f$export$b351c03363e45c4f(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        $shouldInsertAfter: $8ebc39becbfbdd8f$export$6703438f4b73182a,
        disabled: !1
    }),
    name: "@lexical/ClickAfterLastBlock",
    register: (t, e, n)=>$8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            const e = n.getOutput();
            if (!e.disabled.value) return t.registerRootListener((n)=>{
                if (null === n) return;
                return (0, $3e88191b87395c2e$export$4256f76d7567e2ca)(n, {
                    click: (i)=>{
                        $8ebc39becbfbdd8f$var$ge(t, n, i, e.$shouldInsertAfter.peek()) && (i.preventDefault(), (0, $3e88191b87395c2e$export$e066258f9188a34f)(i), t.update(()=>{
                            const t = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)().getLastChild();
                            if (null === t) return;
                            if (!e.$shouldInsertAfter.peek()(t)) return;
                            const n = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
                            t.insertAfter(n), n.select();
                        }));
                    },
                    mousedown: (i)=>{
                        $8ebc39becbfbdd8f$var$ge(t, n, i, e.$shouldInsertAfter.peek()) && i.preventDefault();
                    }
                }, !0);
            });
        })
});
function $8ebc39becbfbdd8f$export$c25a0876f35f253e(t) {
    const e = new Set, n = new Set;
    for (const i of $8ebc39becbfbdd8f$var$ve(t)){
        const t = "function" == typeof i ? i : i.replace;
        (0, $3e88191b87395c2e$export$e89f9d0013499fc6)(t), e.add(t.getType()), n.add(t);
    }
    return {
        nodes: n,
        types: e
    };
}
function $8ebc39becbfbdd8f$var$ve(t) {
    return ("function" == typeof t.nodes ? t.nodes() : t.nodes) || [];
}
const $8ebc39becbfbdd8f$var$ye = /* @__PURE__ */ (0, $3e88191b87395c2e$export$e6a0daad8304de)("format", {
    parse: (t)=>"number" == typeof t ? t : 0
});
class $8ebc39becbfbdd8f$export$491902e995c6a41e extends (0, $3e88191b87395c2e$export$8244b9efe04488e) {
    get __isInlineFormattable() {
        return !0;
    }
    $config() {
        return this.config("decorator-text", {
            extends: (0, $3e88191b87395c2e$export$8244b9efe04488e),
            stateConfigs: [
                {
                    flat: !0,
                    stateConfig: $8ebc39becbfbdd8f$var$ye
                }
            ]
        });
    }
    getFormat(t) {
        return (0, $3e88191b87395c2e$export$5f6d848b3f2eebb0)(this, $8ebc39becbfbdd8f$var$ye, t);
    }
    getFormatFlags(t, e) {
        return (0, $3e88191b87395c2e$export$bfd35cbfa01f02e5)(this.getFormat(), t, e);
    }
    hasFormat(t) {
        const e = (0, $3e88191b87395c2e$export$c9e7d6eb65b13430)[t];
        return 0 !== (this.getFormat() & e);
    }
    setFormat(t) {
        return (0, $3e88191b87395c2e$export$401d8a6b50e0699a)(this, $8ebc39becbfbdd8f$var$ye, t);
    }
    toggleFormat(t) {
        const e = this.getFormat(), n = (0, $3e88191b87395c2e$export$bfd35cbfa01f02e5)(e, t, null);
        return this.setFormat(n);
    }
    isInline() {
        return !0;
    }
    createDOM(t, e) {
        return (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("span");
    }
}
function $8ebc39becbfbdd8f$export$ee1627bd2acd880e(t) {
    return t instanceof $8ebc39becbfbdd8f$export$491902e995c6a41e;
}
function $8ebc39becbfbdd8f$export$5ab448668a7eedad(t, e, n) {
    const i = e.fontWeight, o = e.textDecoration.split(" "), s = "700" === i || "bold" === i, r = o.includes("line-through"), c = "italic" === e.fontStyle, a = o.includes("underline"), d = e.verticalAlign;
    return s && !t.hasFormat("bold") && t.toggleFormat("bold"), r && !t.hasFormat("strikethrough") && t.toggleFormat("strikethrough"), c && !t.hasFormat("italic") && t.toggleFormat("italic"), a && !t.hasFormat("underline") && t.toggleFormat("underline"), "sub" !== d || t.hasFormat("subscript") || t.toggleFormat("subscript"), "super" !== d || t.hasFormat("superscript") || t.toggleFormat("superscript"), n && !t.hasFormat(n) && t.toggleFormat(n), t;
}
function $8ebc39becbfbdd8f$export$995b3c45ea2a1727(t, e, n = $8ebc39becbfbdd8f$var$Oe) {
    let i = e;
    for (const [e, o] of Object.entries(n))t.hasFormat(o) && (i = $8ebc39becbfbdd8f$var$Ne(i, e));
    return i;
}
const $8ebc39becbfbdd8f$export$ead06250488d7fd4 = $8ebc39becbfbdd8f$export$995b3c45ea2a1727;
function $8ebc39becbfbdd8f$var$Ne(t, e) {
    const n = t.ownerDocument.createElement(e);
    return n.appendChild(t), n;
}
const $8ebc39becbfbdd8f$var$Oe = {
    b: "bold",
    code: "code",
    em: "italic",
    i: "italic",
    mark: "highlight",
    s: "strikethrough",
    strong: "bold",
    sub: "subscript",
    sup: "superscript",
    u: "underline"
}, $8ebc39becbfbdd8f$export$e3279eec9bdaebff = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    name: "@lexical/extension/DecoratorText",
    nodes: ()=>[
            $8ebc39becbfbdd8f$export$491902e995c6a41e
        ]
});
function $8ebc39becbfbdd8f$export$4ce37b374ded5463(t, e) {
    let n;
    return $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8(t(), {
        unwatched () {
            n && (n(), n = void 0);
        },
        watched () {
            this.value = t(), n = e(this);
        }
    });
}
const $8ebc39becbfbdd8f$export$d33663c907c2bb2c = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t)=>$8ebc39becbfbdd8f$export$4ce37b374ded5463(()=>t.getEditorState(), (e)=>t.registerUpdateListener((t)=>{
                e.value = t.editorState;
            })),
    name: "@lexical/extension/EditorState"
});
function $8ebc39becbfbdd8f$var$Ie(t, ...e) {
    const n = new URL("https://lexical.dev/docs/error"), i = new URLSearchParams;
    i.append("code", t);
    for (const t of e)i.append("v", t);
    throw n.search = i.toString(), Error(`Minified Lexical error #${t}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
let $8ebc39becbfbdd8f$var$Fe;
try {
    $8ebc39becbfbdd8f$var$Fe = "0.48.0+prod.esm";
} catch (t) {}
const $8ebc39becbfbdd8f$var$Me = $8ebc39becbfbdd8f$var$Fe !== null && $8ebc39becbfbdd8f$var$Fe !== void 0 ? $8ebc39becbfbdd8f$var$Fe : '"<unknown>+source"', $8ebc39becbfbdd8f$var$_e = new Set([
    "__proto__",
    "constructor",
    "prototype"
]);
function $8ebc39becbfbdd8f$var$ke(t, e) {
    if (t && e && !Array.isArray(e) && "object" == typeof t && "object" == typeof e) {
        const n = t, i = e;
        for(const t in i)!$8ebc39becbfbdd8f$var$_e.has(t) && Object.prototype.hasOwnProperty.call(i, t) && (n[t] = $8ebc39becbfbdd8f$var$ke(n[t], i[t]));
        return t;
    }
    return e;
}
const $8ebc39becbfbdd8f$var$Ae = 0, $8ebc39becbfbdd8f$var$Pe = 1, $8ebc39becbfbdd8f$var$Le = 2, $8ebc39becbfbdd8f$var$Ke = 3, $8ebc39becbfbdd8f$var$$e = 4, $8ebc39becbfbdd8f$var$Te = 5, $8ebc39becbfbdd8f$var$je = 6, $8ebc39becbfbdd8f$var$ze = 7;
function $8ebc39becbfbdd8f$var$Ue(t) {
    return t.id === $8ebc39becbfbdd8f$var$Ae;
}
function $8ebc39becbfbdd8f$var$We(t) {
    return t.id === $8ebc39becbfbdd8f$var$Le;
}
function $8ebc39becbfbdd8f$var$Be(t) {
    return function(t) {
        return t.id === $8ebc39becbfbdd8f$var$Pe;
    }(t) || $8ebc39becbfbdd8f$var$Ie(305, String(t.id), String($8ebc39becbfbdd8f$var$Pe)), Object.assign(t, {
        id: $8ebc39becbfbdd8f$var$Le
    });
}
const $8ebc39becbfbdd8f$var$Ve = new Set;
class $8ebc39becbfbdd8f$var$Ge {
    mergeConfigs() {
        let t = this.extension.config || {};
        const e = this.extension.mergeConfig ? this.extension.mergeConfig.bind(this.extension) : (0, $3e88191b87395c2e$export$89e5ee996f4118);
        for (const n of this.configs)t = e(t, n);
        return t;
    }
    init(t) {
        const e = this.state;
        $8ebc39becbfbdd8f$var$We(e) || $8ebc39becbfbdd8f$var$Ie(306, String(e.id));
        const n = {
            getDependency: this.getInitDependency.bind(this),
            getDirectDependentNames: this.getDirectDependentNames.bind(this),
            getPeer: this.getInitPeer.bind(this),
            getPeerNameSet: this.getPeerNameSet.bind(this)
        }, i = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, n), {
            getDependency: this.getDependency.bind(this),
            getInitResult: this.getInitResult.bind(this),
            getPeer: this.getPeer.bind(this)
        }), o = function(t, e, n) {
            return Object.assign(t, {
                config: e,
                id: $8ebc39becbfbdd8f$var$Ke,
                registerState: n
            });
        }(e, this.mergeConfigs(), n);
        let s;
        this.state = o, this.extension.init && (s = this.extension.init(t, o.config, n)), this.state = function(t, e, n) {
            return Object.assign(t, {
                id: $8ebc39becbfbdd8f$var$$e,
                initResult: e,
                registerState: n
            });
        }(o, s, i);
    }
    build(t) {
        const e = this.state;
        let n;
        e.id !== $8ebc39becbfbdd8f$var$$e && $8ebc39becbfbdd8f$var$Ie(307, String(e.id), String($8ebc39becbfbdd8f$var$Te)), this.extension.build && (n = this.extension.build(t, e.config, e.registerState));
        const i = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, e.registerState), {
            getOutput: ()=>n,
            getSignal: this.getSignal.bind(this)
        });
        this.state = function(t, e, n) {
            return Object.assign(t, {
                id: $8ebc39becbfbdd8f$var$Te,
                output: e,
                registerState: n
            });
        }(e, n, i);
    }
    register(t, e) {
        this._signal = e;
        const n = this.state;
        n.id !== $8ebc39becbfbdd8f$var$Te && $8ebc39becbfbdd8f$var$Ie(308, String(n.id), String($8ebc39becbfbdd8f$var$Te));
        const i = this.extension.register && this.extension.register(t, n.config, n.registerState);
        return this.state = function(t) {
            return Object.assign(t, {
                id: $8ebc39becbfbdd8f$var$je
            });
        }(n), ()=>{
            const t = this.state;
            t.id !== $8ebc39becbfbdd8f$var$ze && $8ebc39becbfbdd8f$var$Ie(309, String(n.id), String($8ebc39becbfbdd8f$var$ze)), this.state = function(t) {
                return Object.assign(t, {
                    id: $8ebc39becbfbdd8f$var$Te
                });
            }(t), i && i();
        };
    }
    afterRegistration(t) {
        const e = this.state;
        let n;
        return e.id !== $8ebc39becbfbdd8f$var$je && $8ebc39becbfbdd8f$var$Ie(310, String(e.id), String($8ebc39becbfbdd8f$var$je)), this.extension.afterRegistration && (n = this.extension.afterRegistration(t, e.config, e.registerState)), this.state = function(t) {
            return Object.assign(t, {
                id: $8ebc39becbfbdd8f$var$ze
            });
        }(e), n;
    }
    getSignal() {
        return void 0 === this._signal && $8ebc39becbfbdd8f$var$Ie(311), this._signal;
    }
    getInitResult() {
        void 0 === this.extension.init && $8ebc39becbfbdd8f$var$Ie(312, this.extension.name);
        const t = this.state;
        return function(t) {
            return t.id >= $8ebc39becbfbdd8f$var$$e;
        }(t) || $8ebc39becbfbdd8f$var$Ie(313, String(t.id), String($8ebc39becbfbdd8f$var$$e)), t.initResult;
    }
    getInitPeer(t) {
        const e = this.builder.extensionNameMap.get(t);
        return e ? e.getExtensionInitDependency() : void 0;
    }
    getExtensionInitDependency() {
        const t = this.state;
        return function(t) {
            return t.id >= $8ebc39becbfbdd8f$var$Ke;
        }(t) || $8ebc39becbfbdd8f$var$Ie(314, String(t.id), String($8ebc39becbfbdd8f$var$Ke)), {
            config: t.config
        };
    }
    getPeer(t) {
        const e = this.builder.extensionNameMap.get(t);
        return e ? e.getExtensionDependency() : void 0;
    }
    getInitDependency(t) {
        const e = this.builder.getExtensionRep(t);
        return void 0 === e && $8ebc39becbfbdd8f$var$Ie(315, this.extension.name, t.name), e.getExtensionInitDependency();
    }
    getDependency(t) {
        const e = this.builder.getExtensionRep(t);
        return void 0 === e && $8ebc39becbfbdd8f$var$Ie(315, this.extension.name, t.name), e.getExtensionDependency();
    }
    getState() {
        const t = this.state;
        return function(t) {
            return t.id >= $8ebc39becbfbdd8f$var$ze;
        }(t) || $8ebc39becbfbdd8f$var$Ie(316, String(t.id), String($8ebc39becbfbdd8f$var$ze)), t;
    }
    getDirectDependentNames() {
        return this.builder.incomingEdges.get(this.extension.name) || $8ebc39becbfbdd8f$var$Ve;
    }
    getPeerNameSet() {
        let t = this._peerNameSet;
        return t || (t = new Set((this.extension.peerDependencies || []).map(([t])=>t)), this._peerNameSet = t), t;
    }
    getExtensionDependency() {
        if (!this._dependency) {
            const t = this.state;
            (function(t) {
                return t.id >= $8ebc39becbfbdd8f$var$Te;
            })(t) || $8ebc39becbfbdd8f$var$Ie(317, this.extension.name), this._dependency = {
                config: t.config,
                init: t.initResult,
                output: t.output
            };
        }
        return this._dependency;
    }
    constructor(t, e){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "builder", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "configs", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_dependency", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_peerNameSet", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "extension", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "state", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_signal", void 0);
        this.builder = t, this.extension = e, this.configs = new Set, this.state = {
            id: $8ebc39becbfbdd8f$var$Ae
        };
    }
}
const $8ebc39becbfbdd8f$var$Ze = {
    tag: (0, $3e88191b87395c2e$export$b58a9fabaf2a5573)
};
function $8ebc39becbfbdd8f$var$Je() {
    const t = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)();
    t.isEmpty() && t.append((0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)());
}
const $8ebc39becbfbdd8f$export$17469cfcef8e877c = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        setOptions: $8ebc39becbfbdd8f$var$Ze,
        updateOptions: $8ebc39becbfbdd8f$var$Ze
    }),
    init: ({ $initialEditorState: t = $8ebc39becbfbdd8f$var$Je })=>({
            $initialEditorState: t,
            initialized: !1
        }),
    afterRegistration (t, { updateOptions: e, setOptions: n }, i) {
        const o = i.getInitResult();
        if (!o.initialized) {
            o.initialized = !0;
            const { $initialEditorState: i } = o;
            if ((0, $3e88191b87395c2e$export$ac0ab291f300d875)(i)) t.setEditorState(i, n);
            else if ("function" == typeof i) t.update(()=>{
                i(t);
            }, e);
            else if (i && ("string" == typeof i || "object" == typeof i)) {
                const e = t.parseEditorState(i);
                t.setEditorState(e, n);
            }
        }
        return ()=>{};
    },
    name: "@lexical/extension/InitialState",
    nodes: [
        (0, $3e88191b87395c2e$export$1c180cb67301903c),
        (0, $3e88191b87395c2e$export$f0a25ea3087686aa),
        (0, $3e88191b87395c2e$export$965f56e8043e93ae),
        (0, $3e88191b87395c2e$export$8dbf7edd89edc19c),
        (0, $3e88191b87395c2e$export$e94424771493b912)
    ]
}), $8ebc39becbfbdd8f$var$Xe = Symbol.for("@lexical/extension/LexicalBuilder");
function $8ebc39becbfbdd8f$export$f19a95efed97f38c(...t) {
    return $8ebc39becbfbdd8f$export$e58dbff0cd3a42d8.fromExtensions(t).buildEditor();
}
function $8ebc39becbfbdd8f$var$qe() {}
function $8ebc39becbfbdd8f$var$Qe(t) {
    throw t;
}
function $8ebc39becbfbdd8f$var$tn(t) {
    return Array.isArray(t) ? t : [
        t
    ];
}
const $8ebc39becbfbdd8f$var$en = $8ebc39becbfbdd8f$var$Me;
class $8ebc39becbfbdd8f$export$e58dbff0cd3a42d8 {
    static fromExtensions(t) {
        const e = [
            $8ebc39becbfbdd8f$var$tn($8ebc39becbfbdd8f$export$17469cfcef8e877c)
        ];
        for (const n of t)e.push($8ebc39becbfbdd8f$var$tn(n));
        return new $8ebc39becbfbdd8f$export$e58dbff0cd3a42d8(e);
    }
    static maybeFromEditor(t) {
        const e = t[$8ebc39becbfbdd8f$var$Xe];
        return e && (e.PACKAGE_VERSION !== $8ebc39becbfbdd8f$var$en && $8ebc39becbfbdd8f$var$Ie(292, e.PACKAGE_VERSION, $8ebc39becbfbdd8f$var$en), e instanceof $8ebc39becbfbdd8f$export$e58dbff0cd3a42d8 || $8ebc39becbfbdd8f$var$Ie(293)), e;
    }
    static fromEditor(t) {
        const e = $8ebc39becbfbdd8f$export$e58dbff0cd3a42d8.maybeFromEditor(t);
        return void 0 === e && $8ebc39becbfbdd8f$var$Ie(294), e;
    }
    constructEditor() {
        const _this_buildCreateEditorArgs = this.buildCreateEditorArgs(), { $initialEditorState: t, onError: e, onWarn: n } = _this_buildCreateEditorArgs, i = (0, $8901fc92b5563702$export$71511d61b312f219)(_this_buildCreateEditorArgs, [
            "$initialEditorState",
            "onError",
            "onWarn"
        ]), o = Object.assign((0, $3e88191b87395c2e$export$eb02d1ee0d3cac30)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, i, e ? {
            onError: (t)=>{
                e(t, o);
            }
        } : {}, n ? {
            onWarn: (t)=>{
                n(t, o);
            }
        } : {})), {
            [$8ebc39becbfbdd8f$var$Xe]: this
        });
        for (const t of this.sortedExtensionReps())t.build(o);
        return o;
    }
    buildEditor() {
        let t = $8ebc39becbfbdd8f$var$qe;
        function e() {
            try {
                t();
            } finally{
                t = $8ebc39becbfbdd8f$var$qe;
            }
        }
        const n = Object.assign(this.constructEditor(), {
            dispose: e,
            [Symbol.dispose]: e
        });
        return t = (0, $3e88191b87395c2e$export$d64d64f541cc1835)(this.registerEditor(n), ()=>n.setRootElement(null)), n;
    }
    hasExtensionByName(t) {
        return this.extensionNameMap.has(t);
    }
    getExtensionRep(t) {
        const e = this.extensionNameMap.get(t.name);
        if (e) return e.extension !== t && $8ebc39becbfbdd8f$var$Ie(295, t.name), e;
    }
    addEdge(t, e, n) {
        const i = this.outgoingConfigEdges.get(t);
        i ? i.set(e, n) : this.outgoingConfigEdges.set(t, new Map([
            [
                e,
                n
            ]
        ]));
        const o = this.incomingEdges.get(e);
        o ? o.add(t) : this.incomingEdges.set(e, new Set([
            t
        ]));
    }
    addExtension(t) {
        void 0 !== this._sortedExtensionReps && $8ebc39becbfbdd8f$var$Ie(296);
        const e = $8ebc39becbfbdd8f$var$tn(t), [n] = e;
        "string" != typeof n.name && $8ebc39becbfbdd8f$var$Ie(297, typeof n.name);
        let i = this.extensionNameMap.get(n.name);
        if (void 0 !== i && i.extension !== n && $8ebc39becbfbdd8f$var$Ie(298, n.name), !i) {
            i = new $8ebc39becbfbdd8f$var$Ge(this, n), this.extensionNameMap.set(n.name, i);
            const t = this.conflicts.get(n.name);
            "string" == typeof t && $8ebc39becbfbdd8f$var$Ie(299, n.name, t);
            for (const t of n.conflictsWith || [])this.extensionNameMap.has(t) && $8ebc39becbfbdd8f$var$Ie(299, n.name, t), this.conflicts.set(t, n.name);
            for (const t of n.dependencies || []){
                const e = $8ebc39becbfbdd8f$var$tn(t);
                this.addEdge(n.name, e[0].name, e.slice(1)), this.addExtension(e);
            }
            for (const [t, e] of n.peerDependencies || [])this.addEdge(n.name, t, e ? [
                e
            ] : []);
        }
    }
    sortedExtensionReps() {
        if (this._sortedExtensionReps) return this._sortedExtensionReps;
        const t = [], e = (n, i)=>{
            let o = n.state;
            if ($8ebc39becbfbdd8f$var$We(o)) return;
            const s = n.extension.name;
            var r;
            $8ebc39becbfbdd8f$var$Ue(o) || $8ebc39becbfbdd8f$var$Ie(300, s, i || "[unknown]"), $8ebc39becbfbdd8f$var$Ue(r = o) || $8ebc39becbfbdd8f$var$Ie(304, String(r.id), String($8ebc39becbfbdd8f$var$Ae)), o = Object.assign(r, {
                id: $8ebc39becbfbdd8f$var$Pe
            }), n.state = o;
            const c = this.outgoingConfigEdges.get(s);
            if (c) for (const t of c.keys()){
                const n = this.extensionNameMap.get(t);
                n && e(n, s);
            }
            o = $8ebc39becbfbdd8f$var$Be(o), n.state = o, t.push(n);
        };
        for (const t of this.extensionNameMap.values())$8ebc39becbfbdd8f$var$Ue(t.state) && e(t);
        for (const e of t)for (const [t, n] of this.outgoingConfigEdges.get(e.extension.name) || [])if (n.length > 0) {
            const e = this.extensionNameMap.get(t);
            if (e) for (const t of n)e.configs.add(t);
        }
        for (const [t, ...e] of this.roots)if (e.length > 0) {
            const n = this.extensionNameMap.get(t.name);
            void 0 === n && $8ebc39becbfbdd8f$var$Ie(301, t.name);
            for (const t of e)n.configs.add(t);
        }
        return this._sortedExtensionReps = t, this._sortedExtensionReps;
    }
    registerEditor(t) {
        const e = this.sortedExtensionReps(), n = new AbortController, i = [
            ()=>n.abort()
        ], o = n.signal;
        for (const n of e){
            const e = n.register(t, o);
            e && i.push(e);
        }
        for (const n of e){
            const e = n.afterRegistration(t);
            e && i.push(e);
        }
        return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(...i);
    }
    buildCreateEditorArgs() {
        const t = {}, e = new Set, n = new Map, i = new Map, o = {}, s = {}, r = this.sortedExtensionReps();
        for (const c of r){
            const { extension: r } = c;
            if (void 0 !== r.onError && (t.onError = r.onError), void 0 !== r.onWarn && (t.onWarn = r.onWarn), void 0 !== r.disableEvents && (t.disableEvents = r.disableEvents), void 0 !== r.parentEditor && (t.parentEditor = r.parentEditor), void 0 !== r.editable && (t.editable = r.editable), void 0 !== r.namespace && (t.namespace = r.namespace), void 0 !== r.$initialEditorState && (t.$initialEditorState = r.$initialEditorState), r.nodes) for (const t of $8ebc39becbfbdd8f$var$ve(r)){
                if ("function" != typeof t) {
                    const e = n.get(t.replace);
                    e && $8ebc39becbfbdd8f$var$Ie(302, r.name, t.replace.name, e.extension.name), n.set(t.replace, c);
                }
                e.add(t);
            }
            if (r.html) {
                if (r.html.export) for (const [t, e] of r.html.export.entries())i.set(t, e);
                r.html.import && Object.assign(o, r.html.import);
            }
            r.theme && $8ebc39becbfbdd8f$var$ke(s, r.theme);
        }
        Object.keys(s).length > 0 && (t.theme = s), e.size && (t.nodes = [
            ...e
        ]);
        const c = Object.keys(o).length > 0, a = i.size > 0;
        (c || a) && (t.html = {}, c && (t.html.import = o), a && (t.html.export = i));
        for (const e of r)e.init(t);
        return t.onError || (t.onError = $8ebc39becbfbdd8f$var$Qe), t;
    }
    constructor(t){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "roots", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "extensionNameMap", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "outgoingConfigEdges", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "incomingEdges", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "conflicts", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "_sortedExtensionReps", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "PACKAGE_VERSION", void 0);
        this.outgoingConfigEdges = new Map, this.incomingEdges = new Map, this.extensionNameMap = new Map, this.conflicts = new Map, this.PACKAGE_VERSION = $8ebc39becbfbdd8f$var$en, this.roots = t;
        for (const e of t)this.addExtension(e);
    }
}
function $8ebc39becbfbdd8f$export$f6d797908fcfe7c8(t, e) {
    const n = $8ebc39becbfbdd8f$export$e58dbff0cd3a42d8.fromEditor(t).getExtensionRep(e);
    return void 0 === n && $8ebc39becbfbdd8f$var$Ie(303, e.name), n.getExtensionDependency();
}
function $8ebc39becbfbdd8f$export$1a203010713403e8(t, e) {
    const n = $8ebc39becbfbdd8f$export$e58dbff0cd3a42d8.maybeFromEditor(t);
    if (!n) return;
    const i = n.extensionNameMap.get(e);
    return i ? i.getExtensionDependency() : void 0;
}
function $8ebc39becbfbdd8f$export$dfa680d7d30b062e(t, e) {
    const n = $8ebc39becbfbdd8f$export$1a203010713403e8(t, e);
    return void 0 === n && $8ebc39becbfbdd8f$var$Ie(291, e), n;
}
function $8ebc39becbfbdd8f$export$102b688da169fa12(t) {
    return $8ebc39becbfbdd8f$export$f6d797908fcfe7c8((0, $3e88191b87395c2e$export$8a7392c46faf1a3f)(), t);
}
function $8ebc39becbfbdd8f$export$9ca48ab5b3c00400(t) {
    return $8ebc39becbfbdd8f$export$102b688da169fa12(t).output;
}
function $8ebc39becbfbdd8f$export$c53c4f45b5764867(t) {
    return $8ebc39becbfbdd8f$export$1a203010713403e8((0, $3e88191b87395c2e$export$8a7392c46faf1a3f)(), t);
}
const $8ebc39becbfbdd8f$var$ln = new Set, $8ebc39becbfbdd8f$export$aeaaad743245bd7c = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build (t, e, n) {
        const i = n.getDependency($8ebc39becbfbdd8f$export$d33663c907c2bb2c).output, o = $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8({
            watchedNodeKeys: new Map
        }), s = $8ebc39becbfbdd8f$export$4ce37b374ded5463(()=>{}, ()=>$8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
                const t = s.peek(), { watchedNodeKeys: e } = o.value;
                let n, c = !1;
                i.value.read(()=>{
                    if ((0, $3e88191b87395c2e$export$63a3201b3a5c7d90)()) for (const [i, o] of e.entries()){
                        if (0 === o.size) {
                            e.delete(i);
                            continue;
                        }
                        const s = (0, $3e88191b87395c2e$export$e725f93d4d48c6d8)(i), r = s && s.isSelected() || !1;
                        c = c || r !== (!!t && t.has(i)), r && (n = n || new Set, n.add(i));
                    }
                }), !c && n && t && n.size === t.size || (s.value = n);
            }));
        return {
            watchNodeKey: function(t) {
                const e = $8ebc39becbfbdd8f$export$2983e091f1a1e8e2(()=>(s.value || $8ebc39becbfbdd8f$var$ln).has(t)), { watchedNodeKeys: n } = o.peek();
                let i = n.get(t);
                const r = void 0 !== i;
                return i = i || new Set, i.add(e), r || (n.set(t, i), o.value = {
                    watchedNodeKeys: n
                }), e;
            }
        };
    },
    dependencies: [
        $8ebc39becbfbdd8f$export$d33663c907c2bb2c
    ],
    name: "@lexical/extension/NodeSelection"
}), $8ebc39becbfbdd8f$export$cb74a0e0b1dd37f = /* @__PURE__ */ (0, $3e88191b87395c2e$export$8d4021544bdece00)("INSERT_HORIZONTAL_RULE_COMMAND");
class $8ebc39becbfbdd8f$export$e68cdf336f70c676 extends (0, $3e88191b87395c2e$export$8244b9efe04488e) {
    static getType() {
        return "horizontalrule";
    }
    static clone(t) {
        return new $8ebc39becbfbdd8f$export$e68cdf336f70c676(t.__key);
    }
    static importJSON(t) {
        return $8ebc39becbfbdd8f$export$6fd365a92f1482f2().updateFromJSON(t);
    }
    static importDOM() {
        return {
            hr: ()=>({
                    conversion: $8ebc39becbfbdd8f$var$gn,
                    priority: 0
                })
        };
    }
    exportDOM() {
        return {
            element: (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("hr")
        };
    }
    createDOM(t) {
        const e = (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("hr");
        return (0, $3e88191b87395c2e$export$71781797876b07d6)(e, t.theme.hr), e;
    }
    getTextContent() {
        return "\n";
    }
    isInline() {
        return !1;
    }
    updateDOM() {
        return !1;
    }
}
function $8ebc39becbfbdd8f$var$gn() {
    return {
        node: $8ebc39becbfbdd8f$export$6fd365a92f1482f2()
    };
}
function $8ebc39becbfbdd8f$export$6fd365a92f1482f2() {
    return (0, $3e88191b87395c2e$export$dde9d6ffeb117c5e)($8ebc39becbfbdd8f$export$e68cdf336f70c676);
}
function $8ebc39becbfbdd8f$export$dddc142b287ff132(t) {
    return t instanceof $8ebc39becbfbdd8f$export$e68cdf336f70c676;
}
const $8ebc39becbfbdd8f$export$655225b584cf802e = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    dependencies: [
        $8ebc39becbfbdd8f$export$d33663c907c2bb2c,
        $8ebc39becbfbdd8f$export$aeaaad743245bd7c
    ],
    name: "@lexical/extension/HorizontalRule",
    nodes: ()=>[
            $8ebc39becbfbdd8f$export$e68cdf336f70c676
        ],
    register (t, e, n) {
        var _t__config_theme_hrSelected;
        const { watchNodeKey: i } = n.getDependency($8ebc39becbfbdd8f$export$aeaaad743245bd7c).output, s = $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8({
            nodeSelections: new Map
        }), c = (_t__config_theme_hrSelected = t._config.theme.hrSelected) !== null && _t__config_theme_hrSelected !== void 0 ? _t__config_theme_hrSelected : "selected";
        return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(t.registerCommand($8ebc39becbfbdd8f$export$cb74a0e0b1dd37f, (t)=>{
            const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) return !1;
            if (null !== e.focus.getNode()) {
                const t = $8ebc39becbfbdd8f$export$6fd365a92f1482f2();
                (0, $74849711df60ce24$export$4ec669795a8ed6b)(t);
            }
            return !0;
        }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), t.registerCommand((0, $3e88191b87395c2e$export$c1a2de6c823e5f82), (t)=>{
            if ((0, $3e88191b87395c2e$export$b8eb4d3b76e486c2)(t.target)) {
                const e = (0, $3e88191b87395c2e$export$b1414e7b1cad1d22)(t.target);
                if ($8ebc39becbfbdd8f$export$dddc142b287ff132(e)) return function(t, e = !1) {
                    const n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)(), i = t.isSelected(), o = t.getKey();
                    let s;
                    e && (0, $3e88191b87395c2e$export$7257e4181651a7c3)(n) ? s = n : (s = (0, $3e88191b87395c2e$export$f8cd0c3f35d1a61c)(), (0, $3e88191b87395c2e$export$2aad78c37810bca9)(s)), i ? s.delete(o) : s.add(o);
                }(e, t.shiftKey), !0;
            }
            return !1;
        }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerMutationListener($8ebc39becbfbdd8f$export$e68cdf336f70c676, (e, n)=>{
            $8ebc39becbfbdd8f$export$712ea50be43a7858(()=>{
                let n = !1;
                const { nodeSelections: o } = s.peek();
                for (const [s, r] of e.entries())if ("destroyed" === r) o.delete(s), n = !0;
                else {
                    const e = o.get(s), r = t.getElementByKey(s);
                    e ? e.domNode.value = r : (n = !0, o.set(s, {
                        domNode: $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8(r),
                        selectedSignal: i(s)
                    }));
                }
                n && (s.value = {
                    nodeSelections: o
                });
            });
        }), $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            const t = [];
            for (const { domNode: e, selectedSignal: n } of s.value.nodeSelections.values())t.push($8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
                const t = e.value;
                if (t) n.value ? (0, $3e88191b87395c2e$export$71781797876b07d6)(t, c) : (0, $3e88191b87395c2e$export$b59af601940ff389)(t, c);
            }));
            return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(...t);
        }));
    }
}), $8ebc39becbfbdd8f$export$b7349496c1b04e9 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t)=>({
            composingTextNode: $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8(null),
            compositionKey: $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8(null)
        }),
    name: "@lexical/extension/IME",
    register (t, e, n) {
        const { compositionKey: i, composingTextNode: o } = n.getOutput(), s = t.registerCommand((0, $3e88191b87395c2e$export$e688de3e16be2231), ()=>{
            const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            return (0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && (i.value = t.anchor.key), !1;
        }, (0, $3e88191b87395c2e$export$ad4f8f37df5d0905)), c = $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            const e = i.value;
            o.value = null !== e ? t.read("latest", ()=>{
                const t = (0, $3e88191b87395c2e$export$e725f93d4d48c6d8)(e);
                return (0, $3e88191b87395c2e$export$471953706258be2b)(t) ? t : null;
            }) : null;
        }), d = t.registerUpdateListener(({ tags: t, editorState: e })=>{
            t.has((0, $3e88191b87395c2e$export$98153f24c6e5ae19)) && e.read(()=>{
                const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) return;
                const e = t.anchor.getNode();
                (0, $3e88191b87395c2e$export$471953706258be2b)(e) && (o.value = e);
            });
        }), l = t.registerRootListener((t)=>{
            if (null === t) return void (i.value = null);
            return (0, $3e88191b87395c2e$export$bea698773a21b4e8)(t, "compositionend", ()=>{
                i.value = null;
            });
        });
        return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(s, c, d, l);
    }
});
const $8ebc39becbfbdd8f$export$ae64beb000178cb6 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e)=>$8ebc39becbfbdd8f$export$b351c03363e45c4f({
            inheritEditableFromParent: e.inheritEditableFromParent
        }),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        $getParentEditor: function() {
            const t = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)();
            return $8ebc39becbfbdd8f$export$e58dbff0cd3a42d8.fromEditor(t), t;
        },
        inheritEditableFromParent: !1
    }),
    init: (t, e, n)=>{
        const i = e.$getParentEditor();
        t.parentEditor = i, t.theme = t.theme || i._config.theme;
    },
    name: "@lexical/extension/NestedEditor",
    register: (t, e, n)=>$8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            const e = t._parentEditor;
            if (e && n.getOutput().inheritEditableFromParent.value) return t.setEditable(e.isEditable()), e.registerEditableListener(t.setEditable.bind(t));
        })
}), $8ebc39becbfbdd8f$export$2d1460a8979a665f = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        attribute: "data-selected",
        nodes: []
    }),
    init (t, e) {
        const n = new Set, i = (0, $3e88191b87395c2e$export$178ba1ee8bfc8fa1)($8ebc39becbfbdd8f$export$c25a0876f35f253e(t).nodes);
        for (const t of e.nodes){
            const e = t.getType(), o = i.get(e);
            void 0 === o && $8ebc39becbfbdd8f$var$Ie(339, t.name, e), n.add(e);
            for (const t of o)n.add(t);
        }
        return {
            matchTypes: n
        };
    },
    mergeConfig: (t, e)=>(0, $3e88191b87395c2e$export$89e5ee996f4118)(t, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, e, e.nodes && {
            nodes: [
                ...t.nodes,
                ...e.nodes
            ]
        })),
    name: "@lexical/extension/NodeSelectionDataSelected",
    register (t, e, n) {
        const { attribute: i } = e, { matchTypes: o } = n.getInitResult(), s = new Map, c = (e)=>{
            const n = new Set;
            e.read(()=>{
                const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                if ((0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) for (const e of t.getNodes())o.has(e.getType()) && n.add(e.getKey());
            });
            for (const [t, e] of s)n.has(t) || (e.removeAttribute(i), s.delete(t));
            for (const e of n){
                const n = t.getElementByKey(e);
                null !== n && (n.setAttribute(i, "true"), s.set(e, n));
            }
        };
        c(t.getEditorState());
        const a = t.registerUpdateListener(({ editorState: t })=>c(t));
        return ()=>{
            a();
            for (const t of s.values())t.removeAttribute(i);
            s.clear();
        };
    }
});
function $8ebc39becbfbdd8f$var$bn(t) {
    (0, $3e88191b87395c2e$export$923a058ef54437a4)(t) && t.isInline() && t.isEmpty() && t.remove();
}
const $8ebc39becbfbdd8f$export$ec8a92468ee4937e = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e, n)=>$8ebc39becbfbdd8f$export$b351c03363e45c4f(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        disabled: !1
    }),
    name: "@lexical/NormalizeInlineElements",
    register: (t, e, n)=>{
        const i = n.getOutput();
        return $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            if (!i.disabled.value) {
                const e = [];
                for (const { klass: n, transforms: i } of t._nodes.values())n.prototype instanceof (0, $3e88191b87395c2e$export$dc064fe9e59310fd) && n.prototype.isInline !== (0, $3e88191b87395c2e$export$dc064fe9e59310fd).prototype.isInline && (i.add($8ebc39becbfbdd8f$var$bn), e.push(()=>i.delete($8ebc39becbfbdd8f$var$bn)));
                return ()=>e.forEach((t)=>t());
            }
        });
    }
}), $8ebc39becbfbdd8f$var$wn = new Set([
    (0, $3e88191b87395c2e$export$8a1d07d516311732),
    (0, $3e88191b87395c2e$export$e36816488e788f40)
]);
const $8ebc39becbfbdd8f$export$bdf5c0f0c7e6e1f = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e, n)=>$8ebc39becbfbdd8f$export$b351c03363e45c4f(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        $fixFocusOverselection: function() {
            const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && !t.isCollapsed()) {
                const e = (0, $3e88191b87395c2e$export$b6aa34707ffda54a)((0, $3e88191b87395c2e$export$7bcaa61bc56938bf)(t), "next");
                let n = e.focus;
                for((0, $3e88191b87395c2e$export$6d8c68034bda7a85)(n) && e.anchor.origin !== n.origin && 0 === n.offset && (n = (0, $3e88191b87395c2e$export$3d19514618fb28f3)(n.getSiblingCaret())), (0, $3e88191b87395c2e$export$3bcd9a2637e8506e)(n) && e.anchor.origin !== n.origin && (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(n.origin) && (n = (0, $3e88191b87395c2e$export$3d19514618fb28f3)(n)); (0, $3e88191b87395c2e$export$1c3da6f3e60ca260)(n) && e.anchor.origin !== n.origin;)n = (0, $3e88191b87395c2e$export$3d19514618fb28f3)((0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(n.origin, "next"));
                if ((0, $3e88191b87395c2e$export$3bcd9a2637e8506e)(n) && (0, $3e88191b87395c2e$export$923a058ef54437a4)(n.origin) && (n = (0, $3e88191b87395c2e$export$33e015e8f2ff8536)((0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(n.origin, "previous")).getFlipped()), n = (0, $3e88191b87395c2e$export$33e015e8f2ff8536)(n), !n.isSamePointCaret(e.focus)) {
                    const t = (0, $3e88191b87395c2e$export$9fb698110f44889d)((0, $3e88191b87395c2e$export$36f672915982afb2)(e.anchor, n)), i = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)().getRootElement(), o = i && (0, $3e88191b87395c2e$export$74c14770a0819525)(i.ownerDocument.defaultView);
                    o && (0, $3e88191b87395c2e$export$1e1970b9083661aa)((0, $3e88191b87395c2e$export$846e9407a8b5d98c)(), t, (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)(), o, $8ebc39becbfbdd8f$var$wn, i);
                }
            }
        },
        dateNow: Date.now,
        disabled: !1,
        thresholdMsec: 100
    }),
    name: "@lexical/NormalizeTripleClickSelection",
    register: (t, e, n)=>$8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            const e = n.getOutput();
            if (!e.disabled.value) return t.registerRootListener((n)=>{
                if (!n) return;
                let i = 0;
                const o = (t)=>{
                    if (t ? 3 === t.detail : i > 0) {
                        const n = e.dateNow.peek()();
                        i = t && "mousedown" === t.type || n - i <= e.thresholdMsec.peek() ? n : 0;
                    }
                    return i;
                };
                return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(t.registerCommand((0, $3e88191b87395c2e$export$e396fef71d2b56e5), ()=>(o(null) && (i = 0, e.$fixFocusOverselection.peek()()), !1), (0, $3e88191b87395c2e$export$3bc56e5f4ab213d)), (0, $3e88191b87395c2e$export$4256f76d7567e2ca)(n, {
                    mousedown: o,
                    mouseup: o
                }, !0));
            });
        })
});
function $8ebc39becbfbdd8f$var$On(t) {
    const e = t.target;
    (0, $3e88191b87395c2e$export$56e059fc8d27aa5f)(t, "a", {
        ctrlKey: !(0, $3e88191b87395c2e$export$d093bd80dddd0842),
        metaKey: (0, $3e88191b87395c2e$export$d093bd80dddd0842)
    }) && (0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e) && ("INPUT" === e.tagName || "TEXTAREA" === e.tagName) && e.addEventListener("keydown", (0, $3e88191b87395c2e$export$e066258f9188a34f), {
        once: !0
    });
}
const $8ebc39becbfbdd8f$export$504b6b239a568da3 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e, n)=>$8ebc39becbfbdd8f$export$b351c03363e45c4f(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        disabled: !1
    }),
    name: "@lexical/extension/PreventSelectAll",
    register: (t, e, n)=>{
        const i = n.getOutput();
        return $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            if (!i.disabled.value) return t.registerRootListener((t)=>{
                if (t) return (0, $3e88191b87395c2e$export$bea698773a21b4e8)(t, "keydown", $8ebc39becbfbdd8f$var$On, !0);
            });
        });
    }
}), $8ebc39becbfbdd8f$export$93d482e5238f6e43 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t)=>$8ebc39becbfbdd8f$export$4ce37b374ded5463(()=>t.getRootElement(), (e)=>t.registerRootListener((t)=>{
                e.value = t;
            })),
    name: "@lexical/extension/RootElement"
});
const $8ebc39becbfbdd8f$export$61e85e49b7d1ad3e = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e, n)=>$8ebc39becbfbdd8f$export$b351c03363e45c4f(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        cascadeSelection: !1,
        disabled: !1
    }),
    dependencies: [
        $8ebc39becbfbdd8f$export$504b6b239a568da3
    ],
    name: "@lexical/extension/SelectBlock",
    register: (t, e, n)=>{
        const i = n.getOutput(), o = n.getDependency($8ebc39becbfbdd8f$export$504b6b239a568da3).output;
        return (0, $3e88191b87395c2e$export$d64d64f541cc1835)($8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            o.disabled.value = i.disabled.value;
        }), $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            if (!i.disabled.value) return t.registerCommand((0, $3e88191b87395c2e$export$185c218616045e75), (e, n)=>{
                if (n !== t) {
                    if (!i.cascadeSelection.peek()) return !1;
                    return !!n.read("pending", ()=>{
                        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                        return (0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && (0, $74849711df60ce24$export$970e2195f7f7e928)((0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), t);
                    }) && ((0, $3e88191b87395c2e$export$824f075b28fd7b6c)(), !0);
                }
                const o = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                if ((0, $3e88191b87395c2e$export$7257e4181651a7c3)(o)) {
                    const t = o.getNodes(), e = t[0];
                    if (!e) return !1;
                    const n = e.getTopLevelElement();
                    return !n || (0, $3e88191b87395c2e$export$5b29ca560c2fedab)(n) || n.is(e) || t.length > 1 && (c = n, !t.every((t)=>c.is(t.getTopLevelElement()))) ? (0, $3e88191b87395c2e$export$824f075b28fd7b6c)() : (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) && n.select(0, n.getChildrenSize()), !0;
                }
                var c;
                if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(o)) return !1;
                const d = o.anchor.getNode(), u = d.getTopLevelElement();
                if (u && u.is(o.focus.getNode().getTopLevelElement()) && !(0, $74849711df60ce24$export$970e2195f7f7e928)(u, o)) return u.select(0, u.getChildrenSize()), !0;
                let f = (0, $3e88191b87395c2e$export$fe2dfd0f9ec2306d)(d);
                for(; null !== f;){
                    if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(f) && !(0, $74849711df60ce24$export$970e2195f7f7e928)(f, o)) return f.select(0, f.getChildrenSize()), !0;
                    const t = (0, $3e88191b87395c2e$export$fe2a41df16bf88cd)(f);
                    f = null === t ? null : (0, $3e88191b87395c2e$export$fe2dfd0f9ec2306d)(t);
                }
                return (0, $74849711df60ce24$export$970e2195f7f7e928)((0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), o) || (0, $3e88191b87395c2e$export$824f075b28fd7b6c)(), !0;
            }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4));
        }));
    }
}), $8ebc39becbfbdd8f$export$471c61c757bdbce2 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e, n)=>$8ebc39becbfbdd8f$export$b351c03363e45c4f(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        disabled: !1,
        onReposition: void 0
    }),
    name: "@lexical/utils/SelectionAlwaysOnDisplay",
    register: (t, e, n)=>{
        const i = n.getOutput();
        return $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            if (!i.disabled.value) return (0, $74849711df60ce24$export$624fc3ca4be05b70)(t, i.onReposition.value);
        });
    }
});
function $8ebc39becbfbdd8f$var$Fn(t) {
    return t.canIndent();
}
function $8ebc39becbfbdd8f$export$db2dc216cb098bdc(t, e, n = $8ebc39becbfbdd8f$var$Fn) {
    return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(t.registerCommand((0, $3e88191b87395c2e$export$b321bdc226ccdcde), (e)=>{
        const n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(n)) return !1;
        e.preventDefault();
        const i = function(t) {
            if (t.getNodes().filter((t)=>(0, $3e88191b87395c2e$export$de078facd4ee1560)(t) && t.canIndent()).length > 0) return !0;
            const e = t.anchor, n = t.focus, i = n.isBefore(e) ? n : e, o = i.getNode(), s = (0, $74849711df60ce24$export$87243b8185b18f91)(o);
            if (s.canIndent()) {
                const t = s.getKey();
                let e = (0, $3e88191b87395c2e$export$1ccc217b9831b072)();
                if (e.anchor.set(t, 0, "element"), e.focus.set(t, 0, "element"), e = (0, $3e88191b87395c2e$export$db10bc6ba67ffcb5)(e), e.anchor.is(i)) return !0;
            }
            return !1;
        }(n) ? e.shiftKey ? (0, $3e88191b87395c2e$export$ecf9caa19e96e40d) : (0, $3e88191b87395c2e$export$2f74f6a2d927e6bd) : (0, $3e88191b87395c2e$export$926ce4da2c89d118);
        return t.dispatchCommand(i, void 0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), t.registerCommand((0, $3e88191b87395c2e$export$2f74f6a2d927e6bd), ()=>{
        const t = "number" == typeof e ? e : e ? e.peek() : null, i = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(i)) return !1;
        const o = "function" == typeof n ? n : n.peek();
        return (0, $74849711df60ce24$export$39768b879b3f6739)((e)=>{
            if (o(e)) {
                const n = e.getIndent() + 1;
                (!t || n < t) && e.setIndent(n);
            }
        });
    }, (0, $3e88191b87395c2e$export$6afdf194f304e546)));
}
const $8ebc39becbfbdd8f$export$5f50ecb8c703d7d8 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e, n)=>$8ebc39becbfbdd8f$export$b351c03363e45c4f(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        $canIndent: $8ebc39becbfbdd8f$var$Fn,
        disabled: !1,
        maxIndent: null
    }),
    name: "@lexical/extension/TabIndentation",
    register (t, e, n) {
        const { disabled: i, maxIndent: o, $canIndent: s } = n.getOutput();
        return $8ebc39becbfbdd8f$export$dc573d8a6576cdb3(()=>{
            if (!i.value) return $8ebc39becbfbdd8f$export$db2dc216cb098bdc(t, o, s);
        });
    }
}), $8ebc39becbfbdd8f$export$6abda88bd60ddd8c = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t)=>$8ebc39becbfbdd8f$export$4ce37b374ded5463(()=>t.isEditable(), (e)=>t.registerEditableListener((t)=>{
                e.value = t;
            })),
    name: "@lexical/extension/WatchEditable"
});


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 






function $9429c8604db0efde$var$nt(t, ...e) {
    const n = new URL("https://lexical.dev/docs/error"), o = new URLSearchParams;
    o.append("code", t);
    for (const t of e)o.append("v", t);
    throw n.search = o.toString(), Error(`Minified Lexical error #${t}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
let $9429c8604db0efde$var$ot;
function $9429c8604db0efde$var$rt(t, e) {
    const { key: n } = e;
    return t && n in t ? t[n] : e.defaultValue;
}
function $9429c8604db0efde$var$st(t) {
    return $9429c8604db0efde$var$ot && $9429c8604db0efde$var$ot.editor === t ? $9429c8604db0efde$var$ot : void 0;
}
function $9429c8604db0efde$var$it(t, e) {
    const n = $9429c8604db0efde$var$st(e);
    return n && n[t];
}
function $9429c8604db0efde$var$ct(t, e) {
    if ("cfg" in e) {
        const { cfg: n, updater: o } = e;
        return [
            n,
            o($9429c8604db0efde$var$rt(t, n))
        ];
    }
    return e;
}
function $9429c8604db0efde$var$lt(t, e) {
    let n = e;
    for (const o of t){
        const [t, r] = $9429c8604db0efde$var$ct(n, o), s = t.key;
        if (n === e && $9429c8604db0efde$var$rt(n, t) === r) continue;
        const i = n === e || void 0 === n ? $9429c8604db0efde$var$ut(e) : n;
        i[s] = r, n = i;
    }
    return n;
}
function $9429c8604db0efde$var$ut(t) {
    return Object.create(t || null);
}
function $9429c8604db0efde$export$e229c5eb5ebef953(t, e) {
    return [
        t,
        e
    ];
}
function $9429c8604db0efde$export$67699216630a88e(t, e) {
    return {
        cfg: t,
        updater: e
    };
}
function $9429c8604db0efde$var$dt(t, n, o, r = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)()) {
    const s = $9429c8604db0efde$var$ot, i = $9429c8604db0efde$var$st(r);
    try {
        return $9429c8604db0efde$var$ot = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, i), {
            editor: r,
            [t]: n
        }), o();
    } finally{
        $9429c8604db0efde$var$ot = s;
    }
}
function $9429c8604db0efde$var$pt(t, n = ()=>{}) {
    return (o, r = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)())=>(e)=>{
            const s = $9429c8604db0efde$var$st(r), i = s && s[t], c = $9429c8604db0efde$var$lt(o, i || n(r));
            return c && c !== i ? $9429c8604db0efde$var$dt(t, c, e, r) : e();
        };
}
function $9429c8604db0efde$var$ht(t, e, o, r) {
    return Object.assign((0, $3e88191b87395c2e$export$e6a0daad8304de)(Symbol(e), {
        isEqual: r,
        parse: o
    }), {
        [t]: !0
    });
}
const $9429c8604db0efde$export$4d609331b390d6fb = (t, e, n)=>{
    $9429c8604db0efde$var$mt(t), n();
};
function $9429c8604db0efde$var$mt(t) {
    if (!(0, $3e88191b87395c2e$export$47ea8b9bb8a4c4de)(t)) return;
    const e = t;
    if (null === e.querySelector("style")) return;
    const n = new Map;
    function s(t) {
        let e = n.get(t);
        if (void 0 === e) {
            e = new Set;
            for(let n = 0; n < t.style.length; n++)e.add(t.style[n]);
            n.set(t, e);
        }
        return e;
    }
    try {
        for (const t of Array.from(e.styleSheets)){
            let n;
            try {
                n = t.cssRules;
            } catch (t) {
                continue;
            }
            for (const t of Array.from(n)){
                if (!(0, $74849711df60ce24$export$266ae88fb619dc2e)(t, CSSStyleRule)) continue;
                let n;
                try {
                    n = e.querySelectorAll(t.selectorText);
                } catch (t) {
                    continue;
                }
                for (const e of Array.from(n)){
                    if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e)) continue;
                    const n = s(e);
                    for(let o = 0; o < t.style.length; o++){
                        const r = t.style[o];
                        n.has(r) || e.style.setProperty(r, t.style.getPropertyValue(r), t.style.getPropertyPriority(r));
                    }
                }
            }
        }
    } catch (t) {}
}
const $9429c8604db0efde$var$yt = "@lexical/html/DOM", $9429c8604db0efde$var$xt = Symbol.for("@lexical/html/DOMExportContext"), $9429c8604db0efde$var$St = "@lexical/html/DOMImport", $9429c8604db0efde$var$$t = Symbol.for("@lexical/html/DOMImportContext"), $9429c8604db0efde$var$vt = ()=>!0;
function $9429c8604db0efde$export$b983e3c0ac720270(t, e, n) {
    return $9429c8604db0efde$var$ht($9429c8604db0efde$var$xt, t, e, n);
}
const $9429c8604db0efde$export$884776795aedda53 = /* @__PURE__ */ $9429c8604db0efde$export$b983e3c0ac720270("root", Boolean), $9429c8604db0efde$export$712391d230781d7c = /* @__PURE__ */ $9429c8604db0efde$export$b983e3c0ac720270("isExport", Boolean);
function $9429c8604db0efde$var$Dt(t) {
    const e = (0, $8ebc39becbfbdd8f$export$1a203010713403e8)(t, $9429c8604db0efde$var$yt);
    return e ? e.output.defaults : void 0;
}
function $9429c8604db0efde$export$930b8164491dae01(t, n = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)()) {
    return $9429c8604db0efde$var$rt(function(t) {
        return $9429c8604db0efde$var$it($9429c8604db0efde$var$xt, t) || $9429c8604db0efde$var$Dt(t);
    }(n), t);
}
function $9429c8604db0efde$var$Ot(t) {
    const e = (0, $8ebc39becbfbdd8f$export$1a203010713403e8)(t, $9429c8604db0efde$var$yt);
    return e ? e.output.runtime : void 0;
}
function $9429c8604db0efde$export$b941e38ceb015a4(t, n, o = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)()) {
    const r = $9429c8604db0efde$var$Ot(o);
    r && r.setContextValue(t, n);
}
function $9429c8604db0efde$export$74387c8b04e10633(t, n, o = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)()) {
    const r = $9429c8604db0efde$var$Ot(o);
    r && r.setContextValue(t, n($9429c8604db0efde$var$rt(r.editorContext, t)));
}
function $9429c8604db0efde$export$d340cbda52069b48(t = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)()) {
    const n = $9429c8604db0efde$var$Ot(t);
    return n ? n.getSessionConfig() : (0, $3e88191b87395c2e$export$cee5aec8bb4a87d6)(t);
}
const $9429c8604db0efde$export$9d733c3bbdb5e086 = $9429c8604db0efde$var$pt($9429c8604db0efde$var$xt, $9429c8604db0efde$var$Dt);
function $9429c8604db0efde$export$7d2ca9747d6cabdc(t, e, n) {
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, e, n), {
        nodes: t
    });
}
function $9429c8604db0efde$var$Wt(t) {
    return (e)=>e instanceof t;
}
function $9429c8604db0efde$var$Rt(t, { nodes: e }) {
    if ("*" === e) return $9429c8604db0efde$var$vt;
    let n = {};
    const o = [];
    for (const r of e)if ("getType" in r) {
        const e = r.getType();
        if (n) {
            const o = t.get(e);
            void 0 === o && $9429c8604db0efde$var$nt(339, r.name, e);
            for (const t of o)n[t] = !0;
        }
        o.push($9429c8604db0efde$var$Wt(r));
    } else n = void 0, o.push(r);
    return n || (1 === o.length ? o[0] : (t)=>{
        for (const e of o)if (e(t)) return !0;
        return !1;
    });
}
function $9429c8604db0efde$var$Ft(t) {
    return (e, n, o)=>t(e, o);
}
function $9429c8604db0efde$var$Tt(t) {
    return (e, n, o, r)=>t(e, n, r);
}
function $9429c8604db0efde$var$Pt(t) {
    return (e, n, o, r, s)=>t(e, n, o, s);
}
function $9429c8604db0efde$var$jt(t) {
    return (e, n, o, r, s, i)=>t(e, n, o, r, i);
}
function $9429c8604db0efde$var$zt(t, e) {
    return (n, o)=>{
        const r = ()=>t(n, o), s = e(n);
        return s ? s(n, r, o) : r();
    };
}
function $9429c8604db0efde$var$_t(t, e) {
    return (n, o, r)=>{
        const s = ()=>t(n, o, r), i = e(n);
        return i ? i(n, o, s, r) : s();
    };
}
const $9429c8604db0efde$var$Lt = $9429c8604db0efde$var$_t, $9429c8604db0efde$var$Ut = $9429c8604db0efde$var$Tt;
function $9429c8604db0efde$var$Bt(t, e) {
    return (n, o, r, s)=>{
        const i = ()=>t(n, o, r, s), c = e(n);
        return c ? c(n, o, r, i, s) : i();
    };
}
function $9429c8604db0efde$var$Vt(t, e) {
    return (n, o, r, s, i)=>{
        const c = ()=>t(n, o, r, s, i), l = e(n);
        return l ? l(n, o, r, s, c, i) : c();
    };
}
function $9429c8604db0efde$var$qt(t, e) {
    return (n, o, r, s)=>{
        t(n, o, r, s);
        const i = e(n);
        i && i(n, o, r, s);
    };
}
function $9429c8604db0efde$var$Gt(t, e, n, o, r) {
    let s = n[e];
    for (const n of t[e])if ("function" == typeof n[0]) {
        const [t, e] = n;
        s = o(s, (n)=>t(n) && e || void 0);
    } else {
        const t = n[1], e = {};
        for(const n in t){
            const r = t[n];
            r && (e[n] = r.reduce((t, e)=>o(t, ()=>e), s));
        }
        s = o(s, (t)=>{
            const n = e[t.getType()];
            return n && r(n);
        });
    }
    n[e] = s;
}
function $9429c8604db0efde$var$Ht(t, e, n, o) {
    if (!o) return;
    const r = t[e];
    if ("function" == typeof n) r.push([
        n,
        o
    ]);
    else {
        const t = r[r.length - 1];
        let e;
        t && "types" === t[0] ? e = t[1] : (e = {}, r.push([
            "types",
            e
        ]));
        for(const t in n){
            const n = e[t] || [];
            e[t] = n, n.push(o);
        }
    }
}
function $9429c8604db0efde$var$Jt(t) {
    return "*" === t.nodes;
}
function $9429c8604db0efde$var$Qt(t, e) {
    const n = (0, $3e88191b87395c2e$export$178ba1ee8bfc8fa1)((0, $8ebc39becbfbdd8f$export$c25a0876f35f253e)(t).nodes), o = {
        $createDOM: [],
        $decorateDOM: [],
        $exportDOM: [],
        $extractWithChild: [],
        $getDOMSlot: [],
        $getSlotTargetElement: [],
        $shouldExclude: [],
        $shouldInclude: [],
        $updateDOM: []
    };
    for (const t of function(t) {
        const e = [], n = [], o = [];
        for (const r of t)if ($9429c8604db0efde$var$Jt(r)) e.push(r);
        else if (Array.isArray(r.nodes)) for (const t of r.nodes)(0, $3e88191b87395c2e$export$51639c096d96bcc8)(t.prototype) ? o.push(1 === r.nodes.length ? r : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, r), {
            nodes: [
                t
            ]
        })) : n.push(1 === r.nodes.length ? r : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, r), {
            nodes: [
                t
            ]
        }));
        const r = new Map, s = (t)=>{
            let e = r.get(t);
            if (void 0 === e) {
                e = -1;
                for (const n of (0, $3e88191b87395c2e$export$9f01219fd9911d4c)(t))e++;
                r.set(t, e);
            }
            return e;
        };
        return o.sort((t, e)=>s(t.nodes[0]) - s(e.nodes[0])), [
            ...o,
            ...n,
            ...e
        ];
    }(e)){
        const e = $9429c8604db0efde$var$Rt(n, t);
        for(const n in o)$9429c8604db0efde$var$Ht(o, n, e, t[n]);
    }
    return o;
}
function $9429c8604db0efde$var$Kt(t) {
    return t;
}
function $9429c8604db0efde$var$Yt(t, { overrides: e }) {
    const n = $9429c8604db0efde$var$Qt(t, e), o = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $3e88191b87395c2e$export$1d0bbaf021f5def1), t.dom);
    return $9429c8604db0efde$var$Gt(n, "$createDOM", o, $9429c8604db0efde$var$zt, $9429c8604db0efde$var$Ft), $9429c8604db0efde$var$Gt(n, "$exportDOM", o, $9429c8604db0efde$var$zt, $9429c8604db0efde$var$Ft), $9429c8604db0efde$var$Gt(n, "$extractWithChild", o, $9429c8604db0efde$var$Vt, $9429c8604db0efde$var$jt), $9429c8604db0efde$var$Gt(n, "$getDOMSlot", o, $9429c8604db0efde$var$Lt, $9429c8604db0efde$var$Ut), $9429c8604db0efde$var$Gt(n, "$shouldExclude", o, $9429c8604db0efde$var$_t, $9429c8604db0efde$var$Tt), $9429c8604db0efde$var$Gt(n, "$shouldInclude", o, $9429c8604db0efde$var$_t, $9429c8604db0efde$var$Tt), $9429c8604db0efde$var$Gt(n, "$getSlotTargetElement", o, $9429c8604db0efde$var$Bt, $9429c8604db0efde$var$Pt), $9429c8604db0efde$var$Gt(n, "$updateDOM", o, $9429c8604db0efde$var$Bt, $9429c8604db0efde$var$Pt), $9429c8604db0efde$var$Gt(n, "$decorateDOM", o, $9429c8604db0efde$var$qt, $9429c8604db0efde$var$Kt), o;
}
function $9429c8604db0efde$var$Zt(t) {
    return {
        get: (e)=>$9429c8604db0efde$var$rt(t, e)
    };
}
function $9429c8604db0efde$var$Xt(t) {
    const e = Object.create(null);
    return $9429c8604db0efde$var$lt(t, e) || e;
}
function $9429c8604db0efde$var$te(t, e) {
    const n = $9429c8604db0efde$var$Zt(e);
    return t.filter((t)=>!(t.disabledForEditor && t.disabledForEditor(n)));
}
function $9429c8604db0efde$var$ee(t) {
    if ("*" === t.nodes) return ()=>!0;
    const e = t.nodes.map((t)=>{
        const e = t;
        return (0, $3e88191b87395c2e$export$51639c096d96bcc8)(e.prototype) ? (t)=>t instanceof e : t;
    });
    return (t)=>e.some((e)=>e(t));
}
class $9429c8604db0efde$var$ne {
    setContextValue(t, e) {
        const n = this.installed;
        this.editorContext[t.key] = e;
        const o = $9429c8604db0efde$var$te(this.overrides, this.editorContext);
        if (function(t, e) {
            if (t.length !== e.length) return !1;
            for(let n = 0; n < t.length; n++)if (t[n] !== e[n]) return !1;
            return !0;
        }(n, o)) return;
        const r = function(t, e) {
            const n = new Set(t), o = new Set(e), r = [];
            for (const e of t)o.has(e) || r.push(e);
            for (const t of e)n.has(t) || r.push(t);
            return r;
        }(n, o);
        this.installed = o, this.sessionCache.clear();
        const s = $9429c8604db0efde$var$Yt(this.initialEditorConfig, {
            overrides: o
        });
        this.editor._config.dom = s;
        const i = function(t) {
            const e = [];
            for (const n of t)(n.$createDOM || n.$getDOMSlot || n.$decorateDOM) && e.push($9429c8604db0efde$var$ee(n));
            return 0 === e.length ? null : (t)=>e.some((e)=>e(t));
        }(r);
        if (!i) return;
        const c = s.$updateDOM;
        s.$updateDOM = (t, e, n, o)=>!!i(t) || c(t, e, n, o), this.editor.update((0, $3e88191b87395c2e$export$d05b7cf3bb138003), {
            discrete: !0
        }), s.$updateDOM = c;
    }
    getSessionConfig() {
        const t = this.editor._config.dom || (0, $3e88191b87395c2e$export$1d0bbaf021f5def1);
        if (!this.hasSessionGates) return t;
        const e = $9429c8604db0efde$var$Zt($9429c8604db0efde$var$it($9429c8604db0efde$var$xt, this.editor) || this.editorContext), n = [], o = [];
        if (this.installed.forEach((t, r)=>{
            t.disabledForSession && t.disabledForSession(e) ? n.push(String(r)) : o.push(t);
        }), 0 === n.length) return t;
        const r = n.join(",");
        let s = this.sessionCache.get(r);
        return s || (s = $9429c8604db0efde$var$Yt(this.initialEditorConfig, {
            overrides: o
        }), this.sessionCache.set(r, s)), s;
    }
    constructor(t, e, n, o){
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "editor", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "initialEditorConfig", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "overrides", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "editorContext", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "hasSessionGates", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "installed", void 0);
        (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "sessionCache", new Map);
        this.editor = t, this.initialEditorConfig = e, this.overrides = n, this.editorContext = o, this.installed = $9429c8604db0efde$var$te(n, o), this.hasSessionGates = n.some((t)=>t.disabledForSession);
    }
}
const $9429c8604db0efde$export$71bcb87d515111e0 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build (t, e, n) {
        const { initialEditorConfig: o } = n.getInitResult(), r = $9429c8604db0efde$var$Xt(e.contextDefaults);
        return {
            defaults: r,
            runtime: new $9429c8604db0efde$var$ne(t, o, e.overrides, r)
        };
    },
    config: {
        contextDefaults: [],
        overrides: []
    },
    html: {
        export: new Map([
            [
                (0, $3e88191b87395c2e$export$1c180cb67301903c),
                ()=>{
                    const t = (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("div");
                    return t.role = "textbox", {
                        element: t
                    };
                }
            ]
        ])
    },
    init (t, e) {
        const n = {
            dom: t.dom,
            nodes: t.nodes
        }, o = $9429c8604db0efde$var$Xt(e.contextDefaults), r = $9429c8604db0efde$var$te(e.overrides, o);
        return t.dom = $9429c8604db0efde$var$Yt(t, {
            overrides: r
        }), {
            initialEditorConfig: n
        };
    },
    mergeConfig (t, e) {
        const n = (0, $3e88191b87395c2e$export$89e5ee996f4118)(t, e);
        for (const o of [
            "overrides",
            "contextDefaults"
        ])e[o] && (n[o] = [
            ...t[o],
            ...e[o]
        ]);
        return n;
    },
    name: $9429c8604db0efde$var$yt
}), $9429c8604db0efde$var$re = Symbol.for("@lexical/html/SelectorImpl");
function $9429c8604db0efde$var$se(t, e) {
    const n = {
        kind: "element",
        predicate: (o = e, 0 === o.length ? (0, $3e88191b87395c2e$export$1b3bfaa9684536aa) : 1 === o.length ? o[0] : (t, e)=>{
            for (const n of o)if (!n(t, e)) return !1;
            return !0;
        }),
        tags: t
    };
    var o;
    const s = (n)=>$9429c8604db0efde$var$se(t, [
            ...e,
            n
        ]);
    return {
        [$9429c8604db0efde$var$re]: n,
        attr: (t, e, n)=>s($9429c8604db0efde$var$le(t, e, n)),
        classAll: (...t)=>s($9429c8604db0efde$var$ce(t)),
        classAny: (...t)=>s(function(t) {
                const e = $9429c8604db0efde$var$ie(t);
                if (0 === e.length) return ()=>!1;
                return (t)=>{
                    if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t)) return !1;
                    const n = t.classList;
                    for (const t of e)if (n.contains(t)) return !0;
                    return !1;
                };
            }(t)),
        styleAny: (t, e, n)=>s(function(t, e, n) {
                if ("string" == typeof e) return (n)=>(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(n) && n.style.getPropertyValue(t) === e;
                if (e instanceof RegExp) {
                    const o = n && n.capture, s = e;
                    return (e, n)=>{
                        if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e)) return !1;
                        const i = e.style.getPropertyValue(t);
                        if (!i) return !1;
                        const c = i.match(s);
                        return null !== c && (void 0 !== o && (n[o] = c), !0);
                    };
                }
                $9429c8604db0efde$var$nt(362, JSON.stringify(t));
            }(t, e, n))
    };
}
function $9429c8604db0efde$var$ie(t) {
    const e = [];
    for (const n of t)n && e.push(n);
    return e;
}
function $9429c8604db0efde$var$ce(t) {
    const e = $9429c8604db0efde$var$ie(t);
    return 0 === e.length ? ()=>!0 : (t)=>{
        if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t)) return !1;
        const n = t.classList;
        for (const t of e)if (!n.contains(t)) return !1;
        return !0;
    };
}
function $9429c8604db0efde$var$le(t, e, n) {
    if (!0 === e) return (e)=>(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e) && e.hasAttribute(t);
    if ("string" == typeof e) return (n)=>(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(n) && n.getAttribute(t) === e;
    if (e instanceof RegExp) {
        const o = n && n.capture, s = e;
        return (e, n)=>{
            if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e)) return !1;
            const i = e.getAttribute(t);
            if (null == i) return !1;
            const c = i.match(s);
            return null !== c && (void 0 !== o && (n[o] = c), !0);
        };
    }
    $9429c8604db0efde$var$nt(361, JSON.stringify(t));
}
const $9429c8604db0efde$var$ue = {
    kind: "text",
    predicate: (0, $3e88191b87395c2e$export$4295c0f0b9b754c4),
    tags: new Set
}, $9429c8604db0efde$var$fe = {
    [$9429c8604db0efde$var$re]: $9429c8604db0efde$var$ue
}, $9429c8604db0efde$var$ae = {
    kind: "comment",
    predicate: (t)=>8 === t.nodeType,
    tags: new Set
}, $9429c8604db0efde$var$de = {
    [$9429c8604db0efde$var$re]: $9429c8604db0efde$var$ae
}, $9429c8604db0efde$var$pe = {
    any: ()=>$9429c8604db0efde$var$se(new Set, []),
    comment: ()=>$9429c8604db0efde$var$de,
    tag (...t) {
        t.length > 0 || $9429c8604db0efde$var$nt(363);
        const e = new Set;
        for (const n of t)e.add(n.toUpperCase());
        return $9429c8604db0efde$var$se(e, []);
    },
    text: ()=>$9429c8604db0efde$var$fe
};
function $9429c8604db0efde$export$a880ba0163847a11(t, e) {
    return (0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t) && t.nodeName === e.toUpperCase();
}
const $9429c8604db0efde$var$ge = /[A-Za-z0-9_-]/;
class $9429c8604db0efde$var$me {
    peek(t = 0) {
        return this.source[this.pos + t] || "";
    }
    consume() {
        return this.source[this.pos++] || "";
    }
    eof() {
        return this.pos >= this.source.length;
    }
    skipWhitespace() {
        for(; !this.eof() && /\s/.test(this.peek());)this.pos++;
    }
    readIdent() {
        const t = this.pos;
        for(; !this.eof() && $9429c8604db0efde$var$ge.test(this.peek());)this.pos++;
        return this.source.slice(t, this.pos);
    }
    readQuoted() {
        const t = this.consume();
        this.assert('"' === t || "'" === t, "expected quote");
        const e = this.pos;
        for(; !this.eof() && this.peek() !== t;)"\\" === this.peek() ? this.pos += 2 : this.pos++;
        this.assert(!this.eof(), "unterminated string");
        const n = this.source.slice(e, this.pos);
        return this.pos++, n.replace(/\\(.)/g, "$1");
    }
    assert(t, e) {
        t || $9429c8604db0efde$var$nt(364, String(this.pos + 1), e, this.source);
    }
    constructor(t, e){
        this.source = t, this.pos = e;
    }
}
function $9429c8604db0efde$var$ye(t) {
    const e = new Set, n = [], o = [];
    if (t.skipWhitespace(), "*" === t.peek()) t.consume();
    else if ($9429c8604db0efde$var$ge.test(t.peek())) {
        const n = t.readIdent();
        n && e.add(n.toUpperCase());
    }
    for(; !t.eof();){
        const e = t.peek();
        if ("." === e) {
            t.consume();
            const e = t.readIdent();
            t.assert("" !== e, 'expected class name after "."'), o.push(e);
        } else if ("#" === e) {
            t.consume();
            const e = t.readIdent();
            t.assert("" !== e, 'expected id after "#"'), n.push($9429c8604db0efde$var$le("id", e));
        } else {
            if ("[" !== e) break;
            {
                t.consume(), t.skipWhitespace();
                const e = t.readIdent();
                t.assert("" !== e, 'expected attribute name after "["'), t.skipWhitespace();
                let o = !0;
                if ("=" === t.peek()) {
                    t.consume(), t.skipWhitespace();
                    const e = t.peek();
                    '"' === e || "'" === e ? o = t.readQuoted() : (o = t.readIdent(), t.assert("" !== o, "expected attribute value")), t.skipWhitespace();
                }
                t.assert("]" === t.peek(), 'expected "]"'), t.consume(), n.push($9429c8604db0efde$var$le(e, o));
            }
        }
    }
    return o.length > 0 && n.push($9429c8604db0efde$var$ce(o)), {
        predicates: n,
        tags: e
    };
}
function $9429c8604db0efde$export$529769e360e2fa1b(t) {
    const e = new $9429c8604db0efde$var$me(t, 0), n = [];
    for(;;){
        const t = $9429c8604db0efde$var$ye(e);
        if (n.push(t), e.skipWhitespace(), e.eof()) break;
        e.assert("," === e.peek(), 'expected "," (selector lists are the only supported combinator)'), e.consume(), e.skipWhitespace();
    }
    if (1 === n.length) return $9429c8604db0efde$var$se(n[0].tags, n[0].predicates);
    const o = new Set;
    for (const t of n)for (const e of t.tags)o.add(e);
    return $9429c8604db0efde$var$se(o, [
        (t, e)=>{
            for (const o of n){
                const n = t.nodeName;
                if (o.tags.size > 0 && !o.tags.has(n)) continue;
                let r = !0;
                for (const n of o.predicates)if (!n(t, e)) {
                    r = !1;
                    break;
                }
                if (r) return !0;
            }
            return !1;
        }
    ]);
}
function $9429c8604db0efde$export$253e266dc39d6fc7(t) {
    return t;
}
function $9429c8604db0efde$export$6b7fef8e45d97dbe(t, e, n) {
    return $9429c8604db0efde$var$ht($9429c8604db0efde$var$$t, t, e, n);
}
const $9429c8604db0efde$export$ddc693d0d8207b4d = /* @__PURE__ */ $9429c8604db0efde$export$6b7fef8e45d97dbe("importSource", ()=>"unknown"), $9429c8604db0efde$export$f6c637823756da1e = /* @__PURE__ */ $9429c8604db0efde$export$6b7fef8e45d97dbe("importSourceDataTransfer", ()=>null), $9429c8604db0efde$export$5718ea8abc9cd88d = /* @__PURE__ */ $9429c8604db0efde$export$6b7fef8e45d97dbe("textFormat", ()=>0), $9429c8604db0efde$export$19d8f6484003eaea = /* @__PURE__ */ $9429c8604db0efde$export$6b7fef8e45d97dbe("textStyle", ()=>({}));
function $9429c8604db0efde$export$457a8e5c5d61f37e(t) {
    if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t)) return !1;
    if ("PRE" === t.nodeName) return !0;
    const e = t.style.whiteSpace;
    return "string" == typeof e && e.startsWith("pre");
}
function $9429c8604db0efde$export$e4cab1b6bcd02694(t) {
    if ((0, $3e88191b87395c2e$export$4295c0f0b9b754c4)(t)) return !0;
    if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t)) return !1;
    const e = t.style.display;
    return e ? e.startsWith("inline") : !(0, $3e88191b87395c2e$export$5ef1a5ca687c7168)(t) && (0, $3e88191b87395c2e$export$456fd4e5e0a7123d)(t);
}
const $9429c8604db0efde$export$dfc8b60963d14256 = /* @__PURE__ */ $9429c8604db0efde$export$6b7fef8e45d97dbe("whitespaceConfig", ()=>({
        isInline: $9429c8604db0efde$export$e4cab1b6bcd02694,
        preservesWhitespace: $9429c8604db0efde$export$457a8e5c5d61f37e
    })), $9429c8604db0efde$export$3c70da50d675b4f6 = /* @__PURE__ */ $9429c8604db0efde$export$6b7fef8e45d97dbe("importOverlays", ()=>[]);
class $9429c8604db0efde$var$Ae {
    get(t) {
        return $9429c8604db0efde$var$rt(this.record, t);
    }
    set(t, e) {
        this.record[t.key] = e;
    }
    update(t, e) {
        this.record[t.key] = e($9429c8604db0efde$var$rt(this.record, t));
    }
    has(t) {
        return Object.prototype.hasOwnProperty.call(this.record, t.key);
    }
    constructor(t){
        this.record = t;
    }
}
function $9429c8604db0efde$var$Ne(t) {
    const e = (0, $8ebc39becbfbdd8f$export$1a203010713403e8)(t, $9429c8604db0efde$var$St);
    return e ? e.output.defaults : void 0;
}
function $9429c8604db0efde$export$85e31ed901e790f9(t, n = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)()) {
    return $9429c8604db0efde$var$rt(function(t) {
        return $9429c8604db0efde$var$it($9429c8604db0efde$var$$t, t) || $9429c8604db0efde$var$Ne(t);
    }(n), t);
}
const $9429c8604db0efde$export$27d8d059176782e9 = $9429c8604db0efde$var$pt($9429c8604db0efde$var$$t, $9429c8604db0efde$var$Ne);
function $9429c8604db0efde$export$1caaca6642bf331(t) {
    return (0, $3e88191b87395c2e$export$de078facd4ee1560)(t) || (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(t) && !t.isInline();
}
function $9429c8604db0efde$export$bf3be9b07cad8971(t, e) {
    const n = [];
    let o = [];
    const r = ()=>{
        0 !== o.length && (n.push(e().splice(0, 0, o)), o = []);
    };
    for (const s of t)if ($9429c8604db0efde$export$1caaca6642bf331(s)) {
        if (r(), (0, $3e88191b87395c2e$export$923a058ef54437a4)(s)) {
            const t = $9429c8604db0efde$export$bf3be9b07cad8971(s.getChildren(), e);
            s.splice(0, s.getChildrenSize(), t);
        }
        n.push(s);
    } else o.push(s);
    return r(), n;
}
function $9429c8604db0efde$export$92c6602761cff598(t, e) {
    if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e)) return t;
    const n = e.style.textAlign;
    if (!$9429c8604db0efde$var$Be(n)) return t;
    for (const e of t)(0, $3e88191b87395c2e$export$de078facd4ee1560)(e) && "" === e.getFormatType() && e.setFormat(n);
    return t;
}
function $9429c8604db0efde$var$Te(t, e, n) {
    1 === t.length && (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(t[0]) && (t = []);
    const o = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
    if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(n)) {
        const t = n.style.textAlign;
        $9429c8604db0efde$var$Be(t) && o.setFormat(t);
    }
    return [
        o.splice(0, 0, t)
    ];
}
const $9429c8604db0efde$export$c7a367a70264b348 = {
    $accepts: $9429c8604db0efde$export$1caaca6642bf331,
    $packageRun: $9429c8604db0efde$var$Te,
    name: "BlockSchema"
}, $9429c8604db0efde$export$d52ffb988b3afd39 = {
    $accepts: (t)=>!$9429c8604db0efde$export$1caaca6642bf331(t),
    name: "InlineSchema"
}, $9429c8604db0efde$export$ff0f3ad534ae33d5 = {
    $accepts: $9429c8604db0efde$export$1caaca6642bf331,
    $packageRun: (t)=>t,
    name: "NestedBlockSchema"
}, $9429c8604db0efde$export$749067fe59d5814a = {
    $accepts: $9429c8604db0efde$export$1caaca6642bf331,
    $packageRun: $9429c8604db0efde$var$Te,
    name: "RootSchema"
}, $9429c8604db0efde$var$Le = $9429c8604db0efde$var$pe, $9429c8604db0efde$var$Ue = new Set([
    "center",
    "end",
    "justify",
    "left",
    "right",
    "start"
]);
function $9429c8604db0efde$var$Be(t) {
    return $9429c8604db0efde$var$Ue.has(t);
}
const $9429c8604db0efde$var$Ve = {
    B: {
        fontWeight: "bold"
    },
    EM: {
        fontStyle: "italic"
    },
    I: {
        fontStyle: "italic"
    },
    S: {
        textDecoration: "line-through"
    },
    STRONG: {
        fontWeight: "bold"
    },
    SUB: {
        verticalAlign: "sub"
    },
    SUP: {
        verticalAlign: "super"
    },
    U: {
        textDecoration: "underline"
    }
}, $9429c8604db0efde$var$qe = {
    CODE: (0, $3e88191b87395c2e$export$bf809f2b03ed57cc),
    MARK: (0, $3e88191b87395c2e$export$f1e9b55cdd671814)
};
const $9429c8604db0efde$var$Ge = new Set([
    "font-weight",
    "font-style",
    "text-decoration",
    "vertical-align"
]);
const $9429c8604db0efde$var$He = /* @__PURE__ */ $9429c8604db0efde$export$253e266dc39d6fc7({
    $import: (t, e)=>{
        const n = t.get($9429c8604db0efde$export$5718ea8abc9cd88d), o = $9429c8604db0efde$var$Ve[e.nodeName], r = function(t) {
            return {
                fontStyle: t.style.fontStyle,
                fontWeight: t.style.fontWeight,
                textDecoration: t.style.textDecoration,
                verticalAlign: t.style.verticalAlign
            };
        }(e), s = o ? (i = o, {
            fontStyle: (c = r).fontStyle || i.fontStyle,
            fontWeight: c.fontWeight || i.fontWeight,
            textDecoration: c.textDecoration || i.textDecoration,
            verticalAlign: c.verticalAlign || i.verticalAlign
        }) : r;
        var i, c;
        let l = (u = n, f = function(t) {
            let e = 0, n = 0;
            const { fontWeight: o, fontStyle: r, textDecoration: s, verticalAlign: i } = t;
            if ("700" === o || "bold" === o ? e |= (0, $3e88191b87395c2e$export$d401051135d8c941) : "normal" !== o && "400" !== o || (n |= (0, $3e88191b87395c2e$export$d401051135d8c941)), "italic" === r ? e |= (0, $3e88191b87395c2e$export$6f537bdfcfab164) : "normal" === r && (n |= (0, $3e88191b87395c2e$export$6f537bdfcfab164)), s) {
                const t = s.split(" ");
                t.includes("underline") && (e |= (0, $3e88191b87395c2e$export$4fefe1576f07e925)), t.includes("line-through") && (e |= (0, $3e88191b87395c2e$export$27809404dee18444)), t.includes("none") && (n |= (0, $3e88191b87395c2e$export$4fefe1576f07e925) | (0, $3e88191b87395c2e$export$27809404dee18444));
            }
            return "sub" === i ? (e |= (0, $3e88191b87395c2e$export$22c32c29c50da53a), n |= (0, $3e88191b87395c2e$export$703b9afdf8723203)) : "super" === i ? (e |= (0, $3e88191b87395c2e$export$703b9afdf8723203), n |= (0, $3e88191b87395c2e$export$22c32c29c50da53a)) : "baseline" === i && (n |= (0, $3e88191b87395c2e$export$22c32c29c50da53a) | (0, $3e88191b87395c2e$export$703b9afdf8723203)), {
                clear: n,
                set: e
            };
        }(s), u & ~f.clear | f.set);
        var u, f;
        const a = $9429c8604db0efde$var$qe[e.nodeName];
        return a && (l |= a), l === n ? t.$importChildren(e) : t.$importChildren(e, {
            context: [
                $9429c8604db0efde$export$e229c5eb5ebef953($9429c8604db0efde$export$5718ea8abc9cd88d, l)
            ]
        });
    },
    match: $9429c8604db0efde$var$Le.tag("b", "strong", "em", "i", "code", "mark", "s", "sub", "sup", "u", "span"),
    name: "@lexical/html/inline-format"
});
function $9429c8604db0efde$var$Je(t, e, n) {
    let o = t;
    for(;;){
        let t = null;
        for(; null === (t = e ? o.nextSibling : o.previousSibling);){
            const t = o.parentNode;
            if (null === t) return null;
            o = t;
        }
        if (o = t, !n.isInline(o)) return null;
        let r = o;
        for(; null !== (r = e ? o.firstChild : o.lastChild);)o = r;
        if ((0, $3e88191b87395c2e$export$4295c0f0b9b754c4)(o)) return o;
        if ("BR" === o.nodeName) return null;
    }
}
function $9429c8604db0efde$var$Qe(t, e) {
    return 0 !== e && (0, $3e88191b87395c2e$export$471953706258be2b)(t) ? t.setFormat(e) : t;
}
function $9429c8604db0efde$var$Ke(t, e) {
    if ((0, $3e88191b87395c2e$export$471953706258be2b)(t)) {
        const n = function(t) {
            let e = "";
            for(const n in t)$9429c8604db0efde$var$Ge.has(n) || (e += `${n}: ${t[n]}; `);
            return e.trimEnd();
        }(e);
        "" !== n && t.setStyle(n);
    }
    return t;
}
const $9429c8604db0efde$var$Ye = /* @__PURE__ */ $9429c8604db0efde$export$253e266dc39d6fc7({
    $import: (t, e)=>{
        const n = t.get($9429c8604db0efde$export$5718ea8abc9cd88d), o = t.get($9429c8604db0efde$export$19d8f6484003eaea), r = t.get($9429c8604db0efde$export$dfc8b60963d14256);
        if (function(t, e) {
            let n = t.parentNode;
            for(; null !== n;){
                if (e.preservesWhitespace(n)) return !0;
                n = n.parentNode;
            }
            return !1;
        }(e, r)) {
            const t = (0, $3e88191b87395c2e$export$34f16fe1ef81eac4)(e.textContent || "");
            for (const e of t)$9429c8604db0efde$var$Qe(e, n), $9429c8604db0efde$var$Ke(e, o);
            return t;
        }
        const s = function(t, e) {
            let n = (t.textContent || "").replace(/\r/g, "").replace(/[ \t\n]+/g, " ");
            if (0 === n.length) return "";
            if (" " === n[0]) {
                let o = t, r = !0;
                for(; null !== o && null !== (o = $9429c8604db0efde$var$Je(o, !1, e));){
                    const t = o.textContent || "";
                    if (t.length > 0) {
                        /[ \t\n]$/.test(t) && (n = n.slice(1)), r = !1;
                        break;
                    }
                }
                r && (n = n.slice(1));
            }
            if (n.length > 0 && " " === n[n.length - 1]) {
                let o = t, r = !0;
                for(; null !== o && null !== (o = $9429c8604db0efde$var$Je(o, !0, e));)if ((o.textContent || "").replace(/^( |\t|\r?\n)+/, "").length > 0) {
                    r = !1;
                    break;
                }
                r && (n = n.slice(0, -1));
            }
            return n;
        }(e, r);
        if ("" === s) return [];
        const i = (0, $3e88191b87395c2e$export$2785f39dcdec0078)(s);
        return $9429c8604db0efde$var$Qe(i, n), $9429c8604db0efde$var$Ke(i, o), [
            i
        ];
    },
    match: $9429c8604db0efde$var$Le.text(),
    name: "@lexical/html/#text"
}), $9429c8604db0efde$var$Ze = /* @__PURE__ */ $9429c8604db0efde$export$253e266dc39d6fc7({
    $import: ()=>[],
    match: $9429c8604db0efde$var$Le.tag("script", "style"),
    name: "@lexical/html/script-style-ignore"
}), $9429c8604db0efde$var$Xe = /* @__PURE__ */ $9429c8604db0efde$export$253e266dc39d6fc7({
    $import: (t, e)=>(0, $3e88191b87395c2e$export$1f569a676de9fb13)(e) || (0, $3e88191b87395c2e$export$a9cc11da6f64f6a1)(e) ? [] : [
            (0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)()
        ],
    match: $9429c8604db0efde$var$Le.tag("br"),
    name: "@lexical/html/br"
}), $9429c8604db0efde$var$tn = /* @__PURE__ */ $9429c8604db0efde$export$253e266dc39d6fc7({
    $import: (t, e)=>{
        const n = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
        if ((0, $3e88191b87395c2e$export$b92488674c2048ea)(n, e), (0, $3e88191b87395c2e$export$bf56bccfeec66814)(e, n), "" === n.getFormatType()) {
            const t = e.getAttribute("align");
            t && $9429c8604db0efde$var$Be(t) && n.setFormat(t);
        }
        return (0, $3e88191b87395c2e$export$44a229cf8757fa56)(n, e), [
            n.splice(0, 0, t.$importChildren(e))
        ];
    },
    match: $9429c8604db0efde$var$Le.tag("p"),
    name: "@lexical/html/p"
}), $9429c8604db0efde$var$en = /* @__PURE__ */ $9429c8604db0efde$export$253e266dc39d6fc7({
    $import: (t, n, o)=>(0, $3e88191b87395c2e$export$8a7392c46faf1a3f)().hasNode((0, $8ebc39becbfbdd8f$export$e68cdf336f70c676)) ? [
            (0, $8ebc39becbfbdd8f$export$6fd365a92f1482f2)()
        ] : o(),
    match: $9429c8604db0efde$var$Le.tag("hr"),
    name: "@lexical/html/hr"
}), $9429c8604db0efde$export$c72c508877b8a7ca = [
    $9429c8604db0efde$var$Ze,
    $9429c8604db0efde$var$tn,
    $9429c8604db0efde$var$en,
    /* @__PURE__ */ $9429c8604db0efde$export$253e266dc39d6fc7({
        $import: (t, e, n)=>(0, $3e88191b87395c2e$export$5ef1a5ca687c7168)(e) ? $9429c8604db0efde$export$92c6602761cff598(t.$importChildren(e, {
                schema: $9429c8604db0efde$export$c7a367a70264b348
            }), e) : n(),
        match: $9429c8604db0efde$var$Le.any(),
        name: "@lexical/html/transparent-block"
    }),
    $9429c8604db0efde$var$Ye,
    $9429c8604db0efde$var$Xe,
    $9429c8604db0efde$var$He
];
function $9429c8604db0efde$var$on(t, e) {
    const n = [];
    let o = 0, r = 0;
    for(; o < t.length && r < e.length;)t[o] <= e[r] ? n.push(t[o++]) : n.push(e[r++]);
    for(; o < t.length;)n.push(t[o++]);
    for(; r < e.length;)n.push(e[r++]);
    return n;
}
function $9429c8604db0efde$var$rn(t) {
    const e = [], n = new Map, o = [], r = [], s = [], i = new Set;
    t.forEach((t, c)=>{
        const l = function(t) {
            const e = t[$9429c8604db0efde$var$re];
            return void 0 === e && $9429c8604db0efde$var$nt(360), e;
        }(t.match), u = t.name || function(t, e) {
            if ("text" === t.kind) return `#text@${e}`;
            if ("comment" === t.kind) return `#comment@${e}`;
            if (0 === t.tags.size) return `*@${e}`;
            const n = Array.from(t.tags).join(",").toLowerCase();
            return `${n}@${e}`;
        }(l, c);
        if (t.name && i.add(t.name), e.push({
            $import: t.$import,
            name: u,
            predicate: l.predicate
        }), "text" === l.kind) r.push(c);
        else if ("comment" === l.kind) s.push(c);
        else if (0 === l.tags.size) o.push(c);
        else for (const t of l.tags){
            let e = n.get(t);
            e || (e = [], n.set(t, e)), e.push(c);
        }
    });
    const c = new Map;
    if (0 === o.length) for (const [t, e] of n)c.set(t, e);
    else for (const [t, e] of n)c.set(t, $9429c8604db0efde$var$on(e, o));
    return {
        byTag: c,
        commentIndices: s,
        rules: e,
        textIndices: r,
        wildcardIndices: o
    };
}
function $9429c8604db0efde$var$sn(t, e) {
    return (0, $3e88191b87395c2e$export$4295c0f0b9b754c4)(e) ? t.textIndices : 8 === e.nodeType ? t.commentIndices : (0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e) ? t.byTag.get(e.nodeName) || t.wildcardIndices : $9429c8604db0efde$var$cn;
}
const $9429c8604db0efde$var$cn = Object.freeze([]);
function $9429c8604db0efde$var$ln(t) {
    const e = [];
    for (const n of t)if ($9429c8604db0efde$var$un(n)) for (const t of n.rules)e.push(t);
    else e.push(n);
    return e;
}
function $9429c8604db0efde$var$un(t) {
    return "object" == typeof t && null !== t && "__type" in t && "CompiledOverlayRules" === t.__type;
}
function $9429c8604db0efde$export$61d953550e16ba20(t) {
    const e = $9429c8604db0efde$var$ln(t);
    return {
        __type: "CompiledOverlayRules",
        dispatch: $9429c8604db0efde$var$rn(e),
        rules: e
    };
}
const $9429c8604db0efde$var$an = Object.freeze({});
function $9429c8604db0efde$var$dn(t, e) {
    const n = {
        $importChildren: (e, n)=>(function(t, e, n) {
                const o = n && n.rules ? n.rules.dispatch : void 0;
                o && t.overlays.push(o);
                try {
                    const o = ()=>$9429c8604db0efde$var$pn(t, e, n);
                    return n && n.context ? $9429c8604db0efde$export$27d8d059176782e9(n.context, t.editor)(o) : o();
                } finally{
                    o && t.overlays.pop();
                }
            })(t, e, n),
        $importOne: (e, n)=>$9429c8604db0efde$var$hn(t, e, n),
        captures: e,
        get: (e)=>$9429c8604db0efde$export$85e31ed901e790f9(e, t.editor),
        session: t.session
    };
    return n;
}
function $9429c8604db0efde$var$pn(t, e, n) {
    const o = n && n.$onChild, r = [];
    for (const n of Array.from(e.childNodes)){
        const e = $9429c8604db0efde$var$hn(t, n, void 0);
        for (const t of e){
            const e = o ? o(t) : t;
            null != e && r.push(e);
        }
    }
    const s = n && n.$after ? n.$after(r) : r, i = n && n.schema;
    return i ? function(t, e, n, o) {
        const r = [];
        let s = null;
        const i = ()=>{
            if (null === s) return;
            const e = s;
            if (s = null, t.$packageRun) {
                const s = t.$packageRun(e, n, o);
                if (s.length > 0) {
                    for (const t of s)r.push(t);
                    return;
                }
            }
            if ("hoist" === t.onReject) for (const t of e)r.push(t);
        };
        for (const o of e)t.$accepts(o, n) ? (i(), r.push(o)) : (null === s && (s = []), s.push(o));
        return i(), t.$finalize ? t.$finalize(r, n) : r;
    }(i, s, null, e) : s;
}
function $9429c8604db0efde$var$hn(t, e, n) {
    const o = ()=>(function(t, e) {
            const n = function(t, e) {
                const n = [];
                for(let o = t.overlays.length - 1; o >= 0; o--){
                    const r = t.overlays[o], s = $9429c8604db0efde$var$sn(r, e);
                    s.length > 0 && n.push({
                        dispatch: r,
                        indices: s
                    });
                }
                const o = $9429c8604db0efde$var$sn(t.dispatch, e);
                o.length > 0 && n.push({
                    dispatch: t.dispatch,
                    indices: o
                });
                return n;
            }(t, e);
            if (0 === n.length) return $9429c8604db0efde$var$gn(t, e);
            let o = 0, r = 0;
            const s = ()=>{
                for(; o < n.length;){
                    const { dispatch: i, indices: c } = n[o];
                    for(; r < c.length;){
                        const n = c[r++], o = i.rules[n], l = {};
                        if (o.predicate(e, l)) {
                            const n = $9429c8604db0efde$var$dn(t, 0 === Object.keys(l).length ? $9429c8604db0efde$var$an : l);
                            try {
                                return o.$import(n, e, s);
                            } catch (t) {
                                throw t;
                            }
                        }
                    }
                    o++, r = 0;
                }
                return $9429c8604db0efde$var$gn(t, e);
            };
            return s();
        })(t, e);
    return n && n.context ? $9429c8604db0efde$export$27d8d059176782e9(n.context, t.editor)(o) : o();
}
function $9429c8604db0efde$var$gn(t, e) {
    if (0 === e.childNodes.length) return [];
    const n = [];
    for (const o of Array.from(e.childNodes)){
        const e = $9429c8604db0efde$var$hn(t, o, void 0);
        for (const t of e)n.push(t);
    }
    return n;
}
const $9429c8604db0efde$var$mn = /* @__PURE__ */ $9429c8604db0efde$export$253e266dc39d6fc7({
    $import: (t, e)=>t.$importChildren(e),
    match: $9429c8604db0efde$var$pe.any(),
    name: "@lexical/html/default-hoist"
}), $9429c8604db0efde$export$a1ca1fda83454df7 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build (t, e) {
        const n = $9429c8604db0efde$var$rn($9429c8604db0efde$var$ln(e.rules)), r = $9429c8604db0efde$var$lt(e.contextDefaults, void 0), s = e.preprocess;
        return {
            $generateNodesFromDOM: (e, i)=>{
                const c = $9429c8604db0efde$var$it($9429c8604db0efde$var$$t, t) || r, l = i && i.context ? $9429c8604db0efde$var$lt(i.context, c) : c, u = void 0 !== l && l !== c ? l : Object.create(c || null), f = new $9429c8604db0efde$var$Ae(u), a = {
                    session: f
                };
                return function(t, e, n) {
                    let o = t.length - 1;
                    const r = ()=>{
                        for(; o >= 0;)return void (0, t[o--])(e, n, r);
                    };
                    r();
                }(i && i.preprocess ? [
                    ...s,
                    ...i.preprocess
                ] : s, e, a), $9429c8604db0efde$var$dt($9429c8604db0efde$var$$t, u, ()=>(function(t, e, n, r) {
                        return $9429c8604db0efde$var$pn({
                            dispatch: t,
                            editor: e,
                            overlays: r.get($9429c8604db0efde$export$3c70da50d675b4f6).map((t)=>t.dispatch),
                            session: r
                        }, (0, $3e88191b87395c2e$export$47ea8b9bb8a4c4de)(n) ? n.body : n, {
                            schema: $9429c8604db0efde$export$749067fe59d5814a
                        });
                    })(n, t, e, f), t);
            },
            defaults: r
        };
    },
    config: {
        contextDefaults: [],
        preprocess: [
            $9429c8604db0efde$export$4d609331b390d6fb
        ],
        rules: [
            $9429c8604db0efde$var$mn
        ]
    },
    mergeConfig: (t, e)=>(0, $3e88191b87395c2e$export$89e5ee996f4118)(t, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, e, e.contextDefaults && {
            contextDefaults: [
                ...t.contextDefaults,
                ...e.contextDefaults
            ]
        }, e.preprocess && {
            preprocess: [
                ...t.preprocess,
                ...e.preprocess
            ]
        }, e.rules && {
            rules: [
                ...e.rules,
                ...t.rules
            ]
        })),
    name: $9429c8604db0efde$var$St
});
function $9429c8604db0efde$export$893a54461d35f87f(t, e) {
    return (0, $8ebc39becbfbdd8f$export$9ca48ab5b3c00400)($9429c8604db0efde$export$a1ca1fda83454df7).$generateNodesFromDOM(t, e);
}
const $9429c8604db0efde$export$96cd3b4e2d764c8e = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    dependencies: [
        /* @__PURE__ */ (0, $3e88191b87395c2e$export$7c74af9ea11c2716)($9429c8604db0efde$export$a1ca1fda83454df7, {
            rules: $9429c8604db0efde$export$c72c508877b8a7ca
        })
    ],
    name: "@lexical/html/CoreImport"
}), $9429c8604db0efde$export$89532617406b796 = [
    $9429c8604db0efde$var$en
], $9429c8604db0efde$export$159ed8b24ff243eb = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    dependencies: [
        (0, $8ebc39becbfbdd8f$export$655225b584cf802e),
        $9429c8604db0efde$export$96cd3b4e2d764c8e
    ],
    name: "@lexical/html/HorizontalRuleImport"
}), $9429c8604db0efde$export$e50444d1393b2d0f = {
    any: $9429c8604db0efde$var$pe.any,
    comment: $9429c8604db0efde$var$pe.comment,
    css: $9429c8604db0efde$export$529769e360e2fa1b,
    tag: $9429c8604db0efde$var$pe.tag,
    text: $9429c8604db0efde$var$pe.text
}, $9429c8604db0efde$var$bn = new Set([
    "STYLE",
    "SCRIPT"
]);
function $9429c8604db0efde$export$4b20ea127dfd853d(t, e) {
    $9429c8604db0efde$var$mt(e);
    const n = (0, $3e88191b87395c2e$export$47ea8b9bb8a4c4de)(e) ? e.body.childNodes : e.childNodes, r = [], s = [];
    for (const e of n)if (!$9429c8604db0efde$var$bn.has(e.nodeName)) {
        const n = $9429c8604db0efde$var$Nn(e, t, s, !1);
        if (null !== n) for (const t of n)r.push(t);
    }
    return function(t) {
        for (const e of t)e.getParent() && e.getNextSibling() instanceof (0, $3e88191b87395c2e$export$82a585c2442a6dd6) && e.insertAfter((0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)());
        for (const e of t){
            const t = e.getParent();
            t && t.splice(e.getIndexWithinParent(), 1, e.getChildren());
        }
    }(s), r;
}
function $9429c8604db0efde$export$d3b9d9c54ad66145(t, n = null, o = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)()) {
    return $9429c8604db0efde$export$9d733c3bbdb5e086([
        $9429c8604db0efde$export$e229c5eb5ebef953($9429c8604db0efde$export$712391d230781d7c, !0)
    ], o)(()=>{
        const e = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), r = $9429c8604db0efde$export$d340cbda52069b48(o), s = (0, $3e88191b87395c2e$export$181b63acea8a0224)(n) ? (0, $3e88191b87395c2e$export$fe2dfd0f9ec2306d)(n.anchor.getNode()) : null, i = t.append.bind(t);
        for (const t of ((0, $3e88191b87395c2e$export$923a058ef54437a4)(s) ? s : e).getChildren())$9429c8604db0efde$var$Mn(o, t, i, n, r);
        return t;
    });
}
function $9429c8604db0efde$export$75e4fa19fba08416(t, n = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)()) {
    const o = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)();
    return $9429c8604db0efde$export$9d733c3bbdb5e086([
        $9429c8604db0efde$export$e229c5eb5ebef953($9429c8604db0efde$export$712391d230781d7c, !0),
        $9429c8604db0efde$export$e229c5eb5ebef953($9429c8604db0efde$export$884776795aedda53, !0)
    ], o)(()=>{
        const e = $9429c8604db0efde$export$d340cbda52069b48(o), r = t.append.bind(t);
        return $9429c8604db0efde$var$Mn(o, n, r, null, e), t;
    });
}
function $9429c8604db0efde$export$a1c399724d359ef8(t, e = null) {
    return ("undefined" == typeof document || "undefined" == typeof window && void 0 === $parcel$global.window) && $9429c8604db0efde$var$nt(338), (0, $3e88191b87395c2e$export$d5c083845dcac446)(t), $9429c8604db0efde$export$d3b9d9c54ad66145((0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("div"), e, t).innerHTML;
}
function $9429c8604db0efde$var$Mn(e, n, o, i = null, c = (0, $3e88191b87395c2e$export$cee5aec8bb4a87d6)(e)) {
    let l = c.$shouldInclude(n, i, e);
    const u = c.$shouldExclude(n, i, e);
    let f = n;
    null !== i && (0, $3e88191b87395c2e$export$471953706258be2b)(n) && (f = (0, $016075a3cb2a2f02$export$56763a00ff6960e6)(i, n, "clone"));
    const a = c.$exportDOM(f, e), { element: d, after: p, append: g, $getChildNodes: m } = a;
    if (!d) return !1;
    const y = (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createDocumentFragment(), S = m ? m() : (0, $3e88191b87395c2e$export$923a058ef54437a4)(f) ? f.getChildren() : [], $ = l && (0, $3e88191b87395c2e$export$7257e4181651a7c3)(i) && (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) ? null : i, v = y.append.bind(y);
    for (const t of S){
        const o = $9429c8604db0efde$var$Mn(e, t, v, $, c);
        !l && o && c.$extractWithChild(n, t, i, "html", e) && (l = !0);
    }
    if (l && !u) {
        if (((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(d) || (0, $3e88191b87395c2e$export$bb9401626c51130a)(d)) && (g ? g(y) : d.append(y)), o(d), p) {
            const t = p.call(f, d);
            t && ((0, $3e88191b87395c2e$export$bb9401626c51130a)(d) ? d.replaceChildren(t) : d.replaceWith(t));
        }
    } else o(y);
    return l;
}
function $9429c8604db0efde$export$f536a427692b7ba0(t, e, n, o = null) {
    return $9429c8604db0efde$var$Mn(t, e, n.append.bind(n), o, $9429c8604db0efde$export$d340cbda52069b48(t));
}
function $9429c8604db0efde$var$Nn(t, e, n, o, r = new Map, s) {
    const i = [];
    if ($9429c8604db0efde$var$bn.has(t.nodeName)) return i;
    let c = null;
    const l = function(t, e) {
        const { nodeName: n } = t, o = e._htmlConversions.get(n.toLowerCase());
        let r = null;
        if (void 0 !== o) for (const e of o){
            const n = e(t);
            null !== n && (null === r || (r.priority || 0) <= (n.priority || 0)) && (r = n);
        }
        return null !== r ? r.conversion : null;
    }(t, e), u = l ? l(t) : null;
    let f = null;
    if (null !== u) {
        f = u.after;
        const e = u.node;
        if (c = Array.isArray(e) ? e[e.length - 1] : e, null !== c) {
            for (const [, t] of r)if (c = t(c, s), !c) break;
            c && i.push(...Array.isArray(e) ? e : [
                c
            ]);
        }
        null != u.forChild && r.set(t.nodeName, u.forChild);
    }
    const a = t.childNodes;
    let d = [];
    const p = (null == c || !(0, $3e88191b87395c2e$export$6f851a24c61146af)(c)) && (null != c && (0, $3e88191b87395c2e$export$de078facd4ee1560)(c) || o);
    for(let t = 0; t < a.length; t++)d.push(...$9429c8604db0efde$var$Nn(a[t], e, n, p, new Map(r), c));
    if (null != f && (d = f(d)), (0, $3e88191b87395c2e$export$5ef1a5ca687c7168)(t) && (d = $9429c8604db0efde$var$En(t, d, p ? ()=>{
        const t = new (0, $3e88191b87395c2e$export$82a585c2442a6dd6);
        return n.push(t), t;
    } : (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d))), null == c) {
        if (d.length > 0) for (const t of d)i.push(t);
        else (0, $3e88191b87395c2e$export$5ef1a5ca687c7168)(t) && function(t) {
            if (null == t.nextSibling || null == t.previousSibling) return !1;
            return (0, $3e88191b87395c2e$export$456fd4e5e0a7123d)(t.nextSibling) && (0, $3e88191b87395c2e$export$456fd4e5e0a7123d)(t.previousSibling);
        }(t) && i.push((0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)());
    } else (0, $3e88191b87395c2e$export$923a058ef54437a4)(c) && c.append(...d);
    return i;
}
function $9429c8604db0efde$var$En(t, e, n) {
    const o = t.style.textAlign, r = [];
    let s = [];
    for(let t = 0; t < e.length; t++){
        const i = e[t];
        if ((0, $3e88191b87395c2e$export$de078facd4ee1560)(i)) o && !i.getFormat() && i.setFormat(o), r.push(i);
        else if (s.push(i), t === e.length - 1 || t < e.length - 1 && (0, $3e88191b87395c2e$export$de078facd4ee1560)(e[t + 1])) {
            const t = n();
            t.setFormat(o), t.append(...s), r.push(t), s = [];
        }
    }
    return r;
}




function $ac97767770b90d3c$export$d4d6ab3c31af0336(r, i, l = null) {
    const c = (0, $3e88191b87395c2e$export$c074c5c00886935b)(l), s = l ? (0, $3e88191b87395c2e$export$3ac46f5934eb607d)(l) : [], u = null !== l && s.length > 0;
    if (u && "function" == typeof c.caretPositionFromPoint) {
        const t = c.caretPositionFromPoint(r, i, {
            shadowRoots: s
        });
        if (null !== t && function(t, e) {
            for(let n = t; null !== n;){
                if (n === e) return !0;
                n = (0, $3e88191b87395c2e$export$169e5491001d3ed6)(n);
            }
            return !1;
        }(t.offsetNode, l)) return {
            node: t.offsetNode,
            offset: t.offset
        };
    }
    if (u) {
        const t = l.getRootNode();
        if ((0, $3e88191b87395c2e$export$cbad3bd7ce195561)(t)) {
            const e = t.elementFromPoint(r, i);
            if (null !== e && l.contains(e)) {
                const t = function(t, e, n, o) {
                    const r = o.createRange(), i = (t)=>e < t.top ? t.top - e : e > t.bottom ? e - t.bottom : 0, l = (e)=>t < e.left ? e.left - t : t > e.right ? t - e.right : 0, c = o.createTreeWalker(n, NodeFilter.SHOW_TEXT);
                    let s = null, u = 1 / 0, a = 1 / 0;
                    for(let t = c.nextNode(); t; t = c.nextNode()){
                        r.selectNodeContents(t);
                        for (const e of r.getClientRects()){
                            const n = i(e), o = l(e);
                            (n < u || n === u && o < a) && (u = n, a = o, s = t);
                        }
                    }
                    if (null === s) return null;
                    let f = 0, p = 1 / 0, d = 1 / 0;
                    for(let e = 0; e <= s.length; e++){
                        r.setStart(s, e), r.collapse(!0);
                        const n = r.getBoundingClientRect(), o = i(n), l = Math.abs(t - n.left);
                        (o < p || o === p && l < d) && (p = o, d = l, f = e);
                    }
                    return {
                        node: s,
                        offset: f
                    };
                }(r, i, e, c);
                if (null !== t) return t;
            }
        }
    }
    if ("function" == typeof c.caretRangeFromPoint) {
        const t = c.caretRangeFromPoint(r, i);
        return null === t ? null : {
            node: t.startContainer,
            offset: t.startOffset
        };
    }
    if ("function" == typeof c.caretPositionFromPoint) {
        const t = c.caretPositionFromPoint(r, i);
        return null === t ? null : {
            node: t.offsetNode,
            offset: t.offset
        };
    }
    return null;
}
function $ac97767770b90d3c$var$nt(t, ...e) {
    const n = new URL("https://lexical.dev/docs/error"), o = new URLSearchParams;
    o.append("code", t);
    for (const t of e)o.append("v", t);
    throw n.search = o.toString(), Error(`Minified Lexical error #${t}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
const $ac97767770b90d3c$export$100dbd40296a45e9 = {
    "application/x-lexical-editor": 0,
    "text/html": 10,
    "text/plain": 20,
    "text/uri-list": 30
};
function $ac97767770b90d3c$var$rt(t) {
    if (window.trustedTypes && window.trustedTypes.createPolicy) return window.trustedTypes.createPolicy("lexical", {
        createHTML: (t)=>t
    }).createHTML(t);
    return t;
}
const $ac97767770b90d3c$var$it = (t, e)=>{
    if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) return e.insertRawText(t), !0;
    const n = (t)=>{
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && t(e);
    };
    return (0, $3e88191b87395c2e$export$31e7aa1b3b383742)(t, {
        linebreak: ()=>n((t)=>t.insertParagraph()),
        tab: ()=>n((t)=>t.insertNodes([
                    (0, $3e88191b87395c2e$export$5bde9d58a1da0796)()
                ])),
        text: (t)=>n((e)=>e.insertText(t))
    }), !0;
}, $ac97767770b90d3c$export$d201ca21ae1c528c = {
    "application/x-lexical-editor": [
        (t, e, n)=>{
            try {
                const n = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)(), o = JSON.parse(t);
                if (o && o.namespace === n._config.namespace && Array.isArray(o.nodes)) return $ac97767770b90d3c$export$9201304b1e00ff59(n, $ac97767770b90d3c$export$c5c00050c34078e0(o.nodes), e), !0;
            } catch (t) {
                console.error(t);
            }
            return n();
        }
    ],
    "text/html": [
        (t, e, n)=>{
            try {
                const n = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)(), o = (new DOMParser).parseFromString($ac97767770b90d3c$var$rt(t), "text/html");
                return $ac97767770b90d3c$export$9201304b1e00ff59(n, (0, $9429c8604db0efde$export$4b20ea127dfd853d)(n, o), e), !0;
            } catch (t) {
                return console.error(t), n();
            }
        }
    ],
    "text/plain": [
        $ac97767770b90d3c$var$it
    ],
    "text/uri-list": [
        $ac97767770b90d3c$var$it
    ]
};
function $ac97767770b90d3c$var$ct(t, e, n, o) {
    if (!t) return !1;
    const r = (i)=>!!t[i] && t[i](e, n, r.bind(null, i - 1), o);
    return r(t.length - 1);
}
function $ac97767770b90d3c$var$st(t, e, n) {
    const o = e.getData("text/plain");
    for (const r of function(t) {
        return Object.keys(t.$importMimeType).filter((e)=>void 0 !== t.$importMimeType[e]).sort((e, n)=>{
            const o = t.priority[e], r = t.priority[n];
            return void 0 === o && void 0 === r ? e < n ? -1 : e > n ? 1 : 0 : void 0 === o ? 1 : void 0 === r ? -1 : o - r;
        });
    }(t)){
        const i = e.getData(r);
        if (i && ("text/html" !== r || i !== o) && $ac97767770b90d3c$var$ct(t.$importMimeType[r], i, n, e)) return !0;
    }
    return !1;
}
const $ac97767770b90d3c$var$ut = {
    $importMimeType: $ac97767770b90d3c$export$d201ca21ae1c528c,
    $insertDataTransfer: (t, e)=>$ac97767770b90d3c$var$st({
            $importMimeType: $ac97767770b90d3c$export$d201ca21ae1c528c,
            priority: $ac97767770b90d3c$export$100dbd40296a45e9
        }, t, e),
    priority: $ac97767770b90d3c$export$100dbd40296a45e9
};
const $ac97767770b90d3c$export$7281fb38dc8f7723 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e)=>({
            $importMimeType: e.$importMimeType,
            $insertDataTransfer: (t, n)=>$ac97767770b90d3c$var$st(e, t, n),
            priority: e.priority
        }),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        $importMimeType: $ac97767770b90d3c$export$d201ca21ae1c528c,
        priority: $ac97767770b90d3c$export$100dbd40296a45e9
    }),
    mergeConfig (t, e) {
        const n = (0, $3e88191b87395c2e$export$89e5ee996f4118)(t, e);
        if (e.$importMimeType) {
            const o = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, t.$importMimeType);
            for (const [t, n] of Object.entries(e.$importMimeType))if (n) {
                const e = o[t];
                o[t] = e ? [
                    ...e,
                    ...n
                ] : n;
            }
            n.$importMimeType = o;
        }
        return e.priority && (n.priority = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, t.priority, e.priority)), n;
    },
    name: "@lexical/clipboard/Import"
}), $ac97767770b90d3c$export$91796baa3cfad535 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    dependencies: [
        (0, $9429c8604db0efde$export$96cd3b4e2d764c8e),
        /* @__PURE__ */ (0, $3e88191b87395c2e$export$7c74af9ea11c2716)($ac97767770b90d3c$export$7281fb38dc8f7723, {
            $importMimeType: {
                "text/html": [
                    (t, e, n, o)=>{
                        const r = (new DOMParser).parseFromString($ac97767770b90d3c$var$rt(t), "text/html"), l = (0, $9429c8604db0efde$export$893a54461d35f87f)(r, {
                            context: [
                                (0, $9429c8604db0efde$export$e229c5eb5ebef953)((0, $9429c8604db0efde$export$ddc693d0d8207b4d), "paste"),
                                (0, $9429c8604db0efde$export$e229c5eb5ebef953)((0, $9429c8604db0efde$export$f6c637823756da1e), o)
                            ]
                        });
                        return $ac97767770b90d3c$export$9201304b1e00ff59((0, $3e88191b87395c2e$export$8a7392c46faf1a3f)(), l, e), !0;
                    }
                ]
            }
        })
    ],
    name: "@lexical/clipboard/DOMImport"
});
function $ac97767770b90d3c$export$492f5b1e57660d71(t, e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)()) {
    return null == e && $ac97767770b90d3c$var$nt(166), (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && e.isCollapsed() || 0 === e.getNodes().length ? "" : (0, $9429c8604db0efde$export$a1c399724d359ef8)(t, e);
}
function $ac97767770b90d3c$export$431c00b4f604f022(t, e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)()) {
    return null == e && $ac97767770b90d3c$var$nt(166), (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && e.isCollapsed() || 0 === e.getNodes().length ? null : JSON.stringify($ac97767770b90d3c$export$f84df9bec41e6d85(t, e));
}
function $ac97767770b90d3c$export$f4723b67d276bbb7(t, e) {
    const n = t.getData("text/plain") || t.getData("text/uri-list");
    null != n && e.insertRawText(n);
}
function $ac97767770b90d3c$export$ca1422672b17f174(t, e, n) {
    (function() {
        const t = (0, $8ebc39becbfbdd8f$export$c53c4f45b5764867)($ac97767770b90d3c$export$7281fb38dc8f7723.name);
        return t ? t.output : $ac97767770b90d3c$var$ut;
    })().$insertDataTransfer(t, e);
}
const $ac97767770b90d3c$var$yt = "application/x-lexical-drag";
function $ac97767770b90d3c$export$e943e2b7feb6922b(t, e) {
    const n = {
        editorKey: e.getKey()
    };
    t.setData($ac97767770b90d3c$var$yt, JSON.stringify(n));
}
function $ac97767770b90d3c$var$ht(t, e, n) {
    const o = t.dataTransfer;
    if (null === o) return !1;
    const r = function(t) {
        const e = t.getData($ac97767770b90d3c$var$yt);
        if (!e) return null;
        let n;
        try {
            n = JSON.parse(e);
        } catch (t) {
            return null;
        }
        var o;
        return null !== (o = n) && "object" == typeof o && "editorKey" in o && "string" == typeof o.editorKey ? n : null;
    }(o);
    if (null === r) return !1;
    const i = function(t, e) {
        const n = $ac97767770b90d3c$export$d4d6ab3c31af0336(t.clientX, t.clientY, e.getRootElement());
        if (null === n) return null;
        const o = (0, $3e88191b87395c2e$export$fef265f0d2fcffdd)(n.node);
        if (null === o) return null;
        if ((0, $3e88191b87395c2e$export$471953706258be2b)(o)) return (0, $3e88191b87395c2e$export$be15ddddbeea202c)(o, "next", n.offset);
        if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(o)) return (0, $3e88191b87395c2e$export$723976e2b4bde43d)(o, n.offset, "next");
        const r = o.getParent();
        return null === r ? null : (0, $3e88191b87395c2e$export$723976e2b4bde43d)(r, o.getIndexWithinParent() + 1, "next");
    }(t, e);
    if (null === i) return !1;
    const l = (0, $3e88191b87395c2e$export$9138b8478eedbb65)(i);
    if (null === l) return !1;
    const c = r.editorKey === e.getKey(), u = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (c) {
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(u) || u.isCollapsed()) return !1;
        if (function(t, e) {
            const { anchor: n, focus: o } = (0, $3e88191b87395c2e$export$b6aa34707ffda54a)((0, $3e88191b87395c2e$export$7bcaa61bc56938bf)(e), "next");
            return (0, $3e88191b87395c2e$export$cfa5c948dc0495fa)(n, t) < 0 && (0, $3e88191b87395c2e$export$cfa5c948dc0495fa)(t, o) < 0;
        }(i, u)) return t.preventDefault(), !0;
        u.removeText();
    }
    if (!l.origin.isAttached()) return t.preventDefault(), !0;
    if (n(o, (0, $3e88191b87395c2e$export$9fb698110f44889d)((0, $3e88191b87395c2e$export$4a7df333303cecc7)(l)), e), !c) {
        const t = e.getRootElement(), n = t ? t.ownerDocument : null, o = n ? function(t, e) {
            for (const n of (0, $3e88191b87395c2e$export$5ec8835222827c6b)(e)){
                const e = (0, $3e88191b87395c2e$export$40676f02fb121ce2)(n);
                if ((0, $3e88191b87395c2e$export$811e9996da830291)(e) && e.getKey() === t && (0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(n)) return n;
            }
            return null;
        }(r.editorKey, n) : null;
        null !== o && o.dispatchEvent(new InputEvent("beforeinput", {
            bubbles: !0,
            cancelable: !0,
            inputType: "deleteByDrag"
        }));
    }
    return t.preventDefault(), !0;
}
function $ac97767770b90d3c$export$3f74ffc179825d8a(t, e) {
    return $ac97767770b90d3c$var$ht(t, e, $ac97767770b90d3c$export$ca1422672b17f174);
}
function $ac97767770b90d3c$export$b57f5b9ec1319df7(t, e) {
    return $ac97767770b90d3c$var$ht(t, e, (t, e)=>$ac97767770b90d3c$export$f4723b67d276bbb7(t, e));
}
function $ac97767770b90d3c$export$9201304b1e00ff59(t, e, n) {
    t.dispatchCommand((0, $3e88191b87395c2e$export$e47bb493817ec5f6), {
        nodes: e,
        selection: n
    }) || (n.insertNodes(e), function(t) {
        if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && t.isCollapsed()) {
            const e = t.anchor;
            let n = null;
            const o = (0, $3e88191b87395c2e$export$e435a0def9eb2000)(e, "previous");
            if (o) {
                if ((0, $3e88191b87395c2e$export$6d8c68034bda7a85)(o)) n = o.origin;
                else {
                    const t = (0, $3e88191b87395c2e$export$36f672915982afb2)(o, (0, $3e88191b87395c2e$export$19f6ef5eb31488f9)((0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), "next").getFlipped());
                    for (const e of t){
                        if ((0, $3e88191b87395c2e$export$471953706258be2b)(e.origin)) {
                            n = e.origin;
                            break;
                        }
                        if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(e.origin) && !e.origin.isInline()) break;
                    }
                }
            }
            if (n && (0, $3e88191b87395c2e$export$471953706258be2b)(n)) {
                const e = n.getFormat(), o = n.getStyle();
                t.format === e && t.style === o || (t.format = e, t.style = o, t.dirty = !0);
            }
        }
    }(n));
}
function $ac97767770b90d3c$var$vt(t, e, n, o = []) {
    let r = null === e || n.isSelected(e);
    const i = (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) && n.excludeFromCopy("html");
    let l = n;
    null !== e && (0, $3e88191b87395c2e$export$471953706258be2b)(l) && (l = (0, $016075a3cb2a2f02$export$56763a00ff6960e6)(e, l, "clone"));
    const c = (0, $3e88191b87395c2e$export$923a058ef54437a4)(l) ? l.getChildren() : [], s = function(t) {
        const e = t.exportJSON(), n = t.constructor;
        if (e.type !== n.getType() && $ac97767770b90d3c$var$nt(58, n.name), (0, $3e88191b87395c2e$export$923a058ef54437a4)(t)) {
            const t = e.children;
            Array.isArray(t) || $ac97767770b90d3c$var$nt(59, n.name);
        }
        return e;
    }(l);
    (0, $3e88191b87395c2e$export$471953706258be2b)(l) && 0 === l.getTextContentSize() && (r = !1);
    const u = r && (0, $3e88191b87395c2e$export$7257e4181651a7c3)(e) && (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) ? null : e;
    for(let o = 0; o < c.length; o++){
        const i = c[o], l = $ac97767770b90d3c$var$vt(t, u, i, s.children);
        !r && (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) && l && n.extractWithChild(i, e, "clone") && (r = !0);
    }
    if (r && !i) {
        const e = (0, $3e88191b87395c2e$export$c83fc7fbb76e480a)(l);
        if (e.length > 0) {
            const n = {};
            for (const o of e){
                const e = (0, $3e88191b87395c2e$export$ea4162355720819)(l, o);
                null === e && $ac97767770b90d3c$var$nt(366, l.constructor.name, o);
                const r = [];
                $ac97767770b90d3c$var$vt(t, null, e, r), 1 === r.length && r[0].type === e.getType() || $ac97767770b90d3c$var$nt(385, o, l.constructor.name, String(r.length), String(r.length > 0 ? r[0].type : "none")), n[o] = r[0];
            }
            s.$slots = n;
        }
    }
    if (r && !i) o.push(s);
    else if (Array.isArray(s.children)) for(let t = 0; t < s.children.length; t++){
        const e = s.children[t];
        o.push(e);
    }
    return r;
}
function $ac97767770b90d3c$export$f84df9bec41e6d85(t, e) {
    var _e_getNodes_;
    const n = [], o = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), r = (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) ? e.anchor.getNode() : (0, $3e88191b87395c2e$export$7257e4181651a7c3)(e) ? (_e_getNodes_ = e.getNodes()[0]) !== null && _e_getNodes_ !== void 0 ? _e_getNodes_ : null : null, i = null !== r ? (0, $3e88191b87395c2e$export$fe2dfd0f9ec2306d)(r) : null, l = ((0, $3e88191b87395c2e$export$923a058ef54437a4)(i) ? i : o).getChildren();
    for(let o = 0; o < l.length; o++)$ac97767770b90d3c$var$vt(t, e, l[o], n);
    return {
        namespace: t._config.namespace,
        nodes: n
    };
}
function $ac97767770b90d3c$export$c5c00050c34078e0(t) {
    const e = [];
    for (const n of t)e.push((0, $3e88191b87395c2e$export$e1d3a194df5be556)(n));
    return e;
}
let $ac97767770b90d3c$var$Ct = null;
async function $ac97767770b90d3c$export$2cdf1b96a9f86d16(t, e, n) {
    if (null !== $ac97767770b90d3c$var$Ct) return !1;
    if (null !== e) return new Promise((o, r)=>{
        t.update(()=>{
            o($ac97767770b90d3c$var$Nt(t, e, n));
        });
    });
    const o = t.getRootElement(), r = t._window || window, i = r.document, l = (0, $3e88191b87395c2e$export$74c14770a0819525)(r);
    if (null === o || null === l) return !1;
    const c = i.createElement("span");
    c.style.position = "fixed", c.style.top = "-1000px", c.append(i.createTextNode("#")), o.append(c);
    const s = i.createRange();
    return s.setStart(c, 0), s.setEnd(c, 1), l.removeAllRanges(), l.addRange(s), new Promise((e, o)=>{
        const l = t.registerCommand((0, $3e88191b87395c2e$export$3435fcfb1f59ef96), (o)=>((0, $74849711df60ce24$export$266ae88fb619dc2e)(o, ClipboardEvent) && (l(), null !== $ac97767770b90d3c$var$Ct && (r.clearTimeout($ac97767770b90d3c$var$Ct), $ac97767770b90d3c$var$Ct = null), e($ac97767770b90d3c$var$Nt(t, o, n))), !0), (0, $3e88191b87395c2e$export$6afdf194f304e546));
        $ac97767770b90d3c$var$Ct = r.setTimeout(()=>{
            l(), $ac97767770b90d3c$var$Ct = null, e(!1);
        }, 50), i.execCommand("copy"), c.remove();
    });
}
function $ac97767770b90d3c$var$Nt(t, e, n) {
    if (void 0 === n) {
        const e = (0, $3e88191b87395c2e$export$74c14770a0819525)(t._window), o = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!o || o.isCollapsed()) return !1;
        if (!e) return !1;
        const r = (0, $3e88191b87395c2e$export$fca86712f5243a7e)(e, t.getRootElement()), i = r.anchorNode, l = r.focusNode;
        if (null !== i && null !== l && !(0, $3e88191b87395c2e$export$f1b377b21cd6350b)(t, i, l)) return !1;
        n = $ac97767770b90d3c$export$3993f0f0a241e519(o);
    }
    e.preventDefault();
    const o = e.clipboardData;
    return null !== o && ($ac97767770b90d3c$export$2ce030fe64c2e373(o, n), !0);
}
const $ac97767770b90d3c$var$Pt = [
    [
        "text/html",
        $ac97767770b90d3c$export$492f5b1e57660d71
    ],
    [
        "application/x-lexical-editor",
        $ac97767770b90d3c$export$431c00b4f604f022
    ]
];
function $ac97767770b90d3c$export$3993f0f0a241e519(t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)()) {
    return function(t, e) {
        const n = {
            "text/plain": ""
        };
        for (const [o, r] of Object.entries(t))if (r) {
            const t = $ac97767770b90d3c$var$Et(r, e);
            null !== t && (n[o] = t);
        }
        return n;
    }($ac97767770b90d3c$var$Ot(), t);
}
function $ac97767770b90d3c$export$2ce030fe64c2e373(t, e) {
    for (const [n] of $ac97767770b90d3c$var$Pt)void 0 === e[n] && t.setData(n, "");
    for(const n in e){
        const o = e[n];
        void 0 !== o && t.setData(n, o);
    }
}
function $ac97767770b90d3c$var$Ot(t = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)()) {
    const e = (0, $8ebc39becbfbdd8f$export$1a203010713403e8)(t, $ac97767770b90d3c$export$46c358499d70c1a0.name);
    return e ? e.output : $ac97767770b90d3c$var$Ft;
}
const $ac97767770b90d3c$var$Ft = {
    "application/x-lexical-editor": [
        (t, e)=>t ? $ac97767770b90d3c$export$431c00b4f604f022((0, $3e88191b87395c2e$export$8a7392c46faf1a3f)(), t) : e()
    ],
    "text/html": [
        (t, e)=>t ? $ac97767770b90d3c$export$492f5b1e57660d71((0, $3e88191b87395c2e$export$8a7392c46faf1a3f)(), t) : e()
    ],
    "text/plain": [
        (t, e)=>t ? t.getTextContent() : e()
    ]
};
function $ac97767770b90d3c$var$Et(t, e) {
    const n = (o)=>t[o] ? t[o](e, n.bind(null, o - 1)) : null;
    return n(t.length - 1);
}
function $ac97767770b90d3c$export$4e8c850f0cb37b8f(t, e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)()) {
    return $ac97767770b90d3c$var$Et($ac97767770b90d3c$var$Ot()[t] || [], e);
}
const $ac97767770b90d3c$export$46c358499d70c1a0 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e, n)=>e.$exportMimeType,
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        $exportMimeType: $ac97767770b90d3c$var$Ft
    }),
    mergeConfig (t, e) {
        const n = (0, $3e88191b87395c2e$export$89e5ee996f4118)(t, e);
        if (e.$exportMimeType) {
            const o = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, t.$exportMimeType);
            for (const [t, n] of Object.entries(e.$exportMimeType))if (n) {
                const e = o[t];
                o[t] = e ? [
                    ...e,
                    ...n
                ] : n;
            }
            n.$exportMimeType = o;
        }
        return n;
    },
    name: "@lexical/clipboard/GetClipboardData"
});






/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

const $e67df6634839f611$var$c = {
    bold: "bold",
    italic: "italic",
    strikeThrough: "strikethrough",
    subscript: "subscript",
    superscript: "superscript",
    underline: "underline"
}, $e67df6634839f611$var$f = Symbol.for("@lexical/dragon/WindowState");
function $e67df6634839f611$export$3b7cff61d9a646f4(e = function() {
    return "undefined" != typeof window ? window : void 0;
}()) {
    return e ? $e67df6634839f611$var$p(e, Symbol("@lexical/dragon/globalInstall"), void 0) : ()=>{};
}
function $e67df6634839f611$var$p(e, t, n) {
    const i = function(e) {
        let t = e[$e67df6634839f611$var$f];
        return void 0 === t && (t = {
            dispose: ()=>{},
            editors: new Map,
            installs: new Set
        }, e[$e67df6634839f611$var$f] = t), t;
    }(e);
    if (0 === i.installs.size) {
        const t = $e67df6634839f611$var$x.bind(e);
        e.addEventListener("message", t, !0), i.dispose = ()=>{
            e.removeEventListener("message", t, !0);
        };
    }
    if (i.installs.add(t), n) {
        const e = i.editors.get(n) || new Set;
        e.add(t), i.editors.set(n, e);
    }
    return $e67df6634839f611$var$m.bind(null, e, i, t, n);
}
function $e67df6634839f611$var$m(e, t, n, i) {
    if (i) {
        const e = t.editors.get(i);
        e && e.delete(n) && 0 === e.size && t.editors.delete(i);
    }
    t.installs.delete(n) && 0 === t.installs.size && (t.dispose(), delete e[$e67df6634839f611$var$f]);
}
function $e67df6634839f611$var$y(e) {
    return e && e.ownerDocument.defaultView;
}
function $e67df6634839f611$export$14cafee2f188b8bc(n) {
    const i = (0, $8ebc39becbfbdd8f$export$4ce37b374ded5463)(()=>$e67df6634839f611$var$y(n.getRootElement()), (e)=>n.registerRootListener((t)=>{
            e.value = $e67df6634839f611$var$y(t);
        }));
    return (0, $8ebc39becbfbdd8f$export$dc573d8a6576cdb3)(()=>{
        const e = i.value;
        if (e) return $e67df6634839f611$var$p(e, Symbol("@lexical/dragon/editorInstall"), n);
    });
}
function $e67df6634839f611$var$x(e) {
    if (e.origin !== this.location.origin) return;
    const t = function(e) {
        const t = e[$e67df6634839f611$var$f];
        if (void 0 === t) return null;
        const n = (0, $3e88191b87395c2e$export$40676f02fb121ce2)((0, $3e88191b87395c2e$export$914ab019e7cf55b0)(e.document));
        return (0, $3e88191b87395c2e$export$811e9996da830291)(n) && t.editors.has(n) ? n : null;
    }(this);
    if (null === t) return;
    const n = e.data;
    if ("string" == typeof n) {
        let r;
        try {
            r = JSON.parse(n);
        } catch (e) {
            return;
        }
        if (r && "nuanria_messaging" === r.protocol && "request" === r.type) {
            const n = r.payload;
            if (n && "makeChanges" === n.functionId) {
                const r = n.args;
                if (Array.isArray(r)) {
                    const [n, l, a, d, u, f] = r;
                    if (![
                        n,
                        l,
                        d,
                        u
                    ].every(Number.isFinite) || "string" != typeof a && -1 !== a) return;
                    t.update(()=>{
                        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                        if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) {
                            const i = t.anchor;
                            let o = i.getNode(), r = 0, g = 0;
                            if ((0, $3e88191b87395c2e$export$471953706258be2b)(o) && n >= 0 && l >= 0 && (r = n, g = n + l, t.setTextNodeRange(o, r, o, g)), "string" != typeof a || r === g && "" === a || (t.insertRawText(a), o = i.getNode()), (0, $3e88191b87395c2e$export$471953706258be2b)(o)) {
                                const e = o.getTextContentSize();
                                r = Math.min(Math.max(d, 0), e), g = d < 0 || u < 0 ? r : Math.min(d + u, e), t.setTextNodeRange(o, r, o, g);
                            }
                            if ("string" == typeof f && u > 0 && !t.isCollapsed()) {
                                const e = $e67df6634839f611$var$c[f];
                                void 0 !== e && t.formatText(e);
                            }
                            e.stopImmediatePropagation();
                        }
                    });
                }
            }
        }
    }
}
const $e67df6634839f611$export$7ad6d90b76cc74ab = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (e, t, i)=>(0, $8ebc39becbfbdd8f$export$b351c03363e45c4f)(t),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        disabled: "undefined" == typeof window
    }),
    name: "@lexical/dragon",
    register: (e, n, i)=>(0, $8ebc39becbfbdd8f$export$dc573d8a6576cdb3)(()=>i.getOutput().disabled.value ? void 0 : $e67df6634839f611$export$14cafee2f188b8bc(e))
});



const $cc8bb3cdc37e8788$var$dt = /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
    $import: (e, t)=>{
        const n = $cc8bb3cdc37e8788$export$29cdf7c75bd686cc(t.nodeName.toLowerCase());
        return (0, $3e88191b87395c2e$export$bf56bccfeec66814)(t, n), (0, $3e88191b87395c2e$export$b92488674c2048ea)(n, t), (0, $3e88191b87395c2e$export$44a229cf8757fa56)(n, t), [
            n.splice(0, 0, e.$importChildren(t))
        ];
    },
    match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("h1", "h2", "h3", "h4", "h5", "h6"),
    name: "@lexical/rich-text/heading"
}), $cc8bb3cdc37e8788$var$pt = /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
    $import: (e, t)=>{
        const n = $cc8bb3cdc37e8788$export$b8120bbdf1338c27();
        return (0, $3e88191b87395c2e$export$b92488674c2048ea)(n, t), (0, $3e88191b87395c2e$export$bf56bccfeec66814)(t, n), (0, $3e88191b87395c2e$export$44a229cf8757fa56)(n, t), [
            n.splice(0, 0, e.$importChildren(t))
        ];
    },
    match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("blockquote"),
    name: "@lexical/rich-text/blockquote"
}), $cc8bb3cdc37e8788$export$3ed6c79bd23bc03e = /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
    $import: (e, t)=>{
        const n = $cc8bb3cdc37e8788$export$b8120bbdf1338c27({
            shadowRoot: !0
        });
        return (0, $3e88191b87395c2e$export$b92488674c2048ea)(n, t), (0, $3e88191b87395c2e$export$bf56bccfeec66814)(t, n), (0, $3e88191b87395c2e$export$44a229cf8757fa56)(n, t), [
            n.splice(0, 0, e.$importChildren(t, {
                schema: (0, $9429c8604db0efde$export$c7a367a70264b348)
            }))
        ];
    },
    match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("blockquote"),
    name: "@lexical/rich-text/blockquote-shadow-root"
}), $cc8bb3cdc37e8788$export$2cd88ae2499ed88a = [
    $cc8bb3cdc37e8788$var$dt,
    $cc8bb3cdc37e8788$var$pt,
    /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
        $import: (e, t, n)=>{
            const r = t.firstChild;
            var o;
            return r && (0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(o = r) && "SPAN" === o.nodeName && "26pt" === o.style.fontSize ? e.$importChildren(t) : n();
        },
        match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("p"),
        name: "@lexical/rich-text/google-docs-title-p"
    }),
    /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
        $import: (e, t, n)=>"26pt" !== t.style.fontSize ? n() : [
                $cc8bb3cdc37e8788$export$29cdf7c75bd686cc("h1").splice(0, 0, e.$importChildren(t))
            ],
        match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("span"),
        name: "@lexical/rich-text/google-docs-title-span"
    })
];
function $cc8bb3cdc37e8788$var$Ct(e, t) {
    return e && null !== t ? (0, $3e88191b87395c2e$export$89e5ee996f4118)(e, t) : t;
}
const $cc8bb3cdc37e8788$export$6e8077a0aa415b33 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (e, t)=>(0, $8ebc39becbfbdd8f$export$b351c03363e45c4f)(t),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        escapeFormatTriggers: {
            capitalize: {
                enter: !0,
                space: !0,
                tab: !0
            },
            lowercase: {
                enter: !0,
                space: !0,
                tab: !0
            },
            uppercase: {
                enter: !0,
                space: !0,
                tab: !0
            }
        }
    }),
    conflictsWith: [
        "@lexical/plain-text"
    ],
    dependencies: [
        (0, $e67df6634839f611$export$7ad6d90b76cc74ab),
        (0, $8ebc39becbfbdd8f$export$ec8a92468ee4937e),
        (0, $8ebc39becbfbdd8f$export$bdf5c0f0c7e6e1f),
        (0, $9429c8604db0efde$export$96cd3b4e2d764c8e),
        /* @__PURE__ */ (0, $3e88191b87395c2e$export$7c74af9ea11c2716)((0, $9429c8604db0efde$export$a1ca1fda83454df7), {
            rules: $cc8bb3cdc37e8788$export$2cd88ae2499ed88a
        })
    ],
    mergeConfig: function(e, t) {
        const n = (0, $3e88191b87395c2e$export$89e5ee996f4118)(e, t);
        return t.escapeFormatTriggers && (n.escapeFormatTriggers = function(e, t) {
            const n = (0, $3e88191b87395c2e$export$89e5ee996f4118)(e, t);
            for (const r of Object.keys(t))n[r] = $cc8bb3cdc37e8788$var$Ct(e[r], t[r]);
            return n;
        }(e.escapeFormatTriggers, t.escapeFormatTriggers)), n;
    },
    name: "@lexical/rich-text",
    nodes: ()=>[
            $cc8bb3cdc37e8788$export$90fecd23277fcde2,
            $cc8bb3cdc37e8788$export$c64d7b2153096538
        ],
    register: (e, t, n)=>(0, $8ebc39becbfbdd8f$export$dc573d8a6576cdb3)(()=>$cc8bb3cdc37e8788$export$8d6ed18fd12861da(e, n.getOutput().escapeFormatTriggers))
}), $cc8bb3cdc37e8788$export$b4fdb0c39d06f1b9 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    dependencies: [
        $cc8bb3cdc37e8788$export$6e8077a0aa415b33
    ],
    name: "@lexical/rich-text/Import"
}), $cc8bb3cdc37e8788$export$d4a62c60df78432 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$8d4021544bdece00)("DRAG_DROP_PASTE_FILE"), $cc8bb3cdc37e8788$export$564ccfc6d7a47b47 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$e6a0daad8304de)("shadowRoot", {
    parse: Boolean
});
class $cc8bb3cdc37e8788$export$c64d7b2153096538 extends (0, $3e88191b87395c2e$export$dc064fe9e59310fd) {
    static getType() {
        return "quote";
    }
    static clone(e) {
        return new $cc8bb3cdc37e8788$export$c64d7b2153096538(e.__key);
    }
    $config() {
        return this.config("quote", {
            extends: (0, $3e88191b87395c2e$export$dc064fe9e59310fd),
            stateConfigs: [
                {
                    flat: !0,
                    stateConfig: $cc8bb3cdc37e8788$export$564ccfc6d7a47b47
                }
            ]
        });
    }
    isShadowRoot() {
        return (0, $3e88191b87395c2e$export$5f6d848b3f2eebb0)(this, $cc8bb3cdc37e8788$export$564ccfc6d7a47b47);
    }
    setIsShadowRoot(e) {
        return (0, $3e88191b87395c2e$export$401d8a6b50e0699a)(this, $cc8bb3cdc37e8788$export$564ccfc6d7a47b47, e);
    }
    createDOM(e) {
        const t = (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("blockquote");
        return (0, $3e88191b87395c2e$export$71781797876b07d6)(t, e.theme.quote), t;
    }
    updateDOM(e, t) {
        return !1;
    }
    static importDOM() {
        return {
            blockquote: (e)=>({
                    conversion: $cc8bb3cdc37e8788$var$Ot,
                    priority: 0
                })
        };
    }
    exportDOM(e) {
        const { element: t } = super.exportDOM(e);
        if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t)) {
            this.isEmpty() && t.append((0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("br"));
            const e = this.getFormatType();
            e && (t.style.textAlign = e);
            const n = this.getDirection();
            n && (t.dir = n);
        }
        return {
            element: t
        };
    }
    static importJSON(e) {
        return $cc8bb3cdc37e8788$export$b8120bbdf1338c27().updateFromJSON(e);
    }
    exportJSON() {
        return super.exportJSON();
    }
    insertNewAfter(e, t) {
        const n = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)(), r = this.getDirection();
        return n.setDirection(r), this.insertAfter(n, t), n;
    }
    collapseAtStart() {
        if (this.isShadowRoot()) {
            for (const e of this.getChildren())this.insertBefore(e);
            return this.remove(), !0;
        }
        const e = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
        return this.getChildren().forEach((t)=>e.append(t)), this.replace(e), !0;
    }
    canMergeWhenEmpty() {
        return !0;
    }
}
function $cc8bb3cdc37e8788$export$b8120bbdf1338c27(e) {
    const t = (0, $3e88191b87395c2e$export$2f5beb31df92ea57)(new $cc8bb3cdc37e8788$export$c64d7b2153096538);
    return e && e.shadowRoot ? t.setIsShadowRoot(!0) : t;
}
function $cc8bb3cdc37e8788$export$1c183570990c020a(e) {
    return e instanceof $cc8bb3cdc37e8788$export$c64d7b2153096538;
}
class $cc8bb3cdc37e8788$export$90fecd23277fcde2 extends (0, $3e88191b87395c2e$export$dc064fe9e59310fd) {
    static getType() {
        return "heading";
    }
    static clone(e) {
        return new $cc8bb3cdc37e8788$export$90fecd23277fcde2(e.__tag, e.__key);
    }
    afterCloneFrom(e) {
        super.afterCloneFrom(e), this.__tag = e.__tag;
    }
    getTag() {
        return this.getLatest().__tag;
    }
    setTag(e) {
        const t = this.getWritable();
        return t.__tag = e, t;
    }
    createDOM(e) {
        const t = this.__tag, n = (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement(t), r = e.theme.heading;
        if (void 0 !== r) {
            const e = r[t];
            (0, $3e88191b87395c2e$export$71781797876b07d6)(n, e);
        }
        return n;
    }
    updateDOM(e, t, n) {
        return e.__tag !== this.__tag;
    }
    static importDOM() {
        return {
            h1: (e)=>({
                    conversion: $cc8bb3cdc37e8788$var$wt,
                    priority: 0
                }),
            h2: (e)=>({
                    conversion: $cc8bb3cdc37e8788$var$wt,
                    priority: 0
                }),
            h3: (e)=>({
                    conversion: $cc8bb3cdc37e8788$var$wt,
                    priority: 0
                }),
            h4: (e)=>({
                    conversion: $cc8bb3cdc37e8788$var$wt,
                    priority: 0
                }),
            h5: (e)=>({
                    conversion: $cc8bb3cdc37e8788$var$wt,
                    priority: 0
                }),
            h6: (e)=>({
                    conversion: $cc8bb3cdc37e8788$var$wt,
                    priority: 0
                }),
            p: (e)=>{
                const t = e.firstChild;
                return null !== t && $cc8bb3cdc37e8788$var$Tt(t) ? {
                    conversion: ()=>({
                            node: null
                        }),
                    priority: 3
                } : null;
            },
            span: (e)=>$cc8bb3cdc37e8788$var$Tt(e) ? {
                    conversion: (e)=>({
                            node: $cc8bb3cdc37e8788$export$29cdf7c75bd686cc("h1")
                        }),
                    priority: 3
                } : null
        };
    }
    exportDOM(e) {
        const { element: t } = super.exportDOM(e);
        if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t)) {
            this.isEmpty() && t.append((0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("br"));
            const e = this.getFormatType();
            e && (t.style.textAlign = e);
            const n = this.getDirection();
            n && (t.dir = n);
        }
        return {
            element: t
        };
    }
    static importJSON(e) {
        return $cc8bb3cdc37e8788$export$29cdf7c75bd686cc(e.tag).updateFromJSON(e);
    }
    updateFromJSON(e) {
        return super.updateFromJSON(e).setTag(e.tag);
    }
    exportJSON() {
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, super.exportJSON()), {
            tag: this.getTag()
        });
    }
    insertNewAfter(e, t = !0) {
        const n = e ? e.anchor.offset : 0, r = this.getLastDescendant(), o = !r || e && e.anchor.key === r.getKey() && n === r.getTextContentSize() || !e ? (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)() : $cc8bb3cdc37e8788$export$29cdf7c75bd686cc(this.getTag()), i = this.getDirection();
        if (o.setDirection(i), this.insertAfter(o, t), 0 === n && !this.isEmpty() && e) {
            const e = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
            e.select(), this.replace(e, !0);
        }
        return o;
    }
    collapseAtStart() {
        if (this.isEmpty()) {
            const e = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
            this.getChildren().forEach((t)=>e.append(t)), this.replace(e);
        }
        return !0;
    }
    extractWithChild() {
        return !0;
    }
    constructor(e = "h1", t){
        super(t), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__tag", void 0), this.__tag = e;
    }
}
function $cc8bb3cdc37e8788$var$Tt(e) {
    return "span" === e.nodeName.toLowerCase() && "26pt" === e.style.fontSize;
}
function $cc8bb3cdc37e8788$var$wt(e) {
    const t = e.nodeName.toLowerCase();
    let n = null;
    return "h1" !== t && "h2" !== t && "h3" !== t && "h4" !== t && "h5" !== t && "h6" !== t || (n = $cc8bb3cdc37e8788$export$29cdf7c75bd686cc(t), (0, $3e88191b87395c2e$export$bf56bccfeec66814)(e, n), (0, $3e88191b87395c2e$export$b92488674c2048ea)(n, e), (0, $3e88191b87395c2e$export$44a229cf8757fa56)(n, e)), {
        node: n
    };
}
function $cc8bb3cdc37e8788$var$Ot(e) {
    const t = $cc8bb3cdc37e8788$export$b8120bbdf1338c27();
    return (0, $3e88191b87395c2e$export$b92488674c2048ea)(t, e), (0, $3e88191b87395c2e$export$bf56bccfeec66814)(e, t), (0, $3e88191b87395c2e$export$44a229cf8757fa56)(t, e), {
        node: t
    };
}
function $cc8bb3cdc37e8788$export$29cdf7c75bd686cc(e = "h1") {
    return (0, $3e88191b87395c2e$export$2f5beb31df92ea57)(new $cc8bb3cdc37e8788$export$90fecd23277fcde2(e));
}
function $cc8bb3cdc37e8788$export$78b6c84a5d5b8b31(e) {
    return e instanceof $cc8bb3cdc37e8788$export$90fecd23277fcde2;
}
function $cc8bb3cdc37e8788$var$Et(e) {
    const t = (0, $3e88191b87395c2e$export$fef265f0d2fcffdd)(e);
    return (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(t);
}
function $cc8bb3cdc37e8788$var$Ft(e, t, n, r) {
    let o = !1, i = null;
    if (e.isCollapsed() && "text" === e.anchor.type) {
        const t = e.anchor.getNode();
        if ((0, $3e88191b87395c2e$export$471953706258be2b)(t)) {
            i = t;
            const r = e.anchor.offset, s = r === t.getTextContentSize() && null === t.getNextSibling(), a = 0 === r && null === t.getPreviousSibling();
            o = "end" === n && s || "start" === n && a || "both" === n && (s || a);
        }
    }
    let s = !1;
    for (const [n, a] of Object.entries(r)){
        if (null == a || !a[t]) continue;
        const r = n;
        if (a.onlyAtBoundary) {
            if (!(o && i && (0, $3e88191b87395c2e$export$471953706258be2b)(i) && i.hasFormat(r))) continue;
            s = !0;
        }
        e.hasFormat(r) && e.toggleFormat(r);
    }
    s && e.setStyle("");
}
const $cc8bb3cdc37e8788$var$It = {
    capitalize: {
        enter: !0,
        space: !0,
        tab: !0
    },
    lowercase: {
        enter: !0,
        space: !0,
        tab: !0
    },
    uppercase: {
        enter: !0,
        space: !0,
        tab: !0
    }
};
function $cc8bb3cdc37e8788$var$Rt(e, t) {
    return function(e, t) {
        if (!e.isCollapsed()) return !1;
        const n = (0, $3e88191b87395c2e$export$e435a0def9eb2000)(e.focus, t), r = (0, $3e88191b87395c2e$export$57101724ca611500)(n.origin, (0, $3e88191b87395c2e$export$966170d136a21178));
        if (!r) return !1;
        const o = e.focus.getNode();
        if (!r.is(o) && !(0, $3e88191b87395c2e$export$e3d4b782f65c81f1)(o, r)) return !1;
        const i = (0, $3e88191b87395c2e$export$36f672915982afb2)(n, (0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(r, t));
        if (i.getTextSlices().some((e)=>e && e.getTextContentSize() > 0)) return !1;
        const s = (0, $3e88191b87395c2e$export$36f672915982afb2)(i.anchor.getSiblingCaret(), i.focus);
        let a = s.anchor.origin;
        for (const e of s){
            if (!(0, $3e88191b87395c2e$export$3bcd9a2637e8506e)(e) || !e.origin.is(a.getParent())) return !1;
            a = e.origin;
        }
        let c = r;
        for (const e of (0, $3e88191b87395c2e$export$7f1827f6551d91c3)((0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(r, t))){
            if (!e.origin.is(c.getParent())) {
                if ((0, $3e88191b87395c2e$export$7a90539e4eb02726)(e.origin)) {
                    const e = (0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(c, t);
                    return (0, $3e88191b87395c2e$export$9fb698110f44889d)((0, $3e88191b87395c2e$export$36f672915982afb2)(e, e)), !0;
                }
                break;
            }
            if (!(0, $3e88191b87395c2e$export$966170d136a21178)(e.origin)) break;
            c = e.origin;
        }
        return !1;
    }(e, t) || function(e, t) {
        if (!e.isCollapsed() || "element" !== e.anchor.type) return !1;
        const n = (0, $3e88191b87395c2e$export$e435a0def9eb2000)(e.anchor, t).getNodeAtCaret();
        return !(!(0, $3e88191b87395c2e$export$966170d136a21178)(n) || n.isInline() || ((0, $3e88191b87395c2e$export$9fb698110f44889d)((0, $3e88191b87395c2e$export$4a7df333303cecc7)((0, $3e88191b87395c2e$export$33e015e8f2ff8536)((0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(n, t)))), 0));
    }(e, t);
}
function $cc8bb3cdc37e8788$var$At(e) {
    return (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(e) && !e.isInline() && !e.isIsolated() && e.isKeyboardSelectable();
}
function $cc8bb3cdc37e8788$var$Pt(e) {
    const t = (0, $3e88191b87395c2e$export$f8cd0c3f35d1a61c)();
    t.add(e), (0, $3e88191b87395c2e$export$2aad78c37810bca9)(t);
}
function $cc8bb3cdc37e8788$var$zt(e, t) {
    if (!e.isCollapsed()) return !1;
    const n = e.focus, r = n.getNode(), o = t ? "previous" : "next", i = (0, $3e88191b87395c2e$export$e435a0def9eb2000)(n, o);
    if ("element" === n.type && (0, $3e88191b87395c2e$export$923a058ef54437a4)(r) && ((0, $3e88191b87395c2e$export$5b29ca560c2fedab)(r) || (0, $3e88191b87395c2e$export$966170d136a21178)(r))) {
        const e = i.getNodeAtCaret();
        return !(null === e || !$cc8bb3cdc37e8788$var$At(e)) && ($cc8bb3cdc37e8788$var$Pt(e.__key), !0);
    }
    const s = (0, $3e88191b87395c2e$export$57101724ca611500)((0, $3e88191b87395c2e$export$923a058ef54437a4)(r) ? r : r.getParentOrThrow(), (e)=>(0, $3e88191b87395c2e$export$923a058ef54437a4)(e) && !e.isInline() && (0, $3e88191b87395c2e$export$6f851a24c61146af)(e.getParent()));
    if (null === s) return !1;
    const a = (0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(s, o).getNodeAtCaret();
    if (null === a || !$cc8bb3cdc37e8788$var$At(a)) return !1;
    if (0 === s.getTextContentSize()) return $cc8bb3cdc37e8788$var$Pt(a.__key), !0;
    const c = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)().getRootElement();
    if (null === c) return !1;
    const l = (0, $3e88191b87395c2e$export$74c14770a0819525)(c.ownerDocument.defaultView);
    if (null === l || 0 === l.rangeCount) return !1;
    const u = l.anchorNode, f = l.anchorOffset, g = l.focusNode, d = l.focusOffset;
    l.modify("move", t ? "backward" : "forward", "line");
    const p = l.anchorNode, m = l.anchorOffset;
    if (null === p) return $cc8bb3cdc37e8788$var$Mt(l, u, f, g, d), !1;
    const h = (0, $3e88191b87395c2e$export$fef265f0d2fcffdd)(p);
    if ($cc8bb3cdc37e8788$var$Mt(l, u, f, g, d), null === h) return !1;
    if (p === u && m === f) return $cc8bb3cdc37e8788$var$Pt(a.__key), !0;
    return !h.is(s) && !(0, $3e88191b87395c2e$export$e3d4b782f65c81f1)(h, s) && ($cc8bb3cdc37e8788$var$Pt(a.__key), !0);
}
function $cc8bb3cdc37e8788$var$Mt(e, t, n, r, o) {
    null !== t && null !== r && e.setBaseAndExtent(t, n, r, o);
}
function $cc8bb3cdc37e8788$var$$t(e, n) {
    if (!e.isCollapsed()) return !1;
    const r = e.focus.getNode(), o = (0, $3e88191b87395c2e$export$57101724ca611500)((0, $3e88191b87395c2e$export$923a058ef54437a4)(r) ? r : r.getParentOrThrow(), (e)=>(0, $3e88191b87395c2e$export$923a058ef54437a4)(e) && !e.isInline());
    if (null === o) return !1;
    const i = (0, $3e88191b87395c2e$export$8a7392c46faf1a3f)(), s = i.getRootElement();
    if (null === s) return !1;
    const a = s.ownerDocument.defaultView;
    if (null === a) return !1;
    let c = !1;
    for (const e of o.getChildren())if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(e) && e.isInline()) {
        const t = i.getElementByKey(e.getKey());
        if (null !== t) {
            const e = a.getComputedStyle(t).display;
            if ("inline-grid" === e || "inline-flex" === e) {
                c = !0;
                break;
            }
        }
    }
    if (!c) return !1;
    const l = (0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(o, n ? "previous" : "next").getNodeAtCaret();
    if (null === l || !(0, $3e88191b87395c2e$export$923a058ef54437a4)(l)) {
        if (n) {
            const e = o.getFirstDescendant();
            (0, $3e88191b87395c2e$export$471953706258be2b)(e) ? e.select(0, 0) : o.select(0, 0);
        } else {
            const e = o.getLastDescendant();
            if ((0, $3e88191b87395c2e$export$471953706258be2b)(e)) {
                const t = e.getTextContentSize();
                e.select(t, t);
            } else {
                const e = o.getChildrenSize();
                o.select(e, e);
            }
        }
        return !0;
    }
    const u = i.getElementByKey(l.getKey());
    if (null === u) return !1;
    const f = (0, $3e88191b87395c2e$export$74c14770a0819525)(a);
    if (null === f || 0 === f.rangeCount) return !1;
    const g = f.getRangeAt(0).cloneRange();
    g.collapse(!0);
    const d = g.getBoundingClientRect(), p = u.getBoundingClientRect(), m = p.top + p.height / 2;
    if (d.height > 0) {
        const n = (0, $ac97767770b90d3c$export$d4d6ab3c31af0336)(d.left, m, s);
        if (null !== n && u.contains(n.node)) {
            const t = s.ownerDocument.createRange();
            return t.setStart(n.node, n.offset), t.collapse(!0), e.applyDOMRange(t), e.dirty = !0, !0;
        }
    }
    const h = n ? l.getLastDescendant() : l.getFirstDescendant();
    if ((0, $3e88191b87395c2e$export$471953706258be2b)(h)) {
        const e = n ? h.getTextContentSize() : 0;
        h.select(e, e);
    } else {
        const e = l.getChildrenSize();
        l.select(n ? e : 0, n ? e : 0);
    }
    return !0;
}
function $cc8bb3cdc37e8788$var$Jt(e, t) {
    const n = (0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(e, t), r = n.getAdjacentCaret();
    null !== r && (0, $3e88191b87395c2e$export$923a058ef54437a4)(r.origin) && !r.origin.isInline() && r.origin.isShadowRoot() ? (0, $3e88191b87395c2e$export$9fb698110f44889d)((0, $3e88191b87395c2e$export$4a7df333303cecc7)(n)) : "next" === t ? e.selectNext(0, 0) : e.selectPrevious();
}
function $cc8bb3cdc37e8788$var$Lt(e, t, n) {
    n.preventDefault(), n.stopPropagation();
    const r = e.getNodes();
    if (0 === r.length) return !0;
    var _U;
    const o = r.map((e)=>(0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(e, "next")).sort((0, $3e88191b87395c2e$export$cfa5c948dc0495fa)), i = (t ? o[0] : o[o.length - 1]).origin, s = (_U = (0, $3e88191b87395c2e$export$57101724ca611500)(i, (e)=>e !== i && (0, $3e88191b87395c2e$export$923a058ef54437a4)(e) && !e.isInline())) !== null && _U !== void 0 ? _U : (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), a = t ? 0 : s.getChildrenSize();
    return s.select(a, a), !0;
}
function $cc8bb3cdc37e8788$export$8d6ed18fd12861da(a, c = (0, $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8)($cc8bb3cdc37e8788$var$It)) {
    return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(a.registerCommand((0, $3e88191b87395c2e$export$c1a2de6c823e5f82), ()=>{
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return (0, $3e88191b87395c2e$export$7257e4181651a7c3)(e) ? (e.clear(), !0) : ((0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && $cc8bb3cdc37e8788$var$Ft(e, "click", "both", c.peek()), !1);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$35595bf6d7e36fd5), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return (0, $3e88191b87395c2e$export$181b63acea8a0224)(t) ? (t.deleteCharacter(e), !0) : !!(0, $3e88191b87395c2e$export$7257e4181651a7c3)(t) && (t.deleteNodes(), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$8e315b175631384c), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return !!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && (t.deleteWord(e), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$d77fad8fb8747fd), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return !!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && (t.deleteLine(e), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$6f67c758bb657857), (t)=>{
        const n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if ("string" == typeof t) null !== n && n.insertText(t);
        else {
            if (null === n) return !1;
            const r = t.dataTransfer;
            if (null != r) (0, $ac97767770b90d3c$export$ca1422672b17f174)(r, n, a);
            else if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(n)) {
                const e = t.data;
                return e && n.insertText(e), !0;
            }
        }
        return !0;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$9cc285f2a3ff220c), ()=>{
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return !!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && (e.removeText(), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$85443a1a9543f043), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return !(!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && !(0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) && ((0, $3e88191b87395c2e$export$91ce7d57f84cadd3)(t, e), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$8bd686fd552eaef7), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return !(!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && !(0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) && ((0, $3e88191b87395c2e$export$1f3463ab0266bd6b)(t, e), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$d394dc6514823b18), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && !(0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) return !1;
        const n = t.getNodes();
        for (const t of n){
            const n = (0, $3e88191b87395c2e$export$57101724ca611500)(t, (e)=>(0, $3e88191b87395c2e$export$923a058ef54437a4)(e) && !e.isInline());
            null !== n && n.setFormat(e);
        }
        return !0;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$64e35ce26e025724), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return !!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && (t.insertLineBreak(e), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$24f4fea65b096b4), ()=>{
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return !!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && (e.insertParagraph(), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$926ce4da2c89d118), ()=>{
        const e = (0, $3e88191b87395c2e$export$5bde9d58a1da0796)(), t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return (0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && (e.setFormat(t.format), e.setStyle(t.style)), (0, $3e88191b87395c2e$export$d773017360b45449)([
            e
        ]), !0;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$2f74f6a2d927e6bd), ()=>(0, $74849711df60ce24$export$39768b879b3f6739)((e)=>{
            const t = e.getIndent();
            e.setIndent(t + 1);
        }), (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$ecf9caa19e96e40d), ()=>(0, $74849711df60ce24$export$39768b879b3f6739)((e)=>{
            const t = e.getIndent();
            t > 0 && e.setIndent(Math.max(0, t - 1));
        }), (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$7833c2a33ae81d3d), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if ((0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) {
            const n = t.getNodes();
            if (n.length > 0) return e.preventDefault(), $cc8bb3cdc37e8788$var$Jt(n[0], "previous"), !0;
        } else if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) {
            if (!e.shiftKey && $cc8bb3cdc37e8788$var$Rt(t, "previous")) return e.preventDefault(), !0;
            if (!e.shiftKey && $cc8bb3cdc37e8788$var$zt(t, !0)) return e.preventDefault(), !0;
            if (!e.shiftKey && $cc8bb3cdc37e8788$var$$t(t, !0)) return e.preventDefault(), !0;
        }
        return !1;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$baa60daa2ca402b3), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if ((0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) {
            const n = t.getNodes();
            if (n.length > 0) return e.preventDefault(), $cc8bb3cdc37e8788$var$Jt(n[0], "next"), !0;
        } else if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) {
            if (function(e) {
                const t = e.focus;
                return "root" === t.key && t.offset === (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)().getChildrenSize();
            }(t)) return e.preventDefault(), !0;
            if (!e.shiftKey && $cc8bb3cdc37e8788$var$Rt(t, "next")) return e.preventDefault(), !0;
            if (!e.shiftKey && $cc8bb3cdc37e8788$var$zt(t, !1)) return e.preventDefault(), !0;
            if (!e.shiftKey && $cc8bb3cdc37e8788$var$$t(t, !1)) return e.preventDefault(), !0;
        }
        return !1;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$7525f8f8ab44508), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if ((0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) {
            const n = t.getNodes();
            if (n.length > 0) return e.preventDefault(), $cc8bb3cdc37e8788$var$Jt(n[0], (0, $016075a3cb2a2f02$export$368701545dbe0002)(n[0]) ? "next" : "previous"), !0;
        }
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) return !1;
        if (!e.shiftKey && $cc8bb3cdc37e8788$var$Rt(t, (0, $016075a3cb2a2f02$export$368701545dbe0002)(t.anchor.getNode()) ? "next" : "previous")) return e.preventDefault(), !0;
        if (e.shiftKey || $cc8bb3cdc37e8788$var$Ft(t, "arrow", "start", c.peek()), (0, $016075a3cb2a2f02$export$d0018f657aae1e58)(t, !0)) {
            const n = e.shiftKey;
            return e.preventDefault(), (0, $016075a3cb2a2f02$export$2ced31adbb83549a)(t, n, !0), !0;
        }
        return !1;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$217ec2281ac1c53b), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if ((0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) {
            const n = t.getNodes();
            if (n.length > 0) return e.preventDefault(), $cc8bb3cdc37e8788$var$Jt(n[0], (0, $016075a3cb2a2f02$export$368701545dbe0002)(n[0]) ? "previous" : "next"), !0;
        }
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) return !1;
        if (!e.shiftKey && $cc8bb3cdc37e8788$var$Rt(t, (0, $016075a3cb2a2f02$export$368701545dbe0002)(t.anchor.getNode()) ? "previous" : "next")) return e.preventDefault(), !0;
        if (e.shiftKey || $cc8bb3cdc37e8788$var$Ft(t, "arrow", "end", c.peek()), (0, $016075a3cb2a2f02$export$d0018f657aae1e58)(t, !1)) {
            const n = e.shiftKey;
            return e.preventDefault(), (0, $016075a3cb2a2f02$export$2ced31adbb83549a)(t, n, !1), !0;
        }
        return !1;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$24bbba9bfa830f78), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!(0, $3e88191b87395c2e$export$7257e4181651a7c3)(t) && $cc8bb3cdc37e8788$var$Et(e.target)) return !1;
        if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) {
            if (function(e) {
                if (!e.isCollapsed()) return !1;
                const { anchor: t } = e;
                if (0 !== t.offset) return !1;
                const n = t.getNode();
                if ((0, $3e88191b87395c2e$export$5b29ca560c2fedab)(n)) return !1;
                const r = (0, $74849711df60ce24$export$87243b8185b18f91)(n);
                return r.getIndent() > 0 && (r.is(n) || n.is(r.getFirstDescendant()));
            }(t)) return e.preventDefault(), a.dispatchCommand((0, $3e88191b87395c2e$export$ecf9caa19e96e40d), void 0);
            if ((0, $3e88191b87395c2e$export$9135b5fce2a2854d) && (0, $3e88191b87395c2e$export$7596791c42a3094d)) return !1;
        } else if (!(0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) return !1;
        return e.preventDefault(), a.dispatchCommand((0, $3e88191b87395c2e$export$35595bf6d7e36fd5), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$13a0e72b5c0146bb), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return !(!(0, $3e88191b87395c2e$export$7257e4181651a7c3)(t) && $cc8bb3cdc37e8788$var$Et(e.target)) && !(!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t) && !(0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) && (e.preventDefault(), a.dispatchCommand((0, $3e88191b87395c2e$export$35595bf6d7e36fd5), !1));
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$2cdb7cdd6fccb293), (e)=>{
        let t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if ((0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) {
            const e = t.getNodes();
            1 === e.length && (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(e[0]) && !e[0].isInline() && (t = e[0].selectNext());
        }
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) return !1;
        if ($cc8bb3cdc37e8788$var$Ft(t, "enter", "both", c.peek()), null !== e) {
            if (((0, $3e88191b87395c2e$export$9135b5fce2a2854d) || (0, $3e88191b87395c2e$export$af54264dae9065e6) || (0, $3e88191b87395c2e$export$e9250b0198928087)) && (0, $3e88191b87395c2e$export$7596791c42a3094d)) return !1;
            if (e.preventDefault(), e.shiftKey) return a.dispatchCommand((0, $3e88191b87395c2e$export$64e35ce26e025724), !1);
        }
        return a.dispatchCommand((0, $3e88191b87395c2e$export$24f4fea65b096b4), void 0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$53589e422a755d59), ()=>{
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return !!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && (a.blur(), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$eac1e4b16b80d3ea), (e)=>{
        const [, r] = (0, $74849711df60ce24$export$1faf88b1db1d6bb9)(e);
        if (r.length > 0) {
            const n = e.clientX, o = e.clientY, i = (0, $ac97767770b90d3c$export$d4d6ab3c31af0336)(n, o, a.getRootElement());
            if (null !== i) {
                const { offset: e, node: t } = i, n = (0, $3e88191b87395c2e$export$fef265f0d2fcffdd)(t);
                if (null !== n) {
                    const t = (0, $3e88191b87395c2e$export$1ccc217b9831b072)();
                    if ((0, $3e88191b87395c2e$export$471953706258be2b)(n)) t.anchor.set(n.getKey(), e, "text"), t.focus.set(n.getKey(), e, "text");
                    else {
                        const e = n.getParentOrThrow().getKey(), r = n.getIndexWithinParent() + 1;
                        t.anchor.set(e, r, "element"), t.focus.set(e, r, "element");
                    }
                    const r = (0, $3e88191b87395c2e$export$db10bc6ba67ffcb5)(t);
                    (0, $3e88191b87395c2e$export$2aad78c37810bca9)(r);
                }
                a.dispatchCommand($cc8bb3cdc37e8788$export$d4a62c60df78432, r);
            }
            return e.preventDefault(), !0;
        }
        return (0, $ac97767770b90d3c$export$3f74ffc179825d8a)(e, a);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$2e0fd45fde1da719), (e)=>{
        const [t] = (0, $74849711df60ce24$export$1faf88b1db1d6bb9)(e), n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return !(t && !(0, $3e88191b87395c2e$export$181b63acea8a0224)(n)) && ((0, $3e88191b87395c2e$export$181b63acea8a0224)(n) && !n.isCollapsed() && null !== e.dataTransfer && ((0, $ac97767770b90d3c$export$2ce030fe64c2e373)(e.dataTransfer, (0, $ac97767770b90d3c$export$3993f0f0a241e519)(n)), (0, $ac97767770b90d3c$export$e943e2b7feb6922b)(e.dataTransfer, a)), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$b62c1cce98fa7223), (e)=>{
        const [n] = (0, $74849711df60ce24$export$1faf88b1db1d6bb9)(e), r = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (n && !(0, $3e88191b87395c2e$export$181b63acea8a0224)(r)) return !1;
        const o = e.clientX, i = e.clientY, s = (0, $ac97767770b90d3c$export$d4d6ab3c31af0336)(o, i, a.getRootElement());
        if (null !== s) {
            const t = (0, $3e88191b87395c2e$export$fef265f0d2fcffdd)(s.node);
            (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(t) && e.preventDefault();
        }
        return !0;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$185c218616045e75), ()=>{
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return (0, $3e88191b87395c2e$export$824f075b28fd7b6c)((0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && null !== (0, $3e88191b87395c2e$export$fe2dfd0f9ec2306d)(e.anchor.getNode()) ? e : null), !0;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$3435fcfb1f59ef96), (e)=>((0, $ac97767770b90d3c$export$2cdf1b96a9f86d16)(a, (0, $74849711df60ce24$export$266ae88fb619dc2e)(e, ClipboardEvent) ? e : null), !0), (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$4dc8a35a083beec4), (e)=>((async function(e, t) {
            await (0, $ac97767770b90d3c$export$2cdf1b96a9f86d16)(t, (0, $74849711df60ce24$export$266ae88fb619dc2e)(e, ClipboardEvent) ? e : null), t.update(()=>{
                const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) ? e.removeText() : (0, $3e88191b87395c2e$export$7257e4181651a7c3)(e) && e.getNodes().forEach((e)=>e.remove());
            }, {
                tag: (0, $3e88191b87395c2e$export$b4b7091df6750ac5)
            });
        })(e, a), !0), (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$7fb70c61b3bcc883), (t)=>{
        const [, n, r] = (0, $74849711df60ce24$export$1faf88b1db1d6bb9)(t);
        if (n.length > 0 && !r) return a.dispatchCommand($cc8bb3cdc37e8788$export$d4a62c60df78432, n), !0;
        if ((0, $3e88191b87395c2e$export$b8eb4d3b76e486c2)(t.target) && (0, $3e88191b87395c2e$export$ceaabfa7ddeeb250)(t.target)) return !1;
        return null !== (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)() && (function(t, n) {
            t.preventDefault(), n.update(()=>{
                const r = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)(), o = (0, $74849711df60ce24$export$266ae88fb619dc2e)(t, InputEvent) || (0, $74849711df60ce24$export$266ae88fb619dc2e)(t, KeyboardEvent) ? null : t.clipboardData;
                null != o && null !== r && (0, $ac97767770b90d3c$export$ca1422672b17f174)(o, r, n);
            }, {
                tag: (0, $3e88191b87395c2e$export$c9fefd1a0f1b33fa)
            });
        }(t, a), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$d0bc2bb647ce4c17), ()=>{
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && $cc8bb3cdc37e8788$var$Ft(e, "space", "both", c.peek()), !1;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$b321bdc226ccdcde), ()=>{
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        return (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && $cc8bb3cdc37e8788$var$Ft(e, "tab", "both", c.peek()), !1;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$fb3b2d438650aff6), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if ((0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) return $cc8bb3cdc37e8788$var$Lt(t, !1, e);
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) return !1;
        const { anchor: n } = t;
        if ("element" !== n.type || 0 !== n.offset) return !1;
        const r = n.getNode();
        if (!(0, $3e88191b87395c2e$export$923a058ef54437a4)(r)) return !1;
        const o = r.getFirstChild();
        if (!(0, $3e88191b87395c2e$export$60aa03725ce41b1c)(o) || !o.isInline()) return !1;
        const i = r.getKey(), s = r.selectEnd();
        return e.shiftKey && s.anchor.set(i, 0, "element"), e.preventDefault(), e.stopPropagation(), !0;
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), a.registerCommand((0, $3e88191b87395c2e$export$dc117ee4d661295a), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if ((0, $3e88191b87395c2e$export$7257e4181651a7c3)(t)) return $cc8bb3cdc37e8788$var$Lt(t, !0, e);
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) return !1;
        const { anchor: n, focus: r } = t, o = (0, $3e88191b87395c2e$export$57101724ca611500)(r.getNode(), (e)=>(0, $3e88191b87395c2e$export$923a058ef54437a4)(e) && !e.isInline());
        if (null === o) return !1;
        const i = o.getFirstChild();
        if (!(0, $3e88191b87395c2e$export$60aa03725ce41b1c)(i) || !i.isInline()) return !1;
        if ((0, $3e88191b87395c2e$export$57101724ca611500)(n.getNode(), (e)=>(0, $3e88191b87395c2e$export$923a058ef54437a4)(e) && !e.isInline()) !== o) return !1;
        const s = o.getKey();
        return ("element" !== r.type || r.key !== s || 0 !== r.offset) && (t.focus.set(s, 0, "element"), e.shiftKey || t.anchor.set(s, 0, "element"), e.preventDefault(), e.stopPropagation(), !0);
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)));
}



var $7fPBF = parcelRequire("7fPBF");

var $0a163704d09ac3e9$var$N = Object.defineProperty;
var $0a163704d09ac3e9$var$P = (s, t, e)=>t in s ? $0a163704d09ac3e9$var$N(s, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : s[t] = e;
var $0a163704d09ac3e9$var$p = (s, t, e)=>$0a163704d09ac3e9$var$P(s, typeof t != "symbol" ? t + "" : t, e);
class $0a163704d09ac3e9$var$S {
    clone() {
        return new $0a163704d09ac3e9$var$S(new Map(this.map));
    }
    increment(t) {
        var _this_map_get;
        const e = (_this_map_get = this.map.get(t)) !== null && _this_map_get !== void 0 ? _this_map_get : 0;
        this.map.set(t, e + 1);
    }
    decrement(t, e) {
        let n = this.map.get(t);
        n !== void 0 && (n -= 1, this.map.set(t, n), n === 0 && e());
    }
    constructor(t = /* @__PURE__ */ new Map()){
        this.map = t;
    }
}
class $0a163704d09ac3e9$var$k {
    getOrCreate(t) {
        let e = this.map.get(t);
        return e === void 0 && (e = /* @__PURE__ */ new Set(), this.map.set(t, e)), e;
    }
    get(t) {
        return this.map.get(t);
    }
    use(t, e) {
        const n = this.get(t);
        n !== void 0 && e(n);
    }
    delete(t) {
        return this.map.delete(t);
    }
    constructor(){
        $0a163704d09ac3e9$var$p(this, "map", /* @__PURE__ */ new Map());
    }
}
function $0a163704d09ac3e9$var$d(s, t) {
    return t(s), s;
}
function $0a163704d09ac3e9$var$x() {}
const $0a163704d09ac3e9$var$I = "cell";
function $0a163704d09ac3e9$export$6756c954b2014a15(s, t) {
    return s === t;
}
const $0a163704d09ac3e9$var$C = /* @__PURE__ */ new Map();
let $0a163704d09ac3e9$var$w;
class $0a163704d09ac3e9$export$3ee29d34e33d9116 {
    /**
   * Creates or resolves an existing cell instance in the realm. Useful as a joint point when building your own operators.
   * @returns a reference to the cell.
   * @param value - the initial value of the cell
   * @param distinct - true by default. Pass false to mark the signal as a non-distinct one, meaning that publishing the same value multiple times will re-trigger a recomputation cycle.
   * @param node - optional, a reference to a cell. If the cell has not been touched in the realm before, the realm will instantiate a reference to it. If it's registered already, the function will return the reference.
   */ cellInstance(t, e = !0, n = Symbol()) {
        return this.state.has(n) || this.state.set(n, t), e !== !1 && !this.distinctNodes.has(n) && this.distinctNodes.set(n, e === !0 ? $0a163704d09ac3e9$export$6756c954b2014a15 : e), n;
    }
    /**
   * Creates or resolves an existing signal instance in the realm. Useful as a joint point when building your own operators.
   * @returns a reference to the signal.
   * @param distinct - true by default. Pass false to mark the signal as a non-distinct one, meaning that publishing the same value multiple times will re-trigger a recomputation cycle.
   * @param node - optional, a reference to a signal. If the signal has not been touched in the realm before, the realm will instantiate a reference to it. If it's registered already, the function will return the reference.
   */ signalInstance(t = !0, e = Symbol()) {
        return t !== !1 && this.distinctNodes.set(e, t === !0 ? $0a163704d09ac3e9$export$6756c954b2014a15 : t), e;
    }
    /**
   * Subscribes to the values published in the referred node.
   * @param node - the cell/signal to subscribe to.
   * @param subscription - the callback to execute when the node receives a new value.
   * @returns a function that, when called, will cancel the subscription.
   *
   * @example
   * ```ts
   * const signal$ = Signal<number>()
   * const r = new Realm()
   * const unsub = r.sub(signal$, console.log)
   * r.pub(signal$, 2)
   * unsub()
   * r.pub(signal$, 3)
   * ```
   */ sub(t, e) {
        this.register(t);
        const n = this.subscriptions.getOrCreate(t);
        return n.add(e), ()=>n.delete(e);
    }
    /**
   * Subscribes exclusively to values in the referred node.
   * Calling this multiple times on a single node will remove the previous subscription created through `singletonSub`.
   * Subscriptions created through `sub` are not affected.
   * @returns a function that, when called, will cancel the subscription.
   *
   * @example
   * ```ts
   * const signal$ = Signal<number>()
   * const r = new Realm()
   * // console.log will run only once.
   * r.singletonSub(signal$, console.log)
   * r.singletonSub(signal$, console.log)
   * r.singletonSub(signal$, console.log)
   * r.pub(signal$, 2)
   * ```
   */ singletonSub(t, e) {
        return this.register(t), e === void 0 ? this.singletonSubscriptions.delete(t) : this.singletonSubscriptions.set(t, e), ()=>this.singletonSubscriptions.delete(t);
    }
    /**
   * Clears all exclusive subscriptions.
   */ resetSingletonSubs() {
        this.singletonSubscriptions.clear();
    }
    // biome-ignore lint/suspicious/noExplicitAny: I know why we need any here
    subMultiple(t, e) {
        const n = this.signalInstance();
        return this.connect({
            map: (i)=>(...r)=>{
                    i(r);
                },
            sink: n,
            sources: t
        }), this.sub(n, e);
    }
    /**
   * Publishes into multiple nodes simultaneously, triggering a single re-computation cycle.
   * @param values - a record of node references and their values.
   *
   * @example
   * ```ts
   * const foo$ = Cell('foo')
   * const bar$ = Cell('bar')
   *
   * const r = new Realm()
   * r.pubIn({[foo$]: 'foo1', [bar$]: 'bar1'})
   * ```
   */ pubIn(t) {
        var a;
        const e = Reflect.ownKeys(t), n = this.getExecutionMap(e), i = n.refCount.clone(), r = n.participatingNodes.slice(), o = new Map(this.state), l = (h)=>{
            this.graph.use(h, (c)=>{
                for (const { sources: u, sink: y } of c)u.has(h) && i.decrement(y, ()=>{
                    r.splice(r.indexOf(y), 1), l(y);
                });
            });
        };
        for(;;){
            const h = r.shift();
            if (h === void 0) break;
            const c = h;
            let u = !1;
            const y = (m)=>{
                const f = this.distinctNodes.get(c);
                if (f != null && f(o.get(c), m)) {
                    u = !1;
                    return;
                }
                u = !0, o.set(c, m), this.state.has(c) && this.state.set(c, m);
            };
            if (Object.prototype.hasOwnProperty.call(t, c) ? y(t[c]) : n.projections.use(c, (m)=>{
                for (const f of m){
                    const M = [
                        ...Array.from(f.sources),
                        ...Array.from(f.pulls)
                    ].map((v)=>o.get(v));
                    f.map(y)(...M);
                }
            }), u) {
                const m = o.get(c);
                this.inContext(()=>{
                    this.subscriptions.use(c, (f)=>{
                        for (const M of f)M(m);
                    });
                }), (a = this.singletonSubscriptions.get(c)) == null || a(m);
            } else l(c);
        }
    }
    /**
   * A low-level utility that connects multiple nodes to a sink node with a map function. Used as a foundation for the higher-level operators.
   * The nodes can be active (sources) or passive (pulls).
   */ connect({ sources: t, pulls: e = [], map: n, sink: i }) {
        const r = {
            map: n,
            pulls: new Set(e),
            sink: this.register(i),
            sources: new Set(t)
        };
        for (const o of [
            ...t,
            ...e
        ])this.register(o), this.graph.getOrCreate(o).add(r);
        this.executionMaps.clear();
    }
    pub(t, e) {
        this.pubIn({
            [t]: e
        });
    }
    pipe(t, ...e) {
        return this.combineOperators(...e)(t);
    }
    transformer(...t) {
        return (e)=>$0a163704d09ac3e9$var$d(this.signalInstance(), (n)=>(this.link(this.pipe(n, ...t), e), n));
    }
    /**
   * Links the output of a node to the input of another node.
   */ link(t, e) {
        this.connect({
            map: (n)=>(i)=>{
                    n(i);
                },
            sink: e,
            sources: [
                t
            ]
        });
    }
    // prettier-ignore
    combine(...t) {
        return $0a163704d09ac3e9$var$d(this.signalInstance(), (e)=>{
            this.connect({
                map: (n)=>(...i)=>{
                        n(i);
                    },
                sink: e,
                sources: t
            });
        });
    }
    // prettier-ignore
    combineCells(...t) {
        const e = this.combinedCells.find((i)=>t.length === i.sources.length && t.every((r, o)=>r === i.sources[o]));
        if (e) return e.cell;
        const n = this.cellInstance(t.map((i)=>this.getValue(i)), !0);
        return this.connect({
            map: (i)=>(...r)=>{
                    i(r);
                },
            sink: n,
            sources: t
        }), this.combinedCells.push({
            sources: t,
            cell: n
        }), n;
    }
    /**
   * Gets the current value of a node. The node must be stateful.
   * @remark if possible, use {@link withLatestFrom} or {@link combine}, as getValue will not create a dependency to the passed node,
   * which means that if you call it within a computational cycle, you may not get the correct value.
   * @param node - the node instance.
   * @example
   * ```ts
   * const foo$ = Cell('foo')
   *
   * const r = new Realm()
   * r.getValue(foo$) // 'foo'
   * r.pub(foo$, 'bar')
   * //...
   * r.getValue(foo$) // 'bar'
   * ```
   */ getValue(t) {
        return this.register(t), this.state.get(t);
    }
    getValues(t) {
        return t.map((e)=>this.getValue(e));
    }
    /**
   * Explicitly includes the specified cell/signal reference in the realm.
   * Most of the time you don't need to do that, since any interaction with the node through a realm will register it.
   * The only exception of that rule should be when the interaction is conditional, and the node definition includes an init function that needs to be eagerly evaluated.
   */ register(t) {
        const e = $0a163704d09ac3e9$var$C.get(t);
        return e === void 0 || this.definitionRegistry.has(t) ? t : (this.definitionRegistry.add(t), $0a163704d09ac3e9$var$d(e.type === $0a163704d09ac3e9$var$I ? this.cellInstance(e.initial, e.distinct, t) : this.signalInstance(e.distinct, t), (n)=>{
            this.inContext(()=>{
                e.init(this, n);
            });
        }));
    }
    inContext(t) {
        const e = $0a163704d09ac3e9$var$w;
        $0a163704d09ac3e9$var$w = this;
        const n = t();
        return $0a163704d09ac3e9$var$w = e, n;
    }
    /**
   * Convenient for mutation of cells that contian non-primitive values (e.g. arrays, or objects).
   * Specifies that the cell value should be changed when source emits, with the result of the map callback parameter.
   * the map parameter gets called with the current value of the cell and the value published through the source.
   * @typeParam T - the type of the cell value.
   * @typeParam K - the type of the value published through the source.
   * @example
   * ```ts
   * const items$ = Cell<string[]([])
   * const addItem$ = Signal<string>(false, (r) => {
   *   r.changeWith(items$, addItem$, (items, item) => [...items, item])
   * })
   * const r = new Realm()
   * r.pub(addItem$, 'foo')
   * r.pub(addItem$, 'bar')
   * r.getValue(items$) // ['foo', 'bar']
   * ```
   */ changeWith(t, e, n) {
        this.connect({
            sources: [
                e
            ],
            pulls: [
                t
            ],
            sink: t,
            map: (i)=>(r, o)=>{
                    i(n(o, r));
                }
        });
    }
    calculateExecutionMap(t) {
        const e = [], n = /* @__PURE__ */ new Set(), i = new $0a163704d09ac3e9$var$k(), r = new $0a163704d09ac3e9$var$S(), o = new $0a163704d09ac3e9$var$k(), l = (a, h = 0)=>{
            r.increment(a), !n.has(a) && (this.register(a), i.use(a, (c)=>{
                h = Math.max(...Array.from(c).map((u)=>e.indexOf(u))) + 1;
            }), this.graph.use(a, (c)=>{
                for (const u of c)u.sources.has(a) ? (o.getOrCreate(u.sink).add(u), l(u.sink, h)) : i.getOrCreate(u.sink).add(a);
            }), n.add(a), e.splice(h, 0, a));
        };
        return t.forEach(l), {
            participatingNodes: e,
            pendingPulls: i,
            projections: o,
            refCount: r
        };
    }
    getExecutionMap(t) {
        let e = t;
        if (t.length === 1) {
            e = t[0];
            const i = this.executionMaps.get(e);
            if (i !== void 0) return i;
        } else for (const [i, r] of this.executionMaps.entries())if (Array.isArray(i) && i.length === t.length && i.every((o)=>t.includes(o))) return r;
        const n = this.calculateExecutionMap(t);
        return this.executionMaps.set(e, n), n;
    }
    combineOperators(...t) {
        return (e)=>{
            for (const n of t)e = n(e, this);
            return e;
        };
    }
    /**
   * Creates a new realm.
   * @param initialValues - the initial cell values that will populate the realm.
   * Those values will not trigger a recomputation cycle, and will overwrite the initial values specified for each cell.
   */ constructor(t = {}){
        $0a163704d09ac3e9$var$p(this, "subscriptions", new $0a163704d09ac3e9$var$k());
        $0a163704d09ac3e9$var$p(this, "singletonSubscriptions", /* @__PURE__ */ new Map());
        $0a163704d09ac3e9$var$p(this, "graph", new $0a163704d09ac3e9$var$k());
        $0a163704d09ac3e9$var$p(this, "state", /* @__PURE__ */ new Map());
        $0a163704d09ac3e9$var$p(this, "distinctNodes", /* @__PURE__ */ new Map());
        $0a163704d09ac3e9$var$p(this, "executionMaps", /* @__PURE__ */ new Map());
        $0a163704d09ac3e9$var$p(this, "definitionRegistry", /* @__PURE__ */ new Set());
        $0a163704d09ac3e9$var$p(this, "combinedCells", []);
        for (const e of Object.getOwnPropertySymbols(t))this.state.set(e, t[e]);
    }
}
function $0a163704d09ac3e9$export$f6f0c3fe4ec306ea(s, t = $0a163704d09ac3e9$var$x, e = !0) {
    return $0a163704d09ac3e9$var$d(Symbol(), (n)=>{
        $0a163704d09ac3e9$var$C.set(n, {
            type: $0a163704d09ac3e9$var$I,
            distinct: e,
            initial: s,
            init: t
        });
    });
}
function $0a163704d09ac3e9$export$df56f7d2431ba1a5(s, t, e = !0) {
    return $0a163704d09ac3e9$var$d(Symbol(), (n)=>{
        $0a163704d09ac3e9$var$C.set(n, {
            type: $0a163704d09ac3e9$var$I,
            distinct: e,
            initial: s,
            init: (i, r)=>{
                i.link(t(i, r), r);
            }
        });
    });
}
function $0a163704d09ac3e9$export$8210dfe1863c478(s = $0a163704d09ac3e9$var$x, t = !1) {
    return $0a163704d09ac3e9$var$d(Symbol(), (e)=>{
        $0a163704d09ac3e9$var$C.set(e, {
            type: "signal",
            distinct: t,
            init: s
        });
    });
}
function $0a163704d09ac3e9$export$e19cd5f9376f8cee(s = $0a163704d09ac3e9$var$x) {
    return $0a163704d09ac3e9$var$d(Symbol(), (t)=>{
        $0a163704d09ac3e9$var$C.set(t, {
            type: "signal",
            distinct: !1,
            init: s
        });
    });
}
function $0a163704d09ac3e9$var$b() {
    if (!$0a163704d09ac3e9$var$w) throw new Error("This function must be called within a realm instance");
    return $0a163704d09ac3e9$var$w;
}
const $0a163704d09ac3e9$export$9c30223ca0a664fb = (s, t)=>{
    $0a163704d09ac3e9$var$b().link(s, t);
}, $0a163704d09ac3e9$export$256688814ff031e7 = (...s)=>{
    $0a163704d09ac3e9$var$b().pub(...s);
}, $0a163704d09ac3e9$export$f93b5905241a7cca = (...s)=>$0a163704d09ac3e9$var$b().sub(...s), $0a163704d09ac3e9$export$68ce61193c92e193 = (...s)=>{
    $0a163704d09ac3e9$var$b().pubIn(...s);
}, $0a163704d09ac3e9$export$a4627e546088548d = (...s)=>$0a163704d09ac3e9$var$b().pipe(...s), $0a163704d09ac3e9$export$90545e2e23fbcbae = (...s)=>{
    $0a163704d09ac3e9$var$b().changeWith(...s);
}, $0a163704d09ac3e9$export$1be1fc439b849fdf = (...s)=>$0a163704d09ac3e9$var$b().combine(...s), $0a163704d09ac3e9$export$bf7199a9ebcb84a9 = (s)=>$0a163704d09ac3e9$var$b().getValue(s), $0a163704d09ac3e9$export$c8be0cb1b41d5e09 = $7fPBF.createContext(null);
function $0a163704d09ac3e9$export$fc86ac3cb9707776({ children: s, initWith: t, updateWith: e = {} }) {
    const n = $7fPBF.useMemo(()=>new $0a163704d09ac3e9$export$3ee29d34e33d9116(t), []);
    return $7fPBF.useEffect(()=>{
        n.pubIn(e);
    }, [
        e,
        n
    ]), /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($0a163704d09ac3e9$export$c8be0cb1b41d5e09.Provider, {
        value: n,
        children: s
    });
}
function $0a163704d09ac3e9$export$3f9890b0f4413ba6() {
    const s = $7fPBF.useContext($0a163704d09ac3e9$export$c8be0cb1b41d5e09);
    if (s === null) throw new Error("useRealm must be used within a RealmContextProvider");
    return s;
}
function $0a163704d09ac3e9$export$329730cc601f60(s) {
    const t = $0a163704d09ac3e9$export$3f9890b0f4413ba6();
    t.register(s);
    const e = $7fPBF.useCallback((n)=>t.sub(s, n), [
        t,
        s
    ]);
    return $7fPBF.useSyncExternalStore(e, ()=>t.getValue(s), ()=>t.getValue(s));
}
function $0a163704d09ac3e9$export$42d9b6877111703c(...s) {
    const t = $0a163704d09ac3e9$export$3f9890b0f4413ba6(), e = $7fPBF.useMemo(()=>t.combineCells.apply(t, s), [
        t,
        ...s
    ]);
    return $0a163704d09ac3e9$export$329730cc601f60(e);
}
function $0a163704d09ac3e9$export$595f49c26314e555(s) {
    const t = $0a163704d09ac3e9$export$3f9890b0f4413ba6();
    return t.register(s), $7fPBF.useCallback((e)=>{
        t.pub(s, e);
    }, [
        t,
        s
    ]);
}
function $0a163704d09ac3e9$export$42b866d2c5dc25d7(s) {
    return [
        $0a163704d09ac3e9$export$329730cc601f60(s),
        $0a163704d09ac3e9$export$595f49c26314e555(s)
    ];
}
function $0a163704d09ac3e9$export$871de8747c9eaa88(s) {
    return (t, e)=>{
        const n = e.signalInstance();
        return e.connect({
            map: (i)=>(r)=>{
                    i(s(r));
                },
            sink: n,
            sources: [
                t
            ]
        }), n;
    };
}
function $0a163704d09ac3e9$export$d449030e5c10edf7(...s) {
    return (t, e)=>{
        const n = e.signalInstance();
        return e.connect({
            map: (i)=>(...r)=>{
                    i(r);
                },
            pulls: s,
            sink: n,
            sources: [
                t
            ]
        }), n;
    };
}
function $0a163704d09ac3e9$export$e0eaf3a86c03b2ad(s) {
    return (t, e)=>{
        const n = e.signalInstance();
        return e.connect({
            map: (i)=>()=>{
                    i(s);
                },
            sink: n,
            sources: [
                t
            ]
        }), n;
    };
}
function $0a163704d09ac3e9$export$3dea766d36a8935f(s) {
    return (t, e)=>{
        const n = e.signalInstance();
        return e.connect({
            map: (i)=>(r)=>{
                    s(r) && i(r);
                },
            sink: n,
            sources: [
                t
            ]
        }), n;
    };
}
function $0a163704d09ac3e9$export$d2de3aaeafa91619() {
    return (s, t)=>{
        const e = t.signalInstance();
        let n = !1;
        return t.connect({
            map: (i)=>(r)=>{
                    n || (n = !0, i(r));
                },
            sink: e,
            sources: [
                s
            ]
        }), e;
    };
}
function $0a163704d09ac3e9$export$c87d910e63d22ed6(s, t) {
    return (e, n)=>{
        const i = n.signalInstance();
        return n.connect({
            map: (r)=>(o)=>{
                    r(t = s(t, o));
                },
            sink: i,
            sources: [
                e
            ]
        }), i;
    };
}
function $0a163704d09ac3e9$export$4efe28f192921dd4(s) {
    return (t, e)=>{
        const n = e.signalInstance();
        let i, r = null;
        return e.sub(t, (o)=>{
            i = o, r === null && (r = setTimeout(()=>{
                r = null, e.pub(n, i);
            }, s));
        }), n;
    };
}
function $0a163704d09ac3e9$export$7843a4469d64c07e(s) {
    return (t, e)=>{
        const n = e.signalInstance();
        let i, r = null;
        return e.sub(t, (o)=>{
            i = o, r !== null && clearTimeout(r), r = setTimeout(()=>{
                e.pub(n, i);
            }, s);
        }), n;
    };
}
function $0a163704d09ac3e9$export$f5c7d6c151b42515() {
    return (s, t)=>{
        const e = t.signalInstance();
        return t.sub(s, (n)=>{
            queueMicrotask(()=>{
                t.pub(e, n);
            });
        }), e;
    };
}
function $0a163704d09ac3e9$export$eba1cd81b7ebc55d(s) {
    return (t, e)=>{
        const n = e.signalInstance(), i = Symbol();
        let r = i;
        return e.connect({
            map: (o)=>(l)=>{
                    r !== i && (o([
                        r,
                        l
                    ]), r = i);
                },
            sink: n,
            sources: [
                s
            ]
        }), e.sub(t, (o)=>{
            r = o;
        }), n;
    };
}
function $0a163704d09ac3e9$export$8080b7556d9d6445(s, t, e) {
    return (n, i)=>{
        const r = i.signalInstance();
        return i.sub(n, (o)=>{
            o !== null && typeof o == "object" && "then" in o ? (i.pub(r, s()), o.then((l)=>{
                i.pub(r, t(l));
            }).catch((l)=>{
                i.pub(r, e(l));
            })) : i.pub(r, t(o));
        }), r;
    };
}




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

const $62399e61d90f83a8$var$realmCleanups = /* @__PURE__ */ new WeakMap();
function $62399e61d90f83a8$export$2385055ccde32583(realm, cleanup) {
    let cleanups = $62399e61d90f83a8$var$realmCleanups.get(realm);
    if (!cleanups) {
        cleanups = /* @__PURE__ */ new Set();
        $62399e61d90f83a8$var$realmCleanups.set(realm, cleanups);
    }
    cleanups.add(cleanup);
    return ()=>{
        cleanups.delete(cleanup);
    };
}
function $62399e61d90f83a8$export$4d6a8189d8221e61(realm) {
    const cleanups = $62399e61d90f83a8$var$realmCleanups.get(realm);
    $62399e61d90f83a8$var$realmCleanups.delete(realm);
    if (!cleanups) return;
    let hasError = false;
    let firstError;
    for (const cleanup of [
        ...cleanups
    ].reverse())try {
        cleanup();
    } catch (error) {
        if (!hasError) {
            hasError = true;
            firstError = error;
        }
    }
    if (hasError) throw firstError instanceof Error ? firstError : new Error("Realm cleanup failed with a non-Error value");
}


function $180ae8514eec30ee$export$a1bf852fe7c1a323(plugin) {
    return function(params) {
        return {
            init: (realm)=>{
                var _a;
                return (_a = plugin.init) == null ? void 0 : _a.call(plugin, realm, params);
            },
            postInit: (realm)=>{
                var _a;
                return (_a = plugin.postInit) == null ? void 0 : _a.call(plugin, realm, params);
            },
            update: (realm)=>{
                var _a;
                return (_a = plugin.update) == null ? void 0 : _a.call(plugin, realm, params);
            }
        };
    };
}
function $180ae8514eec30ee$export$9872004391793606({ children: children, plugins: plugins }) {
    const [theRealm, setTheRealm] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        var _a, _b;
        const realm = new (0, $0a163704d09ac3e9$export$3ee29d34e33d9116)();
        try {
            for (const plugin of plugins)(_a = plugin.init) == null || _a.call(plugin, realm);
            for (const plugin of plugins)(_b = plugin.postInit) == null || _b.call(plugin, realm);
        } catch (error) {
            try {
                (0, $62399e61d90f83a8$export$4d6a8189d8221e61)(realm);
            } catch (cleanupError) {
                throw new AggregateError([
                    error,
                    cleanupError
                ], "Realm plugin initialization and cleanup both failed");
            }
            throw error;
        }
        setTheRealm(realm);
        return ()=>{
            (0, $62399e61d90f83a8$export$4d6a8189d8221e61)(realm);
        };
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        var _a;
        if (theRealm) for (const plugin of plugins)(_a = plugin.update) == null || _a.call(plugin, theRealm);
    });
    if (!theRealm) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0a163704d09ac3e9$export$c8be0cb1b41d5e09).Provider, {
        value: theRealm
    }, children);
}


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 


function $08b351797623b941$var$E(t, e, n, o, r) {
    if (null === t || 0 === n.size && 0 === o.size && !r) return 0;
    const a = e._selection, i = t._selection;
    if (r) return 1;
    if (!((0, $3e88191b87395c2e$export$181b63acea8a0224)(a) && (0, $3e88191b87395c2e$export$181b63acea8a0224)(i) && i.isCollapsed() && a.isCollapsed())) return 0;
    const l = function(t, e, n) {
        const o = t._nodeMap, r = [];
        for (const t of e){
            const e = o.get(t);
            void 0 !== e && r.push(e);
        }
        for (const [t, e] of n){
            if (!e) continue;
            const n = o.get(t);
            void 0 === n || (0, $3e88191b87395c2e$export$5b29ca560c2fedab)(n) || r.push(n);
        }
        return r;
    }(e, n, o);
    if (0 === l.length) return 0;
    if (l.length > 1) {
        const n = e._nodeMap, o = n.get(a.anchor.key), r = n.get(i.anchor.key);
        return o && r && !t._nodeMap.has(o.__key) && (0, $3e88191b87395c2e$export$471953706258be2b)(o) && 1 === o.__text.length && 1 === a.anchor.offset ? 2 : 0;
    }
    const s = l[0], u = t._nodeMap.get(s.__key);
    if (!(0, $3e88191b87395c2e$export$471953706258be2b)(u) || !(0, $3e88191b87395c2e$export$471953706258be2b)(s) || u.__mode !== s.__mode) return 0;
    const d = u.__text, c = s.__text;
    if (d === c) return 0;
    const p = a.anchor, f = i.anchor;
    if (p.key !== f.key || "text" !== p.type) return 0;
    const h = p.offset, m = f.offset, g = c.length - d.length;
    return 1 === g && m === h - 1 ? 2 : -1 === g && m === h + 1 ? 3 : -1 === g && m === h ? 4 : 0;
}
function $08b351797623b941$var$D(t, e, n) {
    let o = n(), r = 0, a = o, i = 0, l = null;
    return (s, u, d, c, p, f)=>{
        const h = n();
        if (f.has((0, $3e88191b87395c2e$export$98153f24c6e5ae19)) && (a = o, i = r, l = s), f.has((0, $3e88191b87395c2e$export$7581001a764add86))) return r = 0, o = h, 2;
        f.has((0, $3e88191b87395c2e$export$ecc13538534b9f74)) && l && (o = a, r = i, s = l);
        const m = f.has((0, $3e88191b87395c2e$export$c9fefd1a0f1b33fa)) || f.has((0, $3e88191b87395c2e$export$b4b7091df6750ac5)) ? 0 : $08b351797623b941$var$E(s, u, c, p, t.isComposing()), w = (()=>{
            const n = null === d || d.editor === t, a = f.has((0, $3e88191b87395c2e$export$6387218b6bdcf960));
            if (!a && n && f.has((0, $3e88191b87395c2e$export$b58a9fabaf2a5573))) return 0;
            if (1 === m) return 2;
            if (null === s) return 1;
            const i = u._selection;
            if (!(c.size > 0 || p.size > 0)) return null !== i ? 0 : 2;
            const l = "number" == typeof e ? e : e.peek();
            if (!1 === a && 0 !== m && m === r && h < o + l && n) return 0;
            if (1 === c.size) {
                if (function(t, e, n) {
                    const o = e._nodeMap.get(t), r = n._nodeMap.get(t), a = e._selection, i = n._selection;
                    return !((0, $3e88191b87395c2e$export$181b63acea8a0224)(a) && (0, $3e88191b87395c2e$export$181b63acea8a0224)(i) && "element" === a.anchor.type && "element" === a.focus.type && "text" === i.anchor.type && "text" === i.focus.type || !(0, $3e88191b87395c2e$export$471953706258be2b)(o) || !(0, $3e88191b87395c2e$export$471953706258be2b)(r) || o.__parent !== r.__parent) && JSON.stringify(e.read(()=>o.exportJSON())) === JSON.stringify(n.read(()=>r.exportJSON()));
                }(Array.from(c)[0], s, u)) return 0;
            }
            return 1;
        })();
        return o = h, r = m, w;
    };
}
function $08b351797623b941$var$M(t, e) {
    t.undoStack = [], t.redoStack = [], t.current = null, e && e(t);
}
function $08b351797623b941$export$296432d298e27831(t, e, n, o = Date.now, r, f = null) {
    const h = $08b351797623b941$var$D(t, n, o), m = ()=>{
        r && r(e);
    };
    return m(), (0, $3e88191b87395c2e$export$d64d64f541cc1835)(t.registerCommand((0, $3e88191b87395c2e$export$34722a4946cb641e), ()=>((function(t, e, n) {
            const o = e.redoStack, r = e.undoStack;
            if (0 !== r.length) {
                const a = e.current, i = r.pop();
                null !== a && (o.push(a), t.dispatchCommand((0, $3e88191b87395c2e$export$e36aacf84f559bb3), !0)), 0 === r.length && t.dispatchCommand((0, $3e88191b87395c2e$export$9fd9dd31dd6ebdf5), !1), e.current = i || null, n && n(e), i && i.editor.setEditorState(i.editorState, {
                    tag: (0, $3e88191b87395c2e$export$7581001a764add86)
                });
            }
        })(t, e, r), !0), (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), t.registerCommand((0, $3e88191b87395c2e$export$8c4a0748d31d9941), ()=>((function(t, e, n) {
            const o = e.redoStack, r = e.undoStack;
            if (0 !== o.length) {
                const a = e.current;
                null !== a && (r.push(a), t.dispatchCommand((0, $3e88191b87395c2e$export$9fd9dd31dd6ebdf5), !0));
                const i = o.pop();
                0 === o.length && t.dispatchCommand((0, $3e88191b87395c2e$export$e36aacf84f559bb3), !1), e.current = i || null, n && n(e), i && i.editor.setEditorState(i.editorState, {
                    tag: (0, $3e88191b87395c2e$export$7581001a764add86)
                });
            }
        })(t, e, r), !0), (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), t.registerCommand((0, $3e88191b87395c2e$export$4926ce1a5702fdc7), ()=>($08b351797623b941$var$M(e, r), !1), (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), t.registerCommand((0, $3e88191b87395c2e$export$d3f69a65bbe7edc), ()=>($08b351797623b941$var$M(e, r), t.dispatchCommand((0, $3e88191b87395c2e$export$e36aacf84f559bb3), !1), t.dispatchCommand((0, $3e88191b87395c2e$export$9fd9dd31dd6ebdf5), !1), !0), (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), t.registerUpdateListener(({ editorState: n, prevEditorState: o, dirtyLeaves: r, dirtyElements: a, tags: i })=>{
        const l = e.current, s = e.redoStack, u = e.undoStack, d = null === l ? null : l.editorState;
        if (null !== l && n === d) return;
        const g = h(o, n, l, r, a, i);
        if (1 === g) {
            if (0 !== s.length && (e.redoStack = [], t.dispatchCommand((0, $3e88191b87395c2e$export$e36aacf84f559bb3), !1)), null !== l) {
                u.push((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, l));
                const e = "number" == typeof f || null === f ? f : f.peek();
                null !== e && u.length > e && u.splice(0, u.length - e), t.dispatchCommand((0, $3e88191b87395c2e$export$9fd9dd31dd6ebdf5), !0);
            }
        } else if (2 === g) return;
        e.current = {
            editor: t,
            editorState: n
        }, m();
    }));
}
function $08b351797623b941$export$feb7d16028f7b237() {
    return {
        current: null,
        redoStack: [],
        undoStack: []
    };
}
const $08b351797623b941$export$28f798955ffac32a = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, { delay: e, createInitialHistoryState: o, disabled: r, maxDepth: a, now: i }, l)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $8ebc39becbfbdd8f$export$b351c03363e45c4f)({
            delay: e,
            disabled: r,
            historyState: o(t),
            maxDepth: a,
            now: i
        }), l.getInitResult()),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        createInitialHistoryState: $08b351797623b941$export$feb7d16028f7b237,
        delay: 300,
        disabled: "undefined" == typeof window,
        maxDepth: null,
        now: Date.now
    }),
    init: ()=>({
            canRedo: (0, $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8)(!1),
            canUndo: (0, $8ebc39becbfbdd8f$export$e2ef10f86a8d60e8)(!1)
        }),
    name: "@lexical/history/History",
    register: (e, n, r)=>{
        const { canUndo: a, canRedo: i } = r.getInitResult(), l = r.getOutput(), s = (t)=>(0, $8ebc39becbfbdd8f$export$712ea50be43a7858)(()=>{
                a.value = null != t && t.undoStack.length > 0, i.value = null != t && t.redoStack.length > 0;
            });
        return (0, $8ebc39becbfbdd8f$export$dc573d8a6576cdb3)(()=>{
            if (!l.disabled.value) return $08b351797623b941$export$296432d298e27831(e, l.historyState.value, l.delay, ()=>l.now.peek()(), s, l.maxDepth);
            s(null);
        });
    }
});
const $08b351797623b941$export$264e332fe709f891 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, { disabled: e, parentEditor: o })=>(0, $8ebc39becbfbdd8f$export$b351c03363e45c4f)({
            disabled: e,
            parentEditor: o || t._parentEditor
        }),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        disabled: !1,
        parentEditor: null
    }),
    dependencies: [
        /* @__PURE__ */ (0, $3e88191b87395c2e$export$7c74af9ea11c2716)($08b351797623b941$export$28f798955ffac32a, {
            disabled: !0
        })
    ],
    name: "@lexical/history/SharedHistory",
    register: (e, n, a)=>(0, $8ebc39becbfbdd8f$export$dc573d8a6576cdb3)(()=>{
            const { disabled: t, parentEditor: e } = a.getOutput();
            if (!t.value) {
                const { output: t } = a.getDependency($08b351797623b941$export$28f798955ffac32a), n = function(t) {
                    return t ? (0, $8ebc39becbfbdd8f$export$1a203010713403e8)(t, $08b351797623b941$export$28f798955ffac32a.name) : null;
                }(e.value);
                if (!n) return;
                const i = n.output;
                (0, $8ebc39becbfbdd8f$export$712ea50be43a7858)(()=>{
                    t.delay.value = i.delay.value, t.historyState.value = i.historyState.value, t.now.value = i.now.value, t.disabled.value = i.disabled.value;
                });
            }
        })
});







/**
 * @import {Options} from 'micromark-extension-gfm-strikethrough'
 * @import {Event, Extension, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $6d957c9e6a169a49$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $6d957c9e6a169a49$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $6d957c9e6a169a49$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * @import {Code} from 'micromark-util-types'
 */ /**
 * Check whether the character code represents an ASCII alpha (`a` through `z`,
 * case insensitive).
 *
 * An **ASCII alpha** is an ASCII upper alpha or ASCII lower alpha.
 *
 * An **ASCII upper alpha** is a character in the inclusive range U+0041 (`A`)
 * to U+005A (`Z`).
 *
 * An **ASCII lower alpha** is a character in the inclusive range U+0061 (`a`)
 * to U+007A (`z`).
 *
 * @param code
 *   Code.
 * @returns {boolean}
 *   Whether it matches.
 */ const $9a96cd0c036af4eb$export$d65d6b62c24d5436 = $9a96cd0c036af4eb$var$regexCheck(/[A-Za-z]/);
const $9a96cd0c036af4eb$export$75c76db11865a9f4 = $9a96cd0c036af4eb$var$regexCheck(/[\dA-Za-z]/);
const $9a96cd0c036af4eb$export$4397998b34fe597d = $9a96cd0c036af4eb$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $9a96cd0c036af4eb$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e = $9a96cd0c036af4eb$var$regexCheck(/\d/);
const $9a96cd0c036af4eb$export$eca2752363989806 = $9a96cd0c036af4eb$var$regexCheck(/[\dA-Fa-f]/);
const $9a96cd0c036af4eb$export$35794a7d1db99380 = $9a96cd0c036af4eb$var$regexCheck(/[!-/:-@[-`{-~]/);
function $9a96cd0c036af4eb$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $9a96cd0c036af4eb$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $9a96cd0c036af4eb$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
const $9a96cd0c036af4eb$export$aa04114dd888a7a0 = $9a96cd0c036af4eb$var$regexCheck(RegExp("\\p{P}|\\p{S}", "u"));
const $9a96cd0c036af4eb$export$a0ff789c034ffdf4 = $9a96cd0c036af4eb$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 *   Expression.
 * @returns {(code: Code) => boolean}
 *   Check.
 */ function $9a96cd0c036af4eb$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}


function $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $9a96cd0c036af4eb$export$aa04114dd888a7a0)(code)) return 2;
}


/**
 * @import {Event, Resolver, TokenizeContext} from 'micromark-util-types'
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {ReadonlyArray<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $a0bda62677f8e9a6$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $0f83fff5c7ab5a13$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        name: 'strikethrough',
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === 'enter' && events[index][1].type === 'strikethroughSequenceTemporary' && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === 'exit' && events[open][1].type === 'strikethroughSequenceTemporary' && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = 'strikethroughSequence';
                events[open][1].type = 'strikethroughSequence';
                /** @type {Token} */ const strikethrough = {
                    type: 'strikethrough',
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: 'strikethroughText',
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        'enter',
                        strikethrough,
                        context
                    ],
                    [
                        'enter',
                        events[open][1],
                        context
                    ],
                    [
                        'exit',
                        events[open][1],
                        context
                    ],
                    [
                        'enter',
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $6d957c9e6a169a49$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $6d957c9e6a169a49$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        'exit',
                        text,
                        context
                    ],
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        strikethrough,
                        context
                    ]
                ]);
                (0, $6d957c9e6a169a49$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === 'strikethroughSequenceTemporary') events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter('strikethroughSequenceTemporary');
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit('strikethroughSequenceTemporary');
            const after = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ 

const $09e40cfc169f6d05$var$constructsWithoutStrikethrough = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
$09e40cfc169f6d05$var$handleDelete.peek = $09e40cfc169f6d05$var$peekDelete;
function $09e40cfc169f6d05$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            'delete'
        ],
        enter: {
            strikethrough: $09e40cfc169f6d05$var$enterStrikethrough
        },
        exit: {
            strikethrough: $09e40cfc169f6d05$var$exitStrikethrough
        }
    };
}
function $09e40cfc169f6d05$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: '~',
                inConstruct: 'phrasing',
                notInConstruct: $09e40cfc169f6d05$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $09e40cfc169f6d05$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $09e40cfc169f6d05$var$enterStrikethrough(token) {
    this.enter({
        type: 'delete',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $09e40cfc169f6d05$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $09e40cfc169f6d05$var$handleDelete(node, _, state, info) {
    const tracker = state.createTracker(info);
    const exit = state.enter('strikethrough');
    let value = tracker.move('~~');
    value += state.containerPhrasing(node, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tracker.current()), {
        before: value,
        after: '~'
    }));
    value += tracker.move('~~');
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $09e40cfc169f6d05$var$peekDelete() {
    return '~';
}


// src/handle.ts

$9a247d4cbfd44f10$var$handleMark.peek = $9a247d4cbfd44f10$var$peekMark;
var $9a247d4cbfd44f10$var$constructsWithoutHighlightMark = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
var $9a247d4cbfd44f10$export$2f57a9c081873825 = {
    canContainEols: [
        "highlight"
    ],
    enter: {
        highlight: $9a247d4cbfd44f10$var$enterHighlight
    },
    exit: {
        highlight: $9a247d4cbfd44f10$var$exitHighlight
    }
};
function $9a247d4cbfd44f10$var$enterHighlight(token) {
    this.enter({
        type: "highlight",
        children: []
    }, token);
}
function $9a247d4cbfd44f10$var$exitHighlight(token) {
    this.exit(token);
}
var $9a247d4cbfd44f10$export$994e8fec64bf872f = {
    unsafe: [
        {
            character: "=",
            inConstruct: "phrasing",
            notInConstruct: $9a247d4cbfd44f10$var$constructsWithoutHighlightMark
        }
    ],
    handlers: {
        highlight: $9a247d4cbfd44f10$var$handleMark
    }
};
function $9a247d4cbfd44f10$var$handleMark(node, _, state, info) {
    const marker = "=";
    const tracker = state.createTracker(info);
    const exit = state.enter("highlight");
    let value = tracker.move(marker + marker);
    value += tracker.move(//@ts-expect-error ignore error
    state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: marker
    }, tracker.current())));
    value += tracker.move(marker + marker);
    exit();
    return value;
}
function $9a247d4cbfd44f10$var$peekMark() {
    return "=";
}


/**
 * @import {CompileContext, Extension as FromMarkdownExtension, Handle as FromMarkdownHandle, OnEnterError, OnExitError, Token} from 'mdast-util-from-markdown'
 * @import {Handle as ToMarkdownHandle, Options as ToMarkdownExtension, State, Tracker} from 'mdast-util-to-markdown'
 * @import {Point} from 'unist'
 * @import {MdxJsxAttribute, MdxJsxAttributeValueExpression, MdxJsxExpressionAttribute, MdxJsxFlowElement, MdxJsxTextElement} from '../index.js'
 */ /**
 * @typedef Tag
 *   Single tag.
 * @property {string | undefined} name
 *   Name of tag, or `undefined` for fragment.
 *
 *   > 👉 **Note**: `null` is used in the AST for fragments, as it serializes in
 *   > JSON.
 * @property {Array<MdxJsxAttribute | MdxJsxExpressionAttribute>} attributes
 *   Attributes.
 * @property {boolean} close
 *   Whether the tag is closing (`</x>`).
 * @property {boolean} selfClosing
 *   Whether the tag is self-closing (`<x/>`).
 * @property {Token['start']} start
 *   Start point.
 * @property {Token['start']} end
 *   End point.
 *
 * @typedef ToMarkdownOptions
 *   Configuration.
 * @property {'"' | "'" | null | undefined} [quote='"']
 *   Preferred quote to use around attribute values (default: `'"'`).
 * @property {boolean | null | undefined} [quoteSmart=false]
 *   Use the other quote if that results in less bytes (default: `false`).
 * @property {boolean | null | undefined} [tightSelfClosing=false]
 *   Do not use an extra space when closing self-closing elements: `<img/>`
 *   instead of `<img />` (default: `false`).
 * @property {number | null | undefined} [printWidth=Infinity]
 *   Try and wrap syntax at this width (default: `Infinity`).
 *
 *   When set to a finite number (say, `80`), the formatter will print
 *   attributes on separate lines when a tag doesn’t fit on one line.
 *   The normal behavior is to print attributes with spaces between them
 *   instead of line endings.
 */ 

/**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $b227513681bd728a$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== 'string') throw new TypeError('Expected character');
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}


function $5f7e7f29fdd0c06b$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $5f7e7f29fdd0c06b$export$411ce8e5a71e3069() {}
function $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49() {}
function $5f7e7f29fdd0c06b$export$565e9d9bd6b6e0d4() {}


/**
 * @import {Point} from 'unist'
 * @import {Options} from '../index.js'
 */ /**
 * List of legacy HTML named character references that don’t need a trailing semicolon.
 *
 * @type {Array<string>}
 */ const $9d441a8e4486a83e$export$9545335bdecb4b8c = [
    'AElig',
    'AMP',
    'Aacute',
    'Acirc',
    'Agrave',
    'Aring',
    'Atilde',
    'Auml',
    'COPY',
    'Ccedil',
    'ETH',
    'Eacute',
    'Ecirc',
    'Egrave',
    'Euml',
    'GT',
    'Iacute',
    'Icirc',
    'Igrave',
    'Iuml',
    'LT',
    'Ntilde',
    'Oacute',
    'Ocirc',
    'Ograve',
    'Oslash',
    'Otilde',
    'Ouml',
    'QUOT',
    'REG',
    'THORN',
    'Uacute',
    'Ucirc',
    'Ugrave',
    'Uuml',
    'Yacute',
    'aacute',
    'acirc',
    'acute',
    'aelig',
    'agrave',
    'amp',
    'aring',
    'atilde',
    'auml',
    'brvbar',
    'ccedil',
    'cedil',
    'cent',
    'copy',
    'curren',
    'deg',
    'divide',
    'eacute',
    'ecirc',
    'egrave',
    'eth',
    'euml',
    'frac12',
    'frac14',
    'frac34',
    'gt',
    'iacute',
    'icirc',
    'iexcl',
    'igrave',
    'iquest',
    'iuml',
    'laquo',
    'lt',
    'macr',
    'micro',
    'middot',
    'nbsp',
    'not',
    'ntilde',
    'oacute',
    'ocirc',
    'ograve',
    'ordf',
    'ordm',
    'oslash',
    'otilde',
    'ouml',
    'para',
    'plusmn',
    'pound',
    'quot',
    'raquo',
    'reg',
    'sect',
    'shy',
    'sup1',
    'sup2',
    'sup3',
    'szlig',
    'thorn',
    'times',
    'uacute',
    'ucirc',
    'ugrave',
    'uml',
    'uuml',
    'yacute',
    'yen',
    'yuml'
];


/**
 * Map of invalid numeric character references to their replacements, according to HTML.
 *
 * @type {Record<number, string>}
 */ const $922953b77e46a921$export$18e663c9b25e3b2 = {
    0: "\uFFFD",
    128: "\u20AC",
    130: "\u201A",
    131: "\u0192",
    132: "\u201E",
    133: "\u2026",
    134: "\u2020",
    135: "\u2021",
    136: "\u02C6",
    137: "\u2030",
    138: "\u0160",
    139: "\u2039",
    140: "\u0152",
    142: "\u017D",
    145: "\u2018",
    146: "\u2019",
    147: "\u201C",
    148: "\u201D",
    149: "\u2022",
    150: "\u2013",
    151: "\u2014",
    152: "\u02DC",
    153: "\u2122",
    154: "\u0161",
    155: "\u203A",
    156: "\u0153",
    158: "\u017E",
    159: "\u0178"
};


/**
 * Check if the given character code, or the character code at the first
 * character, is decimal.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is a decimal
 */ function $be23405d8147b49a$export$2ad0182371401ea4(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 48 && code <= 57 /* 0-9 */ ;
}


/**
 * Check if the given character code, or the character code at the first
 * character, is hexadecimal.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is hexadecimal
 */ function $4ccc8a5f535bff43$export$8ec2d91f756e9f4(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 /* a */  && code <= 102 || code >= 65 /* A */  && code <= 70 || code >= 48 /* A */  && code <= 57;
}


/**
 * Check if the given character code, or the character code at the first
 * character, is alphabetical.
 *
 * @param {string|number} character
 * @returns {boolean} Whether `character` is alphabetical.
 */ function $cae77ff8c527c2d9$export$1e381e1de5ace8e(character) {
    const code = typeof character === 'string' ? character.charCodeAt(0) : character;
    return code >= 97 && code <= 122 || code >= 65 && code <= 90;
}



function $7b67d5966946bfd3$export$176ed353558777b8(character) {
    return (0, $cae77ff8c527c2d9$export$1e381e1de5ace8e)(character) || (0, $be23405d8147b49a$export$2ad0182371401ea4)(character);
}


/// <reference lib="dom" />
/* global document */ const $b2bf0a6c22a4700b$var$element = document.createElement('i');
function $b2bf0a6c22a4700b$export$289b6a6320f709b4(value) {
    const characterReference = '&' + value + ';';
    $b2bf0a6c22a4700b$var$element.innerHTML = characterReference;
    const character = $b2bf0a6c22a4700b$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    if (character.charCodeAt(character.length - 1) === 59 /* `;` */  && value !== 'semi') return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    return character === characterReference ? false : character;
}


// Warning messages.
const $fe979033c71e7672$var$messages = [
    '',
    /* 1: Non terminated (named) */ 'Named character references must be terminated by a semicolon',
    /* 2: Non terminated (numeric) */ 'Numeric character references must be terminated by a semicolon',
    /* 3: Empty (named) */ 'Named character references cannot be empty',
    /* 4: Empty (numeric) */ 'Numeric character references cannot be empty',
    /* 5: Unknown (named) */ 'Named character references must be known',
    /* 6: Disallowed (numeric) */ 'Numeric character references cannot be disallowed',
    /* 7: Prohibited (numeric) */ 'Numeric character references cannot be outside the permissible Unicode range'
];
function $fe979033c71e7672$export$6c6c782be925911c(value, options) {
    const settings = options || {};
    const additional = typeof settings.additional === 'string' ? settings.additional.charCodeAt(0) : settings.additional;
    /** @type {Array<string>} */ const result = [];
    let index = 0;
    let lines = -1;
    let queue = '';
    /** @type {Point | undefined} */ let point;
    /** @type {Array<number>|undefined} */ let indent;
    if (settings.position) {
        if ('start' in settings.position || 'indent' in settings.position) {
            // @ts-expect-error: points don’t have indent.
            indent = settings.position.indent;
            // @ts-expect-error: points don’t have indent.
            point = settings.position.start;
        } else point = settings.position;
    }
    let line = (point ? point.line : 0) || 1;
    let column = (point ? point.column : 0) || 1;
    // Cache the current point.
    let previous = now();
    /** @type {number|undefined} */ let character;
    // Ensure the algorithm walks over the first character (inclusive).
    index--;
    while(++index <= value.length){
        // If the previous character was a newline.
        if (character === 10 /* `\n` */ ) column = (indent ? indent[lines] : 0) || 1;
        character = value.charCodeAt(index);
        if (character === 38 /* `&` */ ) {
            const following = value.charCodeAt(index + 1);
            // The behavior depends on the identity of the next character.
            if (following === 9 /* `\t` */  || following === 10 /* `\n` */  || following === 12 /* `\f` */  || following === 32 /* ` ` */  || following === 38 /* `&` */  || following === 60 /* `<` */  || Number.isNaN(following) || additional && following === additional) {
                // Not a character reference.
                // No characters are consumed, and nothing is returned.
                // This is not an error, either.
                queue += String.fromCharCode(character);
                column++;
                continue;
            }
            const start = index + 1;
            let begin = start;
            let end = start;
            /** @type {string} */ let type;
            if (following === 35 /* `#` */ ) {
                // Numerical reference.
                end = ++begin;
                // The behavior further depends on the next character.
                const following = value.charCodeAt(end);
                if (following === 88 /* `X` */  || following === 120 /* `x` */ ) {
                    // ASCII hexadecimal digits.
                    type = 'hexadecimal';
                    end = ++begin;
                } else // ASCII decimal digits.
                type = 'decimal';
            } else // Named reference.
            type = 'named';
            let characterReferenceCharacters = '';
            let characterReference = '';
            let characters = '';
            // Each type of character reference accepts different characters.
            // This test is used to detect whether a reference has ended (as the semicolon
            // is not strictly needed).
            const test = type === 'named' ? (0, $7b67d5966946bfd3$export$176ed353558777b8) : type === 'decimal' ? (0, $be23405d8147b49a$export$2ad0182371401ea4) : (0, $4ccc8a5f535bff43$export$8ec2d91f756e9f4);
            end--;
            while(++end <= value.length){
                const following = value.charCodeAt(end);
                if (!test(following)) break;
                characters += String.fromCharCode(following);
                // Check if we can match a legacy named reference.
                // If so, we cache that as the last viable named reference.
                // This ensures we do not need to walk backwards later.
                if (type === 'named' && (0, $9d441a8e4486a83e$export$9545335bdecb4b8c).includes(characters)) {
                    characterReferenceCharacters = characters;
                    // @ts-expect-error: always able to decode.
                    characterReference = (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(characters);
                }
            }
            let terminated = value.charCodeAt(end) === 59 /* `;` */ ;
            if (terminated) {
                end++;
                const namedReference = type === 'named' ? (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(characters) : false;
                if (namedReference) {
                    characterReferenceCharacters = characters;
                    characterReference = namedReference;
                }
            }
            let diff = 1 + end - start;
            let reference = '';
            if (!terminated && settings.nonTerminated === false) ;
            else if (!characters) // An empty (possible) reference is valid, unless it’s numeric (thus an
            // ampersand followed by an octothorp).
            {
                if (type !== 'named') warning(4 /* Empty (numeric) */ , diff);
            } else if (type === 'named') {
                // An ampersand followed by anything unknown, and not terminated, is
                // invalid.
                if (terminated && !characterReference) warning(5 /* Unknown (named) */ , 1);
                else {
                    // If there’s something after an named reference which is not known,
                    // cap the reference.
                    if (characterReferenceCharacters !== characters) {
                        end = begin + characterReferenceCharacters.length;
                        diff = 1 + end - begin;
                        terminated = false;
                    }
                    // If the reference is not terminated, warn.
                    if (!terminated) {
                        const reason = characterReferenceCharacters ? 1 /* Non terminated (named) */  : 3 /* Empty (named) */ ;
                        if (settings.attribute) {
                            const following = value.charCodeAt(end);
                            if (following === 61 /* `=` */ ) {
                                warning(reason, diff);
                                characterReference = '';
                            } else if ((0, $7b67d5966946bfd3$export$176ed353558777b8)(following)) characterReference = '';
                            else warning(reason, diff);
                        } else warning(reason, diff);
                    }
                }
                reference = characterReference;
            } else {
                if (!terminated) // All nonterminated numeric references are not rendered, and emit a
                // warning.
                warning(2 /* Non terminated (numeric) */ , diff);
                // When terminated and numerical, parse as either hexadecimal or
                // decimal.
                let referenceCode = Number.parseInt(characters, type === 'hexadecimal' ? 16 : 10);
                // Emit a warning when the parsed number is prohibited, and replace with
                // replacement character.
                if ($fe979033c71e7672$var$prohibited(referenceCode)) {
                    warning(7 /* Prohibited (numeric) */ , diff);
                    reference = String.fromCharCode(65533 /* `�` */ );
                } else if (referenceCode in (0, $922953b77e46a921$export$18e663c9b25e3b2)) {
                    // Emit a warning when the parsed number is disallowed, and replace by
                    // an alternative.
                    warning(6 /* Disallowed (numeric) */ , diff);
                    reference = (0, $922953b77e46a921$export$18e663c9b25e3b2)[referenceCode];
                } else {
                    // Parse the number.
                    let output = '';
                    // Emit a warning when the parsed number should not be used.
                    if ($fe979033c71e7672$var$disallowed(referenceCode)) warning(6 /* Disallowed (numeric) */ , diff);
                    // Serialize the number.
                    if (referenceCode > 0xffff) {
                        referenceCode -= 0x10000;
                        output += String.fromCharCode(referenceCode >>> 10 | 0xd800);
                        referenceCode = 0xdc00 | referenceCode & 0x3ff;
                    }
                    reference = output + String.fromCharCode(referenceCode);
                }
            }
            // Found it!
            // First eat the queued characters as normal text, then eat a reference.
            if (reference) {
                flush();
                previous = now();
                index = end - 1;
                column += end - start + 1;
                result.push(reference);
                const next = now();
                next.offset++;
                if (settings.reference) settings.reference.call(settings.referenceContext || undefined, reference, {
                    start: previous,
                    end: next
                }, value.slice(start - 1, end));
                previous = next;
            } else {
                // If we could not find a reference, queue the checked characters (as
                // normal characters), and move the pointer to their end.
                // This is possible because we can be certain neither newlines nor
                // ampersands are included.
                characters = value.slice(start - 1, end);
                queue += characters;
                column += characters.length;
                index = end - 1;
            }
        } else {
            // Handle anything other than an ampersand, including newlines and EOF.
            if (character === 10 /* `\n` */ ) {
                line++;
                lines++;
                column = 0;
            }
            if (Number.isNaN(character)) flush();
            else {
                queue += String.fromCharCode(character);
                column++;
            }
        }
    }
    // Return the reduced nodes.
    return result.join('');
    // Get current position.
    function now() {
        return {
            line: line,
            column: column,
            offset: index + ((point ? point.offset : 0) || 0)
        };
    }
    /**
   * Handle the warning.
   *
   * @param {1|2|3|4|5|6|7} code
   * @param {number} offset
   */ function warning(code, offset) {
        /** @type {ReturnType<now>} */ let position;
        if (settings.warning) {
            position = now();
            position.column += offset;
            position.offset += offset;
            settings.warning.call(settings.warningContext || undefined, $fe979033c71e7672$var$messages[code], position, code);
        }
    }
    /**
   * Flush `queue` (normal text).
   * Macro invoked before each reference and at the end of `value`.
   * Does nothing when `queue` is empty.
   */ function flush() {
        if (queue) {
            result.push(queue);
            if (settings.text) settings.text.call(settings.textContext || undefined, queue, {
                start: previous,
                end: now()
            });
            queue = '';
        }
    }
}
/**
 * Check if `character` is outside the permissible unicode range.
 *
 * @param {number} code
 * @returns {boolean}
 */ function $fe979033c71e7672$var$prohibited(code) {
    return code >= 0xd800 && code <= 0xdfff || code > 0x10ffff;
}
/**
 * Check if `character` is disallowed.
 *
 * @param {number} code
 * @returns {boolean}
 */ function $fe979033c71e7672$var$disallowed(code) {
    return code >= 0x0001 && code <= 0x0008 || code === 0x000b || code >= 0x000d && code <= 0x001f || code >= 0x007f && code <= 0x009f || code >= 0xfdd0 && code <= 0xfdef || (code & 0xffff) === 0xffff || (code & 0xffff) === 0xfffe;
}


/**
 * @typedef {import('./core.js').CoreOptions & import('./util/format-smart.js').FormatSmartOptions} Options
 * @typedef {import('./core.js').CoreOptions} LightOptions
 */ /**
 * @typedef CoreOptions
 * @property {ReadonlyArray<string>} [subset=[]]
 *   Whether to only escape the given subset of characters.
 * @property {boolean} [escapeOnly=false]
 *   Whether to only escape possibly dangerous characters.
 *   Those characters are `"`, `&`, `'`, `<`, `>`, and `` ` ``.
 *
 * @typedef FormatOptions
 * @property {(code: number, next: number, options: CoreWithFormatOptions) => string} format
 *   Format strategy.
 *
 * @typedef {CoreOptions & FormatOptions & import('./util/format-smart.js').FormatSmartOptions} CoreWithFormatOptions
 */ const $410b843dad1a1135$var$defaultSubsetRegex = /["&'<>`]/g;
const $410b843dad1a1135$var$surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
const $410b843dad1a1135$var$controlCharactersRegex = // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
/[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g;
const $410b843dad1a1135$var$regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g;
/** @type {WeakMap<ReadonlyArray<string>, RegExp>} */ const $410b843dad1a1135$var$subsetToRegexCache = new WeakMap();
function $410b843dad1a1135$export$b75f8c4f8f3fbd14(value, options) {
    value = value.replace(options.subset ? $410b843dad1a1135$var$charactersToExpressionCached(options.subset) : $410b843dad1a1135$var$defaultSubsetRegex, basic);
    if (options.subset || options.escapeOnly) return value;
    return value// Surrogate pairs.
    .replace($410b843dad1a1135$var$surrogatePairsRegex, surrogate)// BMP control characters (C0 except for LF, CR, SP; DEL; and some more
    // non-ASCII ones).
    .replace($410b843dad1a1135$var$controlCharactersRegex, basic);
    /**
   * @param {string} pair
   * @param {number} index
   * @param {string} all
   */ function surrogate(pair, index, all) {
        return options.format((pair.charCodeAt(0) - 0xd800) * 0x400 + pair.charCodeAt(1) - 0xdc00 + 0x10000, all.charCodeAt(index + 2), options);
    }
    /**
   * @param {string} character
   * @param {number} index
   * @param {string} all
   */ function basic(character, index, all) {
        return options.format(character.charCodeAt(0), all.charCodeAt(index + 1), options);
    }
}
/**
 * A wrapper function that caches the result of `charactersToExpression` with a WeakMap.
 * This can improve performance when tooling calls `charactersToExpression` repeatedly
 * with the same subset.
 *
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $410b843dad1a1135$var$charactersToExpressionCached(subset) {
    let cached = $410b843dad1a1135$var$subsetToRegexCache.get(subset);
    if (!cached) {
        cached = $410b843dad1a1135$var$charactersToExpression(subset);
        $410b843dad1a1135$var$subsetToRegexCache.set(subset, cached);
    }
    return cached;
}
/**
 * @param {ReadonlyArray<string>} subset
 * @returns {RegExp}
 */ function $410b843dad1a1135$var$charactersToExpression(subset) {
    /** @type {Array<string>} */ const groups = [];
    let index = -1;
    while(++index < subset.length)groups.push(subset[index].replace($410b843dad1a1135$var$regexEscapeRegex, '\\$&'));
    return new RegExp('(?:' + groups.join('|') + ')', 'g');
}


/**
 * @typedef FormatSmartOptions
 * @property {boolean} [useNamedReferences=false]
 *   Prefer named character references (`&amp;`) where possible.
 * @property {boolean} [useShortestReferences=false]
 *   Prefer the shortest possible reference, if that results in less bytes.
 *   **Note**: `useNamedReferences` can be omitted when using `useShortestReferences`.
 * @property {boolean} [omitOptionalSemicolons=false]
 *   Whether to omit semicolons when possible.
 *   **Note**: This creates what HTML calls “parse errors” but is otherwise still valid HTML — don’t use this except when building a minifier.
 *   Omitting semicolons is possible for certain named and numeric references in some cases.
 * @property {boolean} [attribute=false]
 *   Create character references which don’t fail in attributes.
 *   **Note**: `attribute` only applies when operating dangerously with
 *   `omitOptionalSemicolons: true`.
 */ const $cf86d5c85b816fed$var$hexadecimalRegex = /[\dA-Fa-f]/;
function $cf86d5c85b816fed$export$ef12b12fd64fa3cc(code, next, omit) {
    const value = '&#x' + code.toString(16).toUpperCase();
    return omit && next && !$cf86d5c85b816fed$var$hexadecimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}


const $65294a4e137377e3$var$decimalRegex = /\d/;
function $65294a4e137377e3$export$63ad841d70774900(code, next, omit) {
    const value = '&#' + String(code);
    return omit && next && !$65294a4e137377e3$var$decimalRegex.test(String.fromCharCode(next)) ? value : value + ';';
}



/**
 * Map of named character references from HTML 4.
 *
 * @type {Record<string, string>}
 */ const $eddcd7cb7275dd15$export$40952e41c47e8e55 = {
    nbsp: "\xa0",
    iexcl: "\xa1",
    cent: "\xa2",
    pound: "\xa3",
    curren: "\xa4",
    yen: "\xa5",
    brvbar: "\xa6",
    sect: "\xa7",
    uml: "\xa8",
    copy: "\xa9",
    ordf: "\xaa",
    laquo: "\xab",
    not: "\xac",
    shy: "\xad",
    reg: "\xae",
    macr: "\xaf",
    deg: "\xb0",
    plusmn: "\xb1",
    sup2: "\xb2",
    sup3: "\xb3",
    acute: "\xb4",
    micro: "\xb5",
    para: "\xb6",
    middot: "\xb7",
    cedil: "\xb8",
    sup1: "\xb9",
    ordm: "\xba",
    raquo: "\xbb",
    frac14: "\xbc",
    frac12: "\xbd",
    frac34: "\xbe",
    iquest: "\xbf",
    Agrave: "\xc0",
    Aacute: "\xc1",
    Acirc: "\xc2",
    Atilde: "\xc3",
    Auml: "\xc4",
    Aring: "\xc5",
    AElig: "\xc6",
    Ccedil: "\xc7",
    Egrave: "\xc8",
    Eacute: "\xc9",
    Ecirc: "\xca",
    Euml: "\xcb",
    Igrave: "\xcc",
    Iacute: "\xcd",
    Icirc: "\xce",
    Iuml: "\xcf",
    ETH: "\xd0",
    Ntilde: "\xd1",
    Ograve: "\xd2",
    Oacute: "\xd3",
    Ocirc: "\xd4",
    Otilde: "\xd5",
    Ouml: "\xd6",
    times: "\xd7",
    Oslash: "\xd8",
    Ugrave: "\xd9",
    Uacute: "\xda",
    Ucirc: "\xdb",
    Uuml: "\xdc",
    Yacute: "\xdd",
    THORN: "\xde",
    szlig: "\xdf",
    agrave: "\xe0",
    aacute: "\xe1",
    acirc: "\xe2",
    atilde: "\xe3",
    auml: "\xe4",
    aring: "\xe5",
    aelig: "\xe6",
    ccedil: "\xe7",
    egrave: "\xe8",
    eacute: "\xe9",
    ecirc: "\xea",
    euml: "\xeb",
    igrave: "\xec",
    iacute: "\xed",
    icirc: "\xee",
    iuml: "\xef",
    eth: "\xf0",
    ntilde: "\xf1",
    ograve: "\xf2",
    oacute: "\xf3",
    ocirc: "\xf4",
    otilde: "\xf5",
    ouml: "\xf6",
    divide: "\xf7",
    oslash: "\xf8",
    ugrave: "\xf9",
    uacute: "\xfa",
    ucirc: "\xfb",
    uuml: "\xfc",
    yacute: "\xfd",
    thorn: "\xfe",
    yuml: "\xff",
    fnof: "\u0192",
    Alpha: "\u0391",
    Beta: "\u0392",
    Gamma: "\u0393",
    Delta: "\u0394",
    Epsilon: "\u0395",
    Zeta: "\u0396",
    Eta: "\u0397",
    Theta: "\u0398",
    Iota: "\u0399",
    Kappa: "\u039A",
    Lambda: "\u039B",
    Mu: "\u039C",
    Nu: "\u039D",
    Xi: "\u039E",
    Omicron: "\u039F",
    Pi: "\u03A0",
    Rho: "\u03A1",
    Sigma: "\u03A3",
    Tau: "\u03A4",
    Upsilon: "\u03A5",
    Phi: "\u03A6",
    Chi: "\u03A7",
    Psi: "\u03A8",
    Omega: "\u03A9",
    alpha: "\u03B1",
    beta: "\u03B2",
    gamma: "\u03B3",
    delta: "\u03B4",
    epsilon: "\u03B5",
    zeta: "\u03B6",
    eta: "\u03B7",
    theta: "\u03B8",
    iota: "\u03B9",
    kappa: "\u03BA",
    lambda: "\u03BB",
    mu: "\u03BC",
    nu: "\u03BD",
    xi: "\u03BE",
    omicron: "\u03BF",
    pi: "\u03C0",
    rho: "\u03C1",
    sigmaf: "\u03C2",
    sigma: "\u03C3",
    tau: "\u03C4",
    upsilon: "\u03C5",
    phi: "\u03C6",
    chi: "\u03C7",
    psi: "\u03C8",
    omega: "\u03C9",
    thetasym: "\u03D1",
    upsih: "\u03D2",
    piv: "\u03D6",
    bull: "\u2022",
    hellip: "\u2026",
    prime: "\u2032",
    Prime: "\u2033",
    oline: "\u203E",
    frasl: "\u2044",
    weierp: "\u2118",
    image: "\u2111",
    real: "\u211C",
    trade: "\u2122",
    alefsym: "\u2135",
    larr: "\u2190",
    uarr: "\u2191",
    rarr: "\u2192",
    darr: "\u2193",
    harr: "\u2194",
    crarr: "\u21B5",
    lArr: "\u21D0",
    uArr: "\u21D1",
    rArr: "\u21D2",
    dArr: "\u21D3",
    hArr: "\u21D4",
    forall: "\u2200",
    part: "\u2202",
    exist: "\u2203",
    empty: "\u2205",
    nabla: "\u2207",
    isin: "\u2208",
    notin: "\u2209",
    ni: "\u220B",
    prod: "\u220F",
    sum: "\u2211",
    minus: "\u2212",
    lowast: "\u2217",
    radic: "\u221A",
    prop: "\u221D",
    infin: "\u221E",
    ang: "\u2220",
    and: "\u2227",
    or: "\u2228",
    cap: "\u2229",
    cup: "\u222A",
    int: "\u222B",
    there4: "\u2234",
    sim: "\u223C",
    cong: "\u2245",
    asymp: "\u2248",
    ne: "\u2260",
    equiv: "\u2261",
    le: "\u2264",
    ge: "\u2265",
    sub: "\u2282",
    sup: "\u2283",
    nsub: "\u2284",
    sube: "\u2286",
    supe: "\u2287",
    oplus: "\u2295",
    otimes: "\u2297",
    perp: "\u22A5",
    sdot: "\u22C5",
    lceil: "\u2308",
    rceil: "\u2309",
    lfloor: "\u230A",
    rfloor: "\u230B",
    lang: "\u2329",
    rang: "\u232A",
    loz: "\u25CA",
    spades: "\u2660",
    clubs: "\u2663",
    hearts: "\u2665",
    diams: "\u2666",
    quot: '"',
    amp: '&',
    lt: '<',
    gt: '>',
    OElig: "\u0152",
    oelig: "\u0153",
    Scaron: "\u0160",
    scaron: "\u0161",
    Yuml: "\u0178",
    circ: "\u02C6",
    tilde: "\u02DC",
    ensp: "\u2002",
    emsp: "\u2003",
    thinsp: "\u2009",
    zwnj: "\u200C",
    zwj: "\u200D",
    lrm: "\u200E",
    rlm: "\u200F",
    ndash: "\u2013",
    mdash: "\u2014",
    lsquo: "\u2018",
    rsquo: "\u2019",
    sbquo: "\u201A",
    ldquo: "\u201C",
    rdquo: "\u201D",
    bdquo: "\u201E",
    dagger: "\u2020",
    Dagger: "\u2021",
    permil: "\u2030",
    lsaquo: "\u2039",
    rsaquo: "\u203A",
    euro: "\u20AC"
};


/**
 * List of legacy (that don’t need a trailing `;`) named references which could,
 * depending on what follows them, turn into a different meaning
 *
 * @type {Array<string>}
 */ const $4ed18c9e25dcc553$export$39b76096d2f1d598 = [
    'cent',
    'copy',
    'divide',
    'gt',
    'lt',
    'not',
    'para',
    'times'
];


const $6e20758df27af6be$var$own = {}.hasOwnProperty;
/**
 * `characterEntitiesHtml4` but inverted.
 *
 * @type {Record<string, string>}
 */ const $6e20758df27af6be$var$characters = {};
/** @type {string} */ let $6e20758df27af6be$var$key;
for($6e20758df27af6be$var$key in 0, $eddcd7cb7275dd15$export$40952e41c47e8e55)if ($6e20758df27af6be$var$own.call((0, $eddcd7cb7275dd15$export$40952e41c47e8e55), $6e20758df27af6be$var$key)) $6e20758df27af6be$var$characters[(0, $eddcd7cb7275dd15$export$40952e41c47e8e55)[$6e20758df27af6be$var$key]] = $6e20758df27af6be$var$key;
const $6e20758df27af6be$var$notAlphanumericRegex = /[^\dA-Za-z]/;
function $6e20758df27af6be$export$b1e14dcd42472e57(code, next, omit, attribute) {
    const character = String.fromCharCode(code);
    if ($6e20758df27af6be$var$own.call($6e20758df27af6be$var$characters, character)) {
        const name = $6e20758df27af6be$var$characters[character];
        const value = '&' + name;
        if (omit && (0, $9d441a8e4486a83e$export$9545335bdecb4b8c).includes(name) && !(0, $4ed18c9e25dcc553$export$39b76096d2f1d598).includes(name) && (!attribute || next && next !== 61 /* `=` */  && $6e20758df27af6be$var$notAlphanumericRegex.test(String.fromCharCode(next)))) return value;
        return value + ';';
    }
    return '';
}


function $270a3d583edee730$export$f53904683bee23d7(code, next, options) {
    let numeric = (0, $cf86d5c85b816fed$export$ef12b12fd64fa3cc)(code, next, options.omitOptionalSemicolons);
    /** @type {string|undefined} */ let named;
    if (options.useNamedReferences || options.useShortestReferences) named = (0, $6e20758df27af6be$export$b1e14dcd42472e57)(code, next, options.omitOptionalSemicolons, options.attribute);
    // Use the shortest numeric reference when requested.
    // A simple algorithm would use decimal for all code points under 100, as
    // those are shorter than hexadecimal:
    //
    // * `&#99;` vs `&#x63;` (decimal shorter)
    // * `&#100;` vs `&#x64;` (equal)
    //
    // However, because we take `next` into consideration when `omit` is used,
    // And it would be possible that decimals are shorter on bigger values as
    // well if `next` is hexadecimal but not decimal, we instead compare both.
    if ((options.useShortestReferences || !named) && options.useShortestReferences) {
        const decimal = (0, $65294a4e137377e3$export$63ad841d70774900)(code, next, options.omitOptionalSemicolons);
        if (decimal.length < numeric.length) numeric = decimal;
    }
    return named && (!options.useShortestReferences || named.length < numeric.length) ? named : numeric;
}


/**
 * The smallest way to encode a character.
 *
 * @param {number} code
 * @returns {string}
 */ function $3bd3ec3028ea85fe$export$83cfa611e0071208(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


function $4306eeea4ecd9ecc$export$aca9de459d63ca2e(value, options) {
    return (0, $410b843dad1a1135$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $270a3d583edee730$export$f53904683bee23d7)
    }, options));
}
function $4306eeea4ecd9ecc$export$a2577b9dadf100a3(value, options) {
    return (0, $410b843dad1a1135$export$b75f8c4f8f3fbd14)(value, Object.assign({
        format: (0, $3bd3ec3028ea85fe$export$83cfa611e0071208)
    }, options));
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $451965882c5a8799$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== 'object') return '';
    // Node.
    if ('position' in value || 'type' in value) return $451965882c5a8799$var$position(value.position);
    // Position.
    if ('start' in value || 'end' in value) return $451965882c5a8799$var$position(value);
    // Point.
    if ('line' in value || 'column' in value) return $451965882c5a8799$var$point(value);
    // ?
    return '';
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $451965882c5a8799$var$point(point) {
    return $451965882c5a8799$var$index(point && point.line) + ':' + $451965882c5a8799$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $451965882c5a8799$var$position(pos) {
    return $451965882c5a8799$var$point(pos && pos.start) + '-' + $451965882c5a8799$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $451965882c5a8799$var$index(value) {
    return value && typeof value === 'number' ? value : 1;
}


/**
 * @import {Node, Point, Position} from 'unist'
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ 

class $0aa9ed7423c10921$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === 'string') {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = '';
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ('line' in optionsOrParentOrPlace && 'column' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('start' in optionsOrParentOrPlace && 'end' in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ('type' in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, optionsOrParentOrPlace);
        }
        if (typeof causeOrReason === 'string') reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === 'string') {
            const index = origin.indexOf(':');
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && 'start' in options.place ? options.place.start : options.place;
        /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file = '';
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $451965882c5a8799$export$c304dd45fe166145)(options.place) || '1:1';
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === 'string' ? options.cause.stack : '';
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual = undefined;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected = undefined;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note = undefined;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url = undefined;
    }
}
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.file = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.name = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.reason = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.message = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.stack = '';
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.column = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.line = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.ancestors = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.cause = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.fatal = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.place = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.ruleId = undefined;
$0aa9ed7423c10921$export$752e5c445fe834ef.prototype.source = undefined;


const $f743b524b3e33495$var$indent = '  ';
function $f743b524b3e33495$export$49ba96b4164e772f() {
    return {
        canContainEols: [
            'mdxJsxTextElement'
        ],
        enter: {
            mdxJsxFlowTag: enterMdxJsxTag,
            mdxJsxFlowTagClosingMarker: enterMdxJsxTagClosingMarker,
            mdxJsxFlowTagAttribute: enterMdxJsxTagAttribute,
            mdxJsxFlowTagExpressionAttribute: enterMdxJsxTagExpressionAttribute,
            mdxJsxFlowTagAttributeValueLiteral: buffer,
            mdxJsxFlowTagAttributeValueExpression: buffer,
            mdxJsxFlowTagSelfClosingMarker: enterMdxJsxTagSelfClosingMarker,
            mdxJsxTextTag: enterMdxJsxTag,
            mdxJsxTextTagClosingMarker: enterMdxJsxTagClosingMarker,
            mdxJsxTextTagAttribute: enterMdxJsxTagAttribute,
            mdxJsxTextTagExpressionAttribute: enterMdxJsxTagExpressionAttribute,
            mdxJsxTextTagAttributeValueLiteral: buffer,
            mdxJsxTextTagAttributeValueExpression: buffer,
            mdxJsxTextTagSelfClosingMarker: enterMdxJsxTagSelfClosingMarker
        },
        exit: {
            mdxJsxFlowTagClosingMarker: exitMdxJsxTagClosingMarker,
            mdxJsxFlowTagNamePrimary: exitMdxJsxTagNamePrimary,
            mdxJsxFlowTagNameMember: exitMdxJsxTagNameMember,
            mdxJsxFlowTagNameLocal: exitMdxJsxTagNameLocal,
            mdxJsxFlowTagExpressionAttribute: exitMdxJsxTagExpressionAttribute,
            mdxJsxFlowTagExpressionAttributeValue: data,
            mdxJsxFlowTagAttributeNamePrimary: exitMdxJsxTagAttributeNamePrimary,
            mdxJsxFlowTagAttributeNameLocal: exitMdxJsxTagAttributeNameLocal,
            mdxJsxFlowTagAttributeValueLiteral: exitMdxJsxTagAttributeValueLiteral,
            mdxJsxFlowTagAttributeValueLiteralValue: data,
            mdxJsxFlowTagAttributeValueExpression: exitMdxJsxTagAttributeValueExpression,
            mdxJsxFlowTagAttributeValueExpressionValue: data,
            mdxJsxFlowTagSelfClosingMarker: exitMdxJsxTagSelfClosingMarker,
            mdxJsxFlowTag: exitMdxJsxTag,
            mdxJsxTextTagClosingMarker: exitMdxJsxTagClosingMarker,
            mdxJsxTextTagNamePrimary: exitMdxJsxTagNamePrimary,
            mdxJsxTextTagNameMember: exitMdxJsxTagNameMember,
            mdxJsxTextTagNameLocal: exitMdxJsxTagNameLocal,
            mdxJsxTextTagExpressionAttribute: exitMdxJsxTagExpressionAttribute,
            mdxJsxTextTagExpressionAttributeValue: data,
            mdxJsxTextTagAttributeNamePrimary: exitMdxJsxTagAttributeNamePrimary,
            mdxJsxTextTagAttributeNameLocal: exitMdxJsxTagAttributeNameLocal,
            mdxJsxTextTagAttributeValueLiteral: exitMdxJsxTagAttributeValueLiteral,
            mdxJsxTextTagAttributeValueLiteralValue: data,
            mdxJsxTextTagAttributeValueExpression: exitMdxJsxTagAttributeValueExpression,
            mdxJsxTextTagAttributeValueExpressionValue: data,
            mdxJsxTextTagSelfClosingMarker: exitMdxJsxTagSelfClosingMarker,
            mdxJsxTextTag: exitMdxJsxTag
        }
    };
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function buffer() {
        this.buffer();
    }
    /**
   * Copy a point-like value.
   *
   * @param {Point} d
   *   Point-like value.
   * @returns {Point}
   *   unist point.
   */ function point(d) {
        return {
            line: d.line,
            column: d.column,
            offset: d.offset
        };
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function data(token) {
        this.config.enter.data.call(this, token);
        this.config.exit.data.call(this, token);
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function enterMdxJsxTag(token) {
        /** @type {Tag} */ const tag = {
            name: undefined,
            attributes: [],
            close: false,
            selfClosing: false,
            start: token.start,
            end: token.end
        };
        if (!this.data.mdxJsxTagStack) this.data.mdxJsxTagStack = [];
        this.data.mdxJsxTag = tag;
        this.buffer();
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function enterMdxJsxTagClosingMarker(token) {
        const stack = this.data.mdxJsxTagStack;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(stack, 'expected `mdxJsxTagStack`');
        if (stack.length === 0) throw new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected closing slash `/` in tag, expected an open tag first', {
            start: token.start,
            end: token.end
        }, 'mdast-util-mdx-jsx:unexpected-closing-slash');
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function enterMdxJsxTagAnyAttribute(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        if (tag.close) throw new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected attribute in closing tag, expected the end of the tag', {
            start: token.start,
            end: token.end
        }, 'mdast-util-mdx-jsx:unexpected-attribute');
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function enterMdxJsxTagSelfClosingMarker(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        if (tag.close) throw new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected self-closing slash `/` in closing tag, expected the end of the tag', {
            start: token.start,
            end: token.end
        }, 'mdast-util-mdx-jsx:unexpected-self-closing-slash');
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTagClosingMarker() {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        tag.close = true;
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTagNamePrimary(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        tag.name = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTagNameMember(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        tag.name += '.' + this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTagNameLocal(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        tag.name += ':' + this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function enterMdxJsxTagAttribute(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        enterMdxJsxTagAnyAttribute.call(this, token);
        tag.attributes.push({
            type: 'mdxJsxAttribute',
            name: '',
            value: null,
            position: {
                start: point(token.start),
                // @ts-expect-error: `end` will be patched later.
                end: undefined
            }
        });
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function enterMdxJsxTagExpressionAttribute(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        enterMdxJsxTagAnyAttribute.call(this, token);
        tag.attributes.push({
            type: 'mdxJsxExpressionAttribute',
            value: '',
            position: {
                start: point(token.start),
                // @ts-expect-error: `end` will be patched later.
                end: undefined
            }
        });
        this.buffer();
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTagExpressionAttribute(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        const tail = tag.attributes[tag.attributes.length - 1];
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tail.type === 'mdxJsxExpressionAttribute');
        const estree = token.estree;
        tail.value = this.resume();
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tail.position !== undefined);
        tail.position.end = point(token.end);
        if (estree) tail.data = {
            estree: estree
        };
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTagAttributeNamePrimary(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        const node = tag.attributes[tag.attributes.length - 1];
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'mdxJsxAttribute');
        node.name = this.sliceSerialize(token);
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.position !== undefined);
        node.position.end = point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTagAttributeNameLocal(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        const node = tag.attributes[tag.attributes.length - 1];
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'mdxJsxAttribute');
        node.name += ':' + this.sliceSerialize(token);
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.position !== undefined);
        node.position.end = point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTagAttributeValueLiteral(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        const node = tag.attributes[tag.attributes.length - 1];
        node.value = (0, $fe979033c71e7672$export$6c6c782be925911c)(this.resume(), {
            nonTerminated: false
        });
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.position !== undefined);
        node.position.end = point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTagAttributeValueExpression(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        const tail = tag.attributes[tag.attributes.length - 1];
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tail.type === 'mdxJsxAttribute');
        /** @type {MdxJsxAttributeValueExpression} */ const node = {
            type: 'mdxJsxAttributeValueExpression',
            value: this.resume()
        };
        const estree = token.estree;
        if (estree) node.data = {
            estree: estree
        };
        tail.value = node;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tail.position !== undefined);
        tail.position.end = point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTagSelfClosingMarker() {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        tag.selfClosing = true;
    }
    /**
   * @this {CompileContext}
   * @type {FromMarkdownHandle}
   */ function exitMdxJsxTag(token) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        const stack = this.data.mdxJsxTagStack;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(stack, 'expected `mdxJsxTagStack`');
        const tail = stack[stack.length - 1];
        if (tag.close && tail.name !== tag.name) throw new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected closing tag `' + serializeAbbreviatedTag(tag) + '`, expected corresponding closing tag for `' + serializeAbbreviatedTag(tail) + '` (' + (0, $451965882c5a8799$export$c304dd45fe166145)(tail) + ')', {
            start: token.start,
            end: token.end
        }, 'mdast-util-mdx-jsx:end-tag-mismatch');
        // End of a tag, so drop the buffer.
        this.resume();
        if (tag.close) stack.pop();
        else this.enter({
            type: token.type === 'mdxJsxTextTag' ? 'mdxJsxTextElement' : 'mdxJsxFlowElement',
            name: tag.name || null,
            attributes: tag.attributes,
            children: []
        }, token, onErrorRightIsTag);
        if (tag.selfClosing || tag.close) this.exit(token, onErrorLeftIsTag);
        else stack.push(tag);
    }
    /**
   * @this {CompileContext}
   * @type {OnEnterError}
   */ function onErrorRightIsTag(closing, open) {
        const stack = this.data.mdxJsxTagStack;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(stack, 'expected `mdxJsxTagStack`');
        const tag = stack[stack.length - 1];
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        const place = closing ? ' before the end of `' + closing.type + '`' : '';
        const position = closing ? {
            start: closing.start,
            end: closing.end
        } : undefined;
        throw new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Expected a closing tag for `' + serializeAbbreviatedTag(tag) + '` (' + (0, $451965882c5a8799$export$c304dd45fe166145)({
            start: open.start,
            end: open.end
        }) + ')' + place, position, 'mdast-util-mdx-jsx:end-tag-mismatch');
    }
    /**
   * @this {CompileContext}
   * @type {OnExitError}
   */ function onErrorLeftIsTag(a, b) {
        const tag = this.data.mdxJsxTag;
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(tag, 'expected `mdxJsxTag`');
        throw new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Expected the closing tag `' + serializeAbbreviatedTag(tag) + '` either after the end of `' + b.type + '` (' + (0, $451965882c5a8799$export$c304dd45fe166145)(b.end) + ') or another opening tag after the start of `' + b.type + '` (' + (0, $451965882c5a8799$export$c304dd45fe166145)(b.start) + ')', {
            start: a.start,
            end: a.end
        }, 'mdast-util-mdx-jsx:end-tag-mismatch');
    }
    /**
   * Serialize a tag, excluding attributes.
   * `self-closing` is not supported, because we don’t need it yet.
   *
   * @param {Tag} tag
   * @returns {string}
   */ function serializeAbbreviatedTag(tag) {
        return '<' + (tag.close ? '/' : '') + (tag.name || '') + '>';
    }
}
function $f743b524b3e33495$export$276c5dc6e007d744(options) {
    const options_ = options || {};
    const quote = options_.quote || '"';
    const quoteSmart = options_.quoteSmart || false;
    const tightSelfClosing = options_.tightSelfClosing || false;
    const printWidth = options_.printWidth || Number.POSITIVE_INFINITY;
    const alternative = quote === '"' ? "'" : '"';
    if (quote !== '"' && quote !== "'") throw new Error('Cannot serialize attribute values with `' + quote + '` for `options.quote`, expected `"`, or `\'`');
    mdxElement.peek = $f743b524b3e33495$var$peekElement;
    return {
        handlers: {
            mdxJsxFlowElement: mdxElement,
            mdxJsxTextElement: mdxElement
        },
        unsafe: [
            {
                character: '<',
                inConstruct: [
                    'phrasing'
                ]
            },
            {
                atBreak: true,
                character: '<'
            }
        ],
        // Always generate fenced code (never indented code).
        fences: true,
        // Always generate links with resources (never autolinks).
        resourceLink: true
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {MdxJsxFlowElement | MdxJsxTextElement} node
   */ // eslint-disable-next-line complexity
    function mdxElement(node, _, state, info) {
        const flow = node.type === 'mdxJsxFlowElement';
        const selfClosing = node.name ? !node.children || node.children.length === 0 : false;
        const depth = $f743b524b3e33495$var$inferDepth(state);
        const currentIndent = $f743b524b3e33495$var$createIndent(depth);
        const trackerOneLine = state.createTracker(info);
        const trackerMultiLine = state.createTracker(info);
        /** @type {Array<string>} */ const serializedAttributes = [];
        const prefix = (flow ? currentIndent : '') + '<' + (node.name || '');
        const exit = state.enter(node.type);
        trackerOneLine.move(prefix);
        trackerMultiLine.move(prefix);
        // None.
        if (node.attributes && node.attributes.length > 0) {
            if (!node.name) throw new Error('Cannot serialize fragment w/ attributes');
            let index = -1;
            while(++index < node.attributes.length){
                const attribute = node.attributes[index];
                /** @type {string} */ let result;
                if (attribute.type === 'mdxJsxExpressionAttribute') result = '{' + (attribute.value || '') + '}';
                else {
                    if (!attribute.name) throw new Error('Cannot serialize attribute w/o name');
                    const value = attribute.value;
                    const left = attribute.name;
                    /** @type {string} */ let right = '';
                    if (value === null || value === undefined) ;
                    else if (typeof value === 'object') right = '{' + (value.value || '') + '}';
                    else {
                        // If the alternative is less common than `quote`, switch.
                        const appliedQuote = quoteSmart && (0, $b227513681bd728a$export$fa42eaa97a352e23)(value, quote) > (0, $b227513681bd728a$export$fa42eaa97a352e23)(value, alternative) ? alternative : quote;
                        right = appliedQuote + (0, $4306eeea4ecd9ecc$export$a2577b9dadf100a3)(value, {
                            subset: [
                                appliedQuote
                            ]
                        }) + appliedQuote;
                    }
                    result = left + (right ? '=' : '') + right;
                }
                serializedAttributes.push(result);
            }
        }
        let attributesOnTheirOwnLine = false;
        const attributesOnOneLine = serializedAttributes.join(' ');
        if (// Block:
        flow && // Including a line ending (expressions).
        (/\r?\n|\r/.test(attributesOnOneLine) || // Current position (including `<tag`).
        trackerOneLine.current().now.column + // -1 because columns, +1 for ` ` before attributes.
        // Attributes joined by spaces.
        attributesOnOneLine.length + // ` />`.
        (selfClosing ? tightSelfClosing ? 2 : 3 : 1) > printWidth)) attributesOnTheirOwnLine = true;
        let tracker = trackerOneLine;
        let value = prefix;
        if (attributesOnTheirOwnLine) {
            tracker = trackerMultiLine;
            let index = -1;
            while(++index < serializedAttributes.length)// Only indent first line of of attributes, we can’t indent attribute
            // values.
            serializedAttributes[index] = currentIndent + $f743b524b3e33495$var$indent + serializedAttributes[index];
            value += tracker.move('\n' + serializedAttributes.join('\n') + '\n' + currentIndent);
        } else if (attributesOnOneLine) value += tracker.move(' ' + attributesOnOneLine);
        if (selfClosing) value += tracker.move((tightSelfClosing || attributesOnTheirOwnLine ? '' : ' ') + '/');
        value += tracker.move('>');
        if (node.children && node.children.length > 0) {
            if (node.type === 'mdxJsxTextElement') value += tracker.move(state.containerPhrasing(node, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tracker.current()), {
                before: '>',
                after: '<'
            })));
            else {
                tracker.shift(2);
                value += tracker.move('\n');
                value += tracker.move($f743b524b3e33495$var$containerFlow(node, state, tracker.current()));
                value += tracker.move('\n');
            }
        }
        if (!selfClosing) value += tracker.move((flow ? currentIndent : '') + '</' + (node.name || '') + '>');
        exit();
        return value;
    }
}
// Modified copy of:
// <https://github.com/syntax-tree/mdast-util-to-markdown/blob/a381cbc/lib/util/container-flow.js>.
//
// To do: add `indent` support to `mdast-util-to-markdown`.
// As indents are only used for JSX, it’s fine for now, but perhaps better
// there.
/**
 * @param {MdxJsxFlowElement} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {ReturnType<Tracker['current']>} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $f743b524b3e33495$var$containerFlow(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children;
    const tracker = state.createTracker(info);
    const currentIndent = $f743b524b3e33495$var$createIndent($f743b524b3e33495$var$inferDepth(state));
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        const childInfo = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: '\n',
            after: '\n'
        }, tracker.current());
        const result = state.handle(child, parent, state, childInfo);
        const serializedChild = child.type === 'mdxJsxFlowElement' ? result : state.indentLines(result, function(line, _, blank) {
            return (blank ? '' : currentIndent) + line;
        });
        results.push(tracker.move(serializedChild));
        if (child.type !== 'list') state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move('\n\n'));
    }
    indexStack.pop();
    return results.join('');
}
/**
 * @param {State} state
 * @returns {number}
 */ function $f743b524b3e33495$var$inferDepth(state) {
    let depth = 0;
    let index = state.stack.length;
    while(--index > -1){
        const name = state.stack[index];
        if (name === 'blockquote' || name === 'listItem') break;
        if (name === 'mdxJsxFlowElement') depth++;
    }
    return depth;
}
/**
 * @param {number} depth
 * @returns {string}
 */ function $f743b524b3e33495$var$createIndent(depth) {
    return $f743b524b3e33495$var$indent.repeat(depth);
}
/**
 * @type {ToMarkdownHandle}
 */ function $f743b524b3e33495$var$peekElement() {
    return '<';
}


// src/html.ts
var $77ed2de27e076439$var$has = Object.prototype.hasOwnProperty;
function $77ed2de27e076439$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($77ed2de27e076439$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $77ed2de27e076439$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $77ed2de27e076439$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $77ed2de27e076439$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $77ed2de27e076439$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$77ed2de27e076439$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($77ed2de27e076439$var$has.call(foo, ctor) && ++len && !$77ed2de27e076439$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$77ed2de27e076439$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}


'use strict';
let $223a2b1eb8cb557d$var$FORCE_COLOR, $223a2b1eb8cb557d$var$NODE_DISABLE_COLORS, $223a2b1eb8cb557d$var$NO_COLOR, $223a2b1eb8cb557d$var$TERM, $223a2b1eb8cb557d$var$isTTY = true;
const $223a2b1eb8cb557d$var$$ = {
    enabled: !$223a2b1eb8cb557d$var$NODE_DISABLE_COLORS && $223a2b1eb8cb557d$var$NO_COLOR == null && $223a2b1eb8cb557d$var$TERM !== 'dumb' && ($223a2b1eb8cb557d$var$FORCE_COLOR != null && $223a2b1eb8cb557d$var$FORCE_COLOR !== '0' || $223a2b1eb8cb557d$var$isTTY),
    // modifiers
    reset: $223a2b1eb8cb557d$var$init(0, 0),
    bold: $223a2b1eb8cb557d$var$init(1, 22),
    dim: $223a2b1eb8cb557d$var$init(2, 22),
    italic: $223a2b1eb8cb557d$var$init(3, 23),
    underline: $223a2b1eb8cb557d$var$init(4, 24),
    inverse: $223a2b1eb8cb557d$var$init(7, 27),
    hidden: $223a2b1eb8cb557d$var$init(8, 28),
    strikethrough: $223a2b1eb8cb557d$var$init(9, 29),
    // colors
    black: $223a2b1eb8cb557d$var$init(30, 39),
    red: $223a2b1eb8cb557d$var$init(31, 39),
    green: $223a2b1eb8cb557d$var$init(32, 39),
    yellow: $223a2b1eb8cb557d$var$init(33, 39),
    blue: $223a2b1eb8cb557d$var$init(34, 39),
    magenta: $223a2b1eb8cb557d$var$init(35, 39),
    cyan: $223a2b1eb8cb557d$var$init(36, 39),
    white: $223a2b1eb8cb557d$var$init(37, 39),
    gray: $223a2b1eb8cb557d$var$init(90, 39),
    grey: $223a2b1eb8cb557d$var$init(90, 39),
    // background colors
    bgBlack: $223a2b1eb8cb557d$var$init(40, 49),
    bgRed: $223a2b1eb8cb557d$var$init(41, 49),
    bgGreen: $223a2b1eb8cb557d$var$init(42, 49),
    bgYellow: $223a2b1eb8cb557d$var$init(43, 49),
    bgBlue: $223a2b1eb8cb557d$var$init(44, 49),
    bgMagenta: $223a2b1eb8cb557d$var$init(45, 49),
    bgCyan: $223a2b1eb8cb557d$var$init(46, 49),
    bgWhite: $223a2b1eb8cb557d$var$init(47, 49)
};
function $223a2b1eb8cb557d$var$run(arr, str) {
    let i = 0, tmp, beg = '', end = '';
    for(; i < arr.length; i++){
        tmp = arr[i];
        beg += tmp.open;
        end += tmp.close;
        if (!!~str.indexOf(tmp.close)) str = str.replace(tmp.rgx, tmp.close + tmp.open);
    }
    return beg + str + end;
}
function $223a2b1eb8cb557d$var$chain(has, keys) {
    let ctx = {
        has: has,
        keys: keys
    };
    ctx.reset = $223a2b1eb8cb557d$var$$.reset.bind(ctx);
    ctx.bold = $223a2b1eb8cb557d$var$$.bold.bind(ctx);
    ctx.dim = $223a2b1eb8cb557d$var$$.dim.bind(ctx);
    ctx.italic = $223a2b1eb8cb557d$var$$.italic.bind(ctx);
    ctx.underline = $223a2b1eb8cb557d$var$$.underline.bind(ctx);
    ctx.inverse = $223a2b1eb8cb557d$var$$.inverse.bind(ctx);
    ctx.hidden = $223a2b1eb8cb557d$var$$.hidden.bind(ctx);
    ctx.strikethrough = $223a2b1eb8cb557d$var$$.strikethrough.bind(ctx);
    ctx.black = $223a2b1eb8cb557d$var$$.black.bind(ctx);
    ctx.red = $223a2b1eb8cb557d$var$$.red.bind(ctx);
    ctx.green = $223a2b1eb8cb557d$var$$.green.bind(ctx);
    ctx.yellow = $223a2b1eb8cb557d$var$$.yellow.bind(ctx);
    ctx.blue = $223a2b1eb8cb557d$var$$.blue.bind(ctx);
    ctx.magenta = $223a2b1eb8cb557d$var$$.magenta.bind(ctx);
    ctx.cyan = $223a2b1eb8cb557d$var$$.cyan.bind(ctx);
    ctx.white = $223a2b1eb8cb557d$var$$.white.bind(ctx);
    ctx.gray = $223a2b1eb8cb557d$var$$.gray.bind(ctx);
    ctx.grey = $223a2b1eb8cb557d$var$$.grey.bind(ctx);
    ctx.bgBlack = $223a2b1eb8cb557d$var$$.bgBlack.bind(ctx);
    ctx.bgRed = $223a2b1eb8cb557d$var$$.bgRed.bind(ctx);
    ctx.bgGreen = $223a2b1eb8cb557d$var$$.bgGreen.bind(ctx);
    ctx.bgYellow = $223a2b1eb8cb557d$var$$.bgYellow.bind(ctx);
    ctx.bgBlue = $223a2b1eb8cb557d$var$$.bgBlue.bind(ctx);
    ctx.bgMagenta = $223a2b1eb8cb557d$var$$.bgMagenta.bind(ctx);
    ctx.bgCyan = $223a2b1eb8cb557d$var$$.bgCyan.bind(ctx);
    ctx.bgWhite = $223a2b1eb8cb557d$var$$.bgWhite.bind(ctx);
    return ctx;
}
function $223a2b1eb8cb557d$var$init(open, close) {
    let blk = {
        open: `\x1b[${open}m`,
        close: `\x1b[${close}m`,
        rgx: new RegExp(`\\x1b\\[${close}m`, 'g')
    };
    return function(txt) {
        if (this !== void 0 && this.has !== void 0) {
            !!~this.has.indexOf(open) || (this.has.push(open), this.keys.push(blk));
            return txt === void 0 ? this : $223a2b1eb8cb557d$var$$.enabled ? $223a2b1eb8cb557d$var$run(this.keys, txt + '') : txt + '';
        }
        return txt === void 0 ? $223a2b1eb8cb557d$var$chain([
            open
        ], [
            blk
        ]) : $223a2b1eb8cb557d$var$$.enabled ? $223a2b1eb8cb557d$var$run([
            blk
        ], txt + '') : txt + '';
    };
}
var $223a2b1eb8cb557d$export$2e2bcd8739ae039 = $223a2b1eb8cb557d$var$$;


function $4cdcc2e9633bfadb$export$4d8163e2fffcfca2() {}
$4cdcc2e9633bfadb$export$4d8163e2fffcfca2.prototype = {
    diff: function diff(oldString, newString) {
        var _options$timeout;
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
        var callback = options.callback;
        if (typeof options === 'function') {
            callback = options;
            options = {};
        }
        this.options = options;
        var self = this;
        function done(value) {
            if (callback) {
                setTimeout(function() {
                    callback(undefined, value);
                }, 0);
                return true;
            } else return value;
        } // Allow subclasses to massage the input prior to running
        oldString = this.castInput(oldString);
        newString = this.castInput(newString);
        oldString = this.removeEmpty(this.tokenize(oldString));
        newString = this.removeEmpty(this.tokenize(newString));
        var newLen = newString.length, oldLen = oldString.length;
        var editLength = 1;
        var maxEditLength = newLen + oldLen;
        if (options.maxEditLength) maxEditLength = Math.min(maxEditLength, options.maxEditLength);
        var maxExecutionTime = (_options$timeout = options.timeout) !== null && _options$timeout !== void 0 ? _options$timeout : Infinity;
        var abortAfterTimestamp = Date.now() + maxExecutionTime;
        var bestPath = [
            {
                oldPos: -1,
                lastComponent: undefined
            }
        ]; // Seed editLength = 0, i.e. the content starts with the same values
        var newPos = this.extractCommon(bestPath[0], newString, oldString, 0);
        if (bestPath[0].oldPos + 1 >= oldLen && newPos + 1 >= newLen) // Identity per the equality and tokenizer
        return done([
            {
                value: this.join(newString),
                count: newString.length
            }
        ]);
         // Once we hit the right edge of the edit graph on some diagonal k, we can
        // definitely reach the end of the edit graph in no more than k edits, so
        // there's no point in considering any moves to diagonal k+1 any more (from
        // which we're guaranteed to need at least k+1 more edits).
        // Similarly, once we've reached the bottom of the edit graph, there's no
        // point considering moves to lower diagonals.
        // We record this fact by setting minDiagonalToConsider and
        // maxDiagonalToConsider to some finite value once we've hit the edge of
        // the edit graph.
        // This optimization is not faithful to the original algorithm presented in
        // Myers's paper, which instead pointlessly extends D-paths off the end of
        // the edit graph - see page 7 of Myers's paper which notes this point
        // explicitly and illustrates it with a diagram. This has major performance
        // implications for some common scenarios. For instance, to compute a diff
        // where the new text simply appends d characters on the end of the
        // original text of length n, the true Myers algorithm will take O(n+d^2)
        // time while this optimization needs only O(n+d) time.
        var minDiagonalToConsider = -Infinity, maxDiagonalToConsider = Infinity; // Main worker method. checks all permutations of a given edit length for acceptance.
        function execEditLength() {
            for(var diagonalPath = Math.max(minDiagonalToConsider, -editLength); diagonalPath <= Math.min(maxDiagonalToConsider, editLength); diagonalPath += 2){
                var basePath = void 0;
                var removePath = bestPath[diagonalPath - 1], addPath = bestPath[diagonalPath + 1];
                if (removePath) // No one else is going to attempt to use this value, clear it
                bestPath[diagonalPath - 1] = undefined;
                var canAdd = false;
                if (addPath) {
                    // what newPos will be after we do an insertion:
                    var addPathNewPos = addPath.oldPos - diagonalPath;
                    canAdd = addPath && 0 <= addPathNewPos && addPathNewPos < newLen;
                }
                var canRemove = removePath && removePath.oldPos + 1 < oldLen;
                if (!canAdd && !canRemove) {
                    // If this path is a terminal then prune
                    bestPath[diagonalPath] = undefined;
                    continue;
                } // Select the diagonal that we want to branch from. We select the prior
                // path whose position in the old string is the farthest from the origin
                // and does not pass the bounds of the diff graph
                // TODO: Remove the `+ 1` here to make behavior match Myers algorithm
                //       and prefer to order removals before insertions.
                if (!canRemove || canAdd && removePath.oldPos + 1 < addPath.oldPos) basePath = self.addToPath(addPath, true, undefined, 0);
                else basePath = self.addToPath(removePath, undefined, true, 1);
                newPos = self.extractCommon(basePath, newString, oldString, diagonalPath);
                if (basePath.oldPos + 1 >= oldLen && newPos + 1 >= newLen) // If we have hit the end of both strings, then we are done
                return done($4cdcc2e9633bfadb$var$buildValues(self, basePath.lastComponent, newString, oldString, self.useLongestToken));
                else {
                    bestPath[diagonalPath] = basePath;
                    if (basePath.oldPos + 1 >= oldLen) maxDiagonalToConsider = Math.min(maxDiagonalToConsider, diagonalPath - 1);
                    if (newPos + 1 >= newLen) minDiagonalToConsider = Math.max(minDiagonalToConsider, diagonalPath + 1);
                }
            }
            editLength++;
        } // Performs the length of edit iteration. Is a bit fugly as this has to support the
        // sync and async mode which is never fun. Loops over execEditLength until a value
        // is produced, or until the edit length exceeds options.maxEditLength (if given),
        // in which case it will return undefined.
        if (callback) (function exec() {
            setTimeout(function() {
                if (editLength > maxEditLength || Date.now() > abortAfterTimestamp) return callback();
                if (!execEditLength()) exec();
            }, 0);
        })();
        else while(editLength <= maxEditLength && Date.now() <= abortAfterTimestamp){
            var ret = execEditLength();
            if (ret) return ret;
        }
    },
    addToPath: function addToPath(path, added, removed, oldPosInc) {
        var last = path.lastComponent;
        if (last && last.added === added && last.removed === removed) return {
            oldPos: path.oldPos + oldPosInc,
            lastComponent: {
                count: last.count + 1,
                added: added,
                removed: removed,
                previousComponent: last.previousComponent
            }
        };
        else return {
            oldPos: path.oldPos + oldPosInc,
            lastComponent: {
                count: 1,
                added: added,
                removed: removed,
                previousComponent: last
            }
        };
    },
    extractCommon: function extractCommon(basePath, newString, oldString, diagonalPath) {
        var newLen = newString.length, oldLen = oldString.length, oldPos = basePath.oldPos, newPos = oldPos - diagonalPath, commonCount = 0;
        while(newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newString[newPos + 1], oldString[oldPos + 1])){
            newPos++;
            oldPos++;
            commonCount++;
        }
        if (commonCount) basePath.lastComponent = {
            count: commonCount,
            previousComponent: basePath.lastComponent
        };
        basePath.oldPos = oldPos;
        return newPos;
    },
    equals: function equals(left, right) {
        if (this.options.comparator) return this.options.comparator(left, right);
        else return left === right || this.options.ignoreCase && left.toLowerCase() === right.toLowerCase();
    },
    removeEmpty: function removeEmpty(array) {
        var ret = [];
        for(var i = 0; i < array.length; i++)if (array[i]) ret.push(array[i]);
        return ret;
    },
    castInput: function castInput(value) {
        return value;
    },
    tokenize: function tokenize(value) {
        return value.split('');
    },
    join: function join(chars) {
        return chars.join('');
    }
};
function $4cdcc2e9633bfadb$var$buildValues(diff, lastComponent, newString, oldString, useLongestToken) {
    // First we convert our linked list of components in reverse order to an
    // array in the right order:
    var components = [];
    var nextComponent;
    while(lastComponent){
        components.push(lastComponent);
        nextComponent = lastComponent.previousComponent;
        delete lastComponent.previousComponent;
        lastComponent = nextComponent;
    }
    components.reverse();
    var componentPos = 0, componentLen = components.length, newPos = 0, oldPos = 0;
    for(; componentPos < componentLen; componentPos++){
        var component = components[componentPos];
        if (!component.removed) {
            if (!component.added && useLongestToken) {
                var value = newString.slice(newPos, newPos + component.count);
                value = value.map(function(value, i) {
                    var oldValue = oldString[oldPos + i];
                    return oldValue.length > value.length ? oldValue : value;
                });
                component.value = diff.join(value);
            } else component.value = diff.join(newString.slice(newPos, newPos + component.count));
            newPos += component.count; // Common case
            if (!component.added) oldPos += component.count;
        } else {
            component.value = diff.join(oldString.slice(oldPos, oldPos + component.count));
            oldPos += component.count; // Reverse add and remove so removes are output first to match common convention
            // The diffing algorithm is tied to add then remove output and this is the simplest
            // route to get the desired output with minimal overhead.
            if (componentPos && components[componentPos - 1].added) {
                var tmp = components[componentPos - 1];
                components[componentPos - 1] = components[componentPos];
                components[componentPos] = tmp;
            }
        }
    } // Special case handle for when one terminal is ignored (i.e. whitespace).
    // For this case we merge the terminal into the prior string and drop the change.
    // This is only available for string mode.
    var finalComponent = components[componentLen - 1];
    if (componentLen > 1 && typeof finalComponent.value === 'string' && (finalComponent.added || finalComponent.removed) && diff.equals('', finalComponent.value)) {
        components[componentLen - 2].value += finalComponent.value;
        components.pop();
    }
    return components;
}
var $4cdcc2e9633bfadb$var$characterDiff = new $4cdcc2e9633bfadb$export$4d8163e2fffcfca2();
function $4cdcc2e9633bfadb$export$325021f2061a40f5(oldStr, newStr, options) {
    return $4cdcc2e9633bfadb$var$characterDiff.diff(oldStr, newStr, options);
}
function $4cdcc2e9633bfadb$var$generateOptions(options, defaults) {
    if (typeof options === 'function') defaults.callback = options;
    else if (options) {
        for(var name in options)/* istanbul ignore else */ if (options.hasOwnProperty(name)) defaults[name] = options[name];
    }
    return defaults;
}
//
// Ranges and exceptions:
// Latin-1 Supplement, 0080–00FF
//  - U+00D7  × Multiplication sign
//  - U+00F7  ÷ Division sign
// Latin Extended-A, 0100–017F
// Latin Extended-B, 0180–024F
// IPA Extensions, 0250–02AF
// Spacing Modifier Letters, 02B0–02FF
//  - U+02C7  ˇ &#711;  Caron
//  - U+02D8  ˘ &#728;  Breve
//  - U+02D9  ˙ &#729;  Dot Above
//  - U+02DA  ˚ &#730;  Ring Above
//  - U+02DB  ˛ &#731;  Ogonek
//  - U+02DC  ˜ &#732;  Small Tilde
//  - U+02DD  ˝ &#733;  Double Acute Accent
// Latin Extended Additional, 1E00–1EFF
var $4cdcc2e9633bfadb$var$extendedWordChars = /^[A-Za-z\xC0-\u02C6\u02C8-\u02D7\u02DE-\u02FF\u1E00-\u1EFF]+$/;
var $4cdcc2e9633bfadb$var$reWhitespace = /\S/;
var $4cdcc2e9633bfadb$var$wordDiff = new $4cdcc2e9633bfadb$export$4d8163e2fffcfca2();
$4cdcc2e9633bfadb$var$wordDiff.equals = function(left, right) {
    if (this.options.ignoreCase) {
        left = left.toLowerCase();
        right = right.toLowerCase();
    }
    return left === right || this.options.ignoreWhitespace && !$4cdcc2e9633bfadb$var$reWhitespace.test(left) && !$4cdcc2e9633bfadb$var$reWhitespace.test(right);
};
$4cdcc2e9633bfadb$var$wordDiff.tokenize = function(value) {
    // All whitespace symbols except newline group into one token, each newline - in separate token
    var tokens = value.split(/([^\S\r\n]+|[()[\]{}'"\r\n]|\b)/); // Join the boundary splits that we do not consider to be boundaries. This is primarily the extended Latin character set.
    for(var i = 0; i < tokens.length - 1; i++)// If we have an empty string in the next field and we have only word chars before and after, merge
    if (!tokens[i + 1] && tokens[i + 2] && $4cdcc2e9633bfadb$var$extendedWordChars.test(tokens[i]) && $4cdcc2e9633bfadb$var$extendedWordChars.test(tokens[i + 2])) {
        tokens[i] += tokens[i + 2];
        tokens.splice(i + 1, 2);
        i--;
    }
    return tokens;
};
function $4cdcc2e9633bfadb$export$5643fba310ccb33(oldStr, newStr, options) {
    options = $4cdcc2e9633bfadb$var$generateOptions(options, {
        ignoreWhitespace: true
    });
    return $4cdcc2e9633bfadb$var$wordDiff.diff(oldStr, newStr, options);
}
function $4cdcc2e9633bfadb$export$3941790a84174c86(oldStr, newStr, options) {
    return $4cdcc2e9633bfadb$var$wordDiff.diff(oldStr, newStr, options);
}
var $4cdcc2e9633bfadb$var$lineDiff = new $4cdcc2e9633bfadb$export$4d8163e2fffcfca2();
$4cdcc2e9633bfadb$var$lineDiff.tokenize = function(value) {
    if (this.options.stripTrailingCr) // remove one \r before \n to match GNU diff's --strip-trailing-cr behavior
    value = value.replace(/\r\n/g, '\n');
    var retLines = [], linesAndNewlines = value.split(/(\n|\r\n)/); // Ignore the final empty token that occurs if the string ends with a new line
    if (!linesAndNewlines[linesAndNewlines.length - 1]) linesAndNewlines.pop();
     // Merge the content and line separators into single tokens
    for(var i = 0; i < linesAndNewlines.length; i++){
        var line = linesAndNewlines[i];
        if (i % 2 && !this.options.newlineIsToken) retLines[retLines.length - 1] += line;
        else {
            if (this.options.ignoreWhitespace) line = line.trim();
            retLines.push(line);
        }
    }
    return retLines;
};
function $4cdcc2e9633bfadb$export$a2a88fc03c6c0a3(oldStr, newStr, callback) {
    return $4cdcc2e9633bfadb$var$lineDiff.diff(oldStr, newStr, callback);
}
function $4cdcc2e9633bfadb$export$cd9eeaf4d4607510(oldStr, newStr, callback) {
    var options = $4cdcc2e9633bfadb$var$generateOptions(callback, {
        ignoreWhitespace: true
    });
    return $4cdcc2e9633bfadb$var$lineDiff.diff(oldStr, newStr, options);
}
var $4cdcc2e9633bfadb$var$sentenceDiff = new $4cdcc2e9633bfadb$export$4d8163e2fffcfca2();
$4cdcc2e9633bfadb$var$sentenceDiff.tokenize = function(value) {
    return value.split(/(\S.+?[.!?])(?=\s+|$)/);
};
function $4cdcc2e9633bfadb$export$59a838b01f064bbb(oldStr, newStr, callback) {
    return $4cdcc2e9633bfadb$var$sentenceDiff.diff(oldStr, newStr, callback);
}
var $4cdcc2e9633bfadb$var$cssDiff = new $4cdcc2e9633bfadb$export$4d8163e2fffcfca2();
$4cdcc2e9633bfadb$var$cssDiff.tokenize = function(value) {
    return value.split(/([{}:;,]|\s+)/);
};
function $4cdcc2e9633bfadb$export$c4fce3ea136641c(oldStr, newStr, callback) {
    return $4cdcc2e9633bfadb$var$cssDiff.diff(oldStr, newStr, callback);
}
function $4cdcc2e9633bfadb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4cdcc2e9633bfadb$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $4cdcc2e9633bfadb$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4cdcc2e9633bfadb$var$_typeof(obj);
}
function $4cdcc2e9633bfadb$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4cdcc2e9633bfadb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4cdcc2e9633bfadb$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4cdcc2e9633bfadb$var$ownKeys(Object(source), true).forEach(function(key) {
            $4cdcc2e9633bfadb$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4cdcc2e9633bfadb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4cdcc2e9633bfadb$var$_toConsumableArray(arr) {
    return $4cdcc2e9633bfadb$var$_arrayWithoutHoles(arr) || $4cdcc2e9633bfadb$var$_iterableToArray(arr) || $4cdcc2e9633bfadb$var$_unsupportedIterableToArray(arr) || $4cdcc2e9633bfadb$var$_nonIterableSpread();
}
function $4cdcc2e9633bfadb$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4cdcc2e9633bfadb$var$_arrayLikeToArray(arr);
}
function $4cdcc2e9633bfadb$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $4cdcc2e9633bfadb$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4cdcc2e9633bfadb$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4cdcc2e9633bfadb$var$_arrayLikeToArray(o, minLen);
}
function $4cdcc2e9633bfadb$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4cdcc2e9633bfadb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $4cdcc2e9633bfadb$var$objectPrototypeToString = Object.prototype.toString;
var $4cdcc2e9633bfadb$var$jsonDiff = new $4cdcc2e9633bfadb$export$4d8163e2fffcfca2(); // Discriminate between two lines of pretty-printed, serialized JSON where one of them has a
// dangling comma and the other doesn't. Turns out including the dangling comma yields the nicest output:
$4cdcc2e9633bfadb$var$jsonDiff.useLongestToken = true;
$4cdcc2e9633bfadb$var$jsonDiff.tokenize = $4cdcc2e9633bfadb$var$lineDiff.tokenize;
$4cdcc2e9633bfadb$var$jsonDiff.castInput = function(value) {
    var _this$options = this.options, undefinedReplacement = _this$options.undefinedReplacement, _this$options$stringi = _this$options.stringifyReplacer, stringifyReplacer = _this$options$stringi === void 0 ? function(k, v) {
        return typeof v === 'undefined' ? undefinedReplacement : v;
    } : _this$options$stringi;
    return typeof value === 'string' ? value : JSON.stringify($4cdcc2e9633bfadb$export$e55b76bdd351fffc(value, null, null, stringifyReplacer), stringifyReplacer, '  ');
};
$4cdcc2e9633bfadb$var$jsonDiff.equals = function(left, right) {
    return $4cdcc2e9633bfadb$export$4d8163e2fffcfca2.prototype.equals.call($4cdcc2e9633bfadb$var$jsonDiff, left.replace(/,([\r\n])/g, '$1'), right.replace(/,([\r\n])/g, '$1'));
};
function $4cdcc2e9633bfadb$export$904c012e6be94faf(oldObj, newObj, options) {
    return $4cdcc2e9633bfadb$var$jsonDiff.diff(oldObj, newObj, options);
} // This function handles the presence of circular references by bailing out when encountering an
// object that is already on the "stack" of items being processed. Accepts an optional replacer
function $4cdcc2e9633bfadb$export$e55b76bdd351fffc(obj, stack, replacementStack, replacer, key) {
    stack = stack || [];
    replacementStack = replacementStack || [];
    if (replacer) obj = replacer(key, obj);
    var i;
    for(i = 0; i < stack.length; i += 1){
        if (stack[i] === obj) return replacementStack[i];
    }
    var canonicalizedObj;
    if ('[object Array]' === $4cdcc2e9633bfadb$var$objectPrototypeToString.call(obj)) {
        stack.push(obj);
        canonicalizedObj = new Array(obj.length);
        replacementStack.push(canonicalizedObj);
        for(i = 0; i < obj.length; i += 1)canonicalizedObj[i] = $4cdcc2e9633bfadb$export$e55b76bdd351fffc(obj[i], stack, replacementStack, replacer, key);
        stack.pop();
        replacementStack.pop();
        return canonicalizedObj;
    }
    if (obj && obj.toJSON) obj = obj.toJSON();
    if ($4cdcc2e9633bfadb$var$_typeof(obj) === 'object' && obj !== null) {
        stack.push(obj);
        canonicalizedObj = {};
        replacementStack.push(canonicalizedObj);
        var sortedKeys = [], _key;
        for(_key in obj)/* istanbul ignore else */ if (obj.hasOwnProperty(_key)) sortedKeys.push(_key);
        sortedKeys.sort();
        for(i = 0; i < sortedKeys.length; i += 1){
            _key = sortedKeys[i];
            canonicalizedObj[_key] = $4cdcc2e9633bfadb$export$e55b76bdd351fffc(obj[_key], stack, replacementStack, replacer, _key);
        }
        stack.pop();
        replacementStack.pop();
    } else canonicalizedObj = obj;
    return canonicalizedObj;
}
var $4cdcc2e9633bfadb$var$arrayDiff = new $4cdcc2e9633bfadb$export$4d8163e2fffcfca2();
$4cdcc2e9633bfadb$var$arrayDiff.tokenize = function(value) {
    return value.slice();
};
$4cdcc2e9633bfadb$var$arrayDiff.join = $4cdcc2e9633bfadb$var$arrayDiff.removeEmpty = function(value) {
    return value;
};
function $4cdcc2e9633bfadb$export$f1c08b3bfc8443c4(oldArr, newArr, callback) {
    return $4cdcc2e9633bfadb$var$arrayDiff.diff(oldArr, newArr, callback);
}
function $4cdcc2e9633bfadb$export$319fae3601428334(uniDiff) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var diffstr = uniDiff.split(/\r\n|[\n\v\f\r\x85]/), delimiters = uniDiff.match(/\r\n|[\n\v\f\r\x85]/g) || [], list = [], i = 0;
    function parseIndex() {
        var index = {};
        list.push(index); // Parse diff metadata
        while(i < diffstr.length){
            var line = diffstr[i]; // File header found, end parsing diff metadata
            if (/^(\-\-\-|\+\+\+|@@)\s/.test(line)) break;
             // Diff index
            var headerMatch = /^(?:Index:|diff(?: -r \w+)+)\s+/.exec(line);
            if (headerMatch) index.index = line.substring(headerMatch[0].length).trim();
            i++;
        } // Parse file headers if they are defined. Unified diff requires them, but
        // there's no technical issues to have an isolated hunk without file header
        parseFileHeader(index);
        parseFileHeader(index); // Parse hunks
        index.hunks = [];
        while(i < diffstr.length){
            var _line = diffstr[i];
            if (/^(Index:|diff|\-\-\-|\+\+\+)\s/.test(_line)) break;
            else if (/^@@/.test(_line)) index.hunks.push(parseHunk());
            else if (_line && options.strict) // Ignore unexpected content unless in strict mode
            throw new Error('Unknown line ' + (i + 1) + ' ' + JSON.stringify(_line));
            else i++;
        }
    } // Parses the --- and +++ headers, if none are found, no lines
    // are consumed.
    function parseFileHeader(index) {
        var fileHeaderMatch = /^(---|\+\+\+)\s+/.exec(diffstr[i]);
        if (fileHeaderMatch) {
            var keyPrefix = fileHeaderMatch[1] === '---' ? 'old' : 'new';
            var data = diffstr[i].substring(3).trim().split('\t', 2);
            var fileName = data[0].replace(/\\\\/g, '\\');
            if (fileName.startsWith('"') && fileName.endsWith('"')) fileName = fileName.substr(1, fileName.length - 2);
            index[keyPrefix + 'FileName'] = fileName;
            index[keyPrefix + 'Header'] = (data[1] || '').trim();
            i++;
        }
    } // Parses a hunk
    // This assumes that we are at the start of a hunk.
    function parseHunk() {
        var chunkHeaderIndex = i, chunkHeaderLine = diffstr[i++], chunkHeader = chunkHeaderLine.split(/@@ -(\d+)(?:,(\d+))? \+(\d+)(?:,(\d+))? @@/);
        var hunk = {
            oldStart: +chunkHeader[1],
            oldLines: typeof chunkHeader[2] === 'undefined' ? 1 : +chunkHeader[2],
            newStart: +chunkHeader[3],
            newLines: typeof chunkHeader[4] === 'undefined' ? 1 : +chunkHeader[4],
            lines: [],
            linedelimiters: []
        }; // Unified Diff Format quirk: If the chunk size is 0,
        // the first number is one lower than one would expect.
        // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
        if (hunk.oldLines === 0) hunk.oldStart += 1;
        if (hunk.newLines === 0) hunk.newStart += 1;
        var addCount = 0, removeCount = 0;
        for(; i < diffstr.length; i++){
            // Lines starting with '---' could be mistaken for the "remove line" operation
            // But they could be the header for the next file. Therefore prune such cases out.
            if (diffstr[i].indexOf('--- ') === 0 && i + 2 < diffstr.length && diffstr[i + 1].indexOf('+++ ') === 0 && diffstr[i + 2].indexOf('@@') === 0) break;
            var operation = diffstr[i].length == 0 && i != diffstr.length - 1 ? ' ' : diffstr[i][0];
            if (operation === '+' || operation === '-' || operation === ' ' || operation === '\\') {
                hunk.lines.push(diffstr[i]);
                hunk.linedelimiters.push(delimiters[i] || '\n');
                if (operation === '+') addCount++;
                else if (operation === '-') removeCount++;
                else if (operation === ' ') {
                    addCount++;
                    removeCount++;
                }
            } else break;
        } // Handle the empty block count case
        if (!addCount && hunk.newLines === 1) hunk.newLines = 0;
        if (!removeCount && hunk.oldLines === 1) hunk.oldLines = 0;
         // Perform optional sanity checking
        if (options.strict) {
            if (addCount !== hunk.newLines) throw new Error('Added line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
            if (removeCount !== hunk.oldLines) throw new Error('Removed line count did not match for hunk at line ' + (chunkHeaderIndex + 1));
        }
        return hunk;
    }
    while(i < diffstr.length)parseIndex();
    return list;
}
// Iterator that traverses in the range of [min, max], stepping
// by distance from a given start position. I.e. for [0, 4], with
// start of 2, this will iterate 2, 3, 1, 4, 0.
function $4cdcc2e9633bfadb$var$distanceIterator(start, minLine, maxLine) {
    var wantForward = true, backwardExhausted = false, forwardExhausted = false, localOffset = 1;
    return function iterator() {
        if (wantForward && !forwardExhausted) {
            if (backwardExhausted) localOffset++;
            else wantForward = false;
             // Check if trying to fit beyond text length, and if not, check it fits
            // after offset location (or desired location on first iteration)
            if (start + localOffset <= maxLine) return localOffset;
            forwardExhausted = true;
        }
        if (!backwardExhausted) {
            if (!forwardExhausted) wantForward = true;
             // Check if trying to fit before text beginning, and if not, check it fits
            // before offset location
            if (minLine <= start - localOffset) return -localOffset++;
            backwardExhausted = true;
            return iterator();
        } // We tried to fit hunk before text beginning and beyond text length, then
    // hunk can't fit on the text. Return undefined
    };
}
function $4cdcc2e9633bfadb$export$7383fd3fd73657b6(source, uniDiff) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (typeof uniDiff === 'string') uniDiff = $4cdcc2e9633bfadb$export$319fae3601428334(uniDiff);
    if (Array.isArray(uniDiff)) {
        if (uniDiff.length > 1) throw new Error('applyPatch only works with a single input.');
        uniDiff = uniDiff[0];
    } // Apply the diff to the input
    var lines = source.split(/\r\n|[\n\v\f\r\x85]/), delimiters = source.match(/\r\n|[\n\v\f\r\x85]/g) || [], hunks = uniDiff.hunks, compareLine = options.compareLine || function(lineNumber, line, operation, patchContent) {
        return line === patchContent;
    }, errorCount = 0, fuzzFactor = options.fuzzFactor || 0, minLine = 0, offset = 0, removeEOFNL, addEOFNL;
    /**
   * Checks if the hunk exactly fits on the provided location
   */ function hunkFits(hunk, toPos) {
        for(var j = 0; j < hunk.lines.length; j++){
            var line = hunk.lines[j], operation = line.length > 0 ? line[0] : ' ', content = line.length > 0 ? line.substr(1) : line;
            if (operation === ' ' || operation === '-') {
                // Context sanity check
                if (!compareLine(toPos + 1, lines[toPos], operation, content)) {
                    errorCount++;
                    if (errorCount > fuzzFactor) return false;
                }
                toPos++;
            }
        }
        return true;
    } // Search best fit offsets for each hunk based on the previous ones
    for(var i = 0; i < hunks.length; i++){
        var hunk = hunks[i], maxLine = lines.length - hunk.oldLines, localOffset = 0, toPos = offset + hunk.oldStart - 1;
        var iterator = $4cdcc2e9633bfadb$var$distanceIterator(toPos, minLine, maxLine);
        for(; localOffset !== undefined; localOffset = iterator())if (hunkFits(hunk, toPos + localOffset)) {
            hunk.offset = offset += localOffset;
            break;
        }
        if (localOffset === undefined) return false;
         // Set lower text limit to end of the current hunk, so next ones don't try
        // to fit over already patched text
        minLine = hunk.offset + hunk.oldStart + hunk.oldLines;
    } // Apply patch hunks
    var diffOffset = 0;
    for(var _i = 0; _i < hunks.length; _i++){
        var _hunk = hunks[_i], _toPos = _hunk.oldStart + _hunk.offset + diffOffset - 1;
        diffOffset += _hunk.newLines - _hunk.oldLines;
        for(var j = 0; j < _hunk.lines.length; j++){
            var line = _hunk.lines[j], operation = line.length > 0 ? line[0] : ' ', content = line.length > 0 ? line.substr(1) : line, delimiter = _hunk.linedelimiters && _hunk.linedelimiters[j] || '\n';
            if (operation === ' ') _toPos++;
            else if (operation === '-') {
                lines.splice(_toPos, 1);
                delimiters.splice(_toPos, 1);
            /* istanbul ignore else */ } else if (operation === '+') {
                lines.splice(_toPos, 0, content);
                delimiters.splice(_toPos, 0, delimiter);
                _toPos++;
            } else if (operation === '\\') {
                var previousOperation = _hunk.lines[j - 1] ? _hunk.lines[j - 1][0] : null;
                if (previousOperation === '+') removeEOFNL = true;
                else if (previousOperation === '-') addEOFNL = true;
            }
        }
    } // Handle EOFNL insertion/removal
    if (removeEOFNL) while(!lines[lines.length - 1]){
        lines.pop();
        delimiters.pop();
    }
    else if (addEOFNL) {
        lines.push('');
        delimiters.push('\n');
    }
    for(var _k = 0; _k < lines.length - 1; _k++)lines[_k] = lines[_k] + delimiters[_k];
    return lines.join('');
} // Wrapper that supports multiple file patches via callbacks.
function $4cdcc2e9633bfadb$export$a8b8e03e6bbe5473(uniDiff, options) {
    if (typeof uniDiff === 'string') uniDiff = $4cdcc2e9633bfadb$export$319fae3601428334(uniDiff);
    var currentIndex = 0;
    function processIndex() {
        var index = uniDiff[currentIndex++];
        if (!index) return options.complete();
        options.loadFile(index, function(err, data) {
            if (err) return options.complete(err);
            var updatedContent = $4cdcc2e9633bfadb$export$7383fd3fd73657b6(data, index, options);
            options.patched(index, updatedContent, function(err) {
                if (err) return options.complete(err);
                processIndex();
            });
        });
    }
    processIndex();
}
function $4cdcc2e9633bfadb$export$a67febf3ed67329c(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
    if (!options) options = {};
    if (typeof options.context === 'undefined') options.context = 4;
    var diff = $4cdcc2e9633bfadb$export$a2a88fc03c6c0a3(oldStr, newStr, options);
    if (!diff) return;
    diff.push({
        value: '',
        lines: []
    }); // Append an empty value to make cleanup easier
    function contextLines(lines) {
        return lines.map(function(entry) {
            return ' ' + entry;
        });
    }
    var hunks = [];
    var oldRangeStart = 0, newRangeStart = 0, curRange = [], oldLine = 1, newLine = 1;
    var _loop = function _loop(i) {
        var current = diff[i], lines = current.lines || current.value.replace(/\n$/, '').split('\n');
        current.lines = lines;
        if (current.added || current.removed) {
            var _curRange;
            // If we have previous context, start with that
            if (!oldRangeStart) {
                var prev = diff[i - 1];
                oldRangeStart = oldLine;
                newRangeStart = newLine;
                if (prev) {
                    curRange = options.context > 0 ? contextLines(prev.lines.slice(-options.context)) : [];
                    oldRangeStart -= curRange.length;
                    newRangeStart -= curRange.length;
                }
            } // Output our changes
            (_curRange = curRange).push.apply(_curRange, $4cdcc2e9633bfadb$var$_toConsumableArray(lines.map(function(entry) {
                return (current.added ? '+' : '-') + entry;
            }))); // Track the updated file position
            if (current.added) newLine += lines.length;
            else oldLine += lines.length;
        } else {
            // Identical context lines. Track line changes
            if (oldRangeStart) {
                // Close out any changes that have been output (or join overlapping)
                if (lines.length <= options.context * 2 && i < diff.length - 2) {
                    var _curRange2;
                    // Overlapping
                    (_curRange2 = curRange).push.apply(_curRange2, $4cdcc2e9633bfadb$var$_toConsumableArray(contextLines(lines)));
                } else {
                    var _curRange3;
                    // end the range and output
                    var contextSize = Math.min(lines.length, options.context);
                    (_curRange3 = curRange).push.apply(_curRange3, $4cdcc2e9633bfadb$var$_toConsumableArray(contextLines(lines.slice(0, contextSize))));
                    var hunk = {
                        oldStart: oldRangeStart,
                        oldLines: oldLine - oldRangeStart + contextSize,
                        newStart: newRangeStart,
                        newLines: newLine - newRangeStart + contextSize,
                        lines: curRange
                    };
                    if (i >= diff.length - 2 && lines.length <= options.context) {
                        // EOF is inside this hunk
                        var oldEOFNewline = /\n$/.test(oldStr);
                        var newEOFNewline = /\n$/.test(newStr);
                        var noNlBeforeAdds = lines.length == 0 && curRange.length > hunk.oldLines;
                        if (!oldEOFNewline && noNlBeforeAdds && oldStr.length > 0) // special case: old has no eol and no trailing context; no-nl can end up before adds
                        // however, if the old file is empty, do not output the no-nl line
                        curRange.splice(hunk.oldLines, 0, '\\ No newline at end of file');
                        if (!oldEOFNewline && !noNlBeforeAdds || !newEOFNewline) curRange.push('\\ No newline at end of file');
                    }
                    hunks.push(hunk);
                    oldRangeStart = 0;
                    newRangeStart = 0;
                    curRange = [];
                }
            }
            oldLine += lines.length;
            newLine += lines.length;
        }
    };
    for(var i = 0; i < diff.length; i++)_loop(i);
    return {
        oldFileName: oldFileName,
        newFileName: newFileName,
        oldHeader: oldHeader,
        newHeader: newHeader,
        hunks: hunks
    };
}
function $4cdcc2e9633bfadb$export$3c97ed4bbaa81f7a(diff) {
    if (Array.isArray(diff)) return diff.map($4cdcc2e9633bfadb$export$3c97ed4bbaa81f7a).join('\n');
    var ret = [];
    if (diff.oldFileName == diff.newFileName) ret.push('Index: ' + diff.oldFileName);
    ret.push('===================================================================');
    ret.push('--- ' + diff.oldFileName + (typeof diff.oldHeader === 'undefined' ? '' : '\t' + diff.oldHeader));
    ret.push('+++ ' + diff.newFileName + (typeof diff.newHeader === 'undefined' ? '' : '\t' + diff.newHeader));
    for(var i = 0; i < diff.hunks.length; i++){
        var hunk = diff.hunks[i]; // Unified Diff Format quirk: If the chunk size is 0,
        // the first number is one lower than one would expect.
        // https://www.artima.com/weblogs/viewpost.jsp?thread=164293
        if (hunk.oldLines === 0) hunk.oldStart -= 1;
        if (hunk.newLines === 0) hunk.newStart -= 1;
        ret.push('@@ -' + hunk.oldStart + ',' + hunk.oldLines + ' +' + hunk.newStart + ',' + hunk.newLines + ' @@');
        ret.push.apply(ret, hunk.lines);
    }
    return ret.join('\n') + '\n';
}
function $4cdcc2e9633bfadb$export$80aac8782e10a34f(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options) {
    return $4cdcc2e9633bfadb$export$3c97ed4bbaa81f7a($4cdcc2e9633bfadb$export$a67febf3ed67329c(oldFileName, newFileName, oldStr, newStr, oldHeader, newHeader, options));
}
function $4cdcc2e9633bfadb$export$4b8f0727f602f200(fileName, oldStr, newStr, oldHeader, newHeader, options) {
    return $4cdcc2e9633bfadb$export$80aac8782e10a34f(fileName, fileName, oldStr, newStr, oldHeader, newHeader, options);
}
function $4cdcc2e9633bfadb$var$arrayEqual(a, b) {
    if (a.length !== b.length) return false;
    return $4cdcc2e9633bfadb$var$arrayStartsWith(a, b);
}
function $4cdcc2e9633bfadb$var$arrayStartsWith(array, start) {
    if (start.length > array.length) return false;
    for(var i = 0; i < start.length; i++){
        if (start[i] !== array[i]) return false;
    }
    return true;
}
function $4cdcc2e9633bfadb$var$calcLineCount(hunk) {
    var _calcOldNewLineCount = $4cdcc2e9633bfadb$var$calcOldNewLineCount(hunk.lines), oldLines = _calcOldNewLineCount.oldLines, newLines = _calcOldNewLineCount.newLines;
    if (oldLines !== undefined) hunk.oldLines = oldLines;
    else delete hunk.oldLines;
    if (newLines !== undefined) hunk.newLines = newLines;
    else delete hunk.newLines;
}
function $4cdcc2e9633bfadb$export$4950aa0f605343fb(mine, theirs, base) {
    mine = $4cdcc2e9633bfadb$var$loadPatch(mine, base);
    theirs = $4cdcc2e9633bfadb$var$loadPatch(theirs, base);
    var ret = {}; // For index we just let it pass through as it doesn't have any necessary meaning.
    // Leaving sanity checks on this to the API consumer that may know more about the
    // meaning in their own context.
    if (mine.index || theirs.index) ret.index = mine.index || theirs.index;
    if (mine.newFileName || theirs.newFileName) {
        if (!$4cdcc2e9633bfadb$var$fileNameChanged(mine)) {
            // No header or no change in ours, use theirs (and ours if theirs does not exist)
            ret.oldFileName = theirs.oldFileName || mine.oldFileName;
            ret.newFileName = theirs.newFileName || mine.newFileName;
            ret.oldHeader = theirs.oldHeader || mine.oldHeader;
            ret.newHeader = theirs.newHeader || mine.newHeader;
        } else if (!$4cdcc2e9633bfadb$var$fileNameChanged(theirs)) {
            // No header or no change in theirs, use ours
            ret.oldFileName = mine.oldFileName;
            ret.newFileName = mine.newFileName;
            ret.oldHeader = mine.oldHeader;
            ret.newHeader = mine.newHeader;
        } else {
            // Both changed... figure it out
            ret.oldFileName = $4cdcc2e9633bfadb$var$selectField(ret, mine.oldFileName, theirs.oldFileName);
            ret.newFileName = $4cdcc2e9633bfadb$var$selectField(ret, mine.newFileName, theirs.newFileName);
            ret.oldHeader = $4cdcc2e9633bfadb$var$selectField(ret, mine.oldHeader, theirs.oldHeader);
            ret.newHeader = $4cdcc2e9633bfadb$var$selectField(ret, mine.newHeader, theirs.newHeader);
        }
    }
    ret.hunks = [];
    var mineIndex = 0, theirsIndex = 0, mineOffset = 0, theirsOffset = 0;
    while(mineIndex < mine.hunks.length || theirsIndex < theirs.hunks.length){
        var mineCurrent = mine.hunks[mineIndex] || {
            oldStart: Infinity
        }, theirsCurrent = theirs.hunks[theirsIndex] || {
            oldStart: Infinity
        };
        if ($4cdcc2e9633bfadb$var$hunkBefore(mineCurrent, theirsCurrent)) {
            // This patch does not overlap with any of the others, yay.
            ret.hunks.push($4cdcc2e9633bfadb$var$cloneHunk(mineCurrent, mineOffset));
            mineIndex++;
            theirsOffset += mineCurrent.newLines - mineCurrent.oldLines;
        } else if ($4cdcc2e9633bfadb$var$hunkBefore(theirsCurrent, mineCurrent)) {
            // This patch does not overlap with any of the others, yay.
            ret.hunks.push($4cdcc2e9633bfadb$var$cloneHunk(theirsCurrent, theirsOffset));
            theirsIndex++;
            mineOffset += theirsCurrent.newLines - theirsCurrent.oldLines;
        } else {
            // Overlap, merge as best we can
            var mergedHunk = {
                oldStart: Math.min(mineCurrent.oldStart, theirsCurrent.oldStart),
                oldLines: 0,
                newStart: Math.min(mineCurrent.newStart + mineOffset, theirsCurrent.oldStart + theirsOffset),
                newLines: 0,
                lines: []
            };
            $4cdcc2e9633bfadb$var$mergeLines(mergedHunk, mineCurrent.oldStart, mineCurrent.lines, theirsCurrent.oldStart, theirsCurrent.lines);
            theirsIndex++;
            mineIndex++;
            ret.hunks.push(mergedHunk);
        }
    }
    return ret;
}
function $4cdcc2e9633bfadb$var$loadPatch(param, base) {
    if (typeof param === 'string') {
        if (/^@@/m.test(param) || /^Index:/m.test(param)) return $4cdcc2e9633bfadb$export$319fae3601428334(param)[0];
        if (!base) throw new Error('Must provide a base reference or pass in a patch');
        return $4cdcc2e9633bfadb$export$a67febf3ed67329c(undefined, undefined, base, param);
    }
    return param;
}
function $4cdcc2e9633bfadb$var$fileNameChanged(patch) {
    return patch.newFileName && patch.newFileName !== patch.oldFileName;
}
function $4cdcc2e9633bfadb$var$selectField(index, mine, theirs) {
    if (mine === theirs) return mine;
    else {
        index.conflict = true;
        return {
            mine: mine,
            theirs: theirs
        };
    }
}
function $4cdcc2e9633bfadb$var$hunkBefore(test, check) {
    return test.oldStart < check.oldStart && test.oldStart + test.oldLines < check.oldStart;
}
function $4cdcc2e9633bfadb$var$cloneHunk(hunk, offset) {
    return {
        oldStart: hunk.oldStart,
        oldLines: hunk.oldLines,
        newStart: hunk.newStart + offset,
        newLines: hunk.newLines,
        lines: hunk.lines
    };
}
function $4cdcc2e9633bfadb$var$mergeLines(hunk, mineOffset, mineLines, theirOffset, theirLines) {
    // This will generally result in a conflicted hunk, but there are cases where the context
    // is the only overlap where we can successfully merge the content here.
    var mine = {
        offset: mineOffset,
        lines: mineLines,
        index: 0
    }, their = {
        offset: theirOffset,
        lines: theirLines,
        index: 0
    }; // Handle any leading content
    $4cdcc2e9633bfadb$var$insertLeading(hunk, mine, their);
    $4cdcc2e9633bfadb$var$insertLeading(hunk, their, mine); // Now in the overlap content. Scan through and select the best changes from each.
    while(mine.index < mine.lines.length && their.index < their.lines.length){
        var mineCurrent = mine.lines[mine.index], theirCurrent = their.lines[their.index];
        if ((mineCurrent[0] === '-' || mineCurrent[0] === '+') && (theirCurrent[0] === '-' || theirCurrent[0] === '+')) // Both modified ...
        $4cdcc2e9633bfadb$var$mutualChange(hunk, mine, their);
        else if (mineCurrent[0] === '+' && theirCurrent[0] === ' ') {
            var _hunk$lines;
            // Mine inserted
            (_hunk$lines = hunk.lines).push.apply(_hunk$lines, $4cdcc2e9633bfadb$var$_toConsumableArray($4cdcc2e9633bfadb$var$collectChange(mine)));
        } else if (theirCurrent[0] === '+' && mineCurrent[0] === ' ') {
            var _hunk$lines2;
            // Theirs inserted
            (_hunk$lines2 = hunk.lines).push.apply(_hunk$lines2, $4cdcc2e9633bfadb$var$_toConsumableArray($4cdcc2e9633bfadb$var$collectChange(their)));
        } else if (mineCurrent[0] === '-' && theirCurrent[0] === ' ') // Mine removed or edited
        $4cdcc2e9633bfadb$var$removal(hunk, mine, their);
        else if (theirCurrent[0] === '-' && mineCurrent[0] === ' ') // Their removed or edited
        $4cdcc2e9633bfadb$var$removal(hunk, their, mine, true);
        else if (mineCurrent === theirCurrent) {
            // Context identity
            hunk.lines.push(mineCurrent);
            mine.index++;
            their.index++;
        } else // Context mismatch
        $4cdcc2e9633bfadb$var$conflict(hunk, $4cdcc2e9633bfadb$var$collectChange(mine), $4cdcc2e9633bfadb$var$collectChange(their));
    } // Now push anything that may be remaining
    $4cdcc2e9633bfadb$var$insertTrailing(hunk, mine);
    $4cdcc2e9633bfadb$var$insertTrailing(hunk, their);
    $4cdcc2e9633bfadb$var$calcLineCount(hunk);
}
function $4cdcc2e9633bfadb$var$mutualChange(hunk, mine, their) {
    var myChanges = $4cdcc2e9633bfadb$var$collectChange(mine), theirChanges = $4cdcc2e9633bfadb$var$collectChange(their);
    if ($4cdcc2e9633bfadb$var$allRemoves(myChanges) && $4cdcc2e9633bfadb$var$allRemoves(theirChanges)) {
        // Special case for remove changes that are supersets of one another
        if ($4cdcc2e9633bfadb$var$arrayStartsWith(myChanges, theirChanges) && $4cdcc2e9633bfadb$var$skipRemoveSuperset(their, myChanges, myChanges.length - theirChanges.length)) {
            var _hunk$lines3;
            (_hunk$lines3 = hunk.lines).push.apply(_hunk$lines3, $4cdcc2e9633bfadb$var$_toConsumableArray(myChanges));
            return;
        } else if ($4cdcc2e9633bfadb$var$arrayStartsWith(theirChanges, myChanges) && $4cdcc2e9633bfadb$var$skipRemoveSuperset(mine, theirChanges, theirChanges.length - myChanges.length)) {
            var _hunk$lines4;
            (_hunk$lines4 = hunk.lines).push.apply(_hunk$lines4, $4cdcc2e9633bfadb$var$_toConsumableArray(theirChanges));
            return;
        }
    } else if ($4cdcc2e9633bfadb$var$arrayEqual(myChanges, theirChanges)) {
        var _hunk$lines5;
        (_hunk$lines5 = hunk.lines).push.apply(_hunk$lines5, $4cdcc2e9633bfadb$var$_toConsumableArray(myChanges));
        return;
    }
    $4cdcc2e9633bfadb$var$conflict(hunk, myChanges, theirChanges);
}
function $4cdcc2e9633bfadb$var$removal(hunk, mine, their, swap) {
    var myChanges = $4cdcc2e9633bfadb$var$collectChange(mine), theirChanges = $4cdcc2e9633bfadb$var$collectContext(their, myChanges);
    if (theirChanges.merged) {
        var _hunk$lines6;
        (_hunk$lines6 = hunk.lines).push.apply(_hunk$lines6, $4cdcc2e9633bfadb$var$_toConsumableArray(theirChanges.merged));
    } else $4cdcc2e9633bfadb$var$conflict(hunk, swap ? theirChanges : myChanges, swap ? myChanges : theirChanges);
}
function $4cdcc2e9633bfadb$var$conflict(hunk, mine, their) {
    hunk.conflict = true;
    hunk.lines.push({
        conflict: true,
        mine: mine,
        theirs: their
    });
}
function $4cdcc2e9633bfadb$var$insertLeading(hunk, insert, their) {
    while(insert.offset < their.offset && insert.index < insert.lines.length){
        var line = insert.lines[insert.index++];
        hunk.lines.push(line);
        insert.offset++;
    }
}
function $4cdcc2e9633bfadb$var$insertTrailing(hunk, insert) {
    while(insert.index < insert.lines.length){
        var line = insert.lines[insert.index++];
        hunk.lines.push(line);
    }
}
function $4cdcc2e9633bfadb$var$collectChange(state) {
    var ret = [], operation = state.lines[state.index][0];
    while(state.index < state.lines.length){
        var line = state.lines[state.index]; // Group additions that are immediately after subtractions and treat them as one "atomic" modify change.
        if (operation === '-' && line[0] === '+') operation = '+';
        if (operation === line[0]) {
            ret.push(line);
            state.index++;
        } else break;
    }
    return ret;
}
function $4cdcc2e9633bfadb$var$collectContext(state, matchChanges) {
    var changes = [], merged = [], matchIndex = 0, contextChanges = false, conflicted = false;
    while(matchIndex < matchChanges.length && state.index < state.lines.length){
        var change = state.lines[state.index], match = matchChanges[matchIndex]; // Once we've hit our add, then we are done
        if (match[0] === '+') break;
        contextChanges = contextChanges || change[0] !== ' ';
        merged.push(match);
        matchIndex++; // Consume any additions in the other block as a conflict to attempt
        // to pull in the remaining context after this
        if (change[0] === '+') {
            conflicted = true;
            while(change[0] === '+'){
                changes.push(change);
                change = state.lines[++state.index];
            }
        }
        if (match.substr(1) === change.substr(1)) {
            changes.push(change);
            state.index++;
        } else conflicted = true;
    }
    if ((matchChanges[matchIndex] || '')[0] === '+' && contextChanges) conflicted = true;
    if (conflicted) return changes;
    while(matchIndex < matchChanges.length)merged.push(matchChanges[matchIndex++]);
    return {
        merged: merged,
        changes: changes
    };
}
function $4cdcc2e9633bfadb$var$allRemoves(changes) {
    return changes.reduce(function(prev, change) {
        return prev && change[0] === '-';
    }, true);
}
function $4cdcc2e9633bfadb$var$skipRemoveSuperset(state, removeChanges, delta) {
    for(var i = 0; i < delta; i++){
        var changeContent = removeChanges[removeChanges.length - delta + i].substr(1);
        if (state.lines[state.index + i] !== ' ' + changeContent) return false;
    }
    state.index += delta;
    return true;
}
function $4cdcc2e9633bfadb$var$calcOldNewLineCount(lines) {
    var oldLines = 0;
    var newLines = 0;
    lines.forEach(function(line) {
        if (typeof line !== 'string') {
            var myCount = $4cdcc2e9633bfadb$var$calcOldNewLineCount(line.mine);
            var theirCount = $4cdcc2e9633bfadb$var$calcOldNewLineCount(line.theirs);
            if (oldLines !== undefined) {
                if (myCount.oldLines === theirCount.oldLines) oldLines += myCount.oldLines;
                else oldLines = undefined;
            }
            if (newLines !== undefined) {
                if (myCount.newLines === theirCount.newLines) newLines += myCount.newLines;
                else newLines = undefined;
            }
        } else {
            if (newLines !== undefined && (line[0] === '+' || line[0] === ' ')) newLines++;
            if (oldLines !== undefined && (line[0] === '-' || line[0] === ' ')) oldLines++;
        }
    });
    return {
        oldLines: oldLines,
        newLines: newLines
    };
}
function $4cdcc2e9633bfadb$export$56f67c78b16eedcd(structuredPatch) {
    if (Array.isArray(structuredPatch)) return structuredPatch.map($4cdcc2e9633bfadb$export$56f67c78b16eedcd).reverse();
    return $4cdcc2e9633bfadb$var$_objectSpread2($4cdcc2e9633bfadb$var$_objectSpread2({}, structuredPatch), {}, {
        oldFileName: structuredPatch.newFileName,
        oldHeader: structuredPatch.newHeader,
        newFileName: structuredPatch.oldFileName,
        newHeader: structuredPatch.oldHeader,
        hunks: structuredPatch.hunks.map(function(hunk) {
            return {
                oldLines: hunk.newLines,
                oldStart: hunk.newStart,
                newLines: hunk.oldLines,
                newStart: hunk.oldStart,
                linedelimiters: hunk.linedelimiters,
                lines: hunk.lines.map(function(l) {
                    if (l.startsWith('-')) return "+".concat(l.slice(1));
                    if (l.startsWith('+')) return "-".concat(l.slice(1));
                    return l;
                })
            };
        })
    });
}
// See: http://code.google.com/p/google-diff-match-patch/wiki/API
function $4cdcc2e9633bfadb$export$56e038dc2cb96fda(changes) {
    var ret = [], change, operation;
    for(var i = 0; i < changes.length; i++){
        change = changes[i];
        if (change.added) operation = 1;
        else if (change.removed) operation = -1;
        else operation = 0;
        ret.push([
            operation,
            change.value
        ]);
    }
    return ret;
}
function $4cdcc2e9633bfadb$export$1fa5526f71269cc8(changes) {
    var ret = [];
    for(var i = 0; i < changes.length; i++){
        var change = changes[i];
        if (change.added) ret.push('<ins>');
        else if (change.removed) ret.push('<del>');
        ret.push($4cdcc2e9633bfadb$var$escapeHTML(change.value));
        if (change.added) ret.push('</ins>');
        else if (change.removed) ret.push('</del>');
    }
    return ret.join('');
}
function $4cdcc2e9633bfadb$var$escapeHTML(s) {
    var n = s;
    n = n.replace(/&/g, '&amp;');
    n = n.replace(/</g, '&lt;');
    n = n.replace(/>/g, '&gt;');
    n = n.replace(/"/g, '&quot;');
    return n;
}


const $b810e5208693af8e$var$colors = {
    '--': (0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).red,
    "\xb7\xb7": (0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).grey,
    '++': (0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).green
};
const $b810e5208693af8e$var$TITLE = (0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).dim().italic;
const $b810e5208693af8e$var$TAB = (0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).dim("\u2192"), $b810e5208693af8e$var$SPACE = (0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).dim("\xb7"), $b810e5208693af8e$var$NL = (0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).dim("\u21B5");
const $b810e5208693af8e$var$LOG = (sym, str)=>$b810e5208693af8e$var$colors[sym](sym + $b810e5208693af8e$var$PRETTY(str)) + '\n';
const $b810e5208693af8e$var$LINE = (num, x)=>(0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).dim('L' + String(num).padStart(x, '0') + ' ');
const $b810e5208693af8e$var$PRETTY = (str)=>str.replace(/[ ]/g, $b810e5208693af8e$var$SPACE).replace(/\t/g, $b810e5208693af8e$var$TAB).replace(/(\r?\n)/g, $b810e5208693af8e$var$NL);
function $b810e5208693af8e$var$line(obj, prev, pad) {
    let char = obj.removed ? '--' : obj.added ? '++' : "\xb7\xb7";
    let arr = obj.value.replace(/\r?\n$/, '').split('\n');
    let i = 0, tmp, out = '';
    if (obj.added) out += $b810e5208693af8e$var$colors[char]().underline($b810e5208693af8e$var$TITLE('Expected:')) + '\n';
    else if (obj.removed) out += $b810e5208693af8e$var$colors[char]().underline($b810e5208693af8e$var$TITLE('Actual:')) + '\n';
    for(; i < arr.length; i++){
        tmp = arr[i];
        if (tmp != null) {
            if (prev) out += $b810e5208693af8e$var$LINE(prev + i, pad);
            out += $b810e5208693af8e$var$LOG(char, tmp || '\n');
        }
    }
    return out;
}
function $b810e5208693af8e$export$40d218f64510f659(input, expect) {
    let arr = $4cdcc2e9633bfadb$export$f1c08b3bfc8443c4(input, expect);
    let i = 0, j = 0, k = 0, tmp, val, char, isObj, str;
    let out = $b810e5208693af8e$var$LOG("\xb7\xb7", '[');
    for(; i < arr.length; i++){
        char = (tmp = arr[i]).removed ? '--' : tmp.added ? '++' : "\xb7\xb7";
        if (tmp.added) out += $b810e5208693af8e$var$colors[char]().underline($b810e5208693af8e$var$TITLE('Expected:')) + '\n';
        else if (tmp.removed) out += $b810e5208693af8e$var$colors[char]().underline($b810e5208693af8e$var$TITLE('Actual:')) + '\n';
        for(j = 0; j < tmp.value.length; j++){
            isObj = tmp.value[j] && typeof tmp.value[j] === 'object';
            val = $b810e5208693af8e$export$fac44ee5b035f737(tmp.value[j]).split(/\r?\n/g);
            for(k = 0; k < val.length;){
                str = '  ' + val[k++] + (isObj ? '' : ',');
                if (isObj && k === val.length && j + 1 < tmp.value.length) str += ',';
                out += $b810e5208693af8e$var$LOG(char, str);
            }
        }
    }
    return out + $b810e5208693af8e$var$LOG("\xb7\xb7", ']');
}
function $b810e5208693af8e$export$7846a41871731830(input, expect, linenum = 0) {
    let i = 0, tmp, output = '';
    let arr = $4cdcc2e9633bfadb$export$a2a88fc03c6c0a3(input, expect);
    let pad = String(expect.split(/\r?\n/g).length - linenum).length;
    for(; i < arr.length; i++){
        output += $b810e5208693af8e$var$line(tmp = arr[i], linenum, pad);
        if (linenum && !tmp.removed) linenum += tmp.count;
    }
    return output;
}
function $b810e5208693af8e$export$a2af00130072d5c1(input, expect) {
    let arr = $4cdcc2e9633bfadb$export$325021f2061a40f5(input, expect);
    let i = 0, output = '', tmp;
    let l1 = input.length;
    let l2 = expect.length;
    let p1 = $b810e5208693af8e$var$PRETTY(input);
    let p2 = $b810e5208693af8e$var$PRETTY(expect);
    tmp = arr[i];
    if (l1 === l2) ;
    else if (tmp.removed && arr[i + 1]) {
        let del = tmp.count - arr[i + 1].count;
        if (del == 0) ;
        else if (del > 0) {
            expect = ' '.repeat(del) + expect;
            p2 = ' '.repeat(del) + p2;
            l2 += del;
        } else if (del < 0) {
            input = ' '.repeat(-del) + input;
            p1 = ' '.repeat(-del) + p1;
            l1 += -del;
        }
    }
    output += $b810e5208693af8e$export$d32346616aa538f3(p1, p2, l1, l2);
    if (l1 === l2) for(tmp = '  '; i < l1; i++)tmp += input[i] === expect[i] ? ' ' : '^';
    else for(tmp = '  '; i < arr.length; i++){
        tmp += (arr[i].added || arr[i].removed ? '^' : ' ').repeat(Math.max(arr[i].count, 0));
        if (i + 1 < arr.length && (arr[i].added && arr[i + 1].removed || arr[i].removed && arr[i + 1].added)) arr[i + 1].count -= arr[i].count;
    }
    return output + (0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).red(tmp);
}
function $b810e5208693af8e$export$d32346616aa538f3(input, expect, lenA = String(input).length, lenB = String(expect).length) {
    let gutter = 4;
    let lenC = Math.max(lenA, lenB);
    let typeA = typeof input, typeB = typeof expect;
    if (typeA !== typeB) {
        gutter = 2;
        let delA = gutter + lenC - lenA;
        let delB = gutter + lenC - lenB;
        input += ' '.repeat(delA) + (0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).dim(`[${typeA}]`);
        expect += ' '.repeat(delB) + (0, $223a2b1eb8cb557d$export$2e2bcd8739ae039).dim(`[${typeB}]`);
        lenA += delA + typeA.length + 2;
        lenB += delB + typeB.length + 2;
        lenC = Math.max(lenA, lenB);
    }
    let output = $b810e5208693af8e$var$colors['++']('++' + expect + ' '.repeat(gutter + lenC - lenB) + $b810e5208693af8e$var$TITLE('(Expected)')) + '\n';
    return output + $b810e5208693af8e$var$colors['--']('--' + input + ' '.repeat(gutter + lenC - lenA) + $b810e5208693af8e$var$TITLE('(Actual)')) + '\n';
}
function $b810e5208693af8e$export$97db5808d8f88186(input, expect) {
    var k, i = 0, tmp, isArr = Array.isArray(input);
    var keys = [], out = isArr ? Array(input.length) : {};
    if (isArr) for(i = 0; i < out.length; i++){
        tmp = input[i];
        if (!tmp || typeof tmp !== 'object') out[i] = tmp;
        else out[i] = $b810e5208693af8e$export$97db5808d8f88186(tmp, expect[i]); // might not be right
    }
    else {
        for(k in expect)keys.push(k);
        for(; i < keys.length; i++)if (Object.prototype.hasOwnProperty.call(input, k = keys[i])) {
            if (!(tmp = input[k]) || typeof tmp !== 'object') out[k] = tmp;
            else out[k] = $b810e5208693af8e$export$97db5808d8f88186(tmp, expect[k]);
        }
        for(k in input)if (!out.hasOwnProperty(k)) out[k] = input[k]; // expect didnt have
    }
    return out;
}
function $b810e5208693af8e$export$f99d756c6d81ae3f() {
    var cache = new Set;
    return function print(key, val) {
        if (val === void 0) return '[__VOID__]';
        if (typeof val === 'number' && val !== val) return '[__NAN__]';
        if (typeof val === 'bigint') return val.toString();
        if (!val || typeof val !== 'object') return val;
        if (cache.has(val)) return '[Circular]';
        cache.add(val);
        return val;
    };
}
function $b810e5208693af8e$export$fac44ee5b035f737(input) {
    return JSON.stringify(input, $b810e5208693af8e$export$f99d756c6d81ae3f(), 2).replace(/"\[__NAN__\]"/g, 'NaN').replace(/"\[__VOID__\]"/g, 'undefined');
}
function $b810e5208693af8e$export$398604a469f7de9a(input, expect) {
    if (Array.isArray(expect) && Array.isArray(input)) return $b810e5208693af8e$export$40d218f64510f659(input, expect);
    if (expect instanceof RegExp) return $b810e5208693af8e$export$a2af00130072d5c1('' + input, '' + expect);
    let isA = input && typeof input == 'object';
    let isB = expect && typeof expect == 'object';
    if (isA && isB) input = $b810e5208693af8e$export$97db5808d8f88186(input, expect);
    if (isB) expect = $b810e5208693af8e$export$fac44ee5b035f737(expect);
    if (isA) input = $b810e5208693af8e$export$fac44ee5b035f737(input);
    if (expect && typeof expect == 'object') {
        input = $b810e5208693af8e$export$fac44ee5b035f737($b810e5208693af8e$export$97db5808d8f88186(input, expect));
        expect = $b810e5208693af8e$export$fac44ee5b035f737(expect);
    }
    isA = typeof input == 'string';
    isB = typeof expect == 'string';
    if (isA && /\r?\n/.test(input)) return $b810e5208693af8e$export$7846a41871731830(input, '' + expect);
    if (isB && /\r?\n/.test(expect)) return $b810e5208693af8e$export$7846a41871731830('' + input, expect);
    if (isA && isB) return $b810e5208693af8e$export$a2af00130072d5c1(input, expect);
    return $b810e5208693af8e$export$d32346616aa538f3(input, expect);
}


function $1f5e85cb981a53e6$var$dedent(str) {
    str = str.replace(/\r?\n/g, '\n');
    let arr = str.match(/^[ \t]*(?=\S)/gm);
    let i = 0, min = 1 / 0, len = (arr || []).length;
    for(; i < len; i++)min = Math.min(min, arr[i].length);
    return len && min ? str.replace(new RegExp(`^[ \\t]{${min}}`, 'gm'), '') : str;
}
class $1f5e85cb981a53e6$export$ae438a0619af4503 extends Error {
    constructor(opts = {}){
        super(opts.message);
        this.name = 'Assertion';
        this.code = 'ERR_ASSERTION';
        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
        this.details = opts.details || false;
        this.generated = !!opts.generated;
        this.operator = opts.operator;
        this.expects = opts.expects;
        this.actual = opts.actual;
    }
}
function $1f5e85cb981a53e6$var$assert(bool, actual, expects, operator, detailer, backup, msg) {
    if (bool) return;
    let message = msg || backup;
    if (msg instanceof Error) throw msg;
    let details = detailer && detailer(actual, expects);
    throw new $1f5e85cb981a53e6$export$ae438a0619af4503({
        actual: actual,
        expects: expects,
        operator: operator,
        message: message,
        details: details,
        generated: !msg
    });
}
function $1f5e85cb981a53e6$export$dcb8b3f0e2de7e49(val, msg) {
    $1f5e85cb981a53e6$var$assert(!!val, false, true, 'ok', false, 'Expected value to be truthy', msg);
}
function $1f5e85cb981a53e6$export$226b3eccf92c9ed9(val, exp, msg) {
    $1f5e85cb981a53e6$var$assert(val === exp, val, exp, 'is', (0, $b810e5208693af8e$export$398604a469f7de9a), 'Expected values to be strictly equal:', msg);
}
function $1f5e85cb981a53e6$export$411ce8e5a71e3069(val, exp, msg) {
    $1f5e85cb981a53e6$var$assert((0, $77ed2de27e076439$export$de8294bb3be0322f)(val, exp), val, exp, 'equal', (0, $b810e5208693af8e$export$398604a469f7de9a), 'Expected values to be deeply equal:', msg);
}
function $1f5e85cb981a53e6$export$565e9d9bd6b6e0d4(msg) {
    $1f5e85cb981a53e6$var$assert(false, true, false, 'unreachable', false, 'Expected not to be reached!', msg);
}
function $1f5e85cb981a53e6$export$bf9fb029d174d554(val, exp, msg) {
    let tmp = typeof val;
    $1f5e85cb981a53e6$var$assert(tmp === exp, tmp, exp, 'type', false, `Expected "${tmp}" to be "${exp}"`, msg);
}
function $1f5e85cb981a53e6$export$9544d5bb712b01ea(val, exp, msg) {
    let name = '`' + (exp.name || exp.constructor.name) + '`';
    $1f5e85cb981a53e6$var$assert(val instanceof exp, val, exp, 'instance', false, `Expected value to be an instance of ${name}`, msg);
}
function $1f5e85cb981a53e6$export$4659b591c19bdf3d(val, exp, msg) {
    if (typeof exp === 'string') $1f5e85cb981a53e6$var$assert(val.includes(exp), val, exp, 'match', false, `Expected value to include "${exp}" substring`, msg);
    else $1f5e85cb981a53e6$var$assert(exp.test(val), val, exp, 'match', false, `Expected value to match \`${String(exp)}\` pattern`, msg);
}
function $1f5e85cb981a53e6$export$b8801ea43165ed7d(val, exp, msg) {
    val = $1f5e85cb981a53e6$var$dedent(val);
    exp = $1f5e85cb981a53e6$var$dedent(exp);
    $1f5e85cb981a53e6$var$assert(val === exp, val, exp, 'snapshot', (0, $b810e5208693af8e$export$7846a41871731830), 'Expected value to match snapshot:', msg);
}
const $1f5e85cb981a53e6$var$lineNums = (x, y)=>(0, $b810e5208693af8e$export$7846a41871731830)(x, y, 1);
function $1f5e85cb981a53e6$export$8f71d6c56e2a80a4(val, exp, msg) {
    val = $1f5e85cb981a53e6$var$dedent(val);
    exp = $1f5e85cb981a53e6$var$dedent(exp);
    $1f5e85cb981a53e6$var$assert(val === exp, val, exp, 'fixture', $1f5e85cb981a53e6$var$lineNums, 'Expected value to match fixture:', msg);
}
function $1f5e85cb981a53e6$export$b784e1159c889d6b(blk, exp, msg) {
    if (!msg && typeof exp === 'string') {
        msg = exp;
        exp = null;
    }
    try {
        blk();
        $1f5e85cb981a53e6$var$assert(false, false, true, 'throws', false, 'Expected function to throw', msg);
    } catch (err) {
        if (err instanceof $1f5e85cb981a53e6$export$ae438a0619af4503) throw err;
        if (typeof exp === 'function') $1f5e85cb981a53e6$var$assert(exp(err), false, true, 'throws', false, 'Expected function to throw matching exception', msg);
        else if (exp instanceof RegExp) $1f5e85cb981a53e6$var$assert(exp.test(err.message), false, true, 'throws', false, `Expected function to throw exception matching \`${String(exp)}\` pattern`, msg);
    }
}
function $1f5e85cb981a53e6$export$6003a5f097c73977(val, msg) {
    $1f5e85cb981a53e6$var$assert(!val, true, false, 'not', false, 'Expected value to be falsey', msg);
}
$1f5e85cb981a53e6$export$6003a5f097c73977.ok = $1f5e85cb981a53e6$export$6003a5f097c73977;
$1f5e85cb981a53e6$export$226b3eccf92c9ed9.not = function(val, exp, msg) {
    $1f5e85cb981a53e6$var$assert(val !== exp, val, exp, 'is.not', false, 'Expected values not to be strictly equal', msg);
};
$1f5e85cb981a53e6$export$6003a5f097c73977.equal = function(val, exp, msg) {
    $1f5e85cb981a53e6$var$assert(!(0, $77ed2de27e076439$export$de8294bb3be0322f)(val, exp), val, exp, 'not.equal', false, 'Expected values not to be deeply equal', msg);
};
$1f5e85cb981a53e6$export$6003a5f097c73977.type = function(val, exp, msg) {
    let tmp = typeof val;
    $1f5e85cb981a53e6$var$assert(tmp !== exp, tmp, exp, 'not.type', false, `Expected "${tmp}" not to be "${exp}"`, msg);
};
$1f5e85cb981a53e6$export$6003a5f097c73977.instance = function(val, exp, msg) {
    let name = '`' + (exp.name || exp.constructor.name) + '`';
    $1f5e85cb981a53e6$var$assert(!(val instanceof exp), val, exp, 'not.instance', false, `Expected value not to be an instance of ${name}`, msg);
};
$1f5e85cb981a53e6$export$6003a5f097c73977.snapshot = function(val, exp, msg) {
    val = $1f5e85cb981a53e6$var$dedent(val);
    exp = $1f5e85cb981a53e6$var$dedent(exp);
    $1f5e85cb981a53e6$var$assert(val !== exp, val, exp, 'not.snapshot', false, 'Expected value not to match snapshot', msg);
};
$1f5e85cb981a53e6$export$6003a5f097c73977.fixture = function(val, exp, msg) {
    val = $1f5e85cb981a53e6$var$dedent(val);
    exp = $1f5e85cb981a53e6$var$dedent(exp);
    $1f5e85cb981a53e6$var$assert(val !== exp, val, exp, 'not.fixture', false, 'Expected value not to match fixture', msg);
};
$1f5e85cb981a53e6$export$6003a5f097c73977.match = function(val, exp, msg) {
    if (typeof exp === 'string') $1f5e85cb981a53e6$var$assert(!val.includes(exp), val, exp, 'not.match', false, `Expected value not to include "${exp}" substring`, msg);
    else $1f5e85cb981a53e6$var$assert(!exp.test(val), val, exp, 'not.match', false, `Expected value not to match \`${String(exp)}\` pattern`, msg);
};
$1f5e85cb981a53e6$export$6003a5f097c73977.throws = function(blk, exp, msg) {
    if (!msg && typeof exp === 'string') {
        msg = exp;
        exp = null;
    }
    try {
        blk();
    } catch (err) {
        if (typeof exp === 'function') $1f5e85cb981a53e6$var$assert(!exp(err), true, false, 'not.throws', false, 'Expected function not to throw matching exception', msg);
        else if (exp instanceof RegExp) $1f5e85cb981a53e6$var$assert(!exp.test(err.message), true, false, 'not.throws', false, `Expected function not to throw exception matching \`${String(exp)}\` pattern`, msg);
        else if (!exp) $1f5e85cb981a53e6$var$assert(false, true, false, 'not.throws', false, 'Expected function not to throw', msg);
    }
};





/**
 * Character codes.
 *
 * This module is compiled away!
 *
 * micromark works based on character codes.
 * This module contains constants for the ASCII block and the replacement
 * character.
 * A couple of them are handled in a special way, such as the line endings
 * (CR, LF, and CR+LF, commonly known as end-of-line: EOLs), the tab (horizontal
 * tab) and its expansion based on what column it’s at (virtual space),
 * and the end-of-file (eof) character.
 * As values are preprocessed before handling them, the actual characters LF,
 * CR, HT, and NUL (which is present as the replacement character), are
 * guaranteed to not exist.
 *
 * Unicode basic latin block.
 */ const $a5e687b3245d132c$export$e45cb6485273080e = /** @type {const} */ {
    carriageReturn: -5,
    lineFeed: -4,
    carriageReturnLineFeed: -3,
    horizontalTab: -2,
    virtualSpace: -1,
    eof: null,
    nul: 0,
    soh: 1,
    stx: 2,
    etx: 3,
    eot: 4,
    enq: 5,
    ack: 6,
    bel: 7,
    bs: 8,
    ht: 9,
    lf: 10,
    vt: 11,
    ff: 12,
    cr: 13,
    so: 14,
    si: 15,
    dle: 16,
    dc1: 17,
    dc2: 18,
    dc3: 19,
    dc4: 20,
    nak: 21,
    syn: 22,
    etb: 23,
    can: 24,
    em: 25,
    sub: 26,
    esc: 27,
    fs: 28,
    gs: 29,
    rs: 30,
    us: 31,
    space: 32,
    exclamationMark: 33,
    quotationMark: 34,
    numberSign: 35,
    dollarSign: 36,
    percentSign: 37,
    ampersand: 38,
    apostrophe: 39,
    leftParenthesis: 40,
    rightParenthesis: 41,
    asterisk: 42,
    plusSign: 43,
    comma: 44,
    dash: 45,
    dot: 46,
    slash: 47,
    digit0: 48,
    digit1: 49,
    digit2: 50,
    digit3: 51,
    digit4: 52,
    digit5: 53,
    digit6: 54,
    digit7: 55,
    digit8: 56,
    digit9: 57,
    colon: 58,
    semicolon: 59,
    lessThan: 60,
    equalsTo: 61,
    greaterThan: 62,
    questionMark: 63,
    atSign: 64,
    uppercaseA: 65,
    uppercaseB: 66,
    uppercaseC: 67,
    uppercaseD: 68,
    uppercaseE: 69,
    uppercaseF: 70,
    uppercaseG: 71,
    uppercaseH: 72,
    uppercaseI: 73,
    uppercaseJ: 74,
    uppercaseK: 75,
    uppercaseL: 76,
    uppercaseM: 77,
    uppercaseN: 78,
    uppercaseO: 79,
    uppercaseP: 80,
    uppercaseQ: 81,
    uppercaseR: 82,
    uppercaseS: 83,
    uppercaseT: 84,
    uppercaseU: 85,
    uppercaseV: 86,
    uppercaseW: 87,
    uppercaseX: 88,
    uppercaseY: 89,
    uppercaseZ: 90,
    leftSquareBracket: 91,
    backslash: 92,
    rightSquareBracket: 93,
    caret: 94,
    underscore: 95,
    graveAccent: 96,
    lowercaseA: 97,
    lowercaseB: 98,
    lowercaseC: 99,
    lowercaseD: 100,
    lowercaseE: 101,
    lowercaseF: 102,
    lowercaseG: 103,
    lowercaseH: 104,
    lowercaseI: 105,
    lowercaseJ: 106,
    lowercaseK: 107,
    lowercaseL: 108,
    lowercaseM: 109,
    lowercaseN: 110,
    lowercaseO: 111,
    lowercaseP: 112,
    lowercaseQ: 113,
    lowercaseR: 114,
    lowercaseS: 115,
    lowercaseT: 116,
    lowercaseU: 117,
    lowercaseV: 118,
    lowercaseW: 119,
    lowercaseX: 120,
    lowercaseY: 121,
    lowercaseZ: 122,
    leftCurlyBrace: 123,
    verticalBar: 124,
    rightCurlyBrace: 125,
    tilde: 126,
    del: 127,
    // Unicode Specials block.
    byteOrderMarker: 65279,
    // Unicode Specials block.
    replacementCharacter: 65533 // `�`
};

/**
 * This module is compiled away!
 *
 * Parsing markdown comes with a couple of constants, such as minimum or maximum
 * sizes of certain sequences.
 * Additionally, there are a couple symbols used inside micromark.
 * These are all defined here, but compiled away by scripts.
 */ const $6b21958b074eb5fa$export$1a988e7317c65621 = /** @type {const} */ {
    attentionSideAfter: 2,
    attentionSideBefore: 1,
    atxHeadingOpeningFenceSizeMax: 6,
    autolinkDomainSizeMax: 63,
    autolinkSchemeSizeMax: 32,
    cdataOpeningString: 'CDATA[',
    characterGroupPunctuation: 2,
    characterGroupWhitespace: 1,
    characterReferenceDecimalSizeMax: 7,
    characterReferenceHexadecimalSizeMax: 6,
    characterReferenceNamedSizeMax: 31,
    codeFencedSequenceSizeMin: 3,
    contentTypeContent: 'content',
    contentTypeDocument: 'document',
    contentTypeFlow: 'flow',
    contentTypeString: 'string',
    contentTypeText: 'text',
    hardBreakPrefixSizeMin: 2,
    htmlBasic: 6,
    htmlCdata: 5,
    htmlComment: 2,
    htmlComplete: 7,
    htmlDeclaration: 4,
    htmlInstruction: 3,
    htmlRawSizeMax: 8,
    htmlRaw: 1,
    linkResourceDestinationBalanceMax: 32,
    linkReferenceSizeMax: 999,
    listItemValueSizeMax: 10,
    numericBaseDecimal: 10,
    numericBaseHexadecimal: 0x10,
    tabSize: 4,
    thematicBreakMarkerCountMin: 3,
    v8MaxSafeChunkSize: 10000 // V8 (and potentially others) have problems injecting giant arrays into other arrays, hence we operate in chunks.
};

/**
 * This module is compiled away!
 *
 * Here is the list of all types of tokens exposed by micromark, with a short
 * explanation of what they include and where they are found.
 * In picking names, generally, the rule is to be as explicit as possible
 * instead of reusing names.
 * For example, there is a `definitionDestination` and a `resourceDestination`,
 * instead of one shared name.
 */ // Note: when changing the next record, you must also change `TokenTypeMap`
// in `micromark-util-types/index.d.ts`.
const $336a60ec4fcd4711$export$b14ad400b1d09e0f = /** @type {const} */ {
    // Generic type for data, such as in a title, a destination, etc.
    data: 'data',
    // Generic type for syntactic whitespace (tabs, virtual spaces, spaces).
    // Such as, between a fenced code fence and an info string.
    whitespace: 'whitespace',
    // Generic type for line endings (line feed, carriage return, carriage return +
    // line feed).
    lineEnding: 'lineEnding',
    // A line ending, but ending a blank line.
    lineEndingBlank: 'lineEndingBlank',
    // Generic type for whitespace (tabs, virtual spaces, spaces) at the start of a
    // line.
    linePrefix: 'linePrefix',
    // Generic type for whitespace (tabs, virtual spaces, spaces) at the end of a
    // line.
    lineSuffix: 'lineSuffix',
    // Whole ATX heading:
    //
    // ```markdown
    // #
    // ## Alpha
    // ### Bravo ###
    // ```
    //
    // Includes `atxHeadingSequence`, `whitespace`, `atxHeadingText`.
    atxHeading: 'atxHeading',
    // Sequence of number signs in an ATX heading (`###`).
    atxHeadingSequence: 'atxHeadingSequence',
    // Content in an ATX heading (`alpha`).
    // Includes text.
    atxHeadingText: 'atxHeadingText',
    // Whole autolink (`<https://example.com>` or `<admin@example.com>`)
    // Includes `autolinkMarker` and `autolinkProtocol` or `autolinkEmail`.
    autolink: 'autolink',
    // Email autolink w/o markers (`admin@example.com`)
    autolinkEmail: 'autolinkEmail',
    // Marker around an `autolinkProtocol` or `autolinkEmail` (`<` or `>`).
    autolinkMarker: 'autolinkMarker',
    // Protocol autolink w/o markers (`https://example.com`)
    autolinkProtocol: 'autolinkProtocol',
    // A whole character escape (`\-`).
    // Includes `escapeMarker` and `characterEscapeValue`.
    characterEscape: 'characterEscape',
    // The escaped character (`-`).
    characterEscapeValue: 'characterEscapeValue',
    // A whole character reference (`&amp;`, `&#8800;`, or `&#x1D306;`).
    // Includes `characterReferenceMarker`, an optional
    // `characterReferenceMarkerNumeric`, in which case an optional
    // `characterReferenceMarkerHexadecimal`, and a `characterReferenceValue`.
    characterReference: 'characterReference',
    // The start or end marker (`&` or `;`).
    characterReferenceMarker: 'characterReferenceMarker',
    // Mark reference as numeric (`#`).
    characterReferenceMarkerNumeric: 'characterReferenceMarkerNumeric',
    // Mark reference as numeric (`x` or `X`).
    characterReferenceMarkerHexadecimal: 'characterReferenceMarkerHexadecimal',
    // Value of character reference w/o markers (`amp`, `8800`, or `1D306`).
    characterReferenceValue: 'characterReferenceValue',
    // Whole fenced code:
    //
    // ````markdown
    // ```js
    // alert(1)
    // ```
    // ````
    codeFenced: 'codeFenced',
    // A fenced code fence, including whitespace, sequence, info, and meta
    // (` ```js `).
    codeFencedFence: 'codeFencedFence',
    // Sequence of grave accent or tilde characters (` ``` `) in a fence.
    codeFencedFenceSequence: 'codeFencedFenceSequence',
    // Info word (`js`) in a fence.
    // Includes string.
    codeFencedFenceInfo: 'codeFencedFenceInfo',
    // Meta words (`highlight="1"`) in a fence.
    // Includes string.
    codeFencedFenceMeta: 'codeFencedFenceMeta',
    // A line of code.
    codeFlowValue: 'codeFlowValue',
    // Whole indented code:
    //
    // ```markdown
    //     alert(1)
    // ```
    //
    // Includes `lineEnding`, `linePrefix`, and `codeFlowValue`.
    codeIndented: 'codeIndented',
    // A text code (``` `alpha` ```).
    // Includes `codeTextSequence`, `codeTextData`, `lineEnding`, and can include
    // `codeTextPadding`.
    codeText: 'codeText',
    codeTextData: 'codeTextData',
    // A space or line ending right after or before a tick.
    codeTextPadding: 'codeTextPadding',
    // A text code fence (` `` `).
    codeTextSequence: 'codeTextSequence',
    // Whole content:
    //
    // ```markdown
    // [a]: b
    // c
    // =
    // d
    // ```
    //
    // Includes `paragraph` and `definition`.
    content: 'content',
    // Whole definition:
    //
    // ```markdown
    // [micromark]: https://github.com/micromark/micromark
    // ```
    //
    // Includes `definitionLabel`, `definitionMarker`, `whitespace`,
    // `definitionDestination`, and optionally `lineEnding` and `definitionTitle`.
    definition: 'definition',
    // Destination of a definition (`https://github.com/micromark/micromark` or
    // `<https://github.com/micromark/micromark>`).
    // Includes `definitionDestinationLiteral` or `definitionDestinationRaw`.
    definitionDestination: 'definitionDestination',
    // Enclosed destination of a definition
    // (`<https://github.com/micromark/micromark>`).
    // Includes `definitionDestinationLiteralMarker` and optionally
    // `definitionDestinationString`.
    definitionDestinationLiteral: 'definitionDestinationLiteral',
    // Markers of an enclosed definition destination (`<` or `>`).
    definitionDestinationLiteralMarker: 'definitionDestinationLiteralMarker',
    // Unenclosed destination of a definition
    // (`https://github.com/micromark/micromark`).
    // Includes `definitionDestinationString`.
    definitionDestinationRaw: 'definitionDestinationRaw',
    // Text in an destination (`https://github.com/micromark/micromark`).
    // Includes string.
    definitionDestinationString: 'definitionDestinationString',
    // Label of a definition (`[micromark]`).
    // Includes `definitionLabelMarker` and `definitionLabelString`.
    definitionLabel: 'definitionLabel',
    // Markers of a definition label (`[` or `]`).
    definitionLabelMarker: 'definitionLabelMarker',
    // Value of a definition label (`micromark`).
    // Includes string.
    definitionLabelString: 'definitionLabelString',
    // Marker between a label and a destination (`:`).
    definitionMarker: 'definitionMarker',
    // Title of a definition (`"x"`, `'y'`, or `(z)`).
    // Includes `definitionTitleMarker` and optionally `definitionTitleString`.
    definitionTitle: 'definitionTitle',
    // Marker around a title of a definition (`"`, `'`, `(`, or `)`).
    definitionTitleMarker: 'definitionTitleMarker',
    // Data without markers in a title (`z`).
    // Includes string.
    definitionTitleString: 'definitionTitleString',
    // Emphasis (`*alpha*`).
    // Includes `emphasisSequence` and `emphasisText`.
    emphasis: 'emphasis',
    // Sequence of emphasis markers (`*` or `_`).
    emphasisSequence: 'emphasisSequence',
    // Emphasis text (`alpha`).
    // Includes text.
    emphasisText: 'emphasisText',
    // The character escape marker (`\`).
    escapeMarker: 'escapeMarker',
    // A hard break created with a backslash (`\\n`).
    // Note: does not include the line ending.
    hardBreakEscape: 'hardBreakEscape',
    // A hard break created with trailing spaces (`  \n`).
    // Does not include the line ending.
    hardBreakTrailing: 'hardBreakTrailing',
    // Flow HTML:
    //
    // ```markdown
    // <div
    // ```
    //
    // Inlcudes `lineEnding`, `htmlFlowData`.
    htmlFlow: 'htmlFlow',
    htmlFlowData: 'htmlFlowData',
    // HTML in text (the tag in `a <i> b`).
    // Includes `lineEnding`, `htmlTextData`.
    htmlText: 'htmlText',
    htmlTextData: 'htmlTextData',
    // Whole image (`![alpha](bravo)`, `![alpha][bravo]`, `![alpha][]`, or
    // `![alpha]`).
    // Includes `label` and an optional `resource` or `reference`.
    image: 'image',
    // Whole link label (`[*alpha*]`).
    // Includes `labelLink` or `labelImage`, `labelText`, and `labelEnd`.
    label: 'label',
    // Text in an label (`*alpha*`).
    // Includes text.
    labelText: 'labelText',
    // Start a link label (`[`).
    // Includes a `labelMarker`.
    labelLink: 'labelLink',
    // Start an image label (`![`).
    // Includes `labelImageMarker` and `labelMarker`.
    labelImage: 'labelImage',
    // Marker of a label (`[` or `]`).
    labelMarker: 'labelMarker',
    // Marker to start an image (`!`).
    labelImageMarker: 'labelImageMarker',
    // End a label (`]`).
    // Includes `labelMarker`.
    labelEnd: 'labelEnd',
    // Whole link (`[alpha](bravo)`, `[alpha][bravo]`, `[alpha][]`, or `[alpha]`).
    // Includes `label` and an optional `resource` or `reference`.
    link: 'link',
    // Whole paragraph:
    //
    // ```markdown
    // alpha
    // bravo.
    // ```
    //
    // Includes text.
    paragraph: 'paragraph',
    // A reference (`[alpha]` or `[]`).
    // Includes `referenceMarker` and an optional `referenceString`.
    reference: 'reference',
    // A reference marker (`[` or `]`).
    referenceMarker: 'referenceMarker',
    // Reference text (`alpha`).
    // Includes string.
    referenceString: 'referenceString',
    // A resource (`(https://example.com "alpha")`).
    // Includes `resourceMarker`, an optional `resourceDestination` with an optional
    // `whitespace` and `resourceTitle`.
    resource: 'resource',
    // A resource destination (`https://example.com`).
    // Includes `resourceDestinationLiteral` or `resourceDestinationRaw`.
    resourceDestination: 'resourceDestination',
    // A literal resource destination (`<https://example.com>`).
    // Includes `resourceDestinationLiteralMarker` and optionally
    // `resourceDestinationString`.
    resourceDestinationLiteral: 'resourceDestinationLiteral',
    // A resource destination marker (`<` or `>`).
    resourceDestinationLiteralMarker: 'resourceDestinationLiteralMarker',
    // A raw resource destination (`https://example.com`).
    // Includes `resourceDestinationString`.
    resourceDestinationRaw: 'resourceDestinationRaw',
    // Resource destination text (`https://example.com`).
    // Includes string.
    resourceDestinationString: 'resourceDestinationString',
    // A resource marker (`(` or `)`).
    resourceMarker: 'resourceMarker',
    // A resource title (`"alpha"`, `'alpha'`, or `(alpha)`).
    // Includes `resourceTitleMarker` and optionally `resourceTitleString`.
    resourceTitle: 'resourceTitle',
    // A resource title marker (`"`, `'`, `(`, or `)`).
    resourceTitleMarker: 'resourceTitleMarker',
    // Resource destination title (`alpha`).
    // Includes string.
    resourceTitleString: 'resourceTitleString',
    // Whole setext heading:
    //
    // ```markdown
    // alpha
    // bravo
    // =====
    // ```
    //
    // Includes `setextHeadingText`, `lineEnding`, `linePrefix`, and
    // `setextHeadingLine`.
    setextHeading: 'setextHeading',
    // Content in a setext heading (`alpha\nbravo`).
    // Includes text.
    setextHeadingText: 'setextHeadingText',
    // Underline in a setext heading, including whitespace suffix (`==`).
    // Includes `setextHeadingLineSequence`.
    setextHeadingLine: 'setextHeadingLine',
    // Sequence of equals or dash characters in underline in a setext heading (`-`).
    setextHeadingLineSequence: 'setextHeadingLineSequence',
    // Strong (`**alpha**`).
    // Includes `strongSequence` and `strongText`.
    strong: 'strong',
    // Sequence of strong markers (`**` or `__`).
    strongSequence: 'strongSequence',
    // Strong text (`alpha`).
    // Includes text.
    strongText: 'strongText',
    // Whole thematic break:
    //
    // ```markdown
    // * * *
    // ```
    //
    // Includes `thematicBreakSequence` and `whitespace`.
    thematicBreak: 'thematicBreak',
    // A sequence of one or more thematic break markers (`***`).
    thematicBreakSequence: 'thematicBreakSequence',
    // Whole block quote:
    //
    // ```markdown
    // > a
    // >
    // > b
    // ```
    //
    // Includes `blockQuotePrefix` and flow.
    blockQuote: 'blockQuote',
    // The `>` or `> ` of a block quote.
    blockQuotePrefix: 'blockQuotePrefix',
    // The `>` of a block quote prefix.
    blockQuoteMarker: 'blockQuoteMarker',
    // The optional ` ` of a block quote prefix.
    blockQuotePrefixWhitespace: 'blockQuotePrefixWhitespace',
    // Whole ordered list:
    //
    // ```markdown
    // 1. a
    //    b
    // ```
    //
    // Includes `listItemPrefix`, flow, and optionally  `listItemIndent` on further
    // lines.
    listOrdered: 'listOrdered',
    // Whole unordered list:
    //
    // ```markdown
    // - a
    //   b
    // ```
    //
    // Includes `listItemPrefix`, flow, and optionally  `listItemIndent` on further
    // lines.
    listUnordered: 'listUnordered',
    // The indent of further list item lines.
    listItemIndent: 'listItemIndent',
    // A marker, as in, `*`, `+`, `-`, `.`, or `)`.
    listItemMarker: 'listItemMarker',
    // The thing that starts a list item, such as `1. `.
    // Includes `listItemValue` if ordered, `listItemMarker`, and
    // `listItemPrefixWhitespace` (unless followed by a line ending).
    listItemPrefix: 'listItemPrefix',
    // The whitespace after a marker.
    listItemPrefixWhitespace: 'listItemPrefixWhitespace',
    // The numerical value of an ordered item.
    listItemValue: 'listItemValue',
    // Internal types used for subtokenizers, compiled away
    chunkDocument: 'chunkDocument',
    chunkContent: 'chunkContent',
    chunkFlow: 'chunkFlow',
    chunkText: 'chunkText',
    chunkString: 'chunkString'
};


var $bb28592d736320fe$export$fd9699ddf136b759 = {
    enter: {
        highlight () {
            this.tag("<mark>");
        }
    },
    exit: {
        highlight () {
            this.tag("</mark>");
        }
    }
};
var $bb28592d736320fe$var$HIGHLIGHT_SEQUENCE_TEMPORTARY = "highlightSequenceTemporary";
var $bb28592d736320fe$var$HIGHLIGHT_SEQUENCE = "highlightSequence";
var $bb28592d736320fe$var$HIGHLIGHT = "highlight";
var $bb28592d736320fe$var$HIGHLIGHT_TEXT = "highlightText";
function $bb28592d736320fe$export$26b46f3c4275b535() {
    const tokenizer = {
        name: "highlight",
        tokenize: tokenizeHighlight,
        resolveAll: resolveAllHighlight
    };
    return {
        text: {
            [(0, $a5e687b3245d132c$export$e45cb6485273080e).equalsTo]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                (0, $a5e687b3245d132c$export$e45cb6485273080e).equalsTo
            ]
        }
    };
    function resolveAllHighlight(events, context) {
        let index = -1;
        while(++index < events.length)if (events[index][0] === "enter" && events[index][1].type === $bb28592d736320fe$var$HIGHLIGHT_SEQUENCE_TEMPORTARY && events[index][1]._close) {
            let open = index;
            while(open--)if (events[open][0] === "exit" && events[open][1].type === $bb28592d736320fe$var$HIGHLIGHT_SEQUENCE_TEMPORTARY && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = $bb28592d736320fe$var$HIGHLIGHT_SEQUENCE;
                events[open][1].type = $bb28592d736320fe$var$HIGHLIGHT_SEQUENCE;
                const highlight = {
                    type: $bb28592d736320fe$var$HIGHLIGHT,
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                const text = {
                    type: $bb28592d736320fe$var$HIGHLIGHT_TEXT,
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                const nextEvents = [
                    [
                        "enter",
                        highlight,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) (0, $6d957c9e6a169a49$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                (0, $6d957c9e6a169a49$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        highlight,
                        context
                    ]
                ]);
                (0, $6d957c9e6a169a49$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === $bb28592d736320fe$var$HIGHLIGHT_SEQUENCE_TEMPORTARY) events[index][1].type = (0, $336a60ec4fcd4711$export$b14ad400b1d09e0f).data;
        return events;
    }
    function tokenizeHighlight(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        function start(code) {
            (0, $1f5e85cb981a53e6$export$dcb8b3f0e2de7e49)(code === (0, $a5e687b3245d132c$export$e45cb6485273080e).equalsTo, "expected `=`");
            if (previous === (0, $a5e687b3245d132c$export$e45cb6485273080e).equalsTo && events[events.length - 1][1].type !== (0, $336a60ec4fcd4711$export$b14ad400b1d09e0f).characterEscape) return nok(code);
            effects.enter($bb28592d736320fe$var$HIGHLIGHT_SEQUENCE_TEMPORTARY);
            return more(code);
        }
        function more(code) {
            const before = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(previous);
            if (code === (0, $a5e687b3245d132c$export$e45cb6485273080e).equalsTo) {
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2) return nok(code);
            const token = effects.exit($bb28592d736320fe$var$HIGHLIGHT_SEQUENCE_TEMPORTARY);
            const after = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(code);
            token._open = !after || after === (0, $6b21958b074eb5fa$export$1a988e7317c65621).attentionSideAfter && Boolean(before);
            token._close = !before || before === (0, $6b21958b074eb5fa$export$1a988e7317c65621).attentionSideAfter && Boolean(after);
            return ok(code);
        }
    }
}


/**
 * @import {Options} from 'micromark-extension-mdx-jsx'
 * @import {AcornOptions} from 'micromark-util-events-to-acorn'
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {Options} from 'micromark-extension-mdx-jsx'
 * @import {Acorn} from 'micromark-util-events-to-acorn'
 * @import {Construct, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @import {AcornOptions, Acorn} from 'micromark-util-events-to-acorn'
 * @import {Code, Effects, State, TokenType, TokenizeContext} from 'micromark-util-types'
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [jsx=false]
 *   Support JSX identifiers (default: `false`).
 */ const $8ae047d5df63cb7f$var$startRe = RegExp("[$_\\p{ID_Start}]", "u");
const $8ae047d5df63cb7f$var$contRe = RegExp("[$_\\u{200C}\\u{200D}\\p{ID_Continue}]", "u");
const $8ae047d5df63cb7f$var$contReJsx = RegExp("[-$_\\u{200C}\\u{200D}\\p{ID_Continue}]", "u");
const $8ae047d5df63cb7f$var$nameRe = RegExp("^[$_\\p{ID_Start}][$_\\u{200C}\\u{200D}\\p{ID_Continue}]*$", "u");
const $8ae047d5df63cb7f$var$nameReJsx = RegExp("^[$_\\p{ID_Start}][-$_\\u{200C}\\u{200D}\\p{ID_Continue}]*$", "u");
/** @type {Options} */ const $8ae047d5df63cb7f$var$emptyOptions = {};
function $8ae047d5df63cb7f$export$b3571188c770cc5a(code) {
    return code ? $8ae047d5df63cb7f$var$startRe.test(String.fromCodePoint(code)) : false;
}
function $8ae047d5df63cb7f$export$10eb6dc47bf009dc(code, options) {
    const settings = options || $8ae047d5df63cb7f$var$emptyOptions;
    const re = settings.jsx ? $8ae047d5df63cb7f$var$contReJsx : $8ae047d5df63cb7f$var$contRe;
    return code ? re.test(String.fromCodePoint(code)) : false;
}
function $8ae047d5df63cb7f$export$a8ff84c12d48cfa6(name, options) {
    const settings = options || $8ae047d5df63cb7f$var$emptyOptions;
    const re = settings.jsx ? $8ae047d5df63cb7f$var$nameReJsx : $8ae047d5df63cb7f$var$nameRe;
    return re.test(name);
}


/**
 * @import {Program} from 'estree'
 * @import {Acorn, AcornOptions} from 'micromark-util-events-to-acorn'
 * @import {Effects, Point, State, TokenType, TokenizeContext} from 'micromark-util-types'
 */ /**
 * @typedef MdxSignalOk
 *   Good result.
 * @property {'ok'} type
 *   Type.
 * @property {Program | undefined} estree
 *   Value.
 *
 * @typedef MdxSignalNok
 *   Bad result.
 * @property {'nok'} type
 *   Type.
 * @property {VFileMessage} message
 *   Value.
 *
 * @typedef {MdxSignalNok | MdxSignalOk} MdxSignal
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $a27bcbb6afb3eadb$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



/**
 * @import {Comment, Node as AcornNode, Token} from 'acorn'
 * @import {Node as EstreeNode, Program} from 'estree'
 * @import {Chunk, Event, Point as MicromarkPoint, TokenType} from 'micromark-util-types'
 * @import {Point as UnistPoint} from 'unist'
 *
 * @import {AcornOptions, Options} from 'micromark-util-events-to-acorn'
 * @import {AcornError, Collection, Result, Stop} from './types.js'
 */ /**
 * @typedef {import('estree-jsx').Node} Node
 */ /**
 * @typedef {CONTINUE | EXIT | SKIP} Action
 *   Union of the action types.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed), when moving in an array.
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 */ /**
 * @callback Visitor
 *   Handle a node.
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node`, the `Visitor` should
 *   return a new `Index` to specify the sibling to traverse after `node` is
 *   traversed.
 *   Adding or removing next siblings of `node` is handled as expected without
 *   needing to return a new `Index`.
 * @param {Node} node
 *   Found node.
 * @param {string | undefined} key
 *   Field at which `node` lives in its parent (or where a list of nodes lives).
 * @param {number | undefined} index
 *   Index where `node` lives if `parent[key]` is an array.
 * @param {Array<Node>} ancestors
 *   Ancestors of `node`.
 * @returns {Action | ActionTuple | Index | null | undefined | void}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 */ /**
 * @typedef Visitors
 *   Handle nodes when entering (preorder) and leaving (postorder).
 * @property {Visitor | null | undefined} [enter]
 *   Handle nodes when entering (preorder) (optional).
 * @property {Visitor | null | undefined} [leave]
 *   Handle nodes when leaving (postorder) (optional).
 */ /**
 * @param {string} d
 * @returns {string}
 */ function $ea368298cc9fc8e3$export$35e9368ef982300f(d) {
    return d;
}


const $dec343fef8154917$var$own = {}.hasOwnProperty;
const $dec343fef8154917$export$f4d8133c446fe484 = Symbol('continue');
const $dec343fef8154917$export$7f100f842f565dc9 = Symbol('exit');
const $dec343fef8154917$export$8773f85c2fb2c116 = Symbol('skip');
function $dec343fef8154917$export$bf638b60ea8b89b7(tree, visitor) {
    /** @type {Visitor | undefined} */ let enter;
    /** @type {Visitor | undefined} */ let leave;
    if (typeof visitor === 'function') enter = visitor;
    else if (visitor && typeof visitor === 'object') {
        if (visitor.enter) enter = visitor.enter;
        if (visitor.leave) leave = visitor.leave;
    }
    build(tree, undefined, undefined, [])();
    /**
   * @param {Node} node
   * @param {string | undefined} key
   * @param {number | undefined} index
   * @param {Array<Node>} parents
   */ function build(node, key, index, parents) {
        if ($dec343fef8154917$var$nodelike(node)) visit.displayName = 'node (' + (0, $ea368298cc9fc8e3$export$35e9368ef982300f)(node.type) + ')';
        return visit;
        /**
     * @returns {ActionTuple}
     */ function visit() {
            /** @type {ActionTuple} */ const result = enter ? $dec343fef8154917$var$toResult(enter(node, key, index, parents)) : [];
            if (result[0] === $dec343fef8154917$export$7f100f842f565dc9) return result;
            if (result[0] !== $dec343fef8154917$export$8773f85c2fb2c116) {
                /** @type {keyof node} */ let cKey;
                for(cKey in node)if ($dec343fef8154917$var$own.call(node, cKey) && node[cKey] && typeof node[cKey] === 'object' && // @ts-expect-error: custom esast extension.
                cKey !== 'data' && // @ts-expect-error: custom esast extension.
                cKey !== 'position') {
                    const grandparents = parents.concat(node);
                    /** @type {unknown} */ const value = node[cKey];
                    if (Array.isArray(value)) {
                        const nodes = /** @type {Array<unknown>} */ value;
                        let cIndex = 0;
                        while(cIndex > -1 && cIndex < nodes.length){
                            const subvalue = nodes[cIndex];
                            if ($dec343fef8154917$var$nodelike(subvalue)) {
                                const subresult = build(subvalue, cKey, cIndex, grandparents)();
                                if (subresult[0] === $dec343fef8154917$export$7f100f842f565dc9) return subresult;
                                cIndex = typeof subresult[1] === 'number' ? subresult[1] : cIndex + 1;
                            } else cIndex++;
                        }
                    } else if ($dec343fef8154917$var$nodelike(value)) {
                        const subresult = build(value, cKey, undefined, grandparents)();
                        if (subresult[0] === $dec343fef8154917$export$7f100f842f565dc9) return subresult;
                    }
                }
            }
            return leave ? $dec343fef8154917$var$toResult(leave(node, key, index, parents)) : result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {Action | ActionTuple | Index | null | undefined | void} value
 *   Valid return values from visitors.
 * @returns {ActionTuple}
 *   Clean result.
 */ function $dec343fef8154917$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $dec343fef8154917$export$f4d8133c446fe484,
        value
    ];
    return [
        value
    ];
}
/**
 * Check if something looks like a node.
 *
 * @param {unknown} value
 *   Anything.
 * @returns {value is Node}
 *   Whether `value` looks like a node.
 */ function $dec343fef8154917$var$nodelike(value) {
    return Boolean(value && typeof value === 'object' && 'type' in value && typeof value.type === 'string' && value.type.length > 0);
}



function $ea4035acf84f2507$export$2d5e4b80efde7308(events, options) {
    const prefix = options.prefix || '';
    const suffix = options.suffix || '';
    const acornOptions = Object.assign({}, options.acornOptions);
    /** @type {Array<Comment>} */ const comments = [];
    /** @type {Array<Token>} */ const tokens = [];
    const onComment = acornOptions.onComment;
    const onToken = acornOptions.onToken;
    let swallow = false;
    /** @type {AcornNode | undefined} */ let estree;
    /** @type {AcornError | undefined} */ let exception;
    /** @type {AcornOptions} */ const acornConfig = Object.assign({}, acornOptions, {
        onComment: comments,
        preserveParens: true
    });
    if (onToken) acornConfig.onToken = tokens;
    const collection = $ea4035acf84f2507$var$collect(events, options.tokenTypes);
    const source = collection.value;
    const value = prefix + source + suffix;
    const isEmptyExpression = options.expression && $ea4035acf84f2507$var$empty(source);
    if (isEmptyExpression && !options.allowEmpty) throw new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected empty expression', {
        place: parseOffsetToUnistPoint(0),
        ruleId: 'unexpected-empty-expression',
        source: 'micromark-extension-mdx-expression'
    });
    try {
        estree = options.expression && !isEmptyExpression ? options.acorn.parseExpressionAt(value, 0, acornConfig) : options.acorn.parse(value, acornConfig);
    } catch (error_) {
        const error = /** @type {AcornError} */ error_;
        const point = parseOffsetToUnistPoint(error.pos);
        error.message = String(error.message).replace(/ \(\d+:\d+\)$/, '');
        // Always defined in our unist points that come from micromark.
        error.pos = point.offset;
        error.loc = {
            line: point.line,
            column: point.column - 1
        };
        exception = error;
        swallow = error.raisedAt >= prefix.length + source.length || // Broken comments are raised at their start, not their end.
        error.message === 'Unterminated comment';
    }
    if (estree && options.expression && !isEmptyExpression) {
        if ($ea4035acf84f2507$var$empty(value.slice(estree.end, value.length - suffix.length))) estree = {
            type: 'Program',
            start: 0,
            end: prefix.length + source.length,
            // @ts-expect-error: It’s good.
            body: [
                {
                    type: 'ExpressionStatement',
                    expression: estree,
                    start: 0,
                    end: prefix.length + source.length
                }
            ],
            sourceType: 'module',
            comments: []
        };
        else {
            const point = parseOffsetToUnistPoint(estree.end);
            const error = /** @type {AcornError} */ new Error('Unexpected content after expression');
            // Always defined in our unist points that come from micromark.
            error.pos = point.offset;
            error.loc = {
                line: point.line,
                column: point.column - 1
            };
            exception = error;
            estree = undefined;
        }
    }
    if (estree) {
        // @ts-expect-error: acorn *does* allow comments
        estree.comments = comments;
        // @ts-expect-error: acorn looks enough like estree.
        (0, $dec343fef8154917$export$bf638b60ea8b89b7)(estree, function(esnode, field, index, parents) {
            let context = /** @type {AcornNode | Array<AcornNode>} */ parents[parents.length - 1];
            /** @type {number | string | undefined} */ let property = field;
            // Remove non-standard `ParenthesizedExpression`.
            // @ts-expect-error: included in acorn.
            if (esnode.type === 'ParenthesizedExpression' && context && property) {
                /* c8 ignore next 5 */ if (typeof index === 'number') {
                    // @ts-expect-error: indexable.
                    context = context[property];
                    property = index;
                }
                // @ts-expect-error: indexable.
                context[property] = esnode.expression;
            }
            fixPosition(esnode);
        });
        // Comment positions are fixed by `visit` because they’re in the tree.
        if (Array.isArray(onComment)) onComment.push(...comments);
        else if (typeof onComment === 'function') for (const comment of comments)onComment(comment.type === 'Block', comment.value, comment.start, comment.end, comment.loc.start, comment.loc.end);
        for (const token of tokens){
            // Ignore tokens that ends in prefix or start in suffix:
            if (token.end <= prefix.length || token.start - prefix.length >= source.length) continue;
            fixPosition(token);
            if (Array.isArray(onToken)) onToken.push(token);
            else // `tokens` are not added if `onToken` is not defined, so it must be a
            // function.
            onToken(token);
        }
    }
    // @ts-expect-error: It’s a program now.
    return {
        estree: estree,
        error: exception,
        swallow: swallow
    };
    /**
   * Update the position of a node.
   *
   * @param {AcornNode | EstreeNode | Token} nodeOrToken
   * @returns {undefined}
   */ function fixPosition(nodeOrToken) {
        const pointStart = parseOffsetToUnistPoint(nodeOrToken.start);
        const pointEnd = parseOffsetToUnistPoint(nodeOrToken.end);
        // Always defined in our unist points that come from micromark.
        nodeOrToken.start = pointStart.offset;
        nodeOrToken.end = pointEnd.offset;
        nodeOrToken.loc = {
            start: {
                line: pointStart.line,
                column: pointStart.column - 1,
                // @ts-expect-error: not allowed by acorn types.
                offset: pointStart.offset
            },
            end: {
                line: pointEnd.line,
                column: pointEnd.column - 1,
                // @ts-expect-error: not allowed by acorn types.
                offset: pointEnd.offset
            }
        };
        nodeOrToken.range = [
            nodeOrToken.start,
            nodeOrToken.end
        ];
    }
    /**
   * Turn an arbitrary offset into the parsed value, into a point in the source
   * value.
   *
   * @param {number} acornOffset
   * @returns {UnistPoint}
   */ function parseOffsetToUnistPoint(acornOffset) {
        let sourceOffset = acornOffset - prefix.length;
        if (sourceOffset < 0) sourceOffset = 0;
        else if (sourceOffset > source.length) sourceOffset = source.length;
        let point = $ea4035acf84f2507$var$relativeToPoint(collection.stops, sourceOffset);
        if (!point) point = {
            line: options.start.line,
            column: options.start.column,
            offset: options.start.offset
        };
        return point;
    }
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $ea4035acf84f2507$var$empty(value) {
    return /^\s*$/.test(value// Multiline comments.
    .replace(/\/\*[\s\S]*?\*\//g, '')// Line comments.
    // EOF instead of EOL is specifically not allowed, because that would
    // mean the closing brace is on the commented-out line
    .replace(/\/\/[^\r\n]*(\r\n|\n|\r)/g, ''));
}
// Port from <https://github.com/wooorm/markdown-rs/blob/e692ab0/src/util/mdx_collect.rs#L15>.
/**
 * @param {Array<Event>} events
 * @param {Array<TokenType>} tokenTypes
 * @returns {Collection}
 */ function $ea4035acf84f2507$var$collect(events, tokenTypes) {
    /** @type {Collection} */ const result = {
        value: '',
        stops: []
    };
    let index = -1;
    while(++index < events.length){
        const event = events[index];
        // Assume void.
        if (event[0] === 'enter') {
            const type = event[1].type;
            if (type === "lineEnding" || tokenTypes.includes(type)) {
                const chunks = event[2].sliceStream(event[1]);
                // Drop virtual spaces.
                while(chunks.length > 0 && chunks[0] === -1)chunks.shift();
                const value = $ea4035acf84f2507$var$serializeChunks(chunks);
                result.stops.push([
                    result.value.length,
                    event[1].start
                ]);
                result.value += value;
                result.stops.push([
                    result.value.length,
                    event[1].end
                ]);
            }
        }
    }
    return result;
}
// Port from <https://github.com/wooorm/markdown-rs/blob/e692ab0/src/util/location.rs#L91>.
/**
 * Turn a relative offset into an absolute offset.
 *
 * @param {Array<Stop>} stops
 * @param {number} relative
 * @returns {UnistPoint | undefined}
 */ function $ea4035acf84f2507$var$relativeToPoint(stops, relative) {
    let index = 0;
    while(index < stops.length && stops[index][0] <= relative)index += 1;
    // There are no points: that only occurs if there was an empty string.
    if (index === 0) return undefined;
    const [stopRelative, stopAbsolute] = stops[index - 1];
    const rest = relative - stopRelative;
    return {
        line: stopAbsolute.line,
        column: stopAbsolute.column + rest,
        offset: stopAbsolute.offset + rest
    };
}
// Copy from <https://github.com/micromark/micromark/blob/ce3593a/packages/micromark/dev/lib/create-tokenizer.js#L595>
// To do: expose that?
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @returns {string}
 */ function $ea4035acf84f2507$var$serializeChunks(chunks) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = "\t";
                break;
            /* c8 ignore next 6 */ case -1:
                if (atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                // eslint-disable-next-line unicorn/prefer-code-point
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


/**
 * @typedef {import('unist').Point} UnistPoint
 * @typedef {import('unist').Position} UnistPosition
 */ /**
 * @typedef {[start: number | null | undefined, end: number | null | undefined]} RangeLike
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 *
 * @typedef LocLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef NodeLike
 * @property {LocLike | null | undefined} [loc]
 * @property {RangeLike | null | undefined} [range]
 * @property {number | null | undefined} [start]
 * @property {number | null | undefined} [end]
 */ /**
 * Turn an estree `node` into a unist `position`.
 *
 * @param {NodeLike | null | undefined} [node]
 *   estree node.
 * @returns {UnistPosition | undefined}
 *   unist position.
 */ function $e835ebe36ab96295$export$eb05a1bc922beed(node) {
    const nodeLike = node || {};
    const loc = nodeLike.loc || {};
    const range = nodeLike.range || [
        undefined,
        undefined
    ];
    const start = $e835ebe36ab96295$var$pointOrUndefined(loc.start, range[0] || nodeLike.start);
    const end = $e835ebe36ab96295$var$pointOrUndefined(loc.end, range[1] || nodeLike.end);
    if (start && end) return {
        start: start,
        end: end
    };
}
/**
 * @param {unknown} estreePoint
 *   estree point.
 * @param {unknown} estreeOffset
 *  estree offset.
 * @returns {UnistPoint | undefined}
 *   unist point.
 */ function $e835ebe36ab96295$var$pointOrUndefined(estreePoint, estreeOffset) {
    if (estreePoint && typeof estreePoint === 'object') {
        const line = 'line' in estreePoint ? $e835ebe36ab96295$var$numberOrUndefined(estreePoint.line) : undefined;
        const column = 'column' in estreePoint ? $e835ebe36ab96295$var$numberOrUndefined(estreePoint.column) : undefined;
        if (line && column !== undefined) return {
            line: line,
            column: column + 1,
            offset: $e835ebe36ab96295$var$numberOrUndefined(estreeOffset)
        };
    }
}
/**
 * @param {unknown} value
 * @returns {number | undefined}
 */ function $e835ebe36ab96295$var$numberOrUndefined(value) {
    return typeof value === 'number' && value > -1 ? value : undefined;
}



// Tab-size to eat has to be the same as what we serialize as.
// While in some places in markdown that’s 4, in JS it’s more common as 2.
// Which is what’s also in `mdast-util-mdx-jsx`:
// <https://github.com/syntax-tree/mdast-util-mdx-jsx/blob/40b951b/lib/index.js#L52>
const $f9fbe8ea719d7769$var$indentSize = 2;
const $f9fbe8ea719d7769$var$trouble = 'https://github.com/micromark/micromark-extension-mdx-expression/tree/main/packages/micromark-extension-mdx-expression';
const $f9fbe8ea719d7769$var$unexpectedEndOfFileHash = '#unexpected-end-of-file-in-expression-expected-a-corresponding-closing-brace-for-';
const $f9fbe8ea719d7769$var$unexpectedLazyHash = '#unexpected-lazy-line-in-expression-in-container-expected-line-to-be-prefixed';
const $f9fbe8ea719d7769$var$nonSpreadHash = '#unexpected-type-in-code-expected-an-object-spread-spread';
const $f9fbe8ea719d7769$var$spreadExtraHash = '#unexpected-extra-content-in-spread-only-a-single-spread-is-supported';
const $f9fbe8ea719d7769$var$acornHash = '#could-not-parse-expression-with-acorn';
function $f9fbe8ea719d7769$export$dd8b446605ddcf57(effects, ok, type, markerType, chunkType, acorn, acornOptions, addResult, spread, allowEmpty, allowLazy) {
    const self = this;
    const eventStart = this.events.length + 3; // Add main and marker token
    let size = 0;
    /** @type {Point} */ let pointStart;
    /** @type {Error} */ let lastCrash;
    return start;
    /**
   * Start of an MDX expression.
   *
   * ```markdown
   * > | a {Math.PI} c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        pointStart = self.now();
        return before;
    }
    /**
   * Before data.
   *
   * ```markdown
   * > | a {Math.PI} c
   *        ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        if (code === null) {
            if (lastCrash) throw lastCrash;
            const error = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected end of file in expression, expected a corresponding closing brace for `{`', {
                place: self.now(),
                ruleId: 'unexpected-eof',
                source: 'micromark-extension-mdx-expression'
            });
            error.url = $f9fbe8ea719d7769$var$trouble + $f9fbe8ea719d7769$var$unexpectedEndOfFileHash;
            throw error;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return eolAfter;
        }
        if (code === 125 && size === 0) {
            /** @type {MdxSignal} */ const next = acorn ? $f9fbe8ea719d7769$var$mdxExpressionParse.call(self, acorn, acornOptions, chunkType, eventStart, pointStart, allowEmpty || false, spread || false) : {
                type: 'ok',
                estree: undefined
            };
            if (next.type === 'ok') {
                effects.enter(markerType);
                effects.consume(code);
                effects.exit(markerType);
                const token = effects.exit(type);
                if (addResult && next.estree) Object.assign(token, {
                    estree: next.estree
                });
                return ok;
            }
            lastCrash = next.message;
            effects.enter(chunkType);
            effects.consume(code);
            return inside;
        }
        effects.enter(chunkType);
        return inside(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | a {Math.PI} c
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === 125 && size === 0 || code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit(chunkType);
            return before(code);
        }
        // Don’t count if gnostic.
        if (code === 123 && !acorn) size += 1;
        else if (code === 125) size -= 1;
        effects.consume(code);
        return inside;
    }
    /**
   * After eol.
   *
   * ```markdown
   *   | a {b +
   * > | c} d
   *     ^
   * ```
   *
   * @type {State}
   */ function eolAfter(code) {
        const now = self.now();
        // Lazy continuation in a flow expression (or flow tag) is a syntax error.
        if (now.line !== pointStart.line && !allowLazy && self.parser.lazy[now.line]) {
            const error = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected lazy line in expression in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc', {
                place: self.now(),
                ruleId: 'unexpected-lazy',
                source: 'micromark-extension-mdx-expression'
            });
            error.url = $f9fbe8ea719d7769$var$trouble + $f9fbe8ea719d7769$var$unexpectedLazyHash;
            throw error;
        }
        // Note: `markdown-rs` uses `4`, but we use `2`.
        //
        // Idea: investigate if we’d need to use more complex stripping.
        // Take this example:
        //
        // ```markdown
        // >  aaa <b c={`
        // >      d
        // >  `} /> eee
        // ```
        //
        // Currently, the “paragraph” starts at `> | aaa`, so for the next line
        // here we split it into `>␠|␠␠|␠␠␠d` (prefix, this indent here,
        // expression data).
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, before, "linePrefix", $f9fbe8ea719d7769$var$indentSize + 1)(code);
        return before(code);
    }
}
/**
 * Mix of `markdown-rs`’s `parse_expression` and `MdxExpressionParse`
 * functionality, to wrap our `eventsToAcorn`.
 *
 * In the future, the plan is to realise the rust way, which allows arbitrary
 * parsers.
 *
 * @this {TokenizeContext}
 * @param {Acorn} acorn
 * @param {AcornOptions | null | undefined} acornOptions
 * @param {TokenType} chunkType
 * @param {number} eventStart
 * @param {Point} pointStart
 * @param {boolean} allowEmpty
 * @param {boolean} spread
 * @returns {MdxSignal}
 */ // eslint-disable-next-line max-params
function $f9fbe8ea719d7769$var$mdxExpressionParse(acorn, acornOptions, chunkType, eventStart, pointStart, allowEmpty, spread) {
    // Gnostic mode: parse w/ acorn.
    const result = (0, $ea4035acf84f2507$export$2d5e4b80efde7308)(this.events.slice(eventStart), {
        acorn: acorn,
        tokenTypes: [
            chunkType
        ],
        acornOptions: acornOptions,
        start: pointStart,
        expression: true,
        allowEmpty: allowEmpty,
        prefix: spread ? '({' : '',
        suffix: spread ? '})' : ''
    });
    const estree = result.estree;
    // Get the spread value.
    if (spread && estree) {
        // Should always be the case as we wrap in `d={}`
        const head = estree.body[0];
        if (head.type !== 'ExpressionStatement' || head.expression.type !== 'ObjectExpression') {
            const place = (0, $e835ebe36ab96295$export$eb05a1bc922beed)(head);
            const error = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected `' + head.type + '` in code: expected an object spread (`{...spread}`)', {
                place: place.start,
                ruleId: 'non-spread',
                source: 'micromark-extension-mdx-expression'
            });
            error.url = $f9fbe8ea719d7769$var$trouble + $f9fbe8ea719d7769$var$nonSpreadHash;
            throw error;
        }
        if (head.expression.properties[1]) {
            const place = (0, $e835ebe36ab96295$export$eb05a1bc922beed)(head.expression.properties[1]);
            const error = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected extra content in spread: only a single spread is supported', {
                place: place.start,
                ruleId: 'spread-extra',
                source: 'micromark-extension-mdx-expression'
            });
            error.url = $f9fbe8ea719d7769$var$trouble + $f9fbe8ea719d7769$var$spreadExtraHash;
            throw error;
        }
        if (head.expression.properties[0] && head.expression.properties[0].type !== 'SpreadElement') {
            const place = (0, $e835ebe36ab96295$export$eb05a1bc922beed)(head.expression.properties[0]);
            const error = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected `' + head.expression.properties[0].type + '` in code: only spread elements are supported', {
                place: place.start,
                ruleId: 'non-spread',
                source: 'micromark-extension-mdx-expression'
            });
            error.url = $f9fbe8ea719d7769$var$trouble + $f9fbe8ea719d7769$var$nonSpreadHash;
            throw error;
        }
    }
    if (result.error) {
        const error = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Could not parse expression with acorn', {
            cause: result.error,
            place: {
                line: result.error.loc.line,
                column: result.error.loc.column + 1,
                offset: result.error.pos
            },
            ruleId: 'acorn',
            source: 'micromark-extension-mdx-expression'
        });
        error.url = $f9fbe8ea719d7769$var$trouble + $f9fbe8ea719d7769$var$acornHash;
        return {
            type: 'nok',
            message: error
        };
    }
    return {
        type: 'ok',
        estree: estree
    };
}




const $adbfe48065343a10$var$trouble = 'https://github.com/micromark/micromark-extension-mdx-jsx';
function $adbfe48065343a10$export$307463d3ebf233f6(effects, ok, nok, acorn, acornOptions, addResult, allowLazy, tagType, tagMarkerType, tagClosingMarkerType, tagSelfClosingMarker, tagNameType, tagNamePrimaryType, tagNameMemberMarkerType, tagNameMemberType, tagNamePrefixMarkerType, tagNameLocalType, tagExpressionAttributeType, tagExpressionAttributeMarkerType, tagExpressionAttributeValueType, tagAttributeType, tagAttributeNameType, tagAttributeNamePrimaryType, tagAttributeNamePrefixMarkerType, tagAttributeNameLocalType, tagAttributeInitializerMarkerType, tagAttributeValueLiteralType, tagAttributeValueLiteralMarkerType, tagAttributeValueLiteralValueType, tagAttributeValueExpressionType, tagAttributeValueExpressionMarkerType, tagAttributeValueExpressionValueType) {
    const self = this;
    /** @type {State} */ let returnState;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    return start;
    /**
   * Start of MDX: JSX.
   *
   * ```markdown
   * > | a <B /> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(tagType);
        effects.enter(tagMarkerType);
        effects.consume(code);
        effects.exit(tagMarkerType);
        return startAfter;
    }
    /**
   * After `<`.
   *
   * ```markdown
   * > | a <B /> c
   *        ^
   * ```
   *
   * @type {State}
   */ function startAfter(code) {
        // Deviate from JSX, which allows arbitrary whitespace.
        // See: <https://github.com/micromark/micromark-extension-mdx-jsx/issues/7>.
        if ((0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return nok(code);
        // Any other ES whitespace does not get this treatment.
        returnState = nameBefore;
        return esWhitespaceStart(code);
    }
    /**
   * Before name, self slash, or end of tag for fragments.
   *
   * ```markdown
   * > | a <B> c
   *        ^
   * > | a </B> c
   *        ^
   * > | a <> b
   *        ^
   * ```
   *
   * @type {State}
   */ function nameBefore(code) {
        // Closing tag.
        if (code === 47) {
            effects.enter(tagClosingMarkerType);
            effects.consume(code);
            effects.exit(tagClosingMarkerType);
            returnState = closingTagNameBefore;
            return esWhitespaceStart;
        }
        // Fragment opening tag.
        if (code === 62) return tagEnd(code);
        // Start of a name.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.enter(tagNameType);
            effects.enter(tagNamePrimaryType);
            effects.consume(code);
            return primaryName;
        }
        crash(code, 'before name', 'a character that can start a name, such as a letter, `$`, or `_`' + (code === 33 ? ' (note: to create a comment in MDX, use `{/* text */}`)' : ''));
    }
    /**
   * Before name of closing tag or end of closing fragment tag.
   *
   * ```markdown
   * > | a </> b
   *         ^
   * > | a </B> c
   *         ^
   * ```
   *
   * @type {State}
   */ function closingTagNameBefore(code) {
        // Fragment closing tag.
        if (code === 62) return tagEnd(code);
        // Start of a closing tag name.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.enter(tagNameType);
            effects.enter(tagNamePrimaryType);
            effects.consume(code);
            return primaryName;
        }
        crash(code, 'before name', 'a character that can start a name, such as a letter, `$`, or `_`' + (code === 42 || code === 47 ? ' (note: JS comments in JSX tags are not supported in MDX)' : ''));
    }
    /**
   * In primary name.
   *
   * ```markdown
   * > | a <Bc> d
   *         ^
   * ```
   *
   * @type {State}
   */ function primaryName(code) {
        // Continuation of name: remain.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$10eb6dc47bf009dc)(code, {
            jsx: true
        })) {
            effects.consume(code);
            return primaryName;
        }
        // End of name.
        if (code === 46 || code === 47 || code === 58 || code === 62 || code === 123 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) {
            effects.exit(tagNamePrimaryType);
            returnState = primaryNameAfter;
            return esWhitespaceStart(code);
        }
        crash(code, 'in name', 'a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag' + (code === 64 ? ' (note: to create a link in MDX, use `[text](url)`)' : ''));
    }
    /**
   * After primary name.
   *
   * ```markdown
   * > | a <b.c> d
   *         ^
   * > | a <b:c> d
   *         ^
   * ```
   *
   * @type {State}
   */ function primaryNameAfter(code) {
        // Start of a member name.
        if (code === 46) {
            effects.enter(tagNameMemberMarkerType);
            effects.consume(code);
            effects.exit(tagNameMemberMarkerType);
            returnState = memberNameBefore;
            return esWhitespaceStart;
        }
        // Start of a local name.
        if (code === 58) {
            effects.enter(tagNamePrefixMarkerType);
            effects.consume(code);
            effects.exit(tagNamePrefixMarkerType);
            returnState = localNameBefore;
            return esWhitespaceStart;
        }
        // End of name.
        if (code === 47 || code === 62 || code === 123 || code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.exit(tagNameType);
            return attributeBefore(code);
        }
        crash(code, 'after name', 'a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag');
    }
    /**
   * Before member name.
   *
   * ```markdown
   * > | a <b.c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function memberNameBefore(code) {
        // Start of a member name.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.enter(tagNameMemberType);
            effects.consume(code);
            return memberName;
        }
        crash(code, 'before member name', 'a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag');
    }
    /**
   * In member name.
   *
   * ```markdown
   * > | a <b.cd> e
   *           ^
   * ```
   *
   * @type {State}
   */ function memberName(code) {
        // Continuation of name: remain.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$10eb6dc47bf009dc)(code, {
            jsx: true
        })) {
            effects.consume(code);
            return memberName;
        }
        // End of name.
        // Note: no `:` allowed here.
        if (code === 46 || code === 47 || code === 62 || code === 123 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) {
            effects.exit(tagNameMemberType);
            returnState = memberNameAfter;
            return esWhitespaceStart(code);
        }
        crash(code, 'in member name', 'a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag' + (code === 64 ? ' (note: to create a link in MDX, use `[text](url)`)' : ''));
    }
    /**
   * After member name.
   *
   * ```markdown
   * > | a <b.c> d
   *           ^
   * > | a <b.c.d> e
   *           ^
   * ```
   *
   * @type {State}
   */ function memberNameAfter(code) {
        // Start another member name.
        if (code === 46) {
            effects.enter(tagNameMemberMarkerType);
            effects.consume(code);
            effects.exit(tagNameMemberMarkerType);
            returnState = memberNameBefore;
            return esWhitespaceStart;
        }
        // End of name.
        if (code === 47 || code === 62 || code === 123 || code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.exit(tagNameType);
            return attributeBefore(code);
        }
        crash(code, 'after member name', 'a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag');
    }
    /**
   * Local member name.
   *
   * ```markdown
   * > | a <b:c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function localNameBefore(code) {
        // Start of a local name.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.enter(tagNameLocalType);
            effects.consume(code);
            return localName;
        }
        crash(code, 'before local name', 'a character that can start a name, such as a letter, `$`, or `_`' + (code === 43 || code !== null && code > 46 && code < 58 /* `/` - `9` */  ? ' (note: to create a link in MDX, use `[text](url)`)' : ''));
    }
    /**
   * In local name.
   *
   * ```markdown
   * > | a <b:cd> e
   *           ^
   * ```
   *
   * @type {State}
   */ function localName(code) {
        // Continuation of name: remain.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$10eb6dc47bf009dc)(code, {
            jsx: true
        })) {
            effects.consume(code);
            return localName;
        }
        // End of local name (note that we don’t expect another colon, or a member).
        if (code === 47 || code === 62 || code === 123 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) {
            effects.exit(tagNameLocalType);
            returnState = localNameAfter;
            return esWhitespaceStart(code);
        }
        crash(code, 'in local name', 'a name character such as letters, digits, `$`, or `_`; whitespace before attributes; or the end of the tag');
    }
    /**
   * After local name.
   *
   * This is like as `primary_name_after`, but we don’t expect colons or
   * periods.
   *
   * ```markdown
   * > | a <b.c> d
   *           ^
   * > | a <b.c.d> e
   *           ^
   * ```
   *
   * @type {State}
   */ function localNameAfter(code) {
        // End of name.
        if (code === 47 || code === 62 || code === 123 || code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.exit(tagNameType);
            return attributeBefore(code);
        }
        crash(code, 'after local name', 'a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag');
    }
    /**
   * Before attribute.
   *
   * ```markdown
   * > | a <b /> c
   *          ^
   * > | a <b > c
   *          ^
   * > | a <b {...c}> d
   *          ^
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function attributeBefore(code) {
        // Self-closing.
        if (code === 47) {
            effects.enter(tagSelfClosingMarker);
            effects.consume(code);
            effects.exit(tagSelfClosingMarker);
            returnState = selfClosing;
            return esWhitespaceStart;
        }
        // End of tag.
        if (code === 62) return tagEnd(code);
        // Attribute expression.
        if (code === 123) return (0, $f9fbe8ea719d7769$export$dd8b446605ddcf57).call(self, effects, attributeExpressionAfter, tagExpressionAttributeType, tagExpressionAttributeMarkerType, tagExpressionAttributeValueType, acorn, acornOptions, addResult, true, false, allowLazy)(code);
        // Start of an attribute name.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.enter(tagAttributeType);
            effects.enter(tagAttributeNameType);
            effects.enter(tagAttributeNamePrimaryType);
            effects.consume(code);
            return attributePrimaryName;
        }
        crash(code, 'before attribute name', 'a character that can start an attribute name, such as a letter, `$`, or `_`; whitespace before attributes; or the end of the tag');
    }
    /**
   * After attribute expression.
   *
   * ```markdown
   * > | a <b {c} d/> e
   *             ^
   * ```
   *
   * @type {State}
   */ function attributeExpressionAfter(code) {
        returnState = attributeBefore;
        return esWhitespaceStart(code);
    }
    /**
   * In primary attribute name.
   *
   * ```markdown
   * > | a <b cd/> e
   *           ^
   * > | a <b c:d> e
   *           ^
   * > | a <b c=d> e
   *           ^
   * ```
   *
   * @type {State}
   */ function attributePrimaryName(code) {
        // Continuation of name: remain.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$10eb6dc47bf009dc)(code, {
            jsx: true
        })) {
            effects.consume(code);
            return attributePrimaryName;
        }
        // End of attribute name or tag.
        if (code === 47 || code === 58 || code === 61 || code === 62 || code === 123 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) {
            effects.exit(tagAttributeNamePrimaryType);
            returnState = attributePrimaryNameAfter;
            return esWhitespaceStart(code);
        }
        crash(code, 'in attribute name', 'an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag');
    }
    /**
   * After primary attribute name.
   *
   * ```markdown
   * > | a <b c/> d
   *           ^
   * > | a <b c:d> e
   *           ^
   * > | a <b c=d> e
   *           ^
   * ```
   *
   * @type {State}
   */ function attributePrimaryNameAfter(code) {
        // Start of a local name.
        if (code === 58) {
            effects.enter(tagAttributeNamePrefixMarkerType);
            effects.consume(code);
            effects.exit(tagAttributeNamePrefixMarkerType);
            returnState = attributeLocalNameBefore;
            return esWhitespaceStart;
        }
        // Initializer: start of an attribute value.
        if (code === 61) {
            effects.exit(tagAttributeNameType);
            effects.enter(tagAttributeInitializerMarkerType);
            effects.consume(code);
            effects.exit(tagAttributeInitializerMarkerType);
            returnState = attributeValueBefore;
            return esWhitespaceStart;
        }
        // End of tag / new attribute.
        if (code === 47 || code === 62 || code === 123 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code) || code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.exit(tagAttributeNameType);
            effects.exit(tagAttributeType);
            returnState = attributeBefore;
            return esWhitespaceStart(code);
        }
        crash(code, 'after attribute name', 'a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag');
    }
    /**
   * Before local attribute name.
   *
   * ```markdown
   * > | a <b c:d/> e
   *            ^
   * ```
   *
   * @type {State}
   */ function attributeLocalNameBefore(code) {
        // Start of a local name.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.enter(tagAttributeNameLocalType);
            effects.consume(code);
            return attributeLocalName;
        }
        crash(code, 'before local attribute name', 'a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag');
    }
    /**
   * In local attribute name.
   *
   * ```markdown
   * > | a <b c:de/> f
   *             ^
   * > | a <b c:d=e/> f
   *             ^
   * ```
   *
   * @type {State}
   */ function attributeLocalName(code) {
        // Continuation of name: remain.
        if (code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$10eb6dc47bf009dc)(code, {
            jsx: true
        })) {
            effects.consume(code);
            return attributeLocalName;
        }
        // End of local name (note that we don’t expect another colon).
        if (code === 47 || code === 61 || code === 62 || code === 123 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) {
            effects.exit(tagAttributeNameLocalType);
            effects.exit(tagAttributeNameType);
            returnState = attributeLocalNameAfter;
            return esWhitespaceStart(code);
        }
        crash(code, 'in local attribute name', 'an attribute name character such as letters, digits, `$`, or `_`; `=` to initialize a value; whitespace before attributes; or the end of the tag');
    }
    /**
   * After local attribute name.
   *
   * ```markdown
   * > | a <b c:d/> f
   *             ^
   * > | a <b c:d=e/> f
   *             ^
   * ```
   *
   * @type {State}
   */ function attributeLocalNameAfter(code) {
        // Start of an attribute value.
        if (code === 61) {
            effects.enter(tagAttributeInitializerMarkerType);
            effects.consume(code);
            effects.exit(tagAttributeInitializerMarkerType);
            returnState = attributeValueBefore;
            return esWhitespaceStart;
        }
        // End of name.
        if (code === 47 || code === 62 || code === 123 || code !== null && code >= 0 && (0, $8ae047d5df63cb7f$export$b3571188c770cc5a)(code)) {
            effects.exit(tagAttributeType);
            return attributeBefore(code);
        }
        crash(code, 'after local attribute name', 'a character that can start an attribute name, such as a letter, `$`, or `_`; `=` to initialize a value; or the end of the tag');
    }
    /**
   * After `=`, before value.
   *
   * ```markdown
   * > | a <b c="d"/> e
   *            ^
   * > | a <b c={d}/> e
   *            ^
   * ```
   *
   * @type {State}
   */ function attributeValueBefore(code) {
        // Start of double- or single quoted value.
        if (code === 34 || code === 39) {
            effects.enter(tagAttributeValueLiteralType);
            effects.enter(tagAttributeValueLiteralMarkerType);
            effects.consume(code);
            effects.exit(tagAttributeValueLiteralMarkerType);
            marker = code;
            return attributeValueQuotedStart;
        }
        // Attribute value expression.
        if (code === 123) return (0, $f9fbe8ea719d7769$export$dd8b446605ddcf57).call(self, effects, attributeValueExpressionAfter, tagAttributeValueExpressionType, tagAttributeValueExpressionMarkerType, tagAttributeValueExpressionValueType, acorn, acornOptions, addResult, false, false, allowLazy)(code);
        crash(code, 'before attribute value', 'a character that can start an attribute value, such as `"`, `\'`, or `{`' + (code === 60 ? ' (note: to use an element or fragment as a prop value in MDX, use `{<element />}`)' : ''));
    }
    /**
   * After attribute value expression.
   *
   * ```markdown
   * > | a <b c={d} e/> f
   *               ^
   * ```
   *
   * @type {State}
   */ function attributeValueExpressionAfter(code) {
        effects.exit(tagAttributeType);
        returnState = attributeBefore;
        return esWhitespaceStart(code);
    }
    /**
   * Before quoted literal attribute value.
   *
   * ```markdown
   * > | a <b c="d"/> e
   *            ^
   * ```
   *
   * @type {State}
   */ function attributeValueQuotedStart(code) {
        if (code === null) crash(code, 'in attribute value', 'a corresponding closing quote `' + String.fromCodePoint(marker) + '`');
        if (code === marker) {
            effects.enter(tagAttributeValueLiteralMarkerType);
            effects.consume(code);
            effects.exit(tagAttributeValueLiteralMarkerType);
            effects.exit(tagAttributeValueLiteralType);
            effects.exit(tagAttributeType);
            marker = undefined;
            returnState = attributeBefore;
            return esWhitespaceStart;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = attributeValueQuotedStart;
            return esWhitespaceStart(code);
        }
        effects.enter(tagAttributeValueLiteralValueType);
        return attributeValueQuoted(code);
    }
    /**
   * In quoted literal attribute value.
   *
   * ```markdown
   * > | a <b c="d"/> e
   *             ^
   * ```
   *
   * @type {State}
   */ function attributeValueQuoted(code) {
        if (code === null || code === marker || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit(tagAttributeValueLiteralValueType);
            return attributeValueQuotedStart(code);
        }
        effects.consume(code);
        return attributeValueQuoted;
    }
    /**
   * After self-closing slash.
   *
   * ```markdown
   * > | a <b/> c
   *          ^
   * ```
   *
   * @type {State}
   */ function selfClosing(code) {
        if (code === 62) return tagEnd(code);
        crash(code, 'after self-closing slash', '`>` to end the tag' + (code === 42 || code === 47 ? ' (note: JS comments in JSX tags are not supported in MDX)' : ''));
    }
    /**
   * At final `>`.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagEnd(code) {
        effects.enter(tagMarkerType);
        effects.consume(code);
        effects.exit(tagMarkerType);
        effects.exit(tagType);
        return ok;
    }
    /**
   * Before optional ECMAScript whitespace.
   *
   * ```markdown
   * > | a <a b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function esWhitespaceStart(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return esWhitespaceEolAfter;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) {
            effects.enter('esWhitespace');
            return esWhitespaceInside(code);
        }
        return returnState(code);
    }
    /**
   * In ECMAScript whitespace.
   *
   * ```markdown
   * > | a <a  b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function esWhitespaceInside(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit('esWhitespace');
            return esWhitespaceStart(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) || (0, $9a96cd0c036af4eb$export$a0ff789c034ffdf4)(code)) {
            effects.consume(code);
            return esWhitespaceInside;
        }
        effects.exit('esWhitespace');
        return returnState(code);
    }
    /**
   * After eol in whitespace.
   *
   * ```markdown
   * > | a <a\nb> c
   *          ^
   * ```
   *
   * @type {State}
   */ function esWhitespaceEolAfter(code) {
        // Lazy continuation in a flow tag is a syntax error.
        if (!allowLazy && self.parser.lazy[self.now().line]) {
            const error = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected lazy line in container, expected line to be prefixed with `>` when in a block quote, whitespace when in a list, etc', self.now(), 'micromark-extension-mdx-jsx:unexpected-lazy');
            error.url = $adbfe48065343a10$var$trouble + '#unexpected-lazy-line-in-container-expected-line-to-be';
            throw error;
        }
        return esWhitespaceStart(code);
    }
    /**
   * Crash at a nonconforming character.
   *
   * @param {Code} code
   * @param {string} at
   * @param {string} expect
   */ function crash(code, at, expect) {
        const error = new (0, $0aa9ed7423c10921$export$752e5c445fe834ef)('Unexpected ' + (code === null ? 'end of file' : 'character `' + (code === 96 ? '` ` `' : String.fromCodePoint(code)) + '` (' + $adbfe48065343a10$var$serializeCharCode(code) + ')') + ' ' + at + ', expected ' + expect, self.now(), 'micromark-extension-mdx-jsx:unexpected-' + (code === null ? 'eof' : 'character'));
        error.url = $adbfe48065343a10$var$trouble + (code === null ? '#unexpected-end-of-file-at-expected-expect' : '#unexpected-character-at-expected-expect');
        throw error;
    }
}
/**
 * @param {NonNullable<Code>} code
 * @returns {string}
 */ function $adbfe48065343a10$var$serializeCharCode(code) {
    return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}


function $c14aa130bdf7a459$export$83321c0d57b6cdf9(acorn, options) {
    return {
        name: 'mdxJsxTextTag',
        tokenize: tokenizeJsxText
    };
    /**
   * MDX JSX (text).
   *
   * ```markdown
   * > | a <b />.
   *       ^^^^^
   * ```
   *
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeJsxText(effects, ok, nok) {
        return (0, $adbfe48065343a10$export$307463d3ebf233f6).call(this, effects, ok, nok, acorn, options.acornOptions, options.addResult, true, 'mdxJsxTextTag', 'mdxJsxTextTagMarker', 'mdxJsxTextTagClosingMarker', 'mdxJsxTextTagSelfClosingMarker', 'mdxJsxTextTagName', 'mdxJsxTextTagNamePrimary', 'mdxJsxTextTagNameMemberMarker', 'mdxJsxTextTagNameMember', 'mdxJsxTextTagNamePrefixMarker', 'mdxJsxTextTagNameLocal', 'mdxJsxTextTagExpressionAttribute', 'mdxJsxTextTagExpressionAttributeMarker', 'mdxJsxTextTagExpressionAttributeValue', 'mdxJsxTextTagAttribute', 'mdxJsxTextTagAttributeName', 'mdxJsxTextTagAttributeNamePrimary', 'mdxJsxTextTagAttributeNamePrefixMarker', 'mdxJsxTextTagAttributeNameLocal', 'mdxJsxTextTagAttributeInitializerMarker', 'mdxJsxTextTagAttributeValueLiteral', 'mdxJsxTextTagAttributeValueLiteralMarker', 'mdxJsxTextTagAttributeValueLiteralValue', 'mdxJsxTextTagAttributeValueExpression', 'mdxJsxTextTagAttributeValueExpressionMarker', 'mdxJsxTextTagAttributeValueExpressionValue');
    }
}


/**
 * @import {Options} from 'micromark-extension-mdx-jsx'
 * @import {Acorn} from 'micromark-util-events-to-acorn'
 * @import {Construct, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 


function $574d2e3e6225f408$export$9a48c5ccd9d7c542(acorn, options) {
    return {
        concrete: true,
        name: 'mdxJsxFlowTag',
        tokenize: tokenizeJsxFlow
    };
    /**
   * MDX JSX (flow).
   *
   * ```markdown
   * > | <A />
   *     ^^^^^
   * ```
   *
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeJsxFlow(effects, ok, nok) {
        const self = this;
        return start;
        /**
     * Start of MDX: JSX (flow).
     *
     * ```markdown
     * > | <A />
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // To do: in `markdown-rs`, constructs need to parse the indent themselves.
            // This should also be introduced in `micromark-js`.
            return before(code);
        }
        /**
     * After optional whitespace, before of MDX JSX (flow).
     *
     * ```markdown
     * > | <A />
     *     ^
     * ```
     *
     * @type {State}
     */ function before(code) {
            return (0, $adbfe48065343a10$export$307463d3ebf233f6).call(self, effects, after, nok, acorn, options.acornOptions, options.addResult, false, 'mdxJsxFlowTag', 'mdxJsxFlowTagMarker', 'mdxJsxFlowTagClosingMarker', 'mdxJsxFlowTagSelfClosingMarker', 'mdxJsxFlowTagName', 'mdxJsxFlowTagNamePrimary', 'mdxJsxFlowTagNameMemberMarker', 'mdxJsxFlowTagNameMember', 'mdxJsxFlowTagNamePrefixMarker', 'mdxJsxFlowTagNameLocal', 'mdxJsxFlowTagExpressionAttribute', 'mdxJsxFlowTagExpressionAttributeMarker', 'mdxJsxFlowTagExpressionAttributeValue', 'mdxJsxFlowTagAttribute', 'mdxJsxFlowTagAttributeName', 'mdxJsxFlowTagAttributeNamePrimary', 'mdxJsxFlowTagAttributeNamePrefixMarker', 'mdxJsxFlowTagAttributeNameLocal', 'mdxJsxFlowTagAttributeInitializerMarker', 'mdxJsxFlowTagAttributeValueLiteral', 'mdxJsxFlowTagAttributeValueLiteralMarker', 'mdxJsxFlowTagAttributeValueLiteralValue', 'mdxJsxFlowTagAttributeValueExpression', 'mdxJsxFlowTagAttributeValueExpressionMarker', 'mdxJsxFlowTagAttributeValueExpressionValue')(code);
        }
        /**
     * After an MDX JSX (flow) tag.
     *
     * ```markdown
     * > | <A>
     *        ^
     * ```
     *
     * @type {State}
     */ function after(code) {
            return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, end, "whitespace")(code) : end(code);
        }
        /**
     * After an MDX JSX (flow) tag, after optional whitespace.
     *
     * ```markdown
     * > | <A> <B>
     *         ^
     * ```
     *
     * @type {State}
     */ function end(code) {
            // We want to allow expressions directly after tags.
            // See <https://github.com/micromark/micromark-extension-mdx-expression/blob/d5d92b9/packages/micromark-extension-mdx-expression/dev/lib/syntax.js#L183>
            // for more info.
            const leftBraceValue = self.parser.constructs.flow[123];
            /* c8 ignore next 5 -- always a list when normalized. */ const constructs = Array.isArray(leftBraceValue) ? leftBraceValue : leftBraceValue ? [
                leftBraceValue
            ] : [];
            /** @type {Construct | undefined} */ let expression;
            for (const construct of constructs)if (construct.name === 'mdxFlowExpression') {
                expression = construct;
                break;
            }
            // Another tag.
            return code === 60 ? // We can’t just say: fine. Lines of blocks have to be parsed until an eol/eof.
            start(code) : code === 123 && expression ? effects.attempt(expression, end, nok)(code) : code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
        }
    }
}


function $f76040dfe9471610$export$e775b18258bc745d(options) {
    const settings = options || {};
    const acorn = settings.acorn;
    /** @type {AcornOptions | undefined} */ let acornOptions;
    if (acorn) {
        if (!acorn.parse || !acorn.parseExpressionAt) throw new Error('Expected a proper `acorn` instance passed in as `options.acorn`');
        acornOptions = Object.assign({
            ecmaVersion: 2024,
            sourceType: 'module'
        }, settings.acornOptions, {
            locations: true
        });
    } else if (settings.acornOptions || settings.addResult) throw new Error('Expected an `acorn` instance passed in as `options.acorn`');
    return {
        flow: {
            [60]: (0, $574d2e3e6225f408$export$9a48c5ccd9d7c542)(acorn || undefined, {
                acornOptions: acornOptions,
                addResult: settings.addResult || undefined
            })
        },
        text: {
            [60]: (0, $c14aa130bdf7a459$export$83321c0d57b6cdf9)(acorn || undefined, {
                acornOptions: acornOptions,
                addResult: settings.addResult || undefined
            })
        }
    };
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * Create an extension for `micromark` to disable some CommonMark syntax (code
 * (indented), autolinks, and HTML (flow and text)) for MDX.
 *
 * @returns {Extension}
 *   Extension for `micromark` that can be passed in `extensions` to disable
 *   some CommonMark syntax for MDX.
 */ function $537b4dcfe0c6a284$export$629c79f5885bcbb0() {
    return {
        disable: {
            null: [
                'autolink',
                'codeIndented',
                'htmlFlow',
                'htmlText'
            ]
        }
    };
}




/**
 * @import {Info, Join, Options, SafeConfig, State} from 'mdast-util-to-markdown'
 * @import {Nodes} from 'mdast'
 * @import {Enter, FlowParents, PhrasingParents, TrackFields} from './types.js'
 */ 
/**
 * @callback Handler
 *   Handle a value, with a certain ID field set to a certain value.
 *   The ID field is passed to `zwitch`, and it’s value is this function’s
 *   place on the `handlers` record.
 * @param {...any} parameters
 *   Arbitrary parameters passed to the zwitch.
 *   The first will be an object with a certain ID field set to a certain value.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback UnknownHandler
 *   Handle values that do have a certain ID field, but it’s set to a value
 *   that is not listed in the `handlers` record.
 * @param {unknown} value
 *   An object with a certain ID field set to an unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {any}
 *   Anything!
 */ /**
 * @callback InvalidHandler
 *   Handle values that do not have a certain ID field.
 * @param {unknown} value
 *   Any unknown value.
 * @param {...any} rest
 *   Arbitrary parameters passed to the zwitch.
 * @returns {void|null|undefined|never}
 *   This should crash or return nothing.
 */ /**
 * @template {InvalidHandler} [Invalid=InvalidHandler]
 * @template {UnknownHandler} [Unknown=UnknownHandler]
 * @template {Record<string, Handler>} [Handlers=Record<string, Handler>]
 * @typedef Options
 *   Configuration (required).
 * @property {Invalid} [invalid]
 *   Handler to use for invalid values.
 * @property {Unknown} [unknown]
 *   Handler to use for unknown values.
 * @property {Handlers} [handlers]
 *   Handlers to use.
 */ const $17810db8694da3f3$var$own = {}.hasOwnProperty;
function $17810db8694da3f3$export$d6a12bfbbedf6185(key, options) {
    const settings = options || {};
    /**
   * Handle one value.
   *
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @this {unknown}
   *   Any context object.
   * @param {unknown} [value]
   *   Any value.
   * @param {...unknown} parameters
   *   Arbitrary parameters passed to the zwitch.
   * @property {Handler} invalid
   *   Handle for values that do not have a certain ID field.
   * @property {Handler} unknown
   *   Handle values that do have a certain ID field, but it’s set to a value
   *   that is not listed in the `handlers` record.
   * @property {Handlers} handlers
   *   Record of handlers.
   * @returns {unknown}
   *   Anything.
   */ function one(value, ...parameters) {
        /** @type {Handler|undefined} */ let fn = one.invalid;
        const handlers = one.handlers;
        if (value && $17810db8694da3f3$var$own.call(value, key)) {
            // @ts-expect-error Indexable.
            const id = String(value[key]);
            // @ts-expect-error Indexable.
            fn = $17810db8694da3f3$var$own.call(handlers, id) ? handlers[id] : one.unknown;
        }
        if (fn) return fn.call(this, value, ...parameters);
    }
    one.handlers = settings.handlers || {};
    one.invalid = settings.invalid;
    one.unknown = settings.unknown;
    // @ts-expect-error: matches!
    return one;
}


/**
 * @import {Options, State} from './types.js'
 */ const $cb7184018dfae342$var$own = {}.hasOwnProperty;
function $cb7184018dfae342$export$8d21e34596265fa2(base, extension) {
    let index = -1;
    /** @type {keyof Options} */ let key;
    // First do subextensions.
    if (extension.extensions) while(++index < extension.extensions.length)$cb7184018dfae342$export$8d21e34596265fa2(base, extension.extensions[index]);
    for(key in extension)if ($cb7184018dfae342$var$own.call(extension, key)) switch(key){
        case 'extensions':
            break;
        /* c8 ignore next 4 */ case 'unsafe':
            $cb7184018dfae342$var$list(base[key], extension[key]);
            break;
        case 'join':
            $cb7184018dfae342$var$list(base[key], extension[key]);
            break;
        case 'handlers':
            $cb7184018dfae342$var$map(base[key], extension[key]);
            break;
        default:
            // @ts-expect-error: matches.
            base.options[key] = extension[key];
    }
    return base;
}
/**
 * @template T
 * @param {Array<T>} left
 * @param {Array<T> | null | undefined} right
 */ function $cb7184018dfae342$var$list(left, right) {
    if (right) left.push(...right);
}
/**
 * @template T
 * @param {Record<string, T>} left
 * @param {Record<string, T> | null | undefined} right
 */ function $cb7184018dfae342$var$map(left, right) {
    if (right) Object.assign(left, right);
}


/**
 * @import {Blockquote, Parents} from 'mdast'
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $c22d6b26d8763f1a$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter('blockquote');
    const tracker = state.createTracker(info);
    tracker.move('> ');
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $c22d6b26d8763f1a$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $c22d6b26d8763f1a$var$map(line, _, blank) {
    return '>' + (blank ? '' : ' ') + line;
}


/**
 * @import {Break, Parents} from 'mdast'
 * @import {Info, State} from 'mdast-util-to-markdown'
 */ /**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $faa99a565617de42$export$78221a09424368d(stack, pattern) {
    return $faa99a565617de42$var$listInScope(stack, pattern.inConstruct, true) && !$faa99a565617de42$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $faa99a565617de42$var$listInScope(stack, list, none) {
    if (typeof list === 'string') list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $b44c63001bb6e43e$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === '\n' && (0, $faa99a565617de42$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? '' : ' ';
    }
    return '\\\n';
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {Code, Parents} from 'mdast'
 */ 
/**
 * Get the count of the longest repeating streak of `substring` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} substring
 *   Substring to look for, typically one character.
 * @returns {number}
 *   Count of most frequent adjacent `substring`s in `value`.
 */ function $b732c3de0f6b9a59$export$711675ff42d864f2(value, substring) {
    const source = String(value);
    let index = source.indexOf(substring);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof substring !== 'string') throw new TypeError('Expected substring');
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + substring.length;
        index = source.indexOf(substring, expected);
    }
    return max;
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Code} from 'mdast'
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $976a1661809365d1$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $16d1e1d0e9bb535c$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || '`';
    if (marker !== '`' && marker !== '~') throw new Error('Cannot serialize code with `' + marker + '` for `options.fence`, expected `` ` `` or `~`');
    return marker;
}


function $c9de17fde5da4e09$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $16d1e1d0e9bb535c$export$7487ee7cbb2e2919)(state);
    const raw = node.value || '';
    const suffix = marker === '`' ? 'GraveAccent' : 'Tilde';
    if ((0, $976a1661809365d1$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter('codeIndented');
        const value = state.indentLines(raw, $c9de17fde5da4e09$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $b732c3de0f6b9a59$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter('codeFenced');
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: ' ',
            encode: [
                '`'
            ]
        }, tracker.current())));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(' ');
        value += tracker.move(state.safe(node.meta, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: '\n',
            encode: [
                '`'
            ]
        }, tracker.current())));
        subexit();
    }
    value += tracker.move('\n');
    if (raw) value += tracker.move(raw + '\n');
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $c9de17fde5da4e09$var$map(line, _, blank) {
    return (blank ? '' : '    ') + line;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Definition, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $ce55bd1707ed4560$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error('Cannot serialize title with `' + marker + '` for `options.quote`, expected `"`, or `\'`');
    return marker;
}


function $de907278b9522dcf$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $ce55bd1707ed4560$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('definition');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    value += tracker.move(state.safe(state.associationId(node), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current())));
    value += tracker.move(']: ');
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: node.title ? ' ' : '\n'
        }, tracker.current())));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: quote
        }, tracker.current())));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Emphasis, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $75785ad8dfd7e058$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize emphasis with `' + marker + '` for `options.emphasis`, expected `*`, or `_`');
    return marker;
}


/**
 * Encode a code point as a character reference.
 *
 * @param {number} code
 *   Code point to encode.
 * @returns {string}
 *   Encoded character reference.
 */ function $ef164935741e67b3$export$5810cf1e579e9d5b(code) {
    return '&#x' + code.toString(16).toUpperCase() + ';';
}


/**
 * @import {EncodeSides} from '../types.js'
 */ 
function $e3ad60aa0bb5edc4$export$b444be54825dd0b6(outside, inside, marker) {
    const outsideKind = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(outside);
    const insideKind = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(inside);
    // Letter outside:
    if (outsideKind === undefined) return insideKind === undefined ? // we have to encode *both* letters for `_` as it is looser.
    // it already forms for `*` (and GFMs `~`).
    marker === '_' ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: true
    };
    // Whitespace outside:
    if (outsideKind === 1) return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: true
    } : {
        inside: false,
        outside: false
    };
    // Punctuation outside:
    return insideKind === undefined ? {
        inside: false,
        outside: false
    } : insideKind === 1 ? {
        inside: true,
        outside: false
    } : {
        inside: false,
        outside: false
    };
}


$5363ce757c0f934c$export$bef81ba411953b51.peek = $5363ce757c0f934c$var$emphasisPeek;
function $5363ce757c0f934c$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $75785ad8dfd7e058$export$f967eb786dea04e7)(state);
    const exit = state.enter('emphasis');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker);
    let between = tracker.move(state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        after: marker,
        before: before
    }, tracker.current())));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $5363ce757c0f934c$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Heading, Parents} from 'mdast'
 */ 


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Heading} from 'mdast'
 */ /**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<infer T>
 *   ? MatchesOne<Value, T>
 *   : Check extends Array<infer T>
 *   ? MatchesOne<Value, T>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @import {Node, Parent} from 'unist'
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | ReadonlyArray<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $312c10cea7b70433$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends ReadonlyArray<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends Array<string>>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition[number]}) &
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $312c10cea7b70433$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== 'number' || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error('Expected positive finite index');
    if (parent !== undefined && parent !== null && (!$312c10cea7b70433$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error('Expected parent node');
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error('Expected both parent and index');
    return $312c10cea7b70433$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $312c10cea7b70433$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $312c10cea7b70433$var$ok;
    if (typeof test === 'function') return $312c10cea7b70433$var$castFactory(test);
    if (typeof test === 'object') return Array.isArray(test) ? $312c10cea7b70433$var$anyFactory(test) : // narrows to `Array`.
    $312c10cea7b70433$var$propertiesFactory(/** @type {Props} */ test);
    if (typeof test === 'string') return $312c10cea7b70433$var$typeFactory(test);
    throw new Error('Expected function, string, or object as test');
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $312c10cea7b70433$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $312c10cea7b70433$export$9c68d69a4c5bbcf9(tests[index]);
    return $312c10cea7b70433$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $312c10cea7b70433$var$propertiesFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $312c10cea7b70433$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $312c10cea7b70433$var$typeFactory(check) {
    return $312c10cea7b70433$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $312c10cea7b70433$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($312c10cea7b70433$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === 'number' ? index : undefined, parent || undefined));
    }
}
function $312c10cea7b70433$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $312c10cea7b70433$var$looksLikeANode(value) {
    return value !== null && typeof value === 'object' && 'type' in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $1e49ba1db9d29029$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $9ef2eaca0b34953c$var$empty = [];
const $9ef2eaca0b34953c$export$f4d8133c446fe484 = true;
const $9ef2eaca0b34953c$export$7f100f842f565dc9 = false;
const $9ef2eaca0b34953c$export$8773f85c2fb2c116 = 'skip';
function $9ef2eaca0b34953c$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === 'function' && typeof visitor !== 'function') {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === 'object' ? node : {};
        if (typeof value.type === 'string') {
            const name = // `hast`
            typeof value.tagName === 'string' ? value.tagName : typeof value.name === 'string' ? value.name : undefined;
            Object.defineProperty(visit, 'name', {
                value: 'node (' + (0, $1e49ba1db9d29029$export$35e9368ef982300f)(node.type + (name ? '<' + name + '>' : '')) + ')'
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $9ef2eaca0b34953c$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $9ef2eaca0b34953c$var$toResult(visitor(node, parents));
                if (result[0] === $9ef2eaca0b34953c$export$7f100f842f565dc9) return result;
            }
            if ('children' in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $9ef2eaca0b34953c$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $9ef2eaca0b34953c$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === 'number' ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $9ef2eaca0b34953c$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === 'number') return [
        $9ef2eaca0b34953c$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $9ef2eaca0b34953c$var$empty : [
        value
    ];
}

/**
 * @import {Node as UnistNode, Parent as UnistParent} from 'unist'
 * @import {VisitorResult} from 'unist-util-visit-parents'
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends ReadonlyArray<any>
 *   ? MatchesOne<Value, Check[number]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ 
function $2ca43c18c27b56fa$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === 'function' && typeof visitorOrReverse !== 'function') {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $9ef2eaca0b34953c$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}


/**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $da74a7bb5b052f79$var$emptyOptions = {};
function $da74a7bb5b052f79$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $da74a7bb5b052f79$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === 'boolean' ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === 'boolean' ? settings.includeHtml : true;
    return $da74a7bb5b052f79$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $da74a7bb5b052f79$var$one(value, includeImageAlt, includeHtml) {
    if ($da74a7bb5b052f79$var$node(value)) {
        if ('value' in value) return value.type === 'html' && !includeHtml ? '' : value.value;
        if (includeImageAlt && 'alt' in value && value.alt) return value.alt;
        if ('children' in value) return $da74a7bb5b052f79$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $da74a7bb5b052f79$var$all(value, includeImageAlt, includeHtml);
    return '';
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $da74a7bb5b052f79$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $da74a7bb5b052f79$var$one(values[index], includeImageAlt, includeHtml);
    return result.join('');
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $da74a7bb5b052f79$var$node(value) {
    return Boolean(value && typeof value === 'object');
}


function $57ca23d123f29cd8$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $2ca43c18c27b56fa$export$bf638b60ea8b89b7)(node, function(node) {
        if ('value' in node && /\r?\n|\r/.test(node.value) || node.type === 'break') {
            literalWithBreak = true;
            return 0, $9ef2eaca0b34953c$export$7f100f842f565dc9;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $da74a7bb5b052f79$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $b9838158d361d84b$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $57ca23d123f29cd8$export$78863676235adfbc)(node, state)) {
        const exit = state.enter('headingSetext');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tracker.current()), {
            before: '\n',
            after: '\n'
        }));
        subexit();
        exit();
        return value + '\n' + (rank === 1 ? '=' : '-').repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf('\r'), value.lastIndexOf('\n')) + 1));
    }
    const sequence = '#'.repeat(rank);
    const exit = state.enter('headingAtx');
    const subexit = state.enter('phrasing');
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + ' ');
    let value = state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: '# ',
        after: '\n'
    }, tracker.current()));
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(value.charCodeAt(0)) + value.slice(1);
    value = value ? sequence + ' ' + value : sequence;
    if (state.options.closeAtx) value += ' ' + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @import {Html} from 'mdast'
 */ $9a83b6191accc866$export$c0bb0b647f701bb5.peek = $9a83b6191accc866$var$htmlPeek;
function $9a83b6191accc866$export$c0bb0b647f701bb5(node) {
    return node.value || '';
}
/**
 * @returns {string}
 */ function $9a83b6191accc866$var$htmlPeek() {
    return '<';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Image, Parents} from 'mdast'
 */ 

$d5640795fae1711f$export$5c452ff88e35e47d.peek = $d5640795fae1711f$var$imagePeek;
function $d5640795fae1711f$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $ce55bd1707ed4560$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const exit = state.enter('image');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    value += tracker.move(state.safe(node.alt, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current())));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: node.title ? ' ' : ')'
        }, tracker.current())));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: quote
        }, tracker.current())));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $d5640795fae1711f$var$imagePeek() {
    return '!';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {ImageReference, Parents} from 'mdast'
 */ 
$9ab1f1e75e4d33d3$export$f281796f6bc3b8db.peek = $9ab1f1e75e4d33d3$var$imageReferencePeek;
function $9ab1f1e75e4d33d3$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('imageReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('![');
    const alt = state.safe(node.alt, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current()));
    value += tracker.move(alt + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current()));
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !alt || alt !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $9ab1f1e75e4d33d3$var$imageReferencePeek() {
    return '!';
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {InlineCode, Parents} from 'mdast'
 */ $d83732a415638d5c$export$91b9bee19a0d8569.peek = $d83732a415638d5c$var$inlineCodePeek;
function $d83732a415638d5c$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || '';
    let sequence = '`';
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp('(^|[^`])' + sequence + '([^`]|$)').test(value))sequence += '`';
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = ' ' + value + ' ';
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + ' ' + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $d83732a415638d5c$var$inlineCodePeek() {
    return '`';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Link, Parents} from 'mdast'
 * @import {Exit} from '../types.js'
 */ 

/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Link} from 'mdast'
 */ 
function $fa39aaa691787db5$export$74cae3045e3179ed(node, state) {
    const raw = (0, $da74a7bb5b052f79$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === 'text' && // And if the url is the same as the content…
    (raw === node.url || 'mailto:' + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$44386f6ce5814f19$export$9c30223ca0a664fb.peek = $44386f6ce5814f19$var$linkPeek;
function $44386f6ce5814f19$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $ce55bd1707ed4560$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? 'Quote' : 'Apostrophe';
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $fa39aaa691787db5$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter('autolink');
        let value = tracker.move('<');
        value += tracker.move(state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter('link');
    subexit = state.enter('label');
    let value = tracker.move('[');
    value += tracker.move(state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']('
    }, tracker.current())));
    value += tracker.move('](');
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter('destinationLiteral');
        value += tracker.move('<');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: '>'
        }, tracker.current())));
        value += tracker.move('>');
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter('destinationRaw');
        value += tracker.move(state.safe(node.url, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: node.title ? ' ' : ')'
        }, tracker.current())));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(' ' + quote);
        value += tracker.move(state.safe(node.title, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: value,
            after: quote
        }, tracker.current())));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(')');
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $44386f6ce5814f19$var$linkPeek(node, _, state) {
    return (0, $fa39aaa691787db5$export$74cae3045e3179ed)(node, state) ? '<' : '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {LinkReference, Parents} from 'mdast'
 */ 
$6fcde372b87d3fed$export$e6c469b1b7b2bc6a.peek = $6fcde372b87d3fed$var$linkReferencePeek;
function $6fcde372b87d3fed$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter('linkReference');
    let subexit = state.enter('label');
    const tracker = state.createTracker(info);
    let value = tracker.move('[');
    const text = state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current()));
    value += tracker.move(text + '][');
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter('reference');
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        before: value,
        after: ']'
    }, tracker.current()));
    subexit();
    state.stack = stack;
    exit();
    if (type === 'full' || !text || text !== reference) value += tracker.move(reference + ']');
    else if (type === 'shortcut') // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move(']');
    return value;
}
/**
 * @returns {string}
 */ function $6fcde372b87d3fed$var$linkReferencePeek() {
    return '[';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {List, Parents} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $f52261392897ff44$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || '*';
    if (marker !== '*' && marker !== '+' && marker !== '-') throw new Error('Cannot serialize items with `' + marker + '` for `options.bullet`, expected `*`, `+`, or `-`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ 
function $ae37c79b31867a05$export$e6803bf0889262a1(state) {
    const bullet = (0, $f52261392897ff44$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === '*' ? '-' : '*';
    if (bulletOther !== '*' && bulletOther !== '+' && bulletOther !== '-') throw new Error('Cannot serialize items with `' + bulletOther + '` for `options.bulletOther`, expected `*`, `+`, or `-`');
    if (bulletOther === bullet) throw new Error('Expected `bullet` (`' + bullet + '`) and `bulletOther` (`' + bulletOther + '`) to be different');
    return bulletOther;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $82eeac05fc7d31a0$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || '.';
    if (marker !== '.' && marker !== ')') throw new Error('Cannot serialize items with `' + marker + '` for `options.bulletOrdered`, expected `.` or `)`');
    return marker;
}


/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $01ecb0fec064563b$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || '*';
    if (marker !== '*' && marker !== '-' && marker !== '_') throw new Error('Cannot serialize rules with `' + marker + '` for `options.rule`, expected `*`, `-`, or `_`');
    return marker;
}


function $83184e8a3561368a$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter('list');
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $82eeac05fc7d31a0$export$98d522b78eddc19b)(state) : (0, $f52261392897ff44$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === '.' ? ')' : '.' : (0, $ae37c79b31867a05$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === '*' || bullet === '-') && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === 'list' && state.stack[state.stack.length - 2] === 'listItem' && state.stack[state.stack.length - 3] === 'list' && state.stack[state.stack.length - 4] === 'listItem' && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $01ecb0fec064563b$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === 'listItem' && item.children && item.children[0] && item.children[0].type === 'thematicBreak') {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @import {Info, Map, State} from 'mdast-util-to-markdown'
 * @import {ListItem, Parents} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $902901864b46e6e0$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || 'one';
    if (style !== 'tab' && style !== 'one' && style !== 'mixed') throw new Error('Cannot serialize items with `' + style + '` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`');
    return style;
}


function $6e73d61bc3f6f849$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $902901864b46e6e0$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $f52261392897ff44$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === 'list' && parent.ordered) bullet = (typeof parent.start === 'number' && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === 'tab' || listItemIndent === 'mixed' && (parent && parent.type === 'list' && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + ' '.repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter('listItem');
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? '' : ' '.repeat(size)) + line;
        return (blank ? bullet : bullet + ' '.repeat(size - bullet.length)) + line;
    }
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Paragraph, Parents} from 'mdast'
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $5dcdf38c0853bd5d$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter('paragraph');
    const subexit = state.enter('phrasing');
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Root} from 'mdast'
 */ /**
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
const $76e22c02785b163c$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is Exclude<PhrasingContent, Html>} */ (0, $312c10cea7b70433$export$9c68d69a4c5bbcf9)([
    'break',
    'delete',
    'emphasis',
    // To do: next major: removed since footnotes were added to GFM.
    'footnote',
    'footnoteReference',
    'image',
    'imageReference',
    'inlineCode',
    // Enabled by `mdast-util-math`:
    'inlineMath',
    'link',
    'linkReference',
    // Enabled by `mdast-util-mdx`:
    'mdxJsxTextElement',
    // Enabled by `mdast-util-mdx`:
    'mdxTextExpression',
    'strong',
    'text',
    // Enabled by `mdast-util-directive`:
    'textDirective'
]);


function $ec9cfa703f4340b2$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $76e22c02785b163c$export$444c9dec66a6f08c)(d);
    });
    const container = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return container.call(state, node, info);
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Strong} from 'mdast'
 */ 
/**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $6d8e2a72f1cdda8f$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || '*';
    if (marker !== '*' && marker !== '_') throw new Error('Cannot serialize strong with `' + marker + '` for `options.strong`, expected `*`, or `_`');
    return marker;
}




$50fff993476f6ef3$export$59ae2c325a998f89.peek = $50fff993476f6ef3$var$strongPeek;
function $50fff993476f6ef3$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $6d8e2a72f1cdda8f$export$b7ce17905d66a6c3)(state);
    const exit = state.enter('strong');
    const tracker = state.createTracker(info);
    const before = tracker.move(marker + marker);
    let between = tracker.move(state.containerPhrasing(node, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        after: marker,
        before: before
    }, tracker.current())));
    const betweenHead = between.charCodeAt(0);
    const open = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.before.charCodeAt(info.before.length - 1), betweenHead, marker);
    if (open.inside) between = (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenHead) + between.slice(1);
    const betweenTail = between.charCodeAt(between.length - 1);
    const close = (0, $e3ad60aa0bb5edc4$export$b444be54825dd0b6)(info.after.charCodeAt(0), betweenTail, marker);
    if (close.inside) between = between.slice(0, -1) + (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(betweenTail);
    const after = tracker.move(marker + marker);
    exit();
    state.attentionEncodeSurroundingInfo = {
        after: close.outside,
        before: open.outside
    };
    return before + between + after;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $50fff993476f6ef3$var$strongPeek(_, _1, state) {
    return state.options.strong || '*';
}


/**
 * @import {Info, State} from 'mdast-util-to-markdown'
 * @import {Parents, Text} from 'mdast'
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $7d79792942bf3874$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {Parents, ThematicBreak} from 'mdast'
 */ /**
 * @import {Options, State} from 'mdast-util-to-markdown'
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $9c901976bd352085$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error('Cannot serialize rules with repetition `' + repetition + '` for `options.ruleRepetition`, expected `3` or more');
    return repetition;
}



function $8f3edd6f95dc34f7$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $01ecb0fec064563b$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? ' ' : '')).repeat((0, $9c901976bd352085$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $da19da82921559d2$export$8f34ce051745d39e = {
    blockquote: $c22d6b26d8763f1a$export$67dc04e652a298ca,
    break: (0, $b44c63001bb6e43e$export$371da9dd35aba193),
    code: $c9de17fde5da4e09$export$6565f9f03506010b,
    definition: $de907278b9522dcf$export$69f215ed977cdb73,
    emphasis: $5363ce757c0f934c$export$bef81ba411953b51,
    hardBreak: $b44c63001bb6e43e$export$371da9dd35aba193,
    heading: $b9838158d361d84b$export$46e4a324ac90507f,
    html: $9a83b6191accc866$export$c0bb0b647f701bb5,
    image: $d5640795fae1711f$export$5c452ff88e35e47d,
    imageReference: $9ab1f1e75e4d33d3$export$f281796f6bc3b8db,
    inlineCode: $d83732a415638d5c$export$91b9bee19a0d8569,
    link: $44386f6ce5814f19$export$9c30223ca0a664fb,
    linkReference: $6fcde372b87d3fed$export$e6c469b1b7b2bc6a,
    list: $83184e8a3561368a$export$8837f4fc672e936d,
    listItem: $6e73d61bc3f6f849$export$76c7e83ecc9cdf05,
    paragraph: $5dcdf38c0853bd5d$export$9c206ddddb32a9b,
    root: $ec9cfa703f4340b2$export$e8e78c978b129247,
    strong: $50fff993476f6ef3$export$59ae2c325a998f89,
    text: $7d79792942bf3874$export$6f093cfa640b7166,
    thematicBreak: $8f3edd6f95dc34f7$export$ba7b13e047416c03
};


/**
 * @import {Join} from 'mdast-util-to-markdown'
 */ 

const $cb5ab2f3e1bff866$export$f7e2c8231c57a8bd = [
    $cb5ab2f3e1bff866$var$joinDefaults
];
/** @type {Join} */ function $cb5ab2f3e1bff866$var$joinDefaults(left, right, parent, state) {
    // Indented code after list or another indented code.
    if (right.type === 'code' && (0, $976a1661809365d1$export$8c0df78a8cad9f4b)(right, state) && (left.type === 'list' || left.type === right.type && (0, $976a1661809365d1$export$8c0df78a8cad9f4b)(left, state))) return false;
    // Join children of a list or an item.
    // In which case, `parent` has a `spread` field.
    if ('spread' in parent && typeof parent.spread === 'boolean') {
        if (left.type === 'paragraph' && // Two paragraphs.
        (left.type === right.type || right.type === 'definition' || // Paragraph followed by a setext heading.
        right.type === 'heading' && (0, $57ca23d123f29cd8$export$78863676235adfbc)(right, state))) return;
        return parent.spread ? 1 : 0;
    }
}


/**
 * @import {ConstructName, Unsafe} from 'mdast-util-to-markdown'
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain things like attention (emphasis, strong), images, or links.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * @type {Array<ConstructName>}
 */ const $b031131770a4aa99$var$fullPhrasingSpans = [
    'autolink',
    'destinationLiteral',
    'destinationRaw',
    'reference',
    'titleQuote',
    'titleApostrophe'
];
const $b031131770a4aa99$export$aa1c11b655786597 = [
    {
        character: '\t',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: '\t',
        before: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: '\t',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde'
        ]
    },
    {
        character: '\r',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde',
            'codeFencedMetaGraveAccent',
            'codeFencedMetaTilde',
            'destinationLiteral',
            'headingAtx'
        ]
    },
    {
        character: '\n',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde',
            'codeFencedMetaGraveAccent',
            'codeFencedMetaTilde',
            'destinationLiteral',
            'headingAtx'
        ]
    },
    {
        character: ' ',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: ' ',
        before: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    {
        character: ' ',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedLangTilde'
        ]
    },
    // An exclamation mark can start an image, if it is followed by a link or
    // a link reference.
    {
        character: '!',
        after: '\\[',
        inConstruct: 'phrasing',
        notInConstruct: $b031131770a4aa99$var$fullPhrasingSpans
    },
    // A quote can break out of a title.
    {
        character: '"',
        inConstruct: 'titleQuote'
    },
    // A number sign could start an ATX heading if it starts a line.
    {
        atBreak: true,
        character: '#'
    },
    {
        character: '#',
        inConstruct: 'headingAtx',
        after: '(?:[\r\n]|$)'
    },
    // Dollar sign and percentage are not used in markdown.
    // An ampersand could start a character reference.
    {
        character: '&',
        after: '[#A-Za-z]',
        inConstruct: 'phrasing'
    },
    // An apostrophe can break out of a title.
    {
        character: "'",
        inConstruct: 'titleApostrophe'
    },
    // A left paren could break out of a destination raw.
    {
        character: '(',
        inConstruct: 'destinationRaw'
    },
    // A left paren followed by `]` could make something into a link or image.
    {
        before: '\\]',
        character: '(',
        inConstruct: 'phrasing',
        notInConstruct: $b031131770a4aa99$var$fullPhrasingSpans
    },
    // A right paren could start a list item or break out of a destination
    // raw.
    {
        atBreak: true,
        before: '\\d+',
        character: ')'
    },
    {
        character: ')',
        inConstruct: 'destinationRaw'
    },
    // An asterisk can start thematic breaks, list items, emphasis, strong.
    {
        atBreak: true,
        character: '*',
        after: '(?:[ \t\r\n*])'
    },
    {
        character: '*',
        inConstruct: 'phrasing',
        notInConstruct: $b031131770a4aa99$var$fullPhrasingSpans
    },
    // A plus sign could start a list item.
    {
        atBreak: true,
        character: '+',
        after: '(?:[ \t\r\n])'
    },
    // A dash can start thematic breaks, list items, and setext heading
    // underlines.
    {
        atBreak: true,
        character: '-',
        after: '(?:[ \t\r\n-])'
    },
    // A dot could start a list item.
    {
        atBreak: true,
        before: '\\d+',
        character: '.',
        after: '(?:[ \t\r\n]|$)'
    },
    // Slash, colon, and semicolon are not used in markdown for constructs.
    // A less than can start html (flow or text) or an autolink.
    // HTML could start with an exclamation mark (declaration, cdata, comment),
    // slash (closing tag), question mark (instruction), or a letter (tag).
    // An autolink also starts with a letter.
    // Finally, it could break out of a destination literal.
    {
        atBreak: true,
        character: '<',
        after: '[!/?A-Za-z]'
    },
    {
        character: '<',
        after: '[!/?A-Za-z]',
        inConstruct: 'phrasing',
        notInConstruct: $b031131770a4aa99$var$fullPhrasingSpans
    },
    {
        character: '<',
        inConstruct: 'destinationLiteral'
    },
    // An equals to can start setext heading underlines.
    {
        atBreak: true,
        character: '='
    },
    // A greater than can start block quotes and it can break out of a
    // destination literal.
    {
        atBreak: true,
        character: '>'
    },
    {
        character: '>',
        inConstruct: 'destinationLiteral'
    },
    // Question mark and at sign are not used in markdown for constructs.
    // A left bracket can start definitions, references, labels,
    {
        atBreak: true,
        character: '['
    },
    {
        character: '[',
        inConstruct: 'phrasing',
        notInConstruct: $b031131770a4aa99$var$fullPhrasingSpans
    },
    {
        character: '[',
        inConstruct: [
            'label',
            'reference'
        ]
    },
    // A backslash can start an escape (when followed by punctuation) or a
    // hard break (when followed by an eol).
    // Note: typical escapes are handled in `safe`!
    {
        character: '\\',
        after: '[\\r\\n]',
        inConstruct: 'phrasing'
    },
    // A right bracket can exit labels.
    {
        character: ']',
        inConstruct: [
            'label',
            'reference'
        ]
    },
    // Caret is not used in markdown for constructs.
    // An underscore can start emphasis, strong, or a thematic break.
    {
        atBreak: true,
        character: '_'
    },
    {
        character: '_',
        inConstruct: 'phrasing',
        notInConstruct: $b031131770a4aa99$var$fullPhrasingSpans
    },
    // A grave accent can start code (fenced or text), or it can break out of
    // a grave accent code fence.
    {
        atBreak: true,
        character: '`'
    },
    {
        character: '`',
        inConstruct: [
            'codeFencedLangGraveAccent',
            'codeFencedMetaGraveAccent'
        ]
    },
    {
        character: '`',
        inConstruct: 'phrasing',
        notInConstruct: $b031131770a4aa99$var$fullPhrasingSpans
    },
    // Left brace, vertical bar, right brace are not used in markdown for
    // constructs.
    // A tilde can start code (fenced).
    {
        atBreak: true,
        character: '~'
    }
];


/**
 * @import {AssociationId} from '../types.js'
 */ 
/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCodePoint(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $a72b41c19fbe228c$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || /* eslint-disable no-bitwise */ (code & 65535) === 65535 || (code & 65535) === 65534 || /* eslint-enable no-bitwise */ // Out of range
    code > 1114111) return "\uFFFD";
    return String.fromCodePoint(code);
}


const $516ec3b0ba9da2c8$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $516ec3b0ba9da2c8$export$a0fb664af7d0cc44(value) {
    return value.replace($516ec3b0ba9da2c8$var$characterEscapeOrReference, $516ec3b0ba9da2c8$var$decode);
}
/**
 * @param {string} $0
 *   Match.
 * @param {string} $1
 *   Character escape.
 * @param {string} $2
 *   Character reference.
 * @returns {string}
 *   Decoded value
 */ function $516ec3b0ba9da2c8$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $a72b41c19fbe228c$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)($2) || $0;
}


function $cbbebb9a0c6eb64e$export$c4ca1a6065421754(node) {
    if (node.label || !node.identifier) return node.label || '';
    return (0, $516ec3b0ba9da2c8$export$a0fb664af7d0cc44)(node.identifier);
}


/**
 * @import {CompilePattern} from '../types.js'
 */ /**
 * @type {CompilePattern}
 */ function $cd04b192a49dfa5e$export$2db8af076f277cbf(pattern) {
    if (!pattern._compiled) {
        const before = (pattern.atBreak ? '[\\r\\n][\\t ]*' : '') + (pattern.before ? '(?:' + pattern.before + ')' : '');
        pattern._compiled = new RegExp((before ? '(' + before + ')' : '') + (/[|\\{}()[\]^$+*?.-]/.test(pattern.character) ? '\\' : '') + pattern.character + (pattern.after ? '(?:' + pattern.after + ')' : ''), 'g');
    }
    return pattern._compiled;
}


/**
 * @import {Handle, Info, State} from 'mdast-util-to-markdown'
 * @import {PhrasingParents} from '../types.js'
 */ 


function $da0664a15e0ccd9e$export$f4090a9439f37631(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    let before = info.before;
    /** @type {string | undefined} */ let encodeAfter;
    indexStack.push(-1);
    let tracker = state.createTracker(info);
    while(++index < children.length){
        const child = children[index];
        /** @type {string} */ let after;
        indexStack[indexStack.length - 1] = index;
        if (index + 1 < children.length) {
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            let handle = state.handle.handlers[children[index + 1].type];
            /** @type {Handle} */ // @ts-expect-error: hush, it’s actually a `zwitch`.
            if (handle && handle.peek) handle = handle.peek;
            after = handle ? handle(children[index + 1], parent, state, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                before: '',
                after: ''
            }, tracker.current())).charAt(0) : '';
        } else after = info.after;
        // In some cases, html (text) can be found in phrasing right after an eol.
        // When we’d serialize that, in most cases that would be seen as html
        // (flow).
        // As we can’t escape or so to prevent it from happening, we take a somewhat
        // reasonable approach: replace that eol with a space.
        // See: <https://github.com/syntax-tree/mdast-util-to-markdown/issues/15>
        if (results.length > 0 && (before === '\r' || before === '\n') && child.type === 'html') {
            results[results.length - 1] = results[results.length - 1].replace(/(\r?\n|\r)$/, ' ');
            before = ' ';
            // To do: does this work to reset tracker?
            tracker = state.createTracker(info);
            tracker.move(results.join(''));
        }
        let value = state.handle(child, parent, state, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, tracker.current()), {
            after: after,
            before: before
        }));
        // If we had to encode the first character after the previous node and it’s
        // still the same character,
        // encode it.
        if (encodeAfter && encodeAfter === value.slice(0, 1)) value = (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(encodeAfter.charCodeAt(0)) + value.slice(1);
        const encodingInfo = state.attentionEncodeSurroundingInfo;
        state.attentionEncodeSurroundingInfo = undefined;
        encodeAfter = undefined;
        // If we have to encode the first character before the current node and
        // it’s still the same character,
        // encode it.
        if (encodingInfo) {
            if (results.length > 0 && encodingInfo.before && before === results[results.length - 1].slice(-1)) results[results.length - 1] = results[results.length - 1].slice(0, -1) + (0, $ef164935741e67b3$export$5810cf1e579e9d5b)(before.charCodeAt(0));
            if (encodingInfo.after) encodeAfter = after;
        }
        tracker.move(value);
        results.push(value);
        before = value.slice(-1);
    }
    indexStack.pop();
    return results.join('');
}


/**
 * @import {State} from 'mdast-util-to-markdown'
 * @import {FlowChildren, FlowParents, TrackFields} from '../types.js'
 */ /**
 * @param {FlowParents} parent
 *   Parent of flow nodes.
 * @param {State} state
 *   Info passed around about the current state.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ 
function $5df5d51cd1da258d$export$134f7fdacfea8b16(parent, state, info) {
    const indexStack = state.indexStack;
    const children = parent.children || [];
    const tracker = state.createTracker(info);
    /** @type {Array<string>} */ const results = [];
    let index = -1;
    indexStack.push(-1);
    while(++index < children.length){
        const child = children[index];
        indexStack[indexStack.length - 1] = index;
        results.push(tracker.move(state.handle(child, parent, state, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            before: '\n',
            after: '\n'
        }, tracker.current()))));
        if (child.type !== 'list') state.bulletLastUsed = undefined;
        if (index < children.length - 1) results.push(tracker.move($5df5d51cd1da258d$var$between(child, children[index + 1], parent, state)));
    }
    indexStack.pop();
    return results.join('');
}
/**
 * @param {FlowChildren} left
 * @param {FlowChildren} right
 * @param {FlowParents} parent
 * @param {State} state
 * @returns {string}
 */ function $5df5d51cd1da258d$var$between(left, right, parent, state) {
    let index = state.join.length;
    while(index--){
        const result = state.join[index](left, right, parent, state);
        if (result === true || result === 1) break;
        if (typeof result === 'number') return '\n'.repeat(1 + result);
        if (result === false) return '\n\n<!---->\n\n';
    }
    return '\n\n';
}


/**
 * @import {IndentLines} from '../types.js'
 */ const $681845498a1b308f$var$eol = /\r?\n|\r/g;
function $681845498a1b308f$export$7c3cf23d514b264a(value, map) {
    /** @type {Array<string>} */ const result = [];
    let start = 0;
    let line = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = $681845498a1b308f$var$eol.exec(value)){
        one(value.slice(start, match.index));
        result.push(match[0]);
        start = match.index + match[0].length;
        line++;
    }
    one(value.slice(start));
    return result.join('');
    /**
   * @param {string} value
   */ function one(value) {
        result.push(map(value, line, !value));
    }
}


/**
 * @import {SafeConfig, State} from 'mdast-util-to-markdown'
 */ 

function $6459347ca651a5b4$export$170b8c323eee7bec(state, input, config) {
    const value = (config.before || '') + (input || '') + (config.after || '');
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const result = [];
    /** @type {Record<number, {before: boolean, after: boolean}>} */ const infos = {};
    let index = -1;
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        if (!(0, $faa99a565617de42$export$78221a09424368d)(state.stack, pattern)) continue;
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        while(match = expression.exec(value)){
            const before = 'before' in pattern || Boolean(pattern.atBreak);
            const after = 'after' in pattern;
            const position = match.index + (before ? match[1].length : 0);
            if (positions.includes(position)) {
                if (infos[position].before && !before) infos[position].before = false;
                if (infos[position].after && !after) infos[position].after = false;
            } else {
                positions.push(position);
                infos[position] = {
                    before: before,
                    after: after
                };
            }
        }
    }
    positions.sort($6459347ca651a5b4$var$numerical);
    let start = config.before ? config.before.length : 0;
    const end = value.length - (config.after ? config.after.length : 0);
    index = -1;
    while(++index < positions.length){
        const position = positions[index];
        // Character before or after matched:
        if (position < start || position >= end) continue;
        // If this character is supposed to be escaped because it has a condition on
        // the next character, and the next character is definitly being escaped,
        // then skip this escape.
        if (position + 1 < end && positions[index + 1] === position + 1 && infos[position].after && !infos[position + 1].before && !infos[position + 1].after || positions[index - 1] === position - 1 && infos[position].before && !infos[position - 1].before && !infos[position - 1].after) continue;
        if (start !== position) // If we have to use a character reference, an ampersand would be more
        // correct, but as backslashes only care about punctuation, either will
        // do the trick
        result.push($6459347ca651a5b4$var$escapeBackslashes(value.slice(start, position), '\\'));
        start = position;
        if (/[!-/:-@[-`{-~]/.test(value.charAt(position)) && (!config.encode || !config.encode.includes(value.charAt(position)))) // Character escape.
        result.push('\\');
        else {
            // Character reference.
            result.push((0, $ef164935741e67b3$export$5810cf1e579e9d5b)(value.charCodeAt(position)));
            start++;
        }
    }
    result.push($6459347ca651a5b4$var$escapeBackslashes(value.slice(start, end), config.after));
    return result.join('');
}
/**
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */ function $6459347ca651a5b4$var$numerical(a, b) {
    return a - b;
}
/**
 * @param {string} value
 * @param {string} after
 * @returns {string}
 */ function $6459347ca651a5b4$var$escapeBackslashes(value, after) {
    const expression = /\\(?=[!-/:-@[-`{-~])/g;
    /** @type {Array<number>} */ const positions = [];
    /** @type {Array<string>} */ const results = [];
    const whole = value + after;
    let index = -1;
    let start = 0;
    /** @type {RegExpExecArray | null} */ let match;
    while(match = expression.exec(whole))positions.push(match.index);
    while(++index < positions.length){
        if (start !== positions[index]) results.push(value.slice(start, positions[index]));
        results.push('\\');
        start = positions[index];
    }
    results.push(value.slice(start));
    return results.join('');
}


/**
 * @import {CreateTracker, TrackCurrent, TrackMove, TrackShift} from '../types.js'
 */ /**
 * Track positional info in the output.
 *
 * @type {CreateTracker}
 */ function $49e88a44d4bd6cfe$export$6b2a7d5132615086(config) {
    // Defaults are used to prevent crashes when older utilities somehow activate
    // this code.
    /* c8 ignore next 5 */ const options = config || {};
    const now = options.now || {};
    let lineShift = options.lineShift || 0;
    let line = now.line || 1;
    let column = now.column || 1;
    return {
        move: move,
        current: current,
        shift: shift
    };
    /**
   * Get the current tracked info.
   *
   * @type {TrackCurrent}
   */ function current() {
        return {
            now: {
                line: line,
                column: column
            },
            lineShift: lineShift
        };
    }
    /**
   * Define an increased line shift (the typical indent for lines).
   *
   * @type {TrackShift}
   */ function shift(value) {
        lineShift += value;
    }
    /**
   * Move past some generated markdown.
   *
   * @type {TrackMove}
   */ function move(input) {
        // eslint-disable-next-line unicorn/prefer-default-parameters
        const value = input || '';
        const chunks = value.split(/\r?\n|\r/g);
        const tail = chunks[chunks.length - 1];
        line += chunks.length - 1;
        column = chunks.length === 1 ? column + tail.length : 1 + tail.length + lineShift;
        return value;
    }
}


function $3abd4354ed897ab8$export$49a1dda9e62e8ae6(tree, options) {
    const settings = options || {};
    /** @type {State} */ const state = {
        associationId: (0, $cbbebb9a0c6eb64e$export$c4ca1a6065421754),
        containerPhrasing: $3abd4354ed897ab8$var$containerPhrasingBound,
        containerFlow: $3abd4354ed897ab8$var$containerFlowBound,
        createTracker: (0, $49e88a44d4bd6cfe$export$6b2a7d5132615086),
        compilePattern: $cd04b192a49dfa5e$export$2db8af076f277cbf,
        enter: enter,
        // @ts-expect-error: GFM / frontmatter are typed in `mdast` but not defined
        // here.
        handlers: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $da19da82921559d2$export$8f34ce051745d39e)),
        // @ts-expect-error: add `handle` in a second.
        handle: undefined,
        indentLines: $681845498a1b308f$export$7c3cf23d514b264a,
        indexStack: [],
        join: [
            ...(0, $cb5ab2f3e1bff866$export$f7e2c8231c57a8bd)
        ],
        options: {},
        safe: $3abd4354ed897ab8$var$safeBound,
        stack: [],
        unsafe: [
            ...(0, $b031131770a4aa99$export$aa1c11b655786597)
        ]
    };
    (0, $cb7184018dfae342$export$8d21e34596265fa2)(state, settings);
    if (state.options.tightDefinitions) state.join.push($3abd4354ed897ab8$var$joinDefinition);
    state.handle = (0, $17810db8694da3f3$export$d6a12bfbbedf6185)('type', {
        invalid: $3abd4354ed897ab8$var$invalid,
        unknown: $3abd4354ed897ab8$var$unknown,
        handlers: state.handlers
    });
    let result = state.handle(tree, undefined, state, {
        before: '\n',
        after: '\n',
        now: {
            line: 1,
            column: 1
        },
        lineShift: 0
    });
    if (result && result.charCodeAt(result.length - 1) !== 10 && result.charCodeAt(result.length - 1) !== 13) result += '\n';
    return result;
    /** @type {Enter} */ function enter(name) {
        state.stack.push(name);
        return exit;
        /**
     * @returns {undefined}
     */ function exit() {
            state.stack.pop();
        }
    }
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $3abd4354ed897ab8$var$invalid(value) {
    throw new Error('Cannot handle value `' + value + '`, expected node');
}
/**
 * @param {unknown} value
 * @returns {never}
 */ function $3abd4354ed897ab8$var$unknown(value) {
    // Always a node.
    const node = /** @type {Nodes} */ value;
    throw new Error('Cannot handle unknown node `' + node.type + '`');
}
/** @type {Join} */ function $3abd4354ed897ab8$var$joinDefinition(left, right) {
    // No blank line between adjacent definitions.
    if (left.type === 'definition' && left.type === right.type) return 0;
}
/**
 * Serialize the children of a parent that contains phrasing children.
 *
 * These children will be joined flush together.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {PhrasingParents} parent
 *   Parent of flow nodes.
 * @param {Info} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined together.
 */ function $3abd4354ed897ab8$var$containerPhrasingBound(parent, info) {
    return (0, $da0664a15e0ccd9e$export$f4090a9439f37631)(parent, this, info);
}
/**
 * Serialize the children of a parent that contains flow children.
 *
 * These children will typically be joined by blank lines.
 * What they are joined by exactly is defined by `Join` functions.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {FlowParents} parent
 *   Parent of flow nodes.
 * @param {TrackFields} info
 *   Info on where we are in the document we are generating.
 * @returns {string}
 *   Serialized children, joined by (blank) lines.
 */ function $3abd4354ed897ab8$var$containerFlowBound(parent, info) {
    return (0, $5df5d51cd1da258d$export$134f7fdacfea8b16)(parent, this, info);
}
/**
 * Make a string safe for embedding in markdown constructs.
 *
 * In markdown, almost all punctuation characters can, in certain cases,
 * result in something.
 * Whether they do is highly subjective to where they happen and in what
 * they happen.
 *
 * To solve this, `mdast-util-to-markdown` tracks:
 *
 * * Characters before and after something;
 * * What “constructs” we are in.
 *
 * This information is then used by this function to escape or encode
 * special characters.
 *
 * @this {State}
 *   Info passed around about the current state.
 * @param {string | null | undefined} value
 *   Raw value to make safe.
 * @param {SafeConfig} config
 *   Configuration.
 * @returns {string}
 *   Serialized markdown safe for embedding.
 */ function $3abd4354ed897ab8$var$safeBound(value, config) {
    return (0, $6459347ca651a5b4$export$170b8c323eee7bec)(this, value, config);
}


const $4b095f1b731e6368$var$MDX_NODE_TYPES = [
    "mdxJsxTextElement",
    "mdxJsxFlowElement"
];
function $4b095f1b731e6368$export$736fc15d0c902f22(node) {
    return $4b095f1b731e6368$var$MDX_NODE_TYPES.includes(node.type) && $4b095f1b731e6368$export$34f4f5a47a84c7bc.includes(node.name);
}
const $4b095f1b731e6368$export$34f4f5a47a84c7bc = [
    "a",
    "abbr",
    "address",
    "area",
    "article",
    "aside",
    "audio",
    "b",
    "base",
    "bdi",
    "bdo",
    "blockquote",
    "body",
    "br",
    "button",
    "canvas",
    "caption",
    "cite",
    "code",
    "col",
    "colgroup",
    "data",
    "datalist",
    "dd",
    "del",
    "details",
    "dfn",
    "dialog",
    "div",
    "dl",
    "dt",
    "em",
    "embed",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hgroup",
    "hr",
    "html",
    "i",
    "iframe",
    // 'img',
    "input",
    "ins",
    "kbd",
    "label",
    "legend",
    "li",
    "link",
    "main",
    "map",
    "mark",
    "meta",
    "meter",
    "nav",
    "noscript",
    "object",
    "ol",
    "optgroup",
    "option",
    "output",
    "p",
    "param",
    "picture",
    "pre",
    "progress",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "script",
    "section",
    "select",
    "small",
    "source",
    "span",
    "strong",
    "style",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "template",
    "textarea",
    "tfoot",
    "th",
    "thead",
    "time",
    "title",
    "tr",
    "track",
    "u",
    "ul",
    "var",
    "video",
    "wbr"
];



function $41caa3d8767474d7$export$951fccb5529d7b92(style1, style2) {
    const styleObject1 = $41caa3d8767474d7$var$styleToObject(style1);
    const styleObject2 = $41caa3d8767474d7$var$styleToObject(style2);
    const mergedStyleObject = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, styleObject1, styleObject2);
    const mergedStyleString = $41caa3d8767474d7$var$objectToStyle(mergedStyleObject);
    return mergedStyleString;
}
function $41caa3d8767474d7$var$styleToObject(style) {
    const styleObject = {};
    const stylePairs = style.split(";").filter((pair)=>pair.trim() !== "");
    stylePairs.forEach((pair)=>{
        const [key, value] = pair.split(":").map((part)=>part.trim());
        styleObject[key] = value;
    });
    return styleObject;
}
function $41caa3d8767474d7$var$objectToStyle(styleObject) {
    return Object.entries(styleObject).map(([key, value])=>`${key}: ${value}`).join("; ");
}


function $d5a351410f7bf8d8$var$isParent(node) {
    return node.children instanceof Array;
}
function $d5a351410f7bf8d8$export$57051130e393c786({ root: root, visitors: visitors, jsxComponentDescriptors: jsxComponentDescriptors, jsxIsAvailable: jsxIsAvailable, addImportStatements: addImportStatements = true }) {
    let unistRoot = null;
    const referredComponents = /* @__PURE__ */ new Set();
    const knownImportSources = /* @__PURE__ */ new Map();
    visitors = [
        ...visitors
    ].sort((a, b)=>{
        var _b_priority, _a_priority;
        return ((_b_priority = b.priority) !== null && _b_priority !== void 0 ? _b_priority : 0) - ((_a_priority = a.priority) !== null && _a_priority !== void 0 ? _a_priority : 0);
    });
    visit(root, null);
    function registerReferredComponent(componentName, importStatement) {
        referredComponents.add(componentName);
        if (importStatement) knownImportSources.set(componentName, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, importStatement));
    }
    function appendToParent(parentNode, node) {
        if (unistRoot === null) {
            unistRoot = node;
            return unistRoot;
        }
        if (!$d5a351410f7bf8d8$var$isParent(parentNode)) throw new Error("Attempting to append children to a non-parent");
        const siblings = parentNode.children;
        const prevSibling = siblings.at(-1);
        if (prevSibling) {
            const joinVisitor = visitors.find((visitor)=>{
                var _a;
                return (_a = visitor.shouldJoin) == null ? void 0 : _a.call(visitor, prevSibling, node);
            });
            if (joinVisitor) {
                const joinedNode = joinVisitor.join(prevSibling, node);
                siblings.splice(siblings.length - 1, 1, joinedNode);
                return joinedNode;
            }
        }
        siblings.push(node);
        return node;
    }
    function visitChildren(lexicalNode, parentNode) {
        lexicalNode.getChildren().forEach((lexicalChild)=>{
            visit(lexicalChild, parentNode);
        });
    }
    function visit(lexicalNode, mdastParent, usedVisitors = null) {
        var _a;
        const visitor = visitors.find((visitor2, index)=>{
            var _a2;
            if (usedVisitors == null ? void 0 : usedVisitors.has(index)) return false;
            return (_a2 = visitor2.testLexicalNode) == null ? void 0 : _a2.call(visitor2, lexicalNode);
        });
        if (!visitor) throw new Error(`no lexical visitor found for ${lexicalNode.getType()}`, {
            cause: lexicalNode
        });
        (_a = visitor.visitLexicalNode) == null || _a.call(visitor, {
            lexicalNode: lexicalNode,
            mdastParent: mdastParent,
            actions: {
                addAndStepInto (type, props = {}, hasChildren = true) {
                    const newNode = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        type: type
                    }, props, hasChildren ? {
                        children: []
                    } : {});
                    appendToParent(mdastParent, newNode);
                    if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(lexicalNode) && hasChildren) visitChildren(lexicalNode, newNode);
                },
                appendToParent: appendToParent,
                visitChildren: visitChildren,
                visit: visit,
                registerReferredComponent: registerReferredComponent,
                nextVisitor () {
                    visit(lexicalNode, mdastParent, (usedVisitors !== null && usedVisitors !== void 0 ? usedVisitors : /* @__PURE__ */ new Set()).add(visitors.indexOf(visitor)));
                    return;
                }
            }
        });
    }
    if (unistRoot === null) throw new Error("traversal ended with no root element");
    const importsMap = /* @__PURE__ */ new Map();
    const defaultImportsMap = /* @__PURE__ */ new Map();
    for (const componentName of referredComponents){
        var _jsxComponentDescriptors_find, _ref;
        const descriptor = (_ref = (_jsxComponentDescriptors_find = jsxComponentDescriptors.find((descriptor2)=>descriptor2.name === componentName)) !== null && _jsxComponentDescriptors_find !== void 0 ? _jsxComponentDescriptors_find : knownImportSources.get(componentName)) !== null && _ref !== void 0 ? _ref : jsxComponentDescriptors.find((descriptor2)=>descriptor2.name === "*");
        if (!descriptor) throw new Error(`Component ${componentName} is used but not imported`);
        if (!descriptor.source) continue;
        if (descriptor.defaultExport) defaultImportsMap.set(componentName, descriptor.source);
        else {
            const { source: source } = descriptor;
            const existing = importsMap.get(source);
            if (existing) existing.push(componentName);
            else importsMap.set(source, [
                componentName
            ]);
        }
    }
    if (!addImportStatements) {
        for (const [path, names] of importsMap.entries()){
            const cleaned = names.filter((n)=>knownImportSources.has(n));
            if (cleaned.length > 0) importsMap.set(path, cleaned);
            else importsMap.delete(path);
        }
        for (const key of defaultImportsMap.keys())if (!knownImportSources.has(key)) defaultImportsMap.delete(key);
    }
    const imports = Array.from(importsMap).map(([source, componentNames])=>{
        return {
            type: "mdxjsEsm",
            value: `import { ${componentNames.join(", ")} } from '${source}'`
        };
    });
    imports.push(...Array.from(defaultImportsMap).map(([componentName, source])=>{
        return {
            type: "mdxjsEsm",
            value: `import ${componentName} from '${source}'`
        };
    }));
    const typedRoot = unistRoot;
    const frontmatter = typedRoot.children.find((child)=>child.type === "yaml");
    if (frontmatter) typedRoot.children.splice(typedRoot.children.indexOf(frontmatter) + 1, 0, ...imports);
    else typedRoot.children.unshift(...imports);
    $d5a351410f7bf8d8$var$fixWrappingWhitespace(typedRoot, []);
    $d5a351410f7bf8d8$var$collapseNestedHtmlTags(typedRoot);
    if (!jsxIsAvailable) $d5a351410f7bf8d8$var$convertUnderlineJsxToHtml(typedRoot);
    return typedRoot;
}
function $d5a351410f7bf8d8$var$collapseNestedHtmlTags(node) {
    if ("children" in node && node.children.length > 0) {
        if ((0, $4b095f1b731e6368$export$736fc15d0c902f22)(node) && node.children.length === 1) {
            const onlyChild = node.children[0];
            if (onlyChild.type === "mdxJsxTextElement" && onlyChild.name === "span") {
                onlyChild.attributes.forEach((attribute)=>{
                    if (attribute.type === "mdxJsxAttribute") {
                        const parentAttribute = node.attributes.find((attr)=>attr.type === "mdxJsxAttribute" && attr.name === attribute.name);
                        if (parentAttribute) {
                            if (attribute.name === "className") {
                                const mergedClassesSet = /* @__PURE__ */ new Set([
                                    ...parentAttribute.value.split(" "),
                                    ...attribute.value.split(" ")
                                ]);
                                parentAttribute.value = Array.from(mergedClassesSet).join(" ");
                            } else if (attribute.name === "style") parentAttribute.value = (0, $41caa3d8767474d7$export$951fccb5529d7b92)(parentAttribute.value, attribute.value);
                        } else node.attributes.push(attribute);
                    }
                });
                node.children = onlyChild.children;
            }
        }
        node.children.forEach((child)=>{
            $d5a351410f7bf8d8$var$collapseNestedHtmlTags(child);
        });
    }
}
function $d5a351410f7bf8d8$var$convertUnderlineJsxToHtml(node) {
    if (Object.hasOwn(node, "children")) {
        const nodeAsParent = node;
        const newChildren = [];
        nodeAsParent.children.forEach((child)=>{
            if (child.type === "mdxJsxTextElement" && child.name === "u") newChildren.push(...[
                {
                    type: "html",
                    value: "<u>"
                },
                ...child.children,
                {
                    type: "html",
                    value: "</u>"
                }
            ]);
            else {
                newChildren.push(child);
                $d5a351410f7bf8d8$var$convertUnderlineJsxToHtml(child);
            }
        });
        nodeAsParent.children = newChildren;
    }
}
const $d5a351410f7bf8d8$var$TRAILING_WHITESPACE_REGEXP = /\s+$/;
const $d5a351410f7bf8d8$var$LEADING_WHITESPACE_REGEXP = /^\s+/;
function $d5a351410f7bf8d8$var$fixWrappingWhitespace(node, parentChain) {
    if (node.type === "strong" || node.type === "emphasis") {
        const lastChild = node.children.at(-1);
        if ((lastChild == null ? void 0 : lastChild.type) === "text") {
            const trailingWhitespace = $d5a351410f7bf8d8$var$TRAILING_WHITESPACE_REGEXP.exec(lastChild.value);
            if (trailingWhitespace) {
                lastChild.value = lastChild.value.replace($d5a351410f7bf8d8$var$TRAILING_WHITESPACE_REGEXP, "");
                const parent = parentChain.at(-1);
                if (parent) {
                    parent.children.splice(parent.children.indexOf(node) + 1, 0, {
                        type: "text",
                        value: trailingWhitespace[0]
                    });
                    $d5a351410f7bf8d8$var$fixWrappingWhitespace(parent, parentChain.slice(0, -1));
                }
            }
        }
        const firstChild = node.children.at(0);
        if ((firstChild == null ? void 0 : firstChild.type) === "text") {
            const leadingWhitespace = $d5a351410f7bf8d8$var$LEADING_WHITESPACE_REGEXP.exec(firstChild.value);
            if (leadingWhitespace) {
                firstChild.value = firstChild.value.replace($d5a351410f7bf8d8$var$LEADING_WHITESPACE_REGEXP, "");
                const parent = parentChain.at(-1);
                if (parent) {
                    parent.children.splice(parent.children.indexOf(node), 0, {
                        type: "text",
                        value: leadingWhitespace[0]
                    });
                    $d5a351410f7bf8d8$var$fixWrappingWhitespace(parent, parentChain.slice(0, -1));
                }
            }
        }
    }
    if ("children" in node && node.children.length > 0) {
        const nodeAsParent = node;
        nodeAsParent.children.forEach((child)=>{
            $d5a351410f7bf8d8$var$fixWrappingWhitespace(child, [
                ...parentChain,
                nodeAsParent
            ]);
        });
    }
}
function $d5a351410f7bf8d8$export$e9f30850a0a93090({ root: root, toMarkdownOptions: toMarkdownOptions, toMarkdownExtensions: toMarkdownExtensions, visitors: visitors, jsxComponentDescriptors: jsxComponentDescriptors, jsxIsAvailable: jsxIsAvailable }) {
    return (0, $3abd4354ed897ab8$export$49a1dda9e62e8ae6)($d5a351410f7bf8d8$export$57051130e393c786({
        root: root,
        visitors: visitors,
        jsxComponentDescriptors: jsxComponentDescriptors,
        jsxIsAvailable: jsxIsAvailable
    }), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        extensions: toMarkdownExtensions
    }, toMarkdownOptions)) + "\n";
}




/**
 * @import {
 *   Break,
 *   Blockquote,
 *   Code,
 *   Definition,
 *   Emphasis,
 *   Heading,
 *   Html,
 *   Image,
 *   InlineCode,
 *   Link,
 *   ListItem,
 *   List,
 *   Nodes,
 *   Paragraph,
 *   PhrasingContent,
 *   ReferenceType,
 *   Root,
 *   Strong,
 *   Text,
 *   ThematicBreak
 * } from 'mdast'
 * @import {
 *   Encoding,
 *   Event,
 *   Token,
 *   Value
 * } from 'micromark-util-types'
 * @import {Point} from 'unist'
 * @import {
 *   CompileContext,
 *   CompileData,
 *   Config,
 *   Extension,
 *   Handle,
 *   OnEnterError,
 *   Options
 * } from './types.js'
 */ 
/**
 * @import {Encoding, Value} from 'micromark-util-types'
 */ /**
 * @typedef {import('micromark-util-types').Options} Options
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @import {
 *   CompileContext,
 *   CompileData,
 *   CompileOptions,
 *   Compile,
 *   Definition,
 *   Event,
 *   Handle,
 *   HtmlExtension,
 *   LineEnding,
 *   NormalizedHtmlExtension,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ 


/**
 * @import {
 *   Extension,
 *   Handles,
 *   HtmlExtension,
 *   NormalizedExtension
 * } from 'micromark-util-types'
 */ 
const $1c4ab323543eb9b7$var$hasOwnProperty = {}.hasOwnProperty;
function $1c4ab323543eb9b7$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$1c4ab323543eb9b7$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $1c4ab323543eb9b7$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $1c4ab323543eb9b7$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$1c4ab323543eb9b7$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $1c4ab323543eb9b7$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 *   List of constructs to merge into.
 * @param {Array<unknown>} list
 *   List of constructs to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $1c4ab323543eb9b7$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === 'after' ? existing : before).push(list[index]);
    (0, $6d957c9e6a169a49$export$869882364835d202)(existing, 0, 0, before);
}
function $1c4ab323543eb9b7$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$1c4ab323543eb9b7$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 *   Nothing.
 */ function $1c4ab323543eb9b7$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $1c4ab323543eb9b7$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}



const $1730a6ab3d7ab9f0$var$characterReferences = {
    '"': 'quot',
    '&': 'amp',
    '<': 'lt',
    '>': 'gt'
};
function $1730a6ab3d7ab9f0$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   *   Value to replace.
   * @returns {string}
   *   Encoded value.
   */ function replace(value) {
        return '&' + $1730a6ab3d7ab9f0$var$characterReferences[/** @type {keyof typeof characterReferences} */ value] + ';';
    }
}


/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $c580fc709a668807$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, '')// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}




function $b82d09afb4bbc7a9$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $1730a6ab3d7ab9f0$export$c564cdbbe6da493)($b82d09afb4bbc7a9$export$e42a3e39590d28b5(url || ''));
    if (!protocol) return value;
    const colon = value.indexOf(':');
    const questionMark = value.indexOf('?');
    const numberSign = value.indexOf('#');
    const slash = value.indexOf('/');
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return '';
}
function $b82d09afb4bbc7a9$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = '';
        // A correct percent encoded value.
        if (code === 37 && (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "\uFFFD";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = '';
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join('') + value.slice(start);
}


const $76c598c95b20c009$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $76c598c95b20c009$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $76c598c95b20c009$var$protocolSource = /^https?$/i;
function $76c598c95b20c009$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $1c4ab323543eb9b7$export$eaf8c406dfb0a620)([
        defaultHandlers,
        ...settings.htmlExtensions || []
    ]);
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        definitions: definitions,
        tightStack: tightStack
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        buffer: buffer,
        encode: encode,
        getData: getData,
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        raw: raw,
        resume: resume,
        setData: setData,
        tag: tag
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {ReadonlyArray<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) lineEndingStyle = /** @type {LineEnding} */ events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === 'enter') listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === 'enter') {
                    body = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(head, body);
        head = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($76c598c95b20c009$var$hasOwnProperty.call(handles, kind) && handle) handle.call((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                sliceSerialize: result[index][2].sliceSerialize
            }, context), result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join('');
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {ReadonlyArray<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0; // Skip open.
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === 'enter') containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === 'exit') atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter' && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join('');
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData('lastWasTag', true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData('lastWasTag');
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || '\n');
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData('ignoreEncode') ? value : (0, $1730a6ab3d7ab9f0$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ol');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag('<ul');
        setData('expectFirstItem', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData('expectFirstItem')) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData('expectFirstItem')) tag('>');
        else onexitlistitem();
        lineEndingIfNeeded();
        tag('<li>');
        setData('expectFirstItem');
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData('lastWasTag');
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ol>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag('</ul>');
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData('lastWasTag') && !getData('slurpAllLineEndings')) lineEndingIfNeeded();
        tag('</li>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag('<blockquote>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag('</blockquote>');
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag('<p>');
        }
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData('slurpAllLineEndings', true);
        else tag('</p>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag('<pre><code');
        setData('fencesCount', 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData('fencesCount') || 0;
        if (!count) {
            tag('>');
            setData('slurpOneLineEnding', true);
        }
        setData('fencesCount', count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag('<pre><code>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData('fencesCount');
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData('lastWasTag')) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData('flowCodeSeenData')) lineEndingIfNeeded();
        tag('</code></pre>');
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData('flowCodeSeenData');
        setData('fencesCount');
        setData('slurpOneLineEnding');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined; // Disallow tags.
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer(); // We can have line endings in the resource, ignore them.
        mediaStack[mediaStack.length - 1].destination = '';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1; // Skip current.
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $c580fc709a668807$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $76c598c95b20c009$var$protocolSource) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $76c598c95b20c009$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : '');
        if (media.image) tag(' />');
        else {
            tag('>');
            raw(media.label);
            tag('</a>');
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData('ignoreEncode', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData('ignoreEncode');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $c580fc709a668807$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$76c598c95b20c009$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData('headingRank')) return;
        setData('headingRank', this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData('slurpAllLineEndings');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData('slurpAllLineEndings', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag('</h' + getData('headingRank') + '>');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData('headingRank', this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag('<h' + getData('headingRank') + '>');
        raw(value);
        tag('</h' + getData('headingRank') + '>');
        setData('slurpAllLineEndings');
        setData('headingRank');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData('slurpAllLineEndings')) return;
        if (getData('slurpOneLineEnding')) {
            setData('slurpOneLineEnding');
            return;
        }
        if (getData('inCodeText')) {
            raw(' ');
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData('flowCodeSeenData', true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag('<br />');
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData('ignoreEncode');
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData('ignoreEncode', true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag('<em>');
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag('<strong>');
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData('inCodeText', true);
        tag('<code>');
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData('inCodeText');
        tag('</code>');
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag('</em>');
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag('</strong>');
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag('<hr />');
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData('characterReferenceType', token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const value = this.sliceSerialize(token);
        const decoded = getData('characterReferenceType') ? (0, $a72b41c19fbe228c$export$15a69557afac2c20)(value, getData('characterReferenceType') === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(value);
        // `decodeNamedCharacterReference` can return `false` for invalid named
        // character references,
        // but everything we’ve tokenized is valid.
        raw(encode(/** @type {string} */ decoded));
        setData('characterReferenceType');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $76c598c95b20c009$var$protocolHref) + '">');
        raw(encode(uri));
        tag('</a>');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $b82d09afb4bbc7a9$export$d130a2d684099e5a)('mailto:' + uri) + '">');
        raw(encode(uri));
        tag('</a>');
    }
}


/**
 * @import {
 *   Create,
 *   FullNormalizedExtension,
 *   InitialConstruct,
 *   ParseContext,
 *   ParseOptions
 * } from 'micromark-util-types'
 */ 
/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ 

const $145b6cb5bda265c1$export$a7db06668cad9adb = {
    tokenize: $145b6cb5bda265c1$var$initializeContent
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Initializer}
 *   Content.
 */ function $145b6cb5bda265c1$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @import {
 *   Construct,
 *   ContainerState,
 *   InitialConstruct,
 *   Initializer,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 *   Construct and its state.
 */ 



const $3d8796971204dffa$export$5a7bfc01df82fcd1 = {
    tokenize: $3d8796971204dffa$var$initializeDocument
};
/** @type {Construct} */ const $3d8796971204dffa$var$containerConstruct = {
    tokenize: $3d8796971204dffa$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $3d8796971204dffa$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $6d957c9e6a169a49$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($3d8796971204dffa$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($3d8796971204dffa$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            _tokenizer: childFlow,
            contentType: "flow",
            previous: childToken
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   *   Token.
   * @param {boolean | undefined} [endOfFile]
   *   Whether the token is at the end of the file (default: `false`).
   * @returns {undefined}
   *   Nothing.
   */ function writeToChild(token, endOfFile) {
        const stream = self.sliceStream(token);
        if (endOfFile) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === 'exit' && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $6d957c9e6a169a49$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   *   Size.
   * @returns {undefined}
   *   Nothing.
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 *   Tokenizer.
 */ function $3d8796971204dffa$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4);
}


/**
 * @import {
 *   InitialConstruct,
 *   Initializer,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ /**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $30b85425f5f538a1$export$d50d28ce3ab2a612 = {
    partial: true,
    tokenize: $30b85425f5f538a1$var$tokenizeBlankLine
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $30b85425f5f538a1$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 

/**
 * @import {Chunk, Event, Token} from 'micromark-util-types'
 */ 

/**
 * Some of the internal operations of micromark do lots of editing
 * operations on very large arrays. This runs into problems with two
 * properties of most circa-2020 JavaScript interpreters:
 *
 *  - Array-length modifications at the high end of an array (push/pop) are
 *    expected to be common and are implemented in (amortized) time
 *    proportional to the number of elements added or removed, whereas
 *    other operations (shift/unshift and splice) are much less efficient.
 *  - Function arguments are passed on the stack, so adding tens of thousands
 *    of elements to an array with `arr.push(...newElements)` will frequently
 *    cause stack overflows. (see <https://stackoverflow.com/questions/22123769/rangeerror-maximum-call-stack-size-exceeded-why>)
 *
 * SpliceBuffers are an implementation of gap buffers, which are a
 * generalization of the "queue made of two stacks" idea. The splice buffer
 * maintains a cursor, and moving the cursor has cost proportional to the
 * distance the cursor moves, but inserting, deleting, or splicing in
 * new information at the cursor is as efficient as the push/pop operation.
 * This allows for an efficient sequence of splices (or pushes, pops, shifts,
 * or unshifts) as long such edits happen at the same part of the array or
 * generally sweep through the array from the beginning to the end.
 *
 * The interface for splice buffers also supports large numbers of inputs by
 * passing a single array argument rather passing multiple arguments on the
 * function call stack.
 *
 * @template T
 *   Item type.
 */ class $151e2065d6a4ba72$export$bd596157370df26e {
    /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */ get(index) {
        if (index < 0 || index >= this.left.length + this.right.length) throw new RangeError('Cannot access index `' + index + '` in a splice buffer of size `' + (this.left.length + this.right.length) + '`');
        if (index < this.left.length) return this.left[index];
        return this.right[this.right.length - index + this.left.length - 1];
    }
    /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */ get length() {
        return this.left.length + this.right.length;
    }
    /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ shift() {
        this.setCursor(0);
        return this.right.pop();
    }
    /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */ slice(start, end) {
        /** @type {number} */ const stop = end === null || end === undefined ? Number.POSITIVE_INFINITY : end;
        if (stop < this.left.length) return this.left.slice(start, stop);
        if (start > this.left.length) return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
        return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
    }
    /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */ splice(start, deleteCount, items) {
        /** @type {number} */ const count = deleteCount || 0;
        this.setCursor(Math.trunc(start));
        const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
        if (items) $151e2065d6a4ba72$var$chunkedPush(this.left, items);
        return removed.reverse();
    }
    /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */ pop() {
        this.setCursor(Number.POSITIVE_INFINITY);
        return this.left.pop();
    }
    /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ push(item) {
        this.setCursor(Number.POSITIVE_INFINITY);
        this.left.push(item);
    }
    /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ pushMany(items) {
        this.setCursor(Number.POSITIVE_INFINITY);
        $151e2065d6a4ba72$var$chunkedPush(this.left, items);
    }
    /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */ unshift(item) {
        this.setCursor(0);
        this.right.push(item);
    }
    /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */ unshiftMany(items) {
        this.setCursor(0);
        $151e2065d6a4ba72$var$chunkedPush(this.right, items.reverse());
    }
    /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */ setCursor(n) {
        if (n === this.left.length || n > this.left.length && this.right.length === 0 || n < 0 && this.left.length === 0) return;
        if (n < this.left.length) {
            // Move cursor to the this.left
            const removed = this.left.splice(n, Number.POSITIVE_INFINITY);
            $151e2065d6a4ba72$var$chunkedPush(this.right, removed.reverse());
        } else {
            // Move cursor to the this.right
            const removed = this.right.splice(this.left.length + this.right.length - n, Number.POSITIVE_INFINITY);
            $151e2065d6a4ba72$var$chunkedPush(this.left, removed.reverse());
        }
    }
    /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */ constructor(initial){
        /** @type {Array<T>} */ this.left = initial ? [
            ...initial
        ] : [];
        /** @type {Array<T>} */ this.right = [];
    }
}
/**
 * Avoid stack overflow by pushing items onto the stack in segments
 *
 * @template T
 *   Item type.
 * @param {Array<T>} list
 *   List to inject into.
 * @param {ReadonlyArray<T>} right
 *   Items to inject.
 * @return {undefined}
 *   Nothing.
 */ function $151e2065d6a4ba72$var$chunkedPush(list, right) {
    /** @type {number} */ let chunkStart = 0;
    if (right.length < 10000) list.push(...right);
    else while(chunkStart < right.length){
        list.push(...right.slice(chunkStart, chunkStart + 10000));
        chunkStart += 10000;
    }
}


function $7901602e44e77495$export$12949d1dd00fddf4(eventsArray) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    const events = new (0, $151e2065d6a4ba72$export$bd596157370df26e)(eventsArray);
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events.get(index);
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events.get(index - 1)[1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === 'enter') {
            if (event[1].contentType) {
                Object.assign(jumps, $7901602e44e77495$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events.get(otherIndex);
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === 'enter') {
                        if (lineIndex) events.get(lineIndex)[1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
                else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events.get(lineIndex)[1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                events.splice(lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    // The changes to the `events` buffer must be copied back into the eventsArray
    (0, $6d957c9e6a169a49$export$869882364835d202)(eventsArray, 0, Number.POSITIVE_INFINITY, events.slice(0));
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {SpliceBuffer<Event>} events
 *   Events.
 * @param {number} eventIndex
 *   Index.
 * @returns {Record<string, number>}
 *   Gaps.
 */ function $7901602e44e77495$var$subcontent(events, eventIndex) {
    const token = events.get(eventIndex)[1];
    const context = events.get(eventIndex)[2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    let tokenizer = token._tokenizer;
    if (!tokenizer) {
        tokenizer = context.parser[token.contentType](token.start);
        if (token._contentTypeTextTrailing) tokenizer._contentTypeTextTrailing = true;
    }
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events.get(++startPosition)[1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === 'exit' && childEvents[index - 1][0] === 'enter' && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.push([
            start,
            start + slice.length - 1
        ]);
        events.splice(start, 2, slice);
    }
    jumps.reverse();
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $728ee34a4e233cee$export$a7db06668cad9adb = {
    resolve: $728ee34a4e233cee$var$resolveContent,
    tokenize: $728ee34a4e233cee$var$tokenizeContent
};
/** @type {Construct} */ const $728ee34a4e233cee$var$continuationConstruct = {
    partial: true,
    tokenize: $728ee34a4e233cee$var$tokenizeContinuation
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $728ee34a4e233cee$var$resolveContent(events) {
    (0, $7901602e44e77495$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $728ee34a4e233cee$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.check($728ee34a4e233cee$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $728ee34a4e233cee$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes('codeIndented') && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $4320be06d95fd4d0$export$ccc7b0636abaffc3 = {
    tokenize: $4320be06d95fd4d0$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 *   Self.
 * @type {Initializer}
 *   Initializer.
 */ function $4320be06d95fd4d0$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $30b85425f5f538a1$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $728ee34a4e233cee$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @import {
 *   Code,
 *   InitialConstruct,
 *   Initializer,
 *   Resolver,
 *   State,
 *   TokenizeContext
 * } from 'micromark-util-types'
 */ 
const $009f2a13a0d178f2$export$50397835cbfdbc24 = {
    resolveAll: $009f2a13a0d178f2$var$createResolver()
};
const $009f2a13a0d178f2$export$22b082955e083ec3 = $009f2a13a0d178f2$var$initializeFactory('string');
const $009f2a13a0d178f2$export$6f093cfa640b7166 = $009f2a13a0d178f2$var$initializeFactory('text');
/**
 * @param {'string' | 'text'} field
 *   Field.
 * @returns {InitialConstruct}
 *   Construct.
 */ function $009f2a13a0d178f2$var$initializeFactory(field) {
    return {
        resolveAll: $009f2a13a0d178f2$var$createResolver(field === 'text' ? $009f2a13a0d178f2$var$resolveAllLineSuffixes : undefined),
        tokenize: initializeText
    };
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     *   Code.
     * @returns {boolean}
     *   Whether the code is a break.
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 *   Resolver.
 * @returns {Resolver}
 *   Resolver.
 */ function $009f2a13a0d178f2$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $009f2a13a0d178f2$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0; // Skip first.
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === 'string') {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        // Allow final trailing whitespace.
        if (context._contentTypeTextTrailing && eventIndex === events.length) size = 0;
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex,
                    _index: data.start._index + index,
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size
                },
                end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data.end)
            };
            data.end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    'enter',
                    token,
                    context
                ], [
                    'exit',
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


var $f81d41200564ef26$exports = {};

$parcel$export($f81d41200564ef26$exports, "document", function () { return $f81d41200564ef26$export$5a7bfc01df82fcd1; });
$parcel$export($f81d41200564ef26$exports, "contentInitial", function () { return $f81d41200564ef26$export$5a2181fb44b58173; });
$parcel$export($f81d41200564ef26$exports, "flowInitial", function () { return $f81d41200564ef26$export$cf8bead395eff824; });
$parcel$export($f81d41200564ef26$exports, "flow", function () { return $f81d41200564ef26$export$ccc7b0636abaffc3; });
$parcel$export($f81d41200564ef26$exports, "string", function () { return $f81d41200564ef26$export$22b082955e083ec3; });
$parcel$export($f81d41200564ef26$exports, "text", function () { return $f81d41200564ef26$export$6f093cfa640b7166; });
$parcel$export($f81d41200564ef26$exports, "insideSpan", function () { return $f81d41200564ef26$export$d44f260a3f9b69f5; });
$parcel$export($f81d41200564ef26$exports, "attentionMarkers", function () { return $f81d41200564ef26$export$b9c0b60d74426aea; });
$parcel$export($f81d41200564ef26$exports, "disable", function () { return $f81d41200564ef26$export$e20fbacbb41798b; });
/**
 * @import {Extension} from 'micromark-util-types'
 */ /**
 * @import {
 *   Code,
 *   Construct,
 *   Event,
 *   Point,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 



const $ea09a4790e991212$export$45b92471da762af7 = {
    name: 'attention',
    resolveAll: $ea09a4790e991212$var$resolveAllAttention,
    tokenize: $ea09a4790e991212$var$tokenizeAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $ea09a4790e991212$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === 'enter' && events[index][1].type === 'attentionSequence' && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === 'exit' && events[open][1].type === 'attentionSequence' && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open][1].end);
            const end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[index][1].start);
            $ea09a4790e991212$var$movePoint(start, -use);
            $ea09a4790e991212$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open][1].end),
                end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, openingSequence.start),
                end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, closingSequence.end)
            };
            events[open][1].end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, openingSequence.start);
            events[index][1].start = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    events[open][1],
                    context
                ],
                [
                    'exit',
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    'enter',
                    group,
                    context
                ],
                [
                    'enter',
                    openingSequence,
                    context
                ],
                [
                    'exit',
                    openingSequence,
                    context
                ],
                [
                    'enter',
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                [
                    'exit',
                    text,
                    context
                ],
                [
                    'enter',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    closingSequence,
                    context
                ],
                [
                    'exit',
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(nextEvents, [
                    [
                        'enter',
                        events[index][1],
                        context
                    ],
                    [
                        'exit',
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $6d957c9e6a169a49$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === 'attentionSequence') events[index][1].type = 'data';
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $ea09a4790e991212$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter('attentionSequence');
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit('attentionSequence');
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $cae7fc7dfc0e8dc7$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 *   Point.
 * @param {number} offset
 *   Amount to move.
 * @returns {undefined}
 *   Nothing.
 */ function $ea09a4790e991212$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $5d74961dcf69642f$export$17ddf85e4c916ad6 = {
    name: 'autolink',
    tokenize: $5d74961dcf69642f$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5d74961dcf69642f$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        if (code === 64) return nok(code);
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $9a96cd0c036af4eb$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $5b7191973b2dcb30$export$200dcd0a5903c968 = {
    continuation: {
        tokenize: $5b7191973b2dcb30$var$tokenizeBlockQuoteContinuation
    },
    exit: $5b7191973b2dcb30$var$exit,
    name: 'blockQuote',
    tokenize: $5b7191973b2dcb30$var$tokenizeBlockQuoteStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5b7191973b2dcb30$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $5b7191973b2dcb30$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($5b7191973b2dcb30$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $5b7191973b2dcb30$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $be85b25963329d93$export$2005478564e78d96 = {
    name: 'characterEscape',
    tokenize: $be85b25963329d93$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $be85b25963329d93$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $9a96cd0c036af4eb$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $3f5b13d75c9b46b1$export$e31905600aaf3d8e = {
    name: 'characterReference',
    tokenize: $3f5b13d75c9b46b1$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3f5b13d75c9b46b1$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $9a96cd0c036af4eb$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $9a96cd0c036af4eb$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $9a96cd0c036af4eb$export$75c76db11865a9f4) && !(0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

/** @type {Construct} */ const $834069fabf19784a$var$nonLazyContinuation = {
    partial: true,
    tokenize: $834069fabf19784a$var$tokenizeNonLazyContinuation
};
const $834069fabf19784a$export$c23e4921f8d87e7c = {
    concrete: true,
    name: 'codeFenced',
    tokenize: $834069fabf19784a$var$tokenizeCodeFenced
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $834069fabf19784a$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        partial: true,
        tokenize: tokenizeCloseStart
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($834069fabf19784a$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.check($834069fabf19784a$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   *   Context.
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $834069fabf19784a$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $7dbe9fe18b3b23b2$export$47910b7ab28d1853 = {
    name: 'codeIndented',
    tokenize: $7dbe9fe18b3b23b2$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $7dbe9fe18b3b23b2$var$furtherStart = {
    partial: true,
    tokenize: $7dbe9fe18b3b23b2$var$tokenizeFurtherStart
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7dbe9fe18b3b23b2$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return effects.attempt($7dbe9fe18b3b23b2$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $7dbe9fe18b3b23b2$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Previous,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 
const $23d5e8c756b561fa$export$d24f93e715f9df88 = {
    name: 'codeText',
    previous: $23d5e8c756b561fa$var$previous,
    resolve: $23d5e8c756b561fa$var$resolveCodeText,
    tokenize: $23d5e8c756b561fa$var$tokenizeCodeText
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $23d5e8c756b561fa$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === 'space') && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === 'space')) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Previous}
 */ function $23d5e8c756b561fa$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $23d5e8c756b561fa$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter('space');
            effects.consume(code);
            effects.exit('space');
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ /**
 * @import {Effects, State, TokenType} from 'micromark-util-types'
 */ 
function $a5b0165eceaa5b2a$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $9a96cd0c036af4eb$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @import {
 *   Effects,
 *   State,
 *   TokenizeContext,
 *   TokenType
 * } from 'micromark-util-types'
 */ 
function $5b1b1349c9302e3d$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && '_hiddenFootnoteSupport' in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @import {
 *   Code,
 *   Effects,
 *   State,
 *   TokenType
 * } from 'micromark-util-types'
 */ 

function $3b751ecfea53c49c$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @import {Effects, State} from 'micromark-util-types'
 */ 

function $65f43375f77b595c$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $03db4060f53ac021$export$69f215ed977cdb73 = {
    name: 'definition',
    tokenize: $03db4060f53ac021$var$tokenizeDefinition
};
/** @type {Construct} */ const $03db4060f53ac021$var$titleBefore = {
    partial: true,
    tokenize: $03db4060f53ac021$var$tokenizeTitleBefore
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $03db4060f53ac021$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $5b1b1349c9302e3d$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $a5b0165eceaa5b2a$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($03db4060f53ac021$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $03db4060f53ac021$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $3b751ecfea53c49c$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $2db70170e88ebee0$export$86c573ab9e06f418 = {
    name: 'hardBreakEscape',
    tokenize: $2db70170e88ebee0$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2db70170e88ebee0$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 


const $83113747934b3ae6$export$3871e9deb360695c = {
    name: 'headingAtx',
    resolve: $83113747934b3ae6$var$resolveHeadingAtx,
    tokenize: $83113747934b3ae6$var$tokenizeHeadingAtx
};
/** @type {Resolver} */ function $83113747934b3ae6$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $6d957c9e6a169a49$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                'enter',
                content,
                context
            ],
            [
                'enter',
                text,
                context
            ],
            [
                'exit',
                text,
                context
            ],
            [
                'exit',
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $83113747934b3ae6$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $b9e56abd53b703db$export$7364aee1c59d1879 = [
    'address',
    'article',
    'aside',
    'base',
    'basefont',
    'blockquote',
    'body',
    'caption',
    'center',
    'col',
    'colgroup',
    'dd',
    'details',
    'dialog',
    'dir',
    'div',
    'dl',
    'dt',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'frame',
    'frameset',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hr',
    'html',
    'iframe',
    'legend',
    'li',
    'link',
    'main',
    'menu',
    'menuitem',
    'nav',
    'noframes',
    'ol',
    'optgroup',
    'option',
    'p',
    'param',
    'search',
    'section',
    'summary',
    'table',
    'tbody',
    'td',
    'tfoot',
    'th',
    'thead',
    'title',
    'tr',
    'track',
    'ul'
];
const $b9e56abd53b703db$export$948e66da505d080 = [
    'pre',
    'script',
    'style',
    'textarea'
];



const $bc2cbab316b16c92$export$476ac411cb7d0d8f = {
    concrete: true,
    name: 'htmlFlow',
    resolveTo: $bc2cbab316b16c92$var$resolveToHtmlFlow,
    tokenize: $bc2cbab316b16c92$var$tokenizeHtmlFlow
};
/** @type {Construct} */ const $bc2cbab316b16c92$var$blankLineBefore = {
    partial: true,
    tokenize: $bc2cbab316b16c92$var$tokenizeBlankLineBefore
};
const $bc2cbab316b16c92$var$nonLazyContinuationStart = {
    partial: true,
    tokenize: $bc2cbab316b16c92$var$tokenizeNonLazyContinuationStart
};
/** @type {Resolver} */ function $bc2cbab316b16c92$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === 'enter' && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            // Always the case.
            effects.consume(code);
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $b9e56abd53b703db$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $b9e56abd53b703db$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($bc2cbab316b16c92$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($bc2cbab316b16c92$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = '';
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $b9e56abd53b703db$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            // Always the case.
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $bc2cbab316b16c92$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $d4159befe711bc18$export$398af27f284914fe = {
    name: 'htmlText',
    tokenize: $d4159befe711bc18$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $d4159befe711bc18$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $9a96cd0c036af4eb$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @import {
 *   Construct,
 *   Event,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer,
 *   Token
 * } from 'micromark-util-types'
 */ 








const $2761660aaca3721f$export$470a5dafbbf62654 = {
    name: 'labelEnd',
    resolveAll: $2761660aaca3721f$var$resolveAllLabelEnd,
    resolveTo: $2761660aaca3721f$var$resolveToLabelEnd,
    tokenize: $2761660aaca3721f$var$tokenizeLabelEnd
};
/** @type {Construct} */ const $2761660aaca3721f$var$resourceConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeResource
};
/** @type {Construct} */ const $2761660aaca3721f$var$referenceFullConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $2761660aaca3721f$var$referenceCollapsedConstruct = {
    tokenize: $2761660aaca3721f$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $2761660aaca3721f$var$resolveAllLabelEnd(events) {
    let index = -1;
    /** @type {Array<Event>} */ const newEvents = [];
    while(++index < events.length){
        const token = events[index][1];
        newEvents.push(events[index]);
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            const offset = token.type === "labelImage" ? 4 : 2;
            token.type = "data";
            index += offset;
        }
    }
    // If the events are equal, we don't have to copy newEvents to events
    if (events.length !== newEvents.length) (0, $6d957c9e6a169a49$export$869882364835d202)(events, 0, events.length, newEvents);
    return events;
}
/** @type {Resolver} */ function $2761660aaca3721f$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === 'enter' && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === 'enter' && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open][1].start),
        end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open][1].start),
        end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[open + offset + 2][1].end),
        end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[close - 2][1].start)
    };
    media = [
        [
            'enter',
            group,
            context
        ],
        [
            'enter',
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            'enter',
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            'exit',
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            'exit',
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(media, [
        [
            'exit',
            group,
            context
        ]
    ]);
    (0, $6d957c9e6a169a49$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($2761660aaca3721f$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($2761660aaca3721f$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($2761660aaca3721f$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $a5b0165eceaa5b2a$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $3b751ecfea53c49c$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code) ? (0, $65f43375f77b595c$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $5b1b1349c9302e3d$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $c580fc709a668807$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $2761660aaca3721f$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $39595bc63cd49799$export$3d754936e25aa5f5 = {
    name: 'labelStartImage',
    resolveAll: (0, $2761660aaca3721f$export$470a5dafbbf62654).resolveAll,
    tokenize: $39595bc63cd49799$var$tokenizeLabelStartImage
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $39595bc63cd49799$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 
const $036fa9de6a4e2994$export$5c0cee0701a3b584 = {
    name: 'labelStartLink',
    resolveAll: (0, $2761660aaca3721f$export$470a5dafbbf62654).resolveAll,
    tokenize: $036fa9de6a4e2994$var$tokenizeLabelStartLink
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $036fa9de6a4e2994$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && '_hiddenFootnoteSupport' in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @import {
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $309179153cfedf16$export$8e62e0ad51c97b2 = {
    name: 'lineEnding',
    tokenize: $309179153cfedf16$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $309179153cfedf16$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Exiter,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


/**
 * @import {
 *   Code,
 *   Construct,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 

const $e46429feccf3186d$export$ba7b13e047416c03 = {
    name: 'thematicBreak',
    tokenize: $e46429feccf3186d$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $e46429feccf3186d$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $3c31a37b3e3d082a$export$8837f4fc672e936d = {
    continuation: {
        tokenize: $3c31a37b3e3d082a$var$tokenizeListContinuation
    },
    exit: $3c31a37b3e3d082a$var$tokenizeListEnd,
    name: 'list',
    tokenize: $3c31a37b3e3d082a$var$tokenizeListStart
};
/** @type {Construct} */ const $3c31a37b3e3d082a$var$listItemPrefixWhitespaceConstruct = {
    partial: true,
    tokenize: $3c31a37b3e3d082a$var$tokenizeListItemPrefixWhitespace
};
/** @type {Construct} */ const $3c31a37b3e3d082a$var$indentConstruct = {
    partial: true,
    tokenize: $3c31a37b3e3d082a$var$tokenizeIndent
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $e46429feccf3186d$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $9a96cd0c036af4eb$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($3c31a37b3e3d082a$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $30b85425f5f538a1$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($3c31a37b3e3d082a$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, effects.attempt($3c31a37b3e3d082a$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Exiter}
 */ function $3c31a37b3e3d082a$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $3c31a37b3e3d082a$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @import {
 *   Code,
 *   Construct,
 *   Resolver,
 *   State,
 *   TokenizeContext,
 *   Tokenizer
 * } from 'micromark-util-types'
 */ 


const $151c8a7318d441a4$export$e104e2de391dfde9 = {
    name: 'setextUnderline',
    resolveTo: $151c8a7318d441a4$var$resolveToSetextUnderline,
    tokenize: $151c8a7318d441a4$var$tokenizeSetextUnderline
};
/** @type {Resolver} */ function $151c8a7318d441a4$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === 'enter') {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[content][1].start),
        end: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            'enter',
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            'exit',
            events[content][1],
            context
        ]);
        events[content][1].end = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        'exit',
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 *   Context.
 * @type {Tokenizer}
 */ function $151c8a7318d441a4$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code) ? (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $f81d41200564ef26$export$5a7bfc01df82fcd1 = {
    [42]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [43]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [45]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [48]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [49]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [50]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [51]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [52]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [53]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [54]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [55]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [56]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [57]: (0, $3c31a37b3e3d082a$export$8837f4fc672e936d),
    [62]: (0, $5b7191973b2dcb30$export$200dcd0a5903c968)
};
const $f81d41200564ef26$export$5a2181fb44b58173 = {
    [91]: (0, $03db4060f53ac021$export$69f215ed977cdb73)
};
const $f81d41200564ef26$export$cf8bead395eff824 = {
    [-2]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853),
    [-1]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853),
    [32]: (0, $7dbe9fe18b3b23b2$export$47910b7ab28d1853)
};
const $f81d41200564ef26$export$ccc7b0636abaffc3 = {
    [35]: (0, $83113747934b3ae6$export$3871e9deb360695c),
    [42]: (0, $e46429feccf3186d$export$ba7b13e047416c03),
    [45]: [
        (0, $151c8a7318d441a4$export$e104e2de391dfde9),
        (0, $e46429feccf3186d$export$ba7b13e047416c03)
    ],
    [60]: (0, $bc2cbab316b16c92$export$476ac411cb7d0d8f),
    [61]: (0, $151c8a7318d441a4$export$e104e2de391dfde9),
    [95]: (0, $e46429feccf3186d$export$ba7b13e047416c03),
    [96]: (0, $834069fabf19784a$export$c23e4921f8d87e7c),
    [126]: (0, $834069fabf19784a$export$c23e4921f8d87e7c)
};
const $f81d41200564ef26$export$22b082955e083ec3 = {
    [38]: (0, $3f5b13d75c9b46b1$export$e31905600aaf3d8e),
    [92]: (0, $be85b25963329d93$export$2005478564e78d96)
};
const $f81d41200564ef26$export$6f093cfa640b7166 = {
    [-5]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [-4]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [-3]: (0, $309179153cfedf16$export$8e62e0ad51c97b2),
    [33]: (0, $39595bc63cd49799$export$3d754936e25aa5f5),
    [38]: (0, $3f5b13d75c9b46b1$export$e31905600aaf3d8e),
    [42]: (0, $ea09a4790e991212$export$45b92471da762af7),
    [60]: [
        (0, $5d74961dcf69642f$export$17ddf85e4c916ad6),
        (0, $d4159befe711bc18$export$398af27f284914fe)
    ],
    [91]: (0, $036fa9de6a4e2994$export$5c0cee0701a3b584),
    [92]: [
        (0, $2db70170e88ebee0$export$86c573ab9e06f418),
        (0, $be85b25963329d93$export$2005478564e78d96)
    ],
    [93]: (0, $2761660aaca3721f$export$470a5dafbbf62654),
    [95]: (0, $ea09a4790e991212$export$45b92471da762af7),
    [96]: (0, $23d5e8c756b561fa$export$d24f93e715f9df88)
};
const $f81d41200564ef26$export$d44f260a3f9b69f5 = {
    null: [
        (0, $ea09a4790e991212$export$45b92471da762af7),
        (0, $009f2a13a0d178f2$export$50397835cbfdbc24)
    ]
};
const $f81d41200564ef26$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $f81d41200564ef26$export$e20fbacbb41798b = {
    null: []
};


/**
 * @import {
 *   Chunk,
 *   Code,
 *   ConstructRecord,
 *   Construct,
 *   Effects,
 *   InitialConstruct,
 *   ParseContext,
 *   Point,
 *   State,
 *   TokenizeContext,
 *   Token
 * } from 'micromark-util-types'
 */ /**
 * @callback Restore
 *   Restore the state.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef Info
 *   Info.
 * @property {Restore} restore
 *   Restore.
 * @property {number} from
 *   From.
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 *   Construct.
 * @param {Info} info
 *   Info.
 * @returns {undefined}
 *   Nothing.
 */ 


function $e090088a8e1afd2b$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = {
        _bufferIndex: -1,
        _index: 0,
        line: from && from.line || 1,
        column: from && from.column || 1,
        offset: from && from.offset || 0
    };
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        consume: consume,
        enter: enter,
        exit: exit,
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        code: null,
        containerState: {},
        defineSkip: defineSkip,
        events: [],
        now: now,
        parser: parser,
        previous: null,
        sliceSerialize: sliceSerialize,
        sliceStream: sliceStream,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $6d957c9e6a169a49$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $a0bda62677f8e9a6$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $e090088a8e1afd2b$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $e090088a8e1afd2b$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { _bufferIndex: _bufferIndex, _index: _index, line: line, column: column, offset: offset } = point;
        return {
            _bufferIndex: _bufferIndex,
            _index: _index,
            line: line,
            column: column,
            offset: offset
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   *   Nothing.
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === 'string') {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   *   Code.
   * @returns {undefined}
   *   Nothing.
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            if (point._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
            // strings.
            /** @type {string} */ chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            'enter',
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            'exit',
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   *   Callback.
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   *   Fields.
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | ConstructRecord | Construct} constructs
     *   Constructs.
     * @param {State} returnState
     *   State.
     * @param {State | undefined} [bogusState]
     *   State.
     * @returns {State}
     *   State.
     */ function hook(constructs, returnState, bogusState) {
            /** @type {ReadonlyArray<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? /* c8 ignore next 1 */ handleListOfConstructs(constructs) : 'tokenize' in constructs ? // Looks like a construct.
            handleListOfConstructs([
                /** @type {Construct} */ constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const left = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(left) ? left : left ? [
                            left
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {ReadonlyArray<Construct>} list
       *   Constructs.
       * @returns {State}
       *   State.
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       *   Construct.
       * @returns {State}
       *   State.
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   *   Construct.
   * @param {number} from
   *   From.
   * @returns {undefined}
   *   Nothing.
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $6d957c9e6a169a49$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   *   Info.
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            from: startEventsIndex,
            restore: restore
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     *   Nothing.
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   *   Nothing.
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {Pick<Token, 'end' | 'start'>} token
 *   Token.
 * @returns {Array<Chunk>}
 *   Chunks.
 */ function $e090088a8e1afd2b$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === 'string') view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {ReadonlyArray<Chunk>} chunks
 *   Chunks.
 * @param {boolean | undefined} [expandTabs=false]
 *   Whether to expand tabs (default: `false`).
 * @returns {string}
 *   Result.
 */ function $e090088a8e1afd2b$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === 'string') value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "\t";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join('');
}


function $9dfba146f4c3c794$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $1c4ab323543eb9b7$export$86a865d89ef3c690)([
        $f81d41200564ef26$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        constructs: constructs,
        content: create((0, $145b6cb5bda265c1$export$a7db06668cad9adb)),
        defined: [],
        document: create((0, $3d8796971204dffa$export$5a7bfc01df82fcd1)),
        flow: create((0, $4320be06d95fd4d0$export$ccc7b0636abaffc3)),
        lazy: {},
        string: create((0, $009f2a13a0d178f2$export$22b082955e083ec3)),
        text: create((0, $009f2a13a0d178f2$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   *   Construct to start with.
   * @returns {Create}
   *   Create a tokenizer.
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $e090088a8e1afd2b$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @import {Event} from 'micromark-util-types'
 */ 
function $faf817751c9db3c6$export$bd0e6e1378a871d7(events) {
    while(!(0, $7901602e44e77495$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @import {Chunk, Code, Encoding, Value} from 'micromark-util-types'
 */ /**
 * @callback Preprocessor
 *   Preprocess a value.
 * @param {Value} value
 *   Value.
 * @param {Encoding | null | undefined} [encoding]
 *   Encoding when `value` is a typed array (optional).
 * @param {boolean | null | undefined} [end=false]
 *   Whether this is the last chunk (default: `false`).
 * @returns {Array<Chunk>}
 *   Chunks.
 */ const $2dbc8c8d3cee1d06$var$search = /[\0\t\n\r]/g;
function $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = '';
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === 'string' ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = '';
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $2dbc8c8d3cee1d06$var$search.lastIndex = startPosition;
            match = $2dbc8c8d3cee1d06$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $b990c273e4f741f3$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== 'string') {
        options = encoding;
        encoding = undefined;
    }
    return (0, $76c598c95b20c009$export$ef7acd7185315e22)(options)((0, $faf817751c9db3c6$export$bd0e6e1378a871d7)((0, $9dfba146f4c3c794$export$98e6a39c04603d36)(options).document().write((0, $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee)()(value, encoding, true))));
}







const $dc140a31dd8ab4b3$var$own = {}.hasOwnProperty;
function $dc140a31dd8ab4b3$export$d744d789c09bfde6(value, encoding, options) {
    if (encoding && typeof encoding === 'object') {
        options = encoding;
        encoding = undefined;
    }
    return $dc140a31dd8ab4b3$var$compiler(options)((0, $faf817751c9db3c6$export$bd0e6e1378a871d7)((0, $9dfba146f4c3c794$export$98e6a39c04603d36)(options).document().write((0, $2dbc8c8d3cee1d06$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $dc140a31dd8ab4b3$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            'emphasis',
            'fragment',
            'heading',
            'paragraph',
            'strong'
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            characterReference: onexitcharacterreference,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $dc140a31dd8ab4b3$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: 'root',
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === 'enter') listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($dc140a31dd8ab4b3$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $dc140a31dd8ab4b3$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $dc140a31dd8ab4b3$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $dc140a31dd8ab4b3$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === 'enter') containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === 'enter') {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === 'enter' && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === 'exit' && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === 'exit') continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        'exit',
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: 'listItem',
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        'enter',
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @type {CompileContext['buffer']}
   */ function buffer() {
        this.stack.push({
            type: 'fragment',
            children: []
        });
    }
    /**
   * @type {CompileContext['enter']}
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler || undefined
        ]);
        node.position = {
            start: $dc140a31dd8ab4b3$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @type {CompileContext['exit']}
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error('Cannot close `' + token.type + '` (' + (0, $451965882c5a8799$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it\u2019s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $dc140a31dd8ab4b3$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @type {CompileContext['resume']}
   */ function resume() {
        return (0, $da74a7bb5b052f79$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, '');
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, '');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== 'text') {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $dc140a31dd8ab4b3$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || 'shortcut';
            node.type += 'Reference';
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $516ec3b0ba9da2c8$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === 'link') {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = 'collapsed';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $c580fc709a668807$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = 'full';
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $a72b41c19fbe228c$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $b2bf0a6c22a4700b$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack[this.stack.length - 1];
        tail.value += value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreference(token) {
        const tail = this.stack.pop();
        tail.position.end = $dc140a31dd8ab4b3$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = 'mailto:' + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: 'blockquote',
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: 'code',
            lang: null,
            meta: null,
            value: ''
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: 'inlineCode',
            value: ''
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: 'definition',
            identifier: '',
            label: null,
            title: null,
            url: ''
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: 'emphasis',
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: 'heading',
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: 'break'
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: 'html',
            value: ''
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: 'image',
            title: null,
            url: '',
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: 'link',
            title: null,
            url: '',
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: 'list',
            ordered: token.type === 'listOrdered',
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: 'listItem',
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: 'paragraph',
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: 'strong',
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: 'text',
            value: ''
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: 'thematicBreak'
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $dc140a31dd8ab4b3$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $dc140a31dd8ab4b3$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $dc140a31dd8ab4b3$var$configure(combined, value);
        else $dc140a31dd8ab4b3$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $dc140a31dd8ab4b3$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($dc140a31dd8ab4b3$var$own.call(extension, key)) switch(key){
        case 'canContainEols':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'transforms':
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case 'enter':
        case 'exit':
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $dc140a31dd8ab4b3$var$defaultOnError(left, right) {
    if (left) throw new Error('Cannot close `' + left.type + '` (' + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + '): a different token (`' + right.type + '`, ' + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is open');
    else throw new Error('Cannot close document, a token (`' + right.type + '`, ' + (0, $451965882c5a8799$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ') is still open');
}



function $18742b91d99345f0$var$isParent(node) {
    return node.children instanceof Array;
}
class $18742b91d99345f0$export$b81de2290dcdbb74 extends Error {
    constructor(message, cause){
        super(message);
        this.name = "MarkdownParseError";
        this.cause = cause;
    }
}
class $18742b91d99345f0$export$4cbd36ff09193701 extends Error {
    constructor(message){
        super(message);
        this.name = "UnrecognizedMarkdownConstructError";
    }
}
function $18742b91d99345f0$var$gatherMetadata(mdastNode) {
    const importsMap = /* @__PURE__ */ new Map();
    if (mdastNode.type !== "root") return {
        importDeclarations: {}
    };
    const importStatements = mdastNode.children.filter((n)=>n.type === "mdxjsEsm").filter((n)=>n.value.startsWith("import "));
    importStatements.forEach((imp)=>{
        var _a, _b;
        var _ref;
        ((_ref = (_b = (_a = imp.data) == null ? void 0 : _a.estree) == null ? void 0 : _b.body) !== null && _ref !== void 0 ? _ref : []).forEach((declaration)=>{
            if (declaration.type !== "ImportDeclaration") return;
            declaration.specifiers.forEach((specifier)=>{
                importsMap.set(specifier.local.name, {
                    source: `${declaration.source.value}`,
                    defaultExport: specifier.type === "ImportDefaultSpecifier"
                });
            });
        });
    });
    return {
        importDeclarations: Object.fromEntries(importsMap.entries())
    };
}
function $18742b91d99345f0$export$616d8c68001e2b04(_param) {
    var { root: root, markdown: markdown, visitors: visitors, syntaxExtensions: syntaxExtensions, mdastExtensions: mdastExtensions } = _param, descriptors = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "root",
        "markdown",
        "visitors",
        "syntaxExtensions",
        "mdastExtensions"
    ]);
    var _a;
    let mdastRoot;
    try {
        mdastRoot = (0, $dc140a31dd8ab4b3$export$d744d789c09bfde6)(markdown, {
            extensions: syntaxExtensions,
            mdastExtensions: mdastExtensions
        });
    } catch (e) {
        if (e instanceof Error) throw new $18742b91d99345f0$export$b81de2290dcdbb74(`Error parsing markdown: ${e.message}`, e);
        else throw new $18742b91d99345f0$export$b81de2290dcdbb74(`Error parsing markdown: ${e}`, e);
    }
    if (mdastRoot.children.length === 0) mdastRoot.children.push({
        type: "paragraph",
        children: []
    });
    if (((_a = mdastRoot.children.at(-1)) == null ? void 0 : _a.type) !== "paragraph") mdastRoot.children.push({
        type: "paragraph",
        children: []
    });
    $18742b91d99345f0$export$8443dee93ebc5bea((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        root: root,
        mdastRoot: mdastRoot,
        visitors: visitors
    }, descriptors));
}
function $18742b91d99345f0$export$8443dee93ebc5bea(_param) {
    var { root: root, mdastRoot: mdastRoot, visitors: visitors } = _param, descriptors = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "root",
        "mdastRoot",
        "visitors"
    ]);
    const formattingMap = /* @__PURE__ */ new WeakMap();
    const styleMap = /* @__PURE__ */ new WeakMap();
    const metaData = $18742b91d99345f0$var$gatherMetadata(mdastRoot);
    visitors = visitors.sort((a, b)=>{
        var _b_priority, _a_priority;
        return ((_b_priority = b.priority) !== null && _b_priority !== void 0 ? _b_priority : 0) - ((_a_priority = a.priority) !== null && _a_priority !== void 0 ? _a_priority : 0);
    });
    function visitChildren(mdastNode, lexicalParent) {
        if (!$18742b91d99345f0$var$isParent(mdastNode)) throw new Error("Attempting to visit children of a non-parent");
        mdastNode.children.forEach((child)=>{
            visit(child, lexicalParent, mdastNode);
        });
    }
    function visit(mdastNode, lexicalParent, mdastParent, skipVisitors = null) {
        const visitor = visitors.find((visitor2, index)=>{
            if (skipVisitors == null ? void 0 : skipVisitors.has(index)) return false;
            if (typeof visitor2.testNode === "string") return visitor2.testNode === mdastNode.type;
            return visitor2.testNode(mdastNode, descriptors);
        });
        if (!visitor) try {
            throw new $18742b91d99345f0$export$4cbd36ff09193701(`Unsupported markdown syntax: ${(0, $3abd4354ed897ab8$export$49a1dda9e62e8ae6)(mdastNode)}`);
        } catch (_e) {
            throw new $18742b91d99345f0$export$4cbd36ff09193701(`Parsing of the following markdown structure failed: ${JSON.stringify({
                type: mdastNode.type,
                name: "name" in mdastNode ? mdastNode.name : "N/A"
            })}`);
        }
        visitor.visitNode({
            mdastNode: //@ts-expect-error root type is glitching
            mdastNode,
            lexicalParent: lexicalParent,
            mdastParent: mdastParent,
            descriptors: descriptors,
            metaData: metaData,
            actions: {
                visitChildren: visitChildren,
                nextVisitor () {
                    visit(mdastNode, lexicalParent, mdastParent, (skipVisitors !== null && skipVisitors !== void 0 ? skipVisitors : /* @__PURE__ */ new Set()).add(visitors.indexOf(visitor)));
                },
                addAndStepInto (lexicalNode) {
                    lexicalParent.append(lexicalNode);
                    if ($18742b91d99345f0$var$isParent(mdastNode)) visitChildren(mdastNode, lexicalNode);
                },
                addFormatting (format, node) {
                    if (!node) {
                        if ($18742b91d99345f0$var$isParent(mdastNode)) node = mdastNode;
                    }
                    var _formattingMap_get;
                    if (node) formattingMap.set(node, format | ((_formattingMap_get = formattingMap.get(mdastParent)) !== null && _formattingMap_get !== void 0 ? _formattingMap_get : 0));
                },
                removeFormatting (format, node) {
                    if (!node) {
                        if ($18742b91d99345f0$var$isParent(mdastNode)) node = mdastNode;
                    }
                    var _formattingMap_get;
                    if (node) formattingMap.set(node, format ^ ((_formattingMap_get = formattingMap.get(mdastParent)) !== null && _formattingMap_get !== void 0 ? _formattingMap_get : 0));
                },
                getParentFormatting () {
                    var _formattingMap_get;
                    return (_formattingMap_get = formattingMap.get(mdastParent)) !== null && _formattingMap_get !== void 0 ? _formattingMap_get : 0;
                },
                addStyle (style, node) {
                    if (!node) {
                        if ($18742b91d99345f0$var$isParent(mdastNode)) node = mdastNode;
                    }
                    if (node) styleMap.set(node, style);
                },
                getParentStyle () {
                    var _styleMap_get;
                    return (_styleMap_get = styleMap.get(mdastParent)) !== null && _styleMap_get !== void 0 ? _styleMap_get : "";
                }
            }
        });
    }
    visit(mdastRoot, root, null);
}


function $0bde9de2375dfc26$export$f672e0b6f7222cd7(a, b) {
    return (arg)=>a(b(arg));
}
function $0bde9de2375dfc26$export$e9f9df97f2967b27(arg, proc) {
    return proc(arg);
}
function $0bde9de2375dfc26$export$aca6a2d4cfabe6bb(proc, arg1) {
    return (arg2)=>proc(arg1, arg2);
}
function $0bde9de2375dfc26$export$1834bb65bc4b9335(proc, arg) {
    return ()=>proc(arg);
}
function $0bde9de2375dfc26$export$977f3f6a9323c0f6(property) {
    return (object)=>object[property];
}
function $0bde9de2375dfc26$export$3f23594af5f37336(arg, proc) {
    proc(arg);
    return arg;
}
function $0bde9de2375dfc26$export$848feb93d8f32b9b(proc) {
    proc();
}
function $0bde9de2375dfc26$export$ba9e5d519bc326ca(value) {
    return ()=>value;
}
function $0bde9de2375dfc26$export$9fb5322674ad7780(...procs) {
    return ()=>{
        procs.map($0bde9de2375dfc26$export$848feb93d8f32b9b);
    };
}
function $0bde9de2375dfc26$export$8793edee2d425525() {}





var $8cd574f4b8bf10a0$var$__defProp = Object.defineProperty;
var $8cd574f4b8bf10a0$var$__defNormalProp = (obj, key, value)=>key in obj ? $8cd574f4b8bf10a0$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $8cd574f4b8bf10a0$var$__publicField = (obj, key, value)=>$8cd574f4b8bf10a0$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const $8cd574f4b8bf10a0$export$4fb736250be09c2c = "generic-html";
class $8cd574f4b8bf10a0$export$335a9cc096917391 extends (0, $3e88191b87395c2e$export$dc064fe9e59310fd) {
    /** @internal */ static getType() {
        return $8cd574f4b8bf10a0$export$4fb736250be09c2c;
    }
    /** @internal */ static clone(node) {
        return new $8cd574f4b8bf10a0$export$335a9cc096917391(node.__tag, node.__nodeType, node.__attributes, node.__key);
    }
    getTag() {
        return this.__tag;
    }
    getNodeType() {
        return this.__nodeType;
    }
    getAttributes() {
        return this.__attributes;
    }
    updateAttributes(attributes) {
        const self = this.getWritable();
        self.__attributes = attributes;
    }
    getStyle() {
        var _a;
        return (_a = this.__attributes.find((attribute)=>attribute.name === "style")) == null ? void 0 : _a.value;
    }
    // View
    createDOM() {
        const tag = this.__tag;
        const element = document.createElement(tag);
        this.__attributes.forEach((attribute)=>{
            element.setAttribute(attribute.name, attribute.value);
        });
        return element;
    }
    updateDOM() {
        return false;
    }
    static importDOM() {
        return {};
    }
    exportDOM(editor) {
        const { element: element } = super.exportDOM(editor);
        return {
            element: element
        };
    }
    static importJSON(serializedNode) {
        const node = $8cd574f4b8bf10a0$export$9ed808d668bdeebb(serializedNode.tag, serializedNode.mdxType, serializedNode.attributes);
        node.setFormat(serializedNode.format);
        node.setIndent(serializedNode.indent);
        node.setDirection(serializedNode.direction);
        return node;
    }
    exportJSON() {
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, super.exportJSON()), {
            tag: this.getTag(),
            attributes: this.__attributes,
            mdxType: this.__nodeType,
            type: $8cd574f4b8bf10a0$export$4fb736250be09c2c,
            version: 1
        });
    }
    /*
    // Mutation
    insertNewAfter(selection?: RangeSelection, restoreSelection = true): ParagraphNode | GenericHTMLNode {
      const anchorOffset = selection ? selection.anchor.offset : 0
      const newElement =
        anchorOffset > 0 && anchorOffset < this.getTextContentSize() ? $createHeadingNode(this.getTag()) : $createParagraphNode()
      const direction = this.getDirection()
      newElement.setDirection(direction)
      this.insertAfter(newElement, restoreSelection)
      return newElement
    }
  
    collapseAtStart(): true {
      const newElement = !this.isEmpty() ? $createHeadingNode(this.getTag()) : $createParagraphNode()
      const children = this.getChildren()
      children.forEach((child) => newElement.append(child))
      this.replace(newElement)
      return true
    }*/ extractWithChild() {
        return true;
    }
    isInline() {
        return this.__nodeType === "mdxJsxTextElement";
    }
    /**
   * Constructs a new {@link GenericHTMLNode} with the specified MDAST HTML node as the object to edit.
   */ constructor(tag, type, attributes, key){
        super(key);
        /** @internal */ $8cd574f4b8bf10a0$var$__publicField(this, "__tag");
        /** @internal */ $8cd574f4b8bf10a0$var$__publicField(this, "__nodeType");
        /** @internal */ $8cd574f4b8bf10a0$var$__publicField(this, "__attributes");
        this.__tag = tag;
        this.__nodeType = type;
        this.__attributes = attributes;
    }
}
function $8cd574f4b8bf10a0$export$9ed808d668bdeebb(tag, type, attributes) {
    return (0, $3e88191b87395c2e$export$2f5beb31df92ea57)(new $8cd574f4b8bf10a0$export$335a9cc096917391(tag, type, attributes));
}
function $8cd574f4b8bf10a0$export$e634c3d77d749cd6(node) {
    return node instanceof $8cd574f4b8bf10a0$export$335a9cc096917391;
}



const $e0cdfc832ff5f384$export$905c6e2ade14aaff = {
    testLexicalNode: (0, $8cd574f4b8bf10a0$export$e634c3d77d749cd6),
    visitLexicalNode ({ actions: actions, lexicalNode: lexicalNode }) {
        actions.addAndStepInto("mdxJsxTextElement", {
            name: lexicalNode.getTag(),
            type: lexicalNode.getNodeType(),
            attributes: lexicalNode.getAttributes()
        });
    },
    priority: -100
};



const $1fde141512d355a3$export$cc3dd421a8536734 = {
    testLexicalNode: (0, $3e88191b87395c2e$export$b16330e40aa25c4e),
    visitLexicalNode: ({ mdastParent: mdastParent, actions: actions })=>{
        actions.appendToParent(mdastParent, {
            type: "text",
            value: "\n"
        });
    }
};



const $336068f3f0cb3b92$export$6cf15d817cc544bd = {
    testLexicalNode: (0, $3e88191b87395c2e$export$1fdda795300c79c6),
    visitLexicalNode: ({ actions: actions })=>{
        actions.addAndStepInto("paragraph");
    }
};



const $7dd54374c8b08857$export$e15acc840927bc89 = {
    testLexicalNode: (0, $3e88191b87395c2e$export$5b29ca560c2fedab),
    visitLexicalNode: ({ actions: actions })=>{
        actions.addAndStepInto("root");
    }
};





const $0b9b8702aaeac864$export$95afaaf13ada99c3 = 0;
const $0b9b8702aaeac864$export$d401051135d8c941 = 1;
const $0b9b8702aaeac864$export$6f537bdfcfab164 = 2;
const $0b9b8702aaeac864$export$27809404dee18444 = 4;
const $0b9b8702aaeac864$export$4fefe1576f07e925 = 8;
const $0b9b8702aaeac864$export$bf809f2b03ed57cc = 16;
const $0b9b8702aaeac864$export$22c32c29c50da53a = 32;
const $0b9b8702aaeac864$export$703b9afdf8723203 = 64;
const $0b9b8702aaeac864$export$f1e9b55cdd671814 = 128;


function $c367a53735ab2c0b$export$bd2fe71812e84b27(mdastNode) {
    return mdastNode.type === "text";
}
const $c367a53735ab2c0b$var$JOINABLE_TAGS = [
    "u",
    "span",
    "sub",
    "sup"
];
const $c367a53735ab2c0b$export$5b3da66f7d3254c4 = {
    shouldJoin: (prevNode, currentNode)=>{
        if ([
            "text",
            "emphasis",
            "strong",
            "highlight"
        ].includes(prevNode.type)) return prevNode.type === currentNode.type;
        if (prevNode.type === "mdxJsxTextElement" && // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        currentNode.type === "mdxJsxTextElement" && $c367a53735ab2c0b$var$JOINABLE_TAGS.includes(currentNode.name)) {
            const currentMdxNode = currentNode;
            return prevNode.name === currentMdxNode.name && JSON.stringify(prevNode.attributes) === JSON.stringify(currentMdxNode.attributes);
        }
        return false;
    },
    join (prevNode, currentNode) {
        if ($c367a53735ab2c0b$export$bd2fe71812e84b27(prevNode) && $c367a53735ab2c0b$export$bd2fe71812e84b27(currentNode)) return {
            type: "text",
            value: prevNode.value + currentNode.value
        };
        else return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevNode), {
            children: [
                ...prevNode.children,
                ...currentNode.children
            ]
        });
    },
    testLexicalNode: (0, $3e88191b87395c2e$export$471953706258be2b),
    visitLexicalNode: ({ lexicalNode: lexicalNode, mdastParent: mdastParent, actions: actions })=>{
        const previousSibling = lexicalNode.getPreviousSibling();
        const prevFormat = (0, $3e88191b87395c2e$export$471953706258be2b)(previousSibling) ? previousSibling.getFormat() : 0;
        const textContent = lexicalNode.getTextContent();
        const format = lexicalNode.getFormat();
        const style = lexicalNode.getStyle();
        let localParentNode = mdastParent;
        if (style) localParentNode = actions.appendToParent(localParentNode, {
            type: "mdxJsxTextElement",
            name: "span",
            children: [],
            attributes: [
                {
                    type: "mdxJsxAttribute",
                    name: "style",
                    value: style
                }
            ]
        });
        if (prevFormat & format & (0, $0b9b8702aaeac864$export$4fefe1576f07e925)) localParentNode = actions.appendToParent(localParentNode, {
            type: "mdxJsxTextElement",
            name: "u",
            children: [],
            attributes: []
        });
        if (prevFormat & format & (0, $0b9b8702aaeac864$export$703b9afdf8723203)) localParentNode = actions.appendToParent(localParentNode, {
            type: "mdxJsxTextElement",
            name: "sup",
            children: [],
            attributes: []
        });
        if (prevFormat & format & (0, $0b9b8702aaeac864$export$22c32c29c50da53a)) localParentNode = actions.appendToParent(localParentNode, {
            type: "mdxJsxTextElement",
            name: "sub",
            children: [],
            attributes: []
        });
        if (prevFormat & format & (0, $0b9b8702aaeac864$export$6f537bdfcfab164)) localParentNode = actions.appendToParent(localParentNode, {
            type: "emphasis",
            children: []
        });
        if (prevFormat & format & (0, $0b9b8702aaeac864$export$d401051135d8c941)) localParentNode = actions.appendToParent(localParentNode, {
            type: "strong",
            children: []
        });
        if (prevFormat & format & (0, $0b9b8702aaeac864$export$27809404dee18444)) localParentNode = actions.appendToParent(localParentNode, {
            type: "delete",
            children: []
        });
        if (prevFormat & format & (0, $0b9b8702aaeac864$export$f1e9b55cdd671814)) localParentNode = actions.appendToParent(localParentNode, {
            type: "highlight",
            children: []
        });
        if (format & (0, $0b9b8702aaeac864$export$4fefe1576f07e925) && !(prevFormat & (0, $0b9b8702aaeac864$export$4fefe1576f07e925))) localParentNode = actions.appendToParent(localParentNode, {
            type: "mdxJsxTextElement",
            name: "u",
            children: [],
            attributes: []
        });
        if (format & (0, $0b9b8702aaeac864$export$703b9afdf8723203) && !(prevFormat & (0, $0b9b8702aaeac864$export$703b9afdf8723203))) localParentNode = actions.appendToParent(localParentNode, {
            type: "mdxJsxTextElement",
            name: "sup",
            children: [],
            attributes: []
        });
        if (format & (0, $0b9b8702aaeac864$export$22c32c29c50da53a) && !(prevFormat & (0, $0b9b8702aaeac864$export$22c32c29c50da53a))) localParentNode = actions.appendToParent(localParentNode, {
            type: "mdxJsxTextElement",
            name: "sub",
            children: [],
            attributes: []
        });
        if (format & (0, $0b9b8702aaeac864$export$6f537bdfcfab164) && !(prevFormat & (0, $0b9b8702aaeac864$export$6f537bdfcfab164))) localParentNode = actions.appendToParent(localParentNode, {
            type: "emphasis",
            children: []
        });
        if (format & (0, $0b9b8702aaeac864$export$d401051135d8c941) && !(prevFormat & (0, $0b9b8702aaeac864$export$d401051135d8c941))) localParentNode = actions.appendToParent(localParentNode, {
            type: "strong",
            children: []
        });
        if (format & (0, $0b9b8702aaeac864$export$27809404dee18444) && !(prevFormat & (0, $0b9b8702aaeac864$export$27809404dee18444))) localParentNode = actions.appendToParent(localParentNode, {
            type: "delete",
            children: []
        });
        if (format & (0, $0b9b8702aaeac864$export$f1e9b55cdd671814) && !(prevFormat & (0, $0b9b8702aaeac864$export$f1e9b55cdd671814))) localParentNode = actions.appendToParent(localParentNode, {
            type: "highlight",
            children: []
        });
        if (format & (0, $0b9b8702aaeac864$export$bf809f2b03ed57cc)) {
            actions.appendToParent(localParentNode, {
                type: "inlineCode",
                value: textContent
            });
            return;
        }
        actions.appendToParent(localParentNode, {
            type: "text",
            value: textContent
        });
    }
};



const $221e4716b3e6afd7$export$a99d4e452656bd84 = {
    testNode: "break",
    visitNode: function({ lexicalParent: lexicalParent }) {
        lexicalParent.append((0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)());
    }
};




function $c5d55c511ef6792a$var$buildFormattingVisitors(tag, format) {
    return [
        {
            testNode: (node)=>node.type === "mdxJsxTextElement" && node.name === tag,
            visitNode ({ actions: actions, mdastNode: mdastNode, lexicalParent: lexicalParent }) {
                actions.addFormatting(format);
                actions.visitChildren(mdastNode, lexicalParent);
            }
        },
        {
            testNode: (node)=>node.type === "html" && node.value === `<${tag}>`,
            visitNode ({ actions: actions, mdastParent: mdastParent }) {
                actions.addFormatting(format, mdastParent);
            }
        },
        {
            testNode: (node)=>node.type === "html" && node.value === `</${tag}>`,
            visitNode ({ actions: actions, mdastParent: mdastParent }) {
                actions.removeFormatting(format, mdastParent);
            }
        }
    ];
}
const $c5d55c511ef6792a$var$StrikeThroughVisitor = {
    testNode: "delete",
    visitNode ({ mdastNode: mdastNode, actions: actions, lexicalParent: lexicalParent }) {
        actions.addFormatting((0, $0b9b8702aaeac864$export$27809404dee18444));
        actions.visitChildren(mdastNode, lexicalParent);
    }
};
const $c5d55c511ef6792a$var$HighlightVisitor = {
    testNode: "highlight",
    visitNode ({ mdastNode: mdastNode, actions: actions, lexicalParent: lexicalParent }) {
        actions.addFormatting((0, $0b9b8702aaeac864$export$f1e9b55cdd671814));
        actions.visitChildren(mdastNode, lexicalParent);
    }
};
const $c5d55c511ef6792a$var$MdCodeVisitor = {
    testNode: "inlineCode",
    visitNode ({ mdastNode: mdastNode, actions: actions }) {
        actions.addAndStepInto((0, $3e88191b87395c2e$export$2785f39dcdec0078)(mdastNode.value).setFormat(actions.getParentFormatting() | (0, $0b9b8702aaeac864$export$bf809f2b03ed57cc)));
    }
};
const $c5d55c511ef6792a$var$MdEmphasisVisitor = {
    testNode: "emphasis",
    visitNode ({ mdastNode: mdastNode, actions: actions, lexicalParent: lexicalParent }) {
        actions.addFormatting((0, $0b9b8702aaeac864$export$6f537bdfcfab164));
        actions.visitChildren(mdastNode, lexicalParent);
    }
};
const $c5d55c511ef6792a$var$MdStrongVisitor = {
    testNode: "strong",
    visitNode ({ mdastNode: mdastNode, actions: actions, lexicalParent: lexicalParent }) {
        actions.addFormatting((0, $0b9b8702aaeac864$export$d401051135d8c941));
        actions.visitChildren(mdastNode, lexicalParent);
    }
};
const $c5d55c511ef6792a$export$8fb2942f2f386a7d = [
    // emphasis
    $c5d55c511ef6792a$var$MdEmphasisVisitor,
    // strong
    $c5d55c511ef6792a$var$MdStrongVisitor,
    // underline
    ...$c5d55c511ef6792a$var$buildFormattingVisitors("u", (0, $0b9b8702aaeac864$export$4fefe1576f07e925)),
    // code
    ...$c5d55c511ef6792a$var$buildFormattingVisitors("code", (0, $0b9b8702aaeac864$export$bf809f2b03ed57cc)),
    $c5d55c511ef6792a$var$MdCodeVisitor,
    // strikethrough
    $c5d55c511ef6792a$var$StrikeThroughVisitor,
    // highlight
    $c5d55c511ef6792a$var$HighlightVisitor,
    // superscript
    ...$c5d55c511ef6792a$var$buildFormattingVisitors("sup", (0, $0b9b8702aaeac864$export$703b9afdf8723203)),
    // subscript
    ...$c5d55c511ef6792a$var$buildFormattingVisitors("sub", (0, $0b9b8702aaeac864$export$22c32c29c50da53a))
];




const $502b1cab6f6d05b5$export$3de796e6f648521e = {
    testNode: (0, $4b095f1b731e6368$export$736fc15d0c902f22),
    visitNode: function({ mdastNode: mdastNode, actions: actions, lexicalParent: lexicalParent }) {
        if (mdastNode.name === "span" && mdastNode.attributes.length === 1 && mdastNode.attributes[0].type === "mdxJsxAttribute" && mdastNode.attributes[0].name === "style") {
            actions.addStyle(mdastNode.attributes[0].value, mdastNode);
            actions.visitChildren(mdastNode, lexicalParent);
        } else actions.addAndStepInto((0, $8cd574f4b8bf10a0$export$9ed808d668bdeebb)(mdastNode.name, mdastNode.type, mdastNode.attributes));
    },
    priority: -100
};



const $dbb72ce4f379d305$var$lexicalTypesThatShouldSkipParagraphs = [
    "listitem",
    "admonition"
];
const $dbb72ce4f379d305$export$69a5d1a919efc2fc = {
    testNode: "paragraph",
    visitNode: function({ mdastNode: mdastNode, mdastParent: mdastParent, lexicalParent: lexicalParent, actions: actions }) {
        const parentType = lexicalParent.getType();
        if ($dbb72ce4f379d305$var$lexicalTypesThatShouldSkipParagraphs.includes(parentType)) {
            var _ref;
            const mdastNodeIndex = (_ref = mdastParent == null ? void 0 : mdastParent.children.indexOf(mdastNode)) !== null && _ref !== void 0 ? _ref : -1;
            const previousMdastSibling = mdastNodeIndex > 0 ? mdastParent == null ? void 0 : mdastParent.children.at(mdastNodeIndex - 1) : void 0;
            if (parentType === "listitem" && (previousMdastSibling == null ? void 0 : previousMdastSibling.type) === "paragraph") lexicalParent.append((0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)(), (0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)());
            actions.visitChildren(mdastNode, lexicalParent);
        } else actions.addAndStepInto((0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)());
    }
};


const $fede923fafaf71cb$export$1a62e20af8363672 = {
    testNode: "root",
    visitNode ({ actions: actions, mdastNode: mdastNode, lexicalParent: lexicalParent }) {
        actions.visitChildren(mdastNode, lexicalParent);
    }
};



const $60dc02a38c8c295a$export$c0afffa0cceae669 = {
    testNode: "text",
    visitNode ({ mdastNode: mdastNode, actions: actions }) {
        const node = (0, $3e88191b87395c2e$export$2785f39dcdec0078)(mdastNode.value);
        node.setFormat(actions.getParentFormatting());
        const style = actions.getParentStyle();
        if (style !== "") node.setStyle(style);
        actions.addAndStepInto(node);
    }
};




const $bb65379180b682ea$var$codes = {
    dash: 45,
    eof: null,
    exclamationMark: 33,
    greaterThan: 62
};
const $bb65379180b682ea$var$types = {
    data: "data",
    lineEnding: "lineEnding",
    linePrefix: "linePrefix"
};
function $bb65379180b682ea$export$261df8223e720ac7(_options) {
    return {
        canContainEols: [
            "comment"
        ],
        enter: {
            comment (_) {
                this.buffer();
            }
        },
        exit: {
            comment (token) {
                this.resume();
            }
        }
    };
}
const $bb65379180b682ea$var$tokenize = (effects, ok, nok)=>{
    return start;
    function start(code) {
        effects.enter("comment");
        effects.consume(code);
        return open;
    }
    function open(code) {
        if (code === $bb65379180b682ea$var$codes.exclamationMark) {
            effects.consume(code);
            return declarationOpen;
        }
        return nok(code);
    }
    function declarationOpen(code) {
        if (code === $bb65379180b682ea$var$codes.dash) {
            effects.consume(code);
            return commentOpen;
        }
        return nok(code);
    }
    function commentOpen(code) {
        if (code === $bb65379180b682ea$var$codes.dash) {
            effects.consume(code);
            return commentStart;
        }
        return nok(code);
    }
    function commentStart(code) {
        if (code === $bb65379180b682ea$var$codes.greaterThan) return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return atLineEnding(code);
        effects.enter($bb65379180b682ea$var$types.data);
        if (code === $bb65379180b682ea$var$codes.dash) {
            effects.consume(code);
            return commentStartDash;
        }
        return comment2(code);
    }
    function commentStartDash(code) {
        if (code === $bb65379180b682ea$var$codes.greaterThan) return nok(code);
        return comment2(code);
    }
    function comment2(code) {
        if (code === $bb65379180b682ea$var$codes.eof) return nok(code);
        if (code === $bb65379180b682ea$var$codes.dash) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit($bb65379180b682ea$var$types.data);
            return atLineEnding(code);
        }
        effects.consume(code);
        return comment2;
    }
    function atLineEnding(code) {
        effects.enter($bb65379180b682ea$var$types.lineEnding);
        effects.consume(code);
        effects.exit($bb65379180b682ea$var$types.lineEnding);
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, afterPrefix, $bb65379180b682ea$var$types.linePrefix);
    }
    function afterPrefix(code) {
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return atLineEnding(code);
        effects.enter($bb65379180b682ea$var$types.data);
        return comment2(code);
    }
    function commentClose(code) {
        if (code === $bb65379180b682ea$var$codes.dash) {
            effects.consume(code);
            return end;
        }
        return comment2(code);
    }
    function end(code) {
        if (code === $bb65379180b682ea$var$codes.greaterThan) {
            effects.exit($bb65379180b682ea$var$types.data);
            effects.enter("commentEnd");
            effects.consume(code);
            effects.exit("commentEnd");
            effects.exit("comment");
            return ok(code);
        }
        if (code === $bb65379180b682ea$var$codes.dash) {
            effects.consume(code);
            return end;
        }
        return comment2(code);
    }
};
const $bb65379180b682ea$export$4a34f930e789283c = {
    flow: {
        [60]: {
            tokenize: $bb65379180b682ea$var$tokenize,
            concrete: true
        }
    },
    text: {
        [60]: {
            tokenize: $bb65379180b682ea$var$tokenize
        }
    }
};


const $128c6a5e8d0cdc22$export$73ba5813cda80a49 = "_bold_6j9u9_10";
const $128c6a5e8d0cdc22$export$5540da1282cbf565 = "_italic_6j9u9_14";
const $128c6a5e8d0cdc22$export$425327af25286e5e = "_underline_6j9u9_18";
const $128c6a5e8d0cdc22$export$19426ff118fe8be = "_strikethrough_6j9u9_34";
const $128c6a5e8d0cdc22$export$367ae68cbdccf136 = "_underlineStrikethrough_6j9u9_38";
const $128c6a5e8d0cdc22$export$bc5390e4688d2822 = "_subscript_6j9u9_42";
const $128c6a5e8d0cdc22$export$b4aab94a5fcfcead = "_superscript_6j9u9_47";
const $128c6a5e8d0cdc22$export$6565f9f03506010b = "_code_6j9u9_52";
const $128c6a5e8d0cdc22$export$ee7a15c61bfdeb11 = "_quote_6j9u9_59";
const $128c6a5e8d0cdc22$export$4d14e58a0ee442ee = "_nestedListItem_6j9u9_66";
const $128c6a5e8d0cdc22$export$f90eb7c4d1fc985e = "_listitem_6j9u9_76";
const $128c6a5e8d0cdc22$export$cd71b050e243af0c = "_listItemChecked_6j9u9_80";
const $128c6a5e8d0cdc22$export$4aee518609bf0231 = "_listItemUnchecked_6j9u9_81";
const $128c6a5e8d0cdc22$export$443148dd89a65a36 = "_admonitionDanger_6j9u9_158";
const $128c6a5e8d0cdc22$export$d98be01d8eb19239 = "_admonitionInfo_6j9u9_159";
const $128c6a5e8d0cdc22$export$dea99801b84b86ca = "_admonitionNote_6j9u9_160";
const $128c6a5e8d0cdc22$export$9cb68980d9d74d1b = "_admonitionTip_6j9u9_161";
const $128c6a5e8d0cdc22$export$2459f259654912df = "_admonitionCaution_6j9u9_162";
const $128c6a5e8d0cdc22$export$bc53ba69d696225f = "_mdxExpression_6j9u9_195";
const $128c6a5e8d0cdc22$export$2e2bcd8739ae039 = {
    bold: $128c6a5e8d0cdc22$export$73ba5813cda80a49,
    italic: $128c6a5e8d0cdc22$export$5540da1282cbf565,
    underline: $128c6a5e8d0cdc22$export$425327af25286e5e,
    strikethrough: $128c6a5e8d0cdc22$export$19426ff118fe8be,
    underlineStrikethrough: $128c6a5e8d0cdc22$export$367ae68cbdccf136,
    subscript: $128c6a5e8d0cdc22$export$bc5390e4688d2822,
    superscript: $128c6a5e8d0cdc22$export$b4aab94a5fcfcead,
    code: $128c6a5e8d0cdc22$export$6565f9f03506010b,
    quote: $128c6a5e8d0cdc22$export$ee7a15c61bfdeb11,
    nestedListItem: $128c6a5e8d0cdc22$export$4d14e58a0ee442ee,
    listitem: $128c6a5e8d0cdc22$export$f90eb7c4d1fc985e,
    listItemChecked: $128c6a5e8d0cdc22$export$cd71b050e243af0c,
    listItemUnchecked: $128c6a5e8d0cdc22$export$4aee518609bf0231,
    admonitionDanger: $128c6a5e8d0cdc22$export$443148dd89a65a36,
    admonitionInfo: $128c6a5e8d0cdc22$export$d98be01d8eb19239,
    admonitionNote: $128c6a5e8d0cdc22$export$dea99801b84b86ca,
    admonitionTip: $128c6a5e8d0cdc22$export$9cb68980d9d74d1b,
    admonitionCaution: $128c6a5e8d0cdc22$export$2459f259654912df,
    mdxExpression: $128c6a5e8d0cdc22$export$bc53ba69d696225f
};


const $21f2e650573058ac$export$8b7e4ddc5e9bc24a = {
    quote: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).quote,
    text: {
        bold: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).bold,
        italic: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).italic,
        underline: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).underline,
        code: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).code,
        strikethrough: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).strikethrough,
        subscript: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).subscript,
        superscript: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).superscript,
        underlineStrikethrough: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).underlineStrikethrough
    },
    list: {
        listitem: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).listitem,
        listitemChecked: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).listItemChecked,
        listitemUnchecked: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).listItemUnchecked,
        nested: {
            listitem: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).nestedListItem
        }
    },
    admonition: {
        danger: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).admonitionDanger,
        info: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).admonitionInfo,
        note: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).admonitionNote,
        tip: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).admonitionTip,
        caution: (0, $128c6a5e8d0cdc22$export$2e2bcd8739ae039).admonitionCaution
    }
};






/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ /**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
var $7fPBF = parcelRequire("7fPBF");
const $54da90dd2162c735$export$89ed468fc445de9 = (0, $7fPBF.createContext)(null);
function $54da90dd2162c735$export$415f945d0a04b29b(n, e) {
    let r = null;
    return null != n && (r = n[1]), {
        getTheme: function() {
            return null != e ? e : null != r ? r.getTheme() : null;
        }
    };
}
function $54da90dd2162c735$export$6aeca6bab7b7edbc() {
    const n = (0, $7fPBF.useContext)($54da90dd2162c735$export$89ed468fc445de9);
    return null == n && function(n, ...e) {
        const r = new URL("https://lexical.dev/docs/error"), t = new URLSearchParams;
        t.append("code", n);
        for (const n of e)t.append("v", n);
        throw r.search = t.toString(), Error(`Minified Lexical error #${n}; visit ${r.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
    }(8), n;
}



var $7fPBF = parcelRequire("7fPBF");


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
function $3a674b7e320eb29a$export$30f3f631b921b275() {
    return (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)().getTextContent();
}
function $3a674b7e320eb29a$export$39012e9ed4d8a4a2(t, e = !0) {
    if (t) return !1;
    let n = $3a674b7e320eb29a$export$30f3f631b921b275();
    return e && (n = n.trim()), "" === n;
}
function $3a674b7e320eb29a$export$4dd45bbaca0ebba9(t, e) {
    return ()=>$3a674b7e320eb29a$export$39012e9ed4d8a4a2(t, e);
}
function $3a674b7e320eb29a$export$8ccd1eb35058e001(o) {
    if (!$3a674b7e320eb29a$export$39012e9ed4d8a4a2(o, !1)) return !1;
    const l = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)().getChildren(), s = l.length;
    if (s > 1) return !1;
    for(let t = 0; t < s; t++){
        const o = l[t];
        if ((0, $3e88191b87395c2e$export$60aa03725ce41b1c)(o)) return !1;
        if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(o)) {
            if (!(0, $3e88191b87395c2e$export$1fdda795300c79c6)(o)) return !1;
            if (0 !== o.__indent) return !1;
            const e = o.getChildren(), n = e.length;
            for(let r = 0; r < n; r++){
                const n = e[t];
                if (!(0, $3e88191b87395c2e$export$471953706258be2b)(n)) return !1;
            }
        }
    }
    return !0;
}
function $3a674b7e320eb29a$export$91992121baced35b(t) {
    return ()=>$3a674b7e320eb29a$export$8ccd1eb35058e001(t);
}
function $3a674b7e320eb29a$export$36df953e3249f0c7(t, e) {
    let r = t.getFirstChild(), o = 0;
    t: for(; null !== r;){
        if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(r)) {
            const t = r.getFirstChild();
            if (null !== t) {
                r = t;
                continue;
            }
        } else if ((0, $3e88191b87395c2e$export$471953706258be2b)(r)) {
            const t = r.getTextContentSize();
            if (o + t > e) return {
                node: r,
                offset: e - o
            };
            o += t;
        }
        const t = r.getNextSibling();
        if (null !== t) {
            r = t;
            continue;
        }
        let l = r.getParent();
        for(; null !== l;){
            const t = l.getNextSibling();
            if (null !== t) {
                r = t;
                continue t;
            }
            l = l.getParent();
        }
        break;
    }
    return null;
}
function $3a674b7e320eb29a$var$d(t, ...e) {
    const n = new URL("https://lexical.dev/docs/error"), r = new URLSearchParams;
    r.append("code", t);
    for (const t of e)r.append("v", t);
    throw n.search = r.toString(), Error(`Minified Lexical error #${t}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function $3a674b7e320eb29a$export$1a95a1271f0bbc64(t, e, n, r) {
    const s = (t)=>t instanceof n, f = (t)=>{
        const e = (0, $3e88191b87395c2e$export$2785f39dcdec0078)(t.getTextContent());
        e.setFormat(t.getFormat()), t.replace(e);
    };
    return [
        t.registerNodeTransform((0, $3e88191b87395c2e$export$f0a25ea3087686aa), (t)=>{
            if (!t.isSimpleText()) return;
            let n, o = t.getPreviousSibling(), l = t.getTextContent(), u = t;
            if ((0, $3e88191b87395c2e$export$471953706258be2b)(o)) {
                const n = o.getTextContent(), r = e(n + l);
                if (s(o)) {
                    if (null === r || 0 !== ((t)=>t.getLatest().__mode)(o)) return void f(o);
                    {
                        const e = r.end - n.length;
                        if (e > 0) {
                            const r = n + l.slice(0, e);
                            if (o.select(), o.setTextContent(r), e === l.length) t.remove();
                            else {
                                const n = l.slice(e);
                                t.setTextContent(n);
                            }
                            return;
                        }
                    }
                } else if (null === r || r.start < n.length) return;
            }
            let c = 0;
            for(;;){
                n = e(l);
                let t, g = null === n ? "" : l.slice(n.end);
                if (l = g, "" === g) {
                    const t = u.getNextSibling();
                    if ((0, $3e88191b87395c2e$export$471953706258be2b)(t)) {
                        g = u.getTextContent() + t.getTextContent();
                        const n = e(g);
                        if (null === n) return void (s(t) ? f(t) : t.markDirty());
                        if (0 !== n.start) return;
                    }
                }
                if (null === n) return;
                if (0 === n.start && (0, $3e88191b87395c2e$export$471953706258be2b)(o) && o.isTextEntity()) {
                    c += n.end;
                    continue;
                }
                0 === n.start ? [t, u] = u.splitText(n.end) : [, t, u] = u.splitText(n.start + c, n.end + c), void 0 === t && $3a674b7e320eb29a$var$d(165, "nodeToReplace");
                const a = r(t);
                if (a.setFormat(t.getFormat()), t.replace(a), null == u) return;
                c = 0, o = a;
            }
        }),
        t.registerNodeTransform(n, (t)=>{
            const n = t.getTextContent(), r = e(n);
            if (null === r || 0 !== r.start) return void f(t);
            if (n.length > r.end) return void t.splitText(r.end);
            const o = t.getPreviousSibling();
            (0, $3e88191b87395c2e$export$471953706258be2b)(o) && o.isTextEntity() && (f(o), f(t));
            const l = t.getNextSibling();
            (0, $3e88191b87395c2e$export$471953706258be2b)(l) && l.isTextEntity() && (f(l), s(t) && f(t));
        })
    ];
}


const $a04f6a7c3553d076$var$f = (0, $3e88191b87395c2e$export$37d2f1e98a187e61) ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $a04f6a7c3553d076$var$b(_param, R) {
    var { editor: e, ariaActiveDescendant: t, ariaAutoComplete: i, ariaControls: a, ariaDescribedBy: l, ariaErrorMessage: d, ariaExpanded: c, ariaInvalid: u, ariaLabel: m, ariaLabelledBy: b, ariaMultiline: p, ariaOwns: x, ariaRequired: v, autoCapitalize: E, className: y, id: C, role: g = "textbox", spellCheck: L = !0, style: h, tabIndex: w, "data-testid": D } = _param, I = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "editor",
        "ariaActiveDescendant",
        "ariaAutoComplete",
        "ariaControls",
        "ariaDescribedBy",
        "ariaErrorMessage",
        "ariaExpanded",
        "ariaInvalid",
        "ariaLabel",
        "ariaLabelledBy",
        "ariaMultiline",
        "ariaOwns",
        "ariaRequired",
        "autoCapitalize",
        "className",
        "id",
        "role",
        "spellCheck",
        "style",
        "tabIndex",
        "data-testid"
    ]);
    const [k, q] = (0, $7fPBF.useState)(e.isEditable()), z = (0, $7fPBF.useCallback)((t)=>{
        t && t.ownerDocument && t.ownerDocument.defaultView ? e.setRootElement(t) : e.setRootElement(null);
    }, [
        e
    ]), A = (0, $7fPBF.useMemo)(()=>(function(...e) {
            return (t)=>{
                for (const i of e)"function" == typeof i ? i(t) : null != i && (i.current = t);
            };
        })(R, z), [
        z,
        R
    ]);
    return $a04f6a7c3553d076$var$f(()=>(q(e.isEditable()), e.registerEditableListener((e)=>{
            q(e);
        })), [
        e
    ]), /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "aria-activedescendant": k ? t : void 0,
        "aria-autocomplete": k ? i : "none",
        "aria-controls": k ? a : void 0,
        "aria-describedby": l
    }, null != d ? {
        "aria-errormessage": d
    } : {}), {
        "aria-expanded": k && "combobox" === g ? !!c : void 0
    }), null != u ? {
        "aria-invalid": u
    } : {}), {
        "aria-label": m,
        "aria-labelledby": b,
        "aria-multiline": p,
        "aria-owns": k ? x : void 0,
        "aria-readonly": !k || void 0,
        "aria-required": v,
        autoCapitalize: E,
        className: y,
        contentEditable: k,
        "data-testid": D,
        id: C,
        ref: A,
        role: g,
        spellCheck: L,
        style: h,
        tabIndex: w !== null && w !== void 0 ? w : k ? void 0 : -1
    }), I));
}
const $a04f6a7c3553d076$export$b5addb8926dd3cd5 = /*#__PURE__*/ (0, $7fPBF.forwardRef)($a04f6a7c3553d076$var$b);
function $a04f6a7c3553d076$var$x(e) {
    return e.read("latest", (0, $3a674b7e320eb29a$export$91992121baced35b)(e.isComposing()));
}
const $a04f6a7c3553d076$export$15d656b6f5aa1ba8 = /*#__PURE__*/ (0, $7fPBF.forwardRef)($a04f6a7c3553d076$var$E);
function $a04f6a7c3553d076$var$E(t, i) {
    const { placeholder: a } = t, r = (0, $8901fc92b5563702$export$71511d61b312f219)(t, [
        "placeholder"
    ]), [n] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)();
    return (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a04f6a7c3553d076$export$b5addb8926dd3cd5, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                editor: n
            }, r), {
                ref: i
            })),
            null != a && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($a04f6a7c3553d076$var$y, {
                editor: n,
                content: a
            })
        ]
    });
}
function $a04f6a7c3553d076$var$y({ content: e, editor: i }) {
    const a = function(e) {
        const [t, i] = (0, $7fPBF.useState)(()=>$a04f6a7c3553d076$var$x(e));
        return $a04f6a7c3553d076$var$f(()=>{
            function t() {
                const t = $a04f6a7c3553d076$var$x(e);
                i(t);
            }
            return t(), (0, $3e88191b87395c2e$export$d64d64f541cc1835)(e.registerUpdateListener(()=>{
                t();
            }), e.registerEditableListener(()=>{
                t();
            }));
        }, [
            e
        ]), t;
    }(i), [n, o] = (0, $7fPBF.useState)(i.isEditable());
    if ((0, $7fPBF.useLayoutEffect)(()=>(o(i.isEditable()), i.registerEditableListener((e)=>{
            o(e);
        })), [
        i
    ]), !a) return null;
    let l = null;
    return "function" == typeof e ? l = e(n) : null !== e && (l = e), null === l ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        "aria-hidden": !0,
        children: l
    });
}


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

var $7fPBF = parcelRequire("7fPBF");

class $e03e38c0e008fd9d$var$t extends (0, $7fPBF.Component) {
    static getDerivedStateFromError() {
        return {
            hasError: !0
        };
    }
    componentDidCatch(r, o) {
        this.props.onError(r instanceof Error ? r : new Error(String(r), {
            cause: r
        }), o);
    }
    render() {
        return this.state.hasError ? this.props.fallback : this.props.children;
    }
    constructor(...args){
        super(...args), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "state", {
            hasError: !1
        });
    }
}
function $e03e38c0e008fd9d$export$a8147b707c252e29({ children: r, fallback: e, onError: n }) {
    return (0, $824c049f32d4395d$exports.jsx)($e03e38c0e008fd9d$var$t, {
        fallback: void 0 === e ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            style: {
                border: "1px solid #f00",
                color: "#f00",
                padding: "8px"
            },
            children: "An error was thrown."
        }) : e,
        onError: n,
        children: r
    });
}


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
const $5202a342a9f8ce8b$export$3deb62a530a54b75 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    name: "@lexical/react/ReactProvider"
});





var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");

function $28a7ea8b7fe3b9fa$var$p(r, e) {
    const [o] = e, t = r.decorators.map((r)=>"function" == typeof r ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(r, {
            context: e
        }) : r);
    return function(n) {
        const { EditorChildrenComponent: c = r.EditorChildrenComponent, ErrorBoundary: u = r.ErrorBoundary, contentEditable: p = r.contentEditable, children: h } = n, E = function(r, e) {
            const [o, t] = (0, $7fPBF.useMemo)(()=>[
                    (e)=>r.registerDecoratorListener(e),
                    ()=>r.getDecorators()
                ], [
                r
            ]), n = (0, $7fPBF.useSyncExternalStore)(o, t, t);
            return (0, $7fPBF.useMemo)(()=>{
                const o = [];
                for(const t in n){
                    const c = r.getElementByKey(t);
                    if (null !== c) {
                        const i = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(e, {
                            onError: (e)=>{
                                r._onError(e);
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Suspense), {
                                fallback: null,
                                children: n[t]
                            })
                        });
                        o.push(/*#__PURE__*/ (0, $fw0lo.createPortal)(i, c, t));
                    }
                }
                return o;
            }, [
                e,
                n,
                r
            ]);
        }(o, u), x = (0, $7fPBF.useMemo)(()=>t.map((r, e)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(u, {
                    onError: (r)=>{
                        o._onError(r);
                    },
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Suspense), {
                        fallback: null,
                        children: r
                    })
                }, e)), [
            u
        ]);
        return (0, $824c049f32d4395d$exports.jsx)((0, $54da90dd2162c735$export$89ed468fc445de9).Provider, {
            value: e,
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)(c, {
                context: e,
                contentEditable: p,
                children: [
                    h,
                    x,
                    E
                ]
            })
        });
    };
}
function $28a7ea8b7fe3b9fa$export$5203a630295c216d({ contentEditable: r, children: e }) {
    return (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            r,
            e
        ]
    });
}
const $28a7ea8b7fe3b9fa$var$E = {
    EditorChildrenComponent: $28a7ea8b7fe3b9fa$export$5203a630295c216d,
    ErrorBoundary: (0, $e03e38c0e008fd9d$export$a8147b707c252e29),
    contentEditable: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a04f6a7c3553d076$export$15d656b6f5aa1ba8), {}),
    decorators: []
}, $28a7ea8b7fe3b9fa$export$7512bd77445b5962 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build (r, e, t) {
        t.getPeer((0, $5202a342a9f8ce8b$export$3deb62a530a54b75).name) || function(r, ...e) {
            const o = new URL("https://lexical.dev/docs/error"), t = new URLSearchParams;
            t.append("code", r);
            for (const r of e)t.append("v", r);
            throw o.search = t.toString(), Error(`Minified Lexical error #${r}; visit ${o.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
        }(321, [
            ...t.getDirectDependentNames()
        ].join(" "));
        const n = [
            r,
            {
                getTheme: ()=>r._config.theme
            }
        ];
        return {
            Component: $28a7ea8b7fe3b9fa$var$p(e, n),
            context: n
        };
    },
    config: $28a7ea8b7fe3b9fa$var$E,
    mergeConfig (r, e) {
        const o = (0, $3e88191b87395c2e$export$89e5ee996f4118)(r, e);
        return e.decorators && (o.decorators = e.decorators.length > 0 ? [
            ...r.decorators,
            ...e.decorators
        ] : r.decorators), o;
    },
    name: "@lexical/react/React",
    peerDependencies: [
        /* @__PURE__ */ (0, $3e88191b87395c2e$export$27b7a43b7d643f5f)((0, $5202a342a9f8ce8b$export$3deb62a530a54b75).name)
    ]
});




const $e4b4032c9b34afa3$var$editorsWithSharedHistory = /* @__PURE__ */ new WeakSet();
const $e4b4032c9b34afa3$var$editorHistoryStates = /* @__PURE__ */ new WeakMap();
const $e4b4032c9b34afa3$var$extensionBuiltinNodes = /* @__PURE__ */ new Set([
    (0, $3e88191b87395c2e$export$1c180cb67301903c),
    (0, $3e88191b87395c2e$export$f0a25ea3087686aa),
    (0, $3e88191b87395c2e$export$965f56e8043e93ae),
    (0, $3e88191b87395c2e$export$8dbf7edd89edc19c),
    (0, $3e88191b87395c2e$export$e94424771493b912)
]);
const $e4b4032c9b34afa3$var$meaningfulHistoryEntries = /* @__PURE__ */ new WeakMap();
function $e4b4032c9b34afa3$var$externalHistoryExtension(historyState) {
    return (0, $3e88191b87395c2e$export$7c74af9ea11c2716)((0, $08b351797623b941$export$28f798955ffac32a), {
        createInitialHistoryState: ()=>historyState,
        disabled: false
    });
}
function $e4b4032c9b34afa3$export$dbb611ce42f3fd01({ name: name, namespace: namespace, nodes: nodes, theme: theme, editable: editable = true, parentEditor: parentEditor, historyMode: historyMode, historyState: historyState, initialEditorState: initialEditorState, onError: onError = (error)=>{
    throw error;
} }) {
    const dependencies = [
        (0, $5202a342a9f8ce8b$export$3deb62a530a54b75),
        (0, $3e88191b87395c2e$export$7c74af9ea11c2716)((0, $28a7ea8b7fe3b9fa$export$7512bd77445b5962), {
            contentEditable: null
        }),
        (0, $3e88191b87395c2e$export$7c74af9ea11c2716)((0, $8ebc39becbfbdd8f$export$17469cfcef8e877c), {
            setOptions: {
                tag: (0, $3e88191b87395c2e$export$7581001a764add86)
            },
            updateOptions: {
                tag: (0, $3e88191b87395c2e$export$7581001a764add86)
            }
        })
    ];
    if (parentEditor) dependencies.push((0, $3e88191b87395c2e$export$7c74af9ea11c2716)((0, $8ebc39becbfbdd8f$export$ae64beb000178cb6), {
        $getParentEditor: ()=>parentEditor,
        inheritEditableFromParent: true
    }));
    if (historyMode === "nested-shared") dependencies.push((0, $08b351797623b941$export$264e332fe709f891));
    else if (historyMode === "root-shared" || historyMode === "nested-external") {
        if (!historyState) throw new Error(`${historyMode} requires a historyState`);
        dependencies.push($e4b4032c9b34afa3$var$externalHistoryExtension(historyState));
    } else if (historyMode === "table-local") dependencies.push((0, $3e88191b87395c2e$export$7c74af9ea11c2716)((0, $08b351797623b941$export$28f798955ffac32a), {
        disabled: false
    }));
    const editorExtension = (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
        name: name,
        namespace: namespace,
        // InitialStateExtension already declares Lexical's built-ins. Filtering
        // them here also prevents Vite's optimized extension bundle from seeing
        // the same built-in constructor through two module facades.
        nodes: nodes == null ? void 0 : nodes.filter((node)=>!$e4b4032c9b34afa3$var$extensionBuiltinNodes.has(node)),
        theme: theme,
        editable: editable,
        $initialEditorState: initialEditorState,
        onError: onError,
        dependencies: dependencies
    });
    const editor = (0, $8ebc39becbfbdd8f$export$f19a95efed97f38c)(editorExtension);
    const historyDependency = (0, $8ebc39becbfbdd8f$export$1a203010713403e8)(editor, (0, $08b351797623b941$export$28f798955ffac32a).name);
    const editorHistoryState = historyDependency == null ? void 0 : historyDependency.output.historyState.value;
    if (editorHistoryState) $e4b4032c9b34afa3$var$editorHistoryStates.set(editor, editorHistoryState);
    if (editorHistoryState) {
        if (!$e4b4032c9b34afa3$var$meaningfulHistoryEntries.has(editorHistoryState)) $e4b4032c9b34afa3$var$meaningfulHistoryEntries.set(editorHistoryState, editorHistoryState.current);
    }
    const unregisterHistoryFocusGuard = editorHistoryState ? editor.registerUpdateListener(({ dirtyElements: dirtyElements, dirtyLeaves: dirtyLeaves, tags: tags })=>{
        const current = editorHistoryState.current;
        if (tags.has((0, $3e88191b87395c2e$export$7581001a764add86))) {
            $e4b4032c9b34afa3$var$meaningfulHistoryEntries.set(editorHistoryState, current);
            return;
        }
        if (dirtyElements.size > 0 || dirtyLeaves.size > 0) {
            $e4b4032c9b34afa3$var$meaningfulHistoryEntries.set(editorHistoryState, current);
            return;
        }
        const meaningfulEntry = $e4b4032c9b34afa3$var$meaningfulHistoryEntries.get(editorHistoryState);
        if ((current == null ? void 0 : current.editor) === editor && meaningfulEntry && meaningfulEntry.editor !== editor) {
            editorHistoryState.undoStack.push((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, meaningfulEntry));
            editorHistoryState.redoStack = [];
            editor.dispatchCommand((0, $3e88191b87395c2e$export$9fd9dd31dd6ebdf5), true);
            editor.dispatchCommand((0, $3e88191b87395c2e$export$e36aacf84f559bb3), false);
            $e4b4032c9b34afa3$var$meaningfulHistoryEntries.set(editorHistoryState, current);
        } else $e4b4032c9b34afa3$var$meaningfulHistoryEntries.set(editorHistoryState, current);
    }) : ()=>void 0;
    const availabilityTimers = /* @__PURE__ */ new Set();
    const unregisterHistoryAvailability = editorHistoryState ? editor.registerCommand((0, $3e88191b87395c2e$export$cafe35f35e77bf56), ()=>{
        const timer = setTimeout(()=>{
            availabilityTimers.delete(timer);
            editor.dispatchCommand((0, $3e88191b87395c2e$export$9fd9dd31dd6ebdf5), editorHistoryState.undoStack.length > 0);
            editor.dispatchCommand((0, $3e88191b87395c2e$export$e36aacf84f559bb3), editorHistoryState.redoStack.length > 0);
        });
        availabilityTimers.add(timer);
        return false;
    }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)) : ()=>void 0;
    const dispose = editor.dispose.bind(editor);
    let disposed = false;
    editor.dispose = ()=>{
        if (disposed) return;
        disposed = true;
        availabilityTimers.forEach(clearTimeout);
        availabilityTimers.clear();
        unregisterHistoryAvailability();
        unregisterHistoryFocusGuard();
        dispose();
    };
    if (historyMode === "root-shared") $e4b4032c9b34afa3$var$editorsWithSharedHistory.add(editor);
    return editor;
}
function $e4b4032c9b34afa3$export$e71c1dbab21aecb1(editor) {
    return $e4b4032c9b34afa3$var$editorsWithSharedHistory.has(editor);
}
function $e4b4032c9b34afa3$export$d93af48b194c8f4f(editor, historyState) {
    return $e4b4032c9b34afa3$var$editorHistoryStates.get(editor) === historyState;
}


const $5a7e051e41645429$export$6fe69bb678b4acec = (0, $3e88191b87395c2e$export$8d4021544bdece00)("NESTED_EDITOR_UPDATED_COMMAND");
const $5a7e051e41645429$export$1224068c50c179e8 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null);
const $5a7e051e41645429$export$e02bd6a7b04ae431 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null);
const $5a7e051e41645429$export$3bb9950b3162bfb8 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)("");
const $5a7e051e41645429$export$f59a16022f9259bc = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(true);
const $5a7e051e41645429$export$73e7ec35cfb5ca78 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(false, (r)=>{
    r.sub(r.pipe($5a7e051e41645429$export$73e7ec35cfb5ca78, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($5a7e051e41645429$export$1224068c50c179e8)), ([readOnly, rootEditor])=>{
        rootEditor == null || rootEditor.setEditable(!readOnly);
    });
});
const $5a7e051e41645429$export$a6367416e8cdc2d3 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)("");
const $5a7e051e41645429$export$58916d0c91dd34f8 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(false);
const $5a7e051e41645429$export$516bc5c6e1b0201d = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(false);
const $5a7e051e41645429$export$f2a971b630263584 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(0);
const $5a7e051e41645429$export$583006615bf4a06f = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null);
const $5a7e051e41645429$export$84d99ac953d920a3 = (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r)=>{
    r.link(r.pipe($5a7e051e41645429$export$583006615bf4a06f, (0, $0a163704d09ac3e9$export$3dea766d36a8935f)((e)=>e !== null)), $5a7e051e41645429$export$84d99ac953d920a3);
});
const $5a7e051e41645429$export$d5cd67a91c3cfefd = (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r)=>{
    r.sub(r.pipe($5a7e051e41645429$export$d5cd67a91c3cfefd, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($5a7e051e41645429$export$e02bd6a7b04ae431)), ([format, theEditor])=>{
        theEditor == null || theEditor.dispatchCommand((0, $3e88191b87395c2e$export$85443a1a9543f043), format);
    });
});
const $5a7e051e41645429$export$dc45e04d1b3012d9 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null, (r)=>{
    r.sub(r.pipe($5a7e051e41645429$export$dc45e04d1b3012d9, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($5a7e051e41645429$export$e02bd6a7b04ae431)), ([selection, theEditor])=>{
        if (!selection || !theEditor) return;
        const anchorNode = selection.anchor.getNode();
        let element = anchorNode.getKey() === "root" ? anchorNode : (0, $3e88191b87395c2e$export$57101724ca611500)(anchorNode, (e)=>{
            const parent = e.getParent();
            return parent !== null && (0, $3e88191b87395c2e$export$6f851a24c61146af)(parent);
        });
        element !== null && element !== void 0 ? element : element = anchorNode.getTopLevelElementOrThrow();
        const elementKey = element.getKey();
        const elementDOM = theEditor.getElementByKey(elementKey);
        if (elementDOM !== null) {
            const blockType = (0, $cc8bb3cdc37e8788$export$78b6c84a5d5b8b31)(element) ? element.getTag() : element.getType();
            r.pub($5a7e051e41645429$export$24b7b07377f26bbc, blockType);
        }
    });
});
const $5a7e051e41645429$export$d5e62b229d91a037 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)("");
const $5a7e051e41645429$export$15fbbcd8af87566a = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)("");
const $5a7e051e41645429$export$5f39e1f28ec75b79 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(false);
const $5a7e051e41645429$var$markdownSignal$ = (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r)=>{
    r.link($5a7e051e41645429$export$15fbbcd8af87566a, $5a7e051e41645429$var$markdownSignal$);
    r.sub($5a7e051e41645429$export$d5e62b229d91a037, (md)=>{
        r.pubIn({
            [$5a7e051e41645429$export$5f39e1f28ec75b79]: true,
            [$5a7e051e41645429$export$15fbbcd8af87566a]: md
        });
    });
});
const $5a7e051e41645429$var$mutableMarkdownSignal$ = (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r)=>{
    r.link(r.pipe($5a7e051e41645429$var$markdownSignal$, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($5a7e051e41645429$export$db141f3fd61f4d17), (0, $0a163704d09ac3e9$export$3dea766d36a8935f)(([, muted])=>!muted), (0, $0a163704d09ac3e9$export$871de8747c9eaa88)(([value])=>value)), $5a7e051e41645429$var$mutableMarkdownSignal$);
}, true);
const $5a7e051e41645429$export$71d47a1889ca3697 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$56746f0cd199e4a0 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$55810e85945f5418 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$da3e00c99d6c5a44 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$991b374d185bab8d = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$732b150dcf602c0d = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$f6ad78facb90fcf8 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)({});
const $5a7e051e41645429$export$88d0810293b8762a = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(false);
const $5a7e051e41645429$export$f4f33684797bd01d = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$753a63599172396 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$13b405bc957e5ec9 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$f738aae4ba2dfef1 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)("");
const $5a7e051e41645429$export$48bc1afe38b0f854 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null);
const $5a7e051e41645429$export$f3a508116d36fbb8 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null);
const $5a7e051e41645429$export$276eaa1d26354af6 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null);
const $5a7e051e41645429$export$7544518b8e31b27e = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$56746f0cd199e4a0);
const $5a7e051e41645429$export$bab06f5ebfbf5c23 = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$71d47a1889ca3697);
const $5a7e051e41645429$export$e8901c15ed1d713c = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$55810e85945f5418);
const $5a7e051e41645429$export$e37abcf8e1dbb715 = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$da3e00c99d6c5a44);
const $5a7e051e41645429$export$4c7dc64aa0c7faf = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$991b374d185bab8d);
const $5a7e051e41645429$export$f47abfccac67a6f3 = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$732b150dcf602c0d);
const $5a7e051e41645429$export$db141f3fd61f4d17 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(false);
const $5a7e051e41645429$export$b7bf079bbabb7499 = (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r)=>{
    r.sub(r.pipe($5a7e051e41645429$export$b7bf079bbabb7499, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($5a7e051e41645429$export$15fbbcd8af87566a, $5a7e051e41645429$export$1224068c50c179e8, $5a7e051e41645429$export$516bc5c6e1b0201d), (0, $0a163704d09ac3e9$export$3dea766d36a8935f)(([newMarkdown, oldMarkdown])=>{
        return newMarkdown.trim() !== oldMarkdown.trim();
    })), ([theNewMarkdownValue, , editor, inFocus])=>{
        r.pub($5a7e051e41645429$export$db141f3fd61f4d17, true);
        editor == null || editor.update(()=>{
            (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)().clear();
            $5a7e051e41645429$var$tryImportingMarkdown(r, (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), theNewMarkdownValue);
            if (!inFocus) (0, $3e88191b87395c2e$export$2aad78c37810bca9)(null);
            else editor.focus();
        }, {
            onUpdate: ()=>{
                r.pub($5a7e051e41645429$export$db141f3fd61f4d17, false);
            }
        });
    });
});
const $5a7e051e41645429$export$2f89b64ed7c4dd38 = (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r)=>{
    r.sub(r.pipe($5a7e051e41645429$export$2f89b64ed7c4dd38, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($5a7e051e41645429$export$e02bd6a7b04ae431, $5a7e051e41645429$export$516bc5c6e1b0201d)), ([markdownToInsert, editor, inFocus])=>{
        editor == null || editor.update(()=>{
            const selection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if (selection !== null) {
                const importPoint = {
                    children: [],
                    append (node) {
                        this.children.push(node);
                    },
                    getType () {
                        return selection.getNodes()[0].getType();
                    }
                };
                $5a7e051e41645429$var$tryImportingMarkdown(r, importPoint, markdownToInsert);
                (0, $3e88191b87395c2e$export$d773017360b45449)(importPoint.children);
            }
            if (!inFocus) (0, $3e88191b87395c2e$export$2aad78c37810bca9)(null);
            else editor.focus();
        });
    });
});
function $5a7e051e41645429$var$rebind() {
    return (0, $0a163704d09ac3e9$export$c87d910e63d22ed6)((teardowns, [subs, activeEditorValue])=>{
        teardowns.forEach((teardown)=>{
            if (!teardown) throw new Error("You have a subscription that does not return a teardown");
            teardown();
        });
        return activeEditorValue ? subs.map((s)=>s(activeEditorValue)) : [];
    }, []);
}
const $5a7e051e41645429$export$bbe0055b1b3bac82 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null);
const $5a7e051e41645429$export$4e81543145cd4c9b = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([], (r)=>{
    r.pipe(r.combine($5a7e051e41645429$export$4e81543145cd4c9b, $5a7e051e41645429$export$e02bd6a7b04ae431), $5a7e051e41645429$var$rebind());
});
const $5a7e051e41645429$export$70ec4f31fd5d6474 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([], (r)=>{
    r.pipe(r.combine($5a7e051e41645429$export$70ec4f31fd5d6474, $5a7e051e41645429$export$1224068c50c179e8), $5a7e051e41645429$var$rebind());
});
const $5a7e051e41645429$export$d7f1aaab3c44fbe7 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null, (0, $0bde9de2375dfc26$export$8793edee2d425525), (prev, next)=>{
    return Boolean(prev && next && prev.editorRef === next.editorRef);
});
const $5a7e051e41645429$export$ebb121d1a18d247c = (0, $0a163704d09ac3e9$export$8210dfe1863c478)();
const $5a7e051e41645429$export$4fd464b2b09e1c4d = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)((name)=>{
    throw new Error(`No icon component for ${name}`);
});
function $5a7e051e41645429$export$51ddcf3d4dbea317(cell$, init) {
    return (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r, sig$)=>{
        r.changeWith(cell$, sig$, (values, newValue)=>{
            if (!Array.isArray(newValue)) newValue = [
                newValue
            ];
            let result = values;
            for (const v of newValue)if (!values.includes(v)) result = [
                ...result,
                v
            ];
            return result;
        });
        init == null || init(r, sig$);
    });
}
function $5a7e051e41645429$var$handleSelectionChange(r) {
    const selection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(selection)) r.pubIn({
        [$5a7e051e41645429$export$dc45e04d1b3012d9]: selection,
        [$5a7e051e41645429$export$f2a971b630263584]: selection.format
    });
}
const $5a7e051e41645429$export$ba76d7a55f59a79d = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$70ec4f31fd5d6474, (r, sig$)=>{
    r.pub(sig$, [
        (rootEditor)=>{
            return rootEditor.registerCommand((0, $3e88191b87395c2e$export$e396fef71d2b56e5), (_, theActiveEditor)=>{
                r.pubIn({
                    [$5a7e051e41645429$export$e02bd6a7b04ae431]: theActiveEditor,
                    [$5a7e051e41645429$export$516bc5c6e1b0201d]: true
                });
                if (theActiveEditor._parentEditor === null) theActiveEditor.getEditorState().read(()=>{
                    r.pub($5a7e051e41645429$export$d7f1aaab3c44fbe7, {
                        rootNode: (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(),
                        editorType: "lexical",
                        editorRef: theActiveEditor
                    });
                });
                $5a7e051e41645429$var$handleSelectionChange(r);
                return false;
            }, (0, $3e88191b87395c2e$export$6afdf194f304e546));
        },
        // Export handler
        (rootEditor)=>{
            return rootEditor.registerUpdateListener(({ dirtyElements: dirtyElements, dirtyLeaves: dirtyLeaves, editorState: editorState })=>{
                const err = r.getValue($5a7e051e41645429$export$583006615bf4a06f);
                if (err !== null) return;
                if (dirtyElements.size === 0 && dirtyLeaves.size === 0) return;
                let theNewMarkdownValue;
                editorState.read(()=>{
                    const lastChild = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)().getLastChild();
                    if (lastChild instanceof (0, $3e88191b87395c2e$export$8244b9efe04488e)) rootEditor.update(()=>{
                        (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)().append((0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)());
                    }, {
                        discrete: true
                    });
                    theNewMarkdownValue = (0, $d5a351410f7bf8d8$export$e9f30850a0a93090)({
                        root: (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(),
                        visitors: r.getValue($5a7e051e41645429$export$991b374d185bab8d),
                        jsxComponentDescriptors: r.getValue($5a7e051e41645429$export$f4f33684797bd01d),
                        toMarkdownExtensions: r.getValue($5a7e051e41645429$export$732b150dcf602c0d),
                        toMarkdownOptions: r.getValue($5a7e051e41645429$export$f6ad78facb90fcf8),
                        jsxIsAvailable: r.getValue($5a7e051e41645429$export$88d0810293b8762a)
                    });
                });
                r.pub($5a7e051e41645429$export$15fbbcd8af87566a, theNewMarkdownValue.trim());
                r.pub($5a7e051e41645429$export$5f39e1f28ec75b79, false);
            });
        },
        (rootEditor)=>{
            return rootEditor.registerCommand((0, $3e88191b87395c2e$export$cafe35f35e77bf56), ()=>{
                r.pub($5a7e051e41645429$export$516bc5c6e1b0201d, true);
                return false;
            }, (0, $3e88191b87395c2e$export$6afdf194f304e546));
        }
    ]);
});
const $5a7e051e41645429$export$95585712f951d614 = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$4e81543145cd4c9b, (r, sig$)=>{
    r.pub(sig$, [
        (editor)=>{
            return editor.registerUpdateListener(({ editorState: editorState })=>{
                editorState.read(()=>{
                    $5a7e051e41645429$var$handleSelectionChange(r);
                });
            });
        },
        (editor)=>{
            return editor.registerCommand((0, $3e88191b87395c2e$export$4b6d457d076906ac), (payload)=>{
                var _a;
                const theRootEditor = r.getValue($5a7e051e41645429$export$1224068c50c179e8);
                if (theRootEditor) {
                    const movingOutside = !((_a = theRootEditor.getRootElement()) == null ? void 0 : _a.contains(payload.relatedTarget));
                    if (movingOutside) r.pubIn({
                        [$5a7e051e41645429$export$516bc5c6e1b0201d]: false,
                        [$5a7e051e41645429$export$ebb121d1a18d247c]: payload
                    });
                }
                return false;
            }, (0, $3e88191b87395c2e$export$6afdf194f304e546));
        }
    ]);
});
function $5a7e051e41645429$var$tryImportingMarkdown(r, node, markdownValue) {
    try {
        (0, $18742b91d99345f0$export$616d8c68001e2b04)({
            root: node,
            visitors: r.getValue($5a7e051e41645429$export$71d47a1889ca3697),
            mdastExtensions: r.getValue($5a7e051e41645429$export$da3e00c99d6c5a44),
            markdown: markdownValue,
            syntaxExtensions: r.getValue($5a7e051e41645429$export$55810e85945f5418),
            jsxComponentDescriptors: r.getValue($5a7e051e41645429$export$f4f33684797bd01d),
            directiveDescriptors: r.getValue($5a7e051e41645429$export$753a63599172396),
            codeBlockEditorDescriptors: r.getValue($5a7e051e41645429$export$13b405bc957e5ec9),
            defaultCodeBlockLanguage: r.getValue($5a7e051e41645429$export$f738aae4ba2dfef1)
        });
        r.pub($5a7e051e41645429$export$583006615bf4a06f, null);
    } catch (e) {
        if (e instanceof (0, $18742b91d99345f0$export$b81de2290dcdbb74) || e instanceof (0, $18742b91d99345f0$export$4cbd36ff09193701)) r.pubIn({
            [$5a7e051e41645429$export$15fbbcd8af87566a]: markdownValue,
            [$5a7e051e41645429$export$583006615bf4a06f]: {
                error: e.message,
                source: markdownValue
            }
        });
        else throw e;
    }
}
const $5a7e051e41645429$export$400fce55e37924dc = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$d120e029a7b56e15 = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$400fce55e37924dc);
const $5a7e051e41645429$export$2e1af8e29683a3bf = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$b3a108edd2bc7739 = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$2e1af8e29683a3bf);
const $5a7e051e41645429$export$9384cdc215a3fb1e = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$e7146217b130b170 = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$9384cdc215a3fb1e);
const $5a7e051e41645429$export$a35fdf2ea45d077c = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$a5f6d057a92bd7e1 = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$a35fdf2ea45d077c);
const $5a7e051e41645429$export$621d5872b48fc6c0 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$16cecaa0e6290978 = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$621d5872b48fc6c0);
const $5a7e051e41645429$export$2d0720610f038210 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$4195d00b0b92e4c = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$2d0720610f038210);
const $5a7e051e41645429$export$ff9202ce34428c67 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(false, (r)=>{
    r.link(r.pipe($5a7e051e41645429$export$e02bd6a7b04ae431, (0, $0a163704d09ac3e9$export$871de8747c9eaa88)((editor)=>{
        var _a, _b;
        var _ref;
        return [
            "td",
            "th"
        ].includes((_ref = (_b = (_a = editor == null ? void 0 : editor.getRootElement()) == null ? void 0 : _a.parentNode) == null ? void 0 : _b.nodeName.toLowerCase()) !== null && _ref !== void 0 ? _ref : "");
    })), $5a7e051e41645429$export$ff9202ce34428c67);
});
const $5a7e051e41645429$export$7ba6db7b3840296a = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)((0, $08b351797623b941$export$feb7d16028f7b237)());
const $5a7e051e41645429$export$24b7b07377f26bbc = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)("");
const $5a7e051e41645429$export$6eb0bf1543f63635 = (0, $0a163704d09ac3e9$export$8210dfe1863c478)();
const $5a7e051e41645429$export$eb79365488114399 = (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r)=>{
    r.sub(r.pipe($5a7e051e41645429$export$eb79365488114399, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($5a7e051e41645429$export$e02bd6a7b04ae431)), ([factory, editor])=>{
        editor == null || editor.update(()=>{
            const selection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(selection)) {
                (0, $016075a3cb2a2f02$export$b298cd49550a7619)(selection, factory);
                setTimeout(()=>{
                    editor.focus();
                });
            }
        });
    });
});
const $5a7e051e41645429$export$d0d524a47378923b = (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r)=>{
    r.sub(r.pipe($5a7e051e41645429$export$d0d524a47378923b, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($5a7e051e41645429$export$e02bd6a7b04ae431)), ([nodeFactory, theEditor])=>{
        theEditor == null || theEditor.focus(()=>{
            theEditor.getEditorState().read(()=>{
                const selection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(selection)) {
                    theEditor.update(()=>{
                        const node = nodeFactory();
                        if (node.isInline()) {
                            (0, $3e88191b87395c2e$export$d773017360b45449)([
                                node
                            ]);
                            if ((0, $3e88191b87395c2e$export$6f851a24c61146af)(node.getParentOrThrow())) (0, $74849711df60ce24$export$4de868a07eee3cf0)(node, (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)).selectEnd();
                        } else (0, $74849711df60ce24$export$4ec669795a8ed6b)(node);
                        setTimeout(()=>{
                            if ("select" in node && typeof node.select === "function") node.select();
                        });
                    });
                    setTimeout(()=>{
                        theEditor.dispatchCommand($5a7e051e41645429$export$6fe69bb678b4acec, void 0);
                    });
                }
            });
        }, {
            defaultSelection: "rootEnd"
        });
    });
});
const $5a7e051e41645429$export$a65e0fe1b8d07b08 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)("rich-text", (r)=>{
    function currentNextViewMode() {
        return (0, $0a163704d09ac3e9$export$c87d910e63d22ed6)((prev, next)=>{
            return {
                current: prev.next,
                next: next
            };
        }, {
            current: "rich-text",
            next: "rich-text"
        });
    }
    r.sub(r.pipe($5a7e051e41645429$export$a65e0fe1b8d07b08, currentNextViewMode(), (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($5a7e051e41645429$export$db45a26e26d2433c)), ([{ current: current }, markdownSourceFromEditor])=>{
        if (current === "source" || current === "diff") r.pub($5a7e051e41645429$export$b7bf079bbabb7499, markdownSourceFromEditor);
    });
    r.sub(r.pipe($5a7e051e41645429$export$a65e0fe1b8d07b08, currentNextViewMode(), (0, $0a163704d09ac3e9$export$3dea766d36a8935f)((mode)=>mode.current === "rich-text"), (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($5a7e051e41645429$export$e02bd6a7b04ae431)), ([, editor])=>{
        editor == null || editor.dispatchCommand($5a7e051e41645429$export$6fe69bb678b4acec, void 0);
    });
});
const $5a7e051e41645429$export$db45a26e26d2433c = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)("", (r)=>{
    r.link($5a7e051e41645429$export$15fbbcd8af87566a, $5a7e051e41645429$export$db45a26e26d2433c);
    r.link($5a7e051e41645429$export$db45a26e26d2433c, $5a7e051e41645429$var$markdownSignal$);
}, true);
const $5a7e051e41645429$export$5cb858372d2eb3cc = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $5a7e051e41645429$export$ffc48b904d2782f7 = $5a7e051e41645429$export$51ddcf3d4dbea317($5a7e051e41645429$export$5cb858372d2eb3cc);
const $5a7e051e41645429$export$7c852df153e518d = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(()=>{
    throw new Error("No translation function provided");
});
const $5a7e051e41645429$export$253f20e33eed9016 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)((0, $21f2e650573058ac$export$8b7e4ddc5e9bc24a));
const $5a7e051e41645429$export$71ab138dd170c35 = (0, $180ae8514eec30ee$export$a1bf852fe7c1a323)({
    init (r, params) {
        var _ref;
        const initialMarkdown = (_ref = params == null ? void 0 : params.initialMarkdown) !== null && _ref !== void 0 ? _ref : "";
        r.register($5a7e051e41645429$export$ba76d7a55f59a79d);
        r.register($5a7e051e41645429$export$95585712f951d614);
        r.register($5a7e051e41645429$var$markdownSignal$);
        r.register($5a7e051e41645429$export$db45a26e26d2433c);
        var _ref1;
        r.pubIn({
            [$5a7e051e41645429$export$d5e62b229d91a037]: (params == null ? void 0 : params.trim) ? initialMarkdown.trim() : initialMarkdown,
            [$5a7e051e41645429$export$4fd464b2b09e1c4d]: params == null ? void 0 : params.iconComponentFor,
            [$5a7e051e41645429$export$bab06f5ebfbf5c23]: [
                (0, $fede923fafaf71cb$export$1a62e20af8363672),
                (0, $dbb72ce4f379d305$export$69a5d1a919efc2fc),
                (0, $60dc02a38c8c295a$export$c0afffa0cceae669),
                (0, $221e4716b3e6afd7$export$a99d4e452656bd84),
                ...(0, $c5d55c511ef6792a$export$8fb2942f2f386a7d)
            ],
            [$5a7e051e41645429$export$7544518b8e31b27e]: [
                (0, $3e88191b87395c2e$export$e94424771493b912),
                (0, $3e88191b87395c2e$export$f0a25ea3087686aa),
                (0, $8cd574f4b8bf10a0$export$335a9cc096917391)
            ],
            [$5a7e051e41645429$export$4c7dc64aa0c7faf]: [
                (0, $7dd54374c8b08857$export$e15acc840927bc89),
                (0, $336068f3f0cb3b92$export$6cf15d817cc544bd),
                (0, $c367a53735ab2c0b$export$5b3da66f7d3254c4),
                (0, $1fde141512d355a3$export$cc3dd421a8536734),
                (0, $e0cdfc832ff5f384$export$905c6e2ade14aaff)
            ],
            [$5a7e051e41645429$export$3bb9950b3162bfb8]: params == null ? void 0 : params.contentEditableClassName,
            [$5a7e051e41645429$export$f59a16022f9259bc]: params == null ? void 0 : params.spellCheck,
            [$5a7e051e41645429$export$f6ad78facb90fcf8]: params == null ? void 0 : params.toMarkdownOptions,
            [$5a7e051e41645429$export$58916d0c91dd34f8]: params == null ? void 0 : params.autoFocus,
            [$5a7e051e41645429$export$a6367416e8cdc2d3]: params == null ? void 0 : params.placeholder,
            [$5a7e051e41645429$export$73e7ec35cfb5ca78]: params == null ? void 0 : params.readOnly,
            [$5a7e051e41645429$export$7c852df153e518d]: params == null ? void 0 : params.translation,
            [$5a7e051e41645429$export$7ba6db7b3840296a]: (0, $08b351797623b941$export$feb7d16028f7b237)(),
            [$5a7e051e41645429$export$e37abcf8e1dbb715]: [
                (0, $09e40cfc169f6d05$export$34d64e709dd0b9bb)(),
                (0, $9a247d4cbfd44f10$export$2f57a9c081873825)
            ],
            [$5a7e051e41645429$export$e8901c15ed1d713c]: [
                (0, $0f83fff5c7ab5a13$export$8bbec8ea1400a00e)(),
                (0, $bb28592d736320fe$export$26b46f3c4275b535)()
            ],
            [$5a7e051e41645429$export$f47abfccac67a6f3]: [
                (0, $f743b524b3e33495$export$276c5dc6e007d744)(),
                (0, $09e40cfc169f6d05$export$1632835bd2c84956)(),
                (0, $9a247d4cbfd44f10$export$994e8fec64bf872f)
            ],
            [$5a7e051e41645429$export$253f20e33eed9016]: (_ref1 = params == null ? void 0 : params.lexicalTheme) !== null && _ref1 !== void 0 ? _ref1 : (0, $21f2e650573058ac$export$8b7e4ddc5e9bc24a)
        });
        r.singletonSub($5a7e051e41645429$export$84d99ac953d920a3, params == null ? void 0 : params.onError);
        r.singletonSub($5a7e051e41645429$var$mutableMarkdownSignal$, (value)=>{
            params == null || params.onChange(value, r.getValue($5a7e051e41645429$export$5f39e1f28ec75b79));
        });
        r.singletonSub($5a7e051e41645429$export$ebb121d1a18d247c, params == null ? void 0 : params.onBlur);
        if (!(params == null ? void 0 : params.suppressHtmlProcessing)) r.pubIn({
            [$5a7e051e41645429$export$e37abcf8e1dbb715]: [
                (0, $f743b524b3e33495$export$49ba96b4164e772f)(),
                (0, $bb65379180b682ea$export$261df8223e720ac7)()
            ],
            [$5a7e051e41645429$export$e8901c15ed1d713c]: [
                (0, $f76040dfe9471610$export$e775b18258bc745d)(),
                (0, $537b4dcfe0c6a284$export$629c79f5885bcbb0)(),
                (0, $bb65379180b682ea$export$4a34f930e789283c)
            ],
            [$5a7e051e41645429$export$bab06f5ebfbf5c23]: (0, $502b1cab6f6d05b5$export$3de796e6f648521e)
        });
    },
    postInit (r, params) {
        var _ref, _ref1;
        const newEditor = (0, $e4b4032c9b34afa3$export$dbb611ce42f3fd01)({
            name: "@mdxeditor/root",
            editable: (params == null ? void 0 : params.readOnly) !== true,
            namespace: (_ref = params == null ? void 0 : params.lexicalEditorNamespace) !== null && _ref !== void 0 ? _ref : "MDXEditor",
            nodes: [
                ...r.getValue($5a7e051e41645429$export$56746f0cd199e4a0),
                ...(_ref1 = params == null ? void 0 : params.additionalLexicalNodes) !== null && _ref1 !== void 0 ? _ref1 : []
            ],
            theme: r.getValue($5a7e051e41645429$export$253f20e33eed9016),
            historyMode: (params == null ? void 0 : params.suppressSharedHistory) ? "none" : "root-shared",
            historyState: r.getValue($5a7e051e41645429$export$7ba6db7b3840296a),
            initialEditorState: (params == null ? void 0 : params.editorState) === null ? null : ()=>{
                var _ref;
                const markdown = (_ref = params == null ? void 0 : params.initialMarkdown.trim()) !== null && _ref !== void 0 ? _ref : "";
                $5a7e051e41645429$var$tryImportingMarkdown(r, (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(), markdown);
            }
        });
        (0, $62399e61d90f83a8$export$2385055ccde32583)(r, ()=>{
            newEditor.dispose();
        });
        const autoFocusValue = params == null ? void 0 : params.autoFocus;
        if ((params == null ? void 0 : params.editorState) !== null && autoFocusValue) {
            const autoFocusTimer = setTimeout(()=>{
                var _autoFocusValue_defaultSelection;
                newEditor.focus((0, $0bde9de2375dfc26$export$8793edee2d425525), {
                    defaultSelection: autoFocusValue === true ? "rootStart" : (_autoFocusValue_defaultSelection = autoFocusValue.defaultSelection) !== null && _autoFocusValue_defaultSelection !== void 0 ? _autoFocusValue_defaultSelection : "rootStart"
                });
            });
            (0, $62399e61d90f83a8$export$2385055ccde32583)(r, ()=>{
                clearTimeout(autoFocusTimer);
            });
        }
        r.pub($5a7e051e41645429$export$1224068c50c179e8, newEditor);
        r.pub($5a7e051e41645429$export$e02bd6a7b04ae431, newEditor);
    },
    update (realm, params) {
        realm.pubIn({
            [$5a7e051e41645429$export$3bb9950b3162bfb8]: params == null ? void 0 : params.contentEditableClassName,
            [$5a7e051e41645429$export$f59a16022f9259bc]: params == null ? void 0 : params.spellCheck,
            [$5a7e051e41645429$export$f6ad78facb90fcf8]: params == null ? void 0 : params.toMarkdownOptions,
            [$5a7e051e41645429$export$58916d0c91dd34f8]: params == null ? void 0 : params.autoFocus,
            [$5a7e051e41645429$export$a6367416e8cdc2d3]: params == null ? void 0 : params.placeholder,
            [$5a7e051e41645429$export$73e7ec35cfb5ca78]: params == null ? void 0 : params.readOnly
        });
        realm.singletonSub($5a7e051e41645429$var$mutableMarkdownSignal$, (value)=>{
            params == null || params.onChange(value, realm.getValue($5a7e051e41645429$export$5f39e1f28ec75b79));
        });
        realm.singletonSub($5a7e051e41645429$export$ebb121d1a18d247c, params == null ? void 0 : params.onBlur);
        realm.singletonSub($5a7e051e41645429$export$84d99ac953d920a3, params == null ? void 0 : params.onError);
    }
});
function $5a7e051e41645429$export$9fc83ad70ead8663() {
    return (0, $0a163704d09ac3e9$export$329730cc601f60)($5a7e051e41645429$export$7c852df153e518d);
}






const $b735d1bc59b95bee$export$37d2f1e98a187e61 = typeof window !== "undefined" && typeof window.document.createElement !== "undefined";
const $b735d1bc59b95bee$export$d093bd80dddd0842 = $b735d1bc59b95bee$export$37d2f1e98a187e61 && (()=>{
    var _a;
    const platform = (_a = navigator.userAgentData) == null ? void 0 : _a.platform;
    return platform ? /mac/i.test(platform) : /Mac|iPod|iPhone|iPad/.test(navigator.userAgent);
})();
function $b735d1bc59b95bee$export$c7191fa911d5ed19(metaKey, ctrlKey) {
    if ($b735d1bc59b95bee$export$d093bd80dddd0842) return metaKey;
    return ctrlKey;
}




const $21e97305d5ced80d$export$7c44169772792420 = {
    testLexicalNode: (0, $cc8bb3cdc37e8788$export$78b6c84a5d5b8b31),
    visitLexicalNode: ({ lexicalNode: lexicalNode, actions: actions })=>{
        const depth = parseInt(lexicalNode.getTag()[1], 10);
        actions.addAndStepInto("heading", {
            depth: depth
        });
    }
};



const $4d6522df99b37833$export$b76b0f5a438464d6 = {
    testNode: "heading",
    visitNode: function({ mdastNode: mdastNode, actions: actions }) {
        actions.addAndStepInto((0, $cc8bb3cdc37e8788$export$29cdf7c75bd686cc)(`h${mdastNode.depth}`));
    }
};


const $852daab51b9c6f82$var$FORMATTING_KEYS = [
    "Digit0",
    "Digit1",
    "Digit2",
    "Digit3",
    "Digit4",
    "Digit5",
    "Digit6"
];
const $852daab51b9c6f82$export$9b3d1bb141d28348 = [
    1,
    2,
    3,
    4,
    5,
    6
];
const $852daab51b9c6f82$var$CODE_TO_HEADING_LEVEL_MAP = {
    Digit1: 1,
    Digit2: 2,
    Digit3: 3,
    Digit4: 4,
    Digit5: 5,
    Digit6: 6
};
const $852daab51b9c6f82$export$ee0d7003bc6d0c60 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)($852daab51b9c6f82$export$9b3d1bb141d28348, (r)=>{
    r.pub((0, $5a7e051e41645429$export$ba76d7a55f59a79d), (theRootEditor)=>{
        return theRootEditor.registerCommand((0, $3e88191b87395c2e$export$61973214e0e18936), (event)=>{
            const { code: code, ctrlKey: ctrlKey, metaKey: metaKey, altKey: altKey } = event;
            if ($852daab51b9c6f82$var$FORMATTING_KEYS.includes(code) && (0, $b735d1bc59b95bee$export$c7191fa911d5ed19)(metaKey, ctrlKey) && altKey) {
                event.preventDefault();
                theRootEditor.update(()=>{
                    if (code === "Digit0") r.pub((0, $5a7e051e41645429$export$eb79365488114399), ()=>(0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)());
                    else {
                        const allowedHeadingLevels = r.getValue($852daab51b9c6f82$export$ee0d7003bc6d0c60);
                        const requestedHeadingLevel = $852daab51b9c6f82$var$CODE_TO_HEADING_LEVEL_MAP[code];
                        if (allowedHeadingLevels.includes(requestedHeadingLevel)) r.pub((0, $5a7e051e41645429$export$eb79365488114399), ()=>(0, $cc8bb3cdc37e8788$export$29cdf7c75bd686cc)(`h${requestedHeadingLevel}`));
                    }
                });
                return true;
            }
            return false;
        }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4));
    });
});
const $852daab51b9c6f82$export$d4b3c65d0fac3a8f = (0, $180ae8514eec30ee$export$a1bf852fe7c1a323)({
    init (realm, params) {
        realm.pubIn({
            [(0, $5a7e051e41645429$export$ffc48b904d2782f7)]: "headings",
            [(0, $5a7e051e41645429$export$bab06f5ebfbf5c23)]: (0, $4d6522df99b37833$export$b76b0f5a438464d6),
            [(0, $5a7e051e41645429$export$7544518b8e31b27e)]: (0, $cc8bb3cdc37e8788$export$90fecd23277fcde2),
            [(0, $5a7e051e41645429$export$4c7dc64aa0c7faf)]: (0, $21e97305d5ced80d$export$7c44169772792420)
        });
        var _ref;
        realm.pub($852daab51b9c6f82$export$ee0d7003bc6d0c60, (_ref = params == null ? void 0 : params.allowedHeadingLevels) !== null && _ref !== void 0 ? _ref : $852daab51b9c6f82$export$9b3d1bb141d28348);
    },
    update (realm, params) {
        var _ref;
        realm.pub($852daab51b9c6f82$export$ee0d7003bc6d0c60, (_ref = params == null ? void 0 : params.allowedHeadingLevels) !== null && _ref !== void 0 ? _ref : $852daab51b9c6f82$export$9b3d1bb141d28348);
    }
});






var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");
var $6d53081595419ec4$var$__defProp = Object.defineProperty;
var $6d53081595419ec4$var$__name = (target, value)=>$6d53081595419ec4$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// src/number.ts
function $6d53081595419ec4$export$7d15b64cf5a3a4c4(value, [min, max]) {
    return Math.min(max, Math.max(min, value));
}
$6d53081595419ec4$var$__name($6d53081595419ec4$export$7d15b64cf5a3a4c4, "clamp");


var $b40b207d83279ebf$var$__defProp = Object.defineProperty;
var $b40b207d83279ebf$var$__name = (target, value)=>$b40b207d83279ebf$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// src/primitive.tsx
var $b40b207d83279ebf$export$71594e8a50f746f4 = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $b40b207d83279ebf$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return /* @__PURE__ */ $b40b207d83279ebf$var$__name(function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 ? void 0 : originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    }, "handleEvent");
}
$b40b207d83279ebf$var$__name($b40b207d83279ebf$export$b9ecd428b558ff10, "composeEventHandlers");
function $b40b207d83279ebf$export$f21a1ffae260145a(element) {
    var _element_ownerDocument;
    if (!$b40b207d83279ebf$export$71594e8a50f746f4) throw new Error("Cannot access window outside of the DOM");
    var _element_ownerDocument_defaultView;
    return (_element_ownerDocument_defaultView = element === null || element === void 0 ? void 0 : (_element_ownerDocument = element.ownerDocument) === null || _element_ownerDocument === void 0 ? void 0 : _element_ownerDocument.defaultView) !== null && _element_ownerDocument_defaultView !== void 0 ? _element_ownerDocument_defaultView : window;
}
$b40b207d83279ebf$var$__name($b40b207d83279ebf$export$f21a1ffae260145a, "getOwnerWindow");
function $b40b207d83279ebf$export$b204af158042fbac(element) {
    if (!$b40b207d83279ebf$export$71594e8a50f746f4) throw new Error("Cannot access document outside of the DOM");
    var _element_ownerDocument;
    return (_element_ownerDocument = element === null || element === void 0 ? void 0 : element.ownerDocument) !== null && _element_ownerDocument !== void 0 ? _element_ownerDocument : document;
}
$b40b207d83279ebf$var$__name($b40b207d83279ebf$export$b204af158042fbac, "getOwnerDocument");
function $b40b207d83279ebf$export$cd4e5573fbe2b576(node, activeDescendant = false) {
    const { activeElement: activeElement } = $b40b207d83279ebf$export$b204af158042fbac(node);
    if (!(activeElement === null || activeElement === void 0 ? void 0 : activeElement.nodeName)) return null;
    if ($b40b207d83279ebf$export$6a12f24039de8f3a(activeElement) && activeElement.contentDocument) return $b40b207d83279ebf$export$cd4e5573fbe2b576(activeElement.contentDocument.body, activeDescendant);
    if (activeDescendant) {
        const id = activeElement.getAttribute("aria-activedescendant");
        if (id) {
            const element = $b40b207d83279ebf$export$b204af158042fbac(activeElement).getElementById(id);
            if (element) return element;
        }
    }
    return activeElement;
}
$b40b207d83279ebf$var$__name($b40b207d83279ebf$export$cd4e5573fbe2b576, "getActiveElement");
function $b40b207d83279ebf$export$6a12f24039de8f3a(element) {
    return element.tagName === "IFRAME";
}
$b40b207d83279ebf$var$__name($b40b207d83279ebf$export$6a12f24039de8f3a, "isFrame");


function $3e8576eccd4c7288$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $d86b59e89b8a0208$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $54af65440e83a537$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $d86b59e89b8a0208$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $3e8576eccd4c7288$export$71511d61b312f219)(receiver, descriptor);
}


function $4dddf84ac518a0ab$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $0a7837cd8c38b609$export$71511d61b312f219(obj, privateMap, value) {
    (0, $4dddf84ac518a0ab$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $0b3c0e0699c28bdc$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $2906a6c695077413$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $d86b59e89b8a0208$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $0b3c0e0699c28bdc$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}






var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");

var $d0e15db24766ddfc$var$__defProp = Object.defineProperty;
var $d0e15db24766ddfc$var$__name = (target, value)=>$d0e15db24766ddfc$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $d0e15db24766ddfc$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = $7fPBF.createContext(defaultContext);
    Context.displayName = rootComponentName + "Context";
    const Provider = /* @__PURE__ */ $d0e15db24766ddfc$var$__name((props)=>{
        const { children: children } = props, context = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
            "children"
        ]);
        const value = $7fPBF.useMemo(()=>context, Object.values(context));
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Context.Provider, {
            value: value,
            children: children
        });
    }, "Provider");
    Provider.displayName = rootComponentName + "Provider";
    function useContext2(consumerName, options = {}) {
        const { optional: optional = false } = options;
        const context = $7fPBF.useContext(Context);
        if (context) return context;
        if (defaultContext !== void 0) return defaultContext;
        if (optional) return void 0;
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    $d0e15db24766ddfc$var$__name(useContext2, "useContext");
    return [
        Provider,
        useContext2
    ];
}
$d0e15db24766ddfc$var$__name($d0e15db24766ddfc$export$fd42f52fd3ae1109, "createContext");
// @__NO_SIDE_EFFECTS__
function $d0e15db24766ddfc$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    function createContext3(rootComponentName, defaultContext) {
        const BaseContext = $7fPBF.createContext(defaultContext);
        BaseContext.displayName = rootComponentName + "Context";
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        const Provider = /* @__PURE__ */ $d0e15db24766ddfc$var$__name((props)=>{
            var _scope_scopeName;
            const { scope: scope, children: children } = props, context = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
                "scope",
                "children"
            ]);
            const Context = (scope === null || scope === void 0 ? void 0 : (_scope_scopeName = scope[scopeName]) === null || _scope_scopeName === void 0 ? void 0 : _scope_scopeName[index]) || BaseContext;
            const value = $7fPBF.useMemo(()=>context, Object.values(context));
            return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }, "Provider");
        Provider.displayName = rootComponentName + "Provider";
        function useContext2(consumerName, scope, options = {}) {
            var _scope_scopeName;
            const { optional: optional = false } = options;
            const Context = (scope === null || scope === void 0 ? void 0 : (_scope_scopeName = scope[scopeName]) === null || _scope_scopeName === void 0 ? void 0 : _scope_scopeName[index]) || BaseContext;
            const context = $7fPBF.useContext(Context);
            if (context) return context;
            if (defaultContext !== void 0) return defaultContext;
            if (optional) return void 0;
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        $d0e15db24766ddfc$var$__name(useContext2, "useContext");
        return [
            Provider,
            useContext2
        ];
    }
    $d0e15db24766ddfc$var$__name(createContext3, "createContext");
    const createScope = /* @__PURE__ */ $d0e15db24766ddfc$var$__name(()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return $7fPBF.createContext(defaultContext);
        });
        return /* @__PURE__ */ $d0e15db24766ddfc$var$__name(function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return $7fPBF.useMemo(()=>({
                    [`__scope${scopeName}`]: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, scope), {
                        [scopeName]: contexts
                    })
                }), [
                scope,
                contexts
            ]);
        }, "useScope");
    }, "createScope");
    createScope.scopeName = scopeName;
    return [
        createContext3,
        $d0e15db24766ddfc$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
$d0e15db24766ddfc$var$__name($d0e15db24766ddfc$export$50c7b4e9d9f19c1, "createContextScope");
function $d0e15db24766ddfc$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope = /* @__PURE__ */ $d0e15db24766ddfc$var$__name(()=>{
        const scopeHooks = scopes.map((createScope2)=>({
                useScope: createScope2(),
                scopeName: createScope2.scopeName
            }));
        return /* @__PURE__ */ $d0e15db24766ddfc$var$__name(function useComposedScopes(overrideScopes) {
            const nextScopes = scopeHooks.reduce((nextScopes2, { useScope: useScope, scopeName: scopeName })=>{
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, nextScopes2, currentScope);
            }, {});
            return $7fPBF.useMemo(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes
                }), [
                nextScopes
            ]);
        }, "useComposedScopes");
    }, "createScope");
    createScope.scopeName = baseScope.scopeName;
    return createScope;
}
$d0e15db24766ddfc$var$__name($d0e15db24766ddfc$var$composeContextScopes, "composeContextScopes");



var $7fPBF = parcelRequire("7fPBF");
var $2d44b7cb84ff0f1c$var$__defProp = Object.defineProperty;
var $2d44b7cb84ff0f1c$var$__name = (target, value)=>$2d44b7cb84ff0f1c$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $2d44b7cb84ff0f1c$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
$2d44b7cb84ff0f1c$var$__name($2d44b7cb84ff0f1c$var$setRef, "setRef");
function $2d44b7cb84ff0f1c$export$43e446d32b3d21af(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = $2d44b7cb84ff0f1c$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup == "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup == "function") cleanup();
                else $2d44b7cb84ff0f1c$var$setRef(refs[i], null);
            }
        };
    };
}
$2d44b7cb84ff0f1c$var$__name($2d44b7cb84ff0f1c$export$43e446d32b3d21af, "composeRefs");
function $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05(...refs) {
    return $7fPBF.useCallback($2d44b7cb84ff0f1c$export$43e446d32b3d21af(...refs), refs);
}
$2d44b7cb84ff0f1c$var$__name($2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05, "useComposedRefs");





var $7fPBF = parcelRequire("7fPBF");

var $089057084dfb92a4$var$__defProp = Object.defineProperty;
var $089057084dfb92a4$var$__name = (target, value)=>$089057084dfb92a4$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $089057084dfb92a4$export$e88b45bda5c13eb9(ownerName) {
    const Slot2 = $7fPBF.forwardRef((props, forwardedRef)=>{
        let { children: children } = props, slotProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
            "children"
        ]);
        let slottableElement = null;
        let hasSlottable = false;
        const newChildren = [];
        if ($089057084dfb92a4$var$isLazyComponent(children) && typeof $089057084dfb92a4$var$use === "function") children = $089057084dfb92a4$var$use(children._payload);
        $7fPBF.Children.forEach(children, (maybeSlottable)=>{
            if ($089057084dfb92a4$var$isSlottable(maybeSlottable)) {
                var _slottableElement_props;
                hasSlottable = true;
                const slottable = maybeSlottable;
                let child = "child" in slottable.props ? slottable.props.child : slottable.props.children;
                if ($089057084dfb92a4$var$isLazyComponent(child) && typeof $089057084dfb92a4$var$use === "function") child = $089057084dfb92a4$var$use(child._payload);
                slottableElement = $089057084dfb92a4$var$getSlottableElementFromSlottable(slottable, child);
                newChildren.push(slottableElement === null || slottableElement === void 0 ? void 0 : (_slottableElement_props = slottableElement.props) === null || _slottableElement_props === void 0 ? void 0 : _slottableElement_props.children);
            } else newChildren.push(maybeSlottable);
        });
        if (slottableElement) slottableElement = $7fPBF.cloneElement(slottableElement, void 0, newChildren);
        else if (// A `Slottable` was found but it didn't resolve to a single element (e.g.
        // it wrapped multiple elements, text, or a render-prop `child` that
        // wasn't an element). Don't fall back to treating the `Slottable` wrapper
        // itself as the slot target — throw a descriptive error below instead.
        !hasSlottable && $7fPBF.Children.count(children) === 1 && $7fPBF.isValidElement(children)) slottableElement = children;
        const slottableElementRef = slottableElement ? $089057084dfb92a4$var$getElementRef(slottableElement) : void 0;
        const composedRef = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, slottableElementRef);
        if (!slottableElement) {
            if (children || children === 0) throw new Error(hasSlottable ? $089057084dfb92a4$var$createSlottableError(ownerName) : $089057084dfb92a4$var$createSlotError(ownerName));
            return children;
        }
        var _slottableElement_props;
        const mergedProps = $089057084dfb92a4$var$mergeProps(slotProps, (_slottableElement_props = slottableElement.props) !== null && _slottableElement_props !== void 0 ? _slottableElement_props : {});
        if (slottableElement.type !== $7fPBF.Fragment) mergedProps.ref = forwardedRef ? composedRef : slottableElementRef;
        return $7fPBF.cloneElement(slottableElement, mergedProps);
    });
    Slot2.displayName = `${ownerName}.Slot`;
    return Slot2;
}
$089057084dfb92a4$var$__name($089057084dfb92a4$export$e88b45bda5c13eb9, "createSlot");
var $089057084dfb92a4$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $089057084dfb92a4$export$e88b45bda5c13eb9("Slot");
var $089057084dfb92a4$var$SLOTTABLE_IDENTIFIER = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function $089057084dfb92a4$export$bf68c29d8281d0f7(ownerName) {
    const Slottable2 = /* @__PURE__ */ $089057084dfb92a4$var$__name((props)=>"child" in props ? props.children(props.child) : props.children, "Slottable");
    Slottable2.displayName = `${ownerName}.Slottable`;
    Slottable2.__radixId = $089057084dfb92a4$var$SLOTTABLE_IDENTIFIER;
    return Slottable2;
}
$089057084dfb92a4$var$__name($089057084dfb92a4$export$bf68c29d8281d0f7, "createSlottable");
var $089057084dfb92a4$export$d9f1ccf0bdb05d45 = /* @__PURE__ */ $089057084dfb92a4$export$bf68c29d8281d0f7("Slottable");
var $089057084dfb92a4$var$getSlottableElementFromSlottable = /* @__PURE__ */ $089057084dfb92a4$var$__name((slottable, child)=>{
    if ("child" in slottable.props) {
        const child2 = slottable.props.child;
        if (!$7fPBF.isValidElement(child2)) return null;
        return $7fPBF.cloneElement(child2, void 0, slottable.props.children(child2.props.children));
    }
    return $7fPBF.isValidElement(child) ? child : null;
}, "getSlottableElementFromSlottable");
function $089057084dfb92a4$var$mergeProps(slotProps, childProps) {
    const overrideProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, childProps);
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                const result = childPropValue(...args);
                slotPropValue(...args);
                return result;
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, slotPropValue, childPropValue);
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, slotProps, overrideProps);
}
$089057084dfb92a4$var$__name($089057084dfb92a4$var$mergeProps, "mergeProps");
function $089057084dfb92a4$var$getElementRef(element) {
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    let getter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
$089057084dfb92a4$var$__name($089057084dfb92a4$var$getElementRef, "getElementRef");
function $089057084dfb92a4$var$isSlottable(child) {
    return $7fPBF.isValidElement(child) && typeof child.type === "function" && "__radixId" in child.type && child.type.__radixId === $089057084dfb92a4$var$SLOTTABLE_IDENTIFIER;
}
$089057084dfb92a4$var$__name($089057084dfb92a4$var$isSlottable, "isSlottable");
var $089057084dfb92a4$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
function $089057084dfb92a4$var$isLazyComponent(element) {
    return element != null && typeof element === "object" && "$$typeof" in element && element.$$typeof === $089057084dfb92a4$var$REACT_LAZY_TYPE && "_payload" in element && $089057084dfb92a4$var$isPromiseLike(element._payload);
}
$089057084dfb92a4$var$__name($089057084dfb92a4$var$isLazyComponent, "isLazyComponent");
function $089057084dfb92a4$var$isPromiseLike(value) {
    return typeof value === "object" && value !== null && "then" in value;
}
$089057084dfb92a4$var$__name($089057084dfb92a4$var$isPromiseLike, "isPromiseLike");
var $089057084dfb92a4$var$createSlotError = /* @__PURE__ */ $089057084dfb92a4$var$__name((ownerName)=>{
    return `${ownerName} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`;
}, "createSlotError");
var $089057084dfb92a4$var$createSlottableError = /* @__PURE__ */ $089057084dfb92a4$var$__name((ownerName)=>{
    return `${ownerName} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`;
}, "createSlottableError");
var $089057084dfb92a4$var$use = $7fPBF[" use ".trim().toString()];



"use client";
var $08a94ba50b5cc249$var$_keys, $08a94ba50b5cc249$var$__OrderedDict;
var $08a94ba50b5cc249$var$__defProp = Object.defineProperty;
var $08a94ba50b5cc249$var$__name = (target, value)=>$08a94ba50b5cc249$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
// @__NO_SIDE_EFFECTS__
function $08a94ba50b5cc249$export$c74125a8e3af6bb2(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: /* @__PURE__ */ new Map()
    });
    const CollectionProvider = /* @__PURE__ */ $08a94ba50b5cc249$var$__name((props)=>{
        const { scope: scope, children: children } = props;
        const ref = $7fPBF.useRef(null);
        const itemMap = $7fPBF.useRef(/* @__PURE__ */ new Map()).current;
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref,
            children: children
        });
    }, "CollectionProvider");
    CollectionProvider.displayName = PROVIDER_NAME;
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $089057084dfb92a4$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = $7fPBF.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $089057084dfb92a4$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = $7fPBF.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props, itemData = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
            "scope",
            "children"
        ]);
        const ref = $7fPBF.useRef(null);
        const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        $7fPBF.useEffect(()=>{
            context.itemMap.set(ref, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                ref: ref
            }, itemData));
            return ()=>void context.itemMap.delete(ref);
        });
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = $7fPBF.useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    $08a94ba50b5cc249$var$__name(useCollection, "useCollection");
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}
$08a94ba50b5cc249$var$__name($08a94ba50b5cc249$export$c74125a8e3af6bb2, "createCollection");
// src/ordered-dictionary.ts
var $08a94ba50b5cc249$var$__instanciated = /* @__PURE__ */ new WeakMap();
var $08a94ba50b5cc249$var$OrderedDict = ($08a94ba50b5cc249$var$_keys = /*#__PURE__*/ new WeakMap(), $08a94ba50b5cc249$var$__OrderedDict = class _OrderedDict extends Map {
    set(key, value) {
        if ($08a94ba50b5cc249$var$__instanciated.get(this)) {
            if (this.has(key)) (0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys)[(0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys).indexOf(key)] = key;
            else (0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys).push(key);
        }
        super.set(key, value);
        return this;
    }
    insert(index, key, value) {
        const has = this.has(key);
        const length = (0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys).length;
        const relativeIndex = $08a94ba50b5cc249$var$toSafeInteger(index);
        let actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
        const safeIndex = actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
        if (safeIndex === this.size || has && safeIndex === this.size - 1 || safeIndex === -1) {
            this.set(key, value);
            return this;
        }
        const size = this.size + (has ? 0 : 1);
        if (relativeIndex < 0) actualIndex++;
        const keys = [
            ...(0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys)
        ];
        let nextValue;
        let shouldSkip = false;
        for(let i = actualIndex; i < size; i++)if (actualIndex === i) {
            let nextKey = keys[i];
            if (keys[i] === key) nextKey = keys[i + 1];
            if (has) this.delete(key);
            nextValue = this.get(nextKey);
            this.set(key, value);
        } else {
            if (!shouldSkip && keys[i - 1] === key) shouldSkip = true;
            const currentKey = keys[shouldSkip ? i : i - 1];
            const currentValue = nextValue;
            nextValue = this.get(currentKey);
            this.delete(currentKey);
            this.set(currentKey, currentValue);
        }
        return this;
    }
    with(index, key, value) {
        const copy = new _OrderedDict(this);
        copy.insert(index, key, value);
        return copy;
    }
    before(key) {
        const index = (0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys).indexOf(key) - 1;
        if (index < 0) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position before the given key.
   */ setBefore(key, newKey, value) {
        const index = (0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys).indexOf(key);
        if (index === -1) return this;
        return this.insert(index, newKey, value);
    }
    after(key) {
        let index = (0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys).indexOf(key);
        index = index === -1 || index === this.size - 1 ? -1 : index + 1;
        if (index === -1) return void 0;
        return this.entryAt(index);
    }
    /**
   * Sets a new key-value pair at the position after the given key.
   */ setAfter(key, newKey, value) {
        const index = (0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys).indexOf(key);
        if (index === -1) return this;
        return this.insert(index + 1, newKey, value);
    }
    first() {
        return this.entryAt(0);
    }
    last() {
        return this.entryAt(-1);
    }
    clear() {
        (0, $2906a6c695077413$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys, []);
        return super.clear();
    }
    delete(key) {
        const deleted = super.delete(key);
        if (deleted) (0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys).splice((0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys).indexOf(key), 1);
        return deleted;
    }
    deleteAt(index) {
        const key = this.keyAt(index);
        if (key !== void 0) return this.delete(key);
        return false;
    }
    at(index) {
        const key = $08a94ba50b5cc249$var$at((0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys), index);
        if (key !== void 0) return this.get(key);
    }
    entryAt(index) {
        const key = $08a94ba50b5cc249$var$at((0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys), index);
        if (key !== void 0) return [
            key,
            this.get(key)
        ];
    }
    indexOf(key) {
        return (0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys).indexOf(key);
    }
    keyAt(index) {
        return $08a94ba50b5cc249$var$at((0, $54af65440e83a537$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys), index);
    }
    from(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.at(dest);
    }
    keyFrom(key, offset) {
        const index = this.indexOf(key);
        if (index === -1) return void 0;
        let dest = index + offset;
        if (dest < 0) dest = 0;
        if (dest >= this.size) dest = this.size - 1;
        return this.keyAt(dest);
    }
    find(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return entry;
            index++;
        }
        return void 0;
    }
    findIndex(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return index;
            index++;
        }
        return -1;
    }
    filter(predicate, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) entries.push(entry);
            index++;
        }
        return new _OrderedDict(entries);
    }
    map(callbackfn, thisArg) {
        const entries = [];
        let index = 0;
        for (const entry of this){
            entries.push([
                entry[0],
                Reflect.apply(callbackfn, thisArg, [
                    entry,
                    index,
                    this
                ])
            ]);
            index++;
        }
        return new _OrderedDict(entries);
    }
    reduce(...args) {
        const [callbackfn, initialValue] = args;
        let index = 0;
        let accumulator = initialValue !== null && initialValue !== void 0 ? initialValue : this.at(0);
        for (const entry of this){
            if (index === 0 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
            index++;
        }
        return accumulator;
    }
    reduceRight(...args) {
        const [callbackfn, initialValue] = args;
        let accumulator = initialValue !== null && initialValue !== void 0 ? initialValue : this.at(-1);
        for(let index = this.size - 1; index >= 0; index--){
            const entry = this.at(index);
            if (index === this.size - 1 && args.length === 1) accumulator = entry;
            else accumulator = Reflect.apply(callbackfn, this, [
                accumulator,
                entry,
                index,
                this
            ]);
        }
        return accumulator;
    }
    toSorted(compareFn) {
        const entries = [
            ...this.entries()
        ].sort(compareFn);
        return new _OrderedDict(entries);
    }
    toReversed() {
        const reversed = new _OrderedDict();
        for(let index = this.size - 1; index >= 0; index--){
            const key = this.keyAt(index);
            const element = this.get(key);
            reversed.set(key, element);
        }
        return reversed;
    }
    toSpliced(...args) {
        const entries = [
            ...this.entries()
        ];
        entries.splice(...args);
        return new _OrderedDict(entries);
    }
    slice(start, end) {
        const result = new _OrderedDict();
        let stop = this.size - 1;
        if (start === void 0) return result;
        if (start < 0) start = start + this.size;
        if (end !== void 0 && end > 0) stop = end - 1;
        for(let index = start; index <= stop; index++){
            const key = this.keyAt(index);
            const element = this.get(key);
            result.set(key, element);
        }
        return result;
    }
    every(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (!Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return false;
            index++;
        }
        return true;
    }
    some(predicate, thisArg) {
        let index = 0;
        for (const entry of this){
            if (Reflect.apply(predicate, thisArg, [
                entry,
                index,
                this
            ])) return true;
            index++;
        }
        return false;
    }
    constructor(entries){
        super(entries), (0, $0a7837cd8c38b609$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys, {
            writable: true,
            value: void 0
        });
        (0, $2906a6c695077413$export$71511d61b312f219)(this, $08a94ba50b5cc249$var$_keys, [
            ...super.keys()
        ]);
        $08a94ba50b5cc249$var$__instanciated.set(this, true);
    }
}, $08a94ba50b5cc249$var$__name($08a94ba50b5cc249$var$__OrderedDict, "OrderedDict"), $08a94ba50b5cc249$var$__OrderedDict);
function $08a94ba50b5cc249$var$at(array, index) {
    if ("at" in Array.prototype) return Array.prototype.at.call(array, index);
    const actualIndex = $08a94ba50b5cc249$var$toSafeIndex(array, index);
    return actualIndex === -1 ? void 0 : array[actualIndex];
}
$08a94ba50b5cc249$var$__name($08a94ba50b5cc249$var$at, "at");
function $08a94ba50b5cc249$var$toSafeIndex(array, index) {
    const length = array.length;
    const relativeIndex = $08a94ba50b5cc249$var$toSafeInteger(index);
    const actualIndex = relativeIndex >= 0 ? relativeIndex : length + relativeIndex;
    return actualIndex < 0 || actualIndex >= length ? -1 : actualIndex;
}
$08a94ba50b5cc249$var$__name($08a94ba50b5cc249$var$toSafeIndex, "toSafeIndex");
function $08a94ba50b5cc249$var$toSafeInteger(number) {
    return number !== number || number === 0 ? 0 : Math.trunc(number);
}
$08a94ba50b5cc249$var$__name($08a94ba50b5cc249$var$toSafeInteger, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function $08a94ba50b5cc249$export$ec5c5a85b7371a0f(name) {
    const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionContextProvider, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionElement: null,
        collectionRef: {
            current: null
        },
        collectionRefObject: {
            current: null
        },
        itemMap: new $08a94ba50b5cc249$var$OrderedDict(),
        setItemMap: /* @__PURE__ */ $08a94ba50b5cc249$var$__name(()=>void 0, "setItemMap")
    });
    const CollectionProvider = /* @__PURE__ */ $08a94ba50b5cc249$var$__name((_param)=>{
        var { state: state } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
            "state"
        ]);
        return state ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(CollectionProviderImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
            state: state
        })) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(CollectionInit, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props));
    }, "CollectionProvider");
    CollectionProvider.displayName = PROVIDER_NAME;
    const CollectionInit = /* @__PURE__ */ $08a94ba50b5cc249$var$__name((props)=>{
        const state = useInitCollection();
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(CollectionProviderImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
            state: state
        }));
    }, "CollectionInit");
    CollectionInit.displayName = PROVIDER_NAME + "Init";
    const CollectionProviderImpl = /* @__PURE__ */ $08a94ba50b5cc249$var$__name((props)=>{
        const { scope: scope, children: children, state: state } = props;
        const ref = $7fPBF.useRef(null);
        const [collectionElement, setCollectionElement] = $7fPBF.useState(null);
        const composeRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(ref, setCollectionElement);
        const [itemMap, setItemMap] = state;
        $7fPBF.useEffect(()=>{
            if (!collectionElement) return;
            const observer = $08a94ba50b5cc249$var$getChildListObserver(()=>{});
            observer.observe(collectionElement, {
                childList: true,
                subtree: true
            });
            return ()=>{
                observer.disconnect();
            };
        }, [
            collectionElement
        ]);
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(CollectionContextProvider, {
            scope: scope,
            itemMap: itemMap,
            setItemMap: setItemMap,
            collectionRef: composeRefs,
            collectionRefObject: ref,
            collectionElement: collectionElement,
            children: children
        });
    }, "CollectionProviderImpl");
    CollectionProviderImpl.displayName = PROVIDER_NAME + "Impl";
    const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlotImpl = (0, $089057084dfb92a4$export$e88b45bda5c13eb9)(COLLECTION_SLOT_NAME);
    const CollectionSlot = $7fPBF.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(CollectionSlotImpl, {
            ref: composedRefs,
            children: children
        });
    });
    CollectionSlot.displayName = COLLECTION_SLOT_NAME;
    const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlotImpl = (0, $089057084dfb92a4$export$e88b45bda5c13eb9)(ITEM_SLOT_NAME);
    const CollectionItemSlot = $7fPBF.forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props, itemData = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
            "scope",
            "children"
        ]);
        const ref = $7fPBF.useRef(null);
        const [element, setElement] = $7fPBF.useState(null);
        const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref, setElement);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        const { setItemMap: setItemMap } = context;
        const itemDataRef = $7fPBF.useRef(itemData);
        if (!$08a94ba50b5cc249$var$shallowEqual(itemDataRef.current, itemData)) itemDataRef.current = itemData;
        const memoizedItemData = itemDataRef.current;
        $7fPBF.useEffect(()=>{
            const itemData2 = memoizedItemData;
            setItemMap((map)=>{
                if (!element) return map;
                if (!map.has(element)) {
                    map.set(element, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, itemData2), {
                        element: element
                    }));
                    return map.toSorted($08a94ba50b5cc249$var$sortByDocumentPosition);
                }
                return map.set(element, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, itemData2), {
                    element: element
                })).toSorted($08a94ba50b5cc249$var$sortByDocumentPosition);
            });
            return ()=>{
                setItemMap((map)=>{
                    if (!element || !map.has(element)) return map;
                    map.delete(element);
                    return new $08a94ba50b5cc249$var$OrderedDict(map);
                });
            };
        }, [
            element,
            memoizedItemData,
            setItemMap
        ]);
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(CollectionItemSlotImpl, {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs,
            children: children
        });
    });
    CollectionItemSlot.displayName = ITEM_SLOT_NAME;
    function useInitCollection() {
        return $7fPBF.useState(new $08a94ba50b5cc249$var$OrderedDict());
    }
    $08a94ba50b5cc249$var$__name(useInitCollection, "useInitCollection");
    function useCollection(scope) {
        const { itemMap: itemMap } = useCollectionContext(name + "CollectionConsumer", scope);
        return itemMap;
    }
    $08a94ba50b5cc249$var$__name(useCollection, "useCollection");
    const functions = {
        createCollectionScope: createCollectionScope,
        useCollection: useCollection,
        useInitCollection: useInitCollection
    };
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        functions
    ];
}
$08a94ba50b5cc249$var$__name($08a94ba50b5cc249$export$ec5c5a85b7371a0f, "createCollection");
function $08a94ba50b5cc249$var$shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || typeof b !== "object") return false;
    if (a == null || b == null) return false;
    const keysA = Object.keys(a);
    const keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    for (const key of keysA){
        if (!Object.prototype.hasOwnProperty.call(b, key)) return false;
        if (a[key] !== b[key]) return false;
    }
    return true;
}
$08a94ba50b5cc249$var$__name($08a94ba50b5cc249$var$shallowEqual, "shallowEqual");
function $08a94ba50b5cc249$var$isElementPreceding(a, b) {
    return !!(b.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_PRECEDING);
}
$08a94ba50b5cc249$var$__name($08a94ba50b5cc249$var$isElementPreceding, "isElementPreceding");
function $08a94ba50b5cc249$var$sortByDocumentPosition(a, b) {
    return !a[1].element || !b[1].element ? 0 : $08a94ba50b5cc249$var$isElementPreceding(a[1].element, b[1].element) ? -1 : 1;
}
$08a94ba50b5cc249$var$__name($08a94ba50b5cc249$var$sortByDocumentPosition, "sortByDocumentPosition");
function $08a94ba50b5cc249$var$getChildListObserver(callback) {
    const observer = new MutationObserver((mutationsList)=>{
        for (const mutation of mutationsList)if (mutation.type === "childList") {
            callback();
            return;
        }
    });
    return observer;
}
$08a94ba50b5cc249$var$__name($08a94ba50b5cc249$var$getChildListObserver, "getChildListObserver");





var $7fPBF = parcelRequire("7fPBF");

"use client";
var $3342477e04611d10$var$__defProp = Object.defineProperty;
var $3342477e04611d10$var$__name = (target, value)=>$3342477e04611d10$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $3342477e04611d10$var$DirectionContext = $7fPBF.createContext(void 0);
var $3342477e04611d10$export$c760c09fdd558351 = /* @__PURE__ */ $3342477e04611d10$var$__name((props)=>{
    const { dir: dir, children: children } = props;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($3342477e04611d10$var$DirectionContext.Provider, {
        value: dir,
        children: children
    });
}, "DirectionProvider");
function $3342477e04611d10$export$b39126d51d94e6f3(localDir) {
    const globalDir = $7fPBF.useContext($3342477e04611d10$var$DirectionContext);
    return localDir || globalDir || "ltr";
}
$3342477e04611d10$var$__name($3342477e04611d10$export$b39126d51d94e6f3, "useDirection");
var $3342477e04611d10$export$2881499e37b75b9a = $3342477e04611d10$export$c760c09fdd558351;






var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");


var $4b1a25a893812cc7$var$__defProp = Object.defineProperty;
var $4b1a25a893812cc7$var$__name = (target, value)=>$4b1a25a893812cc7$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $4b1a25a893812cc7$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "select",
    "span",
    "svg",
    "ul"
];
var $4b1a25a893812cc7$export$250ffa63cdc0d034 = $4b1a25a893812cc7$var$NODES.reduce((primitive, node)=>{
    const Slot = (0, $089057084dfb92a4$export$e88b45bda5c13eb9)(`Primitive.${node}`);
    const Node = $7fPBF.forwardRef((props, forwardedRef)=>{
        const { asChild: asChild } = props, primitiveProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
            "asChild"
        ]);
        const Comp = asChild ? Slot : node;
        if (typeof window !== "undefined") window[Symbol.for("radix-ui")] = true;
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(Comp, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, primitiveProps), {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, primitive), {
        [node]: Node
    });
}, {});
function $4b1a25a893812cc7$export$6d1a0317bde7de7f(target, event) {
    if (target) $fw0lo.flushSync(()=>target.dispatchEvent(event));
}
$4b1a25a893812cc7$var$__name($4b1a25a893812cc7$export$6d1a0317bde7de7f, "dispatchDiscreteCustomEvent");
var $4b1a25a893812cc7$export$be92b6f5f03c0fe9 = $4b1a25a893812cc7$export$250ffa63cdc0d034;




var $7fPBF = parcelRequire("7fPBF");
var $4ea47b3abe83764c$var$__defProp = Object.defineProperty;
var $4ea47b3abe83764c$var$__name = (target, value)=>$4ea47b3abe83764c$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $4ea47b3abe83764c$export$25bec8c6f54ee79a(callback) {
    const callbackRef = $7fPBF.useRef(callback);
    $7fPBF.useEffect(()=>{
        callbackRef.current = callback;
    });
    return $7fPBF.useMemo(()=>(...args)=>{
            var _callbackRef_current;
            return (_callbackRef_current = callbackRef.current) === null || _callbackRef_current === void 0 ? void 0 : _callbackRef_current.call(callbackRef, ...args);
        }, []);
}
$4ea47b3abe83764c$var$__name($4ea47b3abe83764c$export$25bec8c6f54ee79a, "useCallbackRef");



"use client";
var $251340165f4765e5$var$__defProp = Object.defineProperty;
var $251340165f4765e5$var$__name = (target, value)=>$251340165f4765e5$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $251340165f4765e5$var$CONTEXT_UPDATE = "dismissableLayer.update";
var $251340165f4765e5$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
var $251340165f4765e5$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
var $251340165f4765e5$var$originalBodyPointerEvents;
var $251340165f4765e5$var$DismissableLayerContext = $7fPBF.createContext({
    layers: /* @__PURE__ */ new Set(),
    layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
    branches: /* @__PURE__ */ new Set(),
    // Outside elements that belong to a layer's own dismiss affordance (eg, a
    // dialog overlay). Pressing them should dismiss the layer regardless of
    // whether or not they stop propagation.
    //
    // See https://github.com/radix-ui/primitives/issues/3346
    dismissableSurfaces: /* @__PURE__ */ new Set()
});
var $251340165f4765e5$export$177fb62ff3ec1f22 = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $251340165f4765e5$var$__name(function DismissableLayer2(props, forwardedRef) {
    var _globalThis;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, deferPointerDownOutside: deferPointerDownOutside = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss } = props, layerProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "disableOutsidePointerEvents",
        "deferPointerDownOutside",
        "onEscapeKeyDown",
        "onPointerDownOutside",
        "onFocusOutside",
        "onInteractOutside",
        "onDismiss"
    ]);
    const context = $7fPBF.useContext($251340165f4765e5$var$DismissableLayerContext);
    const [node, setNode] = $7fPBF.useState(null);
    var _node_ownerDocument;
    const ownerDocument = (_node_ownerDocument = node === null || node === void 0 ? void 0 : node.ownerDocument) !== null && _node_ownerDocument !== void 0 ? _node_ownerDocument : (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
    const [, force] = $7fPBF.useState({});
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, setNode);
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1);
    const highestLayerWithOutsidePointerEventsDisabledIndex = highestLayerWithOutsidePointerEventsDisabled ? layers.indexOf(highestLayerWithOutsidePointerEventsDisabled) : -1;
    const index = node ? layers.indexOf(node) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const isDeferredPointerDownOutsideRef = $7fPBF.useRef(false);
    const pointerDownOutside = $251340165f4765e5$var$usePointerDownOutside((event)=>{
        onPointerDownOutside === null || onPointerDownOutside === void 0 ? void 0 : onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, {
        ownerDocument: ownerDocument,
        deferPointerDownOutside: deferPointerDownOutside,
        isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef,
        dismissableSurfaces: context.dismissableSurfaces,
        shouldHandlePointerDownOutside: $7fPBF.useCallback((target)=>{
            if (!(target instanceof Node)) return false;
            const isPointerDownOnBranch = [
                ...context.branches
            ].some((branch)=>branch.contains(target));
            return isPointerEventsEnabled && !isPointerDownOnBranch;
        }, [
            context.branches,
            isPointerEventsEnabled
        ])
    });
    const focusOutside = $251340165f4765e5$var$useFocusOutside((event)=>{
        if (deferPointerDownOutside && isDeferredPointerDownOutsideRef.current) return;
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 ? void 0 : onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 ? void 0 : onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 ? void 0 : onDismiss();
    }, ownerDocument);
    const isHighestLayer = node ? index === layers.length - 1 : false;
    const handleKeyDown = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)((event)=>{
        if (event.key !== "Escape") return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 ? void 0 : onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    });
    $7fPBF.useEffect(()=>{
        if (!isHighestLayer) return;
        ownerDocument.addEventListener("keydown", handleKeyDown, {
            capture: true
        });
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown, {
                capture: true
            });
    }, [
        ownerDocument,
        isHighestLayer,
        handleKeyDown
    ]);
    $7fPBF.useEffect(()=>{
        if (!node) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $251340165f4765e5$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node);
        }
        context.layers.add(node);
        $251340165f4765e5$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents) {
                context.layersWithOutsidePointerEventsDisabled.delete(node);
                if (context.layersWithOutsidePointerEventsDisabled.size === 0) ownerDocument.body.style.pointerEvents = $251340165f4765e5$var$originalBodyPointerEvents;
            }
        };
    }, [
        node,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            if (!node) return;
            context.layers.delete(node);
            context.layersWithOutsidePointerEventsDisabled.delete(node);
            $251340165f4765e5$var$dispatchUpdate();
        };
    }, [
        node,
        context
    ]);
    $7fPBF.useEffect(()=>{
        const handleUpdate = /* @__PURE__ */ $251340165f4765e5$var$__name(()=>force({}), "handleUpdate");
        document.addEventListener($251340165f4765e5$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($251340165f4765e5$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, layerProps), {
        ref: composedRefs,
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : void 0
        }, props.style),
        onFocusCapture: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
}, "DismissableLayer"));
var $251340165f4765e5$export$4d5eb2109db14228 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $251340165f4765e5$var$__name(function DismissableLayerBranch2(props, forwardedRef) {
    const context = $7fPBF.useContext($251340165f4765e5$var$DismissableLayerContext);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    $7fPBF.useEffect(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        ref: composedRefs
    }));
}, "DismissableLayerBranch"));
function $251340165f4765e5$export$210785236bdfcb27() {
    const context = $7fPBF.useContext($251340165f4765e5$var$DismissableLayerContext);
    const [node, setNode] = $7fPBF.useState(null);
    $7fPBF.useEffect(()=>{
        if (!node) return;
        context.dismissableSurfaces.add(node);
        return ()=>{
            context.dismissableSurfaces.delete(node);
        };
    }, [
        node,
        context.dismissableSurfaces
    ]);
    return setNode;
}
$251340165f4765e5$var$__name($251340165f4765e5$export$210785236bdfcb27, "useDismissableLayerSurface");
var $251340165f4765e5$var$IS_TRUE = /* @__PURE__ */ $251340165f4765e5$var$__name(()=>true, "IS_TRUE");
function $251340165f4765e5$var$usePointerDownOutside(onPointerDownOutside, args) {
    var _globalThis;
    const { ownerDocument: ownerDocument = (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document, deferPointerDownOutside: deferPointerDownOutside = false, isDeferredPointerDownOutsideRef: isDeferredPointerDownOutsideRef, dismissableSurfaces: dismissableSurfaces, shouldHandlePointerDownOutside: shouldHandlePointerDownOutside = $251340165f4765e5$var$IS_TRUE } = args;
    const handlePointerDownOutside = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = $7fPBF.useRef(false);
    const isPointerDownOutsideRef = $7fPBF.useRef(false);
    const interceptedOutsideInteractionEventsRef = $7fPBF.useRef(/* @__PURE__ */ new Map());
    const handleClickRef = $7fPBF.useRef(()=>{});
    $7fPBF.useEffect(()=>{
        function resetOutsideInteraction() {
            isPointerDownOutsideRef.current = false;
            isDeferredPointerDownOutsideRef.current = false;
            interceptedOutsideInteractionEventsRef.current.clear();
        }
        $251340165f4765e5$var$__name(resetOutsideInteraction, "resetOutsideInteraction");
        function isOutsideInteractionIntercepted() {
            return Array.from(interceptedOutsideInteractionEventsRef.current.values()).some(Boolean);
        }
        $251340165f4765e5$var$__name(isOutsideInteractionIntercepted, "isOutsideInteractionIntercepted");
        function handleInteractionCapture(event) {
            if (!isPointerDownOutsideRef.current) return;
            const target = event.target;
            const isDismissableSurface = target instanceof Node && [
                ...dismissableSurfaces
            ].some((surface)=>surface.contains(target));
            if (!isDismissableSurface) interceptedOutsideInteractionEventsRef.current.set(event.type, true);
            if (event.type === "click") window.setTimeout(()=>{
                if (isPointerDownOutsideRef.current) handleClickRef.current();
            }, 0);
        }
        $251340165f4765e5$var$__name(handleInteractionCapture, "handleInteractionCapture");
        function handleInteractionBubble(event) {
            if (isPointerDownOutsideRef.current) interceptedOutsideInteractionEventsRef.current.set(event.type, false);
        }
        $251340165f4765e5$var$__name(handleInteractionBubble, "handleInteractionBubble");
        const handlePointerDown = /* @__PURE__ */ $251340165f4765e5$var$__name((event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                let handleAndDispatchPointerDownOutsideEvent2 = function() {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    const wasOutsideInteractionIntercepted = isOutsideInteractionIntercepted();
                    resetOutsideInteraction();
                    if (!wasOutsideInteractionIntercepted) $251340165f4765e5$var$handleAndDispatchCustomEvent($251340165f4765e5$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                };
                var handleAndDispatchPointerDownOutsideEvent = handleAndDispatchPointerDownOutsideEvent2;
                $251340165f4765e5$var$__name(handleAndDispatchPointerDownOutsideEvent2, "handleAndDispatchPointerDownOutsideEvent");
                if (!shouldHandlePointerDownOutside(event.target)) {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    resetOutsideInteraction();
                    isPointerInsideReactTreeRef.current = false;
                    return;
                }
                const eventDetail = {
                    originalEvent: event
                };
                isPointerDownOutsideRef.current = true;
                isDeferredPointerDownOutsideRef.current = deferPointerDownOutside && event.button === 0;
                interceptedOutsideInteractionEventsRef.current.clear();
                if (!deferPointerDownOutside || event.button !== 0) handleAndDispatchPointerDownOutsideEvent2();
                else {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent2;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                }
            } else {
                ownerDocument.removeEventListener("click", handleClickRef.current);
                resetOutsideInteraction();
            }
            isPointerInsideReactTreeRef.current = false;
        }, "handlePointerDown");
        const outsideInteractionEvents = [
            "pointerup",
            "mousedown",
            "mouseup",
            "touchstart",
            "touchend",
            "click"
        ];
        for (const eventName of outsideInteractionEvents){
            ownerDocument.addEventListener(eventName, handleInteractionCapture, true);
            ownerDocument.addEventListener(eventName, handleInteractionBubble);
        }
        const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
            for (const eventName of outsideInteractionEvents){
                ownerDocument.removeEventListener(eventName, handleInteractionCapture, true);
                ownerDocument.removeEventListener(eventName, handleInteractionBubble);
            }
        };
    }, [
        ownerDocument,
        handlePointerDownOutside,
        deferPointerDownOutside,
        isDeferredPointerDownOutsideRef,
        dismissableSurfaces,
        shouldHandlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: /* @__PURE__ */ $251340165f4765e5$var$__name(()=>isPointerInsideReactTreeRef.current = true, "onPointerDownCapture")
    };
}
$251340165f4765e5$var$__name($251340165f4765e5$var$usePointerDownOutside, "usePointerDownOutside");
function $251340165f4765e5$var$useFocusOutside(onFocusOutside, ownerDocument = (()=>{
    var _globalThis;
    return (_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : _globalThis.document;
})()) {
    const handleFocusOutside = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        const handleFocus = /* @__PURE__ */ $251340165f4765e5$var$__name((event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $251340165f4765e5$var$handleAndDispatchCustomEvent($251340165f4765e5$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        }, "handleFocus");
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: /* @__PURE__ */ $251340165f4765e5$var$__name(()=>isFocusInsideReactTreeRef.current = true, "onFocusCapture"),
        onBlurCapture: /* @__PURE__ */ $251340165f4765e5$var$__name(()=>isFocusInsideReactTreeRef.current = false, "onBlurCapture")
    };
}
$251340165f4765e5$var$__name($251340165f4765e5$var$useFocusOutside, "useFocusOutside");
function $251340165f4765e5$var$dispatchUpdate() {
    const event = new CustomEvent($251340165f4765e5$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
$251340165f4765e5$var$__name($251340165f4765e5$var$dispatchUpdate, "dispatchUpdate");
function $251340165f4765e5$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $4b1a25a893812cc7$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
$251340165f4765e5$var$__name($251340165f4765e5$var$handleAndDispatchCustomEvent, "handleAndDispatchCustomEvent");
var $251340165f4765e5$export$be92b6f5f03c0fe9 = $251340165f4765e5$export$177fb62ff3ec1f22;
var $251340165f4765e5$export$aecb2ddcb55c95be = $251340165f4765e5$export$4d5eb2109db14228;



var $7fPBF = parcelRequire("7fPBF");
"use client";
var $38bbe2f1de23f200$var$__defProp = Object.defineProperty;
var $38bbe2f1de23f200$var$__name = (target, value)=>$38bbe2f1de23f200$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $38bbe2f1de23f200$var$count = 0;
var $38bbe2f1de23f200$var$guards = null;
function $38bbe2f1de23f200$export$ac5b58043b79449b(props) {
    $38bbe2f1de23f200$export$b7ece24a22aeda8c();
    return props.children;
}
$38bbe2f1de23f200$var$__name($38bbe2f1de23f200$export$ac5b58043b79449b, "FocusGuards");
function $38bbe2f1de23f200$export$b7ece24a22aeda8c() {
    $7fPBF.useEffect(()=>{
        if (!$38bbe2f1de23f200$var$guards) $38bbe2f1de23f200$var$guards = {
            start: $38bbe2f1de23f200$var$createFocusGuard(),
            end: $38bbe2f1de23f200$var$createFocusGuard()
        };
        const { start: start, end: end } = $38bbe2f1de23f200$var$guards;
        if (document.body.firstElementChild !== start) document.body.insertAdjacentElement("afterbegin", start);
        if (document.body.lastElementChild !== end) document.body.insertAdjacentElement("beforeend", end);
        $38bbe2f1de23f200$var$count++;
        return ()=>{
            if ($38bbe2f1de23f200$var$count === 1) {
                $38bbe2f1de23f200$var$guards === null || $38bbe2f1de23f200$var$guards === void 0 ? void 0 : $38bbe2f1de23f200$var$guards.start.remove();
                $38bbe2f1de23f200$var$guards === null || $38bbe2f1de23f200$var$guards === void 0 ? void 0 : $38bbe2f1de23f200$var$guards.end.remove();
                $38bbe2f1de23f200$var$guards = null;
            }
            $38bbe2f1de23f200$var$count = Math.max(0, $38bbe2f1de23f200$var$count - 1);
        };
    }, []);
}
$38bbe2f1de23f200$var$__name($38bbe2f1de23f200$export$b7ece24a22aeda8c, "useFocusGuards");
function $38bbe2f1de23f200$var$createFocusGuard() {
    const element = document.createElement("span");
    element.setAttribute("data-radix-focus-guard", "");
    element.tabIndex = 0;
    element.style.outline = "none";
    element.style.opacity = "0";
    element.style.position = "fixed";
    element.style.pointerEvents = "none";
    return element;
}
$38bbe2f1de23f200$var$__name($38bbe2f1de23f200$var$createFocusGuard, "createFocusGuard");






var $7fPBF = parcelRequire("7fPBF");




"use client";
var $0d555b2b0a3ffff1$var$__defProp = Object.defineProperty;
var $0d555b2b0a3ffff1$var$__name = (target, value)=>$0d555b2b0a3ffff1$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $0d555b2b0a3ffff1$var$AUTOFOCUS_ON_MOUNT = "focusScope.autoFocusOnMount";
var $0d555b2b0a3ffff1$var$AUTOFOCUS_ON_UNMOUNT = "focusScope.autoFocusOnUnmount";
var $0d555b2b0a3ffff1$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $0d555b2b0a3ffff1$export$20e40289641fbbb6 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $0d555b2b0a3ffff1$var$__name(function FocusScope2(props, forwardedRef) {
    const { loop: loop = false, trapped: trapped = false, onMountAutoFocus: onMountAutoFocusProp, onUnmountAutoFocus: onUnmountAutoFocusProp } = props, scopeProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "loop",
        "trapped",
        "onMountAutoFocus",
        "onUnmountAutoFocus"
    ]);
    const [container, setContainer] = $7fPBF.useState(null);
    const onMountAutoFocus = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onMountAutoFocusProp);
    const onUnmountAutoFocus = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onUnmountAutoFocusProp);
    const lastFocusedElementRef = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, setContainer);
    const focusScope = $7fPBF.useRef({
        paused: false,
        pause () {
            this.paused = true;
        },
        resume () {
            this.paused = false;
        }
    }).current;
    $7fPBF.useEffect(()=>{
        if (trapped) {
            let handleFocusIn2 = function(event) {
                if (focusScope.paused || !container) return;
                const target = event.target;
                if (container.contains(target)) lastFocusedElementRef.current = target;
                else $0d555b2b0a3ffff1$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleFocusOut2 = function(event) {
                if (focusScope.paused || !container) return;
                const relatedTarget = event.relatedTarget;
                if (relatedTarget === null) return;
                if (!container.contains(relatedTarget)) $0d555b2b0a3ffff1$var$focus(lastFocusedElementRef.current, {
                    select: true
                });
            }, handleMutations2 = function(mutations) {
                const focusedElement = document.activeElement;
                if (focusedElement !== document.body) return;
                for (const mutation of mutations)if (mutation.removedNodes.length > 0) $0d555b2b0a3ffff1$var$focus(container);
            };
            var handleFocusIn = handleFocusIn2, handleFocusOut = handleFocusOut2, handleMutations = handleMutations2;
            $0d555b2b0a3ffff1$var$__name(handleFocusIn2, "handleFocusIn");
            $0d555b2b0a3ffff1$var$__name(handleFocusOut2, "handleFocusOut");
            $0d555b2b0a3ffff1$var$__name(handleMutations2, "handleMutations");
            document.addEventListener("focusin", handleFocusIn2);
            document.addEventListener("focusout", handleFocusOut2);
            const mutationObserver = new MutationObserver(handleMutations2);
            if (container) mutationObserver.observe(container, {
                childList: true,
                subtree: true
            });
            return ()=>{
                document.removeEventListener("focusin", handleFocusIn2);
                document.removeEventListener("focusout", handleFocusOut2);
                mutationObserver.disconnect();
            };
        }
    }, [
        trapped,
        container,
        focusScope.paused
    ]);
    $7fPBF.useEffect(()=>{
        if (container) {
            $0d555b2b0a3ffff1$var$focusScopesStack.add(focusScope);
            const previouslyFocusedElement = document.activeElement;
            const hasFocusedCandidate = container.contains(previouslyFocusedElement);
            if (!hasFocusedCandidate) {
                const mountEvent = new CustomEvent($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_MOUNT, $0d555b2b0a3ffff1$var$EVENT_OPTIONS);
                container.addEventListener($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                container.dispatchEvent(mountEvent);
                if (!mountEvent.defaultPrevented) {
                    $0d555b2b0a3ffff1$var$focusFirst($0d555b2b0a3ffff1$var$removeLinks($0d555b2b0a3ffff1$var$getTabbableCandidates(container)), {
                        select: true
                    });
                    if (document.activeElement === previouslyFocusedElement) $0d555b2b0a3ffff1$var$focus(container);
                }
            }
            return ()=>{
                container.removeEventListener($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_MOUNT, onMountAutoFocus);
                setTimeout(()=>{
                    const unmountEvent = new CustomEvent($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_UNMOUNT, $0d555b2b0a3ffff1$var$EVENT_OPTIONS);
                    container.addEventListener($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    container.dispatchEvent(unmountEvent);
                    if (!unmountEvent.defaultPrevented) $0d555b2b0a3ffff1$var$focus(previouslyFocusedElement !== null && previouslyFocusedElement !== void 0 ? previouslyFocusedElement : document.body, {
                        select: true
                    });
                    container.removeEventListener($0d555b2b0a3ffff1$var$AUTOFOCUS_ON_UNMOUNT, onUnmountAutoFocus);
                    $0d555b2b0a3ffff1$var$focusScopesStack.remove(focusScope);
                }, 0);
            };
        }
    }, [
        container,
        onMountAutoFocus,
        onUnmountAutoFocus,
        focusScope
    ]);
    const handleKeyDown = $7fPBF.useCallback((event)=>{
        if (!loop && !trapped) return;
        if (focusScope.paused) return;
        const isTabKey = event.key === "Tab" && !event.altKey && !event.ctrlKey && !event.metaKey;
        const focusedElement = document.activeElement;
        if (isTabKey && focusedElement) {
            const container2 = event.currentTarget;
            const [first, last] = $0d555b2b0a3ffff1$var$getTabbableEdges(container2);
            const hasTabbableElementsInside = first && last;
            if (!hasTabbableElementsInside) {
                if (focusedElement === container2) event.preventDefault();
            } else {
                if (!event.shiftKey && focusedElement === last) {
                    event.preventDefault();
                    if (loop) $0d555b2b0a3ffff1$var$focus(first, {
                        select: true
                    });
                } else if (event.shiftKey && focusedElement === first) {
                    event.preventDefault();
                    if (loop) $0d555b2b0a3ffff1$var$focus(last, {
                        select: true
                    });
                }
            }
        }
    }, [
        loop,
        trapped,
        focusScope.paused
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        tabIndex: -1
    }, scopeProps), {
        ref: composedRefs,
        onKeyDown: handleKeyDown
    }));
}, "FocusScope"));
function $0d555b2b0a3ffff1$var$focusFirst(candidates, { select: select = false } = {}) {
    const previouslyFocusedElement = document.activeElement;
    for (const candidate of candidates){
        $0d555b2b0a3ffff1$var$focus(candidate, {
            select: select
        });
        if (document.activeElement !== previouslyFocusedElement) return;
    }
}
$0d555b2b0a3ffff1$var$__name($0d555b2b0a3ffff1$var$focusFirst, "focusFirst");
function $0d555b2b0a3ffff1$var$getTabbableEdges(container) {
    const candidates = $0d555b2b0a3ffff1$var$getTabbableCandidates(container);
    const first = $0d555b2b0a3ffff1$var$findVisible(candidates, container);
    const last = $0d555b2b0a3ffff1$var$findVisible(candidates.reverse(), container);
    return [
        first,
        last
    ];
}
$0d555b2b0a3ffff1$var$__name($0d555b2b0a3ffff1$var$getTabbableEdges, "getTabbableEdges");
function $0d555b2b0a3ffff1$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: /* @__PURE__ */ $0d555b2b0a3ffff1$var$__name((node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP;
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }, "acceptNode")
    });
    while(walker.nextNode())nodes.push(walker.currentNode);
    return nodes;
}
$0d555b2b0a3ffff1$var$__name($0d555b2b0a3ffff1$var$getTabbableCandidates, "getTabbableCandidates");
function $0d555b2b0a3ffff1$var$findVisible(elements, container) {
    const canUseCheckVisibility = typeof container.checkVisibility === "function" && container.checkVisibility({
        checkVisibilityCSS: true
    });
    for (const element of elements){
        const hidden = canUseCheckVisibility ? !element.checkVisibility({
            checkVisibilityCSS: true
        }) : $0d555b2b0a3ffff1$var$isHidden(element, {
            upTo: container
        });
        if (!hidden) return element;
    }
}
$0d555b2b0a3ffff1$var$__name($0d555b2b0a3ffff1$var$findVisible, "findVisible");
function $0d555b2b0a3ffff1$var$isHidden(node, { upTo: upTo }) {
    if (getComputedStyle(node).visibility === "hidden") return true;
    while(node){
        if (upTo !== void 0 && node === upTo) return false;
        if (getComputedStyle(node).display === "none") return true;
        node = node.parentElement;
    }
    return false;
}
$0d555b2b0a3ffff1$var$__name($0d555b2b0a3ffff1$var$isHidden, "isHidden");
function $0d555b2b0a3ffff1$var$isSelectableInput(element) {
    return element instanceof HTMLInputElement && "select" in element;
}
$0d555b2b0a3ffff1$var$__name($0d555b2b0a3ffff1$var$isSelectableInput, "isSelectableInput");
function $0d555b2b0a3ffff1$var$focus(element, { select: select = false } = {}) {
    if (element && element.focus) {
        const previouslyFocusedElement = document.activeElement;
        element.focus({
            preventScroll: true
        });
        if (element !== previouslyFocusedElement && $0d555b2b0a3ffff1$var$isSelectableInput(element) && select) element.select();
    }
}
$0d555b2b0a3ffff1$var$__name($0d555b2b0a3ffff1$var$focus, "focus");
var $0d555b2b0a3ffff1$var$focusScopesStack = $0d555b2b0a3ffff1$var$createFocusScopesStack();
function $0d555b2b0a3ffff1$var$createFocusScopesStack() {
    let stack = [];
    return {
        add (focusScope) {
            const activeFocusScope = stack[0];
            if (focusScope !== activeFocusScope) activeFocusScope === null || activeFocusScope === void 0 ? void 0 : activeFocusScope.pause();
            stack = $0d555b2b0a3ffff1$var$arrayRemove(stack, focusScope);
            stack.unshift(focusScope);
        },
        remove (focusScope) {
            var _stack_;
            stack = $0d555b2b0a3ffff1$var$arrayRemove(stack, focusScope);
            (_stack_ = stack[0]) === null || _stack_ === void 0 ? void 0 : _stack_.resume();
        }
    };
}
$0d555b2b0a3ffff1$var$__name($0d555b2b0a3ffff1$var$createFocusScopesStack, "createFocusScopesStack");
function $0d555b2b0a3ffff1$var$arrayRemove(array, item) {
    const updatedArray = [
        ...array
    ];
    const index = updatedArray.indexOf(item);
    if (index !== -1) updatedArray.splice(index, 1);
    return updatedArray;
}
$0d555b2b0a3ffff1$var$__name($0d555b2b0a3ffff1$var$arrayRemove, "arrayRemove");
function $0d555b2b0a3ffff1$var$removeLinks(items) {
    return items.filter((item)=>item.tagName !== "A");
}
$0d555b2b0a3ffff1$var$__name($0d555b2b0a3ffff1$var$removeLinks, "removeLinks");
var $0d555b2b0a3ffff1$export$be92b6f5f03c0fe9 = $0d555b2b0a3ffff1$export$20e40289641fbbb6;



var $7fPBF = parcelRequire("7fPBF");
// src/use-layout-effect.tsx

var $7fPBF = parcelRequire("7fPBF");
var $191a4e5730438e92$var$_globalThis;
var $191a4e5730438e92$export$e5c5a5f917a5871c = (($191a4e5730438e92$var$_globalThis = globalThis) === null || $191a4e5730438e92$var$_globalThis === void 0 ? void 0 : $191a4e5730438e92$var$_globalThis.document) ? $7fPBF.useLayoutEffect : ()=>{};


var $8a8e9b94c33ba6d6$var$__defProp = Object.defineProperty;
var $8a8e9b94c33ba6d6$var$__name = (target, value)=>$8a8e9b94c33ba6d6$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $8a8e9b94c33ba6d6$var$useReactId = $7fPBF[" useId ".trim().toString()] || (()=>void 0);
var $8a8e9b94c33ba6d6$var$count = 0;
function $8a8e9b94c33ba6d6$export$f680877a34711e37(deterministicId) {
    const [id, setId] = $7fPBF.useState($8a8e9b94c33ba6d6$var$useReactId());
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (!deterministicId) setId((reactId)=>reactId !== null && reactId !== void 0 ? reactId : String($8a8e9b94c33ba6d6$var$count++));
    }, [
        deterministicId
    ]);
    return deterministicId || (id ? `radix-${id}` : "");
}
$8a8e9b94c33ba6d6$var$__name($8a8e9b94c33ba6d6$export$f680877a34711e37, "useId");






var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");


var $00150e9d341c8d35$var$__defProp = Object.defineProperty;
var $00150e9d341c8d35$var$__name = (target, value)=>$00150e9d341c8d35$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $00150e9d341c8d35$export$21b07c8f274aebd5 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $00150e9d341c8d35$var$__name(function Arrow2(props, forwardedRef) {
    const { children: children, width: width = 10, height: height = 5 } = props, arrowProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "children",
        "width",
        "height"
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).svg, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arrowProps), {
        ref: forwardedRef,
        width: width,
        height: height,
        viewBox: "0 0 30 10",
        preserveAspectRatio: "none",
        children: props.asChild ? children : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("polygon", {
            points: "0,0 30,0 15,10"
        })
    }));
}, "Arrow"));
var $00150e9d341c8d35$export$be92b6f5f03c0fe9 = $00150e9d341c8d35$export$21b07c8f274aebd5;








var $7fPBF = parcelRequire("7fPBF");

var $0560b0618278acc0$var$__defProp = Object.defineProperty;
var $0560b0618278acc0$var$__name = (target, value)=>$0560b0618278acc0$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $0560b0618278acc0$export$1ab7ae714698c4b8(element) {
    const [size, setSize] = $7fPBF.useState(void 0);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (element) {
            setSize({
                width: element.offsetWidth,
                height: element.offsetHeight
            });
            const resizeObserver = new ResizeObserver((entries)=>{
                if (!Array.isArray(entries)) return;
                if (!entries.length) return;
                const entry = entries[0];
                let width;
                let height;
                if ("borderBoxSize" in entry) {
                    const borderSizeEntry = entry["borderBoxSize"];
                    const borderSize = Array.isArray(borderSizeEntry) ? borderSizeEntry[0] : borderSizeEntry;
                    width = borderSize["inlineSize"];
                    height = borderSize["blockSize"];
                } else {
                    width = element.offsetWidth;
                    height = element.offsetHeight;
                }
                setSize({
                    width: width,
                    height: height
                });
            });
            resizeObserver.observe(element, {
                box: "border-box"
            });
            return ()=>resizeObserver.unobserve(element);
        } else setSize(void 0);
    }, [
        element
    ]);
    return size;
}
$0560b0618278acc0$var$__name($0560b0618278acc0$export$1ab7ae714698c4b8, "useSize");



"use client";
var $7952cd297982b588$var$__defProp = Object.defineProperty;
var $7952cd297982b588$var$__name = (target, value)=>$7952cd297982b588$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $7952cd297982b588$export$36f0086da09c4b9f = [
    "top",
    "right",
    "bottom",
    "left"
];
var $7952cd297982b588$export$3671ffab7b302fc9 = [
    "start",
    "center",
    "end"
];
var $7952cd297982b588$var$POPPER_NAME = "Popper";
var [$7952cd297982b588$var$createPopperContext, $7952cd297982b588$export$722aac194ae923] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($7952cd297982b588$var$POPPER_NAME);
var [$7952cd297982b588$var$PopperProvider, $7952cd297982b588$var$usePopperContext] = $7952cd297982b588$var$createPopperContext($7952cd297982b588$var$POPPER_NAME);
var $7952cd297982b588$export$badac9ada3a0bdf9 = /* @__PURE__ */ $7952cd297982b588$var$__name((props)=>{
    const { __scopePopper: __scopePopper, children: children } = props;
    const [anchor, setAnchor] = $7fPBF.useState(null);
    const [placementState, setPlacementState] = $7fPBF.useState(void 0);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$var$PopperProvider, {
        scope: __scopePopper,
        anchor: anchor,
        onAnchorChange: setAnchor,
        placementState: placementState,
        setPlacementState: setPlacementState,
        children: children
    });
}, "Popper");
var $7952cd297982b588$var$ANCHOR_NAME = "PopperAnchor";
var $7952cd297982b588$export$ecd4e1ccab6ed6d = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7952cd297982b588$var$__name(function PopperAnchor2(props, forwardedRef) {
    const { __scopePopper: __scopePopper, virtualRef: virtualRef } = props, anchorProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopePopper",
        "virtualRef"
    ]);
    const context = $7952cd297982b588$var$usePopperContext($7952cd297982b588$var$ANCHOR_NAME, __scopePopper);
    const ref = $7fPBF.useRef(null);
    const onAnchorChange = context.onAnchorChange;
    const callbackRef = $7fPBF.useCallback((node)=>{
        ref.current = node;
        if (node) onAnchorChange(node);
    }, [
        onAnchorChange
    ]);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, callbackRef);
    const anchorRef = $7fPBF.useRef(null);
    $7fPBF.useEffect(()=>{
        if (!virtualRef) return;
        const previousAnchor = anchorRef.current;
        anchorRef.current = virtualRef.current;
        if (previousAnchor !== anchorRef.current) onAnchorChange(anchorRef.current);
    });
    const sideAndAlign = context.placementState && $7952cd297982b588$var$getSideAndAlignFromPlacement(context.placementState);
    const placedSide = sideAndAlign === null || sideAndAlign === void 0 ? void 0 : sideAndAlign[0];
    const placedAlign = sideAndAlign === null || sideAndAlign === void 0 ? void 0 : sideAndAlign[1];
    return virtualRef ? null : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "data-radix-popper-side": placedSide,
        "data-radix-popper-align": placedAlign
    }, anchorProps), {
        ref: composedRefs
    }));
}, "PopperAnchor"));
var $7952cd297982b588$var$CONTENT_NAME = "PopperContent";
var [$7952cd297982b588$var$PopperContentProvider, $7952cd297982b588$var$useContentContext] = $7952cd297982b588$var$createPopperContext($7952cd297982b588$var$CONTENT_NAME);
var $7952cd297982b588$export$bc4ae5855d3c4fc = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7952cd297982b588$var$__name(function PopperContent2(props, forwardedRef) {
    var _middlewareData_arrow, _middlewareData_arrow1, _middlewareData_arrow2, _middlewareData_transformOrigin, _middlewareData_transformOrigin1, _middlewareData_hide, _contentProps_style;
    const { __scopePopper: __scopePopper, side: side = "bottom", sideOffset: sideOffset = 0, align: align = "center", alignOffset: alignOffset = 0, arrowPadding: arrowPadding = 0, avoidCollisions: avoidCollisions = true, collisionBoundary: collisionBoundary = [], collisionPadding: collisionPaddingProp = 0, sticky: sticky = "partial", hideWhenDetached: hideWhenDetached = false, updatePositionStrategy: updatePositionStrategy = "optimized", onPlaced: onPlaced } = props, contentProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopePopper",
        "side",
        "sideOffset",
        "align",
        "alignOffset",
        "arrowPadding",
        "avoidCollisions",
        "collisionBoundary",
        "collisionPadding",
        "sticky",
        "hideWhenDetached",
        "updatePositionStrategy",
        "onPlaced"
    ]);
    const context = $7952cd297982b588$var$usePopperContext($7952cd297982b588$var$CONTENT_NAME, __scopePopper);
    const [content, setContent] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, setContent);
    const [arrow, setArrow] = $7fPBF.useState(null);
    const arrowSize = (0, $0560b0618278acc0$export$1ab7ae714698c4b8)(arrow);
    var _arrowSize_width;
    const arrowWidth = (_arrowSize_width = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.width) !== null && _arrowSize_width !== void 0 ? _arrowSize_width : 0;
    var _arrowSize_height;
    const arrowHeight = (_arrowSize_height = arrowSize === null || arrowSize === void 0 ? void 0 : arrowSize.height) !== null && _arrowSize_height !== void 0 ? _arrowSize_height : 0;
    const desiredPlacement = side + (align !== "center" ? "-" + align : "");
    const collisionPadding = typeof collisionPaddingProp === "number" ? collisionPaddingProp : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }, collisionPaddingProp);
    const boundary = Array.isArray(collisionBoundary) ? collisionBoundary : [
        collisionBoundary
    ];
    const hasExplicitBoundaries = boundary.length > 0;
    const detectOverflowOptions = {
        padding: collisionPadding,
        boundary: boundary.filter($7952cd297982b588$var$isNotNull),
        // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
        altBoundary: hasExplicitBoundaries
    };
    const { refs: refs, floatingStyles: floatingStyles, placement: placement, isPositioned: isPositioned, middlewareData: middlewareData } = (0, $2a1639b232695612$export$4e02a5c1d08bac65)({
        // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
        strategy: "fixed",
        placement: desiredPlacement,
        whileElementsMounted: /* @__PURE__ */ $7952cd297982b588$var$__name((...args)=>{
            const cleanup = (0, $b62109a283c86f13$export$deee3a793edee05f)(...args, {
                animationFrame: updatePositionStrategy === "always"
            });
            return cleanup;
        }, "whileElementsMounted"),
        elements: {
            reference: context.anchor
        },
        middleware: [
            (0, $2a1639b232695612$export$cc800923e997bb8)({
                mainAxis: sideOffset + arrowHeight,
                alignmentAxis: alignOffset
            }),
            avoidCollisions && (0, $2a1639b232695612$export$fba63a578e423eb)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                mainAxis: true,
                crossAxis: false,
                limiter: sticky === "partial" ? (0, $2a1639b232695612$export$7bf07e38f3dc4b69)() : void 0
            }, detectOverflowOptions)),
            avoidCollisions && (0, $2a1639b232695612$export$8a83211c878a3f1f)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, detectOverflowOptions)),
            (0, $2a1639b232695612$export$346677f925de839c)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, detectOverflowOptions), {
                apply: /* @__PURE__ */ $7952cd297982b588$var$__name(({ elements: elements, rects: rects, availableWidth: availableWidth, availableHeight: availableHeight })=>{
                    const { width: anchorWidth, height: anchorHeight } = rects.reference;
                    const contentStyle = elements.floating.style;
                    contentStyle.setProperty("--radix-popper-available-width", `${availableWidth}px`);
                    contentStyle.setProperty("--radix-popper-available-height", `${availableHeight}px`);
                    contentStyle.setProperty("--radix-popper-anchor-width", `${anchorWidth}px`);
                    contentStyle.setProperty("--radix-popper-anchor-height", `${anchorHeight}px`);
                }, "apply")
            })),
            arrow && (0, $2a1639b232695612$export$f2120bbfa5450bd2)({
                element: arrow,
                padding: arrowPadding
            }),
            $7952cd297982b588$var$transformOrigin({
                arrowWidth: arrowWidth,
                arrowHeight: arrowHeight
            }),
            hideWhenDetached && (0, $2a1639b232695612$export$fe8985bb6374093c)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                strategy: "referenceHidden"
            }, detectOverflowOptions), {
                // `hide` detects whether the anchor (reference) is clipped, so when
                // no explicit `collisionBoundary` is set we fall back to Floating
                // UI's default clipping ancestors (e.g. a scrollable menu). This
                // lets an occluded submenu hide once its anchor scrolls out of view
                // (#3237). The collision/size middlewares deliberately keep the
                // viewport-based default to avoid clamping content rendered inside
                // transformed or overflow-clipping portal containers.
                boundary: hasExplicitBoundaries ? detectOverflowOptions.boundary : void 0
            }))
        ]
    });
    const setPlacementState = context.setPlacementState;
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        setPlacementState(placement);
        return ()=>{
            setPlacementState(void 0);
        };
    }, [
        placement,
        setPlacementState
    ]);
    const [placedSide, placedAlign] = $7952cd297982b588$var$getSideAndAlignFromPlacement(placement);
    const handlePlaced = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onPlaced);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (isPositioned) handlePlaced === null || handlePlaced === void 0 ? void 0 : handlePlaced();
    }, [
        isPositioned,
        handlePlaced
    ]);
    const arrowX = (_middlewareData_arrow = middlewareData.arrow) === null || _middlewareData_arrow === void 0 ? void 0 : _middlewareData_arrow.x;
    const arrowY = (_middlewareData_arrow1 = middlewareData.arrow) === null || _middlewareData_arrow1 === void 0 ? void 0 : _middlewareData_arrow1.y;
    const cannotCenterArrow = ((_middlewareData_arrow2 = middlewareData.arrow) === null || _middlewareData_arrow2 === void 0 ? void 0 : _middlewareData_arrow2.centerOffset) !== 0;
    const [contentZIndex, setContentZIndex] = $7fPBF.useState();
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
        ref: refs.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, floatingStyles), {
            transform: isPositioned ? floatingStyles.transform : "translate(0, -200%)",
            // keep off the page when measuring
            minWidth: "max-content",
            zIndex: contentZIndex,
            "--radix-popper-transform-origin": [
                (_middlewareData_transformOrigin = middlewareData.transformOrigin) === null || _middlewareData_transformOrigin === void 0 ? void 0 : _middlewareData_transformOrigin.x,
                (_middlewareData_transformOrigin1 = middlewareData.transformOrigin) === null || _middlewareData_transformOrigin1 === void 0 ? void 0 : _middlewareData_transformOrigin1.y
            ].join(" ")
        }), ((_middlewareData_hide = middlewareData.hide) === null || _middlewareData_hide === void 0 ? void 0 : _middlewareData_hide.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
        }),
        dir: props.dir,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$var$PopperContentProvider, {
            scope: __scopePopper,
            placedSide: placedSide,
            placedAlign: placedAlign,
            onArrowChange: setArrow,
            arrowX: arrowX,
            arrowY: arrowY,
            shouldHideArrow: cannotCenterArrow,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                "data-side": placedSide,
                "data-align": placedAlign
            }, contentProps), {
                ref: composedRefs,
                style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contentProps.style), {
                    // if the PopperContent hasn't been placed yet (not all
                    // measurements done) we prevent animations so that users'
                    // animations don't kick in too early from the wrong sides.
                    animation: !isPositioned ? "none" : (_contentProps_style = contentProps.style) === null || _contentProps_style === void 0 ? void 0 : _contentProps_style.animation
                })
            }))
        })
    });
}, "PopperContent"));
var $7952cd297982b588$var$ARROW_NAME = "PopperArrow";
var $7952cd297982b588$var$OPPOSITE_SIDE = {
    top: "bottom",
    right: "left",
    bottom: "top",
    left: "right"
};
var $7952cd297982b588$export$79d62cd4e10a3fd0 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7952cd297982b588$var$__name(function PopperArrow2(props, forwardedRef) {
    const { __scopePopper: __scopePopper } = props, arrowProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopePopper"
    ]);
    const contentContext = $7952cd297982b588$var$useContentContext($7952cd297982b588$var$ARROW_NAME, __scopePopper);
    const baseSide = $7952cd297982b588$var$OPPOSITE_SIDE[contentContext.placedSide];
    return(// we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("span", {
        ref: contentContext.onArrowChange,
        style: {
            position: "absolute",
            left: contentContext.arrowX,
            top: contentContext.arrowY,
            [baseSide]: 0,
            transformOrigin: {
                top: "",
                right: "0 0",
                bottom: "center 0",
                left: "100% 0"
            }[contentContext.placedSide],
            transform: {
                top: "translateY(100%)",
                right: "translateY(50%) rotate(90deg) translateX(-50%)",
                bottom: `rotate(180deg)`,
                left: "translateY(50%) rotate(-90deg) translateX(50%)"
            }[contentContext.placedSide],
            visibility: contentContext.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($00150e9d341c8d35$export$be92b6f5f03c0fe9, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arrowProps), {
            ref: forwardedRef,
            style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, arrowProps.style), {
                // ensures the element can be measured correctly (mostly for if SVG)
                display: "block"
            })
        }))
    }));
}, "PopperArrow"));
function $7952cd297982b588$var$isNotNull(value) {
    return value !== null;
}
$7952cd297982b588$var$__name($7952cd297982b588$var$isNotNull, "isNotNull");
var $7952cd297982b588$var$transformOrigin = /* @__PURE__ */ $7952cd297982b588$var$__name((options)=>({
        name: "transformOrigin",
        options: options,
        fn (data) {
            var _middlewareData_arrow, _middlewareData_arrow1, _middlewareData_arrow2;
            const { placement: placement, rects: rects, middlewareData: middlewareData } = data;
            const cannotCenterArrow = ((_middlewareData_arrow = middlewareData.arrow) === null || _middlewareData_arrow === void 0 ? void 0 : _middlewareData_arrow.centerOffset) !== 0;
            const isArrowHidden = cannotCenterArrow;
            const arrowWidth = isArrowHidden ? 0 : options.arrowWidth;
            const arrowHeight = isArrowHidden ? 0 : options.arrowHeight;
            const [placedSide, placedAlign] = $7952cd297982b588$var$getSideAndAlignFromPlacement(placement);
            const noArrowAlign = {
                start: "0%",
                center: "50%",
                end: "100%"
            }[placedAlign];
            var _middlewareData_arrow_x;
            const arrowXCenter = ((_middlewareData_arrow_x = (_middlewareData_arrow1 = middlewareData.arrow) === null || _middlewareData_arrow1 === void 0 ? void 0 : _middlewareData_arrow1.x) !== null && _middlewareData_arrow_x !== void 0 ? _middlewareData_arrow_x : 0) + arrowWidth / 2;
            var _middlewareData_arrow_y;
            const arrowYCenter = ((_middlewareData_arrow_y = (_middlewareData_arrow2 = middlewareData.arrow) === null || _middlewareData_arrow2 === void 0 ? void 0 : _middlewareData_arrow2.y) !== null && _middlewareData_arrow_y !== void 0 ? _middlewareData_arrow_y : 0) + arrowHeight / 2;
            let x = "";
            let y = "";
            if (placedSide === "bottom") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${-arrowHeight}px`;
            } else if (placedSide === "top") {
                x = isArrowHidden ? noArrowAlign : `${arrowXCenter}px`;
                y = `${rects.floating.height + arrowHeight}px`;
            } else if (placedSide === "right") {
                x = `${-arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            } else if (placedSide === "left") {
                x = `${rects.floating.width + arrowHeight}px`;
                y = isArrowHidden ? noArrowAlign : `${arrowYCenter}px`;
            }
            return {
                data: {
                    x: x,
                    y: y
                }
            };
        }
    }), "transformOrigin");
function $7952cd297982b588$var$getSideAndAlignFromPlacement(placement) {
    const [side, align = "center"] = placement.split("-");
    return [
        side,
        align
    ];
}
$7952cd297982b588$var$__name($7952cd297982b588$var$getSideAndAlignFromPlacement, "getSideAndAlignFromPlacement");
var $7952cd297982b588$export$be92b6f5f03c0fe9 = $7952cd297982b588$export$badac9ada3a0bdf9;
var $7952cd297982b588$export$b688253958b8dfe7 = $7952cd297982b588$export$ecd4e1ccab6ed6d;
var $7952cd297982b588$export$7c6e2c02157bb7d2 = $7952cd297982b588$export$bc4ae5855d3c4fc;
var $7952cd297982b588$export$21b07c8f274aebd5 = $7952cd297982b588$export$79d62cd4e10a3fd0;






var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");



"use client";
var $57c7abe8fecdeb41$var$__defProp = Object.defineProperty;
var $57c7abe8fecdeb41$var$__name = (target, value)=>$57c7abe8fecdeb41$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $57c7abe8fecdeb41$export$602eac185826482c = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $57c7abe8fecdeb41$var$__name(function Portal2(props, forwardedRef) {
    var _globalThis_document, _globalThis;
    const { container: containerProp } = props, portalProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "container"
    ]);
    const [mounted, setMounted] = $7fPBF.useState(false);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>setMounted(true), []);
    const container = containerProp || mounted && ((_globalThis = globalThis) === null || _globalThis === void 0 ? void 0 : (_globalThis_document = _globalThis.document) === null || _globalThis_document === void 0 ? void 0 : _globalThis_document.body);
    return container ? $fw0lo.createPortal(/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, portalProps), {
        ref: forwardedRef
    })), container) : null;
}, "Portal"));
var $57c7abe8fecdeb41$export$be92b6f5f03c0fe9 = $57c7abe8fecdeb41$export$602eac185826482c;



var $7fPBF = parcelRequire("7fPBF");

"use client";
var $e9ce08b8e6e14786$var$__defProp = Object.defineProperty;
var $e9ce08b8e6e14786$var$__name = (target, value)=>$e9ce08b8e6e14786$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $e9ce08b8e6e14786$var$useStateMachine(initialState, machine) {
    return $7fPBF.useReducer((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
$e9ce08b8e6e14786$var$__name($e9ce08b8e6e14786$var$useStateMachine, "useStateMachine");
// src/presence.tsx
var $e9ce08b8e6e14786$export$99c2b779aa4e8b8b = /* @__PURE__ */ $e9ce08b8e6e14786$var$__name((props)=>{
    const { present: present, children: children } = props;
    const presence = $e9ce08b8e6e14786$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : $7fPBF.Children.only(children);
    const ref = $e9ce08b8e6e14786$var$useStableComposedRefs(presence.ref, $e9ce08b8e6e14786$var$getElementRef(child));
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? $7fPBF.cloneElement(child, {
        ref: ref
    }) : null;
}, "Presence");
function $e9ce08b8e6e14786$var$usePresence(present) {
    const [node, setNode] = $7fPBF.useState();
    const stylesRef = $7fPBF.useRef(null);
    const prevPresentRef = $7fPBF.useRef(present);
    const prevAnimationNameRef = $7fPBF.useRef("none");
    const mountAnimationNameRef = $7fPBF.useRef(void 0);
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $e9ce08b8e6e14786$var$useStateMachine(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    $7fPBF.useEffect(()=>{
        if (state === "mounted") {
            var _mountAnimationNameRef_current;
            prevAnimationNameRef.current = (_mountAnimationNameRef_current = mountAnimationNameRef.current) !== null && _mountAnimationNameRef_current !== void 0 ? _mountAnimationNameRef_current : $e9ce08b8e6e14786$var$getAnimationName(stylesRef.current);
            mountAnimationNameRef.current = void 0;
        } else prevAnimationNameRef.current = "none";
    }, [
        state
    ]);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $e9ce08b8e6e14786$var$getAnimationName(styles);
            if (present) {
                mountAnimationNameRef.current = currentAnimationName;
                send("MOUNT");
            } else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") send("UNMOUNT");
            else {
                const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (node) {
            let timeoutId;
            var _node_ownerDocument_defaultView;
            const ownerWindow = (_node_ownerDocument_defaultView = node.ownerDocument.defaultView) !== null && _node_ownerDocument_defaultView !== void 0 ? _node_ownerDocument_defaultView : window;
            const handleAnimationEnd = /* @__PURE__ */ $e9ce08b8e6e14786$var$__name((event)=>{
                const currentAnimationName = $e9ce08b8e6e14786$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(CSS.escape(event.animationName));
                if (event.target === node && isCurrentAnimation) {
                    send("ANIMATION_END");
                    if (!prevPresentRef.current) {
                        const currentFillMode = node.style.animationFillMode;
                        node.style.animationFillMode = "forwards";
                        timeoutId = ownerWindow.setTimeout(()=>{
                            if (node.style.animationFillMode === "forwards") node.style.animationFillMode = currentFillMode;
                        });
                    }
                }
            }, "handleAnimationEnd");
            const handleAnimationStart = /* @__PURE__ */ $e9ce08b8e6e14786$var$__name((event)=>{
                if (event.target === node) prevAnimationNameRef.current = $e9ce08b8e6e14786$var$getAnimationName(stylesRef.current);
            }, "handleAnimationStart");
            node.addEventListener("animationstart", handleAnimationStart);
            node.addEventListener("animationcancel", handleAnimationEnd);
            node.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                ownerWindow.clearTimeout(timeoutId);
                node.removeEventListener("animationstart", handleAnimationStart);
                node.removeEventListener("animationcancel", handleAnimationEnd);
                node.removeEventListener("animationend", handleAnimationEnd);
            };
        } else send("ANIMATION_END");
    }, [
        node,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: $7fPBF.useCallback((node2)=>{
            if (node2) {
                const styles = getComputedStyle(node2);
                stylesRef.current = styles;
                mountAnimationNameRef.current = $e9ce08b8e6e14786$var$getAnimationName(styles);
            } else stylesRef.current = null;
            setNode(node2);
        }, [])
    };
}
$e9ce08b8e6e14786$var$__name($e9ce08b8e6e14786$var$usePresence, "usePresence");
function $e9ce08b8e6e14786$var$setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
$e9ce08b8e6e14786$var$__name($e9ce08b8e6e14786$var$setRef, "setRef");
function $e9ce08b8e6e14786$var$useStableComposedRefs(...refs) {
    const refsRef = $7fPBF.useRef(refs);
    refsRef.current = refs;
    return $7fPBF.useCallback((node)=>{
        const currentRefs = refsRef.current;
        let hasCleanup = false;
        const cleanups = currentRefs.map((ref)=>{
            const cleanup = $e9ce08b8e6e14786$var$setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else $e9ce08b8e6e14786$var$setRef(currentRefs[i], null);
            }
        };
    }, []);
}
$e9ce08b8e6e14786$var$__name($e9ce08b8e6e14786$var$useStableComposedRefs, "useStableComposedRefs");
function $e9ce08b8e6e14786$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}
$e9ce08b8e6e14786$var$__name($e9ce08b8e6e14786$var$getAnimationName, "getAnimationName");
function $e9ce08b8e6e14786$var$getElementRef(element) {
    var _Object_getOwnPropertyDescriptor, _Object_getOwnPropertyDescriptor1;
    let getter = (_Object_getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor(element.props, "ref")) === null || _Object_getOwnPropertyDescriptor === void 0 ? void 0 : _Object_getOwnPropertyDescriptor.get;
    let mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.ref;
    getter = (_Object_getOwnPropertyDescriptor1 = Object.getOwnPropertyDescriptor(element, "ref")) === null || _Object_getOwnPropertyDescriptor1 === void 0 ? void 0 : _Object_getOwnPropertyDescriptor1.get;
    mayWarn = getter && "isReactWarning" in getter && getter.isReactWarning;
    if (mayWarn) return element.props.ref;
    return element.props.ref || element.ref;
}
$e9ce08b8e6e14786$var$__name($e9ce08b8e6e14786$var$getElementRef, "getElementRef");
var $e9ce08b8e6e14786$export$be92b6f5f03c0fe9 = $e9ce08b8e6e14786$export$99c2b779aa4e8b8b;








var $7fPBF = parcelRequire("7fPBF");
// src/internal/is-development.false.ts
var $26b09300b1f75f81$export$26928cc6c201953c = false;





var $7fPBF = parcelRequire("7fPBF");
var $016579ec1f1cff64$var$__defProp = Object.defineProperty;
var $016579ec1f1cff64$var$__name = (target, value)=>$016579ec1f1cff64$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $016579ec1f1cff64$var$useReactEffectEvent = $7fPBF[" useEffectEvent ".trim().toString()];
var $016579ec1f1cff64$var$useReactInsertionEffect = $7fPBF[" useInsertionEffect ".trim().toString()];
function $016579ec1f1cff64$export$7f54fc3180508a52(callback) {
    if (typeof $016579ec1f1cff64$var$useReactEffectEvent === "function") return $016579ec1f1cff64$var$useReactEffectEvent(callback);
    const ref = $7fPBF.useRef(()=>{
        throw new Error("Cannot call an event handler while rendering.");
    });
    if (typeof $016579ec1f1cff64$var$useReactInsertionEffect === "function") $016579ec1f1cff64$var$useReactInsertionEffect(()=>{
        ref.current = callback;
    });
    else (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        ref.current = callback;
    });
    return $7fPBF.useMemo(()=>(...args)=>{
            var _ref_current;
            return (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.call(ref, ...args);
        }, []);
}
$016579ec1f1cff64$var$__name($016579ec1f1cff64$export$7f54fc3180508a52, "useEffectEvent");


var $915387e6ab4d88b1$var$__defProp = Object.defineProperty;
var $915387e6ab4d88b1$var$__name = (target, value)=>$915387e6ab4d88b1$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $915387e6ab4d88b1$var$useInsertionEffect = $7fPBF[" useInsertionEffect ".trim().toString()] || (0, $191a4e5730438e92$export$e5c5a5f917a5871c);
function $915387e6ab4d88b1$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = /* @__PURE__ */ $915387e6ab4d88b1$var$__name(()=>{}, "onChange"), caller: caller }) {
    const [uncontrolledProp, setUncontrolledProp, onChangeRef] = $915387e6ab4d88b1$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== void 0;
    const value = isControlled ? prop : uncontrolledProp;
    if (0, $26b09300b1f75f81$export$26928cc6c201953c) {
        const isControlledRef = $7fPBF.useRef(prop !== void 0);
        $7fPBF.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const setValue = $7fPBF.useCallback((nextValue)=>{
        if (isControlled) {
            var _onChangeRef_current;
            const value2 = $915387e6ab4d88b1$var$isFunction(nextValue) ? nextValue(prop) : nextValue;
            if (value2 !== prop) (_onChangeRef_current = onChangeRef.current) === null || _onChangeRef_current === void 0 ? void 0 : _onChangeRef_current.call(onChangeRef, value2);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        onChangeRef
    ]);
    return [
        value,
        setValue
    ];
}
$915387e6ab4d88b1$var$__name($915387e6ab4d88b1$export$6f32135080cb4c3, "useControllableState");
function $915387e6ab4d88b1$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const [value, setValue] = $7fPBF.useState(defaultProp);
    const prevValueRef = $7fPBF.useRef(value);
    const onChangeRef = $7fPBF.useRef(onChange);
    $915387e6ab4d88b1$var$useInsertionEffect(()=>{
        onChangeRef.current = onChange;
    }, [
        onChange
    ]);
    $7fPBF.useEffect(()=>{
        if (prevValueRef.current !== value) {
            var _onChangeRef_current;
            (_onChangeRef_current = onChangeRef.current) === null || _onChangeRef_current === void 0 ? void 0 : _onChangeRef_current.call(onChangeRef, value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef
    ]);
    return [
        value,
        setValue,
        onChangeRef
    ];
}
$915387e6ab4d88b1$var$__name($915387e6ab4d88b1$var$useUncontrolledState, "useUncontrolledState");
function $915387e6ab4d88b1$var$isFunction(value) {
    return typeof value === "function";
}
$915387e6ab4d88b1$var$__name($915387e6ab4d88b1$var$isFunction, "isFunction");
var $915387e6ab4d88b1$var$SYNC_STATE = Symbol("RADIX:SYNC_STATE");
function $915387e6ab4d88b1$export$bf6fc034f0c038af(reducer, userArgs, initialArg, init) {
    const { prop: controlledState, defaultProp: defaultProp, onChange: onChangeProp, caller: caller } = userArgs;
    const isControlled = controlledState !== void 0;
    const onChange = (0, $016579ec1f1cff64$export$7f54fc3180508a52)(onChangeProp);
    if (0, $26b09300b1f75f81$export$26928cc6c201953c) {
        const isControlledRef = $7fPBF.useRef(controlledState !== void 0);
        $7fPBF.useEffect(()=>{
            const wasControlled = isControlledRef.current;
            if (wasControlled !== isControlled) {
                const from = wasControlled ? "controlled" : "uncontrolled";
                const to = isControlled ? "controlled" : "uncontrolled";
                console.warn(`${caller} is changing from ${from} to ${to}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`);
            }
            isControlledRef.current = isControlled;
        }, [
            isControlled,
            caller
        ]);
    }
    const args = [
        (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, initialArg), {
            state: defaultProp
        })
    ];
    if (init) args.push(init);
    const [internalState, dispatch] = $7fPBF.useReducer((state2, action)=>{
        if (action.type === $915387e6ab4d88b1$var$SYNC_STATE) return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state2), {
            state: action.state
        });
        const next = reducer(state2, action);
        if (isControlled && !Object.is(next.state, state2.state)) onChange(next.state);
        return next;
    }, ...args);
    const uncontrolledState = internalState.state;
    const prevValueRef = $7fPBF.useRef(uncontrolledState);
    $7fPBF.useEffect(()=>{
        if (prevValueRef.current !== uncontrolledState) {
            prevValueRef.current = uncontrolledState;
            if (!isControlled) onChange(uncontrolledState);
        }
    }, [
        uncontrolledState,
        prevValueRef,
        isControlled
    ]);
    const state = $7fPBF.useMemo(()=>{
        const isControlled2 = controlledState !== void 0;
        if (isControlled2) return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, internalState), {
            state: controlledState
        });
        return internalState;
    }, [
        internalState,
        controlledState
    ]);
    $7fPBF.useEffect(()=>{
        if (isControlled && !Object.is(controlledState, internalState.state)) dispatch({
            type: $915387e6ab4d88b1$var$SYNC_STATE,
            state: controlledState
        });
    }, [
        controlledState,
        internalState.state,
        isControlled
    ]);
    return [
        state,
        dispatch
    ];
}
$915387e6ab4d88b1$var$__name($915387e6ab4d88b1$export$bf6fc034f0c038af, "useControllableStateReducer");




var $7fPBF = parcelRequire("7fPBF");
var $62f6e650b37fb598$var$__defProp = Object.defineProperty;
var $62f6e650b37fb598$var$__name = (target, value)=>$62f6e650b37fb598$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
function $62f6e650b37fb598$export$5cae361ad82dce8b(value) {
    const ref = $7fPBF.useRef({
        value: value,
        previous: value
    });
    return $7fPBF.useMemo(()=>{
        if (ref.current.value !== value) {
            ref.current.previous = ref.current.value;
            ref.current.value = value;
        }
        return ref.current.previous;
    }, [
        value
    ]);
}
$62f6e650b37fb598$var$__name($62f6e650b37fb598$export$5cae361ad82dce8b, "usePrevious");





var $7fPBF = parcelRequire("7fPBF");


var $28c8fa82e4cfdc1a$var$__defProp = Object.defineProperty;
var $28c8fa82e4cfdc1a$var$__name = (target, value)=>$28c8fa82e4cfdc1a$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $28c8fa82e4cfdc1a$export$f23ec2f542b3b173 = Object.freeze({
    // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal"
});
var $28c8fa82e4cfdc1a$export$439d29a4e110a164 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $28c8fa82e4cfdc1a$var$__name(function VisuallyHidden2(props, forwardedRef) {
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        ref: forwardedRef,
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $28c8fa82e4cfdc1a$export$f23ec2f542b3b173, props.style)
    }));
}, "VisuallyHidden"));
var $28c8fa82e4cfdc1a$export$be92b6f5f03c0fe9 = $28c8fa82e4cfdc1a$export$439d29a4e110a164;


var $2950574f4b60c018$var$getDefaultParent = function(originalTarget) {
    if (typeof document === 'undefined') return null;
    var sampleTarget = Array.isArray(originalTarget) ? originalTarget[0] : originalTarget;
    return sampleTarget.ownerDocument.body;
};
var $2950574f4b60c018$var$counterMap = new WeakMap();
var $2950574f4b60c018$var$uncontrolledNodes = new WeakMap();
var $2950574f4b60c018$var$markerMap = {};
var $2950574f4b60c018$var$lockCount = 0;
var $2950574f4b60c018$var$unwrapHost = function(node) {
    return node && (node.host || $2950574f4b60c018$var$unwrapHost(node.parentNode));
};
var $2950574f4b60c018$var$correctTargets = function(parent, targets) {
    return targets.map(function(target) {
        if (parent.contains(target)) return target;
        var correctedTarget = $2950574f4b60c018$var$unwrapHost(target);
        if (correctedTarget && parent.contains(correctedTarget)) return correctedTarget;
        console.error('aria-hidden', target, 'in not contained inside', parent, '. Doing nothing');
        return null;
    }).filter(function(x) {
        return Boolean(x);
    });
};
/**
 * Marks everything except given node(or nodes) as aria-hidden
 * @param {Element | Element[]} originalTarget - elements to keep on the page
 * @param [parentNode] - top element, defaults to document.body
 * @param {String} [markerName] - a special attribute to mark every node
 * @param {String} [controlAttribute] - html Attribute to control
 * @return {Undo} undo command
 */ var $2950574f4b60c018$var$applyAttributeToOthers = function(originalTarget, parentNode, markerName, controlAttribute) {
    var targets = $2950574f4b60c018$var$correctTargets(parentNode, Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    if (!$2950574f4b60c018$var$markerMap[markerName]) $2950574f4b60c018$var$markerMap[markerName] = new WeakMap();
    var markerCounter = $2950574f4b60c018$var$markerMap[markerName];
    var hiddenNodes = [];
    var elementsToKeep = new Set();
    var elementsToStop = new Set(targets);
    var keep = function(el) {
        if (!el || elementsToKeep.has(el)) return;
        elementsToKeep.add(el);
        keep(el.parentNode);
    };
    targets.forEach(keep);
    var deep = function(parent) {
        if (!parent || elementsToStop.has(parent)) return;
        Array.prototype.forEach.call(parent.children, function(node) {
            if (elementsToKeep.has(node)) deep(node);
            else try {
                var attr = node.getAttribute(controlAttribute);
                var alreadyHidden = attr !== null && attr !== 'false';
                var counterValue = ($2950574f4b60c018$var$counterMap.get(node) || 0) + 1;
                var markerValue = (markerCounter.get(node) || 0) + 1;
                $2950574f4b60c018$var$counterMap.set(node, counterValue);
                markerCounter.set(node, markerValue);
                hiddenNodes.push(node);
                if (counterValue === 1 && alreadyHidden) $2950574f4b60c018$var$uncontrolledNodes.set(node, true);
                if (markerValue === 1) node.setAttribute(markerName, 'true');
                if (!alreadyHidden) node.setAttribute(controlAttribute, 'true');
            } catch (e) {
                console.error('aria-hidden: cannot operate on ', node, e);
            }
        });
    };
    deep(parentNode);
    elementsToKeep.clear();
    $2950574f4b60c018$var$lockCount++;
    return function() {
        hiddenNodes.forEach(function(node) {
            var counterValue = $2950574f4b60c018$var$counterMap.get(node) - 1;
            var markerValue = markerCounter.get(node) - 1;
            $2950574f4b60c018$var$counterMap.set(node, counterValue);
            markerCounter.set(node, markerValue);
            if (!counterValue) {
                if (!$2950574f4b60c018$var$uncontrolledNodes.has(node)) node.removeAttribute(controlAttribute);
                $2950574f4b60c018$var$uncontrolledNodes.delete(node);
            }
            if (!markerValue) node.removeAttribute(markerName);
        });
        $2950574f4b60c018$var$lockCount--;
        if (!$2950574f4b60c018$var$lockCount) {
            // clear
            $2950574f4b60c018$var$counterMap = new WeakMap();
            $2950574f4b60c018$var$counterMap = new WeakMap();
            $2950574f4b60c018$var$uncontrolledNodes = new WeakMap();
            $2950574f4b60c018$var$markerMap = {};
        }
    };
};
var $2950574f4b60c018$export$6e33d16126ed003c = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-aria-hidden';
    var targets = Array.from(Array.isArray(originalTarget) ? originalTarget : [
        originalTarget
    ]);
    var activeParentNode = parentNode || $2950574f4b60c018$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    // we should not hide aria-live elements - https://github.com/theKashey/aria-hidden/issues/10
    // and script elements, as they have no impact on accessibility.
    targets.push.apply(targets, Array.from(activeParentNode.querySelectorAll('[aria-live], script')));
    return $2950574f4b60c018$var$applyAttributeToOthers(targets, activeParentNode, markerName, 'aria-hidden');
};
var $2950574f4b60c018$export$59151cc8db999a24 = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-inert-ed';
    var activeParentNode = parentNode || $2950574f4b60c018$var$getDefaultParent(originalTarget);
    if (!activeParentNode) return function() {
        return null;
    };
    return $2950574f4b60c018$var$applyAttributeToOthers(originalTarget, activeParentNode, markerName, 'inert');
};
var $2950574f4b60c018$export$cc95fea82d705fca = function() {
    return typeof HTMLElement !== 'undefined' && HTMLElement.prototype.hasOwnProperty('inert');
};
var $2950574f4b60c018$export$9845d4b6bdad192b = function(originalTarget, parentNode, markerName) {
    if (markerName === void 0) markerName = 'data-suppressed';
    return ($2950574f4b60c018$export$cc95fea82d705fca() ? $2950574f4b60c018$export$59151cc8db999a24 : $2950574f4b60c018$export$6e33d16126ed003c)(originalTarget, parentNode, markerName);
};


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $75d33c26c5e72e04$var$extendStatics = function(d, b) {
    $75d33c26c5e72e04$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $75d33c26c5e72e04$var$extendStatics(d, b);
};
function $75d33c26c5e72e04$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $75d33c26c5e72e04$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $75d33c26c5e72e04$export$18ce0697a983be9b = function() {
    $75d33c26c5e72e04$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $75d33c26c5e72e04$export$18ce0697a983be9b.apply(this, arguments);
};
function $75d33c26c5e72e04$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $75d33c26c5e72e04$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $75d33c26c5e72e04$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $75d33c26c5e72e04$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $75d33c26c5e72e04$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $75d33c26c5e72e04$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $75d33c26c5e72e04$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $75d33c26c5e72e04$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $75d33c26c5e72e04$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $75d33c26c5e72e04$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $75d33c26c5e72e04$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $75d33c26c5e72e04$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $75d33c26c5e72e04$export$45d3717a4c69092e(o, m, p);
}
function $75d33c26c5e72e04$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $75d33c26c5e72e04$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $75d33c26c5e72e04$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($75d33c26c5e72e04$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $75d33c26c5e72e04$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $75d33c26c5e72e04$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $75d33c26c5e72e04$export$10c90e4f7922046c(v) {
    return this instanceof $75d33c26c5e72e04$export$10c90e4f7922046c ? (this.v = v, this) : new $75d33c26c5e72e04$export$10c90e4f7922046c(v);
}
function $75d33c26c5e72e04$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $75d33c26c5e72e04$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $75d33c26c5e72e04$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $75d33c26c5e72e04$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $75d33c26c5e72e04$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $75d33c26c5e72e04$export$19a8beecd37a4c45 === "function" ? $75d33c26c5e72e04$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $75d33c26c5e72e04$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $75d33c26c5e72e04$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $75d33c26c5e72e04$var$ownKeys = function(o) {
    $75d33c26c5e72e04$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $75d33c26c5e72e04$var$ownKeys(o);
};
function $75d33c26c5e72e04$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $75d33c26c5e72e04$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $75d33c26c5e72e04$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $75d33c26c5e72e04$var$__setModuleDefault(result, mod);
    return result;
}
function $75d33c26c5e72e04$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $75d33c26c5e72e04$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $75d33c26c5e72e04$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $75d33c26c5e72e04$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $75d33c26c5e72e04$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $75d33c26c5e72e04$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $75d33c26c5e72e04$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $75d33c26c5e72e04$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $75d33c26c5e72e04$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $75d33c26c5e72e04$export$2e2bcd8739ae039 = {
    __extends: $75d33c26c5e72e04$export$a8ba968b8961cb8a,
    __assign: $75d33c26c5e72e04$export$18ce0697a983be9b,
    __rest: $75d33c26c5e72e04$export$3c9a16f847548506,
    __decorate: $75d33c26c5e72e04$export$29e00dfd3077644b,
    __param: $75d33c26c5e72e04$export$d5ad3fd78186038f,
    __esDecorate: $75d33c26c5e72e04$export$3a84e1ae4e97e9b0,
    __runInitializers: $75d33c26c5e72e04$export$d831c04e792af3d,
    __propKey: $75d33c26c5e72e04$export$6a2a36740a146cb8,
    __setFunctionName: $75d33c26c5e72e04$export$d1a06452d3489bc7,
    __metadata: $75d33c26c5e72e04$export$f1db080c865becb9,
    __awaiter: $75d33c26c5e72e04$export$1050f835b63b671e,
    __generator: $75d33c26c5e72e04$export$67ebef60e6f28a6,
    __createBinding: $75d33c26c5e72e04$export$45d3717a4c69092e,
    __exportStar: $75d33c26c5e72e04$export$f33643c0debef087,
    __values: $75d33c26c5e72e04$export$19a8beecd37a4c45,
    __read: $75d33c26c5e72e04$export$8d051b38c9118094,
    __spread: $75d33c26c5e72e04$export$afc72e2116322959,
    __spreadArrays: $75d33c26c5e72e04$export$6388937ca91ccae8,
    __spreadArray: $75d33c26c5e72e04$export$1216008129fb82ed,
    __await: $75d33c26c5e72e04$export$10c90e4f7922046c,
    __asyncGenerator: $75d33c26c5e72e04$export$e427f37a30a4de9b,
    __asyncDelegator: $75d33c26c5e72e04$export$bbd80228419bb833,
    __asyncValues: $75d33c26c5e72e04$export$e3b29a3d6162315f,
    __makeTemplateObject: $75d33c26c5e72e04$export$4fb47efe1390b86f,
    __importStar: $75d33c26c5e72e04$export$c21735bcef00d192,
    __importDefault: $75d33c26c5e72e04$export$da59b14a69baef04,
    __classPrivateFieldGet: $75d33c26c5e72e04$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $75d33c26c5e72e04$export$d40a35129aaff81f,
    __classPrivateFieldIn: $75d33c26c5e72e04$export$81fdc39f203e4e04,
    __addDisposableResource: $75d33c26c5e72e04$export$88ac25d8e944e405,
    __disposeResources: $75d33c26c5e72e04$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $75d33c26c5e72e04$export$889dfb5d17574b0b
};



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
var $a41a233da3336aff$export$1da7500147d4bc3 = 'right-scroll-bar-position';
var $a41a233da3336aff$export$898e37bbd2a0ae4e = 'width-before-scroll-bar';
var $a41a233da3336aff$export$bb813dfbbc432abc = 'with-scroll-bars-hidden';
var $a41a233da3336aff$export$63d0edf80fea83b1 = '--removed-body-scroll-bar-size';



var $7fPBF = parcelRequire("7fPBF");
/**
 * Assigns a value for a given ref, no matter of the ref format
 * @param {RefObject} ref - a callback function or ref object
 * @param value - a new value
 *
 * @see https://github.com/theKashey/use-callback-ref#assignref
 * @example
 * const refObject = useRef();
 * const refFn = (ref) => {....}
 *
 * assignRef(refObject, "refValue");
 * assignRef(refFn, "refValue");
 */ function $b92e63d00f44a32a$export$d734136a7b018efe(ref, value) {
    if (typeof ref === 'function') ref(value);
    else if (ref) ref.current = value;
    return ref;
}



var $7fPBF = parcelRequire("7fPBF");
function $9852bc1860f56139$export$25bec8c6f54ee79a(initialValue, callback) {
    var ref = (0, $7fPBF.useState)(function() {
        return {
            // value
            value: initialValue,
            // last callback
            callback: callback,
            // "memoized" public interface
            facade: {
                get current () {
                    return ref.value;
                },
                set current (value){
                    var last = ref.value;
                    if (last !== value) {
                        ref.value = value;
                        ref.callback(value, last);
                    }
                }
            }
        };
    })[0];
    // update callback
    ref.callback = callback;
    return ref.facade;
}


var $3aa02bc85fadbfb9$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' ? $7fPBF.useLayoutEffect : $7fPBF.useEffect;
var $3aa02bc85fadbfb9$var$currentValues = new WeakMap();
function $3aa02bc85fadbfb9$export$74665b213cb5c4cf(refs, defaultValue) {
    var callbackRef = (0, $9852bc1860f56139$export$25bec8c6f54ee79a)(defaultValue || null, function(newValue) {
        return refs.forEach(function(ref) {
            return (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, newValue);
        });
    });
    // handle refs changes - added or removed
    $3aa02bc85fadbfb9$var$useIsomorphicLayoutEffect(function() {
        var oldValue = $3aa02bc85fadbfb9$var$currentValues.get(callbackRef);
        if (oldValue) {
            var prevRefs_1 = new Set(oldValue);
            var nextRefs_1 = new Set(refs);
            var current_1 = callbackRef.current;
            prevRefs_1.forEach(function(ref) {
                if (!nextRefs_1.has(ref)) (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, null);
            });
            nextRefs_1.forEach(function(ref) {
                if (!prevRefs_1.has(ref)) (0, $b92e63d00f44a32a$export$d734136a7b018efe)(ref, current_1);
            });
        }
        $3aa02bc85fadbfb9$var$currentValues.set(callbackRef, refs);
    }, [
        refs
    ]);
    return callbackRef;
}



function $efceb32ecd78f18d$var$ItoI(a) {
    return a;
}
function $efceb32ecd78f18d$var$innerCreateMedium(defaults, middleware) {
    if (middleware === void 0) middleware = $efceb32ecd78f18d$var$ItoI;
    var buffer = [];
    var assigned = false;
    var medium = {
        read: function() {
            if (assigned) throw new Error('Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.');
            if (buffer.length) return buffer[buffer.length - 1];
            return defaults;
        },
        useMedium: function(data) {
            var item = middleware(data, assigned);
            buffer.push(item);
            return function() {
                buffer = buffer.filter(function(x) {
                    return x !== item;
                });
            };
        },
        assignSyncMedium: function(cb) {
            assigned = true;
            while(buffer.length){
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
            }
            buffer = {
                push: function(x) {
                    return cb(x);
                },
                filter: function() {
                    return buffer;
                }
            };
        },
        assignMedium: function(cb) {
            assigned = true;
            var pendingQueue = [];
            if (buffer.length) {
                var cbs = buffer;
                buffer = [];
                cbs.forEach(cb);
                pendingQueue = buffer;
            }
            var executeQueue = function() {
                var cbs = pendingQueue;
                pendingQueue = [];
                cbs.forEach(cb);
            };
            var cycle = function() {
                return Promise.resolve().then(executeQueue);
            };
            cycle();
            buffer = {
                push: function(x) {
                    pendingQueue.push(x);
                    cycle();
                },
                filter: function(filter) {
                    pendingQueue = pendingQueue.filter(filter);
                    return buffer;
                }
            };
        }
    };
    return medium;
}
function $efceb32ecd78f18d$export$9ffbfcaf067b02c6(defaults, middleware) {
    if (middleware === void 0) middleware = $efceb32ecd78f18d$var$ItoI;
    return $efceb32ecd78f18d$var$innerCreateMedium(defaults, middleware);
}
function $efceb32ecd78f18d$export$e13ec7dd7a14088d(options) {
    if (options === void 0) options = {};
    var medium = $efceb32ecd78f18d$var$innerCreateMedium(null);
    medium.options = (0, $75d33c26c5e72e04$export$18ce0697a983be9b)({
        async: true,
        ssr: false
    }, options);
    return medium;
}


var $fbab39904a684810$export$e27363444bedfeac = (0, $efceb32ecd78f18d$export$e13ec7dd7a14088d)();


var $25d27fc5e29f9d4f$var$nothing = function() {
    return;
};
/**
 * Removes scrollbar from the page and contain the scroll within the Lock
 */ var $25d27fc5e29f9d4f$export$22940b497e769dee = $7fPBF.forwardRef(function(props, parentRef) {
    var ref = $7fPBF.useRef(null);
    var _a = $7fPBF.useState({
        onScrollCapture: $25d27fc5e29f9d4f$var$nothing,
        onWheelCapture: $25d27fc5e29f9d4f$var$nothing,
        onTouchMoveCapture: $25d27fc5e29f9d4f$var$nothing
    }), callbacks = _a[0], setCallbacks = _a[1];
    var forwardProps = props.forwardProps, children = props.children, className = props.className, removeScrollBar = props.removeScrollBar, enabled = props.enabled, shards = props.shards, sideCar = props.sideCar, noRelative = props.noRelative, noIsolation = props.noIsolation, inert = props.inert, allowPinchZoom = props.allowPinchZoom, _b = props.as, Container = _b === void 0 ? 'div' : _b, gapMode = props.gapMode, rest = (0, $75d33c26c5e72e04$export$3c9a16f847548506)(props, [
        "forwardProps",
        "children",
        "className",
        "removeScrollBar",
        "enabled",
        "shards",
        "sideCar",
        "noRelative",
        "noIsolation",
        "inert",
        "allowPinchZoom",
        "as",
        "gapMode"
    ]);
    var SideCar = sideCar;
    var containerRef = (0, $3aa02bc85fadbfb9$export$74665b213cb5c4cf)([
        ref,
        parentRef
    ]);
    var containerProps = (0, $75d33c26c5e72e04$export$18ce0697a983be9b)((0, $75d33c26c5e72e04$export$18ce0697a983be9b)({}, rest), callbacks);
    return $7fPBF.createElement($7fPBF.Fragment, null, enabled && $7fPBF.createElement(SideCar, {
        sideCar: (0, $fbab39904a684810$export$e27363444bedfeac),
        removeScrollBar: removeScrollBar,
        shards: shards,
        noRelative: noRelative,
        noIsolation: noIsolation,
        inert: inert,
        setCallbacks: setCallbacks,
        allowPinchZoom: !!allowPinchZoom,
        lockRef: ref,
        gapMode: gapMode
    }), forwardProps ? $7fPBF.cloneElement($7fPBF.Children.only(children), (0, $75d33c26c5e72e04$export$18ce0697a983be9b)((0, $75d33c26c5e72e04$export$18ce0697a983be9b)({}, containerProps), {
        ref: containerRef
    })) : $7fPBF.createElement(Container, (0, $75d33c26c5e72e04$export$18ce0697a983be9b)({}, containerProps, {
        className: className,
        ref: containerRef
    }), children));
});
$25d27fc5e29f9d4f$export$22940b497e769dee.defaultProps = {
    enabled: true,
    removeScrollBar: true,
    inert: false
};
$25d27fc5e29f9d4f$export$22940b497e769dee.classNames = {
    fullWidth: (0, $a41a233da3336aff$export$898e37bbd2a0ae4e),
    zeroRight: (0, $a41a233da3336aff$export$1da7500147d4bc3)
};




var $7fPBF = parcelRequire("7fPBF");
var $e6d091439ffe4730$var$SideCar = function(_a) {
    var sideCar = _a.sideCar, rest = (0, $75d33c26c5e72e04$export$3c9a16f847548506)(_a, [
        "sideCar"
    ]);
    if (!sideCar) throw new Error('Sidecar: please provide `sideCar` property to import the right car');
    var Target = sideCar.read();
    if (!Target) throw new Error('Sidecar medium not found');
    return $7fPBF.createElement(Target, (0, $75d33c26c5e72e04$export$18ce0697a983be9b)({}, rest));
};
$e6d091439ffe4730$var$SideCar.isSideCarExport = true;
function $e6d091439ffe4730$export$6cacc8fb0a9b94ce(medium, exported) {
    medium.useMedium(exported);
    return $e6d091439ffe4730$var$SideCar;
}




var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
var $9f919e109ac196c0$var$currentNonce;
var $9f919e109ac196c0$export$c5f670b24c0ae95a = function(nonce) {
    $9f919e109ac196c0$var$currentNonce = nonce;
};
var $9f919e109ac196c0$export$2b85b721e524d74b = function() {
    if ($9f919e109ac196c0$var$currentNonce) return $9f919e109ac196c0$var$currentNonce;
    if (typeof __webpack_nonce__ !== 'undefined') return __webpack_nonce__;
    return undefined;
};


function $5ffdb52866173f3a$var$makeStyleTag() {
    if (!document) return null;
    var tag = document.createElement('style');
    tag.type = 'text/css';
    var nonce = (0, $9f919e109ac196c0$export$2b85b721e524d74b)();
    if (nonce) tag.setAttribute('nonce', nonce);
    return tag;
}
function $5ffdb52866173f3a$var$injectStyles(tag, css) {
    // @ts-ignore
    if (tag.styleSheet) // @ts-ignore
    tag.styleSheet.cssText = css;
    else tag.appendChild(document.createTextNode(css));
}
function $5ffdb52866173f3a$var$insertStyleTag(tag) {
    var head = document.head || document.getElementsByTagName('head')[0];
    head.appendChild(tag);
}
var $5ffdb52866173f3a$export$7c74eec858d5d226 = function() {
    var counter = 0;
    var stylesheet = null;
    return {
        add: function(style) {
            if (counter == 0) {
                if (stylesheet = $5ffdb52866173f3a$var$makeStyleTag()) {
                    $5ffdb52866173f3a$var$injectStyles(stylesheet, style);
                    $5ffdb52866173f3a$var$insertStyleTag(stylesheet);
                }
            }
            counter++;
        },
        remove: function() {
            counter--;
            if (!counter && stylesheet) {
                stylesheet.parentNode && stylesheet.parentNode.removeChild(stylesheet);
                stylesheet = null;
            }
        }
    };
};


var $8227302f574dc881$export$7d7b35c2d250e94c = function() {
    var sheet = (0, $5ffdb52866173f3a$export$7c74eec858d5d226)();
    return function(styles, isDynamic) {
        $7fPBF.useEffect(function() {
            sheet.add(styles);
            return function() {
                sheet.remove();
            };
        }, [
            styles && isDynamic
        ]);
    };
};


var $6c29cb1f12180b44$export$c1248ee86ba532c8 = function() {
    var useStyle = (0, $8227302f574dc881$export$7d7b35c2d250e94c)();
    var Sheet = function(_a) {
        var styles = _a.styles, dynamic = _a.dynamic;
        useStyle(styles, dynamic);
        return null;
    };
    return Sheet;
};







var $f5b4e81188fb2e0b$export$efed13b5d0ca3386 = {
    left: 0,
    top: 0,
    right: 0,
    gap: 0
};
var $f5b4e81188fb2e0b$var$parse = function(x) {
    return parseInt(x || '', 10) || 0;
};
var $f5b4e81188fb2e0b$var$getOffset = function(gapMode) {
    var cs = window.getComputedStyle(document.body);
    var left = cs[gapMode === 'padding' ? 'paddingLeft' : 'marginLeft'];
    var top = cs[gapMode === 'padding' ? 'paddingTop' : 'marginTop'];
    var right = cs[gapMode === 'padding' ? 'paddingRight' : 'marginRight'];
    return [
        $f5b4e81188fb2e0b$var$parse(left),
        $f5b4e81188fb2e0b$var$parse(top),
        $f5b4e81188fb2e0b$var$parse(right)
    ];
};
var $f5b4e81188fb2e0b$export$75f2ca8f029c77f4 = function(gapMode) {
    if (gapMode === void 0) gapMode = 'margin';
    if (typeof window === 'undefined') return $f5b4e81188fb2e0b$export$efed13b5d0ca3386;
    var offsets = $f5b4e81188fb2e0b$var$getOffset(gapMode);
    var documentWidth = document.documentElement.clientWidth;
    var windowWidth = window.innerWidth;
    return {
        left: offsets[0],
        top: offsets[1],
        right: offsets[2],
        gap: Math.max(0, windowWidth - documentWidth + offsets[2] - offsets[0])
    };
};


var $b90eb6861b0073ed$var$Style = (0, $6c29cb1f12180b44$export$c1248ee86ba532c8)();
var $b90eb6861b0073ed$export$65254d5f26cb9564 = 'data-scroll-locked';
// important tip - once we measure scrollBar width and remove them
// we could not repeat this operation
// thus we are using style-singleton - only the first "yet correct" style will be applied.
var $b90eb6861b0073ed$var$getStyles = function(_a, allowRelative, gapMode, important) {
    var left = _a.left, top = _a.top, right = _a.right, gap = _a.gap;
    if (gapMode === void 0) gapMode = 'margin';
    return "\n  .".concat((0, $a41a233da3336aff$export$bb813dfbbc432abc), " {\n   overflow: hidden ").concat(important, ";\n   padding-right: ").concat(gap, "px ").concat(important, ";\n  }\n  body[").concat($b90eb6861b0073ed$export$65254d5f26cb9564, "] {\n    overflow: hidden ").concat(important, ";\n    overscroll-behavior: contain;\n    ").concat([
        allowRelative && "position: relative ".concat(important, ";"),
        gapMode === 'margin' && "\n    padding-left: ".concat(left, "px;\n    padding-top: ").concat(top, "px;\n    padding-right: ").concat(right, "px;\n    margin-left:0;\n    margin-top:0;\n    margin-right: ").concat(gap, "px ").concat(important, ";\n    "),
        gapMode === 'padding' && "padding-right: ".concat(gap, "px ").concat(important, ";")
    ].filter(Boolean).join(''), "\n  }\n  \n  .").concat((0, $a41a233da3336aff$export$1da7500147d4bc3), " {\n    right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a41a233da3336aff$export$898e37bbd2a0ae4e), " {\n    margin-right: ").concat(gap, "px ").concat(important, ";\n  }\n  \n  .").concat((0, $a41a233da3336aff$export$1da7500147d4bc3), " .").concat((0, $a41a233da3336aff$export$1da7500147d4bc3), " {\n    right: 0 ").concat(important, ";\n  }\n  \n  .").concat((0, $a41a233da3336aff$export$898e37bbd2a0ae4e), " .").concat((0, $a41a233da3336aff$export$898e37bbd2a0ae4e), " {\n    margin-right: 0 ").concat(important, ";\n  }\n  \n  body[").concat($b90eb6861b0073ed$export$65254d5f26cb9564, "] {\n    ").concat((0, $a41a233da3336aff$export$63d0edf80fea83b1), ": ").concat(gap, "px;\n  }\n");
};
var $b90eb6861b0073ed$var$getCurrentUseCounter = function() {
    var counter = parseInt(document.body.getAttribute($b90eb6861b0073ed$export$65254d5f26cb9564) || '0', 10);
    return isFinite(counter) ? counter : 0;
};
var $b90eb6861b0073ed$export$a1939b1f9f9b02dc = function() {
    $7fPBF.useEffect(function() {
        document.body.setAttribute($b90eb6861b0073ed$export$65254d5f26cb9564, ($b90eb6861b0073ed$var$getCurrentUseCounter() + 1).toString());
        return function() {
            var newCounter = $b90eb6861b0073ed$var$getCurrentUseCounter() - 1;
            if (newCounter <= 0) document.body.removeAttribute($b90eb6861b0073ed$export$65254d5f26cb9564);
            else document.body.setAttribute($b90eb6861b0073ed$export$65254d5f26cb9564, newCounter.toString());
        };
    }, []);
};
var $b90eb6861b0073ed$export$9aa43b459c5ae9b9 = function(_a) {
    var noRelative = _a.noRelative, noImportant = _a.noImportant, _b = _a.gapMode, gapMode = _b === void 0 ? 'margin' : _b;
    $b90eb6861b0073ed$export$a1939b1f9f9b02dc();
    /*
     gap will be measured on every component mount
     however it will be used only by the "first" invocation
     due to singleton nature of <Style
     */ var gap = $7fPBF.useMemo(function() {
        return (0, $f5b4e81188fb2e0b$export$75f2ca8f029c77f4)(gapMode);
    }, [
        gapMode
    ]);
    return $7fPBF.createElement($b90eb6861b0073ed$var$Style, {
        styles: $b90eb6861b0073ed$var$getStyles(gap, !noRelative, gapMode, !noImportant ? '!important' : '')
    });
};







var $cf3d467337310f3d$var$passiveSupported = false;
if (typeof window !== 'undefined') try {
    var $cf3d467337310f3d$var$options = Object.defineProperty({}, 'passive', {
        get: function() {
            $cf3d467337310f3d$var$passiveSupported = true;
            return true;
        }
    });
    // @ts-ignore
    window.addEventListener('test', $cf3d467337310f3d$var$options, $cf3d467337310f3d$var$options);
    // @ts-ignore
    window.removeEventListener('test', $cf3d467337310f3d$var$options, $cf3d467337310f3d$var$options);
} catch (err) {
    $cf3d467337310f3d$var$passiveSupported = false;
}
var $cf3d467337310f3d$export$10a6e88623fa9454 = $cf3d467337310f3d$var$passiveSupported ? {
    passive: false
} : false;


var $c5b91173956af4fd$var$alwaysContainsScroll = function(node) {
    // textarea will always _contain_ scroll inside self. It only can be hidden
    return node.tagName === 'TEXTAREA';
};
var $c5b91173956af4fd$var$elementCanBeScrolled = function(node, overflow) {
    if (!(node instanceof Element)) return false;
    var styles = window.getComputedStyle(node);
    return(// not-not-scrollable
    styles[overflow] !== 'hidden' && // contains scroll inside self
    !(styles.overflowY === styles.overflowX && !$c5b91173956af4fd$var$alwaysContainsScroll(node) && styles[overflow] === 'visible'));
};
var $c5b91173956af4fd$var$elementCouldBeVScrolled = function(node) {
    return $c5b91173956af4fd$var$elementCanBeScrolled(node, 'overflowY');
};
var $c5b91173956af4fd$var$elementCouldBeHScrolled = function(node) {
    return $c5b91173956af4fd$var$elementCanBeScrolled(node, 'overflowX');
};
var $c5b91173956af4fd$export$9ec64480cae49817 = function(axis, node) {
    var ownerDocument = node.ownerDocument;
    var current = node;
    do {
        // Skip over shadow root
        if (typeof ShadowRoot !== 'undefined' && current instanceof ShadowRoot) current = current.host;
        var isScrollable = $c5b91173956af4fd$var$elementCouldBeScrolled(axis, current);
        if (isScrollable) {
            var _a = $c5b91173956af4fd$var$getScrollVariables(axis, current), scrollHeight = _a[1], clientHeight = _a[2];
            if (scrollHeight > clientHeight) return true;
        }
        current = current.parentNode;
    }while (current && current !== ownerDocument.body);
    return false;
};
var $c5b91173956af4fd$var$getVScrollVariables = function(_a) {
    var scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
    return [
        scrollTop,
        scrollHeight,
        clientHeight
    ];
};
var $c5b91173956af4fd$var$getHScrollVariables = function(_a) {
    var scrollLeft = _a.scrollLeft, scrollWidth = _a.scrollWidth, clientWidth = _a.clientWidth;
    return [
        scrollLeft,
        scrollWidth,
        clientWidth
    ];
};
var $c5b91173956af4fd$var$elementCouldBeScrolled = function(axis, node) {
    return axis === 'v' ? $c5b91173956af4fd$var$elementCouldBeVScrolled(node) : $c5b91173956af4fd$var$elementCouldBeHScrolled(node);
};
var $c5b91173956af4fd$var$getScrollVariables = function(axis, node) {
    return axis === 'v' ? $c5b91173956af4fd$var$getVScrollVariables(node) : $c5b91173956af4fd$var$getHScrollVariables(node);
};
var $c5b91173956af4fd$var$getDirectionFactor = function(axis, direction) {
    /**
     * If the element's direction is rtl (right-to-left), then scrollLeft is 0 when the scrollbar is at its rightmost position,
     * and then increasingly negative as you scroll towards the end of the content.
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollLeft
     */ return axis === 'h' && direction === 'rtl' ? -1 : 1;
};
var $c5b91173956af4fd$export$dde0441bd4a6ded8 = function(axis, endTarget, event, sourceDelta, noOverscroll) {
    var directionFactor = $c5b91173956af4fd$var$getDirectionFactor(axis, window.getComputedStyle(endTarget).direction);
    var delta = directionFactor * sourceDelta;
    // find scrollable target
    var target = event.target;
    var targetInLock = endTarget.contains(target);
    var shouldCancelScroll = false;
    var isDeltaPositive = delta > 0;
    var availableScroll = 0;
    var availableScrollTop = 0;
    do {
        if (!target) break;
        var _a = $c5b91173956af4fd$var$getScrollVariables(axis, target), position = _a[0], scroll_1 = _a[1], capacity = _a[2];
        var elementScroll = scroll_1 - capacity - directionFactor * position;
        if (position || elementScroll) {
            if ($c5b91173956af4fd$var$elementCouldBeScrolled(axis, target)) {
                availableScroll += elementScroll;
                availableScrollTop += position;
            }
        }
        var parent_1 = target.parentNode;
        // we will "bubble" from ShadowDom in case we are, or just to the parent in normal case
        // this is the same logic used in focus-lock
        target = parent_1 && parent_1.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? parent_1.host : parent_1;
    }while (// portaled content
    !targetInLock && target !== document.body || // self content
    targetInLock && (endTarget.contains(target) || endTarget === target));
    // handle epsilon around 0 (non standard zoom levels)
    if (isDeltaPositive && (noOverscroll && Math.abs(availableScroll) < 1 || !noOverscroll && delta > availableScroll)) shouldCancelScroll = true;
    else if (!isDeltaPositive && (noOverscroll && Math.abs(availableScrollTop) < 1 || !noOverscroll && -delta > availableScrollTop)) shouldCancelScroll = true;
    return shouldCancelScroll;
};


var $0905ffb48d1f80f5$export$6e085704a79f4f56 = function(event) {
    return 'changedTouches' in event ? [
        event.changedTouches[0].clientX,
        event.changedTouches[0].clientY
    ] : [
        0,
        0
    ];
};
var $0905ffb48d1f80f5$export$39efaa2ca254a28d = function(event) {
    return [
        event.deltaX,
        event.deltaY
    ];
};
var $0905ffb48d1f80f5$var$extractRef = function(ref) {
    return ref && 'current' in ref ? ref.current : ref;
};
var $0905ffb48d1f80f5$var$deltaCompare = function(x, y) {
    return x[0] === y[0] && x[1] === y[1];
};
var $0905ffb48d1f80f5$var$generateStyle = function(id) {
    return "\n  .block-interactivity-".concat(id, " {pointer-events: none;}\n  .allow-interactivity-").concat(id, " {pointer-events: all;}\n");
};
var $0905ffb48d1f80f5$var$idCounter = 0;
var $0905ffb48d1f80f5$var$lockStack = [];
function $0905ffb48d1f80f5$export$a09dbff87b5da2d(props) {
    var shouldPreventQueue = $7fPBF.useRef([]);
    var touchStartRef = $7fPBF.useRef([
        0,
        0
    ]);
    var activeAxis = $7fPBF.useRef();
    var id = $7fPBF.useState($0905ffb48d1f80f5$var$idCounter++)[0];
    var Style = $7fPBF.useState((0, $6c29cb1f12180b44$export$c1248ee86ba532c8))[0];
    var lastProps = $7fPBF.useRef(props);
    $7fPBF.useEffect(function() {
        lastProps.current = props;
    }, [
        props
    ]);
    $7fPBF.useEffect(function() {
        if (props.inert) {
            document.body.classList.add("block-interactivity-".concat(id));
            var allow_1 = (0, $75d33c26c5e72e04$export$1216008129fb82ed)([
                props.lockRef.current
            ], (props.shards || []).map($0905ffb48d1f80f5$var$extractRef), true).filter(Boolean);
            allow_1.forEach(function(el) {
                return el.classList.add("allow-interactivity-".concat(id));
            });
            return function() {
                document.body.classList.remove("block-interactivity-".concat(id));
                allow_1.forEach(function(el) {
                    return el.classList.remove("allow-interactivity-".concat(id));
                });
            };
        }
        return;
    }, [
        props.inert,
        props.lockRef.current,
        props.shards
    ]);
    var shouldCancelEvent = $7fPBF.useCallback(function(event, parent) {
        if ('touches' in event && event.touches.length === 2 || event.type === 'wheel' && event.ctrlKey) return !lastProps.current.allowPinchZoom;
        var touch = $0905ffb48d1f80f5$export$6e085704a79f4f56(event);
        var touchStart = touchStartRef.current;
        var deltaX = 'deltaX' in event ? event.deltaX : touchStart[0] - touch[0];
        var deltaY = 'deltaY' in event ? event.deltaY : touchStart[1] - touch[1];
        var currentAxis;
        var target = event.target;
        var moveDirection = Math.abs(deltaX) > Math.abs(deltaY) ? 'h' : 'v';
        // allow horizontal touch move on Range inputs. They will not cause any scroll
        if ('touches' in event && moveDirection === 'h' && target.type === 'range') return false;
        // allow drag selection (iOS); check if selection's anchorNode is the same as target or contains target
        var selection = window.getSelection();
        var anchorNode = selection && selection.anchorNode;
        var isTouchingSelection = anchorNode ? anchorNode === target || anchorNode.contains(target) : false;
        if (isTouchingSelection) return false;
        var canBeScrolledInMainDirection = (0, $c5b91173956af4fd$export$9ec64480cae49817)(moveDirection, target);
        if (!canBeScrolledInMainDirection) return true;
        if (canBeScrolledInMainDirection) currentAxis = moveDirection;
        else {
            currentAxis = moveDirection === 'v' ? 'h' : 'v';
            canBeScrolledInMainDirection = (0, $c5b91173956af4fd$export$9ec64480cae49817)(moveDirection, target);
        // other axis might be not scrollable
        }
        if (!canBeScrolledInMainDirection) return false;
        if (!activeAxis.current && 'changedTouches' in event && (deltaX || deltaY)) activeAxis.current = currentAxis;
        if (!currentAxis) return true;
        var cancelingAxis = activeAxis.current || currentAxis;
        return (0, $c5b91173956af4fd$export$dde0441bd4a6ded8)(cancelingAxis, parent, event, cancelingAxis === 'h' ? deltaX : deltaY, true);
    }, []);
    var shouldPrevent = $7fPBF.useCallback(function(_event) {
        var event = _event;
        if (!$0905ffb48d1f80f5$var$lockStack.length || $0905ffb48d1f80f5$var$lockStack[$0905ffb48d1f80f5$var$lockStack.length - 1] !== Style) // not the last active
        return;
        var delta = 'deltaY' in event ? $0905ffb48d1f80f5$export$39efaa2ca254a28d(event) : $0905ffb48d1f80f5$export$6e085704a79f4f56(event);
        var sourceEvent = shouldPreventQueue.current.filter(function(e) {
            return e.name === event.type && (e.target === event.target || event.target === e.shadowParent) && $0905ffb48d1f80f5$var$deltaCompare(e.delta, delta);
        })[0];
        // self event, and should be canceled
        if (sourceEvent && sourceEvent.should) {
            if (event.cancelable) event.preventDefault();
            return;
        }
        // outside or shard event
        if (!sourceEvent) {
            var shardNodes = (lastProps.current.shards || []).map($0905ffb48d1f80f5$var$extractRef).filter(Boolean).filter(function(node) {
                return node.contains(event.target);
            });
            var shouldStop = shardNodes.length > 0 ? shouldCancelEvent(event, shardNodes[0]) : !lastProps.current.noIsolation;
            if (shouldStop) {
                if (event.cancelable) event.preventDefault();
            }
        }
    }, []);
    var shouldCancel = $7fPBF.useCallback(function(name, delta, target, should) {
        var event = {
            name: name,
            delta: delta,
            target: target,
            should: should,
            shadowParent: $0905ffb48d1f80f5$var$getOutermostShadowParent(target)
        };
        shouldPreventQueue.current.push(event);
        setTimeout(function() {
            shouldPreventQueue.current = shouldPreventQueue.current.filter(function(e) {
                return e !== event;
            });
        }, 1);
    }, []);
    var scrollTouchStart = $7fPBF.useCallback(function(event) {
        touchStartRef.current = $0905ffb48d1f80f5$export$6e085704a79f4f56(event);
        activeAxis.current = undefined;
    }, []);
    var scrollWheel = $7fPBF.useCallback(function(event) {
        shouldCancel(event.type, $0905ffb48d1f80f5$export$39efaa2ca254a28d(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    var scrollTouchMove = $7fPBF.useCallback(function(event) {
        shouldCancel(event.type, $0905ffb48d1f80f5$export$6e085704a79f4f56(event), event.target, shouldCancelEvent(event, props.lockRef.current));
    }, []);
    $7fPBF.useEffect(function() {
        $0905ffb48d1f80f5$var$lockStack.push(Style);
        props.setCallbacks({
            onScrollCapture: scrollWheel,
            onWheelCapture: scrollWheel,
            onTouchMoveCapture: scrollTouchMove
        });
        document.addEventListener('wheel', shouldPrevent, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
        document.addEventListener('touchmove', shouldPrevent, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
        document.addEventListener('touchstart', scrollTouchStart, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
        return function() {
            $0905ffb48d1f80f5$var$lockStack = $0905ffb48d1f80f5$var$lockStack.filter(function(inst) {
                return inst !== Style;
            });
            document.removeEventListener('wheel', shouldPrevent, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
            document.removeEventListener('touchmove', shouldPrevent, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
            document.removeEventListener('touchstart', scrollTouchStart, (0, $cf3d467337310f3d$export$10a6e88623fa9454));
        };
    }, []);
    var removeScrollBar = props.removeScrollBar, inert = props.inert;
    return $7fPBF.createElement($7fPBF.Fragment, null, inert ? $7fPBF.createElement(Style, {
        styles: $0905ffb48d1f80f5$var$generateStyle(id)
    }) : null, removeScrollBar ? $7fPBF.createElement((0, $b90eb6861b0073ed$export$9aa43b459c5ae9b9), {
        noRelative: props.noRelative,
        gapMode: props.gapMode
    }) : null);
}
function $0905ffb48d1f80f5$var$getOutermostShadowParent(node) {
    var shadowParent = null;
    while(node !== null){
        if (node instanceof ShadowRoot) {
            shadowParent = node.host;
            node = node.host;
        }
        node = node.parentNode;
    }
    return shadowParent;
}



var $cc925483b10fccaa$export$2e2bcd8739ae039 = (0, $e6d091439ffe4730$export$6cacc8fb0a9b94ce)((0, $fbab39904a684810$export$e27363444bedfeac), (0, $0905ffb48d1f80f5$export$a09dbff87b5da2d));


var $ef57a4b421076988$var$ReactRemoveScroll = $7fPBF.forwardRef(function(props, ref) {
    return $7fPBF.createElement((0, $25d27fc5e29f9d4f$export$22940b497e769dee), (0, $75d33c26c5e72e04$export$18ce0697a983be9b)({}, props, {
        ref: ref,
        sideCar: (0, $cc925483b10fccaa$export$2e2bcd8739ae039)
    }));
});
$ef57a4b421076988$var$ReactRemoveScroll.classNames = (0, $25d27fc5e29f9d4f$export$22940b497e769dee).classNames;
var $ef57a4b421076988$export$2e2bcd8739ae039 = $ef57a4b421076988$var$ReactRemoveScroll;



"use client";
var $7cacca21c6f84773$var$__defProp = Object.defineProperty;
var $7cacca21c6f84773$var$__name = (target, value)=>$7cacca21c6f84773$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $7cacca21c6f84773$var$OPEN_KEYS = [
    " ",
    "Enter",
    "ArrowUp",
    "ArrowDown"
];
var $7cacca21c6f84773$var$SELECTION_KEYS = [
    " ",
    "Enter"
];
var $7cacca21c6f84773$var$SELECT_NAME = "Select";
var [$7cacca21c6f84773$var$Collection, $7cacca21c6f84773$var$useCollection, $7cacca21c6f84773$var$createCollectionScope] = (0, $08a94ba50b5cc249$export$c74125a8e3af6bb2)($7cacca21c6f84773$var$SELECT_NAME);
var [$7cacca21c6f84773$var$createSelectContext, $7cacca21c6f84773$export$286727a75dc039bd] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($7cacca21c6f84773$var$SELECT_NAME, [
    $7cacca21c6f84773$var$createCollectionScope,
    (0, $7952cd297982b588$export$722aac194ae923)
]);
var $7cacca21c6f84773$var$usePopperScope = (0, $7952cd297982b588$export$722aac194ae923)();
var [$7cacca21c6f84773$var$SelectProviderImpl, $7cacca21c6f84773$var$useSelectContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$SELECT_NAME);
var [$7cacca21c6f84773$var$SelectNativeOptionsProvider, $7cacca21c6f84773$var$useSelectNativeOptionsContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$SELECT_NAME);
function $7cacca21c6f84773$export$53dd0e869fa29944(props) {
    const { __scopeSelect: __scopeSelect, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange, dir: dir, name: name, autoComplete: autoComplete, disabled: disabled, required: required, form: form, internal_do_not_use_render: // @ts-expect-error internal render prop used by `Select` to compose its default parts
    internal_do_not_use_render } = props;
    const popperScope = $7cacca21c6f84773$var$usePopperScope(__scopeSelect);
    const [trigger, setTrigger] = $7fPBF.useState(null);
    const [valueNode, setValueNode] = $7fPBF.useState(null);
    const [valueNodeHasChildren, setValueNodeHasChildren] = $7fPBF.useState(false);
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    const [open, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : false,
        onChange: onOpenChange,
        caller: $7cacca21c6f84773$var$SELECT_NAME
    });
    const [value, setValue] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue,
        onChange: onValueChange,
        caller: $7cacca21c6f84773$var$SELECT_NAME
    });
    const triggerPointerDownPosRef = $7fPBF.useRef(null);
    const initialValueRef = $7fPBF.useRef(value);
    $7fPBF.useEffect(()=>{
        const associatedForm = form ? trigger === null || trigger === void 0 ? void 0 : trigger.ownerDocument.getElementById(form) : trigger === null || trigger === void 0 ? void 0 : trigger.form;
        if (associatedForm instanceof HTMLFormElement) {
            const reset = /* @__PURE__ */ $7cacca21c6f84773$var$__name(()=>setValue(initialValueRef.current), "reset");
            associatedForm.addEventListener("reset", reset);
            return ()=>associatedForm.removeEventListener("reset", reset);
        }
    }, [
        form,
        trigger,
        setValue
    ]);
    const isFormControl = trigger ? !!form || !!trigger.closest("form") : true;
    const [nativeOptionsSet, setNativeOptionsSet] = $7fPBF.useState(/* @__PURE__ */ new Set());
    const contentId = (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)();
    const nativeSelectKey = Array.from(nativeOptionsSet).map((option)=>option.props.value).join(";");
    const handleNativeOptionAdd = $7fPBF.useCallback((option)=>{
        setNativeOptionsSet((prev)=>new Set(prev).add(option));
    }, []);
    const handleNativeOptionRemove = $7fPBF.useCallback((option)=>{
        setNativeOptionsSet((prev)=>{
            const optionsSet = new Set(prev);
            optionsSet.delete(option);
            return optionsSet;
        });
    }, []);
    const context = {
        required: required,
        trigger: trigger,
        onTriggerChange: setTrigger,
        valueNode: valueNode,
        onValueNodeChange: setValueNode,
        valueNodeHasChildren: valueNodeHasChildren,
        onValueNodeHasChildrenChange: setValueNodeHasChildren,
        contentId: contentId,
        value: value,
        onValueChange: setValue,
        open: open,
        onOpenChange: setOpen,
        dir: direction,
        triggerPointerDownPosRef: triggerPointerDownPosRef,
        disabled: disabled,
        name: name,
        autoComplete: autoComplete,
        form: form,
        nativeOptions: nativeOptionsSet,
        nativeSelectKey: nativeSelectKey,
        isFormControl: isFormControl
    };
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$be92b6f5f03c0fe9, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, popperScope), {
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectProviderImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            scope: __scopeSelect
        }, context), {
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$Collection.Provider, {
                scope: __scopeSelect,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectNativeOptionsProvider, {
                    scope: __scopeSelect,
                    onNativeOptionAdd: handleNativeOptionAdd,
                    onNativeOptionRemove: handleNativeOptionRemove,
                    children: $7cacca21c6f84773$var$isFunction(internal_do_not_use_render) ? internal_do_not_use_render(context) : children
                })
            })
        }))
    }));
}
$7cacca21c6f84773$var$__name($7cacca21c6f84773$export$53dd0e869fa29944, "SelectProvider");
var $7cacca21c6f84773$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $7cacca21c6f84773$var$__name((props)=>{
    const { __scopeSelect: __scopeSelect, children: children } = props, providerProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "children"
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$export$53dd0e869fa29944, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        __scopeSelect: __scopeSelect
    }, providerProps), {
        internal_do_not_use_render: ({ isFormControl: isFormControl })=>/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    children,
                    isFormControl ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$export$493083511fc9f964, {
                        __scopeSelect: __scopeSelect
                    }) : null
                ]
            })
    }));
}, "Select");
var $7cacca21c6f84773$var$TRIGGER_NAME = "SelectTrigger";
var $7cacca21c6f84773$export$3ac1e88a1c0b9f1 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectTrigger2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect, disabled: disabled = false } = props, triggerProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "disabled"
    ]);
    const popperScope = $7cacca21c6f84773$var$usePopperScope(__scopeSelect);
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$TRIGGER_NAME, __scopeSelect);
    const isDisabled = context.disabled || disabled;
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.onTriggerChange);
    const getItems = $7cacca21c6f84773$var$useCollection(__scopeSelect);
    const pointerTypeRef = $7fPBF.useRef("touch");
    const [searchRef, handleTypeaheadSearch, resetTypeahead] = $7cacca21c6f84773$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.value === context.value);
        const nextItem = $7cacca21c6f84773$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem !== void 0) context.onValueChange(nextItem.value);
    });
    const handleOpen = /* @__PURE__ */ $7cacca21c6f84773$var$__name((pointerEvent)=>{
        if (!isDisabled) {
            context.onOpenChange(true);
            resetTypeahead();
        }
        if (pointerEvent) context.triggerPointerDownPosRef.current = {
            x: Math.round(pointerEvent.pageX),
            y: Math.round(pointerEvent.pageY)
        };
    }, "handleOpen");
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$b688253958b8dfe7, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        asChild: true
    }, popperScope), {
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: "button",
            role: "combobox",
            "aria-controls": context.open ? context.contentId : void 0,
            "aria-expanded": context.open,
            "aria-required": context.required,
            "aria-autocomplete": "none",
            dir: context.dir,
            "data-state": context.open ? "open" : "closed",
            disabled: isDisabled,
            "data-disabled": isDisabled ? "" : void 0,
            "data-placeholder": $7cacca21c6f84773$var$shouldShowPlaceholder(context.value) ? "" : void 0
        }, triggerProps), {
            ref: composedRefs,
            onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(triggerProps.onClick, (event)=>{
                event.currentTarget.focus();
                if (pointerTypeRef.current !== "mouse") handleOpen(event);
            }),
            onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(triggerProps.onPointerDown, (event)=>{
                pointerTypeRef.current = event.pointerType;
                const target = event.target;
                if (target.hasPointerCapture(event.pointerId)) target.releasePointerCapture(event.pointerId);
                if (event.button === 0 && event.ctrlKey === false && event.pointerType === "mouse") {
                    handleOpen(event);
                    event.preventDefault();
                }
            }),
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(triggerProps.onKeyDown, (event)=>{
                const isTypingAhead = searchRef.current !== "";
                const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                if (isTypingAhead && event.key === " ") return;
                if ($7cacca21c6f84773$var$OPEN_KEYS.includes(event.key)) {
                    handleOpen();
                    event.preventDefault();
                }
            })
        }))
    }));
}, "SelectTrigger"));
var $7cacca21c6f84773$var$VALUE_NAME = "SelectValue";
var $7cacca21c6f84773$export$e288731fd71264f0 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectValue2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect, className: className, style: style, children: children, placeholder: placeholder = "" } = props, valueProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "className",
        "style",
        "children",
        "placeholder"
    ]);
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$VALUE_NAME, __scopeSelect);
    const { onValueNodeHasChildrenChange: onValueNodeHasChildrenChange } = context;
    const hasChildren = children !== void 0;
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.onValueNodeChange);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        onValueNodeHasChildrenChange(hasChildren);
    }, [
        onValueNodeHasChildrenChange,
        hasChildren
    ]);
    const showPlaceholder = $7cacca21c6f84773$var$shouldShowPlaceholder(context.value);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, valueProps), {
        asChild: showPlaceholder ? false : valueProps.asChild,
        ref: composedRefs,
        style: {
            pointerEvents: "none"
        },
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7fPBF.Fragment, {
            children: showPlaceholder ? placeholder : children
        }, showPlaceholder ? "placeholder" : "value")
    }));
}, "SelectValue"));
var $7cacca21c6f84773$export$f04a61298a47a40f = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectIcon2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect, children: children } = props, iconProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "children"
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "aria-hidden": true
    }, iconProps), {
        ref: forwardedRef,
        children: children || "\u25BC"
    }));
}, "SelectIcon"));
var $7cacca21c6f84773$var$PORTAL_NAME = "SelectPortal";
var [$7cacca21c6f84773$var$PortalProvider, $7cacca21c6f84773$var$usePortalContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$PORTAL_NAME, {
    forceMount: void 0
});
var $7cacca21c6f84773$export$602eac185826482c = /* @__PURE__ */ $7cacca21c6f84773$var$__name((props)=>{
    const { __scopeSelect: __scopeSelect, forceMount: forceMount } = props, portalProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "forceMount"
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$PortalProvider, {
        scope: props.__scopeSelect,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $57c7abe8fecdeb41$export$602eac185826482c), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            asChild: true
        }, portalProps))
    });
}, "SelectPortal");
var $7cacca21c6f84773$var$CONTENT_NAME = "SelectContent";
var $7cacca21c6f84773$export$7c6e2c02157bb7d2 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectContent2(props, forwardedRef) {
    const portalContext = $7cacca21c6f84773$var$usePortalContext($7cacca21c6f84773$var$CONTENT_NAME, props.__scopeSelect);
    const { forceMount: forceMount = portalContext.forceMount } = props, contentProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "forceMount"
    ]);
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$CONTENT_NAME, props.__scopeSelect);
    const [fragment, setFragment] = $7fPBF.useState();
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        setFragment(new DocumentFragment());
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: ({ present: present })=>present ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectContentImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contentProps), {
                ref: forwardedRef
            })) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectContentFragment, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contentProps), {
                fragment: fragment
            }))
    });
}, "SelectContent"));
var $7cacca21c6f84773$var$SelectContentFragment = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectContentFragment2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect, children: children, fragment: fragment } = props;
    if (!fragment) return null;
    return $fw0lo.createPortal(/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectContentProvider, {
        scope: __scopeSelect,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$Collection.Slot, {
            scope: __scopeSelect,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
                ref: forwardedRef,
                children: children
            })
        })
    }), fragment);
}, "SelectContentFragment"));
var $7cacca21c6f84773$var$CONTENT_MARGIN = 10;
var [$7cacca21c6f84773$var$SelectContentProvider, $7cacca21c6f84773$var$useSelectContentContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$CONTENT_NAME);
var $7cacca21c6f84773$var$Slot = (0, $089057084dfb92a4$export$e88b45bda5c13eb9)("SelectContent.RemoveScroll");
var $7cacca21c6f84773$var$SelectContentImpl = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectContentImpl2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect } = props;
    const { position: position = "item-aligned", onCloseAutoFocus: onCloseAutoFocus, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, side: //
    // PopperContent props
    side, sideOffset: sideOffset, align: align, alignOffset: alignOffset, arrowPadding: arrowPadding, collisionBoundary: collisionBoundary, collisionPadding: collisionPadding, sticky: sticky, hideWhenDetached: hideWhenDetached, avoidCollisions: avoidCollisions } = props, contentProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "position",
        "onCloseAutoFocus",
        "onEscapeKeyDown",
        "onPointerDownOutside",
        "side",
        "sideOffset",
        "align",
        "alignOffset",
        "arrowPadding",
        "collisionBoundary",
        "collisionPadding",
        "sticky",
        "hideWhenDetached",
        "avoidCollisions"
    ]);
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$CONTENT_NAME, __scopeSelect);
    const [content, setContent] = $7fPBF.useState(null);
    const [viewport, setViewport] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, setContent);
    const [selectedItem, setSelectedItem] = $7fPBF.useState(null);
    const [selectedItemText, setSelectedItemText] = $7fPBF.useState(null);
    const getItems = $7cacca21c6f84773$var$useCollection(__scopeSelect);
    const [isPositioned, setIsPositioned] = $7fPBF.useState(false);
    const firstValidItemFoundRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        if (content) return (0, $2950574f4b60c018$export$6e33d16126ed003c)(content);
    }, [
        content
    ]);
    (0, $38bbe2f1de23f200$export$b7ece24a22aeda8c)();
    const focusFirst = $7fPBF.useCallback((candidates)=>{
        const [firstItem, ...restItems] = getItems().map((item)=>item.ref.current);
        const [lastItem] = restItems.slice(-1);
        const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
        for (const candidate of candidates){
            if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
            candidate === null || candidate === void 0 ? void 0 : candidate.scrollIntoView({
                block: "nearest"
            });
            if (candidate === firstItem && viewport) viewport.scrollTop = 0;
            if (candidate === lastItem && viewport) viewport.scrollTop = viewport.scrollHeight;
            candidate === null || candidate === void 0 ? void 0 : candidate.focus();
            if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
        }
    }, [
        getItems,
        viewport
    ]);
    const focusSelectedItem = $7fPBF.useCallback(()=>focusFirst([
            selectedItem,
            content
        ]), [
        focusFirst,
        selectedItem,
        content
    ]);
    $7fPBF.useEffect(()=>{
        if (isPositioned) focusSelectedItem();
    }, [
        isPositioned,
        focusSelectedItem
    ]);
    const { onOpenChange: onOpenChange, triggerPointerDownPosRef: triggerPointerDownPosRef } = context;
    $7fPBF.useEffect(()=>{
        if (content) {
            let pointerMoveDelta = {
                x: 0,
                y: 0
            };
            const handlePointerMove = /* @__PURE__ */ $7cacca21c6f84773$var$__name((event)=>{
                var _triggerPointerDownPosRef_current, _triggerPointerDownPosRef_current1;
                var _triggerPointerDownPosRef_current_x, _triggerPointerDownPosRef_current_y;
                pointerMoveDelta = {
                    x: Math.abs(Math.round(event.pageX) - ((_triggerPointerDownPosRef_current_x = (_triggerPointerDownPosRef_current = triggerPointerDownPosRef.current) === null || _triggerPointerDownPosRef_current === void 0 ? void 0 : _triggerPointerDownPosRef_current.x) !== null && _triggerPointerDownPosRef_current_x !== void 0 ? _triggerPointerDownPosRef_current_x : 0)),
                    y: Math.abs(Math.round(event.pageY) - ((_triggerPointerDownPosRef_current_y = (_triggerPointerDownPosRef_current1 = triggerPointerDownPosRef.current) === null || _triggerPointerDownPosRef_current1 === void 0 ? void 0 : _triggerPointerDownPosRef_current1.y) !== null && _triggerPointerDownPosRef_current_y !== void 0 ? _triggerPointerDownPosRef_current_y : 0))
                };
            }, "handlePointerMove");
            const handlePointerUp = /* @__PURE__ */ $7cacca21c6f84773$var$__name((event)=>{
                if (pointerMoveDelta.x <= 10 && pointerMoveDelta.y <= 10) event.preventDefault();
                else if (!event.composedPath().includes(content)) onOpenChange(false);
                document.removeEventListener("pointermove", handlePointerMove);
                triggerPointerDownPosRef.current = null;
            }, "handlePointerUp");
            if (triggerPointerDownPosRef.current !== null) {
                document.addEventListener("pointermove", handlePointerMove);
                document.addEventListener("pointerup", handlePointerUp, {
                    capture: true,
                    once: true
                });
            }
            return ()=>{
                document.removeEventListener("pointermove", handlePointerMove);
                document.removeEventListener("pointerup", handlePointerUp, {
                    capture: true
                });
            };
        }
    }, [
        content,
        onOpenChange,
        triggerPointerDownPosRef
    ]);
    $7fPBF.useEffect(()=>{
        const close = /* @__PURE__ */ $7cacca21c6f84773$var$__name(()=>onOpenChange(false), "close");
        window.addEventListener("blur", close);
        window.addEventListener("resize", close);
        return ()=>{
            window.removeEventListener("blur", close);
            window.removeEventListener("resize", close);
        };
    }, [
        onOpenChange
    ]);
    const [searchRef, handleTypeaheadSearch] = $7cacca21c6f84773$var$useTypeaheadSearch((search)=>{
        const enabledItems = getItems().filter((item)=>!item.disabled);
        const currentItem = enabledItems.find((item)=>item.ref.current === document.activeElement);
        const nextItem = $7cacca21c6f84773$var$findNextItem(enabledItems, search, currentItem);
        if (nextItem) setTimeout(()=>{
            var _nextItem_ref_current;
            return (_nextItem_ref_current = nextItem.ref.current) === null || _nextItem_ref_current === void 0 ? void 0 : _nextItem_ref_current.focus();
        });
    });
    const itemRefCallback = $7fPBF.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) {
            setSelectedItem(node);
            if (isFirstValidItem) firstValidItemFoundRef.current = true;
        }
    }, [
        context.value
    ]);
    const handleItemLeave = $7fPBF.useCallback(()=>content === null || content === void 0 ? void 0 : content.focus(), [
        content
    ]);
    const itemTextRefCallback = $7fPBF.useCallback((node, value, disabled)=>{
        const isFirstValidItem = !firstValidItemFoundRef.current && !disabled;
        const isSelectedItem = context.value !== void 0 && context.value === value;
        if (isSelectedItem || isFirstValidItem) setSelectedItemText(node);
    }, [
        context.value
    ]);
    const SelectPosition = position === "popper" ? $7cacca21c6f84773$var$SelectPopperPosition : $7cacca21c6f84773$var$SelectItemAlignedPosition;
    const popperContentProps = SelectPosition === $7cacca21c6f84773$var$SelectPopperPosition ? {
        side: side,
        sideOffset: sideOffset,
        align: align,
        alignOffset: alignOffset,
        arrowPadding: arrowPadding,
        collisionBoundary: collisionBoundary,
        collisionPadding: collisionPadding,
        sticky: sticky,
        hideWhenDetached: hideWhenDetached,
        avoidCollisions: avoidCollisions
    } : {};
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectContentProvider, {
        scope: __scopeSelect,
        content: content,
        viewport: viewport,
        onViewportChange: setViewport,
        itemRefCallback: itemRefCallback,
        selectedItem: selectedItem,
        onItemLeave: handleItemLeave,
        itemTextRefCallback: itemTextRefCallback,
        focusSelectedItem: focusSelectedItem,
        selectedItemText: selectedItemText,
        position: position,
        isPositioned: isPositioned,
        searchRef: searchRef,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $ef57a4b421076988$export$2e2bcd8739ae039), {
            as: $7cacca21c6f84773$var$Slot,
            allowPinchZoom: true,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $0d555b2b0a3ffff1$export$20e40289641fbbb6), {
                asChild: true,
                trapped: context.open,
                onMountAutoFocus: (event)=>{
                    event.preventDefault();
                },
                onUnmountAutoFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(onCloseAutoFocus, (event)=>{
                    var _context_trigger;
                    (_context_trigger = context.trigger) === null || _context_trigger === void 0 ? void 0 : _context_trigger.focus({
                        preventScroll: true
                    });
                    event.preventDefault();
                }),
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $251340165f4765e5$export$177fb62ff3ec1f22), {
                    asChild: true,
                    disableOutsidePointerEvents: true,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onPointerDownOutside: onPointerDownOutside,
                    onFocusOutside: (event)=>event.preventDefault(),
                    onDismiss: ()=>context.onOpenChange(false),
                    children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)(SelectPosition, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        role: "listbox",
                        id: context.contentId,
                        "data-state": context.open ? "open" : "closed",
                        dir: context.dir,
                        onContextMenu: (event)=>event.preventDefault()
                    }, contentProps, popperContentProps), {
                        onPlaced: ()=>setIsPositioned(true),
                        ref: composedRefs,
                        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                            // flex layout so we can place the scroll buttons properly
                            display: "flex",
                            flexDirection: "column",
                            // reset the outline by default as the content MAY get focused
                            outline: "none"
                        }, contentProps.style),
                        onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(contentProps.onKeyDown, (event)=>{
                            const isModifierKey = event.ctrlKey || event.altKey || event.metaKey;
                            if (event.key === "Tab") event.preventDefault();
                            if (!isModifierKey && event.key.length === 1) handleTypeaheadSearch(event.key);
                            if ([
                                "ArrowUp",
                                "ArrowDown",
                                "Home",
                                "End"
                            ].includes(event.key)) {
                                const items = getItems().filter((item)=>!item.disabled);
                                let candidateNodes = items.map((item)=>item.ref.current);
                                if ([
                                    "ArrowUp",
                                    "End"
                                ].includes(event.key)) candidateNodes = candidateNodes.slice().reverse();
                                if ([
                                    "ArrowUp",
                                    "ArrowDown"
                                ].includes(event.key)) {
                                    const currentElement = event.target;
                                    const currentIndex = candidateNodes.indexOf(currentElement);
                                    candidateNodes = candidateNodes.slice(currentIndex + 1);
                                }
                                setTimeout(()=>focusFirst(candidateNodes));
                                event.preventDefault();
                            }
                        })
                    }))
                })
            })
        })
    });
}, "SelectContentImpl"));
var $7cacca21c6f84773$var$SelectItemAlignedPosition = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectItemAlignedPosition2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect, onPlaced: onPlaced } = props, popperProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "onPlaced"
    ]);
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$CONTENT_NAME, __scopeSelect);
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$CONTENT_NAME, __scopeSelect);
    const [contentWrapper, setContentWrapper] = $7fPBF.useState(null);
    const [content, setContent] = $7fPBF.useState(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, setContent);
    const getItems = $7cacca21c6f84773$var$useCollection(__scopeSelect);
    const shouldExpandOnScrollRef = $7fPBF.useRef(false);
    const shouldRepositionRef = $7fPBF.useRef(true);
    const { viewport: viewport, selectedItem: selectedItem, selectedItemText: selectedItemText, focusSelectedItem: focusSelectedItem } = contentContext;
    const position = $7fPBF.useCallback(()=>{
        if (context.trigger && context.valueNode && contentWrapper && content && viewport && selectedItem && selectedItemText) {
            const triggerRect = context.trigger.getBoundingClientRect();
            const contentRect = content.getBoundingClientRect();
            const valueNodeRect = context.valueNode.getBoundingClientRect();
            const itemTextRect = selectedItemText.getBoundingClientRect();
            if (context.dir !== "rtl") {
                const itemTextOffset = itemTextRect.left - contentRect.left;
                const left = valueNodeRect.left - itemTextOffset;
                const leftDelta = triggerRect.left - left;
                const minContentWidth = triggerRect.width + leftDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const rightEdge = window.innerWidth - $7cacca21c6f84773$var$CONTENT_MARGIN;
                const clampedLeft = (0, $6d53081595419ec4$export$7d15b64cf5a3a4c4)(left, [
                    $7cacca21c6f84773$var$CONTENT_MARGIN,
                    // Prevents the content from going off the starting edge of the
                    // viewport. It may still go off the ending edge, but this can be
                    // controlled by the user since they may want to manage overflow in a
                    // specific way.
                    // https://github.com/radix-ui/primitives/issues/2049
                    Math.max($7cacca21c6f84773$var$CONTENT_MARGIN, rightEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.left = clampedLeft + "px";
            } else {
                const itemTextOffset = contentRect.right - itemTextRect.right;
                const right = window.innerWidth - valueNodeRect.right - itemTextOffset;
                const rightDelta = window.innerWidth - triggerRect.right - right;
                const minContentWidth = triggerRect.width + rightDelta;
                const contentWidth = Math.max(minContentWidth, contentRect.width);
                const leftEdge = window.innerWidth - $7cacca21c6f84773$var$CONTENT_MARGIN;
                const clampedRight = (0, $6d53081595419ec4$export$7d15b64cf5a3a4c4)(right, [
                    $7cacca21c6f84773$var$CONTENT_MARGIN,
                    Math.max($7cacca21c6f84773$var$CONTENT_MARGIN, leftEdge - contentWidth)
                ]);
                contentWrapper.style.minWidth = minContentWidth + "px";
                contentWrapper.style.right = clampedRight + "px";
            }
            const items = getItems();
            const availableHeight = window.innerHeight - $7cacca21c6f84773$var$CONTENT_MARGIN * 2;
            const itemsHeight = viewport.scrollHeight;
            const contentStyles = window.getComputedStyle(content);
            const contentBorderTopWidth = parseInt(contentStyles.borderTopWidth, 10);
            const contentPaddingTop = parseInt(contentStyles.paddingTop, 10);
            const contentBorderBottomWidth = parseInt(contentStyles.borderBottomWidth, 10);
            const contentPaddingBottom = parseInt(contentStyles.paddingBottom, 10);
            const fullContentHeight = contentBorderTopWidth + contentPaddingTop + itemsHeight + contentPaddingBottom + contentBorderBottomWidth;
            const minContentHeight = Math.min(selectedItem.offsetHeight * 5, fullContentHeight);
            const viewportStyles = window.getComputedStyle(viewport);
            const viewportPaddingTop = parseInt(viewportStyles.paddingTop, 10);
            const viewportPaddingBottom = parseInt(viewportStyles.paddingBottom, 10);
            const topEdgeToTriggerMiddle = triggerRect.top + triggerRect.height / 2 - $7cacca21c6f84773$var$CONTENT_MARGIN;
            const triggerMiddleToBottomEdge = availableHeight - topEdgeToTriggerMiddle;
            const selectedItemHalfHeight = selectedItem.offsetHeight / 2;
            const itemOffsetMiddle = selectedItem.offsetTop + selectedItemHalfHeight;
            const contentTopToItemMiddle = contentBorderTopWidth + contentPaddingTop + itemOffsetMiddle;
            const itemMiddleToContentBottom = fullContentHeight - contentTopToItemMiddle;
            const willAlignWithoutTopOverflow = contentTopToItemMiddle <= topEdgeToTriggerMiddle;
            if (willAlignWithoutTopOverflow) {
                const isLastItem = items.length > 0 && selectedItem === items[items.length - 1].ref.current;
                contentWrapper.style.bottom = "0px";
                const viewportOffsetBottom = content.clientHeight - viewport.offsetTop - viewport.offsetHeight;
                const clampedTriggerMiddleToBottomEdge = Math.max(triggerMiddleToBottomEdge, selectedItemHalfHeight + // viewport might have padding bottom, include it to avoid a scrollable viewport
                (isLastItem ? viewportPaddingBottom : 0) + viewportOffsetBottom + contentBorderBottomWidth);
                const height = contentTopToItemMiddle + clampedTriggerMiddleToBottomEdge;
                contentWrapper.style.height = height + "px";
            } else {
                const isFirstItem = items.length > 0 && selectedItem === items[0].ref.current;
                contentWrapper.style.top = "0px";
                const clampedTopEdgeToTriggerMiddle = Math.max(topEdgeToTriggerMiddle, contentBorderTopWidth + viewport.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
                (isFirstItem ? viewportPaddingTop : 0) + selectedItemHalfHeight);
                const height = clampedTopEdgeToTriggerMiddle + itemMiddleToContentBottom;
                contentWrapper.style.height = height + "px";
                viewport.scrollTop = contentTopToItemMiddle - topEdgeToTriggerMiddle + viewport.offsetTop;
            }
            contentWrapper.style.margin = `${$7cacca21c6f84773$var$CONTENT_MARGIN}px 0`;
            contentWrapper.style.minHeight = minContentHeight + "px";
            contentWrapper.style.maxHeight = availableHeight + "px";
            onPlaced === null || onPlaced === void 0 ? void 0 : onPlaced();
            requestAnimationFrame(()=>shouldExpandOnScrollRef.current = true);
        }
    }, [
        getItems,
        context.trigger,
        context.valueNode,
        contentWrapper,
        content,
        viewport,
        selectedItem,
        selectedItemText,
        context.dir,
        onPlaced
    ]);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>position(), [
        position
    ]);
    const [contentZIndex, setContentZIndex] = $7fPBF.useState();
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (content) setContentZIndex(window.getComputedStyle(content).zIndex);
    }, [
        content
    ]);
    const handleScrollButtonChange = $7fPBF.useCallback((node)=>{
        if (node && shouldRepositionRef.current === true) {
            position();
            focusSelectedItem === null || focusSelectedItem === void 0 ? void 0 : focusSelectedItem();
            shouldRepositionRef.current = false;
        }
    }, [
        position,
        focusSelectedItem
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectViewportProvider, {
        scope: __scopeSelect,
        contentWrapper: contentWrapper,
        shouldExpandOnScrollRef: shouldExpandOnScrollRef,
        onScrollButtonChange: handleScrollButtonChange,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("div", {
            ref: setContentWrapper,
            style: {
                display: "flex",
                flexDirection: "column",
                position: "fixed",
                zIndex: contentZIndex
            },
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, popperProps), {
                ref: composedRefs,
                style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    // When we get the height of the content, it includes borders. If we were to set
                    // the height without having `boxSizing: 'border-box'` it would be too big.
                    boxSizing: "border-box",
                    // We need to ensure the content doesn't get taller than the wrapper
                    maxHeight: "100%"
                }, popperProps.style)
            }))
        })
    });
}, "SelectItemAlignedPosition"));
var $7cacca21c6f84773$var$SelectPopperPosition = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectPopperPosition2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect, align: align = "start", collisionPadding: collisionPadding = $7cacca21c6f84773$var$CONTENT_MARGIN } = props, popperProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "align",
        "collisionPadding"
    ]);
    const popperScope = $7cacca21c6f84773$var$usePopperScope(__scopeSelect);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$7c6e2c02157bb7d2, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, popperScope, popperProps), {
        ref: forwardedRef,
        align: align,
        collisionPadding: collisionPadding,
        style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            // Ensure border-box for floating-ui calculations
            boxSizing: "border-box"
        }, popperProps.style), {
            "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-select-content-available-width": "var(--radix-popper-available-width)",
            "--radix-select-content-available-height": "var(--radix-popper-available-height)",
            "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
        })
    }));
}, "SelectPopperPosition"));
var [$7cacca21c6f84773$var$SelectViewportProvider, $7cacca21c6f84773$var$useSelectViewportContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$CONTENT_NAME, {});
var $7cacca21c6f84773$var$VIEWPORT_NAME = "SelectViewport";
var $7cacca21c6f84773$export$9ed6e7b40248d36d = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectViewport2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect, nonce: nonce } = props, viewportProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "nonce"
    ]);
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$VIEWPORT_NAME, __scopeSelect);
    const viewportContext = $7cacca21c6f84773$var$useSelectViewportContext($7cacca21c6f84773$var$VIEWPORT_NAME, __scopeSelect);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, contentContext.onViewportChange);
    const prevScrollTopRef = $7fPBF.useRef(0);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("style", {
                dangerouslySetInnerHTML: {
                    __html: `[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}`
                },
                nonce: nonce
            }),
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$Collection.Slot, {
                scope: __scopeSelect,
                children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    "data-radix-select-viewport": "",
                    role: "presentation"
                }, viewportProps), {
                    ref: composedRefs,
                    style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        // we use position: 'relative' here on the `viewport` so that when we call
                        // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
                        // (independent of the scrollUpButton).
                        position: "relative",
                        flex: 1,
                        // Viewport should only be scrollable in the vertical direction.
                        // This won't work in vertical writing modes, so we'll need to
                        // revisit this if/when that is supported
                        // https://developer.chrome.com/blog/vertical-form-controls
                        overflow: "hidden auto"
                    }, viewportProps.style),
                    onScroll: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(viewportProps.onScroll, (event)=>{
                        const viewport = event.currentTarget;
                        const { contentWrapper: contentWrapper, shouldExpandOnScrollRef: shouldExpandOnScrollRef } = viewportContext;
                        if ((shouldExpandOnScrollRef === null || shouldExpandOnScrollRef === void 0 ? void 0 : shouldExpandOnScrollRef.current) && contentWrapper) {
                            const scrolledBy = Math.abs(prevScrollTopRef.current - viewport.scrollTop);
                            if (scrolledBy > 0) {
                                const availableHeight = window.innerHeight - $7cacca21c6f84773$var$CONTENT_MARGIN * 2;
                                const cssMinHeight = parseFloat(contentWrapper.style.minHeight);
                                const cssHeight = parseFloat(contentWrapper.style.height);
                                const prevHeight = Math.max(cssMinHeight, cssHeight);
                                if (prevHeight < availableHeight) {
                                    const nextHeight = prevHeight + scrolledBy;
                                    const clampedNextHeight = Math.min(availableHeight, nextHeight);
                                    const heightDiff = nextHeight - clampedNextHeight;
                                    contentWrapper.style.height = clampedNextHeight + "px";
                                    if (contentWrapper.style.bottom === "0px") {
                                        viewport.scrollTop = heightDiff > 0 ? heightDiff : 0;
                                        contentWrapper.style.justifyContent = "flex-end";
                                    }
                                }
                            }
                        }
                        prevScrollTopRef.current = viewport.scrollTop;
                    })
                }))
            })
        ]
    });
}, "SelectViewport"));
var $7cacca21c6f84773$var$GROUP_NAME = "SelectGroup";
var [$7cacca21c6f84773$var$SelectGroupContextProvider, $7cacca21c6f84773$var$useSelectGroupContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$GROUP_NAME);
var $7cacca21c6f84773$export$eb2fcfdbd7ba97d4 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectGroup2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect } = props, groupProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect"
    ]);
    const groupId = (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)();
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectGroupContextProvider, {
        scope: __scopeSelect,
        id: groupId,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            role: "group",
            "aria-labelledby": groupId
        }, groupProps), {
            ref: forwardedRef
        }))
    });
}, "SelectGroup"));
var $7cacca21c6f84773$var$LABEL_NAME = "SelectLabel";
var $7cacca21c6f84773$export$b04be29aa201d4f5 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectLabel2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect } = props, labelProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect"
    ]);
    const groupContext = $7cacca21c6f84773$var$useSelectGroupContext($7cacca21c6f84773$var$LABEL_NAME, __scopeSelect);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: groupContext.id
    }, labelProps), {
        ref: forwardedRef
    }));
}, "SelectLabel"));
var $7cacca21c6f84773$var$ITEM_NAME = "SelectItem";
var [$7cacca21c6f84773$var$SelectItemContextProvider, $7cacca21c6f84773$var$useSelectItemContext] = $7cacca21c6f84773$var$createSelectContext($7cacca21c6f84773$var$ITEM_NAME);
var $7cacca21c6f84773$export$6d08773d2e66f8f2 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectItem2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect, value: value, disabled: disabled = false, textValue: textValueProp } = props, itemProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "value",
        "disabled",
        "textValue"
    ]);
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$ITEM_NAME, __scopeSelect);
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$ITEM_NAME, __scopeSelect);
    const isSelected = context.value === value;
    const [textValue, setTextValue] = $7fPBF.useState(textValueProp !== null && textValueProp !== void 0 ? textValueProp : "");
    const [isFocused, setIsFocused] = $7fPBF.useState(false);
    const handleItemRefCallback = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)((node)=>{
        var _contentContext_itemRefCallback;
        return (_contentContext_itemRefCallback = contentContext.itemRefCallback) === null || _contentContext_itemRefCallback === void 0 ? void 0 : _contentContext_itemRefCallback.call(contentContext, node, value, disabled);
    });
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, handleItemRefCallback);
    const textId = (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)();
    const pointerTypeRef = $7fPBF.useRef("touch");
    const handleSelect = /* @__PURE__ */ $7cacca21c6f84773$var$__name(()=>{
        if (!disabled) {
            context.onValueChange(value);
            context.onOpenChange(false);
        }
    }, "handleSelect");
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectItemContextProvider, {
        scope: __scopeSelect,
        value: value,
        disabled: disabled,
        textId: textId,
        isSelected: isSelected,
        onItemTextChange: $7fPBF.useCallback((node)=>{
            setTextValue((prevTextValue)=>{
                var _node_textContent;
                return prevTextValue || ((_node_textContent = node === null || node === void 0 ? void 0 : node.textContent) !== null && _node_textContent !== void 0 ? _node_textContent : "").trim();
            });
        }, []),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$Collection.ItemSlot, {
            scope: __scopeSelect,
            value: value,
            disabled: disabled,
            textValue: textValue,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                role: "option",
                "aria-labelledby": textId,
                "data-highlighted": isFocused ? "" : void 0,
                "aria-selected": isSelected && isFocused,
                "data-state": isSelected ? "checked" : "unchecked",
                "aria-disabled": disabled || void 0,
                "data-disabled": disabled ? "" : void 0,
                tabIndex: disabled ? void 0 : -1
            }, itemProps), {
                ref: composedRefs,
                onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onFocus, ()=>setIsFocused(true)),
                onBlur: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onBlur, ()=>setIsFocused(false)),
                onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onClick, ()=>{
                    if (pointerTypeRef.current !== "mouse") handleSelect();
                }),
                onPointerUp: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onPointerUp, ()=>{
                    if (pointerTypeRef.current === "mouse") handleSelect();
                }),
                onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onPointerDown, (event)=>{
                    pointerTypeRef.current = event.pointerType;
                }),
                onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onPointerMove, (event)=>{
                    var _contentContext_onItemLeave;
                    pointerTypeRef.current = event.pointerType;
                    if (disabled) (_contentContext_onItemLeave = contentContext.onItemLeave) === null || _contentContext_onItemLeave === void 0 ? void 0 : _contentContext_onItemLeave.call(contentContext);
                    else if (pointerTypeRef.current === "mouse") event.currentTarget.focus({
                        preventScroll: true
                    });
                }),
                onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onPointerLeave, (event)=>{
                    var _contentContext_onItemLeave;
                    if (event.currentTarget === document.activeElement) (_contentContext_onItemLeave = contentContext.onItemLeave) === null || _contentContext_onItemLeave === void 0 ? void 0 : _contentContext_onItemLeave.call(contentContext);
                }),
                onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(itemProps.onKeyDown, (event)=>{
                    var _contentContext_searchRef;
                    if (disabled || event.target !== event.currentTarget) return;
                    const isTypingAhead = ((_contentContext_searchRef = contentContext.searchRef) === null || _contentContext_searchRef === void 0 ? void 0 : _contentContext_searchRef.current) !== "";
                    if (isTypingAhead && event.key === " ") return;
                    if ($7cacca21c6f84773$var$SELECTION_KEYS.includes(event.key)) handleSelect();
                    if (event.key === " ") event.preventDefault();
                })
            }))
        })
    });
}, "SelectItem"));
var $7cacca21c6f84773$var$ITEM_TEXT_NAME = "SelectItemText";
var $7cacca21c6f84773$export$d6e5bf9c43ea9319 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectItemText2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect, className: className, style: style } = props, itemTextProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "className",
        "style"
    ]);
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$ITEM_TEXT_NAME, __scopeSelect);
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$ITEM_TEXT_NAME, __scopeSelect);
    const itemContext = $7cacca21c6f84773$var$useSelectItemContext($7cacca21c6f84773$var$ITEM_TEXT_NAME, __scopeSelect);
    const nativeOptionsContext = $7cacca21c6f84773$var$useSelectNativeOptionsContext($7cacca21c6f84773$var$ITEM_TEXT_NAME, __scopeSelect);
    const [itemTextNode, setItemTextNode] = $7fPBF.useState(null);
    const handleItemTextRefCallback = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)((node)=>{
        var _contentContext_itemTextRefCallback;
        return (_contentContext_itemTextRefCallback = contentContext.itemTextRefCallback) === null || _contentContext_itemTextRefCallback === void 0 ? void 0 : _contentContext_itemTextRefCallback.call(contentContext, node, itemContext.value, itemContext.disabled);
    });
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, setItemTextNode, itemContext.onItemTextChange, handleItemTextRefCallback);
    const textContent = itemTextNode === null || itemTextNode === void 0 ? void 0 : itemTextNode.textContent;
    const nativeOption = $7fPBF.useMemo(()=>/* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("option", {
            value: itemContext.value,
            disabled: itemContext.disabled,
            children: textContent
        }, itemContext.value), [
        itemContext.disabled,
        itemContext.value,
        textContent
    ]);
    const { onNativeOptionAdd: onNativeOptionAdd, onNativeOptionRemove: onNativeOptionRemove } = nativeOptionsContext;
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        onNativeOptionAdd(nativeOption);
        return ()=>onNativeOptionRemove(nativeOption);
    }, [
        onNativeOptionAdd,
        onNativeOptionRemove,
        nativeOption
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                id: itemContext.textId
            }, itemTextProps), {
                ref: composedRefs
            })),
            itemContext.isSelected && context.valueNode && !context.valueNodeHasChildren && !$7cacca21c6f84773$var$shouldShowPlaceholder(context.value) ? $fw0lo.createPortal(itemTextProps.children, context.valueNode) : null
        ]
    });
}, "SelectItemText"));
var $7cacca21c6f84773$var$ITEM_INDICATOR_NAME = "SelectItemIndicator";
var $7cacca21c6f84773$export$c3468e2714d175fa = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectItemIndicator2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect } = props, itemIndicatorProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect"
    ]);
    const itemContext = $7cacca21c6f84773$var$useSelectItemContext($7cacca21c6f84773$var$ITEM_INDICATOR_NAME, __scopeSelect);
    return itemContext.isSelected ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "aria-hidden": true
    }, itemIndicatorProps), {
        ref: forwardedRef
    })) : null;
}, "SelectItemIndicator"));
var $7cacca21c6f84773$var$SCROLL_UP_BUTTON_NAME = "SelectScrollUpButton";
var $7cacca21c6f84773$export$2f60d3ec9ad468f2 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectScrollUpButton2(props, forwardedRef) {
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $7cacca21c6f84773$var$useSelectViewportContext($7cacca21c6f84773$var$SCROLL_UP_BUTTON_NAME, props.__scopeSelect);
    const [canScrollUp, setCanScrollUp] = $7fPBF.useState(false);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const canScrollUp2 = viewport.scrollTop > 0;
                setCanScrollUp(canScrollUp2);
            };
            var handleScroll = handleScroll2;
            $7cacca21c6f84773$var$__name(handleScroll2, "handleScroll");
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollUp ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectScrollButtonImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop - selectedItem.offsetHeight;
        }
    })) : null;
}, "SelectScrollUpButton"));
var $7cacca21c6f84773$var$SCROLL_DOWN_BUTTON_NAME = "SelectScrollDownButton";
var $7cacca21c6f84773$export$bf1aedc3039c8d63 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectScrollDownButton2(props, forwardedRef) {
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const viewportContext = $7cacca21c6f84773$var$useSelectViewportContext($7cacca21c6f84773$var$SCROLL_DOWN_BUTTON_NAME, props.__scopeSelect);
    const [canScrollDown, setCanScrollDown] = $7fPBF.useState(false);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, viewportContext.onScrollButtonChange);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (contentContext.viewport && contentContext.isPositioned) {
            let handleScroll2 = function() {
                const maxScroll = viewport.scrollHeight - viewport.clientHeight;
                const canScrollDown2 = Math.ceil(viewport.scrollTop) < maxScroll;
                setCanScrollDown(canScrollDown2);
            };
            var handleScroll = handleScroll2;
            $7cacca21c6f84773$var$__name(handleScroll2, "handleScroll");
            const viewport = contentContext.viewport;
            handleScroll2();
            viewport.addEventListener("scroll", handleScroll2);
            return ()=>viewport.removeEventListener("scroll", handleScroll2);
        }
    }, [
        contentContext.viewport,
        contentContext.isPositioned
    ]);
    return canScrollDown ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7cacca21c6f84773$var$SelectScrollButtonImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        ref: composedRefs,
        onAutoScroll: ()=>{
            const { viewport: viewport, selectedItem: selectedItem } = contentContext;
            if (viewport && selectedItem) viewport.scrollTop = viewport.scrollTop + selectedItem.offsetHeight;
        }
    })) : null;
}, "SelectScrollDownButton"));
var $7cacca21c6f84773$var$SelectScrollButtonImpl = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectScrollButtonImpl2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect, onAutoScroll: onAutoScroll } = props, scrollIndicatorProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect",
        "onAutoScroll"
    ]);
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext("SelectScrollButton", __scopeSelect);
    const autoScrollTimerRef = $7fPBF.useRef(null);
    const getItems = $7cacca21c6f84773$var$useCollection(__scopeSelect);
    const clearAutoScrollTimer = $7fPBF.useCallback(()=>{
        if (autoScrollTimerRef.current !== null) {
            window.clearInterval(autoScrollTimerRef.current);
            autoScrollTimerRef.current = null;
        }
    }, []);
    $7fPBF.useEffect(()=>{
        return ()=>clearAutoScrollTimer();
    }, [
        clearAutoScrollTimer
    ]);
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        var _activeItem_ref_current;
        const activeItem = getItems().find((item)=>item.ref.current === document.activeElement);
        activeItem === null || activeItem === void 0 ? void 0 : (_activeItem_ref_current = activeItem.ref.current) === null || _activeItem_ref_current === void 0 ? void 0 : _activeItem_ref_current.scrollIntoView({
            block: "nearest"
        });
    }, [
        getItems
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "aria-hidden": true
    }, scrollIndicatorProps), {
        ref: forwardedRef,
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            flexShrink: 0
        }, scrollIndicatorProps.style),
        onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerDown, ()=>{
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerMove, ()=>{
            var _contentContext_onItemLeave;
            (_contentContext_onItemLeave = contentContext.onItemLeave) === null || _contentContext_onItemLeave === void 0 ? void 0 : _contentContext_onItemLeave.call(contentContext);
            if (autoScrollTimerRef.current === null) autoScrollTimerRef.current = window.setInterval(onAutoScroll, 50);
        }),
        onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(scrollIndicatorProps.onPointerLeave, ()=>{
            clearAutoScrollTimer();
        })
    }));
}, "SelectScrollButtonImpl"));
var $7cacca21c6f84773$export$eba4b1df07cb1d3 = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectSeparator2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect } = props, separatorProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect"
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "aria-hidden": true
    }, separatorProps), {
        ref: forwardedRef
    }));
}, "SelectSeparator"));
var $7cacca21c6f84773$var$ARROW_NAME = "SelectArrow";
var $7cacca21c6f84773$export$21b07c8f274aebd5 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectArrow2(props, forwardedRef) {
    const { __scopeSelect: __scopeSelect } = props, arrowProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeSelect"
    ]);
    const popperScope = $7cacca21c6f84773$var$usePopperScope(__scopeSelect);
    const contentContext = $7cacca21c6f84773$var$useSelectContentContext($7cacca21c6f84773$var$ARROW_NAME, __scopeSelect);
    return contentContext.position === "popper" ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$21b07c8f274aebd5, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, popperScope, arrowProps), {
        ref: forwardedRef
    })) : null;
}, "SelectArrow"));
var $7cacca21c6f84773$var$BUBBLE_INPUT_NAME = "SelectBubbleInput";
var $7cacca21c6f84773$export$493083511fc9f964 = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $7cacca21c6f84773$var$__name(function SelectBubbleInput2(_param, forwardedRef) {
    var { __scopeSelect: __scopeSelect } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "__scopeSelect"
    ]);
    const context = $7cacca21c6f84773$var$useSelectContext($7cacca21c6f84773$var$BUBBLE_INPUT_NAME, __scopeSelect);
    const { value: value, onValueChange: onValueChange, required: required, disabled: disabled, name: name, autoComplete: autoComplete, form: form } = context;
    const { nativeOptions: nativeOptions, nativeSelectKey: nativeSelectKey } = context;
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const selectValue = value !== null && value !== void 0 ? value : "";
    const prevValue = (0, $62f6e650b37fb598$export$5cae361ad82dce8b)(selectValue);
    const hasEmptyValueOption = Array.from(nativeOptions).some((option)=>{
        var _option_props_value;
        return ((_option_props_value = option.props.value) !== null && _option_props_value !== void 0 ? _option_props_value : "") === "";
    });
    $7fPBF.useEffect(()=>{
        const select = ref.current;
        if (!select) return;
        const selectProto = window.HTMLSelectElement.prototype;
        const descriptor = Object.getOwnPropertyDescriptor(selectProto, "value");
        const setValue = descriptor.set;
        if (prevValue !== selectValue && setValue) {
            const event = new Event("change", {
                bubbles: true
            });
            setValue.call(select, selectValue);
            select.dispatchEvent(event);
        }
    }, [
        prevValue,
        selectValue
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).select, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "aria-hidden": true,
        required: required,
        tabIndex: -1,
        name: name,
        autoComplete: autoComplete,
        disabled: disabled,
        form: form,
        onChange: (event)=>onValueChange(event.target.value)
    }, props), {
        style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $28c8fa82e4cfdc1a$export$f23ec2f542b3b173), props.style),
        ref: composedRefs,
        defaultValue: selectValue,
        children: [
            $7cacca21c6f84773$var$shouldShowPlaceholder(value) && !hasEmptyValueOption ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)("option", {
                value: ""
            }) : null,
            Array.from(nativeOptions)
        ]
    }), nativeSelectKey);
}, "SelectBubbleInput"));
function $7cacca21c6f84773$var$isFunction(value) {
    return typeof value === "function";
}
$7cacca21c6f84773$var$__name($7cacca21c6f84773$var$isFunction, "isFunction");
function $7cacca21c6f84773$var$shouldShowPlaceholder(value) {
    return value === "" || value === void 0;
}
$7cacca21c6f84773$var$__name($7cacca21c6f84773$var$shouldShowPlaceholder, "shouldShowPlaceholder");
function $7cacca21c6f84773$var$useTypeaheadSearch(onSearchChange) {
    const handleSearchChange = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onSearchChange);
    const searchRef = $7fPBF.useRef("");
    const timerRef = $7fPBF.useRef(0);
    const handleTypeaheadSearch = $7fPBF.useCallback((key)=>{
        const search = searchRef.current + key;
        handleSearchChange(search);
        /* @__PURE__ */ $7cacca21c6f84773$var$__name(function updateSearch(value) {
            searchRef.current = value;
            window.clearTimeout(timerRef.current);
            if (value !== "") timerRef.current = window.setTimeout(()=>updateSearch(""), 1e3);
        }, "updateSearch")(search);
    }, [
        handleSearchChange
    ]);
    const resetTypeahead = $7fPBF.useCallback(()=>{
        searchRef.current = "";
        window.clearTimeout(timerRef.current);
    }, []);
    $7fPBF.useEffect(()=>{
        return ()=>window.clearTimeout(timerRef.current);
    }, []);
    return [
        searchRef,
        handleTypeaheadSearch,
        resetTypeahead
    ];
}
$7cacca21c6f84773$var$__name($7cacca21c6f84773$var$useTypeaheadSearch, "useTypeaheadSearch");
function $7cacca21c6f84773$var$findNextItem(items, search, currentItem) {
    const isRepeated = search.length > 1 && Array.from(search).every((char)=>char === search[0]);
    const normalizedSearch = isRepeated ? search[0] : search;
    const currentItemIndex = currentItem ? items.indexOf(currentItem) : -1;
    let wrappedItems = $7cacca21c6f84773$var$wrapArray(items, Math.max(currentItemIndex, 0));
    const excludeCurrentItem = normalizedSearch.length === 1;
    if (excludeCurrentItem) wrappedItems = wrappedItems.filter((v)=>v !== currentItem);
    const nextItem = wrappedItems.find((item)=>item.textValue.toLowerCase().startsWith(normalizedSearch.toLowerCase()));
    return nextItem !== currentItem ? nextItem : void 0;
}
$7cacca21c6f84773$var$__name($7cacca21c6f84773$var$findNextItem, "findNextItem");
function $7cacca21c6f84773$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
$7cacca21c6f84773$var$__name($7cacca21c6f84773$var$wrapArray, "wrapArray");


var $039fe4ac9c9107fb$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($039fe4ac9c9107fb$exports) {
        classNames.default = classNames;
        $039fe4ac9c9107fb$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $fa9f79213ccb855a$export$c9daff540c6b217b = "_editorRoot_er3ed_53";
const $fa9f79213ccb855a$export$a58a465d07f7906a = "_editorWrapper_er3ed_155";
const $fa9f79213ccb855a$export$cb2b2415d247318 = "_toolbarRoot_er3ed_162";
const $fa9f79213ccb855a$export$a174775cc2811880 = "_readOnlyToolbarRoot_er3ed_189";
const $fa9f79213ccb855a$export$ced219e2533c0215 = "_toolbarToggleItem_er3ed_208";
const $fa9f79213ccb855a$export$2412d27fe1011ab3 = "_toolbarGroupOfGroups_er3ed_219";
const $fa9f79213ccb855a$export$f704eb7945aa5bf1 = "_toolbarToggleSingleGroup_er3ed_224";
const $fa9f79213ccb855a$export$9c7d691958d83aa0 = "_toolbarButton_er3ed_239";
const $fa9f79213ccb855a$export$aa97869132717df6 = "_activeToolbarButton_er3ed_275";
const $fa9f79213ccb855a$export$5687751ee198ccc6 = "_toolbarButtonDropdownContainer_er3ed_286";
const $fa9f79213ccb855a$export$3db7218f5d99c5f1 = "_selectContainer_er3ed_288";
const $fa9f79213ccb855a$export$f26c97331adc89d5 = "_selectItem_er3ed_301";
const $fa9f79213ccb855a$export$c79b8d090cdcb553 = "_toolbarButtonSelectTrigger_er3ed_307";
const $fa9f79213ccb855a$export$c0db220a8517b10 = "_selectTrigger_er3ed_308";
const $fa9f79213ccb855a$export$f68b3a31524421e0 = "_selectDropdownArrow_er3ed_373";
const $fa9f79213ccb855a$export$d9d317b4285c34e7 = "_contentEditable_er3ed_379";
const $fa9f79213ccb855a$export$20a2b989cf036adc = "_codeMirrorWrapper_er3ed_391";
const $fa9f79213ccb855a$export$94b50ebad31a080a = "_codeMirrorToolbar_er3ed_408";
const $fa9f79213ccb855a$export$c12eee8eff46f9cc = "_propertyPanelTitle_er3ed_430";
const $fa9f79213ccb855a$export$1072fa93ff2deb89 = "_propertyEditorTable_er3ed_438";
const $fa9f79213ccb855a$export$60bb6c1f29b8a8cc = "_iconButton_er3ed_456";
const $fa9f79213ccb855a$export$e29b3181a685144e = "_readOnlyColumnCell_er3ed_461";
const $fa9f79213ccb855a$export$7876ff942d31ed81 = "_buttonsFooter_er3ed_474";
const $fa9f79213ccb855a$export$6474dfe88e69e35d = "_propertyEditorInput_er3ed_480";
const $fa9f79213ccb855a$export$41c1085b355ecc97 = "_primaryButton_er3ed_506";
const $fa9f79213ccb855a$export$130dd2cd4186e923 = "_secondaryButton_er3ed_507";
const $fa9f79213ccb855a$export$32bc0991cdcef676 = "_smallButton_er3ed_522";
const $fa9f79213ccb855a$export$7d6285172b9845dd = "_dialogForm_er3ed_534";
const $fa9f79213ccb855a$export$a947c7fe361e5110 = "_linkDialogEditForm_er3ed_540";
const $fa9f79213ccb855a$export$f4f8db29fada747d = "_linkDialogInputContainer_er3ed_548";
const $fa9f79213ccb855a$export$a4fe0414441f73e5 = "_linkDialogInputWrapper_er3ed_554";
const $fa9f79213ccb855a$export$ce718fd9b6714a74 = "_linkDialogInput_er3ed_548";
const $fa9f79213ccb855a$export$2bb30cab8cce18a1 = "_linkDialogAnchor_er3ed_586";
const $fa9f79213ccb855a$export$a5c2dbbd33747c68 = "_linkDialogPopoverContent_er3ed_600";
const $fa9f79213ccb855a$export$edbbd81f86db5fb = "_tableColumnEditorPopoverContent_er3ed_601";
const $fa9f79213ccb855a$export$1a09c8e9a482a512 = "_dialogContent_er3ed_602";
const $fa9f79213ccb855a$export$e6cd0bcf2000e837 = "_largeDialogContent_er3ed_614";
const $fa9f79213ccb855a$export$b8772d08938399e8 = "_dialogTitle_er3ed_624";
const $fa9f79213ccb855a$export$a6a9de45b3e89eae = "_dialogCloseButton_er3ed_630";
const $fa9f79213ccb855a$export$20c53b1a4e15fba6 = "_popoverContent_er3ed_637";
const $fa9f79213ccb855a$export$d223f99cb5541412 = "_popoverArrow_er3ed_649";
const $fa9f79213ccb855a$export$8d9160fad1006ccd = "_linkDialogPreviewAnchor_er3ed_653";
const $fa9f79213ccb855a$export$7410a3885870d7 = "_tooltipTrigger_er3ed_676";
const $fa9f79213ccb855a$export$2cb4ac289f7843e5 = "_tooltipContent_er3ed_680";
const $fa9f79213ccb855a$export$a75c7ea49564edd7 = "_actionButton_er3ed_694";
const $fa9f79213ccb855a$export$54f61ca0c37b8dbf = "_primaryActionButton_er3ed_701";
const $fa9f79213ccb855a$export$a8fb770cab1726c6 = "_tableEditor_er3ed_713";
const $fa9f79213ccb855a$export$2e653c3a4091a6ed = "_toolCell_er3ed_724";
const $fa9f79213ccb855a$export$2ebcaf26fce272e3 = "_tableColumnEditorTrigger_er3ed_743";
const $fa9f79213ccb855a$export$fcf7175eaabf4565 = "_addRowButton_er3ed_745";
const $fa9f79213ccb855a$export$40f52fea6b2a3dfb = "_addColumnButton_er3ed_746";
const $fa9f79213ccb855a$export$8f846d8f6e11ed0d = "_tableColumnEditorToolbar_er3ed_788";
const $fa9f79213ccb855a$export$66c27d6650e64ca7 = "_toggleGroupRoot_er3ed_801";
const $fa9f79213ccb855a$export$ab66b7b4a2e3ca45 = "_tableToolsColumn_er3ed_819";
const $fa9f79213ccb855a$export$592fffabe9a1cb58 = "_leftAlignedCell_er3ed_828";
const $fa9f79213ccb855a$export$eee899e3e591ce5 = "_rightAlignedCell_er3ed_832";
const $fa9f79213ccb855a$export$32c2df481642f7c = "_centeredCell_er3ed_836";
const $fa9f79213ccb855a$export$fd1af5f6d2c0dae1 = "_dialogOverlay_er3ed_869";
const $fa9f79213ccb855a$export$6e56cd61f93f1017 = "_focusedImage_er3ed_915";
const $fa9f79213ccb855a$export$a41c28168cb6e99e = "_imageWrapper_er3ed_919";
const $fa9f79213ccb855a$export$13a17a4e45aca429 = "_editImageToolbar_er3ed_932";
const $fa9f79213ccb855a$export$14d0eda67f6a5806 = "_editImageButton_er3ed_936";
const $fa9f79213ccb855a$export$c47fc3dab69fce60 = "_inlineEditor_er3ed_942";
const $fa9f79213ccb855a$export$af91ca1d97b3a675 = "_blockEditor_er3ed_951";
const $fa9f79213ccb855a$export$a1b33cecc93b0818 = "_nestedEditor_er3ed_960";
const $fa9f79213ccb855a$export$df6d67494c4d5ccc = "_genericComponentName_er3ed_979";
const $fa9f79213ccb855a$export$5ba612e946c0e874 = "_diffSourceToggleWrapper_er3ed_985";
const $fa9f79213ccb855a$export$79ba83e2e1e55cf4 = "_ggDiffSourceToggle_er3ed_993";
const $fa9f79213ccb855a$export$984fd04afdafe432 = "_diffSourceToggle_er3ed_985";
const $fa9f79213ccb855a$export$7f4aed61eeb2a88d = "_selectWithLabel_er3ed_1011";
const $fa9f79213ccb855a$export$cbe6fe489a28a7a3 = "_toolbarTitleMode_er3ed_1026";
const $fa9f79213ccb855a$export$c030bcc3b172e8cb = "_imageControlWrapperResizing_er3ed_1031";
const $fa9f79213ccb855a$export$668723a28bc50784 = "_imageResizer_er3ed_1035";
const $fa9f79213ccb855a$export$5aa67b5d18bc1ad5 = "_imageResizerN_er3ed_1044";
const $fa9f79213ccb855a$export$db2803ae912a3e15 = "_imageResizerNe_er3ed_1050";
const $fa9f79213ccb855a$export$344d319c843b00ed = "_imageResizerE_er3ed_1056";
const $fa9f79213ccb855a$export$952fe2dc48b8b077 = "_imageResizerSe_er3ed_1062";
const $fa9f79213ccb855a$export$6554a0fda9911298 = "_imageResizerS_er3ed_1062";
const $fa9f79213ccb855a$export$ad662fd448584f8a = "_imageResizerSw_er3ed_1074";
const $fa9f79213ccb855a$export$107aceb3aeab7a9 = "_imageResizerW_er3ed_1080";
const $fa9f79213ccb855a$export$db3bca2c52f94267 = "_imageResizerNw_er3ed_1086";
const $fa9f79213ccb855a$export$889af0f292fa2d2 = "_imagePlaceholder_er3ed_1092";
const $fa9f79213ccb855a$export$9fca76deae785102 = "_imageDimensionsContainer_er3ed_1100";
const $fa9f79213ccb855a$export$c7187bbd1a7a9244 = "_placeholder_er3ed_1105";
const $fa9f79213ccb855a$export$2a56eeeb1a767808 = "_rootContentEditableWrapper_er3ed_1118";
const $fa9f79213ccb855a$export$58c0ccc1350d6a0d = "_downshiftInputWrapper_er3ed_1128";
const $fa9f79213ccb855a$export$34bca709b4253c3e = "_downshiftInput_er3ed_1128";
const $fa9f79213ccb855a$export$11e7ab6bb4d9140c = "_downshiftAutocompleteContainer_er3ed_1159";
const $fa9f79213ccb855a$export$181ff85155496734 = "_textInput_er3ed_1205";
const $fa9f79213ccb855a$export$ca85fafc25c909e8 = "_multiFieldForm_er3ed_1213";
const $fa9f79213ccb855a$export$2a668e8d088a0667 = "_formField_er3ed_1219";
const $fa9f79213ccb855a$export$30b7fc0215b86433 = "_markdownParseError_er3ed_1230";
const $fa9f79213ccb855a$export$5b08e3847660f449 = "_popupContainer_er3ed_1239";
const $fa9f79213ccb855a$export$fa3597ea7d7d392b = "_inputSizer_er3ed_1244";
const $fa9f79213ccb855a$export$2e2bcd8739ae039 = {
    editorRoot: $fa9f79213ccb855a$export$c9daff540c6b217b,
    editorWrapper: $fa9f79213ccb855a$export$a58a465d07f7906a,
    toolbarRoot: $fa9f79213ccb855a$export$cb2b2415d247318,
    readOnlyToolbarRoot: $fa9f79213ccb855a$export$a174775cc2811880,
    toolbarToggleItem: $fa9f79213ccb855a$export$ced219e2533c0215,
    toolbarGroupOfGroups: $fa9f79213ccb855a$export$2412d27fe1011ab3,
    toolbarToggleSingleGroup: $fa9f79213ccb855a$export$f704eb7945aa5bf1,
    toolbarButton: $fa9f79213ccb855a$export$9c7d691958d83aa0,
    activeToolbarButton: $fa9f79213ccb855a$export$aa97869132717df6,
    toolbarButtonDropdownContainer: $fa9f79213ccb855a$export$5687751ee198ccc6,
    selectContainer: $fa9f79213ccb855a$export$3db7218f5d99c5f1,
    selectItem: $fa9f79213ccb855a$export$f26c97331adc89d5,
    toolbarButtonSelectTrigger: $fa9f79213ccb855a$export$c79b8d090cdcb553,
    selectTrigger: $fa9f79213ccb855a$export$c0db220a8517b10,
    selectDropdownArrow: $fa9f79213ccb855a$export$f68b3a31524421e0,
    contentEditable: $fa9f79213ccb855a$export$d9d317b4285c34e7,
    codeMirrorWrapper: $fa9f79213ccb855a$export$20a2b989cf036adc,
    codeMirrorToolbar: $fa9f79213ccb855a$export$94b50ebad31a080a,
    propertyPanelTitle: $fa9f79213ccb855a$export$c12eee8eff46f9cc,
    propertyEditorTable: $fa9f79213ccb855a$export$1072fa93ff2deb89,
    iconButton: $fa9f79213ccb855a$export$60bb6c1f29b8a8cc,
    readOnlyColumnCell: $fa9f79213ccb855a$export$e29b3181a685144e,
    buttonsFooter: $fa9f79213ccb855a$export$7876ff942d31ed81,
    propertyEditorInput: $fa9f79213ccb855a$export$6474dfe88e69e35d,
    primaryButton: $fa9f79213ccb855a$export$41c1085b355ecc97,
    secondaryButton: $fa9f79213ccb855a$export$130dd2cd4186e923,
    smallButton: $fa9f79213ccb855a$export$32bc0991cdcef676,
    dialogForm: $fa9f79213ccb855a$export$7d6285172b9845dd,
    linkDialogEditForm: $fa9f79213ccb855a$export$a947c7fe361e5110,
    linkDialogInputContainer: $fa9f79213ccb855a$export$f4f8db29fada747d,
    linkDialogInputWrapper: $fa9f79213ccb855a$export$a4fe0414441f73e5,
    linkDialogInput: $fa9f79213ccb855a$export$ce718fd9b6714a74,
    linkDialogAnchor: $fa9f79213ccb855a$export$2bb30cab8cce18a1,
    linkDialogPopoverContent: $fa9f79213ccb855a$export$a5c2dbbd33747c68,
    tableColumnEditorPopoverContent: $fa9f79213ccb855a$export$edbbd81f86db5fb,
    dialogContent: $fa9f79213ccb855a$export$1a09c8e9a482a512,
    largeDialogContent: $fa9f79213ccb855a$export$e6cd0bcf2000e837,
    dialogTitle: $fa9f79213ccb855a$export$b8772d08938399e8,
    dialogCloseButton: $fa9f79213ccb855a$export$a6a9de45b3e89eae,
    popoverContent: $fa9f79213ccb855a$export$20c53b1a4e15fba6,
    popoverArrow: $fa9f79213ccb855a$export$d223f99cb5541412,
    linkDialogPreviewAnchor: $fa9f79213ccb855a$export$8d9160fad1006ccd,
    tooltipTrigger: $fa9f79213ccb855a$export$7410a3885870d7,
    tooltipContent: $fa9f79213ccb855a$export$2cb4ac289f7843e5,
    actionButton: $fa9f79213ccb855a$export$a75c7ea49564edd7,
    primaryActionButton: $fa9f79213ccb855a$export$54f61ca0c37b8dbf,
    tableEditor: $fa9f79213ccb855a$export$a8fb770cab1726c6,
    toolCell: $fa9f79213ccb855a$export$2e653c3a4091a6ed,
    tableColumnEditorTrigger: $fa9f79213ccb855a$export$2ebcaf26fce272e3,
    addRowButton: $fa9f79213ccb855a$export$fcf7175eaabf4565,
    addColumnButton: $fa9f79213ccb855a$export$40f52fea6b2a3dfb,
    tableColumnEditorToolbar: $fa9f79213ccb855a$export$8f846d8f6e11ed0d,
    toggleGroupRoot: $fa9f79213ccb855a$export$66c27d6650e64ca7,
    tableToolsColumn: $fa9f79213ccb855a$export$ab66b7b4a2e3ca45,
    leftAlignedCell: $fa9f79213ccb855a$export$592fffabe9a1cb58,
    rightAlignedCell: $fa9f79213ccb855a$export$eee899e3e591ce5,
    centeredCell: $fa9f79213ccb855a$export$32c2df481642f7c,
    dialogOverlay: $fa9f79213ccb855a$export$fd1af5f6d2c0dae1,
    focusedImage: $fa9f79213ccb855a$export$6e56cd61f93f1017,
    imageWrapper: $fa9f79213ccb855a$export$a41c28168cb6e99e,
    editImageToolbar: $fa9f79213ccb855a$export$13a17a4e45aca429,
    editImageButton: $fa9f79213ccb855a$export$14d0eda67f6a5806,
    inlineEditor: $fa9f79213ccb855a$export$c47fc3dab69fce60,
    blockEditor: $fa9f79213ccb855a$export$af91ca1d97b3a675,
    nestedEditor: $fa9f79213ccb855a$export$a1b33cecc93b0818,
    genericComponentName: $fa9f79213ccb855a$export$df6d67494c4d5ccc,
    diffSourceToggleWrapper: $fa9f79213ccb855a$export$5ba612e946c0e874,
    ggDiffSourceToggle: $fa9f79213ccb855a$export$79ba83e2e1e55cf4,
    diffSourceToggle: $fa9f79213ccb855a$export$984fd04afdafe432,
    selectWithLabel: $fa9f79213ccb855a$export$7f4aed61eeb2a88d,
    toolbarTitleMode: $fa9f79213ccb855a$export$cbe6fe489a28a7a3,
    imageControlWrapperResizing: $fa9f79213ccb855a$export$c030bcc3b172e8cb,
    imageResizer: $fa9f79213ccb855a$export$668723a28bc50784,
    imageResizerN: $fa9f79213ccb855a$export$5aa67b5d18bc1ad5,
    imageResizerNe: $fa9f79213ccb855a$export$db2803ae912a3e15,
    imageResizerE: $fa9f79213ccb855a$export$344d319c843b00ed,
    imageResizerSe: $fa9f79213ccb855a$export$952fe2dc48b8b077,
    imageResizerS: $fa9f79213ccb855a$export$6554a0fda9911298,
    imageResizerSw: $fa9f79213ccb855a$export$ad662fd448584f8a,
    imageResizerW: $fa9f79213ccb855a$export$107aceb3aeab7a9,
    imageResizerNw: $fa9f79213ccb855a$export$db3bca2c52f94267,
    imagePlaceholder: $fa9f79213ccb855a$export$889af0f292fa2d2,
    imageDimensionsContainer: $fa9f79213ccb855a$export$9fca76deae785102,
    placeholder: $fa9f79213ccb855a$export$c7187bbd1a7a9244,
    rootContentEditableWrapper: $fa9f79213ccb855a$export$2a56eeeb1a767808,
    downshiftInputWrapper: $fa9f79213ccb855a$export$58c0ccc1350d6a0d,
    downshiftInput: $fa9f79213ccb855a$export$34bca709b4253c3e,
    downshiftAutocompleteContainer: $fa9f79213ccb855a$export$11e7ab6bb4d9140c,
    textInput: $fa9f79213ccb855a$export$181ff85155496734,
    multiFieldForm: $fa9f79213ccb855a$export$ca85fafc25c909e8,
    formField: $fa9f79213ccb855a$export$2a668e8d088a0667,
    markdownParseError: $fa9f79213ccb855a$export$30b7fc0215b86433,
    popupContainer: $fa9f79213ccb855a$export$5b08e3847660f449,
    inputSizer: $fa9f79213ccb855a$export$fa3597ea7d7d392b
};






var $7fPBF = parcelRequire("7fPBF");














"use client";
var $ec185ecb78ca2c5c$var$__defProp = Object.defineProperty;
var $ec185ecb78ca2c5c$var$__name = (target, value)=>$ec185ecb78ca2c5c$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var [$ec185ecb78ca2c5c$var$createTooltipContext, $ec185ecb78ca2c5c$export$1c540a2224f0d865] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)("Tooltip", [
    (0, $7952cd297982b588$export$722aac194ae923)
]);
var $ec185ecb78ca2c5c$var$usePopperScope = (0, $7952cd297982b588$export$722aac194ae923)();
var $ec185ecb78ca2c5c$var$PROVIDER_NAME = "TooltipProvider";
var $ec185ecb78ca2c5c$var$DEFAULT_DELAY_DURATION = 700;
var $ec185ecb78ca2c5c$var$TOOLTIP_OPEN = "tooltip.open";
var [$ec185ecb78ca2c5c$var$TooltipProviderContextProvider, $ec185ecb78ca2c5c$var$useTooltipProviderContext] = $ec185ecb78ca2c5c$var$createTooltipContext($ec185ecb78ca2c5c$var$PROVIDER_NAME);
var $ec185ecb78ca2c5c$export$f78649fb9ca566b8 = /* @__PURE__ */ $ec185ecb78ca2c5c$var$__name((props)=>{
    const { __scopeTooltip: __scopeTooltip, delayDuration: delayDuration = $ec185ecb78ca2c5c$var$DEFAULT_DELAY_DURATION, skipDelayDuration: skipDelayDuration = 300, disableHoverableContent: disableHoverableContent = false, children: children } = props;
    const isOpenDelayedRef = $7fPBF.useRef(true);
    const isPointerInTransitRef = $7fPBF.useRef(false);
    const skipDelayTimerRef = $7fPBF.useRef(0);
    $7fPBF.useEffect(()=>{
        const skipDelayTimer = skipDelayTimerRef.current;
        return ()=>window.clearTimeout(skipDelayTimer);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$TooltipProviderContextProvider, {
        scope: __scopeTooltip,
        isOpenDelayedRef: isOpenDelayedRef,
        delayDuration: delayDuration,
        onOpen: $7fPBF.useCallback(()=>{
            if (skipDelayDuration <= 0) return;
            window.clearTimeout(skipDelayTimerRef.current);
            isOpenDelayedRef.current = false;
        }, [
            skipDelayDuration
        ]),
        onClose: $7fPBF.useCallback(()=>{
            if (skipDelayDuration <= 0) return;
            window.clearTimeout(skipDelayTimerRef.current);
            skipDelayTimerRef.current = window.setTimeout(()=>isOpenDelayedRef.current = true, skipDelayDuration);
        }, [
            skipDelayDuration
        ]),
        isPointerInTransitRef: isPointerInTransitRef,
        onPointerInTransitChange: $7fPBF.useCallback((inTransit)=>{
            isPointerInTransitRef.current = inTransit;
        }, []),
        disableHoverableContent: disableHoverableContent,
        children: children
    });
}, "TooltipProvider");
var $ec185ecb78ca2c5c$var$TOOLTIP_NAME = "Tooltip";
var [$ec185ecb78ca2c5c$var$TooltipContextProvider, $ec185ecb78ca2c5c$var$useTooltipContext] = $ec185ecb78ca2c5c$var$createTooltipContext($ec185ecb78ca2c5c$var$TOOLTIP_NAME);
var $ec185ecb78ca2c5c$export$28c660c63b792dea = /* @__PURE__ */ $ec185ecb78ca2c5c$var$__name((props)=>{
    const { __scopeTooltip: __scopeTooltip, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, disableHoverableContent: disableHoverableContentProp, delayDuration: delayDurationProp } = props;
    const providerContext = $ec185ecb78ca2c5c$var$useTooltipProviderContext($ec185ecb78ca2c5c$var$TOOLTIP_NAME, props.__scopeTooltip);
    const popperScope = $ec185ecb78ca2c5c$var$usePopperScope(__scopeTooltip);
    const [trigger, setTrigger] = $7fPBF.useState(null);
    const [contentIdState, setContentId] = $7fPBF.useState(void 0);
    const generatedContentId = (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)();
    const openTimerRef = $7fPBF.useRef(0);
    const disableHoverableContent = disableHoverableContentProp !== null && disableHoverableContentProp !== void 0 ? disableHoverableContentProp : providerContext.disableHoverableContent;
    const delayDuration = delayDurationProp !== null && delayDurationProp !== void 0 ? delayDurationProp : providerContext.delayDuration;
    const wasOpenDelayedRef = $7fPBF.useRef(false);
    const [open, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : false,
        onChange: /* @__PURE__ */ $ec185ecb78ca2c5c$var$__name((open2)=>{
            if (open2) {
                providerContext.onOpen();
                document.dispatchEvent(new CustomEvent($ec185ecb78ca2c5c$var$TOOLTIP_OPEN));
            } else providerContext.onClose();
            onOpenChange === null || onOpenChange === void 0 ? void 0 : onOpenChange(open2);
        }, "onChange"),
        caller: $ec185ecb78ca2c5c$var$TOOLTIP_NAME
    });
    const stateAttribute = $7fPBF.useMemo(()=>{
        return open ? wasOpenDelayedRef.current ? "delayed-open" : "instant-open" : "closed";
    }, [
        open
    ]);
    const handleOpen = $7fPBF.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
        wasOpenDelayedRef.current = false;
        setOpen(true);
    }, [
        setOpen
    ]);
    const handleClose = $7fPBF.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = 0;
        setOpen(false);
    }, [
        setOpen
    ]);
    const handleDelayedOpen = $7fPBF.useCallback(()=>{
        window.clearTimeout(openTimerRef.current);
        openTimerRef.current = window.setTimeout(()=>{
            wasOpenDelayedRef.current = true;
            setOpen(true);
            openTimerRef.current = 0;
        }, delayDuration);
    }, [
        delayDuration,
        setOpen
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>{
            if (openTimerRef.current) {
                window.clearTimeout(openTimerRef.current);
                openTimerRef.current = 0;
            }
        };
    }, []);
    const contentId = contentIdState !== null && contentIdState !== void 0 ? contentIdState : generatedContentId;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$be92b6f5f03c0fe9, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, popperScope), {
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$TooltipContextProvider, {
            scope: __scopeTooltip,
            contentId: contentId,
            setContentId: setContentId,
            open: open,
            stateAttribute: stateAttribute,
            trigger: trigger,
            onTriggerChange: setTrigger,
            onTriggerEnter: $7fPBF.useCallback(()=>{
                if (providerContext.isOpenDelayedRef.current) handleDelayedOpen();
                else handleOpen();
            }, [
                providerContext.isOpenDelayedRef,
                handleDelayedOpen,
                handleOpen
            ]),
            onTriggerLeave: $7fPBF.useCallback(()=>{
                if (disableHoverableContent) handleClose();
                else {
                    window.clearTimeout(openTimerRef.current);
                    openTimerRef.current = 0;
                }
            }, [
                handleClose,
                disableHoverableContent
            ]),
            onOpen: handleOpen,
            onClose: handleClose,
            disableHoverableContent: disableHoverableContent,
            children: children
        })
    }));
}, "Tooltip");
var $ec185ecb78ca2c5c$var$TRIGGER_NAME = "TooltipTrigger";
var $ec185ecb78ca2c5c$export$8c610744efcf8a1d = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $ec185ecb78ca2c5c$var$__name(function TooltipTrigger2(props, forwardedRef) {
    const { __scopeTooltip: __scopeTooltip } = props, triggerProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeTooltip"
    ]);
    const context = $ec185ecb78ca2c5c$var$useTooltipContext($ec185ecb78ca2c5c$var$TRIGGER_NAME, __scopeTooltip);
    const providerContext = $ec185ecb78ca2c5c$var$useTooltipProviderContext($ec185ecb78ca2c5c$var$TRIGGER_NAME, __scopeTooltip);
    const popperScope = $ec185ecb78ca2c5c$var$usePopperScope(__scopeTooltip);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onTriggerChange);
    const isPointerDownRef = $7fPBF.useRef(false);
    const hasPointerMoveOpenedRef = $7fPBF.useRef(false);
    const handlePointerUp = $7fPBF.useCallback(()=>isPointerDownRef.current = false, []);
    $7fPBF.useEffect(()=>{
        return ()=>document.removeEventListener("pointerup", handlePointerUp);
    }, [
        handlePointerUp
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$b688253958b8dfe7, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        asChild: true
    }, popperScope), {
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            "aria-describedby": context.open ? context.contentId : void 0,
            "data-state": context.stateAttribute
        }, triggerProps), {
            ref: composedRefs,
            onPointerMove: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
                if (event.pointerType === "touch") return;
                if (!hasPointerMoveOpenedRef.current && !providerContext.isPointerInTransitRef.current) {
                    context.onTriggerEnter();
                    hasPointerMoveOpenedRef.current = true;
                }
            }),
            onPointerLeave: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerLeave, ()=>{
                context.onTriggerLeave();
                hasPointerMoveOpenedRef.current = false;
            }),
            onPointerDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDown, ()=>{
                if (context.open) context.onClose();
                isPointerDownRef.current = true;
                document.addEventListener("pointerup", handlePointerUp, {
                    once: true
                });
            }),
            onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocus, ()=>{
                if (!isPointerDownRef.current) context.onOpen();
            }),
            onBlur: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onBlur, context.onClose),
            onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, context.onClose)
        }))
    }));
}, "TooltipTrigger"));
var $ec185ecb78ca2c5c$var$PORTAL_NAME = "TooltipPortal";
var [$ec185ecb78ca2c5c$var$PortalProvider, $ec185ecb78ca2c5c$var$usePortalContext] = $ec185ecb78ca2c5c$var$createTooltipContext($ec185ecb78ca2c5c$var$PORTAL_NAME, {
    forceMount: void 0
});
var $ec185ecb78ca2c5c$export$7b36b8f925ab7497 = /* @__PURE__ */ $ec185ecb78ca2c5c$var$__name((props)=>{
    const { __scopeTooltip: __scopeTooltip, forceMount: forceMount, children: children, container: container } = props;
    const context = $ec185ecb78ca2c5c$var$useTooltipContext($ec185ecb78ca2c5c$var$PORTAL_NAME, __scopeTooltip);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$PortalProvider, {
        scope: __scopeTooltip,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $57c7abe8fecdeb41$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
}, "TooltipPortal");
var $ec185ecb78ca2c5c$var$CONTENT_NAME = "TooltipContent";
var $ec185ecb78ca2c5c$export$e9003e2be37ec060 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $ec185ecb78ca2c5c$var$__name(function TooltipContent2(props, forwardedRef) {
    const portalContext = $ec185ecb78ca2c5c$var$usePortalContext($ec185ecb78ca2c5c$var$CONTENT_NAME, props.__scopeTooltip);
    const { forceMount: forceMount = portalContext.forceMount, side: side = "top" } = props, contentProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "forceMount",
        "side"
    ]);
    const context = $ec185ecb78ca2c5c$var$useTooltipContext($ec185ecb78ca2c5c$var$CONTENT_NAME, props.__scopeTooltip);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.disableHoverableContent ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$TooltipContentImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            side: side
        }, contentProps), {
            ref: forwardedRef
        })) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$TooltipContentHoverable, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            side: side
        }, contentProps), {
            ref: forwardedRef
        }))
    });
}, "TooltipContent"));
var $ec185ecb78ca2c5c$var$TooltipContentHoverable = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $ec185ecb78ca2c5c$var$__name(function TooltipContentHoverable2(props, forwardedRef) {
    const context = $ec185ecb78ca2c5c$var$useTooltipContext($ec185ecb78ca2c5c$var$CONTENT_NAME, props.__scopeTooltip);
    const providerContext = $ec185ecb78ca2c5c$var$useTooltipProviderContext($ec185ecb78ca2c5c$var$CONTENT_NAME, props.__scopeTooltip);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const [pointerGraceArea, setPointerGraceArea] = $7fPBF.useState(null);
    const { trigger: trigger, onClose: onClose } = context;
    const content = ref.current;
    const { onPointerInTransitChange: onPointerInTransitChange } = providerContext;
    const handleRemoveGraceArea = $7fPBF.useCallback(()=>{
        setPointerGraceArea(null);
        onPointerInTransitChange(false);
    }, [
        onPointerInTransitChange
    ]);
    const handleCreateGraceArea = $7fPBF.useCallback((event, hoverTarget)=>{
        const currentTarget = event.currentTarget;
        const exitPoint = {
            x: event.clientX,
            y: event.clientY
        };
        const exitSide = $ec185ecb78ca2c5c$var$getExitSideFromRect(exitPoint, currentTarget.getBoundingClientRect());
        const paddedExitPoints = $ec185ecb78ca2c5c$var$getPaddedExitPoints(exitPoint, exitSide);
        const hoverTargetPoints = $ec185ecb78ca2c5c$var$getPointsFromRect(hoverTarget.getBoundingClientRect());
        const graceArea = $ec185ecb78ca2c5c$var$getHull([
            ...paddedExitPoints,
            ...hoverTargetPoints
        ]);
        setPointerGraceArea(graceArea);
        onPointerInTransitChange(true);
    }, [
        onPointerInTransitChange
    ]);
    $7fPBF.useEffect(()=>{
        return ()=>handleRemoveGraceArea();
    }, [
        handleRemoveGraceArea
    ]);
    $7fPBF.useEffect(()=>{
        if (trigger && content) {
            const handleTriggerLeave = /* @__PURE__ */ $ec185ecb78ca2c5c$var$__name((event)=>handleCreateGraceArea(event, content), "handleTriggerLeave");
            const handleContentLeave = /* @__PURE__ */ $ec185ecb78ca2c5c$var$__name((event)=>handleCreateGraceArea(event, trigger), "handleContentLeave");
            trigger.addEventListener("pointerleave", handleTriggerLeave);
            content.addEventListener("pointerleave", handleContentLeave);
            return ()=>{
                trigger.removeEventListener("pointerleave", handleTriggerLeave);
                content.removeEventListener("pointerleave", handleContentLeave);
            };
        }
    }, [
        trigger,
        content,
        handleCreateGraceArea,
        handleRemoveGraceArea
    ]);
    $7fPBF.useEffect(()=>{
        if (pointerGraceArea) {
            const handleTrackPointerGrace = /* @__PURE__ */ $ec185ecb78ca2c5c$var$__name((event)=>{
                const target = event.target;
                const pointerPosition = {
                    x: event.clientX,
                    y: event.clientY
                };
                const hasEnteredTarget = (trigger === null || trigger === void 0 ? void 0 : trigger.contains(target)) || (content === null || content === void 0 ? void 0 : content.contains(target));
                const isPointerOutsideGraceArea = !$ec185ecb78ca2c5c$var$isPointInPolygon(pointerPosition, pointerGraceArea);
                if (hasEnteredTarget) handleRemoveGraceArea();
                else if (isPointerOutsideGraceArea) {
                    handleRemoveGraceArea();
                    onClose();
                }
            }, "handleTrackPointerGrace");
            document.addEventListener("pointermove", handleTrackPointerGrace);
            return ()=>document.removeEventListener("pointermove", handleTrackPointerGrace);
        }
    }, [
        trigger,
        content,
        pointerGraceArea,
        onClose,
        handleRemoveGraceArea
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$TooltipContentImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        ref: composedRefs
    }));
}, "TooltipContentHoverable"));
var $ec185ecb78ca2c5c$var$Slottable = (0, $089057084dfb92a4$export$bf68c29d8281d0f7)("TooltipContent");
var $ec185ecb78ca2c5c$var$TooltipContentImpl = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $ec185ecb78ca2c5c$var$__name(function TooltipContentImpl2(props, forwardedRef) {
    const { __scopeTooltip: __scopeTooltip, children: children, "aria-label": ariaLabel, id: idProp, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside } = props, contentProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeTooltip",
        "children",
        "aria-label",
        "id",
        "onEscapeKeyDown",
        "onPointerDownOutside"
    ]);
    const context = $ec185ecb78ca2c5c$var$useTooltipContext($ec185ecb78ca2c5c$var$CONTENT_NAME, __scopeTooltip);
    const popperScope = $ec185ecb78ca2c5c$var$usePopperScope(__scopeTooltip);
    const { onClose: onClose } = context;
    $7fPBF.useEffect(()=>{
        document.addEventListener($ec185ecb78ca2c5c$var$TOOLTIP_OPEN, onClose);
        return ()=>document.removeEventListener($ec185ecb78ca2c5c$var$TOOLTIP_OPEN, onClose);
    }, [
        onClose
    ]);
    $7fPBF.useEffect(()=>{
        if (context.trigger) {
            const handleScroll = /* @__PURE__ */ $ec185ecb78ca2c5c$var$__name((event)=>{
                if (event.target instanceof Node && event.target.contains(context.trigger)) onClose();
            }, "handleScroll");
            window.addEventListener("scroll", handleScroll, {
                capture: true
            });
            return ()=>window.removeEventListener("scroll", handleScroll, {
                    capture: true
                });
        }
    }, [
        context.trigger,
        onClose
    ]);
    const { setContentId: setContentId } = context;
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        setContentId(idProp);
        return ()=>{
            setContentId(void 0);
        };
    }, [
        idProp,
        setContentId
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $251340165f4765e5$export$177fb62ff3ec1f22), {
        asChild: true,
        disableOutsidePointerEvents: false,
        onEscapeKeyDown: onEscapeKeyDown,
        onPointerDownOutside: onPointerDownOutside,
        onFocusOutside: (event)=>event.preventDefault(),
        onDismiss: onClose,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsxs)($7952cd297982b588$export$7c6e2c02157bb7d2, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            "data-state": context.stateAttribute,
            role: ariaLabel ? void 0 : "tooltip",
            id: ariaLabel ? void 0 : context.contentId
        }, popperScope, contentProps), {
            ref: forwardedRef,
            style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contentProps.style), {
                "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
                "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
                "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
                "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
                "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
            }),
            children: [
                /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($ec185ecb78ca2c5c$var$Slottable, {
                    children: children
                }),
                ariaLabel ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($28c8fa82e4cfdc1a$export$be92b6f5f03c0fe9, {
                    id: context.contentId,
                    role: "tooltip",
                    children: ariaLabel
                }) : null
            ]
        }))
    });
}, "TooltipContentImpl"));
var $ec185ecb78ca2c5c$export$c27ee0ad710f7559 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $ec185ecb78ca2c5c$var$__name(function TooltipArrow2(props, forwardedRef) {
    const { __scopeTooltip: __scopeTooltip } = props, arrowProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeTooltip"
    ]);
    const popperScope = $ec185ecb78ca2c5c$var$usePopperScope(__scopeTooltip);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$21b07c8f274aebd5, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, popperScope, arrowProps), {
        ref: forwardedRef
    }));
}, "TooltipArrow"));
function $ec185ecb78ca2c5c$var$getExitSideFromRect(point, rect) {
    const top = Math.abs(rect.top - point.y);
    const bottom = Math.abs(rect.bottom - point.y);
    const right = Math.abs(rect.right - point.x);
    const left = Math.abs(rect.left - point.x);
    switch(Math.min(top, bottom, right, left)){
        case left:
            return "left";
        case right:
            return "right";
        case top:
            return "top";
        case bottom:
            return "bottom";
        default:
            throw new Error("unreachable");
    }
}
$ec185ecb78ca2c5c$var$__name($ec185ecb78ca2c5c$var$getExitSideFromRect, "getExitSideFromRect");
function $ec185ecb78ca2c5c$var$getPaddedExitPoints(exitPoint, exitSide, padding = 5) {
    const paddedExitPoints = [];
    switch(exitSide){
        case "top":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "bottom":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            });
            break;
        case "left":
            paddedExitPoints.push({
                x: exitPoint.x + padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x + padding,
                y: exitPoint.y + padding
            });
            break;
        case "right":
            paddedExitPoints.push({
                x: exitPoint.x - padding,
                y: exitPoint.y - padding
            }, {
                x: exitPoint.x - padding,
                y: exitPoint.y + padding
            });
            break;
    }
    return paddedExitPoints;
}
$ec185ecb78ca2c5c$var$__name($ec185ecb78ca2c5c$var$getPaddedExitPoints, "getPaddedExitPoints");
function $ec185ecb78ca2c5c$var$getPointsFromRect(rect) {
    const { top: top, right: right, bottom: bottom, left: left } = rect;
    return [
        {
            x: left,
            y: top
        },
        {
            x: right,
            y: top
        },
        {
            x: right,
            y: bottom
        },
        {
            x: left,
            y: bottom
        }
    ];
}
$ec185ecb78ca2c5c$var$__name($ec185ecb78ca2c5c$var$getPointsFromRect, "getPointsFromRect");
function $ec185ecb78ca2c5c$var$isPointInPolygon(point, polygon) {
    const { x: x, y: y } = point;
    let inside = false;
    for(let i = 0, j = polygon.length - 1; i < polygon.length; j = i++){
        const ii = polygon[i];
        const jj = polygon[j];
        const xi = ii.x;
        const yi = ii.y;
        const xj = jj.x;
        const yj = jj.y;
        const intersect = yi > y !== yj > y && x < (xj - xi) * (y - yi) / (yj - yi) + xi;
        if (intersect) inside = !inside;
    }
    return inside;
}
$ec185ecb78ca2c5c$var$__name($ec185ecb78ca2c5c$var$isPointInPolygon, "isPointInPolygon");
function $ec185ecb78ca2c5c$var$getHull(points) {
    const newPoints = points.slice();
    newPoints.sort((a, b)=>{
        if (a.x < b.x) return -1;
        else if (a.x > b.x) return 1;
        else if (a.y < b.y) return -1;
        else if (a.y > b.y) return 1;
        else return 0;
    });
    return $ec185ecb78ca2c5c$var$getHullPresorted(newPoints);
}
$ec185ecb78ca2c5c$var$__name($ec185ecb78ca2c5c$var$getHull, "getHull");
function $ec185ecb78ca2c5c$var$getHullPresorted(points) {
    if (points.length <= 1) return points.slice();
    const upperHull = [];
    for(let i = 0; i < points.length; i++){
        const p = points[i];
        while(upperHull.length >= 2){
            const q = upperHull[upperHull.length - 1];
            const r = upperHull[upperHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) upperHull.pop();
            else break;
        }
        upperHull.push(p);
    }
    upperHull.pop();
    const lowerHull = [];
    for(let i = points.length - 1; i >= 0; i--){
        const p = points[i];
        while(lowerHull.length >= 2){
            const q = lowerHull[lowerHull.length - 1];
            const r = lowerHull[lowerHull.length - 2];
            if ((q.x - r.x) * (p.y - r.y) >= (q.y - r.y) * (p.x - r.x)) lowerHull.pop();
            else break;
        }
        lowerHull.push(p);
    }
    lowerHull.pop();
    if (upperHull.length === 1 && lowerHull.length === 1 && upperHull[0].x === lowerHull[0].x && upperHull[0].y === lowerHull[0].y) return upperHull;
    else return upperHull.concat(lowerHull);
}
$ec185ecb78ca2c5c$var$__name($ec185ecb78ca2c5c$var$getHullPresorted, "getHullPresorted");
var $ec185ecb78ca2c5c$export$2881499e37b75b9a = $ec185ecb78ca2c5c$export$f78649fb9ca566b8;
var $ec185ecb78ca2c5c$export$be92b6f5f03c0fe9 = $ec185ecb78ca2c5c$export$28c660c63b792dea;
var $ec185ecb78ca2c5c$export$41fb9f06171c75f4 = $ec185ecb78ca2c5c$export$8c610744efcf8a1d;
var $ec185ecb78ca2c5c$export$602eac185826482c = $ec185ecb78ca2c5c$export$7b36b8f925ab7497;
var $ec185ecb78ca2c5c$export$7c6e2c02157bb7d2 = $ec185ecb78ca2c5c$export$e9003e2be37ec060;
var $ec185ecb78ca2c5c$export$21b07c8f274aebd5 = $ec185ecb78ca2c5c$export$c27ee0ad710f7559;




var $7fPBF = parcelRequire("7fPBF");



const $b73514486c0ab31e$export$224f953fa9448341 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef(({ title: title, children: children }, ref)=>{
    const editorRootElementRef = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$48bc1afe38b0f854));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$2881499e37b75b9a, {
        delayDuration: 100
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$be92b6f5f03c0fe9, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$41fb9f06171c75f4, {
        ref: ref,
        asChild: true
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tooltipTrigger
    }, children)), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$602eac185826482c, {
        container: editorRootElementRef == null ? void 0 : editorRootElementRef.current
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$7c6e2c02157bb7d2, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tooltipContent),
        sideOffset: 10
    }, title))));
});




const $75748bcfd2174a65$export$13ef48a934230896 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((_param, forwardedRef)=>{
    var { children: children, className: className } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "children",
        "className"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$6d08773d2e66f8f2, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        ref: forwardedRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(className, (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).selectItem)
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$d6e5bf9c43ea9319, null, children));
});
const $75748bcfd2174a65$export$3ac1e88a1c0b9f1 = ({ title: title, placeholder: placeholder, className: className })=>{
    const [readOnly, iconComponentFor] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $5a7e051e41645429$export$73e7ec35cfb5ca78), (0, $5a7e051e41645429$export$4fd464b2b09e1c4d));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b73514486c0ab31e$export$224f953fa9448341), {
        title: title
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$3ac1e88a1c0b9f1, {
        "aria-label": placeholder,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).selectTrigger, className),
        "data-toolbar-item": true,
        disabled: readOnly
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$e288731fd71264f0, {
        placeholder: placeholder
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$f04a61298a47a40f, {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).selectDropdownArrow
    }, iconComponentFor("arrow_drop_down"))));
};
const $75748bcfd2174a65$export$c973a4b3cb86a03d = ({ children: children, className: className = (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).selectContainer })=>{
    const editorRootElementRef = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$48bc1afe38b0f854));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$602eac185826482c, {
        container: editorRootElementRef == null ? void 0 : editorRootElementRef.current
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$7c6e2c02157bb7d2, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(className, "mdxeditor-select-content"),
        onCloseAutoFocus: (e)=>{
            e.preventDefault();
        },
        position: "popper"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$9ed6e7b40248d36d, {
        "data-editor-dropdown": true,
        style: {
            maxHeight: "var(--radix-select-content-available-height)"
        }
    }, children)));
};
const $75748bcfd2174a65$export$4658761e1b3700f1 = ({ children: children, title: title, className: className })=>{
    const [readOnly, iconComponentFor] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $5a7e051e41645429$export$73e7ec35cfb5ca78), (0, $5a7e051e41645429$export$4fd464b2b09e1c4d));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b73514486c0ab31e$export$224f953fa9448341), {
        title: title
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$3ac1e88a1c0b9f1, {
        "aria-label": title,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarButtonSelectTrigger, className),
        disabled: readOnly
    }, children, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$f04a61298a47a40f, {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).selectDropdownArrow
    }, iconComponentFor("arrow_drop_down"))));
};
const $75748bcfd2174a65$export$ef9b1a59e592288f = (props)=>{
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$be92b6f5f03c0fe9, {
        value: props.value || "",
        onValueChange: props.onChange,
        disabled: props.disabled
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($75748bcfd2174a65$export$3ac1e88a1c0b9f1, {
        title: props.triggerTitle,
        placeholder: props.placeholder
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($75748bcfd2174a65$export$c973a4b3cb86a03d, null, props.items.map((item, index)=>{
        if (item === "separator") return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$eba4b1df07cb1d3, {
            key: index
        });
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($75748bcfd2174a65$export$13ef48a934230896, {
            key: index,
            value: item.value
        }, item.label);
    })));
};


const $3732a83a826f23f5$export$933f3c7e3d0b8adf = ()=>{
    const convertSelectionToNode = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $5a7e051e41645429$export$eb79365488114399));
    const currentBlockType = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$24b7b07377f26bbc));
    const activePlugins = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$5cb858372d2eb3cc));
    const hasQuote = activePlugins.includes("quote");
    const hasHeadings = activePlugins.includes("headings");
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    if (!hasQuote && !hasHeadings) return null;
    const items = [
        {
            label: t("toolbar.blockTypes.paragraph", "Paragraph"),
            value: "paragraph"
        }
    ];
    if (hasQuote) items.push({
        label: t("toolbar.blockTypes.quote", "Quote"),
        value: "quote"
    });
    if (hasHeadings) {
        const allowedHeadingLevels = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $852daab51b9c6f82$export$ee0d7003bc6d0c60));
        items.push(...allowedHeadingLevels.map((n)=>({
                label: t("toolbar.blockTypes.heading", "Heading {{level}}", {
                    level: n
                }),
                value: `h${n}`
            })));
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $75748bcfd2174a65$export$ef9b1a59e592288f), {
        value: currentBlockType,
        onChange: (blockType)=>{
            switch(blockType){
                case "quote":
                    convertSelectionToNode(()=>(0, $cc8bb3cdc37e8788$export$b8120bbdf1338c27)());
                    break;
                case "paragraph":
                    convertSelectionToNode(()=>(0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)());
                    break;
                case "":
                    break;
                default:
                    if (blockType.startsWith("h")) convertSelectionToNode(()=>(0, $cc8bb3cdc37e8788$export$29cdf7c75bd686cc)(blockType));
                    else throw new Error(`Unknown block type: ${blockType}`);
            }
        },
        triggerTitle: t("toolbar.blockTypeSelect.selectBlockTypeTooltip", "Select block type"),
        placeholder: t("toolbar.blockTypeSelect.placeholder", "Block type"),
        items: items
    });
};




var $7fPBF = parcelRequire("7fPBF");









var $7fPBF = parcelRequire("7fPBF");






var $7fPBF = parcelRequire("7fPBF");











var $7fPBF = parcelRequire("7fPBF");
var $be40688614ea023d$var$__defProp = Object.defineProperty;
var $be40688614ea023d$var$__name = (target, value)=>$be40688614ea023d$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $be40688614ea023d$var$_isHydrated = false;
function $be40688614ea023d$var$useIsHydrated() {
    const [isHydrated, setIsHydrated] = $7fPBF.useState($be40688614ea023d$var$_isHydrated);
    $7fPBF.useEffect(()=>{
        if (!$be40688614ea023d$var$_isHydrated) {
            $be40688614ea023d$var$_isHydrated = true;
            setIsHydrated(true);
        }
    }, []);
    return isHydrated;
}
$be40688614ea023d$var$__name($be40688614ea023d$var$useIsHydrated, "useIsHydrated");
// src/use-is-hydrated.tsx
var $be40688614ea023d$var$useReactSyncExternalStore = $7fPBF[" useSyncExternalStore ".trim().toString()];
function $be40688614ea023d$var$subscribe() {
    return ()=>{};
}
$be40688614ea023d$var$__name($be40688614ea023d$var$subscribe, "subscribe");
function $be40688614ea023d$var$useIsHydratedModern() {
    return $be40688614ea023d$var$useReactSyncExternalStore($be40688614ea023d$var$subscribe, ()=>true, ()=>false);
}
$be40688614ea023d$var$__name($be40688614ea023d$var$useIsHydratedModern, "useIsHydratedModern");
var $be40688614ea023d$export$fd0534379e135f3d = typeof $be40688614ea023d$var$useReactSyncExternalStore === "function" ? $be40688614ea023d$var$useIsHydratedModern : $be40688614ea023d$var$useIsHydrated;



"use client";
var $8183e11ba1e9b7dc$var$__defProp = Object.defineProperty;
var $8183e11ba1e9b7dc$var$__name = (target, value)=>$8183e11ba1e9b7dc$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $8183e11ba1e9b7dc$var$ENTRY_FOCUS = "rovingFocusGroup.onEntryFocus";
var $8183e11ba1e9b7dc$var$EVENT_OPTIONS = {
    bubbles: false,
    cancelable: true
};
var $8183e11ba1e9b7dc$var$GROUP_NAME = "RovingFocusGroup";
var [$8183e11ba1e9b7dc$var$Collection, $8183e11ba1e9b7dc$var$useCollection, $8183e11ba1e9b7dc$var$createCollectionScope] = (0, $08a94ba50b5cc249$export$c74125a8e3af6bb2)($8183e11ba1e9b7dc$var$GROUP_NAME);
var [$8183e11ba1e9b7dc$var$createRovingFocusGroupContext, $8183e11ba1e9b7dc$export$c7109489551a4f4] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($8183e11ba1e9b7dc$var$GROUP_NAME, [
    $8183e11ba1e9b7dc$var$createCollectionScope
]);
var [$8183e11ba1e9b7dc$var$RovingFocusProvider, $8183e11ba1e9b7dc$var$useRovingFocusContext] = $8183e11ba1e9b7dc$var$createRovingFocusGroupContext($8183e11ba1e9b7dc$var$GROUP_NAME);
var $8183e11ba1e9b7dc$export$8699f7c8af148338 = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $8183e11ba1e9b7dc$var$__name(function RovingFocusGroup2(props, forwardedRef) {
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$var$Collection.Provider, {
        scope: props.__scopeRovingFocusGroup,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$var$Collection.Slot, {
            scope: props.__scopeRovingFocusGroup,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$var$RovingFocusGroupImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
                ref: forwardedRef
            }))
        })
    });
}, "RovingFocusGroup"));
var $8183e11ba1e9b7dc$var$RovingFocusGroupImpl = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $8183e11ba1e9b7dc$var$__name(function RovingFocusGroupImpl2(props, forwardedRef) {
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, orientation: orientation, loop: loop = false, dir: dir, currentTabStopId: currentTabStopIdProp, defaultCurrentTabStopId: defaultCurrentTabStopId, onCurrentTabStopIdChange: onCurrentTabStopIdChange, onEntryFocus: onEntryFocus, preventScrollOnEntryFocus: preventScrollOnEntryFocus = false } = props, groupProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeRovingFocusGroup",
        "orientation",
        "loop",
        "dir",
        "currentTabStopId",
        "defaultCurrentTabStopId",
        "onCurrentTabStopIdChange",
        "onEntryFocus",
        "preventScrollOnEntryFocus"
    ]);
    const ref = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    const [currentTabStopId, setCurrentTabStopId] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: currentTabStopIdProp,
        defaultProp: defaultCurrentTabStopId !== null && defaultCurrentTabStopId !== void 0 ? defaultCurrentTabStopId : null,
        onChange: onCurrentTabStopIdChange,
        caller: $8183e11ba1e9b7dc$var$GROUP_NAME
    });
    const [isTabbingBackOut, setIsTabbingBackOut] = $7fPBF.useState(false);
    const handleEntryFocus = (0, $4ea47b3abe83764c$export$25bec8c6f54ee79a)(onEntryFocus);
    const getItems = $8183e11ba1e9b7dc$var$useCollection(__scopeRovingFocusGroup);
    const isClickFocusRef = $7fPBF.useRef(false);
    const [focusableItemsCount, setFocusableItemsCount] = $7fPBF.useState(0);
    $7fPBF.useEffect(()=>{
        const node = ref.current;
        if (node) {
            node.addEventListener($8183e11ba1e9b7dc$var$ENTRY_FOCUS, handleEntryFocus);
            return ()=>node.removeEventListener($8183e11ba1e9b7dc$var$ENTRY_FOCUS, handleEntryFocus);
        }
    }, [
        handleEntryFocus
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$var$RovingFocusProvider, {
        scope: __scopeRovingFocusGroup,
        orientation: orientation,
        dir: direction,
        loop: loop,
        currentTabStopId: currentTabStopId,
        onItemFocus: $7fPBF.useCallback((tabStopId)=>setCurrentTabStopId(tabStopId), [
            setCurrentTabStopId
        ]),
        onItemShiftTab: $7fPBF.useCallback(()=>setIsTabbingBackOut(true), []),
        onFocusableItemAdd: $7fPBF.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount + 1), []),
        onFocusableItemRemove: $7fPBF.useCallback(()=>setFocusableItemsCount((prevCount)=>prevCount - 1), []),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            tabIndex: isTabbingBackOut || focusableItemsCount === 0 ? -1 : 0,
            "data-orientation": orientation
        }, groupProps), {
            ref: composedRefs,
            style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                outline: "none"
            }, props.style),
            onMouseDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onMouseDown, ()=>{
                isClickFocusRef.current = true;
            }),
            onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocus, (event)=>{
                const isKeyboardFocus = !isClickFocusRef.current;
                if (event.target === event.currentTarget && isKeyboardFocus && !isTabbingBackOut) {
                    const entryFocusEvent = new CustomEvent($8183e11ba1e9b7dc$var$ENTRY_FOCUS, $8183e11ba1e9b7dc$var$EVENT_OPTIONS);
                    event.currentTarget.dispatchEvent(entryFocusEvent);
                    if (!entryFocusEvent.defaultPrevented) {
                        const items = getItems().filter((item)=>item.focusable);
                        const activeItem = items.find((item)=>item.active);
                        const currentItem = items.find((item)=>item.id === currentTabStopId);
                        const candidateItems = [
                            activeItem,
                            currentItem,
                            ...items
                        ].filter(Boolean);
                        const candidateNodes = candidateItems.map((item)=>item.ref.current);
                        $8183e11ba1e9b7dc$var$focusFirst(candidateNodes, preventScrollOnEntryFocus);
                    }
                }
                isClickFocusRef.current = false;
            }),
            onBlur: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onBlur, ()=>setIsTabbingBackOut(false))
        }))
    });
}, "RovingFocusGroupImpl"));
var $8183e11ba1e9b7dc$var$ITEM_NAME = "RovingFocusGroupItem";
var $8183e11ba1e9b7dc$export$ab9df7c53fe8454 = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $8183e11ba1e9b7dc$var$__name(function RovingFocusGroupItem2(props, forwardedRef) {
    const { __scopeRovingFocusGroup: __scopeRovingFocusGroup, focusable: focusable = true, active: active = false, tabStopId: tabStopId, children: children } = props, itemProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeRovingFocusGroup",
        "focusable",
        "active",
        "tabStopId",
        "children"
    ]);
    const autoId = (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)();
    const id = tabStopId || autoId;
    const context = $8183e11ba1e9b7dc$var$useRovingFocusContext($8183e11ba1e9b7dc$var$ITEM_NAME, __scopeRovingFocusGroup);
    const isCurrentTabStop = context.currentTabStopId === id;
    const getItems = $8183e11ba1e9b7dc$var$useCollection(__scopeRovingFocusGroup);
    const { onFocusableItemAdd: onFocusableItemAdd, onFocusableItemRemove: onFocusableItemRemove, currentTabStopId: currentTabStopId } = context;
    const isHydrated = (0, $be40688614ea023d$export$fd0534379e135f3d)();
    (0, $191a4e5730438e92$export$e5c5a5f917a5871c)(()=>{
        if (!isHydrated || !focusable) return;
        onFocusableItemAdd();
        return ()=>onFocusableItemRemove();
    }, [
        isHydrated,
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    $7fPBF.useEffect(()=>{
        if (isHydrated || !focusable) return;
        onFocusableItemAdd();
        return ()=>onFocusableItemRemove();
    }, [
        isHydrated,
        focusable,
        onFocusableItemAdd,
        onFocusableItemRemove
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$var$Collection.ItemSlot, {
        scope: __scopeRovingFocusGroup,
        id: id,
        focusable: focusable,
        active: active,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).span, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            tabIndex: isCurrentTabStop ? 0 : -1,
            "data-orientation": context.orientation
        }, itemProps), {
            ref: forwardedRef,
            onMouseDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onMouseDown, (event)=>{
                if (!focusable) event.preventDefault();
                else context.onItemFocus(id);
            }),
            onFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocus, ()=>context.onItemFocus(id)),
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.key === "Tab" && event.shiftKey) {
                    context.onItemShiftTab();
                    return;
                }
                if (event.target !== event.currentTarget) return;
                const focusIntent = $8183e11ba1e9b7dc$var$getFocusIntent(event, context.orientation, context.dir);
                if (focusIntent !== void 0) {
                    if (event.metaKey || event.ctrlKey || event.altKey || event.shiftKey) return;
                    event.preventDefault();
                    const items = getItems().filter((item)=>item.focusable);
                    let candidateNodes = items.map((item)=>item.ref.current);
                    if (focusIntent === "last") candidateNodes.reverse();
                    else if (focusIntent === "prev" || focusIntent === "next") {
                        if (focusIntent === "prev") candidateNodes.reverse();
                        const currentIndex = candidateNodes.indexOf(event.currentTarget);
                        candidateNodes = context.loop ? $8183e11ba1e9b7dc$var$wrapArray(candidateNodes, currentIndex + 1) : candidateNodes.slice(currentIndex + 1);
                    }
                    setTimeout(()=>$8183e11ba1e9b7dc$var$focusFirst(candidateNodes));
                }
            }),
            children: typeof children === "function" ? children({
                isCurrentTabStop: isCurrentTabStop,
                hasTabStop: currentTabStopId != null
            }) : children
        }))
    });
}, "RovingFocusGroupItem"));
var $8183e11ba1e9b7dc$var$MAP_KEY_TO_FOCUS_INTENT = {
    ArrowLeft: "prev",
    ArrowUp: "prev",
    ArrowRight: "next",
    ArrowDown: "next",
    PageUp: "first",
    Home: "first",
    PageDown: "last",
    End: "last"
};
function $8183e11ba1e9b7dc$var$getDirectionAwareKey(key, dir) {
    if (dir !== "rtl") return key;
    return key === "ArrowLeft" ? "ArrowRight" : key === "ArrowRight" ? "ArrowLeft" : key;
}
$8183e11ba1e9b7dc$var$__name($8183e11ba1e9b7dc$var$getDirectionAwareKey, "getDirectionAwareKey");
function $8183e11ba1e9b7dc$var$getFocusIntent(event, orientation, dir) {
    const key = $8183e11ba1e9b7dc$var$getDirectionAwareKey(event.key, dir);
    if (orientation === "vertical" && [
        "ArrowLeft",
        "ArrowRight"
    ].includes(key)) return void 0;
    if (orientation === "horizontal" && [
        "ArrowUp",
        "ArrowDown"
    ].includes(key)) return void 0;
    return $8183e11ba1e9b7dc$var$MAP_KEY_TO_FOCUS_INTENT[key];
}
$8183e11ba1e9b7dc$var$__name($8183e11ba1e9b7dc$var$getFocusIntent, "getFocusIntent");
function $8183e11ba1e9b7dc$var$focusFirst(candidates, preventScroll = false) {
    const PREVIOUSLY_FOCUSED_ELEMENT = document.activeElement;
    for (const candidate of candidates){
        if (candidate === PREVIOUSLY_FOCUSED_ELEMENT) return;
        candidate.focus({
            preventScroll: preventScroll
        });
        if (document.activeElement !== PREVIOUSLY_FOCUSED_ELEMENT) return;
    }
}
$8183e11ba1e9b7dc$var$__name($8183e11ba1e9b7dc$var$focusFirst, "focusFirst");
function $8183e11ba1e9b7dc$var$wrapArray(array, startIndex) {
    return array.map((_, index)=>array[(startIndex + index) % array.length]);
}
$8183e11ba1e9b7dc$var$__name($8183e11ba1e9b7dc$var$wrapArray, "wrapArray");
var $8183e11ba1e9b7dc$export$be92b6f5f03c0fe9 = $8183e11ba1e9b7dc$export$8699f7c8af148338;
var $8183e11ba1e9b7dc$export$6d08773d2e66f8f2 = $8183e11ba1e9b7dc$export$ab9df7c53fe8454;







var $7fPBF = parcelRequire("7fPBF");


var $060fa6dd431bc46c$var$__defProp = Object.defineProperty;
var $060fa6dd431bc46c$var$__name = (target, value)=>$060fa6dd431bc46c$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $060fa6dd431bc46c$var$DEFAULT_ORIENTATION = "horizontal";
var $060fa6dd431bc46c$var$ORIENTATIONS = [
    "horizontal",
    "vertical"
];
var $060fa6dd431bc46c$export$1ff3c3f08ae963c0 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $060fa6dd431bc46c$var$__name(function Separator2(props, forwardedRef) {
    const { decorative: decorative, orientation: orientationProp = $060fa6dd431bc46c$var$DEFAULT_ORIENTATION } = props, domProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "decorative",
        "orientation"
    ]);
    const orientation = $060fa6dd431bc46c$var$isValidOrientation(orientationProp) ? orientationProp : $060fa6dd431bc46c$var$DEFAULT_ORIENTATION;
    const ariaOrientation = orientation === "vertical" ? orientation : void 0;
    const semanticProps = decorative ? {
        role: "none"
    } : {
        "aria-orientation": ariaOrientation,
        role: "separator"
    };
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "data-orientation": orientation
    }, semanticProps, domProps), {
        ref: forwardedRef
    }));
}, "Separator"));
function $060fa6dd431bc46c$var$isValidOrientation(orientation) {
    return $060fa6dd431bc46c$var$ORIENTATIONS.includes(orientation);
}
$060fa6dd431bc46c$var$__name($060fa6dd431bc46c$var$isValidOrientation, "isValidOrientation");
var $060fa6dd431bc46c$export$be92b6f5f03c0fe9 = $060fa6dd431bc46c$export$1ff3c3f08ae963c0;






var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");




"use client";
var $190783a67cfa1dc0$var$__defProp = Object.defineProperty;
var $190783a67cfa1dc0$var$__name = (target, value)=>$190783a67cfa1dc0$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $190783a67cfa1dc0$var$NAME = "Toggle";
var $190783a67cfa1dc0$export$bea8ebba691c5813 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $190783a67cfa1dc0$var$__name(function Toggle2(props, forwardedRef) {
    const { pressed: pressedProp, defaultPressed: defaultPressed, onPressedChange: onPressedChange } = props, buttonProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "pressed",
        "defaultPressed",
        "onPressedChange"
    ]);
    const [pressed, setPressed] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: pressedProp,
        onChange: onPressedChange,
        defaultProp: defaultPressed !== null && defaultPressed !== void 0 ? defaultPressed : false,
        caller: $190783a67cfa1dc0$var$NAME
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        type: "button",
        "aria-pressed": pressed,
        "data-state": pressed ? "on" : "off",
        "data-disabled": props.disabled ? "" : void 0
    }, buttonProps), {
        ref: forwardedRef,
        onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, ()=>{
            if (!props.disabled) setPressed(!pressed);
        })
    }));
}, "Toggle"));
var $190783a67cfa1dc0$export$be92b6f5f03c0fe9 = $190783a67cfa1dc0$export$bea8ebba691c5813;





"use client";
var $45e01d9175aeb53c$var$__defProp = Object.defineProperty;
var $45e01d9175aeb53c$var$__name = (target, value)=>$45e01d9175aeb53c$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $45e01d9175aeb53c$var$TOGGLE_GROUP_NAME = "ToggleGroup";
var [$45e01d9175aeb53c$var$createToggleGroupContext, $45e01d9175aeb53c$export$d1c7c4bcd9f26dd4] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($45e01d9175aeb53c$var$TOGGLE_GROUP_NAME, [
    (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)
]);
var $45e01d9175aeb53c$var$useRovingFocusGroupScope = (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)();
var $45e01d9175aeb53c$export$be92b6f5f03c0fe9 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $45e01d9175aeb53c$var$__name(function ToggleGroup2(props, forwardedRef) {
    const { type: type } = props, toggleGroupProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "type"
    ]);
    if (type === "single") {
        const singleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupImplSingle, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            role: "radiogroup"
        }, singleProps), {
            ref: forwardedRef
        }));
    }
    if (type === "multiple") {
        const multipleProps = toggleGroupProps;
        return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupImplMultiple, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            role: "toolbar"
        }, multipleProps), {
            ref: forwardedRef
        }));
    }
    throw new Error(`Missing prop \`type\` expected on \`${$45e01d9175aeb53c$var$TOGGLE_GROUP_NAME}\``);
}, "ToggleGroup"));
var [$45e01d9175aeb53c$var$ToggleGroupValueProvider, $45e01d9175aeb53c$var$useToggleGroupValueContext] = $45e01d9175aeb53c$var$createToggleGroupContext($45e01d9175aeb53c$var$TOGGLE_GROUP_NAME);
var $45e01d9175aeb53c$var$ToggleGroupImplSingle = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $45e01d9175aeb53c$var$__name(function ToggleGroupImplSingle2(props, forwardedRef) {
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = /* @__PURE__ */ $45e01d9175aeb53c$var$__name(()=>{}, "onValueChange") } = props, toggleGroupSingleProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "value",
        "defaultValue",
        "onValueChange"
    ]);
    const [value, setValue] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue !== null && defaultValue !== void 0 ? defaultValue : "",
        onChange: onValueChange,
        caller: $45e01d9175aeb53c$var$TOGGLE_GROUP_NAME
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "single",
        value: $7fPBF.useMemo(()=>value ? [
                value
            ] : [], [
            value
        ]),
        onItemActivate: setValue,
        onItemDeactivate: $7fPBF.useCallback(()=>setValue(""), [
            setValue
        ]),
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, toggleGroupSingleProps), {
            ref: forwardedRef
        }))
    });
}, "ToggleGroupImplSingle"));
var $45e01d9175aeb53c$var$ToggleGroupImplMultiple = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $45e01d9175aeb53c$var$__name(function ToggleGroupImplMultiple2(props, forwardedRef) {
    const { value: valueProp, defaultValue: defaultValue, onValueChange: onValueChange = /* @__PURE__ */ $45e01d9175aeb53c$var$__name(()=>{}, "onValueChange") } = props, toggleGroupMultipleProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "value",
        "defaultValue",
        "onValueChange"
    ]);
    const [value, setValue] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: valueProp,
        defaultProp: defaultValue !== null && defaultValue !== void 0 ? defaultValue : [],
        onChange: onValueChange,
        caller: $45e01d9175aeb53c$var$TOGGLE_GROUP_NAME
    });
    const handleButtonActivate = $7fPBF.useCallback((itemValue)=>setValue((prevValue = [])=>[
                ...prevValue,
                itemValue
            ]), [
        setValue
    ]);
    const handleButtonDeactivate = $7fPBF.useCallback((itemValue)=>setValue((prevValue = [])=>prevValue.filter((value2)=>value2 !== itemValue)), [
        setValue
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupValueProvider, {
        scope: props.__scopeToggleGroup,
        type: "multiple",
        value: value,
        onItemActivate: handleButtonActivate,
        onItemDeactivate: handleButtonDeactivate,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, toggleGroupMultipleProps), {
            ref: forwardedRef
        }))
    });
}, "ToggleGroupImplMultiple"));
var [$45e01d9175aeb53c$var$ToggleGroupContext, $45e01d9175aeb53c$var$useToggleGroupContext] = $45e01d9175aeb53c$var$createToggleGroupContext($45e01d9175aeb53c$var$TOGGLE_GROUP_NAME);
var $45e01d9175aeb53c$var$ToggleGroupImpl = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $45e01d9175aeb53c$var$__name(function ToggleGroupImpl2(props, forwardedRef) {
    const { __scopeToggleGroup: __scopeToggleGroup, disabled: disabled = false, rovingFocus: rovingFocus = true, orientation: orientation, dir: dir, loop: loop = true } = props, toggleGroupProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeToggleGroup",
        "disabled",
        "rovingFocus",
        "orientation",
        "dir",
        "loop"
    ]);
    const rovingFocusGroupScope = $45e01d9175aeb53c$var$useRovingFocusGroupScope(__scopeToggleGroup);
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    const commonProps = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        dir: direction
    }, toggleGroupProps);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupContext, {
        scope: __scopeToggleGroup,
        rovingFocus: rovingFocus,
        disabled: disabled,
        children: rovingFocus ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$be92b6f5f03c0fe9, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            asChild: true
        }, rovingFocusGroupScope), {
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, commonProps), {
                ref: forwardedRef
            }))
        })) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, commonProps), {
            ref: forwardedRef
        }))
    });
}, "ToggleGroupImpl"));
var $45e01d9175aeb53c$var$ITEM_NAME = "ToggleGroupItem";
var $45e01d9175aeb53c$export$6d08773d2e66f8f2 = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $45e01d9175aeb53c$var$__name(function ToggleGroupItem2(props, forwardedRef) {
    const valueContext = $45e01d9175aeb53c$var$useToggleGroupValueContext($45e01d9175aeb53c$var$ITEM_NAME, props.__scopeToggleGroup);
    const context = $45e01d9175aeb53c$var$useToggleGroupContext($45e01d9175aeb53c$var$ITEM_NAME, props.__scopeToggleGroup);
    const rovingFocusGroupScope = $45e01d9175aeb53c$var$useRovingFocusGroupScope(props.__scopeToggleGroup);
    const pressed = valueContext.value.includes(props.value);
    const disabled = context.disabled || props.disabled;
    const commonProps = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        pressed: pressed,
        disabled: disabled
    });
    const ref = $7fPBF.useRef(null);
    return context.rovingFocus ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$6d08773d2e66f8f2, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        asChild: true
    }, rovingFocusGroupScope), {
        focusable: !disabled,
        active: pressed,
        ref: ref,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupItemImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, commonProps), {
            ref: forwardedRef
        }))
    })) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$var$ToggleGroupItemImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, commonProps), {
        ref: forwardedRef
    }));
}, "ToggleGroupItem"));
var $45e01d9175aeb53c$var$ToggleGroupItemImpl = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $45e01d9175aeb53c$var$__name(function ToggleGroupItemImpl2(props, forwardedRef) {
    const { __scopeToggleGroup: __scopeToggleGroup, value: value } = props, itemProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeToggleGroup",
        "value"
    ]);
    const valueContext = $45e01d9175aeb53c$var$useToggleGroupValueContext($45e01d9175aeb53c$var$ITEM_NAME, __scopeToggleGroup);
    const singleProps = {
        role: "radio",
        "aria-checked": props.pressed,
        "aria-pressed": void 0
    };
    const typeProps = valueContext.type === "single" ? singleProps : void 0;
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $190783a67cfa1dc0$export$bea8ebba691c5813), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, typeProps, itemProps), {
        ref: forwardedRef,
        onPressedChange: (pressed)=>{
            if (pressed) valueContext.onItemActivate(value);
            else valueContext.onItemDeactivate(value);
        }
    }));
}, "ToggleGroupItemImpl"));




"use client";
var $3addc25501ee06b8$var$__defProp = Object.defineProperty;
var $3addc25501ee06b8$var$__name = (target, value)=>$3addc25501ee06b8$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $3addc25501ee06b8$var$TOOLBAR_NAME = "Toolbar";
var [$3addc25501ee06b8$var$createToolbarContext, $3addc25501ee06b8$export$233e637670877d91] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($3addc25501ee06b8$var$TOOLBAR_NAME, [
    (0, $8183e11ba1e9b7dc$export$c7109489551a4f4),
    (0, $45e01d9175aeb53c$export$d1c7c4bcd9f26dd4)
]);
var $3addc25501ee06b8$var$useRovingFocusGroupScope = (0, $8183e11ba1e9b7dc$export$c7109489551a4f4)();
var $3addc25501ee06b8$var$useToggleGroupScope = (0, $45e01d9175aeb53c$export$d1c7c4bcd9f26dd4)();
var [$3addc25501ee06b8$var$ToolbarProvider, $3addc25501ee06b8$var$useToolbarContext] = $3addc25501ee06b8$var$createToolbarContext($3addc25501ee06b8$var$TOOLBAR_NAME);
var $3addc25501ee06b8$export$4c260019440d418f = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $3addc25501ee06b8$var$__name(function Toolbar2(props, forwardedRef) {
    const { __scopeToolbar: __scopeToolbar, orientation: orientation = "horizontal", dir: dir, loop: loop = true } = props, toolbarProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeToolbar",
        "orientation",
        "dir",
        "loop"
    ]);
    const rovingFocusGroupScope = $3addc25501ee06b8$var$useRovingFocusGroupScope(__scopeToolbar);
    const direction = (0, $3342477e04611d10$export$b39126d51d94e6f3)(dir);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($3addc25501ee06b8$var$ToolbarProvider, {
        scope: __scopeToolbar,
        orientation: orientation,
        dir: direction,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$be92b6f5f03c0fe9, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            asChild: true
        }, rovingFocusGroupScope), {
            orientation: orientation,
            dir: direction,
            loop: loop,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).div, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                role: "toolbar",
                "aria-orientation": orientation,
                dir: direction
            }, toolbarProps), {
                ref: forwardedRef
            }))
        }))
    });
}, "Toolbar"));
var $3addc25501ee06b8$var$SEPARATOR_NAME = "ToolbarSeparator";
var $3addc25501ee06b8$export$291e1a31e8ec7868 = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $3addc25501ee06b8$var$__name(function ToolbarSeparator2(props, forwardedRef) {
    const { __scopeToolbar: __scopeToolbar } = props, separatorProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeToolbar"
    ]);
    const context = $3addc25501ee06b8$var$useToolbarContext($3addc25501ee06b8$var$SEPARATOR_NAME, __scopeToolbar);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($060fa6dd431bc46c$export$be92b6f5f03c0fe9, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        orientation: context.orientation === "horizontal" ? "vertical" : "horizontal"
    }, separatorProps), {
        ref: forwardedRef
    }));
}, "ToolbarSeparator"));
var $3addc25501ee06b8$export$e5c1a33878e86e9e = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $3addc25501ee06b8$var$__name(function ToolbarButton2(props, forwardedRef) {
    const { __scopeToolbar: __scopeToolbar } = props, buttonProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeToolbar"
    ]);
    const rovingFocusGroupScope = $3addc25501ee06b8$var$useRovingFocusGroupScope(__scopeToolbar);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$6d08773d2e66f8f2, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        asChild: true
    }, rovingFocusGroupScope), {
        focusable: !props.disabled,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: "button"
        }, buttonProps), {
            ref: forwardedRef
        }))
    }));
}, "ToolbarButton"));
var $3addc25501ee06b8$export$ff5714eba66809fd = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $3addc25501ee06b8$var$__name(function ToolbarLink2(props, forwardedRef) {
    const { __scopeToolbar: __scopeToolbar } = props, linkProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeToolbar"
    ]);
    const rovingFocusGroupScope = $3addc25501ee06b8$var$useRovingFocusGroupScope(__scopeToolbar);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($8183e11ba1e9b7dc$export$6d08773d2e66f8f2, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        asChild: true
    }, rovingFocusGroupScope), {
        focusable: true,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).a, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, linkProps), {
            ref: forwardedRef,
            onKeyDown: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
                if (event.target !== event.currentTarget) return;
                if (event.key === " ") event.currentTarget.click();
            })
        }))
    }));
}, "ToolbarLink"));
var $3addc25501ee06b8$var$TOGGLE_GROUP_NAME = "ToolbarToggleGroup";
var $3addc25501ee06b8$export$aeae28cb17562c0b = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $3addc25501ee06b8$var$__name(function ToolbarToggleGroup2(props, forwardedRef) {
    const { __scopeToolbar: __scopeToolbar } = props, toggleGroupProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeToolbar"
    ]);
    const context = $3addc25501ee06b8$var$useToolbarContext($3addc25501ee06b8$var$TOGGLE_GROUP_NAME, __scopeToolbar);
    const toggleGroupScope = $3addc25501ee06b8$var$useToggleGroupScope(__scopeToolbar);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$export$be92b6f5f03c0fe9, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "data-orientation": context.orientation,
        dir: context.dir
    }, toggleGroupScope, toggleGroupProps), {
        ref: forwardedRef,
        rovingFocus: false
    }));
}, "ToolbarToggleGroup"));
var $3addc25501ee06b8$export$546b879b639844a1 = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $3addc25501ee06b8$var$__name(function ToolbarToggleItem2(props, forwardedRef) {
    const { __scopeToolbar: __scopeToolbar } = props, toggleItemProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopeToolbar"
    ]);
    const toggleGroupScope = $3addc25501ee06b8$var$useToggleGroupScope(__scopeToolbar);
    const scope = {
        __scopeToolbar: props.__scopeToolbar
    };
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($3addc25501ee06b8$export$e5c1a33878e86e9e, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        asChild: true
    }, scope), {
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($45e01d9175aeb53c$export$6d08773d2e66f8f2, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, toggleGroupScope, toggleItemProps), {
            ref: forwardedRef
        }))
    }));
}, "ToolbarToggleItem"));
var $3addc25501ee06b8$export$be92b6f5f03c0fe9 = $3addc25501ee06b8$export$4c260019440d418f;
var $3addc25501ee06b8$export$1ff3c3f08ae963c0 = $3addc25501ee06b8$export$291e1a31e8ec7868;
var $3addc25501ee06b8$export$353f5b6fc5456de1 = $3addc25501ee06b8$export$e5c1a33878e86e9e;
var $3addc25501ee06b8$export$a6c7ac8248d6e38a = $3addc25501ee06b8$export$ff5714eba66809fd;
var $3addc25501ee06b8$export$af3ec21f6cfb5e30 = $3addc25501ee06b8$export$aeae28cb17562c0b;
var $3addc25501ee06b8$export$920ad4cf87b18fc7 = $3addc25501ee06b8$export$546b879b639844a1;




var $7fPBF = parcelRequire("7fPBF");





function $5f22da7309bc91a3$var$decorateWithRef(Component, decoratedProps) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, ref)=>{
        const className = (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))(decoratedProps.className, props.className);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, decoratedProps, props), {
            className: className,
            ref: ref
        }));
    });
}
function $5f22da7309bc91a3$var$addTooltipToChildren(Component) {
    return (_param)=>{
        var { title: title, children: children } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
            "title",
            "children"
        ]);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Component, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            "aria-label": title
        }, props), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b73514486c0ab31e$export$224f953fa9448341), {
            title: title
        }, children));
    };
}
const $5f22da7309bc91a3$export$be92b6f5f03c0fe9 = ({ readOnly: readOnly, children: children, className: className })=>{
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$be92b6f5f03c0fe9, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("mdxeditor-toolbar", (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarRoot, {
            [(0, $fa9f79213ccb855a$export$2e2bcd8739ae039).readOnlyToolbarRoot]: readOnly
        }, className)
    }, readOnly ? {
        tabIndex: -1
    } : {}), children);
};
const $5f22da7309bc91a3$export$353f5b6fc5456de1 = $5f22da7309bc91a3$var$decorateWithRef($3addc25501ee06b8$export$353f5b6fc5456de1, {
    className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarButton,
    "data-toolbar-item": true
});
const $5f22da7309bc91a3$export$1158bddbb6341bad = $5f22da7309bc91a3$var$addTooltipToChildren($5f22da7309bc91a3$export$353f5b6fc5456de1);
const $5f22da7309bc91a3$export$546b879b639844a1 = $5f22da7309bc91a3$var$decorateWithRef($3addc25501ee06b8$export$920ad4cf87b18fc7, {
    className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarToggleItem,
    "data-toolbar-item": true
});
const $5f22da7309bc91a3$export$561c9a63797a7e0b = $5f22da7309bc91a3$var$decorateWithRef($3addc25501ee06b8$export$af3ec21f6cfb5e30, {
    type: "single",
    className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarToggleSingleGroup
});
const $5f22da7309bc91a3$export$b5f40907b46fefc4 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((_param, forwardedRef)=>{
    var { on: on, title: title, children: children, disabled: disabled } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "on",
        "title",
        "children",
        "disabled"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$af3ec21f6cfb5e30, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        type: "single",
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarToggleSingleGroup
    }, props), {
        value: on ? "on" : "off",
        ref: forwardedRef
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5f22da7309bc91a3$export$546b879b639844a1, {
        "aria-label": title,
        value: "on",
        disabled: disabled
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b73514486c0ab31e$export$224f953fa9448341), {
        title: title
    }, children)));
});
const $5f22da7309bc91a3$export$12058739e3b8fa5e = ({ items: items })=>{
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarGroupOfGroups
    }, items.map((item, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5f22da7309bc91a3$export$b5f40907b46fefc4, {
            key: index,
            title: item.title,
            on: item.active,
            onValueChange: (v)=>{
                item.onChange(v === "on");
            },
            disabled: item.disabled
        }, item.contents)));
};
const $5f22da7309bc91a3$export$cf568d00ccf58bd3 = ({ value: value, onChange: onChange, className: className, ggClassName: ggClassName, items: items, disabled: disabled })=>{
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarGroupOfGroups, ggClassName)
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$af3ec21f6cfb5e30, {
        "aria-label": t("toolbar.toggleGroup", "toggle group"),
        type: "single",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarToggleSingleGroup, className),
        onValueChange: onChange,
        value: value || "",
        disabled: disabled,
        onFocus: (e)=>{
            e.preventDefault();
        }
    }, items.map((item, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5f22da7309bc91a3$export$546b879b639844a1, {
            key: index,
            "aria-label": item.title,
            value: item.value
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $b73514486c0ab31e$export$224f953fa9448341), {
            title: item.title
        }, item.contents)))));
};
const $5f22da7309bc91a3$export$c621b5ff645a4916 = (props)=>{
    const readOnly = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$73e7ec35cfb5ca78));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, props.items.length === 1 ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5f22da7309bc91a3$export$1158bddbb6341bad, {
        title: props.title,
        onClick: ()=>{
            props.onChoose("");
        },
        disabled: readOnly
    }, props.children) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($7cacca21c6f84773$export$be92b6f5f03c0fe9, {
        value: "",
        onValueChange: props.onChoose
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $75748bcfd2174a65$export$4658761e1b3700f1), {
        title: props.title
    }, props.children), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $75748bcfd2174a65$export$c973a4b3cb86a03d), {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarButtonDropdownContainer
    }, props.items.map((item, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $75748bcfd2174a65$export$13ef48a934230896), {
            key: index,
            value: item.value
        }, item.label)))));
};
function $5f22da7309bc91a3$var$isConditionalContentsOption(option) {
    return Object.hasOwn(option, "when");
}
const $5f22da7309bc91a3$export$73704062e2c3c67c = ({ options: options })=>{
    const editorInFocus = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$d7f1aaab3c44fbe7));
    const contents = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>{
        const option = options.find((option2)=>{
            if ($5f22da7309bc91a3$var$isConditionalContentsOption(option2)) {
                if (option2.when(editorInFocus)) return true;
            } else return true;
        });
        return option ? $5f22da7309bc91a3$var$isConditionalContentsOption(option) ? option.contents() : option.fallback() : null;
    }, [
        options,
        editorInFocus
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            display: "flex"
        }
    }, contents);
};
const $5f22da7309bc91a3$export$1ff3c3f08ae963c0 = $3addc25501ee06b8$export$1ff3c3f08ae963c0;



const $d99c558b0fe2051a$var$FormatButton = ({ format: format, addTitle: addTitle, removeTitle: removeTitle, icon: icon, formatName: formatName })=>{
    const [currentFormat, iconComponentFor] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $5a7e051e41645429$export$f2a971b630263584), (0, $5a7e051e41645429$export$4fd464b2b09e1c4d));
    const applyFormat = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $5a7e051e41645429$export$d5cd67a91c3cfefd));
    const active = (currentFormat & format) !== 0;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5f22da7309bc91a3$export$b5f40907b46fefc4), {
        title: active ? removeTitle : addTitle,
        on: active,
        onValueChange: ()=>{
            applyFormat(formatName);
        }
    }, iconComponentFor(icon));
};
const $d99c558b0fe2051a$export$51afbab189e0e951 = ({ options: options })=>{
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    const showAllButtons = typeof options === "undefined";
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarGroupOfGroups
    }, showAllButtons || options.includes("Bold") ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d99c558b0fe2051a$var$FormatButton, {
        format: (0, $0b9b8702aaeac864$export$d401051135d8c941),
        addTitle: t("toolbar.bold", "Bold"),
        removeTitle: t("toolbar.removeBold", "Remove bold"),
        icon: "format_bold",
        formatName: "bold"
    }) : null, showAllButtons || options.includes("Italic") ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d99c558b0fe2051a$var$FormatButton, {
        format: (0, $0b9b8702aaeac864$export$6f537bdfcfab164),
        addTitle: t("toolbar.italic", "Italic"),
        removeTitle: t("toolbar.removeItalic", "Remove italic"),
        icon: "format_italic",
        formatName: "italic"
    }) : null, showAllButtons || options.includes("Underline") ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d99c558b0fe2051a$var$FormatButton, {
        format: (0, $0b9b8702aaeac864$export$4fefe1576f07e925),
        addTitle: t("toolbar.underline", "Underline"),
        removeTitle: t("toolbar.removeUnderline", "Remove underline"),
        icon: "format_underlined",
        formatName: "underline"
    }) : null);
};
const $d99c558b0fe2051a$export$6d69c489768f2548 = ({ options: options })=>{
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    const showAllButtons = typeof options === "undefined";
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolbarGroupOfGroups
    }, showAllButtons || options.includes("Strikethrough") ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d99c558b0fe2051a$var$FormatButton, {
        format: (0, $0b9b8702aaeac864$export$27809404dee18444),
        addTitle: t("toolbar.strikethrough", "Strikethrough"),
        removeTitle: t("toolbar.removeStrikethrough", "Remove strikethrough"),
        icon: "strikeThrough",
        formatName: "strikethrough"
    }) : null, showAllButtons || options.includes("Sup") ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d99c558b0fe2051a$var$FormatButton, {
        format: (0, $0b9b8702aaeac864$export$703b9afdf8723203),
        addTitle: t("toolbar.superscript", "Superscript"),
        removeTitle: t("toolbar.removeSuperscript", "Remove superscript"),
        icon: "superscript",
        formatName: "superscript"
    }) : null, showAllButtons || options.includes("Sub") ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($d99c558b0fe2051a$var$FormatButton, {
        format: (0, $0b9b8702aaeac864$export$22c32c29c50da53a),
        addTitle: t("toolbar.subscript", "Subscript"),
        removeTitle: t("toolbar.removeSubscript", "Remove subscript"),
        icon: "subscript",
        formatName: "subscript"
    }) : null);
};


var $7fPBF = parcelRequire("7fPBF");



/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 







const $1ad5ac6f16b99f6f$var$j = new Set([
    "http:",
    "https:",
    "mailto:",
    "sms:",
    "tel:"
]);
class $1ad5ac6f16b99f6f$export$4341066b87270133 extends (0, $3e88191b87395c2e$export$dc064fe9e59310fd) {
    static getType() {
        return "link";
    }
    static clone(t) {
        return new $1ad5ac6f16b99f6f$export$4341066b87270133(t.__url, {
            rel: t.__rel,
            target: t.__target,
            title: t.__title
        }, t.__key);
    }
    afterCloneFrom(t) {
        super.afterCloneFrom(t), this.__url = t.__url, this.__rel = t.__rel, this.__target = t.__target, this.__title = t.__title;
    }
    createDOM(t) {
        const e = (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("a");
        return this.updateLinkDOM(null, e, t), (0, $3e88191b87395c2e$export$71781797876b07d6)(e, t.theme.link), e;
    }
    updateLinkDOM(t, e, n) {
        if ((0, $3e88191b87395c2e$export$f5326d78d8d21e1f)(e)) {
            t && t.__url === this.__url || (e.href = this.sanitizeUrl(this.__url));
            for (const n of [
                "target",
                "rel",
                "title"
            ]){
                const r = `__${n}`, i = this[r];
                t && t[r] === i || (i ? e[n] = i : e.removeAttribute(n));
            }
        }
    }
    updateDOM(t, e, n) {
        return this.updateLinkDOM(t, e, n), !1;
    }
    static importDOM() {
        return {
            a: (t)=>({
                    conversion: $1ad5ac6f16b99f6f$var$Q,
                    priority: 1
                })
        };
    }
    static importJSON(t) {
        return $1ad5ac6f16b99f6f$export$5ec42376570ce194().updateFromJSON(t);
    }
    updateFromJSON(t) {
        return super.updateFromJSON(t).setURL(t.url).setRel(t.rel || null).setTarget(t.target || null).setTitle(t.title || null);
    }
    sanitizeUrl(t) {
        const e = t;
        t = $1ad5ac6f16b99f6f$export$75025487296cba38(t);
        try {
            const e = new URL($1ad5ac6f16b99f6f$export$75025487296cba38(t));
            if (!$1ad5ac6f16b99f6f$var$j.has(e.protocol)) return "about:blank";
        } catch (t) {
            const n = e.replace(/[\u0000-\u001F\u007F\s]/g, "").match(/^([a-z][a-z0-9+.-]*):/i);
            if (null != n && !$1ad5ac6f16b99f6f$var$j.has(`${n[1].toLowerCase()}:`)) return "about:blank";
        }
        return t;
    }
    exportJSON() {
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, super.exportJSON()), {
            rel: this.getRel(),
            target: this.getTarget(),
            title: this.getTitle(),
            url: this.getURL()
        });
    }
    getURL() {
        return this.getLatest().__url;
    }
    setURL(t) {
        const e = this.getWritable();
        return e.__url = t, e;
    }
    getTarget() {
        return this.getLatest().__target;
    }
    setTarget(t) {
        const e = this.getWritable();
        return e.__target = t, e;
    }
    getRel() {
        return this.getLatest().__rel;
    }
    setRel(t) {
        const e = this.getWritable();
        return e.__rel = t, e;
    }
    getTitle() {
        return this.getLatest().__title;
    }
    setTitle(t) {
        const e = this.getWritable();
        return e.__title = t, e;
    }
    insertNewAfter(t, e = !0) {
        const n = (0, $3e88191b87395c2e$export$def73b17b22438e7)(this);
        return this.insertAfter(n, e), n;
    }
    canInsertTextBefore() {
        return !1;
    }
    canInsertTextAfter() {
        return !1;
    }
    canBeEmpty() {
        return !1;
    }
    isInline() {
        return !0;
    }
    extractWithChild(t, e, n) {
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) return !1;
        const r = e.anchor.getNode(), i = e.focus.getNode();
        return (this.is(r) || this.isParentOf(r)) && (this.is(i) || this.isParentOf(i)) && e.getTextContent().length > 0;
    }
    isEmailURI() {
        return this.__url.startsWith("mailto:");
    }
    isWebSiteURI() {
        return this.__url.startsWith("https://") || this.__url.startsWith("http://");
    }
    shouldMergeAdjacentLink(t) {
        return this.getType() === t.getType() && this.__url === t.__url && this.__target === t.__target && this.__rel === t.__rel && this.__title === t.__title;
    }
    constructor(t = "", e = {}, n){
        super(n), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__url", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__target", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__rel", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__title", void 0);
        const { target: r = null, rel: i = null, title: l = null } = e;
        this.__url = t, this.__target = r, this.__rel = i, this.__title = l;
    }
}
function $1ad5ac6f16b99f6f$var$H(t) {
    const e = (0, $3e88191b87395c2e$export$e435a0def9eb2000)(t, "next");
    return [
        e,
        e.getFlipped()
    ];
}
function $1ad5ac6f16b99f6f$var$G(t, e) {
    for (const n of e)if (n.origin.isAttached()) {
        const e = (0, $3e88191b87395c2e$export$33e015e8f2ff8536)(n);
        return void (0, $3e88191b87395c2e$export$dd601b22fa430ce6)(t, e);
    }
}
function $1ad5ac6f16b99f6f$var$q(t) {
    const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    let n = null, r = null;
    function i() {
        (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && ($1ad5ac6f16b99f6f$var$G(e.anchor, n), $1ad5ac6f16b99f6f$var$G(e.focus, r), (0, $3e88191b87395c2e$export$db10bc6ba67ffcb5)(e));
    }
    (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && (n = $1ad5ac6f16b99f6f$var$H(e.anchor), r = $1ad5ac6f16b99f6f$var$H(e.focus));
    let l = !1;
    for (const e of (0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(t, "next")){
        const n = e.origin;
        if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(n) && !n.isInline()) {
            const r = n.getChildren();
            if (r.length > 0) {
                const e = (0, $3e88191b87395c2e$export$def73b17b22438e7)(t);
                e.append(...r), n.append(e), l = !0;
            }
            (0, $3e88191b87395c2e$export$8074a5062ab072d1)(n, (0, $3e88191b87395c2e$export$3d19514618fb28f3)(e), {
                $shouldSplit: ()=>!1
            });
        }
    }
    function u(t, e, n) {
        const [r, i] = t, l = (t)=>(0, $3e88191b87395c2e$export$3bcd9a2637e8506e)(t) && t.origin.is(e);
        if (!l(r) && !l(i)) return t;
        const s = (0, $3e88191b87395c2e$export$33e015e8f2ff8536)((0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(n, "next"));
        return [
            s,
            s.getFlipped()
        ];
    }
    if (t.isAttached()) {
        const e = t.getPreviousSibling();
        if ($1ad5ac6f16b99f6f$export$b46127abfd772033(e) && e.shouldMergeAdjacentLink(t)) return n && (n = u(n, e, t)), r && (r = u(r, e, t)), e.append(...t.getChildren()), t.remove(), void i();
        const s = t.getNextSibling();
        $1ad5ac6f16b99f6f$export$b46127abfd772033(s) && t.shouldMergeAdjacentLink(s) && (n && (n = u(n, t, s)), r && (r = u(r, t, s)), t.append(...s.getChildren()), s.remove(), l = !0);
    }
    if (l) {
        if (!t.canBeEmpty() && t.isEmpty()) {
            const e = t.getParent();
            t.remove(), e && e.isEmpty() && e.remove();
        }
        i();
    }
}
function $1ad5ac6f16b99f6f$var$Q(t) {
    let e = null;
    if ((0, $3e88191b87395c2e$export$f5326d78d8d21e1f)(t)) {
        const n = t.textContent;
        (null !== n && "" !== n || t.children.length > 0) && (e = $1ad5ac6f16b99f6f$export$5ec42376570ce194(t.getAttribute("href") || "", {
            rel: t.getAttribute("rel"),
            target: t.getAttribute("target"),
            title: t.getAttribute("title")
        }));
    }
    return {
        node: e
    };
}
function $1ad5ac6f16b99f6f$export$5ec42376570ce194(t = "", e) {
    return (0, $3e88191b87395c2e$export$2f5beb31df92ea57)(new $1ad5ac6f16b99f6f$export$4341066b87270133(t, e));
}
function $1ad5ac6f16b99f6f$export$b46127abfd772033(t) {
    return t instanceof $1ad5ac6f16b99f6f$export$4341066b87270133;
}
class $1ad5ac6f16b99f6f$export$1f3c6513e80fcb51 extends $1ad5ac6f16b99f6f$export$4341066b87270133 {
    afterCloneFrom(t) {
        super.afterCloneFrom(t), this.__isUnlinked = t.__isUnlinked;
    }
    static getType() {
        return "autolink";
    }
    static clone(t) {
        return new $1ad5ac6f16b99f6f$export$1f3c6513e80fcb51(t.__url, {
            isUnlinked: t.__isUnlinked,
            rel: t.__rel,
            target: t.__target,
            title: t.__title
        }, t.__key);
    }
    shouldMergeAdjacentLink(t) {
        return !1;
    }
    getIsUnlinked() {
        return this.__isUnlinked;
    }
    setIsUnlinked(t) {
        const e = this.getWritable();
        return e.__isUnlinked = t, e;
    }
    createDOM(t) {
        return this.__isUnlinked ? (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("span") : super.createDOM(t);
    }
    updateDOM(t, e, n) {
        return super.updateDOM(t, e, n) || t.__isUnlinked !== this.__isUnlinked;
    }
    static importJSON(t) {
        return $1ad5ac6f16b99f6f$export$22b33a6815c95543().updateFromJSON(t);
    }
    updateFromJSON(t) {
        return super.updateFromJSON(t).setIsUnlinked(t.isUnlinked || !1);
    }
    static importDOM() {
        return null;
    }
    exportJSON() {
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, super.exportJSON()), {
            isUnlinked: this.__isUnlinked
        });
    }
    insertNewAfter(t, e = !0) {
        const n = $1ad5ac6f16b99f6f$export$22b33a6815c95543(this.__url, {
            isUnlinked: this.__isUnlinked,
            rel: this.__rel,
            target: this.__target,
            title: this.__title
        });
        return this.insertAfter(n, e), n;
    }
    constructor(t = "", e = {}, n){
        super(t, e, n), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__isUnlinked", void 0), this.__isUnlinked = void 0 !== e.isUnlinked && null !== e.isUnlinked && e.isUnlinked;
    }
}
function $1ad5ac6f16b99f6f$export$22b33a6815c95543(t = "", e) {
    return (0, $3e88191b87395c2e$export$2f5beb31df92ea57)(new $1ad5ac6f16b99f6f$export$1f3c6513e80fcb51(t, e));
}
function $1ad5ac6f16b99f6f$export$7fd828bfe44c7434(t) {
    return t instanceof $1ad5ac6f16b99f6f$export$1f3c6513e80fcb51;
}
const $1ad5ac6f16b99f6f$export$42da573aae2f70a = /* @__PURE__ */ (0, $3e88191b87395c2e$export$8d4021544bdece00)("TOGGLE_LINK_COMMAND");
function $1ad5ac6f16b99f6f$var$rt(t, e) {
    if ("element" === t.type) {
        const n = t.getNode();
        (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) || function(t, ...e) {
            const n = new URL("https://lexical.dev/docs/error"), r = new URLSearchParams;
            r.append("code", t);
            for (const t of e)r.append("v", t);
            throw n.search = r.toString(), Error(`Minified Lexical error #${t}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
        }(252);
        return n.getChildren()[t.offset + e] || null;
    }
    return null;
}
function $1ad5ac6f16b99f6f$export$a051ad64de8be534(t, e = {}) {
    let n;
    if (t && "object" == typeof t) {
        const { url: r } = t, i = (0, $8901fc92b5563702$export$71511d61b312f219)(t, [
            "url"
        ]);
        n = r, e = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, i, e);
    } else n = t;
    const { target: r, title: i } = e, l = void 0 === e.rel ? "noreferrer" : e.rel, u = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (null === u || !(0, $3e88191b87395c2e$export$181b63acea8a0224)(u) && !(0, $3e88191b87395c2e$export$7257e4181651a7c3)(u)) return;
    if ((0, $3e88191b87395c2e$export$7257e4181651a7c3)(u)) {
        const t = u.getNodes();
        if (0 === t.length) return;
        return void t.forEach((t)=>{
            if (null === n) {
                const e = (0, $3e88191b87395c2e$export$57101724ca611500)(t, (t)=>!$1ad5ac6f16b99f6f$export$7fd828bfe44c7434(t) && $1ad5ac6f16b99f6f$export$b46127abfd772033(t));
                e && (e.insertBefore(t), 0 === e.getChildren().length && e.remove());
            } else {
                const e = (0, $3e88191b87395c2e$export$57101724ca611500)(t, (t)=>!$1ad5ac6f16b99f6f$export$7fd828bfe44c7434(t) && $1ad5ac6f16b99f6f$export$b46127abfd772033(t));
                if (e) e.setURL(n), void 0 !== r && e.setTarget(r), void 0 !== l && e.setRel(l);
                else {
                    const e = $1ad5ac6f16b99f6f$export$5ec42376570ce194(n, {
                        rel: l,
                        target: r
                    });
                    t.insertBefore(e), e.append(t);
                }
            }
        });
    }
    if (u.isCollapsed() && null === n) for (const t of u.getNodes()){
        const e = (0, $3e88191b87395c2e$export$57101724ca611500)(t, (t)=>!$1ad5ac6f16b99f6f$export$7fd828bfe44c7434(t) && $1ad5ac6f16b99f6f$export$b46127abfd772033(t));
        return void (null !== e && (e.getParentOrThrow().splice(e.getIndexWithinParent(), 0, e.getChildren()), e.remove()));
    }
    const a = u.extract();
    if (null === n) {
        const t = new Set;
        return void a.forEach((e)=>{
            const n = (0, $3e88191b87395c2e$export$57101724ca611500)(e, (t)=>!$1ad5ac6f16b99f6f$export$7fd828bfe44c7434(t) && $1ad5ac6f16b99f6f$export$b46127abfd772033(t));
            if (null !== n) {
                const e = n.getKey();
                if (t.has(e)) return;
                !function(t, e) {
                    const n = new Set(e.filter((e)=>t.isParentOf(e)).map((t)=>t.getKey())), r = t.getChildren(), i = (r)=>n.has(r.getKey()) || (0, $3e88191b87395c2e$export$923a058ef54437a4)(r) && e.some((e)=>t.isParentOf(e) && r.isParentOf(e)), l = r.filter(i);
                    if (l.length === r.length) return r.forEach((e)=>t.insertBefore(e)), void t.remove();
                    const o = r.findIndex(i), u = r.findLastIndex(i), a = 0 === o, c = u === r.length - 1;
                    if (a) l.forEach((e)=>t.insertBefore(e));
                    else if (c) for(let e = l.length - 1; e >= 0; e--)t.insertAfter(l[e]);
                    else {
                        for(let e = l.length - 1; e >= 0; e--)t.insertAfter(l[e]);
                        const e = r.slice(u + 1);
                        if (e.length > 0) {
                            const n = (0, $3e88191b87395c2e$export$def73b17b22438e7)(t);
                            l[l.length - 1].insertAfter(n), e.forEach((t)=>n.append(t));
                        }
                    }
                }(n, a), t.add(e);
            }
        });
    }
    const p = new Set, m = (t)=>{
        p.has(t.getKey()) || (p.add(t.getKey()), t.setURL(n), void 0 !== r && t.setTarget(r), void 0 !== l && t.setRel(l), void 0 !== i && t.setTitle(i));
    };
    if (1 === a.length) {
        const t = a[0], e = (0, $3e88191b87395c2e$export$57101724ca611500)(t, $1ad5ac6f16b99f6f$export$b46127abfd772033);
        if (null !== e) return m(e);
    }
    !function(t) {
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) return t();
        const n = (0, $3e88191b87395c2e$export$db10bc6ba67ffcb5)(e), r = n.isBackward(), i = $1ad5ac6f16b99f6f$var$rt(n.anchor, r ? -1 : 0), l = $1ad5ac6f16b99f6f$var$rt(n.focus, r ? 0 : -1), s = t();
        if (i || l) {
            const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) {
                const e = t.clone();
                if (i) {
                    const t = i.getParent();
                    t && e.anchor.set(t.getKey(), i.getIndexWithinParent() + (r ? 1 : 0), "element");
                }
                if (l) {
                    const t = l.getParent();
                    t && e.focus.set(t.getKey(), l.getIndexWithinParent() + (r ? 0 : 1), "element");
                }
                (0, $3e88191b87395c2e$export$2aad78c37810bca9)((0, $3e88191b87395c2e$export$db10bc6ba67ffcb5)(e));
            }
        }
    }(()=>{
        let t = null;
        for (const e of a){
            if (!e.isAttached()) continue;
            const s = (0, $3e88191b87395c2e$export$57101724ca611500)(e, $1ad5ac6f16b99f6f$export$b46127abfd772033);
            if (s) {
                m(s);
                continue;
            }
            if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(e)) {
                if (!e.isInline()) continue;
                if ($1ad5ac6f16b99f6f$export$b46127abfd772033(e)) {
                    if (!($1ad5ac6f16b99f6f$export$7fd828bfe44c7434(e) || null !== t && t.getParentOrThrow().isParentOf(e))) {
                        m(e), t = e;
                        continue;
                    }
                    for (const t of e.getChildren())e.insertBefore(t);
                    e.remove();
                    continue;
                }
            }
            const o = e.getPreviousSibling();
            $1ad5ac6f16b99f6f$export$b46127abfd772033(o) && o.is(t) ? o.append(e) : (t = $1ad5ac6f16b99f6f$export$5ec42376570ce194(n, {
                rel: l,
                target: r,
                title: i
            }), e.insertAfter(t), t.append(e));
        }
    });
}
const $1ad5ac6f16b99f6f$var$lt = /^\+?[0-9\s()-]{5,}$/;
function $1ad5ac6f16b99f6f$export$75025487296cba38(t) {
    return t.match(/^[a-z][a-z0-9+.-]*:/i) || t.match(/^[/#.]/) ? t : t.includes("@") ? `mailto:${t}` : $1ad5ac6f16b99f6f$var$lt.test(t) ? `tel:${t}` : `https://${t}`;
}
const $1ad5ac6f16b99f6f$export$983419eaf42f7946 = [
    /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
        $import: (t, e)=>{
            if (!e.textContent && 0 === e.children.length) return [];
            const n = e.getAttribute("href") || "", r = {
                rel: e.getAttribute("rel"),
                target: e.getAttribute("target"),
                title: e.getAttribute("title")
            };
            return (0, $9429c8604db0efde$export$bf3be9b07cad8971)(t.$importChildren(e), ()=>$1ad5ac6f16b99f6f$export$5ec42376570ce194(n, r));
        },
        match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("a"),
        name: "@lexical/link/a"
    })
];
function $1ad5ac6f16b99f6f$export$6c7e75a5399f8f91(t, n) {
    return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(t.registerNodeTransform($1ad5ac6f16b99f6f$export$4341066b87270133, $1ad5ac6f16b99f6f$var$q), t.registerCommand($1ad5ac6f16b99f6f$export$42da573aae2f70a, (t)=>{
        const e = n.validateUrl.peek(), r = n.attributes.peek();
        if (null === t) return $1ad5ac6f16b99f6f$export$a051ad64de8be534(null), !0;
        if ("string" == typeof t) return !(void 0 !== e && !e(t)) && ($1ad5ac6f16b99f6f$export$a051ad64de8be534(t, r), !0);
        {
            const { url: e, target: n, rel: i, title: l } = t;
            return $1ad5ac6f16b99f6f$export$a051ad64de8be534(e, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, r), {
                rel: i,
                target: n,
                title: l
            })), !0;
        }
    }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), (0, $8ebc39becbfbdd8f$export$dc573d8a6576cdb3)(()=>{
        const e = n.validateUrl.value;
        if (!e) return;
        const r = n.attributes.value;
        return t.registerCommand((0, $3e88191b87395c2e$export$7fb70c61b3bcc883), (n)=>{
            const i = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(i) || i.isCollapsed() || !(0, $74849711df60ce24$export$266ae88fb619dc2e)(n, ClipboardEvent)) return !1;
            if (null === n.clipboardData) return !1;
            const l = n.clipboardData.getData("text");
            if (!e(l)) return !1;
            return !i.getNodes().some((t)=>(0, $3e88191b87395c2e$export$923a058ef54437a4)(t) || (0, $3e88191b87395c2e$export$471953706258be2b)(t) && !t.isSimpleText()) && (t.dispatchCommand($1ad5ac6f16b99f6f$export$42da573aae2f70a, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, r), {
                url: l
            })), n.preventDefault(), !0);
        }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4));
    }));
}
const $1ad5ac6f16b99f6f$export$6cea0bdce3195ac1 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (e, n, r)=>(0, $8ebc39becbfbdd8f$export$b351c03363e45c4f)(n),
    config: {
        attributes: void 0,
        validateUrl: void 0
    },
    dependencies: [
        (0, $9429c8604db0efde$export$96cd3b4e2d764c8e),
        /* @__PURE__ */ (0, $3e88191b87395c2e$export$7c74af9ea11c2716)((0, $9429c8604db0efde$export$a1ca1fda83454df7), {
            rules: $1ad5ac6f16b99f6f$export$983419eaf42f7946
        })
    ],
    mergeConfig (t, e) {
        const n = (0, $3e88191b87395c2e$export$89e5ee996f4118)(t, e);
        return t.attributes && (n.attributes = (0, $3e88191b87395c2e$export$89e5ee996f4118)(t.attributes, n.attributes)), n;
    },
    name: "@lexical/link/Link",
    nodes: ()=>[
            $1ad5ac6f16b99f6f$export$4341066b87270133
        ],
    register: (t, e, n)=>$1ad5ac6f16b99f6f$export$6c7e75a5399f8f91(t, n.getOutput())
}), $1ad5ac6f16b99f6f$export$9ce1aa19e9f91c1e = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    dependencies: [
        $1ad5ac6f16b99f6f$export$6cea0bdce3195ac1
    ],
    name: "@lexical/link/Import"
});
function $1ad5ac6f16b99f6f$export$df65a1f787ec2295(t, e, n = {}) {
    const r = (n)=>{
        const r = n.target;
        if (!(0, $3e88191b87395c2e$export$b8eb4d3b76e486c2)(r)) return;
        const i = (0, $3e88191b87395c2e$export$30c13854ab4c9903)(r);
        if (null === i) return;
        let s = null, u = null, a = !1;
        if (i.update(()=>{
            const t = (0, $3e88191b87395c2e$export$fef265f0d2fcffdd)(r);
            if (null !== t) {
                const n = (0, $3e88191b87395c2e$export$57101724ca611500)(t, (0, $3e88191b87395c2e$export$923a058ef54437a4));
                if (!e.disabled.peek()) {
                    if ($1ad5ac6f16b99f6f$export$b46127abfd772033(n)) a = $1ad5ac6f16b99f6f$export$7fd828bfe44c7434(n) && n.getIsUnlinked(), s = n.sanitizeUrl(n.getURL()), u = n.getTarget();
                    else {
                        const t = function(t, e) {
                            let n = t;
                            for(; null != n;){
                                if (e(n)) return n;
                                n = n.parentNode;
                            }
                            return null;
                        }(r, (0, $3e88191b87395c2e$export$f5326d78d8d21e1f));
                        null !== t && (s = t.href, u = t.target);
                    }
                }
            }
        }), null === s || "" === s || a) return;
        const g = t.read("latest", (0, $3e88191b87395c2e$export$63a3201b3a5c7d90));
        if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(g) && !g.isCollapsed()) return void n.preventDefault();
        const d = "auxclick" === n.type && 1 === n.button;
        window.open(s, e.newTab.peek() || d || n.metaKey || n.ctrlKey || "_blank" === u ? "_blank" : "_self"), n.preventDefault();
    }, i = (t)=>{
        1 === t.button && r(t);
    };
    return t.registerRootListener((t)=>{
        if (t) return (0, $3e88191b87395c2e$export$4256f76d7567e2ca)(t, {
            click: r,
            mouseup: i
        }, n);
    });
}
const $1ad5ac6f16b99f6f$export$3d5632a10a3c4636 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (e, n, r)=>(0, $8ebc39becbfbdd8f$export$b351c03363e45c4f)(n),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        disabled: !1,
        newTab: !1
    }),
    dependencies: [
        $1ad5ac6f16b99f6f$export$6cea0bdce3195ac1
    ],
    name: "@lexical/link/ClickableLink",
    register: (t, e, n)=>$1ad5ac6f16b99f6f$export$df65a1f787ec2295(t, n.getOutput())
});
function $1ad5ac6f16b99f6f$export$3583a6cf3361e750(t, e = (t)=>t) {
    return (n)=>{
        const r = t.exec(n);
        return null === r ? null : {
            index: r.index,
            length: r[0].length,
            text: r[0],
            url: e(r[0])
        };
    };
}
const $1ad5ac6f16b99f6f$var$ht = RegExp("((https?:\\/\\/(www\\.)?)|(www\\.))[-\\p{L}\\p{N}@:%._+~#=]{1,256}\\.[\\p{L}\\p{N}]{1,6}(?:[-\\p{L}\\p{N}()@:%_+.~#?&//=]*[\\p{L}\\p{N}()@_~#?&//=])?", "u"), $1ad5ac6f16b99f6f$export$bd95be0b7e3e8952 = (t)=>{
    const e = $1ad5ac6f16b99f6f$var$ht.exec(t);
    if (null === e) return null;
    let n = e[0], r = 0;
    for (const t of n)"(" === t ? r++ : ")" === t && r--;
    for(; r < 0 && n.endsWith(")");)n = n.slice(0, -1), r++;
    return {
        index: e.index,
        length: n.length,
        text: n,
        url: n.startsWith("http") ? n : `https://${n}`
    };
}, $1ad5ac6f16b99f6f$export$7a5a4e9d341177fe = $1ad5ac6f16b99f6f$export$3583a6cf3361e750(/(([^<>()[\]\\.,;:\s@"]{1,64}(\.[^<>()[\]\\.,;:\s@"]{1,64}){0,63})|(".{1,255}"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]{1,63}\.){1,127}[a-zA-Z]{2,63}))/, (t)=>`mailto:${t}`);
function $1ad5ac6f16b99f6f$var$mt(t, e) {
    for(let n = 0; n < e.length; n++){
        const r = e[n](t);
        if (r) return r;
    }
    return null;
}
const $1ad5ac6f16b99f6f$var$xt = /[.,;\s]/;
function $1ad5ac6f16b99f6f$var$bt(t, e) {
    return e.test(t);
}
function $1ad5ac6f16b99f6f$var$kt(t, e) {
    return $1ad5ac6f16b99f6f$var$bt(t[t.length - 1], e);
}
function $1ad5ac6f16b99f6f$var$Ut(t, e) {
    return $1ad5ac6f16b99f6f$var$bt(t[0], e);
}
function $1ad5ac6f16b99f6f$var$vt(t, e) {
    let n = t.getPreviousSibling();
    return (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) && (n = n.getLastDescendant()), null === n || (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(n) || (0, $3e88191b87395c2e$export$471953706258be2b)(n) && $1ad5ac6f16b99f6f$var$kt(n.getTextContent(), e);
}
function $1ad5ac6f16b99f6f$var$Tt(t, e) {
    let n = t.getNextSibling();
    return (0, $3e88191b87395c2e$export$923a058ef54437a4)(n) && (n = n.getFirstDescendant()), null === n || (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(n) || (0, $3e88191b87395c2e$export$471953706258be2b)(n) && $1ad5ac6f16b99f6f$var$Ut(n.getTextContent(), e);
}
function $1ad5ac6f16b99f6f$var$Ct(t, e, n, r, i) {
    if (!(t > 0 ? $1ad5ac6f16b99f6f$var$bt(r[t - 1], n) : $1ad5ac6f16b99f6f$var$vt(i[0], n))) return !1;
    return e < r.length ? $1ad5ac6f16b99f6f$var$bt(r[e], n) : $1ad5ac6f16b99f6f$var$Tt(i[i.length - 1], n);
}
function $1ad5ac6f16b99f6f$var$Lt(t, e, n) {
    const r = [], i = [], l = [];
    let s = 0, o = 0;
    const u = [
        ...t
    ];
    for(; u.length > 0;){
        const t = u[0], a = t.getTextContent().length, c = o;
        o + a <= e ? (r.push(t), s += a) : c >= n ? l.push(t) : i.push(t), o += a, u.shift();
    }
    return [
        s,
        r,
        i,
        l
    ];
}
function $1ad5ac6f16b99f6f$var$St(t, e, n, r) {
    const i = $1ad5ac6f16b99f6f$export$22b33a6815c95543(r.url, r.attributes);
    if (1 === t.length) {
        let l, s = t[0];
        0 === e ? [l, s] = s.splitText(n) : [, l, s] = s.splitText(e, n);
        const o = (0, $3e88191b87395c2e$export$2785f39dcdec0078)(r.text);
        return o.setFormat(l.getFormat()), o.setDetail(l.getDetail()), o.setStyle(l.getStyle()), i.append(o), l.replace(i), s;
    }
    if (t.length > 1) {
        const r = t[0];
        let l, s = r.getTextContent().length;
        0 === e ? l = r : [, l] = r.splitText(e);
        const u = [];
        let a;
        for(let e = 1; e < t.length; e++){
            const r = t[e], i = r.getTextContent().length, l = s;
            if (l < n) {
                if (s + i <= n) u.push(r);
                else {
                    const [t, e] = r.splitText(n - l);
                    u.push(t), a = e;
                }
            }
            s += i;
        }
        const f = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)(), d = f ? f.getNodes().find((0, $3e88191b87395c2e$export$471953706258be2b)) : void 0, h = (0, $3e88191b87395c2e$export$2785f39dcdec0078)(l.getTextContent());
        return h.setFormat(l.getFormat()), h.setDetail(l.getDetail()), h.setStyle(l.getStyle()), i.append(h, ...u), d && d === l && ((0, $3e88191b87395c2e$export$181b63acea8a0224)(f) ? h.select(f.anchor.offset, f.focus.offset) : (0, $3e88191b87395c2e$export$7257e4181651a7c3)(f) && h.select(0, h.getTextContent().length)), l.replace(i), a;
    }
}
function $1ad5ac6f16b99f6f$var$Nt(t, e, n, r) {
    const i = t.getChildren(), l = i.length;
    for(let e = 0; e < l; e++){
        const r = i[e];
        if (!(0, $3e88191b87395c2e$export$471953706258be2b)(r) || !r.isSimpleText()) return $1ad5ac6f16b99f6f$var$Ot(t), void n(null, t.getURL());
    }
    const s = t.getTextContent(), o = $1ad5ac6f16b99f6f$var$mt(s, e);
    if (null === o || o.text !== s) return $1ad5ac6f16b99f6f$var$Ot(t), void n(null, t.getURL());
    if (!$1ad5ac6f16b99f6f$var$vt(t, r) || !$1ad5ac6f16b99f6f$var$Tt(t, r)) return $1ad5ac6f16b99f6f$var$Ot(t), void n(null, t.getURL());
    const u = t.getURL();
    if (u !== o.url && (t.setURL(o.url), n(o.url, u)), o.attributes) {
        const e = t.getRel();
        e !== o.attributes.rel && (t.setRel(o.attributes.rel || null), n(o.attributes.rel || null, e));
        const r = t.getTarget();
        r !== o.attributes.target && (t.setTarget(o.attributes.target || null), n(o.attributes.target || null, r));
    }
}
function $1ad5ac6f16b99f6f$var$Ot(t) {
    const e = t.getChildren();
    for(let n = e.length - 1; n >= 0; n--)t.insertAfter(e[n]);
    return t.remove(), e.map((t)=>t.getLatest());
}
const $1ad5ac6f16b99f6f$var$At = {
    changeHandlers: [],
    excludeParents: [],
    matchers: [],
    separatorRegex: $1ad5ac6f16b99f6f$var$xt
};
function $1ad5ac6f16b99f6f$export$882620ee52a742c3(t, e = $1ad5ac6f16b99f6f$var$At) {
    const { matchers: n, changeHandlers: r, excludeParents: i, separatorRegex: l = $1ad5ac6f16b99f6f$var$xt } = e, s = (t, e)=>{
        for (const n of r)n(t, e);
    };
    return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(t.registerNodeTransform((0, $3e88191b87395c2e$export$f0a25ea3087686aa), (t)=>{
        const e = t.getParentOrThrow(), r = t.getPreviousSibling();
        if ($1ad5ac6f16b99f6f$export$7fd828bfe44c7434(e)) $1ad5ac6f16b99f6f$var$Nt(e, n, s, l);
        else if (!$1ad5ac6f16b99f6f$export$b46127abfd772033(e) && !i.some((t)=>t(e))) {
            if (t.isSimpleText() && ($1ad5ac6f16b99f6f$var$Ut(t.getTextContent(), l) || !$1ad5ac6f16b99f6f$export$7fd828bfe44c7434(r))) {
                const e = function(t) {
                    const e = [
                        t
                    ];
                    let n = t.getNextSibling();
                    for(; null !== n && (0, $3e88191b87395c2e$export$471953706258be2b)(n) && n.isSimpleText() && (e.push(n), !/[\s]/.test(n.getTextContent()));)n = n.getNextSibling();
                    return e;
                }(t);
                !function(t, e, n, r) {
                    for (const e of t){
                        const t = e.getParent();
                        if ($1ad5ac6f16b99f6f$export$7fd828bfe44c7434(t) && !t.getIsUnlinked()) return;
                    }
                    let i = [
                        ...t
                    ];
                    const l = i.map((t)=>t.getTextContent()).join("");
                    let s, o = l, u = 0;
                    for(; (s = $1ad5ac6f16b99f6f$var$mt(o, e)) && null !== s;){
                        const t = s.index, e = t + s.length;
                        if ($1ad5ac6f16b99f6f$var$Ct(u + t, u + e, r, l, i)) {
                            const [r, , l, a] = $1ad5ac6f16b99f6f$var$Lt(i, u + t, u + e);
                            let c = !1;
                            for (const t of l){
                                const e = t.getParent();
                                if ($1ad5ac6f16b99f6f$export$7fd828bfe44c7434(e) && !e.getIsUnlinked()) {
                                    c = !0;
                                    break;
                                }
                            }
                            if (c) {
                                u += e, o = o.substring(e);
                                continue;
                            }
                            const g = $1ad5ac6f16b99f6f$var$St(l, u + t - r, u + e - r, s);
                            i = g ? [
                                g,
                                ...a
                            ] : a, n(s.url, null), u = 0;
                        } else u += e;
                        o = o.substring(e);
                    }
                }(e, n, s, l);
            }
            !function(t, e, n, r) {
                const i = t.getParent(), l = t.getPreviousSibling(), s = t.getNextSibling(), o = t.getTextContent();
                if (!$1ad5ac6f16b99f6f$export$7fd828bfe44c7434(i) || i.getIsUnlinked()) {
                    if ($1ad5ac6f16b99f6f$export$7fd828bfe44c7434(l) && !l.getIsUnlinked() && l.is(t.getPreviousSibling()) && t.getParent() === l.getParent()) {
                        if (!$1ad5ac6f16b99f6f$var$Ut(o, r)) return $1ad5ac6f16b99f6f$var$Ot(l), void n(null, l.getURL());
                        if (u = o, l.isEmailURI() ? /^\.[a-zA-Z]{2,}/.test(u) : /^\.[a-zA-Z0-9]{1,}/.test(u)) {
                            const i = l.getTextContent() + o, s = $1ad5ac6f16b99f6f$var$mt(i, e);
                            null !== s && s.text === i && (l.append(t), $1ad5ac6f16b99f6f$var$Nt(l, e, n, r), n(null, l.getURL()));
                        }
                    }
                    var u;
                    !$1ad5ac6f16b99f6f$export$7fd828bfe44c7434(s) || s.getIsUnlinked() || $1ad5ac6f16b99f6f$var$kt(o, r) || s.is(t.getNextSibling()) && t.getParent() === s.getParent() && ($1ad5ac6f16b99f6f$var$Ot(s), n(null, s.getURL()));
                }
            }(t, n, s, l);
        }
    }), t.registerCommand($1ad5ac6f16b99f6f$export$42da573aae2f70a, (t)=>{
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (null !== t || !(0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) return !1;
        return e.extract().forEach((t)=>{
            const e = t.getParent();
            $1ad5ac6f16b99f6f$export$7fd828bfe44c7434(e) && (e.setIsUnlinked(!e.getIsUnlinked()), e.markDirty());
        }), !1;
    }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)));
}
const $1ad5ac6f16b99f6f$export$b0ce3b6b0200d205 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    config: $1ad5ac6f16b99f6f$var$At,
    dependencies: [
        $1ad5ac6f16b99f6f$export$6cea0bdce3195ac1
    ],
    mergeConfig (t, e) {
        const n = (0, $3e88191b87395c2e$export$89e5ee996f4118)(t, e);
        for (const r of [
            "matchers",
            "changeHandlers",
            "excludeParents"
        ]){
            const i = e[r];
            Array.isArray(i) && (n[r] = [
                ...t[r],
                ...i
            ]);
        }
        return n;
    },
    name: "@lexical/link/AutoLink",
    nodes: [
        $1ad5ac6f16b99f6f$export$1f3c6513e80fcb51
    ],
    register: $1ad5ac6f16b99f6f$export$882620ee52a742c3
});












function $4d17661fb36fa8e3$export$904dd34f44eb1c9f(editor, fn) {
    let result = null;
    editor.getEditorState().read(()=>{
        result = fn();
    });
    return result;
}
function $4d17661fb36fa8e3$export$da5a91481a5e4aa3(selection) {
    try {
        const anchor = selection.anchor;
        const focus = selection.focus;
        const anchorNode = selection.anchor.getNode();
        const focusNode = selection.focus.getNode();
        if (anchorNode === focusNode) return anchorNode;
        const isBackward = selection.isBackward();
        if (isBackward) return (0, $016075a3cb2a2f02$export$899bddb8773a1c9e)(focus) ? anchorNode : focusNode;
        else return (0, $016075a3cb2a2f02$export$899bddb8773a1c9e)(anchor) ? anchorNode : focusNode;
    } catch (e) {
        return null;
    }
}
const $4d17661fb36fa8e3$var$WILL_CHANGE_CONTAINING_BLOCK_PROPS = [
    "transform",
    "perspective",
    "filter",
    "backdrop-filter",
    "contain",
    "container-type"
];
const $4d17661fb36fa8e3$var$CONTAIN_VALUES_CREATING_CONTAINING_BLOCK = [
    "layout",
    "paint",
    "strict",
    "content"
];
function $4d17661fb36fa8e3$var$getFixedContainingBlock(element) {
    let current = element == null ? void 0 : element.parentElement;
    while(current){
        const style = window.getComputedStyle(current);
        const willChangeProps = style.willChange.split(",").map((v)=>v.trim());
        const hasRelevantWillChange = willChangeProps.some((prop)=>$4d17661fb36fa8e3$var$WILL_CHANGE_CONTAINING_BLOCK_PROPS.includes(prop));
        const createsContainingBlock = style.transform !== "none" || style.perspective !== "none" || style.filter !== "none" || style.backdropFilter !== "none" || $4d17661fb36fa8e3$var$CONTAIN_VALUES_CREATING_CONTAINING_BLOCK.includes(style.contain) || style.containerType !== "normal" || style.contentVisibility === "auto" || hasRelevantWillChange;
        if (createsContainingBlock) return current;
        current = current.parentElement;
    }
    return null;
}
function $4d17661fb36fa8e3$var$adjustedRectangle(rect, rootElement) {
    const fixedContainer = $4d17661fb36fa8e3$var$getFixedContainingBlock(rootElement);
    if (fixedContainer) {
        const containerRect = fixedContainer.getBoundingClientRect();
        return {
            top: Math.round(rect.top - containerRect.top),
            left: Math.round(rect.left - containerRect.left),
            width: Math.round(rect.width),
            height: Math.round(rect.height)
        };
    }
    return {
        top: Math.round(rect.top),
        left: Math.round(rect.left),
        width: Math.round(rect.width),
        height: Math.round(rect.height)
    };
}
function $4d17661fb36fa8e3$export$29f905b7979c25d2(editor, nodeKey) {
    const rootElement = editor.getRootElement();
    const element = editor.getElementByKey(nodeKey);
    if (rootElement === null || element === null) return null;
    return $4d17661fb36fa8e3$var$adjustedRectangle(element.getBoundingClientRect(), rootElement);
}
function $4d17661fb36fa8e3$export$df352cf6e4f1f4c4(editor) {
    const selection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    const nativeSelection = window.getSelection();
    const activeElement = document.activeElement;
    const rootElement = editor.getRootElement();
    if (selection !== null && nativeSelection !== null && rootElement !== null && rootElement.contains(nativeSelection.anchorNode) && editor.isEditable()) {
        const domRange = nativeSelection.getRangeAt(0);
        let rect;
        if (nativeSelection.isCollapsed) {
            let node = nativeSelection.anchorNode;
            if ((node == null ? void 0 : node.nodeType) == 3) node = node.parentNode;
            rect = node.getBoundingClientRect();
            rect.width = 0;
        } else if (nativeSelection.anchorNode === rootElement) {
            let inner = rootElement;
            while(inner.firstElementChild != null)inner = inner.firstElementChild;
            rect = inner.getBoundingClientRect();
        } else rect = domRange.getBoundingClientRect();
        return $4d17661fb36fa8e3$var$adjustedRectangle(rect, rootElement);
    } else if ((activeElement == null ? void 0 : activeElement.className) !== "link-input") return null;
    return null;
}
function $4d17661fb36fa8e3$export$c69991ce7c300736(editor, exportParams) {
    return (0, $0bde9de2375dfc26$export$3f23594af5f37336)({
        markdown: ""
    }, (result)=>{
        editor.getEditorState().read(()=>{
            result.markdown = (0, $d5a351410f7bf8d8$export$e9f30850a0a93090)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                root: (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)()
            }, exportParams));
        });
    }).markdown;
}
function $4d17661fb36fa8e3$export$8456885e4de2d8bf(editor, exportParams) {
    let temporaryEditor = null;
    let selectedNodes = [];
    let markdown = "";
    editor.getEditorState().read(()=>{
        const selection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!selection || (0, $3e88191b87395c2e$export$181b63acea8a0224)(selection) && selection.isCollapsed() || selection.getNodes().length === 0) return;
        selectedNodes = (0, $ac97767770b90d3c$export$f84df9bec41e6d85)(editor, selection).nodes;
        if (selectedNodes.length > 0) temporaryEditor = (0, $3e88191b87395c2e$export$eb02d1ee0d3cac30)();
    }, {
        editor: editor
    });
    const selectedTreeEditor = temporaryEditor;
    if (!selectedTreeEditor || selectedNodes.length === 0) return "";
    const exportResult = {
        error: void 0,
        failed: false
    };
    selectedTreeEditor.update(()=>{
        try {
            const root = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)();
            const nodes = (0, $ac97767770b90d3c$export$c5c00050c34078e0)(selectedNodes);
            let inlineContainer = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
            const appendInlineContainer = ()=>{
                if (!inlineContainer.isEmpty()) {
                    root.append(inlineContainer);
                    inlineContainer = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
                }
            };
            for (const node of nodes)if (node.isInline()) inlineContainer.append(node);
            else {
                appendInlineContainer();
                root.append(node);
            }
            appendInlineContainer();
            markdown = (0, $d5a351410f7bf8d8$export$e9f30850a0a93090)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                root: root
            }, exportParams));
        } catch (error) {
            exportResult.failed = true;
            exportResult.error = error;
        }
    }, {
        discrete: true,
        skipTransforms: true
    });
    if (exportResult.failed) throw exportResult.error;
    return markdown.replace(RegExp("\\n+$", "u"), "");
}










var $7fPBF = parcelRequire("7fPBF");
















"use client";
var $4fba2669e33915a2$var$__defProp = Object.defineProperty;
var $4fba2669e33915a2$var$__name = (target, value)=>$4fba2669e33915a2$var$__defProp(target, "name", {
        value: value,
        configurable: true
    });
var $4fba2669e33915a2$var$POPOVER_NAME = "Popover";
var [$4fba2669e33915a2$var$createPopoverContext, $4fba2669e33915a2$export$c8393c9e73286932] = (0, $d0e15db24766ddfc$export$50c7b4e9d9f19c1)($4fba2669e33915a2$var$POPOVER_NAME, [
    (0, $7952cd297982b588$export$722aac194ae923)
]);
var $4fba2669e33915a2$var$usePopperScope = (0, $7952cd297982b588$export$722aac194ae923)();
var [$4fba2669e33915a2$var$PopoverProvider, $4fba2669e33915a2$var$usePopoverContext] = $4fba2669e33915a2$var$createPopoverContext($4fba2669e33915a2$var$POPOVER_NAME);
var $4fba2669e33915a2$export$5b6b19405a83ff9d = /* @__PURE__ */ $4fba2669e33915a2$var$__name((props)=>{
    const { __scopePopover: __scopePopover, children: children, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, modal: modal = false } = props;
    const popperScope = $4fba2669e33915a2$var$usePopperScope(__scopePopover);
    const triggerRef = $7fPBF.useRef(null);
    const [hasCustomAnchor, setHasCustomAnchor] = $7fPBF.useState(false);
    const [open, setOpen] = (0, $915387e6ab4d88b1$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : false,
        onChange: onOpenChange,
        caller: $4fba2669e33915a2$var$POPOVER_NAME
    });
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$be92b6f5f03c0fe9, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, popperScope), {
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PopoverProvider, {
            scope: __scopePopover,
            contentId: (0, $8a8e9b94c33ba6d6$export$f680877a34711e37)(),
            triggerRef: triggerRef,
            open: open,
            onOpenChange: setOpen,
            onOpenToggle: $7fPBF.useCallback(()=>setOpen((prevOpen)=>!prevOpen), [
                setOpen
            ]),
            hasCustomAnchor: hasCustomAnchor,
            onCustomAnchorAdd: $7fPBF.useCallback(()=>setHasCustomAnchor(true), []),
            onCustomAnchorRemove: $7fPBF.useCallback(()=>setHasCustomAnchor(false), []),
            modal: modal,
            children: children
        })
    }));
}, "Popover");
var $4fba2669e33915a2$var$ANCHOR_NAME = "PopoverAnchor";
var $4fba2669e33915a2$export$96e5381f42521a79 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $4fba2669e33915a2$var$__name(function PopoverAnchor2(props, forwardedRef) {
    const { __scopePopover: __scopePopover } = props, anchorProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopePopover"
    ]);
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$ANCHOR_NAME, __scopePopover);
    const popperScope = $4fba2669e33915a2$var$usePopperScope(__scopePopover);
    const { onCustomAnchorAdd: onCustomAnchorAdd, onCustomAnchorRemove: onCustomAnchorRemove } = context;
    $7fPBF.useEffect(()=>{
        onCustomAnchorAdd();
        return ()=>onCustomAnchorRemove();
    }, [
        onCustomAnchorAdd,
        onCustomAnchorRemove
    ]);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$b688253958b8dfe7, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, popperScope, anchorProps), {
        ref: forwardedRef
    }));
}, "PopoverAnchor"));
var $4fba2669e33915a2$var$TRIGGER_NAME = "PopoverTrigger";
var $4fba2669e33915a2$export$7dacb05d26466c3 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $4fba2669e33915a2$var$__name(function PopoverTrigger2(props, forwardedRef) {
    const { __scopePopover: __scopePopover } = props, triggerProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopePopover"
    ]);
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$TRIGGER_NAME, __scopePopover);
    const popperScope = $4fba2669e33915a2$var$usePopperScope(__scopePopover);
    const composedTriggerRef = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, context.triggerRef);
    const trigger = /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": context.open,
        "aria-controls": context.open ? context.contentId : void 0,
        "data-state": $4fba2669e33915a2$var$getState(context.open)
    }, triggerProps), {
        ref: composedTriggerRef,
        onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, context.onOpenToggle)
    }));
    return context.hasCustomAnchor ? trigger : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$b688253958b8dfe7, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        asChild: true
    }, popperScope), {
        children: trigger
    }));
}, "PopoverTrigger"));
var $4fba2669e33915a2$var$PORTAL_NAME = "PopoverPortal";
var [$4fba2669e33915a2$var$PortalProvider, $4fba2669e33915a2$var$usePortalContext] = $4fba2669e33915a2$var$createPopoverContext($4fba2669e33915a2$var$PORTAL_NAME, {
    forceMount: void 0
});
var $4fba2669e33915a2$export$dd679ffb4362d2d4 = /* @__PURE__ */ $4fba2669e33915a2$var$__name((props)=>{
    const { __scopePopover: __scopePopover, forceMount: forceMount, children: children, container: container } = props;
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$PORTAL_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PortalProvider, {
        scope: __scopePopover,
        forceMount: forceMount,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
            present: forceMount || context.open,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $57c7abe8fecdeb41$export$602eac185826482c), {
                asChild: true,
                container: container,
                children: children
            })
        })
    });
}, "PopoverPortal");
var $4fba2669e33915a2$var$CONTENT_NAME = "PopoverContent";
var $4fba2669e33915a2$export$d7e1f420b25549ff = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $4fba2669e33915a2$var$__name(function PopoverContent2(props, forwardedRef) {
    const portalContext = $4fba2669e33915a2$var$usePortalContext($4fba2669e33915a2$var$CONTENT_NAME, props.__scopePopover);
    const { forceMount: forceMount = portalContext.forceMount } = props, contentProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "forceMount"
    ]);
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$CONTENT_NAME, props.__scopePopover);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $e9ce08b8e6e14786$export$99c2b779aa4e8b8b), {
        present: forceMount || context.open,
        children: context.modal ? /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PopoverContentModal, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contentProps), {
            ref: forwardedRef
        })) : /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PopoverContentNonModal, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contentProps), {
            ref: forwardedRef
        }))
    });
}, "PopoverContent"));
var $4fba2669e33915a2$var$Slot = (0, $089057084dfb92a4$export$e88b45bda5c13eb9)("PopoverContent.RemoveScroll");
var $4fba2669e33915a2$var$PopoverContentModal = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $4fba2669e33915a2$var$__name(function PopoverContentModal2(props, forwardedRef) {
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$CONTENT_NAME, props.__scopePopover);
    const contentRef = $7fPBF.useRef(null);
    const composedRefs = (0, $2d44b7cb84ff0f1c$export$c7b2cbe3552a0d05)(forwardedRef, contentRef);
    const isRightClickOutsideRef = $7fPBF.useRef(false);
    $7fPBF.useEffect(()=>{
        const content = contentRef.current;
        if (content) return (0, $2950574f4b60c018$export$6e33d16126ed003c)(content);
    }, []);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $ef57a4b421076988$export$2e2bcd8739ae039), {
        as: $4fba2669e33915a2$var$Slot,
        allowPinchZoom: true,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PopoverContentImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
            ref: composedRefs,
            trapFocus: context.open,
            disableOutsidePointerEvents: true,
            onCloseAutoFocus: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onCloseAutoFocus, (event)=>{
                var _context_triggerRef_current;
                event.preventDefault();
                if (!isRightClickOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
            }),
            onPointerDownOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onPointerDownOutside, (event)=>{
                const originalEvent = event.detail.originalEvent;
                const ctrlLeftClick = originalEvent.button === 0 && originalEvent.ctrlKey === true;
                const isRightClick = originalEvent.button === 2 || ctrlLeftClick;
                isRightClickOutsideRef.current = isRightClick;
            }, {
                checkForDefaultPrevented: false
            }),
            onFocusOutside: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onFocusOutside, (event)=>event.preventDefault(), {
                checkForDefaultPrevented: false
            })
        }))
    });
}, "PopoverContentModal"));
var $4fba2669e33915a2$var$PopoverContentNonModal = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $4fba2669e33915a2$var$__name(function PopoverContentNonModal2(props, forwardedRef) {
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$CONTENT_NAME, props.__scopePopover);
    const hasInteractedOutsideRef = $7fPBF.useRef(false);
    const hasPointerDownOutsideRef = $7fPBF.useRef(false);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($4fba2669e33915a2$var$PopoverContentImpl, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        ref: forwardedRef,
        trapFocus: false,
        disableOutsidePointerEvents: false,
        onCloseAutoFocus: (event)=>{
            var _props_onCloseAutoFocus;
            (_props_onCloseAutoFocus = props.onCloseAutoFocus) === null || _props_onCloseAutoFocus === void 0 ? void 0 : _props_onCloseAutoFocus.call(props, event);
            if (!event.defaultPrevented) {
                var _context_triggerRef_current;
                if (!hasInteractedOutsideRef.current) (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.focus();
                event.preventDefault();
            }
            hasInteractedOutsideRef.current = false;
            hasPointerDownOutsideRef.current = false;
        },
        onInteractOutside: (event)=>{
            var _props_onInteractOutside, _context_triggerRef_current;
            (_props_onInteractOutside = props.onInteractOutside) === null || _props_onInteractOutside === void 0 ? void 0 : _props_onInteractOutside.call(props, event);
            if (!event.defaultPrevented) {
                hasInteractedOutsideRef.current = true;
                if (event.detail.originalEvent.type === "pointerdown") hasPointerDownOutsideRef.current = true;
            }
            const target = event.target;
            const targetIsTrigger = (_context_triggerRef_current = context.triggerRef.current) === null || _context_triggerRef_current === void 0 ? void 0 : _context_triggerRef_current.contains(target);
            if (targetIsTrigger) event.preventDefault();
            if (event.detail.originalEvent.type === "focusin" && hasPointerDownOutsideRef.current) event.preventDefault();
        }
    }));
}, "PopoverContentNonModal"));
var $4fba2669e33915a2$var$PopoverContentImpl = /* @__PURE__ */ $7fPBF.forwardRef(// blank line to reduce diff noise
/* @__PURE__ */ $4fba2669e33915a2$var$__name(function PopoverContentImpl2(props, forwardedRef) {
    const { __scopePopover: __scopePopover, trapFocus: trapFocus, onOpenAutoFocus: onOpenAutoFocus, onCloseAutoFocus: onCloseAutoFocus, disableOutsidePointerEvents: disableOutsidePointerEvents, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside } = props, contentProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopePopover",
        "trapFocus",
        "onOpenAutoFocus",
        "onCloseAutoFocus",
        "disableOutsidePointerEvents",
        "onEscapeKeyDown",
        "onPointerDownOutside",
        "onFocusOutside",
        "onInteractOutside"
    ]);
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$CONTENT_NAME, __scopePopover);
    const popperScope = $4fba2669e33915a2$var$usePopperScope(__scopePopover);
    (0, $38bbe2f1de23f200$export$b7ece24a22aeda8c)();
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $0d555b2b0a3ffff1$export$20e40289641fbbb6), {
        asChild: true,
        loop: true,
        trapped: trapFocus,
        onMountAutoFocus: onOpenAutoFocus,
        onUnmountAutoFocus: onCloseAutoFocus,
        children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $251340165f4765e5$export$177fb62ff3ec1f22), {
            asChild: true,
            disableOutsidePointerEvents: disableOutsidePointerEvents,
            onInteractOutside: onInteractOutside,
            onEscapeKeyDown: onEscapeKeyDown,
            onPointerDownOutside: onPointerDownOutside,
            onFocusOutside: onFocusOutside,
            onDismiss: ()=>context.onOpenChange(false),
            deferPointerDownOutside: true,
            children: /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$7c6e2c02157bb7d2, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                "data-state": $4fba2669e33915a2$var$getState(context.open),
                role: "dialog",
                id: context.contentId
            }, popperScope, contentProps), {
                ref: forwardedRef,
                style: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, contentProps.style), {
                    "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                    "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                    "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                    "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                    "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                })
            }))
        })
    });
}, "PopoverContentImpl"));
var $4fba2669e33915a2$var$CLOSE_NAME = "PopoverClose";
var $4fba2669e33915a2$export$d6ac43ebaa40d53e = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $4fba2669e33915a2$var$__name(function PopoverClose2(props, forwardedRef) {
    const { __scopePopover: __scopePopover } = props, closeProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopePopover"
    ]);
    const context = $4fba2669e33915a2$var$usePopoverContext($4fba2669e33915a2$var$CLOSE_NAME, __scopePopover);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)((0, $4b1a25a893812cc7$export$250ffa63cdc0d034).button, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        type: "button"
    }, closeProps), {
        ref: forwardedRef,
        onClick: (0, $b40b207d83279ebf$export$b9ecd428b558ff10)(props.onClick, ()=>context.onOpenChange(false))
    }));
}, "PopoverClose"));
var $4fba2669e33915a2$export$3152841115e061b2 = /* @__PURE__ */ $7fPBF.forwardRef(/* @__PURE__ */ $4fba2669e33915a2$var$__name(function PopoverArrow2(props, forwardedRef) {
    const { __scopePopover: __scopePopover } = props, arrowProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "__scopePopover"
    ]);
    const popperScope = $4fba2669e33915a2$var$usePopperScope(__scopePopover);
    return /* @__PURE__ */ (0, $824c049f32d4395d$exports.jsx)($7952cd297982b588$export$21b07c8f274aebd5, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, popperScope, arrowProps), {
        ref: forwardedRef
    }));
}, "PopoverArrow"));
function $4fba2669e33915a2$var$getState(open) {
    return open ? "open" : "closed";
}
$4fba2669e33915a2$var$__name($4fba2669e33915a2$var$getState, "getState");
var $4fba2669e33915a2$export$be92b6f5f03c0fe9 = $4fba2669e33915a2$export$5b6b19405a83ff9d;
var $4fba2669e33915a2$export$b688253958b8dfe7 = $4fba2669e33915a2$export$96e5381f42521a79;
var $4fba2669e33915a2$export$41fb9f06171c75f4 = $4fba2669e33915a2$export$7dacb05d26466c3;
var $4fba2669e33915a2$export$602eac185826482c = $4fba2669e33915a2$export$dd679ffb4362d2d4;
var $4fba2669e33915a2$export$7c6e2c02157bb7d2 = $4fba2669e33915a2$export$d7e1f420b25549ff;
var $4fba2669e33915a2$export$f39c2d165cd861fe = $4fba2669e33915a2$export$d6ac43ebaa40d53e;
var $4fba2669e33915a2$export$21b07c8f274aebd5 = $4fba2669e33915a2$export$3152841115e061b2;




var $7fPBF = parcelRequire("7fPBF");




function $f43c50d92a19d876$export$2e2bcd8739ae039() {
    return $f43c50d92a19d876$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $f43c50d92a19d876$export$2e2bcd8739ae039.apply(null, arguments);
}



var $3zeAJ = parcelRequire("3zeAJ");

var $iJeDO = parcelRequire("iJeDO");
function $146ee816144a450d$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $iJeDO.default)(t, o);
}



var $2oXYc = parcelRequire("2oXYc");

var $7fPBF = parcelRequire("7fPBF");
var $dddaf6f84c717660$exports = {};
'use strict';

$dddaf6f84c717660$exports = (parcelRequire("45MkT"));


let $43fe3e1a57de4973$var$e = (e)=>"object" == typeof e && null != e && 1 === e.nodeType, $43fe3e1a57de4973$var$t = (e, t)=>(!t || "hidden" !== e) && "visible" !== e && "clip" !== e, $43fe3e1a57de4973$var$n = (e, n)=>{
    if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
        let l = getComputedStyle(e, null);
        return $43fe3e1a57de4973$var$t(l.overflowY, n) || $43fe3e1a57de4973$var$t(l.overflowX, n) || ((e)=>{
            let t = ((e)=>{
                if (!e.ownerDocument || !e.ownerDocument.defaultView) return null;
                try {
                    return e.ownerDocument.defaultView.frameElement;
                } catch (e) {
                    return null;
                }
            })(e);
            return !!t && (t.clientHeight < e.scrollHeight || t.clientWidth < e.scrollWidth);
        })(e);
    }
    return !1;
}, $43fe3e1a57de4973$var$l = (e, t, n, l, i, o, r, d)=>o < e && r > t || o > e && r < t ? 0 : o <= e && d <= n || r >= t && d >= n ? o - e - l : r > t && d < n || o < e && d > n ? r - t + i : 0, $43fe3e1a57de4973$var$i = (e)=>{
    let t = e.parentElement;
    return null == t ? e.getRootNode().host || null : t;
};
var $43fe3e1a57de4973$export$2e2bcd8739ae039 = (t, o)=>{
    var r, d, h, f, u, s;
    if ("undefined" == typeof document) return [];
    let { scrollMode: a, block: c, inline: g, boundary: m, skipOverflowHiddenElements: p } = o, w = "function" == typeof m ? m : (e)=>e !== m;
    if (!$43fe3e1a57de4973$var$e(t)) throw new TypeError("Invalid target");
    let W = document.scrollingElement || document.documentElement, H = [], b = t;
    for(; $43fe3e1a57de4973$var$e(b) && w(b);){
        if (b = $43fe3e1a57de4973$var$i(b), b === W) {
            H.push(b);
            break;
        }
        null != b && b === document.body && $43fe3e1a57de4973$var$n(b) && !$43fe3e1a57de4973$var$n(document.documentElement) || null != b && $43fe3e1a57de4973$var$n(b, p) && H.push(b);
    }
    let v = null != (d = null == (r = window.visualViewport) ? void 0 : r.width) ? d : innerWidth, y = null != (f = null == (h = window.visualViewport) ? void 0 : h.height) ? f : innerHeight, E = null != (u = window.scrollX) ? u : pageXOffset, M = null != (s = window.scrollY) ? s : pageYOffset, { height: x, width: I, top: C, right: R, bottom: T, left: V } = t.getBoundingClientRect(), k = "start" === c || "nearest" === c ? C : "end" === c ? T : C + x / 2, B = "center" === g ? V + I / 2 : "end" === g ? R : V, D = [];
    for(let e = 0; e < H.length; e++){
        let t = H[e], { height: n, width: i, top: o, right: r, bottom: d, left: h } = t.getBoundingClientRect();
        if ("if-needed" === a && C >= 0 && V >= 0 && T <= y && R <= v && C >= o && T <= d && V >= h && R <= r) return D;
        let f = getComputedStyle(t), u = parseInt(f.borderLeftWidth, 10), s = parseInt(f.borderTopWidth, 10), m = parseInt(f.borderRightWidth, 10), p = parseInt(f.borderBottomWidth, 10), w = 0, b = 0, O = "offsetWidth" in t ? t.offsetWidth - t.clientWidth - u - m : 0, X = "offsetHeight" in t ? t.offsetHeight - t.clientHeight - s - p : 0, Y = "offsetWidth" in t ? 0 === t.offsetWidth ? 0 : i / t.offsetWidth : 0, L = "offsetHeight" in t ? 0 === t.offsetHeight ? 0 : n / t.offsetHeight : 0;
        if (W === t) w = "start" === c ? k : "end" === c ? k - y : "nearest" === c ? $43fe3e1a57de4973$var$l(M, M + y, y, s, p, M + k, M + k + x, x) : k - y / 2, b = "start" === g ? B : "center" === g ? B - v / 2 : "end" === g ? B - v : $43fe3e1a57de4973$var$l(E, E + v, v, u, m, E + B, E + B + I, I), w = Math.max(0, w + M), b = Math.max(0, b + E);
        else {
            w = "start" === c ? k - o - s : "end" === c ? k - d + p + X : "nearest" === c ? $43fe3e1a57de4973$var$l(o, d, n, s, p + X, k, k + x, x) : k - (o + n / 2) + X / 2, b = "start" === g ? B - h - u : "center" === g ? B - (h + i / 2) + O / 2 : "end" === g ? B - r + m + O : $43fe3e1a57de4973$var$l(h, r, i, u, m + O, B, B + I, I);
            let { scrollLeft: e, scrollTop: f } = t;
            w = Math.max(0, Math.min(f + w / L, t.scrollHeight - n / L + X)), b = Math.max(0, Math.min(e + b / Y, t.scrollWidth - i / Y + O)), k += f - w, B += e - b;
        }
        D.push({
            el: t,
            top: w,
            left: b
        });
    }
    return D;
};



var $837ff71814b5dbdb$var$idCounter = 0;
/**
 * Accepts a parameter and returns it if it's a function
 * or a noop function if it's not. This allows us to
 * accept a callback, but not worry about it if it's not
 * passed.
 * @param {Function} cb the callback
 * @return {Function} a function
 */ function $837ff71814b5dbdb$var$cbToCb(cb) {
    return typeof cb === 'function' ? cb : $837ff71814b5dbdb$var$noop;
}
function $837ff71814b5dbdb$var$noop() {}
/**
 * Scroll node into view if necessary
 * @param {HTMLElement} node the element that should scroll into view
 * @param {HTMLElement} menuNode the menu element of the component
 */ function $837ff71814b5dbdb$var$scrollIntoView(node, menuNode) {
    if (!node) return;
    var actions = (0, $43fe3e1a57de4973$export$2e2bcd8739ae039)(node, {
        boundary: menuNode,
        block: 'nearest',
        scrollMode: 'if-needed'
    });
    actions.forEach(function(_ref) {
        var el = _ref.el, top = _ref.top, left = _ref.left;
        el.scrollTop = top;
        el.scrollLeft = left;
    });
}
/**
 * @param {HTMLElement} parent the parent node
 * @param {HTMLElement} child the child node
 * @param {Window} environment The window context where downshift renders.
 * @return {Boolean} whether the parent is the child or the child is in the parent
 */ function $837ff71814b5dbdb$var$isOrContainsNode(parent, child, environment) {
    var result = parent === child || child instanceof environment.Node && parent.contains && parent.contains(child);
    return result;
}
/**
 * Simple debounce implementation. Will call the given
 * function once after the time given has passed since
 * it was last called.
 * @param {Function} fn the function to call after the time
 * @param {Number} time the time to wait
 * @return {Function} the debounced function
 */ function $837ff71814b5dbdb$var$debounce(fn, time) {
    var timeoutId;
    function cancel() {
        if (timeoutId) clearTimeout(timeoutId);
    }
    function wrapper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        cancel();
        timeoutId = setTimeout(function() {
            timeoutId = null;
            fn.apply(void 0, args);
        }, time);
    }
    wrapper.cancel = cancel;
    return wrapper;
}
/**
 * This is intended to be used to compose event handlers.
 * They are executed in order until one of them sets
 * `event.preventDownshiftDefault = true`.
 * @param {...Function} fns the event handler functions
 * @return {Function} the event handler to add to an element
 */ function $837ff71814b5dbdb$var$callAllEventHandlers() {
    for(var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)fns[_key2] = arguments[_key2];
    return function(event) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return fns.some(function(fn) {
            if (fn) fn.apply(void 0, [
                event
            ].concat(args));
            return event.preventDownshiftDefault || event.hasOwnProperty('nativeEvent') && event.nativeEvent.preventDownshiftDefault;
        });
    };
}
function $837ff71814b5dbdb$var$handleRefs() {
    for(var _len4 = arguments.length, refs = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)refs[_key4] = arguments[_key4];
    return function(node) {
        refs.forEach(function(ref) {
            if (typeof ref === 'function') ref(node);
            else if (ref) ref.current = node;
        });
    };
}
/**
 * This generates a unique ID for an instance of Downshift
 * @return {String} the unique ID
 */ function $837ff71814b5dbdb$var$generateId() {
    return String($837ff71814b5dbdb$var$idCounter++);
}
/**
 * Resets idCounter to 0. Used for SSR.
 */ function $837ff71814b5dbdb$export$4fba683129f6ab1e() {
    $837ff71814b5dbdb$var$idCounter = 0;
}
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specify if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */ function $837ff71814b5dbdb$var$getA11yStatusMessage$1(_ref2) {
    var isOpen = _ref2.isOpen, resultCount = _ref2.resultCount, previousResultCount = _ref2.previousResultCount;
    if (!isOpen) return '';
    if (!resultCount) return 'No results are available.';
    if (resultCount !== previousResultCount) return resultCount + " result" + (resultCount === 1 ? ' is' : 's are') + " available, use up and down arrow keys to navigate. Press Enter key to select.";
    return '';
}
/**
 * Takes an argument and if it's an array, returns the first item in the array
 * otherwise returns the argument
 * @param {*} arg the maybe-array
 * @param {*} defaultValue the value if arg is falsey not defined
 * @return {*} the arg or it's first item
 */ function $837ff71814b5dbdb$var$unwrapArray(arg, defaultValue) {
    arg = Array.isArray(arg) ? /* istanbul ignore next (preact) */ arg[0] : arg;
    if (!arg && defaultValue) return defaultValue;
    else return arg;
}
/**
 * @param {Object} element (P)react element
 * @return {Boolean} whether it's a DOM element
 */ function $837ff71814b5dbdb$var$isDOMElement(element) {
    // then we assume this is react
    return typeof element.type === 'string';
}
/**
 * @param {Object} element (P)react element
 * @return {Object} the props
 */ function $837ff71814b5dbdb$var$getElementProps(element) {
    return element.props;
}
/**
 * Throws a helpful error message for required properties. Useful
 * to be used as a default in destructuring or object params.
 * @param {String} fnName the function name
 * @param {String} propName the prop name
 */ function $837ff71814b5dbdb$var$requiredProp(fnName, propName) {
    // eslint-disable-next-line no-console
    console.error("The property \"" + propName + "\" is required in \"" + fnName + "\"");
}
var $837ff71814b5dbdb$var$stateKeys = [
    'highlightedIndex',
    'inputValue',
    'isOpen',
    'selectedItem',
    'type'
];
/**
 * @param {Object} state the state object
 * @return {Object} state that is relevant to downshift
 */ function $837ff71814b5dbdb$var$pickState(state) {
    if (state === void 0) state = {};
    var result = {};
    $837ff71814b5dbdb$var$stateKeys.forEach(function(k) {
        if (state.hasOwnProperty(k)) result[k] = state[k];
    });
    return result;
}
/**
 * This will perform a shallow merge of the given state object
 * with the state coming from props
 * (for the controlled component scenario)
 * This is used in state updater functions so they're referencing
 * the right state regardless of where it comes from.
 *
 * @param {Object} state The state of the component/hook.
 * @param {Object} props The props that may contain controlled values.
 * @returns {Object} The merged controlled state.
 */ function $837ff71814b5dbdb$var$getState(state, props) {
    return Object.keys(state).reduce(function(prevState, key) {
        prevState[key] = $837ff71814b5dbdb$var$isControlledProp(props, key) ? props[key] : state[key];
        return prevState;
    }, {});
}
/**
 * This determines whether a prop is a "controlled prop" meaning it is
 * state which is controlled by the outside of this component rather
 * than within this component.
 *
 * @param {Object} props The props that may contain controlled values.
 * @param {String} key the key to check
 * @return {Boolean} whether it is a controlled controlled prop
 */ function $837ff71814b5dbdb$var$isControlledProp(props, key) {
    return props[key] !== undefined;
}
/**
 * Normalizes the 'key' property of a KeyboardEvent in IE/Edge
 * @param {Object} event a keyboardEvent object
 * @return {String} keyboard key
 */ function $837ff71814b5dbdb$var$normalizeArrowKey(event) {
    var key = event.key, keyCode = event.keyCode;
    /* istanbul ignore next (ie) */ if (keyCode >= 37 && keyCode <= 40 && key.indexOf('Arrow') !== 0) return "Arrow" + key;
    return key;
}
/**
 * Simple check if the value passed is object literal
 * @param {*} obj any things
 * @return {Boolean} whether it's object literal
 */ function $837ff71814b5dbdb$var$isPlainObject(obj) {
    return Object.prototype.toString.call(obj) === '[object Object]';
}
/**
 * Returns the new index in the list, in a circular way. If next value is out of bonds from the total,
 * it will wrap to either 0 or itemCount - 1.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index after the move.
 */ function $837ff71814b5dbdb$var$getNextWrappingIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
    if (circular === void 0) circular = true;
    if (itemCount === 0) return -1;
    var itemsLastIndex = itemCount - 1;
    if (typeof baseIndex !== 'number' || baseIndex < 0 || baseIndex >= itemCount) baseIndex = moveAmount > 0 ? -1 : itemsLastIndex + 1;
    var newIndex = baseIndex + moveAmount;
    if (newIndex < 0) newIndex = circular ? itemsLastIndex : 0;
    else if (newIndex > itemsLastIndex) newIndex = circular ? 0 : itemsLastIndex;
    var nonDisabledNewIndex = $837ff71814b5dbdb$var$getNextNonDisabledIndex(moveAmount, newIndex, itemCount, getItemNodeFromIndex, circular);
    if (nonDisabledNewIndex === -1) return baseIndex >= itemCount ? -1 : baseIndex;
    return nonDisabledNewIndex;
}
/**
 * Returns the next index in the list of an item that is not disabled.
 *
 * @param {number} moveAmount Number of positions to move. Negative to move backwards, positive forwards.
 * @param {number} baseIndex The initial position to move from.
 * @param {number} itemCount The total number of items.
 * @param {Function} getItemNodeFromIndex Used to check if item is disabled.
 * @param {boolean} circular Specify if navigation is circular. Default is true.
 * @returns {number} The new index. Returns baseIndex if item is not disabled. Returns next non-disabled item otherwise. If no non-disabled found it will return -1.
 */ function $837ff71814b5dbdb$var$getNextNonDisabledIndex(moveAmount, baseIndex, itemCount, getItemNodeFromIndex, circular) {
    var currentElementNode = getItemNodeFromIndex(baseIndex);
    if (!currentElementNode || !currentElementNode.hasAttribute('disabled')) return baseIndex;
    if (moveAmount > 0) for(var index = baseIndex + 1; index < itemCount; index++){
        if (!getItemNodeFromIndex(index).hasAttribute('disabled')) return index;
    }
    else for(var _index = baseIndex - 1; _index >= 0; _index--){
        if (!getItemNodeFromIndex(_index).hasAttribute('disabled')) return _index;
    }
    if (circular) return moveAmount > 0 ? $837ff71814b5dbdb$var$getNextNonDisabledIndex(1, 0, itemCount, getItemNodeFromIndex, false) : $837ff71814b5dbdb$var$getNextNonDisabledIndex(-1, itemCount - 1, itemCount, getItemNodeFromIndex, false);
    return -1;
}
/**
 * Checks if event target is within the downshift elements.
 *
 * @param {EventTarget} target Target to check.
 * @param {HTMLElement[]} downshiftElements The elements that form downshift (list, toggle button etc).
 * @param {Window} environment The window context where downshift renders.
 * @param {boolean} checkActiveElement Whether to also check activeElement.
 *
 * @returns {boolean} Whether or not the target is within downshift elements.
 */ function $837ff71814b5dbdb$var$targetWithinDownshift(target, downshiftElements, environment, checkActiveElement) {
    if (checkActiveElement === void 0) checkActiveElement = true;
    return downshiftElements.some(function(contextNode) {
        return contextNode && ($837ff71814b5dbdb$var$isOrContainsNode(contextNode, target, environment) || checkActiveElement && $837ff71814b5dbdb$var$isOrContainsNode(contextNode, environment.document.activeElement, environment));
    });
}
// eslint-disable-next-line import/no-mutable-exports
var $837ff71814b5dbdb$var$validateControlledUnchanged = $837ff71814b5dbdb$var$noop;
var $837ff71814b5dbdb$var$cleanupStatus = $837ff71814b5dbdb$var$debounce(function(documentProp) {
    $837ff71814b5dbdb$var$getStatusDiv(documentProp).textContent = '';
}, 500);
/**
 * @param {String} status the status message
 * @param {Object} documentProp document passed by the user.
 */ function $837ff71814b5dbdb$var$setStatus(status, documentProp) {
    var div = $837ff71814b5dbdb$var$getStatusDiv(documentProp);
    if (!status) return;
    div.textContent = status;
    $837ff71814b5dbdb$var$cleanupStatus(documentProp);
}
/**
 * Get the status node or create it if it does not already exist.
 * @param {Object} documentProp document passed by the user.
 * @return {HTMLElement} the status node.
 */ function $837ff71814b5dbdb$var$getStatusDiv(documentProp) {
    if (documentProp === void 0) documentProp = document;
    var statusDiv = documentProp.getElementById('a11y-status-message');
    if (statusDiv) return statusDiv;
    statusDiv = documentProp.createElement('div');
    statusDiv.setAttribute('id', 'a11y-status-message');
    statusDiv.setAttribute('role', 'status');
    statusDiv.setAttribute('aria-live', 'polite');
    statusDiv.setAttribute('aria-relevant', 'additions text');
    Object.assign(statusDiv.style, {
        border: '0',
        clip: 'rect(0 0 0 0)',
        height: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: '0',
        position: 'absolute',
        width: '1px'
    });
    documentProp.body.appendChild(statusDiv);
    return statusDiv;
}
var $837ff71814b5dbdb$var$unknown = 0;
var $837ff71814b5dbdb$var$mouseUp = 1;
var $837ff71814b5dbdb$var$itemMouseEnter = 2;
var $837ff71814b5dbdb$var$keyDownArrowUp = 3;
var $837ff71814b5dbdb$var$keyDownArrowDown = 4;
var $837ff71814b5dbdb$var$keyDownEscape = 5;
var $837ff71814b5dbdb$var$keyDownEnter = 6;
var $837ff71814b5dbdb$var$keyDownHome = 7;
var $837ff71814b5dbdb$var$keyDownEnd = 8;
var $837ff71814b5dbdb$var$clickItem = 9;
var $837ff71814b5dbdb$var$blurInput = 10;
var $837ff71814b5dbdb$var$changeInput = 11;
var $837ff71814b5dbdb$var$keyDownSpaceButton = 12;
var $837ff71814b5dbdb$var$clickButton = 13;
var $837ff71814b5dbdb$var$blurButton = 14;
var $837ff71814b5dbdb$var$controlledPropUpdatedSelectedItem = 15;
var $837ff71814b5dbdb$var$touchEnd = 16;
var $837ff71814b5dbdb$var$stateChangeTypes$3 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    unknown: $837ff71814b5dbdb$var$unknown,
    mouseUp: $837ff71814b5dbdb$var$mouseUp,
    itemMouseEnter: $837ff71814b5dbdb$var$itemMouseEnter,
    keyDownArrowUp: $837ff71814b5dbdb$var$keyDownArrowUp,
    keyDownArrowDown: $837ff71814b5dbdb$var$keyDownArrowDown,
    keyDownEscape: $837ff71814b5dbdb$var$keyDownEscape,
    keyDownEnter: $837ff71814b5dbdb$var$keyDownEnter,
    keyDownHome: $837ff71814b5dbdb$var$keyDownHome,
    keyDownEnd: $837ff71814b5dbdb$var$keyDownEnd,
    clickItem: $837ff71814b5dbdb$var$clickItem,
    blurInput: $837ff71814b5dbdb$var$blurInput,
    changeInput: $837ff71814b5dbdb$var$changeInput,
    keyDownSpaceButton: $837ff71814b5dbdb$var$keyDownSpaceButton,
    clickButton: $837ff71814b5dbdb$var$clickButton,
    blurButton: $837ff71814b5dbdb$var$blurButton,
    controlledPropUpdatedSelectedItem: $837ff71814b5dbdb$var$controlledPropUpdatedSelectedItem,
    touchEnd: $837ff71814b5dbdb$var$touchEnd
});
var $837ff71814b5dbdb$var$_excluded$4 = [
    "refKey",
    "ref"
], $837ff71814b5dbdb$var$_excluded2$3 = [
    "onClick",
    "onPress",
    "onKeyDown",
    "onKeyUp",
    "onBlur"
], $837ff71814b5dbdb$var$_excluded3$2 = [
    "onKeyDown",
    "onBlur",
    "onChange",
    "onInput",
    "onChangeText"
], $837ff71814b5dbdb$var$_excluded4$1 = [
    "refKey",
    "ref"
], $837ff71814b5dbdb$var$_excluded5 = [
    "onMouseMove",
    "onMouseDown",
    "onClick",
    "onPress",
    "index",
    "item"
];
var $837ff71814b5dbdb$var$Downshift = /*#__PURE__*/ function() {
    var Downshift = /*#__PURE__*/ function(_Component) {
        (0, $146ee816144a450d$export$2e2bcd8739ae039)(Downshift, _Component);
        function Downshift(_props) {
            var _this;
            _this = _Component.call(this, _props) || this;
            // fancy destructuring + defaults + aliases
            // this basically says each value of state should either be set to
            // the initial value or the default value if the initial value is not provided
            _this.id = _this.props.id || "downshift-" + $837ff71814b5dbdb$var$generateId();
            _this.menuId = _this.props.menuId || _this.id + "-menu";
            _this.labelId = _this.props.labelId || _this.id + "-label";
            _this.inputId = _this.props.inputId || _this.id + "-input";
            _this.getItemId = _this.props.getItemId || function(index) {
                return _this.id + "-item-" + index;
            };
            _this.input = null;
            _this.items = [];
            // itemCount can be changed asynchronously
            // from within downshift (so it can't come from a prop)
            // this is why we store it as an instance and use
            // getItemCount rather than just use items.length
            // (to support windowing + async)
            _this.itemCount = null;
            _this.previousResultCount = 0;
            _this.timeoutIds = [];
            /**
       * @param {Function} fn the function to call after the time
       * @param {Number} time the time to wait
       */ _this.internalSetTimeout = function(fn, time) {
                var id = setTimeout(function() {
                    _this.timeoutIds = _this.timeoutIds.filter(function(i) {
                        return i !== id;
                    });
                    fn();
                }, time);
                _this.timeoutIds.push(id);
            };
            _this.setItemCount = function(count) {
                _this.itemCount = count;
            };
            _this.unsetItemCount = function() {
                _this.itemCount = null;
            };
            _this.setHighlightedIndex = function(highlightedIndex, otherStateToSet) {
                if (highlightedIndex === void 0) highlightedIndex = _this.props.defaultHighlightedIndex;
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $837ff71814b5dbdb$var$pickState(otherStateToSet);
                _this.internalSetState((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    highlightedIndex: highlightedIndex
                }, otherStateToSet));
            };
            _this.clearSelection = function(cb) {
                _this.internalSetState({
                    selectedItem: null,
                    inputValue: '',
                    highlightedIndex: _this.props.defaultHighlightedIndex,
                    isOpen: _this.props.defaultIsOpen
                }, cb);
            };
            _this.selectItem = function(item, otherStateToSet, cb) {
                otherStateToSet = $837ff71814b5dbdb$var$pickState(otherStateToSet);
                _this.internalSetState((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    isOpen: _this.props.defaultIsOpen,
                    highlightedIndex: _this.props.defaultHighlightedIndex,
                    selectedItem: item,
                    inputValue: _this.props.itemToString(item)
                }, otherStateToSet), cb);
            };
            _this.selectItemAtIndex = function(itemIndex, otherStateToSet, cb) {
                var item = _this.items[itemIndex];
                if (item == null) return;
                _this.selectItem(item, otherStateToSet, cb);
            };
            _this.selectHighlightedItem = function(otherStateToSet, cb) {
                return _this.selectItemAtIndex(_this.getState().highlightedIndex, otherStateToSet, cb);
            };
            // any piece of our state can live in two places:
            // 1. Uncontrolled: it's internal (this.state)
            //    We will call this.setState to update that state
            // 2. Controlled: it's external (this.props)
            //    We will call this.props.onStateChange to update that state
            //
            // In addition, we'll call this.props.onChange if the
            // selectedItem is changed.
            _this.internalSetState = function(stateToSet, cb) {
                var isItemSelected, onChangeArg;
                var onStateChangeArg = {};
                var isStateToSetFunction = typeof stateToSet === 'function';
                // we want to call `onInputValueChange` before the `setState` call
                // so someone controlling the `inputValue` state gets notified of
                // the input change as soon as possible. This avoids issues with
                // preserving the cursor position.
                // See https://github.com/downshift-js/downshift/issues/217 for more info.
                if (!isStateToSetFunction && stateToSet.hasOwnProperty('inputValue')) _this.props.onInputValueChange(stateToSet.inputValue, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, _this.getStateAndHelpers(), stateToSet));
                return _this.setState(function(state) {
                    state = _this.getState(state);
                    var newStateToSet = isStateToSetFunction ? stateToSet(state) : stateToSet;
                    // Your own function that could modify the state that will be set.
                    newStateToSet = _this.props.stateReducer(state, newStateToSet);
                    // checks if an item is selected, regardless of if it's different from
                    // what was selected before
                    // used to determine if onSelect and onChange callbacks should be called
                    isItemSelected = newStateToSet.hasOwnProperty('selectedItem');
                    // this keeps track of the object we want to call with setState
                    var nextState = {};
                    // we need to call on change if the outside world is controlling any of our state
                    // and we're trying to update that state. OR if the selection has changed and we're
                    // trying to update the selection
                    if (isItemSelected && newStateToSet.selectedItem !== state.selectedItem) onChangeArg = newStateToSet.selectedItem;
                    newStateToSet.type = newStateToSet.type || $837ff71814b5dbdb$var$unknown;
                    Object.keys(newStateToSet).forEach(function(key) {
                        // onStateChangeArg should only have the state that is
                        // actually changing
                        if (state[key] !== newStateToSet[key]) onStateChangeArg[key] = newStateToSet[key];
                        // the type is useful for the onStateChangeArg
                        // but we don't actually want to set it in internal state.
                        // this is an undocumented feature for now... Not all internalSetState
                        // calls support it and I'm not certain we want them to yet.
                        // But it enables users controlling the isOpen state to know when
                        // the isOpen state changes due to mouseup events which is quite handy.
                        if (key === 'type') return;
                        newStateToSet[key];
                        // if it's coming from props, then we don't care to set it internally
                        if (!$837ff71814b5dbdb$var$isControlledProp(_this.props, key)) nextState[key] = newStateToSet[key];
                    });
                    // if stateToSet is a function, then we weren't able to call onInputValueChange
                    // earlier, so we'll call it now that we know what the inputValue state will be.
                    if (isStateToSetFunction && newStateToSet.hasOwnProperty('inputValue')) _this.props.onInputValueChange(newStateToSet.inputValue, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, _this.getStateAndHelpers(), newStateToSet));
                    return nextState;
                }, function() {
                    // call the provided callback if it's a function
                    $837ff71814b5dbdb$var$cbToCb(cb)();
                    // only call the onStateChange and onChange callbacks if
                    // we have relevant information to pass them.
                    var hasMoreStateThanType = Object.keys(onStateChangeArg).length > 1;
                    if (hasMoreStateThanType) _this.props.onStateChange(onStateChangeArg, _this.getStateAndHelpers());
                    if (isItemSelected) _this.props.onSelect(stateToSet.selectedItem, _this.getStateAndHelpers());
                    if (onChangeArg !== undefined) _this.props.onChange(onChangeArg, _this.getStateAndHelpers());
                    // this is currently undocumented and therefore subject to change
                    // We'll try to not break it, but just be warned.
                    _this.props.onUserAction(onStateChangeArg, _this.getStateAndHelpers());
                });
            };
            //////////////////////////// ROOT
            _this.rootRef = function(node) {
                return _this._rootNode = node;
            };
            _this.getRootProps = function(_temp, _temp2) {
                var _extends2;
                var _ref = _temp === void 0 ? {} : _temp, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey, ref = _ref.ref, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $837ff71814b5dbdb$var$_excluded$4);
                var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
                // this is used in the render to know whether the user has called getRootProps.
                // It uses that to know whether to apply the props automatically
                _this.getRootProps.called = true;
                _this.getRootProps.refKey = refKey;
                _this.getRootProps.suppressRefError = suppressRefError;
                var _this$getState = _this.getState(), isOpen = _this$getState.isOpen;
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, _this.rootRef), _extends2.role = 'combobox', _extends2['aria-expanded'] = isOpen, _extends2['aria-haspopup'] = 'listbox', _extends2['aria-owns'] = isOpen ? _this.menuId : null, _extends2['aria-labelledby'] = _this.labelId, _extends2), rest);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\ ROOT
            _this.keyDownHandlers = {
                ArrowDown: function ArrowDown(event) {
                    var _this2 = this;
                    event.preventDefault();
                    if (this.getState().isOpen) {
                        var amount = event.shiftKey ? 5 : 1;
                        this.moveHighlightedIndex(amount, {
                            type: $837ff71814b5dbdb$var$keyDownArrowDown
                        });
                    } else this.internalSetState({
                        isOpen: true,
                        type: $837ff71814b5dbdb$var$keyDownArrowDown
                    }, function() {
                        var itemCount = _this2.getItemCount();
                        if (itemCount > 0) {
                            var _this2$getState = _this2.getState(), highlightedIndex = _this2$getState.highlightedIndex;
                            var nextHighlightedIndex = $837ff71814b5dbdb$var$getNextWrappingIndex(1, highlightedIndex, itemCount, function(index) {
                                return _this2.getItemNodeFromIndex(index);
                            });
                            _this2.setHighlightedIndex(nextHighlightedIndex, {
                                type: $837ff71814b5dbdb$var$keyDownArrowDown
                            });
                        }
                    });
                },
                ArrowUp: function ArrowUp(event) {
                    var _this3 = this;
                    event.preventDefault();
                    if (this.getState().isOpen) {
                        var amount = event.shiftKey ? -5 : -1;
                        this.moveHighlightedIndex(amount, {
                            type: $837ff71814b5dbdb$var$keyDownArrowUp
                        });
                    } else this.internalSetState({
                        isOpen: true,
                        type: $837ff71814b5dbdb$var$keyDownArrowUp
                    }, function() {
                        var itemCount = _this3.getItemCount();
                        if (itemCount > 0) {
                            var _this3$getState = _this3.getState(), highlightedIndex = _this3$getState.highlightedIndex;
                            var nextHighlightedIndex = $837ff71814b5dbdb$var$getNextWrappingIndex(-1, highlightedIndex, itemCount, function(index) {
                                return _this3.getItemNodeFromIndex(index);
                            });
                            _this3.setHighlightedIndex(nextHighlightedIndex, {
                                type: $837ff71814b5dbdb$var$keyDownArrowUp
                            });
                        }
                    });
                },
                Enter: function Enter(event) {
                    if (event.which === 229) return;
                    var _this$getState2 = this.getState(), isOpen = _this$getState2.isOpen, highlightedIndex = _this$getState2.highlightedIndex;
                    if (isOpen && highlightedIndex != null) {
                        event.preventDefault();
                        var item = this.items[highlightedIndex];
                        var itemNode = this.getItemNodeFromIndex(highlightedIndex);
                        if (item == null || itemNode && itemNode.hasAttribute('disabled')) return;
                        this.selectHighlightedItem({
                            type: $837ff71814b5dbdb$var$keyDownEnter
                        });
                    }
                },
                Escape: function Escape(event) {
                    event.preventDefault();
                    this.reset((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                        type: $837ff71814b5dbdb$var$keyDownEscape
                    }, !this.state.isOpen && {
                        selectedItem: null,
                        inputValue: ''
                    }));
                }
            };
            //////////////////////////// BUTTON
            _this.buttonKeyDownHandlers = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, _this.keyDownHandlers, {
                ' ': function _(event) {
                    event.preventDefault();
                    this.toggleMenu({
                        type: $837ff71814b5dbdb$var$keyDownSpaceButton
                    });
                }
            });
            _this.inputKeyDownHandlers = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, _this.keyDownHandlers, {
                Home: function Home(event) {
                    var _this4 = this;
                    var _this$getState3 = this.getState(), isOpen = _this$getState3.isOpen;
                    if (!isOpen) return;
                    event.preventDefault();
                    var itemCount = this.getItemCount();
                    if (itemCount <= 0 || !isOpen) return;
                    // get next non-disabled starting downwards from 0 if that's disabled.
                    var newHighlightedIndex = $837ff71814b5dbdb$var$getNextNonDisabledIndex(1, 0, itemCount, function(index) {
                        return _this4.getItemNodeFromIndex(index);
                    }, false);
                    this.setHighlightedIndex(newHighlightedIndex, {
                        type: $837ff71814b5dbdb$var$keyDownHome
                    });
                },
                End: function End(event) {
                    var _this5 = this;
                    var _this$getState4 = this.getState(), isOpen = _this$getState4.isOpen;
                    if (!isOpen) return;
                    event.preventDefault();
                    var itemCount = this.getItemCount();
                    if (itemCount <= 0 || !isOpen) return;
                    // get next non-disabled starting upwards from last index if that's disabled.
                    var newHighlightedIndex = $837ff71814b5dbdb$var$getNextNonDisabledIndex(-1, itemCount - 1, itemCount, function(index) {
                        return _this5.getItemNodeFromIndex(index);
                    }, false);
                    this.setHighlightedIndex(newHighlightedIndex, {
                        type: $837ff71814b5dbdb$var$keyDownEnd
                    });
                }
            });
            _this.getToggleButtonProps = function(_temp3) {
                var _ref3 = _temp3 === void 0 ? {} : _temp3, onClick = _ref3.onClick;
                _ref3.onPress;
                var onKeyDown = _ref3.onKeyDown, onKeyUp = _ref3.onKeyUp, onBlur = _ref3.onBlur, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref3, $837ff71814b5dbdb$var$_excluded2$3);
                var _this$getState5 = _this.getState(), isOpen = _this$getState5.isOpen;
                var enabledEventHandlers = {
                    onClick: $837ff71814b5dbdb$var$callAllEventHandlers(onClick, _this.buttonHandleClick),
                    onKeyDown: $837ff71814b5dbdb$var$callAllEventHandlers(onKeyDown, _this.buttonHandleKeyDown),
                    onKeyUp: $837ff71814b5dbdb$var$callAllEventHandlers(onKeyUp, _this.buttonHandleKeyUp),
                    onBlur: $837ff71814b5dbdb$var$callAllEventHandlers(onBlur, _this.buttonHandleBlur)
                };
                var eventHandlers = rest.disabled ? {} : enabledEventHandlers;
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    type: 'button',
                    role: 'button',
                    'aria-label': isOpen ? 'close menu' : 'open menu',
                    'aria-haspopup': true,
                    'data-toggle': true
                }, eventHandlers, rest);
            };
            _this.buttonHandleKeyUp = function(event) {
                // Prevent click event from emitting in Firefox
                event.preventDefault();
            };
            _this.buttonHandleKeyDown = function(event) {
                var key = $837ff71814b5dbdb$var$normalizeArrowKey(event);
                if (_this.buttonKeyDownHandlers[key]) _this.buttonKeyDownHandlers[key].call((0, $3zeAJ.default)(_this), event);
            };
            _this.buttonHandleClick = function(event) {
                event.preventDefault();
                // handle odd case for Safari and Firefox which
                // don't give the button the focus properly.
                /* istanbul ignore if (can't reasonably test this) */ if (_this.props.environment.document.activeElement === _this.props.environment.document.body) event.target.focus();
                // Ensure that toggle of menu occurs after the potential blur event in iOS
                _this.internalSetTimeout(function() {
                    return _this.toggleMenu({
                        type: $837ff71814b5dbdb$var$clickButton
                    });
                });
            };
            _this.buttonHandleBlur = function(event) {
                var blurTarget = event.target; // Save blur target for comparison with activeElement later
                // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not body element
                _this.internalSetTimeout(function() {
                    if (!_this.isMouseDown && (_this.props.environment.document.activeElement == null || _this.props.environment.document.activeElement.id !== _this.inputId) && _this.props.environment.document.activeElement !== blurTarget // Do nothing if we refocus the same element again (to solve issue in Safari on iOS)
                    ) _this.reset({
                        type: $837ff71814b5dbdb$var$blurButton
                    });
                });
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ BUTTON
            /////////////////////////////// LABEL
            _this.getLabelProps = function(props) {
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    htmlFor: _this.inputId,
                    id: _this.labelId
                }, props);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ LABEL
            /////////////////////////////// INPUT
            _this.getInputProps = function(_temp4) {
                var _ref4 = _temp4 === void 0 ? {} : _temp4, onKeyDown = _ref4.onKeyDown, onBlur = _ref4.onBlur, onChange = _ref4.onChange, onInput = _ref4.onInput;
                _ref4.onChangeText;
                var rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref4, $837ff71814b5dbdb$var$_excluded3$2);
                var onChangeKey;
                var eventHandlers = {};
                onChangeKey = 'onChange';
                var _this$getState6 = _this.getState(), inputValue = _this$getState6.inputValue, isOpen = _this$getState6.isOpen, highlightedIndex = _this$getState6.highlightedIndex;
                if (!rest.disabled) {
                    var _eventHandlers;
                    eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = $837ff71814b5dbdb$var$callAllEventHandlers(onChange, onInput, _this.inputHandleChange), _eventHandlers.onKeyDown = $837ff71814b5dbdb$var$callAllEventHandlers(onKeyDown, _this.inputHandleKeyDown), _eventHandlers.onBlur = $837ff71814b5dbdb$var$callAllEventHandlers(onBlur, _this.inputHandleBlur), _eventHandlers);
                }
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    'aria-autocomplete': 'list',
                    'aria-activedescendant': isOpen && typeof highlightedIndex === 'number' && highlightedIndex >= 0 ? _this.getItemId(highlightedIndex) : null,
                    'aria-controls': isOpen ? _this.menuId : null,
                    'aria-labelledby': rest && rest['aria-label'] ? undefined : _this.labelId,
                    // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
                    // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
                    autoComplete: 'off',
                    value: inputValue,
                    id: _this.inputId
                }, eventHandlers, rest);
            };
            _this.inputHandleKeyDown = function(event) {
                var key = $837ff71814b5dbdb$var$normalizeArrowKey(event);
                if (key && _this.inputKeyDownHandlers[key]) _this.inputKeyDownHandlers[key].call((0, $3zeAJ.default)(_this), event);
            };
            _this.inputHandleChange = function(event) {
                _this.internalSetState({
                    type: $837ff71814b5dbdb$var$changeInput,
                    isOpen: true,
                    inputValue: event.target.value,
                    highlightedIndex: _this.props.defaultHighlightedIndex
                });
            };
            _this.inputHandleBlur = function() {
                // Need setTimeout, so that when the user presses Tab, the activeElement is the next focused element, not the body element
                _this.internalSetTimeout(function() {
                    var downshiftButtonIsActive = _this.props.environment.document && !!_this.props.environment.document.activeElement && !!_this.props.environment.document.activeElement.dataset && _this.props.environment.document.activeElement.dataset.toggle && _this._rootNode && _this._rootNode.contains(_this.props.environment.document.activeElement);
                    if (!_this.isMouseDown && !downshiftButtonIsActive) _this.reset({
                        type: $837ff71814b5dbdb$var$blurInput
                    });
                });
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ INPUT
            /////////////////////////////// MENU
            _this.menuRef = function(node) {
                _this._menuNode = node;
            };
            _this.getMenuProps = function(_temp5, _temp6) {
                var _extends3;
                var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey, ref = _ref5.ref, props = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref5, $837ff71814b5dbdb$var$_excluded4$1);
                var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$suppressRefErro = _ref6.suppressRefError, suppressRefError = _ref6$suppressRefErro === void 0 ? false : _ref6$suppressRefErro;
                _this.getMenuProps.called = true;
                _this.getMenuProps.refKey = refKey;
                _this.getMenuProps.suppressRefError = suppressRefError;
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends3 = {}, _extends3[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, _this.menuRef), _extends3.role = 'listbox', _extends3['aria-labelledby'] = props && props['aria-label'] ? null : _this.labelId, _extends3.id = _this.menuId, _extends3), props);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ MENU
            /////////////////////////////// ITEM
            _this.getItemProps = function(_temp7) {
                var _enabledEventHandlers;
                var _ref7 = _temp7 === void 0 ? {} : _temp7, onMouseMove = _ref7.onMouseMove, onMouseDown = _ref7.onMouseDown, onClick = _ref7.onClick;
                _ref7.onPress;
                var index = _ref7.index, _ref7$item = _ref7.item, item = _ref7$item === void 0 ? /* istanbul ignore next */ undefined : _ref7$item, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref7, $837ff71814b5dbdb$var$_excluded5);
                if (index === undefined) {
                    _this.items.push(item);
                    index = _this.items.indexOf(item);
                } else _this.items[index] = item;
                var onSelectKey = 'onClick';
                var customClickHandler = onClick;
                var enabledEventHandlers = (_enabledEventHandlers = {
                    // onMouseMove is used over onMouseEnter here. onMouseMove
                    // is only triggered on actual mouse movement while onMouseEnter
                    // can fire on DOM changes, interrupting keyboard navigation
                    onMouseMove: $837ff71814b5dbdb$var$callAllEventHandlers(onMouseMove, function() {
                        if (index === _this.getState().highlightedIndex) return;
                        _this.setHighlightedIndex(index, {
                            type: $837ff71814b5dbdb$var$itemMouseEnter
                        });
                        // We never want to manually scroll when changing state based
                        // on `onMouseMove` because we will be moving the element out
                        // from under the user which is currently scrolling/moving the
                        // cursor
                        _this.avoidScrolling = true;
                        _this.internalSetTimeout(function() {
                            return _this.avoidScrolling = false;
                        }, 250);
                    }),
                    onMouseDown: $837ff71814b5dbdb$var$callAllEventHandlers(onMouseDown, function(event) {
                        // This prevents the activeElement from being changed
                        // to the item so it can remain with the current activeElement
                        // which is a more common use case.
                        event.preventDefault();
                    })
                }, _enabledEventHandlers[onSelectKey] = $837ff71814b5dbdb$var$callAllEventHandlers(customClickHandler, function() {
                    _this.selectItemAtIndex(index, {
                        type: $837ff71814b5dbdb$var$clickItem
                    });
                }), _enabledEventHandlers);
                // Passing down the onMouseDown handler to prevent redirect
                // of the activeElement if clicking on disabled items
                var eventHandlers = rest.disabled ? {
                    onMouseDown: enabledEventHandlers.onMouseDown
                } : enabledEventHandlers;
                return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    id: _this.getItemId(index),
                    role: 'option',
                    'aria-selected': _this.getState().highlightedIndex === index
                }, eventHandlers, rest);
            };
            //\\\\\\\\\\\\\\\\\\\\\\\\\\\\\ ITEM
            _this.clearItems = function() {
                _this.items = [];
            };
            _this.reset = function(otherStateToSet, cb) {
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $837ff71814b5dbdb$var$pickState(otherStateToSet);
                _this.internalSetState(function(_ref8) {
                    var selectedItem = _ref8.selectedItem;
                    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                        isOpen: _this.props.defaultIsOpen,
                        highlightedIndex: _this.props.defaultHighlightedIndex,
                        inputValue: _this.props.itemToString(selectedItem)
                    }, otherStateToSet);
                }, cb);
            };
            _this.toggleMenu = function(otherStateToSet, cb) {
                if (otherStateToSet === void 0) otherStateToSet = {};
                otherStateToSet = $837ff71814b5dbdb$var$pickState(otherStateToSet);
                _this.internalSetState(function(_ref9) {
                    var isOpen = _ref9.isOpen;
                    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                        isOpen: !isOpen
                    }, isOpen && {
                        highlightedIndex: _this.props.defaultHighlightedIndex
                    }, otherStateToSet);
                }, function() {
                    var _this$getState7 = _this.getState(), isOpen = _this$getState7.isOpen, highlightedIndex = _this$getState7.highlightedIndex;
                    if (isOpen) {
                        if (_this.getItemCount() > 0 && typeof highlightedIndex === 'number') _this.setHighlightedIndex(highlightedIndex, otherStateToSet);
                    }
                    $837ff71814b5dbdb$var$cbToCb(cb)();
                });
            };
            _this.openMenu = function(cb) {
                _this.internalSetState({
                    isOpen: true
                }, cb);
            };
            _this.closeMenu = function(cb) {
                _this.internalSetState({
                    isOpen: false
                }, cb);
            };
            _this.updateStatus = $837ff71814b5dbdb$var$debounce(function() {
                var state = _this.getState();
                var item = _this.items[state.highlightedIndex];
                var resultCount = _this.getItemCount();
                var status = _this.props.getA11yStatusMessage((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                    itemToString: _this.props.itemToString,
                    previousResultCount: _this.previousResultCount,
                    resultCount: resultCount,
                    highlightedItem: item
                }, state));
                _this.previousResultCount = resultCount;
                $837ff71814b5dbdb$var$setStatus(status, _this.props.environment.document);
            }, 200);
            var _this$props = _this.props, defaultHighlightedIndex = _this$props.defaultHighlightedIndex, _this$props$initialHi = _this$props.initialHighlightedIndex, _highlightedIndex = _this$props$initialHi === void 0 ? defaultHighlightedIndex : _this$props$initialHi, defaultIsOpen = _this$props.defaultIsOpen, _this$props$initialIs = _this$props.initialIsOpen, _isOpen = _this$props$initialIs === void 0 ? defaultIsOpen : _this$props$initialIs, _this$props$initialIn = _this$props.initialInputValue, _inputValue = _this$props$initialIn === void 0 ? '' : _this$props$initialIn, _this$props$initialSe = _this$props.initialSelectedItem, _selectedItem = _this$props$initialSe === void 0 ? null : _this$props$initialSe;
            var _state = _this.getState({
                highlightedIndex: _highlightedIndex,
                isOpen: _isOpen,
                inputValue: _inputValue,
                selectedItem: _selectedItem
            });
            if (_state.selectedItem != null && _this.props.initialInputValue === undefined) _state.inputValue = _this.props.itemToString(_state.selectedItem);
            _this.state = _state;
            return _this;
        }
        var _proto = Downshift.prototype;
        /**
     * Clear all running timeouts
     */ _proto.internalClearTimeouts = function internalClearTimeouts() {
            this.timeoutIds.forEach(function(id) {
                clearTimeout(id);
            });
            this.timeoutIds = [];
        };
        _proto.getState = function getState$1(stateToMerge) {
            if (stateToMerge === void 0) stateToMerge = this.state;
            return $837ff71814b5dbdb$var$getState(stateToMerge, this.props);
        };
        _proto.getItemCount = function getItemCount() {
            // things read better this way. They're in priority order:
            // 1. `this.itemCount`
            // 2. `this.props.itemCount`
            // 3. `this.items.length`
            var itemCount = this.items.length;
            if (this.itemCount != null) itemCount = this.itemCount;
            else if (this.props.itemCount !== undefined) itemCount = this.props.itemCount;
            return itemCount;
        };
        _proto.getItemNodeFromIndex = function getItemNodeFromIndex(index) {
            return this.props.environment.document.getElementById(this.getItemId(index));
        };
        _proto.scrollHighlightedItemIntoView = function scrollHighlightedItemIntoView() {
            var node = this.getItemNodeFromIndex(this.getState().highlightedIndex);
            this.props.scrollIntoView(node, this._menuNode);
        };
        _proto.moveHighlightedIndex = function moveHighlightedIndex(amount, otherStateToSet) {
            var _this6 = this;
            var itemCount = this.getItemCount();
            var _this$getState8 = this.getState(), highlightedIndex = _this$getState8.highlightedIndex;
            if (itemCount > 0) {
                var nextHighlightedIndex = $837ff71814b5dbdb$var$getNextWrappingIndex(amount, highlightedIndex, itemCount, function(index) {
                    return _this6.getItemNodeFromIndex(index);
                });
                this.setHighlightedIndex(nextHighlightedIndex, otherStateToSet);
            }
        };
        _proto.getStateAndHelpers = function getStateAndHelpers() {
            var _this$getState9 = this.getState(), highlightedIndex = _this$getState9.highlightedIndex, inputValue = _this$getState9.inputValue, selectedItem = _this$getState9.selectedItem, isOpen = _this$getState9.isOpen;
            var itemToString = this.props.itemToString;
            var id = this.id;
            var getRootProps = this.getRootProps, getToggleButtonProps = this.getToggleButtonProps, getLabelProps = this.getLabelProps, getMenuProps = this.getMenuProps, getInputProps = this.getInputProps, getItemProps = this.getItemProps, openMenu = this.openMenu, closeMenu = this.closeMenu, toggleMenu = this.toggleMenu, selectItem = this.selectItem, selectItemAtIndex = this.selectItemAtIndex, selectHighlightedItem = this.selectHighlightedItem, setHighlightedIndex = this.setHighlightedIndex, clearSelection = this.clearSelection, clearItems = this.clearItems, reset = this.reset, setItemCount = this.setItemCount, unsetItemCount = this.unsetItemCount, setState = this.internalSetState;
            return {
                // prop getters
                getRootProps: getRootProps,
                getToggleButtonProps: getToggleButtonProps,
                getLabelProps: getLabelProps,
                getMenuProps: getMenuProps,
                getInputProps: getInputProps,
                getItemProps: getItemProps,
                // actions
                reset: reset,
                openMenu: openMenu,
                closeMenu: closeMenu,
                toggleMenu: toggleMenu,
                selectItem: selectItem,
                selectItemAtIndex: selectItemAtIndex,
                selectHighlightedItem: selectHighlightedItem,
                setHighlightedIndex: setHighlightedIndex,
                clearSelection: clearSelection,
                clearItems: clearItems,
                setItemCount: setItemCount,
                unsetItemCount: unsetItemCount,
                setState: setState,
                // props
                itemToString: itemToString,
                // derived
                id: id,
                // state
                highlightedIndex: highlightedIndex,
                inputValue: inputValue,
                isOpen: isOpen,
                selectedItem: selectedItem
            };
        };
        _proto.componentDidMount = function componentDidMount() {
            var _this7 = this;
            // this.isMouseDown helps us track whether the mouse is currently held down.
            // This is useful when the user clicks on an item in the list, but holds the mouse
            // down long enough for the list to disappear (because the blur event fires on the input)
            // this.isMouseDown is used in the blur handler on the input to determine whether the blur event should
            // trigger hiding the menu.
            var onMouseDown = function onMouseDown() {
                _this7.isMouseDown = true;
            };
            var onMouseUp = function onMouseUp(event) {
                _this7.isMouseDown = false;
                // if the target element or the activeElement is within a downshift node
                // then we don't want to reset downshift
                var contextWithinDownshift = $837ff71814b5dbdb$var$targetWithinDownshift(event.target, [
                    _this7._rootNode,
                    _this7._menuNode
                ], _this7.props.environment);
                if (!contextWithinDownshift && _this7.getState().isOpen) _this7.reset({
                    type: $837ff71814b5dbdb$var$mouseUp
                }, function() {
                    return _this7.props.onOuterClick(_this7.getStateAndHelpers());
                });
            };
            // Touching an element in iOS gives focus and hover states, but touching out of
            // the element will remove hover, and persist the focus state, resulting in the
            // blur event not being triggered.
            // this.isTouchMove helps us track whether the user is tapping or swiping on a touch screen.
            // If the user taps outside of Downshift, the component should be reset,
            // but not if the user is swiping
            var onTouchStart = function onTouchStart() {
                _this7.isTouchMove = false;
            };
            var onTouchMove = function onTouchMove() {
                _this7.isTouchMove = true;
            };
            var onTouchEnd = function onTouchEnd(event) {
                var contextWithinDownshift = $837ff71814b5dbdb$var$targetWithinDownshift(event.target, [
                    _this7._rootNode,
                    _this7._menuNode
                ], _this7.props.environment, false);
                if (!_this7.isTouchMove && !contextWithinDownshift && _this7.getState().isOpen) _this7.reset({
                    type: $837ff71814b5dbdb$var$touchEnd
                }, function() {
                    return _this7.props.onOuterClick(_this7.getStateAndHelpers());
                });
            };
            var environment = this.props.environment;
            environment.addEventListener('mousedown', onMouseDown);
            environment.addEventListener('mouseup', onMouseUp);
            environment.addEventListener('touchstart', onTouchStart);
            environment.addEventListener('touchmove', onTouchMove);
            environment.addEventListener('touchend', onTouchEnd);
            this.cleanup = function() {
                _this7.internalClearTimeouts();
                _this7.updateStatus.cancel();
                environment.removeEventListener('mousedown', onMouseDown);
                environment.removeEventListener('mouseup', onMouseUp);
                environment.removeEventListener('touchstart', onTouchStart);
                environment.removeEventListener('touchmove', onTouchMove);
                environment.removeEventListener('touchend', onTouchEnd);
            };
        };
        _proto.shouldScroll = function shouldScroll(prevState, prevProps) {
            var _ref10 = this.props.highlightedIndex === undefined ? this.getState() : this.props, currentHighlightedIndex = _ref10.highlightedIndex;
            var _ref11 = prevProps.highlightedIndex === undefined ? prevState : prevProps, prevHighlightedIndex = _ref11.highlightedIndex;
            var scrollWhenOpen = currentHighlightedIndex && this.getState().isOpen && !prevState.isOpen;
            var scrollWhenNavigating = currentHighlightedIndex !== prevHighlightedIndex;
            return scrollWhenOpen || scrollWhenNavigating;
        };
        _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
            if ($837ff71814b5dbdb$var$isControlledProp(this.props, 'selectedItem') && this.props.selectedItemChanged(prevProps.selectedItem, this.props.selectedItem)) this.internalSetState({
                type: $837ff71814b5dbdb$var$controlledPropUpdatedSelectedItem,
                inputValue: this.props.itemToString(this.props.selectedItem)
            });
            if (!this.avoidScrolling && this.shouldScroll(prevState, prevProps)) this.scrollHighlightedItemIntoView();
            this.updateStatus();
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.cleanup(); // avoids memory leak
        };
        _proto.render = function render() {
            var children = $837ff71814b5dbdb$var$unwrapArray(this.props.children, $837ff71814b5dbdb$var$noop);
            // because the items are rerendered every time we call the children
            // we clear this out each render and it will be populated again as
            // getItemProps is called.
            this.clearItems();
            // we reset this so we know whether the user calls getRootProps during
            // this render. If they do then we don't need to do anything,
            // if they don't then we need to clone the element they return and
            // apply the props for them.
            this.getRootProps.called = false;
            this.getRootProps.refKey = undefined;
            this.getRootProps.suppressRefError = undefined;
            // we do something similar for getMenuProps
            this.getMenuProps.called = false;
            this.getMenuProps.refKey = undefined;
            this.getMenuProps.suppressRefError = undefined;
            // we do something similar for getLabelProps
            this.getLabelProps.called = false;
            // and something similar for getInputProps
            this.getInputProps.called = false;
            var element = $837ff71814b5dbdb$var$unwrapArray(children(this.getStateAndHelpers()));
            if (!element) return null;
            if (this.getRootProps.called || this.props.suppressRefError) return element;
            else if ($837ff71814b5dbdb$var$isDOMElement(element)) // they didn't apply the root props, but we can clone
            // this and apply the props ourselves
            return /*#__PURE__*/ (0, $7fPBF.cloneElement)(element, this.getRootProps($837ff71814b5dbdb$var$getElementProps(element)));
            /* istanbul ignore next */ return undefined;
        };
        return Downshift;
    }((0, $7fPBF.Component));
    Downshift.defaultProps = {
        defaultHighlightedIndex: null,
        defaultIsOpen: false,
        getA11yStatusMessage: $837ff71814b5dbdb$var$getA11yStatusMessage$1,
        itemToString: function itemToString(i) {
            if (i == null) return '';
            return String(i);
        },
        onStateChange: $837ff71814b5dbdb$var$noop,
        onInputValueChange: $837ff71814b5dbdb$var$noop,
        onUserAction: $837ff71814b5dbdb$var$noop,
        onChange: $837ff71814b5dbdb$var$noop,
        onSelect: $837ff71814b5dbdb$var$noop,
        onOuterClick: $837ff71814b5dbdb$var$noop,
        selectedItemChanged: function selectedItemChanged(prevItem, item) {
            return prevItem !== item;
        },
        environment: /* istanbul ignore next (ssr) */ typeof window === 'undefined' ? {} : window,
        stateReducer: function stateReducer(state, stateToSet) {
            return stateToSet;
        },
        suppressRefError: false,
        scrollIntoView: $837ff71814b5dbdb$var$scrollIntoView
    };
    Downshift.stateChangeTypes = $837ff71814b5dbdb$var$stateChangeTypes$3;
    return Downshift;
}();
var $837ff71814b5dbdb$export$2e2bcd8739ae039 = $837ff71814b5dbdb$var$Downshift;
function $837ff71814b5dbdb$var$validateGetMenuPropsCalledCorrectly(node, _ref12) {
    var refKey = _ref12.refKey;
    if (!node) // eslint-disable-next-line no-console
    console.error("downshift: The ref prop \"" + refKey + "\" from getMenuProps was not applied correctly on your menu element.");
}
function $837ff71814b5dbdb$var$validateGetRootPropsCalledCorrectly(element, _ref13) {
    var refKey = _ref13.refKey;
    var refKeySpecified = refKey !== 'ref';
    var isComposite = !$837ff71814b5dbdb$var$isDOMElement(element);
    if (isComposite && !refKeySpecified && !(0, $dddaf6f84c717660$exports.isForwardRef)(element)) // eslint-disable-next-line no-console
    console.error('downshift: You returned a non-DOM element. You must specify a refKey in getRootProps');
    else if (!isComposite && refKeySpecified) // eslint-disable-next-line no-console
    console.error("downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified \"" + refKey + "\"");
    if (!(0, $dddaf6f84c717660$exports.isForwardRef)(element) && !$837ff71814b5dbdb$var$getElementProps(element)[refKey]) // eslint-disable-next-line no-console
    console.error("downshift: You must apply the ref prop \"" + refKey + "\" from getRootProps onto your root element.");
}
var $837ff71814b5dbdb$var$_excluded$3 = [
    "isInitialMount",
    "highlightedIndex",
    "items",
    "environment"
];
var $837ff71814b5dbdb$var$dropdownDefaultStateValues = {
    highlightedIndex: -1,
    isOpen: false,
    selectedItem: null,
    inputValue: ''
};
function $837ff71814b5dbdb$var$callOnChangeProps(action, state, newState) {
    var props = action.props, type = action.type;
    var changes = {};
    Object.keys(state).forEach(function(key) {
        $837ff71814b5dbdb$var$invokeOnChangeHandler(key, action, state, newState);
        if (newState[key] !== state[key]) changes[key] = newState[key];
    });
    if (props.onStateChange && Object.keys(changes).length) props.onStateChange((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        type: type
    }, changes));
}
function $837ff71814b5dbdb$var$invokeOnChangeHandler(key, action, state, newState) {
    var props = action.props, type = action.type;
    var handler = "on" + $837ff71814b5dbdb$var$capitalizeString(key) + "Change";
    if (props[handler] && newState[key] !== undefined && newState[key] !== state[key]) props[handler]((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        type: type
    }, newState));
}
/**
 * Default state reducer that returns the changes.
 *
 * @param {Object} s state.
 * @param {Object} a action with changes.
 * @returns {Object} changes.
 */ function $837ff71814b5dbdb$var$stateReducer(s, a) {
    return a.changes;
}
/**
 * Returns a message to be added to aria-live region when item is selected.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */ function $837ff71814b5dbdb$var$getA11ySelectionMessage(selectionParameters) {
    var selectedItem = selectionParameters.selectedItem, itemToStringLocal = selectionParameters.itemToString;
    return selectedItem ? itemToStringLocal(selectedItem) + " has been selected." : '';
}
/**
 * Debounced call for updating the a11y message.
 */ var $837ff71814b5dbdb$var$updateA11yStatus = $837ff71814b5dbdb$var$debounce(function(getA11yMessage, document1) {
    $837ff71814b5dbdb$var$setStatus(getA11yMessage(), document1);
}, 200);
// istanbul ignore next
var $837ff71814b5dbdb$var$useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $837ff71814b5dbdb$var$useElementIds(_ref) {
    var _ref$id = _ref.id, id = _ref$id === void 0 ? "downshift-" + $837ff71814b5dbdb$var$generateId() : _ref$id, labelId = _ref.labelId, menuId = _ref.menuId, getItemId = _ref.getItemId, toggleButtonId = _ref.toggleButtonId, inputId = _ref.inputId;
    var elementIdsRef = (0, $7fPBF.useRef)({
        labelId: labelId || id + "-label",
        menuId: menuId || id + "-menu",
        getItemId: getItemId || function(index) {
            return id + "-item-" + index;
        },
        toggleButtonId: toggleButtonId || id + "-toggle-button",
        inputId: inputId || id + "-input"
    });
    return elementIdsRef.current;
}
function $837ff71814b5dbdb$var$getItemAndIndex(itemProp, indexProp, items, errorMessage) {
    var item, index;
    if (itemProp === undefined) {
        if (indexProp === undefined) throw new Error(errorMessage);
        item = items[indexProp];
        index = indexProp;
    } else {
        index = indexProp === undefined ? items.indexOf(itemProp) : indexProp;
        item = itemProp;
    }
    return [
        item,
        index
    ];
}
function $837ff71814b5dbdb$var$itemToString(item) {
    return item ? String(item) : '';
}
function $837ff71814b5dbdb$var$isAcceptedCharacterKey(key) {
    return /^\S{1}$/.test(key);
}
function $837ff71814b5dbdb$var$capitalizeString(string) {
    return "" + string.slice(0, 1).toUpperCase() + string.slice(1);
}
function $837ff71814b5dbdb$var$useLatestRef(val) {
    var ref = (0, $7fPBF.useRef)(val);
    // technically this is not "concurrent mode safe" because we're manipulating
    // the value during render (so it's not idempotent). However, the places this
    // hook is used is to support memoizing callbacks which will be called
    // *during* render, so we need the latest values *during* render.
    // If not for this, then we'd probably want to use useLayoutEffect instead.
    ref.current = val;
    return ref;
}
/**
 * Computes the controlled state using a the previous state, props,
 * two reducers, one from downshift and an optional one from the user.
 * Also calls the onChange handlers for state values that have changed.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $837ff71814b5dbdb$var$useEnhancedReducer(reducer, initialState, props) {
    var prevStateRef = (0, $7fPBF.useRef)();
    var actionRef = (0, $7fPBF.useRef)();
    var enhancedReducer = (0, $7fPBF.useCallback)(function(state, action) {
        actionRef.current = action;
        state = $837ff71814b5dbdb$var$getState(state, action.props);
        var changes = reducer(state, action);
        var newState = action.props.stateReducer(state, (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, action, {
            changes: changes
        }));
        return newState;
    }, [
        reducer
    ]);
    var _useReducer = (0, $7fPBF.useReducer)(enhancedReducer, initialState), state = _useReducer[0], dispatch = _useReducer[1];
    var propsRef = $837ff71814b5dbdb$var$useLatestRef(props);
    var dispatchWithProps = (0, $7fPBF.useCallback)(function(action) {
        return dispatch((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            props: propsRef.current
        }, action));
    }, [
        propsRef
    ]);
    var action = actionRef.current;
    (0, $7fPBF.useEffect)(function() {
        if (action && prevStateRef.current && prevStateRef.current !== state) $837ff71814b5dbdb$var$callOnChangeProps(action, $837ff71814b5dbdb$var$getState(prevStateRef.current, action.props), state);
        prevStateRef.current = state;
    }, [
        state,
        props,
        action
    ]);
    return [
        state,
        dispatchWithProps
    ];
}
/**
 * Wraps the useEnhancedReducer and applies the controlled prop values before
 * returning the new state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $837ff71814b5dbdb$var$useControlledReducer$1(reducer, initialState, props) {
    var _useEnhancedReducer = $837ff71814b5dbdb$var$useEnhancedReducer(reducer, initialState, props), state = _useEnhancedReducer[0], dispatch = _useEnhancedReducer[1];
    return [
        $837ff71814b5dbdb$var$getState(state, props),
        dispatch
    ];
}
var $837ff71814b5dbdb$var$defaultProps$3 = {
    itemToString: $837ff71814b5dbdb$var$itemToString,
    stateReducer: $837ff71814b5dbdb$var$stateReducer,
    getA11ySelectionMessage: $837ff71814b5dbdb$var$getA11ySelectionMessage,
    scrollIntoView: $837ff71814b5dbdb$var$scrollIntoView,
    environment: /* istanbul ignore next (ssr) */ typeof window === 'undefined' ? {} : window
};
function $837ff71814b5dbdb$var$getDefaultValue$1(props, propKey, defaultStateValues) {
    if (defaultStateValues === void 0) defaultStateValues = $837ff71814b5dbdb$var$dropdownDefaultStateValues;
    var defaultValue = props["default" + $837ff71814b5dbdb$var$capitalizeString(propKey)];
    if (defaultValue !== undefined) return defaultValue;
    return defaultStateValues[propKey];
}
function $837ff71814b5dbdb$var$getInitialValue$1(props, propKey, defaultStateValues) {
    if (defaultStateValues === void 0) defaultStateValues = $837ff71814b5dbdb$var$dropdownDefaultStateValues;
    var value = props[propKey];
    if (value !== undefined) return value;
    var initialValue = props["initial" + $837ff71814b5dbdb$var$capitalizeString(propKey)];
    if (initialValue !== undefined) return initialValue;
    return $837ff71814b5dbdb$var$getDefaultValue$1(props, propKey, defaultStateValues);
}
function $837ff71814b5dbdb$var$getInitialState$2(props) {
    var selectedItem = $837ff71814b5dbdb$var$getInitialValue$1(props, 'selectedItem');
    var isOpen = $837ff71814b5dbdb$var$getInitialValue$1(props, 'isOpen');
    var highlightedIndex = $837ff71814b5dbdb$var$getInitialValue$1(props, 'highlightedIndex');
    var inputValue = $837ff71814b5dbdb$var$getInitialValue$1(props, 'inputValue');
    return {
        highlightedIndex: highlightedIndex < 0 && selectedItem && isOpen ? props.items.indexOf(selectedItem) : highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
function $837ff71814b5dbdb$var$getHighlightedIndexOnOpen(props, state, offset) {
    var items = props.items, initialHighlightedIndex = props.initialHighlightedIndex, defaultHighlightedIndex = props.defaultHighlightedIndex;
    var selectedItem = state.selectedItem, highlightedIndex = state.highlightedIndex;
    if (items.length === 0) return -1;
    // initialHighlightedIndex will give value to highlightedIndex on initial state only.
    if (initialHighlightedIndex !== undefined && highlightedIndex === initialHighlightedIndex) return initialHighlightedIndex;
    if (defaultHighlightedIndex !== undefined) return defaultHighlightedIndex;
    if (selectedItem) return items.indexOf(selectedItem);
    if (offset === 0) return -1;
    return offset < 0 ? items.length - 1 : 0;
}
/**
 * Reuse the movement tracking of mouse and touch events.
 *
 * @param {boolean} isOpen Whether the dropdown is open or not.
 * @param {Array<Object>} downshiftElementRefs Downshift element refs to track movement (toggleButton, menu etc.)
 * @param {Object} environment Environment where component/hook exists.
 * @param {Function} handleBlur Handler on blur from mouse or touch.
 * @returns {Object} Ref containing whether mouseDown or touchMove event is happening
 */ function $837ff71814b5dbdb$var$useMouseAndTouchTracker(isOpen, downshiftElementRefs, environment, handleBlur) {
    var mouseAndTouchTrackersRef = (0, $7fPBF.useRef)({
        isMouseDown: false,
        isTouchMove: false
    });
    (0, $7fPBF.useEffect)(function() {
        if ((environment == null ? void 0 : environment.addEventListener) == null) return;
        // The same strategy for checking if a click occurred inside or outside downshift
        // as in downshift.js.
        var onMouseDown = function onMouseDown() {
            mouseAndTouchTrackersRef.current.isMouseDown = true;
        };
        var onMouseUp = function onMouseUp(event) {
            mouseAndTouchTrackersRef.current.isMouseDown = false;
            if (isOpen && !$837ff71814b5dbdb$var$targetWithinDownshift(event.target, downshiftElementRefs.map(function(ref) {
                return ref.current;
            }), environment)) handleBlur();
        };
        var onTouchStart = function onTouchStart() {
            mouseAndTouchTrackersRef.current.isTouchMove = false;
        };
        var onTouchMove = function onTouchMove() {
            mouseAndTouchTrackersRef.current.isTouchMove = true;
        };
        var onTouchEnd = function onTouchEnd(event) {
            if (isOpen && !mouseAndTouchTrackersRef.current.isTouchMove && !$837ff71814b5dbdb$var$targetWithinDownshift(event.target, downshiftElementRefs.map(function(ref) {
                return ref.current;
            }), environment, false)) handleBlur();
        };
        environment.addEventListener('mousedown', onMouseDown);
        environment.addEventListener('mouseup', onMouseUp);
        environment.addEventListener('touchstart', onTouchStart);
        environment.addEventListener('touchmove', onTouchMove);
        environment.addEventListener('touchend', onTouchEnd);
        // eslint-disable-next-line consistent-return
        return function cleanup() {
            environment.removeEventListener('mousedown', onMouseDown);
            environment.removeEventListener('mouseup', onMouseUp);
            environment.removeEventListener('touchstart', onTouchStart);
            environment.removeEventListener('touchmove', onTouchMove);
            environment.removeEventListener('touchend', onTouchEnd);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isOpen,
        environment
    ]);
    return mouseAndTouchTrackersRef;
}
/* istanbul ignore next */ // eslint-disable-next-line import/no-mutable-exports
var $837ff71814b5dbdb$var$useGetterPropsCalledChecker = function useGetterPropsCalledChecker() {
    return $837ff71814b5dbdb$var$noop;
};
function $837ff71814b5dbdb$var$useA11yMessageSetter(getA11yMessage, dependencyArray, _ref2) {
    var isInitialMount = _ref2.isInitialMount, highlightedIndex = _ref2.highlightedIndex, items = _ref2.items, environment = _ref2.environment, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref2, $837ff71814b5dbdb$var$_excluded$3);
    // Sets a11y status message on changes in state.
    (0, $7fPBF.useEffect)(function() {
        if (isInitialMount || false) return;
        $837ff71814b5dbdb$var$updateA11yStatus(function() {
            return getA11yMessage((0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                highlightedIndex: highlightedIndex,
                highlightedItem: items[highlightedIndex],
                resultCount: items.length
            }, rest));
        }, environment.document);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, dependencyArray);
}
function $837ff71814b5dbdb$var$useScrollIntoView(_ref3) {
    var highlightedIndex = _ref3.highlightedIndex, isOpen = _ref3.isOpen, itemRefs = _ref3.itemRefs, getItemNodeFromIndex = _ref3.getItemNodeFromIndex, menuElement = _ref3.menuElement, scrollIntoViewProp = _ref3.scrollIntoView;
    // used not to scroll on highlight by mouse.
    var shouldScrollRef = (0, $7fPBF.useRef)(true);
    // Scroll on highlighted item if change comes from keyboard.
    $837ff71814b5dbdb$var$useIsomorphicLayoutEffect(function() {
        if (highlightedIndex < 0 || !isOpen || !Object.keys(itemRefs.current).length) return;
        if (shouldScrollRef.current === false) shouldScrollRef.current = true;
        else scrollIntoViewProp(getItemNodeFromIndex(highlightedIndex), menuElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        highlightedIndex
    ]);
    return shouldScrollRef;
}
// eslint-disable-next-line import/no-mutable-exports
var $837ff71814b5dbdb$var$useControlPropsValidator = $837ff71814b5dbdb$var$noop;
/**
 * Handles selection on Enter / Alt + ArrowUp. Closes the menu and resets the highlighted index, unless there is a highlighted.
 * In that case, selects the item and resets to defaults for open state and highlighted idex.
 * @param {Object} props The useCombobox props.
 * @param {number} highlightedIndex The index from the state.
 * @param {boolean} inputValue Also return the input value for state.
 * @returns The changes for the state.
 */ function $837ff71814b5dbdb$var$getChangesOnSelection(props, highlightedIndex, inputValue) {
    var _props$items;
    if (inputValue === void 0) inputValue = true;
    var shouldSelect = ((_props$items = props.items) == null ? void 0 : _props$items.length) && highlightedIndex >= 0;
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        isOpen: false,
        highlightedIndex: -1
    }, shouldSelect && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        selectedItem: props.items[highlightedIndex],
        isOpen: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'isOpen'),
        highlightedIndex: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'highlightedIndex')
    }, inputValue && {
        inputValue: props.itemToString(props.items[highlightedIndex])
    }));
}
function $837ff71814b5dbdb$var$downshiftCommonReducer(state, action, stateChangeTypes) {
    var type = action.type, props = action.props;
    var changes;
    switch(type){
        case stateChangeTypes.ItemMouseMove:
            changes = {
                highlightedIndex: action.disabled ? -1 : action.index
            };
            break;
        case stateChangeTypes.MenuMouseLeave:
            changes = {
                highlightedIndex: -1
            };
            break;
        case stateChangeTypes.ToggleButtonClick:
        case stateChangeTypes.FunctionToggleMenu:
            changes = {
                isOpen: !state.isOpen,
                highlightedIndex: state.isOpen ? -1 : $837ff71814b5dbdb$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case stateChangeTypes.FunctionOpenMenu:
            changes = {
                isOpen: true,
                highlightedIndex: $837ff71814b5dbdb$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case stateChangeTypes.FunctionCloseMenu:
            changes = {
                isOpen: false
            };
            break;
        case stateChangeTypes.FunctionSetHighlightedIndex:
            changes = {
                highlightedIndex: action.highlightedIndex
            };
            break;
        case stateChangeTypes.FunctionSetInputValue:
            changes = {
                inputValue: action.inputValue
            };
            break;
        case stateChangeTypes.FunctionReset:
            changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'highlightedIndex'),
                isOpen: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'isOpen'),
                selectedItem: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'selectedItem'),
                inputValue: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'inputValue')
            };
            break;
        default:
            throw new Error('Reducer called without proper action type.');
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, changes);
}
/* eslint-enable complexity */ function $837ff71814b5dbdb$var$getItemIndexByCharacterKey(_a) {
    var keysSoFar = _a.keysSoFar, highlightedIndex = _a.highlightedIndex, items = _a.items, itemToString = _a.itemToString, getItemNodeFromIndex = _a.getItemNodeFromIndex;
    var lowerCasedKeysSoFar = keysSoFar.toLowerCase();
    for(var index = 0; index < items.length; index++){
        // if we already have a search query in progress, we also consider the current highlighted item.
        var offsetIndex = (index + highlightedIndex + (keysSoFar.length < 2 ? 1 : 0)) % items.length;
        var item = items[offsetIndex];
        if (item !== undefined && itemToString(item).toLowerCase().startsWith(lowerCasedKeysSoFar)) {
            var element = getItemNodeFromIndex(offsetIndex);
            if (!(element === null || element === void 0 ? void 0 : element.hasAttribute('disabled'))) return offsetIndex;
        }
    }
    return highlightedIndex;
}
var $837ff71814b5dbdb$var$propTypes$2 = {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    getA11yStatusMessage: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    getA11ySelectionMessage: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    highlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    defaultHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    initialHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    defaultIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    initialIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    selectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    initialSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    defaultSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    labelId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    menuId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    getItemId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    toggleButtonId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onSelectedItemChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onHighlightedIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onIsOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any
        })
    })
};
/**
 * Default implementation for status message. Only added when menu is open.
 * Will specift if there are results in the list, and if so, how many,
 * and what keys are relevant.
 *
 * @param {Object} param the downshift state and other relevant properties
 * @return {String} the a11y status message
 */ function $837ff71814b5dbdb$var$getA11yStatusMessage(_a) {
    var isOpen = _a.isOpen, resultCount = _a.resultCount, previousResultCount = _a.previousResultCount;
    if (!isOpen) return '';
    if (!resultCount) return 'No results are available.';
    if (resultCount !== previousResultCount) return "".concat(resultCount, " result").concat(resultCount === 1 ? ' is' : 's are', " available, use up and down arrow keys to navigate. Press Enter or Space Bar keys to select.");
    return '';
}
var $837ff71814b5dbdb$var$defaultProps$2 = (0, $75d33c26c5e72e04$export$18ce0697a983be9b)((0, $75d33c26c5e72e04$export$18ce0697a983be9b)({}, $837ff71814b5dbdb$var$defaultProps$3), {
    getA11yStatusMessage: $837ff71814b5dbdb$var$getA11yStatusMessage
});
// eslint-disable-next-line import/no-mutable-exports
var $837ff71814b5dbdb$var$validatePropTypes$2 = $837ff71814b5dbdb$var$noop;
var $837ff71814b5dbdb$var$ToggleButtonClick$1 = 0;
var $837ff71814b5dbdb$var$ToggleButtonKeyDownArrowDown = 1;
var $837ff71814b5dbdb$var$ToggleButtonKeyDownArrowUp = 2;
var $837ff71814b5dbdb$var$ToggleButtonKeyDownCharacter = 3;
var $837ff71814b5dbdb$var$ToggleButtonKeyDownEscape = 4;
var $837ff71814b5dbdb$var$ToggleButtonKeyDownHome = 5;
var $837ff71814b5dbdb$var$ToggleButtonKeyDownEnd = 6;
var $837ff71814b5dbdb$var$ToggleButtonKeyDownEnter = 7;
var $837ff71814b5dbdb$var$ToggleButtonKeyDownSpaceButton = 8;
var $837ff71814b5dbdb$var$ToggleButtonKeyDownPageUp = 9;
var $837ff71814b5dbdb$var$ToggleButtonKeyDownPageDown = 10;
var $837ff71814b5dbdb$var$ToggleButtonBlur = 11;
var $837ff71814b5dbdb$var$MenuMouseLeave$1 = 12;
var $837ff71814b5dbdb$var$ItemMouseMove$1 = 13;
var $837ff71814b5dbdb$var$ItemClick$1 = 14;
var $837ff71814b5dbdb$var$FunctionToggleMenu$1 = 15;
var $837ff71814b5dbdb$var$FunctionOpenMenu$1 = 16;
var $837ff71814b5dbdb$var$FunctionCloseMenu$1 = 17;
var $837ff71814b5dbdb$var$FunctionSetHighlightedIndex$1 = 18;
var $837ff71814b5dbdb$var$FunctionSelectItem$1 = 19;
var $837ff71814b5dbdb$var$FunctionSetInputValue$1 = 20;
var $837ff71814b5dbdb$var$FunctionReset$2 = 21;
var $837ff71814b5dbdb$var$stateChangeTypes$2 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ToggleButtonClick: $837ff71814b5dbdb$var$ToggleButtonClick$1,
    ToggleButtonKeyDownArrowDown: $837ff71814b5dbdb$var$ToggleButtonKeyDownArrowDown,
    ToggleButtonKeyDownArrowUp: $837ff71814b5dbdb$var$ToggleButtonKeyDownArrowUp,
    ToggleButtonKeyDownCharacter: $837ff71814b5dbdb$var$ToggleButtonKeyDownCharacter,
    ToggleButtonKeyDownEscape: $837ff71814b5dbdb$var$ToggleButtonKeyDownEscape,
    ToggleButtonKeyDownHome: $837ff71814b5dbdb$var$ToggleButtonKeyDownHome,
    ToggleButtonKeyDownEnd: $837ff71814b5dbdb$var$ToggleButtonKeyDownEnd,
    ToggleButtonKeyDownEnter: $837ff71814b5dbdb$var$ToggleButtonKeyDownEnter,
    ToggleButtonKeyDownSpaceButton: $837ff71814b5dbdb$var$ToggleButtonKeyDownSpaceButton,
    ToggleButtonKeyDownPageUp: $837ff71814b5dbdb$var$ToggleButtonKeyDownPageUp,
    ToggleButtonKeyDownPageDown: $837ff71814b5dbdb$var$ToggleButtonKeyDownPageDown,
    ToggleButtonBlur: $837ff71814b5dbdb$var$ToggleButtonBlur,
    MenuMouseLeave: $837ff71814b5dbdb$var$MenuMouseLeave$1,
    ItemMouseMove: $837ff71814b5dbdb$var$ItemMouseMove$1,
    ItemClick: $837ff71814b5dbdb$var$ItemClick$1,
    FunctionToggleMenu: $837ff71814b5dbdb$var$FunctionToggleMenu$1,
    FunctionOpenMenu: $837ff71814b5dbdb$var$FunctionOpenMenu$1,
    FunctionCloseMenu: $837ff71814b5dbdb$var$FunctionCloseMenu$1,
    FunctionSetHighlightedIndex: $837ff71814b5dbdb$var$FunctionSetHighlightedIndex$1,
    FunctionSelectItem: $837ff71814b5dbdb$var$FunctionSelectItem$1,
    FunctionSetInputValue: $837ff71814b5dbdb$var$FunctionSetInputValue$1,
    FunctionReset: $837ff71814b5dbdb$var$FunctionReset$2
});
/* eslint-disable complexity */ function $837ff71814b5dbdb$var$downshiftSelectReducer(state, action) {
    var _props$items;
    var type = action.type, props = action.props, altKey = action.altKey;
    var changes;
    switch(type){
        case $837ff71814b5dbdb$var$ItemClick$1:
            changes = {
                isOpen: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'isOpen'),
                highlightedIndex: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'highlightedIndex'),
                selectedItem: props.items[action.index]
            };
            break;
        case $837ff71814b5dbdb$var$ToggleButtonKeyDownCharacter:
            var lowercasedKey = action.key;
            var inputValue = "" + state.inputValue + lowercasedKey;
            var prevHighlightedIndex = !state.isOpen && state.selectedItem ? props.items.indexOf(state.selectedItem) : state.highlightedIndex;
            var highlightedIndex = $837ff71814b5dbdb$var$getItemIndexByCharacterKey({
                keysSoFar: inputValue,
                highlightedIndex: prevHighlightedIndex,
                items: props.items,
                itemToString: props.itemToString,
                getItemNodeFromIndex: action.getItemNodeFromIndex
            });
            changes = {
                inputValue: inputValue,
                highlightedIndex: highlightedIndex,
                isOpen: true
            };
            break;
        case $837ff71814b5dbdb$var$ToggleButtonKeyDownArrowDown:
            var _highlightedIndex = state.isOpen ? $837ff71814b5dbdb$var$getNextWrappingIndex(1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false) : altKey && state.selectedItem == null ? -1 : $837ff71814b5dbdb$var$getHighlightedIndexOnOpen(props, state, 1);
            changes = {
                highlightedIndex: _highlightedIndex,
                isOpen: true
            };
            break;
        case $837ff71814b5dbdb$var$ToggleButtonKeyDownArrowUp:
            if (state.isOpen && altKey) changes = $837ff71814b5dbdb$var$getChangesOnSelection(props, state.highlightedIndex, false);
            else {
                var _highlightedIndex2 = state.isOpen ? $837ff71814b5dbdb$var$getNextWrappingIndex(-1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false) : $837ff71814b5dbdb$var$getHighlightedIndexOnOpen(props, state, -1);
                changes = {
                    highlightedIndex: _highlightedIndex2,
                    isOpen: true
                };
            }
            break;
        // only triggered when menu is open.
        case $837ff71814b5dbdb$var$ToggleButtonKeyDownEnter:
        case $837ff71814b5dbdb$var$ToggleButtonKeyDownSpaceButton:
            changes = $837ff71814b5dbdb$var$getChangesOnSelection(props, state.highlightedIndex, false);
            break;
        case $837ff71814b5dbdb$var$ToggleButtonKeyDownHome:
            changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false),
                isOpen: true
            };
            break;
        case $837ff71814b5dbdb$var$ToggleButtonKeyDownEnd:
            changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false),
                isOpen: true
            };
            break;
        case $837ff71814b5dbdb$var$ToggleButtonKeyDownPageUp:
            changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getNextWrappingIndex(-10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $837ff71814b5dbdb$var$ToggleButtonKeyDownPageDown:
            changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getNextWrappingIndex(10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $837ff71814b5dbdb$var$ToggleButtonKeyDownEscape:
            changes = {
                isOpen: false,
                highlightedIndex: -1
            };
            break;
        case $837ff71814b5dbdb$var$ToggleButtonBlur:
            changes = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                isOpen: false,
                highlightedIndex: -1
            }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && {
                selectedItem: props.items[state.highlightedIndex]
            });
            break;
        case $837ff71814b5dbdb$var$FunctionSelectItem$1:
            changes = {
                selectedItem: action.selectedItem
            };
            break;
        default:
            return $837ff71814b5dbdb$var$downshiftCommonReducer(state, action, $837ff71814b5dbdb$var$stateChangeTypes$2);
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, changes);
}
/* eslint-enable complexity */ var $837ff71814b5dbdb$var$_excluded$2 = [
    "onMouseLeave",
    "refKey",
    "onKeyDown",
    "onBlur",
    "ref"
], $837ff71814b5dbdb$var$_excluded2$2 = [
    "onBlur",
    "onClick",
    "onPress",
    "onKeyDown",
    "refKey",
    "ref"
], $837ff71814b5dbdb$var$_excluded3$1 = [
    "item",
    "index",
    "onMouseMove",
    "onClick",
    "onPress",
    "refKey",
    "ref",
    "disabled"
];
$837ff71814b5dbdb$export$e64b2f635402ca43.stateChangeTypes = $837ff71814b5dbdb$var$stateChangeTypes$2;
function $837ff71814b5dbdb$export$e64b2f635402ca43(userProps) {
    if (userProps === void 0) userProps = {};
    $837ff71814b5dbdb$var$validatePropTypes$2(userProps, $837ff71814b5dbdb$export$e64b2f635402ca43);
    // Props defaults and destructuring.
    var props = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $837ff71814b5dbdb$var$defaultProps$2, userProps);
    var items = props.items, scrollIntoView = props.scrollIntoView, environment = props.environment, itemToString = props.itemToString, getA11ySelectionMessage = props.getA11ySelectionMessage, getA11yStatusMessage = props.getA11yStatusMessage;
    // Initial state depending on controlled props.
    var initialState = $837ff71814b5dbdb$var$getInitialState$2(props);
    var _useControlledReducer = $837ff71814b5dbdb$var$useControlledReducer$1($837ff71814b5dbdb$var$downshiftSelectReducer, initialState, props), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
    var isOpen = state.isOpen, highlightedIndex = state.highlightedIndex, selectedItem = state.selectedItem, inputValue = state.inputValue;
    // Element efs.
    var toggleButtonRef = (0, $7fPBF.useRef)(null);
    var menuRef = (0, $7fPBF.useRef)(null);
    var itemRefs = (0, $7fPBF.useRef)({});
    // used to keep the inputValue clearTimeout object between renders.
    var clearTimeoutRef = (0, $7fPBF.useRef)(null);
    // prevent id re-generation between renders.
    var elementIds = $837ff71814b5dbdb$var$useElementIds(props);
    // used to keep track of how many items we had on previous cycle.
    var previousResultCountRef = (0, $7fPBF.useRef)();
    var isInitialMountRef = (0, $7fPBF.useRef)(true);
    // utility callback to get item element.
    var latest = $837ff71814b5dbdb$var$useLatestRef({
        state: state,
        props: props
    });
    // Some utils.
    var getItemNodeFromIndex = (0, $7fPBF.useCallback)(function(index) {
        return itemRefs.current[elementIds.getItemId(index)];
    }, [
        elementIds
    ]);
    // Effects.
    // Sets a11y status message on changes in state.
    $837ff71814b5dbdb$var$useA11yMessageSetter(getA11yStatusMessage, [
        isOpen,
        highlightedIndex,
        inputValue,
        items
    ], (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString
    }, state));
    // Sets a11y status message on changes in selectedItem.
    $837ff71814b5dbdb$var$useA11yMessageSetter(getA11ySelectionMessage, [
        selectedItem
    ], (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString
    }, state));
    // Scroll on highlighted item if change comes from keyboard.
    var shouldScrollRef = $837ff71814b5dbdb$var$useScrollIntoView({
        menuElement: menuRef.current,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        itemRefs: itemRefs,
        scrollIntoView: scrollIntoView,
        getItemNodeFromIndex: getItemNodeFromIndex
    });
    // Sets cleanup for the keysSoFar callback, debounded after 500ms.
    (0, $7fPBF.useEffect)(function() {
        // init the clean function here as we need access to dispatch.
        clearTimeoutRef.current = $837ff71814b5dbdb$var$debounce(function(outerDispatch) {
            outerDispatch({
                type: $837ff71814b5dbdb$var$FunctionSetInputValue$1,
                inputValue: ''
            });
        }, 500);
        // Cancel any pending debounced calls on mount
        return function() {
            clearTimeoutRef.current.cancel();
        };
    }, []);
    // Invokes the keysSoFar callback set up above.
    (0, $7fPBF.useEffect)(function() {
        if (!inputValue) return;
        clearTimeoutRef.current(dispatch);
    }, [
        dispatch,
        inputValue
    ]);
    $837ff71814b5dbdb$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    });
    (0, $7fPBF.useEffect)(function() {
        if (isInitialMountRef.current) return;
        previousResultCountRef.current = items.length;
    });
    // Add mouse/touch events to document.
    var mouseAndTouchTrackersRef = $837ff71814b5dbdb$var$useMouseAndTouchTracker(isOpen, [
        menuRef,
        toggleButtonRef
    ], environment, function() {
        dispatch({
            type: $837ff71814b5dbdb$var$ToggleButtonBlur
        });
    });
    var setGetterPropCallInfo = $837ff71814b5dbdb$var$useGetterPropsCalledChecker('getMenuProps', 'getToggleButtonProps');
    // Make initial ref false.
    (0, $7fPBF.useEffect)(function() {
        isInitialMountRef.current = false;
        return function() {
            isInitialMountRef.current = true;
        };
    }, []);
    // Reset itemRefs on close.
    (0, $7fPBF.useEffect)(function() {
        if (!isOpen) itemRefs.current = {};
    }, [
        isOpen
    ]);
    // Event handler functions.
    var toggleButtonKeyDownHandlers = (0, $7fPBF.useMemo)(function() {
        return {
            ArrowDown: function ArrowDown(event) {
                event.preventDefault();
                dispatch({
                    type: $837ff71814b5dbdb$var$ToggleButtonKeyDownArrowDown,
                    getItemNodeFromIndex: getItemNodeFromIndex,
                    altKey: event.altKey
                });
            },
            ArrowUp: function ArrowUp(event) {
                event.preventDefault();
                dispatch({
                    type: $837ff71814b5dbdb$var$ToggleButtonKeyDownArrowUp,
                    getItemNodeFromIndex: getItemNodeFromIndex,
                    altKey: event.altKey
                });
            },
            Home: function Home(event) {
                event.preventDefault();
                dispatch({
                    type: $837ff71814b5dbdb$var$ToggleButtonKeyDownHome,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            End: function End(event) {
                event.preventDefault();
                dispatch({
                    type: $837ff71814b5dbdb$var$ToggleButtonKeyDownEnd,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            Escape: function Escape() {
                if (latest.current.state.isOpen) dispatch({
                    type: $837ff71814b5dbdb$var$ToggleButtonKeyDownEscape
                });
            },
            Enter: function Enter(event) {
                event.preventDefault();
                dispatch({
                    type: latest.current.state.isOpen ? $837ff71814b5dbdb$var$ToggleButtonKeyDownEnter : $837ff71814b5dbdb$var$ToggleButtonClick$1
                });
            },
            PageUp: function PageUp(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $837ff71814b5dbdb$var$ToggleButtonKeyDownPageUp,
                        getItemNodeFromIndex: getItemNodeFromIndex
                    });
                }
            },
            PageDown: function PageDown(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $837ff71814b5dbdb$var$ToggleButtonKeyDownPageDown,
                        getItemNodeFromIndex: getItemNodeFromIndex
                    });
                }
            },
            ' ': function _(event) {
                event.preventDefault();
                var currentState = latest.current.state;
                if (!currentState.isOpen) {
                    dispatch({
                        type: $837ff71814b5dbdb$var$ToggleButtonClick$1
                    });
                    return;
                }
                if (currentState.inputValue) dispatch({
                    type: $837ff71814b5dbdb$var$ToggleButtonKeyDownCharacter,
                    key: ' ',
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
                else dispatch({
                    type: $837ff71814b5dbdb$var$ToggleButtonKeyDownSpaceButton
                });
            }
        };
    }, [
        dispatch,
        getItemNodeFromIndex,
        latest
    ]);
    // Action functions.
    var toggleMenu = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionToggleMenu$1
        });
    }, [
        dispatch
    ]);
    var closeMenu = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionCloseMenu$1
        });
    }, [
        dispatch
    ]);
    var openMenu = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionOpenMenu$1
        });
    }, [
        dispatch
    ]);
    var setHighlightedIndex = (0, $7fPBF.useCallback)(function(newHighlightedIndex) {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionSetHighlightedIndex$1,
            highlightedIndex: newHighlightedIndex
        });
    }, [
        dispatch
    ]);
    var selectItem = (0, $7fPBF.useCallback)(function(newSelectedItem) {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionSelectItem$1,
            selectedItem: newSelectedItem
        });
    }, [
        dispatch
    ]);
    var reset = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionReset$2
        });
    }, [
        dispatch
    ]);
    var setInputValue = (0, $7fPBF.useCallback)(function(newInputValue) {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionSetInputValue$1,
            inputValue: newInputValue
        });
    }, [
        dispatch
    ]);
    // Getter functions.
    var getLabelProps = (0, $7fPBF.useCallback)(function(labelProps) {
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            id: elementIds.labelId,
            htmlFor: elementIds.toggleButtonId
        }, labelProps);
    }, [
        elementIds
    ]);
    var getMenuProps = (0, $7fPBF.useCallback)(function(_temp, _temp2) {
        var _extends2;
        var _ref = _temp === void 0 ? {} : _temp, onMouseLeave = _ref.onMouseLeave, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey;
        _ref.onKeyDown;
        _ref.onBlur;
        var ref = _ref.ref, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $837ff71814b5dbdb$var$_excluded$2);
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
        var menuHandleMouseLeave = function menuHandleMouseLeave() {
            dispatch({
                type: $837ff71814b5dbdb$var$MenuMouseLeave$1
            });
        };
        setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, function(menuNode) {
            menuRef.current = menuNode;
        }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends2.onMouseLeave = $837ff71814b5dbdb$var$callAllEventHandlers(onMouseLeave, menuHandleMouseLeave), _extends2), rest);
    }, [
        dispatch,
        setGetterPropCallInfo,
        elementIds
    ]);
    var getToggleButtonProps = (0, $7fPBF.useCallback)(function(_temp3, _temp4) {
        var _extends3;
        var _ref3 = _temp3 === void 0 ? {} : _temp3, onBlur = _ref3.onBlur, onClick = _ref3.onClick;
        _ref3.onPress;
        var onKeyDown = _ref3.onKeyDown, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey, ref = _ref3.ref, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref3, $837ff71814b5dbdb$var$_excluded2$2);
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$suppressRefErro = _ref4.suppressRefError, suppressRefError = _ref4$suppressRefErro === void 0 ? false : _ref4$suppressRefErro;
        var latestState = latest.current.state;
        var toggleButtonHandleClick = function toggleButtonHandleClick() {
            dispatch({
                type: $837ff71814b5dbdb$var$ToggleButtonClick$1
            });
        };
        var toggleButtonHandleBlur = function toggleButtonHandleBlur() {
            if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) dispatch({
                type: $837ff71814b5dbdb$var$ToggleButtonBlur
            });
        };
        var toggleButtonHandleKeyDown = function toggleButtonHandleKeyDown(event) {
            var key = $837ff71814b5dbdb$var$normalizeArrowKey(event);
            if (key && toggleButtonKeyDownHandlers[key]) toggleButtonKeyDownHandlers[key](event);
            else if ($837ff71814b5dbdb$var$isAcceptedCharacterKey(key)) dispatch({
                type: $837ff71814b5dbdb$var$ToggleButtonKeyDownCharacter,
                key: key,
                getItemNodeFromIndex: getItemNodeFromIndex
            });
        };
        var toggleProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends3 = {}, _extends3[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, function(toggleButtonNode) {
            toggleButtonRef.current = toggleButtonNode;
        }), _extends3['aria-activedescendant'] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : '', _extends3['aria-controls'] = elementIds.menuId, _extends3['aria-expanded'] = latest.current.state.isOpen, _extends3['aria-haspopup'] = 'listbox', _extends3['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends3.id = elementIds.toggleButtonId, _extends3.role = 'combobox', _extends3.tabIndex = 0, _extends3.onBlur = $837ff71814b5dbdb$var$callAllEventHandlers(onBlur, toggleButtonHandleBlur), _extends3), rest);
        if (!rest.disabled) {
            toggleProps.onClick = $837ff71814b5dbdb$var$callAllEventHandlers(onClick, toggleButtonHandleClick);
            toggleProps.onKeyDown = $837ff71814b5dbdb$var$callAllEventHandlers(onKeyDown, toggleButtonHandleKeyDown);
        }
        setGetterPropCallInfo('getToggleButtonProps', suppressRefError, refKey, toggleButtonRef);
        return toggleProps;
    }, [
        latest,
        elementIds,
        setGetterPropCallInfo,
        dispatch,
        mouseAndTouchTrackersRef,
        toggleButtonKeyDownHandlers,
        getItemNodeFromIndex
    ]);
    var getItemProps = (0, $7fPBF.useCallback)(function(_temp5) {
        var _extends4;
        var _ref5 = _temp5 === void 0 ? {} : _temp5, itemProp = _ref5.item, indexProp = _ref5.index, onMouseMove = _ref5.onMouseMove, onClick = _ref5.onClick;
        _ref5.onPress;
        var _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey, ref = _ref5.ref, disabled = _ref5.disabled, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref5, $837ff71814b5dbdb$var$_excluded3$1);
        var _latest$current = latest.current, latestState = _latest$current.state, latestProps = _latest$current.props;
        var _getItemAndIndex = $837ff71814b5dbdb$var$getItemAndIndex(itemProp, indexProp, latestProps.items, 'Pass either item or index to getItemProps!'), item = _getItemAndIndex[0], index = _getItemAndIndex[1];
        var itemHandleMouseMove = function itemHandleMouseMove() {
            if (index === latestState.highlightedIndex) return;
            shouldScrollRef.current = false;
            dispatch({
                type: $837ff71814b5dbdb$var$ItemMouseMove$1,
                index: index,
                disabled: disabled
            });
        };
        var itemHandleClick = function itemHandleClick() {
            dispatch({
                type: $837ff71814b5dbdb$var$ItemClick$1,
                index: index
            });
        };
        var itemProps = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends4 = {
            disabled: disabled,
            role: 'option',
            'aria-selected': "" + (item === selectedItem),
            id: elementIds.getItemId(index)
        }, _extends4[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, function(itemNode) {
            if (itemNode) itemRefs.current[elementIds.getItemId(index)] = itemNode;
        }), _extends4), rest);
        if (!disabled) itemProps.onClick = $837ff71814b5dbdb$var$callAllEventHandlers(onClick, itemHandleClick);
        itemProps.onMouseMove = $837ff71814b5dbdb$var$callAllEventHandlers(onMouseMove, itemHandleMouseMove);
        return itemProps;
    }, [
        latest,
        selectedItem,
        elementIds,
        shouldScrollRef,
        dispatch
    ]);
    return {
        // prop getters.
        getToggleButtonProps: getToggleButtonProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getItemProps: getItemProps,
        // actions.
        toggleMenu: toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu,
        setHighlightedIndex: setHighlightedIndex,
        selectItem: selectItem,
        reset: reset,
        setInputValue: setInputValue,
        // state.
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
var $837ff71814b5dbdb$var$InputKeyDownArrowDown = 0;
var $837ff71814b5dbdb$var$InputKeyDownArrowUp = 1;
var $837ff71814b5dbdb$var$InputKeyDownEscape = 2;
var $837ff71814b5dbdb$var$InputKeyDownHome = 3;
var $837ff71814b5dbdb$var$InputKeyDownEnd = 4;
var $837ff71814b5dbdb$var$InputKeyDownPageUp = 5;
var $837ff71814b5dbdb$var$InputKeyDownPageDown = 6;
var $837ff71814b5dbdb$var$InputKeyDownEnter = 7;
var $837ff71814b5dbdb$var$InputChange = 8;
var $837ff71814b5dbdb$var$InputBlur = 9;
var $837ff71814b5dbdb$var$InputFocus = 10;
var $837ff71814b5dbdb$var$MenuMouseLeave = 11;
var $837ff71814b5dbdb$var$ItemMouseMove = 12;
var $837ff71814b5dbdb$var$ItemClick = 13;
var $837ff71814b5dbdb$var$ToggleButtonClick = 14;
var $837ff71814b5dbdb$var$FunctionToggleMenu = 15;
var $837ff71814b5dbdb$var$FunctionOpenMenu = 16;
var $837ff71814b5dbdb$var$FunctionCloseMenu = 17;
var $837ff71814b5dbdb$var$FunctionSetHighlightedIndex = 18;
var $837ff71814b5dbdb$var$FunctionSelectItem = 19;
var $837ff71814b5dbdb$var$FunctionSetInputValue = 20;
var $837ff71814b5dbdb$var$FunctionReset$1 = 21;
var $837ff71814b5dbdb$var$ControlledPropUpdatedSelectedItem = 22;
var $837ff71814b5dbdb$var$stateChangeTypes$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    InputKeyDownArrowDown: $837ff71814b5dbdb$var$InputKeyDownArrowDown,
    InputKeyDownArrowUp: $837ff71814b5dbdb$var$InputKeyDownArrowUp,
    InputKeyDownEscape: $837ff71814b5dbdb$var$InputKeyDownEscape,
    InputKeyDownHome: $837ff71814b5dbdb$var$InputKeyDownHome,
    InputKeyDownEnd: $837ff71814b5dbdb$var$InputKeyDownEnd,
    InputKeyDownPageUp: $837ff71814b5dbdb$var$InputKeyDownPageUp,
    InputKeyDownPageDown: $837ff71814b5dbdb$var$InputKeyDownPageDown,
    InputKeyDownEnter: $837ff71814b5dbdb$var$InputKeyDownEnter,
    InputChange: $837ff71814b5dbdb$var$InputChange,
    InputBlur: $837ff71814b5dbdb$var$InputBlur,
    InputFocus: $837ff71814b5dbdb$var$InputFocus,
    MenuMouseLeave: $837ff71814b5dbdb$var$MenuMouseLeave,
    ItemMouseMove: $837ff71814b5dbdb$var$ItemMouseMove,
    ItemClick: $837ff71814b5dbdb$var$ItemClick,
    ToggleButtonClick: $837ff71814b5dbdb$var$ToggleButtonClick,
    FunctionToggleMenu: $837ff71814b5dbdb$var$FunctionToggleMenu,
    FunctionOpenMenu: $837ff71814b5dbdb$var$FunctionOpenMenu,
    FunctionCloseMenu: $837ff71814b5dbdb$var$FunctionCloseMenu,
    FunctionSetHighlightedIndex: $837ff71814b5dbdb$var$FunctionSetHighlightedIndex,
    FunctionSelectItem: $837ff71814b5dbdb$var$FunctionSelectItem,
    FunctionSetInputValue: $837ff71814b5dbdb$var$FunctionSetInputValue,
    FunctionReset: $837ff71814b5dbdb$var$FunctionReset$1,
    ControlledPropUpdatedSelectedItem: $837ff71814b5dbdb$var$ControlledPropUpdatedSelectedItem
});
function $837ff71814b5dbdb$var$getInitialState$1(props) {
    var initialState = $837ff71814b5dbdb$var$getInitialState$2(props);
    var selectedItem = initialState.selectedItem;
    var inputValue = initialState.inputValue;
    if (inputValue === '' && selectedItem && props.defaultInputValue === undefined && props.initialInputValue === undefined && props.inputValue === undefined) inputValue = props.itemToString(selectedItem);
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, initialState, {
        inputValue: inputValue
    });
}
var $837ff71814b5dbdb$var$propTypes$1 = {
    items: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array.isRequired,
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    selectedItemChanged: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    getA11yStatusMessage: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    getA11ySelectionMessage: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    highlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    defaultHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    initialHighlightedIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    defaultIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    initialIsOpen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    selectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    initialSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    defaultSelectedItem: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
    inputValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    defaultInputValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    initialInputValue: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    id: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    labelId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    menuId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    getItemId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    inputId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    toggleButtonId: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onSelectedItemChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onHighlightedIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onStateChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onIsOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onInputValueChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any
        })
    })
};
/**
 * The useCombobox version of useControlledReducer, which also
 * checks if the controlled prop selectedItem changed between
 * renders. If so, it will also update inputValue with its
 * string equivalent. It uses the common useEnhancedReducer to
 * compute the rest of the state.
 *
 * @param {Function} reducer Reducer function from downshift.
 * @param {Object} initialState Initial state of the hook.
 * @param {Object} props The hook props.
 * @returns {Array} An array with the state and an action dispatcher.
 */ function $837ff71814b5dbdb$var$useControlledReducer(reducer, initialState, props) {
    var previousSelectedItemRef = (0, $7fPBF.useRef)();
    var _useEnhancedReducer = $837ff71814b5dbdb$var$useEnhancedReducer(reducer, initialState, props), state = _useEnhancedReducer[0], dispatch = _useEnhancedReducer[1];
    // ToDo: if needed, make same approach as selectedItemChanged from Downshift.
    (0, $7fPBF.useEffect)(function() {
        if (!$837ff71814b5dbdb$var$isControlledProp(props, 'selectedItem')) return;
        if (props.selectedItemChanged(previousSelectedItemRef.current, props.selectedItem)) dispatch({
            type: $837ff71814b5dbdb$var$ControlledPropUpdatedSelectedItem,
            inputValue: props.itemToString(props.selectedItem)
        });
        previousSelectedItemRef.current = state.selectedItem === previousSelectedItemRef.current ? props.selectedItem : state.selectedItem;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        state.selectedItem,
        props.selectedItem
    ]);
    return [
        $837ff71814b5dbdb$var$getState(state, props),
        dispatch
    ];
}
// eslint-disable-next-line import/no-mutable-exports
var $837ff71814b5dbdb$var$validatePropTypes$1 = $837ff71814b5dbdb$var$noop;
var $837ff71814b5dbdb$var$defaultProps$1 = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $837ff71814b5dbdb$var$defaultProps$3, {
    selectedItemChanged: function selectedItemChanged(prevItem, item) {
        return prevItem !== item;
    },
    getA11yStatusMessage: $837ff71814b5dbdb$var$getA11yStatusMessage$1
});
/* eslint-disable complexity */ function $837ff71814b5dbdb$var$downshiftUseComboboxReducer(state, action) {
    var _props$items;
    var type = action.type, props = action.props, altKey = action.altKey;
    var changes;
    switch(type){
        case $837ff71814b5dbdb$var$ItemClick:
            changes = {
                isOpen: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'isOpen'),
                highlightedIndex: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'highlightedIndex'),
                selectedItem: props.items[action.index],
                inputValue: props.itemToString(props.items[action.index])
            };
            break;
        case $837ff71814b5dbdb$var$InputKeyDownArrowDown:
            if (state.isOpen) changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getNextWrappingIndex(1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, true)
            };
            else changes = {
                highlightedIndex: altKey && state.selectedItem == null ? -1 : $837ff71814b5dbdb$var$getHighlightedIndexOnOpen(props, state, 1, action.getItemNodeFromIndex),
                isOpen: props.items.length >= 0
            };
            break;
        case $837ff71814b5dbdb$var$InputKeyDownArrowUp:
            if (state.isOpen) {
                if (altKey) changes = $837ff71814b5dbdb$var$getChangesOnSelection(props, state.highlightedIndex);
                else changes = {
                    highlightedIndex: $837ff71814b5dbdb$var$getNextWrappingIndex(-1, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, true)
                };
            } else changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getHighlightedIndexOnOpen(props, state, -1, action.getItemNodeFromIndex),
                isOpen: props.items.length >= 0
            };
            break;
        case $837ff71814b5dbdb$var$InputKeyDownEnter:
            changes = $837ff71814b5dbdb$var$getChangesOnSelection(props, state.highlightedIndex);
            break;
        case $837ff71814b5dbdb$var$InputKeyDownEscape:
            changes = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                isOpen: false,
                highlightedIndex: -1
            }, !state.isOpen && {
                selectedItem: null,
                inputValue: ''
            });
            break;
        case $837ff71814b5dbdb$var$InputKeyDownPageUp:
            changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getNextWrappingIndex(-10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $837ff71814b5dbdb$var$InputKeyDownPageDown:
            changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getNextWrappingIndex(10, state.highlightedIndex, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $837ff71814b5dbdb$var$InputKeyDownHome:
            changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getNextNonDisabledIndex(1, 0, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $837ff71814b5dbdb$var$InputKeyDownEnd:
            changes = {
                highlightedIndex: $837ff71814b5dbdb$var$getNextNonDisabledIndex(-1, props.items.length - 1, props.items.length, action.getItemNodeFromIndex, false)
            };
            break;
        case $837ff71814b5dbdb$var$InputBlur:
            changes = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                isOpen: false,
                highlightedIndex: -1
            }, state.highlightedIndex >= 0 && ((_props$items = props.items) == null ? void 0 : _props$items.length) && action.selectItem && {
                selectedItem: props.items[state.highlightedIndex],
                inputValue: props.itemToString(props.items[state.highlightedIndex])
            });
            break;
        case $837ff71814b5dbdb$var$InputChange:
            changes = {
                isOpen: true,
                highlightedIndex: $837ff71814b5dbdb$var$getDefaultValue$1(props, 'highlightedIndex'),
                inputValue: action.inputValue
            };
            break;
        case $837ff71814b5dbdb$var$InputFocus:
            changes = {
                isOpen: true,
                highlightedIndex: $837ff71814b5dbdb$var$getHighlightedIndexOnOpen(props, state, 0)
            };
            break;
        case $837ff71814b5dbdb$var$FunctionSelectItem:
            changes = {
                selectedItem: action.selectedItem,
                inputValue: props.itemToString(action.selectedItem)
            };
            break;
        case $837ff71814b5dbdb$var$ControlledPropUpdatedSelectedItem:
            changes = {
                inputValue: action.inputValue
            };
            break;
        default:
            return $837ff71814b5dbdb$var$downshiftCommonReducer(state, action, $837ff71814b5dbdb$var$stateChangeTypes$1);
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, changes);
}
/* eslint-enable complexity */ var $837ff71814b5dbdb$var$_excluded$1 = [
    "onMouseLeave",
    "refKey",
    "ref"
], $837ff71814b5dbdb$var$_excluded2$1 = [
    "item",
    "index",
    "refKey",
    "ref",
    "onMouseMove",
    "onMouseDown",
    "onClick",
    "onPress",
    "disabled"
], $837ff71814b5dbdb$var$_excluded3 = [
    "onClick",
    "onPress",
    "refKey",
    "ref"
], $837ff71814b5dbdb$var$_excluded4 = [
    "onKeyDown",
    "onChange",
    "onInput",
    "onFocus",
    "onBlur",
    "onChangeText",
    "refKey",
    "ref"
];
$837ff71814b5dbdb$export$7a023a466c03eb3d.stateChangeTypes = $837ff71814b5dbdb$var$stateChangeTypes$1;
function $837ff71814b5dbdb$export$7a023a466c03eb3d(userProps) {
    if (userProps === void 0) userProps = {};
    $837ff71814b5dbdb$var$validatePropTypes$1(userProps, $837ff71814b5dbdb$export$7a023a466c03eb3d);
    // Props defaults and destructuring.
    var props = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $837ff71814b5dbdb$var$defaultProps$1, userProps);
    var initialIsOpen = props.initialIsOpen, defaultIsOpen = props.defaultIsOpen, items = props.items, scrollIntoView = props.scrollIntoView, environment = props.environment, getA11yStatusMessage = props.getA11yStatusMessage, getA11ySelectionMessage = props.getA11ySelectionMessage, itemToString = props.itemToString;
    // Initial state depending on controlled props.
    var initialState = $837ff71814b5dbdb$var$getInitialState$1(props);
    var _useControlledReducer = $837ff71814b5dbdb$var$useControlledReducer($837ff71814b5dbdb$var$downshiftUseComboboxReducer, initialState, props), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
    var isOpen = state.isOpen, highlightedIndex = state.highlightedIndex, selectedItem = state.selectedItem, inputValue = state.inputValue;
    // Element refs.
    var menuRef = (0, $7fPBF.useRef)(null);
    var itemRefs = (0, $7fPBF.useRef)({});
    var inputRef = (0, $7fPBF.useRef)(null);
    var toggleButtonRef = (0, $7fPBF.useRef)(null);
    var isInitialMountRef = (0, $7fPBF.useRef)(true);
    // prevent id re-generation between renders.
    var elementIds = $837ff71814b5dbdb$var$useElementIds(props);
    // used to keep track of how many items we had on previous cycle.
    var previousResultCountRef = (0, $7fPBF.useRef)();
    // utility callback to get item element.
    var latest = $837ff71814b5dbdb$var$useLatestRef({
        state: state,
        props: props
    });
    var getItemNodeFromIndex = (0, $7fPBF.useCallback)(function(index) {
        return itemRefs.current[elementIds.getItemId(index)];
    }, [
        elementIds
    ]);
    // Effects.
    // Sets a11y status message on changes in state.
    $837ff71814b5dbdb$var$useA11yMessageSetter(getA11yStatusMessage, [
        isOpen,
        highlightedIndex,
        inputValue,
        items
    ], (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString
    }, state));
    // Sets a11y status message on changes in selectedItem.
    $837ff71814b5dbdb$var$useA11yMessageSetter(getA11ySelectionMessage, [
        selectedItem
    ], (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
        isInitialMount: isInitialMountRef.current,
        previousResultCount: previousResultCountRef.current,
        items: items,
        environment: environment,
        itemToString: itemToString
    }, state));
    // Scroll on highlighted item if change comes from keyboard.
    var shouldScrollRef = $837ff71814b5dbdb$var$useScrollIntoView({
        menuElement: menuRef.current,
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        itemRefs: itemRefs,
        scrollIntoView: scrollIntoView,
        getItemNodeFromIndex: getItemNodeFromIndex
    });
    $837ff71814b5dbdb$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    });
    // Focus the input on first render if required.
    (0, $7fPBF.useEffect)(function() {
        var focusOnOpen = initialIsOpen || defaultIsOpen || isOpen;
        if (focusOnOpen && inputRef.current) inputRef.current.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $7fPBF.useEffect)(function() {
        if (isInitialMountRef.current) return;
        previousResultCountRef.current = items.length;
    });
    // Add mouse/touch events to document.
    var mouseAndTouchTrackersRef = $837ff71814b5dbdb$var$useMouseAndTouchTracker(isOpen, [
        inputRef,
        menuRef,
        toggleButtonRef
    ], environment, function() {
        dispatch({
            type: $837ff71814b5dbdb$var$InputBlur,
            selectItem: false
        });
    });
    var setGetterPropCallInfo = $837ff71814b5dbdb$var$useGetterPropsCalledChecker('getInputProps', 'getMenuProps');
    // Make initial ref false.
    (0, $7fPBF.useEffect)(function() {
        isInitialMountRef.current = false;
        return function() {
            isInitialMountRef.current = true;
        };
    }, []);
    // Reset itemRefs on close.
    (0, $7fPBF.useEffect)(function() {
        var _environment$document;
        if (!isOpen) itemRefs.current = {};
        else if (((_environment$document = environment.document) == null ? void 0 : _environment$document.activeElement) !== inputRef.current) {
            var _inputRef$current;
            inputRef == null || (_inputRef$current = inputRef.current) == null || _inputRef$current.focus();
        }
    }, [
        isOpen,
        environment
    ]);
    /* Event handler functions */ var inputKeyDownHandlers = (0, $7fPBF.useMemo)(function() {
        return {
            ArrowDown: function ArrowDown(event) {
                event.preventDefault();
                dispatch({
                    type: $837ff71814b5dbdb$var$InputKeyDownArrowDown,
                    altKey: event.altKey,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            ArrowUp: function ArrowUp(event) {
                event.preventDefault();
                dispatch({
                    type: $837ff71814b5dbdb$var$InputKeyDownArrowUp,
                    altKey: event.altKey,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            Home: function Home(event) {
                if (!latest.current.state.isOpen) return;
                event.preventDefault();
                dispatch({
                    type: $837ff71814b5dbdb$var$InputKeyDownHome,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            End: function End(event) {
                if (!latest.current.state.isOpen) return;
                event.preventDefault();
                dispatch({
                    type: $837ff71814b5dbdb$var$InputKeyDownEnd,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            Escape: function Escape(event) {
                var latestState = latest.current.state;
                if (latestState.isOpen || latestState.inputValue || latestState.selectedItem || latestState.highlightedIndex > -1) {
                    event.preventDefault();
                    dispatch({
                        type: $837ff71814b5dbdb$var$InputKeyDownEscape
                    });
                }
            },
            Enter: function Enter(event) {
                var latestState = latest.current.state;
                // if closed or no highlighted index, do nothing.
                if (!latestState.isOpen || event.which === 229 // if IME composing, wait for next Enter keydown event.
                ) return;
                event.preventDefault();
                dispatch({
                    type: $837ff71814b5dbdb$var$InputKeyDownEnter,
                    getItemNodeFromIndex: getItemNodeFromIndex
                });
            },
            PageUp: function PageUp(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $837ff71814b5dbdb$var$InputKeyDownPageUp,
                        getItemNodeFromIndex: getItemNodeFromIndex
                    });
                }
            },
            PageDown: function PageDown(event) {
                if (latest.current.state.isOpen) {
                    event.preventDefault();
                    dispatch({
                        type: $837ff71814b5dbdb$var$InputKeyDownPageDown,
                        getItemNodeFromIndex: getItemNodeFromIndex
                    });
                }
            }
        };
    }, [
        dispatch,
        latest,
        getItemNodeFromIndex
    ]);
    // Getter props.
    var getLabelProps = (0, $7fPBF.useCallback)(function(labelProps) {
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
            id: elementIds.labelId,
            htmlFor: elementIds.inputId
        }, labelProps);
    }, [
        elementIds
    ]);
    var getMenuProps = (0, $7fPBF.useCallback)(function(_temp, _temp2) {
        var _extends2;
        var _ref = _temp === void 0 ? {} : _temp, onMouseLeave = _ref.onMouseLeave, _ref$refKey = _ref.refKey, refKey = _ref$refKey === void 0 ? 'ref' : _ref$refKey, ref = _ref.ref, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref, $837ff71814b5dbdb$var$_excluded$1);
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$suppressRefErro = _ref2.suppressRefError, suppressRefError = _ref2$suppressRefErro === void 0 ? false : _ref2$suppressRefErro;
        setGetterPropCallInfo('getMenuProps', suppressRefError, refKey, menuRef);
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, function(menuNode) {
            menuRef.current = menuNode;
        }), _extends2.id = elementIds.menuId, _extends2.role = 'listbox', _extends2['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends2.onMouseLeave = $837ff71814b5dbdb$var$callAllEventHandlers(onMouseLeave, function() {
            dispatch({
                type: $837ff71814b5dbdb$var$MenuMouseLeave
            });
        }), _extends2), rest);
    }, [
        dispatch,
        setGetterPropCallInfo,
        elementIds
    ]);
    var getItemProps = (0, $7fPBF.useCallback)(function(_temp3) {
        var _extends3, _ref4;
        var _ref3 = _temp3 === void 0 ? {} : _temp3, itemProp = _ref3.item, indexProp = _ref3.index, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey, ref = _ref3.ref, onMouseMove = _ref3.onMouseMove, onMouseDown = _ref3.onMouseDown, onClick = _ref3.onClick;
        _ref3.onPress;
        var disabled = _ref3.disabled, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref3, $837ff71814b5dbdb$var$_excluded2$1);
        var _latest$current = latest.current, latestProps = _latest$current.props, latestState = _latest$current.state;
        var _getItemAndIndex = $837ff71814b5dbdb$var$getItemAndIndex(itemProp, indexProp, latestProps.items, 'Pass either item or index to getItemProps!'), index = _getItemAndIndex[1];
        var onSelectKey = 'onClick';
        var customClickHandler = onClick;
        var itemHandleMouseMove = function itemHandleMouseMove() {
            if (index === latestState.highlightedIndex) return;
            shouldScrollRef.current = false;
            dispatch({
                type: $837ff71814b5dbdb$var$ItemMouseMove,
                index: index,
                disabled: disabled
            });
        };
        var itemHandleClick = function itemHandleClick() {
            dispatch({
                type: $837ff71814b5dbdb$var$ItemClick,
                index: index
            });
        };
        var itemHandleMouseDown = function itemHandleMouseDown(e) {
            return e.preventDefault();
        };
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends3 = {}, _extends3[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, function(itemNode) {
            if (itemNode) itemRefs.current[elementIds.getItemId(index)] = itemNode;
        }), _extends3.disabled = disabled, _extends3.role = 'option', _extends3['aria-selected'] = "" + (index === latestState.highlightedIndex), _extends3.id = elementIds.getItemId(index), _extends3), !disabled && (_ref4 = {}, _ref4[onSelectKey] = $837ff71814b5dbdb$var$callAllEventHandlers(customClickHandler, itemHandleClick), _ref4), {
            onMouseMove: $837ff71814b5dbdb$var$callAllEventHandlers(onMouseMove, itemHandleMouseMove),
            onMouseDown: $837ff71814b5dbdb$var$callAllEventHandlers(onMouseDown, itemHandleMouseDown)
        }, rest);
    }, [
        dispatch,
        latest,
        shouldScrollRef,
        elementIds
    ]);
    var getToggleButtonProps = (0, $7fPBF.useCallback)(function(_temp4) {
        var _extends4;
        var _ref5 = _temp4 === void 0 ? {} : _temp4, onClick = _ref5.onClick;
        _ref5.onPress;
        var _ref5$refKey = _ref5.refKey, refKey = _ref5$refKey === void 0 ? 'ref' : _ref5$refKey, ref = _ref5.ref, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref5, $837ff71814b5dbdb$var$_excluded3);
        var latestState = latest.current.state;
        var toggleButtonHandleClick = function toggleButtonHandleClick() {
            dispatch({
                type: $837ff71814b5dbdb$var$ToggleButtonClick
            });
        };
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends4 = {}, _extends4[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, function(toggleButtonNode) {
            toggleButtonRef.current = toggleButtonNode;
        }), _extends4['aria-controls'] = elementIds.menuId, _extends4['aria-expanded'] = latestState.isOpen, _extends4.id = elementIds.toggleButtonId, _extends4.tabIndex = -1, _extends4), !rest.disabled && (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, {
            onClick: $837ff71814b5dbdb$var$callAllEventHandlers(onClick, toggleButtonHandleClick)
        }), rest);
    }, [
        dispatch,
        latest,
        elementIds
    ]);
    var getInputProps = (0, $7fPBF.useCallback)(function(_temp5, _temp6) {
        var _extends5;
        var _ref6 = _temp5 === void 0 ? {} : _temp5, onKeyDown = _ref6.onKeyDown, onChange = _ref6.onChange, onInput = _ref6.onInput, onFocus = _ref6.onFocus, onBlur = _ref6.onBlur;
        _ref6.onChangeText;
        var _ref6$refKey = _ref6.refKey, refKey = _ref6$refKey === void 0 ? 'ref' : _ref6$refKey, ref = _ref6.ref, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref6, $837ff71814b5dbdb$var$_excluded4);
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$suppressRefErro = _ref7.suppressRefError, suppressRefError = _ref7$suppressRefErro === void 0 ? false : _ref7$suppressRefErro;
        setGetterPropCallInfo('getInputProps', suppressRefError, refKey, inputRef);
        var latestState = latest.current.state;
        var inputHandleKeyDown = function inputHandleKeyDown(event) {
            var key = $837ff71814b5dbdb$var$normalizeArrowKey(event);
            if (key && inputKeyDownHandlers[key]) inputKeyDownHandlers[key](event);
        };
        var inputHandleChange = function inputHandleChange(event) {
            dispatch({
                type: $837ff71814b5dbdb$var$InputChange,
                inputValue: event.target.value
            });
        };
        var inputHandleBlur = function inputHandleBlur(event) {
            /* istanbul ignore else */ if (latestState.isOpen && !mouseAndTouchTrackersRef.current.isMouseDown) {
                var isBlurByTabChange = event.relatedTarget === null && environment.document.activeElement !== environment.document.body;
                dispatch({
                    type: $837ff71814b5dbdb$var$InputBlur,
                    selectItem: !isBlurByTabChange
                });
            }
        };
        var inputHandleFocus = function inputHandleFocus() {
            if (!latestState.isOpen) dispatch({
                type: $837ff71814b5dbdb$var$InputFocus
            });
        };
        /* istanbul ignore next (preact) */ var onChangeKey = 'onChange';
        var eventHandlers = {};
        if (!rest.disabled) {
            var _eventHandlers;
            eventHandlers = (_eventHandlers = {}, _eventHandlers[onChangeKey] = $837ff71814b5dbdb$var$callAllEventHandlers(onChange, onInput, inputHandleChange), _eventHandlers.onKeyDown = $837ff71814b5dbdb$var$callAllEventHandlers(onKeyDown, inputHandleKeyDown), _eventHandlers.onBlur = $837ff71814b5dbdb$var$callAllEventHandlers(onBlur, inputHandleBlur), _eventHandlers.onFocus = $837ff71814b5dbdb$var$callAllEventHandlers(onFocus, inputHandleFocus), _eventHandlers);
        }
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends5 = {}, _extends5[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, function(inputNode) {
            inputRef.current = inputNode;
        }), _extends5['aria-activedescendant'] = latestState.isOpen && latestState.highlightedIndex > -1 ? elementIds.getItemId(latestState.highlightedIndex) : '', _extends5['aria-autocomplete'] = 'list', _extends5['aria-controls'] = elementIds.menuId, _extends5['aria-expanded'] = latestState.isOpen, _extends5['aria-labelledby'] = rest && rest['aria-label'] ? undefined : "" + elementIds.labelId, _extends5.autoComplete = 'off', _extends5.id = elementIds.inputId, _extends5.role = 'combobox', _extends5.value = latestState.inputValue, _extends5), eventHandlers, rest);
    }, [
        setGetterPropCallInfo,
        latest,
        elementIds,
        inputKeyDownHandlers,
        dispatch,
        mouseAndTouchTrackersRef,
        environment
    ]);
    // returns
    var toggleMenu = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionToggleMenu
        });
    }, [
        dispatch
    ]);
    var closeMenu = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionCloseMenu
        });
    }, [
        dispatch
    ]);
    var openMenu = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionOpenMenu
        });
    }, [
        dispatch
    ]);
    var setHighlightedIndex = (0, $7fPBF.useCallback)(function(newHighlightedIndex) {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionSetHighlightedIndex,
            highlightedIndex: newHighlightedIndex
        });
    }, [
        dispatch
    ]);
    var selectItem = (0, $7fPBF.useCallback)(function(newSelectedItem) {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionSelectItem,
            selectedItem: newSelectedItem
        });
    }, [
        dispatch
    ]);
    var setInputValue = (0, $7fPBF.useCallback)(function(newInputValue) {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionSetInputValue,
            inputValue: newInputValue
        });
    }, [
        dispatch
    ]);
    var reset = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionReset$1
        });
    }, [
        dispatch
    ]);
    return {
        // prop getters.
        getItemProps: getItemProps,
        getLabelProps: getLabelProps,
        getMenuProps: getMenuProps,
        getInputProps: getInputProps,
        getToggleButtonProps: getToggleButtonProps,
        // actions.
        toggleMenu: toggleMenu,
        openMenu: openMenu,
        closeMenu: closeMenu,
        setHighlightedIndex: setHighlightedIndex,
        setInputValue: setInputValue,
        selectItem: selectItem,
        reset: reset,
        // state.
        highlightedIndex: highlightedIndex,
        isOpen: isOpen,
        selectedItem: selectedItem,
        inputValue: inputValue
    };
}
var $837ff71814b5dbdb$var$defaultStateValues = {
    activeIndex: -1,
    selectedItems: []
};
/**
 * Returns the initial value for a state key in the following order:
 * 1. controlled prop, 2. initial prop, 3. default prop, 4. default
 * value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */ function $837ff71814b5dbdb$var$getInitialValue(props, propKey) {
    return $837ff71814b5dbdb$var$getInitialValue$1(props, propKey, $837ff71814b5dbdb$var$defaultStateValues);
}
/**
 * Returns the default value for a state key in the following order:
 * 1. controlled prop, 2. default prop, 3. default value from Downshift.
 *
 * @param {Object} props Props passed to the hook.
 * @param {string} propKey Props key to generate the value for.
 * @returns {any} The initial value for that prop.
 */ function $837ff71814b5dbdb$var$getDefaultValue(props, propKey) {
    return $837ff71814b5dbdb$var$getDefaultValue$1(props, propKey, $837ff71814b5dbdb$var$defaultStateValues);
}
/**
 * Gets the initial state based on the provided props. It uses initial, default
 * and controlled props related to state in order to compute the initial value.
 *
 * @param {Object} props Props passed to the hook.
 * @returns {Object} The initial state.
 */ function $837ff71814b5dbdb$var$getInitialState(props) {
    var activeIndex = $837ff71814b5dbdb$var$getInitialValue(props, 'activeIndex');
    var selectedItems = $837ff71814b5dbdb$var$getInitialValue(props, 'selectedItems');
    return {
        activeIndex: activeIndex,
        selectedItems: selectedItems
    };
}
/**
 * Returns true if dropdown keydown operation is permitted. Should not be
 * allowed on keydown with modifier keys (ctrl, alt, shift, meta), on
 * input element with text content that is either highlighted or selection
 * cursor is not at the starting position.
 *
 * @param {KeyboardEvent} event The event from keydown.
 * @returns {boolean} Whether the operation is allowed.
 */ function $837ff71814b5dbdb$var$isKeyDownOperationPermitted(event) {
    if (event.shiftKey || event.metaKey || event.ctrlKey || event.altKey) return false;
    var element = event.target;
    if (element instanceof HTMLInputElement && // if element is a text input
    element.value !== '' && // and we have text in it
    // and cursor is either not at the start or is currently highlighting text.
    (element.selectionStart !== 0 || element.selectionEnd !== 0)) return false;
    return true;
}
/**
 * Returns a message to be added to aria-live region when item is removed.
 *
 * @param {Object} selectionParameters Parameters required to build the message.
 * @returns {string} The a11y message.
 */ function $837ff71814b5dbdb$var$getA11yRemovalMessage(selectionParameters) {
    var removedSelectedItem = selectionParameters.removedSelectedItem, itemToStringLocal = selectionParameters.itemToString;
    return itemToStringLocal(removedSelectedItem) + " has been removed.";
}
var $837ff71814b5dbdb$var$propTypes = {
    selectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    initialSelectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    defaultSelectedItems: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).array,
    itemToString: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    getA11yRemovalMessage: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    stateReducer: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    initialActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    defaultActiveIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    onActiveIndexChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    onSelectedItemsChange: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
    keyNavigationNext: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    keyNavigationPrevious: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    environment: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
        addEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        removeEventListener: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
        document: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).shape({
            getElementById: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).func,
            activeElement: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any,
            body: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).any
        })
    })
};
var $837ff71814b5dbdb$var$defaultProps = {
    itemToString: $837ff71814b5dbdb$var$defaultProps$3.itemToString,
    stateReducer: $837ff71814b5dbdb$var$defaultProps$3.stateReducer,
    environment: $837ff71814b5dbdb$var$defaultProps$3.environment,
    getA11yRemovalMessage: $837ff71814b5dbdb$var$getA11yRemovalMessage,
    keyNavigationNext: 'ArrowRight',
    keyNavigationPrevious: 'ArrowLeft'
};
// eslint-disable-next-line import/no-mutable-exports
var $837ff71814b5dbdb$var$validatePropTypes = $837ff71814b5dbdb$var$noop;
var $837ff71814b5dbdb$var$SelectedItemClick = 0;
var $837ff71814b5dbdb$var$SelectedItemKeyDownDelete = 1;
var $837ff71814b5dbdb$var$SelectedItemKeyDownBackspace = 2;
var $837ff71814b5dbdb$var$SelectedItemKeyDownNavigationNext = 3;
var $837ff71814b5dbdb$var$SelectedItemKeyDownNavigationPrevious = 4;
var $837ff71814b5dbdb$var$DropdownKeyDownNavigationPrevious = 5;
var $837ff71814b5dbdb$var$DropdownKeyDownBackspace = 6;
var $837ff71814b5dbdb$var$DropdownClick = 7;
var $837ff71814b5dbdb$var$FunctionAddSelectedItem = 8;
var $837ff71814b5dbdb$var$FunctionRemoveSelectedItem = 9;
var $837ff71814b5dbdb$var$FunctionSetSelectedItems = 10;
var $837ff71814b5dbdb$var$FunctionSetActiveIndex = 11;
var $837ff71814b5dbdb$var$FunctionReset = 12;
var $837ff71814b5dbdb$var$stateChangeTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    SelectedItemClick: $837ff71814b5dbdb$var$SelectedItemClick,
    SelectedItemKeyDownDelete: $837ff71814b5dbdb$var$SelectedItemKeyDownDelete,
    SelectedItemKeyDownBackspace: $837ff71814b5dbdb$var$SelectedItemKeyDownBackspace,
    SelectedItemKeyDownNavigationNext: $837ff71814b5dbdb$var$SelectedItemKeyDownNavigationNext,
    SelectedItemKeyDownNavigationPrevious: $837ff71814b5dbdb$var$SelectedItemKeyDownNavigationPrevious,
    DropdownKeyDownNavigationPrevious: $837ff71814b5dbdb$var$DropdownKeyDownNavigationPrevious,
    DropdownKeyDownBackspace: $837ff71814b5dbdb$var$DropdownKeyDownBackspace,
    DropdownClick: $837ff71814b5dbdb$var$DropdownClick,
    FunctionAddSelectedItem: $837ff71814b5dbdb$var$FunctionAddSelectedItem,
    FunctionRemoveSelectedItem: $837ff71814b5dbdb$var$FunctionRemoveSelectedItem,
    FunctionSetSelectedItems: $837ff71814b5dbdb$var$FunctionSetSelectedItems,
    FunctionSetActiveIndex: $837ff71814b5dbdb$var$FunctionSetActiveIndex,
    FunctionReset: $837ff71814b5dbdb$var$FunctionReset
});
/* eslint-disable complexity */ function $837ff71814b5dbdb$var$downshiftMultipleSelectionReducer(state, action) {
    var type = action.type, index = action.index, props = action.props, selectedItem = action.selectedItem;
    var activeIndex = state.activeIndex, selectedItems = state.selectedItems;
    var changes;
    switch(type){
        case $837ff71814b5dbdb$var$SelectedItemClick:
            changes = {
                activeIndex: index
            };
            break;
        case $837ff71814b5dbdb$var$SelectedItemKeyDownNavigationPrevious:
            changes = {
                activeIndex: activeIndex - 1 < 0 ? 0 : activeIndex - 1
            };
            break;
        case $837ff71814b5dbdb$var$SelectedItemKeyDownNavigationNext:
            changes = {
                activeIndex: activeIndex + 1 >= selectedItems.length ? -1 : activeIndex + 1
            };
            break;
        case $837ff71814b5dbdb$var$SelectedItemKeyDownBackspace:
        case $837ff71814b5dbdb$var$SelectedItemKeyDownDelete:
            if (activeIndex < 0) break;
            var newActiveIndex = activeIndex;
            if (selectedItems.length === 1) newActiveIndex = -1;
            else if (activeIndex === selectedItems.length - 1) newActiveIndex = selectedItems.length - 2;
            changes = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({
                selectedItems: [].concat(selectedItems.slice(0, activeIndex), selectedItems.slice(activeIndex + 1))
            }, {
                activeIndex: newActiveIndex
            });
            break;
        case $837ff71814b5dbdb$var$DropdownKeyDownNavigationPrevious:
            changes = {
                activeIndex: selectedItems.length - 1
            };
            break;
        case $837ff71814b5dbdb$var$DropdownKeyDownBackspace:
            changes = {
                selectedItems: selectedItems.slice(0, selectedItems.length - 1)
            };
            break;
        case $837ff71814b5dbdb$var$FunctionAddSelectedItem:
            changes = {
                selectedItems: [].concat(selectedItems, [
                    selectedItem
                ])
            };
            break;
        case $837ff71814b5dbdb$var$DropdownClick:
            changes = {
                activeIndex: -1
            };
            break;
        case $837ff71814b5dbdb$var$FunctionRemoveSelectedItem:
            var _newActiveIndex = activeIndex;
            var selectedItemIndex = selectedItems.indexOf(selectedItem);
            if (selectedItemIndex < 0) break;
            if (selectedItems.length === 1) _newActiveIndex = -1;
            else if (selectedItemIndex === selectedItems.length - 1) _newActiveIndex = selectedItems.length - 2;
            changes = {
                selectedItems: [].concat(selectedItems.slice(0, selectedItemIndex), selectedItems.slice(selectedItemIndex + 1)),
                activeIndex: _newActiveIndex
            };
            break;
        case $837ff71814b5dbdb$var$FunctionSetSelectedItems:
            var newSelectedItems = action.selectedItems;
            changes = {
                selectedItems: newSelectedItems
            };
            break;
        case $837ff71814b5dbdb$var$FunctionSetActiveIndex:
            var _newActiveIndex2 = action.activeIndex;
            changes = {
                activeIndex: _newActiveIndex2
            };
            break;
        case $837ff71814b5dbdb$var$FunctionReset:
            changes = {
                activeIndex: $837ff71814b5dbdb$var$getDefaultValue(props, 'activeIndex'),
                selectedItems: $837ff71814b5dbdb$var$getDefaultValue(props, 'selectedItems')
            };
            break;
        default:
            throw new Error('Reducer called without proper action type.');
    }
    return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, state, changes);
}
var $837ff71814b5dbdb$var$_excluded = [
    "refKey",
    "ref",
    "onClick",
    "onKeyDown",
    "selectedItem",
    "index"
], $837ff71814b5dbdb$var$_excluded2 = [
    "refKey",
    "ref",
    "onKeyDown",
    "onClick",
    "preventKeyAction"
];
$837ff71814b5dbdb$export$134e7e7faed1473a.stateChangeTypes = $837ff71814b5dbdb$var$stateChangeTypes;
function $837ff71814b5dbdb$export$134e7e7faed1473a(userProps) {
    if (userProps === void 0) userProps = {};
    $837ff71814b5dbdb$var$validatePropTypes(userProps, $837ff71814b5dbdb$export$134e7e7faed1473a);
    // Props defaults and destructuring.
    var props = (0, $f43c50d92a19d876$export$2e2bcd8739ae039)({}, $837ff71814b5dbdb$var$defaultProps, userProps);
    var getA11yRemovalMessage = props.getA11yRemovalMessage, itemToString = props.itemToString, environment = props.environment, keyNavigationNext = props.keyNavigationNext, keyNavigationPrevious = props.keyNavigationPrevious;
    // Reducer init.
    var _useControlledReducer = $837ff71814b5dbdb$var$useControlledReducer$1($837ff71814b5dbdb$var$downshiftMultipleSelectionReducer, $837ff71814b5dbdb$var$getInitialState(props), props), state = _useControlledReducer[0], dispatch = _useControlledReducer[1];
    var activeIndex = state.activeIndex, selectedItems = state.selectedItems;
    // Refs.
    var isInitialMountRef = (0, $7fPBF.useRef)(true);
    var dropdownRef = (0, $7fPBF.useRef)(null);
    var previousSelectedItemsRef = (0, $7fPBF.useRef)(selectedItems);
    var selectedItemRefs = (0, $7fPBF.useRef)();
    selectedItemRefs.current = [];
    var latest = $837ff71814b5dbdb$var$useLatestRef({
        state: state,
        props: props
    });
    // Effects.
    /* Sets a11y status message on changes in selectedItem. */ (0, $7fPBF.useEffect)(function() {
        if (isInitialMountRef.current || false) return;
        if (selectedItems.length < previousSelectedItemsRef.current.length) {
            var removedSelectedItem = previousSelectedItemsRef.current.find(function(item) {
                return selectedItems.indexOf(item) < 0;
            });
            $837ff71814b5dbdb$var$setStatus(getA11yRemovalMessage({
                itemToString: itemToString,
                resultCount: selectedItems.length,
                removedSelectedItem: removedSelectedItem,
                activeIndex: activeIndex,
                activeSelectedItem: selectedItems[activeIndex]
            }), environment.document);
        }
        previousSelectedItemsRef.current = selectedItems;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        selectedItems.length
    ]);
    // Sets focus on active item.
    (0, $7fPBF.useEffect)(function() {
        if (isInitialMountRef.current) return;
        if (activeIndex === -1 && dropdownRef.current) dropdownRef.current.focus();
        else if (selectedItemRefs.current[activeIndex]) selectedItemRefs.current[activeIndex].focus();
    }, [
        activeIndex
    ]);
    $837ff71814b5dbdb$var$useControlPropsValidator({
        isInitialMount: isInitialMountRef.current,
        props: props,
        state: state
    });
    var setGetterPropCallInfo = $837ff71814b5dbdb$var$useGetterPropsCalledChecker('getDropdownProps');
    // Make initial ref false.
    (0, $7fPBF.useEffect)(function() {
        isInitialMountRef.current = false;
        return function() {
            isInitialMountRef.current = true;
        };
    }, []);
    // Event handler functions.
    var selectedItemKeyDownHandlers = (0, $7fPBF.useMemo)(function() {
        var _ref;
        return _ref = {}, _ref[keyNavigationPrevious] = function() {
            dispatch({
                type: $837ff71814b5dbdb$var$SelectedItemKeyDownNavigationPrevious
            });
        }, _ref[keyNavigationNext] = function() {
            dispatch({
                type: $837ff71814b5dbdb$var$SelectedItemKeyDownNavigationNext
            });
        }, _ref.Delete = function Delete() {
            dispatch({
                type: $837ff71814b5dbdb$var$SelectedItemKeyDownDelete
            });
        }, _ref.Backspace = function Backspace() {
            dispatch({
                type: $837ff71814b5dbdb$var$SelectedItemKeyDownBackspace
            });
        }, _ref;
    }, [
        dispatch,
        keyNavigationNext,
        keyNavigationPrevious
    ]);
    var dropdownKeyDownHandlers = (0, $7fPBF.useMemo)(function() {
        var _ref2;
        return _ref2 = {}, _ref2[keyNavigationPrevious] = function(event) {
            if ($837ff71814b5dbdb$var$isKeyDownOperationPermitted(event)) dispatch({
                type: $837ff71814b5dbdb$var$DropdownKeyDownNavigationPrevious
            });
        }, _ref2.Backspace = function Backspace(event) {
            if ($837ff71814b5dbdb$var$isKeyDownOperationPermitted(event)) dispatch({
                type: $837ff71814b5dbdb$var$DropdownKeyDownBackspace
            });
        }, _ref2;
    }, [
        dispatch,
        keyNavigationPrevious
    ]);
    // Getter props.
    var getSelectedItemProps = (0, $7fPBF.useCallback)(function(_temp) {
        var _extends2;
        var _ref3 = _temp === void 0 ? {} : _temp, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey, ref = _ref3.ref, onClick = _ref3.onClick, onKeyDown = _ref3.onKeyDown, selectedItemProp = _ref3.selectedItem, indexProp = _ref3.index, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref3, $837ff71814b5dbdb$var$_excluded);
        var latestState = latest.current.state;
        var _getItemAndIndex = $837ff71814b5dbdb$var$getItemAndIndex(selectedItemProp, indexProp, latestState.selectedItems, 'Pass either item or index to getSelectedItemProps!'), index = _getItemAndIndex[1];
        var isFocusable = index > -1 && index === latestState.activeIndex;
        var selectedItemHandleClick = function selectedItemHandleClick() {
            dispatch({
                type: $837ff71814b5dbdb$var$SelectedItemClick,
                index: index
            });
        };
        var selectedItemHandleKeyDown = function selectedItemHandleKeyDown(event) {
            var key = $837ff71814b5dbdb$var$normalizeArrowKey(event);
            if (key && selectedItemKeyDownHandlers[key]) selectedItemKeyDownHandlers[key](event);
        };
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends2 = {}, _extends2[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, function(selectedItemNode) {
            if (selectedItemNode) selectedItemRefs.current.push(selectedItemNode);
        }), _extends2.tabIndex = isFocusable ? 0 : -1, _extends2.onClick = $837ff71814b5dbdb$var$callAllEventHandlers(onClick, selectedItemHandleClick), _extends2.onKeyDown = $837ff71814b5dbdb$var$callAllEventHandlers(onKeyDown, selectedItemHandleKeyDown), _extends2), rest);
    }, [
        dispatch,
        latest,
        selectedItemKeyDownHandlers
    ]);
    var getDropdownProps = (0, $7fPBF.useCallback)(function(_temp2, _temp3) {
        var _extends3;
        var _ref4 = _temp2 === void 0 ? {} : _temp2, _ref4$refKey = _ref4.refKey, refKey = _ref4$refKey === void 0 ? 'ref' : _ref4$refKey, ref = _ref4.ref, onKeyDown = _ref4.onKeyDown, onClick = _ref4.onClick, _ref4$preventKeyActio = _ref4.preventKeyAction, preventKeyAction = _ref4$preventKeyActio === void 0 ? false : _ref4$preventKeyActio, rest = (0, $939dffaddf93a85b$export$2e2bcd8739ae039)(_ref4, $837ff71814b5dbdb$var$_excluded2);
        var _ref5 = _temp3 === void 0 ? {} : _temp3, _ref5$suppressRefErro = _ref5.suppressRefError, suppressRefError = _ref5$suppressRefErro === void 0 ? false : _ref5$suppressRefErro;
        setGetterPropCallInfo('getDropdownProps', suppressRefError, refKey, dropdownRef);
        var dropdownHandleKeyDown = function dropdownHandleKeyDown(event) {
            var key = $837ff71814b5dbdb$var$normalizeArrowKey(event);
            if (key && dropdownKeyDownHandlers[key]) dropdownKeyDownHandlers[key](event);
        };
        var dropdownHandleClick = function dropdownHandleClick() {
            dispatch({
                type: $837ff71814b5dbdb$var$DropdownClick
            });
        };
        return (0, $f43c50d92a19d876$export$2e2bcd8739ae039)((_extends3 = {}, _extends3[refKey] = $837ff71814b5dbdb$var$handleRefs(ref, function(dropdownNode) {
            if (dropdownNode) dropdownRef.current = dropdownNode;
        }), _extends3), !preventKeyAction && {
            onKeyDown: $837ff71814b5dbdb$var$callAllEventHandlers(onKeyDown, dropdownHandleKeyDown),
            onClick: $837ff71814b5dbdb$var$callAllEventHandlers(onClick, dropdownHandleClick)
        }, rest);
    }, [
        dispatch,
        dropdownKeyDownHandlers,
        setGetterPropCallInfo
    ]);
    // returns
    var addSelectedItem = (0, $7fPBF.useCallback)(function(selectedItem) {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionAddSelectedItem,
            selectedItem: selectedItem
        });
    }, [
        dispatch
    ]);
    var removeSelectedItem = (0, $7fPBF.useCallback)(function(selectedItem) {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionRemoveSelectedItem,
            selectedItem: selectedItem
        });
    }, [
        dispatch
    ]);
    var setSelectedItems = (0, $7fPBF.useCallback)(function(newSelectedItems) {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionSetSelectedItems,
            selectedItems: newSelectedItems
        });
    }, [
        dispatch
    ]);
    var setActiveIndex = (0, $7fPBF.useCallback)(function(newActiveIndex) {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionSetActiveIndex,
            activeIndex: newActiveIndex
        });
    }, [
        dispatch
    ]);
    var reset = (0, $7fPBF.useCallback)(function() {
        dispatch({
            type: $837ff71814b5dbdb$var$FunctionReset
        });
    }, [
        dispatch
    ]);
    return {
        getSelectedItemProps: getSelectedItemProps,
        getDropdownProps: getDropdownProps,
        addSelectedItem: addSelectedItem,
        removeSelectedItem: removeSelectedItem,
        setSelectedItems: setSelectedItems,
        setActiveIndex: setActiveIndex,
        reset: reset,
        selectedItems: selectedItems,
        activeIndex: activeIndex
    };
}



var $7fPBF = parcelRequire("7fPBF");




var $7fPBF = parcelRequire("7fPBF");
var $18522b4fc47f45cb$var$isCheckBoxInput = (element)=>element.type === 'checkbox';
var $18522b4fc47f45cb$var$isFileInput = (element)=>element.type === 'file';
var $18522b4fc47f45cb$var$isDateObject = (value1)=>value1 instanceof Date;
var $18522b4fc47f45cb$var$isNullOrUndefined = (value1)=>value1 == null;
const $18522b4fc47f45cb$var$isObjectType = (value1)=>typeof value1 === 'object';
var $18522b4fc47f45cb$var$isObject = (value1)=>!$18522b4fc47f45cb$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $18522b4fc47f45cb$var$isObjectType(value1) && !$18522b4fc47f45cb$var$isDateObject(value1);
var $18522b4fc47f45cb$var$getEventValue = (event)=>$18522b4fc47f45cb$var$isObject(event) && event.target ? $18522b4fc47f45cb$var$isCheckBoxInput(event.target) ? event.target.checked : $18522b4fc47f45cb$var$isFileInput(event.target) ? event.target.files : event.target.value : event;
var $18522b4fc47f45cb$var$isNameInFieldArray = (names, name)=>name.split('.').some((part, index, arr)=>!isNaN(Number(part)) && names.has(arr.slice(0, index).join('.')));
var $18522b4fc47f45cb$var$isWeb = typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined' && typeof document !== 'undefined';
function $18522b4fc47f45cb$var$cloneObject(data) {
    if (data === null || typeof data !== 'object') return data;
    if (data instanceof Date) return new Date(data);
    const isFileListInstance = typeof FileList !== 'undefined' && data instanceof FileList;
    if ($18522b4fc47f45cb$var$isWeb && (data instanceof Blob || isFileListInstance)) return data;
    const isArray = Array.isArray(data);
    if (!isArray && data.constructor !== Object) return data;
    const copy = isArray ? [] : Object.create(Object.getPrototypeOf(data));
    for(const key in data)if (Object.prototype.hasOwnProperty.call(data, key)) copy[key] = $18522b4fc47f45cb$var$cloneObject(data[key]);
    return copy;
}
const $18522b4fc47f45cb$var$EVENTS = {
    BLUR: 'blur',
    FOCUS_OUT: 'focusout',
    CHANGE: 'change',
    SUBMIT: 'submit',
    TRIGGER: 'trigger',
    VALID: 'valid'
};
const $18522b4fc47f45cb$var$VALIDATION_MODE = {
    onBlur: 'onBlur',
    onChange: 'onChange',
    onSubmit: 'onSubmit',
    onTouched: 'onTouched',
    all: 'all'
};
const $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES = {
    max: 'max',
    min: 'min',
    maxLength: 'maxLength',
    minLength: 'minLength',
    pattern: 'pattern',
    required: 'required',
    validate: 'validate'
};
const $18522b4fc47f45cb$var$ROOT_ERROR_TYPE = 'root';
const $18522b4fc47f45cb$var$PROTOTYPE_KEYWORDS = [
    '__proto__',
    'constructor',
    'prototype'
];
const $18522b4fc47f45cb$var$IS_KEY_RE = /^\w*$/;
var $18522b4fc47f45cb$var$isKey = (value1)=>$18522b4fc47f45cb$var$IS_KEY_RE.test(value1);
var $18522b4fc47f45cb$var$isUndefined = (val)=>val === undefined;
const $18522b4fc47f45cb$var$FIELD_PATH_RE = /[.[\]'"]/;
var $18522b4fc47f45cb$var$stringToPath = (input)=>input.split($18522b4fc47f45cb$var$FIELD_PATH_RE).filter(Boolean);
var $18522b4fc47f45cb$export$3988ae62b71be9a3 = (object, path, defaultValue)=>{
    if (!path || !$18522b4fc47f45cb$var$isObject(object)) return defaultValue;
    const paths = $18522b4fc47f45cb$var$isKey(path) ? [
        path
    ] : $18522b4fc47f45cb$var$stringToPath(path);
    if (paths.some((key)=>$18522b4fc47f45cb$var$PROTOTYPE_KEYWORDS.includes(key))) return defaultValue;
    const result = paths.reduce((result, key)=>{
        return $18522b4fc47f45cb$var$isNullOrUndefined(result) ? undefined : result[key];
    }, object);
    return $18522b4fc47f45cb$var$isUndefined(result) || result === object ? $18522b4fc47f45cb$var$isUndefined(object[path]) ? defaultValue : object[path] : result;
};
var $18522b4fc47f45cb$var$isBoolean = (value1)=>typeof value1 === 'boolean';
var $18522b4fc47f45cb$var$isFunction = (value1)=>typeof value1 === 'function';
var $18522b4fc47f45cb$export$adaa4cf7ef1b65be = (object, path, value1)=>{
    let index = -1;
    const tempPath = $18522b4fc47f45cb$var$isKey(path) ? [
        path
    ] : $18522b4fc47f45cb$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $18522b4fc47f45cb$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        if ($18522b4fc47f45cb$var$PROTOTYPE_KEYWORDS.includes(key)) return;
        object[key] = newValue;
        object = object[key];
    }
};
/**
 * Separate context for `control` to prevent unnecessary rerenders.
 * Internal hooks that only need control use this instead of full form context.
 */ const $18522b4fc47f45cb$var$HookFormControlContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
$18522b4fc47f45cb$var$HookFormControlContext.displayName = 'HookFormControlContext';
/**
 * @internal Internal hook to access only control from context.
 */ const $18522b4fc47f45cb$var$useFormControlContext = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($18522b4fc47f45cb$var$HookFormControlContext);
var $18522b4fc47f45cb$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {};
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $18522b4fc47f45cb$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $18522b4fc47f45cb$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
const $18522b4fc47f45cb$var$useIsomorphicLayoutEffect = $18522b4fc47f45cb$var$isWeb ? (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect : (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect;
var $18522b4fc47f45cb$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $18522b4fc47f45cb$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty('isPrototypeOf');
};
var $18522b4fc47f45cb$var$isPrimitive = (value1)=>$18522b4fc47f45cb$var$isNullOrUndefined(value1) || !$18522b4fc47f45cb$var$isObjectType(value1);
const $18522b4fc47f45cb$var$isEmptyObjectWithCustomPrototype = (object, keys)=>keys.length === 0 && !Array.isArray(object) && !$18522b4fc47f45cb$var$isPlainObject(object);
function $18522b4fc47f45cb$var$deepEqual(object1, object2, visited = new WeakMap()) {
    if (object1 === object2) return true;
    if ($18522b4fc47f45cb$var$isPrimitive(object1) || $18522b4fc47f45cb$var$isPrimitive(object2)) return Object.is(object1, object2);
    if ($18522b4fc47f45cb$var$isDateObject(object1) && $18522b4fc47f45cb$var$isDateObject(object2)) return Object.is(object1.getTime(), object2.getTime());
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    if ($18522b4fc47f45cb$var$isEmptyObjectWithCustomPrototype(object1, keys1) || $18522b4fc47f45cb$var$isEmptyObjectWithCustomPrototype(object2, keys2)) return Object.is(object1, object2);
    if (!keys1.length && Array.isArray(object1) !== Array.isArray(object2)) return false;
    const visitedPairs = visited.get(object1);
    if (visitedPairs && visitedPairs.has(object2)) return true;
    if (visitedPairs) visitedPairs.add(object2);
    else {
        const ws = new WeakSet();
        ws.add(object2);
        visited.set(object1, ws);
    }
    for (const key of keys1){
        const val1 = object1[key];
        if (!(key in object2)) return false;
        if (key !== 'ref') {
            const val2 = object2[key];
            if ($18522b4fc47f45cb$var$isDateObject(val1) && $18522b4fc47f45cb$var$isDateObject(val2) || ($18522b4fc47f45cb$var$isObject(val1) || Array.isArray(val1)) && ($18522b4fc47f45cb$var$isObject(val2) || Array.isArray(val2)) ? !$18522b4fc47f45cb$var$deepEqual(val1, val2, visited) : !Object.is(val1, val2)) return false;
        }
    }
    return true;
}
function $18522b4fc47f45cb$var$useResyncOnReconnect() {
    const _connected = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false);
    const _prevValue = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(undefined);
    const resyncIfNeeded = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((enabled, getCurrentValue, setValue)=>{
        if (enabled && _connected.current) {
            const currentValue = getCurrentValue();
            if (!$18522b4fc47f45cb$var$deepEqual(_prevValue.current, currentValue)) setValue(currentValue);
        }
        _connected.current = true;
    }, []);
    const snapshot = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((enabled, getCurrentValue)=>{
        if (enabled) _prevValue.current = $18522b4fc47f45cb$var$cloneObject(getCurrentValue());
    }, []);
    return {
        resyncIfNeeded: resyncIfNeeded,
        snapshot: snapshot
    };
}
/**
 * Subscribes to each form state and isolates re-renders at the custom hook level. It has its own scope for form state subscriptions, so it will not affect other useFormState or useForm instances. Using this hook can reduce the re-render impact on large and complex form applications.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - Include options to specify fields to subscribe to. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$606f11b2eb45ecc6(props) {
    const formControl = $18522b4fc47f45cb$var$useFormControlContext();
    const { control: control = formControl, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState), {
            defaultValues: control._defaultValues
        }));
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        validatingFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const { resyncIfNeeded: resyncIfNeeded, snapshot: snapshot } = $18522b4fc47f45cb$var$useResyncOnReconnect();
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>{
        const getCurrentFormState = ()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState), {
                defaultValues: control._defaultValues
            });
        resyncIfNeeded(!disabled, getCurrentFormState, updateFormState);
        const unsubscribe = control._subscribe({
            name: name,
            formState: _localProxyFormState.current,
            exact: exact,
            callback: (formState)=>{
                !disabled && updateFormState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState, formState), {
                    defaultValues: control._defaultValues
                }));
            }
        });
        return ()=>{
            unsubscribe();
            snapshot(!disabled, getCurrentFormState);
        };
    }, [
        name,
        disabled,
        exact,
        resyncIfNeeded,
        snapshot
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        _localProxyFormState.current.isValid && control._setValid(true);
    }, [
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$18522b4fc47f45cb$var$getProxyFormState(formState, control, _localProxyFormState.current, false), [
        formState,
        control
    ]);
}
var $18522b4fc47f45cb$var$isString = (value1)=>typeof value1 === 'string';
var $18522b4fc47f45cb$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($18522b4fc47f45cb$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $18522b4fc47f45cb$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $18522b4fc47f45cb$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field changes and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/docs/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { control } = useForm();
 * const values = useWatch({
 *   name: "fieldName",
 *   control,
 * })
 * ```
 */ function $18522b4fc47f45cb$export$3c773aa2b84f29e0(props) {
    const formControl = $18522b4fc47f45cb$var$useFormControlContext();
    const { control: control = formControl, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact, compute: compute } = props || {};
    const _defaultValue = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(defaultValue);
    const _compute = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(compute);
    const _computeFormValues = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(undefined);
    const _prevControl = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(control);
    const _prevName = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(name);
    _compute.current = compute;
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(()=>{
        const defaultValue = control._getWatch(name, _defaultValue.current);
        return _compute.current ? _compute.current(defaultValue) : defaultValue;
    });
    const getCurrentOutput = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((values)=>{
        const formValues = $18522b4fc47f45cb$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
        return _compute.current ? _compute.current(formValues) : formValues;
    }, [
        control._formValues,
        control._names,
        name
    ]);
    const refreshValue = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((values)=>{
        if (!disabled) {
            const formValues = $18522b4fc47f45cb$var$generateWatchOutput(name, control._names, values || control._formValues, false, _defaultValue.current);
            if (_compute.current) {
                const computedFormValues = _compute.current(formValues);
                if (!$18522b4fc47f45cb$var$deepEqual(computedFormValues, _computeFormValues.current)) {
                    updateValue(computedFormValues);
                    _computeFormValues.current = computedFormValues;
                }
            } else updateValue(formValues);
        }
    }, [
        control._formValues,
        control._names,
        disabled,
        name
    ]);
    const { resyncIfNeeded: resyncIfNeeded, snapshot: snapshot } = $18522b4fc47f45cb$var$useResyncOnReconnect();
    const _refreshValue = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(refreshValue);
    _refreshValue.current = refreshValue;
    const _getCurrentOutput = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(getCurrentOutput);
    _getCurrentOutput.current = getCurrentOutput;
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>{
        if (_prevControl.current !== control || !$18522b4fc47f45cb$var$deepEqual(_prevName.current, name)) {
            _prevControl.current = control;
            _prevName.current = name;
            _refreshValue.current();
        } else resyncIfNeeded(!disabled, ()=>_getCurrentOutput.current(), (currentValue)=>{
            updateValue(currentValue);
            _computeFormValues.current = currentValue;
        });
        const unsubscribe = control._subscribe({
            name: name,
            formState: {
                values: true
            },
            exact: exact,
            callback: (formState)=>{
                _refreshValue.current(formState.values);
            }
        });
        return ()=>{
            unsubscribe();
            snapshot(!disabled, ()=>_getCurrentOutput.current());
        };
    }, [
        control,
        exact,
        name,
        disabled,
        resyncIfNeeded,
        snapshot
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>control._removeUnmounted());
    // If name or control changed for this render, synchronously reflect the
    // latest value so callers (like useController) see the correct value
    // immediately on the same render.
    // Optimize: Check control reference first before expensive deepEqual
    const controlChanged = _prevControl.current !== control;
    const prevName = _prevName.current;
    // `null`/`undefined` are valid watched values, so a boolean flag (rather
    // than a sentinel return value) decides whether to return the freshly
    // computed output instead of the possibly-stale state value.
    const shouldReturnImmediate = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>{
        if (disabled) return false;
        const nameChanged = !controlChanged && !$18522b4fc47f45cb$var$deepEqual(prevName, name);
        return controlChanged || nameChanged;
    }, [
        disabled,
        controlChanged,
        name,
        prevName
    ]);
    return shouldReturnImmediate ? getCurrentOutput() : value1;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$e8c786024a2b0a79(props) {
    const formControl = $18522b4fc47f45cb$var$useFormControlContext();
    const { name: name, disabled: disabled, control: control = formControl, shouldUnregister: shouldUnregister, defaultValue: defaultValue, exact: exact = true } = props;
    const isArrayField = $18522b4fc47f45cb$var$isNameInFieldArray(control._names.array, name);
    const defaultValueMemo = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name, $18522b4fc47f45cb$export$3988ae62b71be9a3(control._defaultValues, name, defaultValue)), [
        control,
        name,
        defaultValue
    ]);
    const value1 = $18522b4fc47f45cb$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: defaultValueMemo,
        exact: exact
    });
    const formState = $18522b4fc47f45cb$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        exact: exact
    });
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(props);
    const _proxyRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(control.register(name, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.rules), {
        value: value1
    }), $18522b4fc47f45cb$var$isBoolean(props.disabled) ? {
        disabled: props.disabled
    } : {})));
    _props.current = props;
    const fieldState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            isValidating: {
                enumerable: true,
                get: ()=>!!$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.validatingFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$18522b4fc47f45cb$export$3988ae62b71be9a3(formState.errors, name)
            }
        }), [
        formState,
        name
    ]);
    const onChange = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((event)=>{
        const value1 = $18522b4fc47f45cb$var$getEventValue(event);
        if (!$18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name)) _registerProps.current = control.register(name, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _props.current.rules), {
            value: value1
        }));
        return _registerProps.current.onChange({
            target: {
                value: $18522b4fc47f45cb$var$getEventValue(event),
                name: name
            },
            type: $18522b4fc47f45cb$var$EVENTS.CHANGE
        });
    }, [
        name,
        control
    ]);
    const onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(()=>_registerProps.current.onBlur({
            target: {
                value: $18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name),
                name: name
            },
            type: $18522b4fc47f45cb$var$EVENTS.BLUR
        }), [
        name,
        control._formValues
    ]);
    const ref = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((elm)=>{
        if (elm) _proxyRef.current = {
            focus: ()=>$18522b4fc47f45cb$var$isFunction(elm.focus) && elm.focus(),
            select: ()=>$18522b4fc47f45cb$var$isFunction(elm.select) && elm.select(),
            setCustomValidity: (message)=>$18522b4fc47f45cb$var$isFunction(elm.setCustomValidity) && elm.setCustomValidity(message),
            reportValidity: ()=>$18522b4fc47f45cb$var$isFunction(elm.reportValidity) && elm.reportValidity()
        };
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
        if (field && field._f && elm) field._f.ref = _proxyRef.current;
    }, [
        control._fields,
        name
    ]);
    const field = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            name: name,
            value: value1
        }, $18522b4fc47f45cb$var$isBoolean(disabled) || formState.disabled ? {
            disabled: formState.disabled || disabled
        } : {}), {
            onChange: onChange,
            onBlur: onBlur,
            ref: ref
        }), [
        name,
        disabled,
        formState.disabled,
        onChange,
        onBlur,
        ref,
        value1
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        _registerProps.current = control.register(name, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _props.current.rules, $18522b4fc47f45cb$var$isBoolean(_props.current.disabled) ? {
            disabled: _props.current.disabled
        } : {}));
        const updateMounted = (name, value1)=>{
            const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$export$3988ae62b71be9a3(shouldUnregister ? control._defaultValues : control._options.values || control._defaultValues, name, $18522b4fc47f45cb$export$3988ae62b71be9a3(control._options.defaultValues, name, _props.current.defaultValue)));
            $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($18522b4fc47f45cb$var$isUndefined($18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name))) $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        !isArrayField && control.register(name);
        if (_proxyRef.current) {
            const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
            if (field && field._f) field._f.ref = _proxyRef.current;
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        control._setDisabledField({
            disabled: disabled,
            name: name
        });
    }, [
        disabled,
        name,
        control
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>({
            field: field,
            formState: formState,
            fieldState: fieldState
        }), [
        field,
        formState,
        fieldState
    ]);
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $18522b4fc47f45cb$export$bd0bf19f25da8474 = (props)=>props.render($18522b4fc47f45cb$export$e8c786024a2b0a79(props));
var $18522b4fc47f45cb$var$generateId = ()=>typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c)=>{
        const r = Math.random() * 16 | 0;
        return (c === 'x' ? r : r & 0x3 | 0x8).toString(16);
    });
var $18522b4fc47f45cb$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $18522b4fc47f45cb$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$18522b4fc47f45cb$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : '';
var $18522b4fc47f45cb$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.all,
        isOnTouch: mode === $18522b4fc47f45cb$var$VALIDATION_MODE.onTouched
    });
var $18522b4fc47f45cb$var$isWatched = (name, _names, isBlurEvent)=>{
    if (isBlurEvent) return false;
    if (_names.watchAll || _names.watch.has(name)) return true;
    for (const watchName of _names.watch){
        if (name.startsWith(watchName) && name.charAt(watchName.length) === '.') return true;
    }
    return false;
};
const $18522b4fc47f45cb$var$iterateFieldsByAction = (fields, action, fieldsNames, abortEarly)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        if (key === '_f') continue;
        const field = fieldsNames ? $18522b4fc47f45cb$export$3988ae62b71be9a3(fields, key) : fields[key];
        if (field) {
            const { _f: _f } = field;
            if (_f) {
                if (_f.refs && _f.refs[0] && action(_f.refs[0], key) && !abortEarly) return true;
                else if (_f.ref && action(_f.ref, _f.name) && !abortEarly) return true;
                else {
                    if ($18522b4fc47f45cb$var$iterateFieldsByAction(field, action)) break;
                }
            } else if ($18522b4fc47f45cb$var$isObject(field) || Array.isArray(field)) {
                if ($18522b4fc47f45cb$var$iterateFieldsByAction(field, action)) break;
            }
        }
    }
    return;
};
var $18522b4fc47f45cb$var$updateFieldArrayRootError = (errors, error, name)=>{
    const existingErrors = $18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name);
    const fieldArrayErrors = Array.isArray(existingErrors) ? existingErrors : [];
    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(fieldArrayErrors, $18522b4fc47f45cb$var$ROOT_ERROR_TYPE, error[name]);
    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $18522b4fc47f45cb$var$isEmptyObject = (value1)=>$18522b4fc47f45cb$var$isObject(value1) && !Object.keys(value1).length;
var $18522b4fc47f45cb$var$isHTMLElement = (value1)=>{
    if (!$18522b4fc47f45cb$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $18522b4fc47f45cb$var$isRadioInput = (element)=>element.type === 'radio';
var $18522b4fc47f45cb$var$isRegex = (value1)=>value1 instanceof RegExp;
var $18522b4fc47f45cb$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, errors[name]), {
        types: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, errors[name] && errors[name].types ? errors[name].types : {}), {
            [type]: message || true
        })
    }) : {};
const $18522b4fc47f45cb$var$defaultResult = {
    value: false,
    isValid: false
};
const $18522b4fc47f45cb$var$validResult = {
    value: true,
    isValid: true
};
var $18522b4fc47f45cb$var$getCheckboxValue = (options)=>{
    if (!Array.isArray(options)) return $18522b4fc47f45cb$var$defaultResult;
    if (options.length > 1) {
        const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
        return {
            value: values,
            isValid: !!values.length
        };
    }
    const option = options[0];
    if (!option || !option.checked || option.disabled) return $18522b4fc47f45cb$var$defaultResult;
    if (!option.attributes || !('value' in option.attributes)) return $18522b4fc47f45cb$var$validResult;
    return $18522b4fc47f45cb$var$isUndefined(option.value) || option.value === '' ? $18522b4fc47f45cb$var$validResult : {
        value: option.value,
        isValid: true
    };
};
const $18522b4fc47f45cb$var$defaultReturn = {
    isValid: false,
    value: null
};
var $18522b4fc47f45cb$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $18522b4fc47f45cb$var$defaultReturn) : $18522b4fc47f45cb$var$defaultReturn;
function $18522b4fc47f45cb$var$getValidateError(result, ref, type = 'validate') {
    if ($18522b4fc47f45cb$var$isString(result) || Array.isArray(result) && result.every($18522b4fc47f45cb$var$isString) || $18522b4fc47f45cb$var$isBoolean(result) && !result) return {
        type: type,
        message: $18522b4fc47f45cb$var$isString(result) ? result : '',
        ref: ref
    };
}
var $18522b4fc47f45cb$var$getValueAndMessage = (validationData)=>$18522b4fc47f45cb$var$isObject(validationData) && !$18522b4fc47f45cb$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ''
    };
var $18522b4fc47f45cb$var$validateField = async (field, disabledFieldNames, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount } = field._f;
    const inputValue = $18522b4fc47f45cb$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabledFieldNames.has(name)) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            const validityMessage = $18522b4fc47f45cb$var$isBoolean(message) ? '' : message || '';
            if (refs) refs.forEach((ref)=>ref.setCustomValidity(validityMessage));
            else inputRef.setCustomValidity(validityMessage);
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $18522b4fc47f45cb$var$isRadioInput(ref);
    const isCheckBox = $18522b4fc47f45cb$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $18522b4fc47f45cb$var$isFileInput(ref)) && $18522b4fc47f45cb$var$isUndefined(ref.value) && $18522b4fc47f45cb$var$isUndefined(inputValue) || $18522b4fc47f45cb$var$isHTMLElement(ref) && ref.value === '' || inputValue === '' || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $18522b4fc47f45cb$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.maxLength, minType = $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref
        }, appendErrorsCurry(exceedMax ? maxType : minType, message));
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $18522b4fc47f45cb$var$isNullOrUndefined(inputValue)) || $18522b4fc47f45cb$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$18522b4fc47f45cb$var$getCheckboxValue(refs).isValid || isRadio && !$18522b4fc47f45cb$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $18522b4fc47f45cb$var$isString(required) ? {
            value: !!required,
            message: required
        } : $18522b4fc47f45cb$var$getValueAndMessage(required);
        if (value1) {
            error[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                type: $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef
            }, appendErrorsCurry($18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.required, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$18522b4fc47f45cb$var$isNullOrUndefined(min) || !$18522b4fc47f45cb$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $18522b4fc47f45cb$var$getValueAndMessage(max);
        const minOutput = $18522b4fc47f45cb$var$getValueAndMessage(min);
        if (!$18522b4fc47f45cb$var$isNullOrUndefined(inputValue) && !$18522b4fc47f45cb$var$isDateObject(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$18522b4fc47f45cb$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$18522b4fc47f45cb$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + ' ' + time);
            const isTime = ref.type == 'time';
            const isWeek = ref.type == 'week';
            if ($18522b4fc47f45cb$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($18522b4fc47f45cb$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.max, $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($18522b4fc47f45cb$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $18522b4fc47f45cb$var$getValueAndMessage(maxLength);
        const minLengthOutput = $18522b4fc47f45cb$var$getValueAndMessage(minLength);
        const exceedMax = !$18522b4fc47f45cb$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$18522b4fc47f45cb$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $18522b4fc47f45cb$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $18522b4fc47f45cb$var$getValueAndMessage(pattern);
        if ($18522b4fc47f45cb$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                type: $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref
            }, appendErrorsCurry($18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.pattern, message));
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($18522b4fc47f45cb$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $18522b4fc47f45cb$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validateError, appendErrorsCurry($18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.validate, validateError.message));
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($18522b4fc47f45cb$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$18522b4fc47f45cb$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $18522b4fc47f45cb$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, validateError, appendErrorsCurry(key, validateError.message));
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$18522b4fc47f45cb$var$isEmptyObject(validationResult)) {
                error[name] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    ref: inputRef
                }, validationResult);
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    const fieldError = error[name];
    setCustomValidity(fieldError ? fieldError.message : true);
    return error;
};
var $18522b4fc47f45cb$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $18522b4fc47f45cb$var$appendAt = (data, value1)=>[
        ...data,
        ...$18522b4fc47f45cb$var$convertToArrayPayload(value1)
    ];
var $18522b4fc47f45cb$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $18522b4fc47f45cb$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$18522b4fc47f45cb$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $18522b4fc47f45cb$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($18522b4fc47f45cb$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
var $18522b4fc47f45cb$var$prependAt = (data, value1)=>[
        ...$18522b4fc47f45cb$var$convertToArrayPayload(value1),
        ...$18522b4fc47f45cb$var$convertToArrayPayload(data)
    ];
var $18522b4fc47f45cb$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
function $18522b4fc47f45cb$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $18522b4fc47f45cb$var$compact(temp).length ? temp : [];
}
var $18522b4fc47f45cb$var$removeArrayAt = (data, index)=>$18522b4fc47f45cb$var$isUndefined(index) ? [] : $18522b4fc47f45cb$var$removeAtIndexes(data, $18522b4fc47f45cb$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $18522b4fc47f45cb$var$swapArrayAt = (data, indexA, indexB)=>{
    [data[indexA], data[indexB]] = [
        data[indexB],
        data[indexA]
    ];
};
function $18522b4fc47f45cb$var$baseGet(object, updatePath) {
    const length = updatePath.length - 1;
    let index = 0;
    while(index < length){
        if ($18522b4fc47f45cb$var$isNullOrUndefined(object)) {
            object = undefined;
            break;
        }
        object = object[updatePath[index]];
        index++;
    }
    return object;
}
function $18522b4fc47f45cb$var$isEmptyArray(obj) {
    for(const key in obj){
        if (obj.hasOwnProperty(key) && !$18522b4fc47f45cb$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $18522b4fc47f45cb$var$unset(object, path) {
    if ($18522b4fc47f45cb$var$isString(path) && Object.prototype.hasOwnProperty.call(object, path)) {
        delete object[path];
        return object;
    }
    const paths = Array.isArray(path) ? path : $18522b4fc47f45cb$var$isKey(path) ? [
        path
    ] : $18522b4fc47f45cb$var$stringToPath(path);
    if (paths.some((segment)=>$18522b4fc47f45cb$var$PROTOTYPE_KEYWORDS.includes(String(segment)))) return object;
    const childObject = paths.length === 1 ? object : $18522b4fc47f45cb$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($18522b4fc47f45cb$var$isObject(childObject) && $18522b4fc47f45cb$var$isEmptyObject(childObject) || Array.isArray(childObject) && $18522b4fc47f45cb$var$isEmptyArray(childObject))) $18522b4fc47f45cb$var$unset(object, paths.slice(0, -1));
    return object;
}
var $18522b4fc47f45cb$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$310131896651d559(props) {
    const formControl = $18522b4fc47f45cb$var$useFormControlContext();
    const { control: control = formControl, name: name, keyName: keyName = 'id', disabled: disabled, shouldUnregister: shouldUnregister, rules: rules } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(control._getFieldArray(name).map($18522b4fc47f45cb$var$generateId));
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(false);
    if (!disabled) control._names.array.add(name);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>!disabled && rules && fields.length >= 0 && control.register(name, rules), [
        control,
        name,
        fields.length,
        rules,
        disabled
    ]);
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>{
        if (disabled) return;
        return control._subjects.array.subscribe({
            next: ({ values: values, name: fieldArrayName })=>{
                if (fieldArrayName === name || !fieldArrayName) {
                    const fieldValues = $18522b4fc47f45cb$export$3988ae62b71be9a3(values, name);
                    if (Array.isArray(fieldValues)) {
                        setFields(fieldValues);
                        ids.current = fieldValues.map($18522b4fc47f45cb$var$generateId);
                    } else if (!fieldArrayName) {
                        setFields([]);
                        ids.current = [];
                    }
                }
            }
        }).unsubscribe;
    }, [
        control,
        name,
        disabled
    ]);
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._setFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append = (value1, options)=>{
        if (disabled) return;
        const appendValue = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$appendAt(control._getFieldArray(name), appendValue);
        control._names.focus = $18522b4fc47f45cb$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $18522b4fc47f45cb$var$appendAt(ids.current, appendValue.map($18522b4fc47f45cb$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$appendAt, {
            argA: $18522b4fc47f45cb$var$fillEmptyArray(value1)
        });
    };
    const prepend = (value1, options)=>{
        if (disabled) return;
        const prependValue = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$prependAt(control._getFieldArray(name), prependValue);
        control._names.focus = $18522b4fc47f45cb$var$getFocusFieldName(name, 0, options);
        ids.current = $18522b4fc47f45cb$var$prependAt(ids.current, prependValue.map($18522b4fc47f45cb$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$prependAt, {
            argA: $18522b4fc47f45cb$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        if (disabled) return;
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $18522b4fc47f45cb$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        !Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name)) && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._fields, name, undefined);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        if (disabled) return;
        const insertValue = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $18522b4fc47f45cb$var$getFocusFieldName(name, index, options);
        ids.current = $18522b4fc47f45cb$var$insert(ids.current, index, insertValue.map($18522b4fc47f45cb$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$insert, {
            argA: index,
            argB: $18522b4fc47f45cb$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        if (disabled) return;
        const updatedFieldArrayValues = control._getFieldArray(name);
        $18522b4fc47f45cb$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $18522b4fc47f45cb$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        if (disabled) return;
        const updatedFieldArrayValues = control._getFieldArray(name);
        $18522b4fc47f45cb$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $18522b4fc47f45cb$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        if (disabled) return;
        const updateValue = $18522b4fc47f45cb$var$cloneObject(value1);
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $18522b4fc47f45cb$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, updatedFieldArrayValues, $18522b4fc47f45cb$var$updateAt, {
            argA: index,
            argB: $18522b4fc47f45cb$var$fillEmptyArray(value1)
        });
    };
    const replace = (value1)=>{
        if (disabled) return;
        const updatedFieldArrayValues = $18522b4fc47f45cb$var$convertToArrayPayload($18522b4fc47f45cb$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($18522b4fc47f45cb$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._setFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (disabled) {
            control._state.actionArrayLengths.delete(name);
            return;
        }
        control._state.action = false;
        control._state.actionArrayLengths.delete(name);
        $18522b4fc47f45cb$var$isWatched(name, control._names) && control._subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState));
        const validationModes = $18522b4fc47f45cb$var$getValidationModes(control._options.mode);
        if (_actioned.current && (!validationModes.isOnSubmit || control._formState.isSubmitted) && !$18522b4fc47f45cb$var$getValidationModes(control._options.reValidateMode).isOnSubmit && !validationModes.isOnBlur) {
            if (control._options.resolver) control._runSchema([
                name
            ]).then((result)=>{
                var _a, _b;
                control._updateIsValidating([
                    name
                ]);
                const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._formState.errors, name);
                const existingErrorType = existingError && (existingError.type || ((_a = existingError.root) === null || _a === void 0 ? void 0 : _a.type));
                const existingErrorMessage = existingError && (existingError.message || ((_b = existingError.root) === null || _b === void 0 ? void 0 : _b.message));
                if (existingError ? !error && existingErrorType || error && (existingErrorType !== error.type || existingErrorMessage !== error.message) : error && error.type) {
                    if (error) $18522b4fc47f45cb$var$isObject(error) && !Object.keys(error).some((key)=>!Number.isNaN(+key)) ? $18522b4fc47f45cb$var$updateFieldArrayRootError(control._formState.errors, {
                        [name]: error
                    }, name) : $18522b4fc47f45cb$export$adaa4cf7ef1b65be(control._formState.errors, name, error);
                    else $18522b4fc47f45cb$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $18522b4fc47f45cb$var$validateField(field, control._names.disabled, control._formValues, control._options.criteriaMode === $18522b4fc47f45cb$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$18522b4fc47f45cb$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $18522b4fc47f45cb$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        // External updates that change `fields` (e.g. reset() or setValue() on
        // the array) already notify subscribers with the up-to-date values
        // themselves, so only re-broadcast here for genuine array method calls.
        _actioned.current && control._subjects.state.next({
            name: name,
            values: $18522b4fc47f45cb$var$cloneObject(control._formValues)
        });
        control._names.focus && $18522b4fc47f45cb$var$iterateFieldsByAction(control._fields, (ref, key)=>{
            if (control._names.focus && key.startsWith(control._names.focus) && ref.focus) {
                ref.focus();
                return 1;
            }
            return;
        });
        control._names.focus = '';
        control._setValid();
        _actioned.current = false;
    }, [
        fields,
        name,
        control,
        disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (!disabled) !$18522b4fc47f45cb$export$3988ae62b71be9a3(control._formValues, name) && control._setFieldArray(name);
        return ()=>{
            control._state.actionArrayLengths.delete(name);
            if (disabled) return;
            const shouldKeepFieldArrayValues = !(control._options.shouldUnregister || shouldUnregister);
            const updateMounted = (name, value1)=>{
                const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) field._f.mount = value1;
            };
            if (_actioned.current && shouldKeepFieldArrayValues) control._subjects.state.next({
                name: name,
                values: $18522b4fc47f45cb$var$cloneObject(control._formValues)
            });
            shouldKeepFieldArrayValues ? updateMounted(name, false) : control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister,
        disabled
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(swap, [
            updateValues,
            name,
            control,
            disabled
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(move, [
            updateValues,
            name,
            control,
            disabled
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(prepend, [
            updateValues,
            name,
            control,
            disabled
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(append, [
            updateValues,
            name,
            control,
            disabled
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(remove, [
            updateValues,
            name,
            control,
            disabled
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(insert$1, [
            updateValues,
            name,
            control,
            disabled
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(update, [
            updateValues,
            name,
            control,
            disabled
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(replace, [
            updateValues,
            name,
            control,
            disabled
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>fields.map((field, index)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, field, $18522b4fc47f45cb$var$isBoolean(disabled) ? {
                    disabled: disabled
                } : {}), {
                    [keyName]: ids.current[index] || $18522b4fc47f45cb$var$generateId()
                })), [
            fields,
            keyName,
            disabled
        ])
    };
}
/**
 * Component based on `useFieldArray` hook to work with controlled component.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, register } = useForm<FormValues>({
 *     defaultValues: {
 *       test: [
 *         {
 *           value: '',
 *         },
 *       ],
 *     },
 *   });
 *
 *   return (
 *     <form>
 *       <FieldArray
 *         control={control}
 *         name="test"
 *         render={({ fields }) =>
 *           fields.map((field, index) => (
 *             <input key={field.id} {...register(`test.${index}.value`)} />
 *           ))
 *         }
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $18522b4fc47f45cb$export$2683597413c8b91 = (props)=>props.render($18522b4fc47f45cb$export$310131896651d559(props));
const $18522b4fc47f45cb$var$isFileLike = (value1)=>typeof Blob !== 'undefined' && value1 instanceof Blob || typeof File !== 'undefined' && value1 instanceof File;
const $18522b4fc47f45cb$var$flatten = (obj)=>{
    const output = {};
    for (const key of Object.keys(obj))if ($18522b4fc47f45cb$var$isObjectType(obj[key]) && obj[key] !== null && !$18522b4fc47f45cb$var$isDateObject(obj[key]) && !$18522b4fc47f45cb$var$isFileLike(obj[key])) {
        const nested = $18522b4fc47f45cb$var$flatten(obj[key]);
        for (const nestedKey of Object.keys(nested))output[`${key}.${nestedKey}`] = nested[nestedKey];
    } else output[key] = obj[key];
    return output;
};
function $18522b4fc47f45cb$var$jsonToFormData(json) {
    const result = new FormData();
    const flattenFormValues = $18522b4fc47f45cb$var$flatten(json);
    for(const key in flattenFormValues)result.append(key, flattenFormValues[key]);
    return result;
}
function $18522b4fc47f45cb$var$safeJSONStringify(value1) {
    try {
        return JSON.stringify(value1);
    } catch (_a) {
        return '';
    }
}
function $18522b4fc47f45cb$var$noop() {}
const $18522b4fc47f45cb$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
$18522b4fc47f45cb$var$HookFormContext.displayName = 'HookFormContext';
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $18522b4fc47f45cb$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($18522b4fc47f45cb$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://react.dev/reference/react/useContext) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $18522b4fc47f45cb$export$8ce1ff4f94d08846 = ({ children: children, watch: watch, getValues: getValues, getErrors: getErrors, getFieldState: getFieldState, setError: setError, clearErrors: clearErrors, setValue: setValue, setValues: setValues, trigger: trigger, formState: formState, resetField: resetField, reset: reset, resetDefaultValues: resetDefaultValues, handleSubmit: handleSubmit, unregister: unregister, control: control, register: register, setFocus: setFocus, subscribe: subscribe })=>{
    const memoizedValue = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>({
            watch: watch,
            getValues: getValues,
            getErrors: getErrors,
            getFieldState: getFieldState,
            setError: setError,
            clearErrors: clearErrors,
            setValue: setValue,
            setValues: setValues,
            trigger: trigger,
            formState: formState,
            resetField: resetField,
            reset: reset,
            resetDefaultValues: resetDefaultValues,
            handleSubmit: handleSubmit,
            unregister: unregister,
            control: control,
            register: register,
            setFocus: setFocus,
            subscribe: subscribe
        }), [
        clearErrors,
        control,
        formState,
        getErrors,
        getFieldState,
        getValues,
        handleSubmit,
        register,
        reset,
        resetDefaultValues,
        resetField,
        setError,
        setFocus,
        setValue,
        setValues,
        subscribe,
        trigger,
        unregister,
        watch
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($18522b4fc47f45cb$var$HookFormContext.Provider, {
        value: memoizedValue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($18522b4fc47f45cb$var$HookFormControlContext.Provider, {
        value: memoizedValue.control
    }, children));
};
const $18522b4fc47f45cb$var$POST_REQUEST = 'post';
function $18522b4fc47f45cb$var$defaultValidateStatus(status) {
    return status >= 200 && status < 300;
}
/**
 * Form component to manage submission.
 *
 * @param props - to setup submission detail. {@link FormProps}
 *
 * @returns form component or headless render prop.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control, formState: { errors } } = useForm();
 *
 *   return (
 *     <Form action="/api" control={control}>
 *       <input {...register("name")} />
 *       <p>{errors?.root?.server && 'Server error'}</p>
 *       <button>Submit</button>
 *     </Form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$a7fed597f4b8afd8(props) {
    const methods = $18522b4fc47f45cb$export$4d957a5e1be13b03();
    const [mounted, setMounted] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const { control: control = methods.control, onSubmit: onSubmit = $18522b4fc47f45cb$var$noop, children: children, action: action, method: method = $18522b4fc47f45cb$var$POST_REQUEST, headers: headers, encType: encType, onError: onError = $18522b4fc47f45cb$var$noop, render: render, onSuccess: onSuccess = $18522b4fc47f45cb$var$noop, validateStatus: validateStatus = $18522b4fc47f45cb$var$defaultValidateStatus } = props, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "control",
        "onSubmit",
        "children",
        "action",
        "method",
        "headers",
        "encType",
        "onError",
        "render",
        "onSuccess",
        "validateStatus"
    ]);
    const handleSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>{
        return control.handleSubmit(async (data, event)=>{
            const formData = $18522b4fc47f45cb$var$jsonToFormData(data);
            const formDataJson = $18522b4fc47f45cb$var$safeJSONStringify(data);
            if (onSubmit) await onSubmit({
                data: data,
                event: event,
                method: method,
                formData: formData,
                formDataJson: formDataJson
            });
            if ($18522b4fc47f45cb$var$isString(action)) try {
                const shouldStringifySubmissionData = headers && headers['Content-Type'] && headers['Content-Type'].includes('json') || encType && encType.includes('json');
                const response = await fetch(action, {
                    method: method,
                    headers: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, headers, encType && encType !== 'multipart/form-data' && {
                        'Content-Type': encType
                    }),
                    body: shouldStringifySubmissionData ? formDataJson : formData
                });
                if (response && !validateStatus(response.status)) {
                    onError({
                        response: response
                    });
                    return {
                        type: String(response.status)
                    };
                } else onSuccess({
                    response: response
                });
            } catch (error) {
                onError({
                    error: error
                });
                return {
                    type: ''
                };
            }
            if ($18522b4fc47f45cb$var$isFunction(action)) try {
                await action(formData);
            } catch (error) {
                onError({
                    error: error
                });
                return {
                    type: ''
                };
            }
            // Return nothing when successful.
            return;
        });
    }, [
        control,
        onSubmit,
        method,
        action,
        headers,
        encType,
        validateStatus,
        onError,
        onSuccess
    ]);
    const submit = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback(async (event)=>{
        const err = await handleSubmit(event);
        if (err && control) {
            control._subjects.state.next({
                isSubmitSuccessful: false
            });
            control.setError('root.server', err);
        }
    }, [
        handleSubmit,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        setMounted(true);
    }, []);
    if (render) return render({
        submit: submit
    });
    // React forbids passing `method`/`encType` alongside a function `action`
    // (a Server-Action-style submission) -- it manages those itself and warns
    // if they're present, so they're only rendered for string/URL actions.
    return (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        noValidate: mounted,
        action: action
    }, !$18522b4fc47f45cb$var$isFunction(action) && {
        method: method,
        encType: encType
    }), {
        onSubmit: submit
    }), rest), children);
}
const $18522b4fc47f45cb$export$35e922fb7c997117 = ({ control: control, disabled: disabled, exact: exact, name: name, render: render })=>render($18522b4fc47f45cb$export$606f11b2eb45ecc6({
        control: control,
        name: name,
        disabled: disabled,
        exact: exact
    }));
/** @deprecated Use `FormState` instead. Kept as an alias for backward compatibility. */ const $18522b4fc47f45cb$export$6136af724020822e = $18522b4fc47f45cb$export$35e922fb7c997117;
var $18522b4fc47f45cb$var$createSubject = ()=>{
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
function $18522b4fc47f45cb$var$extractFormValues(fieldsState, formValues) {
    const values = {};
    for(const key in fieldsState)if (fieldsState.hasOwnProperty(key)) {
        const fieldState = fieldsState[key];
        const fieldValue = formValues[key];
        if (fieldState && $18522b4fc47f45cb$var$isObject(fieldState) && fieldValue) {
            const nestedFieldsState = $18522b4fc47f45cb$var$extractFormValues(fieldState, fieldValue);
            if ($18522b4fc47f45cb$var$isObject(nestedFieldsState)) values[key] = nestedFieldsState;
        } else if (fieldsState[key]) values[key] = fieldValue;
    }
    return values;
}
const $18522b4fc47f45cb$var$hasOwn = (value1, key)=>value1 !== null && $18522b4fc47f45cb$var$isObjectType(value1) && Object.prototype.hasOwnProperty.call(value1, key);
var $18522b4fc47f45cb$var$has = (object, path)=>{
    if (!path) return false;
    let result = object;
    for (const key of $18522b4fc47f45cb$var$isKey(path) ? [
        path
    ] : $18522b4fc47f45cb$var$stringToPath(path)){
        if (!$18522b4fc47f45cb$var$hasOwn(result, key)) // `get` also resolves a path held as a single literal key, eg `{ 'a.b': 1 }`
        return $18522b4fc47f45cb$var$hasOwn(object, path);
        result = result[key];
    }
    return true;
};
var $18522b4fc47f45cb$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $18522b4fc47f45cb$var$isRadioOrCheckbox = (ref)=>$18522b4fc47f45cb$var$isRadioInput(ref) || $18522b4fc47f45cb$var$isCheckBoxInput(ref);
var $18522b4fc47f45cb$var$live = (ref)=>$18522b4fc47f45cb$var$isHTMLElement(ref) && ref.isConnected;
function $18522b4fc47f45cb$var$isDirtyContainer(value1) {
    return Array.isArray(value1) || $18522b4fc47f45cb$var$isObject(value1);
}
function $18522b4fc47f45cb$var$collectDirtyFieldNames(dirtyTree, cachedDirtyFields, prefix = '', names = []) {
    for(const key in dirtyTree){
        const path = prefix ? `${prefix}.${key}` : key;
        const value1 = dirtyTree[key];
        if ($18522b4fc47f45cb$var$isDirtyContainer(value1) && $18522b4fc47f45cb$var$isDirtyContainer($18522b4fc47f45cb$export$3988ae62b71be9a3(cachedDirtyFields, path))) $18522b4fc47f45cb$var$collectDirtyFieldNames(value1, cachedDirtyFields, path, names);
        else names.push(path);
    }
    return names;
}
var $18522b4fc47f45cb$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($18522b4fc47f45cb$var$isFunction(data[key])) return true;
    }
    return false;
};
function $18522b4fc47f45cb$var$isTraversable(value1) {
    return Array.isArray(value1) || $18522b4fc47f45cb$var$isObject(value1) && !$18522b4fc47f45cb$var$objectHasFunction(value1);
}
function $18522b4fc47f45cb$var$isRegisteredLeaf(fieldRef) {
    return !!(fieldRef && '_f' in fieldRef);
}
function $18522b4fc47f45cb$var$isEmptyDirtyContainer(value1) {
    return Array.isArray(value1) ? !value1.some((item)=>!$18522b4fc47f45cb$var$isUndefined(item)) : !Object.keys(value1).length;
}
function $18522b4fc47f45cb$var$clearDirtyField(container, key) {
    if (Array.isArray(container)) container[key] = undefined;
    else delete container[key];
}
function $18522b4fc47f45cb$var$markFieldsDirty(data, fields = {}, fieldRefs) {
    for(const key in data){
        const value1 = data[key];
        const fieldRef = fieldRefs && fieldRefs[key];
        if ($18522b4fc47f45cb$var$isTraversable(value1) && (!Array.isArray(value1) || !$18522b4fc47f45cb$var$isRegisteredLeaf(fieldRef))) {
            fields[key] = Array.isArray(value1) ? [] : {};
            $18522b4fc47f45cb$var$markFieldsDirty(value1, fields[key], fieldRef);
            if ($18522b4fc47f45cb$var$isEmptyDirtyContainer(fields[key])) $18522b4fc47f45cb$var$clearDirtyField(fields, key);
        } else if (!$18522b4fc47f45cb$var$isUndefined(value1)) fields[key] = true;
    }
    return fields;
}
function $18522b4fc47f45cb$var$getDirtyFields(data, formValues, dirtyFieldsFromValues, fieldRefs) {
    if (!dirtyFieldsFromValues) dirtyFieldsFromValues = $18522b4fc47f45cb$var$markFieldsDirty(formValues, {}, fieldRefs);
    for(const key in data){
        const value1 = data[key];
        const fieldRef = fieldRefs && fieldRefs[key];
        if ($18522b4fc47f45cb$var$isTraversable(value1) && (!Array.isArray(value1) || !$18522b4fc47f45cb$var$isRegisteredLeaf(fieldRef))) {
            if ($18522b4fc47f45cb$var$isUndefined(formValues) || $18522b4fc47f45cb$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = $18522b4fc47f45cb$var$markFieldsDirty(value1, Array.isArray(value1) ? [] : {}, fieldRef);
            else $18522b4fc47f45cb$var$getDirtyFields(value1, $18522b4fc47f45cb$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key], fieldRef);
            if ($18522b4fc47f45cb$var$isEmptyDirtyContainer(dirtyFieldsFromValues[key])) $18522b4fc47f45cb$var$clearDirtyField(dirtyFieldsFromValues, key);
        } else if ($18522b4fc47f45cb$var$deepEqual(value1, formValues[key])) $18522b4fc47f45cb$var$clearDirtyField(dirtyFieldsFromValues, key);
        else dirtyFieldsFromValues[key] = true;
    }
    return dirtyFieldsFromValues;
}
var $18522b4fc47f45cb$var$getFieldArrayItemNames = (names, name)=>{
    const segments = name.split('.');
    const matches = [];
    let prefix = segments[0];
    for(let i = 1; i < segments.length; prefix += '.' + segments[i++])if (!isNaN(+segments[i]) && names.has(prefix)) matches.push(`${prefix}.${segments[i]}`);
    return matches;
};
var $18522b4fc47f45cb$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$18522b4fc47f45cb$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === '' ? NaN : value1 ? +value1 : value1 : valueAsDate && $18522b4fc47f45cb$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $18522b4fc47f45cb$var$getFieldValue(_f) {
    const ref = _f.ref;
    if ($18522b4fc47f45cb$var$isFileInput(ref)) return ref.files;
    if ($18522b4fc47f45cb$var$isRadioInput(ref)) return $18522b4fc47f45cb$var$getRadioValue(_f.refs).value;
    if ($18522b4fc47f45cb$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($18522b4fc47f45cb$var$isCheckBoxInput(ref)) return $18522b4fc47f45cb$var$getCheckboxValue(_f.refs).value;
    return $18522b4fc47f45cb$var$getFieldValueAs(ref.value, _f);
}
var $18522b4fc47f45cb$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        field && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $18522b4fc47f45cb$var$getRuleValue = (rule)=>$18522b4fc47f45cb$var$isUndefined(rule) ? rule : $18522b4fc47f45cb$var$isRegex(rule) ? rule.source : $18522b4fc47f45cb$var$isObject(rule) ? $18522b4fc47f45cb$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
const $18522b4fc47f45cb$var$ASYNC_FUNCTION = 'AsyncFunction';
var $18522b4fc47f45cb$var$hasPromiseValidation = (fieldReference)=>{
    if (!fieldReference || !fieldReference.validate) return false;
    if ($18522b4fc47f45cb$var$isFunction(fieldReference.validate)) return fieldReference.validate.constructor.name === $18522b4fc47f45cb$var$ASYNC_FUNCTION;
    if ($18522b4fc47f45cb$var$isObject(fieldReference.validate)) for(const key in fieldReference.validate){
        if (fieldReference.validate[key].constructor.name === $18522b4fc47f45cb$var$ASYNC_FUNCTION) return true;
    }
    return false;
};
var $18522b4fc47f45cb$var$hasValidation = (options)=>options.mount && (options.required || !$18522b4fc47f45cb$var$isUndefined(options.required) && options.required !== false || !$18522b4fc47f45cb$var$isUndefined(options.min) || !$18522b4fc47f45cb$var$isUndefined(options.max) || !$18522b4fc47f45cb$var$isUndefined(options.maxLength) || !$18522b4fc47f45cb$var$isUndefined(options.minLength) || options.pattern || options.validate);
function $18522b4fc47f45cb$var$schemaErrorLookup(errors, _fields, name) {
    const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name);
    if (error || $18522b4fc47f45cb$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split('.');
    while(names.length){
        const fieldName = names.join('.');
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $18522b4fc47f45cb$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        if (foundError && foundError.root && foundError.root.type) return {
            name: `${fieldName}.root`,
            error: foundError.root
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $18522b4fc47f45cb$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const keys = Object.keys(formStateData).filter((key)=>key !== 'name');
    return !keys.length || isRoot && keys.length >= Object.keys(_proxyFormState).length || keys.find((key)=>_proxyFormState[key] === (!isRoot || $18522b4fc47f45cb$var$VALIDATION_MODE.all));
};
var $18522b4fc47f45cb$var$shouldSubscribeByName = (name, signalName, exact)=>!name || !signalName || name === signalName || $18522b4fc47f45cb$var$convertToArrayPayload(name).some((currentName)=>currentName && (exact ? currentName === signalName || currentName.startsWith(signalName + '.') : currentName.startsWith(signalName) || signalName.startsWith(currentName)));
var $18522b4fc47f45cb$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $18522b4fc47f45cb$var$unsetEmptyArray = (ref, name)=>{
    const array = $18522b4fc47f45cb$export$3988ae62b71be9a3(ref, name);
    !$18522b4fc47f45cb$var$compact(array).length && !(array === null || array === void 0 ? void 0 : array.root) && $18522b4fc47f45cb$var$unset(ref, name);
};
const $18522b4fc47f45cb$var$defaultOptions = {
    mode: $18522b4fc47f45cb$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $18522b4fc47f45cb$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
const $18522b4fc47f45cb$var$FORM_ERROR_TYPE = 'form';
const $18522b4fc47f45cb$var$updateDirtyFields = (dirtyFields, nextDirtyFields)=>{
    for(const key in dirtyFields)if (!(key in nextDirtyFields)) delete dirtyFields[key];
    Object.assign(dirtyFields, nextDirtyFields);
};
const $18522b4fc47f45cb$var$DEFAULT_FORM_STATE = {
    submitCount: 0,
    isDirty: false,
    isReady: false,
    isValidating: false,
    isSubmitted: false,
    isSubmitting: false,
    isSubmitSuccessful: false,
    isValid: false,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {}
};
function $18522b4fc47f45cb$export$1361f5e0e4cca3c3(props = {}) {
    let _options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $18522b4fc47f45cb$var$defaultOptions, props);
    let _formState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$var$DEFAULT_FORM_STATE)), {
        isLoading: $18522b4fc47f45cb$var$isFunction(_options.defaultValues),
        errors: _options.errors || {},
        disabled: _options.disabled || false
    });
    let _fields = {};
    let _defaultValues = $18522b4fc47f45cb$var$isObject(_options.defaultValues) || $18522b4fc47f45cb$var$isObject(_options.values) ? $18522b4fc47f45cb$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $18522b4fc47f45cb$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        actionArrayLengths: new Map(),
        mount: false,
        watch: false,
        keepIsValid: false
    };
    let _names = {
        mount: new Set(),
        disabled: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set(),
        registerName: new Set()
    };
    const delayErrorCallbacks = {};
    const timers = {};
    let _valuesSubscriberCount = 0;
    let _validationModeBeforeSubmit = $18522b4fc47f45cb$var$getValidationModes(_options.mode);
    let _validationModeAfterSubmit = $18522b4fc47f45cb$var$getValidationModes(_options.reValidateMode);
    const defaultProxyFormState = {
        isDirty: false,
        dirtyFields: false,
        validatingFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _proxyFormState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProxyFormState);
    let _proxySubscribeFormState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _proxyFormState);
    const _subjects = {
        array: $18522b4fc47f45cb$var$createSubject(),
        state: $18522b4fc47f45cb$var$createSubject()
    };
    let _setValidCallId = 0;
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $18522b4fc47f45cb$var$VALIDATION_MODE.all;
    const debounce = (name, callback)=>(wait)=>{
            clearTimeout(timers[name]);
            timers[name] = setTimeout(callback, wait);
        };
    const _setValid = async (shouldUpdateValid)=>{
        if (_state.keepIsValid) return;
        if (!_options.disabled && (_proxyFormState.isValid || _proxySubscribeFormState.isValid || shouldUpdateValid)) {
            const callId = ++_setValidCallId;
            let isValid;
            if (_options.resolver) {
                isValid = $18522b4fc47f45cb$var$isEmptyObject((await _runSchema()).errors);
                callId === _setValidCallId && _updateIsValidating();
            } else isValid = await executeBuiltInValidation({
                fields: _fields,
                onlyCheckValid: true,
                eventType: $18522b4fc47f45cb$var$EVENTS.VALID
            });
            if (callId === _setValidCallId && isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (names, isValidating)=>{
        if (!_options.disabled && (_proxyFormState.isValidating || _proxyFormState.validatingFields || _proxySubscribeFormState.isValidating || _proxySubscribeFormState.validatingFields)) {
            (names || _names.mount).forEach((name)=>{
                if (name) isValidating ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.validatingFields, name, isValidating) : $18522b4fc47f45cb$var$unset(_formState.validatingFields, name);
            });
            _subjects.state.next({
                validatingFields: _formState.validatingFields,
                isValidating: !$18522b4fc47f45cb$var$isEmptyObject(_formState.validatingFields)
            });
        }
    };
    const _updateDirtyFields = ()=>{
        _formState.dirtyFields = $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues, undefined, _fields);
    };
    const _setFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method && !_options.disabled) {
            _state.action = true;
            const fields = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
            if (!_state.actionArrayLengths.has(name)) _state.actionArrayLengths.set(name, Array.isArray(fields) ? fields.length : 0);
            if (shouldUpdateFieldsAndState && Array.isArray(fields)) {
                const fieldValues = method(fields, args.argA, args.argB);
                shouldSetValues && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            const fieldArrayErrors = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name);
            if (shouldUpdateFieldsAndState && Array.isArray(fieldArrayErrors)) {
                const rootError = fieldArrayErrors.root;
                const errors = method(fieldArrayErrors, args.argA, args.argB) || fieldArrayErrors;
                if (rootError) errors.root = rootError;
                shouldSetValues && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $18522b4fc47f45cb$var$unsetEmptyArray(_formState.errors, name);
            }
            const touchedFieldsArray = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if ((_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && shouldUpdateFieldsAndState && Array.isArray(touchedFieldsArray)) {
                const touchedFields = method(touchedFieldsArray, args.argA, args.argB);
                shouldSetValues && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) _updateDirtyFields();
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _formState.errors = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState.errors);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const _setErrors = (errors)=>{
        _formState.errors = errors;
        _subjects.state.next({
            errors: _formState.errors,
            isValid: false
        });
    };
    const hasExplicitNullIntermediate = (name)=>{
        const segments = $18522b4fc47f45cb$var$isKey(name) ? [
            name
        ] : $18522b4fc47f45cb$var$stringToPath(name);
        let formValues = _formValues;
        let defaultValues = _defaultValues;
        for(let i = 0; i < segments.length - 1; i++){
            const key = segments[i];
            formValues = $18522b4fc47f45cb$var$isNullOrUndefined(formValues) ? formValues : formValues[key];
            defaultValues = $18522b4fc47f45cb$var$isNullOrUndefined(defaultValues) ? defaultValues : defaultValues[key];
            if (formValues === null && defaultValues !== null) return true;
        }
        return false;
    };
    const isStaleArrayIndex = (name)=>{
        if (!_state.actionArrayLengths.size) return false;
        const segments = $18522b4fc47f45cb$var$isKey(name) ? [
            name
        ] : $18522b4fc47f45cb$var$stringToPath(name);
        let node = _formValues;
        let path = '';
        let ownerDepth = -1;
        let ownerPreActionLength = 0;
        for(let i = 0; i < segments.length; i++){
            if ($18522b4fc47f45cb$var$isNullOrUndefined(node)) return false;
            const key = segments[i];
            path = path ? `${path}.${key}` : key;
            if (Array.isArray(node) && +key >= node.length) return ownerDepth === -1 ? false : i === ownerDepth ? +key < ownerPreActionLength : true;
            if (_state.actionArrayLengths.has(path)) {
                ownerDepth = i + 1;
                ownerPreActionLength = _state.actionArrayLengths.get(path);
            }
            node = node[key];
        }
        return false;
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            if (hasExplicitNullIntermediate(name) || isStaleArrayIndex(name)) return;
            const wasUnsetInFormValues = $18522b4fc47f45cb$var$isUndefined($18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, name));
            const defaultValue = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, name, $18522b4fc47f45cb$var$isUndefined(value1) ? $18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $18522b4fc47f45cb$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $18522b4fc47f45cb$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            if (_state.mount && !_state.action) {
                _setValid();
                if (wasUnsetInFormValues && _formState.isDirty && (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty)) {
                    const isDirty = _getDirty();
                    if (!isDirty) {
                        _formState.isDirty = false;
                        _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState));
                    }
                }
                if (props.shouldUnregister && wasUnsetInFormValues && !$18522b4fc47f45cb$var$isUndefined($18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, name)) && $18522b4fc47f45cb$var$isWatched(name, _names)) _state.watch = true;
            }
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        // an explicit programmatic update (e.g. setValue with shouldDirty: true)
        // opts into dirty tracking even when the form is disabled
        if (!_options.disabled || shouldDirty === true) {
            if (!isBlurEvent || shouldDirty) {
                const isCurrentFieldPristine = $18522b4fc47f45cb$var$deepEqual($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
                if (_proxyFormState.isDirty || _proxySubscribeFormState.isDirty) {
                    isPreviousDirty = _formState.isDirty;
                    _formState.isDirty = output.isDirty = !isCurrentFieldPristine || _getDirty();
                    shouldUpdateField = isPreviousDirty !== output.isDirty;
                }
                isPreviousDirty = !!$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.dirtyFields, name);
                if (isCurrentFieldPristine !== _formState.isDirty) $18522b4fc47f45cb$var$updateDirtyFields(_formState.dirtyFields, $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues, undefined, _fields));
                else isCurrentFieldPristine ? $18522b4fc47f45cb$var$unset(_formState.dirtyFields, name) : $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
                output.dirtyFields = _formState.dirtyFields;
                shouldUpdateField = shouldUpdateField || (_proxyFormState.dirtyFields || _proxySubscribeFormState.dirtyFields) && isPreviousDirty !== !isCurrentFieldPristine;
            }
            if (isBlurEvent) {
                const isPreviousFieldTouched = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name);
                if (!isPreviousFieldTouched) {
                    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                    output.touchedFields = _formState.touchedFields;
                    shouldUpdateField = shouldUpdateField || (_proxyFormState.touchedFields || _proxySubscribeFormState.touchedFields) && isPreviousFieldTouched !== isBlurEvent;
                }
            }
            shouldUpdateField && shouldRender && _subjects.state.next(output);
        }
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && $18522b4fc47f45cb$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (_options.delayError && error) {
            delayErrorCallbacks[name] = debounce(name, ()=>updateErrors(name, error));
            delayErrorCallbacks[name](_options.delayError);
        } else {
            clearTimeout(timers[name]);
            delete delayErrorCallbacks[name];
            error ? $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $18522b4fc47f45cb$var$unset(_formState.errors, name);
            _formState.errors = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState.errors);
        }
        if ((error ? !$18522b4fc47f45cb$var$deepEqual(previousFieldError, error) : previousFieldError) || !$18522b4fc47f45cb$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, fieldState, shouldUpdateValid && $18522b4fc47f45cb$var$isBoolean(isValid) ? {
                isValid: isValid
            } : {}), {
                errors: _formState.errors,
                name: name
            });
            _subjects.state.next(updatedFormState);
        }
    };
    const _runSchema = async (name)=>{
        _updateIsValidating(name, true);
        return await _options.resolver(_formValues, _options.context, $18522b4fc47f45cb$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    };
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _runSchema(names);
        _updateIsValidating(names);
        if (names) {
            for (const name of names){
                const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name);
                error ? _names.array.has(name) && $18522b4fc47f45cb$var$isObject(error) && !Object.keys(error).some((key)=>!Number.isNaN(Number(key))) ? $18522b4fc47f45cb$var$updateFieldArrayRootError(_formState.errors, {
                    [name]: error
                }, name) : $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $18522b4fc47f45cb$var$unset(_formState.errors, name);
            }
            _formState.errors = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState.errors);
        } else _formState.errors = errors;
        return errors;
    };
    const validateForm = async ({ name: name, eventType: eventType })=>{
        if (props.validate) {
            const result = await props.validate({
                formValues: _formValues,
                formState: _formState,
                name: name,
                eventType: eventType
            });
            if ($18522b4fc47f45cb$var$isObject(result)) for(const key in result){
                const error = result[key];
                if (error) setError(`${$18522b4fc47f45cb$var$FORM_ERROR_TYPE}.${key}`, {
                    message: $18522b4fc47f45cb$var$isString(error.message) ? error.message : '',
                    type: error.type || $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.validate
                });
            }
            else if ($18522b4fc47f45cb$var$isString(result) || !result) setError($18522b4fc47f45cb$var$FORM_ERROR_TYPE, {
                message: result || '',
                type: $18522b4fc47f45cb$var$INPUT_VALIDATION_RULES.validate
            });
            else clearErrors($18522b4fc47f45cb$var$FORM_ERROR_TYPE);
            return result;
        }
        return true;
    };
    const executeBuiltInValidation = async ({ fields: fields, onlyCheckValid: onlyCheckValid, name: name, eventType: eventType, context: context = {
        valid: true,
        runRootValidation: false
    } })=>{
        if (props.validate) {
            context.runRootValidation = true;
            const result = await validateForm({
                name: name,
                eventType: eventType
            });
            if (!result) {
                context.valid = false;
                if (onlyCheckValid) return context.valid;
            }
        }
        for(const _ref in fields){
            let name = _ref;
            const field = fields[name];
            if (field) {
                const { _f: _f } = field, fieldValue = (0, $8901fc92b5563702$export$71511d61b312f219)(field, [
                    "_f"
                ]);
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const isPromiseFunction = field._f && $18522b4fc47f45cb$var$hasPromiseValidation(field._f);
                    const shouldTrackIsValidatingState = _proxyFormState.validatingFields || _proxyFormState.isValidating || _proxySubscribeFormState.validatingFields || _proxySubscribeFormState.isValidating;
                    if (isPromiseFunction && shouldTrackIsValidatingState) _updateIsValidating([
                        _f.name
                    ], true);
                    const fieldError = await $18522b4fc47f45cb$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !onlyCheckValid, isFieldArrayRoot);
                    if (isPromiseFunction && shouldTrackIsValidatingState) _updateIsValidating([
                        _f.name
                    ]);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (onlyCheckValid) break;
                    }
                    !onlyCheckValid && ($18522b4fc47f45cb$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $18522b4fc47f45cb$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $18522b4fc47f45cb$var$unset(_formState.errors, _f.name));
                    if (props.shouldUseNativeValidation && fieldError[_f.name]) break;
                }
                !$18522b4fc47f45cb$var$isEmptyObject(fieldValue) && await executeBuiltInValidation({
                    context: context,
                    onlyCheckValid: onlyCheckValid,
                    fields: fieldValue,
                    name: name,
                    eventType: eventType
                });
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$18522b4fc47f45cb$var$live(ref)) : !$18522b4fc47f45cb$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, data), !$18522b4fc47f45cb$var$deepEqual(_state.mount ? _formValues : _defaultValues, _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$18522b4fc47f45cb$var$generateWatchOutput(names, _names, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _state.mount ? _formValues : $18522b4fc47f45cb$var$isUndefined(defaultValue) || $18522b4fc47f45cb$var$isString(names) ? _defaultValues : defaultValue), isGlobal, defaultValue);
    const _getFieldArray = (name)=>$18522b4fc47f45cb$var$compact($18522b4fc47f45cb$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, _options.shouldUnregister ? $18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {}, skipClone = false, skipRender = false, skipValueRender = false)=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, $18522b4fc47f45cb$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $18522b4fc47f45cb$var$isHTMLElement(fieldReference.ref) && $18522b4fc47f45cb$var$isNullOrUndefined(value1) ? '' : value1;
                if ($18522b4fc47f45cb$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($18522b4fc47f45cb$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.forEach((checkboxRef)=>{
                        if (!checkboxRef.defaultChecked || !checkboxRef.disabled) {
                            if (Array.isArray(fieldValue)) checkboxRef.checked = !!fieldValue.find((data)=>data === checkboxRef.value);
                            else checkboxRef.checked = fieldValue === checkboxRef.value || !!fieldValue;
                        }
                    });
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($18522b4fc47f45cb$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = '';
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type && !skipRender && !skipValueRender) _subjects.state.next({
                        name: name,
                        values: skipClone ? _formValues : $18522b4fc47f45cb$var$cloneObject(_formValues)
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, !skipRender);
        options.shouldValidate && trigger(name, {
            delayError: options.delayError
        });
    };
    const setFieldValues = (name, value1, options, skipClone = false, skipRender = false, skipValueRender = false)=>{
        if (_names.array.has(name)) _subjects.array.next({
            name: name,
            values: skipClone ? _formValues : $18522b4fc47f45cb$var$cloneObject(_formValues)
        });
        for(const fieldKey in value1){
            if (!value1.hasOwnProperty(fieldKey)) return;
            const fieldValue = value1[fieldKey];
            const fieldName = name + '.' + fieldKey;
            const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || $18522b4fc47f45cb$var$isObject(fieldValue) || field && !field._f) && !$18522b4fc47f45cb$var$isDateObject(fieldValue) ? setFieldValues(fieldName, fieldValue, options, skipClone, skipRender, skipValueRender) : setFieldValue(fieldName, fieldValue, options, skipClone, skipRender, skipValueRender);
        }
    };
    const _setValue = (name, value1, options, skipClone, skipStateEmit = false)=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = skipClone ? value1 : $18522b4fc47f45cb$var$cloneObject(value1);
        const previousValue = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, name);
        const isValueUnchanged = $18522b4fc47f45cb$var$deepEqual(previousValue, cloneValue);
        if (!isValueUnchanged) $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: skipClone ? _formValues : $18522b4fc47f45cb$var$cloneObject(_formValues)
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields || _proxySubscribeFormState.isDirty || _proxySubscribeFormState.dirtyFields) && options.shouldDirty) {
                _updateDirtyFields();
                if (!skipStateEmit) _subjects.state.next({
                    name: name,
                    dirtyFields: _formState.dirtyFields,
                    isDirty: _getDirty(name, cloneValue)
                });
            }
        } else {
            const isEmpty = Array.isArray(cloneValue) && !cloneValue.length || $18522b4fc47f45cb$var$isEmptyObject(cloneValue);
            const skipValueRender = !isValueUnchanged && !skipStateEmit;
            if (!field || field._f || $18522b4fc47f45cb$var$isNullOrUndefined(cloneValue) || isEmpty) setFieldValue(name, cloneValue, options, skipClone, skipStateEmit, skipValueRender);
            else setFieldValues(name, cloneValue, options, skipClone, skipStateEmit, skipValueRender);
        }
        if (!isValueUnchanged && !skipStateEmit) {
            const watched = $18522b4fc47f45cb$var$isWatched(name, _names);
            const values = skipClone ? _formValues : $18522b4fc47f45cb$var$cloneObject(_formValues);
            _subjects.state.next((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, watched && _formState), {
                name: _state.mount || watched ? name : undefined,
                values: values
            }));
            if (!isFieldArray) for (const itemName of $18522b4fc47f45cb$var$getFieldArrayItemNames(_names.array, name))_subjects.state.next({
                name: itemName,
                values: values
            });
        }
    };
    const setValue = (name, value1, options = {})=>_setValue(name, value1, options, false);
    const setValues = (formValues, options = {})=>{
        const updatedFormValues = $18522b4fc47f45cb$var$isFunction(formValues) ? formValues(_formValues) : formValues;
        if (!$18522b4fc47f45cb$var$deepEqual(_formValues, updatedFormValues)) {
            _formValues = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formValues, updatedFormValues);
            for (const fieldName of _names.mount)if ($18522b4fc47f45cb$var$has(updatedFormValues, fieldName)) _setValue(fieldName, $18522b4fc47f45cb$export$3988ae62b71be9a3(updatedFormValues, fieldName), options, true, true);
            _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState), {
                name: undefined,
                type: undefined
            }), _valuesSubscriberCount ? {
                values: _formValues
            } : {}));
            if (options.shouldValidate) _setValid();
        }
    };
    const onChange = async (event)=>{
        _state.mount = true;
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const _updateIsFieldValueUpdated = (fieldValue)=>{
            isFieldValueUpdated = Number.isNaN(fieldValue) || $18522b4fc47f45cb$var$isDateObject(fieldValue) && isNaN(fieldValue.getTime()) || $18522b4fc47f45cb$var$deepEqual(fieldValue, $18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, name, fieldValue));
        };
        if (field) {
            let error;
            let isValid;
            const fieldValue = target.type ? $18522b4fc47f45cb$var$getFieldValue(field._f) : $18522b4fc47f45cb$var$getEventValue(event);
            const isBlurEvent = event.type === $18522b4fc47f45cb$var$EVENTS.BLUR || event.type === $18522b4fc47f45cb$var$EVENTS.FOCUS_OUT;
            const hasNoValidationEffect = !$18522b4fc47f45cb$var$hasValidation(field._f) && !props.validate && !_options.resolver && !$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps;
            const shouldSkipValidation = hasNoValidationEffect || $18522b4fc47f45cb$var$skipValidation(isBlurEvent, $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, _validationModeAfterSubmit, _validationModeBeforeSubmit);
            const watched = $18522b4fc47f45cb$var$isWatched(name, _names, isBlurEvent);
            $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                if (!target || !target.readOnly) {
                    field._f.onBlur && field._f.onBlur(event);
                    const pendingDelayError = delayErrorCallbacks[name];
                    pendingDelayError && pendingDelayError(0);
                }
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent);
            const shouldRender = !$18522b4fc47f45cb$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                name: name,
                type: event.type
            }, _valuesSubscriberCount ? {
                values: $18522b4fc47f45cb$var$cloneObject(_formValues)
            } : {}));
            if (shouldSkipValidation) {
                if ((!hasNoValidationEffect || !_formState.isValid) && (_proxyFormState.isValid || _proxySubscribeFormState.isValid)) {
                    if (_options.mode === 'onBlur') {
                        if (isBlurEvent) _setValid();
                    } else if (!isBlurEvent) _setValid();
                }
                return shouldRender && _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    name: name
                }, watched ? {} : fieldState));
            }
            if (!_options.resolver && props.validate) await validateForm({
                name: name,
                eventType: event.type
            });
            !isBlurEvent && watched && _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState));
            if (_options.resolver) {
                const { errors: errors } = await _runSchema([
                    name
                ]);
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (!isFieldValueUpdated) {
                    !$18522b4fc47f45cb$var$isEmptyObject(fieldState) && _subjects.state.next(fieldState);
                    return;
                }
                const previousErrorLookupResult = $18522b4fc47f45cb$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $18522b4fc47f45cb$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $18522b4fc47f45cb$var$isEmptyObject(errors);
            } else {
                _updateIsValidating([
                    name
                ], true);
                error = (await $18522b4fc47f45cb$var$validateField(field, _names.disabled, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                _updateIsValidating([
                    name
                ]);
                _updateIsFieldValueUpdated(fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid || _proxySubscribeFormState.isValid) isValid = await executeBuiltInValidation({
                        fields: _fields,
                        onlyCheckValid: true,
                        name: name,
                        eventType: event.type
                    });
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && (!Array.isArray(field._f.deps) || field._f.deps.length > 0) && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const _focusInput = (ref, key)=>{
        if ($18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, key) && ref.focus) {
            ref.focus();
            return 1;
        }
        return;
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $18522b4fc47f45cb$var$convertToArrayPayload(name);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($18522b4fc47f45cb$var$isUndefined(name) ? name : fieldNames);
            isValid = $18522b4fc47f45cb$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$18522b4fc47f45cb$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation({
                    fields: field && field._f ? {
                        [fieldName]: field
                    } : field,
                    eventType: $18522b4fc47f45cb$var$EVENTS.TRIGGER
                });
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _setValid();
        } else validationResult = isValid = await executeBuiltInValidation({
            fields: _fields,
            name: name,
            eventType: $18522b4fc47f45cb$var$EVENTS.TRIGGER
        });
        if (options.delayError && _options.delayError && $18522b4fc47f45cb$var$isString(name)) {
            const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name);
            if (error) {
                $18522b4fc47f45cb$var$unset(_formState.errors, name);
                delayErrorCallbacks[name] = debounce(name, ()=>updateErrors(name, error));
                delayErrorCallbacks[name](_options.delayError);
            } else {
                clearTimeout(timers[name]);
                delete delayErrorCallbacks[name];
            }
        }
        _subjects.state.next((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, !$18522b4fc47f45cb$var$isString(name) || (_proxyFormState.isValid || _proxySubscribeFormState.isValid) && isValid !== _formState.isValid ? {} : {
            name: name
        }, _options.resolver || !name ? {
            isValid: isValid
        } : {}), {
            errors: _formState.errors
        }));
        options.shouldFocus && !validationResult && $18522b4fc47f45cb$var$iterateFieldsByAction(_fields, _focusInput, name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames, config)=>{
        let values = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _state.mount ? _formValues : _defaultValues);
        if (config) values = $18522b4fc47f45cb$var$extractFormValues(config.dirtyFields ? _formState.dirtyFields : _formState.touchedFields, values);
        return $18522b4fc47f45cb$var$isUndefined(fieldNames) ? values : $18522b4fc47f45cb$var$isString(fieldNames) ? $18522b4fc47f45cb$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$18522b4fc47f45cb$export$3988ae62b71be9a3(values, name));
    };
    const getErrors = (fieldNames)=>$18522b4fc47f45cb$var$isUndefined(fieldNames) ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState.errors) : $18522b4fc47f45cb$var$isString(fieldNames) ? $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, fieldNames) : fieldNames.map((name)=>$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name));
    const getFieldState = (name, formState)=>{
        const targetFormState = formState || _formState;
        const error = $18522b4fc47f45cb$export$3988ae62b71be9a3(targetFormState.errors, name);
        return {
            invalid: !!error,
            isDirty: !!$18522b4fc47f45cb$export$3988ae62b71be9a3(targetFormState.dirtyFields, name),
            error: error,
            isValidating: !!$18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.validatingFields, name),
            isTouched: !!$18522b4fc47f45cb$export$3988ae62b71be9a3(targetFormState.touchedFields, name)
        };
    };
    const clearErrors = (name)=>{
        const names = name ? $18522b4fc47f45cb$var$convertToArrayPayload(name) : undefined;
        names === null || names === void 0 || names.forEach((inputName)=>$18522b4fc47f45cb$var$unset(_formState.errors, inputName));
        if (names) names.forEach((inputName)=>{
            _subjects.state.next({
                name: inputName,
                errors: _formState.errors
            });
        });
        else {
            _formState.errors = {};
            _subjects.state.next({
                errors: _formState.errors
            });
        }
    };
    const setError = (name, error, options)=>{
        const ref = ($18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        const currentError = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.errors, name) || {};
        const { ref: currentRef, message: message, type: type } = currentError, restOfErrorTree = (0, $8901fc92b5563702$export$71511d61b312f219)(currentError, [
            "ref",
            "message",
            "type"
        ]);
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formState.errors, name, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, restOfErrorTree, error), {
            ref: ref
        }));
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>{
        if ($18522b4fc47f45cb$var$isFunction(name)) {
            _valuesSubscriberCount++;
            const { unsubscribe: unsubscribe } = _subjects.state.subscribe({
                next: (payload)=>'values' in payload && name(payload.values || _getWatch(undefined, defaultValue), payload)
            });
            let called = false;
            return {
                unsubscribe: ()=>{
                    if (called) return;
                    called = true;
                    _valuesSubscriberCount--;
                    unsubscribe();
                }
            };
        }
        return _getWatch(name, defaultValue, true);
    };
    const _subscribe = (props)=>{
        var _a;
        const needsValues = !!((_a = props.formState) === null || _a === void 0 ? void 0 : _a.values);
        if (needsValues) _valuesSubscriberCount++;
        const { unsubscribe: unsubscribe } = _subjects.state.subscribe({
            next: (formState)=>{
                if ($18522b4fc47f45cb$var$shouldSubscribeByName(props.name, formState.name, props.exact) && $18522b4fc47f45cb$var$shouldRenderFormState(formState, props.formState || _proxyFormState, _setFormState, props.reRenderRoot)) {
                    const snapshot = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formValues);
                    props.callback((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                        values: snapshot
                    }, _formState, formState), {
                        defaultValues: _defaultValues
                    }));
                }
            }
        });
        if (!needsValues) return unsubscribe;
        let called = false;
        return ()=>{
            if (called) return;
            called = true;
            _valuesSubscriberCount--;
            unsubscribe();
        };
    };
    const subscribe = (props)=>{
        _state.mount = true;
        _proxySubscribeFormState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _proxySubscribeFormState, props.formState);
        return _subscribe((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
            formState: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, defaultProxyFormState, props.formState)
        }));
    };
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $18522b4fc47f45cb$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $18522b4fc47f45cb$var$unset(_fields, fieldName);
                $18522b4fc47f45cb$var$unset(_formValues, fieldName);
            }
            !options.keepError && $18522b4fc47f45cb$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $18522b4fc47f45cb$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $18522b4fc47f45cb$var$unset(_formState.touchedFields, fieldName);
            !options.keepIsValidating && $18522b4fc47f45cb$var$unset(_formState.validatingFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $18522b4fc47f45cb$var$unset(_defaultValues, fieldName);
        }
        _valuesSubscriberCount && _subjects.state.next({
            values: $18522b4fc47f45cb$var$cloneObject(_formValues)
        });
        _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState, options.keepDirty ? {} : {
            isDirty: _getDirty()
        }));
        !options.keepIsValid && _setValid();
    };
    const _setDisabledField = ({ disabled: disabled, name: name })=>{
        if ($18522b4fc47f45cb$var$isBoolean(disabled) && _state.mount || !!disabled || _names.disabled.has(name)) {
            const wasDisabled = _names.disabled.has(name);
            const isDisabled = !!disabled;
            const disabledStateChanged = wasDisabled !== isDisabled;
            disabled ? _names.disabled.add(name) : _names.disabled.delete(name);
            disabledStateChanged && _state.mount && !_state.action && _setValid();
        }
    };
    const register = (name, options = {})=>{
        let field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $18522b4fc47f45cb$var$isBoolean(options.disabled) || $18522b4fc47f45cb$var$isBoolean(_options.disabled);
        const shouldRevalidateRemount = !_names.registerName.has(name) && field && field._f && !field._f.mount;
        $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_fields, name, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, field || {}), {
            _f: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, field && field._f ? field._f : {
                ref: {
                    name: name
                }
            }), {
                name: name,
                mount: true
            }), options)
        }));
        _names.mount.add(name);
        if (field && !shouldRevalidateRemount) _setDisabledField({
            disabled: $18522b4fc47f45cb$var$isBoolean(options.disabled) ? options.disabled : _options.disabled,
            name: name
        });
        else updateValidAndValue(name, true, options.value);
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, disabledIsDefined ? {
            disabled: options.disabled || _options.disabled
        } : {}, _options.progressive ? {
            required: !!options.required,
            min: $18522b4fc47f45cb$var$getRuleValue(options.min),
            max: $18522b4fc47f45cb$var$getRuleValue(options.max),
            minLength: $18522b4fc47f45cb$var$getRuleValue(options.minLength),
            maxLength: $18522b4fc47f45cb$var$getRuleValue(options.maxLength),
            pattern: $18522b4fc47f45cb$var$getRuleValue(options.pattern)
        } : {}), {
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    _names.registerName.add(name);
                    register(name, options);
                    _names.registerName.delete(name);
                    field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $18522b4fc47f45cb$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll('input,select,textarea')[0] || ref : ref : ref;
                    const radioOrCheckbox = $18522b4fc47f45cb$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    const newField = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, field._f);
                    if (radioOrCheckbox) {
                        newField.refs = [
                            ...refs.filter($18522b4fc47f45cb$var$live),
                            fieldRef,
                            ...Array.isArray($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                {}
                            ] : []
                        ];
                        newField.ref = {
                            type: fieldRef.type,
                            name: name
                        };
                    } else {
                        newField.ref = fieldRef;
                        delete newField.refs;
                    }
                    $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: newField
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($18522b4fc47f45cb$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        });
    };
    const _focusError = ()=>_options.shouldFocusError && !_options.shouldUseNativeValidation && $18522b4fc47f45cb$var$iterateFieldsByAction(_fields, _focusInput, _names.mount);
    const _disableForm = (disabled)=>{
        if ($18522b4fc47f45cb$var$isBoolean(disabled)) {
            _subjects.state.next({
                disabled: disabled
            });
            $18522b4fc47f45cb$var$iterateFieldsByAction(_fields, (ref, name)=>{
                const currentField = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
                if (currentField) {
                    ref.disabled = currentField._f.disabled || disabled;
                    if (Array.isArray(currentField._f.refs)) currentField._f.refs.forEach((inputRef)=>{
                        inputRef.disabled = currentField._f.disabled || disabled;
                    });
                }
            }, 0, false);
        }
    };
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            let result = undefined;
            let onValidError = undefined;
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $18522b4fc47f45cb$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _runSchema();
                _updateIsValidating();
                _formState.errors = errors;
                fieldValues = $18522b4fc47f45cb$var$cloneObject(values);
            } else await executeBuiltInValidation({
                fields: _fields,
                eventType: $18522b4fc47f45cb$var$EVENTS.SUBMIT
            });
            if (_names.disabled.size) for (const name of _names.disabled)$18522b4fc47f45cb$var$unset(fieldValues, name);
            $18522b4fc47f45cb$var$unset(_formState.errors, $18522b4fc47f45cb$var$ROOT_ERROR_TYPE);
            if ($18522b4fc47f45cb$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                try {
                    result = await onValid(fieldValues, e);
                } catch (error) {
                    onValidError = error;
                }
            } else {
                if (onInvalid) await onInvalid((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState.errors), e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $18522b4fc47f45cb$var$isEmptyObject(_formState.errors) && !onValidError,
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
            if (onValidError) throw onValidError;
            return result;
        };
    const resetField = (name, options = {})=>{
        if ($18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name)) {
            if ($18522b4fc47f45cb$var$isUndefined(options.defaultValue)) setValue(name, $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name)));
            else {
                setValue(name, options.defaultValue);
                $18522b4fc47f45cb$export$adaa4cf7ef1b65be(_defaultValues, name, $18522b4fc47f45cb$var$cloneObject(options.defaultValue));
            }
            if (!options.keepTouched) $18522b4fc47f45cb$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $18522b4fc47f45cb$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$export$3988ae62b71be9a3(_defaultValues, name))) : _getDirty();
            }
            if (!options.keepError) {
                $18522b4fc47f45cb$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _setValid();
            }
            _subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState));
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues ? $18522b4fc47f45cb$var$cloneObject(formValues) : _defaultValues;
        const cloneUpdatedValues = $18522b4fc47f45cb$var$cloneObject(updatedValues);
        const isEmptyResetValues = $18522b4fc47f45cb$var$isEmptyObject(formValues);
        const values = cloneUpdatedValues;
        const fieldRefs = _fields;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues) {
                const fieldsToCheck = new Set([
                    ..._names.mount,
                    ...$18522b4fc47f45cb$var$collectDirtyFieldNames($18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues, undefined, fieldRefs), _formState.dirtyFields)
                ]);
                for (const fieldName of fieldsToCheck){
                    const isDirty = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName);
                    const existingValue = $18522b4fc47f45cb$export$3988ae62b71be9a3(_formValues, fieldName);
                    const newValue = $18522b4fc47f45cb$export$3988ae62b71be9a3(values, fieldName);
                    if (isDirty && !$18522b4fc47f45cb$var$isUndefined(existingValue)) $18522b4fc47f45cb$export$adaa4cf7ef1b65be(values, fieldName, existingValue);
                    else if (!isDirty && !$18522b4fc47f45cb$var$isUndefined(newValue)) setValue(fieldName, newValue);
                }
            } else {
                if ($18522b4fc47f45cb$var$isWeb && $18522b4fc47f45cb$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($18522b4fc47f45cb$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest('form');
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)setValue(fieldName, $18522b4fc47f45cb$export$3988ae62b71be9a3(values, fieldName));
                else _fields = {};
            }
            if (_options.shouldUnregister) {
                _formValues = keepStateOptions.keepDefaultValues ? $18522b4fc47f45cb$var$cloneObject(_defaultValues) : {};
                if (keepStateOptions.keepFieldsRef) for (const fieldName of _names.mount)$18522b4fc47f45cb$export$adaa4cf7ef1b65be(_formValues, fieldName, $18522b4fc47f45cb$export$3988ae62b71be9a3(values, fieldName));
            } else _formValues = $18522b4fc47f45cb$var$cloneObject(values);
            _subjects.array.next({
                values: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, values)
            });
            _subjects.state.next({
                name: undefined,
                type: undefined,
                values: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, values)
            });
        }
        _names = {
            mount: keepStateOptions.keepDirtyValues ? _names.mount : new Set(),
            unMount: new Set(),
            array: new Set(),
            registerName: new Set(),
            disabled: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ''
        };
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid || !!keepStateOptions.keepDirtyValues || !_options.shouldUnregister && !$18522b4fc47f45cb$var$isEmptyObject(values);
        _state.watch = !!_options.shouldUnregister;
        _state.keepIsValid = !!keepStateOptions.keepIsValid;
        _state.action = false;
        _state.actionArrayLengths.clear();
        if (!keepStateOptions.keepErrors) _formState.errors = {};
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: isEmptyResetValues ? false : keepStateOptions.keepDirty ? _formState.isDirty : keepStateOptions.keepValues ? _getDirty() : !!(keepStateOptions.keepDefaultValues && !$18522b4fc47f45cb$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: isEmptyResetValues ? {} : keepStateOptions.keepDirtyValues ? keepStateOptions.keepDefaultValues && _formValues ? $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues, undefined, fieldRefs) : _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, formValues, undefined, fieldRefs) : keepStateOptions.keepDirty ? _formState.dirtyFields : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitSuccessful: keepStateOptions.keepIsSubmitSuccessful ? _formState.isSubmitSuccessful : false,
            isSubmitting: false,
            defaultValues: _defaultValues
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($18522b4fc47f45cb$var$isFunction(formValues) ? formValues(_formValues) : formValues, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _options.resetOptions, keepStateOptions));
    const setFocus = (name, options = {})=>{
        const field = $18522b4fc47f45cb$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) setTimeout(()=>{
                fieldRef.focus();
                options.shouldSelect && $18522b4fc47f45cb$var$isFunction(fieldRef.select) && fieldRef.select();
            });
        }
    };
    const _setFormState = (updatedFormState)=>{
        // `name`, `type`, and `values` describe the event that produced this
        // update, not the form's persisted state (they aren't part of
        // `FormState`). Merging them in would leak a stale `name`/`type` from
        // one event into a later, unrelated notification that doesn't specify
        // its own.
        const { name: name, type: type, values: values } = updatedFormState, formState = (0, $8901fc92b5563702$export$71511d61b312f219)(updatedFormState, [
            "name",
            "type",
            "values"
        ]);
        _formState = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState, formState);
    };
    _subjects.state.subscribe({
        next: _setFormState
    });
    const _resetDefaultValues = ()=>$18522b4fc47f45cb$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    const resetDefaultValues = (values, options = {})=>{
        _defaultValues = $18522b4fc47f45cb$var$cloneObject(values);
        if (!options.keepDirty) {
            const newDirtyFields = $18522b4fc47f45cb$var$getDirtyFields(_defaultValues, _formValues, undefined, _fields);
            _formState.dirtyFields = newDirtyFields;
            _formState.isDirty = !$18522b4fc47f45cb$var$isEmptyObject(newDirtyFields);
        }
        if (!options.keepIsValid) _setValid();
        _subjects.state.next((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _formState), {
            defaultValues: _defaultValues
        }));
    };
    const methods = {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            handleSubmit: handleSubmit,
            setError: setError,
            _subscribe: _subscribe,
            _runSchema: _runSchema,
            _updateIsValidating: _updateIsValidating,
            _focusError: _focusError,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _setValid: _setValid,
            _setFieldArray: _setFieldArray,
            _setDisabledField: _setDisabledField,
            _setErrors: _setErrors,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _removeUnmounted: _removeUnmounted,
            _disableForm: _disableForm,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, _options, value);
                _validationModeBeforeSubmit = $18522b4fc47f45cb$var$getValidationModes(_options.mode);
                _validationModeAfterSubmit = $18522b4fc47f45cb$var$getValidationModes(_options.reValidateMode);
            }
        },
        subscribe: subscribe,
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        setValues: setValues,
        getValues: getValues,
        getErrors: getErrors,
        reset: reset,
        resetField: resetField,
        resetDefaultValues: resetDefaultValues,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, methods), {
        formControl: methods
    });
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/docs/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <button>Submit</button>
 *     </form>
 *   );
 * }
 * ```
 */ function $18522b4fc47f45cb$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(undefined);
    const _values = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(undefined);
    const _formControlProp = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(props.formControl);
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $18522b4fc47f45cb$var$cloneObject($18522b4fc47f45cb$var$DEFAULT_FORM_STATE)), {
            isLoading: $18522b4fc47f45cb$var$isFunction(props.defaultValues),
            errors: props.errors || {},
            disabled: props.disabled || false,
            defaultValues: $18522b4fc47f45cb$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
        }));
    if (!_formControl.current || props.formControl && _formControlProp.current !== props.formControl) {
        _formControlProp.current = props.formControl;
        if (props.formControl) {
            _formControl.current = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props.formControl), {
                formState: formState
            });
            if (props.defaultValues && !$18522b4fc47f45cb$var$isFunction(props.defaultValues)) props.formControl.reset(props.defaultValues, props.resetOptions);
        } else {
            const _createFormControl = $18522b4fc47f45cb$export$1361f5e0e4cca3c3(props), { formControl: formControl } = _createFormControl, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(_createFormControl, [
                "formControl"
            ]);
            _formControl.current = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rest), {
                formState: formState
            });
        }
    }
    const control = _formControl.current.control;
    control._options = props;
    const { resyncIfNeeded: resyncIfNeeded, snapshot: snapshot } = $18522b4fc47f45cb$var$useResyncOnReconnect();
    $18522b4fc47f45cb$var$useIsomorphicLayoutEffect(()=>{
        const getCurrentFormState = ()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState), {
                defaultValues: control._defaultValues
            });
        resyncIfNeeded(true, getCurrentFormState, updateFormState);
        const unsubscribe = control._subscribe({
            formState: control._proxyFormState,
            callback: ()=>updateFormState((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState), {
                    defaultValues: control._defaultValues
                })),
            reRenderRoot: true
        });
        updateFormState((data)=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, data), {
                isReady: true
            }));
        control._formState.isReady = true;
        return ()=>{
            unsubscribe();
            snapshot(true, getCurrentFormState);
        };
    }, [
        control,
        resyncIfNeeded,
        snapshot
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>control._disableForm(props.disabled), [
        control,
        props.disabled
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (props.mode) control._options.mode = props.mode;
        if (props.reValidateMode) control._options.reValidateMode = props.reValidateMode;
    }, [
        control,
        props.mode,
        props.reValidateMode
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (props.errors) {
            control._setErrors(props.errors);
            control._focusError();
        }
    }, [
        control,
        props.errors
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        props.shouldUnregister && control._subjects.state.next({
            values: control._getWatch()
        });
    }, [
        control,
        props.shouldUnregister
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (control._proxyFormState.isDirty) {
            const isDirty = control._getDirty();
            if (isDirty !== formState.isDirty) control._subjects.state.next({
                isDirty: isDirty
            });
        }
    }, [
        control,
        formState.isDirty
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        var _a;
        if (props.values && !$18522b4fc47f45cb$var$deepEqual(props.values, _values.current)) {
            control._reset(props.values, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                keepFieldsRef: true
            }, control._options.resetOptions));
            if (!((_a = control._options.resetOptions) === null || _a === void 0 ? void 0 : _a.keepIsValid)) control._setValid();
            _values.current = props.values;
            updateFormState((state)=>(0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state));
        } else control._resetDefaultValues();
    }, [
        control,
        props.values
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (!control._state.mount) {
            control._setValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, control._formState));
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$18522b4fc47f45cb$var$getProxyFormState(formState, control), [
        control,
        formState
    ]);
    return _formControl.current;
}
/**
 * Watch component that subscribes to form field changes and re-renders when watched fields update.
 *
 * @param control - The form control object from useForm
 * @param name - Can be field name, array of field names, or undefined to watch the entire form
 * @param disabled - Disable subscription
 * @param exact - Whether to watch exact field names or not
 * @param defaultValue - The default value to use if the field is not yet set
 * @param compute - Function to compute derived values from watched fields
 * @param render - The function that receives watched values and returns ReactNode
 * @returns The result of calling render function with watched values
 *
 * @example
 * The `Watch` component only re-render when the values of `foo`, `bar`, and `baz.qux` change.
 * The types of `foo`, `bar`, and `baz.qux` are precisely inferred.
 *
 * ```tsx
 * const { control } = useForm();
 *
 * <Watch
 *   control={control}
 *   names={['foo', 'bar', 'baz.qux']}
 *   render={([foo, bar, baz_qux]) => <div>{foo}{bar}{baz_qux}</div>}
 * />
 * ```
 */ const $18522b4fc47f45cb$export$4c68f1a79f88778c = (props)=>props.render($18522b4fc47f45cb$export$3c773aa2b84f29e0((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        name: props.names
    }, props)));





const $03cc89b08c95a526$var$MAX_SUGGESTIONS = 20;
const $03cc89b08c95a526$export$46e2350fcb6648d6 = (props)=>{
    if (props.suggestions.length > 0) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($03cc89b08c95a526$export$98ebf1e8b27e7503, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props));
    else return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).textInput,
        size: 40,
        autoFocus: true
    }, props.register(props.inputName)));
};
const $03cc89b08c95a526$export$98ebf1e8b27e7503 = ({ autofocus: autofocus, suggestions: suggestions, control: control, inputName: inputName, placeholder: placeholder, initialInputValue: initialInputValue, setValue: setValue })=>{
    const [items, setItems] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(suggestions.slice(0, $03cc89b08c95a526$var$MAX_SUGGESTIONS));
    const iconComponentFor = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$4fd464b2b09e1c4d));
    const enableAutoComplete = suggestions.length > 0;
    const { isOpen: isOpen, getToggleButtonProps: getToggleButtonProps, getMenuProps: getMenuProps, getInputProps: getInputProps, highlightedIndex: highlightedIndex, getItemProps: getItemProps, selectedItem: selectedItem } = (0, $837ff71814b5dbdb$export$7a023a466c03eb3d)({
        initialInputValue: initialInputValue,
        onInputValueChange ({ inputValue: inputValue = "" }) {
            setValue(inputName, inputValue);
            inputValue = inputValue.toLowerCase() || "";
            const matchingItems = [];
            for (const suggestion of suggestions)if (suggestion.toLowerCase().includes(inputValue)) {
                matchingItems.push(suggestion);
                if (matchingItems.length >= $03cc89b08c95a526$var$MAX_SUGGESTIONS) break;
            }
            setItems(matchingItems);
        },
        items: items,
        itemToString (item) {
            return item !== null && item !== void 0 ? item : "";
        }
    });
    const dropdownIsVisible = isOpen && items.length > 0;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).downshiftAutocompleteContainer
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        "data-visible-dropdown": dropdownIsVisible,
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).downshiftInputWrapper
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $18522b4fc47f45cb$export$bd0bf19f25da8474), {
        name: inputName,
        control: control,
        render: ({ field: field })=>{
            const downshiftSrcProps = getInputProps();
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, downshiftSrcProps), {
                name: field.name,
                placeholder: placeholder,
                className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).downshiftInput,
                size: 30,
                "data-editor-dialog": true,
                autoFocus: autofocus
            }));
        }
    }), enableAutoComplete && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        "aria-label": "toggle menu",
        type: "button"
    }, getToggleButtonProps()), iconComponentFor("arrow_drop_down"))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).downshiftAutocompleteContainer
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("ul", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, getMenuProps()), {
        "data-visible": dropdownIsVisible
    }), items.map((item, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("li", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            "data-selected": selectedItem === item,
            "data-highlighted": highlightedIndex === index,
            key: `${item}${index}`
        }, getItemProps({
            item: item,
            index: index
        })), item)))));
};








(0, $3e88191b87395c2e$export$8d4021544bdece00)();
function $28c72891a80f4ac7$export$6136f52e5ca47c2d({ url: url, title: title, text: text, onSubmit: onSubmit, onCancel: onCancel, linkAutocompleteSuggestions: linkAutocompleteSuggestions, showLinkTitleField: showLinkTitleField, showAnchorTextField: showAnchorTextField }) {
    const { register: register, handleSubmit: handleSubmit, control: control, setValue: setValue, reset: _ } = (0, $18522b4fc47f45cb$export$87c0cf8eb5a167e0)({
        values: {
            url: url,
            title: title,
            text: text
        }
    });
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("form", {
        onSubmit: (e)=>{
            handleSubmit(onSubmit)(e);
            e.stopPropagation();
            e.preventDefault();
        },
        onReset: (e)=>{
            e.stopPropagation();
            onCancel();
        },
        onKeyDown: (e)=>{
            if (e.key === "Escape") {
                e.stopPropagation();
                onCancel();
            }
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).multiFieldForm, (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).linkDialogEditForm)
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).formField
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
        htmlFor: "link-url"
    }, t("createLink.url", "URL")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $03cc89b08c95a526$export$46e2350fcb6648d6), {
        register: register,
        initialInputValue: url,
        inputName: "url",
        suggestions: linkAutocompleteSuggestions,
        setValue: setValue,
        control: control,
        placeholder: t("createLink.urlPlaceholder", "Select or paste an URL"),
        autofocus: true
    })), showAnchorTextField ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).formField
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
        htmlFor: "link-text",
        title: t("createLink.textTooltip", "The text to be displayed for the link")
    }, t("createLink.text", "Anchor text")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "link-text",
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).textInput,
        size: 40
    }, register("text")))) : null, showLinkTitleField ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).formField
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("label", {
        htmlFor: "link-title",
        title: t("createLink.titleTooltip", "The link's title attribute, shown on hover")
    }, t("createLink.title", "Link title")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("input", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        id: "link-title",
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).textInput,
        size: 40
    }, register("title")))) : null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        style: {
            display: "flex",
            justifyContent: "flex-end",
            gap: "var(--spacing-2)"
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
        type: "submit",
        title: t("createLink.saveTooltip", "Set URL"),
        "aria-label": t("createLink.saveTooltip", "Set URL"),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).primaryButton)
    }, t("dialogControls.save", "Save")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
        type: "reset",
        title: t("createLink.cancelTooltip", "Cancel change"),
        "aria-label": t("createLink.cancelTooltip", "Cancel change"),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).secondaryButton)
    }, t("dialogControls.cancel", "Cancel"))));
}
const $28c72891a80f4ac7$export$f347b363d1b7f68a = ()=>{
    const [editorRootElementRef, contentEditableWrapperElement, activeEditor, iconComponentFor, linkDialogState, linkAutocompleteSuggestions, onClickLinkCallback, showLinkTitleField] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $5a7e051e41645429$export$48bc1afe38b0f854), (0, $5a7e051e41645429$export$bbe0055b1b3bac82), (0, $5a7e051e41645429$export$e02bd6a7b04ae431), (0, $5a7e051e41645429$export$4fd464b2b09e1c4d), (0, $2a1e7a4c7a8785c8$export$27c4c34d17f02d28), (0, $2a1e7a4c7a8785c8$export$1d74c23caea3638b), (0, $2a1e7a4c7a8785c8$export$9994919b6f3c165d), (0, $2a1e7a4c7a8785c8$export$94506a020c1f4f6d));
    const publishWindowChange = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $2a1e7a4c7a8785c8$export$974a394b185d5055));
    const updateLink = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $2a1e7a4c7a8785c8$export$d858b86bf7fdc1ff));
    const cancelLinkEdit = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $2a1e7a4c7a8785c8$export$4968cad4d9984bc3));
    const switchFromPreviewToLinkEdit = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $2a1e7a4c7a8785c8$export$5d11d0959bf419ec));
    const removeLink = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $2a1e7a4c7a8785c8$export$48585fc9af4c6c72));
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        const scrollContainer = contentEditableWrapperElement == null ? void 0 : contentEditableWrapperElement.closest(".mdxeditor-root-contenteditable");
        const update = ()=>{
            activeEditor == null || activeEditor.getEditorState().read(()=>{
                publishWindowChange(true);
            });
        };
        window.addEventListener("resize", update);
        window.addEventListener("scroll", update);
        scrollContainer == null || scrollContainer.addEventListener("scroll", update);
        return ()=>{
            window.removeEventListener("resize", update);
            window.removeEventListener("scroll", update);
            scrollContainer == null || scrollContainer.removeEventListener("scroll", update);
        };
    }, [
        activeEditor,
        contentEditableWrapperElement,
        publishWindowChange
    ]);
    const [copyUrlTooltipOpen, setCopyUrlTooltipOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    if (linkDialogState.type === "inactive") return null;
    const theRect = linkDialogState.rectangle;
    const urlIsExternal = linkDialogState.type === "preview" && linkDialogState.url.startsWith("http");
    var _linkDialogState_href;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$be92b6f5f03c0fe9, {
        open: true
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$b688253958b8dfe7, {
        "data-visible": linkDialogState.type === "edit",
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).linkDialogAnchor,
        style: {
            top: `${theRect.top}px`,
            left: `${theRect.left}px`,
            width: `${theRect.width}px`,
            height: `${theRect.height}px`
        }
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$602eac185826482c, {
        container: editorRootElementRef == null ? void 0 : editorRootElementRef.current
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$7c6e2c02157bb7d2, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).linkDialogPopoverContent),
        sideOffset: 5,
        updatePositionStrategy: "always",
        onOpenAutoFocus: (e)=>{
            e.preventDefault();
        },
        key: linkDialogState.linkNodeKey
    }, linkDialogState.type === "edit" && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($28c72891a80f4ac7$export$6136f52e5ca47c2d, {
        url: linkDialogState.url,
        title: linkDialogState.title,
        text: linkDialogState.text,
        onSubmit: updateLink,
        onCancel: cancelLinkEdit.bind(null),
        linkAutocompleteSuggestions: linkAutocompleteSuggestions,
        showLinkTitleField: showLinkTitleField,
        showAnchorTextField: linkDialogState.withAnchorText
    }), linkDialogState.type === "preview" && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("a", (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).linkDialogPreviewAnchor,
        "data-testid": "link-dialog-preview",
        href: (_linkDialogState_href = linkDialogState.href) !== null && _linkDialogState_href !== void 0 ? _linkDialogState_href : "about:blank"
    }, urlIsExternal ? {
        target: "_blank",
        rel: "noreferrer"
    } : {}), {
        onClick: (e)=>{
            if (onClickLinkCallback !== null) {
                e.preventDefault();
                onClickLinkCallback(linkDialogState.url);
            }
        },
        title: urlIsExternal ? t("linkPreview.open", `Open {{url}} in new window`, {
            url: linkDialogState.url
        }) : linkDialogState.url
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("span", null, linkDialogState.url), urlIsExternal && iconComponentFor("open_in_new")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($28c72891a80f4ac7$var$ActionButton, {
        onClick: ()=>{
            switchFromPreviewToLinkEdit();
        },
        title: t("linkPreview.edit", "Edit link URL"),
        "aria-label": t("linkPreview.edit", "Edit link URL")
    }, iconComponentFor("edit")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$2881499e37b75b9a, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$be92b6f5f03c0fe9, {
        open: copyUrlTooltipOpen
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$41fb9f06171c75f4, {
        asChild: true
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($28c72891a80f4ac7$var$ActionButton, {
        title: t("linkPreview.copyToClipboard", "Copy to clipboard"),
        "aria-label": t("linkPreview.copyToClipboard", "Copy to clipboard"),
        onClick: ()=>{
            window.navigator.clipboard.writeText(linkDialogState.url).then(()=>{
                setCopyUrlTooltipOpen(true);
                setTimeout(()=>{
                    setCopyUrlTooltipOpen(false);
                }, 1e3);
            });
        }
    }, copyUrlTooltipOpen ? iconComponentFor("check") : iconComponentFor("content_copy"))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$602eac185826482c, {
        container: editorRootElementRef == null ? void 0 : editorRootElementRef.current
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$7c6e2c02157bb7d2, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tooltipContent),
        sideOffset: 5
    }, t("linkPreview.copied", "Copied!"), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($ec185ecb78ca2c5c$export$21b07c8f274aebd5, null))))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($28c72891a80f4ac7$var$ActionButton, {
        title: t("linkPreview.remove", "Remove link"),
        "aria-label": t("linkPreview.remove", "Remove link"),
        onClick: ()=>{
            removeLink();
        }
    }, iconComponentFor("link_off"))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$21b07c8f274aebd5, {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).popoverArrow
    }))));
};
const $28c72891a80f4ac7$var$ActionButton = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((_param, ref)=>{
    var { className: className } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "className"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).actionButton, className),
        ref: ref
    }, props));
});



function $2a1e7a4c7a8785c8$var$getLinkNodeInSelection(selection) {
    if (!selection) return null;
    const node = (0, $4d17661fb36fa8e3$export$da5a91481a5e4aa3)(selection);
    if (node === null) return null;
    const parent = node.getParent();
    if ((0, $1ad5ac6f16b99f6f$export$b46127abfd772033)(parent)) return parent;
    else if ((0, $1ad5ac6f16b99f6f$export$b46127abfd772033)(node)) return node;
    return null;
}
function $2a1e7a4c7a8785c8$var$getSelectedInlineDecorator(selection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)()) {
    if (!(0, $3e88191b87395c2e$export$7257e4181651a7c3)(selection)) return null;
    const nodes = selection.getNodes();
    const node = nodes.length === 1 ? nodes[0] : null;
    return (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(node) && node.isInline() ? node : null;
}
function $2a1e7a4c7a8785c8$var$getPreviewHref(editor, linkNodeKey, url) {
    if (!editor) return "about:blank";
    return editor.getEditorState().read(()=>{
        const keyedNode = linkNodeKey === "" ? null : (0, $3e88191b87395c2e$export$e725f93d4d48c6d8)(linkNodeKey);
        const selection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        const selectedNode = (0, $3e88191b87395c2e$export$181b63acea8a0224)(selection) ? $2a1e7a4c7a8785c8$var$getLinkNodeInSelection(selection) : null;
        const linkNode = (0, $1ad5ac6f16b99f6f$export$b46127abfd772033)(keyedNode) ? keyedNode : selectedNode;
        var _ref;
        return (_ref = linkNode == null ? void 0 : linkNode.sanitizeUrl(url)) !== null && _ref !== void 0 ? _ref : "about:blank";
    });
}
const $2a1e7a4c7a8785c8$export$974a394b185d5055 = (0, $0a163704d09ac3e9$export$8210dfe1863c478)();
const $2a1e7a4c7a8785c8$export$27c4c34d17f02d28 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)({
    type: "inactive"
}, (r)=>{
    r.pub((0, $5a7e051e41645429$export$95585712f951d614), (editor)=>{
        return editor.registerCommand((0, $3e88191b87395c2e$export$53589e422a755d59), ()=>{
            const state = r.getValue($2a1e7a4c7a8785c8$export$27c4c34d17f02d28);
            if (state.type === "preview") {
                r.pub($2a1e7a4c7a8785c8$export$27c4c34d17f02d28, {
                    type: "inactive"
                });
                return true;
            }
            return false;
        }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4));
    });
    r.sub(r.pipe((0, $5a7e051e41645429$export$a65e0fe1b8d07b08)), (viewMode)=>{
        if (viewMode !== "rich-text") r.pub($2a1e7a4c7a8785c8$export$27c4c34d17f02d28, {
            type: "inactive"
        });
    });
    r.pub((0, $5a7e051e41645429$export$95585712f951d614), (editor)=>{
        return editor.registerCommand((0, $3e88191b87395c2e$export$61973214e0e18936), (event)=>{
            if (event.key === "k" && ((0, $b735d1bc59b95bee$export$d093bd80dddd0842) ? event.metaKey : event.ctrlKey) && !r.getValue((0, $5a7e051e41645429$export$73e7ec35cfb5ca78))) {
                const selection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(selection) || $2a1e7a4c7a8785c8$var$getSelectedInlineDecorator(selection) !== null) {
                    r.pub($2a1e7a4c7a8785c8$export$c3cca45dc4520e3a);
                    event.stopPropagation();
                    event.preventDefault();
                    return true;
                } else return false;
            }
            return false;
        }, (0, $3e88191b87395c2e$export$e8fb7042985cd2e9));
    });
    r.sub(r.pipe($2a1e7a4c7a8785c8$export$5d11d0959bf419ec, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($2a1e7a4c7a8785c8$export$27c4c34d17f02d28, (0, $5a7e051e41645429$export$e02bd6a7b04ae431))), ([, state, editor])=>{
        if (state.type === "preview") setTimeout(()=>{
            editor == null || editor.getEditorState().read(()=>{
                const node = (0, $3e88191b87395c2e$export$e725f93d4d48c6d8)(state.linkNodeKey);
                const withAnchorText = (0, $1ad5ac6f16b99f6f$export$b46127abfd772033)(node) ? node.getTextContent().length > 0 && node.getChildrenSize() <= 1 : false;
                const text = withAnchorText && node ? node.getTextContent() : "";
                r.pub($2a1e7a4c7a8785c8$export$27c4c34d17f02d28, {
                    type: "edit",
                    initialUrl: state.url,
                    url: state.url,
                    title: state.title,
                    text: text,
                    withAnchorText: withAnchorText,
                    linkNodeKey: state.linkNodeKey,
                    decoratorNodeKey: state.decoratorNodeKey,
                    rectangle: state.rectangle
                });
            });
        });
        else throw new Error("Cannot switch to edit mode when not in preview mode");
    });
    r.sub(r.pipe($2a1e7a4c7a8785c8$export$d858b86bf7fdc1ff, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)((0, $5a7e051e41645429$export$e02bd6a7b04ae431), $2a1e7a4c7a8785c8$export$27c4c34d17f02d28, (0, $5a7e051e41645429$export$dc45e04d1b3012d9))), ([payload, editor, state, selection])=>{
        var _a, _b, _c;
        var _ref;
        const text = (_ref = (_a = payload.text) == null ? void 0 : _a.trim()) !== null && _ref !== void 0 ? _ref : "";
        var _ref1;
        const url = (_ref1 = (_b = payload.url) == null ? void 0 : _b.trim()) !== null && _ref1 !== void 0 ? _ref1 : "";
        var _ref2;
        const title = (_ref2 = (_c = payload.title) == null ? void 0 : _c.trim()) !== null && _ref2 !== void 0 ? _ref2 : "";
        if (url !== "") {
            if (state.decoratorNodeKey !== void 0) {
                let linkNodeKey = "";
                let linkApplied = false;
                editor == null || editor.update(()=>{
                    const node = (0, $3e88191b87395c2e$export$e725f93d4d48c6d8)(state.decoratorNodeKey);
                    if (node === null) return;
                    const nodeSelection = (0, $3e88191b87395c2e$export$f8cd0c3f35d1a61c)();
                    nodeSelection.add(node.getKey());
                    (0, $3e88191b87395c2e$export$2aad78c37810bca9)(nodeSelection);
                    linkApplied = editor.dispatchCommand((0, $1ad5ac6f16b99f6f$export$42da573aae2f70a), url);
                    if (!linkApplied) return;
                    const parent = node.getParent();
                    if ((0, $1ad5ac6f16b99f6f$export$b46127abfd772033)(parent)) {
                        parent.setTitle(title);
                        linkNodeKey = parent.getKey();
                    }
                }, {
                    discrete: true
                });
                if (linkNodeKey === "") return;
                r.pub($2a1e7a4c7a8785c8$export$27c4c34d17f02d28, {
                    type: "preview",
                    linkNodeKey: linkNodeKey,
                    decoratorNodeKey: state.decoratorNodeKey,
                    rectangle: state.rectangle,
                    title: title,
                    url: url,
                    href: $2a1e7a4c7a8785c8$var$getPreviewHref(editor, linkNodeKey, url)
                });
                return;
            }
            if (selection == null ? void 0 : selection.isCollapsed()) {
                const linkContent = text || title || url;
                editor == null || editor.update(()=>{
                    const linkNode = $2a1e7a4c7a8785c8$var$getLinkNodeInSelection(selection);
                    if (!linkNode) {
                        const node = (0, $1ad5ac6f16b99f6f$export$5ec42376570ce194)(url, {
                            title: title
                        });
                        node.append((0, $3e88191b87395c2e$export$2785f39dcdec0078)(linkContent));
                        (0, $3e88191b87395c2e$export$d773017360b45449)([
                            node
                        ]);
                        node.select();
                    } else if ((0, $1ad5ac6f16b99f6f$export$7fd828bfe44c7434)(linkNode)) {
                        const newLinkNode = (0, $1ad5ac6f16b99f6f$export$5ec42376570ce194)(url, {
                            title: title
                        });
                        newLinkNode.append((0, $3e88191b87395c2e$export$2785f39dcdec0078)(text));
                        linkNode.replace(newLinkNode);
                        newLinkNode.select();
                    } else {
                        linkNode.setURL(url);
                        linkNode.setTitle(title);
                        $2a1e7a4c7a8785c8$var$updateLinkText(linkNode.getFirstChild(), text);
                    }
                }, {
                    discrete: true
                });
            } else {
                editor == null || editor.update(()=>{
                    $2a1e7a4c7a8785c8$var$updateLinkText(selection == null ? void 0 : selection.anchor.getNode(), text);
                });
                editor == null || editor.dispatchCommand((0, $1ad5ac6f16b99f6f$export$42da573aae2f70a), {
                    url: url,
                    title: title
                });
            }
            var _state_linkNodeKey;
            r.pub($2a1e7a4c7a8785c8$export$27c4c34d17f02d28, {
                type: "preview",
                linkNodeKey: state.linkNodeKey,
                rectangle: state.rectangle,
                title: title,
                url: url,
                href: $2a1e7a4c7a8785c8$var$getPreviewHref(editor, (_state_linkNodeKey = state.linkNodeKey) !== null && _state_linkNodeKey !== void 0 ? _state_linkNodeKey : "", url)
            });
        } else {
            if (state.type === "edit" && state.initialUrl !== "") {
                if (state.decoratorNodeKey !== void 0) editor == null || editor.update(()=>{
                    const node = (0, $3e88191b87395c2e$export$e725f93d4d48c6d8)(state.decoratorNodeKey);
                    if (node === null) return;
                    const nodeSelection = (0, $3e88191b87395c2e$export$f8cd0c3f35d1a61c)();
                    nodeSelection.add(node.getKey());
                    (0, $3e88191b87395c2e$export$2aad78c37810bca9)(nodeSelection);
                    editor.dispatchCommand((0, $1ad5ac6f16b99f6f$export$42da573aae2f70a), null);
                });
                else editor == null || editor.dispatchCommand((0, $1ad5ac6f16b99f6f$export$42da573aae2f70a), null);
            }
            r.pub($2a1e7a4c7a8785c8$export$27c4c34d17f02d28, {
                type: "inactive"
            });
        }
    });
    r.link(r.pipe($2a1e7a4c7a8785c8$export$4968cad4d9984bc3, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)($2a1e7a4c7a8785c8$export$27c4c34d17f02d28, (0, $5a7e051e41645429$export$e02bd6a7b04ae431)), (0, $0a163704d09ac3e9$export$871de8747c9eaa88)(([, state, editor])=>{
        if (state.type === "edit") {
            editor == null || editor.focus();
            if (state.initialUrl === "") return {
                type: "inactive"
            };
            else return {
                type: "preview",
                url: state.initialUrl,
                href: $2a1e7a4c7a8785c8$var$getPreviewHref(editor, state.linkNodeKey, state.initialUrl),
                linkNodeKey: state.linkNodeKey,
                decoratorNodeKey: state.decoratorNodeKey,
                rectangle: state.rectangle
            };
        } else throw new Error("Cannot cancel edit when not in edit mode");
    })), $2a1e7a4c7a8785c8$export$27c4c34d17f02d28);
    r.link(r.pipe(r.combine((0, $5a7e051e41645429$export$dc45e04d1b3012d9), $2a1e7a4c7a8785c8$export$974a394b185d5055), (0, $0a163704d09ac3e9$export$d449030e5c10edf7)((0, $5a7e051e41645429$export$e02bd6a7b04ae431), $2a1e7a4c7a8785c8$export$27c4c34d17f02d28, (0, $5a7e051e41645429$export$73e7ec35cfb5ca78)), (0, $0a163704d09ac3e9$export$871de8747c9eaa88)(([[selection], activeEditor, state, readOnly])=>{
        if (state.decoratorNodeKey !== void 0 && activeEditor && !readOnly) {
            const selectedDecoratorKey = activeEditor.getEditorState().read(()=>{
                const editorSelection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                if (!(0, $3e88191b87395c2e$export$7257e4181651a7c3)(editorSelection)) return null;
                const nodes = editorSelection.getNodes();
                return nodes.length === 1 ? nodes[0].getKey() : null;
            });
            if (selectedDecoratorKey !== state.decoratorNodeKey) return {
                type: "inactive"
            };
            const rectangle = (0, $4d17661fb36fa8e3$export$29f905b7979c25d2)(activeEditor, state.decoratorNodeKey);
            return rectangle === null ? {
                type: "inactive"
            } : (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state), {
                rectangle: rectangle
            });
        }
        if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(selection) && activeEditor && !readOnly) {
            const node = $2a1e7a4c7a8785c8$var$getLinkNodeInSelection(selection);
            if (!selection.isCollapsed()) return {
                type: "inactive"
            };
            if (node) {
                const rect = (0, $4d17661fb36fa8e3$export$df352cf6e4f1f4c4)(activeEditor);
                if (!rect) return {
                    type: "inactive"
                };
                return {
                    type: "preview",
                    url: node.getURL(),
                    href: node.sanitizeUrl(node.getURL()),
                    linkNodeKey: node.getKey(),
                    title: node.getTitle(),
                    rectangle: rect
                };
            } else return {
                type: "inactive"
            };
        } else return {
            type: "inactive"
        };
    })), $2a1e7a4c7a8785c8$export$27c4c34d17f02d28);
});
const $2a1e7a4c7a8785c8$export$d858b86bf7fdc1ff = (0, $0a163704d09ac3e9$export$8210dfe1863c478)();
const $2a1e7a4c7a8785c8$export$4968cad4d9984bc3 = (0, $0a163704d09ac3e9$export$e19cd5f9376f8cee)();
const $2a1e7a4c7a8785c8$export$56559d5d004bce03 = (0, $0a163704d09ac3e9$export$e19cd5f9376f8cee)();
const $2a1e7a4c7a8785c8$export$5d11d0959bf419ec = (0, $0a163704d09ac3e9$export$e19cd5f9376f8cee)();
const $2a1e7a4c7a8785c8$export$48585fc9af4c6c72 = (0, $0a163704d09ac3e9$export$e19cd5f9376f8cee)((r)=>{
    r.sub(r.pipe($2a1e7a4c7a8785c8$export$48585fc9af4c6c72, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)((0, $5a7e051e41645429$export$e02bd6a7b04ae431))), ([, editor])=>{
        editor == null || editor.dispatchCommand((0, $1ad5ac6f16b99f6f$export$42da573aae2f70a), null);
    });
});
const $2a1e7a4c7a8785c8$export$c3cca45dc4520e3a = (0, $0a163704d09ac3e9$export$e19cd5f9376f8cee)((r)=>{
    r.sub(r.pipe($2a1e7a4c7a8785c8$export$c3cca45dc4520e3a, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)((0, $5a7e051e41645429$export$dc45e04d1b3012d9), (0, $5a7e051e41645429$export$e02bd6a7b04ae431))), ([, selection, editor])=>{
        if (!editor) return;
        const decorator = editor.getEditorState().read(()=>{
            const node = $2a1e7a4c7a8785c8$var$getSelectedInlineDecorator();
            if (node === null) return null;
            const parent = node.getParent();
            const linkNode = (0, $1ad5ac6f16b99f6f$export$b46127abfd772033)(parent) ? parent : null;
            var _ref, _ref1, _ref2;
            return {
                nodeKey: node.getKey(),
                url: (_ref = linkNode == null ? void 0 : linkNode.getURL()) !== null && _ref !== void 0 ? _ref : "",
                title: (_ref1 = linkNode == null ? void 0 : linkNode.getTitle()) !== null && _ref1 !== void 0 ? _ref1 : "",
                linkNodeKey: (_ref2 = linkNode == null ? void 0 : linkNode.getKey()) !== null && _ref2 !== void 0 ? _ref2 : ""
            };
        });
        if (decorator !== null) {
            const rectangle = (0, $4d17661fb36fa8e3$export$29f905b7979c25d2)(editor, decorator.nodeKey);
            if (rectangle === null) return;
            r.pub($2a1e7a4c7a8785c8$export$27c4c34d17f02d28, {
                type: "edit",
                initialUrl: decorator.url,
                url: decorator.url,
                title: decorator.title,
                text: "",
                withAnchorText: false,
                linkNodeKey: decorator.linkNodeKey,
                decoratorNodeKey: decorator.nodeKey,
                rectangle: rectangle
            });
            return;
        }
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(selection)) return;
        editor.focus(()=>{
            setTimeout(()=>{
                editor.getEditorState().read(()=>{
                    const linkNode = $2a1e7a4c7a8785c8$var$getLinkNodeInSelection(selection);
                    const rectangle = (0, $4d17661fb36fa8e3$export$df352cf6e4f1f4c4)(editor);
                    if (rectangle === null) return;
                    var _ref;
                    const initialUrl = (_ref = linkNode == null ? void 0 : linkNode.getURL()) !== null && _ref !== void 0 ? _ref : "";
                    var _ref1;
                    const url = (_ref1 = linkNode == null ? void 0 : linkNode.getURL()) !== null && _ref1 !== void 0 ? _ref1 : "";
                    var _ref2;
                    const title = (_ref2 = linkNode == null ? void 0 : linkNode.getTitle()) !== null && _ref2 !== void 0 ? _ref2 : "";
                    var _ref3;
                    const linkNodeKey = (_ref3 = linkNode == null ? void 0 : linkNode.getKey()) !== null && _ref3 !== void 0 ? _ref3 : "";
                    const withAnchorText = linkNode ? linkNode.getTextContent().length > 0 && linkNode.getChildrenSize() <= 1 : selection.isCollapsed();
                    const text = withAnchorText && linkNode ? linkNode.getTextContent() : "";
                    r.pub($2a1e7a4c7a8785c8$export$27c4c34d17f02d28, {
                        type: "edit",
                        initialUrl: initialUrl,
                        url: url,
                        title: title,
                        text: text,
                        withAnchorText: withAnchorText,
                        linkNodeKey: linkNodeKey,
                        rectangle: rectangle
                    });
                });
            });
        });
    });
});
const $2a1e7a4c7a8785c8$export$1d74c23caea3638b = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)([]);
const $2a1e7a4c7a8785c8$export$9994919b6f3c165d = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null);
const $2a1e7a4c7a8785c8$export$dc69e5daa9ee8e7f = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(null, (r)=>{
    r.pub((0, $5a7e051e41645429$export$95585712f951d614), (editor)=>{
        function onClick(event) {
            const [readOnly, callback] = r.getValues([
                (0, $5a7e051e41645429$export$73e7ec35cfb5ca78),
                $2a1e7a4c7a8785c8$export$dc69e5daa9ee8e7f
            ]);
            if (!readOnly || callback === null) return;
            editor.update(()=>{
                const nearestNode = (0, $3e88191b87395c2e$export$fef265f0d2fcffdd)(event.target);
                if (nearestNode !== null) {
                    const targetNode = (0, $3e88191b87395c2e$export$57101724ca611500)(nearestNode, (node)=>node instanceof (0, $1ad5ac6f16b99f6f$export$4341066b87270133));
                    if (targetNode !== null) callback(event, targetNode, targetNode.getURL());
                }
            });
        }
        return editor.registerRootListener((rootElement, prevRoot)=>{
            if (rootElement) rootElement.addEventListener("click", onClick);
            if (prevRoot) prevRoot.removeEventListener("click", onClick);
        });
    });
});
function $2a1e7a4c7a8785c8$var$updateLinkText(node, text) {
    if ((0, $3e88191b87395c2e$export$471953706258be2b)(node) && text) {
        node.setTextContent(text);
        node.selectStart();
    }
}
const $2a1e7a4c7a8785c8$export$94506a020c1f4f6d = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(true);
const $2a1e7a4c7a8785c8$export$5a3ca10fb9b2a633 = (0, $180ae8514eec30ee$export$a1bf852fe7c1a323)({
    init (r, params) {
        var _ref;
        r.pub((0, $5a7e051e41645429$export$d120e029a7b56e15), (_ref = params == null ? void 0 : params.LinkDialog) !== null && _ref !== void 0 ? _ref : (0, $28c72891a80f4ac7$export$f347b363d1b7f68a));
        var _ref1;
        r.pub($2a1e7a4c7a8785c8$export$9994919b6f3c165d, (_ref1 = params == null ? void 0 : params.onClickLinkCallback) !== null && _ref1 !== void 0 ? _ref1 : null);
        var _ref2;
        r.pub($2a1e7a4c7a8785c8$export$dc69e5daa9ee8e7f, (_ref2 = params == null ? void 0 : params.onReadOnlyClickLinkCallback) !== null && _ref2 !== void 0 ? _ref2 : null);
        var _ref3;
        r.pub($2a1e7a4c7a8785c8$export$94506a020c1f4f6d, (_ref3 = params == null ? void 0 : params.showLinkTitleField) !== null && _ref3 !== void 0 ? _ref3 : true);
    },
    update (r, params = {}) {
        var _params_linkAutocompleteSuggestions;
        r.pub($2a1e7a4c7a8785c8$export$1d74c23caea3638b, (_params_linkAutocompleteSuggestions = params.linkAutocompleteSuggestions) !== null && _params_linkAutocompleteSuggestions !== void 0 ? _params_linkAutocompleteSuggestions : []);
    }
});




const $db6c5d95ea524016$export$b8fcacb3451702e8 = ()=>{
    const openLinkDialog = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $2a1e7a4c7a8785c8$export$c3cca45dc4520e3a));
    const iconComponentFor = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$4fd464b2b09e1c4d));
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5f22da7309bc91a3$export$1158bddbb6341bad), {
        "aria-label": t("toolbar.link", "Create link"),
        title: t("toolbar.link", "Create link"),
        onPointerDown: (event)=>{
            event.preventDefault();
        },
        onClick: (_)=>{
            openLinkDialog();
        }
    }, iconComponentFor("link"));
};




var $7fPBF = parcelRequire("7fPBF");


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ 


// To do: next major: remove.
/**
 * @typedef {Options} MarkdownTableOptions
 *   Configuration.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [alignDelimiters=true]
 *   Whether to align the delimiters (default: `true`);
 *   they are aligned by default:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {ReadonlyArray<string | null | undefined> | string | null | undefined} [align]
 *   How to align columns (default: `''`);
 *   one style for all columns or styles for their respective columns;
 *   each style is either `'l'` (left), `'r'` (right), or `'c'` (center);
 *   other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left;
 *   *only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean | null | undefined} [delimiterEnd=true]
 *   Whether to end each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean | null | undefined} [delimiterStart=true]
 *   Whether to begin each row with the delimiter (default: `true`).
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean | null | undefined} [padding=true]
 *   Whether to add a space of padding between delimiters and cells
 *   (default: `true`).
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {((value: string) => number) | null | undefined} [stringLength]
 *   Function to detect the length of table cell content (optional);
 *   this is used when aligning the delimiters (`|`) between table cells;
 *   full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source;
 *   to fix this, you can pass this function,
 *   which receives the cell content and returns its “visible” size;
 *   note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @param {string} value
 *   Cell value.
 * @returns {number}
 *   Cell size.
 */ function $04345556f6d0def5$var$defaultStringLength(value) {
    return value.length;
}
function $04345556f6d0def5$export$cdb7288612c4f3d6(table, options) {
    const settings = options || {};
    // To do: next major: change to spread.
    const align = (settings.align || []).concat();
    const stringLength = settings.stringLength || $04345556f6d0def5$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $04345556f6d0def5$var$serialize(table[rowIndex][columnIndex]);
            if (settings.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === 'object' && 'length' in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $04345556f6d0def5$var$toAlignment(align[columnIndex]);
    else {
        const code = $04345556f6d0def5$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = '';
        let after = '';
        if (code === 99 /* `c` */ ) {
            before = ':';
            after = ':';
        } else if (code === 108 /* `l` */ ) before = ':';
        else if (code === 114 /* `r` */ ) after = ':';
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = settings.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + '-'.repeat(size) + after;
        if (settings.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || '';
            let before = '';
            let after = '';
            if (settings.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = ' '.repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = ' '.repeat(size / 2 + 0.5);
                        after = ' '.repeat(size / 2 - 0.5);
                    } else {
                        before = ' '.repeat(size / 2);
                        after = before;
                    }
                } else after = ' '.repeat(size);
            }
            if (settings.delimiterStart !== false && !columnIndex) line.push('|');
            if (settings.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(settings.alignDelimiters === false && cell === '') && (settings.delimiterStart !== false || columnIndex)) line.push(' ');
            if (settings.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (settings.alignDelimiters !== false) line.push(after);
            if (settings.padding !== false) line.push(' ');
            if (settings.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push('|');
        }
        lines.push(settings.delimiterEnd === false ? line.join('').replace(/ +$/, '') : line.join(''));
    }
    return lines.join('\n');
}
/**
 * @param {string | null | undefined} [value]
 *   Value to serialize.
 * @returns {string}
 *   Result.
 */ function $04345556f6d0def5$var$serialize(value) {
    return value === null || value === undefined ? '' : String(value);
}
/**
 * @param {string | null | undefined} value
 *   Value.
 * @returns {number}
 *   Alignment.
 */ function $04345556f6d0def5$var$toAlignment(value) {
    const code = typeof value === 'string' ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}



function $27370860b3e1d456$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $27370860b3e1d456$var$enterTable,
            tableData: $27370860b3e1d456$var$enterCell,
            tableHeader: $27370860b3e1d456$var$enterCell,
            tableRow: $27370860b3e1d456$var$enterRow
        },
        exit: {
            codeText: $27370860b3e1d456$var$exitCodeText,
            table: $27370860b3e1d456$var$exitTable,
            tableData: $27370860b3e1d456$var$exit,
            tableHeader: $27370860b3e1d456$var$exit,
            tableRow: $27370860b3e1d456$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$enterTable(token) {
    const align = token._align;
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(align, 'expected `_align` on table');
    this.enter({
        type: 'table',
        align: align.map(function(d) {
            return d === 'none' ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$enterRow(token) {
    this.enter({
        type: 'tableRow',
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$enterCell(token) {
    this.enter({
        type: 'tableCell',
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $27370860b3e1d456$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $27370860b3e1d456$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'inlineCode');
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $27370860b3e1d456$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === '|' ? $1 : $0;
}
function $27370860b3e1d456$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? ' ' : '|';
    return {
        unsafe: [
            {
                character: '\r',
                inConstruct: 'tableCell'
            },
            {
                character: '\n',
                inConstruct: 'tableCell'
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: '|',
                after: '[\t :-]'
            },
            // A pipe in a cell must be encoded.
            {
                character: '|',
                inConstruct: 'tableCell'
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ':',
                after: '-'
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf('\n'));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter('tableCell');
        const subexit = state.enter('phrasing');
        const value = state.containerPhrasing(node, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, info), {
            before: around,
            after: around
        }));
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $04345556f6d0def5$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter('table');
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter('tableRow');
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $da19da82921559d2$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes('tableCell')) value = value.replace(/\|/g, '\\$&');
        return value;
    }
}


/**
 * @import {Event, Extension, Point, Resolver, State, Token, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @import {Event} from 'micromark-util-types'
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $fb088f9b3e1902f4$export$9348908dd4518b4a {
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ add(index, remove, add) {
        $fb088f9b3e1902f4$var$addImplementation(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImplementation(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push(events.slice());
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            for (const element of slice)events.push(element);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $fb088f9b3e1902f4$var$addImplementation(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @import {Event} from 'micromark-util-types'
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $b6d029dbee6a13e7$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === 'enter') // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === 'tableContent') align.push(events[index + 1][1].type === 'tableDelimiterMarker' ? 'left' : 'none');
            } else if (event[1].type === 'tableContent') {
                if (events[index - 1][1].type === 'tableDelimiterMarker') {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === 'left' ? 'center' : 'right';
                }
            } else if (event[1].type === 'tableDelimiterRow') break;
        } else if (event[0] === 'enter' && event[1].type === 'tableDelimiterRow') inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $fe86da6860750184$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                name: 'table',
                tokenize: $fe86da6860750184$var$tokenizeTable,
                resolveAll: $fe86da6860750184$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $fe86da6860750184$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === 'tableHead' || tail === 'tableRow' ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter('tableHead');
        effects.enter('tableRow');
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit('tableRow');
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter('tableDelimiterRow');
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes('codeIndented') ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter('tableDelimiterFiller');
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit('tableDelimiterFiller');
            effects.enter('tableDelimiterMarker');
            effects.consume(code);
            effects.exit('tableDelimiterMarker');
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit('tableDelimiterFiller');
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit('tableDelimiterRow');
            effects.exit('tableHead');
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter('tableRow');
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter('tableCellDivider');
            effects.consume(code);
            effects.exit('tableCellDivider');
            return bodyRowBreak;
        }
        if (code === null || (0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) {
            effects.exit('tableRow');
            return ok(code);
        }
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $fe86da6860750184$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $fb088f9b3e1902f4$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === 'enter') {
            // Start of head.
            if (token.type === 'tableHead') {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $fe86da6860750184$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: 'table',
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        'enter',
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: 'tableBody',
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            'enter',
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === 'tableDelimiterRow' ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $fe86da6860750184$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === 'tableCellDivider') {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $fe86da6860750184$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === 'tableHead') {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === 'tableRow' || token.type === 'tableDelimiterRow') {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $fe86da6860750184$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $fe86da6860750184$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === 'tableDelimiterMarker' || token.type === 'tableDelimiterFiller')) cell[3] = index;
    }
    if (lastTableEnd !== 0) $fe86da6860750184$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === 'enter' && event[1].type === 'table') event[1]._align = (0, $b6d029dbee6a13e7$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $fe86da6860750184$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? 'tableHeader' : rowKind === 2 ? 'tableDelimiter' : 'tableData';
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = 'tableContent';
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $fe86da6860750184$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $fe86da6860750184$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            'enter',
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $fe86da6860750184$var$getPoint(context.events, range[2]);
        const relatedEnd = $fe86da6860750184$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                'enter',
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                'exit',
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $fe86da6860750184$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                'exit',
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $fe86da6860750184$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $fe86da6860750184$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            'exit',
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        'exit',
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $fe86da6860750184$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === 'enter' ? 'start' : 'end';
    return event[1][side];
}







var $7fPBF = parcelRequire("7fPBF");






/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 


function $3ee369f135efbd55$export$a7eef1ce2651a334({ initialEditor: r, children: e }) {
    const { Component: n } = (0, $8ebc39becbfbdd8f$export$f6d797908fcfe7c8)(r, (0, $28a7ea8b7fe3b9fa$export$7512bd77445b5962)).output;
    return (0, $824c049f32d4395d$exports.jsx)(n, {
        children: e
    });
}


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

var $7fPBF = parcelRequire("7fPBF");

const $7a6a80ad59585d70$var$u = (0, $3e88191b87395c2e$export$37d2f1e98a187e61) ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $7a6a80ad59585d70$var$a(r) {
    return {
        initialValueFn: ()=>r.isEditable(),
        subscribe: (t)=>r.registerEditableListener(t)
    };
}
function $7a6a80ad59585d70$export$216c7470de8af95b() {
    return function(t) {
        const [e] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)(), o = (0, $7fPBF.useMemo)(()=>t(e), [
            e,
            t
        ]), [a, l] = (0, $7fPBF.useState)(()=>o.initialValueFn()), s = (0, $7fPBF.useRef)(a);
        return $7a6a80ad59585d70$var$u(()=>{
            const { initialValueFn: r, subscribe: t } = o, e = r();
            return s.current !== e && (s.current = e, l(e)), t((r)=>{
                s.current = r, l(r);
            });
        }, [
            o,
            t
        ]), a;
    }($7a6a80ad59585d70$var$a);
}





var $7fPBF = parcelRequire("7fPBF");

var $fw0lo = parcelRequire("fw0lo");





function $0c3e62e220668ac1$var$y(r, ...e) {
    const t = new URL("https://lexical.dev/docs/error"), o = new URLSearchParams;
    o.append("code", r);
    for (const r of e)o.append("v", r);
    throw t.search = o.toString(), Error(`Minified Lexical error #${r}; visit ${t.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
const $0c3e62e220668ac1$var$B = (0, $3e88191b87395c2e$export$37d2f1e98a187e61) ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);
function $0c3e62e220668ac1$var$L({ editor: r, ErrorBoundary: e }) {
    return function(r, e) {
        const [t, o] = (0, $7fPBF.useState)(()=>r.getDecorators());
        return $0c3e62e220668ac1$var$B(()=>r.registerDecoratorListener((r)=>{
                (0, $fw0lo.flushSync)(()=>{
                    o(r);
                });
            }), [
            r
        ]), (0, $7fPBF.useEffect)(()=>{
            o(r.getDecorators());
        }, [
            r
        ]), (0, $7fPBF.useMemo)(()=>{
            const o = [], n = Object.keys(t);
            for(let i = 0; i < n.length; i++){
                const c = n[i], a = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)(e, {
                    onError: (e)=>r._onError(e),
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7fPBF.Suspense), {
                        fallback: null,
                        children: t[c]
                    })
                }), s = r.getElementByKey(c);
                null !== s && o.push(/*#__PURE__*/ (0, $fw0lo.createPortal)(a, s, c));
            }
            return o;
        }, [
            e,
            t,
            r
        ]);
    }(r, e);
}
function $0c3e62e220668ac1$var$b({ editor: r, ErrorBoundary: e }) {
    return function(r) {
        const e = (0, $8ebc39becbfbdd8f$export$e58dbff0cd3a42d8).maybeFromEditor(r);
        if (e && e.hasExtensionByName((0, $5202a342a9f8ce8b$export$3deb62a530a54b75).name)) {
            for (const r of [
                "@lexical/plain-text",
                "@lexical/rich-text"
            ])e.hasExtensionByName(r) && $0c3e62e220668ac1$var$y(320, r);
            return !0;
        }
        return !1;
    }(r) ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0c3e62e220668ac1$var$L, {
        editor: r,
        ErrorBoundary: e
    });
}
function $0c3e62e220668ac1$var$v(r) {
    return r.read("latest", (0, $3a674b7e320eb29a$export$91992121baced35b)(r.isComposing()));
}
function $0c3e62e220668ac1$export$26ad95729aab2c7a({ contentEditable: e, placeholder: t = null, ErrorBoundary: o }) {
    const [n] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)();
    return function(r) {
        $0c3e62e220668ac1$var$B(()=>(0, $3e88191b87395c2e$export$d64d64f541cc1835)((0, $cc8bb3cdc37e8788$export$8d6ed18fd12861da)(r), (0, $e67df6634839f611$export$14cafee2f188b8bc)(r)), [
            r
        ]);
    }(n), /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            e,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0c3e62e220668ac1$var$C, {
                content: t
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($0c3e62e220668ac1$var$b, {
                editor: n,
                ErrorBoundary: o
            })
        ]
    });
}
function $0c3e62e220668ac1$var$C({ content: t }) {
    const [o] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)(), n = function(r) {
        const [e, t] = (0, $7fPBF.useState)(()=>$0c3e62e220668ac1$var$v(r));
        return $0c3e62e220668ac1$var$B(()=>{
            function e() {
                const e = $0c3e62e220668ac1$var$v(r);
                t(e);
            }
            return e(), (0, $3e88191b87395c2e$export$d64d64f541cc1835)(r.registerUpdateListener(()=>{
                e();
            }), r.registerEditableListener(()=>{
                e();
            }));
        }, [
            r
        ]), e;
    }(o), i = (0, $7a6a80ad59585d70$export$216c7470de8af95b)();
    return n ? "function" == typeof t ? t(i) : t : null;
}





var $7fPBF = parcelRequire("7fPBF");






function $dbfefabd85c53c9a$export$367c273952fa6d0a(element, editorRoot) {
    if (element === null || element === editorRoot) return false;
    if (element.dataset.editorDialog !== void 0 || element.dataset.toolbarItem !== void 0 || element.dataset.editorDropdown) return true;
    return $dbfefabd85c53c9a$export$367c273952fa6d0a(element.parentElement, editorRoot);
}


function $9c4b33f80625e1df$export$abe4376e1bf796d6() {
    const hex = [
        ...Array(256).keys()
    ].map((index)=>index.toString(16).padStart(2, "0"));
    const r = crypto.getRandomValues(new Uint8Array(16));
    r[6] = r[6] & 15 | 64;
    r[8] = r[8] & 63 | 128;
    return [
        ...r.entries()
    ].map(([index, int])=>[
            4,
            6,
            8,
            10
        ].includes(index) ? `-${hex[int]}` : hex[int]).join("");
}





const $5889103a17472acd$var$getCellType = (rowIndex)=>{
    if (rowIndex === 0) return "th";
    return "td";
};
const $5889103a17472acd$var$AlignToTailwindClassMap = {
    center: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).centeredCell,
    left: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).leftAlignedCell,
    right: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).rightAlignedCell
};
const $5889103a17472acd$export$4a87b5959f9ee157 = ({ mdastNode: mdastNode, parentEditor: parentEditor, lexicalTable: lexicalTable })=>{
    const [activeCell, setActiveCell] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(null);
    const [iconComponentFor, readOnly] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $5a7e051e41645429$export$4fd464b2b09e1c4d), (0, $5a7e051e41645429$export$73e7ec35cfb5ca78));
    const getCellKey = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>{
        return (cell)=>{
            var _cell___cacheKey;
            (_cell___cacheKey = cell.__cacheKey) !== null && _cell___cacheKey !== void 0 ? _cell___cacheKey : cell.__cacheKey = (0, $9c4b33f80625e1df$export$abe4376e1bf796d6)();
            return cell.__cacheKey;
        };
    }, []);
    const setActiveCellWithBoundaries = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((cell)=>{
        const colCount = lexicalTable.getColCount();
        if (cell === null) {
            setActiveCell(null);
            return;
        }
        let [colIndex, rowIndex] = cell;
        if (colIndex > colCount - 1) {
            colIndex = 0;
            rowIndex++;
        }
        if (colIndex < 0) {
            colIndex = colCount - 1;
            rowIndex -= 1;
        }
        if (rowIndex > lexicalTable.getRowCount() - 1) {
            setActiveCell(null);
            parentEditor.update(()=>{
                const nextSibling = lexicalTable.getLatest().getNextSibling();
                if (nextSibling) lexicalTable.getLatest().selectNext();
                else {
                    const newParagraph = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
                    lexicalTable.insertAfter(newParagraph);
                    newParagraph.select();
                }
            });
            return;
        }
        if (rowIndex < 0) {
            setActiveCell(null);
            parentEditor.update(()=>{
                lexicalTable.getLatest().selectPrevious();
            });
            return;
        }
        setActiveCell([
            colIndex,
            rowIndex
        ]);
    }, [
        lexicalTable,
        parentEditor
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        lexicalTable.focusEmitter.subscribe(setActiveCellWithBoundaries);
    }, [
        lexicalTable,
        setActiveCellWithBoundaries
    ]);
    const addRowToBottom = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((e)=>{
        e.preventDefault();
        parentEditor.update(()=>{
            lexicalTable.addRowToBottom();
            setActiveCell([
                0,
                lexicalTable.getRowCount()
            ]);
        });
    }, [
        parentEditor,
        lexicalTable
    ]);
    const addColumnToRight = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((e)=>{
        e.preventDefault();
        parentEditor.update(()=>{
            lexicalTable.addColumnToRight();
            setActiveCell([
                lexicalTable.getColCount(),
                0
            ]);
        });
    }, [
        parentEditor,
        lexicalTable
    ]);
    const [highlightedCoordinates, setHighlightedCoordinates] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState([
        -1,
        -1
    ]);
    const onTableMouseOver = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((e)=>{
        let tableCell = e.target;
        while(tableCell && ![
            "TH",
            "TD"
        ].includes(tableCell.tagName)){
            if (tableCell === e.currentTarget) return;
            tableCell = tableCell.parentElement;
        }
        if (tableCell === null) return;
        const tableRow = tableCell.parentElement;
        const tableContainer = tableRow.parentElement;
        const colIndex = tableContainer.tagName === "TFOOT" ? -1 : Array.from(tableRow.children).indexOf(tableCell);
        const rowIndex = tableCell.tagName === "TH" ? -1 : Array.from(tableRow.parentElement.children).indexOf(tableRow);
        setHighlightedCoordinates([
            colIndex,
            rowIndex
        ]);
    }, []);
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("table", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tableEditor,
        onMouseOver: onTableMouseOver,
        onMouseLeave: ()=>{
            setHighlightedCoordinates([
                -1,
                -1
            ]);
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("colgroup", null, readOnly ? null : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("col", null), Array.from({
        length: mdastNode.children[0].children.length
    }, (_, colIndex)=>{
        var _mdastNode_align;
        const align = (_mdastNode_align = mdastNode.align) !== null && _mdastNode_align !== void 0 ? _mdastNode_align : [];
        var _align_colIndex;
        const currentColumnAlign = (_align_colIndex = align[colIndex]) !== null && _align_colIndex !== void 0 ? _align_colIndex : "left";
        const className = $5889103a17472acd$var$AlignToTailwindClassMap[currentColumnAlign];
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("col", {
            key: colIndex,
            className: className
        });
    }), readOnly ? null : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("col", null)), readOnly || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("thead", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tableToolsColumn
    }), Array.from({
        length: mdastNode.children[0].children.length
    }, (_, colIndex)=>{
        var _mdastNode_align;
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            key: colIndex,
            "data-tool-cell": true
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5889103a17472acd$var$ColumnEditor, {
            setActiveCellWithBoundaries: setActiveCellWithBoundaries,
            parentEditor: parentEditor,
            colIndex: colIndex,
            highlightedCoordinates: highlightedCoordinates,
            lexicalTable: lexicalTable,
            align: ((_mdastNode_align = mdastNode.align) !== null && _mdastNode_align !== void 0 ? _mdastNode_align : [])[colIndex]
        }));
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tableToolsColumn,
        "data-tool-cell": true
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).iconButton,
        type: "button",
        title: t("table.deleteTable", "Delete table"),
        onClick: (e)=>{
            e.preventDefault();
            parentEditor.update(()=>{
                lexicalTable.selectNext();
                lexicalTable.remove();
            });
        }
    }, iconComponentFor("delete_small"))))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tbody", null, mdastNode.children.map((row, rowIndex)=>{
        const CellElement = $5889103a17472acd$var$getCellType(rowIndex);
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", {
            key: rowIndex
        }, readOnly || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(CellElement, {
            className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toolCell,
            "data-tool-cell": true
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5889103a17472acd$var$RowEditor, {
            setActiveCellWithBoundaries: setActiveCellWithBoundaries,
            parentEditor: parentEditor,
            rowIndex: rowIndex,
            highlightedCoordinates: highlightedCoordinates,
            lexicalTable: lexicalTable
        })), row.children.map((mdastCell, colIndex)=>{
            var _a;
            return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5889103a17472acd$var$Cell, {
                align: (_a = mdastNode.align) == null ? void 0 : _a[colIndex],
                key: getCellKey(mdastCell),
                contents: mdastCell.children,
                setActiveCell: setActiveCellWithBoundaries,
                rowIndex: rowIndex,
                colIndex: colIndex,
                lexicalTable: lexicalTable,
                parentEditor: parentEditor,
                activeCell: readOnly ? [
                    -1,
                    -1
                ] : activeCell
            });
        }), readOnly || rowIndex === 0 && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
            rowSpan: lexicalTable.getRowCount(),
            "data-tool-cell": true
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
            type: "button",
            className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).addColumnButton,
            onClick: addColumnToRight
        }, iconComponentFor("add_column"))));
    })), readOnly || /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tfoot", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("tr", null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", {
        colSpan: lexicalTable.getColCount(),
        "data-tool-cell": true
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("button", {
        type: "button",
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).addRowButton,
        onClick: addRowToBottom
    }, iconComponentFor("add_row"))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("th", null))));
};
const $5889103a17472acd$var$Cell = (_param)=>{
    var { align: align } = _param, props = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "align"
    ]);
    const { activeCell: activeCell, setActiveCell: setActiveCell } = props;
    const isActive = (activeCell == null ? void 0 : activeCell[0]) === props.colIndex && activeCell[1] === props.rowIndex;
    const className = $5889103a17472acd$var$AlignToTailwindClassMap[align !== null && align !== void 0 ? align : "left"];
    const CellElement = $5889103a17472acd$var$getCellType(props.rowIndex);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(CellElement, {
        className: className,
        "data-active": isActive,
        onClick: ()=>{
            setActiveCell([
                props.colIndex,
                props.rowIndex
            ]);
        }
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($5889103a17472acd$var$CellEditor, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        focus: isActive
    })));
};
const $5889103a17472acd$var$CellEditor = ({ focus: focus, setActiveCell: setActiveCell, parentEditor: parentEditor, lexicalTable: lexicalTable, contents: contents, colIndex: colIndex, rowIndex: rowIndex })=>{
    const [importVisitors, exportVisitors, usedLexicalNodes, jsxComponentDescriptors, directiveDescriptors, codeBlockEditorDescriptors, defaultCodeBlockLanguage, jsxIsAvailable, rootEditor, tableCellEditorChildren] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $5a7e051e41645429$export$71d47a1889ca3697), (0, $5a7e051e41645429$export$991b374d185bab8d), (0, $5a7e051e41645429$export$56746f0cd199e4a0), (0, $5a7e051e41645429$export$f4f33684797bd01d), (0, $5a7e051e41645429$export$753a63599172396), (0, $5a7e051e41645429$export$13b405bc957e5ec9), (0, $5a7e051e41645429$export$f738aae4ba2dfef1), (0, $5a7e051e41645429$export$88d0810293b8762a), (0, $5a7e051e41645429$export$1224068c50c179e8), (0, $5a7e051e41645429$export$2d0720610f038210));
    const [editor, setEditor] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(null);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        const editor2 = (0, $e4b4032c9b34afa3$export$dbb611ce42f3fd01)({
            name: "@mdxeditor/table-cell",
            nodes: usedLexicalNodes,
            namespace: "TableCellEditor",
            parentEditor: parentEditor,
            historyMode: "table-local",
            initialEditorState: ()=>{
                (0, $18742b91d99345f0$export$8443dee93ebc5bea)({
                    root: (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(),
                    mdastRoot: {
                        type: "root",
                        children: [
                            {
                                type: "paragraph",
                                children: contents
                            }
                        ]
                    },
                    visitors: importVisitors,
                    jsxComponentDescriptors: jsxComponentDescriptors,
                    directiveDescriptors: directiveDescriptors,
                    codeBlockEditorDescriptors: codeBlockEditorDescriptors,
                    defaultCodeBlockLanguage: defaultCodeBlockLanguage
                });
            }
        });
        setEditor(editor2);
        return ()=>{
            editor2.dispose();
        };
    }, []);
    const saveAndFocus = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((nextCell)=>{
        if (!editor) return;
        editor.getEditorState().read(()=>{
            const mdast = (0, $d5a351410f7bf8d8$export$57051130e393c786)({
                root: (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)(),
                jsxComponentDescriptors: jsxComponentDescriptors,
                visitors: exportVisitors,
                jsxIsAvailable: jsxIsAvailable
            });
            parentEditor.update(()=>{
                lexicalTable.updateCellContents(colIndex, rowIndex, mdast.children[0].children);
            }, {
                discrete: true
            });
            parentEditor.dispatchCommand((0, $5a7e051e41645429$export$6fe69bb678b4acec), void 0);
        });
        setActiveCell(nextCell);
    }, [
        colIndex,
        editor,
        exportVisitors,
        jsxComponentDescriptors,
        jsxIsAvailable,
        lexicalTable,
        parentEditor,
        rowIndex,
        setActiveCell
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (!editor) return;
        return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(editor.registerCommand((0, $3e88191b87395c2e$export$b321bdc226ccdcde), (payload)=>{
            payload.preventDefault();
            const nextCell = payload.shiftKey ? [
                colIndex - 1,
                rowIndex
            ] : [
                colIndex + 1,
                rowIndex
            ];
            saveAndFocus(nextCell);
            return true;
        }, (0, $3e88191b87395c2e$export$6afdf194f304e546)), editor.registerCommand((0, $3e88191b87395c2e$export$cafe35f35e77bf56), ()=>{
            setActiveCell([
                colIndex,
                rowIndex
            ]);
            return false;
        }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), editor.registerCommand((0, $3e88191b87395c2e$export$2cdb7cdd6fccb293), (payload)=>{
            payload == null || payload.preventDefault();
            const nextCell = (payload == null ? void 0 : payload.shiftKey) ? [
                colIndex,
                rowIndex - 1
            ] : [
                colIndex,
                rowIndex + 1
            ];
            saveAndFocus(nextCell);
            return true;
        }, (0, $3e88191b87395c2e$export$6afdf194f304e546)), editor.registerCommand((0, $3e88191b87395c2e$export$4b6d457d076906ac), (payload)=>{
            const relatedTarget = payload.relatedTarget;
            if ((0, $dbfefabd85c53c9a$export$367c273952fa6d0a)(relatedTarget, rootEditor.getRootElement())) return false;
            saveAndFocus(null);
            return true;
        }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)), editor.registerCommand((0, $5a7e051e41645429$export$6fe69bb678b4acec), ()=>{
            saveAndFocus(null);
            return true;
        }, (0, $3e88191b87395c2e$export$11c61e12af5e1f41)));
    }, [
        colIndex,
        editor,
        rootEditor,
        rowIndex,
        saveAndFocus,
        setActiveCell
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (focus && editor) editor.focus();
    }, [
        focus,
        editor
    ]);
    if (!editor) return null;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3ee369f135efbd55$export$a7eef1ce2651a334), {
        initialEditor: editor
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0c3e62e220668ac1$export$26ad95729aab2c7a), {
        contentEditable: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a04f6a7c3553d076$export$15d656b6f5aa1ba8), null),
        placeholder: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", null),
        ErrorBoundary: (0, $e03e38c0e008fd9d$export$a8147b707c252e29)
    }), tableCellEditorChildren.map((Child, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Child, {
            key: index
        })));
};
const $5889103a17472acd$var$ColumnEditor = ({ parentEditor: parentEditor, highlightedCoordinates: highlightedCoordinates, align: align, lexicalTable: lexicalTable, colIndex: colIndex, setActiveCellWithBoundaries: setActiveCellWithBoundaries })=>{
    const [editorRootElementRef, iconComponentFor] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $5a7e051e41645429$export$48bc1afe38b0f854), (0, $5a7e051e41645429$export$4fd464b2b09e1c4d));
    const insertColumnAt = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((colIndex2)=>{
        parentEditor.update(()=>{
            lexicalTable.insertColumnAt(colIndex2);
        });
        setActiveCellWithBoundaries([
            colIndex2,
            0
        ]);
    }, [
        parentEditor,
        lexicalTable,
        setActiveCellWithBoundaries
    ]);
    const deleteColumnAt = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((colIndex2)=>{
        parentEditor.update(()=>{
            lexicalTable.deleteColumnAt(colIndex2);
        });
    }, [
        parentEditor,
        lexicalTable
    ]);
    const setColumnAlign = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((colIndex2, align2)=>{
        parentEditor.update(()=>{
            lexicalTable.setColumnAlign(colIndex2, align2);
        });
    }, [
        parentEditor,
        lexicalTable
    ]);
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$be92b6f5f03c0fe9, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$7dacb05d26466c3, {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tableColumnEditorTrigger,
        "data-active": highlightedCoordinates[0] === colIndex + 1,
        title: t("table.columnMenu", "Column menu")
    }, iconComponentFor("more_horiz")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$602eac185826482c, {
        container: editorRootElementRef == null ? void 0 : editorRootElementRef.current
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$d7e1f420b25549ff, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tableColumnEditorPopoverContent),
        onOpenAutoFocus: (e)=>{
            e.preventDefault();
        },
        sideOffset: 5,
        side: "top"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$be92b6f5f03c0fe9, {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tableColumnEditorToolbar
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$af3ec21f6cfb5e30, {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).toggleGroupRoot,
        onValueChange: (value)=>{
            setColumnAlign(colIndex, value);
        },
        value: align !== null && align !== void 0 ? align : "left",
        type: "single",
        "aria-label": t("table.textAlignment", "Text alignment")
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$920ad4cf87b18fc7, {
        value: "left",
        title: t("table.alignLeft", "Align left")
    }, iconComponentFor("format_align_left")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$920ad4cf87b18fc7, {
        value: "center",
        title: t("table.alignCenter", "Align center")
    }, iconComponentFor("format_align_center")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$920ad4cf87b18fc7, {
        value: "right",
        title: t("table.alignRight", "Align right")
    }, iconComponentFor("format_align_right"))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$1ff3c3f08ae963c0, null), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$353f5b6fc5456de1, {
        onClick: insertColumnAt.bind(null, colIndex),
        title: t("table.insertColumnLeft", "Insert a column to the left of this one")
    }, iconComponentFor("insert_col_left")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$353f5b6fc5456de1, {
        onClick: insertColumnAt.bind(null, colIndex + 1),
        title: t("table.insertColumnRight", "Insert a column to the right of this one")
    }, iconComponentFor("insert_col_right")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$353f5b6fc5456de1, {
        onClick: deleteColumnAt.bind(null, colIndex),
        title: t("table.deleteColumn", "Delete this column")
    }, iconComponentFor("delete_small"))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$21b07c8f274aebd5, {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).popoverArrow
    }))));
};
const $5889103a17472acd$var$RowEditor = ({ parentEditor: parentEditor, highlightedCoordinates: highlightedCoordinates, lexicalTable: lexicalTable, rowIndex: rowIndex, setActiveCellWithBoundaries: setActiveCellWithBoundaries })=>{
    const [editorRootElementRef, iconComponentFor] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $5a7e051e41645429$export$48bc1afe38b0f854), (0, $5a7e051e41645429$export$4fd464b2b09e1c4d));
    const insertRowAt = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((rowIndex2)=>{
        parentEditor.update(()=>{
            lexicalTable.insertRowAt(rowIndex2);
        });
        setActiveCellWithBoundaries([
            0,
            rowIndex2
        ]);
    }, [
        parentEditor,
        lexicalTable,
        setActiveCellWithBoundaries
    ]);
    const deleteRowAt = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((rowIndex2)=>{
        parentEditor.update(()=>{
            lexicalTable.deleteRowAt(rowIndex2);
        });
    }, [
        parentEditor,
        lexicalTable
    ]);
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$be92b6f5f03c0fe9, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$7dacb05d26466c3, {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tableColumnEditorTrigger,
        "data-active": highlightedCoordinates[1] === rowIndex,
        title: t("table.rowMenu", "Row menu")
    }, iconComponentFor("more_horiz")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$602eac185826482c, {
        container: editorRootElementRef == null ? void 0 : editorRootElementRef.current
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$d7e1f420b25549ff, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tableColumnEditorPopoverContent),
        onOpenAutoFocus: (e)=>{
            e.preventDefault();
        },
        sideOffset: 5,
        side: "bottom"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$be92b6f5f03c0fe9, {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).tableColumnEditorToolbar
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$353f5b6fc5456de1, {
        onClick: insertRowAt.bind(null, rowIndex),
        title: t("table.insertRowAbove", "Insert a row above this one")
    }, iconComponentFor("insert_row_above")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$353f5b6fc5456de1, {
        onClick: insertRowAt.bind(null, rowIndex + 1),
        title: t("table.insertRowBelow", "Insert a row below this one")
    }, iconComponentFor("insert_row_below")), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($3addc25501ee06b8$export$353f5b6fc5456de1, {
        onClick: deleteRowAt.bind(null, rowIndex),
        title: t("table.deleteRow", "Delete this row")
    }, iconComponentFor("delete_small"))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($4fba2669e33915a2$export$21b07c8f274aebd5, {
        className: (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).popoverArrow
    }))));
};


var $cac9443591eaea96$var$__defProp = Object.defineProperty;
var $cac9443591eaea96$var$__defNormalProp = (obj, key, value)=>key in obj ? $cac9443591eaea96$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $cac9443591eaea96$var$__publicField = (obj, key, value)=>$cac9443591eaea96$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const $cac9443591eaea96$var$EMPTY_CELL = {
    type: "tableCell",
    children: []
};
function $cac9443591eaea96$var$coordinatesEmitter() {
    let subscription = (0, $0bde9de2375dfc26$export$8793edee2d425525);
    return {
        publish: (coords)=>{
            subscription(coords);
        },
        subscribe: (cb)=>{
            subscription = cb;
        }
    };
}
class $cac9443591eaea96$export$8afae231582c1ea2 extends (0, $3e88191b87395c2e$export$8244b9efe04488e) {
    /** @internal */ static getType() {
        return "table";
    }
    /** @internal */ static clone(node) {
        return new $cac9443591eaea96$export$8afae231582c1ea2(structuredClone(node.__mdastNode), node.__key);
    }
    /** @internal */ static importJSON(serializedNode) {
        return $cac9443591eaea96$export$16c8dff111f0446c(serializedNode.mdastNode);
    }
    /** @internal */ static importDOM() {
        return {
            table: ()=>{
                return {
                    conversion: $cac9443591eaea96$export$45940146f364912b,
                    priority: 3
                };
            }
        };
    }
    /** @internal */ exportJSON() {
        return {
            mdastNode: structuredClone(this.__mdastNode),
            type: "table",
            version: 1
        };
    }
    /**
   * Returns the mdast node that this node is constructed from.
   */ getMdastNode() {
        return this.__mdastNode;
    }
    /**
   * Returns the number of rows in the table.
   */ getRowCount() {
        return this.__mdastNode.children.length;
    }
    /**
   * Returns the number of columns in the table.
   */ getColCount() {
        var _a;
        return ((_a = this.__mdastNode.children[0]) == null ? void 0 : _a.children.length) || 0;
    }
    /** @internal */ createDOM() {
        return document.createElement("div");
    }
    /** @internal */ updateDOM() {
        return false;
    }
    /** @internal */ updateCellContents(colIndex, rowIndex, children) {
        const self = this.getWritable();
        const table = self.__mdastNode;
        const row = table.children[rowIndex];
        const cells = row.children;
        const cell = cells[colIndex];
        const cellsClone = Array.from(cells);
        const cellClone = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, cell), {
            children: children
        });
        const rowClone = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, row), {
            children: cellsClone
        });
        cellsClone[colIndex] = cellClone;
        table.children[rowIndex] = rowClone;
    }
    insertColumnAt(colIndex) {
        const self = this.getWritable();
        const table = self.__mdastNode;
        for(let rowIndex = 0; rowIndex < table.children.length; rowIndex++){
            const row = table.children[rowIndex];
            const cells = row.children;
            const cellsClone = Array.from(cells);
            const rowClone = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, row), {
                children: cellsClone
            });
            cellsClone.splice(colIndex, 0, structuredClone($cac9443591eaea96$var$EMPTY_CELL));
            table.children[rowIndex] = rowClone;
        }
        if (table.align && table.align.length > 0) table.align.splice(colIndex, 0, "left");
    }
    deleteColumnAt(colIndex) {
        const self = this.getWritable();
        const table = self.__mdastNode;
        for(let rowIndex = 0; rowIndex < table.children.length; rowIndex++){
            const row = table.children[rowIndex];
            const cells = row.children;
            const cellsClone = Array.from(cells);
            const rowClone = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, row), {
                children: cellsClone
            });
            cellsClone.splice(colIndex, 1);
            table.children[rowIndex] = rowClone;
        }
    }
    insertRowAt(y) {
        const self = this.getWritable();
        const table = self.__mdastNode;
        const newRow = {
            type: "tableRow",
            children: Array.from({
                length: this.getColCount()
            }, ()=>structuredClone($cac9443591eaea96$var$EMPTY_CELL))
        };
        table.children.splice(y, 0, newRow);
    }
    deleteRowAt(rowIndex) {
        if (this.getRowCount() === 1) {
            this.selectNext();
            this.remove();
        } else this.getWritable().__mdastNode.children.splice(rowIndex, 1);
    }
    addRowToBottom() {
        this.insertRowAt(this.getRowCount());
    }
    addColumnToRight() {
        this.insertColumnAt(this.getColCount());
    }
    setColumnAlign(colIndex, align) {
        const self = this.getWritable();
        const table = self.__mdastNode;
        var _table_align;
        (_table_align = table.align) !== null && _table_align !== void 0 ? _table_align : table.align = [];
        table.align[colIndex] = align;
    }
    /** @internal */ decorate(parentEditor) {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5889103a17472acd$export$4a87b5959f9ee157), {
            lexicalTable: this,
            mdastNode: this.__mdastNode,
            parentEditor: parentEditor
        });
    }
    /**
   * Focuses the table cell at the specified coordinates.
   * Pass `undefined` to remove the focus.
   */ select(coords) {
        this.focusEmitter.publish(coords !== null && coords !== void 0 ? coords : [
            0,
            0
        ]);
    }
    /** @internal */ isInline() {
        return false;
    }
    /**
   * Constructs a new {@link TableNode} with the specified MDAST table node as the object to edit.
   * See {@link https://github.com/micromark/micromark-extension-gfm-table | micromark/micromark-extension-gfm-table} for more information on the MDAST table node.
   */ constructor(mdastNode, key){
        super(key);
        /** @internal */ $cac9443591eaea96$var$__publicField(this, "__mdastNode");
        /** @internal */ $cac9443591eaea96$var$__publicField(this, "focusEmitter", $cac9443591eaea96$var$coordinatesEmitter());
        this.__mdastNode = mdastNode !== null && mdastNode !== void 0 ? mdastNode : {
            type: "table",
            children: []
        };
    }
}
function $cac9443591eaea96$export$db59ee06e018b94f(node) {
    return node instanceof $cac9443591eaea96$export$8afae231582c1ea2;
}
function $cac9443591eaea96$export$16c8dff111f0446c(mdastNode) {
    return new $cac9443591eaea96$export$8afae231582c1ea2(mdastNode);
}
function $cac9443591eaea96$export$45940146f364912b(element) {
    const rows = element.querySelectorAll("tr");
    const children = Array.from(rows).map((row)=>{
        return {
            type: "tableRow",
            children: Array.from(row.querySelectorAll("td, th")).map((cell)=>{
                return {
                    type: "tableCell",
                    children: [
                        {
                            type: "text",
                            value: cell.textContent
                        }
                    ]
                };
            })
        };
    });
    return {
        node: new $cac9443591eaea96$export$8afae231582c1ea2({
            type: "table",
            children: children
        })
    };
}


const $8eb4741e881f0786$export$163805289a3fb8b1 = {
    testLexicalNode: (0, $cac9443591eaea96$export$db59ee06e018b94f),
    visitLexicalNode ({ actions: actions, mdastParent: mdastParent, lexicalNode: lexicalNode }) {
        actions.appendToParent(mdastParent, lexicalNode.getMdastNode());
    }
};



const $cc79dccfd5b33a5f$export$d6347cf54537cda8 = {
    testNode: "table",
    visitNode ({ mdastNode: mdastNode, lexicalParent: lexicalParent }) {
        lexicalParent.append((0, $cac9443591eaea96$export$16c8dff111f0446c)(mdastNode));
    }
};



function $fff60e14da704f3d$var$seedTable(rows = 1, columns = 1) {
    const table = {
        type: "table",
        children: []
    };
    for(let i = 0; i < rows; i++){
        const tableRow = {
            type: "tableRow",
            children: []
        };
        for(let j = 0; j < columns; j++){
            const cell = {
                type: "tableCell",
                children: []
            };
            tableRow.children.push(cell);
        }
        table.children.push(tableRow);
    }
    return table;
}
const $fff60e14da704f3d$export$60a7306805f2900c = (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r)=>{
    r.link(r.pipe($fff60e14da704f3d$export$60a7306805f2900c, (0, $0a163704d09ac3e9$export$871de8747c9eaa88)(({ rows: rows, columns: columns })=>{
        return ()=>(0, $cac9443591eaea96$export$16c8dff111f0446c)($fff60e14da704f3d$var$seedTable(rows, columns));
    })), (0, $5a7e051e41645429$export$d0d524a47378923b));
});
const $fff60e14da704f3d$export$2aaa25794affcf21 = (0, $180ae8514eec30ee$export$a1bf852fe7c1a323)({
    init (realm, params) {
        var _ref, _ref1;
        realm.pubIn({
            // import
            [(0, $5a7e051e41645429$export$e37abcf8e1dbb715)]: (0, $27370860b3e1d456$export$8bd0ec8ecf6adb7d)(),
            [(0, $5a7e051e41645429$export$e8901c15ed1d713c)]: (0, $fe86da6860750184$export$e36cebda627bf2dd)(),
            [(0, $5a7e051e41645429$export$bab06f5ebfbf5c23)]: (0, $cc79dccfd5b33a5f$export$d6347cf54537cda8),
            // export
            [(0, $5a7e051e41645429$export$7544518b8e31b27e)]: (0, $cac9443591eaea96$export$8afae231582c1ea2),
            [(0, $5a7e051e41645429$export$4c7dc64aa0c7faf)]: (0, $8eb4741e881f0786$export$163805289a3fb8b1),
            [(0, $5a7e051e41645429$export$f47abfccac67a6f3)]: (0, $27370860b3e1d456$export$dafcad76ea6e0045)({
                tableCellPadding: (_ref = params == null ? void 0 : params.tableCellPadding) !== null && _ref !== void 0 ? _ref : true,
                tablePipeAlign: (_ref1 = params == null ? void 0 : params.tablePipeAlign) !== null && _ref1 !== void 0 ? _ref1 : true
            })
        });
    }
});




const $68250d32f3069ffc$export$cff01a9b5cadaafc = ()=>{
    const iconComponentFor = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$4fd464b2b09e1c4d));
    const insertTable = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $fff60e14da704f3d$export$60a7306805f2900c));
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    const isDisabled = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$ff9202ce34428c67));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5f22da7309bc91a3$export$1158bddbb6341bad), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        title: t("toolbar.table", "Insert Table"),
        onClick: ()=>{
            insertTable({
                rows: 3,
                columns: 3
            });
        }
    }, isDisabled ? {
        "aria-disabled": true,
        "data-disabled": true,
        disabled: true
    } : {}), iconComponentFor("table"));
};



var $7fPBF = parcelRequire("7fPBF");

const $8df0220b28dc4bff$export$d6e88089e23ceb54 = {
    testNode: "link",
    visitNode ({ mdastNode: mdastNode, actions: actions }) {
        actions.addAndStepInto((0, $1ad5ac6f16b99f6f$export$5ec42376570ce194)(mdastNode.url, {
            title: mdastNode.title
        }));
    }
};



const $0f59bda31be35fde$export$d2f09f4cee6bf652 = {
    testLexicalNode: (0, $1ad5ac6f16b99f6f$export$b46127abfd772033),
    visitLexicalNode: ({ lexicalNode: lexicalNode, actions: actions })=>{
        actions.addAndStepInto("link", {
            url: lexicalNode.getURL(),
            title: lexicalNode.getTitle()
        });
    }
};



/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 



var $7fPBF = parcelRequire("7fPBF");
function $1bafc84029aac76d$export$643d96cf64b9f2c1({ validateUrl: l, attributes: n }) {
    const [a] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)();
    return (0, $7fPBF.useEffect)(()=>{
        if (!a.hasNodes([
            (0, $1ad5ac6f16b99f6f$export$4341066b87270133)
        ])) throw new Error("LinkPlugin: LinkNode not registered on editor");
    }), (0, $7fPBF.useEffect)(()=>(0, $1ad5ac6f16b99f6f$export$6c7e75a5399f8f91)(a, (0, $8ebc39becbfbdd8f$export$b351c03363e45c4f)({
            attributes: n,
            validateUrl: l
        })), [
        a,
        l,
        n
    ]), null;
}


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 


var $7fPBF = parcelRequire("7fPBF");
function $e86d619aa079fe75$var$t(n, t, i, a) {
    (0, $7fPBF.useEffect)(()=>{
        n.hasNodes([
            (0, $1ad5ac6f16b99f6f$export$1f3c6513e80fcb51)
        ]) || function(e, ...r) {
            const n = new URL("https://lexical.dev/docs/error"), o = new URLSearchParams;
            o.append("code", e);
            for (const e of r)o.append("v", e);
            throw n.search = o.toString(), Error(`Minified Lexical error #${e}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
        }(77);
    }), (0, $7fPBF.useEffect)(()=>(0, $1ad5ac6f16b99f6f$export$882620ee52a742c3)(n, {
            changeHandlers: i ? [
                i
            ] : [],
            excludeParents: a !== null && a !== void 0 ? a : [],
            matchers: t
        }), [
        n,
        t,
        i,
        a
    ]);
}
function $e86d619aa079fe75$export$537404fc236491c0({ matchers: e, onChange: r, excludeParents: o }) {
    const [i] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)();
    return $e86d619aa079fe75$var$t(i, e, r, o), null;
}



var $7fPBF = parcelRequire("7fPBF");
const $7bf31abb0fd341d2$var$URL_REGEX = /((https?:\/\/(www\.)?)|(www\.))[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_+.~#?&//=]*)/;
const $7bf31abb0fd341d2$var$EMAIL_REGEX = /(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
const $7bf31abb0fd341d2$var$MATCHERS = [
    (0, $1ad5ac6f16b99f6f$export$3583a6cf3361e750)($7bf31abb0fd341d2$var$URL_REGEX, (text)=>{
        return text.startsWith("http") ? text : `https://${text}`;
    }),
    (0, $1ad5ac6f16b99f6f$export$3583a6cf3361e750)($7bf31abb0fd341d2$var$EMAIL_REGEX, (text)=>{
        return `mailto:${text}`;
    })
];
const $7bf31abb0fd341d2$export$fbd0c55d68e719c2 = ()=>{
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $e86d619aa079fe75$export$537404fc236491c0), {
        matchers: $7bf31abb0fd341d2$var$MATCHERS
    });
};





const $2024db92856d5f0d$export$3a5edd51b91384b9 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(false);
const $2024db92856d5f0d$export$4c1439d109c8788c = (0, $180ae8514eec30ee$export$a1bf852fe7c1a323)({
    init (realm, params) {
        const disableAutoLink = Boolean(params == null ? void 0 : params.disableAutoLink);
        const linkPluginProps = (params == null ? void 0 : params.validateUrl) ? {
            validateUrl: params.validateUrl
        } : {};
        const EditorChild = ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $1bafc84029aac76d$export$643d96cf64b9f2c1), (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, linkPluginProps)), disableAutoLink ? null : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $7bf31abb0fd341d2$export$fbd0c55d68e719c2), null));
        realm.pubIn({
            [(0, $5a7e051e41645429$export$ffc48b904d2782f7)]: "link",
            [(0, $5a7e051e41645429$export$bab06f5ebfbf5c23)]: (0, $8df0220b28dc4bff$export$d6e88089e23ceb54),
            [(0, $5a7e051e41645429$export$7544518b8e31b27e)]: [
                (0, $1ad5ac6f16b99f6f$export$4341066b87270133),
                (0, $1ad5ac6f16b99f6f$export$1f3c6513e80fcb51)
            ],
            [(0, $5a7e051e41645429$export$4c7dc64aa0c7faf)]: (0, $0f59bda31be35fde$export$d2f09f4cee6bf652),
            [$2024db92856d5f0d$export$3a5edd51b91384b9]: disableAutoLink,
            [(0, $5a7e051e41645429$export$16cecaa0e6290978)]: EditorChild,
            [(0, $5a7e051e41645429$export$4195d00b0b92e4c)]: EditorChild,
            [(0, $5a7e051e41645429$export$d120e029a7b56e15)]: EditorChild
        });
    }
});


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 






function $5028a2194eda8107$var$ht(t, ...e) {
    const n = new URL("https://lexical.dev/docs/error"), r = new URLSearchParams;
    r.append("code", t);
    for (const t of e)r.append("v", t);
    throw n.search = r.toString(), Error(`Minified Lexical error #${t}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function $5028a2194eda8107$export$65b7c3f240fd9bf2(t) {
    let e = 1, n = t.getParent();
    for(; null != n;){
        if ($5028a2194eda8107$export$5886b0b0310d92bc(n)) {
            const t = n.getParent();
            if ($5028a2194eda8107$export$28b8a3a3a286e016(t)) {
                e++, n = t.getParent();
                continue;
            }
            $5028a2194eda8107$var$ht(40);
        }
        return e;
    }
    return e;
}
function $5028a2194eda8107$var$dt(t) {
    const e = t.getParent();
    $5028a2194eda8107$export$28b8a3a3a286e016(e) || $5028a2194eda8107$var$ht(40);
    let n = e, r = e;
    for(; null !== r;)r = r.getParent(), $5028a2194eda8107$export$28b8a3a3a286e016(r) && (n = r);
    return n;
}
function $5028a2194eda8107$var$pt(t) {
    let e = [];
    const n = t.getChildren().filter($5028a2194eda8107$export$5886b0b0310d92bc);
    for(let t = 0; t < n.length; t++){
        const r = n[t], i = r.getFirstChild();
        $5028a2194eda8107$export$28b8a3a3a286e016(i) ? e = e.concat($5028a2194eda8107$var$pt(i)) : e.push(r);
    }
    return e;
}
function $5028a2194eda8107$var$mt(t) {
    return $5028a2194eda8107$export$5886b0b0310d92bc(t) && $5028a2194eda8107$export$28b8a3a3a286e016(t.getFirstChild());
}
function $5028a2194eda8107$var$_t(t, e) {
    return $5028a2194eda8107$export$5886b0b0310d92bc(t) && (0 === e.length || 1 === e.length && t.is(e[0]) && 0 === t.getChildrenSize());
}
function $5028a2194eda8107$export$eab7c40bdcfe5ae9(t) {
    const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (null !== e) {
        let n = e.getNodes();
        if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) {
            const [r] = e.getStartEndPoints(), i = r.getNode(), l = i.getParent();
            if ((0, $3e88191b87395c2e$export$6f851a24c61146af)(i)) {
                const t = i.getFirstChild();
                if (t) n = t.selectStart().getNodes();
                else {
                    const t = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
                    i.append(t), n = t.select().getNodes();
                }
            } else if ($5028a2194eda8107$var$_t(i, n)) {
                const e = $5028a2194eda8107$export$da1d71251340f655(t);
                if ((0, $3e88191b87395c2e$export$6f851a24c61146af)(l)) {
                    i.replace(e);
                    const t = $5028a2194eda8107$export$e9269f07c60f7b34();
                    (0, $3e88191b87395c2e$export$923a058ef54437a4)(i) && (t.setFormat(i.getFormatType()), t.setIndent(i.getIndent())), e.append(t);
                } else if ($5028a2194eda8107$export$5886b0b0310d92bc(i)) {
                    const t = i.getParentOrThrow();
                    $5028a2194eda8107$var$Ct(e, t.getChildren()), t.replace(e);
                }
                return;
            }
        }
        const i = new Set;
        for(let e = 0; e < n.length; e++){
            const r = n[e];
            if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(r) && r.isEmpty() && !$5028a2194eda8107$export$5886b0b0310d92bc(r) && !i.has(r.getKey())) {
                $5028a2194eda8107$var$kt(r, t);
                continue;
            }
            let o = (0, $3e88191b87395c2e$export$8d016e0592201ace)(r) ? r.getParent() : $5028a2194eda8107$export$5886b0b0310d92bc(r) && r.isEmpty() ? r : null;
            for(; null != o;){
                const e = o.getKey();
                if ($5028a2194eda8107$export$28b8a3a3a286e016(o)) {
                    if (!i.has(e)) {
                        const n = $5028a2194eda8107$export$da1d71251340f655(t);
                        $5028a2194eda8107$var$Ct(n, o.getChildren()), o.replace(n), i.add(e);
                    }
                    break;
                }
                {
                    const n = o.getParent();
                    if ((0, $3e88191b87395c2e$export$6f851a24c61146af)(n) && !i.has(e)) {
                        i.add(e), $5028a2194eda8107$var$kt(o, t);
                        break;
                    }
                    o = n;
                }
            }
        }
    }
}
function $5028a2194eda8107$var$Ct(t, e) {
    t.splice(t.getChildrenSize(), 0, e);
}
function $5028a2194eda8107$var$kt(t, e) {
    if ($5028a2194eda8107$export$28b8a3a3a286e016(t)) return t;
    const i = t.getPreviousSibling(), s = t.getNextSibling(), o = $5028a2194eda8107$export$e9269f07c60f7b34();
    let l;
    if ($5028a2194eda8107$var$Ct(o, t.getChildren()), $5028a2194eda8107$export$28b8a3a3a286e016(i) && e === i.getListType()) i.append(o), $5028a2194eda8107$export$28b8a3a3a286e016(s) && e === s.getListType() && ($5028a2194eda8107$var$Ct(i, s.getChildren()), s.remove()), l = i;
    else if ($5028a2194eda8107$export$28b8a3a3a286e016(s) && e === s.getListType()) s.getFirstChildOrThrow().insertBefore(o), l = s;
    else {
        const n = $5028a2194eda8107$export$da1d71251340f655(e);
        n.append(o), t.replace(n), l = n;
    }
    o.setFormat(t.getFormatType()), o.setIndent(t.getIndent());
    const c = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    return (0, $3e88191b87395c2e$export$181b63acea8a0224)(c) && (l.getKey() === c.anchor.key && c.anchor.set(o.getKey(), c.anchor.offset, "element"), l.getKey() === c.focus.key && c.focus.set(o.getKey(), c.focus.offset, "element")), t.remove(), l;
}
function $5028a2194eda8107$var$bt(t, e) {
    const n = t.getLastChild(), r = e.getFirstChild();
    n && r && $5028a2194eda8107$var$mt(n) && $5028a2194eda8107$var$mt(r) && ($5028a2194eda8107$var$bt(n.getFirstChild(), r.getFirstChild()), r.remove());
    const i = e.getChildren();
    i.length > 0 && t.append(...i), e.remove();
}
function $5028a2194eda8107$export$873326a1afd5a54b() {
    const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) {
        const n = new Set, r = e.getNodes(), i = e.anchor.getNode();
        if ($5028a2194eda8107$var$_t(i, r)) n.add($5028a2194eda8107$var$dt(i));
        else for(let e = 0; e < r.length; e++){
            const i = r[e];
            if ((0, $3e88191b87395c2e$export$8d016e0592201ace)(i)) {
                const e = (0, $74849711df60ce24$export$9f980e09b7e30818)(i, $5028a2194eda8107$export$b54db49906c92aaa);
                null != e && n.add($5028a2194eda8107$var$dt(e));
            }
        }
        for (const t of n){
            let n = t;
            const r = $5028a2194eda8107$var$pt(t);
            for (const t of r){
                const r = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)().setTextStyle(e.style).setTextFormat(e.format);
                $5028a2194eda8107$var$Ct(r, t.getChildren()), n.insertAfter(r), n = r, t.__key === e.anchor.key && (0, $3e88191b87395c2e$export$dd601b22fa430ce6)(e.anchor, (0, $3e88191b87395c2e$export$33e015e8f2ff8536)((0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(r, "next"))), t.__key === e.focus.key && (0, $3e88191b87395c2e$export$dd601b22fa430ce6)(e.focus, (0, $3e88191b87395c2e$export$33e015e8f2ff8536)((0, $3e88191b87395c2e$export$19f6ef5eb31488f9)(r, "next"))), t.remove();
            }
            t.remove();
        }
    }
}
function $5028a2194eda8107$var$vt(t) {
    const e = "check" !== t.getListType();
    let n = t.getStart();
    for (const r of t.getChildren())$5028a2194eda8107$export$5886b0b0310d92bc(r) && (r.getValue() !== n && r.setValue(n), e && null != r.getLatest().__checked && r.setChecked(void 0), $5028a2194eda8107$export$28b8a3a3a286e016(r.getFirstChild()) || n++);
}
function $5028a2194eda8107$var$Tt(t) {
    const e = new Set;
    if ($5028a2194eda8107$var$mt(t) || e.has(t.getKey())) return;
    const n = t.getParent(), r = t.getNextSibling(), i = t.getPreviousSibling();
    if ($5028a2194eda8107$var$mt(r) && $5028a2194eda8107$var$mt(i)) {
        const n = i.getFirstChild();
        if ($5028a2194eda8107$export$28b8a3a3a286e016(n)) {
            n.append(t);
            const i = r.getFirstChild();
            if ($5028a2194eda8107$export$28b8a3a3a286e016(i)) $5028a2194eda8107$var$Ct(n, i.getChildren()), r.remove(), e.add(r.getKey());
        }
    } else if ($5028a2194eda8107$var$mt(r)) {
        const e = r.getFirstChild();
        if ($5028a2194eda8107$export$28b8a3a3a286e016(e)) {
            const n = e.getFirstChild();
            null !== n && n.insertBefore(t);
        }
    } else if ($5028a2194eda8107$var$mt(i)) {
        const e = i.getFirstChild();
        $5028a2194eda8107$export$28b8a3a3a286e016(e) && e.append(t);
    } else if ($5028a2194eda8107$export$28b8a3a3a286e016(n)) {
        const e = (0, $3e88191b87395c2e$export$def73b17b22438e7)(t), s = (0, $3e88191b87395c2e$export$def73b17b22438e7)(n);
        e.append(s), s.append(t), i ? i.insertAfter(e) : r ? r.insertBefore(e) : n.append(e);
    }
}
function $5028a2194eda8107$var$xt(t) {
    if ($5028a2194eda8107$var$mt(t)) return;
    const e = t.getParent(), n = e ? e.getParent() : void 0;
    if ($5028a2194eda8107$export$28b8a3a3a286e016(n ? n.getParent() : void 0) && $5028a2194eda8107$export$5886b0b0310d92bc(n) && $5028a2194eda8107$export$28b8a3a3a286e016(e)) {
        const r = e ? e.getFirstChild() : void 0, i = e ? e.getLastChild() : void 0;
        if (t.is(r)) n.insertBefore(t), e.isEmpty() && n.remove();
        else if (t.is(i)) n.insertAfter(t), e.isEmpty() && n.remove();
        else {
            const r = (0, $3e88191b87395c2e$export$def73b17b22438e7)(t), i = (0, $3e88191b87395c2e$export$def73b17b22438e7)(e);
            r.append(i), t.getPreviousSiblings().forEach((t)=>i.append(t));
            const s = (0, $3e88191b87395c2e$export$def73b17b22438e7)(t), o = (0, $3e88191b87395c2e$export$def73b17b22438e7)(e);
            s.append(o), $5028a2194eda8107$var$Ct(o, t.getNextSiblings()), n.insertBefore(r), n.insertAfter(s), n.replace(t);
        }
    }
}
function $5028a2194eda8107$export$61183f0d4d6eaad(t = !1) {
    const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e) || !e.isCollapsed()) return !1;
    const c = e.anchor.getNode();
    let a = null;
    if ($5028a2194eda8107$export$5886b0b0310d92bc(c) && 0 === c.getChildrenSize()) a = c;
    else if ((0, $3e88191b87395c2e$export$471953706258be2b)(c)) {
        const t = c.getParent();
        $5028a2194eda8107$export$5886b0b0310d92bc(t) && t.getChildren().every((t)=>(0, $3e88191b87395c2e$export$471953706258be2b)(t) && "" === t.getTextContent().trim()) && (a = t);
    }
    if (null === a) return !1;
    const u = $5028a2194eda8107$var$dt(a), g = a.getParent();
    $5028a2194eda8107$export$28b8a3a3a286e016(g) || $5028a2194eda8107$var$ht(40);
    const h = g.getParent();
    let f;
    if ((0, $3e88191b87395c2e$export$6f851a24c61146af)(h)) f = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)(), u.insertAfter(f);
    else {
        if (!$5028a2194eda8107$export$5886b0b0310d92bc(h)) return !1;
        f = (0, $3e88191b87395c2e$export$def73b17b22438e7)(h), h.insertAfter(f);
    }
    f.setTextStyle(e.style).setTextFormat(e.format).select();
    const d = a.getNextSiblings();
    if (d.length > 0) {
        const e = t ? function(t, e) {
            return t.getStart() + e.getIndexWithinParent();
        }(g, a) : 1, n = (0, $3e88191b87395c2e$export$def73b17b22438e7)(g).setStart(e);
        if ($5028a2194eda8107$export$5886b0b0310d92bc(f)) {
            const t = (0, $3e88191b87395c2e$export$def73b17b22438e7)(f);
            t.append(n), f.insertAfter(t);
        } else f.insertAfter(n);
        n.append(...d);
    }
    return function(t) {
        let e = t;
        for(; null == e.getNextSibling() && null == e.getPreviousSibling();){
            const t = e.getParent();
            if (null == t || !$5028a2194eda8107$export$5886b0b0310d92bc(t) && !$5028a2194eda8107$export$28b8a3a3a286e016(t)) break;
            e = t;
        }
        e.remove();
    }(a), !0;
}
class $5028a2194eda8107$export$b54db49906c92aaa extends (0, $3e88191b87395c2e$export$dc064fe9e59310fd) {
    $config() {
        return this.config("listitem", {
            $transform: (t)=>{
                const e = t.getParent();
                if ($5028a2194eda8107$export$28b8a3a3a286e016(e)) "check" !== e.getListType() && null != t.getChecked() && t.setChecked(void 0);
                else if (e) {
                    const n = t.createParentElementNode();
                    $5028a2194eda8107$export$28b8a3a3a286e016(n) || $5028a2194eda8107$var$ht(340);
                    const r = [
                        t
                    ];
                    for (const e of [
                        "previous",
                        "next"
                    ]){
                        r.reverse();
                        for (const { origin: n } of (0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(t, e)){
                            if (!$5028a2194eda8107$export$5886b0b0310d92bc(n)) break;
                            r.push(n);
                        }
                    }
                    t.insertBefore(n), n.splice(0, 0, r), (0, $3e88191b87395c2e$export$6f851a24c61146af)(e) || ((0, $3e88191b87395c2e$export$8074a5062ab072d1)(n, (0, $3e88191b87395c2e$export$3d19514618fb28f3)((0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(n, "next")), {
                        $shouldSplit: ()=>!1,
                        removeEmptyDestination: !0
                    }), e.isEmpty() && e.isAttached() && e.remove());
                }
            },
            extends: (0, $3e88191b87395c2e$export$dc064fe9e59310fd),
            importDOM: (0, $3e88191b87395c2e$export$3bd46c0194b0999e)({
                li: ()=>({
                        conversion: $5028a2194eda8107$var$Ft,
                        priority: 0
                    })
            })
        });
    }
    afterCloneFrom(t) {
        super.afterCloneFrom(t), this.__value = t.__value, this.__checked = t.__checked;
    }
    createDOM(t) {
        const e = (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("li");
        return this.updateListItemDOM(null, e, t), e;
    }
    updateListItemDOM(t, e, n) {
        !function(t, e) {
            const n = e.getParent();
            !$5028a2194eda8107$export$28b8a3a3a286e016(n) || "check" !== n.getListType() || $5028a2194eda8107$export$28b8a3a3a286e016(e.getFirstChild()) ? (t.removeAttribute("role"), t.removeAttribute("tabIndex"), t.removeAttribute("aria-checked")) : (t.setAttribute("role", "checkbox"), t.setAttribute("tabIndex", "-1"), t.setAttribute("aria-checked", e.getChecked() ? "true" : "false"));
        }(e, this), e.value = this.__value, function(t, e, n) {
            const r = e.list;
            if (!r) return;
            const i = r.listitem, s = r.nested && r.nested.listitem, o = n.getParent(), l = $5028a2194eda8107$export$28b8a3a3a286e016(o) && "check" === o.getListType(), c = n.getChecked(), a = n.getChildren().some((t)=>$5028a2194eda8107$export$28b8a3a3a286e016(t)), u = [];
            void 0 !== r.listitemChecked && u.push(r.listitemChecked);
            void 0 !== r.listitemUnchecked && u.push(r.listitemUnchecked);
            void 0 !== s && u.push(...(0, $3e88191b87395c2e$export$68575042fda37fa9)(s));
            u.length > 0 && (0, $3e88191b87395c2e$export$b59af601940ff389)(t, ...u);
            const g = [];
            void 0 !== i && g.push(...(0, $3e88191b87395c2e$export$68575042fda37fa9)(i));
            if (l) {
                const t = c ? r.listitemChecked : r.listitemUnchecked;
                void 0 !== t && g.push(t);
            }
            void 0 !== s && a && g.push(...(0, $3e88191b87395c2e$export$68575042fda37fa9)(s));
            g.length > 0 && (0, $3e88191b87395c2e$export$71781797876b07d6)(t, ...g);
        }(e, n.theme, this);
        const r = t ? t.__style : "", i = this.__style;
        r !== i && (0, $3e88191b87395c2e$export$742e98a31b68d917)(e.style, i, r), function(t, e, n) {
            const r = e.__textStyle, i = n ? n.__textStyle : "";
            if (null !== n && i === r) return;
            const s = (0, $3e88191b87395c2e$export$2ce8a4767ed9993e)(r);
            for(const e in s)t.style.setProperty(`--listitem-marker-${e}`, s[e]);
            if ("" !== i) for(const e in (0, $3e88191b87395c2e$export$2ce8a4767ed9993e)(i))e in s || t.style.removeProperty(`--listitem-marker-${e}`);
        }(e, this, t);
    }
    updateDOM(t, e, n) {
        const r = e;
        return this.updateListItemDOM(t, r, n), !1;
    }
    updateFromJSON(t) {
        return super.updateFromJSON(t).setValue(t.value).setChecked(t.checked);
    }
    exportDOM(t) {
        const e = this.createDOM(t._config), n = this.getFormatType();
        n && (e.style.textAlign = n);
        const r = this.getDirection();
        return r && (e.dir = r), $5028a2194eda8107$var$mt(this) ? {
            after (t) {
                if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t)) {
                    const e = t.previousElementSibling;
                    if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e) && "LI" === e.nodeName) {
                        for(; t.firstChild;)e.append(t.firstChild);
                        t.remove();
                    }
                }
                return t;
            },
            element: e
        } : {
            element: e
        };
    }
    exportJSON() {
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, super.exportJSON()), {
            checked: this.getChecked(),
            value: this.getValue()
        });
    }
    append(...t) {
        for(let e = 0; e < t.length; e++){
            const n = t[e];
            if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(n) && this.canMergeWith(n)) {
                const t = n.getChildren();
                this.append(...t), n.remove();
            } else super.append(n);
        }
        return this;
    }
    replace(t, e) {
        if ($5028a2194eda8107$export$5886b0b0310d92bc(t)) return super.replace(t);
        this.setIndent(0);
        const i = this.getParentOrThrow();
        if (!$5028a2194eda8107$export$28b8a3a3a286e016(i)) return t;
        if (i.__first === this.getKey()) i.insertBefore(t);
        else if (i.__last === this.getKey()) i.insertAfter(t);
        else {
            const e = (0, $3e88191b87395c2e$export$def73b17b22438e7)(i);
            let n = this.getNextSibling();
            for(; n;){
                const t = n;
                n = n.getNextSibling(), e.append(t);
            }
            i.insertAfter(t), t.insertAfter(e);
        }
        const s = this.__key;
        let o = 0;
        if (e && ((0, $3e88191b87395c2e$export$923a058ef54437a4)(t) || $5028a2194eda8107$var$ht(139), o = t.getChildrenSize(), t.splice(o, 0, this.getChildren())), e && (0, $3e88191b87395c2e$export$923a058ef54437a4)(t)) {
            const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) for (const n of e.getStartEndPoints())n.key === s && "element" === n.type && n.set(t.getKey(), o + n.offset, "element");
        }
        return this.remove(), 0 === i.getChildrenSize() && i.remove(), t;
    }
    insertAfter(t, e = !0) {
        const n = this.getParentOrThrow();
        if ($5028a2194eda8107$export$28b8a3a3a286e016(n) || $5028a2194eda8107$var$ht(39), $5028a2194eda8107$export$5886b0b0310d92bc(t)) return super.insertAfter(t, e);
        const r = this.getNextSiblings();
        if (n.insertAfter(t, e), 0 !== r.length) {
            const i = (0, $3e88191b87395c2e$export$def73b17b22438e7)(n);
            r.forEach((t)=>i.append(t)), t.insertAfter(i, e);
        }
        return t;
    }
    remove(t) {
        const e = this.getPreviousSibling(), n = this.getNextSibling();
        super.remove(t), e && n && $5028a2194eda8107$var$mt(e) && $5028a2194eda8107$var$mt(n) && ($5028a2194eda8107$var$bt(e.getFirstChild(), n.getFirstChild()), n.remove());
    }
    resetOnCopyNodeFrom(t) {
        super.resetOnCopyNodeFrom(t), t.getChecked() && this.setChecked(!1);
    }
    insertNewAfter(t, e = !0) {
        const n = (0, $3e88191b87395c2e$export$def73b17b22438e7)(this);
        return this.insertAfter(n, e), n;
    }
    collapseAtStart(t) {
        if ($5028a2194eda8107$var$mt(this)) return !1;
        const e = this.getParentOrThrow();
        if ($5028a2194eda8107$export$5886b0b0310d92bc(e.getParentOrThrow())) return $5028a2194eda8107$var$xt(this), !0;
        const n = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)().append(...this.getChildren()), r = this.getNextSiblings();
        if (r.length > 0) {
            const t = (0, $3e88191b87395c2e$export$def73b17b22438e7)(e);
            t.append(...r), e.insertAfter(t);
        }
        return e.insertAfter(n), this.remove(), 0 === e.getChildrenSize() && e.remove(), n.selectStart(), !0;
    }
    getValue() {
        return this.getLatest().__value;
    }
    setValue(t) {
        const e = this.getWritable();
        return e.__value = t, e;
    }
    getChecked() {
        const t = this.getLatest();
        let e;
        const n = this.getParent();
        return $5028a2194eda8107$export$28b8a3a3a286e016(n) && (e = n.getListType()), "check" === e ? Boolean(t.__checked) : void 0;
    }
    setChecked(t) {
        const e = this.getWritable();
        return e.__checked = t, e;
    }
    toggleChecked() {
        const t = this.getWritable();
        return t.setChecked(!t.__checked);
    }
    getIndent() {
        const t = this.getParent();
        if (null === t || !this.isAttached()) return this.getLatest().__indent;
        let e = t.getParentOrThrow(), n = 0;
        for(; $5028a2194eda8107$export$5886b0b0310d92bc(e);)e = e.getParentOrThrow().getParentOrThrow(), n++;
        return n;
    }
    setIndent(t) {
        "number" != typeof t && $5028a2194eda8107$var$ht(117), (t = Math.floor(t)) >= 0 || $5028a2194eda8107$var$ht(199);
        let e = this.getIndent();
        for(; e !== t;)e < t ? ($5028a2194eda8107$var$Tt(this), e++) : ($5028a2194eda8107$var$xt(this), e--);
        return this;
    }
    canInsertAfter(t) {
        return $5028a2194eda8107$export$5886b0b0310d92bc(t);
    }
    canReplaceWith(t) {
        return $5028a2194eda8107$export$5886b0b0310d92bc(t);
    }
    canMergeWith(t) {
        return $5028a2194eda8107$export$5886b0b0310d92bc(t) || (0, $3e88191b87395c2e$export$1fdda795300c79c6)(t);
    }
    extractWithChild(t, e) {
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) return !1;
        const n = e.anchor.getNode(), i = e.focus.getNode();
        return this.isParentOf(n) && this.isParentOf(i) && this.getTextContent().length === e.getTextContent().length;
    }
    isParentRequired() {
        return !0;
    }
    createParentElementNode() {
        return $5028a2194eda8107$export$da1d71251340f655("bullet");
    }
    canMergeWhenEmpty() {
        return !0;
    }
    constructor(t = 1, e, n){
        super(n), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__value", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__checked", void 0), this.__value = void 0 === t ? 1 : t, this.__checked = e;
    }
}
function $5028a2194eda8107$var$Ft(t) {
    if (t.classList.contains("task-list-item")) {
        for (const e of t.children)if ("INPUT" === e.tagName) return $5028a2194eda8107$var$Lt(e);
    }
    if (t.classList.contains("joplin-checkbox")) {
        for (const e of t.children)if (e.classList.contains("checkbox-wrapper") && e.children.length > 0 && "INPUT" === e.children[0].tagName) return $5028a2194eda8107$var$Lt(e.children[0]);
    }
    const e = t.getAttribute("aria-checked"), n = $5028a2194eda8107$export$e9269f07c60f7b34("true" === e || "false" !== e && void 0);
    return (0, $3e88191b87395c2e$export$b92488674c2048ea)(n, t), {
        after: $5028a2194eda8107$var$At.bind(null, n),
        node: (0, $3e88191b87395c2e$export$44a229cf8757fa56)(n, t)
    };
}
function $5028a2194eda8107$var$Lt(t) {
    if (!("checkbox" === t.getAttribute("type"))) return {
        node: null
    };
    const e = $5028a2194eda8107$export$e9269f07c60f7b34(t.hasAttribute("checked"));
    return {
        after: $5028a2194eda8107$var$At.bind(null, e),
        node: e
    };
}
function $5028a2194eda8107$var$At(t, e) {
    const n = e[0];
    return 1 === e.length && (0, $3e88191b87395c2e$export$1fdda795300c79c6)(n) && !t.getFormatType() && n.getFormatType() ? (t.setFormat(n.getFormatType()), n.getChildren()) : e;
}
function $5028a2194eda8107$export$e9269f07c60f7b34(t) {
    return (0, $3e88191b87395c2e$export$2f5beb31df92ea57)(new $5028a2194eda8107$export$b54db49906c92aaa(void 0, t));
}
function $5028a2194eda8107$export$5886b0b0310d92bc(t) {
    return t instanceof $5028a2194eda8107$export$b54db49906c92aaa;
}
class $5028a2194eda8107$export$1223bbd530a3b8af extends (0, $3e88191b87395c2e$export$dc064fe9e59310fd) {
    $config() {
        return this.config("list", {
            $transform: (t)=>{
                !function(t) {
                    const e = t.getNextSibling();
                    $5028a2194eda8107$export$28b8a3a3a286e016(e) && t.getListType() === e.getListType() && $5028a2194eda8107$var$bt(t, e);
                }(t), $5028a2194eda8107$var$vt(t);
            },
            extends: (0, $3e88191b87395c2e$export$dc064fe9e59310fd),
            importDOM: (0, $3e88191b87395c2e$export$3bd46c0194b0999e)({
                ol: ()=>({
                        conversion: $5028a2194eda8107$var$wt,
                        priority: 0
                    }),
                ul: ()=>({
                        conversion: $5028a2194eda8107$var$wt,
                        priority: 0
                    })
            })
        });
    }
    afterCloneFrom(t) {
        super.afterCloneFrom(t), this.__listType = t.__listType, this.__tag = t.__tag, this.__start = t.__start;
    }
    getTag() {
        return this.getLatest().__tag;
    }
    setListType(t) {
        const e = this.getWritable();
        return e.__listType = t, e.__tag = "number" === t ? "ol" : "ul", e;
    }
    getListType() {
        return this.getLatest().__listType;
    }
    getStart() {
        return this.getLatest().__start;
    }
    setStart(t) {
        const e = this.getWritable();
        return e.__start = t, e;
    }
    createDOM(t, e) {
        const n = this.__tag, r = (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement(n);
        return 1 !== this.__start && r.setAttribute("start", String(this.__start)), r.__lexicalListType = this.__listType, $5028a2194eda8107$var$Dt(r, t.theme, this), r;
    }
    updateDOM(t, e, n) {
        return t.__tag !== this.__tag || t.__listType !== this.__listType || ($5028a2194eda8107$var$Dt(e, n.theme, this), t.__start !== this.__start && e.setAttribute("start", String(this.__start)), !1);
    }
    updateFromJSON(t) {
        return super.updateFromJSON(t).setListType(t.listType).setStart(t.start);
    }
    exportDOM(t) {
        const e = this.createDOM(t._config, t);
        return (0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e) && (1 !== this.__start && e.setAttribute("start", String(this.__start)), "check" === this.__listType && e.setAttribute("__lexicalListType", "check")), {
            element: e
        };
    }
    exportJSON() {
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, super.exportJSON()), {
            listType: this.getListType(),
            start: this.getStart(),
            tag: this.getTag()
        });
    }
    canBeEmpty() {
        return !1;
    }
    canIndent() {
        return !1;
    }
    splice(t, e, n) {
        let r = n;
        for(let t = 0; t < n.length; t++){
            const e = n[t];
            $5028a2194eda8107$export$5886b0b0310d92bc(e) || (r === n && (r = [
                ...n
            ]), r[t] = this.createListItemNode().append(!(0, $3e88191b87395c2e$export$923a058ef54437a4)(e) || $5028a2194eda8107$export$28b8a3a3a286e016(e) || e.isInline() ? e : (0, $3e88191b87395c2e$export$2785f39dcdec0078)(e.getTextContent())));
        }
        return super.splice(t, e, r);
    }
    extractWithChild(t) {
        return $5028a2194eda8107$export$5886b0b0310d92bc(t);
    }
    createListItemNode() {
        return $5028a2194eda8107$export$e9269f07c60f7b34();
    }
    constructor(t = "number", e = 1, n){
        super(n), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__tag", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__start", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__listType", void 0);
        const r = $5028a2194eda8107$var$Mt[t] || t;
        this.__listType = r, this.__tag = "number" === r ? "ol" : "ul", this.__start = e;
    }
}
function $5028a2194eda8107$var$Dt(t, e, n) {
    const r = [], i = [], s = e.list;
    if (void 0 !== s) {
        const t = s[`${n.__tag}Depth`] || [], e = $5028a2194eda8107$export$65b7c3f240fd9bf2(n) - 1, o = e % t.length, l = t[o], c = s[n.__tag];
        let a;
        const u = s.nested, g = s.checklist;
        if (void 0 !== u && u.list && (a = u.list), void 0 !== c && r.push(c), void 0 !== g && "check" === n.__listType && r.push(g), void 0 !== l) {
            r.push(...(0, $3e88191b87395c2e$export$68575042fda37fa9)(l));
            for(let e = 0; e < t.length; e++)e !== o && i.push(n.__tag + e);
        }
        if (void 0 !== a) {
            const t = (0, $3e88191b87395c2e$export$68575042fda37fa9)(a);
            e > 1 ? r.push(...t) : i.push(...t);
        }
    }
    i.length > 0 && (0, $3e88191b87395c2e$export$b59af601940ff389)(t, ...i), r.length > 0 && (0, $3e88191b87395c2e$export$71781797876b07d6)(t, ...r);
}
function $5028a2194eda8107$var$wt(t) {
    let e;
    if (function(t) {
        return (0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t) && "ol" === t.nodeName.toLowerCase();
    }(t)) {
        const n = t.start;
        e = $5028a2194eda8107$export$da1d71251340f655("number", n);
    } else e = function(t) {
        if ("check" === t.getAttribute("__lexicallisttype") || t.classList.contains("contains-task-list") || "1" === t.getAttribute("data-is-checklist")) return !0;
        for (const e of t.childNodes)if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e) && e.hasAttribute("aria-checked")) return !0;
        return !1;
    }(t) ? $5028a2194eda8107$export$da1d71251340f655("check") : $5028a2194eda8107$export$da1d71251340f655("bullet");
    return (0, $3e88191b87395c2e$export$44a229cf8757fa56)(e, t), {
        after: (t)=>(function(t, e) {
                const n = e.createListItemNode.bind(e), r = [];
                for(let e = 0; e < t.length; e++){
                    const i = t[e];
                    if ($5028a2194eda8107$export$5886b0b0310d92bc(i)) {
                        r.push(i);
                        const t = i.getChildren();
                        t.length > 1 && t.forEach((t)=>{
                            $5028a2194eda8107$export$28b8a3a3a286e016(t) && r.push(n().append(t));
                        });
                    } else r.push(n().append(i));
                }
                return r;
            })(t, e),
        node: e
    };
}
const $5028a2194eda8107$var$Mt = {
    ol: "number",
    ul: "bullet"
};
function $5028a2194eda8107$export$da1d71251340f655(t = "number", e = 1) {
    return (0, $3e88191b87395c2e$export$2f5beb31df92ea57)(new $5028a2194eda8107$export$1223bbd530a3b8af(t, e));
}
function $5028a2194eda8107$export$28b8a3a3a286e016(t) {
    return t instanceof $5028a2194eda8107$export$1223bbd530a3b8af;
}
const $5028a2194eda8107$export$8cbe11ae5f0bb2 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$8d4021544bdece00)("INSERT_CHECK_LIST_COMMAND");
function $5028a2194eda8107$export$154ef963a298a2c0(t, e) {
    const i = e && e.disableTakeFocusOnClick || !1, s = "boolean" == typeof i ? ()=>i : i.peek.bind(i), o = (t)=>{
        const e = t.target;
        if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e)) return !1;
        const n = e.__lexicalCheckListLastHandled;
        return void 0 !== n && t.timeStamp - n < 500;
    }, l = (t)=>{
        const e = t.target;
        (0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e) && (e.__lexicalCheckListLastHandled = t.timeStamp);
    }, a = (t)=>{
        o(t) || (l(t), $5028a2194eda8107$var$Ut(t, s()));
    }, u = (t)=>{
        "touch" === t.pointerType && (o(t) || (l(t), $5028a2194eda8107$var$Ut(t, s())));
    }, g = (t)=>{
        !function(t, e) {
            $5028a2194eda8107$var$Wt(t, ()=>{
                t.preventDefault(), e && t.stopPropagation();
            });
        }(t, s());
    };
    return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(t.registerCommand($5028a2194eda8107$export$8cbe11ae5f0bb2, ()=>($5028a2194eda8107$export$eab7c40bdcfe5ae9("check"), !0), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerCommand((0, $3e88191b87395c2e$export$baa60daa2ca402b3), (e)=>$5028a2194eda8107$var$Vt(e, t, !1), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerCommand((0, $3e88191b87395c2e$export$7833c2a33ae81d3d), (e)=>$5028a2194eda8107$var$Vt(e, t, !0), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerCommand((0, $3e88191b87395c2e$export$53589e422a755d59), ()=>{
        if (null != $5028a2194eda8107$var$Jt(t)) {
            const e = t.getRootElement();
            return null != e && e.focus(), !0;
        }
        return !1;
    }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerCommand((0, $3e88191b87395c2e$export$d0bc2bb647ce4c17), (e)=>{
        const n = $5028a2194eda8107$var$Jt(t);
        return !(null == n || !t.isEditable()) && (t.update(()=>{
            const t = (0, $3e88191b87395c2e$export$fef265f0d2fcffdd)(n);
            $5028a2194eda8107$export$5886b0b0310d92bc(t) && (e.preventDefault(), t.toggleChecked());
        }), !0);
    }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerCommand((0, $3e88191b87395c2e$export$7525f8f8ab44508), (e)=>t.read("latest", ()=>{
            const i = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if ((0, $3e88191b87395c2e$export$181b63acea8a0224)(i) && i.isCollapsed()) {
                const { anchor: n } = i, r = "element" === n.type;
                if (r || 0 === n.offset) {
                    const i = n.getNode(), s = (0, $3e88191b87395c2e$export$57101724ca611500)(i, (t)=>(0, $3e88191b87395c2e$export$923a058ef54437a4)(t) && !t.isInline());
                    if ($5028a2194eda8107$export$5886b0b0310d92bc(s)) {
                        const n = s.getParent();
                        if ($5028a2194eda8107$export$28b8a3a3a286e016(n) && "check" === n.getListType() && (r || s.getFirstDescendant() === i)) {
                            const n = t.getElementByKey(s.__key);
                            if (null != n && (0, $3e88191b87395c2e$export$cd4e5573fbe2b576)(n) !== n) return n.focus(), e.preventDefault(), !0;
                        }
                    }
                }
            }
            return !1;
        }), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerRootListener((t)=>{
        if (null !== t) return (0, $3e88191b87395c2e$export$d64d64f541cc1835)((0, $3e88191b87395c2e$export$4256f76d7567e2ca)(t, {
            click: a,
            pointerup: u
        }), (0, $3e88191b87395c2e$export$4256f76d7567e2ca)(t, {
            mousedown: g,
            pointerdown: g
        }, {
            capture: !0
        }), (0, $3e88191b87395c2e$export$bea698773a21b4e8)(t, "touchstart", g, {
            capture: !0,
            passive: !1
        }));
    }));
}
function $5028a2194eda8107$var$Wt(t, n) {
    const r = t.target;
    if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(r)) return;
    const i = r.firstChild;
    if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(i) && ("UL" === i.tagName || "OL" === i.tagName)) return;
    const s = r.parentNode;
    if (!s || "check" !== s.__lexicalListType) return;
    let o = null, l = null;
    if ("clientX" in t) o = t.clientX;
    else if ("touches" in t) {
        const e = t.touches;
        e.length > 0 && (o = e[0].clientX, l = "touch");
    }
    if (null == o) return;
    const c = r.getBoundingClientRect(), a = o / (0, $74849711df60ce24$export$8c73aeb81b5c13e3)(r), u = r.ownerDocument.defaultView, g = u ? u.getComputedStyle(r, "::before") : {
        width: "0px"
    }, h = parseFloat(g.width), f = "touch" === l || "pointerType" in t && "touch" === t.pointerType ? 32 : 0;
    ("rtl" === r.dir ? a < c.right + f && a > c.right - h - f : a > c.left - f && a < c.left + h + f) && n();
}
function $5028a2194eda8107$var$Ut(t, e) {
    $5028a2194eda8107$var$Wt(t, ()=>{
        if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t.target)) {
            const n = t.target, r = (0, $3e88191b87395c2e$export$30c13854ab4c9903)(n);
            null != r && r.isEditable() && r.update(()=>{
                const t = (0, $3e88191b87395c2e$export$fef265f0d2fcffdd)(n);
                $5028a2194eda8107$export$5886b0b0310d92bc(t) && (e ? ((0, $3e88191b87395c2e$export$24cab2f466b76c04)((0, $3e88191b87395c2e$export$8a1d07d516311732)), (0, $3e88191b87395c2e$export$24cab2f466b76c04)((0, $3e88191b87395c2e$export$2d54a03edd17ad1f))) : n.focus(), t.toggleChecked());
            });
        }
    });
}
function $5028a2194eda8107$var$Jt(t) {
    const e = t.getRootElement(), n = e ? (0, $3e88191b87395c2e$export$cd4e5573fbe2b576)(e) : null;
    return (0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(n) && "LI" === n.tagName && null != n.parentNode && "check" === n.parentNode.__lexicalListType ? n : null;
}
function $5028a2194eda8107$var$Vt(t, e, n) {
    const r = $5028a2194eda8107$var$Jt(e);
    return null != r && e.update(()=>{
        const i = (0, $3e88191b87395c2e$export$fef265f0d2fcffdd)(r);
        if (!$5028a2194eda8107$export$5886b0b0310d92bc(i)) return;
        const s = function(t, e) {
            let n = e ? t.getPreviousSibling() : t.getNextSibling(), r = t;
            for(; null == n && $5028a2194eda8107$export$5886b0b0310d92bc(r);)r = r.getParentOrThrow().getParent(), null != r && (n = e ? r.getPreviousSibling() : r.getNextSibling());
            for(; $5028a2194eda8107$export$5886b0b0310d92bc(n);){
                const t = e ? n.getLastChild() : n.getFirstChild();
                if (!$5028a2194eda8107$export$28b8a3a3a286e016(t)) return n;
                n = e ? t.getLastChild() : t.getFirstChild();
            }
            return null;
        }(i, n);
        if (null != s) {
            s.selectStart();
            const n = e.getElementByKey(s.__key);
            null != n && (t.preventDefault(), setTimeout(()=>{
                n.focus();
            }, 0));
        }
    }), !1;
}
function $5028a2194eda8107$var$qt(t) {
    const e = [];
    for (const n of t)if ($5028a2194eda8107$export$5886b0b0310d92bc(n)) {
        e.push(n);
        const t = n.getChildren();
        if (t.length > 1) for (const n of t)$5028a2194eda8107$export$28b8a3a3a286e016(n) && e.push($5028a2194eda8107$export$e9269f07c60f7b34().append(n));
    } else e.push($5028a2194eda8107$export$e9269f07c60f7b34().append(n));
    return e;
}
const $5028a2194eda8107$var$zt = /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
    $import: (t, e)=>{
        let n;
        var r;
        return (0, $9429c8604db0efde$export$a880ba0163847a11)(e, "ol") ? n = $5028a2194eda8107$export$da1d71251340f655("number", e.start) : n = (r = e).matches('[__lexicallisttype="check"], .contains-task-list, [data-is-checklist="1"]') || null !== r.querySelector(":scope > [aria-checked]") ? $5028a2194eda8107$export$da1d71251340f655("check") : $5028a2194eda8107$export$da1d71251340f655("bullet"), (0, $3e88191b87395c2e$export$44a229cf8757fa56)(n, e), [
            n.splice(0, 0, (0, $9429c8604db0efde$export$92c6602761cff598)($5028a2194eda8107$var$qt(t.$importChildren(e)), e))
        ];
    },
    match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("ol", "ul"),
    name: "@lexical/list/list"
});
function $5028a2194eda8107$var$jt(t, e) {
    if (1 !== e.length) return e;
    const n = e[0];
    return (0, $3e88191b87395c2e$export$1fdda795300c79c6)(n) && !t.getFormatType() && n.getFormatType() ? (t.setFormat(n.getFormatType()), n.getChildren()) : e;
}
function $5028a2194eda8107$var$Ht(t) {
    const e = (t)=>(0, $9429c8604db0efde$export$1caaca6642bf331)(t) && !$5028a2194eda8107$export$28b8a3a3a286e016(t);
    if (!t.some(e)) return t;
    const n = [];
    let r = [];
    const i = ()=>{
        r.length > 0 && (n.push(r), r = []);
    };
    for (const s of t)e(s) ? (i(), n.push((0, $3e88191b87395c2e$export$923a058ef54437a4)(s) ? s.getChildren() : [
        s
    ])) : r.push(s);
    i();
    const s = [];
    for (const t of n)s.length > 0 && s.push((0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)()), s.push(...t);
    return s;
}
const $5028a2194eda8107$var$Xt = /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
    $import: (t, e)=>{
        const n = e.getAttribute("aria-checked"), r = $5028a2194eda8107$export$e9269f07c60f7b34("true" === n || "false" !== n && void 0);
        return (0, $3e88191b87395c2e$export$b92488674c2048ea)(r, e), (0, $3e88191b87395c2e$export$44a229cf8757fa56)(r, e), [
            r.splice(0, 0, $5028a2194eda8107$var$Ht($5028a2194eda8107$var$jt(r, t.$importChildren(e))))
        ];
    },
    match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("li"),
    name: "@lexical/list/li"
});
function $5028a2194eda8107$var$Gt(t, e, n) {
    const r = (0, $9429c8604db0efde$export$a880ba0163847a11)(n, "input") ? n : n.querySelector('input[type="checkbox"]');
    if (!r || "checkbox" !== r.getAttribute("type")) return [];
    const i = $5028a2194eda8107$export$e9269f07c60f7b34(r.hasAttribute("checked"));
    return (0, $3e88191b87395c2e$export$b92488674c2048ea)(i, e), (0, $3e88191b87395c2e$export$44a229cf8757fa56)(i, e), [
        i.splice(0, 0, $5028a2194eda8107$var$Ht($5028a2194eda8107$var$jt(i, t.$importChildren(e))))
    ];
}
const $5028a2194eda8107$export$60e2dffcfdbb557b = {
    $accepts: (t)=>$5028a2194eda8107$export$5886b0b0310d92bc(t) || $5028a2194eda8107$export$28b8a3a3a286e016(t),
    $packageRun: (t)=>[
            $5028a2194eda8107$export$e9269f07c60f7b34().splice(0, 0, t)
        ],
    name: "ListSchema"
}, $5028a2194eda8107$export$7e19acffe1d9a73b = [
    /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
        $import: (t, e, n)=>{
            const r = e.querySelector(':scope > input[type="checkbox"]');
            return r ? $5028a2194eda8107$var$Gt(t, e, r) : n();
        },
        match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("li").classAll("task-list-item"),
        name: "@lexical/list/li-task-list-item"
    }),
    /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
        $import: (t, e, n)=>{
            const r = e.querySelector(":scope > .checkbox-wrapper");
            if (!r) return n();
            const i = r.querySelector(':scope > input[type="checkbox"]');
            return i ? $5028a2194eda8107$var$Gt(t, e, i) : n();
        },
        match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("li").classAll("joplin-checkbox"),
        name: "@lexical/list/li-joplin-checkbox"
    }),
    $5028a2194eda8107$var$zt,
    $5028a2194eda8107$var$Xt
], $5028a2194eda8107$export$1e275917a68fefc7 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$8d4021544bdece00)("UPDATE_LIST_START_COMMAND"), $5028a2194eda8107$export$317e9428adaea253 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$8d4021544bdece00)("INSERT_UNORDERED_LIST_COMMAND"), $5028a2194eda8107$export$c04baf1c5b96454b = /* @__PURE__ */ (0, $3e88191b87395c2e$export$8d4021544bdece00)("INSERT_ORDERED_LIST_COMMAND"), $5028a2194eda8107$export$4a3e2234826e52de = /* @__PURE__ */ (0, $3e88191b87395c2e$export$8d4021544bdece00)("REMOVE_LIST_COMMAND");
function $5028a2194eda8107$export$860a6656ca8b0d29(t, e) {
    return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(t.registerCommand($5028a2194eda8107$export$c04baf1c5b96454b, ()=>($5028a2194eda8107$export$eab7c40bdcfe5ae9("number"), !0), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerCommand($5028a2194eda8107$export$1e275917a68fefc7, (t)=>{
        const { listNodeKey: e, newStart: n } = t, r = (0, $3e88191b87395c2e$export$e725f93d4d48c6d8)(e);
        return !!$5028a2194eda8107$export$28b8a3a3a286e016(r) && ("number" === r.getListType() && (r.setStart(n), $5028a2194eda8107$var$vt(r)), !0);
    }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerCommand($5028a2194eda8107$export$317e9428adaea253, ()=>($5028a2194eda8107$export$eab7c40bdcfe5ae9("bullet"), !0), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerCommand($5028a2194eda8107$export$4a3e2234826e52de, ()=>($5028a2194eda8107$export$873326a1afd5a54b(), !0), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerCommand((0, $3e88191b87395c2e$export$24f4fea65b096b4), ()=>$5028a2194eda8107$export$61183f0d4d6eaad(!!(e && e.restoreNumbering)), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), t.registerCommand((0, $3e88191b87395c2e$export$24bbba9bfa830f78), (t)=>{
        if (function() {
            const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t) || !t.isCollapsed() || 0 !== t.anchor.offset) return !1;
            const e = t.anchor.getNode(), i = (0, $3e88191b87395c2e$export$57101724ca611500)(e, $5028a2194eda8107$export$5886b0b0310d92bc);
            if (!$5028a2194eda8107$export$5886b0b0310d92bc(i)) return !1;
            const s = i.getFirstDescendant();
            if (null === s) return !1;
            if (!i.is(e) && !s.is(e)) return !1;
            const l = i.getParent();
            if (!$5028a2194eda8107$export$28b8a3a3a286e016(l) || !i.is(l.getFirstChild())) return !1;
            const c = l.getPreviousSibling();
            if (!(0, $3e88191b87395c2e$export$60aa03725ce41b1c)(c) || c.isIsolated() || !c.isKeyboardSelectable() && c.isInline()) return !1;
            const a = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)().append(...i.getChildren());
            l.insertBefore(a), i.remove(), l.isEmpty() && l.remove();
            return a.selectStart(), !0;
        }()) return t.preventDefault(), !0;
        const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e) || !e.isCollapsed()) return !1;
        const { anchor: i } = e;
        if (0 !== i.offset) return !1;
        let s = i.getNode();
        for(; !$5028a2194eda8107$export$5886b0b0310d92bc(s);){
            if (null !== s.getPreviousSibling()) return !1;
            const t = s.getParent();
            if (null === t) return !1;
            s = t;
        }
        return !(!$5028a2194eda8107$export$5886b0b0310d92bc(s) || !s.collapseAtStart(e)) && (t.preventDefault(), !0);
    }, (0, $3e88191b87395c2e$export$ad4f8f37df5d0905)), t.registerNodeTransform($5028a2194eda8107$export$b54db49906c92aaa, (t)=>{
        const e = t.getFirstChild();
        if (e) {
            if ((0, $3e88191b87395c2e$export$471953706258be2b)(e)) {
                const n = e.getStyle(), r = e.getFormat();
                t.getTextStyle() !== n && t.setTextStyle(n), t.getTextFormat() !== r && t.setTextFormat(r);
            }
        } else {
            const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && (e.style !== t.getTextStyle() || e.format !== t.getTextFormat()) && e.isCollapsed() && t.is(e.anchor.getNode()) && t.setTextStyle(e.style).setTextFormat(e.format);
        }
    }), t.registerNodeTransform((0, $3e88191b87395c2e$export$f0a25ea3087686aa), (t)=>{
        const e = t.getParent();
        if ($5028a2194eda8107$export$5886b0b0310d92bc(e) && t.is(e.getFirstChild())) {
            const n = t.getStyle(), r = t.getFormat();
            n === e.getTextStyle() && r === e.getTextFormat() || e.setTextStyle(n).setTextFormat(r);
        }
    }));
}
function $5028a2194eda8107$export$b612167896ee6416(t) {
    const e = (t)=>{
        const e = t.getParent();
        if ($5028a2194eda8107$export$28b8a3a3a286e016(t.getFirstChild()) || !$5028a2194eda8107$export$28b8a3a3a286e016(e)) return;
        const n = (0, $3e88191b87395c2e$export$57101724ca611500)(t, (t)=>$5028a2194eda8107$export$5886b0b0310d92bc(t) && $5028a2194eda8107$export$28b8a3a3a286e016(t.getParent()) && $5028a2194eda8107$export$5886b0b0310d92bc(t.getPreviousSibling()));
        if (null === n && t.getIndent() > 0) t.setIndent(0);
        else if ($5028a2194eda8107$export$5886b0b0310d92bc(n)) {
            const r = n.getPreviousSibling();
            if ($5028a2194eda8107$export$5886b0b0310d92bc(r)) {
                const n = function(t) {
                    let e = t, n = e.getFirstChild();
                    for(; $5028a2194eda8107$export$28b8a3a3a286e016(n);){
                        const t = n.getLastChild();
                        if (!$5028a2194eda8107$export$5886b0b0310d92bc(t)) break;
                        e = t, n = e.getFirstChild();
                    }
                    return e;
                }(r), i = n.getParent();
                if ($5028a2194eda8107$export$28b8a3a3a286e016(i)) {
                    const n = $5028a2194eda8107$export$65b7c3f240fd9bf2(i);
                    n + 1 < $5028a2194eda8107$export$65b7c3f240fd9bf2(e) && t.setIndent(n);
                }
            }
        }
    };
    return t.registerNodeTransform($5028a2194eda8107$export$1223bbd530a3b8af, (t)=>{
        const n = [
            t
        ];
        for(; n.length > 0;){
            const t = n.shift();
            if ($5028a2194eda8107$export$28b8a3a3a286e016(t)) {
                for (const r of t.getChildren())if ($5028a2194eda8107$export$5886b0b0310d92bc(r)) {
                    e(r);
                    const t = r.getFirstChild();
                    $5028a2194eda8107$export$28b8a3a3a286e016(t) && n.push(t);
                }
            }
        }
    });
}
const $5028a2194eda8107$export$c3197b4e47ac698b = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e, n)=>(0, $8ebc39becbfbdd8f$export$b351c03363e45c4f)(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        hasStrictIndent: !1,
        shouldPreserveNumbering: !1
    }),
    dependencies: [
        (0, $9429c8604db0efde$export$96cd3b4e2d764c8e),
        /* @__PURE__ */ (0, $3e88191b87395c2e$export$7c74af9ea11c2716)((0, $9429c8604db0efde$export$a1ca1fda83454df7), {
            rules: $5028a2194eda8107$export$7e19acffe1d9a73b
        })
    ],
    name: "@lexical/list/List",
    nodes: ()=>[
            $5028a2194eda8107$export$1223bbd530a3b8af,
            $5028a2194eda8107$export$b54db49906c92aaa
        ],
    register (t, e, n) {
        const r = n.getOutput();
        return (0, $3e88191b87395c2e$export$d64d64f541cc1835)((0, $8ebc39becbfbdd8f$export$dc573d8a6576cdb3)(()=>$5028a2194eda8107$export$860a6656ca8b0d29(t, {
                restoreNumbering: r.shouldPreserveNumbering.value
            })), (0, $8ebc39becbfbdd8f$export$dc573d8a6576cdb3)(()=>r.hasStrictIndent.value ? $5028a2194eda8107$export$b612167896ee6416(t) : void 0));
    }
}), $5028a2194eda8107$export$ed15c8417f589b79 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (t, e)=>(0, $8ebc39becbfbdd8f$export$b351c03363e45c4f)(e),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        disableTakeFocusOnClick: !1
    }),
    dependencies: [
        $5028a2194eda8107$export$c3197b4e47ac698b
    ],
    name: "@lexical/list/CheckList",
    register: (t, e, n)=>$5028a2194eda8107$export$154ef963a298a2c0(t, n.getOutput())
}), $5028a2194eda8107$export$3d9c53f878e549d7 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    dependencies: [
        $5028a2194eda8107$export$c3197b4e47ac698b
    ],
    name: "@lexical/list/Import"
});


const $424712122fe7b8db$export$41f5432d44b1213b = {
    testNode: "list",
    visitNode: function({ mdastNode: mdastNode, lexicalParent: lexicalParent, actions: actions }) {
        const listType = mdastNode.children.some((e)=>typeof e.checked === "boolean") ? "check" : mdastNode.ordered ? "number" : "bullet";
        const lexicalNode = (0, $5028a2194eda8107$export$da1d71251340f655)(listType);
        if ((0, $5028a2194eda8107$export$5886b0b0310d92bc)(lexicalParent)) {
            const dedicatedParent = (0, $5028a2194eda8107$export$e9269f07c60f7b34)();
            dedicatedParent.append(lexicalNode);
            lexicalParent.insertAfter(dedicatedParent);
        } else lexicalParent.append(lexicalNode);
        actions.visitChildren(mdastNode, lexicalNode);
    }
};



const $c2f4346591169855$export$84a3747468417e1e = {
    testNode: "listItem",
    visitNode ({ mdastNode: mdastNode, actions: actions, lexicalParent: lexicalParent }) {
        var _mdastNode_checked;
        const isChecked = lexicalParent.getListType() === "check" ? (_mdastNode_checked = mdastNode.checked) !== null && _mdastNode_checked !== void 0 ? _mdastNode_checked : false : void 0;
        actions.addAndStepInto((0, $5028a2194eda8107$export$e9269f07c60f7b34)(isChecked));
    }
};



const $90fdf6bed5941ad2$export$19b951ab12367a5d = {
    testLexicalNode: (0, $5028a2194eda8107$export$28b8a3a3a286e016),
    visitLexicalNode: ({ lexicalNode: lexicalNode, actions: actions })=>{
        actions.addAndStepInto("list", {
            ordered: lexicalNode.getListType() === "number",
            spread: false
        });
    }
};




const $e45586c913865746$export$39a1c4efb8c68220 = {
    testLexicalNode: (0, $5028a2194eda8107$export$5886b0b0310d92bc),
    visitLexicalNode: ({ lexicalNode: lexicalNode, mdastParent: mdastParent, actions: actions })=>{
        const children = lexicalNode.getChildren();
        const firstChild = children[0];
        if (children.length === 1 && (0, $5028a2194eda8107$export$28b8a3a3a286e016)(firstChild)) {
            const prevListItemNode = mdastParent.children.at(-1);
            if (!prevListItemNode) actions.visitChildren(firstChild, mdastParent);
            else actions.visitChildren(lexicalNode, prevListItemNode);
        } else {
            const parentList = lexicalNode.getParent();
            const listItem = actions.appendToParent(mdastParent, {
                type: "listItem",
                checked: parentList.getListType() === "check" ? Boolean(lexicalNode.getChecked()) : void 0,
                spread: false,
                children: []
            });
            let surroundingParagraph = null;
            for (const child of lexicalNode.getChildren())if ((0, $3e88191b87395c2e$export$471953706258be2b)(child) || (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(child) || child.isInline() && ((0, $3e88191b87395c2e$export$923a058ef54437a4)(child) || (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(child))) {
                surroundingParagraph !== null && surroundingParagraph !== void 0 ? surroundingParagraph : surroundingParagraph = actions.appendToParent(listItem, {
                    type: "paragraph",
                    children: []
                });
                actions.visit(child, surroundingParagraph);
            } else {
                surroundingParagraph = null;
                actions.visit(child, listItem);
            }
        }
    }
};




/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 


var $7fPBF = parcelRequire("7fPBF");
function $3648c503bf5dd5f5$export$48d6be11e7b2c639({ maxIndent: o, $canIndent: r }) {
    const [i] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)();
    return (0, $7fPBF.useEffect)(()=>(0, $8ebc39becbfbdd8f$export$db2dc216cb098bdc)(i, o, r), [
        i,
        o,
        r
    ]), null;
}


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 


var $7fPBF = parcelRequire("7fPBF");
function $218c735ed1ad18dd$export$109dd2135537dbe1({ disableTakeFocusOnClick: l = !1 }) {
    const [r] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)();
    return (0, $7fPBF.useEffect)(()=>(0, $5028a2194eda8107$export$154ef963a298a2c0)(r, {
            disableTakeFocusOnClick: l
        }), [
        r,
        l
    ]), null;
}


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 



var $7fPBF = parcelRequire("7fPBF");
function $7c62a038e3e65bc4$export$a4938590c692385d({ hasStrictIndent: l = !1, shouldPreserveNumbering: m = !1 }) {
    const [c] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)();
    return (0, $7fPBF.useEffect)(()=>{
        if (!c.hasNodes([
            (0, $5028a2194eda8107$export$1223bbd530a3b8af),
            (0, $5028a2194eda8107$export$b54db49906c92aaa)
        ])) throw new Error("ListPlugin: ListNode and/or ListItemNode not registered on editor");
    }, [
        c
    ]), (0, $7fPBF.useEffect)(()=>(0, $3e88191b87395c2e$export$d64d64f541cc1835)((0, $5028a2194eda8107$export$860a6656ca8b0d29)(c, {
            restoreNumbering: m
        }), l ? (0, $5028a2194eda8107$export$b612167896ee6416)(c) : ()=>{}), [
        c,
        l,
        m
    ]), function(e) {
        (0, $7fPBF.useEffect)(()=>(0, $5028a2194eda8107$export$860a6656ca8b0d29)(e), [
            e
        ]);
    }(c), null;
}



/**
 * @import {Extension, State, TokenizeContext, Tokenizer} from 'micromark-util-types'
 */ 

const $783b238101f8100d$var$tasklistCheck = {
    name: 'tasklistCheck',
    tokenize: $783b238101f8100d$var$tokenizeTasklistCheck
};
function $783b238101f8100d$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $783b238101f8100d$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $783b238101f8100d$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter('taskListCheck');
        effects.enter('taskListCheckMarker');
        effects.consume(code);
        effects.exit('taskListCheckMarker');
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $9a96cd0c036af4eb$export$a30284361b3814b7)(code)) {
            effects.enter('taskListCheckValueUnchecked');
            effects.consume(code);
            effects.exit('taskListCheckValueUnchecked');
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter('taskListCheckValueChecked');
            effects.consume(code);
            effects.exit('taskListCheckValueChecked');
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter('taskListCheckMarker');
            effects.consume(code);
            effects.exit('taskListCheckMarker');
            effects.exit('taskListCheck');
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $9a96cd0c036af4eb$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $9a96cd0c036af4eb$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $783b238101f8100d$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $783b238101f8100d$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $a27bcbb6afb3eadb$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 


function $d3a60ff58d98f77f$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $d3a60ff58d98f77f$var$exitCheck,
            taskListCheckValueUnchecked: $d3a60ff58d98f77f$var$exitCheck,
            paragraph: $d3a60ff58d98f77f$var$exitParagraphWithTaskListItem
        }
    };
}
function $d3a60ff58d98f77f$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: '-',
                after: '[:|-]'
            }
        ],
        handlers: {
            listItem: $d3a60ff58d98f77f$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d3a60ff58d98f77f$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'listItem');
    node.checked = token.type === 'taskListCheckValueChecked';
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $d3a60ff58d98f77f$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === 'listItem' && typeof parent.checked === 'boolean') {
        const node = this.stack[this.stack.length - 1];
        (0, $5f7e7f29fdd0c06b$export$dcb8b3f0e2de7e49)(node.type === 'paragraph');
        const head = node.children[0];
        if (head && head.type === 'text') {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === 'paragraph') {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === 'number') {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $d3a60ff58d98f77f$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === 'boolean' && head && head.type === 'paragraph';
    const checkbox = '[' + (node.checked ? 'x' : ' ') + '] ';
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $da19da82921559d2$export$8f34ce051745d39e).listItem(node, parent, state, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, info, tracker.current()));
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}




const $1f3afc91d5cda09c$var$ListTypeCommandMap = /* @__PURE__ */ new Map([
    [
        "number",
        (0, $5028a2194eda8107$export$c04baf1c5b96454b)
    ],
    [
        "bullet",
        (0, $5028a2194eda8107$export$317e9428adaea253)
    ],
    [
        "check",
        (0, $5028a2194eda8107$export$8cbe11ae5f0bb2)
    ],
    [
        "",
        (0, $5028a2194eda8107$export$4a3e2234826e52de)
    ]
]);
const $1f3afc91d5cda09c$export$17a124f4373b710f = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)("", (r)=>{
    r.sub(r.pipe((0, $5a7e051e41645429$export$dc45e04d1b3012d9), (0, $0a163704d09ac3e9$export$d449030e5c10edf7)((0, $5a7e051e41645429$export$e02bd6a7b04ae431))), ([selection, theEditor])=>{
        if (!selection || !theEditor) return;
        const anchorNode = selection.anchor.getNode();
        let element = anchorNode.getKey() === "root" ? anchorNode : (0, $3e88191b87395c2e$export$57101724ca611500)(anchorNode, (e)=>{
            const parent = e.getParent();
            return parent !== null && (0, $3e88191b87395c2e$export$6f851a24c61146af)(parent);
        });
        element !== null && element !== void 0 ? element : element = anchorNode.getTopLevelElementOrThrow();
        const elementKey = element.getKey();
        const elementDOM = theEditor.getElementByKey(elementKey);
        if (elementDOM !== null) {
            if ((0, $5028a2194eda8107$export$28b8a3a3a286e016)(element)) {
                const parentList = (0, $74849711df60ce24$export$9f980e09b7e30818)(anchorNode, (0, $5028a2194eda8107$export$1223bbd530a3b8af));
                const type = parentList ? parentList.getListType() : element.getListType();
                r.pub($1f3afc91d5cda09c$export$17a124f4373b710f, type);
            } else r.pub($1f3afc91d5cda09c$export$17a124f4373b710f, "");
        }
    });
});
const $1f3afc91d5cda09c$export$b2576a000f6ee979 = (0, $0a163704d09ac3e9$export$8210dfe1863c478)((r)=>{
    r.sub(r.pipe($1f3afc91d5cda09c$export$b2576a000f6ee979, (0, $0a163704d09ac3e9$export$d449030e5c10edf7)((0, $5a7e051e41645429$export$e02bd6a7b04ae431))), ([listType, theEditor])=>{
        theEditor == null || theEditor.dispatchCommand($1f3afc91d5cda09c$var$ListTypeCommandMap.get(listType), void 0);
    });
});
const $1f3afc91d5cda09c$export$65a8596327f336fa = (0, $180ae8514eec30ee$export$a1bf852fe7c1a323)({
    init (realm) {
        var _a;
        (_a = realm.getValue((0, $5a7e051e41645429$export$1224068c50c179e8))) == null || _a.registerCommand((0, $3e88191b87395c2e$export$2f74f6a2d927e6bd), ()=>!$1f3afc91d5cda09c$var$isIndentPermitted(7), (0, $3e88191b87395c2e$export$6afdf194f304e546));
        realm.pubIn({
            [(0, $5a7e051e41645429$export$ffc48b904d2782f7)]: "lists",
            [(0, $5a7e051e41645429$export$e37abcf8e1dbb715)]: (0, $d3a60ff58d98f77f$export$a427a608608b215f)(),
            [(0, $5a7e051e41645429$export$e8901c15ed1d713c)]: (0, $783b238101f8100d$export$2912e8b2802475ff)(),
            [(0, $5a7e051e41645429$export$bab06f5ebfbf5c23)]: [
                (0, $424712122fe7b8db$export$41f5432d44b1213b),
                (0, $c2f4346591169855$export$84a3747468417e1e)
            ],
            [(0, $5a7e051e41645429$export$7544518b8e31b27e)]: [
                (0, $5028a2194eda8107$export$b54db49906c92aaa),
                (0, $5028a2194eda8107$export$1223bbd530a3b8af)
            ],
            [(0, $5a7e051e41645429$export$4c7dc64aa0c7faf)]: [
                (0, $90fdf6bed5941ad2$export$19b951ab12367a5d),
                (0, $e45586c913865746$export$39a1c4efb8c68220)
            ],
            [(0, $5a7e051e41645429$export$f47abfccac67a6f3)]: (0, $d3a60ff58d98f77f$export$9975722e7e834b78)(),
            [(0, $5a7e051e41645429$export$d120e029a7b56e15)]: [
                (0, $3648c503bf5dd5f5$export$48d6be11e7b2c639),
                (0, $7c62a038e3e65bc4$export$a4938590c692385d),
                (0, $218c735ed1ad18dd$export$109dd2135537dbe1)
            ],
            [(0, $5a7e051e41645429$export$16cecaa0e6290978)]: [
                (0, $3648c503bf5dd5f5$export$48d6be11e7b2c639),
                (0, $7c62a038e3e65bc4$export$a4938590c692385d),
                (0, $218c735ed1ad18dd$export$109dd2135537dbe1)
            ]
        });
    }
});
function $1f3afc91d5cda09c$var$getElementNodesInSelection(selection) {
    const nodesInSelection = selection.getNodes();
    if (nodesInSelection.length === 0) return /* @__PURE__ */ new Set([
        selection.anchor.getNode().getParentOrThrow(),
        selection.focus.getNode().getParentOrThrow()
    ]);
    return new Set(nodesInSelection.map((n)=>(0, $3e88191b87395c2e$export$923a058ef54437a4)(n) ? n : n.getParentOrThrow()));
}
function $1f3afc91d5cda09c$var$isIndentPermitted(maxDepth) {
    const selection = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(selection)) return false;
    const elementNodesInSelection = $1f3afc91d5cda09c$var$getElementNodesInSelection(selection);
    let totalDepth = 0;
    for (const elementNode of elementNodesInSelection){
        if ((0, $5028a2194eda8107$export$28b8a3a3a286e016)(elementNode)) totalDepth = Math.max((0, $5028a2194eda8107$export$65b7c3f240fd9bf2)(elementNode) + 1, totalDepth);
        else if ((0, $5028a2194eda8107$export$5886b0b0310d92bc)(elementNode)) {
            const parent = elementNode.getParent();
            if ((parent == null ? void 0 : parent.getChildren().length) === 1) {
                const grandParentListItem = parent.getParent();
                if ((0, $5028a2194eda8107$export$5886b0b0310d92bc)(grandParentListItem) && grandParentListItem.getChildren().length === 1) return false;
            }
            if (!(0, $5028a2194eda8107$export$28b8a3a3a286e016)(parent)) throw new Error("ListMaxIndentLevelPlugin: A ListItemNode must have a ListNode for a parent.");
            totalDepth = Math.max((0, $5028a2194eda8107$export$65b7c3f240fd9bf2)(parent) + 1, totalDepth);
        }
    }
    return totalDepth <= maxDepth;
}


var $7fPBF = parcelRequire("7fPBF");




const $afa035ce1805b62c$var$ICON_NAME_MAP = {
    bullet: "format_list_bulleted",
    number: "format_list_numbered",
    check: "format_list_checked"
};
const $afa035ce1805b62c$export$83932be8f7500da3 = ({ options: options = [
    "bullet",
    "number",
    "check"
] })=>{
    const [currentListType, iconComponentFor, inTable] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $1f3afc91d5cda09c$export$17a124f4373b710f), (0, $5a7e051e41645429$export$4fd464b2b09e1c4d), (0, $5a7e051e41645429$export$ff9202ce34428c67));
    const applyListType = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $1f3afc91d5cda09c$export$b2576a000f6ee979));
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    const LIST_TITLE_MAP = {
        bullet: t("toolbar.bulletedList", "Bulleted list"),
        number: t("toolbar.numberedList", "Numbered list"),
        check: t("toolbar.checkList", "Check list")
    };
    const items = options.map((type)=>({
            value: type,
            title: LIST_TITLE_MAP[type],
            contents: iconComponentFor($afa035ce1805b62c$var$ICON_NAME_MAP[type])
        }));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5f22da7309bc91a3$export$cf568d00ccf58bd3), {
        value: currentListType || "",
        items: items,
        onChange: applyListType,
        disabled: inTable
    });
};




var $7fPBF = parcelRequire("7fPBF");
/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 






/*@__INLINE__*/ function $9f8013616f75aff2$var$se(e, ...t) {
    const n = new URL("https://lexical.dev/docs/error"), r = new URLSearchParams;
    r.append("code", e);
    for (const e of t)r.append("v", e);
    throw n.search = r.toString(), Error(`Minified Lexical error #${e}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function $9f8013616f75aff2$var$le(e, t) {
    let n = e;
    for(let r = (0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(e, t); r && ($9f8013616f75aff2$export$c16daaa751800618(r.origin) || (0, $3e88191b87395c2e$export$ac9141efa5fb7932)(r.origin)); r = r.getAdjacentCaret())n = r.origin;
    return n;
}
function $9f8013616f75aff2$export$5da783cd7fb41de3(e) {
    return $9f8013616f75aff2$var$le(e, "previous");
}
function $9f8013616f75aff2$export$6ad1e5cd85682cce(e) {
    return $9f8013616f75aff2$var$le(e, "next");
}
function $9f8013616f75aff2$export$da46c3bd478593ec(e) {
    const t = $9f8013616f75aff2$export$5da783cd7fb41de3(e), n = $9f8013616f75aff2$export$6ad1e5cd85682cce(e);
    let r = t;
    for(; null !== r;){
        if ($9f8013616f75aff2$export$c16daaa751800618(r)) {
            const e = (0, $3e88191b87395c2e$export$fab72c0039936348)(r.getTextContent());
            if (null !== e) return e;
        }
        if (r === n) break;
        r = r.getNextSibling();
    }
    const i = t.getParent();
    if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(i)) {
        const e = i.getDirection();
        if ("ltr" === e || "rtl" === e) return e;
    }
    return null;
}
function $9f8013616f75aff2$export$f439b24e3c3c6400(e, t) {
    let n = null, r = null, i = e, o = t, s = e.getTextContent();
    for(;;){
        if (0 === o) {
            const e = i.getPreviousSibling();
            if (null === e) {
                i = null;
                break;
            }
            if ($9f8013616f75aff2$export$c16daaa751800618(e) || (0, $3e88191b87395c2e$export$ac9141efa5fb7932)(e) || (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(e) || $9f8013616f75aff2$var$se(167), i = e, (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(i)) {
                n = {
                    node: i,
                    offset: 1
                };
                break;
            }
            o = Math.max(0, i.getTextContentSize() - 1), s = i.getTextContent();
        } else o--;
        const e = s[o];
        $9f8013616f75aff2$export$c16daaa751800618(i) && " " !== e && (r = {
            node: i,
            offset: o
        });
    }
    if (null !== r) return r;
    let l = null;
    if (t < e.getTextContentSize()) $9f8013616f75aff2$export$c16daaa751800618(e) && (l = e.getTextContent()[t]);
    else {
        const t = e.getNextSibling();
        $9f8013616f75aff2$export$c16daaa751800618(t) && (l = t.getTextContent()[0]);
    }
    if (null !== l && " " !== l) return n;
    {
        const r = function(e, t) {
            let n = e, r = t, i = e.getTextContent(), o = e.getTextContentSize();
            for(;;){
                if (!$9f8013616f75aff2$export$c16daaa751800618(n) || r === o) {
                    if (n = n.getNextSibling(), null === n || (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(n)) return null;
                    $9f8013616f75aff2$export$c16daaa751800618(n) && (r = 0, i = n.getTextContent(), o = n.getTextContentSize());
                }
                if ($9f8013616f75aff2$export$c16daaa751800618(n)) {
                    if (" " !== i[r]) return {
                        node: n,
                        offset: r
                    };
                    r++;
                }
            }
        }(e, t);
        return null !== r ? r : n;
    }
}
function $9f8013616f75aff2$export$7cf00c115ea80169(e) {
    const t = $9f8013616f75aff2$export$6ad1e5cd85682cce(e);
    return (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(t) && $9f8013616f75aff2$var$se(168), t;
}
function $9f8013616f75aff2$export$c6b658d9f18b2200(e) {
    const t = [];
    return (0, $3e88191b87395c2e$export$31e7aa1b3b383742)(e, {
        linebreak: ()=>t.push((0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)()),
        tab: ()=>t.push((0, $3e88191b87395c2e$export$5bde9d58a1da0796)()),
        text: (e)=>t.push($9f8013616f75aff2$export$76abb72d402c4401(e))
    }), t;
}
function $9f8013616f75aff2$export$dff3118fee3b2840(e, t, n) {
    if (!Number.isInteger(t) || t <= 0) return !1;
    const r = e.getTextContent(), i = /^ +/.exec(r);
    if (!i) return !1;
    const o = Math.min(t, i[0].length), s = e.getKey(), l = n.anchor.key === s && "text" === n.anchor.type ? n.anchor.offset : null, u = n.focus.key === s && "text" === n.focus.type ? n.focus.offset : null;
    return e.spliceText(0, o, ""), null !== l && n.anchor.set(s, Math.max(0, l - o), "text"), null !== u && n.focus.set(s, Math.max(0, u - o), "text"), !0;
}
const $9f8013616f75aff2$export$d3b12be75fbd8400 = "javascript", $9f8013616f75aff2$export$b02f3f81108525d0 = ()=>$9f8013616f75aff2$export$d3b12be75fbd8400;
function $9f8013616f75aff2$var$xe(e, t) {
    for (const n of e.childNodes){
        if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(n) && n.tagName === t) return !0;
        if ($9f8013616f75aff2$var$xe(n, t)) return !0;
    }
    return !1;
}
const $9f8013616f75aff2$var$_e = "data-language", $9f8013616f75aff2$var$Se = "data-highlight-language", $9f8013616f75aff2$var$ye = "data-theme", $9f8013616f75aff2$var$be = ()=>{};
class $9f8013616f75aff2$export$347eb46a3090e941 extends (0, $3e88191b87395c2e$export$dc064fe9e59310fd) {
    static getType() {
        return "code";
    }
    static clone(e) {
        return new $9f8013616f75aff2$export$347eb46a3090e941(e.__language, e.__key);
    }
    afterCloneFrom(e) {
        super.afterCloneFrom(e), this.__language = e.__language, this.__theme = e.__theme, this.__isSyntaxHighlightSupported = e.__isSyntaxHighlightSupported;
    }
    createDOM(e) {
        const t = (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("code");
        (0, $3e88191b87395c2e$export$71781797876b07d6)(t, e.theme.code), t.setAttribute("spellcheck", "false");
        const n = this.getLanguage();
        n && (t.setAttribute($9f8013616f75aff2$var$_e, n), this.getIsSyntaxHighlightSupported() && t.setAttribute($9f8013616f75aff2$var$Se, n));
        const r = this.getTheme();
        r && t.setAttribute($9f8013616f75aff2$var$ye, r);
        const i = this.getStyle();
        return i && (0, $3e88191b87395c2e$export$742e98a31b68d917)(t.style, i), t;
    }
    updateDOM(e, t, n) {
        const r = this.__language, i = e.__language;
        r ? r !== i && t.setAttribute($9f8013616f75aff2$var$_e, r) : i && t.removeAttribute($9f8013616f75aff2$var$_e);
        const o = this.__isSyntaxHighlightSupported;
        e.__isSyntaxHighlightSupported && i ? o && r ? r !== i && t.setAttribute($9f8013616f75aff2$var$Se, r) : t.removeAttribute($9f8013616f75aff2$var$Se) : o && r && t.setAttribute($9f8013616f75aff2$var$Se, r);
        const s = this.__theme, l = e.__theme;
        s ? s !== l && t.setAttribute($9f8013616f75aff2$var$ye, s) : l && t.removeAttribute($9f8013616f75aff2$var$ye);
        const u = this.__style, c = e.__style;
        return u !== c && (0, $3e88191b87395c2e$export$742e98a31b68d917)(t.style, u, c), !1;
    }
    exportDOM(e) {
        const t = (0, $3e88191b87395c2e$export$db1ba3824aa1e742)().createElement("pre");
        (0, $3e88191b87395c2e$export$71781797876b07d6)(t, e._config.theme.code), t.setAttribute("spellcheck", "false");
        const n = this.getLanguage();
        n && (t.setAttribute($9f8013616f75aff2$var$_e, n), this.getIsSyntaxHighlightSupported() && t.setAttribute($9f8013616f75aff2$var$Se, n));
        const r = this.getTheme();
        r && t.setAttribute($9f8013616f75aff2$var$ye, r);
        const i = this.getStyle();
        return i && (0, $3e88191b87395c2e$export$742e98a31b68d917)(t.style, i), {
            element: t
        };
    }
    static importDOM() {
        return {
            code: (e)=>null != e.textContent && (/\r?\n/.test(e.textContent) || $9f8013616f75aff2$var$xe(e, "BR")) ? {
                    conversion: $9f8013616f75aff2$var$Te,
                    priority: 1
                } : null,
            div: ()=>({
                    conversion: $9f8013616f75aff2$var$Ae,
                    priority: 1
                }),
            pre: ()=>({
                    conversion: $9f8013616f75aff2$var$Te,
                    priority: 0
                }),
            table: (e)=>$9f8013616f75aff2$var$He(e) ? {
                    conversion: $9f8013616f75aff2$var$Oe,
                    priority: 3
                } : null,
            td: (e)=>{
                const t = e, n = t.closest("table");
                return t.classList.contains("js-file-line") || n && $9f8013616f75aff2$var$He(n) ? {
                    conversion: $9f8013616f75aff2$var$Pe,
                    priority: 3
                } : null;
            },
            tr: (e)=>{
                const t = e.closest("table");
                return t && $9f8013616f75aff2$var$He(t) ? {
                    conversion: $9f8013616f75aff2$var$Pe,
                    priority: 3
                } : null;
            }
        };
    }
    static importJSON(e) {
        return $9f8013616f75aff2$export$6a836d0ebfc33d77().updateFromJSON(e);
    }
    updateFromJSON(e) {
        return super.updateFromJSON(e).setLanguage(e.language).setTheme(e.theme);
    }
    exportJSON() {
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, super.exportJSON()), {
            language: this.getLanguage(),
            theme: this.getTheme()
        });
    }
    insertNewAfter(e, t = !0) {
        if (!(0, $8ebc39becbfbdd8f$export$1a203010713403e8)((0, $3e88191b87395c2e$export$8a7392c46faf1a3f)(), "@lexical/code")) {
            $9f8013616f75aff2$var$be();
            const t = $9f8013616f75aff2$var$De(e);
            if (t) return t;
        }
        const { anchor: n, focus: r } = e, i = (n.isBefore(r) ? n : r).getNode();
        if ((0, $3e88191b87395c2e$export$471953706258be2b)(i)) {
            let e = $9f8013616f75aff2$export$5da783cd7fb41de3(i);
            const t = [];
            for(;;)if ((0, $3e88191b87395c2e$export$ac9141efa5fb7932)(e)) t.push((0, $3e88191b87395c2e$export$5bde9d58a1da0796)()), e = e.getNextSibling();
            else {
                if (!$9f8013616f75aff2$export$c16daaa751800618(e)) break;
                {
                    let n = 0;
                    const r = e.getTextContent(), i = e.getTextContentSize();
                    for(; n < i && " " === r[n];)n++;
                    if (0 !== n && t.push($9f8013616f75aff2$export$76abb72d402c4401(" ".repeat(n))), n !== i) break;
                    e = e.getNextSibling();
                }
            }
            const r = i.splitText(n.offset)[0], o = 0 === n.offset ? 0 : 1, s = r.getIndexWithinParent() + o, l = i.getParentOrThrow(), c = [
                (0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)(),
                ...t
            ];
            l.splice(s, 0, c);
            const a = t[t.length - 1];
            a ? a.select() : 0 === n.offset ? r.selectPrevious() : r.getNextSibling().selectNext(0, 0);
        }
        if ($9f8013616f75aff2$export$b63388d30a3cbb06(i)) {
            const { offset: t } = e.anchor;
            i.splice(t, 0, [
                (0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)()
            ]), i.select(t + 1, t + 1);
        }
        return null;
    }
    canIndent() {
        return !1;
    }
    collapseAtStart() {
        const e = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
        return this.getChildren().forEach((t)=>e.append(t)), this.replace(e), !0;
    }
    setLanguage(e) {
        const t = this.getWritable();
        return t.__language = e || void 0, t;
    }
    getLanguage() {
        return this.getLatest().__language;
    }
    setIsSyntaxHighlightSupported(e) {
        const t = this.getWritable();
        return t.__isSyntaxHighlightSupported = e, t;
    }
    getIsSyntaxHighlightSupported() {
        return this.getLatest().__isSyntaxHighlightSupported;
    }
    setTheme(e) {
        const t = this.getWritable();
        return t.__theme = e || void 0, t;
    }
    getTheme() {
        return this.getLatest().__theme;
    }
    constructor(e, t){
        super(t), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__language", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__theme", void 0), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__isSyntaxHighlightSupported", void 0), this.__language = e || void 0, this.__isSyntaxHighlightSupported = !1, this.__theme = void 0;
    }
}
function $9f8013616f75aff2$export$6a836d0ebfc33d77(e, t) {
    return (0, $3e88191b87395c2e$export$dde9d6ffeb117c5e)($9f8013616f75aff2$export$347eb46a3090e941).setLanguage(e).setTheme(t);
}
function $9f8013616f75aff2$export$b63388d30a3cbb06(e) {
    return e instanceof $9f8013616f75aff2$export$347eb46a3090e941;
}
function $9f8013616f75aff2$var$Te(e) {
    return {
        node: $9f8013616f75aff2$export$6a836d0ebfc33d77(e.getAttribute($9f8013616f75aff2$var$_e))
    };
}
function $9f8013616f75aff2$var$Ae(e) {
    const t = e, n = $9f8013616f75aff2$var$we(t);
    return n || function(e) {
        let t = e.parentElement;
        for(; null !== t;){
            if ($9f8013616f75aff2$var$we(t)) return !0;
            t = t.parentElement;
        }
        return !1;
    }(t) ? {
        node: n ? $9f8013616f75aff2$export$6a836d0ebfc33d77() : null
    } : {
        node: null
    };
}
function $9f8013616f75aff2$var$Oe() {
    return {
        node: $9f8013616f75aff2$export$6a836d0ebfc33d77()
    };
}
function $9f8013616f75aff2$var$Pe() {
    return {
        node: null
    };
}
function $9f8013616f75aff2$var$we(e) {
    return null !== e.style.fontFamily.match("monospace");
}
function $9f8013616f75aff2$var$He(e) {
    return e.classList.contains("js-file-line-container");
}
function $9f8013616f75aff2$var$De(e) {
    const { anchor: t } = e;
    if (e.isCollapsed() && "element" === t.type) {
        const e = t.getNode();
        if ($9f8013616f75aff2$export$b63388d30a3cbb06(e)) {
            const n = e.getChildrenSize();
            if (n >= 2 && t.offset === n) {
                const t = e.getLastChild();
                if ((0, $3e88191b87395c2e$export$b16330e40aa25c4e)(t) && (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(t.getPreviousSibling())) {
                    const t = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
                    return e.splice(n - 2, 2, []).insertAfter(t, !1), t.select(), t;
                }
            }
        }
    }
    return null;
}
class $9f8013616f75aff2$export$bf7acfca113db137 extends (0, $3e88191b87395c2e$export$f0a25ea3087686aa) {
    static getType() {
        return "code-highlight";
    }
    static clone(e) {
        return new $9f8013616f75aff2$export$bf7acfca113db137(e.__text, e.__highlightType || void 0, e.__key);
    }
    afterCloneFrom(e) {
        super.afterCloneFrom(e), this.__highlightType = e.__highlightType;
    }
    getHighlightType() {
        return this.getLatest().__highlightType;
    }
    setHighlightType(e) {
        const t = this.getWritable();
        return t.__highlightType = e || void 0, t;
    }
    canHaveFormat() {
        return !1;
    }
    createDOM(e) {
        const t = super.createDOM(e), n = $9f8013616f75aff2$var$Be(e.theme, this.__highlightType);
        return (0, $3e88191b87395c2e$export$71781797876b07d6)(t, n), t;
    }
    updateDOM(e, t, n) {
        const r = super.updateDOM(e, t, n), i = $9f8013616f75aff2$var$Be(n.theme, e.__highlightType), o = $9f8013616f75aff2$var$Be(n.theme, this.__highlightType);
        return i !== o && (i && (0, $3e88191b87395c2e$export$b59af601940ff389)(t, i), o && (0, $3e88191b87395c2e$export$71781797876b07d6)(t, o)), r;
    }
    static importJSON(e) {
        return $9f8013616f75aff2$export$76abb72d402c4401().updateFromJSON(e);
    }
    updateFromJSON(e) {
        return super.updateFromJSON(e).setHighlightType(e.highlightType);
    }
    exportJSON() {
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, super.exportJSON()), {
            highlightType: this.getHighlightType()
        });
    }
    setFormat(e) {
        return this;
    }
    isParentRequired() {
        return !0;
    }
    createParentElementNode() {
        return $9f8013616f75aff2$export$6a836d0ebfc33d77();
    }
    constructor(e = "", t, n){
        super(e, n), (0, $919ebf39980bf8f3$export$71511d61b312f219)(this, "__highlightType", void 0), this.__highlightType = t;
    }
}
function $9f8013616f75aff2$var$Be(e, t) {
    return t && e && e.codeHighlight && e.codeHighlight[t];
}
function $9f8013616f75aff2$export$76abb72d402c4401(e = "", t) {
    return (0, $3e88191b87395c2e$export$2f5beb31df92ea57)(new $9f8013616f75aff2$export$bf7acfca113db137(e, t));
}
function $9f8013616f75aff2$export$c16daaa751800618(e) {
    return e instanceof $9f8013616f75aff2$export$bf7acfca113db137;
}
const $9f8013616f75aff2$var$$e = "data-language";
function $9f8013616f75aff2$var$Ee(e) {
    return null !== e.style.fontFamily.match("monospace");
}
function $9f8013616f75aff2$var$Me(e) {
    let t = e.parentElement;
    for(; null !== t;){
        if ($9f8013616f75aff2$var$Ee(t)) return !0;
        t = t.parentElement;
    }
    return !1;
}
const $9f8013616f75aff2$var$Je = /* @__PURE__ */ (0, $9429c8604db0efde$export$61d953550e16ba20)([
    /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
        $import: (e, t)=>e.$importChildren(t),
        match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("tr", "td"),
        name: "@lexical/code/github-code-table/unwrap"
    })
]), $9f8013616f75aff2$var$ze = /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
    $import: (e, t)=>[
            $9f8013616f75aff2$export$6a836d0ebfc33d77(t.getAttribute($9f8013616f75aff2$var$$e)).splice(0, 0, e.$importChildren(t))
        ],
    match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("pre"),
    name: "@lexical/code/pre"
}), $9f8013616f75aff2$var$Ke = /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
    $import: (e, t, n)=>{
        const r = t.textContent || "";
        return /\r?\n/.test(r) || null !== t.querySelector("br") ? [
            $9f8013616f75aff2$export$6a836d0ebfc33d77(t.getAttribute($9f8013616f75aff2$var$$e)).splice(0, 0, e.$importChildren(t))
        ] : n();
    },
    match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("code"),
    name: "@lexical/code/code-multiline"
});
function $9f8013616f75aff2$var$Ie(e) {
    if (!(0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(e)) return !1;
    const t = e.style.fontFamily, n = e.style.whiteSpace;
    return "string" == typeof t && /monospace/i.test(t) && "string" == typeof n && n.startsWith("pre");
}
function $9f8013616f75aff2$var$je(e) {
    let t = !1;
    const n = [];
    let r = "", i = !1;
    const o = ()=>{
        i && (n.push(r), r = "", i = !1);
    };
    for (const s of Array.from(e.childNodes))if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(s)) "DIV" === s.tagName ? (o(), n.push(s.textContent || ""), t = !0) : "BR" === s.tagName ? (o(), n.push(""), t = !0) : (r += s.textContent || "", i = !0);
    else if ((0, $3e88191b87395c2e$export$4295c0f0b9b754c4)(s)) {
        const e = s.textContent || "";
        e.length > 0 && (r += e, i = !0);
    }
    return o(), t ? n : null;
}
function $9f8013616f75aff2$var$Re(e) {
    for (const t of Array.from(e.children)){
        if ((0, $3e88191b87395c2e$export$1b3bfaa9684536aa)(t) && $9f8013616f75aff2$var$Ie(t)) {
            if (null !== $9f8013616f75aff2$var$je(t)) return !0;
            const e = t.nextElementSibling;
            if (e && $9f8013616f75aff2$var$Ie(e)) return !0;
            continue;
        }
        if ($9f8013616f75aff2$var$Re(t)) return !0;
    }
    return !1;
}
const $9f8013616f75aff2$var$We = /* @__PURE__ */ (0, $9429c8604db0efde$export$61d953550e16ba20)([
    /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
        $import: (e, t, n)=>{
            if (!$9f8013616f75aff2$var$Ie(t) || $9f8013616f75aff2$var$Me(t)) return n();
            const r = $9f8013616f75aff2$var$je(t);
            return null === r || 0 === r.length ? n() : [
                $9f8013616f75aff2$export$6a836d0ebfc33d77().splice(0, 0, (0, $3e88191b87395c2e$export$34f16fe1ef81eac4)(r.join("\n")))
            ];
        },
        match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("div"),
        name: "@lexical/code/vscode-wrapper"
    }),
    /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
        $import: (e, t, n)=>{
            if (!$9f8013616f75aff2$var$Ie(t) || $9f8013616f75aff2$var$Me(t)) return n();
            const r = t.previousElementSibling;
            if (r && $9f8013616f75aff2$var$Ie(r)) return [];
            const i = [];
            let o = t;
            for(; o && $9f8013616f75aff2$var$Ie(o);)i.push("BR" === o.tagName ? "" : o.textContent || ""), o = o.nextElementSibling;
            return i.length < 2 ? n() : [
                $9f8013616f75aff2$export$6a836d0ebfc33d77().splice(0, 0, (0, $3e88191b87395c2e$export$34f16fe1ef81eac4)(i.join("\n")))
            ];
        },
        match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("div", "br"),
        name: "@lexical/code/vscode-line-run"
    })
]), $9f8013616f75aff2$var$qe = /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
    $import: (e, t, n)=>$9f8013616f75aff2$var$Ee(t) ? [
            $9f8013616f75aff2$export$6a836d0ebfc33d77().splice(0, 0, e.$importChildren(t))
        ] : $9f8013616f75aff2$var$Me(t) ? e.$importChildren(t) : n(),
    match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("div"),
    name: "@lexical/code/div"
}), $9f8013616f75aff2$export$ec17c8ef000603d0 = [
    /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
        $import: (e, t)=>[
                $9f8013616f75aff2$export$6a836d0ebfc33d77().splice(0, 0, e.$importChildren(t, {
                    rules: $9f8013616f75aff2$var$Je
                }))
            ],
        match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("table").classAll("js-file-line-container"),
        name: "@lexical/code/github-code-table"
    }),
    /* @__PURE__ */ (0, $9429c8604db0efde$export$253e266dc39d6fc7)({
        $import: (e, t)=>e.$importChildren(t),
        match: (0, $9429c8604db0efde$export$e50444d1393b2d0f).tag("td").classAll("js-file-line"),
        name: "@lexical/code/github-code-cell-by-class"
    }),
    $9f8013616f75aff2$var$Ke,
    $9f8013616f75aff2$var$ze,
    $9f8013616f75aff2$var$qe
], $9f8013616f75aff2$export$6ce875857237771a = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    dependencies: [
        (0, $9429c8604db0efde$export$96cd3b4e2d764c8e),
        /* @__PURE__ */ (0, $3e88191b87395c2e$export$7c74af9ea11c2716)((0, $9429c8604db0efde$export$a1ca1fda83454df7), {
            preprocess: [
                (e, t, r)=>{
                    $9f8013616f75aff2$var$Re((0, $3e88191b87395c2e$export$47ea8b9bb8a4c4de)(e) ? e.body : e) && t.session.update((0, $9429c8604db0efde$export$3c70da50d675b4f6), (e)=>[
                            ...e,
                            $9f8013616f75aff2$var$We
                        ]), r();
                }
            ],
            rules: $9f8013616f75aff2$export$ec17c8ef000603d0
        })
    ],
    name: "@lexical/code",
    nodes: ()=>[
            $9f8013616f75aff2$export$347eb46a3090e941,
            $9f8013616f75aff2$export$bf7acfca113db137
        ],
    register: (e)=>(0, $3e88191b87395c2e$export$d64d64f541cc1835)(e.registerCommand((0, $3e88191b87395c2e$export$2cdb7cdd6fccb293), (e)=>{
            const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            return !(!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t) || !$9f8013616f75aff2$var$De(t)) && (e.preventDefault(), !0);
        }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), e.registerNodeTransform((0, $3e88191b87395c2e$export$8dbf7edd89edc19c), (e)=>{
            0 !== e.getFormat() && $9f8013616f75aff2$export$b63388d30a3cbb06(e.getParent()) && e.setFormat(0);
        }))
}), $9f8013616f75aff2$export$f4edca532aec85b4 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    dependencies: [
        $9f8013616f75aff2$export$6ce875857237771a
    ],
    name: "@lexical/code/Import"
});
function $9f8013616f75aff2$var$Qe(e) {
    if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(e)) return !1;
    const t = e.anchor.getNode(), n = $9f8013616f75aff2$export$b63388d30a3cbb06(t) ? t : t.getParent(), r = e.focus.getNode(), i = $9f8013616f75aff2$export$b63388d30a3cbb06(r) ? r : r.getParent();
    return $9f8013616f75aff2$export$b63388d30a3cbb06(n) && n.is(i);
}
function $9f8013616f75aff2$var$Xe(e) {
    const t = e.getNodes(), n = [];
    if (1 === t.length && $9f8013616f75aff2$export$b63388d30a3cbb06(t[0])) return n;
    let r = [];
    for(let e = 0; e < t.length; e++){
        const i = t[e];
        $9f8013616f75aff2$export$c16daaa751800618(i) || (0, $3e88191b87395c2e$export$ac9141efa5fb7932)(i) || (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(i) || $9f8013616f75aff2$var$se(169), (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(i) ? r.length > 0 && (n.push(r), r = []) : r.push(i);
    }
    if (r.length > 0) {
        const t = e.isBackward() ? e.anchor : e.focus, i = (0, $3e88191b87395c2e$export$9b3f8d373c057995)(r[0].getKey(), 0, "text");
        t.is(i) || n.push(r);
    }
    return n;
}
function $9f8013616f75aff2$var$Ye(e, t) {
    const n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(n) || !$9f8013616f75aff2$var$Qe(n)) return !1;
    const r = $9f8013616f75aff2$var$Xe(n), i = r.length;
    if (0 === i && n.isCollapsed()) return e === (0, $3e88191b87395c2e$export$2f74f6a2d927e6bd) && n.insertNodes([
        (0, $3e88191b87395c2e$export$5bde9d58a1da0796)()
    ]), !0;
    if (0 === i && e === (0, $3e88191b87395c2e$export$2f74f6a2d927e6bd) && "\n" === n.getTextContent()) {
        const e = (0, $3e88191b87395c2e$export$5bde9d58a1da0796)(), t = (0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)(), r = n.isBackward() ? "previous" : "next";
        return n.insertNodes([
            e,
            t
        ]), (0, $3e88191b87395c2e$export$9fb698110f44889d)((0, $3e88191b87395c2e$export$b6aa34707ffda54a)((0, $3e88191b87395c2e$export$36f672915982afb2)((0, $3e88191b87395c2e$export$be15ddddbeea202c)(e, "next", 0), (0, $3e88191b87395c2e$export$33e015e8f2ff8536)((0, $3e88191b87395c2e$export$cdd98497d9dc1de9)(t, "next"))), r)), !0;
    }
    for(let o = 0; o < i; o++){
        const i = r[o];
        if (i.length > 0) {
            let r = i[0];
            if (0 === o && (r = $9f8013616f75aff2$export$5da783cd7fb41de3(r)), e === (0, $3e88191b87395c2e$export$2f74f6a2d927e6bd)) {
                const e = (0, $3e88191b87395c2e$export$5bde9d58a1da0796)();
                if (r.insertBefore(e), 0 === o) {
                    const t = n.isBackward() ? "focus" : "anchor", i = (0, $3e88191b87395c2e$export$9b3f8d373c057995)(r.getKey(), 0, "text");
                    n[t].is(i) && n[t].set(e.getKey(), 0, "text");
                }
            } else (0, $3e88191b87395c2e$export$ac9141efa5fb7932)(r) ? r.remove() : void 0 !== t && $9f8013616f75aff2$export$c16daaa751800618(r) && $9f8013616f75aff2$export$dff3118fee3b2840(r, t, n);
        }
    }
    return !0;
}
function $9f8013616f75aff2$var$Ze(e, t) {
    const n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(n)) return !1;
    const { anchor: r, focus: i } = n, o = r.offset, s = i.offset, l = r.getNode(), a = i.getNode(), g = e === (0, $3e88191b87395c2e$export$7833c2a33ae81d3d);
    if (!$9f8013616f75aff2$var$Qe(n) || !$9f8013616f75aff2$export$c16daaa751800618(l) && !(0, $3e88191b87395c2e$export$ac9141efa5fb7932)(l) || !$9f8013616f75aff2$export$c16daaa751800618(a) && !(0, $3e88191b87395c2e$export$ac9141efa5fb7932)(a)) return !1;
    if (!t.altKey) {
        if (n.isCollapsed()) {
            const e = l.getParentOrThrow();
            if (g && 0 === o && null === l.getPreviousSibling()) {
                if (null === e.getPreviousSibling()) return e.selectPrevious(), t.preventDefault(), !1;
            } else if (!g && o === l.getTextContentSize() && null === l.getNextSibling()) {
                if (null === e.getNextSibling()) return e.selectNext(), t.preventDefault(), !1;
            }
        }
        return !1;
    }
    let h, f;
    if (l.isBefore(a) ? (h = $9f8013616f75aff2$export$5da783cd7fb41de3(l), f = $9f8013616f75aff2$export$6ad1e5cd85682cce(a)) : (h = $9f8013616f75aff2$export$5da783cd7fb41de3(a), f = $9f8013616f75aff2$export$6ad1e5cd85682cce(l)), null == h || null == f) return !1;
    const p = h.getNodesBetween(f);
    for(let e = 0; e < p.length; e++){
        const t = p[e];
        if (!$9f8013616f75aff2$export$c16daaa751800618(t) && !(0, $3e88191b87395c2e$export$ac9141efa5fb7932)(t) && !(0, $3e88191b87395c2e$export$b16330e40aa25c4e)(t)) return !1;
    }
    t.preventDefault(), t.stopPropagation();
    const d = g ? h.getPreviousSibling() : f.getNextSibling();
    if (!(0, $3e88191b87395c2e$export$b16330e40aa25c4e)(d)) return !0;
    const m = g ? d.getPreviousSibling() : d.getNextSibling();
    if (null == m) return !0;
    const x = $9f8013616f75aff2$export$c16daaa751800618(m) || (0, $3e88191b87395c2e$export$ac9141efa5fb7932)(m) || (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(m) ? g ? $9f8013616f75aff2$export$5da783cd7fb41de3(m) : $9f8013616f75aff2$export$6ad1e5cd85682cce(m) : null;
    let _ = null != x ? x : m;
    return d.remove(), p.forEach((e)=>e.remove()), e === (0, $3e88191b87395c2e$export$7833c2a33ae81d3d) ? (p.forEach((e)=>_.insertBefore(e)), _.insertBefore(d)) : (_.insertAfter(d), _ = d, p.forEach((e)=>{
        _.insertAfter(e), _ = e;
    })), n.setTextNodeRange(l, o, a, s), !0;
}
function $9f8013616f75aff2$var$et(e, t) {
    const n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
    if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(n)) return !1;
    const { anchor: r, focus: i } = n, o = r.getNode(), s = i.getNode(), l = e === (0, $3e88191b87395c2e$export$dc117ee4d661295a);
    if (!$9f8013616f75aff2$var$Qe(n) || !$9f8013616f75aff2$export$c16daaa751800618(o) && !(0, $3e88191b87395c2e$export$ac9141efa5fb7932)(o) || !$9f8013616f75aff2$export$c16daaa751800618(s) && !(0, $3e88191b87395c2e$export$ac9141efa5fb7932)(s)) return !1;
    const a = s, g = "rtl" === $9f8013616f75aff2$export$da46c3bd478593ec(a) ? !l : l, h = r.key, f = r.offset, p = r.type;
    if (g) {
        const e = $9f8013616f75aff2$export$f439b24e3c3c6400(a, i.offset);
        if (null !== e) {
            const { node: t, offset: r } = e;
            (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(t) ? t.selectNext(0, 0) : n.setTextNodeRange(t, r, t, r);
        } else a.getParentOrThrow().selectStart();
    } else $9f8013616f75aff2$export$7cf00c115ea80169(a).select();
    return t.shiftKey && n.anchor.set(h, f, p), t.preventDefault(), t.stopPropagation(), !0;
}
function $9f8013616f75aff2$export$b097189b82711236(e, t, n) {
    return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(...n ? [
        e.registerCommand((0, $3e88191b87395c2e$export$baa60daa2ca402b3), (e)=>!e.altKey && (0, $74849711df60ce24$export$6e6e076922000e47)($9f8013616f75aff2$export$b63388d30a3cbb06, e), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)),
        e.registerCommand((0, $3e88191b87395c2e$export$217ec2281ac1c53b), (e)=>(0, $74849711df60ce24$export$6e6e076922000e47)($9f8013616f75aff2$export$b63388d30a3cbb06, e), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)),
        e.registerCommand((0, $3e88191b87395c2e$export$7833c2a33ae81d3d), (e)=>!e.altKey && (0, $74849711df60ce24$export$17109e98798bb572)($9f8013616f75aff2$export$b63388d30a3cbb06, e), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)),
        e.registerCommand((0, $3e88191b87395c2e$export$7525f8f8ab44508), (e)=>(0, $74849711df60ce24$export$17109e98798bb572)($9f8013616f75aff2$export$b63388d30a3cbb06, e), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4))
    ] : [], e.registerCommand((0, $3e88191b87395c2e$export$b321bdc226ccdcde), (t)=>{
        const n = function(e) {
            const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
            if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t) || !$9f8013616f75aff2$var$Qe(t)) return null;
            const n = e ? (0, $3e88191b87395c2e$export$ecf9caa19e96e40d) : (0, $3e88191b87395c2e$export$2f74f6a2d927e6bd), r = e ? (0, $3e88191b87395c2e$export$ecf9caa19e96e40d) : (0, $3e88191b87395c2e$export$926ce4da2c89d118), i = t.anchor, o = t.focus;
            if (i.is(o)) return r;
            const s = $9f8013616f75aff2$var$Xe(t);
            if (1 !== s.length) return n;
            const l = s[0];
            let u, c;
            0 === l.length && $9f8013616f75aff2$var$se(285), t.isBackward() ? (u = o, c = i) : (u = i, c = o);
            const a = $9f8013616f75aff2$export$5da783cd7fb41de3(l[0]), g = $9f8013616f75aff2$export$6ad1e5cd85682cce(l[0]), h = (0, $3e88191b87395c2e$export$9b3f8d373c057995)(a.getKey(), 0, "text"), f = (0, $3e88191b87395c2e$export$9b3f8d373c057995)(g.getKey(), g.getTextContentSize(), "text");
            return u.isBefore(h) || f.isBefore(c) ? n : h.isBefore(u) || c.isBefore(f) ? r : n;
        }(t.shiftKey);
        return null !== n && (t.preventDefault(), e.dispatchCommand(n, void 0), !0);
    }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), e.registerCommand((0, $3e88191b87395c2e$export$926ce4da2c89d118), ()=>!!$9f8013616f75aff2$var$Qe((0, $3e88191b87395c2e$export$63a3201b3a5c7d90)()) && ((0, $3e88191b87395c2e$export$d773017360b45449)([
            (0, $3e88191b87395c2e$export$5bde9d58a1da0796)()
        ]), !0), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), e.registerCommand((0, $3e88191b87395c2e$export$2f74f6a2d927e6bd), ()=>$9f8013616f75aff2$var$Ye((0, $3e88191b87395c2e$export$2f74f6a2d927e6bd)), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), e.registerCommand((0, $3e88191b87395c2e$export$ecf9caa19e96e40d), ()=>$9f8013616f75aff2$var$Ye((0, $3e88191b87395c2e$export$ecf9caa19e96e40d), t), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), e.registerCommand((0, $3e88191b87395c2e$export$7833c2a33ae81d3d), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) return !1;
        const { anchor: n } = t, r = n.getNode();
        if (!$9f8013616f75aff2$var$Qe(t)) return !1;
        const i = r.getParent();
        return t.isCollapsed() && 0 === n.offset && null === r.getPreviousSibling() && $9f8013616f75aff2$export$b63388d30a3cbb06(i) && null === i.getPreviousSibling() ? (e.preventDefault(), !0) : $9f8013616f75aff2$var$Ze((0, $3e88191b87395c2e$export$7833c2a33ae81d3d), e);
    }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), e.registerCommand((0, $3e88191b87395c2e$export$baa60daa2ca402b3), (e)=>{
        const t = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(t)) return !1;
        const { anchor: n } = t, r = n.getNode();
        return !!$9f8013616f75aff2$var$Qe(t) && (t.isCollapsed() && n.offset === r.getTextContentSize() && null === r.getNextSibling() && $9f8013616f75aff2$export$b63388d30a3cbb06(r.getParentOrThrow()) && null === r.getParentOrThrow().getNextSibling() ? (e.preventDefault(), !0) : $9f8013616f75aff2$var$Ze((0, $3e88191b87395c2e$export$baa60daa2ca402b3), e));
    }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), e.registerCommand((0, $3e88191b87395c2e$export$dc117ee4d661295a), (e)=>$9f8013616f75aff2$var$et((0, $3e88191b87395c2e$export$dc117ee4d661295a), e), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)), e.registerCommand((0, $3e88191b87395c2e$export$fb3b2d438650aff6), (e)=>$9f8013616f75aff2$var$et((0, $3e88191b87395c2e$export$fb3b2d438650aff6), e), (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)));
}
const $9f8013616f75aff2$export$3bed16257724c3a6 = /* @__PURE__ */ (0, $3e88191b87395c2e$export$71a90bfc0b778801)({
    build: (e, t)=>(0, $8ebc39becbfbdd8f$export$b351c03363e45c4f)(t),
    config: /* @__PURE__ */ (0, $3e88191b87395c2e$export$a15b7eb5055a4ef6)({
        disabled: !1,
        escapeWithArrows: !1,
        tabSize: void 0
    }),
    dependencies: [
        $9f8013616f75aff2$export$6ce875857237771a
    ],
    name: "@lexical/code-indent",
    register: (e, t, n)=>{
        const r = n.getOutput();
        return (0, $8ebc39becbfbdd8f$export$dc573d8a6576cdb3)(()=>{
            if (!r.disabled.value) return $9f8013616f75aff2$export$b097189b82711236(e, r.tabSize.value, r.escapeWithArrows.value);
        });
    }
});





function $f14993e044630ec5$var$Q(t, e) {
    const n = {};
    for (const o of t){
        const t = e(o);
        t && (n[t] ? n[t].push(o) : n[t] = [
            o
        ]);
    }
    return n;
}
function $f14993e044630ec5$var$V(t) {
    const e = $f14993e044630ec5$var$Q(t, (t)=>t.type);
    return {
        element: e.element || [],
        multilineElement: e["multiline-element"] || [],
        textFormat: e["text-format"] || [],
        textMatch: e["text-match"] || []
    };
}
const $f14993e044630ec5$var$X = /[!-/:-@[-`{-~\s]/, $f14993e044630ec5$var$Y = /\s/, $f14993e044630ec5$var$Z = /[!"#$%&'()*+,\-./:;<=>?@[\]^_`{|}~]/, $f14993e044630ec5$var$tt = /^\s{0,3}$/;
function $f14993e044630ec5$var$et(n) {
    if (!(0, $3e88191b87395c2e$export$1fdda795300c79c6)(n)) return !1;
    const o = n.getFirstChild();
    return null == o || 1 === n.getChildrenSize() && (0, $3e88191b87395c2e$export$471953706258be2b)(o) && $f14993e044630ec5$var$tt.test(o.getTextContent());
}
function $f14993e044630ec5$var$nt(t) {
    return t.replace(/\\([!-/:-@[-`{-~])/g, "$1").replace(/&#(\d+);/g, (t, e)=>String.fromCodePoint(Number(e)));
}
const $f14993e044630ec5$var$ot = /^(\s*)(\d{1,})\.\s/, $f14993e044630ec5$var$rt = /^(\s*)[-*+]\s/, $f14993e044630ec5$var$st = /^(\s*)(?:[-*+]\s)?\s?(\[(\s|x)?\])\s/i, $f14993e044630ec5$var$it = /^(#{1,6})\s/, $f14993e044630ec5$var$lt = /^>\s/, $f14993e044630ec5$var$ct = /^([ \t]*`{3,})([\w-]+)?[ \t]?/, $f14993e044630ec5$var$ft = /^[ \t]*`{3,}$/, $f14993e044630ec5$var$at = /^[ \t]*```[^`]+(?:(?:`{1,2}|`{4,})[^`]+)*```(?:[^`]|$)/, $f14993e044630ec5$var$ut = /^(?:\|)(.+)(?:\|)\s?$/;
function $f14993e044630ec5$export$1a99ea4f9d976ca8(t) {
    if ("|" !== t[0]) return !1;
    const { length: e } = t;
    let n = 1, o = 0;
    for(; n < e;){
        let e = n;
        for(" " === t[e] && e++, ":" === t[e] && e++; "-" === t[e];)e++;
        if (":" === t[e] && e++, " " === t[e] && e++, "|" !== t[e]) break;
        o++, n = e + 1;
    }
    return o > 0 && (n === e || n === e - 1 && /\s/.test(t[n]));
}
const $f14993e044630ec5$var$gt = /^<[a-z_][\w-]*(?:\s[^<>]*)?\/?>/i, $f14993e044630ec5$var$ht = /^<\/[a-z_][\w-]*\s*>/i, $f14993e044630ec5$var$pt = (t)=>new RegExp(`(?:${t.source})$`, t.flags), $f14993e044630ec5$var$xt = /* @__PURE__ */ (0, $3e88191b87395c2e$export$e6a0daad8304de)("mdListMarker", {
    parse: (t)=>"string" == typeof t && /^[-*+]$/.test(t) ? t : "-",
    resetOnCopyNode: !0
}), $f14993e044630ec5$var$mt = /* @__PURE__ */ (0, $3e88191b87395c2e$export$e6a0daad8304de)("mdCodeFence", {
    parse: (t)=>"string" == typeof t && /^`{3,}$/.test(t) ? t : "```",
    resetOnCopyNode: !0
}), $f14993e044630ec5$var$Ct = /* @__PURE__ */ (0, $3e88191b87395c2e$export$e6a0daad8304de)("mdHardLineBreak", {
    parse: (t)=>"string" == typeof t && /^(\\| {2,})$/.test(t) ? t : "",
    resetOnCopyNode: !0
});
function $f14993e044630ec5$var$It(t) {
    if (t.endsWith("\\")) return [
        t.slice(0, -1),
        "\\"
    ];
    const e = t.match(/^(.*?\S)( {2,})$/);
    return e ? [
        e[1],
        e[2]
    ] : null;
}
function $f14993e044630ec5$var$Tt(t) {
    const n = t.getChildren(), o = n.length - 1, r = n[o];
    if (!(0, $3e88191b87395c2e$export$471953706258be2b)(r)) return null;
    const s = r.getTextContent(), i = $f14993e044630ec5$var$It(s);
    if (null !== i) {
        const [t, e] = i;
        return r.setTextContent(t), e;
    }
    return /^ {2,}$/.test(s) && function(t, e) {
        for(let n = e - 1; n >= 0; n--){
            if ((0, $3e88191b87395c2e$export$b16330e40aa25c4e)(t[n])) return !1;
            if (/\S/.test(t[n].getTextContent())) return !0;
        }
        return !1;
    }(n, o) ? (r.setTextContent(""), s) : null;
}
function $f14993e044630ec5$var$$t(t) {
    const e = (0, $3e88191b87395c2e$export$4ccaf7d0d16ab4c)(), o = $f14993e044630ec5$var$Tt(t);
    return null !== o && (0, $3e88191b87395c2e$export$401d8a6b50e0699a)(e, $f14993e044630ec5$var$Ct, o), e;
}
const $f14993e044630ec5$var$Et = (t)=>(e, n, o, r)=>{
        const s = t(o);
        s.append(...n), e.replace(s), r || s.select(0, 0);
    };
const $f14993e044630ec5$var$vt = (t)=>(e, o, r, s)=>{
        const i = e.getPreviousSibling(), l = e.getNextSibling(), c = (0, $5028a2194eda8107$export$e9269f07c60f7b34)("check" === t ? "x" === r[3] : void 0), f = r[0].trim()[0], a = "bullet" !== t && "check" !== t || f !== $f14993e044630ec5$var$xt.parse(f) ? void 0 : f;
        if ((0, $5028a2194eda8107$export$28b8a3a3a286e016)(l) && l.getListType() === t) {
            a && (0, $3e88191b87395c2e$export$401d8a6b50e0699a)(l, $f14993e044630ec5$var$xt, a);
            const o = l.getFirstChild();
            null !== o ? o.insertBefore(c) : l.append(c), "number" === t && l.setStart(Number(r[2])), e.remove();
        } else if ((0, $5028a2194eda8107$export$28b8a3a3a286e016)(i) && i.getListType() === t) a && (0, $3e88191b87395c2e$export$401d8a6b50e0699a)(i, $f14993e044630ec5$var$xt, a), i.append(c), e.remove();
        else {
            const o = (0, $5028a2194eda8107$export$da1d71251340f655)(t, "number" === t ? Number(r[2]) : void 0);
            a && (0, $3e88191b87395c2e$export$401d8a6b50e0699a)(o, $f14993e044630ec5$var$xt, a), o.append(c), e.replace(o);
        }
        c.append(...o), s || c.select(0, 0);
        const u = function(t) {
            const e = t.match(/\t/g), n = t.match(/ /g);
            let o = 0;
            return e && (o += e.length), n && (o += Math.floor(n.length / 4)), o;
        }(r[1]);
        u && c.setIndent(u);
    }, $f14993e044630ec5$var$yt = (t, e, n, o)=>{
    const s = [], i = t.getChildren();
    let l = 0;
    for (const c of i)if ((0, $5028a2194eda8107$export$5886b0b0310d92bc)(c)) {
        if (1 === c.getChildrenSize()) {
            const t = c.getFirstChild();
            if ((0, $5028a2194eda8107$export$28b8a3a3a286e016)(t)) {
                const r = $f14993e044630ec5$var$yt(t, e, n + 1, o);
                r && s.push(r);
                continue;
            }
        }
        if (o && !c.getChildren().some((t)=>t.isSelected(o))) continue;
        const i = " ".repeat(4 * n), f = t.getListType(), a = (0, $3e88191b87395c2e$export$5f6d848b3f2eebb0)(t, $f14993e044630ec5$var$xt), u = "number" === f ? `${t.getStart() + l}. ` : "check" === f ? `${a} [${c.getChecked() ? "x" : " "}] ` : a + " ";
        let d = e(c);
        "number" !== f && (d = d.replace(/^(\s{0,3}\d+)(\.\s)/, "$1\\$2")), s.push(i + u + d), l++;
    }
    return s.join("\n");
}, $f14993e044630ec5$export$eef1738e402a65e6 = {
    dependencies: [
        (0, $cc8bb3cdc37e8788$export$90fecd23277fcde2)
    ],
    export: (t, e)=>{
        if (!(0, $cc8bb3cdc37e8788$export$78b6c84a5d5b8b31)(t)) return null;
        const n = Number(t.getTag().slice(1));
        return "#".repeat(n) + " " + e(t);
    },
    regExp: $f14993e044630ec5$var$it,
    replace: $f14993e044630ec5$var$Et((t)=>{
        const e = "h" + t[1].length;
        return (0, $cc8bb3cdc37e8788$export$29cdf7c75bd686cc)(e);
    }),
    triggerOnEnter: !0,
    type: "element"
}, $f14993e044630ec5$export$6277ca5a40eac6d0 = {
    dependencies: [
        (0, $cc8bb3cdc37e8788$export$c64d7b2153096538)
    ],
    export: (t, e)=>{
        if (!(0, $cc8bb3cdc37e8788$export$1c183570990c020a)(t)) return null;
        const n = e(t).split("\n"), o = [];
        for (const t of n)o.push("> " + t);
        return o.join("\n");
    },
    regExp: $f14993e044630ec5$var$lt,
    replace: (t, e, n, o)=>{
        if (o) {
            const n = t.getPreviousSibling();
            if ((0, $cc8bb3cdc37e8788$export$1c183570990c020a)(n)) return n.splice(n.getChildrenSize(), 0, [
                $f14993e044630ec5$var$$t(n),
                ...e
            ]), void t.remove();
        }
        const r = (0, $cc8bb3cdc37e8788$export$b8120bbdf1338c27)();
        r.append(...e), t.replace(r), o || r.select(0, 0);
    },
    triggerOnEnter: !0,
    type: "element"
}, $f14993e044630ec5$export$ec5856072852bd7f = {
    dependencies: [
        (0, $9f8013616f75aff2$export$347eb46a3090e941)
    ],
    export: (t)=>{
        if (!(0, $9f8013616f75aff2$export$b63388d30a3cbb06)(t)) return null;
        const e = t.getTextContent();
        let n = (0, $3e88191b87395c2e$export$5f6d848b3f2eebb0)(t, $f14993e044630ec5$var$mt);
        if (e.indexOf(n) > -1) {
            const t = e.match(/`{3,}/g);
            if (t) {
                const e = Math.max(...t.map((t)=>t.length));
                n = "`".repeat(e + 1);
            }
        }
        return n + (t.getLanguage() || "") + (e ? "\n" + e : "") + "\n" + n;
    },
    handleImportAfterStartMatch: ({ lines: t, rootNode: e, startLineIndex: n, startMatch: o })=>{
        const r = o[1], s = r.trim().length, i = t[n], l = o.index + r.length, c = i.slice(l), f = new RegExp(`\`{${s},}$`);
        if (f.test(c)) {
            const t = c.match(f), r = c.slice(0, c.lastIndexOf(t[0])), s = [
                ...o
            ];
            return s[2] = "", $f14993e044630ec5$export$ec5856072852bd7f.replace(e, null, s, t, [
                r
            ], !0), [
                !0,
                n
            ];
        }
        const a = new RegExp(`^[ \\t]*\`{${s},}$`);
        for(let r = n + 1; r < t.length; r++){
            const s = t[r];
            if (a.test(s)) {
                const l = s.match(a), c = t.slice(n + 1, r), f = i.slice(o[0].length);
                return f.length > 0 && c.unshift(f), $f14993e044630ec5$export$ec5856072852bd7f.replace(e, null, o, l, c, !0), [
                    !0,
                    r
                ];
            }
        }
        const u = t.slice(n + 1), d = i.slice(o[0].length);
        return d.length > 0 && u.unshift(d), $f14993e044630ec5$export$ec5856072852bd7f.replace(e, null, o, null, u, !0), [
            !0,
            t.length - 1
        ];
    },
    regExpEnd: {
        optional: !0,
        regExp: $f14993e044630ec5$var$ft
    },
    regExpStart: $f14993e044630ec5$var$ct,
    replace: (t, e, r, s, i, l)=>{
        let c, f;
        const a = r[1] ? r[1].trim() : "```", u = r[2] || void 0;
        if (!e && i) {
            if (1 === i.length) s ? (c = (0, $9f8013616f75aff2$export$6a836d0ebfc33d77)(u), f = i[0]) : (c = (0, $9f8013616f75aff2$export$6a836d0ebfc33d77)(u), f = i[0].startsWith(" ") ? i[0].slice(1) : i[0]);
            else {
                for(c = (0, $9f8013616f75aff2$export$6a836d0ebfc33d77)(u), i.length > 0 && (0 === i[0].trim().length ? i.shift() : i[0].startsWith(" ") && (i[0] = i[0].slice(1))); i.length > 0 && !i[i.length - 1].length;)i.pop();
                f = i.join("\n");
            }
            (0, $3e88191b87395c2e$export$401d8a6b50e0699a)(c, $f14993e044630ec5$var$mt, a);
            const e = (0, $3e88191b87395c2e$export$2785f39dcdec0078)(f);
            c.append(e), t.append(c);
        } else e && $f14993e044630ec5$var$Et((t)=>(0, $9f8013616f75aff2$export$6a836d0ebfc33d77)(t ? t[2] : void 0))(t, e, r, l);
    },
    type: "multiline-element"
}, $f14993e044630ec5$export$895ae9c433e1284f = {
    dependencies: [
        (0, $5028a2194eda8107$export$1223bbd530a3b8af),
        (0, $5028a2194eda8107$export$b54db49906c92aaa)
    ],
    export: (t, e, n)=>(0, $5028a2194eda8107$export$28b8a3a3a286e016)(t) ? $f14993e044630ec5$var$yt(t, e, 0, n) : null,
    regExp: $f14993e044630ec5$var$rt,
    replace: $f14993e044630ec5$var$vt("bullet"),
    triggerOnEnter: !0,
    type: "element"
}, $f14993e044630ec5$export$a2f9cfc16e8207ab = {
    dependencies: [
        (0, $5028a2194eda8107$export$1223bbd530a3b8af),
        (0, $5028a2194eda8107$export$b54db49906c92aaa)
    ],
    export: (t, e, n)=>(0, $5028a2194eda8107$export$28b8a3a3a286e016)(t) ? $f14993e044630ec5$var$yt(t, e, 0, n) : null,
    regExp: $f14993e044630ec5$var$st,
    replace: $f14993e044630ec5$var$vt("check"),
    triggerOnEnter: !0,
    type: "element"
}, $f14993e044630ec5$export$79a56b9f7e08d0e8 = {
    dependencies: [
        (0, $5028a2194eda8107$export$1223bbd530a3b8af),
        (0, $5028a2194eda8107$export$b54db49906c92aaa)
    ],
    export: (t, e, n)=>(0, $5028a2194eda8107$export$28b8a3a3a286e016)(t) ? $f14993e044630ec5$var$yt(t, e, 0, n) : null,
    regExp: $f14993e044630ec5$var$ot,
    replace: $f14993e044630ec5$var$vt("number"),
    triggerOnEnter: !0,
    type: "element"
}, $f14993e044630ec5$export$c86cabe491b202d9 = {
    format: [
        "code"
    ],
    tag: "`",
    type: "text-format"
};
const $f14993e044630ec5$export$73f7aa85b0021907 = {
    format: [
        "highlight"
    ],
    tag: "==",
    type: "text-format"
}, $f14993e044630ec5$export$92abef516ebdb70 = {
    format: [
        "bold",
        "italic"
    ],
    tag: "***",
    type: "text-format"
}, $f14993e044630ec5$export$a86aea402f79f021 = {
    format: [
        "bold",
        "italic"
    ],
    intraword: !1,
    tag: "___",
    type: "text-format"
}, $f14993e044630ec5$export$80b6f921f6be2259 = {
    format: [
        "bold"
    ],
    tag: "**",
    type: "text-format"
}, $f14993e044630ec5$export$53c8c32bd0f4f55 = {
    format: [
        "bold"
    ],
    intraword: !1,
    tag: "__",
    type: "text-format"
}, $f14993e044630ec5$export$12bbe560bea2b47b = {
    format: [
        "strikethrough"
    ],
    tag: "~~",
    type: "text-format"
}, $f14993e044630ec5$export$d698f1b6f2632135 = {
    format: [
        "italic"
    ],
    tag: "*",
    type: "text-format"
}, $f14993e044630ec5$export$5a032254410f13aa = {
    format: [
        "italic"
    ],
    intraword: !1,
    tag: "_",
    type: "text-format"
}, $f14993e044630ec5$export$b395009ca7f092c7 = {
    dependencies: [
        (0, $1ad5ac6f16b99f6f$export$4341066b87270133)
    ],
    export: (t, e, n)=>{
        if (!(0, $1ad5ac6f16b99f6f$export$b46127abfd772033)(t) || (0, $1ad5ac6f16b99f6f$export$7fd828bfe44c7434)(t)) return null;
        const o = e(t);
        let r = t.getTitle();
        null != r && (r = r.replace(/([\\"])/g, "\\$1"));
        return r ? `[${o}](${t.getURL()} "${r}")` : `[${o}](${t.getURL()})`;
    },
    importRegExp: /(?:\[(.+?)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/,
    regExp: /(?:\[([^[\]]*(?:\[[^[\]]*\][^[\]]*)*)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
    replace: (t, e)=>{
        if ((0, $3e88191b87395c2e$export$57101724ca611500)(t, (0, $1ad5ac6f16b99f6f$export$b46127abfd772033))) return;
        const [, n, r, i] = e, l = null != r ? $f14993e044630ec5$var$nt(r) : void 0, c = null != i ? $f14993e044630ec5$var$nt(i) : void 0, f = (0, $1ad5ac6f16b99f6f$export$5ec42376570ce194)(l, {
            title: c
        }), a = n.split("[").length - 1, u = n.split("]").length - 1;
        let d = n, g = "";
        if (a < u) return;
        if (a > u) {
            const t = n.split("[");
            g = "[" + t[0], d = t.slice(1).join("[");
        }
        const h = (0, $3e88191b87395c2e$export$2785f39dcdec0078)(d);
        return h.setFormat(t.getFormat()), f.append(h), t.replace(f), g && f.insertBefore((0, $3e88191b87395c2e$export$2785f39dcdec0078)(g)), h;
    },
    trigger: ")",
    type: "text-match"
}, $f14993e044630ec5$export$fdcfce0dc6e6b7d3 = [
    $f14993e044630ec5$export$eef1738e402a65e6,
    $f14993e044630ec5$export$6277ca5a40eac6d0,
    $f14993e044630ec5$export$895ae9c433e1284f,
    $f14993e044630ec5$export$79a56b9f7e08d0e8
], $f14993e044630ec5$export$26f2ed7df1e31b2d = [
    $f14993e044630ec5$export$ec5856072852bd7f
], $f14993e044630ec5$export$7c278863b2cc10cf = [
    $f14993e044630ec5$export$c86cabe491b202d9,
    $f14993e044630ec5$export$92abef516ebdb70,
    $f14993e044630ec5$export$a86aea402f79f021,
    $f14993e044630ec5$export$80b6f921f6be2259,
    $f14993e044630ec5$export$53c8c32bd0f4f55,
    $f14993e044630ec5$export$73f7aa85b0021907,
    $f14993e044630ec5$export$d698f1b6f2632135,
    $f14993e044630ec5$export$5a032254410f13aa,
    $f14993e044630ec5$export$12bbe560bea2b47b
], $f14993e044630ec5$export$6d2fc911c5a97672 = [
    $f14993e044630ec5$export$b395009ca7f092c7
], $f14993e044630ec5$export$b75ea24683f92be6 = [
    ...$f14993e044630ec5$export$fdcfce0dc6e6b7d3,
    ...$f14993e044630ec5$export$26f2ed7df1e31b2d,
    ...$f14993e044630ec5$export$7c278863b2cc10cf,
    ...$f14993e044630ec5$export$6d2fc911c5a97672
];
function $f14993e044630ec5$var$qt(t, e = !1) {
    const n = t.split("\n");
    let o = 0;
    const r = [];
    for(let t = 0; t < n.length; t++){
        const s = n[t], i = s.trimEnd(), l = r[r.length - 1], c = t < n.length - 1 ? $f14993e044630ec5$var$It(s) : null, f = void 0 !== l && null !== $f14993e044630ec5$var$It(l);
        if ($f14993e044630ec5$var$at.test(i)) r.push(i);
        else if (0 === o) {
            {
                const t = i.match($f14993e044630ec5$var$ct);
                if (t) {
                    o = t[1].trim().length, r.push(i);
                    continue;
                }
            }
            "" === i || "" === l || !l || $f14993e044630ec5$var$it.test(l) || $f14993e044630ec5$var$it.test(i) || $f14993e044630ec5$var$lt.test(i) || $f14993e044630ec5$var$ot.test(i) || $f14993e044630ec5$var$rt.test(i) || $f14993e044630ec5$var$st.test(i) || $f14993e044630ec5$var$ut.test(i) || $f14993e044630ec5$export$1a99ea4f9d976ca8(i) || f || !e || $f14993e044630ec5$var$gt.test(i) || $f14993e044630ec5$var$ht.test(i) || $f14993e044630ec5$var$pt($f14993e044630ec5$var$ht).test(l) || $f14993e044630ec5$var$pt($f14993e044630ec5$var$gt).test(l) || $f14993e044630ec5$var$ft.test(l) ? r.push(!e && "" !== i || null !== c ? s : i) : r[r.length - 1] = l + " " + (null === c ? i : s).trimStart();
        } else {
            if ($f14993e044630ec5$var$ft.test(i) && i.trim().length >= o) {
                o = 0, r.push(i);
                continue;
            }
            r.push(s);
        }
    }
    return r.join("\n");
}
function $f14993e044630ec5$var$Gt(t, e, n, o, r, s) {
    let i = t.isSelected(e);
    for (const l of n){
        if (!l.export) continue;
        const n = l.export(t, (t)=>$f14993e044630ec5$var$Jt(t, e, o, r, s).markdown, e);
        if (null != n) {
            if (!i && (0, $3e88191b87395c2e$export$923a058ef54437a4)(t)) $f14993e044630ec5$var$Jt(t, e, o, r, s).shouldInclude && (i = !0);
            return {
                markdown: n,
                shouldInclude: i
            };
        }
    }
    if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(t)) {
        const n = $f14993e044630ec5$var$Jt(t, e, o, r, s);
        return {
            markdown: n.markdown,
            shouldInclude: i || n.shouldInclude
        };
    }
    return (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(t) ? {
        markdown: t.getTextContent(),
        shouldInclude: i
    } : {
        markdown: null,
        shouldInclude: i
    };
}
function $f14993e044630ec5$var$Jt(t, n, o, r, s, i, l) {
    const f = [], d = t.getChildren();
    let g = !1;
    i || (i = []), l || (l = []);
    t: for (const t of d){
        let d = t.isSelected(n);
        for (const e of r){
            if (!e.export) continue;
            const c = e.export(t, (t)=>$f14993e044630ec5$var$Jt(t, n, o, r, s, i, [
                    ...l,
                    ...i
                ]).markdown, (t, e)=>$f14993e044630ec5$var$Yt(t, (0, $016075a3cb2a2f02$export$56763a00ff6960e6)(n, t, "clone").getTextContent(), o, i, l, s));
            if (null != c) {
                !d && (0, $3e88191b87395c2e$export$923a058ef54437a4)(t) && t.getChildren().some((t)=>t.isSelected(n)) && t.extractWithChild(t, n, "html") && (d = !0), d && (f.push(c), g = !0);
                continue t;
            }
        }
        if ((0, $3e88191b87395c2e$export$b16330e40aa25c4e)(t)) d && (f.push($f14993e044630ec5$var$Xt(t)), g = !0);
        else if ((0, $3e88191b87395c2e$export$471953706258be2b)(t)) {
            if (d) {
                const e = (0, $016075a3cb2a2f02$export$56763a00ff6960e6)(n, t, "clone");
                f.push($f14993e044630ec5$var$Yt(t, e.getTextContent(), o, i, l, s)), g = !0;
            }
        } else if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(t)) {
            const e = $f14993e044630ec5$var$Jt(t, n, o, r, s, i, l);
            !d && e.shouldInclude && t.extractWithChild(t, n, "html") && (d = !0), (d || e.shouldInclude) && (f.push(e.markdown), g = !0);
        } else (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(t) && d && (f.push(t.getTextContent()), g = !0);
    }
    return {
        markdown: f.join(""),
        shouldInclude: g
    };
}
function $f14993e044630ec5$var$Qt(t, e, n, o, r) {
    for (const s of e){
        if (!s.export) continue;
        const e = s.export(t, (t)=>$f14993e044630ec5$var$Vt(t, n, o, void 0, void 0, r));
        if (null != e) return e;
    }
    return (0, $3e88191b87395c2e$export$923a058ef54437a4)(t) ? $f14993e044630ec5$var$Vt(t, n, o, void 0, void 0, r) : (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(t) ? t.getTextContent() : null;
}
function $f14993e044630ec5$var$Vt(t, n, o, r, s, i = !1) {
    const l = [], f = t.getChildren();
    r || (r = []), s || (s = []);
    t: for (const t of f){
        for (const e of o){
            if (!e.export) continue;
            const c = e.export(t, (t)=>$f14993e044630ec5$var$Vt(t, n, o, r, [
                    ...s,
                    ...r
                ], i), (t, e)=>$f14993e044630ec5$var$Yt(t, e, n, r, s, i));
            if (null != c) {
                l.push(c);
                continue t;
            }
        }
        (0, $3e88191b87395c2e$export$b16330e40aa25c4e)(t) ? l.push($f14993e044630ec5$var$Xt(t)) : (0, $3e88191b87395c2e$export$471953706258be2b)(t) ? l.push($f14993e044630ec5$var$Yt(t, t.getTextContent(), n, r, s, i)) : (0, $3e88191b87395c2e$export$923a058ef54437a4)(t) ? l.push($f14993e044630ec5$var$Vt(t, n, o, r, s, i)) : (0, $3e88191b87395c2e$export$60aa03725ce41b1c)(t) && l.push(t.getTextContent());
    }
    return l.join("");
}
function $f14993e044630ec5$var$Xt(t) {
    return (0, $3e88191b87395c2e$export$5f6d848b3f2eebb0)(t, $f14993e044630ec5$var$Ct) + "\n";
}
function $f14993e044630ec5$var$Yt(t, e, n, o, r, s = !1) {
    const i = t.hasFormat("code");
    let l, c, f, a, u = e;
    if (i || (u = s ? u.replace(/([*_`~])/g, "\\$1") : u.replace(/([*_`~\\])/g, "\\$1")), i) {
        const { fence: t, padded: n } = function(t) {
            const e = t.match(/`+/g), n = e ? Math.max(...e.map((t)=>t.length)) : 0;
            return {
                fence: "`".repeat(n + 1),
                padded: 0 === t.length || t.includes("`") || /^\s/.test(t) && /\s$/.test(t) ? ` ${t} ` : t
            };
        }(e);
        l = "", f = "", c = t + n + t, a = !1;
    } else {
        const t = u.match(RegExp("^(\\s*)(.*?)(\\s*)$", "s")) || [
            "",
            "",
            u,
            ""
        ];
        l = t[1], c = t[2], f = t[3], a = "" === c;
    }
    let d = "", g = "", h = "";
    const p = $f14993e044630ec5$var$Zt(t, !0), x = $f14993e044630ec5$var$Zt(t, !1), m = new Set;
    for (const e of n){
        const n = e.format[0], r = e.tag;
        "code" !== n && $f14993e044630ec5$var$ee(t, n) && !m.has(n) && (m.add(n), $f14993e044630ec5$var$ee(p, n) && o.find((t)=>t.tag === r) || (o.push({
            format: n,
            tag: r
        }), d += r));
    }
    for(let e = 0; e < o.length; e++){
        const n = $f14993e044630ec5$var$te(t, o[e].format), s = $f14993e044630ec5$var$te(x, o[e].format);
        if (n && s) continue;
        const i = [
            ...o
        ];
        for(; i.length > e;){
            const t = i.pop();
            r && t && r.find((e)=>e.tag === t.tag) || (t && "string" == typeof t.tag && (n ? s || (h += t.tag) : g += t.tag), o.pop());
        }
        break;
    }
    return a && !t.hasFormat("code") ? g + u : g + l + d + c + h + f;
}
function $f14993e044630ec5$var$Zt(t, n) {
    const o = n ? t.getPreviousSibling() : t.getNextSibling();
    return (0, $3e88191b87395c2e$export$471953706258be2b)(o) ? o : null;
}
function $f14993e044630ec5$var$te(t, n) {
    return (0, $3e88191b87395c2e$export$471953706258be2b)(t) && t.hasFormat(n);
}
function $f14993e044630ec5$var$ee(t, e) {
    return !!$f14993e044630ec5$var$te(t, e) && ("code" === e || !t || !/^\s*$/.test(t.getTextContent()));
}
function $f14993e044630ec5$var$ne(t, e) {
    const n = t.getTextContent(), o = e.transformersByTag["`"], r = [];
    let s = null;
    if (o) {
        const t = function(t) {
            const e = (e)=>{
                let n = 0;
                for(let o = e - 1; o >= 0 && "\\" === t[o]; o--)n++;
                return n % 2 == 1;
            }, n = [];
            let o = 0;
            for(; o < t.length;)if ("`" === t[o]) {
                let e = 1;
                for(; o + e < t.length && "`" === t[o + e];)e++;
                n.push({
                    index: o,
                    length: e
                }), o += e;
            } else o++;
            const r = [];
            let s = 0;
            for(; s < n.length;){
                const o = n[s];
                if (e(o.index)) {
                    s++;
                    continue;
                }
                let i = -1;
                for(let t = s + 1; t < n.length; t++)if (n[t].length === o.length) {
                    i = t;
                    break;
                }
                if (-1 === i) {
                    s++;
                    continue;
                }
                const l = n[i];
                let c = t.slice(o.index + o.length, l.index);
                c.length >= 2 && c.startsWith(" ") && c.endsWith(" ") && /[^ ]/.test(c) && (c = c.slice(1, -1)), r.push({
                    content: c,
                    endIndex: l.index + l.length,
                    startIndex: o.index
                }), s = i + 1;
            }
            return r;
        }(n);
        for (const e of t)s || (s = {
            content: e.content,
            endIndex: e.endIndex,
            startIndex: e.startIndex,
            tag: "`"
        }), r.push({
            end: e.endIndex,
            start: e.startIndex
        });
    }
    const i = function(t, e, n = []) {
        const o = [], r = new Set(Object.keys(e.transformersByTag).filter((t)=>"`" !== t[0]).map((t)=>t[0])), s = (e)=>{
            let n = 0;
            for(let o = e - 1; o >= 0 && "\\" === t[o]; o--)n++;
            return n % 2 == 1;
        }, i = (t)=>n.some((e)=>t >= e.start && t < e.end);
        let l = 0;
        for(; l < t.length;){
            const e = t[l];
            if (!r.has(e) || s(l) || i(l)) {
                l++;
                continue;
            }
            let n = 1;
            for(; l + n < t.length && t[l + n] === e;)n++;
            const c = $f14993e044630ec5$var$oe(e, t, l, n, !0), f = $f14993e044630ec5$var$oe(e, t, l, n, !1);
            (c || f) && o.push({
                active: !0,
                canClose: f,
                canOpen: c,
                char: e,
                index: l,
                length: n
            }), l += n;
        }
        return o;
    }(n, e, r), l = i.length > 0 ? function(t, e, n) {
        const o = {};
        let r = 0, s = null;
        for(; r < e.length;){
            const i = e[r];
            if (!i.active || !i.canClose || 0 === i.length) {
                r++;
                continue;
            }
            var _o_l;
            const l = `${i.char}${i.canOpen}${i.length % 3}`, c = (_o_l = o[l]) !== null && _o_l !== void 0 ? _o_l : -1;
            let f = !1;
            for(let o = r - 1; o > c; o--){
                const l = e[o];
                if (!l.active || !l.canOpen || 0 === l.length || l.char !== i.char) continue;
                if (l.canClose || i.canOpen) {
                    if ((l.length + i.length) % 3 == 0 && l.length % 3 != 0 && i.length % 3 != 0) continue;
                }
                const c = Math.min(l.length, i.length), a = Object.keys(n.transformersByTag).filter((t)=>t[0] === l.char && t.length <= c).sort((t, e)=>e.length - t.length)[0];
                if (!a) continue;
                f = !0;
                const u = a.length, d = {
                    content: t.slice(l.index + l.length, i.index),
                    endIndex: i.index + u,
                    startIndex: l.index + (l.length - u),
                    tag: a
                };
                (!s || d.startIndex < s.startIndex || d.startIndex === s.startIndex && d.endIndex > s.endIndex) && (s = d);
                for(let t = o + 1; t < r; t++)e[t].active = !1;
                l.length -= u, i.length -= u, l.active = l.length > 0, i.length > 0 ? i.index += u : (i.active = !1, r++);
                break;
            }
            f || (o[l] = r - 1, i.canOpen || (i.active = !1), r++);
        }
        return s;
    }(n, i, e) : null;
    let c = null, f = null;
    if (s && l ? l.startIndex <= s.startIndex && l.endIndex >= s.endIndex ? (c = l, f = e.transformersByTag[l.tag]) : (c = s, f = o) : s ? (c = s, f = o) : l && (c = l, f = e.transformersByTag[l.tag]), !c || !f) return null;
    const a = [
        n.slice(c.startIndex, c.endIndex),
        c.tag,
        c.content
    ];
    return a.index = c.startIndex, a.input = n, {
        endIndex: c.endIndex,
        isCodeSpan: f === o,
        match: a,
        startIndex: c.startIndex,
        transformer: f
    };
}
function $f14993e044630ec5$var$oe(t, e, n, o, r) {
    if (!$f14993e044630ec5$var$re(e, n, o, r)) return !1;
    if ("*" === t) return !0;
    if ("_" === t) {
        if (!$f14993e044630ec5$var$re(e, n, o, !r)) return !0;
        const t = r ? e[n - 1] : e[n + o];
        return void 0 !== t && $f14993e044630ec5$var$Z.test(t);
    }
    return !0;
}
function $f14993e044630ec5$var$re(t, e, n, o) {
    const r = t[e - 1], s = t[e + n], [i, l] = o ? [
        s,
        r
    ] : [
        r,
        s
    ];
    return void 0 !== i && !$f14993e044630ec5$var$Y.test(i) && (!$f14993e044630ec5$var$Z.test(i) || void 0 === l || $f14993e044630ec5$var$Y.test(l) || $f14993e044630ec5$var$Z.test(l));
}
function $f14993e044630ec5$var$se(t) {
    return (0, $3e88191b87395c2e$export$471953706258be2b)(t) && !t.hasFormat("code");
}
function $f14993e044630ec5$var$ie(t, e, n) {
    let o = $f14993e044630ec5$var$ne(t, e), r = function(t, e) {
        const n = t;
        let o, r, s, i;
        for (const t of e){
            if (!t.replace || !t.importRegExp) continue;
            const e = n.getTextContent().match(t.importRegExp);
            if (!e) continue;
            const l = e.index || 0, c = t.getEndIndex ? t.getEndIndex(n, e) : l + e[0].length;
            !1 !== c && (void 0 === o || void 0 === r || l < o && (c > r || c <= o)) && (o = l, r = c, s = t, i = e);
        }
        return void 0 === o || void 0 === r || void 0 === s || void 0 === i ? null : {
            endIndex: r,
            match: i,
            startIndex: o,
            transformer: s
        };
    }(t, n);
    if (o && r && (o.isCodeSpan ? r.startIndex <= o.startIndex && r.endIndex >= o.endIndex ? o = null : r = null : o.startIndex <= r.startIndex && o.endIndex >= r.endIndex || r.startIndex > o.endIndex ? r = null : o = null), o) {
        const r = function(t, e, n, o, r) {
            const s = t.getTextContent();
            let i, l, c;
            if (r[0] === s ? i = t : 0 === e ? [i, l] = t.splitText(n) : [c, i, l] = t.splitText(e, n), i.setTextContent(r[2]), o) for (const t of o.format)i.hasFormat(t) || i.toggleFormat(t);
            return {
                nodeAfter: l,
                nodeBefore: c,
                transformedNode: i
            };
        }(t, o.startIndex, o.endIndex, o.transformer, o.match);
        $f14993e044630ec5$var$se(r.nodeAfter) && $f14993e044630ec5$var$ie(r.nodeAfter, e, n), $f14993e044630ec5$var$se(r.nodeBefore) && $f14993e044630ec5$var$ie(r.nodeBefore, e, n), $f14993e044630ec5$var$se(r.transformedNode) && $f14993e044630ec5$var$ie(r.transformedNode, e, n);
    } else if (r) {
        const o = function(t, e, n, o, r) {
            let s, i, l;
            return 0 === e ? [s, i] = t.splitText(n) : [l, s, i] = t.splitText(e, n), o.replace ? {
                nodeAfter: i,
                nodeBefore: l,
                transformedNode: o.replace(s, r) || void 0
            } : null;
        }(t, r.startIndex, r.endIndex, r.transformer, r.match);
        if (!o) return;
        $f14993e044630ec5$var$se(o.nodeAfter) && $f14993e044630ec5$var$ie(o.nodeAfter, e, n), $f14993e044630ec5$var$se(o.nodeBefore) && $f14993e044630ec5$var$ie(o.nodeBefore, e, n), $f14993e044630ec5$var$se(o.transformedNode) && $f14993e044630ec5$var$ie(o.transformedNode, e, n);
    }
    const s = $f14993e044630ec5$var$nt(t.getTextContent());
    t.setTextContent(s);
}
function $f14993e044630ec5$var$le(t, e, n, o = !1) {
    const r = $f14993e044630ec5$var$V(n), s = function(t) {
        const e = {}, n = {}, o = [];
        for (const r of t){
            const { tag: t } = r;
            e[t] = r;
            const s = t.replace(/(\*|\^|\+)/g, "\\$1");
            o.push(s), 1 === t.length ? n[t] = "`" === t ? new RegExp("(^|[^\\\\`])(`)((?:\\\\`|[^`])+?)(`)(?!`)") : new RegExp(`(^|[^\\\\${s}])(${s})((\\\\${s})?.*?[^${s}\\s](\\\\${s})?)(${s})(?![\\\\${s}])`) : n[t] = new RegExp(`(^|[^\\\\])(${s})((\\\\${s})?.*?[^\\s](\\\\${s})?)(${s})(?!\\\\)`);
        }
        return {
            fullMatchRegExpByTag: n,
            openTagsRegExp: new RegExp(`(${o.join("|")})`, "g"),
            transformersByTag: e
        };
    }(r.textFormat), i = t.split("\n"), l = i.length;
    for(let t = 0; t < l; t++){
        const n = i[t], [l, c] = $f14993e044630ec5$var$ce(i, t, r.multilineElement, e);
        l ? t = c : $f14993e044630ec5$var$fe(n, e, r.element, s, r.textMatch, o);
    }
    const c = e.getChildren();
    for (const t of c)if (!o && $f14993e044630ec5$var$et(t) && e.getChildrenSize() > 1) t.remove();
    else if ((0, $3e88191b87395c2e$export$923a058ef54437a4)(t)) for (const e of t.getAllTextNodes())$f14993e044630ec5$var$ae(e);
}
function $f14993e044630ec5$var$ce(t, e, n, o) {
    for (const r of n){
        const { handleImportAfterStartMatch: n, regExpEnd: s, regExpStart: i, replace: l } = r, c = t[e].match(i);
        if (!c) continue;
        if (n) {
            const s = n({
                lines: t,
                rootNode: o,
                startLineIndex: e,
                startMatch: c,
                transformer: r
            });
            if (null === s) continue;
            if (s) return s;
        }
        const f = "object" == typeof s && "regExp" in s ? s.regExp : s, a = s && "object" == typeof s && "optional" in s ? s.optional : !s;
        let u = e;
        const d = t.length;
        for(; u < d;){
            const n = f ? t[u].match(f) : null;
            if (!n && (!a || a && u < d - 1)) {
                u++;
                continue;
            }
            if (n && e === u && n.index === c.index) {
                u++;
                continue;
            }
            const r = [];
            if (n && e === u) r.push(t[e].slice(c[0].length, -n[0].length));
            else for(let o = e; o <= u; o++)if (o === e) {
                const e = t[o].slice(c[0].length);
                r.push(e);
            } else if (o === u && n) {
                const e = t[o].slice(0, -n[0].length);
                r.push(e);
            } else r.push(t[o]);
            if (!1 !== l(o, null, c, n, r, !0)) return [
                !0,
                u
            ];
            break;
        }
    }
    return [
        !1,
        e
    ];
}
function $f14993e044630ec5$var$fe(e, n, r, i, l, c) {
    const f = (0, $3e88191b87395c2e$export$2785f39dcdec0078)(e), a = (0, $3e88191b87395c2e$export$7f0c05ffb7ced90d)();
    a.append(f), n.append(a);
    for (const { regExp: t, replace: n } of r){
        const o = e.match(t);
        if (o && (f.setTextContent(e.slice(o[0].length)), !1 !== n(a, [
            f
        ], o, !0))) break;
    }
    if ($f14993e044630ec5$var$ie(f, i, l), null !== a.getParent() && e.length > 0) {
        const e = a.getPreviousSibling();
        if (!c && ((0, $3e88191b87395c2e$export$1fdda795300c79c6)(e) || (0, $cc8bb3cdc37e8788$export$1c183570990c020a)(e) || (0, $5028a2194eda8107$export$28b8a3a3a286e016)(e))) {
            let t = e;
            if ((0, $5028a2194eda8107$export$28b8a3a3a286e016)(e)) {
                const n = e.getLastDescendant();
                t = null == n ? null : (0, $3e88191b87395c2e$export$57101724ca611500)(n, (0, $5028a2194eda8107$export$5886b0b0310d92bc));
            }
            null != t && t.getTextContentSize() > 0 && (t.splice(t.getChildrenSize(), 0, [
                $f14993e044630ec5$var$$t(t),
                ...a.getChildren()
            ]), a.remove());
        }
    }
}
function $f14993e044630ec5$var$ae(t) {
    const e = new Set, n = t.getTextContent();
    let o = n.indexOf("\t");
    for(; -1 !== o;)e.add(o), e.add(o + 1), o = n.indexOf("\t", o + 1);
    t.splitText(...e).forEach((t)=>{
        "\t" === t.getTextContent() && t.replace((0, $3e88191b87395c2e$export$5bde9d58a1da0796)());
    });
}
function $f14993e044630ec5$var$ue(t, ...e) {
    const n = new URL("https://lexical.dev/docs/error"), o = new URLSearchParams;
    o.append("code", t);
    for (const t of e)o.append("v", t);
    throw n.search = o.toString(), Error(`Minified Lexical error #${t}; visit ${n.toString()} for the full message or use the non-minified dev environment for full errors and additional helpful warnings.`);
}
function $f14993e044630ec5$var$de(t, e, n, o, r) {
    const s = t.getParent();
    if (!(0, $3e88191b87395c2e$export$6f851a24c61146af)(s) || t.getFirstChild() !== e) return !1;
    const i = e.getTextContent();
    if (!r && " " !== i[n - 1]) return !1;
    for (const { regExp: s, replace: l } of o){
        const o = i.match(s), c = r || o && o[0].endsWith(" ") ? n : n - 1;
        if (o && o[0].length === c) {
            const r = e.getNextSiblings(), [s, i] = e.splitText(n);
            if (!1 !== l(t, i ? [
                i,
                ...r
            ] : r, o, !1)) return s.remove(), !0;
        }
    }
    return !1;
}
function $f14993e044630ec5$var$ge(t, e, n, o, r) {
    const s = t.getParent();
    if (!(0, $3e88191b87395c2e$export$6f851a24c61146af)(s) || t.getFirstChild() !== e) return !1;
    const i = e.getTextContent();
    if (!r && " " !== i[n - 1]) return !1;
    for (const { regExpStart: s, replace: l, regExpEnd: c } of o){
        if (c && !("optional" in c) || c && "optional" in c && !c.optional) continue;
        const o = i.match(s);
        if (o) {
            const s = r || o[0].endsWith(" ") ? n : n - 1;
            if (o[0].length !== s) continue;
            const i = e.getNextSiblings(), [c, f] = e.splitText(n);
            if (!1 !== l(t, f ? [
                f,
                ...i
            ] : i, o, null, null, !1)) return c.remove(), !0;
        }
    }
    return !1;
}
function $f14993e044630ec5$var$he(t, e) {
    let n = 0;
    const o = t.getTextContent();
    for(let t = 0; t < e; t++)"`" === o[t] && n++;
    return n % 2 != 0;
}
function $f14993e044630ec5$var$pe(t, e, n) {
    const o = n.length;
    for(let r = e; r >= o; r--){
        const e = r - o;
        if ($f14993e044630ec5$var$xe(t, e, n, 0, o) && " " !== t[e + o]) return e;
    }
    return -1;
}
function $f14993e044630ec5$var$xe(t, e, n, o, r) {
    for(let s = 0; s < r; s++)if (t[e + s] !== n[o + s]) return !1;
    return !0;
}
function $f14993e044630ec5$export$80292e08d7f8bcc4(t, n = $f14993e044630ec5$export$b75ea24683f92be6) {
    const o = $f14993e044630ec5$var$V(n), r = o.element.filter((t)=>t.triggerOnEnter), s = $f14993e044630ec5$var$Q(o.textFormat, ({ tag: t })=>t[t.length - 1]), i = $f14993e044630ec5$var$Q(o.textMatch, ({ trigger: t })=>t), l = new Set([
        " "
    ]);
    for (const t of o.textFormat)l.add(t.tag.slice(-1));
    for (const t of o.textMatch)void 0 !== t.trigger && l.add(t.trigger);
    for (const e of n){
        const n = e.type;
        if ("element" === n || "text-match" === n || "multiline-element" === n) {
            const n = e.dependencies;
            for (const e of n)t.hasNode(e) || $f14993e044630ec5$var$ue(173, e.getType());
        }
    }
    const f = (t, n, r)=>!!$f14993e044630ec5$var$de(t, n, r, o.element) || !!$f14993e044630ec5$var$ge(t, n, r, o.multilineElement) || !!function(t, e, n) {
            let o = t.getTextContent();
            const r = n[o[e - 1]];
            if (null == r) return !1;
            e < o.length && (o = o.slice(0, e));
            for (const e of r){
                if (!e.replace || !e.regExp) continue;
                const n = o.match(e.regExp);
                if (null === n) continue;
                const r = n.index || 0, s = r + n[0].length;
                let i;
                return 0 === r ? [i] = t.splitText(s) : [, i] = t.splitText(r, s), i.selectNext(0, 0), e.replace(i, n), !0;
            }
            return !1;
        }(n, r, i) || !!function(t, n, o) {
            const r = t.getTextContent(), s = n - 1, i = r[s], l = o[i];
            if (!l) return !1;
            for (const n of l){
                const { tag: o } = n, l = o.length, f = s - l + 1;
                if (l > 1 && !$f14993e044630ec5$var$xe(r, f, o, 0, l)) continue;
                if (" " === r[f - 1]) continue;
                const a = r[s + 1];
                if (!1 === n.intraword && a && !$f14993e044630ec5$var$X.test(a)) continue;
                const u = t;
                let d = u, g = $f14993e044630ec5$var$pe(r, f, o), h = d;
                for(; g < 0 && (h = h.getPreviousSibling()) && !(0, $3e88191b87395c2e$export$b16330e40aa25c4e)(h);)if ((0, $3e88191b87395c2e$export$471953706258be2b)(h)) {
                    if (h.hasFormat("code")) continue;
                    const t = h.getTextContent();
                    d = h, g = $f14993e044630ec5$var$pe(t, t.length, o);
                }
                if (g < 0) continue;
                if (d === u && g + l === f) continue;
                const p = d.getTextContent();
                if (g > 0 && p[g - 1] === i) continue;
                const x = p[g - 1];
                if (!1 === n.intraword && x && !$f14993e044630ec5$var$X.test(x)) continue;
                if (!n.format.includes("code") && $f14993e044630ec5$var$he(d, g)) continue;
                const m = u.getTextContent(), T = m.slice(0, f) + m.slice(s + 1);
                u.setTextContent(T);
                const $ = d === u ? T : p;
                d.setTextContent($.slice(0, g) + $.slice(g + l));
                const E = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)(), v = (0, $3e88191b87395c2e$export$1ccc217b9831b072)();
                (0, $3e88191b87395c2e$export$2aad78c37810bca9)(v);
                const y = s - l * (d === u ? 2 : 1) + 1;
                v.anchor.set(d.__key, g, "text"), v.focus.set(u.__key, y, "text");
                for (const t of n.format)v.formatText(t, (0, $3e88191b87395c2e$export$c9e7d6eb65b13430)[t]);
                v.anchor.set(v.focus.key, v.focus.offset, v.focus.type);
                for (const t of n.format)v.hasFormat(t) && v.toggleFormat(t);
                return (0, $3e88191b87395c2e$export$181b63acea8a0224)(E) && (v.format = E.format), !0;
            }
            return !1;
        }(n, r, s);
    return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(t.registerUpdateListener(({ tags: n, dirtyLeaves: o, editorState: r, prevEditorState: s })=>{
        if (n.has((0, $3e88191b87395c2e$export$39d6d771d40857ac)) || n.has((0, $3e88191b87395c2e$export$7581001a764add86))) return;
        if (t.isComposing()) return;
        const i = n.has((0, $3e88191b87395c2e$export$ecc13538534b9f74)), c = r.read((0, $3e88191b87395c2e$export$63a3201b3a5c7d90)), a = s.read((0, $3e88191b87395c2e$export$63a3201b3a5c7d90));
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(a) || !(0, $3e88191b87395c2e$export$181b63acea8a0224)(c) || !c.isCollapsed() || c.is(a) && !i) return;
        const u = c.anchor.key, d = c.anchor.offset, g = r._nodeMap.get(u);
        if ((0, $3e88191b87395c2e$export$471953706258be2b)(g) && o.has(u) && (i || 1 === d || !(d > a.anchor.offset + 1))) {
            if (i) {
                const t = r.read(()=>g.getTextContent())[d - 1];
                if (!l.has(t)) return;
            }
            t.update(()=>{
                if (!$f14993e044630ec5$var$se(g)) return;
                const t = g.getParent();
                null === t || (0, $9f8013616f75aff2$export$b63388d30a3cbb06)(t) || f(t, g, c.anchor.offset) && (0, $3e88191b87395c2e$export$24cab2f466b76c04)((0, $3e88191b87395c2e$export$6387218b6bdcf960));
            });
        }
    }), t.registerCommand((0, $3e88191b87395c2e$export$2cdb7cdd6fccb293), (t)=>{
        if (null !== t && t.shiftKey) return !1;
        const n = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
        if (!(0, $3e88191b87395c2e$export$181b63acea8a0224)(n) || !n.isCollapsed()) return !1;
        const s = n.anchor.offset, i = n.anchor.getNode();
        if (!(0, $3e88191b87395c2e$export$471953706258be2b)(i) || !$f14993e044630ec5$var$se(i)) return !1;
        const l = i.getParent();
        if (null === l || (0, $9f8013616f75aff2$export$b63388d30a3cbb06)(l)) return !1;
        return s === i.getTextContent().length && !(!$f14993e044630ec5$var$ge(l, i, s, o.multilineElement, !0) && !$f14993e044630ec5$var$de(l, i, s, r, !0)) && (null !== t && t.preventDefault(), !0);
    }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4)));
}
function $f14993e044630ec5$export$10c71a223e81def2(t, e = $f14993e044630ec5$export$b75ea24683f92be6, n, o = !1, r = !1) {
    const s = o ? t : $f14993e044630ec5$var$qt(t, r), i = n || (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)();
    i.clear(), $f14993e044630ec5$var$le(s, i, e, o), null !== (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)() && i.selectStart();
}
function $f14993e044630ec5$export$30ddd763f1fb3229(t, e = $f14993e044630ec5$export$b75ea24683f92be6, n = !1, o = !1) {
    const r = n ? t : $f14993e044630ec5$var$qt(t, o), s = new (0, $3e88191b87395c2e$export$82a585c2442a6dd6);
    return $f14993e044630ec5$var$le(r, s, e, n), s.getChildren();
}
function $f14993e044630ec5$export$f74d9f0edf3dd243(t = $f14993e044630ec5$export$b75ea24683f92be6, e, n = !1) {
    const o = function(t, e = !1) {
        const n = $f14993e044630ec5$var$V(t), o = [
            ...n.multilineElement,
            ...n.element
        ], r = !e, s = n.textFormat.filter((t)=>1 === t.format.length).sort((t, e)=>Number(t.format.includes("code")) - Number(e.format.includes("code")));
        return (t)=>{
            const i = [], l = (t || (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)()).getChildren();
            for(let t = 0; t < l.length; t++){
                const c = l[t], f = $f14993e044630ec5$var$Qt(c, o, s, n.textMatch, e);
                null != f && i.push(r && t > 0 && !$f14993e044630ec5$var$et(c) && !$f14993e044630ec5$var$et(l[t - 1]) ? "\n".concat(f) : f);
            }
            return i.join("\n");
        };
    }(t, n);
    return o(e);
}
function $f14993e044630ec5$export$fa78de08e126d962(t = $f14993e044630ec5$export$b75ea24683f92be6, e, n = !1) {
    if (!e || (0, $3e88191b87395c2e$export$181b63acea8a0224)(e) && e.isCollapsed()) return "";
    const o = function(t, e = !1) {
        const n = $f14993e044630ec5$var$V(t), o = [
            ...n.multilineElement,
            ...n.element
        ], r = !e, s = n.textFormat.filter((t)=>1 === t.format.length).sort((t, e)=>Number(t.format.includes("code")) - Number(e.format.includes("code")));
        return (t)=>{
            const i = [], l = (0, $3e88191b87395c2e$export$8d83ea843c4eea9a)().getChildren();
            for(let c = 0; c < l.length; c++){
                const f = l[c], { shouldInclude: a, markdown: u } = $f14993e044630ec5$var$Gt(f, t, o, s, n.textMatch, e);
                a && null != u && i.push(r && c > 0 && !$f14993e044630ec5$var$et(f) && !$f14993e044630ec5$var$et(l[c - 1]) ? "\n".concat(u) : u);
            }
            return i.join("\n");
        };
    }(t, n);
    return o(e);
}


/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 



var $7fPBF = parcelRequire("7fPBF");
const $ce4684f79caee9dd$export$1c5ebb1278c6fc30 = [
    {
        dependencies: [
            (0, $8ebc39becbfbdd8f$export$e68cdf336f70c676)
        ],
        export: (e)=>(0, $8ebc39becbfbdd8f$export$dddc142b287ff132)(e) ? "***" : null,
        regExp: /^(---|\*\*\*|___)\s?$/,
        replace: (e, t, n, o)=>{
            const l = (0, $8ebc39becbfbdd8f$export$6fd365a92f1482f2)();
            o || null != e.getNextSibling() ? e.replace(l) : e.insertBefore(l), l.selectNext();
        },
        triggerOnEnter: !0,
        type: "element"
    },
    ...(0, $f14993e044630ec5$export$b75ea24683f92be6)
];
function $ce4684f79caee9dd$export$786bae3e7d1ae65({ transformers: e = $ce4684f79caee9dd$export$1c5ebb1278c6fc30 }) {
    const [r] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)();
    return (0, $7fPBF.useEffect)(()=>(0, $f14993e044630ec5$export$80292e08d7f8bcc4)(r, e), [
        r,
        e
    ]), null;
}









var $7fPBF = parcelRequire("7fPBF");


function $d8a77a50be28f6e5$export$db3d18595817dd22() {
    let subscription = (0, $0bde9de2375dfc26$export$8793edee2d425525);
    return {
        publish: ()=>{
            subscription();
        },
        subscribe: (cb)=>{
            subscription = cb;
        }
    };
}



function $00b79569002e9b37$export$4713ff64b60a34b0(descriptors, language, meta, defaultLanguage) {
    const sortedDescriptors = [
        ...descriptors
    ].sort((a, b)=>b.priority - a.priority);
    const resolvedMeta = meta !== null && meta !== void 0 ? meta : "";
    var _sortedDescriptors_find;
    return (_sortedDescriptors_find = sortedDescriptors.find((descriptor)=>descriptor.match(language !== null && language !== void 0 ? language : "", resolvedMeta))) !== null && _sortedDescriptors_find !== void 0 ? _sortedDescriptors_find : sortedDescriptors.find((descriptor)=>descriptor.match(defaultLanguage !== null && defaultLanguage !== void 0 ? defaultLanguage : "", resolvedMeta));
}


var $27322b53201ffbba$var$__defProp = Object.defineProperty;
var $27322b53201ffbba$var$__defNormalProp = (obj, key, value)=>key in obj ? $27322b53201ffbba$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $27322b53201ffbba$var$__publicField = (obj, key, value)=>$27322b53201ffbba$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class $27322b53201ffbba$export$792ac49c5d0ff3ae extends (0, $3e88191b87395c2e$export$8244b9efe04488e) {
    static getType() {
        return "codeblock";
    }
    static clone(node) {
        return new $27322b53201ffbba$export$792ac49c5d0ff3ae(node.__code, node.__language, node.__meta, node.__key);
    }
    afterCloneFrom(prevNode) {
        super.afterCloneFrom(prevNode);
        this.__code = prevNode.__code;
        this.__meta = prevNode.__meta;
        this.__language = prevNode.__language;
        this.__focusEmitter = (0, $d8a77a50be28f6e5$export$db3d18595817dd22)();
    }
    static importJSON(serializedNode) {
        const code = typeof serializedNode.code === "string" ? serializedNode.code : "";
        const language = typeof serializedNode.language === "string" ? serializedNode.language : "";
        const meta = typeof serializedNode.meta === "string" ? serializedNode.meta : "";
        return $27322b53201ffbba$export$fa7749131580a2bf({
            code: code,
            language: language,
            meta: meta
        });
    }
    static importDOM() {
        return {
            pre: ()=>{
                return {
                    conversion: $27322b53201ffbba$export$df6288fcc1db6154,
                    priority: 3
                };
            }
        };
    }
    exportJSON() {
        return {
            code: this.getCode(),
            language: this.getLanguage(),
            meta: this.getMeta(),
            type: "codeblock",
            version: 1
        };
    }
    // View
    createDOM(_config, _editor) {
        return document.createElement("div");
    }
    updateDOM() {
        return false;
    }
    getCode() {
        return this.__code;
    }
    getMeta() {
        return this.__meta;
    }
    getLanguage() {
        return this.__language;
    }
    decorate(editor) {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($27322b53201ffbba$var$CodeBlockEditorContainer, {
            parentEditor: editor,
            code: this.getCode(),
            meta: this.getMeta(),
            language: this.getLanguage(),
            codeBlockNode: this,
            nodeKey: this.getKey(),
            focusEmitter: this.__focusEmitter
        });
    }
    isInline() {
        return false;
    }
    constructor(code, language, meta, key){
        super(key);
        $27322b53201ffbba$var$__publicField(this, "__code");
        $27322b53201ffbba$var$__publicField(this, "__meta");
        $27322b53201ffbba$var$__publicField(this, "__language");
        $27322b53201ffbba$var$__publicField(this, "__focusEmitter", (0, $d8a77a50be28f6e5$export$db3d18595817dd22)());
        $27322b53201ffbba$var$__publicField(this, "setCode", (code)=>{
            if (code !== this.__code) this.getWritable().__code = code;
        });
        $27322b53201ffbba$var$__publicField(this, "setMeta", (meta)=>{
            if (meta !== this.__meta) this.getWritable().__meta = meta;
        });
        $27322b53201ffbba$var$__publicField(this, "setLanguage", (language)=>{
            if (language !== this.__language) this.getWritable().__language = language;
        });
        $27322b53201ffbba$var$__publicField(this, "select", ()=>{
            this.__focusEmitter.publish();
        });
        this.__code = code;
        this.__meta = meta;
        this.__language = language;
    }
}
const $27322b53201ffbba$var$CodeBlockEditorContext = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createContext(null);
const $27322b53201ffbba$var$CodeBlockEditorContextProvider = ({ parentEditor: parentEditor, lexicalNode: lexicalNode, children: children })=>{
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>{
        return {
            lexicalNode: lexicalNode,
            parentEditor: parentEditor,
            setCode: (code)=>{
                parentEditor.update(()=>{
                    lexicalNode.setCode(code);
                    setTimeout(()=>{
                        parentEditor.dispatchCommand((0, $5a7e051e41645429$export$6fe69bb678b4acec), void 0);
                    }, 0);
                });
            },
            setLanguage: (language)=>{
                parentEditor.update(()=>{
                    lexicalNode.setLanguage(language);
                });
            },
            setMeta: (meta)=>{
                parentEditor.update(()=>{
                    lexicalNode.setMeta(meta);
                });
            }
        };
    }, [
        lexicalNode,
        parentEditor
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($27322b53201ffbba$var$CodeBlockEditorContext.Provider, {
        value: contextValue
    }, children);
};
function $27322b53201ffbba$export$67e28c3089731a95() {
    const context = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useContext($27322b53201ffbba$var$CodeBlockEditorContext);
    if (!context) throw new Error("useCodeBlockEditor must be used within a CodeBlockEditor");
    return context;
}
const $27322b53201ffbba$var$CodeBlockEditorContainer = (props)=>{
    const codeBlockEditorDescriptors = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$13b405bc957e5ec9));
    const defaultCodeBlockLanguage = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$f738aae4ba2dfef1));
    const descriptor = (0, $00b79569002e9b37$export$4713ff64b60a34b0)(codeBlockEditorDescriptors, props.language, props.meta, defaultCodeBlockLanguage);
    if (!descriptor) throw new Error(`No CodeBlockEditor registered for language=${props.language} meta=${props.meta}`);
    const Editor = descriptor.Editor;
    const { codeBlockNode: _, parentEditor: __ } = props, restProps = (0, $8901fc92b5563702$export$71511d61b312f219)(props, [
        "codeBlockNode",
        "parentEditor"
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($27322b53201ffbba$var$CodeBlockEditorContextProvider, {
        parentEditor: props.parentEditor,
        lexicalNode: props.codeBlockNode
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Editor, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, restProps)));
};
function $27322b53201ffbba$export$fa7749131580a2bf(options) {
    const { code: code = "", language: language = "", meta: meta = "" } = options;
    return new $27322b53201ffbba$export$792ac49c5d0ff3ae(code, language, meta);
}
function $27322b53201ffbba$export$3dfe83392aad92dc(node) {
    return node instanceof $27322b53201ffbba$export$792ac49c5d0ff3ae;
}
function $27322b53201ffbba$export$df6288fcc1db6154(element) {
    const preElement = element;
    const code = preElement.textContent;
    var _element_getAttribute;
    const classAttribute = (_element_getAttribute = element.getAttribute("class")) !== null && _element_getAttribute !== void 0 ? _element_getAttribute : "";
    var _element_getAttribute1;
    const dataLanguageAttribute = (_element_getAttribute1 = element.getAttribute("data-language")) !== null && _element_getAttribute1 !== void 0 ? _element_getAttribute1 : "";
    const languageMatch = /language-(\w+)/.exec(classAttribute);
    const language = languageMatch ? languageMatch[1] : dataLanguageAttribute;
    var _preElement_getAttribute;
    const meta = (_preElement_getAttribute = preElement.getAttribute("data-meta")) !== null && _preElement_getAttribute !== void 0 ? _preElement_getAttribute : "";
    return {
        node: $27322b53201ffbba$export$fa7749131580a2bf({
            code: code,
            language: language,
            meta: meta
        })
    };
}




/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 

/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 


var $7fPBF = parcelRequire("7fPBF");
function $8665ebb90a54c21f$var$s(e, t) {
    return e.read("latest", ()=>{
        const e = (0, $3e88191b87395c2e$export$e725f93d4d48c6d8)(t);
        return null !== e && e.isSelected();
    });
}
function $8665ebb90a54c21f$export$d11cce486b21a5b5(c) {
    const [u] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)(), [d, p] = (0, $7fPBF.useState)(()=>$8665ebb90a54c21f$var$s(u, c));
    (0, $7fPBF.useEffect)(()=>{
        let e = !0;
        const t = u.registerUpdateListener(()=>{
            e && p($8665ebb90a54c21f$var$s(u, c));
        });
        return ()=>{
            e = !1, t();
        };
    }, [
        u,
        c
    ]);
    return [
        d,
        (0, $7fPBF.useCallback)((e)=>{
            u.update(()=>{
                let l = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                (0, $3e88191b87395c2e$export$7257e4181651a7c3)(l) || (l = (0, $3e88191b87395c2e$export$f8cd0c3f35d1a61c)(), (0, $3e88191b87395c2e$export$2aad78c37810bca9)(l)), (0, $3e88191b87395c2e$export$7257e4181651a7c3)(l) && (e ? l.add(c) : l.delete(c));
            });
        }, [
            u,
            c
        ]),
        (0, $7fPBF.useCallback)(()=>{
            u.update(()=>{
                const e = (0, $3e88191b87395c2e$export$63a3201b3a5c7d90)();
                (0, $3e88191b87395c2e$export$7257e4181651a7c3)(e) && e.clear();
            });
        }, [
            u
        ])
    ];
}




var $7fPBF = parcelRequire("7fPBF");

function $31d1c03abfe04f09$var$p({ nodeKey: e }) {
    const [o] = (0, $54da90dd2162c735$export$6aeca6bab7b7edbc)(), [u, p, x] = (0, $8665ebb90a54c21f$export$d11cce486b21a5b5)(e);
    return (0, $7fPBF.useEffect)(()=>(0, $3e88191b87395c2e$export$d64d64f541cc1835)(o.registerCommand((0, $3e88191b87395c2e$export$c1a2de6c823e5f82), (t)=>{
            const r = o.getElementByKey(e);
            return (0, $3e88191b87395c2e$export$da5d2f8c5437c541)(t) === r && (t.shiftKey || x(), p(!u), !0);
        }, (0, $3e88191b87395c2e$export$1d1358fe8b5bfab4))), [
        x,
        o,
        u,
        e,
        p
    ]), (0, $7fPBF.useEffect)(()=>{
        var _o__config_theme_hrSelected;
        const t = o.getElementByKey(e), r = (_o__config_theme_hrSelected = o._config.theme.hrSelected) !== null && _o__config_theme_hrSelected !== void 0 ? _o__config_theme_hrSelected : "selected";
        null !== t && (u ? (0, $3e88191b87395c2e$export$71781797876b07d6)(t, r) : (0, $3e88191b87395c2e$export$b59af601940ff389)(t, r));
    }, [
        o,
        u,
        e
    ]), null;
}
class $31d1c03abfe04f09$export$e68cdf336f70c676 extends (0, $8ebc39becbfbdd8f$export$e68cdf336f70c676) {
    static getType() {
        return "horizontalrule";
    }
    static clone(e) {
        return new $31d1c03abfe04f09$export$e68cdf336f70c676(e.__key);
    }
    static importJSON(e) {
        return $31d1c03abfe04f09$export$6fd365a92f1482f2().updateFromJSON(e);
    }
    static importDOM() {
        return {
            hr: ()=>({
                    conversion: $31d1c03abfe04f09$var$d,
                    priority: 0
                })
        };
    }
    decorate() {
        return (0, $824c049f32d4395d$exports.jsx)($31d1c03abfe04f09$var$p, {
            nodeKey: this.__key
        });
    }
}
function $31d1c03abfe04f09$var$d() {
    return {
        node: $31d1c03abfe04f09$export$6fd365a92f1482f2()
    };
}
function $31d1c03abfe04f09$export$6fd365a92f1482f2() {
    return (0, $3e88191b87395c2e$export$2f5beb31df92ea57)(new $31d1c03abfe04f09$export$e68cdf336f70c676);
}


const $2e3a3767bbf962d6$export$d413029ba7c093b7 = (0, $180ae8514eec30ee$export$a1bf852fe7c1a323)({
    init (realm) {
        const pluginIds = realm.getValue((0, $5a7e051e41645429$export$5cb858372d2eb3cc));
        const allowedHeadingLevels = pluginIds.includes("headings") ? realm.getValue((0, $852daab51b9c6f82$export$ee0d7003bc6d0c60)) : [];
        const transformers = $2e3a3767bbf962d6$var$pickTransformersForActivePlugins(pluginIds, allowedHeadingLevels);
        const tableCellTransformers = transformers.filter((t)=>!$2e3a3767bbf962d6$var$LIST_TRANSFORMERS.has(t));
        realm.pubIn({
            [(0, $5a7e051e41645429$export$d120e029a7b56e15)]: ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ce4684f79caee9dd$export$786bae3e7d1ae65), {
                    transformers: transformers
                }),
            [(0, $5a7e051e41645429$export$16cecaa0e6290978)]: ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ce4684f79caee9dd$export$786bae3e7d1ae65), {
                    transformers: transformers
                }),
            [(0, $5a7e051e41645429$export$4195d00b0b92e4c)]: ()=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $ce4684f79caee9dd$export$786bae3e7d1ae65), {
                    transformers: tableCellTransformers
                })
        });
    }
});
const $2e3a3767bbf962d6$var$createBlockNode = (createNode)=>{
    return (parentNode, children, match)=>{
        const node = createNode(match);
        node.append(...children);
        parentNode.replace(node);
        node.select(0, 0);
    };
};
const $2e3a3767bbf962d6$var$THEMATIC_BREAK = {
    dependencies: [
        (0, $31d1c03abfe04f09$export$e68cdf336f70c676)
    ],
    export: (node)=>{
        return (0, $8ebc39becbfbdd8f$export$dddc142b287ff132)(node) ? "***" : null;
    },
    regExp: /^(---|\*\*\*|___)\s?$/,
    replace: (parentNode, _1, _2, isImport)=>{
        const line = (0, $31d1c03abfe04f09$export$6fd365a92f1482f2)();
        if (isImport || parentNode.getNextSibling() != null) parentNode.replace(line);
        else parentNode.insertBefore(line);
        line.selectNext();
    },
    type: "element"
};
const $2e3a3767bbf962d6$var$LIST_TRANSFORMERS = /* @__PURE__ */ new Set([
    (0, $f14993e044630ec5$export$79a56b9f7e08d0e8),
    (0, $f14993e044630ec5$export$895ae9c433e1284f),
    (0, $f14993e044630ec5$export$a2f9cfc16e8207ab)
]);
function $2e3a3767bbf962d6$var$pickTransformersForActivePlugins(pluginIds, allowedHeadingLevels) {
    const transformers = [
        (0, $f14993e044630ec5$export$92abef516ebdb70),
        (0, $f14993e044630ec5$export$a86aea402f79f021),
        (0, $f14993e044630ec5$export$80b6f921f6be2259),
        (0, $f14993e044630ec5$export$53c8c32bd0f4f55),
        (0, $f14993e044630ec5$export$c86cabe491b202d9),
        (0, $f14993e044630ec5$export$d698f1b6f2632135),
        (0, $f14993e044630ec5$export$5a032254410f13aa)
    ];
    if (pluginIds.includes("headings")) {
        const minHeadingLevel = Math.min(...allowedHeadingLevels);
        const maxHeadingLevel = Math.max(...allowedHeadingLevels);
        const headingRegExp = new RegExp(`^(#{${minHeadingLevel},${maxHeadingLevel}})\\s`);
        const HEADING = {
            dependencies: [
                (0, $cc8bb3cdc37e8788$export$90fecd23277fcde2)
            ],
            export: (node, exportChildren)=>{
                if (!(0, $cc8bb3cdc37e8788$export$78b6c84a5d5b8b31)(node)) return null;
                const level = Number(node.getTag().slice(1));
                return "#".repeat(level) + " " + exportChildren(node);
            },
            regExp: headingRegExp,
            replace: $2e3a3767bbf962d6$var$createBlockNode((match)=>{
                const tag = `h${match[1].length}`;
                return (0, $cc8bb3cdc37e8788$export$29cdf7c75bd686cc)(tag);
            }),
            type: "element"
        };
        transformers.push(HEADING);
    }
    if (pluginIds.includes("thematicBreak")) transformers.push($2e3a3767bbf962d6$var$THEMATIC_BREAK);
    if (pluginIds.includes("quote")) transformers.push((0, $f14993e044630ec5$export$6277ca5a40eac6d0));
    if (pluginIds.includes("link")) transformers.push((0, $f14993e044630ec5$export$b395009ca7f092c7));
    if (pluginIds.includes("lists")) transformers.push((0, $f14993e044630ec5$export$79a56b9f7e08d0e8), (0, $f14993e044630ec5$export$895ae9c433e1284f), (0, $f14993e044630ec5$export$a2f9cfc16e8207ab));
    if (pluginIds.includes("codeblock")) {
        const codeTransformerCopy = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $f14993e044630ec5$export$ec5856072852bd7f)), {
            dependencies: [
                (0, $27322b53201ffbba$export$792ac49c5d0ff3ae)
            ],
            replace: (parentNode, _children, match)=>{
                var _match_;
                const codeBlockNode = (0, $27322b53201ffbba$export$fa7749131580a2bf)({
                    code: "",
                    language: (_match_ = match[1]) !== null && _match_ !== void 0 ? _match_ : "",
                    meta: ""
                });
                parentNode.selectPrevious();
                parentNode.replace(codeBlockNode);
                setTimeout(()=>{
                    codeBlockNode.select();
                }, 80);
            }
        });
        transformers.push(codeTransformerCopy);
    }
    return transformers;
}





var $7fPBF = parcelRequire("7fPBF");








var $7fPBF = parcelRequire("7fPBF");
const $ce8295ee50d4891f$export$c319033752546ed5 = {
    undo: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M7.202 18.5V17H14.3788C15.4224 17 16.3205 16.6554 17.073 15.9663C17.8257 15.2773 18.202 14.4263 18.202 13.4135C18.202 12.4007 17.8257 11.5512 17.073 10.8652C16.3205 10.1794 15.4224 9.8365 14.3788 9.8365H7.35775L10.1402 12.6193L9.0865 13.673L4.5 9.0865L9.0865 4.5L10.1402 5.55375L7.35775 8.3365H14.3788C15.8416 8.3365 17.0945 8.82467 18.1375 9.801C19.1805 10.7773 19.702 11.9815 19.702 13.4135C19.702 14.8455 19.1805 16.0513 18.1375 17.0308C17.0945 18.0103 15.8416 18.5 14.3788 18.5H7.202Z",
        fill: "currentColor"
    })),
    redo: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M9.6211 18.5C8.15827 18.5 6.90535 18.0103 5.86235 17.0308C4.81935 16.0513 4.29785 14.8455 4.29785 13.4135C4.29785 11.9815 4.81935 10.7773 5.86235 9.801C6.90535 8.82467 8.15827 8.3365 9.6211 8.3365H16.6421L13.8596 5.55375L14.9134 4.5L19.4999 9.0865L14.9134 13.673L13.8596 12.6193L16.6421 9.8365H9.6211C8.57744 9.8365 7.67935 10.1794 6.92685 10.8652C6.17418 11.5512 5.79785 12.4007 5.79785 13.4135C5.79785 14.4263 6.17418 15.2773 6.92685 15.9663C7.67935 16.6554 8.57744 17 9.6211 17H16.7979V18.5H9.6211Z",
        fill: "currentColor"
    })),
    format_bold: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M7.33838 18.625V5.375H12.1999C13.219 5.375 14.1405 5.69233 14.9644 6.327C15.788 6.9615 16.1999 7.816 16.1999 8.8905C16.1999 9.63783 16.0194 10.2471 15.6584 10.7182C15.2975 11.1894 14.9088 11.5314 14.4921 11.7442C15.005 11.9211 15.4947 12.2708 15.9614 12.7933C16.428 13.3158 16.6614 14.0193 16.6614 14.9038C16.6614 16.1819 16.1902 17.1217 15.2479 17.723C14.3055 18.3243 13.3562 18.625 12.3999 18.625H7.33838ZM9.48838 16.6328H12.3191C13.1063 16.6328 13.6627 16.4142 13.9884 15.977C14.314 15.5398 14.4769 15.1206 14.4769 14.7192C14.4769 14.3179 14.314 13.8987 13.9884 13.4615C13.6627 13.0243 13.0909 12.8058 12.2729 12.8058H9.48838V16.6328ZM9.48838 10.875H12.0826C12.6903 10.875 13.172 10.7013 13.5279 10.3538C13.8835 10.0064 14.0614 9.59042 14.0614 9.10575C14.0614 8.59042 13.8733 8.16925 13.4971 7.84225C13.1208 7.51542 12.6595 7.352 12.1134 7.352H9.48838V10.875Z",
        fill: "currentColor"
    })),
    format_italic: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M5.39404 18.625V16.8173H9.21129L12.4518 7.18275H8.63454V5.375H17.7883V7.18275H14.2785L11.0383 16.8173H14.5478V18.625H5.39404Z",
        fill: "currentColor"
    })),
    format_underlined: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M5.34619 22.125V20.625H18.6537V22.125H5.34619ZM11.9999 18.5287C10.4448 18.5287 9.23102 18.0566 8.35869 17.1125C7.48619 16.1683 7.04994 14.9032 7.04994 13.3172V5.41345H8.90369V13.4095C8.90369 14.4198 9.17228 15.2295 9.70944 15.8385C10.2466 16.4475 11.0101 16.752 11.9999 16.752C12.9898 16.752 13.7533 16.4475 14.2904 15.8385C14.8276 15.2295 15.0962 14.4198 15.0962 13.4095V5.41345H16.9499V13.3172C16.9499 14.9032 16.5137 16.1683 15.6412 17.1125C14.7689 18.0566 13.5551 18.5287 11.9999 18.5287Z",
        fill: "currentColor"
    })),
    format_highlight: /* taken from from https://lucide.dev/icons/highlighter */ /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "1.75",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "m9 11-6 6v3h9l3-3"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "m22 12-4.6 4.6a2 2 0 0 1-2.8 0l-5.2-5.2a2 2 0 0 1 0-2.8L14 4"
    })),
    code: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M7.99994 17.6537L2.34619 11.9999L7.99994 6.34619L9.06919 7.41544L4.46919 12.0154L9.05369 16.5999L7.99994 17.6537ZM15.9999 17.6537L14.9307 16.5844L19.5307 11.9844L14.9462 7.39994L15.9999 6.34619L21.6537 11.9999L15.9999 17.6537Z",
        fill: "currentColor"
    })),
    strikeThrough: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M12.15 19.6923C10.9732 19.6923 9.9315 19.359 9.025 18.6923C8.11867 18.0256 7.45525 17.1128 7.03475 15.9538L8.6385 15.2635C8.91667 16.0444 9.3545 16.6867 9.952 17.1905C10.5493 17.6944 11.2923 17.9463 12.1808 17.9463C12.9578 17.9463 13.6744 17.7508 14.3307 17.3598C14.9872 16.9686 15.3155 16.3487 15.3155 15.5C15.3155 15.123 15.2555 14.7968 15.1355 14.5213C15.0157 14.2456 14.8462 13.9885 14.627 13.75H16.677C16.7987 13.9705 16.8932 14.2256 16.9605 14.5153C17.0278 14.8051 17.0615 15.1334 17.0615 15.5C17.0615 16.8372 16.5747 17.8702 15.601 18.599C14.6272 19.3279 13.4768 19.6923 12.15 19.6923ZM2.25 11.75V10.25H21.75V11.75H2.25ZM12.05 4.19629C13.0475 4.19629 13.9123 4.42704 14.6443 4.88854C15.3763 5.35004 15.9673 6.05896 16.4173 7.01529L14.823 7.73079C14.6218 7.26029 14.2978 6.84462 13.851 6.48379C13.4042 6.12279 12.8141 5.94229 12.0808 5.94229C11.2244 5.94229 10.5392 6.16221 10.025 6.60204C9.51083 7.04171 9.264 7.59104 9.2845 8.25004H7.5385C7.50133 7.16421 7.89783 6.21712 8.728 5.40879C9.558 4.60046 10.6653 4.19629 12.05 4.19629Z",
        fill: "currentColor"
    })),
    superscript: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M16.6924 8V6.2115C16.6924 5.95383 16.7786 5.73875 16.9511 5.56625C17.1235 5.39392 17.3385 5.30775 17.5961 5.30775H19.5001V4.38475H16.6924V3.5H19.4809C19.7385 3.5 19.9536 3.58625 20.1261 3.75875C20.2985 3.93108 20.3846 4.14617 20.3846 4.404V5.2885C20.3846 5.54617 20.2985 5.76125 20.1261 5.93375C19.9536 6.10608 19.7385 6.19225 19.4809 6.19225H17.5771V7.1155H20.3846V8H16.6924ZM4.44238 18.5L8.84638 11.6287L4.77713 5.30775H6.74438L9.95963 10.404H10.0214L13.2501 5.30775H15.2329L11.1194 11.6287L15.5579 18.5H13.5751L10.0214 12.9308H9.95963L6.42513 18.5H4.44238Z",
        fill: "currentColor"
    })),
    subscript: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M16.6924 20.5V18.7115C16.6924 18.4538 16.7786 18.2387 16.9511 18.0662C17.1235 17.8939 17.3385 17.8077 17.5961 17.8077H19.5001V16.8845H16.6924V16H19.4809C19.7385 16 19.9536 16.0863 20.1261 16.2587C20.2985 16.4311 20.3846 16.6461 20.3846 16.9038V17.7885C20.3846 18.0462 20.2985 18.2612 20.1261 18.4337C19.9536 18.6061 19.7385 18.6923 19.4809 18.6923H17.5771V19.6152H20.3846V20.5H16.6924ZM4.44238 18.6923L8.84638 11.8212L4.77713 5.5H6.74438L9.95963 10.5962H10.0214L13.2501 5.5H15.2329L11.1194 11.8212L15.5579 18.6923H13.5751L10.0214 13.123H9.95963L6.42513 18.6923H4.44238Z",
        fill: "currentColor"
    })),
    format_list_bulleted: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M9.30775 18.75V17.25H20.5V18.75H9.30775ZM9.30775 12.75V11.25H20.5V12.75H9.30775ZM9.30775 6.75005V5.25005H20.5V6.75005H9.30775ZM5.1635 19.6635C4.706 19.6635 4.31442 19.5006 3.98875 19.1748C3.66292 18.8491 3.5 18.4575 3.5 18C3.5 17.5425 3.66292 17.151 3.98875 16.8253C4.31442 16.4995 4.706 16.3365 5.1635 16.3365C5.621 16.3365 6.01258 16.4995 6.33825 16.8253C6.66408 17.151 6.827 17.5425 6.827 18C6.827 18.4575 6.66408 18.8491 6.33825 19.1748C6.01258 19.5006 5.621 19.6635 5.1635 19.6635ZM5.1635 13.6635C4.706 13.6635 4.31442 13.5006 3.98875 13.1748C3.66292 12.8491 3.5 12.4575 3.5 12C3.5 11.5425 3.66292 11.151 3.98875 10.8253C4.31442 10.4995 4.706 10.3365 5.1635 10.3365C5.621 10.3365 6.01258 10.4995 6.33825 10.8253C6.66408 11.151 6.827 11.5425 6.827 12C6.827 12.4575 6.66408 12.8491 6.33825 13.1748C6.01258 13.5006 5.621 13.6635 5.1635 13.6635ZM5.1635 7.66355C4.706 7.66355 4.31442 7.50063 3.98875 7.1748C3.66292 6.84913 3.5 6.45755 3.5 6.00005C3.5 5.54255 3.66292 5.15096 3.98875 4.8253C4.31442 4.49946 4.706 4.33655 5.1635 4.33655C5.621 4.33655 6.01258 4.49946 6.33825 4.8253C6.66408 5.15096 6.827 5.54255 6.827 6.00005C6.827 6.45755 6.66408 6.84913 6.33825 7.1748C6.01258 7.50063 5.621 7.66355 5.1635 7.66355Z",
        fill: "currentColor"
    })),
    format_list_numbered: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M3.5 21.5V20.3078H6V19.25H4.5V18.0577H6V17H3.5V15.8077H6.34625C6.58592 15.8077 6.78683 15.8888 6.949 16.051C7.11117 16.2132 7.19225 16.4141 7.19225 16.6538V17.8462C7.19225 18.0859 7.11117 18.2868 6.949 18.449C6.78683 18.6112 6.58592 18.6923 6.34625 18.6923C6.58592 18.6923 6.78683 18.7733 6.949 18.9355C7.11117 19.0977 7.19225 19.2987 7.19225 19.5385V20.6538C7.19225 20.8936 7.11117 21.0946 6.949 21.2568C6.78683 21.4189 6.58592 21.5 6.34625 21.5H3.5ZM3.5 14.8463V12.25C3.5 12.0103 3.58108 11.8093 3.74325 11.647C3.90542 11.4848 4.10642 11.4038 4.34625 11.4038H6V10.3462H3.5V9.15375H6.34625C6.58592 9.15375 6.78683 9.23483 6.949 9.397C7.11117 9.55933 7.19225 9.76033 7.19225 10V11.75C7.19225 11.9897 7.11117 12.1907 6.949 12.353C6.78683 12.5152 6.58592 12.5963 6.34625 12.5963H4.69225V13.6538H7.19225V14.8463H3.5ZM5 8.19225V3.69225H3.5V2.5H6.19225V8.19225H5ZM9.30775 18.75V17.25H20.5V18.75H9.30775ZM9.30775 12.75V11.25H20.5V12.75H9.30775ZM9.30775 6.75V5.25H20.5V6.75H9.30775Z",
        fill: "currentColor"
    })),
    format_list_checked: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M5.69425 18.452L2.5 15.2578L3.54425 14.2135L5.66925 16.3385L9.91925 12.0885L10.9635 13.1578L5.69425 18.452ZM5.69425 10.8365L2.5 7.64227L3.54425 6.59802L5.66925 8.72302L9.91925 4.47302L10.9635 5.54227L5.69425 10.8365ZM13.0095 16.5578V15.0578H21.5095V16.5578H13.0095ZM13.0095 8.94227V7.44227H21.5095V8.94227H13.0095Z",
        fill: "currentColor"
    })),
    link: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M10.8077 16.5385H7.0385C5.78283 16.5385 4.7125 16.096 3.8275 15.211C2.9425 14.3262 2.5 13.256 2.5 12.0005C2.5 10.745 2.9425 9.67471 3.8275 8.78955C4.7125 7.90421 5.78283 7.46155 7.0385 7.46155H10.8077V8.96155H7.0385C6.19867 8.96155 5.48233 9.25805 4.8895 9.85105C4.2965 10.444 4 11.1604 4 12C4 12.8397 4.2965 13.556 4.8895 14.149C5.48233 14.742 6.19867 15.0385 7.0385 15.0385H10.8077V16.5385ZM8.25 12.75V11.25H15.75V12.75H8.25ZM13.1923 16.5385V15.0385H16.9615C17.8013 15.0385 18.5177 14.742 19.1105 14.149C19.7035 13.556 20 12.8397 20 12C20 11.1604 19.7035 10.444 19.1105 9.85105C18.5177 9.25805 17.8013 8.96155 16.9615 8.96155H13.1923V7.46155H16.9615C18.2172 7.46155 19.2875 7.90405 20.1725 8.78905C21.0575 9.67388 21.5 10.744 21.5 11.9995C21.5 13.255 21.0575 14.3254 20.1725 15.2105C19.2875 16.0959 18.2172 16.5385 16.9615 16.5385H13.1923Z",
        fill: "currentColor"
    })),
    add_photo: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M5.11537 20.5C4.6182 20.5 4.19262 20.323 3.83862 19.969C3.48462 19.615 3.30762 19.1894 3.30762 18.6922V5.30773C3.30762 4.81056 3.48462 4.38498 3.83862 4.03098C4.19262 3.67698 4.6182 3.49998 5.11537 3.49998H13.8076V4.99998H5.11537C5.02553 4.99998 4.95178 5.02881 4.89412 5.08648C4.83645 5.14415 4.80762 5.2179 4.80762 5.30773V18.6922C4.80762 18.7821 4.83645 18.8558 4.89412 18.9135C4.95178 18.9711 5.02553 19 5.11537 19H18.4999C18.5895 19 18.6633 18.9711 18.7211 18.9135C18.7788 18.8558 18.8076 18.7821 18.8076 18.6922V9.99998H20.3076V18.6922C20.3076 19.1894 20.1306 19.615 19.7766 19.969C19.4226 20.323 18.997 20.5 18.4999 20.5H5.11537ZM17.1921 8.61523V6.61523H15.1921V5.11548H17.1921V3.11548H18.6921V5.11548H20.6921V6.61523H18.6921V8.61523H17.1921ZM6.55762 16.75H17.1344L13.8459 12.3655L11.0384 16.0192L9.03837 13.4615L6.55762 16.75Z",
        fill: "currentColor"
    })),
    table: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M3.5 18.6923V5.30775C3.5 4.81058 3.677 4.385 4.031 4.031C4.385 3.677 4.81058 3.5 5.30775 3.5H18.6923C19.1894 3.5 19.615 3.677 19.969 4.031C20.323 4.385 20.5 4.81058 20.5 5.30775V18.6923C20.5 19.1894 20.323 19.615 19.969 19.969C19.615 20.323 19.1894 20.5 18.6923 20.5H5.30775C4.81058 20.5 4.385 20.323 4.031 19.969C3.677 19.615 3.5 19.1894 3.5 18.6923ZM5 9.077H19V5.30775C19 5.21792 18.9712 5.14417 18.9135 5.0865C18.8558 5.02883 18.7821 5 18.6923 5H5.30775C5.21792 5 5.14417 5.02883 5.0865 5.0865C5.02883 5.14417 5 5.21792 5 5.30775V9.077ZM10.1615 14.0385H13.8385V10.577H10.1615V14.0385ZM10.1615 19H13.8385V15.5385H10.1615V19ZM5 14.0385H8.6615V10.577H5V14.0385ZM15.3385 14.0385H19V10.577H15.3385V14.0385ZM5.30775 19H8.6615V15.5385H5V18.6923C5 18.7821 5.02883 18.8558 5.0865 18.9135C5.14417 18.9712 5.21792 19 5.30775 19ZM15.3385 19H18.6923C18.7821 19 18.8558 18.9712 18.9135 18.9135C18.9712 18.8558 19 18.7821 19 18.6923V15.5385H15.3385V19Z",
        fill: "currentColor"
    })),
    horizontal_rule: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M4.5 12.75V11.25H19.5V12.75H4.5Z",
        fill: "currentColor"
    })),
    frontmatter: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M4.5 8.75V7.25H8.5V8.75H4.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M4.5 14.75V13.25H8.5V14.75H4.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M9.5 8.75V7.25H13.5V8.75H9.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M9.5 14.75V13.25H13.5V14.75H9.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M14.5 8.75V7.25H18.5V8.75H14.5Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M14.5 14.75V13.25H18.5V14.75H14.5Z",
        fill: "currentColor"
    })),
    frame_source: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M8.6 15.2443L5.35575 12L8.6 8.75575L9.64425 9.825L7.46925 12L9.64425 14.175L8.6 15.2443ZM15.4 15.2443L14.3558 14.175L16.5307 12L14.3558 9.825L15.4 8.75575L18.6443 12L15.4 15.2443ZM5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V15H5V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H9V20.5H5.30775ZM15 20.5V19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V15H20.5V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H15ZM3.5 9V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H9V5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V9H3.5ZM19 9V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H15V3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V9H19Z",
        fill: "currentColor"
    })),
    arrow_drop_down: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M11.9999 14.6537L7.59619 10.25H16.4037L11.9999 14.6537Z",
        fill: "currentColor"
    })),
    admonition: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M12.0001 21.4C11.7654 21.4 11.5385 21.3548 11.3193 21.2645C11.1002 21.174 10.9002 21.0435 10.7193 20.873L3.1271 13.2807C2.9566 13.0999 2.8261 12.8999 2.7356 12.6807C2.64526 12.4616 2.6001 12.2346 2.6001 12C2.6001 11.7653 2.64526 11.5358 2.7356 11.3115C2.8261 11.0871 2.9566 10.8897 3.1271 10.7192L10.7193 3.12698C10.9002 2.94614 11.1002 2.81314 11.3193 2.72798C11.5385 2.64264 11.7654 2.59998 12.0001 2.59998C12.2348 2.59998 12.4643 2.64264 12.6886 2.72798C12.9129 2.81314 13.1103 2.94614 13.2808 3.12698L20.8731 10.7192C21.0539 10.8897 21.1869 11.0871 21.2721 11.3115C21.3574 11.5358 21.4001 11.7653 21.4001 12C21.4001 12.2346 21.3574 12.4616 21.2721 12.6807C21.1869 12.8999 21.0539 13.0999 20.8731 13.2807L13.2808 20.873C13.1103 21.0435 12.9129 21.174 12.6886 21.2645C12.4643 21.3548 12.2348 21.4 12.0001 21.4ZM12.2213 19.8037L19.8039 12.2212C19.8552 12.1699 19.8808 12.0961 19.8808 12C19.8808 11.9038 19.8552 11.8301 19.8039 11.7787L12.2213 4.19623C12.17 4.14489 12.0963 4.11923 12.0001 4.11923C11.9039 4.11923 11.8302 4.14489 11.7788 4.19623L4.19635 11.7787C4.14501 11.8301 4.11935 11.9038 4.11935 12C4.11935 12.0961 4.14501 12.1699 4.19635 12.2212L11.7788 19.8037C11.8302 19.8551 11.9039 19.8807 12.0001 19.8807C12.0963 19.8807 12.17 19.8551 12.2213 19.8037ZM11.2501 13.0865H12.7501V7.47123H11.2501V13.0865ZM12.0001 15.702C12.2258 15.702 12.4168 15.6237 12.5731 15.4672C12.7296 15.3109 12.8078 15.1199 12.8078 14.8942C12.8078 14.6686 12.7296 14.4776 12.5731 14.3212C12.4168 14.1647 12.2258 14.0865 12.0001 14.0865C11.7744 14.0865 11.5834 14.1647 11.4271 14.3212C11.2706 14.4776 11.1923 14.6686 11.1923 14.8942C11.1923 15.1199 11.2706 15.3109 11.4271 15.4672C11.5834 15.6237 11.7744 15.702 12.0001 15.702Z",
        fill: "currentColor"
    })),
    rich_text: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V5.30775C19 5.23075 18.9679 5.16025 18.9038 5.09625C18.8398 5.03208 18.7692 5 18.6923 5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19ZM6.75 17H17.3268L14 12.3655L11.2308 16.0192L9 13.4615L6.75 17Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M6 12V6.5H9.1925C9.5925 6.5 9.9425 6.65 10.2425 6.95C10.5425 7.25 10.6925 7.6 10.6925 8V8.6925C10.6925 9.03733 10.605 9.32675 10.43 9.56075C10.255 9.79458 10.0168 9.97817 9.7155 10.1115L10.6155 12H9.404L8.504 10.1925H7.1925V12H6ZM9.1925 9H7.1925V7.6925H9.1925C9.26933 7.6925 9.33983 7.7245 9.404 7.7885C9.468 7.85267 9.5 7.92317 9.5 8V8.6925C9.5 8.76933 9.468 8.83983 9.404 8.904C9.33983 8.968 9.26933 9 9.1925 9Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M12.5 7H17.5V8.25H12.5V7Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M12.5 9.25H17.5V10.5H12.5V9.25Z",
        fill: "currentColor"
    })),
    difference: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM18.6923 19H5.30775C5.23075 19 5.16025 18.9679 5.09625 18.9038C5.03208 18.8398 5 18.7692 5 18.6923V5.30775C5 5.23075 5.03208 5.16025 5.09625 5.09625C5.16025 5.03208 5.23075 5 5.30775 5H18.6923C18.7692 5 18.8398 5.03208 18.9038 5.09625C18.9679 5.16025 19 5.23075 19 5.30775V18.6923C19 18.7692 18.9679 18.8398 18.9038 18.9038C18.8398 18.9679 18.7692 19 18.6923 19Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: "9",
        y: "10",
        width: "5.5",
        height: "1.5",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: "9",
        y: "15",
        width: "5.5",
        height: "1.5",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("rect", {
        x: "11",
        y: "8",
        width: "1.5",
        height: "5.5",
        fill: "currentColor"
    })),
    markdown: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H18.6923C19.1974 3.5 19.625 3.675 19.975 4.025C20.325 4.375 20.5 4.80258 20.5 5.30775V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM18.6923 19H5.30775C5.23075 19 5.16025 18.9679 5.09625 18.9038C5.03208 18.8398 5 18.7692 5 18.6923V5.30775C5 5.23075 5.03208 5.16025 5.09625 5.09625C5.16025 5.03208 5.23075 5 5.30775 5H18.6923C18.7692 5 18.8398 5.03208 18.9038 5.09625C18.9679 5.16025 19 5.23075 19 5.30775V18.6923C19 18.7692 18.9679 18.8398 18.9038 18.9038C18.8398 18.9679 18.7692 19 18.6923 19Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M13 15H11.5V11L9.5 14L7.5 11V15H6V8H7.5L9.5 11L11.5 8H13V15Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M15.9921 15.5833L13.2886 12.8797L14.0546 12.1137L15.4504 13.5016V7.99597L16.5336 7.99993V13.5016L17.9296 12.1137L18.6954 12.8797L15.9921 15.5833Z",
        fill: "currentColor"
    })),
    open_in_new: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M5.30775 20.5C4.80258 20.5 4.375 20.325 4.025 19.975C3.675 19.625 3.5 19.1974 3.5 18.6923V5.30775C3.5 4.80258 3.675 4.375 4.025 4.025C4.375 3.675 4.80258 3.5 5.30775 3.5H11.6152V5H5.30775C5.23075 5 5.16025 5.03208 5.09625 5.09625C5.03208 5.16025 5 5.23075 5 5.30775V18.6923C5 18.7692 5.03208 18.8398 5.09625 18.9038C5.16025 18.9679 5.23075 19 5.30775 19H18.6923C18.7692 19 18.8398 18.9679 18.9038 18.9038C18.9679 18.8398 19 18.7692 19 18.6923V12.3848H20.5V18.6923C20.5 19.1974 20.325 19.625 19.975 19.975C19.625 20.325 19.1974 20.5 18.6923 20.5H5.30775ZM9.71925 15.3345L8.6655 14.2808L17.9462 5H14V3.5H20.5V10H19V6.05375L9.71925 15.3345Z",
        fill: "currentColor"
    })),
    link_off: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M18.8843 16.1038L17.7498 14.9385C18.4228 14.7552 18.9661 14.3946 19.3796 13.8568C19.7931 13.319 19.9998 12.7 19.9998 12C19.9998 11.1604 19.705 10.444 19.1153 9.85105C18.5255 9.25805 17.8139 8.96155 16.9806 8.96155H13.1728V7.46155H16.9806C18.2293 7.46155 19.2947 7.90422 20.1768 8.78955C21.0588 9.67472 21.4998 10.7449 21.4998 12C21.4998 12.8859 21.262 13.6951 20.7863 14.4278C20.3107 15.1606 19.6767 15.7193 18.8843 16.1038ZM15.5806 12.75L14.0806 11.25H15.7306V12.75H15.5806ZM20.1461 22.2538L1.74609 3.8538L2.79984 2.80005L21.1998 21.2L20.1461 22.2538ZM10.8268 16.5386H7.03834C5.78318 16.5386 4.71301 16.0959 3.82784 15.2105C2.94251 14.3254 2.49984 13.2552 2.49984 12C2.49984 10.8885 2.85784 9.91322 3.57384 9.07405C4.28984 8.23505 5.18826 7.72838 6.26909 7.55405H6.49984L7.90759 8.96155H7.03834C6.19851 8.96155 5.48218 9.25805 4.88934 9.85105C4.29634 10.444 3.99984 11.1604 3.99984 12C3.99984 12.8397 4.29634 13.556 4.88934 14.149C5.48218 14.742 6.19851 15.0385 7.03834 15.0385H10.8268V16.5386ZM8.26909 12.75V11.25H10.2113L11.6863 12.75H8.26909Z",
        fill: "currentColor"
    })),
    edit: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M5 19H6.2615L16.498 8.7635L15.2365 7.502L5 17.7385V19ZM3.5 20.5V17.1155L16.6905 3.93075C16.8417 3.79342 17.0086 3.68733 17.1913 3.6125C17.3741 3.5375 17.5658 3.5 17.7663 3.5C17.9668 3.5 18.1609 3.53558 18.3488 3.60675C18.5367 3.67792 18.7032 3.79108 18.848 3.94625L20.0693 5.18275C20.2244 5.32758 20.335 5.49425 20.401 5.68275C20.467 5.87125 20.5 6.05975 20.5 6.24825C20.5 6.44942 20.4657 6.64133 20.397 6.824C20.3283 7.00683 20.2191 7.17383 20.0693 7.325L6.8845 20.5H3.5ZM15.8562 8.14375L15.2365 7.502L16.498 8.7635L15.8562 8.14375Z",
        fill: "currentColor"
    })),
    content_copy: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M9.05775 17.5C8.55258 17.5 8.125 17.325 7.775 16.975C7.425 16.625 7.25 16.1974 7.25 15.6923V4.30775C7.25 3.80258 7.425 3.375 7.775 3.025C8.125 2.675 8.55258 2.5 9.05775 2.5H17.4423C17.9474 2.5 18.375 2.675 18.725 3.025C19.075 3.375 19.25 3.80258 19.25 4.30775V15.6923C19.25 16.1974 19.075 16.625 18.725 16.975C18.375 17.325 17.9474 17.5 17.4423 17.5H9.05775ZM9.05775 16H17.4423C17.5192 16 17.5898 15.9679 17.6538 15.9038C17.7179 15.8398 17.75 15.7692 17.75 15.6923V4.30775C17.75 4.23075 17.7179 4.16025 17.6538 4.09625C17.5898 4.03208 17.5192 4 17.4423 4H9.05775C8.98075 4 8.91025 4.03208 8.84625 4.09625C8.78208 4.16025 8.75 4.23075 8.75 4.30775V15.6923C8.75 15.7692 8.78208 15.8398 8.84625 15.9038C8.91025 15.9679 8.98075 16 9.05775 16ZM5.55775 21C5.05258 21 4.625 20.825 4.275 20.475C3.925 20.125 3.75 19.6974 3.75 19.1923V6.30775H5.25V19.1923C5.25 19.2693 5.28208 19.3398 5.34625 19.4038C5.41025 19.4679 5.48075 19.5 5.55775 19.5H15.4423V21H5.55775Z",
        fill: "currentColor"
    })),
    more_horiz: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M6.23096 13.5C5.81846 13.5 5.46537 13.3531 5.17171 13.0592C4.87787 12.7656 4.73096 12.4125 4.73096 12C4.73096 11.5875 4.87787 11.2344 5.17171 10.9408C5.46537 10.6469 5.81846 10.5 6.23096 10.5C6.64346 10.5 6.99662 10.6469 7.29046 10.9408C7.58412 11.2344 7.73096 11.5875 7.73096 12C7.73096 12.4125 7.58412 12.7656 7.29046 13.0592C6.99662 13.3531 6.64346 13.5 6.23096 13.5ZM12.0002 13.5C11.5877 13.5 11.2346 13.3531 10.941 13.0592C10.6471 12.7656 10.5002 12.4125 10.5002 12C10.5002 11.5875 10.6471 11.2344 10.941 10.9408C11.2346 10.6469 11.5877 10.5 12.0002 10.5C12.4127 10.5 12.7658 10.6469 13.0595 10.9408C13.3533 11.2344 13.5002 11.5875 13.5002 12C13.5002 12.4125 13.3533 12.7656 13.0595 13.0592C12.7658 13.3531 12.4127 13.5 12.0002 13.5ZM17.7695 13.5C17.357 13.5 17.0038 13.3531 16.71 13.0592C16.4163 12.7656 16.2695 12.4125 16.2695 12C16.2695 11.5875 16.4163 11.2344 16.71 10.9408C17.0038 10.6469 17.357 10.5 17.7695 10.5C18.182 10.5 18.535 10.6469 18.8287 10.9408C19.1225 11.2344 19.2695 11.5875 19.2695 12C19.2695 12.4125 19.1225 12.7656 18.8287 13.0592C18.535 13.3531 18.182 13.5 17.7695 13.5Z",
        fill: "currentColor"
    })),
    more_vert: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M12 19.2692C11.5875 19.2692 11.2344 19.1223 10.9408 18.8285C10.6469 18.5348 10.5 18.1817 10.5 17.7692C10.5 17.3567 10.6469 17.0035 10.9408 16.7097C11.2344 16.416 11.5875 16.2692 12 16.2692C12.4125 16.2692 12.7656 16.416 13.0592 16.7097C13.3531 17.0035 13.5 17.3567 13.5 17.7692C13.5 18.1817 13.3531 18.5348 13.0592 18.8285C12.7656 19.1223 12.4125 19.2692 12 19.2692ZM12 13.5C11.5875 13.5 11.2344 13.353 10.9408 13.0592C10.6469 12.7655 10.5 12.4125 10.5 12C10.5 11.5875 10.6469 11.2344 10.9408 10.9407C11.2344 10.6469 11.5875 10.5 12 10.5C12.4125 10.5 12.7656 10.6469 13.0592 10.9407C13.3531 11.2344 13.5 11.5875 13.5 12C13.5 12.4125 13.3531 12.7655 13.0592 13.0592C12.7656 13.353 12.4125 13.5 12 13.5ZM12 7.73071C11.5875 7.73071 11.2344 7.58388 10.9408 7.29021C10.6469 6.99638 10.5 6.64321 10.5 6.23071C10.5 5.81821 10.6469 5.46513 10.9408 5.17146C11.2344 4.87763 11.5875 4.73071 12 4.73071C12.4125 4.73071 12.7656 4.87763 13.0592 5.17146C13.3531 5.46513 13.5 5.81821 13.5 6.23071C13.5 6.64321 13.3531 6.99638 13.0592 7.29021C12.7656 7.58388 12.4125 7.73071 12 7.73071Z",
        fill: "currentColor"
    })),
    close: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M6.39994 18.6538L5.34619 17.6L10.9462 12L5.34619 6.4L6.39994 5.34625L11.9999 10.9463L17.5999 5.34625L18.6537 6.4L13.0537 12L18.6537 17.6L17.5999 18.6538L11.9999 13.0538L6.39994 18.6538Z",
        fill: "currentColor"
    })),
    settings: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M9.69225 21.5L9.3115 18.4538C9.04367 18.3641 8.769 18.2385 8.4875 18.077C8.20617 17.9153 7.95459 17.7422 7.73275 17.5577L4.9115 18.75L2.604 14.75L5.04425 12.9058C5.02125 12.7571 5.00492 12.6077 4.99525 12.4578C4.98559 12.3078 4.98075 12.1583 4.98075 12.0095C4.98075 11.8673 4.98559 11.7228 4.99525 11.576C5.00492 11.4292 5.02125 11.2686 5.04425 11.0943L2.604 9.25L4.9115 5.26925L7.723 6.452C7.96417 6.261 8.22159 6.08633 8.49525 5.928C8.76892 5.76967 9.03784 5.64242 9.302 5.54625L9.69225 2.5H14.3078L14.6885 5.55575C14.9885 5.66475 15.2599 5.792 15.5028 5.9375C15.7458 6.083 15.991 6.2545 16.2385 6.452L19.0885 5.26925L21.396 9.25L18.9173 11.123C18.9531 11.2845 18.9727 11.4355 18.976 11.576C18.9792 11.7163 18.9808 11.8577 18.9808 12C18.9808 12.1358 18.9775 12.274 18.971 12.4145C18.9647 12.5548 18.9417 12.7154 18.902 12.8963L21.3615 14.75L19.0538 18.75L16.2385 17.548C15.991 17.7455 15.7384 17.9202 15.4808 18.072C15.2231 18.224 14.959 18.3481 14.6885 18.4443L14.3078 21.5H9.69225ZM11 20H12.9655L13.325 17.3212C13.8353 17.1879 14.3017 16.9985 14.724 16.753C15.1465 16.5073 15.5539 16.1916 15.9463 15.8057L18.4308 16.85L19.4155 15.15L17.2463 13.5155C17.3296 13.2565 17.3863 13.0026 17.4163 12.7537C17.4464 12.5051 17.4615 12.2538 17.4615 12C17.4615 11.7397 17.4464 11.4884 17.4163 11.2463C17.3863 11.0039 17.3296 10.7564 17.2463 10.5038L19.4345 8.85L18.45 7.15L15.9365 8.2095C15.6018 7.85183 15.2009 7.53583 14.7338 7.2615C14.2664 6.98717 13.7937 6.79292 13.3155 6.67875L13 4H11.0155L10.6845 6.66925C10.1743 6.78975 9.70325 6.97433 9.27125 7.223C8.83909 7.47183 8.42684 7.79233 8.0345 8.1845L5.55 7.15L4.5655 8.85L6.725 10.4595C6.64167 10.6968 6.58334 10.9437 6.55 11.2C6.51667 11.4563 6.5 11.7262 6.5 12.0095C6.5 12.2698 6.51667 12.525 6.55 12.775C6.58334 13.025 6.6385 13.2718 6.7155 13.5155L4.5655 15.15L5.55 16.85L8.025 15.8C8.4045 16.1897 8.81025 16.5089 9.24225 16.7578C9.67442 17.0064 10.152 17.1974 10.675 17.3307L11 20ZM12.0115 15C12.8435 15 13.5515 14.708 14.1355 14.124C14.7195 13.54 15.0115 12.832 15.0115 12C15.0115 11.168 14.7195 10.46 14.1355 9.876C13.5515 9.292 12.8435 9 12.0115 9C11.1692 9 10.4586 9.292 9.87975 9.876C9.30092 10.46 9.0115 11.168 9.0115 12C9.0115 12.832 9.30092 13.54 9.87975 14.124C10.4586 14.708 11.1692 15 12.0115 15Z",
        fill: "currentColor"
    })),
    delete_big: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M7.30775 20.5C6.80908 20.5 6.38308 20.3234 6.02975 19.9702C5.67658 19.6169 5.5 19.1909 5.5 18.6922V5.99998H4.5V4.49998H9V3.61548H15V4.49998H19.5V5.99998H18.5V18.6922C18.5 19.1974 18.325 19.625 17.975 19.975C17.625 20.325 17.1974 20.5 16.6923 20.5H7.30775ZM17 5.99998H7V18.6922C7 18.7821 7.02883 18.8558 7.0865 18.9135C7.14417 18.9711 7.21792 19 7.30775 19H16.6923C16.7692 19 16.8398 18.9679 16.9038 18.9037C16.9679 18.8397 17 18.7692 17 18.6922V5.99998ZM9.404 17H10.9037V7.99998H9.404V17ZM13.0962 17H14.596V7.99998H13.0962V17Z",
        fill: "currentColor"
    })),
    delete_small: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M7.30775 20.5C6.80908 20.5 6.38308 20.3234 6.02975 19.9702C5.67658 19.6169 5.5 19.1909 5.5 18.6922V5.99998H4.5V4.49998H9V3.61548H15V4.49998H19.5V5.99998H18.5V18.6922C18.5 19.1974 18.325 19.625 17.975 19.975C17.625 20.325 17.1974 20.5 16.6923 20.5H7.30775ZM17 5.99998H7V18.6922C7 18.7821 7.02883 18.8558 7.0865 18.9135C7.14417 18.9711 7.21792 19 7.30775 19H16.6923C16.7692 19 16.8398 18.9679 16.9038 18.9037C16.9679 18.8397 17 18.7692 17 18.6922V5.99998ZM9.404 17H10.9037V7.99998H9.404V17ZM13.0962 17H14.596V7.99998H13.0962V17Z",
        fill: "currentColor"
    })),
    format_align_center: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M3.5 20.5V19H20.5V20.5H3.5ZM7.5 16.625V15.125H16.5V16.625H7.5ZM3.5 12.75V11.25H20.5V12.75H3.5ZM7.5 8.875V7.375H16.5V8.875H7.5ZM3.5 5V3.5H20.5V5H3.5Z",
        fill: "currentColor"
    })),
    format_align_left: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M3.5 20.5V19H20.5V20.5H3.5ZM3.5 16.625V15.125H14.5V16.625H3.5ZM3.5 12.75V11.25H20.5V12.75H3.5ZM3.5 8.875V7.375H14.5V8.875H3.5ZM3.5 5V3.5H20.5V5H3.5Z",
        fill: "currentColor"
    })),
    format_align_right: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M3.5 5V3.5H20.5V5H3.5ZM9.5 8.875V7.375H20.5V8.875H9.5ZM3.5 12.75V11.25H20.5V12.75H3.5ZM9.5 16.625V15.125H20.5V16.625H9.5ZM3.5 20.5V19H20.5V20.5H3.5Z",
        fill: "currentColor"
    })),
    add_row: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M4.025 10.2077C4.375 9.85775 4.80258 9.68275 5.30775 9.68275H6.5V11.1827H5.30775C5.21792 11.1827 5.14417 11.2116 5.0865 11.2693C5.02883 11.3269 5 11.4007 5 11.4905V16.1923C5 16.2821 5.02883 16.3558 5.0865 16.4135C5.14417 16.4712 5.21792 16.5 5.30775 16.5H18.6923C18.7821 16.5 18.8558 16.4712 18.9135 16.4135C18.9712 16.3558 19 16.2821 19 16.1923V11.4905C19 11.4007 18.9712 11.3269 18.9135 11.2693C18.8558 11.2116 18.7821 11.1827 18.6923 11.1827H17.6923V9.68275H18.6923C19.1974 9.68275 19.625 9.85775 19.975 10.2077C20.325 10.5577 20.5 10.9853 20.5 11.4905V16.1923C20.5 16.6974 20.325 17.125 19.975 17.475C19.625 17.825 19.1974 18 18.6923 18H5.30775C4.80258 18 4.375 17.825 4.025 17.475C3.675 17.125 3.5 16.6974 3.5 16.1923V11.4905C3.5 10.9853 3.675 10.5577 4.025 10.2077Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M11.3848 9.68275V7.5H12.8848V9.68275H15V11.1827H12.8848V13.2307H11.3848V11.1827H9.26925V9.68275H11.3848Z",
        fill: "currentColor"
    })),
    add_column: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.70775 4.025C9.35775 4.375 9.18275 4.80258 9.18275 5.30775V6.5H10.6827V5.30775C10.6827 5.21792 10.7116 5.14417 10.7693 5.0865C10.8269 5.02883 10.9007 5 10.9905 5H15.6923C15.7821 5 15.8558 5.02883 15.9135 5.0865C15.9712 5.14417 16 5.21792 16 5.30775V18.6923C16 18.7821 15.9712 18.8558 15.9135 18.9135C15.8558 18.9712 15.7821 19 15.6923 19H10.9905C10.9007 19 10.8269 18.9712 10.7693 18.9135C10.7116 18.8558 10.6827 18.7821 10.6827 18.6923V17.6923H9.18275V18.6923C9.18275 19.1974 9.35775 19.625 9.70775 19.975C10.0577 20.325 10.4853 20.5 10.9905 20.5H15.6923C16.1974 20.5 16.625 20.325 16.975 19.975C17.325 19.625 17.5 19.1974 17.5 18.6923V5.30775C17.5 4.80258 17.325 4.375 16.975 4.025C16.625 3.675 16.1974 3.5 15.6923 3.5H10.9905C10.4853 3.5 10.0577 3.675 9.70775 4.025Z",
        fill: "currentColor"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M9.18275 11.3848H7V12.8848H9.18275V15H10.6827V12.8848H12.7307V11.3848H10.6827V9.26925H9.18275V11.3848Z",
        fill: "currentColor"
    })),
    insert_col_left: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M13.0001 20.1152H8.67713H8.75388H8.69238H13.0001ZM7.19238 19.8075C7.19238 20.3127 7.36738 20.7402 7.71738 21.0902C8.06738 21.4402 8.49497 21.6152 9.00013 21.6152H12.6924C13.1975 21.6152 13.6251 21.4402 13.9751 21.0902C14.3251 20.7402 14.5001 20.3127 14.5001 19.8075V10.423H13.0001V19.8075C13.0001 19.8973 12.9713 19.9711 12.9136 20.0287C12.856 20.0864 12.7822 20.1152 12.6924 20.1152H9.00013C8.9103 20.1152 8.83655 20.0864 8.77888 20.0287C8.72122 19.9711 8.69238 19.8973 8.69238 19.8075V4.69223C8.26422 4.74357 7.90722 4.93299 7.62138 5.26048C7.33538 5.58798 7.19238 5.97548 7.19238 6.42298V19.8075ZM13.0001 2.49998V4.61523H10.8846V6.11523H13.0001V8.23073H14.5001V6.11523H16.6154V4.61523H14.5001V2.49998H13.0001Z",
        fill: "currentColor"
    })),
    insert_row_above: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M20.1152 9.99987V14.3229V14.2461V14.3076V9.99987ZM19.8075 15.8076C20.3127 15.8076 20.7402 15.6326 21.0902 15.2826C21.4402 14.9326 21.6152 14.505 21.6152 13.9999V10.3076C21.6152 9.80245 21.4402 9.37487 21.0902 9.02487C20.7402 8.67487 20.3127 8.49987 19.8075 8.49987H10.423V9.99987H19.8075C19.8973 9.99987 19.9711 10.0287 20.0287 10.0864C20.0864 10.144 20.1152 10.2178 20.1152 10.3076V13.9999C20.1152 14.0897 20.0864 14.1635 20.0287 14.2211C19.9711 14.2788 19.8973 14.3076 19.8075 14.3076H4.69223C4.74357 14.7358 4.93299 15.0928 5.26048 15.3786C5.58798 15.6646 5.97548 15.8076 6.42298 15.8076H19.8075ZM2.49998 9.99987H4.61523V12.1154H6.11523V9.99987H8.23073V8.49987H6.11523V6.38462H4.61523V8.49987H2.49998V9.99987Z",
        fill: "currentColor"
    })),
    insert_row_below: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M20.1152 14.1924V9.86939V9.94614V9.88464V14.1924ZM19.8075 8.38464C20.3127 8.38464 20.7402 8.55964 21.0902 8.90964C21.4402 9.25964 21.6152 9.68723 21.6152 10.1924V13.8846C21.6152 14.3898 21.4402 14.8174 21.0902 15.1674C20.7402 15.5174 20.3127 15.6924 19.8075 15.6924H10.423V14.1924H19.8075C19.8973 14.1924 19.9711 14.1636 20.0287 14.1059C20.0864 14.0482 20.1152 13.9745 20.1152 13.8846V10.1924C20.1152 10.1026 20.0864 10.0288 20.0287 9.97114C19.9711 9.91348 19.8973 9.88464 19.8075 9.88464H4.69223C4.74357 9.45648 4.93299 9.09948 5.26048 8.81364C5.58798 8.52764 5.97548 8.38464 6.42298 8.38464H19.8075ZM2.49998 14.1924H4.61523V12.0769H6.11523V14.1924H8.23073V15.6924H6.11523V17.8076H4.61523V15.6924H2.49998V14.1924Z",
        fill: "currentColor"
    })),
    insert_col_right: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M10.8075 20.1152H15.1305H15.0537H15.1152H10.8075ZM16.6152 19.8075C16.6152 20.3127 16.4402 20.7402 16.0902 21.0902C15.7402 21.4402 15.3127 21.6152 14.8075 21.6152H11.1152C10.6101 21.6152 10.1825 21.4402 9.83248 21.0902C9.48248 20.7402 9.30748 20.3127 9.30748 19.8075V10.423H10.8075V19.8075C10.8075 19.8973 10.8363 19.9711 10.894 20.0287C10.9517 20.0864 11.0254 20.1152 11.1152 20.1152H14.8075C14.8973 20.1152 14.9711 20.0864 15.0287 20.0287C15.0864 19.9711 15.1152 19.8973 15.1152 19.8075V4.69223C15.5434 4.74357 15.9004 4.93299 16.1862 5.26048C16.4722 5.58798 16.6152 5.97548 16.6152 6.42298V19.8075ZM10.8075 2.49998V4.61523H12.923V6.11523H10.8075V8.23073H9.30748V6.11523H7.19223V4.61523H9.30748V2.49998H10.8075Z",
        fill: "currentColor"
    })),
    check: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("path", {
        d: "M9.54983 17.6537L4.21533 12.3192L5.28433 11.25L9.54983 15.5155L18.7153 6.34998L19.7843 7.41923L9.54983 17.6537Z",
        fill: "currentColor"
    }))
};





const $68f4df690d79ceb0$var$LexicalProvider = ({ children: children })=>{
    const rootEditor = (0, $0a163704d09ac3e9$export$329730cc601f60)((0, $5a7e051e41645429$export$1224068c50c179e8));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $3ee369f135efbd55$export$a7eef1ce2651a334), {
        initialEditor: rootEditor
    }, children);
};
const $68f4df690d79ceb0$var$RichTextEditor = ()=>{
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    const setContentEditableRef = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $5a7e051e41645429$export$276eaa1d26354af6));
    const setEditorRootWrapperElement = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $5a7e051e41645429$export$bbe0055b1b3bac82));
    const onRef = (el)=>{
        setEditorRootWrapperElement(el);
        setContentEditableRef(el ? {
            current: el
        } : null);
    };
    const [contentEditableClassName, spellCheck, composerChildren, topAreaChildren, editorWrappers, placeholder, bottomAreaChildren] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $5a7e051e41645429$export$3bb9950b3162bfb8), (0, $5a7e051e41645429$export$f59a16022f9259bc), (0, $5a7e051e41645429$export$400fce55e37924dc), (0, $5a7e051e41645429$export$2e1af8e29683a3bf), (0, $5a7e051e41645429$export$a35fdf2ea45d077c), (0, $5a7e051e41645429$export$a6367416e8cdc2d3), (0, $5a7e051e41645429$export$9384cdc215a3fb1e));
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, topAreaChildren.map((Child, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Child, {
            key: index
        })), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($68f4df690d79ceb0$var$RenderRecursiveWrappers, {
        wrappers: editorWrappers
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).rootContentEditableWrapper, "mdxeditor-root-contenteditable")
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $0c3e62e220668ac1$export$26ad95729aab2c7a), {
        contentEditable: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            ref: onRef,
            className: "mdxeditor-contenteditable-wrapper"
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $a04f6a7c3553d076$export$15d656b6f5aa1ba8), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).contentEditable, contentEditableClassName),
            ariaLabel: t("contentArea.editableMarkdown", "editable markdown"),
            spellCheck: spellCheck
        })),
        placeholder: /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))((0, $fa9f79213ccb855a$export$2e2bcd8739ae039).contentEditable, (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).placeholder, contentEditableClassName)
        }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("p", null, placeholder)),
        ErrorBoundary: (0, $e03e38c0e008fd9d$export$a8147b707c252e29)
    }))), composerChildren.map((Child, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Child, {
            key: index
        })), bottomAreaChildren.map((Child, index)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Child, {
            key: index
        })));
};
const $68f4df690d79ceb0$var$DEFAULT_MARKDOWN_OPTIONS = {
    listItemIndent: "one"
};
const $68f4df690d79ceb0$var$defaultIconComponentFor = (name)=>{
    return (0, $ce8295ee50d4891f$export$c319033752546ed5)[name];
};
function $68f4df690d79ceb0$var$defaultTranslation(key, defaultValue, interpolations = {}) {
    let value = defaultValue;
    for (const [k, v] of Object.entries(interpolations))value = value.replaceAll(`{{${k}}}`, String(v));
    return value;
}
const $68f4df690d79ceb0$var$RenderRecursiveWrappers = ({ wrappers: wrappers, children: children })=>{
    if (wrappers.length === 0) return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).Fragment, null, children);
    const Wrapper = wrappers[0];
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement(Wrapper, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($68f4df690d79ceb0$var$RenderRecursiveWrappers, {
        wrappers: wrappers.slice(1)
    }, children));
};
const $68f4df690d79ceb0$var$EditorRootElement = ({ children: children, className: className, overlayContainer: overlayContainer })=>{
    const editorRootElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    const wrapperElementRef = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    const setEditorRootElementRef = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $5a7e051e41645429$export$48bc1afe38b0f854));
    const setEditorWrapperElementRef = (0, $0a163704d09ac3e9$export$595f49c26314e555)((0, $5a7e051e41645429$export$f3a508116d36fbb8));
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        const popupContainer = document.createElement("div");
        popupContainer.classList.add("mdxeditor-popup-container", (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).editorRoot, (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).popupContainer, ...(className !== null && className !== void 0 ? className : "").trim().split(" ").filter(Boolean));
        const container = overlayContainer !== null && overlayContainer !== void 0 ? overlayContainer : document.body;
        container.appendChild(popupContainer);
        editorRootElementRef.current = popupContainer;
        setEditorRootElementRef(editorRootElementRef);
        setEditorWrapperElementRef(wrapperElementRef);
        return ()=>{
            popupContainer.remove();
        };
    }, [
        className,
        editorRootElementRef,
        overlayContainer,
        setEditorRootElementRef,
        setEditorWrapperElementRef
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($039fe4ac9c9107fb$exports)))("mdxeditor", (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).editorRoot, (0, $fa9f79213ccb855a$export$2e2bcd8739ae039).editorWrapper, className),
        ref: wrapperElementRef
    }, children);
};
function $68f4df690d79ceb0$var$createMethods(realm) {
    return {
        getMarkdown: ()=>{
            const viewMode = realm.getValue((0, $5a7e051e41645429$export$a65e0fe1b8d07b08));
            if (viewMode === "source" || viewMode === "diff") return realm.getValue((0, $5a7e051e41645429$export$db45a26e26d2433c));
            return realm.getValue((0, $5a7e051e41645429$export$15fbbcd8af87566a));
        },
        setMarkdown: (markdown)=>{
            realm.pub((0, $5a7e051e41645429$export$b7bf079bbabb7499), markdown);
        },
        insertMarkdown: (markdown)=>{
            realm.pub((0, $5a7e051e41645429$export$2f89b64ed7c4dd38), markdown);
        },
        focus: (callbackFn, opts)=>{
            var _a;
            (_a = realm.getValue((0, $5a7e051e41645429$export$1224068c50c179e8))) == null || _a.focus(callbackFn, opts);
        },
        getContentEditableHTML: ()=>{
            var _a;
            var _ref;
            return (_ref = (_a = realm.getValue((0, $5a7e051e41645429$export$276eaa1d26354af6))) == null ? void 0 : _a.current.innerHTML) !== null && _ref !== void 0 ? _ref : "";
        },
        getSelectionMarkdown: ()=>{
            const viewMode = realm.getValue((0, $5a7e051e41645429$export$a65e0fe1b8d07b08));
            if (viewMode === "source" || viewMode === "diff") return "";
            const activeEditor = realm.getValue((0, $5a7e051e41645429$export$e02bd6a7b04ae431));
            if (!activeEditor) return "";
            const visitors = realm.getValue((0, $5a7e051e41645429$export$991b374d185bab8d));
            const toMarkdownExtensions = realm.getValue((0, $5a7e051e41645429$export$732b150dcf602c0d));
            const toMarkdownOptions = realm.getValue((0, $5a7e051e41645429$export$f6ad78facb90fcf8));
            const jsxComponentDescriptors = realm.getValue((0, $5a7e051e41645429$export$f4f33684797bd01d));
            const jsxIsAvailable = realm.getValue((0, $5a7e051e41645429$export$88d0810293b8762a));
            return (0, $4d17661fb36fa8e3$export$8456885e4de2d8bf)(activeEditor, {
                visitors: visitors,
                toMarkdownExtensions: toMarkdownExtensions,
                toMarkdownOptions: toMarkdownOptions,
                jsxComponentDescriptors: jsxComponentDescriptors,
                jsxIsAvailable: jsxIsAvailable
            });
        }
    };
}
const $68f4df690d79ceb0$var$Methods = ({ onReady: onReady, onDispose: onDispose })=>{
    const realm = (0, $0a163704d09ac3e9$export$3f9890b0f4413ba6)();
    const methods = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>$68f4df690d79ceb0$var$createMethods(realm), [
        realm
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useLayoutEffect(()=>{
        onReady(methods);
        return ()=>{
            onDispose(methods);
        };
    }, [
        methods,
        onDispose,
        onReady
    ]);
    return null;
};
const $68f4df690d79ceb0$export$6330e7bc4796f134 = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).forwardRef((props, ref)=>{
    const realmMethods = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    const replayingRealmMethods = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(null);
    const pendingMethodCalls = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef([]);
    const preReadyMarkdown = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useRef(props.trim === false ? props.markdown : props.markdown.trim());
    const callWhenReady = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((call)=>{
        const methods = realmMethods.current;
        if (methods && replayingRealmMethods.current === null) call(methods);
        else pendingMethodCalls.current.push(call);
    }, []);
    const publicMethods = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useMemo(()=>({
            getMarkdown: ()=>{
                var _a;
                var _ref;
                return (_ref = (_a = realmMethods.current) == null ? void 0 : _a.getMarkdown()) !== null && _ref !== void 0 ? _ref : preReadyMarkdown.current;
            },
            setMarkdown: (markdown)=>{
                preReadyMarkdown.current = markdown;
                callWhenReady((methods)=>{
                    methods.setMarkdown(markdown);
                });
            },
            insertMarkdown: (markdown)=>{
                callWhenReady((methods)=>{
                    methods.insertMarkdown(markdown);
                });
            },
            focus: (callbackFn, opts)=>{
                callWhenReady((methods)=>{
                    methods.focus(callbackFn, opts);
                });
            },
            getContentEditableHTML: ()=>{
                var _a;
                var _ref;
                return (_ref = (_a = realmMethods.current) == null ? void 0 : _a.getContentEditableHTML()) !== null && _ref !== void 0 ? _ref : "";
            },
            getSelectionMarkdown: ()=>{
                var _a;
                var _ref;
                return (_ref = (_a = realmMethods.current) == null ? void 0 : _a.getSelectionMarkdown()) !== null && _ref !== void 0 ? _ref : "";
            }
        }), [
        callWhenReady
    ]);
    const attachRealmMethods = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((methods)=>{
        realmMethods.current = methods;
        if (replayingRealmMethods.current === methods) return;
        if (pendingMethodCalls.current.length === 0) {
            preReadyMarkdown.current = methods.getMarkdown();
            return;
        }
        replayingRealmMethods.current = methods;
        const replayNext = ()=>{
            if (realmMethods.current !== methods) {
                if (replayingRealmMethods.current === methods) replayingRealmMethods.current = null;
                return;
            }
            const call = pendingMethodCalls.current.shift();
            if (!call) {
                replayingRealmMethods.current = null;
                preReadyMarkdown.current = methods.getMarkdown();
                return;
            }
            call(methods);
            queueMicrotask(replayNext);
        };
        replayNext();
    }, []);
    const detachRealmMethods = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useCallback((methods)=>{
        if (realmMethods.current === methods) {
            preReadyMarkdown.current = methods.getMarkdown();
            realmMethods.current = null;
        }
    }, []);
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useImperativeHandle(ref, ()=>publicMethods, [
        publicMethods
    ]);
    var _props_contentEditableClassName, _props_spellCheck, _props_onChange, _props_onBlur, _props_toMarkdownOptions, _props_autoFocus, _props_placeholder, _props_iconComponentFor, _props_suppressHtmlProcessing, _props_onError, _props_translation, _props_trim, _props_suppressSharedHistory, _props_additionalLexicalNodes, _props_lexicalEditorNamespace, _props_plugins;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $180ae8514eec30ee$export$9872004391793606), {
        plugins: [
            (0, $5a7e051e41645429$export$71ab138dd170c35)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                contentEditableClassName: (_props_contentEditableClassName = props.contentEditableClassName) !== null && _props_contentEditableClassName !== void 0 ? _props_contentEditableClassName : "",
                spellCheck: (_props_spellCheck = props.spellCheck) !== null && _props_spellCheck !== void 0 ? _props_spellCheck : true,
                initialMarkdown: props.markdown,
                onChange: (_props_onChange = props.onChange) !== null && _props_onChange !== void 0 ? _props_onChange : (0, $0bde9de2375dfc26$export$8793edee2d425525),
                onBlur: (_props_onBlur = props.onBlur) !== null && _props_onBlur !== void 0 ? _props_onBlur : (0, $0bde9de2375dfc26$export$8793edee2d425525),
                toMarkdownOptions: (_props_toMarkdownOptions = props.toMarkdownOptions) !== null && _props_toMarkdownOptions !== void 0 ? _props_toMarkdownOptions : $68f4df690d79ceb0$var$DEFAULT_MARKDOWN_OPTIONS,
                autoFocus: (_props_autoFocus = props.autoFocus) !== null && _props_autoFocus !== void 0 ? _props_autoFocus : false,
                placeholder: (_props_placeholder = props.placeholder) !== null && _props_placeholder !== void 0 ? _props_placeholder : "",
                readOnly: Boolean(props.readOnly),
                iconComponentFor: (_props_iconComponentFor = props.iconComponentFor) !== null && _props_iconComponentFor !== void 0 ? _props_iconComponentFor : $68f4df690d79ceb0$var$defaultIconComponentFor,
                suppressHtmlProcessing: (_props_suppressHtmlProcessing = props.suppressHtmlProcessing) !== null && _props_suppressHtmlProcessing !== void 0 ? _props_suppressHtmlProcessing : false,
                onError: (_props_onError = props.onError) !== null && _props_onError !== void 0 ? _props_onError : (0, $0bde9de2375dfc26$export$8793edee2d425525),
                translation: (_props_translation = props.translation) !== null && _props_translation !== void 0 ? _props_translation : $68f4df690d79ceb0$var$defaultTranslation,
                trim: (_props_trim = props.trim) !== null && _props_trim !== void 0 ? _props_trim : true,
                lexicalTheme: props.lexicalTheme
            }, "editorState" in props ? {
                editorState: props.editorState
            } : {}), {
                suppressSharedHistory: (_props_suppressSharedHistory = props.suppressSharedHistory) !== null && _props_suppressSharedHistory !== void 0 ? _props_suppressSharedHistory : false,
                additionalLexicalNodes: (_props_additionalLexicalNodes = props.additionalLexicalNodes) !== null && _props_additionalLexicalNodes !== void 0 ? _props_additionalLexicalNodes : [],
                lexicalEditorNamespace: (_props_lexicalEditorNamespace = props.lexicalEditorNamespace) !== null && _props_lexicalEditorNamespace !== void 0 ? _props_lexicalEditorNamespace : "MDXEditor"
            })),
            ...(_props_plugins = props.plugins) !== null && _props_plugins !== void 0 ? _props_plugins : []
        ]
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($68f4df690d79ceb0$var$EditorRootElement, {
        className: props.className,
        overlayContainer: props.overlayContainer
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($68f4df690d79ceb0$var$LexicalProvider, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($68f4df690d79ceb0$var$RichTextEditor, null))), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement($68f4df690d79ceb0$var$Methods, {
        onReady: attachRealmMethods,
        onDispose: detachRealmMethods
    }));
});



const $c1ad9057f9f280a8$export$e7daf08fc9cefccb = {
    testNode: "blockquote",
    visitNode ({ actions: actions }) {
        actions.addAndStepInto((0, $cc8bb3cdc37e8788$export$b8120bbdf1338c27)());
    }
};



const $0dcce036fb9dfc07$export$b01837ce5fef5acb = {
    testLexicalNode: (0, $cc8bb3cdc37e8788$export$1c183570990c020a),
    visitLexicalNode: ({ actions: actions })=>{
        actions.addAndStepInto("blockquote");
    }
};




const $5c7fc33ecfc7921c$export$d3385757f5cb9f3a = (0, $180ae8514eec30ee$export$a1bf852fe7c1a323)({
    init (realm) {
        realm.pubIn({
            [(0, $5a7e051e41645429$export$ffc48b904d2782f7)]: "quote",
            [(0, $5a7e051e41645429$export$bab06f5ebfbf5c23)]: (0, $c1ad9057f9f280a8$export$e7daf08fc9cefccb),
            [(0, $5a7e051e41645429$export$7544518b8e31b27e)]: (0, $cc8bb3cdc37e8788$export$c64d7b2153096538),
            [(0, $5a7e051e41645429$export$4c7dc64aa0c7faf)]: (0, $0dcce036fb9dfc07$export$b01837ce5fef5acb)
        });
    }
});




var $7fPBF = parcelRequire("7fPBF");


const $a38ad904dc93d3b3$export$77c877574d1b44d0 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)(()=>null);
const $a38ad904dc93d3b3$export$984c38d0b1cdc108 = (0, $0a163704d09ac3e9$export$f6f0c3fe4ec306ea)("");
const $a38ad904dc93d3b3$var$DEFAULT_TOOLBAR_CONTENTS = ()=>{
    return "This is an empty toolbar. Pass `{toolbarContents: () => { return <>toolbar components</> }}` to the toolbarPlugin to customize it.";
};
const $a38ad904dc93d3b3$export$2235d7d328f4404b = (0, $180ae8514eec30ee$export$a1bf852fe7c1a323)({
    init (realm, params) {
        const toolbarPositionSymbol = (params == null ? void 0 : params.toolbarPosition) === "bottom" ? (0, $5a7e051e41645429$export$e7146217b130b170) : (0, $5a7e051e41645429$export$b3a108edd2bc7739);
        var _ref, _ref1;
        realm.pubIn({
            [$a38ad904dc93d3b3$export$77c877574d1b44d0]: (_ref = params == null ? void 0 : params.toolbarContents) !== null && _ref !== void 0 ? _ref : $a38ad904dc93d3b3$var$DEFAULT_TOOLBAR_CONTENTS,
            [$a38ad904dc93d3b3$export$984c38d0b1cdc108]: (_ref1 = params == null ? void 0 : params.toolbarClassName) !== null && _ref1 !== void 0 ? _ref1 : "",
            [toolbarPositionSymbol]: ()=>{
                const [toolbarContents, readOnly, toolbarClassName] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)($a38ad904dc93d3b3$export$77c877574d1b44d0, (0, $5a7e051e41645429$export$73e7ec35cfb5ca78), $a38ad904dc93d3b3$export$984c38d0b1cdc108);
                return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5f22da7309bc91a3$export$be92b6f5f03c0fe9), {
                    className: toolbarClassName,
                    readOnly: readOnly
                }, toolbarContents());
            }
        });
    },
    update (realm, params) {
        var _ref;
        realm.pub($a38ad904dc93d3b3$export$77c877574d1b44d0, (_ref = params == null ? void 0 : params.toolbarContents) !== null && _ref !== void 0 ? _ref : $a38ad904dc93d3b3$var$DEFAULT_TOOLBAR_CONTENTS);
        var _ref1;
        realm.pub($a38ad904dc93d3b3$export$984c38d0b1cdc108, (_ref1 = params == null ? void 0 : params.toolbarClassName) !== null && _ref1 !== void 0 ? _ref1 : "");
    }
});





var $7fPBF = parcelRequire("7fPBF");



const $cfed9435cadd5915$export$e85559427f111ae6 = ()=>{
    const [iconComponentFor, activeEditor] = (0, $0a163704d09ac3e9$export$42d9b6877111703c)((0, $5a7e051e41645429$export$4fd464b2b09e1c4d), (0, $5a7e051e41645429$export$e02bd6a7b04ae431));
    const [canUndo, setCanUndo] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const [canRedo, setCanRedo] = (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useState(false);
    const t = (0, $5a7e051e41645429$export$9fc83ad70ead8663)();
    (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).useEffect(()=>{
        if (activeEditor) return (0, $3e88191b87395c2e$export$d64d64f541cc1835)(activeEditor.registerCommand((0, $3e88191b87395c2e$export$9fd9dd31dd6ebdf5), (payload)=>{
            setCanUndo(payload);
            return false;
        }, (0, $3e88191b87395c2e$export$6afdf194f304e546)), activeEditor.registerCommand((0, $3e88191b87395c2e$export$e36aacf84f559bb3), (payload)=>{
            setCanRedo(payload);
            return false;
        }, (0, $3e88191b87395c2e$export$6afdf194f304e546)));
    }, [
        activeEditor
    ]);
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($7fPBF))).createElement((0, $5f22da7309bc91a3$export$12058739e3b8fa5e), {
        items: [
            {
                title: t("toolbar.undo", "Undo {{shortcut}}", {
                    shortcut: (0, $b735d1bc59b95bee$export$d093bd80dddd0842) ? "\u2318Z" : "Ctrl+Z"
                }),
                disabled: !canUndo,
                contents: iconComponentFor("undo"),
                active: false,
                onChange: ()=>activeEditor == null ? void 0 : activeEditor.dispatchCommand((0, $3e88191b87395c2e$export$34722a4946cb641e), void 0)
            },
            {
                title: t("toolbar.redo", "Redo {{shortcut}}", {
                    shortcut: (0, $b735d1bc59b95bee$export$d093bd80dddd0842) ? "\u2318Y" : "Ctrl+Y"
                }),
                disabled: !canRedo,
                contents: iconComponentFor("redo"),
                active: false,
                onChange: ()=>activeEditor == null ? void 0 : activeEditor.dispatchCommand((0, $3e88191b87395c2e$export$8c4a0748d31d9941), void 0)
            }
        ]
    });
};







var $7fPBF = parcelRequire("7fPBF");
var $5cc3ec176bbf7015$export$14faa19a0f3bbeb2 = /*#__PURE__*/ function(Theme) {
    Theme[Theme["LIGHT"] = 0] = "LIGHT";
    Theme[Theme["DARK"] = 1] = "DARK";
    return Theme;
}({});
function $5cc3ec176bbf7015$export$2e2bcd8739ae039() {
    const [mode, setMode] = (0, $7fPBF.useState)(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? "dark" : "light");
    (0, $7fPBF.useEffect)(()=>{
        const modeMe = (e)=>{
            setMode(e.matches ? "dark" : "light");
        };
        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', modeMe);
        return window.matchMedia('(prefers-color-scheme: dark)').removeEventListener('change', modeMe);
    }, []);
    return mode === "light" ? 0 : 1;
}




function $e9d4fad799ff15f3$export$567c45f232a0442(body) {
    if (typeof body === 'string') return body.length > 0 ? body : null;
    if (!body || typeof body !== 'object') return null;
    const payload = body;
    var _payload_result;
    const candidate = (_payload_result = payload.result) !== null && _payload_result !== void 0 ? _payload_result : payload;
    if (typeof candidate === 'string') return candidate.length > 0 ? candidate : null;
    var _candidate_url;
    const url = (_candidate_url = candidate === null || candidate === void 0 ? void 0 : candidate.url) !== null && _candidate_url !== void 0 ? _candidate_url : candidate === null || candidate === void 0 ? void 0 : candidate.videoURL;
    return typeof url === 'string' && url.length > 0 ? url : null;
}
function $e9d4fad799ff15f3$export$e3dc061cc0656a85(body) {
    if (!body || typeof body !== 'object') return null;
    const payload = body;
    var _payload_result;
    const candidate = (_payload_result = payload.result) !== null && _payload_result !== void 0 ? _payload_result : payload;
    if (!candidate || typeof candidate !== 'object' || typeof candidate.moduleID !== 'string') return null;
    return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, candidate), {
        completedResourceIDs: Array.isArray(candidate.completedResourceIDs) ? candidate.completedResourceIDs : []
    });
}




const $1b91f8e2aa6bd7e6$var$DESCRIPTION_LIMIT = 300;
function $1b91f8e2aa6bd7e6$export$2e2bcd8739ae039(props) {
    var _props_lesson;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        'lessonEditor',
        'volunteering'
    ]);
    const theme = (0, $5cc3ec176bbf7015$export$2e2bcd8739ae039)();
    const attributes = (_props_lesson = props.lesson) === null || _props_lesson === void 0 ? void 0 : _props_lesson.attributes;
    var _attributes_name;
    const [name, setName] = (0, $7fPBF.useState)((_attributes_name = attributes === null || attributes === void 0 ? void 0 : attributes.name) !== null && _attributes_name !== void 0 ? _attributes_name : '');
    var _attributes_description;
    const [description, setDescription] = (0, $7fPBF.useState)((_attributes_description = attributes === null || attributes === void 0 ? void 0 : attributes.description) !== null && _attributes_description !== void 0 ? _attributes_description : '');
    var _attributes_text;
    const [text, setText] = (0, $7fPBF.useState)((_attributes_text = attributes === null || attributes === void 0 ? void 0 : attributes.text) !== null && _attributes_text !== void 0 ? _attributes_text : '');
    const [videoFile, setVideoFile] = (0, $7fPBF.useState)(null);
    const [thumbnailFile, setThumbnailFile] = (0, $7fPBF.useState)(null);
    const [pickedThumbnailURL, setPickedThumbnailURL] = (0, $7fPBF.useState)(null);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [isPreviewing, setIsPreviewing] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    // The video upload takes over the modal once the Lesson itself is saved, so
    // a long upload reads as progress rather than a stalled save.
    const [uploadingLessonID, setUploadingLessonID] = (0, $7fPBF.useState)(null);
    const [uploadProgress, setUploadProgress] = (0, $7fPBF.useState)(0);
    const [uploadError, setUploadError] = (0, $7fPBF.useState)(null);
    const [isUploadComplete, setIsUploadComplete] = (0, $7fPBF.useState)(false);
    const isUploading = uploadingLessonID !== null;
    var _attributes_video;
    const video = (_attributes_video = attributes === null || attributes === void 0 ? void 0 : attributes.video) !== null && _attributes_video !== void 0 ? _attributes_video : null;
    const isEditing = Boolean(props.lesson);
    // A new Lesson needs its required fields filled in; an existing one needs an
    // actual change to save.
    const meetsRequirements = name.trim().length > 0;
    var _attributes_name1, _attributes_description1, _attributes_text1;
    const hasChanges = name !== ((_attributes_name1 = attributes === null || attributes === void 0 ? void 0 : attributes.name) !== null && _attributes_name1 !== void 0 ? _attributes_name1 : '') || description !== ((_attributes_description1 = attributes === null || attributes === void 0 ? void 0 : attributes.description) !== null && _attributes_description1 !== void 0 ? _attributes_description1 : '') || text !== ((_attributes_text1 = attributes === null || attributes === void 0 ? void 0 : attributes.text) !== null && _attributes_text1 !== void 0 ? _attributes_text1 : '') || videoFile !== null || thumbnailFile !== null;
    const canSave = meetsRequirements && (!isEditing || hasChanges) && !isSaving;
    // A picked thumbnail previews from a local object URL; an existing video
    // falls back to whatever the API already has.
    (0, $7fPBF.useEffect)(()=>{
        if (!thumbnailFile) {
            setPickedThumbnailURL(null);
            return;
        }
        const objectURL = URL.createObjectURL(thumbnailFile);
        setPickedThumbnailURL(objectURL);
        return ()=>{
            URL.revokeObjectURL(objectURL);
        };
    }, [
        thumbnailFile
    ]);
    const previewVideo = async ()=>{
        if (!video || video.type === 'PROCESSING' || video.type === 'FAILED') return;
        // Opened up front so the tab is tied to the click rather than to the
        // response, which a popup blocker would refuse.
        const previewTab = window.open('', '_blank');
        if (video.type === 'HOSTED') {
            if (previewTab) previewTab.location.href = video.url;
            return;
        }
        if (!auth.churchId || !props.lesson) {
            previewTab === null || previewTab === void 0 ? void 0 : previewTab.close();
            setError(t('volunteering:errors.missingChurch'));
            return;
        }
        setIsPreviewing(true);
        setError(null);
        try {
            const response = await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).fetchVideoURL(auth.churchId, props.moduleID, props.lesson.id, auth);
            const url = response.error ? null : (0, $e9d4fad799ff15f3$export$567c45f232a0442)(response.body);
            if (!url) {
                previewTab === null || previewTab === void 0 ? void 0 : previewTab.close();
                setError(response.error || t('previewFailed'));
                return;
            }
            if (previewTab) previewTab.location.href = url;
        } finally{
            setIsPreviewing(false);
        }
    };
    const uploadVideo = async (lessonID)=>{
        var _uploadTargetResponse_body;
        if (!auth.churchId || !videoFile) return;
        setUploadProgress(0);
        setUploadError(null);
        setIsUploadComplete(false);
        const uploadTargetResponse = await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).createVideoUploadTarget(auth.churchId, props.moduleID, lessonID, auth);
        if (!((_uploadTargetResponse_body = uploadTargetResponse.body) === null || _uploadTargetResponse_body === void 0 ? void 0 : _uploadTargetResponse_body.url)) {
            setUploadError(uploadTargetResponse.error || t('uploadStartFailed'));
            return;
        }
        const uploadSucceeded = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performSignedPut(uploadTargetResponse.body.url, videoFile, videoFile.type, setUploadProgress);
        if (!uploadSucceeded) {
            setUploadError(t('uploadFailed'));
            return;
        }
        setIsUploadComplete(true);
    };
    const finishUpload = ()=>{
        setUploadingLessonID(null);
        props.onSaved();
    };
    const saveLesson = async ()=>{
        if (!auth.churchId) {
            setError(t('volunteering:errors.missingChurch'));
            return;
        }
        setIsSaving(true);
        setError(null);
        try {
            var _response_body_result, _response_body, _props_lesson;
            var _video_thumbnailURL;
            let thumbnailURL = (_video_thumbnailURL = video === null || video === void 0 ? void 0 : video.thumbnailURL) !== null && _video_thumbnailURL !== void 0 ? _video_thumbnailURL : null;
            if (thumbnailFile) {
                const thumbnailTargetResponse = await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).createThumbnailUploadTarget(auth.churchId, thumbnailFile.type || 'application/octet-stream', thumbnailFile.size, auth);
                if (!thumbnailTargetResponse.body) {
                    setError(thumbnailTargetResponse.error || t('thumbnailTargetFailed'));
                    setIsSaving(false);
                    return;
                }
                const thumbnailUploaded = await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performSignedPost({
                    url: thumbnailTargetResponse.body.url,
                    fields: thumbnailTargetResponse.body.fields
                }, thumbnailFile, thumbnailFile.type);
                if (!thumbnailUploaded) {
                    setError(t('thumbnailUploadFailed'));
                    setIsSaving(false);
                    return;
                }
                thumbnailURL = thumbnailTargetResponse.body.assetURL;
            }
            const savedAttributes = {
                name: name.trim(),
                description: description.trim() || null,
                text: text.trim() || null,
                // A newly picked video sends only the type; the rest is filled in as
                // the upload progresses. An existing one is carried across untouched
                // apart from a thumbnail that was just replaced.
                video: videoFile ? {
                    type: 'PROCESSING',
                    thumbnailURL: thumbnailURL
                } : video ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, video), {
                    thumbnailURL: thumbnailURL
                }) : null
            };
            const response = props.lesson ? await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).updateTrainingResource(auth.churchId, props.moduleID, props.lesson.id, savedAttributes, auth) : await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).createTrainingResource(auth.churchId, props.moduleID, savedAttributes, auth);
            var _response_body_result_id;
            // An update already knows the ID, so it doesn't depend on the response
            // echoing the Lesson back.
            const savedLessonID = (_response_body_result_id = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : (_response_body_result = _response_body.result) === null || _response_body_result === void 0 ? void 0 : _response_body_result.id) !== null && _response_body_result_id !== void 0 ? _response_body_result_id : (_props_lesson = props.lesson) === null || _props_lesson === void 0 ? void 0 : _props_lesson.id;
            if (response.error || !savedLessonID) {
                setError(response.error || t('saveFailed'));
                setIsSaving(false);
                return;
            }
            if (videoFile) {
                setUploadingLessonID(savedLessonID);
                setIsSaving(false);
                uploadVideo(savedLessonID);
                return;
            }
            props.onSaved();
        } finally{
            setIsSaving(false);
        }
    };
    var _videoFile_name, _ref;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "lesson-editor-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "lesson-editor-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            // Closing mid-upload would abandon the transfer.
                            disabled: isSaving || isUploading && !isUploadComplete && !uploadError,
                            onClick: isUploading ? finishUpload : props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: t('volunteering:common.close')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: isUploading ? isUploadComplete ? t('uploadedTitle') : t('uploadingTitle') : isEditing ? t('editTitle') : t('newTitle')
                        }),
                        isUploading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "header-control-spacer"
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: isSaving ? 'header-control confirm saving' : 'header-control confirm',
                            disabled: !canSave,
                            onClick: ()=>{
                                saveLesson();
                            },
                            children: isSaving ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "header-control-spinner",
                                role: "status",
                                "aria-label": t('savingLabel')
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d5bdfc11cea11cc4$exports))),
                                alt: t('saveLabel')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "body",
                    children: isUploading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1b91f8e2aa6bd7e6$var$VideoUploadScreen, {
                        fileName: (_videoFile_name = videoFile === null || videoFile === void 0 ? void 0 : videoFile.name) !== null && _videoFile_name !== void 0 ? _videoFile_name : t('fallbackFileName'),
                        progress: uploadProgress,
                        isComplete: isUploadComplete,
                        error: uploadError,
                        onRetry: ()=>{
                            uploadVideo(uploadingLessonID);
                        },
                        onDone: finishUpload
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "save-error",
                                children: error
                            }) : null,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "field-container",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "lesson-name",
                                        children: t('titleLabel')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        id: "lesson-name",
                                        type: "text",
                                        value: name,
                                        placeholder: t('titlePlaceholder'),
                                        disabled: isSaving,
                                        onChange: (e)=>setName(e.target.value)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "field-container",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "lesson-description",
                                        children: t('descriptionLabel')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                        id: "lesson-description",
                                        rows: 2,
                                        maxLength: $1b91f8e2aa6bd7e6$var$DESCRIPTION_LIMIT,
                                        value: description,
                                        placeholder: t('descriptionPlaceholder'),
                                        onChange: (e)=>setDescription(e.target.value)
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                        className: "caption character-count",
                                        children: [
                                            description.length,
                                            "/",
                                            $1b91f8e2aa6bd7e6$var$DESCRIPTION_LIMIT
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "field-container",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: t('videoLabel')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1b91f8e2aa6bd7e6$var$VideoPanel, {
                                        video: video,
                                        videoFile: videoFile,
                                        thumbnailFile: thumbnailFile,
                                        thumbnailURL: (_ref = pickedThumbnailURL !== null && pickedThumbnailURL !== void 0 ? pickedThumbnailURL : video === null || video === void 0 ? void 0 : video.thumbnailURL) !== null && _ref !== void 0 ? _ref : null,
                                        isSaving: isSaving,
                                        isPreviewing: isPreviewing,
                                        canPreview: isEditing,
                                        onPick: setVideoFile,
                                        onPickThumbnail: setThumbnailFile,
                                        onPreview: ()=>{
                                            previewVideo();
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "field-container",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        htmlFor: "lesson-text",
                                        children: t('textLabel')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        className: "lesson-text-editor",
                                        onKeyDownCapture: $1b91f8e2aa6bd7e6$var$swallowUnderlineShortcut,
                                        onPasteCapture: $1b91f8e2aa6bd7e6$var$scrubUnderlineFromPaste,
                                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68f4df690d79ceb0$export$6330e7bc4796f134), {
                                            markdown: text,
                                            onChange: setText,
                                            // The editor's own toolbar, dialog and table strings, from this
                                            // screen's catalog. Anything not in it keeps the editor's English.
                                            translation: (key, defaultValue, interpolations)=>{
                                                return t(`editor.${key}`, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                                                    defaultValue: defaultValue
                                                }, interpolations));
                                            },
                                            contentEditableClassName: "lesson-text-content",
                                            className: theme === (0, $5cc3ec176bbf7015$export$14faa19a0f3bbeb2).DARK ? 'dark-theme dark-editor' : undefined,
                                            plugins: [
                                                (0, $852daab51b9c6f82$export$d4b3c65d0fac3a8f)(),
                                                (0, $1f3afc91d5cda09c$export$65a8596327f336fa)(),
                                                (0, $5c7fc33ecfc7921c$export$d3385757f5cb9f3a)(),
                                                (0, $2024db92856d5f0d$export$4c1439d109c8788c)(),
                                                (0, $2a1e7a4c7a8785c8$export$5a3ca10fb9b2a633)(),
                                                (0, $2e3a3767bbf962d6$export$d413029ba7c093b7)(),
                                                // imagePlugin({
                                                //   imageUploadHandler: async (file) => {
                                                //     return ""
                                                //   }
                                                // }),
                                                (0, $fff60e14da704f3d$export$2aaa25794affcf21)(),
                                                (0, $a38ad904dc93d3b3$export$2235d7d328f4404b)({
                                                    toolbarContents: ()=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $cfed9435cadd5915$export$e85559427f111ae6), {}),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d99c558b0fe2051a$export$51afbab189e0e951), {
                                                                    options: [
                                                                        'Bold',
                                                                        'Italic'
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3732a83a826f23f5$export$933f3c7e3d0b8adf), {}),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $afa035ce1805b62c$export$83932be8f7500da3), {
                                                                    options: [
                                                                        'bullet',
                                                                        'number'
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $db6c5d95ea524016$export$b8fcacb3451702e8), {}),
                                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $68250d32f3069ffc$export$cff01a9b5cadaafc), {})
                                                            ]
                                                        })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
}
// The same platform split Lexical's own shortcut matcher uses.
const $1b91f8e2aa6bd7e6$var$IS_APPLE = /Mac|iPod|iPhone|iPad/.test(navigator.platform);
// Mirrors Lexical's isUnderline: the command key on its own -- no shift, no
// alt -- plus the U key, falling back to the physical key on layouts that
// report something non-ASCII. Kept exact so nothing else gets swallowed.
function $1b91f8e2aa6bd7e6$var$isUnderlineShortcut(event) {
    const hasCommandKey = $1b91f8e2aa6bd7e6$var$IS_APPLE ? event.metaKey && !event.ctrlKey : event.ctrlKey && !event.metaKey;
    if (!hasCommandKey || event.altKey || event.shiftKey) return false;
    if (event.key.toLowerCase() === 'u') return true;
    const isASCIIKey = event.key.length === 1 && event.key.charCodeAt(0) <= 127;
    return !isASCIIKey && event.code === 'KeyU';
}
// Cheap pre-check, so an ordinary paste is never rewritten.
const $1b91f8e2aa6bd7e6$var$UNDERLINE_HTML_PATTERN = /<u[\s>]|text-decoration[^;"']*underline/i;
// Underline arrives from other apps as a <u> tag or a text-decoration style,
// either of which Lexical turns back into the <u> the shortcut used to produce.
function $1b91f8e2aa6bd7e6$var$stripUnderlineFromHTML(html) {
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    parsed.querySelectorAll('u').forEach((element)=>{
        element.replaceWith(...Array.from(element.childNodes));
    });
    parsed.querySelectorAll('[style]').forEach((element)=>{
        const decoration = element.style.textDecorationLine || element.style.textDecoration;
        if (!decoration.toLowerCase().includes('underline')) return;
        // Only the underline is dropped: a run that's also struck through keeps it.
        const remaining = decoration.split(/\s+/).filter((value)=>value.toLowerCase() !== 'underline').join(' ');
        element.style.removeProperty('text-decoration');
        element.style.removeProperty('text-decoration-line');
        if (remaining) element.style.textDecoration = remaining;
        if (!element.getAttribute('style')) element.removeAttribute('style');
    });
    return parsed.body.innerHTML;
}
// The replayed pastes below, so they pass straight through this handler rather
// than being scrubbed a second time.
const $1b91f8e2aa6bd7e6$var$replayedPastes = new WeakSet();
// The paste is rewritten in the capture phase and replayed, so the editor only
// ever sees markup with the underline already gone.
function $1b91f8e2aa6bd7e6$var$scrubUnderlineFromPaste(event) {
    if ($1b91f8e2aa6bd7e6$var$replayedPastes.has(event.nativeEvent)) return;
    const clipboard = event.clipboardData;
    const html = clipboard.getData('text/html');
    if (!html || !$1b91f8e2aa6bd7e6$var$UNDERLINE_HTML_PATTERN.test(html)) return;
    const contentEditable = event.currentTarget.querySelector('[contenteditable="true"]');
    if (!contentEditable) return;
    event.preventDefault();
    event.stopPropagation();
    const scrubbed = new DataTransfer();
    scrubbed.setData('text/html', $1b91f8e2aa6bd7e6$var$stripUnderlineFromHTML(html));
    scrubbed.setData('text/plain', clipboard.getData('text/plain'));
    // The editor's own clipboard payload is deliberately left out: Lexical reads
    // it in preference to text/html, which would put the underline right back.
    const replay = new ClipboardEvent('paste', {
        bubbles: true,
        cancelable: true,
        clipboardData: scrubbed
    });
    $1b91f8e2aa6bd7e6$var$replayedPastes.add(replay);
    contentEditable.dispatchEvent(replay);
}
// Lexical binds the underline shortcut itself -- it isn't the markdown shortcut
// plugin -- and writes the result as a <u> tag, which this content doesn't
// render. Caught in the capture phase, so the editor's own keydown listener on
// the contenteditable never sees it.
function $1b91f8e2aa6bd7e6$var$swallowUnderlineShortcut(event) {
    if (!$1b91f8e2aa6bd7e6$var$isUnderlineShortcut(event)) return;
    event.preventDefault();
    event.stopPropagation();
}
function $1b91f8e2aa6bd7e6$var$VideoUploadScreen(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('lessonEditor');
    const percent = Math.round(props.progress * 100);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "video-upload-screen",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "video-upload-filename",
                children: props.fileName
            }),
            props.error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "save-error",
                        children: props.error
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "caption",
                        children: t('uploadSavedCaption')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "video-upload-actions",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                className: "video-upload-retry",
                                onClick: props.onRetry,
                                children: t('retryUpload')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                className: "video-upload-done",
                                onClick: props.onDone,
                                children: t('close')
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "video-upload-track",
                        role: "progressbar",
                        "aria-valuemin": 0,
                        "aria-valuemax": 100,
                        "aria-valuenow": props.isComplete ? 100 : percent,
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "video-upload-fill",
                            style: {
                                width: `${props.isComplete ? 100 : percent}%`
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "caption",
                        children: props.isComplete ? t('uploadComplete') : t('uploading', {
                            percent: percent
                        })
                    })
                ]
            })
        ]
    });
}
function $1b91f8e2aa6bd7e6$var$VideoPanel(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('lessonEditor');
    const video = props.video;
    const isPlayable = (video === null || video === void 0 ? void 0 : video.type) === 'EXTERNAL' || (video === null || video === void 0 ? void 0 : video.type) === 'HOSTED';
    const hasVideo = Boolean(video || props.videoFile);
    const videoPicker = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "video-panel-picker",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                id: "lesson-video",
                type: "file",
                accept: "video/*",
                disabled: props.isSaving,
                onChange: (e)=>{
                    var _e_target_files;
                    var _e_target_files_;
                    return props.onPick((_e_target_files_ = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0]) !== null && _e_target_files_ !== void 0 ? _e_target_files_ : null);
                }
            }),
            props.videoFile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: "video-panel-clear",
                disabled: props.isSaving,
                onClick: ()=>props.onPick(null),
                children: video ? t('keepCurrentVideo') : t('clear')
            }) : null
        ]
    });
    const details = props.videoFile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "video-panel-details",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "video-panel-platform",
                children: props.videoFile.name
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "caption",
                children: t('uploadsAfterCreate')
            })
        ]
    }) : video ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "video-panel-details",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "video-panel-platform",
                children: $1b91f8e2aa6bd7e6$var$videoHeadline(video)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "caption video-panel-url",
                children: $1b91f8e2aa6bd7e6$var$videoDetail(video)
            }),
            isPlayable && props.canPreview ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                type: "button",
                className: "video-panel-preview",
                disabled: props.isPreviewing || props.isSaving,
                onClick: props.onPreview,
                children: props.isPreviewing ? t('preparingPreview') : t('previewVideo')
            }) : null
        ]
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
        className: "video-panel-copy",
        children: t('noVideo')
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "video-panel-stack",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: hasVideo ? 'video-panel' : 'video-panel empty',
                children: [
                    details,
                    videoPicker
                ]
            }),
            hasVideo ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "video-panel thumbnail-row",
                children: [
                    props.thumbnailURL ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        className: "video-panel-thumbnail",
                        src: props.thumbnailURL,
                        alt: "",
                        "aria-hidden": "true"
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "video-panel-thumbnail empty",
                        "aria-hidden": "true"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "video-panel-details",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "video-panel-platform",
                                children: t('thumbnailTitle')
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "caption",
                                children: t('thumbnailCaption')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "video-panel-picker",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                id: "lesson-video-thumbnail",
                                type: "file",
                                accept: "image/*",
                                disabled: props.isSaving,
                                onChange: (e)=>{
                                    var _e_target_files;
                                    var _e_target_files_;
                                    return props.onPickThumbnail((_e_target_files_ = (_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0]) !== null && _e_target_files_ !== void 0 ? _e_target_files_ : null);
                                }
                            }),
                            props.thumbnailFile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                className: "video-panel-clear",
                                disabled: props.isSaving,
                                onClick: ()=>props.onPickThumbnail(null),
                                children: (video === null || video === void 0 ? void 0 : video.thumbnailURL) ? t('keepCurrentImage') : t('clear')
                            }) : null
                        ]
                    })
                ]
            }) : null
        ]
    });
}
const $1b91f8e2aa6bd7e6$var$PLATFORM_LABELS = {
    mux: 'Mux'
};
function $1b91f8e2aa6bd7e6$var$videoHeadline(video) {
    switch(video.type){
        case 'PROCESSING':
            return (0, $2Bwgd.default).t('lessonEditor:videoProcessing');
        case 'EXTERNAL':
            return (0, $2Bwgd.default).t('lessonEditor:videoUploaded');
        case 'HOSTED':
            return (0, $2Bwgd.default).t('lessonEditor:videoHosted');
        case 'FAILED':
            return (0, $2Bwgd.default).t('lessonEditor:videoUploadFailed');
    }
}
function $1b91f8e2aa6bd7e6$var$videoDetail(video) {
    switch(video.type){
        case 'PROCESSING':
            var _video_assetID, _ref;
            return (_ref = (_video_assetID = video.assetID) !== null && _video_assetID !== void 0 ? _video_assetID : video.uploadID) !== null && _ref !== void 0 ? _ref : (0, $2Bwgd.default).t('lessonEditor:videoProcessingDetail');
        case 'EXTERNAL':
            return null;
        case 'HOSTED':
            return video.url;
        case 'FAILED':
            return video.reason;
    }
}


var $d66b8b03bf616497$exports = {};
$d66b8b03bf616497$exports = $parcel$resolve("hRLDk");





function $b47e954e55eff3c7$export$2e2bcd8739ae039() {
    var _location_state;
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('trainingModule');
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const pathParams = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const moduleID = pathParams.moduleID;
    var _location_state_module;
    const routedModule = (_location_state_module = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.module) !== null && _location_state_module !== void 0 ? _location_state_module : null;
    // Seeded from navigation state so the header renders immediately; the fetch
    // brings the Lessons with it.
    const { module: module, resources: lessons, loading: loading, hasLoaded: hasLoaded, error: error, refetch: refetch } = (0, $e3a47506f98723a6$export$2e2bcd8739ae039)(moduleID, routedModule);
    // The module itself can come from navigation state, so the Lessons list has
    // its own loading state rather than riding on the page-level one.
    const isLoadingLessons = loading && !hasLoaded;
    const [lessonForEditor, setLessonForEditor] = (0, $7fPBF.useState)(null);
    const [isLessonEditorOpen, setIsLessonEditorOpen] = (0, $7fPBF.useState)(false);
    const [isModuleEditorOpen, setIsModuleEditorOpen] = (0, $7fPBF.useState)(false);
    const openNewLessonEditor = ()=>{
        setLessonForEditor(null);
        setIsLessonEditorOpen(true);
    };
    const closeLessonEditor = ()=>{
        setIsLessonEditorOpen(false);
        window.setTimeout(()=>{
            setLessonForEditor(null);
        }, 200);
    };
    if (!moduleID) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/volunteering/training",
        replace: true
    });
    if (!module && loading && !hasLoaded) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "training-module-page training-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {})
    });
    if (error) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        error: error,
        buttonText: t('retry'),
        buttonAction: ()=>refetch(),
        fullHeight: true
    });
    if (!module) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        error: t('notFound'),
        buttonText: t('backToTraining'),
        buttonAction: ()=>navigate('/volunteering/training'),
        fullHeight: true
    });
    var _module_attributes_description, _lessonForEditor_id;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "training-module-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: module.attributes.name,
                subtitle: (_module_attributes_description = module.attributes.description) !== null && _module_attributes_description !== void 0 ? _module_attributes_description : undefined,
                backLocation: "/volunteering/training",
                links: [
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($a9cdc003ba228dda$exports))),
                        title: t('edit'),
                        onClick: ()=>setIsModuleEditorOpen(true)
                    }
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ef1657690e180529$export$2e2bcd8739ae039), {
                isOpen: isModuleEditorOpen,
                module: module,
                close: ()=>setIsModuleEditorOpen(false),
                onSaved: ()=>{
                    setIsModuleEditorOpen(false);
                    refetch();
                }
            }, `edit-module-${module.id}`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1b91f8e2aa6bd7e6$export$2e2bcd8739ae039), {
                isOpen: isLessonEditorOpen,
                moduleID: moduleID,
                lesson: lessonForEditor,
                close: closeLessonEditor,
                onSaved: ()=>{
                    closeLessonEditor();
                    refetch();
                }
            }, (_lessonForEditor_id = lessonForEditor === null || lessonForEditor === void 0 ? void 0 : lessonForEditor.id) !== null && _lessonForEditor_id !== void 0 ? _lessonForEditor_id : 'lesson-editor'),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                className: "training-lessons",
                children: isLoadingLessons ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "training-state",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                        fullScreen: false
                    })
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        lessons.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "lessons-header",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                    children: t('lessonsHeading')
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                    type: "button",
                                    className: "new-lesson-button",
                                    onClick: openNewLessonEditor,
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                            src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5c0a9c99fa42f0$exports))),
                                            alt: "",
                                            "aria-hidden": "true"
                                        }),
                                        t('newLesson')
                                    ]
                                })
                            ]
                        }) : null,
                        lessons.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($ced971621fdd495b$exports))),
                            title: t('emptyTitle'),
                            error: t('emptyMessage'),
                            buttonText: t('newLesson'),
                            buttonAction: openNewLessonEditor,
                            fullHeight: true
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ol", {
                            className: "lesson-list",
                            children: lessons.map((lesson)=>{
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($b47e954e55eff3c7$var$LessonRow, {
                                    lesson: lesson,
                                    onClick: ()=>{
                                        setLessonForEditor(lesson);
                                        setIsLessonEditorOpen(true);
                                    }
                                }, lesson.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
}
// A video's state is worth surfacing in the list: a still-processing or
// rejected upload isn't something a volunteer can watch yet.
function $b47e954e55eff3c7$var$videoTagLabel(video) {
    switch(video.type){
        case 'PROCESSING':
            return (0, $2Bwgd.default).t('trainingModule:videoProcessing');
        case 'FAILED':
            return (0, $2Bwgd.default).t('trainingModule:videoFailed');
        default:
            return (0, $2Bwgd.default).t('trainingModule:video');
    }
}
function $b47e954e55eff3c7$var$LessonRow(props) {
    const attributes = props.lesson.attributes;
    var _attributes_video;
    const video = (_attributes_video = attributes.video) !== null && _attributes_video !== void 0 ? _attributes_video : null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
            type: "button",
            className: "lesson-row",
            onClick: props.onClick,
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "lesson-thumbnail",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: (video === null || video === void 0 ? void 0 : video.thumbnailURL) || (0, (/*@__PURE__*/$parcel$interopDefault($d66b8b03bf616497$exports))),
                        alt: "",
                        "aria-hidden": "true"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "lesson-body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            children: attributes.name
                        }),
                        attributes.description ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "lesson-description",
                            children: attributes.description
                        }) : null,
                        video ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "lesson-tags",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: video.type === 'FAILED' ? 'lesson-tag failed' : 'lesson-tag',
                                children: $b47e954e55eff3c7$var$videoTagLabel(video)
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
}





var $7fPBF = parcelRequire("7fPBF");



var $2Bwgd = parcelRequire("2Bwgd");





var $7fPBF = parcelRequire("7fPBF");



var $2Bwgd = parcelRequire("2Bwgd");
function $2bcab502c0cbf83d$export$2e2bcd8739ae039(personID) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    const [assignments, setAssignments] = (0, $7fPBF.useState)([]);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [hasLoaded, setHasLoaded] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        var _response_body;
        if (!churchID || !personID) return;
        setLoading(true);
        setError(null);
        const response = await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).fetchVolunteerTrainingAssignments(churchID, personID, auth);
        const results = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.results;
        if (response.error || !results) {
            setError(response.error || (0, $2Bwgd.default).t('volunteering:errors.loadAssignedTraining'));
            setAssignments([]);
        } else setAssignments(results);
        setLoading(false);
        setHasLoaded(true);
    }, [
        churchID,
        personID,
        auth
    ]);
    // A just-created assignment shows immediately, rather than waiting on the
    // refetch behind it. Re-assigning a Module replaces its row instead of
    // doubling it.
    const addAssignment = (0, $7fPBF.useCallback)((bundle)=>{
        setAssignments((currentAssignments)=>[
                ...currentAssignments.filter((existing)=>existing.assignment.moduleID !== bundle.assignment.moduleID),
                bundle
            ]);
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        fetch();
    }, [
        fetch
    ]);
    return {
        assignments: assignments,
        loading: loading,
        hasLoaded: hasLoaded,
        error: error,
        refetch: fetch,
        addAssignment: addAssignment
    };
}







var $7fPBF = parcelRequire("7fPBF");















const $065ca63d8cbb0a9f$var$DEFAULT_DUE_DAYS = 14;
// Matches the slide in index.scss.
const $065ca63d8cbb0a9f$var$STAGE_TRANSITION_MS = 240;
function $065ca63d8cbb0a9f$var$defaultDueDate() {
    const date = new Date();
    date.setDate(date.getDate() + $065ca63d8cbb0a9f$var$DEFAULT_DUE_DAYS);
    return date;
}
// The picker only chooses a day, so the time rides along from whenever the
// modal was opened. Due at the end of that day is what "due Sep 20" means.
function $065ca63d8cbb0a9f$var$endOfDay(date) {
    const endOfDate = new Date(date);
    endOfDate.setHours(23, 59, 59, 999);
    return endOfDate;
}
function $065ca63d8cbb0a9f$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)([
        'assignTraining',
        'volunteering'
    ]);
    const { modules: modules, loading: loading, hasLoaded: hasLoaded, error: loadError, refetch: refetch } = (0, $9202b6e1bfa100e3$export$2e2bcd8739ae039)();
    const [stage, setStage] = (0, $7fPBF.useState)('module');
    const [transition, setTransition] = (0, $7fPBF.useState)(null);
    const [selectedModule, setSelectedModule] = (0, $7fPBF.useState)(null);
    const [dueDate, setDueDate] = (0, $7fPBF.useState)($065ca63d8cbb0a9f$var$defaultDueDate);
    const [notifyOnCompletion, setNotifyOnCompletion] = (0, $7fPBF.useState)(true);
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (!transition) return;
        const timeout = window.setTimeout(()=>setTransition(null), $065ca63d8cbb0a9f$var$STAGE_TRANSITION_MS);
        return ()=>window.clearTimeout(timeout);
    }, [
        transition
    ]);
    const changeStage = (nextStage)=>{
        if (nextStage === stage) return;
        setTransition({
            from: stage,
            direction: nextStage === 'details' ? 'forward' : 'back'
        });
        setStage(nextStage);
        setError(null);
    };
    const sortedModules = [
        ...modules
    ].sort((one, two)=>{
        return one.attributes.name.localeCompare(two.attributes.name);
    });
    const assignedModuleIDs = new Set(props.assignedModuleIDs);
    const canSave = Boolean(selectedModule) && dueDate !== null && !isSaving;
    const assign = async ()=>{
        if (!auth.churchId || !props.teamID || !props.personID || !selectedModule || !dueDate) {
            setError(t('missingContext'));
            return;
        }
        setIsSaving(true);
        setError(null);
        try {
            const response = await (0, $3b4da10d641ce97c$export$2e2bcd8739ae039).assignTrainingModule(auth.churchId, props.teamID, props.personID, {
                moduleID: selectedModule.id,
                dueDate: $065ca63d8cbb0a9f$var$endOfDay(dueDate).toISOString(),
                notifyStaffAssignerOnCompletion: notifyOnCompletion
            }, auth);
            if (response.error) {
                setError(response.error);
                return;
            }
            const created = (0, $e9d4fad799ff15f3$export$e3dc061cc0656a85)(response.body);
            props.onAssigned(created ? {
                assignment: created,
                module: selectedModule
            } : null);
        } finally{
            setIsSaving(false);
        }
    };
    const renderStage = (target)=>{
        var _selectedModule_id;
        if (target === 'module') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($065ca63d8cbb0a9f$var$ModuleStep, {
            modules: sortedModules,
            loading: loading && !hasLoaded,
            error: loadError,
            assignedModuleIDs: assignedModuleIDs,
            selectedModuleID: (_selectedModule_id = selectedModule === null || selectedModule === void 0 ? void 0 : selectedModule.id) !== null && _selectedModule_id !== void 0 ? _selectedModule_id : null,
            onRetry: ()=>refetch(),
            onSelect: setSelectedModule
        });
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($065ca63d8cbb0a9f$var$DetailsStep, {
            module: selectedModule,
            personName: props.personName,
            isReassignment: selectedModule !== null && assignedModuleIDs.has(selectedModule.id),
            dueDate: dueDate,
            notifyOnCompletion: notifyOnCompletion,
            isSaving: isSaving,
            onDueDateChange: setDueDate,
            onNotifyChange: setNotifyOnCompletion
        });
    };
    const isPickingModule = stage === 'module';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "assign-training-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "assign-training-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: isPickingModule ? 'header-control close' : 'header-control back',
                            disabled: isSaving,
                            onClick: ()=>{
                                if (isPickingModule) {
                                    props.close();
                                    return;
                                }
                                changeStage('module');
                            },
                            children: isPickingModule ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: t('volunteering:common.close')
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($501046bd6ca447c4$exports))),
                                alt: t('volunteering:common.back')
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: isPickingModule ? t('moduleTitle') : t('detailsTitle')
                        }),
                        isPickingModule ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control forward",
                            disabled: !selectedModule,
                            onClick: ()=>changeStage('details'),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($77aa1e44a1d53977$exports))),
                                alt: t('continue')
                            })
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: isSaving ? 'header-control confirm saving' : 'header-control confirm',
                            disabled: !canSave,
                            onClick: ()=>{
                                assign();
                            },
                            children: isSaving ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "header-control-spinner",
                                role: "status",
                                "aria-label": t('assigning')
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($d5bdfc11cea11cc4$exports))),
                                alt: t('assign')
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "save-error",
                            children: error
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "stage-viewport",
                            children: [
                                transition ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: `stage is-outgoing ${transition.direction}`,
                                    "aria-hidden": "true",
                                    children: renderStage(transition.from)
                                }) : null,
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: transition ? `stage is-incoming ${transition.direction}` : 'stage',
                                    children: renderStage(stage)
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
function $065ca63d8cbb0a9f$var$ModuleStep(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('assignTraining');
    if (props.loading) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "assign-training-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
            fullScreen: false
        })
    });
    if (props.error) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        error: props.error,
        buttonText: t('retry'),
        buttonAction: props.onRetry
    });
    if (props.modules.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ced971621fdd495b$exports))),
        title: t('emptyTitle'),
        error: t('emptyMessage'),
        showButton: false
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "module-picker",
        children: props.modules.map((module)=>{
            const isAssigned = props.assignedModuleIDs.has(module.id);
            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6bebf3e1b16bb93$export$2e2bcd8739ae039), {
                module: module,
                isSelected: module.id === props.selectedModuleID,
                badge: isAssigned ? t('alreadyAssigned') : undefined,
                onClick: ()=>props.onSelect(module)
            }, module.id);
        })
    });
}
function $065ca63d8cbb0a9f$var$DetailsStep(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('assignTraining');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            props.module ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "selected-module",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b6bebf3e1b16bb93$export$2e2bcd8739ae039), {
                    module: props.module
                })
            }) : null,
            props.isReassignment ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "reassign-warning",
                children: t('reassignWarning', {
                    person: props.personName
                })
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "field-container",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                        htmlFor: "assignment-due-date",
                        children: t('dueDate')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c7b1a6f859720e7$export$5109c6dd95d8fb00), {
                        id: "assignment-due-date",
                        className: "date-picker",
                        selected: props.dueDate,
                        disabled: props.isSaving,
                        minDate: new Date(),
                        dateFormat: "PP",
                        // The calendar would otherwise be clipped by the modal's own scrolling.
                        popperProps: {
                            strategy: 'fixed'
                        },
                        onChange: (date)=>{
                            if (props.isSaving) return;
                            props.onDueDateChange(date);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                className: "checkbox-field",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                        type: "checkbox",
                        checked: props.notifyOnCompletion,
                        disabled: props.isSaving,
                        onChange: (e)=>props.onNotifyChange(e.target.checked)
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        children: t('notify', {
                            person: props.personName
                        })
                    })
                ]
            })
        ]
    });
}





function $e6ed8283c26dea86$export$2e2bcd8739ae039() {
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('volunteer');
    const pathParams = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const teamID = pathParams.teamID;
    const personID = pathParams.personID;
    var _location_state;
    const routedVolunteer = (_location_state = location.state) !== null && _location_state !== void 0 ? _location_state : null;
    const { assignments: assignments, loading: loading, hasLoaded: hasLoaded, error: error, refetch: refetch, addAssignment: addAssignment } = (0, $2bcab502c0cbf83d$export$2e2bcd8739ae039)(personID);
    // Teams carry the names this page shows: the volunteer's own, the team they
    // were opened from, and any other team an assignment came from.
    const { teams: teams } = (0, $db113dffb920235a$export$2e2bcd8739ae039)();
    var _teams_results_find;
    const teamBundle = (_teams_results_find = teams === null || teams === void 0 ? void 0 : teams.results.find((bundle)=>bundle.team.id === teamID)) !== null && _teams_results_find !== void 0 ? _teams_results_find : null;
    var _teamBundle_members_find;
    const member = (_teamBundle_members_find = teamBundle === null || teamBundle === void 0 ? void 0 : teamBundle.members.find((teamMember)=>teamMember.personID === personID)) !== null && _teamBundle_members_find !== void 0 ? _teamBundle_members_find : null;
    const personName = (member === null || member === void 0 ? void 0 : member.attributes.personName) || (routedVolunteer === null || routedVolunteer === void 0 ? void 0 : routedVolunteer.personName) || t('fallbackName');
    const teamName = (teamBundle === null || teamBundle === void 0 ? void 0 : teamBundle.team.attributes.name) || (routedVolunteer === null || routedVolunteer === void 0 ? void 0 : routedVolunteer.teamName);
    const teamNameByID = (0, $7fPBF.useMemo)(()=>{
        var _teams_results;
        return new Map(((_teams_results = teams === null || teams === void 0 ? void 0 : teams.results) !== null && _teams_results !== void 0 ? _teams_results : []).map((bundle)=>[
                bundle.team.id,
                bundle.team.attributes.name
            ]));
    }, [
        teams
    ]);
    const sortedAssignments = (0, $7fPBF.useMemo)(()=>$e6ed8283c26dea86$var$sortAssignments(assignments), [
        assignments
    ]);
    // Keyed so each open starts back at the Module picker with fresh defaults.
    const [isAssignModalOpen, setIsAssignModalOpen] = (0, $7fPBF.useState)(false);
    const [assignModalKey, setAssignModalKey] = (0, $7fPBF.useState)(0);
    const openAssignModal = ()=>{
        setAssignModalKey((currentKey)=>currentKey + 1);
        setIsAssignModalOpen(true);
    };
    if (!personID) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/volunteering",
        replace: true
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "volunteer-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: personName,
                subtitle: teamName,
                backLocation: "/volunteering",
                links: [
                    {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dc4ccb2f22e15fa3$exports))),
                        title: t('details'),
                        onClick: ()=>{
                            const state = {
                                personName: personName,
                                backLocation: location.pathname
                            };
                            navigate((0, $d093efa5d4df2a8b$export$f7fd57ccce645fe2)(personID), {
                                state: state
                            });
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $065ca63d8cbb0a9f$export$2e2bcd8739ae039), {
                isOpen: isAssignModalOpen,
                teamID: teamID,
                personID: personID,
                personName: personName,
                assignedModuleIDs: assignments.map((bundle)=>bundle.assignment.moduleID),
                close: ()=>setIsAssignModalOpen(false),
                onAssigned: (bundle)=>{
                    setIsAssignModalOpen(false);
                    // The new row lands right away; the refetch behind it reconciles with
                    // whatever the server actually stored.
                    if (bundle) addAssignment(bundle);
                    refetch();
                }
            }, `assign-training-${assignModalKey}`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("section", {
                className: "volunteer-assignments",
                children: loading && !hasLoaded ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "training-state",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                        fullScreen: false
                    })
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
                    children: error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                        error: error,
                        buttonText: t('retry'),
                        buttonAction: ()=>refetch(),
                        fullHeight: true
                    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            sortedAssignments.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "assignments-header",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                                        children: t('assignedHeading')
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                                        type: "button",
                                        className: "assign-training-button",
                                        onClick: openAssignModal,
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ed5c0a9c99fa42f0$exports))),
                                                alt: "",
                                                "aria-hidden": "true"
                                            }),
                                            t('assignTraining')
                                        ]
                                    })
                                ]
                            }) : null,
                            sortedAssignments.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                                icon: (0, (/*@__PURE__*/$parcel$interopDefault($ced971621fdd495b$exports))),
                                title: t('emptyTitle'),
                                error: t('emptyMessage', {
                                    person: personName
                                }),
                                buttonText: t('assignTraining'),
                                buttonAction: openAssignModal,
                                fullHeight: true
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ol", {
                                className: "assignment-list",
                                children: sortedAssignments.map((bundle)=>{
                                    const assignment = bundle.assignment;
                                    var _teamNameByID_get;
                                    // Assignments from elsewhere are labelled; the team this page was
                                    // opened from is already in the header.
                                    const otherTeamName = assignment.volunteerTeamID === teamID ? null : (_teamNameByID_get = teamNameByID.get(assignment.volunteerTeamID)) !== null && _teamNameByID_get !== void 0 ? _teamNameByID_get : t('anotherTeam');
                                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($e6ed8283c26dea86$var$AssignmentRow, {
                                        bundle: bundle,
                                        otherTeamName: otherTeamName
                                    }, assignment.moduleID);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function $e6ed8283c26dea86$var$AssignmentRow(props) {
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('volunteer');
    const assignment = props.bundle.assignment;
    var _props_bundle_module;
    const module = (_props_bundle_module = props.bundle.module) !== null && _props_bundle_module !== void 0 ? _props_bundle_module : null;
    var _module_attributes;
    const attributes = (_module_attributes = module === null || module === void 0 ? void 0 : module.attributes) !== null && _module_attributes !== void 0 ? _module_attributes : null;
    const completedCount = assignment.completedResourceIDs.length;
    const dueDate = $e6ed8283c26dea86$var$parseDate(assignment.dueDate);
    const isOverdue = dueDate !== null && dueDate.getTime() < Date.now();
    const isCompleted = assignment.completionDate != null;
    var _attributes_name, _attributes_name1;
    const content = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "assignment-thumbnail",
                children: (attributes === null || attributes === void 0 ? void 0 : attributes.thumbnailURL) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: attributes.thumbnailURL,
                    alt: "",
                    "aria-hidden": "true"
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                    className: "thumbnail-fallback",
                    "aria-hidden": "true",
                    children: ((_attributes_name = attributes === null || attributes === void 0 ? void 0 : attributes.name) !== null && _attributes_name !== void 0 ? _attributes_name : '?').slice(0, 1)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "assignment-body",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: (_attributes_name1 = attributes === null || attributes === void 0 ? void 0 : attributes.name) !== null && _attributes_name1 !== void 0 ? _attributes_name1 : t('unavailableModule')
                    }),
                    (attributes === null || attributes === void 0 ? void 0 : attributes.description) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "assignment-description",
                        children: attributes.description
                    }) : module ? null : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "assignment-description",
                        children: t('moduleUnavailable')
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "assignment-tags",
                        children: [
                            isCompleted ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "assignment-tag completed",
                                children: t('completed')
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: completedCount > 0 ? 'assignment-tag in-progress' : 'assignment-tag',
                                children: completedCount > 0 ? t('lessonsComplete', {
                                    count: completedCount
                                }) : t('notStarted')
                            }),
                            !isCompleted && dueDate ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: isOverdue ? 'assignment-tag overdue' : 'assignment-tag due',
                                children: t(isOverdue ? 'overdue' : 'due', {
                                    date: $e6ed8283c26dea86$var$formatDate(dueDate)
                                })
                            }) : null,
                            props.otherTeamName ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "assignment-tag muted",
                                children: t('via', {
                                    team: props.otherTeamName
                                })
                            }) : null
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            className: "assignment-row is-static",
            children: content
        })
    });
}
// Dates arrive as ISO 8601. Anything unparseable is treated as absent rather
// than rendered as "Invalid Date".
function $e6ed8283c26dea86$var$parseDate(value) {
    if (!value) return null;
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? null : date;
}
function $e6ed8283c26dea86$var$formatDate(date) {
    return date.toLocaleDateString((0, $2Bwgd.default).language, {
        month: 'short',
        day: 'numeric',
        year: date.getFullYear() === new Date().getFullYear() ? undefined : 'numeric'
    });
}
// Soonest due first, since that's what a staff member is scanning for. Anything
// without a due date sorts after, by module name.
function $e6ed8283c26dea86$var$sortAssignments(assignments) {
    return [
        ...assignments
    ].sort((one, two)=>{
        var _parseDate, _parseDate1, _one_module, _two_module;
        var _parseDate_getTime;
        const dueOne = (_parseDate_getTime = (_parseDate = $e6ed8283c26dea86$var$parseDate(one.assignment.dueDate)) === null || _parseDate === void 0 ? void 0 : _parseDate.getTime()) !== null && _parseDate_getTime !== void 0 ? _parseDate_getTime : null;
        var _parseDate_getTime1;
        const dueTwo = (_parseDate_getTime1 = (_parseDate1 = $e6ed8283c26dea86$var$parseDate(two.assignment.dueDate)) === null || _parseDate1 === void 0 ? void 0 : _parseDate1.getTime()) !== null && _parseDate_getTime1 !== void 0 ? _parseDate_getTime1 : null;
        if (dueOne !== dueTwo) {
            if (dueOne === null) return 1;
            if (dueTwo === null) return -1;
            return dueOne - dueTwo;
        }
        var _one_module_attributes_name;
        const nameOne = (_one_module_attributes_name = (_one_module = one.module) === null || _one_module === void 0 ? void 0 : _one_module.attributes.name) !== null && _one_module_attributes_name !== void 0 ? _one_module_attributes_name : '';
        var _two_module_attributes_name;
        const nameTwo = (_two_module_attributes_name = (_two_module = two.module) === null || _two_module === void 0 ? void 0 : _two_module.attributes.name) !== null && _two_module_attributes_name !== void 0 ? _two_module_attributes_name : '';
        return nameOne.localeCompare(nameTwo);
    });
}











var $7fPBF = parcelRequire("7fPBF");



var $2Bwgd = parcelRequire("2Bwgd");
function $99899f1fed5f6076$export$2e2bcd8739ae039(teamID) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchId = auth.churchId;
    const [bundle, setBundle] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchId || !teamID) return;
        setLoading(true);
        setError(null);
        try {
            var _response_body;
            const response = await (0, $369e4aa7dc42c97e$export$2e2bcd8739ae039).fetchTeam(churchId, teamID, auth);
            var _response_body_result;
            if (response.error) {
                setError(response.error);
                setBundle(null);
            } else setBundle((_response_body_result = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.result) !== null && _response_body_result !== void 0 ? _response_body_result : null);
        } catch (err) {
            setError((err === null || err === void 0 ? void 0 : err.message) || (0, $2Bwgd.default).t('volunteering:errors.loadTeam'));
            setBundle(null);
        } finally{
            setLoading(false);
        }
    }, [
        churchId,
        teamID,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!churchId || !teamID) return;
        fetch();
    }, [
        churchId,
        teamID,
        fetch
    ]);
    return {
        bundle: bundle,
        loading: loading,
        error: error,
        refetch: fetch
    };
}



function $392f3b01ef366b57$export$2e2bcd8739ae039() {
    const { teamID: teamID } = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { t: t } = (0, $9c081519ec78392c$export$9fc83ad70ead8663)('volunteering');
    var _location_state;
    const routedTeam = (_location_state = location.state) !== null && _location_state !== void 0 ? _location_state : null;
    const { bundle: bundle, loading: loading, error: error, refetch: refetch } = (0, $99899f1fed5f6076$export$2e2bcd8739ae039)(teamID);
    if (!teamID) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/volunteering",
        replace: true
    });
    if (!loading && !bundle) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        title: t('team.loadFailedTitle'),
        error: error !== null && error !== void 0 ? error : t('team.loadFailedMessage'),
        buttonText: t('team.backToTeams'),
        buttonAction: ()=>navigate('/volunteering'),
        fullHeight: true
    });
    const teamName = (bundle === null || bundle === void 0 ? void 0 : bundle.team.attributes.name) || (routedTeam === null || routedTeam === void 0 ? void 0 : routedTeam.teamName) || '';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "volunteering-people-page volunteer-team-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: teamName,
                backLocation: "/volunteering"
            }),
            loading && !bundle ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}) : null,
            bundle ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $23b3202b2105069a$export$2e2bcd8739ae039), {
                bundles: [
                    bundle
                ],
                refetch: refetch,
                variant: "team-page"
            }) : null
        ]
    });
}




var $44775bf8c84ed14b$exports = {};
$44775bf8c84ed14b$exports = $parcel$resolve("96vVz");


function $0c522a61e1633b5f$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "welcome",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($44775bf8c84ed14b$exports))),
                alt: "Church Hub logo"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "\uD83D\uDC4B Welcome to Church Hub!"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: "mailto:support@saltplatform.com?subject=Church%20Hub%20Support%20Request",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Get Support"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        href: "mailto:jordan@saltplatform.com?subject=Salt%20Feature%20Request",
                        target: "_blank",
                        rel: "noopener noreferrer",
                        children: "Request a Feature"
                    })
                ]
            })
        ]
    });
}




var $88a4dbdd97534f81$exports = {};
$88a4dbdd97534f81$exports = $parcel$resolve("hXw2B");


var $d6ed300fdf537ea3$exports = {};
$d6ed300fdf537ea3$exports = $parcel$resolve("8nLu6");


var $76492af6a51f5838$exports = {};
$76492af6a51f5838$exports = $parcel$resolve("aJ728");




var $7fPBF = parcelRequire("7fPBF");













function $c37f65d634f8c76f$export$2e2bcd8739ae039(props) {
    var _props_providerName;
    const name = (_props_providerName = props.providerName) !== null && _props_providerName !== void 0 ? _props_providerName : 'this provider';
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "disconnect-integration-modal",
        isOpen: props.isOpen,
        footerButtons: [
            {
                title: props.isDisconnecting ? 'Disconnecting...' : `Disconnect ${name}`,
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !props.isDisconnecting,
                onClick: props.confirm
            },
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !props.isDisconnecting,
                onClick: props.close
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "disconnect-integration-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "close",
                            disabled: props.isDisconnecting,
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                            className: "title",
                            children: [
                                "Disconnect ",
                                name
                            ]
                        })
                    ]
                }),
                props.error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "save-error",
                    children: props.error
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5407115776bd457c$exports))),
                            alt: "",
                            "aria-hidden": "true",
                            className: "warning-icon"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "warning-copy",
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("strong", {
                                children: [
                                    "Are you sure you want to disconnect ",
                                    name,
                                    "?"
                                ]
                            })
                        }),
                        props.consequences ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "warning-copy",
                            children: props.consequences
                        }) : null,
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            className: "warning-copy caption",
                            children: "This takes effect immediately for your whole church. To reconnect, an admin will need to set up the connection again from this page."
                        })
                    ]
                })
            ]
        })
    });
}


const $8b78cb05ee8c928f$var$PROVIDERS = [
    {
        provider: (0, $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72).PLANNING_CENTER,
        name: 'Planning Center',
        description: 'Connecting with Planning Center lets your church bring its people, volunteer teams, and event registrations into Salt.',
        authorizationStyle: (0, $5586e2638b6c1db4$export$22609f4d35043983).OAUTH,
        disconnectConsequences: 'Planning Center registrations will stop syncing with Salt Events, and you won\'t be able to import people or volunteer teams from Planning Center. People and teams you\'ve already imported will stay in Salt.'
    },
    {
        provider: (0, $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72).SMART_WAIVER,
        name: 'Smartwaiver',
        description: 'Connecting with Smartwaiver allows completed waivers to be automatically linked to event registrations in Salt Events.',
        authorizationStyle: (0, $5586e2638b6c1db4$export$22609f4d35043983).API_KEY,
        disconnectConsequences: 'Completed waivers will stop being linked to event registrations in Salt Events, and your Smartwaiver API key will be removed from Salt.',
        apiKeyInstructions: `1. On <a target="_blank" rel="noopener noreferrer" href="https://app.smartwaiver.com/console">Smartwaiver's website</a>, navigate to the "My Account" tab.\n
2. Click "API Keys".\n
3. Give the key a name. We suggest "Salt Church Hub" or "Salt".\n
4. Ensure the "API User" box is checked.\n
5. Click "Save API Token".\n
6. Click "Copy key".\n
7. Return to this page, and paste the key below.`
    }
];
function $8b78cb05ee8c928f$export$2e2bcd8739ae039() {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const darkMode = (0, $5cc3ec176bbf7015$export$2e2bcd8739ae039)();
    const { integrations: integrations, reloadConnectionStatus: reloadConnectionStatus } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const [busyProvider, setBusyProvider] = (0, $7fPBF.useState)(null);
    const [showAPIKeyModal, setShowAPIKeyModal] = (0, $7fPBF.useState)(false);
    const [savingAPIKey, setSavingAPIKey] = (0, $7fPBF.useState)(false);
    const [apiKeyProvider, setAPIKeyProvider] = (0, $7fPBF.useState)(null);
    // The target outlives the open flag so the modal keeps its copy while it
    // animates closed.
    const [disconnectTarget, setDisconnectTarget] = (0, $7fPBF.useState)(null);
    const [isDisconnectModalOpen, setIsDisconnectModalOpen] = (0, $7fPBF.useState)(false);
    const [isDisconnecting, setIsDisconnecting] = (0, $7fPBF.useState)(false);
    const [disconnectError, setDisconnectError] = (0, $7fPBF.useState)(null);
    const openDisconnectModal = (config)=>{
        setDisconnectTarget(config);
        setDisconnectError(null);
        setIsDisconnectModalOpen(true);
    };
    const closeDisconnectModal = ()=>{
        setIsDisconnectModalOpen(false);
        window.setTimeout(()=>{
            setDisconnectTarget(null);
        }, 200);
    };
    const connectionFor = (provider)=>{
        var _integrations_find;
        return (_integrations_find = integrations === null || integrations === void 0 ? void 0 : integrations.find((connection)=>connection.provider === provider)) !== null && _integrations_find !== void 0 ? _integrations_find : null;
    };
    const connect = async (config)=>{
        // An API-key provider has nothing to redirect to: the church pastes a key
        // in instead, and the API answers its authorization-url route with a 400.
        if (config.authorizationStyle === (0, $5586e2638b6c1db4$export$22609f4d35043983).API_KEY) {
            setAPIKeyProvider(config);
            return;
        }
        if (!auth.churchId || busyProvider) return;
        setBusyProvider(config.provider);
        try {
            var _response_body_result, _response_body;
            const response = await (0, $d6ceddc0f5c6ead5$export$2e2bcd8739ae039).fetchAuthorizationURL(auth.churchId, config.provider, auth);
            const authorizationURL = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : (_response_body_result = _response_body.result) === null || _response_body_result === void 0 ? void 0 : _response_body_result.authorizationURL;
            if (response.error || !authorizationURL) {
                window.alert(response.error || `Failed to start connecting with ${config.name}. Please try again later.`);
                return;
            }
            window.location.href = authorizationURL;
        } finally{
            setBusyProvider(null);
        }
    };
    const saveAPIKeyForSelectedProvider = async (apiKey)=>{
        if (!auth.churchId || !apiKeyProvider) return;
        setSavingAPIKey(true);
        try {
            const response = await (0, $d6ceddc0f5c6ead5$export$2e2bcd8739ae039).saveAPIKey(auth.churchId, apiKeyProvider.provider, apiKey, auth);
            if (response.error) {
                window.alert(response.error);
                console.log(response.error);
            } else {
                setShowAPIKeyModal(false);
                reloadConnectionStatus();
            }
        } catch (e) {
            window.alert("Failed to save API Key. Please try again later.");
        } finally{
            setSavingAPIKey(false);
        }
    };
    const disconnect = async ()=>{
        if (!auth.churchId || !disconnectTarget) return;
        setIsDisconnecting(true);
        setDisconnectError(null);
        try {
            const response = await (0, $d6ceddc0f5c6ead5$export$2e2bcd8739ae039).disconnect(auth.churchId, disconnectTarget.provider, auth);
            if (response.error) {
                setDisconnectError(response.error);
                return;
            }
            closeDisconnectModal();
            reloadConnectionStatus();
        } finally{
            setIsDisconnecting(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        // Ensure we have the latest connection status when this page mounts
        reloadConnectionStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $7fPBF.useEffect)(()=>{
        if (apiKeyProvider !== null) setShowAPIKeyModal(true);
    }, [
        apiKeyProvider
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!showAPIKeyModal) setTimeout(()=>{
            setAPIKeyProvider(null);
        }, 400);
    }, [
        showAPIKeyModal
    ]);
    if (!integrations) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "connections-container",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {})
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "connections-container",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ae515035e6d7062$export$2e2bcd8739ae039), {
                title: "Connections",
                tabs: [],
                buttons: []
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8b78cb05ee8c928f$var$APIKeyConnectionInstructionsModal, {
                isOpen: showAPIKeyModal,
                config: apiKeyProvider,
                close: ()=>{
                    setShowAPIKeyModal(false);
                },
                save: (apiKey)=>{
                    saveAPIKeyForSelectedProvider(apiKey);
                },
                isSaving: savingAPIKey
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $c37f65d634f8c76f$export$2e2bcd8739ae039), {
                isOpen: isDisconnectModalOpen,
                providerName: disconnectTarget === null || disconnectTarget === void 0 ? void 0 : disconnectTarget.name,
                consequences: disconnectTarget === null || disconnectTarget === void 0 ? void 0 : disconnectTarget.disconnectConsequences,
                isDisconnecting: isDisconnecting,
                error: disconnectError,
                close: closeDisconnectModal,
                confirm: ()=>{
                    disconnect();
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "cards",
                children: $8b78cb05ee8c928f$var$PROVIDERS.map((config)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($8b78cb05ee8c928f$var$ConnectionCard, {
                        config: config,
                        logo: config.provider === (0, $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72).PLANNING_CENTER ? darkMode ? (0, (/*@__PURE__*/$parcel$interopDefault($88a4dbdd97534f81$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($d6ed300fdf537ea3$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($76492af6a51f5838$exports))),
                        connection: connectionFor(config.provider),
                        isBusy: busyProvider === config.provider,
                        connectButtonClicked: ()=>{
                            connect(config);
                        },
                        disconnectButtonClicked: ()=>openDisconnectModal(config)
                    }, config.provider))
            })
        ]
    });
}
// Only an active connection is usable; the others each need the church to do
// something, so they say what rather than reading as connected.
function $8b78cb05ee8c928f$var$statusLabel(connection) {
    switch(connection.status){
        case (0, $5586e2638b6c1db4$export$140fd4ecf5a82cf0).ACTIVE:
            return 'Connected';
        case (0, $5586e2638b6c1db4$export$140fd4ecf5a82cf0).NEEDS_REAUTHORIZATION:
            return 'Needs reauthorization';
        case (0, $5586e2638b6c1db4$export$140fd4ecf5a82cf0).REVOKED:
            return 'Disconnected by provider';
        default:
            return 'Connected';
    }
}
function $8b78cb05ee8c928f$var$ConnectionCard(props) {
    const connection = props.connection;
    const isActive = (connection === null || connection === void 0 ? void 0 : connection.status) === (0, $5586e2638b6c1db4$export$140fd4ecf5a82cf0).ACTIVE;
    const isAPIKey = props.config.authorizationStyle === (0, $5586e2638b6c1db4$export$22609f4d35043983).API_KEY;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "connection-card card",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "header",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: props.logo,
                    alt: props.config.name
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "description",
                children: props.config.description
            }),
            connection ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        className: isActive ? 'connected-text' : 'connected-text needs-attention',
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                className: "connected-dot",
                                "aria-hidden": "true"
                            }),
                            " ",
                            $8b78cb05ee8c928f$var$statusLabel(connection)
                        ]
                    }),
                    connection.organizationName ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "connection-detail",
                        children: connection.organizationName
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "connection-actions",
                        children: [
                            !isActive ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: props.connectButtonClicked,
                                disabled: props.isBusy,
                                children: isAPIKey ? 'Update API Key' : 'Reconnect'
                            }) : null,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                className: "secondary",
                                onClick: props.disconnectButtonClicked,
                                disabled: props.isBusy,
                                children: "Disconnect"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: props.connectButtonClicked,
                disabled: props.isBusy,
                children: "Connect"
            })
        ]
    });
}
function $8b78cb05ee8c928f$var$APIKeyConnectionInstructionsModal(props) {
    var _props_config;
    const [apiKey, setAPIKey] = (0, $7fPBF.useState)('');
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "apiKey",
        isOpen: props.isOpen,
        footerButtons: [
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                onClick: props.close,
                enabled: !props.isSaving
            },
            {
                title: 'Save',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                onClick: ()=>{
                    props.save(apiKey);
                },
                enabled: apiKey.length > 0 && !props.isSaving
            }
        ],
        children: ((_props_config = props.config) === null || _props_config === void 0 ? void 0 : _props_config.apiKeyInstructions) ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            style: {
                padding: '4px 0 16px 0'
            },
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    children: "Instructions"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    dangerouslySetInnerHTML: {
                        __html: props.config.apiKeyInstructions.replace(/\n/g, '<br />')
                    }
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                    id: "apiKey",
                    type: "text",
                    placeholder: "API Key",
                    style: {
                        width: '100%',
                        boxSizing: 'border-box',
                        height: '48px',
                        border: 'none',
                        borderRadius: '8px',
                        paddingLeft: '16px',
                        fontFamily: 'monospace'
                    },
                    value: apiKey,
                    onChange: (e)=>{
                        setAPIKey(e.target.value);
                    }
                })
            ]
        }) : null
    });
}





var $7fPBF = parcelRequire("7fPBF");



class $6857e104788587b0$export$2e2bcd8739ae039 {
    static async fetchEvents(churchID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events`), auth.consumeRefreshToken);
    }
    static async createEvent(churchID, body, auth) {
        let payload = {
            eventAttributes: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, body.event),
            planningCenterMetadata: null
        };
        if (body.planningCenterMetadata) payload.planningCenterMetadata = body.planningCenterMetadata;
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/church/${churchID}/events`, payload), auth.consumeRefreshToken);
    }
    static async fetchExternalImportOptions(churchID, provider, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events/external-import-options/${provider}`), auth.consumeRefreshToken);
    }
    static async fetchExternalEventDetails(churchID, provider, externalEventID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events/external-import-options/${provider}/${externalEventID}`), auth.consumeRefreshToken);
    }
    static async fetchEvent(churchID, eventID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events/${eventID}`), auth.consumeRefreshToken);
    }
    static async fetchAttendeesForEvent(churchID, eventID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events/${eventID}/attendees`), auth.consumeRefreshToken);
    }
    static async fetchAvailableExternalWaivers(churchID, provider, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).GET, `/church/${churchID}/events/available-waivers/${provider}`), auth.consumeRefreshToken);
    }
    static async attachExternalWaiverToEvent(churchID, eventID, externalWaiver, instructions, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PUT, `/church/${churchID}/events/${eventID}/waivers/external`, {
            externalWaiver: externalWaiver,
            instructions: instructions
        }), auth.consumeRefreshToken);
    }
    static async createManualWaiverForEvent(churchID, eventID, waiver, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PUT, `/church/${churchID}/events/${eventID}/waivers`, waiver), auth.consumeRefreshToken);
    }
    static async sendWaiverReminderEmails(churchID, eventID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/church/${churchID}/events/${eventID}/actions/send-waiver-reminder-emails`), auth.consumeRefreshToken);
    }
    static async submitAttendeeWaiverCompletions(churchID, eventID, waiverID, markAsComplete, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/church/${churchID}/events/${eventID}/waivers/${waiverID}/actions/mark-attendees-complete`, {
            attendees: markAsComplete.map((attendee)=>attendee.id)
        }), auth.consumeRefreshToken);
    }
}
$6857e104788587b0$export$2e2bcd8739ae039.baseURL = "https://events-api.saltplatform.com";


function $5e99117a3c3f973f$export$2e2bcd8739ae039(providedChurchId) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchId = providedChurchId || auth.churchId;
    const [events, setEvents] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchId) return;
        setLoading(true);
        setError(null);
        try {
            const response = await (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchEvents(churchId, auth);
            if (response.error) {
                setError(response.error);
                setEvents(null);
            } else if (response.body) setEvents(response.body.events);
            else setEvents(null);
        } catch (err) {
            setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to load events');
            setEvents(null);
        } finally{
            setLoading(false);
        }
    }, [
        churchId,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!churchId) return;
        let isMounted = true;
        const performFetch = async ()=>{
            await fetch();
            if (!isMounted) return;
        };
        performFetch();
        return ()=>{
            isMounted = false;
        };
    }, [
        churchId,
        fetch
    ]);
    return {
        events: events,
        loading: loading,
        error: error,
        refetch: fetch
    };
}








var $230c122f42a9c337$exports = {};
$230c122f42a9c337$exports = $parcel$resolve("l9fer");


function $5a439522e12ead21$var$formatDateRange(startISO, endISO, showTimes = true) {
    if (!startISO) return "";
    const start = new Date(startISO);
    const end = endISO ? new Date(endISO) : null;
    const options = showTimes ? {
        month: 'short',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric'
    } : {
        month: 'short',
        day: 'numeric'
    };
    if (!end) return start.toLocaleString(undefined, options);
    // If same day, show range of times
    if (start.toDateString() === end.toDateString()) {
        const datePart = start.toLocaleDateString(undefined, {
            month: 'short',
            day: 'numeric'
        });
        const startTime = start.toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: 'numeric'
        });
        const endTime = end.toLocaleTimeString(undefined, {
            hour: 'numeric',
            minute: 'numeric'
        });
        return `${datePart} \u{2022} ${startTime} - ${endTime}`;
    }
    // Different days
    return `${start.toLocaleString(undefined, options)} - ${end.toLocaleString(undefined, options)}`;
}
function $5a439522e12ead21$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
        className: "event-card card",
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                    src: props.thumbnailURL ? props.thumbnailURL : (0, (/*@__PURE__*/$parcel$interopDefault($230c122f42a9c337$exports))),
                    className: "thumbnail",
                    alt: props.title
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "content",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "content-left",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                    className: "title",
                                    children: props.title
                                }),
                                props.dateInfo ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "date",
                                    children: $5a439522e12ead21$var$formatDateRange(props.dateInfo.startsAt, props.dateInfo.endsAt, props.dateInfo.showTimes)
                                }) : null
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($2f86ea90ef359998$exports))),
                            alt: "Open event",
                            className: "link-arrow"
                        })
                    ]
                })
            ]
        })
    });
}



function $2a0798e511c3602a$export$2e2bcd8739ae039() {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const { events: events, loading: loading, error: error, refetch: refetch } = (0, $5e99117a3c3f973f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "events-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ae515035e6d7062$export$2e2bcd8739ae039), {
                title: "Events",
                tabs: [],
                buttons: [
                    {
                        icon: 'add',
                        label: 'Create Event',
                        onClick: ()=>{
                            navigate('/events/create');
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "events-container",
                children: [
                    loading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}) : null,
                    error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                        error: error,
                        buttonText: "Retry",
                        buttonAction: ()=>refetch()
                    }) : null,
                    events && events.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "no-events",
                        children: "No upcoming events."
                    }) : null,
                    events && events.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "cards",
                        children: events.map((e)=>{
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5a439522e12ead21$export$2e2bcd8739ae039), {
                                title: e.title,
                                thumbnailURL: e.thumbnailURL,
                                dateInfo: {
                                    showTimes: e.showTimes,
                                    startsAt: e.startsAt,
                                    endsAt: e.endsAt
                                },
                                onClick: ()=>{
                                    navigate(`/events/${e.id}`);
                                }
                            }, e.id);
                        })
                    }) : null
                ]
            })
        ]
    });
}






var $c7554617f7771263$exports = {};
$c7554617f7771263$exports = $parcel$resolve("fYzlm");



var $729bd1a2fa55fb37$exports = {};
$729bd1a2fa55fb37$exports = $parcel$resolve("abwkZ");




var $7fPBF = parcelRequire("7fPBF");


function $7391c474f3fbb6e2$export$2e2bcd8739ae039() {
    const { connectionStatus: connectionStatus, reloadConnectionStatus: reloadConnectionStatus } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    (0, $7fPBF.useEffect)(()=>{
        // Ensure we have the latest connection status when this page mounts
        reloadConnectionStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const loadedConnectionStatus = connectionStatus !== undefined && connectionStatus !== null;
    const isPlanningCenterConnected = (connectionStatus === null || connectionStatus === void 0 ? void 0 : connectionStatus.PLANNING_CENTER) == true;
    const planningCenterCard = {
        title: "Import from Planning Center",
        description: "Pick an event from Planning Center to import. Events imported from Planning Center will regularly sync attendees and other data with Salt.",
        logo: {
            image: (0, (/*@__PURE__*/$parcel$interopDefault($c7554617f7771263$exports))),
            alt: 'Planning Center'
        },
        enabled: true,
        onClick: ()=>{
            if (isPlanningCenterConnected) navigate('/events/create/import?provider=PLANNING_CENTER');
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "create-event-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: "",
                showBackButton: true,
                backLocation: "/events"
            }),
            !loadedConnectionStatus && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}),
            loadedConnectionStatus === true && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77186c032b6447f6$export$2e2bcd8739ae039), {
                title: "New Event",
                description: "Create events that your church members can attend.",
                icon: {
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($729bd1a2fa55fb37$exports))),
                    alt: 'Events'
                },
                unavailableText: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                    children: [
                        "Unavailable creation methods may require you to connect an external provider in ",
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            href: "/connections",
                            children: "Connections"
                        })
                    ]
                }),
                cards: [
                    {
                        title: "Create in Salt",
                        description: "Create a fully custom event, managed in Salt.",
                        logo: {
                            image: (0, (/*@__PURE__*/$parcel$interopDefault($9a6c88b634913c19$exports))),
                            alt: 'Salt'
                        },
                        enabled: true,
                        onClick: ()=>navigate('/events/create/details')
                    },
                    planningCenterCard
                ]
            })
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");







const $8e08dd08a6f8a76d$var$checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const $8e08dd08a6f8a76d$export$9de1236619d9e756 = /*@__PURE__*/ $8e08dd08a6f8a76d$var$checkStringStartsWith("--");
const $8e08dd08a6f8a76d$var$startsAsVariableToken = /*@__PURE__*/ $8e08dd08a6f8a76d$var$checkStringStartsWith("var(--");
const $8e08dd08a6f8a76d$export$31f9caa2600b5723 = (value)=>{
    const startsWithToken = $8e08dd08a6f8a76d$var$startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return $8e08dd08a6f8a76d$var$singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const $8e08dd08a6f8a76d$var$singleCssVariableRegex = RegExp("var\\(--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)$", "iu");
/**
 * Check if a value contains a CSS variable anywhere (e.g. inside calc()).
 * Unlike isCSSVariableToken which checks if the value IS a var() token,
 * this checks if the value CONTAINS var() somewhere in the string.
 */ function $8e08dd08a6f8a76d$export$df8f90ab5d0b05fa(value) {
    if (typeof value !== "string") return false;
    // Strip comments to avoid false positives
    return value.split("/*")[0].includes("var(--");
}


/**
 * Generate a list of every possible transform key.
 */ const $36437dbf5b93c477$export$280dc01950909d86 = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 *
 * `pathRotation` is a transform for routing purposes (skipped from raw
 * style application, wired to the transform composite, flags transform
 * dirty) but is intentionally NOT in `transformPropOrder` — it is
 * composed onto `rotate` at the build sites, not serialized in its own
 * slot, and must stay out of the order-array consumers (parse-transform,
 * unit-conversion, keys-position).
 */ const $36437dbf5b93c477$export$7b42a0094fb00b6e = /*@__PURE__*/ (()=>new Set([
        ...$36437dbf5b93c477$export$280dc01950909d86,
        "pathRotation"
    ]))();


const $f0207664133f4738$var$radToDeg = (rad)=>rad * 180 / Math.PI;
const $f0207664133f4738$var$rotate = (v)=>{
    const angle = $f0207664133f4738$var$radToDeg(Math.atan2(v[1], v[0]));
    return $f0207664133f4738$var$rebaseAngle(angle);
};
const $f0207664133f4738$var$matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate: $f0207664133f4738$var$rotate,
    rotateZ: $f0207664133f4738$var$rotate,
    skewX: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[1])),
    skewY: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const $f0207664133f4738$var$rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const $f0207664133f4738$var$rotateZ = $f0207664133f4738$var$rotate;
const $f0207664133f4738$var$scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const $f0207664133f4738$var$scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const $f0207664133f4738$var$matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX: $f0207664133f4738$var$scaleX,
    scaleY: $f0207664133f4738$var$scaleY,
    scale: (v)=>($f0207664133f4738$var$scaleX(v) + $f0207664133f4738$var$scaleY(v)) / 2,
    rotateX: (v)=>$f0207664133f4738$var$rebaseAngle($f0207664133f4738$var$radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>$f0207664133f4738$var$rebaseAngle($f0207664133f4738$var$radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ: $f0207664133f4738$var$rotateZ,
    rotate: $f0207664133f4738$var$rotateZ,
    skewX: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[4])),
    skewY: (v)=>$f0207664133f4738$var$radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function $f0207664133f4738$export$1f10c01143b9f089(name) {
    return name.includes("scale") ? 1 : 0;
}
function $f0207664133f4738$export$f9111f9e16b73a26(transform, name) {
    if (!transform || transform === "none") return $f0207664133f4738$export$1f10c01143b9f089(name);
    const matrix3dMatch = transform.match(RegExp("^matrix3d\\(([-\\d.e\\s,]+)\\)$", "u"));
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = $f0207664133f4738$var$matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(RegExp("^matrix\\(([-\\d.e\\s,]+)\\)$", "u"));
        parsers = $f0207664133f4738$var$matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return $f0207664133f4738$export$1f10c01143b9f089(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map($f0207664133f4738$var$convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const $f0207664133f4738$export$bcd97e0e03ba17f6 = (instance, name)=>{
    const { transform: transform = "none" } = getComputedStyle(instance);
    return $f0207664133f4738$export$f9111f9e16b73a26(transform, name);
};
function $f0207664133f4738$var$convertTransformToNumber(value) {
    return parseFloat(value.trim());
}


/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ function $fd94cc0f2e3ce586$export$d3955c6a8f65a36b({ top: top, left: left, right: right, bottom: bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function $fd94cc0f2e3ce586$export$b6b9cd4198191a47({ x: x, y: y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function $fd94cc0f2e3ce586$export$21543fb75483a50(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}


/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ const $98312100572e3dbc$export$3bb0b4ff1037b8dd = (from, to, progress)=>{
    return from + (to - from) * progress;
};


function $8f62b661d366a749$var$isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function $8f62b661d366a749$export$bdf30dca883ea463({ scale: scale, scaleX: scaleX, scaleY: scaleY }) {
    return !$8f62b661d366a749$var$isIdentityScale(scale) || !$8f62b661d366a749$var$isIdentityScale(scaleX) || !$8f62b661d366a749$var$isIdentityScale(scaleY);
}
function $8f62b661d366a749$export$a545127cf1fbb600(values) {
    return $8f62b661d366a749$export$bdf30dca883ea463(values) || $8f62b661d366a749$export$bf80f5f8f4dc327f(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function $8f62b661d366a749$export$bf80f5f8f4dc327f(values) {
    return $8f62b661d366a749$var$is2DTranslate(values.x) || $8f62b661d366a749$var$is2DTranslate(values.y);
}
function $8f62b661d366a749$var$is2DTranslate(value) {
    return value && value !== "0%";
}


/**
 * Scales a point based on a factor and an originPoint
 */ function $0043a8a3eeedd876$export$2290ec7febe36dd6(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function $0043a8a3eeedd876$export$4e122ddcc0c61a2e(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = $0043a8a3eeedd876$export$2290ec7febe36dd6(point, boxScale, originPoint);
    return $0043a8a3eeedd876$export$2290ec7febe36dd6(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function $0043a8a3eeedd876$export$e8e3a712e9ebf422(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = $0043a8a3eeedd876$export$4e122ddcc0c61a2e(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $0043a8a3eeedd876$export$4e122ddcc0c61a2e(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function $0043a8a3eeedd876$export$d80074982803af5c(box, { x: x, y: y }) {
    $0043a8a3eeedd876$export$e8e3a712e9ebf422(box.x, x.translate, x.scale, x.originPoint);
    $0043a8a3eeedd876$export$e8e3a712e9ebf422(box.y, y.translate, y.scale, y.originPoint);
}
const $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MIN = 0.999999999999;
const $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function $0043a8a3eeedd876$export$e2a980535c55eabb(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        var _node_layout;
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement: visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
            $0043a8a3eeedd876$export$a807a5ce5ebb3895(box.x, -node.scroll.offset.x);
            $0043a8a3eeedd876$export$a807a5ce5ebb3895(box.y, -node.scroll.offset.y);
        }
        if (delta) {
            // Incoporate each ancestor's scale into a cumulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            $0043a8a3eeedd876$export$d80074982803af5c(box, delta);
        }
        if (isSharedTransition && (0, $8f62b661d366a749$export$a545127cf1fbb600)(node.latestValues)) $0043a8a3eeedd876$export$58b16271041fbfb(box, node.latestValues, (_node_layout = node.layout) === null || _node_layout === void 0 ? void 0 : _node_layout.layoutBox);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MAX && treeScale.x > $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MAX && treeScale.y > $0043a8a3eeedd876$var$TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function $0043a8a3eeedd876$export$a807a5ce5ebb3895(axis, distance) {
    axis.min += distance;
    axis.max += distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function $0043a8a3eeedd876$export$625f1dd140a2f5e7(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    $0043a8a3eeedd876$export$e8e3a712e9ebf422(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function $0043a8a3eeedd876$var$resolveAxisTranslate(value, axis) {
    if (typeof value === "string") return parseFloat(value) / 100 * (axis.max - axis.min);
    return value;
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function $0043a8a3eeedd876$export$58b16271041fbfb(box, transform, sourceBox) {
    const resolveBox = sourceBox !== null && sourceBox !== void 0 ? sourceBox : box;
    $0043a8a3eeedd876$export$625f1dd140a2f5e7(box.x, $0043a8a3eeedd876$var$resolveAxisTranslate(transform.x, resolveBox.x), transform.scaleX, transform.scale, transform.originX);
    $0043a8a3eeedd876$export$625f1dd140a2f5e7(box.y, $0043a8a3eeedd876$var$resolveAxisTranslate(transform.y, resolveBox.y), transform.scaleY, transform.scale, transform.originY);
}


function $b3c78c86be367659$export$d8718b6a7e5c624e(instance, transformPoint) {
    return (0, $fd94cc0f2e3ce586$export$d3955c6a8f65a36b)((0, $fd94cc0f2e3ce586$export$21543fb75483a50)(instance.getBoundingClientRect(), transformPoint));
}
function $b3c78c86be367659$export$6a597be7a7940a96(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = $b3c78c86be367659$export$d8718b6a7e5c624e(element, transformPagePoint);
    const { scroll: scroll } = rootProjectionNode;
    if (scroll) {
        (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(viewportBox.x, scroll.offset.x);
        (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}


const $61e12cc57eeb85ed$export$605d60a2578142d3 = (value)=>Boolean(value && value.getVelocity);



const $3686a9bc645641a9$export$c66c0d5db2a205d = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, $36437dbf5b93c477$export$280dc01950909d86)
]);


/**
 * ValueType for "auto"
 */ const $cad1ef5802f691e6$export$dfb5619354ba860 = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};




const $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4 = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};


const $d1e8a31585ea6048$export$98e628dec113755e = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const $d1e8a31585ea6048$export$58f0f39f63f3cf42 = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $d1e8a31585ea6048$export$98e628dec113755e), {
    transform: (v)=>(0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, 1, v)
});
const $d1e8a31585ea6048$export$dcdf75081b88279d = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $d1e8a31585ea6048$export$98e628dec113755e), {
    default: 1
});


/*#__NO_SIDE_EFFECTS__*/ 

const $f1a72de1b348da89$var$createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const $f1a72de1b348da89$export$41fc368e1a942b97 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("deg");
const $f1a72de1b348da89$export$626336c2cd4b14de = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("%");
const $f1a72de1b348da89$export$91c0eda1d06bf008 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("px");
const $f1a72de1b348da89$export$f91e8c45a95a32f2 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("vh");
const $f1a72de1b348da89$export$aed3d7b7d206c196 = /*@__PURE__*/ $f1a72de1b348da89$var$createUnitType("vw");
const $f1a72de1b348da89$export$44e2e1705876d7ed = /*@__PURE__*/ (()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $f1a72de1b348da89$export$626336c2cd4b14de), {
        parse: (v)=>$f1a72de1b348da89$export$626336c2cd4b14de.parse(v) / 100,
        transform: (v)=>$f1a72de1b348da89$export$626336c2cd4b14de.transform(v * 100)
    }))();


/**
 * Tests a provided value against a ValueType
 */ const $c97168000d203dd0$export$6eae4d0a6a7ca7cd = (v)=>(type)=>type.test(v);


/**
 * A list of value types commonly used for dimensions
 */ const $a40f0a2352427e09$export$d176691c1998a1f5 = [
    (0, $d1e8a31585ea6048$export$98e628dec113755e),
    (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    (0, $f1a72de1b348da89$export$626336c2cd4b14de),
    (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    (0, $f1a72de1b348da89$export$aed3d7b7d206c196),
    (0, $f1a72de1b348da89$export$f91e8c45a95a32f2),
    (0, $cad1ef5802f691e6$export$dfb5619354ba860)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const $a40f0a2352427e09$export$eefdd52e3ccae428 = (v)=>$a40f0a2352427e09$export$d176691c1998a1f5.find((0, $c97168000d203dd0$export$6eae4d0a6a7ca7cd)(v));



let $19758d730238f0ed$export$491112666e282270 = ()=>{};
let $19758d730238f0ed$export$f5708dca728d7177 = ()=>{};
var $19758d730238f0ed$var$check, $19758d730238f0ed$var$message, $19758d730238f0ed$var$errorCode, $19758d730238f0ed$var$check1, $19758d730238f0ed$var$message1, $19758d730238f0ed$var$errorCode1;

/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ const $162a1451c8fa55b4$export$65583ed5a868f2d9 = (v)=>RegExp("^-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)$", "u").test(v);



/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const $89d5513ff5a37480$var$splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
RegExp("^var\\(--(?:([\\w-]+)|([\\w-]+), ?([a-zA-Z\\d ()%#.,-]+))\\)", "u");
function $89d5513ff5a37480$export$b9f0c1f373aee2b0(current) {
    const match = $89d5513ff5a37480$var$splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 !== null && token1 !== void 0 ? token1 : token2}`,
        fallback
    ];
}
const $89d5513ff5a37480$var$maxDepth = 4;
function $89d5513ff5a37480$export$289398774300c991(current, element, depth = 1) {
    (0, $19758d730238f0ed$export$f5708dca728d7177)(depth <= $89d5513ff5a37480$var$maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = $89d5513ff5a37480$export$b9f0c1f373aee2b0(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, $162a1451c8fa55b4$export$65583ed5a868f2d9)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, $8e08dd08a6f8a76d$export$31f9caa2600b5723)(fallback) ? $89d5513ff5a37480$export$289398774300c991(fallback, element, depth + 1) : fallback;
}



function $08d1bfadb48645d9$export$5a98a90409277f5a(keyframes) {
    var _keyframes_i;
    for(let i = 1; i < keyframes.length; i++)(_keyframes_i = keyframes[i]) !== null && _keyframes_i !== void 0 ? _keyframes_i : keyframes[i] = keyframes[i - 1];
}






const $8f9fb54630ee1595$export$8e5250d1aa9bf370 = (v)=>v === (0, $d1e8a31585ea6048$export$98e628dec113755e) || v === (0, $f1a72de1b348da89$export$91c0eda1d06bf008);
const $8f9fb54630ee1595$var$transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const $8f9fb54630ee1595$var$nonTranslationalTransformKeys = (0, $36437dbf5b93c477$export$280dc01950909d86).filter((key)=>!$8f9fb54630ee1595$var$transformKeys.has(key));
function $8f9fb54630ee1595$export$39d4bc9655f3f632(visualElement) {
    const removedTransforms = [];
    $8f9fb54630ee1595$var$nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const $8f9fb54630ee1595$export$781d46a8aa670d52 = {
    // Dimensions
    width: ({ x: x }, { paddingLeft: paddingLeft = "0", paddingRight: paddingRight = "0", boxSizing: boxSizing })=>{
        const width = x.max - x.min;
        return boxSizing === "border-box" ? width : width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: ({ y: y }, { paddingTop: paddingTop = "0", paddingBottom: paddingBottom = "0", boxSizing: boxSizing })=>{
        const height = y.max - y.min;
        return boxSizing === "border-box" ? height : height - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: (_bbox, { top: top })=>parseFloat(top),
    left: (_bbox, { left: left })=>parseFloat(left),
    bottom: ({ y: y }, { top: top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x: x }, { left: left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform: transform })=>(0, $f0207664133f4738$export$f9111f9e16b73a26)(transform, "x"),
    y: (_bbox, { transform: transform })=>(0, $f0207664133f4738$export$f9111f9e16b73a26)(transform, "y")
};
// Alias translate longform names
$8f9fb54630ee1595$export$781d46a8aa670d52.translateX = $8f9fb54630ee1595$export$781d46a8aa670d52.x;
$8f9fb54630ee1595$export$781d46a8aa670d52.translateY = $8f9fb54630ee1595$export$781d46a8aa670d52.y;


/*#__NO_SIDE_EFFECTS__*/ const $69d49105ec21595d$export$8793edee2d425525 = (any)=>any;


const $877fe7d159c5dd4c$export$dd826089e3c5e502 = {};


const $6df534696c4af587$export$71ecace0a033b35a = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];


const $7fcf3f225d921b82$export$84ce9a476f53d110 = {
    value: null,
    addProjectionMetrics: null
};


function $22c8543101d08652$export$b995e5e85f5c8289(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            // Swap this frame and the next to avoid GC
            const prevFrame = thisFrame;
            thisFrame = nextFrame;
            nextFrame = prevFrame;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) (0, $7fcf3f225d921b82$export$84ce9a476f53d110).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}


const $ebdeb8cab5a1d6c2$var$maxElapsed = 40;
function $ebdeb8cab5a1d6c2$export$510b0596a933801a(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, $6df534696c4af587$export$71ecace0a033b35a).reduce((acc, key)=>{
        acc[key] = (0, $22c8543101d08652$export$b995e5e85f5c8289)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup: setup, read: read, resolveKeyframes: resolveKeyframes, preUpdate: preUpdate, update: update, preRender: preRender, render: render, postRender: postRender } = steps;
    const processBatch = ()=>{
        const useManualTiming = (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).useManualTiming;
        const timestamp = useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, $ebdeb8cab5a1d6c2$var$maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, $6df534696c4af587$export$71ecace0a033b35a).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, $6df534696c4af587$export$71ecace0a033b35a).length; i++)steps[(0, $6df534696c4af587$export$71ecace0a033b35a)[i]].cancel(process);
    };
    return {
        schedule: schedule,
        cancel: cancel,
        state: state,
        steps: steps
    };
}


const { schedule: $44c600a9437aff7c$export$2cef06c20297c17d, cancel: $44c600a9437aff7c$export$ec99c0ef4978dccb, state: $44c600a9437aff7c$export$fff89137e9e818ce, steps: $44c600a9437aff7c$export$1811c3a7e3af92f0 } = /* @__PURE__ */ (0, $ebdeb8cab5a1d6c2$export$510b0596a933801a)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, $69d49105ec21595d$export$8793edee2d425525), true);


const $cf13d99b8a449fd0$var$toResolve = new Set();
let $cf13d99b8a449fd0$var$isScheduled = false;
let $cf13d99b8a449fd0$var$anyNeedsMeasurement = false;
let $cf13d99b8a449fd0$var$isForced = false;
function $cf13d99b8a449fd0$var$measureAllKeyframes() {
    if ($cf13d99b8a449fd0$var$anyNeedsMeasurement) {
        const resolversToMeasure = Array.from($cf13d99b8a449fd0$var$toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, $8f9fb54630ee1595$export$39d4bc9655f3f632)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                var _element_getValue;
                (_element_getValue = element.getValue(key)) === null || _element_getValue === void 0 ? void 0 : _element_getValue.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    $cf13d99b8a449fd0$var$anyNeedsMeasurement = false;
    $cf13d99b8a449fd0$var$isScheduled = false;
    $cf13d99b8a449fd0$var$toResolve.forEach((resolver)=>resolver.complete($cf13d99b8a449fd0$var$isForced));
    $cf13d99b8a449fd0$var$toResolve.clear();
}
function $cf13d99b8a449fd0$var$readAllKeyframes() {
    $cf13d99b8a449fd0$var$toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) $cf13d99b8a449fd0$var$anyNeedsMeasurement = true;
    });
}
function $cf13d99b8a449fd0$export$78b96d2a12593b05() {
    $cf13d99b8a449fd0$var$isForced = true;
    $cf13d99b8a449fd0$var$readAllKeyframes();
    $cf13d99b8a449fd0$var$measureAllKeyframes();
    $cf13d99b8a449fd0$var$isForced = false;
}
class $cf13d99b8a449fd0$export$74d34ca3182f1750 {
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            $cf13d99b8a449fd0$var$toResolve.add(this);
            if (!$cf13d99b8a449fd0$var$isScheduled) {
                $cf13d99b8a449fd0$var$isScheduled = true;
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).read($cf13d99b8a449fd0$var$readAllKeyframes);
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).resolveKeyframes($cf13d99b8a449fd0$var$measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name, element: element, motionValue: motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue === null || motionValue === void 0 ? void 0 : motionValue.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, $08d1bfadb48645d9$export$5a98a90409277f5a)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        $cf13d99b8a449fd0$var$toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            $cf13d99b8a449fd0$var$toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
}


/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ const $410126928ba5c7af$export$ade84c85e44a6cb1 = (v)=>RegExp("^0[^.\\s]+$", "u").test(v);


function $42f46c117bba2041$export$e56af863d5645d5f(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, $410126928ba5c7af$export$ade84c85e44a6cb1)(value);
    else return true;
}






// If this number is a decimal, make it just five decimal places
// to avoid exponents
const $76d9043daec1d091$export$83d2e9e3e4ee39ed = (v)=>Math.round(v * 100000) / 100000;


const $8d7fedef37ba0db5$export$2444ca58c08448e4 = RegExp("-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "gu");


function $b64c9e190d2d6cd7$export$b931b78cbb3caf86(v) {
    return v == null;
}


const $9148c009abbebc0f$export$ed808ff6ecd39e8d = RegExp("^(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))$", "iu");


/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const $e8d29973fdcfed04$export$2c8400d58aca05e = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, $9148c009abbebc0f$export$ed808ff6ecd39e8d).test(v) && v.startsWith(type) || testProp && !(0, $b64c9e190d2d6cd7$export$b931b78cbb3caf86)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const $e8d29973fdcfed04$export$73d6f35be992df24 = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, $8d7fedef37ba0db5$export$2444ca58c08448e4));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };


const $ff7a2ec6f726704e$var$clampRgbUnit = (v)=>(0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, 255, v);
const $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $d1e8a31585ea6048$export$98e628dec113755e)), {
    transform: (v)=>Math.round($ff7a2ec6f726704e$var$clampRgbUnit(v))
});
const $ff7a2ec6f726704e$export$4e46ac54fc82cf3b = {
    test: /*@__PURE__*/ (0, $e8d29973fdcfed04$export$2c8400d58aca05e)("rgb", "red"),
    parse: /*@__PURE__*/ (0, $e8d29973fdcfed04$export$73d6f35be992df24)("red", "green", "blue"),
    transform: ({ red: red, green: green, blue: blue, alpha: alpha$1 = 1 })=>"rgba(" + $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e.transform(red) + ", " + $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e.transform(green) + ", " + $ff7a2ec6f726704e$export$7a99c86b5b1f4c9e.transform(blue) + ", " + (0, $76d9043daec1d091$export$83d2e9e3e4ee39ed)((0, $d1e8a31585ea6048$export$58f0f39f63f3cf42).transform(alpha$1)) + ")"
};



function $90a7f54b29f1453c$var$parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const $90a7f54b29f1453c$export$834dfc94dde4b3d8 = {
    test: /*@__PURE__*/ (0, $e8d29973fdcfed04$export$2c8400d58aca05e)("#"),
    parse: $90a7f54b29f1453c$var$parseHex,
    transform: (0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).transform
};






const $f6f2a31cd5829bc5$export$810b04175080204c = {
    test: /*@__PURE__*/ (0, $e8d29973fdcfed04$export$2c8400d58aca05e)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, $e8d29973fdcfed04$export$73d6f35be992df24)("hue", "saturation", "lightness"),
    transform: ({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, $f1a72de1b348da89$export$626336c2cd4b14de).transform((0, $76d9043daec1d091$export$83d2e9e3e4ee39ed)(saturation)) + ", " + (0, $f1a72de1b348da89$export$626336c2cd4b14de).transform((0, $76d9043daec1d091$export$83d2e9e3e4ee39ed)(lightness)) + ", " + (0, $76d9043daec1d091$export$83d2e9e3e4ee39ed)((0, $d1e8a31585ea6048$export$58f0f39f63f3cf42).transform(alpha$1)) + ")";
    }
};



const $d252968ea52f42fd$export$35e9368ef982300f = {
    test: (v)=>(0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).test(v) || (0, $90a7f54b29f1453c$export$834dfc94dde4b3d8).test(v) || (0, $f6f2a31cd5829bc5$export$810b04175080204c).test(v),
    parse: (v)=>{
        if ((0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).test(v)) return (0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).parse(v);
        else if ((0, $f6f2a31cd5829bc5$export$810b04175080204c).test(v)) return (0, $f6f2a31cd5829bc5$export$810b04175080204c).parse(v);
        else return (0, $90a7f54b29f1453c$export$834dfc94dde4b3d8).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).transform(v) : (0, $f6f2a31cd5829bc5$export$810b04175080204c).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = $d252968ea52f42fd$export$35e9368ef982300f.parse(v);
        parsed.alpha = 0;
        return $d252968ea52f42fd$export$35e9368ef982300f.transform(parsed);
    }
};


const $391b60cd5158e163$export$740b69c5fad25dba = RegExp("(?:#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\))", "giu");




function $ce3767268d4e9ade$var$test(v) {
    var _v_match, _v_match1;
    return isNaN(v) && typeof v === "string" && (((_v_match = v.match((0, $8d7fedef37ba0db5$export$2444ca58c08448e4))) === null || _v_match === void 0 ? void 0 : _v_match.length) || 0) + (((_v_match1 = v.match((0, $391b60cd5158e163$export$740b69c5fad25dba))) === null || _v_match1 === void 0 ? void 0 : _v_match1.length) || 0) > 0;
}
const $ce3767268d4e9ade$var$NUMBER_TOKEN = "number";
const $ce3767268d4e9ade$var$COLOR_TOKEN = "color";
const $ce3767268d4e9ade$var$VAR_TOKEN = "var";
const $ce3767268d4e9ade$var$VAR_FUNCTION_TOKEN = "var(";
const $ce3767268d4e9ade$var$SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const $ce3767268d4e9ade$var$complexRegex = RegExp("var\\s*\\(\\s*--(?:[\\w-]+\\s*|[\\w-]+\\s*,(?:\\s*[^)(\\s]|\\s*\\((?:[^)(]|\\([^)(]*\\))*\\))+\\s*)\\)|#[\\da-f]{3,8}|(?:rgb|hsl)a?\\((?:-?[\\d.]+%?[,\\s]+){2}-?[\\d.]+%?\\s*(?:[,/]\\s*)?(?:\\b\\d+(?:\\.\\d+)?|\\.\\d+)?%?\\)|-?(?:\\d+(?:\\.\\d+)?|\\.\\d+)", "giu");
function $ce3767268d4e9ade$export$b61fc7c44bf646d5(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace($ce3767268d4e9ade$var$complexRegex, (parsedValue)=>{
        if ((0, $d252968ea52f42fd$export$35e9368ef982300f).test(parsedValue)) {
            indexes.color.push(i);
            types.push($ce3767268d4e9ade$var$COLOR_TOKEN);
            values.push((0, $d252968ea52f42fd$export$35e9368ef982300f).parse(parsedValue));
        } else if (parsedValue.startsWith($ce3767268d4e9ade$var$VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push($ce3767268d4e9ade$var$VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push($ce3767268d4e9ade$var$NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return $ce3767268d4e9ade$var$SPLIT_TOKEN;
    });
    const split = tokenised.split($ce3767268d4e9ade$var$SPLIT_TOKEN);
    return {
        values: values,
        split: split,
        indexes: indexes,
        types: types
    };
}
function $ce3767268d4e9ade$var$parseComplexValue(v) {
    return $ce3767268d4e9ade$export$b61fc7c44bf646d5(v).values;
}
function $ce3767268d4e9ade$var$buildTransformer({ split: split, types: types }) {
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === $ce3767268d4e9ade$var$NUMBER_TOKEN) output += (0, $76d9043daec1d091$export$83d2e9e3e4ee39ed)(v[i]);
                else if (type === $ce3767268d4e9ade$var$COLOR_TOKEN) output += (0, $d252968ea52f42fd$export$35e9368ef982300f).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
function $ce3767268d4e9ade$var$createTransformer(source) {
    return $ce3767268d4e9ade$var$buildTransformer($ce3767268d4e9ade$export$b61fc7c44bf646d5(source));
}
const $ce3767268d4e9ade$var$convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, $d252968ea52f42fd$export$35e9368ef982300f).test(v) ? (0, $d252968ea52f42fd$export$35e9368ef982300f).getAnimatableNone(v) : v;
/**
 * Convert a parsed value to its zero equivalent, but preserve numbers
 * that act as divisors in CSS calc() expressions.
 *
 * analyseComplexValue extracts numbers from CSS strings and puts the
 * surrounding text into a `split` template array. For example:
 *   "calc(var(--gap) / 5)"  →  values: [var(--gap), 5]
 *                               split:  ["calc(", " / ", ")"]
 *
 * When building a zero-equivalent for animation, naively zeroing all
 * numbers turns the divisor into 0 → "calc(var(--gap) / 0)" → NaN.
 * We detect this by checking whether the text preceding a number
 * (split[i]) ends with "/" — the CSS calc division operator.
 */ const $ce3767268d4e9ade$var$convertToZero = (value, splitBefore)=>{
    if (typeof value === "number") return (splitBefore === null || splitBefore === void 0 ? void 0 : splitBefore.trim().endsWith("/")) ? value : 0;
    return $ce3767268d4e9ade$var$convertNumbersToZero(value);
};
function $ce3767268d4e9ade$var$getAnimatableNone(v) {
    const info = $ce3767268d4e9ade$export$b61fc7c44bf646d5(v);
    const transformer = $ce3767268d4e9ade$var$buildTransformer(info);
    return transformer(info.values.map((value, i)=>$ce3767268d4e9ade$var$convertToZero(value, info.split[i])));
}
const $ce3767268d4e9ade$export$83a0e34f1302825b = {
    test: $ce3767268d4e9ade$var$test,
    parse: $ce3767268d4e9ade$var$parseComplexValue,
    createTransformer: $ce3767268d4e9ade$var$createTransformer,
    getAnimatableNone: $ce3767268d4e9ade$var$getAnimatableNone
};







/**
 * Properties that should default to 1 or 100%
 */ const $5eadb906d7cb4f97$var$maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function $5eadb906d7cb4f97$var$applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, $8d7fedef37ba0db5$export$2444ca58c08448e4)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = $5eadb906d7cb4f97$var$maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const $5eadb906d7cb4f97$var$functionRegex = RegExp("\\b([a-z-]*)\\(.*?\\)", "gu");
const $5eadb906d7cb4f97$export$3dea766d36a8935f = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $ce3767268d4e9ade$export$83a0e34f1302825b)), {
    getAnimatableNone: (v)=>{
        const functions = v.match($5eadb906d7cb4f97$var$functionRegex);
        return functions ? functions.map($5eadb906d7cb4f97$var$applyDefaultFilter).join(" ") : v;
    }
});





const $68dbe71415cdbee1$export$d99f0801a68bbcf1 = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $ce3767268d4e9ade$export$83a0e34f1302825b)), {
    getAnimatableNone: (v)=>{
        const parsed = (0, $ce3767268d4e9ade$export$83a0e34f1302825b).parse(v);
        const transformer = (0, $ce3767268d4e9ade$export$83a0e34f1302825b).createTransformer(v);
        return transformer(parsed.map((v)=>typeof v === "number" ? 0 : typeof v === "object" ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, v), {
                alpha: 1
            }) : v));
    }
});












const $8e24186f0b4b6a11$export$7d260a2a5f8bc19e = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $d1e8a31585ea6048$export$98e628dec113755e)), {
    transform: Math.round
});






const $134d2ed44a1eadc8$export$f2e4285fee37e26 = {
    rotate: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    /**
     * Internal channel for `transition.path` orientToPath. Composed onto
     * `rotate` at the transform-build sites so the user's `rotate` is
     * never read or overwritten. Not part of `transformPropOrder`.
     */ pathRotation: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    rotateX: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    rotateY: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    rotateZ: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    scale: $d1e8a31585ea6048$export$dcdf75081b88279d,
    scaleX: (0, $d1e8a31585ea6048$export$dcdf75081b88279d),
    scaleY: (0, $d1e8a31585ea6048$export$dcdf75081b88279d),
    scaleZ: (0, $d1e8a31585ea6048$export$dcdf75081b88279d),
    skew: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    skewX: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    skewY: (0, $f1a72de1b348da89$export$41fc368e1a942b97),
    distance: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    translateX: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    translateY: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    translateZ: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    x: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    y: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    z: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    perspective: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    transformPerspective: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    opacity: (0, $d1e8a31585ea6048$export$58f0f39f63f3cf42),
    originX: (0, $f1a72de1b348da89$export$44e2e1705876d7ed),
    originY: (0, $f1a72de1b348da89$export$44e2e1705876d7ed),
    originZ: (0, $f1a72de1b348da89$export$91c0eda1d06bf008)
};


const $d954abda96ea0996$export$eec14432cd1cb67b = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
    // Border props
    borderWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderTopWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderRightWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderBottomWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderLeftWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderRadius: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderTopLeftRadius: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderTopRightRadius: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderBottomRightRadius: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    borderBottomLeftRadius: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    // Positioning props
    width: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    maxWidth: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    height: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    maxHeight: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    top: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    right: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    bottom: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    left: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    inset: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetBlock: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetBlockStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetBlockEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetInline: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetInlineStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    insetInlineEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    // Spacing props
    padding: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingTop: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingRight: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingBottom: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingLeft: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingBlock: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingBlockStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingBlockEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingInline: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingInlineStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    paddingInlineEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    margin: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginTop: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginRight: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginBottom: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginLeft: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginBlock: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginBlockStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginBlockEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginInline: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginInlineStart: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    marginInlineEnd: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    // Typography
    fontSize: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    // Misc
    backgroundPositionX: (0, $f1a72de1b348da89$export$91c0eda1d06bf008),
    backgroundPositionY: (0, $f1a72de1b348da89$export$91c0eda1d06bf008)
}, (0, $134d2ed44a1eadc8$export$f2e4285fee37e26)), {
    zIndex: (0, $8e24186f0b4b6a11$export$7d260a2a5f8bc19e),
    // SVG
    fillOpacity: (0, $d1e8a31585ea6048$export$58f0f39f63f3cf42),
    strokeOpacity: (0, $d1e8a31585ea6048$export$58f0f39f63f3cf42),
    numOctaves: (0, $8e24186f0b4b6a11$export$7d260a2a5f8bc19e)
});


/**
 * A map of default value types for common values
 */ const $4f34bdc9b52d7b1d$export$98cd7c72c5a731fb = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $d954abda96ea0996$export$eec14432cd1cb67b)), {
    color: // Color props
    $d252968ea52f42fd$export$35e9368ef982300f,
    backgroundColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    outlineColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    fill: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    stroke: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    // Border props
    borderColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    borderTopColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    borderRightColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    borderBottomColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    borderLeftColor: (0, $d252968ea52f42fd$export$35e9368ef982300f),
    filter: $5eadb906d7cb4f97$export$3dea766d36a8935f,
    WebkitFilter: (0, $5eadb906d7cb4f97$export$3dea766d36a8935f),
    mask: $68dbe71415cdbee1$export$d99f0801a68bbcf1,
    WebkitMask: (0, $68dbe71415cdbee1$export$d99f0801a68bbcf1)
});
/**
 * Gets the default ValueType for the provided value key
 */ const $4f34bdc9b52d7b1d$export$67d1babe0338d23b = (key)=>$4f34bdc9b52d7b1d$export$98cd7c72c5a731fb[key];


const $a6324f331d30f12e$var$customTypes = /*@__PURE__*/ new Set([
    (0, $5eadb906d7cb4f97$export$3dea766d36a8935f),
    (0, $68dbe71415cdbee1$export$d99f0801a68bbcf1)
]);
function $a6324f331d30f12e$export$cea0cedcb94873b5(key, value) {
    let defaultValueType = (0, $4f34bdc9b52d7b1d$export$67d1babe0338d23b)(key);
    if (!$a6324f331d30f12e$var$customTypes.has(defaultValueType)) defaultValueType = (0, $ce3767268d4e9ade$export$83a0e34f1302825b);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}


/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const $b33deb06f6bb5c07$var$invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function $b33deb06f6bb5c07$export$8cc4958f8e540f37(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !$b33deb06f6bb5c07$var$invalidTemplates.has(keyframe) && (0, $ce3767268d4e9ade$export$b61fc7c44bf646d5)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, $a6324f331d30f12e$export$cea0cedcb94873b5)(name, animatableTemplate);
}



class $6543679a34c2f697$export$4983792d11b61017 extends (0, $cf13d99b8a449fd0$export$74d34ca3182f1750) {
    readKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, element: element, name: name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, $8e08dd08a6f8a76d$export$31f9caa2600b5723)(keyframe)) {
                    const resolved = (0, $89d5513ff5a37480$export$289398774300c991)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, $3686a9bc645641a9$export$c66c0d5db2a205d).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, $a40f0a2352427e09$export$eefdd52e3ccae428)(origin);
        const targetType = (0, $a40f0a2352427e09$export$eefdd52e3ccae428)(target);
        /**
         * If one keyframe contains embedded CSS variables (e.g. in calc()) and the other
         * doesn't, we need to measure to convert to pixels. This handles GitHub issue #3410.
         */ const originHasVar = (0, $8e08dd08a6f8a76d$export$df8f90ab5d0b05fa)(origin);
        const targetHasVar = (0, $8e08dd08a6f8a76d$export$df8f90ab5d0b05fa)(target);
        if (originHasVar !== targetHasVar && (0, $8f9fb54630ee1595$export$781d46a8aa670d52)[name]) {
            this.needsMeasurement = true;
            return;
        }
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, $8f9fb54630ee1595$export$8e5250d1aa9bf370)(originType) && (0, $8f9fb54630ee1595$export$8e5250d1aa9bf370)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, $8f9fb54630ee1595$export$781d46a8aa670d52)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, $42f46c117bba2041$export$e56af863d5645d5f)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, $b33deb06f6bb5c07$export$8cc4958f8e540f37)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element: element, unresolvedKeyframes: unresolvedKeyframes, name: name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, $8f9fb54630ee1595$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        var _this_removedTransforms;
        const { element: element, name: name, unresolvedKeyframes: unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, $8f9fb54630ee1595$export$781d46a8aa670d52)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if ((_this_removedTransforms = this.removedTransforms) === null || _this_removedTransforms === void 0 ? void 0 : _this_removedTransforms.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
}




/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ const $d17a7d2c2068c118$export$fc3e7e8557f8c8c7 = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const $d17a7d2c2068c118$export$f64c3bfbc58eec0f = (milliseconds)=>milliseconds / 1000;

function $3fbb49f840f4b07a$export$20e507e47fae79fd(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function $3fbb49f840f4b07a$export$fe2d9b4e03920b4c(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function $3fbb49f840f4b07a$export$ec937e64de6c1257([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}


class $530b27a3f7a9b181$export$e7dff9482a5fd23c {
    add(handler) {
        (0, $3fbb49f840f4b07a$export$20e507e47fae79fd)(this.subscriptions, handler);
        return ()=>(0, $3fbb49f840f4b07a$export$fe2d9b4e03920b4c)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
    constructor(){
        this.subscriptions = [];
    }
}




const $1abad52e84ac08f3$export$c9f584638d388483 = (name)=>name.startsWith("--");


function $0055d05149405828$export$37a5fde709c1db82(element, name, value) {
    (0, $1abad52e84ac08f3$export$c9f584638d388483)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}


/*#__NO_SIDE_EFFECTS__*/ function $373ae0ce1db34355$export$7c73462e0d25e514(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}


/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ const $2e8f1cca8189061f$export$e3ad02c335474dee = {};


function $3361179f8f81e58e$export$1964673d5ec13c3a(callback, supportsFlag) {
    const memoized = (0, $373ae0ce1db34355$export$7c73462e0d25e514)(callback);
    return ()=>{
        var _supportsFlags_supportsFlag;
        return (_supportsFlags_supportsFlag = (0, $2e8f1cca8189061f$export$e3ad02c335474dee)[supportsFlag]) !== null && _supportsFlags_supportsFlag !== void 0 ? _supportsFlags_supportsFlag : memoized();
    };
}


const $cf8d7908a6543c98$export$20d68f04f30763a5 = /* @__PURE__ */ (0, $3361179f8f81e58e$export$1964673d5ec13c3a)(()=>window.ScrollTimeline !== undefined, "scrollTimeline");
const $cf8d7908a6543c98$export$206321d8c5f8fd38 = /* @__PURE__ */ (0, $3361179f8f81e58e$export$1964673d5ec13c3a)(()=>window.ViewTimeline !== undefined, "viewTimeline");


const $fc831f8861054717$var$isNotNull = (value)=>value !== null;
function $fc831f8861054717$export$14de59408fad90b(keyframes, { repeat: repeat, repeatType: repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter($fc831f8861054717$var$isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}


class $6940fcbd8d4ca66f$export$655db786091c33e0 {
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
    constructor(){
        this.updateFinished();
    }
}


const $86c9ef19d62de386$export$d921fb2475e2900c = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};



/*#__NO_SIDE_EFFECTS__*/ const $09983ccc000b48c8$export$ff43f99925d7366b = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";



const $ab271ab2951341fd$export$866c1d07a1ac2ab = /*@__PURE__*/ (0, $3361179f8f81e58e$export$1964673d5ec13c3a)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");


const $0e9dc36f6f7cb032$export$66d3851e2b1ec912 = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};


const $6fd375bd8200fb33$export$2523b8f0bd8f44cb = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;



const $7fa95de4cb88f140$export$2cf569f5e2221176 = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, $6fd375bd8200fb33$export$2523b8f0bd8f44cb)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, $6fd375bd8200fb33$export$2523b8f0bd8f44cb)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, $6fd375bd8200fb33$export$2523b8f0bd8f44cb)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, $6fd375bd8200fb33$export$2523b8f0bd8f44cb)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};


function $5c7ca815419a9c0b$export$916ea73bcd3a6030(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, $ab271ab2951341fd$export$866c1d07a1ac2ab)() ? (0, $0e9dc36f6f7cb032$export$66d3851e2b1ec912)(easing, duration) : "ease-out";
    else if ((0, $09983ccc000b48c8$export$ff43f99925d7366b)(easing)) return (0, $6fd375bd8200fb33$export$2523b8f0bd8f44cb)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>$5c7ca815419a9c0b$export$916ea73bcd3a6030(segmentEasing, duration) || (0, $7fa95de4cb88f140$export$2cf569f5e2221176).easeOut);
    else return (0, $7fa95de4cb88f140$export$2cf569f5e2221176)[easing];
}


function $583566263f64a846$export$d896de52f97cb615(element, valueName, keyframes, { delay: delay = 0, duration: duration = 300, repeat: repeat = 0, repeatType: repeatType = "loop", ease: ease = "easeOut", times: times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, $5c7ca815419a9c0b$export$916ea73bcd3a6030)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) (0, $86c9ef19d62de386$export$d921fb2475e2900c).waapi++;
    const options = {
        delay: delay,
        duration: duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) animation.finished.finally(()=>{
        (0, $86c9ef19d62de386$export$d921fb2475e2900c).waapi--;
    });
    return animation;
}




function $7499953f74b707a4$export$6ab7812f1bac68be(type) {
    return typeof type === "function" && "applyToOptions" in type;
}


function $53d8149960f311f6$export$a31269144d66b4a(_param) {
    var { type: type } = _param, options = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "type"
    ]);
    if ((0, $7499953f74b707a4$export$6ab7812f1bac68be)(type) && (0, $ab271ab2951341fd$export$866c1d07a1ac2ab)()) return type.applyToOptions(options);
    else {
        var _options_duration;
        (_options_duration = options.duration) !== null && _options_duration !== void 0 ? _options_duration : options.duration = 300;
        var _options_ease;
        (_options_ease = options.ease) !== null && _options_ease !== void 0 ? _options_ease : options.ease = "easeOut";
    }
    return options;
}


/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class $d40de0a79038d88e$export$6c0f9803d8aa7219 extends (0, $6940fcbd8d4ca66f$export$655db786091c33e0) {
    play() {
        if (this.isStopped) return;
        this.manualStartTime = null;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        var _this_animation_finish, _this_animation;
        (_this_animation_finish = (_this_animation = this.animation).finish) === null || _this_animation_finish === void 0 ? void 0 : _this_animation_finish.call(_this_animation);
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state: state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        var _this_options, _this_animation_commitStyles, _this_animation;
        const element = (_this_options = this.options) === null || _this_options === void 0 ? void 0 : _this_options.element;
        if (!this.isPseudoElement && (element === null || element === void 0 ? void 0 : element.isConnected)) (_this_animation_commitStyles = (_this_animation = this.animation).commitStyles) === null || _this_animation_commitStyles === void 0 ? void 0 : _this_animation_commitStyles.call(_this_animation);
    }
    get duration() {
        var _this_animation_effect_getComputedTiming, _this_animation_effect;
        const duration = ((_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : (_this_animation_effect_getComputedTiming = _this_animation_effect.getComputedTiming) === null || _this_animation_effect_getComputedTiming === void 0 ? void 0 : _this_animation_effect_getComputedTiming.call(_this_animation_effect).duration) || 0;
        return (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(Number(duration));
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        const wasFinished = this.finishedTime !== null;
        this.manualStartTime = null;
        this.finishedTime = null;
        this.animation.currentTime = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(newTime);
        if (wasFinished) this.animation.pause();
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        var _this_manualStartTime;
        return (_this_manualStartTime = this.manualStartTime) !== null && _this_manualStartTime !== void 0 ? _this_manualStartTime : Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.manualStartTime = this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline: timeline, rangeStart: rangeStart, rangeEnd: rangeEnd, observe: observe }) {
        var _this_animation_effect;
        if (this.allowFlatten) (_this_animation_effect = this.animation.effect) === null || _this_animation_effect === void 0 ? void 0 : _this_animation_effect.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, $cf8d7908a6543c98$export$20d68f04f30763a5)()) {
            this.animation.timeline = timeline;
            if (rangeStart) this.animation.rangeStart = rangeStart;
            if (rangeEnd) this.animation.rangeEnd = rangeEnd;
            return 0, $69d49105ec21595d$export$8793edee2d425525;
        } else return observe(this);
    }
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        /**
         * Tracks a manually-set start time that takes precedence over WAAPI's
         * dynamic startTime. This is cleared when play() or time setter is called,
         * allowing WAAPI to take over timing.
         */ this.manualStartTime = null;
        if (!options) return;
        const { element: element, name: name, keyframes: keyframes, pseudoElement: pseudoElement, allowFlatten: allowFlatten = false, finalKeyframe: finalKeyframe, onComplete: onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, $19758d730238f0ed$export$f5708dca728d7177)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, $53d8149960f311f6$export$a31269144d66b4a)(options);
        this.animation = (0, $583566263f64a846$export$d896de52f97cb615)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, $fc831f8861054717$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                /**
                 * If we can, we want to commit the final style as set by the user,
                 * rather than the computed keyframe value supplied by the animation.
                 * We always do this, even when a motion value is present, to prevent
                 * a visual flash in Firefox where the WAAPI animation's fill is removed
                 * during cancel() before the scheduled render can apply the correct value.
                 */ (0, $0055d05149405828$export$37a5fde709c1db82)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
            this.notifyFinished();
        };
    }
}


/**
 * A list of values that can be hardware-accelerated.
 */ const $95afec150de2825d$export$a27eefbd8fb5e404 = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);



const { schedule: $4cb138f42ee448c1$export$bb76eed83315504c, cancel: $4cb138f42ee448c1$export$3252729004b8456e } = /* @__PURE__ */ (0, $ebdeb8cab5a1d6c2$export$510b0596a933801a)(queueMicrotask, false);




let $2a28679c5e08a25b$var$now;
function $2a28679c5e08a25b$var$clearTime() {
    $2a28679c5e08a25b$var$now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const $2a28679c5e08a25b$export$2da9be4cfdb689b1 = {
    now: ()=>{
        if ($2a28679c5e08a25b$var$now === undefined) $2a28679c5e08a25b$export$2da9be4cfdb689b1.set((0, $44c600a9437aff7c$export$fff89137e9e818ce).isProcessing || (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).useManualTiming ? (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp : performance.now());
        return $2a28679c5e08a25b$var$now;
    },
    set: (newTime)=>{
        $2a28679c5e08a25b$var$now = newTime;
        queueMicrotask($2a28679c5e08a25b$var$clearTime);
    }
};


const $a0d315cc230b7b79$export$ff25708b37f72782 = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const $a0d315cc230b7b79$export$3d227df54007d73a = ()=>({
        x: $a0d315cc230b7b79$export$ff25708b37f72782(),
        y: $a0d315cc230b7b79$export$ff25708b37f72782()
    });
const $a0d315cc230b7b79$export$6db76765312617ac = ()=>({
        min: 0,
        max: 0
    });
const $a0d315cc230b7b79$export$6459fc9e86be362e = ()=>({
        x: $a0d315cc230b7b79$export$6db76765312617ac(),
        y: $a0d315cc230b7b79$export$6db76765312617ac()
    });


/*
  Convert velocity into velocity per second
*/ /*#__NO_SIDE_EFFECTS__*/ const $53435ded96da5381$export$eab0632f7ad4f9d7 = (velocity, frameDuration)=>frameDuration ? velocity * (1000 / frameDuration) : 0;




/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const $eba58299b894994c$var$MAX_VELOCITY_DELTA = 30;
const $eba58299b894994c$var$isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const $eba58299b894994c$export$67fcd818a264039d = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class $eba58299b894994c$export$8cea36d14ee64562 {
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = $eba58299b894994c$var$isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $530b27a3f7a9b181$export$e7dff9482a5fd23c)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, $44c600a9437aff7c$export$2cef06c20297c17d).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        var _this_events_change;
        (_this_events_change = this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if ($eba58299b894994c$export$67fcd818a264039d.current) $eba58299b894994c$export$67fcd818a264039d.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > $eba58299b894994c$var$MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, $eba58299b894994c$var$MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, $53435ded96da5381$export$eab0632f7ad4f9d7)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        var _this_dependents, _this_events_destroy;
        (_this_dependents = this.dependents) === null || _this_dependents === void 0 ? void 0 : _this_dependents.clear();
        (_this_events_destroy = this.events.destroy) === null || _this_events_destroy === void 0 ? void 0 : _this_events_destroy.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                var _this_events_change;
                (_this_events_change = this.events.change) === null || _this_events_change === void 0 ? void 0 : _this_events_change.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
}
function $eba58299b894994c$export$ce8bdc721e76545f(init, options) {
    return new $eba58299b894994c$export$8cea36d14ee64562(init, options);
}








/**
 * A list of all ValueTypes
 */ const $d47a0afa4e4d071c$var$valueTypes = [
    ...(0, $a40f0a2352427e09$export$d176691c1998a1f5),
    (0, $d252968ea52f42fd$export$35e9368ef982300f),
    (0, $ce3767268d4e9ade$export$83a0e34f1302825b)
];
/**
 * Tests a value against the list of ValueTypes
 */ const $d47a0afa4e4d071c$export$950e7e59ea1ffed7 = (v)=>$d47a0afa4e4d071c$var$valueTypes.find((0, $c97168000d203dd0$export$6eae4d0a6a7ca7cd)(v));



const $44b14b06958d6f59$export$bc2a978a17abfdde = new WeakMap();


function $197e81262ee8f44d$export$aa71198ceeaf53ce(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}


/**
 * Decides if the supplied variable is variant label
 */ function $b2fb93622bbd7df5$export$720b90e312cea233(v) {
    return typeof v === "string" || Array.isArray(v);
}


const $c8a0734e2ee77275$export$16e45afcc206d3a8 = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const $c8a0734e2ee77275$export$1405a65085f40b9 = [
    "initial",
    ...$c8a0734e2ee77275$export$16e45afcc206d3a8
];


function $05ee406980932703$export$4b3c3bd8d910d78d(props) {
    return (0, $197e81262ee8f44d$export$aa71198ceeaf53ce)(props.animate) || (0, $c8a0734e2ee77275$export$1405a65085f40b9).some((name)=>(0, $b2fb93622bbd7df5$export$720b90e312cea233)(props[name]));
}
function $05ee406980932703$export$ce46fa4165cdec40(props) {
    return Boolean($05ee406980932703$export$4b3c3bd8d910d78d(props) || props.variants);
}





/**
 * Updates motion values from props changes.
 * Uses `any` type for element to avoid circular dependencies with VisualElement.
 */ function $16da05f34cd867a6$export$9a552858d5197f6e(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, $eba58299b894994c$export$ce8bdc721e76545f)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, $eba58299b894994c$export$ce8bdc721e76545f)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}


// Does this device prefer reduced motion? Returns `null` server-side.
const $ab7a52d88671d240$export$ff7706047246b98b = {
    current: null
};
const $ab7a52d88671d240$export$6476d16e2fd2d0db = {
    current: false
};


const $904a5ee8b5b90ab9$var$isBrowser = typeof window !== "undefined";
function $904a5ee8b5b90ab9$export$ca9f41fb23dded3d() {
    (0, $ab7a52d88671d240$export$6476d16e2fd2d0db).current = true;
    if (!$904a5ee8b5b90ab9$var$isBrowser) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, $ab7a52d88671d240$export$ff7706047246b98b).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, $ab7a52d88671d240$export$ff7706047246b98b).current = false;
}


function $20ea58c6853b5985$var$getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement === null || visualElement === void 0 ? void 0 : visualElement.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function $20ea58c6853b5985$export$d68f140c4d9b48bc(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = $20ea58c6853b5985$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = $20ea58c6853b5985$var$getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}




const $67fdc880829ae48a$var$propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * Static feature definitions - can be injected by framework layer
 */ let $67fdc880829ae48a$var$featureDefinitions = {};
/**
 * Set feature definitions for all VisualElements.
 * This should be called by the framework layer (e.g., framer-motion) during initialization.
 */ function $67fdc880829ae48a$export$8ad214844176d967(definitions) {
    $67fdc880829ae48a$var$featureDefinitions = definitions;
}
/**
 * Get the current feature definitions
 */ function $67fdc880829ae48a$export$e183cb9c018608ba() {
    return $67fdc880829ae48a$var$featureDefinitions;
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class $67fdc880829ae48a$export$fa8b653c0f3714e5 {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    mount(instance) {
        var _this_parent;
        /**
         * If this element has been mounted before (e.g. after a Suspense
         * unmount/remount), reset motion values to their initial state
         * so animations replay correctly from initial → animate.
         */ if (this.hasBeenMounted) for(const key in this.initialValues){
            var _this_values_get;
            (_this_values_get = this.values.get(key)) === null || _this_values_get === void 0 ? void 0 : _this_values_get.jump(this.initialValues[key]);
            this.latestValues[key] = this.initialValues[key];
        }
        this.current = instance;
        (0, $44b14b06958d6f59$export$bc2a978a17abfdde).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        /**
         * Determine reduced motion preference. Only initialize the matchMedia
         * listener if we actually need the dynamic value (i.e., when config
         * is neither "never" nor "always").
         */ if (this.reducedMotionConfig === "never") this.shouldReduceMotion = false;
        else if (this.reducedMotionConfig === "always") this.shouldReduceMotion = true;
        else {
            if (!(0, $ab7a52d88671d240$export$6476d16e2fd2d0db).current) (0, $904a5ee8b5b90ab9$export$ca9f41fb23dded3d)();
            this.shouldReduceMotion = (0, $ab7a52d88671d240$export$ff7706047246b98b).current;
        }
        var _this_skipAnimationsConfig;
        /**
         * Set whether animations should be skipped based on the config.
         */ this.shouldSkipAnimations = (_this_skipAnimationsConfig = this.skipAnimationsConfig) !== null && _this_skipAnimationsConfig !== void 0 ? _this_skipAnimationsConfig : false;
        (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.addChild(this);
        this.update(this.props, this.presenceContext);
        this.hasBeenMounted = true;
    }
    unmount() {
        var _this_parent;
        this.projection && this.projection.unmount();
        (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(this.notifyUpdate);
        (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        var _this_enteringChildren;
        (_this_enteringChildren = this.enteringChildren) !== null && _this_enteringChildren !== void 0 ? _this_enteringChildren : this.enteringChildren = new Set();
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        if (value.accelerate && (0, $95afec150de2825d$export$a27eefbd8fb5e404).has(key) && this.current instanceof HTMLElement) {
            const { factory: factory, keyframes: keyframes, times: times, ease: ease, duration: duration } = value.accelerate;
            const animation = new (0, $d40de0a79038d88e$export$6c0f9803d8aa7219)({
                element: this.current,
                name: key,
                keyframes: keyframes,
                times: times,
                ease: ease,
                duration: (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(duration)
            });
            const cleanup = factory(animation);
            this.valueSubscriptions.set(key, ()=>{
                cleanup();
                animation.cancel();
            });
            return;
        }
        const valueIsTransform = (0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, $44c600a9437aff7c$export$2cef06c20297c17d).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (typeof window !== "undefined" && window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
        // Defer to MotionValue.on("change") auto-stop so React 19 remounts
        // can resubscribe before the animation is cancelled (#3315).
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in $67fdc880829ae48a$var$featureDefinitions){
            const featureDefinition = $67fdc880829ae48a$var$featureDefinitions[key];
            if (!featureDefinition) continue;
            const { isEnabled: isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < $67fdc880829ae48a$var$propEventHandlers.length; i++){
            const key = $67fdc880829ae48a$var$propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, $16da05f34cd867a6$export$9a552858d5197f6e)(this, this.scrapeMotionValuesFromProps(props, this.prevProps || {}, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, $eba58299b894994c$export$ce8bdc721e76545f)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        var _this_getBaseTargetFromProps;
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : (_this_getBaseTargetFromProps = this.getBaseTargetFromProps(this.props, key)) !== null && _this_getBaseTargetFromProps !== void 0 ? _this_getBaseTargetFromProps : this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, $162a1451c8fa55b4$export$65583ed5a868f2d9)(value) || (0, $410126928ba5c7af$export$ade84c85e44a6cb1)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, $d47a0afa4e4d071c$export$950e7e59ea1ffed7)(value) && (0, $ce3767268d4e9ade$export$83a0e34f1302825b).test(target)) value = (0, $a6324f331d30f12e$export$cea0cedcb94873b5)(key, target);
            this.setBaseTarget(key, (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value) ? value.get() : value);
        }
        return (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial: initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            var _this_presenceContext;
            const variant = (0, $20ea58c6853b5985$export$d68f140c4d9b48bc)(this.props, initial, (_this_presenceContext = this.presenceContext) === null || _this_presenceContext === void 0 ? void 0 : _this_presenceContext.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, $61e12cc57eeb85ed$export$605d60a2578142d3)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, $530b27a3f7a9b181$export$e7dff9482a5fd23c)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, $4cb138f42ee448c1$export$bb76eed83315504c).render(this.render);
    }
    constructor({ parent: parent, props: props, presenceContext: presenceContext, reducedMotionConfig: reducedMotionConfig, skipAnimations: skipAnimations, blockInitialAnimation: blockInitialAnimation, visualState: visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * Decides whether animations should be skipped for this VisualElement.
         * Useful for E2E tests and visual regression testing.
         */ this.shouldSkipAnimations = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, $cf13d99b8a449fd0$export$74d34ca3182f1750);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * Track whether this element has been mounted before, to detect
         * remounts after Suspense unmount/remount cycles.
         */ this.hasBeenMounted = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).render(this.render, false, true);
            }
        };
        const { latestValues: latestValues, renderState: renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, latestValues);
        this.initialValues = props.initial ? (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, latestValues) : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.skipAnimationsConfig = skipAnimations;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, $05ee406980932703$export$4b3c3bd8d910d78d)(props);
        this.isVariantNode = (0, $05ee406980932703$export$ce46fa4165cdec40)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const _this_scrapeMotionValuesFromProps = this.scrapeMotionValuesFromProps(props, {}, this), { willChange: willChange } = _this_scrapeMotionValuesFromProps, initialMotionValues = (0, $8901fc92b5563702$export$71511d61b312f219)(_this_scrapeMotionValuesFromProps, [
            "willChange"
        ]);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value)) value.set(latestValues[key]);
        }
    }
}


class $dba06d9a16f9b2fd$export$e49735c2a366bdc7 extends (0, $67fdc880829ae48a$export$fa8b653c0f3714e5) {
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        const style = props.style;
        return style ? style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars: vars, style: style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children: children } = this.props;
        if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, $6543679a34c2f697$export$4983792d11b61017);
    }
}


/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ const $1f8f8a4cd1b31868$export$453ef540a9a1bd6b = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};








const $780bba6e980489ff$var$translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const $780bba6e980489ff$var$numTransforms = (0, $36437dbf5b93c477$export$280dc01950909d86).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function $780bba6e980489ff$export$bdc96e0d5c8f914(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < $780bba6e980489ff$var$numTransforms; i++){
        const key = (0, $36437dbf5b93c477$export$280dc01950909d86)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            const parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, $1f8f8a4cd1b31868$export$453ef540a9a1bd6b)(value, (0, $d954abda96ea0996$export$eec14432cd1cb67b)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = $780bba6e980489ff$var$translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    // `pathRotation` composes onto `rotate` as a separate additive term so
    // the user's `rotate` is never clobbered. Deliberately not a slot in
    // `transformPropOrder`.
    const pathRotation = latestValues.pathRotation;
    if (pathRotation) {
        transformIsDefault = false;
        transformString += `rotate(${(0, $1f8f8a4cd1b31868$export$453ef540a9a1bd6b)(pathRotation, (0, $d954abda96ea0996$export$eec14432cd1cb67b).pathRotation)}) `;
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}


function $4a12369564e40a1a$export$bb517f8b40f8e99d(state, latestValues, transformTemplate) {
    const { style: style, vars: vars, transformOrigin: transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, $8e08dd08a6f8a76d$export$9de1236619d9e756)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, $1f8f8a4cd1b31868$export$453ef540a9a1bd6b)(value, (0, $d954abda96ea0996$export$eec14432cd1cb67b)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, $780bba6e980489ff$export$bdc96e0d5c8f914)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX: originX = "50%", originY: originY = "50%", originZ: originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}


function $249f8557c7bc151a$export$1a32bf6229c258c0(element, { style: style, vars: vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection === null || projection === void 0 ? void 0 : projection.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}








function $2b08ad704c89288c$export$fafff692be55225d(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const $2b08ad704c89288c$export$5eafb6257a5844c = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, $f1a72de1b348da89$export$91c0eda1d06bf008).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = $2b08ad704c89288c$export$fafff692be55225d(latest, node.target.x);
        const y = $2b08ad704c89288c$export$fafff692be55225d(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};




const $918aeea44afb5b07$export$eb0bc629e74dcf8 = {
    correct: (latest, { treeScale: treeScale, projectionDelta: projectionDelta })=>{
        const original = latest;
        const shadow = (0, $ce3767268d4e9ade$export$83a0e34f1302825b).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, $ce3767268d4e9ade$export$83a0e34f1302825b).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};


const $e69bce41e90c0a87$export$91ddd985b97788d1 = {
    borderRadius: (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $2b08ad704c89288c$export$5eafb6257a5844c)), {
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    }),
    borderTopLeftRadius: (0, $2b08ad704c89288c$export$5eafb6257a5844c),
    borderTopRightRadius: (0, $2b08ad704c89288c$export$5eafb6257a5844c),
    borderBottomLeftRadius: (0, $2b08ad704c89288c$export$5eafb6257a5844c),
    borderBottomRightRadius: (0, $2b08ad704c89288c$export$5eafb6257a5844c),
    boxShadow: (0, $918aeea44afb5b07$export$eb0bc629e74dcf8)
};
function $e69bce41e90c0a87$export$de9e7791c71225fd(correctors) {
    for(const key in correctors){
        $e69bce41e90c0a87$export$91ddd985b97788d1[key] = correctors[key];
        if ((0, $8e08dd08a6f8a76d$export$9de1236619d9e756)(key)) $e69bce41e90c0a87$export$91ddd985b97788d1[key].isCSSVariable = true;
    }
}


function $b4fc036121a01de5$export$6d27ce8e3de1c3cf(key, { layout: layout, layoutId: layoutId }) {
    return (0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, $e69bce41e90c0a87$export$91ddd985b97788d1)[key] || key === "opacity");
}


function $bb3887c01d961675$export$16da615486abaa45(props, prevProps, visualElement) {
    var _visualElement_getValue;
    const style = props.style;
    const prevStyle = prevProps === null || prevProps === void 0 ? void 0 : prevProps.style;
    const newValues = {};
    if (!style) return newValues;
    for(const key in style)if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(style[key]) || prevStyle && (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(prevStyle[key]) || (0, $b4fc036121a01de5$export$6d27ce8e3de1c3cf)(key, props) || (visualElement === null || visualElement === void 0 ? void 0 : (_visualElement_getValue = visualElement.getValue(key)) === null || _visualElement_getValue === void 0 ? void 0 : _visualElement_getValue.liveStyle) !== undefined) newValues[key] = style[key];
    return newValues;
}


function $81ed700fe5da0b90$export$3735103072e4a80(element) {
    return window.getComputedStyle(element);
}
class $81ed700fe5da0b90$export$23fea75b03ac16b3 extends (0, $dba06d9a16f9b2fd$export$e49735c2a366bdc7) {
    readValueFromInstance(instance, key) {
        var _this_projection;
        if ((0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(key)) return ((_this_projection = this.projection) === null || _this_projection === void 0 ? void 0 : _this_projection.isProjecting) ? (0, $f0207664133f4738$export$1f10c01143b9f089)(key) : (0, $f0207664133f4738$export$bcd97e0e03ba17f6)(instance, key);
        else {
            const computedStyle = $81ed700fe5da0b90$export$3735103072e4a80(instance);
            const value = ((0, $8e08dd08a6f8a76d$export$9de1236619d9e756)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint: transformPagePoint }) {
        return (0, $b3c78c86be367659$export$d8718b6a7e5c624e)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, $4a12369564e40a1a$export$bb517f8b40f8e99d)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $bb3887c01d961675$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, $249f8557c7bc151a$export$1a32bf6229c258c0);
    }
}





function $e3efdb4aa4767bb8$export$9fd24a634729c672(str) {
    return str.replace(/([A-Z])/g, (match)=>`-${match.toLowerCase()}`);
}




const $17aabc3c06d8838a$var$dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const $17aabc3c06d8838a$var$camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 *
 * Note: We use unitless values for stroke-dasharray and stroke-dashoffset
 * because Safari incorrectly scales px values when the page is zoomed.
 */ function $17aabc3c06d8838a$export$311b43f666da1d82(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? $17aabc3c06d8838a$var$dashKeys : $17aabc3c06d8838a$var$camelKeys;
    // Build the dash offset (unitless to avoid Safari zoom bug)
    attrs[keys.offset] = `${-offset}`;
    // Build the dash array (unitless to avoid Safari zoom bug)
    attrs[keys.array] = `${length} ${spacing}`;
}


/**
 * CSS Motion Path properties that should remain as CSS styles on SVG elements.
 */ const $b1850672c48c4c28$var$cssMotionPathProperties = [
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "offsetAnchor"
];
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function $b1850672c48c4c28$export$5475d24f125d7053(state, _param, isSVGTag, transformTemplate, styleProp) {
    var { attrX: attrX, attrY: attrY, attrScale: attrScale, pathLength: pathLength, pathSpacing: pathSpacing = 1, pathOffset: pathOffset = 0 } = _param, latest = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "attrX",
        "attrY",
        "attrScale",
        "pathLength",
        "pathSpacing",
        "pathOffset"
    ]);
    (0, $4a12369564e40a1a$export$bb517f8b40f8e99d)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs: attrs, style: style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        var _attrs_transformOrigin;
        style.transformOrigin = (_attrs_transformOrigin = attrs.transformOrigin) !== null && _attrs_transformOrigin !== void 0 ? _attrs_transformOrigin : "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        var _styleProp_transformBox;
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = (_styleProp_transformBox = styleProp === null || styleProp === void 0 ? void 0 : styleProp.transformBox) !== null && _styleProp_transformBox !== void 0 ? _styleProp_transformBox : "fill-box";
        delete attrs.transformBox;
    }
    for (const key of $b1850672c48c4c28$var$cssMotionPathProperties)if (attrs[key] !== undefined) {
        style[key] = attrs[key];
        delete attrs[key];
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, $17aabc3c06d8838a$export$311b43f666da1d82)(attrs, pathLength, pathSpacing, pathOffset, false);
}


/**
 * A set of attribute names that are always read/written as camel case.
 */ const $652662eb2acdfcdb$export$28931db5d57958e5 = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);


const $fe39d18929b68f56$export$6328ce7565ea1049 = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";





function $08ed0d1bc64f3540$export$c5f8399d19a7394b(element, renderState, _styleProp, projection) {
    (0, $249f8557c7bc151a$export$1a32bf6229c258c0)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, $652662eb2acdfcdb$export$28931db5d57958e5).has(key) ? (0, $e3efdb4aa4767bb8$export$9fd24a634729c672)(key) : key, renderState.attrs[key]);
}





function $0cc03b58a88b997c$export$16da615486abaa45(props, prevProps, visualElement) {
    const newValues = (0, $bb3887c01d961675$export$16da615486abaa45)(props, prevProps, visualElement);
    for(const key in props)if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(props[key]) || (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(prevProps[key])) {
        const targetKey = (0, $36437dbf5b93c477$export$280dc01950909d86).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}


class $ea5a8c056a9a6168$export$86bcdffbaf733d84 extends (0, $dba06d9a16f9b2fd$export$e49735c2a366bdc7) {
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(key)) {
            const defaultType = (0, $4f34bdc9b52d7b1d$export$67d1babe0338d23b)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, $652662eb2acdfcdb$export$28931db5d57958e5).has(key) ? (0, $e3efdb4aa4767bb8$export$9fd24a634729c672)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, $0cc03b58a88b997c$export$16da615486abaa45)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, $b1850672c48c4c28$export$5475d24f125d7053)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, $08ed0d1bc64f3540$export$c5f8399d19a7394b)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, $fe39d18929b68f56$export$6328ce7565ea1049)(instance.tagName);
        super.mount(instance);
    }
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, $a0d315cc230b7b79$export$6459fc9e86be362e);
    }
}



var $7fPBF = parcelRequire("7fPBF");
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ const $087915a6be8a879b$export$40209c4c512158e6 = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];


function $e87a7c920482c926$export$88f3fc2fd3766989(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, $087915a6be8a879b$export$40209c4c512158e6).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ RegExp("[A-Z]", "u").test(Component)) return true;
    return false;
}


const $782ff79d5f331768$export$56ba0183203348f5 = (Component, options)=>{
    var _options_isSVG;
    /**
     * Use explicit isSVG override if provided, otherwise auto-detect
     */ const isSVG = (_options_isSVG = options.isSVG) !== null && _options_isSVG !== void 0 ? _options_isSVG : (0, $e87a7c920482c926$export$88f3fc2fd3766989)(Component);
    return isSVG ? new (0, $ea5a8c056a9a6168$export$86bcdffbaf733d84)(options) : new (0, $81ed700fe5da0b90$export$23fea75b03ac16b3)(options, {
        allowProjection: Component !== (0, $7fPBF.Fragment)
    });
};








var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");
"use client";
const $e8832bf2a75e672d$export$a3579ca508007a95 = (0, $7fPBF.createContext)({});



var $7fPBF = parcelRequire("7fPBF");
"use client";
const $1a3b4aa5979f4505$export$40f10139ecf1f171 = (0, $7fPBF.createContext)({
    strict: false
});



var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @public
 */ const $a8ff94f377278375$export$22a697fb29aac98d = (0, $7fPBF.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});



var $7fPBF = parcelRequire("7fPBF");
"use client";
const $022ea981eb8a45f5$export$2285bbca2c666415 = /* @__PURE__ */ (0, $7fPBF.createContext)({});



var $7fPBF = parcelRequire("7fPBF");


function $854409cb45b6f949$export$12fc32fc096a04a3(props, context) {
    if ((0, $05ee406980932703$export$4b3c3bd8d910d78d)(props)) {
        const { initial: initial, animate: animate } = props;
        return {
            initial: initial === false || (0, $b2fb93622bbd7df5$export$720b90e312cea233)(initial) ? initial : undefined,
            animate: (0, $b2fb93622bbd7df5$export$720b90e312cea233)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}


"use client";
function $a9d13e94686be65e$export$c5638d843b37a176(props) {
    const { initial: initial, animate: animate } = (0, $854409cb45b6f949$export$12fc32fc096a04a3)(props, (0, $7fPBF.useContext)((0, $022ea981eb8a45f5$export$2285bbca2c666415)));
    return (0, $7fPBF.useMemo)(()=>({
            initial: initial,
            animate: animate
        }), [
        $a9d13e94686be65e$var$variantLabelsAsDependency(initial),
        $a9d13e94686be65e$var$variantLabelsAsDependency(animate)
    ]);
}
function $a9d13e94686be65e$var$variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
const $0e0ff089d25fb1a0$export$8940b483cf52eeda = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });


"use client";
function $f78b51ebf65a693b$export$40dafdb8630c956b(target, source, props) {
    for(const key in source)if (!(0, $61e12cc57eeb85ed$export$605d60a2578142d3)(source[key]) && !(0, $b4fc036121a01de5$export$6d27ce8e3de1c3cf)(key, props)) target[key] = source[key];
}
function $f78b51ebf65a693b$var$useInitialMotionValues({ transformTemplate: transformTemplate }, visualState) {
    return (0, $7fPBF.useMemo)(()=>{
        const state = (0, $0e0ff089d25fb1a0$export$8940b483cf52eeda)();
        (0, $4a12369564e40a1a$export$bb517f8b40f8e99d)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function $f78b51ebf65a693b$var$useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ $f78b51ebf65a693b$export$40dafdb8630c956b(style, styleProp, props);
    Object.assign(style, $f78b51ebf65a693b$var$useInitialMotionValues(props, visualState));
    return style;
}
function $f78b51ebf65a693b$export$57be0a314572d87d(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = $f78b51ebf65a693b$var$useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}






var $7fPBF = parcelRequire("7fPBF");




const $9caa1e13b1076d24$export$41be8b43e1c4d4f9 = ()=>(0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $0e0ff089d25fb1a0$export$8940b483cf52eeda)()), {
        attrs: {}
    });


"use client";
function $b38d0f78ad3b903e$export$84309c4f53cb1bd5(props, visualState, _isStatic, Component) {
    const visualProps = (0, $7fPBF.useMemo)(()=>{
        const state = (0, $9caa1e13b1076d24$export$41be8b43e1c4d4f9)();
        (0, $b1850672c48c4c28$export$5475d24f125d7053)(state, visualState, (0, $fe39d18929b68f56$export$6328ce7565ea1049)(Component), props.transformTemplate, props.style);
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.attrs), {
            style: (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, state.style)
        });
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, $f78b51ebf65a693b$export$40dafdb8630c956b)(rawStyles, props.style, props);
        visualProps.style = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, rawStyles, visualProps.style);
    }
    return visualProps;
}



/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ const $19b21865892304dc$var$validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "propagate",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function $19b21865892304dc$export$2f9c46555243bf04(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || $19b21865892304dc$var$validMotionProps.has(key);
}


let $8c94e6d37c758765$var$shouldForward = (key)=>!(0, $19b21865892304dc$export$2f9c46555243bf04)(key);
function $8c94e6d37c758765$export$59d6962c470509a5(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    $8c94e6d37c758765$var$shouldForward = (key)=>key.startsWith("on") ? !(0, $19b21865892304dc$export$2f9c46555243bf04)(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     *
     * String concatenation prevents bundlers like webpack (e.g. Storybook)
     * from statically resolving this optional dependency at build time.
     */ const emotionPkg = "@emotion/is-prop-valid";
    $8c94e6d37c758765$export$59d6962c470509a5(require(emotionPkg).default);
} catch (e) {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function $8c94e6d37c758765$export$d697c39a2985a4c(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(props[key])) continue;
        if ($8c94e6d37c758765$var$shouldForward(key) || forwardMotionProps === true && (0, $19b21865892304dc$export$2f9c46555243bf04)(key) || !isDom && !(0, $19b21865892304dc$export$2f9c46555243bf04)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}



"use client";
function $aa7c12fccf65e136$export$e25bb1e5b53cbdff(Component, props, ref, { latestValues: latestValues }, isStatic, forwardMotionProps = false, isSVG) {
    const useVisualProps = (isSVG !== null && isSVG !== void 0 ? isSVG : (0, $e87a7c920482c926$export$88f3fc2fd3766989)(Component)) ? (0, $b38d0f78ad3b903e$export$84309c4f53cb1bd5) : (0, $f78b51ebf65a693b$export$57be0a314572d87d);
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = (0, $8c94e6d37c758765$export$d697c39a2985a4c)(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== (0, $7fPBF.Fragment) ? (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, filteredProps, visualProps), {
        ref: ref
    }) : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ const { children: children } = props;
    const renderedChildren = (0, $7fPBF.useMemo)(()=>(0, $61e12cc57eeb85ed$export$605d60a2578142d3)(children) ? children.get() : children, [
        children
    ]);
    return (0, $7fPBF.createElement)(Component, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, elementProps), {
        children: renderedChildren
    }));
}






/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 */ function $f1898fdc70290c7d$export$fcc2206ecb6d74b(value) {
    return (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value) ? value.get() : value;
}



var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * @public
 */ const $13549fe6f5cbc799$export$f224e4635b6f8ce2 = /* @__PURE__ */ (0, $7fPBF.createContext)(null);



var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function $2a1bdfabf21bf6e8$export$fe4300aa8eebea86(init) {
    const ref = (0, $7fPBF.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}


"use client";
function $598d667c288f7fba$var$makeState({ scrapeMotionValuesFromProps: scrapeMotionValuesFromProps, createRenderState: createRenderState }, props, context, presenceContext) {
    const state = {
        latestValues: $598d667c288f7fba$var$makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function $598d667c288f7fba$var$makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, $f1898fdc70290c7d$export$fcc2206ecb6d74b)(motionValues[key]);
    let { initial: initial, animate: animate } = props;
    const isControllingVariants$1 = (0, $05ee406980932703$export$4b3c3bd8d910d78d)(props);
    const isVariantNode$1 = (0, $05ee406980932703$export$ce46fa4165cdec40)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, $197e81262ee8f44d$export$aa71198ceeaf53ce)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, $20ea58c6853b5985$export$d68f140c4d9b48bc)(props, list[i]);
            if (resolved) {
                const { transitionEnd: transitionEnd, transition: transition } = resolved, target = (0, $8901fc92b5563702$export$71511d61b312f219)(resolved, [
                    "transitionEnd",
                    "transition"
                ]);
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}
const $598d667c288f7fba$export$e91e107bc6d03a8e = (config)=>(props, isStatic)=>{
        const context = (0, $7fPBF.useContext)((0, $022ea981eb8a45f5$export$2285bbca2c666415));
        const presenceContext = (0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2));
        const make = ()=>$598d667c288f7fba$var$makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, $2a1bdfabf21bf6e8$export$fe4300aa8eebea86)(make);
    };



"use client";
const $8294e09ba1da91bf$export$851cf1f78cb3feac = /*@__PURE__*/ (0, $598d667c288f7fba$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $bb3887c01d961675$export$16da615486abaa45),
    createRenderState: (0, $0e0ff089d25fb1a0$export$8940b483cf52eeda)
});





"use client";
const $e69222d4a1c31a59$export$9922240e40b88c48 = /*@__PURE__*/ (0, $598d667c288f7fba$export$e91e107bc6d03a8e)({
    scrapeMotionValuesFromProps: (0, $0cc03b58a88b997c$export$16da615486abaa45),
    createRenderState: (0, $9caa1e13b1076d24$export$41be8b43e1c4d4f9)
});



const $000eadb1a85dd08b$var$featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
let $000eadb1a85dd08b$var$isInitialized = false;
/**
 * Initialize feature definitions with isEnabled checks.
 * This must be called before any motion components are rendered.
 */ function $000eadb1a85dd08b$export$e7d3655c4e2f701f() {
    if ($000eadb1a85dd08b$var$isInitialized) return;
    const initialFeatureDefinitions = {};
    for(const key in $000eadb1a85dd08b$var$featureProps)initialFeatureDefinitions[key] = {
        isEnabled: (props)=>$000eadb1a85dd08b$var$featureProps[key].some((name)=>!!props[name])
    };
    (0, $67fdc880829ae48a$export$8ad214844176d967)(initialFeatureDefinitions);
    $000eadb1a85dd08b$var$isInitialized = true;
}
/**
 * Get the current feature definitions, initializing if needed.
 */ function $000eadb1a85dd08b$export$350148171c356c79() {
    $000eadb1a85dd08b$export$e7d3655c4e2f701f();
    return (0, $67fdc880829ae48a$export$e183cb9c018608ba)();
}





function $1a95148514458996$export$449561ec5703cdc8(features) {
    const featureDefinitions = (0, $000eadb1a85dd08b$export$350148171c356c79)();
    for(const key in features)featureDefinitions[key] = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, featureDefinitions[key], features[key]);
    (0, $67fdc880829ae48a$export$8ad214844176d967)(featureDefinitions);
}


const $b4cb5ee9ecabcf16$export$28e2e4cce424ae23 = Symbol.for("motionComponentSymbol");



var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function $3efbe3f66e4b88ba$export$c684914703d321fd(visualState, visualElement, externalRef) {
    /**
     * Store externalRef in a ref to avoid including it in the useCallback
     * dependency array. Including externalRef in dependencies causes issues
     * with libraries like Radix UI that create new callback refs on each render
     * when using asChild - this would cause the callback to be recreated,
     * triggering element remounts and breaking AnimatePresence exit animations.
     */ const externalRefContainer = (0, $7fPBF.useRef)(externalRef);
    (0, $7fPBF.useInsertionEffect)(()=>{
        externalRefContainer.current = externalRef;
    });
    // Store cleanup function returned by callback refs (React 19 feature)
    const refCleanup = (0, $7fPBF.useRef)(null);
    return (0, $7fPBF.useCallback)((instance)=>{
        var _visualState_onMount;
        if (instance) (_visualState_onMount = visualState.onMount) === null || _visualState_onMount === void 0 ? void 0 : _visualState_onMount.call(visualState, instance);
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
        const ref = externalRefContainer.current;
        if (typeof ref === "function") {
            if (instance) {
                const cleanup = ref(instance);
                if (typeof cleanup === "function") refCleanup.current = cleanup;
            } else if (refCleanup.current) {
                refCleanup.current();
                refCleanup.current = null;
            } else ref(instance);
        } else if (ref) ref.current = instance;
    }, [
        visualElement
    ]);
}



const $e429a9baf33d38af$export$ed7b8fa9dbf0105d = "framerAppearId";
const $e429a9baf33d38af$export$8592e1c077c890a6 = "data-" + (0, $e3efdb4aa4767bb8$export$9fd24a634729c672)($e429a9baf33d38af$export$ed7b8fa9dbf0105d);



var $7fPBF = parcelRequire("7fPBF");





var $7fPBF = parcelRequire("7fPBF");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const $813b6750233d847f$export$da5f7b802957459a = (0, $7fPBF.createContext)({});


function $881a839ff5ec248c$export$dedd81df7bc1307(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}



var $7fPBF = parcelRequire("7fPBF");
const $eab4d64e1bdb7129$export$4e09c449d6c407f7 = typeof window !== "undefined";


"use client";
const $af582d6e296d97ab$export$700979bc83e7db82 = (0, $eab4d64e1bdb7129$export$4e09c449d6c407f7) ? (0, $7fPBF.useLayoutEffect) : (0, $7fPBF.useEffect);


"use client";
function $7d1717bf2273b4e2$export$dc0335d73ab0b115(Component, visualState, props, createVisualElement, ProjectionNodeConstructor, isSVG) {
    var _window_MotionHandoffIsComplete, _window, _window_MotionHasOptimisedAnimation, _window1;
    const { visualElement: parent } = (0, $7fPBF.useContext)((0, $022ea981eb8a45f5$export$2285bbca2c666415));
    const lazyContext = (0, $7fPBF.useContext)((0, $1a3b4aa5979f4505$export$40f10139ecf1f171));
    const presenceContext = (0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2));
    const motionConfig = (0, $7fPBF.useContext)((0, $a8ff94f377278375$export$22a697fb29aac98d));
    const reducedMotionConfig = motionConfig.reducedMotion;
    const skipAnimations = motionConfig.skipAnimations;
    const visualElementRef = (0, $7fPBF.useRef)(null);
    /**
     * Track whether the component has been through React's commit phase.
     * Used to detect when LazyMotion features load after the component has mounted.
     */ const hasMountedOnce = (0, $7fPBF.useRef)(false);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState: visualState,
            parent: parent,
            props: props,
            presenceContext: presenceContext,
            blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
            reducedMotionConfig: reducedMotionConfig,
            skipAnimations: skipAnimations,
            isSVG: isSVG
        });
        /**
         * If the component has already mounted before features loaded (e.g. via
         * LazyMotion with async feature loading), we need to force the initial
         * animation to run. Otherwise state changes that occurred before features
         * loaded will be lost and the element will snap to its final state.
         */ if (hasMountedOnce.current && visualElementRef.current) visualElementRef.current.manuallyAnimateOnMount = true;
    }
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, $7fPBF.useContext)((0, $813b6750233d847f$export$da5f7b802957459a));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) $7d1717bf2273b4e2$var$createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, $e429a9baf33d38af$export$8592e1c077c890a6];
    const wantsHandoff = (0, $7fPBF.useRef)(Boolean(optimisedAppearId) && typeof window !== "undefined" && !((_window_MotionHandoffIsComplete = (_window = window).MotionHandoffIsComplete) === null || _window_MotionHandoffIsComplete === void 0 ? void 0 : _window_MotionHandoffIsComplete.call(_window, optimisedAppearId)) && ((_window_MotionHasOptimisedAnimation = (_window1 = window).MotionHasOptimisedAnimation) === null || _window_MotionHasOptimisedAnimation === void 0 ? void 0 : _window_MotionHasOptimisedAnimation.call(_window1, optimisedAppearId)));
    (0, $af582d6e296d97ab$export$700979bc83e7db82)(()=>{
        /**
         * Track that this component has mounted. This is used to detect when
         * LazyMotion features load after the component has already committed.
         */ hasMountedOnce.current = true;
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, $7fPBF.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                var _window_MotionHandoffMarkAsComplete, _window;
                (_window_MotionHandoffMarkAsComplete = (_window = window).MotionHandoffMarkAsComplete) === null || _window_MotionHandoffMarkAsComplete === void 0 ? void 0 : _window_MotionHandoffMarkAsComplete.call(_window, optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function $7d1717bf2273b4e2$var$createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId: layoutId, layout: layout, drag: drag, dragConstraints: dragConstraints, layoutScroll: layoutScroll, layoutRoot: layoutRoot, layoutAnchor: layoutAnchor, layoutCrossfade: layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : $7d1717bf2273b4e2$var$getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId: layoutId,
        layout: layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints),
        visualElement: visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig: initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll: layoutScroll,
        layoutRoot: layoutRoot,
        layoutAnchor: layoutAnchor
    });
}
function $7d1717bf2273b4e2$var$getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : $7d1717bf2273b4e2$var$getClosestProjectingNode(visualElement.parent);
}


"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function $9202ab606c3569b2$export$46b7e4b9dc6110c3(Component, { forwardMotionProps: forwardMotionProps = false, type: type } = {}, preloadedFeatures, createVisualElement) {
    preloadedFeatures && (0, $1a95148514458996$export$449561ec5703cdc8)(preloadedFeatures);
    /**
     * Determine whether to use SVG or HTML rendering based on:
     * 1. Explicit `type` option (highest priority)
     * 2. Auto-detection via `isSVGComponent`
     */ const isSVG = type ? type === "svg" : (0, $e87a7c920482c926$export$88f3fc2fd3766989)(Component);
    const useVisualState = isSVG ? (0, $e69222d4a1c31a59$export$9922240e40b88c48) : (0, $8294e09ba1da91bf$export$851cf1f78cb3feac);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $7fPBF.useContext)((0, $a8ff94f377278375$export$22a697fb29aac98d)), props), {
            layoutId: $9202ab606c3569b2$var$useLayoutId(props)
        });
        const { isStatic: isStatic } = configAndProps;
        const context = (0, $a9d13e94686be65e$export$c5638d843b37a176)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && typeof window !== "undefined") {
            $9202ab606c3569b2$var$useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = $9202ab606c3569b2$var$getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, $7d1717bf2273b4e2$export$dc0335d73ab0b115)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode, isSVG);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, $824c049f32d4395d$exports.jsxs)((0, $022ea981eb8a45f5$export$2285bbca2c666415).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, $824c049f32d4395d$exports.jsx)(MeasureLayout, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                    visualElement: context.visualElement
                }, configAndProps)) : null,
                (0, $aa7c12fccf65e136$export$e25bb1e5b53cbdff)(Component, props, (0, $3efbe3f66e4b88ba$export$c684914703d321fd)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps, isSVG)
            ]
        });
    }
    var _Component_displayName, _ref;
    MotionDOMComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${(_ref = (_Component_displayName = Component.displayName) !== null && _Component_displayName !== void 0 ? _Component_displayName : Component.name) !== null && _ref !== void 0 ? _ref : ""})`}`;
    const ForwardRefMotionComponent = (0, $7fPBF.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, $b4cb5ee9ecabcf16$export$28e2e4cce424ae23] = Component;
    return ForwardRefMotionComponent;
}
function $9202ab606c3569b2$var$useLayoutId({ layoutId: layoutId }) {
    const layoutGroupId = (0, $7fPBF.useContext)((0, $e8832bf2a75e672d$export$a3579ca508007a95)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function $9202ab606c3569b2$var$useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, $7fPBF.useContext)((0, $1a3b4aa5979f4505$export$40f10139ecf1f171)).strict;
}
function $9202ab606c3569b2$var$getProjectionFunctionality(props) {
    const featureDefinitions = (0, $000eadb1a85dd08b$export$350148171c356c79)();
    const { drag: drag, layout: layout } = featureDefinitions;
    if (!drag && !layout) return {};
    const combined = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, drag, layout);
    return {
        MeasureLayout: (drag === null || drag === void 0 ? void 0 : drag.isEnabled(props)) || (layout === null || layout === void 0 ? void 0 : layout.isEnabled(props)) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}


function $832dbbf8caa22976$export$a28d6df673050e18(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, $9202ab606c3569b2$export$46b7e4b9dc6110c3;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const factory = (Component, options)=>{
        return (0, $9202ab606c3569b2$export$46b7e4b9dc6110c3)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ const deprecatedFactoryFunction = (Component, options)=>{
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, $9202ab606c3569b2$export$46b7e4b9dc6110c3)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}






function $0f821ea1e0e898c8$export$7b1b1c981f4f0558(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, $20ea58c6853b5985$export$d68f140c4d9b48bc)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}




/**
 * If `transition` has `inherit: true`, shallow-merge it with
 * `parentTransition` (child keys win) and strip the `inherit` key.
 * Otherwise return `transition` unchanged.
 */ 

function $46f6985c0d37a6d0$export$b180037f8f468d61(transition, parentTransition) {
    if ((transition === null || transition === void 0 ? void 0 : transition.inherit) && parentTransition) {
        const { inherit: _ } = transition, rest = (0, $8901fc92b5563702$export$71511d61b312f219)(transition, [
            "inherit"
        ]);
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, parentTransition, rest);
    }
    return transition;
}


function $445378a930c6db37$export$7c1391340308742e(transition, key) {
    var _transition_key, _ref;
    const valueTransition = (_ref = (_transition_key = transition === null || transition === void 0 ? void 0 : transition[key]) !== null && _transition_key !== void 0 ? _transition_key : transition === null || transition === void 0 ? void 0 : transition["default"]) !== null && _ref !== void 0 ? _ref : transition;
    if (valueTransition !== transition) return (0, $46f6985c0d37a6d0$export$b180037f8f468d61)(valueTransition, transition);
    return valueTransition;
}








const $b86f35c91384031e$export$9153ad4c4999f4a0 = (v)=>{
    return Array.isArray(v);
};


/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function $52953efd8694e3bd$var$setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, $eba58299b894994c$export$ce8bdc721e76545f)(value));
}
function $52953efd8694e3bd$var$resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, $b86f35c91384031e$export$9153ad4c4999f4a0)(v) ? v[v.length - 1] || 0 : v;
}
function $52953efd8694e3bd$export$1f61c53461aff4a5(visualElement, definition) {
    const resolved = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(visualElement, definition);
    let _ref = resolved || {}, { transitionEnd: transitionEnd = {}, transition: transition = {} } = _ref, target = (0, $8901fc92b5563702$export$71511d61b312f219)(_ref, [
        "transitionEnd",
        "transition"
    ]);
    target = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, target, transitionEnd);
    for(const key in target){
        const value = $52953efd8694e3bd$var$resolveFinalValueInKeyframes(target[key]);
        $52953efd8694e3bd$var$setMotionValue(visualElement, key, value);
    }
}




function $ffcae9ed317c42ed$export$98397f3adbf6259f(value) {
    return Boolean((0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value) && value.add);
}


function $5d399ca24ed34089$export$3ac5aed310be0bee(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, $ffcae9ed317c42ed$export$98397f3adbf6259f)(willChange)) return willChange.add(key);
    else if (!willChange && (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).WillChange) {
        const newWillChange = new (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}



function $dedda87bce0b0fc0$export$5f8d21e84d1d84fc(visualElement) {
    return visualElement.props[0, $e429a9baf33d38af$export$8592e1c077c890a6];
}












/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ const $113d54600cb8d2d0$export$a4627e546088548d = (...transformers)=>transformers.reduce((a, b)=>(v)=>b(a(v)));













// Adapted from https://gist.github.com/mjackson/5311256
function $a395f4e8a86492ea$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function $a395f4e8a86492ea$export$6ae64dbcd6bfc33e({ hue: hue, saturation: saturation, lightness: lightness, alpha: alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = $a395f4e8a86492ea$var$hueToRgb(p, q, hue + 1 / 3);
        green = $a395f4e8a86492ea$var$hueToRgb(p, q, hue);
        blue = $a395f4e8a86492ea$var$hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha: alpha
    };
}



function $e493443a4fa45880$export$a6f92d4bae65c0f1(a, b) {
    return (p)=>p > 0 ? b : a;
}



// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const $08f990a3e51e69f3$export$d4ecea248cce73c = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const $08f990a3e51e69f3$var$colorTypes = [
    (0, $90a7f54b29f1453c$export$834dfc94dde4b3d8),
    (0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b),
    (0, $f6f2a31cd5829bc5$export$810b04175080204c)
];
const $08f990a3e51e69f3$var$getColorType = (v)=>$08f990a3e51e69f3$var$colorTypes.find((type)=>type.test(v));
function $08f990a3e51e69f3$var$asRGBA(color) {
    const type = $08f990a3e51e69f3$var$getColorType(color);
    (0, $19758d730238f0ed$export$491112666e282270)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, $f6f2a31cd5829bc5$export$810b04175080204c)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, $a395f4e8a86492ea$export$6ae64dbcd6bfc33e)(model);
    return model;
}
const $08f990a3e51e69f3$export$51e568cf5c039bac = (from, to)=>{
    const fromRGBA = $08f990a3e51e69f3$var$asRGBA(from);
    const toRGBA = $08f990a3e51e69f3$var$asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, $e493443a4fa45880$export$a6f92d4bae65c0f1)(from, to);
    const blended = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, fromRGBA);
    return (v)=>{
        blended.red = $08f990a3e51e69f3$export$d4ecea248cce73c(fromRGBA.red, toRGBA.red, v);
        blended.green = $08f990a3e51e69f3$export$d4ecea248cce73c(fromRGBA.green, toRGBA.green, v);
        blended.blue = $08f990a3e51e69f3$export$d4ecea248cce73c(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, $ff7a2ec6f726704e$export$4e46ac54fc82cf3b).transform(blended);
    };
};




const $21b14ab67cf766da$export$e5a55ae567dd4ac7 = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function $21b14ab67cf766da$export$fed62ccc3fb1a568(origin, target) {
    if ($21b14ab67cf766da$export$e5a55ae567dd4ac7.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}


function $864ea16ae0114b26$var$mixNumber(a, b) {
    return (p)=>(0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(a, b, p);
}
function $864ea16ae0114b26$export$36ec24672cd098e0(a) {
    if (typeof a === "number") return $864ea16ae0114b26$var$mixNumber;
    else if (typeof a === "string") return (0, $8e08dd08a6f8a76d$export$31f9caa2600b5723)(a) ? (0, $e493443a4fa45880$export$a6f92d4bae65c0f1) : (0, $d252968ea52f42fd$export$35e9368ef982300f).test(a) ? (0, $08f990a3e51e69f3$export$51e568cf5c039bac) : $864ea16ae0114b26$export$65516310a87d8205;
    else if (Array.isArray(a)) return $864ea16ae0114b26$export$3bbefa2f402845c4;
    else if (typeof a === "object") return (0, $d252968ea52f42fd$export$35e9368ef982300f).test(a) ? (0, $08f990a3e51e69f3$export$51e568cf5c039bac) : $864ea16ae0114b26$export$ebc23b6840c51ba1;
    return 0, $e493443a4fa45880$export$a6f92d4bae65c0f1;
}
function $864ea16ae0114b26$export$3bbefa2f402845c4(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>$864ea16ae0114b26$export$36ec24672cd098e0(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function $864ea16ae0114b26$export$ebc23b6840c51ba1(a, b) {
    const output = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, a, b);
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = $864ea16ae0114b26$export$36ec24672cd098e0(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function $864ea16ae0114b26$var$matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        var _origin_values_originIndex;
        const originValue = (_origin_values_originIndex = origin.values[originIndex]) !== null && _origin_values_originIndex !== void 0 ? _origin_values_originIndex : 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const $864ea16ae0114b26$export$65516310a87d8205 = (origin, target)=>{
    const template = (0, $ce3767268d4e9ade$export$83a0e34f1302825b).createTransformer(target);
    const originStats = (0, $ce3767268d4e9ade$export$b61fc7c44bf646d5)(origin);
    const targetStats = (0, $ce3767268d4e9ade$export$b61fc7c44bf646d5)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, $21b14ab67cf766da$export$e5a55ae567dd4ac7).has(origin) && !targetStats.values.length || (0, $21b14ab67cf766da$export$e5a55ae567dd4ac7).has(target) && !originStats.values.length) return (0, $21b14ab67cf766da$export$fed62ccc3fb1a568)(origin, target);
        return (0, $113d54600cb8d2d0$export$a4627e546088548d)($864ea16ae0114b26$export$3bbefa2f402845c4($864ea16ae0114b26$var$matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, $19758d730238f0ed$export$491112666e282270)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, $e493443a4fa45880$export$a6f92d4bae65c0f1)(origin, target);
    }
};



function $a5735c6e2225d49f$export$2c9e8a9632a706b2(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(from, to, p);
    const mixer = (0, $864ea16ae0114b26$export$36ec24672cd098e0)(from);
    return mixer(from, to);
}




const $72b107753e53f4eb$export$c1033964b5ad7fef = (update)=>{
    const passTimestamp = ({ timestamp: timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, $44c600a9437aff7c$export$2cef06c20297c17d).update(passTimestamp, keepAlive),
        stop: ()=>(0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, $44c600a9437aff7c$export$fff89137e9e818ce).isProcessing ? (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp : (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now()
    };
};






/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ const $9c4fce4939386ba9$export$f4ff70a5b4808fd8 = 20000;
function $9c4fce4939386ba9$export$cbdd6b3d40ea54e2(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < $9c4fce4939386ba9$export$f4ff70a5b4808fd8){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= $9c4fce4939386ba9$export$f4ff70a5b4808fd8 ? Infinity : duration;
}






/**
 * Create a progress => progress easing function from a generator.
 */ function $419f83f95667f286$export$7f1511d09ee75a99(options, scale = 100, createGenerator) {
    const generator = createGenerator((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
        keyframes: [
            0,
            scale
        ]
    }));
    const duration = Math.min((0, $9c4fce4939386ba9$export$cbdd6b3d40ea54e2)(generator), (0, $9c4fce4939386ba9$export$f4ff70a5b4808fd8));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(duration)
    };
}


const $cf35667c22d9ae68$var$springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};
function $cf35667c22d9ae68$var$calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const $cf35667c22d9ae68$var$rootIterations = 12;
function $cf35667c22d9ae68$var$approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < $cf35667c22d9ae68$var$rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
/**
 * This is ported from the Framer implementation of duration-based spring resolution.
 */ const $cf35667c22d9ae68$var$safeMin = 0.001;
function $cf35667c22d9ae68$var$findSpring({ duration: duration = $cf35667c22d9ae68$var$springDefaults.duration, bounce: bounce = $cf35667c22d9ae68$var$springDefaults.bounce, velocity: velocity = $cf35667c22d9ae68$var$springDefaults.velocity, mass: mass = $cf35667c22d9ae68$var$springDefaults.mass }) {
    let envelope;
    let derivative;
    (0, $19758d730238f0ed$export$491112666e282270)(duration <= (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)($cf35667c22d9ae68$var$springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)($cf35667c22d9ae68$var$springDefaults.minDamping, $cf35667c22d9ae68$var$springDefaults.maxDamping, dampingRatio);
    duration = (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)($cf35667c22d9ae68$var$springDefaults.minDuration, $cf35667c22d9ae68$var$springDefaults.maxDuration, (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = $cf35667c22d9ae68$var$calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return $cf35667c22d9ae68$var$safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = $cf35667c22d9ae68$var$calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + $cf35667c22d9ae68$var$safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -$cf35667c22d9ae68$var$safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = $cf35667c22d9ae68$var$approximateRoot(envelope, derivative, initialGuess);
    duration = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: $cf35667c22d9ae68$var$springDefaults.stiffness,
        damping: $cf35667c22d9ae68$var$springDefaults.damping,
        duration: duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness: stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration: duration
        };
    }
}
const $cf35667c22d9ae68$var$durationKeys = [
    "duration",
    "bounce"
];
const $cf35667c22d9ae68$var$physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function $cf35667c22d9ae68$var$isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function $cf35667c22d9ae68$var$getSpringOptions(options) {
    let springOptions = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        velocity: $cf35667c22d9ae68$var$springDefaults.velocity,
        stiffness: $cf35667c22d9ae68$var$springDefaults.stiffness,
        damping: $cf35667c22d9ae68$var$springDefaults.damping,
        mass: $cf35667c22d9ae68$var$springDefaults.mass,
        isResolvedFromDuration: false
    }, options);
    // stiffness/damping/mass overrides duration/bounce
    if (!$cf35667c22d9ae68$var$isSpringType(options, $cf35667c22d9ae68$var$physicsKeys) && $cf35667c22d9ae68$var$isSpringType(options, $cf35667c22d9ae68$var$durationKeys)) {
        // Time-defined springs should ignore inherited velocity.
        // Velocity from interrupted animations can cause findSpring()
        // to compute wildly different spring parameters, leading to
        // massive oscillation on small-range animations.
        springOptions.velocity = 0;
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, springOptions), {
                mass: $cf35667c22d9ae68$var$springDefaults.mass,
                stiffness: stiffness,
                damping: damping
            });
        } else {
            const derived = $cf35667c22d9ae68$var$findSpring((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
                velocity: 0
            }));
            springOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, springOptions, derived), {
                mass: $cf35667c22d9ae68$var$springDefaults.mass
            });
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function $cf35667c22d9ae68$export$b36281d89752ae66(optionsOrVisualDuration = $cf35667c22d9ae68$var$springDefaults.visualDuration, bounce = $cf35667c22d9ae68$var$springDefaults.bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce: bounce
    } : optionsOrVisualDuration;
    let { restSpeed: restSpeed, restDelta: restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness: stiffness, damping: damping, mass: mass, duration: duration, velocity: velocity, isResolvedFromDuration: isResolvedFromDuration } = $cf35667c22d9ae68$var$getSpringOptions((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
        velocity: -(0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(options.velocity || 0)
    }));
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? $cf35667c22d9ae68$var$springDefaults.restSpeed.granular : $cf35667c22d9ae68$var$springDefaults.restSpeed.default);
    restDelta || (restDelta = isGranularScale ? $cf35667c22d9ae68$var$springDefaults.restDelta.granular : $cf35667c22d9ae68$var$springDefaults.restDelta.default);
    let resolveSpring;
    let resolveVelocity;
    // Underdamped coefficients, hoisted for use in the inlined next() hot path
    let angularFreq;
    let A;
    let sinCoeff;
    let cosCoeff;
    if (dampingRatio < 1) {
        angularFreq = $cf35667c22d9ae68$var$calcAngularFreq(undampedAngularFreq, dampingRatio);
        A = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq;
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * (A * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
        // Analytical derivative of underdamped spring (px/ms)
        sinCoeff = dampingRatio * undampedAngularFreq * A + initialDelta * angularFreq;
        cosCoeff = dampingRatio * undampedAngularFreq * initialDelta - A * angularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return envelope * (sinCoeff * Math.sin(angularFreq * t) + cosCoeff * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        // Analytical derivative of critically damped spring (px/ms)
        const C = initialVelocity + undampedAngularFreq * initialDelta;
        resolveVelocity = (t)=>Math.exp(-undampedAngularFreq * t) * (undampedAngularFreq * C * t - initialVelocity);
    } else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
        // Analytical derivative of overdamped spring (px/ms)
        const P = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / dampedAngularFreq;
        const sinhCoeff = dampingRatio * undampedAngularFreq * P - initialDelta * dampedAngularFreq;
        const coshCoeff = dampingRatio * undampedAngularFreq * initialDelta - P * dampedAngularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return envelope * (sinhCoeff * Math.sinh(freqForT) + coshCoeff * Math.cosh(freqForT));
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        velocity: (t)=>(0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(resolveVelocity(t)),
        next: (t)=>{
            /**
             * For underdamped physics springs we need both position and
             * velocity each tick. Compute shared trig values once to avoid
             * duplicate Math.exp/sin/cos calls on the hot path.
             */ if (!isResolvedFromDuration && dampingRatio < 1) {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const sin = Math.sin(angularFreq * t);
                const cos = Math.cos(angularFreq * t);
                const current = target - envelope * (A * sin + initialDelta * cos);
                const currentVelocity = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(envelope * (sinCoeff * sin + cosCoeff * cos));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
                state.value = state.done ? target : current;
                return state;
            }
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(resolveVelocity(t));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, $9c4fce4939386ba9$export$cbdd6b3d40ea54e2)(generator), (0, $9c4fce4939386ba9$export$f4ff70a5b4808fd8));
            const easing = (0, $0e9dc36f6f7cb032$export$66d3851e2b1ec912)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
$cf35667c22d9ae68$export$b36281d89752ae66.applyToOptions = (options)=>{
    const generatorOptions = (0, $419f83f95667f286$export$7f1511d09ee75a99)(options, 100, $cf35667c22d9ae68$export$b36281d89752ae66);
    options.ease = generatorOptions.ease;
    options.duration = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};



const $7ca1f8fd8c1eaa05$var$velocitySampleDuration = 5; // ms
function $7ca1f8fd8c1eaa05$export$279c5e002bb29070(resolveValue, t, current) {
    const prevT = Math.max(t - $7ca1f8fd8c1eaa05$var$velocitySampleDuration, 0);
    return (0, $53435ded96da5381$export$eab0632f7ad4f9d7)(current - resolveValue(prevT), t - prevT);
}


function $32e0d307ae2d0987$export$ee3ff3a17106998({ keyframes: keyframes, velocity: velocity = 0.0, power: power = 0.8, timeConstant: timeConstant = 325, bounceDamping: bounceDamping = 10, bounceStiffness: bounceStiffness = 500, modifyTarget: modifyTarget, min: min, max: max, restDelta: restDelta = 0.5, restSpeed: restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, $cf35667c22d9ae68$export$b36281d89752ae66)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, $7ca1f8fd8c1eaa05$export$279c5e002bb29070)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta: restDelta,
            restSpeed: restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}



/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const $c1fbb59bb1e3e7b4$var$calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const $c1fbb59bb1e3e7b4$var$subdivisionPrecision = 0.0000001;
const $c1fbb59bb1e3e7b4$var$subdivisionMaxIterations = 12;
function $c1fbb59bb1e3e7b4$var$binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = $c1fbb59bb1e3e7b4$var$calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > $c1fbb59bb1e3e7b4$var$subdivisionPrecision && ++i < $c1fbb59bb1e3e7b4$var$subdivisionMaxIterations);
    return currentT;
}
/*#__NO_SIDE_EFFECTS__*/ function $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, $69d49105ec21595d$export$8793edee2d425525;
    const getTForX = (aX)=>$c1fbb59bb1e3e7b4$var$binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : $c1fbb59bb1e3e7b4$var$calcBezier(getTForX(t), mY1, mY2);
}


const $0237323c43a18099$export$929e5a82286172a6 = /*@__PURE__*/ (0, $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd)(0.42, 0, 1, 1);
const $0237323c43a18099$export$57636bb43b1ccbb0 = /*@__PURE__*/ (0, $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd)(0, 0, 0.58, 1);
const $0237323c43a18099$export$c07234257a03d5e9 = /*@__PURE__*/ (0, $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd)(0.42, 0, 0.58, 1);




// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
/*#__NO_SIDE_EFFECTS__*/ const $139640f8594c998b$export$f946554fb8aeaf0d = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;


// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
/*#__NO_SIDE_EFFECTS__*/ const $931d9f9e77a0aee7$export$2c07eeff45156d4d = (easing)=>(p)=>1 - easing(1 - p);


const $99127f009a705dfc$export$77edfce482316a60 = /*@__PURE__*/ (0, $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd)(0.33, 1.53, 0.69, 0.99);
const $99127f009a705dfc$export$b01116c84cdfe1a2 = /*@__PURE__*/ (0, $931d9f9e77a0aee7$export$2c07eeff45156d4d)($99127f009a705dfc$export$77edfce482316a60);
const $99127f009a705dfc$export$ddc5fd596f6c71b2 = /*@__PURE__*/ (0, $139640f8594c998b$export$f946554fb8aeaf0d)($99127f009a705dfc$export$b01116c84cdfe1a2);


const $3364581cfa525123$export$6b0af63b873d419e = (p)=>p >= 1 ? 1 : (p *= 2) < 1 ? 0.5 * (0, $99127f009a705dfc$export$b01116c84cdfe1a2)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));





const $e4064fe071cf16bf$export$e444123e42d03385 = (p)=>1 - Math.sin(Math.acos(p));
const $e4064fe071cf16bf$export$c8d67a19199d1a50 = (0, $931d9f9e77a0aee7$export$2c07eeff45156d4d)($e4064fe071cf16bf$export$e444123e42d03385);
const $e4064fe071cf16bf$export$30d3455eee55bed5 = (0, $139640f8594c998b$export$f946554fb8aeaf0d)($e4064fe071cf16bf$export$e444123e42d03385);





const $33255b886b199e10$var$easingLookup = {
    linear: (0, $69d49105ec21595d$export$8793edee2d425525),
    easeIn: $0237323c43a18099$export$929e5a82286172a6,
    easeInOut: $0237323c43a18099$export$c07234257a03d5e9,
    easeOut: $0237323c43a18099$export$57636bb43b1ccbb0,
    circIn: $e4064fe071cf16bf$export$e444123e42d03385,
    circInOut: $e4064fe071cf16bf$export$30d3455eee55bed5,
    circOut: $e4064fe071cf16bf$export$c8d67a19199d1a50,
    backIn: $99127f009a705dfc$export$b01116c84cdfe1a2,
    backInOut: $99127f009a705dfc$export$ddc5fd596f6c71b2,
    backOut: $99127f009a705dfc$export$77edfce482316a60,
    anticipate: $3364581cfa525123$export$6b0af63b873d419e
};
const $33255b886b199e10$var$isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const $33255b886b199e10$export$ef97fe084f156ca4 = (definition)=>{
    if ((0, $09983ccc000b48c8$export$ff43f99925d7366b)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, $19758d730238f0ed$export$f5708dca728d7177)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, $c1fbb59bb1e3e7b4$export$2c575fa1d20488bd)(x1, y1, x2, y2);
    } else if ($33255b886b199e10$var$isValidEasing(definition)) {
        // Else lookup from table
        (0, $19758d730238f0ed$export$f5708dca728d7177)($33255b886b199e10$var$easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return $33255b886b199e10$var$easingLookup[definition];
    }
    return definition;
};

/*#__NO_SIDE_EFFECTS__*/ const $ab974cab0b2b4116$export$216948827bbdc797 = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};


/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.
*/ /*#__NO_SIDE_EFFECTS__*/ const $5a7354d1e57d5b3d$export$504d7abb21fa8c9 = (from, to, value)=>{
    const range = to - from;
    return range ? (value - from) / range : 1;
};



function $d37269c08d34236a$var$createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).mix || (0, $a5735c6e2225d49f$export$2c9e8a9632a706b2);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, $69d49105ec21595d$export$8793edee2d425525) : ease;
            mixer = (0, $113d54600cb8d2d0$export$a4627e546088548d)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function $d37269c08d34236a$export$89e29e4ab65e70a9(input, output, { clamp: isClamp = true, ease: ease, mixer: mixer } = {}) {
    const inputLength = input.length;
    (0, $19758d730238f0ed$export$f5708dca728d7177)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = $d37269c08d34236a$var$createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, $5a7354d1e57d5b3d$export$504d7abb21fa8c9)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(input[0], input[inputLength - 1], v)) : interpolator;
}




function $7e6dd1d3379cddbd$export$dafee61230cf05c6(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, $5a7354d1e57d5b3d$export$504d7abb21fa8c9)(0, remaining, i);
        offset.push((0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(min, 1, offsetProgress));
    }
}


function $f8be49afc4edbaa8$export$24dbcec0b26e6d9d(arr) {
    const offset = [
        0
    ];
    (0, $7e6dd1d3379cddbd$export$dafee61230cf05c6)(offset, arr.length - 1);
    return offset;
}


function $7d2ae0a920715a8d$export$2a91b4e3a4539316(offset, duration) {
    return offset.map((o)=>o * duration);
}


function $01e9914588b77db2$export$6b60b58e4ea7d715(values, easing) {
    return values.map(()=>easing || (0, $0237323c43a18099$export$c07234257a03d5e9)).splice(0, values.length - 1);
}
function $01e9914588b77db2$export$d25ddfdf17c3ad3e({ duration: duration = 300, keyframes: keyframeValues, times: times, ease: ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, $ab974cab0b2b4116$export$216948827bbdc797)(ease) ? ease.map((0, $33255b886b199e10$export$ef97fe084f156ca4)) : (0, $33255b886b199e10$export$ef97fe084f156ca4)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, $7d2ae0a920715a8d$export$2a91b4e3a4539316)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, $f8be49afc4edbaa8$export$24dbcec0b26e6d9d)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, $d37269c08d34236a$export$89e29e4ab65e70a9)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : $01e9914588b77db2$export$6b60b58e4ea7d715(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}








const $8edc467b0ada66ea$var$transitionTypeMap = {
    decay: (0, $32e0d307ae2d0987$export$ee3ff3a17106998),
    inertia: $32e0d307ae2d0987$export$ee3ff3a17106998,
    tween: (0, $01e9914588b77db2$export$d25ddfdf17c3ad3e),
    keyframes: (0, $01e9914588b77db2$export$d25ddfdf17c3ad3e),
    spring: $cf35667c22d9ae68$export$b36281d89752ae66
};
function $8edc467b0ada66ea$export$98db6ef1242dfa2(transition) {
    if (typeof transition.type === "string") transition.type = $8edc467b0ada66ea$var$transitionTypeMap[transition.type];
}



const $66d5e49763a7f8a0$var$percentToProgress = (percent)=>percent / 100;
class $66d5e49763a7f8a0$export$3394f837405475c7 extends (0, $6940fcbd8d4ca66f$export$655db786091c33e0) {
    initAnimation() {
        const { options: options } = this;
        (0, $8edc467b0ada66ea$export$98db6ef1242dfa2)(options);
        const { type: type = (0, $01e9914588b77db2$export$d25ddfdf17c3ad3e), repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType, velocity: velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, $01e9914588b77db2$export$d25ddfdf17c3ad3e);
        if (generatorFactory !== (0, $01e9914588b77db2$export$d25ddfdf17c3ad3e) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, $113d54600cb8d2d0$export$a4627e546088548d)($66d5e49763a7f8a0$var$percentToProgress, (0, $a5735c6e2225d49f$export$2c9e8a9632a706b2)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            keyframes: keyframes$1
        }));
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        }));
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, $9c4fce4939386ba9$export$cbdd6b3d40ea54e2)(generator);
        const { calculatedDuration: calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator: generator, totalDuration: totalDuration, mixKeyframes: mixKeyframes, mirroredGenerator: mirroredGenerator, resolvedDuration: resolvedDuration, calculatedDuration: calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay: delay = 0, keyframes: keyframes, repeat: repeat, repeatType: repeatType, repeatDelay: repeatDelay, type: type, onUpdate: onUpdate, finalKeyframe: finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ let state;
        if (isInDelayPhase) {
            this.delayState.value = keyframes[0];
            state = this.delayState;
        } else state = frameGenerator.next(elapsed);
        if (mixKeyframes && !isInDelayPhase) state.value = mixKeyframes(state.value);
        let { done: done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, $32e0d307ae2d0987$export$ee3ff3a17106998)) state.value = (0, $fc831f8861054717$export$14de59408fad90b)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay: delay = 0 } = this.options || {};
        return this.duration + (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(delay);
    }
    get time() {
        return (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        if (this.driver) this.driver.start(false);
        else {
            this.startTime = 0;
            this.state = "paused";
            this.holdTime = newTime;
            this.tick(newTime);
        }
    }
    /**
     * Returns the generator's velocity at the current time in units/second.
     * Uses the analytical derivative when available (springs), avoiding
     * the MotionValue's frame-dependent velocity estimation.
     */ getGeneratorVelocity() {
        const t = this.currentTime;
        if (t <= 0) return this.options.velocity || 0;
        if (this.generator.velocity) return this.generator.velocity(t);
        // Fallback: finite difference
        const current = this.generator.next(t).value;
        return (0, $7ca1f8fd8c1eaa05$export$279c5e002bb29070)((s)=>this.generator.next(s).value, t, current);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        if (hasChanged && this.driver) this.updateTime((0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now());
        this.playbackSpeed = newSpeed;
        if (hasChanged && this.driver) this.time = (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(this.currentTime);
    }
    play() {
        var _this_options_onPlay, _this_options;
        if (this.isStopped) return;
        const { driver: driver = (0, $72b107753e53f4eb$export$c1033964b5ad7fef), startTime: startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        (_this_options_onPlay = (_this_options = this.options).onPlay) === null || _this_options_onPlay === void 0 ? void 0 : _this_options_onPlay.call(_this_options);
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime !== null && startTime !== void 0 ? startTime : now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        var _this_options_onComplete, _this_options;
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        (_this_options_onComplete = (_this_options = this.options).onComplete) === null || _this_options_onComplete === void 0 ? void 0 : _this_options_onComplete.call(_this_options);
    }
    cancel() {
        var _this_options_onCancel, _this_options;
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        (_this_options_onCancel = (_this_options = this.options).onCancel) === null || _this_options_onCancel === void 0 ? void 0 : _this_options_onCancel.call(_this_options);
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, $86c9ef19d62de386$export$d921fb2475e2900c).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        var _this_driver;
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        (_this_driver = this.driver) === null || _this_driver === void 0 ? void 0 : _this_driver.stop();
        return timeline.observe(this);
    }
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * Reusable state object for the delay phase to avoid
         * allocating a new object every frame.
         */ this.delayState = {
            done: false,
            value: undefined
        };
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            var _this_options_onStop, _this_options;
            const { motionValue: motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now()) this.tick((0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            (_this_options_onStop = (_this_options = this.options).onStop) === null || _this_options_onStop === void 0 ? void 0 : _this_options_onStop.call(_this_options);
        };
        (0, $86c9ef19d62de386$export$d921fb2475e2900c).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
}
// Legacy function support
function $66d5e49763a7f8a0$export$ee9b76de7353d815(options) {
    return new $66d5e49763a7f8a0$export$3394f837405475c7(options);
}














const $3a789180528414af$var$unsupportedEasingFunctions = {
    anticipate: $3364581cfa525123$export$6b0af63b873d419e,
    backInOut: $99127f009a705dfc$export$ddc5fd596f6c71b2,
    circInOut: $e4064fe071cf16bf$export$30d3455eee55bed5
};
function $3a789180528414af$var$isUnsupportedEase(key) {
    return key in $3a789180528414af$var$unsupportedEasingFunctions;
}
function $3a789180528414af$export$5195f232c29d1f82(transition) {
    if (typeof transition.ease === "string" && $3a789180528414af$var$isUnsupportedEase(transition.ease)) transition.ease = $3a789180528414af$var$unsupportedEasingFunctions[transition.ease];
}


/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const $9f819ae9491bd189$var$sampleDelta = 10; //ms
class $9f819ae9491bd189$export$bd2cd6a048093d96 extends (0, $d40de0a79038d88e$export$6c0f9803d8aa7219) {
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read committed styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const _this_options = this.options, { motionValue: motionValue, onUpdate: onUpdate, onComplete: onComplete, element: element } = _this_options, options = (0, $8901fc92b5563702$export$71511d61b312f219)(_this_options, [
            "motionValue",
            "onUpdate",
            "onComplete",
            "element"
        ]);
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, $66d5e49763a7f8a0$export$3394f837405475c7)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            autoplay: false
        }));
        /**
         * Use wall-clock elapsed time for sampling.
         * Under CPU load, WAAPI's currentTime may not reflect actual
         * elapsed time, causing incorrect sampling and visual jumps.
         */ const sampleTime = Math.max($9f819ae9491bd189$var$sampleDelta, (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now() - this.startTime);
        const delta = (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, $9f819ae9491bd189$var$sampleDelta, sampleTime - $9f819ae9491bd189$var$sampleDelta);
        const current = sampleAnimation.sample(sampleTime).value;
        /**
         * Write the estimated value to inline style so it persists
         * after cancel(), covering the async gap before the next
         * animation starts.
         */ const { name: name } = this.options;
        if (element && name) (0, $0055d05149405828$export$37a5fde709c1db82)(element, name, current);
        motionValue.setWithVelocity(sampleAnimation.sample(Math.max(0, sampleTime - delta)).value, current, delta);
        sampleAnimation.stop();
    }
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, $3a789180528414af$export$5195f232c29d1f82)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, $8edc467b0ada66ea$export$98db6ef1242dfa2)(options);
        super(options);
        /**
         * Only set startTime when the animation should autoplay.
         * Setting startTime on a paused WAAPI animation unpauses it
         * (per the WAAPI spec), which breaks autoplay: false.
         */ if (options.startTime !== undefined && options.autoplay !== false) this.startTime = options.startTime;
        this.options = options;
    }
}





/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const $e770b24f49f1bf00$export$65676b58b122bc38 = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, $ce3767268d4e9ade$export$83a0e34f1302825b).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};


function $2a4d473bd153758e$var$hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function $2a4d473bd153758e$export$1b109e6c9968df4f(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, $e770b24f49f1bf00$export$65676b58b122bc38)(originKeyframe, name);
    const isTargetAnimatable = (0, $e770b24f49f1bf00$export$65676b58b122bc38)(targetKeyframe, name);
    (0, $19758d730238f0ed$export$491112666e282270)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return $2a4d473bd153758e$var$hasKeyframesChanged(keyframes) || (type === "spring" || (0, $7499953f74b707a4$export$6ab7812f1bac68be)(type)) && velocity;
}


function $4513539b02d1ff31$export$b2585dd3c345da47(options) {
    options.duration = 0;
    options.type = "keyframes";
}





const $8814a910df4e458b$var$browserColorFunctions = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function $8814a910df4e458b$export$1af9e65d1501d15(keyframes) {
    for(let i = 0; i < keyframes.length; i++){
        if (typeof keyframes[i] === "string" && $8814a910df4e458b$var$browserColorFunctions.test(keyframes[i])) return true;
    }
    return false;
}


const $702fac286bb86197$var$colorProperties = new Set([
    "color",
    "backgroundColor",
    "outlineColor",
    "fill",
    "stroke",
    "borderColor",
    "borderTopColor",
    "borderRightColor",
    "borderBottomColor",
    "borderLeftColor"
]);
const $702fac286bb86197$var$supportsWaapi = /*@__PURE__*/ (0, $373ae0ce1db34355$export$7c73462e0d25e514)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function $702fac286bb86197$export$ea92bde116fda821(options) {
    var _motionValue_owner;
    const { motionValue: motionValue, name: name, repeatDelay: repeatDelay, repeatType: repeatType, damping: damping, type: type, keyframes: keyframes } = options;
    const subject = motionValue === null || motionValue === void 0 ? void 0 : (_motionValue_owner = motionValue.owner) === null || _motionValue_owner === void 0 ? void 0 : _motionValue_owner.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate: onUpdate, transformTemplate: transformTemplate } = motionValue.owner.getProps();
    return $702fac286bb86197$var$supportsWaapi() && name && /**
         * Force WAAPI for color properties with browser-only color formats
         * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
         */ ((0, $95afec150de2825d$export$a27eefbd8fb5e404).has(name) || $702fac286bb86197$var$colorProperties.has(name) && (0, $8814a910df4e458b$export$1af9e65d1501d15)(keyframes)) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}


/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const $583944b926d997b7$var$MAX_RESOLVE_DELAY = 40;
class $583944b926d997b7$export$b9855e2a7dee3dd2 extends (0, $6940fcbd8d4ca66f$export$655db786091c33e0) {
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        var _resolvedOptions_motionValue_owner, _resolvedOptions_motionValue;
        this.keyframeResolver = undefined;
        const { name: name, type: type, velocity: velocity, delay: delay, isHandoff: isHandoff, onUpdate: onUpdate } = options;
        this.resolvedAt = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ let canAnimateValue = true;
        if (!(0, $2a4d473bd153758e$export$1b109e6c9968df4f)(keyframes, name, type, velocity)) {
            canAnimateValue = false;
            if ((0, $877fe7d159c5dd4c$export$dd826089e3c5e502).instantAnimations || !delay) onUpdate === null || onUpdate === void 0 ? void 0 : onUpdate((0, $fc831f8861054717$export$14de59408fad90b)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, $4513539b02d1ff31$export$b2585dd3c345da47)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first committed frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > $583944b926d997b7$var$MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            startTime: startTime,
            finalKeyframe: finalKeyframe
        }, options), {
            keyframes: keyframes
        });
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         *
         * Also skip WAAPI when keyframes aren't animatable, as the resolved
         * values may not be valid CSS and would trigger browser warnings.
         */ const useWaapi = canAnimateValue && !isHandoff && (0, $702fac286bb86197$export$ea92bde116fda821)(resolvedOptions);
        const element = (_resolvedOptions_motionValue = resolvedOptions.motionValue) === null || _resolvedOptions_motionValue === void 0 ? void 0 : (_resolvedOptions_motionValue_owner = _resolvedOptions_motionValue.owner) === null || _resolvedOptions_motionValue_owner === void 0 ? void 0 : _resolvedOptions_motionValue_owner.current;
        let animation;
        if (useWaapi) try {
            animation = new (0, $9f819ae9491bd189$export$bd2cd6a048093d96)((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, resolvedOptions), {
                element: element
            }));
        } catch (e) {
            animation = new (0, $66d5e49763a7f8a0$export$3394f837405475c7)(resolvedOptions);
        }
        else animation = new (0, $66d5e49763a7f8a0$export$3394f837405475c7)(resolvedOptions);
        animation.finished.then(()=>{
            this.notifyFinished();
        }).catch((0, $69d49105ec21595d$export$8793edee2d425525));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            var _this_keyframeResolver;
            (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.resume();
            (0, $cf13d99b8a449fd0$export$78b96d2a12593b05)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        var _this_keyframeResolver;
        if (this._animation) this.animation.cancel();
        (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
    }
    constructor(_param){
        var { autoplay: autoplay = true, delay: delay = 0, type: type = "keyframes", repeat: repeat = 0, repeatDelay: repeatDelay = 0, repeatType: repeatType = "loop", keyframes: keyframes, name: name, motionValue: motionValue, element: element } = _param, options = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
            "autoplay",
            "delay",
            "type",
            "repeat",
            "repeatDelay",
            "repeatType",
            "keyframes",
            "name",
            "motionValue",
            "element"
        ]);
        var _this_keyframeResolver;
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            var _this_keyframeResolver;
            if (this._animation) {
                var _this_stopTimeline, _this;
                this._animation.stop();
                (_this_stopTimeline = (_this = this).stopTimeline) === null || _this_stopTimeline === void 0 ? void 0 : _this_stopTimeline.call(_this);
            }
            (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.cancel();
        };
        this.createdAt = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
        const optionsWithDefaults = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            autoplay: autoplay,
            delay: delay,
            type: type,
            repeat: repeat,
            repeatDelay: repeatDelay,
            repeatType: repeatType,
            name: name,
            motionValue: motionValue,
            element: element
        }, options);
        const KeyframeResolver$1 = (element === null || element === void 0 ? void 0 : element.KeyframeResolver) || (0, $cf13d99b8a449fd0$export$74d34ca3182f1750);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        (_this_keyframeResolver = this.keyframeResolver) === null || _this_keyframeResolver === void 0 ? void 0 : _this_keyframeResolver.scheduleResolve();
    }
}






const $23d00b80313b3daf$var$underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const $23d00b80313b3daf$var$criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const $23d00b80313b3daf$var$keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const $23d00b80313b3daf$var$ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const $23d00b80313b3daf$export$262124b154b9f1c0 = (valueKey, { keyframes: keyframes })=>{
    if (keyframes.length > 2) return $23d00b80313b3daf$var$keyframesTransition;
    else if ((0, $36437dbf5b93c477$export$7b42a0094fb00b6e).has(valueKey)) return valueKey.startsWith("scale") ? $23d00b80313b3daf$var$criticallyDampedSpring(keyframes[1]) : $23d00b80313b3daf$var$underDampedSpring;
    return $23d00b80313b3daf$var$ease;
};



const $ddc4f6cd9cc92def$var$orchestrationKeys = new Set([
    "when",
    "delay",
    "delayChildren",
    "staggerChildren",
    "staggerDirection",
    "repeat",
    "repeatType",
    "repeatDelay",
    "from",
    "elapsed"
]);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function $ddc4f6cd9cc92def$export$ca8e47dc8ed5a9d7(transition) {
    for(const key in transition){
        if (!$ddc4f6cd9cc92def$var$orchestrationKeys.has(key)) return true;
    }
    return false;
}



const $17ccdc0a04fec700$export$90b3dfc33ff3548 = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, $445378a930c6db37$export$7c1391340308742e)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed: elapsed = 0 } = transition;
        elapsed = elapsed - (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(delay);
        const options = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity()
        }, valueTransition), {
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name: name,
            motionValue: value,
            element: isHandoff ? undefined : element
        });
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, $ddc4f6cd9cc92def$export$ca8e47dc8ed5a9d7)(valueTransition)) Object.assign(options, (0, $23d00b80313b3daf$export$262124b154b9f1c0)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, $4513539b02d1ff31$export$b2585dd3c345da47)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, $877fe7d159c5dd4c$export$dd826089e3c5e502).instantAnimations || (0, $877fe7d159c5dd4c$export$dd826089e3c5e502).skipAnimations || (element === null || element === void 0 ? void 0 : element.shouldSkipAnimations) || valueTransition.skipAnimations) {
            shouldSkip = true;
            (0, $4513539b02d1ff31$export$b2585dd3c345da47)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, $fc831f8861054717$export$14de59408fad90b)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, $66d5e49763a7f8a0$export$3394f837405475c7)(options) : new (0, $583944b926d997b7$export$b9855e2a7dee3dd2)(options);
    };



/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function $8910548cca780654$var$shouldBlockAnimation({ protectedKeys: protectedKeys, needsAnimating: needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function $8910548cca780654$export$68cacfeee78d98d2(visualElement, targetAndTransition, { delay: delay = 0, transitionOverride: transitionOverride, type: type } = {}) {
    let { transition: transition, transitionEnd: transitionEnd } = targetAndTransition, target = (0, $8901fc92b5563702$export$71511d61b312f219)(targetAndTransition, [
        "transition",
        "transitionEnd"
    ]);
    const defaultTransition = visualElement.getDefaultTransition();
    transition = transition ? (0, $46f6985c0d37a6d0$export$b180037f8f468d61)(transition, defaultTransition) : defaultTransition;
    const reduceMotion = transition === null || transition === void 0 ? void 0 : transition.reduceMotion;
    const skipAnimations = transition === null || transition === void 0 ? void 0 : transition.skipAnimations;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    const path = transition === null || transition === void 0 ? void 0 : transition.path;
    if (path) // path mutates `target` to claim x/y; loop below skips them.
    path.animateVisualElement(visualElement, target, transition, delay, animations);
    for(const key in target){
        var _visualElement_latestValues_key;
        const value = visualElement.getValue(key, (_visualElement_latestValues_key = visualElement.latestValues[key]) !== null && _visualElement_latestValues_key !== void 0 ? _visualElement_latestValues_key : null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && $8910548cca780654$var$shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            delay: delay
        }, (0, $445378a930c6db37$export$7c1391340308742e)(transition || {}, key));
        if (skipAnimations) valueTransition.skipAnimations = true;
        /**
         * If the value is already at the defined target, skip the animation.
         * We still re-assert the value via frame.update to take precedence
         * over any stale transitionEnd callbacks from previous animations.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating() && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>value.set(valueTarget));
            continue;
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, $dedda87bce0b0fc0$export$5f8d21e84d1d84fc)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, $44c600a9437aff7c$export$2cef06c20297c17d));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, $5d399ca24ed34089$export$3ac5aed310be0bee)(visualElement, key);
        const shouldReduceMotion = reduceMotion !== null && reduceMotion !== void 0 ? reduceMotion : visualElement.shouldReduceMotion;
        value.start((0, $17ccdc0a04fec700$export$90b3dfc33ff3548)(key, value, valueTarget, shouldReduceMotion && (0, $3686a9bc645641a9$export$c66c0d5db2a205d).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) {
        const applyTransitionEnd = ()=>(0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>{
                transitionEnd && (0, $52953efd8694e3bd$export$1f61c53461aff4a5)(visualElement, transitionEnd);
            });
        if (animations.length) Promise.all(animations).then(applyTransitionEnd);
        else applyTransitionEnd();
    }
    return animations;
}





function $82431a0874d8653b$export$6e01cb2cb232d79b(children, child, delayChildren, staggerChildren = 0, staggerDirection = 1) {
    const index = Array.from(children).sort((a, b)=>a.sortNodePosition(b)).indexOf(child);
    const numChildren = children.size;
    const maxStaggerDuration = (numChildren - 1) * staggerChildren;
    const delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}



function $f887f02df845c390$export$4709dc300705b2af(visualElement, variant, options = {}) {
    var _visualElement_presenceContext;
    const resolved = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(visualElement, variant, options.type === "exit" ? (_visualElement_presenceContext = visualElement.presenceContext) === null || _visualElement_presenceContext === void 0 ? void 0 : _visualElement_presenceContext.custom : undefined);
    let { transition: transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, $8910548cca780654$export$68cacfeee78d98d2)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren: delayChildren = 0, staggerChildren: staggerChildren, staggerDirection: staggerDirection } = transition;
        return $f887f02df845c390$var$animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when: when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function $f887f02df845c390$var$animateChildren(visualElement, variant, delay = 0, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    for (const child of visualElement.variantChildren){
        child.notify("AnimationStart", variant);
        animations.push($f887f02df845c390$export$4709dc300705b2af(child, variant, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, $82431a0874d8653b$export$6e01cb2cb232d79b)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
        })).then(()=>child.notify("AnimationComplete", variant)));
    }
    return Promise.all(animations);
}


function $f021ea9634d8167f$export$ff62cf473653f109(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, $f887f02df845c390$export$4709dc300705b2af)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, $f887f02df845c390$export$4709dc300705b2af)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, $8910548cca780654$export$68cacfeee78d98d2)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}





const $ea9b74448f41084f$var$numVariantProps = (0, $c8a0734e2ee77275$export$1405a65085f40b9).length;
/**
 * Get variant context from a visual element's parent chain.
 * Uses `any` type for visualElement to avoid circular dependencies.
 */ function $ea9b74448f41084f$export$6669f52f7ffa343b(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? $ea9b74448f41084f$export$6669f52f7ffa343b(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < $ea9b74448f41084f$var$numVariantProps; i++){
        const name = (0, $c8a0734e2ee77275$export$1405a65085f40b9)[i];
        const prop = visualElement.props[name];
        if ((0, $b2fb93622bbd7df5$export$720b90e312cea233)(prop) || prop === false) context[name] = prop;
    }
    return context;
}






function $13e2025e9e744d5f$export$90e866afbd6b9f1a(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}



const $7cf90d6b464741cf$var$reversePriorityOrder = [
    ...(0, $c8a0734e2ee77275$export$16e45afcc206d3a8)
].reverse();
const $7cf90d6b464741cf$var$numAnimationTypes = (0, $c8a0734e2ee77275$export$16e45afcc206d3a8).length;
function $7cf90d6b464741cf$var$createAnimateFunction(visualElement) {
    return (animations)=>{
        return Promise.all(animations.map(({ animation: animation, options: options })=>(0, $f021ea9634d8167f$export$ff62cf473653f109)(visualElement, animation, options)));
    };
}
function $7cf90d6b464741cf$export$bb53502b7a672aa8(visualElement) {
    let animate = $7cf90d6b464741cf$var$createAnimateFunction(visualElement);
    let state = $7cf90d6b464741cf$var$createState();
    let isInitialRender = true;
    /**
     * Track whether the animation state has been reset (e.g. via StrictMode
     * double-invocation or Suspense unmount/remount). On the first
     * animateChanges() call after a reset we need to behave like the initial
     * render for variant-inheritance checks, even though isInitialRender is
     * already false.
     */ let wasReset = false;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            var _visualElement_presenceContext;
            const resolved = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(visualElement, definition, type === "exit" ? (_visualElement_presenceContext = visualElement.presenceContext) === null || _visualElement_presenceContext === void 0 ? void 0 : _visualElement_presenceContext.custom : undefined);
            if (resolved) {
                const { transition: transition, transitionEnd: transitionEnd } = resolved, target = (0, $8901fc92b5563702$export$71511d61b312f219)(resolved, [
                    "transition",
                    "transitionEnd"
                ]);
                acc = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, acc, target, transitionEnd);
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props: props } = visualElement;
        const context = (0, $ea9b74448f41084f$export$6669f52f7ffa343b)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < $7cf90d6b464741cf$var$numAnimationTypes; i++){
            const type = $7cf90d6b464741cf$var$reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, $b2fb93622bbd7df5$export$720b90e312cea233)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && (isInitialRender || wasReset) && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, encounteredKeys);
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, $197e81262ee8f44d$export$aa71198ceeaf53ce)(prop) || typeof prop === "boolean") continue;
            /**
             * If exit is already active and wasn't just activated, skip
             * re-processing to prevent interrupting running exit animations.
             * Re-resolving exit with a changed custom value can start new
             * value animations that stop the originals, leaving the exit
             * animation promise unresolved and the component stuck in the DOM.
             */ if (type === "exit" && typeState.isActive && activeDelta !== true) {
                if (typeState.prevResolvedValues) encounteredKeys = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, encounteredKeys, typeState.prevResolvedValues);
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = $7cf90d6b464741cf$export$68651800594fd43c(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues: prevResolvedValues = {} } = typeState;
            const allKeys = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, prevResolvedValues, resolvedValues);
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, $b86f35c91384031e$export$9153ad4c4999f4a0)(next) && (0, $b86f35c91384031e$export$9153ad4c4999f4a0)(prev)) valueHasChanged = !(0, $13e2025e9e744d5f$export$90e866afbd6b9f1a)(next, prev) || variantDidChange;
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, encounteredKeys, resolvedValues);
            if ((isInitialRender || wasReset) && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>{
                const options = {
                    type: type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && (isInitialRender || wasReset) && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    const { parent: parent } = visualElement;
                    const parentVariant = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        const { delayChildren: delayChildren } = parentVariant.transition || {};
                        options.delay = (0, $82431a0874d8653b$export$6e01cb2cb232d79b)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options: options
                };
            }));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget !== null && fallbackTarget !== void 0 ? fallbackTarget : null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        wasReset = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        var // Propagate active change to children
        _visualElement_variantChildren;
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        (_visualElement_variantChildren = visualElement.variantChildren) === null || _visualElement_variantChildren === void 0 ? void 0 : _visualElement_variantChildren.forEach((child)=>{
            var _child_animationState;
            return (_child_animationState = child.animationState) === null || _child_animationState === void 0 ? void 0 : _child_animationState.setActive(type, isActive);
        });
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges: animateChanges,
        setActive: setActive,
        setAnimateFunction: setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = $7cf90d6b464741cf$var$createState();
            wasReset = true;
        }
    };
}
function $7cf90d6b464741cf$export$68651800594fd43c(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, $13e2025e9e744d5f$export$90e866afbd6b9f1a)(next, prev);
    return false;
}
function $7cf90d6b464741cf$var$createTypeState(isActive = false) {
    return {
        isActive: isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function $7cf90d6b464741cf$var$createState() {
    return {
        animate: $7cf90d6b464741cf$var$createTypeState(true),
        whileInView: $7cf90d6b464741cf$var$createTypeState(),
        whileHover: $7cf90d6b464741cf$var$createTypeState(),
        whileTap: $7cf90d6b464741cf$var$createTypeState(),
        whileDrag: $7cf90d6b464741cf$var$createTypeState(),
        whileFocus: $7cf90d6b464741cf$var$createTypeState(),
        exit: $7cf90d6b464741cf$var$createTypeState()
    };
}

/**
 * Feature base class for extending VisualElement functionality.
 * Features are plugins that can be mounted/unmounted to add behavior
 * like gestures, animations, or layout tracking.
 */ class $3bb21a5535a42c32$export$6e91cf7616333d5 {
    update() {}
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
}


class $f6a9c87179214dae$export$b45b3fe5caabdca extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    updateAnimationControlsSubscription() {
        const { animate: animate } = this.node.getProps();
        if ((0, $197e81262ee8f44d$export$aa71198ceeaf53ce)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate: animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        var _this_unmountControls, _this;
        this.node.animationState.reset();
        (_this_unmountControls = (_this = this).unmountControls) === null || _this_unmountControls === void 0 ? void 0 : _this_unmountControls.call(_this);
    }
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, $7cf90d6b464741cf$export$bb53502b7a672aa8)(node));
    }
}




let $4c6e705b5858a78b$var$id = 0;
class $4c6e705b5858a78b$export$4989d1eb6104cc6c extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent: isPresent, onExitComplete: onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        if (isPresent && prevIsPresent === false) {
            /**
             * When re-entering, if the exit animation already completed
             * (element is at rest), reset to initial values so the enter
             * animation replays from the correct position.
             */ if (this.isExitComplete) {
                const { initial: initial, custom: custom } = this.node.getProps();
                if (typeof initial === "string" || typeof initial === "object" && initial !== null && !Array.isArray(initial)) {
                    const resolved = (0, $0f821ea1e0e898c8$export$7b1b1c981f4f0558)(this.node, initial, custom);
                    if (resolved) {
                        var _this_node_getValue;
                        const { transition: transition, transitionEnd: transitionEnd } = resolved, target = (0, $8901fc92b5563702$export$71511d61b312f219)(resolved, [
                            "transition",
                            "transitionEnd"
                        ]);
                        for(const key in target)(_this_node_getValue = this.node.getValue(key)) === null || _this_node_getValue === void 0 ? void 0 : _this_node_getValue.jump(target[key]);
                    }
                }
                this.node.animationState.reset();
                this.node.animationState.animateChanges();
            } else this.node.animationState.setActive("exit", false);
            this.isExitComplete = false;
            return;
        }
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            this.isExitComplete = true;
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register: register, onExitComplete: onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.id = $4c6e705b5858a78b$var$id++;
        this.isExitComplete = false;
    }
}


const $9bb9392be544c52d$export$7f9953c70dacfd7f = {
    animation: {
        Feature: (0, $f6a9c87179214dae$export$b45b3fe5caabdca)
    },
    exit: {
        Feature: (0, $4c6e705b5858a78b$export$4989d1eb6104cc6c)
    }
};






function $4da397d0e67b1b1d$export$b1d829ddf82884aa(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}


const $69391feb435da50e$var$SCALE_PRECISION = 0.0001;
const $69391feb435da50e$var$SCALE_MIN = 1 - $69391feb435da50e$var$SCALE_PRECISION;
const $69391feb435da50e$var$SCALE_MAX = 1 + $69391feb435da50e$var$SCALE_PRECISION;
const $69391feb435da50e$var$TRANSLATE_PRECISION = 0.01;
const $69391feb435da50e$var$TRANSLATE_MIN = 0 - $69391feb435da50e$var$TRANSLATE_PRECISION;
const $69391feb435da50e$var$TRANSLATE_MAX = 0 + $69391feb435da50e$var$TRANSLATE_PRECISION;
function $69391feb435da50e$export$c1c127004b72a37(axis) {
    return axis.max - axis.min;
}
function $69391feb435da50e$export$28d0384c4b79bde2(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function $69391feb435da50e$export$e90fc1ae5e3e48ed(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(source.min, source.max, delta.origin);
    delta.scale = $69391feb435da50e$export$c1c127004b72a37(target) / $69391feb435da50e$export$c1c127004b72a37(source);
    delta.translate = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= $69391feb435da50e$var$SCALE_MIN && delta.scale <= $69391feb435da50e$var$SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= $69391feb435da50e$var$TRANSLATE_MIN && delta.translate <= $69391feb435da50e$var$TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function $69391feb435da50e$export$c0d25e96fc67d310(delta, source, target, origin) {
    $69391feb435da50e$export$e90fc1ae5e3e48ed(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    $69391feb435da50e$export$e90fc1ae5e3e48ed(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function $69391feb435da50e$export$cabef5b392704b41(target, relative, parent, anchor = 0) {
    const anchorPoint = anchor ? (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(parent.min, parent.max, anchor) : parent.min;
    target.min = anchorPoint + relative.min;
    target.max = target.min + $69391feb435da50e$export$c1c127004b72a37(relative);
}
function $69391feb435da50e$export$426154f9d100f99(target, relative, parent, anchor) {
    $69391feb435da50e$export$cabef5b392704b41(target.x, relative.x, parent.x, anchor === null || anchor === void 0 ? void 0 : anchor.x);
    $69391feb435da50e$export$cabef5b392704b41(target.y, relative.y, parent.y, anchor === null || anchor === void 0 ? void 0 : anchor.y);
}
function $69391feb435da50e$export$ecd3d3bef81102c3(target, layout, parent, anchor = 0) {
    const anchorPoint = anchor ? (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(parent.min, parent.max, anchor) : parent.min;
    target.min = layout.min - anchorPoint;
    target.max = target.min + $69391feb435da50e$export$c1c127004b72a37(layout);
}
function $69391feb435da50e$export$2785bfcc929c5650(target, layout, parent, anchor) {
    $69391feb435da50e$export$ecd3d3bef81102c3(target.x, layout.x, parent.x, anchor === null || anchor === void 0 ? void 0 : anchor.x);
    $69391feb435da50e$export$ecd3d3bef81102c3(target.y, layout.y, parent.y, anchor === null || anchor === void 0 ? void 0 : anchor.y);
}

function $2ac6ee71286c3d0e$export$b789de563eb43b1(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

const $86168a8dbbef73c2$var$keyboardAccessibleElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
/**
 * Checks if an element is natively keyboard accessible (focusable).
 * Used by the press gesture to determine if we need to add tabIndex.
 */ function $86168a8dbbef73c2$export$5f6976e2f961e8b7(element) {
    return $86168a8dbbef73c2$var$keyboardAccessibleElements.has(element.tagName) || element.isContentEditable === true;
}
const $86168a8dbbef73c2$var$textInputElements = new Set([
    "INPUT",
    "SELECT",
    "TEXTAREA"
]);
/**
 * Checks if an element has text selection or direct interaction behavior
 * that should block drag gestures from starting.
 *
 * This specifically targets form controls where the user might want to select
 * text or interact with the control (e.g., sliders, dropdowns).
 *
 * Buttons and links are NOT included because they don't have click-and-move
 * actions of their own - they only respond to click events, so dragging
 * should still work when initiated from these elements.
 */ function $86168a8dbbef73c2$export$41e5a41992b76128(element) {
    return $86168a8dbbef73c2$var$textInputElements.has(element.tagName) || element.isContentEditable === true;
}

const $d93f81859b2d5a5f$export$a6cdc56e425d0d0a = (value)=>typeof value === "object" && value !== null;


/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function $d21d6497287d50b6$export$17eda790a720ec57(element) {
    return (0, $d93f81859b2d5a5f$export$a6cdc56e425d0d0a)(element) && "ownerSVGElement" in element;
}


function $6709e3be20d4c81f$export$90ceba2564a894f8(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector == null) return [];
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        var _selectorCache_elementOrSelector;
        const elements = (_selectorCache_elementOrSelector = selectorCache === null || selectorCache === void 0 ? void 0 : selectorCache[elementOrSelector]) !== null && _selectorCache_elementOrSelector !== void 0 ? _selectorCache_elementOrSelector : root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector).filter((element)=>element != null);
}


const $d9065a51219d0ea0$var$resizeHandlers = new WeakMap();
let $d9065a51219d0ea0$var$observer;
const $d9065a51219d0ea0$var$getSize = (borderBoxAxis, svgAxis, htmlAxis)=>(target, borderBoxSize)=>{
        if (borderBoxSize && borderBoxSize[0]) return borderBoxSize[0][borderBoxAxis + "Size"];
        else if ((0, $d21d6497287d50b6$export$17eda790a720ec57)(target) && "getBBox" in target) return target.getBBox()[svgAxis];
        else return target[htmlAxis];
    };
const $d9065a51219d0ea0$var$getWidth = /*@__PURE__*/ $d9065a51219d0ea0$var$getSize("inline", "width", "offsetWidth");
const $d9065a51219d0ea0$var$getHeight = /*@__PURE__*/ $d9065a51219d0ea0$var$getSize("block", "height", "offsetHeight");
function $d9065a51219d0ea0$var$notifyTarget({ target: target, borderBoxSize: borderBoxSize }) {
    var _resizeHandlers_get;
    (_resizeHandlers_get = $d9065a51219d0ea0$var$resizeHandlers.get(target)) === null || _resizeHandlers_get === void 0 ? void 0 : _resizeHandlers_get.forEach((handler)=>{
        handler(target, {
            get width () {
                return $d9065a51219d0ea0$var$getWidth(target, borderBoxSize);
            },
            get height () {
                return $d9065a51219d0ea0$var$getHeight(target, borderBoxSize);
            }
        });
    });
}
function $d9065a51219d0ea0$var$notifyAll(entries) {
    entries.forEach($d9065a51219d0ea0$var$notifyTarget);
}
function $d9065a51219d0ea0$var$createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    $d9065a51219d0ea0$var$observer = new ResizeObserver($d9065a51219d0ea0$var$notifyAll);
}
function $d9065a51219d0ea0$export$81a0e12ec749d682(target, handler) {
    if (!$d9065a51219d0ea0$var$observer) $d9065a51219d0ea0$var$createResizeObserver();
    const elements = (0, $6709e3be20d4c81f$export$90ceba2564a894f8)(target);
    elements.forEach((element)=>{
        let elementHandlers = $d9065a51219d0ea0$var$resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            $d9065a51219d0ea0$var$resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        $d9065a51219d0ea0$var$observer === null || $d9065a51219d0ea0$var$observer === void 0 ? void 0 : $d9065a51219d0ea0$var$observer.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = $d9065a51219d0ea0$var$resizeHandlers.get(element);
            elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.delete(handler);
            if (!(elementHandlers === null || elementHandlers === void 0 ? void 0 : elementHandlers.size)) $d9065a51219d0ea0$var$observer === null || $d9065a51219d0ea0$var$observer === void 0 ? void 0 : $d9065a51219d0ea0$var$observer.unobserve(element);
        });
    };
}


const $8744c9ec1840e76d$var$windowCallbacks = new Set();
let $8744c9ec1840e76d$var$windowResizeHandler;
function $8744c9ec1840e76d$var$createWindowResizeHandler() {
    $8744c9ec1840e76d$var$windowResizeHandler = ()=>{
        const info = {
            get width () {
                return window.innerWidth;
            },
            get height () {
                return window.innerHeight;
            }
        };
        $8744c9ec1840e76d$var$windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", $8744c9ec1840e76d$var$windowResizeHandler);
}
function $8744c9ec1840e76d$export$7fc81011b72cd94d(callback) {
    $8744c9ec1840e76d$var$windowCallbacks.add(callback);
    if (!$8744c9ec1840e76d$var$windowResizeHandler) $8744c9ec1840e76d$var$createWindowResizeHandler();
    return ()=>{
        $8744c9ec1840e76d$var$windowCallbacks.delete(callback);
        if (!$8744c9ec1840e76d$var$windowCallbacks.size && typeof $8744c9ec1840e76d$var$windowResizeHandler === "function") {
            window.removeEventListener("resize", $8744c9ec1840e76d$var$windowResizeHandler);
            $8744c9ec1840e76d$var$windowResizeHandler = undefined;
        }
    };
}


function $e568be821d367350$export$4380c87abf28fdf(a, b) {
    return typeof a === "function" ? (0, $8744c9ec1840e76d$export$7fc81011b72cd94d)(a) : (0, $d9065a51219d0ea0$export$81a0e12ec749d682)(a, b);
}

const $712c7e4e4b7d1d34$export$9e9bc3c487fccc00 = {
    x: false,
    y: false
};
function $712c7e4e4b7d1d34$export$1b3dd616664938e4() {
    return $712c7e4e4b7d1d34$export$9e9bc3c487fccc00.x || $712c7e4e4b7d1d34$export$9e9bc3c487fccc00.y;
}


function $34c0dc4b9011d4ce$export$64d8a3fd7eb621d5(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00)[axis]) return null;
        else {
            (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00)[axis] = true;
            return ()=>{
                (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00)[axis] = false;
            };
        }
    } else {
        if ((0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).x || (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).y) return null;
        else {
            (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).x = (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).y = true;
            return ()=>{
                (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).x = (0, $712c7e4e4b7d1d34$export$9e9bc3c487fccc00).y = false;
            };
        }
    }
}




const $8260b027ce2c0643$export$a4cf9c8a4b063a6e = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};


function $fc126d8b66e58ebd$export$12f84bb882d06e1a(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const $fc126d8b66e58ebd$export$c404e80f92c98d29 = (handler)=>(event)=>(0, $8260b027ce2c0643$export$a4cf9c8a4b063a6e)(event) && handler(event, $fc126d8b66e58ebd$export$12f84bb882d06e1a(event));


function $1f42ffe5b9091d52$export$fcff2e64e6676b81(target, eventName, handler, options) {
    return (0, $4da397d0e67b1b1d$export$b1d829ddf82884aa)(target, eventName, (0, $fc126d8b66e58ebd$export$c404e80f92c98d29)(handler), options);
}



// Fixes https://github.com/motiondivision/motion/issues/2270
const $4089e47ff1a2b128$export$d533d84f9871c879 = ({ current: current })=>{
    return current ? current.ownerDocument.defaultView : null;
};









const $8df1b266d7b10633$export$9f17032d917177de = (a, b)=>Math.abs(a - b);
function $8df1b266d7b10633$export$503a1d513f12e38b(a, b) {
    // Multi-dimensional
    const xDelta = $8df1b266d7b10633$export$9f17032d917177de(a.x, b.x);
    const yDelta = $8df1b266d7b10633$export$9f17032d917177de(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}


const $caca2cdd35c93217$var$overflowStyles = /*#__PURE__*/ new Set([
    "auto",
    "scroll"
]);
/**
 * @internal
 */ class $caca2cdd35c93217$export$d9c66232c9c4689c {
    /**
     * Start tracking scroll on ancestors and window.
     */ startScrollTracking(element) {
        // Store initial scroll positions for scrollable ancestors
        let current = element.parentElement;
        while(current){
            const style = getComputedStyle(current);
            if ($caca2cdd35c93217$var$overflowStyles.has(style.overflowX) || $caca2cdd35c93217$var$overflowStyles.has(style.overflowY)) this.scrollPositions.set(current, {
                x: current.scrollLeft,
                y: current.scrollTop
            });
            current = current.parentElement;
        }
        // Track window scroll
        this.scrollPositions.set(window, {
            x: window.scrollX,
            y: window.scrollY
        });
        // Capture listener catches element scroll events as they bubble
        window.addEventListener("scroll", this.onElementScroll, {
            capture: true
        });
        // Direct window scroll listener (window scroll doesn't bubble)
        window.addEventListener("scroll", this.onWindowScroll);
        this.removeScrollListeners = ()=>{
            window.removeEventListener("scroll", this.onElementScroll, {
                capture: true
            });
            window.removeEventListener("scroll", this.onWindowScroll);
        };
    }
    /**
     * Handle scroll compensation during drag.
     *
     * For element scroll: adjusts history origin since pageX/pageY doesn't change.
     * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
     */ handleScroll(target) {
        const initial = this.scrollPositions.get(target);
        if (!initial) return;
        const isWindow = target === window;
        const current = isWindow ? {
            x: window.scrollX,
            y: window.scrollY
        } : {
            x: target.scrollLeft,
            y: target.scrollTop
        };
        const delta = {
            x: current.x - initial.x,
            y: current.y - initial.y
        };
        if (delta.x === 0 && delta.y === 0) return;
        if (isWindow) // Window scroll: pageX/pageY changes, so update lastMoveEventInfo
        {
            if (this.lastMoveEventInfo) {
                this.lastMoveEventInfo.point.x += delta.x;
                this.lastMoveEventInfo.point.y += delta.y;
            }
        } else // Element scroll: pageX/pageY unchanged, so adjust history origin
        if (this.history.length > 0) {
            this.history[0].x -= delta.x;
            this.history[0].y -= delta.y;
        }
        this.scrollPositions.set(target, current);
        (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(this.updatePoint, true);
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        this.removeScrollListeners && this.removeScrollListeners();
        this.scrollPositions.clear();
        (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(this.updatePoint);
    }
    constructor(event, handlers, { transformPagePoint: transformPagePoint, contextWindow: contextWindow = window, dragSnapToOrigin: dragSnapToOrigin = false, distanceThreshold: distanceThreshold = 3, element: element } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * Raw (untransformed) event info, re-transformed each frame
         * so transformPagePoint sees the current parent matrix.
         * @internal
         */ this.lastRawMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        /**
         * Scroll positions of scrollable ancestors and window.
         * @internal
         */ this.scrollPositions = new Map();
        /**
         * Cleanup function for scroll listeners.
         * @internal
         */ this.removeScrollListeners = null;
        this.onElementScroll = (event)=>{
            this.handleScroll(event.target);
        };
        this.onWindowScroll = ()=>{
            this.handleScroll(window);
        };
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            // Re-transform raw point through current transformPagePoint so
            // animated parent transforms (e.g. rotation) are picked up each frame
            if (this.lastRawMoveEventInfo) this.lastMoveEventInfo = $caca2cdd35c93217$var$transformPoint(this.lastRawMoveEventInfo, this.transformPagePoint);
            const info = $caca2cdd35c93217$var$getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            const isDistancePastThreshold = (0, $8df1b266d7b10633$export$503a1d513f12e38b)(info.offset, {
                x: 0,
                y: 0
            }) >= this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point: point } = info;
            const { timestamp: timestamp } = (0, $44c600a9437aff7c$export$fff89137e9e818ce);
            this.history.push((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, point), {
                timestamp: timestamp
            }));
            const { onStart: onStart, onMove: onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastRawMoveEventInfo = info;
            this.lastMoveEventInfo = $caca2cdd35c93217$var$transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd: onEnd, onSessionEnd: onSessionEnd, resumeAnimation: resumeAnimation } = this.handlers;
            // Resume animation if dragSnapToOrigin is set OR if no drag started (user just clicked)
            // This ensures constraint animations continue when interrupted by a click
            if (this.dragSnapToOrigin || !this.startEvent) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = $caca2cdd35c93217$var$getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : $caca2cdd35c93217$var$transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, $8260b027ce2c0643$export$a4cf9c8a4b063a6e)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        const info = (0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(event);
        const initialInfo = $caca2cdd35c93217$var$transformPoint(info, this.transformPagePoint);
        const { point: point } = initialInfo;
        const { timestamp: timestamp } = (0, $44c600a9437aff7c$export$fff89137e9e818ce);
        this.history = [
            (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, point), {
                timestamp: timestamp
            })
        ];
        const { onSessionStart: onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, $caca2cdd35c93217$var$getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, $113d54600cb8d2d0$export$a4627e546088548d)((0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.contextWindow, "pointermove", this.handlePointerMove), (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.contextWindow, "pointerup", this.handlePointerUp), (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.contextWindow, "pointercancel", this.handlePointerUp));
        // Start scroll tracking if element provided
        if (element) this.startScrollTracking(element);
    }
}
function $caca2cdd35c93217$var$transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function $caca2cdd35c93217$var$subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $caca2cdd35c93217$var$getPanInfo({ point: point }, history) {
    return {
        point: point,
        delta: $caca2cdd35c93217$var$subtractPoint(point, $caca2cdd35c93217$var$lastDevicePoint(history)),
        offset: $caca2cdd35c93217$var$subtractPoint(point, $caca2cdd35c93217$var$startDevicePoint(history)),
        velocity: $caca2cdd35c93217$var$getVelocity(history, 0.1)
    };
}
function $caca2cdd35c93217$var$startDevicePoint(history) {
    return history[0];
}
function $caca2cdd35c93217$var$lastDevicePoint(history) {
    return history[history.length - 1];
}
function $caca2cdd35c93217$var$getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = $caca2cdd35c93217$var$lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    /**
     * If the selected point is the pointer-down origin (history[0]),
     * there are better movement points available, and the time gap
     * is suspiciously large (>2x timeDelta), use the next point instead.
     * This prevents stale pointer-down points from diluting velocity
     * in hold-then-flick gestures.
     */ if (timestampedPoint === history[0] && history.length > 2 && lastPoint.timestamp - timestampedPoint.timestamp > (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(timeDelta) * 2) timestampedPoint = history[1];
    const time = (0, $d17a7d2c2068c118$export$f64c3bfbc58eec0f)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}




/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function $1e37744b98f775f4$export$b3c764d3fca3ffe3(point, { min: min, max: max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function $1e37744b98f775f4$export$690c180aa5775042(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function $1e37744b98f775f4$export$4e9195bf7793bc78(layoutBox, { top: top, left: left, bottom: bottom, right: right }) {
    return {
        x: $1e37744b98f775f4$export$690c180aa5775042(layoutBox.x, left, right),
        y: $1e37744b98f775f4$export$690c180aa5775042(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function $1e37744b98f775f4$export$87abc398c3c7ce27(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min: min,
        max: max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function $1e37744b98f775f4$export$4228500f19d4cdf7(layoutBox, constraintsBox) {
    return {
        x: $1e37744b98f775f4$export$87abc398c3c7ce27(layoutBox.x, constraintsBox.x),
        y: $1e37744b98f775f4$export$87abc398c3c7ce27(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function $1e37744b98f775f4$export$13abbfca044ca46d(source, target) {
    let origin = 0.5;
    const sourceLength = (0, $69391feb435da50e$export$c1c127004b72a37)(source);
    const targetLength = (0, $69391feb435da50e$export$c1c127004b72a37)(target);
    if (targetLength > sourceLength) origin = (0, $5a7354d1e57d5b3d$export$504d7abb21fa8c9)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, $5a7354d1e57d5b3d$export$504d7abb21fa8c9)(source.min, source.max - targetLength, target.min);
    return (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function $1e37744b98f775f4$export$e9672cc4c36a8b87(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const $1e37744b98f775f4$export$a3366d3bac43a742 = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function $1e37744b98f775f4$export$7c5eaef8f4723d22(dragElastic = $1e37744b98f775f4$export$a3366d3bac43a742) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = $1e37744b98f775f4$export$a3366d3bac43a742;
    return {
        x: $1e37744b98f775f4$export$589076940abb04b5(dragElastic, "left", "right"),
        y: $1e37744b98f775f4$export$589076940abb04b5(dragElastic, "top", "bottom")
    };
}
function $1e37744b98f775f4$export$589076940abb04b5(dragElastic, minLabel, maxLabel) {
    return {
        min: $1e37744b98f775f4$export$bbbc10b82e6c0afb(dragElastic, minLabel),
        max: $1e37744b98f775f4$export$bbbc10b82e6c0afb(dragElastic, maxLabel)
    };
}
function $1e37744b98f775f4$export$bbbc10b82e6c0afb(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}


const $a35deb4b2fbeb723$export$f0a15892c27dc07c = new WeakMap();
class $a35deb4b2fbeb723$export$86bff71f18910307 {
    start(originEvent, { snapToCursor: snapToCursor = false, distanceThreshold: distanceThreshold } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext: presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            if (snapToCursor) this.snapToCursor((0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(event).point);
            this.stopAnimation();
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag: drag, dragPropagation: dragPropagation, onDragStart: onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, $34c0dc4b9011d4ce$export$64d8a3fd7eb621d5)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin and pointer offset
             */ (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, $f1a72de1b348da89$export$626336c2cd4b14de).test(current)) {
                    const { projection: projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, $69391feb435da50e$export$c1c127004b72a37)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>onDragStart(event, info), false, true);
            (0, $5d399ca24ed34089$export$3ac5aed310be0bee)(this.visualElement, "transform");
            const { animationState: animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            const { dragPropagation: dragPropagation, dragDirectionLock: dragDirectionLock, onDirectionLock: onDirectionLock, onDrag: onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset: offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = $a35deb4b2fbeb723$var$getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ if (onDrag) (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>onDrag(event, info), false, true);
        };
        const onSessionEnd = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.stop(event, info);
            this.latestPointerEvent = null;
            this.latestPanInfo = null;
        };
        const resumeAnimation = ()=>{
            const { dragSnapToOrigin: snap } = this.getProps();
            if (snap || this.constraints) this.startAnimation({
                x: 0,
                y: 0
            });
        };
        const { dragSnapToOrigin: dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, $caca2cdd35c93217$export$d9c66232c9c4689c)(originEvent, {
            onSessionStart: onSessionStart,
            onStart: onStart,
            onMove: onMove,
            onSessionEnd: onSessionEnd,
            resumeAnimation: resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin: dragSnapToOrigin,
            distanceThreshold: distanceThreshold,
            contextWindow: (0, $4089e47ff1a2b128$export$d533d84f9871c879)(this.visualElement),
            element: this.visualElement.current
        });
    }
    /**
     * @internal
     */ stop(event, panInfo) {
        const finalEvent = event || this.latestPointerEvent;
        const finalPanInfo = panInfo || this.latestPanInfo;
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging || !finalPanInfo || !finalEvent) return;
        const { velocity: velocity } = finalPanInfo;
        this.startAnimation(velocity);
        const { onDragEnd: onDragEnd } = this.getProps();
        if (onDragEnd) (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>onDragEnd(finalEvent, finalPanInfo));
    }
    /**
     * @internal
     */ cancel() {
        this.isDragging = false;
        const { projection: projection, animationState: animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.endPanSession();
        const { dragPropagation: dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    /**
     * Clean up the pan session without modifying other drag state.
     * This is used during unmount to ensure event listeners are removed
     * without affecting projection animations or drag locks.
     * @internal
     */ endPanSession() {
        this.panSession && this.panSession.end();
        this.panSession = undefined;
    }
    updateAxis(axis, _point, offset) {
        const { drag: drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !$a35deb4b2fbeb723$var$shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, $1e37744b98f775f4$export$b3c764d3fca3ffe3)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        var _this_visualElement_projection;
        const { dragConstraints: dragConstraints, dragElastic: dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : (_this_visualElement_projection = this.visualElement.projection) === null || _this_visualElement_projection === void 0 ? void 0 : _this_visualElement_projection.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, $1e37744b98f775f4$export$4e9195bf7793bc78)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, $1e37744b98f775f4$export$7c5eaef8f4723d22)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative. This only applies to relative (non-ref)
         * constraints, as ref-based constraints from calcViewportConstraints are already in the
         * correct coordinate space for the motion value transform offset.
         */ if (prevConstraints !== this.constraints && !(0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints) && layout && this.constraints && !this.hasMutatedConstraints) (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, $1e37744b98f775f4$export$e9672cc4c36a8b87)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints: onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, $881a839ff5ec248c$export$dedd81df7bc1307)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, $19758d730238f0ed$export$f5708dca728d7177)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
        const { projection: projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        /**
         * Refresh the root scroll offset so the constraint's viewport box
         * translates to correct page coordinates. The scroll captured at
         * drag mount can be stale if the document was scrolled afterwards —
         * e.g. via the browser restoring scroll on refresh, or an ancestor
         * layout effect running after this element's mount (#2829).
         *
         * Clear the cached scroll first so `updateScroll` bypasses its
         * per-animationId cache and re-reads the live value.
         */ if (projection.root) {
            projection.root.scroll = undefined;
            projection.root.updateScroll();
        }
        const constraintsBox = (0, $b3c78c86be367659$export$6a597be7a7940a96)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, $1e37744b98f775f4$export$4228500f19d4cdf7)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, $fd94cc0f2e3ce586$export$b6b9cd4198191a47)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, $fd94cc0f2e3ce586$export$d3955c6a8f65a36b)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag: drag, dragMomentum: dragMomentum, dragElastic: dragElastic, dragTransition: dragTransition, dragSnapToOrigin: dragSnapToOrigin, onDragTransitionEnd: onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            if (!$a35deb4b2fbeb723$var$shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin === true || dragSnapToOrigin === axis) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness: bounceStiffness,
                bounceDamping: bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10
            }, dragTransition, transition);
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, $5d399ca24ed34089$export$3ac5aed310be0bee)(this.visualElement, axis);
        return axisValue.start((0, $17ccdc0a04fec700$export$90b3dfc33ff3548)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        var _this_visualElement_latestValues_axis;
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (_this_visualElement_latestValues_axis = this.visualElement.latestValues[axis]) !== null && _this_visualElement_latestValues_axis !== void 0 ? _this_visualElement_latestValues_axis : 0);
    }
    snapToCursor(point) {
        (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            const { drag: drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!$a35deb4b2fbeb723$var$shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection: projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min: min, max: max } = projection.layout.layoutBox[axis];
                /**
                 * The layout measurement includes the current transform value,
                 * so we need to add it back to get the correct snap position.
                 * This fixes an issue where elements with initial coordinates
                 * would snap to the wrong position on the first drag.
                 */ const current = axisValue.get() || 0;
                axisValue.set(point[axis] - (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(min, max, 0.5) + current);
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag: drag, dragConstraints: dragConstraints } = this.getProps();
        const { projection: projection } = this.visualElement;
        if (!(0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, $1e37744b98f775f4$export$13abbfca044ca46d)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate: transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        /**
         * Reset constraints so resolveConstraints() will recalculate them
         * with the freshly measured layout rather than returning the cached value.
         */ this.constraints = false;
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            if (!$a35deb4b2fbeb723$var$shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min: min, max: max } = this.constraints[axis];
            axisValue.set((0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(min, max, boxProgress[axis]));
        });
        /**
         * Flush the updated transform to the DOM synchronously to prevent
         * a visual flash at the element's CSS layout position (0,0) when
         * the transform was stripped for measurement.
         */ this.visualElement.render();
    }
    addListeners() {
        if (!this.visualElement.current) return;
        $a35deb4b2fbeb723$export$f0a15892c27dc07c.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(element, "pointerdown", (event)=>{
            const { drag: drag, dragListener: dragListener = true } = this.getProps();
            const target = event.target;
            /**
             * Only block drag if clicking on a text input child element
             * (input, textarea, select, contenteditable) where users might
             * want to select text or interact with the control.
             *
             * Buttons and links don't block drag since they don't have
             * click-and-move actions of their own.
             */ const isClickingTextInputChild = target !== element && (0, $86168a8dbbef73c2$export$41e5a41992b76128)(target);
            if (drag && dragListener && !isClickingTextInputChild) this.start(event);
        });
        /**
         * If using ref-based constraints, observe both the draggable element
         * and the constraint container for size changes via ResizeObserver.
         * Setup is deferred because dragConstraints.current is null when
         * addListeners first runs (React hasn't committed the ref yet).
         */ let stopResizeObservers;
        const measureDragConstraints = ()=>{
            const { dragConstraints: dragConstraints } = this.getProps();
            if ((0, $881a839ff5ec248c$export$dedd81df7bc1307)(dragConstraints) && dragConstraints.current) {
                this.constraints = this.resolveRefConstraints();
                if (!stopResizeObservers) stopResizeObservers = $a35deb4b2fbeb723$var$startResizeObservers(element, dragConstraints.current, ()=>this.scalePositionWithinConstraints());
            }
        };
        const { projection: projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, $44c600a9437aff7c$export$2cef06c20297c17d).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, $4da397d0e67b1b1d$export$b1d829ddf82884aa)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
            stopResizeObservers && stopResizeObservers();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag: drag = false, dragDirectionLock: dragDirectionLock = false, dragPropagation: dragPropagation = false, dragConstraints: dragConstraints = false, dragElastic: dragElastic = (0, $1e37744b98f775f4$export$a3366d3bac43a742), dragMomentum: dragMomentum = true } = props;
        return (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
            drag: drag,
            dragDirectionLock: dragDirectionLock,
            dragPropagation: dragPropagation,
            dragConstraints: dragConstraints,
            dragElastic: dragElastic,
            dragMomentum: dragMomentum
        });
    }
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
}
function $a35deb4b2fbeb723$var$skipFirstCall(callback) {
    let isFirst = true;
    return ()=>{
        if (isFirst) {
            isFirst = false;
            return;
        }
        callback();
    };
}
function $a35deb4b2fbeb723$var$startResizeObservers(element, constraintsElement, onResize) {
    const stopElement = (0, $e568be821d367350$export$4380c87abf28fdf)(element, $a35deb4b2fbeb723$var$skipFirstCall(onResize));
    const stopContainer = (0, $e568be821d367350$export$4380c87abf28fdf)(constraintsElement, $a35deb4b2fbeb723$var$skipFirstCall(onResize));
    return ()=>{
        stopElement();
        stopContainer();
    };
}
function $a35deb4b2fbeb723$var$shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function $a35deb4b2fbeb723$var$getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}


class $4c6ddc74cf07a272$export$5d97dc2872682820 extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls: dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, $69d49105ec21595d$export$8793edee2d425525);
    }
    update() {
        const { dragControls: dragControls } = this.node.getProps();
        const { dragControls: prevDragControls } = this.node.prevProps || {};
        if (dragControls !== prevDragControls) {
            this.removeGroupControls();
            if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        }
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
        /**
         * In React 19, during list reorder reconciliation, components may
         * briefly unmount and remount while the drag is still active. If we're
         * actively dragging, we should NOT end the pan session - it will
         * continue tracking pointer events via its window-level listeners.
         *
         * The pan session will be properly cleaned up when:
         * 1. The drag ends naturally (pointerup/pointercancel)
         * 2. The component is truly removed from the DOM
         */ if (!this.controls.isDragging) this.controls.endPanSession();
    }
    constructor(node){
        super(node);
        this.removeGroupControls = (0, $69d49105ec21595d$export$8793edee2d425525);
        this.removeListeners = (0, $69d49105ec21595d$export$8793edee2d425525);
        this.controls = new (0, $a35deb4b2fbeb723$export$86bff71f18910307)(node);
    }
}







const $11e1e830cf2014df$var$asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>handler(event, info), false, true);
    };
class $11e1e830cf2014df$export$b4f8f1ee75ce5859 extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    onPointerDown(pointerDownEvent) {
        this.session = new (0, $caca2cdd35c93217$export$d9c66232c9c4689c)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, $4089e47ff1a2b128$export$d533d84f9871c879)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart: onPanSessionStart, onPanStart: onPanStart, onPan: onPan, onPanEnd: onPanEnd } = this.node.getProps();
        return {
            onSessionStart: $11e1e830cf2014df$var$asyncHandler(onPanSessionStart),
            onStart: $11e1e830cf2014df$var$asyncHandler(onPanStart),
            onMove: $11e1e830cf2014df$var$asyncHandler(onPan),
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, $1f42ffe5b9091d52$export$fcff2e64e6676b81)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, $69d49105ec21595d$export$8793edee2d425525);
    }
}





/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ const $694c3c23f78cdf80$export$97db156a3ed1593b = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};



var $7fPBF = parcelRequire("7fPBF");

var $7fPBF = parcelRequire("7fPBF");

"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed from the tree,
 * but `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function $0b8f44c4758488da$export$2a8c16d82a0a0e26(subscribe = true) {
    const context = (0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent: isPresent, onExitComplete: onExitComplete, register: register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, $7fPBF.useId)();
    (0, $7fPBF.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, $7fPBF.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function $0b8f44c4758488da$export$8249053f690ea39a() {
    return $0b8f44c4758488da$export$ee27c052bca048fb((0, $7fPBF.useContext)((0, $13549fe6f5cbc799$export$f224e4635b6f8ce2)));
}
function $0b8f44c4758488da$export$ee27c052bca048fb(context) {
    return context === null ? true : context.isPresent;
}




"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ let $fb4bab01f29b923f$var$hasTakenAnySnapshot = false;
class $fb4bab01f29b923f$var$MeasureLayoutWithContext extends (0, $7fPBF.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: switchLayoutGroup, layoutId: layoutId } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            if ($fb4bab01f29b923f$var$hasTakenAnySnapshot) projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, projection.options), {
                layoutDependency: this.props.layoutDependency,
                onExitComplete: ()=>this.safeToRemove()
            }));
        }
        (0, $694c3c23f78cdf80$export$97db156a3ed1593b).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency: layoutDependency, visualElement: visualElement, drag: drag, isPresent: isPresent } = this.props;
        const { projection: projection } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (prevProps.layoutDependency !== layoutDependency) projection.setOptions((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, projection.options), {
            layoutDependency: layoutDependency
        }));
        $fb4bab01f29b923f$var$hasTakenAnySnapshot = true;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { visualElement: visualElement, layoutAnchor: layoutAnchor } = this.props;
        const { projection: projection } = visualElement;
        if (projection) {
            projection.options.layoutAnchor = layoutAnchor;
            projection.root.didUpdate();
            (0, $4cb138f42ee448c1$export$bb76eed83315504c).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement: visualElement, layoutGroup: layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection: projection } = visualElement;
        $fb4bab01f29b923f$var$hasTakenAnySnapshot = true;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove: safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function $fb4bab01f29b923f$export$779f5fb01ad751cd(props) {
    const [isPresent, safeToRemove] = (0, $0b8f44c4758488da$export$2a8c16d82a0a0e26)();
    const layoutGroup = (0, $7fPBF.useContext)((0, $e8832bf2a75e672d$export$a3579ca508007a95));
    return (0, $824c049f32d4395d$exports.jsx)($fb4bab01f29b923f$var$MeasureLayoutWithContext, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, props), {
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, $7fPBF.useContext)((0, $813b6750233d847f$export$da5f7b802957459a)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    }));
}








function $e55ee0bef2336500$export$335a17c977067b99(value, keyframes, options) {
    const motionValue$1 = (0, $61e12cc57eeb85ed$export$605d60a2578142d3)(value) ? value : (0, $eba58299b894994c$export$ce8bdc721e76545f)(value);
    motionValue$1.start((0, $17ccdc0a04fec700$export$90b3dfc33ff3548)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}












/**
 * Timeout defined in ms
 */ function $6e43bd716ab08f1a$export$1391212d75b2ee65(callback, timeout) {
    const start = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
    const checkElapsed = ({ timestamp: timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, $44c600a9437aff7c$export$2cef06c20297c17d).setup(checkElapsed, true);
    return ()=>(0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(checkElapsed);
}
function $6e43bd716ab08f1a$export$fcd451ca460f8a2a(callback, timeout) {
    return $6e43bd716ab08f1a$export$1391212d75b2ee65(callback, (0, $d17a7d2c2068c118$export$fc3e7e8557f8c8c7)(timeout));
}




/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function $ee6f5690d36d6bc6$export$66957ea77182581d(element) {
    return (0, $d21d6497287d50b6$export$17eda790a720ec57)(element) && element.tagName === "svg";
}








const $ff0afc6dee0cd7ca$var$borderLabels = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
];
const $ff0afc6dee0cd7ca$var$numBorders = $ff0afc6dee0cd7ca$var$borderLabels.length;
const $ff0afc6dee0cd7ca$var$asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const $ff0afc6dee0cd7ca$var$isPx = (value)=>typeof value === "number" || (0, $f1a72de1b348da89$export$91c0eda1d06bf008).test(value);
function $ff0afc6dee0cd7ca$export$739e279c17d51c3d(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    var _follow_opacity, _lead_opacity;
    if (shouldCrossfadeOpacity) {
        var _lead_opacity1;
        target.opacity = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(0, (_lead_opacity1 = lead.opacity) !== null && _lead_opacity1 !== void 0 ? _lead_opacity1 : 1, $ff0afc6dee0cd7ca$var$easeCrossfadeIn(progress));
        var _follow_opacity1;
        target.opacityExit = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)((_follow_opacity1 = follow.opacity) !== null && _follow_opacity1 !== void 0 ? _follow_opacity1 : 1, 0, $ff0afc6dee0cd7ca$var$easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)((_follow_opacity = follow.opacity) !== null && _follow_opacity !== void 0 ? _follow_opacity : 1, (_lead_opacity = lead.opacity) !== null && _lead_opacity !== void 0 ? _lead_opacity : 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < $ff0afc6dee0cd7ca$var$numBorders; i++){
        const borderLabel = $ff0afc6dee0cd7ca$var$borderLabels[i];
        let followRadius = $ff0afc6dee0cd7ca$var$getRadius(follow, borderLabel);
        let leadRadius = $ff0afc6dee0cd7ca$var$getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || $ff0afc6dee0cd7ca$var$isPx(followRadius) === $ff0afc6dee0cd7ca$var$isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)($ff0afc6dee0cd7ca$var$asNumber(followRadius), $ff0afc6dee0cd7ca$var$asNumber(leadRadius), progress), 0);
            if ((0, $f1a72de1b348da89$export$626336c2cd4b14de).test(leadRadius) || (0, $f1a72de1b348da89$export$626336c2cd4b14de).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(follow.rotate || 0, lead.rotate || 0, progress);
}
function $ff0afc6dee0cd7ca$var$getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
const $ff0afc6dee0cd7ca$var$easeCrossfadeIn = /*@__PURE__*/ $ff0afc6dee0cd7ca$var$compress(0, 0.5, (0, $e4064fe071cf16bf$export$c8d67a19199d1a50));
const $ff0afc6dee0cd7ca$var$easeCrossfadeOut = /*@__PURE__*/ $ff0afc6dee0cd7ca$var$compress(0.5, 0.95, (0, $69d49105ec21595d$export$8793edee2d425525));
function $ff0afc6dee0cd7ca$var$compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, $5a7354d1e57d5b3d$export$504d7abb21fa8c9)(min, max, p));
    };
}


/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ function $e6c55823fed0ff43$export$a0230ae482601ae8(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function $e6c55823fed0ff43$export$c53fd88f45d77e4b(box, originBox) {
    $e6c55823fed0ff43$export$a0230ae482601ae8(box.x, originBox.x);
    $e6c55823fed0ff43$export$a0230ae482601ae8(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function $e6c55823fed0ff43$export$8ead6a7d6b225ef(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}







/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function $a22a0dc53072c11b$export$691f07066b3be7c5(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, $0043a8a3eeedd876$export$2290ec7febe36dd6)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, $0043a8a3eeedd876$export$2290ec7febe36dd6)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function $a22a0dc53072c11b$export$cc12a0672fae5b4a(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, $f1a72de1b348da89$export$626336c2cd4b14de).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = $a22a0dc53072c11b$export$691f07066b3be7c5(axis.min, translate, scale, originPoint, boxScale);
    axis.max = $a22a0dc53072c11b$export$691f07066b3be7c5(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $a22a0dc53072c11b$export$42b76f1d0d16d5b(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    $a22a0dc53072c11b$export$cc12a0672fae5b4a(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const $a22a0dc53072c11b$var$xKeys = [
    "x",
    "scaleX",
    "originX"
];
const $a22a0dc53072c11b$var$yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function $a22a0dc53072c11b$export$73e1ad0a9694e25c(box, transforms, originBox, sourceBox) {
    $a22a0dc53072c11b$export$42b76f1d0d16d5b(box.x, transforms, $a22a0dc53072c11b$var$xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    $a22a0dc53072c11b$export$42b76f1d0d16d5b(box.y, transforms, $a22a0dc53072c11b$var$yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}




function $f090a83eda83ce9a$var$isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function $f090a83eda83ce9a$export$a7ec7642fe550fb6(delta) {
    return $f090a83eda83ce9a$var$isAxisDeltaZero(delta.x) && $f090a83eda83ce9a$var$isAxisDeltaZero(delta.y);
}
function $f090a83eda83ce9a$export$7a9a6f114ddd0fdb(a, b) {
    return a.min === b.min && a.max === b.max;
}
function $f090a83eda83ce9a$export$8d5cf76bb7daff09(a, b) {
    return $f090a83eda83ce9a$export$7a9a6f114ddd0fdb(a.x, b.x) && $f090a83eda83ce9a$export$7a9a6f114ddd0fdb(a.y, b.y);
}
function $f090a83eda83ce9a$export$22adf28bfca1c186(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function $f090a83eda83ce9a$export$ef641b782d85522(a, b) {
    return $f090a83eda83ce9a$export$22adf28bfca1c186(a.x, b.x) && $f090a83eda83ce9a$export$22adf28bfca1c186(a.y, b.y);
}
function $f090a83eda83ce9a$export$c5706146bc63213(box) {
    return (0, $69391feb435da50e$export$c1c127004b72a37)(box.x) / (0, $69391feb435da50e$export$c1c127004b72a37)(box.y);
}
function $f090a83eda83ce9a$export$444620505e28fe92(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}



class $9df5309f0cf07ef5$export$39be5b2d82fc9dc7 {
    add(node) {
        (0, $3fbb49f840f4b07a$export$20e507e47fae79fd)(this.members, node);
        for(let i = this.members.length - 1; i >= 0; i--){
            const member = this.members[i];
            if (member === node || member === this.lead || member === this.prevLead) continue;
            const inst = member.instance;
            if ((!inst || inst.isConnected === false) && !member.snapshot) {
                (0, $3fbb49f840f4b07a$export$fe2d9b4e03920b4c)(this.members, member);
                member.unmount();
            }
        }
        node.scheduleRender();
    }
    remove(node) {
        (0, $3fbb49f840f4b07a$export$fe2d9b4e03920b4c)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        for(let i = this.members.indexOf(node) - 1; i >= 0; i--){
            var _member_instance;
            const member = this.members[i];
            if (member.isPresent !== false && ((_member_instance = member.instance) === null || _member_instance === void 0 ? void 0 : _member_instance.isConnected) !== false) {
                this.promote(member);
                return true;
            }
        }
        return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.updateSnapshot();
            node.scheduleRender();
            const { layoutDependency: prevDep } = prevLead.options;
            const { layoutDependency: nextDep } = node.options;
            if (prevDep === undefined || prevDep !== nextDep) {
                var _node_root;
                node.resumeFrom = prevLead;
                if (preserveFollowOpacity) prevLead.preserveOpacity = true;
                if (prevLead.snapshot) {
                    node.snapshot = prevLead.snapshot;
                    node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                }
                if ((_node_root = node.root) === null || _node_root === void 0 ? void 0 : _node_root.isUpdating) node.isLayoutDirty = true;
            }
            if (node.options.crossfade === false) prevLead.hide();
        }
    }
    exitAnimationComplete() {
        this.members.forEach((member)=>{
            var _member_options_onExitComplete, _member_options, _member_resumingFrom_options_onExitComplete, _member_resumingFrom, _member_resumingFrom_options;
            (_member_options_onExitComplete = (_member_options = member.options).onExitComplete) === null || _member_options_onExitComplete === void 0 ? void 0 : _member_options_onExitComplete.call(_member_options);
            (_member_resumingFrom = member.resumingFrom) === null || _member_resumingFrom === void 0 ? void 0 : (_member_resumingFrom_options_onExitComplete = (_member_resumingFrom_options = _member_resumingFrom.options).onExitComplete) === null || _member_resumingFrom_options_onExitComplete === void 0 ? void 0 : _member_resumingFrom_options_onExitComplete.call(_member_resumingFrom_options);
        });
    }
    scheduleRender() {
        this.members.forEach((member)=>member.instance && member.scheduleRender(false));
    }
    removeLeadSnapshot() {
        var _this_lead;
        if ((_this_lead = this.lead) === null || _this_lead === void 0 ? void 0 : _this_lead.snapshot) this.lead.snapshot = undefined;
    }
    constructor(){
        this.members = [];
    }
}


function $9a7afe62da049e74$export$d33653b270fe725c(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = (latestTransform === null || latestTransform === void 0 ? void 0 : latestTransform.z) || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective: transformPerspective, rotate: rotate, pathRotation: pathRotation, rotateX: rotateX, rotateY: rotateY, skewX: skewX, skewY: skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        // Additive `rotate()` so user `rotate` isn't clobbered.
        if (pathRotation) transform += `rotate(${pathRotation}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}




const $a535f9dde2d7ff9c$export$d689d9dec5ad338 = (a, b)=>a.depth - b.depth;


class $e519d4bf7457ef44$export$1465d17e3de78a96 {
    add(child) {
        (0, $3fbb49f840f4b07a$export$20e507e47fae79fd)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, $3fbb49f840f4b07a$export$fe2d9b4e03920b4c)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, $a535f9dde2d7ff9c$export$d689d9dec5ad338));
        this.isDirty = false;
        this.children.forEach(callback);
    }
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
}





const $a7634071eff95f0f$var$metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const $a7634071eff95f0f$var$transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const $a7634071eff95f0f$var$animationTarget = 1000;
let $a7634071eff95f0f$var$id = 0;
function $a7634071eff95f0f$var$resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues: latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function $a7634071eff95f0f$var$cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement: visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, $dedda87bce0b0fc0$export$5f8d21e84d1d84fc)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout: layout, layoutId: layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, $44c600a9437aff7c$export$2cef06c20297c17d), !(layout || layoutId));
    }
    const { parent: parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) $a7634071eff95f0f$var$cancelTreeOptimisedTransformAnimations(parent);
}
function $a7634071eff95f0f$export$a84b61f69daa9da0({ attachResizeListener: attachResizeListener, defaultParent: defaultParent, measureScroll: measureScroll, checkIsScrollRoot: checkIsScrollRoot, resetTransform: resetTransform }) {
    return class ProjectionNode {
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, $530b27a3f7a9b181$export$e7dff9482a5fd23c)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, $d21d6497287d50b6$export$17eda790a720ec57)(instance) && !(0, $ee6f5690d36d6bc6$export$66957ea77182581d)(instance);
            this.instance = instance;
            const { layoutId: layoutId, layout: layout, visualElement: visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                let innerWidth = 0;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                // Set initial innerWidth in a frame.read callback to batch the read
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).read(()=>{
                    innerWidth = window.innerWidth;
                });
                attachResizeListener(instance, ()=>{
                    const newInnerWidth = window.innerWidth;
                    if (newInnerWidth === innerWidth) return;
                    innerWidth = newInnerWidth;
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, $6e43bd716ab08f1a$export$1391212d75b2ee65)(resizeUnblockUpdate, 250);
                    if ((0, $694c3c23f78cdf80$export$97db156a3ed1593b).hasAnimatedSinceResize) {
                        (0, $694c3c23f78cdf80$export$97db156a3ed1593b).hasAnimatedSinceResize = false;
                        this.nodes.forEach($a7634071eff95f0f$var$finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta: delta, hasLayoutChanged: hasLayoutChanged, hasRelativeLayoutChanged: hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || $a7634071eff95f0f$var$defaultLayoutTransition;
                const { onLayoutAnimationStart: onLayoutAnimationStart, onLayoutAnimationComplete: onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, $f090a83eda83ce9a$export$ef641b782d85522)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $445378a930c6db37$export$7c1391340308742e)(layoutTransition, "layout")), {
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    });
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged, animationOptions.path);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never committed to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) $a7634071eff95f0f$var$finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach($a7634071eff95f0f$var$resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement: visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) $a7634071eff95f0f$var$cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * Percentage translates resolve against layoutBox dimensions,
                 * so ancestors with them must be re-measured after transform reset.
                 */ if (typeof node.latestValues.x === "string" || typeof node.latestValues.y === "string") node.isLayoutDirty = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId: layoutId, layout: layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                const wasBlockedByResize = this.updateBlockedByResize;
                this.unblockUpdate();
                this.updateBlockedByResize = false;
                this.clearAllSnapshots();
                /**
                 * When blocked by resize, still measure layouts so
                 * callbacks like onLayoutMeasure fire (e.g. Reorder).
                 * Skip notifyLayoutUpdate to prevent animations.
                 */ if (wasBlockedByResize) this.nodes.forEach($a7634071eff95f0f$var$forceLayoutMeasure);
                this.nodes.forEach($a7634071eff95f0f$var$clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach($a7634071eff95f0f$var$clearIsLayoutDirty);
                return;
            }
            this.animationCommitId = this.animationId;
            if (!this.isUpdating) this.nodes.forEach($a7634071eff95f0f$var$clearIsLayoutDirty);
            else {
                this.isUpdating = false;
                /**
                 * Ensure animation-blocked nodes (e.g. during drag)
                 * get measured even when memoized (willUpdate skipped).
                 */ this.nodes.forEach($a7634071eff95f0f$var$ensureDraggedNodesSnapshotted);
                /**
                 * Write
                 */ this.nodes.forEach($a7634071eff95f0f$var$resetTransformStyle);
                /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                this.nodes.forEach($a7634071eff95f0f$var$updateLayout);
                /**
                 * Write
                 */ // Notify listeners that the layout is updated
                this.nodes.forEach($a7634071eff95f0f$var$notifyLayoutUpdate);
            }
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, $2a28679c5e08a25b$export$2da9be4cfdb689b1).now();
            (0, $44c600a9437aff7c$export$fff89137e9e818ce).delta = (0, $d412cf5d698f4b1e$export$7d15b64cf5a3a4c4)(0, 1000 / 60, now - (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp);
            (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp = now;
            (0, $44c600a9437aff7c$export$fff89137e9e818ce).isProcessing = true;
            (0, $44c600a9437aff7c$export$1811c3a7e3af92f0).update.process((0, $44c600a9437aff7c$export$fff89137e9e818ce));
            (0, $44c600a9437aff7c$export$1811c3a7e3af92f0).preRender.process((0, $44c600a9437aff7c$export$fff89137e9e818ce));
            (0, $44c600a9437aff7c$export$1811c3a7e3af92f0).render.process((0, $44c600a9437aff7c$export$fff89137e9e818ce));
            (0, $44c600a9437aff7c$export$fff89137e9e818ce).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, $4cb138f42ee448c1$export$bb76eed83315504c).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach($a7634071eff95f0f$var$clearSnapshot);
            this.sharedNodes.forEach($a7634071eff95f0f$var$removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, $44c600a9437aff7c$export$2cef06c20297c17d).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, $69391feb435da50e$export$c1c127004b72a37)(this.snapshot.measuredBox.x) && !(0, $69391feb435da50e$export$c1c127004b72a37)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutVersion++;
            if (!this.layoutCorrected) this.layoutCorrected = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement: visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase: phase,
                    isRoot: isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, $f090a83eda83ce9a$export$a7ec7642fe550fb6)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, $8f62b661d366a749$export$a545127cf1fbb600)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            $a7634071eff95f0f$var$roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox: layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            var _this_scroll;
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = ((_this_scroll = this.scroll) === null || _this_scroll === void 0 ? void 0 : _this_scroll.wasRoot) || this.path.some($a7634071eff95f0f$var$checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll: scroll } = this.root;
                if (scroll) {
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(box.x, scroll.offset.x);
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            var _this_scroll;
            const boxWithoutScroll = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
            if ((_this_scroll = this.scroll) === null || _this_scroll === void 0 ? void 0 : _this_scroll.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll: scroll, options: options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(boxWithoutScroll, box);
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(boxWithoutScroll.x, scroll.offset.x);
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false, output) {
            var _this_layout;
            const withTransforms = output || (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                var _node_layout;
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(withTransforms.x, -node.scroll.offset.x);
                    (0, $0043a8a3eeedd876$export$a807a5ce5ebb3895)(withTransforms.y, -node.scroll.offset.y);
                }
                if (!(0, $8f62b661d366a749$export$a545127cf1fbb600)(node.latestValues)) continue;
                (0, $0043a8a3eeedd876$export$58b16271041fbfb)(withTransforms, node.latestValues, (_node_layout = node.layout) === null || _node_layout === void 0 ? void 0 : _node_layout.layoutBox);
            }
            if ((0, $8f62b661d366a749$export$a545127cf1fbb600)(this.latestValues)) (0, $0043a8a3eeedd876$export$58b16271041fbfb)(withTransforms, this.latestValues, (_this_layout = this.layout) === null || _this_layout === void 0 ? void 0 : _this_layout.layoutBox);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                var _node_snapshot;
                const node = this.path[i];
                if (!(0, $8f62b661d366a749$export$a545127cf1fbb600)(node.latestValues)) continue;
                let sourceBox;
                if (node.instance) {
                    (0, $8f62b661d366a749$export$bdf30dca883ea463)(node.latestValues) && node.updateSnapshot();
                    sourceBox = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                    (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(sourceBox, node.measurePageBox());
                }
                (0, $a22a0dc53072c11b$export$73e1ad0a9694e25c)(boxWithoutTransform, node.latestValues, (_node_snapshot = node.snapshot) === null || _node_snapshot === void 0 ? void 0 : _node_snapshot.layoutBox, sourceBox);
            }
            if ((0, $8f62b661d366a749$export$a545127cf1fbb600)(this.latestValues)) (0, $a22a0dc53072c11b$export$73e1ad0a9694e25c)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.options, options), {
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            });
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            var _this_parent;
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isProjectionDirty) || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp;
            const relativeParent = this.getClosestProjectingParent();
            if (relativeParent && this.linkedParentVersion !== relativeParent.layoutVersion && !relativeParent.options.layoutRoot) this.removeRelativeTarget();
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                if (this.options.layoutAnchor !== false && relativeParent && relativeParent.layout) this.createRelativeTarget(relativeParent, this.layout.layoutBox, relativeParent.layout.layoutBox);
                else this.removeRelativeTarget();
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                this.targetWithTransforms = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, $69391feb435da50e$export$426154f9d100f99)(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || undefined);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) this.applyTransform(this.layout.layoutBox, false, this.target);
                else (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
                (0, $0043a8a3eeedd876$export$d80074982803af5c)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                if (this.options.layoutAnchor !== false && relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) this.createRelativeTarget(relativeParent, this.target, relativeParent.target);
                else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) $a7634071eff95f0f$var$metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, $8f62b661d366a749$export$bdf30dca883ea463)(this.parent.latestValues) || (0, $8f62b661d366a749$export$bf80f5f8f4dc327f)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        createRelativeTarget(relativeParent, layout, parentLayout) {
            this.relativeParent = relativeParent;
            this.linkedParentVersion = relativeParent.layoutVersion;
            this.forceRelativeParentToResolveTarget();
            this.relativeTarget = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            this.relativeTargetOrigin = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            (0, $69391feb435da50e$export$2785bfcc929c5650)(this.relativeTargetOrigin, layout, parentLayout, this.options.layoutAnchor || undefined);
            (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(this.relativeTarget, this.relativeTargetOrigin);
        }
        removeRelativeTarget() {
            this.relativeParent = this.relativeTarget = undefined;
        }
        calcProjection() {
            var _this_parent;
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || ((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isProjectionDirty)) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, $44c600a9437aff7c$export$fff89137e9e818ce).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout: layout, layoutId: layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, $0043a8a3eeedd876$export$e2a980535c55eabb)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            }
            const { target: target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, $e6c55823fed0ff43$export$8ead6a7d6b225ef)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, $e6c55823fed0ff43$export$8ead6a7d6b225ef)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, $69391feb435da50e$export$c0d25e96fc67d310)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, $f090a83eda83ce9a$export$444620505e28fe92)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, $f090a83eda83ce9a$export$444620505e28fe92)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) $a7634071eff95f0f$var$metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            var _this_options_visualElement;
            (_this_options_visualElement = this.options.visualElement) === null || _this_options_visualElement === void 0 ? void 0 : _this_options_visualElement.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
            this.projectionDelta = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
            this.projectionDeltaWithTransform = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false, pathFn) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.latestValues);
            const targetDelta = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some($a7634071eff95f0f$var$hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            // The path decides whether the layout shift is worth curving
            // (distance floor) and resolves the interpolator from the delta.
            const interpolate = pathFn === null || pathFn === void 0 ? void 0 : pathFn.interpolateProjection(delta);
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                const point = interpolate === null || interpolate === void 0 ? void 0 : interpolate(progress);
                if (point) {
                    targetDelta.x.translate = point.x;
                    targetDelta.x.scale = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(delta.x.scale, 1, progress);
                    targetDelta.x.origin = delta.x.origin;
                    targetDelta.x.originPoint = delta.x.originPoint;
                    targetDelta.y.translate = point.y;
                    targetDelta.y.scale = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(delta.y.scale, 1, progress);
                    targetDelta.y.origin = delta.y.origin;
                    targetDelta.y.originPoint = delta.y.originPoint;
                } else {
                    $a7634071eff95f0f$var$mixAxisDeltaLinear(targetDelta.x, delta.x, progress);
                    $a7634071eff95f0f$var$mixAxisDeltaLinear(targetDelta.y, delta.y, progress);
                }
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, $69391feb435da50e$export$2785bfcc929c5650)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || undefined);
                    $a7634071eff95f0f$export$6ffd3e6ae339a132(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, $f090a83eda83ce9a$export$8d5cf76bb7daff09)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                    (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, $ff0afc6dee0cd7ca$export$739e279c17d51c3d)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                if (point && point.rotate !== undefined) {
                    // Dedicated `pathRotation` channel, not `rotate`, so an
                    // animating `rotate` is composed with, never clobbered.
                    if (!this.animationValues) this.animationValues = mixedValues;
                    this.animationValues.pathRotation = point.rotate;
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            var _this_currentAnimation, _this_resumingFrom_currentAnimation, _this_resumingFrom;
            this.notifyListeners("animationStart");
            (_this_currentAnimation = this.currentAnimation) === null || _this_currentAnimation === void 0 ? void 0 : _this_currentAnimation.stop();
            (_this_resumingFrom = this.resumingFrom) === null || _this_resumingFrom === void 0 ? void 0 : (_this_resumingFrom_currentAnimation = _this_resumingFrom.currentAnimation) === null || _this_resumingFrom_currentAnimation === void 0 ? void 0 : _this_resumingFrom_currentAnimation.stop();
            if (this.pendingAnimation) {
                (0, $44c600a9437aff7c$export$ec99c0ef4978dccb)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, $44c600a9437aff7c$export$2cef06c20297c17d).update(()=>{
                (0, $694c3c23f78cdf80$export$97db156a3ed1593b).hasAnimatedSinceResize = true;
                (0, $86c9ef19d62de386$export$d921fb2475e2900c).layout++;
                this.motionValue || (this.motionValue = (0, $eba58299b894994c$export$ce8bdc721e76545f)(0));
                this.motionValue.jump(0, false);
                this.currentAnimation = (0, $e55ee0bef2336500$export$335a17c977067b99)(this.motionValue, [
                    0,
                    1000
                ], (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, $86c9ef19d62de386$export$d921fb2475e2900c).layout--;
                    },
                    onComplete: ()=>{
                        (0, $86c9ef19d62de386$export$d921fb2475e2900c).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                }));
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta($a7634071eff95f0f$var$animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms: targetWithTransforms, target: target, layout: layout, latestValues: latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && $a7634071eff95f0f$var$shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                const xLength = (0, $69391feb435da50e$export$c1c127004b72a37)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, $69391feb435da50e$export$c1c127004b72a37)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, $e6c55823fed0ff43$export$c53fd88f45d77e4b)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, $0043a8a3eeedd876$export$58b16271041fbfb)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, $69391feb435da50e$export$c0d25e96fc67d310)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, $9df5309f0cf07ef5$export$39be5b2d82fc9dc7)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            var _this_getStack;
            const { layoutId: layoutId } = this.options;
            return layoutId ? ((_this_getStack = this.getStack()) === null || _this_getStack === void 0 ? void 0 : _this_getStack.lead) || this : this;
        }
        getPrevLead() {
            var _this_getStack;
            const { layoutId: layoutId } = this.options;
            return layoutId ? (_this_getStack = this.getStack()) === null || _this_getStack === void 0 ? void 0 : _this_getStack.prevLead : undefined;
        }
        getStack() {
            const { layoutId: layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset: needsReset, transition: transition, preserveFollowOpacity: preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition: transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement: visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues: latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) $a7634071eff95f0f$var$resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < $a7634071eff95f0f$var$transformAxes.length; i++){
                $a7634071eff95f0f$var$resetDistortingTransform(`rotate${$a7634071eff95f0f$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                $a7634071eff95f0f$var$resetDistortingTransform(`skew${$a7634071eff95f0f$var$transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        applyProjectionStyles(targetStyle, styleProp) {
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) {
                targetStyle.visibility = "hidden";
                return;
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                targetStyle.visibility = "";
                targetStyle.opacity = "";
                targetStyle.pointerEvents = (0, $f1898fdc70290c7d$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                if (this.options.layoutId) {
                    targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    targetStyle.pointerEvents = (0, $f1898fdc70290c7d$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, $8f62b661d366a749$export$a545127cf1fbb600)(this.latestValues)) {
                    targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return;
            }
            targetStyle.visibility = "";
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            let transform = (0, $9a7afe62da049e74$export$d33653b270fe725c)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
            targetStyle.transform = transform;
            const { x: x, y: y } = this.projectionDelta;
            targetStyle.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            var _valuesToRender_opacity, _ref;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? (_ref = (_valuesToRender_opacity = valuesToRender.opacity) !== null && _valuesToRender_opacity !== void 0 ? _valuesToRender_opacity : this.latestValues.opacity) !== null && _ref !== void 0 ? _ref : 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, $e69bce41e90c0a87$export$91ddd985b97788d1){
                if (valuesToRender[key] === undefined) continue;
                const { correct: correct, applyTo: applyTo, isCSSVariable: isCSSVariable } = (0, $e69bce41e90c0a87$export$91ddd985b97788d1)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else targetStyle[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, $f1898fdc70290c7d$export$fcc2206ecb6d74b)(styleProp === null || styleProp === void 0 ? void 0 : styleProp.pointerEvents) || "" : "none";
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>{
                var _node_currentAnimation;
                return (_node_currentAnimation = node.currentAnimation) === null || _node_currentAnimation === void 0 ? void 0 : _node_currentAnimation.stop();
            });
            this.root.nodes.forEach($a7634071eff95f0f$var$clearMeasurements);
            this.root.sharedNodes.clear();
        }
        constructor(latestValues = {}, parent = defaultParent === null || defaultParent === void 0 ? void 0 : defaultParent()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = $a7634071eff95f0f$var$id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            this.layoutVersion = 0;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) $a7634071eff95f0f$var$metrics.nodes = $a7634071eff95f0f$var$metrics.calculatedTargetDeltas = $a7634071eff95f0f$var$metrics.calculatedProjections = 0;
                this.nodes.forEach($a7634071eff95f0f$export$131f2f0cc5fe9609);
                this.nodes.forEach($a7634071eff95f0f$var$resolveTargetDelta);
                this.nodes.forEach($a7634071eff95f0f$var$calcProjection);
                this.nodes.forEach($a7634071eff95f0f$export$c2664f37bc951031);
                if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).addProjectionMetrics) (0, $7fcf3f225d921b82$export$84ce9a476f53d110).addProjectionMetrics($a7634071eff95f0f$var$metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.linkedParentVersion = 0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, $e519d4bf7457ef44$export$1465d17e3de78a96)();
        }
    };
}
function $a7634071eff95f0f$var$updateLayout(node) {
    node.updateLayout();
}
function $a7634071eff95f0f$var$notifyLayoutUpdate(node) {
    var _node_resumeFrom;
    const snapshot = ((_node_resumeFrom = node.resumeFrom) === null || _node_resumeFrom === void 0 ? void 0 : _node_resumeFrom.snapshot) || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType: animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $69391feb435da50e$export$c1c127004b72a37)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (animationType === "x" || animationType === "y") {
            const snapAxis = animationType === "x" ? "y" : "x";
            (0, $e6c55823fed0ff43$export$a0230ae482601ae8)(isShared ? snapshot.measuredBox[snapAxis] : snapshot.layoutBox[snapAxis], layout[snapAxis]);
        } else if ($a7634071eff95f0f$var$shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, $2ac6ee71286c3d0e$export$b789de563eb43b1)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, $69391feb435da50e$export$c1c127004b72a37)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
        (0, $69391feb435da50e$export$c0d25e96fc67d310)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, $a0d315cc230b7b79$export$3d227df54007d73a)();
        if (isShared) (0, $69391feb435da50e$export$c0d25e96fc67d310)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, $69391feb435da50e$export$c0d25e96fc67d310)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, $f090a83eda83ce9a$export$a7ec7642fe550fb6)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const anchor = node.options.layoutAnchor || undefined;
                    const relativeSnapshot = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                    (0, $69391feb435da50e$export$2785bfcc929c5650)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox, anchor);
                    const relativeLayout = (0, $a0d315cc230b7b79$export$6459fc9e86be362e)();
                    (0, $69391feb435da50e$export$2785bfcc929c5650)(relativeLayout, layout, parentLayout.layoutBox, anchor);
                    if (!(0, $f090a83eda83ce9a$export$ef641b782d85522)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout: layout,
            snapshot: snapshot,
            delta: visualDelta,
            layoutDelta: layoutDelta,
            hasLayoutChanged: hasLayoutChanged,
            hasRelativeLayoutChanged: hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete: onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function $a7634071eff95f0f$export$131f2f0cc5fe9609(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, $7fcf3f225d921b82$export$84ce9a476f53d110).value) $a7634071eff95f0f$var$metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function $a7634071eff95f0f$export$c2664f37bc951031(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function $a7634071eff95f0f$var$clearSnapshot(node) {
    node.clearSnapshot();
}
function $a7634071eff95f0f$var$clearMeasurements(node) {
    node.clearMeasurements();
}
function $a7634071eff95f0f$var$forceLayoutMeasure(node) {
    node.isLayoutDirty = true;
    node.updateLayout();
}
function $a7634071eff95f0f$var$clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
/**
 * When a node is animation-blocked (e.g. during drag) and its component
 * didn't re-render (memoized), willUpdate() is never called so there's
 * no snapshot. Use the previous layout as a snapshot and mark dirty so
 * resetTransform/updateLayout/notifyLayoutUpdate process it normally.
 */ function $a7634071eff95f0f$var$ensureDraggedNodesSnapshotted(node) {
    if (node.isAnimationBlocked && node.layout && !node.isLayoutDirty) {
        node.snapshot = node.layout;
        node.isLayoutDirty = true;
    }
}
function $a7634071eff95f0f$var$resetTransformStyle(node) {
    const { visualElement: visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function $a7634071eff95f0f$var$finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function $a7634071eff95f0f$var$resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function $a7634071eff95f0f$var$calcProjection(node) {
    node.calcProjection();
}
function $a7634071eff95f0f$var$resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function $a7634071eff95f0f$var$removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function $a7634071eff95f0f$var$mixAxisDeltaLinear(output, delta, p) {
    output.translate = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(delta.translate, 0, p);
    output.scale = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function $a7634071eff95f0f$export$8f9f6b0c76c773c7(output, from, to, p) {
    output.min = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(from.min, to.min, p);
    output.max = (0, $98312100572e3dbc$export$3bb0b4ff1037b8dd)(from.max, to.max, p);
}
function $a7634071eff95f0f$export$6ffd3e6ae339a132(output, from, to, p) {
    $a7634071eff95f0f$export$8f9f6b0c76c773c7(output.x, from.x, to.x, p);
    $a7634071eff95f0f$export$8f9f6b0c76c773c7(output.y, from.y, to.y, p);
}
function $a7634071eff95f0f$var$hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const $a7634071eff95f0f$var$defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const $a7634071eff95f0f$var$userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const $a7634071eff95f0f$var$roundPoint = $a7634071eff95f0f$var$userAgentContains("applewebkit/") && !$a7634071eff95f0f$var$userAgentContains("chrome/") ? Math.round : (0, $69d49105ec21595d$export$8793edee2d425525);
function $a7634071eff95f0f$var$roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = $a7634071eff95f0f$var$roundPoint(axis.min);
    axis.max = $a7634071eff95f0f$var$roundPoint(axis.max);
}
function $a7634071eff95f0f$var$roundBox(box) {
    $a7634071eff95f0f$var$roundAxis(box.x);
    $a7634071eff95f0f$var$roundAxis(box.y);
}
function $a7634071eff95f0f$var$shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, $69391feb435da50e$export$28d0384c4b79bde2)((0, $f090a83eda83ce9a$export$c5706146bc63213)(snapshot), (0, $f090a83eda83ce9a$export$c5706146bc63213)(layout), 0.2);
}
function $a7634071eff95f0f$var$checkNodeWasScrollRoot(node) {
    var _node_scroll;
    return node !== node.root && ((_node_scroll = node.scroll) === null || _node_scroll === void 0 ? void 0 : _node_scroll.wasRoot);
}




const $b00564a5cf5376d5$export$2d029a49a09b6177 = (0, $a7634071eff95f0f$export$a84b61f69daa9da0)({
    attachResizeListener: (ref, notify)=>(0, $4da397d0e67b1b1d$export$b1d829ddf82884aa)(ref, "resize", notify),
    measureScroll: ()=>{
        var _document_body, _document_body1;
        return {
            x: document.documentElement.scrollLeft || ((_document_body = document.body) === null || _document_body === void 0 ? void 0 : _document_body.scrollLeft) || 0,
            y: document.documentElement.scrollTop || ((_document_body1 = document.body) === null || _document_body1 === void 0 ? void 0 : _document_body1.scrollTop) || 0
        };
    },
    checkIsScrollRoot: ()=>true
});


const $df5100f59fd5f7c7$export$b91509fcf893b648 = {
    current: undefined
};
const $df5100f59fd5f7c7$export$b61a9eb3dbde8858 = (0, $a7634071eff95f0f$export$a84b61f69daa9da0)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!$df5100f59fd5f7c7$export$b91509fcf893b648.current) {
            const documentNode = new (0, $b00564a5cf5376d5$export$2d029a49a09b6177)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            $df5100f59fd5f7c7$export$b91509fcf893b648.current = documentNode;
        }
        return $df5100f59fd5f7c7$export$b91509fcf893b648.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});


const $58aa614d3a6a82b6$export$d7d5d435647ed5a0 = {
    pan: {
        Feature: (0, $11e1e830cf2014df$export$b4f8f1ee75ce5859)
    },
    drag: {
        Feature: (0, $4c6ddc74cf07a272$export$5d97dc2872682820),
        ProjectionNode: (0, $df5100f59fd5f7c7$export$b61a9eb3dbde8858),
        MeasureLayout: $fb4bab01f29b923f$export$779f5fb01ad751cd
    }
};






function $25bb4b427e2bca4e$export$edc0ace9d5e7e842(elementOrSelector, options) {
    const elements = (0, $6709e3be20d4c81f$export$90ceba2564a894f8)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        passive: true
    }, options), {
        signal: gestureAbortController.signal
    });
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}


function $1f2a858d47bdd163$var$isValidHover(event) {
    return !(event.pointerType === "touch" || (0, $712c7e4e4b7d1d34$export$1b3dd616664938e4)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function $1f2a858d47bdd163$export$3f60957f5dbf3876(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, $25bb4b427e2bca4e$export$edc0ace9d5e7e842)(elementOrSelector, options);
    elements.forEach((element)=>{
        let isPressed = false;
        let deferredHoverEnd = false;
        let hoverEndCallback;
        const removePointerLeave = ()=>{
            element.removeEventListener("pointerleave", onPointerLeave);
        };
        const endHover = (event)=>{
            if (hoverEndCallback) {
                hoverEndCallback(event);
                hoverEndCallback = undefined;
            }
            removePointerLeave();
        };
        const onPointerUp = (event)=>{
            isPressed = false;
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerUp);
            if (deferredHoverEnd) {
                deferredHoverEnd = false;
                endHover(event);
            }
        };
        const onPointerDown = ()=>{
            isPressed = true;
            window.addEventListener("pointerup", onPointerUp, eventOptions);
            window.addEventListener("pointercancel", onPointerUp, eventOptions);
        };
        const onPointerLeave = (leaveEvent)=>{
            if (leaveEvent.pointerType === "touch") return;
            if (isPressed) {
                deferredHoverEnd = true;
                return;
            }
            endHover(leaveEvent);
        };
        const onPointerEnter = (enterEvent)=>{
            if (!$1f2a858d47bdd163$var$isValidHover(enterEvent)) return;
            deferredHoverEnd = false;
            const onHoverEnd = onHoverStart(element, enterEvent);
            if (typeof onHoverEnd !== "function") return;
            hoverEndCallback = onHoverEnd;
            element.addEventListener("pointerleave", onPointerLeave, eventOptions);
        };
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
        element.addEventListener("pointerdown", onPointerDown, eventOptions);
    });
    return cancel;
}



function $cc9187ec974de0d4$var$handleHoverEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(event)));
}
class $cc9187ec974de0d4$export$93a81ea037eac456 extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        this.unmount = (0, $1f2a858d47bdd163$export$3f60957f5dbf3876)(current, (_element, startEvent)=>{
            $cc9187ec974de0d4$var$handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>$cc9187ec974de0d4$var$handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}




class $78cbf4a00036ebdd$export$d4826db40d47595b extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, $113d54600cb8d2d0$export$a4627e546088548d)((0, $4da397d0e67b1b1d$export$b1d829ddf82884aa)(this.node.current, "focus", ()=>this.onFocus()), (0, $4da397d0e67b1b1d$export$b1d829ddf82884aa)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
}



/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function $80af6ff61bd6e9d1$export$1b3bfaa9684536aa(element) {
    return (0, $d93f81859b2d5a5f$export$a6cdc56e425d0d0a)(element) && "offsetHeight" in element && !("ownerSVGElement" in element);
}



/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ const $14401caf9c9c2c14$export$e841ada32ff745b = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return $14401caf9c9c2c14$export$e841ada32ff745b(parent, child.parentElement);
};





const $45665e91e5eab086$export$7987404a4e35b84b = new WeakSet();


/**
 * Filter out events that are not "Enter" keys.
 */ function $383fd3a718194f0b$var$filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function $383fd3a718194f0b$var$firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const $383fd3a718194f0b$export$4b5790288fe12a79 = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = $383fd3a718194f0b$var$filterEvents(()=>{
        if ((0, $45665e91e5eab086$export$7987404a4e35b84b).has(element)) return;
        $383fd3a718194f0b$var$firePointerEvent(element, "down");
        const handleKeyup = $383fd3a718194f0b$var$filterEvents(()=>{
            $383fd3a718194f0b$var$firePointerEvent(element, "up");
        });
        const handleBlur = ()=>$383fd3a718194f0b$var$firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};



/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function $53da3250d6db73d2$var$isValidPressEvent(event) {
    return (0, $8260b027ce2c0643$export$a4cf9c8a4b063a6e)(event) && !(0, $712c7e4e4b7d1d34$export$1b3dd616664938e4)();
}
const $53da3250d6db73d2$var$claimedPointerDownEvents = new WeakSet();
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function $53da3250d6db73d2$export$dbe9198142dace0c(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, $25bb4b427e2bca4e$export$edc0ace9d5e7e842)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!$53da3250d6db73d2$var$isValidPressEvent(startEvent)) return;
        if ($53da3250d6db73d2$var$claimedPointerDownEvents.has(startEvent)) return;
        (0, $45665e91e5eab086$export$7987404a4e35b84b).add(target);
        if (options.stopPropagation) $53da3250d6db73d2$var$claimedPointerDownEvents.add(startEvent);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, $45665e91e5eab086$export$7987404a4e35b84b).has(target)) (0, $45665e91e5eab086$export$7987404a4e35b84b).delete(target);
            if (!$53da3250d6db73d2$var$isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success: success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, $14401caf9c9c2c14$export$e841ada32ff745b)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, $80af6ff61bd6e9d1$export$1b3bfaa9684536aa)(target)) {
            target.addEventListener("focus", (event)=>(0, $383fd3a718194f0b$export$4b5790288fe12a79)(event, eventOptions));
            if (!(0, $86168a8dbbef73c2$export$5f6976e2f961e8b7)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}



function $1ff4529f1b09a613$var$handlePressEvent(node, event, lifecycle) {
    const { props: props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, $44c600a9437aff7c$export$2cef06c20297c17d).postRender(()=>callback(event, (0, $fc126d8b66e58ebd$export$12f84bb882d06e1a)(event)));
}
class $1ff4529f1b09a613$export$f026abdbba7f0c9e extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    mount() {
        const { current: current } = this.node;
        if (!current) return;
        const { globalTapTarget: globalTapTarget, propagate: propagate } = this.node.props;
        this.unmount = (0, $53da3250d6db73d2$export$dbe9198142dace0c)(current, (_element, startEvent)=>{
            $1ff4529f1b09a613$var$handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success: success })=>$1ff4529f1b09a613$var$handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: globalTapTarget,
            stopPropagation: (propagate === null || propagate === void 0 ? void 0 : propagate.tap) === false
        });
    }
    unmount() {}
}



/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ 

const $d711141c523810a9$var$observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const $d711141c523810a9$var$observers = new WeakMap();
const $d711141c523810a9$var$fireObserverCallback = (entry)=>{
    const callback = $d711141c523810a9$var$observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const $d711141c523810a9$var$fireAllObserverCallbacks = (entries)=>{
    entries.forEach($d711141c523810a9$var$fireObserverCallback);
};
function $d711141c523810a9$var$initIntersectionObserver(_param) {
    var { root: root } = _param, options = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "root"
    ]);
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!$d711141c523810a9$var$observers.has(lookupRoot)) $d711141c523810a9$var$observers.set(lookupRoot, {});
    const rootObservers = $d711141c523810a9$var$observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver($d711141c523810a9$var$fireAllObserverCallbacks, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        root: root
    }, options));
    return rootObservers[key];
}
function $d711141c523810a9$export$b2bcd62fb7925aa5(element, options, callback) {
    const rootInteresectionObserver = $d711141c523810a9$var$initIntersectionObserver(options);
    $d711141c523810a9$var$observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        $d711141c523810a9$var$observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}


const $13f3207f49b45e2c$var$thresholdNames = {
    some: 0,
    all: 1
};
class $13f3207f49b45e2c$export$150851c8cc2f0c72 extends (0, $3bb21a5535a42c32$export$6e91cf7616333d5) {
    startObserver() {
        var _this_stopObserver, _this;
        (_this_stopObserver = (_this = this).stopObserver) === null || _this_stopObserver === void 0 ? void 0 : _this_stopObserver.call(_this);
        const { viewport: viewport = {} } = this.node.getProps();
        const { root: root, margin: rootMargin, amount: amount = "some", once: once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin: rootMargin,
            threshold: typeof amount === "number" ? amount : $13f3207f49b45e2c$var$thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting: isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter: onViewportEnter, onViewportLeave: onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        this.stopObserver = (0, $d711141c523810a9$export$b2bcd62fb7925aa5)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props: props, prevProps: prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some($13f3207f49b45e2c$var$hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {
        var _this_stopObserver, _this;
        (_this_stopObserver = (_this = this).stopObserver) === null || _this_stopObserver === void 0 ? void 0 : _this_stopObserver.call(_this);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
}
function $13f3207f49b45e2c$var$hasViewportOptionChanged({ viewport: viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}


const $55b9f4465d1c76fa$export$e5b72898e5a201f1 = {
    inView: {
        Feature: (0, $13f3207f49b45e2c$export$150851c8cc2f0c72)
    },
    tap: {
        Feature: (0, $1ff4529f1b09a613$export$f026abdbba7f0c9e)
    },
    focus: {
        Feature: (0, $78cbf4a00036ebdd$export$d4826db40d47595b)
    },
    hover: {
        Feature: (0, $cc9187ec974de0d4$export$93a81ea037eac456)
    }
};




const $55377c4d7156276f$export$b3219800bda33a1f = {
    layout: {
        ProjectionNode: (0, $df5100f59fd5f7c7$export$b61a9eb3dbde8858),
        MeasureLayout: $fb4bab01f29b923f$export$779f5fb01ad751cd
    }
};


const $937872241f1f7f1f$export$d596cd8841d25433 = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $9bb9392be544c52d$export$7f9953c70dacfd7f), (0, $55b9f4465d1c76fa$export$e5b72898e5a201f1), (0, $58aa614d3a6a82b6$export$d7d5d435647ed5a0), (0, $55377c4d7156276f$export$b3219800bda33a1f));


const $682ba43d460c7b6e$export$e25e478948902b8b = /*@__PURE__*/ (0, $832dbbf8caa22976$export$a28d6df673050e18)((0, $937872241f1f7f1f$export$d596cd8841d25433), (0, $782ff79d5f331768$export$56ba0183203348f5));


function $1931765328266215$export$2e2bcd8739ae039() {
    var _location_state;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const [searchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const isMountedRef = (0, $7fPBF.useRef)(true);
    // allow prefill from external import
    const externalPrefill = (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.externalEvent;
    // Get query params
    const queryTitle = searchParams.get('title');
    const queryDescription = searchParams.get('description');
    const queryRegistrationURL = searchParams.get('registrationURL');
    const queryThumbnailURL = searchParams.get('thumbnailURL');
    const queryExternalEventID = searchParams.get('externalEventID');
    const queryExternalProvider = searchParams.get('provider');
    const [title, setTitle] = (0, $7fPBF.useState)((externalPrefill === null || externalPrefill === void 0 ? void 0 : externalPrefill.name) || queryTitle || '');
    const [startsAt, setStartsAt] = (0, $7fPBF.useState)(new Date());
    const [endsAt, setEndsAt] = (0, $7fPBF.useState)(new Date());
    const [showTimes, setShowTimes] = (0, $7fPBF.useState)(true);
    const [description, setDescription] = (0, $7fPBF.useState)(queryDescription || '');
    const [locationText, setLocationText] = (0, $7fPBF.useState)('');
    const [registrationURL, setRegistrationURL] = (0, $7fPBF.useState)(queryRegistrationURL || '');
    const [thumbnailURL, setThumbnailURL] = (0, $7fPBF.useState)((externalPrefill === null || externalPrefill === void 0 ? void 0 : externalPrefill.thumbnailImageURL) || queryThumbnailURL || '');
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [externalEventDetails, setExternalEventDetails] = (0, $7fPBF.useState)(null);
    const [loadingExternalDetails, setLoadingExternalDetails] = (0, $7fPBF.useState)(false);
    const [roleMap, setRoleMap] = (0, $7fPBF.useState)({});
    // Fetch external event details if externalEventID and provider are present
    (0, $7fPBF.useEffect)(()=>{
        if (!queryExternalEventID || !queryExternalProvider || !auth.churchId) return;
        let isMounted = true;
        const fetchDetails = async ()=>{
            setLoadingExternalDetails(true);
            try {
                const resp = await (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchExternalEventDetails(auth.churchId || '', queryExternalProvider, queryExternalEventID, auth);
                if (isMounted) {
                    if (!resp.error && resp.body) setExternalEventDetails(resp.body);
                }
            } catch (err) {
                if (isMounted) console.error('Failed to fetch external event details:', err);
            } finally{
                if (isMounted) setLoadingExternalDetails(false);
            }
        };
        fetchDetails();
        return ()=>{
            isMounted = false;
        };
    }, [
        queryExternalEventID,
        queryExternalProvider,
        auth.churchId,
        auth
    ]);
    // Cleanup ref on unmount to prevent state updates after navigation
    (0, $7fPBF.useEffect)(()=>{
        return ()=>{
            isMountedRef.current = false;
        };
    }, []);
    const onSubmit = async ()=>{
        if (!auth.churchId || !canSubmit()) return;
        setSaving(true);
        setError(null);
        const payload = {
            id: '',
            churchID: auth.churchId,
            title: title,
            startsAt: startsAt ? startsAt.toISOString() : new Date().toISOString(),
            endsAt: endsAt ? endsAt.toISOString() : new Date().toISOString(),
            showTimes: showTimes,
            description: description || null,
            location: locationText || null,
            registrationURL: registrationURL || null,
            thumbnailURL: thumbnailURL || null,
            waivers: []
        };
        let planningCenterMetadata = null;
        if (queryExternalProvider === 'PLANNING_CENTER') planningCenterMetadata = {
            signupID: queryExternalEventID || '',
            selectionTypeMap: roleMap
        };
        try {
            const resp = await (0, $6857e104788587b0$export$2e2bcd8739ae039).createEvent(auth.churchId, {
                event: payload,
                planningCenterMetadata: planningCenterMetadata
            }, auth);
            if (isMountedRef.current) {
                if (resp.error) setError(resp.error);
                else navigate('/events');
            }
        } catch (err) {
            if (isMountedRef.current) setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to create event');
        } finally{
            if (isMountedRef.current) setSaving(false);
        }
    };
    const canSubmit = ()=>{
        if (saving) return false;
        if (!title || title.trim().length === 0) return false;
        if (!startsAt || !endsAt) return false;
        if (queryExternalProvider !== null && externalEventDetails === null) return false; // if we have a provider, we MUST wait for these to be loaded.
        // If using Planning Center, ensure all role mappings are set
        if (queryExternalProvider === 'PLANNING_CENTER') {
            var _externalEventDetails_planningCenter;
            const selectionTypes = (externalEventDetails === null || externalEventDetails === void 0 ? void 0 : (_externalEventDetails_planningCenter = externalEventDetails.planningCenter) === null || _externalEventDetails_planningCenter === void 0 ? void 0 : _externalEventDetails_planningCenter.selectionTypes) || [];
            if (selectionTypes.length > 0) {
                const allRolesMapped = selectionTypes.every((type)=>roleMap[type.id]);
                if (!allRolesMapped) return false;
            }
        }
        return true;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "create-event-internal",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: "",
                showBackButton: true,
                backLocation: "/events/create"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "form",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        children: "New Event"
                    }),
                    error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: error
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Details"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "text",
                                    name: "title",
                                    placeholder: "Title",
                                    value: title,
                                    onChange: (e)=>setTitle(e.target.value),
                                    disabled: saving
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                    name: "description",
                                    placeholder: "Event Description",
                                    value: description,
                                    onChange: (e)=>setDescription(e.target.value),
                                    disabled: saving
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section",
                        style: {
                            marginTop: 18
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "text",
                                    name: "registrationURL",
                                    placeholder: "Registration Link",
                                    value: registrationURL,
                                    onChange: (e)=>setRegistrationURL(e.target.value),
                                    disabled: saving
                                })
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "input",
                                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    type: "text",
                                    name: "location",
                                    placeholder: "Location",
                                    value: locationText,
                                    onChange: (e)=>setLocationText(e.target.value),
                                    disabled: saving
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Schedule"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "input",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Start Date"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c7b1a6f859720e7$export$5109c6dd95d8fb00), {
                                        className: "date-picker",
                                        selected: startsAt,
                                        disabled: saving,
                                        showTimeInput: true,
                                        timeInputLabel: "Time",
                                        timeFormat: "p",
                                        dateFormat: "Pp",
                                        onChange: (date)=>{
                                            if (saving) return;
                                            setStartsAt(date);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "input",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "End Date"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c7b1a6f859720e7$export$5109c6dd95d8fb00), {
                                        className: "date-picker",
                                        selected: endsAt,
                                        disabled: saving,
                                        showTimeInput: true,
                                        timeInputLabel: "Time",
                                        timeFormat: "p",
                                        dateFormat: "Pp",
                                        onChange: (date)=>{
                                            if (saving) return;
                                            setEndsAt(date);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "input",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                        children: "Show times"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        type: "checkbox",
                                        checked: showTimes,
                                        onChange: (e)=>setShowTimes(e.target.checked),
                                        disabled: saving
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: 'Turning on "Show times" will display the time alongside the event dates in the Salt app.'
                    }),
                    loadingExternalDetails ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: "Loading external event details..."
                    }) : null,
                    queryExternalProvider === 'PLANNING_CENTER' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$PlanningCenterSpecificConfig, {
                        details: externalEventDetails,
                        roleMap: roleMap,
                        setRoleMap: setRoleMap,
                        saving: saving
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        disabled: !canSubmit(),
                        className: "submit",
                        onClick: (e)=>{
                            e.preventDefault();
                            onSubmit();
                        },
                        children: saving ? "Saving..." : "Create Event"
                    })
                ]
            })
        ]
    });
}
function $1931765328266215$var$PlanningCenterSpecificConfig({ details: details, roleMap: roleMap, setRoleMap: setRoleMap, saving: saving }) {
    var _details_planningCenter;
    if (!details || !((_details_planningCenter = details.planningCenter) === null || _details_planningCenter === void 0 ? void 0 : _details_planningCenter.selectionTypes) || details.planningCenter.selectionTypes.length === 0) return null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $682ba43d460c7b6e$export$e25e478948902b8b).div, {
        initial: {
            opacity: 0
        },
        animate: {
            opacity: 1
        },
        transition: {
            duration: 0.3
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "planning-center-config",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                    children: "Role Mapping"
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "section",
                    children: details.planningCenter.selectionTypes.map((selectionType, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                idx > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($1931765328266215$var$Separator, {}),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "input",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            children: selectionType.name
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                            className: "role-select",
                                            value: roleMap[selectionType.id] || '',
                                            onChange: (e)=>setRoleMap((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, roleMap), {
                                                    [selectionType.id]: e.target.value
                                                })),
                                            disabled: saving,
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: "",
                                                    children: "Select a role..."
                                                }),
                                                [
                                                    'standard',
                                                    'volunteer',
                                                    'admin'
                                                ].map((role)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                        value: role,
                                                        children: role.charAt(0).toUpperCase() + role.slice(1)
                                                    }, role))
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, selectionType.id))
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "footnote",
                    children: "Map each Planning Center selection type to a Salt role, so that if an attendee links their registration to their Salt account they will have an appropriate level of access."
                })
            ]
        })
    });
}
function $1931765328266215$var$Separator() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            width: "100%",
            height: 1,
            backgroundColor: "#eaeaea",
            opacity: 0.10,
            margin: '12px 0'
        }
    });
}




var $7fPBF = parcelRequire("7fPBF");







function $fd33414c39acb8d6$export$2e2bcd8739ae039() {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [searchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const [externalLoading, setExternalLoading] = (0, $7fPBF.useState)(false);
    const [externalError, setExternalError] = (0, $7fPBF.useState)(null);
    const [externalEvents, setExternalEvents] = (0, $7fPBF.useState)(null);
    const provider = searchParams.get('provider');
    let providerName = '';
    if (provider === 'PLANNING_CENTER') providerName = 'Planning Center';
    // If provider is missing/unsupported, declaratively redirect back to the chooser.
    if (!provider || provider !== 'PLANNING_CENTER') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/events/create",
        replace: true
    });
    // Only fetch external events when we have a valid provider and church context.
    (0, $7fPBF.useEffect)(()=>{
        if (!provider || provider !== 'PLANNING_CENTER') return;
        let isMounted = true;
        const performFetch = async ()=>{
            if (!auth.churchId) return;
            setExternalLoading(true);
            setExternalError(null);
            setExternalEvents(null);
            try {
                const resp = await (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchExternalImportOptions(auth.churchId, provider, auth);
                if (!isMounted) return;
                if (resp.error) setExternalError(resp.error);
                else if (resp.body) setExternalEvents(resp.body.externalEvents);
            } catch (err) {
                setExternalError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to load external events');
            } finally{
                setExternalLoading(false);
            }
        };
        performFetch();
        return ()=>{
            isMounted = false;
        };
    // eslint-disable-next-line
    }, [
        provider,
        auth.churchId
    ]);
    const navigateToCreateForEvent = (ev)=>{
        const params = new URLSearchParams();
        if (ev.name) params.set('title', ev.name);
        if (ev.description) params.set('description', ev.description);
        if (ev.registrationURL) params.set('registrationURL', ev.registrationURL);
        if (ev.thumbnailImageURL) params.set('thumbnailURL', ev.thumbnailImageURL);
        params.set('externalEventID', ev.externalID);
        params.set('provider', provider);
        const search = params.toString();
        navigate({
            pathname: '/events/create/details',
            search: search ? `?${search}` : ''
        });
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "create-event-external",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                title: `Select ${providerName} Event`,
                showBackButton: true,
                backLocation: "/events/create"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "external-list",
                children: [
                    externalLoading ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}) : null,
                    externalError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: externalError
                    }) : null,
                    externalEvents ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            externalEvents.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "No events available to import."
                            }) : null,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "cards",
                                children: externalEvents.map((ev)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $5a439522e12ead21$export$2e2bcd8739ae039), {
                                        title: ev.name,
                                        thumbnailURL: ev.thumbnailImageURL,
                                        dateInfo: null,
                                        onClick: ()=>{
                                            navigateToCreateForEvent(ev);
                                        }
                                    }, ev.externalID))
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}





var $5400a2a63bd6350c$exports = {};
$5400a2a63bd6350c$exports = $parcel$resolve("5pgWl");


var $8acff66747a6c928$exports = {};
$8acff66747a6c928$exports = $parcel$resolve("ltOob");





var $7fPBF = parcelRequire("7fPBF");
var $f20b05b49aeba227$var$Context = /*#__PURE__*/ function(Context) {
    Context[Context["LOGIN"] = 0] = "LOGIN";
    Context[Context["REQUEST_RESET"] = 1] = "REQUEST_RESET";
    return Context;
}($f20b05b49aeba227$var$Context || {});
function $f20b05b49aeba227$export$2e2bcd8739ae039(props) {
    var _location_state_from, _location_state;
    let navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    let location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    let auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [performingAction, setPerformingAction] = (0, $7fPBF.useState)(false);
    const [context, setContext] = (0, $7fPBF.useState)(0);
    const [error, setError] = (0, $7fPBF.useState)("");
    const [email, setEmail] = (0, $7fPBF.useState)("");
    const [password, setPassword] = (0, $7fPBF.useState)("");
    const theme = (0, $5cc3ec176bbf7015$export$2e2bcd8739ae039)();
    let from = ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : (_location_state_from = _location_state.from) === null || _location_state_from === void 0 ? void 0 : _location_state_from.pathname) || '/';
    async function handleSubmit() {
        if (performingAction) return;
        if (context === 0) submitLogin();
        else submitReset();
    }
    async function submitLogin() {
        if (email.length === 0) {
            setError("Please enter your email.");
            return;
        }
        if (password.length === 0) {
            setError("Please enter your password.");
            return;
        }
        setError("");
        setPerformingAction(true);
        try {
            await auth.signIn(email, password);
            navigate(from, {
                replace: true
            });
        } catch (error) {
            setError(error.message);
            setPerformingAction(false);
        }
    }
    async function submitReset() {
        if (email.length === 0) {
            setError("Please enter your email.");
            return;
        }
        setError("");
        setPerformingAction(true);
        try {
            const message = await auth.requestPasswordReset(email);
            alert(message);
        } catch (error) {
            setError(error.message);
        }
        setPerformingAction(false);
    }
    async function handleContextChangeButtonClick() {
        if (performingAction) return;
        setError("");
        setContext(context === 0 ? 1 : 0);
    }
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "login-screen",
        children: [
            theme === (0, $5cc3ec176bbf7015$export$14faa19a0f3bbeb2).DARK ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "opacity-layer"
            }) : null,
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "login-form",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                        src: theme === (0, $5cc3ec176bbf7015$export$14faa19a0f3bbeb2).LIGHT ? (0, (/*@__PURE__*/$parcel$interopDefault($5400a2a63bd6350c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8acff66747a6c928$exports))),
                        draggable: false,
                        alt: "Salt Logo"
                    }),
                    error !== "" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: error
                    }) : "",
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        style: {
                            textAlign: 'center'
                        },
                        children: context === 0 ? "Please use your Salt Church Hub credentials to login." : "Please enter your email to reset your password for your Salt Church Hub account."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "input-holder",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                type: "email",
                                placeholder: "Email",
                                value: email,
                                disabled: performingAction,
                                onChange: (e)=>{
                                    setEmail(e.target.value);
                                    setError("");
                                }
                            }),
                            context === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                type: "password",
                                placeholder: "Password",
                                value: password,
                                disabled: performingAction,
                                onChange: (e)=>{
                                    setPassword(e.target.value);
                                    setError("");
                                }
                            }) : null
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: `login ${performingAction ? "disabled" : ""}`,
                        disabled: performingAction,
                        onClick: handleSubmit,
                        children: context === 0 ? "Login" : "Request Reset"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "forgot",
                        disabled: performingAction,
                        onClick: handleContextChangeButtonClick,
                        children: context === 0 ? "Forgot Password?" : "Login Instead"
                    })
                ]
            })
        ]
    });
}












var $7fPBF = parcelRequire("7fPBF");

function $14b7ba2e956aca92$export$2e2bcd8739ae039() {
    const [searchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const type = searchParams.get("type");
    const token = searchParams.get("token");
    const theme = (0, $5cc3ec176bbf7015$export$2e2bcd8739ae039)();
    const [error, setError] = (0, $7fPBF.useState)("");
    const [performingAction, setPerformingAction] = (0, $7fPBF.useState)(false);
    const [newPassword, setNewPassword] = (0, $7fPBF.useState)("");
    const [newPasswordConfirm, setNewPasswordConfirm] = (0, $7fPBF.useState)("");
    if (!token) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/login"
    });
    const handleSubmit = async ()=>{
        if (newPassword !== newPasswordConfirm) return setError("Your passwords do not match");
        if (newPassword.match(/^(.{0,7}|[^0-9]*|[^A-Z]*|[^a-z]*|[a-zA-Z0-9]*)$/) !== null) return setError("Your password must be at least 8 characters long, contain a lowercase and uppercase letter, at least one number, and a special character.");
        setPerformingAction(true);
        setError("");
        try {
            const success = await auth.resetPassword(token, newPassword);
            if (success) {
                alert("Your password has been reset. Please login with your new password.");
                navigate("/login");
            } else setError("Failed to reset your password. Please try again later.");
        } catch (error) {
            setError(error.message);
        }
        setPerformingAction(false);
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "container reset-password-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: theme === (0, $5cc3ec176bbf7015$export$14faa19a0f3bbeb2).LIGHT ? (0, (/*@__PURE__*/$parcel$interopDefault($5400a2a63bd6350c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8acff66747a6c928$exports))),
                draggable: false,
                alt: "Salt Logo"
            }),
            error !== "" ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "error",
                children: error
            }) : "",
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                style: {
                    textAlign: 'center'
                },
                children: [
                    "Use this form to ",
                    type === 'initial' ? 'set' : 'reset',
                    " your Salt Church Hub password."
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                type: "password",
                placeholder: "New Password",
                value: newPassword,
                disabled: performingAction,
                onChange: (e)=>{
                    setNewPassword(e.target.value);
                    setError("");
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                type: "password",
                placeholder: "New Password (Confirm)",
                value: newPasswordConfirm,
                disabled: performingAction,
                onChange: (e)=>{
                    setNewPasswordConfirm(e.target.value);
                    setError("");
                }
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("button", {
                className: `reset ${performingAction ? "disabled" : ""}`,
                disabled: performingAction,
                onClick: handleSubmit,
                children: [
                    type === 'initial' ? 'Set' : 'Reset',
                    " Password"
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                className: "login",
                disabled: performingAction,
                onClick: ()=>navigate("/"),
                children: "Login Instead"
            })
        ]
    });
}








var $49ae69acb74a3943$exports = {};
$49ae69acb74a3943$exports = $parcel$resolve("bBooK");


var $6f588133950e6aa3$exports = {};
$6f588133950e6aa3$exports = $parcel$resolve("es6ZK");


var $ec0551d2c7d279c4$exports = {};
$ec0551d2c7d279c4$exports = $parcel$resolve("aKLVB");




var $67945e64350c48fb$exports = {};
$67945e64350c48fb$exports = $parcel$resolve("kGQfz");


var $6e961e8ad9a8f0e3$exports = {};
$6e961e8ad9a8f0e3$exports = $parcel$resolve("ha6AV");



var $71ea430f4a671b73$exports = {};
$71ea430f4a671b73$exports = $parcel$resolve("5AGgz");



var $dcf07832ec5ba2b3$exports = {};
$dcf07832ec5ba2b3$exports = $parcel$resolve("gmrzU");


var $7cb3273eb8a138bf$exports = {};
$7cb3273eb8a138bf$exports = $parcel$resolve("7Tmfa");




var $ce5d85dadab4b28c$exports = {};
'use strict';
Object.defineProperty($ce5d85dadab4b28c$exports, '__esModule', {
    value: true
});










$ce5d85dadab4b28c$exports['default'] = {
    slide: (parcelRequire("as5xI")),
    stack: (parcelRequire("8LDbR")),
    elastic: (parcelRequire("5Z3UW")),
    bubble: (parcelRequire("63d8t")),
    push: (parcelRequire("d9Mhz")),
    pushRotate: (parcelRequire("cJH6C")),
    scaleDown: (parcelRequire("1v5Sr")),
    scaleRotate: (parcelRequire("i1zqH")),
    fallDown: (parcelRequire("k9vVI")),
    reveal: (parcelRequire("6UWsR"))
};
$ce5d85dadab4b28c$exports = $ce5d85dadab4b28c$exports['default'];



var $7fPBF = parcelRequire("7fPBF");

var $405982bdd950bba4$var$_httpsapisaltplatformcom, $405982bdd950bba4$var$_httpseventsapisaltplatformcom, $405982bdd950bba4$var$_httpsplaylistssaltplatformcom, $405982bdd950bba4$var$_httpssanctuaryapisaltplatformcom;
const $405982bdd950bba4$var$isStagingEnvironment = (($405982bdd950bba4$var$_httpsapisaltplatformcom = "https://api.saltplatform.com") === null || $405982bdd950bba4$var$_httpsapisaltplatformcom === void 0 ? void 0 : $405982bdd950bba4$var$_httpsapisaltplatformcom.includes('staging')) === true || (($405982bdd950bba4$var$_httpseventsapisaltplatformcom = "https://events-api.saltplatform.com") === null || $405982bdd950bba4$var$_httpseventsapisaltplatformcom === void 0 ? void 0 : $405982bdd950bba4$var$_httpseventsapisaltplatformcom.includes('staging')) === true || (($405982bdd950bba4$var$_httpsplaylistssaltplatformcom = "https://playlists.saltplatform.com") === null || $405982bdd950bba4$var$_httpsplaylistssaltplatformcom === void 0 ? void 0 : $405982bdd950bba4$var$_httpsplaylistssaltplatformcom.includes('staging')) === true || (($405982bdd950bba4$var$_httpssanctuaryapisaltplatformcom = "https://sanctuary-api.saltplatform.com") === null || $405982bdd950bba4$var$_httpssanctuaryapisaltplatformcom === void 0 ? void 0 : $405982bdd950bba4$var$_httpssanctuaryapisaltplatformcom.includes('staging')) === true;
const $405982bdd950bba4$var$routes = [
    {
        path: 'home',
        name: 'Home',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($49ae69acb74a3943$exports))),
        requiredPermission: null
    },
    {
        path: 'launchpad',
        name: 'Launchpad',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($b683f9125e92b609$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_LAUNCHPAD
    },
    {
        type: 'separator',
        label: 'Content'
    },
    {
        path: 'services',
        name: 'Services',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($55cab1b870ffe3ff$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_SERVICES
    },
    {
        path: 'playlists',
        name: 'Playlists',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($ec0551d2c7d279c4$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_PLAYLISTS
    },
    {
        path: 'events',
        name: 'Events',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($729bd1a2fa55fb37$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_EVENTS
    },
    {
        type: 'separator',
        label: 'People'
    },
    {
        path: 'volunteering',
        name: 'Volunteering',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($30bbe81485bfa1db$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_VOLUNTEERING
    },
    {
        path: 'people',
        name: 'People',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dcf07832ec5ba2b3$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_PEOPLE
    },
    {
        type: 'separator',
        label: 'Administration'
    },
    {
        path: 'staff',
        name: 'Staff Members',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6e961e8ad9a8f0e3$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_STAFF
    },
    {
        path: 'connections',
        name: 'Connections',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($6f588133950e6aa3$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_CONNECTIONS
    },
    {
        path: 'settings',
        name: 'Settings',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($71ea430f4a671b73$exports))),
        requiredPermission: (0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_SETTINGS
    }
];
function $405982bdd950bba4$export$2e2bcd8739ae039(props) {
    const [isOpen, setIsOpen] = (0, $7fPBF.useState)(false);
    const sidebarContent = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($405982bdd950bba4$var$SidebarContent, {
        churchName: props.churchName,
        closeSidebar: ()=>{
            setIsOpen(false);
        }
    });
    return props.isMobile ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("header", {
                className: "sidebar-header",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                        onClick: (e)=>{
                            e.preventDefault();
                            setIsOpen(true);
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($7cb3273eb8a138bf$exports)))
                        })
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                        children: "Salt Church Hub"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ce5d85dadab4b28c$exports.slide), {
                isOpen: isOpen,
                onStateChange: (state)=>setIsOpen(state.isOpen),
                className: "sidebar",
                styles: {
                    bmBurgerButton: {
                        display: 'none'
                    }
                },
                children: sidebarContent
            })
        ]
    }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "sidebar sidebar-div",
        children: sidebarContent
    });
}
function $405982bdd950bba4$var$SidebarContent(props) {
    var _auth_user;
    const theme = (0, $5cc3ec176bbf7015$export$2e2bcd8739ae039)();
    const location = (0, $d9fd026bfea79ab9$export$45d76561a5302f2b)();
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const path = location.pathname;
    let pathComponents = path.split('/');
    let route = pathComponents[1];
    if (route === "") route = "home";
    // A volunteer team's page lives at /team/{teamID}.
    if (route === "team") route = "volunteering";
    const canSee = (item)=>item.requiredPermission === null || auth.hasPermission(item.requiredPermission);
    // The routes this user's roles open, with each separator kept only if a
    // route follows it before the next one.
    const visibleItems = $405982bdd950bba4$var$routes.map((item, index)=>({
            item: item,
            index: index
        })).filter(({ item: item, index: index })=>{
        if (item.type !== 'separator') return canSee(item);
        for (const next of $405982bdd950bba4$var$routes.slice(index + 1)){
            if (next.type === 'separator') return false;
            if (canSee(next)) return true;
        }
        return false;
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                src: theme === (0, $5cc3ec176bbf7015$export$14faa19a0f3bbeb2).LIGHT ? (0, (/*@__PURE__*/$parcel$interopDefault($5400a2a63bd6350c$exports))) : (0, (/*@__PURE__*/$parcel$interopDefault($8acff66747a6c928$exports))),
                draggable: false,
                alt: "Salt Icon",
                className: "logo"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "greeting",
                children: [
                    "\uD83D\uDC4B Hi, ",
                    (_auth_user = auth.user) === null || _auth_user === void 0 ? void 0 : _auth_user.name,
                    "!"
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "churchName",
                children: props.churchName
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "divider"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                children: visibleItems.map(({ item: r, index: i })=>{
                    // handle separator items
                    if (r.type === 'separator') {
                        const sep = r;
                        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                            className: "route-separator",
                            children: sep.label ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                className: "separator-label",
                                children: sep.label
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "separator-line"
                            })
                        }, `sep-${i}`);
                    }
                    const routeItem = r;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                        className: route == routeItem.path ? 'selected' : '',
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                            href: `/${routeItem.path}`,
                            onClick: (e)=>{
                                e.preventDefault();
                                navigate(`/${routeItem.path}`);
                                props.closeSidebar();
                            },
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                    src: routeItem.icon
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    children: routeItem.name
                                })
                            ]
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "divider"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
                        href: "/logout",
                        onClick: (e)=>{
                            e.preventDefault();
                            auth.signOut(()=>navigate("/"));
                            props.closeSidebar();
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                style: {
                                    marginRight: 8
                                },
                                children: "Sign Out"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($67945e64350c48fb$exports)))
                            })
                        ]
                    })
                })
            })
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");
var $66dfb6eb404a098b$exports = {};
'use strict';
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ var $5f306376e4d30ca7$export$4659b591c19bdf3d;
var $5f306376e4d30ca7$export$98e6a39c04603d36;
'use strict';
$5f306376e4d30ca7$export$4659b591c19bdf3d = $5f306376e4d30ca7$var$matchQuery;
$5f306376e4d30ca7$export$98e6a39c04603d36 = $5f306376e4d30ca7$var$parseQuery;
// -----------------------------------------------------------------------------
var $5f306376e4d30ca7$var$RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, $5f306376e4d30ca7$var$RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, $5f306376e4d30ca7$var$RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, $5f306376e4d30ca7$var$RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, $5f306376e4d30ca7$var$RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
function $5f306376e4d30ca7$var$matchQuery(mediaQuery, values) {
    return $5f306376e4d30ca7$var$parseQuery(mediaQuery).some(function(query) {
        var inverse = query.inverse;
        // Either the parsed or specified `type` is "all", or the types must be
        // equal for a match.
        var typeMatch = query.type === 'all' || values.type === query.type;
        // Quit early when `type` doesn't match, but take "not" into account.
        if (typeMatch && inverse || !(typeMatch || inverse)) return false;
        var expressionsMatch = query.expressions.every(function(expression) {
            var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
            // Missing or falsy values don't match.
            if (!value) return false;
            switch(feature){
                case 'orientation':
                case 'scan':
                    return value.toLowerCase() === expValue.toLowerCase();
                case 'width':
                case 'height':
                case 'device-width':
                case 'device-height':
                    expValue = $5f306376e4d30ca7$var$toPx(expValue);
                    value = $5f306376e4d30ca7$var$toPx(value);
                    break;
                case 'resolution':
                    expValue = $5f306376e4d30ca7$var$toDpi(expValue);
                    value = $5f306376e4d30ca7$var$toDpi(value);
                    break;
                case 'aspect-ratio':
                case 'device-aspect-ratio':
                case /* Deprecated */ 'device-pixel-ratio':
                    expValue = $5f306376e4d30ca7$var$toDecimal(expValue);
                    value = $5f306376e4d30ca7$var$toDecimal(value);
                    break;
                case 'grid':
                case 'color':
                case 'color-index':
                case 'monochrome':
                    expValue = parseInt(expValue, 10) || 1;
                    value = parseInt(value, 10) || 0;
                    break;
            }
            switch(modifier){
                case 'min':
                    return value >= expValue;
                case 'max':
                    return value <= expValue;
                default:
                    return value === expValue;
            }
        });
        return expressionsMatch && !inverse || !expressionsMatch && inverse;
    });
}
function $5f306376e4d30ca7$var$parseQuery(mediaQuery) {
    return mediaQuery.split(',').map(function(query) {
        query = query.trim();
        var captures = query.match($5f306376e4d30ca7$var$RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || '', parsed = {};
        parsed.inverse = !!modifier && modifier.toLowerCase() === 'not';
        parsed.type = type ? type.toLowerCase() : 'all';
        // Split expressions into a list.
        expressions = expressions.match(/\([^\)]+\)/g) || [];
        parsed.expressions = expressions.map(function(expression) {
            var captures = expression.match($5f306376e4d30ca7$var$RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match($5f306376e4d30ca7$var$RE_MQ_FEATURE);
            return {
                modifier: feature[1],
                feature: feature[2],
                value: captures[2]
            };
        });
        return parsed;
    });
}
// -- Utilities ----------------------------------------------------------------
function $5f306376e4d30ca7$var$toDecimal(ratio) {
    var decimal = Number(ratio), numbers;
    if (!decimal) {
        numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/);
        decimal = numbers[1] / numbers[2];
    }
    return decimal;
}
function $5f306376e4d30ca7$var$toDpi(resolution) {
    var value = parseFloat(resolution), units = String(resolution).match($5f306376e4d30ca7$var$RE_RESOLUTION_UNIT)[1];
    switch(units){
        case 'dpcm':
            return value / 2.54;
        case 'dppx':
            return value * 96;
        default:
            return value;
    }
}
function $5f306376e4d30ca7$var$toPx(length) {
    var value = parseFloat(length), units = String(length).match($5f306376e4d30ca7$var$RE_LENGTH_UNIT)[1];
    switch(units){
        case 'em':
            return value * 16;
        case 'rem':
            return value * 16;
        case 'cm':
            return value * 96 / 2.54;
        case 'mm':
            return value * 96 / 2.54 / 10;
        case 'in':
            return value * 96;
        case 'pt':
            return value * 72;
        case 'pc':
            return value * 72 / 12;
        default:
            return value;
    }
}


var $66dfb6eb404a098b$require$staticMatch = $5f306376e4d30ca7$export$4659b591c19bdf3d;
var $66dfb6eb404a098b$var$dynamicMatch = typeof window !== 'undefined' ? window.matchMedia : null;
// our fake MediaQueryList
function $66dfb6eb404a098b$var$Mql(query, values, forceStatic) {
    var self = this;
    var mql;
    // matchMedia will return null in FF when it's called in a hidden iframe
    // ref: https://stackoverflow.com/a/12330568
    if ($66dfb6eb404a098b$var$dynamicMatch && !forceStatic) mql = $66dfb6eb404a098b$var$dynamicMatch.call(window, query);
    if (mql) {
        this.matches = mql.matches;
        this.media = mql.media;
        // TODO: is there a time it makes sense to remove this listener?
        mql.addListener(update);
    } else {
        this.matches = $66dfb6eb404a098b$require$staticMatch(query, values);
        this.media = query;
    }
    this.addListener = addListener;
    this.removeListener = removeListener;
    this.dispose = dispose;
    function addListener(listener) {
        if (mql) mql.addListener(listener);
    }
    function removeListener(listener) {
        if (mql) mql.removeListener(listener);
    }
    // update ourselves!
    function update(evt) {
        self.matches = evt.matches;
        self.media = evt.media;
    }
    function dispose() {
        if (mql) mql.removeListener(update);
    }
}
function $66dfb6eb404a098b$var$matchMedia(query, values, forceStatic) {
    return new $66dfb6eb404a098b$var$Mql(query, values, forceStatic);
}
$66dfb6eb404a098b$exports = $66dfb6eb404a098b$var$matchMedia;


/* eslint-disable no-var, prefer-template */ var $1b42eaed349bc9b0$var$uppercasePattern = /[A-Z]/g;
var $1b42eaed349bc9b0$var$msPattern = /^ms-/;
var $1b42eaed349bc9b0$var$cache = {};
function $1b42eaed349bc9b0$var$toHyphenLower(match) {
    return '-' + match.toLowerCase();
}
function $1b42eaed349bc9b0$var$hyphenateStyleName(name) {
    if ($1b42eaed349bc9b0$var$cache.hasOwnProperty(name)) return $1b42eaed349bc9b0$var$cache[name];
    var hName = name.replace($1b42eaed349bc9b0$var$uppercasePattern, $1b42eaed349bc9b0$var$toHyphenLower);
    return $1b42eaed349bc9b0$var$cache[name] = $1b42eaed349bc9b0$var$msPattern.test(hName) ? '-' + hName : hName;
}
var $1b42eaed349bc9b0$export$2e2bcd8739ae039 = $1b42eaed349bc9b0$var$hyphenateStyleName;


function $99216e69d1643bce$export$967a6b9924a689f7(arrA, arrB) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++){
        if (arrA[i] !== arrB[i]) return false;
    }
    return true;
}
function $99216e69d1643bce$export$3e67810a3f0e9f1c(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    const aKeys = Object.keys(objA);
    const bKeys = Object.keys(objB);
    const len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(let i = 0; i < len; i++){
        const key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
function $99216e69d1643bce$export$d36bdfa510afb180(a, b) {
    const aIsArr = Array.isArray(a);
    const bIsArr = Array.isArray(b);
    if (aIsArr !== bIsArr) return false;
    if (aIsArr && bIsArr) return $99216e69d1643bce$export$967a6b9924a689f7(a, b);
    return $99216e69d1643bce$export$3e67810a3f0e9f1c(a, b);
}



var $2oXYc = parcelRequire("2oXYc");
const $92f580e302e93e6f$var$stringOrNumber = (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number
]);
// media types
const $92f580e302e93e6f$var$types = {
    all: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    grid: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    aural: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    braille: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    handheld: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    print: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    projection: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    screen: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    tty: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    tv: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    embossed: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool
};
// properties that match media queries
const $92f580e302e93e6f$var$matchers = {
    orientation: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        'portrait',
        'landscape'
    ]),
    scan: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).oneOf([
        'progressive',
        'interlace'
    ]),
    aspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    deviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    height: $92f580e302e93e6f$var$stringOrNumber,
    deviceHeight: $92f580e302e93e6f$var$stringOrNumber,
    width: $92f580e302e93e6f$var$stringOrNumber,
    deviceWidth: $92f580e302e93e6f$var$stringOrNumber,
    color: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    colorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    monochrome: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).bool,
    resolution: $92f580e302e93e6f$var$stringOrNumber,
    type: Object.keys($92f580e302e93e6f$var$types)
};
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const { type: $92f580e302e93e6f$var$type } = $92f580e302e93e6f$var$matchers, $92f580e302e93e6f$var$featureMatchers = (0, $8901fc92b5563702$export$71511d61b312f219)($92f580e302e93e6f$var$matchers, [
    "type"
]);
// media features
const $92f580e302e93e6f$var$features = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
    minAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    maxAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    minDeviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    maxDeviceAspectRatio: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).string,
    minHeight: $92f580e302e93e6f$var$stringOrNumber,
    maxHeight: $92f580e302e93e6f$var$stringOrNumber,
    minDeviceHeight: $92f580e302e93e6f$var$stringOrNumber,
    maxDeviceHeight: $92f580e302e93e6f$var$stringOrNumber,
    minWidth: $92f580e302e93e6f$var$stringOrNumber,
    maxWidth: $92f580e302e93e6f$var$stringOrNumber,
    minDeviceWidth: $92f580e302e93e6f$var$stringOrNumber,
    maxDeviceWidth: $92f580e302e93e6f$var$stringOrNumber,
    minColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    maxColor: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    minColorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    maxColorIndex: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    minMonochrome: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    maxMonochrome: (0, (/*@__PURE__*/$parcel$interopDefault($2oXYc))).number,
    minResolution: $92f580e302e93e6f$var$stringOrNumber,
    maxResolution: $92f580e302e93e6f$var$stringOrNumber
}, $92f580e302e93e6f$var$featureMatchers);
const $92f580e302e93e6f$var$all = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, $92f580e302e93e6f$var$types, $92f580e302e93e6f$var$features);
var $92f580e302e93e6f$var$mq = {
    all: $92f580e302e93e6f$var$all,
    types: $92f580e302e93e6f$var$types,
    matchers: $92f580e302e93e6f$var$matchers,
    features: $92f580e302e93e6f$var$features
};
const $92f580e302e93e6f$var$negate = (cond)=>`not ${cond}`;
const $92f580e302e93e6f$var$keyVal = (k, v)=>{
    const realKey = (0, $1b42eaed349bc9b0$export$2e2bcd8739ae039)(k);
    // px shorthand
    if (typeof v === 'number') v = `${v}px`;
    if (v === true) return realKey;
    if (v === false) return $92f580e302e93e6f$var$negate(realKey);
    return `(${realKey}: ${v})`;
};
const $92f580e302e93e6f$var$join = (conds)=>conds.join(' and ');
const $92f580e302e93e6f$export$da99e50c1f5e8cc8 = (obj)=>{
    const rules = [];
    Object.keys($92f580e302e93e6f$var$mq.all).forEach((k)=>{
        const v = obj[k];
        if (v != null) rules.push($92f580e302e93e6f$var$keyVal(k, v));
    });
    return $92f580e302e93e6f$var$join(rules);
};
const $92f580e302e93e6f$export$841858b892ce1f4c = (0, $7fPBF.createContext)(undefined);
const $92f580e302e93e6f$var$makeQuery = (settings)=>settings.query || $92f580e302e93e6f$export$da99e50c1f5e8cc8(settings);
const $92f580e302e93e6f$var$hyphenateKeys = (obj)=>{
    if (!obj) return undefined;
    const keys = Object.keys(obj);
    return keys.reduce((result, key)=>{
        result[(0, $1b42eaed349bc9b0$export$2e2bcd8739ae039)(key)] = obj[key];
        return result;
    }, {});
};
const $92f580e302e93e6f$var$useIsUpdate = ()=>{
    const ref = (0, $7fPBF.useRef)(false);
    (0, $7fPBF.useEffect)(()=>{
        ref.current = true;
    }, []);
    return ref.current;
};
const $92f580e302e93e6f$var$useDevice = (deviceFromProps)=>{
    const deviceFromContext = (0, $7fPBF.useContext)($92f580e302e93e6f$export$841858b892ce1f4c);
    const getDevice = ()=>$92f580e302e93e6f$var$hyphenateKeys(deviceFromProps) || $92f580e302e93e6f$var$hyphenateKeys(deviceFromContext);
    const [device, setDevice] = (0, $7fPBF.useState)(getDevice);
    (0, $7fPBF.useEffect)(()=>{
        const newDevice = getDevice();
        if (!(0, $99216e69d1643bce$export$3e67810a3f0e9f1c)(device, newDevice)) setDevice(newDevice);
    }, [
        deviceFromProps,
        deviceFromContext
    ]);
    return device;
};
const $92f580e302e93e6f$var$useQuery = (settings)=>{
    const getQuery = ()=>$92f580e302e93e6f$var$makeQuery(settings);
    const [query, setQuery] = (0, $7fPBF.useState)(getQuery);
    (0, $7fPBF.useEffect)(()=>{
        const newQuery = getQuery();
        if (query !== newQuery) setQuery(newQuery);
    }, [
        settings
    ]);
    return query;
};
const $92f580e302e93e6f$var$useMatchMedia = (query, device)=>{
    const getMatchMedia = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($66dfb6eb404a098b$exports)))(query, device || {}, !!device);
    const [mq, setMq] = (0, $7fPBF.useState)(getMatchMedia);
    const isUpdate = $92f580e302e93e6f$var$useIsUpdate();
    (0, $7fPBF.useEffect)(()=>{
        if (isUpdate) {
            // skip on mounting, it has already been set
            const newMq = getMatchMedia();
            setMq(newMq);
            return ()=>{
                if (newMq) newMq.dispose();
            };
        }
    }, [
        query,
        device
    ]);
    return mq;
};
const $92f580e302e93e6f$var$useMatches = (mediaQuery)=>{
    const [matches, setMatches] = (0, $7fPBF.useState)(mediaQuery.matches);
    (0, $7fPBF.useEffect)(()=>{
        const updateMatches = (ev)=>{
            setMatches(ev.matches);
        };
        mediaQuery.addListener(updateMatches);
        setMatches(mediaQuery.matches);
        return ()=>{
            mediaQuery.removeListener(updateMatches);
        };
    }, [
        mediaQuery
    ]);
    return matches;
};
const $92f580e302e93e6f$export$32d5543ab307c01 = (settings, device, onChange)=>{
    const deviceSettings = $92f580e302e93e6f$var$useDevice(device);
    const query = $92f580e302e93e6f$var$useQuery(settings);
    if (!query) throw new Error('Invalid or missing MediaQuery!');
    const mq = $92f580e302e93e6f$var$useMatchMedia(query, deviceSettings);
    const matches = $92f580e302e93e6f$var$useMatches(mq);
    const isUpdate = $92f580e302e93e6f$var$useIsUpdate();
    (0, $7fPBF.useEffect)(()=>{
        if (isUpdate && onChange) onChange(matches);
    }, [
        matches
    ]);
    (0, $7fPBF.useEffect)(()=>()=>{
            if (mq) mq.dispose();
        }, []);
    return matches;
};
// ReactNode and ReactElement typings are a little funky for functional components, so the ReactElement cast is needed on the return
const $92f580e302e93e6f$export$b745838c41029eb3 = (_param)=>{
    var { children: children, device: device, onChange: onChange } = _param, settings = (0, $8901fc92b5563702$export$71511d61b312f219)(_param, [
        "children",
        "device",
        "onChange"
    ]);
    const matches = $92f580e302e93e6f$export$32d5543ab307c01(settings, device, onChange);
    if (typeof children === 'function') return children(matches);
    return matches ? children : null;
};



function $2471b8f7d7b0c863$export$2e2bcd8739ae039() {
    var _churchData_church;
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const isMobile = (0, $92f580e302e93e6f$export$32d5543ab307c01)({
        query: `(max-width: 800px)`
    });
    var _churchData_church_attributes_name;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "Appv2",
        style: {
            display: 'flex'
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $405982bdd950bba4$export$2e2bcd8739ae039), {
                churchName: (_churchData_church_attributes_name = (_churchData_church = churchData.church) === null || _churchData_church === void 0 ? void 0 : _churchData_church.attributes.name) !== null && _churchData_church_attributes_name !== void 0 ? _churchData_church_attributes_name : "",
                isMobile: isMobile
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                style: {
                    marginTop: isMobile ? '80px' : '0',
                    width: '100%',
                    // Clips like hidden, but without becoming a scroll container that never
                    // scrolls, which would stop position: sticky working in any page.
                    overflow: 'clip'
                },
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$910ae8079b2c2852), {})
            })
        ]
    });
}






// The API sends the provider's own value (PLANNING_CENTER); the events backend
// sent a short name, and old links are still worth reading.
function $4b0f979acc21dbbe$var$providerName(provider) {
    switch(provider){
        case 'PLANNING_CENTER':
        case 'planning-center':
        case 'pco':
            return 'Planning Center';
        case 'SMART_WAIVER':
        case 'smart-waiver':
            return 'Smartwaiver';
        default:
            return 'provider';
    }
}
// Machine-readable codes from the callback, so the Hub renders its own copy
// rather than surfacing the API's prose.
function $4b0f979acc21dbbe$var$reasonCopy(reason, name) {
    switch(reason){
        case 'organization_mismatch':
            return `That ${name} organization is different from the one already connected. Connect the original organization, or disconnect first.`;
        case 'missing_organization':
            return `We couldn't read an organization from that ${name} account.`;
        case 'access_denied':
            return `The ${name} connection was declined.`;
        case 'missing_parameters':
        case 'unsupported_flow':
            return `${name} sent us back without everything we needed. Please try again.`;
        default:
            return `Failed to connect with ${name}.`;
    }
}
function $4b0f979acc21dbbe$export$2e2bcd8739ae039() {
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const [searchParams] = (0, $a0cf24fd73ae067c$export$f1a78c17382fe22a)();
    const provider = searchParams.get("provider");
    const success = searchParams.get("success") == "true";
    const reason = searchParams.get("reason");
    const name = $4b0f979acc21dbbe$var$providerName(provider);
    if (!success) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        error: $4b0f979acc21dbbe$var$reasonCopy(reason, name),
        buttonText: "Continue",
        buttonAction: ()=>navigate('/connections')
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "redirect-success-view",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "\u2705"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h1", {
                children: "Successfully Connected!"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                children: [
                    "You've successfully connected with ",
                    name,
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                href: "#",
                onClick: ()=>navigate('/connections'),
                children: "Continue"
            })
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");




var $6df11232f48ec2ff$exports = {};
$6df11232f48ec2ff$exports = $parcel$resolve("ahs3Z");






// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ class $886de9df440664a3$var$LuxonError extends Error {
}
class $886de9df440664a3$export$aaeef2cf7fd7967f extends $886de9df440664a3$var$LuxonError {
    constructor(reason){
        super(`Invalid DateTime: ${reason.toMessage()}`);
    }
}
class $886de9df440664a3$export$cdb4559f04a244ae extends $886de9df440664a3$var$LuxonError {
    constructor(reason){
        super(`Invalid Interval: ${reason.toMessage()}`);
    }
}
class $886de9df440664a3$export$fa63917b8416fe36 extends $886de9df440664a3$var$LuxonError {
    constructor(reason){
        super(`Invalid Duration: ${reason.toMessage()}`);
    }
}
class $886de9df440664a3$export$10234d3be7f66e6a extends $886de9df440664a3$var$LuxonError {
}
class $886de9df440664a3$export$ac94f561e2d387b4 extends $886de9df440664a3$var$LuxonError {
    constructor(unit){
        super(`Invalid unit ${unit}`);
    }
}
class $886de9df440664a3$export$9c711d4a95378233 extends $886de9df440664a3$var$LuxonError {
}
class $886de9df440664a3$export$b0a664b8a649f992 extends $886de9df440664a3$var$LuxonError {
    constructor(){
        super("Zone is an abstract class");
    }
}



/**
 * @private
 */ const $58f58a4a5bb96d49$var$n = "numeric", $58f58a4a5bb96d49$var$s = "short", $58f58a4a5bb96d49$var$l = "long";
const $58f58a4a5bb96d49$export$19db5ed0dfbf6b4 = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$n,
    day: $58f58a4a5bb96d49$var$n
};
const $58f58a4a5bb96d49$export$7f19f128b5a661d5 = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$s,
    day: $58f58a4a5bb96d49$var$n
};
const $58f58a4a5bb96d49$export$7afd5e65ff14ad5f = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$s,
    day: $58f58a4a5bb96d49$var$n,
    weekday: $58f58a4a5bb96d49$var$s
};
const $58f58a4a5bb96d49$export$e8af1c0b0290dbe2 = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$l,
    day: $58f58a4a5bb96d49$var$n
};
const $58f58a4a5bb96d49$export$ab5c0d098dcfe775 = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$l,
    day: $58f58a4a5bb96d49$var$n,
    weekday: $58f58a4a5bb96d49$var$l
};
const $58f58a4a5bb96d49$export$b4941e7fc62df1ff = {
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n
};
const $58f58a4a5bb96d49$export$61c7c50acaa56067 = {
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    second: $58f58a4a5bb96d49$var$n
};
const $58f58a4a5bb96d49$export$417ed025e483567 = {
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    second: $58f58a4a5bb96d49$var$n,
    timeZoneName: $58f58a4a5bb96d49$var$s
};
const $58f58a4a5bb96d49$export$e0d12640fceb849c = {
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    second: $58f58a4a5bb96d49$var$n,
    timeZoneName: $58f58a4a5bb96d49$var$l
};
const $58f58a4a5bb96d49$export$7333d0894ea2a492 = {
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    hourCycle: "h23"
};
const $58f58a4a5bb96d49$export$2664018dfbf7eca = {
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    second: $58f58a4a5bb96d49$var$n,
    hourCycle: "h23"
};
const $58f58a4a5bb96d49$export$3f5c467c8b3c85f6 = {
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    second: $58f58a4a5bb96d49$var$n,
    hourCycle: "h23",
    timeZoneName: $58f58a4a5bb96d49$var$s
};
const $58f58a4a5bb96d49$export$edc722d6385d5cfa = {
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    second: $58f58a4a5bb96d49$var$n,
    hourCycle: "h23",
    timeZoneName: $58f58a4a5bb96d49$var$l
};
const $58f58a4a5bb96d49$export$434cdda648f6d8ed = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$n,
    day: $58f58a4a5bb96d49$var$n,
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n
};
const $58f58a4a5bb96d49$export$115df8ec21cc4422 = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$n,
    day: $58f58a4a5bb96d49$var$n,
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    second: $58f58a4a5bb96d49$var$n
};
const $58f58a4a5bb96d49$export$2a10deefdeef9026 = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$s,
    day: $58f58a4a5bb96d49$var$n,
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n
};
const $58f58a4a5bb96d49$export$652ead5a5aee93d0 = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$s,
    day: $58f58a4a5bb96d49$var$n,
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    second: $58f58a4a5bb96d49$var$n
};
const $58f58a4a5bb96d49$export$97006f3c2fab9954 = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$s,
    day: $58f58a4a5bb96d49$var$n,
    weekday: $58f58a4a5bb96d49$var$s,
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n
};
const $58f58a4a5bb96d49$export$6fbcfb06dd40694b = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$l,
    day: $58f58a4a5bb96d49$var$n,
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    timeZoneName: $58f58a4a5bb96d49$var$s
};
const $58f58a4a5bb96d49$export$9ae9ad238dcfe6df = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$l,
    day: $58f58a4a5bb96d49$var$n,
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    second: $58f58a4a5bb96d49$var$n,
    timeZoneName: $58f58a4a5bb96d49$var$s
};
const $58f58a4a5bb96d49$export$c01f9be9042ca6d2 = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$l,
    day: $58f58a4a5bb96d49$var$n,
    weekday: $58f58a4a5bb96d49$var$l,
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    timeZoneName: $58f58a4a5bb96d49$var$l
};
const $58f58a4a5bb96d49$export$c3b12c6a0fb1f516 = {
    year: $58f58a4a5bb96d49$var$n,
    month: $58f58a4a5bb96d49$var$l,
    day: $58f58a4a5bb96d49$var$n,
    weekday: $58f58a4a5bb96d49$var$l,
    hour: $58f58a4a5bb96d49$var$n,
    minute: $58f58a4a5bb96d49$var$n,
    second: $58f58a4a5bb96d49$var$n,
    timeZoneName: $58f58a4a5bb96d49$var$l
};


/*
  This is just a junk drawer, containing anything used across multiple classes.
  Because Luxon is small(ish), this should stay small and we won't worry about splitting
  it up into, say, parsingUtil.js and basicUtil.js and so on. But they are divided up by feature area.
*/ 

function $37f3a6ffca6d953c$export$fce6876652108ab(o) {
    return typeof o === "undefined";
}
function $37f3a6ffca6d953c$export$7e4aa119212bc614(o) {
    return typeof o === "number";
}
function $37f3a6ffca6d953c$export$a287f47fed4544b8(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $37f3a6ffca6d953c$export$844ec244b1367d54(o) {
    return typeof o === "string";
}
function $37f3a6ffca6d953c$export$871608497c498473(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
function $37f3a6ffca6d953c$export$36c4ef3ee752f47f() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
function $37f3a6ffca6d953c$export$334480083959f08a(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $37f3a6ffca6d953c$export$d322b949ce403225(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce((best, next)=>{
        const pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $37f3a6ffca6d953c$export$357523c63a2253b9(obj, keys) {
    return keys.reduce((a, k)=>{
        a[k] = obj[k];
        return a;
    }, {});
}
function $37f3a6ffca6d953c$export$5a15a386532a5ea4(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function $37f3a6ffca6d953c$export$9fe178c7471c91db(thing, bottom, top) {
    return $37f3a6ffca6d953c$export$a287f47fed4544b8(thing) && thing >= bottom && thing <= top;
}
function $37f3a6ffca6d953c$export$3b34b3b59ac8ca7e(x, n) {
    return x - n * Math.floor(x / n);
}
function $37f3a6ffca6d953c$export$36cf564d487b5178(input, n = 2) {
    const isNeg = input < 0;
    let padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $37f3a6ffca6d953c$export$7181a16950b3209d(string) {
    if ($37f3a6ffca6d953c$export$fce6876652108ab(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $37f3a6ffca6d953c$export$ccc9a81fca9859cb(string) {
    if ($37f3a6ffca6d953c$export$fce6876652108ab(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $37f3a6ffca6d953c$export$3989d60cf160c565(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($37f3a6ffca6d953c$export$fce6876652108ab(fraction) || fraction === null || fraction === "") return undefined;
    else {
        const f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $37f3a6ffca6d953c$export$7978a6ddf29f4374(number, digits, towardZero = false) {
    const factor = 10 ** digits, rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
function $37f3a6ffca6d953c$export$553d7fa8e3805fc0(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $37f3a6ffca6d953c$export$3913210603d8e9ae(year) {
    return $37f3a6ffca6d953c$export$553d7fa8e3805fc0(year) ? 366 : 365;
}
function $37f3a6ffca6d953c$export$4169ecd548fbc13a(year, month) {
    const modMonth = $37f3a6ffca6d953c$export$3b34b3b59ac8ca7e(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $37f3a6ffca6d953c$export$553d7fa8e3805fc0(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
function $37f3a6ffca6d953c$export$c7c54c08b29e0736(obj) {
    let d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        d.setUTCFullYear(d.getUTCFullYear() - 1900);
    }
    return +d;
}
function $37f3a6ffca6d953c$export$fcb8e8d76a6f2959(weekYear) {
    const p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $37f3a6ffca6d953c$export$b7a39e2df70cc6be(year) {
    if (year > 99) return year;
    else return year > 60 ? 1900 + year : 2000 + year;
}
function $37f3a6ffca6d953c$export$897bcc5343b25acd(ts, offsetFormat, locale, timeZone = null) {
    const date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    const modified = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        timeZoneName: offsetFormat
    }, intlOpts);
    const parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find((m)=>m.type.toLowerCase() === "timezonename");
    return parsed ? parsed.value : null;
}
function $37f3a6ffca6d953c$export$f60aa7c70b05722d(offHourStr, offMinuteStr) {
    let offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    const offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
function $37f3a6ffca6d953c$export$37576b9ba69b50db(value) {
    const numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new (0, $886de9df440664a3$export$9c711d4a95378233)(`Invalid unit value ${value}`);
    return numericValue;
}
function $37f3a6ffca6d953c$export$ba17feb4405f3f38(obj, normalizer) {
    const normalized = {};
    for(const u in obj)if ($37f3a6ffca6d953c$export$5a15a386532a5ea4(obj, u)) {
        const v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $37f3a6ffca6d953c$export$37576b9ba69b50db(v);
    }
    return normalized;
}
function $37f3a6ffca6d953c$export$a52dc21079c7600(offset, format) {
    const hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return `${sign}${$37f3a6ffca6d953c$export$36cf564d487b5178(hours, 2)}:${$37f3a6ffca6d953c$export$36cf564d487b5178(minutes, 2)}`;
        case "narrow":
            return `${sign}${hours}${minutes > 0 ? `:${minutes}` : ""}`;
        case "techie":
            return `${sign}${$37f3a6ffca6d953c$export$36cf564d487b5178(hours, 2)}${$37f3a6ffca6d953c$export$36cf564d487b5178(minutes, 2)}`;
        default:
            throw new RangeError(`Value format ${format} is out of range for property format`);
    }
}
function $37f3a6ffca6d953c$export$4401ec2a884d3d6f(obj) {
    return $37f3a6ffca6d953c$export$357523c63a2253b9(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
const $37f3a6ffca6d953c$export$fa4795673f93e132 = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;


function $26d169874dd3df9b$var$stringify(obj) {
    return JSON.stringify(obj, Object.keys(obj).sort());
}
const $26d169874dd3df9b$export$2bb3eb27682a776 = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $26d169874dd3df9b$export$b4b23bfab2f68498 = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
const $26d169874dd3df9b$export$db1cae8e85a8ede0 = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $26d169874dd3df9b$export$16352d1b10c5eb38(length) {
    switch(length){
        case "narrow":
            return [
                ...$26d169874dd3df9b$export$db1cae8e85a8ede0
            ];
        case "short":
            return [
                ...$26d169874dd3df9b$export$b4b23bfab2f68498
            ];
        case "long":
            return [
                ...$26d169874dd3df9b$export$2bb3eb27682a776
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
const $26d169874dd3df9b$export$406f4855508be663 = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
const $26d169874dd3df9b$export$d89a20b736c12a21 = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
const $26d169874dd3df9b$export$2997fd2e8025c4fc = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $26d169874dd3df9b$export$21e30707d27594c3(length) {
    switch(length){
        case "narrow":
            return [
                ...$26d169874dd3df9b$export$2997fd2e8025c4fc
            ];
        case "short":
            return [
                ...$26d169874dd3df9b$export$d89a20b736c12a21
            ];
        case "long":
            return [
                ...$26d169874dd3df9b$export$406f4855508be663
            ];
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
const $26d169874dd3df9b$export$94f480e07472beac = [
    "AM",
    "PM"
];
const $26d169874dd3df9b$export$a3539dc50fc6cc47 = [
    "Before Christ",
    "Anno Domini"
];
const $26d169874dd3df9b$export$a8f63c83729947a4 = [
    "BC",
    "AD"
];
const $26d169874dd3df9b$export$2b0880176b7ca6fb = [
    "B",
    "A"
];
function $26d169874dd3df9b$export$41e043ce18349ee8(length) {
    switch(length){
        case "narrow":
            return [
                ...$26d169874dd3df9b$export$2b0880176b7ca6fb
            ];
        case "short":
            return [
                ...$26d169874dd3df9b$export$a8f63c83729947a4
            ];
        case "long":
            return [
                ...$26d169874dd3df9b$export$a3539dc50fc6cc47
            ];
        default:
            return null;
    }
}
function $26d169874dd3df9b$export$fbaec5aff3c47ddc(dt) {
    return $26d169874dd3df9b$export$94f480e07472beac[dt.hour < 12 ? 0 : 1];
}
function $26d169874dd3df9b$export$a48176098d281ad2(dt, length) {
    return $26d169874dd3df9b$export$21e30707d27594c3(length)[dt.weekday - 1];
}
function $26d169874dd3df9b$export$5d07d42a611abcf2(dt, length) {
    return $26d169874dd3df9b$export$16352d1b10c5eb38(length)[dt.month - 1];
}
function $26d169874dd3df9b$export$3394b151c30b498b(dt, length) {
    return $26d169874dd3df9b$export$41e043ce18349ee8(length)[dt.year < 0 ? 0 : 1];
}
function $26d169874dd3df9b$export$b4ea3b48dcf921f6(unit, count, numeric = "always", narrow = false) {
    const units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    const lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        const isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : `next ${units[unit][0]}`;
            case -1:
                return isDay ? "yesterday" : `last ${units[unit][0]}`;
            case 0:
                return isDay ? "today" : `this ${units[unit][0]}`;
            default:
        }
    }
    const isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? `${fmtValue} ${fmtUnit} ago` : `in ${fmtValue} ${fmtUnit}`;
}
function $26d169874dd3df9b$export$1aa7d7568ce4670d(knownFormat) {
    // these all have the offsets removed because we don't have access to them
    // without all the intl stuff this is backfilling
    const filtered = (0, $37f3a6ffca6d953c$export$357523c63a2253b9)(knownFormat, [
        "weekday",
        "era",
        "year",
        "month",
        "day",
        "hour",
        "minute",
        "second",
        "timeZoneName",
        "hourCycle"
    ]), key = $26d169874dd3df9b$var$stringify(filtered), dateTimeHuge = "EEEE, LLLL d, yyyy, h:mm a";
    switch(key){
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$19db5ed0dfbf6b4):
            return "M/d/yyyy";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$7f19f128b5a661d5):
            return "LLL d, yyyy";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$7afd5e65ff14ad5f):
            return "EEE, LLL d, yyyy";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$e8af1c0b0290dbe2):
            return "LLLL d, yyyy";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$ab5c0d098dcfe775):
            return "EEEE, LLLL d, yyyy";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$b4941e7fc62df1ff):
            return "h:mm a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$61c7c50acaa56067):
            return "h:mm:ss a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$417ed025e483567):
            return "h:mm a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$e0d12640fceb849c):
            return "h:mm a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$7333d0894ea2a492):
            return "HH:mm";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$2664018dfbf7eca):
            return "HH:mm:ss";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$3f5c467c8b3c85f6):
            return "HH:mm";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$edc722d6385d5cfa):
            return "HH:mm";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$434cdda648f6d8ed):
            return "M/d/yyyy, h:mm a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$2a10deefdeef9026):
            return "LLL d, yyyy, h:mm a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$6fbcfb06dd40694b):
            return "LLLL d, yyyy, h:mm a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$c01f9be9042ca6d2):
            return dateTimeHuge;
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$115df8ec21cc4422):
            return "M/d/yyyy, h:mm:ss a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$652ead5a5aee93d0):
            return "LLL d, yyyy, h:mm:ss a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$97006f3c2fab9954):
            return "EEE, d LLL yyyy, h:mm a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$9ae9ad238dcfe6df):
            return "LLLL d, yyyy, h:mm:ss a";
        case $26d169874dd3df9b$var$stringify($58f58a4a5bb96d49$export$c3b12c6a0fb1f516):
            return "EEEE, LLLL d, yyyy, h:mm:ss a";
        default:
            return dateTimeHuge;
    }
}




function $35e0b627fa211618$var$stringifyTokens(splits, tokenToString) {
    let s = "";
    for (const token of splits)if (token.literal) s += token.val;
    else s += tokenToString(token.val);
    return s;
}
const $35e0b627fa211618$var$macroTokenToFormatOpts = {
    D: $58f58a4a5bb96d49$export$19db5ed0dfbf6b4,
    DD: $58f58a4a5bb96d49$export$7f19f128b5a661d5,
    DDD: $58f58a4a5bb96d49$export$e8af1c0b0290dbe2,
    DDDD: $58f58a4a5bb96d49$export$ab5c0d098dcfe775,
    t: $58f58a4a5bb96d49$export$b4941e7fc62df1ff,
    tt: $58f58a4a5bb96d49$export$61c7c50acaa56067,
    ttt: $58f58a4a5bb96d49$export$417ed025e483567,
    tttt: $58f58a4a5bb96d49$export$e0d12640fceb849c,
    T: $58f58a4a5bb96d49$export$7333d0894ea2a492,
    TT: $58f58a4a5bb96d49$export$2664018dfbf7eca,
    TTT: $58f58a4a5bb96d49$export$3f5c467c8b3c85f6,
    TTTT: $58f58a4a5bb96d49$export$edc722d6385d5cfa,
    f: $58f58a4a5bb96d49$export$434cdda648f6d8ed,
    ff: $58f58a4a5bb96d49$export$2a10deefdeef9026,
    fff: $58f58a4a5bb96d49$export$6fbcfb06dd40694b,
    ffff: $58f58a4a5bb96d49$export$c01f9be9042ca6d2,
    F: $58f58a4a5bb96d49$export$115df8ec21cc4422,
    FF: $58f58a4a5bb96d49$export$652ead5a5aee93d0,
    FFF: $58f58a4a5bb96d49$export$9ae9ad238dcfe6df,
    FFFF: $58f58a4a5bb96d49$export$c3b12c6a0fb1f516
};
class $35e0b627fa211618$export$2e2bcd8739ae039 {
    static create(locale, opts = {}) {
        return new $35e0b627fa211618$export$2e2bcd8739ae039(locale, opts);
    }
    static parseFormat(fmt) {
        let current = null, currentFull = "", bracketed = false;
        const splits = [];
        for(let i = 0; i < fmt.length; i++){
            const c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed,
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: false,
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed,
            val: currentFull
        });
        return splits;
    }
    static macroTokenToFormatOpts(token) {
        return $35e0b627fa211618$var$macroTokenToFormatOpts[token];
    }
    formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        const df = this.systemLoc.dtFormatter(dt, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.opts, opts));
        return df.format();
    }
    formatDateTime(dt, opts = {}) {
        const df = this.loc.dtFormatter(dt, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.opts, opts));
        return df.format();
    }
    formatDateTimeParts(dt, opts = {}) {
        const df = this.loc.dtFormatter(dt, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.opts, opts));
        return df.formatToParts();
    }
    resolvedOptions(dt, opts = {}) {
        const df = this.loc.dtFormatter(dt, (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.opts, opts));
        return df.resolvedOptions();
    }
    num(n, p = 0) {
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(n, p);
        const opts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    }
    formatDateTimeFromString(dt, fmt) {
        const knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = (opts, extract)=>this.loc.extract(dt, opts, extract), formatOffset = (opts)=>{
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = ()=>knownEnglish ? $26d169874dd3df9b$export$fbaec5aff3c47ddc(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod"), month = (length, standalone)=>knownEnglish ? $26d169874dd3df9b$export$5d07d42a611abcf2(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month"), weekday = (length, standalone)=>knownEnglish ? $26d169874dd3df9b$export$a48176098d281ad2(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday"), maybeMacro = (token)=>{
            const formatOpts = $35e0b627fa211618$export$2e2bcd8739ae039.macroTokenToFormatOpts(token);
            if (formatOpts) return this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = (length)=>knownEnglish ? $26d169874dd3df9b$export$3394b151c30b498b(dt, length) : string({
                era: length
            }, "era"), tokenToString = (token)=>{
            // Where possible: http://cldr.unicode.org/translation/date-time-1/date-time#TOC-Standalone-vs.-Format-Styles
            switch(token){
                // ms
                case "S":
                    return this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return this.num(dt.second);
                case "ss":
                    return this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return this.num(dt.minute);
                case "mm":
                    return this.num(dt.minute, 2);
                // hours
                case "h":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return this.num(dt.hour);
                case "HH":
                    return this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return this.num(dt.weekYear, 4);
                case "W":
                    return this.num(dt.weekNumber);
                case "WW":
                    return this.num(dt.weekNumber, 2);
                case "o":
                    return this.num(dt.ordinal);
                case "ooo":
                    return this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return this.num(dt.quarter);
                case "qq":
                    // like 01
                    return this.num(dt.quarter, 2);
                case "X":
                    return this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $35e0b627fa211618$var$stringifyTokens($35e0b627fa211618$export$2e2bcd8739ae039.parseFormat(fmt), tokenToString);
    }
    formatDurationFromString(dur, fmt) {
        const tokenToField = (token)=>{
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = (lildur)=>(token)=>{
                const mapped = tokenToField(token);
                if (mapped) return this.num(lildur.get(mapped), token.length);
                else return token;
            }, tokens = $35e0b627fa211618$export$2e2bcd8739ae039.parseFormat(fmt), realTokens = tokens.reduce((found, { literal: literal, val: val })=>literal ? found : found.concat(val), []), collapsed = dur.shiftTo(...realTokens.map(tokenToField).filter((t)=>t));
        return $35e0b627fa211618$var$stringifyTokens(tokens, tokenToString(collapsed));
    }
    constructor(locale, formatOpts){
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
}


class $5f1edb5a58b87e86$export$2e2bcd8739ae039 {
    toMessage() {
        if (this.explanation) return `${this.reason}: ${this.explanation}`;
        else return this.reason;
    }
    constructor(reason, explanation){
        this.reason = reason;
        this.explanation = explanation;
    }
}









class $46dc25b196618c0e$export$2e2bcd8739ae039 {
    /**
   * The type of zone
   * @abstract
   * @type {string}
   */ get type() {
        throw new (0, $886de9df440664a3$export$b0a664b8a649f992)();
    }
    /**
   * The name of this zone.
   * @abstract
   * @type {string}
   */ get name() {
        throw new (0, $886de9df440664a3$export$b0a664b8a649f992)();
    }
    get ianaName() {
        return this.name;
    }
    /**
   * Returns whether the offset is known to be fixed for the whole year.
   * @abstract
   * @type {boolean}
   */ get isUniversal() {
        throw new (0, $886de9df440664a3$export$b0a664b8a649f992)();
    }
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ offsetName(ts, opts) {
        throw new (0, $886de9df440664a3$export$b0a664b8a649f992)();
    }
    /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ formatOffset(ts, format) {
        throw new (0, $886de9df440664a3$export$b0a664b8a649f992)();
    }
    /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ offset(ts) {
        throw new (0, $886de9df440664a3$export$b0a664b8a649f992)();
    }
    /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ equals(otherZone) {
        throw new (0, $886de9df440664a3$export$b0a664b8a649f992)();
    }
    /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ get isValid() {
        throw new (0, $886de9df440664a3$export$b0a664b8a649f992)();
    }
}


let $373507541b289b2f$var$singleton = null;
class $373507541b289b2f$export$2e2bcd8739ae039 extends (0, $46dc25b196618c0e$export$2e2bcd8739ae039) {
    /**
   * Get a singleton instance of the local zone
   * @return {SystemZone}
   */ static get instance() {
        if ($373507541b289b2f$var$singleton === null) $373507541b289b2f$var$singleton = new $373507541b289b2f$export$2e2bcd8739ae039();
        return $373507541b289b2f$var$singleton;
    }
    /** @override **/ get type() {
        return "system";
    }
    /** @override **/ get name() {
        return new Intl.DateTimeFormat().resolvedOptions().timeZone;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName(ts, { format: format, locale: locale }) {
        return (0, $37f3a6ffca6d953c$export$897bcc5343b25acd)(ts, format, locale);
    }
    /** @override **/ formatOffset(ts, format) {
        return (0, $37f3a6ffca6d953c$export$a52dc21079c7600)(this.offset(ts), format);
    }
    /** @override **/ offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    }
    /** @override **/ equals(otherZone) {
        return otherZone.type === "system";
    }
    /** @override **/ get isValid() {
        return true;
    }
}




let $950478f3e6f849c2$var$dtfCache = {};
function $950478f3e6f849c2$var$makeDTF(zone) {
    if (!$950478f3e6f849c2$var$dtfCache[zone]) $950478f3e6f849c2$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $950478f3e6f849c2$var$dtfCache[zone];
}
const $950478f3e6f849c2$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $950478f3e6f849c2$var$hackyOffset(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), [, fMonth, fDay, fYear, fadOrBc, fHour, fMinute, fSecond] = parsed;
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $950478f3e6f849c2$var$partsOffset(dtf, date) {
    const formatted = dtf.formatToParts(date);
    const filled = [];
    for(let i = 0; i < formatted.length; i++){
        const { type: type, value: value } = formatted[i];
        const pos = $950478f3e6f849c2$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!(0, $37f3a6ffca6d953c$export$fce6876652108ab)(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
let $950478f3e6f849c2$var$ianaZoneCache = {};
class $950478f3e6f849c2$export$2e2bcd8739ae039 extends (0, $46dc25b196618c0e$export$2e2bcd8739ae039) {
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ static create(name) {
        if (!$950478f3e6f849c2$var$ianaZoneCache[name]) $950478f3e6f849c2$var$ianaZoneCache[name] = new $950478f3e6f849c2$export$2e2bcd8739ae039(name);
        return $950478f3e6f849c2$var$ianaZoneCache[name];
    }
    /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCache() {
        $950478f3e6f849c2$var$ianaZoneCache = {};
        $950478f3e6f849c2$var$dtfCache = {};
    }
    /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */ static isValidSpecifier(s) {
        return this.isValidZone(s);
    }
    /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ static isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    }
    /** @override **/ get type() {
        return "iana";
    }
    /** @override **/ get name() {
        return this.zoneName;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName(ts, { format: format, locale: locale }) {
        return (0, $37f3a6ffca6d953c$export$897bcc5343b25acd)(ts, format, locale, this.name);
    }
    /** @override **/ formatOffset(ts, format) {
        return (0, $37f3a6ffca6d953c$export$a52dc21079c7600)(this.offset(ts), format);
    }
    /** @override **/ offset(ts) {
        const date = new Date(ts);
        if (isNaN(date)) return NaN;
        const dtf = $950478f3e6f849c2$var$makeDTF(this.name);
        let [year, month, day, adOrBc, hour, minute, second] = dtf.formatToParts ? $950478f3e6f849c2$var$partsOffset(dtf, date) : $950478f3e6f849c2$var$hackyOffset(dtf, date);
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        const adjustedHour = hour === 24 ? 0 : hour;
        const asUTC = (0, $37f3a6ffca6d953c$export$c7c54c08b29e0736)({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        let asTS = +date;
        const over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    }
    /** @override **/ equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    }
    /** @override **/ get isValid() {
        return this.valid;
    }
    constructor(name){
        super();
        /** @private **/ this.zoneName = name;
        /** @private **/ this.valid = $950478f3e6f849c2$export$2e2bcd8739ae039.isValidZone(name);
    }
}



/**
 * @private
 */ 



let $be616c40eb3ec295$var$singleton = null;
class $be616c40eb3ec295$export$2e2bcd8739ae039 extends (0, $46dc25b196618c0e$export$2e2bcd8739ae039) {
    /**
   * Get a singleton instance of UTC
   * @return {FixedOffsetZone}
   */ static get utcInstance() {
        if ($be616c40eb3ec295$var$singleton === null) $be616c40eb3ec295$var$singleton = new $be616c40eb3ec295$export$2e2bcd8739ae039(0);
        return $be616c40eb3ec295$var$singleton;
    }
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ static instance(offset) {
        return offset === 0 ? $be616c40eb3ec295$export$2e2bcd8739ae039.utcInstance : new $be616c40eb3ec295$export$2e2bcd8739ae039(offset);
    }
    /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ static parseSpecifier(s) {
        if (s) {
            const r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new $be616c40eb3ec295$export$2e2bcd8739ae039((0, $37f3a6ffca6d953c$export$f60aa7c70b05722d)(r[1], r[2]));
        }
        return null;
    }
    /** @override **/ get type() {
        return "fixed";
    }
    /** @override **/ get name() {
        return this.fixed === 0 ? "UTC" : `UTC${(0, $37f3a6ffca6d953c$export$a52dc21079c7600)(this.fixed, "narrow")}`;
    }
    get ianaName() {
        if (this.fixed === 0) return "Etc/UTC";
        else return `Etc/GMT${(0, $37f3a6ffca6d953c$export$a52dc21079c7600)(-this.fixed, "narrow")}`;
    }
    /** @override **/ offsetName() {
        return this.name;
    }
    /** @override **/ formatOffset(ts, format) {
        return (0, $37f3a6ffca6d953c$export$a52dc21079c7600)(this.fixed, format);
    }
    /** @override **/ get isUniversal() {
        return true;
    }
    /** @override **/ offset() {
        return this.fixed;
    }
    /** @override **/ equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    }
    /** @override **/ get isValid() {
        return true;
    }
    constructor(offset){
        super();
        /** @private **/ this.fixed = offset;
    }
}



class $3c157faeb195a6ae$export$2e2bcd8739ae039 extends (0, $46dc25b196618c0e$export$2e2bcd8739ae039) {
    /** @override **/ get type() {
        return "invalid";
    }
    /** @override **/ get name() {
        return this.zoneName;
    }
    /** @override **/ get isUniversal() {
        return false;
    }
    /** @override **/ offsetName() {
        return null;
    }
    /** @override **/ formatOffset() {
        return "";
    }
    /** @override **/ offset() {
        return NaN;
    }
    /** @override **/ equals() {
        return false;
    }
    /** @override **/ get isValid() {
        return false;
    }
    constructor(zoneName){
        super();
        /**  @private */ this.zoneName = zoneName;
    }
}



function $d46f30efbf427e5a$export$4527f24d1e617e9(input, defaultZone) {
    let offset;
    if ((0, $37f3a6ffca6d953c$export$fce6876652108ab)(input) || input === null) return defaultZone;
    else if (input instanceof (0, $46dc25b196618c0e$export$2e2bcd8739ae039)) return input;
    else if ((0, $37f3a6ffca6d953c$export$844ec244b1367d54)(input)) {
        const lowered = input.toLowerCase();
        if (lowered === "local" || lowered === "system") return defaultZone;
        else if (lowered === "utc" || lowered === "gmt") return (0, $be616c40eb3ec295$export$2e2bcd8739ae039).utcInstance;
        else return (0, $be616c40eb3ec295$export$2e2bcd8739ae039).parseSpecifier(lowered) || (0, $950478f3e6f849c2$export$2e2bcd8739ae039).create(input);
    } else if ((0, $37f3a6ffca6d953c$export$7e4aa119212bc614)(input)) return (0, $be616c40eb3ec295$export$2e2bcd8739ae039).instance(input);
    else if (typeof input === "object" && input.offset && typeof input.offset === "number") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new (0, $3c157faeb195a6ae$export$2e2bcd8739ae039)(input);
}


let $30b5604947d63dd3$var$now = ()=>Date.now(), $30b5604947d63dd3$var$defaultZone = "system", $30b5604947d63dd3$var$defaultLocale = null, $30b5604947d63dd3$var$defaultNumberingSystem = null, $30b5604947d63dd3$var$defaultOutputCalendar = null, $30b5604947d63dd3$var$throwOnInvalid;
class $30b5604947d63dd3$export$2e2bcd8739ae039 {
    /**
   * Get the callback for returning the current timestamp.
   * @type {function}
   */ static get now() {
        return $30b5604947d63dd3$var$now;
    }
    /**
   * Set the callback for returning the current timestamp.
   * The function should return a number, which will be interpreted as an Epoch millisecond count
   * @type {function}
   * @example Settings.now = () => Date.now() + 3000 // pretend it is 3 seconds in the future
   * @example Settings.now = () => 0 // always pretend it's Jan 1, 1970 at midnight in UTC time
   */ static set now(n) {
        $30b5604947d63dd3$var$now = n;
    }
    /**
   * Set the default time zone to create DateTimes in. Does not affect existing instances.
   * Use the value "system" to reset this value to the system's time zone.
   * @type {string}
   */ static set defaultZone(zone) {
        $30b5604947d63dd3$var$defaultZone = zone;
    }
    /**
   * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
   * The default value is the system's time zone (the one set on the machine that runs this code).
   * @type {Zone}
   */ static get defaultZone() {
        return (0, $d46f30efbf427e5a$export$4527f24d1e617e9)($30b5604947d63dd3$var$defaultZone, (0, $373507541b289b2f$export$2e2bcd8739ae039).instance);
    }
    /**
   * Get the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultLocale() {
        return $30b5604947d63dd3$var$defaultLocale;
    }
    /**
   * Set the default locale to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultLocale(locale) {
        $30b5604947d63dd3$var$defaultLocale = locale;
    }
    /**
   * Get the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultNumberingSystem() {
        return $30b5604947d63dd3$var$defaultNumberingSystem;
    }
    /**
   * Set the default numbering system to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultNumberingSystem(numberingSystem) {
        $30b5604947d63dd3$var$defaultNumberingSystem = numberingSystem;
    }
    /**
   * Get the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static get defaultOutputCalendar() {
        return $30b5604947d63dd3$var$defaultOutputCalendar;
    }
    /**
   * Set the default output calendar to create DateTimes with. Does not affect existing instances.
   * @type {string}
   */ static set defaultOutputCalendar(outputCalendar) {
        $30b5604947d63dd3$var$defaultOutputCalendar = outputCalendar;
    }
    /**
   * Get whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static get throwOnInvalid() {
        return $30b5604947d63dd3$var$throwOnInvalid;
    }
    /**
   * Set whether Luxon will throw when it encounters invalid DateTimes, Durations, or Intervals
   * @type {boolean}
   */ static set throwOnInvalid(t) {
        $30b5604947d63dd3$var$throwOnInvalid = t;
    }
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ static resetCaches() {
        (0, $e692b3aca11585b0$export$2e2bcd8739ae039).resetCache();
        (0, $950478f3e6f849c2$export$2e2bcd8739ae039).resetCache();
    }
}




// todo - remap caching
let $e692b3aca11585b0$var$intlLFCache = {};
function $e692b3aca11585b0$var$getCachedLF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = $e692b3aca11585b0$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $e692b3aca11585b0$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
let $e692b3aca11585b0$var$intlDTCache = {};
function $e692b3aca11585b0$var$getCachedDTF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let dtf = $e692b3aca11585b0$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $e692b3aca11585b0$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
let $e692b3aca11585b0$var$intlNumCache = {};
function $e692b3aca11585b0$var$getCachedINF(locString, opts = {}) {
    const key = JSON.stringify([
        locString,
        opts
    ]);
    let inf = $e692b3aca11585b0$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $e692b3aca11585b0$var$intlNumCache[key] = inf;
    }
    return inf;
}
let $e692b3aca11585b0$var$intlRelCache = {};
function $e692b3aca11585b0$var$getCachedRTF(locString, opts = {}) {
    const { base: base } = opts, cacheKeyOpts = (0, $8901fc92b5563702$export$71511d61b312f219)(opts, [
        "base"
    ]); // exclude `base` from the options
    const key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    let inf = $e692b3aca11585b0$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $e692b3aca11585b0$var$intlRelCache[key] = inf;
    }
    return inf;
}
let $e692b3aca11585b0$var$sysLocaleCache = null;
function $e692b3aca11585b0$var$systemLocale() {
    if ($e692b3aca11585b0$var$sysLocaleCache) return $e692b3aca11585b0$var$sysLocaleCache;
    else {
        $e692b3aca11585b0$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $e692b3aca11585b0$var$sysLocaleCache;
    }
}
function $e692b3aca11585b0$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    const uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        let options;
        const smaller = localeStr.substring(0, uIndex);
        try {
            options = $e692b3aca11585b0$var$getCachedDTF(localeStr).resolvedOptions();
        } catch (e) {
            options = $e692b3aca11585b0$var$getCachedDTF(smaller).resolvedOptions();
        }
        const { numberingSystem: numberingSystem, calendar: calendar } = options;
        // return the smaller one so that we can append the calendar and numbering overrides to it
        return [
            smaller,
            numberingSystem,
            calendar
        ];
    }
}
function $e692b3aca11585b0$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        localeStr += "-u";
        if (outputCalendar) localeStr += `-ca-${outputCalendar}`;
        if (numberingSystem) localeStr += `-nu-${numberingSystem}`;
        return localeStr;
    } else return localeStr;
}
function $e692b3aca11585b0$var$mapMonths(f) {
    const ms = [];
    for(let i = 1; i <= 12; i++){
        const dt = (0, $485b75493327b6f7$export$2e2bcd8739ae039).utc(2016, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $e692b3aca11585b0$var$mapWeekdays(f) {
    const ms = [];
    for(let i = 1; i <= 7; i++){
        const dt = (0, $485b75493327b6f7$export$2e2bcd8739ae039).utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $e692b3aca11585b0$var$listStuff(loc, length, defaultOK, englishFn, intlFn) {
    const mode = loc.listingMode(defaultOK);
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $e692b3aca11585b0$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ class $e692b3aca11585b0$var$PolyNumberFormatter {
    format(i) {
        if (this.inf) {
            const fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            const fixed = this.floor ? Math.floor(i) : (0, $37f3a6ffca6d953c$export$7978a6ddf29f4374)(i, 3);
            return (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(fixed, this.padTo);
        }
    }
    constructor(intl, forceSimple, opts){
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        const { padTo: padTo, floor: floor } = opts, otherOpts = (0, $8901fc92b5563702$export$71511d61b312f219)(opts, [
            "padTo",
            "floor"
        ]);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            const intlOpts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $e692b3aca11585b0$var$getCachedINF(intl, intlOpts);
        }
    }
}
/**
 * @private
 */ class $e692b3aca11585b0$var$PolyDateFormatter {
    format() {
        return this.dtf.format(this.dt.toJSDate());
    }
    formatToParts() {
        return this.dtf.formatToParts(this.dt.toJSDate());
    }
    resolvedOptions() {
        return this.dtf.resolvedOptions();
    }
    constructor(dt, intl, opts){
        this.opts = opts;
        let z;
        if (dt.zone.isUniversal) {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            const gmtOffset = -1 * (dt.offset / 60);
            const offsetZ = gmtOffset >= 0 ? `Etc/GMT+${gmtOffset}` : `Etc/GMT${gmtOffset}`;
            if (dt.offset !== 0 && (0, $950478f3e6f849c2$export$2e2bcd8739ae039).create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata.
                // So we have to make do. Two cases:
                // 1. The format options tell us to show the zone. We can't do that, so the best
                // we can do is format the date in UTC.
                // 2. The format options don't tell us to show the zone. Then we can adjust them
                // the time and tell the formatter to show it to us in UTC, so that the time is right
                // and the bad zone doesn't show up.
                z = "UTC";
                if (opts.timeZoneName) this.dt = dt;
                else this.dt = dt.offset === 0 ? dt : (0, $485b75493327b6f7$export$2e2bcd8739ae039).fromMillis(dt.ts + dt.offset * 60000);
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else {
            this.dt = dt;
            z = dt.zone.name;
        }
        const intlOpts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.opts);
        if (z) intlOpts.timeZone = z;
        this.dtf = $e692b3aca11585b0$var$getCachedDTF(intl, intlOpts);
    }
}
/**
 * @private
 */ class $e692b3aca11585b0$var$PolyRelFormatter {
    format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $26d169874dd3df9b$export$b4ea3b48dcf921f6(unit, count, this.opts.numeric, this.opts.style !== "long");
    }
    formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    }
    constructor(intl, isEnglish, opts){
        this.opts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            style: "long"
        }, opts);
        if (!isEnglish && (0, $37f3a6ffca6d953c$export$36c4ef3ee752f47f)()) this.rtf = $e692b3aca11585b0$var$getCachedRTF(intl, opts);
    }
}
class $e692b3aca11585b0$export$2e2bcd8739ae039 {
    static fromOpts(opts) {
        return $e692b3aca11585b0$export$2e2bcd8739ae039.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    }
    static create(locale, numberingSystem, outputCalendar, defaultToEN = false) {
        const specifiedLocale = locale || (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultLocale;
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        const localeR = specifiedLocale || (defaultToEN ? "en-US" : $e692b3aca11585b0$var$systemLocale());
        const numberingSystemR = numberingSystem || (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultNumberingSystem;
        const outputCalendarR = outputCalendar || (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultOutputCalendar;
        return new $e692b3aca11585b0$export$2e2bcd8739ae039(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    }
    static resetCache() {
        $e692b3aca11585b0$var$sysLocaleCache = null;
        $e692b3aca11585b0$var$intlDTCache = {};
        $e692b3aca11585b0$var$intlNumCache = {};
        $e692b3aca11585b0$var$intlRelCache = {};
    }
    static fromObject({ locale: locale, numberingSystem: numberingSystem, outputCalendar: outputCalendar } = {}) {
        return $e692b3aca11585b0$export$2e2bcd8739ae039.create(locale, numberingSystem, outputCalendar);
    }
    get fastNumbers() {
        if (this.fastNumbersCached == null) this.fastNumbersCached = $e692b3aca11585b0$var$supportsFastNumbers(this);
        return this.fastNumbersCached;
    }
    listingMode() {
        const isActuallyEn = this.isEnglish();
        const hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    }
    clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return $e692b3aca11585b0$export$2e2bcd8739ae039.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    }
    redefaultToEN(alts = {}) {
        return this.clone((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, alts), {
            defaultToEN: true
        }));
    }
    redefaultToSystem(alts = {}) {
        return this.clone((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, alts), {
            defaultToEN: false
        }));
    }
    months(length, format = false, defaultOK = true) {
        return $e692b3aca11585b0$var$listStuff(this, length, defaultOK, $26d169874dd3df9b$export$16352d1b10c5eb38, ()=>{
            const intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.monthsCache[formatStr][length]) this.monthsCache[formatStr][length] = $e692b3aca11585b0$var$mapMonths((dt)=>this.extract(dt, intl, "month"));
            return this.monthsCache[formatStr][length];
        });
    }
    weekdays(length, format = false, defaultOK = true) {
        return $e692b3aca11585b0$var$listStuff(this, length, defaultOK, $26d169874dd3df9b$export$21e30707d27594c3, ()=>{
            const intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!this.weekdaysCache[formatStr][length]) this.weekdaysCache[formatStr][length] = $e692b3aca11585b0$var$mapWeekdays((dt)=>this.extract(dt, intl, "weekday"));
            return this.weekdaysCache[formatStr][length];
        });
    }
    meridiems(defaultOK = true) {
        return $e692b3aca11585b0$var$listStuff(this, undefined, defaultOK, ()=>$26d169874dd3df9b$export$94f480e07472beac, ()=>{
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!this.meridiemCache) {
                const intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                this.meridiemCache = [
                    (0, $485b75493327b6f7$export$2e2bcd8739ae039).utc(2016, 11, 13, 9),
                    (0, $485b75493327b6f7$export$2e2bcd8739ae039).utc(2016, 11, 13, 19)
                ].map((dt)=>this.extract(dt, intl, "dayperiod"));
            }
            return this.meridiemCache;
        });
    }
    eras(length, defaultOK = true) {
        return $e692b3aca11585b0$var$listStuff(this, length, defaultOK, $26d169874dd3df9b$export$41e043ce18349ee8, ()=>{
            const intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!this.eraCache[length]) this.eraCache[length] = [
                (0, $485b75493327b6f7$export$2e2bcd8739ae039).utc(-40, 1, 1),
                (0, $485b75493327b6f7$export$2e2bcd8739ae039).utc(2017, 1, 1)
            ].map((dt)=>this.extract(dt, intl, "era"));
            return this.eraCache[length];
        });
    }
    extract(dt, intlOpts, field) {
        const df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find((m)=>m.type.toLowerCase() === field);
        return matching ? matching.value : null;
    }
    numberFormatter(opts = {}) {
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $e692b3aca11585b0$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    }
    dtFormatter(dt, intlOpts = {}) {
        return new $e692b3aca11585b0$var$PolyDateFormatter(dt, this.intl, intlOpts);
    }
    relFormatter(opts = {}) {
        return new $e692b3aca11585b0$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    }
    listFormatter(opts = {}) {
        return $e692b3aca11585b0$var$getCachedLF(this.intl, opts);
    }
    isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    }
    equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    }
    constructor(locale, numbering, outputCalendar, specifiedLocale){
        const [parsedLocale, parsedNumberingSystem, parsedOutputCalendar] = $e692b3aca11585b0$var$parseLocaleString(locale);
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $e692b3aca11585b0$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
}







/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ function $d9e03d2ca5209f90$var$combineRegexes(...regexes) {
    const full = regexes.reduce((f, r)=>f + r.source, "");
    return RegExp(`^${full}$`);
}
function $d9e03d2ca5209f90$var$combineExtractors(...extractors) {
    return (m)=>extractors.reduce(([mergedVals, mergedZone, cursor], ex)=>{
            const [val, zone, next] = ex(m, cursor);
            return [
                (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
}
function $d9e03d2ca5209f90$var$parse(s, ...patterns) {
    if (s == null) return [
        null,
        null
    ];
    for (const [regex, extractor] of patterns){
        const m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $d9e03d2ca5209f90$var$simpleParse(...keys) {
    return (match, cursor)=>{
        const ret = {};
        let i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = (0, $37f3a6ffca6d953c$export$7181a16950b3209d)(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
const $d9e03d2ca5209f90$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
const $d9e03d2ca5209f90$var$isoExtendedZone = `(?:${$d9e03d2ca5209f90$var$offsetRegex.source}?(?:\\[(${(0, $37f3a6ffca6d953c$export$fa4795673f93e132).source})\\])?)?`;
const $d9e03d2ca5209f90$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
const $d9e03d2ca5209f90$var$isoTimeRegex = RegExp(`${$d9e03d2ca5209f90$var$isoTimeBaseRegex.source}${$d9e03d2ca5209f90$var$isoExtendedZone}`);
const $d9e03d2ca5209f90$var$isoTimeExtensionRegex = RegExp(`(?:T${$d9e03d2ca5209f90$var$isoTimeRegex.source})?`);
const $d9e03d2ca5209f90$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
const $d9e03d2ca5209f90$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
const $d9e03d2ca5209f90$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
const $d9e03d2ca5209f90$var$extractISOWeekData = $d9e03d2ca5209f90$var$simpleParse("weekYear", "weekNumber", "weekDay");
const $d9e03d2ca5209f90$var$extractISOOrdinalData = $d9e03d2ca5209f90$var$simpleParse("year", "ordinal");
const $d9e03d2ca5209f90$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
const $d9e03d2ca5209f90$var$sqlTimeRegex = RegExp(`${$d9e03d2ca5209f90$var$isoTimeBaseRegex.source} ?(?:${$d9e03d2ca5209f90$var$offsetRegex.source}|(${(0, $37f3a6ffca6d953c$export$fa4795673f93e132).source}))?`);
const $d9e03d2ca5209f90$var$sqlTimeExtensionRegex = RegExp(`(?: ${$d9e03d2ca5209f90$var$sqlTimeRegex.source})?`);
function $d9e03d2ca5209f90$var$int(match, pos, fallback) {
    const m = match[pos];
    return (0, $37f3a6ffca6d953c$export$fce6876652108ab)(m) ? fallback : (0, $37f3a6ffca6d953c$export$7181a16950b3209d)(m);
}
function $d9e03d2ca5209f90$var$extractISOYmd(match, cursor) {
    const item = {
        year: $d9e03d2ca5209f90$var$int(match, cursor),
        month: $d9e03d2ca5209f90$var$int(match, cursor + 1, 1),
        day: $d9e03d2ca5209f90$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $d9e03d2ca5209f90$var$extractISOTime(match, cursor) {
    const item = {
        hours: $d9e03d2ca5209f90$var$int(match, cursor, 0),
        minutes: $d9e03d2ca5209f90$var$int(match, cursor + 1, 0),
        seconds: $d9e03d2ca5209f90$var$int(match, cursor + 2, 0),
        milliseconds: (0, $37f3a6ffca6d953c$export$3989d60cf160c565)(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $d9e03d2ca5209f90$var$extractISOOffset(match, cursor) {
    const local = !match[cursor] && !match[cursor + 1], fullOffset = (0, $37f3a6ffca6d953c$export$f60aa7c70b05722d)(match[cursor + 1], match[cursor + 2]), zone = local ? null : (0, $be616c40eb3ec295$export$2e2bcd8739ae039).instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $d9e03d2ca5209f90$var$extractIANAZone(match, cursor) {
    const zone = match[cursor] ? (0, $950478f3e6f849c2$export$2e2bcd8739ae039).create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
const $d9e03d2ca5209f90$var$isoTimeOnly = RegExp(`^T?${$d9e03d2ca5209f90$var$isoTimeBaseRegex.source}$`);
// ISO duration parsing
const $d9e03d2ca5209f90$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $d9e03d2ca5209f90$var$extractISODuration(match) {
    const [s, yearStr, monthStr, weekStr, dayStr, hourStr, minuteStr, secondStr, millisecondsStr] = match;
    const hasNegativePrefix = s[0] === "-";
    const negativeSeconds = secondStr && secondStr[0] === "-";
    const maybeNegate = (num, force = false)=>num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    return [
        {
            years: maybeNegate((0, $37f3a6ffca6d953c$export$ccc9a81fca9859cb)(yearStr)),
            months: maybeNegate((0, $37f3a6ffca6d953c$export$ccc9a81fca9859cb)(monthStr)),
            weeks: maybeNegate((0, $37f3a6ffca6d953c$export$ccc9a81fca9859cb)(weekStr)),
            days: maybeNegate((0, $37f3a6ffca6d953c$export$ccc9a81fca9859cb)(dayStr)),
            hours: maybeNegate((0, $37f3a6ffca6d953c$export$ccc9a81fca9859cb)(hourStr)),
            minutes: maybeNegate((0, $37f3a6ffca6d953c$export$ccc9a81fca9859cb)(minuteStr)),
            seconds: maybeNegate((0, $37f3a6ffca6d953c$export$ccc9a81fca9859cb)(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate((0, $37f3a6ffca6d953c$export$3989d60cf160c565)(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
const $d9e03d2ca5209f90$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $d9e03d2ca5209f90$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    const result = {
        year: yearStr.length === 2 ? (0, $37f3a6ffca6d953c$export$b7a39e2df70cc6be)((0, $37f3a6ffca6d953c$export$7181a16950b3209d)(yearStr)) : (0, $37f3a6ffca6d953c$export$7181a16950b3209d)(yearStr),
        month: $26d169874dd3df9b$export$b4b23bfab2f68498.indexOf(monthStr) + 1,
        day: (0, $37f3a6ffca6d953c$export$7181a16950b3209d)(dayStr),
        hour: (0, $37f3a6ffca6d953c$export$7181a16950b3209d)(hourStr),
        minute: (0, $37f3a6ffca6d953c$export$7181a16950b3209d)(minuteStr)
    };
    if (secondStr) result.second = (0, $37f3a6ffca6d953c$export$7181a16950b3209d)(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $26d169874dd3df9b$export$406f4855508be663.indexOf(weekdayStr) + 1 : $26d169874dd3df9b$export$d89a20b736c12a21.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
const $d9e03d2ca5209f90$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $d9e03d2ca5209f90$var$extractRFC2822(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr, obsOffset, milOffset, offHourStr, offMinuteStr] = match, result = $d9e03d2ca5209f90$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    let offset;
    if (obsOffset) offset = $d9e03d2ca5209f90$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = (0, $37f3a6ffca6d953c$export$f60aa7c70b05722d)(offHourStr, offMinuteStr);
    return [
        result,
        new (0, $be616c40eb3ec295$export$2e2bcd8739ae039)(offset)
    ];
}
function $d9e03d2ca5209f90$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
const $d9e03d2ca5209f90$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $d9e03d2ca5209f90$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $d9e03d2ca5209f90$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $d9e03d2ca5209f90$var$extractRFC1123Or850(match) {
    const [, weekdayStr, dayStr, monthStr, yearStr, hourStr, minuteStr, secondStr] = match, result = $d9e03d2ca5209f90$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        (0, $be616c40eb3ec295$export$2e2bcd8739ae039).utcInstance
    ];
}
function $d9e03d2ca5209f90$var$extractASCII(match) {
    const [, weekdayStr, monthStr, dayStr, hourStr, minuteStr, secondStr, yearStr] = match, result = $d9e03d2ca5209f90$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        (0, $be616c40eb3ec295$export$2e2bcd8739ae039).utcInstance
    ];
}
const $d9e03d2ca5209f90$var$isoYmdWithTimeExtensionRegex = $d9e03d2ca5209f90$var$combineRegexes($d9e03d2ca5209f90$var$isoYmdRegex, $d9e03d2ca5209f90$var$isoTimeExtensionRegex);
const $d9e03d2ca5209f90$var$isoWeekWithTimeExtensionRegex = $d9e03d2ca5209f90$var$combineRegexes($d9e03d2ca5209f90$var$isoWeekRegex, $d9e03d2ca5209f90$var$isoTimeExtensionRegex);
const $d9e03d2ca5209f90$var$isoOrdinalWithTimeExtensionRegex = $d9e03d2ca5209f90$var$combineRegexes($d9e03d2ca5209f90$var$isoOrdinalRegex, $d9e03d2ca5209f90$var$isoTimeExtensionRegex);
const $d9e03d2ca5209f90$var$isoTimeCombinedRegex = $d9e03d2ca5209f90$var$combineRegexes($d9e03d2ca5209f90$var$isoTimeRegex);
const $d9e03d2ca5209f90$var$extractISOYmdTimeAndOffset = $d9e03d2ca5209f90$var$combineExtractors($d9e03d2ca5209f90$var$extractISOYmd, $d9e03d2ca5209f90$var$extractISOTime, $d9e03d2ca5209f90$var$extractISOOffset, $d9e03d2ca5209f90$var$extractIANAZone);
const $d9e03d2ca5209f90$var$extractISOWeekTimeAndOffset = $d9e03d2ca5209f90$var$combineExtractors($d9e03d2ca5209f90$var$extractISOWeekData, $d9e03d2ca5209f90$var$extractISOTime, $d9e03d2ca5209f90$var$extractISOOffset, $d9e03d2ca5209f90$var$extractIANAZone);
const $d9e03d2ca5209f90$var$extractISOOrdinalDateAndTime = $d9e03d2ca5209f90$var$combineExtractors($d9e03d2ca5209f90$var$extractISOOrdinalData, $d9e03d2ca5209f90$var$extractISOTime, $d9e03d2ca5209f90$var$extractISOOffset, $d9e03d2ca5209f90$var$extractIANAZone);
const $d9e03d2ca5209f90$var$extractISOTimeAndOffset = $d9e03d2ca5209f90$var$combineExtractors($d9e03d2ca5209f90$var$extractISOTime, $d9e03d2ca5209f90$var$extractISOOffset, $d9e03d2ca5209f90$var$extractIANAZone);
function $d9e03d2ca5209f90$export$ee8e61141c87635a(s) {
    return $d9e03d2ca5209f90$var$parse(s, [
        $d9e03d2ca5209f90$var$isoYmdWithTimeExtensionRegex,
        $d9e03d2ca5209f90$var$extractISOYmdTimeAndOffset
    ], [
        $d9e03d2ca5209f90$var$isoWeekWithTimeExtensionRegex,
        $d9e03d2ca5209f90$var$extractISOWeekTimeAndOffset
    ], [
        $d9e03d2ca5209f90$var$isoOrdinalWithTimeExtensionRegex,
        $d9e03d2ca5209f90$var$extractISOOrdinalDateAndTime
    ], [
        $d9e03d2ca5209f90$var$isoTimeCombinedRegex,
        $d9e03d2ca5209f90$var$extractISOTimeAndOffset
    ]);
}
function $d9e03d2ca5209f90$export$22671fa29093a82f(s) {
    return $d9e03d2ca5209f90$var$parse($d9e03d2ca5209f90$var$preprocessRFC2822(s), [
        $d9e03d2ca5209f90$var$rfc2822,
        $d9e03d2ca5209f90$var$extractRFC2822
    ]);
}
function $d9e03d2ca5209f90$export$6eac75d7e2e61231(s) {
    return $d9e03d2ca5209f90$var$parse(s, [
        $d9e03d2ca5209f90$var$rfc1123,
        $d9e03d2ca5209f90$var$extractRFC1123Or850
    ], [
        $d9e03d2ca5209f90$var$rfc850,
        $d9e03d2ca5209f90$var$extractRFC1123Or850
    ], [
        $d9e03d2ca5209f90$var$ascii,
        $d9e03d2ca5209f90$var$extractASCII
    ]);
}
function $d9e03d2ca5209f90$export$87483128cec2621c(s) {
    return $d9e03d2ca5209f90$var$parse(s, [
        $d9e03d2ca5209f90$var$isoDuration,
        $d9e03d2ca5209f90$var$extractISODuration
    ]);
}
const $d9e03d2ca5209f90$var$extractISOTimeOnly = $d9e03d2ca5209f90$var$combineExtractors($d9e03d2ca5209f90$var$extractISOTime);
function $d9e03d2ca5209f90$export$a8603b5245545f3e(s) {
    return $d9e03d2ca5209f90$var$parse(s, [
        $d9e03d2ca5209f90$var$isoTimeOnly,
        $d9e03d2ca5209f90$var$extractISOTimeOnly
    ]);
}
const $d9e03d2ca5209f90$var$sqlYmdWithTimeExtensionRegex = $d9e03d2ca5209f90$var$combineRegexes($d9e03d2ca5209f90$var$sqlYmdRegex, $d9e03d2ca5209f90$var$sqlTimeExtensionRegex);
const $d9e03d2ca5209f90$var$sqlTimeCombinedRegex = $d9e03d2ca5209f90$var$combineRegexes($d9e03d2ca5209f90$var$sqlTimeRegex);
const $d9e03d2ca5209f90$var$extractISOTimeOffsetAndIANAZone = $d9e03d2ca5209f90$var$combineExtractors($d9e03d2ca5209f90$var$extractISOTime, $d9e03d2ca5209f90$var$extractISOOffset, $d9e03d2ca5209f90$var$extractIANAZone);
function $d9e03d2ca5209f90$export$425a58f41d7e6b1e(s) {
    return $d9e03d2ca5209f90$var$parse(s, [
        $d9e03d2ca5209f90$var$sqlYmdWithTimeExtensionRegex,
        $d9e03d2ca5209f90$var$extractISOYmdTimeAndOffset
    ], [
        $d9e03d2ca5209f90$var$sqlTimeCombinedRegex,
        $d9e03d2ca5209f90$var$extractISOTimeOffsetAndIANAZone
    ]);
}




const $0c452a562a879a0d$var$INVALID = "Invalid Duration";
const $0c452a562a879a0d$export$b2b4559e62423d84 = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $0c452a562a879a0d$export$66b25084afa3c725 = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $0c452a562a879a0d$export$b2b4559e62423d84), $0c452a562a879a0d$export$afca50ae33abd78b = 365.2425, $0c452a562a879a0d$export$70cde7cbd78deec8 = 30.436875, $0c452a562a879a0d$export$3a9e77e060440793 = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
    years: {
        quarters: 4,
        months: 12,
        weeks: $0c452a562a879a0d$export$afca50ae33abd78b / 7,
        days: $0c452a562a879a0d$export$afca50ae33abd78b,
        hours: $0c452a562a879a0d$export$afca50ae33abd78b * 24,
        minutes: $0c452a562a879a0d$export$afca50ae33abd78b * 1440,
        seconds: $0c452a562a879a0d$export$afca50ae33abd78b * 86400,
        milliseconds: $0c452a562a879a0d$export$afca50ae33abd78b * 86400000
    },
    quarters: {
        months: 3,
        weeks: $0c452a562a879a0d$export$afca50ae33abd78b / 28,
        days: $0c452a562a879a0d$export$afca50ae33abd78b / 4,
        hours: $0c452a562a879a0d$export$afca50ae33abd78b * 24 / 4,
        minutes: $0c452a562a879a0d$export$afca50ae33abd78b * 1440 / 4,
        seconds: $0c452a562a879a0d$export$afca50ae33abd78b * 86400 / 4,
        milliseconds: $0c452a562a879a0d$export$afca50ae33abd78b * 86400000 / 4
    },
    months: {
        weeks: $0c452a562a879a0d$export$70cde7cbd78deec8 / 7,
        days: $0c452a562a879a0d$export$70cde7cbd78deec8,
        hours: $0c452a562a879a0d$export$70cde7cbd78deec8 * 24,
        minutes: $0c452a562a879a0d$export$70cde7cbd78deec8 * 1440,
        seconds: $0c452a562a879a0d$export$70cde7cbd78deec8 * 86400,
        milliseconds: $0c452a562a879a0d$export$70cde7cbd78deec8 * 86400000
    }
}, $0c452a562a879a0d$export$b2b4559e62423d84);
// units ordered by size
const $0c452a562a879a0d$var$orderedUnits = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
const $0c452a562a879a0d$var$reverseUnits = $0c452a562a879a0d$var$orderedUnits.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $0c452a562a879a0d$var$clone(dur, alts, clear = false) {
    // deep merge for vals
    const conf = {
        values: clear ? alts.values : (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy
    };
    return new $0c452a562a879a0d$export$2e2bcd8739ae039(conf);
}
function $0c452a562a879a0d$var$antiTrunc(n) {
    return n < 0 ? Math.floor(n) : Math.ceil(n);
}
// NB: mutates parameters
function $0c452a562a879a0d$var$convert(matrix, fromMap, fromUnit, toMap, toUnit) {
    const conv = matrix[toUnit][fromUnit], raw = fromMap[fromUnit] / conv, sameSign = Math.sign(raw) === Math.sign(toMap[toUnit]), // ok, so this is wild, but see the matrix in the tests
    added = !sameSign && toMap[toUnit] !== 0 && Math.abs(raw) <= 1 ? $0c452a562a879a0d$var$antiTrunc(raw) : Math.trunc(raw);
    toMap[toUnit] += added;
    fromMap[fromUnit] -= added * conv;
}
// NB: mutates parameters
function $0c452a562a879a0d$var$normalizeValues(matrix, vals) {
    $0c452a562a879a0d$var$reverseUnits.reduce((previous, current)=>{
        if (!(0, $37f3a6ffca6d953c$export$fce6876652108ab)(vals[current])) {
            if (previous) $0c452a562a879a0d$var$convert(matrix, vals, previous, vals, current);
            return current;
        } else return previous;
    }, null);
}
class $0c452a562a879a0d$export$2e2bcd8739ae039 {
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ static fromMillis(count, opts) {
        return $0c452a562a879a0d$export$2e2bcd8739ae039.fromObject({
            milliseconds: count
        }, opts);
    }
    /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ static fromObject(obj, opts = {}) {
        if (obj == null || typeof obj !== "object") throw new (0, $886de9df440664a3$export$9c711d4a95378233)(`Duration.fromObject: argument expected to be an object, got ${obj === null ? "null" : typeof obj}`);
        return new $0c452a562a879a0d$export$2e2bcd8739ae039({
            values: (0, $37f3a6ffca6d953c$export$ba17feb4405f3f38)(obj, $0c452a562a879a0d$export$2e2bcd8739ae039.normalizeUnit),
            loc: (0, $e692b3aca11585b0$export$2e2bcd8739ae039).fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy
        });
    }
    /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ static fromDurationLike(durationLike) {
        if ((0, $37f3a6ffca6d953c$export$7e4aa119212bc614)(durationLike)) return $0c452a562a879a0d$export$2e2bcd8739ae039.fromMillis(durationLike);
        else if ($0c452a562a879a0d$export$2e2bcd8739ae039.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return $0c452a562a879a0d$export$2e2bcd8739ae039.fromObject(durationLike);
        else throw new (0, $886de9df440664a3$export$9c711d4a95378233)(`Unknown duration argument ${durationLike} of type ${typeof durationLike}`);
    }
    /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ static fromISO(text, opts) {
        const [parsed] = (0, $d9e03d2ca5209f90$export$87483128cec2621c)(text);
        if (parsed) return $0c452a562a879a0d$export$2e2bcd8739ae039.fromObject(parsed, opts);
        else return $0c452a562a879a0d$export$2e2bcd8739ae039.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ static fromISOTime(text, opts) {
        const [parsed] = (0, $d9e03d2ca5209f90$export$a8603b5245545f3e)(text);
        if (parsed) return $0c452a562a879a0d$export$2e2bcd8739ae039.fromObject(parsed, opts);
        else return $0c452a562a879a0d$export$2e2bcd8739ae039.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new (0, $886de9df440664a3$export$9c711d4a95378233)("need to specify a reason the Duration is invalid");
        const invalid = reason instanceof (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039) ? reason : new (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039)(reason, explanation);
        if ((0, $30b5604947d63dd3$export$2e2bcd8739ae039).throwOnInvalid) throw new (0, $886de9df440664a3$export$fa63917b8416fe36)(invalid);
        else return new $0c452a562a879a0d$export$2e2bcd8739ae039({
            invalid: invalid
        });
    }
    /**
   * @private
   */ static normalizeUnit(unit) {
        const normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new (0, $886de9df440664a3$export$ac94f561e2d387b4)(unit);
        return normalized;
    }
    /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDuration(o) {
        return o && o.isLuxonDuration || false;
    }
    /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a Duration, such 'beng'. The numbering system is used when formatting the Duration
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        const fmtOpts = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opts), {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? (0, $35e0b627fa211618$export$2e2bcd8739ae039).create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $0c452a562a879a0d$var$INVALID;
    }
    /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ toHuman(opts = {}) {
        const l = $0c452a562a879a0d$var$orderedUnits.map((unit)=>{
            const val = this.values[unit];
            if ((0, $37f3a6ffca6d953c$export$fce6876652108ab)(val)) return null;
            return this.loc.numberFormatter((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
                style: "unit",
                unitDisplay: "long"
            }, opts), {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter((n)=>n);
        return this.loc.listFormatter((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    }
    /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ toObject() {
        if (!this.isValid) return {};
        return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.values);
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        let s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += (0, $37f3a6ffca6d953c$export$7978a6ddf29f4374)(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ toISOTime(opts = {}) {
        if (!this.isValid) return null;
        const millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts);
        const value = this.shiftTo("hours", "minutes", "seconds", "milliseconds");
        let fmt = opts.format === "basic" ? "hhmm" : "hh:mm";
        if (!opts.suppressSeconds || value.seconds !== 0 || value.milliseconds !== 0) {
            fmt += opts.format === "basic" ? "ss" : ":ss";
            if (!opts.suppressMilliseconds || value.milliseconds !== 0) fmt += ".SSS";
        }
        let str = value.toFormat(fmt);
        if (opts.includePrefix) str = "T" + str;
        return str;
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ toString() {
        return this.toISO();
    }
    /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ toMillis() {
        return this.as("milliseconds");
    }
    /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = $0c452a562a879a0d$export$2e2bcd8739ae039.fromDurationLike(duration), result = {};
        for (const k of $0c452a562a879a0d$var$orderedUnits)if ((0, $37f3a6ffca6d953c$export$5a15a386532a5ea4)(dur.values, k) || (0, $37f3a6ffca6d953c$export$5a15a386532a5ea4)(this.values, k)) result[k] = dur.get(k) + this.get(k);
        return $0c452a562a879a0d$var$clone(this, {
            values: result
        }, true);
    }
    /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = $0c452a562a879a0d$export$2e2bcd8739ae039.fromDurationLike(duration);
        return this.plus(dur.negate());
    }
    /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hour" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ mapUnits(fn) {
        if (!this.isValid) return this;
        const result = {};
        for (const k of Object.keys(this.values))result[k] = (0, $37f3a6ffca6d953c$export$37576b9ba69b50db)(fn(this.values[k], k));
        return $0c452a562a879a0d$var$clone(this, {
            values: result
        }, true);
    }
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ get(unit) {
        return this[$0c452a562a879a0d$export$2e2bcd8739ae039.normalizeUnit(unit)];
    }
    /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ set(values) {
        if (!this.isValid) return this;
        const mixed = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.values, (0, $37f3a6ffca6d953c$export$ba17feb4405f3f38)(values, $0c452a562a879a0d$export$2e2bcd8739ae039.normalizeUnit));
        return $0c452a562a879a0d$var$clone(this, {
            values: mixed
        });
    }
    /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ reconfigure({ locale: locale, numberingSystem: numberingSystem, conversionAccuracy: conversionAccuracy } = {}) {
        const loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        }), opts = {
            loc: loc
        };
        if (conversionAccuracy) opts.conversionAccuracy = conversionAccuracy;
        return $0c452a562a879a0d$var$clone(this, opts);
    }
    /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    }
    /**
   * Reduce this Duration to its canonical representation in its current units.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @return {Duration}
   */ normalize() {
        if (!this.isValid) return this;
        const vals = this.toObject();
        $0c452a562a879a0d$var$normalizeValues(this.matrix, vals);
        return $0c452a562a879a0d$var$clone(this, {
            values: vals
        }, true);
    }
    /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ shiftTo(...units) {
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map((u)=>$0c452a562a879a0d$export$2e2bcd8739ae039.normalizeUnit(u));
        const built = {}, accumulated = {}, vals = this.toObject();
        let lastUnit;
        for (const k of $0c452a562a879a0d$var$orderedUnits){
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                let own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(const ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ((0, $37f3a6ffca6d953c$export$7e4aa119212bc614)(vals[k])) own += vals[k];
                const i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
                // plus anything further down the chain that should be rolled up in to this
                for(const down in vals)if ($0c452a562a879a0d$var$orderedUnits.indexOf(down) > $0c452a562a879a0d$var$orderedUnits.indexOf(k)) $0c452a562a879a0d$var$convert(this.matrix, vals, down, built, k);
            // otherwise, keep it in the wings to boil it later
            } else if ((0, $37f3a6ffca6d953c$export$7e4aa119212bc614)(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(const key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        return $0c452a562a879a0d$var$clone(this, {
            values: built
        }, true).normalize();
    }
    /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ negate() {
        if (!this.isValid) return this;
        const negated = {};
        for (const k of Object.keys(this.values))negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        return $0c452a562a879a0d$var$clone(this, {
            values: negated
        }, true);
    }
    /**
   * Get the years.
   * @type {number}
   */ get years() {
        return this.isValid ? this.values.years || 0 : NaN;
    }
    /**
   * Get the quarters.
   * @type {number}
   */ get quarters() {
        return this.isValid ? this.values.quarters || 0 : NaN;
    }
    /**
   * Get the months.
   * @type {number}
   */ get months() {
        return this.isValid ? this.values.months || 0 : NaN;
    }
    /**
   * Get the weeks
   * @type {number}
   */ get weeks() {
        return this.isValid ? this.values.weeks || 0 : NaN;
    }
    /**
   * Get the days.
   * @type {number}
   */ get days() {
        return this.isValid ? this.values.days || 0 : NaN;
    }
    /**
   * Get the hours.
   * @type {number}
   */ get hours() {
        return this.isValid ? this.values.hours || 0 : NaN;
    }
    /**
   * Get the minutes.
   * @type {number}
   */ get minutes() {
        return this.isValid ? this.values.minutes || 0 : NaN;
    }
    /**
   * Get the seconds.
   * @return {number}
   */ get seconds() {
        return this.isValid ? this.values.seconds || 0 : NaN;
    }
    /**
   * Get the milliseconds.
   * @return {number}
   */ get milliseconds() {
        return this.isValid ? this.values.milliseconds || 0 : NaN;
    }
    /**
   * Returns whether the Duration is invalid. Invalid durations are returned by diff operations
   * on invalid DateTimes or Intervals.
   * @return {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this Duration became invalid, or null if the Duration is valid
   * @return {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Duration became invalid, or null if the Duration is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for (const u of $0c452a562a879a0d$var$orderedUnits){
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    }
    /**
   * @private
   */ constructor(config){
        const accurate = config.conversionAccuracy === "longterm" || false;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || (0, $e692b3aca11585b0$export$2e2bcd8739ae039).create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = accurate ? $0c452a562a879a0d$export$3a9e77e060440793 : $0c452a562a879a0d$export$66b25084afa3c725;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
}







const $b3e55c7f0c6f7168$var$INVALID = "Invalid Interval";
// checks if the start is equal to or before the end
function $b3e55c7f0c6f7168$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.invalid("missing or invalid end");
    else if (end < start) return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.invalid("end before start", `The end of an interval must be after its start, but you had start=${start.toISO()} and end=${end.toISO()}`);
    else return null;
}
class $b3e55c7f0c6f7168$export$2e2bcd8739ae039 {
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new (0, $886de9df440664a3$export$9c711d4a95378233)("need to specify a reason the Interval is invalid");
        const invalid = reason instanceof (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039) ? reason : new (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039)(reason, explanation);
        if ((0, $30b5604947d63dd3$export$2e2bcd8739ae039).throwOnInvalid) throw new (0, $886de9df440664a3$export$cdb4559f04a244ae)(invalid);
        else return new $b3e55c7f0c6f7168$export$2e2bcd8739ae039({
            invalid: invalid
        });
    }
    /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ static fromDateTimes(start, end) {
        const builtStart = (0, $485b75493327b6f7$export$d207855dff529fc9)(start), builtEnd = (0, $485b75493327b6f7$export$d207855dff529fc9)(end);
        const validateError = $b3e55c7f0c6f7168$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new $b3e55c7f0c6f7168$export$2e2bcd8739ae039({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    }
    /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static after(start, duration) {
        const dur = (0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromDurationLike(duration), dt = (0, $485b75493327b6f7$export$d207855dff529fc9)(start);
        return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.fromDateTimes(dt, dt.plus(dur));
    }
    /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ static before(end, duration) {
        const dur = (0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromDurationLike(duration), dt = (0, $485b75493327b6f7$export$d207855dff529fc9)(end);
        return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.fromDateTimes(dt.minus(dur), dt);
    }
    /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ static fromISO(text, opts) {
        const [s, e] = (text || "").split("/", 2);
        if (s && e) {
            let start, startIsValid;
            try {
                start = (0, $485b75493327b6f7$export$2e2bcd8739ae039).fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            let end, endIsValid;
            try {
                end = (0, $485b75493327b6f7$export$2e2bcd8739ae039).fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.fromDateTimes(start, end);
            if (startIsValid) {
                const dur = (0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromISO(e, opts);
                if (dur.isValid) return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.after(start, dur);
            } else if (endIsValid) {
                const dur = (0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromISO(s, opts);
                if (dur.isValid) return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.before(end, dur);
            }
        }
        return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.invalid("unparsable", `the input "${text}" can't be parsed as ISO 8601`);
    }
    /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isInterval(o) {
        return o && o.isLuxonInterval || false;
    }
    /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ get start() {
        return this.isValid ? this.s : null;
    }
    /**
   * Returns the end of the Interval
   * @type {DateTime}
   */ get end() {
        return this.isValid ? this.e : null;
    }
    /**
   * Returns whether this Interval's end is at least its start, meaning that the Interval isn't 'backwards'.
   * @type {boolean}
   */ get isValid() {
        return this.invalidReason === null;
    }
    /**
   * Returns an error code if this Interval is invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this Interval became invalid, or null if the Interval is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ length(unit = "milliseconds") {
        return this.isValid ? this.toDuration(...[
            unit
        ]).get(unit) : NaN;
    }
    /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */ count(unit = "milliseconds") {
        if (!this.isValid) return NaN;
        const start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + 1;
    }
    /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    }
    /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    }
    /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    }
    /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    }
    /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    }
    /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ set({ start: start, end: end } = {}) {
        if (!this.isValid) return this;
        return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.fromDateTimes(start || this.s, end || this.e);
    }
    /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ splitAt(...dateTimes) {
        if (!this.isValid) return [];
        const sorted = dateTimes.map((0, $485b75493327b6f7$export$d207855dff529fc9)).filter((d)=>this.contains(d)).sort(), results = [];
        let { s: s } = this, i = 0;
        while(s < this.e){
            const added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push($b3e55c7f0c6f7168$export$2e2bcd8739ae039.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    }
    /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ splitBy(duration) {
        const dur = (0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        let { s: s } = this, idx = 1, next;
        const results = [];
        while(s < this.e){
            const added = this.start.plus(dur.mapUnits((x)=>x * idx));
            next = +added > +this.e ? this.e : added;
            results.push($b3e55c7f0c6f7168$export$2e2bcd8739ae039.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    }
    /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    }
    /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ overlaps(other) {
        return this.e > other.s && this.s < other.e;
    }
    /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    }
    /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    }
    /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    }
    /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    }
    /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ intersection(other) {
        if (!this.isValid) return this;
        const s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.fromDateTimes(s, e);
    }
    /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ union(other) {
        if (!this.isValid) return this;
        const s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.fromDateTimes(s, e);
    }
    /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ static merge(intervals) {
        const [found, final] = intervals.sort((a, b)=>a.s - b.s).reduce(([sofar, current], item)=>{
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]);
        if (final) found.push(final);
        return found;
    }
    /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ static xor(intervals) {
        let start = null, currentCount = 0;
        const results = [], ends = intervals.map((i)=>[
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ]), flattened = Array.prototype.concat(...ends), arr = flattened.sort((a, b)=>a.time - b.time);
        for (const i of arr){
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push($b3e55c7f0c6f7168$export$2e2bcd8739ae039.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.merge(results);
    }
    /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ difference(...intervals) {
        return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.xor([
            this
        ].concat(intervals)).map((i)=>this.intersection(i)).filter((i)=>i && !i.isEmpty());
    }
    /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ toString() {
        if (!this.isValid) return $b3e55c7f0c6f7168$var$INVALID;
        return `[${this.s.toISO()} \u{2013} ${this.e.toISO()})`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISO(opts) {
        if (!this.isValid) return $b3e55c7f0c6f7168$var$INVALID;
        return `${this.s.toISO(opts)}/${this.e.toISO(opts)}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ toISODate() {
        if (!this.isValid) return $b3e55c7f0c6f7168$var$INVALID;
        return `${this.s.toISODate()}/${this.e.toISODate()}`;
    }
    /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ toISOTime(opts) {
        if (!this.isValid) return $b3e55c7f0c6f7168$var$INVALID;
        return `${this.s.toISOTime(opts)}/${this.e.toISOTime(opts)}`;
    }
    /**
   * Returns a string representation of this Interval formatted according to the specified format string.
   * @param {string} dateFormat - the format string. This string formats the start and end time. See {@link DateTime#toFormat} for details.
   * @param {Object} opts - options
   * @param {string} [opts.separator =  ' – '] - a separator to place between the start and end representations
   * @return {string}
   */ toFormat(dateFormat, { separator: separator = " \u2013 " } = {}) {
        if (!this.isValid) return $b3e55c7f0c6f7168$var$INVALID;
        return `${this.s.toFormat(dateFormat)}${separator}${this.e.toFormat(dateFormat)}`;
    }
    /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ toDuration(unit, opts) {
        if (!this.isValid) return (0, $0c452a562a879a0d$export$2e2bcd8739ae039).invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    }
    /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ mapEndpoints(mapFn) {
        return $b3e55c7f0c6f7168$export$2e2bcd8739ae039.fromDateTimes(mapFn(this.s), mapFn(this.e));
    }
    /**
   * @private
   */ constructor(config){
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
}









class $8133d12953b92b37$export$2e2bcd8739ae039 {
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ static hasDST(zone = (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultZone) {
        const proto = (0, $485b75493327b6f7$export$2e2bcd8739ae039).now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    }
    /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ static isValidIANAZone(zone) {
        return (0, $950478f3e6f849c2$export$2e2bcd8739ae039).isValidZone(zone);
    }
    /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ static normalizeZone(input) {
        return (0, $d46f30efbf427e5a$export$4527f24d1e617e9)(input, (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultZone);
    }
    /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ static months(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null, outputCalendar: outputCalendar = "gregory" } = {}) {
        return (locObj || (0, $e692b3aca11585b0$export$2e2bcd8739ae039).create(locale, numberingSystem, outputCalendar)).months(length);
    }
    /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ static monthsFormat(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null, outputCalendar: outputCalendar = "gregory" } = {}) {
        return (locObj || (0, $e692b3aca11585b0$export$2e2bcd8739ae039).create(locale, numberingSystem, outputCalendar)).months(length, true);
    }
    /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ static weekdays(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null } = {}) {
        return (locObj || (0, $e692b3aca11585b0$export$2e2bcd8739ae039).create(locale, numberingSystem, null)).weekdays(length);
    }
    /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ static weekdaysFormat(length = "long", { locale: locale = null, numberingSystem: numberingSystem = null, locObj: locObj = null } = {}) {
        return (locObj || (0, $e692b3aca11585b0$export$2e2bcd8739ae039).create(locale, numberingSystem, null)).weekdays(length, true);
    }
    /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ static meridiems({ locale: locale = null } = {}) {
        return (0, $e692b3aca11585b0$export$2e2bcd8739ae039).create(locale).meridiems();
    }
    /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ static eras(length = "short", { locale: locale = null } = {}) {
        return (0, $e692b3aca11585b0$export$2e2bcd8739ae039).create(locale, null, "gregory").eras(length);
    }
    /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */ static features() {
        return {
            relative: (0, $37f3a6ffca6d953c$export$36c4ef3ee752f47f)()
        };
    }
}








function $30b136513522fd0b$var$dayDiff(earlier, later) {
    const utcDayStart = (dt)=>dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor((0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromMillis(ms).as("days"));
}
function $30b136513522fd0b$var$highOrderDiffs(cursor, later, units) {
    const differs = [
        [
            "years",
            (a, b)=>b.year - a.year
        ],
        [
            "quarters",
            (a, b)=>b.quarter - a.quarter
        ],
        [
            "months",
            (a, b)=>b.month - a.month + (b.year - a.year) * 12
        ],
        [
            "weeks",
            (a, b)=>{
                const days = $30b136513522fd0b$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $30b136513522fd0b$var$dayDiff
        ]
    ];
    const results = {};
    let lowestOrder, highWater;
    for (const [unit, differ] of differs)if (units.indexOf(unit) >= 0) {
        lowestOrder = unit;
        let delta = differ(cursor, later);
        highWater = cursor.plus({
            [unit]: delta
        });
        if (highWater > later) {
            cursor = cursor.plus({
                [unit]: delta - 1
            });
            delta -= 1;
        } else cursor = highWater;
        results[unit] = delta;
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $30b136513522fd0b$export$2e2bcd8739ae039(earlier, later, units, opts) {
    let [cursor, results, highWater, lowestOrder] = $30b136513522fd0b$var$highOrderDiffs(earlier, later, units);
    const remainingMillis = later - cursor;
    const lowerOrderUnits = units.filter((u)=>[
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0);
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) highWater = cursor.plus({
            [lowestOrder]: 1
        });
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    const duration = (0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromObject(results, opts);
    if (lowerOrderUnits.length > 0) return (0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration);
    else return duration;
}








const $ed30c330385d60af$var$numberingSystems = {
    arab: "[\u0660-\u0669]",
    arabext: "[\u06F0-\u06F9]",
    bali: "[\u1B50-\u1B59]",
    beng: "[\u09E6-\u09EF]",
    deva: "[\u0966-\u096F]",
    fullwide: "[\uFF10-\uFF19]",
    gujr: "[\u0AE6-\u0AEF]",
    hanidec: "[\u3007|\u4E00|\u4E8C|\u4E09|\u56DB|\u4E94|\u516D|\u4E03|\u516B|\u4E5D]",
    khmr: "[\u17E0-\u17E9]",
    knda: "[\u0CE6-\u0CEF]",
    laoo: "[\u0ED0-\u0ED9]",
    limb: "[\u1946-\u194F]",
    mlym: "[\u0D66-\u0D6F]",
    mong: "[\u1810-\u1819]",
    mymr: "[\u1040-\u1049]",
    orya: "[\u0B66-\u0B6F]",
    tamldec: "[\u0BE6-\u0BEF]",
    telu: "[\u0C66-\u0C6F]",
    thai: "[\u0E50-\u0E59]",
    tibt: "[\u0F20-\u0F29]",
    latn: "\\d"
};
const $ed30c330385d60af$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
const $ed30c330385d60af$var$hanidecChars = $ed30c330385d60af$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $ed30c330385d60af$export$b37c688a581b2f6b(str) {
    let value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(let i = 0; i < str.length; i++){
            const code = str.charCodeAt(i);
            if (str[i].search($ed30c330385d60af$var$numberingSystems.hanidec) !== -1) value += $ed30c330385d60af$var$hanidecChars.indexOf(str[i]);
            else for(const key in $ed30c330385d60af$var$numberingSystemsUTF16){
                const [min, max] = $ed30c330385d60af$var$numberingSystemsUTF16[key];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $ed30c330385d60af$export$79fd8462ddaefe42({ numberingSystem: numberingSystem }, append = "") {
    return new RegExp(`${$ed30c330385d60af$var$numberingSystems[numberingSystem || "latn"]}${append}`);
}



const $3ee0473af38ba5b9$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $3ee0473af38ba5b9$var$intUnit(regex, post = (i)=>i) {
    return {
        regex: regex,
        deser: ([s])=>post((0, $ed30c330385d60af$export$b37c688a581b2f6b)(s))
    };
}
const $3ee0473af38ba5b9$var$NBSP = String.fromCharCode(160);
const $3ee0473af38ba5b9$var$spaceOrNBSP = `[ ${$3ee0473af38ba5b9$var$NBSP}]`;
const $3ee0473af38ba5b9$var$spaceOrNBSPRegExp = new RegExp($3ee0473af38ba5b9$var$spaceOrNBSP, "g");
function $3ee0473af38ba5b9$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($3ee0473af38ba5b9$var$spaceOrNBSPRegExp, $3ee0473af38ba5b9$var$spaceOrNBSP);
}
function $3ee0473af38ba5b9$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($3ee0473af38ba5b9$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $3ee0473af38ba5b9$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($3ee0473af38ba5b9$var$fixListRegex).join("|")),
        deser: ([s])=>strings.findIndex((i)=>$3ee0473af38ba5b9$var$stripInsensitivities(s) === $3ee0473af38ba5b9$var$stripInsensitivities(i)) + startIndex
    };
}
function $3ee0473af38ba5b9$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: ([, h, m])=>(0, $37f3a6ffca6d953c$export$f60aa7c70b05722d)(h, m),
        groups: groups
    };
}
function $3ee0473af38ba5b9$var$simple(regex) {
    return {
        regex: regex,
        deser: ([s])=>s
    };
}
function $3ee0473af38ba5b9$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
function $3ee0473af38ba5b9$var$unitForToken(token, loc) {
    const one = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc), two = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc, "{2}"), three = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc, "{3}"), four = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc, "{4}"), six = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc, "{6}"), oneOrTwo = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc, "{1,2}"), oneToThree = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc, "{1,3}"), oneToSix = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc, "{1,6}"), oneToNine = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc, "{1,9}"), twoToFour = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc, "{2,4}"), fourToSix = (0, $ed30c330385d60af$export$79fd8462ddaefe42)(loc, "{4,6}"), literal = (t)=>({
            regex: RegExp($3ee0473af38ba5b9$var$escapeToken(t.val)),
            deser: ([s])=>s,
            literal: true
        }), unitate = (t)=>{
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $3ee0473af38ba5b9$var$oneOf(loc.eras("short", false), 0);
            case "GG":
                return $3ee0473af38ba5b9$var$oneOf(loc.eras("long", false), 0);
            // years
            case "y":
                return $3ee0473af38ba5b9$var$intUnit(oneToSix);
            case "yy":
                return $3ee0473af38ba5b9$var$intUnit(twoToFour, (0, $37f3a6ffca6d953c$export$b7a39e2df70cc6be));
            case "yyyy":
                return $3ee0473af38ba5b9$var$intUnit(four);
            case "yyyyy":
                return $3ee0473af38ba5b9$var$intUnit(fourToSix);
            case "yyyyyy":
                return $3ee0473af38ba5b9$var$intUnit(six);
            // months
            case "M":
                return $3ee0473af38ba5b9$var$intUnit(oneOrTwo);
            case "MM":
                return $3ee0473af38ba5b9$var$intUnit(two);
            case "MMM":
                return $3ee0473af38ba5b9$var$oneOf(loc.months("short", true, false), 1);
            case "MMMM":
                return $3ee0473af38ba5b9$var$oneOf(loc.months("long", true, false), 1);
            case "L":
                return $3ee0473af38ba5b9$var$intUnit(oneOrTwo);
            case "LL":
                return $3ee0473af38ba5b9$var$intUnit(two);
            case "LLL":
                return $3ee0473af38ba5b9$var$oneOf(loc.months("short", false, false), 1);
            case "LLLL":
                return $3ee0473af38ba5b9$var$oneOf(loc.months("long", false, false), 1);
            // dates
            case "d":
                return $3ee0473af38ba5b9$var$intUnit(oneOrTwo);
            case "dd":
                return $3ee0473af38ba5b9$var$intUnit(two);
            // ordinals
            case "o":
                return $3ee0473af38ba5b9$var$intUnit(oneToThree);
            case "ooo":
                return $3ee0473af38ba5b9$var$intUnit(three);
            // time
            case "HH":
                return $3ee0473af38ba5b9$var$intUnit(two);
            case "H":
                return $3ee0473af38ba5b9$var$intUnit(oneOrTwo);
            case "hh":
                return $3ee0473af38ba5b9$var$intUnit(two);
            case "h":
                return $3ee0473af38ba5b9$var$intUnit(oneOrTwo);
            case "mm":
                return $3ee0473af38ba5b9$var$intUnit(two);
            case "m":
                return $3ee0473af38ba5b9$var$intUnit(oneOrTwo);
            case "q":
                return $3ee0473af38ba5b9$var$intUnit(oneOrTwo);
            case "qq":
                return $3ee0473af38ba5b9$var$intUnit(two);
            case "s":
                return $3ee0473af38ba5b9$var$intUnit(oneOrTwo);
            case "ss":
                return $3ee0473af38ba5b9$var$intUnit(two);
            case "S":
                return $3ee0473af38ba5b9$var$intUnit(oneToThree);
            case "SSS":
                return $3ee0473af38ba5b9$var$intUnit(three);
            case "u":
                return $3ee0473af38ba5b9$var$simple(oneToNine);
            case "uu":
                return $3ee0473af38ba5b9$var$simple(oneOrTwo);
            case "uuu":
                return $3ee0473af38ba5b9$var$intUnit(one);
            // meridiem
            case "a":
                return $3ee0473af38ba5b9$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $3ee0473af38ba5b9$var$intUnit(four);
            case "kk":
                return $3ee0473af38ba5b9$var$intUnit(twoToFour, (0, $37f3a6ffca6d953c$export$b7a39e2df70cc6be));
            // weekNumber (W)
            case "W":
                return $3ee0473af38ba5b9$var$intUnit(oneOrTwo);
            case "WW":
                return $3ee0473af38ba5b9$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $3ee0473af38ba5b9$var$intUnit(one);
            case "EEE":
                return $3ee0473af38ba5b9$var$oneOf(loc.weekdays("short", false, false), 1);
            case "EEEE":
                return $3ee0473af38ba5b9$var$oneOf(loc.weekdays("long", false, false), 1);
            case "ccc":
                return $3ee0473af38ba5b9$var$oneOf(loc.weekdays("short", true, false), 1);
            case "cccc":
                return $3ee0473af38ba5b9$var$oneOf(loc.weekdays("long", true, false), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $3ee0473af38ba5b9$var$offset(new RegExp(`([+-]${oneOrTwo.source})(?::(${two.source}))?`), 2);
            case "ZZZ":
                return $3ee0473af38ba5b9$var$offset(new RegExp(`([+-]${oneOrTwo.source})(${two.source})?`), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $3ee0473af38ba5b9$var$simple(/[a-z_+-/]{1,256}?/i);
            default:
                return literal(t);
        }
    };
    const unit = unitate(token) || {
        invalidReason: $3ee0473af38ba5b9$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
const $3ee0473af38ba5b9$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour: {
        numeric: "h",
        "2-digit": "hh"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    }
};
function $3ee0473af38ba5b9$var$tokenForPart(part, locale, formatOpts) {
    const { type: type, value: value } = part;
    if (type === "literal") return {
        literal: true,
        val: value
    };
    const style = formatOpts[type];
    let val = $3ee0473af38ba5b9$var$partTypeStyleToTokenVal[type];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $3ee0473af38ba5b9$var$buildRegex(units) {
    const re = units.map((u)=>u.regex).reduce((f, r)=>`${f}(${r.source})`, "");
    return [
        `^${re}$`,
        units
    ];
}
function $3ee0473af38ba5b9$var$match(input, regex, handlers) {
    const matches = input.match(regex);
    if (matches) {
        const all = {};
        let matchIndex = 1;
        for(const i in handlers)if ((0, $37f3a6ffca6d953c$export$5a15a386532a5ea4)(handlers, i)) {
            const h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $3ee0473af38ba5b9$var$dateTimeFromMatches(matches) {
    const toField = (token)=>{
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    let zone = null;
    let specificOffset;
    if (!(0, $37f3a6ffca6d953c$export$fce6876652108ab)(matches.z)) zone = (0, $950478f3e6f849c2$export$2e2bcd8739ae039).create(matches.z);
    if (!(0, $37f3a6ffca6d953c$export$fce6876652108ab)(matches.Z)) {
        if (!zone) zone = new (0, $be616c40eb3ec295$export$2e2bcd8739ae039)(matches.Z);
        specificOffset = matches.Z;
    }
    if (!(0, $37f3a6ffca6d953c$export$fce6876652108ab)(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!(0, $37f3a6ffca6d953c$export$fce6876652108ab)(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!(0, $37f3a6ffca6d953c$export$fce6876652108ab)(matches.u)) matches.S = (0, $37f3a6ffca6d953c$export$3989d60cf160c565)(matches.u);
    const vals = Object.keys(matches).reduce((r, k)=>{
        const f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
let $3ee0473af38ba5b9$var$dummyDateTimeCache = null;
function $3ee0473af38ba5b9$var$getDummyDateTime() {
    if (!$3ee0473af38ba5b9$var$dummyDateTimeCache) $3ee0473af38ba5b9$var$dummyDateTimeCache = (0, $485b75493327b6f7$export$2e2bcd8739ae039).fromMillis(1555555555555);
    return $3ee0473af38ba5b9$var$dummyDateTimeCache;
}
function $3ee0473af38ba5b9$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    const formatOpts = (0, $35e0b627fa211618$export$2e2bcd8739ae039).macroTokenToFormatOpts(token.val);
    if (!formatOpts) return token;
    const formatter = (0, $35e0b627fa211618$export$2e2bcd8739ae039).create(locale, formatOpts);
    const parts = formatter.formatDateTimeParts($3ee0473af38ba5b9$var$getDummyDateTime());
    const tokens = parts.map((p)=>$3ee0473af38ba5b9$var$tokenForPart(p, locale, formatOpts));
    if (tokens.includes(undefined)) return token;
    return tokens;
}
function $3ee0473af38ba5b9$var$expandMacroTokens(tokens, locale) {
    return Array.prototype.concat(...tokens.map((t)=>$3ee0473af38ba5b9$var$maybeExpandMacroToken(t, locale)));
}
function $3ee0473af38ba5b9$export$8388bdfbc6b581fa(locale, input, format) {
    const tokens = $3ee0473af38ba5b9$var$expandMacroTokens((0, $35e0b627fa211618$export$2e2bcd8739ae039).parseFormat(format), locale), units = tokens.map((t)=>$3ee0473af38ba5b9$var$unitForToken(t, locale)), disqualifyingUnit = units.find((t)=>t.invalidReason);
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        const [regexString, handlers] = $3ee0473af38ba5b9$var$buildRegex(units), regex = RegExp(regexString, "i"), [rawMatches, matches] = $3ee0473af38ba5b9$var$match(input, regex, handlers), [result, zone, specificOffset] = matches ? $3ee0473af38ba5b9$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ];
        if ((0, $37f3a6ffca6d953c$export$5a15a386532a5ea4)(matches, "a") && (0, $37f3a6ffca6d953c$export$5a15a386532a5ea4)(matches, "H")) throw new (0, $886de9df440664a3$export$10234d3be7f66e6a)("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $3ee0473af38ba5b9$export$d3d42e05768c662d(locale, input, format) {
    const { result: result, zone: zone, specificOffset: specificOffset, invalidReason: invalidReason } = $3ee0473af38ba5b9$export$8388bdfbc6b581fa(locale, input, format);
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}





const $d08bd9aa0b0e0e54$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $d08bd9aa0b0e0e54$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $d08bd9aa0b0e0e54$var$unitOutOfRange(unit, value) {
    return new (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039)("unit out of range", `you specified ${value} (of type ${typeof value}) as a ${unit}, which is invalid`);
}
function $d08bd9aa0b0e0e54$var$dayOfWeek(year, month, day) {
    const d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    const js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $d08bd9aa0b0e0e54$var$computeOrdinal(year, month, day) {
    return day + ((0, $37f3a6ffca6d953c$export$553d7fa8e3805fc0)(year) ? $d08bd9aa0b0e0e54$var$leapLadder : $d08bd9aa0b0e0e54$var$nonLeapLadder)[month - 1];
}
function $d08bd9aa0b0e0e54$var$uncomputeOrdinal(year, ordinal) {
    const table = (0, $37f3a6ffca6d953c$export$553d7fa8e3805fc0)(year) ? $d08bd9aa0b0e0e54$var$leapLadder : $d08bd9aa0b0e0e54$var$nonLeapLadder, month0 = table.findIndex((i)=>i < ordinal), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
function $d08bd9aa0b0e0e54$export$5f982b63a73e30d5(gregObj) {
    const { year: year, month: month, day: day } = gregObj, ordinal = $d08bd9aa0b0e0e54$var$computeOrdinal(year, month, day), weekday = $d08bd9aa0b0e0e54$var$dayOfWeek(year, month, day);
    let weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = (0, $37f3a6ffca6d953c$export$fcb8e8d76a6f2959)(weekYear);
    } else if (weekNumber > (0, $37f3a6ffca6d953c$export$fcb8e8d76a6f2959)(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, (0, $37f3a6ffca6d953c$export$4401ec2a884d3d6f)(gregObj));
}
function $d08bd9aa0b0e0e54$export$82dcd477cc9ab67d(weekData) {
    const { weekYear: weekYear, weekNumber: weekNumber, weekday: weekday } = weekData, weekdayOfJan4 = $d08bd9aa0b0e0e54$var$dayOfWeek(weekYear, 1, 4), yearInDays = (0, $37f3a6ffca6d953c$export$3913210603d8e9ae)(weekYear);
    let ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += (0, $37f3a6ffca6d953c$export$3913210603d8e9ae)(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= (0, $37f3a6ffca6d953c$export$3913210603d8e9ae)(weekYear);
    } else year = weekYear;
    const { month: month, day: day } = $d08bd9aa0b0e0e54$var$uncomputeOrdinal(year, ordinal);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        year: year,
        month: month,
        day: day
    }, (0, $37f3a6ffca6d953c$export$4401ec2a884d3d6f)(weekData));
}
function $d08bd9aa0b0e0e54$export$78dea2ea345b4d9b(gregData) {
    const { year: year, month: month, day: day } = gregData;
    const ordinal = $d08bd9aa0b0e0e54$var$computeOrdinal(year, month, day);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        year: year,
        ordinal: ordinal
    }, (0, $37f3a6ffca6d953c$export$4401ec2a884d3d6f)(gregData));
}
function $d08bd9aa0b0e0e54$export$4ad8037b9961f2a(ordinalData) {
    const { year: year, ordinal: ordinal } = ordinalData;
    const { month: month, day: day } = $d08bd9aa0b0e0e54$var$uncomputeOrdinal(year, ordinal);
    return (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
        year: year,
        month: month,
        day: day
    }, (0, $37f3a6ffca6d953c$export$4401ec2a884d3d6f)(ordinalData));
}
function $d08bd9aa0b0e0e54$export$48544eeabe120519(obj) {
    const validYear = (0, $37f3a6ffca6d953c$export$a287f47fed4544b8)(obj.weekYear), validWeek = (0, $37f3a6ffca6d953c$export$9fe178c7471c91db)(obj.weekNumber, 1, (0, $37f3a6ffca6d953c$export$fcb8e8d76a6f2959)(obj.weekYear)), validWeekday = (0, $37f3a6ffca6d953c$export$9fe178c7471c91db)(obj.weekday, 1, 7);
    if (!validYear) return $d08bd9aa0b0e0e54$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $d08bd9aa0b0e0e54$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $d08bd9aa0b0e0e54$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $d08bd9aa0b0e0e54$export$32d428c9a6653964(obj) {
    const validYear = (0, $37f3a6ffca6d953c$export$a287f47fed4544b8)(obj.year), validOrdinal = (0, $37f3a6ffca6d953c$export$9fe178c7471c91db)(obj.ordinal, 1, (0, $37f3a6ffca6d953c$export$3913210603d8e9ae)(obj.year));
    if (!validYear) return $d08bd9aa0b0e0e54$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $d08bd9aa0b0e0e54$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $d08bd9aa0b0e0e54$export$b807d5063f9fabd1(obj) {
    const validYear = (0, $37f3a6ffca6d953c$export$a287f47fed4544b8)(obj.year), validMonth = (0, $37f3a6ffca6d953c$export$9fe178c7471c91db)(obj.month, 1, 12), validDay = (0, $37f3a6ffca6d953c$export$9fe178c7471c91db)(obj.day, 1, (0, $37f3a6ffca6d953c$export$4169ecd548fbc13a)(obj.year, obj.month));
    if (!validYear) return $d08bd9aa0b0e0e54$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $d08bd9aa0b0e0e54$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $d08bd9aa0b0e0e54$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $d08bd9aa0b0e0e54$export$f087c0ea5c760b87(obj) {
    const { hour: hour, minute: minute, second: second, millisecond: millisecond } = obj;
    const validHour = (0, $37f3a6ffca6d953c$export$9fe178c7471c91db)(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = (0, $37f3a6ffca6d953c$export$9fe178c7471c91db)(minute, 0, 59), validSecond = (0, $37f3a6ffca6d953c$export$9fe178c7471c91db)(second, 0, 59), validMillisecond = (0, $37f3a6ffca6d953c$export$9fe178c7471c91db)(millisecond, 0, 999);
    if (!validHour) return $d08bd9aa0b0e0e54$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $d08bd9aa0b0e0e54$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $d08bd9aa0b0e0e54$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $d08bd9aa0b0e0e54$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}





const $485b75493327b6f7$var$INVALID = "Invalid DateTime";
const $485b75493327b6f7$var$MAX_DATE = 8.64e15;
function $485b75493327b6f7$var$unsupportedZone(zone) {
    return new (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039)("unsupported zone", `the zone "${zone.name}" is not supported`);
}
// we cache week data on the DT object and this intermediates the cache
function $485b75493327b6f7$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = (0, $d08bd9aa0b0e0e54$export$5f982b63a73e30d5)(dt.c);
    return dt.weekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $485b75493327b6f7$var$clone(inst, alts) {
    const current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $485b75493327b6f7$export$2e2bcd8739ae039((0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, current, alts), {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $485b75493327b6f7$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    const o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    const o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $485b75493327b6f7$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    const d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $485b75493327b6f7$var$objToTS(obj, offset, zone) {
    return $485b75493327b6f7$var$fixOffset((0, $37f3a6ffca6d953c$export$c7c54c08b29e0736)(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $485b75493327b6f7$var$adjustTime(inst, dur) {
    const oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, inst.c), {
        year: year,
        month: month,
        day: Math.min(inst.c.day, (0, $37f3a6ffca6d953c$export$4169ecd548fbc13a)(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = (0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = (0, $37f3a6ffca6d953c$export$c7c54c08b29e0736)(c);
    let [ts, o] = $485b75493327b6f7$var$fixOffset(localTS, oPre, inst.zone);
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $485b75493327b6f7$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    const { setZone: setZone, zone: zone } = opts;
    if (parsed && Object.keys(parsed).length !== 0) {
        const interpretationZone = parsedZone || zone, inst = $485b75493327b6f7$export$2e2bcd8739ae039.fromObject(parsed, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, opts), {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $485b75493327b6f7$export$2e2bcd8739ae039.invalid(new (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039)("unparsable", `the input "${text}" can't be parsed as ${format}`));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $485b75493327b6f7$var$toTechFormat(dt, format, allowZ = true) {
    return dt.isValid ? (0, $35e0b627fa211618$export$2e2bcd8739ae039).create((0, $e692b3aca11585b0$export$2e2bcd8739ae039).create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $485b75493327b6f7$var$toISODate(o, extended) {
    const longFormat = o.c.year > 9999 || o.c.year < 0;
    let c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(o.c.month);
        c += "-";
        c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(o.c.day);
    } else {
        c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(o.c.month);
        c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(o.c.day);
    }
    return c;
}
function $485b75493327b6f7$var$toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    let c = (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(o.c.hour);
    if (extended) {
        c += ":";
        c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(o.c.minute);
        if (o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(o.c.minute);
    if (o.c.second !== 0 || !suppressSeconds) {
        c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(Math.trunc(-o.o / 60));
            c += ":";
            c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(Math.trunc(o.o / 60));
            c += ":";
            c += (0, $37f3a6ffca6d953c$export$36cf564d487b5178)(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
const $485b75493327b6f7$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $485b75493327b6f7$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $485b75493327b6f7$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
const $485b75493327b6f7$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $485b75493327b6f7$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $485b75493327b6f7$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $485b75493327b6f7$var$normalizeUnit(unit) {
    const normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new (0, $886de9df440664a3$export$ac94f561e2d387b4)(unit);
    return normalized;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $485b75493327b6f7$var$quickDT(obj, opts) {
    const zone = (0, $d46f30efbf427e5a$export$4527f24d1e617e9)(opts.zone, (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultZone), loc = (0, $e692b3aca11585b0$export$2e2bcd8739ae039).fromObject(opts), tsNow = (0, $30b5604947d63dd3$export$2e2bcd8739ae039).now();
    let ts, o;
    // assume we have the higher-order units
    if (!(0, $37f3a6ffca6d953c$export$fce6876652108ab)(obj.year)) {
        for (const u of $485b75493327b6f7$var$orderedUnits)if ((0, $37f3a6ffca6d953c$export$fce6876652108ab)(obj[u])) obj[u] = $485b75493327b6f7$var$defaultUnitValues[u];
        const invalid = (0, $d08bd9aa0b0e0e54$export$b807d5063f9fabd1)(obj) || (0, $d08bd9aa0b0e0e54$export$f087c0ea5c760b87)(obj);
        if (invalid) return $485b75493327b6f7$export$2e2bcd8739ae039.invalid(invalid);
        const offsetProvis = zone.offset(tsNow);
        [ts, o] = $485b75493327b6f7$var$objToTS(obj, offsetProvis, zone);
    } else ts = tsNow;
    return new $485b75493327b6f7$export$2e2bcd8739ae039({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $485b75493327b6f7$var$diffRelative(start, end, opts) {
    const round = (0, $37f3a6ffca6d953c$export$fce6876652108ab)(opts.round) ? true : opts.round, format = (c, unit)=>{
        c = (0, $37f3a6ffca6d953c$export$7978a6ddf29f4374)(c, round || opts.calendary ? 0 : 2, true);
        const formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = (unit)=>{
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for (const unit of opts.units){
        const count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $485b75493327b6f7$var$lastOpts(argList) {
    let opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
class $485b75493327b6f7$export$2e2bcd8739ae039 {
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ static now() {
        return new $485b75493327b6f7$export$2e2bcd8739ae039({});
    }
    /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ static local() {
        const [opts, args] = $485b75493327b6f7$var$lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        return $485b75493327b6f7$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    }
    /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ static utc() {
        const [opts, args] = $485b75493327b6f7$var$lastOpts(arguments), [year, month, day, hour, minute, second, millisecond] = args;
        opts.zone = (0, $be616c40eb3ec295$export$2e2bcd8739ae039).utcInstance;
        return $485b75493327b6f7$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    }
    /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ static fromJSDate(date, options = {}) {
        const ts = (0, $37f3a6ffca6d953c$export$871608497c498473)(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return $485b75493327b6f7$export$2e2bcd8739ae039.invalid("invalid input");
        const zoneToUse = (0, $d46f30efbf427e5a$export$4527f24d1e617e9)(options.zone, (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultZone);
        if (!zoneToUse.isValid) return $485b75493327b6f7$export$2e2bcd8739ae039.invalid($485b75493327b6f7$var$unsupportedZone(zoneToUse));
        return new $485b75493327b6f7$export$2e2bcd8739ae039({
            ts: ts,
            zone: zoneToUse,
            loc: (0, $e692b3aca11585b0$export$2e2bcd8739ae039).fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromMillis(milliseconds, options = {}) {
        if (!(0, $37f3a6ffca6d953c$export$7e4aa119212bc614)(milliseconds)) throw new (0, $886de9df440664a3$export$9c711d4a95378233)(`fromMillis requires a numerical input, but received a ${typeof milliseconds} with value ${milliseconds}`);
        else if (milliseconds < -$485b75493327b6f7$var$MAX_DATE || milliseconds > $485b75493327b6f7$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return $485b75493327b6f7$export$2e2bcd8739ae039.invalid("Timestamp out of range");
        else return new $485b75493327b6f7$export$2e2bcd8739ae039({
            ts: milliseconds,
            zone: (0, $d46f30efbf427e5a$export$4527f24d1e617e9)(options.zone, (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultZone),
            loc: (0, $e692b3aca11585b0$export$2e2bcd8739ae039).fromObject(options)
        });
    }
    /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromSeconds(seconds, options = {}) {
        if (!(0, $37f3a6ffca6d953c$export$7e4aa119212bc614)(seconds)) throw new (0, $886de9df440664a3$export$9c711d4a95378233)("fromSeconds requires a numerical input");
        else return new $485b75493327b6f7$export$2e2bcd8739ae039({
            ts: seconds * 1000,
            zone: (0, $d46f30efbf427e5a$export$4527f24d1e617e9)(options.zone, (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultZone),
            loc: (0, $e692b3aca11585b0$export$2e2bcd8739ae039).fromObject(options)
        });
    }
    /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */ static fromObject(obj, opts = {}) {
        obj = obj || {};
        const zoneToUse = (0, $d46f30efbf427e5a$export$4527f24d1e617e9)(opts.zone, (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultZone);
        if (!zoneToUse.isValid) return $485b75493327b6f7$export$2e2bcd8739ae039.invalid($485b75493327b6f7$var$unsupportedZone(zoneToUse));
        const tsNow = (0, $30b5604947d63dd3$export$2e2bcd8739ae039).now(), offsetProvis = !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = (0, $37f3a6ffca6d953c$export$ba17feb4405f3f38)(obj, $485b75493327b6f7$var$normalizeUnit), containsOrdinal = !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.ordinal), containsGregorYear = !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.year), containsGregorMD = !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.month) || !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = (0, $e692b3aca11585b0$export$2e2bcd8739ae039).fromObject(opts);
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new (0, $886de9df440664a3$export$10234d3be7f66e6a)("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new (0, $886de9df440664a3$export$10234d3be7f66e6a)("Can't mix ordinal dates with month/day");
        const useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        let units, defaultValues, objNow = $485b75493327b6f7$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $485b75493327b6f7$var$orderedWeekUnits;
            defaultValues = $485b75493327b6f7$var$defaultWeekUnitValues;
            objNow = (0, $d08bd9aa0b0e0e54$export$5f982b63a73e30d5)(objNow);
        } else if (containsOrdinal) {
            units = $485b75493327b6f7$var$orderedOrdinalUnits;
            defaultValues = $485b75493327b6f7$var$defaultOrdinalUnitValues;
            objNow = (0, $d08bd9aa0b0e0e54$export$78dea2ea345b4d9b)(objNow);
        } else {
            units = $485b75493327b6f7$var$orderedUnits;
            defaultValues = $485b75493327b6f7$var$defaultUnitValues;
        }
        // set default values for missing stuff
        let foundFirst = false;
        for (const u of units){
            const v = normalized[u];
            if (!(0, $37f3a6ffca6d953c$export$fce6876652108ab)(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        const higherOrderInvalid = useWeekData ? (0, $d08bd9aa0b0e0e54$export$48544eeabe120519)(normalized) : containsOrdinal ? (0, $d08bd9aa0b0e0e54$export$32d428c9a6653964)(normalized) : (0, $d08bd9aa0b0e0e54$export$b807d5063f9fabd1)(normalized), invalid = higherOrderInvalid || (0, $d08bd9aa0b0e0e54$export$f087c0ea5c760b87)(normalized);
        if (invalid) return $485b75493327b6f7$export$2e2bcd8739ae039.invalid(invalid);
        // compute the actual time
        const gregorian = useWeekData ? (0, $d08bd9aa0b0e0e54$export$82dcd477cc9ab67d)(normalized) : containsOrdinal ? (0, $d08bd9aa0b0e0e54$export$4ad8037b9961f2a)(normalized) : normalized, [tsFinal, offsetFinal] = $485b75493327b6f7$var$objToTS(gregorian, offsetProvis, zoneToUse), inst = new $485b75493327b6f7$export$2e2bcd8739ae039({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return $485b75493327b6f7$export$2e2bcd8739ae039.invalid("mismatched weekday", `you can't specify both a weekday of ${normalized.weekday} and a date of ${inst.toISO()}`);
        return inst;
    }
    /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ static fromISO(text, opts = {}) {
        const [vals, parsedZone] = (0, $d9e03d2ca5209f90$export$ee8e61141c87635a)(text);
        return $485b75493327b6f7$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    }
    /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ static fromRFC2822(text, opts = {}) {
        const [vals, parsedZone] = (0, $d9e03d2ca5209f90$export$22671fa29093a82f)(text);
        return $485b75493327b6f7$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    }
    /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ static fromHTTP(text, opts = {}) {
        const [vals, parsedZone] = (0, $d9e03d2ca5209f90$export$6eac75d7e2e61231)(text);
        return $485b75493327b6f7$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    }
    /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ static fromFormat(text, fmt, opts = {}) {
        if ((0, $37f3a6ffca6d953c$export$fce6876652108ab)(text) || (0, $37f3a6ffca6d953c$export$fce6876652108ab)(fmt)) throw new (0, $886de9df440664a3$export$9c711d4a95378233)("fromFormat requires an input string and a format");
        const { locale: locale = null, numberingSystem: numberingSystem = null } = opts, localeToUse = (0, $e692b3aca11585b0$export$2e2bcd8739ae039).fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), [vals, parsedZone, specificOffset, invalid] = (0, $3ee0473af38ba5b9$export$d3d42e05768c662d)(localeToUse, text, fmt);
        if (invalid) return $485b75493327b6f7$export$2e2bcd8739ae039.invalid(invalid);
        else return $485b75493327b6f7$var$parseDataToDateTime(vals, parsedZone, opts, `format ${fmt}`, text, specificOffset);
    }
    /**
   * @deprecated use fromFormat instead
   */ static fromString(text, fmt, opts = {}) {
        return $485b75493327b6f7$export$2e2bcd8739ae039.fromFormat(text, fmt, opts);
    }
    /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ static fromSQL(text, opts = {}) {
        const [vals, parsedZone] = (0, $d9e03d2ca5209f90$export$425a58f41d7e6b1e)(text);
        return $485b75493327b6f7$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    }
    /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ static invalid(reason, explanation = null) {
        if (!reason) throw new (0, $886de9df440664a3$export$9c711d4a95378233)("need to specify a reason the DateTime is invalid");
        const invalid = reason instanceof (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039) ? reason : new (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039)(reason, explanation);
        if ((0, $30b5604947d63dd3$export$2e2bcd8739ae039).throwOnInvalid) throw new (0, $886de9df440664a3$export$aaeef2cf7fd7967f)(invalid);
        else return new $485b75493327b6f7$export$2e2bcd8739ae039({
            invalid: invalid
        });
    }
    /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ static isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    }
    // INFO
    /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ get(unit) {
        return this[unit];
    }
    /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ get isValid() {
        return this.invalid === null;
    }
    /**
   * Returns an error code if this DateTime is invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidReason() {
        return this.invalid ? this.invalid.reason : null;
    }
    /**
   * Returns an explanation of why this DateTime became invalid, or null if the DateTime is valid
   * @type {string}
   */ get invalidExplanation() {
        return this.invalid ? this.invalid.explanation : null;
    }
    /**
   * Get the locale of a DateTime, such 'en-GB'. The locale is used when formatting the DateTime
   *
   * @type {string}
   */ get locale() {
        return this.isValid ? this.loc.locale : null;
    }
    /**
   * Get the numbering system of a DateTime, such 'beng'. The numbering system is used when formatting the DateTime
   *
   * @type {string}
   */ get numberingSystem() {
        return this.isValid ? this.loc.numberingSystem : null;
    }
    /**
   * Get the output calendar of a DateTime, such 'islamic'. The output calendar is used when formatting the DateTime
   *
   * @type {string}
   */ get outputCalendar() {
        return this.isValid ? this.loc.outputCalendar : null;
    }
    /**
   * Get the time zone associated with this DateTime.
   * @type {Zone}
   */ get zone() {
        return this._zone;
    }
    /**
   * Get the name of the time zone.
   * @type {string}
   */ get zoneName() {
        return this.isValid ? this.zone.name : null;
    }
    /**
   * Get the year
   * @example DateTime.local(2017, 5, 25).year //=> 2017
   * @type {number}
   */ get year() {
        return this.isValid ? this.c.year : NaN;
    }
    /**
   * Get the quarter
   * @example DateTime.local(2017, 5, 25).quarter //=> 2
   * @type {number}
   */ get quarter() {
        return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
    }
    /**
   * Get the month (1-12).
   * @example DateTime.local(2017, 5, 25).month //=> 5
   * @type {number}
   */ get month() {
        return this.isValid ? this.c.month : NaN;
    }
    /**
   * Get the day of the month (1-30ish).
   * @example DateTime.local(2017, 5, 25).day //=> 25
   * @type {number}
   */ get day() {
        return this.isValid ? this.c.day : NaN;
    }
    /**
   * Get the hour of the day (0-23).
   * @example DateTime.local(2017, 5, 25, 9).hour //=> 9
   * @type {number}
   */ get hour() {
        return this.isValid ? this.c.hour : NaN;
    }
    /**
   * Get the minute of the hour (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30).minute //=> 30
   * @type {number}
   */ get minute() {
        return this.isValid ? this.c.minute : NaN;
    }
    /**
   * Get the second of the minute (0-59).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52).second //=> 52
   * @type {number}
   */ get second() {
        return this.isValid ? this.c.second : NaN;
    }
    /**
   * Get the millisecond of the second (0-999).
   * @example DateTime.local(2017, 5, 25, 9, 30, 52, 654).millisecond //=> 654
   * @type {number}
   */ get millisecond() {
        return this.isValid ? this.c.millisecond : NaN;
    }
    /**
   * Get the week year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 12, 31).weekYear //=> 2015
   * @type {number}
   */ get weekYear() {
        return this.isValid ? $485b75493327b6f7$var$possiblyCachedWeekData(this).weekYear : NaN;
    }
    /**
   * Get the week number of the week year (1-52ish).
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2017, 5, 25).weekNumber //=> 21
   * @type {number}
   */ get weekNumber() {
        return this.isValid ? $485b75493327b6f7$var$possiblyCachedWeekData(this).weekNumber : NaN;
    }
    /**
   * Get the day of the week.
   * 1 is Monday and 7 is Sunday
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2014, 11, 31).weekday //=> 4
   * @type {number}
   */ get weekday() {
        return this.isValid ? $485b75493327b6f7$var$possiblyCachedWeekData(this).weekday : NaN;
    }
    /**
   * Get the ordinal (meaning the day of the year)
   * @example DateTime.local(2017, 5, 25).ordinal //=> 145
   * @type {number|DateTime}
   */ get ordinal() {
        return this.isValid ? (0, $d08bd9aa0b0e0e54$export$78dea2ea345b4d9b)(this.c).ordinal : NaN;
    }
    /**
   * Get the human readable short month name, such as 'Oct'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthShort //=> Oct
   * @type {string}
   */ get monthShort() {
        return this.isValid ? (0, $8133d12953b92b37$export$2e2bcd8739ae039).months("short", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable long month name, such as 'October'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).monthLong //=> October
   * @type {string}
   */ get monthLong() {
        return this.isValid ? (0, $8133d12953b92b37$export$2e2bcd8739ae039).months("long", {
            locObj: this.loc
        })[this.month - 1] : null;
    }
    /**
   * Get the human readable short weekday, such as 'Mon'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayShort //=> Mon
   * @type {string}
   */ get weekdayShort() {
        return this.isValid ? (0, $8133d12953b92b37$export$2e2bcd8739ae039).weekdays("short", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the human readable long weekday, such as 'Monday'.
   * Defaults to the system's locale if no locale has been specified
   * @example DateTime.local(2017, 10, 30).weekdayLong //=> Monday
   * @type {string}
   */ get weekdayLong() {
        return this.isValid ? (0, $8133d12953b92b37$export$2e2bcd8739ae039).weekdays("long", {
            locObj: this.loc
        })[this.weekday - 1] : null;
    }
    /**
   * Get the UTC offset of this DateTime in minutes
   * @example DateTime.now().offset //=> -240
   * @example DateTime.utc().offset //=> 0
   * @type {number}
   */ get offset() {
        return this.isValid ? +this.o : NaN;
    }
    /**
   * Get the short human name for the zone's current offset, for example "EST" or "EDT".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameShort() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "short",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get the long human name for the zone's current offset, for example "Eastern Standard Time" or "Eastern Daylight Time".
   * Defaults to the system's locale if no locale has been specified
   * @type {string}
   */ get offsetNameLong() {
        if (this.isValid) return this.zone.offsetName(this.ts, {
            format: "long",
            locale: this.locale
        });
        else return null;
    }
    /**
   * Get whether this zone's offset ever changes, as in a DST.
   * @type {boolean}
   */ get isOffsetFixed() {
        return this.isValid ? this.zone.isUniversal : null;
    }
    /**
   * Get whether the DateTime is in a DST.
   * @type {boolean}
   */ get isInDST() {
        if (this.isOffsetFixed) return false;
        else return this.offset > this.set({
            month: 1,
            day: 1
        }).offset || this.offset > this.set({
            month: 5
        }).offset;
    }
    /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ get isInLeapYear() {
        return (0, $37f3a6ffca6d953c$export$553d7fa8e3805fc0)(this.year);
    }
    /**
   * Returns the number of days in this DateTime's month
   * @example DateTime.local(2016, 2).daysInMonth //=> 29
   * @example DateTime.local(2016, 3).daysInMonth //=> 31
   * @type {number}
   */ get daysInMonth() {
        return (0, $37f3a6ffca6d953c$export$4169ecd548fbc13a)(this.year, this.month);
    }
    /**
   * Returns the number of days in this DateTime's year
   * @example DateTime.local(2016).daysInYear //=> 366
   * @example DateTime.local(2013).daysInYear //=> 365
   * @type {number}
   */ get daysInYear() {
        return this.isValid ? (0, $37f3a6ffca6d953c$export$3913210603d8e9ae)(this.year) : NaN;
    }
    /**
   * Returns the number of weeks in this DateTime's year
   * @see https://en.wikipedia.org/wiki/ISO_week_date
   * @example DateTime.local(2004).weeksInWeekYear //=> 53
   * @example DateTime.local(2013).weeksInWeekYear //=> 52
   * @type {number}
   */ get weeksInWeekYear() {
        return this.isValid ? (0, $37f3a6ffca6d953c$export$fcb8e8d76a6f2959)(this.weekYear) : NaN;
    }
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ resolvedLocaleOptions(opts = {}) {
        const { locale: locale, numberingSystem: numberingSystem, calendar: calendar } = (0, $35e0b627fa211618$export$2e2bcd8739ae039).create(this.loc.clone(opts), opts).resolvedOptions(this);
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    }
    // TRANSFORM
    /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ toUTC(offset = 0, opts = {}) {
        return this.setZone((0, $be616c40eb3ec295$export$2e2bcd8739ae039).instance(offset), opts);
    }
    /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ toLocal() {
        return this.setZone((0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultZone);
    }
    /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ setZone(zone, { keepLocalTime: keepLocalTime = false, keepCalendarTime: keepCalendarTime = false } = {}) {
        zone = (0, $d46f30efbf427e5a$export$4527f24d1e617e9)(zone, (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return $485b75493327b6f7$export$2e2bcd8739ae039.invalid($485b75493327b6f7$var$unsupportedZone(zone));
        else {
            let newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                const offsetGuess = zone.offset(this.ts);
                const asObj = this.toObject();
                [newTS] = $485b75493327b6f7$var$objToTS(asObj, offsetGuess, zone);
            }
            return $485b75493327b6f7$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    }
    /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ reconfigure({ locale: locale, numberingSystem: numberingSystem, outputCalendar: outputCalendar } = {}) {
        const loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $485b75493327b6f7$var$clone(this, {
            loc: loc
        });
    }
    /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    }
    /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ set(values) {
        if (!this.isValid) return this;
        const normalized = (0, $37f3a6ffca6d953c$export$ba17feb4405f3f38)(values, $485b75493327b6f7$var$normalizeUnit), settingWeekStuff = !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.weekYear) || !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.weekNumber) || !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.weekday), containsOrdinal = !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.ordinal), containsGregorYear = !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.year), containsGregorMD = !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.month) || !(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new (0, $886de9df440664a3$export$10234d3be7f66e6a)("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new (0, $886de9df440664a3$export$10234d3be7f66e6a)("Can't mix ordinal dates with month/day");
        let mixed;
        if (settingWeekStuff) mixed = (0, $d08bd9aa0b0e0e54$export$82dcd477cc9ab67d)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $d08bd9aa0b0e0e54$export$5f982b63a73e30d5)(this.c), normalized));
        else if (!(0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.ordinal)) mixed = (0, $d08bd9aa0b0e0e54$export$4ad8037b9961f2a)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, (0, $d08bd9aa0b0e0e54$export$78dea2ea345b4d9b)(this.c), normalized));
        else {
            mixed = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ((0, $37f3a6ffca6d953c$export$fce6876652108ab)(normalized.day)) mixed.day = Math.min((0, $37f3a6ffca6d953c$export$4169ecd548fbc13a)(mixed.year, mixed.month), mixed.day);
        }
        const [ts, o] = $485b75493327b6f7$var$objToTS(mixed, this.o, this.zone);
        return $485b75493327b6f7$var$clone(this, {
            ts: ts,
            o: o
        });
    }
    /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ plus(duration) {
        if (!this.isValid) return this;
        const dur = (0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromDurationLike(duration);
        return $485b75493327b6f7$var$clone(this, $485b75493327b6f7$var$adjustTime(this, dur));
    }
    /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ minus(duration) {
        if (!this.isValid) return this;
        const dur = (0, $0c452a562a879a0d$export$2e2bcd8739ae039).fromDurationLike(duration).negate();
        return $485b75493327b6f7$var$clone(this, $485b75493327b6f7$var$adjustTime(this, dur));
    }
    /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ startOf(unit) {
        if (!this.isValid) return this;
        const o = {}, normalizedUnit = (0, $0c452a562a879a0d$export$2e2bcd8739ae039).normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
            case "milliseconds":
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            const q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    }
    /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ endOf(unit) {
        return this.isValid ? this.plus({
            [unit]: 1
        }).startOf(unit).minus(1) : this;
    }
    // OUTPUT
    /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ toFormat(fmt, opts = {}) {
        return this.isValid ? (0, $35e0b627fa211618$export$2e2bcd8739ae039).create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $485b75493327b6f7$var$INVALID;
    }
    /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString({ locale: 'en-gb' }); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ toLocaleString(formatOpts = $58f58a4a5bb96d49$export$19db5ed0dfbf6b4, opts = {}) {
        return this.isValid ? (0, $35e0b627fa211618$export$2e2bcd8739ae039).create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $485b75493327b6f7$var$INVALID;
    }
    /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ toLocaleParts(opts = {}) {
        return this.isValid ? (0, $35e0b627fa211618$export$2e2bcd8739ae039).create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ toISO({ format: format = "extended", suppressSeconds: suppressSeconds = false, suppressMilliseconds: suppressMilliseconds = false, includeOffset: includeOffset = true, extendedZone: extendedZone = false } = {}) {
        if (!this.isValid) return null;
        const ext = format === "extended";
        let c = $485b75493327b6f7$var$toISODate(this, ext);
        c += "T";
        c += $485b75493327b6f7$var$toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ toISODate({ format: format = "extended" } = {}) {
        if (!this.isValid) return null;
        return $485b75493327b6f7$var$toISODate(this, format === "extended");
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ toISOWeekDate() {
        return $485b75493327b6f7$var$toTechFormat(this, "kkkk-'W'WW-c");
    }
    /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ toISOTime({ suppressMilliseconds: suppressMilliseconds = false, suppressSeconds: suppressSeconds = false, includeOffset: includeOffset = true, includePrefix: includePrefix = false, extendedZone: extendedZone = false, format: format = "extended" } = {}) {
        if (!this.isValid) return null;
        let c = includePrefix ? "T" : "";
        return c + $485b75493327b6f7$var$toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    }
    /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ toRFC2822() {
        return $485b75493327b6f7$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ toHTTP() {
        return $485b75493327b6f7$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ toSQLDate() {
        if (!this.isValid) return null;
        return $485b75493327b6f7$var$toISODate(this, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ toSQLTime({ includeOffset: includeOffset = true, includeZone: includeZone = false, includeOffsetSpace: includeOffsetSpace = true } = {}) {
        let fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $485b75493327b6f7$var$toTechFormat(this, fmt, true);
    }
    /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ toSQL(opts = {}) {
        if (!this.isValid) return null;
        return `${this.toSQLDate()} ${this.toSQLTime(opts)}`;
    }
    /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ toString() {
        return this.isValid ? this.toISO() : $485b75493327b6f7$var$INVALID;
    }
    /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ valueOf() {
        return this.toMillis();
    }
    /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ toMillis() {
        return this.isValid ? this.ts : NaN;
    }
    /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    }
    /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    }
    /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ toJSON() {
        return this.toISO();
    }
    /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ toBSON() {
        return this.toJSDate();
    }
    /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ toObject(opts = {}) {
        if (!this.isValid) return {};
        const base = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    }
    /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    }
    // COMPARE
    /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ diff(otherDateTime, unit = "milliseconds", opts = {}) {
        if (!this.isValid || !otherDateTime.isValid) return (0, $0c452a562a879a0d$export$2e2bcd8739ae039).invalid("created by diffing an invalid DateTime");
        const durOpts = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        const units = (0, $37f3a6ffca6d953c$export$334480083959f08a)(unit).map((0, $0c452a562a879a0d$export$2e2bcd8739ae039).normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = (0, $30b136513522fd0b$export$2e2bcd8739ae039)(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    }
    /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ diffNow(unit = "milliseconds", opts = {}) {
        return this.diff($485b75493327b6f7$export$2e2bcd8739ae039.now(), unit, opts);
    }
    /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ until(otherDateTime) {
        return this.isValid ? (0, $b3e55c7f0c6f7168$export$2e2bcd8739ae039).fromDateTimes(this, otherDateTime) : this;
    }
    /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        const inputMs = otherDateTime.valueOf();
        const adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
    }
    /**
   * Equality check
   * Two DateTimes are equal iff they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    }
    /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ toRelative(options = {}) {
        if (!this.isValid) return null;
        const base = options.base || $485b75493327b6f7$export$2e2bcd8739ae039.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        let units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        let unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $485b75493327b6f7$var$diffRelative(base, this.plus(padding), (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            numeric: "always",
            units: units,
            unit: unit
        }));
    }
    /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ toRelativeCalendar(options = {}) {
        if (!this.isValid) return null;
        return $485b75493327b6f7$var$diffRelative(options.base || $485b75493327b6f7$export$2e2bcd8739ae039.fromObject({}, {
            zone: this.zone
        }), this, (0, $1c481e73824c6361$export$71511d61b312f219)((0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, options), {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    }
    /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ static min(...dateTimes) {
        if (!dateTimes.every($485b75493327b6f7$export$2e2bcd8739ae039.isDateTime)) throw new (0, $886de9df440664a3$export$9c711d4a95378233)("min requires all arguments be DateTimes");
        return (0, $37f3a6ffca6d953c$export$d322b949ce403225)(dateTimes, (i)=>i.valueOf(), Math.min);
    }
    /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ static max(...dateTimes) {
        if (!dateTimes.every($485b75493327b6f7$export$2e2bcd8739ae039.isDateTime)) throw new (0, $886de9df440664a3$export$9c711d4a95378233)("max requires all arguments be DateTimes");
        return (0, $37f3a6ffca6d953c$export$d322b949ce403225)(dateTimes, (i)=>i.valueOf(), Math.max);
    }
    // MISC
    /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ static fromFormatExplain(text, fmt, options = {}) {
        const { locale: locale = null, numberingSystem: numberingSystem = null } = options, localeToUse = (0, $e692b3aca11585b0$export$2e2bcd8739ae039).fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return (0, $3ee0473af38ba5b9$export$8388bdfbc6b581fa)(localeToUse, text, fmt);
    }
    /**
   * @deprecated use fromFormatExplain instead
   */ static fromStringExplain(text, fmt, options = {}) {
        return $485b75493327b6f7$export$2e2bcd8739ae039.fromFormatExplain(text, fmt, options);
    }
    // FORMAT PRESETS
    /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ static get DATE_SHORT() {
        return $58f58a4a5bb96d49$export$19db5ed0dfbf6b4;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED() {
        return $58f58a4a5bb96d49$export$7f19f128b5a661d5;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, Oct 14, 1983'
   * @type {Object}
   */ static get DATE_MED_WITH_WEEKDAY() {
        return $58f58a4a5bb96d49$export$7afd5e65ff14ad5f;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983'
   * @type {Object}
   */ static get DATE_FULL() {
        return $58f58a4a5bb96d49$export$e8af1c0b0290dbe2;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Tuesday, October 14, 1983'
   * @type {Object}
   */ static get DATE_HUGE() {
        return $58f58a4a5bb96d49$export$ab5c0d098dcfe775;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_SIMPLE() {
        return $58f58a4a5bb96d49$export$b4941e7fc62df1ff;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SECONDS() {
        return $58f58a4a5bb96d49$export$61c7c50acaa56067;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_SHORT_OFFSET() {
        return $58f58a4a5bb96d49$export$417ed025e483567;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get TIME_WITH_LONG_OFFSET() {
        return $58f58a4a5bb96d49$export$e0d12640fceb849c;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30', always 24-hour.
   * @type {Object}
   */ static get TIME_24_SIMPLE() {
        return $58f58a4a5bb96d49$export$7333d0894ea2a492;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SECONDS() {
        return $58f58a4a5bb96d49$export$2664018dfbf7eca;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 EDT', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_SHORT_OFFSET() {
        return $58f58a4a5bb96d49$export$3f5c467c8b3c85f6;
    }
    /**
   * {@link DateTime#toLocaleString} format like '09:30:23 Eastern Daylight Time', always 24-hour.
   * @type {Object}
   */ static get TIME_24_WITH_LONG_OFFSET() {
        return $58f58a4a5bb96d49$export$edc722d6385d5cfa;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT() {
        return $58f58a4a5bb96d49$export$434cdda648f6d8ed;
    }
    /**
   * {@link DateTime#toLocaleString} format like '10/14/1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_SHORT_WITH_SECONDS() {
        return $58f58a4a5bb96d49$export$115df8ec21cc4422;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED() {
        return $58f58a4a5bb96d49$export$2a10deefdeef9026;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Oct 14, 1983, 9:30:33 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_SECONDS() {
        return $58f58a4a5bb96d49$export$652ead5a5aee93d0;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Fri, 14 Oct 1983, 9:30 AM'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_MED_WITH_WEEKDAY() {
        return $58f58a4a5bb96d49$export$97006f3c2fab9954;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL() {
        return $58f58a4a5bb96d49$export$6fbcfb06dd40694b;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'October 14, 1983, 9:30:33 AM EDT'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_FULL_WITH_SECONDS() {
        return $58f58a4a5bb96d49$export$9ae9ad238dcfe6df;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE() {
        return $58f58a4a5bb96d49$export$c01f9be9042ca6d2;
    }
    /**
   * {@link DateTime#toLocaleString} format like 'Friday, October 14, 1983, 9:30:33 AM Eastern Daylight Time'. Only 12-hour if the locale is.
   * @type {Object}
   */ static get DATETIME_HUGE_WITH_SECONDS() {
        return $58f58a4a5bb96d49$export$c3b12c6a0fb1f516;
    }
    /**
   * @access private
   */ constructor(config){
        const zone = config.zone || (0, $30b5604947d63dd3$export$2e2bcd8739ae039).defaultZone;
        let invalid = config.invalid || (Number.isNaN(config.ts) ? new (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039)("invalid input") : null) || (!zone.isValid ? $485b75493327b6f7$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = (0, $37f3a6ffca6d953c$export$fce6876652108ab)(config.ts) ? (0, $30b5604947d63dd3$export$2e2bcd8739ae039).now() : config.ts;
        let c = null, o = null;
        if (!invalid) {
            const unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) [c, o] = [
                config.old.c,
                config.old.o
            ];
            else {
                const ot = zone.offset(this.ts);
                c = $485b75493327b6f7$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new (0, $5f1edb5a58b87e86$export$2e2bcd8739ae039)("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || (0, $e692b3aca11585b0$export$2e2bcd8739ae039).create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
}
function $485b75493327b6f7$export$d207855dff529fc9(dateTimeish) {
    if ($485b75493327b6f7$export$2e2bcd8739ae039.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && (0, $37f3a6ffca6d953c$export$7e4aa119212bc614)(dateTimeish.valueOf())) return $485b75493327b6f7$export$2e2bcd8739ae039.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $485b75493327b6f7$export$2e2bcd8739ae039.fromObject(dateTimeish);
    else throw new (0, $886de9df440664a3$export$9c711d4a95378233)(`Unknown datetime argument: ${dateTimeish}, of type ${typeof dateTimeish}`);
}











const $a1c260a57b985722$export$a4ad2735b021c132 = "2.5.2";









var $7fPBF = parcelRequire("7fPBF");




function $a879c7c9b4e34f4c$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [showProgressIndicator, setShowProgressIndicator] = (0, $7fPBF.useState)(false);
    const [showSuccess, setShowSuccess] = (0, $7fPBF.useState)(false);
    const [totalSent, setTotalSent] = (0, $7fPBF.useState)(0);
    const [totalFailed, setTotalFailed] = (0, $7fPBF.useState)(0);
    const [error, setError] = (0, $7fPBF.useState)(null);
    (0, $7fPBF.useEffect)(()=>{
        if (!props.isOpen) return;
        setError(null);
        setShowProgressIndicator(false);
        setShowSuccess(false);
    }, [
        props.isOpen
    ]);
    const sendWaiverReminder = async ()=>{
        setShowProgressIndicator(true);
        try {
            var _response_body, _response_body1;
            const response = await (0, $6857e104788587b0$export$2e2bcd8739ae039).sendWaiverReminderEmails(props.event.churchID, props.event.id, auth);
            if (response.error) {
                setError(response.error);
                return;
            }
            var _response_body_totalSent;
            setTotalSent((_response_body_totalSent = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.totalSent) !== null && _response_body_totalSent !== void 0 ? _response_body_totalSent : 0);
            var _response_body_totalFailed;
            setTotalFailed((_response_body_totalFailed = (_response_body1 = response.body) === null || _response_body1 === void 0 ? void 0 : _response_body1.totalFailed) !== null && _response_body_totalFailed !== void 0 ? _response_body_totalFailed : 0);
            setShowSuccess(true);
        } catch (e) {
            setError(e);
        } finally{
            setShowProgressIndicator(false);
        }
    };
    const closeButton = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        className: "close",
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            props.close();
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
            className: "icon",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
            alt: "Close icon"
        })
    });
    const hideFooterButtons = showProgressIndicator || showSuccess || error !== null;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "waiver-reminder-modal",
        isOpen: props.isOpen,
        footerButtons: hideFooterButtons ? [] : [
            {
                title: 'Send Reminder Email',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                onClick: ()=>{
                    sendWaiverReminder();
                }
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            style: {
                paddingTop: 32
            },
            children: showProgressIndicator ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                fullScreen: false
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    closeButton,
                    showSuccess ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9f2c42b26582cc85$export$2e2bcd8739ae039), {
                        title: "Reminders Sent",
                        description: `Successfully sent ${totalSent} reminder email${totalSent == 1 ? '' : 's'}.` + (totalFailed > 0 ? ` (${totalFailed} failed to send. Please contact support.)` : "")
                    }) : null,
                    error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                        error: error,
                        showButton: false
                    }),
                    !error && !showSuccess ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                children: "Confirm Waiver Reminder Email"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "Would you like to send a reminder to all attendees who have not completed their waivers? This action cannot be undone."
                            })
                        ]
                    }) : null
                ]
            })
        })
    });
}














var $7fPBF = parcelRequire("7fPBF");
var $5cac7a7b6d0c0db7$exports = {};
$5cac7a7b6d0c0db7$exports = $parcel$resolve("9YVV8");


var $436c0d5fb2f377a3$exports = {};
$436c0d5fb2f377a3$exports = $parcel$resolve("ktzxf");






function $75c3ed5f39befefd$export$2e2bcd8739ae039(props) {
    const { connectionStatus: connectionStatus, church: church } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [showManualWaiverCreation, setShowManualWaiverCreation] = (0, $7fPBF.useState)(false);
    const [selectedProvider, setSelectedProvider] = (0, $7fPBF.useState)(null);
    const [selectedWaiver, setSelectedWaiver] = (0, $7fPBF.useState)(null);
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const [showSuccess, setShowSuccess] = (0, $7fPBF.useState)(false);
    const [saveError, setSaveError] = (0, $7fPBF.useState)(null);
    const [externalWaivers, setExternalWaivers] = (0, $7fPBF.useState)(null);
    const [externalWaiverLoadingError, setExternalWaiversLoadingError] = (0, $7fPBF.useState)(null);
    const [waiverInstructions, setWaiverInstructions] = (0, $7fPBF.useState)(null);
    const fetchExternalWaivers = (0, $7fPBF.useCallback)(async ()=>{
        if (!selectedProvider || !church) return;
        try {
            const response = await (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchAvailableExternalWaivers(church.id, selectedProvider, auth);
            if (response.body) {
                setExternalWaivers(response.body.externalWaivers);
                setExternalWaiversLoadingError(null);
            } else {
                setExternalWaivers(null);
                setExternalWaiversLoadingError(response.error || "Failed to load available waivers from that provider.");
            }
        } catch (error) {
            setExternalWaiversLoadingError(error);
        }
    }, [
        selectedProvider,
        church
    ]);
    const attachExternalWaiver = async (externalWaiver)=>{
        save(()=>(0, $6857e104788587b0$export$2e2bcd8739ae039).attachExternalWaiverToEvent(props.event.churchID, props.event.id, externalWaiver, waiverInstructions, auth));
    };
    const createWaiver = async (name, url, instructions)=>{
        save(()=>(0, $6857e104788587b0$export$2e2bcd8739ae039).createManualWaiverForEvent(props.event.churchID, props.event.id, {
                name: name,
                url: url,
                instructions: instructions
            }, auth));
    };
    const save = async (action)=>{
        setSaving(true);
        try {
            const response = await action();
            if (response.error) {
                setSaveError(response.error);
                return;
            }
            const body = response.body;
            if (body) props.updateEvent(body.event);
            setShowSuccess(true);
        } catch (e) {
            setSaveError(e);
        } finally{
            setSaving(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!props.isOpen) return;
        setSaveError(null);
        setSaving(false);
        setShowSuccess(false);
        setSelectedProvider(null);
        setExternalWaivers(null);
        setExternalWaiversLoadingError(null);
        setSelectedWaiver(null);
        setShowManualWaiverCreation(false);
    }, [
        props.isOpen
    ]);
    const optionsForm = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $77186c032b6447f6$export$2e2bcd8739ae039), {
        icon: {
            image: (0, (/*@__PURE__*/$parcel$interopDefault($5cac7a7b6d0c0db7$exports))),
            alt: 'Waivers'
        },
        title: "Add Waiver",
        description: "Get started by selecting a waiver provider.",
        unavailableText: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
            children: [
                "Unavailable creation methods may require you to connect an external provider in ",
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                    href: "/connections",
                    children: "Connections"
                })
            ]
        }),
        cards: [
            {
                title: 'Smartwaiver',
                logo: {
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($436c0d5fb2f377a3$exports))),
                    alt: 'Smartwaiver'
                },
                description: 'Import a Smartwaiver template',
                enabled: (connectionStatus === null || connectionStatus === void 0 ? void 0 : connectionStatus.SMART_WAIVER) === true,
                onClick: ()=>{
                    setSelectedProvider((0, $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72).SMART_WAIVER);
                }
            },
            {
                title: "Manual Waiver",
                description: "Create a waiver that must be manually updated when completed by each attendee",
                enabled: true,
                logo: {
                    image: (0, (/*@__PURE__*/$parcel$interopDefault($a9cdc003ba228dda$exports))),
                    alt: 'Manual Waiver'
                },
                onClick: ()=>{
                    setShowManualWaiverCreation(true);
                }
            }
        ]
    });
    const closeButton = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        className: "close",
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            props.close();
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
            className: "icon",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
            alt: "Close icon"
        })
    });
    const backButton = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("a", {
        className: "back",
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            if (selectedWaiver) setSelectedWaiver(null);
            else {
                setSelectedProvider(null);
                setExternalWaivers(null);
                setExternalWaiversLoadingError(null);
                setShowManualWaiverCreation(false);
            }
        },
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                className: "icon",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($48a08cc73bd1bdd6$exports))),
                alt: "Left arrow icon"
            }),
            " Back"
        ]
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "waiver-setup",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
            style: {
                paddingTop: 32
            },
            children: saving || showSuccess || saveError ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    saving && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                        fullScreen: false
                    }),
                    saveError && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            closeButton,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                                error: saveError,
                                showButton: false
                            })
                        ]
                    }),
                    showSuccess && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            closeButton,
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9f2c42b26582cc85$export$2e2bcd8739ae039), {
                                title: "Waiver Added",
                                description: `Waiver successfully added to ${props.event.title}.`
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "buttons",
                        children: [
                            selectedProvider && backButton,
                            showManualWaiverCreation && backButton,
                            !selectedProvider && !showManualWaiverCreation && closeButton
                        ]
                    }),
                    !connectionStatus && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                        fullScreen: false
                    }),
                    selectedProvider === null && connectionStatus && !showManualWaiverCreation ? optionsForm : null,
                    selectedProvider && !selectedWaiver && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($75c3ed5f39befefd$var$ExternalWaiverList, {
                        event: props.event,
                        selectedProvider: selectedProvider,
                        externalWaiverLoadingError: externalWaiverLoadingError,
                        externalWaivers: externalWaivers,
                        fetchExternalWaivers: fetchExternalWaivers,
                        externalWaiverSelected: (waiver)=>{
                            setSelectedWaiver(waiver);
                        }
                    }),
                    selectedWaiver && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "selectedWaiverDetails",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                                children: [
                                    "Instructions for ",
                                    selectedWaiver.name
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "If you would like to display specific instructions for this waiver, enter them below. Then, click the Attach button to complete setup."
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                placeholder: "Custom Waiver Instructions",
                                value: waiverInstructions || "",
                                onChange: (e)=>{
                                    setWaiverInstructions(e.target.value);
                                }
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                onClick: (e)=>{
                                    e.preventDefault();
                                    attachExternalWaiver(selectedWaiver);
                                },
                                children: "Attach Waiver to Event"
                            })
                        ]
                    }),
                    showManualWaiverCreation && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($75c3ed5f39befefd$var$ManualWaiverSetup, {
                        onCreateClicked: (name, url, instructions)=>{
                            createWaiver(name, url, instructions);
                        }
                    })
                ]
            })
        })
    });
}
function $75c3ed5f39befefd$var$ManualWaiverSetup(props) {
    const [name, setName] = (0, $7fPBF.useState)("");
    const [url, setURL] = (0, $7fPBF.useState)("");
    const [instructions, setInstructions] = (0, $7fPBF.useState)(null);
    const canCreate = name.length > 0 && url.length > 0;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "manualWaivers",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Manual Waiver Setup"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Manual Waivers should be created for waivers that don't directly integrate with Salt."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "heading",
                        style: {
                            marginBottom: '0.5rem'
                        },
                        children: "Information"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "section",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                type: "text",
                                name: "waiverName",
                                placeholder: "Waiver Name",
                                value: name || '',
                                onChange: (e)=>setName(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($75c3ed5f39befefd$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                type: "text",
                                name: "waiverURL",
                                placeholder: "Waiver URL",
                                value: url || '',
                                onChange: (e)=>setURL(e.target.value)
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($75c3ed5f39befefd$var$Separator, {}),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("textarea", {
                                placeholder: "Instructions",
                                name: "instructions",
                                value: instructions || '',
                                onChange: (e)=>setInstructions(e.target.value)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "footnote",
                        children: "Instructions will be sent alongside attendee Waiver Reminder emails."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: (e)=>{
                    e.preventDefault();
                    if (!canCreate) return;
                    props.onCreateClicked(name, url, instructions);
                },
                disabled: !canCreate,
                children: "Create Waiver"
            })
        ]
    });
}
function $75c3ed5f39befefd$var$ExternalWaiverList(props) {
    const prettyProviderName = (0, $7fPBF.useMemo)(()=>{
        if (!props.selectedProvider) return '';
        switch(props.selectedProvider){
            case (0, $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72).SMART_WAIVER:
                return 'Smartwaiver';
            default:
                return null;
        }
    }, [
        props.selectedProvider
    ]);
    (0, $7fPBF.useEffect)(()=>{
        let mounted = true;
        const performFetch = async ()=>{
            await props.fetchExternalWaivers();
            if (!mounted) return;
        };
        performFetch();
        return ()=>{
            mounted = false;
        };
    }, []);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            !props.externalWaivers && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                fullScreen: false
            }),
            props.externalWaivers && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "availableExternalWaivers",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                        children: [
                            "Available Waivers from ",
                            prettyProviderName
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        children: [
                            "Select a waiver to attach to ",
                            props.event.title,
                            "."
                        ]
                    }),
                    props.externalWaiverLoadingError && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "error",
                        children: props.externalWaiverLoadingError
                    }),
                    props.externalWaivers.length > 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        style: {
                            marginTop: 16
                        },
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                            className: "card",
                            children: props.externalWaivers.map((waiver, idx)=>{
                                const existingWaiver = props.event.waivers.find((existingWaiver)=>{
                                    var _existingWaiver_externalMetadata;
                                    return ((_existingWaiver_externalMetadata = existingWaiver.externalMetadata) === null || _existingWaiver_externalMetadata === void 0 ? void 0 : _existingWaiver_externalMetadata.externalID) == waiver.externalID;
                                });
                                const alreadyAdded = existingWaiver !== undefined;
                                return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    children: [
                                        idx !== 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "separator"
                                        }) : null,
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            style: {
                                                padding: 8,
                                                paddingTop: 16,
                                                paddingBottom: 16
                                            },
                                            role: "button",
                                            className: 'waiver-option ' + (alreadyAdded ? "existing" : ""),
                                            onClick: (e)=>{
                                                e.preventDefault();
                                                if (alreadyAdded) return;
                                                props.externalWaiverSelected(waiver);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "text",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            style: {
                                                                margin: 0,
                                                                fontWeight: 500
                                                            },
                                                            children: waiver.name
                                                        }),
                                                        alreadyAdded ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                            className: "existing-warning",
                                                            children: "This waiver is already attached to this event."
                                                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                                                            target: "_blank",
                                                            rel: "noopener noreferrer",
                                                            href: waiver.url,
                                                            children: waiver.url
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                                    src: (0, (/*@__PURE__*/$parcel$interopDefault($e5c73394f0bf85aa$exports))),
                                                    className: "chevron",
                                                    alt: ""
                                                })
                                            ]
                                        })
                                    ]
                                }, waiver.externalID);
                            })
                        })
                    }) : null
                ]
            })
        ]
    });
}
function $75c3ed5f39befefd$var$Separator() {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        style: {
            width: "100%",
            height: 1,
            backgroundColor: "#eaeaea",
            opacity: 0.10,
            margin: '12px 0'
        }
    });
}







var $7fPBF = parcelRequire("7fPBF");
/*! xlsx.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported XLSX */ /*global process:false, Buffer:false, ArrayBuffer:false, DataView:false, Deno:false */ 
var $ifbub = parcelRequire("ifbub");
var $a1a91b25d7598376$require$Buffer = $ifbub.Buffer;
var $a1a91b25d7598376$var$XLSX = {};
$a1a91b25d7598376$var$XLSX.version = '0.20.3';
var $a1a91b25d7598376$var$current_codepage = 1200, $a1a91b25d7598376$var$current_ansi = 1252;
/*:: declare var cptable:any; */ /*global cptable:true, window */ var $a1a91b25d7598376$var$$cptable;
var $a1a91b25d7598376$var$VALID_ANSI = [
    874,
    932,
    936,
    949,
    950,
    1250,
    1251,
    1252,
    1253,
    1254,
    1255,
    1256,
    1257,
    1258,
    10000
];
/* ECMA-376 Part I 18.4.1 charset to codepage mapping */ var $a1a91b25d7598376$var$CS2CP = {
    0: 1252,
    /* ANSI */ 1: 65001,
    /* DEFAULT */ 2: 65001,
    /* SYMBOL */ 77: 10000,
    /* MAC */ 128: 932,
    /* SHIFTJIS */ 129: 949,
    /* HANGUL */ 130: 1361,
    /* JOHAB */ 134: 936,
    /* GB2312 */ 136: 950,
    /* CHINESEBIG5 */ 161: 1253,
    /* GREEK */ 162: 1254,
    /* TURKISH */ 163: 1258,
    /* VIETNAMESE */ 177: 1255,
    /* HEBREW */ 178: 1256,
    /* ARABIC */ 186: 1257,
    /* BALTIC */ 204: 1251,
    /* RUSSIAN */ 222: 874,
    /* THAI */ 238: 1250,
    /* EASTEUROPE */ 255: 1252,
    /* OEM */ 69: 6969 /* MISC */ 
} /*:any*/ ;
var $a1a91b25d7598376$var$set_ansi = function(cp /*:number*/ ) {
    if ($a1a91b25d7598376$var$VALID_ANSI.indexOf(cp) == -1) return;
    $a1a91b25d7598376$var$current_ansi = $a1a91b25d7598376$var$CS2CP[0] = cp;
};
function $a1a91b25d7598376$var$reset_ansi() {
    $a1a91b25d7598376$var$set_ansi(1252);
}
var $a1a91b25d7598376$var$set_cp = function(cp /*:number*/ ) {
    $a1a91b25d7598376$var$current_codepage = cp;
    $a1a91b25d7598376$var$set_ansi(cp);
};
function $a1a91b25d7598376$var$reset_cp() {
    $a1a91b25d7598376$var$set_cp(1200);
    $a1a91b25d7598376$var$reset_ansi();
}
function $a1a91b25d7598376$var$char_codes(data /*:string*/ ) /*:Array<number>*/ {
    var o /*:Array<number>*/  = [];
    for(var i = 0, len = data.length; i < len; ++i)o[i] = data.charCodeAt(i);
    return o;
}
function $a1a91b25d7598376$var$utf16leread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i) + (data.charCodeAt(2 * i + 1) << 8));
    return o.join("");
}
function $a1a91b25d7598376$var$utf16lereadu(data /*:Uint8Array*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data[2 * i] + (data[2 * i + 1] << 8));
    return o.join("");
}
function $a1a91b25d7598376$var$utf16beread(data /*:string*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length >> 1; ++i)o[i] = String.fromCharCode(data.charCodeAt(2 * i + 1) + (data.charCodeAt(2 * i) << 8));
    return o.join("");
}
var $a1a91b25d7598376$var$debom = function(data /*:string*/ ) /*:string*/ {
    var c1 = data.charCodeAt(0), c2 = data.charCodeAt(1);
    if (c1 == 0xFF && c2 == 0xFE) return $a1a91b25d7598376$var$utf16leread(data.slice(2));
    if (c1 == 0xFE && c2 == 0xFF) return $a1a91b25d7598376$var$utf16beread(data.slice(2));
    if (c1 == 0xFEFF) return data.slice(1);
    return data;
};
var $a1a91b25d7598376$var$_getchar = function _gc1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
var $a1a91b25d7598376$var$_getansi = function _ga1(x /*:number*/ ) /*:string*/ {
    return String.fromCharCode(x);
};
function $a1a91b25d7598376$export$58f247d16f363b86(cptable) {
    $a1a91b25d7598376$var$$cptable = cptable;
    $a1a91b25d7598376$var$set_cp = function(cp /*:number*/ ) {
        $a1a91b25d7598376$var$current_codepage = cp;
        $a1a91b25d7598376$var$set_ansi(cp);
    };
    $a1a91b25d7598376$var$debom = function(data /*:string*/ ) {
        if (data.charCodeAt(0) === 0xFF && data.charCodeAt(1) === 0xFE) return $a1a91b25d7598376$var$$cptable.utils.decode(1200, $a1a91b25d7598376$var$char_codes(data.slice(2)));
        return data;
    };
    $a1a91b25d7598376$var$_getchar = function _gc2(x /*:number*/ ) /*:string*/ {
        if ($a1a91b25d7598376$var$current_codepage === 1200) return String.fromCharCode(x);
        return $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, [
            x & 255,
            x >> 8
        ])[0];
    };
    $a1a91b25d7598376$var$_getansi = function _ga2(x /*:number*/ ) /*:string*/ {
        return $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_ansi, [
            x
        ])[0];
    };
    $a1a91b25d7598376$var$cpdoit();
}
var $a1a91b25d7598376$var$DENSE = null;
var $a1a91b25d7598376$var$DIF_XL = true;
var $a1a91b25d7598376$var$Base64_map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
function $a1a91b25d7598376$var$Base64_encode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $a1a91b25d7598376$var$Base64_map.charAt(e1) + $a1a91b25d7598376$var$Base64_map.charAt(e2) + $a1a91b25d7598376$var$Base64_map.charAt(e3) + $a1a91b25d7598376$var$Base64_map.charAt(e4);
    }
    return o;
}
function $a1a91b25d7598376$var$Base64_encode_pass(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input.charCodeAt(i++);
        if (c1 > 255) c1 = 95;
        e1 = c1 >> 2;
        c2 = input.charCodeAt(i++);
        if (c2 > 255) c2 = 95;
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input.charCodeAt(i++);
        if (c3 > 255) c3 = 95;
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $a1a91b25d7598376$var$Base64_map.charAt(e1) + $a1a91b25d7598376$var$Base64_map.charAt(e2) + $a1a91b25d7598376$var$Base64_map.charAt(e3) + $a1a91b25d7598376$var$Base64_map.charAt(e4);
    }
    return o;
}
function $a1a91b25d7598376$var$Base64_encode_arr(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    for(var i = 0; i < input.length;){
        c1 = input[i++];
        e1 = c1 >> 2;
        c2 = input[i++];
        e2 = (c1 & 3) << 4 | c2 >> 4;
        c3 = input[i++];
        e3 = (c2 & 15) << 2 | c3 >> 6;
        e4 = c3 & 63;
        if (isNaN(c2)) e3 = e4 = 64;
        else if (isNaN(c3)) e4 = 64;
        o += $a1a91b25d7598376$var$Base64_map.charAt(e1) + $a1a91b25d7598376$var$Base64_map.charAt(e2) + $a1a91b25d7598376$var$Base64_map.charAt(e3) + $a1a91b25d7598376$var$Base64_map.charAt(e4);
    }
    return o;
}
function $a1a91b25d7598376$var$Base64_decode(input) {
    var o = "";
    var c1 = 0, c2 = 0, c3 = 0, e1 = 0, e2 = 0, e3 = 0, e4 = 0;
    if (input.slice(0, 5) == "data:") {
        var i = input.slice(0, 1024).indexOf(";base64,");
        if (i > -1) input = input.slice(i + 8);
    }
    input = input.replace(/[^\w\+\/\=]/g, "");
    for(var i = 0; i < input.length;){
        e1 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        e2 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        c1 = e1 << 2 | e2 >> 4;
        o += String.fromCharCode(c1);
        e3 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        c2 = (e2 & 15) << 4 | e3 >> 2;
        if (e3 !== 64) o += String.fromCharCode(c2);
        e4 = $a1a91b25d7598376$var$Base64_map.indexOf(input.charAt(i++));
        c3 = (e3 & 3) << 6 | e4;
        if (e4 !== 64) o += String.fromCharCode(c3);
    }
    return o;
}
var $a1a91b25d7598376$var$has_buf = /*#__PURE__*/ function() {
    return typeof $a1a91b25d7598376$require$Buffer !== 'undefined' && false;
}();
var $a1a91b25d7598376$var$Buffer_from = /*#__PURE__*/ function() {
    if (typeof $a1a91b25d7598376$require$Buffer !== 'undefined') {
        var nbfs = !$a1a91b25d7598376$require$Buffer.from;
        if (!nbfs) try {
            $a1a91b25d7598376$require$Buffer.from("foo", "utf8");
        } catch (e) {
            nbfs = true;
        }
        return nbfs ? function(buf, enc) {
            return enc ? new $a1a91b25d7598376$require$Buffer(buf, enc) : new $a1a91b25d7598376$require$Buffer(buf);
        } : $a1a91b25d7598376$require$Buffer.from.bind($a1a91b25d7598376$require$Buffer);
    }
    return function() {};
}();
var $a1a91b25d7598376$var$buf_utf16le = /*#__PURE__*/ function() {
    if (typeof $a1a91b25d7598376$require$Buffer === 'undefined') return false;
    var x = $a1a91b25d7598376$var$Buffer_from([
        65,
        0
    ]);
    if (!x) return false;
    var o = x.toString("utf16le");
    return o.length == 1;
}();
function $a1a91b25d7598376$var$new_raw_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$require$Buffer.alloc ? $a1a91b25d7598376$require$Buffer.alloc(len) : new $a1a91b25d7598376$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
function $a1a91b25d7598376$var$new_unsafe_buf(len /*:number*/ ) {
    /* jshint -W056 */ if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$require$Buffer.allocUnsafe ? $a1a91b25d7598376$require$Buffer.allocUnsafe(len) : new $a1a91b25d7598376$require$Buffer(len);
    return typeof Uint8Array != "undefined" ? new Uint8Array(len) : new Array(len);
/* jshint +W056 */ }
var $a1a91b25d7598376$var$s2a = function s2a(s /*:string*/ ) /*:any*/ {
    if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$Buffer_from(s, "binary");
    return s.split("").map(function(x /*:string*/ ) /*:number*/ {
        return x.charCodeAt(0) & 0xff;
    });
};
function $a1a91b25d7598376$var$s2ab(s /*:string*/ ) /*:any*/ {
    if (typeof ArrayBuffer === 'undefined') return $a1a91b25d7598376$var$s2a(s);
    var buf = new ArrayBuffer(s.length), view = new Uint8Array(buf);
    for(var i = 0; i != s.length; ++i)view[i] = s.charCodeAt(i) & 0xFF;
    return buf;
}
function $a1a91b25d7598376$var$a2s(data /*:any*/ ) /*:string*/ {
    if (Array.isArray(data)) return data.map(function(c) {
        return String.fromCharCode(c);
    }).join("");
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < data.length; ++i)o[i] = String.fromCharCode(data[i]);
    return o.join("");
}
function $a1a91b25d7598376$var$a2u(data /*:Array<number>*/ ) /*:Uint8Array*/ {
    if (typeof Uint8Array === 'undefined') throw new Error("Unsupported");
    return new Uint8Array(data);
}
function $a1a91b25d7598376$var$ab2a(data /*:ArrayBuffer|Uint8Array*/ ) /*:Array<number>*/ {
    if (typeof ArrayBuffer == 'undefined') throw new Error("Unsupported");
    if (data instanceof ArrayBuffer) return $a1a91b25d7598376$var$ab2a(new Uint8Array(data));
    /*:: if(data instanceof ArrayBuffer) throw new Error("unreachable"); */ var o = new Array(data.length);
    for(var i = 0; i < data.length; ++i)o[i] = data[i];
    return o;
}
var $a1a91b25d7598376$var$bconcat = $a1a91b25d7598376$var$has_buf ? function(bufs) {
    return $a1a91b25d7598376$require$Buffer.concat(bufs.map(function(buf) {
        return $a1a91b25d7598376$require$Buffer.isBuffer(buf) ? buf : $a1a91b25d7598376$var$Buffer_from(buf);
    }));
} : function(bufs) {
    if (typeof Uint8Array !== "undefined") {
        var i = 0, maxlen = 0;
        for(i = 0; i < bufs.length; ++i)maxlen += bufs[i].length;
        var o = new Uint8Array(maxlen);
        var len = 0;
        for(i = 0, maxlen = 0; i < bufs.length; maxlen += len, ++i){
            len = bufs[i].length;
            if (bufs[i] instanceof Uint8Array) o.set(bufs[i], maxlen);
            else if (typeof bufs[i] == "string") o.set(new Uint8Array($a1a91b25d7598376$var$s2a(bufs[i])), maxlen);
            else o.set(new Uint8Array(bufs[i]), maxlen);
        }
        return o;
    }
    return [].concat.apply([], bufs.map(function(buf) {
        return Array.isArray(buf) ? buf : [].slice.call(buf);
    }));
};
function $a1a91b25d7598376$var$utf8decode(content /*:string*/ ) {
    var out = [], widx = 0, L = content.length + 250;
    var o = $a1a91b25d7598376$var$new_raw_buf(content.length + 255);
    for(var ridx = 0; ridx < content.length; ++ridx){
        var c = content.charCodeAt(ridx);
        if (c < 0x80) o[widx++] = c;
        else if (c < 0x800) {
            o[widx++] = 192 | c >> 6 & 31;
            o[widx++] = 128 | c & 63;
        } else if (c >= 0xD800 && c < 0xE000) {
            c = (c & 1023) + 64;
            var d = content.charCodeAt(++ridx) & 1023;
            o[widx++] = 240 | c >> 8 & 7;
            o[widx++] = 128 | c >> 2 & 63;
            o[widx++] = 128 | d >> 6 & 15 | (c & 3) << 4;
            o[widx++] = 128 | d & 63;
        } else {
            o[widx++] = 224 | c >> 12 & 15;
            o[widx++] = 128 | c >> 6 & 63;
            o[widx++] = 128 | c & 63;
        }
        if (widx > L) {
            out.push(o.slice(0, widx));
            widx = 0;
            o = $a1a91b25d7598376$var$new_raw_buf(65535);
            L = 65530;
        }
    }
    out.push(o.slice(0, widx));
    return $a1a91b25d7598376$var$bconcat(out);
}
var $a1a91b25d7598376$var$chr0 = /\u0000/g, $a1a91b25d7598376$var$chr1 = /[\u0001-\u0006]/g;
/*::
declare type Block = any;
declare type BufArray = {
	newblk(sz:number):Block;
	next(sz:number):Block;
	end():any;
	push(buf:Block):void;
};

type RecordHopperCB = {(d:any, Rn:string, RT:number):?boolean;};

type EvertType = {[string]:string};
type EvertNumType = {[string]:number};
type EvertArrType = {[string]:Array<string>};

type StringConv = {(string):string};

*/ /* ssf.js (C) 2013-present SheetJS -- http://sheetjs.com */ /*jshint -W041 */ function $a1a91b25d7598376$var$_strrev(x /*:string*/ ) /*:string*/ {
    var o = "", i = x.length - 1;
    while(i >= 0)o += x.charAt(i--);
    return o;
}
function $a1a91b25d7598376$var$pad0(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $a1a91b25d7598376$var$fill('0', d - t.length) + t;
}
function $a1a91b25d7598376$var$pad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $a1a91b25d7598376$var$fill(' ', d - t.length) + t;
}
function $a1a91b25d7598376$var$rpad_(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : t + $a1a91b25d7598376$var$fill(' ', d - t.length);
}
function $a1a91b25d7598376$var$pad0r1(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + Math.round(v);
    return t.length >= d ? t : $a1a91b25d7598376$var$fill('0', d - t.length) + t;
}
function $a1a91b25d7598376$var$pad0r2(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    var t = "" + v;
    return t.length >= d ? t : $a1a91b25d7598376$var$fill('0', d - t.length) + t;
}
var $a1a91b25d7598376$var$p2_32 = /*#__PURE__*/ Math.pow(2, 32);
function $a1a91b25d7598376$var$pad0r(v /*:any*/ , d /*:number*/ ) /*:string*/ {
    if (v > $a1a91b25d7598376$var$p2_32 || v < -$a1a91b25d7598376$var$p2_32) return $a1a91b25d7598376$var$pad0r1(v, d);
    var i = Math.round(v);
    return $a1a91b25d7598376$var$pad0r2(i, d);
}
/* yes, in 2022 this is still faster than string compare */ function $a1a91b25d7598376$var$SSF_isgeneral(s /*:string*/ , i /*:?number*/ ) /*:boolean*/ {
    i = i || 0;
    return s.length >= 7 + i && (s.charCodeAt(i) | 32) === 103 && (s.charCodeAt(i + 1) | 32) === 101 && (s.charCodeAt(i + 2) | 32) === 110 && (s.charCodeAt(i + 3) | 32) === 101 && (s.charCodeAt(i + 4) | 32) === 114 && (s.charCodeAt(i + 5) | 32) === 97 && (s.charCodeAt(i + 6) | 32) === 108;
}
var $a1a91b25d7598376$var$days /*:Array<Array<string> >*/  = [
    [
        'Sun',
        'Sunday'
    ],
    [
        'Mon',
        'Monday'
    ],
    [
        'Tue',
        'Tuesday'
    ],
    [
        'Wed',
        'Wednesday'
    ],
    [
        'Thu',
        'Thursday'
    ],
    [
        'Fri',
        'Friday'
    ],
    [
        'Sat',
        'Saturday'
    ]
];
var $a1a91b25d7598376$var$months /*:Array<Array<string> >*/  = [
    [
        'J',
        'Jan',
        'January'
    ],
    [
        'F',
        'Feb',
        'February'
    ],
    [
        'M',
        'Mar',
        'March'
    ],
    [
        'A',
        'Apr',
        'April'
    ],
    [
        'M',
        'May',
        'May'
    ],
    [
        'J',
        'Jun',
        'June'
    ],
    [
        'J',
        'Jul',
        'July'
    ],
    [
        'A',
        'Aug',
        'August'
    ],
    [
        'S',
        'Sep',
        'September'
    ],
    [
        'O',
        'Oct',
        'October'
    ],
    [
        'N',
        'Nov',
        'November'
    ],
    [
        'D',
        'Dec',
        'December'
    ]
];
function $a1a91b25d7598376$var$SSF_init_table(t /*:any*/ ) {
    if (!t) t = {};
    t[0] = 'General';
    t[1] = '0';
    t[2] = '0.00';
    t[3] = '#,##0';
    t[4] = '#,##0.00';
    t[9] = '0%';
    t[10] = '0.00%';
    t[11] = '0.00E+00';
    t[12] = '# ?/?';
    t[13] = '# ??/??';
    t[14] = 'm/d/yy';
    t[15] = 'd-mmm-yy';
    t[16] = 'd-mmm';
    t[17] = 'mmm-yy';
    t[18] = 'h:mm AM/PM';
    t[19] = 'h:mm:ss AM/PM';
    t[20] = 'h:mm';
    t[21] = 'h:mm:ss';
    t[22] = 'm/d/yy h:mm';
    t[37] = '#,##0 ;(#,##0)';
    t[38] = '#,##0 ;[Red](#,##0)';
    t[39] = '#,##0.00;(#,##0.00)';
    t[40] = '#,##0.00;[Red](#,##0.00)';
    t[45] = 'mm:ss';
    t[46] = '[h]:mm:ss';
    t[47] = 'mmss.0';
    t[48] = '##0.0E+0';
    t[49] = '@';
    t[56] = '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "';
    return t;
}
/* repeated to satiate webpack */ var $a1a91b25d7598376$var$table_fmt = {
    0: 'General',
    1: '0',
    2: '0.00',
    3: '#,##0',
    4: '#,##0.00',
    9: '0%',
    10: '0.00%',
    11: '0.00E+00',
    12: '# ?/?',
    13: '# ??/??',
    14: 'm/d/yy',
    15: 'd-mmm-yy',
    16: 'd-mmm',
    17: 'mmm-yy',
    18: 'h:mm AM/PM',
    19: 'h:mm:ss AM/PM',
    20: 'h:mm',
    21: 'h:mm:ss',
    22: 'm/d/yy h:mm',
    37: '#,##0 ;(#,##0)',
    38: '#,##0 ;[Red](#,##0)',
    39: '#,##0.00;(#,##0.00)',
    40: '#,##0.00;[Red](#,##0.00)',
    45: 'mm:ss',
    46: '[h]:mm:ss',
    47: 'mmss.0',
    48: '##0.0E+0',
    49: '@',
    56: '"\u4E0A\u5348/\u4E0B\u5348 "hh"\u6642"mm"\u5206"ss"\u79D2 "'
};
/* Defaults determined by systematically testing in Excel 2019 */ /* These formats appear to default to other formats in the table */ var $a1a91b25d7598376$var$SSF_default_map = {
    5: 37,
    6: 38,
    7: 39,
    8: 40,
    23: 0,
    24: 0,
    25: 0,
    26: 0,
    27: 14,
    28: 14,
    29: 14,
    30: 14,
    31: 14,
    50: 14,
    51: 14,
    52: 14,
    53: 14,
    54: 14,
    55: 14,
    56: 14,
    57: 14,
    58: 14,
    59: 1,
    60: 2,
    61: 3,
    62: 4,
    67: 9,
    68: 10,
    69: 12,
    70: 13,
    71: 14,
    72: 14,
    73: 15,
    74: 16,
    75: 17,
    76: 20,
    77: 21,
    78: 22,
    79: 45,
    80: 46,
    81: 47,
    82: 0 // 82 ->  0 ... 65536 -> 0 (omitted)
};
/* These formats technically refer to Accounting formats with no equivalent */ var $a1a91b25d7598376$var$SSF_default_str = {
    //  5 -- Currency,   0 decimal, black negative
    5: '"$"#,##0_);\\("$"#,##0\\)',
    63: '"$"#,##0_);\\("$"#,##0\\)',
    //  6 -- Currency,   0 decimal, red   negative
    6: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    64: '"$"#,##0_);[Red]\\("$"#,##0\\)',
    //  7 -- Currency,   2 decimal, black negative
    7: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    65: '"$"#,##0.00_);\\("$"#,##0.00\\)',
    //  8 -- Currency,   2 decimal, red   negative
    8: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    66: '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    // 41 -- Accounting, 0 decimal, No Symbol
    41: '_(* #,##0_);_(* \\(#,##0\\);_(* "-"_);_(@_)',
    // 42 -- Accounting, 0 decimal, $  Symbol
    42: '_("$"* #,##0_);_("$"* \\(#,##0\\);_("$"* "-"_);_(@_)',
    // 43 -- Accounting, 2 decimal, No Symbol
    43: '_(* #,##0.00_);_(* \\(#,##0.00\\);_(* "-"??_);_(@_)',
    // 44 -- Accounting, 2 decimal, $  Symbol
    44: '_("$"* #,##0.00_);_("$"* \\(#,##0.00\\);_("$"* "-"??_);_(@_)'
};
function $a1a91b25d7598376$var$SSF_frac(x /*:number*/ , D /*:number*/ , mixed /*:?boolean*/ ) /*:Array<number>*/ {
    var sgn = x < 0 ? -1 : 1;
    var B = x * sgn;
    var P_2 = 0, P_1 = 1, P = 0;
    var Q_2 = 1, Q_1 = 0, Q = 0;
    var A = Math.floor(B);
    while(Q_1 < D){
        A = Math.floor(B);
        P = A * P_1 + P_2;
        Q = A * Q_1 + Q_2;
        if (B - A < 0.00000005) break;
        B = 1 / (B - A);
        P_2 = P_1;
        P_1 = P;
        Q_2 = Q_1;
        Q_1 = Q;
    }
    if (Q > D) {
        if (Q_1 > D) {
            Q = Q_2;
            P = P_2;
        } else {
            Q = Q_1;
            P = P_1;
        }
    }
    if (!mixed) return [
        0,
        sgn * P,
        Q
    ];
    var q = Math.floor(sgn * P / Q);
    return [
        q,
        sgn * P - q * Q,
        Q
    ];
}
function $a1a91b25d7598376$var$SSF_normalize_xl_unsafe(v /*:number*/ ) /*:number*/ {
    var s = v.toPrecision(16);
    if (s.indexOf("e") > -1) {
        var m = s.slice(0, s.indexOf("e"));
        m = m.indexOf(".") > -1 ? m.slice(0, m.slice(0, 2) == "0." ? 17 : 16) : m.slice(0, 15) + $a1a91b25d7598376$var$fill("0", m.length - 15);
        return m + s.slice(s.indexOf("e"));
    }
    var n = s.indexOf(".") > -1 ? s.slice(0, s.slice(0, 2) == "0." ? 17 : 16) : s.slice(0, 15) + $a1a91b25d7598376$var$fill("0", s.length - 15);
    return Number(n);
}
function $a1a91b25d7598376$var$SSF_parse_date_code(v /*:number*/ , opts /*:?any*/ , b2 /*:?boolean*/ ) {
    if (v > 2958465 || v < 0) return null;
    v = $a1a91b25d7598376$var$SSF_normalize_xl_unsafe(v);
    var date = v | 0, time = Math.floor(86400 * (v - date)), dow = 0;
    var dout = [];
    var out = {
        D: date,
        T: time,
        u: 86400 * (v - date) - time,
        y: 0,
        m: 0,
        d: 0,
        H: 0,
        M: 0,
        S: 0,
        q: 0
    };
    if (Math.abs(out.u) < 1e-6) out.u = 0;
    if (opts && opts.date1904) date += 1462;
    if (out.u > 0.9999) {
        out.u = 0;
        if (++time == 86400) {
            out.T = time = 0;
            ++date;
            ++out.D;
        }
    }
    if (date === 60) {
        dout = b2 ? [
            1317,
            10,
            29
        ] : [
            1900,
            2,
            29
        ];
        dow = 3;
    } else if (date === 0) {
        dout = b2 ? [
            1317,
            8,
            29
        ] : [
            1900,
            1,
            0
        ];
        dow = 6;
    } else {
        if (date > 60) --date;
        /* 1 = Jan 1 1900 in Gregorian */ var d = new Date(1900, 0, 1);
        d.setDate(d.getDate() + date - 1);
        dout = [
            d.getFullYear(),
            d.getMonth() + 1,
            d.getDate()
        ];
        dow = d.getDay();
        if (date < 60) dow = (dow + 6) % 7;
        if (b2) dow = $a1a91b25d7598376$var$SSF_fix_hijri(d, dout);
    }
    out.y = dout[0];
    out.m = dout[1];
    out.d = dout[2];
    out.S = time % 60;
    time = Math.floor(time / 60);
    out.M = time % 60;
    time = Math.floor(time / 60);
    out.H = time;
    out.q = dow;
    return out;
}
/* ECMA-376 18.8.30 numFmt*/ /* Note: `toPrecision` uses standard form when prec > E and E >= -6 */ /* exponent >= -9 and <= 9 */ function $a1a91b25d7598376$var$SSF_strip_decimal(o /*:string*/ ) /*:string*/ {
    return o.indexOf(".") == -1 ? o : o.replace(/(?:\.0*|(\.\d*[1-9])0+)$/, "$1");
}
/* General Exponential always shows 2 digits exp and trims the mantissa */ function $a1a91b25d7598376$var$SSF_normalize_exp(o /*:string*/ ) /*:string*/ {
    if (o.indexOf("E") == -1) return o;
    return o.replace(/(?:\.0*|(\.\d*[1-9])0+)[Ee]/, "$1E").replace(/(E[+-])(\d)$/, "$10$2");
}
/* exponent >= -9 and <= 9 */ function $a1a91b25d7598376$var$SSF_small_exp(v /*:number*/ ) /*:string*/ {
    var w = v < 0 ? 12 : 11;
    var o = $a1a91b25d7598376$var$SSF_strip_decimal(v.toFixed(12));
    if (o.length <= w) return o;
    o = v.toPrecision(10);
    if (o.length <= w) return o;
    return v.toExponential(5);
}
/* exponent >= 11 or <= -10 likely exponential */ function $a1a91b25d7598376$var$SSF_large_exp(v /*:number*/ ) /*:string*/ {
    var o = $a1a91b25d7598376$var$SSF_strip_decimal(v.toFixed(11));
    return o.length > (v < 0 ? 12 : 11) || o === "0" || o === "-0" ? v.toPrecision(6) : o;
}
function $a1a91b25d7598376$var$SSF_general_num(v /*:number*/ ) /*:string*/ {
    if (!isFinite(v)) return isNaN(v) ? "#NUM!" : "#DIV/0!";
    var V = Math.floor(Math.log(Math.abs(v)) * Math.LOG10E), o;
    if (V >= -4 && V <= -1) o = v.toPrecision(10 + V);
    else if (Math.abs(V) <= 9) o = $a1a91b25d7598376$var$SSF_small_exp(v);
    else if (V === 10) o = v.toFixed(10).substr(0, 12);
    else o = $a1a91b25d7598376$var$SSF_large_exp(v);
    return $a1a91b25d7598376$var$SSF_strip_decimal($a1a91b25d7598376$var$SSF_normalize_exp(o.toUpperCase()));
}
/*
	"General" rules:
	- text is passed through ("@")
	- booleans are rendered as TRUE/FALSE
	- "up to 11 characters" displayed for numbers
	- Default date format (code 14) used for Dates

	The longest 32-bit integer text is "-2147483648", exactly 11 chars
	TODO: technically the display depends on the width of the cell
*/ function $a1a91b25d7598376$var$SSF_general(v /*:any*/ , opts /*:any*/ ) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? "TRUE" : "FALSE";
        case 'number':
            return (v | 0) === v ? v.toString(10) : $a1a91b25d7598376$var$SSF_general_num(v);
        case 'undefined':
            return "";
        case 'object':
            if (v == null) return "";
            if (v instanceof Date) return $a1a91b25d7598376$var$SSF_format(14, $a1a91b25d7598376$var$datenum(v, opts && opts.date1904), opts);
    }
    throw new Error("unsupported value in General format: " + v);
}
function $a1a91b25d7598376$var$SSF_fix_hijri(date /*:Date*/ , o /*:[number, number, number]*/ ) {
    /* TODO: properly adjust y/m/d and  */ o[0] -= 581;
    var dow = date.getDay();
    if (date < 60) dow = (dow + 6) % 7;
    return dow;
}
//var THAI_DIGITS = "\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59".split("");
function $a1a91b25d7598376$var$SSF_write_date(type /*:number*/ , fmt /*:string*/ , val1, ss0 /*:?number*/ ) /*:string*/ {
    var o = "", ss = 0, tt = 0, y = val1.y, out, outl = 0;
    switch(type){
        case 98:
            /* 'b' buddhist year */ y = val1.y + 543;
        /* falls through */ case 121:
            /* 'y' year */ switch(fmt.length){
                case 1:
                case 2:
                    out = y % 100;
                    outl = 2;
                    break;
                default:
                    out = y % 10000;
                    outl = 4;
                    break;
            }
            break;
        case 109:
            /* 'm' month */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.m;
                    outl = fmt.length;
                    break;
                case 3:
                    return $a1a91b25d7598376$var$months[val1.m - 1][1];
                case 5:
                    return $a1a91b25d7598376$var$months[val1.m - 1][0];
                default:
                    return $a1a91b25d7598376$var$months[val1.m - 1][2];
            }
            break;
        case 100:
            /* 'd' day */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.d;
                    outl = fmt.length;
                    break;
                case 3:
                    return $a1a91b25d7598376$var$days[val1.q][0];
                default:
                    return $a1a91b25d7598376$var$days[val1.q][1];
            }
            break;
        case 104:
            /* 'h' 12-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = 1 + (val1.H + 11) % 12;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 72:
            /* 'H' 24-hour */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.H;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad hour format: ' + fmt;
            }
            break;
        case 77:
            /* 'M' minutes */ switch(fmt.length){
                case 1:
                case 2:
                    out = val1.M;
                    outl = fmt.length;
                    break;
                default:
                    throw 'bad minute format: ' + fmt;
            }
            break;
        case 115:
            /* 's' seconds */ if (fmt != 's' && fmt != 'ss' && fmt != '.0' && fmt != '.00' && fmt != '.000') throw 'bad second format: ' + fmt;
            if (val1.u === 0 && (fmt == "s" || fmt == "ss")) return $a1a91b25d7598376$var$pad0(val1.S, fmt.length);
            /*::if(!ss0) ss0 = 0; */ if (ss0 >= 2) tt = ss0 === 3 ? 1000 : 100;
            else tt = ss0 === 1 ? 10 : 1;
            ss = Math.round(tt * (val1.S + val1.u));
            if (ss >= 60 * tt) ss = 0;
            if (fmt === 's') return ss === 0 ? "0" : "" + ss / tt;
            o = $a1a91b25d7598376$var$pad0(ss, 2 + ss0);
            if (fmt === 'ss') return o.substr(0, 2);
            return "." + o.substr(2, fmt.length - 1);
        case 90:
            /* 'Z' absolute time */ switch(fmt){
                case '[h]':
                case '[hh]':
                    out = val1.D * 24 + val1.H;
                    break;
                case '[m]':
                case '[mm]':
                    out = (val1.D * 24 + val1.H) * 60 + val1.M;
                    break;
                case '[s]':
                case '[ss]':
                    out = ((val1.D * 24 + val1.H) * 60 + val1.M) * 60 + (ss0 == 0 ? Math.round(val1.S + val1.u) : val1.S);
                    break;
                default:
                    throw 'bad abstime format: ' + fmt;
            }
            outl = fmt.length === 3 ? 1 : 2;
            break;
        case 101:
            /* 'e' era */ out = y;
            outl = 1;
            break;
    }
    var outstr = outl > 0 ? $a1a91b25d7598376$var$pad0(out, outl) : "";
    return outstr;
}
/*jshint -W086 */ /*jshint +W086 */ function $a1a91b25d7598376$var$commaify(s /*:string*/ ) /*:string*/ {
    var w = 3;
    if (s.length <= w) return s;
    var j = s.length % w, o = s.substr(0, j);
    for(; j != s.length; j += w)o += (o.length > 0 ? "," : "") + s.substr(j, w);
    return o;
}
var $a1a91b25d7598376$var$pct1 = /%/g;
function $a1a91b25d7598376$var$write_num_pct(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($a1a91b25d7598376$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $a1a91b25d7598376$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $a1a91b25d7598376$var$fill("%", mul);
}
function $a1a91b25d7598376$var$write_num_cm(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $a1a91b25d7598376$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $a1a91b25d7598376$var$write_num_exp(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $a1a91b25d7598376$var$write_num_exp(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (o.indexOf("e") === -1) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            while(o.substr(0, 2) === "0."){
                o = o.charAt(0) + o.substr(2, period) + "." + o.substr(2 + period);
                o = o.replace(/^0+([1-9])/, "$1").replace(/^0+\./, "0.");
            }
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
var $a1a91b25d7598376$var$frac1 = /# (\?+)( ?)\/( ?)(\d+)/;
function $a1a91b25d7598376$var$write_num_f1(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    var den = parseInt(r[4], 10), rr = Math.round(aval * den), base = Math.floor(rr / den);
    var myn = rr - base * den, myd = den;
    return sign + (base === 0 ? "" : "" + base) + " " + (myn === 0 ? $a1a91b25d7598376$var$fill(" ", r[1].length + 1 + r[4].length) : $a1a91b25d7598376$var$pad_(myn, r[1].length) + r[2] + "/" + r[3] + $a1a91b25d7598376$var$pad0(myd, r[4].length));
}
function $a1a91b25d7598376$var$write_num_f2(r /*:Array<string>*/ , aval /*:number*/ , sign /*:string*/ ) /*:string*/ {
    return sign + (aval === 0 ? "" : "" + aval) + $a1a91b25d7598376$var$fill(" ", r[1].length + 2 + r[4].length);
}
var $a1a91b25d7598376$var$dec1 = /^#*0*\.([0#]+)/;
var $a1a91b25d7598376$var$closeparen = /\)[^)]*[0#]/;
var $a1a91b25d7598376$var$phone = /\(###\) ###\\?-####/;
function $a1a91b25d7598376$var$hashq(str /*:string*/ ) /*:string*/ {
    var o = "", cc;
    for(var i = 0; i != str.length; ++i)switch(cc = str.charCodeAt(i)){
        case 35:
            break;
        case 63:
            o += " ";
            break;
        case 48:
            o += "0";
            break;
        default:
            o += String.fromCharCode(cc);
    }
    return o;
}
function $a1a91b25d7598376$var$rnd(val1 /*:number*/ , d /*:number*/ ) /*:string*/ {
    var dd = Math.pow(10, d);
    return "" + Math.round(val1 * dd) / dd;
}
function $a1a91b25d7598376$var$dec(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    var _frac = val1 - Math.floor(val1), dd = Math.pow(10, d);
    if (d < ('' + Math.round(_frac * dd)).length) return 0;
    return Math.round(_frac * dd);
}
function $a1a91b25d7598376$var$carry(val1 /*:number*/ , d /*:number*/ ) /*:number*/ {
    if (d < ('' + Math.round((val1 - Math.floor(val1)) * Math.pow(10, d))).length) return 1;
    return 0;
}
function $a1a91b25d7598376$var$flr(val1 /*:number*/ ) /*:string*/ {
    if (val1 < 2147483647 && val1 > -2147483648) return "" + (val1 >= 0 ? val1 | 0 : val1 - 1 | 0);
    return "" + Math.floor(val1);
}
function $a1a91b25d7598376$var$write_num_flt(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($a1a91b25d7598376$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $a1a91b25d7598376$var$write_num_flt('n', ffmt, val1);
        return '(' + $a1a91b25d7598376$var$write_num_flt('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $a1a91b25d7598376$var$write_num_cm(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $a1a91b25d7598376$var$write_num_pct(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $a1a91b25d7598376$var$write_num_exp(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $a1a91b25d7598376$var$write_num_flt(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $a1a91b25d7598376$var$pad0r(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = $a1a91b25d7598376$var$pad0r(val1, 0);
        if (o === "0") o = "";
        return o.length > fmt.length ? o : $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($a1a91b25d7598376$var$frac1)) return $a1a91b25d7598376$var$write_num_f1(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $a1a91b25d7598376$var$pad0r(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($a1a91b25d7598376$var$dec1)) {
        o = $a1a91b25d7598376$var$rnd(val1, r[1].length).replace(/^([^\.]+)$/, "$1." + $a1a91b25d7598376$var$hashq(r[1])).replace(/\.$/, "." + $a1a91b25d7598376$var$hashq(r[1])).replace(/\.(\d*)$/, function($$, $1) {
            return "." + $1 + $a1a91b25d7598376$var$fill("0", $a1a91b25d7598376$var$hashq(/*::(*/ r /*::||[""])*/ [1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + $a1a91b25d7598376$var$rnd(aval, r[2].length).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$pad0r(aval, 0));
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $a1a91b25d7598376$var$write_num_flt(type, fmt, -val1) : $a1a91b25d7598376$var$commaify("" + (Math.floor(val1) + $a1a91b25d7598376$var$carry(val1, r[1].length))) + "." + $a1a91b25d7598376$var$pad0($a1a91b25d7598376$var$dec(val1, r[1].length), r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $a1a91b25d7598376$var$write_num_flt(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$write_num_flt(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($a1a91b25d7598376$var$phone)) {
        o = $a1a91b25d7598376$var$write_num_flt(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $a1a91b25d7598376$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $a1a91b25d7598376$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $a1a91b25d7598376$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $a1a91b25d7598376$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $a1a91b25d7598376$var$rpad_(ff[2], ri) : $a1a91b25d7598376$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = $a1a91b25d7598376$var$pad0r(val1, 0);
        if (fmt.length <= o.length) return o;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0?]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) {
        ri = $a1a91b25d7598376$var$dec(val1, r[1].length);
        return val1 < 0 ? "-" + $a1a91b25d7598376$var$write_num_flt(type, fmt, -val1) : $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$flr(val1)).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
            return "00," + ($$.length < 3 ? $a1a91b25d7598376$var$pad0(0, 3 - $$.length) : "") + $$;
        }) + "." + $a1a91b25d7598376$var$pad0(ri, r[1].length);
    }
    switch(fmt){
        case "###,##0.00":
            return $a1a91b25d7598376$var$write_num_flt(type, "#,##0.00", val1);
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$pad0r(aval, 0));
            return x !== "0" ? sign + x : "";
        case "###,###.00":
            return $a1a91b25d7598376$var$write_num_flt(type, "###,##0.00", val1).replace(/^0\./, ".");
        case "#,###.00":
            return $a1a91b25d7598376$var$write_num_flt(type, "#,##0.00", val1).replace(/^0\./, ".");
        default:
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $a1a91b25d7598376$var$write_num_cm2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var idx = fmt.length - 1;
    while(fmt.charCodeAt(idx - 1) === 44)--idx;
    return $a1a91b25d7598376$var$write_num(type, fmt.substr(0, idx), val1 / Math.pow(10, 3 * (fmt.length - idx)));
}
function $a1a91b25d7598376$var$write_num_pct2(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var sfmt = fmt.replace($a1a91b25d7598376$var$pct1, ""), mul = fmt.length - sfmt.length;
    return $a1a91b25d7598376$var$write_num(type, sfmt, val1 * Math.pow(10, 2 * mul)) + $a1a91b25d7598376$var$fill("%", mul);
}
function $a1a91b25d7598376$var$write_num_exp2(fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    var o /*:string*/ ;
    var idx = fmt.indexOf("E") - fmt.indexOf(".") - 1;
    if (fmt.match(/^#+0.0E\+0$/)) {
        if (val1 == 0) return "0.0E+0";
        else if (val1 < 0) return "-" + $a1a91b25d7598376$var$write_num_exp2(fmt, -val1);
        var period = fmt.indexOf(".");
        if (period === -1) period = fmt.indexOf('E');
        var ee = Math.floor(Math.log(val1) * Math.LOG10E) % period;
        if (ee < 0) ee += period;
        o = (val1 / Math.pow(10, ee)).toPrecision(idx + 1 + (period + ee) % period);
        if (!o.match(/[Ee]/)) {
            var fakee = Math.floor(Math.log(val1) * Math.LOG10E);
            if (o.indexOf(".") === -1) o = o.charAt(0) + "." + o.substr(1) + "E+" + (fakee - o.length + ee);
            else o += "E+" + (fakee - ee);
            o = o.replace(/\+-/, "-");
        }
        o = o.replace(/^([+-]?)(\d*)\.(\d*)[Ee]/, function($$, $1, $2, $3) {
            return $1 + $2 + $3.substr(0, (period + ee) % period) + "." + $3.substr(ee) + "E";
        });
    } else o = val1.toExponential(idx);
    if (fmt.match(/E\+00$/) && o.match(/e[+-]\d$/)) o = o.substr(0, o.length - 1) + "0" + o.charAt(o.length - 1);
    if (fmt.match(/E\-/) && o.match(/e\+/)) o = o.replace(/e\+/, "e");
    return o.replace("e", "E");
}
function $a1a91b25d7598376$var$write_num_int(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    if (type.charCodeAt(0) === 40 && !fmt.match($a1a91b25d7598376$var$closeparen)) {
        var ffmt = fmt.replace(/\( */, "").replace(/ \)/, "").replace(/\)/, "");
        if (val1 >= 0) return $a1a91b25d7598376$var$write_num_int('n', ffmt, val1);
        return '(' + $a1a91b25d7598376$var$write_num_int('n', ffmt, -val1) + ')';
    }
    if (fmt.charCodeAt(fmt.length - 1) === 44) return $a1a91b25d7598376$var$write_num_cm2(type, fmt, val1);
    if (fmt.indexOf('%') !== -1) return $a1a91b25d7598376$var$write_num_pct2(type, fmt, val1);
    if (fmt.indexOf('E') !== -1) return $a1a91b25d7598376$var$write_num_exp2(fmt, val1);
    if (fmt.charCodeAt(0) === 36) return "$" + $a1a91b25d7598376$var$write_num_int(type, fmt.substr(fmt.charAt(1) == ' ' ? 2 : 1), val1);
    var o;
    var r /*:?Array<string>*/ , ri, ff, aval = Math.abs(val1), sign = val1 < 0 ? "-" : "";
    if (fmt.match(/^00+$/)) return sign + $a1a91b25d7598376$var$pad0(aval, fmt.length);
    if (fmt.match(/^[#?]+$/)) {
        o = "" + val1;
        if (val1 === 0) o = "";
        return o.length > fmt.length ? o : $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match($a1a91b25d7598376$var$frac1)) return $a1a91b25d7598376$var$write_num_f2(r, aval, sign);
    if (fmt.match(/^#+0+$/)) return sign + $a1a91b25d7598376$var$pad0(aval, fmt.length - fmt.indexOf("0"));
    if (r = fmt.match($a1a91b25d7598376$var$dec1)) {
        /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ o = ("" + val1).replace(/^([^\.]+)$/, "$1." + $a1a91b25d7598376$var$hashq(r[1])).replace(/\.$/, "." + $a1a91b25d7598376$var$hashq(r[1]));
        o = o.replace(/\.(\d*)$/, function($$, $1) {
            /*:: if(!Array.isArray(r)) throw new Error("unreachable"); */ return "." + $1 + $a1a91b25d7598376$var$fill("0", $a1a91b25d7598376$var$hashq(r[1]).length - $1.length);
        });
        return fmt.indexOf("0.") !== -1 ? o : o.replace(/^0\./, ".");
    }
    fmt = fmt.replace(/^#+([0.])/, "$1");
    if (r = fmt.match(/^(0*)\.(#*)$/)) return sign + ("" + aval).replace(/\.(\d*[1-9])0*$/, ".$1").replace(/^(-?\d*)$/, "$1.").replace(/^0\./, r[1].length ? "0." : ".");
    if (r = fmt.match(/^#{1,3},##0(\.?)$/)) return sign + $a1a91b25d7598376$var$commaify("" + aval);
    if (r = fmt.match(/^#,##0\.([#0]*0)$/)) return val1 < 0 ? "-" + $a1a91b25d7598376$var$write_num_int(type, fmt, -val1) : $a1a91b25d7598376$var$commaify("" + val1) + "." + $a1a91b25d7598376$var$fill('0', r[1].length);
    if (r = fmt.match(/^#,#*,#0/)) return $a1a91b25d7598376$var$write_num_int(type, fmt.replace(/^#,#*,/, ""), val1);
    if (r = fmt.match(/^([0#]+)(\\?-([0#]+))+$/)) {
        o = $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$write_num_int(type, fmt.replace(/[\\-]/g, ""), val1));
        ri = 0;
        return $a1a91b25d7598376$var$_strrev($a1a91b25d7598376$var$_strrev(fmt.replace(/\\/g, "")).replace(/[0#]/g, function(x) {
            return ri < o.length ? o.charAt(ri++) : x === '0' ? '0' : "";
        }));
    }
    if (fmt.match($a1a91b25d7598376$var$phone)) {
        o = $a1a91b25d7598376$var$write_num_int(type, "##########", val1);
        return "(" + o.substr(0, 3) + ") " + o.substr(3, 3) + "-" + o.substr(6);
    }
    var oa = "";
    if (r = fmt.match(/^([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(/*::String(*/ r[4]/*::)*/ .length, 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, false);
        o = "" + sign;
        oa = $a1a91b25d7598376$var$write_num("n", /*::String(*/ r[1], ff[1]);
        if (oa.charAt(oa.length - 1) == " ") oa = oa.substr(0, oa.length - 1) + "0";
        o += oa + /*::String(*/ r[2] + "/" + /*::String(*/ r[3] /*::)*/ ;
        oa = $a1a91b25d7598376$var$rpad_(ff[2], ri);
        if (oa.length < r[4].length) oa = $a1a91b25d7598376$var$hashq(r[4].substr(r[4].length - oa.length)) + oa;
        o += oa;
        return o;
    }
    if (r = fmt.match(/^# ([#0?]+)( ?)\/( ?)([#0?]+)/)) {
        ri = Math.min(Math.max(r[1].length, r[4].length), 7);
        ff = $a1a91b25d7598376$var$SSF_frac(aval, Math.pow(10, ri) - 1, true);
        return sign + (ff[0] || (ff[1] ? "" : "0")) + " " + (ff[1] ? $a1a91b25d7598376$var$pad_(ff[1], ri) + r[2] + "/" + r[3] + $a1a91b25d7598376$var$rpad_(ff[2], ri) : $a1a91b25d7598376$var$fill(" ", 2 * ri + 1 + r[2].length + r[3].length));
    }
    if (r = fmt.match(/^[#0?]+$/)) {
        o = "" + val1;
        if (fmt.length <= o.length) return o;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, fmt.length - o.length)) + o;
    }
    if (r = fmt.match(/^([#0]+)\.([#0]+)$/)) {
        o = "" + val1.toFixed(Math.min(r[2].length, 10)).replace(/([^0])0+$/, "$1");
        ri = o.indexOf(".");
        var lres = fmt.indexOf(".") - ri, rres = fmt.length - o.length - lres;
        return $a1a91b25d7598376$var$hashq(fmt.substr(0, lres) + o + fmt.substr(fmt.length - rres));
    }
    if (r = fmt.match(/^00,000\.([#0]*0)$/)) return val1 < 0 ? "-" + $a1a91b25d7598376$var$write_num_int(type, fmt, -val1) : $a1a91b25d7598376$var$commaify("" + val1).replace(/^\d,\d{3}$/, "0$&").replace(/^\d*$/, function($$) {
        return "00," + ($$.length < 3 ? $a1a91b25d7598376$var$pad0(0, 3 - $$.length) : "") + $$;
    }) + "." + $a1a91b25d7598376$var$pad0(0, r[1].length);
    switch(fmt){
        case "###,###":
        case "##,###":
        case "#,###":
            var x = $a1a91b25d7598376$var$commaify("" + aval);
            return x !== "0" ? sign + x : "";
        default:
            if (fmt.match(/\.[0#?]*$/)) return $a1a91b25d7598376$var$write_num_int(type, fmt.slice(0, fmt.lastIndexOf(".")), val1) + $a1a91b25d7598376$var$hashq(fmt.slice(fmt.lastIndexOf(".")));
    }
    throw new Error("unsupported format |" + fmt + "|");
}
function $a1a91b25d7598376$var$write_num(type /*:string*/ , fmt /*:string*/ , val1 /*:number*/ ) /*:string*/ {
    return (val1 | 0) === val1 ? $a1a91b25d7598376$var$write_num_int(type, fmt, val1) : $a1a91b25d7598376$var$write_num_flt(type, fmt, val1);
}
function $a1a91b25d7598376$var$SSF_split_fmt(fmt /*:string*/ ) /*:Array<string>*/ {
    var out /*:Array<string>*/  = [];
    var in_str = false /*, cc*/ ;
    for(var i = 0, j = 0; i < fmt.length; ++i)switch(/*cc=*/ fmt.charCodeAt(i)){
        case 34:
            /* '"' */ in_str = !in_str;
            break;
        case 95:
        case 42:
        case 92:
            /* '_' '*' '\\' */ ++i;
            break;
        case 59:
            /* ';' */ out[out.length] = fmt.substr(j, i - j);
            j = i + 1;
    }
    out[out.length] = fmt.substr(j);
    if (in_str === true) throw new Error("Format |" + fmt + "| unterminated string ");
    return out;
}
var $a1a91b25d7598376$var$SSF_abstime = /\[[HhMmSs\u0E0A\u0E19\u0E17]*\]/;
function $a1a91b25d7598376$var$fmt_is_date(fmt /*:string*/ ) /*:boolean*/ {
    var i = 0, /*cc = 0,*/ c = "", o = "";
    while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            if ($a1a91b25d7598376$var$SSF_isgeneral(fmt, i)) i += 6;
            i++;
            break;
        case '"':
            for(; /*cc=*/ fmt.charCodeAt(++i) !== 34 && i < fmt.length;);
            ++i;
            break;
        case '\\':
            i += 2;
            break;
        case '_':
            i += 2;
            break;
        case '@':
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") return true;
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            return true;
        case 'A':
        case 'a':
        case "\u4E0A":
            if (fmt.substr(i, 3).toUpperCase() === "A/P") return true;
            if (fmt.substr(i, 5).toUpperCase() === "AM/PM") return true;
            if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") return true;
            ++i;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.match($a1a91b25d7598376$var$SSF_abstime)) return true;
            break;
        case '.':
        /* falls through */ case '0':
        case '#':
            while(i < fmt.length && ("0#?.,E+-%".indexOf(c = fmt.charAt(++i)) > -1 || c == '\\' && fmt.charAt(i + 1) == "-" && "0#".indexOf(fmt.charAt(i + 2)) > -1));
            break;
        case '?':
            while(fmt.charAt(++i) === c);
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break;
        case '(':
        case ')':
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1);
            break;
        case ' ':
            ++i;
            break;
        default:
            ++i;
            break;
    }
    return false;
}
function $a1a91b25d7598376$var$eval_fmt(fmt /*:string*/ , v /*:any*/ , opts /*:any*/ , flen /*:number*/ ) {
    var out = [], o = "", i = 0, c = "", lst = 't', dt, j, cc;
    var hr = 'H';
    /* Tokenize */ while(i < fmt.length)switch(c = fmt.charAt(i)){
        case 'G':
            /* General */ if (!$a1a91b25d7598376$var$SSF_isgeneral(fmt, i)) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 'G',
                v: 'General'
            };
            i += 7;
            break;
        case '"':
            /* Literal text */ for(o = ""; (cc = fmt.charCodeAt(++i)) !== 34 && i < fmt.length;)o += String.fromCharCode(cc);
            out[out.length] = {
                t: 't',
                v: o
            };
            ++i;
            break;
        case '\\':
            var w = fmt.charAt(++i), t = w === "(" || w === ")" ? w : 't';
            out[out.length] = {
                t: t,
                v: w
            };
            ++i;
            break;
        case '_':
            out[out.length] = {
                t: 't',
                v: " "
            };
            i += 2;
            break;
        case '@':
            /* Text Placeholder */ out[out.length] = {
                t: 'T',
                v: v
            };
            ++i;
            break;
        case 'B':
        case 'b':
            if (fmt.charAt(i + 1) === "1" || fmt.charAt(i + 1) === "2") {
                if (dt == null) {
                    dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts, fmt.charAt(i + 1) === "2");
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'X',
                    v: fmt.substr(i, 2)
                };
                lst = c;
                i += 2;
                break;
            }
        /* falls through */ case 'M':
        case 'D':
        case 'Y':
        case 'H':
        case 'S':
        case 'E':
            c = c.toLowerCase();
        /* falls through */ case 'm':
        case 'd':
        case 'y':
        case 'h':
        case 's':
        case 'e':
        case 'g':
            if (v < 0) return "";
            if (dt == null) {
                dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts);
                if (dt == null) return "";
            }
            o = c;
            while(++i < fmt.length && fmt.charAt(i).toLowerCase() === c)o += c;
            if (c === 'm' && lst.toLowerCase() === 'h') c = 'M';
            if (c === 'h') c = hr;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case 'A':
        case 'a':
        case "\u4E0A":
            var q = {
                t: c,
                v: c
            };
            if (dt == null) dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts);
            if (fmt.substr(i, 3).toUpperCase() === "A/P") {
                if (dt != null) q.v = dt.H >= 12 ? fmt.charAt(i + 2) : c;
                q.t = 'T';
                hr = 'h';
                i += 3;
            } else if (fmt.substr(i, 5).toUpperCase() === "AM/PM") {
                if (dt != null) q.v = dt.H >= 12 ? "PM" : "AM";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else if (fmt.substr(i, 5).toUpperCase() === "\u4E0A\u5348/\u4E0B\u5348") {
                if (dt != null) q.v = dt.H >= 12 ? "\u4E0B\u5348" : "\u4E0A\u5348";
                q.t = 'T';
                i += 5;
                hr = 'h';
            } else {
                q.t = "t";
                ++i;
            }
            if (dt == null && q.t === 'T') return "";
            out[out.length] = q;
            lst = c;
            break;
        case '[':
            o = c;
            while(fmt.charAt(i++) !== ']' && i < fmt.length)o += fmt.charAt(i);
            if (o.slice(-1) !== ']') throw 'unterminated "[" block: |' + o + '|';
            if (o.match($a1a91b25d7598376$var$SSF_abstime)) {
                if (dt == null) {
                    dt = $a1a91b25d7598376$var$SSF_parse_date_code(v, opts);
                    if (dt == null) return "";
                }
                out[out.length] = {
                    t: 'Z',
                    v: o.toLowerCase()
                };
                lst = o.charAt(1);
            } else if (o.indexOf("$") > -1) {
                o = (o.match(/\$([^-\[\]]*)/) || [])[1] || "$";
                if (!$a1a91b25d7598376$var$fmt_is_date(fmt)) out[out.length] = {
                    t: 't',
                    v: o
                };
            }
            break;
        /* Numbers */ case '.':
            if (dt != null) {
                o = c;
                while(++i < fmt.length && (c = fmt.charAt(i)) === "0")o += c;
                out[out.length] = {
                    t: 's',
                    v: o
                };
                break;
            }
        /* falls through */ case '0':
        case '#':
            o = c;
            while(++i < fmt.length && "0#?.,E+-%".indexOf(c = fmt.charAt(i)) > -1)o += c;
            out[out.length] = {
                t: 'n',
                v: o
            };
            break;
        case '?':
            o = c;
            while(fmt.charAt(++i) === c)o += c;
            out[out.length] = {
                t: c,
                v: o
            };
            lst = c;
            break;
        case '*':
            ++i;
            if (fmt.charAt(i) == ' ' || fmt.charAt(i) == '*') ++i;
            break; // **
        case '(':
        case ')':
            out[out.length] = {
                t: flen === 1 ? 't' : c,
                v: c
            };
            ++i;
            break;
        case '1':
        case '2':
        case '3':
        case '4':
        case '5':
        case '6':
        case '7':
        case '8':
        case '9':
            o = c;
            while(i < fmt.length && "0123456789".indexOf(fmt.charAt(++i)) > -1)o += fmt.charAt(i);
            out[out.length] = {
                t: 'D',
                v: o
            };
            break;
        case ' ':
            out[out.length] = {
                t: c,
                v: c
            };
            ++i;
            break;
        case '$':
            out[out.length] = {
                t: 't',
                v: '$'
            };
            ++i;
            break;
        default:
            if (",$-+/():!^&'~{}<>=\u20ACacfijklopqrtuvwxzP".indexOf(c) === -1) throw new Error('unrecognized character ' + c + ' in ' + fmt);
            out[out.length] = {
                t: 't',
                v: c
            };
            ++i;
            break;
    }
    /* Scan for date/time parts */ var bt = 0, ss0 = 0, ssm;
    for(i = out.length - 1, lst = 't'; i >= 0; --i)switch(out[i].t){
        case 'h':
        case 'H':
            out[i].t = hr;
            lst = 'h';
            if (bt < 1) bt = 1;
            break;
        case 's':
            if (ssm = out[i].v.match(/\.0+$/)) {
                ss0 = Math.max(ss0, ssm[0].length - 1);
                bt = 4;
            }
            if (bt < 3) bt = 3;
        /* falls through */ case 'd':
        case 'y':
        case 'e':
            lst = out[i].t;
            break;
        case 'M':
            lst = out[i].t;
            if (bt < 2) bt = 2;
            break;
        case 'm':
            if (lst === 's') {
                out[i].t = 'M';
                if (bt < 2) bt = 2;
            }
            break;
        case 'X':
            break;
        case 'Z':
            if (bt < 1 && out[i].v.match(/[Hh]/)) bt = 1;
            if (bt < 2 && out[i].v.match(/[Mm]/)) bt = 2;
            if (bt < 3 && out[i].v.match(/[Ss]/)) bt = 3;
    }
    /* time rounding depends on presence of minute / second / usec fields */ var _dt;
    switch(bt){
        case 0:
            break;
        case 1:
        case 2:
        case 3:
            if (dt.u >= 0.5) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $a1a91b25d7598376$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
        case 4:
            switch(ss0){
                case 1:
                    dt.u = Math.round(dt.u * 10) / 10;
                    break;
                case 2:
                    dt.u = Math.round(dt.u * 100) / 100;
                    break;
                case 3:
                    dt.u = Math.round(dt.u * 1000) / 1000;
                    break;
            }
            if (dt.u >= 1) {
                dt.u = 0;
                ++dt.S;
            }
            if (dt.S >= 60) {
                dt.S = 0;
                ++dt.M;
            }
            if (dt.M >= 60) {
                dt.M = 0;
                ++dt.H;
            }
            if (dt.H >= 24) {
                dt.H = 0;
                ++dt.D;
                _dt = $a1a91b25d7598376$var$SSF_parse_date_code(dt.D);
                _dt.u = dt.u;
                _dt.S = dt.S;
                _dt.M = dt.M;
                _dt.H = dt.H;
                dt = _dt;
            }
            break;
    }
    /* replace fields */ var nstr = "", jj;
    for(i = 0; i < out.length; ++i)switch(out[i].t){
        case 't':
        case 'T':
        case ' ':
        case 'D':
            break;
        case 'X':
            out[i].v = "";
            out[i].t = ";";
            break;
        case 'd':
        case 'm':
        case 'y':
        case 'h':
        case 'H':
        case 'M':
        case 's':
        case 'e':
        case 'b':
        case 'Z':
            /*::if(!dt) throw "unreachable"; */ out[i].v = $a1a91b25d7598376$var$SSF_write_date(out[i].t.charCodeAt(0), out[i].v, dt, ss0);
            out[i].t = 't';
            break;
        case 'n':
        case '?':
            jj = i + 1;
            while(out[jj] != null && ((c = out[jj].t) === "?" || c === "D" || (c === " " || c === "t") && out[jj + 1] != null && (out[jj + 1].t === '?' || out[jj + 1].t === "t" && out[jj + 1].v === '/') || out[i].t === '(' && (c === ' ' || c === 'n' || c === ')') || c === 't' && (out[jj].v === '/' || out[jj].v === ' ' && out[jj + 1] != null && out[jj + 1].t == '?'))){
                out[i].v += out[jj].v;
                out[jj] = {
                    v: "",
                    t: ";"
                };
                ++jj;
            }
            nstr += out[i].v;
            i = jj - 1;
            break;
        case 'G':
            out[i].t = 't';
            out[i].v = $a1a91b25d7598376$var$SSF_general(v, opts);
            break;
    }
    var vv = "", myv, ostr;
    if (nstr.length > 0) {
        if (nstr.charCodeAt(0) == 40) /* '(' */ {
            myv = v < 0 && nstr.charCodeAt(0) === 45 ? -v : v;
            ostr = $a1a91b25d7598376$var$write_num('n', nstr, myv);
        } else {
            myv = v < 0 && flen > 1 ? -v : v;
            ostr = $a1a91b25d7598376$var$write_num('n', nstr, myv);
            if (myv < 0 && out[0] && out[0].t == 't') {
                ostr = ostr.substr(1);
                out[0].v = "-" + out[0].v;
            }
        }
        jj = ostr.length - 1;
        var decpt = out.length;
        for(i = 0; i < out.length; ++i)if (out[i] != null && out[i].t != 't' && out[i].v.indexOf(".") > -1) {
            decpt = i;
            break;
        }
        var lasti = out.length;
        if (decpt === out.length && ostr.indexOf("E") === -1) {
            for(i = out.length - 1; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                if (jj >= out[i].v.length - 1) {
                    jj -= out[i].v.length;
                    out[i].v = ostr.substr(jj + 1, out[i].v.length);
                } else if (jj < 0) out[i].v = "";
                else {
                    out[i].v = ostr.substr(0, jj + 1);
                    jj = -1;
                }
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
        } else if (decpt !== out.length && ostr.indexOf("E") === -1) {
            jj = ostr.indexOf(".") - 1;
            for(i = decpt; i >= 0; --i){
                if (out[i] == null || 'n?'.indexOf(out[i].t) === -1) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") - 1 : out[i].v.length - 1;
                vv = out[i].v.substr(j + 1);
                for(; j >= 0; --j)if (jj >= 0 && (out[i].v.charAt(j) === "0" || out[i].v.charAt(j) === "#")) vv = ostr.charAt(jj--) + vv;
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
            if (jj >= 0 && lasti < out.length) out[lasti].v = ostr.substr(0, jj + 1) + out[lasti].v;
            jj = ostr.indexOf(".") + 1;
            for(i = decpt; i < out.length; ++i){
                if (out[i] == null || 'n?('.indexOf(out[i].t) === -1 && i !== decpt) continue;
                j = out[i].v.indexOf(".") > -1 && i === decpt ? out[i].v.indexOf(".") + 1 : 0;
                vv = out[i].v.substr(0, j);
                for(; j < out[i].v.length; ++j)if (jj < ostr.length) vv += ostr.charAt(jj++);
                out[i].v = vv;
                out[i].t = 't';
                lasti = i;
            }
        }
    }
    for(i = 0; i < out.length; ++i)if (out[i] != null && 'n?'.indexOf(out[i].t) > -1) {
        myv = flen > 1 && v < 0 && i > 0 && out[i - 1].v === "-" ? -v : v;
        out[i].v = $a1a91b25d7598376$var$write_num(out[i].t, out[i].v, myv);
        out[i].t = 't';
    }
    var retval = "";
    for(i = 0; i !== out.length; ++i)if (out[i] != null) retval += out[i].v;
    return retval;
}
var $a1a91b25d7598376$var$cfregex2 = /\[(=|>[=]?|<[>=]?)(-?\d+(?:\.\d*)?)\]/;
function $a1a91b25d7598376$var$chkcond(v, rr) {
    if (rr == null) return false;
    var thresh = parseFloat(rr[2]);
    switch(rr[1]){
        case "=":
            if (v == thresh) return true;
            break;
        case ">":
            if (v > thresh) return true;
            break;
        case "<":
            if (v < thresh) return true;
            break;
        case "<>":
            if (v != thresh) return true;
            break;
        case ">=":
            if (v >= thresh) return true;
            break;
        case "<=":
            if (v <= thresh) return true;
            break;
    }
    return false;
}
function $a1a91b25d7598376$var$choose_fmt(f /*:string*/ , v /*:any*/ ) {
    var fmt = $a1a91b25d7598376$var$SSF_split_fmt(f);
    var l = fmt.length, lat = fmt[l - 1].indexOf("@");
    if (l < 4 && lat > -1) --l;
    if (fmt.length > 4) throw new Error("cannot find right format for |" + fmt.join("|") + "|");
    if (typeof v !== "number") return [
        4,
        fmt.length === 4 || lat > -1 ? fmt[fmt.length - 1] : "@"
    ];
    /* NOTE: most spreadsheet software do not support NaN or infinities */ if (typeof v === "number" && !isFinite(v)) v = 0;
    switch(fmt.length){
        case 1:
            fmt = lat > -1 ? [
                "General",
                "General",
                "General",
                fmt[0]
            ] : [
                fmt[0],
                fmt[0],
                fmt[0],
                "@"
            ];
            break;
        case 2:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[0],
                fmt[0],
                fmt[1]
            ] : [
                fmt[0],
                fmt[1],
                fmt[0],
                "@"
            ];
            break;
        case 3:
            fmt = lat > -1 ? [
                fmt[0],
                fmt[1],
                fmt[0],
                fmt[2]
            ] : [
                fmt[0],
                fmt[1],
                fmt[2],
                "@"
            ];
            break;
        case 4:
            break;
    }
    var ff = v > 0 ? fmt[0] : v < 0 ? fmt[1] : fmt[2];
    if (fmt[0].indexOf("[") === -1 && fmt[1].indexOf("[") === -1) return [
        l,
        ff
    ];
    if (fmt[0].match(/\[[=<>]/) != null || fmt[1].match(/\[[=<>]/) != null) {
        var m1 = fmt[0].match($a1a91b25d7598376$var$cfregex2);
        var m2 = fmt[1].match($a1a91b25d7598376$var$cfregex2);
        return $a1a91b25d7598376$var$chkcond(v, m1) ? [
            l,
            fmt[0]
        ] : $a1a91b25d7598376$var$chkcond(v, m2) ? [
            l,
            fmt[1]
        ] : [
            l,
            fmt[m1 != null && m2 != null ? 2 : 1]
        ];
    }
    return [
        l,
        ff
    ];
}
function $a1a91b25d7598376$var$SSF_format(fmt /*:string|number*/ , v /*:any*/ , o /*:?any*/ ) {
    if (o == null) o = {};
    var sfmt = "";
    switch(typeof fmt){
        case "string":
            if (fmt == "m/d/yy" && o.dateNF) sfmt = o.dateNF;
            else sfmt = fmt;
            break;
        case "number":
            if (fmt == 14 && o.dateNF) sfmt = o.dateNF;
            else sfmt = (o.table != null ? o.table /*:any*/  : $a1a91b25d7598376$var$table_fmt)[fmt];
            if (sfmt == null) sfmt = o.table && o.table[$a1a91b25d7598376$var$SSF_default_map[fmt]] || $a1a91b25d7598376$var$table_fmt[$a1a91b25d7598376$var$SSF_default_map[fmt]];
            if (sfmt == null) sfmt = $a1a91b25d7598376$var$SSF_default_str[fmt] || "General";
            break;
    }
    if ($a1a91b25d7598376$var$SSF_isgeneral(sfmt, 0)) return $a1a91b25d7598376$var$SSF_general(v, o);
    if (v instanceof Date) v = $a1a91b25d7598376$var$datenum(v, o.date1904);
    var f = $a1a91b25d7598376$var$choose_fmt(sfmt, v);
    if ($a1a91b25d7598376$var$SSF_isgeneral(f[1])) return $a1a91b25d7598376$var$SSF_general(v, o);
    if (v === true) v = "TRUE";
    else if (v === false) v = "FALSE";
    else if (v === "" || v == null) return "";
    else if (isNaN(v) && f[1].indexOf("0") > -1) return "#NUM!";
    else if (!isFinite(v) && f[1].indexOf("0") > -1) return "#DIV/0!";
    return $a1a91b25d7598376$var$eval_fmt(f[1], v, o, f[0]);
}
function $a1a91b25d7598376$var$SSF_load(fmt /*:string*/ , idx /*:?number*/ ) /*:number*/ {
    if (typeof idx != 'number') {
        idx = +idx || -1;
        /*::if(typeof idx != 'number') return 0x188; */ for(var i = 0; i < 0x0188; ++i){
            /*::if(typeof idx != 'number') return 0x188; */ if ($a1a91b25d7598376$var$table_fmt[i] == undefined) {
                if (idx < 0) idx = i;
                continue;
            }
            if ($a1a91b25d7598376$var$table_fmt[i] == fmt) {
                idx = i;
                break;
            }
        }
        /*::if(typeof idx != 'number') return 0x188; */ if (idx < 0) idx = 0x187;
    }
    /*::if(typeof idx != 'number') return 0x188; */ $a1a91b25d7598376$var$table_fmt[idx] = fmt;
    return idx;
}
function $a1a91b25d7598376$var$SSF_load_table(tbl /*:SSFTable*/ ) /*:void*/ {
    for(var i = 0; i != 0x0188; ++i)if (tbl[i] !== undefined) $a1a91b25d7598376$var$SSF_load(tbl[i], i);
}
function $a1a91b25d7598376$var$make_ssf() {
    $a1a91b25d7598376$var$table_fmt = $a1a91b25d7598376$var$SSF_init_table();
}
var $a1a91b25d7598376$export$40d8edd678456c2b = {
    format: $a1a91b25d7598376$var$SSF_format,
    load: $a1a91b25d7598376$var$SSF_load,
    _table: $a1a91b25d7598376$var$table_fmt,
    load_table: $a1a91b25d7598376$var$SSF_load_table,
    parse_date_code: $a1a91b25d7598376$var$SSF_parse_date_code,
    is_date: $a1a91b25d7598376$var$fmt_is_date,
    get_table: function get_table() {
        return $a1a91b25d7598376$export$40d8edd678456c2b._table = $a1a91b25d7598376$var$table_fmt;
    }
};
var $a1a91b25d7598376$var$SSFImplicit /*{[number]:string}*/  = {
    "5": '"$"#,##0_);\\("$"#,##0\\)',
    "6": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "7": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "8": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "23": 'General',
    "24": 'General',
    "25": 'General',
    "26": 'General',
    "27": 'm/d/yy',
    "28": 'm/d/yy',
    "29": 'm/d/yy',
    "30": 'm/d/yy',
    "31": 'm/d/yy',
    "32": 'h:mm:ss',
    "33": 'h:mm:ss',
    "34": 'h:mm:ss',
    "35": 'h:mm:ss',
    "36": 'm/d/yy',
    "41": '_(* #,##0_);_(* \(#,##0\);_(* "-"_);_(@_)',
    "42": '_("$"* #,##0_);_("$"* \(#,##0\);_("$"* "-"_);_(@_)',
    "43": '_(* #,##0.00_);_(* \(#,##0.00\);_(* "-"??_);_(@_)',
    "44": '_("$"* #,##0.00_);_("$"* \(#,##0.00\);_("$"* "-"??_);_(@_)',
    "50": 'm/d/yy',
    "51": 'm/d/yy',
    "52": 'm/d/yy',
    "53": 'm/d/yy',
    "54": 'm/d/yy',
    "55": 'm/d/yy',
    "56": 'm/d/yy',
    "57": 'm/d/yy',
    "58": 'm/d/yy',
    "59": '0',
    "60": '0.00',
    "61": '#,##0',
    "62": '#,##0.00',
    "63": '"$"#,##0_);\\("$"#,##0\\)',
    "64": '"$"#,##0_);[Red]\\("$"#,##0\\)',
    "65": '"$"#,##0.00_);\\("$"#,##0.00\\)',
    "66": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
    "67": '0%',
    "68": '0.00%',
    "69": '# ?/?',
    "70": '# ??/??',
    "71": 'm/d/yy',
    "72": 'm/d/yy',
    "73": 'd-mmm-yy',
    "74": 'd-mmm',
    "75": 'mmm-yy',
    "76": 'h:mm',
    "77": 'h:mm:ss',
    "78": 'm/d/yy h:mm',
    "79": 'mm:ss',
    "80": '[h]:mm:ss',
    "81": 'mmss.0'
} /*:any*/ ;
/* dateNF parse TODO: move to SSF */ var $a1a91b25d7598376$var$dateNFregex = /[dD]+|[mM]+|[yYeE]+|[Hh]+|[Ss]+/g;
function $a1a91b25d7598376$var$dateNF_regex(dateNF /*:string|number*/ ) /*:RegExp*/ {
    var fmt = typeof dateNF == "number" ? $a1a91b25d7598376$var$table_fmt[dateNF] : dateNF;
    fmt = fmt.replace($a1a91b25d7598376$var$dateNFregex, "(\\d+)");
    $a1a91b25d7598376$var$dateNFregex.lastIndex = 0;
    return new RegExp("^" + fmt + "$");
}
function $a1a91b25d7598376$var$dateNF_fix(str /*:string*/ , dateNF /*:string*/ , match /*:Array<string>*/ ) /*:string*/ {
    var Y = -1, m = -1, d = -1, H = -1, M = -1, S = -1;
    (dateNF.match($a1a91b25d7598376$var$dateNFregex) || []).forEach(function(n, i) {
        var v = parseInt(match[i + 1], 10);
        switch(n.toLowerCase().charAt(0)){
            case 'y':
                Y = v;
                break;
            case 'd':
                d = v;
                break;
            case 'h':
                H = v;
                break;
            case 's':
                S = v;
                break;
            case 'm':
                if (H >= 0) M = v;
                else m = v;
                break;
        }
    });
    $a1a91b25d7598376$var$dateNFregex.lastIndex = 0;
    if (S >= 0 && M == -1 && m >= 0) {
        M = m;
        m = -1;
    }
    var datestr = ("" + (Y >= 0 ? Y : new Date().getFullYear())).slice(-4) + "-" + ("00" + (m >= 1 ? m : 1)).slice(-2) + "-" + ("00" + (d >= 1 ? d : 1)).slice(-2);
    if (datestr.length == 7) datestr = "0" + datestr;
    if (datestr.length == 8) datestr = "20" + datestr;
    var timestr = ("00" + (H >= 0 ? H : 0)).slice(-2) + ":" + ("00" + (M >= 0 ? M : 0)).slice(-2) + ":" + ("00" + (S >= 0 ? S : 0)).slice(-2);
    if (H == -1 && M == -1 && S == -1) return datestr;
    if (Y == -1 && m == -1 && d == -1) return timestr;
    return datestr + "T" + timestr;
}
/* table of bad formats written by third-party tools */ var $a1a91b25d7598376$var$bad_formats = {
    "d.m": "d\\.m" // Issue #2571 Google Sheets writes invalid format 'd.m', correct format is 'd"."m' or 'd\\.m'
};
function $a1a91b25d7598376$var$SSF__load(fmt, idx) {
    return $a1a91b25d7598376$var$SSF_load($a1a91b25d7598376$var$bad_formats[fmt] || fmt, idx);
}
/*::
declare var ReadShift:any;
declare var CheckField:any;
declare var prep_blob:any;
declare var __readUInt32LE:any;
declare var __readInt32LE:any;
declare var __toBuffer:any;
declare var __utf16le:any;
declare var bconcat:any;
declare var s2a:any;
declare var chr0:any;
declare var chr1:any;
declare var has_buf:boolean;
declare var new_buf:any;
declare var new_raw_buf:any;
declare var new_unsafe_buf:any;
declare var Buffer_from:any;
*/ /* cfb.js (C) 2013-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*jshint eqnull:true */ /*exported CFB */ /*global Uint8Array:false, Uint16Array:false */ /*::
type SectorEntry = {
	name?:string;
	nodes?:Array<number>;
	data:RawBytes;
};
type SectorList = {
	[k:string|number]:SectorEntry;
	name:?string;
	fat_addrs:Array<number>;
	ssz:number;
}
type CFBFiles = {[n:string]:CFBEntry};
*/ /* crc32.js (C) 2014-present SheetJS -- http://sheetjs.com */ /* vim: set ts=2: */ /*exported CRC32 */ var $a1a91b25d7598376$var$CRC32 = /*#__PURE__*/ function() {
    var CRC32 = {};
    CRC32.version = '1.2.0';
    /*::
type CRC32TableType = Array<number> | Int32Array;
*/ /*global Int32Array */ function signed_crc_table() /*:any*/ {
        var c = 0, table /*:Array<number>*/  = new Array(256);
        for(var n = 0; n != 256; ++n){
            c = n;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            c = c & 1 ? -306674912 ^ c >>> 1 : c >>> 1;
            table[n] = c;
        }
        return typeof Int32Array !== 'undefined' ? new Int32Array(table) : table;
    }
    var T0 = signed_crc_table();
    function slice_by_16_tables(T) {
        var c = 0, v = 0, n = 0, table /*:Array<number>*/  = typeof Int32Array !== 'undefined' ? new Int32Array(4096) : new Array(4096);
        for(n = 0; n != 256; ++n)table[n] = T[n];
        for(n = 0; n != 256; ++n){
            v = T[n];
            for(c = 256 + n; c < 4096; c += 256)v = table[c] = v >>> 8 ^ T[v & 0xFF];
        }
        var out = [];
        for(n = 1; n != 16; ++n)out[n - 1] = typeof Int32Array !== 'undefined' && typeof table.subarray == "function" ? table.subarray(n * 256, n * 256 + 256) : table.slice(n * 256, n * 256 + 256);
        return out;
    }
    var TT = slice_by_16_tables(T0);
    var T1 = TT[0], T2 = TT[1], T3 = TT[2], T4 = TT[3], T5 = TT[4];
    var T6 = TT[5], T7 = TT[6], T8 = TT[7], T9 = TT[8], Ta = TT[9];
    var Tb = TT[10], Tc = TT[11], Td = TT[12], Te = TT[13], Tf = TT[14];
    function crc32_bstr(bstr /*:string*/ , seed /*:?number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1;
        for(var i = 0, L = bstr.length; i < L;)C = C >>> 8 ^ T0[(C ^ bstr.charCodeAt(i++)) & 0xFF];
        return ~C;
    }
    function crc32_buf(B /*:Uint8Array|Array<number>*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed /*:: ? 0 : 0 */  ^ -1, L = B.length - 15, i = 0;
        for(; i < L;)C = Tf[B[i++] ^ C & 255] ^ Te[B[i++] ^ C >> 8 & 255] ^ Td[B[i++] ^ C >> 16 & 255] ^ Tc[B[i++] ^ C >>> 24] ^ Tb[B[i++]] ^ Ta[B[i++]] ^ T9[B[i++]] ^ T8[B[i++]] ^ T7[B[i++]] ^ T6[B[i++]] ^ T5[B[i++]] ^ T4[B[i++]] ^ T3[B[i++]] ^ T2[B[i++]] ^ T1[B[i++]] ^ T0[B[i++]];
        L += 15;
        while(i < L)C = C >>> 8 ^ T0[(C ^ B[i++]) & 0xFF];
        return ~C;
    }
    function crc32_str(str /*:string*/ , seed /*:number*/ ) /*:number*/ {
        var C = seed ^ -1;
        for(var i = 0, L = str.length, c = 0, d = 0; i < L;){
            c = str.charCodeAt(i++);
            if (c < 0x80) C = C >>> 8 ^ T0[(C ^ c) & 0xFF];
            else if (c < 0x800) {
                C = C >>> 8 ^ T0[(C ^ (192 | c >> 6 & 31)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            } else if (c >= 0xD800 && c < 0xE000) {
                c = (c & 1023) + 64;
                d = str.charCodeAt(i++) & 1023;
                C = C >>> 8 ^ T0[(C ^ (240 | c >> 8 & 7)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 2 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d >> 6 & 15 | (c & 3) << 4)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | d & 63)) & 0xFF];
            } else {
                C = C >>> 8 ^ T0[(C ^ (224 | c >> 12 & 15)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c >> 6 & 63)) & 0xFF];
                C = C >>> 8 ^ T0[(C ^ (128 | c & 63)) & 0xFF];
            }
        }
        return ~C;
    }
    CRC32.table = T0;
    CRC32.bstr = crc32_bstr;
    CRC32.buf = crc32_buf;
    CRC32.str = crc32_str;
    return CRC32;
}();
/* [MS-CFB] v20171201 */ var $a1a91b25d7598376$export$9f0e51cd97c572a = /*#__PURE__*/ function _CFB() {
    var exports /*:CFBModule*/  = /*::(*/ {} /*:: :any)*/ ;
    exports.version = '1.2.2';
    /* [MS-CFB] 2.6.4 */ function namecmp(l /*:string*/ , r /*:string*/ ) /*:number*/ {
        var L = l.split("/"), R = r.split("/");
        for(var i = 0, c = 0, Z = Math.min(L.length, R.length); i < Z; ++i){
            if (c = L[i].length - R[i].length) return c;
            if (L[i] != R[i]) return L[i] < R[i] ? -1 : 1;
        }
        return L.length - R.length;
    }
    function dirname(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return p.slice(0, -1).indexOf("/") === -1 ? p : dirname(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(0, c + 1);
    }
    function filename(p /*:string*/ ) /*:string*/ {
        if (p.charAt(p.length - 1) == "/") return filename(p.slice(0, -1));
        var c = p.lastIndexOf("/");
        return c === -1 ? p : p.slice(c + 1);
    }
    /* -------------------------------------------------------------------------- */ /* DOS Date format:
   high|YYYYYYYm.mmmddddd.HHHHHMMM.MMMSSSSS|low
   add 1980 to stored year
   stored second should be doubled
*/ /* write JS date to buf as a DOS date */ function write_dos_date(buf /*:CFBlob*/ , date /*:Date|string*/ ) {
        if (typeof date === "string") date = new Date(date);
        var hms /*:number*/  = date.getHours();
        hms = hms << 6 | date.getMinutes();
        hms = hms << 5 | date.getSeconds() >>> 1;
        buf.write_shift(2, hms);
        var ymd /*:number*/  = date.getFullYear() - 1980;
        ymd = ymd << 4 | date.getMonth() + 1;
        ymd = ymd << 5 | date.getDate();
        buf.write_shift(2, ymd);
    }
    /* read four bytes from buf and interpret as a DOS date */ function parse_dos_date(buf /*:CFBlob*/ ) /*:Date*/ {
        var hms = buf.read_shift(2) & 0xFFFF;
        var ymd = buf.read_shift(2) & 0xFFFF;
        var val1 = new Date();
        var d = ymd & 0x1F;
        ymd >>>= 5;
        var m = ymd & 0x0F;
        ymd >>>= 4;
        val1.setMilliseconds(0);
        val1.setFullYear(ymd + 1980);
        val1.setMonth(m - 1);
        val1.setDate(d);
        var S = hms & 0x1F;
        hms >>>= 5;
        var M = hms & 0x3F;
        hms >>>= 6;
        val1.setHours(hms);
        val1.setMinutes(M);
        val1.setSeconds(S << 1);
        return val1;
    }
    function parse_extra_field(blob /*:CFBlob*/ ) /*:any*/ {
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        var o = /*::(*/ {} /*:: :any)*/ ;
        var flags = 0;
        while(blob.l <= blob.length - 4){
            var type = blob.read_shift(2);
            var sz = blob.read_shift(2), tgt = blob.l + sz;
            var p = {};
            switch(type){
                /* UNIX-style Timestamps */ case 0x5455:
                    flags = blob.read_shift(1);
                    if (flags & 1) p.mtime = blob.read_shift(4);
                    /* for some reason, CD flag corresponds to LFH */ if (sz > 5) {
                        if (flags & 2) p.atime = blob.read_shift(4);
                        if (flags & 4) p.ctime = blob.read_shift(4);
                    }
                    if (p.mtime) p.mt = new Date(p.mtime * 1000);
                    break;
                /* ZIP64 Extended Information Field */ case 0x0001:
                    var sz1 = blob.read_shift(4), sz2 = blob.read_shift(4);
                    p.usz = sz2 * Math.pow(2, 32) + sz1;
                    sz1 = blob.read_shift(4);
                    sz2 = blob.read_shift(4);
                    p.csz = sz2 * Math.pow(2, 32) + sz1;
                    break;
            }
            blob.l = tgt;
            o[type] = p;
        }
        return o;
    }
    var fs /*:: = require('fs'); */ ;
    function get_fs() {
        return fs || (fs = $a1a91b25d7598376$var$_fs);
    }
    function parse(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (file[0] == 0x50 && file[1] == 0x4b) return parse_zip(file, options);
        if ((file[0] | 0x20) == 0x6d && (file[1] | 0x20) == 0x69) return parse_mad(file, options);
        if (file.length < 512) throw new Error("CFB file size " + file.length + " < 512");
        var mver = 3;
        var ssz = 512;
        var nmfs = 0; // number of mini FAT sectors
        var difat_sec_cnt = 0;
        var dir_start = 0;
        var minifat_start = 0;
        var difat_start = 0;
        var fat_addrs /*:Array<number>*/  = []; // locations of FAT sectors
        /* [MS-CFB] 2.2 Compound File Header */ var blob /*:CFBlob*/  = /*::(*/ file.slice(0, 512) /*:: :any)*/ ;
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        /* major version */ var mv = check_get_mver(blob);
        mver = mv[0];
        switch(mver){
            case 3:
                ssz = 512;
                break;
            case 4:
                ssz = 4096;
                break;
            case 0:
                if (mv[1] == 0) return parse_zip(file, options);
            /* falls through */ default:
                throw new Error("Major Version: Expected 3 or 4 saw " + mver);
        }
        /* reprocess header */ if (ssz !== 512) {
            blob = /*::(*/ file.slice(0, ssz) /*:: :any)*/ ;
            $a1a91b25d7598376$var$prep_blob(blob, 28 /* blob.l */ );
        }
        /* Save header for final object */ var header /*:RawBytes*/  = file.slice(0, ssz);
        check_shifts(blob, mver);
        // Number of Directory Sectors
        var dir_cnt /*:number*/  = blob.read_shift(4, 'i');
        if (mver === 3 && dir_cnt !== 0) throw new Error('# Directory Sectors: Expected 0 saw ' + dir_cnt);
        // Number of FAT Sectors
        blob.l += 4;
        // First Directory Sector Location
        dir_start = blob.read_shift(4, 'i');
        // Transaction Signature
        blob.l += 4;
        // Mini Stream Cutoff Size
        blob.chk('00100000', 'Mini Stream Cutoff Size: ');
        // First Mini FAT Sector Location
        minifat_start = blob.read_shift(4, 'i');
        // Number of Mini FAT Sectors
        nmfs = blob.read_shift(4, 'i');
        // First DIFAT sector location
        difat_start = blob.read_shift(4, 'i');
        // Number of DIFAT Sectors
        difat_sec_cnt = blob.read_shift(4, 'i');
        // Grab FAT Sector Locations
        for(var q = -1, j = 0; j < 109; ++j){
            q = blob.read_shift(4, 'i');
            if (q < 0) break;
            fat_addrs[j] = q;
        }
        /** Break the file up into sectors */ var sectors /*:Array<RawBytes>*/  = sectorify(file, ssz);
        sleuth_fat(difat_start, difat_sec_cnt, sectors, ssz, fat_addrs);
        /** Chains */ var sector_list /*:SectorList*/  = make_sector_list(sectors, dir_start, fat_addrs, ssz);
        if (dir_start < sector_list.length) sector_list[dir_start].name = "!Directory";
        if (nmfs > 0 && minifat_start !== ENDOFCHAIN) sector_list[minifat_start].name = "!MiniFAT";
        sector_list[fat_addrs[0]].name = "!FAT";
        sector_list.fat_addrs = fat_addrs;
        sector_list.ssz = ssz;
        /* [MS-CFB] 2.6.1 Compound File Directory Entry */ var files /*:CFBFiles*/  = {}, Paths /*:Array<string>*/  = [], FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        read_directory(dir_start, sector_list, sectors, Paths, nmfs, files, FileIndex, minifat_start);
        build_full_paths(FileIndex, FullPaths, Paths);
        Paths.shift();
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        // $FlowIgnore
        if (options && options.raw) o.raw = {
            header: header,
            sectors: sectors
        };
        return o;
    } // parse
    /* [MS-CFB] 2.2 Compound File Header -- read up to major version */ function check_get_mver(blob /*:CFBlob*/ ) /*:[number, number]*/ {
        if (blob[blob.l] == 0x50 && blob[blob.l + 1] == 0x4b) return [
            0,
            0
        ];
        // header signature 8
        blob.chk(HEADER_SIGNATURE, 'Header Signature: ');
        // clsid 16
        //blob.chk(HEADER_CLSID, 'CLSID: ');
        blob.l += 16;
        // minor version 2
        var mver /*:number*/  = blob.read_shift(2, 'u');
        return [
            blob.read_shift(2, 'u'),
            mver
        ];
    }
    function check_shifts(blob /*:CFBlob*/ , mver /*:number*/ ) /*:void*/ {
        var shift = 0x09;
        // Byte Order
        //blob.chk('feff', 'Byte Order: '); // note: some writers put 0xffff
        blob.l += 2;
        // Sector Shift
        switch(shift = blob.read_shift(2)){
            case 0x09:
                if (mver != 3) throw new Error('Sector Shift: Expected 9 saw ' + shift);
                break;
            case 0x0c:
                if (mver != 4) throw new Error('Sector Shift: Expected 12 saw ' + shift);
                break;
            default:
                throw new Error('Sector Shift: Expected 9 or 12 saw ' + shift);
        }
        // Mini Sector Shift
        blob.chk('0600', 'Mini Sector Shift: ');
        // Reserved
        blob.chk('000000000000', 'Reserved: ');
    }
    /** Break the file up into sectors */ function sectorify(file /*:RawBytes*/ , ssz /*:number*/ ) /*:Array<RawBytes>*/ {
        var nsectors = Math.ceil(file.length / ssz) - 1;
        var sectors /*:Array<RawBytes>*/  = [];
        for(var i = 1; i < nsectors; ++i)sectors[i - 1] = file.slice(i * ssz, (i + 1) * ssz);
        sectors[nsectors - 1] = file.slice(nsectors * ssz);
        return sectors;
    }
    /* [MS-CFB] 2.6.4 Red-Black Tree */ function build_full_paths(FI /*:CFBFileIndex*/ , FP /*:Array<string>*/ , Paths /*:Array<string>*/ ) /*:void*/ {
        var i = 0, L = 0, R = 0, C = 0, j = 0, pl = Paths.length;
        var dad /*:Array<number>*/  = [], q /*:Array<number>*/  = [];
        for(; i < pl; ++i){
            dad[i] = q[i] = i;
            FP[i] = Paths[i];
        }
        for(; j < q.length; ++j){
            i = q[j];
            L = FI[i].L;
            R = FI[i].R;
            C = FI[i].C;
            if (dad[i] === i) {
                if (L !== -1 /*NOSTREAM*/  && dad[L] !== L) dad[i] = dad[L];
                if (R !== -1 && dad[R] !== R) dad[i] = dad[R];
            }
            if (C !== -1 /*NOSTREAM*/ ) dad[C] = i;
            if (L !== -1 && i != dad[i]) {
                dad[L] = dad[i];
                if (q.lastIndexOf(L) < j) q.push(L);
            }
            if (R !== -1 && i != dad[i]) {
                dad[R] = dad[i];
                if (q.lastIndexOf(R) < j) q.push(R);
            }
        }
        for(i = 1; i < pl; ++i)if (dad[i] === i) {
            if (R !== -1 /*NOSTREAM*/  && dad[R] !== R) dad[i] = dad[R];
            else if (L !== -1 && dad[L] !== L) dad[i] = dad[L];
        }
        for(i = 1; i < pl; ++i){
            if (FI[i].type === 0 /* unknown */ ) continue;
            j = i;
            if (j != dad[j]) do {
                j = dad[j];
                FP[i] = FP[j] + "/" + FP[i];
            }while (j !== 0 && -1 !== dad[j] && j != dad[j]);
            dad[i] = -1;
        }
        FP[0] += "/";
        for(i = 1; i < pl; ++i)if (FI[i].type !== 2 /* stream */ ) FP[i] += "/";
    }
    function get_mfat_entry(entry /*:CFBEntry*/ , payload /*:RawBytes*/ , mini /*:?RawBytes*/ ) /*:CFBlob*/ {
        var start = entry.start, size = entry.size;
        //return (payload.slice(start*MSSZ, start*MSSZ + size)/*:any*/);
        var o = [];
        var idx = start;
        while(mini && size > 0 && idx >= 0){
            o.push(payload.slice(idx * MSSZ, idx * MSSZ + MSSZ));
            size -= MSSZ;
            idx = $a1a91b25d7598376$var$__readInt32LE(mini, idx * 4);
        }
        if (o.length === 0) return $a1a91b25d7598376$var$new_buf(0);
        return $a1a91b25d7598376$var$bconcat(o).slice(0, entry.size);
    }
    /** Chase down the rest of the DIFAT chain to build a comprehensive list
    DIFAT chains by storing the next sector number as the last 32 bits */ function sleuth_fat(idx /*:number*/ , cnt /*:number*/ , sectors /*:Array<RawBytes>*/ , ssz /*:number*/ , fat_addrs) /*:void*/ {
        var q /*:number*/  = ENDOFCHAIN;
        if (idx === ENDOFCHAIN) {
            if (cnt !== 0) throw new Error("DIFAT chain shorter than expected");
        } else if (idx !== -1 /*FREESECT*/ ) {
            var sector = sectors[idx], m = (ssz >>> 2) - 1;
            if (!sector) return;
            for(var i = 0; i < m; ++i){
                if ((q = $a1a91b25d7598376$var$__readInt32LE(sector, i * 4)) === ENDOFCHAIN) break;
                fat_addrs.push(q);
            }
            if (cnt >= 1) sleuth_fat($a1a91b25d7598376$var$__readInt32LE(sector, ssz - 4), cnt - 1, sectors, ssz, fat_addrs);
        }
    }
    /** Follow the linked list of sectors for a given starting point */ function get_sector_list(sectors /*:Array<RawBytes>*/ , start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ , chkd /*:?Array<boolean>*/ ) /*:SectorEntry*/ {
        var buf /*:Array<number>*/  = [], buf_chain /*:Array<any>*/  = [];
        if (!chkd) chkd = [];
        var modulus = ssz - 1, j = 0, jj = 0;
        for(j = start; j >= 0;){
            chkd[j] = true;
            buf[buf.length] = j;
            buf_chain.push(sectors[j]);
            var addr = fat_addrs[Math.floor(j * 4 / ssz)];
            jj = j * 4 & modulus;
            if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
            if (!sectors[addr]) break;
            j = $a1a91b25d7598376$var$__readInt32LE(sectors[addr], jj);
        }
        return {
            nodes: buf,
            data: $a1a91b25d7598376$var$__toBuffer([
                buf_chain
            ])
        };
    }
    /** Chase down the sector linked lists */ function make_sector_list(sectors /*:Array<RawBytes>*/ , dir_start /*:number*/ , fat_addrs /*:Array<number>*/ , ssz /*:number*/ ) /*:SectorList*/ {
        var sl = sectors.length, sector_list /*:SectorList*/  = [];
        var chkd /*:Array<boolean>*/  = [], buf /*:Array<number>*/  = [], buf_chain /*:Array<RawBytes>*/  = [];
        var modulus = ssz - 1, i = 0, j = 0, k = 0, jj = 0;
        for(i = 0; i < sl; ++i){
            buf = [];
            k = i + dir_start;
            if (k >= sl) k -= sl;
            if (chkd[k]) continue;
            buf_chain = [];
            var seen = [];
            for(j = k; j >= 0;){
                seen[j] = true;
                chkd[j] = true;
                buf[buf.length] = j;
                buf_chain.push(sectors[j]);
                var addr /*:number*/  = fat_addrs[Math.floor(j * 4 / ssz)];
                jj = j * 4 & modulus;
                if (ssz < 4 + jj) throw new Error("FAT boundary crossed: " + j + " 4 " + ssz);
                if (!sectors[addr]) break;
                j = $a1a91b25d7598376$var$__readInt32LE(sectors[addr], jj);
                if (seen[j]) break;
            }
            sector_list[k] = {
                nodes: buf,
                data: $a1a91b25d7598376$var$__toBuffer([
                    buf_chain
                ])
            } /*:SectorEntry*/ ;
        }
        return sector_list;
    }
    /* [MS-CFB] 2.6.1 Compound File Directory Entry */ function read_directory(dir_start /*:number*/ , sector_list /*:SectorList*/ , sectors /*:Array<RawBytes>*/ , Paths /*:Array<string>*/ , nmfs, files, FileIndex, mini) {
        var minifat_store = 0, pl = Paths.length ? 2 : 0;
        var sector = sector_list[dir_start].data;
        var i = 0, namelen = 0, name;
        for(; i < sector.length; i += 128){
            var blob /*:CFBlob*/  = /*::(*/ sector.slice(i, i + 128) /*:: :any)*/ ;
            $a1a91b25d7598376$var$prep_blob(blob, 64);
            namelen = blob.read_shift(2);
            name = $a1a91b25d7598376$var$__utf16le(blob, 0, namelen - pl);
            Paths.push(name);
            var o /*:CFBEntry*/  = {
                name: name,
                type: blob.read_shift(1),
                color: blob.read_shift(1),
                L: blob.read_shift(4, 'i'),
                R: blob.read_shift(4, 'i'),
                C: blob.read_shift(4, 'i'),
                clsid: blob.read_shift(16),
                state: blob.read_shift(4, 'i'),
                start: 0,
                size: 0
            };
            var ctime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (ctime !== 0) o.ct = read_date(blob, blob.l - 8);
            var mtime /*:number*/  = blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2) + blob.read_shift(2);
            if (mtime !== 0) o.mt = read_date(blob, blob.l - 8);
            o.start = blob.read_shift(4, 'i');
            o.size = blob.read_shift(4, 'i');
            if (o.size < 0 && o.start < 0) {
                o.size = o.type = 0;
                o.start = ENDOFCHAIN;
                o.name = "";
            }
            if (o.type === 5) {
                minifat_store = o.start;
                if (nmfs > 0 && minifat_store !== ENDOFCHAIN) sector_list[minifat_store].name = "!StreamData";
            /*minifat_size = o.size;*/ } else if (o.size >= 4096 /* MSCSZ */ ) {
                o.storage = 'fat';
                if (sector_list[o.start] === undefined) sector_list[o.start] = get_sector_list(sectors, o.start, sector_list.fat_addrs, sector_list.ssz);
                sector_list[o.start].name = o.name;
                o.content = sector_list[o.start].data.slice(0, o.size);
            } else {
                o.storage = 'minifat';
                if (o.size < 0) o.size = 0;
                else if (minifat_store !== ENDOFCHAIN && o.start !== ENDOFCHAIN && sector_list[minifat_store]) o.content = get_mfat_entry(o, sector_list[minifat_store].data, (sector_list[mini] || {}).data);
            }
            if (o.content) $a1a91b25d7598376$var$prep_blob(o.content, 0);
            files[name] = o;
            FileIndex.push(o);
        }
    }
    function read_date(blob /*:RawBytes|CFBlob*/ , offset /*:number*/ ) /*:Date*/ {
        return new Date(($a1a91b25d7598376$var$__readUInt32LE(blob, offset + 4) / 1e7 * Math.pow(2, 32) + $a1a91b25d7598376$var$__readUInt32LE(blob, offset) / 1e7 - 11644473600) * 1000);
    }
    function read_file(filename /*:string*/ , options /*:CFBReadOpts*/ ) {
        get_fs();
        return parse(fs.readFileSync(filename), options);
    }
    function read(blob /*:RawBytes|string*/ , options /*:CFBReadOpts*/ ) {
        var type = options && options.type;
        if (!type) {
            if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(blob)) type = "buffer";
        }
        switch(type || "base64"){
            case "file":
                /*:: if(typeof blob !== 'string') throw "Must pass a filename when type='file'"; */ return read_file(blob, options);
            case "base64":
                /*:: if(typeof blob !== 'string') throw "Must pass a base64-encoded binary string when type='file'"; */ return parse($a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(blob)), options);
            case "binary":
                /*:: if(typeof blob !== 'string') throw "Must pass a binary string when type='file'"; */ return parse($a1a91b25d7598376$var$s2a(blob), options);
        }
        return parse(/*::typeof blob == 'string' ? new Buffer(blob, 'utf-8') : */ blob, options);
    }
    function init_cfb(cfb /*:CFBContainer*/ , opts /*:?any*/ ) /*:void*/ {
        var o = opts || {}, root = o.root || "Root Entry";
        if (!cfb.FullPaths) cfb.FullPaths = [];
        if (!cfb.FileIndex) cfb.FileIndex = [];
        if (cfb.FullPaths.length !== cfb.FileIndex.length) throw new Error("inconsistent CFB structure");
        if (cfb.FullPaths.length === 0) {
            cfb.FullPaths[0] = root + "/";
            cfb.FileIndex[0] = {
                name: root,
                type: 5
            } /*:any*/ ;
        }
        if (o.CLSID) cfb.FileIndex[0].clsid = o.CLSID;
        seed_cfb(cfb);
    }
    function seed_cfb(cfb /*:CFBContainer*/ ) /*:void*/ {
        var nm = "\u0001Sh33tJ5";
        if ($a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "/" + nm)) return;
        var p = $a1a91b25d7598376$var$new_buf(4);
        p[0] = 55;
        p[1] = p[3] = 50;
        p[2] = 54;
        cfb.FileIndex.push({
            name: nm,
            type: 2,
            content: p,
            size: 4,
            L: 69,
            R: 69,
            C: 69
        } /*:any*/ );
        cfb.FullPaths.push(cfb.FullPaths[0] + nm);
        rebuild_cfb(cfb);
    }
    function rebuild_cfb(cfb /*:CFBContainer*/ , f /*:?boolean*/ ) /*:void*/ {
        init_cfb(cfb);
        var gc = false, s = false;
        for(var i = cfb.FullPaths.length - 1; i >= 0; --i){
            var _file = cfb.FileIndex[i];
            switch(_file.type){
                case 0:
                    if (s) gc = true;
                    else {
                        cfb.FileIndex.pop();
                        cfb.FullPaths.pop();
                    }
                    break;
                case 1:
                case 2:
                case 5:
                    s = true;
                    if (isNaN(_file.R * _file.L * _file.C)) gc = true;
                    if (_file.R > -1 && _file.L > -1 && _file.R == _file.L) gc = true;
                    break;
                default:
                    gc = true;
                    break;
            }
        }
        if (!gc && !f) return;
        var now = new Date(1987, 1, 19), j = 0;
        // Track which names exist
        var fullPaths = Object.create ? Object.create(null) : {};
        var data /*:Array<[string, CFBEntry]>*/  = [];
        for(i = 0; i < cfb.FullPaths.length; ++i){
            fullPaths[cfb.FullPaths[i]] = true;
            if (cfb.FileIndex[i].type === 0) continue;
            data.push([
                cfb.FullPaths[i],
                cfb.FileIndex[i]
            ]);
        }
        for(i = 0; i < data.length; ++i){
            var dad = dirname(data[i][0]);
            s = fullPaths[dad];
            while(!s){
                while(dirname(dad) && !fullPaths[dirname(dad)])dad = dirname(dad);
                data.push([
                    dad,
                    {
                        name: filename(dad).replace("/", ""),
                        type: 1,
                        clsid: HEADER_CLSID,
                        ct: now,
                        mt: now,
                        content: null
                    } /*:any*/ 
                ]);
                // Add name to set
                fullPaths[dad] = true;
                dad = dirname(data[i][0]);
                s = fullPaths[dad];
            }
        }
        data.sort(function(x, y) {
            return namecmp(x[0], y[0]);
        });
        cfb.FullPaths = [];
        cfb.FileIndex = [];
        for(i = 0; i < data.length; ++i){
            cfb.FullPaths[i] = data[i][0];
            cfb.FileIndex[i] = data[i][1];
        }
        for(i = 0; i < data.length; ++i){
            var elt = cfb.FileIndex[i];
            var nm = cfb.FullPaths[i];
            elt.name = filename(nm).replace("/", "");
            elt.L = elt.R = elt.C = -(elt.color = 1);
            elt.size = elt.content ? elt.content.length : 0;
            elt.start = 0;
            elt.clsid = elt.clsid || HEADER_CLSID;
            if (i === 0) {
                elt.C = data.length > 1 ? 1 : -1;
                elt.size = 0;
                elt.type = 5;
            } else if (nm.slice(-1) == "/") {
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == nm) break;
                elt.C = j >= data.length ? -1 : j;
                for(j = i + 1; j < data.length; ++j)if (dirname(cfb.FullPaths[j]) == dirname(nm)) break;
                elt.R = j >= data.length ? -1 : j;
                elt.type = 1;
            } else {
                if (dirname(cfb.FullPaths[i + 1] || "") == dirname(nm)) elt.R = i + 1;
                elt.type = 2;
            }
        }
    }
    function _write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var _opts = options || {};
        /* MAD is order-sensitive, skip rebuild and sort */ if (_opts.fileType == 'mad') return write_mad(cfb, _opts);
        rebuild_cfb(cfb);
        switch(_opts.fileType){
            case 'zip':
                return write_zip(cfb, _opts);
        }
        var L = function(cfb /*:CFBContainer*/ ) /*:Array<number>*/ {
            var mini_size = 0, fat_size = 0;
            for(var i = 0; i < cfb.FileIndex.length; ++i){
                var file = cfb.FileIndex[i];
                if (!file.content) continue;
                var flen = file.content.length;
                if (flen > 0) {
                    if (flen < 0x1000) mini_size += flen + 0x3F >> 6;
                    else fat_size += flen + 0x01FF >> 9;
                }
            }
            var dir_cnt = cfb.FullPaths.length + 3 >> 2;
            var mini_cnt = mini_size + 7 >> 3;
            var mfat_cnt = mini_size + 0x7F >> 7;
            var fat_base = mini_cnt + fat_size + dir_cnt + mfat_cnt;
            var fat_cnt = fat_base + 0x7F >> 7;
            var difat_cnt = fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            while(fat_base + fat_cnt + difat_cnt + 0x7F >> 7 > fat_cnt)difat_cnt = ++fat_cnt <= 109 ? 0 : Math.ceil((fat_cnt - 109) / 0x7F);
            var L = [
                1,
                difat_cnt,
                fat_cnt,
                mfat_cnt,
                dir_cnt,
                fat_size,
                mini_size,
                0
            ];
            cfb.FileIndex[0].size = mini_size << 6;
            L[7] = (cfb.FileIndex[0].start = L[0] + L[1] + L[2] + L[3] + L[4] + L[5]) + (L[6] + 7 >> 3);
            return L;
        }(cfb);
        var o = $a1a91b25d7598376$var$new_buf(L[7] << 9);
        var i = 0, T = 0;
        for(i = 0; i < 8; ++i)o.write_shift(1, HEADER_SIG[i]);
        for(i = 0; i < 8; ++i)o.write_shift(2, 0);
        o.write_shift(2, 0x003E);
        o.write_shift(2, 0x0003);
        o.write_shift(2, 0xFFFE);
        o.write_shift(2, 0x0009);
        o.write_shift(2, 0x0006);
        for(i = 0; i < 3; ++i)o.write_shift(2, 0);
        o.write_shift(4, 0);
        o.write_shift(4, L[2]);
        o.write_shift(4, L[0] + L[1] + L[2] + L[3] - 1);
        o.write_shift(4, 0);
        o.write_shift(4, 4096);
        o.write_shift(4, L[3] ? L[0] + L[1] + L[2] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[3]);
        o.write_shift(-4, L[1] ? L[0] - 1 : ENDOFCHAIN);
        o.write_shift(4, L[1]);
        for(i = 0; i < 109; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
        if (L[1]) for(T = 0; T < L[1]; ++T){
            for(; i < 236 + T * 127; ++i)o.write_shift(-4, i < L[2] ? L[1] + i : -1);
            o.write_shift(-4, T === L[1] - 1 ? ENDOFCHAIN : T + 1);
        }
        var chainit = function(w /*:number*/ ) /*:void*/ {
            for(T += w; i < T - 1; ++i)o.write_shift(-4, i + 1);
            if (w) {
                ++i;
                o.write_shift(-4, ENDOFCHAIN);
            }
        };
        T = i = 0;
        for(T += L[1]; i < T; ++i)o.write_shift(-4, consts.DIFSECT);
        for(T += L[2]; i < T; ++i)o.write_shift(-4, consts.FATSECT);
        chainit(L[3]);
        chainit(L[4]);
        var j /*:number*/  = 0, flen /*:number*/  = 0;
        var file /*:CFBEntry*/  = cfb.FileIndex[0];
        for(; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (flen < 0x1000) continue;
            file.start = T;
            chainit(flen + 0x01FF >> 9);
        }
        chainit(L[6] + 7 >> 3);
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        T = i = 0;
        for(j = 0; j < cfb.FileIndex.length; ++j){
            file = cfb.FileIndex[j];
            if (!file.content) continue;
            /*:: if(file.content == null) throw new Error("unreachable"); */ flen = file.content.length;
            if (!flen || flen >= 0x1000) continue;
            file.start = T;
            chainit(flen + 0x3F >> 6);
        }
        while(o.l & 0x1FF)o.write_shift(-4, consts.ENDOFCHAIN);
        for(i = 0; i < L[4] << 2; ++i){
            var nm = cfb.FullPaths[i];
            if (!nm || nm.length === 0) {
                for(j = 0; j < 17; ++j)o.write_shift(4, 0);
                for(j = 0; j < 3; ++j)o.write_shift(4, -1);
                for(j = 0; j < 12; ++j)o.write_shift(4, 0);
                continue;
            }
            file = cfb.FileIndex[i];
            if (i === 0) file.start = file.size ? file.start - 1 : ENDOFCHAIN;
            var _nm /*:string*/  = i === 0 && _opts.root || file.name;
            if (_nm.length > 31) {
                console.error("Name " + _nm + " will be truncated to " + _nm.slice(0, 31));
                _nm = _nm.slice(0, 31);
            }
            flen = 2 * (_nm.length + 1);
            o.write_shift(64, _nm, "utf16le");
            o.write_shift(2, flen);
            o.write_shift(1, file.type);
            o.write_shift(1, file.color);
            o.write_shift(-4, file.L);
            o.write_shift(-4, file.R);
            o.write_shift(-4, file.C);
            if (!file.clsid) for(j = 0; j < 4; ++j)o.write_shift(4, 0);
            else o.write_shift(16, file.clsid, "hex");
            o.write_shift(4, file.state || 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(4, file.start);
            o.write_shift(4, file.size);
            o.write_shift(4, 0);
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size >= 0x1000) {
                o.l = file.start + 1 << 9;
                if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 511 & -512;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x1FF; ++j)o.write_shift(1, 0);
                }
            }
        }
        for(i = 1; i < cfb.FileIndex.length; ++i){
            file = cfb.FileIndex[i];
            /*:: if(!file.content) throw new Error("unreachable"); */ if (file.size > 0 && file.size < 0x1000) {
                if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(file.content)) {
                    file.content.copy(o, o.l, 0, file.size);
                    // o is a 0-filled Buffer so just set next offset
                    o.l += file.size + 63 & -64;
                } else {
                    for(j = 0; j < file.size; ++j)o.write_shift(1, file.content[j]);
                    for(; j & 0x3F; ++j)o.write_shift(1, 0);
                }
            }
        }
        if ($a1a91b25d7598376$var$has_buf) o.l = o.length;
        else // When using Buffer, already 0-filled
        while(o.l < o.length)o.write_shift(1, 0);
        return o;
    }
    /* [MS-CFB] 2.6.4 (Unicode 3.0.1 case conversion) */ function find(cfb /*:CFBContainer*/ , path /*:string*/ ) /*:?CFBEntry*/ {
        var UCFullPaths /*:Array<string>*/  = cfb.FullPaths.map(function(x) {
            return x.toUpperCase();
        });
        var UCPaths /*:Array<string>*/  = UCFullPaths.map(function(x) {
            var y = x.split("/");
            return y[y.length - (x.slice(-1) == "/" ? 2 : 1)];
        });
        var k /*:boolean*/  = false;
        if (path.charCodeAt(0) === 47 /* "/" */ ) {
            k = true;
            path = UCFullPaths[0].slice(0, -1) + path;
        } else k = path.indexOf("/") !== -1;
        var UCPath /*:string*/  = path.toUpperCase();
        var w /*:number*/  = k === true ? UCFullPaths.indexOf(UCPath) : UCPaths.indexOf(UCPath);
        if (w !== -1) return cfb.FileIndex[w];
        var m = !UCPath.match($a1a91b25d7598376$var$chr1);
        UCPath = UCPath.replace($a1a91b25d7598376$var$chr0, '');
        if (m) UCPath = UCPath.replace($a1a91b25d7598376$var$chr1, '!');
        for(w = 0; w < UCFullPaths.length; ++w){
            if ((m ? UCFullPaths[w].replace($a1a91b25d7598376$var$chr1, '!') : UCFullPaths[w]).replace($a1a91b25d7598376$var$chr0, '') == UCPath) return cfb.FileIndex[w];
            if ((m ? UCPaths[w].replace($a1a91b25d7598376$var$chr1, '!') : UCPaths[w]).replace($a1a91b25d7598376$var$chr0, '') == UCPath) return cfb.FileIndex[w];
        }
        return null;
    }
    /** CFB Constants */ var MSSZ = 64; /* Mini Sector Size = 1<<6 */ 
    //var MSCSZ = 4096; /* Mini Stream Cutoff Size */
    /* 2.1 Compound File Sector Numbers and Types */ var ENDOFCHAIN = -2;
    /* 2.2 Compound File Header */ var HEADER_SIGNATURE = 'd0cf11e0a1b11ae1';
    var HEADER_SIG = [
        0xD0,
        0xCF,
        0x11,
        0xE0,
        0xA1,
        0xB1,
        0x1A,
        0xE1
    ];
    var HEADER_CLSID = '00000000000000000000000000000000';
    var consts = {
        /* 2.1 Compund File Sector Numbers and Types */ MAXREGSECT: -6,
        DIFSECT: -4,
        FATSECT: -3,
        ENDOFCHAIN: ENDOFCHAIN,
        FREESECT: -1,
        /* 2.2 Compound File Header */ HEADER_SIGNATURE: HEADER_SIGNATURE,
        HEADER_MINOR_VERSION: '3e00',
        MAXREGSID: -6,
        NOSTREAM: -1,
        HEADER_CLSID: HEADER_CLSID,
        /* 2.6.1 Compound File Directory Entry */ EntryTypes: [
            'unknown',
            'storage',
            'stream',
            'lockbytes',
            'property',
            'root'
        ]
    };
    function write_file(cfb /*:CFBContainer*/ , filename /*:string*/ , options /*:CFBWriteOpts*/ ) /*:void*/ {
        get_fs();
        var o = _write(cfb, options);
        /*:: if(typeof Buffer == 'undefined' || !Buffer.isBuffer(o) || !(o instanceof Buffer)) throw new Error("unreachable"); */ fs.writeFileSync(filename, o);
    }
    function a2s(o /*:RawBytes*/ ) /*:string*/ {
        var out = new Array(o.length);
        for(var i = 0; i < o.length; ++i)out[i] = String.fromCharCode(o[i]);
        return out.join("");
    }
    function write(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes|string*/ {
        var o = _write(cfb, options);
        switch(options && options.type || "buffer"){
            case "file":
                get_fs();
                fs.writeFileSync(options.filename, o /*:any*/ );
                return o;
            case "binary":
                return typeof o == "string" ? o : a2s(o);
            case "base64":
                return $a1a91b25d7598376$var$Base64_encode(typeof o == "string" ? o : a2s(o));
            case "buffer":
                if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$require$Buffer.isBuffer(o) ? o : $a1a91b25d7598376$var$Buffer_from(o);
            /* falls through */ case "array":
                return typeof o == "string" ? $a1a91b25d7598376$var$s2a(o) : o;
        }
        return o;
    }
    /* node < 8.1 zlib does not expose bytesRead, so default to pure JS */ var _zlib;
    function use_zlib(zlib) {
        try {
            var InflateRaw = zlib.InflateRaw;
            var InflRaw = new InflateRaw();
            InflRaw._processChunk(new Uint8Array([
                3,
                0
            ]), InflRaw._finishFlushFlag);
            if (InflRaw.bytesRead) _zlib = zlib;
            else throw new Error("zlib does not expose bytesRead");
        } catch (e) {
            console.error("cannot use native zlib: " + (e.message || e));
        }
    }
    function _inflateRawSync(payload, usz) {
        if (!_zlib) return _inflate(payload, usz);
        var InflateRaw = _zlib.InflateRaw;
        var InflRaw = new InflateRaw();
        var out = InflRaw._processChunk(payload.slice(payload.l), InflRaw._finishFlushFlag);
        payload.l += InflRaw.bytesRead;
        return out;
    }
    function _deflateRawSync(payload) {
        return _zlib ? _zlib.deflateRawSync(payload) : _deflate(payload);
    }
    var CLEN_ORDER = [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    /*  LEN_ID = [ 257, 258, 259, 260, 261, 262, 263, 264, 265, 266, 267, 268, 269, 270, 271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 282, 283, 284, 285 ]; */ var LEN_LN = [
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11,
        13,
        15,
        17,
        19,
        23,
        27,
        31,
        35,
        43,
        51,
        59,
        67,
        83,
        99,
        115,
        131,
        163,
        195,
        227,
        258
    ];
    /*  DST_ID = [  0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13,  14,  15,  16,  17,  18,  19,   20,   21,   22,   23,   24,   25,   26,    27,    28,    29 ]; */ var DST_LN = [
        1,
        2,
        3,
        4,
        5,
        7,
        9,
        13,
        17,
        25,
        33,
        49,
        65,
        97,
        129,
        193,
        257,
        385,
        513,
        769,
        1025,
        1537,
        2049,
        3073,
        4097,
        6145,
        8193,
        12289,
        16385,
        24577
    ];
    function bit_swap_8(n) {
        var t = (n << 1 | n << 11) & 0x22110 | (n << 5 | n << 15) & 0x88440;
        return (t >> 16 | t >> 8 | t) & 0xFF;
    }
    var use_typed_arrays = typeof Uint8Array !== 'undefined';
    var bitswap8 = use_typed_arrays ? new Uint8Array(256) : [];
    for(var q = 0; q < 256; ++q)bitswap8[q] = bit_swap_8(q);
    function bit_swap_n(n, b) {
        var rev = bitswap8[n & 0xFF];
        if (b <= 8) return rev >>> 8 - b;
        rev = rev << 8 | bitswap8[n >> 8 & 0xFF];
        if (b <= 16) return rev >>> 16 - b;
        rev = rev << 8 | bitswap8[n >> 16 & 0xFF];
        return rev >>> 24 - b;
    }
    /* helpers for unaligned bit reads */ function read_bits_2(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 6 ? 0 : buf[h + 1] << 8)) >>> w & 0x03;
    }
    function read_bits_3(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 5 ? 0 : buf[h + 1] << 8)) >>> w & 0x07;
    }
    function read_bits_4(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 4 ? 0 : buf[h + 1] << 8)) >>> w & 0x0F;
    }
    function read_bits_5(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 3 ? 0 : buf[h + 1] << 8)) >>> w & 0x1F;
    }
    function read_bits_7(buf, bl) {
        var w = bl & 7, h = bl >>> 3;
        return (buf[h] | (w <= 1 ? 0 : buf[h + 1] << 8)) >>> w & 0x7F;
    }
    /* works up to n = 3 * 8 + 1 = 25 */ function read_bits_n(buf, bl, n) {
        var w = bl & 7, h = bl >>> 3, f = (1 << n) - 1;
        var v = buf[h] >>> w;
        if (n < 8 - w) return v & f;
        v |= buf[h + 1] << 8 - w;
        if (n < 16 - w) return v & f;
        v |= buf[h + 2] << 16 - w;
        if (n < 24 - w) return v & f;
        v |= buf[h + 3] << 24 - w;
        return v & f;
    }
    /* helpers for unaligned bit writes */ function write_bits_3(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        if (w <= 5) buf[h] |= (v & 7) << w;
        else {
            buf[h] |= v << w & 0xFF;
            buf[h + 1] = (v & 7) >> 8 - w;
        }
        return bl + 3;
    }
    function write_bits_1(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v = (v & 1) << w;
        buf[h] |= v;
        return bl + 1;
    }
    function write_bits_8(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v;
        return bl + 8;
    }
    function write_bits_16(buf, bl, v) {
        var w = bl & 7, h = bl >>> 3;
        v <<= w;
        buf[h] |= v & 0xFF;
        v >>>= 8;
        buf[h + 1] = v & 0xFF;
        buf[h + 2] = v >>> 8;
        return bl + 16;
    }
    /* until ArrayBuffer#realloc is a thing, fake a realloc */ function realloc(b, sz /*:number*/ ) {
        var L = b.length, M = 2 * L > sz ? 2 * L : sz + 5, i = 0;
        if (L >= sz) return b;
        if ($a1a91b25d7598376$var$has_buf) {
            var o = $a1a91b25d7598376$var$new_unsafe_buf(M);
            // $FlowIgnore
            if (b.copy) b.copy(o);
            else for(; i < b.length; ++i)o[i] = b[i];
            return o;
        } else if (use_typed_arrays) {
            var a = new Uint8Array(M);
            if (a.set) a.set(b);
            else for(; i < L; ++i)a[i] = b[i];
            return a;
        }
        b.length = M;
        return b;
    }
    /* zero-filled arrays for older browsers */ function zero_fill_array(n) {
        var o = new Array(n);
        for(var i = 0; i < n; ++i)o[i] = 0;
        return o;
    }
    /* build tree (used for literals and lengths) */ function build_tree(clens, cmap, MAX /*:number*/ ) /*:number*/ {
        var maxlen = 1, w = 0, i = 0, j = 0, ccode = 0, L = clens.length;
        var bl_count = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
        for(i = 0; i < 32; ++i)bl_count[i] = 0;
        for(i = L; i < MAX; ++i)clens[i] = 0;
        L = clens.length;
        var ctree = use_typed_arrays ? new Uint16Array(L) : zero_fill_array(L); // []
        /* build code tree */ for(i = 0; i < L; ++i){
            bl_count[w = clens[i]]++;
            if (maxlen < w) maxlen = w;
            ctree[i] = 0;
        }
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)bl_count[i + 16] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i){
            ccode = clens[i];
            if (ccode != 0) ctree[i] = bl_count[ccode + 16]++;
        }
        /* cmap[maxlen + 4 bits] = (off&15) + (lit<<4) reverse mapping */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bit_swap_n(ctree[i], maxlen) >> maxlen - cleni;
                for(j = (1 << maxlen + 4 - cleni) - 1; j >= 0; --j)cmap[ccode | j << cleni] = cleni & 15 | i << 4;
            }
        }
        return maxlen;
    }
    /* Fixed Huffman */ var fix_lmap = use_typed_arrays ? new Uint16Array(512) : zero_fill_array(512);
    var fix_dmap = use_typed_arrays ? new Uint16Array(32) : zero_fill_array(32);
    if (!use_typed_arrays) {
        for(var i = 0; i < 512; ++i)fix_lmap[i] = 0;
        for(i = 0; i < 32; ++i)fix_dmap[i] = 0;
    }
    (function() {
        var dlens /*:Array<number>*/  = [];
        var i = 0;
        for(; i < 32; i++)dlens.push(5);
        build_tree(dlens, fix_dmap, 32);
        var clens /*:Array<number>*/  = [];
        i = 0;
        for(; i <= 143; i++)clens.push(8);
        for(; i <= 255; i++)clens.push(9);
        for(; i <= 279; i++)clens.push(7);
        for(; i <= 287; i++)clens.push(8);
        build_tree(clens, fix_lmap, 288);
    })();
    var _deflateRaw = /*#__PURE__*/ function _deflateRawIIFE() {
        var DST_LN_RE = use_typed_arrays ? new Uint8Array(0x8000) : [];
        var j = 0, k = 0;
        for(; j < DST_LN.length - 1; ++j)for(; k < DST_LN[j + 1]; ++k)DST_LN_RE[k] = j;
        for(; k < 32768; ++k)DST_LN_RE[k] = 29;
        var LEN_LN_RE = use_typed_arrays ? new Uint8Array(0x103) : [];
        for(j = 0, k = 0; j < LEN_LN.length - 1; ++j)for(; k < LEN_LN[j + 1]; ++k)LEN_LN_RE[k] = j;
        function write_stored(data, out) {
            var boff = 0;
            while(boff < data.length){
                var L = Math.min(0xFFFF, data.length - boff);
                var h = boff + L == data.length;
                out.write_shift(1, +h);
                out.write_shift(2, L);
                out.write_shift(2, ~L & 0xFFFF);
                while(L-- > 0)out[out.l++] = data[boff++];
            }
            return out.l;
        }
        /* Fixed Huffman */ function write_huff_fixed(data, out) {
            var bl = 0;
            var boff = 0;
            var addrs = use_typed_arrays ? new Uint16Array(0x8000) : [];
            while(boff < data.length){
                var L = /* data.length - boff; */ Math.min(0xFFFF, data.length - boff);
                /* write a stored block for short data */ if (L < 10) {
                    bl = write_bits_3(out, bl, +!!(boff + L == data.length)); // jshint ignore:line
                    if (bl & 7) bl += 8 - (bl & 7);
                    out.l = bl / 8 | 0;
                    out.write_shift(2, L);
                    out.write_shift(2, ~L & 0xFFFF);
                    while(L-- > 0)out[out.l++] = data[boff++];
                    bl = out.l * 8;
                    continue;
                }
                bl = write_bits_3(out, bl, +!!(boff + L == data.length) + 2); // jshint ignore:line
                var hash = 0;
                while(L-- > 0){
                    var d = data[boff];
                    hash = (hash << 5 ^ d) & 0x7FFF;
                    var match = -1, mlen = 0;
                    if (match = addrs[hash]) {
                        match |= boff & -32768;
                        if (match > boff) match -= 0x8000;
                        if (match < boff) while(data[match + mlen] == data[boff + mlen] && mlen < 250)++mlen;
                    }
                    if (mlen > 2) {
                        /* Copy Token  */ d = LEN_LN_RE[mlen];
                        if (d <= 22) bl = write_bits_8(out, bl, bitswap8[d + 1] >> 1) - 1;
                        else {
                            write_bits_8(out, bl, 3);
                            bl += 5;
                            write_bits_8(out, bl, bitswap8[d - 23] >> 5);
                            bl += 3;
                        }
                        var len_eb = d < 8 ? 0 : d - 4 >> 2;
                        if (len_eb > 0) {
                            write_bits_16(out, bl, mlen - LEN_LN[d]);
                            bl += len_eb;
                        }
                        d = DST_LN_RE[boff - match];
                        bl = write_bits_8(out, bl, bitswap8[d] >> 3);
                        bl -= 3;
                        var dst_eb = d < 4 ? 0 : d - 2 >> 1;
                        if (dst_eb > 0) {
                            write_bits_16(out, bl, boff - match - DST_LN[d]);
                            bl += dst_eb;
                        }
                        for(var q = 0; q < mlen; ++q){
                            addrs[hash] = boff & 0x7FFF;
                            hash = (hash << 5 ^ data[boff]) & 0x7FFF;
                            ++boff;
                        }
                        L -= mlen - 1;
                    } else {
                        /* Literal Token */ if (d <= 143) d = d + 48;
                        else bl = write_bits_1(out, bl, 1);
                        bl = write_bits_8(out, bl, bitswap8[d]);
                        addrs[hash] = boff & 0x7FFF;
                        ++boff;
                    }
                }
                bl = write_bits_8(out, bl, 0) - 1;
            }
            out.l = (bl + 7) / 8 | 0;
            return out.l;
        }
        return function _deflateRaw(data, out) {
            if (data.length < 8) return write_stored(data, out);
            return write_huff_fixed(data, out);
        };
    }();
    function _deflate(data) {
        var buf = $a1a91b25d7598376$var$new_buf(50 + Math.floor(data.length * 1.1));
        var off = _deflateRaw(data, buf);
        return buf.slice(0, off);
    }
    /* modified inflate function also moves original read head */ var dyn_lmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_dmap = use_typed_arrays ? new Uint16Array(32768) : zero_fill_array(32768);
    var dyn_cmap = use_typed_arrays ? new Uint16Array(128) : zero_fill_array(128);
    var dyn_len_1 = 1, dyn_len_2 = 1;
    /* 5.5.3 Expanding Huffman Codes */ function dyn(data, boff /*:number*/ ) {
        /* nomenclature from RFC1951 refers to bit values; these are offset by the implicit constant */ var _HLIT = read_bits_5(data, boff) + 257;
        boff += 5;
        var _HDIST = read_bits_5(data, boff) + 1;
        boff += 5;
        var _HCLEN = read_bits_4(data, boff) + 4;
        boff += 4;
        var w = 0;
        /* grab and store code lengths */ var clens = use_typed_arrays ? new Uint8Array(19) : zero_fill_array(19);
        var ctree = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        var maxlen = 1;
        var bl_count = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var next_code = use_typed_arrays ? new Uint8Array(8) : zero_fill_array(8);
        var L = clens.length; /* 19 */ 
        for(var i = 0; i < _HCLEN; ++i){
            clens[CLEN_ORDER[i]] = w = read_bits_3(data, boff);
            if (maxlen < w) maxlen = w;
            bl_count[w]++;
            boff += 3;
        }
        /* build code tree */ var ccode = 0;
        bl_count[0] = 0;
        for(i = 1; i <= maxlen; ++i)next_code[i] = ccode = ccode + bl_count[i - 1] << 1;
        for(i = 0; i < L; ++i)if ((ccode = clens[i]) != 0) ctree[i] = next_code[ccode]++;
        /* cmap[7 bits from stream] = (off&7) + (lit<<3) */ var cleni = 0;
        for(i = 0; i < L; ++i){
            cleni = clens[i];
            if (cleni != 0) {
                ccode = bitswap8[ctree[i]] >> 8 - cleni;
                for(var j = (1 << 7 - cleni) - 1; j >= 0; --j)dyn_cmap[ccode | j << cleni] = cleni & 7 | i << 3;
            }
        }
        /* read literal and dist codes at once */ var hcodes /*:Array<number>*/  = [];
        maxlen = 1;
        for(; hcodes.length < _HLIT + _HDIST;){
            ccode = dyn_cmap[read_bits_7(data, boff)];
            boff += ccode & 7;
            switch(ccode >>>= 3){
                case 16:
                    w = 3 + read_bits_2(data, boff);
                    boff += 2;
                    ccode = hcodes[hcodes.length - 1];
                    while(w-- > 0)hcodes.push(ccode);
                    break;
                case 17:
                    w = 3 + read_bits_3(data, boff);
                    boff += 3;
                    while(w-- > 0)hcodes.push(0);
                    break;
                case 18:
                    w = 11 + read_bits_7(data, boff);
                    boff += 7;
                    while(w-- > 0)hcodes.push(0);
                    break;
                default:
                    hcodes.push(ccode);
                    if (maxlen < ccode) maxlen = ccode;
                    break;
            }
        }
        /* build literal / length trees */ var h1 = hcodes.slice(0, _HLIT), h2 = hcodes.slice(_HLIT);
        for(i = _HLIT; i < 286; ++i)h1[i] = 0;
        for(i = _HDIST; i < 30; ++i)h2[i] = 0;
        dyn_len_1 = build_tree(h1, dyn_lmap, 286);
        dyn_len_2 = build_tree(h2, dyn_dmap, 30);
        return boff;
    }
    /* return [ data, bytesRead ] */ function inflate(data, usz /*:number*/ ) {
        /* shortcircuit for empty buffer [0x03, 0x00] */ if (data[0] == 3 && !(data[1] & 0x3)) return [
            $a1a91b25d7598376$var$new_raw_buf(usz),
            2
        ];
        /* bit offset */ var boff = 0;
        /* header includes final bit and type bits */ var header = 0;
        var outbuf = $a1a91b25d7598376$var$new_unsafe_buf(usz ? usz : 262144);
        var woff = 0;
        var OL = outbuf.length >>> 0;
        var max_len_1 = 0, max_len_2 = 0;
        while((header & 1) == 0){
            header = read_bits_3(data, boff);
            boff += 3;
            if (header >>> 1 == 0) {
                /* Stored block */ if (boff & 7) boff += 8 - (boff & 7);
                /* 2 bytes sz, 2 bytes bit inverse */ var sz = data[boff >>> 3] | data[(boff >>> 3) + 1] << 8;
                boff += 32;
                /* push sz bytes */ if (sz > 0) {
                    if (!usz && OL < woff + sz) {
                        outbuf = realloc(outbuf, woff + sz);
                        OL = outbuf.length;
                    }
                    while(sz-- > 0){
                        outbuf[woff++] = data[boff >>> 3];
                        boff += 8;
                    }
                }
                continue;
            } else if (header >> 1 == 1) {
                /* Fixed Huffman */ max_len_1 = 9;
                max_len_2 = 5;
            } else {
                /* Dynamic Huffman */ boff = dyn(data, boff);
                max_len_1 = dyn_len_1;
                max_len_2 = dyn_len_2;
            }
            for(;;){
                if (!usz && OL < woff + 32767) {
                    outbuf = realloc(outbuf, woff + 32767);
                    OL = outbuf.length;
                }
                /* ingest code and move read head */ var bits = read_bits_n(data, boff, max_len_1);
                var code = header >>> 1 == 1 ? fix_lmap[bits] : dyn_lmap[bits];
                boff += code & 15;
                code >>>= 4;
                /* 0-255 are literals, 256 is end of block token, 257+ are copy tokens */ if ((code >>> 8 & 0xFF) === 0) outbuf[woff++] = code;
                else if (code == 256) break;
                else {
                    code -= 257;
                    var len_eb = code < 8 ? 0 : code - 4 >> 2;
                    if (len_eb > 5) len_eb = 0;
                    var tgt = woff + LEN_LN[code];
                    /* length extra bits */ if (len_eb > 0) {
                        tgt += read_bits_n(data, boff, len_eb);
                        boff += len_eb;
                    }
                    /* dist code */ bits = read_bits_n(data, boff, max_len_2);
                    code = header >>> 1 == 1 ? fix_dmap[bits] : dyn_dmap[bits];
                    boff += code & 15;
                    code >>>= 4;
                    var dst_eb = code < 4 ? 0 : code - 2 >> 1;
                    var dst = DST_LN[code];
                    /* dist extra bits */ if (dst_eb > 0) {
                        dst += read_bits_n(data, boff, dst_eb);
                        boff += dst_eb;
                    }
                    /* in the common case, manual byte copy is faster than TA set / Buffer copy */ if (!usz && OL < tgt) {
                        outbuf = realloc(outbuf, tgt + 100);
                        OL = outbuf.length;
                    }
                    while(woff < tgt){
                        outbuf[woff] = outbuf[woff - dst];
                        ++woff;
                    }
                }
            }
        }
        if (usz) return [
            outbuf,
            boff + 7 >>> 3
        ];
        return [
            outbuf.slice(0, woff),
            boff + 7 >>> 3
        ];
    }
    function _inflate(payload, usz) {
        var data = payload.slice(payload.l || 0);
        var out = inflate(data, usz);
        payload.l += out[1];
        return out[0];
    }
    function warn_or_throw(wrn, msg) {
        if (wrn) {
            if (typeof console !== 'undefined') console.error(msg);
        } else throw new Error(msg);
    }
    function parse_zip(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        var blob /*:CFBlob*/  = /*::(*/ file /*:: :any)*/ ;
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o, {
            root: options.root
        });
        /* find end of central directory, start just after signature */ var i = blob.length - 4;
        while((blob[i] != 0x50 || blob[i + 1] != 0x4b || blob[i + 2] != 0x05 || blob[i + 3] != 0x06) && i >= 0)--i;
        blob.l = i + 4;
        /* parse end of central directory */ blob.l += 4;
        var fcnt = blob.read_shift(2);
        blob.l += 6;
        var start_cd = blob.read_shift(4);
        /* parse central directory */ blob.l = start_cd;
        for(i = 0; i < fcnt; ++i){
            /* trust local file header instead of CD entry */ blob.l += 20;
            var csz = blob.read_shift(4);
            var usz = blob.read_shift(4);
            var namelen = blob.read_shift(2);
            var efsz = blob.read_shift(2);
            var fcsz = blob.read_shift(2);
            blob.l += 8;
            var offset = blob.read_shift(4);
            var EF = parse_extra_field(/*::(*/ blob.slice(blob.l + namelen, blob.l + namelen + efsz));
            blob.l += namelen + efsz + fcsz;
            var L = blob.l;
            blob.l = offset + 4;
            /* ZIP64 lengths */ if (EF && EF[0x0001]) {
                if ((EF[0x0001] || {}).usz) usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) csz = EF[0x0001].csz;
            }
            parse_local_file(blob, csz, usz, o, EF);
            blob.l = L;
        }
        return o;
    }
    /* head starts just after local file header signature */ function parse_local_file(blob /*:CFBlob*/ , csz /*:number*/ , usz /*:number*/ , o /*:CFBContainer*/ , EF) {
        /* [local file header] */ blob.l += 2;
        var flags = blob.read_shift(2);
        var meth = blob.read_shift(2);
        var date = parse_dos_date(blob);
        if (flags & 0x2041) throw new Error("Unsupported ZIP encryption");
        var crc32 = blob.read_shift(4);
        var _csz = blob.read_shift(4);
        var _usz = blob.read_shift(4);
        var namelen = blob.read_shift(2);
        var efsz = blob.read_shift(2);
        // TODO: flags & (1<<11) // UTF8
        var name = "";
        for(var i = 0; i < namelen; ++i)name += String.fromCharCode(blob[blob.l++]);
        if (efsz) {
            var ef = parse_extra_field(/*::(*/ blob.slice(blob.l, blob.l + efsz));
            if ((ef[0x5455] || {}).mt) date = ef[0x5455].mt;
            if ((ef[0x0001] || {}).usz) _usz = ef[0x0001].usz;
            if ((ef[0x0001] || {}).csz) _csz = ef[0x0001].csz;
            if (EF) {
                if ((EF[0x5455] || {}).mt) date = EF[0x5455].mt;
                if ((EF[0x0001] || {}).usz) _usz = EF[0x0001].usz;
                if ((EF[0x0001] || {}).csz) _csz = EF[0x0001].csz;
            }
        }
        blob.l += efsz;
        /* [encryption header] */ /* [file data] */ var data = blob.slice(blob.l, blob.l + _csz);
        switch(meth){
            case 8:
                data = _inflateRawSync(blob, _usz);
                break;
            case 0:
                blob.l += _csz;
                break; // TODO: scan for magic number
            default:
                throw new Error("Unsupported ZIP Compression method " + meth);
        }
        /* [data descriptor] */ var wrn = false;
        if (flags & 8) {
            crc32 = blob.read_shift(4);
            if (crc32 == 0x08074b50) {
                crc32 = blob.read_shift(4);
                wrn = true;
            }
            _csz = blob.read_shift(4);
            _usz = blob.read_shift(4);
        }
        if (_csz != csz) warn_or_throw(wrn, "Bad compressed size: " + csz + " != " + _csz);
        if (_usz != usz) warn_or_throw(wrn, "Bad uncompressed size: " + usz + " != " + _usz);
        //var _crc32 = CRC32.buf(data, 0);
        //if((crc32>>0) != (_crc32>>0)) warn_or_throw(wrn, "Bad CRC32 checksum: " + crc32 + " != " + _crc32);
        cfb_add(o, name, data, {
            unsafe: true,
            mt: date
        });
    }
    function write_zip(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:RawBytes*/ {
        var _opts = options || {};
        var out = [], cdirs = [];
        var o /*:CFBlob*/  = $a1a91b25d7598376$var$new_buf(1);
        var method = _opts.compression ? 8 : 0, flags = 0;
        var desc = false;
        if (desc) flags |= 8;
        var i = 0, j = 0;
        var start_cd = 0, fcnt = 0;
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        var crcs = [];
        var sz_cd = 0;
        for(i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || Array.isArray(fi.content) && fi.content.length == 0 || fp == "\u0001Sh33tJ5") continue;
            var start = start_cd;
            /* TODO: CP437 filename */ var namebuf = $a1a91b25d7598376$var$new_buf(fp.length);
            for(j = 0; j < fp.length; ++j)namebuf.write_shift(1, fp.charCodeAt(j) & 0x7F);
            namebuf = namebuf.slice(0, namebuf.l);
            crcs[fcnt] = typeof fi.content == "string" ? $a1a91b25d7598376$var$CRC32.bstr(fi.content, 0) : $a1a91b25d7598376$var$CRC32.buf(/*::((*/ fi.content /*::||[]):any)*/ , 0);
            var outbuf = typeof fi.content == "string" ? $a1a91b25d7598376$var$s2a(fi.content) : fi.content /*::||[]*/ ;
            if (method == 8) outbuf = _deflateRawSync(outbuf);
            /* local file header */ o = $a1a91b25d7598376$var$new_buf(30);
            o.write_shift(4, 0x04034b50);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            /* TODO: last mod file time/date */ if (fi.mt) write_dos_date(o, fi.mt);
            else o.write_shift(4, 0);
            o.write_shift(-4, flags & 8 ? 0 : crcs[fcnt]);
            o.write_shift(4, flags & 8 ? 0 : outbuf.length);
            o.write_shift(4, flags & 8 ? 0 : /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            start_cd += o.length;
            out.push(o);
            start_cd += namebuf.length;
            out.push(namebuf);
            /* TODO: extra fields? */ /* TODO: encryption header ? */ start_cd += outbuf.length;
            out.push(outbuf);
            /* data descriptor */ if (flags & 8) {
                o = $a1a91b25d7598376$var$new_buf(12);
                o.write_shift(-4, crcs[fcnt]);
                o.write_shift(4, outbuf.length);
                o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
                start_cd += o.l;
                out.push(o);
            }
            /* central directory */ o = $a1a91b25d7598376$var$new_buf(46);
            o.write_shift(4, 0x02014b50);
            o.write_shift(2, 0);
            o.write_shift(2, 20);
            o.write_shift(2, flags);
            o.write_shift(2, method);
            o.write_shift(4, 0); /* TODO: last mod file time/date */ 
            o.write_shift(-4, crcs[fcnt]);
            o.write_shift(4, outbuf.length);
            o.write_shift(4, /*::(*/ fi.content /*::||[])*/ .length);
            o.write_shift(2, namebuf.length);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(2, 0);
            o.write_shift(4, 0);
            o.write_shift(4, start);
            sz_cd += o.l;
            cdirs.push(o);
            sz_cd += namebuf.length;
            cdirs.push(namebuf);
            ++fcnt;
        }
        /* end of central directory */ o = $a1a91b25d7598376$var$new_buf(22);
        o.write_shift(4, 0x06054b50);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, fcnt);
        o.write_shift(2, fcnt);
        o.write_shift(4, sz_cd);
        o.write_shift(4, start_cd);
        o.write_shift(2, 0);
        return $a1a91b25d7598376$var$bconcat([
            $a1a91b25d7598376$var$bconcat(out /*:any*/ ),
            $a1a91b25d7598376$var$bconcat(cdirs),
            o
        ]);
    }
    var ContentTypeMap = {
        "htm": "text/html",
        "xml": "text/xml",
        "gif": "image/gif",
        "jpg": "image/jpeg",
        "png": "image/png",
        "mso": "application/x-mso",
        "thmx": "application/vnd.ms-officetheme",
        "sh33tj5": "application/octet-stream"
    } /*:any*/ ;
    function get_content_type(fi /*:CFBEntry*/ , fp /*:string*/ ) /*:string*/ {
        if (fi.ctype) return fi.ctype;
        var ext = fi.name || "", m = ext.match(/\.([^\.]+)$/);
        if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        if (fp) {
            m = (ext = fp).match(/[\.\\]([^\.\\])+$/);
            if (m && ContentTypeMap[m[1]]) return ContentTypeMap[m[1]];
        }
        return "application/octet-stream";
    }
    /* 76 character chunks TODO: intertwine encoding */ function write_base64_76(bstr /*:string*/ ) /*:string*/ {
        var data = $a1a91b25d7598376$var$Base64_encode(bstr);
        var o = [];
        for(var i = 0; i < data.length; i += 76)o.push(data.slice(i, i + 76));
        return o.join("\r\n") + "\r\n";
    }
    /*
Rules for QP:
	- escape =## applies for all non-display characters and literal "="
	- space or tab at end of line must be encoded
	- \r\n newlines can be preserved, but bare \r and \n must be escaped
	- lines must not exceed 76 characters, use soft breaks =\r\n

TODO: Some files from word appear to write line extensions with bare equals:

```
<table class=3DMsoTableGrid border=3D1 cellspacing=3D0 cellpadding=3D0 width=
="70%"
```
*/ function write_quoted_printable(text /*:string*/ ) /*:string*/ {
        var encoded = text.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF=]/g, function(c) {
            var w = c.charCodeAt(0).toString(16).toUpperCase();
            return "=" + (w.length == 1 ? "0" + w : w);
        });
        encoded = encoded.replace(/ $/mg, "=20").replace(/\t$/mg, "=09");
        if (encoded.charAt(0) == "\n") encoded = "=0D" + encoded.slice(1);
        encoded = encoded.replace(/\r(?!\n)/mg, "=0D").replace(/\n\n/mg, "\n=0A").replace(/([^\r\n])\n/mg, "$1=0A");
        var o /*:Array<string>*/  = [], split = encoded.split("\r\n");
        for(var si = 0; si < split.length; ++si){
            var str = split[si];
            if (str.length == 0) {
                o.push("");
                continue;
            }
            for(var i = 0; i < str.length;){
                var end = 76;
                var tmp = str.slice(i, i + end);
                if (tmp.charAt(end - 1) == "=") end--;
                else if (tmp.charAt(end - 2) == "=") end -= 2;
                else if (tmp.charAt(end - 3) == "=") end -= 3;
                tmp = str.slice(i, i + end);
                i += end;
                if (i < str.length) tmp += "=";
                o.push(tmp);
            }
        }
        return o.join("\r\n");
    }
    function parse_quoted_printable(data /*:Array<string>*/ ) /*:RawBytes*/ {
        var o = [];
        /* unify long lines */ for(var di = 0; di < data.length; ++di){
            var line = data[di];
            while(di <= data.length && line.charAt(line.length - 1) == "=")line = line.slice(0, line.length - 1) + data[++di];
            o.push(line);
        }
        /* decode */ for(var oi = 0; oi < o.length; ++oi)o[oi] = o[oi].replace(/[=][0-9A-Fa-f]{2}/g, function($$) {
            return String.fromCharCode(parseInt($$.slice(1), 16));
        });
        return $a1a91b25d7598376$var$s2a(o.join("\r\n"));
    }
    function parse_mime(cfb /*:CFBContainer*/ , data /*:Array<string>*/ , root /*:string*/ ) /*:void*/ {
        var fname = "", cte = "", ctype = "", fdata;
        var di = 0;
        for(; di < 10; ++di){
            var line = data[di];
            if (!line || line.match(/^\s*$/)) break;
            var m = line.match(/^([^:]*?):\s*([^\s].*)$/);
            if (m) switch(m[1].toLowerCase()){
                case "content-location":
                    fname = m[2].trim();
                    break;
                case "content-type":
                    ctype = m[2].trim();
                    break;
                case "content-transfer-encoding":
                    cte = m[2].trim();
                    break;
            }
        }
        ++di;
        switch(cte.toLowerCase()){
            case 'base64':
                fdata = $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(data.slice(di).join("")));
                break;
            case 'quoted-printable':
                fdata = parse_quoted_printable(data.slice(di));
                break;
            default:
                throw new Error("Unsupported Content-Transfer-Encoding " + cte);
        }
        var file = cfb_add(cfb, fname.slice(root.length), fdata, {
            unsafe: true
        });
        if (ctype) file.ctype = ctype;
    }
    function parse_mad(file /*:RawBytes*/ , options /*:CFBReadOpts*/ ) /*:CFBContainer*/ {
        if (a2s(file.slice(0, 13)).toLowerCase() != "mime-version:") throw new Error("Unsupported MAD header");
        var root = options && options.root || "";
        // $FlowIgnore
        var data = ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(file) ? file.toString("binary") : a2s(file)).split("\r\n");
        var di = 0, row = "";
        /* if root is not specified, scan for the common prefix */ for(di = 0; di < data.length; ++di){
            row = data[di];
            if (!/^Content-Location:/i.test(row)) continue;
            row = row.slice(row.indexOf("file"));
            if (!root) root = row.slice(0, row.lastIndexOf("/") + 1);
            if (row.slice(0, root.length) == root) continue;
            while(root.length > 0){
                root = root.slice(0, root.length - 1);
                root = root.slice(0, root.lastIndexOf("/") + 1);
                if (row.slice(0, root.length) == root) break;
            }
        }
        var mboundary = (data[1] || "").match(/boundary="(.*?)"/);
        if (!mboundary) throw new Error("MAD cannot find boundary");
        var boundary = "--" + (mboundary[1] || "");
        var FileIndex /*:CFBFileIndex*/  = [], FullPaths /*:Array<string>*/  = [];
        var o = {
            FileIndex: FileIndex,
            FullPaths: FullPaths
        };
        init_cfb(o);
        var start_di, fcnt = 0;
        for(di = 0; di < data.length; ++di){
            var line = data[di];
            if (line !== boundary && line !== boundary + "--") continue;
            if (fcnt++) parse_mime(o, data.slice(start_di, di), root);
            start_di = di;
        }
        return o;
    }
    function write_mad(cfb /*:CFBContainer*/ , options /*:CFBWriteOpts*/ ) /*:string*/ {
        var opts = options || {};
        var boundary = opts.boundary || "SheetJS";
        boundary = '------=' + boundary;
        var out = [
            'MIME-Version: 1.0',
            'Content-Type: multipart/related; boundary="' + boundary.slice(2) + '"',
            '',
            '',
            ''
        ];
        var root = cfb.FullPaths[0], fp = root, fi = cfb.FileIndex[0];
        for(var i = 1; i < cfb.FullPaths.length; ++i){
            fp = cfb.FullPaths[i].slice(root.length);
            fi = cfb.FileIndex[i];
            if (!fi.size || !fi.content || fp == "\u0001Sh33tJ5") continue;
            /* Normalize filename */ fp = fp.replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7E-\xFF]/g, function(c) {
                return "_x" + c.charCodeAt(0).toString(16) + "_";
            }).replace(/[\u0080-\uFFFF]/g, function(u) {
                return "_u" + u.charCodeAt(0).toString(16) + "_";
            });
            /* Extract content as binary string */ var ca = fi.content;
            // $FlowIgnore
            var cstr = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(ca) ? ca.toString("binary") : a2s(ca);
            /* 4/5 of first 1024 chars ascii -> quoted printable, else base64 */ var dispcnt = 0, L = Math.min(1024, cstr.length), cc = 0;
            for(var csl = 0; csl <= L; ++csl)if ((cc = cstr.charCodeAt(csl)) >= 0x20 && cc < 0x80) ++dispcnt;
            var qp = dispcnt >= L * 4 / 5;
            out.push(boundary);
            out.push('Content-Location: ' + (opts.root || 'file:///C:/SheetJS/') + fp);
            out.push('Content-Transfer-Encoding: ' + (qp ? 'quoted-printable' : 'base64'));
            out.push('Content-Type: ' + get_content_type(fi, fp));
            out.push('');
            out.push(qp ? write_quoted_printable(cstr) : write_base64_76(cstr));
        }
        out.push(boundary + '--\r\n');
        return out.join("\r\n");
    }
    function cfb_new(opts /*:?any*/ ) /*:CFBContainer*/ {
        var o /*:CFBContainer*/  = {} /*:any*/ ;
        init_cfb(o, opts);
        return o;
    }
    function cfb_add(cfb /*:CFBContainer*/ , name /*:string*/ , content /*:?RawBytes*/ , opts /*:?any*/ ) /*:CFBEntry*/ {
        var unsafe = opts && opts.unsafe;
        if (!unsafe) init_cfb(cfb);
        var file = !unsafe && $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, name);
        if (!file) {
            var fpath /*:string*/  = cfb.FullPaths[0];
            if (name.slice(0, fpath.length) == fpath) fpath = name;
            else {
                if (fpath.slice(-1) != "/") fpath += "/";
                fpath = (fpath + name).replace("//", "/");
            }
            file = {
                name: filename(name),
                type: 2
            } /*:any*/ ;
            cfb.FileIndex.push(file);
            cfb.FullPaths.push(fpath);
            if (!unsafe) $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_gc(cfb);
        }
        /*:: if(!file) throw new Error("unreachable"); */ file.content = content /*:any*/ ;
        file.size = content ? content.length : 0;
        if (opts) {
            if (opts.CLSID) file.clsid = opts.CLSID;
            if (opts.mt) file.mt = opts.mt;
            if (opts.ct) file.ct = opts.ct;
        }
        return file;
    }
    function cfb_del(cfb /*:CFBContainer*/ , name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex.splice(j, 1);
                cfb.FullPaths.splice(j, 1);
                return true;
            }
        }
        return false;
    }
    function cfb_mov(cfb /*:CFBContainer*/ , old_name /*:string*/ , new_name /*:string*/ ) /*:boolean*/ {
        init_cfb(cfb);
        var file = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, old_name);
        if (file) {
            for(var j = 0; j < cfb.FileIndex.length; ++j)if (cfb.FileIndex[j] == file) {
                cfb.FileIndex[j].name = filename(new_name);
                cfb.FullPaths[j] = new_name;
                return true;
            }
        }
        return false;
    }
    function cfb_gc(cfb /*:CFBContainer*/ ) /*:void*/ {
        rebuild_cfb(cfb, true);
    }
    exports.find = find;
    exports.read = read;
    exports.parse = parse;
    exports.write = write;
    exports.writeFile = write_file;
    exports.utils = {
        cfb_new: cfb_new,
        cfb_add: cfb_add,
        cfb_del: cfb_del,
        cfb_mov: cfb_mov,
        cfb_gc: cfb_gc,
        ReadShift: $a1a91b25d7598376$var$ReadShift,
        CheckField: $a1a91b25d7598376$var$CheckField,
        prep_blob: $a1a91b25d7598376$var$prep_blob,
        bconcat: $a1a91b25d7598376$var$bconcat,
        use_zlib: use_zlib,
        _deflateRaw: _deflate,
        _inflateRaw: _inflate,
        consts: consts
    };
    return exports;
}();
var $a1a91b25d7598376$var$_fs;
function $a1a91b25d7598376$export$a48eb669e1768bcf(fs) {
    $a1a91b25d7598376$var$_fs = fs;
}
/* normalize data for blob ctor */ function $a1a91b25d7598376$var$blobify(data) {
    if (typeof data === "string") return $a1a91b25d7598376$var$s2ab(data);
    if (Array.isArray(data)) return $a1a91b25d7598376$var$a2u(data);
    return data;
}
/* write or download file */ function $a1a91b25d7598376$var$write_dl(fname /*:string*/ , payload /*:any*/ , enc /*:?string*/ ) {
    /*global IE_SaveFile, Blob, navigator, saveAs, document, File, chrome */ if (typeof $a1a91b25d7598376$var$_fs !== 'undefined' && $a1a91b25d7598376$var$_fs.writeFileSync) return enc ? $a1a91b25d7598376$var$_fs.writeFileSync(fname, payload, enc) : $a1a91b25d7598376$var$_fs.writeFileSync(fname, payload);
    if (typeof Deno !== 'undefined') {
        /* in this spot, it's safe to assume typed arrays and TextEncoder/TextDecoder exist */ if (enc && typeof payload == "string") switch(enc){
            case "utf8":
                payload = new TextEncoder(enc).encode(payload);
                break;
            case "binary":
                payload = $a1a91b25d7598376$var$s2ab(payload);
                break;
            /* TODO: binary equivalent */ default:
                throw new Error("Unsupported encoding " + enc);
        }
        return Deno.writeFileSync(fname, payload);
    }
    var data = enc == "utf8" ? $a1a91b25d7598376$var$utf8write(payload) : payload;
    /*:: declare var IE_SaveFile: any; */ if (typeof IE_SaveFile !== 'undefined') return IE_SaveFile(data, fname);
    if (typeof Blob !== 'undefined') {
        var blob = new Blob([
            $a1a91b25d7598376$var$blobify(data)
        ], {
            type: "application/octet-stream"
        });
        /*:: declare var navigator: any; */ if (typeof navigator !== 'undefined' && navigator.msSaveBlob) return navigator.msSaveBlob(blob, fname);
        /*:: declare var saveAs: any; */ if (typeof saveAs !== 'undefined') return saveAs(blob, fname);
        if (typeof URL !== 'undefined' && typeof document !== 'undefined' && document.createElement && URL.createObjectURL) {
            var url = URL.createObjectURL(blob);
            /*:: declare var chrome: any; */ if (typeof chrome === 'object' && typeof (chrome.downloads || {}).download == "function") {
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return chrome.downloads.download({
                    url: url,
                    filename: fname,
                    saveAs: true
                });
            }
            var a = document.createElement("a");
            if (a.download != null) {
                /*:: if(document.body == null) throw new Error("unreachable"); */ a.download = fname;
                a.href = url;
                document.body.appendChild(a);
                a.click();
                /*:: if(document.body == null) throw new Error("unreachable"); */ document.body.removeChild(a);
                if (URL.revokeObjectURL && typeof setTimeout !== 'undefined') setTimeout(function() {
                    URL.revokeObjectURL(url);
                }, 60000);
                return url;
            }
        } else if (typeof URL !== 'undefined' && !URL.createObjectURL && typeof chrome === 'object') {
            /* manifest v3 extensions -- no URL.createObjectURL */ var b64 = "data:application/octet-stream;base64," + $a1a91b25d7598376$var$Base64_encode_arr(new Uint8Array($a1a91b25d7598376$var$blobify(data)));
            return chrome.downloads.download({
                url: b64,
                filename: fname,
                saveAs: true
            });
        }
    }
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var out = File(fname);
        out.open("w");
        out.encoding = "binary";
        if (Array.isArray(payload)) payload = $a1a91b25d7598376$var$a2s(payload);
        out.write(payload);
        out.close();
        return payload;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("cannot save file " + fname);
}
/* read binary data from file */ function $a1a91b25d7598376$var$read_binary(path /*:string*/ ) {
    if (typeof $a1a91b25d7598376$var$_fs !== 'undefined') return $a1a91b25d7598376$var$_fs.readFileSync(path);
    if (typeof Deno !== 'undefined') return Deno.readFileSync(path);
    // $FlowIgnore
    if (typeof $ !== 'undefined' && typeof File !== 'undefined' && typeof Folder !== 'undefined') try {
        // $FlowIgnore
        var infile = File(path);
        infile.open("r");
        infile.encoding = "binary";
        var data = infile.read();
        infile.close();
        return data;
    } catch (e) {
        if (!e.message || e.message.indexOf("onstruct") == -1) throw e;
    }
    throw new Error("Cannot access file " + path);
}
function $a1a91b25d7598376$var$keys(o /*:any*/ ) /*:Array<any>*/ {
    var ks = Object.keys(o), o2 = [];
    for(var i = 0; i < ks.length; ++i)if (Object.prototype.hasOwnProperty.call(o, ks[i])) o2.push(ks[i]);
    return o2;
}
function $a1a91b25d7598376$var$evert_key(obj /*:any*/ , key /*:string*/ ) /*:EvertType*/ {
    var o = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)if (o[obj[K[i]][key]] == null) o[obj[K[i]][key]] = K[i];
    return o;
}
function $a1a91b25d7598376$var$evert(obj /*:any*/ ) /*:EvertType*/ {
    var o = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = K[i];
    return o;
}
function $a1a91b25d7598376$var$evert_num(obj /*:any*/ ) /*:EvertNumType*/ {
    var o = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i)o[obj[K[i]]] = parseInt(K[i], 10);
    return o;
}
function $a1a91b25d7598376$var$evert_arr(obj /*:any*/ ) /*:EvertArrType*/ {
    var o /*:EvertArrType*/  = [], K = $a1a91b25d7598376$var$keys(obj);
    for(var i = 0; i !== K.length; ++i){
        if (o[obj[K[i]]] == null) o[obj[K[i]]] = [];
        o[obj[K[i]]].push(K[i]);
    }
    return o;
}
var $a1a91b25d7598376$var$dnthresh = /*#__PURE__*/ Date.UTC(1899, 11, 30, 0, 0, 0); // -2209161600000
var $a1a91b25d7598376$var$dnthresh1 = /*#__PURE__*/ Date.UTC(1899, 11, 31, 0, 0, 0); // -2209075200000
var $a1a91b25d7598376$var$dnthresh2 = /*#__PURE__*/ Date.UTC(1904, 0, 1, 0, 0, 0); // -2209075200000
function $a1a91b25d7598376$var$datenum(v /*:Date*/ , date1904 /*:?boolean*/ ) /*:number*/ {
    var epoch = /*#__PURE__*/ v.getTime();
    var res = (epoch - $a1a91b25d7598376$var$dnthresh) / 86400000;
    if (date1904) {
        res -= 1462;
        return res < -1402 ? res - 1 : res;
    }
    return res < 60 ? res - 1 : res;
}
function $a1a91b25d7598376$var$numdate(v /*:number*/ ) /*:Date|number*/ {
    if (v >= 60 && v < 61) return v;
    var out = new Date();
    out.setTime((v > 60 ? v : v + 1) * 86400000 + $a1a91b25d7598376$var$dnthresh);
    return out;
}
/* ISO 8601 Duration */ function $a1a91b25d7598376$var$parse_isodur(s) {
    var sec = 0, mt = 0, time = false;
    var m = s.match(/P([0-9\.]+Y)?([0-9\.]+M)?([0-9\.]+D)?T([0-9\.]+H)?([0-9\.]+M)?([0-9\.]+S)?/);
    if (!m) throw new Error("|" + s + "| is not an ISO8601 Duration");
    for(var i = 1; i != m.length; ++i){
        if (!m[i]) continue;
        mt = 1;
        if (i > 3) time = true;
        switch(m[i].slice(m[i].length - 1)){
            case 'Y':
                throw new Error("Unsupported ISO Duration Field: " + m[i].slice(m[i].length - 1));
            case 'D':
                mt *= 24;
            /* falls through */ case 'H':
                mt *= 60;
            /* falls through */ case 'M':
                if (!time) throw new Error("Unsupported ISO Duration Field: M");
                else mt *= 60;
            /* falls through */ case 'S':
                break;
        }
        sec += mt * parseInt(m[i], 10);
    }
    return sec;
}
/* Blame https://bugs.chromium.org/p/v8/issues/detail?id=7863 for the regexide */ var $a1a91b25d7598376$var$pdre1 = /^(\d+):(\d+)(:\d+)?(\.\d+)?$/; // HH:MM[:SS[.UUU]]
var $a1a91b25d7598376$var$pdre2 = /^(\d+)-(\d+)-(\d+)$/; // YYYY-mm-dd
var $a1a91b25d7598376$var$pdre3 = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)?(\.\d+)?$/; // YYYY-mm-dd(T or space)HH:MM[:SS[.UUU]], sans "Z"
/* parses a date string as a UTC date */ function $a1a91b25d7598376$var$parseDate(str /*:string*/ , date1904 /*:boolean*/ ) /*:Date*/ {
    if (str instanceof Date) return str;
    var m = str.match($a1a91b25d7598376$var$pdre1);
    if (m) return new Date((date1904 ? $a1a91b25d7598376$var$dnthresh2 : $a1a91b25d7598376$var$dnthresh1) + ((parseInt(m[1], 10) * 60 + parseInt(m[2], 10)) * 60 + (m[3] ? parseInt(m[3].slice(1), 10) : 0)) * 1000 + (m[4] ? parseInt((m[4] + "000").slice(1, 4), 10) : 0));
    m = str.match($a1a91b25d7598376$var$pdre2);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], 0, 0, 0, 0));
    /* TODO: 1900-02-29T00:00:00.000 should return a flag to treat as a date code (affects xlml) */ m = str.match($a1a91b25d7598376$var$pdre3);
    if (m) return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], m[6] && parseInt(m[6].slice(1), 10) || 0, m[7] && parseInt((m[7] + "0000").slice(1, 4), 10) || 0));
    var d = new Date(str);
    return d;
}
function $a1a91b25d7598376$var$cc2str(arr /*:Array<number>*/ , debomit) /*:string*/ {
    if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(arr)) {
        if (debomit && $a1a91b25d7598376$var$buf_utf16le) {
            // TODO: temporary patch
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $a1a91b25d7598376$var$utf8write(arr.slice(2).toString("utf16le"));
            if (arr[1] == 0xFE && arr[2] == 0xFF) return $a1a91b25d7598376$var$utf8write($a1a91b25d7598376$var$utf16beread(arr.slice(2).toString("binary")));
        }
        return arr.toString("binary");
    }
    if (typeof TextDecoder !== "undefined") try {
        if (debomit) {
            if (arr[0] == 0xFF && arr[1] == 0xFE) return $a1a91b25d7598376$var$utf8write(new TextDecoder("utf-16le").decode(arr.slice(2)));
            if (arr[0] == 0xFE && arr[1] == 0xFF) return $a1a91b25d7598376$var$utf8write(new TextDecoder("utf-16be").decode(arr.slice(2)));
        }
        var rev = {
            "\u20ac": "\x80",
            "\u201a": "\x82",
            "\u0192": "\x83",
            "\u201e": "\x84",
            "\u2026": "\x85",
            "\u2020": "\x86",
            "\u2021": "\x87",
            "\u02c6": "\x88",
            "\u2030": "\x89",
            "\u0160": "\x8a",
            "\u2039": "\x8b",
            "\u0152": "\x8c",
            "\u017d": "\x8e",
            "\u2018": "\x91",
            "\u2019": "\x92",
            "\u201c": "\x93",
            "\u201d": "\x94",
            "\u2022": "\x95",
            "\u2013": "\x96",
            "\u2014": "\x97",
            "\u02dc": "\x98",
            "\u2122": "\x99",
            "\u0161": "\x9a",
            "\u203a": "\x9b",
            "\u0153": "\x9c",
            "\u017e": "\x9e",
            "\u0178": "\x9f"
        };
        if (Array.isArray(arr)) arr = new Uint8Array(arr);
        return new TextDecoder("latin1").decode(arr).replace(/[€‚ƒ„…†‡ˆ‰Š‹ŒŽ‘’“”•–—˜™š›œžŸ]/g, function(c) {
            return rev[c] || c;
        });
    } catch (e) {}
    var o = [], i = 0;
    // this cascade is for the browsers and runtimes of antiquity (and for modern runtimes that lack TextEncoder)
    try {
        for(i = 0; i < arr.length - 65536; i += 65536)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 65536)));
        o.push(String.fromCharCode.apply(0, arr.slice(i)));
    } catch (e) {
        try {
            for(; i < arr.length - 16384; i += 16384)o.push(String.fromCharCode.apply(0, arr.slice(i, i + 16384)));
            o.push(String.fromCharCode.apply(0, arr.slice(i)));
        } catch (e) {
            for(; i != arr.length; ++i)o.push(String.fromCharCode(arr[i]));
        }
    }
    return o.join("");
}
function $a1a91b25d7598376$var$dup(o /*:any*/ ) /*:any*/ {
    if (typeof JSON != 'undefined' && !Array.isArray(o)) return JSON.parse(JSON.stringify(o));
    if (typeof o != 'object' || o == null) return o;
    if (o instanceof Date) return new Date(o.getTime());
    var out = {};
    for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = $a1a91b25d7598376$var$dup(o[k]);
    return out;
}
function $a1a91b25d7598376$var$fill(c /*:string*/ , l /*:number*/ ) /*:string*/ {
    var o = "";
    while(o.length < l)o += c;
    return o;
}
/* TODO: stress test */ function $a1a91b25d7598376$var$fuzzynum(s /*:string*/ ) /*:number*/ {
    var v /*:number*/  = Number(s);
    if (!isNaN(v)) return isFinite(v) ? v : NaN;
    if (!/\d/.test(s)) return v;
    var wt = 1;
    var ss = s.replace(/([\d]),([\d])/g, "$1$2").replace(/[$]/g, "").replace(/[%]/g, function() {
        wt *= 100;
        return "";
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    ss = ss.replace(/[(]([^()]*)[)]/, function($$, $1) {
        wt = -wt;
        return $1;
    });
    if (!isNaN(v = Number(ss))) return v / wt;
    return v;
}
/* NOTE: Chrome rejects bare times like 1:23 PM */ var $a1a91b25d7598376$var$FDRE1 = /^(0?\d|1[0-2])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))\s+([ap])m?$/;
var $a1a91b25d7598376$var$FDRE2 = /^([01]?\d|2[0-3])(?:|:([0-5]?\d)(?:|(\.\d+)(?:|:([0-5]?\d))|:([0-5]?\d)(|\.\d+)))$/;
var $a1a91b25d7598376$var$FDISO = /^(\d+)-(\d+)-(\d+)[T ](\d+):(\d+)(:\d+)(\.\d+)?[Z]?$/; // YYYY-mm-dd(T or space)HH:MM:SS[.UUU][Z]
/* TODO: 1904 adjustment */ var $a1a91b25d7598376$var$utc_append_works = new Date("6/9/69 00:00 UTC").valueOf() == -17798400000;
function $a1a91b25d7598376$var$fuzzytime1(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, M[7] == "p" ? 12 : 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1] % 12 + (M[7] == "p" ? 12 : 0), +M[2], 0, 0));
}
function $a1a91b25d7598376$var$fuzzytime2(M) /*:Date*/ {
    if (!M[2]) return new Date(Date.UTC(1899, 11, 31, +M[1], 0, 0, 0));
    if (M[3]) {
        if (M[4]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[4], parseFloat(M[3]) * 1000));
        else return new Date(Date.UTC(1899, 11, 31, 0, +M[1], +M[2], parseFloat(M[3]) * 1000));
    } else if (M[5]) return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], +M[5], M[6] ? parseFloat(M[6]) * 1000 : 0));
    else return new Date(Date.UTC(1899, 11, 31, +M[1], +M[2], 0, 0));
}
var $a1a91b25d7598376$var$lower_months = [
    'january',
    'february',
    'march',
    'april',
    'may',
    'june',
    'july',
    'august',
    'september',
    'october',
    'november',
    'december'
];
function $a1a91b25d7598376$var$fuzzydate(s /*:string*/ ) /*:Date*/ {
    // See issue 2863 -- this is technically not supported in Excel but is otherwise useful
    if ($a1a91b25d7598376$var$FDISO.test(s)) return s.indexOf("Z") == -1 ? $a1a91b25d7598376$var$local_to_utc(new Date(s)) : new Date(s);
    var lower = s.toLowerCase();
    var lnos = lower.replace(/\s+/g, " ").trim();
    var M = lnos.match($a1a91b25d7598376$var$FDRE1);
    if (M) return $a1a91b25d7598376$var$fuzzytime1(M);
    M = lnos.match($a1a91b25d7598376$var$FDRE2);
    if (M) return $a1a91b25d7598376$var$fuzzytime2(M);
    M = lnos.match($a1a91b25d7598376$var$pdre3);
    if (M) return new Date(Date.UTC(+M[1], +M[2] - 1, +M[3], +M[4], +M[5], M[6] && parseInt(M[6].slice(1), 10) || 0, M[7] && parseInt((M[7] + "0000").slice(1, 4), 10) || 0));
    var o = new Date($a1a91b25d7598376$var$utc_append_works && s.indexOf("UTC") == -1 ? s + " UTC" : s), n = new Date(NaN);
    var y = o.getYear(), m = o.getMonth(), d = o.getDate();
    if (isNaN(d)) return n;
    if (lower.match(/jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec/)) {
        lower = lower.replace(/[^a-z]/g, "").replace(/([^a-z]|^)[ap]m?([^a-z]|$)/, "");
        if (lower.length > 3 && $a1a91b25d7598376$var$lower_months.indexOf(lower) == -1) return n;
    } else if (lower.replace(/[ap]m?/, "").match(/[a-z]/)) return n;
    if (y < 0 || y > 8099 || s.match(/[^-0-9:,\/\\\ ]/)) return n;
    return o;
}
var $a1a91b25d7598376$var$split_regex = /*#__PURE__*/ function() {
    var safe_split_regex = "abacaba".split(/(:?b)/i).length == 5;
    return function split_regex(str /*:string*/ , re, def /*:string*/ ) /*:Array<string>*/ {
        if (safe_split_regex || typeof re == "string") return str.split(re);
        var p = str.split(re), o = [
            p[0]
        ];
        for(var i = 1; i < p.length; ++i){
            o.push(def);
            o.push(p[i]);
        }
        return o;
    };
}();
function $a1a91b25d7598376$var$utc_to_local(utc) {
    return new Date(utc.getUTCFullYear(), utc.getUTCMonth(), utc.getUTCDate(), utc.getUTCHours(), utc.getUTCMinutes(), utc.getUTCSeconds(), utc.getUTCMilliseconds());
}
function $a1a91b25d7598376$var$local_to_utc(local) {
    return new Date(Date.UTC(local.getFullYear(), local.getMonth(), local.getDate(), local.getHours(), local.getMinutes(), local.getSeconds(), local.getMilliseconds()));
}
function $a1a91b25d7598376$var$remove_doctype(str) {
    var preamble = str.slice(0, 1024);
    var si = preamble.indexOf("<!DOCTYPE");
    if (si == -1) return str;
    var m = str.match(/<[\w]/);
    if (!m) return str;
    return str.slice(0, si) + str.slice(m.index);
}
/* str.match(/<!--[\s\S]*?-->/g) --> str_match_ng(str, "<!--", "-->") */ function $a1a91b25d7598376$var$str_match_ng(str, s, e) {
    var out = [];
    var si = str.indexOf(s);
    while(si > -1){
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        out.push(str.slice(si, ei + e.length));
        si = str.indexOf(s, ei + e.length);
    }
    return out.length > 0 ? out : null;
}
/* str.replace(/<!--[\s\S]*?-->/g, "") --> str_remove_ng(str, "<!--", "-->") */ function $a1a91b25d7598376$var$str_remove_ng(str, s, e) {
    var out = [], last = 0;
    var si = str.indexOf(s);
    if (si == -1) return str;
    while(si > -1){
        out.push(str.slice(last, si));
        var ei = str.indexOf(e, si + s.length);
        if (ei == -1) break;
        if ((si = str.indexOf(s, last = ei + e.length)) == -1) out.push(str.slice(last));
    }
    return out.join("");
}
/* str.match(/<tag\b[^>]*?>([\s\S]*?)</tag>/) --> str_match_xml(str, "tag") */ var $a1a91b25d7598376$var$xml_boundary = {
    " ": 1,
    "\t": 1,
    "\r": 1,
    "\n": 1,
    ">": 1
};
function $a1a91b25d7598376$var$str_match_xml(str, tag) {
    var si = str.indexOf('<' + tag), w = tag.length + 1, L = str.length;
    while(si >= 0 && si <= L - w && !$a1a91b25d7598376$var$xml_boundary[str.charAt(si + w)])si = str.indexOf('<' + tag, si + 1);
    if (si === -1) return null;
    var sf = str.indexOf(">", si + tag.length);
    if (sf === -1) return null;
    var et = "</" + tag + ">";
    var ei = str.indexOf(et, sf);
    if (ei == -1) return null;
    return [
        str.slice(si, ei + et.length),
        str.slice(sf + 1, ei)
    ];
}
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/) --> str_match_xml(str, "tag") */ var $a1a91b25d7598376$var$str_match_xml_ns = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m = res[0].exec(str);
        if (!m) return null;
        var si = m.index;
        var sf = res[0].lastIndex;
        res[1].lastIndex = res[0].lastIndex;
        m = res[1].exec(str);
        if (!m) return null;
        var ei = m.index;
        var ef = res[1].lastIndex;
        return [
            str.slice(si, ef),
            str.slice(sf, ei)
        ];
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^<>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/g) --> str_match_xml_ns_g(str, "tag") */ var $a1a91b25d7598376$var$str_match_xml_ns_g = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
var $a1a91b25d7598376$var$str_remove_xml_ns_g = /*#__PURE__*/ function() {
    var str_remove_xml_ns_cache = {};
    return function str_remove_xml_ns_g(str, tag) {
        var out = [];
        var res = str_remove_xml_ns_cache[tag];
        if (!res) str_remove_xml_ns_cache[tag] = res = [
            new RegExp('<(?:\\w+:)?' + tag + '\\b[^<>]*>', "g"),
            new RegExp('</(?:\\w+:)?' + tag + '>', "g")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        var si = 0, ef = 0;
        while(m = res[0].exec(str)){
            si = m.index;
            out.push(str.slice(ef, si));
            ef = si;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            ef = res[1].lastIndex;
            res[0].lastIndex = res[1].lastIndex;
        }
        out.push(str.slice(ef));
        return out.length == 0 ? "" : out.join("");
    };
}();
/* str.match(/<(?:\w+:)?tag\b[^>]*?>([\s\S]*?)<\/(?:\w+:)?tag>/gi) --> str_match_xml_ns_ig(str, "tag") */ var $a1a91b25d7598376$var$str_match_xml_ig = /*#__PURE__*/ function() {
    var str_match_xml_ns_cache = {};
    return function str_match_xml_ns(str, tag) {
        var out = [];
        var res = str_match_xml_ns_cache[tag];
        if (!res) str_match_xml_ns_cache[tag] = res = [
            new RegExp('<' + tag + '\\b[^<>]*>', "ig"),
            new RegExp('</' + tag + '>', "ig")
        ];
        res[0].lastIndex = res[1].lastIndex = 0;
        var m;
        while(m = res[0].exec(str)){
            var si = m.index;
            res[1].lastIndex = res[0].lastIndex;
            m = res[1].exec(str);
            if (!m) return null;
            var ef = res[1].lastIndex;
            out.push(str.slice(si, ef));
            res[0].lastIndex = res[1].lastIndex;
        }
        return out.length == 0 ? null : out;
    };
}();
function $a1a91b25d7598376$var$getdatastr(data) /*:?string*/ {
    if (!data) return null;
    if (data.content && data.type) return $a1a91b25d7598376$var$cc2str(data.content, true);
    if (data.data) return $a1a91b25d7598376$var$debom(data.data);
    if (data.asNodeBuffer && $a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$debom(data.asNodeBuffer().toString('binary'));
    if (data.asBinary) return $a1a91b25d7598376$var$debom(data.asBinary());
    if (data._data && data._data.getContent) return $a1a91b25d7598376$var$debom($a1a91b25d7598376$var$cc2str(Array.prototype.slice.call(data._data.getContent(), 0)));
    return null;
}
function $a1a91b25d7598376$var$getdatabin(data) {
    if (!data) return null;
    if (data.data) return $a1a91b25d7598376$var$char_codes(data.data);
    if (data.asNodeBuffer && $a1a91b25d7598376$var$has_buf) return data.asNodeBuffer();
    if (data._data && data._data.getContent) {
        var o = data._data.getContent();
        if (typeof o == "string") return $a1a91b25d7598376$var$char_codes(o);
        return Array.prototype.slice.call(o);
    }
    if (data.content && data.type) return data.content;
    return null;
}
function $a1a91b25d7598376$var$getdata(data) {
    return data && data.name.slice(-4) === ".bin" ? $a1a91b25d7598376$var$getdatabin(data) : $a1a91b25d7598376$var$getdatastr(data);
}
/* Part 2 Section 10.1.2 "Mapping Content Types" Names are case-insensitive */ /* OASIS does not comment on filename case sensitivity */ function $a1a91b25d7598376$var$safegetzipfile(zip, file /*:string*/ ) {
    var k = zip.FullPaths || $a1a91b25d7598376$var$keys(zip.files);
    var f = file.toLowerCase().replace(/[\/]/g, '\\'), g = f.replace(/\\/g, '\/');
    for(var i = 0; i < k.length; ++i){
        var n = k[i].replace(/^Root Entry[\/]/, "").toLowerCase();
        if (f == n || g == n) return zip.files ? zip.files[k[i]] : zip.FileIndex[i];
    }
    return null;
}
function $a1a91b25d7598376$var$getzipfile(zip, file /*:string*/ ) {
    var o = $a1a91b25d7598376$var$safegetzipfile(zip, file);
    if (o == null) throw new Error("Cannot find file " + file + " in zip");
    return o;
}
function $a1a91b25d7598376$var$getzipdata(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $a1a91b25d7598376$var$getdata($a1a91b25d7598376$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $a1a91b25d7598376$var$getzipdata(zip, file);
    } catch (e) {
        return null;
    }
}
function $a1a91b25d7598376$var$getzipstr(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:?string*/ {
    if (!safe) return $a1a91b25d7598376$var$getdatastr($a1a91b25d7598376$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $a1a91b25d7598376$var$getzipstr(zip, file);
    } catch (e) {
        return null;
    }
}
function $a1a91b25d7598376$var$getzipbin(zip, file /*:string*/ , safe /*:?boolean*/ ) /*:any*/ {
    if (!safe) return $a1a91b25d7598376$var$getdatabin($a1a91b25d7598376$var$getzipfile(zip, file));
    if (!file) return null;
    try {
        return $a1a91b25d7598376$var$getzipbin(zip, file);
    } catch (e) {
        return null;
    }
}
function $a1a91b25d7598376$var$zipentries(zip) {
    var k = zip.FullPaths || $a1a91b25d7598376$var$keys(zip.files), o = [];
    for(var i = 0; i < k.length; ++i)if (k[i].slice(-1) != '/') o.push(k[i].replace(/^Root Entry[\/]/, ""));
    return o.sort();
}
function $a1a91b25d7598376$var$zip_add_file(zip, path, content) {
    if (zip.FullPaths) {
        if (Array.isArray(content) && typeof content[0] == "string") content = content.join("");
        if (typeof content == "string") {
            var res;
            if ($a1a91b25d7598376$var$has_buf) res = $a1a91b25d7598376$var$Buffer_from(content);
            else res = $a1a91b25d7598376$var$utf8decode(content);
            return $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(zip, path, res);
        }
        $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(zip, path, content);
    } else zip.file(path, content);
}
function $a1a91b25d7598376$var$zip_new() {
    return $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new();
}
function $a1a91b25d7598376$var$zip_read(d, o) {
    switch(o.type){
        case "base64":
            return $a1a91b25d7598376$export$9f0e51cd97c572a.read(d, {
                type: "base64"
            });
        case "binary":
            return $a1a91b25d7598376$export$9f0e51cd97c572a.read(d, {
                type: "binary"
            });
        case "buffer":
        case "array":
            return $a1a91b25d7598376$export$9f0e51cd97c572a.read(d, {
                type: "buffer"
            });
    }
    throw new Error("Unrecognized type " + o.type);
}
function $a1a91b25d7598376$var$resolve_path(path /*:string*/ , base /*:string*/ ) /*:string*/ {
    if (path.charAt(0) == "/") return path.slice(1);
    var result = base.split('/');
    if (base.slice(-1) != "/") result.pop(); // folder path
    var target = path.split('/');
    while(target.length !== 0){
        var step = target.shift();
        if (step === '..') result.pop();
        else if (step !== '.') result.push(step);
    }
    return result.join('/');
}
var $a1a91b25d7598376$var$XML_HEADER = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>\r\n';
var $a1a91b25d7598376$var$attregexg = /\s([^"\s?>\/]+)\s*=\s*((?:")([^"]*)(?:")|(?:')([^']*)(?:')|([^'">\s]+))/g;
var $a1a91b25d7598376$var$tagregex1 = /<[\/\?]?[a-zA-Z0-9:_-]+(?:\s+[^"\s?<>\/]+\s*=\s*(?:"[^"]*"|'[^']*'|[^'"<>\s=]+))*\s*[\/\?]?>/mg, $a1a91b25d7598376$var$tagregex2 = /<[^<>]*>/g;
var $a1a91b25d7598376$var$tagregex = /*#__PURE__*/ $a1a91b25d7598376$var$XML_HEADER.match($a1a91b25d7598376$var$tagregex1) ? $a1a91b25d7598376$var$tagregex1 : $a1a91b25d7598376$var$tagregex2;
var $a1a91b25d7598376$var$nsregex = /<\w*:/, $a1a91b25d7598376$var$nsregex2 = /<(\/?)\w+:/;
function $a1a91b25d7598376$var$parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        for(j = 0; j != q.length; ++j)if (q.charCodeAt(j) === 58) break;
        if (j === q.length) {
            if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
            z[q] = v;
            if (!skip_LC) z[q.toLowerCase()] = v;
        } else {
            var k = (j === 5 && q.slice(0, 5) === "xmlns" ? "xmlns" : "") + q.slice(j + 1);
            if (z[k] && q.slice(j - 3, j) == "ext") continue; // from ods
            z[k] = v;
            if (!skip_LC) z[k.toLowerCase()] = v;
        }
    }
    return z;
}
function $a1a91b25d7598376$var$parsexmltagraw(tag /*:string*/ , skip_root /*:?boolean*/ , skip_LC /*:?boolean*/ ) /*:any*/ {
    var z = {} /*:any*/ ;
    var eq = 0, c = 0;
    for(; eq !== tag.length; ++eq)if ((c = tag.charCodeAt(eq)) === 32 || c === 10 || c === 13) break;
    if (!skip_root) z[0] = tag.slice(0, eq);
    if (eq === tag.length) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg), j = 0, v = "", i = 0, q = "", cc = "", quot = 1;
    if (m) for(i = 0; i != m.length; ++i){
        cc = m[i].slice(1);
        for(c = 0; c != cc.length; ++c)if (cc.charCodeAt(c) === 61) break;
        q = cc.slice(0, c).trim();
        while(cc.charCodeAt(c + 1) == 32)++c;
        quot = (eq = cc.charCodeAt(c + 1)) == 34 || eq == 39 ? 1 : 0;
        v = cc.slice(c + 1 + quot, cc.length - quot);
        if (q.indexOf("_") > 0) q = q.slice(0, q.indexOf("_")); // from ods
        z[q] = v;
        if (!skip_LC) z[q.toLowerCase()] = v;
    }
    return z;
}
function $a1a91b25d7598376$var$strip_ns(x /*:string*/ ) /*:string*/ {
    return x.replace($a1a91b25d7598376$var$nsregex2, "<$1");
}
var $a1a91b25d7598376$var$encodings = {
    '&quot;': '"',
    '&apos;': "'",
    '&gt;': '>',
    '&lt;': '<',
    '&amp;': '&'
};
var $a1a91b25d7598376$var$rencoding = /*#__PURE__*/ $a1a91b25d7598376$var$evert($a1a91b25d7598376$var$encodings);
//var rencstr = "&<>'\"".split("");
// TODO: CP remap (need to read file version to determine OS)
var $a1a91b25d7598376$var$unescapexml /*:StringConv*/  = /*#__PURE__*/ function() {
    /* 22.4.2.4 bstr (Basic String) */ var encregex = /&(?:quot|apos|gt|lt|amp|#x?([\da-fA-F]+));/ig, coderegex = /_x([\da-fA-F]{4})_/ig;
    function raw_unescapexml(text /*:string*/ ) /*:string*/ {
        var s = text + '', i = s.indexOf("<![CDATA[");
        if (i == -1) return s.replace(encregex, function($$, $1) {
            return $a1a91b25d7598376$var$encodings[$$] || String.fromCharCode(parseInt($1, $$.indexOf("x") > -1 ? 16 : 10)) || $$;
        }).replace(coderegex, function(m, c) {
            return String.fromCharCode(parseInt(c, 16));
        });
        var j = s.indexOf("]]>");
        return raw_unescapexml(s.slice(0, i)) + s.slice(i + 9, j) + raw_unescapexml(s.slice(j + 3));
    }
    return function unescapexml(text /*:string*/ , xlsx /*:boolean*/ ) {
        var out = raw_unescapexml(text);
        return xlsx ? out.replace(/\r\n/g, "\n") : out;
    };
}();
var $a1a91b25d7598376$var$decregex = /[&<>'"]/g, $a1a91b25d7598376$var$charegex = /[\u0000-\u0008\u000b-\u001f\uFFFE-\uFFFF]/g;
function $a1a91b25d7598376$var$escapexml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($a1a91b25d7598376$var$decregex, function(y) {
        return $a1a91b25d7598376$var$rencoding[y];
    }).replace($a1a91b25d7598376$var$charegex, function(s) {
        return "_x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + "_";
    });
}
function $a1a91b25d7598376$var$escapexmltag(text /*:string*/ ) /*:string*/ {
    return $a1a91b25d7598376$var$escapexml(text).replace(/ /g, "_x0020_");
}
var $a1a91b25d7598376$var$htmlcharegex = /[\u0000-\u001f]/g;
function $a1a91b25d7598376$var$escapehtml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($a1a91b25d7598376$var$decregex, function(y) {
        return $a1a91b25d7598376$var$rencoding[y];
    }).replace(/\n/g, "<br/>").replace($a1a91b25d7598376$var$htmlcharegex, function(s) {
        return "&#x" + ("000" + s.charCodeAt(0).toString(16)).slice(-4) + ";";
    });
}
function $a1a91b25d7598376$var$escapexlml(text /*:string*/ ) /*:string*/ {
    var s = text + '';
    return s.replace($a1a91b25d7598376$var$decregex, function(y) {
        return $a1a91b25d7598376$var$rencoding[y];
    }).replace($a1a91b25d7598376$var$htmlcharegex, function(s) {
        return "&#x" + s.charCodeAt(0).toString(16).toUpperCase() + ";";
    });
}
/* TODO: handle codepages */ var $a1a91b25d7598376$var$xlml_fixstr /*:StringConv*/  = /*#__PURE__*/ function() {
    var entregex = /&#(\d+);/g;
    function entrepl($$ /*:string*/ , $1 /*:string*/ ) /*:string*/ {
        return String.fromCharCode(parseInt($1, 10));
    }
    return function xlml_fixstr(str /*:string*/ ) /*:string*/ {
        return str.replace(entregex, entrepl);
    };
}();
function $a1a91b25d7598376$var$xlml_unfixstr(str /*:string*/ ) /*:string*/ {
    return str.replace(/(\r\n|[\r\n])/g, "\&#10;");
}
/* note: xsd:boolean valid values: true / 1 / false / 0 */ function $a1a91b25d7598376$var$parsexmlbool(value /*:any*/ ) /*:boolean*/ {
    switch(value){
        case 1:
        case true:
        case '1':
        case 'true':
            return true;
        case 0:
        case false:
        case '0':
        case 'false':
            return false;
    }
    return false;
}
function $a1a91b25d7598376$var$utf8reada(orig /*:string*/ ) /*:string*/ {
    var out = "", i = 0, c = 0, d = 0, e = 0, f = 0, w = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        if (c < 128) {
            out += String.fromCharCode(c);
            continue;
        }
        d = orig.charCodeAt(i++);
        if (c > 191 && c < 224) {
            f = (c & 31) << 6;
            f |= d & 63;
            out += String.fromCharCode(f);
            continue;
        }
        e = orig.charCodeAt(i++);
        if (c < 240) {
            out += String.fromCharCode((c & 15) << 12 | (d & 63) << 6 | e & 63);
            continue;
        }
        f = orig.charCodeAt(i++);
        w = ((c & 7) << 18 | (d & 63) << 12 | (e & 63) << 6 | f & 63) - 65536;
        out += String.fromCharCode(0xD800 + (w >>> 10 & 1023));
        out += String.fromCharCode(0xDC00 + (w & 1023));
    }
    return out;
}
function $a1a91b25d7598376$var$utf8readb(data) {
    var out = $a1a91b25d7598376$var$new_raw_buf(2 * data.length), w, i, j = 1, k = 0, ww = 0, c;
    for(i = 0; i < data.length; i += j){
        j = 1;
        if ((c = data.charCodeAt(i)) < 128) w = c;
        else if (c < 224) {
            w = (c & 31) * 64 + (data.charCodeAt(i + 1) & 63);
            j = 2;
        } else if (c < 240) {
            w = (c & 15) * 4096 + (data.charCodeAt(i + 1) & 63) * 64 + (data.charCodeAt(i + 2) & 63);
            j = 3;
        } else {
            j = 4;
            w = (c & 7) * 262144 + (data.charCodeAt(i + 1) & 63) * 4096 + (data.charCodeAt(i + 2) & 63) * 64 + (data.charCodeAt(i + 3) & 63);
            w -= 65536;
            ww = 0xD800 + (w >>> 10 & 1023);
            w = 0xDC00 + (w & 1023);
        }
        if (ww !== 0) {
            out[k++] = ww & 255;
            out[k++] = ww >>> 8;
            ww = 0;
        }
        out[k++] = w % 256;
        out[k++] = w >>> 8;
    }
    return out.slice(0, k).toString('ucs2');
}
function $a1a91b25d7598376$var$utf8readc(data) {
    return $a1a91b25d7598376$var$Buffer_from(data, 'binary').toString('utf8');
}
var $a1a91b25d7598376$var$utf8corpus = "foo bar baz\u00e2\u0098\u0083\u00f0\u009f\u008d\u00a3";
var $a1a91b25d7598376$var$utf8read = $a1a91b25d7598376$var$has_buf && /*#__PURE__*/ ($a1a91b25d7598376$var$utf8readc($a1a91b25d7598376$var$utf8corpus) == /*#__PURE__*/ $a1a91b25d7598376$var$utf8reada($a1a91b25d7598376$var$utf8corpus) && $a1a91b25d7598376$var$utf8readc || /*#__PURE__*/ $a1a91b25d7598376$var$utf8readb($a1a91b25d7598376$var$utf8corpus) == /*#__PURE__*/ $a1a91b25d7598376$var$utf8reada($a1a91b25d7598376$var$utf8corpus) && $a1a91b25d7598376$var$utf8readb) || $a1a91b25d7598376$var$utf8reada;
var $a1a91b25d7598376$var$utf8write /*:StringConv*/  = $a1a91b25d7598376$var$has_buf ? function(data) {
    return $a1a91b25d7598376$var$Buffer_from(data, 'utf8').toString("binary");
} : function(orig /*:string*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [], i = 0, c = 0, d = 0;
    while(i < orig.length){
        c = orig.charCodeAt(i++);
        switch(true){
            case c < 128:
                out.push(String.fromCharCode(c));
                break;
            case c < 2048:
                out.push(String.fromCharCode(192 + (c >> 6)));
                out.push(String.fromCharCode(128 + (c & 63)));
                break;
            case c >= 55296 && c < 57344:
                c -= 55296;
                d = orig.charCodeAt(i++) - 56320 + (c << 10);
                out.push(String.fromCharCode(240 + (d >> 18 & 7)));
                out.push(String.fromCharCode(144 + (d >> 12 & 63)));
                out.push(String.fromCharCode(128 + (d >> 6 & 63)));
                out.push(String.fromCharCode(128 + (d & 63)));
                break;
            default:
                out.push(String.fromCharCode(224 + (c >> 12)));
                out.push(String.fromCharCode(128 + (c >> 6 & 63)));
                out.push(String.fromCharCode(128 + (c & 63)));
        }
    }
    return out.join("");
};
var $a1a91b25d7598376$var$htmldecode /*:{(s:string):string}*/  = /*#__PURE__*/ function() {
    var entities /*:Array<[RegExp, string]>*/  = [
        [
            'nbsp',
            ' '
        ],
        [
            'middot',
            "\xb7"
        ],
        [
            'quot',
            '"'
        ],
        [
            'apos',
            "'"
        ],
        [
            'gt',
            '>'
        ],
        [
            'lt',
            '<'
        ],
        [
            'amp',
            '&'
        ]
    ].map(function(x /*:[string, string]*/ ) {
        return [
            new RegExp('&' + x[0] + ';', "ig"),
            x[1]
        ];
    });
    return function htmldecode(str /*:string*/ ) /*:string*/ {
        var o = str// Remove new lines and spaces from start of content
        .replace(/^[\t\n\r ]+/, "")// Remove new lines and spaces from end of content
        .replace(/(^|[^\t\n\r ])[\t\n\r ]+$/, "$1")// Added line which removes any white space characters after and before html tags
        .replace(/>\s+/g, ">").replace(/\b\s+</g, "<")// Replace remaining new lines and spaces with space
        .replace(/[\t\n\r ]+/g, " ")// Replace <br> tags with new lines
        .replace(/<\s*[bB][rR]\s*\/?>/g, "\n")// Strip HTML elements
        .replace(/<[^<>]*>/g, "");
        for(var i = 0; i < entities.length; ++i)o = o.replace(entities[i][0], entities[i][1]);
        return o;
    };
}();
var $a1a91b25d7598376$var$vtvregex = /<\/?(?:vt:)?variant>/g, $a1a91b25d7598376$var$vtmregex = /<(?:vt:)([^<"'>]*)>([\s\S]*)</;
function $a1a91b25d7598376$var$parseVector(data /*:string*/ , opts) /*:Array<{v:string,t:string}>*/ {
    var h = $a1a91b25d7598376$var$parsexmltag(data);
    var matches /*:Array<string>*/  = $a1a91b25d7598376$var$str_match_xml_ns_g(data, h.baseType) || [];
    var res /*:Array<any>*/  = [];
    if (matches.length != h.size) {
        if (opts.WTF) throw new Error("unexpected vector length " + matches.length + " != " + h.size);
        return res;
    }
    matches.forEach(function(x /*:string*/ ) {
        var v = x.replace($a1a91b25d7598376$var$vtvregex, "").match($a1a91b25d7598376$var$vtmregex);
        if (v) res.push({
            v: $a1a91b25d7598376$var$utf8read(v[2]),
            t: v[1]
        });
    });
    return res;
}
var $a1a91b25d7598376$var$wtregex = /(^\s|\s$|\n)/;
function $a1a91b25d7598376$var$writetag(f /*:string*/ , g /*:string*/ ) /*:string*/ {
    return '<' + f + (g.match($a1a91b25d7598376$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f + '>';
}
function $a1a91b25d7598376$var$wxt_helper(h) /*:string*/ {
    return $a1a91b25d7598376$var$keys(h).map(function(k) {
        return " " + k + '="' + h[k] + '"';
    }).join("");
}
function $a1a91b25d7598376$var$writextag(f /*:string*/ , g /*:?string*/ , h) {
    return '<' + f + (h != null ? $a1a91b25d7598376$var$wxt_helper(h) : "") + (g != null ? (g.match($a1a91b25d7598376$var$wtregex) ? ' xml:space="preserve"' : "") + '>' + g + '</' + f : "/") + '>';
}
function $a1a91b25d7598376$var$write_w3cdtf(d /*:Date*/ , t /*:?boolean*/ ) /*:string*/ {
    try {
        return d.toISOString().replace(/\.\d*/, "");
    } catch (e) {
        if (t) throw e;
    }
    return "";
}
function $a1a91b25d7598376$var$write_vt(s, xlsx /*:?boolean*/ ) /*:string*/ {
    switch(typeof s){
        case 'string':
            var o = $a1a91b25d7598376$var$writextag('vt:lpwstr', $a1a91b25d7598376$var$escapexml(s));
            if (xlsx) o = o.replace(/&quot;/g, "_x0022_");
            return o;
        case 'number':
            return $a1a91b25d7598376$var$writextag((s | 0) == s ? 'vt:i4' : 'vt:r8', $a1a91b25d7598376$var$escapexml(String(s)));
        case 'boolean':
            return $a1a91b25d7598376$var$writextag('vt:bool', s ? 'true' : 'false');
    }
    if (s instanceof Date) return $a1a91b25d7598376$var$writextag('vt:filetime', $a1a91b25d7598376$var$write_w3cdtf(s));
    throw new Error("Unable to serialize " + s);
}
function $a1a91b25d7598376$var$xlml_normalize(d) /*:string*/ {
    if ($a1a91b25d7598376$var$has_buf && /*::typeof Buffer !== "undefined" && d != null && d instanceof Buffer &&*/ $a1a91b25d7598376$require$Buffer.isBuffer(d)) return d.toString('utf8');
    if (typeof d === 'string') return d;
    /* duktape */ if (typeof Uint8Array !== 'undefined' && d instanceof Uint8Array) return $a1a91b25d7598376$var$utf8read($a1a91b25d7598376$var$a2s($a1a91b25d7598376$var$ab2a(d)));
    throw new Error("Bad input format: expected Buffer or string");
}
/* UOS uses CJK in tags, ODS uses invalid XML */ var $a1a91b25d7598376$var$xlmlregex = /<([\/]?)([^\s?><!\/:"]*:|)([^\s?<>:\/"]+)(?:\s+[^<>=?"'\s]+="[^"]*?")*\s*[\/]?>/mg;
var $a1a91b25d7598376$var$XMLNS = {
    CORE_PROPS: 'http://schemas.openxmlformats.org/package/2006/metadata/core-properties',
    CUST_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
    EXT_PROPS: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
    CT: 'http://schemas.openxmlformats.org/package/2006/content-types',
    RELS: 'http://schemas.openxmlformats.org/package/2006/relationships',
    TCMNT: 'http://schemas.microsoft.com/office/spreadsheetml/2018/threadedcomments',
    'dc': 'http://purl.org/dc/elements/1.1/',
    'dcterms': 'http://purl.org/dc/terms/',
    'dcmitype': 'http://purl.org/dc/dcmitype/',
    'mx': 'http://schemas.microsoft.com/office/mac/excel/2008/main',
    'r': 'http://schemas.openxmlformats.org/officeDocument/2006/relationships',
    'sjs': 'http://schemas.openxmlformats.org/package/2006/sheetjs/core-properties',
    'vt': 'http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes',
    'xsi': 'http://www.w3.org/2001/XMLSchema-instance',
    'xsd': 'http://www.w3.org/2001/XMLSchema'
} /*:any*/ ;
var $a1a91b25d7598376$var$XMLNS_main = [
    'http://schemas.openxmlformats.org/spreadsheetml/2006/main',
    'http://purl.oclc.org/ooxml/spreadsheetml/main',
    'http://schemas.microsoft.com/office/excel/2006/main',
    'http://schemas.microsoft.com/office/excel/2006/2'
];
var $a1a91b25d7598376$var$XLMLNS = {
    'o': 'urn:schemas-microsoft-com:office:office',
    'x': 'urn:schemas-microsoft-com:office:excel',
    'ss': 'urn:schemas-microsoft-com:office:spreadsheet',
    'dt': 'uuid:C2F41010-65B3-11d1-A29F-00AA00C14882',
    'mv': 'http://macVmlSchemaUri',
    'v': 'urn:schemas-microsoft-com:vml',
    'html': 'http://www.w3.org/TR/REC-html40'
} /*:any*/ ;
function $a1a91b25d7598376$var$read_double_le(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var s = 1 - 2 * (b[idx + 7] >>> 7);
    var e = ((b[idx + 7] & 0x7f) << 4) + (b[idx + 6] >>> 4 & 0x0f);
    var m = b[idx + 6] & 0x0f;
    for(var i = 5; i >= 0; --i)m = m * 256 + b[idx + i];
    if (e == 0x7ff) return m == 0 ? s * Infinity : NaN;
    if (e == 0) e = -1022;
    else {
        e -= 1023;
        m += Math.pow(2, 52);
    }
    return s * Math.pow(2, e - 52) * m;
}
function $a1a91b25d7598376$var$write_double_le(b /*:RawBytes|CFBlob*/ , v /*:number*/ , idx /*:number*/ ) {
    var bs = (v < 0 || 1 / v == -Infinity ? 1 : 0) << 7, e = 0, m = 0;
    var av = bs ? -v : v;
    if (!isFinite(av)) {
        e = 0x7ff;
        m = isNaN(v) ? 0x6969 : 0;
    } else if (av == 0) e = m = 0;
    else {
        e = Math.floor(Math.log(av) / Math.LN2);
        m = av * Math.pow(2, 52 - e);
        if (e <= -1023 && (!isFinite(m) || m < Math.pow(2, 52))) e = -1022;
        else {
            m -= Math.pow(2, 52);
            e += 1023;
        }
    }
    for(var i = 0; i <= 5; ++i, m /= 256)b[idx + i] = m & 0xff;
    b[idx + 6] = (e & 0x0f) << 4 | m & 0xf;
    b[idx + 7] = e >> 4 | bs;
}
var $a1a91b25d7598376$var$___toBuffer = function(bufs /*:Array<Array<RawBytes> >*/ ) /*:RawBytes*/ {
    var x = [], w = 10240;
    for(var i = 0; i < bufs[0].length; ++i)if (bufs[0][i]) for(var j = 0, L = bufs[0][i].length; j < L; j += w)x.push.apply(x, bufs[0][i].slice(j, j + w));
    return x;
};
var $a1a91b25d7598376$var$__toBuffer = $a1a91b25d7598376$var$has_buf ? function(bufs) {
    return bufs[0].length > 0 && $a1a91b25d7598376$require$Buffer.isBuffer(bufs[0][0]) ? $a1a91b25d7598376$require$Buffer.concat(bufs[0].map(function(x) {
        return $a1a91b25d7598376$require$Buffer.isBuffer(x) ? x : $a1a91b25d7598376$var$Buffer_from(x);
    })) : $a1a91b25d7598376$var$___toBuffer(bufs);
} : $a1a91b25d7598376$var$___toBuffer;
var $a1a91b25d7598376$var$___utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < e; i += 2)ss.push(String.fromCharCode($a1a91b25d7598376$var$__readUInt16LE(b, i)));
    return ss.join("").replace($a1a91b25d7598376$var$chr0, '');
};
var $a1a91b25d7598376$var$__utf16le = $a1a91b25d7598376$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) /*:string*/ {
    if (!$a1a91b25d7598376$require$Buffer.isBuffer(b) || !$a1a91b25d7598376$var$buf_utf16le) return $a1a91b25d7598376$var$___utf16le(b, s, e);
    return b.toString('utf16le', s, e).replace($a1a91b25d7598376$var$chr0, '') /*.replace(chr1,'!')*/ ;
} : $a1a91b25d7598376$var$___utf16le;
var $a1a91b25d7598376$var$___hexlify = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    var ss /*:Array<string>*/  = [];
    for(var i = s; i < s + l; ++i)ss.push(("0" + b[i].toString(16)).slice(-2));
    return ss.join("");
};
var $a1a91b25d7598376$var$__hexlify = $a1a91b25d7598376$var$has_buf ? function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , l /*:number*/ ) /*:string*/ {
    return $a1a91b25d7598376$require$Buffer.isBuffer(b) ? b.toString('hex', s, s + l) : $a1a91b25d7598376$var$___hexlify(b, s, l);
} : $a1a91b25d7598376$var$___hexlify;
var $a1a91b25d7598376$var$___utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    var ss = [];
    for(var i = s; i < e; i++)ss.push(String.fromCharCode($a1a91b25d7598376$var$__readUInt8(b, i)));
    return ss.join("");
};
var $a1a91b25d7598376$var$__utf8 = $a1a91b25d7598376$var$has_buf ? function utf8_b(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
    return $a1a91b25d7598376$require$Buffer.isBuffer(b) ? b.toString('utf8', s, e) : $a1a91b25d7598376$var$___utf8(b, s, e);
} : $a1a91b25d7598376$var$___utf8;
var $a1a91b25d7598376$var$___lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $a1a91b25d7598376$var$__lpstr = $a1a91b25d7598376$var$___lpstr;
var $a1a91b25d7598376$var$___cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $a1a91b25d7598376$var$__cpstr = $a1a91b25d7598376$var$___cpstr;
var $a1a91b25d7598376$var$___lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = 2 * $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len - 1) : "";
};
var $a1a91b25d7598376$var$__lpwstr = $a1a91b25d7598376$var$___lpwstr;
var $a1a91b25d7598376$var$___lpp4 = function lpp4_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf16le(b, i + 4, i + 4 + len) : "";
};
var $a1a91b25d7598376$var$__lpp4 = $a1a91b25d7598376$var$___lpp4;
var $a1a91b25d7598376$var$___8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
    var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
    return len > 0 ? $a1a91b25d7598376$var$__utf8(b, i + 4, i + 4 + len) : "";
};
var $a1a91b25d7598376$var$__8lpp4 = $a1a91b25d7598376$var$___8lpp4;
var $a1a91b25d7598376$var$___double = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) {
    return $a1a91b25d7598376$var$read_double_le(b, idx);
};
var $a1a91b25d7598376$var$__double = $a1a91b25d7598376$var$___double;
var $a1a91b25d7598376$var$is_buf = function is_buf_a(a) {
    return Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
};
if ($a1a91b25d7598376$var$has_buf /*:: && typeof Buffer !== 'undefined'*/ ) {
    $a1a91b25d7598376$var$__lpstr = function lpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b)) return $a1a91b25d7598376$var$___lpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $a1a91b25d7598376$var$__cpstr = function cpstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b)) return $a1a91b25d7598376$var$___cpstr(b, i);
        var len = b.readUInt32LE(i);
        return len > 0 ? b.toString('utf8', i + 4, i + 4 + len - 1) : "";
    };
    $a1a91b25d7598376$var$__lpwstr = function lpwstr_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b) || !$a1a91b25d7598376$var$buf_utf16le) return $a1a91b25d7598376$var$___lpwstr(b, i);
        var len = 2 * b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len - 1);
    };
    $a1a91b25d7598376$var$__lpp4 = function lpp4_b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b) || !$a1a91b25d7598376$var$buf_utf16le) return $a1a91b25d7598376$var$___lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf16le', i + 4, i + 4 + len);
    };
    $a1a91b25d7598376$var$__8lpp4 = function lpp4_8b(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if (!$a1a91b25d7598376$require$Buffer.isBuffer(b)) return $a1a91b25d7598376$var$___8lpp4(b, i);
        var len = b.readUInt32LE(i);
        return b.toString('utf8', i + 4, i + 4 + len);
    };
    $a1a91b25d7598376$var$__double = function double_(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        if ($a1a91b25d7598376$require$Buffer.isBuffer(b)) return b.readDoubleLE(i);
        return $a1a91b25d7598376$var$___double(b, i);
    };
    $a1a91b25d7598376$var$is_buf = function is_buf_b(a) {
        return $a1a91b25d7598376$require$Buffer.isBuffer(a) || Array.isArray(a) || typeof Uint8Array !== "undefined" && a instanceof Uint8Array;
    };
}
/* from js-xls */ function $a1a91b25d7598376$var$cpdoit() {
    $a1a91b25d7598376$var$__utf16le = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $a1a91b25d7598376$var$$cptable.utils.decode(1200, b.slice(s, e)).replace($a1a91b25d7598376$var$chr0, '');
    };
    $a1a91b25d7598376$var$__utf8 = function(b /*:RawBytes|CFBlob*/ , s /*:number*/ , e /*:number*/ ) {
        return $a1a91b25d7598376$var$$cptable.utils.decode(65001, b.slice(s, e));
    };
    $a1a91b25d7598376$var$__lpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_ansi, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $a1a91b25d7598376$var$__cpstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $a1a91b25d7598376$var$__lpwstr = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = 2 * $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len - 1)) : "";
    };
    $a1a91b25d7598376$var$__lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode(1200, b.slice(i + 4, i + 4 + len)) : "";
    };
    $a1a91b25d7598376$var$__8lpp4 = function(b /*:RawBytes|CFBlob*/ , i /*:number*/ ) {
        var len = $a1a91b25d7598376$var$__readUInt32LE(b, i);
        return len > 0 ? $a1a91b25d7598376$var$$cptable.utils.decode(65001, b.slice(i + 4, i + 4 + len)) : "";
    };
}
if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined') $a1a91b25d7598376$var$cpdoit();
var $a1a91b25d7598376$var$__readUInt8 = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx];
};
var $a1a91b25d7598376$var$__readUInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 1] * 256 + b[idx];
};
var $a1a91b25d7598376$var$__readInt16LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    var u = b[idx + 1] * 256 + b[idx];
    return u < 0x8000 ? u : (0xffff - u + 1) * -1;
};
var $a1a91b25d7598376$var$__readUInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] * 16777216 + (b[idx + 2] << 16) + (b[idx + 1] << 8) + b[idx];
};
var $a1a91b25d7598376$var$__readInt32LE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx + 3] << 24 | b[idx + 2] << 16 | b[idx + 1] << 8 | b[idx];
};
var $a1a91b25d7598376$var$__readInt32BE = function(b /*:RawBytes|CFBlob*/ , idx /*:number*/ ) /*:number*/ {
    return b[idx] << 24 | b[idx + 1] << 16 | b[idx + 2] << 8 | b[idx + 3];
};
function $a1a91b25d7598376$var$ReadShift(size /*:number*/ , t /*:?string*/ ) /*:number|string*/ {
    var o = "", oI /*:: :number = 0*/ , oR, oo = [], w, vv, i, loc;
    switch(t){
        case 'dbcs':
            loc = this.l;
            if ($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(this) && $a1a91b25d7598376$var$buf_utf16le) o = this.slice(this.l, this.l + 2 * size).toString("utf16le");
            else for(i = 0; i < size; ++i){
                o += String.fromCharCode($a1a91b25d7598376$var$__readUInt16LE(this, loc));
                loc += 2;
            }
            size *= 2;
            break;
        case 'utf8':
            o = $a1a91b25d7598376$var$__utf8(this, this.l, this.l + size);
            break;
        case 'utf16le':
            size *= 2;
            o = $a1a91b25d7598376$var$__utf16le(this, this.l, this.l + size);
            break;
        case 'wstr':
            if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined') o = $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, this.slice(this.l, this.l + 2 * size));
            else return $a1a91b25d7598376$var$ReadShift.call(this, size, 'dbcs');
            size = 2 * size;
            break;
        /* [MS-OLEDS] 2.1.4 LengthPrefixedAnsiString */ case 'lpstr-ansi':
            o = $a1a91b25d7598376$var$__lpstr(this, this.l);
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            break;
        case 'lpstr-cp':
            o = $a1a91b25d7598376$var$__cpstr(this, this.l);
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OLEDS] 2.1.5 LengthPrefixedUnicodeString */ case 'lpwstr':
            o = $a1a91b25d7598376$var$__lpwstr(this, this.l);
            size = 4 + 2 * $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            break;
        /* [MS-OFFCRYPTO] 2.1.2 Length-Prefixed Padded Unicode String (UNICODE-LP-P4) */ case 'lpp4':
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            o = $a1a91b25d7598376$var$__lpp4(this, this.l);
            if (size & 0x02) size += 2;
            break;
        /* [MS-OFFCRYPTO] 2.1.3 Length-Prefixed UTF-8 String (UTF-8-LP-P4) */ case '8lpp4':
            size = 4 + $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
            o = $a1a91b25d7598376$var$__8lpp4(this, this.l);
            if (size & 0x03) size += 4 - (size & 0x03);
            break;
        case 'cstr':
            size = 0;
            o = "";
            while((w = $a1a91b25d7598376$var$__readUInt8(this, this.l + size++)) !== 0)oo.push($a1a91b25d7598376$var$_getchar(w));
            o = oo.join("");
            break;
        case '_wstr':
            size = 0;
            o = "";
            while((w = $a1a91b25d7598376$var$__readUInt16LE(this, this.l + size)) !== 0){
                oo.push($a1a91b25d7598376$var$_getchar(w));
                size += 2;
            }
            size += 2;
            o = oo.join("");
            break;
        /* sbcs and dbcs support continue records in the SST way TODO codepages */ case 'dbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i < size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $a1a91b25d7598376$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $a1a91b25d7598376$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($a1a91b25d7598376$var$_getchar($a1a91b25d7598376$var$__readUInt16LE(this, loc)));
                loc += 2;
            }
            o = oo.join("");
            size *= 2;
            break;
        case 'cpstr':
            if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined') {
                o = $a1a91b25d7598376$var$$cptable.utils.decode($a1a91b25d7598376$var$current_codepage, this.slice(this.l, this.l + size));
                break;
            }
        /* falls through */ case 'sbcs-cont':
            o = "";
            loc = this.l;
            for(i = 0; i != size; ++i){
                if (this.lens && this.lens.indexOf(loc) !== -1) {
                    w = $a1a91b25d7598376$var$__readUInt8(this, loc);
                    this.l = loc + 1;
                    vv = $a1a91b25d7598376$var$ReadShift.call(this, size - i, w ? 'dbcs-cont' : 'sbcs-cont');
                    return oo.join("") + vv;
                }
                oo.push($a1a91b25d7598376$var$_getchar($a1a91b25d7598376$var$__readUInt8(this, loc)));
                loc += 1;
            }
            o = oo.join("");
            break;
        default:
            switch(size){
                case 1:
                    oI = $a1a91b25d7598376$var$__readUInt8(this, this.l);
                    this.l++;
                    return oI;
                case 2:
                    oI = (t === 'i' ? $a1a91b25d7598376$var$__readInt16LE : $a1a91b25d7598376$var$__readUInt16LE)(this, this.l);
                    this.l += 2;
                    return oI;
                case 4:
                case -4:
                    if (t === 'i' || (this[this.l + 3] & 0x80) === 0) {
                        oI = (size > 0 ? $a1a91b25d7598376$var$__readInt32LE : $a1a91b25d7598376$var$__readInt32BE)(this, this.l);
                        this.l += 4;
                        return oI;
                    } else {
                        oR = $a1a91b25d7598376$var$__readUInt32LE(this, this.l);
                        this.l += 4;
                    }
                    return oR;
                case 8:
                case -8:
                    if (t === 'f') {
                        if (size == 8) oR = $a1a91b25d7598376$var$__double(this, this.l);
                        else oR = $a1a91b25d7598376$var$__double([
                            this[this.l + 7],
                            this[this.l + 6],
                            this[this.l + 5],
                            this[this.l + 4],
                            this[this.l + 3],
                            this[this.l + 2],
                            this[this.l + 1],
                            this[this.l + 0]
                        ], 0);
                        this.l += 8;
                        return oR;
                    } else size = 8;
                /* falls through */ case 16:
                    o = $a1a91b25d7598376$var$__hexlify(this, this.l, size);
                    break;
            }
    }
    this.l += size;
    return o;
}
var $a1a91b25d7598376$var$__writeUInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
    b[idx + 2] = val1 >>> 16 & 0xFF;
    b[idx + 3] = val1 >>> 24 & 0xFF;
};
var $a1a91b25d7598376$var$__writeInt32LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >> 8 & 0xFF;
    b[idx + 2] = val1 >> 16 & 0xFF;
    b[idx + 3] = val1 >> 24 & 0xFF;
};
var $a1a91b25d7598376$var$__writeUInt16LE = function(b /*:RawBytes|CFBlob*/ , val1 /*:number*/ , idx /*:number*/ ) /*:void*/ {
    b[idx] = val1 & 0xFF;
    b[idx + 1] = val1 >>> 8 & 0xFF;
};
function $a1a91b25d7598376$var$WriteShift(t /*:number*/ , val1 /*:string|number*/ , f /*:?string*/ ) /*:any*/ {
    var size = 0, i = 0;
    if (f === 'dbcs') {
        /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)$a1a91b25d7598376$var$__writeUInt16LE(this, val1.charCodeAt(i), this.l + 2 * i);
        size = 2 * val1.length;
    } else if (f === 'sbcs' || f == 'cpstr') {
        if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined' && $a1a91b25d7598376$var$current_ansi == 874) {
            /* TODO: use tables directly, don't encode */ /*:: if(typeof val !== "string") throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i){
                var cpp = $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_ansi, val1.charAt(i));
                this[this.l + i] = cpp[0];
            }
            size = val1.length;
        } else if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined' && f == 'cpstr') {
            cpp = $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_codepage, val1);
            /* replace null bytes with _ when relevant */ if (cpp.length == val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[i] == 0 && val1.charCodeAt(i) != 0) cpp[i] = 0x5F;
            }
            if (cpp.length == 2 * val1.length) {
                for(i = 0; i < val1.length; ++i)if (cpp[2 * i] == 0 && cpp[2 * i + 1] == 0 && val1.charCodeAt(i) != 0) cpp[2 * i] = 0x5F;
            }
            for(i = 0; i < cpp.length; ++i)this[this.l + i] = cpp[i];
            size = cpp.length;
        } else {
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ val1 = val1.replace(/[^\x00-\x7F]/g, "_");
            /*:: if(typeof val !== 'string') throw new Error("unreachable"); */ for(i = 0; i != val1.length; ++i)this[this.l + i] = val1.charCodeAt(i) & 0xFF;
            size = val1.length;
        }
    } else if (f === 'hex') {
        for(; i < t; ++i)/*:: if(typeof val !== "string") throw new Error("unreachable"); */ this[this.l++] = parseInt(val1.slice(2 * i, 2 * i + 2), 16) || 0;
        return this;
    } else if (f === 'utf16le') {
        /*:: if(typeof val !== "string") throw new Error("unreachable"); */ var end /*:number*/  = Math.min(this.l + t, this.length);
        for(i = 0; i < Math.min(val1.length, t); ++i){
            var cc = val1.charCodeAt(i);
            this[this.l++] = cc & 0xff;
            this[this.l++] = cc >> 8;
        }
        while(this.l < end)this[this.l++] = 0;
        return this;
    } else /*:: if(typeof val === 'number') */ switch(t){
        case 1:
            size = 1;
            this[this.l] = val1 & 0xFF;
            break;
        case 2:
            size = 2;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            break;
        case 3:
            size = 3;
            this[this.l] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 1] = val1 & 0xFF;
            val1 >>>= 8;
            this[this.l + 2] = val1 & 0xFF;
            break;
        case 4:
            size = 4;
            $a1a91b25d7598376$var$__writeUInt32LE(this, val1, this.l);
            break;
        case 8:
            size = 8;
            if (f === 'f') {
                $a1a91b25d7598376$var$write_double_le(this, val1, this.l);
                break;
            }
        /* falls through */ case 16:
            break;
        case -4:
            size = 4;
            $a1a91b25d7598376$var$__writeInt32LE(this, val1, this.l);
            break;
    }
    this.l += size;
    return this;
}
function $a1a91b25d7598376$var$CheckField(hexstr /*:string*/ , fld /*:string*/ ) /*:void*/ {
    var m = $a1a91b25d7598376$var$__hexlify(this, this.l, hexstr.length >> 1);
    if (m !== hexstr) throw new Error(fld + 'Expected ' + hexstr + ' saw ' + m);
    this.l += hexstr.length >> 1;
}
function $a1a91b25d7598376$var$prep_blob(blob, pos /*:number*/ ) /*:void*/ {
    blob.l = pos;
    blob.read_shift = /*::(*/ $a1a91b25d7598376$var$ReadShift /*:: :any)*/ ;
    blob.chk = $a1a91b25d7598376$var$CheckField;
    blob.write_shift = $a1a91b25d7598376$var$WriteShift;
}
function $a1a91b25d7598376$var$parsenoop(blob, length /*:: :number, opts?:any */ ) {
    blob.l += length;
}
function $a1a91b25d7598376$var$new_buf(sz /*:number*/ ) /*:Block*/ {
    var o = $a1a91b25d7598376$var$new_raw_buf(sz);
    $a1a91b25d7598376$var$prep_blob(o, 0);
    return o;
}
/* [MS-XLSB] 2.1.4 Record */ function $a1a91b25d7598376$var$recordhopper(data, cb /*:RecordHopperCB*/ , opts /*:?any*/ ) {
    if (!data) return;
    var tmpbyte, cntbyte, length;
    $a1a91b25d7598376$var$prep_blob(data, data.l || 0);
    var L = data.length, RT = 0, tgt = 0;
    while(data.l < L){
        RT = data.read_shift(1);
        if (RT & 0x80) RT = (RT & 0x7F) + ((data.read_shift(1) & 0x7F) << 7);
        var R = $a1a91b25d7598376$var$XLSBRecordEnum[RT] || $a1a91b25d7598376$var$XLSBRecordEnum[0xFFFF];
        tmpbyte = data.read_shift(1);
        length = tmpbyte & 0x7F;
        for(cntbyte = 1; cntbyte < 4 && tmpbyte & 0x80; ++cntbyte)length += ((tmpbyte = data.read_shift(1)) & 0x7F) << 7 * cntbyte;
        tgt = data.l + length;
        var d = R.f && R.f(data, length, opts);
        data.l = tgt;
        if (cb(d, R, RT)) return;
    }
}
/* control buffer usage for fixed-length buffers */ function $a1a91b25d7598376$var$buf_array() /*:BufArray*/ {
    var bufs /*:Array<Block>*/  = [], blksz = $a1a91b25d7598376$var$has_buf ? 16384 : 2048;
    var has_buf_copy = $a1a91b25d7598376$var$has_buf && typeof $a1a91b25d7598376$var$new_buf(blksz).copy == "function";
    var newblk = function ba_newblk(sz /*:number*/ ) /*:Block*/ {
        var o /*:Block*/  = $a1a91b25d7598376$var$new_buf(sz);
        $a1a91b25d7598376$var$prep_blob(o, 0);
        return o;
    };
    var curbuf /*:Block*/  = newblk(blksz);
    var endbuf = function ba_endbuf() {
        if (!curbuf) return;
        // workaround for new Buffer(3).slice(0,0) bug in bun 0.1.3
        if (curbuf.l) {
            if (curbuf.length > curbuf.l) {
                curbuf = curbuf.slice(0, curbuf.l);
                curbuf.l = curbuf.length;
            }
            if (curbuf.length > 0) bufs.push(curbuf);
        }
        curbuf = null;
    };
    var next = function ba_next(sz /*:number*/ ) /*:Block*/ {
        if (curbuf && sz < curbuf.length - curbuf.l) return curbuf;
        endbuf();
        return curbuf = newblk(Math.max(sz + 1, blksz));
    };
    var end = function ba_end() {
        endbuf();
        return $a1a91b25d7598376$var$bconcat(bufs);
    };
    var end2 = function() {
        endbuf();
        return bufs;
    };
    var push = function ba_push(buf) {
        endbuf();
        curbuf = buf;
        if (curbuf.l == null) curbuf.l = curbuf.length;
        next(blksz);
    };
    return {
        next: next,
        push: push,
        end: end,
        _bufs: bufs,
        end2: end2
    } /*:any*/ ;
}
function $a1a91b25d7598376$var$write_record(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) {
    var t /*:number*/  = +type, l;
    if (isNaN(t)) return; // TODO: throw something here?
    if (!length) length = $a1a91b25d7598376$var$XLSBRecordEnum[t].p || (payload || []).length || 0;
    l = 1 + (t >= 0x80 ? 1 : 0) + 1 /* + length*/ ;
    if (length >= 0x80) ++l;
    if (length >= 0x4000) ++l;
    if (length >= 0x200000) ++l;
    var o = ba.next(l);
    if (t <= 0x7F) o.write_shift(1, t);
    else {
        o.write_shift(1, (t & 0x7F) + 0x80);
        o.write_shift(1, t >> 7);
    }
    for(var i = 0; i != 4; ++i)if (length >= 0x80) {
        o.write_shift(1, (length & 0x7F) + 0x80);
        length >>= 7;
    } else {
        o.write_shift(1, length);
        break;
    }
    if (/*:: length != null &&*/ length > 0 && $a1a91b25d7598376$var$is_buf(payload)) ba.push(payload);
}
/* XLS ranges enforced */ function $a1a91b25d7598376$var$shift_cell_xls(cell /*:CellAddress*/ , tgt /*:any*/ , opts /*:?any*/ ) /*:CellAddress*/ {
    var out = $a1a91b25d7598376$var$dup(cell);
    if (tgt.s) {
        if (out.cRel) out.c += tgt.s.c;
        if (out.rRel) out.r += tgt.s.r;
    } else {
        if (out.cRel) out.c += tgt.c;
        if (out.rRel) out.r += tgt.r;
    }
    if (!opts || opts.biff < 12) {
        while(out.c >= 0x100)out.c -= 0x100;
        while(out.r >= 0x10000)out.r -= 0x10000;
    }
    return out;
}
function $a1a91b25d7598376$var$shift_range_xls(cell, range, opts) {
    var out = $a1a91b25d7598376$var$dup(cell);
    out.s = $a1a91b25d7598376$var$shift_cell_xls(out.s, range.s, opts);
    out.e = $a1a91b25d7598376$var$shift_cell_xls(out.e, range.s, opts);
    return out;
}
function $a1a91b25d7598376$var$encode_cell_xls(c /*:CellAddress*/ , biff /*:number*/ ) /*:string*/ {
    if (c.cRel && c.c < 0) {
        c = $a1a91b25d7598376$var$dup(c);
        while(c.c < 0)c.c += biff > 8 ? 0x4000 : 0x100;
    }
    if (c.rRel && c.r < 0) {
        c = $a1a91b25d7598376$var$dup(c);
        while(c.r < 0)c.r += biff > 8 ? 0x100000 : biff > 5 ? 0x10000 : 0x4000;
    }
    var s = $a1a91b25d7598376$var$encode_cell(c);
    if (!c.cRel && c.cRel != null) s = $a1a91b25d7598376$var$fix_col(s);
    if (!c.rRel && c.rRel != null) s = $a1a91b25d7598376$var$fix_row(s);
    return s;
}
function $a1a91b25d7598376$var$encode_range_xls(r, opts) /*:string*/ {
    if (r.s.r == 0 && !r.s.rRel) {
        if (r.e.r == (opts.biff >= 12 ? 0xFFFFF : opts.biff >= 8 ? 0x10000 : 0x4000) && !r.e.rRel) return (r.s.cRel ? "" : "$") + $a1a91b25d7598376$var$encode_col(r.s.c) + ":" + (r.e.cRel ? "" : "$") + $a1a91b25d7598376$var$encode_col(r.e.c);
    }
    if (r.s.c == 0 && !r.s.cRel) {
        if (r.e.c == (opts.biff >= 12 ? 0x3FFF : 0xFF) && !r.e.cRel) return (r.s.rRel ? "" : "$") + $a1a91b25d7598376$var$encode_row(r.s.r) + ":" + (r.e.rRel ? "" : "$") + $a1a91b25d7598376$var$encode_row(r.e.r);
    }
    return $a1a91b25d7598376$var$encode_cell_xls(r.s, opts.biff) + ":" + $a1a91b25d7598376$var$encode_cell_xls(r.e, opts.biff);
}
function $a1a91b25d7598376$var$decode_row(rowstr /*:string*/ ) /*:number*/ {
    return parseInt($a1a91b25d7598376$var$unfix_row(rowstr), 10) - 1;
}
function $a1a91b25d7598376$var$encode_row(row /*:number*/ ) /*:string*/ {
    return "" + (row + 1);
}
function $a1a91b25d7598376$var$fix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/([A-Z]|^)(\d+)$/, "$1$$$2");
}
function $a1a91b25d7598376$var$unfix_row(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/\$(\d+)$/, "$1");
}
function $a1a91b25d7598376$var$decode_col(colstr /*:string*/ ) /*:number*/ {
    var c = $a1a91b25d7598376$var$unfix_col(colstr), d = 0, i = 0;
    for(; i !== c.length; ++i)d = 26 * d + c.charCodeAt(i) - 64;
    return d - 1;
}
function $a1a91b25d7598376$var$encode_col(col /*:number*/ ) /*:string*/ {
    if (col < 0) throw new Error("invalid column " + col);
    var s = "";
    for(++col; col; col = Math.floor((col - 1) / 26))s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s;
}
function $a1a91b25d7598376$var$fix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^([A-Z])/, "$$$1");
}
function $a1a91b25d7598376$var$unfix_col(cstr /*:string*/ ) /*:string*/ {
    return cstr.replace(/^\$([A-Z])/, "$1");
}
function $a1a91b25d7598376$var$split_cell(cstr /*:string*/ ) /*:Array<string>*/ {
    return cstr.replace(/(\$?[A-Z]*)(\$?\d*)/, "$1,$2").split(",");
}
function $a1a91b25d7598376$var$decode_cell(cstr /*:string*/ ) /*:CellAddress*/ {
    var R = 0, C = 0;
    for(var i = 0; i < cstr.length; ++i){
        var cc = cstr.charCodeAt(i);
        if (cc >= 48 && cc <= 57) R = 10 * R + (cc - 48);
        else if (cc >= 65 && cc <= 90) C = 26 * C + (cc - 64);
    }
    return {
        c: C - 1,
        r: R - 1
    };
}
function $a1a91b25d7598376$var$encode_cell(cell /*:CellAddress*/ ) /*:string*/ {
    var col = cell.c + 1;
    var s = "";
    for(; col; col = (col - 1) / 26 | 0)s = String.fromCharCode((col - 1) % 26 + 65) + s;
    return s + (cell.r + 1);
}
function $a1a91b25d7598376$var$decode_range(range /*:string*/ ) /*:Range*/ {
    var idx = range.indexOf(":");
    if (idx == -1) return {
        s: $a1a91b25d7598376$var$decode_cell(range),
        e: $a1a91b25d7598376$var$decode_cell(range)
    };
    return {
        s: $a1a91b25d7598376$var$decode_cell(range.slice(0, idx)),
        e: $a1a91b25d7598376$var$decode_cell(range.slice(idx + 1))
    };
}
/*# if only one arg, it is assumed to be a Range.  If 2 args, both are cell addresses */ function $a1a91b25d7598376$var$encode_range(cs /*:CellAddrSpec|Range*/ , ce /*:?CellAddrSpec*/ ) /*:string*/ {
    if (typeof ce === 'undefined' || typeof ce === 'number') /*:: if(!(cs instanceof Range)) throw "unreachable"; */ return $a1a91b25d7598376$var$encode_range(cs.s, cs.e);
    /*:: if((cs instanceof Range)) throw "unreachable"; */ if (typeof cs !== 'string') cs = $a1a91b25d7598376$var$encode_cell(cs /*:any*/ );
    if (typeof ce !== 'string') ce = $a1a91b25d7598376$var$encode_cell(ce /*:any*/ );
    /*:: if(typeof cs !== 'string') throw "unreachable"; */ /*:: if(typeof ce !== 'string') throw "unreachable"; */ return cs == ce ? cs : cs + ":" + ce;
}
function $a1a91b25d7598376$var$fix_range(a1 /*:string*/ ) /*:string*/ {
    var s = $a1a91b25d7598376$var$decode_range(a1);
    return "$" + $a1a91b25d7598376$var$encode_col(s.s.c) + "$" + $a1a91b25d7598376$var$encode_row(s.s.r) + ":$" + $a1a91b25d7598376$var$encode_col(s.e.c) + "$" + $a1a91b25d7598376$var$encode_row(s.e.r);
}
// List of invalid characters needs to be tested further
function $a1a91b25d7598376$var$formula_quote_sheet_name(sname /*:string*/ , opts) /*:string*/ {
    if (!sname && !(opts && opts.biff <= 5 && opts.biff >= 2)) throw new Error("empty sheet name");
    if (/[^\w\u4E00-\u9FFF\u3040-\u30FF]/.test(sname)) return "'" + sname.replace(/'/g, "''") + "'";
    return sname;
}
function $a1a91b25d7598376$var$safe_decode_range(range /*:string*/ ) /*:Range*/ {
    var o = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var idx = 0, i = 0, cc = 0;
    var len = range.length;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.s.c = --idx;
    for(idx = 0; i < len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.s.r = --idx;
    if (i === len || cc != 10) {
        o.e.c = o.s.c;
        o.e.r = o.s.r;
        return o;
    }
    ++i;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 64) < 1 || cc > 26) break;
        idx = 26 * idx + cc;
    }
    o.e.c = --idx;
    for(idx = 0; i != len; ++i){
        if ((cc = range.charCodeAt(i) - 48) < 0 || cc > 9) break;
        idx = 10 * idx + cc;
    }
    o.e.r = --idx;
    return o;
}
function $a1a91b25d7598376$var$safe_format_cell(cell /*:Cell*/ , v /*:any*/ ) {
    var q = cell.t == 'd' && v instanceof Date;
    if (cell.z != null) try {
        return cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, q ? $a1a91b25d7598376$var$datenum(v) : v);
    } catch (e) {}
    try {
        return cell.w = $a1a91b25d7598376$var$SSF_format((cell.XF || {}).numFmtId || (q ? 14 : 0), q ? $a1a91b25d7598376$var$datenum(v) : v);
    } catch (e) {
        return '' + v;
    }
}
function $a1a91b25d7598376$var$format_cell(cell /*:Cell*/ , v /*:any*/ , o /*:any*/ ) {
    if (cell == null || cell.t == null || cell.t == 'z') return "";
    if (cell.w !== undefined) return cell.w;
    if (cell.t == 'd' && !cell.z && o && o.dateNF) cell.z = o.dateNF;
    if (cell.t == "e") return $a1a91b25d7598376$var$BErr[cell.v] || cell.v;
    if (v == undefined) return $a1a91b25d7598376$var$safe_format_cell(cell, cell.v);
    return $a1a91b25d7598376$var$safe_format_cell(cell, v);
}
function $a1a91b25d7598376$var$sheet_to_workbook(sheet /*:Worksheet*/ , opts) /*:Workbook*/ {
    var n = opts && opts.sheet ? opts.sheet : "Sheet1";
    var sheets = {};
    sheets[n] = sheet;
    return {
        SheetNames: [
            n
        ],
        Sheets: sheets
    };
}
function $a1a91b25d7598376$var$sheet_new(opts) {
    var out = {};
    var o = opts || {};
    if (o.dense) out["!data"] = [];
    return out;
}
function $a1a91b25d7598376$var$sheet_add_aoa(_ws /*:?Worksheet*/ , data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($a1a91b25d7598376$var$DENSE != null && dense == null) dense = $a1a91b25d7598376$var$DENSE;
    var ws /*:Worksheet*/  = _ws || (dense ? {
        "!data": []
    } : {} /*:any*/ );
    if (dense && !ws["!data"]) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $a1a91b25d7598376$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 10000000,
            r: 10000000
        },
        e: {
            c: 0,
            r: 0
        }
    } /*:any*/ ;
    if (ws["!ref"]) {
        var _range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
        range.s.c = _range.s.c;
        range.s.r = _range.s.r;
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) range.e.r = _R = ws["!ref"] ? _range.e.r + 1 : 0;
    } else range.s.c = range.e.c = range.s.r = range.e.r = 0;
    var row = [], seen = false;
    for(var R = 0; R != data.length; ++R){
        if (!data[R]) continue;
        if (!Array.isArray(data[R])) throw new Error("aoa_to_sheet expects an array of arrays");
        var __R = _R + R;
        if (dense) {
            if (!ws["!data"][__R]) ws["!data"][__R] = [];
            row = ws["!data"][__R];
        }
        var data_R = data[R];
        for(var C = 0; C != data_R.length; ++C){
            if (typeof data_R[C] === 'undefined') continue;
            var cell /*:Cell*/  = {
                v: data_R[C],
                t: ""
            } /*:any*/ ;
            var __C = _C + C;
            if (range.s.r > __R) range.s.r = __R;
            if (range.s.c > __C) range.s.c = __C;
            if (range.e.r < __R) range.e.r = __R;
            if (range.e.c < __C) range.e.c = __C;
            seen = true;
            if (data_R[C] && typeof data_R[C] === 'object' && !Array.isArray(data_R[C]) && !(data_R[C] instanceof Date)) cell = data_R[C];
            else {
                if (Array.isArray(cell.v)) {
                    cell.f = data_R[C][1];
                    cell.v = cell.v[0];
                }
                if (cell.v === null) {
                    if (cell.f) cell.t = 'n';
                    else if (o.nullError) {
                        cell.t = 'e';
                        cell.v = 0;
                    } else if (!o.sheetStubs) continue;
                    else cell.t = 'z';
                } else if (typeof cell.v === 'number') {
                    if (isFinite(cell.v)) cell.t = 'n';
                    else if (isNaN(cell.v)) {
                        cell.t = 'e';
                        cell.v = 0x0F; /* #VALUE! */ 
                    } else {
                        cell.t = 'e';
                        cell.v = 0x07; /*# DIV/0 */ 
                    }
                } else if (typeof cell.v === 'boolean') cell.t = 'b';
                else if (cell.v instanceof Date) {
                    cell.z = o.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                    if (!o.UTC) cell.v = $a1a91b25d7598376$var$local_to_utc(cell.v);
                    if (o.cellDates) {
                        cell.t = 'd';
                        cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, $a1a91b25d7598376$var$datenum(cell.v, o.date1904));
                    } else {
                        cell.t = 'n';
                        cell.v = $a1a91b25d7598376$var$datenum(cell.v, o.date1904);
                        cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, cell.v);
                    }
                } else cell.t = 's';
            }
            if (dense) {
                if (row[__C] && row[__C].z) cell.z = row[__C].z;
                row[__C] = cell;
            } else {
                var cell_ref = $a1a91b25d7598376$var$encode_col(__C) + (__R + 1 /*:any*/ );
                if (ws[cell_ref] && ws[cell_ref].z) cell.z = ws[cell_ref].z;
                ws[cell_ref] = cell;
            }
        }
    }
    if (seen && range.s.c < 10400000) ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
    return ws;
}
function $a1a91b25d7598376$var$aoa_to_sheet(data /*:AOA*/ , opts /*:?any*/ ) /*:Worksheet*/ {
    return $a1a91b25d7598376$var$sheet_add_aoa(null, data, opts);
}
function $a1a91b25d7598376$var$parse_Int32LE(data) {
    return data.read_shift(4, 'i');
}
function $a1a91b25d7598376$var$write_UInt32LE(x /*:number*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(4, x);
    return o;
}
/* [MS-XLSB] 2.5.168 */ function $a1a91b25d7598376$var$parse_XLWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $a1a91b25d7598376$var$write_XLWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(4 + 2 * data.length);
    }
    o.write_shift(4, data.length);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.91 */ //function parse_LPWideString(data/*::, length*/)/*:string*/ {
//	var cchCharacters = data.read_shift(2);
//	return cchCharacters === 0 ? "" : data.read_shift(cchCharacters, "utf16le");
//}
/* [MS-XLSB] 2.5.143 */ function $a1a91b25d7598376$var$parse_StrRun(data) {
    return {
        ich: data.read_shift(2),
        ifnt: data.read_shift(2)
    };
}
function $a1a91b25d7598376$var$write_StrRun(run, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(2, run.ich || 0);
    o.write_shift(2, run.ifnt || 0);
    return o;
}
/* [MS-XLSB] 2.5.121 */ function $a1a91b25d7598376$var$parse_RichStr(data, length /*:number*/ ) /*:XLString*/ {
    var start = data.l;
    var flags = data.read_shift(1);
    var str = $a1a91b25d7598376$var$parse_XLWideString(data);
    var rgsStrRun = [];
    var z = {
        t: str,
        h: str
    } /*:any*/ ;
    if ((flags & 1) !== 0) {
        /* TODO: formatted string */ var dwSizeStrRun = data.read_shift(4);
        for(var i = 0; i != dwSizeStrRun; ++i)rgsStrRun.push($a1a91b25d7598376$var$parse_StrRun(data));
        z.r = rgsStrRun;
    } else z.r = [
        {
            ich: 0,
            ifnt: 0
        }
    ];
    //if((flags & 2) !== 0) { /* fExtStr */
    //	/* TODO: phonetic string */
    //}
    data.l = start + length;
    return z;
}
function $a1a91b25d7598376$var$write_RichStr(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(15 + 4 * str.t.length);
    }
    o.write_shift(1, 0);
    $a1a91b25d7598376$var$write_XLWideString(str.t, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.328 BrtCommentText (RichStr w/1 run) */ var $a1a91b25d7598376$var$parse_BrtCommentText = $a1a91b25d7598376$var$parse_RichStr;
function $a1a91b25d7598376$var$write_BrtCommentText(str /*:XLString*/ , o /*:?Block*/ ) /*:Block*/ {
    /* TODO: formatted string */ var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(23 + 4 * str.t.length);
    }
    o.write_shift(1, 1);
    $a1a91b25d7598376$var$write_XLWideString(str.t, o);
    o.write_shift(4, 1);
    $a1a91b25d7598376$var$write_StrRun({
        ich: 0,
        ifnt: 0
    }, o);
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.9 */ function $a1a91b25d7598376$var$parse_XLSBCell(data) /*:any*/ {
    var col = data.read_shift(4);
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: col,
        iStyleRef: iStyleRef
    };
}
function $a1a91b25d7598376$var$write_XLSBCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(-4, cell.c);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* Short XLSB Cell does not include column */ function $a1a91b25d7598376$var$parse_XLSBShortCell(data) /*:any*/ {
    var iStyleRef = data.read_shift(2);
    iStyleRef += data.read_shift(1) << 16;
    data.l++; //var fPhShow = data.read_shift(1);
    return {
        c: -1,
        iStyleRef: iStyleRef
    };
}
function $a1a91b25d7598376$var$write_XLSBShortCell(cell /*:any*/ , o /*:?Block*/ ) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(3, cell.iStyleRef || cell.s);
    o.write_shift(1, 0); /* fPhShow */ 
    return o;
}
/* [MS-XLSB] 2.5.21 */ var $a1a91b25d7598376$var$parse_XLSBCodeName = $a1a91b25d7598376$var$parse_XLWideString;
var $a1a91b25d7598376$var$write_XLSBCodeName = $a1a91b25d7598376$var$write_XLWideString;
/* [MS-XLSB] 2.5.166 */ function $a1a91b25d7598376$var$parse_XLNullableWideString(data /*::, length*/ ) /*:string*/ {
    var cchCharacters = data.read_shift(4);
    return cchCharacters === 0 || cchCharacters === 0xFFFFFFFF ? "" : data.read_shift(cchCharacters, 'dbcs');
}
function $a1a91b25d7598376$var$write_XLNullableWideString(data /*:string*/ , o) {
    var _null = false;
    if (o == null) {
        _null = true;
        o = $a1a91b25d7598376$var$new_buf(127);
    }
    o.write_shift(4, data.length > 0 ? data.length : 0xFFFFFFFF);
    if (data.length > 0) o.write_shift(0, data, 'dbcs');
    return _null ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.5.165 */ var $a1a91b25d7598376$var$parse_XLNameWideString = $a1a91b25d7598376$var$parse_XLWideString;
//var write_XLNameWideString = write_XLWideString;
/* [MS-XLSB] 2.5.114 */ var $a1a91b25d7598376$var$parse_RelID = $a1a91b25d7598376$var$parse_XLNullableWideString;
var $a1a91b25d7598376$var$write_RelID = $a1a91b25d7598376$var$write_XLNullableWideString;
/* [MS-XLS] 2.5.217 ; [MS-XLSB] 2.5.122 */ function $a1a91b25d7598376$var$parse_RkNumber(data) /*:number*/ {
    var b = data.slice(data.l, data.l + 4);
    var fX100 = b[0] & 1, fInt = b[0] & 2;
    data.l += 4;
    var RK = fInt === 0 ? $a1a91b25d7598376$var$__double([
        0,
        0,
        0,
        0,
        b[0] & 0xFC,
        b[1],
        b[2],
        b[3]
    ], 0) : $a1a91b25d7598376$var$__readInt32LE(b, 0) >> 2;
    return fX100 ? RK / 100 : RK;
}
function $a1a91b25d7598376$var$write_RkNumber(data /*:number*/ , o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    var fX100 = 0, fInt = 0, d100 = data * 100;
    if (data == (data | 0) && data >= -536870912 && data < 536870912) fInt = 1;
    else if (d100 == (d100 | 0) && d100 >= -536870912 && d100 < 536870912) {
        fInt = 1;
        fX100 = 1;
    }
    if (fInt) o.write_shift(-4, ((fX100 ? d100 : data) << 2) + (fX100 + 2));
    else throw new Error("unsupported RkNumber " + data); // TODO
}
/* [MS-XLSB] 2.5.117 RfX */ function $a1a91b25d7598376$var$parse_RfX(data /*::, length*/ ) /*:Range*/ {
    var cell /*:Range*/  = {
        s: {},
        e: {}
    } /*:any*/ ;
    cell.s.r = data.read_shift(4);
    cell.e.r = data.read_shift(4);
    cell.s.c = data.read_shift(4);
    cell.e.c = data.read_shift(4);
    return cell;
}
function $a1a91b25d7598376$var$write_RfX(r /*:Range*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(16);
    o.write_shift(4, r.s.r);
    o.write_shift(4, r.e.r);
    o.write_shift(4, r.s.c);
    o.write_shift(4, r.e.c);
    return o;
}
/* [MS-XLSB] 2.5.153 UncheckedRfX */ var $a1a91b25d7598376$var$parse_UncheckedRfX = $a1a91b25d7598376$var$parse_RfX;
var $a1a91b25d7598376$var$write_UncheckedRfX = $a1a91b25d7598376$var$write_RfX;
/* [MS-XLSB] 2.5.155 UncheckedSqRfX */ //function parse_UncheckedSqRfX(data) {
//	var cnt = data.read_shift(4);
//	var out = [];
//	for(var i = 0; i < cnt; ++i) {
//		var rng = parse_UncheckedRfX(data);
//		out.push(encode_range(rng));
//	}
//	return out.join(",");
//}
//function write_UncheckedSqRfX(sqrfx/*:string*/) {
//	var parts = sqrfx.split(/\s*,\s*/);
//	var o = new_buf(4); o.write_shift(4, parts.length);
//	var out = [o];
//	parts.forEach(function(rng) {
//		out.push(write_UncheckedRfX(safe_decode_range(rng)));
//	});
//	return bconcat(out);
//}
/* [MS-XLS] 2.5.342 ; [MS-XLSB] 2.5.171 */ /* TODO: error checking, NaN and Infinity values are not valid Xnum */ function $a1a91b25d7598376$var$parse_Xnum(data /*::, length*/ ) {
    if (data.length - data.l < 8) throw "XLS Xnum Buffer underflow";
    return data.read_shift(8, 'f');
}
function $a1a91b25d7598376$var$write_Xnum(data, o) {
    return (o || $a1a91b25d7598376$var$new_buf(8)).write_shift(8, data, 'f');
}
/* [MS-XLSB] 2.4.324 BrtColor */ function $a1a91b25d7598376$var$parse_BrtColor(data /*::, length*/ ) {
    var out = {};
    var d = data.read_shift(1);
    //var fValidRGB = d & 1;
    var xColorType = d >>> 1;
    var index = data.read_shift(1);
    var nTS = data.read_shift(2, 'i');
    var bR = data.read_shift(1);
    var bG = data.read_shift(1);
    var bB = data.read_shift(1);
    data.l++; //var bAlpha = data.read_shift(1);
    switch(xColorType){
        case 0:
            out.auto = 1;
            break;
        case 1:
            out.index = index;
            var icv = $a1a91b25d7598376$var$XLSIcv[index];
            /* automatic pseudo index 81 */ if (icv) out.rgb = $a1a91b25d7598376$var$rgb2Hex(icv);
            break;
        case 2:
            /* if(!fValidRGB) throw new Error("invalid"); */ out.rgb = $a1a91b25d7598376$var$rgb2Hex([
                bR,
                bG,
                bB
            ]);
            break;
        case 3:
            out.theme = index;
            break;
    }
    if (nTS != 0) out.tint = nTS > 0 ? nTS / 32767 : nTS / 32768;
    return out;
}
function $a1a91b25d7598376$var$write_BrtColor(color, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(8);
    if (!color || color.auto) {
        o.write_shift(4, 0);
        o.write_shift(4, 0);
        return o;
    }
    if (color.index != null) {
        o.write_shift(1, 0x02);
        o.write_shift(1, color.index);
    } else if (color.theme != null) {
        o.write_shift(1, 0x06);
        o.write_shift(1, color.theme);
    } else {
        o.write_shift(1, 0x05);
        o.write_shift(1, 0);
    }
    var nTS = color.tint || 0;
    if (nTS > 0) nTS *= 32767;
    else if (nTS < 0) nTS *= 32768;
    o.write_shift(2, nTS);
    if (!color.rgb || color.theme != null) {
        o.write_shift(2, 0);
        o.write_shift(1, 0);
        o.write_shift(1, 0);
    } else {
        var rgb = color.rgb || 'FFFFFF';
        if (typeof rgb == 'number') rgb = ("000000" + rgb.toString(16)).slice(-6);
        o.write_shift(1, parseInt(rgb.slice(0, 2), 16));
        o.write_shift(1, parseInt(rgb.slice(2, 4), 16));
        o.write_shift(1, parseInt(rgb.slice(4, 6), 16));
        o.write_shift(1, 0xFF);
    }
    return o;
}
/* [MS-XLSB] 2.5.52 */ function $a1a91b25d7598376$var$parse_FontFlags(data /*::, length, opts*/ ) {
    var d = data.read_shift(1);
    data.l++;
    var out = {
        fBold: d & 0x01,
        fItalic: d & 0x02,
        fUnderline: d & 0x04,
        fStrikeout: d & 0x08,
        fOutline: d & 0x10,
        fShadow: d & 0x20,
        fCondense: d & 0x40,
        fExtend: d & 0x80
    };
    return out;
}
function $a1a91b25d7598376$var$write_FontFlags(font, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    var grbit = (font.italic ? 0x02 : 0) | (font.strike ? 0x08 : 0) | (font.outline ? 0x10 : 0) | (font.shadow ? 0x20 : 0) | (font.condense ? 0x40 : 0) | (font.extend ? 0x80 : 0);
    o.write_shift(1, grbit);
    o.write_shift(1, 0);
    return o;
}
/* [MS-OLEDS] 2.3.1 and 2.3.2 */ function $a1a91b25d7598376$var$parse_ClipboardFormatOrString(o, w /*:number*/ ) /*:string*/ {
    // $FlowIgnore
    var ClipFmt = {
        2: "BITMAP",
        3: "METAFILEPICT",
        8: "DIB",
        14: "ENHMETAFILE"
    };
    var m /*:number*/  = o.read_shift(4);
    switch(m){
        case 0x00000000:
            return "";
        case 0xffffffff:
        case 0xfffffffe:
            return ClipFmt[o.read_shift(4)] || "";
    }
    if (m > 0x190) throw new Error("Unsupported Clipboard: " + m.toString(16));
    o.l -= 4;
    return o.read_shift(0, w == 1 ? "lpstr" : "lpwstr");
}
function $a1a91b25d7598376$var$parse_ClipboardFormatOrAnsiString(o) {
    return $a1a91b25d7598376$var$parse_ClipboardFormatOrString(o, 1);
}
function $a1a91b25d7598376$var$parse_ClipboardFormatOrUnicodeString(o) {
    return $a1a91b25d7598376$var$parse_ClipboardFormatOrString(o, 2);
}
/* [MS-OLEPS] 2.2 PropertyType */ // Note: some tree shakers cannot handle VT_VECTOR | $CONST, hence extra vars
//var VT_EMPTY    = 0x0000;
//var VT_NULL     = 0x0001;
var $a1a91b25d7598376$var$VT_I2 = 0x0002;
var $a1a91b25d7598376$var$VT_I4 = 0x0003;
//var VT_R4       = 0x0004;
//var VT_R8       = 0x0005;
//var VT_CY       = 0x0006;
//var VT_DATE     = 0x0007;
//var VT_BSTR     = 0x0008;
//var VT_ERROR    = 0x000A;
var $a1a91b25d7598376$var$VT_BOOL = 0x000B;
var $a1a91b25d7598376$var$VT_VARIANT = 0x000C;
//var VT_DECIMAL  = 0x000E;
//var VT_I1       = 0x0010;
//var VT_UI1      = 0x0011;
//var VT_UI2      = 0x0012;
var $a1a91b25d7598376$var$VT_UI4 = 0x0013;
//var VT_I8       = 0x0014;
//var VT_UI8      = 0x0015;
//var VT_INT      = 0x0016;
//var VT_UINT     = 0x0017;
//var VT_LPSTR    = 0x001E;
//var VT_LPWSTR   = 0x001F;
var $a1a91b25d7598376$var$VT_FILETIME = 0x0040;
var $a1a91b25d7598376$var$VT_BLOB = 0x0041;
//var VT_STREAM   = 0x0042;
//var VT_STORAGE  = 0x0043;
//var VT_STREAMED_Object  = 0x0044;
//var VT_STORED_Object    = 0x0045;
//var VT_BLOB_Object      = 0x0046;
var $a1a91b25d7598376$var$VT_CF = 0x0047;
//var VT_CLSID    = 0x0048;
//var VT_VERSIONED_STREAM = 0x0049;
//var VT_VECTOR   = 0x1000;
var $a1a91b25d7598376$var$VT_VECTOR_VARIANT = 0x100C;
var $a1a91b25d7598376$var$VT_VECTOR_LPSTR = 0x101E;
//var VT_ARRAY    = 0x2000;
var $a1a91b25d7598376$var$VT_STRING = 0x0050; // 2.3.3.1.11 VtString
var $a1a91b25d7598376$var$VT_USTR = 0x0051; // 2.3.3.1.12 VtUnalignedString
var $a1a91b25d7598376$var$VT_CUSTOM = [
    $a1a91b25d7598376$var$VT_STRING,
    $a1a91b25d7598376$var$VT_USTR
];
/* [MS-OSHARED] 2.3.3.2.2.1 Document Summary Information PIDDSI */ var $a1a91b25d7598376$var$DocSummaryPIDDSI = {
    0x01: {
        n: 'CodePage',
        t: $a1a91b25d7598376$var$VT_I2
    },
    0x02: {
        n: 'Category',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x03: {
        n: 'PresentationFormat',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x04: {
        n: 'ByteCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x05: {
        n: 'LineCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x06: {
        n: 'ParagraphCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x07: {
        n: 'SlideCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x08: {
        n: 'NoteCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x09: {
        n: 'HiddenCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x0a: {
        n: 'MultimediaClipCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x0b: {
        n: 'ScaleCrop',
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    0x0c: {
        n: 'HeadingPairs',
        t: $a1a91b25d7598376$var$VT_VECTOR_VARIANT /* VT_VECTOR | VT_VARIANT */ 
    },
    0x0d: {
        n: 'TitlesOfParts',
        t: $a1a91b25d7598376$var$VT_VECTOR_LPSTR /* VT_VECTOR | VT_LPSTR */ 
    },
    0x0e: {
        n: 'Manager',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x0f: {
        n: 'Company',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x10: {
        n: 'LinksUpToDate',
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    0x11: {
        n: 'CharacterCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x13: {
        n: 'SharedDoc',
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    0x16: {
        n: 'HyperlinksChanged',
        t: $a1a91b25d7598376$var$VT_BOOL
    },
    0x17: {
        n: 'AppVersion',
        t: $a1a91b25d7598376$var$VT_I4,
        p: 'version'
    },
    0x18: {
        n: 'DigSig',
        t: $a1a91b25d7598376$var$VT_BLOB
    },
    0x1A: {
        n: 'ContentType',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x1B: {
        n: 'ContentStatus',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x1C: {
        n: 'Language',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x1D: {
        n: 'Version',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $a1a91b25d7598376$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $a1a91b25d7598376$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-OSHARED] 2.3.3.2.1.1 Summary Information Property Set PIDSI */ var $a1a91b25d7598376$var$SummaryPIDSI = {
    0x01: {
        n: 'CodePage',
        t: $a1a91b25d7598376$var$VT_I2
    },
    0x02: {
        n: 'Title',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x03: {
        n: 'Subject',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x04: {
        n: 'Author',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x05: {
        n: 'Keywords',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x06: {
        n: 'Comments',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x07: {
        n: 'Template',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x08: {
        n: 'LastAuthor',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x09: {
        n: 'RevNumber',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x0A: {
        n: 'EditTime',
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    0x0B: {
        n: 'LastPrinted',
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    0x0C: {
        n: 'CreatedDate',
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    0x0D: {
        n: 'ModifiedDate',
        t: $a1a91b25d7598376$var$VT_FILETIME
    },
    0x0E: {
        n: 'PageCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x0F: {
        n: 'WordCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x10: {
        n: 'CharCount',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0x11: {
        n: 'Thumbnail',
        t: $a1a91b25d7598376$var$VT_CF
    },
    0x12: {
        n: 'Application',
        t: $a1a91b25d7598376$var$VT_STRING
    },
    0x13: {
        n: 'DocSecurity',
        t: $a1a91b25d7598376$var$VT_I4
    },
    0xFF: {},
    /* [MS-OLEPS] 2.18 */ 0x80000000: {
        n: 'Locale',
        t: $a1a91b25d7598376$var$VT_UI4
    },
    0x80000003: {
        n: 'Behavior',
        t: $a1a91b25d7598376$var$VT_UI4
    },
    0x72627262: {}
};
/* [MS-XLS] 2.4.63 Country/Region codes */ var $a1a91b25d7598376$var$CountryEnum = {
    0x0001: "US",
    0x0002: "CA",
    0x0003: "",
    0x0007: "RU",
    0x0014: "EG",
    0x001E: "GR",
    0x001F: "NL",
    0x0020: "BE",
    0x0021: "FR",
    0x0022: "ES",
    0x0024: "HU",
    0x0027: "IT",
    0x0029: "CH",
    0x002B: "AT",
    0x002C: "GB",
    0x002D: "DK",
    0x002E: "SE",
    0x002F: "NO",
    0x0030: "PL",
    0x0031: "DE",
    0x0034: "MX",
    0x0037: "BR",
    0x003d: "AU",
    0x0040: "NZ",
    0x0042: "TH",
    0x0051: "JP",
    0x0052: "KR",
    0x0054: "VN",
    0x0056: "CN",
    0x005A: "TR",
    0x0069: "JS",
    0x00D5: "DZ",
    0x00D8: "MA",
    0x00DA: "LY",
    0x015F: "PT",
    0x0162: "IS",
    0x0166: "FI",
    0x01A4: "CZ",
    0x0376: "TW",
    0x03C1: "LB",
    0x03C2: "JO",
    0x03C3: "SY",
    0x03C4: "IQ",
    0x03C5: "KW",
    0x03C6: "SA",
    0x03CB: "AE",
    0x03CC: "IL",
    0x03CE: "QA",
    0x03D5: "IR",
    0xFFFF: "US" // United States
};
/* [MS-XLS] 2.5.127 */ var $a1a91b25d7598376$var$XLSFillPattern = [
    null,
    'solid',
    'mediumGray',
    'darkGray',
    'lightGray',
    'darkHorizontal',
    'darkVertical',
    'darkDown',
    'darkUp',
    'darkGrid',
    'darkTrellis',
    'lightHorizontal',
    'lightVertical',
    'lightDown',
    'lightUp',
    'lightGrid',
    'lightTrellis',
    'gray125',
    'gray0625'
];
function $a1a91b25d7598376$var$rgbify(arr /*:Array<number>*/ ) /*:Array<[number, number, number]>*/ {
    return arr.map(function(x) {
        return [
            x >> 16 & 255,
            x >> 8 & 255,
            x & 255
        ];
    });
}
/* [MS-XLS] 2.5.161 */ /* [MS-XLSB] 2.5.75 Icv */ var $a1a91b25d7598376$var$_XLSIcv = /*#__PURE__*/ $a1a91b25d7598376$var$rgbify([
    /* Color Constants */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    /* Overridable Defaults */ 0x000000,
    0xFFFFFF,
    0xFF0000,
    0x00FF00,
    0x0000FF,
    0xFFFF00,
    0xFF00FF,
    0x00FFFF,
    0x800000,
    0x008000,
    0x000080,
    0x808000,
    0x800080,
    0x008080,
    0xC0C0C0,
    0x808080,
    0x9999FF,
    0x993366,
    0xFFFFCC,
    0xCCFFFF,
    0x660066,
    0xFF8080,
    0x0066CC,
    0xCCCCFF,
    0x000080,
    0xFF00FF,
    0xFFFF00,
    0x00FFFF,
    0x800080,
    0x800000,
    0x008080,
    0x0000FF,
    0x00CCFF,
    0xCCFFFF,
    0xCCFFCC,
    0xFFFF99,
    0x99CCFF,
    0xFF99CC,
    0xCC99FF,
    0xFFCC99,
    0x3366FF,
    0x33CCCC,
    0x99CC00,
    0xFFCC00,
    0xFF9900,
    0xFF6600,
    0x666699,
    0x969696,
    0x003366,
    0x339966,
    0x003300,
    0x333300,
    0x993300,
    0x993366,
    0x333399,
    0x333333,
    /* Other entries to appease BIFF8/12 */ 0x000000,
    /* 0x40 icvForeground ?? */ 0xFFFFFF,
    /* 0x41 icvBackground ?? */ 0x000000,
    /* 0x42 icvFrame ?? */ 0x000000,
    /* 0x43 icv3D ?? */ 0x000000,
    /* 0x44 icv3DText ?? */ 0x000000,
    /* 0x45 icv3DHilite ?? */ 0x000000,
    /* 0x46 icv3DShadow ?? */ 0x000000,
    /* 0x47 icvHilite ?? */ 0x000000,
    /* 0x48 icvCtlText ?? */ 0x000000,
    /* 0x49 icvCtlScrl ?? */ 0x000000,
    /* 0x4A icvCtlInv ?? */ 0x000000,
    /* 0x4B icvCtlBody ?? */ 0x000000,
    /* 0x4C icvCtlFrame ?? */ 0x000000,
    /* 0x4D icvCtlFore ?? */ 0x000000,
    /* 0x4E icvCtlBack ?? */ 0x000000,
    /* 0x4F icvCtlNeutral */ 0x000000,
    /* 0x50 icvInfoBk ?? */ 0x000000 /* 0x51 icvInfoText ?? */ 
]);
var $a1a91b25d7598376$var$XLSIcv = /*#__PURE__*/ $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$_XLSIcv);
/* [MS-XLSB] 2.5.97.2 */ var $a1a91b25d7598376$var$BErr = {
    0x00: "#NULL!",
    0x07: "#DIV/0!",
    0x0F: "#VALUE!",
    0x17: "#REF!",
    0x1D: "#NAME?",
    0x24: "#NUM!",
    0x2A: "#N/A",
    0x2B: "#GETTING_DATA",
    0xFF: "#WTF?"
};
//var RBErr = evert_num(BErr);
var $a1a91b25d7598376$var$RBErr = {
    "#NULL!": 0x00,
    "#DIV/0!": 0x07,
    "#VALUE!": 0x0F,
    "#REF!": 0x17,
    "#NAME?": 0x1D,
    "#NUM!": 0x24,
    "#N/A": 0x2A,
    "#GETTING_DATA": 0x2B,
    "#WTF?": 0xFF
};
var $a1a91b25d7598376$var$XLSLblBuiltIn = [
    "_xlnm.Consolidate_Area",
    "_xlnm.Auto_Open",
    "_xlnm.Auto_Close",
    "_xlnm.Extract",
    "_xlnm.Database",
    "_xlnm.Criteria",
    "_xlnm.Print_Area",
    "_xlnm.Print_Titles",
    "_xlnm.Recorder",
    "_xlnm.Data_Form",
    "_xlnm.Auto_Activate",
    "_xlnm.Auto_Deactivate",
    "_xlnm.Sheet_Title",
    "_xlnm._FilterDatabase"
];
/* Parts enumerated in OPC spec, MS-XLSB and MS-XLSX */ /* 12.3 Part Summary <SpreadsheetML> */ /* 14.2 Part Summary <DrawingML> */ /* [MS-XLSX] 2.1 Part Enumerations ; [MS-XLSB] 2.1.7 Part Enumeration */ var $a1a91b25d7598376$var$ct2type /*{[string]:string}*/  = {
    /* Workbook */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.macroEnabled.main+xml": "workbooks",
    "application/vnd.ms-excel.sheet.binary.macroEnabled.main": "workbooks",
    "application/vnd.ms-excel.addin.macroEnabled.main+xml": "workbooks",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": "workbooks",
    /* Worksheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": "sheets",
    "application/vnd.ms-excel.worksheet": "sheets",
    "application/vnd.ms-excel.binIndexWs": "TODO",
    /* Binary Index */ /* Chartsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": "charts",
    "application/vnd.ms-excel.chartsheet": "charts",
    /* Macrosheet */ "application/vnd.ms-excel.macrosheet+xml": "macros",
    "application/vnd.ms-excel.macrosheet": "macros",
    "application/vnd.ms-excel.intlmacrosheet": "TODO",
    "application/vnd.ms-excel.binIndexMs": "TODO",
    /* Binary Index */ /* Dialogsheet */ "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": "dialogs",
    "application/vnd.ms-excel.dialogsheet": "dialogs",
    /* Shared Strings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml": "strs",
    "application/vnd.ms-excel.sharedStrings": "strs",
    /* Styles */ "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": "styles",
    "application/vnd.ms-excel.styles": "styles",
    /* File Properties */ "application/vnd.openxmlformats-package.core-properties+xml": "coreprops",
    "application/vnd.openxmlformats-officedocument.custom-properties+xml": "custprops",
    "application/vnd.openxmlformats-officedocument.extended-properties+xml": "extprops",
    /* Custom Data Properties */ "application/vnd.openxmlformats-officedocument.customXmlProperties+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.customProperty": "TODO",
    /* Comments */ "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": "comments",
    "application/vnd.ms-excel.comments": "comments",
    "application/vnd.ms-excel.threadedcomments+xml": "threadedcomments",
    "application/vnd.ms-excel.person+xml": "people",
    /* Metadata (Stock/Geography and Dynamic Array) */ "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml": "metadata",
    "application/vnd.ms-excel.sheetMetadata": "metadata",
    /* PivotTable */ "application/vnd.ms-excel.pivotTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotTable+xml": "TODO",
    /* Chart Objects */ "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": "TODO",
    /* Chart Colors */ "application/vnd.ms-office.chartcolorstyle+xml": "TODO",
    /* Chart Style */ "application/vnd.ms-office.chartstyle+xml": "TODO",
    /* Chart Advanced */ "application/vnd.ms-office.chartex+xml": "TODO",
    /* Calculation Chain */ "application/vnd.ms-excel.calcChain": "calcchains",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.calcChain+xml": "calcchains",
    /* Printer Settings */ "application/vnd.openxmlformats-officedocument.spreadsheetml.printerSettings": "TODO",
    /* ActiveX */ "application/vnd.ms-office.activeX": "TODO",
    "application/vnd.ms-office.activeX+xml": "TODO",
    /* Custom Toolbars */ "application/vnd.ms-excel.attachedToolbars": "TODO",
    /* External Data Connections */ "application/vnd.ms-excel.connections": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": "TODO",
    /* External Links */ "application/vnd.ms-excel.externalLink": "links",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.externalLink+xml": "links",
    /* PivotCache */ "application/vnd.ms-excel.pivotCacheDefinition": "TODO",
    "application/vnd.ms-excel.pivotCacheRecords": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheDefinition+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotCacheRecords+xml": "TODO",
    /* Query Table */ "application/vnd.ms-excel.queryTable": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.queryTable+xml": "TODO",
    /* Shared Workbook */ "application/vnd.ms-excel.userNames": "TODO",
    "application/vnd.ms-excel.revisionHeaders": "TODO",
    "application/vnd.ms-excel.revisionLog": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionHeaders+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionLog+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.userNames+xml": "TODO",
    /* Single Cell Table */ "application/vnd.ms-excel.tableSingleCells": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.tableSingleCells+xml": "TODO",
    /* Slicer */ "application/vnd.ms-excel.slicer": "TODO",
    "application/vnd.ms-excel.slicerCache": "TODO",
    "application/vnd.ms-excel.slicer+xml": "TODO",
    "application/vnd.ms-excel.slicerCache+xml": "TODO",
    /* Sort Map */ "application/vnd.ms-excel.wsSortMap": "TODO",
    /* Table */ "application/vnd.ms-excel.table": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": "TODO",
    /* Themes */ "application/vnd.openxmlformats-officedocument.theme+xml": "themes",
    /* Theme Override */ "application/vnd.openxmlformats-officedocument.themeOverride+xml": "TODO",
    /* Timeline */ "application/vnd.ms-excel.Timeline+xml": "TODO",
    /* verify */ "application/vnd.ms-excel.TimelineCache+xml": "TODO",
    /* verify */ /* VBA */ "application/vnd.ms-office.vbaProject": "vba",
    "application/vnd.ms-office.vbaProjectSignature": "TODO",
    /* Volatile Dependencies */ "application/vnd.ms-office.volatileDependencies": "TODO",
    "application/vnd.openxmlformats-officedocument.spreadsheetml.volatileDependencies+xml": "TODO",
    /* Control Properties */ "application/vnd.ms-excel.controlproperties+xml": "TODO",
    /* Data Model */ "application/vnd.openxmlformats-officedocument.model+data": "TODO",
    /* Survey */ "application/vnd.ms-excel.Survey+xml": "TODO",
    /* Drawing */ "application/vnd.openxmlformats-officedocument.drawing+xml": "drawings",
    "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramColors+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramData+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramLayout+xml": "TODO",
    "application/vnd.openxmlformats-officedocument.drawingml.diagramStyle+xml": "TODO",
    /* VML */ "application/vnd.openxmlformats-officedocument.vmlDrawing": "TODO",
    "application/vnd.openxmlformats-package.relationships+xml": "rels",
    "application/vnd.openxmlformats-officedocument.oleObject": "TODO",
    /* Image */ "image/png": "TODO",
    "sheet": "js"
} /*:any*/ ;
var $a1a91b25d7598376$var$CT_LIST = {
    workbooks: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml",
        xlsm: "application/vnd.ms-excel.sheet.macroEnabled.main+xml",
        xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.main",
        xlam: "application/vnd.ms-excel.addin.macroEnabled.main+xml",
        xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml"
    },
    strs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedStrings+xml",
        xlsb: "application/vnd.ms-excel.sharedStrings"
    },
    comments: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml",
        xlsb: "application/vnd.ms-excel.comments"
    },
    sheets: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml",
        xlsb: "application/vnd.ms-excel.worksheet"
    },
    charts: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml",
        xlsb: "application/vnd.ms-excel.chartsheet"
    },
    dialogs: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml",
        xlsb: "application/vnd.ms-excel.dialogsheet"
    },
    macros: {
        xlsx: "application/vnd.ms-excel.macrosheet+xml",
        xlsb: "application/vnd.ms-excel.macrosheet"
    },
    metadata: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetMetadata+xml",
        xlsb: "application/vnd.ms-excel.sheetMetadata"
    },
    styles: {
        xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml",
        xlsb: "application/vnd.ms-excel.styles"
    }
};
function $a1a91b25d7598376$var$new_ct() /*:any*/ {
    return {
        workbooks: [],
        sheets: [],
        charts: [],
        dialogs: [],
        macros: [],
        rels: [],
        strs: [],
        comments: [],
        threadedcomments: [],
        links: [],
        coreprops: [],
        extprops: [],
        custprops: [],
        themes: [],
        styles: [],
        calcchains: [],
        vba: [],
        drawings: [],
        metadata: [],
        people: [],
        TODO: [],
        xmlns: ""
    } /*:any*/ ;
}
function $a1a91b25d7598376$var$parse_ct(data /*:?string*/ ) {
    var ct = $a1a91b25d7598376$var$new_ct();
    if (!data || !data.match) return ct;
    var ctext = {};
    (data.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch(y[0].replace($a1a91b25d7598376$var$nsregex, "<")){
            case '<?xml':
                break;
            case '<Types':
                ct.xmlns = y['xmlns' + (y[0].match(/<(\w+):/) || [
                    "",
                    ""
                ])[1]];
                break;
            case '<Default':
                ctext[y.Extension.toLowerCase()] = y.ContentType;
                break;
            case '<Override':
                if (ct[$a1a91b25d7598376$var$ct2type[y.ContentType]] !== undefined) ct[$a1a91b25d7598376$var$ct2type[y.ContentType]].push(y.PartName);
                break;
        }
    });
    if (ct.xmlns !== $a1a91b25d7598376$var$XMLNS.CT) throw new Error("Unknown Namespace: " + ct.xmlns);
    ct.calcchain = ct.calcchains.length > 0 ? ct.calcchains[0] : "";
    ct.sst = ct.strs.length > 0 ? ct.strs[0] : "";
    ct.style = ct.styles.length > 0 ? ct.styles[0] : "";
    ct.defaults = ctext;
    delete ct.calcchains;
    return ct;
}
function $a1a91b25d7598376$var$write_ct(ct, opts, raw) /*:string*/ {
    var type2ct /*{[string]:Array<string>}*/  = $a1a91b25d7598376$var$evert_arr($a1a91b25d7598376$var$ct2type);
    var o /*:Array<string>*/  = [], v;
    if (!raw) {
        o[o.length] = $a1a91b25d7598376$var$XML_HEADER;
        o[o.length] = $a1a91b25d7598376$var$writextag('Types', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS.CT,
            'xmlns:xsd': $a1a91b25d7598376$var$XMLNS.xsd,
            'xmlns:xsi': $a1a91b25d7598376$var$XMLNS.xsi
        });
        o = o.concat([
            [
                'xml',
                'application/xml'
            ],
            [
                'bin',
                'application/vnd.ms-excel.sheet.binary.macroEnabled.main'
            ],
            [
                'vml',
                'application/vnd.openxmlformats-officedocument.vmlDrawing'
            ],
            [
                'data',
                'application/vnd.openxmlformats-officedocument.model+data'
            ],
            /* from test files */ [
                'bmp',
                'image/bmp'
            ],
            [
                'png',
                'image/png'
            ],
            [
                'gif',
                'image/gif'
            ],
            [
                'emf',
                'image/x-emf'
            ],
            [
                'wmf',
                'image/x-wmf'
            ],
            [
                'jpg',
                'image/jpeg'
            ],
            [
                'jpeg',
                'image/jpeg'
            ],
            [
                'tif',
                'image/tiff'
            ],
            [
                'tiff',
                'image/tiff'
            ],
            [
                'pdf',
                'application/pdf'
            ],
            [
                'rels',
                'application/vnd.openxmlformats-package.relationships+xml'
            ]
        ].map(function(x) {
            return $a1a91b25d7598376$var$writextag('Default', null, {
                'Extension': x[0],
                'ContentType': x[1]
            });
        }));
    }
    /* only write first instance */ var f1 = function(w) {
        if (ct[w] && ct[w].length > 0) {
            v = ct[w][0];
            o[o.length] = $a1a91b25d7598376$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $a1a91b25d7598376$var$CT_LIST[w][opts.bookType] || $a1a91b25d7598376$var$CT_LIST[w]['xlsx']
            });
        }
    };
    /* book type-specific */ var f2 = function(w) {
        (ct[w] || []).forEach(function(v) {
            o[o.length] = $a1a91b25d7598376$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': $a1a91b25d7598376$var$CT_LIST[w][opts.bookType] || $a1a91b25d7598376$var$CT_LIST[w]['xlsx']
            });
        });
    };
    /* standard type */ var f3 = function(t) {
        (ct[t] || []).forEach(function(v) {
            o[o.length] = $a1a91b25d7598376$var$writextag('Override', null, {
                'PartName': (v[0] == '/' ? "" : "/") + v,
                'ContentType': type2ct[t][0]
            });
        });
    };
    f1('workbooks');
    f2('sheets');
    f2('charts');
    f3('themes');
    [
        'strs',
        'styles'
    ].forEach(f1);
    [
        'coreprops',
        'extprops',
        'custprops'
    ].forEach(f3);
    f3('vba');
    f3('comments');
    f3('threadedcomments');
    f3('drawings');
    f2('metadata');
    f3('people');
    if (!raw && o.length > 2) {
        o[o.length] = '</Types>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 9.3 Relationships */ var $a1a91b25d7598376$var$RELS = {
    WB: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    SHEET: "http://sheetjs.openxmlformats.org/officeDocument/2006/relationships/officeDocument",
    HLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink",
    VML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/vmlDrawing",
    XPATH: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLinkPath",
    XMISS: "http://schemas.microsoft.com/office/2006/relationships/xlExternalLinkPath/xlPathMissing",
    XLINK: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/externalLink",
    CXML: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml",
    CXMLP: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps",
    CMNT: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments",
    CORE_PROPS: "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties",
    EXT_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties',
    CUST_PROPS: 'http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties',
    SST: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sharedStrings",
    STY: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles",
    THEME: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme",
    CHART: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chart",
    CHARTEX: "http://schemas.microsoft.com/office/2014/relationships/chartEx",
    CS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/chartsheet",
    WS: [
        "http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet",
        "http://purl.oclc.org/ooxml/officeDocument/relationships/worksheet"
    ],
    DS: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/dialogsheet",
    MS: "http://schemas.microsoft.com/office/2006/relationships/xlMacrosheet",
    IMG: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image",
    DRAW: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/drawing",
    XLMETA: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/sheetMetadata",
    TCMNT: "http://schemas.microsoft.com/office/2017/10/relationships/threadedComment",
    PEOPLE: "http://schemas.microsoft.com/office/2017/10/relationships/person",
    CONN: "http://schemas.openxmlformats.org/officeDocument/2006/relationships/connections",
    VBA: "http://schemas.microsoft.com/office/2006/relationships/vbaProject"
} /*:any*/ ;
/* 9.3.3 Representing Relationships */ function $a1a91b25d7598376$var$get_rels_path(file /*:string*/ ) /*:string*/ {
    var n = file.lastIndexOf("/");
    return file.slice(0, n + 1) + '_rels/' + file.slice(n + 1) + ".rels";
}
function $a1a91b25d7598376$var$parse_rels(data /*:?string*/ , currentFilePath /*:string*/ ) {
    var rels = {
        "!id": {}
    };
    if (!data) return rels;
    if (currentFilePath.charAt(0) !== '/') currentFilePath = '/' + currentFilePath;
    var hash = {};
    (data.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        /* 9.3.2.2 OPC_Relationships */ if (y[0] === '<Relationship') {
            var rel = {};
            rel.Type = y.Type;
            rel.Target = $a1a91b25d7598376$var$unescapexml(y.Target);
            rel.Id = y.Id;
            if (y.TargetMode) rel.TargetMode = y.TargetMode;
            var canonictarget = y.TargetMode === 'External' ? y.Target : $a1a91b25d7598376$var$resolve_path(y.Target, currentFilePath);
            rels[canonictarget] = rel;
            hash[y.Id] = rel;
        }
    });
    rels["!id"] = hash;
    return rels;
}
/* TODO */ function $a1a91b25d7598376$var$write_rels(rels) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('Relationships', null, {
            //'xmlns:ns0': XMLNS.RELS,
            'xmlns': $a1a91b25d7598376$var$XMLNS.RELS
        })
    ];
    $a1a91b25d7598376$var$keys(rels['!id']).forEach(function(rid) {
        o[o.length] = $a1a91b25d7598376$var$writextag('Relationship', null, rels['!id'][rid]);
    });
    if (o.length > 2) {
        o[o.length] = '</Relationships>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
function $a1a91b25d7598376$var$add_rels(rels, rId /*:number*/ , f, type, relobj, targetmode /*:?string*/ ) /*:number*/ {
    if (!relobj) relobj = {};
    if (!rels['!id']) rels['!id'] = {};
    if (!rels['!idx']) rels['!idx'] = 1;
    if (rId < 0) for(rId = rels['!idx']; rels['!id']['rId' + rId]; ++rId);
    rels['!idx'] = rId + 1;
    relobj.Id = 'rId' + rId;
    relobj.Type = type;
    relobj.Target = f;
    if (targetmode) relobj.TargetMode = targetmode;
    else if ([
        $a1a91b25d7598376$var$RELS.HLINK,
        $a1a91b25d7598376$var$RELS.XPATH,
        $a1a91b25d7598376$var$RELS.XMISS
    ].indexOf(relobj.Type) > -1) relobj.TargetMode = "External";
    if (rels['!id'][relobj.Id]) throw new Error("Cannot rewrite rId " + rId);
    rels['!id'][relobj.Id] = relobj;
    rels[('/' + relobj.Target).replace("//", "/")] = relobj;
    return rId;
}
var $a1a91b25d7598376$var$CT_ODS = "application/vnd.oasis.opendocument.spreadsheet";
function $a1a91b25d7598376$var$parse_manifest(d, opts) {
    var str = $a1a91b25d7598376$var$xlml_normalize(d);
    var Rn;
    var FEtag;
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3]){
        case "manifest":
            break;
        case "file-entry":
            FEtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (FEtag.path == "/" && FEtag.type !== $a1a91b25d7598376$var$CT_ODS) throw new Error("This OpenDocument is not a spreadsheet");
            break;
        case "encryption-data":
        case "algorithm":
        case "start-key-generation":
        case "key-derivation":
            throw new Error("Unsupported ODS Encryption");
        default:
            if (opts && opts.WTF) throw Rn;
    }
}
function $a1a91b25d7598376$var$write_manifest(manifest) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o.push('<manifest:manifest xmlns:manifest="urn:oasis:names:tc:opendocument:xmlns:manifest:1.0" manifest:version="1.2">\n');
    o.push('  <manifest:file-entry manifest:full-path="/" manifest:version="1.2" manifest:media-type="application/vnd.oasis.opendocument.spreadsheet"/>\n');
    for(var i = 0; i < manifest.length; ++i)o.push('  <manifest:file-entry manifest:full-path="' + manifest[i][0] + '" manifest:media-type="' + manifest[i][1] + '"/>\n');
    o.push("</manifest:manifest>");
    return o.join("");
}
function $a1a91b25d7598376$var$write_rdf_type(file, res, tag) {
    return [
        '  <rdf:Description rdf:about="' + file + '">\n',
        '    <rdf:type rdf:resource="http://docs.oasis-open.org/ns/office/1.2/meta/' + (tag || "odf") + "#" + res + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $a1a91b25d7598376$var$write_rdf_has(base, file) {
    return [
        '  <rdf:Description rdf:about="' + base + '">\n',
        '    <ns0:hasPart xmlns:ns0="http://docs.oasis-open.org/ns/office/1.2/meta/pkg#" rdf:resource="' + file + '"/>\n',
        "  </rdf:Description>\n"
    ].join("");
}
function $a1a91b25d7598376$var$write_rdf(rdf) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o.push('<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#">\n');
    for(var i = 0; i != rdf.length; ++i){
        o.push($a1a91b25d7598376$var$write_rdf_type(rdf[i][0], rdf[i][1]));
        o.push($a1a91b25d7598376$var$write_rdf_has("", rdf[i][0]));
    }
    o.push($a1a91b25d7598376$var$write_rdf_type("", "Document", "pkg"));
    o.push("</rdf:RDF>");
    return o.join("");
}
function $a1a91b25d7598376$var$write_meta_ods(wb, opts) {
    return '<office:document-meta xmlns:office="urn:oasis:names:tc:opendocument:xmlns:office:1.0" xmlns:meta="urn:oasis:names:tc:opendocument:xmlns:meta:1.0" xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:xlink="http://www.w3.org/1999/xlink" office:version="1.2"><office:meta><meta:generator>SheetJS ' + $a1a91b25d7598376$var$XLSX.version + "</meta:generator></office:meta></office:document-meta>";
}
/* ECMA-376 Part II 11.1 Core Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $a1a91b25d7598376$var$CORE_PROPS /*:Array<Array<string> >*/  = [
    [
        "cp:category",
        "Category"
    ],
    [
        "cp:contentStatus",
        "ContentStatus"
    ],
    [
        "cp:keywords",
        "Keywords"
    ],
    [
        "cp:lastModifiedBy",
        "LastAuthor"
    ],
    [
        "cp:lastPrinted",
        "LastPrinted"
    ],
    [
        "cp:revision",
        "RevNumber"
    ],
    [
        "cp:version",
        "Version"
    ],
    [
        "dc:creator",
        "Author"
    ],
    [
        "dc:description",
        "Comments"
    ],
    [
        "dc:identifier",
        "Identifier"
    ],
    [
        "dc:language",
        "Language"
    ],
    [
        "dc:subject",
        "Subject"
    ],
    [
        "dc:title",
        "Title"
    ],
    [
        "dcterms:created",
        "CreatedDate",
        'date'
    ],
    [
        "dcterms:modified",
        "ModifiedDate",
        'date'
    ]
];
function $a1a91b25d7598376$var$parse_core_props(data) {
    var p = {};
    data = $a1a91b25d7598376$var$utf8read(data);
    for(var i = 0; i < $a1a91b25d7598376$var$CORE_PROPS.length; ++i){
        var f = $a1a91b25d7598376$var$CORE_PROPS[i], cur = $a1a91b25d7598376$var$str_match_xml(data, f[0]);
        if (cur != null && cur.length > 0) p[f[1]] = $a1a91b25d7598376$var$unescapexml(cur[1]);
        if (f[2] === 'date' && p[f[1]]) p[f[1]] = $a1a91b25d7598376$var$parseDate(p[f[1]]);
    }
    return p;
}
function $a1a91b25d7598376$var$cp_doit(f, g, h, o, p) {
    if (p[f] != null || g == null || g === "") return;
    p[f] = g;
    g = $a1a91b25d7598376$var$escapexml(g);
    o[o.length] = h ? $a1a91b25d7598376$var$writextag(f, g, h) : $a1a91b25d7598376$var$writetag(f, g);
}
function $a1a91b25d7598376$var$write_core_props(cp, _opts) {
    var opts = _opts || {};
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('cp:coreProperties', null, {
            //'xmlns': XMLNS.CORE_PROPS,
            'xmlns:cp': $a1a91b25d7598376$var$XMLNS.CORE_PROPS,
            'xmlns:dc': $a1a91b25d7598376$var$XMLNS.dc,
            'xmlns:dcterms': $a1a91b25d7598376$var$XMLNS.dcterms,
            'xmlns:dcmitype': $a1a91b25d7598376$var$XMLNS.dcmitype,
            'xmlns:xsi': $a1a91b25d7598376$var$XMLNS.xsi
        })
    ], p = {};
    if (!cp && !opts.Props) return o.join("");
    if (cp) {
        if (cp.CreatedDate != null) $a1a91b25d7598376$var$cp_doit("dcterms:created", typeof cp.CreatedDate === "string" ? cp.CreatedDate : $a1a91b25d7598376$var$write_w3cdtf(cp.CreatedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
        if (cp.ModifiedDate != null) $a1a91b25d7598376$var$cp_doit("dcterms:modified", typeof cp.ModifiedDate === "string" ? cp.ModifiedDate : $a1a91b25d7598376$var$write_w3cdtf(cp.ModifiedDate, opts.WTF), {
            "xsi:type": "dcterms:W3CDTF"
        }, o, p);
    }
    for(var i = 0; i != $a1a91b25d7598376$var$CORE_PROPS.length; ++i){
        var f = $a1a91b25d7598376$var$CORE_PROPS[i];
        var v = opts.Props && opts.Props[f[1]] != null ? opts.Props[f[1]] : cp ? cp[f[1]] : null;
        if (v === true) v = "1";
        else if (v === false) v = "0";
        else if (typeof v == "number") v = String(v);
        if (v != null) $a1a91b25d7598376$var$cp_doit(f[0], v, null, o, p);
    }
    if (o.length > 2) {
        o[o.length] = '</cp:coreProperties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.3 Extended File Properties Part */ /* [MS-OSHARED] 2.3.3.2.[1-2].1 (PIDSI/PIDDSI) */ var $a1a91b25d7598376$var$EXT_PROPS /*:Array<Array<string> >*/  = [
    [
        "Application",
        "Application",
        "string"
    ],
    [
        "AppVersion",
        "AppVersion",
        "string"
    ],
    [
        "Company",
        "Company",
        "string"
    ],
    [
        "DocSecurity",
        "DocSecurity",
        "string"
    ],
    [
        "Manager",
        "Manager",
        "string"
    ],
    [
        "HyperlinksChanged",
        "HyperlinksChanged",
        "bool"
    ],
    [
        "SharedDoc",
        "SharedDoc",
        "bool"
    ],
    [
        "LinksUpToDate",
        "LinksUpToDate",
        "bool"
    ],
    [
        "ScaleCrop",
        "ScaleCrop",
        "bool"
    ],
    [
        "HeadingPairs",
        "HeadingPairs",
        "raw"
    ],
    [
        "TitlesOfParts",
        "TitlesOfParts",
        "raw"
    ]
];
var $a1a91b25d7598376$var$PseudoPropsPairs = [
    "Worksheets",
    "SheetNames",
    "NamedRanges",
    "DefinedNames",
    "Chartsheets",
    "ChartNames"
];
function $a1a91b25d7598376$var$load_props_pairs(HP /*:string|Array<Array<any>>*/ , TOP, props, opts) {
    var v = [];
    if (typeof HP == "string") v = $a1a91b25d7598376$var$parseVector(HP, opts);
    else for(var j = 0; j < HP.length; ++j)v = v.concat(HP[j].map(function(hp) {
        return {
            v: hp
        };
    }));
    var parts = typeof TOP == "string" ? $a1a91b25d7598376$var$parseVector(TOP, opts).map(function(x) {
        return x.v;
    }) : TOP;
    var idx = 0, len = 0;
    if (parts.length > 0) for(var i = 0; i !== v.length; i += 2){
        len = +v[i + 1].v;
        switch(v[i].v){
            case "Worksheets":
            case "\u5DE5\u4F5C\u8868":
            case "\u041B\u0438\u0441\u0442\u044B":
            case "\u0623\u0648\u0631\u0627\u0642 \u0627\u0644\u0639\u0645\u0644":
            case "\u30EF\u30FC\u30AF\u30B7\u30FC\u30C8":
            case "\u05D2\u05DC\u05D9\u05D5\u05E0\u05D5\u05EA \u05E2\u05D1\u05D5\u05D3\u05D4":
            case "Arbeitsbl\xe4tter":
            case "\xc7al\u0131\u015Fma Sayfalar\u0131":
            case "Feuilles de calcul":
            case "Fogli di lavoro":
            case "Folhas de c\xe1lculo":
            case "Planilhas":
            case "Regneark":
            case "Hojas de c\xe1lculo":
            case "Werkbladen":
                props.Worksheets = len;
                props.SheetNames = parts.slice(idx, idx + len);
                break;
            case "Named Ranges":
            case "Rangos con nombre":
            case "\u540D\u524D\u4ED8\u304D\u4E00\u89A7":
            case "Benannte Bereiche":
            case "Navngivne omr\xe5der":
                props.NamedRanges = len;
                props.DefinedNames = parts.slice(idx, idx + len);
                break;
            case "Charts":
            case "Diagramme":
                props.Chartsheets = len;
                props.ChartNames = parts.slice(idx, idx + len);
                break;
        }
        idx += len;
    }
}
function $a1a91b25d7598376$var$parse_ext_props(data, p, opts) {
    var q = {};
    if (!p) p = {};
    data = $a1a91b25d7598376$var$utf8read(data);
    $a1a91b25d7598376$var$EXT_PROPS.forEach(function(f) {
        var xml = ($a1a91b25d7598376$var$str_match_xml_ns(data, f[0]) || [])[1];
        switch(f[2]){
            case "string":
                if (xml) p[f[1]] = $a1a91b25d7598376$var$unescapexml(xml);
                break;
            case "bool":
                p[f[1]] = xml === "true";
                break;
            case "raw":
                var cur = $a1a91b25d7598376$var$str_match_xml(data, f[0]);
                if (cur && cur.length > 0) q[f[1]] = cur[1];
                break;
        }
    });
    if (q.HeadingPairs && q.TitlesOfParts) $a1a91b25d7598376$var$load_props_pairs(q.HeadingPairs, q.TitlesOfParts, p, opts);
    return p;
}
function $a1a91b25d7598376$var$write_ext_props(cp /*::, opts*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], W = $a1a91b25d7598376$var$writextag;
    if (!cp) cp = {};
    cp.Application = "SheetJS";
    o[o.length] = $a1a91b25d7598376$var$XML_HEADER;
    o[o.length] = $a1a91b25d7598376$var$writextag('Properties', null, {
        'xmlns': $a1a91b25d7598376$var$XMLNS.EXT_PROPS,
        'xmlns:vt': $a1a91b25d7598376$var$XMLNS.vt
    });
    $a1a91b25d7598376$var$EXT_PROPS.forEach(function(f) {
        if (cp[f[1]] === undefined) return;
        var v;
        switch(f[2]){
            case 'string':
                v = $a1a91b25d7598376$var$escapexml(String(cp[f[1]]));
                break;
            case 'bool':
                v = cp[f[1]] ? 'true' : 'false';
                break;
        }
        if (v !== undefined) o[o.length] = W(f[0], v);
    });
    /* TODO: HeadingPairs, TitlesOfParts */ o[o.length] = W('HeadingPairs', W('vt:vector', W('vt:variant', '<vt:lpstr>Worksheets</vt:lpstr>') + W('vt:variant', W('vt:i4', String(cp.Worksheets))), {
        size: 2,
        baseType: "variant"
    }));
    o[o.length] = W('TitlesOfParts', W('vt:vector', cp.SheetNames.map(function(s) {
        return "<vt:lpstr>" + $a1a91b25d7598376$var$escapexml(s) + "</vt:lpstr>";
    }).join(""), {
        size: cp.Worksheets,
        baseType: "lpstr"
    }));
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* 15.2.12.2 Custom File Properties Part */ var $a1a91b25d7598376$var$custregex = /<[^<>]+>[^<]*/g;
function $a1a91b25d7598376$var$parse_cust_props(data /*:string*/ , opts) {
    var p = {}, name = "";
    var m = data.match($a1a91b25d7598376$var$custregex);
    if (m) for(var i = 0; i != m.length; ++i){
        var x = m[i], y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<Properties':
                break;
            case '<property':
                name = $a1a91b25d7598376$var$unescapexml(y.name);
                break;
            case '</property>':
                name = null;
                break;
            default:
                if (x.indexOf('<vt:') === 0) {
                    var toks = x.split('>');
                    var type = toks[0].slice(4), text = toks[1];
                    /* 22.4.2.32 (CT_Variant). Omit the binary types from 22.4 (Variant Types) */ switch(type){
                        case 'lpstr':
                        case 'bstr':
                        case 'lpwstr':
                            p[name] = $a1a91b25d7598376$var$unescapexml(text);
                            break;
                        case 'bool':
                            p[name] = $a1a91b25d7598376$var$parsexmlbool(text);
                            break;
                        case 'i1':
                        case 'i2':
                        case 'i4':
                        case 'i8':
                        case 'int':
                        case 'uint':
                            p[name] = parseInt(text, 10);
                            break;
                        case 'r4':
                        case 'r8':
                        case 'decimal':
                            p[name] = parseFloat(text);
                            break;
                        case 'filetime':
                        case 'date':
                            p[name] = $a1a91b25d7598376$var$parseDate(text);
                            break;
                        case 'cy':
                        case 'error':
                            p[name] = $a1a91b25d7598376$var$unescapexml(text);
                            break;
                        default:
                            if (type.slice(-1) == '/') break;
                            if (opts.WTF && typeof console !== 'undefined') console.warn('Unexpected', x, type, toks);
                    }
                } else if (x.slice(0, 2) === "</") ;
                else if (opts.WTF) throw new Error(x);
        }
    }
    return p;
}
function $a1a91b25d7598376$var$write_cust_props(cp /*::, opts*/ ) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('Properties', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS.CUST_PROPS,
            'xmlns:vt': $a1a91b25d7598376$var$XMLNS.vt
        })
    ];
    if (!cp) return o.join("");
    var pid = 1;
    $a1a91b25d7598376$var$keys(cp).forEach(function custprop(k) {
        ++pid;
        o[o.length] = $a1a91b25d7598376$var$writextag('property', $a1a91b25d7598376$var$write_vt(cp[k], true), {
            'fmtid': '{D5CDD505-2E9C-101B-9397-08002B2CF9AE}',
            'pid': pid,
            'name': $a1a91b25d7598376$var$escapexml(k)
        });
    });
    if (o.length > 2) {
        o[o.length] = '</Properties>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* Common Name -> XLML Name */ var $a1a91b25d7598376$var$XLMLDocPropsMap = {
    Title: 'Title',
    Subject: 'Subject',
    Author: 'Author',
    Keywords: 'Keywords',
    Comments: 'Description',
    LastAuthor: 'LastAuthor',
    RevNumber: 'Revision',
    Application: 'AppName',
    /* TotalTime: 'TotalTime', */ LastPrinted: 'LastPrinted',
    CreatedDate: 'Created',
    ModifiedDate: 'LastSaved',
    /* Pages */ /* Words */ /* Characters */ Category: 'Category',
    /* PresentationFormat */ Manager: 'Manager',
    Company: 'Company',
    /* Guid */ /* HyperlinkBase */ /* Bytes */ /* Lines */ /* Paragraphs */ /* CharactersWithSpaces */ AppVersion: 'Version',
    ContentStatus: 'ContentStatus',
    /* NOTE: missing from schema */ Identifier: 'Identifier',
    /* NOTE: missing from schema */ Language: 'Language' /* NOTE: missing from schema */ 
};
var $a1a91b25d7598376$var$evert_XLMLDPM;
function $a1a91b25d7598376$var$xlml_set_prop(Props, tag /*:string*/ , val1) {
    if (!$a1a91b25d7598376$var$evert_XLMLDPM) $a1a91b25d7598376$var$evert_XLMLDPM = $a1a91b25d7598376$var$evert($a1a91b25d7598376$var$XLMLDocPropsMap);
    tag = $a1a91b25d7598376$var$evert_XLMLDPM[tag] || tag;
    Props[tag] = val1;
}
function $a1a91b25d7598376$var$xlml_write_docprops(Props, opts) {
    var o /*:Array<string>*/  = [];
    $a1a91b25d7598376$var$keys($a1a91b25d7598376$var$XLMLDocPropsMap).map(function(m) {
        for(var i = 0; i < $a1a91b25d7598376$var$CORE_PROPS.length; ++i)if ($a1a91b25d7598376$var$CORE_PROPS[i][1] == m) return $a1a91b25d7598376$var$CORE_PROPS[i];
        for(i = 0; i < $a1a91b25d7598376$var$EXT_PROPS.length; ++i)if ($a1a91b25d7598376$var$EXT_PROPS[i][1] == m) return $a1a91b25d7598376$var$EXT_PROPS[i];
        throw m;
    }).forEach(function(p) {
        if (Props[p[1]] == null) return;
        var m = opts && opts.Props && opts.Props[p[1]] != null ? opts.Props[p[1]] : Props[p[1]];
        switch(p[2]){
            case 'date':
                m = new Date(m).toISOString().replace(/\.\d*Z/, "Z");
                break;
        }
        if (typeof m == 'number') m = String(m);
        else if (m === true || m === false) m = m ? "1" : "0";
        else if (m instanceof Date) m = new Date(m).toISOString().replace(/\.\d*Z/, "");
        o.push($a1a91b25d7598376$var$writetag($a1a91b25d7598376$var$XLMLDocPropsMap[p[1]] || p[1], m));
    });
    return $a1a91b25d7598376$var$writextag('DocumentProperties', o.join(""), {
        xmlns: $a1a91b25d7598376$var$XLMLNS.o
    });
}
function $a1a91b25d7598376$var$xlml_write_custprops(Props, Custprops /*::, opts*/ ) {
    var BLACKLIST = [
        "Worksheets",
        "SheetNames"
    ];
    var T = 'CustomDocumentProperties';
    var o /*:Array<string>*/  = [];
    if (Props) $a1a91b25d7598376$var$keys(Props).forEach(function(k) {
        /*:: if(!Props) return; */ if (!Object.prototype.hasOwnProperty.call(Props, k)) return;
        for(var i = 0; i < $a1a91b25d7598376$var$CORE_PROPS.length; ++i)if (k == $a1a91b25d7598376$var$CORE_PROPS[i][1]) return;
        for(i = 0; i < $a1a91b25d7598376$var$EXT_PROPS.length; ++i)if (k == $a1a91b25d7598376$var$EXT_PROPS[i][1]) return;
        for(i = 0; i < BLACKLIST.length; ++i)if (k == BLACKLIST[i]) return;
        var m = Props[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else m = String(m);
        o.push($a1a91b25d7598376$var$writextag($a1a91b25d7598376$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    if (Custprops) $a1a91b25d7598376$var$keys(Custprops).forEach(function(k) {
        /*:: if(!Custprops) return; */ if (!Object.prototype.hasOwnProperty.call(Custprops, k)) return;
        if (Props && Object.prototype.hasOwnProperty.call(Props, k)) return;
        var m = Custprops[k];
        var t = "string";
        if (typeof m == 'number') {
            t = "float";
            m = String(m);
        } else if (m === true || m === false) {
            t = "boolean";
            m = m ? "1" : "0";
        } else if (m instanceof Date) {
            t = "dateTime.tz";
            m = m.toISOString();
        } else m = String(m);
        o.push($a1a91b25d7598376$var$writextag($a1a91b25d7598376$var$escapexmltag(k), m, {
            "dt:dt": t
        }));
    });
    return '<' + T + ' xmlns="' + $a1a91b25d7598376$var$XLMLNS.o + '">' + o.join("") + '</' + T + '>';
}
/* [MS-DTYP] 2.3.3 FILETIME */ /* [MS-OLEDS] 2.1.3 FILETIME (Packet Version) */ /* [MS-OLEPS] 2.8 FILETIME (Packet Version) */ function $a1a91b25d7598376$var$parse_FILETIME(blob) {
    var dwLowDateTime = blob.read_shift(4), dwHighDateTime = blob.read_shift(4);
    return new Date((dwHighDateTime / 1e7 * Math.pow(2, 32) + dwLowDateTime / 1e7 - 11644473600) * 1000).toISOString().replace(/\.000/, "");
}
function $a1a91b25d7598376$var$write_FILETIME(time /*:string|Date*/ ) {
    var date = typeof time == "string" ? new Date(Date.parse(time)) : time;
    var t = date.getTime() / 1000 + 11644473600;
    var l = t % Math.pow(2, 32), h = (t - l) / Math.pow(2, 32);
    l *= 1e7;
    h *= 1e7;
    var w = l / Math.pow(2, 32) | 0;
    if (w > 0) {
        l = l % Math.pow(2, 32);
        h += w;
    }
    var o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, l);
    o.write_shift(4, h);
    return o;
}
/* [MS-OSHARED] 2.3.3.1.4 Lpstr */ function $a1a91b25d7598376$var$parse_lpstr(blob, type, pad /*:?number*/ ) {
    var start = blob.l;
    var str = blob.read_shift(0, 'lpstr-cp');
    if (pad) while(blob.l - start & 3)++blob.l;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.6 Lpwstr */ function $a1a91b25d7598376$var$parse_lpwstr(blob, type, pad) {
    var str = blob.read_shift(0, 'lpwstr');
    if (pad) blob.l += 4 - (str.length + 1 & 3) & 3;
    return str;
}
/* [MS-OSHARED] 2.3.3.1.11 VtString */ /* [MS-OSHARED] 2.3.3.1.12 VtUnalignedString */ function $a1a91b25d7598376$var$parse_VtStringBase(blob, stringType, pad) {
    if (stringType === 0x1F /*VT_LPWSTR*/ ) return $a1a91b25d7598376$var$parse_lpwstr(blob);
    return $a1a91b25d7598376$var$parse_lpstr(blob, stringType, pad);
}
function $a1a91b25d7598376$var$parse_VtString(blob, t /*:number*/ , pad /*:?boolean*/ ) {
    return $a1a91b25d7598376$var$parse_VtStringBase(blob, t, pad === false ? 0 : 4);
}
function $a1a91b25d7598376$var$parse_VtUnalignedString(blob, t /*:number*/ ) {
    if (!t) throw new Error("VtUnalignedString must have positive length");
    return $a1a91b25d7598376$var$parse_VtStringBase(blob, t, 0);
}
/* [MS-OSHARED] 2.3.3.1.7 VtVecLpwstrValue */ function $a1a91b25d7598376$var$parse_VtVecLpwstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i){
        var start = blob.l;
        ret[i] = blob.read_shift(0, 'lpwstr').replace($a1a91b25d7598376$var$chr0, '');
        if (blob.l - start & 0x02) blob.l += 2;
    }
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.9 VtVecUnalignedLpstrValue */ function $a1a91b25d7598376$var$parse_VtVecUnalignedLpstrValue(blob) /*:Array<string>*/ {
    var length = blob.read_shift(4);
    var ret /*:Array<string>*/  = [];
    for(var i = 0; i != length; ++i)ret[i] = blob.read_shift(0, 'lpstr-cp').replace($a1a91b25d7598376$var$chr0, '');
    return ret;
}
/* [MS-OSHARED] 2.3.3.1.13 VtHeadingPair */ function $a1a91b25d7598376$var$parse_VtHeadingPair(blob) {
    var start = blob.l;
    var headingString = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, $a1a91b25d7598376$var$VT_USTR);
    if (blob[blob.l] == 0x00 && blob[blob.l + 1] == 0x00 && blob.l - start & 0x02) blob.l += 2;
    var headerParts = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, $a1a91b25d7598376$var$VT_I4);
    return [
        headingString,
        headerParts
    ];
}
/* [MS-OSHARED] 2.3.3.1.14 VtVecHeadingPairValue */ function $a1a91b25d7598376$var$parse_VtVecHeadingPairValue(blob) {
    var cElements = blob.read_shift(4);
    var out = [];
    for(var i = 0; i < cElements / 2; ++i)out.push($a1a91b25d7598376$var$parse_VtHeadingPair(blob));
    return out;
}
/* [MS-OLEPS] 2.18.1 Dictionary (uses 2.17, 2.16) */ function $a1a91b25d7598376$var$parse_dictionary(blob, CodePage) {
    var cnt = blob.read_shift(4);
    var dict /*:{[number]:string}*/  = {} /*:any*/ ;
    for(var j = 0; j != cnt; ++j){
        var pid = blob.read_shift(4);
        var len = blob.read_shift(4);
        dict[pid] = blob.read_shift(len, CodePage === 0x4B0 ? 'utf16le' : 'utf8').replace($a1a91b25d7598376$var$chr0, '').replace($a1a91b25d7598376$var$chr1, '!');
        if (CodePage === 0x4B0 && len % 2) blob.l += 2;
    }
    if (blob.l & 3) blob.l = blob.l >> 3 << 2;
    return dict;
}
/* [MS-OLEPS] 2.9 BLOB */ function $a1a91b25d7598376$var$parse_BLOB(blob) {
    var size = blob.read_shift(4);
    var bytes = blob.slice(blob.l, blob.l + size);
    blob.l += size;
    if ((size & 3) > 0) blob.l += 4 - (size & 3) & 3;
    return bytes;
}
/* [MS-OLEPS] 2.11 ClipboardData */ function $a1a91b25d7598376$var$parse_ClipboardData(blob) {
    // TODO
    var o = {};
    o.Size = blob.read_shift(4);
    //o.Format = blob.read_shift(4);
    blob.l += o.Size + 3 - (o.Size - 1) % 4;
    return o;
}
/* [MS-OLEPS] 2.15 TypedPropertyValue */ function $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, type /*:number*/ , _opts) /*:any*/ {
    var t = blob.read_shift(2), ret, opts = _opts || {};
    blob.l += 2;
    if (type !== $a1a91b25d7598376$var$VT_VARIANT) {
        if (t !== type && $a1a91b25d7598376$var$VT_CUSTOM.indexOf(type) === -1 && !((type & 0xFFFE) == 0x101E && (t & 0xFFFE) == 0x101E)) throw new Error('Expected type ' + type + ' saw ' + t);
    }
    switch(type === $a1a91b25d7598376$var$VT_VARIANT ? t : type){
        case 0x02 /*VT_I2*/ :
            ret = blob.read_shift(2, 'i');
            if (!opts.raw) blob.l += 2;
            return ret;
        case 0x03 /*VT_I4*/ :
            ret = blob.read_shift(4, 'i');
            return ret;
        case 0x0B /*VT_BOOL*/ :
            return blob.read_shift(4) !== 0x0;
        case 0x13 /*VT_UI4*/ :
            ret = blob.read_shift(4);
            return ret;
        case 0x1E /*VT_LPSTR*/ :
            blob.l += 4;
            val = $a1a91b25d7598376$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x1F /*VT_LPWSTR*/ :
            blob.l += 4;
            val = $a1a91b25d7598376$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
            break;
        case 0x40 /*VT_FILETIME*/ :
            return $a1a91b25d7598376$var$parse_FILETIME(blob);
        case 0x41 /*VT_BLOB*/ :
            return $a1a91b25d7598376$var$parse_BLOB(blob);
        case 0x47 /*VT_CF*/ :
            return $a1a91b25d7598376$var$parse_ClipboardData(blob);
        case 0x50 /*VT_STRING*/ :
            return $a1a91b25d7598376$var$parse_VtString(blob, t, !opts.raw).replace($a1a91b25d7598376$var$chr0, '');
        case 0x51 /*VT_USTR*/ :
            return $a1a91b25d7598376$var$parse_VtUnalignedString(blob, t /*, 4*/ ).replace($a1a91b25d7598376$var$chr0, '');
        case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
            return $a1a91b25d7598376$var$parse_VtVecHeadingPairValue(blob);
        case 0x101E /*VT_VECTOR|VT_LPSTR*/ :
        case 0x101F /*VT_VECTOR|VT_LPWSTR*/ :
            return t == 0x101F ? $a1a91b25d7598376$var$parse_VtVecLpwstrValue(blob) : $a1a91b25d7598376$var$parse_VtVecUnalignedLpstrValue(blob);
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + t);
    }
}
function $a1a91b25d7598376$var$write_TypedPropertyValue(type /*:number*/ , value) {
    var o = $a1a91b25d7598376$var$new_buf(4), p = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(4, type == 0x50 ? 0x1F : type);
    switch(type){
        case 0x03 /*VT_I4*/ :
            p.write_shift(-4, value);
            break;
        case 0x05 /*VT_I4*/ :
            p = $a1a91b25d7598376$var$new_buf(8);
            p.write_shift(8, value, 'f');
            break;
        case 0x0B /*VT_BOOL*/ :
            p.write_shift(4, value ? 0x01 : 0x00);
            break;
        case 0x40 /*VT_FILETIME*/ :
            /*:: if(typeof value !== "string" && !(value instanceof Date)) throw "unreachable"; */ p = $a1a91b25d7598376$var$write_FILETIME(value);
            break;
        case 0x1F /*VT_LPWSTR*/ :
        case 0x50 /*VT_STRING*/ :
            /*:: if(typeof value !== "string") throw "unreachable"; */ p = $a1a91b25d7598376$var$new_buf(4 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            p.write_shift(4, value.length + 1);
            p.write_shift(0, value, "dbcs");
            while(p.l != p.length)p.write_shift(1, 0);
            break;
        default:
            throw new Error("TypedPropertyValue unrecognized type " + type + " " + value);
    }
    return $a1a91b25d7598376$var$bconcat([
        o,
        p
    ]);
}
/* [MS-OLEPS] 2.20 PropertySet */ function $a1a91b25d7598376$var$parse_PropertySet(blob, PIDSI) {
    var start_addr = blob.l;
    var size = blob.read_shift(4);
    var NumProps = blob.read_shift(4);
    var Props = [], i = 0;
    var CodePage = 0;
    var Dictionary = -1, DictObj /*:{[number]:string}*/  = {} /*:any*/ ;
    for(i = 0; i != NumProps; ++i){
        var PropID = blob.read_shift(4);
        var Offset = blob.read_shift(4);
        Props[i] = [
            PropID,
            Offset + start_addr
        ];
    }
    Props.sort(function(x, y) {
        return x[1] - y[1];
    });
    var PropH = {};
    for(i = 0; i != NumProps; ++i){
        if (blob.l !== Props[i][1]) {
            var fail = true;
            if (i > 0 && PIDSI) switch(PIDSI[Props[i - 1][0]].t){
                case 0x02 /*VT_I2*/ :
                    if (blob.l + 2 === Props[i][1]) {
                        blob.l += 2;
                        fail = false;
                    }
                    break;
                case 0x50 /*VT_STRING*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
                case 0x100C /*VT_VECTOR|VT_VARIANT*/ :
                    if (blob.l <= Props[i][1]) {
                        blob.l = Props[i][1];
                        fail = false;
                    }
                    break;
            }
            if ((!PIDSI || i == 0) && blob.l <= Props[i][1]) {
                fail = false;
                blob.l = Props[i][1];
            }
            if (fail) throw new Error("Read Error: Expected address " + Props[i][1] + ' at ' + blob.l + ' :' + i);
        }
        if (PIDSI) {
            if (Props[i][0] == 0 && Props.length > i + 1 && Props[i][1] == Props[i + 1][1]) continue; // R9
            var piddsi = PIDSI[Props[i][0]];
            PropH[piddsi.n] = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, piddsi.t, {
                raw: true
            });
            if (piddsi.p === 'version') PropH[piddsi.n] = String(PropH[piddsi.n] >> 16) + "." + ("0000" + String(PropH[piddsi.n] & 0xFFFF)).slice(-4);
            if (piddsi.n == "CodePage") switch(PropH[piddsi.n]){
                case 0:
                    PropH[piddsi.n] = 1252;
                /* falls through */ case 874:
                case 932:
                case 936:
                case 949:
                case 950:
                case 1250:
                case 1251:
                case 1253:
                case 1254:
                case 1255:
                case 1256:
                case 1257:
                case 1258:
                case 10000:
                case 1200:
                case 1201:
                case 1252:
                case 65000:
                case -536:
                case 65001:
                case -535:
                    $a1a91b25d7598376$var$set_cp(CodePage = PropH[piddsi.n] >>> 0 & 0xFFFF);
                    break;
                default:
                    throw new Error("Unsupported CodePage: " + PropH[piddsi.n]);
            }
        } else {
            if (Props[i][0] === 0x1) {
                CodePage = PropH.CodePage = $a1a91b25d7598376$var$parse_TypedPropertyValue(blob, $a1a91b25d7598376$var$VT_I2);
                $a1a91b25d7598376$var$set_cp(CodePage);
                if (Dictionary !== -1) {
                    var oldpos = blob.l;
                    blob.l = Props[Dictionary][1];
                    DictObj = $a1a91b25d7598376$var$parse_dictionary(blob, CodePage);
                    blob.l = oldpos;
                }
            } else if (Props[i][0] === 0) {
                if (CodePage === 0) {
                    Dictionary = i;
                    blob.l = Props[i + 1][1];
                    continue;
                }
                DictObj = $a1a91b25d7598376$var$parse_dictionary(blob, CodePage);
            } else {
                var name = DictObj[Props[i][0]];
                var val1;
                /* [MS-OSHARED] 2.3.3.2.3.1.2 + PROPVARIANT */ switch(blob[blob.l]){
                    case 0x41 /*VT_BLOB*/ :
                        blob.l += 4;
                        val1 = $a1a91b25d7598376$var$parse_BLOB(blob);
                        break;
                    case 0x1E /*VT_LPSTR*/ :
                        blob.l += 4;
                        val1 = $a1a91b25d7598376$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x1F /*VT_LPWSTR*/ :
                        blob.l += 4;
                        val1 = $a1a91b25d7598376$var$parse_VtString(blob, blob[blob.l - 4]).replace(/(^|[^\u0000])\u0000+$/, "$1");
                        break;
                    case 0x03 /*VT_I4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4, 'i');
                        break;
                    case 0x13 /*VT_UI4*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(4);
                        break;
                    case 0x05 /*VT_R8*/ :
                        blob.l += 4;
                        val1 = blob.read_shift(8, 'f');
                        break;
                    case 0x0B /*VT_BOOL*/ :
                        blob.l += 4;
                        val1 = $a1a91b25d7598376$var$parsebool(blob, 4);
                        break;
                    case 0x40 /*VT_FILETIME*/ :
                        blob.l += 4;
                        val1 = $a1a91b25d7598376$var$parseDate($a1a91b25d7598376$var$parse_FILETIME(blob));
                        break;
                    default:
                        throw new Error("unparsed value: " + blob[blob.l]);
                }
                PropH[name] = val1;
            }
        }
    }
    blob.l = start_addr + size; /* step ahead to skip padding */ 
    return PropH;
}
var $a1a91b25d7598376$var$XLSPSSkip = [
    "CodePage",
    "Thumbnail",
    "_PID_LINKBASE",
    "_PID_HLINKS",
    "SystemIdentifier",
    "FMTID"
];
function $a1a91b25d7598376$var$guess_property_type(val1 /*:any*/ ) /*:number*/ {
    switch(typeof val1){
        case "boolean":
            return 0x0B;
        case "number":
            return (val1 | 0) == val1 ? 0x03 : 0x05;
        case "string":
            return 0x1F;
        case "object":
            if (val1 instanceof Date) return 0x40;
            break;
    }
    return -1;
}
function $a1a91b25d7598376$var$write_PropertySet(entries, RE, PIDSI) {
    var hdr = $a1a91b25d7598376$var$new_buf(8), piao = [], prop = [];
    var sz = 8, i = 0;
    var pr = $a1a91b25d7598376$var$new_buf(8), pio = $a1a91b25d7598376$var$new_buf(8);
    pr.write_shift(4, 0x0002);
    pr.write_shift(4, 0x04B0);
    pio.write_shift(4, 0x0001);
    prop.push(pr);
    piao.push(pio);
    sz += 8 + pr.length;
    if (!RE) {
        pio = $a1a91b25d7598376$var$new_buf(8);
        pio.write_shift(4, 0);
        piao.unshift(pio);
        var bufs = [
            $a1a91b25d7598376$var$new_buf(4)
        ];
        bufs[0].write_shift(4, entries.length);
        for(i = 0; i < entries.length; ++i){
            var value = entries[i][0];
            pr = $a1a91b25d7598376$var$new_buf(8 + 2 * (value.length + 1) + (value.length % 2 ? 0 : 2));
            pr.write_shift(4, i + 2);
            pr.write_shift(4, value.length + 1);
            pr.write_shift(0, value, "dbcs");
            while(pr.l != pr.length)pr.write_shift(1, 0);
            bufs.push(pr);
        }
        pr = $a1a91b25d7598376$var$bconcat(bufs);
        prop.unshift(pr);
        sz += 8 + pr.length;
    }
    for(i = 0; i < entries.length; ++i){
        if (RE && !RE[entries[i][0]]) continue;
        if ($a1a91b25d7598376$var$XLSPSSkip.indexOf(entries[i][0]) > -1 || $a1a91b25d7598376$var$PseudoPropsPairs.indexOf(entries[i][0]) > -1) continue;
        if (entries[i][1] == null) continue;
        var val1 = entries[i][1], idx = 0;
        if (RE) {
            idx = +RE[entries[i][0]];
            var pinfo = PIDSI /*:: || {}*/ [idx] /*:: || {} */ ;
            if (pinfo.p == "version" && typeof val1 == "string") {
                /*:: if(typeof val !== "string") throw "unreachable"; */ var arr = val1.split(".");
                val1 = (+arr[0] << 16) + (+arr[1] || 0);
            }
            pr = $a1a91b25d7598376$var$write_TypedPropertyValue(pinfo.t, val1);
        } else {
            var T = $a1a91b25d7598376$var$guess_property_type(val1);
            if (T == -1) {
                T = 0x1F;
                val1 = String(val1);
            }
            pr = $a1a91b25d7598376$var$write_TypedPropertyValue(T, val1);
        }
        prop.push(pr);
        pio = $a1a91b25d7598376$var$new_buf(8);
        pio.write_shift(4, !RE ? 2 + i : idx);
        piao.push(pio);
        sz += 8 + pr.length;
    }
    var w = 8 * (prop.length + 1);
    for(i = 0; i < prop.length; ++i){
        piao[i].write_shift(4, w);
        w += prop[i].length;
    }
    hdr.write_shift(4, sz);
    hdr.write_shift(4, prop.length);
    return $a1a91b25d7598376$var$bconcat([
        hdr
    ].concat(piao).concat(prop));
}
/* [MS-OLEPS] 2.21 PropertySetStream */ function $a1a91b25d7598376$var$parse_PropertySetStream(file, PIDSI, clsid) {
    var blob = file.content;
    if (!blob) return {} /*:any*/ ;
    $a1a91b25d7598376$var$prep_blob(blob, 0);
    var NumSets, FMTID0, FMTID1, Offset0, Offset1 = 0;
    blob.chk('feff', 'Byte Order: ');
    /*var vers = */ blob.read_shift(2); // TODO: check version
    var SystemIdentifier = blob.read_shift(4);
    var CLSID = blob.read_shift(16);
    if (CLSID !== $a1a91b25d7598376$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID && CLSID !== clsid) throw new Error("Bad PropertySet CLSID " + CLSID);
    NumSets = blob.read_shift(4);
    if (NumSets !== 1 && NumSets !== 2) throw new Error("Unrecognized #Sets: " + NumSets);
    FMTID0 = blob.read_shift(16);
    Offset0 = blob.read_shift(4);
    if (NumSets === 1 && Offset0 !== blob.l) throw new Error("Length mismatch: " + Offset0 + " !== " + blob.l);
    else if (NumSets === 2) {
        FMTID1 = blob.read_shift(16);
        Offset1 = blob.read_shift(4);
    }
    var PSet0 = $a1a91b25d7598376$var$parse_PropertySet(blob, PIDSI);
    var rval = {
        SystemIdentifier: SystemIdentifier
    } /*:any*/ ;
    for(var y in PSet0)rval[y] = PSet0[y];
    //rval.blob = blob;
    rval.FMTID = FMTID0;
    //rval.PSet0 = PSet0;
    if (NumSets === 1) return rval;
    if (Offset1 - blob.l == 2) blob.l += 2;
    if (blob.l !== Offset1) throw new Error("Length mismatch 2: " + blob.l + " !== " + Offset1);
    var PSet1;
    try {
        PSet1 = $a1a91b25d7598376$var$parse_PropertySet(blob, null);
    } catch (e) {}
    for(y in PSet1)rval[y] = PSet1[y];
    rval.FMTID = [
        FMTID0,
        FMTID1
    ]; // TODO: verify FMTID0/1
    return rval;
}
function $a1a91b25d7598376$var$write_PropertySetStream(entries, clsid, RE, PIDSI /*:{[key:string|number]:any}*/ , entries2 /*:?any*/ , clsid2 /*:?any*/ ) {
    var hdr = $a1a91b25d7598376$var$new_buf(entries2 ? 68 : 48);
    var bufs = [
        hdr
    ];
    hdr.write_shift(2, 0xFFFE);
    hdr.write_shift(2, 0x0000); /* TODO: type 1 props */ 
    hdr.write_shift(4, 0x32363237);
    hdr.write_shift(16, $a1a91b25d7598376$export$9f0e51cd97c572a.utils.consts.HEADER_CLSID, "hex");
    hdr.write_shift(4, entries2 ? 2 : 1);
    hdr.write_shift(16, clsid, "hex");
    hdr.write_shift(4, entries2 ? 68 : 48);
    var ps0 = $a1a91b25d7598376$var$write_PropertySet(entries, RE, PIDSI);
    bufs.push(ps0);
    if (entries2) {
        var ps1 = $a1a91b25d7598376$var$write_PropertySet(entries2, null, null);
        hdr.write_shift(16, clsid2, "hex");
        hdr.write_shift(4, 68 + ps0.length);
        bufs.push(ps1);
    }
    return $a1a91b25d7598376$var$bconcat(bufs);
}
function $a1a91b25d7598376$var$parsenoop2(blob, length) {
    blob.read_shift(length);
    return null;
}
function $a1a91b25d7598376$var$writezeroes(n, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(n);
    for(var j = 0; j < n; ++j)o.write_shift(1, 0);
    return o;
}
function $a1a91b25d7598376$var$parslurp(blob, length, cb) {
    var arr = [], target = blob.l + length;
    while(blob.l < target)arr.push(cb(blob, target - blob.l));
    if (target !== blob.l) throw new Error("Slurp error");
    return arr;
}
function $a1a91b25d7598376$var$parsebool(blob, length /*:number*/ ) {
    return blob.read_shift(length) === 0x1;
}
function $a1a91b25d7598376$var$writebool(v /*:any*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    o.write_shift(2, +!!v);
    return o;
}
function $a1a91b25d7598376$var$parseuint16(blob /*::, length:?number, opts:?any*/ ) {
    return blob.read_shift(2, 'u');
}
function $a1a91b25d7598376$var$writeuint16(v /*:number*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    o.write_shift(2, v);
    return o;
}
function $a1a91b25d7598376$var$parseuint16a(blob, length /*:: :?number, opts:?any*/ ) {
    return $a1a91b25d7598376$var$parslurp(blob, length, $a1a91b25d7598376$var$parseuint16);
}
/* --- 2.5 Structures --- */ /* [MS-XLS] 2.5.10 Bes (boolean or error) */ function $a1a91b25d7598376$var$parse_Bes(blob /*::, length*/ ) {
    var v = blob.read_shift(1), t = blob.read_shift(1);
    return t === 0x01 ? v : v === 0x01;
}
function $a1a91b25d7598376$var$write_Bes(v, t /*:string*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(2);
    o.write_shift(1, t == 'e' ? +v : +!!v);
    o.write_shift(1, t == 'e' ? 1 : 0);
    return o;
}
/* [MS-XLS] 2.5.240 ShortXLUnicodeString */ function $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff >= 12 ? 2 : 1);
    var encoding = 'sbcs-cont';
    var cp = $a1a91b25d7598376$var$current_codepage;
    if (opts && opts.biff >= 8) $a1a91b25d7598376$var$current_codepage = 1200;
    if (!opts || opts.biff == 8) {
        var fHighByte = blob.read_shift(1);
        if (fHighByte) encoding = 'dbcs-cont';
    } else if (opts.biff == 12) encoding = 'wstr';
    if (opts.biff >= 2 && opts.biff <= 5) encoding = 'cpstr';
    var o = cch ? blob.read_shift(cch, encoding) : "";
    $a1a91b25d7598376$var$current_codepage = cp;
    return o;
}
/* 2.5.293 XLUnicodeRichExtendedString */ function $a1a91b25d7598376$var$parse_XLUnicodeRichExtendedString(blob) {
    var cp = $a1a91b25d7598376$var$current_codepage;
    $a1a91b25d7598376$var$current_codepage = 1200;
    var cch = blob.read_shift(2), flags = blob.read_shift(1);
    var /*fHighByte = flags & 0x1,*/ fExtSt = flags & 0x4, fRichSt = flags & 0x8;
    var width = 1 + (flags & 0x1); // 0x0 -> utf8, 0x1 -> dbcs
    var cRun = 0, cbExtRst;
    var z = {};
    if (fRichSt) cRun = blob.read_shift(2);
    if (fExtSt) cbExtRst = blob.read_shift(4);
    var encoding = width == 2 ? 'dbcs-cont' : 'sbcs-cont';
    var msg = cch === 0 ? "" : blob.read_shift(cch, encoding);
    if (fRichSt) blob.l += 4 * cRun; //TODO: parse this
    if (fExtSt) blob.l += cbExtRst; //TODO: parse this
    z.t = msg;
    if (!fRichSt) {
        z.raw = "<t>" + z.t + "</t>";
        z.r = z.t;
    }
    $a1a91b25d7598376$var$current_codepage = cp;
    return z;
}
function $a1a91b25d7598376$var$write_XLUnicodeRichExtendedString(xlstr /*:: :XLString, opts*/ ) {
    var str = xlstr.t || "", nfmts = 1;
    var hdr = $a1a91b25d7598376$var$new_buf(3 + (nfmts > 1 ? 2 : 0));
    hdr.write_shift(2, str.length);
    hdr.write_shift(1, (nfmts > 1 ? 0x08 : 0x00) | 0x01);
    if (nfmts > 1) hdr.write_shift(2, nfmts);
    var otext = $a1a91b25d7598376$var$new_buf(2 * str.length);
    otext.write_shift(2 * str.length, str, 'utf16le');
    var out = [
        hdr,
        otext
    ];
    return $a1a91b25d7598376$var$bconcat(out);
}
/* 2.5.296 XLUnicodeStringNoCch */ function $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts) {
    var retval;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return blob.read_shift(cch, 'cpstr');
        if (opts.biff >= 12) return blob.read_shift(cch, 'dbcs-cont');
    }
    var fHighByte = blob.read_shift(1);
    if (fHighByte === 0) retval = blob.read_shift(cch, 'sbcs-cont');
    else retval = blob.read_shift(cch, 'dbcs-cont');
    return retval;
}
/* 2.5.294 XLUnicodeString */ function $a1a91b25d7598376$var$parse_XLUnicodeString(blob, length, opts) {
    var cch = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
}
/* BIFF5 override */ function $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, length, opts) {
    if (opts.biff > 5) return $a1a91b25d7598376$var$parse_XLUnicodeString(blob, length, opts);
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, opts.biff <= 4 || !blob.lens ? 'cpstr' : 'sbcs-cont');
}
/* TODO: BIFF5 and lower, codepage awareness */ function $a1a91b25d7598376$var$write_XLUnicodeString(str, opts, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(3 + 2 * str.length);
    o.write_shift(2, str.length);
    o.write_shift(1, 1);
    o.write_shift(31, str, 'utf16le');
    return o;
}
/* [MS-XLS] 2.5.61 ControlInfo */ function $a1a91b25d7598376$var$parse_ControlInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(1);
    blob.l++;
    var accel = blob.read_shift(2);
    blob.l += 2;
    return [
        flags,
        accel
    ];
}
/* [MS-OSHARED] 2.3.7.6 URLMoniker TODO: flags */ function $a1a91b25d7598376$var$parse_URLMoniker(blob /*::, length, opts*/ ) {
    var len = blob.read_shift(4), start = blob.l;
    var extra = false;
    if (len > 24) {
        /* look ahead */ blob.l += len - 24;
        if (blob.read_shift(16) === "795881f43b1d7f48af2c825dc4852763") extra = true;
        blob.l = start;
    }
    var url = blob.read_shift((extra ? len - 24 : len) >> 1, 'utf16le').replace($a1a91b25d7598376$var$chr0, "");
    if (extra) blob.l += 24;
    return url;
}
/* [MS-OSHARED] 2.3.7.8 FileMoniker TODO: all fields */ function $a1a91b25d7598376$var$parse_FileMoniker(blob /*::, length*/ ) {
    var cAnti = blob.read_shift(2);
    var preamble = "";
    while(cAnti-- > 0)preamble += "../";
    var ansiPath = blob.read_shift(0, 'lpstr-ansi');
    blob.l += 2; //var endServer = blob.read_shift(2);
    if (blob.read_shift(2) != 0xDEAD) throw new Error("Bad FileMoniker");
    var sz = blob.read_shift(4);
    if (sz === 0) return preamble + ansiPath.replace(/\\/g, "/");
    var bytes = blob.read_shift(4);
    if (blob.read_shift(2) != 3) throw new Error("Bad FileMoniker");
    var unicodePath = blob.read_shift(bytes >> 1, 'utf16le').replace($a1a91b25d7598376$var$chr0, "");
    return preamble + unicodePath;
}
/* [MS-OSHARED] 2.3.7.2 HyperlinkMoniker TODO: all the monikers */ function $a1a91b25d7598376$var$parse_HyperlinkMoniker(blob, length) {
    var clsid = blob.read_shift(16);
    length -= 16;
    switch(clsid){
        case "e0c9ea79f9bace118c8200aa004ba90b":
            return $a1a91b25d7598376$var$parse_URLMoniker(blob, length);
        case "0303000000000000c000000000000046":
            return $a1a91b25d7598376$var$parse_FileMoniker(blob, length);
        default:
            throw new Error("Unsupported Moniker " + clsid);
    }
}
/* [MS-OSHARED] 2.3.7.9 HyperlinkString */ function $a1a91b25d7598376$var$parse_HyperlinkString(blob /*::, length*/ ) {
    var len = blob.read_shift(4);
    var o = len > 0 ? blob.read_shift(len, 'utf16le').replace($a1a91b25d7598376$var$chr0, "") : "";
    return o;
}
function $a1a91b25d7598376$var$write_HyperlinkString(str /*:string*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(6 + str.length * 2);
    o.write_shift(4, 1 + str.length);
    for(var i = 0; i < str.length; ++i)o.write_shift(2, str.charCodeAt(i));
    o.write_shift(2, 0);
    return o;
}
/* [MS-OSHARED] 2.3.7.1 Hyperlink Object */ function $a1a91b25d7598376$var$parse_Hyperlink(blob, length) /*:Hyperlink*/ {
    var end = blob.l + length;
    var sVer = blob.read_shift(4);
    if (sVer !== 2) throw new Error("Unrecognized streamVersion: " + sVer);
    var flags = blob.read_shift(2);
    blob.l += 2;
    var displayName, targetFrameName, moniker, oleMoniker, Loc = "", guid, fileTime;
    if (flags & 0x0010) displayName = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0080) targetFrameName = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0101) moniker = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if ((flags & 0x0101) === 0x0001) oleMoniker = $a1a91b25d7598376$var$parse_HyperlinkMoniker(blob, end - blob.l);
    if (flags & 0x0008) Loc = $a1a91b25d7598376$var$parse_HyperlinkString(blob, end - blob.l);
    if (flags & 0x0020) guid = blob.read_shift(16);
    if (flags & 0x0040) fileTime = $a1a91b25d7598376$var$parse_FILETIME(blob /*, 8*/ );
    blob.l = end;
    var target = targetFrameName || moniker || oleMoniker || "";
    if (target && Loc) target += "#" + Loc;
    if (!target) target = "#" + Loc;
    if (flags & 0x0002 && target.charAt(0) == "/" && target.charAt(1) != "/") target = "file://" + target;
    var out = {
        Target: target
    } /*:any*/ ;
    if (guid) out.guid = guid;
    if (fileTime) out.time = fileTime;
    if (displayName) out.Tooltip = displayName;
    return out;
}
function $a1a91b25d7598376$var$write_Hyperlink(hl) {
    var out = $a1a91b25d7598376$var$new_buf(512), i = 0;
    var Target = hl.Target;
    if (Target.slice(0, 7) == "file://") Target = Target.slice(7);
    var hashidx = Target.indexOf("#");
    var F = hashidx > -1 ? 0x1f : 0x17;
    switch(Target.charAt(0)){
        case "#":
            F = 0x1c;
            break;
        case ".":
            F &= -3;
            break;
    }
    out.write_shift(4, 2);
    out.write_shift(4, F);
    var data = [
        8,
        6815827,
        6619237,
        4849780,
        83
    ];
    for(i = 0; i < data.length; ++i)out.write_shift(4, data[i]);
    if (F == 0x1C) {
        Target = Target.slice(1);
        $a1a91b25d7598376$var$write_HyperlinkString(Target, out);
    } else if (F & 0x02) {
        data = "e0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var Pretarget = hashidx > -1 ? Target.slice(0, hashidx) : Target;
        out.write_shift(4, 2 * (Pretarget.length + 1));
        for(i = 0; i < Pretarget.length; ++i)out.write_shift(2, Pretarget.charCodeAt(i));
        out.write_shift(2, 0);
        if (F & 0x08) $a1a91b25d7598376$var$write_HyperlinkString(hashidx > -1 ? Target.slice(hashidx + 1) : "", out);
    } else {
        data = "03 03 00 00 00 00 00 00 c0 00 00 00 00 00 00 46".split(" ");
        for(i = 0; i < data.length; ++i)out.write_shift(1, parseInt(data[i], 16));
        var P = 0;
        while(Target.slice(P * 3, P * 3 + 3) == "../" || Target.slice(P * 3, P * 3 + 3) == "..\\")++P;
        out.write_shift(2, P);
        out.write_shift(4, Target.length - 3 * P + 1);
        for(i = 0; i < Target.length - 3 * P; ++i)out.write_shift(1, Target.charCodeAt(i + 3 * P) & 0xFF);
        out.write_shift(1, 0);
        out.write_shift(2, 0xFFFF);
        out.write_shift(2, 0xDEAD);
        for(i = 0; i < 6; ++i)out.write_shift(4, 0);
    }
    return out.slice(0, out.l);
}
/* 2.5.178 LongRGBA */ function $a1a91b25d7598376$var$parse_LongRGBA(blob /*::, length*/ ) {
    var r = blob.read_shift(1), g = blob.read_shift(1), b = blob.read_shift(1), a = blob.read_shift(1);
    return [
        r,
        g,
        b,
        a
    ];
}
/* 2.5.177 LongRGB */ function $a1a91b25d7598376$var$parse_LongRGB(blob, length) {
    var x = $a1a91b25d7598376$var$parse_LongRGBA(blob, length);
    x[3] = 0;
    return x;
}
/* [MS-XLS] 2.5.19 */ function $a1a91b25d7598376$var$parse_XLSCell(blob, length, opts) /*:Cell*/ {
    var rw = blob.read_shift(2); // 0-indexed
    var col = blob.read_shift(2);
    var ret = {
        r: rw,
        c: col,
        ixfe: 0
    } /*:any*/ ;
    if (opts && opts.biff == 2 || length == 7) {
        /* TODO: pass back flags */ var flags = blob.read_shift(1);
        ret.ixfe = flags & 0x3F;
        blob.l += 2;
    /*
		var ifntifmt = blob.read_shift(1);
		var ifmt = ifntifmt & 0x3f, ifnt = ifntifmt >> 6;
		var flags3 = blob.read_shift(1);
		*/ } else ret.ixfe = blob.read_shift(2);
    return ret;
}
function $a1a91b25d7598376$var$write_XLSCell(R /*:number*/ , C /*:number*/ , ixfe /*:?number*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(6);
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, ixfe || 0);
    return o;
}
/* [MS-XLS] 2.5.134 */ function $a1a91b25d7598376$var$parse_frtHeader(blob) {
    var rt = blob.read_shift(2);
    var flags = blob.read_shift(2); // TODO: parse these flags
    blob.l += 8;
    return {
        type: rt,
        flags: flags
    };
}
function $a1a91b25d7598376$var$parse_OptXLUnicodeString(blob, length, opts) {
    return length === 0 ? "" : $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, length, opts);
}
/* [MS-XLS] 2.5.344 */ function $a1a91b25d7598376$var$parse_XTI(blob, length, opts) {
    var w = opts.biff > 8 ? 4 : 2;
    var iSupBook = blob.read_shift(w), itabFirst = blob.read_shift(w, 'i'), itabLast = blob.read_shift(w, 'i');
    return [
        iSupBook,
        itabFirst,
        itabLast
    ];
}
/* [MS-XLS] 2.5.218 */ function $a1a91b25d7598376$var$parse_RkRec(blob) {
    var ixfe = blob.read_shift(2);
    var RK = $a1a91b25d7598376$var$parse_RkNumber(blob);
    return [
        ixfe,
        RK
    ];
}
/* [MS-XLS] 2.5.1 */ function $a1a91b25d7598376$var$parse_AddinUdf(blob, length, opts) {
    blob.l += 4;
    length -= 4;
    var l = blob.l + length;
    var udfName = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length, opts);
    var cb = blob.read_shift(2);
    l -= blob.l;
    if (cb !== l) throw new Error("Malformed AddinUdf: padding = " + l + " != " + cb);
    blob.l += cb;
    return udfName;
}
/* [MS-XLS] 2.5.209 TODO: Check sizes */ function $a1a91b25d7598376$var$parse_Ref8U(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(2);
    var colLast = blob.read_shift(2);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
function $a1a91b25d7598376$var$write_Ref8U(r /*:Range*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(2, r.s.r);
    o.write_shift(2, r.e.r);
    o.write_shift(2, r.s.c);
    o.write_shift(2, r.e.c);
    return o;
}
/* [MS-XLS] 2.5.211 */ function $a1a91b25d7598376$var$parse_RefU(blob /*::, length*/ ) {
    var rwFirst = blob.read_shift(2);
    var rwLast = blob.read_shift(2);
    var colFirst = blob.read_shift(1);
    var colLast = blob.read_shift(1);
    return {
        s: {
            c: colFirst,
            r: rwFirst
        },
        e: {
            c: colLast,
            r: rwLast
        }
    };
}
/* [MS-XLS] 2.5.207 */ var $a1a91b25d7598376$var$parse_Ref = $a1a91b25d7598376$var$parse_RefU;
/* [MS-XLS] 2.5.143 */ function $a1a91b25d7598376$var$parse_FtCmo(blob /*::, length*/ ) {
    blob.l += 4;
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var flags = blob.read_shift(2);
    blob.l += 12;
    return [
        id,
        ot,
        flags
    ];
}
/* [MS-XLS] 2.5.149 */ function $a1a91b25d7598376$var$parse_FtNts(blob) {
    var out = {};
    blob.l += 4;
    blob.l += 16; // GUID TODO
    out.fSharedNote = blob.read_shift(2);
    blob.l += 4;
    return out;
}
/* [MS-XLS] 2.5.142 */ function $a1a91b25d7598376$var$parse_FtCf(blob) {
    var out = {};
    blob.l += 4;
    blob.cf = blob.read_shift(2);
    return out;
}
/* [MS-XLS] 2.5.140 - 2.5.154 and friends */ function $a1a91b25d7598376$var$parse_FtSkip(blob) {
    blob.l += 2;
    blob.l += blob.read_shift(2);
}
var $a1a91b25d7598376$var$FtTab = {
    0x00: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtEnd */ 0x04: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtMacro */ 0x05: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtButton */ 0x06: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtGmo */ 0x07: $a1a91b25d7598376$var$parse_FtCf,
    /* FtCf */ 0x08: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtPioGrbit */ 0x09: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtPictFmla */ 0x0A: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtCbls */ 0x0B: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtRbo */ 0x0C: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtSbs */ 0x0D: $a1a91b25d7598376$var$parse_FtNts,
    /* FtNts */ 0x0E: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtSbsFmla */ 0x0F: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtGboData */ 0x10: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtEdoData */ 0x11: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtRboData */ 0x12: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtCblsData */ 0x13: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtLbsData */ 0x14: $a1a91b25d7598376$var$parse_FtSkip,
    /* FtCblsFmla */ 0x15: $a1a91b25d7598376$var$parse_FtCmo
};
function $a1a91b25d7598376$var$parse_FtArray(blob, length /*::, ot*/ ) {
    var tgt = blob.l + length;
    var fts = [];
    while(blob.l < tgt){
        var ft = blob.read_shift(2);
        blob.l -= 2;
        try {
            fts[ft] = $a1a91b25d7598376$var$FtTab[ft](blob, tgt - blob.l);
        } catch (e) {
            blob.l = tgt;
            return fts;
        }
    }
    if (blob.l != tgt) blob.l = tgt; //throw new Error("bad Object Ft-sequence");
    return fts;
}
/* --- 2.4 Records --- */ /* [MS-XLS] 2.4.21 */ function $a1a91b25d7598376$var$parse_BOF(blob, length) {
    var o = {
        BIFFVer: 0,
        dt: 0
    };
    o.BIFFVer = blob.read_shift(2);
    length -= 2;
    if (length >= 2) {
        o.dt = blob.read_shift(2);
        blob.l -= 2;
    }
    switch(o.BIFFVer){
        case 0x0600:
        /* BIFF8 */ case 0x0500:
        /* BIFF5 */ case 0x0400:
        /* BIFF4 */ case 0x0300:
        /* BIFF3 */ case 0x0200:
        /* BIFF2 */ case 0x0002:
        case 0x0007:
            break;
        default:
            if (length > 6) throw new Error("Unexpected BIFF Ver " + o.BIFFVer);
    }
    blob.read_shift(length);
    return o;
}
function $a1a91b25d7598376$var$write_BOF(wb /*:Workbook*/ , t /*:number*/ , o) {
    var h = 0x0600, w = 16;
    switch(o.bookType){
        case 'biff8':
            break;
        case 'biff5':
            h = 0x0500;
            w = 8;
            break;
        case 'biff4':
            h = 0x0004;
            w = 6;
            break;
        case 'biff3':
            h = 0x0003;
            w = 6;
            break;
        case 'biff2':
            h = 0x0002;
            w = 4;
            break;
        case 'xla':
            break;
        default:
            throw new Error("unsupported BIFF version");
    }
    var out = $a1a91b25d7598376$var$new_buf(w);
    out.write_shift(2, h);
    out.write_shift(2, t);
    if (w > 4) out.write_shift(2, 0x7262);
    if (w > 6) out.write_shift(2, 0x07CD);
    if (w > 8) {
        out.write_shift(2, 0xC009);
        out.write_shift(2, 0x0001);
        out.write_shift(2, 0x0706);
        out.write_shift(2, 0x0000);
    }
    return out;
}
/* [MS-XLS] 2.4.146 */ function $a1a91b25d7598376$var$parse_InterfaceHdr(blob, length) {
    if (length === 0) return 0x04b0;
    blob.read_shift(2);
    return 0x04b0;
}
/* [MS-XLS] 2.4.349 */ function $a1a91b25d7598376$var$parse_WriteAccess(blob, length, opts) {
    if (opts.enc) {
        blob.l += length;
        return "";
    }
    var l = blob.l;
    // TODO: make sure XLUnicodeString doesnt overrun
    var UserName = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, opts);
    blob.read_shift(length + l - blob.l);
    return UserName;
}
function $a1a91b25d7598376$var$write_WriteAccess(s /*:string*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $a1a91b25d7598376$var$new_buf(b8 ? 112 : 54);
    o.write_shift(opts.biff == 8 ? 2 : 1, 7);
    if (b8) o.write_shift(1, 0);
    o.write_shift(4, 0x33336853);
    o.write_shift(4, 0x00534A74 | (b8 ? 0 : 0x20000000));
    while(o.l < o.length)o.write_shift(1, b8 ? 0 : 32);
    return o;
}
/* [MS-XLS] 2.4.351 */ function $a1a91b25d7598376$var$parse_WsBool(blob, length, opts) {
    var flags = opts && opts.biff == 8 || length == 2 ? blob.read_shift(2) : (blob.l += length, 0);
    return {
        fDialog: flags & 0x10,
        fBelow: flags & 0x40,
        fRight: flags & 0x80
    };
}
/* [MS-XLS] 2.4.28 */ function $a1a91b25d7598376$var$parse_BoundSheet8(blob, length, opts) {
    var name = "";
    if (opts.biff == 4) {
        name = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, 0, opts);
        if (name.length === 0) name = "Sheet1";
        return {
            name: name
        };
    }
    var pos = blob.read_shift(4);
    var hidden = blob.read_shift(1) & 0x03;
    var dt = blob.read_shift(1);
    switch(dt){
        case 0:
            dt = 'Worksheet';
            break;
        case 1:
            dt = 'Macrosheet';
            break;
        case 2:
            dt = 'Chartsheet';
            break;
        case 6:
            dt = 'VBAModule';
            break;
    }
    name = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, 0, opts);
    if (name.length === 0) name = "Sheet1";
    return {
        pos: pos,
        hs: hidden,
        dt: dt,
        name: name
    };
}
function $a1a91b25d7598376$var$write_BoundSheet8(data, opts) {
    var w = !opts || opts.biff >= 8 ? 2 : 1;
    var o = $a1a91b25d7598376$var$new_buf(8 + w * data.name.length);
    o.write_shift(4, data.pos);
    o.write_shift(1, data.hs || 0);
    o.write_shift(1, data.dt);
    o.write_shift(1, data.name.length);
    if (opts.biff >= 8) o.write_shift(1, 1);
    o.write_shift(w * data.name.length, data.name, opts.biff < 8 ? 'sbcs' : 'utf16le');
    var out = o.slice(0, o.l);
    out.l = o.l;
    return out;
}
/* [MS-XLS] 2.4.265 TODO */ function $a1a91b25d7598376$var$parse_SST(blob, length) /*:SST*/ {
    var end = blob.l + length;
    var cnt = blob.read_shift(4);
    var ucnt = blob.read_shift(4);
    var strs /*:SST*/  = [];
    for(var i = 0; i != ucnt && blob.l < end; ++i)strs.push($a1a91b25d7598376$var$parse_XLUnicodeRichExtendedString(blob));
    strs.Count = cnt;
    strs.Unique = ucnt;
    return strs;
}
function $a1a91b25d7598376$var$write_SST(sst, opts) {
    var header = $a1a91b25d7598376$var$new_buf(8);
    header.write_shift(4, sst.Count);
    header.write_shift(4, sst.Unique);
    var strs = [];
    for(var j = 0; j < sst.length; ++j)strs[j] = $a1a91b25d7598376$var$write_XLUnicodeRichExtendedString(sst[j], opts);
    var o = $a1a91b25d7598376$var$bconcat([
        header
    ].concat(strs));
    /*::(*/ o /*:: :any)*/ .parts = [
        header.length
    ].concat(strs.map(function(str) {
        return str.length;
    }));
    return o;
}
/* [MS-XLS] 2.4.107 */ function $a1a91b25d7598376$var$parse_ExtSST(blob, length) {
    var extsst = {};
    extsst.dsst = blob.read_shift(2);
    blob.l += length - 2;
    return extsst;
}
/* [MS-XLS] 2.4.221 TODO: check BIFF2-4 */ function $a1a91b25d7598376$var$parse_Row(blob) {
    var z = {} /*:any*/ ;
    z.r = blob.read_shift(2);
    z.c = blob.read_shift(2);
    z.cnt = blob.read_shift(2) - z.c;
    var miyRw = blob.read_shift(2);
    blob.l += 4; // reserved(2), unused(2)
    var flags = blob.read_shift(1); // various flags
    blob.l += 3; // reserved(8), ixfe(12), flags(4)
    if (flags & 0x07) z.level = flags & 0x07;
    // collapsed: flags & 0x10
    if (flags & 0x20) z.hidden = true;
    if (flags & 0x40) z.hpt = miyRw / 20;
    return z;
}
/* [MS-XLS] 2.4.125 */ function $a1a91b25d7598376$var$parse_ForceFullCalculation(blob) {
    var header = $a1a91b25d7598376$var$parse_frtHeader(blob);
    if (header.type != 0x08A3) throw new Error("Invalid Future Record " + header.type);
    var fullcalc = blob.read_shift(4);
    return fullcalc !== 0x0;
}
/* [MS-XLS] 2.4.215 rt */ function $a1a91b25d7598376$var$parse_RecalcId(blob) {
    blob.read_shift(2);
    return blob.read_shift(4);
}
/* [MS-XLS] 2.4.87 */ function $a1a91b25d7598376$var$parse_DefaultRowHeight(blob, length, opts) {
    var f = 0;
    if (!(opts && opts.biff == 2)) f = blob.read_shift(2);
    var miyRw = blob.read_shift(2);
    if (opts && opts.biff == 2) {
        f = 1 - (miyRw >> 15);
        miyRw &= 0x7fff;
    }
    var fl = {
        Unsynced: f & 1,
        DyZero: (f & 2) >> 1,
        ExAsc: (f & 4) >> 2,
        ExDsc: (f & 8) >> 3
    };
    return [
        fl,
        miyRw
    ];
}
/* [MS-XLS] 2.4.345 TODO */ function $a1a91b25d7598376$var$parse_Window1(blob) {
    var xWn = blob.read_shift(2), yWn = blob.read_shift(2), dxWn = blob.read_shift(2), dyWn = blob.read_shift(2);
    var flags = blob.read_shift(2), iTabCur = blob.read_shift(2), iTabFirst = blob.read_shift(2);
    var ctabSel = blob.read_shift(2), wTabRatio = blob.read_shift(2);
    return {
        Pos: [
            xWn,
            yWn
        ],
        Dim: [
            dxWn,
            dyWn
        ],
        Flags: flags,
        CurTab: iTabCur,
        FirstTab: iTabFirst,
        Selected: ctabSel,
        TabRatio: wTabRatio
    };
}
function $a1a91b25d7598376$var$write_Window1() {
    var o = $a1a91b25d7598376$var$new_buf(18);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0x7260);
    o.write_shift(2, 0x44c0);
    o.write_shift(2, 0x38);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 1);
    o.write_shift(2, 0x01f4);
    return o;
}
/* [MS-XLS] 2.4.346 TODO */ function $a1a91b25d7598376$var$parse_Window2(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff < 5) return {};
    var f = blob.read_shift(2);
    return {
        RTL: f & 0x40
    };
}
function $a1a91b25d7598376$var$write_Window2(view) {
    var o = $a1a91b25d7598376$var$new_buf(18), f = 0x6b6;
    if (view && view.RTL) f |= 0x40;
    o.write_shift(2, f);
    o.write_shift(4, 0);
    o.write_shift(4, 64);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLS] 2.4.189 TODO */ function $a1a91b25d7598376$var$parse_Pane() {}
/* [MS-XLS] 2.4.122 TODO */ function $a1a91b25d7598376$var$parse_Font(blob, length, opts) {
    var o /*:any*/  = {
        dyHeight: blob.read_shift(2),
        fl: blob.read_shift(2)
    };
    switch(opts && opts.biff || 8){
        case 2:
            break;
        case 3:
        case 4:
            blob.l += 2;
            break;
        default:
            blob.l += 10;
            break;
    }
    o.name = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, 0, opts);
    return o;
}
function $a1a91b25d7598376$var$write_Font(data, opts) {
    var name = data.name || "Arial";
    var b5 = opts && opts.biff == 5, w = b5 ? 15 + name.length : 16 + 2 * name.length;
    var o = $a1a91b25d7598376$var$new_buf(w);
    o.write_shift(2, (data.sz || 12) * 20);
    o.write_shift(4, 0);
    o.write_shift(2, 400);
    o.write_shift(4, 0);
    o.write_shift(2, 0);
    o.write_shift(1, name.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * name.length, name, b5 ? "sbcs" : "utf16le");
    return o;
}
/* [MS-XLS] 2.4.149 */ function $a1a91b25d7598376$var$parse_LabelSst(blob, length, opts) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, length, opts);
    cell.isst = blob.read_shift(4);
    return cell;
}
function $a1a91b25d7598376$var$write_LabelSst(R /*:number*/ , C /*:number*/ , v /*:number*/ , os /*:number*/  /*::, opts*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(10);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    o.write_shift(4, v);
    return o;
}
/* [MS-XLS] 2.4.148 */ function $a1a91b25d7598376$var$parse_Label(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var target = blob.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, length, opts);
    var str = $a1a91b25d7598376$var$parse_XLUnicodeString(blob, target - blob.l, opts);
    cell.val = str;
    return cell;
}
function $a1a91b25d7598376$var$write_Label(R /*:number*/ , C /*:number*/ , v /*:string*/ , os /*:number*/ , opts) {
    var b8 = !opts || opts.biff == 8;
    var o = $a1a91b25d7598376$var$new_buf(8 + +b8 + (1 + b8) * v.length);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    o.write_shift(2, v.length);
    if (b8) o.write_shift(1, 1);
    o.write_shift((1 + b8) * v.length, v, b8 ? 'utf16le' : 'sbcs');
    return o;
}
/* [MS-XLS] 2.4.126 Number Formats */ function $a1a91b25d7598376$var$parse_Format(blob, length, opts) {
    var numFmtId = blob.read_shift(2);
    var fmtstr = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        numFmtId,
        fmtstr
    ];
}
function $a1a91b25d7598376$var$write_Format(i /*:number*/ , f /*:string*/ , opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $a1a91b25d7598376$var$new_buf(b5 ? 3 + f.length : 5 + 2 * f.length);
    o.write_shift(2, i);
    o.write_shift(b5 ? 1 : 2, f.length);
    if (!b5) o.write_shift(1, 1);
    o.write_shift((b5 ? 1 : 2) * f.length, f, b5 ? 'sbcs' : 'utf16le');
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (out.l == null) out.l = out.length;
    return out;
}
var $a1a91b25d7598376$var$parse_BIFF2Format = $a1a91b25d7598376$var$parse_XLUnicodeString2;
function $a1a91b25d7598376$var$write_BIFF2Format(f /*:string*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(1 + f.length);
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
function $a1a91b25d7598376$var$write_BIFF4Format(f /*:string*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(3 + f.length);
    o.l += 2;
    o.write_shift(1, f.length);
    o.write_shift(f.length, f, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.90 */ function $a1a91b25d7598376$var$parse_Dimensions(blob, length, opts) {
    var end = blob.l + length;
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = blob.read_shift(2), C = blob.read_shift(2);
    blob.l = end;
    return {
        s: {
            r: r,
            c: c
        },
        e: {
            r: R,
            c: C
        }
    };
}
function $a1a91b25d7598376$var$write_Dimensions(range, opts) {
    var w = opts.biff == 8 || !opts.biff ? 4 : 2;
    var o = $a1a91b25d7598376$var$new_buf(2 * w + 6);
    o.write_shift(w, range.s.r);
    o.write_shift(w, range.e.r + 1);
    o.write_shift(2, range.s.c);
    o.write_shift(2, range.e.c + 1);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.220 */ function $a1a91b25d7598376$var$parse_RK(blob) {
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrec = $a1a91b25d7598376$var$parse_RkRec(blob);
    return {
        r: rw,
        c: col,
        ixfe: rkrec[0],
        rknum: rkrec[1]
    };
}
/* [MS-XLS] 2.4.175 */ function $a1a91b25d7598376$var$parse_MulRk(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var rkrecs = [];
    while(blob.l < target)rkrecs.push($a1a91b25d7598376$var$parse_RkRec(blob));
    if (blob.l !== target) throw new Error("MulRK read error");
    var lastcol = blob.read_shift(2);
    if (rkrecs.length != lastcol - col + 1) throw new Error("MulRK length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        rkrec: rkrecs
    };
}
/* [MS-XLS] 2.4.174 */ function $a1a91b25d7598376$var$parse_MulBlank(blob, length) {
    var target = blob.l + length - 2;
    var rw = blob.read_shift(2), col = blob.read_shift(2);
    var ixfes = [];
    while(blob.l < target)ixfes.push(blob.read_shift(2));
    if (blob.l !== target) throw new Error("MulBlank read error");
    var lastcol = blob.read_shift(2);
    if (ixfes.length != lastcol - col + 1) throw new Error("MulBlank length mismatch");
    return {
        r: rw,
        c: col,
        C: lastcol,
        ixfe: ixfes
    };
}
/* [MS-XLS] 2.5.20 2.5.249 TODO: interpret values here */ function $a1a91b25d7598376$var$parse_CellStyleXF(blob, length, style, opts) {
    var o = {};
    var a = blob.read_shift(4), b = blob.read_shift(4);
    var c = blob.read_shift(4), d = blob.read_shift(2);
    o.patternType = $a1a91b25d7598376$var$XLSFillPattern[c >> 26];
    if (!opts.cellStyles) return o;
    o.alc = a & 0x07;
    o.fWrap = a >> 3 & 0x01;
    o.alcV = a >> 4 & 0x07;
    o.fJustLast = a >> 7 & 0x01;
    o.trot = a >> 8 & 0xFF;
    o.cIndent = a >> 16 & 0x0F;
    o.fShrinkToFit = a >> 20 & 0x01;
    o.iReadOrder = a >> 22 & 0x02;
    o.fAtrNum = a >> 26 & 0x01;
    o.fAtrFnt = a >> 27 & 0x01;
    o.fAtrAlc = a >> 28 & 0x01;
    o.fAtrBdr = a >> 29 & 0x01;
    o.fAtrPat = a >> 30 & 0x01;
    o.fAtrProt = a >> 31 & 0x01;
    o.dgLeft = b & 0x0F;
    o.dgRight = b >> 4 & 0x0F;
    o.dgTop = b >> 8 & 0x0F;
    o.dgBottom = b >> 12 & 0x0F;
    o.icvLeft = b >> 16 & 0x7F;
    o.icvRight = b >> 23 & 0x7F;
    o.grbitDiag = b >> 30 & 0x03;
    o.icvTop = c & 0x7F;
    o.icvBottom = c >> 7 & 0x7F;
    o.icvDiag = c >> 14 & 0x7F;
    o.dgDiag = c >> 21 & 0x0F;
    o.icvFore = d & 0x7F;
    o.icvBack = d >> 7 & 0x7F;
    o.fsxButton = d >> 14 & 0x01;
    return o;
}
//function parse_CellXF(blob, length, opts) {return parse_CellStyleXF(blob,length,0, opts);}
//function parse_StyleXF(blob, length, opts) {return parse_CellStyleXF(blob,length,1, opts);}
/* [MS-XLS] 2.4.353 TODO: actually do this right */ function $a1a91b25d7598376$var$parse_XF(blob, length, opts) {
    var o = {};
    o.ifnt = blob.read_shift(2);
    o.numFmtId = blob.read_shift(2);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    length -= 6;
    o.data = $a1a91b25d7598376$var$parse_CellStyleXF(blob, length, o.fStyle, opts);
    return o;
}
function $a1a91b25d7598376$var$write_XF(data, ixfeP, opts, o) {
    var b5 = opts && opts.biff == 5;
    if (!o) o = $a1a91b25d7598376$var$new_buf(b5 ? 16 : 20);
    o.write_shift(2, 0);
    if (data.style) {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, 0xFFF4);
    } else {
        o.write_shift(2, data.numFmtId || 0);
        o.write_shift(2, ixfeP << 4);
    }
    var f = 0;
    if (data.numFmtId > 0 && b5) f |= 0x0400;
    o.write_shift(4, f);
    o.write_shift(4, 0);
    if (!b5) o.write_shift(4, 0);
    o.write_shift(2, 0);
    return o;
}
function $a1a91b25d7598376$var$parse_BIFF2XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    blob.l++;
    o.flags = blob.read_shift(1);
    o.numFmtId = o.flags & 0x3F;
    o.flags >>= 6;
    o.fStyle = 0;
    o.data = {}; // TODO
    return o;
}
function $a1a91b25d7598376$var$write_BIFF2XF(xf) {
    var o = $a1a91b25d7598376$var$new_buf(4);
    o.l += 2;
    o.write_shift(1, xf.numFmtId);
    o.l++;
    return o;
}
function $a1a91b25d7598376$var$write_BIFF3XF(xf) {
    var o = $a1a91b25d7598376$var$new_buf(12);
    o.l++;
    o.write_shift(1, xf.numFmtId);
    o.l += 10;
    return o;
}
/* TODO: check other fields */ var $a1a91b25d7598376$var$write_BIFF4XF = $a1a91b25d7598376$var$write_BIFF3XF;
function $a1a91b25d7598376$var$parse_BIFF3XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
function $a1a91b25d7598376$var$parse_BIFF4XF(blob /*::, length, opts*/ ) {
    var o = {};
    o.ifnt = blob.read_shift(1);
    o.numFmtId = blob.read_shift(1);
    o.flags = blob.read_shift(2);
    o.fStyle = o.flags >> 2 & 0x01;
    o.data = {}; // TODO
    return o;
}
/* [MS-XLS] 2.4.134 */ function $a1a91b25d7598376$var$parse_Guts(blob) {
    blob.l += 4;
    var out = [
        blob.read_shift(2),
        blob.read_shift(2)
    ];
    if (out[0] !== 0) out[0]--;
    if (out[1] !== 0) out[1]--;
    if (out[0] > 7 || out[1] > 7) throw new Error("Bad Gutters: " + out.join("|"));
    return out;
}
function $a1a91b25d7598376$var$write_Guts(guts /*:Array<number>*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, 0);
    o.write_shift(2, guts[0] ? guts[0] + 1 : 0);
    o.write_shift(2, guts[1] ? guts[1] + 1 : 0);
    return o;
}
/* [MS-XLS] 2.4.24 */ function $a1a91b25d7598376$var$parse_BoolErr(blob, length, opts) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6, opts);
    var val1 = $a1a91b25d7598376$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
function $a1a91b25d7598376$var$write_BoolErr(R /*:number*/ , C /*:number*/ , v, os /*:number*/ , opts, t /*:string*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    $a1a91b25d7598376$var$write_Bes(v, t, o);
    return o;
}
/* [MS-XLS] 2.4.180 Number */ function $a1a91b25d7598376$var$parse_Number(blob, length, opts) {
    if (opts.biffguess && opts.biff == 2) opts.biff = 5;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6, opts);
    var xnum = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    cell.val = xnum;
    return cell;
}
function $a1a91b25d7598376$var$write_Number(R /*:number*/ , C /*:number*/ , v, os /*:: :number, opts*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(14);
    $a1a91b25d7598376$var$write_XLSCell(R, C, os, o);
    $a1a91b25d7598376$var$write_Xnum(v, o);
    return o;
}
var $a1a91b25d7598376$var$parse_XLHeaderFooter = $a1a91b25d7598376$var$parse_OptXLUnicodeString; // TODO: parse 2.4.136
/* [MS-XLS] 2.4.271 */ function $a1a91b25d7598376$var$parse_SupBook(blob, length, opts) {
    var end = blob.l + length;
    var ctab = blob.read_shift(2);
    var cch = blob.read_shift(2);
    opts.sbcch = cch;
    if (cch == 0x0401 || cch == 0x3A01) return [
        cch,
        ctab
    ];
    if (cch < 0x01 || cch > 0xff) throw new Error("Unexpected SupBook type: " + cch);
    var virtPath = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch);
    /* TODO: 2.5.277 Virtual Path */ var rgst = [];
    while(end > blob.l)rgst.push($a1a91b25d7598376$var$parse_XLUnicodeString(blob));
    return [
        cch,
        ctab,
        virtPath,
        rgst
    ];
}
/* [MS-XLS] 2.4.105 TODO */ function $a1a91b25d7598376$var$parse_ExternName(blob, length, opts) {
    var flags = blob.read_shift(2);
    var body;
    var o = {
        fBuiltIn: flags & 0x01,
        fWantAdvise: flags >>> 1 & 0x01,
        fWantPict: flags >>> 2 & 0x01,
        fOle: flags >>> 3 & 0x01,
        fOleLink: flags >>> 4 & 0x01,
        cf: flags >>> 5 & 0x3FF,
        fIcon: flags >>> 15 & 0x01
    } /*:any*/ ;
    if (opts.sbcch === 0x3A01) body = $a1a91b25d7598376$var$parse_AddinUdf(blob, length - 2, opts);
    //else throw new Error("unsupported SupBook cch: " + opts.sbcch);
    o.body = body || blob.read_shift(length - 2);
    if (typeof body === "string") o.Name = body;
    return o;
}
/* [MS-XLS] 2.4.150 TODO */ function $a1a91b25d7598376$var$parse_Lbl(blob, length, opts) {
    var target = blob.l + length;
    var flags = blob.read_shift(2);
    var chKey = blob.read_shift(1);
    var cch = blob.read_shift(1);
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var itab = 0;
    if (!opts || opts.biff >= 5) {
        if (opts.biff != 5) blob.l += 2;
        itab = blob.read_shift(2);
        if (opts.biff == 5) blob.l += 2;
        blob.l += 4;
    }
    var name = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    if (flags & 0x20) name = $a1a91b25d7598376$var$XLSLblBuiltIn[name.charCodeAt(0)];
    var npflen = target - blob.l;
    if (opts && opts.biff == 2) --npflen;
    /*jshint -W018 */ var rgce = target == blob.l || cce === 0 || !(npflen > 0) ? [] : $a1a91b25d7598376$var$parse_NameParsedFormula(blob, npflen, opts, cce);
    /*jshint +W018 */ return {
        chKey: chKey,
        Name: name,
        itab: itab,
        rgce: rgce
    };
}
/* [MS-XLS] 2.4.106 TODO: legacy record filename encoding */ function $a1a91b25d7598376$var$parse_ExternSheet(blob, length, opts) {
    if (opts.biff < 8) return $a1a91b25d7598376$var$parse_BIFF5ExternSheet(blob, length, opts);
    /* see issue 2907 */ if (!(opts.biff > 8) && length == blob[blob.l] + (blob[blob.l + 1] == 0x03 ? 1 : 0) + 1) return $a1a91b25d7598376$var$parse_BIFF5ExternSheet(blob, length, opts);
    var o = [], target = blob.l + length, len = blob.read_shift(opts.biff > 8 ? 4 : 2);
    while(len-- !== 0)o.push($a1a91b25d7598376$var$parse_XTI(blob, opts.biff > 8 ? 12 : 6, opts));
    // [iSupBook, itabFirst, itabLast];
    if (blob.l != target) throw new Error("Bad ExternSheet: " + blob.l + " != " + target);
    return o;
}
function $a1a91b25d7598376$var$parse_BIFF5ExternSheet(blob, length, opts) {
    if (blob[blob.l + 1] == 0x03) blob[blob.l]++;
    var o = $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length, opts);
    return o.charCodeAt(0) == 0x03 ? o.slice(1) : o;
}
/* [MS-XLS] 2.4.176 TODO: check older biff */ function $a1a91b25d7598376$var$parse_NameCmt(blob, length, opts) {
    if (opts.biff < 8) {
        blob.l += length;
        return;
    }
    var cchName = blob.read_shift(2);
    var cchComment = blob.read_shift(2);
    var name = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cchName, opts);
    var comment = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cchComment, opts);
    return [
        name,
        comment
    ];
}
/* [MS-XLS] 2.4.260 */ function $a1a91b25d7598376$var$parse_ShrFmla(blob, length, opts) {
    var ref = $a1a91b25d7598376$var$parse_RefU(blob, 6);
    blob.l++;
    var cUse = blob.read_shift(1);
    length -= 8;
    return [
        $a1a91b25d7598376$var$parse_SharedParsedFormula(blob, length, opts),
        cUse,
        ref
    ];
}
/* [MS-XLS] 2.4.4 TODO */ function $a1a91b25d7598376$var$parse_Array(blob, length, opts) {
    var ref = $a1a91b25d7598376$var$parse_Ref(blob, 6);
    /* TODO: fAlwaysCalc */ switch(opts.biff){
        case 2:
            blob.l++;
            length -= 7;
            break;
        case 3:
        case 4:
            blob.l += 2;
            length -= 8;
            break;
        default:
            blob.l += 6;
            length -= 12;
    }
    return [
        ref,
        $a1a91b25d7598376$var$parse_ArrayParsedFormula(blob, length, opts, ref)
    ];
}
/* [MS-XLS] 2.4.173 */ function $a1a91b25d7598376$var$parse_MTRSettings(blob) {
    var fMTREnabled = blob.read_shift(4) !== 0x00;
    var fUserSetThreadCount = blob.read_shift(4) !== 0x00;
    var cUserThreadCount = blob.read_shift(4);
    return [
        fMTREnabled,
        fUserSetThreadCount,
        cUserThreadCount
    ];
}
/* [MS-XLS] 2.5.186 */ function $a1a91b25d7598376$var$parse_NoteSh(blob, length, opts) {
    var row = blob.read_shift(2), col = blob.read_shift(2);
    var flags = blob.read_shift(2), idObj = blob.read_shift(2);
    var stAuthor = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, opts);
    return [
        {
            r: row,
            c: col
        },
        stAuthor,
        idObj,
        flags
    ];
}
/* [MS-XLS] 2.4.179 */ function $a1a91b25d7598376$var$parse_Note(blob, length, opts) {
    if (opts && opts.biff < 8) {
        var row = blob.read_shift(2), col = blob.read_shift(2);
        if (row == 0xFFFF || row == -1) return; // TODO: test continuation
        var cch = blob.read_shift(2);
        var cmnt = blob.read_shift(Math.min(cch, 2048), 'cpstr');
        return [
            {
                r: row,
                c: col
            },
            cmnt
        ];
    }
    /* TODO: Support revisions */ return $a1a91b25d7598376$var$parse_NoteSh(blob, length, opts);
}
function $a1a91b25d7598376$var$write_NOTE_BIFF2(text /*:string*/ , R /*:number*/ , C /*:number*/ , len /*?:number*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(6 + (len || text.length));
    o.write_shift(2, R);
    o.write_shift(2, C);
    o.write_shift(2, len || text.length);
    o.write_shift(text.length, text, "sbcs");
    return o;
}
/* [MS-XLS] 2.4.168 */ function $a1a91b25d7598376$var$parse_MergeCells(blob, length) /*:Array<Range>*/ {
    var merges /*:Array<Range>*/  = [];
    var cmcs = blob.read_shift(2);
    while(cmcs--)merges.push($a1a91b25d7598376$var$parse_Ref8U(blob, length));
    return merges;
}
function $a1a91b25d7598376$var$write_MergeCells(merges /*:Array<Range>*/ ) {
    var o = $a1a91b25d7598376$var$new_buf(2 + merges.length * 8);
    o.write_shift(2, merges.length);
    for(var i = 0; i < merges.length; ++i)$a1a91b25d7598376$var$write_Ref8U(merges[i], o);
    return o;
}
/* [MS-XLS] 2.4.181 TODO: parse all the things! */ function $a1a91b25d7598376$var$parse_Obj(blob, length, opts) {
    if (opts && opts.biff < 8) return $a1a91b25d7598376$var$parse_BIFF5Obj(blob, length, opts);
    var cmo = $a1a91b25d7598376$var$parse_FtCmo(blob, 22); // id, ot, flags
    var fts = $a1a91b25d7598376$var$parse_FtArray(blob, length - 22, cmo[1]);
    return {
        cmo: cmo,
        ft: fts
    };
}
/* from older spec */ var $a1a91b25d7598376$var$parse_BIFF5OT = {
    0x08: function(blob, length) {
        var tgt = blob.l + length;
        blob.l += 10; // todo
        var cf = blob.read_shift(2);
        blob.l += 4;
        blob.l += 2; //var cbPictFmla = blob.read_shift(2);
        blob.l += 2;
        blob.l += 2; //var grbit = blob.read_shift(2);
        blob.l += 4;
        var cchName = blob.read_shift(1);
        blob.l += cchName; // TODO: stName
        blob.l = tgt; // TODO: fmla
        return {
            fmt: cf
        };
    }
};
function $a1a91b25d7598376$var$parse_BIFF5Obj(blob, length, opts) {
    blob.l += 4; //var cnt = blob.read_shift(4);
    var ot = blob.read_shift(2);
    var id = blob.read_shift(2);
    var grbit = blob.read_shift(2);
    blob.l += 2; //var colL = blob.read_shift(2);
    blob.l += 2; //var dxL = blob.read_shift(2);
    blob.l += 2; //var rwT = blob.read_shift(2);
    blob.l += 2; //var dyT = blob.read_shift(2);
    blob.l += 2; //var colR = blob.read_shift(2);
    blob.l += 2; //var dxR = blob.read_shift(2);
    blob.l += 2; //var rwB = blob.read_shift(2);
    blob.l += 2; //var dyB = blob.read_shift(2);
    blob.l += 2; //var cbMacro = blob.read_shift(2);
    blob.l += 6;
    length -= 36;
    var fts = [];
    fts.push(($a1a91b25d7598376$var$parse_BIFF5OT[ot] || $a1a91b25d7598376$var$parsenoop)(blob, length, opts));
    return {
        cmo: [
            id,
            ot,
            grbit
        ],
        ft: fts
    };
}
/* [MS-XLS] 2.4.329 TODO: parse properly */ function $a1a91b25d7598376$var$parse_TxO(blob, length, opts) {
    var s = blob.l;
    var texts = "";
    try {
        blob.l += 4;
        var ot = (opts.lastobj || {
            cmo: [
                0,
                0
            ]
        }).cmo[1];
        var controlInfo; // eslint-disable-line no-unused-vars
        if ([
            0,
            5,
            7,
            11,
            12,
            14
        ].indexOf(ot) == -1) blob.l += 6;
        else controlInfo = $a1a91b25d7598376$var$parse_ControlInfo(blob, 6, opts); // eslint-disable-line no-unused-vars
        var cchText = blob.read_shift(2);
        /*var cbRuns = */ blob.read_shift(2);
        /*var ifntEmpty = */ $a1a91b25d7598376$var$parseuint16(blob, 2);
        var len = blob.read_shift(2);
        blob.l += len;
        //var fmla = parse_ObjFmla(blob, s + length - blob.l);
        for(var i = 1; i < blob.lens.length - 1; ++i){
            if (blob.l - s != blob.lens[i]) throw new Error("TxO: bad continue record");
            var hdr = blob[blob.l];
            var t = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, blob.lens[i + 1] - blob.lens[i] - 1);
            texts += t;
            if (texts.length >= (hdr ? cchText : 2 * cchText)) break;
        }
        if (texts.length !== cchText && texts.length !== cchText * 2) throw new Error("cchText: " + cchText + " != " + texts.length);
        blob.l = s + length;
        /* [MS-XLS] 2.5.272 TxORuns */ //	var rgTxoRuns = [];
        //	for(var j = 0; j != cbRuns/8-1; ++j) blob.l += 8;
        //	var cchText2 = blob.read_shift(2);
        //	if(cchText2 !== cchText) throw new Error("TxOLastRun mismatch: " + cchText2 + " " + cchText);
        //	blob.l += 6;
        //	if(s + length != blob.l) throw new Error("TxO " + (s + length) + ", at " + blob.l);
        return {
            t: texts
        };
    } catch (e) {
        blob.l = s + length;
        return {
            t: texts
        };
    }
}
/* [MS-XLS] 2.4.140 */ function $a1a91b25d7598376$var$parse_HLink(blob, length) {
    var ref = $a1a91b25d7598376$var$parse_Ref8U(blob, 8);
    blob.l += 16; /* CLSID */ 
    var hlink = $a1a91b25d7598376$var$parse_Hyperlink(blob, length - 24);
    return [
        ref,
        hlink
    ];
}
function $a1a91b25d7598376$var$write_HLink(hl) {
    var O = $a1a91b25d7598376$var$new_buf(24);
    var ref = $a1a91b25d7598376$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    var clsid = "d0 c9 ea 79 f9 ba ce 11 8c 82 00 aa 00 4b a9 0b".split(" ");
    for(var i = 0; i < 16; ++i)O.write_shift(1, parseInt(clsid[i], 16));
    return $a1a91b25d7598376$var$bconcat([
        O,
        $a1a91b25d7598376$var$write_Hyperlink(hl[1])
    ]);
}
/* [MS-XLS] 2.4.141 */ function $a1a91b25d7598376$var$parse_HLinkTooltip(blob, length) {
    blob.read_shift(2);
    var ref = $a1a91b25d7598376$var$parse_Ref8U(blob, 8);
    var wzTooltip = blob.read_shift((length - 10) / 2, 'dbcs-cont');
    wzTooltip = wzTooltip.replace($a1a91b25d7598376$var$chr0, "");
    return [
        ref,
        wzTooltip
    ];
}
function $a1a91b25d7598376$var$write_HLinkTooltip(hl) {
    var TT = hl[1].Tooltip;
    var O = $a1a91b25d7598376$var$new_buf(10 + 2 * (TT.length + 1));
    O.write_shift(2, 0x0800);
    var ref = $a1a91b25d7598376$var$decode_cell(hl[0]);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.r);
    O.write_shift(2, ref.c);
    O.write_shift(2, ref.c);
    for(var i = 0; i < TT.length; ++i)O.write_shift(2, TT.charCodeAt(i));
    O.write_shift(2, 0);
    return O;
}
/* [MS-XLS] 2.4.63 */ function $a1a91b25d7598376$var$parse_Country(blob) /*:[string|number, string|number]*/ {
    var o = [
        0,
        0
    ], d;
    d = blob.read_shift(2);
    o[0] = $a1a91b25d7598376$var$CountryEnum[d] || d;
    d = blob.read_shift(2);
    o[1] = $a1a91b25d7598376$var$CountryEnum[d] || d;
    return o;
}
function $a1a91b25d7598376$var$write_Country(o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(2, 0x01);
    o.write_shift(2, 0x01);
    return o;
}
/* [MS-XLS] 2.4.50 ClrtClient */ function $a1a91b25d7598376$var$parse_ClrtClient(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($a1a91b25d7598376$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.188 */ function $a1a91b25d7598376$var$parse_Palette(blob) {
    var ccv = blob.read_shift(2);
    var o = [];
    while(ccv-- > 0)o.push($a1a91b25d7598376$var$parse_LongRGB(blob, 8));
    return o;
}
/* [MS-XLS] 2.4.354 */ function $a1a91b25d7598376$var$parse_XFCRC(blob) {
    blob.l += 2;
    var o = {
        cxfs: 0,
        crc: 0
    };
    o.cxfs = blob.read_shift(2);
    o.crc = blob.read_shift(4);
    return o;
}
/* [MS-XLS] 2.4.53 TODO: parse flags */ /* [MS-XLSB] 2.4.323 TODO: parse flags */ function $a1a91b25d7598376$var$parse_ColInfo(blob, length, opts) {
    if (!opts.cellStyles) return $a1a91b25d7598376$var$parsenoop(blob, length);
    var w = opts && opts.biff >= 12 ? 4 : 2;
    var colFirst = blob.read_shift(w);
    var colLast = blob.read_shift(w);
    var coldx = blob.read_shift(w);
    var ixfe = blob.read_shift(w);
    var flags = blob.read_shift(2);
    if (w == 2) blob.l += 2;
    var o = {
        s: colFirst,
        e: colLast,
        w: coldx,
        ixfe: ixfe,
        flags: flags
    } /*:any*/ ;
    if (opts.biff >= 5 || !opts.biff) o.level = flags >> 8 & 0x7;
    return o;
}
function $a1a91b25d7598376$var$write_ColInfo(col, idx) {
    var o = $a1a91b25d7598376$var$new_buf(12);
    o.write_shift(2, idx);
    o.write_shift(2, idx);
    o.write_shift(2, col.width * 256);
    o.write_shift(2, 0);
    var f = 0;
    if (col.hidden) f |= 1;
    o.write_shift(1, f);
    f = col.level || 0;
    o.write_shift(1, f);
    o.write_shift(2, 0);
    return o;
}
/* [MS-XLS] 2.4.257 */ function $a1a91b25d7598376$var$parse_Setup(blob, length) {
    var o = {};
    if (length < 32) return o;
    blob.l += 16;
    o.header = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    o.footer = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    blob.l += 2;
    return o;
}
/* [MS-XLS] 2.4.261 */ function $a1a91b25d7598376$var$parse_ShtProps(blob, length, opts) {
    var def = {
        area: false
    };
    if (opts.biff != 5) {
        blob.l += length;
        return def;
    }
    var d = blob.read_shift(1);
    blob.l += 3;
    if (d & 0x10) def.area = true;
    return def;
}
/* [MS-XLS] 2.4.241 */ function $a1a91b25d7598376$var$write_RRTabId(n /*:number*/ ) {
    var out = $a1a91b25d7598376$var$new_buf(2 * n);
    for(var i = 0; i < n; ++i)out.write_shift(2, i + 1);
    return out;
}
var $a1a91b25d7598376$var$parse_Blank = $a1a91b25d7598376$var$parse_XLSCell; /* [MS-XLS] 2.4.20 Just the cell */ 
var $a1a91b25d7598376$var$parse_Scl = $a1a91b25d7598376$var$parseuint16a; /* [MS-XLS] 2.4.247 num, den */ 
var $a1a91b25d7598376$var$parse_String = $a1a91b25d7598376$var$parse_XLUnicodeString; /* [MS-XLS] 2.4.268 */ 
/* --- Specific to versions before BIFF8 --- */ function $a1a91b25d7598376$var$parse_ImData(blob) {
    var cf = blob.read_shift(2);
    var env = blob.read_shift(2);
    var lcb = blob.read_shift(4);
    var o = {
        fmt: cf,
        env: env,
        len: lcb,
        data: blob.slice(blob.l, blob.l + lcb)
    };
    blob.l += lcb;
    return o;
}
function $a1a91b25d7598376$var$write_BIFF2Cell(out, r /*:number*/ , c /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    if (!out) out = $a1a91b25d7598376$var$new_buf(7);
    out.write_shift(2, r);
    out.write_shift(2, c);
    out.write_shift(1, ixfe || 0 /* & 0x3F */ );
    out.write_shift(1, ifmt || 0 /* & 0x3F */ );
    out.write_shift(1, 0);
    return out;
}
/* BIFF2_??? where ??? is the name from [XLS] */ function $a1a91b25d7598376$var$parse_BIFF2STR(blob, length, opts) {
    if (opts.biffguess && opts.biff == 5) opts.biff = 2;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 7, opts);
    var str = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, length - 7, opts);
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $a1a91b25d7598376$var$parse_BIFF2NUM(blob, length, opts) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 7, opts);
    var num = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $a1a91b25d7598376$var$write_BIFF2NUM(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe, ifmt) {
    var out = $a1a91b25d7598376$var$new_buf(15);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(8, val1, 'f');
    return out;
}
function $a1a91b25d7598376$var$parse_BIFF2INT(blob, length, opts) {
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 7, opts);
    var num = blob.read_shift(2);
    cell.t = 'n';
    cell.val = num;
    return cell;
}
function $a1a91b25d7598376$var$write_BIFF2INT(r /*:number*/ , c /*:number*/ , val1 /*:number*/ , ixfe /*:number*/ , ifmt /*:number*/ ) {
    var out = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c, ixfe || 0, ifmt || 0);
    out.write_shift(2, val1);
    return out;
}
function $a1a91b25d7598376$var$parse_BIFF2STRING(blob) {
    var cch = blob.read_shift(1);
    if (cch === 0) {
        blob.l++;
        return "";
    }
    return blob.read_shift(cch, 'sbcs-cont');
}
function $a1a91b25d7598376$var$parse_BIFF2BOOLERR(blob, length, opts) {
    var bestart = blob.l + 7;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6, opts);
    blob.l = bestart;
    var val1 = $a1a91b25d7598376$var$parse_Bes(blob, 2);
    cell.val = val1;
    cell.t = val1 === true || val1 === false ? 'b' : 'e';
    return cell;
}
/* TODO: convert to BIFF8 font struct */ function $a1a91b25d7598376$var$parse_BIFF2FONTXTRA(blob, length) {
    blob.l += 6; // unknown
    blob.l += 2; // font weight "bls"
    blob.l += 1; // charset
    blob.l += 3; // unknown
    blob.l += 1; // font family
    blob.l += length - 13;
}
/* TODO: parse rich text runs */ function $a1a91b25d7598376$var$parse_RString(blob, length, opts) {
    var end = blob.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6, opts);
    var cch = blob.read_shift(2);
    var str = $a1a91b25d7598376$var$parse_XLUnicodeStringNoCch(blob, cch, opts);
    blob.l = end;
    cell.t = 'str';
    cell.val = str;
    return cell;
}
function $a1a91b25d7598376$var$parse_BIFF4SheetInfo(blob /*::, length, opts*/ ) {
    var flags = blob.read_shift(4);
    var cch = blob.read_shift(1), name = blob.read_shift(cch, "sbcs");
    if (name.length === 0) name = "Sheet1";
    return {
        flags: flags,
        name: name
    };
}
var $a1a91b25d7598376$var$DBF_SUPPORTED_VERSIONS = [
    0x02,
    0x03,
    0x30,
    0x31,
    0x83,
    0x8B,
    0x8C,
    0xF5
];
var $a1a91b25d7598376$var$DBF = /*#__PURE__*/ function() {
    var dbf_codepage_map = {
        /* Code Pages Supported by Visual FoxPro */ 0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        /* shapefile DBF extension */ 0x00: 20127,
        0x08: 865,
        0x09: 437,
        0x0A: 850,
        0x0B: 437,
        0x0D: 437,
        0x0E: 850,
        0x0F: 437,
        0x10: 850,
        0x11: 437,
        0x12: 850,
        0x13: 932,
        0x14: 850,
        0x15: 437,
        0x16: 850,
        0x17: 865,
        0x18: 437,
        0x19: 437,
        0x1A: 850,
        0x1B: 437,
        0x1C: 863,
        0x1D: 850,
        0x1F: 852,
        0x22: 852,
        0x23: 852,
        0x24: 860,
        0x25: 850,
        0x26: 866,
        0x37: 850,
        0x40: 852,
        0x4D: 936,
        0x4E: 949,
        0x4F: 950,
        0x50: 874,
        0x57: 1252,
        0x58: 1252,
        0x59: 1252,
        0x6C: 863,
        0x86: 737,
        0x87: 852,
        0x88: 857,
        0xCC: 1257,
        0xFF: 16969
    };
    var dbf_reverse_map = $a1a91b25d7598376$var$evert({
        0x01: 437,
        0x02: 850,
        0x03: 1252,
        0x04: 10000,
        0x64: 852,
        0x65: 866,
        0x66: 865,
        0x67: 861,
        0x68: 895,
        0x69: 620,
        0x6A: 737,
        0x6B: 857,
        0x78: 950,
        0x79: 949,
        0x7A: 936,
        0x7B: 932,
        0x7C: 874,
        0x7D: 1255,
        0x7E: 1256,
        0x96: 10007,
        0x97: 10029,
        0x98: 10006,
        0xC8: 1250,
        0xC9: 1251,
        0xCA: 1254,
        0xCB: 1253,
        0x00: 20127
    });
    /* TODO: find an actual specification */ function dbf_to_aoa(buf, opts) /*:AOA*/ {
        var out /*:AOA*/  = [];
        var d /*:Block*/  = $a1a91b25d7598376$var$new_raw_buf(1);
        switch(opts.type){
            case 'base64':
                d = $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(buf));
                break;
            case 'binary':
                d = $a1a91b25d7598376$var$s2a(buf);
                break;
            case 'buffer':
            case 'array':
                d = buf;
                break;
        }
        $a1a91b25d7598376$var$prep_blob(d, 0);
        /* header */ var ft = d.read_shift(1);
        var memo = !!(ft & 0x88);
        var vfp = false, l7 = false;
        switch(ft){
            case 0x02:
                break; // dBASE II
            case 0x03:
                break; // dBASE III
            case 0x30:
                vfp = true;
                memo = true;
                break; // VFP
            case 0x31:
                vfp = true;
                memo = true;
                break; // VFP with autoincrement
            // 0x43 dBASE IV SQL table files
            // 0x63 dBASE IV SQL system files
            case 0x83:
                break; // dBASE III with memo
            case 0x8B:
                break; // dBASE IV with memo
            case 0x8C:
                l7 = true;
                break; // dBASE Level 7 with memo
            // case 0xCB dBASE IV SQL table files with memo
            case 0xF5:
                break; // FoxPro 2.x with memo
            // case 0xFB FoxBASE
            default:
                throw new Error("DBF Unsupported Version: " + ft.toString(16));
        }
        var nrow = 0, fpos = 0x0209;
        if (ft == 0x02) nrow = d.read_shift(2);
        d.l += 3; // dBASE II stores DDMMYY date, others use YYMMDD
        if (ft != 0x02) nrow = d.read_shift(4);
        if (nrow > 1048576) nrow = 1e6;
        if (ft != 0x02) fpos = d.read_shift(2); // header length
        var rlen = d.read_shift(2); // record length
        var /*flags = 0,*/ current_cp = opts.codepage || 1252;
        if (ft != 0x02) {
            d.l += 16;
            /*flags = */ d.read_shift(1);
            //if(memo && ((flags & 0x02) === 0)) throw new Error("DBF Flags " + flags.toString(16) + " ft " + ft.toString(16));
            /* codepage present in FoxPro and dBASE Level 7 */ if (d[d.l] !== 0) current_cp = dbf_codepage_map[d[d.l]];
            d.l += 1;
            d.l += 2;
        }
        if (l7) d.l += 36; // Level 7: 32 byte "Language driver name", 4 byte reserved
        /*:: type DBFField = { name:string; len:number; type:string; } */ var fields /*:Array<DBFField>*/  = [], field /*:DBFField*/  = {} /*:any*/ ;
        var hend = Math.min(d.length, ft == 0x02 ? 0x209 : fpos - 10 - (vfp ? 264 : 0));
        var ww = l7 ? 32 : 11;
        while(d.l < hend && d[d.l] != 0x0d){
            field = {} /*:any*/ ;
            field.name = (typeof $a1a91b25d7598376$var$$cptable !== "undefined" ? $a1a91b25d7598376$var$$cptable.utils.decode(current_cp, d.slice(d.l, d.l + ww)) : $a1a91b25d7598376$var$a2s(d.slice(d.l, d.l + ww))).replace(/[\u0000\r\n][\S\s]*$/g, "");
            d.l += ww;
            field.type = String.fromCharCode(d.read_shift(1));
            if (ft != 0x02 && !l7) field.offset = d.read_shift(4);
            field.len = d.read_shift(1);
            if (ft == 0x02) field.offset = d.read_shift(2);
            field.dec = d.read_shift(1);
            if (field.name.length) fields.push(field);
            if (ft != 0x02) d.l += l7 ? 13 : 14;
            switch(field.type){
                case 'B':
                    if ((!vfp || field.len != 8) && opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case 'G':
                case 'P':
                    if (opts.WTF) console.log('Skipping ' + field.name + ':' + field.type);
                    break;
                case '+':
                case '0':
                case '@':
                case 'C':
                case 'D':
                case 'F':
                case 'I':
                case 'L':
                case 'M':
                case 'N':
                case 'O':
                case 'T':
                case 'Y':
                    break;
                default:
                    throw new Error('Unknown Field Type: ' + field.type);
            }
        }
        if (d[d.l] !== 0x0D) d.l = fpos - 1;
        if (d.read_shift(1) !== 0x0D) throw new Error("DBF Terminator not found " + d.l + " " + d[d.l]);
        d.l = fpos;
        /* data */ var R = 0, C = 0;
        out[0] = [];
        for(C = 0; C != fields.length; ++C)out[0][C] = fields[C].name;
        while(nrow-- > 0){
            if (d[d.l] === 0x2A) {
                // TODO: record marked as deleted -- create a hidden row?
                d.l += rlen;
                continue;
            }
            ++d.l;
            out[++R] = [];
            C = 0;
            for(C = 0; C != fields.length; ++C){
                var dd = d.slice(d.l, d.l + fields[C].len);
                d.l += fields[C].len;
                $a1a91b25d7598376$var$prep_blob(dd, 0);
                var s = typeof $a1a91b25d7598376$var$$cptable !== "undefined" ? $a1a91b25d7598376$var$$cptable.utils.decode(current_cp, dd) : $a1a91b25d7598376$var$a2s(dd);
                switch(fields[C].type){
                    case 'C':
                        // NOTE: it is conventional to write '  /  /  ' for empty dates
                        if (s.trim().length) out[R][C] = s.replace(/([^\s])\s+$/, "$1");
                        break;
                    case 'D':
                        if (s.length === 8) {
                            out[R][C] = new Date(Date.UTC(+s.slice(0, 4), +s.slice(4, 6) - 1, +s.slice(6, 8), 0, 0, 0, 0));
                            if (!(opts && opts.UTC)) out[R][C] = $a1a91b25d7598376$var$utc_to_local(out[R][C]);
                        } else out[R][C] = s;
                        break;
                    case 'F':
                        out[R][C] = parseFloat(s.trim());
                        break;
                    case '+':
                    case 'I':
                        out[R][C] = l7 ? dd.read_shift(-4, 'i') ^ 0x80000000 : dd.read_shift(4, 'i');
                        break;
                    case 'L':
                        switch(s.trim().toUpperCase()){
                            case 'Y':
                            case 'T':
                                out[R][C] = true;
                                break;
                            case 'N':
                            case 'F':
                                out[R][C] = false;
                                break;
                            case '':
                            case '\x00':
                            case '?':
                                break;
                            default:
                                throw new Error("DBF Unrecognized L:|" + s + "|");
                        }
                        break;
                    case 'M':
                        /* TODO: handle memo files */ if (!memo) throw new Error("DBF Unexpected MEMO for type " + ft.toString(16));
                        out[R][C] = "##MEMO##" + (l7 ? parseInt(s.trim(), 10) : dd.read_shift(4));
                        break;
                    case 'N':
                        s = s.replace(/\u0000/g, "").trim();
                        // NOTE: dBASE II interprets "  .  " as 0
                        if (s && s != ".") out[R][C] = +s || 0;
                        break;
                    case '@':
                        // NOTE: dBASE specs appear to be incorrect
                        out[R][C] = new Date(dd.read_shift(-8, 'f') - 0x388317533400);
                        break;
                    case 'T':
                        var hi = dd.read_shift(4), lo = dd.read_shift(4);
                        if (hi == 0 && lo == 0) break;
                        out[R][C] = new Date((hi - 0x253D8C) * 0x5265C00 + lo);
                        if (!(opts && opts.UTC)) out[R][C] = $a1a91b25d7598376$var$utc_to_local(out[R][C]);
                        break;
                    case 'Y':
                        out[R][C] = dd.read_shift(4, 'i') / 1e4 + dd.read_shift(4, 'i') / 1e4 * Math.pow(2, 32);
                        break;
                    case 'O':
                        out[R][C] = -dd.read_shift(-8, 'f');
                        break;
                    case 'B':
                        if (vfp && fields[C].len == 8) {
                            out[R][C] = dd.read_shift(8, 'f');
                            break;
                        }
                    /* falls through */ case 'G':
                    case 'P':
                        dd.l += fields[C].len;
                        break;
                    case '0':
                        if (fields[C].name === '_NullFlags') break;
                    /* falls through */ default:
                        throw new Error("DBF Unsupported data type " + fields[C].type);
                }
            }
        }
        if (ft != 0x02) {
            if (d.l < d.length && d[d.l++] != 0x1A) throw new Error("DBF EOF Marker missing " + (d.l - 1) + " of " + d.length + " " + d[d.l - 1].toString(16));
        }
        if (opts && opts.sheetRows) out = out.slice(0, opts.sheetRows);
        opts.DBF = fields;
        return out;
    }
    function dbf_to_sheet(buf, opts) /*:Worksheet*/ {
        var o = opts || {};
        if (!o.dateNF) o.dateNF = "yyyymmdd";
        var ws = $a1a91b25d7598376$var$aoa_to_sheet(dbf_to_aoa(buf, o), o);
        ws["!cols"] = o.DBF.map(function(field) {
            return {
                wch: field.len,
                DBF: field
            };
        });
        delete o.DBF;
        return ws;
    }
    function dbf_to_workbook(buf, opts) /*:Workbook*/ {
        try {
            var o = $a1a91b25d7598376$var$sheet_to_workbook(dbf_to_sheet(buf, opts), opts);
            o.bookType = "dbf";
            return o;
        } catch (e) {
            if (opts && opts.WTF) throw e;
        }
        return {
            SheetNames: [],
            Sheets: {}
        };
    }
    var _RLEN = {
        'B': 8,
        'C': 250,
        'L': 1,
        'D': 8,
        '?': 0,
        '': 0
    };
    function sheet_to_dbf(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DBF");
        var o = opts || {};
        var old_cp = $a1a91b25d7598376$var$current_codepage;
        if (+o.codepage >= 0) $a1a91b25d7598376$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write DBF to JS string");
        var ba = $a1a91b25d7598376$var$buf_array();
        var aoa /*:AOA*/  = $a1a91b25d7598376$var$sheet_to_json(ws, {
            header: 1,
            raw: true,
            cellDates: true
        });
        var headers = aoa[0], data = aoa.slice(1), cols = ws["!cols"] || [];
        var i = 0, j = 0, hcnt = 0, rlen = 1;
        for(i = 0; i < headers.length; ++i){
            if (((cols[i] || {}).DBF || {}).name) {
                headers[i] = cols[i].DBF.name;
                ++hcnt;
                continue;
            }
            if (headers[i] == null) continue;
            ++hcnt;
            if (typeof headers[i] === 'number') headers[i] = headers[i].toString(10);
            if (typeof headers[i] !== 'string') throw new Error("DBF Invalid column name " + headers[i] + " |" + typeof headers[i] + "|");
            if (headers.indexOf(headers[i]) !== i) {
                for(j = 0; j < 1024; ++j)if (headers.indexOf(headers[i] + "_" + j) == -1) {
                    headers[i] += "_" + j;
                    break;
                }
            }
        }
        var range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
        var coltypes /*:Array<string>*/  = [];
        var colwidths /*:Array<number>*/  = [];
        var coldecimals /*:Array<number>*/  = [];
        for(i = 0; i <= range.e.c - range.s.c; ++i){
            var guess = '', _guess = '', maxlen = 0;
            var col /*:Array<any>*/  = [];
            for(j = 0; j < data.length; ++j)if (data[j][i] != null) col.push(data[j][i]);
            if (col.length == 0 || headers[i] == null) {
                coltypes[i] = '?';
                continue;
            }
            for(j = 0; j < col.length; ++j){
                switch(typeof col[j]){
                    /* TODO: check if L2 compat is desired */ case 'number':
                        _guess = 'B';
                        break;
                    case 'string':
                        _guess = 'C';
                        break;
                    case 'boolean':
                        _guess = 'L';
                        break;
                    case 'object':
                        _guess = col[j] instanceof Date ? 'D' : 'C';
                        break;
                    default:
                        _guess = 'C';
                }
                /* TODO: cache the values instead of encoding twice */ maxlen = Math.max(maxlen, (typeof $a1a91b25d7598376$var$$cptable !== "undefined" && typeof col[j] == "string" ? $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_ansi, col[j]) : String(col[j])).length);
                guess = guess && guess != _guess ? 'C' : _guess;
            //if(guess == 'C') break;
            }
            if (maxlen > 250) maxlen = 250;
            _guess = ((cols[i] || {}).DBF || {}).type;
            /* TODO: more fine grained control over DBF type resolution */ if (_guess == 'C') {
                if (cols[i].DBF.len > maxlen) maxlen = cols[i].DBF.len;
            }
            if (guess == 'B' && _guess == 'N') {
                guess = 'N';
                coldecimals[i] = cols[i].DBF.dec;
                maxlen = cols[i].DBF.len;
            }
            colwidths[i] = guess == 'C' || _guess == 'N' ? maxlen : _RLEN[guess] || 0;
            rlen += colwidths[i];
            coltypes[i] = guess;
        }
        var h = ba.next(32);
        h.write_shift(4, 0x13021130);
        h.write_shift(4, data.length);
        h.write_shift(2, 296 + 32 * hcnt);
        h.write_shift(2, rlen);
        for(i = 0; i < 4; ++i)h.write_shift(4, 0);
        var cp = +dbf_reverse_map[/*::String(*/ $a1a91b25d7598376$var$current_codepage /*::)*/ ] || 0x03;
        h.write_shift(4, 0x00000000 | cp << 8);
        if (dbf_codepage_map[cp] != +o.codepage) {
            if (o.codepage) console.error("DBF Unsupported codepage " + $a1a91b25d7598376$var$current_codepage + ", using 1252");
            $a1a91b25d7598376$var$current_codepage = 1252;
        }
        for(i = 0, j = 0; i < headers.length; ++i){
            if (headers[i] == null) continue;
            var hf = ba.next(32);
            /* TODO: test how applications handle non-ASCII field names */ var _f = (headers[i].slice(-10) + "\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00\x00").slice(0, 11);
            hf.write_shift(1, _f, "sbcs");
            hf.write_shift(1, coltypes[i] == '?' ? 'C' : coltypes[i], "sbcs");
            hf.write_shift(4, j);
            hf.write_shift(1, colwidths[i] || _RLEN[coltypes[i]] || 0);
            hf.write_shift(1, coldecimals[i] || 0);
            hf.write_shift(1, 0x02);
            hf.write_shift(4, 0);
            hf.write_shift(1, 0);
            hf.write_shift(4, 0);
            hf.write_shift(4, 0);
            j += colwidths[i] || _RLEN[coltypes[i]] || 0;
        }
        var hb = ba.next(264);
        hb.write_shift(4, 0x0000000D);
        for(i = 0; i < 65; ++i)hb.write_shift(4, 0x00000000);
        for(i = 0; i < data.length; ++i){
            var rout = ba.next(rlen);
            rout.write_shift(1, 0);
            for(j = 0; j < headers.length; ++j){
                if (headers[j] == null) continue;
                switch(coltypes[j]){
                    case 'L':
                        rout.write_shift(1, data[i][j] == null ? 0x3F : data[i][j] ? 0x54 : 0x46);
                        break;
                    case 'B':
                        rout.write_shift(8, data[i][j] || 0, 'f');
                        break;
                    case 'N':
                        var _n = "0";
                        if (typeof data[i][j] == "number") _n = data[i][j].toFixed(coldecimals[j] || 0);
                        if (_n.length > colwidths[j]) _n = _n.slice(0, colwidths[j]); // addresses decimal > width
                        for(hcnt = 0; hcnt < colwidths[j] - _n.length; ++hcnt)rout.write_shift(1, 0x20);
                        rout.write_shift(1, _n, "sbcs");
                        break;
                    case 'D':
                        if (!data[i][j]) rout.write_shift(8, "00000000", "sbcs");
                        else {
                            rout.write_shift(4, ("0000" + data[i][j].getFullYear()).slice(-4), "sbcs");
                            rout.write_shift(2, ("00" + (data[i][j].getMonth() + 1)).slice(-2), "sbcs");
                            rout.write_shift(2, ("00" + data[i][j].getDate()).slice(-2), "sbcs");
                        }
                        break;
                    case 'C':
                        var _l = rout.l;
                        var _s = String(data[i][j] != null ? data[i][j] : "").slice(0, colwidths[j]);
                        rout.write_shift(1, _s, "cpstr");
                        _l += colwidths[j] - rout.l;
                        for(hcnt = 0; hcnt < _l; ++hcnt)rout.write_shift(1, 0x20);
                        break;
                }
            }
        // data
        }
        $a1a91b25d7598376$var$current_codepage = old_cp;
        ba.next(1).write_shift(1, 0x1A);
        return ba.end();
    }
    return {
        to_workbook: dbf_to_workbook,
        to_sheet: dbf_to_sheet,
        from_sheet: sheet_to_dbf
    };
}();
var $a1a91b25d7598376$var$SYLK = /*#__PURE__*/ function() {
    /* TODO: stress test sequences */ var sylk_escapes = {
        AA: "\xc0",
        BA: "\xc1",
        CA: "\xc2",
        DA: 195,
        HA: "\xc4",
        JA: 197,
        AE: "\xc8",
        BE: "\xc9",
        CE: "\xca",
        HE: "\xcb",
        AI: "\xcc",
        BI: "\xcd",
        CI: "\xce",
        HI: "\xcf",
        AO: "\xd2",
        BO: "\xd3",
        CO: "\xd4",
        DO: 213,
        HO: "\xd6",
        AU: "\xd9",
        BU: "\xda",
        CU: "\xdb",
        HU: "\xdc",
        Aa: "\xe0",
        Ba: "\xe1",
        Ca: "\xe2",
        Da: 227,
        Ha: "\xe4",
        Ja: 229,
        Ae: "\xe8",
        Be: "\xe9",
        Ce: "\xea",
        He: "\xeb",
        Ai: "\xec",
        Bi: "\xed",
        Ci: "\xee",
        Hi: "\xef",
        Ao: "\xf2",
        Bo: "\xf3",
        Co: "\xf4",
        Do: 245,
        Ho: "\xf6",
        Au: "\xf9",
        Bu: "\xfa",
        Cu: "\xfb",
        Hu: "\xfc",
        KC: "\xc7",
        Kc: "\xe7",
        q: "\xe6",
        z: "\u0153",
        a: "\xc6",
        j: "\u0152",
        DN: 209,
        Dn: 241,
        Hy: 255,
        S: 169,
        c: 170,
        R: 174,
        "B ": 180,
        0: 176,
        1: 177,
        2: 178,
        3: 179,
        5: 181,
        6: 182,
        7: 183,
        Q: 185,
        k: 186,
        b: 208,
        i: 216,
        l: 222,
        s: 240,
        y: 248,
        "!": 161,
        '"': 162,
        "#": 163,
        "(": 164,
        "%": 165,
        "'": 167,
        "H ": 168,
        "+": 171,
        ";": 187,
        "<": 188,
        "=": 189,
        ">": 190,
        "?": 191,
        "{": 223
    } /*:any*/ ;
    var sylk_char_regex = new RegExp("\u001BN(" + $a1a91b25d7598376$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1").replace("{", "\\{") + "|\\|)", "gm");
    try {
        sylk_char_regex = new RegExp("\u001BN(" + $a1a91b25d7598376$var$keys(sylk_escapes).join("|").replace(/\|\|\|/, "|\\||").replace(/([?()+])/g, "\\$1") + "|\\|)", "gm");
    } catch (e) {}
    var sylk_char_fn = function(_, $1) {
        var o = sylk_escapes[$1];
        return typeof o == "number" ? $a1a91b25d7598376$var$_getansi(o) : o;
    };
    var decode_sylk_char = function($$, $1, $2) {
        var newcc = $1.charCodeAt(0) - 0x20 << 4 | $2.charCodeAt(0) - 0x30;
        return newcc == 59 ? $$ : $a1a91b25d7598376$var$_getansi(newcc);
    };
    sylk_escapes["|"] = 254;
    /* TODO: evert the escape map */ var encode_sylk_str = function($$) {
        return $$.replace(/\n/g, "\x1b :").replace(/\r/g, "\x1b =");
    };
    /* https://oss.sheetjs.com/notes/sylk/ for more details */ function sylk_to_aoa(d /*:RawData*/ , opts) /*:[AOA, Worksheet]*/ {
        switch(opts.type){
            case 'base64':
                return sylk_to_aoa_str($a1a91b25d7598376$var$Base64_decode(d), opts);
            case 'binary':
                return sylk_to_aoa_str(d, opts);
            case 'buffer':
                return sylk_to_aoa_str($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString('binary') : $a1a91b25d7598376$var$a2s(d), opts);
            case 'array':
                return sylk_to_aoa_str($a1a91b25d7598376$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function sylk_to_aoa_str(str /*:string*/ , opts) /*:[AOA, Worksheet]*/ {
        var records = str.split(/[\n\r]+/), R = -1, C = -1, ri = 0, rj = 0, arr /*:AOA*/  = [];
        var formats /*:Array<string>*/  = [];
        var next_cell_format /*:string|null*/  = null;
        var sht = {}, rowinfo /*:Array<RowInfo>*/  = [], colinfo /*:Array<ColInfo>*/  = [], cw /*:Array<string>*/  = [];
        var Mval = 0, j;
        var wb = {
            Workbook: {
                WBProps: {},
                Names: []
            }
        };
        if (+opts.codepage >= 0) $a1a91b25d7598376$var$set_cp(+opts.codepage);
        for(; ri !== records.length; ++ri){
            Mval = 0;
            var rstr = records[ri].trim().replace(/\x1B([\x20-\x2F])([\x30-\x3F])/g, decode_sylk_char).replace(sylk_char_regex, sylk_char_fn);
            var record = rstr.replace(/;;/g, "\u0000").split(";").map(function(x) {
                return x.replace(/\u0000/g, ";");
            });
            var RT = record[0], val1;
            if (rstr.length > 0) switch(RT){
                case 'ID':
                    break; /* header */ 
                case 'E':
                    break; /* EOF */ 
                case 'B':
                    break; /* dimensions */ 
                case 'O':
                    /* workbook options */ for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'V':
                            var d1904 = parseInt(record[rj].slice(1), 10);
                            // NOTE: it is technically an error if d1904 >= 5 or < 0
                            if (d1904 >= 1 && d1904 <= 4) wb.Workbook.WBProps.date1904 = true;
                            break;
                    }
                    break;
                case 'W':
                    break; /* window */ 
                case 'P':
                    switch(record[1].charAt(0)){
                        case 'P':
                            formats.push(rstr.slice(3).replace(/;;/g, ";"));
                            break;
                    }
                    break;
                case 'NN':
                    var nn = {
                        Sheet: 0
                    };
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'N':
                            nn.Name = record[rj].slice(1);
                            break;
                        case 'E':
                            nn.Ref = (opts && opts.sheet || "Sheet1") + "!" + $a1a91b25d7598376$var$rc_to_a1(record[rj].slice(1));
                            break;
                    }
                    wb.Workbook.Names.push(nn);
                    break;
                // case 'NE': // ??
                // case 'NU': // ??
                case 'C':
                    /* cell */ var C_seen_K = false, C_seen_X = false, C_seen_S = false, C_seen_E = false, _R = -1, _C = -1, formula = "", cell_t = "z";
                    var cmnt = "";
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'A':
                            cmnt = record[rj].slice(1);
                            break; // TODO: comment
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            C_seen_X = true;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!C_seen_X) C = 0;
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'K':
                            val1 = record[rj].slice(1);
                            if (val1.charAt(0) === '"') {
                                val1 = val1.slice(1, val1.length - 1);
                                cell_t = "s";
                            } else if (val1 === 'TRUE' || val1 === 'FALSE') {
                                val1 = val1 === 'TRUE';
                                cell_t = "b";
                            } else if (val1.charAt(0) == "#" && $a1a91b25d7598376$var$RBErr[val1] != null) {
                                cell_t = "e";
                                val1 = $a1a91b25d7598376$var$RBErr[val1];
                            } else if (!isNaN($a1a91b25d7598376$var$fuzzynum(val1))) {
                                val1 = $a1a91b25d7598376$var$fuzzynum(val1);
                                cell_t = "n";
                                if (next_cell_format !== null && $a1a91b25d7598376$var$fmt_is_date(next_cell_format) && opts.cellDates) {
                                    val1 = $a1a91b25d7598376$var$numdate(wb.Workbook.WBProps.date1904 ? val1 + 1462 : val1);
                                    cell_t = typeof val1 == "number" ? "n" : "d";
                                }
                            }
                            if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined' && typeof val1 == "string" && (opts || {}).type != "string" && (opts || {}).codepage) val1 = $a1a91b25d7598376$var$$cptable.utils.decode(opts.codepage, val1);
                            C_seen_K = true;
                            break;
                        case 'E':
                            C_seen_E = true;
                            formula = $a1a91b25d7598376$var$rc_to_a1(record[rj].slice(1), {
                                r: R,
                                c: C
                            });
                            break;
                        case 'S':
                            C_seen_S = true;
                            break;
                        case 'G':
                            break; // unknown
                        case 'R':
                            _R = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        case 'C':
                            _C = parseInt(record[rj].slice(1), 10) - 1;
                            break;
                        // case 'P': // ??
                        // case 'D': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (C_seen_K) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: cell_t,
                            v: val1
                        };
                        else {
                            arr[R][C].t = cell_t;
                            arr[R][C].v = val1;
                        }
                        if (next_cell_format) arr[R][C].z = next_cell_format;
                        if (opts.cellText !== false && next_cell_format) arr[R][C].w = $a1a91b25d7598376$var$SSF_format(arr[R][C].z, arr[R][C].v, {
                            date1904: wb.Workbook.WBProps.date1904
                        });
                        next_cell_format = null;
                    }
                    if (C_seen_S) {
                        if (C_seen_E) throw new Error("SYLK shared formula cannot have own formula");
                        var shrbase = _R > -1 && arr[_R][_C];
                        if (!shrbase || !shrbase[1]) throw new Error("SYLK shared formula cannot find base");
                        formula = $a1a91b25d7598376$var$shift_formula_str(shrbase[1], {
                            r: R - _R,
                            c: C - _C
                        });
                    }
                    if (formula) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'n',
                            f: formula
                        };
                        else arr[R][C].f = formula;
                    }
                    if (cmnt) {
                        if (!arr[R][C]) arr[R][C] = {
                            t: 'z'
                        };
                        arr[R][C].c = [
                            {
                                a: "SheetJSYLK",
                                t: cmnt
                            }
                        ];
                    }
                    break;
                case 'F':
                    /* Format */ var F_seen = 0;
                    for(rj = 1; rj < record.length; ++rj)switch(record[rj].charAt(0)){
                        case 'X':
                            C = parseInt(record[rj].slice(1), 10) - 1;
                            ++F_seen;
                            break;
                        case 'Y':
                            R = parseInt(record[rj].slice(1), 10) - 1; /*C = 0;*/ 
                            for(j = arr.length; j <= R; ++j)arr[j] = [];
                            break;
                        case 'M':
                            Mval = parseInt(record[rj].slice(1), 10) / 20;
                            break;
                        case 'F':
                            break; /* ??? */ 
                        case 'G':
                            break; /* hide grid */ 
                        case 'P':
                            next_cell_format = formats[parseInt(record[rj].slice(1), 10)];
                            break;
                        case 'S':
                            break; /* cell style */ 
                        case 'D':
                            break; /* column */ 
                        case 'N':
                            break; /* font */ 
                        case 'W':
                            cw = record[rj].slice(1).split(" ");
                            for(j = parseInt(cw[0], 10); j <= parseInt(cw[1], 10); ++j){
                                Mval = parseInt(cw[2], 10);
                                colinfo[j - 1] = Mval === 0 ? {
                                    hidden: true
                                } : {
                                    wch: Mval
                                };
                            }
                            break;
                        case 'C':
                            /* default column format */ C = parseInt(record[rj].slice(1), 10) - 1;
                            if (!colinfo[C]) colinfo[C] = {};
                            break;
                        case 'R':
                            /* row properties */ R = parseInt(record[rj].slice(1), 10) - 1;
                            if (!rowinfo[R]) rowinfo[R] = {};
                            if (Mval > 0) {
                                rowinfo[R].hpt = Mval;
                                rowinfo[R].hpx = $a1a91b25d7598376$var$pt2px(Mval);
                            } else if (Mval === 0) rowinfo[R].hidden = true;
                            break;
                        // case 'K': // ??
                        // case 'E': // ??
                        default:
                            if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
                    }
                    if (F_seen < 1) next_cell_format = null;
                    break;
                default:
                    if (opts && opts.WTF) throw new Error("SYLK bad record " + rstr);
            }
        }
        if (rowinfo.length > 0) sht['!rows'] = rowinfo;
        if (colinfo.length > 0) sht['!cols'] = colinfo;
        colinfo.forEach(function(col) {
            $a1a91b25d7598376$var$process_col(col);
        });
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return [
            arr,
            sht,
            wb
        ];
    }
    function sylk_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        var aoasht = sylk_to_aoa(d, opts);
        var aoa = aoasht[0], ws = aoasht[1], wb = aoasht[2];
        var _opts = $a1a91b25d7598376$var$dup(opts);
        _opts.date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var o = $a1a91b25d7598376$var$aoa_to_sheet(aoa, _opts);
        $a1a91b25d7598376$var$keys(ws).forEach(function(k) {
            o[k] = ws[k];
        });
        var outwb = $a1a91b25d7598376$var$sheet_to_workbook(o, opts);
        $a1a91b25d7598376$var$keys(wb).forEach(function(k) {
            outwb[k] = wb[k];
        });
        outwb.bookType = "sylk";
        return outwb;
    }
    function write_ws_cell_sylk(cell /*:Cell*/ , ws /*:Worksheet*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";K";
        switch(cell.t){
            case 'n':
                o += isFinite(cell.v) ? cell.v || 0 : $a1a91b25d7598376$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                if (cell.f && !cell.F) o += ";E" + $a1a91b25d7598376$var$a1_to_rc(cell.f, {
                    r: R,
                    c: C
                });
                break;
            case 'b':
                o += cell.v ? "TRUE" : "FALSE";
                break;
            case 'e':
                o += cell.w || $a1a91b25d7598376$var$BErr[cell.v] || cell.v;
                break;
            case 'd':
                o += $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v, date1904), date1904);
                break;
            case 's':
                o += '"' + (cell.v == null ? "" : String(cell.v)).replace(/"/g, "").replace(/;/g, ";;") + '"';
                break;
        }
        return o;
    }
    function write_ws_cmnt_sylk(cmnt /*:Comment*/ , R /*:number*/ , C /*:number*/ ) /*:string*/ {
        var o = "C;Y" + (R + 1) + ";X" + (C + 1) + ";A";
        /* TODO: max length? */ o += encode_sylk_str(cmnt.map(function(c) {
            return c.t;
        }).join(""));
        return o;
    }
    function write_ws_cols_sylk(out, cols) {
        cols.forEach(function(col, i) {
            var rec = "F;W" + (i + 1) + " " + (i + 1) + " ";
            if (col.hidden) rec += "0";
            else {
                if (typeof col.width == 'number' && !col.wpx) col.wpx = $a1a91b25d7598376$var$width2px(col.width);
                if (typeof col.wpx == 'number' && !col.wch) col.wch = $a1a91b25d7598376$var$px2char(col.wpx);
                if (typeof col.wch == 'number') rec += Math.round(col.wch);
            }
            if (rec.charAt(rec.length - 1) != " ") out.push(rec);
        });
    }
    function write_ws_rows_sylk(out /*:Array<string>*/ , rows /*:Array<RowInfo>*/ ) {
        rows.forEach(function(row, i) {
            var rec = "F;";
            if (row.hidden) rec += "M0;";
            else if (row.hpt) rec += "M" + 20 * row.hpt + ";";
            else if (row.hpx) rec += "M" + 20 * $a1a91b25d7598376$var$px2pt(row.hpx) + ";";
            if (rec.length > 2) out.push(rec + "R" + (i + 1));
        });
    }
    function sheet_to_sylk(ws /*:Worksheet*/ , opts /*:?any*/ , wb /*:?WorkBook*/ ) /*:string*/ {
        if (!opts) opts = {};
        opts._formats = [
            "General"
        ];
        /* TODO: codepage */ var preamble /*:Array<string>*/  = [
            "ID;PSheetJS;N;E"
        ], o /*:Array<string>*/  = [];
        var r = $a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1"), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        var RS = "\r\n";
        var d1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
        var _lastfmt = "General";
        preamble.push("P;PGeneral");
        /* Excel has been inconsistent in comment placement */ var R = r.s.r, C = r.s.c, p = [];
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)];
                if (!cell || !cell.c) continue;
                p.push(write_ws_cmnt_sylk(cell.c, R, C));
            }
            if (p.length) o.push(p.join(RS));
        }
        if (ws["!ref"]) for(R = r.s.r; R <= r.e.r; ++R){
            if (dense && !ws["!data"][R]) continue;
            p = [];
            for(C = r.s.c; C <= r.e.c; ++C){
                cell = dense ? ws["!data"][R][C] : ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)];
                if (!cell || cell.v == null && (!cell.f || cell.F)) continue;
                if ((cell.z || (cell.t == "d" ? $a1a91b25d7598376$var$table_fmt[14] : "General")) != _lastfmt) {
                    var ifmt = opts._formats.indexOf(cell.z);
                    if (ifmt == -1) {
                        opts._formats.push(cell.z);
                        ifmt = opts._formats.length - 1;
                        preamble.push("P;P" + cell.z.replace(/;/g, ";;"));
                    }
                    p.push("F;P" + ifmt + ";Y" + (R + 1) + ";X" + (C + 1));
                }
                p.push(write_ws_cell_sylk(cell, ws, R, C, opts, d1904));
            }
            o.push(p.join(RS));
        }
        preamble.push("F;P0;DG0G8;M255");
        if (ws['!cols']) write_ws_cols_sylk(preamble, ws['!cols']);
        if (ws['!rows']) write_ws_rows_sylk(preamble, ws['!rows']);
        if (ws["!ref"]) preamble.push("B;Y" + (r.e.r - r.s.r + 1) + ";X" + (r.e.c - r.s.c + 1) + ";D" + [
            r.s.c,
            r.s.r,
            r.e.c,
            r.e.r
        ].join(" "));
        preamble.push("O;L;D;B" + (d1904 ? ";V4" : "") + ";K47;G100 0.001");
        delete opts._formats;
        return preamble.join(RS) + RS + o.join(RS) + RS + "E" + RS;
    }
    return {
        to_workbook: sylk_to_workbook,
        from_sheet: sheet_to_sylk
    };
}();
var $a1a91b25d7598376$var$DIF = /*#__PURE__*/ function() {
    function dif_to_aoa(d /*:RawData*/ , opts) /*:AOA*/ {
        switch(opts.type){
            case 'base64':
                return dif_to_aoa_str($a1a91b25d7598376$var$Base64_decode(d), opts);
            case 'binary':
                return dif_to_aoa_str(d, opts);
            case 'buffer':
                return dif_to_aoa_str($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString('binary') : $a1a91b25d7598376$var$a2s(d), opts);
            case 'array':
                return dif_to_aoa_str($a1a91b25d7598376$var$cc2str(d), opts);
        }
        throw new Error("Unrecognized type " + opts.type);
    }
    function dif_to_aoa_str(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            if (records[ri].trim() === 'BOT') {
                arr[++R] = [];
                C = 0;
                continue;
            }
            if (R < 0) continue;
            var metadata = records[ri].trim().split(",");
            var type = metadata[0], value = metadata[1];
            ++ri;
            var data = records[ri] || "";
            while((data.match(/["]/g) || []).length & 1 && ri < records.length - 1)data += "\n" + records[++ri];
            data = data.trim();
            switch(+type){
                case -1:
                    if (data === 'BOT') {
                        arr[++R] = [];
                        C = 0;
                        continue;
                    } else if (data !== 'EOD') throw new Error("Unrecognized DIF special command " + data);
                    break;
                case 0:
                    if (data === 'TRUE') arr[R][C] = true;
                    else if (data === 'FALSE') arr[R][C] = false;
                    else if (!isNaN($a1a91b25d7598376$var$fuzzynum(value))) arr[R][C] = $a1a91b25d7598376$var$fuzzynum(value);
                    else if (!isNaN($a1a91b25d7598376$var$fuzzydate(value).getDate())) {
                        arr[R][C] = $a1a91b25d7598376$var$parseDate(value);
                        if (!(opts && opts.UTC)) arr[R][C] = $a1a91b25d7598376$var$utc_to_local(arr[R][C]);
                    } else arr[R][C] = value;
                    ++C;
                    break;
                case 1:
                    data = data.slice(1, data.length - 1);
                    data = data.replace(/""/g, '"');
                    if ($a1a91b25d7598376$var$DIF_XL && data && data.match(/^=".*"$/)) data = data.slice(2, -1);
                    arr[R][C++] = data !== '' ? data : null;
                    break;
            }
            if (data === 'EOD') break;
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function dif_to_sheet(str /*:string*/ , opts) /*:Worksheet*/ {
        return $a1a91b25d7598376$var$aoa_to_sheet(dif_to_aoa(str, opts), opts);
    }
    function dif_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
        var o = $a1a91b25d7598376$var$sheet_to_workbook(dif_to_sheet(str, opts), opts);
        o.bookType = "dif";
        return o;
    }
    function make_value(v /*:number*/ , s /*:string*/ ) /*:string*/ {
        return "0," + String(v) + "\r\n" + s;
    }
    function make_value_str(s /*:string*/ ) /*:string*/ {
        return "1,0\r\n\"" + s.replace(/"/g, '""') + '"';
    }
    function sheet_to_dif(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var _DIF_XL = $a1a91b25d7598376$var$DIF_XL;
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to DIF");
        var r = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        var o /*:Array<string>*/  = [
            "TABLE\r\n0,1\r\n\"sheetjs\"\r\n",
            "VECTORS\r\n0," + (r.e.r - r.s.r + 1) + "\r\n\"\"\r\n",
            "TUPLES\r\n0," + (r.e.c - r.s.c + 1) + "\r\n\"\"\r\n",
            "DATA\r\n0,0\r\n\"\"\r\n"
        ];
        for(var R = r.s.r; R <= r.e.r; ++R){
            var row = dense ? ws["!data"][R] : [];
            var p = "-1,0\r\nBOT\r\n";
            for(var C = r.s.c; C <= r.e.c; ++C){
                var cell /*:Cell*/  = dense ? row && row[C] : ws[$a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (cell == null) {
                    p += "1,0\r\n\"\"\r\n";
                    continue;
                }
                switch(cell.t){
                    case 'n':
                        if (_DIF_XL) {
                            if (cell.w != null) p += "0," + cell.w + "\r\nV";
                            else if (cell.v != null) p += make_value(cell.v, "V"); // TODO: should this call SSF_format?
                            else if (cell.f != null && !cell.F) p += make_value_str("=" + cell.f);
                            else p += "1,0\r\n\"\"";
                        } else if (cell.v == null) p += "1,0\r\n\"\"";
                        else p += make_value(cell.v, "V");
                        break;
                    case 'b':
                        p += cell.v ? make_value(1, "TRUE") : make_value(0, "FALSE");
                        break;
                    case 's':
                        p += make_value_str(!_DIF_XL || isNaN(+cell.v) ? cell.v : '="' + cell.v + '"');
                        break;
                    case 'd':
                        if (!cell.w) cell.w = $a1a91b25d7598376$var$SSF_format(cell.z || $a1a91b25d7598376$var$table_fmt[14], $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v)));
                        if (_DIF_XL) p += make_value(cell.w, "V");
                        else p += make_value_str(cell.w);
                        break;
                    default:
                        p += "1,0\r\n\"\"";
                }
                p += "\r\n";
            }
            o.push(p);
        }
        return o.join("") + "-1,0\r\nEOD";
    }
    return {
        to_workbook: dif_to_workbook,
        to_sheet: dif_to_sheet,
        from_sheet: sheet_to_dif
    };
}();
var $a1a91b25d7598376$var$ETH = /*#__PURE__*/ function() {
    function decode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\b/g, "\\").replace(/\\c/g, ":").replace(/\\n/g, "\n");
    }
    function encode(s /*:string*/ ) /*:string*/ {
        return s.replace(/\\/g, "\\b").replace(/:/g, "\\c").replace(/\n/g, "\\n");
    }
    function eth_to_aoa(str /*:string*/ , opts) /*:AOA*/ {
        var records = str.split('\n'), R = -1, C = -1, ri = 0, arr /*:AOA*/  = [];
        for(; ri !== records.length; ++ri){
            var record = records[ri].trim().split(":");
            if (record[0] !== 'cell') continue;
            var addr = $a1a91b25d7598376$var$decode_cell(record[1]);
            if (arr.length <= addr.r) {
                for(R = arr.length; R <= addr.r; ++R)if (!arr[R]) arr[R] = [];
            }
            R = addr.r;
            C = addr.c;
            switch(record[2]){
                case 't':
                    arr[R][C] = decode(record[3]);
                    break;
                case 'v':
                    arr[R][C] = +record[3];
                    break;
                case 'vtf':
                    var _f = record[record.length - 1];
                /* falls through */ case 'vtc':
                    switch(record[3]){
                        case 'nl':
                            arr[R][C] = +record[4] ? true : false;
                            break;
                        default:
                            arr[R][C] = record[record.length - 1].charAt(0) == "#" ? {
                                t: "e",
                                v: $a1a91b25d7598376$var$RBErr[record[record.length - 1]]
                            } : +record[4];
                            break;
                    }
                    if (record[2] == 'vtf') arr[R][C] = [
                        arr[R][C],
                        _f
                    ];
            }
        }
        if (opts && opts.sheetRows) arr = arr.slice(0, opts.sheetRows);
        return arr;
    }
    function eth_to_sheet(d /*:string*/ , opts) /*:Worksheet*/ {
        return $a1a91b25d7598376$var$aoa_to_sheet(eth_to_aoa(d, opts), opts);
    }
    function eth_to_workbook(d /*:string*/ , opts) /*:Workbook*/ {
        return $a1a91b25d7598376$var$sheet_to_workbook(eth_to_sheet(d, opts), opts);
    }
    var header = [
        "socialcalc:version:1.5",
        "MIME-Version: 1.0",
        "Content-Type: multipart/mixed; boundary=SocialCalcSpreadsheetControlSave"
    ].join("\n");
    var sep = [
        "--SocialCalcSpreadsheetControlSave",
        "Content-type: text/plain; charset=UTF-8"
    ].join("\n") + "\n";
    /* TODO: the other parts */ var meta = [
        "# SocialCalc Spreadsheet Control Save",
        "part:sheet"
    ].join("\n");
    var end = "--SocialCalcSpreadsheetControlSave--";
    function sheet_to_eth_data(ws /*:Worksheet*/ ) /*:string*/ {
        if (!ws || !ws['!ref']) return "";
        var o /*:Array<string>*/  = [], oo /*:Array<string>*/  = [], cell, coord = "";
        var r = $a1a91b25d7598376$var$decode_range(ws['!ref']);
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R)for(var C = r.s.c; C <= r.e.c; ++C){
            coord = $a1a91b25d7598376$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
            if (!cell || cell.v == null || cell.t === 'z') continue;
            oo = [
                "cell",
                coord,
                't'
            ];
            switch(cell.t){
                case 's':
                    oo.push(encode(cell.v));
                    break;
                case 'b':
                    oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                    oo[3] = 'nl';
                    oo[4] = cell.v ? "1" : "0";
                    oo[5] = encode(cell.f || (cell.v ? 'TRUE' : 'FALSE'));
                    break;
                case 'd':
                    var t = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v));
                    oo[2] = 'vtc';
                    oo[3] = 'nd';
                    oo[4] = "" + t;
                    oo[5] = cell.w || $a1a91b25d7598376$var$SSF_format(cell.z || $a1a91b25d7598376$var$table_fmt[14], t);
                    break;
                case 'n':
                    if (isFinite(cell.v)) {
                        if (!cell.f) {
                            oo[2] = 'v';
                            oo[3] = cell.v;
                        } else {
                            oo[2] = 'vtf';
                            oo[3] = 'n';
                            oo[4] = cell.v;
                            oo[5] = encode(cell.f);
                        }
                    } else {
                        oo[2] = 'vt' + (cell.f ? 'f' : 'c');
                        oo[3] = "e" + $a1a91b25d7598376$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
                        oo[4] = "0";
                        oo[5] = cell.f || oo[3].slice(1);
                        oo[6] = "e";
                        oo[7] = oo[3].slice(1);
                    }
                    break;
                case 'e':
                    continue;
            }
            o.push(oo.join(":"));
        }
        o.push("sheet:c:" + (r.e.c - r.s.c + 1) + ":r:" + (r.e.r - r.s.r + 1) + ":tvf:1");
        o.push("valueformat:1:text-wiki");
        //o.push("copiedfrom:" + ws['!ref']); // clipboard only
        return o.join("\n");
    }
    function sheet_to_eth(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        return [
            header,
            sep,
            meta,
            sep,
            sheet_to_eth_data(ws),
            end
        ].join("\n");
    // return ["version:1.5", sheet_to_eth_data(ws)].join("\n"); // clipboard form
    }
    return {
        to_workbook: eth_to_workbook,
        to_sheet: eth_to_sheet,
        from_sheet: sheet_to_eth
    };
}();
var $a1a91b25d7598376$var$PRN = /*#__PURE__*/ function() {
    function set_text_arr(data /*:string*/ , arr /*:AOA*/ , R /*:number*/ , C /*:number*/ , o /*:any*/ ) {
        if (o.raw) arr[R][C] = data;
        else if (data === "") ;
        else if (data === 'TRUE') arr[R][C] = true;
        else if (data === 'FALSE') arr[R][C] = false;
        else if (!isNaN($a1a91b25d7598376$var$fuzzynum(data))) arr[R][C] = $a1a91b25d7598376$var$fuzzynum(data);
        else if (!isNaN($a1a91b25d7598376$var$fuzzydate(data).getDate())) arr[R][C] = $a1a91b25d7598376$var$parseDate(data);
        else if (data.charCodeAt(0) == 35 /* # */  && $a1a91b25d7598376$var$RBErr[data] != null) arr[R][C] = {
            t: 'e',
            v: $a1a91b25d7598376$var$RBErr[data],
            w: data
        };
        else arr[R][C] = data;
    }
    function prn_to_aoa_str(f /*:string*/ , opts) /*:AOA*/ {
        var o = opts || {};
        var arr /*:AOA*/  = [];
        if (!f || f.length === 0) return arr;
        var lines = f.split(/[\r\n]/);
        var L = lines.length - 1;
        while(L >= 0 && lines[L].length === 0)--L;
        var start = 10, idx = 0;
        var R = 0;
        for(; R <= L; ++R){
            idx = lines[R].indexOf(" ");
            if (idx == -1) idx = lines[R].length;
            else idx++;
            start = Math.max(start, idx);
        }
        for(R = 0; R <= L; ++R){
            arr[R] = [];
            /* TODO: confirm that widths are always 10 */ var C = 0;
            set_text_arr(lines[R].slice(0, start).trim(), arr, R, C, o);
            for(C = 1; C <= (lines[R].length - start) / 10 + 1; ++C)set_text_arr(lines[R].slice(start + (C - 1) * 10, start + C * 10).trim(), arr, R, C, o);
        }
        if (o.sheetRows) arr = arr.slice(0, o.sheetRows);
        return arr;
    }
    // List of accepted CSV separators
    var guess_seps = {
        0x2C: ',',
        0x09: "\t",
        0x3B: ';',
        0x7C: '|'
    };
    // CSV separator weights to be used in case of equal numbers
    var guess_sep_weights = {
        0x2C: 3,
        0x09: 2,
        0x3B: 1,
        0x7C: 0
    };
    function guess_sep(str) {
        var cnt = {}, instr = false, end = 0, cc = 0;
        for(; end < str.length; ++end){
            if ((cc = str.charCodeAt(end)) == 0x22) instr = !instr;
            else if (!instr && cc in guess_seps) cnt[cc] = (cnt[cc] || 0) + 1;
        }
        cc = [];
        for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
            cnt[end],
            end
        ]);
        if (!cc.length) {
            cnt = guess_sep_weights;
            for(end in cnt)if (Object.prototype.hasOwnProperty.call(cnt, end)) cc.push([
                cnt[end],
                end
            ]);
        }
        cc.sort(function(a, b) {
            return a[0] - b[0] || guess_sep_weights[a[1]] - guess_sep_weights[b[1]];
        });
        return guess_seps[cc.pop()[1]] || 0x2C;
    }
    function dsv_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        var o = opts || {};
        var sep = "";
        if ($a1a91b25d7598376$var$DENSE != null && o.dense == null) o.dense = $a1a91b25d7598376$var$DENSE;
        var ws /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) ws["!data"] = [];
        var range /*:Range*/  = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        } /*:any*/ ;
        if (str.slice(0, 4) == "sep=") {
            // If the line ends in \r\n
            if (str.charCodeAt(5) == 13 && str.charCodeAt(6) == 10) {
                sep = str.charAt(4);
                str = str.slice(7);
            } else if (str.charCodeAt(5) == 13 || str.charCodeAt(5) == 10) {
                sep = str.charAt(4);
                str = str.slice(6);
            } else sep = guess_sep(str.slice(0, 1024));
        } else if (o && o.FS) sep = o.FS;
        else sep = guess_sep(str.slice(0, 1024));
        var R = 0, C = 0, v = 0;
        var start = 0, end = 0, sepcc = sep.charCodeAt(0), instr = false, cc = 0, startcc = str.charCodeAt(0);
        var _re /*:?RegExp*/  = o.dateNF != null ? $a1a91b25d7598376$var$dateNF_regex(o.dateNF) : null;
        function finish_cell() {
            /* TODO: fuzzy parsers should pass back assumed number format */ var s = str.slice(start, end);
            if (s.slice(-1) == "\r") s = s.slice(0, -1);
            var cell = {} /*:any*/ ;
            if (s.charAt(0) == '"' && s.charAt(s.length - 1) == '"') s = s.slice(1, -1).replace(/""/g, '"');
            if (o.cellText !== false) cell.w = s;
            if (s.length === 0) cell.t = 'z';
            else if (o.raw) {
                cell.t = 's';
                cell.v = s;
            } else if (s.trim().length === 0) {
                cell.t = 's';
                cell.v = s;
            } else if (s.charCodeAt(0) == 0x3D) {
                if (s.charCodeAt(1) == 0x22 && s.charCodeAt(s.length - 1) == 0x22) {
                    cell.t = 's';
                    cell.v = s.slice(2, -1).replace(/""/g, '"');
                } else if ($a1a91b25d7598376$var$fuzzyfmla(s)) {
                    cell.t = 's';
                    cell.f = s.slice(1);
                    cell.v = s;
                } else {
                    cell.t = 's';
                    cell.v = s;
                }
            } else if (s == "TRUE") {
                cell.t = 'b';
                cell.v = true;
            } else if (s == "FALSE") {
                cell.t = 'b';
                cell.v = false;
            } else if (!isNaN(v = $a1a91b25d7598376$var$fuzzynum(s))) {
                cell.t = 'n';
                cell.v = v;
            } else if (!isNaN((v = $a1a91b25d7598376$var$fuzzydate(s)).getDate()) || _re && s.match(_re)) {
                cell.z = o.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                if (_re && s.match(_re)) {
                    var news = $a1a91b25d7598376$var$dateNF_fix(s, o.dateNF, s.match(_re) || []);
                    v = $a1a91b25d7598376$var$parseDate(news);
                    if (o && o.UTC === false) v = $a1a91b25d7598376$var$utc_to_local(v);
                } else if (o && o.UTC === false) v = $a1a91b25d7598376$var$utc_to_local(v);
                else if (o.cellText !== false && o.dateNF) cell.w = $a1a91b25d7598376$var$SSF_format(cell.z, v);
                if (o.cellDates) {
                    cell.t = 'd';
                    cell.v = v;
                } else {
                    cell.t = 'n';
                    cell.v = $a1a91b25d7598376$var$datenum(v);
                }
                if (!o.cellNF) delete cell.z;
            } else if (s.charCodeAt(0) == 35 /* # */  && $a1a91b25d7598376$var$RBErr[s] != null) {
                cell.t = 'e';
                cell.w = s;
                cell.v = $a1a91b25d7598376$var$RBErr[s];
            } else {
                cell.t = 's';
                cell.v = s;
            }
            if (cell.t == 'z') ;
            else if (o.dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = cell;
            } else ws[$a1a91b25d7598376$var$encode_cell({
                c: C,
                r: R
            })] = cell;
            start = end + 1;
            startcc = str.charCodeAt(start);
            if (range.e.c < C) range.e.c = C;
            if (range.e.r < R) range.e.r = R;
            if (cc == sepcc) ++C;
            else {
                C = 0;
                ++R;
                if (o.sheetRows && o.sheetRows <= R) return true;
            }
        }
        outer: for(; end < str.length; ++end)switch(cc = str.charCodeAt(end)){
            case 0x22:
                if (startcc === 0x22) instr = !instr;
                break;
            case 0x0d:
                if (instr) break;
                if (str.charCodeAt(end + 1) == 0x0a) ++end;
            /* falls through */ case sepcc:
            case 0x0a:
                if (!instr && finish_cell()) break outer;
                break;
            default:
                break;
        }
        if (end - start > 0) finish_cell();
        ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
        return ws;
    }
    function prn_to_sheet_str(str /*:string*/ , opts) /*:Worksheet*/ {
        if (!(opts && opts.PRN)) return dsv_to_sheet_str(str, opts);
        if (opts.FS) return dsv_to_sheet_str(str, opts);
        if (str.slice(0, 4) == "sep=") return dsv_to_sheet_str(str, opts);
        if (str.indexOf("\t") >= 0 || str.indexOf(",") >= 0 || str.indexOf(";") >= 0) return dsv_to_sheet_str(str, opts);
        return $a1a91b25d7598376$var$aoa_to_sheet(prn_to_aoa_str(str, opts), opts);
    }
    function prn_to_sheet(d /*:RawData*/ , opts) /*:Worksheet*/ {
        var str = "", bytes = opts.type == 'string' ? [
            0,
            0,
            0,
            0
        ] : $a1a91b25d7598376$var$firstbyte(d, opts);
        switch(opts.type){
            case 'base64':
                str = $a1a91b25d7598376$var$Base64_decode(d);
                break;
            case 'binary':
                str = d;
                break;
            case 'buffer':
                if (opts.codepage == 65001) str = d.toString('utf8'); // TODO: test if buf
                else if (opts.codepage && typeof $a1a91b25d7598376$var$$cptable !== 'undefined') str = $a1a91b25d7598376$var$$cptable.utils.decode(opts.codepage, d);
                else str = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString('binary') : $a1a91b25d7598376$var$a2s(d);
                break;
            case 'array':
                str = $a1a91b25d7598376$var$cc2str(d);
                break;
            case 'string':
                str = d;
                break;
            default:
                throw new Error("Unrecognized type " + opts.type);
        }
        if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $a1a91b25d7598376$var$utf8read(str.slice(3));
        else if (opts.type != 'string' && opts.type != 'buffer' && opts.codepage == 65001) str = $a1a91b25d7598376$var$utf8read(str);
        else if (opts.type == 'binary' && typeof $a1a91b25d7598376$var$$cptable !== 'undefined' && opts.codepage) str = $a1a91b25d7598376$var$$cptable.utils.decode(opts.codepage, $a1a91b25d7598376$var$$cptable.utils.encode(28591, str));
        if (str.slice(0, 19) == "socialcalc:version:") return $a1a91b25d7598376$var$ETH.to_sheet(opts.type == 'string' ? str : $a1a91b25d7598376$var$utf8read(str), opts);
        return prn_to_sheet_str(str, opts);
    }
    function prn_to_workbook(d /*:RawData*/ , opts) /*:Workbook*/ {
        return $a1a91b25d7598376$var$sheet_to_workbook(prn_to_sheet(d, opts), opts);
    }
    function sheet_to_prn(ws /*:Worksheet*/  /*::, opts:?any*/ ) /*:string*/ {
        var o /*:Array<string>*/  = [];
        if (!ws["!ref"]) return "";
        var r = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']), cell /*:Cell*/ ;
        var dense = ws["!data"] != null;
        for(var R = r.s.r; R <= r.e.r; ++R){
            var oo /*:Array<string>*/  = [];
            for(var C = r.s.c; C <= r.e.c; ++C){
                var coord = $a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                });
                cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
                if (!cell || cell.v == null) {
                    oo.push("          ");
                    continue;
                }
                var w = (cell.w || ($a1a91b25d7598376$var$format_cell(cell), cell.w) || "").slice(0, 10);
                while(w.length < 10)w += " ";
                oo.push(w + (C === 0 ? " " : ""));
            }
            o.push(oo.join(""));
        }
        return o.join("\n");
    }
    return {
        to_workbook: prn_to_workbook,
        to_sheet: prn_to_sheet,
        from_sheet: sheet_to_prn
    };
}();
/* Excel defaults to SYLK but warns if data is not valid */ function $a1a91b25d7598376$var$read_wb_ID(d, opts) {
    var o = opts || {}, OLD_WTF = !!o.WTF;
    o.WTF = true;
    try {
        var out = $a1a91b25d7598376$var$SYLK.to_workbook(d, o);
        o.WTF = OLD_WTF;
        return out;
    } catch (e) {
        o.WTF = OLD_WTF;
        if (e.message.indexOf("SYLK bad record ID") == -1 && OLD_WTF) throw e;
        return $a1a91b25d7598376$var$PRN.to_workbook(d, opts);
    }
}
var $a1a91b25d7598376$var$WK_ = /*#__PURE__*/ function() {
    function lotushopper(data, cb /*:RecordHopperCB*/ , opts /*:any*/ ) {
        if (!data) return;
        $a1a91b25d7598376$var$prep_blob(data, data.l || 0);
        var Enum = opts.Enum || WK1Enum;
        while(data.l < data.length){
            var RT = data.read_shift(2);
            var R = Enum[RT] || Enum[0xFFFF];
            var length = data.read_shift(2);
            var tgt = data.l + length;
            var d = R.f && R.f(data, length, opts);
            data.l = tgt;
            if (cb(d, R, RT)) return;
        }
    }
    function lotus_to_workbook(d /*:RawData*/ , opts) {
        switch(opts.type){
            case 'base64':
                return lotus_to_workbook_buf($a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(d)), opts);
            case 'binary':
                return lotus_to_workbook_buf($a1a91b25d7598376$var$s2a(d), opts);
            case 'buffer':
            case 'array':
                return lotus_to_workbook_buf(d, opts);
        }
        throw "Unsupported type " + opts.type;
    }
    /* NOTE: this list intentionally starts at 1 */ var LOTUS_DATE_FMTS = [
        "mmmm",
        "dd-mmm-yyyy",
        "dd-mmm",
        "mmm-yyyy",
        "@",
        "mm/dd",
        "hh:mm:ss AM/PM",
        "hh:mm AM/PM",
        "mm/dd/yyyy",
        "mm/dd",
        "hh:mm:ss",
        "hh:mm" // 12
    ];
    function lotus_to_workbook_buf(d, opts) /*:Workbook*/ {
        if (!d) return d;
        var o = opts || {};
        if ($a1a91b25d7598376$var$DENSE != null && o.dense == null) o.dense = $a1a91b25d7598376$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ , n = "Sheet1", next_n = "", sidx = 0;
        var sheets = {}, snames = [], realnames = [], sdata = [];
        if (o.dense) sdata = s["!data"] = [];
        var refguess = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        var sheetRows = o.sheetRows || 0;
        var lastcell = {};
        if (d[4] == 0x51 && d[5] == 0x50 && d[6] == 0x57) return qpw_to_workbook_buf(d, opts);
        if (d[2] == 0x00) {
            if (d[3] == 0x08 || d[3] == 0x09) {
                if (d.length >= 16 && d[14] == 0x05 && d[15] === 0x6c) throw new Error("Unsupported Works 3 for Mac file");
            }
        }
        if (d[2] == 0x02) {
            o.Enum = WK1Enum;
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0x00:
                        /* BOF */ o.vers = val1;
                        if (val1 >= 0x1000) o.qpro = true;
                        break;
                    case 0xFF:
                        /* BOF (works 3+) */ o.vers = val1;
                        o.works = true;
                        break;
                    case 0x06:
                        refguess = val1;
                        break; /* RANGE */ 
                    case 0xCC:
                        if (val1) next_n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0xDE:
                        next_n = val1;
                        break; /* SHEETNAMELP */ 
                    case 0x0F:
                    /* LABEL */ case 0x33:
                        /* STRING */ if ((!o.qpro && !o.works || RT == 0x33) && val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        if (o.works || o.works2) val1[1].v = val1[1].v.replace(/\r\n/g, "\n");
                    /* falls through */ case 0x0D:
                    /* INTEGER */ case 0x0E:
                    /* NUMBER */ case 0x10:
                        /* FORMULA */ /* TODO: actual translation of the format code */ if ((val1[2] & 0x70) == 0x70 && (val1[2] & 0x0F) > 1 && (val1[2] & 0x0F) < 15) {
                            val1[1].z = o.dateNF || LOTUS_DATE_FMTS[(val1[2] & 0x0F) - 1] || $a1a91b25d7598376$var$table_fmt[14];
                            if (o.cellDates) {
                                val1[1].v = $a1a91b25d7598376$var$numdate(val1[1].v);
                                val1[1].t = typeof val1[1].v == "number" ? 'n' : 'd';
                            }
                        }
                        if (o.qpro) {
                            if (val1[3] > sidx) {
                                s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                                sheets[n] = s;
                                snames.push(n);
                                s = {} /*:any*/ ;
                                if (o.dense) sdata = s["!data"] = [];
                                refguess = {
                                    s: {
                                        r: 0,
                                        c: 0
                                    },
                                    e: {
                                        r: 0,
                                        c: 0
                                    }
                                };
                                sidx = val1[3];
                                n = next_n || "Sheet" + (sidx + 1);
                                next_n = "";
                            }
                        }
                        var tmpcell = o.dense ? (sdata[val1[0].r] || [])[val1[0].c] : s[$a1a91b25d7598376$var$encode_cell(val1[0])];
                        if (tmpcell) {
                            tmpcell.t = val1[1].t;
                            tmpcell.v = val1[1].v;
                            if (val1[1].z != null) tmpcell.z = val1[1].z;
                            if (val1[1].f != null) tmpcell.f = val1[1].f;
                            lastcell = tmpcell;
                            break;
                        }
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$a1a91b25d7598376$var$encode_cell(val1[0])] = val1[1];
                        lastcell = val1[1];
                        break;
                    case 0x5405:
                        o.works2 = true;
                        break;
                    case 0x5402:
                        /* TODO: enumerate all extended number formats */ if (val1 == 0x14a1) {
                            lastcell.z = "hh:mm:ss";
                            if (o.cellDates && lastcell.t == "n") {
                                lastcell.v = $a1a91b25d7598376$var$numdate(lastcell.v);
                                lastcell.t = typeof lastcell.v == "number" ? 'n' : 'd';
                            }
                        }
                        break;
                }
            }, o);
        } else if (d[2] == 0x1A || d[2] == 0x0E) {
            o.Enum = WK3Enum;
            if (d[2] == 0x0E) {
                o.qpro = true;
                d.l = 0;
            }
            lotushopper(d, function(val1, R, RT) {
                switch(RT){
                    case 0xCC:
                        n = val1;
                        break; /* SHEETNAMECS */ 
                    case 0x16:
                        /* LABEL16 */ if (val1[1].v.charCodeAt(0) < 0x30) val1[1].v = val1[1].v.slice(1);
                        // TODO: R9 appears to encode control codes this way -- verify against other versions
                        val1[1].v = val1[1].v.replace(/\x0F./g, function($$) {
                            return String.fromCharCode($$.charCodeAt(1) - 0x20);
                        }).replace(/\r\n/g, "\n");
                    /* falls through */ case 0x17:
                    /* NUMBER17 */ case 0x18:
                    /* NUMBER18 */ case 0x19:
                    /* FORMULA19 */ case 0x25:
                    /* NUMBER25 */ case 0x27:
                    /* NUMBER27 */ case 0x28:
                        /* FORMULA28 */ if (val1[3] > sidx) {
                            s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                            sheets[n] = s;
                            snames.push(n);
                            s = {} /*:any*/ ;
                            if (o.dense) sdata = s["!data"] = [];
                            refguess = {
                                s: {
                                    r: 0,
                                    c: 0
                                },
                                e: {
                                    r: 0,
                                    c: 0
                                }
                            };
                            sidx = val1[3];
                            n = "Sheet" + (sidx + 1);
                        }
                        if (sheetRows > 0 && val1[0].r >= sheetRows) break;
                        if (o.dense) {
                            if (!sdata[val1[0].r]) sdata[val1[0].r] = [];
                            sdata[val1[0].r][val1[0].c] = val1[1];
                        } else s[$a1a91b25d7598376$var$encode_cell(val1[0])] = val1[1];
                        if (refguess.e.c < val1[0].c) refguess.e.c = val1[0].c;
                        if (refguess.e.r < val1[0].r) refguess.e.r = val1[0].r;
                        break;
                    case 0x1B:
                        /* XFORMAT */ if (val1[0x36b0]) realnames[val1[0x36b0][0]] = val1[0x36b0][1];
                        break;
                    case 0x0601:
                        /* SHEETINFOQP */ realnames[val1[0]] = val1[1];
                        if (val1[0] == sidx) n = val1[1];
                        break;
                    default:
                        break;
                }
            }, o);
        } else throw new Error("Unrecognized LOTUS BOF " + d[2]);
        s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
        sheets[next_n || n] = s;
        snames.push(next_n || n);
        if (!realnames.length) return {
            SheetNames: snames,
            Sheets: sheets
        };
        var osheets = {}, rnames = [];
        /* TODO: verify no collisions */ for(var i = 0; i < realnames.length; ++i)if (sheets[snames[i]]) {
            rnames.push(realnames[i] || snames[i]);
            osheets[realnames[i]] = sheets[realnames[i]] || sheets[snames[i]];
        } else {
            rnames.push(realnames[i]);
            osheets[realnames[i]] = {
                "!ref": "A1"
            };
        }
        return {
            SheetNames: rnames,
            Sheets: osheets
        };
    }
    function sheet_to_wk1(ws /*:Worksheet*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $a1a91b25d7598376$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK1 to JS string");
        var ba = $a1a91b25d7598376$var$buf_array();
        if (!ws["!ref"]) throw new Error("Cannot export empty sheet to WK1");
        var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var cols = [];
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x00, write_BOF_WK1(0x0406));
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x06, write_RANGE(range));
        var max_R = Math.min(range.e.r, 8191);
        for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
        for(var R = range.s.r; R <= max_R; ++R){
            var rr = $a1a91b25d7598376$var$encode_row(R);
            for(C = range.s.c; C <= range.e.c; ++C){
                var cell = dense ? (ws["!data"][R] || [])[C] : ws[cols[C] + rr];
                if (!cell || cell.t == "z") continue;
                /* TODO: formula records */ switch(cell.t){
                    case "n":
                        if ((cell.v | 0) == cell.v && cell.v >= -32768 && cell.v <= 32767) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, cell));
                        else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, cell));
                        break;
                    case "d":
                        var dc = $a1a91b25d7598376$var$datenum(cell.v);
                        if ((dc | 0) == dc && dc >= -32768 && dc <= 32767) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0d, write_INTEGER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $a1a91b25d7598376$var$table_fmt[14]
                        }));
                        else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0e, write_NUMBER(R, C, {
                            t: "n",
                            v: dc,
                            z: cell.z || $a1a91b25d7598376$var$table_fmt[14]
                        }));
                        break;
                    default:
                        var str = $a1a91b25d7598376$var$format_cell(cell);
                        $a1a91b25d7598376$var$write_biff_rec(ba, 0x0F, write_LABEL(R, C, str.slice(0, 239)));
                }
            }
        }
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function book_to_wk3(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
        var o = opts || {};
        if (+o.codepage >= 0) $a1a91b25d7598376$var$set_cp(+o.codepage);
        if (o.type == "string") throw new Error("Cannot write WK3 to JS string");
        var ba = $a1a91b25d7598376$var$buf_array();
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x00, write_BOF_WK3(wb));
        for(var i = 0, cnt = 0; i < wb.SheetNames.length; ++i)if ((wb.Sheets[wb.SheetNames[i]] || {})["!ref"]) $a1a91b25d7598376$var$write_biff_rec(ba, 0x1b, write_XFORMAT_SHEETNAME(wb.SheetNames[i], cnt++));
        var wsidx = 0;
        for(i = 0; i < wb.SheetNames.length; ++i){
            var ws = wb.Sheets[wb.SheetNames[i]];
            if (!ws || !ws["!ref"]) continue;
            var range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
            var dense = ws["!data"] != null;
            var cols = [];
            var max_R = Math.min(range.e.r, 8191);
            for(var R = range.s.r; R <= max_R; ++R){
                var rr = $a1a91b25d7598376$var$encode_row(R);
                for(var C = range.s.c; C <= range.e.c; ++C){
                    if (R === range.s.r) cols[C] = $a1a91b25d7598376$var$encode_col(C);
                    var ref = cols[C] + rr;
                    var cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                    if (!cell || cell.t == "z") continue;
                    /* TODO: FORMULA19 NUMBER18 records */ if (cell.t == "n") $a1a91b25d7598376$var$write_biff_rec(ba, 0x17, write_NUMBER_17(R, C, wsidx, cell.v));
                    else {
                        var str = $a1a91b25d7598376$var$format_cell(cell);
                        /* TODO: max len? */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x16, write_LABEL_16(R, C, wsidx, str.slice(0, 239)));
                    }
                }
            }
            ++wsidx;
        }
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x01);
        return ba.end();
    }
    function write_BOF_WK1(v /*:number*/ ) {
        var out = $a1a91b25d7598376$var$new_buf(2);
        out.write_shift(2, v);
        return out;
    }
    function write_BOF_WK3(wb /*:Workbook*/ ) {
        var out = $a1a91b25d7598376$var$new_buf(26);
        out.write_shift(2, 0x1000);
        out.write_shift(2, 0x0004);
        out.write_shift(4, 0x0000);
        var rows = 0, cols = 0, wscnt = 0;
        for(var i = 0; i < wb.SheetNames.length; ++i){
            var name = wb.SheetNames[i];
            var ws = wb.Sheets[name];
            if (!ws || !ws["!ref"]) continue;
            ++wscnt;
            var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
            if (rows < range.e.r) rows = range.e.r;
            if (cols < range.e.c) cols = range.e.c;
        }
        if (rows > 8191) rows = 8191;
        out.write_shift(2, rows);
        out.write_shift(1, wscnt);
        out.write_shift(1, cols);
        out.write_shift(2, 0x00);
        out.write_shift(2, 0x00);
        out.write_shift(1, 0x01);
        out.write_shift(1, 0x02);
        out.write_shift(4, 0);
        out.write_shift(4, 0);
        return out;
    }
    function parse_RANGE(blob, length, opts) {
        var o = {
            s: {
                c: 0,
                r: 0
            },
            e: {
                c: 0,
                r: 0
            }
        };
        if (length == 8 && opts.qpro) {
            o.s.c = blob.read_shift(1);
            blob.l++;
            o.s.r = blob.read_shift(2);
            o.e.c = blob.read_shift(1);
            blob.l++;
            o.e.r = blob.read_shift(2);
            return o;
        }
        o.s.c = blob.read_shift(2);
        o.s.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        o.e.c = blob.read_shift(2);
        o.e.r = blob.read_shift(2);
        if (length == 12 && opts.qpro) blob.l += 2;
        if (o.s.c == 0xFFFF) o.s.c = o.e.c = o.s.r = o.e.r = 0;
        return o;
    }
    function write_RANGE(range) {
        var out = $a1a91b25d7598376$var$new_buf(8);
        out.write_shift(2, range.s.c);
        out.write_shift(2, range.s.r);
        out.write_shift(2, range.e.c);
        out.write_shift(2, range.e.r);
        return out;
    }
    function parse_cell(blob, length, opts) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0,
            0
        ];
        if (opts.qpro && opts.vers != 0x5120) {
            o[0].c = blob.read_shift(1);
            o[3] = blob.read_shift(1);
            o[0].r = blob.read_shift(2);
            blob.l += 2;
        } else if (opts.works) {
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
            o[2] = blob.read_shift(2);
        } else {
            o[2] = blob.read_shift(1);
            o[0].c = blob.read_shift(2);
            o[0].r = blob.read_shift(2);
        }
        return o;
    }
    function get_wk1_fmt(cell) /*:number*/ {
        /* TODO: some fuzzy matching on the number format */ if (cell.z && $a1a91b25d7598376$var$fmt_is_date(cell.z)) return 0xf0 | (LOTUS_DATE_FMTS.indexOf(cell.z) + 1 || 2);
        return 0xFF;
    }
    function parse_LABEL(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if ((opts.vers & 0xFFFE) == 0x5120) {
            blob.l++;
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        if (opts.qpro) blob.l++;
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function write_LABEL(R, C, s) {
        /* TODO: encoding */ var o = $a1a91b25d7598376$var$new_buf(7 + s.length);
        o.write_shift(1, 0xFF);
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(1, 0x27); // ??
        for(var i = 0; i < o.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_STRING(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        o[1].t = 's';
        if (opts.vers == 0x5120) {
            var len = blob.read_shift(1);
            o[1].v = blob.read_shift(len, 'utf8');
            return o;
        }
        o[1].v = blob.read_shift(tgt - blob.l, 'cstr');
        return o;
    }
    function parse_INTEGER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(2, 'i');
        return o;
    }
    function write_INTEGER(R, C, cell) {
        var o = $a1a91b25d7598376$var$new_buf(7);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(2, cell.v, 'i');
        return o;
    }
    function parse_NUMBER(blob, length, opts) {
        var o = parse_cell(blob, length, opts);
        o[1].v = blob.read_shift(8, 'f');
        return o;
    }
    function write_NUMBER(R, C, cell) {
        var o = $a1a91b25d7598376$var$new_buf(13);
        o.write_shift(1, get_wk1_fmt(cell));
        o.write_shift(2, C);
        o.write_shift(2, R);
        o.write_shift(8, cell.v, 'f');
        return o;
    }
    function parse_FORMULA(blob, length, opts) {
        var tgt = blob.l + length;
        var o = parse_cell(blob, length, opts);
        /* TODO: formula */ o[1].v = blob.read_shift(8, 'f');
        if (opts.qpro) blob.l = tgt;
        else {
            var flen = blob.read_shift(2);
            wk1_fmla_to_csf(blob.slice(blob.l, blob.l + flen), o);
            blob.l += flen;
        }
        return o;
    }
    function wk1_parse_rc(B, V, col) {
        var rel = V & 0x8000;
        V &= -32769;
        V = (rel ? B : 0) + (V >= 0x2000 ? V - 0x4000 : V);
        return (rel ? "" : "$") + (col ? $a1a91b25d7598376$var$encode_col(V) : $a1a91b25d7598376$var$encode_row(V));
    }
    /* var oprec = [
		8, 8, 8, 8, 8, 8, 8, 8, 6, 4, 4, 5, 5, 7, 3, 3,
		3, 3, 3, 3, 1, 1, 2, 6, 8, 8, 8, 8, 8, 8, 8, 8
	]; */ /* TODO: flesh out */ var FuncTab = {
        0x1F: [
            "NA",
            0
        ],
        // 0x20: ["ERR", 0],
        0x21: [
            "ABS",
            1
        ],
        0x22: [
            "TRUNC",
            1
        ],
        0x23: [
            "SQRT",
            1
        ],
        0x24: [
            "LOG",
            1
        ],
        0x25: [
            "LN",
            1
        ],
        0x26: [
            "PI",
            0
        ],
        0x27: [
            "SIN",
            1
        ],
        0x28: [
            "COS",
            1
        ],
        0x29: [
            "TAN",
            1
        ],
        0x2A: [
            "ATAN2",
            2
        ],
        0x2B: [
            "ATAN",
            1
        ],
        0x2C: [
            "ASIN",
            1
        ],
        0x2D: [
            "ACOS",
            1
        ],
        0x2E: [
            "EXP",
            1
        ],
        0x2F: [
            "MOD",
            2
        ],
        // 0x30
        0x31: [
            "ISNA",
            1
        ],
        0x32: [
            "ISERR",
            1
        ],
        0x33: [
            "FALSE",
            0
        ],
        0x34: [
            "TRUE",
            0
        ],
        0x35: [
            "RAND",
            0
        ],
        0x36: [
            "DATE",
            3
        ],
        // 0x37 NOW
        // 0x38 PMT
        // 0x39 PV
        // 0x3A FV
        // 0x3B IF
        // 0x3C DAY
        // 0x3D MONTH
        // 0x3E YEAR
        0x3F: [
            "ROUND",
            2
        ],
        0x40: [
            "TIME",
            3
        ],
        // 0x41 HOUR
        // 0x42 MINUTE
        // 0x43 SECOND
        0x44: [
            "ISNUMBER",
            1
        ],
        0x45: [
            "ISTEXT",
            1
        ],
        0x46: [
            "LEN",
            1
        ],
        0x47: [
            "VALUE",
            1
        ],
        // 0x48: ["FIXED", ?? 1],
        0x49: [
            "MID",
            3
        ],
        0x4A: [
            "CHAR",
            1
        ],
        // 0x4B
        // 0x4C FIND
        // 0x4D DATEVALUE
        // 0x4E TIMEVALUE
        // 0x4F CELL
        0x50: [
            "SUM",
            69
        ],
        0x51: [
            "AVERAGEA",
            69
        ],
        0x52: [
            "COUNTA",
            69
        ],
        0x53: [
            "MINA",
            69
        ],
        0x54: [
            "MAXA",
            69
        ],
        // 0x55 VLOOKUP
        // 0x56 NPV
        // 0x57 VAR
        // 0x58 STD
        // 0x59 IRR
        // 0x5A HLOOKUP
        // 0x5B DSUM
        // 0x5C DAVERAGE
        // 0x5D DCOUNTA
        // 0x5E DMIN
        // 0x5F DMAX
        // 0x60 DVARP
        // 0x61 DSTDEVP
        // 0x62 INDEX
        // 0x63 COLS
        // 0x64 ROWS
        // 0x65 REPEAT
        0x66: [
            "UPPER",
            1
        ],
        0x67: [
            "LOWER",
            1
        ],
        // 0x68 LEFT
        // 0x69 RIGHT
        // 0x6A REPLACE
        0x6B: [
            "PROPER",
            1
        ],
        // 0x6C CELL
        0x6D: [
            "TRIM",
            1
        ],
        // 0x6E CLEAN
        0x6F: [
            "T",
            1
        ]
    };
    var BinOpTab = [
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "+",
        "-",
        "*",
        "/",
        "^",
        "=",
        "<>",
        "<=",
        ">=",
        "<",
        ">",
        "",
        "",
        "",
        "",
        "&",
        "",
        "",
        "",
        "",
        "",
        "",
        "" // eslint-disable-line no-mixed-spaces-and-tabs
    ];
    function wk1_fmla_to_csf(blob, o) {
        $a1a91b25d7598376$var$prep_blob(blob, 0);
        var out = [], argc = 0, R = "", C = "", argL = "", argR = "";
        while(blob.l < blob.length){
            var cc = blob[blob.l++];
            switch(cc){
                case 0x00:
                    out.push(blob.read_shift(8, 'f'));
                    break;
                case 0x01:
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(C + R);
                    break;
                case 0x02:
                    var c = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    var r = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    C = wk1_parse_rc(o[0].c, blob.read_shift(2), true);
                    R = wk1_parse_rc(o[0].r, blob.read_shift(2), false);
                    out.push(c + r + ":" + C + R);
                    break;
                case 0x03:
                    if (blob.l < blob.length) {
                        console.error("WK1 premature formula end");
                        return;
                    }
                    break;
                case 0x04:
                    out.push("(" + out.pop() + ")");
                    break;
                case 0x05:
                    out.push(blob.read_shift(2));
                    break;
                case 0x06:
                    /* TODO: text encoding */ var Z = "";
                    while(cc = blob[blob.l++])Z += String.fromCharCode(cc);
                    out.push('"' + Z.replace(/"/g, '""') + '"');
                    break;
                case 0x08:
                    out.push("-" + out.pop());
                    break;
                case 0x17:
                    out.push("+" + out.pop());
                    break;
                case 0x16:
                    out.push("NOT(" + out.pop() + ")");
                    break;
                case 0x14:
                case 0x15:
                    argR = out.pop();
                    argL = out.pop();
                    out.push([
                        "AND",
                        "OR"
                    ][cc - 0x14] + "(" + argL + "," + argR + ")");
                    break;
                default:
                    if (cc < 0x20 && BinOpTab[cc]) {
                        argR = out.pop();
                        argL = out.pop();
                        out.push(argL + BinOpTab[cc] + argR);
                    } else if (FuncTab[cc]) {
                        argc = FuncTab[cc][1];
                        if (argc == 69) argc = blob[blob.l++];
                        if (argc > out.length) {
                            console.error("WK1 bad formula parse 0x" + cc.toString(16) + ":|" + out.join("|") + "|");
                            return;
                        }
                        var args = out.slice(-argc);
                        out.length -= argc;
                        out.push(FuncTab[cc][0] + "(" + args.join(",") + ")");
                    } else if (cc <= 0x07) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x18) return console.error("WK1 unsupported op " + cc.toString(16));
                    else if (cc <= 0x1E) return console.error("WK1 invalid opcode " + cc.toString(16));
                    else if (cc <= 0x73) return console.error("WK1 unsupported function opcode " + cc.toString(16));
                    else return console.error("WK1 unrecognized opcode " + cc.toString(16));
            }
        }
        if (out.length == 1) o[1].f = "" + out[0];
        else console.error("WK1 bad formula parse |" + out.join("|") + "|");
    }
    function parse_cell_3(blob /*::, length*/ ) {
        var o = [
            {
                c: 0,
                r: 0
            },
            {
                t: 'n',
                v: 0
            },
            0
        ];
        o[0].r = blob.read_shift(2);
        o[3] = blob[blob.l++];
        o[0].c = blob[blob.l++];
        return o;
    }
    function parse_LABEL_16(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].t = 's';
        o[1].v = blob.read_shift(length - 4, 'cstr');
        return o;
    }
    function write_LABEL_16(R, C, wsidx, s) {
        /* TODO: encoding */ var o = $a1a91b25d7598376$var$new_buf(6 + s.length);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        o.write_shift(1, 0x27);
        for(var i = 0; i < s.length; ++i){
            var cc = s.charCodeAt(i);
            o.write_shift(1, cc >= 0x80 ? 0x5F : cc);
        }
        o.write_shift(1, 0);
        return o;
    }
    function parse_NUMBER_18(blob, length) {
        var o = parse_cell_3(blob, length);
        o[1].v = blob.read_shift(2);
        var v = o[1].v >> 1;
        if (o[1].v & 0x1) switch(v & 0x07){
            case 0:
                v = (v >> 3) * 5000;
                break;
            case 1:
                v = (v >> 3) * 500;
                break;
            case 2:
                v = (v >> 3) / 20;
                break;
            case 3:
                v = (v >> 3) / 200;
                break;
            case 4:
                v = (v >> 3) / 2000;
                break;
            case 5:
                v = (v >> 3) / 20000;
                break;
            case 6:
                v = (v >> 3) / 16;
                break;
            case 7:
                v = (v >> 3) / 64;
                break;
        }
        o[1].v = v;
        return o;
    }
    function parse_NUMBER_17(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        var v2 = blob.read_shift(4);
        var e = blob.read_shift(2);
        if (e == 0xFFFF) {
            if (v1 === 0 && v2 === 0xC0000000) {
                o[1].t = "e";
                o[1].v = 0x0F;
            } else if (v1 === 0 && v2 === 0xD0000000) {
                o[1].t = "e";
                o[1].v = 0x2A;
            } else o[1].v = 0;
            return o;
        }
        var s = e & 0x8000;
        e = (e & 0x7FFF) - 16446;
        o[1].v = (1 - s * 2) * (v2 * Math.pow(2, e + 32) + v1 * Math.pow(2, e));
        return o;
    }
    function write_NUMBER_17(R, C, wsidx, v) {
        var o = $a1a91b25d7598376$var$new_buf(14);
        o.write_shift(2, R);
        o.write_shift(1, wsidx);
        o.write_shift(1, C);
        if (v == 0) {
            o.write_shift(4, 0);
            o.write_shift(4, 0);
            o.write_shift(2, 0xFFFF);
            return o;
        }
        var s = 0, e = 0, v1 = 0, v2 = 0;
        if (v < 0) {
            s = 1;
            v = -v;
        }
        e = Math.log2(v) | 0;
        v /= Math.pow(2, e - 31);
        v2 = v >>> 0;
        if ((v2 & 0x80000000) == 0) {
            v /= 2;
            ++e;
            v2 = v >>> 0;
        }
        v -= v2;
        v2 |= 0x80000000;
        v2 >>>= 0;
        v *= Math.pow(2, 32);
        v1 = v >>> 0;
        o.write_shift(4, v1);
        o.write_shift(4, v2);
        e += 0x3FFF + (s ? 0x8000 : 0);
        o.write_shift(2, e);
        return o;
    }
    function parse_FORMULA_19(blob, length) {
        var o = parse_NUMBER_17(blob, 14);
        blob.l += length - 14; /* TODO: WK3 formula */ 
        return o;
    }
    function parse_NUMBER_25(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(4);
        o[1].v = v1 >> 6;
        return o;
    }
    function parse_NUMBER_27(blob, length) {
        var o = parse_cell_3(blob, length);
        var v1 = blob.read_shift(8, 'f');
        o[1].v = v1;
        return o;
    }
    function parse_FORMULA_28(blob, length) {
        var o = parse_NUMBER_27(blob, 12);
        blob.l += length - 12; /* TODO: formula */ 
        return o;
    }
    function parse_SHEETNAMECS(blob, length) {
        return blob[blob.l + length - 1] == 0 ? blob.read_shift(length, 'cstr') : "";
    }
    function parse_SHEETNAMELP(blob, length) {
        var len = blob[blob.l++];
        if (len > length - 1) len = length - 1;
        var o = "";
        while(o.length < len)o += String.fromCharCode(blob[blob.l++]);
        return o;
    }
    function parse_SHEETINFOQP(blob, length, opts) {
        if (!opts.qpro || length < 21) return;
        var id = blob.read_shift(1);
        blob.l += 17;
        blob.l += 1; //var len = blob.read_shift(1);
        blob.l += 2;
        var nm = blob.read_shift(length - 21, 'cstr');
        return [
            id,
            nm
        ];
    }
    function parse_XFORMAT(blob, length) {
        var o = {}, tgt = blob.l + length;
        while(blob.l < tgt){
            var dt = blob.read_shift(2);
            if (dt == 0x36b0) {
                o[dt] = [
                    0,
                    ""
                ];
                o[dt][0] = blob.read_shift(2);
                while(blob[blob.l]){
                    o[dt][1] += String.fromCharCode(blob[blob.l]);
                    blob.l++;
                }
                blob.l++;
            }
        // TODO: 0x3a99 ??
        }
        return o;
    }
    function write_XFORMAT_SHEETNAME(name, wsidx) {
        var out = $a1a91b25d7598376$var$new_buf(5 + name.length);
        out.write_shift(2, 0x36b0);
        out.write_shift(2, wsidx);
        for(var i = 0; i < name.length; ++i){
            var cc = name.charCodeAt(i);
            out[out.l++] = cc > 0x7F ? 0x5F : cc;
        }
        out[out.l++] = 0;
        return out;
    }
    var WK1Enum = {
        0x0000: {
            n: "BOF",
            f: $a1a91b25d7598376$var$parseuint16
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "CALCMODE"
        },
        0x0003: {
            n: "CALCORDER"
        },
        0x0004: {
            n: "SPLIT"
        },
        0x0005: {
            n: "SYNC"
        },
        0x0006: {
            n: "RANGE",
            f: parse_RANGE
        },
        0x0007: {
            n: "WINDOW1"
        },
        0x0008: {
            n: "COLW1"
        },
        0x0009: {
            n: "WINTWO"
        },
        0x000A: {
            n: "COLW2"
        },
        0x000B: {
            n: "NAME"
        },
        0x000C: {
            n: "BLANK"
        },
        0x000D: {
            n: "INTEGER",
            f: parse_INTEGER
        },
        0x000E: {
            n: "NUMBER",
            f: parse_NUMBER
        },
        0x000F: {
            n: "LABEL",
            f: parse_LABEL
        },
        0x0010: {
            n: "FORMULA",
            f: parse_FORMULA
        },
        0x0018: {
            n: "TABLE"
        },
        0x0019: {
            n: "ORANGE"
        },
        0x001A: {
            n: "PRANGE"
        },
        0x001B: {
            n: "SRANGE"
        },
        0x001C: {
            n: "FRANGE"
        },
        0x001D: {
            n: "KRANGE1"
        },
        0x0020: {
            n: "HRANGE"
        },
        0x0023: {
            n: "KRANGE2"
        },
        0x0024: {
            n: "PROTEC"
        },
        0x0025: {
            n: "FOOTER"
        },
        0x0026: {
            n: "HEADER"
        },
        0x0027: {
            n: "SETUP"
        },
        0x0028: {
            n: "MARGINS"
        },
        0x0029: {
            n: "LABELFMT"
        },
        0x002A: {
            n: "TITLES"
        },
        0x002B: {
            n: "SHEETJS"
        },
        0x002D: {
            n: "GRAPH"
        },
        0x002E: {
            n: "NGRAPH"
        },
        0x002F: {
            n: "CALCCOUNT"
        },
        0x0030: {
            n: "UNFORMATTED"
        },
        0x0031: {
            n: "CURSORW12"
        },
        0x0032: {
            n: "WINDOW"
        },
        0x0033: {
            n: "STRING",
            f: parse_STRING
        },
        0x0037: {
            n: "PASSWORD"
        },
        0x0038: {
            n: "LOCKED"
        },
        0x003C: {
            n: "QUERY"
        },
        0x003D: {
            n: "QUERYNAME"
        },
        0x003E: {
            n: "PRINT"
        },
        0x003F: {
            n: "PRINTNAME"
        },
        0x0040: {
            n: "GRAPH2"
        },
        0x0041: {
            n: "GRAPHNAME"
        },
        0x0042: {
            n: "ZOOM"
        },
        0x0043: {
            n: "SYMSPLIT"
        },
        0x0044: {
            n: "NSROWS"
        },
        0x0045: {
            n: "NSCOLS"
        },
        0x0046: {
            n: "RULER"
        },
        0x0047: {
            n: "NNAME"
        },
        0x0048: {
            n: "ACOMM"
        },
        0x0049: {
            n: "AMACRO"
        },
        0x004A: {
            n: "PARSE"
        },
        // 0x0064
        0x0066: {
            n: "PRANGES??"
        },
        0x0067: {
            n: "RRANGES??"
        },
        0x0068: {
            n: "FNAME??"
        },
        0x0069: {
            n: "MRANGES??"
        },
        // 0x0096
        // 0x0099
        // 0x009A
        // 0x009B
        // 0x009C
        // 0x00C0
        // 0x00C7
        // 0x00C9
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        // 0x00CD
        0x00DE: {
            n: "SHEETNAMELP",
            f: parse_SHEETNAMELP
        },
        0x00FF: {
            n: "BOF",
            f: $a1a91b25d7598376$var$parseuint16
        },
        0x5402: {
            n: "WKSNF",
            f: $a1a91b25d7598376$var$parseuint16
        },
        0xFFFF: {
            n: ""
        }
    };
    var WK3Enum = {
        0x0000: {
            n: "BOF"
        },
        0x0001: {
            n: "EOF"
        },
        0x0002: {
            n: "PASSWORD"
        },
        0x0003: {
            n: "CALCSET"
        },
        0x0004: {
            n: "WINDOWSET"
        },
        0x0005: {
            n: "SHEETCELLPTR"
        },
        0x0006: {
            n: "SHEETLAYOUT"
        },
        0x0007: {
            n: "COLUMNWIDTH"
        },
        0x0008: {
            n: "HIDDENCOLUMN"
        },
        0x0009: {
            n: "USERRANGE"
        },
        0x000A: {
            n: "SYSTEMRANGE"
        },
        0x000B: {
            n: "ZEROFORCE"
        },
        0x000C: {
            n: "SORTKEYDIR"
        },
        0x000D: {
            n: "FILESEAL"
        },
        0x000E: {
            n: "DATAFILLNUMS"
        },
        0x000F: {
            n: "PRINTMAIN"
        },
        0x0010: {
            n: "PRINTSTRING"
        },
        0x0011: {
            n: "GRAPHMAIN"
        },
        0x0012: {
            n: "GRAPHSTRING"
        },
        0x0013: {
            n: "??"
        },
        0x0014: {
            n: "ERRCELL"
        },
        0x0015: {
            n: "NACELL"
        },
        0x0016: {
            n: "LABEL16",
            f: parse_LABEL_16
        },
        0x0017: {
            n: "NUMBER17",
            f: parse_NUMBER_17
        },
        0x0018: {
            n: "NUMBER18",
            f: parse_NUMBER_18
        },
        0x0019: {
            n: "FORMULA19",
            f: parse_FORMULA_19
        },
        0x001A: {
            n: "FORMULA1A"
        },
        0x001B: {
            n: "XFORMAT",
            f: parse_XFORMAT
        },
        0x001C: {
            n: "DTLABELMISC"
        },
        0x001D: {
            n: "DTLABELCELL"
        },
        0x001E: {
            n: "GRAPHWINDOW"
        },
        0x001F: {
            n: "CPA"
        },
        0x0020: {
            n: "LPLAUTO"
        },
        0x0021: {
            n: "QUERY"
        },
        0x0022: {
            n: "HIDDENSHEET"
        },
        0x0023: {
            n: "??"
        },
        0x0025: {
            n: "NUMBER25",
            f: parse_NUMBER_25
        },
        0x0026: {
            n: "??"
        },
        0x0027: {
            n: "NUMBER27",
            f: parse_NUMBER_27
        },
        0x0028: {
            n: "FORMULA28",
            f: parse_FORMULA_28
        },
        0x008E: {
            n: "??"
        },
        0x0093: {
            n: "??"
        },
        0x0096: {
            n: "??"
        },
        0x0097: {
            n: "??"
        },
        0x0098: {
            n: "??"
        },
        0x0099: {
            n: "??"
        },
        0x009A: {
            n: "??"
        },
        0x009B: {
            n: "??"
        },
        0x009C: {
            n: "??"
        },
        0x00A3: {
            n: "??"
        },
        0x00AE: {
            n: "??"
        },
        0x00AF: {
            n: "??"
        },
        0x00B0: {
            n: "??"
        },
        0x00B1: {
            n: "??"
        },
        0x00B8: {
            n: "??"
        },
        0x00B9: {
            n: "??"
        },
        0x00BA: {
            n: "??"
        },
        0x00BB: {
            n: "??"
        },
        0x00BC: {
            n: "??"
        },
        0x00C3: {
            n: "??"
        },
        0x00C9: {
            n: "??"
        },
        0x00CC: {
            n: "SHEETNAMECS",
            f: parse_SHEETNAMECS
        },
        0x00CD: {
            n: "??"
        },
        0x00CE: {
            n: "??"
        },
        0x00CF: {
            n: "??"
        },
        0x00D0: {
            n: "??"
        },
        0x0100: {
            n: "??"
        },
        0x0103: {
            n: "??"
        },
        0x0104: {
            n: "??"
        },
        0x0105: {
            n: "??"
        },
        0x0106: {
            n: "??"
        },
        0x0107: {
            n: "??"
        },
        0x0109: {
            n: "??"
        },
        0x010A: {
            n: "??"
        },
        0x010B: {
            n: "??"
        },
        0x010C: {
            n: "??"
        },
        0x010E: {
            n: "??"
        },
        0x010F: {
            n: "??"
        },
        0x0180: {
            n: "??"
        },
        0x0185: {
            n: "??"
        },
        0x0186: {
            n: "??"
        },
        0x0189: {
            n: "??"
        },
        0x018C: {
            n: "??"
        },
        0x0200: {
            n: "??"
        },
        0x0202: {
            n: "??"
        },
        0x0201: {
            n: "??"
        },
        0x0204: {
            n: "??"
        },
        0x0205: {
            n: "??"
        },
        0x0280: {
            n: "??"
        },
        0x0281: {
            n: "??"
        },
        0x0282: {
            n: "??"
        },
        0x0283: {
            n: "??"
        },
        0x0284: {
            n: "??"
        },
        0x0285: {
            n: "??"
        },
        0x0286: {
            n: "??"
        },
        0x0287: {
            n: "??"
        },
        0x0288: {
            n: "??"
        },
        0x0292: {
            n: "??"
        },
        0x0293: {
            n: "??"
        },
        0x0294: {
            n: "??"
        },
        0x0295: {
            n: "??"
        },
        0x0296: {
            n: "??"
        },
        0x0299: {
            n: "??"
        },
        0x029A: {
            n: "??"
        },
        0x0300: {
            n: "??"
        },
        0x0304: {
            n: "??"
        },
        0x0601: {
            n: "SHEETINFOQP",
            f: parse_SHEETINFOQP
        },
        0x0640: {
            n: "??"
        },
        0x0642: {
            n: "??"
        },
        0x0701: {
            n: "??"
        },
        0x0702: {
            n: "??"
        },
        0x0703: {
            n: "??"
        },
        0x0704: {
            n: "??"
        },
        0x0780: {
            n: "??"
        },
        0x0800: {
            n: "??"
        },
        0x0801: {
            n: "??"
        },
        0x0804: {
            n: "??"
        },
        0x0A80: {
            n: "??"
        },
        0x2AF6: {
            n: "??"
        },
        0x3231: {
            n: "??"
        },
        0x6E49: {
            n: "??"
        },
        0x6F44: {
            n: "??"
        },
        0xFFFF: {
            n: ""
        }
    };
    /* TODO: fill out and verify this table across QP versions */ var QPWNFTable = {
        0x05: "dd-mmm-yy",
        0x06: "dd-mmm",
        0x07: "mmm-yy",
        0x08: "mm/dd/yy",
        0x0A: "hh:mm:ss AM/PM",
        0x0B: "hh:mm AM/PM",
        0x0E: "dd-mmm-yyyy",
        0x0F: "mmm-yyyy",
        /* It is suspected that the the low nybble specifies decimal places */ 0x0022: "0.00",
        0x0032: "0.00;[Red]0.00",
        0x0042: "0.00;\(0.00\)",
        0x0052: "0.00;[Red]\(0.00\)",
        0x00A2: '"$"#,##0.00;\\("$"#,##0.00\\)',
        0x0120: '0%',
        0x0130: '0E+00',
        0x0140: '# ?/?'
    };
    function parse_qpw_str(p) {
        var cch = p.read_shift(2);
        var flags = p.read_shift(1);
        /* TODO: find examples with nonzero flags */ if (flags != 0) throw "unsupported QPW string type " + flags.toString(16);
        return p.read_shift(cch, "sbcs-cont");
    }
    /* QPW uses a different set of record types */ function qpw_to_workbook_buf(d, opts) /*:Workbook*/ {
        $a1a91b25d7598376$var$prep_blob(d, 0);
        var o = opts || {};
        if ($a1a91b25d7598376$var$DENSE != null && o.dense == null) o.dense = $a1a91b25d7598376$var$DENSE;
        var s /*:Worksheet*/  = {} /*:any*/ ;
        if (o.dense) s["!data"] = [];
        var SST = [], sname = "", formulae = [];
        var range = {
            s: {
                r: -1,
                c: -1
            },
            e: {
                r: -1,
                c: -1
            }
        };
        var cnt = 0, type = 0, C = 0, R = 0;
        var wb = {
            SheetNames: [],
            Sheets: {}
        };
        var FMTS = [];
        outer: while(d.l < d.length){
            var RT = d.read_shift(2), length = d.read_shift(2);
            var p = d.slice(d.l, d.l + length);
            $a1a91b25d7598376$var$prep_blob(p, 0);
            switch(RT){
                case 0x01:
                    /* BOF */ if (p.read_shift(4) != 0x39575051) throw "Bad QPW9 BOF!";
                    break;
                case 0x02:
                    break outer;
                case 0x08:
                    break; // TODO: this is tied to custom number formats
                case 0x0A:
                    var fcnt = p.read_shift(4);
                    var step = (p.length - p.l) / fcnt | 0;
                    for(var ifmt = 0; ifmt < fcnt; ++ifmt){
                        var end = p.l + step;
                        var fmt = {};
                        p.l += 2;
                        fmt.numFmtId = p.read_shift(2);
                        if (QPWNFTable[fmt.numFmtId]) fmt.z = QPWNFTable[fmt.numFmtId];
                        p.l = end;
                        FMTS.push(fmt);
                    }
                    break;
                /* TODO: The behavior here should be consistent with Numbers: QP Notebook ~ .TN.SheetArchive, QP Sheet ~ .TST.TableModelArchive */ case 0x0401:
                    break;
                case 0x0402:
                    break;
                case 0x0407:
                    p.l += 12;
                    while(p.l < p.length){
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        SST.push(p.read_shift(cnt, 'cstr'));
                    }
                    break;
                case 0x0408:
                    break;
                case 0x0601:
                    var sidx = p.read_shift(2);
                    s = {} /*:any*/ ;
                    if (o.dense) s["!data"] = [];
                    range.s.c = p.read_shift(2);
                    range.e.c = p.read_shift(2);
                    range.s.r = p.read_shift(4);
                    range.e.r = p.read_shift(4);
                    p.l += 4;
                    if (p.l + 2 < p.length) {
                        cnt = p.read_shift(2);
                        type = p.read_shift(1);
                        sname = cnt == 0 ? "" : p.read_shift(cnt, 'cstr');
                    }
                    if (!sname) sname = $a1a91b25d7598376$var$encode_col(sidx);
                    break;
                case 0x0602:
                    /* NOTE: QP valid range A1:IV1000000 */ if (range.s.c > 0xFF || range.s.r > 999999) break;
                    if (range.e.c < range.s.c) range.e.c = range.s.c;
                    if (range.e.r < range.s.r) range.e.r = range.s.r;
                    s["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                    $a1a91b25d7598376$var$book_append_sheet(wb, s, sname); // TODO: a barrel roll
                    break;
                case 0x0A01:
                    C = p.read_shift(2);
                    if (range.e.c < C) range.e.c = C;
                    if (range.s.c > C) range.s.c = C;
                    R = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    R = p.read_shift(4);
                    if (range.e.r < R) range.e.r = R;
                    break;
                case 0x0C01:
                    R = p.read_shift(4), cnt = p.read_shift(4);
                    if (range.s.r > R) range.s.r = R;
                    if (range.e.r < R + cnt - 1) range.e.r = R + cnt - 1;
                    var CC = $a1a91b25d7598376$var$encode_col(C);
                    while(p.l < p.length){
                        var cell = {
                            t: "z"
                        };
                        var flags = p.read_shift(1), fmtidx = -1;
                        if (flags & 0x80) fmtidx = p.read_shift(2);
                        var mul = flags & 0x40 ? p.read_shift(2) - 1 : 0;
                        switch(flags & 0x1F){
                            case 0:
                                break;
                            case 1:
                                break;
                            case 2:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2)
                                };
                                break;
                            case 3:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(2, 'i')
                                };
                                break;
                            case 4:
                                cell = {
                                    t: "n",
                                    v: $a1a91b25d7598376$var$parse_RkNumber(p)
                                };
                                break;
                            case 5:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                break;
                            case 7:
                                cell = {
                                    t: "s",
                                    v: SST[type = p.read_shift(4) - 1]
                                };
                                break;
                            case 8:
                                cell = {
                                    t: "n",
                                    v: p.read_shift(8, 'f')
                                };
                                p.l += 2; /* cell.f = formulae[p.read_shift(4)]; */ 
                                p.l += 4;
                                if (isNaN(cell.v)) cell = {
                                    t: "e",
                                    v: 0x0F
                                }; // #VALUE!
                                break;
                            default:
                                throw "Unrecognized QPW cell type " + (flags & 0x1F);
                        }
                        if (fmtidx != -1 && (FMTS[fmtidx - 1] || {}).z) cell.z = FMTS[fmtidx - 1].z;
                        var delta = 0;
                        if (flags & 0x20) switch(flags & 0x1F){
                            case 2:
                                delta = p.read_shift(2);
                                break;
                            case 3:
                                delta = p.read_shift(2, 'i');
                                break;
                            case 7:
                                delta = p.read_shift(2);
                                break;
                            default:
                                throw "Unsupported delta for QPW cell type " + (flags & 0x1F);
                        }
                        if (!(!o.sheetStubs && cell.t == "z")) {
                            var newcell = $a1a91b25d7598376$var$dup(cell);
                            if (cell.t == "n" && cell.z && $a1a91b25d7598376$var$fmt_is_date(cell.z) && o.cellDates) {
                                newcell.v = $a1a91b25d7598376$var$numdate(cell.v);
                                newcell.t = typeof newcell.v == "number" ? 'n' : 'd';
                            }
                            if (s["!data"] != null) {
                                if (!s["!data"][R]) s["!data"][R] = [];
                                s["!data"][R][C] = newcell;
                            } else s[CC + $a1a91b25d7598376$var$encode_row(R)] = newcell;
                        }
                        ++R;
                        --cnt;
                        while(mul-- > 0 && cnt >= 0){
                            if (flags & 0x20) switch(flags & 0x1F){
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    break;
                                case 3:
                                    cell = {
                                        t: "n",
                                        v: cell.v + delta & 0xFFFF
                                    };
                                    if (cell.v > 0x7FFF) cell.v -= 0x10000;
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = type + delta >>> 0]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply delta for QPW cell type " + (flags & 0x1F);
                            }
                            else switch(flags & 0x1F){
                                case 1:
                                    cell = {
                                        t: "z"
                                    };
                                    break;
                                case 2:
                                    cell = {
                                        t: "n",
                                        v: p.read_shift(2)
                                    };
                                    break;
                                case 7:
                                    cell = {
                                        t: "s",
                                        v: SST[type = p.read_shift(4) - 1]
                                    };
                                    break;
                                default:
                                    throw "Cannot apply repeat for QPW cell type " + (flags & 0x1F);
                            }
                            fmtidx;
                            if (!(!o.sheetStubs && cell.t == "z")) {
                                if (s["!data"] != null) {
                                    if (!s["!data"][R]) s["!data"][R] = [];
                                    s["!data"][R][C] = cell;
                                } else s[CC + $a1a91b25d7598376$var$encode_row(R)] = cell;
                            }
                            ++R;
                            --cnt;
                        }
                    }
                    break;
                case 0x0C02:
                    C = p.read_shift(2);
                    R = p.read_shift(4);
                    var str = parse_qpw_str(p);
                    /* TODO: QP10 record has an additional unknown character after the string */ if (s["!data"] != null) {
                        if (!s["!data"][R]) s["!data"][R] = [];
                        s["!data"][R][C] = {
                            t: "s",
                            v: str
                        };
                    } else s[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)] = {
                        t: "s",
                        v: str
                    };
                    break;
                default:
                    break;
            }
            d.l += length;
        }
        return wb;
    }
    return {
        sheet_to_wk1: sheet_to_wk1,
        book_to_wk3: book_to_wk3,
        to_workbook: lotus_to_workbook
    };
}();
/* 18.4.7 rPr CT_RPrElt */ function $a1a91b25d7598376$var$parse_rpr(rpr) {
    var font = {}, m = rpr.match($a1a91b25d7598376$var$tagregex), i = 0;
    var pass = false;
    if (m) for(; i != m.length; ++i){
        var y = $a1a91b25d7598376$var$parsexmltag(m[i]);
        switch(y[0].replace(/<\w*:/g, "<")){
            /* 18.8.12 condense CT_BooleanProperty */ /* ** not required . */ case '<condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ /* ** not required . */ case '<extend':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ /* ** not required . */ case '<shadow':
                if (!y.val) break;
            /* falls through */ case '<shadow>':
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
                break;
            /* 18.4.1 charset CT_IntProperty TODO */ case '<charset':
                if (y.val == '1') break;
                font.cp = $a1a91b25d7598376$var$CS2CP[parseInt(y.val, 10)];
                break;
            /* 18.4.2 outline CT_BooleanProperty TODO */ case '<outline':
                if (!y.val) break;
            /* falls through */ case '<outline>':
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
                break;
            /* 18.4.5 rFont CT_FontName */ case '<rFont':
                font.name = y.val;
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                font.sz = y.val;
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                if (!y.val) break;
            /* falls through */ case '<strike>':
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                if (!y.val) break;
                switch(y.val){
                    case 'double':
                        font.uval = "double";
                        break;
                    case 'singleAccounting':
                        font.uval = "single-accounting";
                        break;
                    case 'doubleAccounting':
                        font.uval = "double-accounting";
                        break;
                }
            /* falls through */ case '<u>':
            case '<u/>':
                font.u = 1;
                break;
            case '</u>':
                break;
            /* 18.8.2 b */ case '<b':
                if (y.val == '0') break;
            /* falls through */ case '<b>':
            case '<b/>':
                font.b = 1;
                break;
            case '</b>':
                break;
            /* 18.8.26 i */ case '<i':
                if (y.val == '0') break;
            /* falls through */ case '<i>':
            case '<i/>':
                font.i = 1;
                break;
            case '</i>':
                break;
            /* 18.3.1.15 color CT_Color TODO: tint, theme, auto, indexed */ case '<color':
                if (y.rgb) font.color = y.rgb.slice(2, 8);
                break;
            case '<color>':
            case '<color/>':
            case '</color>':
                break;
            /* 18.8.18 family ST_FontFamily */ case '<family':
                font.family = y.val;
                break;
            case '<family>':
            case '<family/>':
            case '</family>':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty TODO */ case '<vertAlign':
                font.valign = y.val;
                break;
            case '<vertAlign>':
            case '<vertAlign/>':
            case '</vertAlign>':
                break;
            /* 18.8.35 scheme CT_FontScheme TODO */ case '<scheme':
                break;
            case '<scheme>':
            case '<scheme/>':
            case '</scheme>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (y[0].charCodeAt(1) !== 47 && !pass) throw new Error('Unrecognized rich format ' + y[0]);
        }
    }
    return font;
}
var $a1a91b25d7598376$var$parse_rs = /*#__PURE__*/ function() {
    /* 18.4.4 r CT_RElt */ function parse_r(r) {
        /* 18.4.12 t ST_Xstring */ var t = $a1a91b25d7598376$var$str_match_xml_ns(r, "t") /*, cp = 65001*/ ;
        if (!t) return {
            t: "s",
            v: ""
        };
        var o /*:Cell*/  = {
            t: 's',
            v: $a1a91b25d7598376$var$unescapexml(t[1])
        } /*:any*/ ;
        var rpr = $a1a91b25d7598376$var$str_match_xml_ns(r, "rPr");
        if (rpr) o.s = $a1a91b25d7598376$var$parse_rpr(rpr[1]);
        return o;
    }
    var rregex = /<(?:\w+:)?r>/g, rend = /<\/(?:\w+:)?r>/;
    return function parse_rs(rs) {
        return rs.replace(rregex, "").split(rend).map(parse_r).filter(function(r) {
            return r.v;
        });
    };
}();
/* Parse a list of <r> tags */ var $a1a91b25d7598376$var$rs_to_html = /*#__PURE__*/ function parse_rs_factory() {
    var nlregex = /(\r\n|\n)/g;
    function parse_rpr2(font, intro, outro) {
        var style /*:Array<string>*/  = [];
        if (font.u) style.push("text-decoration: underline;");
        if (font.uval) style.push("text-underline-style:" + font.uval + ";");
        if (font.sz) style.push("font-size:" + font.sz + "pt;");
        if (font.outline) style.push("text-effect: outline;");
        if (font.shadow) style.push("text-shadow: auto;");
        intro.push('<span style="' + style.join("") + '">');
        if (font.b) {
            intro.push("<b>");
            outro.push("</b>");
        }
        if (font.i) {
            intro.push("<i>");
            outro.push("</i>");
        }
        if (font.strike) {
            intro.push("<s>");
            outro.push("</s>");
        }
        var align = font.valign || "";
        if (align == "superscript" || align == "super") align = "sup";
        else if (align == "subscript") align = "sub";
        if (align != "") {
            intro.push("<" + align + ">");
            outro.push("</" + align + ">");
        }
        outro.push("</span>");
        return font;
    }
    /* 18.4.4 r CT_RElt */ function r_to_html(r) {
        var terms /*:[Array<string>, string, Array<string>]*/  = [
            [],
            r.v,
            []
        ];
        if (!r.v) return "";
        if (r.s) parse_rpr2(r.s, terms[0], terms[2]);
        return terms[0].join("") + terms[1].replace(nlregex, '<br/>') + terms[2].join("");
    }
    return function parse_rs(rs) {
        return rs.map(r_to_html).join("");
    };
}();
/* 18.4.8 si CT_Rst */ var $a1a91b25d7598376$var$sitregex = /<(?:\w+:)?t\b[^<>]*>([^<]*)<\/(?:\w+:)?t>/g, $a1a91b25d7598376$var$sirregex = /<(?:\w+:)?r\b[^<>]*>/;
function $a1a91b25d7598376$var$parse_si(x, opts) {
    var html = opts ? opts.cellHTML : true;
    var z = {};
    if (!x) return {
        t: ""
    };
    //var y;
    /* 18.4.12 t ST_Xstring (Plaintext String) */ // TODO: is whitespace actually valid here?
    if (x.match(/^\s*<(?:\w+:)?t[^>]*>/)) {
        z.t = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(x.slice(x.indexOf(">") + 1).split(/<\/(?:\w+:)?t>/)[0] || ""), true);
        z.r = $a1a91b25d7598376$var$utf8read(x);
        if (html) z.h = $a1a91b25d7598376$var$escapehtml(z.t);
    } else if (/*y = */ x.match($a1a91b25d7598376$var$sirregex)) {
        z.r = $a1a91b25d7598376$var$utf8read(x);
        z.t = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(($a1a91b25d7598376$var$str_remove_xml_ns_g(x, "rPh").match($a1a91b25d7598376$var$sitregex) || []).join("").replace($a1a91b25d7598376$var$tagregex, "")), true);
        if (html) z.h = $a1a91b25d7598376$var$rs_to_html($a1a91b25d7598376$var$parse_rs(z.r));
    }
    /* 18.4.3 phoneticPr CT_PhoneticPr (TODO: needed for Asian support) */ /* 18.4.6 rPh CT_PhoneticRun (TODO: needed for Asian support) */ return z;
}
/* 18.4 Shared String Table */ var $a1a91b25d7598376$var$sstr1 = /<(?:\w+:)?(?:si|sstItem)>/g;
var $a1a91b25d7598376$var$sstr2 = /<\/(?:\w+:)?(?:si|sstItem)>/;
function $a1a91b25d7598376$var$parse_sst_xml(data /*:string*/ , opts) /*:SST*/ {
    var s /*:SST*/  = [], ss = "";
    if (!data) return s;
    /* 18.4.9 sst CT_Sst */ var sst = $a1a91b25d7598376$var$str_match_xml_ns(data, "sst");
    if (sst) {
        ss = sst[1].replace($a1a91b25d7598376$var$sstr1, "").split($a1a91b25d7598376$var$sstr2);
        for(var i = 0; i != ss.length; ++i){
            var o = $a1a91b25d7598376$var$parse_si(ss[i].trim(), opts);
            if (o != null) s[s.length] = o;
        }
        sst = $a1a91b25d7598376$var$parsexmltag(sst[0].slice(0, sst[0].indexOf(">")));
        s.Count = sst.count;
        s.Unique = sst.uniqueCount;
    }
    return s;
}
var $a1a91b25d7598376$var$straywsregex = /^\s|\s$|[\t\n\r]/;
function $a1a91b25d7598376$var$write_sst_xml(sst /*:SST*/ , opts) /*:string*/ {
    if (!opts.bookSST) return "";
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o[o.length] = $a1a91b25d7598376$var$writextag('sst', null, {
        xmlns: $a1a91b25d7598376$var$XMLNS_main[0],
        count: sst.Count,
        uniqueCount: sst.Unique
    });
    for(var i = 0; i != sst.length; ++i){
        if (sst[i] == null) continue;
        var s /*:XLString*/  = sst[i];
        var sitag = "<si>";
        if (s.r) sitag += s.r;
        else {
            sitag += "<t";
            if (!s.t) s.t = "";
            if (typeof s.t !== "string") s.t = String(s.t);
            if (s.t.match($a1a91b25d7598376$var$straywsregex)) sitag += ' xml:space="preserve"';
            sitag += ">" + $a1a91b25d7598376$var$escapexml(s.t) + "</t>";
        }
        sitag += "</si>";
        o[o.length] = sitag;
    }
    if (o.length > 2) {
        o[o.length] = '</sst>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.221 BrtBeginSst */ function $a1a91b25d7598376$var$parse_BrtBeginSst(data) {
    return [
        data.read_shift(4),
        data.read_shift(4)
    ];
}
/* [MS-XLSB] 2.1.7.45 Shared Strings */ function $a1a91b25d7598376$var$parse_sst_bin(data, opts) /*:SST*/ {
    var s /*:SST*/  = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_sst(val1, R, RT) {
        switch(RT){
            case 0x009F:
                /* BrtBeginSst */ s.Count = val1[0];
                s.Unique = val1[1];
                break;
            case 0x0013:
                /* BrtSSTItem */ s.push(val1);
                break;
            case 0x00A0:
                /* BrtEndSst */ return true;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            default:
                R.T;
                if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return s;
}
function $a1a91b25d7598376$var$write_BrtBeginSst(sst, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, sst.Count);
    o.write_shift(4, sst.Unique);
    return o;
}
var $a1a91b25d7598376$var$write_BrtSSTItem = $a1a91b25d7598376$var$write_RichStr;
function $a1a91b25d7598376$var$write_sst_bin(sst /*::, opts*/ ) {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 0x009F /* BrtBeginSst */ , $a1a91b25d7598376$var$write_BrtBeginSst(sst));
    for(var i = 0; i < sst.length; ++i)$a1a91b25d7598376$var$write_record(ba, 0x0013 /* BrtSSTItem */ , $a1a91b25d7598376$var$write_BrtSSTItem(sst[i]));
    /* FRTSST */ $a1a91b25d7598376$var$write_record(ba, 0x00A0 /* BrtEndSst */ );
    return ba.end();
}
function $a1a91b25d7598376$var$_JS2ANSI(str /*:string*/ ) /*:Array<number>*/ {
    if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined') return $a1a91b25d7598376$var$$cptable.utils.encode($a1a91b25d7598376$var$current_ansi, str);
    var o /*:Array<number>*/  = [], oo = str.split("");
    for(var i = 0; i < oo.length; ++i)o[i] = oo[i].charCodeAt(0);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.4 Version */ function $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, length /*:?number*/ ) {
    var o /*:any*/  = {};
    o.Major = blob.read_shift(2);
    o.Minor = blob.read_shift(2);
    /*:: if(length == null) return o; */ if (length >= 4) blob.l += length - 4;
    return o;
}
/* [MS-OFFCRYPTO] 2.1.5 DataSpaceVersionInfo */ function $a1a91b25d7598376$var$parse_DataSpaceVersionInfo(blob) {
    var o = {};
    o.id = blob.read_shift(0, 'lpp4');
    o.R = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.U = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.W = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6.1 DataSpaceMapEntry Structure */ function $a1a91b25d7598376$var$parse_DataSpaceMapEntry(blob) {
    var len = blob.read_shift(4);
    var end = blob.l + len - 4;
    var o = {};
    var cnt = blob.read_shift(4);
    var comps /*:Array<{t:number, v:string}>*/  = [];
    /* [MS-OFFCRYPTO] 2.1.6.2 DataSpaceReferenceComponent Structure */ while(cnt-- > 0)comps.push({
        t: blob.read_shift(4),
        v: blob.read_shift(0, 'lpp4')
    });
    o.name = blob.read_shift(0, 'lpp4');
    o.comps = comps;
    if (blob.l != end) throw new Error("Bad DataSpaceMapEntry: " + blob.l + " != " + end);
    return o;
}
/* [MS-OFFCRYPTO] 2.1.6 DataSpaceMap */ function $a1a91b25d7598376$var$parse_DataSpaceMap(blob) {
    var o = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push($a1a91b25d7598376$var$parse_DataSpaceMapEntry(blob));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.7 DataSpaceDefinition */ function $a1a91b25d7598376$var$parse_DataSpaceDefinition(blob) /*:Array<string>*/ {
    var o /*:Array<string>*/  = [];
    blob.l += 4; // must be 0x8
    var cnt = blob.read_shift(4);
    while(cnt-- > 0)o.push(blob.read_shift(0, 'lpp4'));
    return o;
}
/* [MS-OFFCRYPTO] 2.1.8 DataSpaceDefinition */ function $a1a91b25d7598376$var$parse_TransformInfoHeader(blob) {
    var o = {};
    /*var len = */ blob.read_shift(4);
    blob.l += 4; // must be 0x1
    o.id = blob.read_shift(0, 'lpp4');
    o.name = blob.read_shift(0, 'lpp4');
    o.R = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.U = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    o.W = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    return o;
}
function $a1a91b25d7598376$var$parse_Primary(blob) {
    /* [MS-OFFCRYPTO] 2.2.6 IRMDSTransformInfo */ var hdr = $a1a91b25d7598376$var$parse_TransformInfoHeader(blob);
    /* [MS-OFFCRYPTO] 2.1.9 EncryptionTransformInfo */ hdr.ename = blob.read_shift(0, '8lpp4');
    hdr.blksz = blob.read_shift(4);
    hdr.cmode = blob.read_shift(4);
    if (blob.read_shift(4) != 0x04) throw new Error("Bad !Primary record");
    return hdr;
}
/* [MS-OFFCRYPTO] 2.3.2 Encryption Header */ function $a1a91b25d7598376$var$parse_EncryptionHeader(blob, length /*:number*/ ) {
    var tgt = blob.l + length;
    var o = {};
    o.Flags = blob.read_shift(4) & 0x3F;
    blob.l += 4;
    o.AlgID = blob.read_shift(4);
    var valid = false;
    switch(o.AlgID){
        case 0x660E:
        case 0x660F:
        case 0x6610:
            valid = o.Flags == 0x24;
            break;
        case 0x6801:
            valid = o.Flags == 0x04;
            break;
        case 0:
            valid = o.Flags == 0x10 || o.Flags == 0x04 || o.Flags == 0x24;
            break;
        default:
            throw 'Unrecognized encryption algorithm: ' + o.AlgID;
    }
    if (!valid) throw new Error("Encryption Flags/AlgID mismatch");
    o.AlgIDHash = blob.read_shift(4);
    o.KeySize = blob.read_shift(4);
    o.ProviderType = blob.read_shift(4);
    blob.l += 8;
    o.CSPName = blob.read_shift(tgt - blob.l >> 1, 'utf16le');
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.3 Encryption Verifier */ function $a1a91b25d7598376$var$parse_EncryptionVerifier(blob, length /*:number*/ ) {
    var o = {}, tgt = blob.l + length;
    blob.l += 4; // SaltSize must be 0x10
    o.Salt = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    o.Verifier = blob.slice(blob.l, blob.l + 16);
    blob.l += 16;
    /*var sz = */ blob.read_shift(4);
    o.VerifierHash = blob.slice(blob.l, tgt);
    blob.l = tgt;
    return o;
}
/* [MS-OFFCRYPTO] 2.3.4.* EncryptionInfo Stream */ function $a1a91b25d7598376$var$parse_EncryptionInfo(blob) {
    var vers = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob);
    switch(vers.Minor){
        case 0x02:
            return [
                vers.Minor,
                $a1a91b25d7598376$var$parse_EncInfoStd(blob, vers)
            ];
        case 0x03:
            return [
                vers.Minor,
                $a1a91b25d7598376$var$parse_EncInfoExt(blob, vers)
            ];
        case 0x04:
            return [
                vers.Minor,
                $a1a91b25d7598376$var$parse_EncInfoAgl(blob, vers)
            ];
    }
    throw new Error("ECMA-376 Encrypted file unrecognized Version: " + vers.Minor);
}
/* [MS-OFFCRYPTO] 2.3.4.5  EncryptionInfo Stream (Standard Encryption) */ function $a1a91b25d7598376$var$parse_EncInfoStd(blob /*::, vers*/ ) {
    var flags = blob.read_shift(4);
    if ((flags & 0x3F) != 0x24) throw new Error("EncryptionInfo mismatch");
    var sz = blob.read_shift(4);
    //var tgt = blob.l + sz;
    var hdr = $a1a91b25d7598376$var$parse_EncryptionHeader(blob, sz);
    var verifier = $a1a91b25d7598376$var$parse_EncryptionVerifier(blob, blob.length - blob.l);
    return {
        t: "Std",
        h: hdr,
        v: verifier
    };
}
/* [MS-OFFCRYPTO] 2.3.4.6  EncryptionInfo Stream (Extensible Encryption) */ function $a1a91b25d7598376$var$parse_EncInfoExt() {
    throw new Error("File is password-protected: ECMA-376 Extensible");
}
/* [MS-OFFCRYPTO] 2.3.4.10 EncryptionInfo Stream (Agile Encryption) */ function $a1a91b25d7598376$var$parse_EncInfoAgl(blob /*::, vers*/ ) {
    var KeyData = [
        "saltSize",
        "blockSize",
        "keyBits",
        "hashSize",
        "cipherAlgorithm",
        "cipherChaining",
        "hashAlgorithm",
        "saltValue"
    ];
    blob.l += 4;
    var xml = blob.read_shift(blob.length - blob.l, 'utf8');
    var o = {};
    xml.replace($a1a91b25d7598376$var$tagregex, function xml_agile(x) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<?xml':
                break;
            case '<encryption':
            case '</encryption>':
                break;
            case '<keyData':
                KeyData.forEach(function(k) {
                    o[k] = y[k];
                });
                break;
            case '<dataIntegrity':
                o.encryptedHmacKey = y.encryptedHmacKey;
                o.encryptedHmacValue = y.encryptedHmacValue;
                break;
            case '<keyEncryptors>':
            case '<keyEncryptors':
                o.encs = [];
                break;
            case '</keyEncryptors>':
                break;
            case '<keyEncryptor':
                o.uri = y.uri;
                break;
            case '</keyEncryptor>':
                break;
            case '<encryptedKey':
                o.encs.push(y);
                break;
            default:
                throw y[0];
        }
    });
    return o;
}
/* [MS-OFFCRYPTO] 2.3.5.1 RC4 CryptoAPI Encryption Header */ function $a1a91b25d7598376$var$parse_RC4CryptoHeader(blob, length /*:number*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    length -= 4;
    if (vers.Minor != 2) throw new Error('unrecognized minor version code: ' + vers.Minor);
    if (vers.Major > 4 || vers.Major < 2) throw new Error('unrecognized major version code: ' + vers.Major);
    o.Flags = blob.read_shift(4);
    length -= 4;
    var sz = blob.read_shift(4);
    length -= 4;
    o.EncryptionHeader = $a1a91b25d7598376$var$parse_EncryptionHeader(blob, sz);
    length -= sz;
    o.EncryptionVerifier = $a1a91b25d7598376$var$parse_EncryptionVerifier(blob, length);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.6.1 RC4 Encryption Header */ function $a1a91b25d7598376$var$parse_RC4Header(blob /*::, length*/ ) {
    var o = {};
    var vers = o.EncryptionVersionInfo = $a1a91b25d7598376$var$parse_CRYPTOVersion(blob, 4);
    if (vers.Major != 1 || vers.Minor != 1) throw 'unrecognized version code ' + vers.Major + ' : ' + vers.Minor;
    o.Salt = blob.read_shift(16);
    o.EncryptedVerifier = blob.read_shift(16);
    o.EncryptedVerifierHash = blob.read_shift(16);
    return o;
}
/* [MS-OFFCRYPTO] 2.3.7.1 Binary Document Password Verifier Derivation */ function $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(Password /*:string*/ ) {
    var Verifier = 0x0000, PasswordArray;
    var PasswordDecoded = $a1a91b25d7598376$var$_JS2ANSI(Password);
    var len = PasswordDecoded.length + 1, i, PasswordByte;
    var Intermediate1, Intermediate2, Intermediate3;
    PasswordArray = $a1a91b25d7598376$var$new_raw_buf(len);
    PasswordArray[0] = PasswordDecoded.length;
    for(i = 1; i != len; ++i)PasswordArray[i] = PasswordDecoded[i - 1];
    for(i = len - 1; i >= 0; --i){
        PasswordByte = PasswordArray[i];
        Intermediate1 = (Verifier & 0x4000) === 0x0000 ? 0 : 1;
        Intermediate2 = Verifier << 1 & 0x7FFF;
        Intermediate3 = Intermediate1 | Intermediate2;
        Verifier = Intermediate3 ^ PasswordByte;
    }
    return Verifier ^ 0xCE4B;
}
/* [MS-OFFCRYPTO] 2.3.7.2 Binary Document XOR Array Initialization */ var $a1a91b25d7598376$var$crypto_CreateXorArray_Method1 = /*#__PURE__*/ function() {
    var PadArray = [
        0xBB,
        0xFF,
        0xFF,
        0xBA,
        0xFF,
        0xFF,
        0xB9,
        0x80,
        0x00,
        0xBE,
        0x0F,
        0x00,
        0xBF,
        0x0F,
        0x00
    ];
    var InitialCode = [
        0xE1F0,
        0x1D0F,
        0xCC9C,
        0x84C0,
        0x110C,
        0x0E10,
        0xF1CE,
        0x313E,
        0x1872,
        0xE139,
        0xD40F,
        0x84F9,
        0x280C,
        0xA96A,
        0x4EC3
    ];
    var XorMatrix = [
        0xAEFC,
        0x4DD9,
        0x9BB2,
        0x2745,
        0x4E8A,
        0x9D14,
        0x2A09,
        0x7B61,
        0xF6C2,
        0xFDA5,
        0xEB6B,
        0xC6F7,
        0x9DCF,
        0x2BBF,
        0x4563,
        0x8AC6,
        0x05AD,
        0x0B5A,
        0x16B4,
        0x2D68,
        0x5AD0,
        0x0375,
        0x06EA,
        0x0DD4,
        0x1BA8,
        0x3750,
        0x6EA0,
        0xDD40,
        0xD849,
        0xA0B3,
        0x5147,
        0xA28E,
        0x553D,
        0xAA7A,
        0x44D5,
        0x6F45,
        0xDE8A,
        0xAD35,
        0x4A4B,
        0x9496,
        0x390D,
        0x721A,
        0xEB23,
        0xC667,
        0x9CEF,
        0x29FF,
        0x53FE,
        0xA7FC,
        0x5FD9,
        0x47D3,
        0x8FA6,
        0x0F6D,
        0x1EDA,
        0x3DB4,
        0x7B68,
        0xF6D0,
        0xB861,
        0x60E3,
        0xC1C6,
        0x93AD,
        0x377B,
        0x6EF6,
        0xDDEC,
        0x45A0,
        0x8B40,
        0x06A1,
        0x0D42,
        0x1A84,
        0x3508,
        0x6A10,
        0xAA51,
        0x4483,
        0x8906,
        0x022D,
        0x045A,
        0x08B4,
        0x1168,
        0x76B4,
        0xED68,
        0xCAF1,
        0x85C3,
        0x1BA7,
        0x374E,
        0x6E9C,
        0x3730,
        0x6E60,
        0xDCC0,
        0xA9A1,
        0x4363,
        0x86C6,
        0x1DAD,
        0x3331,
        0x6662,
        0xCCC4,
        0x89A9,
        0x0373,
        0x06E6,
        0x0DCC,
        0x1021,
        0x2042,
        0x4084,
        0x8108,
        0x1231,
        0x2462,
        0x48C4
    ];
    var Ror = function(Byte) {
        return (Byte / 2 | Byte * 128) & 0xFF;
    };
    var XorRor = function(byte1, byte2) {
        return Ror(byte1 ^ byte2);
    };
    var CreateXorKey_Method1 = function(Password) {
        var XorKey = InitialCode[Password.length - 1];
        var CurrentElement = 0x68;
        for(var i = Password.length - 1; i >= 0; --i){
            var Char = Password[i];
            for(var j = 0; j != 7; ++j){
                if (Char & 0x40) XorKey ^= XorMatrix[CurrentElement];
                Char *= 2;
                --CurrentElement;
            }
        }
        return XorKey;
    };
    return function(password /*:string*/ ) {
        var Password = $a1a91b25d7598376$var$_JS2ANSI(password);
        var XorKey = CreateXorKey_Method1(Password);
        var Index = Password.length;
        var ObfuscationArray = $a1a91b25d7598376$var$new_raw_buf(16);
        for(var i = 0; i != 16; ++i)ObfuscationArray[i] = 0x00;
        var Temp, PasswordLastChar, PadIndex;
        if ((Index & 1) === 1) {
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[0], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            PasswordLastChar = Password[Password.length - 1];
            ObfuscationArray[Index] = XorRor(PasswordLastChar, Temp);
        }
        while(Index > 0){
            --Index;
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
        }
        Index = 15;
        PadIndex = 15 - Password.length;
        while(PadIndex > 0){
            Temp = XorKey >> 8;
            ObfuscationArray[Index] = XorRor(PadArray[PadIndex], Temp);
            --Index;
            --PadIndex;
            Temp = XorKey & 0xFF;
            ObfuscationArray[Index] = XorRor(Password[Index], Temp);
            --Index;
            --PadIndex;
        }
        return ObfuscationArray;
    };
}();
/* [MS-OFFCRYPTO] 2.3.7.3 Binary Document XOR Data Transformation Method 1 */ var $a1a91b25d7598376$var$crypto_DecryptData_Method1 = function(password /*:string*/ , Data, XorArrayIndex, XorArray, O) {
    /* If XorArray is set, use it; if O is not set, make changes in-place */ if (!O) O = Data;
    if (!XorArray) XorArray = $a1a91b25d7598376$var$crypto_CreateXorArray_Method1(password);
    var Index, Value;
    for(Index = 0; Index != Data.length; ++Index){
        Value = Data[Index];
        Value ^= XorArray[XorArrayIndex];
        Value = (Value >> 5 | Value << 3) & 0xFF;
        O[Index] = Value;
        ++XorArrayIndex;
    }
    return [
        O,
        XorArrayIndex,
        XorArray
    ];
};
var $a1a91b25d7598376$var$crypto_MakeXorDecryptor = function(password /*:string*/ ) {
    var XorArrayIndex = 0, XorArray = $a1a91b25d7598376$var$crypto_CreateXorArray_Method1(password);
    return function(Data) {
        var O = $a1a91b25d7598376$var$crypto_DecryptData_Method1("", Data, XorArrayIndex, XorArray);
        XorArrayIndex = O[1];
        return O[0];
    };
};
/* 2.5.343 */ function $a1a91b25d7598376$var$parse_XORObfuscation(blob, length, opts, out) {
    var o = {
        key: $a1a91b25d7598376$var$parseuint16(blob),
        verificationBytes: $a1a91b25d7598376$var$parseuint16(blob)
    } /*:any*/ ;
    if (opts.password) o.verifier = $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(opts.password);
    out.valid = o.verificationBytes === o.verifier;
    if (out.valid) out.insitu = $a1a91b25d7598376$var$crypto_MakeXorDecryptor(opts.password);
    return o;
}
/* 2.4.117 */ function $a1a91b25d7598376$var$parse_FilePassHeader(blob, length /*:number*/ , oo) {
    var o = oo || {};
    o.Info = blob.read_shift(2);
    blob.l -= 2;
    if (o.Info === 1) o.Data = $a1a91b25d7598376$var$parse_RC4Header(blob, length);
    else o.Data = $a1a91b25d7598376$var$parse_RC4CryptoHeader(blob, length);
    return o;
}
function $a1a91b25d7598376$var$parse_FilePass(blob, length /*:number*/ , opts) {
    var o = {
        Type: opts.biff >= 8 ? blob.read_shift(2) : 0
    } /*:any*/ ; /* wEncryptionType */ 
    if (o.Type) $a1a91b25d7598376$var$parse_FilePassHeader(blob, length - 2, o);
    else $a1a91b25d7598376$var$parse_XORObfuscation(blob, opts.biff >= 8 ? length : length - 2, opts, o);
    return o;
}
function $a1a91b25d7598376$var$rtf_to_sheet(d, opts) {
    switch(opts.type){
        case "base64":
            return $a1a91b25d7598376$var$rtf_to_sheet_str($a1a91b25d7598376$var$Base64_decode(d), opts);
        case "binary":
            return $a1a91b25d7598376$var$rtf_to_sheet_str(d, opts);
        case "buffer":
            return $a1a91b25d7598376$var$rtf_to_sheet_str($a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(d) ? d.toString("binary") : $a1a91b25d7598376$var$a2s(d), opts);
        case "array":
            return $a1a91b25d7598376$var$rtf_to_sheet_str($a1a91b25d7598376$var$cc2str(d), opts);
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $a1a91b25d7598376$var$rtf_to_sheet_str(str, opts) {
    var o = opts || {};
    var ws = {};
    var dense = o.dense;
    if (dense) ws["!data"] = [];
    var rows = $a1a91b25d7598376$var$str_match_ng(str, "\\trowd", "\\row");
    if (!rows) throw new Error("RTF missing table");
    var range = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: rows.length - 1
        }
    };
    var row = [];
    rows.forEach(function(rowtf, R) {
        if (dense) row = ws["!data"][R] = [];
        var rtfre = /\\[\w\-]+\b/g;
        var last_index = 0;
        var res;
        var C = -1;
        var payload = [];
        while((res = rtfre.exec(rowtf)) != null){
            var data = rowtf.slice(last_index, rtfre.lastIndex - res[0].length);
            if (data.charCodeAt(0) == 32) data = data.slice(1);
            if (data.length) payload.push(data);
            switch(res[0]){
                case "\\cell":
                    ++C;
                    if (payload.length) {
                        var cell = {
                            v: payload.join(""),
                            t: "s"
                        };
                        if (cell.v == "TRUE" || cell.v == "FALSE") {
                            cell.v = cell.v == "TRUE";
                            cell.t = "b";
                        } else if (!isNaN($a1a91b25d7598376$var$fuzzynum(cell.v))) {
                            cell.t = "n";
                            if (o.cellText !== false) cell.w = cell.v;
                            cell.v = $a1a91b25d7598376$var$fuzzynum(cell.v);
                        } else if ($a1a91b25d7598376$var$RBErr[cell.v] != null) {
                            cell.t = "e";
                            cell.w = cell.v;
                            cell.v = $a1a91b25d7598376$var$RBErr[cell.v];
                        }
                        if (dense) row[C] = cell;
                        else ws[$a1a91b25d7598376$var$encode_cell({
                            r: R,
                            c: C
                        })] = cell;
                    }
                    payload = [];
                    break;
                case "\\par":
                    payload.push("\n");
                    break;
            }
            last_index = rtfre.lastIndex;
        }
        if (C > range.e.c) range.e.c = C;
    });
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
    return ws;
}
function $a1a91b25d7598376$var$rtf_to_workbook(d, opts) {
    var wb = $a1a91b25d7598376$var$sheet_to_workbook($a1a91b25d7598376$var$rtf_to_sheet(d, opts), opts);
    wb.bookType = "rtf";
    return wb;
}
function $a1a91b25d7598376$var$sheet_to_rtf(ws, opts) {
    var o = [
        "{\\rtf1\\ansi"
    ];
    if (!ws["!ref"]) return o[0] + "}";
    var r = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]), cell;
    var dense = ws["!data"] != null, row = [];
    for(var R = r.s.r; R <= r.e.r; ++R){
        o.push("\\trowd\\trautofit1");
        for(var C = r.s.c; C <= r.e.c; ++C)o.push("\\cellx" + (C + 1));
        o.push("\\pard\\intbl");
        if (dense) row = ws["!data"][R] || [];
        for(C = r.s.c; C <= r.e.c; ++C){
            var coord = $a1a91b25d7598376$var$encode_cell({
                r: R,
                c: C
            });
            cell = dense ? row[C] : ws[coord];
            if (!cell || cell.v == null && (!cell.f || cell.F)) {
                o.push(" \\cell");
                continue;
            }
            o.push(" " + (cell.w || ($a1a91b25d7598376$var$format_cell(cell), cell.w) || "").replace(/[\r\n]/g, "\\par "));
            o.push("\\cell");
        }
        o.push("\\pard\\intbl\\row");
    }
    return o.join("") + "}";
}
function $a1a91b25d7598376$var$hex2RGB(h) {
    var o = h.slice(h[0] === "#" ? 1 : 0).slice(0, 6);
    return [
        parseInt(o.slice(0, 2), 16),
        parseInt(o.slice(2, 4), 16),
        parseInt(o.slice(4, 6), 16)
    ];
}
function $a1a91b25d7598376$var$rgb2Hex(rgb) {
    for(var i = 0, o = 1; i != 3; ++i)o = o * 256 + (rgb[i] > 255 ? 255 : rgb[i] < 0 ? 0 : rgb[i]);
    return o.toString(16).toUpperCase().slice(1);
}
function $a1a91b25d7598376$var$rgb2HSL(rgb) {
    var R = rgb[0] / 255, G = rgb[1] / 255, B = rgb[2] / 255;
    var M = Math.max(R, G, B), m = Math.min(R, G, B), C = M - m;
    if (C === 0) return [
        0,
        0,
        R
    ];
    var H6 = 0, S = 0, L2 = M + m;
    S = C / (L2 > 1 ? 2 - L2 : L2);
    switch(M){
        case R:
            H6 = ((G - B) / C + 6) % 6;
            break;
        case G:
            H6 = (B - R) / C + 2;
            break;
        case B:
            H6 = (R - G) / C + 4;
            break;
    }
    return [
        H6 / 6,
        S,
        L2 / 2
    ];
}
function $a1a91b25d7598376$var$hsl2RGB(hsl) {
    var H = hsl[0], S = hsl[1], L = hsl[2];
    var C = S * 2 * (L < 0.5 ? L : 1 - L), m = L - C / 2;
    var rgb = [
        m,
        m,
        m
    ], h6 = 6 * H;
    var X;
    if (S !== 0) switch(h6 | 0){
        case 0:
        case 6:
            X = C * h6;
            rgb[0] += C;
            rgb[1] += X;
            break;
        case 1:
            X = C * (2 - h6);
            rgb[0] += X;
            rgb[1] += C;
            break;
        case 2:
            X = C * (h6 - 2);
            rgb[1] += C;
            rgb[2] += X;
            break;
        case 3:
            X = C * (4 - h6);
            rgb[1] += X;
            rgb[2] += C;
            break;
        case 4:
            X = C * (h6 - 4);
            rgb[2] += C;
            rgb[0] += X;
            break;
        case 5:
            X = C * (6 - h6);
            rgb[2] += X;
            rgb[0] += C;
            break;
    }
    for(var i = 0; i != 3; ++i)rgb[i] = Math.round(rgb[i] * 255);
    return rgb;
}
/* 18.8.3 bgColor tint algorithm */ function $a1a91b25d7598376$var$rgb_tint(hex, tint) {
    if (tint === 0) return hex;
    var hsl = $a1a91b25d7598376$var$rgb2HSL($a1a91b25d7598376$var$hex2RGB(hex));
    if (tint < 0) hsl[2] = hsl[2] * (1 + tint);
    else hsl[2] = 1 - (1 - hsl[2]) * (1 - tint);
    return $a1a91b25d7598376$var$rgb2Hex($a1a91b25d7598376$var$hsl2RGB(hsl));
}
/* 18.3.1.13 width calculations */ /* [MS-OI29500] 2.1.595 Column Width & Formatting */ var $a1a91b25d7598376$var$DEF_MDW = 6, $a1a91b25d7598376$var$MAX_MDW = 15, $a1a91b25d7598376$var$MIN_MDW = 1, $a1a91b25d7598376$var$MDW = $a1a91b25d7598376$var$DEF_MDW;
function $a1a91b25d7598376$var$width2px(width) {
    return Math.floor((width + Math.round(128 / $a1a91b25d7598376$var$MDW) / 256) * $a1a91b25d7598376$var$MDW);
}
function $a1a91b25d7598376$var$px2char(px) {
    return Math.floor((px - 5) / $a1a91b25d7598376$var$MDW * 100 + 0.5) / 100;
}
function $a1a91b25d7598376$var$char2width(chr) {
    return Math.round((chr * $a1a91b25d7598376$var$MDW + 5) / $a1a91b25d7598376$var$MDW * 256) / 256;
}
//function px2char_(px) { return (((px - 5)/MDW * 100 + 0.5))/100; }
//function char2width_(chr) { return (((chr * MDW + 5)/MDW*256))/256; }
function $a1a91b25d7598376$var$cycle_width(collw) {
    return $a1a91b25d7598376$var$char2width($a1a91b25d7598376$var$px2char($a1a91b25d7598376$var$width2px(collw)));
}
/* XLSX/XLSB/XLS specify width in units of MDW */ function $a1a91b25d7598376$var$find_mdw_colw(collw) {
    var delta = Math.abs(collw - $a1a91b25d7598376$var$cycle_width(collw)), _MDW = $a1a91b25d7598376$var$MDW;
    if (delta > 0.005) {
        for($a1a91b25d7598376$var$MDW = $a1a91b25d7598376$var$MIN_MDW; $a1a91b25d7598376$var$MDW < $a1a91b25d7598376$var$MAX_MDW; ++$a1a91b25d7598376$var$MDW)if (Math.abs(collw - $a1a91b25d7598376$var$cycle_width(collw)) <= delta) {
            delta = Math.abs(collw - $a1a91b25d7598376$var$cycle_width(collw));
            _MDW = $a1a91b25d7598376$var$MDW;
        }
    }
    $a1a91b25d7598376$var$MDW = _MDW;
}
/* XLML specifies width in terms of pixels */ /*function find_mdw_wpx(wpx) {
	var delta = Infinity, guess = 0, _MDW = MIN_MDW;
	for(MDW=MIN_MDW; MDW<MAX_MDW; ++MDW) {
		guess = char2width_(px2char_(wpx))*256;
		guess = (guess) % 1;
		if(guess > 0.5) guess--;
		if(Math.abs(guess) < delta) { delta = Math.abs(guess); _MDW = MDW; }
	}
	MDW = _MDW;
}*/ function $a1a91b25d7598376$var$process_col(coll /*:ColInfo*/ ) {
    if (coll.width) {
        coll.wpx = $a1a91b25d7598376$var$width2px(coll.width);
        coll.wch = $a1a91b25d7598376$var$px2char(coll.wpx);
        coll.MDW = $a1a91b25d7598376$var$MDW;
    } else if (coll.wpx) {
        coll.wch = $a1a91b25d7598376$var$px2char(coll.wpx);
        coll.width = $a1a91b25d7598376$var$char2width(coll.wch);
        coll.MDW = $a1a91b25d7598376$var$MDW;
    } else if (typeof coll.wch == 'number') {
        coll.width = $a1a91b25d7598376$var$char2width(coll.wch);
        coll.wpx = $a1a91b25d7598376$var$width2px(coll.width);
        coll.MDW = $a1a91b25d7598376$var$MDW;
    }
    if (coll.customWidth) delete coll.customWidth;
}
var $a1a91b25d7598376$var$DEF_PPI = 96, $a1a91b25d7598376$var$PPI = $a1a91b25d7598376$var$DEF_PPI;
function $a1a91b25d7598376$var$px2pt(px) {
    return px * 96 / $a1a91b25d7598376$var$PPI;
}
function $a1a91b25d7598376$var$pt2px(pt) {
    return pt * $a1a91b25d7598376$var$PPI / 96;
}
/* [MS-EXSPXML3] 2.4.54 ST_enmPattern */ var $a1a91b25d7598376$var$XLMLPatternTypeMap = {
    "None": "none",
    "Solid": "solid",
    "Gray50": "mediumGray",
    "Gray75": "darkGray",
    "Gray25": "lightGray",
    "HorzStripe": "darkHorizontal",
    "VertStripe": "darkVertical",
    "ReverseDiagStripe": "darkDown",
    "DiagStripe": "darkUp",
    "DiagCross": "darkGrid",
    "ThickDiagCross": "darkTrellis",
    "ThinHorzStripe": "lightHorizontal",
    "ThinVertStripe": "lightVertical",
    "ThinReverseDiagStripe": "lightDown",
    "ThinHorzCross": "lightGrid"
};
/* 18.8.5 borders CT_Borders */ function $a1a91b25d7598376$var$parse_borders(t, styles, themes, opts) {
    styles.Borders = [];
    var border = {};
    var pass = false;
    (t.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<borders':
            case '<borders>':
            case '</borders>':
                break;
            /* 18.8.4 border CT_Border */ case '<border':
            case '<border>':
            case '<border/>':
                border = /*::(*/ {} /*:: :any)*/ ;
                if (y.diagonalUp) border.diagonalUp = $a1a91b25d7598376$var$parsexmlbool(y.diagonalUp);
                if (y.diagonalDown) border.diagonalDown = $a1a91b25d7598376$var$parsexmlbool(y.diagonalDown);
                styles.Borders.push(border);
                break;
            case '</border>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<left/>':
                break;
            case '<left':
            case '<left>':
                break;
            case '</left>':
                break;
            /* note: not in spec, appears to be CT_BorderPr */ case '<right/>':
                break;
            case '<right':
            case '<right>':
                break;
            case '</right>':
                break;
            /* 18.8.43 top CT_BorderPr */ case '<top/>':
                break;
            case '<top':
            case '<top>':
                break;
            case '</top>':
                break;
            /* 18.8.6 bottom CT_BorderPr */ case '<bottom/>':
                break;
            case '<bottom':
            case '<bottom>':
                break;
            case '</bottom>':
                break;
            /* 18.8.13 diagonal CT_BorderPr */ case '<diagonal':
            case '<diagonal>':
            case '<diagonal/>':
                break;
            case '</diagonal>':
                break;
            /* 18.8.25 horizontal CT_BorderPr */ case '<horizontal':
            case '<horizontal>':
            case '<horizontal/>':
                break;
            case '</horizontal>':
                break;
            /* 18.8.44 vertical CT_BorderPr */ case '<vertical':
            case '<vertical>':
            case '<vertical/>':
                break;
            case '</vertical>':
                break;
            /* 18.8.37 start CT_BorderPr */ case '<start':
            case '<start>':
            case '<start/>':
                break;
            case '</start>':
                break;
            /* 18.8.16 end CT_BorderPr */ case '<end':
            case '<end>':
            case '<end/>':
                break;
            case '</end>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color>':
                break;
            case '<color/>':
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in borders');
                }
        }
    });
}
/* 18.8.21 fills CT_Fills */ function $a1a91b25d7598376$var$parse_fills(t, styles, themes, opts) {
    styles.Fills = [];
    var fill = {};
    var pass = false;
    (t.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<fills':
            case '<fills>':
            case '</fills>':
                break;
            /* 18.8.20 fill CT_Fill */ case '<fill>':
            case '<fill':
            case '<fill/>':
                fill = {};
                styles.Fills.push(fill);
                break;
            case '</fill>':
                break;
            /* 18.8.24 gradientFill CT_GradientFill */ case '<gradientFill>':
                break;
            case '<gradientFill':
            case '</gradientFill>':
                styles.Fills.push(fill);
                fill = {};
                break;
            /* 18.8.32 patternFill CT_PatternFill */ case '<patternFill':
            case '<patternFill>':
                if (y.patternType) fill.patternType = y.patternType;
                break;
            case '<patternFill/>':
            case '</patternFill>':
                break;
            /* 18.8.3 bgColor CT_Color */ case '<bgColor':
                if (!fill.bgColor) fill.bgColor = {};
                if (y.indexed) fill.bgColor.indexed = parseInt(y.indexed, 10);
                if (y.theme) fill.bgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.bgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb) fill.bgColor.rgb = y.rgb.slice(-6);
                break;
            case '<bgColor/>':
            case '</bgColor>':
                break;
            /* 18.8.19 fgColor CT_Color */ case '<fgColor':
                if (!fill.fgColor) fill.fgColor = {};
                if (y.theme) fill.fgColor.theme = parseInt(y.theme, 10);
                if (y.tint) fill.fgColor.tint = parseFloat(y.tint);
                /* Excel uses ARGB strings */ if (y.rgb != null) fill.fgColor.rgb = y.rgb.slice(-6);
                break;
            case '<fgColor/>':
            case '</fgColor>':
                break;
            /* 18.8.38 stop CT_GradientStop */ case '<stop':
            case '<stop/>':
                break;
            case '</stop>':
                break;
            /* 18.8.? color CT_Color */ case '<color':
            case '<color/>':
                break;
            case '</color>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fills');
                }
        }
    });
}
/* 18.8.23 fonts CT_Fonts */ function $a1a91b25d7598376$var$parse_fonts(t, styles, themes, opts) {
    styles.Fonts = [];
    var font = {};
    var pass = false;
    (t.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<fonts':
            case '<fonts>':
            case '</fonts>':
                break;
            /* 18.8.22 font CT_Font */ case '<font':
            case '<font>':
                break;
            case '</font>':
            case '<font/>':
                styles.Fonts.push(font);
                font = {};
                break;
            /* 18.8.29 name CT_FontName */ case '<name':
                if (y.val) font.name = $a1a91b25d7598376$var$utf8read(y.val);
                break;
            case '<name/>':
            case '</name>':
                break;
            /* 18.8.2  b CT_BooleanProperty */ case '<b':
                font.bold = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<b/>':
                font.bold = 1;
                break;
            case '</b>':
            case '</b':
                break;
            /* 18.8.26 i CT_BooleanProperty */ case '<i':
                font.italic = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<i/>':
                font.italic = 1;
                break;
            case '</i>':
            case '</i':
                break;
            /* 18.4.13 u CT_UnderlineProperty */ case '<u':
                switch(y.val){
                    case "none":
                        font.underline = 0x00;
                        break;
                    case "single":
                        font.underline = 0x01;
                        break;
                    case "double":
                        font.underline = 0x02;
                        break;
                    case "singleAccounting":
                        font.underline = 0x21;
                        break;
                    case "doubleAccounting":
                        font.underline = 0x22;
                        break;
                }
                break;
            case '<u/>':
                font.underline = 1;
                break;
            case '</u>':
            case '</u':
                break;
            /* 18.4.10 strike CT_BooleanProperty */ case '<strike':
                font.strike = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<strike/>':
                font.strike = 1;
                break;
            case '</strike>':
            case '</strike':
                break;
            /* 18.4.2  outline CT_BooleanProperty */ case '<outline':
                font.outline = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<outline/>':
                font.outline = 1;
                break;
            case '</outline>':
            case '</outline':
                break;
            /* 18.8.36 shadow CT_BooleanProperty */ case '<shadow':
                font.shadow = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<shadow/>':
                font.shadow = 1;
                break;
            case '</shadow>':
            case '</shadow':
                break;
            /* 18.8.12 condense CT_BooleanProperty */ case '<condense':
                font.condense = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<condense/>':
                font.condense = 1;
                break;
            case '</condense>':
            case '</condense':
                break;
            /* 18.8.17 extend CT_BooleanProperty */ case '<extend':
                font.extend = y.val ? $a1a91b25d7598376$var$parsexmlbool(y.val) : 1;
                break;
            case '<extend/>':
                font.extend = 1;
                break;
            case '</extend>':
            case '</extend':
                break;
            /* 18.4.11 sz CT_FontSize */ case '<sz':
                if (y.val) font.sz = +y.val;
                break;
            case '<sz/>':
            case '</sz>':
            case '</sz':
                break;
            /* 18.4.14 vertAlign CT_VerticalAlignFontProperty */ case '<vertAlign':
                if (y.val) font.vertAlign = y.val;
                break;
            case '<vertAlign/>':
            case '</vertAlign>':
            case '</vertAlign':
                break;
            /* 18.8.18 family CT_FontFamily */ case '<family':
                if (y.val) font.family = parseInt(y.val, 10);
                break;
            case '<family/>':
            case '</family>':
            case '</family':
                break;
            /* 18.8.35 scheme CT_FontScheme */ case '<scheme':
                if (y.val) font.scheme = y.val;
                break;
            case '<scheme/>':
            case '</scheme>':
            case '</scheme':
                break;
            /* 18.4.1 charset CT_IntProperty */ case '<charset':
                if (y.val == '1') break;
                y.codepage = $a1a91b25d7598376$var$CS2CP[parseInt(y.val, 10)];
                break;
            case '<charset/>':
            case '</charset>':
            case '</charset':
                break;
            /* 18.?.? color CT_Color */ case '<color':
                if (!font.color) font.color = {};
                if (y.auto) font.color.auto = $a1a91b25d7598376$var$parsexmlbool(y.auto);
                if (y.rgb) font.color.rgb = y.rgb.slice(-6);
                else if (y.indexed) {
                    font.color.index = parseInt(y.indexed, 10);
                    var icv = $a1a91b25d7598376$var$XLSIcv[font.color.index];
                    if (font.color.index == 81) icv = $a1a91b25d7598376$var$XLSIcv[1];
                    if (!icv) icv = $a1a91b25d7598376$var$XLSIcv[1]; //throw new Error(x); // note: 206 is valid
                    font.color.rgb = icv[0].toString(16) + icv[1].toString(16) + icv[2].toString(16);
                } else if (y.theme) {
                    font.color.theme = parseInt(y.theme, 10);
                    if (y.tint) font.color.tint = parseFloat(y.tint);
                    if (y.theme && themes.themeElements && themes.themeElements.clrScheme) font.color.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[font.color.theme].rgb, font.color.tint || 0);
                }
                break;
            case '<color/>':
            case '</color>':
            case '</color':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
                pass = true;
                break;
            case '</AlternateContent>':
            case '</AlternateContent':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in fonts');
                }
        }
    });
}
/* 18.8.31 numFmts CT_NumFmts */ function $a1a91b25d7598376$var$parse_numFmts(t, styles, opts) {
    styles.NumberFmt = [];
    var k /*Array<number>*/  = $a1a91b25d7598376$var$keys($a1a91b25d7598376$var$table_fmt);
    for(var i = 0; i < k.length; ++i)styles.NumberFmt[k[i]] = $a1a91b25d7598376$var$table_fmt[k[i]];
    var m = t.match($a1a91b25d7598376$var$tagregex);
    if (!m) return;
    for(i = 0; i < m.length; ++i){
        var y = $a1a91b25d7598376$var$parsexmltag(m[i]);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<numFmts':
            case '</numFmts>':
            case '<numFmts/>':
            case '<numFmts>':
                break;
            case '<numFmt':
                var f = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(y.formatCode)), j = parseInt(y.numFmtId, 10);
                styles.NumberFmt[j] = f;
                if (j > 0) {
                    if (j > 0x188) {
                        for(j = 0x188; j > 0x3c; --j)if (styles.NumberFmt[j] == null) break;
                        styles.NumberFmt[j] = f;
                    }
                    $a1a91b25d7598376$var$SSF__load(f, j);
                }
                break;
            case '</numFmt>':
                break;
            default:
                if (opts.WTF) throw new Error('unrecognized ' + y[0] + ' in numFmts');
        }
    }
}
function $a1a91b25d7598376$var$write_numFmts(NF /*:{[n:number|string]:string}*/  /*::, opts*/ ) {
    var o = [
        "<numFmts>"
    ];
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) o[o.length] = $a1a91b25d7598376$var$writextag('numFmt', null, {
            numFmtId: i,
            formatCode: $a1a91b25d7598376$var$escapexml(NF[i])
        });
    });
    if (o.length === 1) return "";
    o[o.length] = "</numFmts>";
    o[0] = $a1a91b25d7598376$var$writextag('numFmts', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8.10 cellXfs CT_CellXfs */ var $a1a91b25d7598376$var$cellXF_uint = [
    "numFmtId",
    "fillId",
    "fontId",
    "borderId",
    "xfId"
];
var $a1a91b25d7598376$var$cellXF_bool = [
    "applyAlignment",
    "applyBorder",
    "applyFill",
    "applyFont",
    "applyNumberFormat",
    "applyProtection",
    "pivotButton",
    "quotePrefix"
];
function $a1a91b25d7598376$var$parse_cellXfs(t, styles, opts) {
    styles.CellXf = [];
    var xf;
    var pass = false;
    (t.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x), i = 0;
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<cellXfs':
            case '<cellXfs>':
            case '<cellXfs/>':
            case '</cellXfs>':
                break;
            /* 18.8.45 xf CT_Xf */ case '<xf':
            case '<xf/>':
            case '<xf>':
                xf = y;
                delete xf[0];
                for(i = 0; i < $a1a91b25d7598376$var$cellXF_uint.length; ++i)if (xf[$a1a91b25d7598376$var$cellXF_uint[i]]) xf[$a1a91b25d7598376$var$cellXF_uint[i]] = parseInt(xf[$a1a91b25d7598376$var$cellXF_uint[i]], 10);
                for(i = 0; i < $a1a91b25d7598376$var$cellXF_bool.length; ++i)if (xf[$a1a91b25d7598376$var$cellXF_bool[i]]) xf[$a1a91b25d7598376$var$cellXF_bool[i]] = $a1a91b25d7598376$var$parsexmlbool(xf[$a1a91b25d7598376$var$cellXF_bool[i]]);
                if (styles.NumberFmt && xf.numFmtId > 0x188) {
                    for(i = 0x188; i > 0x3c; --i)if (styles.NumberFmt[xf.numFmtId] == styles.NumberFmt[i]) {
                        xf.numFmtId = i;
                        break;
                    }
                }
                styles.CellXf.push(xf);
                break;
            case '</xf>':
                break;
            /* 18.8.1 alignment CT_CellAlignment */ case '<alignment':
            case '<alignment/>':
            case '<alignment>':
                var alignment = {};
                if (y.vertical) alignment.vertical = y.vertical;
                if (y.horizontal) alignment.horizontal = y.horizontal;
                if (y.textRotation != null) alignment.textRotation = y.textRotation;
                if (y.indent) alignment.indent = y.indent;
                if (y.wrapText) alignment.wrapText = $a1a91b25d7598376$var$parsexmlbool(y.wrapText);
                xf.alignment = alignment;
                break;
            case '</alignment>':
                break;
            /* 18.8.33 protection CT_CellProtection */ case '<protection':
            case '<protection>':
                break;
            case '</protection>':
            case '<protection/>':
                break;
            /* note: sometimes mc:AlternateContent appears bare */ case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
                break;
            case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (opts && opts.WTF) {
                    if (!pass) throw new Error('unrecognized ' + y[0] + ' in cellXfs');
                }
        }
    });
}
function $a1a91b25d7598376$var$write_cellXfs(cellXfs) /*:string*/ {
    var o /*:Array<string>*/  = [];
    o[o.length] = $a1a91b25d7598376$var$writextag('cellXfs', null);
    cellXfs.forEach(function(c) {
        o[o.length] = $a1a91b25d7598376$var$writextag('xf', null, c);
    });
    o[o.length] = "</cellXfs>";
    if (o.length === 2) return "";
    o[0] = $a1a91b25d7598376$var$writextag('cellXfs', null, {
        count: o.length - 2
    }).replace("/>", ">");
    return o.join("");
}
/* 18.8 Styles CT_Stylesheet*/ var $a1a91b25d7598376$var$parse_sty_xml = /*#__PURE__*/ function make_pstyx() {
    return function parse_sty_xml(data, themes, opts) {
        var styles = {};
        if (!data) return styles;
        data = $a1a91b25d7598376$var$remove_doctype($a1a91b25d7598376$var$str_remove_ng(data, "<!--", "-->"));
        /* 18.8.39 styleSheet CT_Stylesheet */ var t;
        /* 18.8.31 numFmts CT_NumFmts ? */ if (t = $a1a91b25d7598376$var$str_match_xml_ns(data, "numFmts")) $a1a91b25d7598376$var$parse_numFmts(t[0], styles, opts);
        /* 18.8.23 fonts CT_Fonts ? */ if (t = $a1a91b25d7598376$var$str_match_xml_ns(data, "fonts")) $a1a91b25d7598376$var$parse_fonts(t[0], styles, themes, opts);
        /* 18.8.21 fills CT_Fills ? */ if (t = $a1a91b25d7598376$var$str_match_xml_ns(data, "fills")) $a1a91b25d7598376$var$parse_fills(t[0], styles, themes, opts);
        /* 18.8.5  borders CT_Borders ? */ if (t = $a1a91b25d7598376$var$str_match_xml_ns(data, "borders")) $a1a91b25d7598376$var$parse_borders(t[0], styles, themes, opts);
        /* 18.8.9  cellStyleXfs CT_CellStyleXfs ? */ /* 18.8.8  cellStyles CT_CellStyles ? */ /* 18.8.10 cellXfs CT_CellXfs ? */ if (t = $a1a91b25d7598376$var$str_match_xml_ns(data, "cellXfs")) $a1a91b25d7598376$var$parse_cellXfs(t[0], styles, opts);
        /* 18.8.15 dxfs CT_Dxfs ? */ /* 18.8.42 tableStyles CT_TableStyles ? */ /* 18.8.11 colors CT_Colors ? */ /* 18.2.10 extLst CT_ExtensionList ? */ return styles;
    };
}();
function $a1a91b25d7598376$var$write_sty_xml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('styleSheet', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS_main[0],
            'xmlns:vt': $a1a91b25d7598376$var$XMLNS.vt
        })
    ], w;
    if (wb.SSF && (w = $a1a91b25d7598376$var$write_numFmts(wb.SSF)) != null) o[o.length] = w;
    o[o.length] = '<fonts count="1"><font><sz val="12"/><color theme="1"/><name val="Calibri"/><family val="2"/><scheme val="minor"/></font></fonts>';
    o[o.length] = '<fills count="2"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill></fills>';
    o[o.length] = '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>';
    o[o.length] = '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>';
    if (w = $a1a91b25d7598376$var$write_cellXfs(opts.cellXfs)) o[o.length] = w;
    o[o.length] = '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>';
    o[o.length] = '<dxfs count="0"/>';
    o[o.length] = '<tableStyles count="0" defaultTableStyle="TableStyleMedium9" defaultPivotStyle="PivotStyleMedium4"/>';
    if (o.length > 2) {
        o[o.length] = '</styleSheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.657 BrtFmt */ function $a1a91b25d7598376$var$parse_BrtFmt(data, length /*:number*/ ) {
    var numFmtId = data.read_shift(2);
    var stFmtCode = $a1a91b25d7598376$var$parse_XLWideString(data, length - 2);
    return [
        numFmtId,
        stFmtCode
    ];
}
function $a1a91b25d7598376$var$write_BrtFmt(i /*:number*/ , f /*:string*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(6 + 4 * f.length);
    o.write_shift(2, i);
    $a1a91b25d7598376$var$write_XLWideString(f, o);
    var out = o.length > o.l ? o.slice(0, o.l) : o;
    if (o.l == null) o.l = o.length;
    return out;
}
/* [MS-XLSB] 2.4.659 BrtFont TODO */ function $a1a91b25d7598376$var$parse_BrtFont(data, length /*:number*/ , opts) {
    var out = {} /*:any*/ ;
    out.sz = data.read_shift(2) / 20;
    var grbit = $a1a91b25d7598376$var$parse_FontFlags(data, 2, opts);
    if (grbit.fItalic) out.italic = 1;
    if (grbit.fCondense) out.condense = 1;
    if (grbit.fExtend) out.extend = 1;
    if (grbit.fShadow) out.shadow = 1;
    if (grbit.fOutline) out.outline = 1;
    if (grbit.fStrikeout) out.strike = 1;
    var bls = data.read_shift(2);
    if (bls === 0x02BC) out.bold = 1;
    switch(data.read_shift(2)){
        /* case 0: out.vertAlign = "baseline"; break; */ case 1:
            out.vertAlign = "superscript";
            break;
        case 2:
            out.vertAlign = "subscript";
            break;
    }
    var underline = data.read_shift(1);
    if (underline != 0) out.underline = underline;
    var family = data.read_shift(1);
    if (family > 0) out.family = family;
    var bCharSet = data.read_shift(1);
    if (bCharSet > 0) out.charset = bCharSet;
    data.l++;
    out.color = $a1a91b25d7598376$var$parse_BrtColor(data, 8);
    switch(data.read_shift(1)){
        /* case 0: out.scheme = "none": break; */ case 1:
            out.scheme = "major";
            break;
        case 2:
            out.scheme = "minor";
            break;
    }
    out.name = $a1a91b25d7598376$var$parse_XLWideString(data, length - 21);
    return out;
}
function $a1a91b25d7598376$var$write_BrtFont(font /*:any*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(153);
    o.write_shift(2, font.sz * 20);
    $a1a91b25d7598376$var$write_FontFlags(font, o);
    o.write_shift(2, font.bold ? 0x02BC : 0x0190);
    var sss = 0;
    if (font.vertAlign == "superscript") sss = 1;
    else if (font.vertAlign == "subscript") sss = 2;
    o.write_shift(2, sss);
    o.write_shift(1, font.underline || 0);
    o.write_shift(1, font.family || 0);
    o.write_shift(1, font.charset || 0);
    o.write_shift(1, 0);
    $a1a91b25d7598376$var$write_BrtColor(font.color, o);
    var scheme = 0;
    if (font.scheme == "major") scheme = 1;
    if (font.scheme == "minor") scheme = 2;
    o.write_shift(1, scheme);
    $a1a91b25d7598376$var$write_XLWideString(font.name, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.650 BrtFill */ var $a1a91b25d7598376$var$XLSBFillPTNames = [
    "none",
    "solid",
    "mediumGray",
    "darkGray",
    "lightGray",
    "darkHorizontal",
    "darkVertical",
    "darkDown",
    "darkUp",
    "darkGrid",
    "darkTrellis",
    "lightHorizontal",
    "lightVertical",
    "lightDown",
    "lightUp",
    "lightGrid",
    "lightTrellis",
    "gray125",
    "gray0625"
];
var $a1a91b25d7598376$var$rev_XLSBFillPTNames /*:EvertNumType*/ ;
/* TODO: gradient fill representation */ var $a1a91b25d7598376$var$parse_BrtFill = $a1a91b25d7598376$var$parsenoop;
function $a1a91b25d7598376$var$write_BrtFill(fill, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(84);
    if (!$a1a91b25d7598376$var$rev_XLSBFillPTNames) $a1a91b25d7598376$var$rev_XLSBFillPTNames = $a1a91b25d7598376$var$evert($a1a91b25d7598376$var$XLSBFillPTNames);
    var fls /*:number*/  = $a1a91b25d7598376$var$rev_XLSBFillPTNames[fill.patternType];
    if (fls == null) fls = 0x28;
    o.write_shift(4, fls);
    var j = 0;
    if (fls != 0x28) {
        /* TODO: custom FG Color */ $a1a91b25d7598376$var$write_BrtColor({
            auto: 1
        }, o);
        /* TODO: custom BG Color */ $a1a91b25d7598376$var$write_BrtColor({
            auto: 1
        }, o);
        for(; j < 12; ++j)o.write_shift(4, 0);
    } else {
        for(; j < 4; ++j)o.write_shift(4, 0);
        for(; j < 12; ++j)o.write_shift(4, 0); /* TODO */ 
    /* iGradientType */ /* xnumDegree */ /* xnumFillToLeft */ /* xnumFillToRight */ /* xnumFillToTop */ /* xnumFillToBottom */ /* cNumStop */ /* xfillGradientStop */ }
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.824 BrtXF */ function $a1a91b25d7598376$var$parse_BrtXF(data, length /*:number*/ ) {
    var tgt = data.l + length;
    var ixfeParent = data.read_shift(2);
    var ifmt = data.read_shift(2);
    data.l = tgt;
    return {
        ixfe: ixfeParent,
        numFmtId: ifmt
    };
}
function $a1a91b25d7598376$var$write_BrtXF(data, ixfeP, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(16);
    o.write_shift(2, ixfeP || 0);
    o.write_shift(2, data.numFmtId || 0);
    o.write_shift(2, 0); /* iFont */ 
    o.write_shift(2, 0); /* iFill */ 
    o.write_shift(2, 0); /* ixBorder */ 
    o.write_shift(1, 0); /* trot */ 
    o.write_shift(1, 0); /* indent */ 
    var flow = 0;
    o.write_shift(1, flow); /* flags */ 
    o.write_shift(1, 0); /* flags */ 
    o.write_shift(1, 0); /* xfGrbitAtr */ 
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.5.4 Blxf TODO */ function $a1a91b25d7598376$var$write_Blxf(data, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(10);
    o.write_shift(1, 0); /* dg */ 
    o.write_shift(1, 0);
    o.write_shift(4, 0); /* color */ 
    o.write_shift(4, 0); /* color */ 
    return o;
}
/* [MS-XLSB] 2.4.302 BrtBorder TODO */ var $a1a91b25d7598376$var$parse_BrtBorder = $a1a91b25d7598376$var$parsenoop;
function $a1a91b25d7598376$var$write_BrtBorder(border, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(51);
    o.write_shift(1, 0); /* diagonal */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* top */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* bottom */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* left */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* right */ 
    $a1a91b25d7598376$var$write_Blxf(null, o); /* diag */ 
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.763 BrtStyle TODO */ function $a1a91b25d7598376$var$write_BrtStyle(style, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(52);
    o.write_shift(4, style.xfId);
    o.write_shift(2, 1);
    o.write_shift(1, +style.builtinId);
    o.write_shift(1, 0); /* iLevel */ 
    $a1a91b25d7598376$var$write_XLNullableWideString(style.name || "", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.272 BrtBeginTableStyles */ function $a1a91b25d7598376$var$write_BrtBeginTableStyles(cnt, defTableStyle, defPivotStyle) {
    var o = $a1a91b25d7598376$var$new_buf(2052);
    o.write_shift(4, cnt);
    $a1a91b25d7598376$var$write_XLNullableWideString(defTableStyle, o);
    $a1a91b25d7598376$var$write_XLNullableWideString(defPivotStyle, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.1.7.50 Styles */ function $a1a91b25d7598376$var$parse_sty_bin(data, themes, opts) {
    var styles = {};
    styles.NumberFmt = [];
    for(var y in $a1a91b25d7598376$var$table_fmt)styles.NumberFmt[y] = $a1a91b25d7598376$var$table_fmt[y];
    styles.CellXf = [];
    styles.Fonts = [];
    var state /*:Array<string>*/  = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_sty(val1, R, RT) {
        switch(RT){
            case 0x002C:
                /* BrtFmt */ styles.NumberFmt[val1[0]] = val1[1];
                $a1a91b25d7598376$var$SSF__load(val1[1], val1[0]);
                break;
            case 0x002B:
                /* BrtFont */ styles.Fonts.push(val1);
                if (val1.color.theme != null && themes && themes.themeElements && themes.themeElements.clrScheme) val1.color.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[val1.color.theme].rgb, val1.color.tint || 0);
                break;
            case 0x0401:
                break;
            case 0x002D:
                break;
            case 0x002E:
                break;
            case 0x002F:
                /* BrtXF */ if (state[state.length - 1] == 0x0269 /* BrtBeginCellXFs */ ) styles.CellXf.push(val1);
                break;
            case 0x0030:
            /* BrtStyle */ case 0x01FB:
            /* BrtDXF */ case 0x023C:
            /* BrtMRUColor */ case 0x01DB:
                break;
            case 0x0493:
            /* BrtDXF14 */ case 0x0836:
            /* BrtDXF15 */ case 0x046A:
            /* BrtSlicerStyleElement */ case 0x0200:
            /* BrtTableStyleElement */ case 0x082F:
            /* BrtTimelineStyleElement */ case 0x0C00:
                break;
            case 0x0023:
                /* BrtFRTBegin */ pass = true;
                break;
            case 0x0024:
                /* BrtFRTEnd */ pass = false;
                break;
            case 0x0025:
                /* BrtACBegin */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* BrtACEnd */ state.pop();
                pass = false;
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return styles;
}
function $a1a91b25d7598376$var$write_FMTS_bin(ba, NF /*:?SSFTable*/ ) {
    if (!NF) return;
    var cnt = 0;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) ++cnt;
    });
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0267 /* BrtBeginFmts */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $a1a91b25d7598376$var$write_record(ba, 0x002C /* BrtFmt */ , $a1a91b25d7598376$var$write_BrtFmt(i, NF[i]));
    });
    $a1a91b25d7598376$var$write_record(ba, 0x0268 /* BrtEndFmts */ );
}
function $a1a91b25d7598376$var$write_FONTS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0263 /* BrtBeginFonts */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002B /* BrtFont */ , $a1a91b25d7598376$var$write_BrtFont({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Calibri",
        family: 2,
        scheme: "minor"
    }));
    /* 1*65491BrtFont [ACFONTS] */ $a1a91b25d7598376$var$write_record(ba, 0x0264 /* BrtEndFonts */ );
}
function $a1a91b25d7598376$var$write_FILLS_bin(ba /*::, data*/ ) {
    var cnt = 2;
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x025B /* BrtBeginFills */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002D /* BrtFill */ , $a1a91b25d7598376$var$write_BrtFill({
        patternType: "none"
    }));
    $a1a91b25d7598376$var$write_record(ba, 0x002D /* BrtFill */ , $a1a91b25d7598376$var$write_BrtFill({
        patternType: "gray125"
    }));
    /* 1*65431BrtFill */ $a1a91b25d7598376$var$write_record(ba, 0x025C /* BrtEndFills */ );
}
function $a1a91b25d7598376$var$write_BORDERS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    if (cnt == 0) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0265 /* BrtBeginBorders */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002E /* BrtBorder */ , $a1a91b25d7598376$var$write_BrtBorder({}));
    /* 1*65430BrtBorder */ $a1a91b25d7598376$var$write_record(ba, 0x0266 /* BrtEndBorders */ );
}
function $a1a91b25d7598376$var$write_CELLSTYLEXFS_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $a1a91b25d7598376$var$write_record(ba, 0x0272 /* BrtBeginCellStyleXFs */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x002F /* BrtXF */ , $a1a91b25d7598376$var$write_BrtXF({
        numFmtId: 0,
        fontId: 0,
        fillId: 0,
        borderId: 0
    }, 0xFFFF));
    /* 1*65430(BrtXF *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x0273 /* BrtEndCellStyleXFs */ );
}
function $a1a91b25d7598376$var$write_CELLXFS_bin(ba, data) {
    $a1a91b25d7598376$var$write_record(ba, 0x0269 /* BrtBeginCellXFs */ , $a1a91b25d7598376$var$write_UInt32LE(data.length));
    data.forEach(function(c) {
        $a1a91b25d7598376$var$write_record(ba, 0x002F /* BrtXF */ , $a1a91b25d7598376$var$write_BrtXF(c, 0));
    });
    /* 1*65430(BrtXF *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x026A /* BrtEndCellXFs */ );
}
function $a1a91b25d7598376$var$write_STYLES_bin(ba /*::, data*/ ) {
    var cnt = 1;
    $a1a91b25d7598376$var$write_record(ba, 0x026B /* BrtBeginStyles */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    $a1a91b25d7598376$var$write_record(ba, 0x0030 /* BrtStyle */ , $a1a91b25d7598376$var$write_BrtStyle({
        xfId: 0,
        builtinId: 0,
        name: "Normal"
    }));
    /* 1*65430(BrtStyle *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x026C /* BrtEndStyles */ );
}
function $a1a91b25d7598376$var$write_DXFS_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $a1a91b25d7598376$var$write_record(ba, 0x01F9 /* BrtBeginDXFs */ , $a1a91b25d7598376$var$write_UInt32LE(cnt));
    /* *2147483647(BrtDXF *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x01FA /* BrtEndDXFs */ );
}
function $a1a91b25d7598376$var$write_TABLESTYLES_bin(ba /*::, data*/ ) {
    var cnt = 0;
    $a1a91b25d7598376$var$write_record(ba, 0x01FC /* BrtBeginTableStyles */ , $a1a91b25d7598376$var$write_BrtBeginTableStyles(cnt, "TableStyleMedium9", "PivotStyleMedium4"));
    /* *TABLESTYLE */ $a1a91b25d7598376$var$write_record(ba, 0x01FD /* BrtEndTableStyles */ );
}
function $a1a91b25d7598376$var$write_COLORPALETTE_bin() {
    return;
/* BrtBeginColorPalette [INDEXEDCOLORS] [MRUCOLORS] BrtEndColorPalette */ }
/* [MS-XLSB] 2.1.7.50 Styles */ function $a1a91b25d7598376$var$write_sty_bin(wb, opts) {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 0x0116 /* BrtBeginStyleSheet */ );
    $a1a91b25d7598376$var$write_FMTS_bin(ba, wb.SSF);
    $a1a91b25d7598376$var$write_FONTS_bin(ba, wb);
    $a1a91b25d7598376$var$write_FILLS_bin(ba, wb);
    $a1a91b25d7598376$var$write_BORDERS_bin(ba, wb);
    $a1a91b25d7598376$var$write_CELLSTYLEXFS_bin(ba, wb);
    $a1a91b25d7598376$var$write_CELLXFS_bin(ba, opts.cellXfs);
    $a1a91b25d7598376$var$write_STYLES_bin(ba, wb);
    $a1a91b25d7598376$var$write_DXFS_bin(ba, wb);
    $a1a91b25d7598376$var$write_TABLESTYLES_bin(ba, wb);
    $a1a91b25d7598376$var$write_COLORPALETTE_bin(ba, wb);
    /* FRTSTYLESHEET*/ $a1a91b25d7598376$var$write_record(ba, 0x0117 /* BrtEndStyleSheet */ );
    return ba.end();
}
/* Even though theme layout is dk1 lt1 dk2 lt2, true order is lt1 dk1 lt2 dk2 */ var $a1a91b25d7598376$var$XLSXThemeClrScheme = [
    '</a:lt1>',
    '</a:dk1>',
    '</a:lt2>',
    '</a:dk2>',
    '</a:accent1>',
    '</a:accent2>',
    '</a:accent3>',
    '</a:accent4>',
    '</a:accent5>',
    '</a:accent6>',
    '</a:hlink>',
    '</a:folHlink>'
];
/* 20.1.6.2 clrScheme CT_ColorScheme */ function $a1a91b25d7598376$var$parse_clrScheme(t, themes, opts) {
    themes.themeElements.clrScheme = [];
    var color = {};
    (t[0].match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch(y[0]){
            /* 20.1.6.2 clrScheme (Color Scheme) CT_ColorScheme */ case '<a:clrScheme':
            case '</a:clrScheme>':
                break;
            /* 20.1.2.3.32 srgbClr CT_SRgbColor */ case '<a:srgbClr':
                color.rgb = y.val;
                break;
            case '</a:srgbClr>':
                break;
            /* 20.1.2.3.33 sysClr CT_SystemColor */ case '<a:sysClr':
                color.rgb = y.lastClr;
                break;
            case '</a:sysClr>':
                break;
            /* 20.1.4.1.1 accent1 (Accent 1) */ /* 20.1.4.1.2 accent2 (Accent 2) */ /* 20.1.4.1.3 accent3 (Accent 3) */ /* 20.1.4.1.4 accent4 (Accent 4) */ /* 20.1.4.1.5 accent5 (Accent 5) */ /* 20.1.4.1.6 accent6 (Accent 6) */ /* 20.1.4.1.9 dk1 (Dark 1) */ /* 20.1.4.1.10 dk2 (Dark 2) */ /* 20.1.4.1.15 folHlink (Followed Hyperlink) */ /* 20.1.4.1.19 hlink (Hyperlink) */ /* 20.1.4.1.22 lt1 (Light 1) */ /* 20.1.4.1.23 lt2 (Light 2) */ case '</a:dk1>':
            case '</a:lt1>':
            case '<a:dk1>':
            case '<a:lt1>':
            case '<a:dk2>':
            case '</a:dk2>':
            case '<a:lt2>':
            case '</a:lt2>':
            case '<a:accent1>':
            case '</a:accent1>':
            case '<a:accent2>':
            case '</a:accent2>':
            case '<a:accent3>':
            case '</a:accent3>':
            case '<a:accent4>':
            case '</a:accent4>':
            case '<a:accent5>':
            case '</a:accent5>':
            case '<a:accent6>':
            case '</a:accent6>':
            case '<a:hlink>':
            case '</a:hlink>':
            case '<a:folHlink>':
            case '</a:folHlink>':
                if (y[0].charAt(1) === '/') {
                    themes.themeElements.clrScheme[$a1a91b25d7598376$var$XLSXThemeClrScheme.indexOf(y[0])] = color;
                    color = {};
                } else color.name = y[0].slice(3, y[0].length - 1);
                break;
            default:
                if (opts && opts.WTF) throw new Error('Unrecognized ' + y[0] + ' in clrScheme');
        }
    });
}
/* 20.1.4.1.18 fontScheme CT_FontScheme */ function $a1a91b25d7598376$var$parse_fontScheme() {}
/* 20.1.4.1.15 fmtScheme CT_StyleMatrix */ function $a1a91b25d7598376$var$parse_fmtScheme() {}
/* 20.1.6.10 themeElements CT_BaseStyles */ function $a1a91b25d7598376$var$parse_themeElements(data, themes, opts) {
    themes.themeElements = {};
    var t;
    /* clrScheme CT_ColorScheme */ if (!(t = $a1a91b25d7598376$var$str_match_xml(data, "a:clrScheme"))) throw new Error('clrScheme not found in themeElements');
    $a1a91b25d7598376$var$parse_clrScheme(t, themes, opts);
    /* fontScheme CT_FontScheme */ if (!(t = $a1a91b25d7598376$var$str_match_xml(data, "a:fontScheme"))) throw new Error('fontScheme not found in themeElements');
    $a1a91b25d7598376$var$parse_fontScheme(t, themes, opts);
    /* fmtScheme CT_StyleMatrix */ if (!(t = $a1a91b25d7598376$var$str_match_xml(data, "a:fmtScheme"))) throw new Error('fmtScheme not found in themeElements');
    $a1a91b25d7598376$var$parse_fmtScheme(t, themes, opts);
}
/* 14.2.7 Theme Part */ function $a1a91b25d7598376$var$parse_theme_xml(data /*:string*/ , opts) {
    /* 20.1.6.9 theme CT_OfficeStyleSheet */ if (!data || data.length === 0) data = $a1a91b25d7598376$var$write_theme();
    var t;
    var themes = {};
    /* themeElements CT_BaseStyles */ if (!(t = $a1a91b25d7598376$var$str_match_xml(data, "a:themeElements"))) throw new Error('themeElements not found in theme');
    $a1a91b25d7598376$var$parse_themeElements(t[0], themes, opts);
    themes.raw = data;
    return themes;
}
function $a1a91b25d7598376$var$write_theme(Themes, opts) /*:string*/ {
    if (opts && opts.themeXLSX) return opts.themeXLSX;
    if (Themes && typeof Themes.raw == "string") return Themes.raw;
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o[o.length] = '<a:theme xmlns:a="http://schemas.openxmlformats.org/drawingml/2006/main" name="Office Theme">';
    o[o.length] = '<a:themeElements>';
    o[o.length] = '<a:clrScheme name="Office">';
    o[o.length] = '<a:dk1><a:sysClr val="windowText" lastClr="000000"/></a:dk1>';
    o[o.length] = '<a:lt1><a:sysClr val="window" lastClr="FFFFFF"/></a:lt1>';
    o[o.length] = '<a:dk2><a:srgbClr val="1F497D"/></a:dk2>';
    o[o.length] = '<a:lt2><a:srgbClr val="EEECE1"/></a:lt2>';
    o[o.length] = '<a:accent1><a:srgbClr val="4F81BD"/></a:accent1>';
    o[o.length] = '<a:accent2><a:srgbClr val="C0504D"/></a:accent2>';
    o[o.length] = '<a:accent3><a:srgbClr val="9BBB59"/></a:accent3>';
    o[o.length] = '<a:accent4><a:srgbClr val="8064A2"/></a:accent4>';
    o[o.length] = '<a:accent5><a:srgbClr val="4BACC6"/></a:accent5>';
    o[o.length] = '<a:accent6><a:srgbClr val="F79646"/></a:accent6>';
    o[o.length] = '<a:hlink><a:srgbClr val="0000FF"/></a:hlink>';
    o[o.length] = '<a:folHlink><a:srgbClr val="800080"/></a:folHlink>';
    o[o.length] = '</a:clrScheme>';
    o[o.length] = '<a:fontScheme name="Office">';
    o[o.length] = '<a:majorFont>';
    o[o.length] = '<a:latin typeface="Cambria"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="MoolBoran"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Times New Roman"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:majorFont>';
    o[o.length] = '<a:minorFont>';
    o[o.length] = '<a:latin typeface="Calibri"/>';
    o[o.length] = '<a:ea typeface=""/>';
    o[o.length] = '<a:cs typeface=""/>';
    o[o.length] = '<a:font script="Jpan" typeface="\uFF2D\uFF33 \uFF30\u30B4\u30B7\u30C3\u30AF"/>';
    o[o.length] = '<a:font script="Hang" typeface="\uB9D1\uC740 \uACE0\uB515"/>';
    o[o.length] = '<a:font script="Hans" typeface="\u5B8B\u4F53"/>';
    o[o.length] = '<a:font script="Hant" typeface="\u65B0\u7D30\u660E\u9AD4"/>';
    o[o.length] = '<a:font script="Arab" typeface="Arial"/>';
    o[o.length] = '<a:font script="Hebr" typeface="Arial"/>';
    o[o.length] = '<a:font script="Thai" typeface="Tahoma"/>';
    o[o.length] = '<a:font script="Ethi" typeface="Nyala"/>';
    o[o.length] = '<a:font script="Beng" typeface="Vrinda"/>';
    o[o.length] = '<a:font script="Gujr" typeface="Shruti"/>';
    o[o.length] = '<a:font script="Khmr" typeface="DaunPenh"/>';
    o[o.length] = '<a:font script="Knda" typeface="Tunga"/>';
    o[o.length] = '<a:font script="Guru" typeface="Raavi"/>';
    o[o.length] = '<a:font script="Cans" typeface="Euphemia"/>';
    o[o.length] = '<a:font script="Cher" typeface="Plantagenet Cherokee"/>';
    o[o.length] = '<a:font script="Yiii" typeface="Microsoft Yi Baiti"/>';
    o[o.length] = '<a:font script="Tibt" typeface="Microsoft Himalaya"/>';
    o[o.length] = '<a:font script="Thaa" typeface="MV Boli"/>';
    o[o.length] = '<a:font script="Deva" typeface="Mangal"/>';
    o[o.length] = '<a:font script="Telu" typeface="Gautami"/>';
    o[o.length] = '<a:font script="Taml" typeface="Latha"/>';
    o[o.length] = '<a:font script="Syrc" typeface="Estrangelo Edessa"/>';
    o[o.length] = '<a:font script="Orya" typeface="Kalinga"/>';
    o[o.length] = '<a:font script="Mlym" typeface="Kartika"/>';
    o[o.length] = '<a:font script="Laoo" typeface="DokChampa"/>';
    o[o.length] = '<a:font script="Sinh" typeface="Iskoola Pota"/>';
    o[o.length] = '<a:font script="Mong" typeface="Mongolian Baiti"/>';
    o[o.length] = '<a:font script="Viet" typeface="Arial"/>';
    o[o.length] = '<a:font script="Uigh" typeface="Microsoft Uighur"/>';
    o[o.length] = '<a:font script="Geor" typeface="Sylfaen"/>';
    o[o.length] = '</a:minorFont>';
    o[o.length] = '</a:fontScheme>';
    o[o.length] = '<a:fmtScheme name="Office">';
    o[o.length] = '<a:fillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="50000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="35000"><a:schemeClr val="phClr"><a:tint val="37000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="15000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="1"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="100000"/><a:shade val="100000"/><a:satMod val="130000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:tint val="50000"/><a:shade val="100000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:lin ang="16200000" scaled="0"/>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:fillStyleLst>';
    o[o.length] = '<a:lnStyleLst>';
    o[o.length] = '<a:ln w="9525" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"><a:shade val="95000"/><a:satMod val="105000"/></a:schemeClr></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="25400" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '<a:ln w="38100" cap="flat" cmpd="sng" algn="ctr"><a:solidFill><a:schemeClr val="phClr"/></a:solidFill><a:prstDash val="solid"/></a:ln>';
    o[o.length] = '</a:lnStyleLst>';
    o[o.length] = '<a:effectStyleLst>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="20000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="38000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '<a:effectStyle>';
    o[o.length] = '<a:effectLst>';
    o[o.length] = '<a:outerShdw blurRad="40000" dist="23000" dir="5400000" rotWithShape="0"><a:srgbClr val="000000"><a:alpha val="35000"/></a:srgbClr></a:outerShdw>';
    o[o.length] = '</a:effectLst>';
    o[o.length] = '<a:scene3d><a:camera prst="orthographicFront"><a:rot lat="0" lon="0" rev="0"/></a:camera><a:lightRig rig="threePt" dir="t"><a:rot lat="0" lon="0" rev="1200000"/></a:lightRig></a:scene3d>';
    o[o.length] = '<a:sp3d><a:bevelT w="63500" h="25400"/></a:sp3d>';
    o[o.length] = '</a:effectStyle>';
    o[o.length] = '</a:effectStyleLst>';
    o[o.length] = '<a:bgFillStyleLst>';
    o[o.length] = '<a:solidFill><a:schemeClr val="phClr"/></a:solidFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="40000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="40000"><a:schemeClr val="phClr"><a:tint val="45000"/><a:shade val="99000"/><a:satMod val="350000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="20000"/><a:satMod val="255000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="-80000" r="50000" b="180000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '<a:gradFill rotWithShape="1">';
    o[o.length] = '<a:gsLst>';
    o[o.length] = '<a:gs pos="0"><a:schemeClr val="phClr"><a:tint val="80000"/><a:satMod val="300000"/></a:schemeClr></a:gs>';
    o[o.length] = '<a:gs pos="100000"><a:schemeClr val="phClr"><a:shade val="30000"/><a:satMod val="200000"/></a:schemeClr></a:gs>';
    o[o.length] = '</a:gsLst>';
    o[o.length] = '<a:path path="circle"><a:fillToRect l="50000" t="50000" r="50000" b="50000"/></a:path>';
    o[o.length] = '</a:gradFill>';
    o[o.length] = '</a:bgFillStyleLst>';
    o[o.length] = '</a:fmtScheme>';
    o[o.length] = '</a:themeElements>';
    o[o.length] = '<a:objectDefaults>';
    o[o.length] = '<a:spDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="1"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="3"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="2"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="lt1"/></a:fontRef></a:style>';
    o[o.length] = '</a:spDef>';
    o[o.length] = '<a:lnDef>';
    o[o.length] = '<a:spPr/><a:bodyPr/><a:lstStyle/><a:style><a:lnRef idx="2"><a:schemeClr val="accent1"/></a:lnRef><a:fillRef idx="0"><a:schemeClr val="accent1"/></a:fillRef><a:effectRef idx="1"><a:schemeClr val="accent1"/></a:effectRef><a:fontRef idx="minor"><a:schemeClr val="tx1"/></a:fontRef></a:style>';
    o[o.length] = '</a:lnDef>';
    o[o.length] = '</a:objectDefaults>';
    o[o.length] = '<a:extraClrSchemeLst/>';
    o[o.length] = '</a:theme>';
    return o.join("");
}
/* [MS-XLS] 2.4.326 TODO: payload is a zip file */ function $a1a91b25d7598376$var$parse_Theme(blob, length, opts) {
    var end = blob.l + length;
    var dwThemeVersion = blob.read_shift(4);
    if (dwThemeVersion === 124226) return;
    if (!opts.cellStyles) {
        blob.l = end;
        return;
    }
    var data = blob.slice(blob.l);
    blob.l = end;
    var zip;
    try {
        zip = $a1a91b25d7598376$var$zip_read(data, {
            type: "array"
        });
    } catch (e) {
        return;
    }
    var themeXML = $a1a91b25d7598376$var$getzipstr(zip, "theme/theme/theme1.xml", true);
    if (!themeXML) return;
    return $a1a91b25d7598376$var$parse_theme_xml(themeXML, opts);
}
/* 2.5.49 */ function $a1a91b25d7598376$var$parse_ColorTheme(blob /*::, length*/ ) {
    return blob.read_shift(4);
}
/* 2.5.155 */ function $a1a91b25d7598376$var$parse_FullColorExt(blob /*::, length*/ ) {
    var o = {};
    o.xclrType = blob.read_shift(2);
    o.nTintShade = blob.read_shift(2);
    switch(o.xclrType){
        case 0:
            blob.l += 4;
            break;
        case 1:
            o.xclrValue = $a1a91b25d7598376$var$parse_IcvXF(blob, 4);
            break;
        case 2:
            o.xclrValue = $a1a91b25d7598376$var$parse_LongRGBA(blob, 4);
            break;
        case 3:
            o.xclrValue = $a1a91b25d7598376$var$parse_ColorTheme(blob, 4);
            break;
        case 4:
            blob.l += 4;
            break;
    }
    blob.l += 8;
    return o;
}
/* 2.5.164 TODO: read 7 bits*/ function $a1a91b25d7598376$var$parse_IcvXF(blob, length) {
    return $a1a91b25d7598376$var$parsenoop(blob, length);
}
/* 2.5.280 */ function $a1a91b25d7598376$var$parse_XFExtGradient(blob, length) {
    return $a1a91b25d7598376$var$parsenoop(blob, length);
}
/* [MS-XLS] 2.5.108 */ function $a1a91b25d7598376$var$parse_ExtProp(blob /*::, length*/ ) /*:Array<any>*/ {
    var extType = blob.read_shift(2);
    var cb = blob.read_shift(2) - 4;
    var o = [
        extType
    ];
    switch(extType){
        case 0x04:
        case 0x05:
        case 0x07:
        case 0x08:
        case 0x09:
        case 0x0A:
        case 0x0B:
        case 0x0D:
            o[1] = $a1a91b25d7598376$var$parse_FullColorExt(blob, cb);
            break;
        case 0x06:
            o[1] = $a1a91b25d7598376$var$parse_XFExtGradient(blob, cb);
            break;
        case 0x0E:
        case 0x0F:
            o[1] = blob.read_shift(cb === 1 ? 1 : 2);
            break;
        default:
            throw new Error("Unrecognized ExtProp type: " + extType + " " + cb);
    }
    return o;
}
/* 2.4.355 */ function $a1a91b25d7598376$var$parse_XFExt(blob, length) {
    var end = blob.l + length;
    blob.l += 2;
    var ixfe = blob.read_shift(2);
    blob.l += 2;
    var cexts = blob.read_shift(2);
    var ext /*:AOA*/  = [];
    while(cexts-- > 0)ext.push($a1a91b25d7598376$var$parse_ExtProp(blob, end - blob.l));
    return {
        ixfe: ixfe,
        ext: ext
    };
}
/* xf is an XF, see parse_XFExt for xfext */ function $a1a91b25d7598376$var$update_xfext(xf, xfext) {
    xfext.forEach(function(xfe) {
        xfe[0];
    });
}
function $a1a91b25d7598376$var$parse_BrtMdtinfo(data, length) {
    return {
        flags: data.read_shift(4),
        version: data.read_shift(4),
        name: $a1a91b25d7598376$var$parse_XLWideString(data, length - 8)
    };
}
function $a1a91b25d7598376$var$write_BrtMdtinfo(data) {
    var o = $a1a91b25d7598376$var$new_buf(12 + 2 * data.name.length);
    o.write_shift(4, data.flags);
    o.write_shift(4, data.version);
    $a1a91b25d7598376$var$write_XLWideString(data.name, o);
    return o.slice(0, o.l);
}
function $a1a91b25d7598376$var$parse_BrtMdb(data) {
    var out = [];
    var cnt = data.read_shift(4);
    while(cnt-- > 0)out.push([
        data.read_shift(4),
        data.read_shift(4)
    ]);
    return out;
}
function $a1a91b25d7598376$var$write_BrtMdb(mdb) {
    var o = $a1a91b25d7598376$var$new_buf(4 + 8 * mdb.length);
    o.write_shift(4, mdb.length);
    for(var i = 0; i < mdb.length; ++i){
        o.write_shift(4, mdb[i][0]);
        o.write_shift(4, mdb[i][1]);
    }
    return o;
}
function $a1a91b25d7598376$var$write_BrtBeginEsfmd(cnt, name) {
    var o = $a1a91b25d7598376$var$new_buf(8 + 2 * name.length);
    o.write_shift(4, cnt);
    $a1a91b25d7598376$var$write_XLWideString(name, o);
    return o.slice(0, o.l);
}
function $a1a91b25d7598376$var$parse_BrtBeginEsmdb(data) {
    data.l += 4;
    return data.read_shift(4) != 0;
}
function $a1a91b25d7598376$var$write_BrtBeginEsmdb(cnt, cm) {
    var o = $a1a91b25d7598376$var$new_buf(8);
    o.write_shift(4, cnt);
    o.write_shift(4, cm ? 1 : 0);
    return o;
}
function $a1a91b25d7598376$var$parse_xlmeta_bin(data, name, _opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    var opts = _opts || {};
    var state = [];
    var pass = false;
    var metatype = 2;
    $a1a91b25d7598376$var$recordhopper(data, function(val1, R, RT) {
        switch(RT){
            case 335:
                out.Types.push({
                    name: val1.name
                });
                break;
            case 51:
                val1.forEach(function(r) {
                    if (metatype == 1) out.Cell.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                    else if (metatype == 0) out.Value.push({
                        type: out.Types[r[0] - 1].name,
                        index: r[1]
                    });
                });
                break;
            case 337:
                metatype = val1 ? 1 : 0;
                break;
            case 338:
                metatype = 2;
                break;
            case 35:
                state.push(RT);
                pass = true;
                break;
            case 36:
                state.pop();
                pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 35) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $a1a91b25d7598376$var$write_xlmeta_bin() {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 332);
    $a1a91b25d7598376$var$write_record(ba, 334, $a1a91b25d7598376$var$write_UInt32LE(1));
    $a1a91b25d7598376$var$write_record(ba, 335, $a1a91b25d7598376$var$write_BrtMdtinfo({
        name: "XLDAPR",
        version: 12e4,
        flags: 3496657072
    }));
    $a1a91b25d7598376$var$write_record(ba, 336);
    $a1a91b25d7598376$var$write_record(ba, 339, $a1a91b25d7598376$var$write_BrtBeginEsfmd(1, "XLDAPR"));
    $a1a91b25d7598376$var$write_record(ba, 52);
    $a1a91b25d7598376$var$write_record(ba, 35, $a1a91b25d7598376$var$write_UInt32LE(514));
    $a1a91b25d7598376$var$write_record(ba, 4096, $a1a91b25d7598376$var$write_UInt32LE(0));
    $a1a91b25d7598376$var$write_record(ba, 4097, $a1a91b25d7598376$var$writeuint16(1));
    $a1a91b25d7598376$var$write_record(ba, 36);
    $a1a91b25d7598376$var$write_record(ba, 53);
    $a1a91b25d7598376$var$write_record(ba, 340);
    $a1a91b25d7598376$var$write_record(ba, 337, $a1a91b25d7598376$var$write_BrtBeginEsmdb(1, true));
    $a1a91b25d7598376$var$write_record(ba, 51, $a1a91b25d7598376$var$write_BrtMdb([
        [
            1,
            0
        ]
    ]));
    $a1a91b25d7598376$var$write_record(ba, 338);
    $a1a91b25d7598376$var$write_record(ba, 333);
    return ba.end();
}
function $a1a91b25d7598376$var$parse_xlmeta_xml(data, name, opts) {
    var out = {
        Types: [],
        Cell: [],
        Value: []
    };
    if (!data) return out;
    var pass = false;
    var metatype = 2;
    var lastmeta;
    data.replace($a1a91b25d7598376$var$tagregex, function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case "<?xml":
                break;
            case "<metadata":
            case "</metadata>":
                break;
            case "<metadataTypes":
            case "</metadataTypes>":
                break;
            case "<metadataType":
                out.Types.push({
                    name: y.name
                });
                break;
            case "</metadataType>":
                break;
            case "<futureMetadata":
                for(var j = 0; j < out.Types.length; ++j)if (out.Types[j].name == y.name) lastmeta = out.Types[j];
                break;
            case "</futureMetadata>":
                break;
            case "<bk>":
                break;
            case "</bk>":
                break;
            case "<rc":
                if (metatype == 1) out.Cell.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                else if (metatype == 0) out.Value.push({
                    type: out.Types[y.t - 1].name,
                    index: +y.v
                });
                break;
            case "</rc>":
                break;
            case "<cellMetadata":
                metatype = 1;
                break;
            case "</cellMetadata>":
                metatype = 2;
                break;
            case "<valueMetadata":
                metatype = 0;
                break;
            case "</valueMetadata>":
                metatype = 2;
                break;
            case "<extLst":
            case "<extLst>":
            case "</extLst>":
            case "<extLst/>":
                break;
            case "<ext":
                pass = true;
                break;
            case "</ext>":
                pass = false;
                break;
            case "<rvb":
                if (!lastmeta) break;
                if (!lastmeta.offsets) lastmeta.offsets = [];
                lastmeta.offsets.push(+y.i);
                break;
            default:
                if (!pass && (opts == null ? void 0 : opts.WTF)) throw new Error("unrecognized " + y[0] + " in metadata");
        }
        return x;
    });
    return out;
}
function $a1a91b25d7598376$var$write_xlmeta_xml() {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o.push('<metadata xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:xlrd="http://schemas.microsoft.com/office/spreadsheetml/2017/richdata" xmlns:xda="http://schemas.microsoft.com/office/spreadsheetml/2017/dynamicarray">\n  <metadataTypes count="1">\n    <metadataType name="XLDAPR" minSupportedVersion="120000" copy="1" pasteAll="1" pasteValues="1" merge="1" splitFirst="1" rowColShift="1" clearFormats="1" clearComments="1" assign="1" coerce="1" cellMeta="1"/>\n  </metadataTypes>\n  <futureMetadata name="XLDAPR" count="1">\n    <bk>\n      <extLst>\n        <ext uri="{bdbb8cdc-fa1e-496e-a857-3c3f30c029c3}">\n          <xda:dynamicArrayProperties fDynamic="1" fCollapsed="0"/>\n        </ext>\n      </extLst>\n    </bk>\n  </futureMetadata>\n  <cellMetadata count="1">\n    <bk>\n      <rc t="1" v="0"/>\n    </bk>\n  </cellMetadata>\n</metadata>');
    return o.join("");
}
/* 18.6 Calculation Chain */ function $a1a91b25d7598376$var$parse_cc_xml(data /*::, name, opts*/ ) /*:Array<any>*/ {
    var d = [];
    if (!data) return d;
    var i = 1;
    (data.match($a1a91b25d7598376$var$tagregex) || []).forEach(function(x) {
        var y = $a1a91b25d7598376$var$parsexmltag(x);
        switch(y[0]){
            case '<?xml':
                break;
            /* 18.6.2  calcChain CT_CalcChain 1 */ case '<calcChain':
            case '<calcChain>':
            case '</calcChain>':
                break;
            /* 18.6.1  c CT_CalcCell 1 */ case '<c':
                delete y[0];
                if (y.i) i = y.i;
                else y.i = i;
                d.push(y);
                break;
        }
    });
    return d;
}
//function write_cc_xml(data, opts) { }
/* [MS-XLSB] 2.6.4.1 */ function $a1a91b25d7598376$var$parse_BrtCalcChainItem$(data) {
    var out = {};
    out.i = data.read_shift(4);
    var cell = {};
    cell.r = data.read_shift(4);
    cell.c = data.read_shift(4);
    out.r = $a1a91b25d7598376$var$encode_cell(cell);
    var flags = data.read_shift(1);
    if (flags & 0x2) out.l = '1';
    if (flags & 0x8) out.a = '1';
    return out;
}
/* 18.6 Calculation Chain */ function $a1a91b25d7598376$var$parse_cc_bin(data, name, opts) {
    var out = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_cc(val1, R, RT) {
        switch(RT){
            case 0x003F:
                /* 'BrtCalcChainItem$' */ out.push(val1);
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
//function write_cc_bin(data, opts) { }
/* 18.14 Supplementary Workbook Data */ function $a1a91b25d7598376$var$parse_xlink_xml() {
//var opts = _opts || {};
//if(opts.WTF) throw "XLSX External Link";
}
/* [MS-XLSB] 2.1.7.25 External Link */ function $a1a91b25d7598376$var$parse_xlink_bin(data, rel, name /*:string*/ , _opts) {
    if (!data) return data;
    var opts = _opts || {};
    var pass = false, end = false;
    $a1a91b25d7598376$var$recordhopper(data, function xlink_parse(val1, R, RT) {
        if (end) return;
        switch(RT){
            case 0x0167:
            /* 'BrtSupTabs' */ case 0x016B:
            /* 'BrtExternTableStart' */ case 0x016C:
            /* 'BrtExternTableEnd' */ case 0x016E:
            /* 'BrtExternRowHdr' */ case 0x016F:
            /* 'BrtExternCellBlank' */ case 0x0170:
            /* 'BrtExternCellReal' */ case 0x0171:
            /* 'BrtExternCellBool' */ case 0x0172:
            /* 'BrtExternCellError' */ case 0x0173:
            /* 'BrtExternCellString' */ case 0x01D8:
            /* 'BrtExternValueMeta' */ case 0x0241:
            /* 'BrtSupNameStart' */ case 0x0242:
            /* 'BrtSupNameValueStart' */ case 0x0243:
            /* 'BrtSupNameValueEnd' */ case 0x0244:
            /* 'BrtSupNameNum' */ case 0x0245:
            /* 'BrtSupNameErr' */ case 0x0246:
            /* 'BrtSupNameSt' */ case 0x0247:
            /* 'BrtSupNameNil' */ case 0x0248:
            /* 'BrtSupNameBool' */ case 0x0249:
            /* 'BrtSupNameFmla' */ case 0x024A:
            /* 'BrtSupNameBits' */ case 0x024B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
}
/* 20.5 DrawingML - SpreadsheetML Drawing */ /* 20.5.2.35 wsDr CT_Drawing */ function $a1a91b25d7598376$var$parse_drawing(data, rels /*:any*/ ) {
    if (!data) return "??";
    /*
	  Chartsheet Drawing:
	   - 20.5.2.35 wsDr CT_Drawing
	    - 20.5.2.1  absoluteAnchor CT_AbsoluteAnchor
	     - 20.5.2.16 graphicFrame CT_GraphicalObjectFrame
	      - 20.1.2.2.16 graphic CT_GraphicalObject
	       - 20.1.2.2.17 graphicData CT_GraphicalObjectData
          - chart reference
	   the actual type is based on the URI of the graphicData
		TODO: handle embedded charts and other types of graphics
	*/ var id = (data.match(/<c:chart [^<>]*r:id="([^<>"]*)"/) || [
        "",
        ""
    ])[1];
    return rels['!id'][id].Target;
}
/* L.5.5.2 SpreadsheetML Comments + VML Schema */ function $a1a91b25d7598376$var$parse_vml(data /*:string*/ , sheet, comments) {
    var cidx = 0;
    ($a1a91b25d7598376$var$str_match_xml_ns_g(data, "shape") || []).forEach(function(m) {
        var type = "";
        var hidden = true;
        var aidx = -1;
        var R = -1, C = -1;
        m.replace($a1a91b25d7598376$var$tagregex, function(x /*:string*/ , idx /*:number*/ ) {
            var y = $a1a91b25d7598376$var$parsexmltag(x);
            switch($a1a91b25d7598376$var$strip_ns(y[0])){
                case '<ClientData':
                    if (y.ObjectType) type = y.ObjectType;
                    break;
                case '<Visible':
                case '<Visible/>':
                    hidden = false;
                    break;
                case '<Row':
                case '<Row>':
                    aidx = idx + x.length;
                    break;
                case '</Row>':
                    R = +m.slice(aidx, idx).trim();
                    break;
                case '<Column':
                case '<Column>':
                    aidx = idx + x.length;
                    break;
                case '</Column>':
                    C = +m.slice(aidx, idx).trim();
                    break;
            }
            return "";
        });
        switch(type){
            case 'Note':
                var cell = $a1a91b25d7598376$var$ws_get_cell_stub(sheet, R >= 0 && C >= 0 ? $a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                }) : comments[cidx].ref);
                if (cell.c) cell.c.hidden = hidden;
                ++cidx;
                break;
        }
    });
}
/* comment boxes */ function $a1a91b25d7598376$var$write_vml(rId /*:number*/ , comments, ws) {
    var csize = [
        21600,
        21600
    ];
    /* L.5.2.1.2 Path Attribute */ var bbox = [
        "m0,0l0",
        csize[1],
        csize[0],
        csize[1],
        csize[0],
        "0xe"
    ].join(",");
    var o = [
        $a1a91b25d7598376$var$writextag("xml", null, {
            'xmlns:v': $a1a91b25d7598376$var$XLMLNS.v,
            'xmlns:o': $a1a91b25d7598376$var$XLMLNS.o,
            'xmlns:x': $a1a91b25d7598376$var$XLMLNS.x,
            'xmlns:mv': $a1a91b25d7598376$var$XLMLNS.mv
        }).replace(/\/>/, ">"),
        $a1a91b25d7598376$var$writextag("o:shapelayout", $a1a91b25d7598376$var$writextag("o:idmap", null, {
            'v:ext': "edit",
            'data': rId
        }), {
            'v:ext': "edit"
        })
    ];
    var _shapeid = 65536 * rId;
    var _comments = comments || [];
    if (_comments.length > 0) o.push($a1a91b25d7598376$var$writextag("v:shapetype", [
        $a1a91b25d7598376$var$writextag("v:stroke", null, {
            joinstyle: "miter"
        }),
        $a1a91b25d7598376$var$writextag("v:path", null, {
            gradientshapeok: "t",
            'o:connecttype': "rect"
        })
    ].join(""), {
        id: "_x0000_t202",
        coordsize: csize.join(","),
        'o:spt': 202,
        path: bbox
    }));
    _comments.forEach(function(x) {
        ++_shapeid;
        o.push($a1a91b25d7598376$var$write_vml_comment(x, _shapeid));
    });
    o.push('</xml>');
    return o.join("");
}
function $a1a91b25d7598376$var$write_vml_comment(x, _shapeid, ws) /*:string*/ {
    var c = $a1a91b25d7598376$var$decode_cell(x[0]);
    var fillopts = /*::(*/ {
        'color2': "#BEFF82",
        'type': "gradient"
    } /*:: :any)*/ ;
    if (fillopts.type == "gradient") fillopts.angle = "-180";
    var fillparm = fillopts.type == "gradient" ? $a1a91b25d7598376$var$writextag("o:fill", null, {
        type: "gradientUnscaled",
        'v:ext': "view"
    }) : null;
    var fillxml = $a1a91b25d7598376$var$writextag('v:fill', fillparm, fillopts);
    var shadata = {
        on: "t",
        'obscured': "t"
    } /*:any*/ ;
    return [
        '<v:shape' + $a1a91b25d7598376$var$wxt_helper({
            id: '_x0000_s' + _shapeid,
            type: "#_x0000_t202",
            style: "position:absolute; margin-left:80pt;margin-top:5pt;width:104pt;height:64pt;z-index:10" + (x[1].hidden ? ";visibility:hidden" : ""),
            fillcolor: "#ECFAD4",
            strokecolor: "#edeaa1"
        }) + '>',
        fillxml,
        $a1a91b25d7598376$var$writextag("v:shadow", null, shadata),
        $a1a91b25d7598376$var$writextag("v:path", null, {
            'o:connecttype': "none"
        }),
        '<v:textbox><div style="text-align:left"></div></v:textbox>',
        '<x:ClientData ObjectType="Note">',
        '<x:MoveWithCells/>',
        '<x:SizeWithCells/>',
        /* Part 4 19.4.2.3 Anchor (Anchor) */ $a1a91b25d7598376$var$writetag('x:Anchor', [
            c.c + 1,
            0,
            c.r + 1,
            0,
            c.c + 3,
            20,
            c.r + 5,
            20
        ].join(",")),
        $a1a91b25d7598376$var$writetag('x:AutoFill', "False"),
        $a1a91b25d7598376$var$writetag('x:Row', String(c.r)),
        $a1a91b25d7598376$var$writetag('x:Column', String(c.c)),
        x[1].hidden ? '' : '<x:Visible/>',
        '</x:ClientData>',
        '</v:shape>'
    ].join("");
}
function $a1a91b25d7598376$var$sheet_insert_comments(sheet /*:WorkSheet*/ , comments /*:Array<RawComment>*/ , threaded /*:boolean*/ , people /*:?Array<any>*/ ) {
    var dense = sheet["!data"] != null;
    var cell /*:Cell*/ ;
    comments.forEach(function(comment) {
        var r = $a1a91b25d7598376$var$decode_cell(comment.ref);
        if (r.r < 0 || r.c < 0) return;
        if (dense) {
            if (!sheet["!data"][r.r]) sheet["!data"][r.r] = [];
            cell = sheet["!data"][r.r][r.c];
        } else cell = sheet[comment.ref];
        if (!cell) {
            cell = {
                t: "z"
            } /*:any*/ ;
            if (dense) sheet["!data"][r.r][r.c] = cell;
            else sheet[comment.ref] = cell;
            var range = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"] || "BDWGO1000001:A1");
            if (range.s.r > r.r) range.s.r = r.r;
            if (range.e.r < r.r) range.e.r = r.r;
            if (range.s.c > r.c) range.s.c = r.c;
            if (range.e.c < r.c) range.e.c = r.c;
            var encoded = $a1a91b25d7598376$var$encode_range(range);
            sheet["!ref"] = encoded;
        }
        if (!cell.c) cell.c = [];
        var o /*:Comment*/  = {
            a: comment.author,
            t: comment.t,
            r: comment.r,
            T: threaded
        };
        if (comment.h) o.h = comment.h;
        /* threaded comments always override */ for(var i = cell.c.length - 1; i >= 0; --i){
            if (!threaded && cell.c[i].T) return;
            if (threaded && !cell.c[i].T) cell.c.splice(i, 1);
        }
        if (threaded && people) {
            for(i = 0; i < people.length; ++i)if (o.a == people[i].id) {
                o.a = people[i].name || o.a;
                break;
            }
        }
        cell.c.push(o);
    });
}
/* 18.7 Comments */ function $a1a91b25d7598376$var$parse_comments_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    /* 18.7.6 CT_Comments */ if (data.match(/<(?:\w+:)?comments *\/>/)) return [];
    var authors /*:Array<string>*/  = [];
    var commentList /*:Array<RawComment>*/  = [];
    var authtag = $a1a91b25d7598376$var$str_match_xml_ns(data, "authors");
    if (authtag && authtag[1]) authtag[1].split(/<\/\w*:?author>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var a = x.match(/<(?:\w+:)?author[^<>]*>(.*)/);
        if (a) authors.push(a[1]);
    });
    var cmnttag = $a1a91b25d7598376$var$str_match_xml_ns(data, "commentList");
    if (cmnttag && cmnttag[1]) cmnttag[1].split(/<\/\w*:?comment>/).forEach(function(x) {
        if (x === "" || x.trim() === "") return;
        var cm = x.match(/<(?:\w+:)?comment[^<>]*>/);
        if (!cm) return;
        var y = $a1a91b25d7598376$var$parsexmltag(cm[0]);
        var comment /*:RawComment*/  = {
            author: y.authorId && authors[y.authorId] || "sheetjsghost",
            ref: y.ref,
            guid: y.guid
        } /*:any*/ ;
        var cell = $a1a91b25d7598376$var$decode_cell(y.ref);
        if (opts.sheetRows && opts.sheetRows <= cell.r) return;
        var textMatch = $a1a91b25d7598376$var$str_match_xml_ns(x, "text");
        var rt = !!textMatch && !!textMatch[1] && $a1a91b25d7598376$var$parse_si(textMatch[1]) || {
            r: "",
            t: "",
            h: ""
        };
        comment.r = rt.r;
        if (rt.r == "<t></t>") rt.t = rt.h = "";
        comment.t = (rt.t || "").replace(/\r\n/g, "\n").replace(/\r/g, "\n");
        if (opts.cellHTML) comment.h = rt.h;
        commentList.push(comment);
    });
    return commentList;
}
function $a1a91b25d7598376$var$write_comments_xml(data /*::, opts*/ ) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('comments', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS_main[0]
        })
    ];
    var iauthor /*:Array<string>*/  = [];
    o.push("<authors>");
    data.forEach(function(x) {
        x[1].forEach(function(w) {
            var a = $a1a91b25d7598376$var$escapexml(w.a);
            if (iauthor.indexOf(a) == -1) {
                iauthor.push(a);
                o.push("<author>" + a + "</author>");
            }
            if (w.T && w.ID && iauthor.indexOf("tc=" + w.ID) == -1) {
                iauthor.push("tc=" + w.ID);
                o.push("<author>tc=" + w.ID + "</author>");
            }
        });
    });
    if (iauthor.length == 0) {
        iauthor.push("SheetJ5");
        o.push("<author>SheetJ5</author>");
    }
    o.push("</authors>");
    o.push("<commentList>");
    data.forEach(function(d) {
        /* 18.7.3 CT_Comment */ var lastauthor = 0, ts = [], tcnt = 0;
        if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
        d[1].forEach(function(c) {
            if (c.a) lastauthor = iauthor.indexOf($a1a91b25d7598376$var$escapexml(c.a));
            if (c.T) ++tcnt;
            ts.push(c.t == null ? "" : $a1a91b25d7598376$var$escapexml(c.t));
        });
        if (tcnt === 0) d[1].forEach(function(c) {
            o.push('<comment ref="' + d[0] + '" authorId="' + iauthor.indexOf($a1a91b25d7598376$var$escapexml(c.a)) + '"><text>');
            o.push($a1a91b25d7598376$var$writetag("t", c.t == null ? "" : $a1a91b25d7598376$var$escapexml(c.t)));
            o.push('</text></comment>');
        });
        else {
            if (d[1][0] && d[1][0].T && d[1][0].ID) lastauthor = iauthor.indexOf("tc=" + d[1][0].ID);
            /* based on Threaded Comments -> Comments projection */ o.push('<comment ref="' + d[0] + '" authorId="' + lastauthor + '"><text>');
            var t = "Comment:\n    " + ts[0] + "\n";
            for(var i = 1; i < ts.length; ++i)t += "Reply:\n    " + ts[i] + "\n";
            o.push($a1a91b25d7598376$var$writetag("t", $a1a91b25d7598376$var$escapexml(t)));
            o.push('</text></comment>');
        }
    });
    o.push("</commentList>");
    if (o.length > 2) {
        o[o.length] = '</comments>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSX] 2.1.17 */ function $a1a91b25d7598376$var$parse_tcmnt_xml(data /*:string*/ , opts) /*:Array<RawComment>*/ {
    var out = [];
    var pass = false, comment = {}, tidx = 0;
    data.replace($a1a91b25d7598376$var$tagregex, function xml_tcmnt(x, idx) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.6.207 ThreadedComments CT_ThreadedComments */ case '<ThreadedComments':
                break;
            case '</ThreadedComments>':
                break;
            /* 2.6.205 threadedComment CT_ThreadedComment */ case '<threadedComment':
                comment = {
                    author: y.personId,
                    guid: y.id,
                    ref: y.ref,
                    T: 1
                };
                break;
            case '</threadedComment>':
                if (comment.t != null) out.push(comment);
                break;
            case '<text>':
            case '<text':
                tidx = idx + x.length;
                break;
            case '</text>':
                comment.t = data.slice(tidx, idx).replace(/\r\n/g, "\n").replace(/\r/g, "\n");
                break;
            /* 2.6.206 mentions CT_ThreadedCommentMentions TODO */ case '<mentions':
            case '<mentions>':
                pass = true;
                break;
            case '</mentions>':
                pass = false;
                break;
            /* 2.6.202 mention CT_Mention TODO */ /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $a1a91b25d7598376$var$write_tcmnt_xml(comments, people, opts) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('ThreadedComments', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS.TCMNT
        }).replace(/[\/]>/, ">")
    ];
    comments.forEach(function(carr) {
        var rootid = "";
        (carr[1] || []).forEach(function(c, idx) {
            if (!c.T) {
                delete c.ID;
                return;
            }
            if (c.a && people.indexOf(c.a) == -1) people.push(c.a);
            var tcopts = {
                ref: carr[0],
                id: "{54EE7951-7262-4200-6969-" + ("000000000000" + opts.tcid++).slice(-12) + "}"
            };
            if (idx == 0) rootid = tcopts.id;
            else tcopts.parentId = rootid;
            c.ID = tcopts.id;
            if (c.a) tcopts.personId = "{54EE7950-7262-4200-6969-" + ("000000000000" + people.indexOf(c.a)).slice(-12) + "}";
            o.push($a1a91b25d7598376$var$writextag('threadedComment', $a1a91b25d7598376$var$writetag('text', c.t || ""), tcopts));
        });
    });
    o.push('</ThreadedComments>');
    return o.join("");
}
/* [MS-XLSX] 2.1.18 */ function $a1a91b25d7598376$var$parse_people_xml(data /*:string*/ , opts) {
    var out = [];
    var pass = false;
    data.replace($a1a91b25d7598376$var$tagregex, function xml_tcmnt(x) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 2.4.85 personList CT_PersonList */ case '<personList':
                break;
            case '</personList>':
                break;
            /* 2.6.203 person CT_Person TODO: providers */ case '<person':
                out.push({
                    name: y.displayname,
                    id: y.id
                });
                break;
            case '</person>':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break;
            case '</ext>':
                pass = false;
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in threaded comments');
        }
        return x;
    });
    return out;
}
function $a1a91b25d7598376$var$write_people_xml(people /*, opts*/ ) {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('personList', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS.TCMNT,
            'xmlns:x': $a1a91b25d7598376$var$XMLNS_main[0]
        }).replace(/[\/]>/, ">")
    ];
    people.forEach(function(person, idx) {
        o.push($a1a91b25d7598376$var$writextag('person', null, {
            displayName: person,
            id: "{54EE7950-7262-4200-6969-" + ("000000000000" + idx).slice(-12) + "}",
            userId: person,
            providerId: "None"
        }));
    });
    o.push("</personList>");
    return o.join("");
}
/* [MS-XLSB] 2.4.28 BrtBeginComment */ function $a1a91b25d7598376$var$parse_BrtBeginComment(data) {
    var out = {};
    out.iauthor = data.read_shift(4);
    var rfx = $a1a91b25d7598376$var$parse_UncheckedRfX(data, 16);
    out.rfx = rfx.s;
    out.ref = $a1a91b25d7598376$var$encode_cell(rfx.s);
    data.l += 16; /*var guid = parse_GUID(data); */ 
    return out;
}
function $a1a91b25d7598376$var$write_BrtBeginComment(data, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(36);
    o.write_shift(4, data[1].iauthor);
    $a1a91b25d7598376$var$write_UncheckedRfX(data[0], o);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    return o;
}
/* [MS-XLSB] 2.4.327 BrtCommentAuthor */ var $a1a91b25d7598376$var$parse_BrtCommentAuthor = $a1a91b25d7598376$var$parse_XLWideString;
function $a1a91b25d7598376$var$write_BrtCommentAuthor(data) {
    return $a1a91b25d7598376$var$write_XLWideString(data.slice(0, 54));
}
/* [MS-XLSB] 2.1.7.8 Comments */ function $a1a91b25d7598376$var$parse_comments_bin(data, opts) /*:Array<RawComment>*/ {
    var out /*:Array<RawComment>*/  = [];
    var authors /*:Array<string>*/  = [];
    var c = {};
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function hopper_cmnt(val1, R, RT) {
        switch(RT){
            case 0x0278:
                /* 'BrtCommentAuthor' */ authors.push(val1);
                break;
            case 0x027B:
                /* 'BrtBeginComment' */ c = val1;
                break;
            case 0x027D:
                /* 'BrtCommentText' */ c.t = val1.t;
                c.h = val1.h;
                c.r = val1.r;
                break;
            case 0x027C:
                /* 'BrtEndComment' */ c.author = authors[c.iauthor];
                delete c /*:any*/ .iauthor;
                if (opts.sheetRows && c.rfx && opts.sheetRows <= c.rfx.r) break;
                if (!c.t) c.t = "";
                delete c.rfx;
                out.push(c);
                break;
            case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                break;
            case 0x0026:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    });
    return out;
}
function $a1a91b25d7598376$var$write_comments_bin(data /*::, opts*/ ) {
    var ba = $a1a91b25d7598376$var$buf_array();
    var iauthor /*:Array<string>*/  = [];
    $a1a91b25d7598376$var$write_record(ba, 0x0274 /* BrtBeginComments */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0276 /* BrtBeginCommentAuthors */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            if (iauthor.indexOf(c.a) > -1) return;
            iauthor.push(c.a.slice(0, 54));
            $a1a91b25d7598376$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $a1a91b25d7598376$var$write_BrtCommentAuthor(c.a));
            if (c.T && c.ID && iauthor.indexOf("tc=" + c.ID) == -1) {
                iauthor.push("tc=" + c.ID);
                $a1a91b25d7598376$var$write_record(ba, 0x0278 /* BrtCommentAuthor */ , $a1a91b25d7598376$var$write_BrtCommentAuthor("tc=" + c.ID));
            }
        });
    });
    $a1a91b25d7598376$var$write_record(ba, 0x0277 /* BrtEndCommentAuthors */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0279 /* BrtBeginCommentList */ );
    data.forEach(function(comment) {
        comment[1].forEach(function(c) {
            var _ia = -1;
            if (c.ID) _ia = iauthor.indexOf("tc=" + c.ID);
            if (_ia == -1 && comment[1][0].T && comment[1][0].ID) _ia = iauthor.indexOf("tc=" + comment[1][0].ID);
            if (_ia == -1) _ia = iauthor.indexOf(c.a);
            c.iauthor = _ia;
            var range = {
                s: $a1a91b25d7598376$var$decode_cell(comment[0]),
                e: $a1a91b25d7598376$var$decode_cell(comment[0])
            };
            $a1a91b25d7598376$var$write_record(ba, 0x027B /* BrtBeginComment */ , $a1a91b25d7598376$var$write_BrtBeginComment([
                range,
                c
            ]));
            if (c.t && c.t.length > 0) $a1a91b25d7598376$var$write_record(ba, 0x027D /* BrtCommentText */ , $a1a91b25d7598376$var$write_BrtCommentText(c));
            $a1a91b25d7598376$var$write_record(ba, 0x027C /* BrtEndComment */ );
            delete c.iauthor;
        });
    });
    $a1a91b25d7598376$var$write_record(ba, 0x027A /* BrtEndCommentList */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0275 /* BrtEndComments */ );
    return ba.end();
}
var $a1a91b25d7598376$var$CT_VBA = "application/vnd.ms-office.vbaProject";
function $a1a91b25d7598376$var$make_vba_xls(cfb) {
    var newcfb = $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    cfb.FullPaths.forEach(function(p, i) {
        if (p.slice(-1) === "/" || !p.match(/_VBA_PROJECT_CUR/)) return;
        var newpath = p.replace(/^[^\/]*/, "R").replace(/\/_VBA_PROJECT_CUR\u0000*/, "");
        $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(newcfb, newpath, cfb.FileIndex[i].content);
    });
    return $a1a91b25d7598376$export$9f0e51cd97c572a.write(newcfb);
}
function $a1a91b25d7598376$var$fill_vba_xls(cfb, vba) {
    vba.FullPaths.forEach(function(p, i) {
        if (i == 0) return;
        var newpath = p.replace(/^[\/]*[^\/]*[\/]/, "/_VBA_PROJECT_CUR/");
        if (newpath.slice(-1) !== "/") $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, newpath, vba.FileIndex[i].content);
    });
}
var $a1a91b25d7598376$var$VBAFMTS = [
    "xlsb",
    "xlsm",
    "xlam",
    "biff8",
    "xla"
];
/* macro and dialog sheet stubs */ function $a1a91b25d7598376$var$parse_ds_bin() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $a1a91b25d7598376$var$parse_ds_xml() /*:Worksheet*/ {
    return {
        '!type': 'dialog'
    };
}
function $a1a91b25d7598376$var$parse_ms_bin() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
function $a1a91b25d7598376$var$parse_ms_xml() /*:Worksheet*/ {
    return {
        '!type': 'macro'
    };
}
/* TODO: it will be useful to parse the function str */ var $a1a91b25d7598376$var$rc_to_a1 = /*#__PURE__*/ function() {
    var rcregex = /(^|[^A-Za-z_])R(\[?-?\d+\]|[1-9]\d*|)C(\[?-?\d+\]|[1-9]\d*|)(?![A-Za-z0-9_])/g;
    var rcbase /*:Cell*/  = {
        r: 0,
        c: 0
    } /*:any*/ ;
    function rcfunc($$, $1, $2, $3) {
        var cRel = false, rRel = false;
        if ($2.length == 0) rRel = true;
        else if ($2.charAt(0) == "[") {
            rRel = true;
            $2 = $2.slice(1, -1);
        }
        if ($3.length == 0) cRel = true;
        else if ($3.charAt(0) == "[") {
            cRel = true;
            $3 = $3.slice(1, -1);
        }
        var R = $2.length > 0 ? parseInt($2, 10) | 0 : 0, C = $3.length > 0 ? parseInt($3, 10) | 0 : 0;
        if (cRel) C += rcbase.c;
        else --C;
        if (rRel) R += rcbase.r;
        else --R;
        return $1 + (cRel ? "" : "$") + $a1a91b25d7598376$var$encode_col(C) + (rRel ? "" : "$") + $a1a91b25d7598376$var$encode_row(R);
    }
    return function rc_to_a1(fstr /*:string*/ , base /*:Cell*/ ) /*:string*/ {
        rcbase = base;
        return fstr.replace(rcregex, rcfunc);
    };
}();
var $a1a91b25d7598376$var$crefregex = /(^|[^._A-Z0-9])(\$?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])(\$?)(\d{1,7})(?![_.\(A-Za-z0-9])/g;
try {
    $a1a91b25d7598376$var$crefregex = /(^|[^._A-Z0-9])([$]?)([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])([$]?)(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})(?![_.\(A-Za-z0-9])/g;
} catch (e) {}
var $a1a91b25d7598376$var$a1_to_rc = /*#__PURE__*/ function() {
    return function a1_to_rc(fstr /*:string*/ , base /*:CellAddress*/ ) {
        return fstr.replace($a1a91b25d7598376$var$crefregex, function($0, $1, $2, $3, $4, $5) {
            var c = $a1a91b25d7598376$var$decode_col($3) - ($2 ? 0 : base.c);
            var r = $a1a91b25d7598376$var$decode_row($5) - ($4 ? 0 : base.r);
            var R = $4 == "$" ? r + 1 : r == 0 ? "" : "[" + r + "]";
            var C = $2 == "$" ? c + 1 : c == 0 ? "" : "[" + c + "]";
            return $1 + "R" + R + "C" + C;
        });
    };
}();
/* no defined name can collide with a valid cell address A1:XFD1048576 ... except LOG10! */ function $a1a91b25d7598376$var$shift_formula_str(f /*:string*/ , delta /*:Cell*/ ) /*:string*/ {
    return f.replace($a1a91b25d7598376$var$crefregex, function($0, $1, $2, $3, $4, $5) {
        return $1 + ($2 == "$" ? $2 + $3 : $a1a91b25d7598376$var$encode_col($a1a91b25d7598376$var$decode_col($3) + delta.c)) + ($4 == "$" ? $4 + $5 : $a1a91b25d7598376$var$encode_row($a1a91b25d7598376$var$decode_row($5) + delta.r));
    });
}
function $a1a91b25d7598376$var$shift_formula_xlsx(f /*:string*/ , range /*:string*/ , cell /*:string*/ ) /*:string*/ {
    var r = $a1a91b25d7598376$var$decode_range(range), s = r.s, c = $a1a91b25d7598376$var$decode_cell(cell);
    var delta = {
        r: c.r - s.r,
        c: c.c - s.c
    };
    return $a1a91b25d7598376$var$shift_formula_str(f, delta);
}
/* TODO: parse formula */ function $a1a91b25d7598376$var$fuzzyfmla(f /*:string*/ ) /*:boolean*/ {
    if (f.length == 1) return false;
    return true;
}
function $a1a91b25d7598376$var$_xlfn(f /*:string*/ ) /*:string*/ {
    return f.replace(/_xlfn\./g, "");
}
function $a1a91b25d7598376$var$parseread1(blob) {
    blob.l += 1;
    return;
}
/* [MS-XLS] 2.5.51 */ function $a1a91b25d7598376$var$parse_ColRelU(blob, length) {
    var c = blob.read_shift(length == 1 ? 1 : 2);
    return [
        c & 0x3FFF,
        c >> 14 & 1,
        c >> 15 & 1
    ];
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.89 */ function $a1a91b25d7598376$var$parse_RgceArea(blob, length, opts) {
    var w = 2;
    if (opts) {
        if (opts.biff >= 2 && opts.biff <= 5) return $a1a91b25d7598376$var$parse_RgceArea_BIFF2(blob, length, opts);
        else if (opts.biff == 12) w = 4;
    }
    var r = blob.read_shift(w), R = blob.read_shift(w);
    var c = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var C = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* BIFF 2-5 encodes flags in the row field */ function $a1a91b25d7598376$var$parse_RgceArea_BIFF2(blob /*::, length, opts*/ ) {
    var r = $a1a91b25d7598376$var$parse_ColRelU(blob, 2), R = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    var C = blob.read_shift(1);
    return {
        s: {
            r: r[0],
            c: c,
            cRel: r[1],
            rRel: r[2]
        },
        e: {
            r: R[0],
            c: C,
            cRel: R[1],
            rRel: R[2]
        }
    };
}
/* [MS-XLS] 2.5.198.105 ; [MS-XLSB] 2.5.97.90 */ function $a1a91b25d7598376$var$parse_RgceAreaRel(blob, length, opts) {
    if (opts.biff < 8) return $a1a91b25d7598376$var$parse_RgceArea_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts.biff == 12 ? 4 : 2), R = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var c = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var C = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    return {
        s: {
            r: r,
            c: c[0],
            cRel: c[1],
            rRel: c[2]
        },
        e: {
            r: R,
            c: C[0],
            cRel: C[1],
            rRel: C[2]
        }
    };
}
/* [MS-XLS] 2.5.198.109 ; [MS-XLSB] 2.5.97.91 */ function $a1a91b25d7598376$var$parse_RgceLoc(blob, length, opts) {
    if (opts && opts.biff >= 2 && opts.biff <= 5) return $a1a91b25d7598376$var$parse_RgceLoc_BIFF2(blob, length, opts);
    var r = blob.read_shift(opts && opts.biff == 12 ? 4 : 2);
    var c = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    return {
        r: r,
        c: c[0],
        cRel: c[1],
        rRel: c[2]
    };
}
function $a1a91b25d7598376$var$parse_RgceLoc_BIFF2(blob /*::, length, opts*/ ) {
    var r = $a1a91b25d7598376$var$parse_ColRelU(blob, 2);
    var c = blob.read_shift(1);
    return {
        r: r[0],
        c: c,
        cRel: r[1],
        rRel: r[2]
    };
}
/* [MS-XLS] 2.5.198.107, 2.5.47 */ function $a1a91b25d7598376$var$parse_RgceElfLoc(blob /*::, length, opts*/ ) {
    var r = blob.read_shift(2);
    var c = blob.read_shift(2);
    return {
        r: r,
        c: c & 0xFF,
        fQuoted: !!(c & 0x4000),
        cRel: c >> 15,
        rRel: c >> 15
    };
}
/* [MS-XLS] 2.5.198.111 ; [MS-XLSB] 2.5.97.92 TODO */ function $a1a91b25d7598376$var$parse_RgceLocRel(blob, length, opts) {
    var biff = opts && opts.biff ? opts.biff : 8;
    if (biff >= 2 && biff <= 5) return $a1a91b25d7598376$var$parse_RgceLocRel_BIFF2(blob, length, opts);
    var r = blob.read_shift(biff >= 12 ? 4 : 2);
    var cl = blob.read_shift(2);
    var cRel = (cl & 0x4000) >> 14, rRel = (cl & 0x8000) >> 15;
    cl &= 0x3FFF;
    if (rRel == 1) while(r > 0x7FFFF)r -= 0x100000;
    if (cRel == 1) while(cl > 0x1FFF)cl = cl - 0x4000;
    return {
        r: r,
        c: cl,
        cRel: cRel,
        rRel: rRel
    };
}
function $a1a91b25d7598376$var$parse_RgceLocRel_BIFF2(blob /*::, length:number, opts*/ ) {
    var rl = blob.read_shift(2);
    var c = blob.read_shift(1);
    var rRel = (rl & 0x8000) >> 15, cRel = (rl & 0x4000) >> 14;
    rl &= 0x3FFF;
    if (rRel == 1 && rl >= 0x2000) rl = rl - 0x4000;
    if (cRel == 1 && c >= 0x80) c = c - 0x100;
    return {
        r: rl,
        c: c,
        cRel: cRel,
        rRel: rRel
    };
}
/* [MS-XLS] 2.5.198.27 ; [MS-XLSB] 2.5.97.18 */ function $a1a91b25d7598376$var$parse_PtgArea(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $a1a91b25d7598376$var$parse_RgceArea(blob, opts.biff >= 2 && opts.biff <= 5 ? 6 : 8, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.28 ; [MS-XLSB] 2.5.97.19 */ function $a1a91b25d7598376$var$parse_PtgArea3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2, 'i');
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    var area = $a1a91b25d7598376$var$parse_RgceArea(blob, w, opts);
    return [
        type,
        ixti,
        area
    ];
}
/* [MS-XLS] 2.5.198.29 ; [MS-XLSB] 2.5.97.20 */ function $a1a91b25d7598376$var$parse_PtgAreaErr(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts && opts.biff > 8 ? 12 : opts.biff < 8 ? 6 : 8;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.30 ; [MS-XLSB] 2.5.97.21 */ function $a1a91b25d7598376$var$parse_PtgAreaErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 8;
    if (opts) switch(opts.biff){
        case 5:
            blob.l += 12;
            w = 6;
            break;
        case 12:
            w = 12;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.31 ; [MS-XLSB] 2.5.97.22 */ function $a1a91b25d7598376$var$parse_PtgAreaN(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var area = $a1a91b25d7598376$var$parse_RgceAreaRel(blob, length - 1, opts);
    return [
        type,
        area
    ];
}
/* [MS-XLS] 2.5.198.32 ; [MS-XLSB] 2.5.97.23 */ function $a1a91b25d7598376$var$parse_PtgArray(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    blob.l += opts.biff == 2 ? 6 : opts.biff == 12 ? 14 : 7;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.33 ; [MS-XLSB] 2.5.97.24 */ function $a1a91b25d7598376$var$parse_PtgAttrBaxcel(blob) {
    var bitSemi = blob[blob.l + 1] & 0x01; /* 1 = volatile */ 
    var bitBaxcel = 1;
    blob.l += 4;
    return [
        bitSemi,
        bitBaxcel
    ];
}
/* [MS-XLS] 2.5.198.34 ; [MS-XLSB] 2.5.97.25 */ function $a1a91b25d7598376$var$parse_PtgAttrChoose(blob, length, opts) /*:Array<number>*/ {
    blob.l += 2;
    var offset = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    var o /*:Array<number>*/  = [];
    /* offset is 1 less than the number of elements */ for(var i = 0; i <= offset; ++i)o.push(blob.read_shift(opts && opts.biff == 2 ? 1 : 2));
    return o;
}
/* [MS-XLS] 2.5.198.35 ; [MS-XLSB] 2.5.97.26 */ function $a1a91b25d7598376$var$parse_PtgAttrGoto(blob, length, opts) {
    var bitGoto = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitGoto,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLS] 2.5.198.36 ; [MS-XLSB] 2.5.97.27 */ function $a1a91b25d7598376$var$parse_PtgAttrIf(blob, length, opts) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(opts && opts.biff == 2 ? 1 : 2)
    ];
}
/* [MS-XLSB] 2.5.97.28 */ function $a1a91b25d7598376$var$parse_PtgAttrIfError(blob) {
    var bitIf = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += 2;
    return [
        bitIf,
        blob.read_shift(2)
    ];
}
/* [MS-XLS] 2.5.198.37 ; [MS-XLSB] 2.5.97.29 */ function $a1a91b25d7598376$var$parse_PtgAttrSemi(blob, length, opts) {
    var bitSemi = blob[blob.l + 1] & 0xFF ? 1 : 0;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return [
        bitSemi
    ];
}
/* [MS-XLS] 2.5.198.40 ; [MS-XLSB] 2.5.97.32 */ function $a1a91b25d7598376$var$parse_PtgAttrSpaceType(blob /*::, length*/ ) {
    var type = blob.read_shift(1), cch = blob.read_shift(1);
    return [
        type,
        cch
    ];
}
/* [MS-XLS] 2.5.198.38 ; [MS-XLSB] 2.5.97.30 */ function $a1a91b25d7598376$var$parse_PtgAttrSpace(blob) {
    blob.read_shift(2);
    return $a1a91b25d7598376$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.39 ; [MS-XLSB] 2.5.97.31 */ function $a1a91b25d7598376$var$parse_PtgAttrSpaceSemi(blob) {
    blob.read_shift(2);
    return $a1a91b25d7598376$var$parse_PtgAttrSpaceType(blob, 2);
}
/* [MS-XLS] 2.5.198.84 ; [MS-XLSB] 2.5.97.68 TODO */ function $a1a91b25d7598376$var$parse_PtgRef(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $a1a91b25d7598376$var$parse_RgceLoc(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.88 ; [MS-XLSB] 2.5.97.72 TODO */ function $a1a91b25d7598376$var$parse_PtgRefN(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var loc = $a1a91b25d7598376$var$parse_RgceLocRel(blob, 0, opts);
    return [
        type,
        loc
    ];
}
/* [MS-XLS] 2.5.198.85 ; [MS-XLSB] 2.5.97.69 TODO */ function $a1a91b25d7598376$var$parse_PtgRef3d(blob, length, opts) {
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var ixti = blob.read_shift(2); // XtiIndex
    if (opts && opts.biff == 5) blob.l += 12;
    var loc = $a1a91b25d7598376$var$parse_RgceLoc(blob, 0, opts); // TODO: or RgceLocRel
    return [
        type,
        ixti,
        loc
    ];
}
/* [MS-XLS] 2.5.198.62 ; [MS-XLSB] 2.5.97.45 TODO */ function $a1a91b25d7598376$var$parse_PtgFunc(blob, length, opts) {
    //var ptg = blob[blob.l] & 0x1F;
    var type = (blob[blob.l] & 0x60) >> 5;
    blob.l += 1;
    var iftab = blob.read_shift(opts && opts.biff <= 3 ? 1 : 2);
    return [
        $a1a91b25d7598376$var$FtabArgc[iftab],
        $a1a91b25d7598376$var$Ftab[iftab],
        type
    ];
}
/* [MS-XLS] 2.5.198.63 ; [MS-XLSB] 2.5.97.46 TODO */ function $a1a91b25d7598376$var$parse_PtgFuncVar(blob, length, opts) {
    var type = blob[blob.l++];
    var cparams = blob.read_shift(1), tab = opts && opts.biff <= 3 ? [
        type == 0x58 ? -1 : 0,
        blob.read_shift(1)
    ] : $a1a91b25d7598376$var$parsetab(blob);
    return [
        cparams,
        (tab[0] === 0 ? $a1a91b25d7598376$var$Ftab : $a1a91b25d7598376$var$Cetab)[tab[1]]
    ];
}
function $a1a91b25d7598376$var$parsetab(blob) {
    return [
        blob[blob.l + 1] >> 7,
        blob.read_shift(2) & 0x7FFF
    ];
}
/* [MS-XLS] 2.5.198.41 ; [MS-XLSB] 2.5.97.33 */ function $a1a91b25d7598376$var$parse_PtgAttrSum(blob, length, opts) {
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    return;
}
/* [MS-XLS] 2.5.198.58 ; [MS-XLSB] 2.5.97.40 */ function $a1a91b25d7598376$var$parse_PtgExp(blob, length, opts) {
    blob.l++;
    if (opts && opts.biff == 12) return [
        blob.read_shift(4, 'i'),
        0
    ];
    var row = blob.read_shift(2);
    var col = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        row,
        col
    ];
}
/* [MS-XLS] 2.5.198.57 ; [MS-XLSB] 2.5.97.39 */ function $a1a91b25d7598376$var$parse_PtgErr(blob) {
    blob.l++;
    return $a1a91b25d7598376$var$BErr[blob.read_shift(1)];
}
/* [MS-XLS] 2.5.198.66 ; [MS-XLSB] 2.5.97.49 */ function $a1a91b25d7598376$var$parse_PtgInt(blob) {
    blob.l++;
    return blob.read_shift(2);
}
/* [MS-XLS] 2.5.198.42 ; [MS-XLSB] 2.5.97.34 */ function $a1a91b25d7598376$var$parse_PtgBool(blob) {
    blob.l++;
    return blob.read_shift(1) !== 0;
}
/* [MS-XLS] 2.5.198.79 ; [MS-XLSB] 2.5.97.63 */ function $a1a91b25d7598376$var$parse_PtgNum(blob) {
    blob.l++;
    return $a1a91b25d7598376$var$parse_Xnum(blob, 8);
}
/* [MS-XLS] 2.5.198.89 ; [MS-XLSB] 2.5.97.74 */ function $a1a91b25d7598376$var$parse_PtgStr(blob, length, opts) {
    blob.l++;
    return $a1a91b25d7598376$var$parse_ShortXLUnicodeString(blob, length - 1, opts);
}
/* [MS-XLS] 2.5.192.112 + 2.5.192.11{3,4,5,6,7} */ /* [MS-XLSB] 2.5.97.93 + 2.5.97.9{4,5,6,7} */ function $a1a91b25d7598376$var$parse_SerAr(blob, biff /*:number*/ ) {
    var val1 = [
        blob.read_shift(1)
    ];
    if (biff == 12) switch(val1[0]){
        case 0x02:
            val1[0] = 0x04;
            break; /* SerBool */ 
        case 0x04:
            val1[0] = 0x10;
            break; /* SerErr */ 
        case 0x00:
            val1[0] = 0x01;
            break; /* SerNum */ 
        case 0x01:
            val1[0] = 0x02;
            break; /* SerStr */ 
    }
    switch(val1[0]){
        case 0x04:
            /* SerBool -- boolean */ val1[1] = $a1a91b25d7598376$var$parsebool(blob, 1) ? 'TRUE' : 'FALSE';
            if (biff != 12) blob.l += 7;
            break;
        case 0x25:
        /* appears to be an alias */ case 0x10:
            /* SerErr -- error */ val1[1] = $a1a91b25d7598376$var$BErr[blob[blob.l]];
            blob.l += biff == 12 ? 4 : 8;
            break;
        case 0x00:
            /* SerNil -- honestly, I'm not sure how to reproduce this */ blob.l += 8;
            break;
        case 0x01:
            /* SerNum -- Xnum */ val1[1] = $a1a91b25d7598376$var$parse_Xnum(blob, 8);
            break;
        case 0x02:
            /* SerStr -- XLUnicodeString (<256 chars) */ val1[1] = $a1a91b25d7598376$var$parse_XLUnicodeString2(blob, 0, {
                biff: biff > 0 && biff < 8 ? 2 : biff
            });
            break;
        default:
            throw new Error("Bad SerAr: " + val1[0]); /* Unreachable */ 
    }
    return val1;
}
/* [MS-XLS] 2.5.198.61 ; [MS-XLSB] 2.5.97.44 */ function $a1a91b25d7598376$var$parse_PtgExtraMem(blob, cce, opts) {
    var count = blob.read_shift(opts.biff == 12 ? 4 : 2);
    var out /*:Array<Range>*/  = [];
    for(var i = 0; i != count; ++i)out.push((opts.biff == 12 ? $a1a91b25d7598376$var$parse_UncheckedRfX : $a1a91b25d7598376$var$parse_Ref8U)(blob, 8));
    return out;
}
/* [MS-XLS] 2.5.198.59 ; [MS-XLSB] 2.5.97.41 */ function $a1a91b25d7598376$var$parse_PtgExtraArray(blob, length, opts) {
    var rows = 0, cols = 0;
    if (opts.biff == 12) {
        rows = blob.read_shift(4); // DRw
        cols = blob.read_shift(4); // DCol
    } else {
        cols = 1 + blob.read_shift(1); //DColByteU
        rows = 1 + blob.read_shift(2); //DRw
    }
    if (opts.biff >= 2 && opts.biff < 8) {
        --rows;
        if (--cols == 0) cols = 0x100;
    }
    // $FlowIgnore
    for(var i = 0, o /*:Array<Array<any>>*/  = []; i != rows && (o[i] = []); ++i)for(var j = 0; j != cols; ++j)o[i][j] = $a1a91b25d7598376$var$parse_SerAr(blob, opts.biff);
    return o;
}
/* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 */ function $a1a91b25d7598376$var$parse_PtgName(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var w = !opts || opts.biff >= 8 ? 4 : 2;
    var nameindex = blob.read_shift(w);
    switch(opts.biff){
        case 2:
            blob.l += 5;
            break;
        case 3:
        case 4:
            blob.l += 8;
            break;
        case 5:
            blob.l += 12;
            break;
    }
    return [
        type,
        0,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 */ function $a1a91b25d7598376$var$parse_PtgNameX(blob, length, opts) {
    if (opts.biff == 5) return $a1a91b25d7598376$var$parse_PtgNameX_BIFF5(blob, length, opts);
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2); // XtiIndex
    var nameindex = blob.read_shift(4);
    return [
        type,
        ixti,
        nameindex
    ];
}
function $a1a91b25d7598376$var$parse_PtgNameX_BIFF5(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var ixti = blob.read_shift(2, 'i'); // XtiIndex
    blob.l += 8;
    var nameindex = blob.read_shift(2);
    blob.l += 12;
    return [
        type,
        ixti,
        nameindex
    ];
}
/* [MS-XLS] 2.5.198.70 ; [MS-XLSB] 2.5.97.54 */ function $a1a91b25d7598376$var$parse_PtgMemArea(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += opts && opts.biff == 2 ? 3 : 4;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.72 ; [MS-XLSB] 2.5.97.56 */ function $a1a91b25d7598376$var$parse_PtgMemFunc(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(opts && opts.biff == 2 ? 1 : 2);
    return [
        type,
        cce
    ];
}
/* [MS-XLS] 2.5.198.86 ; [MS-XLSB] 2.5.97.69 */ function $a1a91b25d7598376$var$parse_PtgRefErr(blob, length, opts) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    blob.l += 4;
    if (opts.biff < 8) blob.l--;
    if (opts.biff == 12) blob.l += 2;
    return [
        type
    ];
}
/* [MS-XLS] 2.5.198.87 ; [MS-XLSB] 2.5.97.71 */ function $a1a91b25d7598376$var$parse_PtgRefErr3d(blob, length, opts) {
    var type = (blob[blob.l++] & 0x60) >> 5;
    var ixti = blob.read_shift(2);
    var w = 4;
    if (opts) switch(opts.biff){
        case 5:
            w = 15;
            break;
        case 12:
            w = 6;
            break;
    }
    blob.l += w;
    return [
        type,
        ixti
    ];
}
/* [MS-XLS] 2.5.198.71 ; [MS-XLSB] 2.5.97.55 */ var $a1a91b25d7598376$var$parse_PtgMemErr = $a1a91b25d7598376$var$parsenoop;
/* [MS-XLS] 2.5.198.73  ; [MS-XLSB] 2.5.97.57 */ var $a1a91b25d7598376$var$parse_PtgMemNoMem = $a1a91b25d7598376$var$parsenoop;
/* [MS-XLS] 2.5.198.92 */ var $a1a91b25d7598376$var$parse_PtgTbl = $a1a91b25d7598376$var$parsenoop;
function $a1a91b25d7598376$var$parse_PtgElfLoc(blob, length, opts) {
    blob.l += 2;
    return [
        $a1a91b25d7598376$var$parse_RgceElfLoc(blob, 4, opts)
    ];
}
function $a1a91b25d7598376$var$parse_PtgElfNoop(blob /*::, length, opts*/ ) {
    blob.l += 6;
    return [];
}
/* [MS-XLS] 2.5.198.46 */ var $a1a91b25d7598376$var$parse_PtgElfCol = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.47 */ var $a1a91b25d7598376$var$parse_PtgElfColS = $a1a91b25d7598376$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.48 */ var $a1a91b25d7598376$var$parse_PtgElfColSV = $a1a91b25d7598376$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.49 */ var $a1a91b25d7598376$var$parse_PtgElfColV = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.50 */ function $a1a91b25d7598376$var$parse_PtgElfLel(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        $a1a91b25d7598376$var$parseuint16(blob),
        blob.read_shift(2) & 0x01
    ];
}
/* [MS-XLS] 2.5.198.51 */ var $a1a91b25d7598376$var$parse_PtgElfRadical = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.52 */ var $a1a91b25d7598376$var$parse_PtgElfRadicalLel = $a1a91b25d7598376$var$parse_PtgElfLel;
/* [MS-XLS] 2.5.198.53 */ var $a1a91b25d7598376$var$parse_PtgElfRadicalS = $a1a91b25d7598376$var$parse_PtgElfNoop;
/* [MS-XLS] 2.5.198.54 */ var $a1a91b25d7598376$var$parse_PtgElfRw = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLS] 2.5.198.55 */ var $a1a91b25d7598376$var$parse_PtgElfRwV = $a1a91b25d7598376$var$parse_PtgElfLoc;
/* [MS-XLSB] 2.5.97.52 TODO */ var $a1a91b25d7598376$var$PtgListRT = [
    "Data",
    "All",
    "Headers",
    "??",
    "?Data2",
    "??",
    "?DataHeaders",
    "??",
    "Totals",
    "??",
    "??",
    "??",
    "?DataTotals",
    "??",
    "??",
    "??",
    "?Current"
];
function $a1a91b25d7598376$var$parse_PtgList(blob /*::, length, opts*/ ) {
    blob.l += 2;
    var ixti = blob.read_shift(2);
    var flags = blob.read_shift(2);
    var idx = blob.read_shift(4);
    var c = blob.read_shift(2);
    var C = blob.read_shift(2);
    var rt = $a1a91b25d7598376$var$PtgListRT[flags >> 2 & 0x1F];
    return {
        ixti: ixti,
        coltype: flags & 0x3,
        rt: rt,
        idx: idx,
        c: c,
        C: C
    };
}
/* [MS-XLS] 2.5.198.91 ; [MS-XLSB] 2.5.97.76 */ function $a1a91b25d7598376$var$parse_PtgSxName(blob /*::, length, opts*/ ) {
    blob.l += 2;
    return [
        blob.read_shift(4)
    ];
}
/* [XLS] old spec */ function $a1a91b25d7598376$var$parse_PtgSheet(blob, length, opts) {
    blob.l += 5;
    blob.l += 2;
    blob.l += opts.biff == 2 ? 1 : 4;
    return [
        "PTGSHEET"
    ];
}
function $a1a91b25d7598376$var$parse_PtgEndSheet(blob, length, opts) {
    blob.l += opts.biff == 2 ? 4 : 5;
    return [
        "PTGENDSHEET"
    ];
}
function $a1a91b25d7598376$var$parse_PtgMemAreaN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $a1a91b25d7598376$var$parse_PtgMemNoMemN(blob /*::, length, opts*/ ) {
    var type = blob.read_shift(1) >>> 5 & 0x03;
    var cce = blob.read_shift(2);
    return [
        type,
        cce
    ];
}
function $a1a91b25d7598376$var$parse_PtgAttrNoop(blob /*::, length, opts*/ ) {
    blob.l += 4;
    return [
        0,
        0
    ];
}
/* [MS-XLS] 2.5.198.25 ; [MS-XLSB] 2.5.97.16 */ var $a1a91b25d7598376$var$PtgTypes = {
    0x01: {
        n: 'PtgExp',
        f: $a1a91b25d7598376$var$parse_PtgExp
    },
    0x02: {
        n: 'PtgTbl',
        f: $a1a91b25d7598376$var$parse_PtgTbl
    },
    0x03: {
        n: 'PtgAdd',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x04: {
        n: 'PtgSub',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x05: {
        n: 'PtgMul',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x06: {
        n: 'PtgDiv',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x07: {
        n: 'PtgPower',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x08: {
        n: 'PtgConcat',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x09: {
        n: 'PtgLt',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0A: {
        n: 'PtgLe',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0B: {
        n: 'PtgEq',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0C: {
        n: 'PtgGe',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0D: {
        n: 'PtgGt',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0E: {
        n: 'PtgNe',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x0F: {
        n: 'PtgIsect',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x10: {
        n: 'PtgUnion',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x11: {
        n: 'PtgRange',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x12: {
        n: 'PtgUplus',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x13: {
        n: 'PtgUminus',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x14: {
        n: 'PtgPercent',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x15: {
        n: 'PtgParen',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x16: {
        n: 'PtgMissArg',
        f: $a1a91b25d7598376$var$parseread1
    },
    0x17: {
        n: 'PtgStr',
        f: $a1a91b25d7598376$var$parse_PtgStr
    },
    0x1A: {
        n: 'PtgSheet',
        f: $a1a91b25d7598376$var$parse_PtgSheet
    },
    0x1B: {
        n: 'PtgEndSheet',
        f: $a1a91b25d7598376$var$parse_PtgEndSheet
    },
    0x1C: {
        n: 'PtgErr',
        f: $a1a91b25d7598376$var$parse_PtgErr
    },
    0x1D: {
        n: 'PtgBool',
        f: $a1a91b25d7598376$var$parse_PtgBool
    },
    0x1E: {
        n: 'PtgInt',
        f: $a1a91b25d7598376$var$parse_PtgInt
    },
    0x1F: {
        n: 'PtgNum',
        f: $a1a91b25d7598376$var$parse_PtgNum
    },
    0x20: {
        n: 'PtgArray',
        f: $a1a91b25d7598376$var$parse_PtgArray
    },
    0x21: {
        n: 'PtgFunc',
        f: $a1a91b25d7598376$var$parse_PtgFunc
    },
    0x22: {
        n: 'PtgFuncVar',
        f: $a1a91b25d7598376$var$parse_PtgFuncVar
    },
    0x23: {
        n: 'PtgName',
        f: $a1a91b25d7598376$var$parse_PtgName
    },
    0x24: {
        n: 'PtgRef',
        f: $a1a91b25d7598376$var$parse_PtgRef
    },
    0x25: {
        n: 'PtgArea',
        f: $a1a91b25d7598376$var$parse_PtgArea
    },
    0x26: {
        n: 'PtgMemArea',
        f: $a1a91b25d7598376$var$parse_PtgMemArea
    },
    0x27: {
        n: 'PtgMemErr',
        f: $a1a91b25d7598376$var$parse_PtgMemErr
    },
    0x28: {
        n: 'PtgMemNoMem',
        f: $a1a91b25d7598376$var$parse_PtgMemNoMem
    },
    0x29: {
        n: 'PtgMemFunc',
        f: $a1a91b25d7598376$var$parse_PtgMemFunc
    },
    0x2A: {
        n: 'PtgRefErr',
        f: $a1a91b25d7598376$var$parse_PtgRefErr
    },
    0x2B: {
        n: 'PtgAreaErr',
        f: $a1a91b25d7598376$var$parse_PtgAreaErr
    },
    0x2C: {
        n: 'PtgRefN',
        f: $a1a91b25d7598376$var$parse_PtgRefN
    },
    0x2D: {
        n: 'PtgAreaN',
        f: $a1a91b25d7598376$var$parse_PtgAreaN
    },
    0x2E: {
        n: 'PtgMemAreaN',
        f: $a1a91b25d7598376$var$parse_PtgMemAreaN
    },
    0x2F: {
        n: 'PtgMemNoMemN',
        f: $a1a91b25d7598376$var$parse_PtgMemNoMemN
    },
    0x39: {
        n: 'PtgNameX',
        f: $a1a91b25d7598376$var$parse_PtgNameX
    },
    0x3A: {
        n: 'PtgRef3d',
        f: $a1a91b25d7598376$var$parse_PtgRef3d
    },
    0x3B: {
        n: 'PtgArea3d',
        f: $a1a91b25d7598376$var$parse_PtgArea3d
    },
    0x3C: {
        n: 'PtgRefErr3d',
        f: $a1a91b25d7598376$var$parse_PtgRefErr3d
    },
    0x3D: {
        n: 'PtgAreaErr3d',
        f: $a1a91b25d7598376$var$parse_PtgAreaErr3d
    },
    0xFF: {}
};
/* These are duplicated in the PtgTypes table */ var $a1a91b25d7598376$var$PtgDupes = {
    0x40: 0x20,
    0x60: 0x20,
    0x41: 0x21,
    0x61: 0x21,
    0x42: 0x22,
    0x62: 0x22,
    0x43: 0x23,
    0x63: 0x23,
    0x44: 0x24,
    0x64: 0x24,
    0x45: 0x25,
    0x65: 0x25,
    0x46: 0x26,
    0x66: 0x26,
    0x47: 0x27,
    0x67: 0x27,
    0x48: 0x28,
    0x68: 0x28,
    0x49: 0x29,
    0x69: 0x29,
    0x4A: 0x2A,
    0x6A: 0x2A,
    0x4B: 0x2B,
    0x6B: 0x2B,
    0x4C: 0x2C,
    0x6C: 0x2C,
    0x4D: 0x2D,
    0x6D: 0x2D,
    0x4E: 0x2E,
    0x6E: 0x2E,
    0x4F: 0x2F,
    0x6F: 0x2F,
    0x58: 0x22,
    0x78: 0x22,
    0x59: 0x39,
    0x79: 0x39,
    0x5A: 0x3A,
    0x7A: 0x3A,
    0x5B: 0x3B,
    0x7B: 0x3B,
    0x5C: 0x3C,
    0x7C: 0x3C,
    0x5D: 0x3D,
    0x7D: 0x3D
};
var $a1a91b25d7598376$var$Ptg18 = {
    0x01: {
        n: 'PtgElfLel',
        f: $a1a91b25d7598376$var$parse_PtgElfLel
    },
    0x02: {
        n: 'PtgElfRw',
        f: $a1a91b25d7598376$var$parse_PtgElfRw
    },
    0x03: {
        n: 'PtgElfCol',
        f: $a1a91b25d7598376$var$parse_PtgElfCol
    },
    0x06: {
        n: 'PtgElfRwV',
        f: $a1a91b25d7598376$var$parse_PtgElfRwV
    },
    0x07: {
        n: 'PtgElfColV',
        f: $a1a91b25d7598376$var$parse_PtgElfColV
    },
    0x0A: {
        n: 'PtgElfRadical',
        f: $a1a91b25d7598376$var$parse_PtgElfRadical
    },
    0x0B: {
        n: 'PtgElfRadicalS',
        f: $a1a91b25d7598376$var$parse_PtgElfRadicalS
    },
    0x0D: {
        n: 'PtgElfColS',
        f: $a1a91b25d7598376$var$parse_PtgElfColS
    },
    0x0F: {
        n: 'PtgElfColSV',
        f: $a1a91b25d7598376$var$parse_PtgElfColSV
    },
    0x10: {
        n: 'PtgElfRadicalLel',
        f: $a1a91b25d7598376$var$parse_PtgElfRadicalLel
    },
    0x19: {
        n: 'PtgList',
        f: $a1a91b25d7598376$var$parse_PtgList
    },
    0x1D: {
        n: 'PtgSxName',
        f: $a1a91b25d7598376$var$parse_PtgSxName
    },
    0xFF: {}
};
var $a1a91b25d7598376$var$Ptg19 = {
    0x00: {
        n: 'PtgAttrNoop',
        f: $a1a91b25d7598376$var$parse_PtgAttrNoop
    },
    0x01: {
        n: 'PtgAttrSemi',
        f: $a1a91b25d7598376$var$parse_PtgAttrSemi
    },
    0x02: {
        n: 'PtgAttrIf',
        f: $a1a91b25d7598376$var$parse_PtgAttrIf
    },
    0x04: {
        n: 'PtgAttrChoose',
        f: $a1a91b25d7598376$var$parse_PtgAttrChoose
    },
    0x08: {
        n: 'PtgAttrGoto',
        f: $a1a91b25d7598376$var$parse_PtgAttrGoto
    },
    0x10: {
        n: 'PtgAttrSum',
        f: $a1a91b25d7598376$var$parse_PtgAttrSum
    },
    0x20: {
        n: 'PtgAttrBaxcel',
        f: $a1a91b25d7598376$var$parse_PtgAttrBaxcel
    },
    0x21: {
        n: 'PtgAttrBaxcel',
        f: $a1a91b25d7598376$var$parse_PtgAttrBaxcel
    },
    0x40: {
        n: 'PtgAttrSpace',
        f: $a1a91b25d7598376$var$parse_PtgAttrSpace
    },
    0x41: {
        n: 'PtgAttrSpaceSemi',
        f: $a1a91b25d7598376$var$parse_PtgAttrSpaceSemi
    },
    0x80: {
        n: 'PtgAttrIfError',
        f: $a1a91b25d7598376$var$parse_PtgAttrIfError
    },
    0xFF: {}
};
/* [MS-XLS] 2.5.198.103 ; [MS-XLSB] 2.5.97.87 */ function $a1a91b25d7598376$var$parse_RgbExtra(blob, length, rgce, opts) {
    if (opts.biff < 8) return $a1a91b25d7598376$var$parsenoop(blob, length);
    var target = blob.l + length;
    var o = [];
    for(var i = 0; i !== rgce.length; ++i)switch(rgce[i][0]){
        case 'PtgArray':
            /* PtgArray -> PtgExtraArray */ rgce[i][1] = $a1a91b25d7598376$var$parse_PtgExtraArray(blob, 0, opts);
            o.push(rgce[i][1]);
            break;
        case 'PtgMemArea':
            /* PtgMemArea -> PtgExtraMem */ rgce[i][2] = $a1a91b25d7598376$var$parse_PtgExtraMem(blob, rgce[i][1], opts);
            o.push(rgce[i][2]);
            break;
        case 'PtgExp':
            /* PtgExp -> PtgExtraCol */ if (opts && opts.biff == 12) {
                rgce[i][1][1] = blob.read_shift(4);
                o.push(rgce[i][1]);
            }
            break;
        case 'PtgList':
        /* TODO: PtgList -> PtgExtraList */ case 'PtgElfRadicalS':
        /* TODO: PtgElfRadicalS -> PtgExtraElf */ case 'PtgElfColS':
        /* TODO: PtgElfColS -> PtgExtraElf */ case 'PtgElfColSV':
            /* TODO: PtgElfColSV -> PtgExtraElf */ throw "Unsupported " + rgce[i][0];
        default:
            break;
    }
    length = target - blob.l;
    /* note: this is technically an error but Excel disregards */ //if(target !== blob.l && blob.l !== target - length) throw new Error(target + " != " + blob.l);
    if (length !== 0) o.push($a1a91b25d7598376$var$parsenoop(blob, length));
    return o;
}
/* [MS-XLS] 2.5.198.104 ; [MS-XLSB] 2.5.97.88 */ function $a1a91b25d7598376$var$parse_Rgce(blob, length, opts) {
    var target = blob.l + length;
    var R, id, ptgs = [];
    while(target != blob.l){
        length = target - blob.l;
        id = blob[blob.l];
        R = $a1a91b25d7598376$var$PtgTypes[id] || $a1a91b25d7598376$var$PtgTypes[$a1a91b25d7598376$var$PtgDupes[id]];
        if (id === 0x18 || id === 0x19) R = (id === 0x18 ? $a1a91b25d7598376$var$Ptg18 : $a1a91b25d7598376$var$Ptg19)[blob[blob.l + 1]];
        if (!R || !R.f) $a1a91b25d7598376$var$parsenoop(blob, length);
        else ptgs.push([
            R.n,
            R.f(blob, length, opts)
        ]);
    }
    return ptgs;
}
function $a1a91b25d7598376$var$stringify_array(f /*:Array<Array<string>>*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    for(var i = 0; i < f.length; ++i){
        var x = f[i], r /*:Array<string>*/  = [];
        for(var j = 0; j < x.length; ++j){
            var y = x[j];
            if (y) switch(y[0]){
                // TODO: handle embedded quotes
                case 0x02:
                    /*:: if(typeof y[1] != 'string') throw "unreachable"; */ r.push('"' + y[1].replace(/"/g, '""') + '"');
                    break;
                default:
                    r.push(y[1]);
            }
            else r.push("");
        }
        o.push(r.join(","));
    }
    return o.join(";");
}
/* [MS-XLS] 2.2.2 ; [MS-XLSB] 2.2.2 TODO */ var $a1a91b25d7598376$var$PtgBinOp = {
    PtgAdd: "+",
    PtgConcat: "&",
    PtgDiv: "/",
    PtgEq: "=",
    PtgGe: ">=",
    PtgGt: ">",
    PtgLe: "<=",
    PtgLt: "<",
    PtgMul: "*",
    PtgNe: "<>",
    PtgPower: "^",
    PtgSub: "-"
};
// TODO: explore space
function $a1a91b25d7598376$var$make_3d_range(start, end) {
    var s = start.lastIndexOf("!"), e = end.lastIndexOf("!");
    if (s == -1 && e == -1) return start + ":" + end;
    if (s > 0 && e > 0 && start.slice(0, s).toLowerCase() == end.slice(0, e).toLowerCase()) return start + ":" + end.slice(e + 1);
    console.error("Cannot hydrate range", start, end);
    return start + ":" + end;
}
function $a1a91b25d7598376$var$get_ixti_raw(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    if (!supbooks) return "SH33TJSERR0";
    if (opts.biff > 8 && (!supbooks.XTI || !supbooks.XTI[ixti])) return supbooks.SheetNames[ixti];
    if (!supbooks.XTI) return "SH33TJSERR6";
    var XTI = supbooks.XTI[ixti];
    if (opts.biff < 8) {
        if (ixti > 10000) ixti -= 65536;
        if (ixti < 0) ixti = -ixti;
        return ixti == 0 ? "" : supbooks.XTI[ixti - 1];
    }
    if (!XTI) return "SH33TJSERR1";
    var o = "";
    if (opts.biff > 8) switch(supbooks[XTI[0]][0]){
        case 0x0165:
            /* 'BrtSupSelf' */ o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]];
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x0166:
            /* 'BrtSupSame' */ if (opts.SID != null) return supbooks.SheetNames[opts.SID];
            return "SH33TJSSAME" + supbooks[XTI[0]][0];
        case 0x0163:
        /* 'BrtSupBookSrc' */ /* falls through */ default:
            return "SH33TJSSRC" + supbooks[XTI[0]][0];
    }
    switch(supbooks[XTI[0]][0][0]){
        case 0x0401:
            o = XTI[1] == -1 ? "#REF" : supbooks.SheetNames[XTI[1]] || "SH33TJSERR3";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks.SheetNames[XTI[2]];
        case 0x3A01:
            return supbooks[XTI[0]].slice(1).map(function(name) {
                return name.Name;
            }).join(";;"); //return "SH33TJSERR8";
        default:
            if (!supbooks[XTI[0]][0][3]) return "SH33TJSERR2";
            o = XTI[1] == -1 ? "#REF" : supbooks[XTI[0]][0][3][XTI[1]] || "SH33TJSERR4";
            return XTI[1] == XTI[2] ? o : o + ":" + supbooks[XTI[0]][0][3][XTI[2]];
    }
}
function $a1a91b25d7598376$var$get_ixti(supbooks, ixti /*:number*/ , opts) /*:string*/ {
    var ixtiraw = $a1a91b25d7598376$var$get_ixti_raw(supbooks, ixti, opts);
    return ixtiraw == "#REF" ? ixtiraw : $a1a91b25d7598376$var$formula_quote_sheet_name(ixtiraw, opts);
}
function $a1a91b25d7598376$var$stringify_formula(formula /*Array<any>*/ , range, cell /*:any*/ , supbooks, opts) /*:string*/ {
    var biff = opts && opts.biff || 8;
    var _range = /*range != null ? range :*/ {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: 0,
            r: 0
        }
    };
    var stack /*:Array<string>*/  = [], e1, e2, /*::type,*/ c /*:CellAddress*/ , ixti = 0, nameidx = 0, r, sname = "";
    if (!formula[0] || !formula[0][0]) return "";
    var last_sp = -1, sp = "";
    for(var ff = 0, fflen = formula[0].length; ff < fflen; ++ff){
        var f = formula[0][ff];
        switch(f[0]){
            case 'PtgUminus':
                /* [MS-XLS] 2.5.198.93 */ stack.push("-" + stack.pop());
                break;
            case 'PtgUplus':
                /* [MS-XLS] 2.5.198.95 */ stack.push("+" + stack.pop());
                break;
            case 'PtgPercent':
                /* [MS-XLS] 2.5.198.81 */ stack.push(stack.pop() + "%");
                break;
            case 'PtgAdd':
            /* [MS-XLS] 2.5.198.26 */ case 'PtgConcat':
            /* [MS-XLS] 2.5.198.43 */ case 'PtgDiv':
            /* [MS-XLS] 2.5.198.45 */ case 'PtgEq':
            /* [MS-XLS] 2.5.198.56 */ case 'PtgGe':
            /* [MS-XLS] 2.5.198.64 */ case 'PtgGt':
            /* [MS-XLS] 2.5.198.65 */ case 'PtgLe':
            /* [MS-XLS] 2.5.198.68 */ case 'PtgLt':
            /* [MS-XLS] 2.5.198.69 */ case 'PtgMul':
            /* [MS-XLS] 2.5.198.75 */ case 'PtgNe':
            /* [MS-XLS] 2.5.198.78 */ case 'PtgPower':
            /* [MS-XLS] 2.5.198.82 */ case 'PtgSub':
                /* [MS-XLS] 2.5.198.90 */ e1 = stack.pop();
                e2 = stack.pop();
                if (last_sp >= 0) {
                    switch(formula[0][last_sp][1][0]){
                        case 0:
                            // $FlowIgnore
                            sp = $a1a91b25d7598376$var$fill(" ", formula[0][last_sp][1][1]);
                            break;
                        case 1:
                            // $FlowIgnore
                            sp = $a1a91b25d7598376$var$fill("\r", formula[0][last_sp][1][1]);
                            break;
                        default:
                            sp = "";
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    e2 = e2 + sp;
                    last_sp = -1;
                }
                stack.push(e2 + $a1a91b25d7598376$var$PtgBinOp[f[0]] + e1);
                break;
            case 'PtgIsect':
                /* [MS-XLS] 2.5.198.67 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + " " + e1);
                break;
            case 'PtgUnion':
                /* [MS-XLS] 2.5.198.94 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push(e2 + "," + e1);
                break;
            case 'PtgRange':
                /* [MS-XLS] 2.5.198.83 */ e1 = stack.pop();
                e2 = stack.pop();
                stack.push($a1a91b25d7598376$var$make_3d_range(e2, e1));
                break;
            case 'PtgAttrChoose':
                break;
            case 'PtgAttrGoto':
                break;
            case 'PtgAttrIf':
                break;
            case 'PtgAttrIfError':
                break;
            case 'PtgRef':
                /* [MS-XLS] 2.5.198.84 */ /*::type = f[1][0]; */ c = $a1a91b25d7598376$var$shift_cell_xls(f[1][1], _range, opts);
                stack.push($a1a91b25d7598376$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRefN':
                /* [MS-XLS] 2.5.198.88 */ /*::type = f[1][0]; */ c = cell ? $a1a91b25d7598376$var$shift_cell_xls(f[1][1], cell, opts) : f[1][1];
                stack.push($a1a91b25d7598376$var$encode_cell_xls(c, biff));
                break;
            case 'PtgRef3d':
                /* [MS-XLS] 2.5.198.85 */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                c = $a1a91b25d7598376$var$shift_cell_xls(f[1][2], _range, opts);
                sname = $a1a91b25d7598376$var$get_ixti(supbooks, ixti, opts);
                var w = sname; /* IE9 fails on defined names */  // eslint-disable-line no-unused-vars
                stack.push(sname + "!" + $a1a91b25d7598376$var$encode_cell_xls(c, biff));
                break;
            case 'PtgFunc':
            /* [MS-XLS] 2.5.198.62 */ case 'PtgFuncVar':
                /* [MS-XLS] 2.5.198.63 */ /* f[1] = [argc, func, type] */ var argc /*:number*/  = f[1][0], func /*:string*/  = f[1][1];
                if (!argc) argc = 0;
                argc &= 0x7F;
                var args = argc == 0 ? [] : stack.slice(-argc);
                stack.length -= argc;
                if (func === 'User') func = args.shift();
                stack.push(func + "(" + args.join(",") + ")");
                break;
            case 'PtgBool':
                /* [MS-XLS] 2.5.198.42 */ stack.push(f[1] ? "TRUE" : "FALSE");
                break;
            case 'PtgInt':
                /* [MS-XLS] 2.5.198.66 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgNum':
                /* [MS-XLS] 2.5.198.79 TODO: precision? */ stack.push(String(f[1]));
                break;
            case 'PtgStr':
                /* [MS-XLS] 2.5.198.89 */ // $FlowIgnore
                stack.push('"' + f[1].replace(/"/g, '""') + '"');
                break;
            case 'PtgErr':
                /* [MS-XLS] 2.5.198.57 */ stack.push(/*::String(*/ f[1]);
                break;
            case 'PtgAreaN':
                /* [MS-XLS] 2.5.198.31 TODO */ /*::type = f[1][0]; */ r = $a1a91b25d7598376$var$shift_range_xls(f[1][1], cell ? {
                    s: cell
                } : _range, opts);
                stack.push($a1a91b25d7598376$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea':
                /* [MS-XLS] 2.5.198.27 TODO: fixed points */ /*::type = f[1][0]; */ r = $a1a91b25d7598376$var$shift_range_xls(f[1][1], _range, opts);
                stack.push($a1a91b25d7598376$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgArea3d':
                /* [MS-XLS] 2.5.198.28 TODO */ /*::type = f[1][0]; */ ixti = /*::Number(*/ f[1][1] /*::)*/ ;
                r = f[1][2];
                sname = $a1a91b25d7598376$var$get_ixti(supbooks, ixti, opts);
                stack.push(sname + "!" + $a1a91b25d7598376$var$encode_range_xls(r /*:any*/ , opts));
                break;
            case 'PtgAttrSum':
                /* [MS-XLS] 2.5.198.41 */ stack.push("SUM(" + stack.pop() + ")");
                break;
            case 'PtgAttrBaxcel':
            /* [MS-XLS] 2.5.198.33 */ case 'PtgAttrSemi':
                break;
            case 'PtgName':
                /* [MS-XLS] 2.5.198.76 ; [MS-XLSB] 2.5.97.60 TODO: revisions */ /* f[1] = type, 0, nameindex */ nameidx = f[1][2];
                var lbl = (supbooks.names || [])[nameidx - 1] || (supbooks[0] || [])[nameidx];
                var name = lbl ? lbl.Name : "SH33TJSNAME" + String(nameidx);
                /* [MS-XLSB] 2.5.97.10 Ftab -- last verified 20220204 */ if (name && name.slice(0, 6) == "_xlfn." && !opts.xlfn) name = name.slice(6);
                stack.push(name);
                break;
            case 'PtgNameX':
                /* [MS-XLS] 2.5.198.77 ; [MS-XLSB] 2.5.97.61 TODO: revisions */ /* f[1] = type, ixti, nameindex */ var bookidx /*:number*/  = f[1][1];
                nameidx = f[1][2];
                var externbook;
                /* TODO: Properly handle missing values -- this should be using get_ixti_raw primarily */ if (opts.biff <= 5) {
                    if (bookidx < 0) bookidx = -bookidx;
                    if (supbooks[bookidx]) externbook = supbooks[bookidx][nameidx];
                } else {
                    var o = "";
                    if (((supbooks[bookidx] || [])[0] || [])[0] == 0x3A01) ;
                    else if (((supbooks[bookidx] || [])[0] || [])[0] == 0x0401) {
                        if (supbooks[bookidx][nameidx] && supbooks[bookidx][nameidx].itab > 0) o = supbooks.SheetNames[supbooks[bookidx][nameidx].itab - 1] + "!";
                    } else o = supbooks.SheetNames[nameidx - 1] + "!";
                    if (supbooks[bookidx] && supbooks[bookidx][nameidx]) o += supbooks[bookidx][nameidx].Name;
                    else if (supbooks[0] && supbooks[0][nameidx]) o += supbooks[0][nameidx].Name;
                    else {
                        var ixtidata = ($a1a91b25d7598376$var$get_ixti_raw(supbooks, bookidx, opts) || "").split(";;");
                        if (ixtidata[nameidx - 1]) o = ixtidata[nameidx - 1]; // TODO: confirm this is correct
                        else o += "SH33TJSERRX";
                    }
                    stack.push(o);
                    break;
                }
                if (!externbook) externbook = {
                    Name: "SH33TJSERRY"
                };
                stack.push(externbook.Name);
                break;
            case 'PtgParen':
                /* [MS-XLS] 2.5.198.80 */ var lp = '(', rp = ')';
                if (last_sp >= 0) {
                    sp = "";
                    switch(formula[0][last_sp][1][0]){
                        // $FlowIgnore
                        case 2:
                            lp = $a1a91b25d7598376$var$fill(" ", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 3:
                            lp = $a1a91b25d7598376$var$fill("\r", formula[0][last_sp][1][1]) + lp;
                            break;
                        // $FlowIgnore
                        case 4:
                            rp = $a1a91b25d7598376$var$fill(" ", formula[0][last_sp][1][1]) + rp;
                            break;
                        // $FlowIgnore
                        case 5:
                            rp = $a1a91b25d7598376$var$fill("\r", formula[0][last_sp][1][1]) + rp;
                            break;
                        default:
                            // $FlowIgnore
                            if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + formula[0][last_sp][1][0]);
                    }
                    last_sp = -1;
                }
                stack.push(lp + stack.pop() + rp);
                break;
            case 'PtgRefErr':
                /* [MS-XLS] 2.5.198.86 */ stack.push('#REF!');
                break;
            case 'PtgRefErr3d':
                /* [MS-XLS] 2.5.198.87 */ stack.push('#REF!');
                break;
            case 'PtgExp':
                /* [MS-XLS] 2.5.198.58 TODO */ c = {
                    c: f[1][1],
                    r: f[1][0]
                };
                var q = {
                    c: cell.c,
                    r: cell.r
                } /*:any*/ ;
                if (supbooks.sharedf[$a1a91b25d7598376$var$encode_cell(c)]) {
                    var parsedf = supbooks.sharedf[$a1a91b25d7598376$var$encode_cell(c)];
                    stack.push($a1a91b25d7598376$var$stringify_formula(parsedf, _range, q, supbooks, opts));
                } else {
                    var fnd = false;
                    for(e1 = 0; e1 != supbooks.arrayf.length; ++e1){
                        /* TODO: should be something like range_has */ e2 = supbooks.arrayf[e1];
                        if (c.c < e2[0].s.c || c.c > e2[0].e.c) continue;
                        if (c.r < e2[0].s.r || c.r > e2[0].e.r) continue;
                        stack.push($a1a91b25d7598376$var$stringify_formula(e2[1], _range, q, supbooks, opts));
                        fnd = true;
                        break;
                    }
                    if (!fnd) stack.push(/*::String(*/ f[1]);
                }
                break;
            case 'PtgArray':
                /* [MS-XLS] 2.5.198.32 TODO */ stack.push("{" + $a1a91b25d7598376$var$stringify_array(/*::(*/ f[1]) + "}");
                break;
            case 'PtgMemArea':
                break;
            case 'PtgAttrSpace':
            /* [MS-XLS] 2.5.198.38 */ case 'PtgAttrSpaceSemi':
                /* [MS-XLS] 2.5.198.39 */ last_sp = ff;
                break;
            case 'PtgTbl':
                break;
            case 'PtgMemErr':
                break;
            case 'PtgMissArg':
                /* [MS-XLS] 2.5.198.74 */ stack.push("");
                break;
            case 'PtgAreaErr':
                /* [MS-XLS] 2.5.198.29 */ stack.push("#REF!");
                break;
            case 'PtgAreaErr3d':
                /* [MS-XLS] 2.5.198.30 */ stack.push("#REF!");
                break;
            case 'PtgList':
                /* [MS-XLSB] 2.5.97.52 */ // $FlowIgnore
                stack.push("Table" + f[1].idx + "[#" + f[1].rt + "]");
                break;
            case 'PtgMemAreaN':
            case 'PtgMemNoMemN':
            case 'PtgAttrNoop':
            case 'PtgSheet':
            case 'PtgEndSheet':
                break;
            case 'PtgMemFunc':
                break;
            case 'PtgMemNoMem':
                break;
            case 'PtgElfCol':
            /* [MS-XLS] 2.5.198.46 */ case 'PtgElfColS':
            /* [MS-XLS] 2.5.198.47 */ case 'PtgElfColSV':
            /* [MS-XLS] 2.5.198.48 */ case 'PtgElfColV':
            /* [MS-XLS] 2.5.198.49 */ case 'PtgElfLel':
            /* [MS-XLS] 2.5.198.50 */ case 'PtgElfRadical':
            /* [MS-XLS] 2.5.198.51 */ case 'PtgElfRadicalLel':
            /* [MS-XLS] 2.5.198.52 */ case 'PtgElfRadicalS':
            /* [MS-XLS] 2.5.198.53 */ case 'PtgElfRw':
            /* [MS-XLS] 2.5.198.54 */ case 'PtgElfRwV':
                /* [MS-XLS] 2.5.198.55 */ throw new Error("Unsupported ELFs");
            case 'PtgSxName':
                /* [MS-XLS] 2.5.198.91 TODO -- find a test case */ throw new Error('Unrecognized Formula Token: ' + String(f));
            default:
                throw new Error('Unrecognized Formula Token: ' + String(f));
        }
        var PtgNonDisp = [
            'PtgAttrSpace',
            'PtgAttrSpaceSemi',
            'PtgAttrGoto'
        ];
        if (opts.biff != 3) {
            if (last_sp >= 0 && PtgNonDisp.indexOf(formula[0][ff][0]) == -1) {
                f = formula[0][last_sp];
                var _left = true;
                switch(f[1][0]){
                    /* note: some bad XLSB files omit the PtgParen */ case 4:
                        _left = false;
                    /* falls through */ case 0:
                        // $FlowIgnore
                        sp = $a1a91b25d7598376$var$fill(" ", f[1][1]);
                        break;
                    case 5:
                        _left = false;
                    /* falls through */ case 1:
                        // $FlowIgnore
                        sp = $a1a91b25d7598376$var$fill("\r", f[1][1]);
                        break;
                    default:
                        sp = "";
                        // $FlowIgnore
                        if (opts.WTF) throw new Error("Unexpected PtgAttrSpaceType " + f[1][0]);
                }
                stack.push((_left ? sp : "") + stack.pop() + (_left ? "" : sp));
                last_sp = -1;
            }
        }
    }
    if (stack.length > 1 && opts.WTF) throw new Error("bad formula stack");
    if (stack[0] == "TRUE") return true;
    if (stack[0] == "FALSE") return false;
    return stack[0];
}
/* [MS-XLS] 2.5.198.1 TODO */ function $a1a91b25d7598376$var$parse_ArrayParsedFormula(blob, length, opts /*::, ref*/ ) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $a1a91b25d7598376$var$parsenoop(blob, length - 2)
    ];
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.3 TODO */ function $a1a91b25d7598376$var$parse_XLSCellParsedFormula(blob, length, opts) {
    var target = blob.l + length, len = opts.biff == 2 ? 1 : 2;
    var rgcb, cce = blob.read_shift(len); // length of rgce
    if (cce == 0xFFFF) return [
        [],
        $a1a91b25d7598376$var$parsenoop(blob, length - 2)
    ];
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    if (length !== cce + len) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, length - cce - len, rgce, opts);
    blob.l = target;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.21 */ function $a1a91b25d7598376$var$parse_NameParsedFormula(blob, length, opts, cce) {
    var target = blob.l + length;
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    var rgcb;
    if (target !== blob.l) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, target - blob.l, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.198.118 TODO */ function $a1a91b25d7598376$var$parse_SharedParsedFormula(blob, length, opts) {
    var target = blob.l + length;
    var rgcb, cce = blob.read_shift(2); // length of rgce
    var rgce = $a1a91b25d7598376$var$parse_Rgce(blob, cce, opts);
    if (cce == 0xFFFF) return [
        [],
        $a1a91b25d7598376$var$parsenoop(blob, length - 2)
    ];
    if (length !== cce + 2) rgcb = $a1a91b25d7598376$var$parse_RgbExtra(blob, target - cce - 2, rgce, opts);
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLS] 2.5.133 TODO: how to emit empty strings? */ function $a1a91b25d7598376$var$parse_FormulaValue(blob /*::, length*/ ) {
    var b;
    if ($a1a91b25d7598376$var$__readUInt16LE(blob, blob.l + 6) !== 0xFFFF) return [
        $a1a91b25d7598376$var$parse_Xnum(blob),
        'n'
    ];
    switch(blob[blob.l]){
        case 0x00:
            blob.l += 8;
            return [
                "String",
                's'
            ];
        case 0x01:
            b = blob[blob.l + 2] === 0x1;
            blob.l += 8;
            return [
                b,
                'b'
            ];
        case 0x02:
            b = blob[blob.l + 2];
            blob.l += 8;
            return [
                b,
                'e'
            ];
        case 0x03:
            blob.l += 8;
            return [
                "",
                's'
            ];
    }
    return [];
}
function $a1a91b25d7598376$var$write_FormulaValue(value) {
    if (value == null) {
        // Blank String Value
        var o = $a1a91b25d7598376$var$new_buf(8);
        o.write_shift(1, 0x03);
        o.write_shift(1, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0);
        o.write_shift(2, 0xFFFF);
        return o;
    } else if (typeof value == "number") return $a1a91b25d7598376$var$write_Xnum(value);
    return $a1a91b25d7598376$var$write_Xnum(0);
}
/* [MS-XLS] 2.4.127 TODO */ function $a1a91b25d7598376$var$parse_Formula(blob, length, opts) {
    var end = blob.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSCell(blob, 6, opts);
    var val1 = $a1a91b25d7598376$var$parse_FormulaValue(blob, 8);
    var flags = blob.read_shift(1);
    if (opts.biff != 2) {
        blob.read_shift(1);
        if (opts.biff >= 5) /*var chn = */ blob.read_shift(4);
    }
    var cbf = $a1a91b25d7598376$var$parse_XLSCellParsedFormula(blob, end - blob.l, opts);
    return {
        cell: cell,
        val: val1[0],
        formula: cbf,
        shared: flags >> 3 & 1,
        tt: val1[1]
    };
}
function $a1a91b25d7598376$var$write_Formula(cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, os /*:number*/ ) {
    // Cell
    var o1 = $a1a91b25d7598376$var$write_XLSCell(R, C, os);
    // FormulaValue
    var o2 = $a1a91b25d7598376$var$write_FormulaValue(cell.v);
    // flags + cache
    var o3 = $a1a91b25d7598376$var$new_buf(6);
    var flags = 33;
    o3.write_shift(2, flags);
    o3.write_shift(4, 0);
    // CellParsedFormula
    var bf = $a1a91b25d7598376$var$new_buf(cell.bf.length);
    for(var i = 0; i < cell.bf.length; ++i)bf[i] = cell.bf[i];
    var out = $a1a91b25d7598376$var$bconcat([
        o1,
        o2,
        o3,
        bf
    ]);
    return out;
}
/* XLSB Parsed Formula records have the same shape */ function $a1a91b25d7598376$var$parse_XLSBParsedFormula(data, length, opts) {
    var cce = data.read_shift(4);
    var rgce = $a1a91b25d7598376$var$parse_Rgce(data, cce, opts);
    var cb = data.read_shift(4);
    var rgcb = cb > 0 ? $a1a91b25d7598376$var$parse_RgbExtra(data, cb, rgce, opts) : null;
    return [
        rgce,
        rgcb
    ];
}
/* [MS-XLSB] 2.5.97.1 ArrayParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBArrayParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.4 CellParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBCellParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.8 DVParsedFormula */ //var parse_XLSBDVParsedFormula = parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.9 FRTParsedFormula */ //var parse_XLSBFRTParsedFormula = parse_XLSBParsedFormula2;
/* [MS-XLSB] 2.5.97.12 NameParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBNameParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* [MS-XLSB] 2.5.97.98 SharedParsedFormula */ var $a1a91b25d7598376$var$parse_XLSBSharedParsedFormula = $a1a91b25d7598376$var$parse_XLSBParsedFormula;
/* Writes a PtgNum or PtgInt */ function $a1a91b25d7598376$var$write_XLSBFormulaNum(val1 /*:number*/ ) {
    if ((val1 | 0) == val1 && val1 < Math.pow(2, 16) && val1 >= 0) {
        var oint = $a1a91b25d7598376$var$new_buf(11);
        oint.write_shift(4, 3);
        oint.write_shift(1, 0x1e);
        oint.write_shift(2, val1);
        oint.write_shift(4, 0);
        return oint;
    }
    var num = $a1a91b25d7598376$var$new_buf(17);
    num.write_shift(4, 11);
    num.write_shift(1, 0x1f);
    num.write_shift(8, val1);
    num.write_shift(4, 0);
    return num;
}
/* Writes a PtgErr */ function $a1a91b25d7598376$var$write_XLSBFormulaErr(val1 /*:number*/ ) {
    var oint = $a1a91b25d7598376$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1C);
    oint.write_shift(1, val1);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgBool */ function $a1a91b25d7598376$var$write_XLSBFormulaBool(val1 /*:boolean*/ ) {
    var oint = $a1a91b25d7598376$var$new_buf(10);
    oint.write_shift(4, 2);
    oint.write_shift(1, 0x1D);
    oint.write_shift(1, val1 ? 1 : 0);
    oint.write_shift(4, 0);
    return oint;
}
/* Writes a PtgStr */ function $a1a91b25d7598376$var$write_XLSBFormulaStr(val1 /*:string*/ ) {
    var preamble = $a1a91b25d7598376$var$new_buf(7);
    preamble.write_shift(4, 3 + 2 * val1.length);
    preamble.write_shift(1, 0x17);
    preamble.write_shift(2, val1.length);
    var body = $a1a91b25d7598376$var$new_buf(2 * val1.length);
    body.write_shift(2 * val1.length, val1, "utf16le");
    var postamble = $a1a91b25d7598376$var$new_buf(4);
    postamble.write_shift(4, 0);
    return $a1a91b25d7598376$var$bconcat([
        preamble,
        body,
        postamble
    ]);
}
/* Writes a PtgRef */ function $a1a91b25d7598376$var$write_XLSBFormulaRef(str) {
    var cell = $a1a91b25d7598376$var$decode_cell(str);
    var out = $a1a91b25d7598376$var$new_buf(15);
    out.write_shift(4, 7);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRef3d */ function $a1a91b25d7598376$var$write_XLSBFormulaRef3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    var cell = $a1a91b25d7598376$var$decode_cell(str);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $a1a91b25d7598376$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a PtgRefErr3d */ function $a1a91b25d7598376$var$write_XLSBFormulaRefErr3D(str, wb) {
    var lastbang = str.lastIndexOf("!");
    var sname = str.slice(0, lastbang);
    str = str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var out = $a1a91b25d7598376$var$new_buf(17);
    out.write_shift(4, 9);
    out.write_shift(1, 60);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, 0);
    out.write_shift(2, 0); // <== ColRelShort
    out.write_shift(4, 0);
    return out;
}
/* Writes a single sheet range [PtgRef PtgRef PtgRange] */ function $a1a91b25d7598376$var$write_XLSBFormulaRange(_str) {
    var parts = _str.split(":"), str = parts[0];
    var out = $a1a91b25d7598376$var$new_buf(23);
    out.write_shift(4, 15);
    /* start cell */ str = parts[0];
    var cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* end cell */ str = parts[1];
    cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 36);
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    out.write_shift(4, 0);
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgRef3D PtgRef3D PtgRange] */ function $a1a91b25d7598376$var$write_XLSBFormulaRangeWS(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var parts = _str.split(":");
    var out = $a1a91b25d7598376$var$new_buf(27);
    out.write_shift(4, 19);
    /* start cell */ var str = parts[0], cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* end cell */ str = parts[1];
    cell = $a1a91b25d7598376$var$decode_cell(str);
    out.write_shift(1, 58);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, cell.r);
    out.write_shift(2, cell.c | (str.charAt(0) == "$" ? 0 : 1) << 14 | (str.match(/\$\d/) ? 0 : 1) << 15); // <== ColRelShort
    /* PtgRange */ out.write_shift(1, 0x11);
    out.write_shift(4, 0);
    return out;
}
/* Writes a range with explicit sheet name [PtgArea3d] */ function $a1a91b25d7598376$var$write_XLSBFormulaArea3D(_str, wb) {
    var lastbang = _str.lastIndexOf("!");
    var sname = _str.slice(0, lastbang);
    _str = _str.slice(lastbang + 1);
    if (sname.charAt(0) == "'") sname = sname.slice(1, -1).replace(/''/g, "'");
    var range = $a1a91b25d7598376$var$decode_range(_str);
    var out = $a1a91b25d7598376$var$new_buf(23);
    out.write_shift(4, 15);
    out.write_shift(1, 59);
    out.write_shift(2, 2 + wb.SheetNames.map(function(n) {
        return n.toLowerCase();
    }).indexOf(sname.toLowerCase()));
    out.write_shift(4, range.s.r);
    out.write_shift(4, range.e.r);
    out.write_shift(2, range.s.c);
    out.write_shift(2, range.e.c);
    out.write_shift(4, 0);
    return out;
}
/* General Formula */ function $a1a91b25d7598376$var$write_XLSBFormula(val1 /*:string|number*/ , wb) {
    if (typeof val1 == "number") return $a1a91b25d7598376$var$write_XLSBFormulaNum(val1);
    if (typeof val1 == "boolean") return $a1a91b25d7598376$var$write_XLSBFormulaBool(val1);
    if (/^#(DIV\/0!|GETTING_DATA|N\/A|NAME\?|NULL!|NUM!|REF!|VALUE!)$/.test(val1)) return $a1a91b25d7598376$var$write_XLSBFormulaErr(+$a1a91b25d7598376$var$RBErr[val1]);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRef(val1);
    if (val1.match(/^\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRange(val1);
    if (val1.match(/^#REF!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaArea3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRef3D(val1, wb);
    if (val1.match(/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5}):\$?(?:[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D]|[A-Z]{1,2})\$?(?:10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})$/)) return $a1a91b25d7598376$var$write_XLSBFormulaRangeWS(val1, wb);
    if (/^(?:'[^\\\/?*\[\]:]*'|[^'][^\\\/?*\[\]:'`~!@#$%^()\-=+{}|;,<.>]*)!#REF!$/.test(val1)) return $a1a91b25d7598376$var$write_XLSBFormulaRefErr3D(val1, wb);
    if (/^".*"$/.test(val1)) return $a1a91b25d7598376$var$write_XLSBFormulaStr(val1);
    if (/^[+-]\d+$/.test(val1)) return $a1a91b25d7598376$var$write_XLSBFormulaNum(parseInt(val1, 10));
    throw "Formula |" + val1 + "| not supported for XLSB";
}
var $a1a91b25d7598376$var$write_XLSBNameParsedFormula = $a1a91b25d7598376$var$write_XLSBFormula;
var $a1a91b25d7598376$var$Cetab = {
    0: "BEEP",
    1: "OPEN",
    2: "OPEN.LINKS",
    3: "CLOSE.ALL",
    4: "SAVE",
    5: "SAVE.AS",
    6: "FILE.DELETE",
    7: "PAGE.SETUP",
    8: "PRINT",
    9: "PRINTER.SETUP",
    10: "QUIT",
    11: "NEW.WINDOW",
    12: "ARRANGE.ALL",
    13: "WINDOW.SIZE",
    14: "WINDOW.MOVE",
    15: "FULL",
    16: "CLOSE",
    17: "RUN",
    22: "SET.PRINT.AREA",
    23: "SET.PRINT.TITLES",
    24: "SET.PAGE.BREAK",
    25: "REMOVE.PAGE.BREAK",
    26: "FONT",
    27: "DISPLAY",
    28: "PROTECT.DOCUMENT",
    29: "PRECISION",
    30: "A1.R1C1",
    31: "CALCULATE.NOW",
    32: "CALCULATION",
    34: "DATA.FIND",
    35: "EXTRACT",
    36: "DATA.DELETE",
    37: "SET.DATABASE",
    38: "SET.CRITERIA",
    39: "SORT",
    40: "DATA.SERIES",
    41: "TABLE",
    42: "FORMAT.NUMBER",
    43: "ALIGNMENT",
    44: "STYLE",
    45: "BORDER",
    46: "CELL.PROTECTION",
    47: "COLUMN.WIDTH",
    48: "UNDO",
    49: "CUT",
    50: "COPY",
    51: "PASTE",
    52: "CLEAR",
    53: "PASTE.SPECIAL",
    54: "EDIT.DELETE",
    55: "INSERT",
    56: "FILL.RIGHT",
    57: "FILL.DOWN",
    61: "DEFINE.NAME",
    62: "CREATE.NAMES",
    63: "FORMULA.GOTO",
    64: "FORMULA.FIND",
    65: "SELECT.LAST.CELL",
    66: "SHOW.ACTIVE.CELL",
    67: "GALLERY.AREA",
    68: "GALLERY.BAR",
    69: "GALLERY.COLUMN",
    70: "GALLERY.LINE",
    71: "GALLERY.PIE",
    72: "GALLERY.SCATTER",
    73: "COMBINATION",
    74: "PREFERRED",
    75: "ADD.OVERLAY",
    76: "GRIDLINES",
    77: "SET.PREFERRED",
    78: "AXES",
    79: "LEGEND",
    80: "ATTACH.TEXT",
    81: "ADD.ARROW",
    82: "SELECT.CHART",
    83: "SELECT.PLOT.AREA",
    84: "PATTERNS",
    85: "MAIN.CHART",
    86: "OVERLAY",
    87: "SCALE",
    88: "FORMAT.LEGEND",
    89: "FORMAT.TEXT",
    90: "EDIT.REPEAT",
    91: "PARSE",
    92: "JUSTIFY",
    93: "HIDE",
    94: "UNHIDE",
    95: "WORKSPACE",
    96: "FORMULA",
    97: "FORMULA.FILL",
    98: "FORMULA.ARRAY",
    99: "DATA.FIND.NEXT",
    100: "DATA.FIND.PREV",
    101: "FORMULA.FIND.NEXT",
    102: "FORMULA.FIND.PREV",
    103: "ACTIVATE",
    104: "ACTIVATE.NEXT",
    105: "ACTIVATE.PREV",
    106: "UNLOCKED.NEXT",
    107: "UNLOCKED.PREV",
    108: "COPY.PICTURE",
    109: "SELECT",
    110: "DELETE.NAME",
    111: "DELETE.FORMAT",
    112: "VLINE",
    113: "HLINE",
    114: "VPAGE",
    115: "HPAGE",
    116: "VSCROLL",
    117: "HSCROLL",
    118: "ALERT",
    119: "NEW",
    120: "CANCEL.COPY",
    121: "SHOW.CLIPBOARD",
    122: "MESSAGE",
    124: "PASTE.LINK",
    125: "APP.ACTIVATE",
    126: "DELETE.ARROW",
    127: "ROW.HEIGHT",
    128: "FORMAT.MOVE",
    129: "FORMAT.SIZE",
    130: "FORMULA.REPLACE",
    131: "SEND.KEYS",
    132: "SELECT.SPECIAL",
    133: "APPLY.NAMES",
    134: "REPLACE.FONT",
    135: "FREEZE.PANES",
    136: "SHOW.INFO",
    137: "SPLIT",
    138: "ON.WINDOW",
    139: "ON.DATA",
    140: "DISABLE.INPUT",
    142: "OUTLINE",
    143: "LIST.NAMES",
    144: "FILE.CLOSE",
    145: "SAVE.WORKBOOK",
    146: "DATA.FORM",
    147: "COPY.CHART",
    148: "ON.TIME",
    149: "WAIT",
    150: "FORMAT.FONT",
    151: "FILL.UP",
    152: "FILL.LEFT",
    153: "DELETE.OVERLAY",
    155: "SHORT.MENUS",
    159: "SET.UPDATE.STATUS",
    161: "COLOR.PALETTE",
    162: "DELETE.STYLE",
    163: "WINDOW.RESTORE",
    164: "WINDOW.MAXIMIZE",
    166: "CHANGE.LINK",
    167: "CALCULATE.DOCUMENT",
    168: "ON.KEY",
    169: "APP.RESTORE",
    170: "APP.MOVE",
    171: "APP.SIZE",
    172: "APP.MINIMIZE",
    173: "APP.MAXIMIZE",
    174: "BRING.TO.FRONT",
    175: "SEND.TO.BACK",
    185: "MAIN.CHART.TYPE",
    186: "OVERLAY.CHART.TYPE",
    187: "SELECT.END",
    188: "OPEN.MAIL",
    189: "SEND.MAIL",
    190: "STANDARD.FONT",
    191: "CONSOLIDATE",
    192: "SORT.SPECIAL",
    193: "GALLERY.3D.AREA",
    194: "GALLERY.3D.COLUMN",
    195: "GALLERY.3D.LINE",
    196: "GALLERY.3D.PIE",
    197: "VIEW.3D",
    198: "GOAL.SEEK",
    199: "WORKGROUP",
    200: "FILL.GROUP",
    201: "UPDATE.LINK",
    202: "PROMOTE",
    203: "DEMOTE",
    204: "SHOW.DETAIL",
    206: "UNGROUP",
    207: "OBJECT.PROPERTIES",
    208: "SAVE.NEW.OBJECT",
    209: "SHARE",
    210: "SHARE.NAME",
    211: "DUPLICATE",
    212: "APPLY.STYLE",
    213: "ASSIGN.TO.OBJECT",
    214: "OBJECT.PROTECTION",
    215: "HIDE.OBJECT",
    216: "SET.EXTRACT",
    217: "CREATE.PUBLISHER",
    218: "SUBSCRIBE.TO",
    219: "ATTRIBUTES",
    220: "SHOW.TOOLBAR",
    222: "PRINT.PREVIEW",
    223: "EDIT.COLOR",
    224: "SHOW.LEVELS",
    225: "FORMAT.MAIN",
    226: "FORMAT.OVERLAY",
    227: "ON.RECALC",
    228: "EDIT.SERIES",
    229: "DEFINE.STYLE",
    240: "LINE.PRINT",
    243: "ENTER.DATA",
    249: "GALLERY.RADAR",
    250: "MERGE.STYLES",
    251: "EDITION.OPTIONS",
    252: "PASTE.PICTURE",
    253: "PASTE.PICTURE.LINK",
    254: "SPELLING",
    256: "ZOOM",
    259: "INSERT.OBJECT",
    260: "WINDOW.MINIMIZE",
    265: "SOUND.NOTE",
    266: "SOUND.PLAY",
    267: "FORMAT.SHAPE",
    268: "EXTEND.POLYGON",
    269: "FORMAT.AUTO",
    272: "GALLERY.3D.BAR",
    273: "GALLERY.3D.SURFACE",
    274: "FILL.AUTO",
    276: "CUSTOMIZE.TOOLBAR",
    277: "ADD.TOOL",
    278: "EDIT.OBJECT",
    279: "ON.DOUBLECLICK",
    280: "ON.ENTRY",
    281: "WORKBOOK.ADD",
    282: "WORKBOOK.MOVE",
    283: "WORKBOOK.COPY",
    284: "WORKBOOK.OPTIONS",
    285: "SAVE.WORKSPACE",
    288: "CHART.WIZARD",
    289: "DELETE.TOOL",
    290: "MOVE.TOOL",
    291: "WORKBOOK.SELECT",
    292: "WORKBOOK.ACTIVATE",
    293: "ASSIGN.TO.TOOL",
    295: "COPY.TOOL",
    296: "RESET.TOOL",
    297: "CONSTRAIN.NUMERIC",
    298: "PASTE.TOOL",
    302: "WORKBOOK.NEW",
    305: "SCENARIO.CELLS",
    306: "SCENARIO.DELETE",
    307: "SCENARIO.ADD",
    308: "SCENARIO.EDIT",
    309: "SCENARIO.SHOW",
    310: "SCENARIO.SHOW.NEXT",
    311: "SCENARIO.SUMMARY",
    312: "PIVOT.TABLE.WIZARD",
    313: "PIVOT.FIELD.PROPERTIES",
    314: "PIVOT.FIELD",
    315: "PIVOT.ITEM",
    316: "PIVOT.ADD.FIELDS",
    318: "OPTIONS.CALCULATION",
    319: "OPTIONS.EDIT",
    320: "OPTIONS.VIEW",
    321: "ADDIN.MANAGER",
    322: "MENU.EDITOR",
    323: "ATTACH.TOOLBARS",
    324: "VBAActivate",
    325: "OPTIONS.CHART",
    328: "VBA.INSERT.FILE",
    330: "VBA.PROCEDURE.DEFINITION",
    336: "ROUTING.SLIP",
    338: "ROUTE.DOCUMENT",
    339: "MAIL.LOGON",
    342: "INSERT.PICTURE",
    343: "EDIT.TOOL",
    344: "GALLERY.DOUGHNUT",
    350: "CHART.TREND",
    352: "PIVOT.ITEM.PROPERTIES",
    354: "WORKBOOK.INSERT",
    355: "OPTIONS.TRANSITION",
    356: "OPTIONS.GENERAL",
    370: "FILTER.ADVANCED",
    373: "MAIL.ADD.MAILER",
    374: "MAIL.DELETE.MAILER",
    375: "MAIL.REPLY",
    376: "MAIL.REPLY.ALL",
    377: "MAIL.FORWARD",
    378: "MAIL.NEXT.LETTER",
    379: "DATA.LABEL",
    380: "INSERT.TITLE",
    381: "FONT.PROPERTIES",
    382: "MACRO.OPTIONS",
    383: "WORKBOOK.HIDE",
    384: "WORKBOOK.UNHIDE",
    385: "WORKBOOK.DELETE",
    386: "WORKBOOK.NAME",
    388: "GALLERY.CUSTOM",
    390: "ADD.CHART.AUTOFORMAT",
    391: "DELETE.CHART.AUTOFORMAT",
    392: "CHART.ADD.DATA",
    393: "AUTO.OUTLINE",
    394: "TAB.ORDER",
    395: "SHOW.DIALOG",
    396: "SELECT.ALL",
    397: "UNGROUP.SHEETS",
    398: "SUBTOTAL.CREATE",
    399: "SUBTOTAL.REMOVE",
    400: "RENAME.OBJECT",
    412: "WORKBOOK.SCROLL",
    413: "WORKBOOK.NEXT",
    414: "WORKBOOK.PREV",
    415: "WORKBOOK.TAB.SPLIT",
    416: "FULL.SCREEN",
    417: "WORKBOOK.PROTECT",
    420: "SCROLLBAR.PROPERTIES",
    421: "PIVOT.SHOW.PAGES",
    422: "TEXT.TO.COLUMNS",
    423: "FORMAT.CHARTTYPE",
    424: "LINK.FORMAT",
    425: "TRACER.DISPLAY",
    430: "TRACER.NAVIGATE",
    431: "TRACER.CLEAR",
    432: "TRACER.ERROR",
    433: "PIVOT.FIELD.GROUP",
    434: "PIVOT.FIELD.UNGROUP",
    435: "CHECKBOX.PROPERTIES",
    436: "LABEL.PROPERTIES",
    437: "LISTBOX.PROPERTIES",
    438: "EDITBOX.PROPERTIES",
    439: "PIVOT.REFRESH",
    440: "LINK.COMBO",
    441: "OPEN.TEXT",
    442: "HIDE.DIALOG",
    443: "SET.DIALOG.FOCUS",
    444: "ENABLE.OBJECT",
    445: "PUSHBUTTON.PROPERTIES",
    446: "SET.DIALOG.DEFAULT",
    447: "FILTER",
    448: "FILTER.SHOW.ALL",
    449: "CLEAR.OUTLINE",
    450: "FUNCTION.WIZARD",
    451: "ADD.LIST.ITEM",
    452: "SET.LIST.ITEM",
    453: "REMOVE.LIST.ITEM",
    454: "SELECT.LIST.ITEM",
    455: "SET.CONTROL.VALUE",
    456: "SAVE.COPY.AS",
    458: "OPTIONS.LISTS.ADD",
    459: "OPTIONS.LISTS.DELETE",
    460: "SERIES.AXES",
    461: "SERIES.X",
    462: "SERIES.Y",
    463: "ERRORBAR.X",
    464: "ERRORBAR.Y",
    465: "FORMAT.CHART",
    466: "SERIES.ORDER",
    467: "MAIL.LOGOFF",
    468: "CLEAR.ROUTING.SLIP",
    469: "APP.ACTIVATE.MICROSOFT",
    470: "MAIL.EDIT.MAILER",
    471: "ON.SHEET",
    472: "STANDARD.WIDTH",
    473: "SCENARIO.MERGE",
    474: "SUMMARY.INFO",
    475: "FIND.FILE",
    476: "ACTIVE.CELL.FONT",
    477: "ENABLE.TIPWIZARD",
    478: "VBA.MAKE.ADDIN",
    480: "INSERTDATATABLE",
    481: "WORKGROUP.OPTIONS",
    482: "MAIL.SEND.MAILER",
    485: "AUTOCORRECT",
    489: "POST.DOCUMENT",
    491: "PICKLIST",
    493: "VIEW.SHOW",
    494: "VIEW.DEFINE",
    495: "VIEW.DELETE",
    509: "SHEET.BACKGROUND",
    510: "INSERT.MAP.OBJECT",
    511: "OPTIONS.MENONO",
    517: "MSOCHECKS",
    518: "NORMAL",
    519: "LAYOUT",
    520: "RM.PRINT.AREA",
    521: "CLEAR.PRINT.AREA",
    522: "ADD.PRINT.AREA",
    523: "MOVE.BRK",
    545: "HIDECURR.NOTE",
    546: "HIDEALL.NOTES",
    547: "DELETE.NOTE",
    548: "TRAVERSE.NOTES",
    549: "ACTIVATE.NOTES",
    620: "PROTECT.REVISIONS",
    621: "UNPROTECT.REVISIONS",
    647: "OPTIONS.ME",
    653: "WEB.PUBLISH",
    667: "NEWWEBQUERY",
    673: "PIVOT.TABLE.CHART",
    753: "OPTIONS.SAVE",
    755: "OPTIONS.SPELL",
    808: "HIDEALL.INKANNOTS"
};
var $a1a91b25d7598376$var$Ftab = {
    0: "COUNT",
    1: "IF",
    2: "ISNA",
    3: "ISERROR",
    4: "SUM",
    5: "AVERAGE",
    6: "MIN",
    7: "MAX",
    8: "ROW",
    9: "COLUMN",
    10: "NA",
    11: "NPV",
    12: "STDEV",
    13: "DOLLAR",
    14: "FIXED",
    15: "SIN",
    16: "COS",
    17: "TAN",
    18: "ATAN",
    19: "PI",
    20: "SQRT",
    21: "EXP",
    22: "LN",
    23: "LOG10",
    24: "ABS",
    25: "INT",
    26: "SIGN",
    27: "ROUND",
    28: "LOOKUP",
    29: "INDEX",
    30: "REPT",
    31: "MID",
    32: "LEN",
    33: "VALUE",
    34: "TRUE",
    35: "FALSE",
    36: "AND",
    37: "OR",
    38: "NOT",
    39: "MOD",
    40: "DCOUNT",
    41: "DSUM",
    42: "DAVERAGE",
    43: "DMIN",
    44: "DMAX",
    45: "DSTDEV",
    46: "VAR",
    47: "DVAR",
    48: "TEXT",
    49: "LINEST",
    50: "TREND",
    51: "LOGEST",
    52: "GROWTH",
    53: "GOTO",
    54: "HALT",
    55: "RETURN",
    56: "PV",
    57: "FV",
    58: "NPER",
    59: "PMT",
    60: "RATE",
    61: "MIRR",
    62: "IRR",
    63: "RAND",
    64: "MATCH",
    65: "DATE",
    66: "TIME",
    67: "DAY",
    68: "MONTH",
    69: "YEAR",
    70: "WEEKDAY",
    71: "HOUR",
    72: "MINUTE",
    73: "SECOND",
    74: "NOW",
    75: "AREAS",
    76: "ROWS",
    77: "COLUMNS",
    78: "OFFSET",
    79: "ABSREF",
    80: "RELREF",
    81: "ARGUMENT",
    82: "SEARCH",
    83: "TRANSPOSE",
    84: "ERROR",
    85: "STEP",
    86: "TYPE",
    87: "ECHO",
    88: "SET.NAME",
    89: "CALLER",
    90: "DEREF",
    91: "WINDOWS",
    92: "SERIES",
    93: "DOCUMENTS",
    94: "ACTIVE.CELL",
    95: "SELECTION",
    96: "RESULT",
    97: "ATAN2",
    98: "ASIN",
    99: "ACOS",
    100: "CHOOSE",
    101: "HLOOKUP",
    102: "VLOOKUP",
    103: "LINKS",
    104: "INPUT",
    105: "ISREF",
    106: "GET.FORMULA",
    107: "GET.NAME",
    108: "SET.VALUE",
    109: "LOG",
    110: "EXEC",
    111: "CHAR",
    112: "LOWER",
    113: "UPPER",
    114: "PROPER",
    115: "LEFT",
    116: "RIGHT",
    117: "EXACT",
    118: "TRIM",
    119: "REPLACE",
    120: "SUBSTITUTE",
    121: "CODE",
    122: "NAMES",
    123: "DIRECTORY",
    124: "FIND",
    125: "CELL",
    126: "ISERR",
    127: "ISTEXT",
    128: "ISNUMBER",
    129: "ISBLANK",
    130: "T",
    131: "N",
    132: "FOPEN",
    133: "FCLOSE",
    134: "FSIZE",
    135: "FREADLN",
    136: "FREAD",
    137: "FWRITELN",
    138: "FWRITE",
    139: "FPOS",
    140: "DATEVALUE",
    141: "TIMEVALUE",
    142: "SLN",
    143: "SYD",
    144: "DDB",
    145: "GET.DEF",
    146: "REFTEXT",
    147: "TEXTREF",
    148: "INDIRECT",
    149: "REGISTER",
    150: "CALL",
    151: "ADD.BAR",
    152: "ADD.MENU",
    153: "ADD.COMMAND",
    154: "ENABLE.COMMAND",
    155: "CHECK.COMMAND",
    156: "RENAME.COMMAND",
    157: "SHOW.BAR",
    158: "DELETE.MENU",
    159: "DELETE.COMMAND",
    160: "GET.CHART.ITEM",
    161: "DIALOG.BOX",
    162: "CLEAN",
    163: "MDETERM",
    164: "MINVERSE",
    165: "MMULT",
    166: "FILES",
    167: "IPMT",
    168: "PPMT",
    169: "COUNTA",
    170: "CANCEL.KEY",
    171: "FOR",
    172: "WHILE",
    173: "BREAK",
    174: "NEXT",
    175: "INITIATE",
    176: "REQUEST",
    177: "POKE",
    178: "EXECUTE",
    179: "TERMINATE",
    180: "RESTART",
    181: "HELP",
    182: "GET.BAR",
    183: "PRODUCT",
    184: "FACT",
    185: "GET.CELL",
    186: "GET.WORKSPACE",
    187: "GET.WINDOW",
    188: "GET.DOCUMENT",
    189: "DPRODUCT",
    190: "ISNONTEXT",
    191: "GET.NOTE",
    192: "NOTE",
    193: "STDEVP",
    194: "VARP",
    195: "DSTDEVP",
    196: "DVARP",
    197: "TRUNC",
    198: "ISLOGICAL",
    199: "DCOUNTA",
    200: "DELETE.BAR",
    201: "UNREGISTER",
    204: "USDOLLAR",
    205: "FINDB",
    206: "SEARCHB",
    207: "REPLACEB",
    208: "LEFTB",
    209: "RIGHTB",
    210: "MIDB",
    211: "LENB",
    212: "ROUNDUP",
    213: "ROUNDDOWN",
    214: "ASC",
    215: "DBCS",
    216: "RANK",
    219: "ADDRESS",
    220: "DAYS360",
    221: "TODAY",
    222: "VDB",
    223: "ELSE",
    224: "ELSE.IF",
    225: "END.IF",
    226: "FOR.CELL",
    227: "MEDIAN",
    228: "SUMPRODUCT",
    229: "SINH",
    230: "COSH",
    231: "TANH",
    232: "ASINH",
    233: "ACOSH",
    234: "ATANH",
    235: "DGET",
    236: "CREATE.OBJECT",
    237: "VOLATILE",
    238: "LAST.ERROR",
    239: "CUSTOM.UNDO",
    240: "CUSTOM.REPEAT",
    241: "FORMULA.CONVERT",
    242: "GET.LINK.INFO",
    243: "TEXT.BOX",
    244: "INFO",
    245: "GROUP",
    246: "GET.OBJECT",
    247: "DB",
    248: "PAUSE",
    251: "RESUME",
    252: "FREQUENCY",
    253: "ADD.TOOLBAR",
    254: "DELETE.TOOLBAR",
    255: "User",
    256: "RESET.TOOLBAR",
    257: "EVALUATE",
    258: "GET.TOOLBAR",
    259: "GET.TOOL",
    260: "SPELLING.CHECK",
    261: "ERROR.TYPE",
    262: "APP.TITLE",
    263: "WINDOW.TITLE",
    264: "SAVE.TOOLBAR",
    265: "ENABLE.TOOL",
    266: "PRESS.TOOL",
    267: "REGISTER.ID",
    268: "GET.WORKBOOK",
    269: "AVEDEV",
    270: "BETADIST",
    271: "GAMMALN",
    272: "BETAINV",
    273: "BINOMDIST",
    274: "CHIDIST",
    275: "CHIINV",
    276: "COMBIN",
    277: "CONFIDENCE",
    278: "CRITBINOM",
    279: "EVEN",
    280: "EXPONDIST",
    281: "FDIST",
    282: "FINV",
    283: "FISHER",
    284: "FISHERINV",
    285: "FLOOR",
    286: "GAMMADIST",
    287: "GAMMAINV",
    288: "CEILING",
    289: "HYPGEOMDIST",
    290: "LOGNORMDIST",
    291: "LOGINV",
    292: "NEGBINOMDIST",
    293: "NORMDIST",
    294: "NORMSDIST",
    295: "NORMINV",
    296: "NORMSINV",
    297: "STANDARDIZE",
    298: "ODD",
    299: "PERMUT",
    300: "POISSON",
    301: "TDIST",
    302: "WEIBULL",
    303: "SUMXMY2",
    304: "SUMX2MY2",
    305: "SUMX2PY2",
    306: "CHITEST",
    307: "CORREL",
    308: "COVAR",
    309: "FORECAST",
    310: "FTEST",
    311: "INTERCEPT",
    312: "PEARSON",
    313: "RSQ",
    314: "STEYX",
    315: "SLOPE",
    316: "TTEST",
    317: "PROB",
    318: "DEVSQ",
    319: "GEOMEAN",
    320: "HARMEAN",
    321: "SUMSQ",
    322: "KURT",
    323: "SKEW",
    324: "ZTEST",
    325: "LARGE",
    326: "SMALL",
    327: "QUARTILE",
    328: "PERCENTILE",
    329: "PERCENTRANK",
    330: "MODE",
    331: "TRIMMEAN",
    332: "TINV",
    334: "MOVIE.COMMAND",
    335: "GET.MOVIE",
    336: "CONCATENATE",
    337: "POWER",
    338: "PIVOT.ADD.DATA",
    339: "GET.PIVOT.TABLE",
    340: "GET.PIVOT.FIELD",
    341: "GET.PIVOT.ITEM",
    342: "RADIANS",
    343: "DEGREES",
    344: "SUBTOTAL",
    345: "SUMIF",
    346: "COUNTIF",
    347: "COUNTBLANK",
    348: "SCENARIO.GET",
    349: "OPTIONS.LISTS.GET",
    350: "ISPMT",
    351: "DATEDIF",
    352: "DATESTRING",
    353: "NUMBERSTRING",
    354: "ROMAN",
    355: "OPEN.DIALOG",
    356: "SAVE.DIALOG",
    357: "VIEW.GET",
    358: "GETPIVOTDATA",
    359: "HYPERLINK",
    360: "PHONETIC",
    361: "AVERAGEA",
    362: "MAXA",
    363: "MINA",
    364: "STDEVPA",
    365: "VARPA",
    366: "STDEVA",
    367: "VARA",
    368: "BAHTTEXT",
    369: "THAIDAYOFWEEK",
    370: "THAIDIGIT",
    371: "THAIMONTHOFYEAR",
    372: "THAINUMSOUND",
    373: "THAINUMSTRING",
    374: "THAISTRINGLENGTH",
    375: "ISTHAIDIGIT",
    376: "ROUNDBAHTDOWN",
    377: "ROUNDBAHTUP",
    378: "THAIYEAR",
    379: "RTD",
    380: "CUBEVALUE",
    381: "CUBEMEMBER",
    382: "CUBEMEMBERPROPERTY",
    383: "CUBERANKEDMEMBER",
    384: "HEX2BIN",
    385: "HEX2DEC",
    386: "HEX2OCT",
    387: "DEC2BIN",
    388: "DEC2HEX",
    389: "DEC2OCT",
    390: "OCT2BIN",
    391: "OCT2HEX",
    392: "OCT2DEC",
    393: "BIN2DEC",
    394: "BIN2OCT",
    395: "BIN2HEX",
    396: "IMSUB",
    397: "IMDIV",
    398: "IMPOWER",
    399: "IMABS",
    400: "IMSQRT",
    401: "IMLN",
    402: "IMLOG2",
    403: "IMLOG10",
    404: "IMSIN",
    405: "IMCOS",
    406: "IMEXP",
    407: "IMARGUMENT",
    408: "IMCONJUGATE",
    409: "IMAGINARY",
    410: "IMREAL",
    411: "COMPLEX",
    412: "IMSUM",
    413: "IMPRODUCT",
    414: "SERIESSUM",
    415: "FACTDOUBLE",
    416: "SQRTPI",
    417: "QUOTIENT",
    418: "DELTA",
    419: "GESTEP",
    420: "ISEVEN",
    421: "ISODD",
    422: "MROUND",
    423: "ERF",
    424: "ERFC",
    425: "BESSELJ",
    426: "BESSELK",
    427: "BESSELY",
    428: "BESSELI",
    429: "XIRR",
    430: "XNPV",
    431: "PRICEMAT",
    432: "YIELDMAT",
    433: "INTRATE",
    434: "RECEIVED",
    435: "DISC",
    436: "PRICEDISC",
    437: "YIELDDISC",
    438: "TBILLEQ",
    439: "TBILLPRICE",
    440: "TBILLYIELD",
    441: "PRICE",
    442: "YIELD",
    443: "DOLLARDE",
    444: "DOLLARFR",
    445: "NOMINAL",
    446: "EFFECT",
    447: "CUMPRINC",
    448: "CUMIPMT",
    449: "EDATE",
    450: "EOMONTH",
    451: "YEARFRAC",
    452: "COUPDAYBS",
    453: "COUPDAYS",
    454: "COUPDAYSNC",
    455: "COUPNCD",
    456: "COUPNUM",
    457: "COUPPCD",
    458: "DURATION",
    459: "MDURATION",
    460: "ODDLPRICE",
    461: "ODDLYIELD",
    462: "ODDFPRICE",
    463: "ODDFYIELD",
    464: "RANDBETWEEN",
    465: "WEEKNUM",
    466: "AMORDEGRC",
    467: "AMORLINC",
    468: "CONVERT",
    724: "SHEETJS",
    469: "ACCRINT",
    470: "ACCRINTM",
    471: "WORKDAY",
    472: "NETWORKDAYS",
    473: "GCD",
    474: "MULTINOMIAL",
    475: "LCM",
    476: "FVSCHEDULE",
    477: "CUBEKPIMEMBER",
    478: "CUBESET",
    479: "CUBESETCOUNT",
    480: "IFERROR",
    481: "COUNTIFS",
    482: "SUMIFS",
    483: "AVERAGEIF",
    484: "AVERAGEIFS"
};
var $a1a91b25d7598376$var$FtabArgc = {
    2: 1,
    3: 1,
    10: 0,
    15: 1,
    16: 1,
    17: 1,
    18: 1,
    19: 0,
    20: 1,
    21: 1,
    22: 1,
    23: 1,
    24: 1,
    25: 1,
    26: 1,
    27: 2,
    30: 2,
    31: 3,
    32: 1,
    33: 1,
    34: 0,
    35: 0,
    38: 1,
    39: 2,
    40: 3,
    41: 3,
    42: 3,
    43: 3,
    44: 3,
    45: 3,
    47: 3,
    48: 2,
    53: 1,
    61: 3,
    63: 0,
    65: 3,
    66: 3,
    67: 1,
    68: 1,
    69: 1,
    70: 1,
    71: 1,
    72: 1,
    73: 1,
    74: 0,
    75: 1,
    76: 1,
    77: 1,
    79: 2,
    80: 2,
    83: 1,
    85: 0,
    86: 1,
    89: 0,
    90: 1,
    94: 0,
    95: 0,
    97: 2,
    98: 1,
    99: 1,
    101: 3,
    102: 3,
    105: 1,
    106: 1,
    108: 2,
    111: 1,
    112: 1,
    113: 1,
    114: 1,
    117: 2,
    118: 1,
    119: 4,
    121: 1,
    126: 1,
    127: 1,
    128: 1,
    129: 1,
    130: 1,
    131: 1,
    133: 1,
    134: 1,
    135: 1,
    136: 2,
    137: 2,
    138: 2,
    140: 1,
    141: 1,
    142: 3,
    143: 4,
    144: 4,
    161: 1,
    162: 1,
    163: 1,
    164: 1,
    165: 2,
    172: 1,
    175: 2,
    176: 2,
    177: 3,
    178: 2,
    179: 1,
    184: 1,
    186: 1,
    189: 3,
    190: 1,
    195: 3,
    196: 3,
    197: 1,
    198: 1,
    199: 3,
    201: 1,
    207: 4,
    210: 3,
    211: 1,
    212: 2,
    213: 2,
    214: 1,
    215: 1,
    225: 0,
    229: 1,
    230: 1,
    231: 1,
    232: 1,
    233: 1,
    234: 1,
    235: 3,
    244: 1,
    247: 4,
    252: 2,
    257: 1,
    261: 1,
    271: 1,
    273: 4,
    274: 2,
    275: 2,
    276: 2,
    277: 3,
    278: 3,
    279: 1,
    280: 3,
    281: 3,
    282: 3,
    283: 1,
    284: 1,
    285: 2,
    286: 4,
    287: 3,
    288: 2,
    289: 4,
    290: 3,
    291: 3,
    292: 3,
    293: 4,
    294: 1,
    295: 3,
    296: 1,
    297: 3,
    298: 1,
    299: 2,
    300: 3,
    301: 3,
    302: 4,
    303: 2,
    304: 2,
    305: 2,
    306: 2,
    307: 2,
    308: 2,
    309: 3,
    310: 2,
    311: 2,
    312: 2,
    313: 2,
    314: 2,
    315: 2,
    316: 4,
    325: 2,
    326: 2,
    327: 2,
    328: 2,
    331: 2,
    332: 2,
    337: 2,
    342: 1,
    343: 1,
    346: 2,
    347: 1,
    350: 4,
    351: 3,
    352: 1,
    353: 2,
    360: 1,
    368: 1,
    369: 1,
    370: 1,
    371: 1,
    372: 1,
    373: 1,
    374: 1,
    375: 1,
    376: 1,
    377: 1,
    378: 1,
    382: 3,
    385: 1,
    392: 1,
    393: 1,
    396: 2,
    397: 2,
    398: 2,
    399: 1,
    400: 1,
    401: 1,
    402: 1,
    403: 1,
    404: 1,
    405: 1,
    406: 1,
    407: 1,
    408: 1,
    409: 1,
    410: 1,
    414: 4,
    415: 1,
    416: 1,
    417: 2,
    420: 1,
    421: 1,
    422: 2,
    424: 1,
    425: 2,
    426: 2,
    427: 2,
    428: 2,
    430: 3,
    438: 3,
    439: 3,
    440: 3,
    443: 2,
    444: 2,
    445: 2,
    446: 2,
    447: 6,
    448: 6,
    449: 2,
    450: 2,
    464: 2,
    468: 3,
    476: 2,
    479: 1,
    480: 2,
    65535: 0
};
/* Part 3 TODO: actually parse formulae */ function $a1a91b25d7598376$var$ods_to_csf_formula(f /*:string*/ ) /*:string*/ {
    if (f.slice(0, 3) == "of:") f = f.slice(3);
    /* 5.2 Basic Expressions */ if (f.charCodeAt(0) == 61) {
        f = f.slice(1);
        if (f.charCodeAt(0) == 61) f = f.slice(1);
    }
    f = f.replace(/COM\.MICROSOFT\./g, "");
    /* Part 3 Section 5.8 References */ f = f.replace(/\[((?:\.[A-Z]+[0-9]+)(?::\.[A-Z]+[0-9]+)?)\]/g, function($$, $1) {
        return $1.replace(/\./g, "");
    });
    f = f.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    f = f.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    /* TODO: something other than this */ f = f.replace(/\[.(#[A-Z]*[?!])\]/g, "$1");
    return f.replace(/[;~]/g, ",").replace(/\|/g, ";");
}
function $a1a91b25d7598376$var$csf_to_ods_formula(f /*:string*/ ) /*:string*/ {
    var o = "of:=" + f.replace($a1a91b25d7598376$var$crefregex, "$1[.$2$3$4$5]").replace(/\]:\[/g, ":");
    /* TODO: something other than this */ return o.replace(/;/g, "|").replace(/,/g, ";");
}
function $a1a91b25d7598376$var$ods_to_csf_3D(r /*:string*/ ) /*:[string, string]*/ {
    r = r.replace(/\$'([^']|'')+'/g, function($$) {
        return $$.slice(1);
    });
    r = r.replace(/\$([^\]\. #$]+)/g, function($$, $1) {
        return $1.match(/^([A-Z]{1,2}|[A-W][A-Z]{2}|X[A-E][A-Z]|XF[A-D])?(10[0-3]\d{4}|104[0-7]\d{3}|1048[0-4]\d{2}|10485[0-6]\d|104857[0-6]|[1-9]\d{0,5})?$/) ? $$ : $1;
    });
    var a = r.split(":");
    var s = a[0].split(".")[0];
    return [
        s,
        a[0].split(".")[1] + (a.length > 1 ? ":" + (a[1].split(".")[1] || a[1].split(".")[0]) : "")
    ];
}
function $a1a91b25d7598376$var$csf_to_ods_3D(r /*:string*/ ) /*:string*/ {
    return r.replace(/!/, ".").replace(/:/, ":.");
}
var $a1a91b25d7598376$var$strs = {}; // shared strings
var $a1a91b25d7598376$var$_ssfopts = {}; // spreadsheet formatting options
/*global Map */ var $a1a91b25d7598376$var$browser_has_Map = typeof Map !== 'undefined';
function $a1a91b25d7598376$var$get_sst_id(sst /*:SST*/ , str /*:string*/ , rev) /*:number*/ {
    var i = 0, len = sst.length;
    if (rev) {
        if ($a1a91b25d7598376$var$browser_has_Map ? rev.has(str) : Object.prototype.hasOwnProperty.call(rev, str)) {
            var revarr = $a1a91b25d7598376$var$browser_has_Map ? rev.get(str) : rev[str];
            for(; i < revarr.length; ++i)if (sst[revarr[i]].t === str) {
                sst.Count++;
                return revarr[i];
            }
        }
    } else for(; i < len; ++i)if (sst[i].t === str) {
        sst.Count++;
        return i;
    }
    sst[len] = {
        t: str
    } /*:any*/ ;
    sst.Count++;
    sst.Unique++;
    if (rev) {
        if ($a1a91b25d7598376$var$browser_has_Map) {
            if (!rev.has(str)) rev.set(str, []);
            rev.get(str).push(len);
        } else {
            if (!Object.prototype.hasOwnProperty.call(rev, str)) rev[str] = [];
            rev[str].push(len);
        }
    }
    return len;
}
function $a1a91b25d7598376$var$col_obj_w(C /*:number*/ , col) {
    var p = {
        min: C + 1,
        max: C + 1
    } /*:any*/ ;
    /* wch (chars), wpx (pixels) */ var wch = -1;
    if (col.MDW) $a1a91b25d7598376$var$MDW = col.MDW;
    if (col.width != null) p.customWidth = 1;
    else if (col.wpx != null) wch = $a1a91b25d7598376$var$px2char(col.wpx);
    else if (col.wch != null) wch = col.wch;
    if (wch > -1) {
        p.width = $a1a91b25d7598376$var$char2width(wch);
        p.customWidth = 1;
    } else if (col.width != null) p.width = col.width;
    if (col.hidden) p.hidden = true;
    if (col.level != null) p.outlineLevel = p.level = col.level;
    return p;
}
function $a1a91b25d7598376$var$default_margins(margins /*:Margins*/ , mode /*:?string*/ ) {
    if (!margins) return;
    var defs = [
        0.7,
        0.7,
        0.75,
        0.75,
        0.3,
        0.3
    ];
    if (mode == 'xlml') defs = [
        1,
        1,
        1,
        1,
        0.5,
        0.5
    ];
    if (margins.left == null) margins.left = defs[0];
    if (margins.right == null) margins.right = defs[1];
    if (margins.top == null) margins.top = defs[2];
    if (margins.bottom == null) margins.bottom = defs[3];
    if (margins.header == null) margins.header = defs[4];
    if (margins.footer == null) margins.footer = defs[5];
}
function $a1a91b25d7598376$var$get_cell_style(styles /*:Array<any>*/ , cell /*:Cell*/ , opts) {
    var z = opts.revssf[cell.z != null ? cell.z : "General"];
    var i = 0x3c, len = styles.length;
    if (z == null && opts.ssf) {
        for(; i < 0x188; ++i)if (opts.ssf[i] == null) {
            $a1a91b25d7598376$var$SSF__load(cell.z, i);
            // $FlowIgnore
            opts.ssf[i] = cell.z;
            opts.revssf[cell.z] = z = i;
            break;
        }
    }
    for(i = 0; i != len; ++i)if (styles[i].numFmtId === z) return i;
    styles[len] = {
        numFmtId: z,
        fontId: 0,
        fillId: 0,
        borderId: 0,
        xfId: 0,
        applyNumberFormat: 1
    };
    return len;
}
function $a1a91b25d7598376$var$safe_format(p /*:Cell*/ , fmtid /*:number*/ , fillid /*:?number*/ , opts, themes, styles, date1904) {
    try {
        if (opts.cellNF) p.z = $a1a91b25d7598376$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (p.t === 'z' && !opts.cellStyles) return;
    if (p.t === 'd' && typeof p.v === 'string') p.v = $a1a91b25d7598376$var$parseDate(p.v);
    if ((!opts || opts.cellText !== false) && p.t !== 'z') try {
        if ($a1a91b25d7598376$var$table_fmt[fmtid] == null) $a1a91b25d7598376$var$SSF__load($a1a91b25d7598376$var$SSFImplicit[fmtid] || "General", fmtid);
        if (p.t === 'e') p.w = p.w || $a1a91b25d7598376$var$BErr[p.v];
        else if (fmtid === 0) {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $a1a91b25d7598376$var$SSF_general_num(p.v);
            } else if (p.t === 'd') {
                var dd = $a1a91b25d7598376$var$datenum(p.v, !!date1904);
                if ((dd | 0) === dd) p.w = dd.toString(10);
                else p.w = $a1a91b25d7598376$var$SSF_general_num(dd);
            } else if (p.v === undefined) return "";
            else p.w = $a1a91b25d7598376$var$SSF_general(p.v, $a1a91b25d7598376$var$_ssfopts);
        } else if (p.t === 'd') p.w = $a1a91b25d7598376$var$SSF_format(fmtid, $a1a91b25d7598376$var$datenum(p.v, !!date1904), $a1a91b25d7598376$var$_ssfopts);
        else p.w = $a1a91b25d7598376$var$SSF_format(fmtid, p.v, $a1a91b25d7598376$var$_ssfopts);
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts.cellStyles) return;
    if (fillid != null) try {
        p.s = styles.Fills[fillid];
        if (p.s.fgColor && p.s.fgColor.theme && !p.s.fgColor.rgb) {
            p.s.fgColor.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[p.s.fgColor.theme].rgb, p.s.fgColor.tint || 0);
            if (opts.WTF) p.s.fgColor.raw_rgb = themes.themeElements.clrScheme[p.s.fgColor.theme].rgb;
        }
        if (p.s.bgColor && p.s.bgColor.theme) {
            p.s.bgColor.rgb = $a1a91b25d7598376$var$rgb_tint(themes.themeElements.clrScheme[p.s.bgColor.theme].rgb, p.s.bgColor.tint || 0);
            if (opts.WTF) p.s.bgColor.raw_rgb = themes.themeElements.clrScheme[p.s.bgColor.theme].rgb;
        }
    } catch (e) {
        if (opts.WTF && styles.Fills) throw e;
    }
}
function $a1a91b25d7598376$var$check_ws(ws /*:Worksheet*/ , sname /*:string*/ , i /*:number*/ ) {
    if (ws && ws['!ref']) {
        var range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
        if (range.e.c < range.s.c || range.e.r < range.s.r) throw new Error("Bad range (" + i + "): " + ws['!ref']);
    }
}
function $a1a91b25d7598376$var$parse_ws_xml_dim(ws /*:Worksheet*/ , s /*:string*/ ) {
    var d = $a1a91b25d7598376$var$safe_decode_range(s);
    if (d.s.r <= d.e.r && d.s.c <= d.e.c && d.s.r >= 0 && d.s.c >= 0) ws["!ref"] = $a1a91b25d7598376$var$encode_range(d);
}
var $a1a91b25d7598376$var$mergecregex = /<(?:\w+:)?mergeCell ref=["'][A-Z0-9:]+['"]\s*[\/]?>/g;
var $a1a91b25d7598376$var$hlinkregex = /<(?:\w+:)?hyperlink [^<>]*>/mg;
var $a1a91b25d7598376$var$dimregex = /"(\w*:\w*)"/;
var $a1a91b25d7598376$var$colregex = /<(?:\w+:)?col\b[^<>]*[\/]?>/g;
var $a1a91b25d7598376$var$afregex = /<(?:\w+:)?autoFilter[^>]*/g;
var $a1a91b25d7598376$var$marginregex = /<(?:\w+:)?pageMargins[^<>]*\/>/g;
var $a1a91b25d7598376$var$sheetprregex = /<(?:\w+:)?sheetPr\b[^<>]*?\/>/;
/* 18.3 Worksheets */ function $a1a91b25d7598376$var$parse_ws_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    /* 18.3.1.99 worksheet CT_Worksheet */ var s = {} /*:any*/ ;
    if (opts.dense) s["!data"] = [];
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    } /*:any*/ ;
    var data1 = "", data2 = "";
    var mtch /*:?any*/  = $a1a91b25d7598376$var$str_match_xml_ns(data, "sheetData");
    if (mtch) {
        data1 = data.slice(0, mtch.index);
        data2 = data.slice(mtch.index + mtch[0].length);
    } else data1 = data2 = data;
    /* 18.3.1.82 sheetPr CT_SheetPr */ var sheetPr = data1.match($a1a91b25d7598376$var$sheetprregex);
    if (sheetPr) $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    else if (sheetPr = $a1a91b25d7598376$var$str_match_xml_ns(data1, "sheetPr")) $a1a91b25d7598376$var$parse_ws_xml_sheetpr2(sheetPr[0], sheetPr[1] || "", s, wb, idx, styles, themes);
    /* 18.3.1.35 dimension CT_SheetDimension */ var ridx = (data1.match(/<(?:\w*:)?dimension/) || {
        index: -1
    }).index;
    if (ridx > 0) {
        var ref = data1.slice(ridx, ridx + 50).match($a1a91b25d7598376$var$dimregex);
        if (ref && !(opts && opts.nodim)) $a1a91b25d7598376$var$parse_ws_xml_dim(s, ref[1]);
    }
    /* 18.3.1.88 sheetViews CT_SheetViews */ var svs = $a1a91b25d7598376$var$str_match_xml_ns(data1, "sheetViews");
    if (svs && svs[1]) $a1a91b25d7598376$var$parse_ws_xml_sheetviews(svs[1], wb);
    /* 18.3.1.17 cols CT_Cols */ var columns /*:Array<ColInfo>*/  = [];
    if (opts.cellStyles) {
        /* 18.3.1.13 col CT_Col */ var cols = data1.match($a1a91b25d7598376$var$colregex);
        if (cols) $a1a91b25d7598376$var$parse_ws_xml_cols(columns, cols);
    }
    /* 18.3.1.80 sheetData CT_SheetData ? */ if (mtch) $a1a91b25d7598376$var$parse_ws_xml_data(mtch[1], s, opts, refguess, themes, styles, wb);
    /* 18.3.1.2  autoFilter CT_AutoFilter */ var afilter = data2.match($a1a91b25d7598376$var$afregex);
    if (afilter) s['!autofilter'] = $a1a91b25d7598376$var$parse_ws_xml_autofilter(afilter[0]);
    /* 18.3.1.55 mergeCells CT_MergeCells */ var merges /*:Array<Range>*/  = [];
    var _merge = data2.match($a1a91b25d7598376$var$mergecregex);
    if (_merge) for(ridx = 0; ridx != _merge.length; ++ridx)merges[ridx] = $a1a91b25d7598376$var$safe_decode_range(_merge[ridx].slice(_merge[ridx].indexOf("=") + 2));
    /* 18.3.1.48 hyperlinks CT_Hyperlinks */ var hlink = data2.match($a1a91b25d7598376$var$hlinkregex);
    if (hlink) $a1a91b25d7598376$var$parse_ws_xml_hlinks(s, hlink, rels);
    /* 18.3.1.62 pageMargins CT_PageMargins */ var margins = data2.match($a1a91b25d7598376$var$marginregex);
    if (margins) s['!margins'] = $a1a91b25d7598376$var$parse_ws_xml_margins($a1a91b25d7598376$var$parsexmltag(margins[0]));
    /* legacyDrawing */ var m;
    if (m = data2.match(/legacyDrawing r:id="(.*?)"/)) s['!legrel'] = m[1];
    if (opts && opts.nodim) refguess.s.c = refguess.s.r = 0;
    if (!s["!ref"] && refguess.e.c >= refguess.s.c && refguess.e.r >= refguess.s.r) s["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
    if (opts.sheetRows > 0 && s["!ref"]) {
        var tmpref = $a1a91b25d7598376$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $a1a91b25d7598376$var$encode_range(tmpref);
        }
    }
    if (columns.length > 0) s["!cols"] = columns;
    if (merges.length > 0) s["!merges"] = merges;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
function $a1a91b25d7598376$var$write_ws_xml_merges(merges /*:Array<Range>*/ ) /*:string*/ {
    if (merges.length === 0) return "";
    var o = '<mergeCells count="' + merges.length + '">';
    for(var i = 0; i != merges.length; ++i)o += '<mergeCell ref="' + $a1a91b25d7598376$var$encode_range(merges[i]) + '"/>';
    return o + '</mergeCells>';
}
/* 18.3.1.82-3 sheetPr CT_ChartsheetPr / CT_SheetPr */ function $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    var data = $a1a91b25d7598376$var$parsexmltag(sheetPr);
    if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
    if (data.codeName) wb.Sheets[idx].CodeName = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(data.codeName));
}
function $a1a91b25d7598376$var$parse_ws_xml_sheetpr2(sheetPr /*:string*/ , body /*:string*/ , s, wb /*:WBWBProps*/ , idx /*:number*/ ) {
    $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr.slice(0, sheetPr.indexOf(">")), s, wb, idx);
}
function $a1a91b25d7598376$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o) {
    var needed = false;
    var props = {}, payload = null;
    if (opts.bookType !== 'xlsx' && wb.vbaraw) {
        var cname = wb.SheetNames[idx];
        try {
            if (wb.Workbook) cname = wb.Workbook.Sheets[idx].CodeName || cname;
        } catch (e) {}
        needed = true;
        props.codeName = $a1a91b25d7598376$var$utf8write($a1a91b25d7598376$var$escapexml(cname));
    }
    if (ws && ws["!outline"]) {
        var outlineprops = {
            summaryBelow: 1,
            summaryRight: 1
        };
        if (ws["!outline"].above) outlineprops.summaryBelow = 0;
        if (ws["!outline"].left) outlineprops.summaryRight = 0;
        payload = (payload || "") + $a1a91b25d7598376$var$writextag('outlinePr', null, outlineprops);
    }
    if (!needed && !payload) return;
    o[o.length] = $a1a91b25d7598376$var$writextag('sheetPr', payload, props);
}
/* 18.3.1.85 sheetProtection CT_SheetProtection */ var $a1a91b25d7598376$var$sheetprot_deffalse = [
    "objects",
    "scenarios",
    "selectLockedCells",
    "selectUnlockedCells"
];
var $a1a91b25d7598376$var$sheetprot_deftrue = [
    "formatColumns",
    "formatRows",
    "formatCells",
    "insertColumns",
    "insertRows",
    "insertHyperlinks",
    "deleteColumns",
    "deleteRows",
    "sort",
    "autoFilter",
    "pivotTables"
];
function $a1a91b25d7598376$var$write_ws_xml_protection(sp) /*:string*/ {
    // algorithmName, hashValue, saltValue, spinCount
    var o = {
        sheet: 1
    } /*:any*/ ;
    $a1a91b25d7598376$var$sheetprot_deffalse.forEach(function(n) {
        if (sp[n] != null && sp[n]) o[n] = "1";
    });
    $a1a91b25d7598376$var$sheetprot_deftrue.forEach(function(n) {
        if (sp[n] != null && !sp[n]) o[n] = "0";
    });
    /* TODO: algorithm */ if (sp.password) o.password = $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(sp.password).toString(16).toUpperCase();
    return $a1a91b25d7598376$var$writextag('sheetProtection', null, o);
}
function $a1a91b25d7598376$var$parse_ws_xml_hlinks(s, data /*:Array<string>*/ , rels) {
    var dense = s["!data"] != null;
    for(var i = 0; i != data.length; ++i){
        var val1 = $a1a91b25d7598376$var$parsexmltag($a1a91b25d7598376$var$utf8read(data[i]), true);
        if (!val1.ref) return;
        var rel = ((rels || {})['!id'] || [])[val1.id];
        if (rel) {
            val1.Target = rel.Target;
            if (val1.location) val1.Target += "#" + $a1a91b25d7598376$var$unescapexml(val1.location);
        } else {
            val1.Target = "#" + $a1a91b25d7598376$var$unescapexml(val1.location);
            rel = {
                Target: val1.Target,
                TargetMode: 'Internal'
            };
        }
        val1.Rel = rel;
        if (val1.tooltip) {
            val1.Tooltip = val1.tooltip;
            delete val1.tooltip;
        }
        var rng = $a1a91b25d7598376$var$safe_decode_range(val1.ref);
        for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
            var addr = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R);
            if (dense) {
                if (!s["!data"][R]) s["!data"][R] = [];
                if (!s["!data"][R][C]) s["!data"][R][C] = {
                    t: "z",
                    v: undefined
                };
                s["!data"][R][C].l = val1;
            } else {
                if (!s[addr]) s[addr] = {
                    t: "z",
                    v: undefined
                };
                s[addr].l = val1;
            }
        }
    }
}
function $a1a91b25d7598376$var$parse_ws_xml_margins(margin) {
    var o = {};
    [
        "left",
        "right",
        "top",
        "bottom",
        "header",
        "footer"
    ].forEach(function(k) {
        if (margin[k]) o[k] = parseFloat(margin[k]);
    });
    return o;
}
function $a1a91b25d7598376$var$write_ws_xml_margins(margin) /*:string*/ {
    $a1a91b25d7598376$var$default_margins(margin);
    return $a1a91b25d7598376$var$writextag('pageMargins', null, margin);
}
function $a1a91b25d7598376$var$parse_ws_xml_cols(columns, cols) {
    var seencol = false;
    for(var coli = 0; coli != cols.length; ++coli){
        var coll = $a1a91b25d7598376$var$parsexmltag(cols[coli], true);
        if (coll.hidden) coll.hidden = $a1a91b25d7598376$var$parsexmlbool(coll.hidden);
        var colm = parseInt(coll.min, 10) - 1, colM = parseInt(coll.max, 10) - 1;
        if (coll.outlineLevel) coll.level = +coll.outlineLevel || 0;
        delete coll.min;
        delete coll.max;
        coll.width = +coll.width;
        if (!seencol && coll.width) {
            seencol = true;
            $a1a91b25d7598376$var$find_mdw_colw(coll.width);
        }
        $a1a91b25d7598376$var$process_col(coll);
        while(colm <= colM)columns[colm++] = $a1a91b25d7598376$var$dup(coll);
    }
}
function $a1a91b25d7598376$var$write_ws_xml_cols(ws, cols) /*:string*/ {
    var o = [
        "<cols>"
    ], col;
    for(var i = 0; i != cols.length; ++i){
        if (!(col = cols[i])) continue;
        o[o.length] = $a1a91b25d7598376$var$writextag('col', null, $a1a91b25d7598376$var$col_obj_w(i, col));
    }
    o[o.length] = "</cols>";
    return o.join("");
}
function $a1a91b25d7598376$var$parse_ws_xml_autofilter(data /*:string*/ ) {
    var o = {
        ref: (data.match(/ref="([^"]*)"/) || [])[1]
    };
    return o;
}
function $a1a91b25d7598376$var$write_ws_xml_autofilter(data, ws, wb, idx) /*:string*/ {
    var ref = typeof data.ref == "string" ? data.ref : $a1a91b25d7598376$var$encode_range(data.ref);
    if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $a1a91b25d7598376$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $a1a91b25d7598376$var$decode_range(ws["!ref"]).e.r;
        ref = $a1a91b25d7598376$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $a1a91b25d7598376$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $a1a91b25d7598376$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: "'" + wb.SheetNames[idx] + "'!" + ref
    });
    return $a1a91b25d7598376$var$writextag("autoFilter", null, {
        ref: ref
    });
}
/* 18.3.1.88 sheetViews CT_SheetViews */ /* 18.3.1.87 sheetView CT_SheetView */ var $a1a91b25d7598376$var$sviewregex = /<(?:\w:)?sheetView(?:[^<>a-z][^<>]*)?\/?>/g;
function $a1a91b25d7598376$var$parse_ws_xml_sheetviews(data, wb /*:WBWBProps*/ ) {
    if (!wb.Views) wb.Views = [
        {}
    ];
    (data.match($a1a91b25d7598376$var$sviewregex) || []).forEach(function(r /*:string*/ , i /*:number*/ ) {
        var tag = $a1a91b25d7598376$var$parsexmltag(r);
        // $FlowIgnore
        if (!wb.Views[i]) wb.Views[i] = {};
        // $FlowIgnore
        if (+tag.zoomScale) wb.Views[i].zoom = +tag.zoomScale;
        // $FlowIgnore
        if (tag.rightToLeft && $a1a91b25d7598376$var$parsexmlbool(tag.rightToLeft)) wb.Views[i].RTL = true;
    });
}
function $a1a91b25d7598376$var$write_ws_xml_sheetviews(ws, opts, idx, wb) /*:string*/ {
    var sview = {
        workbookViewId: "0"
    } /*:any*/ ;
    // $FlowIgnore
    if ((((wb || {}).Workbook || {}).Views || [])[0]) sview.rightToLeft = wb.Workbook.Views[0].RTL ? "1" : "0";
    return $a1a91b25d7598376$var$writextag("sheetViews", $a1a91b25d7598376$var$writextag("sheetView", null, sview), {});
}
function $a1a91b25d7598376$var$write_ws_xml_cell(cell /*:Cell*/ , ref, ws, opts, idx, wb, date1904) /*:string*/ {
    if (cell.c) ws['!comments'].push([
        ref,
        cell.c
    ]);
    if ((cell.v === undefined || cell.t === "z" && !(opts || {}).sheetStubs) && typeof cell.f !== "string" && typeof cell.z == "undefined") return "";
    var vv = "";
    var oldt = cell.t, oldv = cell.v;
    if (cell.t !== "z") switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'n':
            if (isNaN(cell.v)) {
                cell.t = "e";
                vv = $a1a91b25d7598376$var$BErr[cell.v = 0x24];
            } else if (!isFinite(cell.v)) {
                cell.t = "e";
                vv = $a1a91b25d7598376$var$BErr[cell.v = 0x07];
            } else vv = '' + cell.v;
            break;
        case 'e':
            vv = $a1a91b25d7598376$var$BErr[cell.v];
            break;
        case 'd':
            if (opts && opts.cellDates) {
                var _vv = $a1a91b25d7598376$var$parseDate(cell.v, date1904);
                vv = _vv.toISOString();
                if (_vv.getUTCFullYear() < 1900) vv = vv.slice(vv.indexOf("T") + 1).replace("Z", "");
            } else {
                cell = $a1a91b25d7598376$var$dup(cell);
                cell.t = 'n';
                vv = '' + (cell.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v, date1904), date1904));
            }
            if (typeof cell.z === 'undefined') cell.z = $a1a91b25d7598376$var$table_fmt[14];
            break;
        default:
            vv = cell.v;
            break;
    }
    var v = cell.t == "z" || cell.v == null ? "" : $a1a91b25d7598376$var$writetag('v', $a1a91b25d7598376$var$escapexml(vv)), o = {
        r: ref
    } /*:any*/ ;
    /* TODO: cell style */ var os = $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    if (os !== 0) o.s = os;
    switch(cell.t){
        case 'n':
            break;
        case 'd':
            o.t = "d";
            break;
        case 'b':
            o.t = "b";
            break;
        case 'e':
            o.t = "e";
            break;
        case 'z':
            break;
        default:
            if (cell.v == null) {
                delete cell.t;
                break;
            }
            if (cell.v.length > 32767) throw new Error("Text length must not exceed 32767 characters");
            if (opts && opts.bookSST) {
                v = $a1a91b25d7598376$var$writetag('v', '' + $a1a91b25d7598376$var$get_sst_id(opts.Strings, cell.v, opts.revStrings));
                o.t = "s";
                break;
            } else o.t = "str";
            break;
    }
    if (cell.t != oldt) {
        cell.t = oldt;
        cell.v = oldv;
    }
    if (typeof cell.f == "string" && cell.f) {
        var ff = cell.F && cell.F.slice(0, ref.length) == ref ? {
            t: "array",
            ref: cell.F
        } : null;
        v = $a1a91b25d7598376$var$writextag('f', $a1a91b25d7598376$var$escapexml(cell.f), ff) + (cell.v != null ? v : "");
    }
    if (cell.l) {
        cell.l.display = $a1a91b25d7598376$var$escapexml(vv);
        ws['!links'].push([
            ref,
            cell.l
        ]);
    }
    if (cell.D) o.cm = 1;
    return $a1a91b25d7598376$var$writextag('c', v, o);
}
var $a1a91b25d7598376$var$parse_ws_xml_data = /*#__PURE__*/ function() {
    var cellregex = /<(?:\w+:)?c[ \/>]/, rowregex = /<\/(?:\w+:)?row>/;
    var rregex = /r=["']([^"']*)["']/;
    var refregex = /ref=["']([^"']*)["']/;
    return function parse_ws_xml_data(sdata /*:string*/ , s, opts, guess /*:Range*/ , themes, styles, wb) {
        var ri = 0, x = "", cells /*:Array<string>*/  = [], cref /*:?Array<string>*/  = [], idx = 0, i = 0, cc = 0, d = "", p /*:any*/ ;
        var tag, tagr = 0, tagc = 0;
        var sstr, ftag;
        var fmtid = 0, fillid = 0;
        var do_format = Array.isArray(styles.CellXf), cf;
        var arrayf /*:Array<[Range, string]>*/  = [];
        var sharedf = [];
        var dense = s["!data"] != null;
        var rows /*:Array<RowInfo>*/  = [], rowobj = {}, rowrite = false;
        var sheetStubs = !!opts.sheetStubs;
        var date1904 = !!((wb || {}).WBProps || {}).date1904;
        for(var marr = sdata.split(rowregex), mt = 0, marrlen = marr.length; mt != marrlen; ++mt){
            x = marr[mt].trim();
            var xlen = x.length;
            if (xlen === 0) continue;
            /* 18.3.1.73 row CT_Row */ var rstarti = 0;
            outa: for(ri = 0; ri < xlen; ++ri)switch(/*x.charCodeAt(ri)*/ x[ri]){
                case ">" /*62*/ :
                    if (/*x.charCodeAt(ri-1) != 47*/ x[ri - 1] != "/") {
                        ++ri;
                        break outa;
                    }
                    if (opts && opts.cellStyles) {
                        // TODO: avoid duplication
                        tag = $a1a91b25d7598376$var$parsexmltag(x.slice(rstarti, ri), true);
                        tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
                        tagc = -1;
                        if (opts.sheetRows && opts.sheetRows < tagr) continue;
                        rowobj = {};
                        rowrite = false;
                        if (tag.ht) {
                            rowrite = true;
                            rowobj.hpt = parseFloat(tag.ht);
                            rowobj.hpx = $a1a91b25d7598376$var$pt2px(rowobj.hpt);
                        }
                        if (tag.hidden && $a1a91b25d7598376$var$parsexmlbool(tag.hidden)) {
                            rowrite = true;
                            rowobj.hidden = true;
                        }
                        if (tag.outlineLevel != null) {
                            rowrite = true;
                            rowobj.level = +tag.outlineLevel;
                        }
                        if (rowrite) rows[tagr - 1] = rowobj;
                    }
                    break;
                case "<" /*60*/ :
                    rstarti = ri;
                    break;
            }
            if (rstarti >= ri) break;
            tag = $a1a91b25d7598376$var$parsexmltag(x.slice(rstarti, ri), true);
            tagr = tag.r != null ? parseInt(tag.r, 10) : tagr + 1;
            tagc = -1;
            if (opts.sheetRows && opts.sheetRows < tagr) continue;
            if (!opts.nodim) {
                if (guess.s.r > tagr - 1) guess.s.r = tagr - 1;
                if (guess.e.r < tagr - 1) guess.e.r = tagr - 1;
            }
            if (opts && opts.cellStyles) {
                rowobj = {};
                rowrite = false;
                if (tag.ht) {
                    rowrite = true;
                    rowobj.hpt = parseFloat(tag.ht);
                    rowobj.hpx = $a1a91b25d7598376$var$pt2px(rowobj.hpt);
                }
                if (tag.hidden && $a1a91b25d7598376$var$parsexmlbool(tag.hidden)) {
                    rowrite = true;
                    rowobj.hidden = true;
                }
                if (tag.outlineLevel != null) {
                    rowrite = true;
                    rowobj.level = +tag.outlineLevel;
                }
                if (rowrite) rows[tagr - 1] = rowobj;
            }
            /* 18.3.1.4 c CT_Cell */ cells = x.slice(ri).split(cellregex);
            for(var rslice = 0; rslice != cells.length; ++rslice)if (cells[rslice].trim().charAt(0) != "<") break;
            cells = cells.slice(rslice);
            for(ri = 0; ri != cells.length; ++ri){
                x = cells[ri].trim();
                if (x.length === 0) continue;
                cref = x.match(rregex);
                idx = ri;
                i = 0;
                cc = 0;
                x = "<c " + (x.slice(0, 1) == "<" ? ">" : "") + x;
                if (cref != null && cref.length === 2) {
                    idx = 0;
                    d = cref[1];
                    for(i = 0; i != d.length; ++i){
                        if ((cc = d.charCodeAt(i) - 64) < 1 || cc > 26) break;
                        idx = 26 * idx + cc;
                    }
                    --idx;
                    tagc = idx;
                } else ++tagc;
                for(i = 0; i != x.length; ++i)if (x.charCodeAt(i) === 62) break;
                ++i;
                tag = $a1a91b25d7598376$var$parsexmltag(x.slice(0, i), true);
                if (!tag.r) tag.r = $a1a91b25d7598376$var$encode_cell({
                    r: tagr - 1,
                    c: tagc
                });
                d = x.slice(i);
                p = {
                    t: ""
                } /*:any*/ ;
                if ((cref = $a1a91b25d7598376$var$str_match_xml_ns(d, "v")) != null && /*::cref != null && */ cref[1] !== '') p.v = $a1a91b25d7598376$var$unescapexml(cref[1]);
                if (opts.cellFormula) {
                    if ((cref = $a1a91b25d7598376$var$str_match_xml_ns(d, "f")) != null) {
                        if (cref[1] == "") {
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $a1a91b25d7598376$var$parsexmltag(cref[0]);
                                if (sharedf[ftag.si]) p.f = $a1a91b25d7598376$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                            }
                        } else {
                            /* TODO: match against XLSXFutureFunctions */ p.f = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(cref[1]), true);
                            if (!opts.xlfn) p.f = $a1a91b25d7598376$var$_xlfn(p.f);
                            if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="array"') > -1) {
                                p.F = (d.match(refregex) || [])[1];
                                if (p.F.indexOf(":") > -1) arrayf.push([
                                    $a1a91b25d7598376$var$safe_decode_range(p.F),
                                    p.F
                                ]);
                            } else if (/*::cref != null && cref[0] != null && */ cref[0].indexOf('t="shared"') > -1) {
                                // TODO: parse formula
                                ftag = $a1a91b25d7598376$var$parsexmltag(cref[0]);
                                var ___f = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(cref[1]));
                                if (!opts.xlfn) ___f = $a1a91b25d7598376$var$_xlfn(___f);
                                sharedf[parseInt(ftag.si, 10)] = [
                                    ftag,
                                    ___f,
                                    tag.r
                                ];
                            }
                        }
                    } else if (cref = d.match(/<f[^<>]*\/>/)) {
                        ftag = $a1a91b25d7598376$var$parsexmltag(cref[0]);
                        if (sharedf[ftag.si]) p.f = $a1a91b25d7598376$var$shift_formula_xlsx(sharedf[ftag.si][1], sharedf[ftag.si][2], tag.r);
                    }
                    /* TODO: factor out contains logic */ var _tag = $a1a91b25d7598376$var$decode_cell(tag.r);
                    for(i = 0; i < arrayf.length; ++i)if (_tag.r >= arrayf[i][0].s.r && _tag.r <= arrayf[i][0].e.r) {
                        if (_tag.c >= arrayf[i][0].s.c && _tag.c <= arrayf[i][0].e.c) p.F = arrayf[i][1];
                    }
                }
                if (tag.t == null && p.v === undefined) {
                    if (p.f || p.F) {
                        p.v = 0;
                        p.t = "n";
                    } else if (!sheetStubs) continue;
                    else p.t = "z";
                } else p.t = tag.t || "n";
                if (guess.s.c > tagc) guess.s.c = tagc;
                if (guess.e.c < tagc) guess.e.c = tagc;
                /* 18.18.11 t ST_CellType */ switch(p.t){
                    case 'n':
                        if (p.v == "" || p.v == null) {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else p.v = parseFloat(p.v);
                        break;
                    case 's':
                        if (typeof p.v == 'undefined') {
                            if (!sheetStubs) continue;
                            p.t = 'z';
                        } else {
                            sstr = $a1a91b25d7598376$var$strs[parseInt(p.v, 10)];
                            p.v = sstr.t;
                            p.r = sstr.r;
                            if (opts.cellHTML) p.h = sstr.h;
                        }
                        break;
                    case 'str':
                        p.t = "s";
                        p.v = p.v != null ? $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(p.v), true) : '';
                        if (opts.cellHTML) p.h = $a1a91b25d7598376$var$escapehtml(p.v);
                        break;
                    case 'inlineStr':
                        cref = $a1a91b25d7598376$var$str_match_xml_ns(d, "is");
                        p.t = 's';
                        if (cref != null && (sstr = $a1a91b25d7598376$var$parse_si(cref[1]))) {
                            p.v = sstr.t;
                            if (opts.cellHTML) p.h = sstr.h;
                        } else p.v = "";
                        break;
                    case 'b':
                        p.v = $a1a91b25d7598376$var$parsexmlbool(p.v);
                        break;
                    case 'd':
                        if (opts.cellDates) p.v = $a1a91b25d7598376$var$parseDate(p.v, date1904);
                        else {
                            p.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(p.v, date1904), date1904);
                            p.t = 'n';
                        }
                        break;
                    /* error string in .w, number in .v */ case 'e':
                        if (!opts || opts.cellText !== false) p.w = p.v;
                        p.v = $a1a91b25d7598376$var$RBErr[p.v];
                        break;
                }
                /* formatting */ fmtid = fillid = 0;
                cf = null;
                if (do_format && tag.s !== undefined) {
                    cf = styles.CellXf[tag.s];
                    if (cf != null) {
                        if (cf.numFmtId != null) fmtid = cf.numFmtId;
                        if (opts.cellStyles) {
                            if (cf.fillId != null) fillid = cf.fillId;
                        }
                    }
                }
                $a1a91b25d7598376$var$safe_format(p, fmtid, fillid, opts, themes, styles, date1904);
                if (opts.cellDates && do_format && p.t == 'n' && $a1a91b25d7598376$var$fmt_is_date($a1a91b25d7598376$var$table_fmt[fmtid])) {
                    p.v = $a1a91b25d7598376$var$numdate(p.v + (date1904 ? 1462 : 0));
                    p.t = typeof p.v == "number" ? 'n' : 'd';
                }
                if (tag.cm && opts.xlmeta) {
                    var cm = (opts.xlmeta.Cell || [])[+tag.cm - 1];
                    if (cm && cm.type == 'XLDAPR') p.D = true;
                }
                var _r;
                if (opts.nodim) {
                    _r = $a1a91b25d7598376$var$decode_cell(tag.r);
                    if (guess.s.r > _r.r) guess.s.r = _r.r;
                    if (guess.e.r < _r.r) guess.e.r = _r.r;
                }
                if (dense) {
                    _r = $a1a91b25d7598376$var$decode_cell(tag.r);
                    if (!s["!data"][_r.r]) s["!data"][_r.r] = [];
                    s["!data"][_r.r][_r.c] = p;
                } else s[tag.r] = p;
            }
        }
        if (rows.length > 0) s['!rows'] = rows;
    };
}();
function $a1a91b25d7598376$var$write_ws_xml_data(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/  /*::, rels*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [], r /*:Array<string>*/  = [], range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']), cell = "", ref, rr = "", cols /*:Array<string>*/  = [], R = 0, C = 0, rows = ws['!rows'];
    var dense = ws["!data"] != null, data = dense ? ws["!data"] : [];
    var params = {
        r: rr
    } /*:any*/ , row /*:RowInfo*/ , height = -1;
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    for(C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    for(R = range.s.r; R <= range.e.r; ++R){
        r = [];
        rr = $a1a91b25d7598376$var$encode_row(R);
        var data_R = dense ? data[R] : [];
        for(C = range.s.c; C <= range.e.c; ++C){
            ref = cols[C] + rr;
            var _cell = dense ? data_R[C] : ws[ref];
            if (_cell === undefined) continue;
            if ((cell = $a1a91b25d7598376$var$write_ws_xml_cell(_cell, ref, ws, opts, idx, wb, date1904)) != null) r.push(cell);
        }
        if (r.length > 0 || rows && rows[R]) {
            params = {
                r: rr
            } /*:any*/ ;
            if (rows && rows[R]) {
                row = rows[R];
                if (row.hidden) params.hidden = 1;
                height = -1;
                if (row.hpx) height = $a1a91b25d7598376$var$px2pt(row.hpx);
                else if (row.hpt) height = row.hpt;
                if (height > -1) {
                    params.ht = height;
                    params.customHeight = 1;
                }
                if (row.level) params.outlineLevel = row.level;
            }
            o[o.length] = $a1a91b25d7598376$var$writextag('row', r.join(""), params);
        }
    }
    if (rows) {
        for(; R < rows.length; ++R)if (rows && rows[R]) {
            params = {
                r: R + 1
            } /*:any*/ ;
            row = rows[R];
            if (row.hidden) params.hidden = 1;
            height = -1;
            if (row.hpx) height = $a1a91b25d7598376$var$px2pt(row.hpx);
            else if (row.hpt) height = row.hpt;
            if (height > -1) {
                params.ht = height;
                params.customHeight = 1;
            }
            if (row.level) params.outlineLevel = row.level;
            o[o.length] = $a1a91b25d7598376$var$writextag('row', "", params);
        }
    }
    return o.join("");
}
function $a1a91b25d7598376$var$write_ws_xml(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER,
        $a1a91b25d7598376$var$writextag('worksheet', null, {
            'xmlns': $a1a91b25d7598376$var$XMLNS_main[0],
            'xmlns:r': $a1a91b25d7598376$var$XMLNS.r
        })
    ];
    var s = wb.SheetNames[idx], sidx = 0, rdata = "";
    var ws = wb.Sheets[s];
    if (ws == null) ws = {};
    var ref = ws['!ref'] || 'A1';
    var range = $a1a91b25d7598376$var$safe_decode_range(ref);
    if (range.e.c > 0x3FFF || range.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + ref + " exceeds format limit A1:XFD1048576");
        range.e.c = Math.min(range.e.c, 0x3FFF);
        range.e.r = Math.min(range.e.c, 0xFFFFF);
        ref = $a1a91b25d7598376$var$encode_range(range);
    }
    if (!rels) rels = {};
    ws['!comments'] = [];
    var _drawing = [];
    $a1a91b25d7598376$var$write_ws_xml_sheetpr(ws, wb, idx, opts, o);
    o[o.length] = $a1a91b25d7598376$var$writextag('dimension', null, {
        'ref': ref
    });
    o[o.length] = $a1a91b25d7598376$var$write_ws_xml_sheetviews(ws, opts, idx, wb);
    /* TODO: store in WB, process styles */ if (opts.sheetFormat) o[o.length] = $a1a91b25d7598376$var$writextag('sheetFormatPr', null, {
        defaultRowHeight: opts.sheetFormat.defaultRowHeight || '16',
        baseColWidth: opts.sheetFormat.baseColWidth || '10',
        outlineLevelRow: opts.sheetFormat.outlineLevelRow || '7'
    });
    if (ws['!cols'] != null && ws['!cols'].length > 0) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_cols(ws, ws['!cols']);
    o[sidx = o.length] = '<sheetData/>';
    ws['!links'] = [];
    if (ws['!ref'] != null) {
        rdata = $a1a91b25d7598376$var$write_ws_xml_data(ws, opts, idx, wb, rels);
        if (rdata.length > 0) o[o.length] = rdata;
    }
    if (o.length > sidx + 1) {
        o[o.length] = '</sheetData>';
        o[sidx] = o[sidx].replace("/>", ">");
    }
    /* sheetCalcPr */ if (ws['!protect']) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_protection(ws['!protect']);
    /* protectedRanges */ /* scenarios */ if (ws['!autofilter'] != null) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_autofilter(ws['!autofilter'], ws, wb, idx);
    /* sortState */ /* dataConsolidate */ /* customSheetViews */ if (ws['!merges'] != null && ws['!merges'].length > 0) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_merges(ws['!merges']);
    /* phoneticPr */ /* conditionalFormatting */ /* dataValidations */ var relc = -1, rel, rId = -1;
    if (/*::(*/ ws['!links']/*::||[])*/ .length > 0) {
        o[o.length] = "<hyperlinks>";
        /*::(*/ ws['!links']/*::||[])*/ .forEach(function(l) {
            if (!l[1].Target) return;
            rel = {
                "ref": l[0]
            } /*:any*/ ;
            if (l[1].Target.charAt(0) != "#") {
                rId = $a1a91b25d7598376$var$add_rels(rels, -1, $a1a91b25d7598376$var$escapexml(l[1].Target).replace(/#[\s\S]*$/, ""), $a1a91b25d7598376$var$RELS.HLINK);
                rel["r:id"] = "rId" + rId;
            }
            if ((relc = l[1].Target.indexOf("#")) > -1) rel.location = $a1a91b25d7598376$var$escapexml(l[1].Target.slice(relc + 1));
            if (l[1].Tooltip) rel.tooltip = $a1a91b25d7598376$var$escapexml(l[1].Tooltip);
            rel.display = l[1].display;
            o[o.length] = $a1a91b25d7598376$var$writextag("hyperlink", null, rel);
        });
        o[o.length] = "</hyperlinks>";
    }
    delete ws['!links'];
    /* printOptions */ if (ws['!margins'] != null) o[o.length] = $a1a91b25d7598376$var$write_ws_xml_margins(ws['!margins']);
    /* pageSetup */ /* headerFooter */ /* rowBreaks */ /* colBreaks */ /* customProperties */ /* cellWatches */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) o[o.length] = $a1a91b25d7598376$var$writetag("ignoredErrors", $a1a91b25d7598376$var$writextag("ignoredError", null, {
        numberStoredAsText: 1,
        sqref: ref
    }));
    /* smartTags */ if (_drawing.length > 0) {
        rId = $a1a91b25d7598376$var$add_rels(rels, -1, "../drawings/drawing" + (idx + 1) + ".xml", $a1a91b25d7598376$var$RELS.DRAW);
        o[o.length] = $a1a91b25d7598376$var$writextag("drawing", null, {
            "r:id": "rId" + rId
        });
        ws['!drawing'] = _drawing;
    }
    if (ws['!comments'].length > 0) {
        rId = $a1a91b25d7598376$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $a1a91b25d7598376$var$RELS.VML);
        o[o.length] = $a1a91b25d7598376$var$writextag("legacyDrawing", null, {
            "r:id": "rId" + rId
        });
        ws['!legacy'] = rId;
    }
    /* legacyDrawingHF */ /* picture */ /* oleObjects */ /* controls */ /* webPublishItems */ /* tableParts */ /* extLst */ if (o.length > 1) {
        o[o.length] = '</worksheet>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.726 BrtRowHdr */ function $a1a91b25d7598376$var$parse_BrtRowHdr(data, length) {
    var z = {} /*:any*/ ;
    var tgt = data.l + length;
    z.r = data.read_shift(4);
    data.l += 4; // TODO: ixfe
    var miyRw = data.read_shift(2);
    data.l += 1; // TODO: top/bot padding
    var flags = data.read_shift(1);
    data.l = tgt;
    if (flags & 0x07) z.level = flags & 0x07;
    if (flags & 0x10) z.hidden = true;
    if (flags & 0x20) z.hpt = miyRw / 20;
    return z;
}
function $a1a91b25d7598376$var$write_BrtRowHdr(R /*:number*/ , range, ws) {
    var o = $a1a91b25d7598376$var$new_buf(145);
    var row = (ws['!rows'] || [])[R] || {};
    o.write_shift(4, R);
    o.write_shift(4, 0); /* TODO: ixfe */ 
    var miyRw = 0x0140;
    if (row.hpx) miyRw = $a1a91b25d7598376$var$px2pt(row.hpx) * 20;
    else if (row.hpt) miyRw = row.hpt * 20;
    o.write_shift(2, miyRw);
    o.write_shift(1, 0); /* top/bot padding */ 
    var flags = 0x0;
    if (row.level) flags |= row.level;
    if (row.hidden) flags |= 0x10;
    if (row.hpx || row.hpt) flags |= 0x20;
    o.write_shift(1, flags);
    o.write_shift(1, 0); /* phonetic guide */ 
    /* [MS-XLSB] 2.5.8 BrtColSpan explains the mechanism */ var ncolspan = 0, lcs = o.l;
    o.l += 4;
    var caddr = {
        r: R,
        c: 0
    };
    var dense = ws["!data"] != null;
    for(var i = 0; i < 16; ++i){
        if (range.s.c > i + 1 << 10 || range.e.c < i << 10) continue;
        var first = -1, last = -1;
        for(var j = i << 10; j < i + 1 << 10; ++j){
            caddr.c = j;
            var cell = dense ? (ws["!data"][caddr.r] || [])[caddr.c] : ws[$a1a91b25d7598376$var$encode_cell(caddr)];
            if (cell) {
                if (first < 0) first = j;
                last = j;
            }
        }
        if (first < 0) continue;
        ++ncolspan;
        o.write_shift(4, first);
        o.write_shift(4, last);
    }
    var l = o.l;
    o.l = lcs;
    o.write_shift(4, ncolspan);
    o.l = l;
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $a1a91b25d7598376$var$write_row_header(ba, ws, range, R) {
    var o = $a1a91b25d7598376$var$write_BrtRowHdr(R, range, ws);
    if (o.length > 17 || (ws['!rows'] || [])[R]) $a1a91b25d7598376$var$write_record(ba, 0x0000 /* BrtRowHdr */ , o);
}
/* [MS-XLSB] 2.4.820 BrtWsDim */ var $a1a91b25d7598376$var$parse_BrtWsDim = $a1a91b25d7598376$var$parse_UncheckedRfX;
var $a1a91b25d7598376$var$write_BrtWsDim = $a1a91b25d7598376$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.821 BrtWsFmtInfo */ function $a1a91b25d7598376$var$parse_BrtWsFmtInfo() {}
//function write_BrtWsFmtInfo(ws, o) { }
/* [MS-XLSB] 2.4.823 BrtWsProp */ function $a1a91b25d7598376$var$parse_BrtWsProp(data, length) {
    var z = {};
    var f = data[data.l];
    ++data.l;
    z.above = !(f & 0x40);
    z.left = !(f & 0x80);
    /* TODO: pull flags */ data.l += 18;
    z.name = $a1a91b25d7598376$var$parse_XLSBCodeName(data, length - 19);
    return z;
}
function $a1a91b25d7598376$var$write_BrtWsProp(str, outl, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(84 + 4 * str.length);
    var f = 0xC0;
    if (outl) {
        if (outl.above) f &= -65;
        if (outl.left) f &= -129;
    }
    o.write_shift(1, f);
    for(var i = 1; i < 3; ++i)o.write_shift(1, 0);
    $a1a91b25d7598376$var$write_BrtColor({
        auto: 1
    }, o);
    o.write_shift(-4, -1);
    o.write_shift(-4, -1);
    $a1a91b25d7598376$var$write_XLSBCodeName(str, o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.306 BrtCellBlank */ function $a1a91b25d7598376$var$parse_BrtCellBlank(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    return [
        cell
    ];
}
function $a1a91b25d7598376$var$write_BrtCellBlank(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    return $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
}
function $a1a91b25d7598376$var$parse_BrtShortBlank(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    return [
        cell
    ];
}
function $a1a91b25d7598376$var$write_BrtShortBlank(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    return $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
}
/* [MS-XLSB] 2.4.307 BrtCellBool */ function $a1a91b25d7598376$var$parse_BrtCellBool(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellBool(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortBool(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var fBool = data.read_shift(1);
    return [
        cell,
        fBool,
        'b'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortBool(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(5);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v ? 1 : 0);
    return o;
}
/* [MS-XLSB] 2.4.308 BrtCellError */ function $a1a91b25d7598376$var$parse_BrtCellError(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellError(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    o.write_shift(1, cell.v);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortError(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var bError = data.read_shift(1);
    return [
        cell,
        bError,
        'e'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortError(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    o.write_shift(1, cell.v);
    o.write_shift(2, 0);
    o.write_shift(1, 0);
    return o;
}
/* [MS-XLSB] 2.4.311 BrtCellIsst */ function $a1a91b25d7598376$var$parse_BrtCellIsst(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellIsst(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortIsst(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var isst = data.read_shift(4);
    return [
        cell,
        isst,
        's'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortIsst(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    o.write_shift(4, ncell.v);
    return o;
}
/* [MS-XLSB] 2.4.313 BrtCellReal */ function $a1a91b25d7598376$var$parse_BrtCellReal(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellReal(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(16);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    $a1a91b25d7598376$var$write_Xnum(cell.v, o);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortReal(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var value = $a1a91b25d7598376$var$parse_Xnum(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortReal(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    $a1a91b25d7598376$var$write_Xnum(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.314 BrtCellRk */ function $a1a91b25d7598376$var$parse_BrtCellRk(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellRk(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    $a1a91b25d7598376$var$write_RkNumber(cell.v, o);
    return o;
}
function $a1a91b25d7598376$var$parse_BrtShortRk(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var value = $a1a91b25d7598376$var$parse_RkNumber(data);
    return [
        cell,
        value,
        'n'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortRk(cell, ncell, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    $a1a91b25d7598376$var$write_RkNumber(cell.v, o);
    return o;
}
/* [MS-XLSB] 2.4.323 BrtCellRString */ function $a1a91b25d7598376$var$parse_BrtCellRString(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_RichStr(data);
    return [
        cell,
        value,
        'is'
    ];
}
/* [MS-XLSB] 2.4.317 BrtCellSt */ function $a1a91b25d7598376$var$parse_BrtCellSt(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    var value = $a1a91b25d7598376$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $a1a91b25d7598376$var$write_BrtCellSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $a1a91b25d7598376$var$new_buf(12 + 4 * cell.v.length);
    $a1a91b25d7598376$var$write_XLSBCell(ncell, o);
    $a1a91b25d7598376$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $a1a91b25d7598376$var$parse_BrtShortSt(data) {
    var cell = $a1a91b25d7598376$var$parse_XLSBShortCell(data);
    var value = $a1a91b25d7598376$var$parse_XLWideString(data);
    return [
        cell,
        value,
        'str'
    ];
}
function $a1a91b25d7598376$var$write_BrtShortSt(cell, ncell, o) {
    var data = cell.v == null ? "" : String(cell.v);
    if (o == null) o = $a1a91b25d7598376$var$new_buf(8 + 4 * data.length);
    $a1a91b25d7598376$var$write_XLSBShortCell(ncell, o);
    $a1a91b25d7598376$var$write_XLWideString(data, o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.653 BrtFmlaBool */ function $a1a91b25d7598376$var$parse_BrtFmlaBool(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'b'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.654 BrtFmlaError */ function $a1a91b25d7598376$var$parse_BrtFmlaError(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = data.read_shift(1);
    var o = [
        cell,
        value,
        'e'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.655 BrtFmlaNum */ function $a1a91b25d7598376$var$parse_BrtFmlaNum(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $a1a91b25d7598376$var$parse_Xnum(data);
    var o = [
        cell,
        value,
        'n'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.656 BrtFmlaString */ function $a1a91b25d7598376$var$parse_BrtFmlaString(data, length, opts) {
    var end = data.l + length;
    var cell = $a1a91b25d7598376$var$parse_XLSBCell(data);
    cell.r = opts['!row'];
    var value = $a1a91b25d7598376$var$parse_XLWideString(data);
    var o = [
        cell,
        value,
        'str'
    ];
    if (opts.cellFormula) {
        data.l += 2;
        var formula = $a1a91b25d7598376$var$parse_XLSBCellParsedFormula(data, end - data.l, opts);
        o[3] = $a1a91b25d7598376$var$stringify_formula(formula, null, cell, opts.supbooks, opts); /* TODO */ 
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.682 BrtMergeCell */ var $a1a91b25d7598376$var$parse_BrtMergeCell = $a1a91b25d7598376$var$parse_UncheckedRfX;
var $a1a91b25d7598376$var$write_BrtMergeCell = $a1a91b25d7598376$var$write_UncheckedRfX;
/* [MS-XLSB] 2.4.107 BrtBeginMergeCells */ function $a1a91b25d7598376$var$write_BrtBeginMergeCells(cnt, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(4);
    o.write_shift(4, cnt);
    return o;
}
/* [MS-XLSB] 2.4.662 BrtHLink */ function $a1a91b25d7598376$var$parse_BrtHLink(data, length /*::, opts*/ ) {
    var end = data.l + length;
    var rfx = $a1a91b25d7598376$var$parse_UncheckedRfX(data, 16);
    var relId = $a1a91b25d7598376$var$parse_XLNullableWideString(data);
    var loc = $a1a91b25d7598376$var$parse_XLWideString(data);
    var tooltip = $a1a91b25d7598376$var$parse_XLWideString(data);
    var display = $a1a91b25d7598376$var$parse_XLWideString(data);
    data.l = end;
    var o = {
        rfx: rfx,
        relId: relId,
        loc: loc,
        display: display
    } /*:any*/ ;
    if (tooltip) o.Tooltip = tooltip;
    return o;
}
function $a1a91b25d7598376$var$write_BrtHLink(l, rId) {
    var o = $a1a91b25d7598376$var$new_buf(50 + 4 * (l[1].Target.length + (l[1].Tooltip || "").length));
    $a1a91b25d7598376$var$write_UncheckedRfX({
        s: $a1a91b25d7598376$var$decode_cell(l[0]),
        e: $a1a91b25d7598376$var$decode_cell(l[0])
    }, o);
    $a1a91b25d7598376$var$write_RelID("rId" + rId, o);
    var locidx = l[1].Target.indexOf("#");
    var loc = locidx == -1 ? "" : l[1].Target.slice(locidx + 1);
    $a1a91b25d7598376$var$write_XLWideString(loc || "", o);
    $a1a91b25d7598376$var$write_XLWideString(l[1].Tooltip || "", o);
    $a1a91b25d7598376$var$write_XLWideString("", o);
    return o.slice(0, o.l);
}
/* [MS-XLSB] 2.4.692 BrtPane */ function $a1a91b25d7598376$var$parse_BrtPane() {}
/* [MS-XLSB] 2.4.6 BrtArrFmla */ function $a1a91b25d7598376$var$parse_BrtArrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $a1a91b25d7598376$var$parse_RfX(data, 16);
    var fAlwaysCalc = data.read_shift(1);
    var o = [
        rfx
    ];
    o[2] = fAlwaysCalc;
    if (opts.cellFormula) {
        var formula = $a1a91b25d7598376$var$parse_XLSBArrayParsedFormula(data, end - data.l, opts);
        o[1] = formula;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.750 BrtShrFmla */ function $a1a91b25d7598376$var$parse_BrtShrFmla(data, length, opts) {
    var end = data.l + length;
    var rfx = $a1a91b25d7598376$var$parse_UncheckedRfX(data, 16);
    var o = [
        rfx
    ];
    if (opts.cellFormula) {
        var formula = $a1a91b25d7598376$var$parse_XLSBSharedParsedFormula(data, end - data.l, opts);
        o[1] = formula;
        data.l = end;
    } else data.l = end;
    return o;
}
/* [MS-XLSB] 2.4.323 BrtColInfo */ /* TODO: once XLS ColInfo is set, combine the functions */ function $a1a91b25d7598376$var$write_BrtColInfo(C /*:number*/ , col, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(18);
    var p = $a1a91b25d7598376$var$col_obj_w(C, col);
    o.write_shift(-4, C);
    o.write_shift(-4, C);
    o.write_shift(4, (p.width || 10) * 256);
    o.write_shift(4, 0 /*ixfe*/ ); // style
    var flags = 0;
    if (col.hidden) flags |= 0x01;
    if (typeof p.width == 'number') flags |= 0x02;
    if (col.level) flags |= col.level << 8;
    o.write_shift(2, flags); // bit flag
    return o;
}
/* [MS-XLSB] 2.4.678 BrtMargins */ var $a1a91b25d7598376$var$BrtMarginKeys = [
    "left",
    "right",
    "top",
    "bottom",
    "header",
    "footer"
];
function $a1a91b25d7598376$var$parse_BrtMargins(data /*::, length, opts*/ ) /*:Margins*/ {
    var margins = {} /*:any*/ ;
    $a1a91b25d7598376$var$BrtMarginKeys.forEach(function(k) {
        margins[k] = $a1a91b25d7598376$var$parse_Xnum(data, 8);
    });
    return margins;
}
function $a1a91b25d7598376$var$write_BrtMargins(margins /*:Margins*/ , o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(48);
    $a1a91b25d7598376$var$default_margins(margins);
    $a1a91b25d7598376$var$BrtMarginKeys.forEach(function(k) {
        $a1a91b25d7598376$var$write_Xnum(margins /*:any*/ [k], o);
    });
    return o;
}
/* [MS-XLSB] 2.4.299 BrtBeginWsView */ function $a1a91b25d7598376$var$parse_BrtBeginWsView(data /*::, length, opts*/ ) {
    var f = data.read_shift(2);
    data.l += 28;
    return {
        RTL: f & 0x20
    };
}
function $a1a91b25d7598376$var$write_BrtBeginWsView(ws, Workbook, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(30);
    var f = 0x39c;
    if ((((Workbook || {}).Views || [])[0] || {}).RTL) f |= 0x20;
    o.write_shift(2, f); // bit flag
    o.write_shift(4, 0);
    o.write_shift(4, 0); // view first row
    o.write_shift(4, 0); // view first col
    o.write_shift(1, 0); // gridline color ICV
    o.write_shift(1, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 100); // zoom scale
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(2, 0);
    o.write_shift(4, 0); // workbook view id
    return o;
}
/* [MS-XLSB] 2.4.309 BrtCellIgnoreEC */ function $a1a91b25d7598376$var$write_BrtCellIgnoreEC(ref) {
    var o = $a1a91b25d7598376$var$new_buf(24);
    o.write_shift(4, 4);
    o.write_shift(4, 1);
    $a1a91b25d7598376$var$write_UncheckedRfX(ref, o);
    return o;
}
/* [MS-XLSB] 2.4.748 BrtSheetProtection */ function $a1a91b25d7598376$var$write_BrtSheetProtection(sp, o) {
    if (o == null) o = $a1a91b25d7598376$var$new_buf(66);
    o.write_shift(2, sp.password ? $a1a91b25d7598376$var$crypto_CreatePasswordVerifier_Method1(sp.password) : 0);
    o.write_shift(4, 1); // this record should not be written if no protection
    [
        [
            "objects",
            false
        ],
        [
            "scenarios",
            false
        ],
        [
            "formatCells",
            true
        ],
        [
            "formatColumns",
            true
        ],
        [
            "formatRows",
            true
        ],
        [
            "insertColumns",
            true
        ],
        [
            "insertRows",
            true
        ],
        [
            "insertHyperlinks",
            true
        ],
        [
            "deleteColumns",
            true
        ],
        [
            "deleteRows",
            true
        ],
        [
            "selectLockedCells",
            false
        ],
        [
            "sort",
            true
        ],
        [
            "autoFilter",
            true
        ],
        [
            "pivotTables",
            true
        ],
        [
            "selectUnlockedCells",
            false
        ] // fSelUnlockedCells
    ].forEach(function(n) {
        /*:: if(o == null) throw "unreachable"; */ if (n[1]) o.write_shift(4, sp[n[0]] != null && !sp[n[0]] ? 1 : 0);
        else o.write_shift(4, sp[n[0]] != null && sp[n[0]] ? 0 : 1);
    });
    return o;
}
function $a1a91b25d7598376$var$parse_BrtDVal() {}
function $a1a91b25d7598376$var$parse_BrtDVal14() {}
/* [MS-XLSB] 2.1.7.61 Worksheet */ function $a1a91b25d7598376$var$parse_ws_bin(data, _opts, idx, rels, wb /*:WBWBProps*/ , themes, styles) /*:Worksheet*/ {
    if (!data) return data;
    var opts = _opts || {};
    if (!rels) rels = {
        '!id': {}
    };
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    var s /*:Worksheet*/  = {};
    if (opts.dense) s["!data"] = [];
    var ref;
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var state /*:Array<string>*/  = [];
    var pass = false, end = false;
    var row, p, cf, R, C, addr, sstr, rr, cell /*:Cell*/ ;
    var merges /*:Array<Range>*/  = [];
    opts.biff = 12;
    opts['!row'] = 0;
    var ai = 0, af = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var sharedf = {};
    var supbooks = opts.supbooks || /*::(*/ wb /*:: :any)*/ .supbooks || [
        []
    ];
    supbooks.sharedf = sharedf;
    supbooks.arrayf = arrayf;
    supbooks.SheetNames = wb.SheetNames || wb.Sheets.map(function(x) {
        return x.name;
    });
    if (!opts.supbooks) {
        opts.supbooks = supbooks;
        if (wb.Names) for(var i = 0; i < wb.Names.length; ++i)supbooks[0][i + 1] = wb.Names[i];
    }
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    $a1a91b25d7598376$var$XLSBRecordEnum[0x0010] = {
        n: "BrtShortReal",
        f: $a1a91b25d7598376$var$parse_BrtShortReal
    };
    var cm, vm;
    var date1904 = 1462 * +!!((wb || {}).WBProps || {}).date1904;
    $a1a91b25d7598376$var$recordhopper(data, function ws_parse(val1, RR, RT) {
        if (end) return;
        switch(RT){
            case 0x0094:
                /* 'BrtWsDim' */ ref = val1;
                break;
            case 0x0000:
                /* 'BrtRowHdr' */ row = val1;
                if (opts.sheetRows && opts.sheetRows <= row.r) end = true;
                rr = $a1a91b25d7598376$var$encode_row(R = row.r);
                opts['!row'] = row.r;
                if (val1.hidden || val1.hpt || val1.level != null) {
                    if (val1.hpt) val1.hpx = $a1a91b25d7598376$var$pt2px(val1.hpt);
                    rowinfo[val1.r] = val1;
                }
                break;
            case 0x0002:
            /* 'BrtCellRk' */ case 0x0003:
            /* 'BrtCellError' */ case 0x0004:
            /* 'BrtCellBool' */ case 0x0005:
            /* 'BrtCellReal' */ case 0x0006:
            /* 'BrtCellSt' */ case 0x0007:
            /* 'BrtCellIsst' */ case 0x0008:
            /* 'BrtFmlaString' */ case 0x0009:
            /* 'BrtFmlaNum' */ case 0x000A:
            /* 'BrtFmlaBool' */ case 0x000B:
            /* 'BrtFmlaError' */ case 0x000D:
            /* 'BrtShortRk' */ case 0x000E:
            /* 'BrtShortError' */ case 0x000F:
            /* 'BrtShortBool' */ case 0x0010:
            /* 'BrtShortReal' */ case 0x0011:
            /* 'BrtShortSt' */ case 0x0012:
            /* 'BrtShortIsst' */ case 0x003E:
                /* 'BrtCellRString' */ p = {
                    t: val1[2]
                } /*:any*/ ;
                switch(val1[2]){
                    case 'n':
                        p.v = val1[1];
                        break;
                    case 's':
                        sstr = $a1a91b25d7598376$var$strs[val1[1]];
                        p.v = sstr.t;
                        p.r = sstr.r;
                        break;
                    case 'b':
                        p.v = val1[1] ? true : false;
                        break;
                    case 'e':
                        p.v = val1[1];
                        if (opts.cellText !== false) p.w = $a1a91b25d7598376$var$BErr[p.v];
                        break;
                    case 'str':
                        p.t = 's';
                        p.v = val1[1];
                        break;
                    case 'is':
                        p.t = 's';
                        p.v = val1[1].t;
                        break;
                }
                if (cf = styles.CellXf[val1[0].iStyleRef]) $a1a91b25d7598376$var$safe_format(p, cf.numFmtId, null, opts, themes, styles, date1904 > 0);
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$a1a91b25d7598376$var$encode_col(C) + rr] = p;
                if (opts.cellFormula) {
                    af = false;
                    for(ai = 0; ai < arrayf.length; ++ai){
                        var aii = arrayf[ai];
                        if (row.r >= aii[0].s.r && row.r <= aii[0].e.r) {
                            if (C >= aii[0].s.c && C <= aii[0].e.c) {
                                p.F = $a1a91b25d7598376$var$encode_range(aii[0]);
                                af = true;
                            }
                        }
                    }
                    if (!af && val1.length > 3) p.f = val1[3];
                }
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (opts.cellDates && cf && p.t == 'n' && $a1a91b25d7598376$var$fmt_is_date($a1a91b25d7598376$var$table_fmt[cf.numFmtId])) {
                    var _d = $a1a91b25d7598376$var$SSF_parse_date_code(p.v + date1904);
                    if (_d) {
                        p.t = 'd';
                        p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
                    }
                }
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x0001:
            /* 'BrtCellBlank' */ case 0x000C:
                /* 'BrtShortBlank' */ if (!opts.sheetStubs || pass) break;
                p = {
                    t: 'z',
                    v: void 0
                } /*:any*/ ;
                C = val1[0].c == -1 ? C + 1 : val1[0].c;
                if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    s["!data"][R][C] = p;
                } else s[$a1a91b25d7598376$var$encode_col(C) + rr] = p;
                if (refguess.s.r > row.r) refguess.s.r = row.r;
                if (refguess.s.c > C) refguess.s.c = C;
                if (refguess.e.r < row.r) refguess.e.r = row.r;
                if (refguess.e.c < C) refguess.e.c = C;
                if (cm) {
                    if (cm.type == 'XLDAPR') p.D = true;
                    cm = void 0;
                }
                if (vm) vm = void 0;
                break;
            case 0x00B0:
                /* 'BrtMergeCell' */ merges.push(val1);
                break;
            case 0x0031:
                cm = ((opts.xlmeta || {}).Cell || [])[val1 - 1];
                break;
            case 0x01EE:
                /* 'BrtHLink' */ var rel = rels['!id'][val1.relId];
                if (rel) {
                    val1.Target = rel.Target;
                    if (val1.loc) val1.Target += "#" + val1.loc;
                    val1.Rel = rel;
                } else if (val1.relId == '') val1.Target = "#" + val1.loc;
                for(R = val1.rfx.s.r; R <= val1.rfx.e.r; ++R)for(C = val1.rfx.s.c; C <= val1.rfx.e.c; ++C)if (opts.dense) {
                    if (!s["!data"][R]) s["!data"][R] = [];
                    if (!s["!data"][R][C]) s["!data"][R][C] = {
                        t: 'z',
                        v: undefined
                    };
                    s["!data"][R][C].l = val1;
                } else {
                    addr = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R);
                    if (!s[addr]) s[addr] = {
                        t: 'z',
                        v: undefined
                    };
                    s[addr].l = val1;
                }
                break;
            case 0x01AA:
                /* 'BrtArrFmla' */ if (!opts.cellFormula) break;
                arrayf.push(val1);
                cell = opts.dense ? s["!data"][R][C] : s[$a1a91b25d7598376$var$encode_col(C) + rr];
                cell.f = $a1a91b25d7598376$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                cell.F = $a1a91b25d7598376$var$encode_range(val1[0]);
                break;
            case 0x01AB:
                /* 'BrtShrFmla' */ if (!opts.cellFormula) break;
                sharedf[$a1a91b25d7598376$var$encode_cell(val1[0].s)] = val1[1];
                cell = opts.dense ? s["!data"][R][C] : s[$a1a91b25d7598376$var$encode_col(C) + rr];
                cell.f = $a1a91b25d7598376$var$stringify_formula(val1[1], refguess, {
                    r: row.r,
                    c: C
                }, supbooks, opts);
                break;
            /* identical to 'ColInfo' in XLS */ case 0x003C:
                /* 'BrtColInfo' */ if (!opts.cellStyles) break;
                while(val1.e >= val1.s){
                    colinfo[val1.e--] = {
                        width: val1.w / 256,
                        hidden: !!(val1.flags & 0x01),
                        level: val1.level
                    };
                    if (!seencol) {
                        seencol = true;
                        $a1a91b25d7598376$var$find_mdw_colw(val1.w / 256);
                    }
                    $a1a91b25d7598376$var$process_col(colinfo[val1.e + 1]);
                }
                break;
            case 0x0227:
                /* 'BrtLegacyDrawing' */ if (val1) s["!legrel"] = val1;
                break;
            case 0x00A1:
                /* 'BrtBeginAFilter' */ s['!autofilter'] = {
                    ref: $a1a91b25d7598376$var$encode_range(val1)
                };
                break;
            case 0x01DC:
                /* 'BrtMargins' */ s['!margins'] = val1;
                break;
            case 0x0093:
                /* 'BrtWsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                if (val1.above || val1.left) s['!outline'] = {
                    above: val1.above,
                    left: val1.left
                };
                break;
            case 0x0089:
                /* 'BrtBeginWsView' */ if (!wb.Views) wb.Views = [
                    {}
                ];
                if (!wb.Views[0]) wb.Views[0] = {};
                if (val1.RTL) wb.Views[0].RTL = true;
                break;
            case 0x01E5:
                break;
            case 0x0040:
            /* 'BrtDVal' */ case 0x041D:
                break;
            case 0x0097:
                break;
            case 0x0098:
            /* 'BrtSel' */ case 0x00AF:
            /* 'BrtAFilterDateGroupItem' */ case 0x0284:
            /* 'BrtActiveX' */ case 0x0271:
            /* 'BrtBigName' */ case 0x0232:
            /* 'BrtBkHim' */ case 0x018C:
            /* 'BrtBrk' */ case 0x0458:
            /* 'BrtCFIcon' */ case 0x047A:
            /* 'BrtCFRuleExt' */ case 0x01D7:
            /* 'BrtCFVO' */ case 0x041A:
            /* 'BrtCFVO14' */ case 0x0289:
            /* 'BrtCellIgnoreEC' */ case 0x0451:
            /* 'BrtCellIgnoreEC14' */ case 0x024D:
            /* 'BrtCellSmartTagProperty' */ case 0x025F:
            /* 'BrtCellWatch' */ case 0x0234:
            /* 'BrtColor' */ case 0x041F:
            /* 'BrtColor14' */ case 0x00A8:
            /* 'BrtColorFilter' */ case 0x00AE:
            /* 'BrtCustomFilter' */ case 0x049C:
            /* 'BrtCustomFilter14' */ case 0x01F3:
            /* 'BrtDRef' */ case 0x01FB:
            /* 'BrtDXF' */ case 0x0226:
            /* 'BrtDrawing' */ case 0x00AB:
            /* 'BrtDynamicFilter' */ case 0x00A7:
            /* 'BrtFilter' */ case 0x0499:
            /* 'BrtFilter14' */ case 0x00A9:
            /* 'BrtIconFilter' */ case 0x049D:
            /* 'BrtIconFilter14' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x0295:
            /* 'BrtListPart' */ case 0x027F:
            /* 'BrtOleObject' */ case 0x01DE:
            /* 'BrtPageSetup' */ case 0x0219:
            /* 'BrtPhoneticInfo' */ case 0x01DD:
            /* 'BrtPrintOptions' */ case 0x0218:
            /* 'BrtRangeProtection' */ case 0x044F:
            /* 'BrtRangeProtection14' */ case 0x02A8:
            /* 'BrtRangeProtectionIso' */ case 0x0450:
            /* 'BrtRangeProtectionIso14' */ case 0x0400:
            /* 'BrtRwDescent' */ case 0x0297:
            /* 'BrtSheetCalcProp' */ case 0x0217:
            /* 'BrtSheetProtection' */ case 0x02A6:
            /* 'BrtSheetProtectionIso' */ case 0x01F8:
            /* 'BrtSlc' */ case 0x0413:
            /* 'BrtSparkline' */ case 0x01AC:
            /* 'BrtTable' */ case 0x00AA:
            /* 'BrtTop10Filter' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0032:
            /* 'BrtValueMeta' */ case 0x0816:
            /* 'BrtWebExtension' */ case 0x0415:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            default:
                if (RR.T) ;
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    delete opts.supbooks;
    delete opts['!row'];
    if (!s["!ref"] && (refguess.s.r < 2000000 || ref && (ref.e.r > 0 || ref.e.c > 0 || ref.s.r > 0 || ref.s.c > 0))) s["!ref"] = $a1a91b25d7598376$var$encode_range(ref || refguess);
    if (opts.sheetRows && s["!ref"]) {
        var tmpref = $a1a91b25d7598376$var$safe_decode_range(s["!ref"]);
        if (opts.sheetRows <= +tmpref.e.r) {
            tmpref.e.r = opts.sheetRows - 1;
            if (tmpref.e.r > refguess.e.r) tmpref.e.r = refguess.e.r;
            if (tmpref.e.r < tmpref.s.r) tmpref.s.r = tmpref.e.r;
            if (tmpref.e.c > refguess.e.c) tmpref.e.c = refguess.e.c;
            if (tmpref.e.c < tmpref.s.c) tmpref.s.c = tmpref.e.c;
            s["!fullref"] = s["!ref"];
            s["!ref"] = $a1a91b25d7598376$var$encode_range(tmpref);
        }
    }
    if (merges.length > 0) s["!merges"] = merges;
    if (colinfo.length > 0) s["!cols"] = colinfo;
    if (rowinfo.length > 0) s["!rows"] = rowinfo;
    if (rels['!id'][s['!legrel']]) s['!legdrawel'] = rels['!id'][s['!legrel']];
    return s;
}
/* TODO: something useful -- this is a stub */ function $a1a91b25d7598376$var$write_ws_bin_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, ws /*:Worksheet*/ , last_seen /*:boolean*/ , date1904 /*:boolean*/ ) /*:boolean*/ {
    var o /*:any*/  = {
        r: R,
        c: C
    } /*:any*/ ;
    if (cell.c) ws['!comments'].push([
        $a1a91b25d7598376$var$encode_cell(o),
        cell.c
    ]);
    if (cell.v === undefined) return false;
    var vv = "";
    switch(cell.t){
        case 'b':
            vv = cell.v ? "1" : "0";
            break;
        case 'd':
            cell = $a1a91b25d7598376$var$dup(cell);
            cell.z = cell.z || $a1a91b25d7598376$var$table_fmt[14];
            cell.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v, date1904), date1904);
            cell.t = 'n';
            break;
        /* falls through */ case 'n':
        case 'e':
            vv = '' + cell.v;
            break;
        default:
            vv = cell.v;
            break;
    }
    /* TODO: cell style */ o.s = $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.l) ws['!links'].push([
        $a1a91b25d7598376$var$encode_cell(o),
        cell.l
    ]);
    switch(cell.t){
        case 's':
        case 'str':
            if (opts.bookSST) {
                vv = $a1a91b25d7598376$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                o.t = "s";
                o.v = vv;
                if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x0012 /* BrtShortIsst */ , $a1a91b25d7598376$var$write_BrtShortIsst(cell, o));
                else $a1a91b25d7598376$var$write_record(ba, 0x0007 /* BrtCellIsst */ , $a1a91b25d7598376$var$write_BrtCellIsst(cell, o));
            } else {
                o.t = "str";
                if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x0011 /* BrtShortSt */ , $a1a91b25d7598376$var$write_BrtShortSt(cell, o));
                else $a1a91b25d7598376$var$write_record(ba, 0x0006 /* BrtCellSt */ , $a1a91b25d7598376$var$write_BrtCellSt(cell, o));
            }
            return true;
        case 'n':
            /* TODO: determine threshold for Real vs RK */ if (cell.v == (cell.v | 0) && cell.v > -1000 && cell.v < 1000) {
                if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000D /* BrtShortRk */ , $a1a91b25d7598376$var$write_BrtShortRk(cell, o));
                else $a1a91b25d7598376$var$write_record(ba, 0x0002 /* BrtCellRk */ , $a1a91b25d7598376$var$write_BrtCellRk(cell, o));
            } else if (!isFinite(cell.v)) {
                o.t = "e";
                if (isNaN(cell.v)) {
                    if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000E /* BrtShortError */ , $a1a91b25d7598376$var$write_BrtShortError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                    else $a1a91b25d7598376$var$write_record(ba, 0x0003 /* BrtCellError */ , $a1a91b25d7598376$var$write_BrtCellError({
                        t: "e",
                        v: 0x24
                    }, o)); // #NUM!
                } else if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000E /* BrtShortError */ , $a1a91b25d7598376$var$write_BrtShortError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
                else $a1a91b25d7598376$var$write_record(ba, 0x0003 /* BrtCellError */ , $a1a91b25d7598376$var$write_BrtCellError({
                    t: "e",
                    v: 0x07
                }, o)); // #DIV/0!
            } else if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x0010 /* BrtShortReal */ , $a1a91b25d7598376$var$write_BrtShortReal(cell, o));
            else $a1a91b25d7598376$var$write_record(ba, 0x0005 /* BrtCellReal */ , $a1a91b25d7598376$var$write_BrtCellReal(cell, o));
            return true;
        case 'b':
            o.t = "b";
            if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000F /* BrtShortBool */ , $a1a91b25d7598376$var$write_BrtShortBool(cell, o));
            else $a1a91b25d7598376$var$write_record(ba, 0x0004 /* BrtCellBool */ , $a1a91b25d7598376$var$write_BrtCellBool(cell, o));
            return true;
        case 'e':
            o.t = "e";
            if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000E /* BrtShortError */ , $a1a91b25d7598376$var$write_BrtShortError(cell, o));
            else $a1a91b25d7598376$var$write_record(ba, 0x0003 /* BrtCellError */ , $a1a91b25d7598376$var$write_BrtCellError(cell, o));
            return true;
    }
    if (last_seen) $a1a91b25d7598376$var$write_record(ba, 0x000C /* BrtShortBlank */ , $a1a91b25d7598376$var$write_BrtShortBlank(cell, o));
    else $a1a91b25d7598376$var$write_record(ba, 0x0001 /* BrtCellBlank */ , $a1a91b25d7598376$var$write_BrtCellBlank(cell, o));
    return true;
}
function $a1a91b25d7598376$var$write_CELLTABLE(ba, ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    $a1a91b25d7598376$var$write_record(ba, 0x0091 /* BrtBeginSheetData */ );
    var dense = ws["!data"] != null, row = dense ? ws["!data"][range.s.r] : [];
    var cap = range.e.r;
    if (ws['!rows']) cap = Math.max(range.e.r, ws['!rows'].length - 1);
    for(var R = range.s.r; R <= cap; ++R){
        rr = $a1a91b25d7598376$var$encode_row(R);
        if (dense) row = ws["!data"][R];
        /* [ACCELLTABLE] */ /* BrtRowHdr */ $a1a91b25d7598376$var$write_row_header(ba, ws, range, R);
        if (dense && !row) continue;
        var last_seen = false;
        if (R <= range.e.r) for(var C = range.s.c; C <= range.e.c; ++C){
            /* *16384CELL */ if (R === range.s.r) cols[C] = $a1a91b25d7598376$var$encode_col(C);
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) {
                last_seen = false;
                continue;
            }
            /* write cell */ last_seen = $a1a91b25d7598376$var$write_ws_bin_cell(ba, cell, R, C, opts, ws, last_seen, date1904);
        }
    }
    $a1a91b25d7598376$var$write_record(ba, 0x0092 /* BrtEndSheetData */ );
}
function $a1a91b25d7598376$var$write_MERGECELLS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!merges']) return;
    $a1a91b25d7598376$var$write_record(ba, 0x00B1 /* BrtBeginMergeCells */ , $a1a91b25d7598376$var$write_BrtBeginMergeCells(ws['!merges'].length));
    ws['!merges'].forEach(function(m) {
        $a1a91b25d7598376$var$write_record(ba, 0x00B0 /* BrtMergeCell */ , $a1a91b25d7598376$var$write_BrtMergeCell(m));
    });
    $a1a91b25d7598376$var$write_record(ba, 0x00B2 /* BrtEndMergeCells */ );
}
function $a1a91b25d7598376$var$write_COLINFOS(ba, ws /*:Worksheet*/  /*::, idx:number, opts, wb:Workbook*/ ) {
    if (!ws || !ws['!cols']) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0186 /* BrtBeginColInfos */ );
    ws['!cols'].forEach(function(m, i) {
        if (m) $a1a91b25d7598376$var$write_record(ba, 0x003C /* 'BrtColInfo' */ , $a1a91b25d7598376$var$write_BrtColInfo(i, m));
    });
    $a1a91b25d7598376$var$write_record(ba, 0x0187 /* BrtEndColInfos */ );
}
function $a1a91b25d7598376$var$write_IGNOREECS(ba, ws /*:Worksheet*/ ) {
    if (!ws || !ws['!ref']) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0288 /* BrtBeginCellIgnoreECs */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0289 /* BrtCellIgnoreEC */ , $a1a91b25d7598376$var$write_BrtCellIgnoreEC($a1a91b25d7598376$var$safe_decode_range(ws['!ref'])));
    $a1a91b25d7598376$var$write_record(ba, 0x028A /* BrtEndCellIgnoreECs */ );
}
function $a1a91b25d7598376$var$write_HLINKS(ba, ws /*:Worksheet*/ , rels) {
    /* *BrtHLink */ ws['!links'].forEach(function(l) {
        if (!l[1].Target) return;
        var rId = $a1a91b25d7598376$var$add_rels(rels, -1, l[1].Target.replace(/#[\s\S]*$/, ""), $a1a91b25d7598376$var$RELS.HLINK);
        $a1a91b25d7598376$var$write_record(ba, 0x01EE /* BrtHLink */ , $a1a91b25d7598376$var$write_BrtHLink(l, rId));
    });
    delete ws['!links'];
}
function $a1a91b25d7598376$var$write_LEGACYDRAWING(ba, ws /*:Worksheet*/ , idx /*:number*/ , rels) {
    /* [BrtLegacyDrawing] */ if (ws['!comments'].length > 0) {
        var rId = $a1a91b25d7598376$var$add_rels(rels, -1, "../drawings/vmlDrawing" + (idx + 1) + ".vml", $a1a91b25d7598376$var$RELS.VML);
        $a1a91b25d7598376$var$write_record(ba, 0x0227 /* BrtLegacyDrawing */ , $a1a91b25d7598376$var$write_RelID("rId" + rId));
        ws['!legacy'] = rId;
    }
}
function $a1a91b25d7598376$var$write_AUTOFILTER(ba, ws, wb, idx) {
    if (!ws['!autofilter']) return;
    var data = ws['!autofilter'];
    var ref = typeof data.ref === "string" ? data.ref : $a1a91b25d7598376$var$encode_range(data.ref);
    /* Update FilterDatabase defined name for the worksheet */ if (!wb.Workbook) wb.Workbook = {
        Sheets: []
    } /*:any*/ ;
    if (!wb.Workbook.Names) wb.Workbook.Names = [];
    var names /*: Array<any> */  = wb.Workbook.Names;
    var range = $a1a91b25d7598376$var$decode_range(ref);
    if (range.s.r == range.e.r) {
        range.e.r = $a1a91b25d7598376$var$decode_range(ws["!ref"]).e.r;
        ref = $a1a91b25d7598376$var$encode_range(range);
    }
    for(var i = 0; i < names.length; ++i){
        var name = names[i];
        if (name.Name != '_xlnm._FilterDatabase') continue;
        if (name.Sheet != idx) continue;
        name.Ref = $a1a91b25d7598376$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $a1a91b25d7598376$var$fix_range(ref);
        break;
    }
    if (i == names.length) names.push({
        Name: '_xlnm._FilterDatabase',
        Sheet: idx,
        Ref: $a1a91b25d7598376$var$formula_quote_sheet_name(wb.SheetNames[idx]) + "!" + $a1a91b25d7598376$var$fix_range(ref)
    });
    $a1a91b25d7598376$var$write_record(ba, 0x00A1 /* BrtBeginAFilter */ , $a1a91b25d7598376$var$write_UncheckedRfX($a1a91b25d7598376$var$safe_decode_range(ref)));
    /* *FILTERCOLUMN */ /* [SORTSTATE] */ /* BrtEndAFilter */ $a1a91b25d7598376$var$write_record(ba, 0x00A2 /* BrtEndAFilter */ );
}
function $a1a91b25d7598376$var$write_WSVIEWS2(ba, ws, Workbook) {
    $a1a91b25d7598376$var$write_record(ba, 0x0085 /* BrtBeginWsViews */ );
    /* [ACUID] */ $a1a91b25d7598376$var$write_record(ba, 0x0089 /* BrtBeginWsView */ , $a1a91b25d7598376$var$write_BrtBeginWsView(ws, Workbook));
    /* [BrtPane] */ /* *4BrtSel */ /* *4SXSELECT */ /* *FRT */ $a1a91b25d7598376$var$write_record(ba, 0x008A /* BrtEndWsView */ );
    /* *FRT */ $a1a91b25d7598376$var$write_record(ba, 0x0086 /* BrtEndWsViews */ );
}
function $a1a91b25d7598376$var$write_WSFMTINFO() {
/* [ACWSFMTINFO] */ // write_record(ba, 0x01E5 /* BrtWsFmtInfo */, write_BrtWsFmtInfo(ws));
}
function $a1a91b25d7598376$var$write_SHEETPROTECT(ba, ws) {
    if (!ws['!protect']) return;
    /* [BrtSheetProtectionIso] */ $a1a91b25d7598376$var$write_record(ba, 0x0217 /* BrtSheetProtection */ , $a1a91b25d7598376$var$write_BrtSheetProtection(ws['!protect']));
}
function $a1a91b25d7598376$var$write_ws_bin(idx /*:number*/ , opts, wb /*:Workbook*/ , rels) {
    var ba = $a1a91b25d7598376$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var c /*:string*/  = s;
    try {
        if (wb && wb.Workbook) c = wb.Workbook.Sheets[idx].CodeName || c;
    } catch (e) {}
    var r = $a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1");
    if (r.e.c > 0x3FFF || r.e.r > 0xFFFFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:XFD1048576");
        r.e.c = Math.min(r.e.c, 0x3FFF);
        r.e.r = Math.min(r.e.c, 0xFFFFF);
    }
    ws['!links'] = [];
    /* passed back to write_zip and removed there */ ws['!comments'] = [];
    $a1a91b25d7598376$var$write_record(ba, 0x0081 /* BrtBeginSheet */ );
    if (wb.vbaraw || ws['!outline']) $a1a91b25d7598376$var$write_record(ba, 0x0093 /* BrtWsProp */ , $a1a91b25d7598376$var$write_BrtWsProp(c, ws['!outline']));
    $a1a91b25d7598376$var$write_record(ba, 0x0094 /* BrtWsDim */ , $a1a91b25d7598376$var$write_BrtWsDim(r));
    $a1a91b25d7598376$var$write_WSVIEWS2(ba, ws, wb.Workbook);
    $a1a91b25d7598376$var$write_WSFMTINFO(ba, ws);
    $a1a91b25d7598376$var$write_COLINFOS(ba, ws, idx, opts, wb);
    $a1a91b25d7598376$var$write_CELLTABLE(ba, ws, idx, opts, wb);
    /* [BrtSheetCalcProp] */ $a1a91b25d7598376$var$write_SHEETPROTECT(ba, ws);
    /* *([BrtRangeProtectionIso] BrtRangeProtection) */ /* [SCENMAN] */ $a1a91b25d7598376$var$write_AUTOFILTER(ba, ws, wb, idx);
    /* [SORTSTATE] */ /* [DCON] */ /* [USERSHVIEWS] */ $a1a91b25d7598376$var$write_MERGECELLS(ba, ws);
    /* [BrtPhoneticInfo] */ /* *CONDITIONALFORMATTING */ /* [DVALS] */ $a1a91b25d7598376$var$write_HLINKS(ba, ws, rels);
    /* [BrtPrintOptions] */ if (ws['!margins']) $a1a91b25d7598376$var$write_record(ba, 0x01DC /* BrtMargins */ , $a1a91b25d7598376$var$write_BrtMargins(ws['!margins']));
    /* [BrtPageSetup] */ /* [HEADERFOOTER] */ /* [RWBRK] */ /* [COLBRK] */ /* *BrtBigName */ /* [CELLWATCHES] */ if (!opts || opts.ignoreEC || opts.ignoreEC == void 0) $a1a91b25d7598376$var$write_IGNOREECS(ba, ws);
    /* [SMARTTAGS] */ /* [BrtDrawing] */ $a1a91b25d7598376$var$write_LEGACYDRAWING(ba, ws, idx, rels);
    /* [BrtLegacyDrawingHF] */ /* [BrtBkHim] */ /* [OLEOBJECTS] */ /* [ACTIVEXCONTROLS] */ /* [WEBPUBITEMS] */ /* [LISTPARTS] */ /* FRTWORKSHEET */ $a1a91b25d7598376$var$write_record(ba, 0x0082 /* BrtEndSheet */ );
    return ba.end();
}
function $a1a91b25d7598376$var$parse_Cache(data /*:string*/ ) /*:[Array<number|string>, string, ?string]*/ {
    var col /*:Array<number|string>*/  = [];
    var num = data.match(/^<c:numCache>/);
    var f;
    /* 21.2.2.150 pt CT_NumVal */ (data.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<])<\/c:v><\/c:pt>/mg) || []).forEach(function(pt) {
        var q = pt.match(/<c:pt idx="(\d*)"[^<>\/]*><c:v>([^<]*)<\/c:v><\/c:pt>/);
        if (!q) return;
        col[+q[1]] = num ? +q[2] : q[2];
    });
    /* 21.2.2.71 formatCode CT_Xstring */ var nf = $a1a91b25d7598376$var$unescapexml(($a1a91b25d7598376$var$str_match_xml(data, "c:formatCode") || [
        "",
        "General"
    ])[1]);
    ($a1a91b25d7598376$var$str_match_ng(data, "<c:f>", "</c:f>") || []).forEach(function(F) {
        f = F.replace(/<[^<>]*>/g, "");
    });
    return [
        col,
        nf,
        f
    ];
}
/* 21.2 DrawingML - Charts */ function $a1a91b25d7598376$var$parse_chart(data /*:?string*/ , name /*:string*/ , opts, rels, wb, csheet) {
    var cs /*:Worksheet*/  = csheet || {
        "!type": "chart"
    };
    if (!data) return csheet;
    /* 21.2.2.27 chart CT_Chart */ var C = 0, R = 0, col = "A";
    var refguess = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    /* 21.2.2.120 numCache CT_NumData */ ($a1a91b25d7598376$var$str_match_ng(data, "<c:numCache>", "</c:numCache>") || []).forEach(function(nc) {
        var cache = $a1a91b25d7598376$var$parse_Cache(nc);
        refguess.s.r = refguess.s.c = 0;
        refguess.e.c = C;
        col = $a1a91b25d7598376$var$encode_col(C);
        cache[0].forEach(function(n, i) {
            if (cs["!data"]) {
                if (!cs["!data"][i]) cs["!data"][i] = [];
                cs["!data"][i][C] = {
                    t: 'n',
                    v: n,
                    z: cache[1]
                };
            } else cs[col + $a1a91b25d7598376$var$encode_row(i)] = {
                t: 'n',
                v: n,
                z: cache[1]
            };
            R = i;
        });
        if (refguess.e.r < R) refguess.e.r = R;
        ++C;
    });
    if (C > 0) cs["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
    return cs;
}
/* 18.3 Worksheets also covers Chartsheets */ function $a1a91b25d7598376$var$parse_cs_xml(data /*:?string*/ , opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    /* 18.3.1.12 chartsheet CT_ChartSheet */ if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    } /*:any*/ ;
    var m;
    /* 18.3.1.83 sheetPr CT_ChartsheetPr */ var sheetPr = data.match($a1a91b25d7598376$var$sheetprregex);
    if (sheetPr) $a1a91b25d7598376$var$parse_ws_xml_sheetpr(sheetPr[0], s, wb, idx);
    /* 18.3.1.36 drawing CT_Drawing */ if (m = data.match(/drawing r:id="(.*?)"/)) s['!rel'] = m[1];
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_xml(idx/*:number*/, opts, wb/*:Workbook*/, rels)/*:string*/ {
//	var o = [XML_HEADER, writextag('chartsheet', null, {
//		'xmlns': XMLNS_main[0],
//		'xmlns:r': XMLNS.r
//	})];
//	o[o.length] = writextag("drawing", null, {"r:id": "rId1"});
//	add_rels(rels, -1, "../drawings/drawing" + (idx+1) + ".xml", RELS.DRAW);
//	if(o.length>2) { o[o.length] = ('</chartsheet>'); o[1]=o[1].replace("/>",">"); }
//	return o.join("");
//}
/* [MS-XLSB] 2.4.331 BrtCsProp */ function $a1a91b25d7598376$var$parse_BrtCsProp(data, length /*:number*/ ) {
    data.l += 10;
    var name = $a1a91b25d7598376$var$parse_XLWideString(data, length - 10);
    return {
        name: name
    };
}
/* [MS-XLSB] 2.1.7.7 Chart Sheet */ function $a1a91b25d7598376$var$parse_cs_bin(data, opts, idx /*:number*/ , rels, wb /*::, themes, styles*/ ) /*:Worksheet*/ {
    if (!data) return data;
    if (!rels) rels = {
        '!id': {}
    };
    var s = {
        '!type': "chart",
        '!drawel': null,
        '!rel': ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    $a1a91b25d7598376$var$recordhopper(data, function cs_parse(val1, R, RT) {
        switch(RT){
            case 0x0226:
                /* 'BrtDrawing' */ s['!rel'] = val1;
                break;
            case 0x028B:
                /* 'BrtCsProp' */ if (!wb.Sheets[idx]) wb.Sheets[idx] = {};
                if (val1.name) wb.Sheets[idx].CodeName = val1.name;
                break;
            case 0x0232:
            /* 'BrtBkHim' */ case 0x028C:
            /* 'BrtCsPageSetup' */ case 0x029D:
            /* 'BrtCsProtection' */ case 0x02A7:
            /* 'BrtCsProtectionIso' */ case 0x0227:
            /* 'BrtLegacyDrawing' */ case 0x0228:
            /* 'BrtLegacyDrawingHF' */ case 0x01DC:
            /* 'BrtMargins' */ case 0x0C00:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                break;
            default:
                if (R.T > 0) state.push(RT);
                else if (R.T < 0) state.pop();
                else if (!pass || opts.WTF) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    if (rels['!id'][s['!rel']]) s['!drawel'] = rels['!id'][s['!rel']];
    return s;
}
//function write_cs_bin(/*::idx:number, opts, wb:Workbook, rels*/) {
//	var ba = buf_array();
//	write_record(ba, 0x0081 /* BrtBeginSheet */);
//	/* [BrtCsProp] */
//	/* CSVIEWS */
//	/* [[BrtCsProtectionIso] BrtCsProtection] */
//	/* [USERCSVIEWS] */
//	/* [BrtMargins] */
//	/* [BrtCsPageSetup] */
//	/* [HEADERFOOTER] */
//	/* BrtDrawing */
//	/* [BrtLegacyDrawing] */
//	/* [BrtLegacyDrawingHF] */
//	/* [BrtBkHim] */
//	/* [WEBPUBITEMS] */
//	/* FRTCHARTSHEET */
//	write_record(ba, 0x0082 /* BrtEndSheet */);
//	return ba.end();
//}
/* 18.2.28 (CT_WorkbookProtection) Defaults */ var $a1a91b25d7598376$var$WBPropsDef = [
    [
        'allowRefreshQuery',
        false,
        "bool"
    ],
    [
        'autoCompressPictures',
        true,
        "bool"
    ],
    [
        'backupFile',
        false,
        "bool"
    ],
    [
        'checkCompatibility',
        false,
        "bool"
    ],
    [
        'CodeName',
        ''
    ],
    [
        'date1904',
        false,
        "bool"
    ],
    [
        'defaultThemeVersion',
        0,
        "int"
    ],
    [
        'filterPrivacy',
        false,
        "bool"
    ],
    [
        'hidePivotFieldList',
        false,
        "bool"
    ],
    [
        'promptedSolutions',
        false,
        "bool"
    ],
    [
        'publishItems',
        false,
        "bool"
    ],
    [
        'refreshAllConnections',
        false,
        "bool"
    ],
    [
        'saveExternalLinkValues',
        true,
        "bool"
    ],
    [
        'showBorderUnselectedTables',
        true,
        "bool"
    ],
    [
        'showInkAnnotation',
        true,
        "bool"
    ],
    [
        'showObjects',
        'all'
    ],
    [
        'showPivotChartFilter',
        false,
        "bool"
    ],
    [
        'updateLinks',
        'userSet'
    ]
];
/* 18.2.30 (CT_BookView) Defaults */ var $a1a91b25d7598376$var$WBViewDef = [
    [
        'activeTab',
        0,
        "int"
    ],
    [
        'autoFilterDateGrouping',
        true,
        "bool"
    ],
    [
        'firstSheet',
        0,
        "int"
    ],
    [
        'minimized',
        false,
        "bool"
    ],
    [
        'showHorizontalScroll',
        true,
        "bool"
    ],
    [
        'showSheetTabs',
        true,
        "bool"
    ],
    [
        'showVerticalScroll',
        true,
        "bool"
    ],
    [
        'tabRatio',
        600,
        "int"
    ],
    [
        'visibility',
        'visible'
    ]
];
/* 18.2.19 (CT_Sheet) Defaults */ var $a1a91b25d7598376$var$SheetDef = [];
/* 18.2.2  (CT_CalcPr) Defaults */ var $a1a91b25d7598376$var$CalcPrDef = [
    [
        'calcCompleted',
        'true'
    ],
    [
        'calcMode',
        'auto'
    ],
    [
        'calcOnSave',
        'true'
    ],
    [
        'concurrentCalc',
        'true'
    ],
    [
        'fullCalcOnLoad',
        'false'
    ],
    [
        'fullPrecision',
        'true'
    ],
    [
        'iterate',
        'false'
    ],
    [
        'iterateCount',
        '100'
    ],
    [
        'iterateDelta',
        '0.001'
    ],
    [
        'refMode',
        'A1'
    ]
];
/* 18.2.3 (CT_CustomWorkbookView) Defaults */ /*var CustomWBViewDef = [
	['autoUpdate', 'false'],
	['changesSavedWin', 'false'],
	['includeHiddenRowCol', 'true'],
	['includePrintSettings', 'true'],
	['maximized', 'false'],
	['minimized', 'false'],
	['onlySync', 'false'],
	['personalView', 'false'],
	['showComments', 'commIndicator'],
	['showFormulaBar', 'true'],
	['showHorizontalScroll', 'true'],
	['showObjects', 'all'],
	['showSheetTabs', 'true'],
	['showStatusbar', 'true'],
	['showVerticalScroll', 'true'],
	['tabRatio', '600'],
	['xWindow', '0'],
	['yWindow', '0']
];*/ function $a1a91b25d7598376$var$push_defaults_array(target, defaults) {
    for(var j = 0; j != target.length; ++j){
        var w = target[j];
        for(var i = 0; i != defaults.length; ++i){
            var z = defaults[i];
            if (w[z[0]] == null) w[z[0]] = z[1];
            else switch(z[2]){
                case "bool":
                    if (typeof w[z[0]] == "string") w[z[0]] = $a1a91b25d7598376$var$parsexmlbool(w[z[0]]);
                    break;
                case "int":
                    if (typeof w[z[0]] == "string") w[z[0]] = parseInt(w[z[0]], 10);
                    break;
            }
        }
    }
}
function $a1a91b25d7598376$var$push_defaults(target, defaults) {
    for(var i = 0; i != defaults.length; ++i){
        var z = defaults[i];
        if (target[z[0]] == null) target[z[0]] = z[1];
        else switch(z[2]){
            case "bool":
                if (typeof target[z[0]] == "string") target[z[0]] = $a1a91b25d7598376$var$parsexmlbool(target[z[0]]);
                break;
            case "int":
                if (typeof target[z[0]] == "string") target[z[0]] = parseInt(target[z[0]], 10);
                break;
        }
    }
}
function $a1a91b25d7598376$var$parse_wb_defaults(wb) {
    $a1a91b25d7598376$var$push_defaults(wb.WBProps, $a1a91b25d7598376$var$WBPropsDef);
    $a1a91b25d7598376$var$push_defaults(wb.CalcPr, $a1a91b25d7598376$var$CalcPrDef);
    $a1a91b25d7598376$var$push_defaults_array(wb.WBView, $a1a91b25d7598376$var$WBViewDef);
    $a1a91b25d7598376$var$push_defaults_array(wb.Sheets, $a1a91b25d7598376$var$SheetDef);
    $a1a91b25d7598376$var$_ssfopts.date1904 = $a1a91b25d7598376$var$parsexmlbool(wb.WBProps.date1904);
}
function $a1a91b25d7598376$var$safe1904(wb /*:Workbook*/ ) /*:string*/ {
    /* TODO: store date1904 somewhere else */ if (!wb.Workbook) return "false";
    if (!wb.Workbook.WBProps) return "false";
    return $a1a91b25d7598376$var$parsexmlbool(wb.Workbook.WBProps.date1904) ? "true" : "false";
}
var $a1a91b25d7598376$var$badchars = /*#__PURE__*/ ":][*?\/\\".split("");
function $a1a91b25d7598376$var$check_ws_name(n /*:string*/ , safe /*:?boolean*/ ) /*:boolean*/ {
    try {
        if (n == "") throw new Error("Sheet name cannot be blank");
        if (n.length > 31) throw new Error("Sheet name cannot exceed 31 chars");
        if (n.charCodeAt(0) == 0x27 || n.charCodeAt(n.length - 1) == 0x27) throw new Error("Sheet name cannot start or end with apostrophe (')");
        if (n.toLowerCase() == "history") throw new Error("Sheet name cannot be 'History'");
        $a1a91b25d7598376$var$badchars.forEach(function(c) {
            if (n.indexOf(c) == -1) return;
            throw new Error("Sheet name cannot contain : \\ / ? * [ ]");
        });
    } catch (e) {
        if (safe) return false;
        throw e;
    }
    return true;
}
function $a1a91b25d7598376$var$check_wb_names(N, S, codes) {
    N.forEach(function(n, i) {
        $a1a91b25d7598376$var$check_ws_name(n);
        for(var j = 0; j < i; ++j)if (n == N[j]) throw new Error("Duplicate Sheet Name: " + n);
        if (codes) {
            var cn = S && S[i] && S[i].CodeName || n;
            if (cn.charCodeAt(0) == 95 && cn.length > 22) throw new Error("Bad Code Name: Worksheet" + cn);
        }
    });
}
function $a1a91b25d7598376$var$check_wb(wb) {
    if (!wb || !wb.SheetNames || !wb.Sheets) throw new Error("Invalid Workbook");
    if (!wb.SheetNames.length) throw new Error("Workbook is empty");
    var Sheets = wb.Workbook && wb.Workbook.Sheets || [];
    $a1a91b25d7598376$var$check_wb_names(wb.SheetNames, Sheets, !!wb.vbaraw);
    for(var i = 0; i < wb.SheetNames.length; ++i)$a1a91b25d7598376$var$check_ws(wb.Sheets[wb.SheetNames[i]], wb.SheetNames[i], i);
    wb.SheetNames.forEach(function(n, i) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!autofilter"]) return;
        var DN;
        if (!wb.Workbook) wb.Workbook = {};
        if (!wb.Workbook.Names) wb.Workbook.Names = [];
        wb.Workbook.Names.forEach(function(dn) {
            if (dn.Name == "_xlnm._FilterDatabase" && dn.Sheet == i) DN = dn;
        });
        var nn = $a1a91b25d7598376$var$formula_quote_sheet_name(n) + "!" + $a1a91b25d7598376$var$fix_range(ws["!autofilter"].ref);
        if (DN) DN.Ref = nn;
        else wb.Workbook.Names.push({
            Name: "_xlnm._FilterDatabase",
            Sheet: i,
            Ref: nn
        });
    });
/* TODO: validate workbook */ }
/* 18.2 Workbook */ var $a1a91b25d7598376$var$wbnsregex = /<\w+:workbook/;
function $a1a91b25d7598376$var$parse_wb_xml(data, opts) /*:WorkbookFile*/ {
    if (!data) throw new Error("Could not find file");
    var wb = /*::(*/ {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        Names: [],
        xmlns: ""
    } /*::)*/ ;
    var pass = false, xmlns = "xmlns";
    var dname = {}, dnstart = 0;
    data.replace($a1a91b25d7598376$var$tagregex, function xml_wb(x, idx) {
        var y /*:any*/  = $a1a91b25d7598376$var$parsexmltag(x);
        switch($a1a91b25d7598376$var$strip_ns(y[0])){
            case '<?xml':
                break;
            /* 18.2.27 workbook CT_Workbook 1 */ case '<workbook':
                if (x.match($a1a91b25d7598376$var$wbnsregex)) xmlns = "xmlns" + x.match(/<(\w+):/)[1];
                wb.xmlns = y[xmlns];
                break;
            case '</workbook>':
                break;
            /* 18.2.13 fileVersion CT_FileVersion ? */ case '<fileVersion':
                delete y[0];
                wb.AppVersion = y;
                break;
            case '<fileVersion/>':
            case '</fileVersion>':
                break;
            /* 18.2.12 fileSharing CT_FileSharing ? */ case '<fileSharing':
                break;
            case '<fileSharing/>':
                break;
            /* 18.2.28 workbookPr CT_WorkbookPr ? */ case '<workbookPr':
            case '<workbookPr/>':
                $a1a91b25d7598376$var$WBPropsDef.forEach(function(w) {
                    if (y[w[0]] == null) return;
                    switch(w[2]){
                        case "bool":
                            wb.WBProps[w[0]] = $a1a91b25d7598376$var$parsexmlbool(y[w[0]]);
                            break;
                        case "int":
                            wb.WBProps[w[0]] = parseInt(y[w[0]], 10);
                            break;
                        default:
                            wb.WBProps[w[0]] = y[w[0]];
                    }
                });
                if (y.codeName) wb.WBProps.CodeName = $a1a91b25d7598376$var$utf8read(y.codeName);
                break;
            case '</workbookPr>':
                break;
            /* 18.2.29 workbookProtection CT_WorkbookProtection ? */ case '<workbookProtection':
                break;
            case '<workbookProtection/>':
                break;
            /* 18.2.1  bookViews CT_BookViews ? */ case '<bookViews':
            case '<bookViews>':
            case '</bookViews>':
                break;
            /* 18.2.30   workbookView CT_BookView + */ case '<workbookView':
            case '<workbookView/>':
                delete y[0];
                wb.WBView.push(y);
                break;
            case '</workbookView>':
                break;
            /* 18.2.20 sheets CT_Sheets 1 */ case '<sheets':
            case '<sheets>':
            case '</sheets>':
                break; // aggregate sheet
            /* 18.2.19   sheet CT_Sheet + */ case '<sheet':
                switch(y.state){
                    case "hidden":
                        y.Hidden = 1;
                        break;
                    case "veryHidden":
                        y.Hidden = 2;
                        break;
                    default:
                        y.Hidden = 0;
                }
                delete y.state;
                y.name = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(y.name));
                delete y[0];
                wb.Sheets.push(y);
                break;
            case '</sheet>':
                break;
            /* 18.2.15 functionGroups CT_FunctionGroups ? */ case '<functionGroups':
            case '<functionGroups/>':
                break;
            /* 18.2.14   functionGroup CT_FunctionGroup + */ case '<functionGroup':
                break;
            /* 18.2.9  externalReferences CT_ExternalReferences ? */ case '<externalReferences':
            case '</externalReferences>':
            case '<externalReferences>':
                break;
            /* 18.2.8    externalReference CT_ExternalReference + */ case '<externalReference':
                break;
            /* 18.2.6  definedNames CT_DefinedNames ? */ case '<definedNames/>':
                break;
            case '<definedNames>':
            case '<definedNames':
                pass = true;
                break;
            case '</definedNames>':
                pass = false;
                break;
            /* 18.2.5    definedName CT_DefinedName + */ case '<definedName':
                dname = {};
                dname.Name = $a1a91b25d7598376$var$utf8read(y.name);
                if (y.comment) dname.Comment = y.comment;
                if (y.localSheetId) dname.Sheet = +y.localSheetId;
                if ($a1a91b25d7598376$var$parsexmlbool(y.hidden || "0")) dname.Hidden = true;
                dnstart = idx + x.length;
                break;
            case '</definedName>':
                dname.Ref = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$utf8read(data.slice(dnstart, idx)));
                wb.Names.push(dname);
                break;
            case '<definedName/>':
                break;
            /* 18.2.2  calcPr CT_CalcPr ? */ case '<calcPr':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '<calcPr/>':
                delete y[0];
                wb.CalcPr = y;
                break;
            case '</calcPr>':
                break;
            /* 18.2.16 oleSize CT_OleSize ? (ref required) */ case '<oleSize':
                break;
            /* 18.2.4  customWorkbookViews CT_CustomWorkbookViews ? */ case '<customWorkbookViews>':
            case '</customWorkbookViews>':
            case '<customWorkbookViews':
                break;
            /* 18.2.3  customWorkbookView CT_CustomWorkbookView + */ case '<customWorkbookView':
            case '</customWorkbookView>':
                break;
            /* 18.2.18 pivotCaches CT_PivotCaches ? */ case '<pivotCaches>':
            case '</pivotCaches>':
            case '<pivotCaches':
                break;
            /* 18.2.17 pivotCache CT_PivotCache ? */ case '<pivotCache':
                break;
            /* 18.2.21 smartTagPr CT_SmartTagPr ? */ case '<smartTagPr':
            case '<smartTagPr/>':
                break;
            /* 18.2.23 smartTagTypes CT_SmartTagTypes ? */ case '<smartTagTypes':
            case '<smartTagTypes>':
            case '</smartTagTypes>':
                break;
            /* 18.2.22 smartTagType CT_SmartTagType ? */ case '<smartTagType':
                break;
            /* 18.2.24 webPublishing CT_WebPublishing ? */ case '<webPublishing':
            case '<webPublishing/>':
                break;
            /* 18.2.11 fileRecoveryPr CT_FileRecoveryPr ? */ case '<fileRecoveryPr':
            case '<fileRecoveryPr/>':
                break;
            /* 18.2.26 webPublishObjects CT_WebPublishObjects ? */ case '<webPublishObjects>':
            case '<webPublishObjects':
            case '</webPublishObjects>':
                break;
            /* 18.2.25 webPublishObject CT_WebPublishObject ? */ case '<webPublishObject':
                break;
            /* 18.2.10 extLst CT_ExtensionList ? */ case '<extLst':
            case '<extLst>':
            case '</extLst>':
            case '<extLst/>':
                break;
            /* 18.2.7  ext CT_Extension + */ case '<ext':
                pass = true;
                break; //TODO: check with versions of excel
            case '</ext>':
                pass = false;
                break;
            /* Others */ case '<ArchID':
                break;
            case '<AlternateContent':
            case '<AlternateContent>':
                pass = true;
                break;
            case '</AlternateContent>':
                pass = false;
                break;
            /* TODO */ case '<revisionPtr':
                break;
            default:
                if (!pass && opts.WTF) throw new Error('unrecognized ' + y[0] + ' in workbook');
        }
        return x;
    });
    if ($a1a91b25d7598376$var$XMLNS_main.indexOf(wb.xmlns) === -1) throw new Error("Unknown Namespace: " + wb.xmlns);
    $a1a91b25d7598376$var$parse_wb_defaults(wb);
    return wb;
}
function $a1a91b25d7598376$var$write_wb_xml(wb /*:Workbook*/  /*::, opts:?WriteOpts*/ ) /*:string*/ {
    var o = [
        $a1a91b25d7598376$var$XML_HEADER
    ];
    o[o.length] = $a1a91b25d7598376$var$writextag('workbook', null, {
        'xmlns': $a1a91b25d7598376$var$XMLNS_main[0],
        //'xmlns:mx': XMLNS.mx,
        //'xmlns:s': XMLNS_main[0],
        'xmlns:r': $a1a91b25d7598376$var$XMLNS.r
    });
    var write_names = wb.Workbook && (wb.Workbook.Names || []).length > 0;
    /* fileVersion */ /* fileSharing */ var workbookPr /*:any*/  = {
        codeName: "ThisWorkbook"
    } /*:any*/ ;
    if (wb.Workbook && wb.Workbook.WBProps) {
        $a1a91b25d7598376$var$WBPropsDef.forEach(function(x) {
            /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps[x[0]] == null) return;
            if (wb.Workbook.WBProps[x[0]] == x[1]) return;
            workbookPr[x[0]] = wb.Workbook.WBProps[x[0]];
        });
        /*:: if(!wb.Workbook || !wb.Workbook.WBProps) throw "unreachable"; */ if (wb.Workbook.WBProps.CodeName) {
            workbookPr.codeName = wb.Workbook.WBProps.CodeName;
            delete workbookPr.CodeName;
        }
    }
    o[o.length] = $a1a91b25d7598376$var$writextag('workbookPr', null, workbookPr);
    /* workbookProtection */ var sheets = wb.Workbook && wb.Workbook.Sheets || [];
    var i = 0;
    /* bookViews only written if first worksheet is hidden */ if (sheets && sheets[0] && !!sheets[0].Hidden) {
        o[o.length] = "<bookViews>";
        for(i = 0; i != wb.SheetNames.length; ++i){
            if (!sheets[i]) break;
            if (!sheets[i].Hidden) break;
        }
        if (i == wb.SheetNames.length) i = 0;
        o[o.length] = '<workbookView firstSheet="' + i + '" activeTab="' + i + '"/>';
        o[o.length] = "</bookViews>";
    }
    o[o.length] = "<sheets>";
    for(i = 0; i != wb.SheetNames.length; ++i){
        var sht = {
            name: $a1a91b25d7598376$var$escapexml(wb.SheetNames[i].slice(0, 31))
        } /*:any*/ ;
        sht.sheetId = "" + (i + 1);
        sht["r:id"] = "rId" + (i + 1);
        if (sheets[i]) switch(sheets[i].Hidden){
            case 1:
                sht.state = "hidden";
                break;
            case 2:
                sht.state = "veryHidden";
                break;
        }
        o[o.length] = $a1a91b25d7598376$var$writextag('sheet', null, sht);
    }
    o[o.length] = "</sheets>";
    /* functionGroups */ /* externalReferences */ if (write_names) {
        o[o.length] = "<definedNames>";
        if (wb.Workbook && wb.Workbook.Names) wb.Workbook.Names.forEach(function(n) {
            var d /*:any*/  = {
                name: n.Name
            };
            if (n.Comment) d.comment = n.Comment;
            if (n.Sheet != null) d.localSheetId = "" + n.Sheet;
            if (n.Hidden) d.hidden = "1";
            if (!n.Ref) return;
            o[o.length] = $a1a91b25d7598376$var$writextag('definedName', $a1a91b25d7598376$var$escapexml(n.Ref), d);
        });
        o[o.length] = "</definedNames>";
    }
    /* calcPr */ /* oleSize */ /* customWorkbookViews */ /* pivotCaches */ /* smartTagPr */ /* smartTagTypes */ /* webPublishing */ /* fileRecoveryPr */ /* webPublishObjects */ /* extLst */ if (o.length > 2) {
        o[o.length] = '</workbook>';
        o[1] = o[1].replace("/>", ">");
    }
    return o.join("");
}
/* [MS-XLSB] 2.4.304 BrtBundleSh */ function $a1a91b25d7598376$var$parse_BrtBundleSh(data, length /*:number*/ ) {
    var z = {};
    z.Hidden = data.read_shift(4); //hsState ST_SheetState
    z.iTabID = data.read_shift(4);
    z.strRelID = $a1a91b25d7598376$var$parse_RelID(data, length - 8);
    z.name = $a1a91b25d7598376$var$parse_XLWideString(data);
    return z;
}
function $a1a91b25d7598376$var$write_BrtBundleSh(data, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(127);
    o.write_shift(4, data.Hidden);
    o.write_shift(4, data.iTabID);
    $a1a91b25d7598376$var$write_RelID(data.strRelID, o);
    $a1a91b25d7598376$var$write_XLWideString(data.name.slice(0, 31), o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.815 BrtWbProp */ function $a1a91b25d7598376$var$parse_BrtWbProp(data, length) /*:WBProps*/ {
    var o /*:WBProps*/  = {} /*:any*/ ;
    var flags = data.read_shift(4);
    o.defaultThemeVersion = data.read_shift(4);
    var strName = length > 8 ? $a1a91b25d7598376$var$parse_XLWideString(data) : "";
    if (strName.length > 0) o.CodeName = strName;
    o.autoCompressPictures = !!(flags & 0x10000);
    o.backupFile = !!(flags & 0x40);
    o.checkCompatibility = !!(flags & 0x1000);
    o.date1904 = !!(flags & 0x01);
    o.filterPrivacy = !!(flags & 0x08);
    o.hidePivotFieldList = !!(flags & 0x400);
    o.promptedSolutions = !!(flags & 0x10);
    o.publishItems = !!(flags & 0x800);
    o.refreshAllConnections = !!(flags & 0x40000);
    o.saveExternalLinkValues = !!(flags & 0x80);
    o.showBorderUnselectedTables = !!(flags & 0x04);
    o.showInkAnnotation = !!(flags & 0x20);
    o.showObjects = [
        "all",
        "placeholders",
        "none"
    ][flags >> 13 & 0x03];
    o.showPivotChartFilter = !!(flags & 0x8000);
    o.updateLinks = [
        "userSet",
        "never",
        "always"
    ][flags >> 8 & 0x03];
    return o;
}
function $a1a91b25d7598376$var$write_BrtWbProp(data /*:?WBProps*/ , o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(72);
    var flags = 0;
    if (data) {
        /* TODO: mirror parse_BrtWbProp fields */ if (data.date1904) flags |= 0x01;
        if (data.filterPrivacy) flags |= 0x08;
    }
    o.write_shift(4, flags);
    o.write_shift(4, 0);
    $a1a91b25d7598376$var$write_XLSBCodeName(data && data.CodeName || "ThisWorkbook", o);
    return o.slice(0, o.l);
}
function $a1a91b25d7598376$var$parse_BrtFRTArchID$(data, length) {
    var o = {};
    data.read_shift(4);
    o.ArchID = data.read_shift(4);
    data.l += length - 8;
    return o;
}
/* [MS-XLSB] 2.4.687 BrtName */ function $a1a91b25d7598376$var$parse_BrtName(data, length, opts) {
    var end = data.l + length;
    var flags = data.read_shift(4);
    data.l += 1; //var chKey = data.read_shift(1);
    var itab = data.read_shift(4);
    var name = $a1a91b25d7598376$var$parse_XLNameWideString(data);
    var formula;
    var comment = "";
    try {
        formula = $a1a91b25d7598376$var$parse_XLSBNameParsedFormula(data, 0, opts);
        try {
            comment = $a1a91b25d7598376$var$parse_XLNullableWideString(data);
        } catch (e) {}
    } catch (e) {
        console.error("Could not parse defined name " + name);
    }
    if (flags & 0x20) name = "_xlnm." + name;
    //if(0 /* fProc */) {
    // unusedstring1: XLNullableWideString
    // description: XLNullableWideString
    // helpTopic: XLNullableWideString
    // unusedstring2: XLNullableWideString
    //}
    data.l = end;
    var out = {
        Name: name,
        Ptg: formula,
        Flags: flags
    } /*:any*/ ;
    if (itab < 0xFFFFFFF) out.Sheet = itab;
    if (comment) out.Comment = comment;
    return out;
}
function $a1a91b25d7598376$var$write_BrtName(name, wb) {
    var o = $a1a91b25d7598376$var$new_buf(9);
    var flags = 0;
    var dname = name.Name;
    if ($a1a91b25d7598376$var$XLSLblBuiltIn.indexOf(dname) > -1) {
        flags |= 0x20;
        dname = dname.slice(6);
    }
    o.write_shift(4, flags); // flags
    o.write_shift(1, 0); // chKey
    o.write_shift(4, name.Sheet == null ? 0xFFFFFFFF : name.Sheet);
    var arr = [
        o,
        $a1a91b25d7598376$var$write_XLWideString(dname),
        $a1a91b25d7598376$var$write_XLSBNameParsedFormula(name.Ref, wb)
    ];
    if (name.Comment) arr.push($a1a91b25d7598376$var$write_XLNullableWideString(name.Comment));
    else {
        var x = $a1a91b25d7598376$var$new_buf(4);
        x.write_shift(4, 0xFFFFFFFF);
        arr.push(x);
    }
    // if macro (flags & 0x0F):
    // write_shift(4, 0xFFFFFFFF);
    // write_XLNullableWideString(description)
    // write_XLNullableWideString(helpTopic)
    // write_shift(4, 0xFFFFFFFF);
    return $a1a91b25d7598376$var$bconcat(arr);
}
/* [MS-XLSB] 2.1.7.61 Workbook */ function $a1a91b25d7598376$var$parse_wb_bin(data, opts) /*:WorkbookFile*/ {
    var wb = {
        AppVersion: {},
        WBProps: {},
        WBView: [],
        Sheets: [],
        CalcPr: {},
        xmlns: ""
    };
    var state /*:Array<string>*/  = [];
    var pass = false;
    if (!opts) opts = {};
    opts.biff = 12;
    var Names = [];
    var supbooks = [
        []
    ];
    supbooks.SheetNames = [];
    supbooks.XTI = [];
    $a1a91b25d7598376$var$XLSBRecordEnum[0x0010] = {
        n: "BrtFRTArchID$",
        f: $a1a91b25d7598376$var$parse_BrtFRTArchID$
    };
    $a1a91b25d7598376$var$recordhopper(data, function hopper_wb(val1, R, RT) {
        switch(RT){
            case 0x009C:
                /* 'BrtBundleSh' */ supbooks.SheetNames.push(val1.name);
                wb.Sheets.push(val1);
                break;
            case 0x0099:
                /* 'BrtWbProp' */ wb.WBProps = val1;
                break;
            case 0x0027:
                /* 'BrtName' */ if (val1.Sheet != null) opts.SID = val1.Sheet;
                val1.Ref = val1.Ptg ? $a1a91b25d7598376$var$stringify_formula(val1.Ptg, null, null, supbooks, opts) : "#REF!";
                delete opts.SID;
                delete val1.Ptg;
                Names.push(val1);
                break;
            case 0x040C:
                break;
            case 0x0165:
            /* 'BrtSupSelf' */ case 0x0166:
            /* 'BrtSupSame' */ case 0x0163:
            /* 'BrtSupBookSrc' */ case 0x029B:
                /* 'BrtSupAddin' */ if (!supbooks[0].length) supbooks[0] = [
                    RT,
                    val1
                ];
                else supbooks.push([
                    RT,
                    val1
                ]);
                supbooks[supbooks.length - 1].XTI = [];
                break;
            case 0x016A:
                /* 'BrtExternSheet' */ if (supbooks.length === 0) {
                    supbooks[0] = [];
                    supbooks[0].XTI = [];
                }
                supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                supbooks.XTI = supbooks.XTI.concat(val1);
                break;
            case 0x0169:
                break;
            case 0x0817:
            /* 'BrtAbsPath15' */ case 0x009E:
            /* 'BrtBookView' */ case 0x008F:
            /* 'BrtBeginBundleShs' */ case 0x0298:
            /* 'BrtBeginFnGroup' */ case 0x0161:
                break;
            /* case 'BrtModelTimeGroupingCalcCol' */ case 0x0C00:
            /* 'BrtUid' */ case 0x0C01:
            /* 'BrtRevisionPtr' */ case 0x0216:
            /* 'BrtBookProtection' */ case 0x02A5:
            /* 'BrtBookProtectionIso' */ case 0x009D:
            /* 'BrtCalcProp' */ case 0x0262:
            /* 'BrtCrashRecErr' */ case 0x0802:
            /* 'BrtDecoupledPivotCacheID' */ case 0x009B:
            /* 'BrtFileRecover' */ case 0x0224:
            /* 'BrtFileSharing' */ case 0x02A4:
            /* 'BrtFileSharingIso' */ case 0x0080:
            /* 'BrtFileVersion' */ case 0x0299:
            /* 'BrtFnGroup' */ case 0x0850:
            /* 'BrtModelRelationship' */ case 0x084D:
            /* 'BrtModelTable' */ case 0x0225:
            /* 'BrtOleSize' */ case 0x0805:
            /* 'BrtPivotTableRef' */ case 0x0254:
            /* 'BrtSmartTagType' */ case 0x081C:
            /* 'BrtTableSlicerCacheID' */ case 0x081B:
            /* 'BrtTableSlicerCacheIDs' */ case 0x0822:
            /* 'BrtTimelineCachePivotCacheID' */ case 0x018D:
            /* 'BrtUserBookView' */ case 0x009A:
            /* 'BrtWbFactoid' */ case 0x045D:
            /* 'BrtWbProp14' */ case 0x0229:
            /* 'BrtWebOpt' */ case 0x082B:
                break;
            case 0x0023:
                /* 'BrtFRTBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0024:
                /* 'BrtFRTEnd' */ state.pop();
                pass = false;
                break;
            case 0x0025:
                /* 'BrtACBegin' */ state.push(RT);
                pass = true;
                break;
            case 0x0026:
                /* 'BrtACEnd' */ state.pop();
                pass = false;
                break;
            case 0x0010:
                break;
            default:
                if (R.T) ;
                else if (!pass || opts.WTF && state[state.length - 1] != 0x0025 /* BrtACBegin */  && state[state.length - 1] != 0x0023 /* BrtFRTBegin */ ) throw new Error("Unexpected record 0x" + RT.toString(16));
        }
    }, opts);
    $a1a91b25d7598376$var$parse_wb_defaults(wb);
    // $FlowIgnore
    wb.Names = Names;
    wb /*:any*/ .supbooks = supbooks;
    return wb;
}
function $a1a91b25d7598376$var$write_BUNDLESHS(ba, wb /*::, opts*/ ) {
    $a1a91b25d7598376$var$write_record(ba, 0x008F /* BrtBeginBundleShs */ );
    for(var idx = 0; idx != wb.SheetNames.length; ++idx){
        var viz = wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx] && wb.Workbook.Sheets[idx].Hidden || 0;
        var d = {
            Hidden: viz,
            iTabID: idx + 1,
            strRelID: 'rId' + (idx + 1),
            name: wb.SheetNames[idx]
        };
        $a1a91b25d7598376$var$write_record(ba, 0x009C /* BrtBundleSh */ , $a1a91b25d7598376$var$write_BrtBundleSh(d));
    }
    $a1a91b25d7598376$var$write_record(ba, 0x0090 /* BrtEndBundleShs */ );
}
/* [MS-XLSB] 2.4.649 BrtFileVersion */ function $a1a91b25d7598376$var$write_BrtFileVersion(data, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(127);
    for(var i = 0; i != 4; ++i)o.write_shift(4, 0);
    $a1a91b25d7598376$var$write_XLWideString("SheetJS", o);
    $a1a91b25d7598376$var$write_XLWideString($a1a91b25d7598376$var$XLSX.version, o);
    $a1a91b25d7598376$var$write_XLWideString($a1a91b25d7598376$var$XLSX.version, o);
    $a1a91b25d7598376$var$write_XLWideString("7262", o);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
/* [MS-XLSB] 2.4.301 BrtBookView */ function $a1a91b25d7598376$var$write_BrtBookView(idx, o) {
    if (!o) o = $a1a91b25d7598376$var$new_buf(29);
    o.write_shift(-4, 0);
    o.write_shift(-4, 460);
    o.write_shift(4, 28800);
    o.write_shift(4, 17600);
    o.write_shift(4, 500);
    o.write_shift(4, idx);
    o.write_shift(4, idx);
    var flags = 0x78;
    o.write_shift(1, flags);
    return o.length > o.l ? o.slice(0, o.l) : o;
}
function $a1a91b25d7598376$var$write_BOOKVIEWS(ba, wb /*::, opts*/ ) {
    /* required if hidden tab appears before visible tab */ if (!wb.Workbook || !wb.Workbook.Sheets) return;
    var sheets = wb.Workbook.Sheets;
    var i = 0, vistab = -1, hidden = -1;
    for(; i < sheets.length; ++i){
        if (!sheets[i] || !sheets[i].Hidden && vistab == -1) vistab = i;
        else if (sheets[i].Hidden == 1 && hidden == -1) hidden = i;
    }
    if (hidden > vistab) return;
    $a1a91b25d7598376$var$write_record(ba, 0x0087 /* BrtBeginBookViews */ );
    $a1a91b25d7598376$var$write_record(ba, 0x009E /* BrtBookView */ , $a1a91b25d7598376$var$write_BrtBookView(vistab));
    /* 1*(BrtBookView *FRT) */ $a1a91b25d7598376$var$write_record(ba, 0x0088 /* BrtEndBookViews */ );
}
function $a1a91b25d7598376$var$write_BRTNAMES(ba, wb) {
    if (!wb.Workbook || !wb.Workbook.Names) return;
    wb.Workbook.Names.forEach(function(name) {
        try {
            if (name.Flags & 0x0e) return; // TODO: macro name write
            $a1a91b25d7598376$var$write_record(ba, 0x0027 /* BrtName */ , $a1a91b25d7598376$var$write_BrtName(name, wb));
        } catch (e) {
            console.error("Could not serialize defined name " + JSON.stringify(name));
        }
    });
}
function $a1a91b25d7598376$var$write_SELF_EXTERNS_xlsb(wb) {
    var L = wb.SheetNames.length;
    var o = $a1a91b25d7598376$var$new_buf(12 * L + 28);
    o.write_shift(4, L + 2);
    o.write_shift(4, 0);
    o.write_shift(4, -2);
    o.write_shift(4, -2); // workbook-level reference
    o.write_shift(4, 0);
    o.write_shift(4, -1);
    o.write_shift(4, -1); // #REF!...
    for(var i = 0; i < L; ++i){
        o.write_shift(4, 0);
        o.write_shift(4, i);
        o.write_shift(4, i);
    }
    return o;
}
function $a1a91b25d7598376$var$write_EXTERNALS_xlsb(ba, wb) {
    $a1a91b25d7598376$var$write_record(ba, 0x0161 /* BrtBeginExternals */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0165 /* BrtSupSelf */ );
    $a1a91b25d7598376$var$write_record(ba, 0x016A /* BrtExternSheet */ , $a1a91b25d7598376$var$write_SELF_EXTERNS_xlsb(wb, 0));
    $a1a91b25d7598376$var$write_record(ba, 0x0162 /* BrtEndExternals */ );
}
/* [MS-XLSB] 2.4.305 BrtCalcProp */ /*function write_BrtCalcProp(data, o) {
	if(!o) o = new_buf(26);
	o.write_shift(4,0); // force recalc
	o.write_shift(4,1);
	o.write_shift(4,0);
	write_Xnum(0, o);
	o.write_shift(-4, 1023);
	o.write_shift(1, 0x33);
	o.write_shift(1, 0x00);
	return o;
}*/ /* [MS-XLSB] 2.4.646 BrtFileRecover */ /*function write_BrtFileRecover(data, o) {
	if(!o) o = new_buf(1);
	o.write_shift(1,0);
	return o;
}*/ /* [MS-XLSB] 2.1.7.61 Workbook */ function $a1a91b25d7598376$var$write_wb_bin(wb, opts) {
    var ba = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_record(ba, 0x0083 /* BrtBeginBook */ );
    $a1a91b25d7598376$var$write_record(ba, 0x0080 /* BrtFileVersion */ , $a1a91b25d7598376$var$write_BrtFileVersion());
    /* [[BrtFileSharingIso] BrtFileSharing] */ $a1a91b25d7598376$var$write_record(ba, 0x0099 /* BrtWbProp */ , $a1a91b25d7598376$var$write_BrtWbProp(wb.Workbook && wb.Workbook.WBProps || null));
    /* [ACABSPATH] */ /* [[BrtBookProtectionIso] BrtBookProtection] */ $a1a91b25d7598376$var$write_BOOKVIEWS(ba, wb, opts);
    $a1a91b25d7598376$var$write_BUNDLESHS(ba, wb, opts);
    /* [FNGROUP] */ $a1a91b25d7598376$var$write_EXTERNALS_xlsb(ba, wb);
    if ((wb.Workbook || {}).Names) $a1a91b25d7598376$var$write_BRTNAMES(ba, wb);
    /* write_record(ba, 0x009D BrtCalcProp, write_BrtCalcProp()); */ /* [BrtOleSize] */ /* *(BrtUserBookView *FRT) */ /* [PIVOTCACHEIDS] */ /* [BrtWbFactoid] */ /* [SMARTTAGTYPES] */ /* [BrtWebOpt] */ /* write_record(ba, 0x009B BrtFileRecover, write_BrtFileRecover()); */ /* [WEBPUBITEMS] */ /* [CRERRS] */ /* FRTWORKBOOK */ $a1a91b25d7598376$var$write_record(ba, 0x0084 /* BrtEndBook */ );
    return ba.end();
}
function $a1a91b25d7598376$var$parse_wb(data, name /*:string*/ , opts) /*:WorkbookFile*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_wb_bin(data /*:any*/ , opts);
    return $a1a91b25d7598376$var$parse_wb_xml(data /*:any*/ , opts);
}
function $a1a91b25d7598376$var$parse_ws(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_ws_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_ws_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_cs(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_cs_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_cs_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_ms(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_ms_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_ms_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_ds(data, name /*:string*/ , idx /*:number*/ , opts, rels, wb, themes, styles) /*:Worksheet*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_ds_bin(data /*:any*/ , opts, idx, rels, wb, themes, styles);
    return $a1a91b25d7598376$var$parse_ds_xml(data /*:any*/ , opts, idx, rels, wb, themes, styles);
}
function $a1a91b25d7598376$var$parse_sty(data, name /*:string*/ , themes, opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_sty_bin(data /*:any*/ , themes, opts);
    return $a1a91b25d7598376$var$parse_sty_xml(data /*:any*/ , themes, opts);
}
function $a1a91b25d7598376$var$parse_sst(data, name /*:string*/ , opts) /*:SST*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_sst_bin(data /*:any*/ , opts);
    return $a1a91b25d7598376$var$parse_sst_xml(data /*:any*/ , opts);
}
function $a1a91b25d7598376$var$parse_cmnt(data, name /*:string*/ , opts) /*:Array<RawComment>*/ {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_comments_bin(data /*:any*/ , opts);
    return $a1a91b25d7598376$var$parse_comments_xml(data /*:any*/ , opts);
}
function $a1a91b25d7598376$var$parse_cc(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_cc_bin(data /*:any*/ , name, opts);
    return $a1a91b25d7598376$var$parse_cc_xml(data /*:any*/ , name, opts);
}
function $a1a91b25d7598376$var$parse_xlink(data, rel, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_xlink_bin(data /*:any*/ , rel, name, opts);
    return $a1a91b25d7598376$var$parse_xlink_xml(data /*:any*/ , rel, name, opts);
}
function $a1a91b25d7598376$var$parse_xlmeta(data, name /*:string*/ , opts) {
    if (name.slice(-4) === ".bin") return $a1a91b25d7598376$var$parse_xlmeta_bin(data /*:any*/ , name, opts);
    return $a1a91b25d7598376$var$parse_xlmeta_xml(data /*:any*/ , name, opts);
}
var $a1a91b25d7598376$var$attregexg2 = /\b((?:\w+:)?[\w]+)=((?:")([^"]*)(?:")|(?:')([^']*)(?:'))/g;
var $a1a91b25d7598376$var$attregex2 = /\b((?:\w+:)?[\w]+)=((?:")(?:[^"]*)(?:")|(?:')(?:[^']*)(?:'))/;
function $a1a91b25d7598376$var$xlml_parsexmltag(tag /*:string*/ , skip_root /*:?boolean*/ ) {
    var words = tag.split(/\s+/);
    var z /*:any*/  = [];
    if (!skip_root) z[0] = words[0];
    if (words.length === 1) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($a1a91b25d7598376$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
function $a1a91b25d7598376$var$xlml_parsexmltagobj(tag /*:string*/ ) {
    var words = tag.split(/\s+/);
    var z = {};
    if (words.length === 1) return z;
    var m = tag.match($a1a91b25d7598376$var$attregexg2), y, j, w, i;
    if (m) for(i = 0; i != m.length; ++i){
        y = m[i].match($a1a91b25d7598376$var$attregex2);
        /*:: if(!y || !y[2]) continue; */ if ((j = y[1].indexOf(":")) === -1) z[y[1]] = y[2].slice(1, y[2].length - 1);
        else {
            if (y[1].slice(0, 6) === "xmlns:") w = "xmlns" + y[1].slice(6);
            else w = y[1].slice(j + 1);
            z[w] = y[2].slice(1, y[2].length - 1);
        }
    }
    return z;
}
// ----
/* map from xlml named formats to SSF TODO: localize */ var $a1a91b25d7598376$var$XLMLFormatMap /*: {[string]:string}*/ ;
function $a1a91b25d7598376$var$xlml_format(format, value, date1904) /*:string*/ {
    var fmt = $a1a91b25d7598376$var$XLMLFormatMap[format] || $a1a91b25d7598376$var$unescapexml(format);
    if (fmt === "General") return $a1a91b25d7598376$var$SSF_general(value);
    return $a1a91b25d7598376$var$SSF_format(fmt, value, {
        date1904: !!date1904
    });
}
function $a1a91b25d7598376$var$xlml_set_custprop(Custprops, key, cp, val1 /*:string*/ ) {
    var oval /*:any*/  = val1;
    switch((cp[0].match(/dt:dt="([\w.]+)"/) || [
        "",
        ""
    ])[1]){
        case "boolean":
            oval = $a1a91b25d7598376$var$parsexmlbool(val1);
            break;
        case "i2":
        case "int":
            oval = parseInt(val1, 10);
            break;
        case "r4":
        case "float":
            oval = parseFloat(val1);
            break;
        case "date":
        case "dateTime.tz":
            oval = $a1a91b25d7598376$var$parseDate(val1);
            break;
        case "i8":
        case "string":
        case "fixed":
        case "uuid":
        case "bin.base64":
            break;
        default:
            throw new Error("bad custprop:" + cp[0]);
    }
    Custprops[$a1a91b25d7598376$var$unescapexml(key)] = oval;
}
function $a1a91b25d7598376$var$safe_format_xlml(cell /*:Cell*/ , nf, o, date1904) {
    if (cell.t === 'z') return;
    if (!o || o.cellText !== false) try {
        if (cell.t === 'e') cell.w = cell.w || $a1a91b25d7598376$var$BErr[cell.v];
        else if (nf === "General") {
            if (cell.t === 'n') {
                if ((cell.v | 0) === cell.v) cell.w = cell.v.toString(10);
                else cell.w = $a1a91b25d7598376$var$SSF_general_num(cell.v);
            } else cell.w = $a1a91b25d7598376$var$SSF_general(cell.v);
        } else cell.w = $a1a91b25d7598376$var$xlml_format(nf || "General", cell.v, date1904);
    } catch (e) {
        if (o.WTF) throw e;
    }
    try {
        var z = $a1a91b25d7598376$var$XLMLFormatMap[nf] || nf || "General";
        if (o.cellNF) cell.z = z;
        if (o.cellDates && cell.t == 'n' && $a1a91b25d7598376$var$fmt_is_date(z)) {
            var _d = $a1a91b25d7598376$var$SSF_parse_date_code(cell.v + (date1904 ? 1462 : 0));
            if (_d) {
                cell.t = 'd';
                cell.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
            }
        }
    } catch (e) {
        if (o.WTF) throw e;
    }
}
function $a1a91b25d7598376$var$process_style_xlml(styles, stag, opts) {
    if (opts.cellStyles) {
        if (stag.Interior) {
            var I = stag.Interior;
            if (I.Pattern) I.patternType = $a1a91b25d7598376$var$XLMLPatternTypeMap[I.Pattern] || I.Pattern;
        }
    }
    styles[stag.ID] = stag;
}
/* TODO: there must exist some form of OSP-blessed spec */ function $a1a91b25d7598376$var$parse_xlml_data(xml, ss, data, cell /*:any*/ , base, styles, csty, row, arrayf, o, date1904) {
    var nf = "General", sid = cell.StyleID, S = {};
    o = o || {};
    var interiors = [];
    var i = 0;
    if (sid === undefined && row) sid = row.StyleID;
    if (sid === undefined && csty) sid = csty.StyleID;
    while(styles[sid] !== undefined){
        var ssid = styles[sid];
        if (ssid.nf) nf = ssid.nf;
        if (ssid.Interior) interiors.push(ssid.Interior);
        if (!ssid.Parent) break;
        sid = ssid.Parent;
    }
    switch(data.Type){
        case 'Boolean':
            cell.t = 'b';
            cell.v = $a1a91b25d7598376$var$parsexmlbool(xml);
            break;
        case 'String':
            cell.t = 's';
            cell.r = $a1a91b25d7598376$var$xlml_fixstr($a1a91b25d7598376$var$unescapexml(xml));
            cell.v = xml.indexOf("<") > -1 ? $a1a91b25d7598376$var$unescapexml(ss || xml).replace(/<[^<>]*>/g, "") : cell.r; // todo: BR etc
            break;
        case 'DateTime':
            if (xml.slice(-1) != "Z") xml += "Z";
            cell.v = $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(xml, date1904), date1904);
            if (cell.v !== cell.v) cell.v = $a1a91b25d7598376$var$unescapexml(xml);
            if (!nf || nf == "General") nf = "yyyy-mm-dd";
        /* falls through */ case 'Number':
            if (cell.v === undefined) cell.v = +xml;
            if (!cell.t) cell.t = 'n';
            break;
        case 'Error':
            cell.t = 'e';
            cell.v = $a1a91b25d7598376$var$RBErr[xml];
            if (o.cellText !== false) cell.w = xml;
            break;
        default:
            if (xml == "" && ss == "") cell.t = 'z';
            else {
                cell.t = 's';
                cell.v = $a1a91b25d7598376$var$xlml_fixstr(ss || xml);
            }
            break;
    }
    $a1a91b25d7598376$var$safe_format_xlml(cell, nf, o, date1904);
    if (o.cellFormula !== false) {
        if (cell.Formula) {
            var fstr = $a1a91b25d7598376$var$unescapexml(cell.Formula);
            /* strictly speaking, the leading = is required but some writers omit */ if (fstr.charCodeAt(0) == 61 /* = */ ) fstr = fstr.slice(1);
            cell.f = $a1a91b25d7598376$var$rc_to_a1(fstr, base);
            delete cell.Formula;
            if (cell.ArrayRange == "RC") cell.F = $a1a91b25d7598376$var$rc_to_a1("RC:RC", base);
            else if (cell.ArrayRange) {
                cell.F = $a1a91b25d7598376$var$rc_to_a1(cell.ArrayRange, base);
                arrayf.push([
                    $a1a91b25d7598376$var$safe_decode_range(cell.F),
                    cell.F
                ]);
            }
        } else {
            for(i = 0; i < arrayf.length; ++i)if (base.r >= arrayf[i][0].s.r && base.r <= arrayf[i][0].e.r) {
                if (base.c >= arrayf[i][0].s.c && base.c <= arrayf[i][0].e.c) cell.F = arrayf[i][1];
            }
        }
    }
    if (o.cellStyles) {
        interiors.forEach(function(x) {
            if (!S.patternType && x.patternType) S.patternType = x.patternType;
        });
        cell.s = S;
    }
    if (cell.StyleID !== undefined) cell.ixfe = cell.StyleID;
}
function $a1a91b25d7598376$var$xlml_prefix_dname(dname) {
    return $a1a91b25d7598376$var$XLSLblBuiltIn.indexOf("_xlnm." + dname) > -1 ? "_xlnm." + dname : dname;
}
function $a1a91b25d7598376$var$xlml_clean_comment(comment /*:any*/ ) {
    comment.t = comment.v || "";
    comment.t = comment.t.replace(/\r\n/g, "\n").replace(/\r/g, "\n");
    comment.v = comment.w = comment.ixfe = undefined;
}
/* TODO: Everything */ function $a1a91b25d7598376$var$parse_xlml_xml(d, _opts) /*:Workbook*/ {
    var opts = _opts || {};
    $a1a91b25d7598376$var$make_ssf();
    var str = $a1a91b25d7598376$var$debom($a1a91b25d7598376$var$xlml_normalize(d));
    if (opts.type == 'binary' || opts.type == 'array' || opts.type == 'base64') {
        if (typeof $a1a91b25d7598376$var$$cptable !== 'undefined') str = $a1a91b25d7598376$var$$cptable.utils.decode(65001, $a1a91b25d7598376$var$char_codes(str));
        else str = $a1a91b25d7598376$var$utf8read(str);
    }
    var opening = str.slice(0, 1024).toLowerCase(), ishtml = false;
    opening = opening.replace(/".*?"/g, "");
    if ((opening.indexOf(">") & 1023) > Math.min(opening.indexOf(",") & 1023, opening.indexOf(";") & 1023)) {
        var _o = $a1a91b25d7598376$var$dup(opts);
        _o.type = "string";
        return $a1a91b25d7598376$var$PRN.to_workbook(str, _o);
    }
    if (opening.indexOf("<?xml") == -1) [
        "html",
        "table",
        "head",
        "meta",
        "script",
        "style",
        "div"
    ].forEach(function(tag) {
        if (opening.indexOf("<" + tag) >= 0) ishtml = true;
    });
    if (ishtml) return $a1a91b25d7598376$var$html_to_workbook(str, opts);
    $a1a91b25d7598376$var$XLMLFormatMap = {
        "General Number": "General",
        "General Date": $a1a91b25d7598376$var$table_fmt[22],
        "Long Date": "dddd, mmmm dd, yyyy",
        "Medium Date": $a1a91b25d7598376$var$table_fmt[15],
        "Short Date": $a1a91b25d7598376$var$table_fmt[14],
        "Long Time": $a1a91b25d7598376$var$table_fmt[19],
        "Medium Time": $a1a91b25d7598376$var$table_fmt[18],
        "Short Time": $a1a91b25d7598376$var$table_fmt[20],
        "Currency": '"$"#,##0.00_);[Red]\\("$"#,##0.00\\)',
        "Fixed": $a1a91b25d7598376$var$table_fmt[2],
        "Standard": $a1a91b25d7598376$var$table_fmt[4],
        "Percent": $a1a91b25d7598376$var$table_fmt[10],
        "Scientific": $a1a91b25d7598376$var$table_fmt[11],
        "Yes/No": '"Yes";"Yes";"No";@',
        "True/False": '"True";"True";"False";@',
        "On/Off": '"Yes";"Yes";"No";@'
    } /*:any*/ ;
    var Rn;
    var state = [], tmp;
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    var sheets = {}, sheetnames /*:Array<string>*/  = [], cursheet /*:Worksheet*/  = {}, sheetname = "";
    if (opts.dense) cursheet["!data"] = [];
    var cell = {} /*:any*/ , row = {}; // eslint-disable-line no-unused-vars
    var dtag = $a1a91b25d7598376$var$xlml_parsexmltag('<Data ss:Type="String">'), didx = 0;
    var c = 0, r = 0;
    var refguess /*:Range*/  = {
        s: {
            r: 2000000,
            c: 2000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var styles = {}, stag = {};
    var ss = "", fidx = 0;
    var merges /*:Array<Range>*/  = [];
    var Props = {}, Custprops = {}, pidx = 0, cp = [];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var cstys = [], csty, seencol = false;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var rowinfo /*:Array<RowInfo>*/  = [], rowobj = {}, cc = 0, rr = 0;
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        }
    } /*:any*/ , wsprops = {};
    $a1a91b25d7598376$var$xlmlregex.lastIndex = 0;
    str = $a1a91b25d7598376$var$str_remove_ng(str, "<!--", "-->");
    var raw_Rn3 = "";
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3] = (raw_Rn3 = Rn[3]).toLowerCase()){
        case 'data' /*case 'Data'*/ :
            if (raw_Rn3 == "data") {
                if (Rn[1] === '/') {
                    if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                    Rn[3],
                    true
                ]);
                break;
            }
            if (state[state.length - 1][1]) break;
            if (Rn[1] === '/') $a1a91b25d7598376$var$parse_xlml_data(str.slice(didx, Rn.index), ss, dtag, state[state.length - 1][0] == /*"Comment"*/ "comment" ? comment : cell, {
                c: c,
                r: r
            }, styles, cstys[c], row, arrayf, opts, Workbook.WBProps.date1904);
            else {
                ss = "";
                dtag = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                didx = Rn.index + Rn[0].length;
            }
            break;
        case 'cell' /*case 'Cell'*/ :
            if (Rn[1] === '/') {
                if (comments.length > 0) cell.c = comments;
                if ((!opts.sheetRows || opts.sheetRows > r) && cell.v !== void 0) {
                    if (opts.dense) {
                        if (!cursheet["!data"][r]) cursheet["!data"][r] = [];
                        cursheet["!data"][r][c] = cell;
                    } else cursheet[$a1a91b25d7598376$var$encode_col(c) + $a1a91b25d7598376$var$encode_row(r)] = cell;
                }
                if (cell.HRef) {
                    cell.l = {
                        Target: $a1a91b25d7598376$var$unescapexml(cell.HRef)
                    } /*:any*/ ;
                    if (cell.HRefScreenTip) cell.l.Tooltip = cell.HRefScreenTip;
                    delete cell.HRef;
                    delete cell.HRefScreenTip;
                }
                if (cell.MergeAcross || cell.MergeDown) {
                    cc = c + (parseInt(cell.MergeAcross, 10) | 0);
                    rr = r + (parseInt(cell.MergeDown, 10) | 0);
                    if (cc > c || rr > r) merges.push({
                        s: {
                            c: c,
                            r: r
                        },
                        e: {
                            c: cc,
                            r: rr
                        }
                    });
                }
                if (!opts.sheetStubs) {
                    if (cell.MergeAcross) c = cc + 1;
                    else ++c;
                } else if (cell.MergeAcross || cell.MergeDown) {
                    /*:: if(!cc) cc = 0; if(!rr) rr = 0; */ for(var cma = c; cma <= cc; ++cma){
                        for(var cmd = r; cmd <= rr; ++cmd)if (cma > c || cmd > r) {
                            if (opts.dense) {
                                if (!cursheet["!data"][cmd]) cursheet["!data"][cmd] = [];
                                cursheet["!data"][cmd][cma] = {
                                    t: 'z'
                                };
                            } else cursheet[$a1a91b25d7598376$var$encode_col(cma) + $a1a91b25d7598376$var$encode_row(cmd)] = {
                                t: 'z'
                            };
                        }
                    }
                    c = cc + 1;
                } else ++c;
            } else {
                cell = $a1a91b25d7598376$var$xlml_parsexmltagobj(Rn[0]);
                if (cell.Index) c = +cell.Index - 1;
                if (c < refguess.s.c) refguess.s.c = c;
                if (c > refguess.e.c) refguess.e.c = c;
                if (Rn[0].slice(-2) === "/>") ++c;
                comments = [];
            }
            break;
        case 'row' /*case 'Row'*/ :
            if (Rn[1] === '/' || Rn[0].slice(-2) === "/>") {
                if (r < refguess.s.r) refguess.s.r = r;
                if (r > refguess.e.r) refguess.e.r = r;
                if (Rn[0].slice(-2) === "/>") {
                    row = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                    if (row.Index) r = +row.Index - 1;
                }
                c = 0;
                ++r;
            } else {
                row = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                if (row.Index) r = +row.Index - 1;
                rowobj = {};
                if (row.AutoFitHeight == "0" || row.Height) {
                    rowobj.hpx = parseInt(row.Height, 10);
                    rowobj.hpt = $a1a91b25d7598376$var$px2pt(rowobj.hpx);
                    rowinfo[r] = rowobj;
                }
                if (row.Hidden == "1") {
                    rowobj.hidden = true;
                    rowinfo[r] = rowobj;
                }
            }
            break;
        case 'worksheet' /*case 'Worksheet'*/ :
            /* TODO: read range from FullRows/FullColumns */ if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                sheetnames.push(sheetname);
                if (refguess.s.r <= refguess.e.r && refguess.s.c <= refguess.e.c) {
                    cursheet["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                    if (opts.sheetRows && opts.sheetRows <= refguess.e.r) {
                        cursheet["!fullref"] = cursheet["!ref"];
                        refguess.e.r = opts.sheetRows - 1;
                        cursheet["!ref"] = $a1a91b25d7598376$var$encode_range(refguess);
                    }
                }
                if (merges.length) cursheet["!merges"] = merges;
                if (cstys.length > 0) cursheet["!cols"] = cstys;
                if (rowinfo.length > 0) cursheet["!rows"] = rowinfo;
                sheets[sheetname] = cursheet;
            } else {
                refguess = {
                    s: {
                        r: 2000000,
                        c: 2000000
                    },
                    e: {
                        r: 0,
                        c: 0
                    }
                };
                r = c = 0;
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                sheetname = $a1a91b25d7598376$var$unescapexml(tmp.Name);
                cursheet = {};
                if (opts.dense) cursheet["!data"] = [];
                merges = [];
                arrayf = [];
                rowinfo = [];
                wsprops = {
                    name: sheetname,
                    Hidden: 0
                };
                Workbook.Sheets.push(wsprops);
            }
            break;
        case 'table' /*case 'Table'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].slice(-2) == "/>") break;
            else {
                state.push([
                    Rn[3],
                    false
                ]);
                cstys = [];
                seencol = false;
            }
            break;
        case 'style' /*case 'Style'*/ :
            if (Rn[1] === '/') $a1a91b25d7598376$var$process_style_xlml(styles, stag, opts);
            else stag = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'numberformat' /*case 'NumberFormat'*/ :
            stag.nf = $a1a91b25d7598376$var$unescapexml($a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]).Format || "General");
            if ($a1a91b25d7598376$var$XLMLFormatMap[stag.nf]) stag.nf = $a1a91b25d7598376$var$XLMLFormatMap[stag.nf];
            for(var ssfidx = 0; ssfidx != 0x188; ++ssfidx)if ($a1a91b25d7598376$var$table_fmt[ssfidx] == stag.nf) break;
            if (ssfidx == 0x188) {
                for(ssfidx = 0x39; ssfidx != 0x188; ++ssfidx)if ($a1a91b25d7598376$var$table_fmt[ssfidx] == null) {
                    $a1a91b25d7598376$var$SSF__load(stag.nf, ssfidx);
                    break;
                }
            }
            break;
        case 'column' /*case 'Column'*/ :
            if (state[state.length - 1][0] !== /*'Table'*/ 'table') break;
            if (Rn[1] === '/') break;
            csty = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
            if (csty.Hidden) {
                csty.hidden = true;
                delete csty.Hidden;
            }
            if (csty.Width) csty.wpx = parseInt(csty.Width, 10);
            if (!seencol && csty.wpx > 10) {
                seencol = true;
                $a1a91b25d7598376$var$MDW = $a1a91b25d7598376$var$DEF_MDW; //find_mdw_wpx(csty.wpx);
                for(var _col = 0; _col < cstys.length; ++_col)if (cstys[_col]) $a1a91b25d7598376$var$process_col(cstys[_col]);
            }
            if (seencol) $a1a91b25d7598376$var$process_col(csty);
            cstys[csty.Index - 1 || cstys.length] = csty;
            for(var i = 0; i < +csty.Span; ++i)cstys[cstys.length] = $a1a91b25d7598376$var$dup(csty);
            break;
        case 'namedrange' /*case 'NamedRange'*/ :
            if (Rn[1] === '/') break;
            if (!Workbook.Names) Workbook.Names = [];
            var _NamedRange = $a1a91b25d7598376$var$parsexmltag(Rn[0]);
            var _DefinedName /*:DefinedName*/  = {
                Name: $a1a91b25d7598376$var$xlml_prefix_dname(_NamedRange.Name),
                Ref: $a1a91b25d7598376$var$rc_to_a1(_NamedRange.RefersTo.slice(1), {
                    r: 0,
                    c: 0
                })
            } /*:any*/ ;
            if (Workbook.Sheets.length > 0) _DefinedName.Sheet = Workbook.Sheets.length - 1;
            /*:: if(Workbook.Names) */ Workbook.Names.push(_DefinedName);
            break;
        case 'namedcell' /*case 'NamedCell'*/ :
            break;
        case 'b' /*case 'B'*/ :
            break;
        case 'i' /*case 'I'*/ :
            break;
        case 'u' /*case 'U'*/ :
            break;
        case 's' /*case 'S'*/ :
            break;
        case 'em' /*case 'EM'*/ :
            break;
        case 'h2' /*case 'H2'*/ :
            break;
        case 'h3' /*case 'H3'*/ :
            break;
        case 'sub' /*case 'Sub'*/ :
            break;
        case 'sup' /*case 'Sup'*/ :
            break;
        case 'span' /*case 'Span'*/ :
            break;
        case 'alignment' /*case 'Alignment'*/ :
            break;
        case 'borders' /*case 'Borders'*/ :
            break;
        case 'border' /*case 'Border'*/ :
            break;
        case 'font' /*case 'Font'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") ss += str.slice(fidx, Rn.index);
            else fidx = Rn.index + Rn[0].length;
            break;
        case 'interior' /*case 'Interior'*/ :
            if (!opts.cellStyles) break;
            stag.Interior = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
            break;
        case 'protection' /*case 'Protection'*/ :
            break;
        case 'author' /*case 'Author'*/ :
        case 'title' /*case 'Title'*/ :
        case 'description' /*case 'Description'*/ :
        case 'created' /*case 'Created'*/ :
        case 'keywords' /*case 'Keywords'*/ :
        case 'subject' /*case 'Subject'*/ :
        case 'category' /*case 'Category'*/ :
        case 'company' /*case 'Company'*/ :
        case 'lastauthor' /*case 'LastAuthor'*/ :
        case 'lastsaved' /*case 'LastSaved'*/ :
        case 'lastprinted' /*case 'LastPrinted'*/ :
        case 'version' /*case 'Version'*/ :
        case 'revision' /*case 'Revision'*/ :
        case 'totaltime' /*case 'TotalTime'*/ :
        case 'hyperlinkbase' /*case 'HyperlinkBase'*/ :
        case 'manager' /*case 'Manager'*/ :
        case 'contentstatus' /*case 'ContentStatus'*/ :
        case 'identifier' /*case 'Identifier'*/ :
        case 'language' /*case 'Language'*/ :
        case 'appname' /*case 'AppName'*/ :
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") $a1a91b25d7598376$var$xlml_set_prop(Props, raw_Rn3, str.slice(pidx, Rn.index));
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'paragraphs' /*case 'Paragraphs'*/ :
            break;
        case 'styles' /*case 'Styles'*/ :
        case 'workbook' /*case 'Workbook'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else state.push([
                Rn[3],
                false
            ]);
            break;
        case 'comment' /*case 'Comment'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
                $a1a91b25d7598376$var$xlml_clean_comment(comment);
                comments.push(comment);
            } else {
                state.push([
                    Rn[3],
                    false
                ]);
                tmp = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                if (!$a1a91b25d7598376$var$parsexmlbool(tmp["ShowAlways"] || "0")) comments.hidden = true;
                comment = {
                    a: tmp.Author
                } /*:any*/ ;
            }
            break;
        case 'autofilter' /*case 'AutoFilter'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                var AutoFilter = $a1a91b25d7598376$var$xlml_parsexmltag(Rn[0]);
                cursheet['!autofilter'] = {
                    ref: $a1a91b25d7598376$var$rc_to_a1(AutoFilter.Range).replace(/\$/g, "")
                };
                state.push([
                    Rn[3],
                    true
                ]);
            }
            break;
        case 'name' /*case 'Name'*/ :
            break;
        case 'datavalidation' /*case 'DataValidation'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'pixelsperinch' /*case 'PixelsPerInch'*/ :
            break;
        case 'componentoptions' /*case 'ComponentOptions'*/ :
        case 'documentproperties' /*case 'DocumentProperties'*/ :
        case 'customdocumentproperties' /*case 'CustomDocumentProperties'*/ :
        case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
        case 'pivottable' /*case 'PivotTable'*/ :
        case 'pivotcache' /*case 'PivotCache'*/ :
        case 'names' /*case 'Names'*/ :
        case 'mapinfo' /*case 'MapInfo'*/ :
        case 'pagebreaks' /*case 'PageBreaks'*/ :
        case 'querytable' /*case 'QueryTable'*/ :
        case 'sorting' /*case 'Sorting'*/ :
        case 'schema' /*case 'Schema'*/ :
        case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
        case 'smarttagtype' /*case 'SmartTagType'*/ :
        case 'smarttags' /*case 'SmartTags'*/ :
        case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
        case 'workbookoptions' /*case 'WorkbookOptions'*/ :
        case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw new Error("Bad state: " + tmp.join("|"));
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'null' /*case 'Null'*/ :
            break;
        default:
            /* FODS file root is <office:document> */ if (state.length == 0 && Rn[3] == "document") return $a1a91b25d7598376$var$parse_fods(str, opts);
            /* UOS file root is <uof:UOF> */ if (state.length == 0 && Rn[3] == "uof" /*"UOF"*/ ) return $a1a91b25d7598376$var$parse_fods(str, opts);
            var seen = true;
            switch(state[state.length - 1][0]){
                /* OfficeDocumentSettings */ case 'officedocumentsettings' /*case 'OfficeDocumentSettings'*/ :
                    switch(Rn[3]){
                        case 'allowpng' /*case 'AllowPNG'*/ :
                            break;
                        case 'removepersonalinformation' /*case 'RemovePersonalInformation'*/ :
                            break;
                        case 'downloadcomponents' /*case 'DownloadComponents'*/ :
                            break;
                        case 'locationofcomponents' /*case 'LocationOfComponents'*/ :
                            break;
                        case 'colors' /*case 'Colors'*/ :
                            break;
                        case 'color' /*case 'Color'*/ :
                            break;
                        case 'index' /*case 'Index'*/ :
                            break;
                        case 'rgb' /*case 'RGB'*/ :
                            break;
                        case 'targetscreensize' /*case 'TargetScreenSize'*/ :
                            break;
                        case 'readonlyrecommended' /*case 'ReadOnlyRecommended'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ComponentOptions */ case 'componentoptions' /*case 'ComponentOptions'*/ :
                    switch(Rn[3]){
                        case 'toolbar' /*case 'Toolbar'*/ :
                            break;
                        case 'hideofficelogo' /*case 'HideOfficeLogo'*/ :
                            break;
                        case 'spreadsheetautofit' /*case 'SpreadsheetAutoFit'*/ :
                            break;
                        case 'label' /*case 'Label'*/ :
                            break;
                        case 'caption' /*case 'Caption'*/ :
                            break;
                        case 'maxheight' /*case 'MaxHeight'*/ :
                            break;
                        case 'maxwidth' /*case 'MaxWidth'*/ :
                            break;
                        case 'nextsheetnumber' /*case 'NextSheetNumber'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* ExcelWorkbook */ case 'excelworkbook' /*case 'ExcelWorkbook'*/ :
                    switch(Rn[3]){
                        case 'date1904' /*case 'Date1904'*/ :
                            /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ Workbook.WBProps.date1904 = true;
                            break;
                        case 'hidehorizontalscrollbar' /*case 'HideHorizontalScrollBar'*/ :
                            break;
                        case 'hideverticalscrollbar' /*case 'HideVerticalScrollBar'*/ :
                            break;
                        case 'hideworkbooktabs' /*case 'HideWorkbookTabs'*/ :
                            break;
                        case 'windowheight' /*case 'WindowHeight'*/ :
                            break;
                        case 'windowwidth' /*case 'WindowWidth'*/ :
                            break;
                        case 'windowtopx' /*case 'WindowTopX'*/ :
                            break;
                        case 'windowtopy' /*case 'WindowTopY'*/ :
                            break;
                        case 'tabratio' /*case 'TabRatio'*/ :
                            break;
                        case 'protectstructure' /*case 'ProtectStructure'*/ :
                            break;
                        case 'protectwindow' /*case 'ProtectWindow'*/ :
                            break;
                        case 'protectwindows' /*case 'ProtectWindows'*/ :
                            break;
                        case 'activesheet' /*case 'ActiveSheet'*/ :
                            break;
                        case 'displayinknotes' /*case 'DisplayInkNotes'*/ :
                            break;
                        case 'firstvisiblesheet' /*case 'FirstVisibleSheet'*/ :
                            break;
                        case 'supbook' /*case 'SupBook'*/ :
                            break;
                        case 'sheetname' /*case 'SheetName'*/ :
                            break;
                        case 'sheetindex' /*case 'SheetIndex'*/ :
                            break;
                        case 'sheetindexfirst' /*case 'SheetIndexFirst'*/ :
                            break;
                        case 'sheetindexlast' /*case 'SheetIndexLast'*/ :
                            break;
                        case 'dll' /*case 'Dll'*/ :
                            break;
                        case 'acceptlabelsinformulas' /*case 'AcceptLabelsInFormulas'*/ :
                            break;
                        case 'donotsavelinkvalues' /*case 'DoNotSaveLinkValues'*/ :
                            break;
                        case 'iteration' /*case 'Iteration'*/ :
                            break;
                        case 'maxiterations' /*case 'MaxIterations'*/ :
                            break;
                        case 'maxchange' /*case 'MaxChange'*/ :
                            break;
                        case 'path' /*case 'Path'*/ :
                            break;
                        case 'xct' /*case 'Xct'*/ :
                            break;
                        case 'count' /*case 'Count'*/ :
                            break;
                        case 'selectedsheets' /*case 'SelectedSheets'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        case 'uncalced' /*case 'Uncalced'*/ :
                            break;
                        case 'startupprompt' /*case 'StartupPrompt'*/ :
                            break;
                        case 'crn' /*case 'Crn'*/ :
                            break;
                        case 'externname' /*case 'ExternName'*/ :
                            break;
                        case 'formula' /*case 'Formula'*/ :
                            break;
                        case 'colfirst' /*case 'ColFirst'*/ :
                            break;
                        case 'collast' /*case 'ColLast'*/ :
                            break;
                        case 'wantadvise' /*case 'WantAdvise'*/ :
                            break;
                        case 'boolean' /*case 'Boolean'*/ :
                            break;
                        case 'error' /*case 'Error'*/ :
                            break;
                        case 'text' /*case 'Text'*/ :
                            break;
                        case 'ole' /*case 'OLE'*/ :
                            break;
                        case 'noautorecover' /*case 'NoAutoRecover'*/ :
                            break;
                        case 'publishobjects' /*case 'PublishObjects'*/ :
                            break;
                        case 'donotcalculatebeforesave' /*case 'DoNotCalculateBeforeSave'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'refmoder1c1' /*case 'RefModeR1C1'*/ :
                            break;
                        case 'embedsavesmarttags' /*case 'EmbedSaveSmartTags'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorkbookOptions */ case 'workbookoptions' /*case 'WorkbookOptions'*/ :
                    switch(Rn[3]){
                        case 'owcversion' /*case 'OWCVersion'*/ :
                            break;
                        case 'height' /*case 'Height'*/ :
                            break;
                        case 'width' /*case 'Width'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* WorksheetOptions */ case 'worksheetoptions' /*case 'WorksheetOptions'*/ :
                    switch(Rn[3]){
                        case 'visible' /*case 'Visible'*/ :
                            if (Rn[0].slice(-2) === "/>") ;
                            else if (Rn[1] === "/") switch(str.slice(pidx, Rn.index)){
                                case "SheetHidden":
                                    wsprops.Hidden = 1;
                                    break;
                                case "SheetVeryHidden":
                                    wsprops.Hidden = 2;
                                    break;
                            }
                            else pidx = Rn.index + Rn[0].length;
                            break;
                        case 'header' /*case 'Header'*/ :
                            if (!cursheet['!margins']) $a1a91b25d7598376$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].header = +$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'footer' /*case 'Footer'*/ :
                            if (!cursheet['!margins']) $a1a91b25d7598376$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin)) cursheet['!margins'].footer = +$a1a91b25d7598376$var$parsexmltag(Rn[0]).Margin;
                            break;
                        case 'pagemargins' /*case 'PageMargins'*/ :
                            var pagemargins = $a1a91b25d7598376$var$parsexmltag(Rn[0]);
                            if (!cursheet['!margins']) $a1a91b25d7598376$var$default_margins(cursheet['!margins'] = {}, 'xlml');
                            if (!isNaN(+pagemargins.Top)) cursheet['!margins'].top = +pagemargins.Top;
                            if (!isNaN(+pagemargins.Left)) cursheet['!margins'].left = +pagemargins.Left;
                            if (!isNaN(+pagemargins.Right)) cursheet['!margins'].right = +pagemargins.Right;
                            if (!isNaN(+pagemargins.Bottom)) cursheet['!margins'].bottom = +pagemargins.Bottom;
                            break;
                        case 'displayrighttoleft' /*case 'DisplayRightToLeft'*/ :
                            if (!Workbook.Views) Workbook.Views = [];
                            if (!Workbook.Views[0]) Workbook.Views[0] = {};
                            Workbook.Views[0].RTL = true;
                            break;
                        case 'freezepanes' /*case 'FreezePanes'*/ :
                            break;
                        case 'frozennosplit' /*case 'FrozenNoSplit'*/ :
                            break;
                        case 'splithorizontal' /*case 'SplitHorizontal'*/ :
                        case 'splitvertical' /*case 'SplitVertical'*/ :
                            break;
                        case 'donotdisplaygridlines' /*case 'DoNotDisplayGridlines'*/ :
                            break;
                        case 'activerow' /*case 'ActiveRow'*/ :
                            break;
                        case 'activecol' /*case 'ActiveCol'*/ :
                            break;
                        case 'toprowbottompane' /*case 'TopRowBottomPane'*/ :
                            break;
                        case 'leftcolumnrightpane' /*case 'LeftColumnRightPane'*/ :
                            break;
                        case 'unsynced' /*case 'Unsynced'*/ :
                            break;
                        case 'print' /*case 'Print'*/ :
                            break;
                        case 'printerrors' /*case 'PrintErrors'*/ :
                            break;
                        case 'panes' /*case 'Panes'*/ :
                            break;
                        case 'scale' /*case 'Scale'*/ :
                            break;
                        case 'pane' /*case 'Pane'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'layout' /*case 'Layout'*/ :
                            break;
                        case 'pagesetup' /*case 'PageSetup'*/ :
                            break;
                        case 'selected' /*case 'Selected'*/ :
                            break;
                        case 'protectobjects' /*case 'ProtectObjects'*/ :
                            break;
                        case 'enableselection' /*case 'EnableSelection'*/ :
                            break;
                        case 'protectscenarios' /*case 'ProtectScenarios'*/ :
                            break;
                        case 'validprinterinfo' /*case 'ValidPrinterInfo'*/ :
                            break;
                        case 'horizontalresolution' /*case 'HorizontalResolution'*/ :
                            break;
                        case 'verticalresolution' /*case 'VerticalResolution'*/ :
                            break;
                        case 'numberofcopies' /*case 'NumberofCopies'*/ :
                            break;
                        case 'activepane' /*case 'ActivePane'*/ :
                            break;
                        case 'toprowvisible' /*case 'TopRowVisible'*/ :
                            break;
                        case 'leftcolumnvisible' /*case 'LeftColumnVisible'*/ :
                            break;
                        case 'fittopage' /*case 'FitToPage'*/ :
                            break;
                        case 'rangeselection' /*case 'RangeSelection'*/ :
                            break;
                        case 'papersizeindex' /*case 'PaperSizeIndex'*/ :
                            break;
                        case 'pagelayoutzoom' /*case 'PageLayoutZoom'*/ :
                            break;
                        case 'pagebreakzoom' /*case 'PageBreakZoom'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'fitwidth' /*case 'FitWidth'*/ :
                            break;
                        case 'fitheight' /*case 'FitHeight'*/ :
                            break;
                        case 'commentslayout' /*case 'CommentsLayout'*/ :
                            break;
                        case 'zoom' /*case 'Zoom'*/ :
                            break;
                        case 'lefttoright' /*case 'LeftToRight'*/ :
                            break;
                        case 'gridlines' /*case 'Gridlines'*/ :
                            break;
                        case 'allowsort' /*case 'AllowSort'*/ :
                            break;
                        case 'allowfilter' /*case 'AllowFilter'*/ :
                            break;
                        case 'allowinsertrows' /*case 'AllowInsertRows'*/ :
                            break;
                        case 'allowdeleterows' /*case 'AllowDeleteRows'*/ :
                            break;
                        case 'allowinsertcols' /*case 'AllowInsertCols'*/ :
                            break;
                        case 'allowdeletecols' /*case 'AllowDeleteCols'*/ :
                            break;
                        case 'allowinserthyperlinks' /*case 'AllowInsertHyperlinks'*/ :
                            break;
                        case 'allowformatcells' /*case 'AllowFormatCells'*/ :
                            break;
                        case 'allowsizecols' /*case 'AllowSizeCols'*/ :
                            break;
                        case 'allowsizerows' /*case 'AllowSizeRows'*/ :
                            break;
                        case 'nosummaryrowsbelowdetail' /*case 'NoSummaryRowsBelowDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].above = true;
                            break;
                        case 'tabcolorindex' /*case 'TabColorIndex'*/ :
                            break;
                        case 'donotdisplayheadings' /*case 'DoNotDisplayHeadings'*/ :
                            break;
                        case 'showpagelayoutzoom' /*case 'ShowPageLayoutZoom'*/ :
                            break;
                        case 'nosummarycolumnsrightdetail' /*case 'NoSummaryColumnsRightDetail'*/ :
                            if (!cursheet["!outline"]) cursheet["!outline"] = {};
                            cursheet["!outline"].left = true;
                            break;
                        case 'blackandwhite' /*case 'BlackAndWhite'*/ :
                            break;
                        case 'donotdisplayzeros' /*case 'DoNotDisplayZeros'*/ :
                            break;
                        case 'displaypagebreak' /*case 'DisplayPageBreak'*/ :
                            break;
                        case 'rowcolheadings' /*case 'RowColHeadings'*/ :
                            break;
                        case 'donotdisplayoutline' /*case 'DoNotDisplayOutline'*/ :
                            break;
                        case 'noorientation' /*case 'NoOrientation'*/ :
                            break;
                        case 'allowusepivottables' /*case 'AllowUsePivotTables'*/ :
                            break;
                        case 'zeroheight' /*case 'ZeroHeight'*/ :
                            break;
                        case 'viewablerange' /*case 'ViewableRange'*/ :
                            break;
                        case 'selection' /*case 'Selection'*/ :
                            break;
                        case 'protectcontents' /*case 'ProtectContents'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PivotTable */ case 'pivottable' /*case 'PivotTable'*/ :
                case 'pivotcache' /*case 'PivotCache'*/ :
                    switch(Rn[3]){
                        case 'immediateitemsondrop' /*case 'ImmediateItemsOnDrop'*/ :
                            break;
                        case 'showpagemultipleitemlabel' /*case 'ShowPageMultipleItemLabel'*/ :
                            break;
                        case 'compactrowindent' /*case 'CompactRowIndent'*/ :
                            break;
                        case 'location' /*case 'Location'*/ :
                            break;
                        case 'pivotfield' /*case 'PivotField'*/ :
                            break;
                        case 'orientation' /*case 'Orientation'*/ :
                            break;
                        case 'layoutform' /*case 'LayoutForm'*/ :
                            break;
                        case 'layoutsubtotallocation' /*case 'LayoutSubtotalLocation'*/ :
                            break;
                        case 'layoutcompactrow' /*case 'LayoutCompactRow'*/ :
                            break;
                        case 'position' /*case 'Position'*/ :
                            break;
                        case 'pivotitem' /*case 'PivotItem'*/ :
                            break;
                        case 'datatype' /*case 'DataType'*/ :
                            break;
                        case 'datafield' /*case 'DataField'*/ :
                            break;
                        case 'sourcename' /*case 'SourceName'*/ :
                            break;
                        case 'parentfield' /*case 'ParentField'*/ :
                            break;
                        case 'ptlineitems' /*case 'PTLineItems'*/ :
                            break;
                        case 'ptlineitem' /*case 'PTLineItem'*/ :
                            break;
                        case 'countofsameitems' /*case 'CountOfSameItems'*/ :
                            break;
                        case 'item' /*case 'Item'*/ :
                            break;
                        case 'itemtype' /*case 'ItemType'*/ :
                            break;
                        case 'ptsource' /*case 'PTSource'*/ :
                            break;
                        case 'cacheindex' /*case 'CacheIndex'*/ :
                            break;
                        case 'consolidationreference' /*case 'ConsolidationReference'*/ :
                            break;
                        case 'filename' /*case 'FileName'*/ :
                            break;
                        case 'reference' /*case 'Reference'*/ :
                            break;
                        case 'nocolumngrand' /*case 'NoColumnGrand'*/ :
                            break;
                        case 'norowgrand' /*case 'NoRowGrand'*/ :
                            break;
                        case 'blanklineafteritems' /*case 'BlankLineAfterItems'*/ :
                            break;
                        case 'hidden' /*case 'Hidden'*/ :
                            break;
                        case 'subtotal' /*case 'Subtotal'*/ :
                            break;
                        case 'basefield' /*case 'BaseField'*/ :
                            break;
                        case 'mapchilditems' /*case 'MapChildItems'*/ :
                            break;
                        case 'function' /*case 'Function'*/ :
                            break;
                        case 'refreshonfileopen' /*case 'RefreshOnFileOpen'*/ :
                            break;
                        case 'printsettitles' /*case 'PrintSetTitles'*/ :
                            break;
                        case 'mergelabels' /*case 'MergeLabels'*/ :
                            break;
                        case 'defaultversion' /*case 'DefaultVersion'*/ :
                            break;
                        case 'refreshname' /*case 'RefreshName'*/ :
                            break;
                        case 'refreshdate' /*case 'RefreshDate'*/ :
                            break;
                        case 'refreshdatecopy' /*case 'RefreshDateCopy'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        case 'versionlastupdate' /*case 'VersionLastUpdate'*/ :
                            break;
                        case 'versionupdateablemin' /*case 'VersionUpdateableMin'*/ :
                            break;
                        case 'versionrefreshablemin' /*case 'VersionRefreshableMin'*/ :
                            break;
                        case 'calculation' /*case 'Calculation'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* PageBreaks */ case 'pagebreaks' /*case 'PageBreaks'*/ :
                    switch(Rn[3]){
                        case 'colbreaks' /*case 'ColBreaks'*/ :
                            break;
                        case 'colbreak' /*case 'ColBreak'*/ :
                            break;
                        case 'rowbreaks' /*case 'RowBreaks'*/ :
                            break;
                        case 'rowbreak' /*case 'RowBreak'*/ :
                            break;
                        case 'colstart' /*case 'ColStart'*/ :
                            break;
                        case 'colend' /*case 'ColEnd'*/ :
                            break;
                        case 'rowend' /*case 'RowEnd'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* AutoFilter */ case 'autofilter' /*case 'AutoFilter'*/ :
                    switch(Rn[3]){
                        case 'autofiltercolumn' /*case 'AutoFilterColumn'*/ :
                            break;
                        case 'autofiltercondition' /*case 'AutoFilterCondition'*/ :
                            break;
                        case 'autofilterand' /*case 'AutoFilterAnd'*/ :
                            break;
                        case 'autofilteror' /*case 'AutoFilterOr'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* QueryTable */ case 'querytable' /*case 'QueryTable'*/ :
                    switch(Rn[3]){
                        case 'id' /*case 'Id'*/ :
                            break;
                        case 'autoformatfont' /*case 'AutoFormatFont'*/ :
                            break;
                        case 'autoformatpattern' /*case 'AutoFormatPattern'*/ :
                            break;
                        case 'querysource' /*case 'QuerySource'*/ :
                            break;
                        case 'querytype' /*case 'QueryType'*/ :
                            break;
                        case 'enableredirections' /*case 'EnableRedirections'*/ :
                            break;
                        case 'refreshedinxl9' /*case 'RefreshedInXl9'*/ :
                            break;
                        case 'urlstring' /*case 'URLString'*/ :
                            break;
                        case 'htmltables' /*case 'HTMLTables'*/ :
                            break;
                        case 'connection' /*case 'Connection'*/ :
                            break;
                        case 'commandtext' /*case 'CommandText'*/ :
                            break;
                        case 'refreshinfo' /*case 'RefreshInfo'*/ :
                            break;
                        case 'notitles' /*case 'NoTitles'*/ :
                            break;
                        case 'nextid' /*case 'NextId'*/ :
                            break;
                        case 'columninfo' /*case 'ColumnInfo'*/ :
                            break;
                        case 'overwritecells' /*case 'OverwriteCells'*/ :
                            break;
                        case 'donotpromptforfile' /*case 'DoNotPromptForFile'*/ :
                            break;
                        case 'textwizardsettings' /*case 'TextWizardSettings'*/ :
                            break;
                        case 'source' /*case 'Source'*/ :
                            break;
                        case 'number' /*case 'Number'*/ :
                            break;
                        case 'decimal' /*case 'Decimal'*/ :
                            break;
                        case 'thousandseparator' /*case 'ThousandSeparator'*/ :
                            break;
                        case 'trailingminusnumbers' /*case 'TrailingMinusNumbers'*/ :
                            break;
                        case 'formatsettings' /*case 'FormatSettings'*/ :
                            break;
                        case 'fieldtype' /*case 'FieldType'*/ :
                            break;
                        case 'delimiters' /*case 'Delimiters'*/ :
                            break;
                        case 'tab' /*case 'Tab'*/ :
                            break;
                        case 'comma' /*case 'Comma'*/ :
                            break;
                        case 'autoformatname' /*case 'AutoFormatName'*/ :
                            break;
                        case 'versionlastedit' /*case 'VersionLastEdit'*/ :
                            break;
                        case 'versionlastrefresh' /*case 'VersionLastRefresh'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'datavalidation' /*case 'DataValidation'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                case 'sorting' /*case 'Sorting'*/ :
                case 'conditionalformatting' /*case 'ConditionalFormatting'*/ :
                    switch(Rn[3]){
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'type' /*case 'Type'*/ :
                            break;
                        case 'min' /*case 'Min'*/ :
                            break;
                        case 'max' /*case 'Max'*/ :
                            break;
                        case 'sort' /*case 'Sort'*/ :
                            break;
                        case 'descending' /*case 'Descending'*/ :
                            break;
                        case 'order' /*case 'Order'*/ :
                            break;
                        case 'casesensitive' /*case 'CaseSensitive'*/ :
                            break;
                        case 'value' /*case 'Value'*/ :
                            break;
                        case 'errorstyle' /*case 'ErrorStyle'*/ :
                            break;
                        case 'errormessage' /*case 'ErrorMessage'*/ :
                            break;
                        case 'errortitle' /*case 'ErrorTitle'*/ :
                            break;
                        case 'cellrangelist' /*case 'CellRangeList'*/ :
                            break;
                        case 'inputmessage' /*case 'InputMessage'*/ :
                            break;
                        case 'inputtitle' /*case 'InputTitle'*/ :
                            break;
                        case 'combohide' /*case 'ComboHide'*/ :
                            break;
                        case 'inputhide' /*case 'InputHide'*/ :
                            break;
                        case 'condition' /*case 'Condition'*/ :
                            break;
                        case 'qualifier' /*case 'Qualifier'*/ :
                            break;
                        case 'useblank' /*case 'UseBlank'*/ :
                            break;
                        case 'value1' /*case 'Value1'*/ :
                            break;
                        case 'value2' /*case 'Value2'*/ :
                            break;
                        case 'format' /*case 'Format'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* MapInfo (schema) */ case 'mapinfo' /*case 'MapInfo'*/ :
                case 'schema' /*case 'Schema'*/ :
                case 'data' /*case 'data'*/ :
                    switch(Rn[3]){
                        case 'map' /*case 'Map'*/ :
                            break;
                        case 'entry' /*case 'Entry'*/ :
                            break;
                        case 'range' /*case 'Range'*/ :
                            break;
                        case 'xpath' /*case 'XPath'*/ :
                            break;
                        case 'field' /*case 'Field'*/ :
                            break;
                        case 'xsdtype' /*case 'XSDType'*/ :
                            break;
                        case 'filteron' /*case 'FilterOn'*/ :
                            break;
                        case 'aggregate' /*case 'Aggregate'*/ :
                            break;
                        case 'elementtype' /*case 'ElementType'*/ :
                            break;
                        case 'attributetype' /*case 'AttributeType'*/ :
                            break;
                        /* These are from xsd (XML Schema Definition) */ case 'schema' /*case 'schema'*/ :
                        case 'element' /*case 'element'*/ :
                        case 'complextype' /*case 'complexType'*/ :
                        case 'datatype' /*case 'datatype'*/ :
                        case 'all' /*case 'all'*/ :
                        case 'attribute' /*case 'attribute'*/ :
                        case 'extends' /*case 'extends'*/ :
                            break;
                        case 'row' /*case 'row'*/ :
                            break;
                        default:
                            seen = false;
                    }
                    break;
                /* SmartTags (can be anything) */ case 'smarttags' /*case 'SmartTags'*/ :
                    break;
                default:
                    seen = false;
                    break;
            }
            if (seen) break;
            /* CustomDocumentProperties */ if (Rn[3].match(/!\[CDATA/)) break;
            if (!state[state.length - 1][1]) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
            if (state[state.length - 1][0] === /*'CustomDocumentProperties'*/ 'customdocumentproperties') {
                if (Rn[0].slice(-2) === "/>") break;
                else if (Rn[1] === "/") $a1a91b25d7598376$var$xlml_set_custprop(Custprops, raw_Rn3, cp, str.slice(pidx, Rn.index));
                else {
                    cp = Rn;
                    pidx = Rn.index + Rn[0].length;
                }
                break;
            }
            if (opts.WTF) throw 'Unrecognized tag: ' + Rn[3] + "|" + state.join("|");
    }
    var out = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) out.Sheets = sheets;
    out.SheetNames = sheetnames;
    out.Workbook = Workbook;
    out.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    out.Props = Props;
    out.Custprops = Custprops;
    out.bookType = "xlml";
    return out;
}
function $a1a91b25d7598376$var$parse_xlml(data /*:RawBytes|string*/ , opts) /*:Workbook*/ {
    $a1a91b25d7598376$var$fix_read_opts(opts = opts || {});
    switch(opts.type || "base64"){
        case "base64":
            return $a1a91b25d7598376$var$parse_xlml_xml($a1a91b25d7598376$var$Base64_decode(data), opts);
        case "binary":
        case "buffer":
        case "file":
            return $a1a91b25d7598376$var$parse_xlml_xml(data, opts);
        case "array":
            return $a1a91b25d7598376$var$parse_xlml_xml($a1a91b25d7598376$var$a2s(data), opts);
    }
/*:: throw new Error("unsupported type " + opts.type); */ }
/* TODO */ function $a1a91b25d7598376$var$write_props_xlml(wb /*:Workbook*/ , opts) /*:string*/ {
    var o /*:Array<string>*/  = [];
    /* DocumentProperties */ if (wb.Props) o.push($a1a91b25d7598376$var$xlml_write_docprops(wb.Props, opts));
    /* CustomDocumentProperties */ if (wb.Custprops) o.push($a1a91b25d7598376$var$xlml_write_custprops(wb.Props, wb.Custprops, opts));
    return o.join("");
}
/* TODO */ function $a1a91b25d7598376$var$write_wb_xlml(wb /*::, opts*/ ) /*:string*/ {
    /* OfficeDocumentSettings */ /* ExcelWorkbook */ if ((((wb || {}).Workbook || {}).WBProps || {}).date1904) return '<ExcelWorkbook xmlns="urn:schemas-microsoft-com:office:excel"><Date1904/></ExcelWorkbook>';
    return "";
}
/* TODO */ function $a1a91b25d7598376$var$write_sty_xlml(wb, opts) /*:string*/ {
    /* Styles */ var styles /*:Array<string>*/  = [
        '<Style ss:ID="Default" ss:Name="Normal"><NumberFormat/></Style>'
    ];
    opts.cellXfs.forEach(function(xf, id) {
        var payload /*:Array<string>*/  = [];
        payload.push($a1a91b25d7598376$var$writextag('NumberFormat', null, {
            "ss:Format": $a1a91b25d7598376$var$escapexml($a1a91b25d7598376$var$table_fmt[xf.numFmtId])
        }));
        var o = /*::(*/ {
            "ss:ID": "s" + (21 + id)
        } /*:: :any)*/ ;
        styles.push($a1a91b25d7598376$var$writextag('Style', payload.join(""), o));
    });
    return $a1a91b25d7598376$var$writextag("Styles", styles.join(""));
}
function $a1a91b25d7598376$var$write_name_xlml(n) {
    return $a1a91b25d7598376$var$writextag("NamedRange", null, {
        "ss:Name": n.Name.slice(0, 6) == "_xlnm." ? n.Name.slice(6) : n.Name,
        "ss:RefersTo": "=" + $a1a91b25d7598376$var$a1_to_rc(n.Ref, {
            r: 0,
            c: 0
        })
    });
}
function $a1a91b25d7598376$var$write_names_xlml(wb /*::, opts*/ ) /*:string*/ {
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != null) continue;
        if (n.Name.match(/^_xlfn\./)) continue;
        out.push($a1a91b25d7598376$var$write_name_xlml(n));
    }
    return $a1a91b25d7598376$var$writextag("Names", out.join(""));
}
function $a1a91b25d7598376$var$write_ws_xlml_names(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    if (!((wb || {}).Workbook || {}).Names) return "";
    /*:: if(!wb || !wb.Workbook || !wb.Workbook.Names) throw new Error("unreachable"); */ var names /*:Array<any>*/  = wb.Workbook.Names;
    var out /*:Array<string>*/  = [];
    for(var i = 0; i < names.length; ++i){
        var n = names[i];
        if (n.Sheet != idx) continue;
        /*switch(n.Name) {
			case "_": continue;
		}*/ if (n.Name.match(/^_xlfn\./)) continue;
        out.push($a1a91b25d7598376$var$write_name_xlml(n));
    }
    return out.join("");
}
/* WorksheetOptions */ function $a1a91b25d7598376$var$write_ws_xlml_wsopts(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws) return "";
    var o /*:Array<string>*/  = [];
    /* NOTE: spec technically allows any order, but stick with implied order */ /* FitToPage */ /* DoNotDisplayColHeaders */ /* DoNotDisplayRowHeaders */ /* ViewableRange */ /* Selection */ /* GridlineColor */ /* Name */ /* ExcelWorksheetType */ /* IntlMacro */ /* Unsynced */ /* Selected */ /* CodeName */ if (ws['!margins']) {
        o.push("<PageSetup>");
        if (ws['!margins'].header) o.push($a1a91b25d7598376$var$writextag("Header", null, {
            'x:Margin': ws['!margins'].header
        }));
        if (ws['!margins'].footer) o.push($a1a91b25d7598376$var$writextag("Footer", null, {
            'x:Margin': ws['!margins'].footer
        }));
        o.push($a1a91b25d7598376$var$writextag("PageMargins", null, {
            'x:Bottom': ws['!margins'].bottom || "0.75",
            'x:Left': ws['!margins'].left || "0.7",
            'x:Right': ws['!margins'].right || "0.7",
            'x:Top': ws['!margins'].top || "0.75"
        }));
        o.push("</PageSetup>");
    }
    /* PageSetup */ /* DisplayPageBreak */ /* TransitionExpressionEvaluation */ /* TransitionFormulaEntry */ /* Print */ /* Zoom */ /* PageLayoutZoom */ /* PageBreakZoom */ /* ShowPageBreakZoom */ /* DefaultRowHeight */ /* DefaultColumnWidth */ /* StandardWidth */ if (wb && wb.Workbook && wb.Workbook.Sheets && wb.Workbook.Sheets[idx]) {
        /* Visible */ if (wb.Workbook.Sheets[idx].Hidden) o.push($a1a91b25d7598376$var$writextag("Visible", wb.Workbook.Sheets[idx].Hidden == 1 ? "SheetHidden" : "SheetVeryHidden", {}));
        else {
            /* Selected */ for(var i = 0; i < idx; ++i)if (wb.Workbook.Sheets[i] && !wb.Workbook.Sheets[i].Hidden) break;
            if (i == idx) o.push("<Selected/>");
        }
    }
    /* LeftColumnVisible */ if (((((wb || {}).Workbook || {}).Views || [])[0] || {}).RTL) o.push("<DisplayRightToLeft/>");
    /* GridlineColorIndex */ /* DisplayFormulas */ /* DoNotDisplayGridlines */ /* DoNotDisplayHeadings */ /* DoNotDisplayOutline */ /* ApplyAutomaticOutlineStyles */ /* NoSummaryRowsBelowDetail */ /* NoSummaryColumnsRightDetail */ /* DoNotDisplayZeros */ /* ActiveRow */ /* ActiveColumn */ /* FilterOn */ /* RangeSelection */ /* TopRowVisible */ /* TopRowBottomPane */ /* LeftColumnRightPane */ /* ActivePane */ /* SplitHorizontal */ /* SplitVertical */ /* FreezePanes */ /* FrozenNoSplit */ /* TabColorIndex */ /* Panes */ /* NOTE: Password not supported in XLML Format */ if (ws['!protect']) {
        o.push($a1a91b25d7598376$var$writetag("ProtectContents", "True"));
        if (ws['!protect'].objects) o.push($a1a91b25d7598376$var$writetag("ProtectObjects", "True"));
        if (ws['!protect'].scenarios) o.push($a1a91b25d7598376$var$writetag("ProtectScenarios", "True"));
        if (ws['!protect'].selectLockedCells != null && !ws['!protect'].selectLockedCells) o.push($a1a91b25d7598376$var$writetag("EnableSelection", "NoSelection"));
        else if (ws['!protect'].selectUnlockedCells != null && !ws['!protect'].selectUnlockedCells) o.push($a1a91b25d7598376$var$writetag("EnableSelection", "UnlockedCells"));
        [
            [
                "formatCells",
                "AllowFormatCells"
            ],
            [
                "formatColumns",
                "AllowSizeCols"
            ],
            [
                "formatRows",
                "AllowSizeRows"
            ],
            [
                "insertColumns",
                "AllowInsertCols"
            ],
            [
                "insertRows",
                "AllowInsertRows"
            ],
            [
                "insertHyperlinks",
                "AllowInsertHyperlinks"
            ],
            [
                "deleteColumns",
                "AllowDeleteCols"
            ],
            [
                "deleteRows",
                "AllowDeleteRows"
            ],
            [
                "sort",
                "AllowSort"
            ],
            [
                "autoFilter",
                "AllowFilter"
            ],
            [
                "pivotTables",
                "AllowUsePivotTables"
            ]
        ].forEach(function(x) {
            if (ws['!protect'][x[0]]) o.push("<" + x[1] + "/>");
        });
    }
    if (o.length == 0) return "";
    return $a1a91b25d7598376$var$writextag("WorksheetOptions", o.join(""), {
        xmlns: $a1a91b25d7598376$var$XLMLNS.x
    });
}
function $a1a91b25d7598376$var$write_ws_xlml_comment(comments /*:Array<any>*/ ) /*:string*/ {
    /* TODO: test multiple comments */ return comments.map(function(c) {
        // TODO: formatted text
        var t = $a1a91b25d7598376$var$xlml_unfixstr(c.t || "");
        var d = $a1a91b25d7598376$var$writextag("ss:Data", t, {
            "xmlns": "http://www.w3.org/TR/REC-html40"
        });
        var p = {};
        if (c.a) p["ss:Author"] = c.a;
        if (!comments.hidden) p["ss:ShowAlways"] = "1";
        return $a1a91b25d7598376$var$writextag("Comment", d, p);
    }).join("");
}
function $a1a91b25d7598376$var$write_ws_xlml_cell(cell, ref /*:string*/ , ws, opts, idx /*:number*/ , wb, addr) /*:string*/ {
    if (!cell || cell.v == undefined && cell.f == undefined) return "";
    var attr = {};
    if (cell.f) attr["ss:Formula"] = "=" + $a1a91b25d7598376$var$escapexml($a1a91b25d7598376$var$a1_to_rc(cell.f, addr));
    if (cell.F && cell.F.slice(0, ref.length) == ref) {
        var end = $a1a91b25d7598376$var$decode_cell(cell.F.slice(ref.length + 1));
        attr["ss:ArrayRange"] = "RC:R" + (end.r == addr.r ? "" : "[" + (end.r - addr.r) + "]") + "C" + (end.c == addr.c ? "" : "[" + (end.c - addr.c) + "]");
    }
    if (cell.l && cell.l.Target) {
        attr["ss:HRef"] = $a1a91b25d7598376$var$escapexml(cell.l.Target);
        if (cell.l.Tooltip) attr["x:HRefScreenTip"] = $a1a91b25d7598376$var$escapexml(cell.l.Tooltip);
    }
    if (ws['!merges']) {
        var marr = ws['!merges'];
        for(var mi = 0; mi != marr.length; ++mi){
            if (marr[mi].s.c != addr.c || marr[mi].s.r != addr.r) continue;
            if (marr[mi].e.c > marr[mi].s.c) attr['ss:MergeAcross'] = marr[mi].e.c - marr[mi].s.c;
            if (marr[mi].e.r > marr[mi].s.r) attr['ss:MergeDown'] = marr[mi].e.r - marr[mi].s.r;
        }
    }
    var t = "", p = "";
    switch(cell.t){
        case 'z':
            if (!opts.sheetStubs) return "";
            break;
        case 'n':
            if (!isFinite(cell.v)) {
                t = 'Error';
                p = $a1a91b25d7598376$var$BErr[isNaN(cell.v) ? 0x24 : 0x07];
            } else {
                t = 'Number';
                p = String(cell.v);
            }
            break;
        case 'b':
            t = 'Boolean';
            p = cell.v ? "1" : "0";
            break;
        case 'e':
            t = 'Error';
            p = $a1a91b25d7598376$var$BErr[cell.v];
            break;
        case 'd':
            t = 'DateTime';
            p = new Date(cell.v).toISOString();
            if (cell.z == null) cell.z = cell.z || $a1a91b25d7598376$var$table_fmt[14];
            break;
        case 's':
            t = 'String';
            p = $a1a91b25d7598376$var$escapexlml(cell.v || "");
            break;
    }
    /* TODO: cell style */ var os = $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    attr["ss:StyleID"] = "s" + (21 + os);
    attr["ss:Index"] = addr.c + 1;
    var _v = cell.v != null ? p : "";
    var m = cell.t == 'z' ? "" : '<Data ss:Type="' + t + '">' + _v + '</Data>';
    if ((cell.c || []).length > 0) m += $a1a91b25d7598376$var$write_ws_xlml_comment(cell.c);
    return $a1a91b25d7598376$var$writextag("Cell", m, attr);
}
function $a1a91b25d7598376$var$write_ws_xlml_row(R /*:number*/ , row) /*:string*/ {
    var o = '<Row ss:Index="' + (R + 1) + '"';
    if (row) {
        if (row.hpt && !row.hpx) row.hpx = $a1a91b25d7598376$var$pt2px(row.hpt);
        if (row.hpx) o += ' ss:AutoFitHeight="0" ss:Height="' + row.hpx + '"';
        if (row.hidden) o += ' ss:Hidden="1"';
    }
    return o + '>';
}
/* TODO */ function $a1a91b25d7598376$var$write_ws_xlml_table(ws /*:Worksheet*/ , opts, idx /*:number*/ , wb /*:Workbook*/ ) /*:string*/ {
    if (!ws['!ref']) return "";
    var range /*:Range*/  = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
    var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
    var o /*:Array<string>*/  = [];
    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
        $a1a91b25d7598376$var$process_col(n);
        var w = !!n.width;
        var p = $a1a91b25d7598376$var$col_obj_w(i, n);
        var k /*:any*/  = {
            "ss:Index": i + 1
        };
        if (w) k['ss:Width'] = $a1a91b25d7598376$var$width2px(p.width);
        if (n.hidden) k['ss:Hidden'] = "1";
        o.push($a1a91b25d7598376$var$writextag("Column", null, k));
    });
    var dense = ws["!data"] != null;
    var addr = {
        r: 0,
        c: 0
    };
    for(var R = range.s.r; R <= range.e.r; ++R){
        var row = [
            $a1a91b25d7598376$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
        ];
        addr.r = R;
        for(var C = range.s.c; C <= range.e.c; ++C){
            addr.c = C;
            var skip = false;
            for(mi = 0; mi != marr.length; ++mi){
                if (marr[mi].s.c > C) continue;
                if (marr[mi].s.r > R) continue;
                if (marr[mi].e.c < C) continue;
                if (marr[mi].e.r < R) continue;
                if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                break;
            }
            if (skip) continue;
            var ref = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
            row.push($a1a91b25d7598376$var$write_ws_xlml_cell(cell, ref, ws, opts, idx, wb, addr));
        }
        row.push("</Row>");
        if (row.length > 2) o.push(row.join(""));
    }
    return o.join("");
}
function $a1a91b25d7598376$var$write_ws_xlml(idx /*:number*/ , opts, wb /*:Workbook*/ ) /*:string*/ {
    var o /*:Array<string>*/  = [];
    var s = wb.SheetNames[idx];
    var ws = wb.Sheets[s];
    var t /*:string*/  = ws ? $a1a91b25d7598376$var$write_ws_xlml_names(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Names>" + t + "</Names>");
    /* Table */ t = ws ? $a1a91b25d7598376$var$write_ws_xlml_table(ws, opts, idx, wb) : "";
    if (t.length > 0) o.push("<Table>" + t + "</Table>");
    /* WorksheetOptions */ o.push($a1a91b25d7598376$var$write_ws_xlml_wsopts(ws, opts, idx, wb));
    if (ws && ws["!autofilter"]) o.push('<AutoFilter x:Range="' + $a1a91b25d7598376$var$a1_to_rc($a1a91b25d7598376$var$fix_range(ws["!autofilter"].ref), {
        r: 0,
        c: 0
    }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
    return o.join("");
}
function $a1a91b25d7598376$var$write_xlml(wb, opts) /*:string*/ {
    if (!opts) opts = {};
    if (!wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    var d /*:Array<string>*/  = [];
    d.push($a1a91b25d7598376$var$write_props_xlml(wb, opts));
    d.push($a1a91b25d7598376$var$write_wb_xlml(wb, opts));
    d.push("");
    d.push($a1a91b25d7598376$var$write_names_xlml(wb, opts));
    for(var i = 0; i < wb.SheetNames.length; ++i)d.push($a1a91b25d7598376$var$writextag("Worksheet", $a1a91b25d7598376$var$write_ws_xlml(i, opts, wb), {
        "ss:Name": $a1a91b25d7598376$var$escapexml(wb.SheetNames[i])
    }));
    d[2] = $a1a91b25d7598376$var$write_sty_xlml(wb, opts);
    return $a1a91b25d7598376$var$XML_HEADER + $a1a91b25d7598376$var$writextag("Workbook", d.join(""), {
        'xmlns': $a1a91b25d7598376$var$XLMLNS.ss,
        'xmlns:o': $a1a91b25d7598376$var$XLMLNS.o,
        'xmlns:x': $a1a91b25d7598376$var$XLMLNS.x,
        'xmlns:ss': $a1a91b25d7598376$var$XLMLNS.ss,
        'xmlns:dt': $a1a91b25d7598376$var$XLMLNS.dt,
        'xmlns:html': $a1a91b25d7598376$var$XLMLNS.html
    });
}
/* [MS-OLEDS] 2.3.8 CompObjStream */ function $a1a91b25d7598376$var$parse_compobj(obj /*:CFBEntry*/ ) {
    var v = {};
    var o = obj.content;
    /*:: if(o == null) return; */ /* [MS-OLEDS] 2.3.7 CompObjHeader -- All fields MUST be ignored */ o.l = 28;
    v.AnsiUserType = o.read_shift(0, "lpstr-ansi");
    v.AnsiClipboardFormat = $a1a91b25d7598376$var$parse_ClipboardFormatOrAnsiString(o);
    if (o.length - o.l <= 4) return v;
    var m /*:number*/  = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved1 = o.read_shift(0, "lpstr-ansi");
    if (o.length - o.l <= 4) return v;
    m = o.read_shift(4);
    if (m !== 0x71b239f4) return v;
    v.UnicodeClipboardFormat = $a1a91b25d7598376$var$parse_ClipboardFormatOrUnicodeString(o);
    m = o.read_shift(4);
    if (m == 0 || m > 40) return v;
    o.l -= 4;
    v.Reserved2 = o.read_shift(0, "lpwstr");
}
/*
	Continue logic for:
	- 2.4.58 Continue          0x003c
	- 2.4.59 ContinueBigName   0x043c
	- 2.4.60 ContinueFrt       0x0812
	- 2.4.61 ContinueFrt11     0x0875
	- 2.4.62 ContinueFrt12     0x087f
*/ var $a1a91b25d7598376$var$CONTINUE_RT = [
    0x003c,
    0x043c,
    0x0812,
    0x0875,
    0x087f
];
function $a1a91b25d7598376$var$slurp(RecordType, R, blob, length /*:number*/ , opts) /*:any*/ {
    var l = length;
    var bufs = [];
    var d = blob.slice(blob.l, blob.l + l);
    if (opts && opts.enc && opts.enc.insitu && d.length > 0) switch(RecordType){
        case 0x0009:
        case 0x0209:
        case 0x0409:
        case 0x0809 /* BOF */ :
        case 0x002F /* FilePass */ :
        case 0x0195 /* FileLock */ :
        case 0x00E1 /* InterfaceHdr */ :
        case 0x0196 /* RRDInfo */ :
        case 0x0138 /* RRDHead */ :
        case 0x0194 /* UsrExcl */ :
        case 0x000a /* EOF */ :
            break;
        case 0x0085 /* BoundSheet8 */ :
            break;
        default:
            opts.enc.insitu(d);
    }
    bufs.push(d);
    blob.l += l;
    var nextrt = $a1a91b25d7598376$var$__readUInt16LE(blob, blob.l), next = $a1a91b25d7598376$var$XLSRecordEnum[nextrt];
    var start = 0;
    while(next != null && $a1a91b25d7598376$var$CONTINUE_RT.indexOf(nextrt) > -1){
        l = $a1a91b25d7598376$var$__readUInt16LE(blob, blob.l + 2);
        start = blob.l + 4;
        if (nextrt == 0x0812 /* ContinueFrt */ ) start += 4;
        else if (nextrt == 0x0875 || nextrt == 0x087f) start += 12;
        d = blob.slice(start, blob.l + 4 + l);
        bufs.push(d);
        blob.l += 4 + l;
        next = $a1a91b25d7598376$var$XLSRecordEnum[nextrt = $a1a91b25d7598376$var$__readUInt16LE(blob, blob.l)];
    }
    var b = $a1a91b25d7598376$var$bconcat(bufs);
    $a1a91b25d7598376$var$prep_blob(b, 0);
    var ll = 0;
    b.lens = [];
    for(var j = 0; j < bufs.length; ++j){
        b.lens.push(ll);
        ll += bufs[j].length;
    }
    if (b.length < length) throw "XLS Record 0x" + RecordType.toString(16) + " Truncated: " + b.length + " < " + length;
    return R.f(b, b.length, opts);
}
function $a1a91b25d7598376$var$safe_format_xf(p /*:any*/ , opts /*:ParseOpts*/ , date1904 /*:?boolean*/ ) {
    if (p.t === 'z') return;
    if (!p.XF) return;
    var fmtid = 0;
    try {
        fmtid = p.z || p.XF.numFmtId || 0;
        if (opts.cellNF && p.z == null) p.z = $a1a91b25d7598376$var$table_fmt[fmtid];
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (!opts || opts.cellText !== false) try {
        if (p.t === 'e') p.w = p.w || $a1a91b25d7598376$var$BErr[p.v];
        else if (fmtid === 0 || fmtid == "General") {
            if (p.t === 'n') {
                if ((p.v | 0) === p.v) p.w = p.v.toString(10);
                else p.w = $a1a91b25d7598376$var$SSF_general_num(p.v);
            } else p.w = $a1a91b25d7598376$var$SSF_general(p.v);
        } else p.w = $a1a91b25d7598376$var$SSF_format(fmtid, p.v, {
            date1904: !!date1904,
            dateNF: opts && opts.dateNF
        });
    } catch (e) {
        if (opts.WTF) throw e;
    }
    if (opts.cellDates && fmtid && p.t == 'n' && $a1a91b25d7598376$var$fmt_is_date($a1a91b25d7598376$var$table_fmt[fmtid] || String(fmtid))) {
        var _d = $a1a91b25d7598376$var$SSF_parse_date_code(p.v + (date1904 ? 1462 : 0));
        if (_d) {
            p.t = 'd';
            p.v = new Date(Date.UTC(_d.y, _d.m - 1, _d.d, _d.H, _d.M, _d.S, _d.u));
        }
    }
}
function $a1a91b25d7598376$var$make_cell(val1, ixfe, t) /*:Cell*/ {
    return {
        v: val1,
        ixfe: ixfe,
        t: t
    } /*:any*/ ;
}
// 2.3.2
function $a1a91b25d7598376$var$parse_workbook(blob, options /*:ParseOpts*/ ) /*:Workbook*/ {
    var wb = {
        opts: {}
    } /*:any*/ ;
    var Sheets = {};
    if ($a1a91b25d7598376$var$DENSE != null && options.dense == null) options.dense = $a1a91b25d7598376$var$DENSE;
    var out /*:Worksheet*/  = {} /*:any*/ ;
    if (options.dense) out["!data"] = [];
    var Directory = {};
    var range /*:Range*/  = {} /*:any*/ ;
    var last_formula = null;
    var sst /*:SST*/  = [];
    var cur_sheet = "";
    var Preamble = {};
    var lastcell, last_cell = "", cc /*:Cell*/ , cmnt, rngC, rngR;
    var sharedf = {};
    var arrayf /*:Array<[Range, string]>*/  = [];
    var temp_val /*:Cell*/ ;
    var country;
    var XFs = []; /* XF records */ 
    var palette /*:Array<[number, number, number]>*/  = [];
    var Workbook /*:WBWBProps*/  = {
        Sheets: [],
        WBProps: {
            date1904: false
        },
        Views: [
            {}
        ]
    } /*:any*/ , wsprops = {};
    var biff4w = false;
    var get_rgb = function getrgb(icv /*:number*/ ) /*:[number, number, number]*/ {
        if (icv < 8) return $a1a91b25d7598376$var$XLSIcv[icv];
        if (icv < 64) return palette[icv - 8] || $a1a91b25d7598376$var$XLSIcv[icv];
        return $a1a91b25d7598376$var$XLSIcv[icv];
    };
    var process_cell_style = function pcs(line /*:any*/ , options) {
        var xfd = line.XF.data;
        if (!xfd || !xfd.patternType || !options || !options.cellStyles) return;
        line.s = {} /*:any*/ ;
        line.s.patternType = xfd.patternType;
        var t;
        if (t = $a1a91b25d7598376$var$rgb2Hex(get_rgb(xfd.icvFore))) line.s.fgColor = {
            rgb: t
        };
        if (t = $a1a91b25d7598376$var$rgb2Hex(get_rgb(xfd.icvBack))) line.s.bgColor = {
            rgb: t
        };
    };
    var addcell = function addcell(cell /*:any*/ , line /*:any*/ , options /*:any*/ ) {
        if (!biff4w && file_depth > 1) return;
        if (options.sheetRows && cell.r >= options.sheetRows) return;
        if (options.cellStyles && line.XF && line.XF.data) process_cell_style(line, options);
        delete line.ixfe;
        delete line.XF;
        lastcell = cell;
        last_cell = $a1a91b25d7598376$var$encode_cell(cell);
        if (!range || !range.s || !range.e) range = {
            s: {
                r: 0,
                c: 0
            },
            e: {
                r: 0,
                c: 0
            }
        };
        if (cell.r < range.s.r) range.s.r = cell.r;
        if (cell.c < range.s.c) range.s.c = cell.c;
        if (cell.r + 1 > range.e.r) range.e.r = cell.r + 1;
        if (cell.c + 1 > range.e.c) range.e.c = cell.c + 1;
        if (options.cellFormula && line.f) for(var afi = 0; afi < arrayf.length; ++afi){
            if (arrayf[afi][0].s.c > cell.c || arrayf[afi][0].s.r > cell.r) continue;
            if (arrayf[afi][0].e.c < cell.c || arrayf[afi][0].e.r < cell.r) continue;
            line.F = $a1a91b25d7598376$var$encode_range(arrayf[afi][0]);
            if (arrayf[afi][0].s.c != cell.c || arrayf[afi][0].s.r != cell.r) delete line.f;
            if (line.f) line.f = "" + $a1a91b25d7598376$var$stringify_formula(arrayf[afi][1], range, cell, supbooks, opts);
            break;
        }
        if (options.dense) {
            if (!out["!data"][cell.r]) out["!data"][cell.r] = [];
            out["!data"][cell.r][cell.c] = line;
        } else out[last_cell] = line;
    };
    var opts = {
        enc: false,
        sbcch: 0,
        snames: [],
        sharedf: sharedf,
        arrayf: arrayf,
        rrtabid: [],
        lastuser: "",
        biff: 8,
        codepage: 0,
        winlocked: 0,
        cellStyles: !!options && !!options.cellStyles,
        WTF: !!options && !!options.wtf
    } /*:any*/ ;
    if (options.password) opts.password = options.password;
    var themes;
    var merges /*:Array<Range>*/  = [];
    var objects = [];
    var colinfo /*:Array<ColInfo>*/  = [], rowinfo /*:Array<RowInfo>*/  = [];
    var seencol = false;
    var supbooks = []; // 1-indexed, will hold extern names
    supbooks.SheetNames = opts.snames;
    supbooks.sharedf = opts.sharedf;
    supbooks.arrayf = opts.arrayf;
    supbooks.names = [];
    supbooks.XTI = [];
    var last_RT = 0;
    var file_depth = 0; /* TODO: make a real stack */ 
    var BIFF2Fmt = 0, BIFF2FmtTable /*:Array<string>*/  = [];
    var FilterDatabases = []; /* TODO: sort out supbooks and process elsewhere */ 
    var last_lbl /*:?DefinedName*/ ;
    /* explicit override for some broken writers */ opts.codepage = 1200;
    $a1a91b25d7598376$var$set_cp(1200);
    var seen_codepage = false;
    while(blob.l < blob.length - 1){
        var s = blob.l;
        var RecordType = blob.read_shift(2);
        if (RecordType === 0 && last_RT === 0x000a /* EOF */ ) break;
        var length = blob.l === blob.length ? 0 : blob.read_shift(2);
        var R = $a1a91b25d7598376$var$XLSRecordEnum[RecordType];
        if (file_depth == 0 && [
            0x0009,
            0x0209,
            0x0409,
            0x0809
        ].indexOf(RecordType) == -1 /* BOF */ ) break;
        //console.log(RecordType.toString(16), RecordType, R, blob.l, length, blob.length);
        //if(!R) console.log(blob.slice(blob.l, blob.l + length));
        if (R && R.f) {
            if (options.bookSheets) {
                if (last_RT === 0x0085 /* BoundSheet8 */  && RecordType !== 0x0085 /* R.n !== 'BoundSheet8' */ ) break;
            }
            last_RT = RecordType;
            if (R.r === 2 || R.r == 12) {
                var rt = blob.read_shift(2);
                length -= 2;
                if (!opts.enc && rt !== RecordType && ((rt & 0xFF) << 8 | rt >> 8) !== RecordType) throw new Error("rt mismatch: " + rt + "!=" + RecordType);
                if (R.r == 12) {
                    blob.l += 10;
                    length -= 10;
                } // skip FRT
            }
            //console.error(R,blob.l,length,blob.length);
            var val1 /*:any*/  = {} /*:any*/ ;
            if (RecordType === 0x000a /* EOF */ ) val1 = /*::(*/ R.f(blob, length, opts) /*:: :any)*/ ;
            else val1 = /*::(*/ $a1a91b25d7598376$var$slurp(RecordType, R, blob, length, opts) /*:: :any)*/ ;
            /*:: val = (val:any); */ if (file_depth == 0 && [
                0x0009,
                0x0209,
                0x0409,
                0x0809
            ].indexOf(last_RT) === -1 /* BOF */ ) continue;
            switch(RecordType){
                case 0x0022 /* Date1904 */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ wb.opts.Date1904 = Workbook.WBProps.date1904 = val1;
                    break;
                case 0x0086 /* WriteProtect */ :
                    wb.opts.WriteProtect = true;
                    break;
                case 0x002f /* FilePass */ :
                    if (!opts.enc) blob.l = 0;
                    opts.enc = val1;
                    if (!options.password) throw new Error("File is password-protected");
                    if (val1.valid == null) throw new Error("Encryption scheme unsupported");
                    if (!val1.valid) throw new Error("Password is incorrect");
                    break;
                case 0x005c /* WriteAccess */ :
                    opts.lastuser = val1;
                    break;
                case 0x0042 /* CodePage */ :
                    var cpval = Number(val1);
                    /* overrides based on test cases */ switch(cpval){
                        case 0x5212:
                            cpval = 1200;
                            break;
                        case 0x8000:
                            cpval = 10000;
                            break;
                        case 0x8001:
                            cpval = 1252;
                            break;
                    }
                    $a1a91b25d7598376$var$set_cp(opts.codepage = cpval);
                    seen_codepage = true;
                    break;
                case 0x013d /* RRTabId */ :
                    opts.rrtabid = val1;
                    break;
                case 0x0019 /* WinProtect */ :
                    opts.winlocked = val1;
                    break;
                case 0x01b7 /* RefreshAll */ :
                    wb.opts["RefreshAll"] = val1;
                    break;
                case 0x000c /* CalcCount */ :
                    wb.opts["CalcCount"] = val1;
                    break;
                case 0x0010 /* CalcDelta */ :
                    wb.opts["CalcDelta"] = val1;
                    break;
                case 0x0011 /* CalcIter */ :
                    wb.opts["CalcIter"] = val1;
                    break;
                case 0x000d /* CalcMode */ :
                    wb.opts["CalcMode"] = val1;
                    break;
                case 0x000e /* CalcPrecision */ :
                    wb.opts["CalcPrecision"] = val1;
                    break;
                case 0x005f /* CalcSaveRecalc */ :
                    wb.opts["CalcSaveRecalc"] = val1;
                    break;
                case 0x000f /* CalcRefMode */ :
                    opts.CalcRefMode = val1;
                    break; // TODO: implement R1C1
                case 0x08a3 /* ForceFullCalculation */ :
                    wb.opts.FullCalc = val1;
                    break;
                case 0x0081 /* WsBool */ :
                    if (val1.fDialog) out["!type"] = "dialog";
                    if (!val1.fBelow) (out["!outline"] || (out["!outline"] = {})).above = true;
                    if (!val1.fRight) (out["!outline"] || (out["!outline"] = {})).left = true;
                    break; // TODO
                case 0x0043:
                /* BIFF2XF */ case 0x0243:
                /* BIFF3XF */ case 0x0443:
                /* BIFF4XF */ case 0x00e0 /* XF */ :
                    XFs.push(val1);
                    break;
                case 0x01ae /* SupBook */ :
                    supbooks.push([
                        val1
                    ]);
                    supbooks[supbooks.length - 1].XTI = [];
                    break;
                case 0x0023:
                case 0x0223 /* ExternName */ :
                    supbooks[supbooks.length - 1].push(val1);
                    break;
                case 0x0018:
                case 0x0218 /* Lbl */ :
                    last_lbl = {
                        Name: val1.Name,
                        Ref: $a1a91b25d7598376$var$stringify_formula(val1.rgce, range, null, supbooks, opts)
                    } /*:DefinedName*/ ;
                    if (val1.itab > 0) last_lbl.Sheet = val1.itab - 1;
                    supbooks.names.push(last_lbl);
                    if (!supbooks[0]) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].push(val1);
                    if (val1.Name == "_xlnm._FilterDatabase" && val1.itab > 0) {
                        if (val1.rgce && val1.rgce[0] && val1.rgce[0][0] && val1.rgce[0][0][0] == 'PtgArea3d') FilterDatabases[val1.itab - 1] = {
                            ref: $a1a91b25d7598376$var$encode_range(val1.rgce[0][0][1][2])
                        };
                    }
                    break;
                case 0x0016 /* ExternCount */ :
                    opts.ExternCount = val1;
                    break;
                case 0x0017 /* ExternSheet */ :
                    if (supbooks.length == 0) {
                        supbooks[0] = [];
                        supbooks[0].XTI = [];
                    }
                    supbooks[supbooks.length - 1].XTI = supbooks[supbooks.length - 1].XTI.concat(val1);
                    supbooks.XTI = supbooks.XTI.concat(val1);
                    break;
                case 0x0894 /* NameCmt */ :
                    /* TODO: search for correct name */ if (opts.biff < 8) break;
                    if (last_lbl != null) last_lbl.Comment = val1[1];
                    break;
                case 0x0012 /* Protect */ :
                    out["!protect"] = val1;
                    break; /* for sheet or book */ 
                case 0x0013 /* Password */ :
                    if (val1 !== 0 && opts.WTF) console.error("Password verifier: " + val1);
                    break;
                case 0x0085 /* BoundSheet8 */ :
                    Directory[opts.biff == 4 ? opts.snames.length : val1.pos] = val1;
                    opts.snames.push(val1.name);
                    break;
                case 0x000a /* EOF */ :
                    if (--file_depth ? !biff4w : biff4w) break;
                    if (range.e) {
                        if (range.e.r > 0 && range.e.c > 0) {
                            range.e.r--;
                            range.e.c--;
                            out["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                            if (options.sheetRows && options.sheetRows <= range.e.r) {
                                var tmpri = range.e.r;
                                range.e.r = options.sheetRows - 1;
                                out["!fullref"] = out["!ref"];
                                out["!ref"] = $a1a91b25d7598376$var$encode_range(range);
                                range.e.r = tmpri;
                            }
                            range.e.r++;
                            range.e.c++;
                        }
                        if (merges.length > 0) out["!merges"] = merges;
                        if (objects.length > 0) out["!objects"] = objects;
                        if (colinfo.length > 0) out["!cols"] = colinfo;
                        if (rowinfo.length > 0) out["!rows"] = rowinfo;
                        Workbook.Sheets.push(wsprops);
                    }
                    if (cur_sheet === "") Preamble = out;
                    else Sheets[cur_sheet] = out;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    break;
                case 0x0009:
                case 0x0209:
                case 0x0409:
                case 0x0809 /* BOF */ :
                    if (opts.biff === 8) opts.biff = ({
                        0x0009: 2,
                        0x0209: 3,
                        0x0409: 4
                    })[RecordType] || ({
                        0x0200: 2,
                        0x0300: 3,
                        0x0400: 4,
                        0x0500: 5,
                        0x0600: 8,
                        0x0002: 2,
                        0x0007: 2
                    })[val1.BIFFVer] || 8;
                    opts.biffguess = val1.BIFFVer == 0;
                    if (val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        opts.biff = 5;
                        seen_codepage = true;
                        $a1a91b25d7598376$var$set_cp(opts.codepage = 28591);
                    }
                    if (opts.biff == 4 && val1.dt & 0x100) biff4w = true;
                    if (opts.biff == 8 && val1.BIFFVer == 0 && val1.dt == 16) opts.biff = 2;
                    if (file_depth++ && !biff4w) break;
                    out = {} /*:any*/ ;
                    if (options.dense) out["!data"] = [];
                    if (opts.biff < 8 && !seen_codepage) {
                        seen_codepage = true;
                        $a1a91b25d7598376$var$set_cp(opts.codepage = options.codepage || 1252);
                    }
                    if (opts.biff == 4 && biff4w) cur_sheet = (Directory[opts.snames.indexOf(cur_sheet) + 1] || {
                        name: ""
                    }).name;
                    else if (opts.biff < 5 || val1.BIFFVer == 0 && val1.dt == 0x1000) {
                        if (cur_sheet === "") cur_sheet = "Sheet1";
                        range = {
                            s: {
                                r: 0,
                                c: 0
                            },
                            e: {
                                r: 0,
                                c: 0
                            }
                        };
                        /* fake BoundSheet8 */ var fakebs8 = {
                            pos: blob.l - length,
                            name: cur_sheet
                        };
                        Directory[fakebs8.pos] = fakebs8;
                        opts.snames.push(cur_sheet);
                    } else cur_sheet = (Directory[s] || {
                        name: ""
                    }).name;
                    if (val1.dt == 0x20) out["!type"] = "chart";
                    if (val1.dt == 0x40) out["!type"] = "macro";
                    merges = [];
                    objects = [];
                    opts.arrayf = arrayf = [];
                    colinfo = [];
                    rowinfo = [];
                    seencol = false;
                    wsprops = {
                        Hidden: (Directory[s] || {
                            hs: 0
                        }).hs,
                        name: cur_sheet
                    };
                    break;
                case 0x0203 /* Number */ :
                case 0x0003 /* BIFF2NUM */ :
                case 0x0002 /* BIFF2INT */ :
                    if (out["!type"] == "chart") {
                        if (options.dense ? (out["!data"][val1.r] || [])[val1.c] : out[$a1a91b25d7598376$var$encode_col(val1.c) + $a1a91b25d7598376$var$encode_row(val1.r)]) ++val1.c;
                    }
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe] || {},
                        v: val1.val,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0005:
                case 0x0205 /* BoolErr */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.val,
                        t: val1.t
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x027e /* RK */ :
                    temp_val = {
                        ixfe: val1.ixfe,
                        XF: XFs[val1.ixfe],
                        v: val1.rknum,
                        t: 'n'
                    } /*:any*/ ;
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x00bd /* MulRk */ :
                    for(var j = val1.c; j <= val1.C; ++j){
                        var ixfe = val1.rkrec[j - val1.c][0];
                        temp_val = {
                            ixfe: ixfe,
                            XF: XFs[ixfe],
                            v: val1.rkrec[j - val1.c][1],
                            t: 'n'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x0006:
                case 0x0206:
                case 0x0406 /* Formula */ :
                    if (val1.val == 'String') {
                        last_formula = val1;
                        break;
                    }
                    temp_val = $a1a91b25d7598376$var$make_cell(val1.val, val1.cell.ixfe, val1.tt);
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (options.cellFormula) {
                        var _f = val1.formula;
                        if (_f && _f[0] && _f[0][0] && _f[0][0][0] == 'PtgExp') {
                            var _fr = _f[0][0][1][0], _fc = _f[0][0][1][1];
                            var _fe = $a1a91b25d7598376$var$encode_cell({
                                r: _fr,
                                c: _fc
                            });
                            if (sharedf[_fe]) temp_val.f = "" + $a1a91b25d7598376$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                            else temp_val.F = ((options.dense ? (out["!data"][_fr] || [])[_fc] : out[_fe]) || {}).F;
                        } else temp_val.f = "" + $a1a91b25d7598376$var$stringify_formula(val1.formula, range, val1.cell, supbooks, opts);
                    }
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell(val1.cell, temp_val, options);
                    last_formula = val1;
                    break;
                case 0x0007:
                case 0x0207 /* String */ :
                    if (last_formula) {
                        last_formula.val = val1;
                        temp_val = $a1a91b25d7598376$var$make_cell(val1, last_formula.cell.ixfe, 's');
                        temp_val.XF = XFs[temp_val.ixfe];
                        if (options.cellFormula) temp_val.f = "" + $a1a91b25d7598376$var$stringify_formula(last_formula.formula, range, last_formula.cell, supbooks, opts);
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell(last_formula.cell, temp_val, options);
                        last_formula = null;
                    } else throw new Error("String record expects Formula");
                    break;
                case 0x0021:
                case 0x0221 /* Array */ :
                    arrayf.push(val1);
                    var _arraystart = $a1a91b25d7598376$var$encode_cell(val1[0].s);
                    cc = options.dense ? (out["!data"][val1[0].s.r] || [])[val1[0].s.c] : out[_arraystart];
                    if (options.cellFormula && cc) {
                        if (!last_formula) break; /* technically unreachable */ 
                        if (!_arraystart || !cc) break;
                        cc.f = "" + $a1a91b25d7598376$var$stringify_formula(val1[1], range, val1[0], supbooks, opts);
                        cc.F = $a1a91b25d7598376$var$encode_range(val1[0]);
                    }
                    break;
                case 0x04bc /* ShrFmla */ :
                    if (!options.cellFormula) break;
                    if (last_cell) {
                        /* TODO: capture range */ if (!last_formula) break; /* technically unreachable */ 
                        sharedf[$a1a91b25d7598376$var$encode_cell(last_formula.cell)] = val1[0];
                        cc = options.dense ? (out["!data"][last_formula.cell.r] || [])[last_formula.cell.c] : out[$a1a91b25d7598376$var$encode_cell(last_formula.cell)];
                        (cc || {}).f = "" + $a1a91b25d7598376$var$stringify_formula(val1[0], range, lastcell, supbooks, opts);
                    }
                    break;
                case 0x00fd /* LabelSst */ :
                    temp_val = $a1a91b25d7598376$var$make_cell(sst[val1.isst].t, val1.ixfe, 's');
                    if (sst[val1.isst].h) temp_val.h = sst[val1.isst].h;
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0201 /* Blank */ :
                    if (options.sheetStubs) {
                        temp_val = {
                            ixfe: val1.ixfe,
                            XF: XFs[val1.ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: val1.c,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00be /* MulBlank */ :
                    if (options.sheetStubs) for(var _j = val1.c; _j <= val1.C; ++_j){
                        var _ixfe = val1.ixfe[_j - val1.c];
                        temp_val = {
                            ixfe: _ixfe,
                            XF: XFs[_ixfe],
                            t: 'z'
                        } /*:any*/ ;
                        if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                        $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                        addcell({
                            c: _j,
                            r: val1.r
                        }, temp_val, options);
                    }
                    break;
                case 0x00d6 /* RString */ :
                case 0x0204 /* Label */ :
                case 0x0004 /* BIFF2STR */ :
                    temp_val = $a1a91b25d7598376$var$make_cell(val1.val, val1.ixfe, 's');
                    temp_val.XF = XFs[temp_val.ixfe];
                    if (BIFF2Fmt > 0) temp_val.z = temp_val.XF && temp_val.XF.numFmtId && BIFF2FmtTable[temp_val.XF.numFmtId] || BIFF2FmtTable[temp_val.ixfe >> 8 & 0x3F];
                    $a1a91b25d7598376$var$safe_format_xf(temp_val, options, wb.opts.Date1904);
                    addcell({
                        c: val1.c,
                        r: val1.r
                    }, temp_val, options);
                    break;
                case 0x0000:
                case 0x0200 /* Dimensions */ :
                    if (file_depth === 1) range = val1; /* TODO: stack */ 
                    break;
                case 0x00fc /* SST */ :
                    sst = val1;
                    break;
                case 0x041e /* Format */ :
                    if (opts.biff >= 3 && opts.biff <= 4) {
                        BIFF2FmtTable[BIFF2Fmt++] = val1[1];
                        for(var b4idx = 0; b4idx < BIFF2Fmt + 163; ++b4idx)if ($a1a91b25d7598376$var$table_fmt[b4idx] == val1[1]) break;
                        if (b4idx >= 163) $a1a91b25d7598376$var$SSF__load(val1[1], BIFF2Fmt + 163);
                    } else $a1a91b25d7598376$var$SSF__load(val1[1], val1[0]);
                    break;
                case 0x001e /* BIFF2FORMAT */ :
                    BIFF2FmtTable[BIFF2Fmt++] = val1;
                    for(var b2idx = 0; b2idx < BIFF2Fmt + 163; ++b2idx)if ($a1a91b25d7598376$var$table_fmt[b2idx] == val1) break;
                    if (b2idx >= 163) $a1a91b25d7598376$var$SSF__load(val1, BIFF2Fmt + 163);
                    break;
                case 0x00e5 /* MergeCells */ :
                    merges = merges.concat(val1);
                    break;
                case 0x005d /* Obj */ :
                    objects[val1.cmo[0]] = opts.lastobj = val1;
                    break;
                case 0x01b6 /* TxO */ :
                    opts.lastobj.TxO = val1;
                    break;
                case 0x007f /* ImData */ :
                    opts.lastobj.ImData = val1;
                    break;
                case 0x01b8 /* HLink */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$a1a91b25d7598376$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc) cc.l = val1[1];
                    }
                    break;
                case 0x0800 /* HLinkTooltip */ :
                    for(rngR = val1[0].s.r; rngR <= val1[0].e.r; ++rngR)for(rngC = val1[0].s.c; rngC <= val1[0].e.c; ++rngC){
                        cc = options.dense ? (out["!data"][rngR] || [])[rngC] : out[$a1a91b25d7598376$var$encode_cell({
                            c: rngC,
                            r: rngR
                        })];
                        if (cc && cc.l) cc.l.Tooltip = val1[1];
                    }
                    break;
                case 0x001c /* Note */ :
                    /* TODO: comment continuation (row == -1 / 0xFFFF) */ cc = options.dense ? (out["!data"][val1[0].r] || [])[val1[0].c] : out[$a1a91b25d7598376$var$encode_cell(val1[0])];
                    if (!cc) {
                        if (options.dense) {
                            if (!out["!data"][val1[0].r]) out["!data"][val1[0].r] = [];
                            cc = out["!data"][val1[0].r][val1[0].c] = {
                                t: "z"
                            } /*:any*/ ;
                        } else cc = out[$a1a91b25d7598376$var$encode_cell(val1[0])] = {
                            t: "z"
                        } /*:any*/ ;
                        range.e.r = Math.max(range.e.r, val1[0].r);
                        range.s.r = Math.min(range.s.r, val1[0].r);
                        range.e.c = Math.max(range.e.c, val1[0].c);
                        range.s.c = Math.min(range.s.c, val1[0].c);
                    }
                    if (!cc.c) cc.c = [];
                    if (opts.biff <= 5 && opts.biff >= 2) cmnt = {
                        a: "SheetJ5",
                        t: val1[1]
                    };
                    else {
                        var noteobj = objects[val1[2]];
                        cmnt = {
                            a: val1[1],
                            t: noteobj.TxO.t
                        };
                        if (val1[3] != null && !(val1[3] & 0x02)) cc.c.hidden = true;
                    }
                    cc.c.push(cmnt);
                    break;
                case 0x087d /* XFExt */ :
                    $a1a91b25d7598376$var$update_xfext(XFs[val1.ixfe], val1.ext);
                    break;
                case 0x007d /* ColInfo */ :
                    if (!opts.cellStyles) break;
                    while(val1.e >= val1.s){
                        colinfo[val1.e--] = {
                            width: val1.w / 256,
                            level: val1.level || 0,
                            hidden: !!(val1.flags & 1)
                        };
                        if (!seencol) {
                            seencol = true;
                            $a1a91b25d7598376$var$find_mdw_colw(val1.w / 256);
                        }
                        $a1a91b25d7598376$var$process_col(colinfo[val1.e + 1]);
                    }
                    break;
                case 0x0208 /* Row */ :
                    var rowobj = {};
                    if (val1.level != null) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.level = val1.level;
                    }
                    if (val1.hidden) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hidden = true;
                    }
                    if (val1.hpt) {
                        rowinfo[val1.r] = rowobj;
                        rowobj.hpt = val1.hpt;
                        rowobj.hpx = $a1a91b25d7598376$var$pt2px(val1.hpt);
                    }
                    break;
                case 0x0026 /* LeftMargin */ :
                case 0x0027 /* RightMargin */ :
                case 0x0028 /* TopMargin */ :
                case 0x0029 /* BottomMargin */ :
                    if (!out['!margins']) $a1a91b25d7598376$var$default_margins(out['!margins'] = {});
                    out['!margins'][({
                        0x26: "left",
                        0x27: "right",
                        0x28: "top",
                        0x29: "bottom"
                    })[RecordType]] = val1;
                    break;
                case 0x00a1 /* Setup */ :
                    if (!out['!margins']) $a1a91b25d7598376$var$default_margins(out['!margins'] = {});
                    out['!margins'].header = val1.header;
                    out['!margins'].footer = val1.footer;
                    break;
                case 0x023e /* Window2 */ :
                    // $FlowIgnore
                    if (val1.RTL) Workbook.Views[0].RTL = true;
                    break;
                case 0x0092 /* Palette */ :
                    palette = val1;
                    break;
                case 0x0896 /* Theme */ :
                    themes = val1;
                    break;
                case 0x008c /* Country */ :
                    country = val1;
                    break;
                case 0x01ba /* CodeName */ :
                    /*:: if(!Workbook.WBProps) Workbook.WBProps = {}; */ if (!cur_sheet) Workbook.WBProps.CodeName = val1 || "ThisWorkbook";
                    else wsprops.CodeName = val1 || wsprops.name;
                    break;
            }
        } else {
            if (!R) console.error("Missing Info for XLS Record 0x" + RecordType.toString(16));
            blob.l += length;
        }
    }
    wb.SheetNames = $a1a91b25d7598376$var$keys(Directory).sort(function(a, b) {
        return Number(a) - Number(b);
    }).map(function(x) {
        return Directory[x].name;
    });
    if (!options.bookSheets) wb.Sheets = Sheets;
    if (!wb.SheetNames.length && Preamble["!ref"]) {
        wb.SheetNames.push("Sheet1");
        /*jshint -W069 */ if (wb.Sheets) wb.Sheets["Sheet1"] = Preamble;
    /*jshint +W069 */ } else wb.Preamble = Preamble;
    if (wb.Sheets) FilterDatabases.forEach(function(r, i) {
        wb.Sheets[wb.SheetNames[i]]['!autofilter'] = r;
    });
    wb.Strings = sst;
    wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (opts.enc) wb.Encryption = opts.enc;
    if (themes) wb.Themes = themes;
    wb.Metadata = {};
    if (country !== undefined) wb.Metadata.Country = country;
    if (supbooks.names.length > 0) Workbook.Names = supbooks.names;
    wb.Workbook = Workbook;
    return wb;
}
/* TODO: split props*/ var $a1a91b25d7598376$var$PSCLSID = {
    SI: "e0859ff2f94f6810ab9108002b27b3d9",
    DSI: "02d5cdd59c2e1b10939708002b2cf9ae",
    UDI: "05d5cdd59c2e1b10939708002b2cf9ae"
};
function $a1a91b25d7598376$var$parse_xls_props(cfb /*:CFBContainer*/ , props, o) {
    /* [MS-OSHARED] 2.3.3.2.2 Document Summary Information Property Set */ var DSI = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/!DocumentSummaryInformation');
    if (DSI && DSI.size > 0) try {
        var DocSummary = $a1a91b25d7598376$var$parse_PropertySetStream(DSI, $a1a91b25d7598376$var$DocSummaryPIDDSI, $a1a91b25d7598376$var$PSCLSID.DSI);
        for(var d in DocSummary)props[d] = DocSummary[d];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    /* [MS-OSHARED] 2.3.3.2.1 Summary Information Property Set*/ var SI = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/!SummaryInformation');
    if (SI && SI.size > 0) try {
        var Summary = $a1a91b25d7598376$var$parse_PropertySetStream(SI, $a1a91b25d7598376$var$SummaryPIDSI, $a1a91b25d7598376$var$PSCLSID.SI);
        for(var s in Summary)if (props[s] == null) props[s] = Summary[s];
    } catch (e) {
        if (o.WTF) throw e; /* empty */ 
    }
    if (props.HeadingPairs && props.TitlesOfParts) {
        $a1a91b25d7598376$var$load_props_pairs(props.HeadingPairs, props.TitlesOfParts, props, o);
        delete props.HeadingPairs;
        delete props.TitlesOfParts;
    }
}
function $a1a91b25d7598376$var$write_xls_props(wb /*:Workbook*/ , cfb /*:CFBContainer*/ ) {
    var DSEntries = [], SEntries = [], CEntries = [];
    var i = 0, Keys;
    var DocSummaryRE /*:{[key:string]:string}*/  = $a1a91b25d7598376$var$evert_key($a1a91b25d7598376$var$DocSummaryPIDDSI, "n");
    var SummaryRE /*:{[key:string]:string}*/  = $a1a91b25d7598376$var$evert_key($a1a91b25d7598376$var$SummaryPIDSI, "n");
    if (wb.Props) {
        Keys = $a1a91b25d7598376$var$keys(wb.Props);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)(Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Props[Keys[i]]
        ]);
    }
    if (wb.Custprops) {
        Keys = $a1a91b25d7598376$var$keys(wb.Custprops);
        // $FlowIgnore
        for(i = 0; i < Keys.length; ++i)if (!Object.prototype.hasOwnProperty.call(wb.Props || {}, Keys[i])) (Object.prototype.hasOwnProperty.call(DocSummaryRE, Keys[i]) ? DSEntries : Object.prototype.hasOwnProperty.call(SummaryRE, Keys[i]) ? SEntries : CEntries).push([
            Keys[i],
            wb.Custprops[Keys[i]]
        ]);
    }
    var CEntries2 = [];
    for(i = 0; i < CEntries.length; ++i){
        if ($a1a91b25d7598376$var$XLSPSSkip.indexOf(CEntries[i][0]) > -1 || $a1a91b25d7598376$var$PseudoPropsPairs.indexOf(CEntries[i][0]) > -1) continue;
        if (CEntries[i][1] == null) continue;
        CEntries2.push(CEntries[i]);
    }
    if (SEntries.length) $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005SummaryInformation", $a1a91b25d7598376$var$write_PropertySetStream(SEntries, $a1a91b25d7598376$var$PSCLSID.SI, SummaryRE, $a1a91b25d7598376$var$SummaryPIDSI));
    if (DSEntries.length || CEntries2.length) $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/\u0005DocumentSummaryInformation", $a1a91b25d7598376$var$write_PropertySetStream(DSEntries, $a1a91b25d7598376$var$PSCLSID.DSI, DocSummaryRE, $a1a91b25d7598376$var$DocSummaryPIDDSI, CEntries2.length ? CEntries2 : null, $a1a91b25d7598376$var$PSCLSID.UDI));
}
function $a1a91b25d7598376$export$b41972a043aba84c(cfb /*:any*/ , options /*:?ParseOpts*/ ) /*:Workbook*/ {
    if (!options) options = {};
    $a1a91b25d7598376$var$fix_read_opts(options);
    $a1a91b25d7598376$var$reset_cp();
    if (options.codepage) $a1a91b25d7598376$var$set_ansi(options.codepage);
    var CompObj /*:?CFBEntry*/ , WB /*:?any*/ ;
    if (cfb.FullPaths) {
        if ($a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/encryption')) throw new Error("File is password-protected");
        CompObj = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '!CompObj');
        WB = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/Workbook') || $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/Book');
    } else {
        switch(options.type){
            case 'base64':
                cfb = $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$Base64_decode(cfb));
                break;
            case 'binary':
                cfb = $a1a91b25d7598376$var$s2a(cfb);
                break;
            case 'buffer':
                break;
            case 'array':
                if (!Array.isArray(cfb)) cfb = Array.prototype.slice.call(cfb);
                break;
        }
        $a1a91b25d7598376$var$prep_blob(cfb, 0);
        WB = {
            content: cfb
        } /*:any*/ ;
    }
    var /*::CompObjP, */ WorkbookP /*:: :Workbook = XLSX.utils.book_new(); */ ;
    var _data /*:?any*/ ;
    if (CompObj) /*::CompObjP = */ $a1a91b25d7598376$var$parse_compobj(CompObj);
    if (options.bookProps && !options.bookSheets) WorkbookP = {} /*:any*/ ;
    else /*:: if(cfb instanceof CFBContainer) */ {
        var T = $a1a91b25d7598376$var$has_buf ? 'buffer' : 'array';
        if (WB && WB.content) WorkbookP = $a1a91b25d7598376$var$parse_workbook(WB.content, options);
        else if ((_data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, 'PerfectOffice_MAIN')) && _data.content) WorkbookP = $a1a91b25d7598376$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, 'NativeContent_MAIN')) && _data.content) WorkbookP = $a1a91b25d7598376$var$WK_.to_workbook(_data.content, (options.type = T, options));
        else if ((_data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, 'MN0')) && _data.content) throw new Error("Unsupported Works 4 for Mac file");
        else throw new Error("Cannot find Workbook stream");
        if (options.bookVBA && cfb.FullPaths && $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, '/_VBA_PROJECT_CUR/VBA/dir')) WorkbookP.vbaraw = $a1a91b25d7598376$var$make_vba_xls(cfb);
    }
    var props = {};
    if (cfb.FullPaths) $a1a91b25d7598376$var$parse_xls_props(/*::((*/ cfb /*:: :any):CFBContainer)*/ , props, options);
    WorkbookP.Props = WorkbookP.Custprops = props; /* TODO: split up properties */ 
    if (options.bookFiles) WorkbookP.cfb = cfb;
    /*WorkbookP.CompObjP = CompObjP; // TODO: storage? */ return WorkbookP;
}
function $a1a91b25d7598376$var$write_xlscfb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:CFBContainer*/ {
    var o = opts || {};
    var cfb = $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new({
        root: "R"
    });
    var wbpath = "/Workbook";
    switch(o.bookType || "xls"){
        case "xls":
            o.bookType = "biff8";
        /* falls through */ case "xla":
            if (!o.bookType) o.bookType = "xla";
        /* falls through */ case "biff8":
            wbpath = "/Workbook";
            o.biff = 8;
            break;
        case "biff5":
            wbpath = "/Book";
            o.biff = 5;
            break;
        default:
            throw new Error("invalid type " + o.bookType + " for XLS CFB");
    }
    $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, wbpath, $a1a91b25d7598376$var$write_biff_buf(wb, o));
    if (o.biff == 8 && (wb.Props || wb.Custprops)) $a1a91b25d7598376$var$write_xls_props(wb, cfb);
    // TODO: SI, DSI, CO
    if (o.biff == 8 && wb.vbaraw) $a1a91b25d7598376$var$fill_vba_xls(cfb, $a1a91b25d7598376$export$9f0e51cd97c572a.read(wb.vbaraw, {
        type: typeof wb.vbaraw == "string" ? "binary" : "buffer"
    }));
    return cfb;
}
/* [MS-XLSB] 2.3 Record Enumeration */ var $a1a91b25d7598376$var$XLSBRecordEnum = {
    0x0000: {
        f: $a1a91b25d7598376$var$parse_BrtRowHdr
    },
    0x0001: {
        f: $a1a91b25d7598376$var$parse_BrtCellBlank
    },
    0x0002: {
        f: $a1a91b25d7598376$var$parse_BrtCellRk
    },
    0x0003: {
        f: $a1a91b25d7598376$var$parse_BrtCellError
    },
    0x0004: {
        f: $a1a91b25d7598376$var$parse_BrtCellBool
    },
    0x0005: {
        f: $a1a91b25d7598376$var$parse_BrtCellReal
    },
    0x0006: {
        f: $a1a91b25d7598376$var$parse_BrtCellSt
    },
    0x0007: {
        f: $a1a91b25d7598376$var$parse_BrtCellIsst
    },
    0x0008: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaString
    },
    0x0009: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaNum
    },
    0x000A: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaBool
    },
    0x000B: {
        f: $a1a91b25d7598376$var$parse_BrtFmlaError
    },
    0x000C: {
        f: $a1a91b25d7598376$var$parse_BrtShortBlank
    },
    0x000D: {
        f: $a1a91b25d7598376$var$parse_BrtShortRk
    },
    0x000E: {
        f: $a1a91b25d7598376$var$parse_BrtShortError
    },
    0x000F: {
        f: $a1a91b25d7598376$var$parse_BrtShortBool
    },
    0x0010: {
        f: $a1a91b25d7598376$var$parse_BrtShortReal
    },
    0x0011: {
        f: $a1a91b25d7598376$var$parse_BrtShortSt
    },
    0x0012: {
        f: $a1a91b25d7598376$var$parse_BrtShortIsst
    },
    0x0013: {
        f: $a1a91b25d7598376$var$parse_RichStr
    },
    0x0014: {},
    0x0015: {},
    0x0016: {},
    0x0017: {},
    0x0018: {},
    0x0019: {},
    0x001A: {},
    0x001B: {},
    0x001C: {},
    0x001D: {},
    0x001E: {},
    0x001F: {},
    0x0020: {},
    0x0021: {},
    0x0022: {},
    0x0023: {
        T: 1
    },
    0x0024: {
        T: -1
    },
    0x0025: {
        T: 1
    },
    0x0026: {
        T: -1
    },
    0x0027: {
        f: $a1a91b25d7598376$var$parse_BrtName
    },
    0x0028: {},
    0x002A: {},
    0x002B: {
        f: $a1a91b25d7598376$var$parse_BrtFont
    },
    0x002C: {
        f: $a1a91b25d7598376$var$parse_BrtFmt
    },
    0x002D: {
        f: $a1a91b25d7598376$var$parse_BrtFill
    },
    0x002E: {
        f: $a1a91b25d7598376$var$parse_BrtBorder
    },
    0x002F: {
        f: $a1a91b25d7598376$var$parse_BrtXF
    },
    0x0030: {},
    0x0031: {
        f: $a1a91b25d7598376$var$parse_Int32LE
    },
    0x0032: {},
    0x0033: {
        f: $a1a91b25d7598376$var$parse_BrtMdb
    },
    0x0034: {
        T: 1
    },
    0x0035: {
        T: -1
    },
    0x0036: {
        T: 1
    },
    0x0037: {
        T: -1
    },
    0x0038: {
        T: 1
    },
    0x0039: {
        T: -1
    },
    0x003A: {},
    0x003B: {},
    0x003C: {
        f: $a1a91b25d7598376$var$parse_ColInfo
    },
    0x003E: {
        f: $a1a91b25d7598376$var$parse_BrtCellRString
    },
    0x003F: {
        f: $a1a91b25d7598376$var$parse_BrtCalcChainItem$
    },
    0x0040: {
        f: $a1a91b25d7598376$var$parse_BrtDVal
    },
    0x0041: {},
    0x0042: {},
    0x0043: {},
    0x0044: {},
    0x0045: {},
    0x0046: {},
    0x0080: {},
    0x0081: {
        T: 1
    },
    0x0082: {
        T: -1
    },
    0x0083: {
        T: 1,
        f: $a1a91b25d7598376$var$parsenoop,
        p: 0
    },
    0x0084: {
        T: -1
    },
    0x0085: {
        T: 1
    },
    0x0086: {
        T: -1
    },
    0x0087: {
        T: 1
    },
    0x0088: {
        T: -1
    },
    0x0089: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_BrtBeginWsView
    },
    0x008A: {
        T: -1
    },
    0x008B: {
        T: 1
    },
    0x008C: {
        T: -1
    },
    0x008D: {
        T: 1
    },
    0x008E: {
        T: -1
    },
    0x008F: {
        T: 1
    },
    0x0090: {
        T: -1
    },
    0x0091: {
        T: 1
    },
    0x0092: {
        T: -1
    },
    0x0093: {
        f: $a1a91b25d7598376$var$parse_BrtWsProp
    },
    0x0094: {
        f: $a1a91b25d7598376$var$parse_BrtWsDim,
        p: 16
    },
    0x0097: {
        f: $a1a91b25d7598376$var$parse_BrtPane
    },
    0x0098: {},
    0x0099: {
        f: $a1a91b25d7598376$var$parse_BrtWbProp
    },
    0x009A: {},
    0x009B: {},
    0x009C: {
        f: $a1a91b25d7598376$var$parse_BrtBundleSh
    },
    0x009D: {},
    0x009E: {},
    0x009F: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_BrtBeginSst
    },
    0x00A0: {
        T: -1
    },
    0x00A1: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_UncheckedRfX
    },
    0x00A2: {
        T: -1
    },
    0x00A3: {
        T: 1
    },
    0x00A4: {
        T: -1
    },
    0x00A5: {
        T: 1
    },
    0x00A6: {
        T: -1
    },
    0x00A7: {},
    0x00A8: {},
    0x00A9: {},
    0x00AA: {},
    0x00AB: {},
    0x00AC: {
        T: 1
    },
    0x00AD: {
        T: -1
    },
    0x00AE: {},
    0x00AF: {},
    0x00B0: {
        f: $a1a91b25d7598376$var$parse_BrtMergeCell
    },
    0x00B1: {
        T: 1
    },
    0x00B2: {
        T: -1
    },
    0x00B3: {
        T: 1
    },
    0x00B4: {
        T: -1
    },
    0x00B5: {
        T: 1
    },
    0x00B6: {
        T: -1
    },
    0x00B7: {
        T: 1
    },
    0x00B8: {
        T: -1
    },
    0x00B9: {
        T: 1
    },
    0x00BA: {
        T: -1
    },
    0x00BB: {
        T: 1
    },
    0x00BC: {
        T: -1
    },
    0x00BD: {
        T: 1
    },
    0x00BE: {
        T: -1
    },
    0x00BF: {
        T: 1
    },
    0x00C0: {
        T: -1
    },
    0x00C1: {
        T: 1
    },
    0x00C2: {
        T: -1
    },
    0x00C3: {
        T: 1
    },
    0x00C4: {
        T: -1
    },
    0x00C5: {
        T: 1
    },
    0x00C6: {
        T: -1
    },
    0x00C7: {
        T: 1
    },
    0x00C8: {
        T: -1
    },
    0x00C9: {
        T: 1
    },
    0x00CA: {
        T: -1
    },
    0x00CB: {
        T: 1
    },
    0x00CC: {
        T: -1
    },
    0x00CD: {
        T: 1
    },
    0x00CE: {
        T: -1
    },
    0x00CF: {
        T: 1
    },
    0x00D0: {
        T: -1
    },
    0x00D1: {
        T: 1
    },
    0x00D2: {
        T: -1
    },
    0x00D3: {
        T: 1
    },
    0x00D4: {
        T: -1
    },
    0x00D5: {
        T: 1
    },
    0x00D6: {
        T: -1
    },
    0x00D7: {
        T: 1
    },
    0x00D8: {
        T: -1
    },
    0x00D9: {
        T: 1
    },
    0x00DA: {
        T: -1
    },
    0x00DB: {
        T: 1
    },
    0x00DC: {
        T: -1
    },
    0x00DD: {
        T: 1
    },
    0x00DE: {
        T: -1
    },
    0x00DF: {
        T: 1
    },
    0x00E0: {
        T: -1
    },
    0x00E1: {
        T: 1
    },
    0x00E2: {
        T: -1
    },
    0x00E3: {
        T: 1
    },
    0x00E4: {
        T: -1
    },
    0x00E5: {
        T: 1
    },
    0x00E6: {
        T: -1
    },
    0x00E7: {
        T: 1
    },
    0x00E8: {
        T: -1
    },
    0x00E9: {
        T: 1
    },
    0x00EA: {
        T: -1
    },
    0x00EB: {
        T: 1
    },
    0x00EC: {
        T: -1
    },
    0x00ED: {
        T: 1
    },
    0x00EE: {
        T: -1
    },
    0x00EF: {
        T: 1
    },
    0x00F0: {
        T: -1
    },
    0x00F1: {
        T: 1
    },
    0x00F2: {
        T: -1
    },
    0x00F3: {
        T: 1
    },
    0x00F4: {
        T: -1
    },
    0x00F5: {
        T: 1
    },
    0x00F6: {
        T: -1
    },
    0x00F7: {
        T: 1
    },
    0x00F8: {
        T: -1
    },
    0x00F9: {
        T: 1
    },
    0x00FA: {
        T: -1
    },
    0x00FB: {
        T: 1
    },
    0x00FC: {
        T: -1
    },
    0x00FD: {
        T: 1
    },
    0x00FE: {
        T: -1
    },
    0x00FF: {
        T: 1
    },
    0x0100: {
        T: -1
    },
    0x0101: {
        T: 1
    },
    0x0102: {
        T: -1
    },
    0x0103: {
        T: 1
    },
    0x0104: {
        T: -1
    },
    0x0105: {
        T: 1
    },
    0x0106: {
        T: -1
    },
    0x0107: {
        T: 1
    },
    0x0108: {
        T: -1
    },
    0x0109: {
        T: 1
    },
    0x010A: {
        T: -1
    },
    0x010B: {
        T: 1
    },
    0x010C: {
        T: -1
    },
    0x010D: {
        T: 1
    },
    0x010E: {
        T: -1
    },
    0x010F: {
        T: 1
    },
    0x0110: {
        T: -1
    },
    0x0111: {
        T: 1
    },
    0x0112: {
        T: -1
    },
    0x0113: {
        T: 1
    },
    0x0114: {
        T: -1
    },
    0x0115: {},
    0x0116: {
        T: 1
    },
    0x0117: {
        T: -1
    },
    0x0118: {
        T: 1
    },
    0x0119: {
        T: -1
    },
    0x011A: {
        T: 1
    },
    0x011B: {
        T: 1
    },
    0x011C: {
        T: -1
    },
    0x011D: {
        T: 1
    },
    0x011E: {
        T: -1
    },
    0x011F: {
        T: 1
    },
    0x0120: {
        T: -1
    },
    0x0121: {
        T: 1
    },
    0x0122: {
        T: -1
    },
    0x0123: {
        T: 1
    },
    0x0124: {
        T: -1
    },
    0x0125: {
        T: 1
    },
    0x0126: {
        T: -1
    },
    0x0127: {
        T: 1
    },
    0x0128: {
        T: -1
    },
    0x0129: {
        T: 1
    },
    0x012A: {
        T: -1
    },
    0x012B: {
        T: 1
    },
    0x012C: {
        T: -1
    },
    0x012D: {
        T: 1
    },
    0x012E: {
        T: -1
    },
    0x012F: {
        T: 1
    },
    0x0130: {
        T: -1
    },
    0x0131: {
        T: 1
    },
    0x0132: {
        T: -1
    },
    0x0133: {
        T: 1
    },
    0x0134: {
        T: -1
    },
    0x0135: {
        T: 1
    },
    0x0136: {
        T: -1
    },
    0x0137: {
        T: 1
    },
    0x0138: {
        T: -1
    },
    0x0139: {
        T: -1
    },
    0x013A: {
        T: 1
    },
    0x013B: {
        T: -1
    },
    0x013C: {
        T: 1
    },
    0x013D: {
        T: -1
    },
    0x013E: {
        T: 1
    },
    0x013F: {
        T: -1
    },
    0x0140: {
        T: 1
    },
    0x0141: {
        T: -1
    },
    0x0142: {
        T: 1
    },
    0x0143: {
        T: -1
    },
    0x0144: {
        T: 1
    },
    0x0145: {
        T: -1
    },
    0x0146: {
        T: 1
    },
    0x0147: {
        T: -1
    },
    0x0148: {
        T: 1
    },
    0x0149: {
        T: -1
    },
    0x014A: {
        T: 1
    },
    0x014B: {
        T: -1
    },
    0x014C: {
        T: 1
    },
    0x014D: {
        T: -1
    },
    0x014E: {
        T: 1
    },
    0x014F: {
        f: $a1a91b25d7598376$var$parse_BrtMdtinfo
    },
    0x0150: {
        T: -1
    },
    0x0151: {
        f: $a1a91b25d7598376$var$parse_BrtBeginEsmdb,
        T: 1
    },
    0x0152: {
        T: -1
    },
    0x0153: {
        T: 1
    },
    0x0154: {
        T: -1
    },
    0x0155: {
        T: 1
    },
    0x0156: {
        T: -1
    },
    0x0157: {
        T: 1
    },
    0x0158: {
        T: -1
    },
    0x0159: {
        T: 1
    },
    0x015A: {
        T: -1
    },
    0x015B: {
        T: 1
    },
    0x015C: {
        T: -1
    },
    0x015D: {
        T: 1
    },
    0x015E: {
        T: -1
    },
    0x015F: {},
    0x0160: {},
    0x0161: {
        T: 1
    },
    0x0162: {
        T: -1
    },
    0x0163: {
        f: $a1a91b25d7598376$var$parse_RelID
    },
    0x0165: {},
    0x0166: {},
    0x0167: {},
    0x0168: {
        T: 1
    },
    0x0169: {},
    0x016A: {
        f: $a1a91b25d7598376$var$parse_ExternSheet
    },
    0x016B: {},
    0x016C: {},
    0x016E: {},
    0x016F: {},
    0x0170: {},
    0x0171: {},
    0x0172: {},
    0x0173: {},
    0x0174: {
        T: 1
    },
    0x0175: {
        T: -1
    },
    0x0176: {
        T: 1
    },
    0x0177: {
        T: -1
    },
    0x0178: {
        T: 1
    },
    0x0179: {
        T: -1
    },
    0x017A: {
        T: 1
    },
    0x017B: {
        T: -1
    },
    0x017C: {
        T: 1
    },
    0x017D: {
        T: -1
    },
    0x017E: {
        T: 1
    },
    0x017F: {
        T: -1
    },
    0x0180: {
        T: 1
    },
    0x0181: {
        T: -1
    },
    0x0182: {
        T: 1
    },
    0x0183: {
        T: -1
    },
    0x0184: {
        T: 1
    },
    0x0185: {
        T: -1
    },
    0x0186: {
        T: 1
    },
    0x0187: {
        T: -1
    },
    0x0188: {
        T: 1
    },
    0x0189: {
        T: -1
    },
    0x018A: {
        T: 1
    },
    0x018B: {
        T: -1
    },
    0x018C: {},
    0x018D: {},
    0x018E: {},
    0x018F: {},
    0x0190: {},
    0x0191: {
        T: 1
    },
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x0199: {},
    0x019A: {},
    0x019B: {},
    0x019C: {},
    0x019D: {},
    0x019E: {},
    0x019F: {},
    0x01A0: {},
    0x01A1: {},
    0x01A2: {},
    0x01A3: {},
    0x01A4: {},
    0x01A5: {},
    0x01A6: {
        T: 1
    },
    0x01A7: {
        T: 1
    },
    0x01A8: {
        T: -1
    },
    0x01A9: {
        T: -1
    },
    0x01AA: {
        f: $a1a91b25d7598376$var$parse_BrtArrFmla
    },
    0x01AB: {
        f: $a1a91b25d7598376$var$parse_BrtShrFmla
    },
    0x01AC: {},
    0x01AD: {
        T: 1
    },
    0x01AE: {
        T: -1
    },
    0x01AF: {
        T: 1
    },
    0x01B0: {
        T: -1
    },
    0x01B1: {
        T: 1
    },
    0x01B2: {
        T: -1
    },
    0x01B3: {
        T: 1
    },
    0x01B4: {
        T: -1
    },
    0x01B5: {
        T: 1
    },
    0x01B6: {
        T: -1
    },
    0x01B7: {
        T: 1
    },
    0x01B8: {
        T: -1
    },
    0x01B9: {
        T: 1
    },
    0x01BA: {
        T: -1
    },
    0x01BB: {
        T: 1
    },
    0x01BC: {
        T: -1
    },
    0x01BD: {
        T: 1
    },
    0x01BE: {
        T: -1
    },
    0x01BF: {
        T: 1
    },
    0x01C0: {
        T: -1
    },
    0x01C1: {
        T: 1
    },
    0x01C2: {
        T: -1
    },
    0x01C3: {
        T: 1
    },
    0x01C4: {
        T: -1
    },
    0x01C5: {
        T: 1
    },
    0x01C6: {
        T: -1
    },
    0x01C7: {
        T: 1
    },
    0x01C8: {
        T: -1
    },
    0x01C9: {
        T: 1
    },
    0x01CA: {
        T: -1
    },
    0x01CB: {
        T: 1
    },
    0x01CC: {
        T: -1
    },
    0x01CD: {
        T: 1
    },
    0x01CE: {
        T: -1
    },
    0x01CF: {
        T: 1
    },
    0x01D0: {
        T: -1
    },
    0x01D1: {
        T: 1
    },
    0x01D2: {
        T: -1
    },
    0x01D3: {
        T: 1
    },
    0x01D4: {
        T: -1
    },
    0x01D5: {
        T: 1
    },
    0x01D6: {
        T: -1
    },
    0x01D7: {},
    0x01D8: {},
    0x01D9: {
        T: 1
    },
    0x01DA: {
        T: -1
    },
    0x01DB: {},
    0x01DC: {
        f: $a1a91b25d7598376$var$parse_BrtMargins
    },
    0x01DD: {},
    0x01DE: {},
    0x01DF: {
        T: 1
    },
    0x01E0: {
        T: -1
    },
    0x01E1: {
        T: 1
    },
    0x01E2: {
        T: -1
    },
    0x01E3: {
        T: 1
    },
    0x01E4: {
        T: -1
    },
    0x01E5: {
        f: $a1a91b25d7598376$var$parse_BrtWsFmtInfo
    },
    0x01E6: {
        T: 1
    },
    0x01E7: {
        T: -1
    },
    0x01E8: {
        T: 1
    },
    0x01E9: {
        T: -1
    },
    0x01EA: {
        T: 1
    },
    0x01EB: {
        T: -1
    },
    0x01EC: {
        T: 1
    },
    0x01ED: {
        T: -1
    },
    0x01EE: {
        f: $a1a91b25d7598376$var$parse_BrtHLink
    },
    0x01EF: {
        T: 1
    },
    0x01F0: {
        T: -1
    },
    0x01F1: {
        T: 1
    },
    0x01F2: {
        T: -1
    },
    0x01F3: {},
    0x01F4: {
        T: 1
    },
    0x01F5: {
        T: -1
    },
    0x01F6: {
        T: 1
    },
    0x01F7: {
        T: -1
    },
    0x01F8: {},
    0x01F9: {
        T: 1
    },
    0x01FA: {
        T: -1
    },
    0x01FB: {},
    0x01FC: {
        T: 1
    },
    0x01FD: {
        T: -1
    },
    0x01FE: {
        T: 1
    },
    0x01FF: {
        T: -1
    },
    0x0200: {},
    0x0201: {},
    0x0202: {
        T: 1
    },
    0x0203: {
        T: -1
    },
    0x0204: {
        T: 1
    },
    0x0205: {
        T: -1
    },
    0x0206: {
        T: 1
    },
    0x0207: {
        T: -1
    },
    0x0208: {
        T: 1
    },
    0x0209: {
        T: -1
    },
    0x020A: {},
    0x020B: {},
    0x020C: {},
    0x020D: {},
    0x020E: {},
    0x020F: {},
    0x0210: {
        T: 1
    },
    0x0211: {
        T: -1
    },
    0x0212: {
        T: 1
    },
    0x0213: {
        T: -1
    },
    0x0214: {
        T: 1
    },
    0x0215: {
        T: -1
    },
    0x0216: {},
    0x0217: {},
    0x0218: {},
    0x0219: {},
    0x021A: {
        T: 1
    },
    0x021B: {
        T: -1
    },
    0x021C: {
        T: 1
    },
    0x021D: {
        T: -1
    },
    0x021E: {
        T: 1
    },
    0x0224: {},
    0x0225: {},
    0x0226: {
        f: $a1a91b25d7598376$var$parse_RelID
    },
    0x0227: {
        f: $a1a91b25d7598376$var$parse_XLNullableWideString
    },
    0x0228: {},
    0x0229: {},
    0x022A: {
        T: 1
    },
    0x022B: {
        T: -1
    },
    0x022C: {
        T: 1
    },
    0x022D: {
        T: -1
    },
    0x022E: {
        T: 1
    },
    0x022F: {
        T: -1
    },
    0x0230: {
        T: 1
    },
    0x0231: {
        T: -1
    },
    0x0232: {},
    0x0234: {},
    0x0235: {
        T: 1
    },
    0x0236: {
        T: -1
    },
    0x0239: {
        T: 1
    },
    0x023A: {
        T: -1
    },
    0x023C: {},
    0x023D: {
        T: 1
    },
    0x023E: {
        T: -1
    },
    0x0241: {},
    0x0242: {},
    0x0243: {},
    0x0244: {},
    0x0245: {},
    0x0246: {},
    0x0247: {},
    0x0248: {},
    0x0249: {},
    0x024A: {},
    0x024B: {},
    0x024C: {
        T: -1
    },
    0x024D: {},
    0x024E: {
        T: 1
    },
    0x024F: {
        T: -1
    },
    0x0250: {
        T: 1
    },
    0x0251: {
        T: -1
    },
    0x0252: {
        T: 1
    },
    0x0253: {
        T: -1
    },
    0x0254: {},
    0x0255: {
        T: 1
    },
    0x0256: {
        T: -1
    },
    0x0257: {
        T: 1
    },
    0x0258: {
        T: -1
    },
    0x0259: {
        T: 1
    },
    0x025A: {
        T: -1
    },
    0x025B: {
        T: 1
    },
    0x025C: {
        T: -1
    },
    0x025D: {
        T: 1
    },
    0x025E: {
        T: -1
    },
    0x025F: {},
    0x0260: {
        T: 1
    },
    0x0261: {
        T: -1
    },
    0x0262: {},
    0x0263: {
        T: 1
    },
    0x0264: {
        T: -1
    },
    0x0265: {
        T: 1
    },
    0x0266: {
        T: -1
    },
    0x0267: {
        T: 1
    },
    0x0268: {
        T: -1
    },
    0x0269: {
        T: 1
    },
    0x026A: {
        T: -1
    },
    0x026B: {
        T: 1
    },
    0x026C: {
        T: -1
    },
    0x0271: {},
    0x0272: {
        T: 1
    },
    0x0273: {
        T: -1
    },
    0x0274: {
        T: 1
    },
    0x0275: {
        T: -1
    },
    0x0276: {
        T: 1
    },
    0x0277: {
        T: -1
    },
    0x0278: {
        f: $a1a91b25d7598376$var$parse_BrtCommentAuthor
    },
    0x0279: {
        T: 1
    },
    0x027A: {
        T: -1
    },
    0x027B: {
        T: 1,
        f: $a1a91b25d7598376$var$parse_BrtBeginComment
    },
    0x027C: {
        T: -1
    },
    0x027D: {
        f: $a1a91b25d7598376$var$parse_BrtCommentText
    },
    0x027E: {
        T: 1
    },
    0x027F: {},
    0x0280: {
        T: -1
    },
    0x0281: {
        T: 1
    },
    0x0282: {
        T: -1
    },
    0x0283: {
        T: 1
    },
    0x0284: {},
    0x0285: {
        T: -1
    },
    0x0286: {
        T: 1
    },
    0x0288: {
        T: 1
    },
    0x0289: {},
    0x028A: {
        T: -1
    },
    0x028B: {
        f: $a1a91b25d7598376$var$parse_BrtCsProp
    },
    0x028C: {},
    0x028D: {
        T: 1
    },
    0x028E: {
        T: -1
    },
    0x028F: {
        T: 1
    },
    0x0290: {
        T: -1
    },
    0x0291: {
        T: 1
    },
    0x0292: {
        T: -1
    },
    0x0293: {},
    0x0294: {
        T: 1
    },
    0x0295: {},
    0x0296: {
        T: -1
    },
    0x0297: {},
    0x0298: {
        T: 1
    },
    0x0299: {},
    0x029A: {
        T: -1
    },
    0x029B: {},
    0x029C: {},
    0x029D: {},
    0x029F: {
        T: 1
    },
    0x02A0: {
        T: -1
    },
    0x02A1: {
        T: 1
    },
    0x02A2: {
        T: -1
    },
    0x02A3: {},
    0x02A4: {},
    0x02A5: {},
    0x02A6: {},
    0x02A7: {},
    0x02A8: {},
    0x02A9: {},
    0x0400: {},
    0x0401: {},
    0x0402: {
        T: 1
    },
    0x0403: {
        T: -1
    },
    0x0404: {
        T: 1
    },
    0x0405: {
        T: -1
    },
    0x0406: {},
    0x0407: {
        T: 1
    },
    0x0408: {
        T: -1
    },
    0x0409: {
        T: 1
    },
    0x040A: {
        T: -1
    },
    0x040B: {},
    0x040C: {},
    0x040D: {},
    0x040E: {
        T: 1
    },
    0x040F: {
        T: -1
    },
    0x0410: {},
    0x0411: {
        T: 1
    },
    0x0412: {
        T: -1
    },
    0x0413: {},
    0x0414: {},
    0x0415: {},
    0x0416: {
        T: 1
    },
    0x0417: {
        T: -1
    },
    0x0418: {
        T: 1
    },
    0x0419: {
        T: -1
    },
    0x041A: {},
    0x041B: {
        T: 1
    },
    0x041C: {
        T: 1
    },
    0x041D: {
        f: $a1a91b25d7598376$var$parse_BrtDVal14
    },
    0x041E: {
        T: 1
    },
    0x041F: {},
    0x0420: {
        T: 1
    },
    0x0421: {
        T: -1
    },
    0x0422: {
        T: 1
    },
    0x0423: {
        T: -1
    },
    0x0425: {},
    0x0426: {
        T: 1
    },
    0x0427: {
        T: -1
    },
    0x0428: {
        T: 1
    },
    0x0429: {
        T: -1
    },
    0x042A: {
        T: 1
    },
    0x042B: {
        T: -1
    },
    0x042C: {
        T: 1
    },
    0x042D: {
        T: -1
    },
    0x042E: {
        T: 1
    },
    0x042F: {
        T: -1
    },
    0x0430: {
        T: 1
    },
    0x0431: {
        T: -1
    },
    0x0433: {
        T: 1
    },
    0x0434: {
        T: -1
    },
    0x0435: {
        T: 1
    },
    0x0436: {
        T: -1
    },
    0x0437: {
        T: 1
    },
    0x0438: {
        T: -1
    },
    0x0439: {
        T: 1
    },
    0x043A: {
        T: -1
    },
    0x043B: {
        T: 1
    },
    0x043C: {
        T: -1
    },
    0x043D: {},
    0x043E: {
        T: 1
    },
    0x043F: {
        T: -1
    },
    0x0440: {
        T: 1
    },
    0x0441: {
        T: -1
    },
    0x0442: {
        T: 1
    },
    0x0443: {
        T: -1
    },
    0x0444: {
        T: 1
    },
    0x0445: {
        T: -1
    },
    0x0446: {
        T: 1
    },
    0x0447: {
        T: -1
    },
    0x0448: {},
    0x0449: {
        T: 1
    },
    0x044A: {},
    0x044B: {
        T: -1
    },
    0x044C: {
        T: 1
    },
    0x044D: {
        T: -1
    },
    0x044E: {},
    0x044F: {},
    0x0450: {},
    0x0451: {},
    0x0457: {},
    0x0458: {},
    0x0459: {
        T: 1
    },
    0x045A: {
        T: -1
    },
    0x045B: {
        T: 1
    },
    0x045C: {
        T: -1
    },
    0x045D: {},
    0x045E: {
        T: 1
    },
    0x045F: {
        T: -1
    },
    0x0460: {
        T: 1
    },
    0x0461: {
        T: -1
    },
    0x0462: {
        T: 1
    },
    0x0463: {
        T: -1
    },
    0x0464: {
        T: 1
    },
    0x0465: {
        T: -1
    },
    0x0466: {},
    0x0468: {
        T: 1
    },
    0x0469: {
        T: -1
    },
    0x046A: {},
    0x046B: {
        T: 1
    },
    0x046C: {
        T: -1
    },
    0x046D: {
        T: 1
    },
    0x046E: {
        T: -1
    },
    0x046F: {
        T: 1
    },
    0x0470: {
        T: -1
    },
    0x0471: {
        T: 1
    },
    0x0472: {
        T: -1
    },
    0x0473: {
        T: 1
    },
    0x0474: {
        T: -1
    },
    0x0475: {},
    0x0476: {
        T: 1
    },
    0x0477: {
        T: -1
    },
    0x0478: {
        T: 1
    },
    0x0479: {
        T: -1
    },
    0x047A: {},
    0x047B: {
        T: 1
    },
    0x047C: {
        T: -1
    },
    0x047D: {
        T: 1
    },
    0x047E: {
        T: -1
    },
    0x0480: {
        T: 1
    },
    0x0481: {
        T: -1
    },
    0x0482: {
        T: -1
    },
    0x0483: {
        T: -1
    },
    0x0484: {
        T: -1
    },
    0x0485: {
        T: 1
    },
    0x0486: {
        T: -1
    },
    0x0487: {
        T: 1
    },
    0x0488: {
        T: -1
    },
    0x0489: {
        T: 1
    },
    0x048A: {
        T: -1
    },
    0x048B: {
        T: 1
    },
    0x048C: {
        T: -1
    },
    0x048D: {
        T: 1
    },
    0x048E: {
        T: -1
    },
    0x048F: {
        T: 1
    },
    0x0490: {
        T: -1
    },
    0x0491: {
        T: 1
    },
    0x0492: {
        T: -1
    },
    0x0493: {},
    0x0494: {
        T: 1
    },
    0x0495: {
        T: -1
    },
    0x0499: {},
    0x049A: {
        T: 1
    },
    0x049C: {},
    0x049D: {},
    0x049E: {},
    0x0800: {
        T: 1
    },
    0x0801: {
        T: -1
    },
    0x0802: {},
    0x0803: {
        T: 1
    },
    0x0804: {
        T: -1
    },
    0x0805: {},
    0x0806: {},
    0x0807: {
        T: 1
    },
    0x0808: {
        T: -1
    },
    0x0809: {
        T: 1
    },
    0x080A: {
        T: -1
    },
    0x080C: {},
    0x0813: {},
    0x0814: {
        T: 1
    },
    0x0815: {
        T: -1
    },
    0x0816: {},
    0x0817: {},
    0x0818: {
        T: 1
    },
    0x0819: {
        T: -1
    },
    0x081B: {},
    0x081C: {},
    0x081D: {
        T: 1
    },
    0x081E: {
        T: -1
    },
    0x081F: {},
    0x0820: {
        T: 1
    },
    0x0821: {
        T: -1
    },
    0x0822: {},
    0x0823: {
        T: 1
    },
    0x0824: {
        T: -1
    },
    0x0825: {
        T: 1
    },
    0x0826: {
        T: -1
    },
    0x0827: {
        T: 1
    },
    0x0828: {
        T: -1
    },
    0x0829: {
        T: 1
    },
    0x082A: {
        T: -1
    },
    0x082B: {},
    0x082C: {},
    0x082D: {
        T: 1
    },
    0x082E: {
        T: -1
    },
    0x082F: {},
    0x0830: {
        T: 1
    },
    0x0831: {
        T: -1
    },
    0x0832: {
        T: 1
    },
    0x0833: {
        T: -1
    },
    0x0834: {
        T: 1
    },
    0x0835: {
        T: -1
    },
    0x0836: {},
    0x0837: {
        T: 1
    },
    0x0838: {
        T: -1
    },
    0x0839: {},
    0x083A: {
        T: 1
    },
    0x083B: {
        T: -1
    },
    0x083C: {},
    0x083D: {
        T: 1
    },
    0x083E: {
        T: -1
    },
    0x083F: {
        T: 1
    },
    0x0840: {
        T: -1
    },
    0x0841: {
        T: 1
    },
    0x0842: {
        T: -1
    },
    0x0843: {},
    0x0844: {},
    0x0845: {},
    0x0846: {
        T: 1
    },
    0x0847: {
        T: -1
    },
    0x0848: {},
    0x0849: {
        T: 1
    },
    0x084A: {
        T: -1
    },
    0x084B: {
        T: 1
    },
    0x084C: {
        T: -1
    },
    0x084D: {},
    0x084E: {
        T: 1
    },
    0x084F: {
        T: -1
    },
    0x0850: {},
    0x0851: {
        T: 1
    },
    0x0852: {
        T: -1
    },
    0x0853: {
        T: 1
    },
    0x0854: {
        T: -1
    },
    0x0855: {
        T: 1
    },
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {
        T: 1
    },
    0x085A: {
        T: -1
    },
    0x085B: {
        T: 1
    },
    0x085C: {
        T: -1
    },
    0x085D: {},
    0x0C00: {},
    0x0C01: {},
    0x1000: {
        T: 1
    },
    0x1001: {
        T: -1
    },
    0x138A: {
        T: 1
    },
    0x138B: {
        T: -1
    },
    0x13D9: {
        T: 1
    },
    0x13DA: {
        T: -1
    },
    0x13DB: {},
    0x13DC: {
        T: 1
    },
    0x13DD: {
        T: -1
    },
    0x13DE: {
        T: 1
    },
    0x13DF: {
        T: -1
    },
    0x13E0: {},
    0x13E1: {},
    0x13E2: {},
    0x13E4: {
        T: 1
    },
    0x13E5: {
        T: -1
    },
    0x13E6: {},
    0x13E7: {
        T: 1
    },
    0x13E8: {
        T: -1
    },
    0x13E9: {},
    0x13EB: {},
    0xFFFF: {
        n: ""
    }
};
/* [MS-XLS] 2.3 Record Enumeration (and other sources) */ var $a1a91b25d7598376$var$XLSRecordEnum = {
    /* [MS-XLS] 2.3 Record Enumeration 2021-08-17 */ 0x0006: {
        f: $a1a91b25d7598376$var$parse_Formula
    },
    0x000a: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x000c: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x000d: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x000e: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x000f: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0010: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    0x0011: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0012: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0013: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x0014: {
        f: $a1a91b25d7598376$var$parse_XLHeaderFooter
    },
    0x0015: {
        f: $a1a91b25d7598376$var$parse_XLHeaderFooter
    },
    0x0017: {
        f: $a1a91b25d7598376$var$parse_ExternSheet
    },
    0x0018: {
        f: $a1a91b25d7598376$var$parse_Lbl
    },
    0x0019: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x001a: {},
    0x001b: {},
    0x001c: {
        f: $a1a91b25d7598376$var$parse_Note
    },
    0x001d: {},
    0x0022: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0023: {
        f: $a1a91b25d7598376$var$parse_ExternName
    },
    0x0026: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    0x0027: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    0x0028: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    0x0029: {
        f: $a1a91b25d7598376$var$parse_Xnum
    },
    0x002a: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x002b: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x002f: {
        f: $a1a91b25d7598376$var$parse_FilePass
    },
    0x0031: {
        f: $a1a91b25d7598376$var$parse_Font
    },
    0x0033: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x003c: {},
    0x003d: {
        f: $a1a91b25d7598376$var$parse_Window1
    },
    0x0040: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0041: {
        f: $a1a91b25d7598376$var$parse_Pane
    },
    0x0042: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x004d: {},
    0x0050: {},
    0x0051: {},
    0x0052: {},
    0x0055: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x0059: {},
    0x005a: {},
    0x005b: {},
    0x005c: {
        f: $a1a91b25d7598376$var$parse_WriteAccess
    },
    0x005d: {
        f: $a1a91b25d7598376$var$parse_Obj
    },
    0x005e: {},
    0x005f: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0060: {},
    0x0061: {},
    0x0063: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x007d: {
        f: $a1a91b25d7598376$var$parse_ColInfo
    },
    0x0080: {
        f: $a1a91b25d7598376$var$parse_Guts
    },
    0x0081: {
        f: $a1a91b25d7598376$var$parse_WsBool
    },
    0x0082: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x0083: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0084: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0085: {
        f: $a1a91b25d7598376$var$parse_BoundSheet8
    },
    0x0086: {},
    0x008c: {
        f: $a1a91b25d7598376$var$parse_Country
    },
    0x008d: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x0090: {},
    0x0092: {
        f: $a1a91b25d7598376$var$parse_Palette
    },
    0x0097: {},
    0x0098: {},
    0x0099: {},
    0x009a: {},
    0x009b: {},
    0x009c: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x009d: {},
    0x009e: {},
    0x00a0: {
        f: $a1a91b25d7598376$var$parse_Scl
    },
    0x00a1: {
        f: $a1a91b25d7598376$var$parse_Setup
    },
    0x00ae: {},
    0x00af: {},
    0x00b0: {},
    0x00b1: {},
    0x00b2: {},
    0x00b4: {},
    0x00b5: {},
    0x00b6: {},
    0x00b8: {},
    0x00b9: {},
    0x00bd: {
        f: $a1a91b25d7598376$var$parse_MulRk
    },
    0x00be: {
        f: $a1a91b25d7598376$var$parse_MulBlank
    },
    0x00c1: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x00c5: {},
    0x00c6: {},
    0x00c7: {},
    0x00c8: {},
    0x00c9: {},
    0x00ca: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x00cb: {},
    0x00cc: {},
    0x00cd: {},
    0x00ce: {},
    0x00cf: {},
    0x00d0: {},
    0x00d1: {},
    0x00d2: {},
    0x00d3: {},
    0x00d5: {},
    0x00d7: {},
    0x00d8: {},
    0x00d9: {},
    0x00da: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x00dc: {},
    0x00dd: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x00de: {},
    0x00e0: {
        f: $a1a91b25d7598376$var$parse_XF
    },
    0x00e1: {
        f: $a1a91b25d7598376$var$parse_InterfaceHdr
    },
    0x00e2: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x00e3: {},
    0x00e5: {
        f: $a1a91b25d7598376$var$parse_MergeCells
    },
    0x00e9: {},
    0x00eb: {},
    0x00ec: {},
    0x00ed: {},
    0x00ef: {},
    0x00f0: {},
    0x00f1: {},
    0x00f2: {},
    0x00f4: {},
    0x00f5: {},
    0x00f6: {},
    0x00f7: {},
    0x00f8: {},
    0x00f9: {},
    0x00fb: {},
    0x00fc: {
        f: $a1a91b25d7598376$var$parse_SST
    },
    0x00fd: {
        f: $a1a91b25d7598376$var$parse_LabelSst
    },
    0x00ff: {
        f: $a1a91b25d7598376$var$parse_ExtSST
    },
    0x0100: {},
    0x0103: {},
    0x0122: {},
    0x0137: {},
    0x0138: {},
    0x013b: {},
    0x013d: {
        f: $a1a91b25d7598376$var$parseuint16a
    },
    0x013e: {},
    0x013f: {},
    0x0140: {},
    0x014a: {},
    0x014b: {},
    0x014d: {},
    0x014e: {},
    0x014f: {},
    0x0150: {},
    0x0151: {},
    0x0152: {},
    0x0153: {},
    0x0154: {},
    0x015f: {},
    0x0160: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x0161: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x0191: {},
    0x0192: {},
    0x0193: {},
    0x0194: {},
    0x0195: {},
    0x0196: {},
    0x0197: {},
    0x0198: {},
    0x01a9: {},
    0x01aa: {},
    0x01ab: {},
    0x01ac: {},
    0x01ad: {},
    0x01ae: {
        f: $a1a91b25d7598376$var$parse_SupBook
    },
    0x01af: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x01b0: {},
    0x01b1: {},
    0x01b2: {},
    0x01b5: {},
    0x01b6: {
        f: $a1a91b25d7598376$var$parse_TxO
    },
    0x01b7: {
        f: $a1a91b25d7598376$var$parsebool
    },
    0x01b8: {
        f: $a1a91b25d7598376$var$parse_HLink
    },
    0x01b9: {},
    0x01ba: {
        f: $a1a91b25d7598376$var$parse_XLUnicodeString
    },
    0x01bb: {},
    0x01bc: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x01bd: {},
    0x01be: {},
    0x01c0: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x01c1: {
        f: $a1a91b25d7598376$var$parse_RecalcId,
        r: 2
    },
    0x01c2: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x0200: {
        f: $a1a91b25d7598376$var$parse_Dimensions
    },
    0x0201: {
        f: $a1a91b25d7598376$var$parse_Blank
    },
    0x0203: {
        f: $a1a91b25d7598376$var$parse_Number
    },
    0x0204: {
        f: $a1a91b25d7598376$var$parse_Label
    },
    0x0205: {
        f: $a1a91b25d7598376$var$parse_BoolErr
    },
    0x0207: {
        f: $a1a91b25d7598376$var$parse_String
    },
    0x0208: {
        f: $a1a91b25d7598376$var$parse_Row
    },
    0x020b: {},
    0x0221: {
        f: $a1a91b25d7598376$var$parse_Array
    },
    0x0225: {
        f: $a1a91b25d7598376$var$parse_DefaultRowHeight
    },
    0x0236: {},
    0x023e: {
        f: $a1a91b25d7598376$var$parse_Window2
    },
    0x027e: {
        f: $a1a91b25d7598376$var$parse_RK
    },
    0x0293: {},
    0x0418: {},
    0x041e: {
        f: $a1a91b25d7598376$var$parse_Format
    },
    0x043c: {},
    0x04bc: {
        f: $a1a91b25d7598376$var$parse_ShrFmla
    },
    0x0800: {
        f: $a1a91b25d7598376$var$parse_HLinkTooltip
    },
    0x0801: {},
    0x0802: {},
    0x0803: {},
    0x0804: {},
    0x0805: {},
    0x0806: {},
    0x0807: {},
    0x0808: {},
    0x0809: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    0x080a: {},
    0x080b: {},
    0x080c: {},
    0x080d: {},
    0x080e: {},
    0x080f: {},
    0x0810: {},
    0x0812: {},
    0x0813: {},
    0x0850: {},
    0x0851: {},
    0x0852: {},
    0x0853: {},
    0x0854: {},
    0x0855: {},
    0x0856: {},
    0x0857: {},
    0x0858: {},
    0x0859: {},
    0x085a: {},
    0x0862: {},
    0x0863: {
        r: 12
    },
    0x0864: {},
    0x0865: {},
    0x0866: {},
    0x0867: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x0868: {},
    0x086a: {},
    0x086b: {},
    0x086c: {},
    0x0871: {},
    0x0872: {},
    0x0874: {},
    0x0875: {},
    0x0876: {},
    0x0877: {},
    0x0878: {},
    0x0879: {},
    0x087a: {},
    0x087b: {},
    0x087c: {
        f: $a1a91b25d7598376$var$parse_XFCRC,
        r: 12
    },
    0x087d: {
        f: $a1a91b25d7598376$var$parse_XFExt,
        r: 12
    },
    0x087e: {},
    0x087f: {},
    0x0884: {},
    0x0885: {},
    0x0886: {},
    0x0887: {},
    0x0888: {},
    0x0889: {},
    0x088a: {},
    0x088b: {},
    0x088c: {
        f: $a1a91b25d7598376$var$parsebool,
        r: 12
    },
    0x088d: {},
    0x088e: {
        r: 12
    },
    0x088f: {},
    0x0890: {},
    0x0892: {},
    0x0893: {},
    0x0894: {
        f: $a1a91b25d7598376$var$parse_NameCmt,
        r: 12
    },
    0x0895: {},
    0x0896: {
        f: $a1a91b25d7598376$var$parse_Theme,
        r: 12
    },
    0x0897: {},
    0x0898: {},
    0x0899: {},
    0x089a: {
        f: $a1a91b25d7598376$var$parse_MTRSettings,
        r: 12
    },
    0x089b: {
        f: $a1a91b25d7598376$var$parsenoop2
    },
    0x089c: {},
    0x089d: {},
    0x089e: {},
    0x089f: {},
    0x08a3: {
        f: $a1a91b25d7598376$var$parse_ForceFullCalculation
    },
    0x08a4: {},
    0x08a5: {},
    0x08a6: {},
    0x08a7: {},
    0x1001: {},
    0x1002: {},
    0x1003: {},
    0x1006: {},
    0x1007: {},
    0x1009: {},
    0x100a: {},
    0x100b: {},
    0x100c: {},
    0x100d: {},
    0x1014: {},
    0x1015: {},
    0x1016: {},
    0x1017: {},
    0x1018: {},
    0x1019: {},
    0x101a: {},
    0x101b: {},
    0x101c: {},
    0x101d: {},
    0x101e: {},
    0x101f: {},
    0x1020: {},
    0x1021: {},
    0x1022: {},
    0x1024: {},
    0x1025: {},
    0x1026: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x1027: {},
    0x1032: {},
    0x1033: {},
    0x1034: {},
    0x1035: {},
    0x103a: {},
    0x103c: {},
    0x103d: {},
    0x103e: {},
    0x103f: {},
    0x1040: {},
    0x1041: {},
    0x1043: {},
    0x1044: {
        f: $a1a91b25d7598376$var$parse_ShtProps
    },
    0x1045: {},
    0x1046: {},
    0x1048: {},
    0x104a: {},
    0x104b: {},
    0x104e: {},
    0x104f: {},
    0x1050: {},
    0x1051: {},
    0x105b: {},
    0x105c: {
        f: $a1a91b25d7598376$var$parse_ClrtClient
    },
    0x105d: {},
    0x105f: {},
    0x1060: {},
    0x1061: {},
    0x1062: {},
    0x1063: {},
    0x1064: {},
    0x1065: {},
    0x1066: {},
    0x1067: {},
    0x1068: {},
    0x0000: {
        f: $a1a91b25d7598376$var$parse_Dimensions
    },
    0x0001: {},
    0x0002: {
        f: $a1a91b25d7598376$var$parse_BIFF2INT
    },
    0x0003: {
        f: $a1a91b25d7598376$var$parse_BIFF2NUM
    },
    0x0004: {
        f: $a1a91b25d7598376$var$parse_BIFF2STR
    },
    0x0005: {
        f: $a1a91b25d7598376$var$parse_BIFF2BOOLERR
    },
    0x0007: {
        f: $a1a91b25d7598376$var$parse_BIFF2STRING
    },
    0x0008: {},
    0x0009: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    0x000b: {},
    0x0016: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x001e: {
        f: $a1a91b25d7598376$var$parse_BIFF2Format
    },
    0x001f: {},
    /* 16-bit cnt of BIFF2FORMAT records */ 0x0020: {},
    0x0021: {
        f: $a1a91b25d7598376$var$parse_Array
    },
    0x0024: {},
    0x0025: {
        f: $a1a91b25d7598376$var$parse_DefaultRowHeight
    },
    // 0x002c ??
    // 0x002d ??
    // 0x002e ??
    // 0x0030 FONTCOUNT: number of fonts
    0x0032: {
        f: $a1a91b25d7598376$var$parse_BIFF2FONTXTRA
    },
    // 0x0035: INFOOPTS
    // 0x0036: TABLE (BIFF2 only)
    // 0x0037: TABLE2 (BIFF2 only)
    // 0x0038: WNDESK
    // 0x0039 ??
    // 0x003a: BEGINPREF
    // 0x003b: ENDPREF
    0x003e: {},
    // 0x003f ??
    // 0x0046: SHOWSCROLL
    // 0x0047: SHOWFORMULA
    // 0x0048: STATUSBAR
    // 0x0049: SHORTMENUS
    // 0x004A:
    // 0x004B:
    // 0x004C:
    // 0x004E:
    // 0x004F:
    // 0x0058: TOOLBAR (BIFF3)
    /* - - - */ 0x0034: {},
    0x0043: {
        f: $a1a91b25d7598376$var$parse_BIFF2XF
    },
    0x0044: {
        f: $a1a91b25d7598376$var$parseuint16
    },
    0x0045: {},
    0x0056: {},
    /* 16-bit cnt, similar to BIFF2 */ 0x007e: {},
    /* Not necessarily same as 0x027e */ 0x007f: {
        f: $a1a91b25d7598376$var$parse_ImData
    },
    0x0087: {},
    0x0088: {},
    0x0089: {},
    // 0x8A
    // 0x8B LH: alternate menu key flag (BIFF3/4)
    // 0x8E
    0x008F: {
        f: $a1a91b25d7598376$var$parse_BIFF4SheetInfo
    },
    0x0091: {},
    // 0x93 STYLE
    0x0094: {},
    0x0095: {},
    0x0096: {},
    // 0xA2 FNPROTO: function prototypes (BIFF4)
    // 0xA3
    // 0xA8
    0x00a9: {},
    0x00ab: {},
    0x00bc: {},
    /* Not necessarily same as 0x04bc */ 0x00bf: {},
    0x00c0: {},
    0x00c2: {},
    0x00c3: {},
    0x00d6: {
        f: $a1a91b25d7598376$var$parse_RString
    },
    0x00df: {},
    0x00ea: {},
    0x0162: {},
    0x01a5: {},
    0x0206: {
        f: $a1a91b25d7598376$var$parse_Formula
    },
    0x0209: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    0x0218: {
        f: $a1a91b25d7598376$var$parse_Lbl
    },
    0x0223: {
        f: $a1a91b25d7598376$var$parse_ExternName
    },
    0x0231: {},
    0x0243: {
        f: $a1a91b25d7598376$var$parse_BIFF3XF
    },
    0x0406: {
        f: $a1a91b25d7598376$var$parse_Formula
    },
    0x0409: {
        f: $a1a91b25d7598376$var$parse_BOF
    },
    0x0443: {
        f: $a1a91b25d7598376$var$parse_BIFF4XF
    },
    0x086d: {},
    0x0873: {},
    0x0881: {},
    0x08c0: {},
    0x08c1: {},
    0x08c2: {},
    0x08c3: {},
    0x08c4: {},
    0x08c5: {},
    0x08c6: {},
    0x08c7: {},
    0x08c8: {},
    0x08c9: {},
    0x08ca: {},
    0x08cb: {},
    0x08d6: {
        r: 12
    },
    /* --- multiplan 4 records --- */ 0x0065: {},
    0x0066: {},
    0x0069: {},
    0x006a: {},
    0x006b: {},
    0x006d: {},
    0x0070: {},
    0x0072: {},
    0x7262: {}
};
function $a1a91b25d7598376$var$write_biff_rec(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var t /*:number*/  = type;
    if (isNaN(t)) return;
    var len = length || (payload || []).length || 0;
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, len);
    if (/*:: len != null &&*/ len > 0 && $a1a91b25d7598376$var$is_buf(payload)) ba.push(payload);
}
function $a1a91b25d7598376$var$write_biff_continue(ba /*:BufArray*/ , type /*:number*/ , payload, length /*:?number*/ ) /*:void*/ {
    var len = length || (payload || []).length || 0;
    if (len <= 8224) return $a1a91b25d7598376$var$write_biff_rec(ba, type, payload, len);
    var t = type;
    if (isNaN(t)) return;
    var parts = payload.parts || [], sidx = 0;
    var i = 0, w = 0;
    while(w + (parts[sidx] || 8224) <= 8224){
        w += parts[sidx] || 8224;
        sidx++;
    }
    var o = ba.next(4);
    o.write_shift(2, t);
    o.write_shift(2, w);
    ba.push(payload.slice(i, i + w));
    i += w;
    while(i < len){
        o = ba.next(4);
        o.write_shift(2, 0x3c); // TODO: figure out correct continue type
        w = 0;
        while(w + (parts[sidx] || 8224) <= 8224){
            w += parts[sidx] || 8224;
            sidx++;
        }
        o.write_shift(2, w);
        ba.push(payload.slice(i, i + w));
        i += w;
    }
}
function $a1a91b25d7598376$var$write_BIFF2BERR(r /*:number*/ , c /*:number*/ , val1, t /*:?string*/ ) {
    var out = $a1a91b25d7598376$var$new_buf(9);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c);
    $a1a91b25d7598376$var$write_Bes(val1, t || 'b', out);
    return out;
}
/* TODO: codepage, large strings */ function $a1a91b25d7598376$var$write_BIFF2LABEL(r /*:number*/ , c /*:number*/ , val1) {
    var out = $a1a91b25d7598376$var$new_buf(8 + 2 * val1.length);
    $a1a91b25d7598376$var$write_BIFF2Cell(out, r, c);
    out.write_shift(1, val1.length);
    out.write_shift(val1.length, val1, 'sbcs');
    return out.l < out.length ? out.slice(0, out.l) : out;
}
function $a1a91b25d7598376$var$write_comments_biff2(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    comments.forEach(function(data) {
        var text = data[0].map(function(cc) {
            return cc.t;
        }).join("");
        // TODO: should '\n' be translated to '\r' to correct for Excel 5.0 bug when exporting to BIFF2/3 ?
        if (text.length <= 2048) return $a1a91b25d7598376$var$write_biff_rec(ba, 0x001C, $a1a91b25d7598376$var$write_NOTE_BIFF2(text, data[1], data[2]));
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x001C, $a1a91b25d7598376$var$write_NOTE_BIFF2(text.slice(0, 2048), data[1], data[2], text.length));
        for(var i = 2048; i < text.length; i += 2048)$a1a91b25d7598376$var$write_biff_rec(ba, 0x001C, $a1a91b25d7598376$var$write_NOTE_BIFF2(text.slice(i, Math.min(i + 2048, text.length)), -1, -1, Math.min(2048, text.length - i)));
    });
}
/* TODO: BIFF3/4 use different records -- see comments*/ function $a1a91b25d7598376$var$write_ws_biff2_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var ifmt = 0;
    if (cell.z != null) {
        ifmt = opts._BIFF2FmtTable.indexOf(cell.z);
        if (ifmt == -1) {
            opts._BIFF2FmtTable.push(cell.z);
            ifmt = opts._BIFF2FmtTable.length - 1;
        }
    }
    var ixfe = 0;
    if (cell.z != null) {
        for(; ixfe < opts.cellXfs.length; ++ixfe)if (opts.cellXfs[ixfe].numFmtId == ifmt) break;
        if (ixfe == opts.cellXfs.length) opts.cellXfs.push({
            numFmtId: ifmt
        });
    }
    if (cell.v != null) switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (opts.biff == 2 && v == (v | 0) && v >= 0 && v < 65536) // 0x027E (RK) in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0002, $a1a91b25d7598376$var$write_BIFF2INT(R, C, v, ixfe, ifmt));
            else if (isNaN(v)) // 0x0205 in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0005, $a1a91b25d7598376$var$write_BIFF2BERR(R, C, 0x24, "e")); // #NUM!
            else if (!isFinite(v)) // 0x0205 in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0005, $a1a91b25d7598376$var$write_BIFF2BERR(R, C, 0x07, "e")); // #DIV/0!
            else // 0x0203 in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0003, $a1a91b25d7598376$var$write_BIFF2NUM(R, C, v, ixfe, ifmt));
            return;
        case 'b':
        case 'e':
            // 0x0205 in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0005, $a1a91b25d7598376$var$write_BIFF2BERR(R, C, cell.v, cell.t));
            return;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            // 0x0204 in BIFF3/4
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0004, $a1a91b25d7598376$var$write_BIFF2LABEL(R, C, cell.v == null ? "" : String(cell.v).slice(0, 255)));
            return;
    }
    // 0x0201 in BIFF3/4
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0001, $a1a91b25d7598376$var$write_BIFF2Cell(null, R, C));
}
function $a1a91b25d7598376$var$write_ws_biff2(ba /*:BufArray*/ , ws /*:Worksheet*/ , idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var dense = ws["!data"] != null;
    var range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1"), rr = "", cols /*:Array<string>*/  = [];
    if (range.e.c > 0xFF || range.e.r > 0x3FFF) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV16384");
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, 0x3FFF);
    }
    var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    var row = [], comments = [];
    /* TODO: 0x0000 / 0x0200 dimensions? */ for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $a1a91b25d7598376$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $a1a91b25d7598376$var$write_ws_biff2_cell(ba, cell, R, C, opts, date1904);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    /* ... 0x12 0x19 0x13 (Password) */ $a1a91b25d7598376$var$write_comments_biff2(ba, comments);
/* 0x3d (Window1) ... */ }
/* Based on test files */ function $a1a91b25d7598376$var$write_biff2_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var ba = $a1a91b25d7598376$var$buf_array();
    var idx = 0;
    for(var i = 0; i < wb.SheetNames.length; ++i)if (wb.SheetNames[i] == o.sheet) idx = i;
    if (idx == 0 && !!o.sheet && wb.SheetNames[0] != o.sheet) throw new Error("Sheet not found: " + o.sheet);
    $a1a91b25d7598376$var$write_biff_rec(ba, o.biff == 4 ? 0x0409 : o.biff == 3 ? 0x0209 : 0x0009, $a1a91b25d7598376$var$write_BOF(wb, 0x10, o));
    if (((wb.Workbook || {}).WBProps || {}).date1904) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0022, $a1a91b25d7598376$var$writebool(true));
    o.cellXfs = [
        {
            numFmtId: 0
        }
    ];
    o._BIFF2FmtTable = [
        "General"
    ];
    o._Fonts = [];
    var body = $a1a91b25d7598376$var$buf_array();
    $a1a91b25d7598376$var$write_ws_biff2(body, wb.Sheets[wb.SheetNames[idx]], idx, o, wb);
    o._BIFF2FmtTable.forEach(function(f) {
        if (o.biff <= 3) $a1a91b25d7598376$var$write_biff_rec(ba, 0x001E, $a1a91b25d7598376$var$write_BIFF2Format(f));
        else $a1a91b25d7598376$var$write_biff_rec(ba, 0x041E, $a1a91b25d7598376$var$write_BIFF4Format(f));
    });
    o.cellXfs.forEach(function(xf) {
        switch(o.biff){
            case 2:
                $a1a91b25d7598376$var$write_biff_rec(ba, 0x0043, $a1a91b25d7598376$var$write_BIFF2XF(xf));
                break;
            case 3:
                $a1a91b25d7598376$var$write_biff_rec(ba, 0x0243, $a1a91b25d7598376$var$write_BIFF3XF(xf));
                break;
            case 4:
                $a1a91b25d7598376$var$write_biff_rec(ba, 0x0443, $a1a91b25d7598376$var$write_BIFF4XF(xf));
                break;
        }
    });
    delete o._BIFF2FmtTable;
    delete o.cellXfs;
    delete o._Fonts;
    ba.push(body.end());
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x000A);
    return ba.end();
}
var $a1a91b25d7598376$var$b8oid = 1, $a1a91b25d7598376$var$b8ocnts /*:Array<[number, number, number]>*/  = [];
function $a1a91b25d7598376$var$write_MsoDrawingGroup() {
    var buf = $a1a91b25d7598376$var$new_buf(82 + 8 * $a1a91b25d7598376$var$b8ocnts.length);
    /* [MS-ODRAW] 2.2.12 OfficeArtDggContainer */ buf.write_shift(2, 0x0F);
    buf.write_shift(2, 0xF000);
    buf.write_shift(4, 74 + 8 * $a1a91b25d7598376$var$b8ocnts.length);
    buf.write_shift(2, 0);
    buf.write_shift(2, 0xF006);
    buf.write_shift(4, 16 + 8 * $a1a91b25d7598376$var$b8ocnts.length);
    buf.write_shift(4, $a1a91b25d7598376$var$b8oid);
    buf.write_shift(4, $a1a91b25d7598376$var$b8ocnts.length + 1);
    var acc = 0;
    for(var i = 0; i < $a1a91b25d7598376$var$b8ocnts.length; ++i)acc += $a1a91b25d7598376$var$b8ocnts[i] && $a1a91b25d7598376$var$b8ocnts[i][1] || 0;
    buf.write_shift(4, acc);
    buf.write_shift(4, $a1a91b25d7598376$var$b8ocnts.length);
    /* 2.2.46 OfficeArtIDCL + */ $a1a91b25d7598376$var$b8ocnts.forEach(function(b8) {
        buf.write_shift(4, b8[0]);
        buf.write_shift(4, b8[2]);
    });
    buf.write_shift(2, 0x33); // 0x03 | (3 << 4)
    buf.write_shift(2, 0xF00B);
    buf.write_shift(4, 0x12); // 3 * 6
    /* 2.3.21.15 Text Boolean Properties */ buf.write_shift(2, 0xBF);
    buf.write_shift(4, 0x00080008);
    /* 2.3.7.2 fillColor */ buf.write_shift(2, 0x0181);
    buf.write_shift(4, 0x08000041);
    /* 2.3.8.1 lineColor */ buf.write_shift(2, 0x01C0);
    buf.write_shift(4, 0x08000040);
    buf.write_shift(2, 0x40);
    buf.write_shift(2, 0xF11E);
    buf.write_shift(4, 16);
    buf.write_shift(4, 0x0800000D);
    buf.write_shift(4, 0x0800000C);
    buf.write_shift(4, 0x08000017);
    buf.write_shift(4, 0x100000F7);
    return buf;
}
function $a1a91b25d7598376$var$write_comments_biff8(ba /*:BufArray*/ , comments /*:Array<[Comment[], number, number]>*/ ) {
    var notes /*:Array<RawData>*/  = [], sz = 0, pl = $a1a91b25d7598376$var$buf_array(), baseid = $a1a91b25d7598376$var$b8oid;
    var _oasc;
    comments.forEach(function(c, ci) {
        var author = "";
        var text = c[0].map(function(t) {
            if (t.a && !author) author = t.a;
            return t.t;
        }).join("");
        ++$a1a91b25d7598376$var$b8oid;
        var oasc = $a1a91b25d7598376$var$new_buf(0x96);
        oasc.write_shift(2, 0x0F);
        oasc.write_shift(2, 0xF004);
        oasc.write_shift(4, 0x96);
        oasc.write_shift(2, 0xca2); // 0x02 | (0xca << 4)
        oasc.write_shift(2, 0xF00A);
        oasc.write_shift(4, 8);
        oasc.write_shift(4, $a1a91b25d7598376$var$b8oid);
        oasc.write_shift(4, 0xA00);
        oasc.write_shift(2, 0xE3); // 0x03 | (14 << 4)
        oasc.write_shift(2, 0xF00B);
        oasc.write_shift(4, 0x54); // 14 * 6
        /* 2.3.21.1 ITxid */ oasc.write_shift(2, 0x80);
        oasc.write_shift(4, 0);
        /* 2.3.21.12 txdir */ oasc.write_shift(2, 0x8B);
        oasc.write_shift(4, 0x02);
        /* 2.3.21.15 Text Boolean Properties */ oasc.write_shift(2, 0xBF);
        oasc.write_shift(4, 0x00080008);
        /* 2.3.6.30 cxk */ oasc.write_shift(2, 0x0158);
        oasc.l += 4;
        /* 2.3.7.2 fillColor */ oasc.write_shift(2, 0x0181);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.4 fillBackColor */ oasc.write_shift(2, 0x0183);
        oasc.write_shift(4, 0x08000050);
        /* 2.3.7.6 fillCrMod */ oasc.write_shift(2, 0x0185);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.7.43 Fill Style Boolean Properties */ oasc.write_shift(2, 0x01BF);
        oasc.write_shift(4, 0x00100010);
        /* 2.3.8.1 lineColor */ oasc.write_shift(2, 0x01C0);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.8.4 lineCrMod */ oasc.write_shift(2, 0x01C3);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.2 shadowColor */ oasc.write_shift(2, 0x0201);
        oasc.write_shift(4, 0x08000051);
        /* 2.3.13.4 shadowCrMod */ oasc.write_shift(2, 0x0203);
        oasc.write_shift(4, 0x100000F4);
        /* 2.3.13.23 Shadow Style Boolean Properties */ oasc.write_shift(2, 0x023F);
        oasc.write_shift(4, 0x00030001);
        /* 2.3.4.44 Group Shape Boolean Properties */ oasc.write_shift(2, 0x03BF);
        oasc.write_shift(4, 0x00020000 | (c[0].hidden ? 2 : 0));
        oasc.l += 2;
        oasc.write_shift(2, 0xF010);
        oasc.write_shift(4, 0x12);
        oasc.write_shift(2, 0x3); // do not move or size with cells
        oasc.write_shift(2, c[2] + 2);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 1);
        oasc.l += 2;
        oasc.write_shift(2, c[2] + 4);
        oasc.l += 2;
        oasc.write_shift(2, c[1] + 5);
        oasc.l += 2;
        oasc.l += 2;
        oasc.write_shift(2, 0xF011);
        oasc.l += 4;
        oasc.l = 0x96;
        if (ci == 0) /* write_biff_rec(pl, 0x003C, oasc); */ _oasc = oasc;
        else $a1a91b25d7598376$var$write_biff_rec(pl, 0x00EC, oasc);
        sz += 0x96;
        var obj = $a1a91b25d7598376$var$new_buf(52); // 22 + 26 + 4
        /* [MS-XLS] 2.5.143 FtCmo */ obj.write_shift(2, 0x15);
        obj.write_shift(2, 0x12);
        obj.write_shift(2, 0x19);
        obj.write_shift(2, $a1a91b25d7598376$var$b8oid);
        obj.write_shift(2, 0);
        obj.l = 22;
        /* [MS-XLS] 2.5.149 FtNts */ obj.write_shift(2, 0x0D);
        obj.write_shift(2, 0x16);
        obj.write_shift(4, 0x62726272);
        obj.write_shift(4, 0x95374305);
        obj.write_shift(4, 0x80301328);
        obj.write_shift(4, 0x69696904 + $a1a91b25d7598376$var$b8oid * 256);
        obj.write_shift(2, 0);
        obj.write_shift(4, 0);
        // reserved
        obj.l += 4;
        $a1a91b25d7598376$var$write_biff_rec(pl, 0x005D, obj);
        var oact = $a1a91b25d7598376$var$new_buf(8);
        oact.l += 2;
        oact.write_shift(2, 0xF00D);
        oact.l += 4;
        $a1a91b25d7598376$var$write_biff_rec(pl, 0x00EC, oact);
        sz += 8;
        var txo = $a1a91b25d7598376$var$new_buf(18);
        txo.write_shift(2, 0x12);
        txo.l += 8;
        txo.write_shift(2, text.length);
        txo.write_shift(2, 0x10);
        txo.l += 4;
        $a1a91b25d7598376$var$write_biff_rec(pl, 0x01b6, txo);
        var cont = $a1a91b25d7598376$var$new_buf(1 + text.length);
        cont.write_shift(1, 0);
        cont.write_shift(text.length, text, "sbcs");
        $a1a91b25d7598376$var$write_biff_rec(pl, 0x003C, cont);
        var conf = $a1a91b25d7598376$var$new_buf(0x10);
        conf.l += 8;
        conf.write_shift(2, text.length);
        conf.l += 6;
        $a1a91b25d7598376$var$write_biff_rec(pl, 0x003C, conf);
        var notesh = $a1a91b25d7598376$var$new_buf(12 + author.length);
        notesh.write_shift(2, c[1]);
        notesh.write_shift(2, c[2]);
        notesh.write_shift(2, 0 | (c[0].hidden ? 0 : 2));
        notesh.write_shift(2, $a1a91b25d7598376$var$b8oid);
        notesh.write_shift(2, author.length);
        notesh.write_shift(1, 0);
        notesh.write_shift(author.length, author, "sbcs");
        notesh.l++;
        notes.push(notesh);
    });
    var hdr = $a1a91b25d7598376$var$new_buf(80);
    hdr.write_shift(2, 0x0F);
    hdr.write_shift(2, 0xF002);
    hdr.write_shift(4, sz + hdr.length - 8);
    hdr.write_shift(2, 0x10);
    hdr.write_shift(2, 0xF008);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, comments.length + 1);
    hdr.write_shift(4, $a1a91b25d7598376$var$b8oid);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF003);
    hdr.write_shift(4, sz + 0x30);
    hdr.write_shift(2, 0x0f);
    hdr.write_shift(2, 0xF004);
    hdr.write_shift(4, 0x28);
    hdr.write_shift(2, 0x01);
    hdr.write_shift(2, 0xF009);
    hdr.write_shift(4, 0x10);
    hdr.l += 16;
    hdr.write_shift(2, 0x02);
    hdr.write_shift(2, 0xF00A);
    hdr.write_shift(4, 0x08);
    hdr.write_shift(4, baseid);
    hdr.write_shift(4, 0x05);
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x00EC, /* hdr */ _oasc ? $a1a91b25d7598376$var$bconcat([
        hdr,
        _oasc
    ]) : hdr);
    ba.push(pl.end());
    notes.forEach(function(n) {
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x001C, n);
    });
    $a1a91b25d7598376$var$b8ocnts.push([
        baseid,
        comments.length + 1,
        $a1a91b25d7598376$var$b8oid
    ]);
    ++$a1a91b25d7598376$var$b8oid;
}
function $a1a91b25d7598376$var$write_FONTS_biff8(ba, data, opts) {
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0031 /* Font */ , $a1a91b25d7598376$var$write_Font({
        sz: 12,
        color: {
            theme: 1
        },
        name: "Arial",
        family: 2,
        scheme: "minor"
    }, opts));
}
function $a1a91b25d7598376$var$write_FMTS_biff8(ba, NF /*:?SSFTable*/ , opts) {
    if (!NF) return;
    [
        [
            5,
            8
        ],
        [
            23,
            26
        ],
        [
            41,
            44
        ],
        [
            /*63*/ 50,
            /*66],[164,*/ 392
        ]
    ].forEach(function(r) {
        /*:: if(!NF) return; */ for(var i = r[0]; i <= r[1]; ++i)if (NF[i] != null) $a1a91b25d7598376$var$write_biff_rec(ba, 0x041E /* Format */ , $a1a91b25d7598376$var$write_Format(i, NF[i], opts));
    });
}
function $a1a91b25d7598376$var$write_FEAT(ba, ws) {
    /* [MS-XLS] 2.4.112 */ var o = $a1a91b25d7598376$var$new_buf(19);
    o.write_shift(4, 0x867);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 1);
    o.write_shift(4, 0);
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0867 /* FeatHdr */ , o);
    /* [MS-XLS] 2.4.111 */ o = $a1a91b25d7598376$var$new_buf(39);
    o.write_shift(4, 0x868);
    o.write_shift(4, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 3);
    o.write_shift(1, 0);
    o.write_shift(4, 0);
    o.write_shift(2, 1);
    o.write_shift(4, 4);
    o.write_shift(2, 0);
    $a1a91b25d7598376$var$write_Ref8U($a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1"), o);
    o.write_shift(4, 4);
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0868 /* Feat */ , o);
}
function $a1a91b25d7598376$var$write_CELLXFS_biff8(ba, opts) {
    for(var i = 0; i < 16; ++i)$a1a91b25d7598376$var$write_biff_rec(ba, 0x00e0 /* XF */ , $a1a91b25d7598376$var$write_XF({
        numFmtId: 0,
        style: true
    }, 0, opts));
    opts.cellXfs.forEach(function(c) {
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x00e0 /* XF */ , $a1a91b25d7598376$var$write_XF(c, 0, opts));
    });
}
function $a1a91b25d7598376$var$write_ws_biff8_hlinks(ba /*:BufArray*/ , ws) {
    for(var R = 0; R < ws['!links'].length; ++R){
        var HL = ws['!links'][R];
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x01b8 /* HLink */ , $a1a91b25d7598376$var$write_HLink(HL));
        if (HL[1].Tooltip) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0800 /* HLinkTooltip */ , $a1a91b25d7598376$var$write_HLinkTooltip(HL));
    }
    delete ws['!links'];
}
function $a1a91b25d7598376$var$write_ws_cols_biff8(ba, cols) {
    if (!cols) return;
    var cnt = 0;
    cols.forEach(function(col, idx) {
        if (++cnt <= 256 && col) $a1a91b25d7598376$var$write_biff_rec(ba, 0x007d /* ColInfo */ , $a1a91b25d7598376$var$write_ColInfo($a1a91b25d7598376$var$col_obj_w(idx, col), idx));
    });
}
function $a1a91b25d7598376$var$write_ws_biff8_cell(ba /*:BufArray*/ , cell /*:Cell*/ , R /*:number*/ , C /*:number*/ , opts, date1904 /*:boolean*/ ) {
    var os = 16 + $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
    if (cell.v == null && !cell.bf) {
        $a1a91b25d7598376$var$write_biff_rec(ba, 0x0201 /* Blank */ , $a1a91b25d7598376$var$write_XLSCell(R, C, os));
        return;
    }
    if (cell.bf) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0006 /* Formula */ , $a1a91b25d7598376$var$write_Formula(cell, R, C, opts, os));
    else switch(cell.t){
        case 'd':
        case 'n':
            var v = cell.t == 'd' ? $a1a91b25d7598376$var$datenum($a1a91b25d7598376$var$parseDate(cell.v, date1904), date1904) : cell.v;
            if (isNaN(v)) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $a1a91b25d7598376$var$write_BoolErr(R, C, 0x24, os, opts, "e")); // #NUM!
            else if (!isFinite(v)) $a1a91b25d7598376$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $a1a91b25d7598376$var$write_BoolErr(R, C, 0x07, os, opts, "e")); // #DIV/0!
            else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0203 /* Number */ , $a1a91b25d7598376$var$write_Number(R, C, v, os, opts));
            break;
        case 'b':
        case 'e':
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0205 /* BoolErr */ , $a1a91b25d7598376$var$write_BoolErr(R, C, cell.v, os, opts, cell.t));
            break;
        /* TODO: codepage, sst */ case 's':
        case 'str':
            if (opts.bookSST) {
                var isst = $a1a91b25d7598376$var$get_sst_id(opts.Strings, cell.v == null ? "" : String(cell.v), opts.revStrings);
                $a1a91b25d7598376$var$write_biff_rec(ba, 0x00fd /* LabelSst */ , $a1a91b25d7598376$var$write_LabelSst(R, C, isst, os, opts));
            } else $a1a91b25d7598376$var$write_biff_rec(ba, 0x0204 /* Label */ , $a1a91b25d7598376$var$write_Label(R, C, (cell.v == null ? "" : String(cell.v)).slice(0, 255), os, opts));
            break;
        default:
            $a1a91b25d7598376$var$write_biff_rec(ba, 0x0201 /* Blank */ , $a1a91b25d7598376$var$write_XLSCell(R, C, os));
    }
}
/* [MS-XLS] 2.1.7.20.5 */ function $a1a91b25d7598376$var$write_ws_biff8(idx /*:number*/ , opts, wb /*:Workbook*/ ) {
    var ba = $a1a91b25d7598376$var$buf_array();
    var s = wb.SheetNames[idx], ws = wb.Sheets[s] || {};
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheet /*:WBWSProp*/  = (_WB.Sheets || [])[idx] || {} /*:any*/ ;
    var dense = ws["!data"] != null;
    var b8 = opts.biff == 8;
    var ref /*:string*/ , rr = "", cols /*:Array<string>*/  = [];
    var range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref'] || "A1");
    var MAX_ROWS = b8 ? 65536 : 16384;
    if (range.e.c > 0xFF || range.e.r >= MAX_ROWS) {
        if (opts.WTF) throw new Error("Range " + (ws['!ref'] || "A1") + " exceeds format limit A1:IV" + MAX_ROWS);
        range.e.c = Math.min(range.e.c, 0xFF);
        range.e.r = Math.min(range.e.r, MAX_ROWS - 1);
    }
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0809, $a1a91b25d7598376$var$write_BOF(wb, 0x10, opts));
    /* [Uncalced] Index */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x000d /* CalcMode */ , $a1a91b25d7598376$var$writeuint16(1));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x000c /* CalcCount */ , $a1a91b25d7598376$var$writeuint16(100));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x000f /* CalcRefMode */ , $a1a91b25d7598376$var$writebool(true));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0011 /* CalcIter */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0010 /* CalcDelta */ , $a1a91b25d7598376$var$write_Xnum(0.001));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x005f /* CalcSaveRecalc */ , $a1a91b25d7598376$var$writebool(true));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x002a /* PrintRowCol */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x002b /* PrintGrid */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0082 /* GridSet */ , $a1a91b25d7598376$var$writeuint16(1));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0080 /* Guts */ , $a1a91b25d7598376$var$write_Guts([
        0,
        0
    ]));
    /* DefaultRowHeight WsBool [Sync] [LPr] [HorizontalPageBreaks] [VerticalPageBreaks] */ /* Header (string) */ /* Footer (string) */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x0083 /* HCenter */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(ba, 0x0084 /* VCenter */ , $a1a91b25d7598376$var$writebool(false));
    /* ... */ if (b8) $a1a91b25d7598376$var$write_ws_cols_biff8(ba, ws["!cols"]);
    /* ... */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x0200 /* Dimensions */ , $a1a91b25d7598376$var$write_Dimensions(range, opts));
    /* ... */ var date1904 = (((wb || {}).Workbook || {}).WBProps || {}).date1904;
    if (b8) ws['!links'] = [];
    for(var C = range.s.c; C <= range.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    var comments = [];
    var row = [];
    for(var R = range.s.r; R <= range.e.r; ++R){
        if (dense) row = ws["!data"][R] || [];
        rr = $a1a91b25d7598376$var$encode_row(R);
        for(C = range.s.c; C <= range.e.c; ++C){
            var cell = dense ? row[C] : ws[cols[C] + rr];
            if (!cell) continue;
            /* write cell */ $a1a91b25d7598376$var$write_ws_biff8_cell(ba, cell, R, C, opts, date1904);
            if (b8 && cell.l) ws['!links'].push([
                cols[C] + rr,
                cell.l
            ]);
            if (cell.c) comments.push([
                cell.c,
                R,
                C
            ]);
        }
    }
    var cname /*:string*/  = _sheet.CodeName || _sheet.name || s;
    /* ... */ if (b8) $a1a91b25d7598376$var$write_comments_biff8(ba, comments);
    else $a1a91b25d7598376$var$write_comments_biff2(ba, comments);
    /* ... */ if (b8) $a1a91b25d7598376$var$write_biff_rec(ba, 0x023e /* Window2 */ , $a1a91b25d7598376$var$write_Window2((_WB.Views || [])[0]));
    /* ... */ if (b8 && (ws['!merges'] || []).length) $a1a91b25d7598376$var$write_biff_rec(ba, 0x00e5 /* MergeCells */ , $a1a91b25d7598376$var$write_MergeCells(ws['!merges']));
    /* [LRng] *QUERYTABLE [PHONETICINFO] CONDFMTS */ if (b8) $a1a91b25d7598376$var$write_ws_biff8_hlinks(ba, ws);
    /* [DVAL] */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x01ba /* CodeName */ , $a1a91b25d7598376$var$write_XLUnicodeString(cname, opts));
    /* *WebPub *CellWatch [SheetExt] */ if (b8) $a1a91b25d7598376$var$write_FEAT(ba, ws);
    /* *FEAT11 *RECORD12 */ $a1a91b25d7598376$var$write_biff_rec(ba, 0x000a /* EOF */ );
    return ba.end();
}
/* [MS-XLS] 2.1.7.20.3 */ function $a1a91b25d7598376$var$write_biff8_global(wb /*:Workbook*/ , bufs, opts /*:WriteOpts*/ ) {
    var A = $a1a91b25d7598376$var$buf_array();
    var _WB /*:WBWBProps*/  = (wb || {}).Workbook || {} /*:any*/ ;
    var _sheets /*:Array<WBWSProp>*/  = _WB.Sheets || [];
    var _wb /*:WBProps*/  = /*::((*/ _WB.WBProps || {} /*:: ):any)*/ ;
    var b8 = opts.biff == 8, b5 = opts.biff == 5;
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0809, $a1a91b25d7598376$var$write_BOF(wb, 0x05, opts));
    if (opts.bookType == "xla") $a1a91b25d7598376$var$write_biff_rec(A, 0x0087 /* Addin */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00e1 /* InterfaceHdr */ , b8 ? $a1a91b25d7598376$var$writeuint16(0x04b0) : null);
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00c1 /* Mms */ , $a1a91b25d7598376$var$writezeroes(2));
    if (b5) $a1a91b25d7598376$var$write_biff_rec(A, 0x00bf /* ToolbarHdr */ );
    if (b5) $a1a91b25d7598376$var$write_biff_rec(A, 0x00c0 /* ToolbarEnd */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00e2 /* InterfaceEnd */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x005c /* WriteAccess */ , $a1a91b25d7598376$var$write_WriteAccess("SheetJS", opts));
    /* [FileSharing] */ $a1a91b25d7598376$var$write_biff_rec(A, 0x0042 /* CodePage */ , $a1a91b25d7598376$var$writeuint16(b8 ? 0x04b0 : 0x04E4));
    /* *2047 Lel */ if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x0161 /* DSF */ , $a1a91b25d7598376$var$writeuint16(0));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01c0 /* Excel9File */ );
    $a1a91b25d7598376$var$write_biff_rec(A, 0x013d /* RRTabId */ , $a1a91b25d7598376$var$write_RRTabId(wb.SheetNames.length));
    if (b8 && wb.vbaraw) $a1a91b25d7598376$var$write_biff_rec(A, 0x00d3 /* ObProj */ );
    /* [ObNoMacros] */ if (b8 && wb.vbaraw) {
        var cname /*:string*/  = _wb.CodeName || "ThisWorkbook";
        $a1a91b25d7598376$var$write_biff_rec(A, 0x01ba /* CodeName */ , $a1a91b25d7598376$var$write_XLUnicodeString(cname, opts));
    }
    $a1a91b25d7598376$var$write_biff_rec(A, 0x009c /* BuiltInFnGroupCount */ , $a1a91b25d7598376$var$writeuint16(0x11));
    /* *FnGroupName *FnGrp12 */ /* *Lbl */ /* [OleObjectSize] */ $a1a91b25d7598376$var$write_biff_rec(A, 0x0019 /* WinProtect */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0012 /* Protect */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0013 /* Password */ , $a1a91b25d7598376$var$writeuint16(0));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01af /* Prot4Rev */ , $a1a91b25d7598376$var$writebool(false));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01bc /* Prot4RevPass */ , $a1a91b25d7598376$var$writeuint16(0));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x003d /* Window1 */ , $a1a91b25d7598376$var$write_Window1(opts));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0040 /* Backup */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x008d /* HideObj */ , $a1a91b25d7598376$var$writeuint16(0));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x0022 /* Date1904 */ , $a1a91b25d7598376$var$writebool($a1a91b25d7598376$var$safe1904(wb) == "true"));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x000e /* CalcPrecision */ , $a1a91b25d7598376$var$writebool(true));
    if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x01b7 /* RefreshAll */ , $a1a91b25d7598376$var$writebool(false));
    $a1a91b25d7598376$var$write_biff_rec(A, 0x00DA /* BookBool */ , $a1a91b25d7598376$var$writeuint16(0));
    /* ... */ $a1a91b25d7598376$var$write_FONTS_biff8(A, wb, opts);
    $a1a91b25d7598376$var$write_FMTS_biff8(A, wb.SSF, opts);
    $a1a91b25d7598376$var$write_CELLXFS_biff8(A, opts);
    /* ... */ if (b8) $a1a91b25d7598376$var$write_biff_rec(A, 0x0160 /* UsesELFs */ , $a1a91b25d7598376$var$writebool(false));
    var a = A.end();
    var C = $a1a91b25d7598376$var$buf_array();
    /* METADATA [MTRSettings] [ForceFullCalculation] */ if (b8) $a1a91b25d7598376$var$write_biff_rec(C, 0x008C /* Country */ , $a1a91b25d7598376$var$write_Country());
    /* *SUPBOOK *LBL *RTD [RecalcId] *HFPicture */ /* BIFF8: MsoDrawingGroup [*Continue] */ if (b8 && $a1a91b25d7598376$var$b8ocnts.length) $a1a91b25d7598376$var$write_biff_rec(C, 0x00EB /* MsoDrawingGroup */ , $a1a91b25d7598376$var$write_MsoDrawingGroup());
    /* BIFF8: [SST *Continue] ExtSST */ if (b8 && opts.Strings) $a1a91b25d7598376$var$write_biff_continue(C, 0x00FC /* SST */ , $a1a91b25d7598376$var$write_SST(opts.Strings, opts));
    /* *WebPub [WOpt] [CrErr] [BookExt] *FeatHdr *DConn [THEME] [CompressPictures] [Compat12] [GUIDTypeLib] */ $a1a91b25d7598376$var$write_biff_rec(C, 0x000A /* EOF */ );
    var c = C.end();
    var B = $a1a91b25d7598376$var$buf_array();
    var blen = 0, j = 0;
    for(j = 0; j < wb.SheetNames.length; ++j)blen += (b8 ? 12 : 11) + (b8 ? 2 : 1) * wb.SheetNames[j].length;
    var start = a.length + blen + c.length;
    for(j = 0; j < wb.SheetNames.length; ++j){
        var _sheet /*:WBWSProp*/  = _sheets[j] || {} /*:any*/ ;
        $a1a91b25d7598376$var$write_biff_rec(B, 0x0085 /* BoundSheet8 */ , $a1a91b25d7598376$var$write_BoundSheet8({
            pos: start,
            hs: _sheet.Hidden || 0,
            dt: 0,
            name: wb.SheetNames[j]
        }, opts));
        start += bufs[j].length;
    }
    /* 1*BoundSheet8 */ var b = B.end();
    if (blen != b.length) throw new Error("BS8 " + blen + " != " + b.length);
    var out = [];
    if (a.length) out.push(a);
    if (b.length) out.push(b);
    if (c.length) out.push(c);
    return $a1a91b25d7598376$var$bconcat(out);
}
/* [MS-XLS] 2.1.7.20 Workbook Stream */ function $a1a91b25d7598376$var$write_biff8_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    var o = opts || {};
    var bufs = [];
    if (wb && !wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb && wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        o.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        o.revssf[wb.SSF[65535]] = 0;
        o.ssf = wb.SSF;
    }
    $a1a91b25d7598376$var$b8oid = 1;
    $a1a91b25d7598376$var$b8ocnts = [];
    o.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    o.Strings.Count = 0;
    o.Strings.Unique = 0;
    $a1a91b25d7598376$var$fix_write_opts(o);
    o.cellXfs = [];
    $a1a91b25d7598376$var$get_cell_style(o.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    for(var i = 0; i < wb.SheetNames.length; ++i)bufs[bufs.length] = $a1a91b25d7598376$var$write_ws_biff8(i, o, wb);
    bufs.unshift($a1a91b25d7598376$var$write_biff8_global(wb, bufs, o));
    return $a1a91b25d7598376$var$bconcat(bufs);
}
function $a1a91b25d7598376$var$write_biff_buf(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) {
    for(var i = 0; i <= wb.SheetNames.length; ++i){
        var ws = wb.Sheets[wb.SheetNames[i]];
        if (!ws || !ws["!ref"]) continue;
        var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
        if (range.e.c > 255) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond column IV (255).  Data may be lost.");
        }
        if (range.e.r > 65535) {
            if (typeof console != "undefined" && console.error) console.error("Worksheet '" + wb.SheetNames[i] + "' extends beyond row 65536.  Data may be lost.");
        }
    }
    var o = opts || {};
    switch(o.biff || 2){
        case 8:
        case 5:
            return $a1a91b25d7598376$var$write_biff8_buf(wb, opts);
        case 4:
        case 3:
        case 2:
            return $a1a91b25d7598376$var$write_biff2_buf(wb, opts);
    }
    throw new Error("invalid type " + o.bookType + " for BIFF");
}
/* note: browser DOM element cannot see mso- style attrs, must parse */ function $a1a91b25d7598376$var$html_to_sheet(str /*:string*/ , _opts) /*:Workbook*/ {
    var opts = _opts || {};
    var dense = opts.dense != null ? opts.dense : $a1a91b25d7598376$var$DENSE;
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (dense) ws["!data"] = [];
    str = $a1a91b25d7598376$var$str_remove_ng(str, "<!--", "-->");
    var mtch /*:any*/  = str.match(/<table/i);
    if (!mtch) throw new Error("Invalid HTML: could not find <table>");
    var mtch2 /*:any*/  = str.match(/<\/table/i);
    var i /*:number*/  = mtch.index, j /*:number*/  = mtch2 && mtch2.index || str.length;
    var rows = $a1a91b25d7598376$var$split_regex(str.slice(i, j), /(:?<tr[^<>]*>)/i, "<tr>");
    var R = -1, C = 0, RS = 0, CS = 0;
    var range /*:Range*/  = {
        s: {
            r: 10000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var merges /*:Array<Range>*/  = [];
    for(i = 0; i < rows.length; ++i){
        var row = rows[i].trim();
        var hd = row.slice(0, 3).toLowerCase();
        if (hd == "<tr") {
            ++R;
            if (opts.sheetRows && opts.sheetRows <= R) {
                --R;
                break;
            }
            C = 0;
            continue;
        }
        if (hd != "<td" && hd != "<th") continue;
        var cells = row.split(/<\/t[dh]>/i);
        for(j = 0; j < cells.length; ++j){
            var cell = cells[j].trim();
            if (!cell.match(/<t[dh]/i)) continue;
            var m = cell, cc = 0;
            /* TODO: parse styles etc */ while(m.charAt(0) == "<" && (cc = m.indexOf(">")) > -1)m = m.slice(cc + 1);
            for(var midx = 0; midx < merges.length; ++midx){
                var _merge /*:Range*/  = merges[midx];
                if (_merge.s.c == C && _merge.s.r < R && R <= _merge.e.r) {
                    C = _merge.e.c + 1;
                    midx = -1;
                }
            }
            var tag = $a1a91b25d7598376$var$parsexmltag(cell.slice(0, cell.indexOf(">")));
            CS = tag.colspan ? +tag.colspan : 1;
            if ((RS = +tag.rowspan) > 1 || CS > 1) merges.push({
                s: {
                    r: R,
                    c: C
                },
                e: {
                    r: R + (RS || 1) - 1,
                    c: C + CS - 1
                }
            });
            var _t /*:string*/  = tag.t || tag["data-t"] || "";
            /* TODO: generate stub cells */ if (!m.length) {
                C += CS;
                continue;
            }
            m = $a1a91b25d7598376$var$htmldecode(m);
            if (range.s.r > R) range.s.r = R;
            if (range.e.r < R) range.e.r = R;
            if (range.s.c > C) range.s.c = C;
            if (range.e.c < C) range.e.c = C;
            if (!m.length) {
                C += CS;
                continue;
            }
            var o /*:Cell*/  = {
                t: 's',
                v: m
            };
            if (opts.raw || !m.trim().length || _t == 's') ;
            else if (m === 'TRUE') o = {
                t: 'b',
                v: true
            };
            else if (m === 'FALSE') o = {
                t: 'b',
                v: false
            };
            else if (!isNaN($a1a91b25d7598376$var$fuzzynum(m))) o = {
                t: 'n',
                v: $a1a91b25d7598376$var$fuzzynum(m)
            };
            else if (!isNaN($a1a91b25d7598376$var$fuzzydate(m).getDate())) {
                o = {
                    t: 'd',
                    v: $a1a91b25d7598376$var$parseDate(m)
                } /*:any*/ ;
                if (opts.UTC === false) o.v = $a1a91b25d7598376$var$utc_to_local(o.v);
                if (!opts.cellDates) o = {
                    t: 'n',
                    v: $a1a91b25d7598376$var$datenum(o.v)
                } /*:any*/ ;
                o.z = opts.dateNF || $a1a91b25d7598376$var$table_fmt[14];
            } else if (m.charCodeAt(0) == 35 /* # */  && $a1a91b25d7598376$var$RBErr[m] != null) {
                o.t = 'e';
                o.w = m;
                o.v = $a1a91b25d7598376$var$RBErr[m];
            }
            if (o.cellText !== false) o.w = m;
            if (dense) {
                if (!ws["!data"][R]) ws["!data"][R] = [];
                ws["!data"][R][C] = o;
            } else ws[$a1a91b25d7598376$var$encode_cell({
                r: R,
                c: C
            })] = o;
            C += CS;
        }
    }
    ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
    if (merges.length) ws["!merges"] = merges;
    return ws;
}
function $a1a91b25d7598376$var$make_html_row(ws /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var M /*:Array<Range>*/  = ws['!merges'] || [];
    var oo /*:Array<string>*/  = [];
    var sp = {} /*:any*/ ;
    var dense = ws["!data"] != null;
    for(var C = r.s.c; C <= r.e.c; ++C){
        var RS = 0, CS = 0;
        for(var j = 0; j < M.length; ++j){
            if (M[j].s.r > R || M[j].s.c > C) continue;
            if (M[j].e.r < R || M[j].e.c < C) continue;
            if (M[j].s.r < R || M[j].s.c < C) {
                RS = -1;
                break;
            }
            RS = M[j].e.r - M[j].s.r + 1;
            CS = M[j].e.c - M[j].s.c + 1;
            break;
        }
        if (RS < 0) continue;
        var coord = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R);
        var cell = dense ? (ws["!data"][R] || [])[C] : ws[coord];
        if (cell && cell.t == 'n' && cell.v != null && !isFinite(cell.v)) {
            if (isNaN(cell.v)) cell = {
                t: 'e',
                v: 0x24,
                w: $a1a91b25d7598376$var$BErr[0x24]
            };
            else cell = {
                t: 'e',
                v: 0x07,
                w: $a1a91b25d7598376$var$BErr[0x07]
            };
        }
        /* TODO: html entities */ var w = cell && cell.v != null && (cell.h || $a1a91b25d7598376$var$escapehtml(cell.w || ($a1a91b25d7598376$var$format_cell(cell), cell.w) || "")) || "";
        sp = {} /*:any*/ ;
        if (RS > 1) sp.rowspan = RS;
        if (CS > 1) sp.colspan = CS;
        if (o.editable) w = '<span contenteditable="true">' + w + '</span>';
        else if (cell) {
            sp["data-t"] = cell && cell.t || 'z';
            // note: data-v is unaffected by the timezone interpretation
            if (cell.v != null) sp["data-v"] = $a1a91b25d7598376$var$escapehtml(cell.v instanceof Date ? cell.v.toISOString() : cell.v);
            if (cell.z != null) sp["data-z"] = cell.z;
            if (cell.l && (cell.l.Target || "#").charAt(0) != "#") w = '<a href="' + $a1a91b25d7598376$var$escapehtml(cell.l.Target) + '">' + w + '</a>';
        }
        sp.id = (o.id || "sjs") + "-" + coord;
        oo.push($a1a91b25d7598376$var$writextag('td', w, sp));
    }
    var preamble = "<tr>";
    return preamble + oo.join("") + "</tr>";
}
var $a1a91b25d7598376$var$HTML_BEGIN = '<html><head><meta charset="utf-8"/><title>SheetJS Table Export</title></head><body>';
var $a1a91b25d7598376$var$HTML_END = '</body></html>';
function $a1a91b25d7598376$var$html_to_workbook(str /*:string*/ , opts) /*:Workbook*/ {
    var mtch = $a1a91b25d7598376$var$str_match_xml_ig(str, "table");
    if (!mtch || mtch.length == 0) throw new Error("Invalid HTML: could not find <table>");
    if (mtch.length == 1) {
        var w = $a1a91b25d7598376$var$sheet_to_workbook($a1a91b25d7598376$var$html_to_sheet(mtch[0], opts), opts);
        w.bookType = "html";
        return w;
    }
    var wb = $a1a91b25d7598376$var$book_new();
    mtch.forEach(function(s, idx) {
        $a1a91b25d7598376$var$book_append_sheet(wb, $a1a91b25d7598376$var$html_to_sheet(s, opts), "Sheet" + (idx + 1));
    });
    wb.bookType = "html";
    return wb;
}
function $a1a91b25d7598376$var$make_html_preamble(ws /*:Worksheet*/ , R /*:Range*/ , o /*:Sheet2HTMLOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    return out.join("") + '<table' + (o && o.id ? ' id="' + o.id + '"' : "") + '>';
}
function $a1a91b25d7598376$var$sheet_to_html(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/  /*, wb:?Workbook*/ ) /*:string*/ {
    var o = opts || {};
    var header = o.header != null ? o.header : $a1a91b25d7598376$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $a1a91b25d7598376$var$HTML_END;
    var out /*:Array<string>*/  = [
        header
    ];
    var r = $a1a91b25d7598376$var$decode_range(ws['!ref'] || "A1");
    out.push($a1a91b25d7598376$var$make_html_preamble(ws, r, o));
    if (ws["!ref"]) for(var R = r.s.r; R <= r.e.r; ++R)out.push($a1a91b25d7598376$var$make_html_row(ws, r, R, o));
    out.push("</table>" + footer);
    return out.join("");
}
function $a1a91b25d7598376$var$sheet_add_dom(ws /*:Worksheet*/ , table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var rows /*:HTMLCollection<HTMLTableRowElement>*/  = table.rows;
    if (!rows) /* not an HTML TABLE */ throw "Unsupported origin when " + table.tagName + " is not a TABLE";
    var opts = _opts || {};
    var dense = ws["!data"] != null;
    var or_R = 0, or_C = 0;
    if (opts.origin != null) {
        if (typeof opts.origin == 'number') or_R = opts.origin;
        else {
            var _origin /*:CellAddress*/  = typeof opts.origin == "string" ? $a1a91b25d7598376$var$decode_cell(opts.origin) : opts.origin;
            or_R = _origin.r;
            or_C = _origin.c;
        }
    }
    var sheetRows = Math.min(opts.sheetRows || 10000000, rows.length);
    var range /*:Range*/  = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: or_R,
            c: or_C
        }
    };
    if (ws["!ref"]) {
        var _range /*:Range*/  = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
        range.s.r = Math.min(range.s.r, _range.s.r);
        range.s.c = Math.min(range.s.c, _range.s.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        range.e.c = Math.max(range.e.c, _range.e.c);
        if (or_R == -1) range.e.r = or_R = _range.e.r + 1;
    }
    var merges /*:Array<Range>*/  = [], midx = 0;
    var rowinfo /*:Array<RowInfo>*/  = ws["!rows"] || (ws["!rows"] = []);
    var _R = 0, R = 0, _C = 0, C = 0, RS = 0, CS = 0;
    if (!ws["!cols"]) ws['!cols'] = [];
    for(; _R < rows.length && R < sheetRows; ++_R){
        var row /*:HTMLTableRowElement*/  = rows[_R];
        if ($a1a91b25d7598376$var$is_dom_element_hidden(row)) {
            if (opts.display) continue;
            rowinfo[R] = {
                hidden: true
            };
        }
        var elts /*:HTMLCollection<HTMLTableCellElement>*/  = row.cells;
        for(_C = C = 0; _C < elts.length; ++_C){
            var elt /*:HTMLTableCellElement*/  = elts[_C];
            if (opts.display && $a1a91b25d7598376$var$is_dom_element_hidden(elt)) continue;
            var v /*:?string*/  = elt.hasAttribute('data-v') ? elt.getAttribute('data-v') : elt.hasAttribute('v') ? elt.getAttribute('v') : $a1a91b25d7598376$var$htmldecode(elt.innerHTML);
            var z /*:?string*/  = elt.getAttribute('data-z') || elt.getAttribute('z');
            for(midx = 0; midx < merges.length; ++midx){
                var m /*:Range*/  = merges[midx];
                if (m.s.c == C + or_C && m.s.r < R + or_R && R + or_R <= m.e.r) {
                    C = m.e.c + 1 - or_C;
                    midx = -1;
                }
            }
            /* TODO: figure out how to extract nonstandard mso- style */ CS = +elt.getAttribute("colspan") || 1;
            if ((RS = +elt.getAttribute("rowspan") || 1) > 1 || CS > 1) merges.push({
                s: {
                    r: R + or_R,
                    c: C + or_C
                },
                e: {
                    r: R + or_R + (RS || 1) - 1,
                    c: C + or_C + (CS || 1) - 1
                }
            });
            var o /*:Cell*/  = {
                t: 's',
                v: v
            };
            var _t /*:string*/  = elt.getAttribute("data-t") || elt.getAttribute("t") || "";
            if (v != null) {
                if (v.length == 0) o.t = _t || 'z';
                else if (opts.raw || v.trim().length == 0 || _t == "s") ;
                else if (_t == "e" && $a1a91b25d7598376$var$BErr[+v]) o = {
                    t: 'e',
                    v: +v,
                    w: $a1a91b25d7598376$var$BErr[+v]
                };
                else if (v === 'TRUE') o = {
                    t: 'b',
                    v: true
                };
                else if (v === 'FALSE') o = {
                    t: 'b',
                    v: false
                };
                else if (!isNaN($a1a91b25d7598376$var$fuzzynum(v))) o = {
                    t: 'n',
                    v: $a1a91b25d7598376$var$fuzzynum(v)
                };
                else if (!isNaN($a1a91b25d7598376$var$fuzzydate(v).getDate())) {
                    o = {
                        t: 'd',
                        v: $a1a91b25d7598376$var$parseDate(v)
                    } /*:any*/ ;
                    if (opts.UTC) o.v = $a1a91b25d7598376$var$local_to_utc(o.v);
                    if (!opts.cellDates) o = {
                        t: 'n',
                        v: $a1a91b25d7598376$var$datenum(o.v)
                    } /*:any*/ ;
                    o.z = opts.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                } else if (v.charCodeAt(0) == 35 /* # */  && $a1a91b25d7598376$var$RBErr[v] != null) o = {
                    t: 'e',
                    v: $a1a91b25d7598376$var$RBErr[v],
                    w: v
                };
            }
            if (o.z === undefined && z != null) o.z = z;
            /* The first link is used.  Links are assumed to be fully specified.
			 * TODO: The right way to process relative links is to make a new <a> */ var l = "", Aelts = elt.getElementsByTagName("A");
            if (Aelts && Aelts.length) {
                for(var Aelti = 0; Aelti < Aelts.length; ++Aelti)if (Aelts[Aelti].hasAttribute("href")) {
                    l = Aelts[Aelti].getAttribute("href");
                    if (l.charAt(0) != "#") break;
                }
            }
            if (l && l.charAt(0) != "#" && l.slice(0, 11).toLowerCase() != 'javascript:') o.l = {
                Target: l
            };
            if (dense) {
                if (!ws["!data"][R + or_R]) ws["!data"][R + or_R] = [];
                ws["!data"][R + or_R][C + or_C] = o;
            } else ws[$a1a91b25d7598376$var$encode_cell({
                c: C + or_C,
                r: R + or_R
            })] = o;
            if (range.e.c < C + or_C) range.e.c = C + or_C;
            C += CS;
        }
        ++R;
    }
    if (merges.length) ws['!merges'] = (ws["!merges"] || []).concat(merges);
    range.e.r = Math.max(range.e.r, R - 1 + or_R);
    ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
    if (R >= sheetRows) ws['!fullref'] = $a1a91b25d7598376$var$encode_range((range.e.r = rows.length - _R + R - 1 + or_R, range)); // We can count the real number of rows to parse but we don't to improve the performance
    return ws;
}
function $a1a91b25d7598376$var$parse_dom_table(table /*:HTMLElement*/ , _opts /*:?any*/ ) /*:Worksheet*/ {
    var opts = _opts || {};
    var ws /*:Worksheet*/  = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    return $a1a91b25d7598376$var$sheet_add_dom(ws, table, _opts);
}
function $a1a91b25d7598376$var$table_to_book(table /*:HTMLElement*/ , opts /*:?any*/ ) /*:Workbook*/ {
    var o = $a1a91b25d7598376$var$sheet_to_workbook($a1a91b25d7598376$var$parse_dom_table(table, opts), opts);
    //o.bookType = "dom"; // TODO: define a type for this
    return o;
}
function $a1a91b25d7598376$var$is_dom_element_hidden(element /*:HTMLElement*/ ) /*:boolean*/ {
    var display /*:string*/  = '';
    var get_computed_style /*:?function*/  = $a1a91b25d7598376$var$get_get_computed_style_function(element);
    if (get_computed_style) display = get_computed_style(element).getPropertyValue('display');
    if (!display) display = element.style && element.style.display;
    return display === 'none';
}
/* global getComputedStyle */ function $a1a91b25d7598376$var$get_get_computed_style_function(element /*:HTMLElement*/ ) /*:?function*/ {
    // The proper getComputedStyle implementation is the one defined in the element window
    if (element.ownerDocument.defaultView && typeof element.ownerDocument.defaultView.getComputedStyle === 'function') return element.ownerDocument.defaultView.getComputedStyle;
    // If it is not available, try to get one from the global namespace
    if (typeof getComputedStyle === 'function') return getComputedStyle;
    return null;
}
/* OpenDocument */ function $a1a91b25d7598376$var$parse_text_p(text /*:string*/  /*::, tag*/ ) /*:Array<any>*/ {
    /* 6.1.2 White Space Characters */ var fixed = text.replace(/[\t\r\n]/g, " ").trim().replace(/ +/g, " ").replace(/<text:s\/>/g, " ").replace(/<text:s text:c="(\d+)"\/>/g, function($$, $1) {
        return Array(parseInt($1, 10) + 1).join(" ");
    }).replace(/<text:tab[^<>]*\/>/g, "\t").replace(/<text:line-break\/>/g, "\n");
    var v = $a1a91b25d7598376$var$unescapexml(fixed.replace(/<[^<>]*>/g, ""));
    return [
        v
    ];
}
/* Note: ODS can stick styles in content.xml or styles.xml, FODS blurs lines */ function $a1a91b25d7598376$var$parse_ods_styles(d /*:string*/ , _opts, _nfm) {
    var number_format_map = _nfm || {};
    var str = $a1a91b25d7598376$var$xlml_normalize(d);
    $a1a91b25d7598376$var$xlmlregex.lastIndex = 0;
    str = $a1a91b25d7598376$var$remove_doctype($a1a91b25d7598376$var$str_remove_ng(str, "<!--", "-->"));
    var Rn, NFtag, NF = "", tNF = "", y, etpos = 0, tidx = -1, infmt = false, payload = "";
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        /* Number Format Definitions */ case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
        case 'text-style':
            if (Rn[1] === '/') {
                infmt = false;
                if (NFtag['truncate-on-overflow'] == "false") {
                    if (NF.match(/h/)) NF = NF.replace(/h+/, "[$&]");
                    else if (NF.match(/m/)) NF = NF.replace(/m+/, "[$&]");
                    else if (NF.match(/s/)) NF = NF.replace(/s+/, "[$&]");
                }
                number_format_map[NFtag.name] = NF;
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            }
            break;
        // LibreOffice bug https://bugs.documentfoundation.org/show_bug.cgi?id=149484
        case 'boolean-style':
            if (Rn[1] === '/') {
                infmt = false;
                number_format_map[NFtag.name] = "General";
                NF = "";
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                infmt = true;
                NF = "";
                NFtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            }
            break;
        /* Number Format Elements */ case 'boolean':
            NF += "General"; // ODF spec is unfortunately underspecified here
            break;
        case 'text':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                if (payload == "%" && NFtag[0] == '<number:percentage-style') NF += "%";
                else NF += '"' + payload.replace(/"/g, '""') + '"';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
            break;
        case 'day':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "d";
                    break;
                case "long":
                    NF += "dd";
                    break;
                default:
                    NF += "dd";
                    break; // TODO: error condition
            }
            break;
        case 'day-of-week':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ddd";
                    break;
                case "long":
                    NF += "dddd";
                    break;
                default:
                    NF += "ddd";
                    break;
            }
            break;
        case 'era':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "ee";
                    break;
                case "long":
                    NF += "eeee";
                    break;
                default:
                    NF += "eeee";
                    break; // TODO: error condition
            }
            break;
        case 'hours':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "h";
                    break;
                case "long":
                    NF += "hh";
                    break;
                default:
                    NF += "hh";
                    break; // TODO: error condition
            }
            break;
        case 'minutes':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "mm";
                    break; // TODO: error condition
            }
            break;
        case 'month':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (y["textual"]) NF += "mm";
            switch(y["style"]){
                case "short":
                    NF += "m";
                    break;
                case "long":
                    NF += "mm";
                    break;
                default:
                    NF += "m";
                    break;
            }
            break;
        case 'seconds':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "s";
                    break;
                case "long":
                    NF += "ss";
                    break;
                default:
                    NF += "ss";
                    break; // TODO: error condition
            }
            if (y["decimal-places"]) NF += "." + $a1a91b25d7598376$var$fill("0", +y["decimal-places"]);
            break;
        case 'year':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(y["style"]){
                case "short":
                    NF += "yy";
                    break;
                case "long":
                    NF += "yyyy";
                    break;
                default:
                    NF += "yy";
                    break; // TODO: error condition
            }
            break;
        case 'am-pm':
            NF += "AM/PM"; // LO autocorrects A/P -> AM/PM
            break;
        case 'week-of-year':
        case 'quarter':
            console.error("Excel does not support ODS format token " + Rn[3]);
            break;
        case 'fill-character':
            if (Rn[1] === '/') {
                payload = str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length);
                // NOTE: Excel has a different interpretation of "%%" and friends
                NF += '"' + payload.replace(/"/g, '""') + '"*';
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
            break;
        case 'scientific-number':
            // TODO: find a mapping for all parameters
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            NF += "0." + $a1a91b25d7598376$var$fill("0", +y["min-decimal-places"] || +y["decimal-places"] || 2) + $a1a91b25d7598376$var$fill("?", +y["decimal-places"] - +y["min-decimal-places"] || 0) + "E" + ($a1a91b25d7598376$var$parsexmlbool(y["forced-exponent-sign"]) ? "+" : "") + $a1a91b25d7598376$var$fill("0", +y["min-exponent-digits"] || 2);
            break;
        case 'fraction':
            // TODO: find a mapping for all parameters
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (!+y["min-integer-digits"]) NF += "#";
            else NF += $a1a91b25d7598376$var$fill("0", +y["min-integer-digits"]);
            NF += " ";
            NF += $a1a91b25d7598376$var$fill("?", +y["min-numerator-digits"] || 1);
            NF += "/";
            if (+y["denominator-value"]) NF += y["denominator-value"];
            else NF += $a1a91b25d7598376$var$fill("?", +y["min-denominator-digits"] || 1);
            break;
        case 'currency-symbol':
            // TODO: localization with [$-...]
            if (Rn[1] === '/') NF += '"' + str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
            else if (Rn[0].charAt(Rn[0].length - 2) !== '/') tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
            else NF += "$";
            break;
        case 'text-properties':
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch((y["color"] || "").toLowerCase().replace("#", "")){
                case "ff0000":
                case "red":
                    NF = "[Red]" + NF;
                    break;
            }
            break;
        case 'text-content':
            NF += "@";
            break;
        case 'map':
            // TODO: handle more complex maps
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if ($a1a91b25d7598376$var$unescapexml(y["condition"]) == "value()>=0") NF = number_format_map[y["apply-style-name"]] + ";" + NF;
            else console.error("ODS number format may be incorrect: " + y["condition"]);
            break;
        case 'number':
            // TODO: handle all the attributes
            if (Rn[1] === '/') break;
            y = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            tNF = "";
            tNF += $a1a91b25d7598376$var$fill("0", +y["min-integer-digits"] || 1);
            if ($a1a91b25d7598376$var$parsexmlbool(y["grouping"])) tNF = $a1a91b25d7598376$var$commaify($a1a91b25d7598376$var$fill("#", Math.max(0, 4 - tNF.length)) + tNF);
            if (+y["min-decimal-places"] || +y["decimal-places"]) tNF += ".";
            if (+y["min-decimal-places"]) tNF += $a1a91b25d7598376$var$fill("0", +y["min-decimal-places"] || 1);
            if (+y["decimal-places"] - (+y["min-decimal-places"] || 0)) tNF += $a1a91b25d7598376$var$fill("0", +y["decimal-places"] - (+y["min-decimal-places"] || 0)); // TODO: should this be "#" ?
            NF += tNF;
            break;
        case 'embedded-text':
            // TODO: verify interplay with grouping et al
            if (Rn[1] === '/') {
                if (etpos == 0) NF += '"' + str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"';
                else NF = NF.slice(0, etpos) + '"' + str.slice(tidx, $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length).replace(/"/g, '""') + '"' + NF.slice(etpos);
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                tidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
                etpos = -+$a1a91b25d7598376$var$parsexmltag(Rn[0], false)["position"] || 0;
            }
            break;
    }
    return number_format_map;
}
function $a1a91b25d7598376$var$parse_content_xml(d /*:string*/ , _opts, _nfm) /*:Workbook*/ {
    var opts = _opts || {};
    if ($a1a91b25d7598376$var$DENSE != null && opts.dense == null) opts.dense = $a1a91b25d7598376$var$DENSE;
    var str = $a1a91b25d7598376$var$xlml_normalize(d);
    var state /*:Array<any>*/  = [], tmp;
    var tag /*:: = {}*/ ;
    var nfidx, NF = "", pidx = 0;
    var sheetag /*:: = {name:"", '名称':""}*/ ;
    var rowtag /*:: = {'行号':""}*/ ;
    var Sheets = {}, SheetNames /*:Array<string>*/  = [];
    var ws = {} /*:any*/ ;
    if (opts.dense) ws["!data"] = [];
    var Rn, q /*:: :any = ({t:"", v:null, z:null, w:"",c:[],}:any)*/ ;
    var ctag = {
        value: ""
    } /*:any*/ , ctag2 = {} /*:any*/ ;
    var textp = "", textpidx = 0, textptag /*:: = {}*/ , oldtextp = "", oldtextpidx = 0;
    var textR = [], oldtextR = [];
    var R = -1, C = -1, range = {
        s: {
            r: 1000000,
            c: 10000000
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var row_ol = 0;
    var number_format_map = _nfm || {}, styles = {};
    var merges /*:Array<Range>*/  = [], mrange = {}, mR = 0, mC = 0;
    var rowinfo /*:Array<RowInfo>*/  = [], rowpeat = 1, colpeat = 1;
    var arrayf /*:Array<[Range, string]>*/  = [];
    var WB = {
        Names: [],
        WBProps: {}
    };
    var atag = {} /*:any*/ ;
    var _Ref /*:[string, string]*/  = [
        "",
        ""
    ];
    var comments /*:Array<Comment>*/  = [], comment /*:Comment*/  = {} /*:any*/ ;
    var creator = "", creatoridx = 0;
    var isstub = false, intable = false;
    var i = 0;
    $a1a91b25d7598376$var$xlmlregex.lastIndex = 0;
    str = $a1a91b25d7598376$var$remove_doctype($a1a91b25d7598376$var$str_remove_ng(str, "<!--", "-->"));
    while(Rn = $a1a91b25d7598376$var$xlmlregex.exec(str))switch(Rn[3] = Rn[3].replace(/_[\s\S]*$/, "")){
        case 'table':
        case "\u5DE5\u4F5C\u8868":
            if (Rn[1] === '/') {
                if (range.e.c >= range.s.c && range.e.r >= range.s.r) ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
                else ws['!ref'] = "A1:A1";
                if (opts.sheetRows > 0 && opts.sheetRows <= range.e.r) {
                    ws['!fullref'] = ws['!ref'];
                    range.e.r = opts.sheetRows - 1;
                    ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
                }
                if (merges.length) ws['!merges'] = merges;
                if (rowinfo.length) ws["!rows"] = rowinfo;
                sheetag.name = sheetag["\u540D\u79F0"] || sheetag.name;
                if (typeof JSON !== 'undefined') JSON.stringify(sheetag);
                SheetNames.push(sheetag.name);
                Sheets[sheetag.name] = ws;
                intable = false;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                sheetag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                R = C = -1;
                range.s.r = range.s.c = 10000000;
                range.e.r = range.e.c = 0;
                ws = {} /*:any*/ ;
                if (opts.dense) ws["!data"] = [];
                merges = [];
                rowinfo = [];
                intable = true;
            }
            break;
        case 'table-row-group':
            if (Rn[1] === "/") --row_ol;
            else ++row_ol;
            break;
        case 'table-row':
        case "\u884C":
            if (Rn[1] === '/') {
                R += rowpeat;
                rowpeat = 1;
                break;
            }
            rowtag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (rowtag["\u884C\u53F7"]) R = rowtag["\u884C\u53F7"] - 1;
            else if (R == -1) R = 0;
            rowpeat = +rowtag['number-rows-repeated'] || 1;
            /* TODO: remove magic */ if (rowpeat < 10) {
                for(i = 0; i < rowpeat; ++i)if (row_ol > 0) rowinfo[R + i] = {
                    level: row_ol
                };
            }
            C = -1;
            break;
        case 'covered-table-cell':
            if (Rn[1] !== '/') {
                ++C;
                ctag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                if (opts.sheetStubs) {
                    while(colpeat-- > 0){
                        if (opts.dense) {
                            if (!ws["!data"][R]) ws["!data"][R] = [];
                            ws["!data"][R][C] = {
                                t: 'z'
                            };
                        } else ws[$a1a91b25d7598376$var$encode_cell({
                            r: R,
                            c: C
                        })] = {
                            t: 'z'
                        };
                        ++C;
                    }
                    --C;
                } else C += colpeat - 1;
            }
            textp = "";
            textR = [];
            break; /* stub */ 
        case 'table-cell':
        case "\u6570\u636E":
            if (Rn[0].charAt(Rn[0].length - 2) === '/') {
                ++C;
                ctag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10) || 1;
                q = {
                    t: 'z',
                    v: null
                } /*:any*/ ;
                if (ctag.formula && opts.cellFormula != false) q.f = $a1a91b25d7598376$var$ods_to_csf_formula($a1a91b25d7598376$var$unescapexml(ctag.formula));
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if ((ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type']) == "string") {
                    q.t = "s";
                    q.v = $a1a91b25d7598376$var$unescapexml(ctag['string-value'] || "");
                    if (opts.dense) {
                        if (!ws["!data"][R]) ws["!data"][R] = [];
                        ws["!data"][R][C] = q;
                    } else ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)] = q;
                }
                C += colpeat - 1;
            } else if (Rn[1] !== '/') {
                ++C;
                textp = oldtextp = "";
                textpidx = oldtextpidx = 0;
                textR = [];
                oldtextR = [];
                colpeat = 1;
                var rptR = rowpeat ? R + rowpeat - 1 : R;
                if (C > range.e.c) range.e.c = C;
                if (C < range.s.c) range.s.c = C;
                if (R < range.s.r) range.s.r = R;
                if (rptR > range.e.r) range.e.r = rptR;
                ctag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                ctag2 = $a1a91b25d7598376$var$parsexmltagraw(Rn[0], true);
                comments = [];
                comment = {} /*:any*/ ;
                q = {
                    t: ctag["\u6570\u636E\u7C7B\u578B"] || ctag['value-type'],
                    v: null
                } /*:any*/ ;
                if (ctag["style-name"] && styles[ctag["style-name"]]) q.z = styles[ctag["style-name"]];
                if (opts.cellFormula) {
                    if (ctag.formula) ctag.formula = $a1a91b25d7598376$var$unescapexml(ctag.formula);
                    if (ctag['number-matrix-columns-spanned'] && ctag['number-matrix-rows-spanned']) {
                        mR = parseInt(ctag['number-matrix-rows-spanned'], 10) || 0;
                        mC = parseInt(ctag['number-matrix-columns-spanned'], 10) || 0;
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        q.F = $a1a91b25d7598376$var$encode_range(mrange);
                        arrayf.push([
                            mrange,
                            q.F
                        ]);
                    }
                    if (ctag.formula) q.f = $a1a91b25d7598376$var$ods_to_csf_formula(ctag.formula);
                    else for(i = 0; i < arrayf.length; ++i)if (R >= arrayf[i][0].s.r && R <= arrayf[i][0].e.r) {
                        if (C >= arrayf[i][0].s.c && C <= arrayf[i][0].e.c) q.F = arrayf[i][1];
                    }
                }
                if (ctag['number-columns-spanned'] || ctag['number-rows-spanned']) {
                    mR = parseInt(ctag['number-rows-spanned'] || "1", 10) || 1;
                    mC = parseInt(ctag['number-columns-spanned'] || "1", 10) || 1;
                    if (mR * mC > 1) {
                        mrange = {
                            s: {
                                r: R,
                                c: C
                            },
                            e: {
                                r: R + mR - 1,
                                c: C + mC - 1
                            }
                        };
                        merges.push(mrange);
                    }
                }
                /* 19.675.2 table:number-columns-repeated */ if (ctag['number-columns-repeated']) colpeat = parseInt(ctag['number-columns-repeated'], 10);
                /* 19.385 office:value-type TODO: verify ODS and UOS */ switch(q.t){
                    case 'boolean':
                        q.t = 'b';
                        q.v = $a1a91b25d7598376$var$parsexmlbool(ctag['boolean-value']) || +ctag['boolean-value'] >= 1;
                        break;
                    case 'float':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        if (opts.cellDates && q.z && $a1a91b25d7598376$var$fmt_is_date(q.z)) {
                            q.v = $a1a91b25d7598376$var$numdate(q.v + (WB.WBProps.date1904 ? 1462 : 0));
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        break;
                    case 'percentage':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'currency':
                        q.t = 'n';
                        q.v = parseFloat(ctag.value);
                        break;
                    case 'date':
                        q.t = 'd';
                        q.v = $a1a91b25d7598376$var$parseDate(ctag['date-value'], WB.WBProps.date1904);
                        if (!opts.cellDates) {
                            q.t = 'n';
                            q.v = $a1a91b25d7598376$var$datenum(q.v, WB.WBProps.date1904);
                        }
                        if (!q.z) q.z = 'm/d/yy';
                        break;
                    /* NOTE: for `time`, Excel ODS export incorrectly uses durations relative to 1900 epoch even if 1904 is specified */ case 'time':
                        q.t = 'n';
                        q.v = $a1a91b25d7598376$var$parse_isodur(ctag['time-value']) / 86400;
                        if (opts.cellDates) {
                            q.v = $a1a91b25d7598376$var$numdate(q.v);
                            q.t = typeof q.v == "number" ? 'n' : 'd';
                        }
                        if (!q.z) q.z = 'HH:MM:SS';
                        break;
                    case 'number':
                        q.t = 'n';
                        q.v = parseFloat(ctag["\u6570\u636E\u6570\u503C"]);
                        break;
                    default:
                        if (q.t === 'string' || q.t === 'text' || !q.t) {
                            q.t = 's';
                            if (ctag['string-value'] != null) {
                                textp = $a1a91b25d7598376$var$unescapexml(ctag['string-value']);
                                textR = [];
                            }
                        } else throw new Error('Unsupported value type ' + q.t);
                }
            } else {
                isstub = false;
                if (ctag2['calcext:value-type'] == "error" && $a1a91b25d7598376$var$RBErr[textp] != null) {
                    q.t = 'e';
                    q.w = textp;
                    q.v = $a1a91b25d7598376$var$RBErr[textp];
                }
                if (q.t === 's') {
                    q.v = textp || '';
                    if (textR.length) q.R = textR;
                    isstub = textpidx == 0;
                }
                if (atag.Target) q.l = atag;
                if (comments.length > 0) {
                    q.c = comments;
                    comments = [];
                }
                if (textp && opts.cellText !== false) q.w = textp;
                if (isstub) {
                    q.t = "z";
                    delete q.v;
                }
                if (!isstub || opts.sheetStubs) {
                    if (!(opts.sheetRows && opts.sheetRows <= R)) for(var rpt = 0; rpt < rowpeat; ++rpt){
                        colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                        if (opts.dense) {
                            if (!ws["!data"][R + rpt]) ws["!data"][R + rpt] = [];
                            ws["!data"][R + rpt][C] = rpt == 0 ? q : $a1a91b25d7598376$var$dup(q);
                            while(--colpeat > 0)ws["!data"][R + rpt][C + colpeat] = $a1a91b25d7598376$var$dup(q);
                        } else {
                            ws[$a1a91b25d7598376$var$encode_cell({
                                r: R + rpt,
                                c: C
                            })] = q;
                            while(--colpeat > 0)ws[$a1a91b25d7598376$var$encode_cell({
                                r: R + rpt,
                                c: C + colpeat
                            })] = $a1a91b25d7598376$var$dup(q);
                        }
                        if (range.e.c <= C) range.e.c = C;
                    }
                }
                colpeat = parseInt(ctag['number-columns-repeated'] || "1", 10);
                C += colpeat - 1;
                colpeat = 0;
                q = {};
                textp = "";
                textR = [];
            }
            atag = {} /*:any*/ ;
            break; // 9.1.4 <table:table-cell>
        /* pure state */ case 'document':
        case 'document-content':
        case "\u7535\u5B50\u8868\u683C\u6587\u6863":
        case 'spreadsheet':
        case "\u4E3B\u4F53":
        case 'scripts':
        case 'styles':
        case 'font-face-decls':
        case 'master-styles':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                true
            ]);
            break;
        case 'annotation':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
                comment.t = textp;
                if (textR.length) /*::(*/ comment /*:: :any)*/ .R = textR;
                comment.a = creator;
                comments.push(comment);
                textp = oldtextp;
                textpidx = oldtextpidx;
                textR = oldtextR;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') {
                state.push([
                    Rn[3],
                    false
                ]);
                var annotag = $a1a91b25d7598376$var$parsexmltag(Rn[0], true);
                /* office:display TODO: check if there is a global override */ if (!(annotag["display"] && $a1a91b25d7598376$var$parsexmlbool(annotag["display"]))) comments.hidden = true;
                oldtextp = textp;
                oldtextpidx = textpidx;
                oldtextR = textR;
                textp = "";
                textpidx = 0;
                textR = [];
            }
            creator = "";
            creatoridx = 0;
            break;
        case 'creator':
            if (Rn[1] === '/') creator = str.slice(creatoridx, Rn.index);
            else creatoridx = Rn.index + Rn[0].length;
            break;
        /* ignore state */ case 'meta':
        case "\u5143\u6570\u636E":
        case 'settings':
        case 'config-item-set':
        case 'config-item-map-indexed':
        case 'config-item-map-entry':
        case 'config-item-map-named':
        case 'shapes':
        case 'frame':
        case 'text-box':
        case 'image':
        case 'data-pilot-tables':
        case 'list-style':
        case 'form':
        case 'dde-links':
        case 'event-listeners':
        case 'chart':
            if (Rn[1] === '/') {
                if ((tmp = state.pop())[0] !== Rn[3]) throw "Bad state: " + tmp;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') state.push([
                Rn[3],
                false
            ]);
            textp = "";
            textpidx = 0;
            textR = [];
            break;
        case 'scientific-number':
        case 'currency-symbol':
        case 'fill-character':
            break;
        case 'text-style':
        case 'boolean-style':
        case 'number-style':
        case 'currency-style':
        case 'percentage-style':
        case 'date-style':
        case 'time-style':
            if (Rn[1] === '/') {
                var xlmlidx = $a1a91b25d7598376$var$xlmlregex.lastIndex;
                $a1a91b25d7598376$var$parse_ods_styles(str.slice(nfidx, $a1a91b25d7598376$var$xlmlregex.lastIndex), _opts, number_format_map);
                $a1a91b25d7598376$var$xlmlregex.lastIndex = xlmlidx;
            } else if (Rn[0].charAt(Rn[0].length - 2) !== '/') nfidx = $a1a91b25d7598376$var$xlmlregex.lastIndex - Rn[0].length;
            break;
        case 'script':
            break; // 3.13 <office:script>
        case 'libraries':
            break; // TODO: <ooo:libraries>
        case 'automatic-styles':
            break; // 3.15.3 <office:automatic-styles>
        case 'default-style':
        case 'page-layout':
            break; // TODO: <style:page-layout>
        case 'style':
            var styletag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            if (styletag["family"] == "table-cell" && number_format_map[styletag["data-style-name"]]) styles[styletag["name"]] = number_format_map[styletag["data-style-name"]];
            break;
        case 'map':
            break; // 16.3 <style:map>
        case 'font-face':
            break; // 16.21 <style:font-face>
        case 'paragraph-properties':
            break; // 17.6 <style:paragraph-properties>
        case 'table-properties':
            break; // 17.15 <style:table-properties>
        case 'table-column-properties':
            break; // 17.16 <style:table-column-properties>
        case 'table-row-properties':
            break; // 17.17 <style:table-row-properties>
        case 'table-cell-properties':
            break; // 17.18 <style:table-cell-properties>
        case 'number':
            break;
        case 'fraction':
            break; // TODO 16.27.6 <number:fraction>
        case 'day':
        case 'month':
        case 'year':
        case 'era':
        case 'day-of-week':
        case 'week-of-year':
        case 'quarter':
        case 'hours':
        case 'minutes':
        case 'seconds':
        case 'am-pm':
            break;
        case 'boolean':
            break; // 16.27.24 <number:boolean>
        case 'text':
            if (Rn[0].slice(-2) === "/>") break;
            else if (Rn[1] === "/") switch(state[state.length - 1][0]){
                case 'number-style':
                case 'date-style':
                case 'time-style':
                    NF += str.slice(pidx, Rn.index);
                    break;
            }
            else pidx = Rn.index + Rn[0].length;
            break;
        case 'named-range':
            tag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            _Ref = $a1a91b25d7598376$var$ods_to_csf_3D(tag['cell-range-address']);
            var nrange = {
                Name: tag.name,
                Ref: _Ref[0] + '!' + _Ref[1]
            } /*:any*/ ;
            if (intable) nrange.Sheet = SheetNames.length;
            WB.Names.push(nrange);
            break;
        case 'text-content':
            break; // 16.27.27 <number:text-content>
        case 'text-properties':
            break; // 16.27.27 <style:text-properties>
        case 'embedded-text':
            break; // 16.27.4 <number:embedded-text>
        case 'body':
        case "\u7535\u5B50\u8868\u683C":
            break; // 3.3 16.9.6 19.726.3
        case 'forms':
            break; // 12.25.2 13.2
        case 'table-column':
            break; // 9.1.6 <table:table-column>
        case 'table-header-rows':
            break; // 9.1.7 <table:table-header-rows>
        case 'table-rows':
            break; // 9.1.12 <table:table-rows>
        /* TODO: outline levels */ case 'table-column-group':
            break; // 9.1.10 <table:table-column-group>
        case 'table-header-columns':
            break; // 9.1.11 <table:table-header-columns>
        case 'table-columns':
            break; // 9.1.12 <table:table-columns>
        case 'null-date':
            tag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
            switch(tag["date-value"]){
                case "1904-01-01":
                    WB.WBProps.date1904 = true;
                    break;
            }
            break;
        case 'graphic-properties':
            break; // 17.21 <style:graphic-properties>
        case 'calculation-settings':
            break; // 9.4.1 <table:calculation-settings>
        case 'named-expressions':
            break; // 9.4.11 <table:named-expressions>
        case 'label-range':
            break; // 9.4.9 <table:label-range>
        case 'label-ranges':
            break; // 9.4.10 <table:label-ranges>
        case 'named-expression':
            break; // 9.4.13 <table:named-expression>
        case 'sort':
            break; // 9.4.19 <table:sort>
        case 'sort-by':
            break; // 9.4.20 <table:sort-by>
        case 'sort-groups':
            break; // 9.4.22 <table:sort-groups>
        case 'tab':
            break; // 6.1.4 <text:tab>
        case 'line-break':
            break; // 6.1.5 <text:line-break>
        case 'span':
            break; // 6.1.7 <text:span>
        case 'p':
        case "\u6587\u672C\u4E32":
            if ([
                'master-styles'
            ].indexOf(state[state.length - 1][0]) > -1) break;
            if (Rn[1] === '/' && (!ctag || !ctag['string-value'])) {
                var ptp = $a1a91b25d7598376$var$parse_text_p(str.slice(textpidx, Rn.index), textptag);
                textp = (textp.length > 0 ? textp + "\n" : "") + ptp[0];
            } else if (Rn[0].slice(-2) == "/>") /* TODO: is self-closing 文本串 valid? */ textp += "\n";
            else {
                textptag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                textpidx = Rn.index + Rn[0].length;
            }
            break; // <text:p>
        case 's':
            break; // <text:s>
        case 'database-range':
            if (Rn[1] === '/') break;
            try {
                _Ref = $a1a91b25d7598376$var$ods_to_csf_3D($a1a91b25d7598376$var$parsexmltag(Rn[0])['target-range-address']);
                Sheets[_Ref[0]]['!autofilter'] = {
                    ref: _Ref[1]
                };
            } catch (e) {}
            break;
        case 'date':
            break; // <*:date>
        case 'object':
            break; // 10.4.6.2 <draw:object>
        case 'title':
        case "\u6807\u9898":
            break; // <*:title> OR <uof:标题>
        case 'desc':
            break; // <*:desc>
        case 'binary-data':
            break; // 10.4.5 TODO: b64 blob
        /* 9.2 Advanced Tables */ case 'table-source':
            break; // 9.2.6
        case 'scenario':
            break; // 9.2.6
        case 'iteration':
            break; // 9.4.3 <table:iteration>
        case 'content-validations':
            break; // 9.4.4 <table:
        case 'content-validation':
            break; // 9.4.5 <table:
        case 'help-message':
            break; // 9.4.6 <table:
        case 'error-message':
            break; // 9.4.7 <table:
        case 'database-ranges':
            break; // 9.4.14 <table:database-ranges>
        /* 9.5 Filters */ case 'filter':
            break; // 9.5.2 <table:filter>
        case 'filter-and':
            break; // 9.5.3 <table:filter-and>
        case 'filter-or':
            break; // 9.5.4 <table:filter-or>
        case 'filter-condition':
            break; // 9.5.5 <table:filter-condition>
        case 'filter-set-item':
            break; // 9.5.6 <table:filter-condition>
        case 'list-level-style-bullet':
            break; // 16.31 <text:
        case 'list-level-style-number':
            break; // 16.32 <text:
        case 'list-level-properties':
            break; // 17.19 <style:
        /* 7.3 Document Fields */ case 'sender-firstname':
        case 'sender-lastname':
        case 'sender-initials':
        case 'sender-title':
        case 'sender-position':
        case 'sender-email':
        case 'sender-phone-private':
        case 'sender-fax':
        case 'sender-company':
        case 'sender-phone-work':
        case 'sender-street':
        case 'sender-city':
        case 'sender-postal-code':
        case 'sender-country':
        case 'sender-state-or-province':
        case 'author-name':
        case 'author-initials':
        case 'chapter':
        case 'file-name':
        case 'template-name':
        case 'sheet-name':
            break;
        case 'event-listener':
            break;
        /* TODO: FODS Properties */ case 'initial-creator':
        case 'creation-date':
        case 'print-date':
        case 'generator':
        case 'document-statistic':
        case 'user-defined':
        case 'editing-duration':
        case 'editing-cycles':
            break;
        /* TODO: FODS Config */ case 'config-item':
            break;
        /* TODO: style tokens */ case 'page-number':
            break; // TODO <text:page-number>
        case 'page-count':
            break; // TODO <text:page-count>
        case 'time':
            break; // TODO <text:time>
        /* 9.3 Advanced Table Cells */ case 'cell-range-source':
            break; // 9.3.1 <table:
        case 'detective':
            break; // 9.3.2 <table:
        case 'operation':
            break; // 9.3.3 <table:
        case 'highlighted-range':
            break; // 9.3.4 <table:
        /* 9.6 Data Pilot Tables <table: */ case 'data-pilot-table':
        case 'source-cell-range':
        case 'source-service':
        case 'data-pilot-field':
        case 'data-pilot-level':
        case 'data-pilot-subtotals':
        case 'data-pilot-subtotal':
        case 'data-pilot-members':
        case 'data-pilot-member':
        case 'data-pilot-display-info':
        case 'data-pilot-sort-info':
        case 'data-pilot-layout-info':
        case 'data-pilot-field-reference':
        case 'data-pilot-groups':
        case 'data-pilot-group':
        case 'data-pilot-group-member':
            break;
        /* 10.3 Drawing Shapes */ case 'rect':
            break;
        /* 14.6 DDE Connections */ case 'dde-connection-decls':
        case 'dde-connection-decl':
        case 'dde-link':
        case 'dde-source':
            break;
        case 'properties':
            break; // 13.7 <form:properties>
        case 'property':
            break; // 13.8 <form:property>
        case 'a':
            if (Rn[1] !== '/') {
                atag = $a1a91b25d7598376$var$parsexmltag(Rn[0], false);
                if (!atag.href) break;
                atag.Target = $a1a91b25d7598376$var$unescapexml(atag.href);
                delete atag.href;
                if (atag.Target.charAt(0) == "#" && atag.Target.indexOf(".") > -1) {
                    _Ref = $a1a91b25d7598376$var$ods_to_csf_3D(atag.Target.slice(1));
                    atag.Target = "#" + _Ref[0] + "!" + _Ref[1];
                } else if (atag.Target.match(/^\.\.[\\\/]/)) atag.Target = atag.Target.slice(3);
            }
            break;
        /* non-standard */ case 'table-protection':
            break;
        case 'data-pilot-grand-total':
            break; // <table:
        case 'office-document-common-attrs':
            break; // bare
        default:
            switch(Rn[2]){
                case 'dc:':
                case 'calcext:':
                case 'loext:':
                case 'ooo:':
                case 'chartooo:':
                case 'draw:':
                case 'style:':
                case 'chart:':
                case 'form:':
                case 'uof:':
                case "\u8868:":
                case "\u5B57:":
                    break;
                default:
                    if (opts.WTF) throw new Error(Rn);
            }
    }
    var out /*:Workbook*/  = {
        Sheets: Sheets,
        SheetNames: SheetNames,
        Workbook: WB
    } /*:any*/ ;
    if (opts.bookSheets) delete /*::(*/ out /*:: :any)*/ .Sheets;
    return out;
}
function $a1a91b25d7598376$var$parse_ods(zip /*:ZIPFile*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    opts = opts || {} /*:any*/ ;
    if ($a1a91b25d7598376$var$safegetzipfile(zip, 'META-INF/manifest.xml')) $a1a91b25d7598376$var$parse_manifest($a1a91b25d7598376$var$getzipdata(zip, 'META-INF/manifest.xml'), opts);
    var styles = $a1a91b25d7598376$var$getzipstr(zip, 'styles.xml');
    var Styles = styles && $a1a91b25d7598376$var$parse_ods_styles($a1a91b25d7598376$var$utf8read(styles), opts);
    var content = $a1a91b25d7598376$var$getzipstr(zip, 'content.xml');
    if (!content) throw new Error("Missing content.xml in ODS / UOF file");
    var wb = $a1a91b25d7598376$var$parse_content_xml($a1a91b25d7598376$var$utf8read(content), opts, Styles);
    if ($a1a91b25d7598376$var$safegetzipfile(zip, 'meta.xml')) wb.Props = $a1a91b25d7598376$var$parse_core_props($a1a91b25d7598376$var$getzipdata(zip, 'meta.xml'));
    wb.bookType = "ods";
    return wb;
}
function $a1a91b25d7598376$var$parse_fods(data /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var wb = $a1a91b25d7598376$var$parse_content_xml(data, opts);
    wb.bookType = "fods";
    return wb;
}
/* OpenDocument */ var $a1a91b25d7598376$var$write_styles_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    var master_styles = [
        '<office:master-styles>',
        '<style:master-page style:name="mp1" style:page-layout-name="mp1">',
        '<style:header/>',
        '<style:header-left style:display="false"/>',
        '<style:footer/>',
        '<style:footer-left style:display="false"/>',
        '</style:master-page>',
        '</office:master-styles>'
    ].join("");
    var payload = '<office:document-styles ' + $a1a91b25d7598376$var$wxt_helper({
        'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
        'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
        'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
        'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
        'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
        'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
        'xmlns:xlink': "http://www.w3.org/1999/xlink",
        'xmlns:dc': "http://purl.org/dc/elements/1.1/",
        'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
        'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
        'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
        'office:version': "1.2"
    }) + '>' + master_styles + '</office:document-styles>';
    return function wso() {
        return $a1a91b25d7598376$var$XML_HEADER + payload;
    };
}();
// TODO: find out if anyone actually read the spec.  LO has some wild errors
function $a1a91b25d7598376$var$write_number_format_ods(nf /*:string*/ , nfidx /*:string*/ ) /*:string*/ {
    var type = "number", payload = "", nopts = {
        "style:name": nfidx
    }, c = "", i = 0;
    nf = nf.replace(/"[$]"/g, "$");
    /* TODO: replace with an actual parser based on a real grammar */ j: {
        // TODO: support style maps
        if (nf.indexOf(";") > -1) {
            console.error("Unsupported ODS Style Map exported.  Using first branch of " + nf);
            nf = nf.slice(0, nf.indexOf(";"));
        }
        if (nf == "@") {
            type = "text";
            payload = "<number:text-content/>";
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* opening string literal */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* fractions */ var t = nf.match(/# (\?+)\/(\?+)/);
        if (t) {
            payload += $a1a91b25d7598376$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:max-denominator-value": Math.max(+t[1].replace(/./g, "9"), +t[2].replace(/./g, "9"))
            });
            break j;
        }
        if (t = nf.match(/# (\?+)\/(\d+)/)) {
            payload += $a1a91b25d7598376$var$writextag("number:fraction", null, {
                "number:min-integer-digits": 0,
                "number:min-numerator-digits": t[1].length,
                "number:denominator-value": +t[2]
            });
            break j;
        }
        /* percentages */ if (t = nf.match(/\b(\d+)(|\.\d+)%/)) {
            type = "percentage";
            payload += $a1a91b25d7598376$var$writextag("number:number", null, {
                "number:decimal-places": t[2] && t.length - 1 || 0,
                "number:min-decimal-places": t[2] && t.length - 1 || 0,
                "number:min-integer-digits": t[1].length
            }) + "<number:text>%</number:text>";
            break j;
        }
        /* datetime */ var has_time = false;
        if ([
            "y",
            "m",
            "d"
        ].indexOf(nf[0]) > -1) {
            type = "date";
            k: for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "s":
                    has_time = true;
                    --i;
                    break k;
                case "m":
                    l: for(var h = i + 1; h < nf.length; ++h)switch(nf[h]){
                        case "y":
                        case "d":
                            break l;
                        case "h":
                        case "s":
                            has_time = true;
                            --i;
                            break k;
                    }
                /* falls through */ case "y":
                case "d":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "y":
                        case "yy":
                            payload += "<number:year/>";
                            break;
                        case "yyy":
                        case "yyyy":
                            payload += '<number:year number:style="long"/>';
                            break;
                        case "mmmmm":
                            console.error("ODS has no equivalent of format |mmmmm|");
                        /* falls through */ case "m":
                        case "mm":
                        case "mmm":
                        case "mmmm":
                            payload += '<number:month number:style="' + (c.length % 2 ? "short" : "long") + '" number:textual="' + (c.length >= 3 ? "true" : "false") + '"/>';
                            break;
                        case "d":
                        case "dd":
                            payload += '<number:day number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "ddd":
                        case "dddd":
                            payload += '<number:day-of-week number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '\\':
                    c = nf[++i];
                    payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c) + '</number:text>';
                    break;
                default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            if (!has_time) break j;
            nf = nf.slice(i + 1);
            i = 0;
        }
        if (nf.match(/^\[?[hms]/)) {
            if (type == "number") type = "time";
            if (nf.match(/\[/)) {
                nf = nf.replace(/[\[\]]/g, "");
                nopts['number:truncate-on-overflow'] = "false";
            }
            for(; i < nf.length; ++i)switch(c = nf[i].toLowerCase()){
                case "h":
                case "m":
                case "s":
                    while((nf[++i] || "").toLowerCase() == c[0])c += c[0];
                    --i;
                    switch(c){
                        case "h":
                        case "hh":
                            payload += '<number:hours number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "m":
                        case "mm":
                            payload += '<number:minutes number:style="' + (c.length % 2 ? "short" : "long") + '"/>';
                            break;
                        case "s":
                        case "ss":
                            if (nf[i + 1] == ".") do {
                                c += nf[i + 1];
                                ++i;
                            }while (nf[i + 1] == "0");
                            payload += '<number:seconds number:style="' + (c.match("ss") ? "long" : "short") + '"' + (c.match(/\./) ? ' number:decimal-places="' + (c.match(/0+/) || [
                                ""
                            ])[0].length + '"' : "") + '/>';
                            break;
                    }
                    break;
                case '"':
                    while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
                    --i;
                    payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c.slice(1).replace(/""/g, '"')) + '</number:text>';
                    break;
                case '/':
                case ':':
                    payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c) + '</number:text>';
                    break;
                case "a":
                    if (nf.slice(i, i + 3).toLowerCase() == "a/p") {
                        payload += '<number:am-pm/>';
                        i += 2;
                        break;
                    } // Note: ODF does not support A/P
                    if (nf.slice(i, i + 5).toLowerCase() == "am/pm") {
                        payload += '<number:am-pm/>';
                        i += 4;
                        break;
                    }
                /* falls through */ default:
                    console.error("unrecognized character " + c + " in ODF format " + nf);
            }
            break j;
        }
        /* currency flag */ if (nf.indexOf(/\$/) > -1) type = "currency";
        /* should be in a char loop */ if (nf[0] == "$") {
            payload += '<number:currency-symbol number:language="en" number:country="US">$</number:currency-symbol>';
            nf = nf.slice(1);
            i = 0;
        }
        i = 0;
        if (nf[i] == '"') {
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            if (nf[i + 1] == "*") {
                i++;
                payload += '<number:fill-character>' + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + '</number:fill-character>';
            } else payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
            nf = nf.slice(i + 1);
            i = 0;
        }
        /* number TODO: interstitial text e.g. 000)000-0000 */ var np = nf.match(/([#0][0#,]*)(\.[0#]*|)(E[+]?0*|)/i);
        if (!np || !np[0]) console.error("Could not find numeric part of " + nf);
        else {
            var base = np[1].replace(/,/g, "");
            payload += '<number:' + (np[3] ? "scientific-" : "") + 'number' + ' number:min-integer-digits="' + (base.indexOf("0") == -1 ? "0" : base.length - base.indexOf("0")) + '"' + (np[0].indexOf(",") > -1 ? ' number:grouping="true"' : "") + (np[2] && ' number:decimal-places="' + (np[2].length - 1) + '"' || ' number:decimal-places="0"') + (np[3] && np[3].indexOf("+") > -1 ? ' number:forced-exponent-sign="true"' : "") + (np[3] ? ' number:min-exponent-digits="' + np[3].match(/0+/)[0].length + '"' : "") + '>' + /* TODO: interstitial text placeholders */ '</number:' + (np[3] ? "scientific-" : "") + 'number>';
            i = np.index + np[0].length;
        }
        /* residual text */ if (nf[i] == '"') {
            c = "";
            while(nf[++i] != '"' || nf[++i] == '"')c += nf[i];
            --i;
            payload += '<number:text>' + $a1a91b25d7598376$var$escapexml(c.replace(/""/g, '"')) + '</number:text>';
        }
    }
    if (!payload) {
        console.error("Could not generate ODS number format for |" + nf + "|");
        return "";
    }
    return $a1a91b25d7598376$var$writextag("number:" + type + "-style", payload, nopts);
}
function $a1a91b25d7598376$var$write_names_ods(Names, SheetNames, idx) {
    //var scoped = Names.filter(function(name) { return name.Sheet == (idx == -1 ? null : idx); });
    var scoped = [];
    for(var namei = 0; namei < Names.length; ++namei){
        var name = Names[namei];
        if (!name) continue;
        if (name.Sheet == (idx == -1 ? null : idx)) scoped.push(name);
    }
    if (!scoped.length) return "";
    return "      <table:named-expressions>\n" + scoped.map(function(name) {
        var odsref = (idx == -1 ? "$" : "") + $a1a91b25d7598376$var$csf_to_ods_3D(name.Ref);
        return "        " + $a1a91b25d7598376$var$writextag("table:named-range", null, {
            "table:name": name.Name,
            "table:cell-range-address": odsref,
            "table:base-cell-address": odsref.replace(/[\.][^\.]*$/, ".$A$1")
        });
    }).join("\n") + "\n      </table:named-expressions>\n";
}
var $a1a91b25d7598376$var$write_content_ods /*:{(wb:any, opts:any):string}*/  = /* @__PURE__ */ function() {
    /* 6.1.2 White Space Characters */ var write_text_p = function(text /*:string*/ , span) /*:string*/ {
        return $a1a91b25d7598376$var$escapexml(text).replace(/  +/g, function($$) {
            return '<text:s text:c="' + $$.length + '"/>';
        }).replace(/\t/g, "<text:tab/>").replace(/\n/g, span ? "<text:line-break/>" : "</text:p><text:p>").replace(/^ /, "<text:s/>").replace(/ $/, "<text:s/>");
    };
    var null_cell_xml = '          <table:table-cell />\n';
    var write_ws = function(ws, wb /*:Workbook*/ , i /*:number*/ , opts, nfs, date1904) /*:string*/ {
        /* Section 9 Tables */ var o /*:Array<string>*/  = [];
        o.push('      <table:table table:name="' + $a1a91b25d7598376$var$escapexml(wb.SheetNames[i]) + '" table:style-name="ta1">\n');
        var R = 0, C = 0, range = $a1a91b25d7598376$var$decode_range(ws['!ref'] || "A1");
        var marr /*:Array<Range>*/  = ws['!merges'] || [], mi = 0;
        var dense = ws["!data"] != null;
        if (ws["!cols"]) for(C = 0; C <= range.e.c; ++C)o.push('        <table:table-column' + (ws["!cols"][C] ? ' table:style-name="co' + ws["!cols"][C].ods + '"' : '') + '></table:table-column>\n');
        var H = "", ROWS = ws["!rows"] || [];
        for(R = 0; R < range.s.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '></table:table-row>\n');
        }
        for(; R <= range.e.r; ++R){
            H = ROWS[R] ? ' table:style-name="ro' + ROWS[R].ods + '"' : "";
            o.push('        <table:table-row' + H + '>\n');
            for(C = 0; C < range.s.c; ++C)o.push(null_cell_xml);
            for(; C <= range.e.c; ++C){
                var skip = false, ct = {}, textp = "";
                for(mi = 0; mi != marr.length; ++mi){
                    if (marr[mi].s.c > C) continue;
                    if (marr[mi].s.r > R) continue;
                    if (marr[mi].e.c < C) continue;
                    if (marr[mi].e.r < R) continue;
                    if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                    ct['table:number-columns-spanned'] = marr[mi].e.c - marr[mi].s.c + 1;
                    ct['table:number-rows-spanned'] = marr[mi].e.r - marr[mi].s.r + 1;
                    break;
                }
                if (skip) {
                    o.push('          <table:covered-table-cell/>\n');
                    continue;
                }
                var ref = $a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                }), cell = dense ? (ws["!data"][R] || [])[C] : ws[ref];
                if (cell && cell.f) {
                    ct['table:formula'] = $a1a91b25d7598376$var$escapexml($a1a91b25d7598376$var$csf_to_ods_formula(cell.f));
                    if (cell.F) {
                        if (cell.F.slice(0, ref.length) == ref) {
                            var _Fref = $a1a91b25d7598376$var$decode_range(cell.F);
                            ct['table:number-matrix-columns-spanned'] = _Fref.e.c - _Fref.s.c + 1;
                            ct['table:number-matrix-rows-spanned'] = _Fref.e.r - _Fref.s.r + 1;
                        }
                    }
                }
                if (!cell) {
                    o.push(null_cell_xml);
                    continue;
                }
                switch(cell.t){
                    case 'b':
                        textp = cell.v ? 'TRUE' : 'FALSE';
                        ct['office:value-type'] = "boolean";
                        ct['office:boolean-value'] = cell.v ? 'true' : 'false';
                        break;
                    case 'n':
                        if (!isFinite(cell.v)) {
                            if (isNaN(cell.v)) {
                                textp = "#NUM!";
                                ct['table:formula'] = "of:=#NUM!";
                            } else {
                                textp = "#DIV/0!";
                                ct['table:formula'] = "of:=" + (cell.v < 0 ? "-" : "") + "1/0";
                            }
                            ct['office:string-value'] = "";
                            ct['office:value-type'] = "string";
                            ct['calcext:value-type'] = "error";
                        } else {
                            textp = cell.w || String(cell.v || 0);
                            ct['office:value-type'] = "float";
                            ct['office:value'] = cell.v || 0;
                        }
                        break;
                    case 's':
                    case 'str':
                        textp = cell.v == null ? "" : cell.v;
                        ct['office:value-type'] = "string";
                        break;
                    case 'd':
                        textp = cell.w || $a1a91b25d7598376$var$parseDate(cell.v, date1904).toISOString();
                        ct['office:value-type'] = "date";
                        ct['office:date-value'] = $a1a91b25d7598376$var$parseDate(cell.v, date1904).toISOString();
                        ct['table:style-name'] = "ce1";
                        break;
                    //case 'e': // TODO: translate to ODS errors
                    default:
                        o.push(null_cell_xml);
                        continue; // TODO: empty cell with comments
                }
                var text_p = write_text_p(textp);
                if (cell.l && cell.l.Target) {
                    var _tgt = cell.l.Target;
                    _tgt = _tgt.charAt(0) == "#" ? "#" + $a1a91b25d7598376$var$csf_to_ods_3D(_tgt.slice(1)) : _tgt;
                    // TODO: choose correct parent path format based on link delimiters
                    if (_tgt.charAt(0) != "#" && !_tgt.match(/^\w+:/)) _tgt = '../' + _tgt;
                    text_p = $a1a91b25d7598376$var$writextag('text:a', text_p, {
                        'xlink:href': _tgt.replace(/&/g, "&amp;")
                    });
                }
                if (nfs[cell.z]) ct["table:style-name"] = "ce" + nfs[cell.z].slice(1);
                var payload = $a1a91b25d7598376$var$writextag('text:p', text_p, {});
                if (cell.c) {
                    var acreator = "", apayload = "", aprops = {};
                    for(var ci = 0; ci < cell.c.length; ++ci){
                        if (!acreator && cell.c[ci].a) acreator = cell.c[ci].a;
                        apayload += "<text:p>" + write_text_p(cell.c[ci].t) + "</text:p>";
                    }
                    if (!cell.c.hidden) aprops["office:display"] = true;
                    payload = $a1a91b25d7598376$var$writextag('office:annotation', apayload, aprops) + payload;
                }
                o.push('          ' + $a1a91b25d7598376$var$writextag('table:table-cell', payload, ct) + '\n');
            }
            o.push('        </table:table-row>\n');
        }
        if ((wb.Workbook || {}).Names) o.push($a1a91b25d7598376$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, i));
        o.push('      </table:table>\n');
        return o.join("");
    };
    var write_automatic_styles_ods = function(o /*:Array<string>*/ , wb) {
        o.push(' <office:automatic-styles>\n');
        /* column styles */ var cidx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!cols"]) {
                for(var C = 0; C < ws["!cols"].length; ++C)if (ws["!cols"][C]) {
                    var colobj = ws["!cols"][C];
                    if (colobj.width == null && colobj.wpx == null && colobj.wch == null) continue;
                    $a1a91b25d7598376$var$process_col(colobj);
                    colobj.ods = cidx;
                    var w = ws["!cols"][C].wpx + "px";
                    o.push('  <style:style style:name="co' + cidx + '" style:family="table-column">\n');
                    o.push('   <style:table-column-properties fo:break-before="auto" style:column-width="' + w + '"/>\n');
                    o.push('  </style:style>\n');
                    ++cidx;
                }
            }
        });
        /* row styles */ var ridx = 0;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            if (ws["!rows"]) {
                for(var R = 0; R < ws["!rows"].length; ++R)if (ws["!rows"][R]) {
                    ws["!rows"][R].ods = ridx;
                    var h = ws["!rows"][R].hpx + "px";
                    o.push('  <style:style style:name="ro' + ridx + '" style:family="table-row">\n');
                    o.push('   <style:table-row-properties fo:break-before="auto" style:row-height="' + h + '"/>\n');
                    o.push('  </style:style>\n');
                    ++ridx;
                }
            }
        });
        /* table */ o.push('  <style:style style:name="ta1" style:family="table" style:master-page-name="mp1">\n');
        o.push('   <style:table-properties table:display="true" style:writing-mode="lr-tb"/>\n');
        o.push('  </style:style>\n');
        o.push('  <number:date-style style:name="N37" number:automatic-order="true">\n');
        o.push('   <number:month number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:day number:style="long"/>\n');
        o.push('   <number:text>/</number:text>\n');
        o.push('   <number:year/>\n');
        o.push('  </number:date-style>\n');
        /* number formats, table cells, text */ var nfs = {};
        var nfi = 69;
        wb.SheetNames.map(function(n) {
            return wb.Sheets[n];
        }).forEach(function(ws) {
            if (!ws) return;
            var dense = ws["!data"] != null;
            if (!ws["!ref"]) return;
            var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
            for(var R = 0; R <= range.e.r; ++R)for(var C = 0; C <= range.e.c; ++C){
                var c = dense ? (ws["!data"][R] || [])[C] : ws[$a1a91b25d7598376$var$encode_cell({
                    r: R,
                    c: C
                })];
                if (!c || !c.z || c.z.toLowerCase() == "general") continue;
                if (!nfs[c.z]) {
                    var out = $a1a91b25d7598376$var$write_number_format_ods(c.z, "N" + nfi);
                    if (out) {
                        nfs[c.z] = "N" + nfi;
                        ++nfi;
                        o.push(out + "\n");
                    }
                }
            }
        });
        o.push('  <style:style style:name="ce1" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="N37"/>\n');
        $a1a91b25d7598376$var$keys(nfs).forEach(function(nf) {
            o.push('<style:style style:name="ce' + nfs[nf].slice(1) + '" style:family="table-cell" style:parent-style-name="Default" style:data-style-name="' + nfs[nf] + '"/>\n');
        });
        /* page-layout */ o.push(' </office:automatic-styles>\n');
        return nfs;
    };
    return function wcx(wb, opts) {
        var o = [
            $a1a91b25d7598376$var$XML_HEADER
        ];
        /* 3.1.3.2 */ var attr = $a1a91b25d7598376$var$wxt_helper({
            'xmlns:office': "urn:oasis:names:tc:opendocument:xmlns:office:1.0",
            'xmlns:table': "urn:oasis:names:tc:opendocument:xmlns:table:1.0",
            'xmlns:style': "urn:oasis:names:tc:opendocument:xmlns:style:1.0",
            'xmlns:text': "urn:oasis:names:tc:opendocument:xmlns:text:1.0",
            'xmlns:draw': "urn:oasis:names:tc:opendocument:xmlns:drawing:1.0",
            'xmlns:fo': "urn:oasis:names:tc:opendocument:xmlns:xsl-fo-compatible:1.0",
            'xmlns:xlink': "http://www.w3.org/1999/xlink",
            'xmlns:dc': "http://purl.org/dc/elements/1.1/",
            'xmlns:meta': "urn:oasis:names:tc:opendocument:xmlns:meta:1.0",
            'xmlns:number': "urn:oasis:names:tc:opendocument:xmlns:datastyle:1.0",
            'xmlns:presentation': "urn:oasis:names:tc:opendocument:xmlns:presentation:1.0",
            'xmlns:svg': "urn:oasis:names:tc:opendocument:xmlns:svg-compatible:1.0",
            'xmlns:chart': "urn:oasis:names:tc:opendocument:xmlns:chart:1.0",
            'xmlns:dr3d': "urn:oasis:names:tc:opendocument:xmlns:dr3d:1.0",
            'xmlns:math': "http://www.w3.org/1998/Math/MathML",
            'xmlns:form': "urn:oasis:names:tc:opendocument:xmlns:form:1.0",
            'xmlns:script': "urn:oasis:names:tc:opendocument:xmlns:script:1.0",
            'xmlns:ooo': "http://openoffice.org/2004/office",
            'xmlns:ooow': "http://openoffice.org/2004/writer",
            'xmlns:oooc': "http://openoffice.org/2004/calc",
            'xmlns:dom': "http://www.w3.org/2001/xml-events",
            'xmlns:xforms': "http://www.w3.org/2002/xforms",
            'xmlns:xsd': "http://www.w3.org/2001/XMLSchema",
            'xmlns:xsi': "http://www.w3.org/2001/XMLSchema-instance",
            'xmlns:sheet': "urn:oasis:names:tc:opendocument:sh33tjs:1.0",
            'xmlns:rpt': "http://openoffice.org/2005/report",
            'xmlns:of': "urn:oasis:names:tc:opendocument:xmlns:of:1.2",
            'xmlns:xhtml': "http://www.w3.org/1999/xhtml",
            'xmlns:grddl': "http://www.w3.org/2003/g/data-view#",
            'xmlns:tableooo': "http://openoffice.org/2009/table",
            'xmlns:drawooo': "http://openoffice.org/2010/draw",
            'xmlns:calcext': "urn:org:documentfoundation:names:experimental:calc:xmlns:calcext:1.0",
            'xmlns:loext': "urn:org:documentfoundation:names:experimental:office:xmlns:loext:1.0",
            'xmlns:field': "urn:openoffice:names:experimental:ooo-ms-interop:xmlns:field:1.0",
            'xmlns:formx': "urn:openoffice:names:experimental:ooxml-odf-interop:xmlns:form:1.0",
            'xmlns:css3t': "http://www.w3.org/TR/css3-text/",
            'office:version': "1.2"
        });
        var fods = $a1a91b25d7598376$var$wxt_helper({
            'xmlns:config': "urn:oasis:names:tc:opendocument:xmlns:config:1.0",
            'office:mimetype': "application/vnd.oasis.opendocument.spreadsheet"
        });
        if (opts.bookType == "fods") {
            o.push('<office:document' + attr + fods + '>\n');
            o.push($a1a91b25d7598376$var$write_meta_ods().replace(/<office:document-meta[^<>]*?>/, "").replace(/<\/office:document-meta>/, "") + "\n");
        // TODO: settings (equiv of settings.xml for ODS)
        } else o.push('<office:document-content' + attr + '>\n');
        // o.push('  <office:scripts/>\n');
        var nfs = write_automatic_styles_ods(o, wb);
        o.push('  <office:body>\n');
        o.push('    <office:spreadsheet>\n');
        if (((wb.Workbook || {}).WBProps || {}).date1904) o.push('      <table:calculation-settings table:case-sensitive="false" table:search-criteria-must-apply-to-whole-cell="true" table:use-wildcards="true" table:use-regular-expressions="false" table:automatic-find-labels="false">\n        <table:null-date table:date-value="1904-01-01"/>\n      </table:calculation-settings>\n');
        for(var i = 0; i != wb.SheetNames.length; ++i)o.push(write_ws(wb.Sheets[wb.SheetNames[i]], wb, i, opts, nfs, ((wb.Workbook || {}).WBProps || {}).date1904));
        if ((wb.Workbook || {}).Names) o.push($a1a91b25d7598376$var$write_names_ods(wb.Workbook.Names, wb.SheetNames, -1));
        o.push('    </office:spreadsheet>\n');
        o.push('  </office:body>\n');
        if (opts.bookType == "fods") o.push('</office:document>');
        else o.push('</office:document-content>');
        return o.join("");
    };
}();
function $a1a91b25d7598376$var$write_ods(wb /*:any*/ , opts /*:any*/ ) {
    if (opts.bookType == "fods") return $a1a91b25d7598376$var$write_content_ods(wb, opts);
    var zip = $a1a91b25d7598376$var$zip_new();
    var f = "";
    var manifest /*:Array<Array<string> >*/  = [];
    var rdf /*:Array<[string, string]>*/  = [];
    /* Part 3 Section 3.3 MIME Media Type */ f = "mimetype";
    $a1a91b25d7598376$var$zip_add_file(zip, f, "application/vnd.oasis.opendocument.spreadsheet");
    /* Part 1 Section 2.2 Documents */ f = "content.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_content_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "ContentFile"
    ]);
    /* TODO: these are hard-coded styles to satiate excel */ f = "styles.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_styles_ods(wb, opts));
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "StylesFile"
    ]);
    /* TODO: this is hard-coded to satiate excel */ f = "meta.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$XML_HEADER + $a1a91b25d7598376$var$write_meta_ods());
    manifest.push([
        f,
        "text/xml"
    ]);
    rdf.push([
        f,
        "MetadataFile"
    ]);
    /* Part 3 Section 6 Metadata Manifest File */ f = "manifest.rdf";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_rdf(rdf /*, opts*/ ));
    manifest.push([
        f,
        "application/rdf+xml"
    ]);
    /* Part 3 Section 4 Manifest File */ f = "META-INF/manifest.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_manifest(manifest /*, opts*/ ));
    return zip;
}
/*! sheetjs (C) 2013-present SheetJS -- http://sheetjs.com */ var $a1a91b25d7598376$var$subarray = function() {
    try {
        if (typeof Uint8Array == "undefined") return "slice";
        if (typeof Uint8Array.prototype.subarray == "undefined") return "slice";
        if (typeof $a1a91b25d7598376$require$Buffer !== "undefined") {
            if (typeof $a1a91b25d7598376$require$Buffer.prototype.subarray == "undefined") return "slice";
            if ((typeof $a1a91b25d7598376$require$Buffer.from == "function" ? $a1a91b25d7598376$require$Buffer.from([
                72,
                62
            ]) : new $a1a91b25d7598376$require$Buffer([
                72,
                62
            ])) instanceof Uint8Array) return "subarray";
            return "slice";
        }
        return "subarray";
    } catch (e) {
        return "slice";
    }
}();
function $a1a91b25d7598376$var$u8_to_dataview(array) {
    return new DataView(array.buffer, array.byteOffset, array.byteLength);
}
function $a1a91b25d7598376$var$u8str(u8) {
    return typeof TextDecoder != "undefined" ? new TextDecoder().decode(u8) : $a1a91b25d7598376$var$utf8read($a1a91b25d7598376$var$a2s(u8));
}
function $a1a91b25d7598376$var$stru8(str) {
    return typeof TextEncoder != "undefined" ? new TextEncoder().encode(str) : $a1a91b25d7598376$var$s2a($a1a91b25d7598376$var$utf8write(str));
}
function $a1a91b25d7598376$var$u8concat(u8a) {
    var len = 0;
    for(var i = 0; i < u8a.length; ++i)len += u8a[i].length;
    var out = new Uint8Array(len);
    var off = 0;
    for(i = 0; i < u8a.length; ++i){
        var u8 = u8a[i], L = u8.length;
        if (L < 250) for(var j = 0; j < L; ++j)out[off++] = u8[j];
        else {
            out.set(u8, off);
            off += L;
        }
    }
    return out;
}
function $a1a91b25d7598376$var$popcnt(x) {
    x -= x >> 1 & 1431655765;
    x = (x & 858993459) + (x >> 2 & 858993459);
    return (x + (x >> 4) & 252645135) * 16843009 >>> 24;
}
function $a1a91b25d7598376$var$readDecimal128LE(buf, offset) {
    var exp = (buf[offset + 15] & 127) << 7 | buf[offset + 14] >> 1;
    var mantissa = buf[offset + 14] & 1;
    for(var j = offset + 13; j >= offset; --j)mantissa = mantissa * 256 + buf[j];
    return (buf[offset + 15] & 128 ? -mantissa : mantissa) * Math.pow(10, exp - 6176);
}
function $a1a91b25d7598376$var$writeDecimal128LE(buf, offset, value) {
    var exp = Math.floor(value == 0 ? 0 : Math.LOG10E * Math.log(Math.abs(value))) + 6176 - 16;
    var mantissa = value / Math.pow(10, exp - 6176);
    buf[offset + 15] |= exp >> 7;
    buf[offset + 14] |= (exp & 127) << 1;
    for(var i = 0; mantissa >= 1; ++i, mantissa /= 256)buf[offset + i] = mantissa & 255;
    buf[offset + 15] |= value >= 0 ? 0 : 128;
}
function $a1a91b25d7598376$var$parse_varint49(buf, ptr) {
    var l = ptr.l;
    var usz = buf[l] & 127;
    varint: if (buf[l++] >= 128) {
        usz |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        usz |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 28);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 35);
        ++l;
        if (buf[l++] < 128) break varint;
        usz += (buf[l] & 127) * Math.pow(2, 42);
        ++l;
        if (buf[l++] < 128) break varint;
    }
    ptr.l = l;
    return usz;
}
function $a1a91b25d7598376$var$write_varint49(v) {
    var usz = new Uint8Array(7);
    usz[0] = v & 127;
    var L = 1;
    sz: if (v > 127) {
        usz[L - 1] |= 128;
        usz[L] = v >> 7 & 127;
        ++L;
        if (v <= 16383) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 14 & 127;
        ++L;
        if (v <= 2097151) break sz;
        usz[L - 1] |= 128;
        usz[L] = v >> 21 & 127;
        ++L;
        if (v <= 268435455) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 256 >>> 21 & 127;
        ++L;
        if (v <= 34359738367) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 65536 >>> 21 & 127;
        ++L;
        if (v <= 4398046511103) break sz;
        usz[L - 1] |= 128;
        usz[L] = v / 16777216 >>> 21 & 127;
        ++L;
    }
    return usz[$a1a91b25d7598376$var$subarray](0, L);
}
function $a1a91b25d7598376$var$parse_packed_varints(buf) {
    var ptr = {
        l: 0
    };
    var out = [];
    while(ptr.l < buf.length)out.push($a1a91b25d7598376$var$parse_varint49(buf, ptr));
    return out;
}
function $a1a91b25d7598376$var$write_packed_varints(nums) {
    return $a1a91b25d7598376$var$u8concat(nums.map(function(x) {
        return $a1a91b25d7598376$var$write_varint49(x);
    }));
}
function $a1a91b25d7598376$var$varint_to_i32(buf) {
    var l = 0, i32 = buf[l] & 127;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 7;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 14;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 127) << 21;
    if (buf[l++] < 128) return i32;
    i32 |= (buf[l] & 15) << 28;
    return i32;
}
function $a1a91b25d7598376$var$varint_to_u64(buf) {
    var l = 0, lo = buf[l] & 127, hi = 0;
    varint: if (buf[l++] >= 128) {
        lo |= (buf[l] & 127) << 7;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 14;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 21;
        if (buf[l++] < 128) break varint;
        lo |= (buf[l] & 127) << 28;
        hi = buf[l] >> 4 & 7;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 3;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 10;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 17;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 24;
        if (buf[l++] < 128) break varint;
        hi |= (buf[l] & 127) << 31;
    }
    return [
        lo >>> 0,
        hi >>> 0
    ];
}
function $a1a91b25d7598376$var$parse_shallow(buf) {
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var off = ptr.l;
        var num = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
        var type = num & 7;
        num = num / 8 | 0;
        var data;
        var l = ptr.l;
        switch(type){
            case 0:
                while(buf[l++] >= 128);
                data = buf[$a1a91b25d7598376$var$subarray](ptr.l, l);
                ptr.l = l;
                break;
            case 1:
                data = buf[$a1a91b25d7598376$var$subarray](l, l + 8);
                ptr.l = l + 8;
                break;
            case 2:
                var len = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
                data = buf[$a1a91b25d7598376$var$subarray](ptr.l, ptr.l + len);
                ptr.l += len;
                break;
            case 5:
                data = buf[$a1a91b25d7598376$var$subarray](l, l + 4);
                ptr.l = l + 4;
                break;
            default:
                throw new Error("PB Type ".concat(type, " for Field ").concat(num, " at offset ").concat(off));
        }
        var v = {
            data: data,
            type: type
        };
        if (out[num] == null) out[num] = [];
        out[num].push(v);
    }
    return out;
}
function $a1a91b25d7598376$var$write_shallow(proto) {
    var out = [];
    proto.forEach(function(field, idx) {
        if (idx == 0) return;
        field.forEach(function(item) {
            if (!item.data) return;
            out.push($a1a91b25d7598376$var$write_varint49(idx * 8 + item.type));
            if (item.type == 2) out.push($a1a91b25d7598376$var$write_varint49(item.data.length));
            out.push(item.data);
        });
    });
    return $a1a91b25d7598376$var$u8concat(out);
}
function $a1a91b25d7598376$var$mappa(data, cb) {
    return (data == null ? void 0 : data.map(function(d) {
        return cb(d.data);
    })) || [];
}
function $a1a91b25d7598376$var$parse_iwa_file(buf) {
    var _a;
    var out = [], ptr = {
        l: 0
    };
    while(ptr.l < buf.length){
        var len = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
        var ai = $a1a91b25d7598376$var$parse_shallow(buf[$a1a91b25d7598376$var$subarray](ptr.l, ptr.l + len));
        ptr.l += len;
        var res = {
            id: $a1a91b25d7598376$var$varint_to_i32(ai[1][0].data),
            messages: []
        };
        ai[2].forEach(function(b) {
            var mi = $a1a91b25d7598376$var$parse_shallow(b.data);
            var fl = $a1a91b25d7598376$var$varint_to_i32(mi[3][0].data);
            res.messages.push({
                meta: mi,
                data: buf[$a1a91b25d7598376$var$subarray](ptr.l, ptr.l + fl)
            });
            ptr.l += fl;
        });
        if ((_a = ai[3]) == null ? void 0 : _a[0]) res.merge = $a1a91b25d7598376$var$varint_to_i32(ai[3][0].data) >>> 0 > 0;
        out.push(res);
    }
    return out;
}
function $a1a91b25d7598376$var$write_iwa_file(ias) {
    var bufs = [];
    ias.forEach(function(ia) {
        var ai = [
            [],
            [
                {
                    data: $a1a91b25d7598376$var$write_varint49(ia.id),
                    type: 0
                }
            ],
            []
        ];
        if (ia.merge != null) ai[3] = [
            {
                data: $a1a91b25d7598376$var$write_varint49(+!!ia.merge),
                type: 0
            }
        ];
        var midata = [];
        ia.messages.forEach(function(mi) {
            midata.push(mi.data);
            mi.meta[3] = [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(mi.data.length)
                }
            ];
            ai[2].push({
                data: $a1a91b25d7598376$var$write_shallow(mi.meta),
                type: 2
            });
        });
        var aipayload = $a1a91b25d7598376$var$write_shallow(ai);
        bufs.push($a1a91b25d7598376$var$write_varint49(aipayload.length));
        bufs.push(aipayload);
        midata.forEach(function(mid) {
            return bufs.push(mid);
        });
    });
    return $a1a91b25d7598376$var$u8concat(bufs);
}
function $a1a91b25d7598376$var$parse_snappy_chunk(type, buf) {
    if (type != 0) throw new Error("Unexpected Snappy chunk type ".concat(type));
    var ptr = {
        l: 0
    };
    var usz = $a1a91b25d7598376$var$parse_varint49(buf, ptr);
    var chunks = [];
    var l = ptr.l;
    while(l < buf.length){
        var tag = buf[l] & 3;
        if (tag == 0) {
            var len = buf[l++] >> 2;
            if (len < 60) ++len;
            else {
                var c = len - 59;
                len = buf[l];
                if (c > 1) len |= buf[l + 1] << 8;
                if (c > 2) len |= buf[l + 2] << 16;
                if (c > 3) len |= buf[l + 3] << 24;
                len >>>= 0;
                len++;
                l += c;
            }
            chunks.push(buf[$a1a91b25d7598376$var$subarray](l, l + len));
            l += len;
            continue;
        } else {
            var offset = 0, length = 0;
            if (tag == 1) {
                length = (buf[l] >> 2 & 7) + 4;
                offset = (buf[l++] & 224) << 3;
                offset |= buf[l++];
            } else {
                length = (buf[l++] >> 2) + 1;
                if (tag == 2) {
                    offset = buf[l] | buf[l + 1] << 8;
                    l += 2;
                } else {
                    offset = (buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16 | buf[l + 3] << 24) >>> 0;
                    l += 4;
                }
            }
            if (offset == 0) throw new Error("Invalid offset 0");
            var j = chunks.length - 1, off = offset;
            while(j >= 0 && off >= chunks[j].length){
                off -= chunks[j].length;
                --j;
            }
            if (j < 0) {
                if (off == 0) off = chunks[j = 0].length;
                else throw new Error("Invalid offset beyond length");
            }
            if (length < off) chunks.push(chunks[j][$a1a91b25d7598376$var$subarray](chunks[j].length - off, chunks[j].length - off + length));
            else {
                if (off > 0) {
                    chunks.push(chunks[j][$a1a91b25d7598376$var$subarray](chunks[j].length - off));
                    length -= off;
                }
                ++j;
                while(length >= chunks[j].length){
                    chunks.push(chunks[j]);
                    length -= chunks[j].length;
                    ++j;
                }
                if (length) chunks.push(chunks[j][$a1a91b25d7598376$var$subarray](0, length));
            }
            if (chunks.length > 25) chunks = [
                $a1a91b25d7598376$var$u8concat(chunks)
            ];
        }
    }
    var clen = 0;
    for(var u8i = 0; u8i < chunks.length; ++u8i)clen += chunks[u8i].length;
    if (clen != usz) throw new Error("Unexpected length: ".concat(clen, " != ").concat(usz));
    return chunks;
}
function $a1a91b25d7598376$var$decompress_iwa_file(buf) {
    if (Array.isArray(buf)) buf = new Uint8Array(buf);
    var out = [];
    var l = 0;
    while(l < buf.length){
        var t = buf[l++];
        var len = buf[l] | buf[l + 1] << 8 | buf[l + 2] << 16;
        l += 3;
        out.push.apply(out, $a1a91b25d7598376$var$parse_snappy_chunk(t, buf[$a1a91b25d7598376$var$subarray](l, l + len)));
        l += len;
    }
    if (l !== buf.length) throw new Error("data is not a valid framed stream!");
    return out.length == 1 ? out[0] : $a1a91b25d7598376$var$u8concat(out);
}
function $a1a91b25d7598376$var$compress_iwa_file(buf) {
    var out = [];
    var l = 0;
    while(l < buf.length){
        var c = Math.min(buf.length - l, 268435455);
        var frame = new Uint8Array(4);
        out.push(frame);
        var usz = $a1a91b25d7598376$var$write_varint49(c);
        var L = usz.length;
        out.push(usz);
        if (c <= 60) {
            L++;
            out.push(new Uint8Array([
                c - 1 << 2
            ]));
        } else if (c <= 256) {
            L += 2;
            out.push(new Uint8Array([
                240,
                c - 1 & 255
            ]));
        } else if (c <= 65536) {
            L += 3;
            out.push(new Uint8Array([
                244,
                c - 1 & 255,
                c - 1 >> 8 & 255
            ]));
        } else if (c <= 16777216) {
            L += 4;
            out.push(new Uint8Array([
                248,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255
            ]));
        } else if (c <= 4294967296) {
            L += 5;
            out.push(new Uint8Array([
                252,
                c - 1 & 255,
                c - 1 >> 8 & 255,
                c - 1 >> 16 & 255,
                c - 1 >>> 24 & 255
            ]));
        }
        out.push(buf[$a1a91b25d7598376$var$subarray](l, l + c));
        L += c;
        frame[0] = 0;
        frame[1] = L & 255;
        frame[2] = L >> 8 & 255;
        frame[3] = L >> 16 & 255;
        l += c;
    }
    return $a1a91b25d7598376$var$u8concat(out);
}
var $a1a91b25d7598376$var$numbers_lut_new = function() {
    return {
        sst: [],
        rsst: [],
        ofmt: [],
        nfmt: [],
        fmla: [],
        ferr: [],
        cmnt: []
    };
};
function $a1a91b25d7598376$var$numbers_format_cell(cell, t, flags, ofmt, nfmt) {
    var _a, _b, _c, _d;
    var ctype = t & 255, ver = t >> 8;
    var fmt = ver >= 5 ? nfmt : ofmt;
    dur: if (flags & (ver > 4 ? 8 : 4) && cell.t == "n" && ctype == 7) {
        var dstyle = ((_a = fmt[7]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[7][0].data) : -1;
        if (dstyle == -1) break dur;
        var dmin = ((_b = fmt[15]) == null ? void 0 : _b[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[15][0].data) : -1;
        var dmax = ((_c = fmt[16]) == null ? void 0 : _c[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[16][0].data) : -1;
        var auto = ((_d = fmt[40]) == null ? void 0 : _d[0]) ? $a1a91b25d7598376$var$varint_to_i32(fmt[40][0].data) : -1;
        var d = cell.v, dd = d;
        autodur: if (auto) {
            if (d == 0) {
                dmin = dmax = 2;
                break autodur;
            }
            if (d >= 604800) dmin = 1;
            else if (d >= 86400) dmin = 2;
            else if (d >= 3600) dmin = 4;
            else if (d >= 60) dmin = 8;
            else if (d >= 1) dmin = 16;
            else dmin = 32;
            if (Math.floor(d) != d) dmax = 32;
            else if (d % 60) dmax = 16;
            else if (d % 3600) dmax = 8;
            else if (d % 86400) dmax = 4;
            else if (d % 604800) dmax = 2;
            if (dmax < dmin) dmax = dmin;
        }
        if (dmin == -1 || dmax == -1) break dur;
        var dstr = [], zstr = [];
        if (dmin == 1) {
            dd = d / 604800;
            if (dmax == 1) zstr.push('d"d"');
            else {
                dd |= 0;
                d -= 604800 * dd;
            }
            dstr.push(dd + (dstyle == 2 ? " week" + (dd == 1 ? "" : "s") : dstyle == 1 ? "w" : ""));
        }
        if (dmin <= 2 && dmax >= 2) {
            dd = d / 86400;
            if (dmax > 2) {
                dd |= 0;
                d -= 86400 * dd;
            }
            zstr.push('d"d"');
            dstr.push(dd + (dstyle == 2 ? " day" + (dd == 1 ? "" : "s") : dstyle == 1 ? "d" : ""));
        }
        if (dmin <= 4 && dmax >= 4) {
            dd = d / 3600;
            if (dmax > 4) {
                dd |= 0;
                d -= 3600 * dd;
            }
            zstr.push((dmin >= 4 ? "[h]" : "h") + '"h"');
            dstr.push(dd + (dstyle == 2 ? " hour" + (dd == 1 ? "" : "s") : dstyle == 1 ? "h" : ""));
        }
        if (dmin <= 8 && dmax >= 8) {
            dd = d / 60;
            if (dmax > 8) {
                dd |= 0;
                d -= 60 * dd;
            }
            zstr.push((dmin >= 8 ? "[m]" : "m") + '"m"');
            if (dstyle == 0) dstr.push((dmin == 8 && dmax == 8 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " minute" + (dd == 1 ? "" : "s") : dstyle == 1 ? "m" : ""));
        }
        if (dmin <= 16 && dmax >= 16) {
            dd = d;
            if (dmax > 16) {
                dd |= 0;
                d -= dd;
            }
            zstr.push((dmin >= 16 ? "[s]" : "s") + '"s"');
            if (dstyle == 0) dstr.push((dmax == 16 && dmin == 16 || dd >= 10 ? "" : "0") + dd);
            else dstr.push(dd + (dstyle == 2 ? " second" + (dd == 1 ? "" : "s") : dstyle == 1 ? "s" : ""));
        }
        if (dmax >= 32) {
            dd = Math.round(1e3 * d);
            if (dmin < 32) zstr.push('.000"ms"');
            if (dstyle == 0) dstr.push((dd >= 100 ? "" : dd >= 10 ? "0" : "00") + dd);
            else dstr.push(dd + (dstyle == 2 ? " millisecond" + (dd == 1 ? "" : "s") : dstyle == 1 ? "ms" : ""));
        }
        cell.w = dstr.join(dstyle == 0 ? ":" : " ");
        cell.z = zstr.join(dstyle == 0 ? '":"' : " ");
        if (dstyle == 0) cell.w = cell.w.replace(/:(\d\d\d)$/, ".$1");
    }
}
function $a1a91b25d7598376$var$parse_old_storage(buf, lut, v, opts) {
    var dv = $a1a91b25d7598376$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var ridx = -1, sidx = -1, zidx = -1, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1));
    var doff = v > 1 ? 12 : 8;
    if (flags & 2) {
        zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $a1a91b25d7598376$var$popcnt(flags & (v > 1 ? 3468 : 396)) * 4;
    if (flags & 512) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $a1a91b25d7598376$var$popcnt(flags & (v > 1 ? 12288 : 4096)) * 4;
    if (flags & 16) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (flags & 32) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (flags & 64) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (v > 1) {
        flags = dv.getUint32(8, true) >>> 16;
        if (flags & 255) {
            if (zidx == -1) zidx = dv.getUint32(doff, true);
            doff += 4;
        }
    }
    var ret;
    var t = buf[v >= 4 ? 1 : 2];
    switch(t){
        case 0:
            return void 0;
        case 2:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $a1a91b25d7598376$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
    }
    if (zidx > -1) $a1a91b25d7598376$var$numbers_format_cell(ret, t | v << 8, flags, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $a1a91b25d7598376$var$parse_new_storage(buf, lut, opts) {
    var dv = $a1a91b25d7598376$var$u8_to_dataview(buf);
    var flags = dv.getUint32(4, true);
    var fields = dv.getUint32(8, true);
    var doff = 12;
    var ridx = -1, sidx = -1, zidx = -1, d128 = NaN, ieee = NaN, dc = 0, dt = new Date(Date.UTC(2001, 0, 1)), eidx = -1, fidx = -1;
    if (fields & 1) {
        d128 = $a1a91b25d7598376$var$readDecimal128LE(buf, doff);
        doff += 16;
    }
    if (fields & 2) {
        ieee = dv.getFloat64(doff, true);
        doff += 8;
    }
    if (fields & 4) {
        dt.setTime(dt.getTime() + (dc = dv.getFloat64(doff, true)) * 1e3);
        doff += 8;
    }
    if (fields & 8) {
        sidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 16) {
        ridx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $a1a91b25d7598376$var$popcnt(fields & 480) * 4;
    if (fields & 512) {
        fidx = dv.getUint32(doff, true);
        doff += 4;
    }
    doff += $a1a91b25d7598376$var$popcnt(fields & 1024) * 4;
    if (fields & 2048) {
        eidx = dv.getUint32(doff, true);
        doff += 4;
    }
    var ret;
    var t = buf[1];
    switch(t){
        case 0:
            ret = {
                t: "z"
            };
            break;
        case 2:
            ret = {
                t: "n",
                v: d128
            };
            break;
        case 3:
            ret = {
                t: "s",
                v: lut.sst[sidx]
            };
            break;
        case 5:
            if (opts == null ? void 0 : opts.cellDates) ret = {
                t: "d",
                v: dt
            };
            else ret = {
                t: "n",
                v: dc / 86400 + 35430,
                z: $a1a91b25d7598376$var$table_fmt[14]
            };
            break;
        case 6:
            ret = {
                t: "b",
                v: ieee > 0
            };
            break;
        case 7:
            ret = {
                t: "n",
                v: ieee
            };
            break;
        case 8:
            ret = {
                t: "e",
                v: 0
            };
            break;
        case 9:
            if (ridx > -1) {
                var rts = lut.rsst[ridx];
                ret = {
                    t: "s",
                    v: rts.v
                };
                if (rts.l) ret.l = {
                    Target: rts.l
                };
            } else throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
            break;
        case 10:
            ret = {
                t: "n",
                v: d128
            };
            break;
        default:
            throw new Error("Unsupported cell type ".concat(buf[1], " : ").concat(fields & 31, " : ").concat(buf[$a1a91b25d7598376$var$subarray](0, 4)));
    }
    doff += $a1a91b25d7598376$var$popcnt(fields & 4096) * 4;
    if (fields & 516096) {
        if (zidx == -1) zidx = dv.getUint32(doff, true);
        doff += 4;
    }
    if (fields & 524288) {
        var cmntidx = dv.getUint32(doff, true);
        doff += 4;
        if (lut.cmnt[cmntidx]) ret.c = $a1a91b25d7598376$var$iwa_to_s5s_comment(lut.cmnt[cmntidx]);
    }
    if (zidx > -1) $a1a91b25d7598376$var$numbers_format_cell(ret, t | 1280, fields >> 13, lut.ofmt[zidx], lut.nfmt[zidx]);
    if (t == 7) ret.v /= 86400;
    return ret;
}
function $a1a91b25d7598376$var$write_new_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $a1a91b25d7598376$var$u8_to_dataview(out), l = 12, fields = 0;
    out[0] = 5;
    switch(cell.t){
        case "n":
            if (cell.z && $a1a91b25d7598376$var$fmt_is_date(cell.z)) {
                out[1] = 5;
                dv.setFloat64(l, ($a1a91b25d7598376$var$numdate(cell.v + 1462).getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
                fields |= 4;
                l += 8;
                break;
            } else {
                out[1] = 2;
                $a1a91b25d7598376$var$writeDecimal128LE(out, l, cell.v);
                fields |= 1;
                l += 16;
            }
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 2;
            l += 8;
            break;
        case "s":
            var s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 16;
                l += 4;
            } else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 8;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 4;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        lut.cmnt.push($a1a91b25d7598376$var$s5s_to_iwa_comment(cell.c));
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 524288;
        l += 4;
    }
    dv.setUint32(8, fields, true);
    return out[$a1a91b25d7598376$var$subarray](0, l);
}
function $a1a91b25d7598376$var$write_old_storage(cell, lut) {
    var out = new Uint8Array(32), dv = $a1a91b25d7598376$var$u8_to_dataview(out), l = 12, fields = 0, s = "";
    out[0] = 4;
    switch(cell.t){
        case "n":
            break;
        case "b":
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) {
                var irsst = lut.rsst.findIndex(function(v) {
                    var _a;
                    return v.v == s && v.l == ((_a = cell.l) == null ? void 0 : _a.Target);
                });
                if (irsst == -1) lut.rsst[irsst = lut.rsst.length] = {
                    v: s,
                    l: cell.l.Target
                };
                out[1] = 9;
                dv.setUint32(l, irsst, true);
                fields |= 512;
                l += 4;
            }
            break;
        case "d":
            break;
        case "e":
            break;
        case "z":
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    if (cell.c) {
        dv.setUint32(l, lut.cmnt.length - 1, true);
        fields |= 4096;
        l += 4;
    }
    switch(cell.t){
        case "n":
            out[1] = 2;
            dv.setFloat64(l, cell.v, true);
            fields |= 32;
            l += 8;
            break;
        case "b":
            out[1] = 6;
            dv.setFloat64(l, cell.v ? 1 : 0, true);
            fields |= 32;
            l += 8;
            break;
        case "s":
            s = cell.v == null ? "" : String(cell.v);
            if (cell.l) ;
            else {
                var isst = lut.sst.indexOf(s);
                if (isst == -1) lut.sst[isst = lut.sst.length] = s;
                out[1] = 3;
                dv.setUint32(l, isst, true);
                fields |= 16;
                l += 4;
            }
            break;
        case "d":
            out[1] = 5;
            dv.setFloat64(l, (cell.v.getTime() - Date.UTC(2001, 0, 1)) / 1e3, true);
            fields |= 64;
            l += 8;
            break;
        case "z":
            out[1] = 0;
            break;
        default:
            throw "unsupported cell type " + cell.t;
    }
    dv.setUint32(8, fields, true);
    return out[$a1a91b25d7598376$var$subarray](0, l);
}
function $a1a91b25d7598376$var$parse_cell_storage(buf, lut, opts) {
    switch(buf[0]){
        case 0:
        case 1:
        case 2:
        case 3:
        case 4:
            return $a1a91b25d7598376$var$parse_old_storage(buf, lut, buf[0], opts);
        case 5:
            return $a1a91b25d7598376$var$parse_new_storage(buf, lut, opts);
        default:
            throw new Error("Unsupported payload version ".concat(buf[0]));
    }
}
function $a1a91b25d7598376$var$parse_TSP_Reference(buf) {
    var pb = $a1a91b25d7598376$var$parse_shallow(buf);
    return $a1a91b25d7598376$var$varint_to_i32(pb[1][0].data);
}
function $a1a91b25d7598376$var$write_TSP_Reference(idx) {
    return $a1a91b25d7598376$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(idx)
            }
        ]
    ]);
}
function $a1a91b25d7598376$var$numbers_add_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    var orefidx = orefs.indexOf(ref);
    if (orefidx == -1) {
        orefs.push(ref);
        iwa.messages[0].meta[5] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$write_packed_varints(orefs)
            }
        ];
    }
}
function $a1a91b25d7598376$var$numbers_del_oref(iwa, ref) {
    var _a;
    var orefs = ((_a = iwa.messages[0].meta[5]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$parse_packed_varints(iwa.messages[0].meta[5][0].data) : [];
    iwa.messages[0].meta[5] = [
        {
            type: 2,
            data: $a1a91b25d7598376$var$write_packed_varints(orefs.filter(function(r) {
                return r != ref;
            }))
        }
    ];
}
function $a1a91b25d7598376$var$parse_TST_TableDataList(M, root) {
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var type = $a1a91b25d7598376$var$varint_to_i32(pb[1][0].data);
    var entries = pb[3];
    var data = [];
    (entries || []).forEach(function(entry) {
        var _a, _b;
        var le = $a1a91b25d7598376$var$parse_shallow(entry.data);
        if (!le[1]) return;
        var key = $a1a91b25d7598376$var$varint_to_i32(le[1][0].data) >>> 0;
        switch(type){
            case 1:
                data[key] = $a1a91b25d7598376$var$u8str(le[3][0].data);
                break;
            case 8:
                var rt = M[$a1a91b25d7598376$var$parse_TSP_Reference(le[9][0].data)][0];
                var rtp = $a1a91b25d7598376$var$parse_shallow(rt.data);
                var rtpref = M[$a1a91b25d7598376$var$parse_TSP_Reference(rtp[1][0].data)][0];
                var mtype = $a1a91b25d7598376$var$varint_to_i32(rtpref.meta[1][0].data);
                if (mtype != 2001) throw new Error("2000 unexpected reference to ".concat(mtype));
                var tswpsa = $a1a91b25d7598376$var$parse_shallow(rtpref.data);
                var richtext = {
                    v: tswpsa[3].map(function(x) {
                        return $a1a91b25d7598376$var$u8str(x.data);
                    }).join("")
                };
                data[key] = richtext;
                sfields: if ((_a = tswpsa == null ? void 0 : tswpsa[11]) == null ? void 0 : _a[0]) {
                    var smartfields = (_b = $a1a91b25d7598376$var$parse_shallow(tswpsa[11][0].data)) == null ? void 0 : _b[1];
                    if (!smartfields) break sfields;
                    smartfields.forEach(function(sf) {
                        var _a2, _b2, _c;
                        var attr = $a1a91b25d7598376$var$parse_shallow(sf.data);
                        if ((_a2 = attr[2]) == null ? void 0 : _a2[0]) {
                            var obj = M[$a1a91b25d7598376$var$parse_TSP_Reference((_b2 = attr[2]) == null ? void 0 : _b2[0].data)][0];
                            var objtype = $a1a91b25d7598376$var$varint_to_i32(obj.meta[1][0].data);
                            switch(objtype){
                                case 2032:
                                    var hlink = $a1a91b25d7598376$var$parse_shallow(obj.data);
                                    if (((_c = hlink == null ? void 0 : hlink[2]) == null ? void 0 : _c[0]) && !richtext.l) richtext.l = $a1a91b25d7598376$var$u8str(hlink[2][0].data);
                                    break;
                                case 2039:
                                    break;
                                default:
                                    console.log("unrecognized ObjectAttribute type ".concat(objtype));
                            }
                        }
                    });
                }
                break;
            case 2:
                data[key] = $a1a91b25d7598376$var$parse_shallow(le[6][0].data);
                break;
            case 3:
                data[key] = $a1a91b25d7598376$var$parse_shallow(le[5][0].data);
                break;
            case 10:
                var cs = M[$a1a91b25d7598376$var$parse_TSP_Reference(le[10][0].data)][0];
                data[key] = $a1a91b25d7598376$var$parse_TSD_CommentStorageArchive(M, cs.data);
                break;
            default:
                throw type;
        }
    });
    return data;
}
function $a1a91b25d7598376$var$parse_TST_TileRowInfo(u8, type) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $a1a91b25d7598376$var$parse_shallow(u8);
    var R = $a1a91b25d7598376$var$varint_to_i32(pb[1][0].data) >>> 0;
    var cnt = $a1a91b25d7598376$var$varint_to_i32(pb[2][0].data) >>> 0;
    var wide_offsets = ((_b = (_a = pb[8]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) && $a1a91b25d7598376$var$varint_to_i32(pb[8][0].data) > 0 || false;
    var used_storage_u8, used_storage;
    if (((_d = (_c = pb[7]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) && type != 0) {
        used_storage_u8 = (_f = (_e = pb[7]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data;
        used_storage = (_h = (_g = pb[6]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data;
    } else if (((_j = (_i = pb[4]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) && type != 1) {
        used_storage_u8 = (_l = (_k = pb[4]) == null ? void 0 : _k[0]) == null ? void 0 : _l.data;
        used_storage = (_n = (_m = pb[3]) == null ? void 0 : _m[0]) == null ? void 0 : _n.data;
    } else throw "NUMBERS Tile missing ".concat(type, " cell storage");
    var width = wide_offsets ? 4 : 1;
    var used_storage_offsets = $a1a91b25d7598376$var$u8_to_dataview(used_storage_u8);
    var offsets = [];
    for(var C = 0; C < used_storage_u8.length / 2; ++C){
        var off = used_storage_offsets.getUint16(C * 2, true);
        if (off < 65535) offsets.push([
            C,
            off
        ]);
    }
    if (offsets.length != cnt) throw "Expected ".concat(cnt, " cells, found ").concat(offsets.length);
    var cells = [];
    for(C = 0; C < offsets.length - 1; ++C)cells[offsets[C][0]] = used_storage[$a1a91b25d7598376$var$subarray](offsets[C][1] * width, offsets[C + 1][1] * width);
    if (offsets.length >= 1) cells[offsets[offsets.length - 1][0]] = used_storage[$a1a91b25d7598376$var$subarray](offsets[offsets.length - 1][1] * width);
    return {
        R: R,
        cells: cells
    };
}
function $a1a91b25d7598376$var$parse_TST_Tile(M, root) {
    var _a;
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var storage = -1;
    if ((_a = pb == null ? void 0 : pb[7]) == null ? void 0 : _a[0]) {
        if ($a1a91b25d7598376$var$varint_to_i32(pb[7][0].data) >>> 0) storage = 1;
        else storage = 0;
    }
    var ri = $a1a91b25d7598376$var$mappa(pb[5], function(u8) {
        return $a1a91b25d7598376$var$parse_TST_TileRowInfo(u8, storage);
    });
    return {
        nrows: $a1a91b25d7598376$var$varint_to_i32(pb[4][0].data) >>> 0,
        data: ri.reduce(function(acc, x) {
            if (!acc[x.R]) acc[x.R] = [];
            x.cells.forEach(function(cell, C) {
                if (acc[x.R][C]) throw new Error("Duplicate cell r=".concat(x.R, " c=").concat(C));
                acc[x.R][C] = cell;
            });
            return acc;
        }, [])
    };
}
function $a1a91b25d7598376$var$parse_TSD_CommentStorageArchive(M, data) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
    var out = {
        t: "",
        a: ""
    };
    var csp = $a1a91b25d7598376$var$parse_shallow(data);
    if ((_b = (_a = csp == null ? void 0 : csp[1]) == null ? void 0 : _a[0]) == null ? void 0 : _b.data) out.t = $a1a91b25d7598376$var$u8str((_d = (_c = csp == null ? void 0 : csp[1]) == null ? void 0 : _c[0]) == null ? void 0 : _d.data) || "";
    if ((_f = (_e = csp == null ? void 0 : csp[3]) == null ? void 0 : _e[0]) == null ? void 0 : _f.data) {
        var as = M[$a1a91b25d7598376$var$parse_TSP_Reference((_h = (_g = csp == null ? void 0 : csp[3]) == null ? void 0 : _g[0]) == null ? void 0 : _h.data)][0];
        var asp = $a1a91b25d7598376$var$parse_shallow(as.data);
        if ((_j = (_i = asp[1]) == null ? void 0 : _i[0]) == null ? void 0 : _j.data) out.a = $a1a91b25d7598376$var$u8str(asp[1][0].data);
    }
    if (csp == null ? void 0 : csp[4]) {
        out.replies = [];
        csp[4].forEach(function(pi) {
            var cs = M[$a1a91b25d7598376$var$parse_TSP_Reference(pi.data)][0];
            out.replies.push($a1a91b25d7598376$var$parse_TSD_CommentStorageArchive(M, cs.data));
        });
    }
    return out;
}
function $a1a91b25d7598376$var$iwa_to_s5s_comment(iwa) {
    var out = [];
    out.push({
        t: iwa.t || "",
        a: iwa.a,
        T: iwa.replies && iwa.replies.length > 0
    });
    if (iwa.replies) iwa.replies.forEach(function(reply) {
        out.push({
            t: reply.t || "",
            a: reply.a,
            T: true
        });
    });
    return out;
}
function $a1a91b25d7598376$var$s5s_to_iwa_comment(s5s) {
    var out = {
        a: "",
        t: "",
        replies: []
    };
    for(var i = 0; i < s5s.length; ++i)if (i == 0) {
        out.a = s5s[i].a;
        out.t = s5s[i].t;
    } else out.replies.push({
        a: s5s[i].a,
        t: s5s[i].t
    });
    return out;
}
function $a1a91b25d7598376$var$parse_TST_TableModelArchive(M, root, ws, opts) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n;
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var range = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    range.e.r = ($a1a91b25d7598376$var$varint_to_i32(pb[6][0].data) >>> 0) - 1;
    if (range.e.r < 0) throw new Error("Invalid row varint ".concat(pb[6][0].data));
    range.e.c = ($a1a91b25d7598376$var$varint_to_i32(pb[7][0].data) >>> 0) - 1;
    if (range.e.c < 0) throw new Error("Invalid col varint ".concat(pb[7][0].data));
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(range);
    var dense = ws["!data"] != null, dws = ws;
    var store = $a1a91b25d7598376$var$parse_shallow(pb[4][0].data);
    var lut = $a1a91b25d7598376$var$numbers_lut_new();
    if ((_a = store[4]) == null ? void 0 : _a[0]) lut.sst = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[4][0].data)][0]);
    if ((_b = store[6]) == null ? void 0 : _b[0]) lut.fmla = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[6][0].data)][0]);
    if ((_c = store[11]) == null ? void 0 : _c[0]) lut.ofmt = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[11][0].data)][0]);
    if ((_d = store[12]) == null ? void 0 : _d[0]) lut.ferr = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[12][0].data)][0]);
    if ((_e = store[17]) == null ? void 0 : _e[0]) lut.rsst = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[17][0].data)][0]);
    if ((_f = store[19]) == null ? void 0 : _f[0]) lut.cmnt = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[19][0].data)][0]);
    if ((_g = store[22]) == null ? void 0 : _g[0]) lut.nfmt = $a1a91b25d7598376$var$parse_TST_TableDataList(M, M[$a1a91b25d7598376$var$parse_TSP_Reference(store[22][0].data)][0]);
    var tile = $a1a91b25d7598376$var$parse_shallow(store[3][0].data);
    var _R = 0;
    if (!((_h = store[9]) == null ? void 0 : _h[0])) throw "NUMBERS file missing row tree";
    var rtt = $a1a91b25d7598376$var$parse_shallow(store[9][0].data)[1].map(function(p) {
        return $a1a91b25d7598376$var$parse_shallow(p.data);
    });
    rtt.forEach(function(kv) {
        _R = $a1a91b25d7598376$var$varint_to_i32(kv[1][0].data);
        var tidx = $a1a91b25d7598376$var$varint_to_i32(kv[2][0].data);
        var t = tile[1][tidx];
        if (!t) throw "NUMBERS missing tile " + tidx;
        var tl = $a1a91b25d7598376$var$parse_shallow(t.data);
        var ref2 = M[$a1a91b25d7598376$var$parse_TSP_Reference(tl[2][0].data)][0];
        var mtype2 = $a1a91b25d7598376$var$varint_to_i32(ref2.meta[1][0].data);
        if (mtype2 != 6002) throw new Error("6001 unexpected reference to ".concat(mtype2));
        var _tile = $a1a91b25d7598376$var$parse_TST_Tile(M, ref2);
        _tile.data.forEach(function(row, R) {
            row.forEach(function(buf, C) {
                var res = $a1a91b25d7598376$var$parse_cell_storage(buf, lut, opts);
                if (res) {
                    if (dense) {
                        if (!dws["!data"][_R + R]) dws["!data"][_R + R] = [];
                        dws["!data"][_R + R][C] = res;
                    } else ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(_R + R)] = res;
                }
            });
        });
        _R += _tile.nrows;
    });
    if ((_i = store[13]) == null ? void 0 : _i[0]) {
        var ref = M[$a1a91b25d7598376$var$parse_TSP_Reference(store[13][0].data)][0];
        var mtype = $a1a91b25d7598376$var$varint_to_i32(ref.meta[1][0].data);
        if (mtype != 6144) throw new Error("Expected merge type 6144, found ".concat(mtype));
        ws["!merges"] = (_j = $a1a91b25d7598376$var$parse_shallow(ref.data)) == null ? void 0 : _j[1].map(function(pi) {
            var merge = $a1a91b25d7598376$var$parse_shallow(pi.data);
            var origin = $a1a91b25d7598376$var$u8_to_dataview($a1a91b25d7598376$var$parse_shallow(merge[1][0].data)[1][0].data), size = $a1a91b25d7598376$var$u8_to_dataview($a1a91b25d7598376$var$parse_shallow(merge[2][0].data)[1][0].data);
            return {
                s: {
                    r: origin.getUint16(0, true),
                    c: origin.getUint16(2, true)
                },
                e: {
                    r: origin.getUint16(0, true) + size.getUint16(0, true) - 1,
                    c: origin.getUint16(2, true) + size.getUint16(2, true) - 1
                }
            };
        });
    }
    if (!((_k = ws["!merges"]) == null ? void 0 : _k.length) && ((_l = pb[47]) == null ? void 0 : _l[0])) {
        var merge_owner = $a1a91b25d7598376$var$parse_shallow(pb[47][0].data);
        if ((_m = merge_owner[2]) == null ? void 0 : _m[0]) {
            var formula_store = $a1a91b25d7598376$var$parse_shallow(merge_owner[2][0].data);
            if ((_n = formula_store[3]) == null ? void 0 : _n[0]) ws["!merges"] = $a1a91b25d7598376$var$mappa(formula_store[3], function(u) {
                var _a2, _b2, _c2, _d2, _e2;
                var formula_pair = $a1a91b25d7598376$var$parse_shallow(u);
                var formula = $a1a91b25d7598376$var$parse_shallow(formula_pair[2][0].data);
                var AST_node_array = $a1a91b25d7598376$var$parse_shallow(formula[1][0].data);
                if (!((_a2 = AST_node_array[1]) == null ? void 0 : _a2[0])) return;
                var AST_node0 = $a1a91b25d7598376$var$parse_shallow(AST_node_array[1][0].data);
                var AST_node_type = $a1a91b25d7598376$var$varint_to_i32(AST_node0[1][0].data);
                if (AST_node_type != 67) return;
                var AST_colon_tract = $a1a91b25d7598376$var$parse_shallow(AST_node0[40][0].data);
                if (!((_b2 = AST_colon_tract[3]) == null ? void 0 : _b2[0]) || !((_c2 = AST_colon_tract[4]) == null ? void 0 : _c2[0])) return;
                var colrange = $a1a91b25d7598376$var$parse_shallow(AST_colon_tract[3][0].data);
                var rowrange = $a1a91b25d7598376$var$parse_shallow(AST_colon_tract[4][0].data);
                var c = $a1a91b25d7598376$var$varint_to_i32(colrange[1][0].data);
                var C = ((_d2 = colrange[2]) == null ? void 0 : _d2[0]) ? $a1a91b25d7598376$var$varint_to_i32(colrange[2][0].data) : c;
                var r = $a1a91b25d7598376$var$varint_to_i32(rowrange[1][0].data);
                var R = ((_e2 = rowrange[2]) == null ? void 0 : _e2[0]) ? $a1a91b25d7598376$var$varint_to_i32(rowrange[2][0].data) : r;
                return {
                    s: {
                        r: r,
                        c: c
                    },
                    e: {
                        r: R,
                        c: C
                    }
                };
            }).filter(function(x) {
                return x != null;
            });
        }
    }
}
function $a1a91b25d7598376$var$parse_TST_TableInfoArchive(M, root, opts) {
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var out = {
        "!ref": "A1"
    };
    if (opts == null ? void 0 : opts.dense) out["!data"] = [];
    var tableref = M[$a1a91b25d7598376$var$parse_TSP_Reference(pb[2][0].data)];
    var mtype = $a1a91b25d7598376$var$varint_to_i32(tableref[0].meta[1][0].data);
    if (mtype != 6001) throw new Error("6000 unexpected reference to ".concat(mtype));
    $a1a91b25d7598376$var$parse_TST_TableModelArchive(M, tableref[0], out, opts);
    return out;
}
function $a1a91b25d7598376$var$parse_TN_SheetArchive(M, root, opts) {
    var _a;
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    var out = {
        name: ((_a = pb[1]) == null ? void 0 : _a[0]) ? $a1a91b25d7598376$var$u8str(pb[1][0].data) : "",
        sheets: []
    };
    var shapeoffs = $a1a91b25d7598376$var$mappa(pb[2], $a1a91b25d7598376$var$parse_TSP_Reference);
    shapeoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $a1a91b25d7598376$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 6e3) out.sheets.push($a1a91b25d7598376$var$parse_TST_TableInfoArchive(M, m, opts));
        });
    });
    return out;
}
function $a1a91b25d7598376$var$parse_TN_DocumentArchive(M, root, opts) {
    var _a;
    var out = $a1a91b25d7598376$var$book_new();
    out.Workbook = {
        WBProps: {
            date1904: true
        }
    };
    var pb = $a1a91b25d7598376$var$parse_shallow(root.data);
    if ((_a = pb[2]) == null ? void 0 : _a[0]) throw new Error("Keynote presentations are not supported");
    var sheetoffs = $a1a91b25d7598376$var$mappa(pb[1], $a1a91b25d7598376$var$parse_TSP_Reference);
    sheetoffs.forEach(function(off) {
        M[off].forEach(function(m) {
            var mtype = $a1a91b25d7598376$var$varint_to_i32(m.meta[1][0].data);
            if (mtype == 2) {
                var root2 = $a1a91b25d7598376$var$parse_TN_SheetArchive(M, m, opts);
                root2.sheets.forEach(function(sheet, idx) {
                    $a1a91b25d7598376$var$book_append_sheet(out, sheet, idx == 0 ? root2.name : root2.name + "_" + idx, true);
                });
            }
        });
    });
    if (out.SheetNames.length == 0) throw new Error("Empty NUMBERS file");
    out.bookType = "numbers";
    return out;
}
function $a1a91b25d7598376$var$parse_numbers_iwa(cfb, opts) {
    var _a, _b, _c, _d, _e, _f, _g;
    var M = {}, indices = [];
    cfb.FullPaths.forEach(function(p) {
        if (p.match(/\.iwpv2/)) throw new Error("Unsupported password protection");
    });
    cfb.FileIndex.forEach(function(s) {
        if (!s.name.match(/\.iwa$/)) return;
        if (s.content[0] != 0) return;
        var o;
        try {
            o = $a1a91b25d7598376$var$decompress_iwa_file(s.content);
        } catch (e) {
            return console.log("?? " + s.content.length + " " + (e.message || e));
        }
        var packets;
        try {
            packets = $a1a91b25d7598376$var$parse_iwa_file(o);
        } catch (e) {
            return console.log("## " + (e.message || e));
        }
        packets.forEach(function(packet) {
            M[packet.id] = packet.messages;
            indices.push(packet.id);
        });
    });
    if (!indices.length) throw new Error("File has no messages");
    if (((_c = (_b = (_a = M == null ? void 0 : M[1]) == null ? void 0 : _a[0].meta) == null ? void 0 : _b[1]) == null ? void 0 : _c[0].data) && $a1a91b25d7598376$var$varint_to_i32(M[1][0].meta[1][0].data) == 1e4) throw new Error("Pages documents are not supported");
    var docroot = ((_g = (_f = (_e = (_d = M == null ? void 0 : M[1]) == null ? void 0 : _d[0]) == null ? void 0 : _e.meta) == null ? void 0 : _f[1]) == null ? void 0 : _g[0].data) && $a1a91b25d7598376$var$varint_to_i32(M[1][0].meta[1][0].data) == 1 && M[1][0];
    if (!docroot) indices.forEach(function(idx) {
        M[idx].forEach(function(iwam) {
            var mtype = $a1a91b25d7598376$var$varint_to_i32(iwam.meta[1][0].data) >>> 0;
            if (mtype == 1) {
                if (!docroot) docroot = iwam;
                else throw new Error("Document has multiple roots");
            }
        });
    });
    if (!docroot) throw new Error("Cannot find Document root");
    return $a1a91b25d7598376$var$parse_TN_DocumentArchive(M, docroot, opts);
}
function $a1a91b25d7598376$var$write_TST_TileRowInfo(data, lut, wide) {
    var _a, _b, _c;
    var tri = [
        [],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(0)
            }
        ],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(0)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(5)
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array([])
            }
        ],
        [
            {
                type: 2,
                data: new Uint8Array(Array.from({
                    length: 510
                }, function() {
                    return 255;
                }))
            }
        ],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(1)
            }
        ]
    ];
    if (!((_a = tri[6]) == null ? void 0 : _a[0]) || !((_b = tri[7]) == null ? void 0 : _b[0])) throw "Mutation only works on post-BNC storages!";
    var cnt = 0;
    if (tri[7][0].data.length < 2 * data.length) {
        var new_7 = new Uint8Array(2 * data.length);
        new_7.set(tri[7][0].data);
        tri[7][0].data = new_7;
    }
    if (tri[4][0].data.length < 2 * data.length) {
        var new_4 = new Uint8Array(2 * data.length);
        new_4.set(tri[4][0].data);
        tri[4][0].data = new_4;
    }
    var dv = $a1a91b25d7598376$var$u8_to_dataview(tri[7][0].data), last_offset = 0, cell_storage = [];
    var _dv = $a1a91b25d7598376$var$u8_to_dataview(tri[4][0].data), _last_offset = 0, _cell_storage = [];
    var width = wide ? 4 : 1;
    for(var C = 0; C < data.length; ++C){
        if (data[C] == null || data[C].t == "z" && !((_c = data[C].c) == null ? void 0 : _c.length) || data[C].t == "e") {
            dv.setUint16(C * 2, 65535, true);
            _dv.setUint16(C * 2, 65535);
            continue;
        }
        dv.setUint16(C * 2, last_offset / width, true);
        _dv.setUint16(C * 2, _last_offset / width, true);
        var celload, _celload;
        switch(data[C].t){
            case "d":
                if (data[C].v instanceof Date) {
                    celload = $a1a91b25d7598376$var$write_new_storage(data[C], lut);
                    _celload = $a1a91b25d7598376$var$write_old_storage(data[C], lut);
                    break;
                }
                celload = $a1a91b25d7598376$var$write_new_storage(data[C], lut);
                _celload = $a1a91b25d7598376$var$write_old_storage(data[C], lut);
                break;
            case "s":
            case "n":
            case "b":
            case "z":
                celload = $a1a91b25d7598376$var$write_new_storage(data[C], lut);
                _celload = $a1a91b25d7598376$var$write_old_storage(data[C], lut);
                break;
            default:
                throw new Error("Unsupported value " + data[C]);
        }
        cell_storage.push(celload);
        last_offset += celload.length;
        _cell_storage.push(_celload);
        _last_offset += _celload.length;
        ++cnt;
    }
    tri[2][0].data = $a1a91b25d7598376$var$write_varint49(cnt);
    tri[5][0].data = $a1a91b25d7598376$var$write_varint49(5);
    for(; C < tri[7][0].data.length / 2; ++C){
        dv.setUint16(C * 2, 65535, true);
        _dv.setUint16(C * 2, 65535, true);
    }
    tri[6][0].data = $a1a91b25d7598376$var$u8concat(cell_storage);
    tri[3][0].data = $a1a91b25d7598376$var$u8concat(_cell_storage);
    tri[8] = [
        {
            type: 0,
            data: $a1a91b25d7598376$var$write_varint49(wide ? 1 : 0)
        }
    ];
    return tri;
}
function $a1a91b25d7598376$var$write_iwam(type, payload) {
    return {
        meta: [
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(type)
                }
            ]
        ],
        data: payload
    };
}
function $a1a91b25d7598376$var$get_unique_msgid(dep, dependents) {
    if (!dependents.last) dependents.last = 927262;
    for(var i = dependents.last; i < 2e6; ++i)if (!dependents[i]) {
        dependents[dependents.last = i] = dep;
        return i;
    }
    throw new Error("Too many messages");
}
function $a1a91b25d7598376$var$build_numbers_deps(cfb) {
    var dependents = {};
    var indices = [];
    cfb.FileIndex.map(function(fi, idx) {
        return [
            fi,
            cfb.FullPaths[idx]
        ];
    }).forEach(function(row) {
        var fi = row[0], fp = row[1];
        if (fi.type != 2) return;
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(fi.content)).forEach(function(packet) {
            indices.push(packet.id);
            dependents[packet.id] = {
                deps: [],
                location: fp,
                type: $a1a91b25d7598376$var$varint_to_i32(packet.messages[0].meta[1][0].data)
            };
        });
    });
    cfb.FileIndex.forEach(function(fi) {
        if (!fi.name.match(/\.iwa/)) return;
        if (fi.content[0] != 0) return;
        $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(fi.content)).forEach(function(ia) {
            ia.messages.forEach(function(mess) {
                [
                    5,
                    6
                ].forEach(function(f) {
                    if (!mess.meta[f]) return;
                    mess.meta[f].forEach(function(x) {
                        dependents[ia.id].deps.push($a1a91b25d7598376$var$varint_to_i32(x.data));
                    });
                });
            });
        });
    });
    return dependents;
}
function $a1a91b25d7598376$var$write_TSP_Color_RGB(r, g, b) {
    return $a1a91b25d7598376$var$write_shallow([
        [],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(1)
            }
        ],
        [],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    r / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    g / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    b / 255
                ]).buffer)
            }
        ],
        [
            {
                type: 5,
                data: new Uint8Array(Float32Array.from([
                    1
                ]).buffer)
            }
        ],
        [],
        [],
        [],
        [],
        [],
        [
            {
                type: 0,
                data: $a1a91b25d7598376$var$write_varint49(1)
            }
        ]
    ]);
}
function $a1a91b25d7598376$var$get_author_color(n) {
    switch(n){
        case 0:
            return $a1a91b25d7598376$var$write_TSP_Color_RGB(99, 222, 171);
        case 1:
            return $a1a91b25d7598376$var$write_TSP_Color_RGB(162, 197, 240);
        case 2:
            return $a1a91b25d7598376$var$write_TSP_Color_RGB(255, 189, 189);
    }
    return $a1a91b25d7598376$var$write_TSP_Color_RGB(Math.random() * 255, Math.random() * 255, Math.random() * 255);
}
function $a1a91b25d7598376$var$write_numbers_iwa(wb, opts) {
    if (!opts || !opts.numbers) throw new Error("Must pass a `numbers` option -- check the README");
    var cfb = $a1a91b25d7598376$export$9f0e51cd97c572a.read(opts.numbers, {
        type: "base64"
    });
    var deps = $a1a91b25d7598376$var$build_numbers_deps(cfb);
    var docroot = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, 1);
    if (docroot == null) throw "Could not find message ".concat(1, " in Numbers template");
    var sheetrefs = $a1a91b25d7598376$var$mappa($a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data)[1], $a1a91b25d7598376$var$parse_TSP_Reference);
    if (sheetrefs.length > 1) throw new Error("Template NUMBERS file must have exactly one sheet");
    wb.SheetNames.forEach(function(name, idx) {
        if (idx >= 1) {
            $a1a91b25d7598376$var$numbers_add_ws(cfb, deps, idx + 1);
            docroot = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, 1);
            sheetrefs = $a1a91b25d7598376$var$mappa($a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data)[1], $a1a91b25d7598376$var$parse_TSP_Reference);
        }
        $a1a91b25d7598376$var$write_numbers_ws(cfb, deps, wb.Sheets[name], name, idx, sheetrefs[idx]);
    });
    return cfb;
}
function $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, id, cb) {
    var entry = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    cb(ainfo, x);
    entry.content = $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file(x));
    entry.size = entry.content.length;
}
function $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, id) {
    var entry = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, deps[id].location);
    if (!entry) throw "Could not find ".concat(deps[id].location, " in Numbers template");
    var x = $a1a91b25d7598376$var$parse_iwa_file($a1a91b25d7598376$var$decompress_iwa_file(entry.content));
    var ainfo = x.find(function(packet) {
        return packet.id == id;
    });
    return ainfo;
}
function $a1a91b25d7598376$var$numbers_add_meta(mlist, newid, newloc) {
    mlist[3].push({
        type: 2,
        data: $a1a91b25d7598376$var$write_shallow([
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(newid)
                }
            ],
            [
                {
                    type: 2,
                    data: $a1a91b25d7598376$var$stru8(newloc.replace(/-[\s\S]*$/, ""))
                }
            ],
            [
                {
                    type: 2,
                    data: $a1a91b25d7598376$var$stru8(newloc)
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [
                {
                    type: 2,
                    data: new Uint8Array([
                        2,
                        0,
                        0
                    ])
                }
            ],
            [],
            [],
            [],
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(0)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(0)
                }
            ]
        ])
    });
    mlist[1] = [
        {
            type: 0,
            data: $a1a91b25d7598376$var$write_varint49(Math.max(newid + 1, $a1a91b25d7598376$var$varint_to_i32(mlist[1][0].data)))
        }
    ];
}
function $a1a91b25d7598376$var$numbers_add_msg(cfb, type, msg, path, deps, id) {
    if (!id) id = $a1a91b25d7598376$var$get_unique_msgid({
        deps: [],
        location: "",
        type: type
    }, deps);
    var loc = "".concat(path, "-").concat(id, ".iwa");
    deps[id].location = "Root Entry" + loc;
    $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, loc, $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
        {
            id: id,
            messages: [
                $a1a91b25d7598376$var$write_iwam(type, $a1a91b25d7598376$var$write_shallow(msg))
            ]
        }
    ])));
    var newloc = loc.replace(/^[\/]/, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
        $a1a91b25d7598376$var$numbers_add_meta(mlist, id || 0, newloc);
        ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
    });
    return id;
}
function $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    (Array.isArray(dep) ? dep : [
        dep
    ]).forEach(function(dep2) {
        parent[6].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(dep2)
                    }
                ]
            ])
        });
    });
    mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
}
function $a1a91b25d7598376$var$numbers_meta_del_dep(mlist, deps, id, dep) {
    var loc = deps[id].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
    var parentidx = mlist[3].findIndex(function(m) {
        var _a, _b;
        var mm = $a1a91b25d7598376$var$parse_shallow(m.data);
        if ((_a = mm[3]) == null ? void 0 : _a[0]) return $a1a91b25d7598376$var$u8str(mm[3][0].data) == loc;
        if (((_b = mm[2]) == null ? void 0 : _b[0]) && $a1a91b25d7598376$var$u8str(mm[2][0].data) == loc) return true;
        return false;
    });
    var parent = $a1a91b25d7598376$var$parse_shallow(mlist[3][parentidx].data);
    if (!parent[6]) parent[6] = [];
    parent[6] = parent[6].filter(function(m) {
        return $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(m.data)[1][0].data) != dep;
    });
    mlist[3][parentidx].data = $a1a91b25d7598376$var$write_shallow(parent);
}
function $a1a91b25d7598376$var$numbers_add_ws(cfb, deps, wsidx) {
    var sheetref = -1, newsheetref = -1;
    var remap = {};
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 1, function(docroot, arch) {
        var doc = $a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data);
        sheetref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data)[1][0].data);
        newsheetref = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [
                1
            ],
            location: deps[sheetref].location,
            type: 2
        }, deps);
        remap[sheetref] = newsheetref;
        $a1a91b25d7598376$var$numbers_add_oref(docroot, newsheetref);
        doc[1].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_TSP_Reference(newsheetref)
        });
        var sheet = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, sheetref);
        sheet.id = newsheetref;
        if (deps[1].location == deps[newsheetref].location) arch.push(sheet);
        else $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, newsheetref, function(_, x) {
            return x.push(sheet);
        });
        docroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(doc);
    });
    var tiaref = -1;
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, newsheetref, function(sheetroot, arch) {
        var sa = $a1a91b25d7598376$var$parse_shallow(sheetroot.messages[0].data);
        for(var i = 3; i <= 69; ++i)delete sa[i];
        var drawables = $a1a91b25d7598376$var$mappa(sa[2], $a1a91b25d7598376$var$parse_TSP_Reference);
        drawables.forEach(function(n) {
            return $a1a91b25d7598376$var$numbers_del_oref(sheetroot, n);
        });
        tiaref = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [
                newsheetref
            ],
            location: deps[drawables[0]].location,
            type: deps[drawables[0]].type
        }, deps);
        $a1a91b25d7598376$var$numbers_add_oref(sheetroot, tiaref);
        remap[drawables[0]] = tiaref;
        sa[2] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$write_TSP_Reference(tiaref)
            }
        ];
        var tia = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, drawables[0]);
        tia.id = tiaref;
        if (deps[drawables[0]].location == deps[newsheetref].location) arch.push(tia);
        else {
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, newsheetref, tiaref);
                ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
            });
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tiaref, function(_, x) {
                return x.push(tia);
            });
        }
        sheetroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(sa);
    });
    var tmaref = -1;
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tiaref, function(tiaroot, arch) {
        var tia = $a1a91b25d7598376$var$parse_shallow(tiaroot.messages[0].data);
        var da = $a1a91b25d7598376$var$parse_shallow(tia[1][0].data);
        for(var i = 3; i <= 69; ++i)delete da[i];
        var dap = $a1a91b25d7598376$var$parse_TSP_Reference(da[2][0].data);
        da[2][0].data = $a1a91b25d7598376$var$write_TSP_Reference(remap[dap]);
        tia[1][0].data = $a1a91b25d7598376$var$write_shallow(da);
        var oldtmaref = $a1a91b25d7598376$var$parse_TSP_Reference(tia[2][0].data);
        $a1a91b25d7598376$var$numbers_del_oref(tiaroot, oldtmaref);
        tmaref = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [
                tiaref
            ],
            location: deps[oldtmaref].location,
            type: deps[oldtmaref].type
        }, deps);
        $a1a91b25d7598376$var$numbers_add_oref(tiaroot, tmaref);
        remap[oldtmaref] = tmaref;
        tia[2][0].data = $a1a91b25d7598376$var$write_TSP_Reference(tmaref);
        var tma = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldtmaref);
        tma.id = tmaref;
        if (deps[tiaref].location == deps[tmaref].location) arch.push(tma);
        else $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tmaref, function(_, x) {
            return x.push(tma);
        });
        tiaroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(tia);
    });
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tmaref, function(tmaroot, arch) {
        var _a, _b;
        var tma = $a1a91b25d7598376$var$parse_shallow(tmaroot.messages[0].data);
        var uuid = $a1a91b25d7598376$var$u8str(tma[1][0].data), new_uuid = uuid.replace(/-[A-Z0-9]*/, "-".concat(("0000" + wsidx.toString(16)).slice(-4)));
        tma[1][0].data = $a1a91b25d7598376$var$stru8(new_uuid);
        [
            12,
            13,
            29,
            31,
            32,
            33,
            39,
            44,
            47,
            81,
            82,
            84
        ].forEach(function(n) {
            return delete tma[n];
        });
        if (tma[45]) {
            var srrta = $a1a91b25d7598376$var$parse_shallow(tma[45][0].data);
            var ref = $a1a91b25d7598376$var$parse_TSP_Reference(srrta[1][0].data);
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, ref);
            delete tma[45];
        }
        if (tma[70]) {
            var hsoa = $a1a91b25d7598376$var$parse_shallow(tma[70][0].data);
            (_a = hsoa[2]) == null || _a.forEach(function(item) {
                var hsa = $a1a91b25d7598376$var$parse_shallow(item.data);
                [
                    2,
                    3
                ].map(function(n) {
                    return hsa[n][0];
                }).forEach(function(hseadata) {
                    var hsea = $a1a91b25d7598376$var$parse_shallow(hseadata.data);
                    if (!hsea[8]) return;
                    var ref2 = $a1a91b25d7598376$var$parse_TSP_Reference(hsea[8][0].data);
                    $a1a91b25d7598376$var$numbers_del_oref(tmaroot, ref2);
                });
            });
            delete tma[70];
        }
        [
            46,
            30,
            34,
            35,
            36,
            38,
            48,
            49,
            60,
            61,
            62,
            63,
            64,
            71,
            72,
            73,
            74,
            75,
            85,
            86,
            87,
            88,
            89
        ].forEach(function(n) {
            if (!tma[n]) return;
            var ref2 = $a1a91b25d7598376$var$parse_TSP_Reference(tma[n][0].data);
            delete tma[n];
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, ref2);
        });
        var store = $a1a91b25d7598376$var$parse_shallow(tma[4][0].data);
        [
            2,
            4,
            5,
            6,
            11,
            12,
            13,
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22
        ].forEach(function(n) {
            var _a2;
            if (!((_a2 = store[n]) == null ? void 0 : _a2[0])) return;
            var oldref = $a1a91b25d7598376$var$parse_TSP_Reference(store[n][0].data);
            var newref = $a1a91b25d7598376$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, oldref);
            $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    $a1a91b25d7598376$var$numbers_add_meta(mlist, newref, newloc);
                    $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            }
            store[n][0].data = $a1a91b25d7598376$var$write_TSP_Reference(newref);
        });
        var row_headers = $a1a91b25d7598376$var$parse_shallow(store[1][0].data);
        (_b = row_headers[2]) == null || _b.forEach(function(tspref) {
            var oldref = $a1a91b25d7598376$var$parse_TSP_Reference(tspref.data);
            var newref = $a1a91b25d7598376$var$get_unique_msgid({
                deps: [
                    tmaref
                ],
                location: deps[oldref].location,
                type: deps[oldref].type
            }, deps);
            $a1a91b25d7598376$var$numbers_del_oref(tmaroot, oldref);
            $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newref);
            remap[oldref] = newref;
            var msg = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldref);
            msg.id = newref;
            if (deps[oldref].location == deps[tmaref].location) arch.push(msg);
            else {
                deps[newref].location = deps[oldref].location.replace(oldref.toString(), newref.toString());
                if (deps[newref].location == deps[oldref].location) deps[newref].location = deps[newref].location.replace(/\.iwa/, "-".concat(newref, ".iwa"));
                $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, deps[newref].location, $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
                    msg
                ])));
                var newloc = deps[newref].location.replace(/^Root Entry\//, "").replace(/^Index\//, "").replace(/\.iwa$/, "");
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    $a1a91b25d7598376$var$numbers_add_meta(mlist, newref, newloc);
                    $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tmaref, newref);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            }
            tspref.data = $a1a91b25d7598376$var$write_TSP_Reference(newref);
        });
        store[1][0].data = $a1a91b25d7598376$var$write_shallow(row_headers);
        var tiles = $a1a91b25d7598376$var$parse_shallow(store[3][0].data);
        tiles[1].forEach(function(t) {
            var tst = $a1a91b25d7598376$var$parse_shallow(t.data);
            var oldtileref = $a1a91b25d7598376$var$parse_TSP_Reference(tst[2][0].data);
            var newtileref = remap[oldtileref];
            if (!remap[oldtileref]) {
                newtileref = $a1a91b25d7598376$var$get_unique_msgid({
                    deps: [
                        tmaref
                    ],
                    location: "",
                    type: deps[oldtileref].type
                }, deps);
                deps[newtileref].location = "Root Entry/Index/Tables/Tile-".concat(newtileref, ".iwa");
                remap[oldtileref] = newtileref;
                var oldtile = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, oldtileref);
                oldtile.id = newtileref;
                $a1a91b25d7598376$var$numbers_del_oref(tmaroot, oldtileref);
                $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newtileref);
                $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileref, ".iwa"), $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
                    oldtile
                ])));
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    mlist[3].push({
                        type: 2,
                        data: $a1a91b25d7598376$var$write_shallow([
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(newtileref)
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $a1a91b25d7598376$var$stru8("Tables/Tile")
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: $a1a91b25d7598376$var$stru8("Tables/Tile-".concat(newtileref))
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [
                                {
                                    type: 2,
                                    data: new Uint8Array([
                                        2,
                                        0,
                                        0
                                    ])
                                }
                            ],
                            [],
                            [],
                            [],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(0)
                                }
                            ],
                            [],
                            [
                                {
                                    type: 0,
                                    data: $a1a91b25d7598376$var$write_varint49(0)
                                }
                            ]
                        ])
                    });
                    mlist[1] = [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(Math.max(newtileref + 1, $a1a91b25d7598376$var$varint_to_i32(mlist[1][0].data)))
                        }
                    ];
                    $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileref);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            }
            tst[2][0].data = $a1a91b25d7598376$var$write_TSP_Reference(newtileref);
            t.data = $a1a91b25d7598376$var$write_shallow(tst);
        });
        store[3][0].data = $a1a91b25d7598376$var$write_shallow(tiles);
        tma[4][0].data = $a1a91b25d7598376$var$write_shallow(store);
        tmaroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(tma);
    });
}
function $a1a91b25d7598376$var$write_numbers_ws(cfb, deps, ws, wsname, sheetidx, rootref) {
    var drawables = [];
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, rootref, function(docroot) {
        var sheetref = $a1a91b25d7598376$var$parse_shallow(docroot.messages[0].data);
        sheetref[1] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$stru8(wsname)
            }
        ];
        drawables = $a1a91b25d7598376$var$mappa(sheetref[2], $a1a91b25d7598376$var$parse_TSP_Reference);
        docroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(sheetref);
    });
    var tia = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, drawables[0]);
    var tmaref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(tia.messages[0].data)[2][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tmaref, function(docroot, x) {
        return $a1a91b25d7598376$var$write_numbers_tma(cfb, deps, ws, docroot, x, tmaref);
    });
}
var $a1a91b25d7598376$var$USE_WIDE_ROWS = true;
function $a1a91b25d7598376$var$write_numbers_tma(cfb, deps, ws, tmaroot, tmafile, tmaref) {
    if (!ws["!ref"]) throw new Error("Cannot export empty sheet to NUMBERS");
    var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
    range.s.r = range.s.c = 0;
    var trunc = false;
    if (range.e.c > 999) {
        trunc = true;
        range.e.c = 999;
    }
    if (range.e.r > 999999) {
        trunc = true;
        range.e.r = 999999;
    }
    if (trunc) console.error("Truncating to ".concat($a1a91b25d7598376$var$encode_range(range)));
    var data = [];
    if (ws["!data"]) data = ws["!data"];
    else {
        var colstr = [];
        for(var _C = 0; _C <= range.e.c; ++_C)colstr[_C] = $a1a91b25d7598376$var$encode_col(_C);
        for(var R_ = 0; R_ <= range.e.r; ++R_){
            data[R_] = [];
            var _R = "" + (R_ + 1);
            for(_C = 0; _C <= range.e.c; ++_C){
                var _cell = ws[colstr[_C] + _R];
                if (!_cell) continue;
                data[R_][_C] = _cell;
            }
        }
    }
    var LUT = {
        cmnt: [
            {
                a: "~54ee77S~",
                t: "... the people who are crazy enough to think they can change the world, are the ones who do."
            }
        ],
        ferr: [],
        fmla: [],
        nfmt: [],
        ofmt: [],
        rsst: [
            {
                v: "~54ee77S~",
                l: "https://sheetjs.com/"
            }
        ],
        sst: [
            "~Sh33tJ5~"
        ]
    };
    var pb = $a1a91b25d7598376$var$parse_shallow(tmaroot.messages[0].data);
    pb[6][0].data = $a1a91b25d7598376$var$write_varint49(range.e.r + 1);
    pb[7][0].data = $a1a91b25d7598376$var$write_varint49(range.e.c + 1);
    delete pb[46];
    var store = $a1a91b25d7598376$var$parse_shallow(pb[4][0].data);
    var row_header_ref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(store[1][0].data)[2][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, row_header_ref, function(rowhead, _x) {
        var _a;
        var base_bucket = $a1a91b25d7598376$var$parse_shallow(rowhead.messages[0].data);
        if ((_a = base_bucket == null ? void 0 : base_bucket[2]) == null ? void 0 : _a[0]) for(var R2 = 0; R2 < data.length; ++R2){
            var _bucket = $a1a91b25d7598376$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $a1a91b25d7598376$var$write_varint49(R2);
            _bucket[4][0].data = $a1a91b25d7598376$var$write_varint49(data[R2].length);
            base_bucket[2][R2] = {
                type: base_bucket[2][0].type,
                data: $a1a91b25d7598376$var$write_shallow(_bucket)
            };
        }
        rowhead.messages[0].data = $a1a91b25d7598376$var$write_shallow(base_bucket);
    });
    var col_header_ref = $a1a91b25d7598376$var$parse_TSP_Reference(store[2][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, col_header_ref, function(colhead, _x) {
        var base_bucket = $a1a91b25d7598376$var$parse_shallow(colhead.messages[0].data);
        for(var C = 0; C <= range.e.c; ++C){
            var _bucket = $a1a91b25d7598376$var$parse_shallow(base_bucket[2][0].data);
            _bucket[1][0].data = $a1a91b25d7598376$var$write_varint49(C);
            _bucket[4][0].data = $a1a91b25d7598376$var$write_varint49(range.e.r + 1);
            base_bucket[2][C] = {
                type: base_bucket[2][0].type,
                data: $a1a91b25d7598376$var$write_shallow(_bucket)
            };
        }
        colhead.messages[0].data = $a1a91b25d7598376$var$write_shallow(base_bucket);
    });
    var rbtree = $a1a91b25d7598376$var$parse_shallow(store[9][0].data);
    rbtree[1] = [];
    var tilestore = $a1a91b25d7598376$var$parse_shallow(store[3][0].data);
    var tstride = 256;
    tilestore[2] = [
        {
            type: 0,
            data: $a1a91b25d7598376$var$write_varint49(tstride)
        }
    ];
    var tileref = $a1a91b25d7598376$var$parse_TSP_Reference($a1a91b25d7598376$var$parse_shallow(tilestore[1][0].data)[2][0].data);
    var save_token = function() {
        var metadata = $a1a91b25d7598376$var$numbers_iwa_find(cfb, deps, 2);
        var mlist = $a1a91b25d7598376$var$parse_shallow(metadata.messages[0].data);
        var mlst = mlist[3].filter(function(m) {
            return $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(m.data)[1][0].data) == tileref;
        });
        return (mlst == null ? void 0 : mlst.length) ? $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(mlst[0].data)[12][0].data) : 0;
    }();
    $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_del(cfb, deps[tileref].location);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
        var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
        mlist[3] = mlist[3].filter(function(m) {
            return $a1a91b25d7598376$var$varint_to_i32($a1a91b25d7598376$var$parse_shallow(m.data)[1][0].data) != tileref;
        });
        $a1a91b25d7598376$var$numbers_meta_del_dep(mlist, deps, tmaref, tileref);
        ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
    });
    $a1a91b25d7598376$var$numbers_del_oref(tmaroot, tileref);
    tilestore[1] = [];
    var ntiles = Math.ceil((range.e.r + 1) / tstride);
    for(var tidx = 0; tidx < ntiles; ++tidx){
        var newtileid = $a1a91b25d7598376$var$get_unique_msgid({
            deps: [],
            location: "",
            type: 6002
        }, deps);
        deps[newtileid].location = "Root Entry/Index/Tables/Tile-".concat(newtileid, ".iwa");
        var tiledata = [
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(Math.min(range.e.r + 1, (tidx + 1) * tstride))
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(0)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(Math.min((tidx + 1) * tstride, range.e.r + 1) - tidx * tstride)
                }
            ],
            [],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(5)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(1)
                }
            ],
            [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49($a1a91b25d7598376$var$USE_WIDE_ROWS ? 1 : 0)
                }
            ]
        ];
        for(var R = tidx * tstride; R <= Math.min(range.e.r, (tidx + 1) * tstride - 1); ++R){
            var tilerow = $a1a91b25d7598376$var$write_TST_TileRowInfo(data[R], LUT, $a1a91b25d7598376$var$USE_WIDE_ROWS);
            tilerow[1][0].data = $a1a91b25d7598376$var$write_varint49(R - tidx * tstride);
            tiledata[5].push({
                data: $a1a91b25d7598376$var$write_shallow(tilerow),
                type: 2
            });
        }
        tilestore[1].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(tidx)
                    }
                ],
                [
                    {
                        type: 2,
                        data: $a1a91b25d7598376$var$write_TSP_Reference(newtileid)
                    }
                ]
            ])
        });
        var newtile = {
            id: newtileid,
            messages: [
                $a1a91b25d7598376$var$write_iwam(6002, $a1a91b25d7598376$var$write_shallow(tiledata))
            ]
        };
        var tilecontent = $a1a91b25d7598376$var$compress_iwa_file($a1a91b25d7598376$var$write_iwa_file([
            newtile
        ]));
        $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_add(cfb, "/Index/Tables/Tile-".concat(newtileid, ".iwa"), tilecontent);
        $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
            mlist[3].push({
                type: 2,
                data: $a1a91b25d7598376$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(newtileid)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8("Tables/Tile")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8("Tables/Tile-".concat(newtileid))
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: new Uint8Array([
                                2,
                                0,
                                0
                            ])
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(0)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(save_token)
                        }
                    ]
                ])
            });
            mlist[1] = [
                {
                    type: 0,
                    data: $a1a91b25d7598376$var$write_varint49(Math.max(newtileid + 1, $a1a91b25d7598376$var$varint_to_i32(mlist[1][0].data)))
                }
            ];
            $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tmaref, newtileid);
            ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
        });
        $a1a91b25d7598376$var$numbers_add_oref(tmaroot, newtileid);
        rbtree[1].push({
            type: 2,
            data: $a1a91b25d7598376$var$write_shallow([
                [],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(tidx * tstride)
                    }
                ],
                [
                    {
                        type: 0,
                        data: $a1a91b25d7598376$var$write_varint49(tidx)
                    }
                ]
            ])
        });
    }
    store[3][0].data = $a1a91b25d7598376$var$write_shallow(tilestore);
    store[9][0].data = $a1a91b25d7598376$var$write_shallow(rbtree);
    store[10] = [
        {
            type: 2,
            data: new Uint8Array([])
        }
    ];
    if (ws["!merges"]) {
        var mergeid = $a1a91b25d7598376$var$get_unique_msgid({
            type: 6144,
            deps: [
                tmaref
            ],
            location: deps[tmaref].location
        }, deps);
        tmafile.push({
            id: mergeid,
            messages: [
                $a1a91b25d7598376$var$write_iwam(6144, $a1a91b25d7598376$var$write_shallow([
                    [],
                    ws["!merges"].map(function(m) {
                        return {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 2,
                                        data: $a1a91b25d7598376$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.s.r,
                                                        m.s.c
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ],
                                [
                                    {
                                        type: 2,
                                        data: $a1a91b25d7598376$var$write_shallow([
                                            [],
                                            [
                                                {
                                                    type: 5,
                                                    data: new Uint8Array(new Uint16Array([
                                                        m.e.r - m.s.r + 1,
                                                        m.e.c - m.s.c + 1
                                                    ]).buffer)
                                                }
                                            ]
                                        ])
                                    }
                                ]
                            ])
                        };
                    })
                ]))
            ]
        });
        store[13] = [
            {
                type: 2,
                data: $a1a91b25d7598376$var$write_TSP_Reference(mergeid)
            }
        ];
        $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
            var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
            $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tmaref, mergeid);
            ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
        });
        $a1a91b25d7598376$var$numbers_add_oref(tmaroot, mergeid);
    } else delete store[13];
    var sstref = $a1a91b25d7598376$var$parse_TSP_Reference(store[4][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, sstref, function(sstroot) {
        var sstdata = $a1a91b25d7598376$var$parse_shallow(sstroot.messages[0].data);
        sstdata[3] = [];
        LUT.sst.forEach(function(str, i) {
            if (i == 0) return;
            sstdata[3].push({
                type: 2,
                data: $a1a91b25d7598376$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(1)
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8(str)
                        }
                    ]
                ])
            });
        });
        sstroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(sstdata);
    });
    var rsstref = $a1a91b25d7598376$var$parse_TSP_Reference(store[17][0].data);
    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, rsstref, function(rsstroot) {
        var rsstdata = $a1a91b25d7598376$var$parse_shallow(rsstroot.messages[0].data);
        rsstdata[3] = [];
        var style_indices = [
            904980,
            903835,
            903815,
            903845
        ];
        LUT.rsst.forEach(function(rsst, i) {
            if (i == 0) return;
            var tswpsa = [
                [],
                [
                    {
                        type: 0,
                        data: new Uint8Array([
                            5
                        ])
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: $a1a91b25d7598376$var$stru8(rsst.v)
                    }
                ]
            ];
            tswpsa[10] = [
                {
                    type: 0,
                    data: new Uint8Array([
                        1
                    ])
                }
            ];
            tswpsa[19] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        18,
                        2,
                        101,
                        110
                    ])
                }
            ];
            tswpsa[5] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        155,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[2] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        8,
                        148,
                        158,
                        55
                    ])
                }
            ];
            tswpsa[6] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[7] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        135,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[8] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        8,
                        8,
                        0,
                        18,
                        4,
                        8,
                        165,
                        149,
                        55
                    ])
                }
            ];
            tswpsa[14] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            tswpsa[24] = [
                {
                    type: 2,
                    data: new Uint8Array([
                        10,
                        6,
                        8,
                        0,
                        16,
                        0,
                        24,
                        0
                    ])
                }
            ];
            var tswpsaid = $a1a91b25d7598376$var$get_unique_msgid({
                deps: [],
                location: "",
                type: 2001
            }, deps);
            var tswpsarefs = [];
            if (rsst.l) {
                var newhlinkid = $a1a91b25d7598376$var$numbers_add_msg(cfb, 2032, [
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8(rsst.l)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                tswpsa[11] = [];
                var smartfield = [
                    [],
                    []
                ];
                if (!smartfield[1]) smartfield[1] = [];
                smartfield[1].push({
                    type: 2,
                    data: $a1a91b25d7598376$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $a1a91b25d7598376$var$write_varint49(0)
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$write_TSP_Reference(newhlinkid)
                            }
                        ]
                    ])
                });
                tswpsa[11][0] = {
                    type: 2,
                    data: $a1a91b25d7598376$var$write_shallow(smartfield)
                };
                tswpsarefs.push(newhlinkid);
            }
            $a1a91b25d7598376$var$numbers_add_msg(cfb, 2001, tswpsa, "/Index/Tables/DataList", deps, tswpsaid);
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, tswpsaid, function(iwa) {
                style_indices.forEach(function(ref) {
                    return $a1a91b25d7598376$var$numbers_add_oref(iwa, ref);
                });
                tswpsarefs.forEach(function(ref) {
                    return $a1a91b25d7598376$var$numbers_add_oref(iwa, ref);
                });
            });
            var rtpaid = $a1a91b25d7598376$var$numbers_add_msg(cfb, 6218, [
                [],
                [
                    {
                        type: 2,
                        data: $a1a91b25d7598376$var$write_TSP_Reference(tswpsaid)
                    }
                ],
                [],
                [
                    {
                        type: 2,
                        data: new Uint8Array([
                            13,
                            255,
                            255,
                            255,
                            0,
                            18,
                            10,
                            16,
                            255,
                            255,
                            1,
                            24,
                            255,
                            255,
                            255,
                            255,
                            7
                        ])
                    }
                ]
            ], "/Index/Tables/DataList", deps);
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, rtpaid, function(iwa) {
                return $a1a91b25d7598376$var$numbers_add_oref(iwa, tswpsaid);
            });
            rsstdata[3].push({
                type: 2,
                data: $a1a91b25d7598376$var$write_shallow([
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(i)
                        }
                    ],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(1)
                        }
                    ],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_TSP_Reference(rtpaid)
                        }
                    ]
                ])
            });
            $a1a91b25d7598376$var$numbers_add_oref(rsstroot, rtpaid);
            $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, rsstref, rtpaid);
                $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, rtpaid, tswpsaid);
                $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tswpsaid, tswpsarefs);
                $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, tswpsaid, style_indices);
                ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
            });
        });
        rsstroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(rsstdata);
    });
    if (LUT.cmnt.length > 1) {
        var cmntref = $a1a91b25d7598376$var$parse_TSP_Reference(store[19][0].data);
        var authors = {}, iauthor = 0;
        $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, cmntref, function(cmntroot) {
            var cmntdata = $a1a91b25d7598376$var$parse_shallow(cmntroot.messages[0].data);
            cmntdata[3] = [];
            LUT.cmnt.forEach(function(cc, i) {
                if (i == 0) return;
                var replies = [];
                if (cc.replies) cc.replies.forEach(function(c) {
                    if (!authors[c.a || ""]) authors[c.a || ""] = $a1a91b25d7598376$var$numbers_add_msg(cfb, 212, [
                        [],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$stru8(c.a || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$get_author_color(++iauthor)
                            }
                        ],
                        [],
                        [
                            {
                                type: 0,
                                data: $a1a91b25d7598376$var$write_varint49(0)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    var aaaid2 = authors[c.a || ""];
                    var csaid2 = $a1a91b25d7598376$var$numbers_add_msg(cfb, 3056, [
                        [],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$stru8(c.t || "")
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$write_shallow([
                                    [],
                                    [
                                        {
                                            type: 1,
                                            data: new Uint8Array([
                                                0,
                                                0,
                                                0,
                                                128,
                                                116,
                                                109,
                                                182,
                                                65
                                            ])
                                        }
                                    ]
                                ])
                            }
                        ],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$write_TSP_Reference(aaaid2)
                            }
                        ]
                    ], "/Index/Tables/DataList", deps);
                    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, csaid2, function(iwa) {
                        return $a1a91b25d7598376$var$numbers_add_oref(iwa, aaaid2);
                    });
                    replies.push(csaid2);
                    $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                        var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                        $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, csaid2, aaaid2);
                        ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                    });
                });
                if (!authors[cc.a || ""]) authors[cc.a || ""] = $a1a91b25d7598376$var$numbers_add_msg(cfb, 212, [
                    [],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8(cc.a || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$get_author_color(++iauthor)
                        }
                    ],
                    [],
                    [
                        {
                            type: 0,
                            data: $a1a91b25d7598376$var$write_varint49(0)
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                var aaaid = authors[cc.a || ""];
                var csaid = $a1a91b25d7598376$var$numbers_add_msg(cfb, 3056, [
                    [],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$stru8(cc.t || "")
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 1,
                                        data: new Uint8Array([
                                            0,
                                            0,
                                            0,
                                            128,
                                            116,
                                            109,
                                            182,
                                            65
                                        ])
                                    }
                                ]
                            ])
                        }
                    ],
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_TSP_Reference(aaaid)
                        }
                    ],
                    replies.map(function(r) {
                        return {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_TSP_Reference(r)
                        };
                    }),
                    [
                        {
                            type: 2,
                            data: $a1a91b25d7598376$var$write_shallow([
                                [],
                                [
                                    {
                                        type: 0,
                                        data: $a1a91b25d7598376$var$write_varint49(i)
                                    }
                                ],
                                [
                                    {
                                        type: 0,
                                        data: $a1a91b25d7598376$var$write_varint49(0)
                                    }
                                ]
                            ])
                        }
                    ]
                ], "/Index/Tables/DataList", deps);
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, csaid, function(iwa) {
                    $a1a91b25d7598376$var$numbers_add_oref(iwa, aaaid);
                    replies.forEach(function(r) {
                        return $a1a91b25d7598376$var$numbers_add_oref(iwa, r);
                    });
                });
                cmntdata[3].push({
                    type: 2,
                    data: $a1a91b25d7598376$var$write_shallow([
                        [],
                        [
                            {
                                type: 0,
                                data: $a1a91b25d7598376$var$write_varint49(i)
                            }
                        ],
                        [
                            {
                                type: 0,
                                data: $a1a91b25d7598376$var$write_varint49(1)
                            }
                        ],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [],
                        [
                            {
                                type: 2,
                                data: $a1a91b25d7598376$var$write_TSP_Reference(csaid)
                            }
                        ]
                    ])
                });
                $a1a91b25d7598376$var$numbers_add_oref(cmntroot, csaid);
                $a1a91b25d7598376$var$numbers_iwa_doit(cfb, deps, 2, function(ai) {
                    var mlist = $a1a91b25d7598376$var$parse_shallow(ai.messages[0].data);
                    $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, cmntref, csaid);
                    $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, csaid, aaaid);
                    if (replies.length) $a1a91b25d7598376$var$numbers_meta_add_dep(mlist, deps, csaid, replies);
                    ai.messages[0].data = $a1a91b25d7598376$var$write_shallow(mlist);
                });
            });
            cmntdata[2][0].data = $a1a91b25d7598376$var$write_varint49(LUT.cmnt.length + 1);
            cmntroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(cmntdata);
        });
    }
    pb[4][0].data = $a1a91b25d7598376$var$write_shallow(store);
    tmaroot.messages[0].data = $a1a91b25d7598376$var$write_shallow(pb);
}
function $a1a91b25d7598376$var$fix_opts_func(defaults /*:Array<Array<any> >*/ ) /*:{(o:any):void}*/ {
    return function fix_opts(opts) {
        for(var i = 0; i != defaults.length; ++i){
            var d = defaults[i];
            if (opts[d[0]] === undefined) opts[d[0]] = d[1];
            if (d[2] === 'n') opts[d[0]] = Number(opts[d[0]]);
        }
    };
}
function $a1a91b25d7598376$var$fix_read_opts(opts) {
    $a1a91b25d7598376$var$fix_opts_func([
        [
            'cellNF',
            false
        ],
        /* emit cell number format string as .z */ [
            'cellHTML',
            true
        ],
        /* emit html string as .h */ [
            'cellFormula',
            true
        ],
        /* emit formulae as .f */ [
            'cellStyles',
            false
        ],
        /* emits style/theme as .s */ [
            'cellText',
            true
        ],
        /* emit formatted text as .w */ [
            'cellDates',
            false
        ],
        /* emit date cells with type `d` */ [
            'sheetStubs',
            false
        ],
        /* emit empty cells */ [
            'sheetRows',
            0,
            'n'
        ],
        /* read n rows (0 = read all rows) */ [
            'bookDeps',
            false
        ],
        /* parse calculation chains */ [
            'bookSheets',
            false
        ],
        /* only try to get sheet names (no Sheets) */ [
            'bookProps',
            false
        ],
        /* only try to get properties (no Sheets) */ [
            'bookFiles',
            false
        ],
        /* include raw file structure (keys, files, cfb) */ [
            'bookVBA',
            false
        ],
        /* include vba raw data (vbaraw) */ [
            'password',
            ''
        ],
        /* password */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $a1a91b25d7598376$var$fix_write_opts(opts) {
    $a1a91b25d7598376$var$fix_opts_func([
        [
            'cellDates',
            false
        ],
        /* write date cells with type `d` */ [
            'bookSST',
            false
        ],
        /* Generate Shared String Table */ [
            'bookType',
            'xlsx'
        ],
        /* Type of workbook (xlsx/m/b) */ [
            'compression',
            false
        ],
        /* Use file compression */ [
            'WTF',
            false
        ]
    ])(opts);
}
function $a1a91b25d7598376$var$get_sheet_type(n /*:string*/ ) /*:string*/ {
    if ($a1a91b25d7598376$var$RELS.WS.indexOf(n) > -1) return "sheet";
    if ($a1a91b25d7598376$var$RELS.CS && n == $a1a91b25d7598376$var$RELS.CS) return "chart";
    if ($a1a91b25d7598376$var$RELS.DS && n == $a1a91b25d7598376$var$RELS.DS) return "dialog";
    if ($a1a91b25d7598376$var$RELS.MS && n == $a1a91b25d7598376$var$RELS.MS) return "macro";
    return n && n.length ? n : "sheet";
}
function $a1a91b25d7598376$var$safe_parse_wbrels(wbrels, sheets) {
    if (!wbrels) return 0;
    try {
        wbrels = sheets.map(function pwbr(w) {
            if (!w.id) w.id = w.strRelID;
            return [
                w.name,
                wbrels['!id'][w.id].Target,
                $a1a91b25d7598376$var$get_sheet_type(wbrels['!id'][w.id].Type)
            ];
        });
    } catch (e) {
        return null;
    }
    return !wbrels || wbrels.length === 0 ? null : wbrels;
}
function $a1a91b25d7598376$var$parse_sheet_legacy_drawing(sheet, type, zip, path, idx, opts, wb, comments) {
    if (!sheet || !sheet['!legdrawel']) return;
    var dfile = $a1a91b25d7598376$var$resolve_path(sheet['!legdrawel'].Target, path);
    var draw = $a1a91b25d7598376$var$getzipstr(zip, dfile, true);
    if (draw) $a1a91b25d7598376$var$parse_vml($a1a91b25d7598376$var$utf8read(draw), sheet, comments || []);
}
function $a1a91b25d7598376$var$safe_parse_sheet(zip, path /*:string*/ , relsPath /*:string*/ , sheet, idx /*:number*/ , sheetRels, sheets, stype /*:string*/ , opts, wb, themes, styles) {
    try {
        sheetRels[sheet] = $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, relsPath, true), path);
        var data = $a1a91b25d7598376$var$getzipdata(zip, path);
        var _ws;
        switch(stype){
            case 'sheet':
                _ws = $a1a91b25d7598376$var$parse_ws(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'chart':
                _ws = $a1a91b25d7598376$var$parse_cs(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                if (!_ws || !_ws['!drawel']) break;
                var dfile = $a1a91b25d7598376$var$resolve_path(_ws['!drawel'].Target, path);
                var drelsp = $a1a91b25d7598376$var$get_rels_path(dfile);
                var draw = $a1a91b25d7598376$var$parse_drawing($a1a91b25d7598376$var$getzipstr(zip, dfile, true), $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, drelsp, true), dfile));
                var chartp = $a1a91b25d7598376$var$resolve_path(draw, dfile);
                var crelsp = $a1a91b25d7598376$var$get_rels_path(chartp);
                _ws = $a1a91b25d7598376$var$parse_chart($a1a91b25d7598376$var$getzipstr(zip, chartp, true), chartp, opts, $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, crelsp, true), chartp), wb, _ws);
                break;
            case 'macro':
                _ws = $a1a91b25d7598376$var$parse_ms(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            case 'dialog':
                _ws = $a1a91b25d7598376$var$parse_ds(data, path, idx, opts, sheetRels[sheet], wb, themes, styles);
                break;
            default:
                throw new Error("Unrecognized sheet type " + stype);
        }
        sheets[sheet] = _ws;
        /* scan rels for comments and threaded comments */ var comments = [], tcomments = [];
        if (sheetRels && sheetRels[sheet]) $a1a91b25d7598376$var$keys(sheetRels[sheet]).forEach(function(n) {
            var dfile = "";
            if (sheetRels[sheet][n].Type == $a1a91b25d7598376$var$RELS.CMNT) {
                dfile = $a1a91b25d7598376$var$resolve_path(sheetRels[sheet][n].Target, path);
                comments = $a1a91b25d7598376$var$parse_cmnt($a1a91b25d7598376$var$getzipdata(zip, dfile, true), dfile, opts);
                if (!comments || !comments.length) return;
                $a1a91b25d7598376$var$sheet_insert_comments(_ws, comments, false);
            }
            if (sheetRels[sheet][n].Type == $a1a91b25d7598376$var$RELS.TCMNT) {
                dfile = $a1a91b25d7598376$var$resolve_path(sheetRels[sheet][n].Target, path);
                tcomments = tcomments.concat($a1a91b25d7598376$var$parse_tcmnt_xml($a1a91b25d7598376$var$getzipdata(zip, dfile, true), opts));
            }
        });
        if (tcomments && tcomments.length) $a1a91b25d7598376$var$sheet_insert_comments(_ws, tcomments, true, opts.people || []);
        $a1a91b25d7598376$var$parse_sheet_legacy_drawing(_ws, stype, zip, path, idx, opts, wb, comments);
    } catch (e) {
        if (opts.WTF) throw e;
    }
}
function $a1a91b25d7598376$var$strip_front_slash(x /*:string*/ ) /*:string*/ {
    return x.charAt(0) == '/' ? x.slice(1) : x;
}
function $a1a91b25d7598376$export$b165387946f79a1(zip /*:ZIP*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $a1a91b25d7598376$var$make_ssf();
    opts = opts || {};
    $a1a91b25d7598376$var$fix_read_opts(opts);
    /* OpenDocument Part 3 Section 2.2.1 OpenDocument Package */ if ($a1a91b25d7598376$var$safegetzipfile(zip, 'META-INF/manifest.xml')) return $a1a91b25d7598376$var$parse_ods(zip, opts);
    /* UOC */ if ($a1a91b25d7598376$var$safegetzipfile(zip, 'objectdata.xml')) return $a1a91b25d7598376$var$parse_ods(zip, opts);
    /* Numbers */ if ($a1a91b25d7598376$var$safegetzipfile(zip, 'Index/Document.iwa')) {
        if (typeof Uint8Array == "undefined") throw new Error('NUMBERS file parsing requires Uint8Array support');
        if (typeof $a1a91b25d7598376$var$parse_numbers_iwa != "undefined") {
            if (zip.FileIndex) return $a1a91b25d7598376$var$parse_numbers_iwa(zip, opts);
            var _zip = $a1a91b25d7598376$export$9f0e51cd97c572a.utils.cfb_new();
            $a1a91b25d7598376$var$zipentries(zip).forEach(function(e) {
                $a1a91b25d7598376$var$zip_add_file(_zip, e, $a1a91b25d7598376$var$getzipbin(zip, e));
            });
            return $a1a91b25d7598376$var$parse_numbers_iwa(_zip, opts);
        }
        throw new Error('Unsupported NUMBERS file');
    }
    if (!$a1a91b25d7598376$var$safegetzipfile(zip, '[Content_Types].xml')) {
        if ($a1a91b25d7598376$var$safegetzipfile(zip, 'index.xml.gz')) throw new Error('Unsupported NUMBERS 08 file');
        if ($a1a91b25d7598376$var$safegetzipfile(zip, 'index.xml')) throw new Error('Unsupported NUMBERS 09 file');
        var index_zip = $a1a91b25d7598376$export$9f0e51cd97c572a.find(zip, 'Index.zip');
        if (index_zip) {
            opts = $a1a91b25d7598376$var$dup(opts);
            delete opts.type;
            if (typeof index_zip.content == "string") opts.type = "binary";
            // TODO: Bun buffer bug
            if (typeof Bun !== "undefined" && $a1a91b25d7598376$require$Buffer.isBuffer(index_zip.content)) return $a1a91b25d7598376$export$aafa59e2e03f2942(new Uint8Array(index_zip.content), opts);
            return $a1a91b25d7598376$export$aafa59e2e03f2942(index_zip.content, opts);
        }
        throw new Error('Unsupported ZIP file');
    }
    var entries = $a1a91b25d7598376$var$zipentries(zip);
    var dir = $a1a91b25d7598376$var$parse_ct($a1a91b25d7598376$var$getzipstr(zip, '[Content_Types].xml'));
    var xlsb = false;
    var sheets, binname;
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.xml";
        if ($a1a91b25d7598376$var$getzipdata(zip, binname, true)) dir.workbooks.push(binname);
    }
    if (dir.workbooks.length === 0) {
        binname = "xl/workbook.bin";
        if (!$a1a91b25d7598376$var$getzipdata(zip, binname, true)) throw new Error("Could not find workbook");
        dir.workbooks.push(binname);
        xlsb = true;
    }
    if (dir.workbooks[0].slice(-3) == "bin") xlsb = true;
    var themes = {} /*:any*/ ;
    var styles = {} /*:any*/ ;
    if (!opts.bookSheets && !opts.bookProps) {
        $a1a91b25d7598376$var$strs = [];
        if (dir.sst) try {
            $a1a91b25d7598376$var$strs = $a1a91b25d7598376$var$parse_sst($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.sst)), dir.sst, opts);
        } catch (e) {
            if (opts.WTF) throw e;
        }
        if (opts.cellStyles && dir.themes.length) themes = $a1a91b25d7598376$var$parse_theme_xml($a1a91b25d7598376$var$getzipstr(zip, dir.themes[0].replace(/^\//, ''), true) || "", opts);
        if (dir.style) styles = $a1a91b25d7598376$var$parse_sty($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.style)), dir.style, themes, opts);
    }
    /*var externbooks = */ dir.links.map(function(link) {
        try {
            var rels = $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, $a1a91b25d7598376$var$get_rels_path($a1a91b25d7598376$var$strip_front_slash(link))), link);
            return $a1a91b25d7598376$var$parse_xlink($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(link)), rels, link, opts);
        } catch (e) {}
    });
    var wb = $a1a91b25d7598376$var$parse_wb($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.workbooks[0])), dir.workbooks[0], opts);
    var props = {}, propdata = "";
    if (dir.coreprops.length) {
        propdata = $a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.coreprops[0]), true);
        if (propdata) props = $a1a91b25d7598376$var$parse_core_props(propdata);
        if (dir.extprops.length !== 0) {
            propdata = $a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.extprops[0]), true);
            if (propdata) $a1a91b25d7598376$var$parse_ext_props(propdata, props, opts);
        }
    }
    var custprops = {};
    if (!opts.bookSheets || opts.bookProps) {
        if (dir.custprops.length !== 0) {
            propdata = $a1a91b25d7598376$var$getzipstr(zip, $a1a91b25d7598376$var$strip_front_slash(dir.custprops[0]), true);
            if (propdata) custprops = $a1a91b25d7598376$var$parse_cust_props(propdata, opts);
        }
    }
    var out = {} /*:any*/ ;
    if (opts.bookSheets || opts.bookProps) {
        if (wb.Sheets) sheets = wb.Sheets.map(function pluck(x) {
            return x.name;
        });
        else if (props.Worksheets && props.SheetNames.length > 0) sheets = props.SheetNames;
        if (opts.bookProps) {
            out.Props = props;
            out.Custprops = custprops;
        }
        if (opts.bookSheets && typeof sheets !== 'undefined') out.SheetNames = sheets;
        if (opts.bookSheets ? out.SheetNames : opts.bookProps) return out;
    }
    sheets = {};
    var deps = {};
    if (opts.bookDeps && dir.calcchain) deps = $a1a91b25d7598376$var$parse_cc($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.calcchain)), dir.calcchain, opts);
    var i = 0;
    var sheetRels = {} /*:any*/ ;
    var path, relsPath;
    var wbsheets = wb.Sheets;
    props.Worksheets = wbsheets.length;
    props.SheetNames = [];
    for(var j = 0; j != wbsheets.length; ++j)props.SheetNames[j] = wbsheets[j].name;
    var wbext = xlsb ? "bin" : "xml";
    var wbrelsi = dir.workbooks[0].lastIndexOf("/");
    var wbrelsfile = (dir.workbooks[0].slice(0, wbrelsi + 1) + "_rels/" + dir.workbooks[0].slice(wbrelsi + 1) + ".rels").replace(/^\//, "");
    if (!$a1a91b25d7598376$var$safegetzipfile(zip, wbrelsfile)) wbrelsfile = 'xl/_rels/workbook.' + wbext + '.rels';
    var wbrels = $a1a91b25d7598376$var$parse_rels($a1a91b25d7598376$var$getzipstr(zip, wbrelsfile, true), wbrelsfile.replace(/_rels.*/, "s5s"));
    if ((dir.metadata || []).length >= 1) /* TODO: MDX and other types of metadata */ opts.xlmeta = $a1a91b25d7598376$var$parse_xlmeta($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.metadata[0])), dir.metadata[0], opts);
    if ((dir.people || []).length >= 1) opts.people = $a1a91b25d7598376$var$parse_people_xml($a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.people[0])), opts);
    if (wbrels) wbrels = $a1a91b25d7598376$var$safe_parse_wbrels(wbrels, wb.Sheets);
    /* Numbers iOS hack */ var nmode = $a1a91b25d7598376$var$getzipdata(zip, "xl/worksheets/sheet.xml", true) ? 1 : 0;
    wsloop: for(i = 0; i != props.Worksheets; ++i){
        var stype = "sheet";
        if (wbrels && wbrels[i]) {
            path = 'xl/' + wbrels[i][1].replace(/[\/]?xl\//, "");
            if (!$a1a91b25d7598376$var$safegetzipfile(zip, path)) path = wbrels[i][1];
            if (!$a1a91b25d7598376$var$safegetzipfile(zip, path)) path = wbrelsfile.replace(/_rels\/[\S\s]*$/, "") + wbrels[i][1];
            stype = wbrels[i][2];
        } else {
            path = 'xl/worksheets/sheet' + (i + 1 - nmode) + "." + wbext;
            path = path.replace(/sheet0\./, "sheet.");
        }
        relsPath = path.replace(/^(.*)(\/)([^\/]*)$/, "$1/_rels/$3.rels");
        if (opts && opts.sheets != null) switch(typeof opts.sheets){
            case "number":
                if (i != opts.sheets) continue wsloop;
                break;
            case "string":
                if (props.SheetNames[i].toLowerCase() != opts.sheets.toLowerCase()) continue wsloop;
                break;
            default:
                if (Array.isArray && Array.isArray(opts.sheets)) {
                    var snjseen = false;
                    for(var snj = 0; snj != opts.sheets.length; ++snj){
                        if (typeof opts.sheets[snj] == "number" && opts.sheets[snj] == i) snjseen = 1;
                        if (typeof opts.sheets[snj] == "string" && opts.sheets[snj].toLowerCase() == props.SheetNames[i].toLowerCase()) snjseen = 1;
                    }
                    if (!snjseen) continue wsloop;
                }
        }
        $a1a91b25d7598376$var$safe_parse_sheet(zip, path, relsPath, props.SheetNames[i], i, sheetRels, sheets, stype, opts, wb, themes, styles);
    }
    out = {
        Directory: dir,
        Workbook: wb,
        Props: props,
        Custprops: custprops,
        Deps: deps,
        Sheets: sheets,
        SheetNames: props.SheetNames,
        Strings: $a1a91b25d7598376$var$strs,
        Styles: styles,
        Themes: themes,
        SSF: $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt)
    } /*:any*/ ;
    if (opts && opts.bookFiles) {
        if (zip.files) {
            out.keys = entries;
            out.files = zip.files;
        } else {
            out.keys = [];
            out.files = {};
            zip.FullPaths.forEach(function(p, idx) {
                p = p.replace(/^Root Entry[\/]/, "");
                out.keys.push(p);
                out.files[p] = zip.FileIndex[idx];
            });
        }
    }
    if (opts && opts.bookVBA) {
        if (dir.vba.length > 0) out.vbaraw = $a1a91b25d7598376$var$getzipdata(zip, $a1a91b25d7598376$var$strip_front_slash(dir.vba[0]), true);
        else if (dir.defaults && dir.defaults.bin === $a1a91b25d7598376$var$CT_VBA) out.vbaraw = $a1a91b25d7598376$var$getzipdata(zip, 'xl/vbaProject.bin', true);
    }
    // TODO: pass back content types metadata for xlsm/xlsx resolution
    out.bookType = xlsb ? "xlsb" : "xlsx";
    return out;
}
/* [MS-OFFCRYPTO] 2.1.1 */ function $a1a91b25d7598376$var$parse_xlsxcfb(cfb, _opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var opts = _opts || {};
    var f = 'Workbook', data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
    try {
        f = '/!DataSpaces/Version';
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var version = */ $a1a91b25d7598376$var$parse_DataSpaceVersionInfo(data.content);
        /* 2.3.4.1 */ f = '/!DataSpaces/DataSpaceMap';
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var dsm = $a1a91b25d7598376$var$parse_DataSpaceMap(data.content);
        if (dsm.length !== 1 || dsm[0].comps.length !== 1 || dsm[0].comps[0].t !== 0 || dsm[0].name !== "StrongEncryptionDataSpace" || dsm[0].comps[0].v !== "EncryptedPackage") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.2 */ f = '/!DataSpaces/DataSpaceInfo/StrongEncryptionDataSpace';
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        var seds = $a1a91b25d7598376$var$parse_DataSpaceDefinition(data.content);
        if (seds.length != 1 || seds[0] != "StrongEncryptionTransform") throw new Error("ECMA-376 Encrypted file bad " + f);
        /* 2.3.4.3 */ f = '/!DataSpaces/TransformInfo/StrongEncryptionTransform/!Primary';
        data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
        if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
        /*var hdr = */ $a1a91b25d7598376$var$parse_Primary(data.content);
    } catch (e) {}
    f = '/EncryptionInfo';
    data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    var einfo = $a1a91b25d7598376$var$parse_EncryptionInfo(data.content);
    /* 2.3.4.4 */ f = '/EncryptedPackage';
    data = $a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, f);
    if (!data || !data.content) throw new Error("ECMA-376 Encrypted file missing " + f);
    /*global decrypt_agile */ /*:: declare var decrypt_agile:any; */ if (einfo[0] == 0x04 && typeof decrypt_agile !== 'undefined') return decrypt_agile(einfo[1], data.content, opts.password || "", opts);
    /*global decrypt_std76 */ /*:: declare var decrypt_std76:any; */ if (einfo[0] == 0x02 && typeof decrypt_std76 !== 'undefined') return decrypt_std76(einfo[1], data.content, opts.password || "", opts);
    throw new Error("File is password-protected");
}
function $a1a91b25d7598376$var$write_zip_xlsb(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb && wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($a1a91b25d7598376$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "bin";
    var vbafmt = true;
    var ct = $a1a91b25d7598376$var$new_ct();
    $a1a91b25d7598376$var$fix_write_opts(opts = opts || {});
    var zip = $a1a91b25d7598376$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 2, f, $a1a91b25d7598376$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 3, f, $a1a91b25d7598376$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $a1a91b25d7598376$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $a1a91b25d7598376$var$add_rels(opts.rels, 4, f, $a1a91b25d7598376$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ws_bin(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $a1a91b25d7598376$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $a1a91b25d7598376$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_comments_bin(comments, opts));
                ct.comments.push(cf);
                $a1a91b25d7598376$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $a1a91b25d7598376$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $a1a91b25d7598376$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $a1a91b25d7598376$var$zip_add_file(zip, $a1a91b25d7598376$var$get_rels_path(f), $a1a91b25d7598376$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sst_bin(opts.Strings, opts));
        ct.strs.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $a1a91b25d7598376$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_wb_bin(wb, opts));
    ct.workbooks.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 1, f, $a1a91b25d7598376$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    var ww = $a1a91b25d7598376$var$write_theme(wb.Themes, opts);
    $a1a91b25d7598376$var$zip_add_file(zip, f, ww);
    ct.themes.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $a1a91b25d7598376$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sty_bin(wb, opts));
    ct.styles.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "styles." + wbext, $a1a91b25d7598376$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $a1a91b25d7598376$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $a1a91b25d7598376$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_xlmeta_bin());
    ct.metadata.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $a1a91b25d7598376$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_people_xml(people, opts));
        ct.people.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "persons/person.xml", $a1a91b25d7598376$var$RELS.PEOPLE);
    }
    $a1a91b25d7598376$var$zip_add_file(zip, "[Content_Types].xml", $a1a91b25d7598376$var$write_ct(ct, opts));
    $a1a91b25d7598376$var$zip_add_file(zip, '_rels/.rels', $a1a91b25d7598376$var$write_rels(opts.rels));
    $a1a91b25d7598376$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $a1a91b25d7598376$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $a1a91b25d7598376$var$write_zip_xlsx(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    if (wb && !wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb && wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
    }
    opts.rels = {};
    opts.wbrels = {};
    opts.Strings = /*::((*/ [] /*:: :any):SST)*/ ;
    opts.Strings.Count = 0;
    opts.Strings.Unique = 0;
    if ($a1a91b25d7598376$var$browser_has_Map) opts.revStrings = new Map();
    else {
        opts.revStrings = {};
        opts.revStrings.foo = [];
        delete opts.revStrings.foo;
    }
    var wbext = "xml";
    var vbafmt = $a1a91b25d7598376$var$VBAFMTS.indexOf(opts.bookType) > -1;
    var ct = $a1a91b25d7598376$var$new_ct();
    $a1a91b25d7598376$var$fix_write_opts(opts = opts || {});
    var zip = $a1a91b25d7598376$var$zip_new();
    var f = "", rId = 0;
    opts.cellXfs = [];
    $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
        revssf: {
            "General": 0
        }
    });
    if (!wb.Props) wb.Props = {};
    f = "docProps/core.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_core_props(wb.Props, opts));
    ct.coreprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 2, f, $a1a91b25d7598376$var$RELS.CORE_PROPS);
    /*::if(!wb.Props) throw "unreachable"; */ f = "docProps/app.xml";
    if (wb.Props && wb.Props.SheetNames) ;
    else if (!wb.Workbook || !wb.Workbook.Sheets) wb.Props.SheetNames = wb.SheetNames;
    else {
        var _sn = [];
        for(var _i = 0; _i < wb.SheetNames.length; ++_i)if ((wb.Workbook.Sheets[_i] || {}).Hidden != 2) _sn.push(wb.SheetNames[_i]);
        wb.Props.SheetNames = _sn;
    }
    wb.Props.Worksheets = wb.Props.SheetNames.length;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ext_props(wb.Props, opts));
    ct.extprops.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 3, f, $a1a91b25d7598376$var$RELS.EXT_PROPS);
    if (wb.Custprops !== wb.Props && $a1a91b25d7598376$var$keys(wb.Custprops || {}).length > 0) {
        f = "docProps/custom.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_cust_props(wb.Custprops, opts));
        ct.custprops.push(f);
        $a1a91b25d7598376$var$add_rels(opts.rels, 4, f, $a1a91b25d7598376$var$RELS.CUST_PROPS);
    }
    var people = [
        "SheetJ5"
    ];
    opts.tcid = 0;
    for(rId = 1; rId <= wb.SheetNames.length; ++rId){
        var wsrels = {
            '!id': {}
        };
        var ws = wb.Sheets[wb.SheetNames[rId - 1]];
        var _type = (ws || {})["!type"] || "sheet";
        _type;
        f = "xl/worksheets/sheet" + rId + "." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_ws_xml(rId - 1, opts, wb, wsrels));
        ct.sheets.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "worksheets/sheet" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.WS[0]);
        if (ws) {
            var comments = ws['!comments'];
            var need_vml = false;
            var cf = "";
            if (comments && comments.length > 0) {
                var needtc = false;
                comments.forEach(function(carr) {
                    carr[1].forEach(function(c) {
                        if (c.T == true) needtc = true;
                    });
                });
                if (needtc) {
                    cf = "xl/threadedComments/threadedComment" + rId + ".xml";
                    $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_tcmnt_xml(comments, people, opts));
                    ct.threadedcomments.push(cf);
                    $a1a91b25d7598376$var$add_rels(wsrels, -1, "../threadedComments/threadedComment" + rId + ".xml", $a1a91b25d7598376$var$RELS.TCMNT);
                }
                cf = "xl/comments" + rId + "." + wbext;
                $a1a91b25d7598376$var$zip_add_file(zip, cf, $a1a91b25d7598376$var$write_comments_xml(comments, opts));
                ct.comments.push(cf);
                $a1a91b25d7598376$var$add_rels(wsrels, -1, "../comments" + rId + "." + wbext, $a1a91b25d7598376$var$RELS.CMNT);
                need_vml = true;
            }
            if (ws['!legacy']) {
                if (need_vml) $a1a91b25d7598376$var$zip_add_file(zip, "xl/drawings/vmlDrawing" + rId + ".vml", $a1a91b25d7598376$var$write_vml(rId, ws['!comments']));
            }
            delete ws['!comments'];
            delete ws['!legacy'];
        }
        if (wsrels['!id'].rId1) $a1a91b25d7598376$var$zip_add_file(zip, $a1a91b25d7598376$var$get_rels_path(f), $a1a91b25d7598376$var$write_rels(wsrels));
    }
    if (opts.Strings != null && opts.Strings.length > 0) {
        f = "xl/sharedStrings." + wbext;
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sst_xml(opts.Strings, opts));
        ct.strs.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "sharedStrings." + wbext, $a1a91b25d7598376$var$RELS.SST);
    }
    f = "xl/workbook." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_wb_xml(wb, opts));
    ct.workbooks.push(f);
    $a1a91b25d7598376$var$add_rels(opts.rels, 1, f, $a1a91b25d7598376$var$RELS.WB);
    /* TODO: something more intelligent with themes */ f = "xl/theme/theme1.xml";
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_theme(wb.Themes, opts));
    ct.themes.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "theme/theme1.xml", $a1a91b25d7598376$var$RELS.THEME);
    /* TODO: something more intelligent with styles */ f = "xl/styles." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_sty_xml(wb, opts));
    ct.styles.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "styles." + wbext, $a1a91b25d7598376$var$RELS.STY);
    if (wb.vbaraw && vbafmt) {
        f = "xl/vbaProject.bin";
        $a1a91b25d7598376$var$zip_add_file(zip, f, wb.vbaraw);
        ct.vba.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "vbaProject.bin", $a1a91b25d7598376$var$RELS.VBA);
    }
    f = "xl/metadata." + wbext;
    $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_xlmeta_xml());
    ct.metadata.push(f);
    $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "metadata." + wbext, $a1a91b25d7598376$var$RELS.XLMETA);
    if (people.length > 1) {
        f = "xl/persons/person.xml";
        $a1a91b25d7598376$var$zip_add_file(zip, f, $a1a91b25d7598376$var$write_people_xml(people, opts));
        ct.people.push(f);
        $a1a91b25d7598376$var$add_rels(opts.wbrels, -1, "persons/person.xml", $a1a91b25d7598376$var$RELS.PEOPLE);
    }
    $a1a91b25d7598376$var$zip_add_file(zip, "[Content_Types].xml", $a1a91b25d7598376$var$write_ct(ct, opts));
    $a1a91b25d7598376$var$zip_add_file(zip, '_rels/.rels', $a1a91b25d7598376$var$write_rels(opts.rels));
    $a1a91b25d7598376$var$zip_add_file(zip, 'xl/_rels/workbook.' + wbext + '.rels', $a1a91b25d7598376$var$write_rels(opts.wbrels));
    delete opts.revssf;
    delete opts.ssf;
    return zip;
}
function $a1a91b25d7598376$var$firstbyte(f /*:RawData*/ , o /*:?TypeOpts*/ ) /*:Array<number>*/ {
    var x = "";
    switch((o || {}).type || "base64"){
        case 'buffer':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        case 'base64':
            x = $a1a91b25d7598376$var$Base64_decode(f.slice(0, 12));
            break;
        case 'binary':
            x = f;
            break;
        case 'array':
            return [
                f[0],
                f[1],
                f[2],
                f[3],
                f[4],
                f[5],
                f[6],
                f[7]
            ];
        default:
            throw new Error("Unrecognized type " + (o && o.type || "undefined"));
    }
    return [
        x.charCodeAt(0),
        x.charCodeAt(1),
        x.charCodeAt(2),
        x.charCodeAt(3),
        x.charCodeAt(4),
        x.charCodeAt(5),
        x.charCodeAt(6),
        x.charCodeAt(7)
    ];
}
function $a1a91b25d7598376$var$read_cfb(cfb /*:CFBContainer*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    if ($a1a91b25d7598376$export$9f0e51cd97c572a.find(cfb, "EncryptedPackage")) return $a1a91b25d7598376$var$parse_xlsxcfb(cfb, opts);
    return $a1a91b25d7598376$export$b41972a043aba84c(cfb, opts);
}
function $a1a91b25d7598376$var$read_zip(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var zip, d = data;
    var o = opts || {};
    if (!o.type) o.type = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    zip = $a1a91b25d7598376$var$zip_read(d, o);
    return $a1a91b25d7598376$export$b165387946f79a1(zip, o);
}
function $a1a91b25d7598376$var$read_plaintext(data /*:string*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var i = 0;
    main: while(i < data.length)switch(data.charCodeAt(i)){
        case 0x0A:
        case 0x0D:
        case 0x20:
            ++i;
            break;
        case 0x3C:
            return $a1a91b25d7598376$var$parse_xlml(data.slice(i), o);
        default:
            break main;
    }
    return $a1a91b25d7598376$var$PRN.to_workbook(data, o);
}
function $a1a91b25d7598376$var$read_plaintext_raw(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var str = "", bytes = $a1a91b25d7598376$var$firstbyte(data, o);
    switch(o.type){
        case 'base64':
            str = $a1a91b25d7598376$var$Base64_decode(data);
            break;
        case 'binary':
            str = data;
            break;
        case 'buffer':
            str = data.toString('binary');
            break;
        case 'array':
            str = $a1a91b25d7598376$var$cc2str(data);
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    if (bytes[0] == 0xEF && bytes[1] == 0xBB && bytes[2] == 0xBF) str = $a1a91b25d7598376$var$utf8read(str);
    o.type = "binary";
    return $a1a91b25d7598376$var$read_plaintext(str, o);
}
function $a1a91b25d7598376$var$read_utf16(data /*:RawData*/ , o /*:ParseOpts*/ ) /*:Workbook*/ {
    var d = data;
    if (o.type == 'base64') d = $a1a91b25d7598376$var$Base64_decode(d);
    if (typeof ArrayBuffer !== "undefined" && data instanceof ArrayBuffer) d = new Uint8Array(data);
    d = typeof $a1a91b25d7598376$var$$cptable !== "undefined" ? $a1a91b25d7598376$var$$cptable.utils.decode(1200, d.slice(2), 'str') : $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(data) ? data.slice(2).toString("utf16le") : typeof Uint8Array !== "undefined" && d instanceof Uint8Array ? typeof TextDecoder !== "undefined" ? new TextDecoder("utf-16le").decode(d.slice(2)) : $a1a91b25d7598376$var$utf16lereadu(d.slice(2)) : $a1a91b25d7598376$var$utf16leread(d.slice(2));
    o.type = "binary";
    return $a1a91b25d7598376$var$read_plaintext(d, o);
}
function $a1a91b25d7598376$var$bstrify(data /*:string*/ ) /*:string*/ {
    return !data.match(/[^\x00-\x7F]/) ? data : $a1a91b25d7598376$var$utf8write(data);
}
function $a1a91b25d7598376$var$read_prn(data, d, o, str) {
    if (str) {
        o.type = "string";
        return $a1a91b25d7598376$var$PRN.to_workbook(data, o);
    }
    return $a1a91b25d7598376$var$PRN.to_workbook(d, o);
}
function $a1a91b25d7598376$export$aafa59e2e03f2942(data /*:RawData*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    $a1a91b25d7598376$var$reset_cp();
    var o = opts || {};
    if (o.codepage && typeof $a1a91b25d7598376$var$$cptable === "undefined") console.error("Codepage tables are not loaded.  Non-ASCII characters may not give expected results");
    if (typeof ArrayBuffer !== 'undefined' && data instanceof ArrayBuffer) return $a1a91b25d7598376$export$aafa59e2e03f2942(new Uint8Array(data), (o = $a1a91b25d7598376$var$dup(o), o.type = "array", o));
    /* Javet projects `byte[]` to `Int8Array` */ if (typeof Int8Array !== 'undefined' && data instanceof Int8Array) return $a1a91b25d7598376$export$aafa59e2e03f2942(new Uint8Array(data.buffer, data.byteOffset, data.length), o);
    if (typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && !o.type) o.type = typeof Deno !== "undefined" ? "buffer" : "array";
    var d = data, n = [
        0,
        0,
        0,
        0
    ], str = false;
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    $a1a91b25d7598376$var$_ssfopts = {};
    if (o.dateNF) $a1a91b25d7598376$var$_ssfopts.dateNF = o.dateNF;
    if (!o.type) o.type = $a1a91b25d7598376$var$has_buf && $a1a91b25d7598376$require$Buffer.isBuffer(data) ? "buffer" : "base64";
    if (o.type == "file") {
        o.type = $a1a91b25d7598376$var$has_buf ? "buffer" : "binary";
        d = $a1a91b25d7598376$var$read_binary(data);
        if (typeof Uint8Array !== 'undefined' && !$a1a91b25d7598376$var$has_buf) o.type = "array";
    }
    if (o.type == "string") {
        str = true;
        o.type = "binary";
        o.codepage = 65001;
        d = $a1a91b25d7598376$var$bstrify(data);
    }
    if (o.type == 'array' && typeof Uint8Array !== 'undefined' && data instanceof Uint8Array && typeof ArrayBuffer !== 'undefined') {
        // $FlowIgnore
        var ab = new ArrayBuffer(3), vu = new Uint8Array(ab);
        vu.foo = "bar";
        // $FlowIgnore
        if (!vu.foo) {
            o = $a1a91b25d7598376$var$dup(o);
            o.type = 'array';
            return $a1a91b25d7598376$export$aafa59e2e03f2942($a1a91b25d7598376$var$ab2a(d), o);
        }
    }
    switch((n = $a1a91b25d7598376$var$firstbyte(d, o))[0]){
        case 0xD0:
            if (n[1] === 0xCF && n[2] === 0x11 && n[3] === 0xE0 && n[4] === 0xA1 && n[5] === 0xB1 && n[6] === 0x1A && n[7] === 0xE1) return $a1a91b25d7598376$var$read_cfb($a1a91b25d7598376$export$9f0e51cd97c572a.read(d, o), o);
            break;
        case 0x09:
            if (n[1] <= 0x08) return $a1a91b25d7598376$export$b41972a043aba84c(d, o);
            break;
        case 0x3C:
            return $a1a91b25d7598376$var$parse_xlml(d, o);
        case 0x49:
            if (n[1] === 0x49 && n[2] === 0x2a && n[3] === 0x00) throw new Error("TIFF Image File is not a spreadsheet");
            if (n[1] === 0x44) return $a1a91b25d7598376$var$read_wb_ID(d, o);
            break;
        case 0x54:
            if (n[1] === 0x41 && n[2] === 0x42 && n[3] === 0x4C) return $a1a91b25d7598376$var$DIF.to_workbook(d, o);
            break;
        case 0x50:
            return n[1] === 0x4B && n[2] < 0x09 && n[3] < 0x09 ? $a1a91b25d7598376$var$read_zip(d, o) : $a1a91b25d7598376$var$read_prn(data, d, o, str);
        case 0xEF:
            return n[3] === 0x3C ? $a1a91b25d7598376$var$parse_xlml(d, o) : $a1a91b25d7598376$var$read_prn(data, d, o, str);
        case 0xFF:
            if (n[1] === 0xFE) return $a1a91b25d7598376$var$read_utf16(d, o);
            else if (n[1] === 0x00 && n[2] === 0x02 && n[3] === 0x00) return $a1a91b25d7598376$var$WK_.to_workbook(d, o);
            break;
        case 0x00:
            if (n[1] === 0x00) {
                if (n[2] >= 0x02 && n[3] === 0x00) return $a1a91b25d7598376$var$WK_.to_workbook(d, o);
                if (n[2] === 0x00 && (n[3] === 0x08 || n[3] === 0x09)) return $a1a91b25d7598376$var$WK_.to_workbook(d, o);
            }
            break;
        case 0x03:
        case 0x83:
        case 0x8B:
        case 0x8C:
            return $a1a91b25d7598376$var$DBF.to_workbook(d, o);
        case 0x7B:
            if (n[1] === 0x5C && n[2] === 0x72 && n[3] === 0x74) return $a1a91b25d7598376$var$rtf_to_workbook(d, o);
            break;
        case 0x0A:
        case 0x0D:
        case 0x20:
            return $a1a91b25d7598376$var$read_plaintext_raw(d, o);
        case 0x89:
            if (n[1] === 0x50 && n[2] === 0x4E && n[3] === 0x47) throw new Error("PNG Image File is not a spreadsheet");
            break;
        case 0x08:
            if (n[1] === 0xE7) throw new Error("Unsupported Multiplan 1.x file!");
            break;
        case 0x0C:
            if (n[1] === 0xEC) throw new Error("Unsupported Multiplan 2.x file!");
            if (n[1] === 0xED) throw new Error("Unsupported Multiplan 3.x file!");
            break;
    }
    if ($a1a91b25d7598376$var$DBF_SUPPORTED_VERSIONS.indexOf(n[0]) > -1 && n[2] <= 12 && n[3] <= 31) return $a1a91b25d7598376$var$DBF.to_workbook(d, o);
    return $a1a91b25d7598376$var$read_prn(data, d, o, str);
}
function $a1a91b25d7598376$export$72c04af63de9061a(filename /*:string*/ , opts /*:?ParseOpts*/ ) /*:Workbook*/ {
    var o = opts || {};
    o.type = 'file';
    return $a1a91b25d7598376$export$aafa59e2e03f2942(filename, o);
}
function $a1a91b25d7598376$var$write_cfb_ctr(cfb /*:CFBContainer*/ , o /*:WriteOpts*/ ) /*:any*/ {
    switch(o.type){
        case "base64":
        case "binary":
            break;
        case "buffer":
        case "array":
            o.type = "";
            break;
        case "file":
            return $a1a91b25d7598376$var$write_dl(o.file, $a1a91b25d7598376$export$9f0e51cd97c572a.write(cfb, {
                type: $a1a91b25d7598376$var$has_buf ? 'buffer' : ""
            }));
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    return $a1a91b25d7598376$export$9f0e51cd97c572a.write(cfb, o);
}
function $a1a91b25d7598376$var$write_zip(wb /*:Workbook*/ , opts /*:WriteOpts*/ ) /*:ZIP*/ {
    switch(opts.bookType){
        case "ods":
            return $a1a91b25d7598376$var$write_ods(wb, opts);
        case "numbers":
            return $a1a91b25d7598376$var$write_numbers_iwa(wb, opts);
        case "xlsb":
            return $a1a91b25d7598376$var$write_zip_xlsb(wb, opts);
        default:
            return $a1a91b25d7598376$var$write_zip_xlsx(wb, opts);
    }
}
/*:: declare var encrypt_agile:any; */ function $a1a91b25d7598376$var$write_zip_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $a1a91b25d7598376$var$dup(opts || {});
    var z = $a1a91b25d7598376$var$write_zip(wb, o);
    return $a1a91b25d7598376$var$write_zip_denouement(z, o);
}
function $a1a91b25d7598376$var$write_zip_typeXLSX(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = $a1a91b25d7598376$var$dup(opts || {});
    var z = $a1a91b25d7598376$var$write_zip_xlsx(wb, o);
    return $a1a91b25d7598376$var$write_zip_denouement(z, o);
}
function $a1a91b25d7598376$var$write_zip_denouement(z /*:any*/ , o /*:?WriteOpts*/ ) /*:any*/ {
    var oopts = {};
    var ftype = $a1a91b25d7598376$var$has_buf ? "nodebuffer" : typeof Uint8Array !== "undefined" ? "array" : "string";
    if (o.compression) oopts.compression = 'DEFLATE';
    if (o.password) oopts.type = ftype;
    else switch(o.type){
        case "base64":
            oopts.type = "base64";
            break;
        case "binary":
            oopts.type = "string";
            break;
        case "string":
            throw new Error("'string' output type invalid for '" + o.bookType + "' files");
        case "buffer":
        case "file":
            oopts.type = ftype;
            break;
        default:
            throw new Error("Unrecognized type " + o.type);
    }
    var out = z.FullPaths ? $a1a91b25d7598376$export$9f0e51cd97c572a.write(z, {
        fileType: "zip",
        type: /*::(*/ {
            "nodebuffer": "buffer",
            "string": "binary"
        } /*:: :any)*/ [oopts.type] || oopts.type,
        compression: !!o.compression
    }) : z.generate(oopts);
    if (typeof Deno !== "undefined") {
        if (typeof out == "string") {
            if (o.type == "binary" || o.type == "base64") return out;
            out = new Uint8Array($a1a91b25d7598376$var$s2ab(out));
        }
    }
    /*jshint -W083 */ if (o.password && typeof encrypt_agile !== 'undefined') return $a1a91b25d7598376$var$write_cfb_ctr(encrypt_agile(out, o.password), o); // eslint-disable-line no-undef
    /*jshint +W083 */ if (o.type === "file") return $a1a91b25d7598376$var$write_dl(o.file, out);
    return o.type == "string" ? $a1a91b25d7598376$var$utf8read(/*::(*/ out /*:: :any)*/ ) : out;
}
function $a1a91b25d7598376$var$write_cfb_type(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) /*:any*/ {
    var o = opts || {};
    var cfb /*:CFBContainer*/  = $a1a91b25d7598376$var$write_xlscfb(wb, o);
    return $a1a91b25d7598376$var$write_cfb_ctr(cfb, o);
}
function $a1a91b25d7598376$var$write_string_type(out /*:string*/ , opts /*:WriteOpts*/ , bom /*:?string*/ ) /*:any*/ {
    if (!bom) bom = "";
    var o = bom + out;
    switch(opts.type){
        case "base64":
            return $a1a91b25d7598376$var$Base64_encode($a1a91b25d7598376$var$utf8write(o));
        case "binary":
            return $a1a91b25d7598376$var$utf8write(o);
        case "string":
            return out;
        case "file":
            return $a1a91b25d7598376$var$write_dl(opts.file, o, 'utf8');
        case "buffer":
            if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$Buffer_from(o, 'utf8');
            else if (typeof TextEncoder !== "undefined") return new TextEncoder().encode(o);
            else return $a1a91b25d7598376$var$write_string_type(o, {
                type: 'binary'
            }).split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
function $a1a91b25d7598376$var$write_stxt_type(out /*:string*/ , opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "base64":
            return $a1a91b25d7598376$var$Base64_encode_pass(out);
        case "binary":
            return out;
        case "string":
            return out; /* override in sheet_to_txt */ 
        case "file":
            return $a1a91b25d7598376$var$write_dl(opts.file, out, 'binary');
        case "buffer":
            if ($a1a91b25d7598376$var$has_buf) return $a1a91b25d7598376$var$Buffer_from(out, 'binary');
            else return out.split("").map(function(c) {
                return c.charCodeAt(0);
            });
    }
    throw new Error("Unrecognized type " + opts.type);
}
/* TODO: test consistency */ function $a1a91b25d7598376$var$write_binary_type(out, opts /*:WriteOpts*/ ) /*:any*/ {
    switch(opts.type){
        case "string":
        case "base64":
        case "binary":
            var bstr = "";
            // $FlowIgnore
            for(var i = 0; i < out.length; ++i)bstr += String.fromCharCode(out[i]);
            return opts.type == 'base64' ? $a1a91b25d7598376$var$Base64_encode(bstr) : opts.type == 'string' ? $a1a91b25d7598376$var$utf8read(bstr) : bstr;
        case "file":
            return $a1a91b25d7598376$var$write_dl(opts.file, out);
        case "buffer":
            return out;
        default:
            throw new Error("Unrecognized type " + opts.type);
    }
}
function $a1a91b25d7598376$export$f6ca43591cb061b1(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $a1a91b25d7598376$var$reset_cp();
    $a1a91b25d7598376$var$check_wb(wb);
    var o = $a1a91b25d7598376$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $a1a91b25d7598376$export$f6ca43591cb061b1(wb, o);
        o.type = "array";
        return $a1a91b25d7598376$var$s2ab(out);
    }
    return $a1a91b25d7598376$var$write_zip_typeXLSX(wb, o);
}
function $a1a91b25d7598376$export$68d8715fc104d294(wb /*:Workbook*/ , opts /*:?WriteOpts*/ ) {
    $a1a91b25d7598376$var$reset_cp();
    $a1a91b25d7598376$var$check_wb(wb);
    var o = $a1a91b25d7598376$var$dup(opts || {});
    if (o.cellStyles) {
        o.cellNF = true;
        o.sheetStubs = true;
    }
    if (o.type == "array") {
        o.type = "binary";
        var out /*:string*/  = $a1a91b25d7598376$export$68d8715fc104d294(wb, o);
        o.type = "array";
        return $a1a91b25d7598376$var$s2ab(out);
    }
    var idx = 0;
    if (o.sheet) {
        if (typeof o.sheet == "number") idx = o.sheet;
        else idx = wb.SheetNames.indexOf(o.sheet);
        if (!wb.SheetNames[idx]) throw new Error("Sheet not found: " + o.sheet + " : " + typeof o.sheet);
    }
    switch(o.bookType || 'xlsb'){
        case 'xml':
        case 'xlml':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$write_xlml(wb, o), o);
        case 'slk':
        case 'sylk':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$SYLK.from_sheet(wb.Sheets[wb.SheetNames[idx]], o, wb), o);
        case 'htm':
        case 'html':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$sheet_to_html(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'txt':
            return $a1a91b25d7598376$var$write_stxt_type($a1a91b25d7598376$var$sheet_to_txt(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'csv':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$sheet_to_csv(wb.Sheets[wb.SheetNames[idx]], o), o, "\ufeff");
        case 'dif':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$DIF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'dbf':
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$DBF.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'prn':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$PRN.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'rtf':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$sheet_to_rtf(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'eth':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$ETH.from_sheet(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'fods':
            return $a1a91b25d7598376$var$write_string_type($a1a91b25d7598376$var$write_ods(wb, o), o);
        case 'wk1':
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$WK_.sheet_to_wk1(wb.Sheets[wb.SheetNames[idx]], o), o);
        case 'wk3':
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$WK_.book_to_wk3(wb, o), o);
        case 'biff2':
            if (!o.biff) o.biff = 2; /* falls through */ 
        case 'biff3':
            if (!o.biff) o.biff = 3; /* falls through */ 
        case 'biff4':
            if (!o.biff) o.biff = 4;
            return $a1a91b25d7598376$var$write_binary_type($a1a91b25d7598376$var$write_biff_buf(wb, o), o);
        case 'biff5':
            if (!o.biff) o.biff = 5; /* falls through */ 
        case 'biff8':
        case 'xla':
        case 'xls':
            if (!o.biff) o.biff = 8;
            return $a1a91b25d7598376$var$write_cfb_type(wb, o);
        case 'xlsx':
        case 'xlsm':
        case 'xlam':
        case 'xlsb':
        case 'numbers':
        case 'ods':
            return $a1a91b25d7598376$var$write_zip_type(wb, o);
        default:
            throw new Error("Unrecognized bookType |" + o.bookType + "|");
    }
}
function $a1a91b25d7598376$var$resolve_book_type(o /*:WriteFileOpts*/ ) {
    if (o.bookType) return;
    var _BT = {
        "xls": "biff8",
        "htm": "html",
        "slk": "sylk",
        "socialcalc": "eth",
        "Sh33tJS": "WTF"
    };
    var ext = o.file.slice(o.file.lastIndexOf(".")).toLowerCase();
    if (ext.match(/^\.[a-z]+$/)) o.bookType = ext.slice(1);
    o.bookType = _BT[o.bookType] || o.bookType;
}
function $a1a91b25d7598376$export$552bfb764b5cd2b4(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $a1a91b25d7598376$var$resolve_book_type(o);
    return $a1a91b25d7598376$export$68d8715fc104d294(wb, o);
}
function $a1a91b25d7598376$export$40a06aea54ee074e(wb /*:Workbook*/ , filename /*:string*/ , opts /*:?WriteFileOpts*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $a1a91b25d7598376$var$resolve_book_type(o);
    return $a1a91b25d7598376$export$f6ca43591cb061b1(wb, o);
}
function $a1a91b25d7598376$export$25469296c4b8ebda(filename /*:string*/ , wb /*:Workbook*/ , opts /*:?WriteFileOpts*/ , cb /*:?(e?:ErrnoError)=>void*/ ) {
    var o = opts || {};
    o.type = 'file';
    o.file = filename;
    $a1a91b25d7598376$var$resolve_book_type(o);
    o.type = 'buffer';
    var _cb = cb;
    if (!(_cb instanceof Function)) _cb = opts /*:any*/ ;
    return $a1a91b25d7598376$var$_fs.writeFile(filename, $a1a91b25d7598376$export$68d8715fc104d294(wb, o), _cb);
}
/*::
type MJRObject = {
	row: any;
	isempty: boolean;
};
*/ function $a1a91b25d7598376$var$make_json_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , header /*:number*/ , hdr /*:Array<any>*/ , o /*:Sheet2JSONOpts*/ ) /*:MJRObject*/ {
    var rr = $a1a91b25d7598376$var$encode_row(R);
    var defval = o.defval, raw = o.raw || !Object.prototype.hasOwnProperty.call(o, "raw");
    var isempty = true, dense = sheet["!data"] != null;
    var row /*:any*/  = header === 1 ? [] : {};
    if (header !== 1) {
        if (Object.defineProperty) try {
            Object.defineProperty(row, '__rowNum__', {
                value: R,
                enumerable: false
            });
        } catch (e) {
            row.__rowNum__ = R;
        }
        else row.__rowNum__ = R;
    }
    if (!dense || sheet["!data"][R]) for(var C = r.s.c; C <= r.e.c; ++C){
        var val1 = dense ? (sheet["!data"][R] || [])[C] : sheet[cols[C] + rr];
        if (val1 == null || val1.t === undefined) {
            if (defval === undefined) continue;
            if (hdr[C] != null) row[hdr[C]] = defval;
            continue;
        }
        var v = val1.v;
        switch(val1.t){
            case 'z':
                if (v == null) break;
                continue;
            case 'e':
                v = v == 0 ? null : void 0;
                break;
            case 's':
            case 'b':
            case 'n':
                if (!val1.z || !$a1a91b25d7598376$var$fmt_is_date(val1.z)) break;
                v = $a1a91b25d7598376$var$numdate(v); // TODO: date1904 setting should also be stored in worksheet object
                if (typeof v == "number") break;
            /* falls through */ case 'd':
                if (!(o && (o.UTC || o.raw === false))) v = $a1a91b25d7598376$var$utc_to_local(new Date(v));
                break;
            default:
                throw new Error('unrecognized type ' + val1.t);
        }
        if (hdr[C] != null) {
            if (v == null) {
                if (val1.t == "e" && v === null) row[hdr[C]] = null;
                else if (defval !== undefined) row[hdr[C]] = defval;
                else if (raw && v === null) row[hdr[C]] = null;
                else continue;
            } else row[hdr[C]] = (val1.t === 'n' && typeof o.rawNumbers === 'boolean' ? o.rawNumbers : raw) ? v : $a1a91b25d7598376$var$format_cell(val1, v, o);
            if (v != null) isempty = false;
        }
    }
    return {
        row: row,
        isempty: isempty
    };
}
function $a1a91b25d7598376$var$sheet_to_json(sheet /*:Worksheet*/ , opts /*:?Sheet2JSONOpts*/ ) {
    if (sheet == null || sheet["!ref"] == null) return [];
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    else if (o.header == null) header = 0;
    switch(typeof range){
        case 'string':
            r = $a1a91b25d7598376$var$safe_decode_range(range);
            break;
        case 'number':
            r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $a1a91b25d7598376$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var out /*:Array<any>*/  = [];
    var outi = 0, counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $a1a91b25d7598376$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $a1a91b25d7598376$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    for(R = r.s.r + offset; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        var row = $a1a91b25d7598376$var$make_json_row(sheet, r, R, cols, header, hdr, o);
        if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) out[outi++] = row.row;
    }
    out.length = outi;
    return out;
}
var $a1a91b25d7598376$var$qreg = /"/g;
function $a1a91b25d7598376$var$make_csv_row(sheet /*:Worksheet*/ , r /*:Range*/ , R /*:number*/ , cols /*:Array<string>*/ , fs /*:number*/ , rs /*:number*/ , FS /*:string*/ , w /*:number*/ , o /*:Sheet2CSVOpts*/ ) /*:?string*/ {
    var isempty = true;
    var row /*:Array<string>*/  = [], txt = "", rr = $a1a91b25d7598376$var$encode_row(R);
    var dense = sheet["!data"] != null;
    var datarow = dense && sheet["!data"][R] || [];
    for(var C = r.s.c; C <= r.e.c; ++C){
        if (!cols[C]) continue;
        var val1 = dense ? datarow[C] : sheet[cols[C] + rr];
        if (val1 == null) txt = "";
        else if (val1.v != null) {
            isempty = false;
            txt = '' + (o.rawNumbers && val1.t == "n" ? val1.v : $a1a91b25d7598376$var$format_cell(val1, null, o));
            for(var i = 0, cc = 0; i !== txt.length; ++i)if ((cc = txt.charCodeAt(i)) === fs || cc === rs || cc === 34 || o.forceQuotes) {
                txt = "\"" + txt.replace($a1a91b25d7598376$var$qreg, '""') + "\"";
                break;
            }
            if (txt == "ID" && w == 0 && row.length == 0) txt = '"ID"';
        } else if (val1.f != null && !val1.F) {
            isempty = false;
            txt = '=' + val1.f;
            if (txt.indexOf(",") >= 0) txt = '"' + txt.replace($a1a91b25d7598376$var$qreg, '""') + '"';
        } else txt = "";
        /* NOTE: Excel CSV does not support array formulae */ row.push(txt);
    }
    if (o.strip) while(row[row.length - 1] === "")--row.length;
    if (o.blankrows === false && isempty) return null;
    return row.join(FS);
}
function $a1a91b25d7598376$var$sheet_to_csv(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) /*:string*/ {
    var out /*:Array<string>*/  = [];
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) return "";
    var r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $a1a91b25d7598376$var$encode_col(C);
    var w = 0;
    for(var R = r.s.r; R <= r.e.r; ++R){
        if ((rowinfo[R] || {}).hidden) continue;
        row = $a1a91b25d7598376$var$make_csv_row(sheet, r, R, cols, fs, rs, FS, w, o);
        if (row == null) continue;
        if (row || o.blankrows !== false) out.push((w++ ? RS : "") + row);
    }
    return out.join("");
}
function $a1a91b25d7598376$var$sheet_to_txt(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    if (!opts) opts = {};
    opts.FS = "\t";
    opts.RS = "\n";
    var s = $a1a91b25d7598376$var$sheet_to_csv(sheet, opts);
    if (typeof $a1a91b25d7598376$var$$cptable == 'undefined' || opts.type == 'string') return s;
    var o = $a1a91b25d7598376$var$$cptable.utils.encode(1200, s, 'str');
    return String.fromCharCode(255) + String.fromCharCode(254) + o;
}
function $a1a91b25d7598376$var$sheet_to_formulae(sheet /*:Worksheet*/ , opts /*:?Sheet2FormulaOpts*/ ) /*:Array<string>*/ {
    var y = "", x, val1 = "";
    if (sheet == null || sheet["!ref"] == null) return [];
    var r = $a1a91b25d7598376$var$safe_decode_range(sheet['!ref']), rr = "", cols /*:Array<string>*/  = [], C;
    var cmds /*:Array<string>*/  = [];
    var dense = sheet["!data"] != null;
    for(C = r.s.c; C <= r.e.c; ++C)cols[C] = $a1a91b25d7598376$var$encode_col(C);
    for(var R = r.s.r; R <= r.e.r; ++R){
        rr = $a1a91b25d7598376$var$encode_row(R);
        for(C = r.s.c; C <= r.e.c; ++C){
            y = cols[C] + rr;
            x = dense ? (sheet["!data"][R] || [])[C] : sheet[y];
            val1 = "";
            if (x === undefined) continue;
            else if (x.F != null) {
                y = x.F;
                if (!x.f) continue;
                val1 = x.f;
                if (y.indexOf(":") == -1) y = y + ":" + y;
            }
            if (x.f != null) val1 = x.f;
            else if (opts && opts.values === false) continue;
            else if (x.t == 'z') continue;
            else if (x.t == 'n' && x.v != null) val1 = "" + x.v;
            else if (x.t == 'b') val1 = x.v ? "TRUE" : "FALSE";
            else if (x.w !== undefined) val1 = "'" + x.w;
            else if (x.v === undefined) continue;
            else if (x.t == 's') val1 = "'" + x.v;
            else val1 = "" + x.v;
            cmds[cmds.length] = y + "=" + val1;
        }
    }
    return cmds;
}
function $a1a91b25d7598376$var$sheet_add_json(_ws /*:?Worksheet*/ , js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    var o = opts || {};
    var dense = _ws ? _ws["!data"] != null : o.dense;
    if ($a1a91b25d7598376$var$DENSE != null && dense == null) dense = $a1a91b25d7598376$var$DENSE;
    var offset = +!o.skipHeader;
    var ws /*:Worksheet*/  = _ws || {};
    if (!_ws && dense) ws["!data"] = [];
    var _R = 0, _C = 0;
    if (ws && o.origin != null) {
        if (typeof o.origin == 'number') _R = o.origin;
        else {
            var _origin /*:CellAddress*/  = typeof o.origin == "string" ? $a1a91b25d7598376$var$decode_cell(o.origin) : o.origin;
            _R = _origin.r;
            _C = _origin.c;
        }
    }
    var range /*:Range*/  = {
        s: {
            c: 0,
            r: 0
        },
        e: {
            c: _C,
            r: _R + js.length - 1 + offset
        }
    } /*:any*/ ;
    if (ws['!ref']) {
        var _range = $a1a91b25d7598376$var$safe_decode_range(ws['!ref']);
        range.e.c = Math.max(range.e.c, _range.e.c);
        range.e.r = Math.max(range.e.r, _range.e.r);
        if (_R == -1) {
            _R = _range.e.r + 1;
            range.e.r = _R + js.length - 1 + offset;
        }
    } else if (_R == -1) {
        _R = 0;
        range.e.r = js.length - 1 + offset;
    }
    var hdr /*:Array<string>*/  = o.header || [], C = 0;
    var ROW = [];
    js.forEach(function(JS, R /*:number*/ ) {
        if (dense && !ws["!data"][_R + R + offset]) ws["!data"][_R + R + offset] = [];
        if (dense) ROW = ws["!data"][_R + R + offset];
        $a1a91b25d7598376$var$keys(JS).forEach(function(k) {
            if ((C = hdr.indexOf(k)) == -1) hdr[C = hdr.length] = k;
            var v = JS[k];
            var t = 'z';
            var z = "";
            var ref = dense ? "" : $a1a91b25d7598376$var$encode_col(_C + C) + $a1a91b25d7598376$var$encode_row(_R + R + offset);
            var cell /*:Cell*/  = dense ? ROW[_C + C] : ws[ref];
            if (v && typeof v === 'object' && !(v instanceof Date)) {
                if (dense) ROW[_C + C] = v;
                else ws[ref] = v;
            } else {
                if (typeof v == 'number') t = 'n';
                else if (typeof v == 'boolean') t = 'b';
                else if (typeof v == 'string') t = 's';
                else if (v instanceof Date) {
                    t = 'd';
                    if (!o.UTC) v = $a1a91b25d7598376$var$local_to_utc(v);
                    if (!o.cellDates) {
                        t = 'n';
                        v = $a1a91b25d7598376$var$datenum(v);
                    }
                    z = cell != null && cell.z && $a1a91b25d7598376$var$fmt_is_date(cell.z) ? cell.z : o.dateNF || $a1a91b25d7598376$var$table_fmt[14];
                } else if (v === null && o.nullError) {
                    t = 'e';
                    v = 0;
                }
                if (!cell) {
                    if (!dense) ws[ref] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                    else ROW[_C + C] = cell = {
                        t: t,
                        v: v
                    } /*:any*/ ;
                } else {
                    cell.t = t;
                    cell.v = v;
                    delete cell.w;
                    delete cell.R;
                    if (z) cell.z = z;
                }
                if (z) cell.z = z;
            }
        });
    });
    range.e.c = Math.max(range.e.c, _C + hdr.length - 1);
    var __R = $a1a91b25d7598376$var$encode_row(_R);
    if (dense && !ws["!data"][_R]) ws["!data"][_R] = [];
    if (offset) for(C = 0; C < hdr.length; ++C)if (dense) ws["!data"][_R][C + _C] = {
        t: 's',
        v: hdr[C]
    };
    else ws[$a1a91b25d7598376$var$encode_col(C + _C) + __R] = {
        t: 's',
        v: hdr[C]
    };
    ws['!ref'] = $a1a91b25d7598376$var$encode_range(range);
    return ws;
}
function $a1a91b25d7598376$var$json_to_sheet(js /*:Array<any>*/ , opts) /*:Worksheet*/ {
    return $a1a91b25d7598376$var$sheet_add_json(null, js, opts);
}
/* get cell, creating a stub if necessary */ function $a1a91b25d7598376$var$ws_get_cell_stub(ws /*:Worksheet*/ , R, C /*:?number*/ ) /*:Cell*/ {
    /* A1 cell address */ if (typeof R == "string") {
        if (ws["!data"] != null) {
            var RC = $a1a91b25d7598376$var$decode_cell(R);
            if (!ws["!data"][RC.r]) ws["!data"][RC.r] = [];
            return ws["!data"][RC.r][RC.c] || (ws["!data"][RC.r][RC.c] = {
                t: 'z'
            });
        }
        return ws[R] || (ws[R] = {
            t: 'z'
        });
    }
    /* cell address object */ if (typeof R != "number") return $a1a91b25d7598376$var$ws_get_cell_stub(ws, $a1a91b25d7598376$var$encode_cell(R));
    /* R and C are 0-based indices */ return $a1a91b25d7598376$var$ws_get_cell_stub(ws, $a1a91b25d7598376$var$encode_col(C || 0) + $a1a91b25d7598376$var$encode_row(R));
}
/* find sheet index for given name / validate index */ function $a1a91b25d7598376$var$wb_sheet_idx(wb /*:Workbook*/ , sh /*:number|string*/ ) {
    if (typeof sh == "number") {
        if (sh >= 0 && wb.SheetNames.length > sh) return sh;
        throw new Error("Cannot find sheet # " + sh);
    } else if (typeof sh == "string") {
        var idx = wb.SheetNames.indexOf(sh);
        if (idx > -1) return idx;
        throw new Error("Cannot find sheet name |" + sh + "|");
    } else throw new Error("Cannot find sheet |" + sh + "|");
}
/* simple blank or single-sheet workbook object */ function $a1a91b25d7598376$var$book_new(ws /*:?Worksheet*/ , wsname /*:?string*/ ) /*:Workbook*/ {
    var wb = {
        SheetNames: [],
        Sheets: {}
    };
    if (ws) $a1a91b25d7598376$var$book_append_sheet(wb, ws, wsname || "Sheet1");
    return wb;
}
/* add a worksheet to the end of a given workbook */ function $a1a91b25d7598376$var$book_append_sheet(wb /*:Workbook*/ , ws /*:Worksheet*/ , name /*:?string*/ , roll /*:?boolean*/ ) /*:string*/ {
    var i = 1;
    if (!name) {
        for(; i <= 0xFFFF; ++i, name = undefined)if (wb.SheetNames.indexOf(name = "Sheet" + i) == -1) break;
    }
    if (!name || wb.SheetNames.length >= 0xFFFF) throw new Error("Too many worksheets");
    if (roll && wb.SheetNames.indexOf(name) >= 0 && name.length < 32) {
        var m = name.match(/\d+$/); // at this point, name length is capped at 32
        i = m && +m[0] || 0;
        var root = m && name.slice(0, m.index) || name;
        for(++i; i <= 0xFFFF; ++i)if (wb.SheetNames.indexOf(name = root + i) == -1) break;
    }
    $a1a91b25d7598376$var$check_ws_name(name);
    if (wb.SheetNames.indexOf(name) >= 0) throw new Error("Worksheet with name |" + name + "| already exists!");
    wb.SheetNames.push(name);
    wb.Sheets[name] = ws;
    return name;
}
/* set sheet visibility (visible/hidden/very hidden) */ function $a1a91b25d7598376$var$book_set_sheet_visibility(wb /*:Workbook*/ , sh /*:number|string*/ , vis /*:number*/ ) {
    if (!wb.Workbook) wb.Workbook = {};
    if (!wb.Workbook.Sheets) wb.Workbook.Sheets = [];
    var idx = $a1a91b25d7598376$var$wb_sheet_idx(wb, sh);
    // $FlowIgnore
    if (!wb.Workbook.Sheets[idx]) wb.Workbook.Sheets[idx] = {};
    switch(vis){
        case 0:
        case 1:
        case 2:
            break;
        default:
            throw new Error("Bad sheet visibility setting " + vis);
    }
    // $FlowIgnore
    wb.Workbook.Sheets[idx].Hidden = vis;
}
/* set number format */ function $a1a91b25d7598376$var$cell_set_number_format(cell /*:Cell*/ , fmt /*:string|number*/ ) {
    cell.z = fmt;
    return cell;
}
/* set cell hyperlink */ function $a1a91b25d7598376$var$cell_set_hyperlink(cell /*:Cell*/ , target /*:string*/ , tooltip /*:?string*/ ) {
    if (!target) delete cell.l;
    else {
        cell.l = {
            Target: target
        } /*:Hyperlink*/ ;
        if (tooltip) cell.l.Tooltip = tooltip;
    }
    return cell;
}
function $a1a91b25d7598376$var$cell_set_internal_link(cell /*:Cell*/ , range /*:string*/ , tooltip /*:?string*/ ) {
    return $a1a91b25d7598376$var$cell_set_hyperlink(cell, "#" + range, tooltip);
}
/* add to cell comments */ function $a1a91b25d7598376$var$cell_add_comment(cell /*:Cell*/ , text /*:string*/ , author /*:?string*/ ) {
    if (!cell.c) cell.c = [];
    cell.c.push({
        t: text,
        a: author || "SheetJS"
    });
}
/* set array formula and flush related cells */ function $a1a91b25d7598376$var$sheet_set_array_formula(ws /*:Worksheet*/ , range, formula /*:string*/ , dynamic /*:boolean*/ ) {
    var rng = typeof range != "string" ? range : $a1a91b25d7598376$var$safe_decode_range(range);
    var rngstr = typeof range == "string" ? range : $a1a91b25d7598376$var$encode_range(range);
    for(var R = rng.s.r; R <= rng.e.r; ++R)for(var C = rng.s.c; C <= rng.e.c; ++C){
        var cell = $a1a91b25d7598376$var$ws_get_cell_stub(ws, R, C);
        cell.t = 'n';
        cell.F = rngstr;
        delete cell.v;
        if (R == rng.s.r && C == rng.s.c) {
            cell.f = formula;
            if (dynamic) cell.D = true;
        }
    }
    var wsr = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
    if (wsr.s.r > rng.s.r) wsr.s.r = rng.s.r;
    if (wsr.s.c > rng.s.c) wsr.s.c = rng.s.c;
    if (wsr.e.r < rng.e.r) wsr.e.r = rng.e.r;
    if (wsr.e.c < rng.e.c) wsr.e.c = rng.e.c;
    ws["!ref"] = $a1a91b25d7598376$var$encode_range(wsr);
    return ws;
}
var $a1a91b25d7598376$export$eab97d15b1788b8d /*:any*/  = {
    encode_col: $a1a91b25d7598376$var$encode_col,
    encode_row: $a1a91b25d7598376$var$encode_row,
    encode_cell: $a1a91b25d7598376$var$encode_cell,
    encode_range: $a1a91b25d7598376$var$encode_range,
    decode_col: $a1a91b25d7598376$var$decode_col,
    decode_row: $a1a91b25d7598376$var$decode_row,
    split_cell: $a1a91b25d7598376$var$split_cell,
    decode_cell: $a1a91b25d7598376$var$decode_cell,
    decode_range: $a1a91b25d7598376$var$decode_range,
    format_cell: $a1a91b25d7598376$var$format_cell,
    sheet_new: $a1a91b25d7598376$var$sheet_new,
    sheet_add_aoa: $a1a91b25d7598376$var$sheet_add_aoa,
    sheet_add_json: $a1a91b25d7598376$var$sheet_add_json,
    sheet_add_dom: $a1a91b25d7598376$var$sheet_add_dom,
    aoa_to_sheet: $a1a91b25d7598376$var$aoa_to_sheet,
    json_to_sheet: $a1a91b25d7598376$var$json_to_sheet,
    table_to_sheet: $a1a91b25d7598376$var$parse_dom_table,
    table_to_book: $a1a91b25d7598376$var$table_to_book,
    sheet_to_csv: $a1a91b25d7598376$var$sheet_to_csv,
    sheet_to_txt: $a1a91b25d7598376$var$sheet_to_txt,
    sheet_to_json: $a1a91b25d7598376$var$sheet_to_json,
    sheet_to_html: $a1a91b25d7598376$var$sheet_to_html,
    sheet_to_formulae: $a1a91b25d7598376$var$sheet_to_formulae,
    sheet_to_row_object_array: $a1a91b25d7598376$var$sheet_to_json,
    sheet_get_cell: $a1a91b25d7598376$var$ws_get_cell_stub,
    book_new: $a1a91b25d7598376$var$book_new,
    book_append_sheet: $a1a91b25d7598376$var$book_append_sheet,
    book_set_sheet_visibility: $a1a91b25d7598376$var$book_set_sheet_visibility,
    cell_set_number_format: $a1a91b25d7598376$var$cell_set_number_format,
    cell_set_hyperlink: $a1a91b25d7598376$var$cell_set_hyperlink,
    cell_set_internal_link: $a1a91b25d7598376$var$cell_set_internal_link,
    cell_add_comment: $a1a91b25d7598376$var$cell_add_comment,
    sheet_set_array_formula: $a1a91b25d7598376$var$sheet_set_array_formula,
    consts: {
        SHEET_VISIBLE: 0,
        SHEET_HIDDEN: 1,
        SHEET_VERY_HIDDEN: 2
    }
};
var $a1a91b25d7598376$var$_Readable;
function $a1a91b25d7598376$var$set_readable(R) {
    $a1a91b25d7598376$var$_Readable = R;
}
function $a1a91b25d7598376$var$write_csv_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable();
    var o = opts == null ? {} : opts;
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
    var FS = o.FS !== undefined ? o.FS : ",", fs = FS.charCodeAt(0);
    var RS = o.RS !== undefined ? o.RS : "\n", rs = RS.charCodeAt(0);
    var row /*:?string*/  = "", cols /*:Array<string>*/  = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(var C = r.s.c; C <= r.e.c; ++C)if (!(colinfo[C] || {}).hidden) cols[C] = $a1a91b25d7598376$var$encode_col(C);
    var R = r.s.r;
    var BOM = false, w = 0;
    stream._read = function() {
        if (!BOM) {
            BOM = true;
            return stream.push("\uFEFF");
        }
        while(R <= r.e.r){
            ++R;
            if ((rowinfo[R - 1] || {}).hidden) continue;
            row = $a1a91b25d7598376$var$make_csv_row(sheet, r, R - 1, cols, fs, rs, FS, w, o);
            if (row != null) {
                if (row || o.blankrows !== false) return stream.push((w++ ? RS : "") + row);
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $a1a91b25d7598376$var$write_html_stream(ws /*:Worksheet*/ , opts /*:?Sheet2HTMLOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable();
    var o = opts || {};
    var header = o.header != null ? o.header : $a1a91b25d7598376$var$HTML_BEGIN;
    var footer = o.footer != null ? o.footer : $a1a91b25d7598376$var$HTML_END;
    stream.push(header);
    var r = $a1a91b25d7598376$var$decode_range(ws['!ref']);
    stream.push($a1a91b25d7598376$var$make_html_preamble(ws, r, o));
    var R = r.s.r;
    var end = false;
    stream._read = function() {
        if (R > r.e.r) {
            if (!end) {
                end = true;
                stream.push("</table>" + footer);
            }
            return stream.push(null);
        }
        while(R <= r.e.r){
            stream.push($a1a91b25d7598376$var$make_html_row(ws, r, R, o));
            ++R;
            break;
        }
    };
    return stream;
}
function $a1a91b25d7598376$var$write_json_stream(sheet /*:Worksheet*/ , opts /*:?Sheet2CSVOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable({
        objectMode: true
    });
    if (sheet == null || sheet["!ref"] == null) {
        stream.push(null);
        return stream;
    }
    var val1 = {
        t: 'n',
        v: 0
    }, header = 0, offset = 1, hdr /*:Array<any>*/  = [], v = 0, vv = "";
    var r = {
        s: {
            r: 0,
            c: 0
        },
        e: {
            r: 0,
            c: 0
        }
    };
    var o = opts || {};
    var range = o.range != null ? o.range : sheet["!ref"];
    if (o.header === 1) header = 1;
    else if (o.header === "A") header = 2;
    else if (Array.isArray(o.header)) header = 3;
    switch(typeof range){
        case 'string':
            r = $a1a91b25d7598376$var$safe_decode_range(range);
            break;
        case 'number':
            r = $a1a91b25d7598376$var$safe_decode_range(sheet["!ref"]);
            r.s.r = range;
            break;
        default:
            r = range;
    }
    if (header > 0) offset = 0;
    var rr = $a1a91b25d7598376$var$encode_row(r.s.r);
    var cols /*:Array<string>*/  = [];
    var counter = 0;
    var dense = sheet["!data"] != null;
    var R = r.s.r, C = 0;
    var header_cnt = {};
    if (dense && !sheet["!data"][R]) sheet["!data"][R] = [];
    var colinfo /*:Array<ColInfo>*/  = o.skipHidden && sheet["!cols"] || [];
    var rowinfo /*:Array<RowInfo>*/  = o.skipHidden && sheet["!rows"] || [];
    for(C = r.s.c; C <= r.e.c; ++C){
        if ((colinfo[C] || {}).hidden) continue;
        cols[C] = $a1a91b25d7598376$var$encode_col(C);
        val1 = dense ? sheet["!data"][R][C] : sheet[cols[C] + rr];
        switch(header){
            case 1:
                hdr[C] = C - r.s.c;
                break;
            case 2:
                hdr[C] = cols[C];
                break;
            case 3:
                hdr[C] = o.header[C - r.s.c];
                break;
            default:
                if (val1 == null) val1 = {
                    w: "__EMPTY",
                    t: "s"
                };
                vv = v = $a1a91b25d7598376$var$format_cell(val1, null, o);
                counter = header_cnt[v] || 0;
                if (!counter) header_cnt[v] = 1;
                else {
                    do vv = v + "_" + counter++;
                    while (header_cnt[vv]);
                    header_cnt[v] = counter;
                    header_cnt[vv] = 1;
                }
                hdr[C] = vv;
        }
    }
    R = r.s.r + offset;
    stream._read = function() {
        while(R <= r.e.r){
            if ((rowinfo[R - 1] || {}).hidden) continue;
            var row = $a1a91b25d7598376$var$make_json_row(sheet, r, R, cols, header, hdr, o);
            ++R;
            if (row.isempty === false || (header === 1 ? o.blankrows !== false : !!o.blankrows)) {
                stream.push(row.row);
                return;
            }
        }
        return stream.push(null);
    };
    return stream;
}
function $a1a91b25d7598376$var$write_xlml_stream(wb /*:Workbook*/ , o /*:?Sheet2XLMLOpts*/ ) {
    var stream = $a1a91b25d7598376$var$_Readable();
    var opts = o == null ? {} : o;
    var stride = +opts.stride || 10;
    if (!wb.SSF) wb.SSF = $a1a91b25d7598376$var$dup($a1a91b25d7598376$var$table_fmt);
    if (wb.SSF) {
        $a1a91b25d7598376$var$make_ssf();
        $a1a91b25d7598376$var$SSF_load_table(wb.SSF);
        // $FlowIgnore
        opts.revssf = $a1a91b25d7598376$var$evert_num(wb.SSF);
        opts.revssf[wb.SSF[65535]] = 0;
        opts.ssf = wb.SSF;
        opts.cellXfs = [];
        $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, {}, {
            revssf: {
                "General": 0
            }
        });
    }
    /* do one pass to determine styles since they must be added before tables */ wb.SheetNames.forEach(function(n) {
        var ws = wb.Sheets[n];
        if (!ws || !ws["!ref"]) return;
        var range = $a1a91b25d7598376$var$decode_range(ws["!ref"]);
        var dense = ws["!data"] != null;
        var ddata = dense ? ws["!data"] : [];
        var addr = {
            r: 0,
            c: 0
        };
        for(var R = range.s.r; R <= range.e.r; ++R){
            addr.r = R;
            if (dense && !ddata[R]) continue;
            for(var C = range.s.c; C <= range.e.c; ++C){
                addr.c = C;
                var cell = dense ? ddata[R][C] : ws[$a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R)];
                if (!cell) continue;
                if (cell.t == "d" && cell.z == null) {
                    cell = $a1a91b25d7598376$var$dup(cell);
                    cell.z = $a1a91b25d7598376$var$table_fmt[14];
                }
                $a1a91b25d7598376$var$get_cell_style(opts.cellXfs, cell, opts);
            }
        }
    });
    var sty = $a1a91b25d7598376$var$write_sty_xlml(wb, opts);
    var stage = 0, wsidx = 0, ws = wb.Sheets[wb.SheetNames[wsidx]], range = $a1a91b25d7598376$var$safe_decode_range(ws), R = -1, T = false;
    var marr = [], mi = 0, dense = false, darr = [], addr = {
        r: 0,
        c: 0
    };
    stream._read = function() {
        switch(stage){
            /* header */ case 0:
                stage = 1;
                stream.push($a1a91b25d7598376$var$XML_HEADER);
                stream.push("<Workbook" + $a1a91b25d7598376$var$wxt_helper({
                    'xmlns': $a1a91b25d7598376$var$XLMLNS.ss,
                    'xmlns:o': $a1a91b25d7598376$var$XLMLNS.o,
                    'xmlns:x': $a1a91b25d7598376$var$XLMLNS.x,
                    'xmlns:ss': $a1a91b25d7598376$var$XLMLNS.ss,
                    'xmlns:dt': $a1a91b25d7598376$var$XLMLNS.dt,
                    'xmlns:html': $a1a91b25d7598376$var$XLMLNS.html
                }) + ">");
                break;
            /* preamble */ case 1:
                stage = 2;
                stream.push($a1a91b25d7598376$var$write_props_xlml(wb, opts));
                stream.push($a1a91b25d7598376$var$write_wb_xlml(wb, opts));
                break;
            /* style and name tables */ case 2:
                stage = 3;
                stream.push(sty);
                stream.push($a1a91b25d7598376$var$write_names_xlml(wb, opts));
                break;
            /* worksheet preamble */ case 3:
                T = false;
                if (wsidx >= wb.SheetNames.length) {
                    stage = -1;
                    stream.push("");
                    break;
                }
                stream.push("<Worksheet" + $a1a91b25d7598376$var$wxt_helper({
                    "ss:Name": $a1a91b25d7598376$var$escapexml(wb.SheetNames[wsidx])
                }) + ">");
                ws = wb.Sheets[wb.SheetNames[wsidx]];
                if (!ws) {
                    stream.push("</Worksheet>");
                    return void ++wsidx;
                }
                var names = $a1a91b25d7598376$var$write_ws_xlml_names(ws, opts, wsidx, wb);
                if (names.length) stream.push("<Names>" + names + "</Names>");
                if (!ws["!ref"]) return stage = 5;
                range = $a1a91b25d7598376$var$safe_decode_range(ws["!ref"]);
                R = range.s.r;
                stage = 4;
                break;
            /* worksheet intramble */ case 4:
                if (R < 0 || R > range.e.r) {
                    if (T) stream.push("</Table>");
                    return void (stage = 5);
                }
                if (R <= range.s.r) {
                    if (ws['!cols']) ws['!cols'].forEach(function(n, i) {
                        $a1a91b25d7598376$var$process_col(n);
                        var w = !!n.width;
                        var p = $a1a91b25d7598376$var$col_obj_w(i, n);
                        var k /*:any*/  = {
                            "ss:Index": i + 1
                        };
                        if (w) k['ss:Width'] = $a1a91b25d7598376$var$width2px(p.width);
                        if (n.hidden) k['ss:Hidden'] = "1";
                        if (!T) {
                            T = true;
                            stream.push("<Table>");
                        }
                        stream.push($a1a91b25d7598376$var$writextag("Column", null, k));
                    });
                    dense = ws["!data"] != null;
                    if (dense) darr = ws["!data"];
                    addr.r = addr.c = 0;
                }
                /* process `stride` rows per invocation */ for(var cnt = 0; R <= range.e.r && cnt < stride; ++R, ++cnt){
                    var row = [
                        $a1a91b25d7598376$var$write_ws_xlml_row(R, (ws['!rows'] || [])[R])
                    ];
                    addr.r = R;
                    if (!(dense && !darr[R])) for(var C = range.s.c; C <= range.e.c; ++C){
                        addr.c = C;
                        var skip = false;
                        for(mi = 0; mi != marr.length; ++mi){
                            if (marr[mi].s.c > C) continue;
                            if (marr[mi].s.r > R) continue;
                            if (marr[mi].e.c < C) continue;
                            if (marr[mi].e.r < R) continue;
                            if (marr[mi].s.c != C || marr[mi].s.r != R) skip = true;
                            break;
                        }
                        if (skip) continue;
                        var ref = $a1a91b25d7598376$var$encode_col(C) + $a1a91b25d7598376$var$encode_row(R), cell = dense ? darr[R][C] : ws[ref];
                        row.push($a1a91b25d7598376$var$write_ws_xlml_cell(cell, ref, ws, opts, wsidx, wb, addr));
                    }
                    row.push("</Row>");
                    if (!T) {
                        T = true;
                        stream.push("<Table>");
                    }
                    stream.push(row.join(""));
                }
                break;
            /* worksheet postamble */ case 5:
                stream.push($a1a91b25d7598376$var$write_ws_xlml_wsopts(ws, opts, wsidx, wb));
                if (ws && ws["!autofilter"]) stream.push('<AutoFilter x:Range="' + $a1a91b25d7598376$var$a1_to_rc($a1a91b25d7598376$var$fix_range(ws["!autofilter"].ref), {
                    r: 0,
                    c: 0
                }) + '" xmlns="urn:schemas-microsoft-com:office:excel"></AutoFilter>');
                stream.push("</Worksheet>");
                wsidx++;
                R = -1;
                return void (stage = 3);
            /* footer */ case -1:
                stage = -2;
                stream.push("</Workbook>");
                break;
            /* exeunt */ case -2:
                stream.push(null);
                break;
        }
    };
    return stream;
}
var $a1a91b25d7598376$export$4938110305e6185f = {
    to_json: $a1a91b25d7598376$var$write_json_stream,
    to_html: $a1a91b25d7598376$var$write_html_stream,
    to_csv: $a1a91b25d7598376$var$write_csv_stream,
    to_xlml: $a1a91b25d7598376$var$write_xlml_stream,
    set_readable: $a1a91b25d7598376$var$set_readable
};
const $a1a91b25d7598376$export$83d89fbfd8236492 = $a1a91b25d7598376$var$XLSX.version;
var $a1a91b25d7598376$export$2e2bcd8739ae039 = {
    parse_xlscfb: $a1a91b25d7598376$export$b41972a043aba84c,
    parse_zip: $a1a91b25d7598376$export$b165387946f79a1,
    read: $a1a91b25d7598376$export$aafa59e2e03f2942,
    readFile: $a1a91b25d7598376$export$72c04af63de9061a,
    readFileSync: $a1a91b25d7598376$export$72c04af63de9061a,
    write: $a1a91b25d7598376$export$68d8715fc104d294,
    writeFile: $a1a91b25d7598376$export$552bfb764b5cd2b4,
    writeFileSync: $a1a91b25d7598376$export$552bfb764b5cd2b4,
    writeFileAsync: $a1a91b25d7598376$export$25469296c4b8ebda,
    writeXLSX: $a1a91b25d7598376$export$f6ca43591cb061b1,
    writeFileXLSX: $a1a91b25d7598376$export$40a06aea54ee074e,
    utils: $a1a91b25d7598376$export$eab97d15b1788b8d,
    set_fs: $a1a91b25d7598376$export$a48eb669e1768bcf,
    set_cptable: $a1a91b25d7598376$export$58f247d16f363b86,
    stream: $a1a91b25d7598376$export$4938110305e6185f,
    SSF: $a1a91b25d7598376$export$40d8edd678456c2b,
    CFB: $a1a91b25d7598376$export$9f0e51cd97c572a
};








function $7739a5f0c43df8e2$export$2e2bcd8739ae039(props) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [pendingSelectedWaiver, setPendingSelectedWaiver] = (0, $7fPBF.useState)(null);
    const [selectedWaiver, setSelectedWaiver] = (0, $7fPBF.useState)(null);
    const [file, setFile] = (0, $7fPBF.useState)(null);
    const [sheetJSON, setSheetJSON] = (0, $7fPBF.useState)(null);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [selectedColumnIndex, setSelectedColumnIndex] = (0, $7fPBF.useState)(null);
    const [proposedUpdate, setProposedUpdate] = (0, $7fPBF.useState)(null);
    const [saving, setSaving] = (0, $7fPBF.useState)(false);
    const [success, setSuccess] = (0, $7fPBF.useState)(false);
    const createProposedUpdates = ()=>{
        if (selectedColumnIndex == null || !sheetJSON || !selectedWaiver) return;
        let newlyCompleted = [];
        let failedToFindMatch = [];
        // Take off header
        for (const row of sheetJSON.slice(1)){
            const name = row[selectedColumnIndex];
            if (!name || typeof name !== 'string') continue;
            let replace = name.replace(/[^a-zA-Z0-9 ,]/g, ' ').trim();
            let split = replace.split(', ').filter((s)=>s.length > 0);
            for (const item of split){
                const matchingAttendee = props.attendees.find((attendee)=>{
                    const attendeeName = attendee.name.toLowerCase();
                    return attendeeName === item.toLowerCase();
                });
                if (matchingAttendee) // only add if attendee hasn't completed waiver.
                {
                    if (!matchingAttendee.completedWaivers.find((w)=>w.id === selectedWaiver.id)) newlyCompleted.push(matchingAttendee);
                } else failedToFindMatch.push(item);
            }
        }
        setProposedUpdate({
            newlyCompleted: newlyCompleted,
            failedToFindMatch: failedToFindMatch
        });
    };
    const submitAttendeeUpdate = async (markAsComplete)=>{
        if (!selectedWaiver) return;
        setSaving(true);
        setError(null);
        try {
            const response = await (0, $6857e104788587b0$export$2e2bcd8739ae039).submitAttendeeWaiverCompletions(props.event.churchID, props.event.id, selectedWaiver.id, markAsComplete, auth);
            if (response.error || !response.body) {
                setError(response.error || "Failed to save updates. Please try again later.");
                return;
            }
            props.onAttendeesUpdated(response.body.attendees);
            setSuccess(true);
        } catch (err) {
            setError("Failed to save updates. Please try again later.");
        } finally{
            setSaving(false);
        }
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!props.isOpen) return;
        setError(null);
        setFile(null);
        setSheetJSON(null);
        setSelectedColumnIndex(null);
        setProposedUpdate(null);
        setSelectedWaiver(null);
        setPendingSelectedWaiver(null);
        setSaving(false);
        setSuccess(false);
    }, [
        props.isOpen
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!file) return;
        const parseFile = async ()=>{
            try {
                const ab = await file.arrayBuffer();
                const workbook = (0, $a1a91b25d7598376$export$2e2bcd8739ae039).read(ab, {
                    type: "array"
                });
                const firstSheetName = workbook.SheetNames[0];
                if (firstSheetName) {
                    const sheet = workbook.Sheets[firstSheetName];
                    const data = (0, $a1a91b25d7598376$export$2e2bcd8739ae039).utils.sheet_to_json(sheet, {
                        header: 1
                    });
                    setSheetJSON(data);
                } else setError("Failed to parse sheets from file. Please contact support with a copy of your spreadsheet.");
            } catch (err) {
                setError("Failed to parse sheets from file. Please contact support with a copy of your spreadsheet.");
            }
        };
        parseFile();
    }, [
        file
    ]);
    const closeButton = /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
        className: "close",
        href: "#",
        onClick: (e)=>{
            e.preventDefault();
            props.close();
        },
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
            className: "icon",
            src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
            alt: "Close icon"
        })
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        isOpen: props.isOpen,
        id: "manual-waiver-upload",
        footerButtons: [],
        children: [
            saving && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
                fullScreen: false
            }),
            !error && !saving && !success && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "header",
                children: [
                    closeButton,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                        children: "Manual Waiver Upload"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {})
                ]
            }),
            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    marginTop: 24
                },
                children: [
                    closeButton,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
                        error: error,
                        showButton: false
                    })
                ]
            }),
            !error && !selectedWaiver && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "selectWaiver",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Please select the waiver which you would like to update attendee status for."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                        value: pendingSelectedWaiver ? pendingSelectedWaiver.id : 'null',
                        onChange: (e)=>{
                            const waiver = props.event.waivers.find((w)=>w.id === e.target.value);
                            setPendingSelectedWaiver(waiver || null);
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                value: 'null',
                                disabled: true,
                                children: "-- Select Waiver --"
                            }),
                            props.event.waivers.map((waiver)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                    value: waiver.id,
                                    children: waiver.name
                                }, waiver.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        disabled: !pendingSelectedWaiver,
                        onClick: (e)=>{
                            e.preventDefault();
                            setSelectedWaiver(pendingSelectedWaiver);
                        },
                        children: "Next"
                    })
                ]
            }),
            !error && selectedWaiver && !sheetJSON && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Please select a spreadsheet (CSV or Excel files supported)"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                        type: "file",
                        name: "spreadsheet",
                        accept: ".xlsx,.xls,.csv",
                        onChange: (e)=>{
                            var _e_target_files;
                            e.preventDefault();
                            setFile(((_e_target_files = e.target.files) === null || _e_target_files === void 0 ? void 0 : _e_target_files[0]) || null);
                        }
                    })
                ]
            }),
            !error && sheetJSON && !proposedUpdate && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "columnSelect",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "Please select which column contains the names of attendees"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                        value: selectedColumnIndex === null ? 'null' : selectedColumnIndex,
                        onChange: (e)=>{
                            if (e.target.value === 'null') {
                                setSelectedColumnIndex(null);
                                return;
                            }
                            setSelectedColumnIndex(parseInt(e.target.value));
                        },
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                value: 'null',
                                disabled: true,
                                children: "-- Select Column --"
                            }),
                            sheetJSON[0] && sheetJSON[0].map((col, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                    value: idx,
                                    children: col || `Column ${idx + 1}`
                                }, idx))
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        disabled: selectedColumnIndex === null,
                        onClick: (e)=>{
                            e.preventDefault();
                            createProposedUpdates();
                        },
                        children: "Next"
                    })
                ]
            }),
            !error && proposedUpdate && selectedWaiver && !saving && !success && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($7739a5f0c43df8e2$var$ProposedUpdateEditor, {
                proposedUpdate: proposedUpdate,
                attendees: props.attendees,
                waiver: selectedWaiver,
                onConfirm: (markAsComplete)=>{
                    submitAttendeeUpdate(markAsComplete);
                }
            }),
            success && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                style: {
                    marginTop: 24
                },
                children: [
                    closeButton,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $9f2c42b26582cc85$export$2e2bcd8739ae039), {
                        title: "Waiver Submissions Updated",
                        description: "Successfully updated the waiver submissions for this event."
                    })
                ]
            })
        ]
    });
}
function $7739a5f0c43df8e2$var$ProposedUpdateEditor(props) {
    const { proposedUpdate: proposedUpdate } = props;
    const [participantOverride, setParticipantOverride] = (0, $7fPBF.useState)({});
    const availableAttendees = (0, $7fPBF.useMemo)(()=>{
        const newlyCompletedIds = new Set(proposedUpdate.newlyCompleted.map((a)=>a.id));
        return props.attendees.filter((attendee)=>!newlyCompletedIds.has(attendee.id)) // not recently completed
        .filter((attendee)=>attendee.completedWaivers.find((w)=>w.id == props.waiver.id) == null) // not already completed
        .filter((attendee)=>!Object.values(participantOverride).includes(attendee.id)); // not already selected as override
    }, [
        props.attendees,
        participantOverride
    ]);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "proposedUpdates",
        children: [
            proposedUpdate.newlyCompleted.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                        children: "Proposed Status Updates"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "These attendees will be marked as having recently completed the selected waiver."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                        className: "attendeeList",
                        children: proposedUpdate.newlyCompleted.sort((a, b)=>{
                            if (a.name === b.name) return 0;
                            return a.name < b.name ? -1 : 1;
                        }).map((attendee, idx)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                className: "attendee",
                                children: attendee.name
                            }, idx))
                    })
                ]
            }),
            proposedUpdate.failedToFindMatch.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                        children: "Unmatched Names"
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        children: "The following names could not be matched to any attendees who have not already completed the selected waiver. You may manually select an attendee per unmatched name, or leave blank to skip."
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("ul", {
                        className: "attendeeList",
                        children: proposedUpdate.failedToFindMatch.sort((a, b)=>{
                            if (a === b) return 0;
                            return a < b ? -1 : 1;
                        }).map((name, idx)=>{
                            const fuzzyMatch = props.attendees.find((attendee)=>{
                                const attendeeName = attendee.name.toLowerCase();
                                const attendeeNameSplit = attendeeName.split(" ");
                                const nameSplit = name.toLowerCase().split(" ");
                                for (const part of attendeeNameSplit)for (const namePart of nameSplit){
                                    if (part.toLowerCase() === namePart.toLowerCase()) return true;
                                }
                                return false;
                            });
                            return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("li", {
                                className: "attendee",
                                children: [
                                    name,
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                        value: participantOverride[name] || (fuzzyMatch === null || fuzzyMatch === void 0 ? void 0 : fuzzyMatch.id) || 'null',
                                        onChange: (e)=>{
                                            const selected = e.target.value;
                                            const newOverrides = (0, $6e5b65c9cbae0db9$export$71511d61b312f219)({}, participantOverride);
                                            if (selected === 'null') delete newOverrides[name];
                                            else newOverrides[name] = selected;
                                            setParticipantOverride(newOverrides);
                                            console.log(newOverrides);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                value: 'null',
                                                children: "-- Select Attendee --"
                                            }),
                                            props.attendees.sort((a, b)=>{
                                                if (a.name === b.name) return 0;
                                                return a.name < b.name ? -1 : 1;
                                            }).map((attendee)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                    value: attendee.id,
                                                    disabled: !availableAttendees.includes(attendee) && attendee.id !== participantOverride[name],
                                                    children: attendee.name
                                                }, attendee.id))
                                        ]
                                    })
                                ]
                            }, idx);
                        })
                    })
                ]
            }),
            proposedUpdate.failedToFindMatch.length === 0 && proposedUpdate.newlyCompleted.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                children: "No updates were found in the uploaded spreadsheet. Either the spreadsheet was impossible to read, or all attendees within have already been marked as having completed the selected waiver."
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                onClick: (e)=>{
                    e.preventDefault();
                    const finalNewlyCompleted = [
                        ...proposedUpdate.newlyCompleted
                    ];
                    for (const [_, attendeeId] of Object.entries(participantOverride)){
                        const attendee = props.attendees.find((a)=>a.id === attendeeId);
                        if (attendee) finalNewlyCompleted.push(attendee);
                    }
                    props.onConfirm(finalNewlyCompleted);
                },
                children: "Confirm Update"
            })
        ]
    });
}



function $ed4b406b926302af$var$useEventAttendees(eventID) {
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchId = auth.churchId;
    const [event, setEvent] = (0, $7fPBF.useState)(null);
    const [attendees, setAttendees] = (0, $7fPBF.useState)(null);
    const [loading, setLoading] = (0, $7fPBF.useState)(true);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const fetch = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchId) return;
        setLoading(true);
        setError(null);
        try {
            const [eventResponse, attendeesResponse] = await Promise.all([
                (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchEvent(churchId, eventID, auth),
                (0, $6857e104788587b0$export$2e2bcd8739ae039).fetchAttendeesForEvent(churchId, eventID, auth)
            ]);
            if (eventResponse.error) {
                setError(eventResponse.error);
                setAttendees(null);
                setEvent(null);
            } else if (attendeesResponse.error) {
                setError(attendeesResponse.error);
                setAttendees(null);
                setEvent(null);
            } else if (eventResponse.body && attendeesResponse.body) {
                setEvent(eventResponse.body.event);
                setAttendees(attendeesResponse.body.attendees);
            } else {
                setAttendees(null);
                setEvent(null);
            }
        } catch (err) {
            setError((err === null || err === void 0 ? void 0 : err.message) || 'Failed to load events');
            setAttendees(null);
            setEvent(null);
        } finally{
            setLoading(false);
        }
    }, [
        churchId,
        eventID,
        auth
    ]);
    const updateEvent = (newEvent)=>{
        setEvent(newEvent);
    };
    const updateAttendees = (newAttendees)=>{
        setAttendees(newAttendees);
    };
    (0, $7fPBF.useEffect)(()=>{
        if (!churchId || !eventID) return;
        let isMounted = true;
        const performFetch = async ()=>{
            await fetch();
            if (!isMounted) return;
        };
        performFetch();
        return ()=>{
            isMounted = false;
        };
    }, [
        churchId,
        fetch
    ]);
    return {
        attendees: attendees,
        event: event,
        loading: loading,
        error: error,
        refetch: fetch,
        updateEvent: updateEvent,
        updateAttendees: updateAttendees
    };
}
function $ed4b406b926302af$export$2e2bcd8739ae039() {
    const pathParams = (0, $d9fd026bfea79ab9$export$99eaa27ddbbb95ef)();
    const eventID = pathParams.eventID;
    if (!eventID) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
        to: "/events",
        replace: true
    });
    const [showSetupWaiverModal, setShowWaiverSetupModal] = (0, $7fPBF.useState)(false);
    const [showManualWaiverUploadModal, setShowManualWaiverUploadModal] = (0, $7fPBF.useState)(false);
    const [showSendWaiverEmailModal, setShowWaiverEmailModal] = (0, $7fPBF.useState)(false);
    const [waiverFilter, setWaiverFilter] = (0, $7fPBF.useState)('all');
    const { attendees: attendees, event: event, loading: loading, error: error, updateEvent: updateEvent, updateAttendees: updateAttendees } = $ed4b406b926302af$var$useEventAttendees(eventID);
    const filteredAttendees = (0, $7fPBF.useMemo)(()=>{
        if (!attendees || !event) return [];
        return attendees.filter((attendee)=>{
            if (waiverFilter === 'all') return true;
            return !event.waivers.every((waiver)=>attendee.completedWaivers.find((cw)=>cw.id === waiver.id) !== undefined);
        });
    }, [
        attendees,
        event,
        waiverFilter
    ]);
    const makeWaiverCompletionsData = ()=>{
        if (!event || !attendees) return null;
        const headers = [
            'Name',
            ...event.waivers.map((w)=>w.name)
        ];
        const rows = [
            headers
        ];
        const attendeeData = attendees.sort((a, b)=>{
            return a.name.localeCompare(b.name); // alphabetical order
        });
        attendeeData.forEach((attendee)=>{
            const row = [
                attendee.name
            ];
            event.waivers.forEach((waiver)=>{
                const isCompleted = attendee.completedWaivers.some((cw)=>cw.id === waiver.id);
                row.push(isCompleted ? 'X' : '');
            });
            rows.push(row);
        });
        return rows;
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "event-details-page",
        children: [
            loading && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {}),
            error && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                className: "error",
                children: [
                    "Error loading event details: ",
                    error
                ]
            }),
            event && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "content",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7f236beed1e911ce$export$2e2bcd8739ae039), {
                        title: event === null || event === void 0 ? void 0 : event.title,
                        backLocation: "/events",
                        dropdown: {
                            title: 'Event Actions',
                            items: [
                                {
                                    title: 'New Waiver',
                                    icon: (0, $0298034ab94cd70d$export$3ed8400b82efd319).DOCUMENT,
                                    onClick: ()=>{
                                        setShowWaiverSetupModal(true);
                                    }
                                },
                                {
                                    title: 'Manual Waiver Upload',
                                    icon: (0, $0298034ab94cd70d$export$3ed8400b82efd319).SHARE,
                                    onClick: ()=>{
                                        setShowManualWaiverUploadModal(true);
                                    }
                                },
                                {
                                    title: 'Send Reminder Emails',
                                    icon: (0, $0298034ab94cd70d$export$3ed8400b82efd319).MAIL,
                                    onClick: ()=>{
                                        setShowWaiverEmailModal(true);
                                    }
                                },
                                {
                                    title: 'Download Completed Waivers',
                                    icon: (0, $0298034ab94cd70d$export$3ed8400b82efd319).DOCUMENT,
                                    onClick: ()=>{
                                        const data = makeWaiverCompletionsData();
                                        if (data) {
                                            const worksheet = (0, $a1a91b25d7598376$export$2e2bcd8739ae039).utils.aoa_to_sheet(data);
                                            const workbook = (0, $a1a91b25d7598376$export$2e2bcd8739ae039).utils.book_new();
                                            (0, $a1a91b25d7598376$export$2e2bcd8739ae039).utils.book_append_sheet(workbook, worksheet, "Waivers");
                                            (0, $a1a91b25d7598376$export$2e2bcd8739ae039).writeFile(workbook, `${event.title}-waivers.xlsx`);
                                        } else window.alert('No data available to export.');
                                    }
                                }
                            ]
                        },
                        links: []
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $75c3ed5f39befefd$export$2e2bcd8739ae039), {
                        event: event,
                        isOpen: showSetupWaiverModal,
                        updateEvent: updateEvent,
                        close: ()=>{
                            setShowWaiverSetupModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a879c7c9b4e34f4c$export$2e2bcd8739ae039), {
                        event: event,
                        isOpen: showSendWaiverEmailModal,
                        close: ()=>{
                            setShowWaiverEmailModal(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7739a5f0c43df8e2$export$2e2bcd8739ae039), {
                        event: event,
                        attendees: attendees || [],
                        isOpen: showManualWaiverUploadModal,
                        onAttendeesUpdated: (attendees)=>{
                            updateAttendees(attendees);
                        },
                        close: ()=>{
                            setShowManualWaiverUploadModal(false);
                        }
                    }),
                    attendees && event && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '1rem'
                                },
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h3", {
                                        style: {
                                            margin: 0
                                        },
                                        children: [
                                            "Attendees (",
                                            filteredAttendees.length,
                                            ")"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("label", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '0.5rem'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                                                children: "Filter:"
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("select", {
                                                value: waiverFilter,
                                                onChange: (e)=>setWaiverFilter(e.target.value),
                                                style: {
                                                    padding: '0.25rem 0.5rem',
                                                    cursor: 'pointer'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                        value: "all",
                                                        children: "All Attendees"
                                                    }),
                                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("option", {
                                                        value: "incomplete",
                                                        children: "Incomplete Waivers"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                style: {
                                    margin: 0
                                },
                                children: "If this event was just imported from Planning Center, it may take some time before attendees are available."
                            }),
                            attendees.length === 0 ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                children: "No attendees registered for this event."
                            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                className: "legend grid-format",
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        children: "Waivers"
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {}),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                        style: {
                                            textAlign: 'end'
                                        },
                                        children: "Submitted"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "cards",
                                children: [
                                    ...filteredAttendees
                                ].sort((a, b)=>{
                                    const roleCompare = a.role.localeCompare(b.role);
                                    if (roleCompare !== 0) return roleCompare;
                                    const nameCompare = a.name.localeCompare(b.name);
                                    if (nameCompare !== 0) return nameCompare;
                                    return a.createdAt && b.createdAt ? new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime() : 0;
                                }).map((attendee)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($ed4b406b926302af$var$AttendeeCard, {
                                        attendee: attendee,
                                        waivers: event.waivers
                                    }, attendee.id))
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
function $ed4b406b926302af$var$AttendeeCard(props) {
    const completedAllWaivers = props.waivers.every((waiver)=>props.attendee.completedWaivers.find((cw)=>cw.id === waiver.id) !== undefined);
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: 'attendee-card card grid-format ' + (completedAllWaivers ? 'complete' : 'incomplete'),
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "status-strip",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "metadata",
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "name",
                        children: props.attendee.name
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        className: 'role-label ' + props.attendee.role.toLowerCase(),
                        children: [
                            props.attendee.role == 'volunteer' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($6df11232f48ec2ff$exports))),
                                className: "volunteer",
                                alt: "Volunteer icon"
                            }) : null,
                            props.attendee.role.charAt(0).toUpperCase() + props.attendee.role.slice(1)
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "waivers",
                role: "group",
                "aria-label": "Waiver status",
                children: props.waivers.map((waiver)=>{
                    const completed = props.attendee.completedWaivers.find((cw)=>cw.id === waiver.id) !== undefined;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        className: "waiver " + (completed ? "waiver--complete" : "waiver--incomplete"),
                        "aria-label": waiver.name
                    }, waiver.id);
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {}),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "date",
                children: props.attendee.createdAt ? (0, $485b75493327b6f7$export$2e2bcd8739ae039).fromISO(props.attendee.createdAt).toFormat("LLL dd, yyyy") : null
            })
        ]
    });
}






var $7fPBF = parcelRequire("7fPBF");


var $7fPBF = parcelRequire("7fPBF");




class $12067525e9cf7d1e$export$2e2bcd8739ae039 {
    static async createCampus(churchID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/campus`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    static async updateCampus(churchID, campusID, attributes, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/campus/${campusID}`, {
            attributes: attributes
        }), auth.consumeRefreshToken);
    }
    static async deleteCampus(churchID, campusID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/campus/${campusID}`), auth.consumeRefreshToken);
    }
}
$12067525e9cf7d1e$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";



function $4db1538198bec684$export$2e2bcd8739ae039(props) {
    var _props_campus, _props_campus1, _props_campus_attributes_address, _props_campus2, _props_campus_attributes_address1, _props_campus3, _props_campus_attributes_address2, _props_campus4, _props_campus_attributes_address3, _props_campus5, _props_campus_attributes_address4, _props_campus6;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    var _props_campus_attributes_name;
    const modalTitle = (_props_campus_attributes_name = (_props_campus = props.campus) === null || _props_campus === void 0 ? void 0 : _props_campus.attributes.name) !== null && _props_campus_attributes_name !== void 0 ? _props_campus_attributes_name : 'New Campus';
    var _props_campus_attributes_name1;
    const [name, setName] = (0, $7fPBF.useState)((_props_campus_attributes_name1 = (_props_campus1 = props.campus) === null || _props_campus1 === void 0 ? void 0 : _props_campus1.attributes.name) !== null && _props_campus_attributes_name1 !== void 0 ? _props_campus_attributes_name1 : '');
    var _props_campus_attributes_address_street;
    const [street, setStreet] = (0, $7fPBF.useState)((_props_campus_attributes_address_street = (_props_campus2 = props.campus) === null || _props_campus2 === void 0 ? void 0 : (_props_campus_attributes_address = _props_campus2.attributes.address) === null || _props_campus_attributes_address === void 0 ? void 0 : _props_campus_attributes_address.street) !== null && _props_campus_attributes_address_street !== void 0 ? _props_campus_attributes_address_street : '');
    var _props_campus_attributes_address_city;
    const [city, setCity] = (0, $7fPBF.useState)((_props_campus_attributes_address_city = (_props_campus3 = props.campus) === null || _props_campus3 === void 0 ? void 0 : (_props_campus_attributes_address1 = _props_campus3.attributes.address) === null || _props_campus_attributes_address1 === void 0 ? void 0 : _props_campus_attributes_address1.city) !== null && _props_campus_attributes_address_city !== void 0 ? _props_campus_attributes_address_city : '');
    var _props_campus_attributes_address_state;
    const [state, setState] = (0, $7fPBF.useState)((_props_campus_attributes_address_state = (_props_campus4 = props.campus) === null || _props_campus4 === void 0 ? void 0 : (_props_campus_attributes_address2 = _props_campus4.attributes.address) === null || _props_campus_attributes_address2 === void 0 ? void 0 : _props_campus_attributes_address2.state) !== null && _props_campus_attributes_address_state !== void 0 ? _props_campus_attributes_address_state : '');
    var _props_campus_attributes_address_zip;
    const [zip, setZip] = (0, $7fPBF.useState)((_props_campus_attributes_address_zip = (_props_campus5 = props.campus) === null || _props_campus5 === void 0 ? void 0 : (_props_campus_attributes_address3 = _props_campus5.attributes.address) === null || _props_campus_attributes_address3 === void 0 ? void 0 : _props_campus_attributes_address3.zip) !== null && _props_campus_attributes_address_zip !== void 0 ? _props_campus_attributes_address_zip : '');
    var _props_campus_attributes_address_country;
    const [country, setCountry] = (0, $7fPBF.useState)((_props_campus_attributes_address_country = (_props_campus6 = props.campus) === null || _props_campus6 === void 0 ? void 0 : (_props_campus_attributes_address4 = _props_campus6.attributes.address) === null || _props_campus_attributes_address4 === void 0 ? void 0 : _props_campus_attributes_address4.country) !== null && _props_campus_attributes_address_country !== void 0 ? _props_campus_attributes_address_country : '');
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const saveCampus = async ()=>{
        if (!auth.churchId) {
            setError('Missing church context. Please refresh and try again.');
            return;
        }
        const trimmedName = name.trim();
        if (trimmedName.length === 0) {
            setError('Please give this campus a name.');
            return;
        }
        const addressFields = [
            street,
            city,
            state,
            zip,
            country
        ].map((value)=>value.trim());
        const hasAnyAddressField = addressFields.some((value)=>value.length > 0);
        const hasAllAddressFields = addressFields.every((value)=>value.length > 0);
        if (hasAnyAddressField && !hasAllAddressFields) {
            setError('If you add an address, please fill out every address field.');
            return;
        }
        setIsSaving(true);
        setError(null);
        try {
            const attributes = {
                name: trimmedName,
                address: hasAllAddressFields ? {
                    street: street.trim(),
                    city: city.trim(),
                    state: state.trim(),
                    zip: zip.trim(),
                    country: country.trim()
                } : undefined
            };
            const response = props.campus ? await (0, $12067525e9cf7d1e$export$2e2bcd8739ae039).updateCampus(auth.churchId, props.campus.id, attributes, auth) : await (0, $12067525e9cf7d1e$export$2e2bcd8739ae039).createCampus(auth.churchId, attributes, auth);
            if (!response.body) {
                setError(response.error || 'Unable to save this campus right now.');
                setIsSaving(false);
                return;
            }
            props.onSaved(response.body);
        } finally{
            setIsSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "campus-modal",
        isOpen: props.isOpen,
        footerButtons: [
            {
                title: props.campus ? 'Save Changes' : 'Create Campus',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !isSaving,
                onClick: saveCampus
            },
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !isSaving,
                onClick: props.close
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "campus-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            className: "close",
                            "aria-disabled": isSaving,
                            className: isSaving ? 'close disabled' : 'close',
                            href: "#",
                            onClick: (e)=>{
                                e.preventDefault();
                                if (isSaving) return;
                                props.close();
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: modalTitle
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "save-error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "field-container",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                    htmlFor: "campus-name",
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                    id: "campus-name",
                                    type: "text",
                                    name: "campus-name",
                                    placeholder: "Campus Name",
                                    value: name,
                                    onChange: (e)=>setName(e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            className: "address-section",
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "section-copy",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                            children: "Address"
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "caption",
                                            children: "Optional"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "field-container",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                        id: "campus-street",
                                        type: "text",
                                        placeholder: "Street",
                                        value: street,
                                        onChange: (e)=>setStreet(e.target.value)
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "address-grid",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "field-container",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                id: "campus-city",
                                                type: "text",
                                                placeholder: "City",
                                                value: city,
                                                onChange: (e)=>setCity(e.target.value)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "field-container",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                id: "campus-state",
                                                type: "text",
                                                placeholder: "State",
                                                value: state,
                                                onChange: (e)=>setState(e.target.value)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "field-container",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                id: "campus-zip",
                                                type: "text",
                                                placeholder: "ZIP",
                                                value: zip,
                                                onChange: (e)=>setZip(e.target.value)
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                            className: "field-container",
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                                id: "campus-country",
                                                type: "text",
                                                placeholder: "Country",
                                                value: country,
                                                onChange: (e)=>setCountry(e.target.value)
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}





var $7fPBF = parcelRequire("7fPBF");





class $a48cbcb0792c3f61$export$2e2bcd8739ae039 {
    static async createCategory(churchID, name, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).POST, `/v1/church/${churchID}/category`, {
            name: name
        }), auth.consumeRefreshToken);
    }
    static async updateCategory(churchID, categoryID, name, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).PATCH, `/v1/church/${churchID}/category/${categoryID}`, {
            name: name
        }), auth.consumeRefreshToken);
    }
    static async deleteCategory(churchID, categoryID, auth) {
        return await (0, $45c7c1b07e176ae0$export$2e2bcd8739ae039).performRequestAt(this.baseURL, new (0, $45c7c1b07e176ae0$export$3df08bb5d0f8b499)((0, $45c7c1b07e176ae0$export$f03a741ee867f39c).DELETE, `/v1/church/${churchID}/category/${categoryID}`), auth.consumeRefreshToken);
    }
}
$a48cbcb0792c3f61$export$2e2bcd8739ae039.baseURL = "https://sanctuary-api.saltplatform.com";




// Sanctuary's refusal when content still points at the campus or category.
const $2f262a84d665f8bd$var$HTTP_CONFLICT = 409;
function $2f262a84d665f8bd$export$2e2bcd8739ae039(props) {
    var _props_campus, _props_category;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const [isDeleting, setIsDeleting] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    // Sanctuary's message naming what still uses it, e.g. "This campus is still
    // used by 2 playlists and 1 event. Remove or reassign that content first."
    const [blockedReason, setBlockedReason] = (0, $7fPBF.useState)(null);
    const targetType = props.campus ? 'campus' : 'category';
    var _props_campus_attributes_name, _ref;
    const targetName = (_ref = (_props_campus_attributes_name = (_props_campus = props.campus) === null || _props_campus === void 0 ? void 0 : _props_campus.attributes.name) !== null && _props_campus_attributes_name !== void 0 ? _props_campus_attributes_name : (_props_category = props.category) === null || _props_category === void 0 ? void 0 : _props_category.name) !== null && _ref !== void 0 ? _ref : targetType === 'campus' ? 'Campus' : 'Category';
    const deleteTarget = async ()=>{
        if (!auth.churchId || !props.campus && !props.category) {
            setError(`Missing ${targetType} context. Please refresh and try again.`);
            return;
        }
        setIsDeleting(true);
        setError(null);
        try {
            const response = props.campus ? await (0, $12067525e9cf7d1e$export$2e2bcd8739ae039).deleteCampus(auth.churchId, props.campus.id, auth) : await (0, $a48cbcb0792c3f61$export$2e2bcd8739ae039).deleteCategory(auth.churchId, props.category.id, auth);
            if (response.status === $2f262a84d665f8bd$var$HTTP_CONFLICT) {
                var _response_error;
                setBlockedReason((_response_error = response.error) !== null && _response_error !== void 0 ? _response_error : `This ${targetType} is still in use. Remove or reassign that content first.`);
                return;
            }
            if (response.error) {
                setError(response.error);
                return;
            }
            props.onDeleted();
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "delete-campus-modal",
        isOpen: props.isOpen,
        footerButtons: blockedReason ? [
            {
                title: 'Done',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                onClick: props.close
            }
        ] : [
            {
                title: targetType === 'campus' ? 'Delete Campus' : 'Delete Category',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !isDeleting,
                onClick: deleteTarget
            },
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !isDeleting,
                onClick: props.close
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "delete-campus-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            "aria-disabled": isDeleting,
                            className: isDeleting ? 'close disabled' : 'close',
                            href: "#",
                            onClick: (e)=>{
                                e.preventDefault();
                                if (isDeleting) return;
                                props.close();
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: blockedReason ? `Can't Delete ${targetName}` : `Delete ${targetName}`
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "save-error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5407115776bd457c$exports))),
                            alt: "",
                            "aria-hidden": "true",
                            className: "warning-icon"
                        }),
                        blockedReason ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "warning-copy",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("strong", {
                                        children: [
                                            targetName,
                                            " can't be deleted while content still uses it."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "warning-copy",
                                    children: blockedReason
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    className: "warning-copy caption",
                                    children: [
                                        "Open each item and choose a different ",
                                        targetType,
                                        ", or none, then try deleting again."
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "warning-copy",
                                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("strong", {
                                        children: [
                                            "Are you sure you want to delete ",
                                            targetName,
                                            "?"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                    className: "warning-copy",
                                    children: [
                                        "A ",
                                        targetType,
                                        " can only be deleted once nothing is linked to it. If any Launchpads, Playlists, Services, or Events still use ",
                                        targetName,
                                        ", deletion won't be possible until they're unlinked from it."
                                    ]
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                    className: "warning-copy caption",
                                    children: "This action cannot be undone."
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}




var $7fPBF = parcelRequire("7fPBF");





function $ac531395aa823ed9$export$2e2bcd8739ae039(props) {
    var _props_category, _props_category1;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    var _props_category_name;
    const modalTitle = (_props_category_name = (_props_category = props.category) === null || _props_category === void 0 ? void 0 : _props_category.name) !== null && _props_category_name !== void 0 ? _props_category_name : 'New Category';
    var _props_category_name1;
    const [name, setName] = (0, $7fPBF.useState)((_props_category_name1 = (_props_category1 = props.category) === null || _props_category1 === void 0 ? void 0 : _props_category1.name) !== null && _props_category_name1 !== void 0 ? _props_category_name1 : '');
    const [isSaving, setIsSaving] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const saveCategory = async ()=>{
        if (!auth.churchId) {
            setError('Missing church context. Please refresh and try again.');
            return;
        }
        const trimmedName = name.trim();
        if (trimmedName.length === 0) {
            setError('Please give this category a name.');
            return;
        }
        setIsSaving(true);
        setError(null);
        try {
            const response = props.category ? await (0, $a48cbcb0792c3f61$export$2e2bcd8739ae039).updateCategory(auth.churchId, props.category.id, trimmedName, auth) : await (0, $a48cbcb0792c3f61$export$2e2bcd8739ae039).createCategory(auth.churchId, trimmedName, auth);
            if (!response.body) {
                setError(response.error || 'Unable to save this category right now.');
                setIsSaving(false);
                return;
            }
            props.onSaved(response.body);
        } finally{
            setIsSaving(false);
        }
    };
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "category-modal",
        isOpen: props.isOpen,
        footerButtons: [
            {
                title: props.category ? 'Save Changes' : 'Create Category',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).FILLED,
                enabled: !isSaving,
                onClick: saveCategory
            },
            {
                title: 'Cancel',
                style: (0, $63d64463cd01676b$export$46c1ead11549edea).OUTLINE,
                enabled: !isSaving,
                onClick: props.close
            }
        ],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "category-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("a", {
                            className: isSaving ? 'close disabled' : 'close',
                            "aria-disabled": isSaving,
                            href: "#",
                            onClick: (e)=>{
                                e.preventDefault();
                                if (isSaving) return;
                                props.close();
                            },
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                className: "icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: modalTitle
                        })
                    ]
                }),
                error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "save-error",
                    children: error
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "body",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "field-container",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("label", {
                                htmlFor: "category-name",
                                children: "Name"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                                id: "category-name",
                                type: "text",
                                name: "category-name",
                                placeholder: "Category Name",
                                value: name,
                                onChange: (e)=>setName(e.target.value)
                            })
                        ]
                    })
                })
            ]
        })
    });
}



function $29a438cb51d3f023$export$2e2bcd8739ae039() {
    const churchData = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    const campuses = churchData.campuses;
    const categories = churchData.categories;
    const [isCampusModalOpen, setIsCampusModalOpen] = (0, $7fPBF.useState)(false);
    const [campusForModal, setCampusForModal] = (0, $7fPBF.useState)(null);
    const [isDeleteCampusModalOpen, setIsDeleteCampusModalOpen] = (0, $7fPBF.useState)(false);
    const [campusForDeleteModal, setCampusForDeleteModal] = (0, $7fPBF.useState)(null);
    const [isCategoryModalOpen, setIsCategoryModalOpen] = (0, $7fPBF.useState)(false);
    const [categoryForModal, setCategoryForModal] = (0, $7fPBF.useState)(null);
    const [isDeleteCategoryModalOpen, setIsDeleteCategoryModalOpen] = (0, $7fPBF.useState)(false);
    const [categoryForDeleteModal, setCategoryForDeleteModal] = (0, $7fPBF.useState)(null);
    const [newCampusModalKey, setNewCampusModalKey] = (0, $7fPBF.useState)(0);
    const [newCategoryModalKey, setNewCategoryModalKey] = (0, $7fPBF.useState)(0);
    const closeCampusModal = ()=>{
        setIsCampusModalOpen(false);
        window.setTimeout(()=>{
            setCampusForModal(null);
        }, 200);
    };
    const closeDeleteCampusModal = ()=>{
        setIsDeleteCampusModalOpen(false);
        window.setTimeout(()=>{
            setCampusForDeleteModal(null);
        }, 200);
    };
    const closeCategoryModal = ()=>{
        setIsCategoryModalOpen(false);
        window.setTimeout(()=>{
            setCategoryForModal(null);
        }, 200);
    };
    const closeDeleteCategoryModal = ()=>{
        setIsDeleteCategoryModalOpen(false);
        window.setTimeout(()=>{
            setCategoryForDeleteModal(null);
        }, 200);
    };
    if (!churchData.church || !churchData.campuses) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "settings-page",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {})
    });
    var _campusForModal_id, _campusForDeleteModal_id, _categoryForModal_id, _categoryForDeleteModal_id;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "settings-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4db1538198bec684$export$2e2bcd8739ae039), {
                isOpen: isCampusModalOpen,
                campus: campusForModal,
                close: closeCampusModal,
                onSaved: ()=>{
                    churchData.reloadChurch();
                    closeCampusModal();
                }
            }, (_campusForModal_id = campusForModal === null || campusForModal === void 0 ? void 0 : campusForModal.id) !== null && _campusForModal_id !== void 0 ? _campusForModal_id : `new-campus-${newCampusModalKey}`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f262a84d665f8bd$export$2e2bcd8739ae039), {
                isOpen: isDeleteCampusModalOpen,
                campus: campusForDeleteModal,
                close: closeDeleteCampusModal,
                onDeleted: ()=>{
                    churchData.reloadChurch();
                    closeDeleteCampusModal();
                }
            }, (_campusForDeleteModal_id = campusForDeleteModal === null || campusForDeleteModal === void 0 ? void 0 : campusForDeleteModal.id) !== null && _campusForDeleteModal_id !== void 0 ? _campusForDeleteModal_id : 'delete-campus'),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ac531395aa823ed9$export$2e2bcd8739ae039), {
                isOpen: isCategoryModalOpen,
                category: categoryForModal,
                close: closeCategoryModal,
                onSaved: ()=>{
                    churchData.reloadChurch();
                    closeCategoryModal();
                }
            }, (_categoryForModal_id = categoryForModal === null || categoryForModal === void 0 ? void 0 : categoryForModal.id) !== null && _categoryForModal_id !== void 0 ? _categoryForModal_id : `new-category-${newCategoryModalKey}`),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2f262a84d665f8bd$export$2e2bcd8739ae039), {
                isOpen: isDeleteCategoryModalOpen,
                category: categoryForDeleteModal,
                close: closeDeleteCategoryModal,
                onDeleted: ()=>{
                    churchData.reloadChurch();
                    closeDeleteCategoryModal();
                }
            }, (_categoryForDeleteModal_id = categoryForDeleteModal === null || categoryForDeleteModal === void 0 ? void 0 : categoryForDeleteModal.id) !== null && _categoryForDeleteModal_id !== void 0 ? _categoryForDeleteModal_id : 'delete-category'),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ae515035e6d7062$export$2e2bcd8739ae039), {
                title: "Settings",
                tabs: [],
                buttons: []
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "section-header",
                children: "Campuses"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "section card",
                children: [
                    campuses.map((campus, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                index > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "divider"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "campus",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "campus-header",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                                    children: campus.attributes.name
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                                    className: "campus-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                            className: "inline-action-button",
                                                            onClick: ()=>{
                                                                setCampusForModal(campus);
                                                                setIsCampusModalOpen(true);
                                                            },
                                                            children: "Edit"
                                                        }),
                                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                            className: "inline-action-button danger",
                                                            onClick: ()=>{
                                                                setCampusForDeleteModal(campus);
                                                                setIsDeleteCampusModalOpen(true);
                                                            },
                                                            children: "Delete"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        campus.attributes.address && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "address",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    children: campus.attributes.address.street
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                                                    children: [
                                                        campus.attributes.address.city,
                                                        ", ",
                                                        campus.attributes.address.state,
                                                        " ",
                                                        campus.attributes.address.zip
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                    children: campus.attributes.address.country
                                                })
                                            ]
                                        }),
                                        !campus.attributes.address && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                            className: "address",
                                            children: "No address"
                                        })
                                    ]
                                })
                            ]
                        }, campus.id)),
                    campuses.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "divider"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                className: "inline-action-button",
                                onClick: ()=>{
                                    setCampusForModal(null);
                                    setNewCampusModalKey((currentKey)=>currentKey + 1);
                                    setIsCampusModalOpen(true);
                                },
                                children: "+ Add Campus"
                            })
                        ]
                    }),
                    campuses.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "inline-action-button",
                        onClick: ()=>{
                            setCampusForModal(null);
                            setNewCampusModalKey((currentKey)=>currentKey + 1);
                            setIsCampusModalOpen(true);
                        },
                        children: "+ Add Campus"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "section-header",
                children: "Categories"
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                className: "section card",
                children: [
                    categories.map((category, index)=>/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                            children: [
                                index > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                    className: "divider"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                    className: "category-row",
                                    children: [
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                                            children: category.name
                                        }),
                                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                                            className: "campus-actions",
                                            children: [
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    className: "inline-action-button",
                                                    onClick: ()=>{
                                                        setCategoryForModal(category);
                                                        setIsCategoryModalOpen(true);
                                                    },
                                                    children: "Edit"
                                                }),
                                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                                    className: "inline-action-button danger",
                                                    onClick: ()=>{
                                                        setCategoryForDeleteModal(category);
                                                        setIsDeleteCategoryModalOpen(true);
                                                    },
                                                    children: "Delete"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, category.id)),
                    categories.length > 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                                className: "divider"
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                className: "inline-action-button",
                                onClick: ()=>{
                                    setCategoryForModal(null);
                                    setNewCategoryModalKey((currentKey)=>currentKey + 1);
                                    setIsCategoryModalOpen(true);
                                },
                                children: "+ Add Category"
                            })
                        ]
                    }),
                    categories.length === 0 && /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        className: "inline-action-button",
                        onClick: ()=>{
                            setCategoryForModal(null);
                            setNewCategoryModalKey((currentKey)=>currentKey + 1);
                            setIsCategoryModalOpen(true);
                        },
                        children: "+ Add Category"
                    })
                ]
            })
        ]
    });
}





var $7fPBF = parcelRequire("7fPBF");







var $7fPBF = parcelRequire("7fPBF");






// Quick at first, so the card feels live, then slower: a large import can run
// long enough that a steady 4s would add up to hundreds of requests.
function $d8987e8fd3e2f706$var$pollDelay(elapsedMs) {
    if (elapsedMs < 60000) return 4000;
    if (elapsedMs < 300000) return 15000;
    return 30000;
}
// The start route's two refusals, from StartPeopleImportForChurch.
const $d8987e8fd3e2f706$var$ALREADY_IMPORTED = 'ALREADY_IMPORTED';
const $d8987e8fd3e2f706$var$IMPORT_IN_PROGRESS = 'IMPORT_IN_PROGRESS';
function $d8987e8fd3e2f706$var$newestFirst(jobs) {
    return [
        ...jobs
    ].sort((one, two)=>two.createdAt.localeCompare(one.createdAt));
}
function $d8987e8fd3e2f706$export$2e2bcd8739ae039(options = {}) {
    var _options_provider;
    const provider = (_options_provider = options.provider) !== null && _options_provider !== void 0 ? _options_provider : (0, $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72).PLANNING_CENTER;
    const auth = (0, $12342e602c448a3c$export$1d39dc5b47e56ff0)();
    const churchID = auth.churchId;
    const { integrations: integrations, reloadConnectionStatus: reloadConnectionStatus } = (0, $516c6e0c0adbc42f$export$2f841eb01d18b05e)();
    var _integrations_find;
    const connection = (_integrations_find = integrations === null || integrations === void 0 ? void 0 : integrations.find((candidate)=>candidate.provider === provider)) !== null && _integrations_find !== void 0 ? _integrations_find : null;
    const isConnected = (0, $5586e2638b6c1db4$export$432e3e4ebac25704)(connection);
    var _connection_peopleImportCompletedAt;
    const importedAt = (_connection_peopleImportCompletedAt = connection === null || connection === void 0 ? void 0 : connection.peopleImportCompletedAt) !== null && _connection_peopleImportCompletedAt !== void 0 ? _connection_peopleImportCompletedAt : null;
    // Starting needs what Sanctuary's start route asks for, a People Manager or
    // an admin; anyone can watch one that's already running.
    const canStart = auth.hasPermission((0, $490c7b02975ed1ea$export$dd9f17662886326).MANAGE_PEOPLE);
    const [jobs, setJobs] = (0, $7fPBF.useState)(null);
    // The job started or polled in this session, which is newer than the list.
    const [trackedJob, setTrackedJob] = (0, $7fPBF.useState)(null);
    const [alreadyImported, setAlreadyImported] = (0, $7fPBF.useState)(false);
    const [isStarting, setIsStarting] = (0, $7fPBF.useState)(false);
    const [error, setError] = (0, $7fPBF.useState)(null);
    const [isDismissed, setIsDismissed] = (0, $7fPBF.useState)(false);
    const onCompletedRef = (0, $7fPBF.useRef)(options.onCompleted);
    onCompletedRef.current = options.onCompleted;
    const fetchJobs = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchID) return;
        const response = await (0, $d6ceddc0f5c6ead5$export$2e2bcd8739ae039).fetchPeopleImports(churchID, provider, auth);
        var _response_body_result;
        if (!response.error && response.body) setJobs((_response_body_result = response.body.result) !== null && _response_body_result !== void 0 ? _response_body_result : []);
    }, [
        churchID,
        provider,
        auth
    ]);
    (0, $7fPBF.useEffect)(()=>{
        if (!isConnected || importedAt) return;
        fetchJobs();
    }, [
        isConnected,
        importedAt,
        fetchJobs
    ]);
    var _newestFirst_find;
    // Only an apply imports anyone; previews run in the background untouched.
    const latestApply = (_newestFirst_find = $d8987e8fd3e2f706$var$newestFirst(jobs !== null && jobs !== void 0 ? jobs : []).find((job)=>job.mode === (0, $5586e2638b6c1db4$export$464939c50b7e9aa5).APPLY)) !== null && _newestFirst_find !== void 0 ? _newestFirst_find : null;
    const activeJob = trackedJob !== null && trackedJob !== void 0 ? trackedJob : latestApply;
    // An import that finished this session counts before the connection is
    // refetched, so it isn't offered again in between.
    const hasImported = importedAt !== null || alreadyImported || (trackedJob === null || trackedJob === void 0 ? void 0 : trackedJob.mode) === (0, $5586e2638b6c1db4$export$464939c50b7e9aa5).APPLY && trackedJob.status === (0, $5586e2638b6c1db4$export$16d185230a192260).SUCCEEDED;
    const isRunning = activeJob !== null && !(0, $5586e2638b6c1db4$export$2711b377650411ef)(activeJob.status);
    // Poll the running job until it finishes, backing off as it runs, and not at
    // all while the tab is hidden.
    (0, $7fPBF.useEffect)(()=>{
        if (!churchID || !activeJob || (0, $5586e2638b6c1db4$export$2711b377650411ef)(activeJob.status)) return;
        const jobID = activeJob.id;
        const startedPollingAt = Date.now();
        let timeout;
        let isInFlight = false;
        let isCancelled = false;
        const poll = async ()=>{
            var _response_body;
            timeout = undefined;
            isInFlight = true;
            const response = await (0, $d6ceddc0f5c6ead5$export$2e2bcd8739ae039).fetchPeopleImport(churchID, provider, jobID, auth);
            const job = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.result;
            isInFlight = false;
            if (isCancelled) return;
            if (!response.error && job) {
                setTrackedJob(job);
                if ((0, $5586e2638b6c1db4$export$2711b377650411ef)(job.status)) {
                    if (job.status === (0, $5586e2638b6c1db4$export$16d185230a192260).SUCCEEDED) {
                        var _onCompletedRef_current;
                        (_onCompletedRef_current = onCompletedRef.current) === null || _onCompletedRef_current === void 0 ? void 0 : _onCompletedRef_current.call(onCompletedRef);
                        // Picks up peopleImportCompletedAt, so every screen agrees it's done.
                        reloadConnectionStatus();
                    }
                    return;
                }
            }
            schedule();
        };
        const schedule = ()=>{
            if (isCancelled || document.hidden || timeout !== undefined || isInFlight) return;
            timeout = window.setTimeout(()=>{
                poll();
            }, $d8987e8fd3e2f706$var$pollDelay(Date.now() - startedPollingAt));
        };
        // Coming back to the tab checks straight away rather than waiting out a
        // delay that may have been set half an hour ago.
        const onVisibilityChange = ()=>{
            if (document.hidden) {
                window.clearTimeout(timeout);
                timeout = undefined;
                return;
            }
            // A request already on its way will schedule the next one itself.
            if (timeout === undefined && !isInFlight) poll();
        };
        document.addEventListener('visibilitychange', onVisibilityChange);
        schedule();
        return ()=>{
            isCancelled = true;
            window.clearTimeout(timeout);
            document.removeEventListener('visibilitychange', onVisibilityChange);
        };
    // The job's identity and whether it's finished are what matter, not every
    // counter update.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        churchID,
        provider,
        auth,
        activeJob === null || activeJob === void 0 ? void 0 : activeJob.id,
        isRunning,
        reloadConnectionStatus
    ]);
    const start = (0, $7fPBF.useCallback)(async ()=>{
        if (!churchID) return;
        setIsStarting(true);
        setError(null);
        try {
            var _response_body;
            const response = await (0, $d6ceddc0f5c6ead5$export$2e2bcd8739ae039).startPeopleImport(churchID, provider, (0, $5586e2638b6c1db4$export$464939c50b7e9aa5).APPLY, auth);
            const job = (_response_body = response.body) === null || _response_body === void 0 ? void 0 : _response_body.result;
            if (job && !response.error) {
                setTrackedJob(job);
                return;
            }
            // Neither refusal is really an error to show: one means there's nothing
            // left to do, the other that it's already happening.
            if (response.code === $d8987e8fd3e2f706$var$ALREADY_IMPORTED) {
                setAlreadyImported(true);
                reloadConnectionStatus();
                return;
            }
            if (response.code === $d8987e8fd3e2f706$var$IMPORT_IN_PROGRESS) {
                await fetchJobs();
                return;
            }
            var _response_error;
            setError((_response_error = response.error) !== null && _response_error !== void 0 ? _response_error : 'Unable to start the import right now.');
        } finally{
            setIsStarting(false);
        }
    }, [
        churchID,
        provider,
        auth,
        fetchJobs,
        reloadConnectionStatus
    ]);
    let state = {
        kind: 'hidden'
    };
    if (activeJob && isRunning) state = {
        kind: 'inProgress',
        job: activeJob
    };
    else if ((trackedJob === null || trackedJob === void 0 ? void 0 : trackedJob.status) === (0, $5586e2638b6c1db4$export$16d185230a192260).SUCCEEDED && !isDismissed) // Finished while this page was open, so it's worth saying so once.
    state = {
        kind: 'succeeded',
        job: trackedJob
    };
    else if (!isConnected || hasImported || !canStart || jobs === null) state = {
        kind: 'hidden'
    };
    else if (latestApply && (0, $5586e2638b6c1db4$export$2711b377650411ef)(latestApply.status)) state = {
        kind: 'failed',
        job: activeJob !== null && activeJob !== void 0 ? activeJob : latestApply
    };
    else state = {
        kind: 'available'
    };
    return {
        state: state,
        providerName: provider === (0, $c0668f4c2e4aa4de$export$ca1f2f1c178e9c72).PLANNING_CENTER ? 'Planning Center' : 'your provider',
        canStart: canStart,
        isStarting: isStarting,
        error: error,
        start: start,
        dismiss: ()=>setIsDismissed(true)
    };
}






function $aae837cfc25e0182$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $63d64463cd01676b$export$2e2bcd8739ae039), {
        id: "people-info-modal",
        isOpen: props.isOpen,
        footerButtons: [],
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
            className: "people-info-modal-content",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "header",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            className: "header-control close",
                            onClick: props.close,
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("img", {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($3254a4d5e28fabfa$exports))),
                                alt: "Close icon"
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h3", {
                            className: "title",
                            children: "About People"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "header-control-spacer"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "body",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h4", {
                            children: "People Sources"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "People can be added to your church in three ways:"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("ul", {
                            children: [
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                    children: 'Manually using the "New Person" button'
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                    children: "Automatically imported from Planning Center"
                                }),
                                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("li", {
                                    children: "Automatically when someone creates a profile while using the Salt app with your church"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                            children: "You can search for people using the search bar at the top of the page. You must search starting with someone's first name, or the beginning of their email address."
                        })
                    ]
                })
            ]
        })
    });
}






var $7fPBF = parcelRequire("7fPBF");

function $1dbc79cd94c4736f$var$statusCopy(status) {
    switch(status){
        case (0, $5586e2638b6c1db4$export$16d185230a192260).QUEUED:
            return "Waiting to start\u2026";
        case (0, $5586e2638b6c1db4$export$16d185230a192260).INTERRUPTED:
            // A chunk reached its deadline; the job resumes from where it stopped.
            return 'Paused briefly. It will pick up where it left off.';
        default:
            return "Importing\u2026";
    }
}
function $1dbc79cd94c4736f$var$countCopy(job) {
    const processed = (0, $5586e2638b6c1db4$export$1fb54e0e25b02151)(job.counters);
    var _job_estimatedTotal;
    const total = (_job_estimatedTotal = job.estimatedTotal) !== null && _job_estimatedTotal !== void 0 ? _job_estimatedTotal : null;
    if (total !== null && total > 0) return `${processed.toLocaleString()} of ${total.toLocaleString()} people`;
    return processed > 0 ? `${processed.toLocaleString()} people so far` : null;
}
// Only the parts that happened, so a church with no existing people isn't told
// "0 linked".
function $1dbc79cd94c4736f$var$summaryParts(job) {
    const counters = job.counters;
    return [
        counters.created > 0 ? `${counters.created.toLocaleString()} added` : null,
        counters.claimed > 0 ? `${counters.claimed.toLocaleString()} linked to people already in Salt` : null,
        counters.updated > 0 ? `${counters.updated.toLocaleString()} updated` : null
    ].filter((part)=>part !== null);
}
function $1dbc79cd94c4736f$export$2e2bcd8739ae039(props) {
    var _state_job_failure;
    const [isConfirming, setIsConfirming] = (0, $7fPBF.useState)(false);
    const { state: state, providerName: providerName } = props;
    // A confirmation belongs to the moment it was asked for. Once the card moves
    // on -- started, finished, failed -- it shouldn't come back mid-question.
    (0, $7fPBF.useEffect)(()=>{
        setIsConfirming(false);
    }, [
        state.kind
    ]);
    if (state.kind === 'hidden') return null;
    if (state.kind === 'inProgress') {
        const job = state.job;
        const processed = (0, $5586e2638b6c1db4$export$1fb54e0e25b02151)(job.counters);
        var _job_estimatedTotal;
        const total = (_job_estimatedTotal = job.estimatedTotal) !== null && _job_estimatedTotal !== void 0 ? _job_estimatedTotal : null;
        const fraction = total !== null && total > 0 ? Math.min(processed / total, 1) : null;
        const count = $1dbc79cd94c4736f$var$countCopy(job);
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
            className: "people-import-card",
            "aria-live": "polite",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                    className: "people-import-heading",
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                            className: "people-import-spinner",
                            "aria-hidden": "true"
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h2", {
                            children: [
                                "Importing people from ",
                                providerName
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "people-import-status",
                    children: $1dbc79cd94c4736f$var$statusCopy(job.status)
                }),
                fraction !== null ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "people-import-progress",
                    role: "progressbar",
                    "aria-valuemin": 0,
                    "aria-valuemax": total !== null && total !== void 0 ? total : undefined,
                    "aria-valuenow": processed,
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("span", {
                        style: {
                            width: `${fraction * 100}%`
                        }
                    })
                }) : null,
                count ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "people-import-count",
                    children: count
                }) : null,
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                    className: "people-import-note",
                    children: "This may take a while. You can leave this page, and we'll email you once the import is complete."
                })
            ]
        });
    }
    if (state.kind === 'succeeded') {
        const parts = $1dbc79cd94c4736f$var$summaryParts(state.job);
        const failed = state.job.counters.failed;
        return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
            className: "people-import-card is-complete",
            "aria-live": "polite",
            children: [
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "people-import-heading",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("h2", {
                        children: "Import complete"
                    })
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                    className: "people-import-status",
                    children: [
                        parts.length > 0 ? `${parts.join(', ')}.` : `Everyone from ${providerName} is now in Salt.`,
                        failed > 0 ? ` ${failed.toLocaleString()} couldn't be imported.` : null
                    ]
                }),
                /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                    className: "people-import-actions",
                    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                        type: "button",
                        className: "secondary",
                        onClick: props.onDismiss,
                        children: "Done"
                    })
                })
            ]
        });
    }
    var _state_job_failure_message;
    if (state.kind === 'failed') return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
        className: "people-import-card is-failed",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "people-import-heading",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h2", {
                    children: [
                        "The import from ",
                        providerName,
                        " didn't finish"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "people-import-status",
                children: (_state_job_failure_message = (_state_job_failure = state.job.failure) === null || _state_job_failure === void 0 ? void 0 : _state_job_failure.message) !== null && _state_job_failure_message !== void 0 ? _state_job_failure_message : 'Something went wrong partway through.'
            }),
            props.error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "people-import-error",
                children: props.error
            }) : null,
            props.canStart ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "people-import-actions",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    disabled: props.isStarting,
                    onClick: props.onStart,
                    children: props.isStarting ? "Starting\u2026" : 'Try Again'
                })
            }) : null
        ]
    });
    // Available: connected, and nothing imported yet.
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("section", {
        className: "people-import-card",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "people-import-heading",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("h2", {
                    children: [
                        "Import your people from ",
                        providerName
                    ]
                })
            }),
            isConfirming ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        className: "people-import-status",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("strong", {
                                children: "Start the import?"
                            }),
                            " Anyone already in Salt with a matching email will be linked and updated from ",
                            providerName,
                            ". This can't be undone."
                        ]
                    }),
                    props.error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                        className: "people-import-error",
                        children: props.error
                    }) : null,
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
                        className: "people-import-actions",
                        children: [
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                disabled: props.isStarting,
                                onClick: props.onStart,
                                children: props.isStarting ? "Starting\u2026" : 'Start Import'
                            }),
                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                                type: "button",
                                className: "secondary",
                                disabled: props.isStarting,
                                onClick: ()=>setIsConfirming(false),
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("p", {
                        className: "people-import-status",
                        children: [
                            providerName,
                            " is connected. Bring everyone over so they show up here, and they'll stay in sync from then on."
                        ]
                    }),
                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                        className: "people-import-actions",
                        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                            type: "button",
                            onClick: ()=>setIsConfirming(true),
                            children: "Import People"
                        })
                    })
                ]
            })
        ]
    });
}



const $17ee7b72a0fcf2ab$var$VIEW_FADE_MS = 180;
function $17ee7b72a0fcf2ab$export$2e2bcd8739ae039() {
    const [query, setQuery] = (0, $7fPBF.useState)('');
    const [isInfoModalOpen, setIsInfoModalOpen] = (0, $7fPBF.useState)(false);
    const navigate = (0, $d9fd026bfea79ab9$export$9770f232ac06a008)();
    const openPerson = (person)=>{
        const state = {
            personName: person.attributes.name,
            backLocation: '/people'
        };
        navigate((0, $d093efa5d4df2a8b$export$f7fd57ccce645fe2)(person.id), {
            state: state
        });
    };
    const isSearching = query.trim().length > 0;
    const allPeople = (0, $7a49e75250975903$export$2e2bcd8739ae039)();
    const searchResults = (0, $7a49e75250975903$export$d443a927de736110)(query);
    // Newly imported people appear in the list as soon as the import finishes.
    const peopleImport = (0, $d8987e8fd3e2f706$export$2e2bcd8739ae039)({
        onCompleted: ()=>{
            allPeople.refetch();
        }
    });
    // The outgoing view fades before the incoming one mounts, so only one list is
    // ever measured for height.
    const targetView = isSearching ? 'search' : 'default';
    const [visibleView, setVisibleView] = (0, $7fPBF.useState)(targetView);
    (0, $7fPBF.useEffect)(()=>{
        if (visibleView === targetView) return;
        const timeout = window.setTimeout(()=>setVisibleView(targetView), $17ee7b72a0fcf2ab$var$VIEW_FADE_MS);
        return ()=>window.clearTimeout(timeout);
    }, [
        targetView,
        visibleView
    ]);
    const isLeaving = visibleView !== targetView;
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)("div", {
        className: "people-page",
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $aae837cfc25e0182$export$2e2bcd8739ae039), {
                isOpen: isInfoModalOpen,
                close: ()=>setIsInfoModalOpen(false)
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $6ae515035e6d7062$export$2e2bcd8739ae039), {
                title: "People",
                tabs: [],
                buttons: [
                    {
                        label: "Info",
                        icon: 'info',
                        onClick: ()=>setIsInfoModalOpen(true)
                    },
                    {
                        label: "New Person",
                        icon: 'add',
                        onClick: ()=>{}
                    }
                ]
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "people-search",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("input", {
                    type: "search",
                    value: query,
                    placeholder: "Search by first name or email",
                    "aria-label": "Search people",
                    onChange: (e)=>setQuery(e.target.value)
                })
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1dbc79cd94c4736f$export$2e2bcd8739ae039), {
                state: peopleImport.state,
                providerName: peopleImport.providerName,
                canStart: peopleImport.canStart,
                isStarting: peopleImport.isStarting,
                error: peopleImport.error,
                onStart: ()=>{
                    peopleImport.start();
                },
                onDismiss: peopleImport.dismiss
            }),
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: isLeaving ? 'people-view is-leaving' : 'people-view',
                children: visibleView === 'search' ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($17ee7b72a0fcf2ab$var$PeopleResults, {
                    people: searchResults.people,
                    loading: searchResults.loading,
                    hasLoaded: searchResults.hasLoaded,
                    error: searchResults.error,
                    hasMore: searchResults.hasMore,
                    isLoadingMore: searchResults.isLoadingMore,
                    loadMore: searchResults.loadMore,
                    refetch: searchResults.refetch,
                    onSelect: openPerson,
                    emptyTitle: "No Matches",
                    emptyMessage: `No one found matching that ${searchResults.field === 'email' ? 'email' : 'name'}.${searchResults.field === 'name' ? ' If you are trying to find someone by email, type their full email address up to the @ symbol for better results.' : ''}`
                }) : /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)($17ee7b72a0fcf2ab$var$PeopleResults, {
                    people: allPeople.people,
                    loading: allPeople.loading,
                    hasLoaded: allPeople.hasLoaded,
                    error: allPeople.error,
                    hasMore: allPeople.hasMore,
                    isLoadingMore: allPeople.isLoadingMore,
                    loadMore: allPeople.loadMore,
                    refetch: allPeople.refetch,
                    onSelect: openPerson,
                    emptyTitle: "No People Yet",
                    emptyMessage: "People added to this church will show up here. Create one to get started."
                })
            })
        ]
    });
}
function $17ee7b72a0fcf2ab$var$PeopleResults(props) {
    if (props.loading && props.people.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
        className: "people-state",
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ebf906ca24cd582c$export$2e2bcd8739ae039), {
            fullScreen: false
        })
    });
    if (props.error && props.people.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        error: props.error,
        buttonText: "Retry",
        buttonAction: props.refetch,
        fullHeight: true
    });
    if (props.hasLoaded && props.people.length === 0) return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1bcae8edd2c9b338$export$2e2bcd8739ae039), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dcf07832ec5ba2b3$exports))),
        title: props.emptyTitle,
        error: props.emptyMessage,
        showButton: false,
        fullHeight: true
    });
    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $824c049f32d4395d$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "people",
                children: props.people.map((person)=>{
                    var _person_attributes_email;
                    return /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2baa135e072363db$export$2e2bcd8739ae039), {
                        name: person.attributes.name,
                        email: (_person_attributes_email = person.attributes.email) !== null && _person_attributes_email !== void 0 ? _person_attributes_email : undefined,
                        onClick: ()=>props.onSelect(person)
                    }, person.id);
                })
            }),
            props.error ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                className: "people-error",
                children: props.error
            }) : null,
            props.hasMore ? /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("div", {
                className: "people-load-more",
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("button", {
                    type: "button",
                    disabled: props.isLoadingMore,
                    onClick: props.loadMore,
                    children: props.isLoadingMore ? "Loading\u2026" : 'Load More'
                })
            }) : null
        ]
    });
}



(0, (/*@__PURE__*/$parcel$interopDefault($7857575a213426db$exports))).setAppElement('#root');
const $4a5191623062d5ff$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($f11ec298ebcca059$exports))).createRoot(document.getElementById('root'));
$4a5191623062d5ff$var$root.render(/*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $824c049f32d4395d$exports.Fragment), {
    children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $a0cf24fd73ae067c$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $12342e602c448a3c$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $516c6e0c0adbc42f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f1b5de3ad0a0b51c$export$2e2bcd8739ae039), {}),
                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2471b8f7d7b0c863$export$2e2bcd8739ae039), {}),
                                children: [
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c522a61e1633b5f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "settings",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $29a438cb51d3f023$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "home",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0c522a61e1633b5f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "playlists",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $642e727260322576$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "playlists/:playlistID",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $de2e140928c5997e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "services",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $470393d7db593e2c$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fbeffcef14d41dff$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "series",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d91f6cd1037b45b2$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "series/:seriesID",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2a0c35f4183b1c04$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "services/new",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a2fec0e077f8fd2$export$2f557ba72376749f), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "services/:serviceID",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4a2fec0e077f8fd2$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "launchpad",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78ffe0c21bc67c21$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $78790fb1db1697a8$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: ":launchpadID",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $3411554fac1e8fe2$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsxs)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "volunteering",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $35ec7910fa739a74$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $284d277906b46fb8$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "training",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7c74839fe1f39bb8$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "training/:moduleID",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $b47e954e55eff3c7$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                                path: "teams/:teamID/people/:personID",
                                                element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $e6ed8283c26dea86$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "people",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $17ee7b72a0fcf2ab$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "people/:personID",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d093efa5d4df2a8b$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "staff",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $0df0f1e0da66b712$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "team",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$444b3ab0cb9aec40), {
                                            to: "/staff",
                                            replace: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "team/:teamID",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $392f3b01ef366b57$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "integrations/redirect",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b0f979acc21dbbe$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "connections/redirect",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $4b0f979acc21dbbe$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "connections",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $8b78cb05ee8c928f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "events",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $2a0798e511c3602a$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "events/create",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $7391c474f3fbb6e2$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "events/create/details",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $1931765328266215$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "events/create/import",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $fd33414c39acb8d6$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "events/:eventID",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $ed4b406b926302af$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                                        path: "*",
                                        element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("main", {
                                            style: {
                                                padding: "1rem"
                                            },
                                            children: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)("p", {
                                                children: "There's nothing here!"
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                            path: "/login",
                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $f20b05b49aeba227$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $d9fd026bfea79ab9$export$e7b0ac011bb776c6), {
                            path: "/reset-password",
                            element: /*#__PURE__*/ (0, $824c049f32d4395d$exports.jsx)((0, $14b7ba2e956aca92$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            })
        })
    })
}));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $5a0342ebaab9f2d7$export$2e2bcd8739ae039)();


//# sourceMappingURL=public.038ddb08.js.map
